(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire379f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire379f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cp2FO", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $9079e4b3d0ffef98$export$ffb0004e005737fa; }, function (v) { return $9079e4b3d0ffef98$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $9079e4b3d0ffef98$export$34b9dba7ce09269b; }, function (v) { return $9079e4b3d0ffef98$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $9079e4b3d0ffef98$export$25062201e9e25d76; }, function (v) { return $9079e4b3d0ffef98$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9079e4b3d0ffef98$export$ffb0004e005737fa;
var $9079e4b3d0ffef98$export$34b9dba7ce09269b;
var $9079e4b3d0ffef98$export$25062201e9e25d76;
"use strict";

var $f2Y41 = parcelRequire("f2Y41");
var $9079e4b3d0ffef98$var$k = Symbol.for("react.element"), $9079e4b3d0ffef98$var$l = Symbol.for("react.fragment"), $9079e4b3d0ffef98$var$m = Object.prototype.hasOwnProperty, $9079e4b3d0ffef98$var$n = $f2Y41.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $9079e4b3d0ffef98$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9079e4b3d0ffef98$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$9079e4b3d0ffef98$var$m.call(a, b) && !$9079e4b3d0ffef98$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $9079e4b3d0ffef98$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $9079e4b3d0ffef98$var$n.current
    };
}
$9079e4b3d0ffef98$export$ffb0004e005737fa = $9079e4b3d0ffef98$var$l;
$9079e4b3d0ffef98$export$34b9dba7ce09269b = $9079e4b3d0ffef98$var$q;
$9079e4b3d0ffef98$export$25062201e9e25d76 = $9079e4b3d0ffef98$var$q;

});
parcelRegister("f2Y41", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l04CO"));

});
parcelRegister("l04CO", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f49d2f7b75e7125a$export$dca3b0875bd9a954; }, function (v) { return $f49d2f7b75e7125a$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f49d2f7b75e7125a$export$16fa2f45be04daa8; }, function (v) { return $f49d2f7b75e7125a$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f49d2f7b75e7125a$export$ffb0004e005737fa; }, function (v) { return $f49d2f7b75e7125a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f49d2f7b75e7125a$export$e2c29f18771995cb; }, function (v) { return $f49d2f7b75e7125a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f49d2f7b75e7125a$export$221d75b3f55bb0bd; }, function (v) { return $f49d2f7b75e7125a$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f49d2f7b75e7125a$export$5f8d39834fd61797; }, function (v) { return $f49d2f7b75e7125a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f49d2f7b75e7125a$export$74bf444e3cd11ea5; }, function (v) { return $f49d2f7b75e7125a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f49d2f7b75e7125a$export$ae55be85d98224ed; }, function (v) { return $f49d2f7b75e7125a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $f49d2f7b75e7125a$export$3ba232387fd5d6dd; }, function (v) { return $f49d2f7b75e7125a$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f49d2f7b75e7125a$export$e530037191fcd5d7; }, function (v) { return $f49d2f7b75e7125a$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f49d2f7b75e7125a$export$fd42f52fd3ae1109; }, function (v) { return $f49d2f7b75e7125a$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f49d2f7b75e7125a$export$c8a8987d4410bf2d; }, function (v) { return $f49d2f7b75e7125a$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f49d2f7b75e7125a$export$d38cd72104c1f0e9; }, function (v) { return $f49d2f7b75e7125a$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f49d2f7b75e7125a$export$7d1e3a5e95ceca43; }, function (v) { return $f49d2f7b75e7125a$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f49d2f7b75e7125a$export$257a8862b851cb5b; }, function (v) { return $f49d2f7b75e7125a$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f49d2f7b75e7125a$export$a8257692ac88316c; }, function (v) { return $f49d2f7b75e7125a$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f49d2f7b75e7125a$export$488013bae63b21da; }, function (v) { return $f49d2f7b75e7125a$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f49d2f7b75e7125a$export$7c73462e0d25e514; }, function (v) { return $f49d2f7b75e7125a$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f49d2f7b75e7125a$export$7568632d0d33d16d; }, function (v) { return $f49d2f7b75e7125a$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f49d2f7b75e7125a$export$88948ce120ea2619; }, function (v) { return $f49d2f7b75e7125a$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f49d2f7b75e7125a$export$35808ee640e87ca7; }, function (v) { return $f49d2f7b75e7125a$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f49d2f7b75e7125a$export$fae74005e78b1a27; }, function (v) { return $f49d2f7b75e7125a$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f49d2f7b75e7125a$export$dc8fbce3eb94dc1e; }, function (v) { return $f49d2f7b75e7125a$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f49d2f7b75e7125a$export$6a7bc4e911dc01cf; }, function (v) { return $f49d2f7b75e7125a$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f49d2f7b75e7125a$export$6d9c69b0de29b591; }, function (v) { return $f49d2f7b75e7125a$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f49d2f7b75e7125a$export$f680877a34711e37; }, function (v) { return $f49d2f7b75e7125a$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f49d2f7b75e7125a$export$d5a552a76deda3c2; }, function (v) { return $f49d2f7b75e7125a$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f49d2f7b75e7125a$export$aaabe4eda9ed9969; }, function (v) { return $f49d2f7b75e7125a$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f49d2f7b75e7125a$export$e5c5a5f917a5871c; }, function (v) { return $f49d2f7b75e7125a$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f49d2f7b75e7125a$export$1538c33de8887b59; }, function (v) { return $f49d2f7b75e7125a$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f49d2f7b75e7125a$export$13e3392192263954; }, function (v) { return $f49d2f7b75e7125a$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f49d2f7b75e7125a$export$b8f5890fc79d6aca; }, function (v) { return $f49d2f7b75e7125a$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f49d2f7b75e7125a$export$60241385465d0a34; }, function (v) { return $f49d2f7b75e7125a$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f49d2f7b75e7125a$export$306c0aa65ff9ec16; }, function (v) { return $f49d2f7b75e7125a$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f49d2f7b75e7125a$export$7b286972b8d8ccbf; }, function (v) { return $f49d2f7b75e7125a$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f49d2f7b75e7125a$export$83d89fbfd8236492; }, function (v) { return $f49d2f7b75e7125a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f49d2f7b75e7125a$export$dca3b0875bd9a954;
var $f49d2f7b75e7125a$export$16fa2f45be04daa8;
var $f49d2f7b75e7125a$export$ffb0004e005737fa;
var $f49d2f7b75e7125a$export$e2c29f18771995cb;
var $f49d2f7b75e7125a$export$221d75b3f55bb0bd;
var $f49d2f7b75e7125a$export$5f8d39834fd61797;
var $f49d2f7b75e7125a$export$74bf444e3cd11ea5;
var $f49d2f7b75e7125a$export$ae55be85d98224ed;
var $f49d2f7b75e7125a$export$3ba232387fd5d6dd;
var $f49d2f7b75e7125a$export$e530037191fcd5d7;
var $f49d2f7b75e7125a$export$fd42f52fd3ae1109;
var $f49d2f7b75e7125a$export$c8a8987d4410bf2d;
var $f49d2f7b75e7125a$export$d38cd72104c1f0e9;
var $f49d2f7b75e7125a$export$7d1e3a5e95ceca43;
var $f49d2f7b75e7125a$export$257a8862b851cb5b;
var $f49d2f7b75e7125a$export$a8257692ac88316c;
var $f49d2f7b75e7125a$export$488013bae63b21da;
var $f49d2f7b75e7125a$export$7c73462e0d25e514;
var $f49d2f7b75e7125a$export$7568632d0d33d16d;
var $f49d2f7b75e7125a$export$88948ce120ea2619;
var $f49d2f7b75e7125a$export$35808ee640e87ca7;
var $f49d2f7b75e7125a$export$fae74005e78b1a27;
var $f49d2f7b75e7125a$export$dc8fbce3eb94dc1e;
var $f49d2f7b75e7125a$export$6a7bc4e911dc01cf;
var $f49d2f7b75e7125a$export$6d9c69b0de29b591;
var $f49d2f7b75e7125a$export$f680877a34711e37;
var $f49d2f7b75e7125a$export$d5a552a76deda3c2;
var $f49d2f7b75e7125a$export$aaabe4eda9ed9969;
var $f49d2f7b75e7125a$export$e5c5a5f917a5871c;
var $f49d2f7b75e7125a$export$1538c33de8887b59;
var $f49d2f7b75e7125a$export$13e3392192263954;
var $f49d2f7b75e7125a$export$b8f5890fc79d6aca;
var $f49d2f7b75e7125a$export$60241385465d0a34;
var $f49d2f7b75e7125a$export$306c0aa65ff9ec16;
var $f49d2f7b75e7125a$export$7b286972b8d8ccbf;
var $f49d2f7b75e7125a$export$83d89fbfd8236492;
"use strict";
var $f49d2f7b75e7125a$var$l = Symbol.for("react.element"), $f49d2f7b75e7125a$var$n = Symbol.for("react.portal"), $f49d2f7b75e7125a$var$p = Symbol.for("react.fragment"), $f49d2f7b75e7125a$var$q = Symbol.for("react.strict_mode"), $f49d2f7b75e7125a$var$r = Symbol.for("react.profiler"), $f49d2f7b75e7125a$var$t = Symbol.for("react.provider"), $f49d2f7b75e7125a$var$u = Symbol.for("react.context"), $f49d2f7b75e7125a$var$v = Symbol.for("react.forward_ref"), $f49d2f7b75e7125a$var$w = Symbol.for("react.suspense"), $f49d2f7b75e7125a$var$x = Symbol.for("react.memo"), $f49d2f7b75e7125a$var$y = Symbol.for("react.lazy"), $f49d2f7b75e7125a$var$z = Symbol.iterator;
function $f49d2f7b75e7125a$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f49d2f7b75e7125a$var$z && a[$f49d2f7b75e7125a$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f49d2f7b75e7125a$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f49d2f7b75e7125a$var$C = Object.assign, $f49d2f7b75e7125a$var$D = {};
function $f49d2f7b75e7125a$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f49d2f7b75e7125a$var$D;
    this.updater = e || $f49d2f7b75e7125a$var$B;
}
$f49d2f7b75e7125a$var$E.prototype.isReactComponent = {};
$f49d2f7b75e7125a$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f49d2f7b75e7125a$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f49d2f7b75e7125a$var$F() {}
$f49d2f7b75e7125a$var$F.prototype = $f49d2f7b75e7125a$var$E.prototype;
function $f49d2f7b75e7125a$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f49d2f7b75e7125a$var$D;
    this.updater = e || $f49d2f7b75e7125a$var$B;
}
var $f49d2f7b75e7125a$var$H = $f49d2f7b75e7125a$var$G.prototype = new $f49d2f7b75e7125a$var$F;
$f49d2f7b75e7125a$var$H.constructor = $f49d2f7b75e7125a$var$G;
$f49d2f7b75e7125a$var$C($f49d2f7b75e7125a$var$H, $f49d2f7b75e7125a$var$E.prototype);
$f49d2f7b75e7125a$var$H.isPureReactComponent = !0;
var $f49d2f7b75e7125a$var$I = Array.isArray, $f49d2f7b75e7125a$var$J = Object.prototype.hasOwnProperty, $f49d2f7b75e7125a$var$K = {
    current: null
}, $f49d2f7b75e7125a$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f49d2f7b75e7125a$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f49d2f7b75e7125a$var$J.call(b, d) && !$f49d2f7b75e7125a$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f49d2f7b75e7125a$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f49d2f7b75e7125a$var$K.current
    };
}
function $f49d2f7b75e7125a$var$N(a, b) {
    return {
        $$typeof: $f49d2f7b75e7125a$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f49d2f7b75e7125a$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f49d2f7b75e7125a$var$l;
}
function $f49d2f7b75e7125a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f49d2f7b75e7125a$var$P = /\/+/g;
function $f49d2f7b75e7125a$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f49d2f7b75e7125a$var$escape("" + a.key) : b.toString(36);
}
function $f49d2f7b75e7125a$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f49d2f7b75e7125a$var$l:
                case $f49d2f7b75e7125a$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f49d2f7b75e7125a$var$Q(h, 0) : d, $f49d2f7b75e7125a$var$I(c) ? (e = "", null != a && (e = a.replace($f49d2f7b75e7125a$var$P, "$&/") + "/"), $f49d2f7b75e7125a$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f49d2f7b75e7125a$var$O(c) && (c = $f49d2f7b75e7125a$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f49d2f7b75e7125a$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f49d2f7b75e7125a$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f49d2f7b75e7125a$var$Q(k, g);
        h += $f49d2f7b75e7125a$var$R(k, b, e, f, c);
    }
    else if (f = $f49d2f7b75e7125a$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f49d2f7b75e7125a$var$Q(k, g++), h += $f49d2f7b75e7125a$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f49d2f7b75e7125a$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f49d2f7b75e7125a$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f49d2f7b75e7125a$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f49d2f7b75e7125a$var$U = {
    current: null
}, $f49d2f7b75e7125a$var$V = {
    transition: null
}, $f49d2f7b75e7125a$var$W = {
    ReactCurrentDispatcher: $f49d2f7b75e7125a$var$U,
    ReactCurrentBatchConfig: $f49d2f7b75e7125a$var$V,
    ReactCurrentOwner: $f49d2f7b75e7125a$var$K
};
function $f49d2f7b75e7125a$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$f49d2f7b75e7125a$export$dca3b0875bd9a954 = {
    map: $f49d2f7b75e7125a$var$S,
    forEach: function(a, b, e) {
        $f49d2f7b75e7125a$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f49d2f7b75e7125a$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f49d2f7b75e7125a$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f49d2f7b75e7125a$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f49d2f7b75e7125a$export$16fa2f45be04daa8 = $f49d2f7b75e7125a$var$E;
$f49d2f7b75e7125a$export$ffb0004e005737fa = $f49d2f7b75e7125a$var$p;
$f49d2f7b75e7125a$export$e2c29f18771995cb = $f49d2f7b75e7125a$var$r;
$f49d2f7b75e7125a$export$221d75b3f55bb0bd = $f49d2f7b75e7125a$var$G;
$f49d2f7b75e7125a$export$5f8d39834fd61797 = $f49d2f7b75e7125a$var$q;
$f49d2f7b75e7125a$export$74bf444e3cd11ea5 = $f49d2f7b75e7125a$var$w;
$f49d2f7b75e7125a$export$ae55be85d98224ed = $f49d2f7b75e7125a$var$W;
$f49d2f7b75e7125a$export$3ba232387fd5d6dd = $f49d2f7b75e7125a$var$X;
$f49d2f7b75e7125a$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f49d2f7b75e7125a$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f49d2f7b75e7125a$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f49d2f7b75e7125a$var$J.call(b, f) && !$f49d2f7b75e7125a$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f49d2f7b75e7125a$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f49d2f7b75e7125a$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f49d2f7b75e7125a$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f49d2f7b75e7125a$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f49d2f7b75e7125a$export$c8a8987d4410bf2d = $f49d2f7b75e7125a$var$M;
$f49d2f7b75e7125a$export$d38cd72104c1f0e9 = function(a) {
    var b = $f49d2f7b75e7125a$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f49d2f7b75e7125a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f49d2f7b75e7125a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f49d2f7b75e7125a$var$v,
        render: a
    };
};
$f49d2f7b75e7125a$export$a8257692ac88316c = $f49d2f7b75e7125a$var$O;
$f49d2f7b75e7125a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f49d2f7b75e7125a$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f49d2f7b75e7125a$var$T
    };
};
$f49d2f7b75e7125a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f49d2f7b75e7125a$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f49d2f7b75e7125a$export$7568632d0d33d16d = function(a) {
    var b = $f49d2f7b75e7125a$var$V.transition;
    $f49d2f7b75e7125a$var$V.transition = {};
    try {
        a();
    } finally{
        $f49d2f7b75e7125a$var$V.transition = b;
    }
};
$f49d2f7b75e7125a$export$88948ce120ea2619 = $f49d2f7b75e7125a$var$X;
$f49d2f7b75e7125a$export$35808ee640e87ca7 = function(a, b) {
    return $f49d2f7b75e7125a$var$U.current.useCallback(a, b);
};
$f49d2f7b75e7125a$export$fae74005e78b1a27 = function(a) {
    return $f49d2f7b75e7125a$var$U.current.useContext(a);
};
$f49d2f7b75e7125a$export$dc8fbce3eb94dc1e = function() {};
$f49d2f7b75e7125a$export$6a7bc4e911dc01cf = function(a) {
    return $f49d2f7b75e7125a$var$U.current.useDeferredValue(a);
};
$f49d2f7b75e7125a$export$6d9c69b0de29b591 = function(a, b) {
    return $f49d2f7b75e7125a$var$U.current.useEffect(a, b);
};
$f49d2f7b75e7125a$export$f680877a34711e37 = function() {
    return $f49d2f7b75e7125a$var$U.current.useId();
};
$f49d2f7b75e7125a$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f49d2f7b75e7125a$var$U.current.useImperativeHandle(a, b, e);
};
$f49d2f7b75e7125a$export$aaabe4eda9ed9969 = function(a, b) {
    return $f49d2f7b75e7125a$var$U.current.useInsertionEffect(a, b);
};
$f49d2f7b75e7125a$export$e5c5a5f917a5871c = function(a, b) {
    return $f49d2f7b75e7125a$var$U.current.useLayoutEffect(a, b);
};
$f49d2f7b75e7125a$export$1538c33de8887b59 = function(a, b) {
    return $f49d2f7b75e7125a$var$U.current.useMemo(a, b);
};
$f49d2f7b75e7125a$export$13e3392192263954 = function(a, b, e) {
    return $f49d2f7b75e7125a$var$U.current.useReducer(a, b, e);
};
$f49d2f7b75e7125a$export$b8f5890fc79d6aca = function(a) {
    return $f49d2f7b75e7125a$var$U.current.useRef(a);
};
$f49d2f7b75e7125a$export$60241385465d0a34 = function(a) {
    return $f49d2f7b75e7125a$var$U.current.useState(a);
};
$f49d2f7b75e7125a$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f49d2f7b75e7125a$var$U.current.useSyncExternalStore(a, b, e);
};
$f49d2f7b75e7125a$export$7b286972b8d8ccbf = function() {
    return $f49d2f7b75e7125a$var$U.current.useTransition();
};
$f49d2f7b75e7125a$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("f915p", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b06889f723b28786$export$ae55be85d98224ed; }, function (v) { return $b06889f723b28786$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b06889f723b28786$export$d39a5bbd09211389; }, function (v) { return $b06889f723b28786$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b06889f723b28786$export$882461b6382ed46c; }, function (v) { return $b06889f723b28786$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b06889f723b28786$export$466bfc07425424d5; }, function (v) { return $b06889f723b28786$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b06889f723b28786$export$cd75ccfd720a3cd4; }, function (v) { return $b06889f723b28786$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b06889f723b28786$export$fa8d919ba61d84db; }, function (v) { return $b06889f723b28786$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b06889f723b28786$export$757ceba2d55c277e; }, function (v) { return $b06889f723b28786$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b06889f723b28786$export$b3890eb0ae9dca99; }, function (v) { return $b06889f723b28786$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b06889f723b28786$export$502457920280e6be; }, function (v) { return $b06889f723b28786$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b06889f723b28786$export$c78a37762a8d58e1; }, function (v) { return $b06889f723b28786$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b06889f723b28786$export$dc54d992c10e8a18; }, function (v) { return $b06889f723b28786$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b06889f723b28786$export$83d89fbfd8236492; }, function (v) { return $b06889f723b28786$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b06889f723b28786$export$ae55be85d98224ed;
var $b06889f723b28786$export$d39a5bbd09211389;
var $b06889f723b28786$export$882461b6382ed46c;
var $b06889f723b28786$export$466bfc07425424d5;
var $b06889f723b28786$export$cd75ccfd720a3cd4;
var $b06889f723b28786$export$fa8d919ba61d84db;
var $b06889f723b28786$export$757ceba2d55c277e;
var $b06889f723b28786$export$b3890eb0ae9dca99;
var $b06889f723b28786$export$502457920280e6be;
var $b06889f723b28786$export$c78a37762a8d58e1;
var $b06889f723b28786$export$dc54d992c10e8a18;
var $b06889f723b28786$export$83d89fbfd8236492;
"use strict";

var $f2Y41 = parcelRequire("f2Y41");

var $4pKUR = parcelRequire("4pKUR");
function $b06889f723b28786$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b06889f723b28786$var$da = new Set, $b06889f723b28786$var$ea = {};
function $b06889f723b28786$var$fa(a, b) {
    $b06889f723b28786$var$ha(a, b);
    $b06889f723b28786$var$ha(a + "Capture", b);
}
function $b06889f723b28786$var$ha(a, b) {
    $b06889f723b28786$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b06889f723b28786$var$da.add(b[a]);
}
var $b06889f723b28786$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b06889f723b28786$var$ja = Object.prototype.hasOwnProperty, $b06889f723b28786$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b06889f723b28786$var$la = {}, $b06889f723b28786$var$ma = {};
function $b06889f723b28786$var$oa(a) {
    if ($b06889f723b28786$var$ja.call($b06889f723b28786$var$ma, a)) return !0;
    if ($b06889f723b28786$var$ja.call($b06889f723b28786$var$la, a)) return !1;
    if ($b06889f723b28786$var$ka.test(a)) return $b06889f723b28786$var$ma[a] = !0;
    $b06889f723b28786$var$la[a] = !0;
    return !1;
}
function $b06889f723b28786$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b06889f723b28786$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b06889f723b28786$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b06889f723b28786$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b06889f723b28786$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b06889f723b28786$var$z[b] = new $b06889f723b28786$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b06889f723b28786$var$ra = /[\-:]([a-z])/g;
function $b06889f723b28786$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b06889f723b28786$var$ra, $b06889f723b28786$var$sa);
    $b06889f723b28786$var$z[b] = new $b06889f723b28786$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b06889f723b28786$var$ra, $b06889f723b28786$var$sa);
    $b06889f723b28786$var$z[b] = new $b06889f723b28786$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b06889f723b28786$var$ra, $b06889f723b28786$var$sa);
    $b06889f723b28786$var$z[b] = new $b06889f723b28786$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b06889f723b28786$var$z.xlinkHref = new $b06889f723b28786$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b06889f723b28786$var$z[a] = new $b06889f723b28786$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b06889f723b28786$var$ta(a, b, c, d) {
    var e = $b06889f723b28786$var$z.hasOwnProperty(b) ? $b06889f723b28786$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b06889f723b28786$var$qa(b, c, e, d) && (c = null), d || null === e ? $b06889f723b28786$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b06889f723b28786$var$ua = $f2Y41.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b06889f723b28786$var$va = Symbol.for("react.element"), $b06889f723b28786$var$wa = Symbol.for("react.portal"), $b06889f723b28786$var$ya = Symbol.for("react.fragment"), $b06889f723b28786$var$za = Symbol.for("react.strict_mode"), $b06889f723b28786$var$Aa = Symbol.for("react.profiler"), $b06889f723b28786$var$Ba = Symbol.for("react.provider"), $b06889f723b28786$var$Ca = Symbol.for("react.context"), $b06889f723b28786$var$Da = Symbol.for("react.forward_ref"), $b06889f723b28786$var$Ea = Symbol.for("react.suspense"), $b06889f723b28786$var$Fa = Symbol.for("react.suspense_list"), $b06889f723b28786$var$Ga = Symbol.for("react.memo"), $b06889f723b28786$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b06889f723b28786$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b06889f723b28786$var$Ja = Symbol.iterator;
function $b06889f723b28786$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b06889f723b28786$var$Ja && a[$b06889f723b28786$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b06889f723b28786$var$A = Object.assign, $b06889f723b28786$var$La;
function $b06889f723b28786$var$Ma(a) {
    if (void 0 === $b06889f723b28786$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b06889f723b28786$var$La = b && b[1] || "";
    }
    return "\n" + $b06889f723b28786$var$La + a;
}
var $b06889f723b28786$var$Na = !1;
function $b06889f723b28786$var$Oa(a, b) {
    if (!a || $b06889f723b28786$var$Na) return "";
    $b06889f723b28786$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b06889f723b28786$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b06889f723b28786$var$Ma(a) : "";
}
function $b06889f723b28786$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b06889f723b28786$var$Ma(a.type);
        case 16:
            return $b06889f723b28786$var$Ma("Lazy");
        case 13:
            return $b06889f723b28786$var$Ma("Suspense");
        case 19:
            return $b06889f723b28786$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b06889f723b28786$var$Oa(a.type, !1), a;
        case 11:
            return a = $b06889f723b28786$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b06889f723b28786$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b06889f723b28786$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b06889f723b28786$var$ya:
            return "Fragment";
        case $b06889f723b28786$var$wa:
            return "Portal";
        case $b06889f723b28786$var$Aa:
            return "Profiler";
        case $b06889f723b28786$var$za:
            return "StrictMode";
        case $b06889f723b28786$var$Ea:
            return "Suspense";
        case $b06889f723b28786$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b06889f723b28786$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b06889f723b28786$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b06889f723b28786$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b06889f723b28786$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b06889f723b28786$var$Qa(a.type) || "Memo";
        case $b06889f723b28786$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b06889f723b28786$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b06889f723b28786$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b06889f723b28786$var$Qa(b);
        case 8:
            return b === $b06889f723b28786$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b06889f723b28786$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b06889f723b28786$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b06889f723b28786$var$Ua(a) {
    var b = $b06889f723b28786$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b06889f723b28786$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b06889f723b28786$var$Ua(a));
}
function $b06889f723b28786$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b06889f723b28786$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b06889f723b28786$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b06889f723b28786$var$Ya(a, b) {
    var c = b.checked;
    return $b06889f723b28786$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b06889f723b28786$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b06889f723b28786$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b06889f723b28786$var$ab(a, b) {
    b = b.checked;
    null != b && $b06889f723b28786$var$ta(a, "checked", b, !1);
}
function $b06889f723b28786$var$bb(a, b) {
    $b06889f723b28786$var$ab(a, b);
    var c = $b06889f723b28786$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b06889f723b28786$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b06889f723b28786$var$cb(a, b.type, $b06889f723b28786$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b06889f723b28786$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b06889f723b28786$var$cb(a, b, c) {
    if ("number" !== b || $b06889f723b28786$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b06889f723b28786$var$eb = Array.isArray;
function $b06889f723b28786$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b06889f723b28786$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b06889f723b28786$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b06889f723b28786$var$p(91));
    return $b06889f723b28786$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b06889f723b28786$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b06889f723b28786$var$p(92));
            if ($b06889f723b28786$var$eb(c)) {
                if (1 < c.length) throw Error($b06889f723b28786$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b06889f723b28786$var$Sa(c)
    };
}
function $b06889f723b28786$var$ib(a, b) {
    var c = $b06889f723b28786$var$Sa(b.value), d = $b06889f723b28786$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b06889f723b28786$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b06889f723b28786$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b06889f723b28786$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b06889f723b28786$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b06889f723b28786$var$mb, $b06889f723b28786$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b06889f723b28786$var$mb = $b06889f723b28786$var$mb || document.createElement("div");
        $b06889f723b28786$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b06889f723b28786$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b06889f723b28786$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b06889f723b28786$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b06889f723b28786$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b06889f723b28786$var$pb).forEach(function(a) {
    $b06889f723b28786$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b06889f723b28786$var$pb[b] = $b06889f723b28786$var$pb[a];
    });
});
function $b06889f723b28786$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b06889f723b28786$var$pb.hasOwnProperty(a) && $b06889f723b28786$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b06889f723b28786$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b06889f723b28786$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b06889f723b28786$var$tb = $b06889f723b28786$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b06889f723b28786$var$ub(a, b) {
    if (b) {
        if ($b06889f723b28786$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b06889f723b28786$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b06889f723b28786$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b06889f723b28786$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b06889f723b28786$var$p(62));
    }
}
function $b06889f723b28786$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b06889f723b28786$var$wb = null;
function $b06889f723b28786$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b06889f723b28786$var$yb = null, $b06889f723b28786$var$zb = null, $b06889f723b28786$var$Ab = null;
function $b06889f723b28786$var$Bb(a) {
    if (a = $b06889f723b28786$var$Cb(a)) {
        if ("function" !== typeof $b06889f723b28786$var$yb) throw Error($b06889f723b28786$var$p(280));
        var b = a.stateNode;
        b && (b = $b06889f723b28786$var$Db(b), $b06889f723b28786$var$yb(a.stateNode, a.type, b));
    }
}
function $b06889f723b28786$var$Eb(a) {
    $b06889f723b28786$var$zb ? $b06889f723b28786$var$Ab ? $b06889f723b28786$var$Ab.push(a) : $b06889f723b28786$var$Ab = [
        a
    ] : $b06889f723b28786$var$zb = a;
}
function $b06889f723b28786$var$Fb() {
    if ($b06889f723b28786$var$zb) {
        var a = $b06889f723b28786$var$zb, b = $b06889f723b28786$var$Ab;
        $b06889f723b28786$var$Ab = $b06889f723b28786$var$zb = null;
        $b06889f723b28786$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b06889f723b28786$var$Bb(b[a]);
    }
}
function $b06889f723b28786$var$Gb(a, b) {
    return a(b);
}
function $b06889f723b28786$var$Hb() {}
var $b06889f723b28786$var$Ib = !1;
function $b06889f723b28786$var$Jb(a, b, c) {
    if ($b06889f723b28786$var$Ib) return a(b, c);
    $b06889f723b28786$var$Ib = !0;
    try {
        return $b06889f723b28786$var$Gb(a, b, c);
    } finally{
        if ($b06889f723b28786$var$Ib = !1, null !== $b06889f723b28786$var$zb || null !== $b06889f723b28786$var$Ab) $b06889f723b28786$var$Hb(), $b06889f723b28786$var$Fb();
    }
}
function $b06889f723b28786$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b06889f723b28786$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b06889f723b28786$var$p(231, b, typeof c));
    return c;
}
var $b06889f723b28786$var$Lb = !1;
if ($b06889f723b28786$var$ia) try {
    var $b06889f723b28786$var$Mb = {};
    Object.defineProperty($b06889f723b28786$var$Mb, "passive", {
        get: function() {
            $b06889f723b28786$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b06889f723b28786$var$Mb, $b06889f723b28786$var$Mb);
    window.removeEventListener("test", $b06889f723b28786$var$Mb, $b06889f723b28786$var$Mb);
} catch (a) {
    $b06889f723b28786$var$Lb = !1;
}
function $b06889f723b28786$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b06889f723b28786$var$Ob = !1, $b06889f723b28786$var$Pb = null, $b06889f723b28786$var$Qb = !1, $b06889f723b28786$var$Rb = null, $b06889f723b28786$var$Sb = {
    onError: function(a) {
        $b06889f723b28786$var$Ob = !0;
        $b06889f723b28786$var$Pb = a;
    }
};
function $b06889f723b28786$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b06889f723b28786$var$Ob = !1;
    $b06889f723b28786$var$Pb = null;
    $b06889f723b28786$var$Nb.apply($b06889f723b28786$var$Sb, arguments);
}
function $b06889f723b28786$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b06889f723b28786$var$Tb.apply(this, arguments);
    if ($b06889f723b28786$var$Ob) {
        if ($b06889f723b28786$var$Ob) {
            var l = $b06889f723b28786$var$Pb;
            $b06889f723b28786$var$Ob = !1;
            $b06889f723b28786$var$Pb = null;
        } else throw Error($b06889f723b28786$var$p(198));
        $b06889f723b28786$var$Qb || ($b06889f723b28786$var$Qb = !0, $b06889f723b28786$var$Rb = l);
    }
}
function $b06889f723b28786$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b06889f723b28786$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b06889f723b28786$var$Xb(a) {
    if ($b06889f723b28786$var$Vb(a) !== a) throw Error($b06889f723b28786$var$p(188));
}
function $b06889f723b28786$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b06889f723b28786$var$Vb(a);
        if (null === b) throw Error($b06889f723b28786$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b06889f723b28786$var$Xb(e), a;
                if (f === d) return $b06889f723b28786$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b06889f723b28786$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b06889f723b28786$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b06889f723b28786$var$p(190));
    }
    if (3 !== c.tag) throw Error($b06889f723b28786$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b06889f723b28786$var$Zb(a) {
    a = $b06889f723b28786$var$Yb(a);
    return null !== a ? $b06889f723b28786$var$$b(a) : null;
}
function $b06889f723b28786$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b06889f723b28786$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b06889f723b28786$var$ac = $4pKUR.unstable_scheduleCallback, $b06889f723b28786$var$bc = $4pKUR.unstable_cancelCallback, $b06889f723b28786$var$cc = $4pKUR.unstable_shouldYield, $b06889f723b28786$var$dc = $4pKUR.unstable_requestPaint, $b06889f723b28786$var$B = $4pKUR.unstable_now, $b06889f723b28786$var$ec = $4pKUR.unstable_getCurrentPriorityLevel, $b06889f723b28786$var$fc = $4pKUR.unstable_ImmediatePriority, $b06889f723b28786$var$gc = $4pKUR.unstable_UserBlockingPriority, $b06889f723b28786$var$hc = $4pKUR.unstable_NormalPriority, $b06889f723b28786$var$ic = $4pKUR.unstable_LowPriority, $b06889f723b28786$var$jc = $4pKUR.unstable_IdlePriority, $b06889f723b28786$var$kc = null, $b06889f723b28786$var$lc = null;
function $b06889f723b28786$var$mc(a) {
    if ($b06889f723b28786$var$lc && "function" === typeof $b06889f723b28786$var$lc.onCommitFiberRoot) try {
        $b06889f723b28786$var$lc.onCommitFiberRoot($b06889f723b28786$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b06889f723b28786$var$oc = Math.clz32 ? Math.clz32 : $b06889f723b28786$var$nc, $b06889f723b28786$var$pc = Math.log, $b06889f723b28786$var$qc = Math.LN2;
function $b06889f723b28786$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b06889f723b28786$var$pc(a) / $b06889f723b28786$var$qc | 0) | 0;
}
var $b06889f723b28786$var$rc = 64, $b06889f723b28786$var$sc = 4194304;
function $b06889f723b28786$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b06889f723b28786$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b06889f723b28786$var$tc(h) : (f &= g, 0 !== f && (d = $b06889f723b28786$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b06889f723b28786$var$tc(g) : 0 !== f && (d = $b06889f723b28786$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b06889f723b28786$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b06889f723b28786$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b06889f723b28786$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b06889f723b28786$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b06889f723b28786$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b06889f723b28786$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b06889f723b28786$var$yc() {
    var a = $b06889f723b28786$var$rc;
    $b06889f723b28786$var$rc <<= 1;
    0 === ($b06889f723b28786$var$rc & 4194240) && ($b06889f723b28786$var$rc = 64);
    return a;
}
function $b06889f723b28786$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b06889f723b28786$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b06889f723b28786$var$oc(b);
    a[b] = c;
}
function $b06889f723b28786$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b06889f723b28786$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b06889f723b28786$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b06889f723b28786$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b06889f723b28786$var$C = 0;
function $b06889f723b28786$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b06889f723b28786$var$Ec, $b06889f723b28786$var$Fc, $b06889f723b28786$var$Gc, $b06889f723b28786$var$Hc, $b06889f723b28786$var$Ic, $b06889f723b28786$var$Jc = !1, $b06889f723b28786$var$Kc = [], $b06889f723b28786$var$Lc = null, $b06889f723b28786$var$Mc = null, $b06889f723b28786$var$Nc = null, $b06889f723b28786$var$Oc = new Map, $b06889f723b28786$var$Pc = new Map, $b06889f723b28786$var$Qc = [], $b06889f723b28786$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b06889f723b28786$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b06889f723b28786$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b06889f723b28786$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b06889f723b28786$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b06889f723b28786$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b06889f723b28786$var$Pc.delete(b.pointerId);
    }
}
function $b06889f723b28786$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b06889f723b28786$var$Cb(b), null !== b && $b06889f723b28786$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b06889f723b28786$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b06889f723b28786$var$Lc = $b06889f723b28786$var$Tc($b06889f723b28786$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b06889f723b28786$var$Mc = $b06889f723b28786$var$Tc($b06889f723b28786$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b06889f723b28786$var$Nc = $b06889f723b28786$var$Tc($b06889f723b28786$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b06889f723b28786$var$Oc.set(f, $b06889f723b28786$var$Tc($b06889f723b28786$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b06889f723b28786$var$Pc.set(f, $b06889f723b28786$var$Tc($b06889f723b28786$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b06889f723b28786$var$Vc(a) {
    var b = $b06889f723b28786$var$Wc(a.target);
    if (null !== b) {
        var c = $b06889f723b28786$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b06889f723b28786$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b06889f723b28786$var$Ic(a.priority, function() {
                        $b06889f723b28786$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b06889f723b28786$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b06889f723b28786$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b06889f723b28786$var$wb = d;
            c.target.dispatchEvent(d);
            $b06889f723b28786$var$wb = null;
        } else return b = $b06889f723b28786$var$Cb(c), null !== b && $b06889f723b28786$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b06889f723b28786$var$Zc(a, b, c) {
    $b06889f723b28786$var$Xc(a) && c.delete(b);
}
function $b06889f723b28786$var$$c() {
    $b06889f723b28786$var$Jc = !1;
    null !== $b06889f723b28786$var$Lc && $b06889f723b28786$var$Xc($b06889f723b28786$var$Lc) && ($b06889f723b28786$var$Lc = null);
    null !== $b06889f723b28786$var$Mc && $b06889f723b28786$var$Xc($b06889f723b28786$var$Mc) && ($b06889f723b28786$var$Mc = null);
    null !== $b06889f723b28786$var$Nc && $b06889f723b28786$var$Xc($b06889f723b28786$var$Nc) && ($b06889f723b28786$var$Nc = null);
    $b06889f723b28786$var$Oc.forEach($b06889f723b28786$var$Zc);
    $b06889f723b28786$var$Pc.forEach($b06889f723b28786$var$Zc);
}
function $b06889f723b28786$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b06889f723b28786$var$Jc || ($b06889f723b28786$var$Jc = !0, $4pKUR.unstable_scheduleCallback($4pKUR.unstable_NormalPriority, $b06889f723b28786$var$$c)));
}
function $b06889f723b28786$var$bd(a) {
    function b(b) {
        return $b06889f723b28786$var$ad(b, a);
    }
    if (0 < $b06889f723b28786$var$Kc.length) {
        $b06889f723b28786$var$ad($b06889f723b28786$var$Kc[0], a);
        for(var c = 1; c < $b06889f723b28786$var$Kc.length; c++){
            var d = $b06889f723b28786$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b06889f723b28786$var$Lc && $b06889f723b28786$var$ad($b06889f723b28786$var$Lc, a);
    null !== $b06889f723b28786$var$Mc && $b06889f723b28786$var$ad($b06889f723b28786$var$Mc, a);
    null !== $b06889f723b28786$var$Nc && $b06889f723b28786$var$ad($b06889f723b28786$var$Nc, a);
    $b06889f723b28786$var$Oc.forEach(b);
    $b06889f723b28786$var$Pc.forEach(b);
    for(c = 0; c < $b06889f723b28786$var$Qc.length; c++)d = $b06889f723b28786$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b06889f723b28786$var$Qc.length && (c = $b06889f723b28786$var$Qc[0], null === c.blockedOn);)$b06889f723b28786$var$Vc(c), null === c.blockedOn && $b06889f723b28786$var$Qc.shift();
}
var $b06889f723b28786$var$cd = $b06889f723b28786$var$ua.ReactCurrentBatchConfig, $b06889f723b28786$var$dd = !0;
function $b06889f723b28786$var$ed(a, b, c, d) {
    var e = $b06889f723b28786$var$C, f = $b06889f723b28786$var$cd.transition;
    $b06889f723b28786$var$cd.transition = null;
    try {
        $b06889f723b28786$var$C = 1, $b06889f723b28786$var$fd(a, b, c, d);
    } finally{
        $b06889f723b28786$var$C = e, $b06889f723b28786$var$cd.transition = f;
    }
}
function $b06889f723b28786$var$gd(a, b, c, d) {
    var e = $b06889f723b28786$var$C, f = $b06889f723b28786$var$cd.transition;
    $b06889f723b28786$var$cd.transition = null;
    try {
        $b06889f723b28786$var$C = 4, $b06889f723b28786$var$fd(a, b, c, d);
    } finally{
        $b06889f723b28786$var$C = e, $b06889f723b28786$var$cd.transition = f;
    }
}
function $b06889f723b28786$var$fd(a, b, c, d) {
    if ($b06889f723b28786$var$dd) {
        var e = $b06889f723b28786$var$Yc(a, b, c, d);
        if (null === e) $b06889f723b28786$var$hd(a, b, d, $b06889f723b28786$var$id, c), $b06889f723b28786$var$Sc(a, d);
        else if ($b06889f723b28786$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b06889f723b28786$var$Sc(a, d), b & 4 && -1 < $b06889f723b28786$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b06889f723b28786$var$Cb(e);
                null !== f && $b06889f723b28786$var$Ec(f);
                f = $b06889f723b28786$var$Yc(a, b, c, d);
                null === f && $b06889f723b28786$var$hd(a, b, d, $b06889f723b28786$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b06889f723b28786$var$hd(a, b, d, null, c);
    }
}
var $b06889f723b28786$var$id = null;
function $b06889f723b28786$var$Yc(a, b, c, d) {
    $b06889f723b28786$var$id = null;
    a = $b06889f723b28786$var$xb(d);
    a = $b06889f723b28786$var$Wc(a);
    if (null !== a) {
        if (b = $b06889f723b28786$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b06889f723b28786$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b06889f723b28786$var$id = a;
    return null;
}
function $b06889f723b28786$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b06889f723b28786$var$ec()){
                case $b06889f723b28786$var$fc:
                    return 1;
                case $b06889f723b28786$var$gc:
                    return 4;
                case $b06889f723b28786$var$hc:
                case $b06889f723b28786$var$ic:
                    return 16;
                case $b06889f723b28786$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b06889f723b28786$var$kd = null, $b06889f723b28786$var$ld = null, $b06889f723b28786$var$md = null;
function $b06889f723b28786$var$nd() {
    if ($b06889f723b28786$var$md) return $b06889f723b28786$var$md;
    var a, b = $b06889f723b28786$var$ld, c = b.length, d, e = "value" in $b06889f723b28786$var$kd ? $b06889f723b28786$var$kd.value : $b06889f723b28786$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b06889f723b28786$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b06889f723b28786$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b06889f723b28786$var$pd() {
    return !0;
}
function $b06889f723b28786$var$qd() {
    return !1;
}
function $b06889f723b28786$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b06889f723b28786$var$pd : $b06889f723b28786$var$qd;
        this.isPropagationStopped = $b06889f723b28786$var$qd;
        return this;
    }
    $b06889f723b28786$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b06889f723b28786$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b06889f723b28786$var$pd);
        },
        persist: function() {},
        isPersistent: $b06889f723b28786$var$pd
    });
    return b;
}
var $b06889f723b28786$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b06889f723b28786$var$td = $b06889f723b28786$var$rd($b06889f723b28786$var$sd), $b06889f723b28786$var$ud = $b06889f723b28786$var$A({}, $b06889f723b28786$var$sd, {
    view: 0,
    detail: 0
}), $b06889f723b28786$var$vd = $b06889f723b28786$var$rd($b06889f723b28786$var$ud), $b06889f723b28786$var$wd, $b06889f723b28786$var$xd, $b06889f723b28786$var$yd, $b06889f723b28786$var$Ad = $b06889f723b28786$var$A({}, $b06889f723b28786$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b06889f723b28786$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b06889f723b28786$var$yd && ($b06889f723b28786$var$yd && "mousemove" === a.type ? ($b06889f723b28786$var$wd = a.screenX - $b06889f723b28786$var$yd.screenX, $b06889f723b28786$var$xd = a.screenY - $b06889f723b28786$var$yd.screenY) : $b06889f723b28786$var$xd = $b06889f723b28786$var$wd = 0, $b06889f723b28786$var$yd = a);
        return $b06889f723b28786$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b06889f723b28786$var$xd;
    }
}), $b06889f723b28786$var$Bd = $b06889f723b28786$var$rd($b06889f723b28786$var$Ad), $b06889f723b28786$var$Cd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$Ad, {
    dataTransfer: 0
}), $b06889f723b28786$var$Dd = $b06889f723b28786$var$rd($b06889f723b28786$var$Cd), $b06889f723b28786$var$Ed = $b06889f723b28786$var$A({}, $b06889f723b28786$var$ud, {
    relatedTarget: 0
}), $b06889f723b28786$var$Fd = $b06889f723b28786$var$rd($b06889f723b28786$var$Ed), $b06889f723b28786$var$Gd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b06889f723b28786$var$Hd = $b06889f723b28786$var$rd($b06889f723b28786$var$Gd), $b06889f723b28786$var$Id = $b06889f723b28786$var$A({}, $b06889f723b28786$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b06889f723b28786$var$Jd = $b06889f723b28786$var$rd($b06889f723b28786$var$Id), $b06889f723b28786$var$Kd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$sd, {
    data: 0
}), $b06889f723b28786$var$Ld = $b06889f723b28786$var$rd($b06889f723b28786$var$Kd), $b06889f723b28786$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b06889f723b28786$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b06889f723b28786$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b06889f723b28786$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b06889f723b28786$var$Od[a]) ? !!b[a] : !1;
}
function $b06889f723b28786$var$zd() {
    return $b06889f723b28786$var$Pd;
}
var $b06889f723b28786$var$Qd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b06889f723b28786$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b06889f723b28786$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b06889f723b28786$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b06889f723b28786$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b06889f723b28786$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b06889f723b28786$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b06889f723b28786$var$Rd = $b06889f723b28786$var$rd($b06889f723b28786$var$Qd), $b06889f723b28786$var$Sd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b06889f723b28786$var$Td = $b06889f723b28786$var$rd($b06889f723b28786$var$Sd), $b06889f723b28786$var$Ud = $b06889f723b28786$var$A({}, $b06889f723b28786$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b06889f723b28786$var$zd
}), $b06889f723b28786$var$Vd = $b06889f723b28786$var$rd($b06889f723b28786$var$Ud), $b06889f723b28786$var$Wd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b06889f723b28786$var$Xd = $b06889f723b28786$var$rd($b06889f723b28786$var$Wd), $b06889f723b28786$var$Yd = $b06889f723b28786$var$A({}, $b06889f723b28786$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b06889f723b28786$var$Zd = $b06889f723b28786$var$rd($b06889f723b28786$var$Yd), $b06889f723b28786$var$$d = [
    9,
    13,
    27,
    32
], $b06889f723b28786$var$ae = $b06889f723b28786$var$ia && "CompositionEvent" in window, $b06889f723b28786$var$be = null;
$b06889f723b28786$var$ia && "documentMode" in document && ($b06889f723b28786$var$be = document.documentMode);
var $b06889f723b28786$var$ce = $b06889f723b28786$var$ia && "TextEvent" in window && !$b06889f723b28786$var$be, $b06889f723b28786$var$de = $b06889f723b28786$var$ia && (!$b06889f723b28786$var$ae || $b06889f723b28786$var$be && 8 < $b06889f723b28786$var$be && 11 >= $b06889f723b28786$var$be), $b06889f723b28786$var$ee = String.fromCharCode(32), $b06889f723b28786$var$fe = !1;
function $b06889f723b28786$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b06889f723b28786$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b06889f723b28786$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b06889f723b28786$var$ie = !1;
function $b06889f723b28786$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b06889f723b28786$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b06889f723b28786$var$fe = !0;
            return $b06889f723b28786$var$ee;
        case "textInput":
            return a = b.data, a === $b06889f723b28786$var$ee && $b06889f723b28786$var$fe ? null : a;
        default:
            return null;
    }
}
function $b06889f723b28786$var$ke(a, b) {
    if ($b06889f723b28786$var$ie) return "compositionend" === a || !$b06889f723b28786$var$ae && $b06889f723b28786$var$ge(a, b) ? (a = $b06889f723b28786$var$nd(), $b06889f723b28786$var$md = $b06889f723b28786$var$ld = $b06889f723b28786$var$kd = null, $b06889f723b28786$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b06889f723b28786$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b06889f723b28786$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b06889f723b28786$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b06889f723b28786$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b06889f723b28786$var$ne(a, b, c, d) {
    $b06889f723b28786$var$Eb(d);
    b = $b06889f723b28786$var$oe(b, "onChange");
    0 < b.length && (c = new $b06889f723b28786$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b06889f723b28786$var$pe = null, $b06889f723b28786$var$qe = null;
function $b06889f723b28786$var$re(a) {
    $b06889f723b28786$var$se(a, 0);
}
function $b06889f723b28786$var$te(a) {
    var b = $b06889f723b28786$var$ue(a);
    if ($b06889f723b28786$var$Wa(b)) return a;
}
function $b06889f723b28786$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b06889f723b28786$var$we = !1;
if ($b06889f723b28786$var$ia) {
    var $b06889f723b28786$var$xe;
    if ($b06889f723b28786$var$ia) {
        var $b06889f723b28786$var$ye = "oninput" in document;
        if (!$b06889f723b28786$var$ye) {
            var $b06889f723b28786$var$ze = document.createElement("div");
            $b06889f723b28786$var$ze.setAttribute("oninput", "return;");
            $b06889f723b28786$var$ye = "function" === typeof $b06889f723b28786$var$ze.oninput;
        }
        $b06889f723b28786$var$xe = $b06889f723b28786$var$ye;
    } else $b06889f723b28786$var$xe = !1;
    $b06889f723b28786$var$we = $b06889f723b28786$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b06889f723b28786$var$Ae() {
    $b06889f723b28786$var$pe && ($b06889f723b28786$var$pe.detachEvent("onpropertychange", $b06889f723b28786$var$Be), $b06889f723b28786$var$qe = $b06889f723b28786$var$pe = null);
}
function $b06889f723b28786$var$Be(a) {
    if ("value" === a.propertyName && $b06889f723b28786$var$te($b06889f723b28786$var$qe)) {
        var b = [];
        $b06889f723b28786$var$ne(b, $b06889f723b28786$var$qe, a, $b06889f723b28786$var$xb(a));
        $b06889f723b28786$var$Jb($b06889f723b28786$var$re, b);
    }
}
function $b06889f723b28786$var$Ce(a, b, c) {
    "focusin" === a ? ($b06889f723b28786$var$Ae(), $b06889f723b28786$var$pe = b, $b06889f723b28786$var$qe = c, $b06889f723b28786$var$pe.attachEvent("onpropertychange", $b06889f723b28786$var$Be)) : "focusout" === a && $b06889f723b28786$var$Ae();
}
function $b06889f723b28786$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b06889f723b28786$var$te($b06889f723b28786$var$qe);
}
function $b06889f723b28786$var$Ee(a, b) {
    if ("click" === a) return $b06889f723b28786$var$te(b);
}
function $b06889f723b28786$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b06889f723b28786$var$te(b);
}
function $b06889f723b28786$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b06889f723b28786$var$He = "function" === typeof Object.is ? Object.is : $b06889f723b28786$var$Ge;
function $b06889f723b28786$var$Ie(a, b) {
    if ($b06889f723b28786$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b06889f723b28786$var$ja.call(b, e) || !$b06889f723b28786$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b06889f723b28786$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b06889f723b28786$var$Ke(a, b) {
    var c = $b06889f723b28786$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b06889f723b28786$var$Je(c);
    }
}
function $b06889f723b28786$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b06889f723b28786$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b06889f723b28786$var$Me() {
    for(var a = window, b = $b06889f723b28786$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b06889f723b28786$var$Xa(a.document);
    }
    return b;
}
function $b06889f723b28786$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b06889f723b28786$var$Oe(a) {
    var b = $b06889f723b28786$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b06889f723b28786$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b06889f723b28786$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b06889f723b28786$var$Ke(c, f);
                var g = $b06889f723b28786$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b06889f723b28786$var$Pe = $b06889f723b28786$var$ia && "documentMode" in document && 11 >= document.documentMode, $b06889f723b28786$var$Qe = null, $b06889f723b28786$var$Re = null, $b06889f723b28786$var$Se = null, $b06889f723b28786$var$Te = !1;
function $b06889f723b28786$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b06889f723b28786$var$Te || null == $b06889f723b28786$var$Qe || $b06889f723b28786$var$Qe !== $b06889f723b28786$var$Xa(d) || (d = $b06889f723b28786$var$Qe, "selectionStart" in d && $b06889f723b28786$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b06889f723b28786$var$Se && $b06889f723b28786$var$Ie($b06889f723b28786$var$Se, d) || ($b06889f723b28786$var$Se = d, d = $b06889f723b28786$var$oe($b06889f723b28786$var$Re, "onSelect"), 0 < d.length && (b = new $b06889f723b28786$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b06889f723b28786$var$Qe)));
}
function $b06889f723b28786$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b06889f723b28786$var$We = {
    animationend: $b06889f723b28786$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b06889f723b28786$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b06889f723b28786$var$Ve("Animation", "AnimationStart"),
    transitionend: $b06889f723b28786$var$Ve("Transition", "TransitionEnd")
}, $b06889f723b28786$var$Xe = {}, $b06889f723b28786$var$Ye = {};
$b06889f723b28786$var$ia && ($b06889f723b28786$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b06889f723b28786$var$We.animationend.animation, delete $b06889f723b28786$var$We.animationiteration.animation, delete $b06889f723b28786$var$We.animationstart.animation), "TransitionEvent" in window || delete $b06889f723b28786$var$We.transitionend.transition);
function $b06889f723b28786$var$Ze(a) {
    if ($b06889f723b28786$var$Xe[a]) return $b06889f723b28786$var$Xe[a];
    if (!$b06889f723b28786$var$We[a]) return a;
    var b = $b06889f723b28786$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b06889f723b28786$var$Ye) return $b06889f723b28786$var$Xe[a] = b[c];
    return a;
}
var $b06889f723b28786$var$$e = $b06889f723b28786$var$Ze("animationend"), $b06889f723b28786$var$af = $b06889f723b28786$var$Ze("animationiteration"), $b06889f723b28786$var$bf = $b06889f723b28786$var$Ze("animationstart"), $b06889f723b28786$var$cf = $b06889f723b28786$var$Ze("transitionend"), $b06889f723b28786$var$df = new Map, $b06889f723b28786$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b06889f723b28786$var$ff(a, b) {
    $b06889f723b28786$var$df.set(a, b);
    $b06889f723b28786$var$fa(b, [
        a
    ]);
}
for(var $b06889f723b28786$var$gf = 0; $b06889f723b28786$var$gf < $b06889f723b28786$var$ef.length; $b06889f723b28786$var$gf++){
    var $b06889f723b28786$var$hf = $b06889f723b28786$var$ef[$b06889f723b28786$var$gf], $b06889f723b28786$var$jf = $b06889f723b28786$var$hf.toLowerCase(), $b06889f723b28786$var$kf = $b06889f723b28786$var$hf[0].toUpperCase() + $b06889f723b28786$var$hf.slice(1);
    $b06889f723b28786$var$ff($b06889f723b28786$var$jf, "on" + $b06889f723b28786$var$kf);
}
$b06889f723b28786$var$ff($b06889f723b28786$var$$e, "onAnimationEnd");
$b06889f723b28786$var$ff($b06889f723b28786$var$af, "onAnimationIteration");
$b06889f723b28786$var$ff($b06889f723b28786$var$bf, "onAnimationStart");
$b06889f723b28786$var$ff("dblclick", "onDoubleClick");
$b06889f723b28786$var$ff("focusin", "onFocus");
$b06889f723b28786$var$ff("focusout", "onBlur");
$b06889f723b28786$var$ff($b06889f723b28786$var$cf, "onTransitionEnd");
$b06889f723b28786$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b06889f723b28786$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b06889f723b28786$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b06889f723b28786$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b06889f723b28786$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b06889f723b28786$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b06889f723b28786$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b06889f723b28786$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b06889f723b28786$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b06889f723b28786$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b06889f723b28786$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b06889f723b28786$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b06889f723b28786$var$lf));
function $b06889f723b28786$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b06889f723b28786$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b06889f723b28786$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b06889f723b28786$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b06889f723b28786$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b06889f723b28786$var$Qb) throw a = $b06889f723b28786$var$Rb, $b06889f723b28786$var$Qb = !1, $b06889f723b28786$var$Rb = null, a;
}
function $b06889f723b28786$var$D(a, b) {
    var c = b[$b06889f723b28786$var$of];
    void 0 === c && (c = b[$b06889f723b28786$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b06889f723b28786$var$pf(b, a, 2, !1), c.add(d));
}
function $b06889f723b28786$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b06889f723b28786$var$pf(c, a, d, b);
}
var $b06889f723b28786$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b06889f723b28786$var$sf(a) {
    if (!a[$b06889f723b28786$var$rf]) {
        a[$b06889f723b28786$var$rf] = !0;
        $b06889f723b28786$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b06889f723b28786$var$mf.has(b) || $b06889f723b28786$var$qf(b, !1, a), $b06889f723b28786$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b06889f723b28786$var$rf] || (b[$b06889f723b28786$var$rf] = !0, $b06889f723b28786$var$qf("selectionchange", !1, b));
    }
}
function $b06889f723b28786$var$pf(a, b, c, d) {
    switch($b06889f723b28786$var$jd(b)){
        case 1:
            var e = $b06889f723b28786$var$ed;
            break;
        case 4:
            e = $b06889f723b28786$var$gd;
            break;
        default:
            e = $b06889f723b28786$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b06889f723b28786$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b06889f723b28786$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b06889f723b28786$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b06889f723b28786$var$Jb(function() {
        var d = f, e = $b06889f723b28786$var$xb(c), g = [];
        a: {
            var h = $b06889f723b28786$var$df.get(a);
            if (void 0 !== h) {
                var k = $b06889f723b28786$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b06889f723b28786$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b06889f723b28786$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b06889f723b28786$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b06889f723b28786$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b06889f723b28786$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b06889f723b28786$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b06889f723b28786$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b06889f723b28786$var$Vd;
                        break;
                    case $b06889f723b28786$var$$e:
                    case $b06889f723b28786$var$af:
                    case $b06889f723b28786$var$bf:
                        k = $b06889f723b28786$var$Hd;
                        break;
                    case $b06889f723b28786$var$cf:
                        k = $b06889f723b28786$var$Xd;
                        break;
                    case "scroll":
                        k = $b06889f723b28786$var$vd;
                        break;
                    case "wheel":
                        k = $b06889f723b28786$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b06889f723b28786$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b06889f723b28786$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b06889f723b28786$var$Kb(w, x), null != F && t.push($b06889f723b28786$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b06889f723b28786$var$wb && (n = c.relatedTarget || c.fromElement) && ($b06889f723b28786$var$Wc(n) || n[$b06889f723b28786$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b06889f723b28786$var$Wc(n) : null, null !== n && (J = $b06889f723b28786$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b06889f723b28786$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b06889f723b28786$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b06889f723b28786$var$ue(k);
                        u = null == n ? h : $b06889f723b28786$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b06889f723b28786$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b06889f723b28786$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b06889f723b28786$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b06889f723b28786$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b06889f723b28786$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b06889f723b28786$var$vf(t);
                                x = $b06889f723b28786$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b06889f723b28786$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b06889f723b28786$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b06889f723b28786$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b06889f723b28786$var$ve;
                else if ($b06889f723b28786$var$me(h)) {
                    if ($b06889f723b28786$var$we) na = $b06889f723b28786$var$Fe;
                    else {
                        na = $b06889f723b28786$var$De;
                        var xa = $b06889f723b28786$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b06889f723b28786$var$Ee);
                if (na && (na = na(a, d))) {
                    $b06889f723b28786$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b06889f723b28786$var$cb(h, "number", h.value);
            }
            xa = d ? $b06889f723b28786$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b06889f723b28786$var$me(xa) || "true" === xa.contentEditable) $b06889f723b28786$var$Qe = xa, $b06889f723b28786$var$Re = d, $b06889f723b28786$var$Se = null;
                    break;
                case "focusout":
                    $b06889f723b28786$var$Se = $b06889f723b28786$var$Re = $b06889f723b28786$var$Qe = null;
                    break;
                case "mousedown":
                    $b06889f723b28786$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b06889f723b28786$var$Te = !1;
                    $b06889f723b28786$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b06889f723b28786$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b06889f723b28786$var$Ue(g, c, e);
            }
            var $a;
            if ($b06889f723b28786$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b06889f723b28786$var$ie ? $b06889f723b28786$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b06889f723b28786$var$de && "ko" !== c.locale && ($b06889f723b28786$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b06889f723b28786$var$ie && ($a = $b06889f723b28786$var$nd()) : ($b06889f723b28786$var$kd = e, $b06889f723b28786$var$ld = "value" in $b06889f723b28786$var$kd ? $b06889f723b28786$var$kd.value : $b06889f723b28786$var$kd.textContent, $b06889f723b28786$var$ie = !0)), xa = $b06889f723b28786$var$oe(d, ba), 0 < xa.length && (ba = new $b06889f723b28786$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b06889f723b28786$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b06889f723b28786$var$ce ? $b06889f723b28786$var$je(a, c) : $b06889f723b28786$var$ke(a, c)) d = $b06889f723b28786$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b06889f723b28786$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b06889f723b28786$var$se(g, b);
    });
}
function $b06889f723b28786$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b06889f723b28786$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b06889f723b28786$var$Kb(a, c), null != f && d.unshift($b06889f723b28786$var$tf(a, f, e)), f = $b06889f723b28786$var$Kb(a, b), null != f && d.push($b06889f723b28786$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b06889f723b28786$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b06889f723b28786$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b06889f723b28786$var$Kb(c, f), null != k && g.unshift($b06889f723b28786$var$tf(c, k, h))) : e || (k = $b06889f723b28786$var$Kb(c, f), null != k && g.push($b06889f723b28786$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b06889f723b28786$var$xf = /\r\n?/g, $b06889f723b28786$var$yf = /\u0000|\uFFFD/g;
function $b06889f723b28786$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b06889f723b28786$var$xf, "\n").replace($b06889f723b28786$var$yf, "");
}
function $b06889f723b28786$var$Af(a, b, c) {
    b = $b06889f723b28786$var$zf(b);
    if ($b06889f723b28786$var$zf(a) !== b && c) throw Error($b06889f723b28786$var$p(425));
}
function $b06889f723b28786$var$Bf() {}
var $b06889f723b28786$var$Cf = null, $b06889f723b28786$var$Df = null;
function $b06889f723b28786$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b06889f723b28786$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b06889f723b28786$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b06889f723b28786$var$Hf = "function" === typeof Promise ? Promise : void 0, $b06889f723b28786$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b06889f723b28786$var$Hf ? function(a) {
    return $b06889f723b28786$var$Hf.resolve(null).then(a).catch($b06889f723b28786$var$If);
} : $b06889f723b28786$var$Ff;
function $b06889f723b28786$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b06889f723b28786$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b06889f723b28786$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b06889f723b28786$var$bd(b);
}
function $b06889f723b28786$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b06889f723b28786$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b06889f723b28786$var$Nf = Math.random().toString(36).slice(2), $b06889f723b28786$var$Of = "__reactFiber$" + $b06889f723b28786$var$Nf, $b06889f723b28786$var$Pf = "__reactProps$" + $b06889f723b28786$var$Nf, $b06889f723b28786$var$uf = "__reactContainer$" + $b06889f723b28786$var$Nf, $b06889f723b28786$var$of = "__reactEvents$" + $b06889f723b28786$var$Nf, $b06889f723b28786$var$Qf = "__reactListeners$" + $b06889f723b28786$var$Nf, $b06889f723b28786$var$Rf = "__reactHandles$" + $b06889f723b28786$var$Nf;
function $b06889f723b28786$var$Wc(a) {
    var b = a[$b06889f723b28786$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b06889f723b28786$var$uf] || c[$b06889f723b28786$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b06889f723b28786$var$Mf(a); null !== a;){
                if (c = a[$b06889f723b28786$var$Of]) return c;
                a = $b06889f723b28786$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b06889f723b28786$var$Cb(a) {
    a = a[$b06889f723b28786$var$Of] || a[$b06889f723b28786$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b06889f723b28786$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b06889f723b28786$var$p(33));
}
function $b06889f723b28786$var$Db(a) {
    return a[$b06889f723b28786$var$Pf] || null;
}
var $b06889f723b28786$var$Sf = [], $b06889f723b28786$var$Tf = -1;
function $b06889f723b28786$var$Uf(a) {
    return {
        current: a
    };
}
function $b06889f723b28786$var$E(a) {
    0 > $b06889f723b28786$var$Tf || (a.current = $b06889f723b28786$var$Sf[$b06889f723b28786$var$Tf], $b06889f723b28786$var$Sf[$b06889f723b28786$var$Tf] = null, $b06889f723b28786$var$Tf--);
}
function $b06889f723b28786$var$G(a, b) {
    $b06889f723b28786$var$Tf++;
    $b06889f723b28786$var$Sf[$b06889f723b28786$var$Tf] = a.current;
    a.current = b;
}
var $b06889f723b28786$var$Vf = {}, $b06889f723b28786$var$H = $b06889f723b28786$var$Uf($b06889f723b28786$var$Vf), $b06889f723b28786$var$Wf = $b06889f723b28786$var$Uf(!1), $b06889f723b28786$var$Xf = $b06889f723b28786$var$Vf;
function $b06889f723b28786$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b06889f723b28786$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b06889f723b28786$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b06889f723b28786$var$$f() {
    $b06889f723b28786$var$E($b06889f723b28786$var$Wf);
    $b06889f723b28786$var$E($b06889f723b28786$var$H);
}
function $b06889f723b28786$var$ag(a, b, c) {
    if ($b06889f723b28786$var$H.current !== $b06889f723b28786$var$Vf) throw Error($b06889f723b28786$var$p(168));
    $b06889f723b28786$var$G($b06889f723b28786$var$H, b);
    $b06889f723b28786$var$G($b06889f723b28786$var$Wf, c);
}
function $b06889f723b28786$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b06889f723b28786$var$p(108, $b06889f723b28786$var$Ra(a) || "Unknown", e));
    return $b06889f723b28786$var$A({}, c, d);
}
function $b06889f723b28786$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b06889f723b28786$var$Vf;
    $b06889f723b28786$var$Xf = $b06889f723b28786$var$H.current;
    $b06889f723b28786$var$G($b06889f723b28786$var$H, a);
    $b06889f723b28786$var$G($b06889f723b28786$var$Wf, $b06889f723b28786$var$Wf.current);
    return !0;
}
function $b06889f723b28786$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b06889f723b28786$var$p(169));
    c ? (a = $b06889f723b28786$var$bg(a, b, $b06889f723b28786$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b06889f723b28786$var$E($b06889f723b28786$var$Wf), $b06889f723b28786$var$E($b06889f723b28786$var$H), $b06889f723b28786$var$G($b06889f723b28786$var$H, a)) : $b06889f723b28786$var$E($b06889f723b28786$var$Wf);
    $b06889f723b28786$var$G($b06889f723b28786$var$Wf, c);
}
var $b06889f723b28786$var$eg = null, $b06889f723b28786$var$fg = !1, $b06889f723b28786$var$gg = !1;
function $b06889f723b28786$var$hg(a) {
    null === $b06889f723b28786$var$eg ? $b06889f723b28786$var$eg = [
        a
    ] : $b06889f723b28786$var$eg.push(a);
}
function $b06889f723b28786$var$ig(a) {
    $b06889f723b28786$var$fg = !0;
    $b06889f723b28786$var$hg(a);
}
function $b06889f723b28786$var$jg() {
    if (!$b06889f723b28786$var$gg && null !== $b06889f723b28786$var$eg) {
        $b06889f723b28786$var$gg = !0;
        var a = 0, b = $b06889f723b28786$var$C;
        try {
            var c = $b06889f723b28786$var$eg;
            for($b06889f723b28786$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b06889f723b28786$var$eg = null;
            $b06889f723b28786$var$fg = !1;
        } catch (e) {
            throw null !== $b06889f723b28786$var$eg && ($b06889f723b28786$var$eg = $b06889f723b28786$var$eg.slice(a + 1)), $b06889f723b28786$var$ac($b06889f723b28786$var$fc, $b06889f723b28786$var$jg), e;
        } finally{
            $b06889f723b28786$var$C = b, $b06889f723b28786$var$gg = !1;
        }
    }
    return null;
}
var $b06889f723b28786$var$kg = [], $b06889f723b28786$var$lg = 0, $b06889f723b28786$var$mg = null, $b06889f723b28786$var$ng = 0, $b06889f723b28786$var$og = [], $b06889f723b28786$var$pg = 0, $b06889f723b28786$var$qg = null, $b06889f723b28786$var$rg = 1, $b06889f723b28786$var$sg = "";
function $b06889f723b28786$var$tg(a, b) {
    $b06889f723b28786$var$kg[$b06889f723b28786$var$lg++] = $b06889f723b28786$var$ng;
    $b06889f723b28786$var$kg[$b06889f723b28786$var$lg++] = $b06889f723b28786$var$mg;
    $b06889f723b28786$var$mg = a;
    $b06889f723b28786$var$ng = b;
}
function $b06889f723b28786$var$ug(a, b, c) {
    $b06889f723b28786$var$og[$b06889f723b28786$var$pg++] = $b06889f723b28786$var$rg;
    $b06889f723b28786$var$og[$b06889f723b28786$var$pg++] = $b06889f723b28786$var$sg;
    $b06889f723b28786$var$og[$b06889f723b28786$var$pg++] = $b06889f723b28786$var$qg;
    $b06889f723b28786$var$qg = a;
    var d = $b06889f723b28786$var$rg;
    a = $b06889f723b28786$var$sg;
    var e = 32 - $b06889f723b28786$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b06889f723b28786$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b06889f723b28786$var$rg = 1 << 32 - $b06889f723b28786$var$oc(b) + e | c << e | d;
        $b06889f723b28786$var$sg = f + a;
    } else $b06889f723b28786$var$rg = 1 << f | c << e | d, $b06889f723b28786$var$sg = a;
}
function $b06889f723b28786$var$vg(a) {
    null !== a.return && ($b06889f723b28786$var$tg(a, 1), $b06889f723b28786$var$ug(a, 1, 0));
}
function $b06889f723b28786$var$wg(a) {
    for(; a === $b06889f723b28786$var$mg;)$b06889f723b28786$var$mg = $b06889f723b28786$var$kg[--$b06889f723b28786$var$lg], $b06889f723b28786$var$kg[$b06889f723b28786$var$lg] = null, $b06889f723b28786$var$ng = $b06889f723b28786$var$kg[--$b06889f723b28786$var$lg], $b06889f723b28786$var$kg[$b06889f723b28786$var$lg] = null;
    for(; a === $b06889f723b28786$var$qg;)$b06889f723b28786$var$qg = $b06889f723b28786$var$og[--$b06889f723b28786$var$pg], $b06889f723b28786$var$og[$b06889f723b28786$var$pg] = null, $b06889f723b28786$var$sg = $b06889f723b28786$var$og[--$b06889f723b28786$var$pg], $b06889f723b28786$var$og[$b06889f723b28786$var$pg] = null, $b06889f723b28786$var$rg = $b06889f723b28786$var$og[--$b06889f723b28786$var$pg], $b06889f723b28786$var$og[$b06889f723b28786$var$pg] = null;
}
var $b06889f723b28786$var$xg = null, $b06889f723b28786$var$yg = null, $b06889f723b28786$var$I = !1, $b06889f723b28786$var$zg = null;
function $b06889f723b28786$var$Ag(a, b) {
    var c = $b06889f723b28786$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b06889f723b28786$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b06889f723b28786$var$xg = a, $b06889f723b28786$var$yg = $b06889f723b28786$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b06889f723b28786$var$xg = a, $b06889f723b28786$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b06889f723b28786$var$qg ? {
                id: $b06889f723b28786$var$rg,
                overflow: $b06889f723b28786$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b06889f723b28786$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b06889f723b28786$var$xg = a, $b06889f723b28786$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b06889f723b28786$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b06889f723b28786$var$Eg(a) {
    if ($b06889f723b28786$var$I) {
        var b = $b06889f723b28786$var$yg;
        if (b) {
            var c = b;
            if (!$b06889f723b28786$var$Cg(a, b)) {
                if ($b06889f723b28786$var$Dg(a)) throw Error($b06889f723b28786$var$p(418));
                b = $b06889f723b28786$var$Lf(c.nextSibling);
                var d = $b06889f723b28786$var$xg;
                b && $b06889f723b28786$var$Cg(a, b) ? $b06889f723b28786$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b06889f723b28786$var$I = !1, $b06889f723b28786$var$xg = a);
            }
        } else {
            if ($b06889f723b28786$var$Dg(a)) throw Error($b06889f723b28786$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b06889f723b28786$var$I = !1;
            $b06889f723b28786$var$xg = a;
        }
    }
}
function $b06889f723b28786$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b06889f723b28786$var$xg = a;
}
function $b06889f723b28786$var$Gg(a) {
    if (a !== $b06889f723b28786$var$xg) return !1;
    if (!$b06889f723b28786$var$I) return $b06889f723b28786$var$Fg(a), $b06889f723b28786$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b06889f723b28786$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b06889f723b28786$var$yg)) {
        if ($b06889f723b28786$var$Dg(a)) throw $b06889f723b28786$var$Hg(), Error($b06889f723b28786$var$p(418));
        for(; b;)$b06889f723b28786$var$Ag(a, b), b = $b06889f723b28786$var$Lf(b.nextSibling);
    }
    $b06889f723b28786$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b06889f723b28786$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b06889f723b28786$var$yg = $b06889f723b28786$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b06889f723b28786$var$yg = null;
        }
    } else $b06889f723b28786$var$yg = $b06889f723b28786$var$xg ? $b06889f723b28786$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b06889f723b28786$var$Hg() {
    for(var a = $b06889f723b28786$var$yg; a;)a = $b06889f723b28786$var$Lf(a.nextSibling);
}
function $b06889f723b28786$var$Ig() {
    $b06889f723b28786$var$yg = $b06889f723b28786$var$xg = null;
    $b06889f723b28786$var$I = !1;
}
function $b06889f723b28786$var$Jg(a) {
    null === $b06889f723b28786$var$zg ? $b06889f723b28786$var$zg = [
        a
    ] : $b06889f723b28786$var$zg.push(a);
}
var $b06889f723b28786$var$Kg = $b06889f723b28786$var$ua.ReactCurrentBatchConfig;
function $b06889f723b28786$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b06889f723b28786$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b06889f723b28786$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b06889f723b28786$var$p(284));
        if (!c._owner) throw Error($b06889f723b28786$var$p(290, a));
    }
    return a;
}
function $b06889f723b28786$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b06889f723b28786$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b06889f723b28786$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b06889f723b28786$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b06889f723b28786$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b06889f723b28786$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b06889f723b28786$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b06889f723b28786$var$Ha && $b06889f723b28786$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b06889f723b28786$var$Lg(a, b, c), d.return = a, d;
        d = $b06889f723b28786$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b06889f723b28786$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b06889f723b28786$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b06889f723b28786$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b06889f723b28786$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b06889f723b28786$var$va:
                    return c = $b06889f723b28786$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b06889f723b28786$var$Lg(a, null, b), c.return = a, c;
                case $b06889f723b28786$var$wa:
                    return b = $b06889f723b28786$var$Sg(b, a.mode, c), b.return = a, b;
                case $b06889f723b28786$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b06889f723b28786$var$eb(b) || $b06889f723b28786$var$Ka(b)) return b = $b06889f723b28786$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b06889f723b28786$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b06889f723b28786$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b06889f723b28786$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b06889f723b28786$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b06889f723b28786$var$eb(c) || $b06889f723b28786$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b06889f723b28786$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b06889f723b28786$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b06889f723b28786$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b06889f723b28786$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b06889f723b28786$var$eb(d) || $b06889f723b28786$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b06889f723b28786$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b06889f723b28786$var$I && $b06889f723b28786$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b06889f723b28786$var$I && $b06889f723b28786$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b06889f723b28786$var$I && $b06889f723b28786$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b06889f723b28786$var$Ka(h);
        if ("function" !== typeof l) throw Error($b06889f723b28786$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b06889f723b28786$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b06889f723b28786$var$I && $b06889f723b28786$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b06889f723b28786$var$I && $b06889f723b28786$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b06889f723b28786$var$I && $b06889f723b28786$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b06889f723b28786$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b06889f723b28786$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b06889f723b28786$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b06889f723b28786$var$Ha && $b06889f723b28786$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b06889f723b28786$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b06889f723b28786$var$ya ? (d = $b06889f723b28786$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b06889f723b28786$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b06889f723b28786$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b06889f723b28786$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b06889f723b28786$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b06889f723b28786$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b06889f723b28786$var$eb(f)) return n(a, d, f, h);
            if ($b06889f723b28786$var$Ka(f)) return t(a, d, f, h);
            $b06889f723b28786$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b06889f723b28786$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b06889f723b28786$var$Ug = $b06889f723b28786$var$Og(!0), $b06889f723b28786$var$Vg = $b06889f723b28786$var$Og(!1), $b06889f723b28786$var$Wg = $b06889f723b28786$var$Uf(null), $b06889f723b28786$var$Xg = null, $b06889f723b28786$var$Yg = null, $b06889f723b28786$var$Zg = null;
function $b06889f723b28786$var$$g() {
    $b06889f723b28786$var$Zg = $b06889f723b28786$var$Yg = $b06889f723b28786$var$Xg = null;
}
function $b06889f723b28786$var$ah(a) {
    var b = $b06889f723b28786$var$Wg.current;
    $b06889f723b28786$var$E($b06889f723b28786$var$Wg);
    a._currentValue = b;
}
function $b06889f723b28786$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b06889f723b28786$var$ch(a, b) {
    $b06889f723b28786$var$Xg = a;
    $b06889f723b28786$var$Zg = $b06889f723b28786$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b06889f723b28786$var$dh = !0), a.firstContext = null);
}
function $b06889f723b28786$var$eh(a) {
    var b = a._currentValue;
    if ($b06889f723b28786$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b06889f723b28786$var$Yg) {
            if (null === $b06889f723b28786$var$Xg) throw Error($b06889f723b28786$var$p(308));
            $b06889f723b28786$var$Yg = a;
            $b06889f723b28786$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b06889f723b28786$var$Yg = $b06889f723b28786$var$Yg.next = a;
    }
    return b;
}
var $b06889f723b28786$var$fh = null;
function $b06889f723b28786$var$gh(a) {
    null === $b06889f723b28786$var$fh ? $b06889f723b28786$var$fh = [
        a
    ] : $b06889f723b28786$var$fh.push(a);
}
function $b06889f723b28786$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b06889f723b28786$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b06889f723b28786$var$ih(a, d);
}
function $b06889f723b28786$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b06889f723b28786$var$jh = !1;
function $b06889f723b28786$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b06889f723b28786$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b06889f723b28786$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b06889f723b28786$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b06889f723b28786$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b06889f723b28786$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b06889f723b28786$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b06889f723b28786$var$ih(a, c);
}
function $b06889f723b28786$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b06889f723b28786$var$Cc(a, c);
    }
}
function $b06889f723b28786$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b06889f723b28786$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b06889f723b28786$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b06889f723b28786$var$A({}, q, r);
                            break a;
                        case 2:
                            $b06889f723b28786$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b06889f723b28786$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b06889f723b28786$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b06889f723b28786$var$p(191, e));
            e.call(d);
        }
    }
}
var $b06889f723b28786$var$th = {}, $b06889f723b28786$var$uh = $b06889f723b28786$var$Uf($b06889f723b28786$var$th), $b06889f723b28786$var$vh = $b06889f723b28786$var$Uf($b06889f723b28786$var$th), $b06889f723b28786$var$wh = $b06889f723b28786$var$Uf($b06889f723b28786$var$th);
function $b06889f723b28786$var$xh(a) {
    if (a === $b06889f723b28786$var$th) throw Error($b06889f723b28786$var$p(174));
    return a;
}
function $b06889f723b28786$var$yh(a, b) {
    $b06889f723b28786$var$G($b06889f723b28786$var$wh, b);
    $b06889f723b28786$var$G($b06889f723b28786$var$vh, a);
    $b06889f723b28786$var$G($b06889f723b28786$var$uh, $b06889f723b28786$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b06889f723b28786$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b06889f723b28786$var$lb(b, a);
    }
    $b06889f723b28786$var$E($b06889f723b28786$var$uh);
    $b06889f723b28786$var$G($b06889f723b28786$var$uh, b);
}
function $b06889f723b28786$var$zh() {
    $b06889f723b28786$var$E($b06889f723b28786$var$uh);
    $b06889f723b28786$var$E($b06889f723b28786$var$vh);
    $b06889f723b28786$var$E($b06889f723b28786$var$wh);
}
function $b06889f723b28786$var$Ah(a) {
    $b06889f723b28786$var$xh($b06889f723b28786$var$wh.current);
    var b = $b06889f723b28786$var$xh($b06889f723b28786$var$uh.current);
    var c = $b06889f723b28786$var$lb(b, a.type);
    b !== c && ($b06889f723b28786$var$G($b06889f723b28786$var$vh, a), $b06889f723b28786$var$G($b06889f723b28786$var$uh, c));
}
function $b06889f723b28786$var$Bh(a) {
    $b06889f723b28786$var$vh.current === a && ($b06889f723b28786$var$E($b06889f723b28786$var$uh), $b06889f723b28786$var$E($b06889f723b28786$var$vh));
}
var $b06889f723b28786$var$L = $b06889f723b28786$var$Uf(0);
function $b06889f723b28786$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b06889f723b28786$var$Dh = [];
function $b06889f723b28786$var$Eh() {
    for(var a = 0; a < $b06889f723b28786$var$Dh.length; a++)$b06889f723b28786$var$Dh[a]._workInProgressVersionPrimary = null;
    $b06889f723b28786$var$Dh.length = 0;
}
var $b06889f723b28786$var$Fh = $b06889f723b28786$var$ua.ReactCurrentDispatcher, $b06889f723b28786$var$Gh = $b06889f723b28786$var$ua.ReactCurrentBatchConfig, $b06889f723b28786$var$Hh = 0, $b06889f723b28786$var$M = null, $b06889f723b28786$var$N = null, $b06889f723b28786$var$O = null, $b06889f723b28786$var$Ih = !1, $b06889f723b28786$var$Jh = !1, $b06889f723b28786$var$Kh = 0, $b06889f723b28786$var$Lh = 0;
function $b06889f723b28786$var$P() {
    throw Error($b06889f723b28786$var$p(321));
}
function $b06889f723b28786$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b06889f723b28786$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b06889f723b28786$var$Nh(a, b, c, d, e, f) {
    $b06889f723b28786$var$Hh = f;
    $b06889f723b28786$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b06889f723b28786$var$Fh.current = null === a || null === a.memoizedState ? $b06889f723b28786$var$Oh : $b06889f723b28786$var$Ph;
    a = c(d, e);
    if ($b06889f723b28786$var$Jh) {
        f = 0;
        do {
            $b06889f723b28786$var$Jh = !1;
            $b06889f723b28786$var$Kh = 0;
            if (25 <= f) throw Error($b06889f723b28786$var$p(301));
            f += 1;
            $b06889f723b28786$var$O = $b06889f723b28786$var$N = null;
            b.updateQueue = null;
            $b06889f723b28786$var$Fh.current = $b06889f723b28786$var$Qh;
            a = c(d, e);
        }while ($b06889f723b28786$var$Jh);
    }
    $b06889f723b28786$var$Fh.current = $b06889f723b28786$var$Rh;
    b = null !== $b06889f723b28786$var$N && null !== $b06889f723b28786$var$N.next;
    $b06889f723b28786$var$Hh = 0;
    $b06889f723b28786$var$O = $b06889f723b28786$var$N = $b06889f723b28786$var$M = null;
    $b06889f723b28786$var$Ih = !1;
    if (b) throw Error($b06889f723b28786$var$p(300));
    return a;
}
function $b06889f723b28786$var$Sh() {
    var a = 0 !== $b06889f723b28786$var$Kh;
    $b06889f723b28786$var$Kh = 0;
    return a;
}
function $b06889f723b28786$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b06889f723b28786$var$O ? $b06889f723b28786$var$M.memoizedState = $b06889f723b28786$var$O = a : $b06889f723b28786$var$O = $b06889f723b28786$var$O.next = a;
    return $b06889f723b28786$var$O;
}
function $b06889f723b28786$var$Uh() {
    if (null === $b06889f723b28786$var$N) {
        var a = $b06889f723b28786$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b06889f723b28786$var$N.next;
    var b = null === $b06889f723b28786$var$O ? $b06889f723b28786$var$M.memoizedState : $b06889f723b28786$var$O.next;
    if (null !== b) $b06889f723b28786$var$O = b, $b06889f723b28786$var$N = a;
    else {
        if (null === a) throw Error($b06889f723b28786$var$p(310));
        $b06889f723b28786$var$N = a;
        a = {
            memoizedState: $b06889f723b28786$var$N.memoizedState,
            baseState: $b06889f723b28786$var$N.baseState,
            baseQueue: $b06889f723b28786$var$N.baseQueue,
            queue: $b06889f723b28786$var$N.queue,
            next: null
        };
        null === $b06889f723b28786$var$O ? $b06889f723b28786$var$M.memoizedState = $b06889f723b28786$var$O = a : $b06889f723b28786$var$O = $b06889f723b28786$var$O.next = a;
    }
    return $b06889f723b28786$var$O;
}
function $b06889f723b28786$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b06889f723b28786$var$Wh(a) {
    var b = $b06889f723b28786$var$Uh(), c = b.queue;
    if (null === c) throw Error($b06889f723b28786$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b06889f723b28786$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b06889f723b28786$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b06889f723b28786$var$M.lanes |= m;
                $b06889f723b28786$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b06889f723b28786$var$He(d, b.memoizedState) || ($b06889f723b28786$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b06889f723b28786$var$M.lanes |= f, $b06889f723b28786$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b06889f723b28786$var$Xh(a) {
    var b = $b06889f723b28786$var$Uh(), c = b.queue;
    if (null === c) throw Error($b06889f723b28786$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b06889f723b28786$var$He(f, b.memoizedState) || ($b06889f723b28786$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b06889f723b28786$var$Yh() {}
function $b06889f723b28786$var$Zh(a, b) {
    var c = $b06889f723b28786$var$M, d = $b06889f723b28786$var$Uh(), e = b(), f = !$b06889f723b28786$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b06889f723b28786$var$dh = !0);
    d = d.queue;
    $b06889f723b28786$var$$h($b06889f723b28786$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b06889f723b28786$var$O && $b06889f723b28786$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b06889f723b28786$var$bi(9, $b06889f723b28786$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b06889f723b28786$var$Q) throw Error($b06889f723b28786$var$p(349));
        0 !== ($b06889f723b28786$var$Hh & 30) || $b06889f723b28786$var$di(c, b, e);
    }
    return e;
}
function $b06889f723b28786$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b06889f723b28786$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b06889f723b28786$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b06889f723b28786$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b06889f723b28786$var$ei(b) && $b06889f723b28786$var$fi(a);
}
function $b06889f723b28786$var$ai(a, b, c) {
    return c(function() {
        $b06889f723b28786$var$ei(b) && $b06889f723b28786$var$fi(a);
    });
}
function $b06889f723b28786$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b06889f723b28786$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b06889f723b28786$var$fi(a) {
    var b = $b06889f723b28786$var$ih(a, 1);
    null !== b && $b06889f723b28786$var$gi(b, a, 1, -1);
}
function $b06889f723b28786$var$hi(a) {
    var b = $b06889f723b28786$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b06889f723b28786$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b06889f723b28786$var$ii.bind(null, $b06889f723b28786$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b06889f723b28786$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b06889f723b28786$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b06889f723b28786$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b06889f723b28786$var$ji() {
    return $b06889f723b28786$var$Uh().memoizedState;
}
function $b06889f723b28786$var$ki(a, b, c, d) {
    var e = $b06889f723b28786$var$Th();
    $b06889f723b28786$var$M.flags |= a;
    e.memoizedState = $b06889f723b28786$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b06889f723b28786$var$li(a, b, c, d) {
    var e = $b06889f723b28786$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b06889f723b28786$var$N) {
        var g = $b06889f723b28786$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b06889f723b28786$var$Mh(d, g.deps)) {
            e.memoizedState = $b06889f723b28786$var$bi(b, c, f, d);
            return;
        }
    }
    $b06889f723b28786$var$M.flags |= a;
    e.memoizedState = $b06889f723b28786$var$bi(1 | b, c, f, d);
}
function $b06889f723b28786$var$mi(a, b) {
    return $b06889f723b28786$var$ki(8390656, 8, a, b);
}
function $b06889f723b28786$var$$h(a, b) {
    return $b06889f723b28786$var$li(2048, 8, a, b);
}
function $b06889f723b28786$var$ni(a, b) {
    return $b06889f723b28786$var$li(4, 2, a, b);
}
function $b06889f723b28786$var$oi(a, b) {
    return $b06889f723b28786$var$li(4, 4, a, b);
}
function $b06889f723b28786$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b06889f723b28786$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b06889f723b28786$var$li(4, 4, $b06889f723b28786$var$pi.bind(null, b, a), c);
}
function $b06889f723b28786$var$ri() {}
function $b06889f723b28786$var$si(a, b) {
    var c = $b06889f723b28786$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b06889f723b28786$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b06889f723b28786$var$ti(a, b) {
    var c = $b06889f723b28786$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b06889f723b28786$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b06889f723b28786$var$ui(a, b, c) {
    if (0 === ($b06889f723b28786$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b06889f723b28786$var$dh = !0), a.memoizedState = c;
    $b06889f723b28786$var$He(c, b) || (c = $b06889f723b28786$var$yc(), $b06889f723b28786$var$M.lanes |= c, $b06889f723b28786$var$rh |= c, a.baseState = !0);
    return b;
}
function $b06889f723b28786$var$vi(a, b) {
    var c = $b06889f723b28786$var$C;
    $b06889f723b28786$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b06889f723b28786$var$Gh.transition;
    $b06889f723b28786$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b06889f723b28786$var$C = c, $b06889f723b28786$var$Gh.transition = d;
    }
}
function $b06889f723b28786$var$wi() {
    return $b06889f723b28786$var$Uh().memoizedState;
}
function $b06889f723b28786$var$xi(a, b, c) {
    var d = $b06889f723b28786$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b06889f723b28786$var$zi(a)) $b06889f723b28786$var$Ai(b, c);
    else if (c = $b06889f723b28786$var$hh(a, b, c, d), null !== c) {
        var e = $b06889f723b28786$var$R();
        $b06889f723b28786$var$gi(c, a, d, e);
        $b06889f723b28786$var$Bi(c, b, d);
    }
}
function $b06889f723b28786$var$ii(a, b, c) {
    var d = $b06889f723b28786$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b06889f723b28786$var$zi(a)) $b06889f723b28786$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b06889f723b28786$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b06889f723b28786$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b06889f723b28786$var$hh(a, b, e, d);
        null !== c && (e = $b06889f723b28786$var$R(), $b06889f723b28786$var$gi(c, a, d, e), $b06889f723b28786$var$Bi(c, b, d));
    }
}
function $b06889f723b28786$var$zi(a) {
    var b = a.alternate;
    return a === $b06889f723b28786$var$M || null !== b && b === $b06889f723b28786$var$M;
}
function $b06889f723b28786$var$Ai(a, b) {
    $b06889f723b28786$var$Jh = $b06889f723b28786$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b06889f723b28786$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b06889f723b28786$var$Cc(a, c);
    }
}
var $b06889f723b28786$var$Rh = {
    readContext: $b06889f723b28786$var$eh,
    useCallback: $b06889f723b28786$var$P,
    useContext: $b06889f723b28786$var$P,
    useEffect: $b06889f723b28786$var$P,
    useImperativeHandle: $b06889f723b28786$var$P,
    useInsertionEffect: $b06889f723b28786$var$P,
    useLayoutEffect: $b06889f723b28786$var$P,
    useMemo: $b06889f723b28786$var$P,
    useReducer: $b06889f723b28786$var$P,
    useRef: $b06889f723b28786$var$P,
    useState: $b06889f723b28786$var$P,
    useDebugValue: $b06889f723b28786$var$P,
    useDeferredValue: $b06889f723b28786$var$P,
    useTransition: $b06889f723b28786$var$P,
    useMutableSource: $b06889f723b28786$var$P,
    useSyncExternalStore: $b06889f723b28786$var$P,
    useId: $b06889f723b28786$var$P,
    unstable_isNewReconciler: !1
}, $b06889f723b28786$var$Oh = {
    readContext: $b06889f723b28786$var$eh,
    useCallback: function(a, b) {
        $b06889f723b28786$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b06889f723b28786$var$eh,
    useEffect: $b06889f723b28786$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b06889f723b28786$var$ki(4194308, 4, $b06889f723b28786$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b06889f723b28786$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b06889f723b28786$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b06889f723b28786$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b06889f723b28786$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b06889f723b28786$var$xi.bind(null, $b06889f723b28786$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b06889f723b28786$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b06889f723b28786$var$hi,
    useDebugValue: $b06889f723b28786$var$ri,
    useDeferredValue: function(a) {
        return $b06889f723b28786$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b06889f723b28786$var$hi(!1), b = a[0];
        a = $b06889f723b28786$var$vi.bind(null, a[1]);
        $b06889f723b28786$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b06889f723b28786$var$M, e = $b06889f723b28786$var$Th();
        if ($b06889f723b28786$var$I) {
            if (void 0 === c) throw Error($b06889f723b28786$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b06889f723b28786$var$Q) throw Error($b06889f723b28786$var$p(349));
            0 !== ($b06889f723b28786$var$Hh & 30) || $b06889f723b28786$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b06889f723b28786$var$mi($b06889f723b28786$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b06889f723b28786$var$bi(9, $b06889f723b28786$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b06889f723b28786$var$Th(), b = $b06889f723b28786$var$Q.identifierPrefix;
        if ($b06889f723b28786$var$I) {
            var c = $b06889f723b28786$var$sg;
            var d = $b06889f723b28786$var$rg;
            c = (d & ~(1 << 32 - $b06889f723b28786$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b06889f723b28786$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b06889f723b28786$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b06889f723b28786$var$Ph = {
    readContext: $b06889f723b28786$var$eh,
    useCallback: $b06889f723b28786$var$si,
    useContext: $b06889f723b28786$var$eh,
    useEffect: $b06889f723b28786$var$$h,
    useImperativeHandle: $b06889f723b28786$var$qi,
    useInsertionEffect: $b06889f723b28786$var$ni,
    useLayoutEffect: $b06889f723b28786$var$oi,
    useMemo: $b06889f723b28786$var$ti,
    useReducer: $b06889f723b28786$var$Wh,
    useRef: $b06889f723b28786$var$ji,
    useState: function() {
        return $b06889f723b28786$var$Wh($b06889f723b28786$var$Vh);
    },
    useDebugValue: $b06889f723b28786$var$ri,
    useDeferredValue: function(a) {
        var b = $b06889f723b28786$var$Uh();
        return $b06889f723b28786$var$ui(b, $b06889f723b28786$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b06889f723b28786$var$Wh($b06889f723b28786$var$Vh)[0], b = $b06889f723b28786$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b06889f723b28786$var$Yh,
    useSyncExternalStore: $b06889f723b28786$var$Zh,
    useId: $b06889f723b28786$var$wi,
    unstable_isNewReconciler: !1
}, $b06889f723b28786$var$Qh = {
    readContext: $b06889f723b28786$var$eh,
    useCallback: $b06889f723b28786$var$si,
    useContext: $b06889f723b28786$var$eh,
    useEffect: $b06889f723b28786$var$$h,
    useImperativeHandle: $b06889f723b28786$var$qi,
    useInsertionEffect: $b06889f723b28786$var$ni,
    useLayoutEffect: $b06889f723b28786$var$oi,
    useMemo: $b06889f723b28786$var$ti,
    useReducer: $b06889f723b28786$var$Xh,
    useRef: $b06889f723b28786$var$ji,
    useState: function() {
        return $b06889f723b28786$var$Xh($b06889f723b28786$var$Vh);
    },
    useDebugValue: $b06889f723b28786$var$ri,
    useDeferredValue: function(a) {
        var b = $b06889f723b28786$var$Uh();
        return null === $b06889f723b28786$var$N ? b.memoizedState = a : $b06889f723b28786$var$ui(b, $b06889f723b28786$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b06889f723b28786$var$Xh($b06889f723b28786$var$Vh)[0], b = $b06889f723b28786$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b06889f723b28786$var$Yh,
    useSyncExternalStore: $b06889f723b28786$var$Zh,
    useId: $b06889f723b28786$var$wi,
    unstable_isNewReconciler: !1
};
function $b06889f723b28786$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b06889f723b28786$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b06889f723b28786$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b06889f723b28786$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b06889f723b28786$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b06889f723b28786$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b06889f723b28786$var$R(), e = $b06889f723b28786$var$yi(a), f = $b06889f723b28786$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b06889f723b28786$var$nh(a, f, e);
        null !== b && ($b06889f723b28786$var$gi(b, a, e, d), $b06889f723b28786$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b06889f723b28786$var$R(), e = $b06889f723b28786$var$yi(a), f = $b06889f723b28786$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b06889f723b28786$var$nh(a, f, e);
        null !== b && ($b06889f723b28786$var$gi(b, a, e, d), $b06889f723b28786$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b06889f723b28786$var$R(), d = $b06889f723b28786$var$yi(a), e = $b06889f723b28786$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b06889f723b28786$var$nh(a, e, d);
        null !== b && ($b06889f723b28786$var$gi(b, a, d, c), $b06889f723b28786$var$oh(b, a, d));
    }
};
function $b06889f723b28786$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b06889f723b28786$var$Ie(c, d) || !$b06889f723b28786$var$Ie(e, f) : !0;
}
function $b06889f723b28786$var$Gi(a, b, c) {
    var d = !1, e = $b06889f723b28786$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b06889f723b28786$var$eh(f) : (e = $b06889f723b28786$var$Zf(b) ? $b06889f723b28786$var$Xf : $b06889f723b28786$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b06889f723b28786$var$Yf(a, e) : $b06889f723b28786$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b06889f723b28786$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b06889f723b28786$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b06889f723b28786$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b06889f723b28786$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b06889f723b28786$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b06889f723b28786$var$eh(f) : (f = $b06889f723b28786$var$Zf(b) ? $b06889f723b28786$var$Xf : $b06889f723b28786$var$H.current, e.context = $b06889f723b28786$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b06889f723b28786$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b06889f723b28786$var$Ei.enqueueReplaceState(e, e.state, null), $b06889f723b28786$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b06889f723b28786$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b06889f723b28786$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b06889f723b28786$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b06889f723b28786$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b06889f723b28786$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b06889f723b28786$var$Ni(a, b, c) {
    c = $b06889f723b28786$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b06889f723b28786$var$Oi || ($b06889f723b28786$var$Oi = !0, $b06889f723b28786$var$Pi = d);
        $b06889f723b28786$var$Li(a, b);
    };
    return c;
}
function $b06889f723b28786$var$Qi(a, b, c) {
    c = $b06889f723b28786$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b06889f723b28786$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b06889f723b28786$var$Li(a, b);
        "function" !== typeof d && (null === $b06889f723b28786$var$Ri ? $b06889f723b28786$var$Ri = new Set([
            this
        ]) : $b06889f723b28786$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b06889f723b28786$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b06889f723b28786$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b06889f723b28786$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b06889f723b28786$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b06889f723b28786$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b06889f723b28786$var$mh(-1, 1), b.tag = 2, $b06889f723b28786$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b06889f723b28786$var$Wi = $b06889f723b28786$var$ua.ReactCurrentOwner, $b06889f723b28786$var$dh = !1;
function $b06889f723b28786$var$Xi(a, b, c, d) {
    b.child = null === a ? $b06889f723b28786$var$Vg(b, null, c, d) : $b06889f723b28786$var$Ug(b, a.child, c, d);
}
function $b06889f723b28786$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b06889f723b28786$var$ch(b, e);
    d = $b06889f723b28786$var$Nh(a, b, c, d, f, e);
    c = $b06889f723b28786$var$Sh();
    if (null !== a && !$b06889f723b28786$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b06889f723b28786$var$Zi(a, b, e);
    $b06889f723b28786$var$I && c && $b06889f723b28786$var$vg(b);
    b.flags |= 1;
    $b06889f723b28786$var$Xi(a, b, d, e);
    return b.child;
}
function $b06889f723b28786$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b06889f723b28786$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b06889f723b28786$var$bj(a, b, f, d, e);
        a = $b06889f723b28786$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b06889f723b28786$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b06889f723b28786$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b06889f723b28786$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b06889f723b28786$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b06889f723b28786$var$Ie(f, d) && a.ref === b.ref) {
            if ($b06889f723b28786$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b06889f723b28786$var$dh = !0);
            else return b.lanes = a.lanes, $b06889f723b28786$var$Zi(a, b, e);
        }
    }
    return $b06889f723b28786$var$cj(a, b, c, d, e);
}
function $b06889f723b28786$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b06889f723b28786$var$G($b06889f723b28786$var$ej, $b06889f723b28786$var$fj), $b06889f723b28786$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b06889f723b28786$var$G($b06889f723b28786$var$ej, $b06889f723b28786$var$fj), $b06889f723b28786$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b06889f723b28786$var$G($b06889f723b28786$var$ej, $b06889f723b28786$var$fj);
            $b06889f723b28786$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b06889f723b28786$var$G($b06889f723b28786$var$ej, $b06889f723b28786$var$fj), $b06889f723b28786$var$fj |= d;
    $b06889f723b28786$var$Xi(a, b, e, c);
    return b.child;
}
function $b06889f723b28786$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b06889f723b28786$var$cj(a, b, c, d, e) {
    var f = $b06889f723b28786$var$Zf(c) ? $b06889f723b28786$var$Xf : $b06889f723b28786$var$H.current;
    f = $b06889f723b28786$var$Yf(b, f);
    $b06889f723b28786$var$ch(b, e);
    c = $b06889f723b28786$var$Nh(a, b, c, d, f, e);
    d = $b06889f723b28786$var$Sh();
    if (null !== a && !$b06889f723b28786$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b06889f723b28786$var$Zi(a, b, e);
    $b06889f723b28786$var$I && d && $b06889f723b28786$var$vg(b);
    b.flags |= 1;
    $b06889f723b28786$var$Xi(a, b, c, e);
    return b.child;
}
function $b06889f723b28786$var$hj(a, b, c, d, e) {
    if ($b06889f723b28786$var$Zf(c)) {
        var f = !0;
        $b06889f723b28786$var$cg(b);
    } else f = !1;
    $b06889f723b28786$var$ch(b, e);
    if (null === b.stateNode) $b06889f723b28786$var$ij(a, b), $b06889f723b28786$var$Gi(b, c, d), $b06889f723b28786$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b06889f723b28786$var$eh(l) : (l = $b06889f723b28786$var$Zf(c) ? $b06889f723b28786$var$Xf : $b06889f723b28786$var$H.current, l = $b06889f723b28786$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b06889f723b28786$var$Hi(b, g, d, l);
        $b06889f723b28786$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b06889f723b28786$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b06889f723b28786$var$Wf.current || $b06889f723b28786$var$jh ? ("function" === typeof m && ($b06889f723b28786$var$Di(b, c, m, d), k = b.memoizedState), (h = $b06889f723b28786$var$jh || $b06889f723b28786$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b06889f723b28786$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b06889f723b28786$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b06889f723b28786$var$eh(k) : (k = $b06889f723b28786$var$Zf(c) ? $b06889f723b28786$var$Xf : $b06889f723b28786$var$H.current, k = $b06889f723b28786$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b06889f723b28786$var$Hi(b, g, d, k);
        $b06889f723b28786$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b06889f723b28786$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b06889f723b28786$var$Wf.current || $b06889f723b28786$var$jh ? ("function" === typeof y && ($b06889f723b28786$var$Di(b, c, y, d), n = b.memoizedState), (l = $b06889f723b28786$var$jh || $b06889f723b28786$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b06889f723b28786$var$jj(a, b, c, d, f, e);
}
function $b06889f723b28786$var$jj(a, b, c, d, e, f) {
    $b06889f723b28786$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b06889f723b28786$var$dg(b, c, !1), $b06889f723b28786$var$Zi(a, b, f);
    d = b.stateNode;
    $b06889f723b28786$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b06889f723b28786$var$Ug(b, a.child, null, f), b.child = $b06889f723b28786$var$Ug(b, null, h, f)) : $b06889f723b28786$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b06889f723b28786$var$dg(b, c, !0);
    return b.child;
}
function $b06889f723b28786$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b06889f723b28786$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b06889f723b28786$var$ag(a, b.context, !1);
    $b06889f723b28786$var$yh(a, b.containerInfo);
}
function $b06889f723b28786$var$lj(a, b, c, d, e) {
    $b06889f723b28786$var$Ig();
    $b06889f723b28786$var$Jg(e);
    b.flags |= 256;
    $b06889f723b28786$var$Xi(a, b, c, d);
    return b.child;
}
var $b06889f723b28786$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b06889f723b28786$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b06889f723b28786$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b06889f723b28786$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b06889f723b28786$var$G($b06889f723b28786$var$L, e & 1);
    if (null === a) {
        $b06889f723b28786$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b06889f723b28786$var$pj(g, d, 0, null), a = $b06889f723b28786$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b06889f723b28786$var$nj(c), b.memoizedState = $b06889f723b28786$var$mj, a) : $b06889f723b28786$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b06889f723b28786$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b06889f723b28786$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b06889f723b28786$var$Pg(h, f) : (f = $b06889f723b28786$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b06889f723b28786$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b06889f723b28786$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b06889f723b28786$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b06889f723b28786$var$qj(a, b) {
    b = $b06889f723b28786$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b06889f723b28786$var$sj(a, b, c, d) {
    null !== d && $b06889f723b28786$var$Jg(d);
    $b06889f723b28786$var$Ug(b, a.child, null, c);
    a = $b06889f723b28786$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b06889f723b28786$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b06889f723b28786$var$Ki(Error($b06889f723b28786$var$p(422))), $b06889f723b28786$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b06889f723b28786$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b06889f723b28786$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b06889f723b28786$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b06889f723b28786$var$nj(g);
        b.memoizedState = $b06889f723b28786$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b06889f723b28786$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b06889f723b28786$var$p(419));
        d = $b06889f723b28786$var$Ki(f, d, void 0);
        return $b06889f723b28786$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b06889f723b28786$var$dh || h) {
        d = $b06889f723b28786$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b06889f723b28786$var$ih(a, e), $b06889f723b28786$var$gi(d, a, e, -1));
        }
        $b06889f723b28786$var$tj();
        d = $b06889f723b28786$var$Ki(Error($b06889f723b28786$var$p(421)));
        return $b06889f723b28786$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b06889f723b28786$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b06889f723b28786$var$yg = $b06889f723b28786$var$Lf(e.nextSibling);
    $b06889f723b28786$var$xg = b;
    $b06889f723b28786$var$I = !0;
    $b06889f723b28786$var$zg = null;
    null !== a && ($b06889f723b28786$var$og[$b06889f723b28786$var$pg++] = $b06889f723b28786$var$rg, $b06889f723b28786$var$og[$b06889f723b28786$var$pg++] = $b06889f723b28786$var$sg, $b06889f723b28786$var$og[$b06889f723b28786$var$pg++] = $b06889f723b28786$var$qg, $b06889f723b28786$var$rg = a.id, $b06889f723b28786$var$sg = a.overflow, $b06889f723b28786$var$qg = b);
    b = $b06889f723b28786$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b06889f723b28786$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b06889f723b28786$var$bh(a.return, b, c);
}
function $b06889f723b28786$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b06889f723b28786$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b06889f723b28786$var$Xi(a, b, d.children, c);
    d = $b06889f723b28786$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b06889f723b28786$var$vj(a, c, b);
            else if (19 === a.tag) $b06889f723b28786$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b06889f723b28786$var$G($b06889f723b28786$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b06889f723b28786$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b06889f723b28786$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b06889f723b28786$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b06889f723b28786$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b06889f723b28786$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b06889f723b28786$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b06889f723b28786$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b06889f723b28786$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b06889f723b28786$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b06889f723b28786$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b06889f723b28786$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b06889f723b28786$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b06889f723b28786$var$kj(b);
            $b06889f723b28786$var$Ig();
            break;
        case 5:
            $b06889f723b28786$var$Ah(b);
            break;
        case 1:
            $b06889f723b28786$var$Zf(b.type) && $b06889f723b28786$var$cg(b);
            break;
        case 4:
            $b06889f723b28786$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b06889f723b28786$var$G($b06889f723b28786$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b06889f723b28786$var$G($b06889f723b28786$var$L, $b06889f723b28786$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b06889f723b28786$var$oj(a, b, c);
                $b06889f723b28786$var$G($b06889f723b28786$var$L, $b06889f723b28786$var$L.current & 1);
                a = $b06889f723b28786$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b06889f723b28786$var$G($b06889f723b28786$var$L, $b06889f723b28786$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b06889f723b28786$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b06889f723b28786$var$G($b06889f723b28786$var$L, $b06889f723b28786$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b06889f723b28786$var$dj(a, b, c);
    }
    return $b06889f723b28786$var$Zi(a, b, c);
}
var $b06889f723b28786$var$zj, $b06889f723b28786$var$Aj, $b06889f723b28786$var$Bj, $b06889f723b28786$var$Cj;
$b06889f723b28786$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b06889f723b28786$var$Aj = function() {};
$b06889f723b28786$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b06889f723b28786$var$xh($b06889f723b28786$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b06889f723b28786$var$Ya(a, e);
                d = $b06889f723b28786$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b06889f723b28786$var$A({}, e, {
                    value: void 0
                });
                d = $b06889f723b28786$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b06889f723b28786$var$gb(a, e);
                d = $b06889f723b28786$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b06889f723b28786$var$Bf);
        }
        $b06889f723b28786$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b06889f723b28786$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b06889f723b28786$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b06889f723b28786$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b06889f723b28786$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b06889f723b28786$var$Dj(a, b) {
    if (!$b06889f723b28786$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b06889f723b28786$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b06889f723b28786$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b06889f723b28786$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b06889f723b28786$var$S(b), null;
        case 1:
            return $b06889f723b28786$var$Zf(b.type) && $b06889f723b28786$var$$f(), $b06889f723b28786$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b06889f723b28786$var$zh();
            $b06889f723b28786$var$E($b06889f723b28786$var$Wf);
            $b06889f723b28786$var$E($b06889f723b28786$var$H);
            $b06889f723b28786$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b06889f723b28786$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b06889f723b28786$var$zg && ($b06889f723b28786$var$Fj($b06889f723b28786$var$zg), $b06889f723b28786$var$zg = null));
            $b06889f723b28786$var$Aj(a, b);
            $b06889f723b28786$var$S(b);
            return null;
        case 5:
            $b06889f723b28786$var$Bh(b);
            var e = $b06889f723b28786$var$xh($b06889f723b28786$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b06889f723b28786$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b06889f723b28786$var$p(166));
                    $b06889f723b28786$var$S(b);
                    return null;
                }
                a = $b06889f723b28786$var$xh($b06889f723b28786$var$uh.current);
                if ($b06889f723b28786$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b06889f723b28786$var$Of] = b;
                    d[$b06889f723b28786$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b06889f723b28786$var$D("cancel", d);
                            $b06889f723b28786$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b06889f723b28786$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b06889f723b28786$var$lf.length; e++)$b06889f723b28786$var$D($b06889f723b28786$var$lf[e], d);
                            break;
                        case "source":
                            $b06889f723b28786$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b06889f723b28786$var$D("error", d);
                            $b06889f723b28786$var$D("load", d);
                            break;
                        case "details":
                            $b06889f723b28786$var$D("toggle", d);
                            break;
                        case "input":
                            $b06889f723b28786$var$Za(d, f);
                            $b06889f723b28786$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b06889f723b28786$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b06889f723b28786$var$hb(d, f), $b06889f723b28786$var$D("invalid", d);
                    }
                    $b06889f723b28786$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b06889f723b28786$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b06889f723b28786$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b06889f723b28786$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b06889f723b28786$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b06889f723b28786$var$Va(d);
                            $b06889f723b28786$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b06889f723b28786$var$Va(d);
                            $b06889f723b28786$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b06889f723b28786$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b06889f723b28786$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b06889f723b28786$var$Of] = b;
                    a[$b06889f723b28786$var$Pf] = d;
                    $b06889f723b28786$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b06889f723b28786$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b06889f723b28786$var$D("cancel", a);
                                $b06889f723b28786$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b06889f723b28786$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b06889f723b28786$var$lf.length; e++)$b06889f723b28786$var$D($b06889f723b28786$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b06889f723b28786$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b06889f723b28786$var$D("error", a);
                                $b06889f723b28786$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b06889f723b28786$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b06889f723b28786$var$Za(a, d);
                                e = $b06889f723b28786$var$Ya(a, d);
                                $b06889f723b28786$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b06889f723b28786$var$A({}, d, {
                                    value: void 0
                                });
                                $b06889f723b28786$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b06889f723b28786$var$hb(a, d);
                                e = $b06889f723b28786$var$gb(a, d);
                                $b06889f723b28786$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b06889f723b28786$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b06889f723b28786$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b06889f723b28786$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b06889f723b28786$var$ob(a, k) : "number" === typeof k && $b06889f723b28786$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b06889f723b28786$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b06889f723b28786$var$D("scroll", a) : null != k && $b06889f723b28786$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b06889f723b28786$var$Va(a);
                                $b06889f723b28786$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b06889f723b28786$var$Va(a);
                                $b06889f723b28786$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b06889f723b28786$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b06889f723b28786$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b06889f723b28786$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b06889f723b28786$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b06889f723b28786$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b06889f723b28786$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b06889f723b28786$var$p(166));
                c = $b06889f723b28786$var$xh($b06889f723b28786$var$wh.current);
                $b06889f723b28786$var$xh($b06889f723b28786$var$uh.current);
                if ($b06889f723b28786$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b06889f723b28786$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b06889f723b28786$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b06889f723b28786$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b06889f723b28786$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b06889f723b28786$var$Of] = b, b.stateNode = d;
            }
            $b06889f723b28786$var$S(b);
            return null;
        case 13:
            $b06889f723b28786$var$E($b06889f723b28786$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b06889f723b28786$var$I && null !== $b06889f723b28786$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b06889f723b28786$var$Hg(), $b06889f723b28786$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b06889f723b28786$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b06889f723b28786$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b06889f723b28786$var$p(317));
                        f[$b06889f723b28786$var$Of] = b;
                    } else $b06889f723b28786$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b06889f723b28786$var$S(b);
                    f = !1;
                } else null !== $b06889f723b28786$var$zg && ($b06889f723b28786$var$Fj($b06889f723b28786$var$zg), $b06889f723b28786$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b06889f723b28786$var$L.current & 1) ? 0 === $b06889f723b28786$var$T && ($b06889f723b28786$var$T = 3) : $b06889f723b28786$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b06889f723b28786$var$S(b);
            return null;
        case 4:
            return $b06889f723b28786$var$zh(), $b06889f723b28786$var$Aj(a, b), null === a && $b06889f723b28786$var$sf(b.stateNode.containerInfo), $b06889f723b28786$var$S(b), null;
        case 10:
            return $b06889f723b28786$var$ah(b.type._context), $b06889f723b28786$var$S(b), null;
        case 17:
            return $b06889f723b28786$var$Zf(b.type) && $b06889f723b28786$var$$f(), $b06889f723b28786$var$S(b), null;
        case 19:
            $b06889f723b28786$var$E($b06889f723b28786$var$L);
            f = b.memoizedState;
            if (null === f) return $b06889f723b28786$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b06889f723b28786$var$Dj(f, !1);
                else {
                    if (0 !== $b06889f723b28786$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b06889f723b28786$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b06889f723b28786$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b06889f723b28786$var$G($b06889f723b28786$var$L, $b06889f723b28786$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b06889f723b28786$var$B() > $b06889f723b28786$var$Gj && (b.flags |= 128, d = !0, $b06889f723b28786$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b06889f723b28786$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b06889f723b28786$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b06889f723b28786$var$I) return $b06889f723b28786$var$S(b), null;
                    } else 2 * $b06889f723b28786$var$B() - f.renderingStartTime > $b06889f723b28786$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b06889f723b28786$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b06889f723b28786$var$B(), b.sibling = null, c = $b06889f723b28786$var$L.current, $b06889f723b28786$var$G($b06889f723b28786$var$L, d ? c & 1 | 2 : c & 1), b;
            $b06889f723b28786$var$S(b);
            return null;
        case 22:
        case 23:
            return $b06889f723b28786$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b06889f723b28786$var$fj & 1073741824) && ($b06889f723b28786$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b06889f723b28786$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b06889f723b28786$var$p(156, b.tag));
}
function $b06889f723b28786$var$Ij(a, b) {
    $b06889f723b28786$var$wg(b);
    switch(b.tag){
        case 1:
            return $b06889f723b28786$var$Zf(b.type) && $b06889f723b28786$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b06889f723b28786$var$zh(), $b06889f723b28786$var$E($b06889f723b28786$var$Wf), $b06889f723b28786$var$E($b06889f723b28786$var$H), $b06889f723b28786$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b06889f723b28786$var$Bh(b), null;
        case 13:
            $b06889f723b28786$var$E($b06889f723b28786$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b06889f723b28786$var$p(340));
                $b06889f723b28786$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b06889f723b28786$var$E($b06889f723b28786$var$L), null;
        case 4:
            return $b06889f723b28786$var$zh(), null;
        case 10:
            return $b06889f723b28786$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b06889f723b28786$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b06889f723b28786$var$Jj = !1, $b06889f723b28786$var$U = !1, $b06889f723b28786$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b06889f723b28786$var$V = null;
function $b06889f723b28786$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b06889f723b28786$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b06889f723b28786$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b06889f723b28786$var$W(a, b, d);
    }
}
var $b06889f723b28786$var$Nj = !1;
function $b06889f723b28786$var$Oj(a, b) {
    $b06889f723b28786$var$Cf = $b06889f723b28786$var$dd;
    a = $b06889f723b28786$var$Me();
    if ($b06889f723b28786$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b06889f723b28786$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b06889f723b28786$var$dd = !1;
    for($b06889f723b28786$var$V = b; null !== $b06889f723b28786$var$V;)if (b = $b06889f723b28786$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b06889f723b28786$var$V = a;
    else for(; null !== $b06889f723b28786$var$V;){
        b = $b06889f723b28786$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b06889f723b28786$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b06889f723b28786$var$p(163));
            }
        } catch (F) {
            $b06889f723b28786$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b06889f723b28786$var$V = a;
            break;
        }
        $b06889f723b28786$var$V = b.return;
    }
    n = $b06889f723b28786$var$Nj;
    $b06889f723b28786$var$Nj = !1;
    return n;
}
function $b06889f723b28786$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b06889f723b28786$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b06889f723b28786$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b06889f723b28786$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b06889f723b28786$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b06889f723b28786$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b06889f723b28786$var$Of], delete b[$b06889f723b28786$var$Pf], delete b[$b06889f723b28786$var$of], delete b[$b06889f723b28786$var$Qf], delete b[$b06889f723b28786$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b06889f723b28786$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b06889f723b28786$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b06889f723b28786$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b06889f723b28786$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b06889f723b28786$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b06889f723b28786$var$Vj(a, b, c), a = a.sibling; null !== a;)$b06889f723b28786$var$Vj(a, b, c), a = a.sibling;
}
function $b06889f723b28786$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b06889f723b28786$var$Wj(a, b, c), a = a.sibling; null !== a;)$b06889f723b28786$var$Wj(a, b, c), a = a.sibling;
}
var $b06889f723b28786$var$X = null, $b06889f723b28786$var$Xj = !1;
function $b06889f723b28786$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b06889f723b28786$var$Zj(a, b, c), c = c.sibling;
}
function $b06889f723b28786$var$Zj(a, b, c) {
    if ($b06889f723b28786$var$lc && "function" === typeof $b06889f723b28786$var$lc.onCommitFiberUnmount) try {
        $b06889f723b28786$var$lc.onCommitFiberUnmount($b06889f723b28786$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b06889f723b28786$var$U || $b06889f723b28786$var$Lj(c, b);
        case 6:
            var d = $b06889f723b28786$var$X, e = $b06889f723b28786$var$Xj;
            $b06889f723b28786$var$X = null;
            $b06889f723b28786$var$Yj(a, b, c);
            $b06889f723b28786$var$X = d;
            $b06889f723b28786$var$Xj = e;
            null !== $b06889f723b28786$var$X && ($b06889f723b28786$var$Xj ? (a = $b06889f723b28786$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b06889f723b28786$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b06889f723b28786$var$X && ($b06889f723b28786$var$Xj ? (a = $b06889f723b28786$var$X, c = c.stateNode, 8 === a.nodeType ? $b06889f723b28786$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b06889f723b28786$var$Kf(a, c), $b06889f723b28786$var$bd(a)) : $b06889f723b28786$var$Kf($b06889f723b28786$var$X, c.stateNode));
            break;
        case 4:
            d = $b06889f723b28786$var$X;
            e = $b06889f723b28786$var$Xj;
            $b06889f723b28786$var$X = c.stateNode.containerInfo;
            $b06889f723b28786$var$Xj = !0;
            $b06889f723b28786$var$Yj(a, b, c);
            $b06889f723b28786$var$X = d;
            $b06889f723b28786$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b06889f723b28786$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b06889f723b28786$var$Mj(c, b, g) : 0 !== (f & 4) && $b06889f723b28786$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b06889f723b28786$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b06889f723b28786$var$U && ($b06889f723b28786$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b06889f723b28786$var$W(c, b, h);
            }
            $b06889f723b28786$var$Yj(a, b, c);
            break;
        case 21:
            $b06889f723b28786$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b06889f723b28786$var$U = (d = $b06889f723b28786$var$U) || null !== c.memoizedState, $b06889f723b28786$var$Yj(a, b, c), $b06889f723b28786$var$U = d) : $b06889f723b28786$var$Yj(a, b, c);
            break;
        default:
            $b06889f723b28786$var$Yj(a, b, c);
    }
}
function $b06889f723b28786$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b06889f723b28786$var$Kj);
        b.forEach(function(b) {
            var d = $b06889f723b28786$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b06889f723b28786$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b06889f723b28786$var$X = h.stateNode;
                        $b06889f723b28786$var$Xj = !1;
                        break a;
                    case 3:
                        $b06889f723b28786$var$X = h.stateNode.containerInfo;
                        $b06889f723b28786$var$Xj = !0;
                        break a;
                    case 4:
                        $b06889f723b28786$var$X = h.stateNode.containerInfo;
                        $b06889f723b28786$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b06889f723b28786$var$X) throw Error($b06889f723b28786$var$p(160));
            $b06889f723b28786$var$Zj(f, g, e);
            $b06889f723b28786$var$X = null;
            $b06889f723b28786$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b06889f723b28786$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b06889f723b28786$var$dk(b, a), b = b.sibling;
}
function $b06889f723b28786$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            if (d & 4) {
                try {
                    $b06889f723b28786$var$Pj(3, a, a.return), $b06889f723b28786$var$Qj(3, a);
                } catch (t) {
                    $b06889f723b28786$var$W(a, a.return, t);
                }
                try {
                    $b06889f723b28786$var$Pj(5, a, a.return);
                } catch (t) {
                    $b06889f723b28786$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            d & 512 && null !== c && $b06889f723b28786$var$Lj(c, c.return);
            break;
        case 5:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            d & 512 && null !== c && $b06889f723b28786$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b06889f723b28786$var$ob(e, "");
                } catch (t) {
                    $b06889f723b28786$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b06889f723b28786$var$ab(e, f);
                    $b06889f723b28786$var$vb(h, g);
                    var l = $b06889f723b28786$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b06889f723b28786$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b06889f723b28786$var$nb(e, q) : "children" === m ? $b06889f723b28786$var$ob(e, q) : $b06889f723b28786$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b06889f723b28786$var$bb(e, f);
                            break;
                        case "textarea":
                            $b06889f723b28786$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b06889f723b28786$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b06889f723b28786$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b06889f723b28786$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b06889f723b28786$var$Pf] = f;
                } catch (t) {
                    $b06889f723b28786$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b06889f723b28786$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b06889f723b28786$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b06889f723b28786$var$bd(b.containerInfo);
            } catch (t) {
                $b06889f723b28786$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            break;
        case 13:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b06889f723b28786$var$fk = $b06889f723b28786$var$B()));
            d & 4 && $b06889f723b28786$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b06889f723b28786$var$U = (l = $b06889f723b28786$var$U) || m, $b06889f723b28786$var$ck(b, a), $b06889f723b28786$var$U = l) : $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b06889f723b28786$var$V = a, m = a.child; null !== m;){
                    for(q = $b06889f723b28786$var$V = m; null !== $b06889f723b28786$var$V;){
                        r = $b06889f723b28786$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b06889f723b28786$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b06889f723b28786$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b06889f723b28786$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b06889f723b28786$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b06889f723b28786$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b06889f723b28786$var$V = y) : $b06889f723b28786$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b06889f723b28786$var$rb("display", g));
                            } catch (t) {
                                $b06889f723b28786$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b06889f723b28786$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b06889f723b28786$var$ck(b, a);
            $b06889f723b28786$var$ek(a);
            d & 4 && $b06889f723b28786$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b06889f723b28786$var$ck(b, a), $b06889f723b28786$var$ek(a);
    }
}
function $b06889f723b28786$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b06889f723b28786$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b06889f723b28786$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b06889f723b28786$var$ob(e, ""), d.flags &= -33);
                    var f = $b06889f723b28786$var$Uj(a);
                    $b06889f723b28786$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b06889f723b28786$var$Uj(a);
                    $b06889f723b28786$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b06889f723b28786$var$p(161));
            }
        } catch (k) {
            $b06889f723b28786$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b06889f723b28786$var$hk(a, b, c) {
    $b06889f723b28786$var$V = a;
    $b06889f723b28786$var$ik(a, b, c);
}
function $b06889f723b28786$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b06889f723b28786$var$V;){
        var e = $b06889f723b28786$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b06889f723b28786$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b06889f723b28786$var$U;
                h = $b06889f723b28786$var$Jj;
                var l = $b06889f723b28786$var$U;
                $b06889f723b28786$var$Jj = g;
                if (($b06889f723b28786$var$U = k) && !l) for($b06889f723b28786$var$V = e; null !== $b06889f723b28786$var$V;)g = $b06889f723b28786$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b06889f723b28786$var$jk(e) : null !== k ? (k.return = g, $b06889f723b28786$var$V = k) : $b06889f723b28786$var$jk(e);
                for(; null !== f;)$b06889f723b28786$var$V = f, $b06889f723b28786$var$ik(f, b, c), f = f.sibling;
                $b06889f723b28786$var$V = e;
                $b06889f723b28786$var$Jj = h;
                $b06889f723b28786$var$U = l;
            }
            $b06889f723b28786$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b06889f723b28786$var$V = f) : $b06889f723b28786$var$kk(a, b, c);
    }
}
function $b06889f723b28786$var$kk(a) {
    for(; null !== $b06889f723b28786$var$V;){
        var b = $b06889f723b28786$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b06889f723b28786$var$U || $b06889f723b28786$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b06889f723b28786$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b06889f723b28786$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b06889f723b28786$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b06889f723b28786$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b06889f723b28786$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b06889f723b28786$var$p(163));
                }
                $b06889f723b28786$var$U || b.flags & 512 && $b06889f723b28786$var$Rj(b);
            } catch (r) {
                $b06889f723b28786$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b06889f723b28786$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b06889f723b28786$var$V = c;
            break;
        }
        $b06889f723b28786$var$V = b.return;
    }
}
function $b06889f723b28786$var$gk(a) {
    for(; null !== $b06889f723b28786$var$V;){
        var b = $b06889f723b28786$var$V;
        if (b === a) {
            $b06889f723b28786$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b06889f723b28786$var$V = c;
            break;
        }
        $b06889f723b28786$var$V = b.return;
    }
}
function $b06889f723b28786$var$jk(a) {
    for(; null !== $b06889f723b28786$var$V;){
        var b = $b06889f723b28786$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b06889f723b28786$var$Qj(4, b);
                    } catch (k) {
                        $b06889f723b28786$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b06889f723b28786$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b06889f723b28786$var$Rj(b);
                    } catch (k) {
                        $b06889f723b28786$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b06889f723b28786$var$Rj(b);
                    } catch (k) {
                        $b06889f723b28786$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b06889f723b28786$var$W(b, b.return, k);
        }
        if (b === a) {
            $b06889f723b28786$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b06889f723b28786$var$V = h;
            break;
        }
        $b06889f723b28786$var$V = b.return;
    }
}
var $b06889f723b28786$var$lk = Math.ceil, $b06889f723b28786$var$mk = $b06889f723b28786$var$ua.ReactCurrentDispatcher, $b06889f723b28786$var$nk = $b06889f723b28786$var$ua.ReactCurrentOwner, $b06889f723b28786$var$ok = $b06889f723b28786$var$ua.ReactCurrentBatchConfig, $b06889f723b28786$var$K = 0, $b06889f723b28786$var$Q = null, $b06889f723b28786$var$Y = null, $b06889f723b28786$var$Z = 0, $b06889f723b28786$var$fj = 0, $b06889f723b28786$var$ej = $b06889f723b28786$var$Uf(0), $b06889f723b28786$var$T = 0, $b06889f723b28786$var$pk = null, $b06889f723b28786$var$rh = 0, $b06889f723b28786$var$qk = 0, $b06889f723b28786$var$rk = 0, $b06889f723b28786$var$sk = null, $b06889f723b28786$var$tk = null, $b06889f723b28786$var$fk = 0, $b06889f723b28786$var$Gj = Infinity, $b06889f723b28786$var$uk = null, $b06889f723b28786$var$Oi = !1, $b06889f723b28786$var$Pi = null, $b06889f723b28786$var$Ri = null, $b06889f723b28786$var$vk = !1, $b06889f723b28786$var$wk = null, $b06889f723b28786$var$xk = 0, $b06889f723b28786$var$yk = 0, $b06889f723b28786$var$zk = null, $b06889f723b28786$var$Ak = -1, $b06889f723b28786$var$Bk = 0;
function $b06889f723b28786$var$R() {
    return 0 !== ($b06889f723b28786$var$K & 6) ? $b06889f723b28786$var$B() : -1 !== $b06889f723b28786$var$Ak ? $b06889f723b28786$var$Ak : $b06889f723b28786$var$Ak = $b06889f723b28786$var$B();
}
function $b06889f723b28786$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b06889f723b28786$var$K & 2) && 0 !== $b06889f723b28786$var$Z) return $b06889f723b28786$var$Z & -$b06889f723b28786$var$Z;
    if (null !== $b06889f723b28786$var$Kg.transition) return 0 === $b06889f723b28786$var$Bk && ($b06889f723b28786$var$Bk = $b06889f723b28786$var$yc()), $b06889f723b28786$var$Bk;
    a = $b06889f723b28786$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b06889f723b28786$var$jd(a.type);
    return a;
}
function $b06889f723b28786$var$gi(a, b, c, d) {
    if (50 < $b06889f723b28786$var$yk) throw $b06889f723b28786$var$yk = 0, $b06889f723b28786$var$zk = null, Error($b06889f723b28786$var$p(185));
    $b06889f723b28786$var$Ac(a, c, d);
    if (0 === ($b06889f723b28786$var$K & 2) || a !== $b06889f723b28786$var$Q) a === $b06889f723b28786$var$Q && (0 === ($b06889f723b28786$var$K & 2) && ($b06889f723b28786$var$qk |= c), 4 === $b06889f723b28786$var$T && $b06889f723b28786$var$Ck(a, $b06889f723b28786$var$Z)), $b06889f723b28786$var$Dk(a, d), 1 === c && 0 === $b06889f723b28786$var$K && 0 === (b.mode & 1) && ($b06889f723b28786$var$Gj = $b06889f723b28786$var$B() + 500, $b06889f723b28786$var$fg && $b06889f723b28786$var$jg());
}
function $b06889f723b28786$var$Dk(a, b) {
    var c = a.callbackNode;
    $b06889f723b28786$var$wc(a, b);
    var d = $b06889f723b28786$var$uc(a, a === $b06889f723b28786$var$Q ? $b06889f723b28786$var$Z : 0);
    if (0 === d) null !== c && $b06889f723b28786$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b06889f723b28786$var$bc(c);
        if (1 === b) 0 === a.tag ? $b06889f723b28786$var$ig($b06889f723b28786$var$Ek.bind(null, a)) : $b06889f723b28786$var$hg($b06889f723b28786$var$Ek.bind(null, a)), $b06889f723b28786$var$Jf(function() {
            0 === ($b06889f723b28786$var$K & 6) && $b06889f723b28786$var$jg();
        }), c = null;
        else {
            switch($b06889f723b28786$var$Dc(d)){
                case 1:
                    c = $b06889f723b28786$var$fc;
                    break;
                case 4:
                    c = $b06889f723b28786$var$gc;
                    break;
                case 16:
                    c = $b06889f723b28786$var$hc;
                    break;
                case 536870912:
                    c = $b06889f723b28786$var$jc;
                    break;
                default:
                    c = $b06889f723b28786$var$hc;
            }
            c = $b06889f723b28786$var$Fk(c, $b06889f723b28786$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b06889f723b28786$var$Gk(a, b) {
    $b06889f723b28786$var$Ak = -1;
    $b06889f723b28786$var$Bk = 0;
    if (0 !== ($b06889f723b28786$var$K & 6)) throw Error($b06889f723b28786$var$p(327));
    var c = a.callbackNode;
    if ($b06889f723b28786$var$Hk() && a.callbackNode !== c) return null;
    var d = $b06889f723b28786$var$uc(a, a === $b06889f723b28786$var$Q ? $b06889f723b28786$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b06889f723b28786$var$Ik(a, d);
    else {
        b = d;
        var e = $b06889f723b28786$var$K;
        $b06889f723b28786$var$K |= 2;
        var f = $b06889f723b28786$var$Jk();
        if ($b06889f723b28786$var$Q !== a || $b06889f723b28786$var$Z !== b) $b06889f723b28786$var$uk = null, $b06889f723b28786$var$Gj = $b06889f723b28786$var$B() + 500, $b06889f723b28786$var$Kk(a, b);
        for(;;)try {
            $b06889f723b28786$var$Lk();
            break;
        } catch (h) {
            $b06889f723b28786$var$Mk(a, h);
        }
        $b06889f723b28786$var$$g();
        $b06889f723b28786$var$mk.current = f;
        $b06889f723b28786$var$K = e;
        null !== $b06889f723b28786$var$Y ? b = 0 : ($b06889f723b28786$var$Q = null, $b06889f723b28786$var$Z = 0, b = $b06889f723b28786$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b06889f723b28786$var$xc(a), 0 !== e && (d = e, b = $b06889f723b28786$var$Nk(a, e)));
        if (1 === b) throw c = $b06889f723b28786$var$pk, $b06889f723b28786$var$Kk(a, 0), $b06889f723b28786$var$Ck(a, d), $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B()), c;
        if (6 === b) $b06889f723b28786$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b06889f723b28786$var$Ok(e) && (b = $b06889f723b28786$var$Ik(a, d), 2 === b && (f = $b06889f723b28786$var$xc(a), 0 !== f && (d = f, b = $b06889f723b28786$var$Nk(a, f))), 1 === b)) throw c = $b06889f723b28786$var$pk, $b06889f723b28786$var$Kk(a, 0), $b06889f723b28786$var$Ck(a, d), $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b06889f723b28786$var$p(345));
                case 2:
                    $b06889f723b28786$var$Pk(a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk);
                    break;
                case 3:
                    $b06889f723b28786$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b06889f723b28786$var$fk + 500 - $b06889f723b28786$var$B(), 10 < b)) {
                        if (0 !== $b06889f723b28786$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b06889f723b28786$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b06889f723b28786$var$Ff($b06889f723b28786$var$Pk.bind(null, a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk), b);
                        break;
                    }
                    $b06889f723b28786$var$Pk(a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk);
                    break;
                case 4:
                    $b06889f723b28786$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b06889f723b28786$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b06889f723b28786$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b06889f723b28786$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b06889f723b28786$var$Ff($b06889f723b28786$var$Pk.bind(null, a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk), d);
                        break;
                    }
                    $b06889f723b28786$var$Pk(a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk);
                    break;
                case 5:
                    $b06889f723b28786$var$Pk(a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk);
                    break;
                default:
                    throw Error($b06889f723b28786$var$p(329));
            }
        }
    }
    $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B());
    return a.callbackNode === c ? $b06889f723b28786$var$Gk.bind(null, a) : null;
}
function $b06889f723b28786$var$Nk(a, b) {
    var c = $b06889f723b28786$var$sk;
    a.current.memoizedState.isDehydrated && ($b06889f723b28786$var$Kk(a, b).flags |= 256);
    a = $b06889f723b28786$var$Ik(a, b);
    2 !== a && (b = $b06889f723b28786$var$tk, $b06889f723b28786$var$tk = c, null !== b && $b06889f723b28786$var$Fj(b));
    return a;
}
function $b06889f723b28786$var$Fj(a) {
    null === $b06889f723b28786$var$tk ? $b06889f723b28786$var$tk = a : $b06889f723b28786$var$tk.push.apply($b06889f723b28786$var$tk, a);
}
function $b06889f723b28786$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b06889f723b28786$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b06889f723b28786$var$Ck(a, b) {
    b &= ~$b06889f723b28786$var$rk;
    b &= ~$b06889f723b28786$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b06889f723b28786$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b06889f723b28786$var$Ek(a) {
    if (0 !== ($b06889f723b28786$var$K & 6)) throw Error($b06889f723b28786$var$p(327));
    $b06889f723b28786$var$Hk();
    var b = $b06889f723b28786$var$uc(a, 0);
    if (0 === (b & 1)) return $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B()), null;
    var c = $b06889f723b28786$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b06889f723b28786$var$xc(a);
        0 !== d && (b = d, c = $b06889f723b28786$var$Nk(a, d));
    }
    if (1 === c) throw c = $b06889f723b28786$var$pk, $b06889f723b28786$var$Kk(a, 0), $b06889f723b28786$var$Ck(a, b), $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B()), c;
    if (6 === c) throw Error($b06889f723b28786$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b06889f723b28786$var$Pk(a, $b06889f723b28786$var$tk, $b06889f723b28786$var$uk);
    $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B());
    return null;
}
function $b06889f723b28786$var$Qk(a, b) {
    var c = $b06889f723b28786$var$K;
    $b06889f723b28786$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b06889f723b28786$var$K = c, 0 === $b06889f723b28786$var$K && ($b06889f723b28786$var$Gj = $b06889f723b28786$var$B() + 500, $b06889f723b28786$var$fg && $b06889f723b28786$var$jg());
    }
}
function $b06889f723b28786$var$Rk(a) {
    null !== $b06889f723b28786$var$wk && 0 === $b06889f723b28786$var$wk.tag && 0 === ($b06889f723b28786$var$K & 6) && $b06889f723b28786$var$Hk();
    var b = $b06889f723b28786$var$K;
    $b06889f723b28786$var$K |= 1;
    var c = $b06889f723b28786$var$ok.transition, d = $b06889f723b28786$var$C;
    try {
        if ($b06889f723b28786$var$ok.transition = null, $b06889f723b28786$var$C = 1, a) return a();
    } finally{
        $b06889f723b28786$var$C = d, $b06889f723b28786$var$ok.transition = c, $b06889f723b28786$var$K = b, 0 === ($b06889f723b28786$var$K & 6) && $b06889f723b28786$var$jg();
    }
}
function $b06889f723b28786$var$Hj() {
    $b06889f723b28786$var$fj = $b06889f723b28786$var$ej.current;
    $b06889f723b28786$var$E($b06889f723b28786$var$ej);
}
function $b06889f723b28786$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b06889f723b28786$var$Gf(c));
    if (null !== $b06889f723b28786$var$Y) for(c = $b06889f723b28786$var$Y.return; null !== c;){
        var d = c;
        $b06889f723b28786$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b06889f723b28786$var$$f();
                break;
            case 3:
                $b06889f723b28786$var$zh();
                $b06889f723b28786$var$E($b06889f723b28786$var$Wf);
                $b06889f723b28786$var$E($b06889f723b28786$var$H);
                $b06889f723b28786$var$Eh();
                break;
            case 5:
                $b06889f723b28786$var$Bh(d);
                break;
            case 4:
                $b06889f723b28786$var$zh();
                break;
            case 13:
                $b06889f723b28786$var$E($b06889f723b28786$var$L);
                break;
            case 19:
                $b06889f723b28786$var$E($b06889f723b28786$var$L);
                break;
            case 10:
                $b06889f723b28786$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b06889f723b28786$var$Hj();
        }
        c = c.return;
    }
    $b06889f723b28786$var$Q = a;
    $b06889f723b28786$var$Y = a = $b06889f723b28786$var$Pg(a.current, null);
    $b06889f723b28786$var$Z = $b06889f723b28786$var$fj = b;
    $b06889f723b28786$var$T = 0;
    $b06889f723b28786$var$pk = null;
    $b06889f723b28786$var$rk = $b06889f723b28786$var$qk = $b06889f723b28786$var$rh = 0;
    $b06889f723b28786$var$tk = $b06889f723b28786$var$sk = null;
    if (null !== $b06889f723b28786$var$fh) {
        for(b = 0; b < $b06889f723b28786$var$fh.length; b++)if (c = $b06889f723b28786$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b06889f723b28786$var$fh = null;
    }
    return a;
}
function $b06889f723b28786$var$Mk(a, b) {
    do {
        var c = $b06889f723b28786$var$Y;
        try {
            $b06889f723b28786$var$$g();
            $b06889f723b28786$var$Fh.current = $b06889f723b28786$var$Rh;
            if ($b06889f723b28786$var$Ih) {
                for(var d = $b06889f723b28786$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b06889f723b28786$var$Ih = !1;
            }
            $b06889f723b28786$var$Hh = 0;
            $b06889f723b28786$var$O = $b06889f723b28786$var$N = $b06889f723b28786$var$M = null;
            $b06889f723b28786$var$Jh = !1;
            $b06889f723b28786$var$Kh = 0;
            $b06889f723b28786$var$nk.current = null;
            if (null === c || null === c.return) {
                $b06889f723b28786$var$T = 1;
                $b06889f723b28786$var$pk = b;
                $b06889f723b28786$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b06889f723b28786$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b06889f723b28786$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b06889f723b28786$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b06889f723b28786$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b06889f723b28786$var$Si(f, l, b);
                            $b06889f723b28786$var$tj();
                            break a;
                        }
                        k = Error($b06889f723b28786$var$p(426));
                    }
                } else if ($b06889f723b28786$var$I && h.mode & 1) {
                    var J = $b06889f723b28786$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b06889f723b28786$var$Vi(J, g, h, f, b);
                        $b06889f723b28786$var$Jg($b06889f723b28786$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b06889f723b28786$var$Ji(k, h);
                4 !== $b06889f723b28786$var$T && ($b06889f723b28786$var$T = 2);
                null === $b06889f723b28786$var$sk ? $b06889f723b28786$var$sk = [
                    f
                ] : $b06889f723b28786$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b06889f723b28786$var$Ni(f, k, b);
                            $b06889f723b28786$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b06889f723b28786$var$Ri || !$b06889f723b28786$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b06889f723b28786$var$Qi(f, h, b);
                                $b06889f723b28786$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b06889f723b28786$var$Sk(c);
        } catch (na) {
            b = na;
            $b06889f723b28786$var$Y === c && null !== c && ($b06889f723b28786$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b06889f723b28786$var$Jk() {
    var a = $b06889f723b28786$var$mk.current;
    $b06889f723b28786$var$mk.current = $b06889f723b28786$var$Rh;
    return null === a ? $b06889f723b28786$var$Rh : a;
}
function $b06889f723b28786$var$tj() {
    if (0 === $b06889f723b28786$var$T || 3 === $b06889f723b28786$var$T || 2 === $b06889f723b28786$var$T) $b06889f723b28786$var$T = 4;
    null === $b06889f723b28786$var$Q || 0 === ($b06889f723b28786$var$rh & 268435455) && 0 === ($b06889f723b28786$var$qk & 268435455) || $b06889f723b28786$var$Ck($b06889f723b28786$var$Q, $b06889f723b28786$var$Z);
}
function $b06889f723b28786$var$Ik(a, b) {
    var c = $b06889f723b28786$var$K;
    $b06889f723b28786$var$K |= 2;
    var d = $b06889f723b28786$var$Jk();
    if ($b06889f723b28786$var$Q !== a || $b06889f723b28786$var$Z !== b) $b06889f723b28786$var$uk = null, $b06889f723b28786$var$Kk(a, b);
    for(;;)try {
        $b06889f723b28786$var$Tk();
        break;
    } catch (e) {
        $b06889f723b28786$var$Mk(a, e);
    }
    $b06889f723b28786$var$$g();
    $b06889f723b28786$var$K = c;
    $b06889f723b28786$var$mk.current = d;
    if (null !== $b06889f723b28786$var$Y) throw Error($b06889f723b28786$var$p(261));
    $b06889f723b28786$var$Q = null;
    $b06889f723b28786$var$Z = 0;
    return $b06889f723b28786$var$T;
}
function $b06889f723b28786$var$Tk() {
    for(; null !== $b06889f723b28786$var$Y;)$b06889f723b28786$var$Uk($b06889f723b28786$var$Y);
}
function $b06889f723b28786$var$Lk() {
    for(; null !== $b06889f723b28786$var$Y && !$b06889f723b28786$var$cc();)$b06889f723b28786$var$Uk($b06889f723b28786$var$Y);
}
function $b06889f723b28786$var$Uk(a) {
    var b = $b06889f723b28786$var$Vk(a.alternate, a, $b06889f723b28786$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b06889f723b28786$var$Sk(a) : $b06889f723b28786$var$Y = b;
    $b06889f723b28786$var$nk.current = null;
}
function $b06889f723b28786$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b06889f723b28786$var$Ej(c, b, $b06889f723b28786$var$fj), null !== c) {
                $b06889f723b28786$var$Y = c;
                return;
            }
        } else {
            c = $b06889f723b28786$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b06889f723b28786$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b06889f723b28786$var$T = 6;
                $b06889f723b28786$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b06889f723b28786$var$Y = b;
            return;
        }
        $b06889f723b28786$var$Y = b = a;
    }while (null !== b);
    0 === $b06889f723b28786$var$T && ($b06889f723b28786$var$T = 5);
}
function $b06889f723b28786$var$Pk(a, b, c) {
    var d = $b06889f723b28786$var$C, e = $b06889f723b28786$var$ok.transition;
    try {
        $b06889f723b28786$var$ok.transition = null, $b06889f723b28786$var$C = 1, $b06889f723b28786$var$Wk(a, b, c, d);
    } finally{
        $b06889f723b28786$var$ok.transition = e, $b06889f723b28786$var$C = d;
    }
    return null;
}
function $b06889f723b28786$var$Wk(a, b, c, d) {
    do $b06889f723b28786$var$Hk();
    while (null !== $b06889f723b28786$var$wk);
    if (0 !== ($b06889f723b28786$var$K & 6)) throw Error($b06889f723b28786$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b06889f723b28786$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b06889f723b28786$var$Bc(a, f);
    a === $b06889f723b28786$var$Q && ($b06889f723b28786$var$Y = $b06889f723b28786$var$Q = null, $b06889f723b28786$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b06889f723b28786$var$vk || ($b06889f723b28786$var$vk = !0, $b06889f723b28786$var$Fk($b06889f723b28786$var$hc, function() {
        $b06889f723b28786$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b06889f723b28786$var$ok.transition;
        $b06889f723b28786$var$ok.transition = null;
        var g = $b06889f723b28786$var$C;
        $b06889f723b28786$var$C = 1;
        var h = $b06889f723b28786$var$K;
        $b06889f723b28786$var$K |= 4;
        $b06889f723b28786$var$nk.current = null;
        $b06889f723b28786$var$Oj(a, c);
        $b06889f723b28786$var$dk(c, a);
        $b06889f723b28786$var$Oe($b06889f723b28786$var$Df);
        $b06889f723b28786$var$dd = !!$b06889f723b28786$var$Cf;
        $b06889f723b28786$var$Df = $b06889f723b28786$var$Cf = null;
        a.current = c;
        $b06889f723b28786$var$hk(c, a, e);
        $b06889f723b28786$var$dc();
        $b06889f723b28786$var$K = h;
        $b06889f723b28786$var$C = g;
        $b06889f723b28786$var$ok.transition = f;
    } else a.current = c;
    $b06889f723b28786$var$vk && ($b06889f723b28786$var$vk = !1, $b06889f723b28786$var$wk = a, $b06889f723b28786$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b06889f723b28786$var$Ri = null);
    $b06889f723b28786$var$mc(c.stateNode, d);
    $b06889f723b28786$var$Dk(a, $b06889f723b28786$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b06889f723b28786$var$Oi) throw $b06889f723b28786$var$Oi = !1, a = $b06889f723b28786$var$Pi, $b06889f723b28786$var$Pi = null, a;
    0 !== ($b06889f723b28786$var$xk & 1) && 0 !== a.tag && $b06889f723b28786$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b06889f723b28786$var$zk ? $b06889f723b28786$var$yk++ : ($b06889f723b28786$var$yk = 0, $b06889f723b28786$var$zk = a) : $b06889f723b28786$var$yk = 0;
    $b06889f723b28786$var$jg();
    return null;
}
function $b06889f723b28786$var$Hk() {
    if (null !== $b06889f723b28786$var$wk) {
        var a = $b06889f723b28786$var$Dc($b06889f723b28786$var$xk), b = $b06889f723b28786$var$ok.transition, c = $b06889f723b28786$var$C;
        try {
            $b06889f723b28786$var$ok.transition = null;
            $b06889f723b28786$var$C = 16 > a ? 16 : a;
            if (null === $b06889f723b28786$var$wk) var d = !1;
            else {
                a = $b06889f723b28786$var$wk;
                $b06889f723b28786$var$wk = null;
                $b06889f723b28786$var$xk = 0;
                if (0 !== ($b06889f723b28786$var$K & 6)) throw Error($b06889f723b28786$var$p(331));
                var e = $b06889f723b28786$var$K;
                $b06889f723b28786$var$K |= 4;
                for($b06889f723b28786$var$V = a.current; null !== $b06889f723b28786$var$V;){
                    var f = $b06889f723b28786$var$V, g = f.child;
                    if (0 !== ($b06889f723b28786$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b06889f723b28786$var$V = l; null !== $b06889f723b28786$var$V;){
                                    var m = $b06889f723b28786$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b06889f723b28786$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b06889f723b28786$var$V = q;
                                    else for(; null !== $b06889f723b28786$var$V;){
                                        m = $b06889f723b28786$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b06889f723b28786$var$Sj(m);
                                        if (m === l) {
                                            $b06889f723b28786$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b06889f723b28786$var$V = r;
                                            break;
                                        }
                                        $b06889f723b28786$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b06889f723b28786$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b06889f723b28786$var$V = g;
                    else b: for(; null !== $b06889f723b28786$var$V;){
                        f = $b06889f723b28786$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b06889f723b28786$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b06889f723b28786$var$V = x;
                            break b;
                        }
                        $b06889f723b28786$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b06889f723b28786$var$V = w; null !== $b06889f723b28786$var$V;){
                    g = $b06889f723b28786$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b06889f723b28786$var$V = u;
                    else b: for(g = w; null !== $b06889f723b28786$var$V;){
                        h = $b06889f723b28786$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b06889f723b28786$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b06889f723b28786$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b06889f723b28786$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b06889f723b28786$var$V = F;
                            break b;
                        }
                        $b06889f723b28786$var$V = h.return;
                    }
                }
                $b06889f723b28786$var$K = e;
                $b06889f723b28786$var$jg();
                if ($b06889f723b28786$var$lc && "function" === typeof $b06889f723b28786$var$lc.onPostCommitFiberRoot) try {
                    $b06889f723b28786$var$lc.onPostCommitFiberRoot($b06889f723b28786$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b06889f723b28786$var$C = c, $b06889f723b28786$var$ok.transition = b;
        }
    }
    return !1;
}
function $b06889f723b28786$var$Xk(a, b, c) {
    b = $b06889f723b28786$var$Ji(c, b);
    b = $b06889f723b28786$var$Ni(a, b, 1);
    a = $b06889f723b28786$var$nh(a, b, 1);
    b = $b06889f723b28786$var$R();
    null !== a && ($b06889f723b28786$var$Ac(a, 1, b), $b06889f723b28786$var$Dk(a, b));
}
function $b06889f723b28786$var$W(a, b, c) {
    if (3 === a.tag) $b06889f723b28786$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b06889f723b28786$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b06889f723b28786$var$Ri || !$b06889f723b28786$var$Ri.has(d))) {
                a = $b06889f723b28786$var$Ji(c, a);
                a = $b06889f723b28786$var$Qi(b, a, 1);
                b = $b06889f723b28786$var$nh(b, a, 1);
                a = $b06889f723b28786$var$R();
                null !== b && ($b06889f723b28786$var$Ac(b, 1, a), $b06889f723b28786$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b06889f723b28786$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b06889f723b28786$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b06889f723b28786$var$Q === a && ($b06889f723b28786$var$Z & c) === c && (4 === $b06889f723b28786$var$T || 3 === $b06889f723b28786$var$T && ($b06889f723b28786$var$Z & 130023424) === $b06889f723b28786$var$Z && 500 > $b06889f723b28786$var$B() - $b06889f723b28786$var$fk ? $b06889f723b28786$var$Kk(a, 0) : $b06889f723b28786$var$rk |= c);
    $b06889f723b28786$var$Dk(a, b);
}
function $b06889f723b28786$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b06889f723b28786$var$sc, $b06889f723b28786$var$sc <<= 1, 0 === ($b06889f723b28786$var$sc & 130023424) && ($b06889f723b28786$var$sc = 4194304)));
    var c = $b06889f723b28786$var$R();
    a = $b06889f723b28786$var$ih(a, b);
    null !== a && ($b06889f723b28786$var$Ac(a, b, c), $b06889f723b28786$var$Dk(a, c));
}
function $b06889f723b28786$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b06889f723b28786$var$Yk(a, c);
}
function $b06889f723b28786$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b06889f723b28786$var$p(314));
    }
    null !== d && d.delete(b);
    $b06889f723b28786$var$Yk(a, c);
}
var $b06889f723b28786$var$Vk;
$b06889f723b28786$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b06889f723b28786$var$Wf.current) $b06889f723b28786$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b06889f723b28786$var$dh = !1, $b06889f723b28786$var$yj(a, b, c);
            $b06889f723b28786$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b06889f723b28786$var$dh = !1, $b06889f723b28786$var$I && 0 !== (b.flags & 1048576) && $b06889f723b28786$var$ug(b, $b06889f723b28786$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b06889f723b28786$var$ij(a, b);
            a = b.pendingProps;
            var e = $b06889f723b28786$var$Yf(b, $b06889f723b28786$var$H.current);
            $b06889f723b28786$var$ch(b, c);
            e = $b06889f723b28786$var$Nh(null, b, d, a, e, c);
            var f = $b06889f723b28786$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b06889f723b28786$var$Zf(d) ? (f = !0, $b06889f723b28786$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b06889f723b28786$var$kh(b), e.updater = $b06889f723b28786$var$Ei, b.stateNode = e, e._reactInternals = b, $b06889f723b28786$var$Ii(b, d, a, c), b = $b06889f723b28786$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b06889f723b28786$var$I && f && $b06889f723b28786$var$vg(b), $b06889f723b28786$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b06889f723b28786$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b06889f723b28786$var$Zk(d);
                a = $b06889f723b28786$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b06889f723b28786$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b06889f723b28786$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b06889f723b28786$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b06889f723b28786$var$$i(null, b, d, $b06889f723b28786$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b06889f723b28786$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b06889f723b28786$var$Ci(d, e), $b06889f723b28786$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b06889f723b28786$var$Ci(d, e), $b06889f723b28786$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b06889f723b28786$var$kj(b);
                if (null === a) throw Error($b06889f723b28786$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b06889f723b28786$var$lh(a, b);
                $b06889f723b28786$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b06889f723b28786$var$Ji(Error($b06889f723b28786$var$p(423)), b);
                        b = $b06889f723b28786$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b06889f723b28786$var$Ji(Error($b06889f723b28786$var$p(424)), b);
                        b = $b06889f723b28786$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b06889f723b28786$var$yg = $b06889f723b28786$var$Lf(b.stateNode.containerInfo.firstChild), $b06889f723b28786$var$xg = b, $b06889f723b28786$var$I = !0, $b06889f723b28786$var$zg = null, c = $b06889f723b28786$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b06889f723b28786$var$Ig();
                    if (d === e) {
                        b = $b06889f723b28786$var$Zi(a, b, c);
                        break a;
                    }
                    $b06889f723b28786$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b06889f723b28786$var$Ah(b), null === a && $b06889f723b28786$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b06889f723b28786$var$Ef(d, e) ? g = null : null !== f && $b06889f723b28786$var$Ef(d, f) && (b.flags |= 32), $b06889f723b28786$var$gj(a, b), $b06889f723b28786$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b06889f723b28786$var$Eg(b), null;
        case 13:
            return $b06889f723b28786$var$oj(a, b, c);
        case 4:
            return $b06889f723b28786$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b06889f723b28786$var$Ug(b, null, d, c) : $b06889f723b28786$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b06889f723b28786$var$Ci(d, e), $b06889f723b28786$var$Yi(a, b, d, e, c);
        case 7:
            return $b06889f723b28786$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b06889f723b28786$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b06889f723b28786$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b06889f723b28786$var$G($b06889f723b28786$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b06889f723b28786$var$He(f.value, g)) {
                        if (f.children === e.children && !$b06889f723b28786$var$Wf.current) {
                            b = $b06889f723b28786$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b06889f723b28786$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b06889f723b28786$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b06889f723b28786$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b06889f723b28786$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b06889f723b28786$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b06889f723b28786$var$ch(b, c), e = $b06889f723b28786$var$eh(e), d = d(e), b.flags |= 1, $b06889f723b28786$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b06889f723b28786$var$Ci(d, b.pendingProps), e = $b06889f723b28786$var$Ci(d.type, e), $b06889f723b28786$var$$i(a, b, d, e, c);
        case 15:
            return $b06889f723b28786$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b06889f723b28786$var$Ci(d, e), $b06889f723b28786$var$ij(a, b), b.tag = 1, $b06889f723b28786$var$Zf(d) ? (a = !0, $b06889f723b28786$var$cg(b)) : a = !1, $b06889f723b28786$var$ch(b, c), $b06889f723b28786$var$Gi(b, d, e), $b06889f723b28786$var$Ii(b, d, e, c), $b06889f723b28786$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b06889f723b28786$var$xj(a, b, c);
        case 22:
            return $b06889f723b28786$var$dj(a, b, c);
    }
    throw Error($b06889f723b28786$var$p(156, b.tag));
};
function $b06889f723b28786$var$Fk(a, b) {
    return $b06889f723b28786$var$ac(a, b);
}
function $b06889f723b28786$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b06889f723b28786$var$Bg(a, b, c, d) {
    return new $b06889f723b28786$var$$k(a, b, c, d);
}
function $b06889f723b28786$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b06889f723b28786$var$Zk(a) {
    if ("function" === typeof a) return $b06889f723b28786$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b06889f723b28786$var$Da) return 11;
        if (a === $b06889f723b28786$var$Ga) return 14;
    }
    return 2;
}
function $b06889f723b28786$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b06889f723b28786$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b06889f723b28786$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b06889f723b28786$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b06889f723b28786$var$ya:
            return $b06889f723b28786$var$Tg(c.children, e, f, b);
        case $b06889f723b28786$var$za:
            g = 8;
            e |= 8;
            break;
        case $b06889f723b28786$var$Aa:
            return a = $b06889f723b28786$var$Bg(12, c, b, e | 2), a.elementType = $b06889f723b28786$var$Aa, a.lanes = f, a;
        case $b06889f723b28786$var$Ea:
            return a = $b06889f723b28786$var$Bg(13, c, b, e), a.elementType = $b06889f723b28786$var$Ea, a.lanes = f, a;
        case $b06889f723b28786$var$Fa:
            return a = $b06889f723b28786$var$Bg(19, c, b, e), a.elementType = $b06889f723b28786$var$Fa, a.lanes = f, a;
        case $b06889f723b28786$var$Ia:
            return $b06889f723b28786$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b06889f723b28786$var$Ba:
                    g = 10;
                    break a;
                case $b06889f723b28786$var$Ca:
                    g = 9;
                    break a;
                case $b06889f723b28786$var$Da:
                    g = 11;
                    break a;
                case $b06889f723b28786$var$Ga:
                    g = 14;
                    break a;
                case $b06889f723b28786$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b06889f723b28786$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b06889f723b28786$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b06889f723b28786$var$Tg(a, b, c, d) {
    a = $b06889f723b28786$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b06889f723b28786$var$pj(a, b, c, d) {
    a = $b06889f723b28786$var$Bg(22, a, d, b);
    a.elementType = $b06889f723b28786$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b06889f723b28786$var$Qg(a, b, c) {
    a = $b06889f723b28786$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b06889f723b28786$var$Sg(a, b, c) {
    b = $b06889f723b28786$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b06889f723b28786$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b06889f723b28786$var$zc(0);
    this.expirationTimes = $b06889f723b28786$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b06889f723b28786$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b06889f723b28786$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b06889f723b28786$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b06889f723b28786$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b06889f723b28786$var$kh(f);
    return a;
}
function $b06889f723b28786$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b06889f723b28786$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b06889f723b28786$var$dl(a) {
    if (!a) return $b06889f723b28786$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b06889f723b28786$var$Vb(a) !== a || 1 !== a.tag) throw Error($b06889f723b28786$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b06889f723b28786$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b06889f723b28786$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b06889f723b28786$var$Zf(c)) return $b06889f723b28786$var$bg(a, c, b);
    }
    return b;
}
function $b06889f723b28786$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b06889f723b28786$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b06889f723b28786$var$dl(null);
    c = a.current;
    d = $b06889f723b28786$var$R();
    e = $b06889f723b28786$var$yi(c);
    f = $b06889f723b28786$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b06889f723b28786$var$nh(c, f, e);
    a.current.lanes = e;
    $b06889f723b28786$var$Ac(a, e, d);
    $b06889f723b28786$var$Dk(a, d);
    return a;
}
function $b06889f723b28786$var$fl(a, b, c, d) {
    var e = b.current, f = $b06889f723b28786$var$R(), g = $b06889f723b28786$var$yi(e);
    c = $b06889f723b28786$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b06889f723b28786$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b06889f723b28786$var$nh(e, b, g);
    null !== a && ($b06889f723b28786$var$gi(a, e, g, f), $b06889f723b28786$var$oh(a, e, g));
    return g;
}
function $b06889f723b28786$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b06889f723b28786$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b06889f723b28786$var$il(a, b) {
    $b06889f723b28786$var$hl(a, b);
    (a = a.alternate) && $b06889f723b28786$var$hl(a, b);
}
function $b06889f723b28786$var$jl() {
    return null;
}
var $b06889f723b28786$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b06889f723b28786$var$ll(a) {
    this._internalRoot = a;
}
$b06889f723b28786$var$ml.prototype.render = $b06889f723b28786$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b06889f723b28786$var$p(409));
    $b06889f723b28786$var$fl(a, b, null, null);
};
$b06889f723b28786$var$ml.prototype.unmount = $b06889f723b28786$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b06889f723b28786$var$Rk(function() {
            $b06889f723b28786$var$fl(null, a, null, null);
        });
        b[$b06889f723b28786$var$uf] = null;
    }
};
function $b06889f723b28786$var$ml(a) {
    this._internalRoot = a;
}
$b06889f723b28786$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b06889f723b28786$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b06889f723b28786$var$Qc.length && 0 !== b && b < $b06889f723b28786$var$Qc[c].priority; c++);
        $b06889f723b28786$var$Qc.splice(c, 0, a);
        0 === c && $b06889f723b28786$var$Vc(a);
    }
};
function $b06889f723b28786$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b06889f723b28786$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b06889f723b28786$var$pl() {}
function $b06889f723b28786$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b06889f723b28786$var$gl(g);
                f.call(a);
            };
        }
        var g = $b06889f723b28786$var$el(b, d, a, 0, null, !1, !1, "", $b06889f723b28786$var$pl);
        a._reactRootContainer = g;
        a[$b06889f723b28786$var$uf] = g.current;
        $b06889f723b28786$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b06889f723b28786$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b06889f723b28786$var$gl(k);
            h.call(a);
        };
    }
    var k = $b06889f723b28786$var$bl(a, 0, !1, null, null, !1, !1, "", $b06889f723b28786$var$pl);
    a._reactRootContainer = k;
    a[$b06889f723b28786$var$uf] = k.current;
    $b06889f723b28786$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b06889f723b28786$var$Rk(function() {
        $b06889f723b28786$var$fl(b, k, c, d);
    });
    return k;
}
function $b06889f723b28786$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b06889f723b28786$var$gl(g);
                h.call(a);
            };
        }
        $b06889f723b28786$var$fl(b, g, a, e);
    } else g = $b06889f723b28786$var$ql(c, b, a, e, d);
    return $b06889f723b28786$var$gl(g);
}
$b06889f723b28786$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b06889f723b28786$var$tc(b.pendingLanes);
                0 !== c && ($b06889f723b28786$var$Cc(b, c | 1), $b06889f723b28786$var$Dk(b, $b06889f723b28786$var$B()), 0 === ($b06889f723b28786$var$K & 6) && ($b06889f723b28786$var$Gj = $b06889f723b28786$var$B() + 500, $b06889f723b28786$var$jg()));
            }
            break;
        case 13:
            $b06889f723b28786$var$Rk(function() {
                var b = $b06889f723b28786$var$ih(a, 1);
                if (null !== b) {
                    var c = $b06889f723b28786$var$R();
                    $b06889f723b28786$var$gi(b, a, 1, c);
                }
            }), $b06889f723b28786$var$il(a, 1);
    }
};
$b06889f723b28786$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b06889f723b28786$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b06889f723b28786$var$R();
            $b06889f723b28786$var$gi(b, a, 134217728, c);
        }
        $b06889f723b28786$var$il(a, 134217728);
    }
};
$b06889f723b28786$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b06889f723b28786$var$yi(a), c = $b06889f723b28786$var$ih(a, b);
        if (null !== c) {
            var d = $b06889f723b28786$var$R();
            $b06889f723b28786$var$gi(c, a, b, d);
        }
        $b06889f723b28786$var$il(a, b);
    }
};
$b06889f723b28786$var$Hc = function() {
    return $b06889f723b28786$var$C;
};
$b06889f723b28786$var$Ic = function(a, b) {
    var c = $b06889f723b28786$var$C;
    try {
        return $b06889f723b28786$var$C = a, b();
    } finally{
        $b06889f723b28786$var$C = c;
    }
};
$b06889f723b28786$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b06889f723b28786$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b06889f723b28786$var$Db(d);
                        if (!e) throw Error($b06889f723b28786$var$p(90));
                        $b06889f723b28786$var$Wa(d);
                        $b06889f723b28786$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b06889f723b28786$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b06889f723b28786$var$fb(a, !!c.multiple, b, !1);
    }
};
$b06889f723b28786$var$Gb = $b06889f723b28786$var$Qk;
$b06889f723b28786$var$Hb = $b06889f723b28786$var$Rk;
var $b06889f723b28786$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b06889f723b28786$var$Cb,
        $b06889f723b28786$var$ue,
        $b06889f723b28786$var$Db,
        $b06889f723b28786$var$Eb,
        $b06889f723b28786$var$Fb,
        $b06889f723b28786$var$Qk
    ]
}, $b06889f723b28786$var$tl = {
    findFiberByHostInstance: $b06889f723b28786$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b06889f723b28786$var$ul = {
    bundleType: $b06889f723b28786$var$tl.bundleType,
    version: $b06889f723b28786$var$tl.version,
    rendererPackageName: $b06889f723b28786$var$tl.rendererPackageName,
    rendererConfig: $b06889f723b28786$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b06889f723b28786$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b06889f723b28786$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b06889f723b28786$var$tl.findFiberByHostInstance || $b06889f723b28786$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b06889f723b28786$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b06889f723b28786$var$vl.isDisabled && $b06889f723b28786$var$vl.supportsFiber) try {
        $b06889f723b28786$var$kc = $b06889f723b28786$var$vl.inject($b06889f723b28786$var$ul), $b06889f723b28786$var$lc = $b06889f723b28786$var$vl;
    } catch (a) {}
}
$b06889f723b28786$export$ae55be85d98224ed = $b06889f723b28786$var$sl;
$b06889f723b28786$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b06889f723b28786$var$nl(b)) throw Error($b06889f723b28786$var$p(200));
    return $b06889f723b28786$var$cl(a, b, null, c);
};
$b06889f723b28786$export$882461b6382ed46c = function(a, b) {
    if (!$b06889f723b28786$var$nl(a)) throw Error($b06889f723b28786$var$p(299));
    var c = !1, d = "", e = $b06889f723b28786$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b06889f723b28786$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b06889f723b28786$var$uf] = b.current;
    $b06889f723b28786$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b06889f723b28786$var$ll(b);
};
$b06889f723b28786$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b06889f723b28786$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b06889f723b28786$var$p(268, a));
    }
    a = $b06889f723b28786$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b06889f723b28786$export$cd75ccfd720a3cd4 = function(a) {
    return $b06889f723b28786$var$Rk(a);
};
$b06889f723b28786$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b06889f723b28786$var$ol(b)) throw Error($b06889f723b28786$var$p(200));
    return $b06889f723b28786$var$rl(null, a, b, !0, c);
};
$b06889f723b28786$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b06889f723b28786$var$nl(a)) throw Error($b06889f723b28786$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b06889f723b28786$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b06889f723b28786$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b06889f723b28786$var$uf] = b.current;
    $b06889f723b28786$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b06889f723b28786$var$ml(b);
};
$b06889f723b28786$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b06889f723b28786$var$ol(b)) throw Error($b06889f723b28786$var$p(200));
    return $b06889f723b28786$var$rl(null, a, b, !1, c);
};
$b06889f723b28786$export$502457920280e6be = function(a) {
    if (!$b06889f723b28786$var$ol(a)) throw Error($b06889f723b28786$var$p(40));
    return a._reactRootContainer ? ($b06889f723b28786$var$Rk(function() {
        $b06889f723b28786$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b06889f723b28786$var$uf] = null;
        });
    }), !0) : !1;
};
$b06889f723b28786$export$c78a37762a8d58e1 = $b06889f723b28786$var$Qk;
$b06889f723b28786$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b06889f723b28786$var$ol(c)) throw Error($b06889f723b28786$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b06889f723b28786$var$p(38));
    return $b06889f723b28786$var$rl(a, b, c, !1, d);
};
$b06889f723b28786$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4pKUR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kUUNY"));

});
parcelRegister("kUUNY", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f3a519e3e5a9282f$export$c4744153514ff05d; }, function (v) { return $f3a519e3e5a9282f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f3a519e3e5a9282f$export$3e506c1ccc9cc1a7; }, function (v) { return $f3a519e3e5a9282f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f3a519e3e5a9282f$export$e26fe2ed2fa76875; }, function (v) { return $f3a519e3e5a9282f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f3a519e3e5a9282f$export$502329bbf4b505b1; }, function (v) { return $f3a519e3e5a9282f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f3a519e3e5a9282f$export$6e3807111c4874c4; }, function (v) { return $f3a519e3e5a9282f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f3a519e3e5a9282f$export$c27134553091fb3a; }, function (v) { return $f3a519e3e5a9282f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f3a519e3e5a9282f$export$33ee1acdc04fd2a2; }, function (v) { return $f3a519e3e5a9282f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f3a519e3e5a9282f$export$b00a404bbd5edef2; }, function (v) { return $f3a519e3e5a9282f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f3a519e3e5a9282f$export$8352ce38b91d0c62; }, function (v) { return $f3a519e3e5a9282f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f3a519e3e5a9282f$export$d66a1c1c77bd778b; }, function (v) { return $f3a519e3e5a9282f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f3a519e3e5a9282f$export$d3dfb8e4810cb555; }, function (v) { return $f3a519e3e5a9282f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f3a519e3e5a9282f$export$839f9183b0465a69; }, function (v) { return $f3a519e3e5a9282f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f3a519e3e5a9282f$export$72fdf0e06517287b; }, function (v) { return $f3a519e3e5a9282f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f3a519e3e5a9282f$export$4b844e58a3e414b4; }, function (v) { return $f3a519e3e5a9282f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f3a519e3e5a9282f$export$816d2913ae6b83b1; }, function (v) { return $f3a519e3e5a9282f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f3a519e3e5a9282f$export$61bcfe829111a1d0; }, function (v) { return $f3a519e3e5a9282f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f3a519e3e5a9282f$export$7ee8c9beb337bc3f; }, function (v) { return $f3a519e3e5a9282f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f3a519e3e5a9282f$export$b5836b71941fa3ed; }, function (v) { return $f3a519e3e5a9282f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f3a519e3e5a9282f$export$cf845f2c119da08a; }, function (v) { return $f3a519e3e5a9282f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f3a519e3e5a9282f$export$c4744153514ff05d;
var $f3a519e3e5a9282f$export$3e506c1ccc9cc1a7;
var $f3a519e3e5a9282f$export$e26fe2ed2fa76875;
var $f3a519e3e5a9282f$export$502329bbf4b505b1;
var $f3a519e3e5a9282f$export$6e3807111c4874c4;
var $f3a519e3e5a9282f$export$c27134553091fb3a;
var $f3a519e3e5a9282f$export$33ee1acdc04fd2a2;
var $f3a519e3e5a9282f$export$b00a404bbd5edef2;
var $f3a519e3e5a9282f$export$8352ce38b91d0c62;
var $f3a519e3e5a9282f$export$d66a1c1c77bd778b;
var $f3a519e3e5a9282f$export$d3dfb8e4810cb555;
var $f3a519e3e5a9282f$export$839f9183b0465a69;
var $f3a519e3e5a9282f$export$72fdf0e06517287b;
var $f3a519e3e5a9282f$export$4b844e58a3e414b4;
var $f3a519e3e5a9282f$export$816d2913ae6b83b1;
var $f3a519e3e5a9282f$export$61bcfe829111a1d0;
var $f3a519e3e5a9282f$export$7ee8c9beb337bc3f;
var $f3a519e3e5a9282f$export$b5836b71941fa3ed;
var $f3a519e3e5a9282f$export$cf845f2c119da08a;
"use strict";
function $f3a519e3e5a9282f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f3a519e3e5a9282f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f3a519e3e5a9282f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f3a519e3e5a9282f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f3a519e3e5a9282f$var$g(C, c)) n < e && 0 > $f3a519e3e5a9282f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f3a519e3e5a9282f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f3a519e3e5a9282f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f3a519e3e5a9282f$var$l = performance;
    $f3a519e3e5a9282f$export$c4744153514ff05d = function() {
        return $f3a519e3e5a9282f$var$l.now();
    };
} else {
    var $f3a519e3e5a9282f$var$p = Date, $f3a519e3e5a9282f$var$q = $f3a519e3e5a9282f$var$p.now();
    $f3a519e3e5a9282f$export$c4744153514ff05d = function() {
        return $f3a519e3e5a9282f$var$p.now() - $f3a519e3e5a9282f$var$q;
    };
}
var $f3a519e3e5a9282f$var$r = [], $f3a519e3e5a9282f$var$t = [], $f3a519e3e5a9282f$var$u = 1, $f3a519e3e5a9282f$var$v = null, $f3a519e3e5a9282f$var$y = 3, $f3a519e3e5a9282f$var$z = !1, $f3a519e3e5a9282f$var$A = !1, $f3a519e3e5a9282f$var$B = !1, $f3a519e3e5a9282f$var$D = "function" === typeof setTimeout ? setTimeout : null, $f3a519e3e5a9282f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f3a519e3e5a9282f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f3a519e3e5a9282f$var$G(a) {
    for(var b = $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$t); null !== b;){
        if (null === b.callback) $f3a519e3e5a9282f$var$k($f3a519e3e5a9282f$var$t);
        else if (b.startTime <= a) $f3a519e3e5a9282f$var$k($f3a519e3e5a9282f$var$t), b.sortIndex = b.expirationTime, $f3a519e3e5a9282f$var$f($f3a519e3e5a9282f$var$r, b);
        else break;
        b = $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$t);
    }
}
function $f3a519e3e5a9282f$var$H(a) {
    $f3a519e3e5a9282f$var$B = !1;
    $f3a519e3e5a9282f$var$G(a);
    if (!$f3a519e3e5a9282f$var$A) {
        if (null !== $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$r)) $f3a519e3e5a9282f$var$A = !0, $f3a519e3e5a9282f$var$I($f3a519e3e5a9282f$var$J);
        else {
            var b = $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$t);
            null !== b && $f3a519e3e5a9282f$var$K($f3a519e3e5a9282f$var$H, b.startTime - a);
        }
    }
}
function $f3a519e3e5a9282f$var$J(a, b) {
    $f3a519e3e5a9282f$var$A = !1;
    $f3a519e3e5a9282f$var$B && ($f3a519e3e5a9282f$var$B = !1, $f3a519e3e5a9282f$var$E($f3a519e3e5a9282f$var$L), $f3a519e3e5a9282f$var$L = -1);
    $f3a519e3e5a9282f$var$z = !0;
    var c = $f3a519e3e5a9282f$var$y;
    try {
        $f3a519e3e5a9282f$var$G(b);
        for($f3a519e3e5a9282f$var$v = $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$r); null !== $f3a519e3e5a9282f$var$v && (!($f3a519e3e5a9282f$var$v.expirationTime > b) || a && !$f3a519e3e5a9282f$var$M());){
            var d = $f3a519e3e5a9282f$var$v.callback;
            if ("function" === typeof d) {
                $f3a519e3e5a9282f$var$v.callback = null;
                $f3a519e3e5a9282f$var$y = $f3a519e3e5a9282f$var$v.priorityLevel;
                var e = d($f3a519e3e5a9282f$var$v.expirationTime <= b);
                b = $f3a519e3e5a9282f$export$c4744153514ff05d();
                "function" === typeof e ? $f3a519e3e5a9282f$var$v.callback = e : $f3a519e3e5a9282f$var$v === $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$r) && $f3a519e3e5a9282f$var$k($f3a519e3e5a9282f$var$r);
                $f3a519e3e5a9282f$var$G(b);
            } else $f3a519e3e5a9282f$var$k($f3a519e3e5a9282f$var$r);
            $f3a519e3e5a9282f$var$v = $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$r);
        }
        if (null !== $f3a519e3e5a9282f$var$v) var w = !0;
        else {
            var m = $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$t);
            null !== m && $f3a519e3e5a9282f$var$K($f3a519e3e5a9282f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f3a519e3e5a9282f$var$v = null, $f3a519e3e5a9282f$var$y = c, $f3a519e3e5a9282f$var$z = !1;
    }
}
var $f3a519e3e5a9282f$var$N = !1, $f3a519e3e5a9282f$var$O = null, $f3a519e3e5a9282f$var$L = -1, $f3a519e3e5a9282f$var$P = 5, $f3a519e3e5a9282f$var$Q = -1;
function $f3a519e3e5a9282f$var$M() {
    return $f3a519e3e5a9282f$export$c4744153514ff05d() - $f3a519e3e5a9282f$var$Q < $f3a519e3e5a9282f$var$P ? !1 : !0;
}
function $f3a519e3e5a9282f$var$R() {
    if (null !== $f3a519e3e5a9282f$var$O) {
        var a = $f3a519e3e5a9282f$export$c4744153514ff05d();
        $f3a519e3e5a9282f$var$Q = a;
        var b = !0;
        try {
            b = $f3a519e3e5a9282f$var$O(!0, a);
        } finally{
            b ? $f3a519e3e5a9282f$var$S() : ($f3a519e3e5a9282f$var$N = !1, $f3a519e3e5a9282f$var$O = null);
        }
    } else $f3a519e3e5a9282f$var$N = !1;
}
var $f3a519e3e5a9282f$var$S;
if ("function" === typeof $f3a519e3e5a9282f$var$F) $f3a519e3e5a9282f$var$S = function() {
    $f3a519e3e5a9282f$var$F($f3a519e3e5a9282f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f3a519e3e5a9282f$var$T = new MessageChannel, $f3a519e3e5a9282f$var$U = $f3a519e3e5a9282f$var$T.port2;
    $f3a519e3e5a9282f$var$T.port1.onmessage = $f3a519e3e5a9282f$var$R;
    $f3a519e3e5a9282f$var$S = function() {
        $f3a519e3e5a9282f$var$U.postMessage(null);
    };
} else $f3a519e3e5a9282f$var$S = function() {
    $f3a519e3e5a9282f$var$D($f3a519e3e5a9282f$var$R, 0);
};
function $f3a519e3e5a9282f$var$I(a) {
    $f3a519e3e5a9282f$var$O = a;
    $f3a519e3e5a9282f$var$N || ($f3a519e3e5a9282f$var$N = !0, $f3a519e3e5a9282f$var$S());
}
function $f3a519e3e5a9282f$var$K(a, b) {
    $f3a519e3e5a9282f$var$L = $f3a519e3e5a9282f$var$D(function() {
        a($f3a519e3e5a9282f$export$c4744153514ff05d());
    }, b);
}
$f3a519e3e5a9282f$export$3e506c1ccc9cc1a7 = 5;
$f3a519e3e5a9282f$export$e26fe2ed2fa76875 = 1;
$f3a519e3e5a9282f$export$502329bbf4b505b1 = 4;
$f3a519e3e5a9282f$export$6e3807111c4874c4 = 3;
$f3a519e3e5a9282f$export$c27134553091fb3a = null;
$f3a519e3e5a9282f$export$33ee1acdc04fd2a2 = 2;
$f3a519e3e5a9282f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f3a519e3e5a9282f$export$8352ce38b91d0c62 = function() {
    $f3a519e3e5a9282f$var$A || $f3a519e3e5a9282f$var$z || ($f3a519e3e5a9282f$var$A = !0, $f3a519e3e5a9282f$var$I($f3a519e3e5a9282f$var$J));
};
$f3a519e3e5a9282f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f3a519e3e5a9282f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f3a519e3e5a9282f$export$d3dfb8e4810cb555 = function() {
    return $f3a519e3e5a9282f$var$y;
};
$f3a519e3e5a9282f$export$839f9183b0465a69 = function() {
    return $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$r);
};
$f3a519e3e5a9282f$export$72fdf0e06517287b = function(a) {
    switch($f3a519e3e5a9282f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f3a519e3e5a9282f$var$y;
    }
    var c = $f3a519e3e5a9282f$var$y;
    $f3a519e3e5a9282f$var$y = b;
    try {
        return a();
    } finally{
        $f3a519e3e5a9282f$var$y = c;
    }
};
$f3a519e3e5a9282f$export$4b844e58a3e414b4 = function() {};
$f3a519e3e5a9282f$export$816d2913ae6b83b1 = function() {};
$f3a519e3e5a9282f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f3a519e3e5a9282f$var$y;
    $f3a519e3e5a9282f$var$y = a;
    try {
        return b();
    } finally{
        $f3a519e3e5a9282f$var$y = c;
    }
};
$f3a519e3e5a9282f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f3a519e3e5a9282f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f3a519e3e5a9282f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f3a519e3e5a9282f$var$f($f3a519e3e5a9282f$var$t, a), null === $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$r) && a === $f3a519e3e5a9282f$var$h($f3a519e3e5a9282f$var$t) && ($f3a519e3e5a9282f$var$B ? ($f3a519e3e5a9282f$var$E($f3a519e3e5a9282f$var$L), $f3a519e3e5a9282f$var$L = -1) : $f3a519e3e5a9282f$var$B = !0, $f3a519e3e5a9282f$var$K($f3a519e3e5a9282f$var$H, c - d))) : (a.sortIndex = e, $f3a519e3e5a9282f$var$f($f3a519e3e5a9282f$var$r, a), $f3a519e3e5a9282f$var$A || $f3a519e3e5a9282f$var$z || ($f3a519e3e5a9282f$var$A = !0, $f3a519e3e5a9282f$var$I($f3a519e3e5a9282f$var$J)));
    return a;
};
$f3a519e3e5a9282f$export$b5836b71941fa3ed = $f3a519e3e5a9282f$var$M;
$f3a519e3e5a9282f$export$cf845f2c119da08a = function(a) {
    var b = $f3a519e3e5a9282f$var$y;
    return function() {
        var c = $f3a519e3e5a9282f$var$y;
        $f3a519e3e5a9282f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f3a519e3e5a9282f$var$y = c;
        }
    };
};

});



parcelRegister("rwG8S", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $052bdf0ae74f8085$export$2b8d127b894957b9; }, function (v) { return $052bdf0ae74f8085$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $052bdf0ae74f8085$export$cea3a54a6425200c; }, function (v) { return $052bdf0ae74f8085$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $052bdf0ae74f8085$export$a7c73072b1a182ae; }, function (v) { return $052bdf0ae74f8085$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $052bdf0ae74f8085$export$9f27bc3417b4524d; }, function (v) { return $052bdf0ae74f8085$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $052bdf0ae74f8085$export$db77ccec0bb4ccac; }, function (v) { return $052bdf0ae74f8085$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $052bdf0ae74f8085$export$8392c0c9d3dcbd35; }, function (v) { return $052bdf0ae74f8085$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $052bdf0ae74f8085$export$ffb0004e005737fa; }, function (v) { return $052bdf0ae74f8085$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $052bdf0ae74f8085$export$b624eff549462981; }, function (v) { return $052bdf0ae74f8085$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $052bdf0ae74f8085$export$7897aa7841a5380c; }, function (v) { return $052bdf0ae74f8085$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $052bdf0ae74f8085$export$602eac185826482c; }, function (v) { return $052bdf0ae74f8085$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $052bdf0ae74f8085$export$e2c29f18771995cb; }, function (v) { return $052bdf0ae74f8085$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $052bdf0ae74f8085$export$5f8d39834fd61797; }, function (v) { return $052bdf0ae74f8085$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $052bdf0ae74f8085$export$74bf444e3cd11ea5; }, function (v) { return $052bdf0ae74f8085$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $052bdf0ae74f8085$export$92387174baf9b227; }, function (v) { return $052bdf0ae74f8085$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $052bdf0ae74f8085$export$ec112efeb987d9c6; }, function (v) { return $052bdf0ae74f8085$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $052bdf0ae74f8085$export$b706b080d889d2c9; }, function (v) { return $052bdf0ae74f8085$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $052bdf0ae74f8085$export$5be5a87408f70ddc; }, function (v) { return $052bdf0ae74f8085$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $052bdf0ae74f8085$export$45a5e7f76e0caa8d; }, function (v) { return $052bdf0ae74f8085$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $052bdf0ae74f8085$export$455c2e768291efa6; }, function (v) { return $052bdf0ae74f8085$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $052bdf0ae74f8085$export$9522e17588c12572; }, function (v) { return $052bdf0ae74f8085$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $052bdf0ae74f8085$export$2110ac352bb060b9; }, function (v) { return $052bdf0ae74f8085$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $052bdf0ae74f8085$export$56885ab8b9c456ab; }, function (v) { return $052bdf0ae74f8085$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $052bdf0ae74f8085$export$d927fcb6adf8f9de; }, function (v) { return $052bdf0ae74f8085$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $052bdf0ae74f8085$export$b82d16f27459e05a; }, function (v) { return $052bdf0ae74f8085$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $052bdf0ae74f8085$export$522c17b4f5e123e8; }, function (v) { return $052bdf0ae74f8085$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $052bdf0ae74f8085$export$1aabd8a0274ecfd6; }, function (v) { return $052bdf0ae74f8085$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $052bdf0ae74f8085$export$9b621391a187a31a; }, function (v) { return $052bdf0ae74f8085$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $052bdf0ae74f8085$export$f5bbd400c2f4426f; }, function (v) { return $052bdf0ae74f8085$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $052bdf0ae74f8085$export$2b8d127b894957b9;
var $052bdf0ae74f8085$export$cea3a54a6425200c;
var $052bdf0ae74f8085$export$a7c73072b1a182ae;
var $052bdf0ae74f8085$export$9f27bc3417b4524d;
var $052bdf0ae74f8085$export$db77ccec0bb4ccac;
var $052bdf0ae74f8085$export$8392c0c9d3dcbd35;
var $052bdf0ae74f8085$export$ffb0004e005737fa;
var $052bdf0ae74f8085$export$b624eff549462981;
var $052bdf0ae74f8085$export$7897aa7841a5380c;
var $052bdf0ae74f8085$export$602eac185826482c;
var $052bdf0ae74f8085$export$e2c29f18771995cb;
var $052bdf0ae74f8085$export$5f8d39834fd61797;
var $052bdf0ae74f8085$export$74bf444e3cd11ea5;
var $052bdf0ae74f8085$export$92387174baf9b227;
var $052bdf0ae74f8085$export$ec112efeb987d9c6;
var $052bdf0ae74f8085$export$b706b080d889d2c9;
var $052bdf0ae74f8085$export$5be5a87408f70ddc;
var $052bdf0ae74f8085$export$45a5e7f76e0caa8d;
var $052bdf0ae74f8085$export$455c2e768291efa6;
var $052bdf0ae74f8085$export$9522e17588c12572;
var $052bdf0ae74f8085$export$2110ac352bb060b9;
var $052bdf0ae74f8085$export$56885ab8b9c456ab;
var $052bdf0ae74f8085$export$d927fcb6adf8f9de;
var $052bdf0ae74f8085$export$b82d16f27459e05a;
var $052bdf0ae74f8085$export$522c17b4f5e123e8;
var $052bdf0ae74f8085$export$1aabd8a0274ecfd6;
var $052bdf0ae74f8085$export$9b621391a187a31a;
var $052bdf0ae74f8085$export$f5bbd400c2f4426f;
"use strict";
var $052bdf0ae74f8085$var$b = "function" === typeof Symbol && Symbol.for, $052bdf0ae74f8085$var$c = $052bdf0ae74f8085$var$b ? Symbol.for("react.element") : 60103, $052bdf0ae74f8085$var$d = $052bdf0ae74f8085$var$b ? Symbol.for("react.portal") : 60106, $052bdf0ae74f8085$var$e = $052bdf0ae74f8085$var$b ? Symbol.for("react.fragment") : 60107, $052bdf0ae74f8085$var$f = $052bdf0ae74f8085$var$b ? Symbol.for("react.strict_mode") : 60108, $052bdf0ae74f8085$var$g = $052bdf0ae74f8085$var$b ? Symbol.for("react.profiler") : 60114, $052bdf0ae74f8085$var$h = $052bdf0ae74f8085$var$b ? Symbol.for("react.provider") : 60109, $052bdf0ae74f8085$var$k = $052bdf0ae74f8085$var$b ? Symbol.for("react.context") : 60110, $052bdf0ae74f8085$var$l = $052bdf0ae74f8085$var$b ? Symbol.for("react.async_mode") : 60111, $052bdf0ae74f8085$var$m = $052bdf0ae74f8085$var$b ? Symbol.for("react.concurrent_mode") : 60111, $052bdf0ae74f8085$var$n = $052bdf0ae74f8085$var$b ? Symbol.for("react.forward_ref") : 60112, $052bdf0ae74f8085$var$p = $052bdf0ae74f8085$var$b ? Symbol.for("react.suspense") : 60113, $052bdf0ae74f8085$var$q = $052bdf0ae74f8085$var$b ? Symbol.for("react.suspense_list") : 60120, $052bdf0ae74f8085$var$r = $052bdf0ae74f8085$var$b ? Symbol.for("react.memo") : 60115, $052bdf0ae74f8085$var$t = $052bdf0ae74f8085$var$b ? Symbol.for("react.lazy") : 60116, $052bdf0ae74f8085$var$v = $052bdf0ae74f8085$var$b ? Symbol.for("react.block") : 60121, $052bdf0ae74f8085$var$w = $052bdf0ae74f8085$var$b ? Symbol.for("react.fundamental") : 60117, $052bdf0ae74f8085$var$x = $052bdf0ae74f8085$var$b ? Symbol.for("react.responder") : 60118, $052bdf0ae74f8085$var$y = $052bdf0ae74f8085$var$b ? Symbol.for("react.scope") : 60119;
function $052bdf0ae74f8085$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $052bdf0ae74f8085$var$c:
                switch(a = a.type, a){
                    case $052bdf0ae74f8085$var$l:
                    case $052bdf0ae74f8085$var$m:
                    case $052bdf0ae74f8085$var$e:
                    case $052bdf0ae74f8085$var$g:
                    case $052bdf0ae74f8085$var$f:
                    case $052bdf0ae74f8085$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $052bdf0ae74f8085$var$k:
                            case $052bdf0ae74f8085$var$n:
                            case $052bdf0ae74f8085$var$t:
                            case $052bdf0ae74f8085$var$r:
                            case $052bdf0ae74f8085$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $052bdf0ae74f8085$var$d:
                return u;
        }
    }
}
function $052bdf0ae74f8085$var$A(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$m;
}
$052bdf0ae74f8085$export$2b8d127b894957b9 = $052bdf0ae74f8085$var$l;
$052bdf0ae74f8085$export$cea3a54a6425200c = $052bdf0ae74f8085$var$m;
$052bdf0ae74f8085$export$a7c73072b1a182ae = $052bdf0ae74f8085$var$k;
$052bdf0ae74f8085$export$9f27bc3417b4524d = $052bdf0ae74f8085$var$h;
$052bdf0ae74f8085$export$db77ccec0bb4ccac = $052bdf0ae74f8085$var$c;
$052bdf0ae74f8085$export$8392c0c9d3dcbd35 = $052bdf0ae74f8085$var$n;
$052bdf0ae74f8085$export$ffb0004e005737fa = $052bdf0ae74f8085$var$e;
$052bdf0ae74f8085$export$b624eff549462981 = $052bdf0ae74f8085$var$t;
$052bdf0ae74f8085$export$7897aa7841a5380c = $052bdf0ae74f8085$var$r;
$052bdf0ae74f8085$export$602eac185826482c = $052bdf0ae74f8085$var$d;
$052bdf0ae74f8085$export$e2c29f18771995cb = $052bdf0ae74f8085$var$g;
$052bdf0ae74f8085$export$5f8d39834fd61797 = $052bdf0ae74f8085$var$f;
$052bdf0ae74f8085$export$74bf444e3cd11ea5 = $052bdf0ae74f8085$var$p;
$052bdf0ae74f8085$export$92387174baf9b227 = function(a) {
    return $052bdf0ae74f8085$var$A(a) || $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$l;
};
$052bdf0ae74f8085$export$ec112efeb987d9c6 = $052bdf0ae74f8085$var$A;
$052bdf0ae74f8085$export$b706b080d889d2c9 = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$k;
};
$052bdf0ae74f8085$export$5be5a87408f70ddc = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$h;
};
$052bdf0ae74f8085$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $052bdf0ae74f8085$var$c;
};
$052bdf0ae74f8085$export$455c2e768291efa6 = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$n;
};
$052bdf0ae74f8085$export$9522e17588c12572 = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$e;
};
$052bdf0ae74f8085$export$2110ac352bb060b9 = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$t;
};
$052bdf0ae74f8085$export$56885ab8b9c456ab = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$r;
};
$052bdf0ae74f8085$export$d927fcb6adf8f9de = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$d;
};
$052bdf0ae74f8085$export$b82d16f27459e05a = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$g;
};
$052bdf0ae74f8085$export$522c17b4f5e123e8 = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$f;
};
$052bdf0ae74f8085$export$1aabd8a0274ecfd6 = function(a) {
    return $052bdf0ae74f8085$var$z(a) === $052bdf0ae74f8085$var$p;
};
$052bdf0ae74f8085$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $052bdf0ae74f8085$var$e || a === $052bdf0ae74f8085$var$m || a === $052bdf0ae74f8085$var$g || a === $052bdf0ae74f8085$var$f || a === $052bdf0ae74f8085$var$p || a === $052bdf0ae74f8085$var$q || "object" === typeof a && null !== a && (a.$$typeof === $052bdf0ae74f8085$var$t || a.$$typeof === $052bdf0ae74f8085$var$r || a.$$typeof === $052bdf0ae74f8085$var$h || a.$$typeof === $052bdf0ae74f8085$var$k || a.$$typeof === $052bdf0ae74f8085$var$n || a.$$typeof === $052bdf0ae74f8085$var$w || a.$$typeof === $052bdf0ae74f8085$var$x || a.$$typeof === $052bdf0ae74f8085$var$y || a.$$typeof === $052bdf0ae74f8085$var$v);
};
$052bdf0ae74f8085$export$f5bbd400c2f4426f = $052bdf0ae74f8085$var$z;

});

parcelRegister("ewWP8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $bkP80 = parcelRequire("bkP80");
function $a941af05dfd6835a$var$emptyFunction() {}
function $a941af05dfd6835a$var$emptyFunctionWithReset() {}
$a941af05dfd6835a$var$emptyFunctionWithReset.resetWarningCache = $a941af05dfd6835a$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $bkP80) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a941af05dfd6835a$var$emptyFunctionWithReset,
        resetWarningCache: $a941af05dfd6835a$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("bkP80", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $840938ee86cc726f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $840938ee86cc726f$var$ReactPropTypesSecret;

});


parcelRegister("dFWbn", function(module, exports) {
function $9f4c3c891100a0e1$var$_extends() {
    module.exports = $9f4c3c891100a0e1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $9f4c3c891100a0e1$var$_extends.apply(this, arguments);
}
module.exports = $9f4c3c891100a0e1$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1gl5Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("aahau")).default; });

var $aahau = parcelRequire("aahau");

});
parcelRegister("aahau", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766827d1f050c1dd$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $766827d1f050c1dd$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});


parcelRegister("1B8UC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fzDmb")).default; });

var $fzDmb = parcelRequire("fzDmb");

});
parcelRegister("fzDmb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b568a7592e920172$export$2e2bcd8739ae039; });
function $b568a7592e920172$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $b568a7592e920172$export$2e2bcd8739ae039 = $b568a7592e920172$var$clamp;

});


parcelRegister("7iyvN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5504fc31342872ae$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $5504fc31342872ae$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $5504fc31342872ae$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $5504fc31342872ae$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $5504fc31342872ae$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $5504fc31342872ae$var$timeLongFormatter(timePattern, formatLong));
};
var $5504fc31342872ae$var$longFormatters = {
    p: $5504fc31342872ae$var$timeLongFormatter,
    P: $5504fc31342872ae$var$dateTimeLongFormatter
};
var $5504fc31342872ae$var$_default = $5504fc31342872ae$var$longFormatters;
module.exports.default = $5504fc31342872ae$var$_default;
module.exports = module.exports.default;

});

parcelRegister("k6Ukq", function(module, exports) {
$parcel$export(module.exports, "addEasing", function () { return (parcelRequire("8wHfp")).addEasing; });
$parcel$export(module.exports, "AnimatableColor", function () { return (parcelRequire("cHoex")).AnimatableColor; });
$parcel$export(module.exports, "arrayRandomIndex", function () { return (parcelRequire("b9FKP")).arrayRandomIndex; });
$parcel$export(module.exports, "calcPositionOrRandomFromSize", function () { return (parcelRequire("8wHfp")).calcPositionOrRandomFromSize; });
$parcel$export(module.exports, "calcPositionOrRandomFromSizeRanged", function () { return (parcelRequire("8wHfp")).calcPositionOrRandomFromSizeRanged; });
$parcel$export(module.exports, "calculateBounds", function () { return (parcelRequire("b9FKP")).calculateBounds; });
$parcel$export(module.exports, "Circle", function () { return (parcelRequire("lvIxI")).Circle; });
$parcel$export(module.exports, "circleBounce", function () { return (parcelRequire("b9FKP")).circleBounce; });
$parcel$export(module.exports, "circleBounceDataFromParticle", function () { return (parcelRequire("b9FKP")).circleBounceDataFromParticle; });
$parcel$export(module.exports, "clamp", function () { return (parcelRequire("8wHfp")).clamp; });
$parcel$export(module.exports, "colorMix", function () { return (parcelRequire("lr6PC")).colorMix; });
$parcel$export(module.exports, "deepExtend", function () { return (parcelRequire("b9FKP")).deepExtend; });
$parcel$export(module.exports, "degToRad", function () { return (parcelRequire("8wHfp")).degToRad; });
$parcel$export(module.exports, "divMode", function () { return (parcelRequire("b9FKP")).divMode; });
$parcel$export(module.exports, "divModeExecute", function () { return (parcelRequire("b9FKP")).divModeExecute; });
$parcel$export(module.exports, "drawLine", function () { return (parcelRequire("7Cxfx")).drawLine; });
$parcel$export(module.exports, "errorPrefix", function () { return (parcelRequire("bOXKQ")).errorPrefix; });
$parcel$export(module.exports, "executeOnSingleOrMultiple", function () { return (parcelRequire("b9FKP")).executeOnSingleOrMultiple; });
$parcel$export(module.exports, "ExternalInteractorBase", function () { return (parcelRequire("iqSVQ")).ExternalInteractorBase; });
$parcel$export(module.exports, "getDistance", function () { return (parcelRequire("8wHfp")).getDistance; });
$parcel$export(module.exports, "getDistances", function () { return (parcelRequire("8wHfp")).getDistances; });
$parcel$export(module.exports, "getEasing", function () { return (parcelRequire("8wHfp")).getEasing; });
$parcel$export(module.exports, "getHslAnimationFromHsl", function () { return (parcelRequire("lr6PC")).getHslAnimationFromHsl; });
$parcel$export(module.exports, "getLinkColor", function () { return (parcelRequire("lr6PC")).getLinkColor; });
$parcel$export(module.exports, "getLinkRandomColor", function () { return (parcelRequire("lr6PC")).getLinkRandomColor; });
$parcel$export(module.exports, "getLogger", function () { return (parcelRequire("b9FKP")).getLogger; });
$parcel$export(module.exports, "getRandom", function () { return (parcelRequire("8wHfp")).getRandom; });
$parcel$export(module.exports, "getRangeMax", function () { return (parcelRequire("8wHfp")).getRangeMax; });
$parcel$export(module.exports, "getRangeValue", function () { return (parcelRequire("8wHfp")).getRangeValue; });
$parcel$export(module.exports, "getSize", function () { return (parcelRequire("b9FKP")).getSize; });
$parcel$export(module.exports, "getStyleFromHsl", function () { return (parcelRequire("lr6PC")).getStyleFromHsl; });
$parcel$export(module.exports, "getStyleFromRgb", function () { return (parcelRequire("lr6PC")).getStyleFromRgb; });
$parcel$export(module.exports, "halfRandom", function () { return (parcelRequire("bOXKQ")).halfRandom; });
$parcel$export(module.exports, "initParticleNumericAnimationValue", function () { return (parcelRequire("b9FKP")).initParticleNumericAnimationValue; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("1Cbg8")).isArray; });
$parcel$export(module.exports, "isDivModeEnabled", function () { return (parcelRequire("b9FKP")).isDivModeEnabled; });
$parcel$export(module.exports, "isInArray", function () { return (parcelRequire("b9FKP")).isInArray; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("1Cbg8")).isNumber; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("1Cbg8")).isObject; });
$parcel$export(module.exports, "isPointInside", function () { return (parcelRequire("b9FKP")).isPointInside; });
$parcel$export(module.exports, "isSsr", function () { return (parcelRequire("b9FKP")).isSsr; });
$parcel$export(module.exports, "itemFromArray", function () { return (parcelRequire("b9FKP")).itemFromArray; });
$parcel$export(module.exports, "itemFromSingleOrMultiple", function () { return (parcelRequire("b9FKP")).itemFromSingleOrMultiple; });
$parcel$export(module.exports, "loadFont", function () { return (parcelRequire("b9FKP")).loadFont; });
$parcel$export(module.exports, "loadParticlesOptions", function () { return (parcelRequire("bPqPl")).loadParticlesOptions; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return (parcelRequire("bOXKQ")).millisecondsToSeconds; });
$parcel$export(module.exports, "mouseLeaveEvent", function () { return (parcelRequire("bOXKQ")).mouseLeaveEvent; });
$parcel$export(module.exports, "mouseMoveEvent", function () { return (parcelRequire("bOXKQ")).mouseMoveEvent; });
$parcel$export(module.exports, "OptionsColor", function () { return (parcelRequire("ceG2E")).OptionsColor; });
$parcel$export(module.exports, "ParticlesInteractorBase", function () { return (parcelRequire("cZfuF")).ParticlesInteractorBase; });
$parcel$export(module.exports, "percentDenominator", function () { return (parcelRequire("bOXKQ")).percentDenominator; });
$parcel$export(module.exports, "randomInRange", function () { return (parcelRequire("8wHfp")).randomInRange; });
$parcel$export(module.exports, "rangeColorToHsl", function () { return (parcelRequire("lr6PC")).rangeColorToHsl; });
$parcel$export(module.exports, "rangeColorToRgb", function () { return (parcelRequire("lr6PC")).rangeColorToRgb; });
$parcel$export(module.exports, "Rectangle", function () { return (parcelRequire("lvIxI")).Rectangle; });
$parcel$export(module.exports, "rectBounce", function () { return (parcelRequire("b9FKP")).rectBounce; });
$parcel$export(module.exports, "rgbToHsl", function () { return (parcelRequire("lr6PC")).rgbToHsl; });
$parcel$export(module.exports, "setRangeValue", function () { return (parcelRequire("8wHfp")).setRangeValue; });
$parcel$export(module.exports, "updateAnimation", function () { return (parcelRequire("b9FKP")).updateAnimation; });
$parcel$export(module.exports, "updateColor", function () { return (parcelRequire("lr6PC")).updateColor; });
$parcel$export(module.exports, "ValueWithRandom", function () { return (parcelRequire("dusZm")).ValueWithRandom; });
$parcel$export(module.exports, "Vector", function () { return (parcelRequire("jpo9d")).Vector; });

$parcel$export(module.exports, "tsParticles", function () { return $ea400fd79553402d$export$218c38ca7c058037; });

var $26OmT = parcelRequire("26OmT");

var $b9FKP = parcelRequire("b9FKP");
parcelRequire("7zVhK");
parcelRequire("86buA");
const $ea400fd79553402d$export$218c38ca7c058037 = (0, $26OmT.init)();
if (!(0, $b9FKP.isSsr)()) window.tsParticles = $ea400fd79553402d$export$218c38ca7c058037;

});
parcelRegister("26OmT", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $1893365e749b4098$export$2cd8252107eb640b; });

var $g9vQd = parcelRequire("g9vQd");

var $1dkw8 = parcelRequire("1dkw8");

var $kc8F4 = parcelRequire("kc8F4");

var $lr6PC = parcelRequire("lr6PC");
function $1893365e749b4098$export$2cd8252107eb640b() {
    const rgbColorManager = new (0, $kc8F4.RgbColorManager)(), hslColorManager = new (0, $1dkw8.HslColorManager)();
    (0, $lr6PC.addColorManager)(rgbColorManager);
    (0, $lr6PC.addColorManager)(hslColorManager);
    const engine = new (0, $g9vQd.Engine)();
    engine.init();
    return engine;
}

});
parcelRegister("g9vQd", function(module, exports) {

$parcel$export(module.exports, "Engine", function () { return $bc262f9ed4828e71$export$2c3b404bf3a77a1f; });

var $bOXKQ = parcelRequire("bOXKQ");

var $b9FKP = parcelRequire("b9FKP");

var $ham3z = parcelRequire("ham3z");

var $8wHfp = parcelRequire("8wHfp");
async function $bc262f9ed4828e71$var$getItemsFromInitializer(container, map, initializers, force = false) {
    let res = map.get(container);
    if (!res || force) {
        res = await Promise.all([
            ...initializers.values()
        ].map((t)=>t(container)));
        map.set(container, res);
    }
    return res;
}
async function $bc262f9ed4828e71$var$getDataFromUrl(data) {
    const url = (0, $b9FKP.itemFromSingleOrMultiple)(data.url, data.index);
    if (!url) return data.fallback;
    const response = await fetch(url);
    if (response.ok) return await response.json();
    (0, $b9FKP.getLogger)().error(`${(0, $bOXKQ.errorPrefix)} ${response.status} while retrieving config file`);
    return data.fallback;
}

class $bc262f9ed4828e71$export$2c3b404bf3a77a1f {
    constructor(){
        this._configs = new Map();
        this._domArray = [];
        this._eventDispatcher = new (0, $ham3z.EventDispatcher)();
        this._initialized = false;
        this.plugins = [];
        this._initializers = {
            interactors: new Map(),
            movers: new Map(),
            updaters: new Map()
        };
        this.interactors = new Map();
        this.movers = new Map();
        this.updaters = new Map();
        this.presets = new Map();
        this.effectDrawers = new Map();
        this.shapeDrawers = new Map();
        this.pathGenerators = new Map();
    }
    get configs() {
        const res = {};
        for (const [name, config] of this._configs)res[name] = config;
        return res;
    }
    get version() {
        return "3.3.0";
    }
    addConfig(config) {
        const key = config.key ?? config.name ?? "default";
        this._configs.set(key, config);
        this._eventDispatcher.dispatchEvent("configAdded", {
            data: {
                name: key,
                config: config
            }
        });
    }
    async addEffect(effect, drawer, refresh = true) {
        (0, $b9FKP.executeOnSingleOrMultiple)(effect, (type)=>{
            if (!this.getEffectDrawer(type)) this.effectDrawers.set(type, drawer);
        });
        await this.refresh(refresh);
    }
    addEventListener(type, listener) {
        this._eventDispatcher.addEventListener(type, listener);
    }
    async addInteractor(name, interactorInitializer, refresh = true) {
        this._initializers.interactors.set(name, interactorInitializer);
        await this.refresh(refresh);
    }
    async addMover(name, moverInitializer, refresh = true) {
        this._initializers.movers.set(name, moverInitializer);
        await this.refresh(refresh);
    }
    async addParticleUpdater(name, updaterInitializer, refresh = true) {
        this._initializers.updaters.set(name, updaterInitializer);
        await this.refresh(refresh);
    }
    async addPathGenerator(name, generator, refresh = true) {
        if (!this.getPathGenerator(name)) this.pathGenerators.set(name, generator);
        await this.refresh(refresh);
    }
    async addPlugin(plugin, refresh = true) {
        if (!this.getPlugin(plugin.id)) this.plugins.push(plugin);
        await this.refresh(refresh);
    }
    async addPreset(preset, options, override = false, refresh = true) {
        if (override || !this.getPreset(preset)) this.presets.set(preset, options);
        await this.refresh(refresh);
    }
    async addShape(shape, drawer, refresh = true) {
        (0, $b9FKP.executeOnSingleOrMultiple)(shape, (type)=>{
            if (!this.getShapeDrawer(type)) this.shapeDrawers.set(type, drawer);
        });
        await this.refresh(refresh);
    }
    clearPlugins(container) {
        this.updaters.delete(container);
        this.movers.delete(container);
        this.interactors.delete(container);
    }
    dispatchEvent(type, args) {
        this._eventDispatcher.dispatchEvent(type, args);
    }
    dom() {
        return this._domArray;
    }
    domItem(index) {
        const dom = this.dom(), item = dom[index];
        if (!item || item.destroyed) {
            const deleteCount = 1;
            dom.splice(index, deleteCount);
            return;
        }
        return item;
    }
    async getAvailablePlugins(container) {
        const res = new Map();
        for (const plugin of this.plugins)if (plugin.needsPlugin(container.actualOptions)) res.set(plugin.id, await plugin.getPlugin(container));
        return res;
    }
    getEffectDrawer(type) {
        return this.effectDrawers.get(type);
    }
    async getInteractors(container, force = false) {
        return await $bc262f9ed4828e71$var$getItemsFromInitializer(container, this.interactors, this._initializers.interactors, force);
    }
    async getMovers(container, force = false) {
        return await $bc262f9ed4828e71$var$getItemsFromInitializer(container, this.movers, this._initializers.movers, force);
    }
    getPathGenerator(type) {
        return this.pathGenerators.get(type);
    }
    getPlugin(plugin) {
        return this.plugins.find((t)=>t.id === plugin);
    }
    getPreset(preset) {
        return this.presets.get(preset);
    }
    getShapeDrawer(type) {
        return this.shapeDrawers.get(type);
    }
    getSupportedEffects() {
        return this.effectDrawers.keys();
    }
    getSupportedShapes() {
        return this.shapeDrawers.keys();
    }
    async getUpdaters(container, force = false) {
        return await $bc262f9ed4828e71$var$getItemsFromInitializer(container, this.updaters, this._initializers.updaters, force);
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
    }
    async load(params) {
        const randomFactor = 10000, id = params.id ?? params.element?.id ?? `tsparticles${Math.floor((0, $8wHfp.getRandom)() * randomFactor)}`, { index: index, url: url } = params, options = url ? await $bc262f9ed4828e71$var$getDataFromUrl({
            fallback: params.options,
            url: url,
            index: index
        }) : params.options;
        let domContainer = params.element ?? document.getElementById(id);
        if (!domContainer) {
            domContainer = document.createElement("div");
            domContainer.id = id;
            document.body.append(domContainer);
        }
        const currentOptions = (0, $b9FKP.itemFromSingleOrMultiple)(options, index), dom = this.dom(), oldIndex = dom.findIndex((v)=>v.id.description === id), minIndex = 0;
        if (oldIndex >= minIndex) {
            const old = this.domItem(oldIndex);
            if (old && !old.destroyed) {
                old.destroy();
                const deleteCount = 1;
                dom.splice(oldIndex, deleteCount);
            }
        }
        let canvasEl;
        if (domContainer.tagName.toLowerCase() === "canvas") {
            canvasEl = domContainer;
            canvasEl.dataset[0, $bOXKQ.generatedAttribute] = "false";
        } else {
            const existingCanvases = domContainer.getElementsByTagName("canvas");
            if (existingCanvases.length) {
                const firstIndex = 0;
                canvasEl = existingCanvases[firstIndex];
                canvasEl.dataset[0, $bOXKQ.generatedAttribute] = "false";
            } else {
                canvasEl = document.createElement("canvas");
                canvasEl.dataset[0, $bOXKQ.generatedAttribute] = "true";
                domContainer.appendChild(canvasEl);
            }
        }
        if (!canvasEl.style.width) canvasEl.style.width = "100%";
        if (!canvasEl.style.height) canvasEl.style.height = "100%";
        const { Container: Container } = await (parcelRequire("fmKzn")), newItem = new Container(this, id, currentOptions);
        if (oldIndex >= minIndex) {
            const deleteCount = 0;
            dom.splice(oldIndex, deleteCount, newItem);
        } else dom.push(newItem);
        newItem.canvas.loadCanvas(canvasEl);
        await newItem.start();
        return newItem;
    }
    loadOptions(options, sourceOptions) {
        for (const plugin of this.plugins)plugin.loadOptions(options, sourceOptions);
    }
    loadParticlesOptions(container, options, ...sourceOptions) {
        const updaters = this.updaters.get(container);
        if (!updaters) return;
        for (const updater of updaters)updater.loadOptions?.(options, ...sourceOptions);
    }
    async refresh(refresh = true) {
        if (!refresh) return;
        await Promise.all(this.dom().map((t)=>t.refresh()));
    }
    removeEventListener(type, listener) {
        this._eventDispatcher.removeEventListener(type, listener);
    }
    setOnClickHandler(callback) {
        const dom = this.dom();
        if (!dom.length) throw new Error(`${(0, $bOXKQ.errorPrefix)} can only set click handlers after calling tsParticles.load()`);
        for (const domItem of dom)domItem.addClickHandler(callback);
    }
}

});
parcelRegister("bOXKQ", function(module, exports) {

$parcel$export(module.exports, "generatedAttribute", function () { return $89b2b741b4e51295$export$4a278486528d5cfb; });
$parcel$export(module.exports, "mouseDownEvent", function () { return $89b2b741b4e51295$export$9ffd73c9a0e32c34; });
$parcel$export(module.exports, "mouseUpEvent", function () { return $89b2b741b4e51295$export$9fb0268ce1bdbca0; });
$parcel$export(module.exports, "mouseLeaveEvent", function () { return $89b2b741b4e51295$export$f4b184a85a586f8a; });
$parcel$export(module.exports, "mouseOutEvent", function () { return $89b2b741b4e51295$export$55cc1d6a692feb2b; });
$parcel$export(module.exports, "mouseMoveEvent", function () { return $89b2b741b4e51295$export$1ffe551d7d33cd33; });
$parcel$export(module.exports, "touchStartEvent", function () { return $89b2b741b4e51295$export$d5353b6c79bbcc70; });
$parcel$export(module.exports, "touchEndEvent", function () { return $89b2b741b4e51295$export$11164630b85c192d; });
$parcel$export(module.exports, "touchMoveEvent", function () { return $89b2b741b4e51295$export$d28a82874c0e6212; });
$parcel$export(module.exports, "touchCancelEvent", function () { return $89b2b741b4e51295$export$65db1c69591947a7; });
$parcel$export(module.exports, "resizeEvent", function () { return $89b2b741b4e51295$export$8b3d73c91cd7cc65; });
$parcel$export(module.exports, "visibilityChangeEvent", function () { return $89b2b741b4e51295$export$73536144dc68dd0f; });
$parcel$export(module.exports, "errorPrefix", function () { return $89b2b741b4e51295$export$adea4917e02d93dc; });
$parcel$export(module.exports, "percentDenominator", function () { return $89b2b741b4e51295$export$9519bca7a9fbeccd; });
$parcel$export(module.exports, "halfRandom", function () { return $89b2b741b4e51295$export$fa0534be1c9f2e23; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $89b2b741b4e51295$export$f64c3bfbc58eec0f; });
const $89b2b741b4e51295$export$4a278486528d5cfb = "generated";
const $89b2b741b4e51295$export$9ffd73c9a0e32c34 = "pointerdown";
const $89b2b741b4e51295$export$9fb0268ce1bdbca0 = "pointerup";
const $89b2b741b4e51295$export$f4b184a85a586f8a = "pointerleave";
const $89b2b741b4e51295$export$55cc1d6a692feb2b = "pointerout";
const $89b2b741b4e51295$export$1ffe551d7d33cd33 = "pointermove";
const $89b2b741b4e51295$export$d5353b6c79bbcc70 = "touchstart";
const $89b2b741b4e51295$export$11164630b85c192d = "touchend";
const $89b2b741b4e51295$export$d28a82874c0e6212 = "touchmove";
const $89b2b741b4e51295$export$65db1c69591947a7 = "touchcancel";
const $89b2b741b4e51295$export$8b3d73c91cd7cc65 = "resize";
const $89b2b741b4e51295$export$73536144dc68dd0f = "visibilitychange";
const $89b2b741b4e51295$export$adea4917e02d93dc = "tsParticles - Error";
const $89b2b741b4e51295$export$9519bca7a9fbeccd = 100;
const $89b2b741b4e51295$export$fa0534be1c9f2e23 = 0.5;
const $89b2b741b4e51295$export$f64c3bfbc58eec0f = 1000;

});

parcelRegister("b9FKP", function(module, exports) {

$parcel$export(module.exports, "getLogger", function () { return $81f0ec7bcb657543$export$2b1d391cd05230fd; });
$parcel$export(module.exports, "executeOnSingleOrMultiple", function () { return $81f0ec7bcb657543$export$8e5dc47097396754; });
$parcel$export(module.exports, "isSsr", function () { return $81f0ec7bcb657543$export$460b6777813d3d86; });
$parcel$export(module.exports, "safeMatchMedia", function () { return $81f0ec7bcb657543$export$db32b9574e21e00f; });
$parcel$export(module.exports, "safeIntersectionObserver", function () { return $81f0ec7bcb657543$export$d97d2a93dce76cc2; });
$parcel$export(module.exports, "safeMutationObserver", function () { return $81f0ec7bcb657543$export$c2f9084a48da0641; });
$parcel$export(module.exports, "isInArray", function () { return $81f0ec7bcb657543$export$5e9bb4359042e24b; });
$parcel$export(module.exports, "loadFont", function () { return $81f0ec7bcb657543$export$672089c3debc1182; });
$parcel$export(module.exports, "arrayRandomIndex", function () { return $81f0ec7bcb657543$export$aab6d48e027939d7; });
$parcel$export(module.exports, "itemFromArray", function () { return $81f0ec7bcb657543$export$3a5d12ca7137122f; });
$parcel$export(module.exports, "isPointInside", function () { return $81f0ec7bcb657543$export$2ea42ef493c7076c; });
$parcel$export(module.exports, "calculateBounds", function () { return $81f0ec7bcb657543$export$b0a2169b5f9d18d8; });
$parcel$export(module.exports, "deepExtend", function () { return $81f0ec7bcb657543$export$54e9fb29908872fa; });
$parcel$export(module.exports, "isDivModeEnabled", function () { return $81f0ec7bcb657543$export$5d1f020956707f4; });
$parcel$export(module.exports, "divModeExecute", function () { return $81f0ec7bcb657543$export$194f9554360903fd; });
$parcel$export(module.exports, "divMode", function () { return $81f0ec7bcb657543$export$f7c2b83aad443adb; });
$parcel$export(module.exports, "circleBounceDataFromParticle", function () { return $81f0ec7bcb657543$export$11ae16f2acc5c3ba; });
$parcel$export(module.exports, "circleBounce", function () { return $81f0ec7bcb657543$export$c6e9f28fb57ea828; });
$parcel$export(module.exports, "rectBounce", function () { return $81f0ec7bcb657543$export$e83851ba31840182; });
$parcel$export(module.exports, "itemFromSingleOrMultiple", function () { return $81f0ec7bcb657543$export$3fbf39566d3ee62e; });
$parcel$export(module.exports, "initParticleNumericAnimationValue", function () { return $81f0ec7bcb657543$export$bebd78259cce4fd; });
$parcel$export(module.exports, "getPosition", function () { return $81f0ec7bcb657543$export$1690e12b840569b9; });
$parcel$export(module.exports, "getSize", function () { return $81f0ec7bcb657543$export$31b21d0167753bb4; });
$parcel$export(module.exports, "updateAnimation", function () { return $81f0ec7bcb657543$export$efead17ed5dcfd2; });

var $8wHfp = parcelRequire("8wHfp");

var $bOXKQ = parcelRequire("bOXKQ");

var $1Cbg8 = parcelRequire("1Cbg8");

var $jpo9d = parcelRequire("jpo9d");
const $81f0ec7bcb657543$var$_logger = {
    debug: console.debug,
    error: console.error,
    info: console.info,
    log: console.log,
    verbose: console.log,
    warning: console.warn
};
function $81f0ec7bcb657543$export$3abbd92f765bee58(logger) {
    $81f0ec7bcb657543$var$_logger.debug = logger.debug || $81f0ec7bcb657543$var$_logger.debug;
    $81f0ec7bcb657543$var$_logger.error = logger.error || $81f0ec7bcb657543$var$_logger.error;
    $81f0ec7bcb657543$var$_logger.info = logger.info || $81f0ec7bcb657543$var$_logger.info;
    $81f0ec7bcb657543$var$_logger.log = logger.log || $81f0ec7bcb657543$var$_logger.log;
    $81f0ec7bcb657543$var$_logger.verbose = logger.verbose || $81f0ec7bcb657543$var$_logger.verbose;
    $81f0ec7bcb657543$var$_logger.warning = logger.warning || $81f0ec7bcb657543$var$_logger.warning;
}
function $81f0ec7bcb657543$export$2b1d391cd05230fd() {
    return $81f0ec7bcb657543$var$_logger;
}
function $81f0ec7bcb657543$var$rectSideBounce(data) {
    const res = {
        bounced: false
    }, { pSide: pSide, pOtherSide: pOtherSide, rectSide: rectSide, rectOtherSide: rectOtherSide, velocity: velocity, factor: factor } = data, half = 0.5, minVelocity = 0;
    if (pOtherSide.min < rectOtherSide.min || pOtherSide.min > rectOtherSide.max || pOtherSide.max < rectOtherSide.min || pOtherSide.max > rectOtherSide.max) return res;
    if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) * half && velocity > minVelocity || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) * half && velocity < minVelocity) {
        res.velocity = velocity * -factor;
        res.bounced = true;
    }
    return res;
}
function $81f0ec7bcb657543$var$checkSelector(element, selectors) {
    const res = $81f0ec7bcb657543$export$8e5dc47097396754(selectors, (selector)=>{
        return element.matches(selector);
    });
    return (0, $1Cbg8.isArray)(res) ? res.some((t)=>t) : res;
}
function $81f0ec7bcb657543$export$460b6777813d3d86() {
    return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
function $81f0ec7bcb657543$export$c242851ed0beda6c() {
    return !$81f0ec7bcb657543$export$460b6777813d3d86() && typeof matchMedia !== "undefined";
}
function $81f0ec7bcb657543$export$db32b9574e21e00f(query) {
    if (!$81f0ec7bcb657543$export$c242851ed0beda6c()) return;
    return matchMedia(query);
}
function $81f0ec7bcb657543$export$d97d2a93dce76cc2(callback) {
    if ($81f0ec7bcb657543$export$460b6777813d3d86() || typeof IntersectionObserver === "undefined") return;
    return new IntersectionObserver(callback);
}
function $81f0ec7bcb657543$export$c2f9084a48da0641(callback) {
    if ($81f0ec7bcb657543$export$460b6777813d3d86() || typeof MutationObserver === "undefined") return;
    return new MutationObserver(callback);
}
function $81f0ec7bcb657543$export$5e9bb4359042e24b(value, array) {
    const invalidIndex = -1;
    return value === array || (0, $1Cbg8.isArray)(array) && array.indexOf(value) > invalidIndex;
}
async function $81f0ec7bcb657543$export$672089c3debc1182(font, weight) {
    try {
        await document.fonts.load(`${weight ?? "400"} 36px '${font ?? "Verdana"}'`);
    } catch  {}
}
function $81f0ec7bcb657543$export$aab6d48e027939d7(array) {
    return Math.floor((0, $8wHfp.getRandom)() * array.length);
}
function $81f0ec7bcb657543$export$3a5d12ca7137122f(array, index, useIndex = true) {
    return array[index !== undefined && useIndex ? index % array.length : $81f0ec7bcb657543$export$aab6d48e027939d7(array)];
}
function $81f0ec7bcb657543$export$2ea42ef493c7076c(point, size, offset, radius, direction) {
    const minRadius = 0;
    return $81f0ec7bcb657543$export$bb47d4799bdb9a4d($81f0ec7bcb657543$export$b0a2169b5f9d18d8(point, radius ?? minRadius), size, offset, direction);
}
function $81f0ec7bcb657543$export$bb47d4799bdb9a4d(bounds, size, offset, direction) {
    let inside = true;
    if (!direction || direction === "bottom") inside = bounds.top < size.height + offset.x;
    if (inside && (!direction || direction === "left")) inside = bounds.right > offset.x;
    if (inside && (!direction || direction === "right")) inside = bounds.left < size.width + offset.y;
    if (inside && (!direction || direction === "top")) inside = bounds.bottom > offset.y;
    return inside;
}
function $81f0ec7bcb657543$export$b0a2169b5f9d18d8(point, radius) {
    return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius
    };
}
function $81f0ec7bcb657543$export$54e9fb29908872fa(destination, ...sources) {
    for (const source of sources){
        if (source === undefined || source === null) continue;
        if (!(0, $1Cbg8.isObject)(source)) {
            destination = source;
            continue;
        }
        const sourceIsArray = Array.isArray(source);
        if (sourceIsArray && ((0, $1Cbg8.isObject)(destination) || !destination || !Array.isArray(destination))) destination = [];
        else if (!sourceIsArray && ((0, $1Cbg8.isObject)(destination) || !destination || Array.isArray(destination))) destination = {};
        for(const key in source){
            if (key === "__proto__") continue;
            const sourceDict = source, value = sourceDict[key], destDict = destination;
            destDict[key] = (0, $1Cbg8.isObject)(value) && Array.isArray(value) ? value.map((v)=>$81f0ec7bcb657543$export$54e9fb29908872fa(destDict[key], v)) : $81f0ec7bcb657543$export$54e9fb29908872fa(destDict[key], value);
        }
    }
    return destination;
}
function $81f0ec7bcb657543$export$5d1f020956707f4(mode, divs) {
    return !!$81f0ec7bcb657543$export$bfd133b0f67a5a3a(divs, (t)=>t.enable && $81f0ec7bcb657543$export$5e9bb4359042e24b(mode, t.mode));
}
function $81f0ec7bcb657543$export$194f9554360903fd(mode, divs, callback) {
    $81f0ec7bcb657543$export$8e5dc47097396754(divs, (div)=>{
        const divMode = div.mode, divEnabled = div.enable;
        if (divEnabled && $81f0ec7bcb657543$export$5e9bb4359042e24b(mode, divMode)) $81f0ec7bcb657543$export$921eaa53ee8b79db(div, callback);
    });
}
function $81f0ec7bcb657543$export$921eaa53ee8b79db(div, callback) {
    const selectors = div.selectors;
    $81f0ec7bcb657543$export$8e5dc47097396754(selectors, (selector)=>{
        callback(selector, div);
    });
}
function $81f0ec7bcb657543$export$f7c2b83aad443adb(divs, element) {
    if (!element || !divs) return;
    return $81f0ec7bcb657543$export$bfd133b0f67a5a3a(divs, (div)=>{
        return $81f0ec7bcb657543$var$checkSelector(element, div.selectors);
    });
}
function $81f0ec7bcb657543$export$11ae16f2acc5c3ba(p) {
    return {
        position: p.getPosition(),
        radius: p.getRadius(),
        mass: p.getMass(),
        velocity: p.velocity,
        factor: (0, $jpo9d.Vector).create((0, $8wHfp.getRangeValue)(p.options.bounce.horizontal.value), (0, $8wHfp.getRangeValue)(p.options.bounce.vertical.value))
    };
}
function $81f0ec7bcb657543$export$c6e9f28fb57ea828(p1, p2) {
    const { x: xVelocityDiff, y: yVelocityDiff } = p1.velocity.sub(p2.velocity), [pos1, pos2] = [
        p1.position,
        p2.position
    ], { dx: xDist, dy: yDist } = (0, $8wHfp.getDistances)(pos2, pos1), minimumDistance = 0;
    if (xVelocityDiff * xDist + yVelocityDiff * yDist < minimumDistance) return;
    const angle = -Math.atan2(yDist, xDist), m1 = p1.mass, m2 = p2.mass, u1 = p1.velocity.rotate(angle), u2 = p2.velocity.rotate(angle), v1 = (0, $8wHfp.collisionVelocity)(u1, u2, m1, m2), v2 = (0, $8wHfp.collisionVelocity)(u2, u1, m1, m2), vFinal1 = v1.rotate(-angle), vFinal2 = v2.rotate(-angle);
    p1.velocity.x = vFinal1.x * p1.factor.x;
    p1.velocity.y = vFinal1.y * p1.factor.y;
    p2.velocity.x = vFinal2.x * p2.factor.x;
    p2.velocity.y = vFinal2.y * p2.factor.y;
}
function $81f0ec7bcb657543$export$e83851ba31840182(particle, divBounds) {
    const pPos = particle.getPosition(), size = particle.getRadius(), bounds = $81f0ec7bcb657543$export$b0a2169b5f9d18d8(pPos, size), bounceOptions = particle.options.bounce, resH = $81f0ec7bcb657543$var$rectSideBounce({
        pSide: {
            min: bounds.left,
            max: bounds.right
        },
        pOtherSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        rectSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        rectOtherSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        velocity: particle.velocity.x,
        factor: (0, $8wHfp.getRangeValue)(bounceOptions.horizontal.value)
    });
    if (resH.bounced) {
        if (resH.velocity !== undefined) particle.velocity.x = resH.velocity;
        if (resH.position !== undefined) particle.position.x = resH.position;
    }
    const resV = $81f0ec7bcb657543$var$rectSideBounce({
        pSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        pOtherSide: {
            min: bounds.left,
            max: bounds.right
        },
        rectSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        rectOtherSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        velocity: particle.velocity.y,
        factor: (0, $8wHfp.getRangeValue)(bounceOptions.vertical.value)
    });
    if (resV.bounced) {
        if (resV.velocity !== undefined) particle.velocity.y = resV.velocity;
        if (resV.position !== undefined) particle.position.y = resV.position;
    }
}
function $81f0ec7bcb657543$export$8e5dc47097396754(obj, callback) {
    const defaultIndex = 0;
    return (0, $1Cbg8.isArray)(obj) ? obj.map((item, index)=>callback(item, index)) : callback(obj, defaultIndex);
}
function $81f0ec7bcb657543$export$3fbf39566d3ee62e(obj, index, useIndex) {
    return (0, $1Cbg8.isArray)(obj) ? $81f0ec7bcb657543$export$3a5d12ca7137122f(obj, index, useIndex) : obj;
}
function $81f0ec7bcb657543$export$bfd133b0f67a5a3a(obj, callback) {
    if ((0, $1Cbg8.isArray)(obj)) return obj.find((t, index)=>callback(t, index));
    const defaultIndex = 0;
    return callback(obj, defaultIndex) ? obj : undefined;
}
function $81f0ec7bcb657543$export$bebd78259cce4fd(options, pxRatio) {
    const valueRange = options.value, animationOptions = options.animation, res = {
        delayTime: (0, $8wHfp.getRangeValue)(animationOptions.delay) * (0, $bOXKQ.millisecondsToSeconds),
        enable: animationOptions.enable,
        value: (0, $8wHfp.getRangeValue)(options.value) * pxRatio,
        max: (0, $8wHfp.getRangeMax)(valueRange) * pxRatio,
        min: (0, $8wHfp.getRangeMin)(valueRange) * pxRatio,
        loops: 0,
        maxLoops: (0, $8wHfp.getRangeValue)(animationOptions.count),
        time: 0
    }, decayOffset = 1;
    if (animationOptions.enable) {
        res.decay = decayOffset - (0, $8wHfp.getRangeValue)(animationOptions.decay);
        switch(animationOptions.mode){
            case "increase":
                res.status = "increasing";
                break;
            case "decrease":
                res.status = "decreasing";
                break;
            case "random":
                res.status = (0, $8wHfp.getRandom)() >= (0, $bOXKQ.halfRandom) ? "increasing" : "decreasing";
                break;
        }
        const autoStatus = animationOptions.mode === "auto";
        switch(animationOptions.startValue){
            case "min":
                res.value = res.min;
                if (autoStatus) res.status = "increasing";
                break;
            case "max":
                res.value = res.max;
                if (autoStatus) res.status = "decreasing";
                break;
            case "random":
            default:
                res.value = (0, $8wHfp.randomInRange)(res);
                if (autoStatus) res.status = (0, $8wHfp.getRandom)() >= (0, $bOXKQ.halfRandom) ? "increasing" : "decreasing";
                break;
        }
    }
    res.initialValue = res.value;
    return res;
}
function $81f0ec7bcb657543$var$getPositionOrSize(positionOrSize, canvasSize) {
    const isPercent = positionOrSize.mode === "percent";
    if (!isPercent) {
        const { mode: _, ...rest } = positionOrSize;
        return rest;
    }
    const isPosition = "x" in positionOrSize;
    if (isPosition) return {
        x: positionOrSize.x / (0, $bOXKQ.percentDenominator) * canvasSize.width,
        y: positionOrSize.y / (0, $bOXKQ.percentDenominator) * canvasSize.height
    };
    else return {
        width: positionOrSize.width / (0, $bOXKQ.percentDenominator) * canvasSize.width,
        height: positionOrSize.height / (0, $bOXKQ.percentDenominator) * canvasSize.height
    };
}
function $81f0ec7bcb657543$export$1690e12b840569b9(position, canvasSize) {
    return $81f0ec7bcb657543$var$getPositionOrSize(position, canvasSize);
}
function $81f0ec7bcb657543$export$31b21d0167753bb4(size, canvasSize) {
    return $81f0ec7bcb657543$var$getPositionOrSize(size, canvasSize);
}
function $81f0ec7bcb657543$var$checkDestroy(particle, destroyType, value, minValue, maxValue) {
    switch(destroyType){
        case "max":
            if (value >= maxValue) particle.destroy();
            break;
        case "min":
            if (value <= minValue) particle.destroy();
            break;
    }
}
function $81f0ec7bcb657543$export$efead17ed5dcfd2(particle, data, changeDirection, destroyType, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minDecay = 1;
    if (particle.destroyed || !data || !data.enable || (data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops)) return;
    const velocity = (data.velocity ?? minVelocity) * delta.factor, minValue = data.min, maxValue = data.max, decay = data.decay ?? minDecay;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) data.time += delta.value;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) return;
    switch(data.status){
        case "increasing":
            if (data.value >= maxValue) {
                if (changeDirection) data.status = "decreasing";
                else data.value -= maxValue;
                if (!data.loops) data.loops = minLoops;
                data.loops++;
            } else data.value += velocity;
            break;
        case "decreasing":
            if (data.value <= minValue) {
                if (changeDirection) data.status = "increasing";
                else data.value += maxValue;
                if (!data.loops) data.loops = minLoops;
                data.loops++;
            } else data.value -= velocity;
    }
    if (data.velocity && decay !== identity) data.velocity *= decay;
    $81f0ec7bcb657543$var$checkDestroy(particle, destroyType, data.value, minValue, maxValue);
    if (!particle.destroyed) data.value = (0, $8wHfp.clamp)(data.value, minValue, maxValue);
}

});
parcelRegister("8wHfp", function(module, exports) {

$parcel$export(module.exports, "addEasing", function () { return $6352dbf6c3aca25f$export$e2251c95822ce867; });
$parcel$export(module.exports, "getEasing", function () { return $6352dbf6c3aca25f$export$2bbf531f74195405; });
$parcel$export(module.exports, "getRandom", function () { return $6352dbf6c3aca25f$export$1a76347094524b3b; });
$parcel$export(module.exports, "clamp", function () { return $6352dbf6c3aca25f$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "mix", function () { return $6352dbf6c3aca25f$export$2c9e8a9632a706b2; });
$parcel$export(module.exports, "randomInRange", function () { return $6352dbf6c3aca25f$export$8b958c8ecd94a804; });
$parcel$export(module.exports, "getRangeMax", function () { return $6352dbf6c3aca25f$export$27d2c76f835d583d; });
$parcel$export(module.exports, "getRangeMin", function () { return $6352dbf6c3aca25f$export$71c94d28c0fa4bfe; });
$parcel$export(module.exports, "getRangeValue", function () { return $6352dbf6c3aca25f$export$e70c64b68236cb4e; });
$parcel$export(module.exports, "setRangeValue", function () { return $6352dbf6c3aca25f$export$6dcd5a07b989db7; });
$parcel$export(module.exports, "getDistances", function () { return $6352dbf6c3aca25f$export$c76b58cfe053f228; });
$parcel$export(module.exports, "getDistance", function () { return $6352dbf6c3aca25f$export$79376507b09a66f; });
$parcel$export(module.exports, "degToRad", function () { return $6352dbf6c3aca25f$export$e6bfdeff8bfc94f9; });
$parcel$export(module.exports, "getParticleDirectionAngle", function () { return $6352dbf6c3aca25f$export$2045f76df51d18c4; });
$parcel$export(module.exports, "getParticleBaseVelocity", function () { return $6352dbf6c3aca25f$export$cce6f12debc4024a; });
$parcel$export(module.exports, "collisionVelocity", function () { return $6352dbf6c3aca25f$export$ee2fb97c67882d88; });
$parcel$export(module.exports, "calcPositionOrRandomFromSize", function () { return $6352dbf6c3aca25f$export$b19bedb83d642783; });
$parcel$export(module.exports, "calcPositionOrRandomFromSizeRanged", function () { return $6352dbf6c3aca25f$export$b6e437e0d75e3d2c; });
$parcel$export(module.exports, "calcExactPositionOrRandomFromSize", function () { return $6352dbf6c3aca25f$export$a3c87c98a736c457; });
$parcel$export(module.exports, "parseAlpha", function () { return $6352dbf6c3aca25f$export$988633967de92230; });

var $jpo9d = parcelRequire("jpo9d");

var $1Cbg8 = parcelRequire("1Cbg8");

var $bOXKQ = parcelRequire("bOXKQ");
let $6352dbf6c3aca25f$var$_random = Math.random;
const $6352dbf6c3aca25f$var$easings = new Map(), $6352dbf6c3aca25f$var$double = 2, $6352dbf6c3aca25f$var$doublePI = Math.PI * $6352dbf6c3aca25f$var$double;
function $6352dbf6c3aca25f$export$e2251c95822ce867(name, easing) {
    if ($6352dbf6c3aca25f$var$easings.get(name)) return;
    $6352dbf6c3aca25f$var$easings.set(name, easing);
}
function $6352dbf6c3aca25f$export$2bbf531f74195405(name) {
    return $6352dbf6c3aca25f$var$easings.get(name) ?? ((value)=>value);
}
function $6352dbf6c3aca25f$export$3ba5cb2c014ef7d5(rnd = Math.random) {
    $6352dbf6c3aca25f$var$_random = rnd;
}
function $6352dbf6c3aca25f$export$1a76347094524b3b() {
    const min = 0, max = 1;
    return $6352dbf6c3aca25f$export$7d15b64cf5a3a4c4($6352dbf6c3aca25f$var$_random(), min, max - Number.EPSILON);
}
function $6352dbf6c3aca25f$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $6352dbf6c3aca25f$export$2c9e8a9632a706b2(comp1, comp2, weight1, weight2) {
    return Math.floor((comp1 * weight1 + comp2 * weight2) / (weight1 + weight2));
}
function $6352dbf6c3aca25f$export$8b958c8ecd94a804(r) {
    const max = $6352dbf6c3aca25f$export$27d2c76f835d583d(r), minOffset = 0;
    let min = $6352dbf6c3aca25f$export$71c94d28c0fa4bfe(r);
    if (max === min) min = minOffset;
    return $6352dbf6c3aca25f$export$1a76347094524b3b() * (max - min) + min;
}
function $6352dbf6c3aca25f$export$e70c64b68236cb4e(value) {
    return (0, $1Cbg8.isNumber)(value) ? value : $6352dbf6c3aca25f$export$8b958c8ecd94a804(value);
}
function $6352dbf6c3aca25f$export$71c94d28c0fa4bfe(value) {
    return (0, $1Cbg8.isNumber)(value) ? value : value.min;
}
function $6352dbf6c3aca25f$export$27d2c76f835d583d(value) {
    return (0, $1Cbg8.isNumber)(value) ? value : value.max;
}
function $6352dbf6c3aca25f$export$6dcd5a07b989db7(source, value) {
    if (source === value || value === undefined && (0, $1Cbg8.isNumber)(source)) return source;
    const min = $6352dbf6c3aca25f$export$71c94d28c0fa4bfe(source), max = $6352dbf6c3aca25f$export$27d2c76f835d583d(source);
    return value !== undefined ? {
        min: Math.min(min, value),
        max: Math.max(max, value)
    } : $6352dbf6c3aca25f$export$6dcd5a07b989db7(min, max);
}
function $6352dbf6c3aca25f$export$c76b58cfe053f228(pointA, pointB) {
    const dx = pointA.x - pointB.x, dy = pointA.y - pointB.y, squareExp = 2;
    return {
        dx: dx,
        dy: dy,
        distance: Math.sqrt(dx ** squareExp + dy ** squareExp)
    };
}
function $6352dbf6c3aca25f$export$79376507b09a66f(pointA, pointB) {
    return $6352dbf6c3aca25f$export$c76b58cfe053f228(pointA, pointB).distance;
}
function $6352dbf6c3aca25f$export$e6bfdeff8bfc94f9(degrees) {
    const PIDeg = 180;
    return degrees * Math.PI / PIDeg;
}
function $6352dbf6c3aca25f$export$2045f76df51d18c4(direction, position, center) {
    if ((0, $1Cbg8.isNumber)(direction)) return $6352dbf6c3aca25f$export$e6bfdeff8bfc94f9(direction);
    const empty = 0, half = 0.5, quarter = 0.25, threeQuarter = half + quarter;
    switch(direction){
        case "top":
            return -Math.PI * half;
        case "top-right":
            return -Math.PI * quarter;
        case "right":
            return empty;
        case "bottom-right":
            return Math.PI * quarter;
        case "bottom":
            return Math.PI * half;
        case "bottom-left":
            return Math.PI * threeQuarter;
        case "left":
            return Math.PI;
        case "top-left":
            return -Math.PI * threeQuarter;
        case "inside":
            return Math.atan2(center.y - position.y, center.x - position.x);
        case "outside":
            return Math.atan2(position.y - center.y, position.x - center.x);
        default:
            return $6352dbf6c3aca25f$export$1a76347094524b3b() * $6352dbf6c3aca25f$var$doublePI;
    }
}
function $6352dbf6c3aca25f$export$cce6f12debc4024a(direction) {
    const baseVelocity = (0, $jpo9d.Vector).origin;
    baseVelocity.length = 1;
    baseVelocity.angle = direction;
    return baseVelocity;
}
function $6352dbf6c3aca25f$export$ee2fb97c67882d88(v1, v2, m1, m2) {
    const double = 2;
    return (0, $jpo9d.Vector).create(v1.x * (m1 - m2) / (m1 + m2) + v2.x * double * m2 / (m1 + m2), v1.y);
}
function $6352dbf6c3aca25f$export$3cb8a699840fed18(data) {
    return data.position?.x !== undefined && data.position.y !== undefined ? {
        x: data.position.x * data.size.width / (0, $bOXKQ.percentDenominator),
        y: data.position.y * data.size.height / (0, $bOXKQ.percentDenominator)
    } : undefined;
}
function $6352dbf6c3aca25f$export$b19bedb83d642783(data) {
    return {
        x: (data.position?.x ?? $6352dbf6c3aca25f$export$1a76347094524b3b() * (0, $bOXKQ.percentDenominator)) * data.size.width / (0, $bOXKQ.percentDenominator),
        y: (data.position?.y ?? $6352dbf6c3aca25f$export$1a76347094524b3b() * (0, $bOXKQ.percentDenominator)) * data.size.height / (0, $bOXKQ.percentDenominator)
    };
}
function $6352dbf6c3aca25f$export$b6e437e0d75e3d2c(data) {
    const position = {
        x: data.position?.x !== undefined ? $6352dbf6c3aca25f$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $6352dbf6c3aca25f$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $6352dbf6c3aca25f$export$b19bedb83d642783({
        size: data.size,
        position: position
    });
}
function $6352dbf6c3aca25f$export$a3c87c98a736c457(data) {
    return {
        x: data.position?.x ?? $6352dbf6c3aca25f$export$1a76347094524b3b() * data.size.width,
        y: data.position?.y ?? $6352dbf6c3aca25f$export$1a76347094524b3b() * data.size.height
    };
}
function $6352dbf6c3aca25f$export$30970e96ab2e23ee(data) {
    const position = {
        x: data.position?.x !== undefined ? $6352dbf6c3aca25f$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $6352dbf6c3aca25f$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $6352dbf6c3aca25f$export$a3c87c98a736c457({
        size: data.size,
        position: position
    });
}
function $6352dbf6c3aca25f$export$988633967de92230(input) {
    const defaultAlpha = 1;
    if (!input) return defaultAlpha;
    return input.endsWith("%") ? parseFloat(input) / (0, $bOXKQ.percentDenominator) : parseFloat(input);
}

});
parcelRegister("jpo9d", function(module, exports) {

$parcel$export(module.exports, "Vector3d", function () { return $e2131559d0a96365$export$ece015703618ce3d; });
$parcel$export(module.exports, "Vector", function () { return $e2131559d0a96365$export$9b781de7bf37bf48; });

var $bOXKQ = parcelRequire("bOXKQ");

var $1Cbg8 = parcelRequire("1Cbg8");
const $e2131559d0a96365$var$origin = {
    x: 0,
    y: 0,
    z: 0
}, $e2131559d0a96365$var$squareExp = 2, $e2131559d0a96365$var$inverseFactorNumerator = 1.0;
class $e2131559d0a96365$export$ece015703618ce3d {
    constructor(xOrCoords, y, z){
        this._updateFromAngle = (angle, length)=>{
            this.x = Math.cos(angle) * length;
            this.y = Math.sin(angle) * length;
        };
        if (!(0, $1Cbg8.isNumber)(xOrCoords) && xOrCoords) {
            this.x = xOrCoords.x;
            this.y = xOrCoords.y;
            const coords3d = xOrCoords;
            this.z = coords3d.z ? coords3d.z : $e2131559d0a96365$var$origin.z;
        } else if (xOrCoords !== undefined && y !== undefined) {
            this.x = xOrCoords;
            this.y = y;
            this.z = z ?? $e2131559d0a96365$var$origin.z;
        } else throw new Error(`${(0, $bOXKQ.errorPrefix)} Vector3d not initialized correctly`);
    }
    static get origin() {
        return $e2131559d0a96365$export$ece015703618ce3d.create($e2131559d0a96365$var$origin.x, $e2131559d0a96365$var$origin.y, $e2131559d0a96365$var$origin.z);
    }
    get angle() {
        return Math.atan2(this.y, this.x);
    }
    set angle(angle) {
        this._updateFromAngle(angle, this.length);
    }
    get length() {
        return Math.sqrt(this.getLengthSq());
    }
    set length(length) {
        this._updateFromAngle(this.angle, length);
    }
    static clone(source) {
        return $e2131559d0a96365$export$ece015703618ce3d.create(source.x, source.y, source.z);
    }
    static create(x, y, z) {
        return new $e2131559d0a96365$export$ece015703618ce3d(x, y, z);
    }
    add(v) {
        return $e2131559d0a96365$export$ece015703618ce3d.create(this.x + v.x, this.y + v.y, this.z + v.z);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
    }
    copy() {
        return $e2131559d0a96365$export$ece015703618ce3d.clone(this);
    }
    distanceTo(v) {
        return this.sub(v).length;
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    div(n) {
        return $e2131559d0a96365$export$ece015703618ce3d.create(this.x / n, this.y / n, this.z / n);
    }
    divTo(n) {
        this.x /= n;
        this.y /= n;
        this.z /= n;
    }
    getLengthSq() {
        return this.x ** $e2131559d0a96365$var$squareExp + this.y ** $e2131559d0a96365$var$squareExp;
    }
    mult(n) {
        return $e2131559d0a96365$export$ece015703618ce3d.create(this.x * n, this.y * n, this.z * n);
    }
    multTo(n) {
        this.x *= n;
        this.y *= n;
        this.z *= n;
    }
    normalize() {
        const length = this.length, noLength = 0;
        if (length != noLength) this.multTo($e2131559d0a96365$var$inverseFactorNumerator / length);
    }
    rotate(angle) {
        return $e2131559d0a96365$export$ece015703618ce3d.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle), $e2131559d0a96365$var$origin.z);
    }
    setTo(c) {
        this.x = c.x;
        this.y = c.y;
        const v3d = c;
        this.z = v3d.z ? v3d.z : $e2131559d0a96365$var$origin.z;
    }
    sub(v) {
        return $e2131559d0a96365$export$ece015703618ce3d.create(this.x - v.x, this.y - v.y, this.z - v.z);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
    }
}
class $e2131559d0a96365$export$9b781de7bf37bf48 extends $e2131559d0a96365$export$ece015703618ce3d {
    constructor(xOrCoords, y){
        super(xOrCoords, y, $e2131559d0a96365$var$origin.z);
    }
    static get origin() {
        return $e2131559d0a96365$export$9b781de7bf37bf48.create($e2131559d0a96365$var$origin.x, $e2131559d0a96365$var$origin.y);
    }
    static clone(source) {
        return $e2131559d0a96365$export$9b781de7bf37bf48.create(source.x, source.y);
    }
    static create(x, y) {
        return new $e2131559d0a96365$export$9b781de7bf37bf48(x, y);
    }
}

});
parcelRegister("1Cbg8", function(module, exports) {

$parcel$export(module.exports, "isBoolean", function () { return $12d212e4f8b4e983$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isString", function () { return $12d212e4f8b4e983$export$844ec244b1367d54; });
$parcel$export(module.exports, "isNumber", function () { return $12d212e4f8b4e983$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isObject", function () { return $12d212e4f8b4e983$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isArray", function () { return $12d212e4f8b4e983$export$43bee75e5e14138e; });
function $12d212e4f8b4e983$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $12d212e4f8b4e983$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $12d212e4f8b4e983$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $12d212e4f8b4e983$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $12d212e4f8b4e983$export$a6cdc56e425d0d0a(arg) {
    return typeof arg === "object" && arg !== null;
}
function $12d212e4f8b4e983$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}

});




parcelRegister("ham3z", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", function () { return $c7f47ad328a8f8ce$export$ec8b666c5fe2c75a; });
class $c7f47ad328a8f8ce$export$ec8b666c5fe2c75a {
    constructor(){
        this._listeners = new Map();
    }
    addEventListener(type, listener) {
        this.removeEventListener(type, listener);
        let arr = this._listeners.get(type);
        if (!arr) {
            arr = [];
            this._listeners.set(type, arr);
        }
        arr.push(listener);
    }
    dispatchEvent(type, args) {
        const listeners = this._listeners.get(type);
        listeners?.forEach((handler)=>handler(args));
    }
    hasEventListener(type) {
        return !!this._listeners.get(type);
    }
    removeAllEventListeners(type) {
        if (!type) this._listeners = new Map();
        else this._listeners.delete(type);
    }
    removeEventListener(type, listener) {
        const arr = this._listeners.get(type);
        if (!arr) return;
        const length = arr.length, idx = arr.indexOf(listener), minIndex = 0;
        if (idx < minIndex) return;
        const deleteCount = 1;
        if (length === deleteCount) this._listeners.delete(type);
        else arr.splice(idx, deleteCount);
    }
}

});

parcelRegister("fmKzn", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("hcPmM")).then(()=>parcelRequire("l24ZZ"));

});
parcelRegister("hKRz6", function(module, exports) {
"use strict";

var $6Ul3Y = parcelRequire("6Ul3Y");
module.exports = $6Ul3Y(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("6Ul3Y", function(module, exports) {
"use strict";
var $50784fb691a02955$var$cachedBundles = {};
var $50784fb691a02955$var$cachedPreloads = {};
var $50784fb691a02955$var$cachedPrefetches = {};
function $50784fb691a02955$var$getCache(type) {
    switch(type){
        case "preload":
            return $50784fb691a02955$var$cachedPreloads;
        case "prefetch":
            return $50784fb691a02955$var$cachedPrefetches;
        default:
            return $50784fb691a02955$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $50784fb691a02955$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("1dkw8", function(module, exports) {

$parcel$export(module.exports, "HslColorManager", function () { return $0e26eba73b9c9ba4$export$a0d665b8e8138206; });

var $8wHfp = parcelRequire("8wHfp");

var $lr6PC = parcelRequire("lr6PC");
class $0e26eba73b9c9ba4$export$a0d665b8e8138206 {
    constructor(){
        this.key = "hsl";
        this.stringPrefix = "hsl";
    }
    handleColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.s !== undefined && hslColor.l !== undefined) return (0, $lr6PC.hslToRgb)(hslColor);
    }
    handleRangeColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.l !== undefined) return (0, $lr6PC.hslToRgb)({
            h: (0, $8wHfp.getRangeValue)(hslColor.h),
            l: (0, $8wHfp.getRangeValue)(hslColor.l),
            s: (0, $8wHfp.getRangeValue)(hslColor.s)
        });
    }
    parseString(input) {
        if (!input.startsWith("hsl")) return;
        const regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), minLength = 4, defaultAlpha = 1, radix = 10;
        return result ? (0, $lr6PC.hslaToRgba)({
            a: result.length > minLength ? (0, $8wHfp.parseAlpha)(result[5]) : defaultAlpha,
            h: parseInt(result[1], radix),
            l: parseInt(result[3], radix),
            s: parseInt(result[2], radix)
        }) : undefined;
    }
}

});
parcelRegister("lr6PC", function(module, exports) {

$parcel$export(module.exports, "addColorManager", function () { return $f9b16b2dd914cf90$export$fac4919b23cbaf23; });
$parcel$export(module.exports, "rangeColorToRgb", function () { return $f9b16b2dd914cf90$export$fbf0bf3cc1fc0cc4; });
$parcel$export(module.exports, "rgbToHsl", function () { return $f9b16b2dd914cf90$export$c85ca4f4753af384; });
$parcel$export(module.exports, "rangeColorToHsl", function () { return $f9b16b2dd914cf90$export$79a89086521c0f12; });
$parcel$export(module.exports, "hslToRgb", function () { return $f9b16b2dd914cf90$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "hslaToRgba", function () { return $f9b16b2dd914cf90$export$6ae64dbcd6bfc33e; });
$parcel$export(module.exports, "getStyleFromRgb", function () { return $f9b16b2dd914cf90$export$2476af37e47fcae2; });
$parcel$export(module.exports, "getStyleFromHsl", function () { return $f9b16b2dd914cf90$export$9d057e59c7b0a82d; });
$parcel$export(module.exports, "colorMix", function () { return $f9b16b2dd914cf90$export$9b476054b78b89cd; });
$parcel$export(module.exports, "getLinkColor", function () { return $f9b16b2dd914cf90$export$b676eb46c472d7df; });
$parcel$export(module.exports, "getLinkRandomColor", function () { return $f9b16b2dd914cf90$export$cf0e5a4ae26bdcdc; });
$parcel$export(module.exports, "getHslFromAnimation", function () { return $f9b16b2dd914cf90$export$c90768c73bc1d7ab; });
$parcel$export(module.exports, "getHslAnimationFromHsl", function () { return $f9b16b2dd914cf90$export$6e8a573710bea117; });
$parcel$export(module.exports, "updateColor", function () { return $f9b16b2dd914cf90$export$649b44ac750da8e; });

var $8wHfp = parcelRequire("8wHfp");

var $1Cbg8 = parcelRequire("1Cbg8");

var $bOXKQ = parcelRequire("bOXKQ");

var $b9FKP = parcelRequire("b9FKP");
const $f9b16b2dd914cf90$var$randomColorValue = "random", $f9b16b2dd914cf90$var$midColorValue = "mid", $f9b16b2dd914cf90$var$colorManagers = new Map();
function $f9b16b2dd914cf90$export$fac4919b23cbaf23(manager) {
    $f9b16b2dd914cf90$var$colorManagers.set(manager.key, manager);
}
function $f9b16b2dd914cf90$var$stringToRgba(input) {
    for (const [, manager] of $f9b16b2dd914cf90$var$colorManagers){
        if (input.startsWith(manager.stringPrefix)) return manager.parseString(input);
    }
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, hexFixed = input.replace(shorthandRegex, (_, r, g, b, a)=>{
        return r + r + g + g + b + b + (a !== undefined ? a + a : "");
    }), regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, result = regex.exec(hexFixed), radix = 16, defaultAlpha = 1, alphaFactor = 0xff;
    return result ? {
        a: result[4] !== undefined ? parseInt(result[4], radix) / alphaFactor : defaultAlpha,
        b: parseInt(result[3], radix),
        g: parseInt(result[2], radix),
        r: parseInt(result[1], radix)
    } : undefined;
}
function $f9b16b2dd914cf90$export$fbf0bf3cc1fc0cc4(input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $1Cbg8.isString)(input) ? {
        value: input
    } : input;
    if ((0, $1Cbg8.isString)(color.value)) return $f9b16b2dd914cf90$export$170d64abcc52d97a(color.value, index, useIndex);
    if ((0, $1Cbg8.isArray)(color.value)) return $f9b16b2dd914cf90$export$fbf0bf3cc1fc0cc4({
        value: (0, $b9FKP.itemFromArray)(color.value, index, useIndex)
    });
    for (const [, manager] of $f9b16b2dd914cf90$var$colorManagers){
        const res = manager.handleRangeColor(color);
        if (res) return res;
    }
}
function $f9b16b2dd914cf90$export$170d64abcc52d97a(input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $1Cbg8.isString)(input) ? {
        value: input
    } : input;
    if ((0, $1Cbg8.isString)(color.value)) return color.value === $f9b16b2dd914cf90$var$randomColorValue ? $f9b16b2dd914cf90$export$ac4fc8e9144a1018() : $f9b16b2dd914cf90$export$d2c5ec93815c4391(color.value);
    if ((0, $1Cbg8.isArray)(color.value)) return $f9b16b2dd914cf90$export$170d64abcc52d97a({
        value: (0, $b9FKP.itemFromArray)(color.value, index, useIndex)
    });
    for (const [, manager] of $f9b16b2dd914cf90$var$colorManagers){
        const res = manager.handleColor(color);
        if (res) return res;
    }
}
function $f9b16b2dd914cf90$export$5e49d166a305dfce(color, index, useIndex = true) {
    const rgb = $f9b16b2dd914cf90$export$170d64abcc52d97a(color, index, useIndex);
    return rgb ? $f9b16b2dd914cf90$export$c85ca4f4753af384(rgb) : undefined;
}
function $f9b16b2dd914cf90$export$79a89086521c0f12(color, index, useIndex = true) {
    const rgb = $f9b16b2dd914cf90$export$fbf0bf3cc1fc0cc4(color, index, useIndex);
    return rgb ? $f9b16b2dd914cf90$export$c85ca4f4753af384(rgb) : undefined;
}
function $f9b16b2dd914cf90$export$c85ca4f4753af384(color) {
    const rgbMax = 255, hMax = 360, sMax = 100, lMax = 100, hMin = 0, sMin = 0, hPhase = 60, half = 0.5, double = 2, r1 = color.r / rgbMax, g1 = color.g / rgbMax, b1 = color.b / rgbMax, max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1), res = {
        h: hMin,
        l: (max + min) * half,
        s: sMin
    };
    if (max !== min) {
        res.s = res.l < half ? (max - min) / (max + min) : (max - min) / (double - max - min);
        res.h = r1 === max ? (g1 - b1) / (max - min) : res.h = g1 === max ? double + (b1 - r1) / (max - min) : double * double + (r1 - g1) / (max - min);
    }
    res.l *= lMax;
    res.s *= sMax;
    res.h *= hPhase;
    if (res.h < hMin) res.h += hMax;
    if (res.h >= hMax) res.h -= hMax;
    return res;
}
function $f9b16b2dd914cf90$export$143dda7722fd213d(input) {
    return $f9b16b2dd914cf90$var$stringToRgba(input)?.a;
}
function $f9b16b2dd914cf90$export$d2c5ec93815c4391(input) {
    return $f9b16b2dd914cf90$var$stringToRgba(input);
}
function $f9b16b2dd914cf90$export$29fb7152bd3f781a(hsl) {
    const hMax = 360, sMax = 100, lMax = 100, sMin = 0, lMin = 0, h = (hsl.h % hMax + hMax) % hMax, s = Math.max(sMin, Math.min(sMax, hsl.s)), l = Math.max(lMin, Math.min(lMax, hsl.l)), hNormalized = h / hMax, sNormalized = s / sMax, lNormalized = l / lMax, rgbFactor = 255, triple = 3;
    if (s === sMin) {
        const grayscaleValue = Math.round(lNormalized * rgbFactor);
        return {
            r: grayscaleValue,
            g: grayscaleValue,
            b: grayscaleValue
        };
    }
    const half = 0.5, double = 2, channel = (temp1, temp2, temp3)=>{
        const temp3Min = 0, temp3Max = 1, sextuple = 6;
        if (temp3 < temp3Min) temp3++;
        if (temp3 > temp3Max) temp3--;
        if (temp3 * sextuple < temp3Max) return temp1 + (temp2 - temp1) * sextuple * temp3;
        if (temp3 * double < temp3Max) return temp2;
        if (temp3 * triple < temp3Max * double) {
            const temp3Offset = double / triple;
            return temp1 + (temp2 - temp1) * (temp3Offset - temp3) * sextuple;
        }
        return temp1;
    }, sNormalizedOffset = 1, temp1 = lNormalized < half ? lNormalized * (sNormalizedOffset + sNormalized) : lNormalized + sNormalized - lNormalized * sNormalized, temp2 = double * lNormalized - temp1, phaseNumerator = 1, phaseThird = phaseNumerator / triple, red = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized + phaseThird)), green = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized)), blue = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized - phaseThird));
    return {
        r: Math.round(red),
        g: Math.round(green),
        b: Math.round(blue)
    };
}
function $f9b16b2dd914cf90$export$6ae64dbcd6bfc33e(hsla) {
    const rgbResult = $f9b16b2dd914cf90$export$29fb7152bd3f781a(hsla);
    return {
        a: hsla.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r
    };
}
function $f9b16b2dd914cf90$export$ac4fc8e9144a1018(min) {
    const defaultMin = 0, fixedMin = min ?? defaultMin, rgbMax = 256;
    return {
        b: Math.floor((0, $8wHfp.randomInRange)((0, $8wHfp.setRangeValue)(fixedMin, rgbMax))),
        g: Math.floor((0, $8wHfp.randomInRange)((0, $8wHfp.setRangeValue)(fixedMin, rgbMax))),
        r: Math.floor((0, $8wHfp.randomInRange)((0, $8wHfp.setRangeValue)(fixedMin, rgbMax)))
    };
}
function $f9b16b2dd914cf90$export$2476af37e47fcae2(color, opacity) {
    const defaultOpacity = 1;
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity ?? defaultOpacity})`;
}
function $f9b16b2dd914cf90$export$9d057e59c7b0a82d(color, opacity) {
    const defaultOpacity = 1;
    return `hsla(${color.h}, ${color.s}%, ${color.l}%, ${opacity ?? defaultOpacity})`;
}
function $f9b16b2dd914cf90$export$9b476054b78b89cd(color1, color2, size1, size2) {
    let rgb1 = color1, rgb2 = color2;
    if (rgb1.r === undefined) rgb1 = $f9b16b2dd914cf90$export$29fb7152bd3f781a(color1);
    if (rgb2.r === undefined) rgb2 = $f9b16b2dd914cf90$export$29fb7152bd3f781a(color2);
    return {
        b: (0, $8wHfp.mix)(rgb1.b, rgb2.b, size1, size2),
        g: (0, $8wHfp.mix)(rgb1.g, rgb2.g, size1, size2),
        r: (0, $8wHfp.mix)(rgb1.r, rgb2.r, size1, size2)
    };
}
function $f9b16b2dd914cf90$export$b676eb46c472d7df(p1, p2, linkColor) {
    if (linkColor === $f9b16b2dd914cf90$var$randomColorValue) return $f9b16b2dd914cf90$export$ac4fc8e9144a1018();
    else if (linkColor === $f9b16b2dd914cf90$var$midColorValue) {
        const sourceColor = p1.getFillColor() ?? p1.getStrokeColor(), destColor = p2?.getFillColor() ?? p2?.getStrokeColor();
        if (sourceColor && destColor && p2) return $f9b16b2dd914cf90$export$9b476054b78b89cd(sourceColor, destColor, p1.getRadius(), p2.getRadius());
        else {
            const hslColor = sourceColor ?? destColor;
            if (hslColor) return $f9b16b2dd914cf90$export$29fb7152bd3f781a(hslColor);
        }
    } else return linkColor;
}
function $f9b16b2dd914cf90$export$cf0e5a4ae26bdcdc(optColor, blink, consent) {
    const color = (0, $1Cbg8.isString)(optColor) ? optColor : optColor.value;
    if (color === $f9b16b2dd914cf90$var$randomColorValue) {
        if (consent) return $f9b16b2dd914cf90$export$fbf0bf3cc1fc0cc4({
            value: color
        });
        if (blink) return $f9b16b2dd914cf90$var$randomColorValue;
        return $f9b16b2dd914cf90$var$midColorValue;
    } else if (color === $f9b16b2dd914cf90$var$midColorValue) return $f9b16b2dd914cf90$var$midColorValue;
    else return $f9b16b2dd914cf90$export$fbf0bf3cc1fc0cc4({
        value: color
    });
}
function $f9b16b2dd914cf90$export$c90768c73bc1d7ab(animation) {
    return animation !== undefined ? {
        h: animation.h.value,
        s: animation.s.value,
        l: animation.l.value
    } : undefined;
}
function $f9b16b2dd914cf90$export$6e8a573710bea117(hsl, animationOptions, reduceFactor) {
    const resColor = {
        h: {
            enable: false,
            value: hsl.h
        },
        s: {
            enable: false,
            value: hsl.s
        },
        l: {
            enable: false,
            value: hsl.l
        }
    };
    if (animationOptions) {
        $f9b16b2dd914cf90$var$setColorAnimation(resColor.h, animationOptions.h, reduceFactor);
        $f9b16b2dd914cf90$var$setColorAnimation(resColor.s, animationOptions.s, reduceFactor);
        $f9b16b2dd914cf90$var$setColorAnimation(resColor.l, animationOptions.l, reduceFactor);
    }
    return resColor;
}
function $f9b16b2dd914cf90$var$setColorAnimation(colorValue, colorAnimation, reduceFactor) {
    colorValue.enable = colorAnimation.enable;
    const defaultVelocity = 0, decayOffset = 1, defaultLoops = 0, defaultTime = 0;
    if (colorValue.enable) {
        colorValue.velocity = (0, $8wHfp.getRangeValue)(colorAnimation.speed) / (0, $bOXKQ.percentDenominator) * reduceFactor;
        colorValue.decay = decayOffset - (0, $8wHfp.getRangeValue)(colorAnimation.decay);
        colorValue.status = "increasing";
        colorValue.loops = defaultLoops;
        colorValue.maxLoops = (0, $8wHfp.getRangeValue)(colorAnimation.count);
        colorValue.time = defaultTime;
        colorValue.delayTime = (0, $8wHfp.getRangeValue)(colorAnimation.delay) * (0, $bOXKQ.millisecondsToSeconds);
        if (!colorAnimation.sync) {
            colorValue.velocity *= (0, $8wHfp.getRandom)();
            colorValue.value *= (0, $8wHfp.getRandom)();
        }
        colorValue.initialValue = colorValue.value;
        colorValue.offset = (0, $8wHfp.setRangeValue)(colorAnimation.offset);
    } else colorValue.velocity = defaultVelocity;
}
function $f9b16b2dd914cf90$export$a151177c20377190(data, range, decrease, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minOffset = 0, velocityFactor = 3.6;
    if (!data || !data.enable || (data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops)) return;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) data.time += delta.value;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) return;
    const offset = data.offset ? (0, $8wHfp.randomInRange)(data.offset) : minOffset, velocity = (data.velocity ?? minVelocity) * delta.factor + offset * velocityFactor, decay = data.decay ?? identity, max = (0, $8wHfp.getRangeMax)(range), min = (0, $8wHfp.getRangeMin)(range);
    if (!decrease || data.status === "increasing") {
        data.value += velocity;
        if (data.value > max) {
            if (!data.loops) data.loops = 0;
            data.loops++;
            if (decrease) data.status = "decreasing";
            else data.value -= max;
        }
    } else {
        data.value -= velocity;
        const minValue = 0;
        if (data.value < minValue) {
            if (!data.loops) data.loops = 0;
            data.loops++;
            data.status = "increasing";
        }
    }
    if (data.velocity && decay !== identity) data.velocity *= decay;
    data.value = (0, $8wHfp.clamp)(data.value, min, max);
}
function $f9b16b2dd914cf90$export$649b44ac750da8e(color, delta) {
    if (!color) return;
    const { h: h, s: s, l: l } = color;
    const ranges = {
        h: {
            min: 0,
            max: 360
        },
        s: {
            min: 0,
            max: 100
        },
        l: {
            min: 0,
            max: 100
        }
    };
    if (h) $f9b16b2dd914cf90$export$a151177c20377190(h, ranges.h, false, delta);
    if (s) $f9b16b2dd914cf90$export$a151177c20377190(s, ranges.s, true, delta);
    if (l) $f9b16b2dd914cf90$export$a151177c20377190(l, ranges.l, true, delta);
}

});


parcelRegister("kc8F4", function(module, exports) {

$parcel$export(module.exports, "RgbColorManager", function () { return $eb3ba59ea5064772$export$24da4f0c4702c17e; });

var $8wHfp = parcelRequire("8wHfp");
class $eb3ba59ea5064772$export$24da4f0c4702c17e {
    constructor(){
        this.key = "rgb";
        this.stringPrefix = "rgb";
    }
    handleColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return rgbColor;
    }
    handleRangeColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return {
            r: (0, $8wHfp.getRangeValue)(rgbColor.r),
            g: (0, $8wHfp.getRangeValue)(rgbColor.g),
            b: (0, $8wHfp.getRangeValue)(rgbColor.b)
        };
    }
    parseString(input) {
        if (!input.startsWith(this.stringPrefix)) return;
        const regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), radix = 10, minLength = 4, defaultAlpha = 1;
        return result ? {
            a: result.length > minLength ? (0, $8wHfp.parseAlpha)(result[5]) : defaultAlpha,
            b: parseInt(result[3], radix),
            g: parseInt(result[2], radix),
            r: parseInt(result[1], radix)
        } : undefined;
    }
}

});


parcelRegister("7zVhK", function(module, exports) {
$parcel$export(module.exports, "errorPrefix", function () { return (parcelRequire("bOXKQ")).errorPrefix; });
$parcel$export(module.exports, "halfRandom", function () { return (parcelRequire("bOXKQ")).halfRandom; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return (parcelRequire("bOXKQ")).millisecondsToSeconds; });
$parcel$export(module.exports, "mouseLeaveEvent", function () { return (parcelRequire("bOXKQ")).mouseLeaveEvent; });
$parcel$export(module.exports, "mouseMoveEvent", function () { return (parcelRequire("bOXKQ")).mouseMoveEvent; });
$parcel$export(module.exports, "percentDenominator", function () { return (parcelRequire("bOXKQ")).percentDenominator; });
$parcel$export(module.exports, "ExternalInteractorBase", function () { return (parcelRequire("iqSVQ")).ExternalInteractorBase; });
$parcel$export(module.exports, "ParticlesInteractorBase", function () { return (parcelRequire("cZfuF")).ParticlesInteractorBase; });
$parcel$export(module.exports, "Circle", function () { return (parcelRequire("lvIxI")).Circle; });
$parcel$export(module.exports, "Rectangle", function () { return (parcelRequire("lvIxI")).Rectangle; });
$parcel$export(module.exports, "Vector", function () { return (parcelRequire("jpo9d")).Vector; });
$parcel$export(module.exports, "AnimatableColor", function () { return (parcelRequire("cHoex")).AnimatableColor; });
$parcel$export(module.exports, "OptionsColor", function () { return (parcelRequire("ceG2E")).OptionsColor; });
$parcel$export(module.exports, "ValueWithRandom", function () { return (parcelRequire("dusZm")).ValueWithRandom; });
$parcel$export(module.exports, "drawLine", function () { return (parcelRequire("7Cxfx")).drawLine; });
$parcel$export(module.exports, "colorMix", function () { return (parcelRequire("lr6PC")).colorMix; });
$parcel$export(module.exports, "getHslAnimationFromHsl", function () { return (parcelRequire("lr6PC")).getHslAnimationFromHsl; });
$parcel$export(module.exports, "getLinkColor", function () { return (parcelRequire("lr6PC")).getLinkColor; });
$parcel$export(module.exports, "getLinkRandomColor", function () { return (parcelRequire("lr6PC")).getLinkRandomColor; });
$parcel$export(module.exports, "getStyleFromHsl", function () { return (parcelRequire("lr6PC")).getStyleFromHsl; });
$parcel$export(module.exports, "getStyleFromRgb", function () { return (parcelRequire("lr6PC")).getStyleFromRgb; });
$parcel$export(module.exports, "rangeColorToHsl", function () { return (parcelRequire("lr6PC")).rangeColorToHsl; });
$parcel$export(module.exports, "rangeColorToRgb", function () { return (parcelRequire("lr6PC")).rangeColorToRgb; });
$parcel$export(module.exports, "rgbToHsl", function () { return (parcelRequire("lr6PC")).rgbToHsl; });
$parcel$export(module.exports, "updateColor", function () { return (parcelRequire("lr6PC")).updateColor; });
$parcel$export(module.exports, "addEasing", function () { return (parcelRequire("8wHfp")).addEasing; });
$parcel$export(module.exports, "calcPositionOrRandomFromSize", function () { return (parcelRequire("8wHfp")).calcPositionOrRandomFromSize; });
$parcel$export(module.exports, "calcPositionOrRandomFromSizeRanged", function () { return (parcelRequire("8wHfp")).calcPositionOrRandomFromSizeRanged; });
$parcel$export(module.exports, "clamp", function () { return (parcelRequire("8wHfp")).clamp; });
$parcel$export(module.exports, "degToRad", function () { return (parcelRequire("8wHfp")).degToRad; });
$parcel$export(module.exports, "getDistance", function () { return (parcelRequire("8wHfp")).getDistance; });
$parcel$export(module.exports, "getDistances", function () { return (parcelRequire("8wHfp")).getDistances; });
$parcel$export(module.exports, "getEasing", function () { return (parcelRequire("8wHfp")).getEasing; });
$parcel$export(module.exports, "getRandom", function () { return (parcelRequire("8wHfp")).getRandom; });
$parcel$export(module.exports, "getRangeMax", function () { return (parcelRequire("8wHfp")).getRangeMax; });
$parcel$export(module.exports, "getRangeValue", function () { return (parcelRequire("8wHfp")).getRangeValue; });
$parcel$export(module.exports, "randomInRange", function () { return (parcelRequire("8wHfp")).randomInRange; });
$parcel$export(module.exports, "setRangeValue", function () { return (parcelRequire("8wHfp")).setRangeValue; });
$parcel$export(module.exports, "loadParticlesOptions", function () { return (parcelRequire("bPqPl")).loadParticlesOptions; });
$parcel$export(module.exports, "arrayRandomIndex", function () { return (parcelRequire("b9FKP")).arrayRandomIndex; });
$parcel$export(module.exports, "calculateBounds", function () { return (parcelRequire("b9FKP")).calculateBounds; });
$parcel$export(module.exports, "circleBounce", function () { return (parcelRequire("b9FKP")).circleBounce; });
$parcel$export(module.exports, "circleBounceDataFromParticle", function () { return (parcelRequire("b9FKP")).circleBounceDataFromParticle; });
$parcel$export(module.exports, "deepExtend", function () { return (parcelRequire("b9FKP")).deepExtend; });
$parcel$export(module.exports, "divMode", function () { return (parcelRequire("b9FKP")).divMode; });
$parcel$export(module.exports, "divModeExecute", function () { return (parcelRequire("b9FKP")).divModeExecute; });
$parcel$export(module.exports, "executeOnSingleOrMultiple", function () { return (parcelRequire("b9FKP")).executeOnSingleOrMultiple; });
$parcel$export(module.exports, "getLogger", function () { return (parcelRequire("b9FKP")).getLogger; });
$parcel$export(module.exports, "getSize", function () { return (parcelRequire("b9FKP")).getSize; });
$parcel$export(module.exports, "initParticleNumericAnimationValue", function () { return (parcelRequire("b9FKP")).initParticleNumericAnimationValue; });
$parcel$export(module.exports, "isDivModeEnabled", function () { return (parcelRequire("b9FKP")).isDivModeEnabled; });
$parcel$export(module.exports, "isInArray", function () { return (parcelRequire("b9FKP")).isInArray; });
$parcel$export(module.exports, "isPointInside", function () { return (parcelRequire("b9FKP")).isPointInside; });
$parcel$export(module.exports, "isSsr", function () { return (parcelRequire("b9FKP")).isSsr; });
$parcel$export(module.exports, "itemFromArray", function () { return (parcelRequire("b9FKP")).itemFromArray; });
$parcel$export(module.exports, "itemFromSingleOrMultiple", function () { return (parcelRequire("b9FKP")).itemFromSingleOrMultiple; });
$parcel$export(module.exports, "loadFont", function () { return (parcelRequire("b9FKP")).loadFont; });
$parcel$export(module.exports, "rectBounce", function () { return (parcelRequire("b9FKP")).rectBounce; });
$parcel$export(module.exports, "updateAnimation", function () { return (parcelRequire("b9FKP")).updateAnimation; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("1Cbg8")).isArray; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("1Cbg8")).isNumber; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("1Cbg8")).isObject; });
parcelRequire("bOXKQ");
parcelRequire("iqSVQ");
parcelRequire("cZfuF");
parcelRequire("kHHy2");
parcelRequire("lvIxI");
parcelRequire("jpo9d");
parcelRequire("iKjwN");
parcelRequire("gJPey");
parcelRequire("1OoJM");
parcelRequire("1r4NX");
parcelRequire("gTTQt");
parcelRequire("1MVcJ");
parcelRequire("3mO7o");
parcelRequire("9X0y9");
parcelRequire("dexAw");
parcelRequire("3GpyJ");
parcelRequire("kYje2");
parcelRequire("4RdgQ");
parcelRequire("eJgad");
parcelRequire("efUcx");
parcelRequire("8WaiF");
parcelRequire("kCFQk");
parcelRequire("92q1x");
parcelRequire("4PP5e");
parcelRequire("clFa3");
parcelRequire("5uti0");
parcelRequire("6tmzu");
parcelRequire("cHoex");
parcelRequire("4CK3F");
parcelRequire("jul2w");
parcelRequire("94ckh");
parcelRequire("3XRUy");
parcelRequire("EevF8");
parcelRequire("crTeo");
parcelRequire("ehaTG");
parcelRequire("ljwzP");
parcelRequire("41xd9");
parcelRequire("5xpDO");
parcelRequire("5Sypn");
parcelRequire("lHY9h");
parcelRequire("4fcSn");
parcelRequire("gx4Gm");
parcelRequire("lHQ1o");
parcelRequire("4fb4i");
parcelRequire("56IuD");
parcelRequire("ceG2E");
parcelRequire("gt1eT");
parcelRequire("kQpzQ");
parcelRequire("eUPzq");
parcelRequire("2qdVq");
parcelRequire("k7yaC");
parcelRequire("7yCdy");
parcelRequire("71DMI");
parcelRequire("5y8qA");
parcelRequire("6bIr7");
parcelRequire("500nK");
parcelRequire("yeiCA");
parcelRequire("laB4H");
parcelRequire("fVGHe");
parcelRequire("gmix7");
parcelRequire("aEDsA");
parcelRequire("gH2dY");
parcelRequire("9XDjp");
parcelRequire("d4DmF");
parcelRequire("TkwXE");
parcelRequire("lVl6w");
parcelRequire("3PdrB");
parcelRequire("5WmnD");
parcelRequire("1Ts97");
parcelRequire("gOwDF");
parcelRequire("5d6o4");
parcelRequire("dIIqE");
parcelRequire("1UBOA");
parcelRequire("fpVR2");
parcelRequire("3Bgmq");
parcelRequire("dusZm");
parcelRequire("7Cxfx");
parcelRequire("lr6PC");
parcelRequire("1dkw8");
parcelRequire("8wHfp");
parcelRequire("bPqPl");
parcelRequire("kc8F4");
parcelRequire("b9FKP");
parcelRequire("1Cbg8");

});
parcelRegister("iqSVQ", function(module, exports) {

$parcel$export(module.exports, "ExternalInteractorBase", function () { return $d6b5440ee93a50de$export$6e252256471acc61; });
class $d6b5440ee93a50de$export$6e252256471acc61 {
    constructor(container){
        this.type = "external";
        this.container = container;
    }
}

});

parcelRegister("cZfuF", function(module, exports) {

$parcel$export(module.exports, "ParticlesInteractorBase", function () { return $9747334197942b71$export$becdaab2d9289dc4; });
class $9747334197942b71$export$becdaab2d9289dc4 {
    constructor(container){
        this.type = "particles";
        this.container = container;
    }
}

});

parcelRegister("kHHy2", function(module, exports) {

$parcel$export(module.exports, "Point", function () { return $f1299a8461dcaf0a$export$baf26146a414f24a; });
class $f1299a8461dcaf0a$export$baf26146a414f24a {
    constructor(position, particle){
        this.position = position;
        this.particle = particle;
    }
}

});

parcelRegister("lvIxI", function(module, exports) {

$parcel$export(module.exports, "Circle", function () { return $fa8f0b7ad164dd4f$export$c89a927ffc67e6fa; });
$parcel$export(module.exports, "Rectangle", function () { return $fa8f0b7ad164dd4f$export$4617fb02663045ef; });

var $8wHfp = parcelRequire("8wHfp");
const $fa8f0b7ad164dd4f$var$squareExp = 2;
class $fa8f0b7ad164dd4f$export$f237afe0deab98f9 {
    constructor(x, y, type){
        this.position = {
            x: x,
            y: y
        };
        this.type = type;
    }
}
class $fa8f0b7ad164dd4f$export$c89a927ffc67e6fa extends $fa8f0b7ad164dd4f$export$f237afe0deab98f9 {
    constructor(x, y, radius){
        super(x, y, "circle");
        this.radius = radius;
    }
    contains(point) {
        return (0, $8wHfp.getDistance)(point, this.position) <= this.radius;
    }
    intersects(range) {
        const pos1 = this.position, pos2 = range.position, distPos = {
            x: Math.abs(pos2.x - pos1.x),
            y: Math.abs(pos2.y - pos1.y)
        }, r = this.radius;
        if (range instanceof $fa8f0b7ad164dd4f$export$c89a927ffc67e6fa || range.type === "circle") {
            const circleRange = range, rSum = r + circleRange.radius, dist = Math.sqrt(distPos.x ** $fa8f0b7ad164dd4f$var$squareExp + distPos.y ** $fa8f0b7ad164dd4f$var$squareExp);
            return rSum > dist;
        } else if (range instanceof $fa8f0b7ad164dd4f$export$4617fb02663045ef || range.type === "rectangle") {
            const rectRange = range, { width: width, height: height } = rectRange.size, edges = Math.pow(distPos.x - width, $fa8f0b7ad164dd4f$var$squareExp) + Math.pow(distPos.y - height, $fa8f0b7ad164dd4f$var$squareExp);
            return edges <= r ** $fa8f0b7ad164dd4f$var$squareExp || distPos.x <= r + width && distPos.y <= r + height || distPos.x <= width || distPos.y <= height;
        }
        return false;
    }
}
class $fa8f0b7ad164dd4f$export$4617fb02663045ef extends $fa8f0b7ad164dd4f$export$f237afe0deab98f9 {
    constructor(x, y, width, height){
        super(x, y, "rectangle");
        this.size = {
            height: height,
            width: width
        };
    }
    contains(point) {
        const w = this.size.width, h = this.size.height, pos = this.position;
        return point.x >= pos.x && point.x <= pos.x + w && point.y >= pos.y && point.y <= pos.y + h;
    }
    intersects(range) {
        if (range instanceof $fa8f0b7ad164dd4f$export$c89a927ffc67e6fa) return range.intersects(this);
        const w = this.size.width, h = this.size.height, pos1 = this.position, pos2 = range.position, size2 = range instanceof $fa8f0b7ad164dd4f$export$4617fb02663045ef ? range.size : {
            width: 0,
            height: 0
        }, w2 = size2.width, h2 = size2.height;
        return pos2.x < pos1.x + w && pos2.x + w2 > pos1.x && pos2.y < pos1.y + h && pos2.y + h2 > pos1.y;
    }
}

});

parcelRegister("iKjwN", function(module, exports) {

});

parcelRegister("gJPey", function(module, exports) {

});

parcelRegister("1OoJM", function(module, exports) {

});

parcelRegister("1r4NX", function(module, exports) {

});

parcelRegister("gTTQt", function(module, exports) {

});

parcelRegister("1MVcJ", function(module, exports) {

});

parcelRegister("3mO7o", function(module, exports) {

});

parcelRegister("9X0y9", function(module, exports) {

});

parcelRegister("dexAw", function(module, exports) {

});

parcelRegister("3GpyJ", function(module, exports) {

});

parcelRegister("kYje2", function(module, exports) {

});

parcelRegister("4RdgQ", function(module, exports) {

});

parcelRegister("eJgad", function(module, exports) {

});

parcelRegister("efUcx", function(module, exports) {

});

parcelRegister("8WaiF", function(module, exports) {

});

parcelRegister("kCFQk", function(module, exports) {

});

parcelRegister("92q1x", function(module, exports) {

});

parcelRegister("4PP5e", function(module, exports) {

});

parcelRegister("clFa3", function(module, exports) {

});

parcelRegister("5uti0", function(module, exports) {

});

parcelRegister("6tmzu", function(module, exports) {

});

parcelRegister("cHoex", function(module, exports) {

$parcel$export(module.exports, "AnimatableColor", function () { return $93ec4c755a635d18$export$6f79b6ff75533155; });

var $1Cbg8 = parcelRequire("1Cbg8");

var $ehaTG = parcelRequire("ehaTG");

var $ceG2E = parcelRequire("ceG2E");
class $93ec4c755a635d18$export$6f79b6ff75533155 extends (0, $ceG2E.OptionsColor) {
    constructor(){
        super();
        this.animation = new (0, $ehaTG.HslAnimation)();
    }
    static create(source, data) {
        const color = new $93ec4c755a635d18$export$6f79b6ff75533155();
        color.load(source);
        if (data !== undefined) {
            if ((0, $1Cbg8.isString)(data) || (0, $1Cbg8.isArray)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const colorAnimation = data.animation;
        if (colorAnimation !== undefined) {
            if (colorAnimation.enable !== undefined) this.animation.h.load(colorAnimation);
            else this.animation.load(data.animation);
        }
    }
}

});
parcelRegister("ehaTG", function(module, exports) {

$parcel$export(module.exports, "HslAnimation", function () { return $a64b1b2425382432$export$b4c56f18acc5f2f4; });

var $EevF8 = parcelRequire("EevF8");
class $a64b1b2425382432$export$b4c56f18acc5f2f4 {
    constructor(){
        this.h = new (0, $EevF8.ColorAnimation)();
        this.s = new (0, $EevF8.ColorAnimation)();
        this.l = new (0, $EevF8.ColorAnimation)();
    }
    load(data) {
        if (!data) return;
        this.h.load(data.h);
        this.s.load(data.s);
        this.l.load(data.l);
    }
}

});
parcelRegister("EevF8", function(module, exports) {

$parcel$export(module.exports, "ColorAnimation", function () { return $078efddccaa460f4$export$3cc8aa7a0c621de0; });

var $4CK3F = parcelRequire("4CK3F");

var $8wHfp = parcelRequire("8wHfp");
class $078efddccaa460f4$export$3cc8aa7a0c621de0 extends (0, $4CK3F.AnimationOptions) {
    constructor(){
        super();
        this.offset = 0;
        this.sync = true;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.offset !== undefined) this.offset = (0, $8wHfp.setRangeValue)(data.offset);
    }
}

});
parcelRegister("4CK3F", function(module, exports) {

$parcel$export(module.exports, "AnimationOptions", function () { return $35de703b1e5274ce$export$e293c31e7176ae39; });
$parcel$export(module.exports, "RangedAnimationOptions", function () { return $35de703b1e5274ce$export$664e182a9c83d6f5; });

var $8wHfp = parcelRequire("8wHfp");
class $35de703b1e5274ce$export$e293c31e7176ae39 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.speed = 1;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = (0, $8wHfp.setRangeValue)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $8wHfp.setRangeValue)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $8wHfp.setRangeValue)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $8wHfp.setRangeValue)(data.delay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}
class $35de703b1e5274ce$export$664e182a9c83d6f5 extends $35de703b1e5274ce$export$e293c31e7176ae39 {
    constructor(){
        super();
        this.mode = "auto";
        this.startValue = "random";
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.startValue !== undefined) this.startValue = data.startValue;
    }
}

});



parcelRegister("ceG2E", function(module, exports) {

$parcel$export(module.exports, "OptionsColor", function () { return $8e87676f40593e32$export$c2b08aa25660fcaa; });

var $1Cbg8 = parcelRequire("1Cbg8");
class $8e87676f40593e32$export$c2b08aa25660fcaa {
    constructor(){
        this.value = "";
    }
    static create(source, data) {
        const color = new $8e87676f40593e32$export$c2b08aa25660fcaa();
        color.load(source);
        if (data !== undefined) {
            if ((0, $1Cbg8.isString)(data) || (0, $1Cbg8.isArray)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        if (data?.value === undefined) return;
        this.value = data.value;
    }
}

});


parcelRegister("jul2w", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $e30123b71a32530a$export$668799e4797757a8; });

var $ceG2E = parcelRequire("ceG2E");
class $e30123b71a32530a$export$668799e4797757a8 {
    constructor(){
        this.color = new (0, $ceG2E.OptionsColor)();
        this.color.value = "";
        this.image = "";
        this.position = "";
        this.repeat = "";
        this.size = "";
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $ceG2E.OptionsColor).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.position !== undefined) this.position = data.position;
        if (data.repeat !== undefined) this.repeat = data.repeat;
        if (data.size !== undefined) this.size = data.size;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}

});

parcelRegister("94ckh", function(module, exports) {

$parcel$export(module.exports, "BackgroundMask", function () { return $699e0c7b47dc1833$export$36a2fa1e47ffeebc; });

var $3XRUy = parcelRequire("3XRUy");

var $1Cbg8 = parcelRequire("1Cbg8");
class $699e0c7b47dc1833$export$36a2fa1e47ffeebc {
    constructor(){
        this.composite = "destination-out";
        this.cover = new (0, $3XRUy.BackgroundMaskCover)();
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.composite !== undefined) this.composite = data.composite;
        if (data.cover !== undefined) {
            const cover = data.cover, color = (0, $1Cbg8.isString)(data.cover) ? {
                color: data.cover
            } : data.cover;
            this.cover.load(cover.color !== undefined || cover.image !== undefined ? cover : {
                color: color
            });
        }
        if (data.enable !== undefined) this.enable = data.enable;
    }
}

});
parcelRegister("3XRUy", function(module, exports) {

$parcel$export(module.exports, "BackgroundMaskCover", function () { return $2e30b3701610bca7$export$83d45d4584162ec0; });

var $ceG2E = parcelRequire("ceG2E");
class $2e30b3701610bca7$export$83d45d4584162ec0 {
    constructor(){
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $ceG2E.OptionsColor).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}

});


parcelRegister("crTeo", function(module, exports) {

$parcel$export(module.exports, "FullScreen", function () { return $9102d9643525c665$export$f885b95b3f0be76d; });
class $9102d9643525c665$export$f885b95b3f0be76d {
    constructor(){
        this.enable = true;
        this.zIndex = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.zIndex !== undefined) this.zIndex = data.zIndex;
    }
}

});

parcelRegister("ljwzP", function(module, exports) {

$parcel$export(module.exports, "ClickEvent", function () { return $f844a46ac219352e$export$8d82f6df2d02cd91; });
class $f844a46ac219352e$export$8d82f6df2d02cd91 {
    constructor(){
        this.enable = false;
        this.mode = [];
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
    }
}

});

parcelRegister("41xd9", function(module, exports) {

$parcel$export(module.exports, "DivEvent", function () { return $2ee1047a181d3d29$export$54136f11f358067a; });
class $2ee1047a181d3d29$export$54136f11f358067a {
    constructor(){
        this.selectors = [];
        this.enable = false;
        this.mode = [];
        this.type = "circle";
    }
    load(data) {
        if (!data) return;
        if (data.selectors !== undefined) this.selectors = data.selectors;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.type !== undefined) this.type = data.type;
    }
}

});

parcelRegister("5xpDO", function(module, exports) {

$parcel$export(module.exports, "Events", function () { return $4083ec9e72b5b201$export$ada873a34909da65; });

var $ljwzP = parcelRequire("ljwzP");

var $41xd9 = parcelRequire("41xd9");

var $5Sypn = parcelRequire("5Sypn");

var $4fcSn = parcelRequire("4fcSn");

var $b9FKP = parcelRequire("b9FKP");
class $4083ec9e72b5b201$export$ada873a34909da65 {
    constructor(){
        this.onClick = new (0, $ljwzP.ClickEvent)();
        this.onDiv = new (0, $41xd9.DivEvent)();
        this.onHover = new (0, $5Sypn.HoverEvent)();
        this.resize = new (0, $4fcSn.ResizeEvent)();
    }
    load(data) {
        if (!data) return;
        this.onClick.load(data.onClick);
        const onDiv = data.onDiv;
        if (onDiv !== undefined) this.onDiv = (0, $b9FKP.executeOnSingleOrMultiple)(onDiv, (t)=>{
            const tmp = new (0, $41xd9.DivEvent)();
            tmp.load(t);
            return tmp;
        });
        this.onHover.load(data.onHover);
        this.resize.load(data.resize);
    }
}

});
parcelRegister("5Sypn", function(module, exports) {

$parcel$export(module.exports, "HoverEvent", function () { return $447cafad9e348aab$export$2f13ede603111372; });

var $lHY9h = parcelRequire("lHY9h");
class $447cafad9e348aab$export$2f13ede603111372 {
    constructor(){
        this.enable = false;
        this.mode = [];
        this.parallax = new (0, $lHY9h.Parallax)();
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        this.parallax.load(data.parallax);
    }
}

});
parcelRegister("lHY9h", function(module, exports) {

$parcel$export(module.exports, "Parallax", function () { return $fcdc4563a1181d3f$export$1bc430945f060dd1; });
class $fcdc4563a1181d3f$export$1bc430945f060dd1 {
    constructor(){
        this.enable = false;
        this.force = 2;
        this.smooth = 10;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.force !== undefined) this.force = data.force;
        if (data.smooth !== undefined) this.smooth = data.smooth;
    }
}

});


parcelRegister("4fcSn", function(module, exports) {

$parcel$export(module.exports, "ResizeEvent", function () { return $31728d0b584ff614$export$4a407cdeed472cd5; });
class $31728d0b584ff614$export$4a407cdeed472cd5 {
    constructor(){
        this.delay = 0.5;
        this.enable = true;
    }
    load(data) {
        if (data === undefined) return;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}

});


parcelRegister("gx4Gm", function(module, exports) {

$parcel$export(module.exports, "Interactivity", function () { return $031b26a619a5d62d$export$865458a3ba269c4a; });

var $5xpDO = parcelRequire("5xpDO");

var $lHQ1o = parcelRequire("lHQ1o");
class $031b26a619a5d62d$export$865458a3ba269c4a {
    constructor(engine, container){
        this.detectsOn = "window";
        this.events = new (0, $5xpDO.Events)();
        this.modes = new (0, $lHQ1o.Modes)(engine, container);
    }
    load(data) {
        if (!data) return;
        const detectsOn = data.detectsOn;
        if (detectsOn !== undefined) this.detectsOn = detectsOn;
        this.events.load(data.events);
        this.modes.load(data.modes);
    }
}

});
parcelRegister("lHQ1o", function(module, exports) {

$parcel$export(module.exports, "Modes", function () { return $fcd5f78127879196$export$43660d87cb080eb; });
class $fcd5f78127879196$export$43660d87cb080eb {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
    }
    load(data) {
        if (!data) return;
        if (!this._container) return;
        const interactors = this._engine.interactors.get(this._container);
        if (!interactors) return;
        for (const interactor of interactors){
            if (!interactor.loadModeOptions) continue;
            interactor.loadModeOptions(this, data);
        }
    }
}

});


parcelRegister("4fb4i", function(module, exports) {

$parcel$export(module.exports, "ManualParticle", function () { return $31712612748948ef$export$4f41a3ab9fa8cdf; });

var $b9FKP = parcelRequire("b9FKP");
const $31712612748948ef$var$defaultPosition = 50;
class $31712612748948ef$export$4f41a3ab9fa8cdf {
    load(data) {
        if (!data) return;
        if (data.position) this.position = {
            x: data.position.x ?? $31712612748948ef$var$defaultPosition,
            y: data.position.y ?? $31712612748948ef$var$defaultPosition,
            mode: data.position.mode ?? "percent"
        };
        if (data.options) this.options = (0, $b9FKP.deepExtend)({}, data.options);
    }
}

});

parcelRegister("56IuD", function(module, exports) {

$parcel$export(module.exports, "Options", function () { return $3b8006b00fbfdcaa$export$c019608e5b5bb4cb; });

var $b9FKP = parcelRequire("b9FKP");

var $jul2w = parcelRequire("jul2w");

var $94ckh = parcelRequire("94ckh");

var $crTeo = parcelRequire("crTeo");

var $gx4Gm = parcelRequire("gx4Gm");

var $4fb4i = parcelRequire("4fb4i");

var $1UBOA = parcelRequire("1UBOA");

var $fpVR2 = parcelRequire("fpVR2");

var $1Cbg8 = parcelRequire("1Cbg8");

var $bPqPl = parcelRequire("bPqPl");

var $8wHfp = parcelRequire("8wHfp");
class $3b8006b00fbfdcaa$export$c019608e5b5bb4cb {
    constructor(engine, container){
        this._findDefaultTheme = (mode)=>{
            return this.themes.find((theme)=>theme.default.value && theme.default.mode === mode) ?? this.themes.find((theme)=>theme.default.value && theme.default.mode === "any");
        };
        this._importPreset = (preset)=>{
            this.load(this._engine.getPreset(preset));
        };
        this._engine = engine;
        this._container = container;
        this.autoPlay = true;
        this.background = new (0, $jul2w.Background)();
        this.backgroundMask = new (0, $94ckh.BackgroundMask)();
        this.clear = true;
        this.defaultThemes = {};
        this.delay = 0;
        this.fullScreen = new (0, $crTeo.FullScreen)();
        this.detectRetina = true;
        this.duration = 0;
        this.fpsLimit = 120;
        this.interactivity = new (0, $gx4Gm.Interactivity)(engine, container);
        this.manualParticles = [];
        this.particles = (0, $bPqPl.loadParticlesOptions)(this._engine, this._container);
        this.pauseOnBlur = true;
        this.pauseOnOutsideViewport = true;
        this.responsive = [];
        this.smooth = false;
        this.style = {};
        this.themes = [];
        this.zLayers = 100;
    }
    load(data) {
        if (!data) return;
        if (data.preset !== undefined) (0, $b9FKP.executeOnSingleOrMultiple)(data.preset, (preset)=>this._importPreset(preset));
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.clear !== undefined) this.clear = data.clear;
        if (data.key !== undefined) this.key = data.key;
        if (data.name !== undefined) this.name = data.name;
        if (data.delay !== undefined) this.delay = (0, $8wHfp.setRangeValue)(data.delay);
        const detectRetina = data.detectRetina;
        if (detectRetina !== undefined) this.detectRetina = detectRetina;
        if (data.duration !== undefined) this.duration = (0, $8wHfp.setRangeValue)(data.duration);
        const fpsLimit = data.fpsLimit;
        if (fpsLimit !== undefined) this.fpsLimit = fpsLimit;
        if (data.pauseOnBlur !== undefined) this.pauseOnBlur = data.pauseOnBlur;
        if (data.pauseOnOutsideViewport !== undefined) this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
        if (data.zLayers !== undefined) this.zLayers = data.zLayers;
        this.background.load(data.background);
        const fullScreen = data.fullScreen;
        if ((0, $1Cbg8.isBoolean)(fullScreen)) this.fullScreen.enable = fullScreen;
        else this.fullScreen.load(fullScreen);
        this.backgroundMask.load(data.backgroundMask);
        this.interactivity.load(data.interactivity);
        if (data.manualParticles) this.manualParticles = data.manualParticles.map((t)=>{
            const tmp = new (0, $4fb4i.ManualParticle)();
            tmp.load(t);
            return tmp;
        });
        this.particles.load(data.particles);
        this.style = (0, $b9FKP.deepExtend)(this.style, data.style);
        this._engine.loadOptions(this, data);
        if (data.smooth !== undefined) this.smooth = data.smooth;
        const interactors = this._engine.interactors.get(this._container);
        if (interactors) {
            for (const interactor of interactors)if (interactor.loadOptions) interactor.loadOptions(this, data);
        }
        if (data.responsive !== undefined) for (const responsive of data.responsive){
            const optResponsive = new (0, $1UBOA.Responsive)();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
        }
        this.responsive.sort((a, b)=>a.maxWidth - b.maxWidth);
        if (data.themes !== undefined) for (const theme of data.themes){
            const existingTheme = this.themes.find((t)=>t.name === theme.name);
            if (!existingTheme) {
                const optTheme = new (0, $fpVR2.Theme)();
                optTheme.load(theme);
                this.themes.push(optTheme);
            } else existingTheme.load(theme);
        }
        this.defaultThemes.dark = this._findDefaultTheme("dark")?.name;
        this.defaultThemes.light = this._findDefaultTheme("light")?.name;
    }
    setResponsive(width, pxRatio, defaultOptions) {
        this.load(defaultOptions);
        const responsiveOptions = this.responsive.find((t)=>t.mode === "screen" && screen ? t.maxWidth > screen.availWidth : t.maxWidth * pxRatio > width);
        this.load(responsiveOptions?.options);
        return responsiveOptions?.maxWidth;
    }
    setTheme(name) {
        if (name) {
            const chosenTheme = this.themes.find((theme)=>theme.name === name);
            if (chosenTheme) this.load(chosenTheme.options);
        } else {
            const mediaMatch = (0, $b9FKP.safeMatchMedia)("(prefers-color-scheme: dark)"), clientDarkMode = mediaMatch && mediaMatch.matches, defaultTheme = this._findDefaultTheme(clientDarkMode ? "dark" : "light");
            if (defaultTheme) this.load(defaultTheme.options);
        }
    }
}

});
parcelRegister("1UBOA", function(module, exports) {

$parcel$export(module.exports, "Responsive", function () { return $16485aa4543021ac$export$49b67f1c7ac91d9b; });

var $b9FKP = parcelRequire("b9FKP");
class $16485aa4543021ac$export$49b67f1c7ac91d9b {
    constructor(){
        this.maxWidth = Infinity;
        this.options = {};
        this.mode = "canvas";
    }
    load(data) {
        if (!data) return;
        if (data.maxWidth !== undefined) this.maxWidth = data.maxWidth;
        if (data.mode !== undefined) {
            if (data.mode === "screen") this.mode = "screen";
            else this.mode = "canvas";
        }
        if (data.options !== undefined) this.options = (0, $b9FKP.deepExtend)({}, data.options);
    }
}

});

parcelRegister("fpVR2", function(module, exports) {

$parcel$export(module.exports, "Theme", function () { return $b396118685fa5213$export$14faa19a0f3bbeb2; });

var $3Bgmq = parcelRequire("3Bgmq");

var $b9FKP = parcelRequire("b9FKP");
class $b396118685fa5213$export$14faa19a0f3bbeb2 {
    constructor(){
        this.name = "";
        this.default = new (0, $3Bgmq.ThemeDefault)();
    }
    load(data) {
        if (!data) return;
        if (data.name !== undefined) this.name = data.name;
        this.default.load(data.default);
        if (data.options !== undefined) this.options = (0, $b9FKP.deepExtend)({}, data.options);
    }
}

});
parcelRegister("3Bgmq", function(module, exports) {

$parcel$export(module.exports, "ThemeDefault", function () { return $29f184b7cb7232c8$export$4bc81bcab6354024; });
class $29f184b7cb7232c8$export$4bc81bcab6354024 {
    constructor(){
        this.auto = false;
        this.mode = "any";
        this.value = false;
    }
    load(data) {
        if (!data) return;
        if (data.auto !== undefined) this.auto = data.auto;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}

});


parcelRegister("bPqPl", function(module, exports) {

$parcel$export(module.exports, "loadOptions", function () { return $89c9446f02a004cb$export$cad72087bded938; });
$parcel$export(module.exports, "loadParticlesOptions", function () { return $89c9446f02a004cb$export$3e14721506027822; });

var $7yCdy = parcelRequire("7yCdy");
function $89c9446f02a004cb$export$cad72087bded938(options, ...sourceOptionsArr) {
    for (const sourceOptions of sourceOptionsArr)options.load(sourceOptions);
}
function $89c9446f02a004cb$export$3e14721506027822(engine, container, ...sourceOptionsArr) {
    const options = new (0, $7yCdy.ParticlesOptions)(engine, container);
    $89c9446f02a004cb$export$cad72087bded938(options, ...sourceOptionsArr);
    return options;
}

});
parcelRegister("7yCdy", function(module, exports) {

$parcel$export(module.exports, "ParticlesOptions", function () { return $58095a95f164cca0$export$b4f1619131f0bce9; });

var $b9FKP = parcelRequire("b9FKP");

var $cHoex = parcelRequire("cHoex");

var $eUPzq = parcelRequire("eUPzq");

var $4ew4q = parcelRequire("4ew4q");

var $500nK = parcelRequire("500nK");

var $3PdrB = parcelRequire("3PdrB");

var $gt1eT = parcelRequire("gt1eT");

var $d4DmF = parcelRequire("d4DmF");

var $71DMI = parcelRequire("71DMI");

var $1Ts97 = parcelRequire("1Ts97");

var $gOwDF = parcelRequire("gOwDF");

var $5y8qA = parcelRequire("5y8qA");

var $dIIqE = parcelRequire("dIIqE");
class $58095a95f164cca0$export$b4f1619131f0bce9 {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
        this.bounce = new (0, $gt1eT.ParticlesBounce)();
        this.collisions = new (0, $eUPzq.Collisions)();
        this.color = new (0, $cHoex.AnimatableColor)();
        this.color.value = "#fff";
        this.effect = new (0, $4ew4q.Effect)();
        this.groups = {};
        this.move = new (0, $500nK.Move)();
        this.number = new (0, $d4DmF.ParticlesNumber)();
        this.opacity = new (0, $3PdrB.Opacity)();
        this.reduceDuplicates = false;
        this.shadow = new (0, $71DMI.Shadow)();
        this.shape = new (0, $1Ts97.Shape)();
        this.size = new (0, $gOwDF.Size)();
        this.stroke = new (0, $5y8qA.Stroke)();
        this.zIndex = new (0, $dIIqE.ZIndex)();
    }
    load(data) {
        if (!data) return;
        if (data.groups !== undefined) for (const group of Object.keys(data.groups)){
            if (!Object.hasOwn(data.groups, group)) continue;
            const item = data.groups[group];
            if (item !== undefined) this.groups[group] = (0, $b9FKP.deepExtend)(this.groups[group] ?? {}, item);
        }
        if (data.reduceDuplicates !== undefined) this.reduceDuplicates = data.reduceDuplicates;
        this.bounce.load(data.bounce);
        this.color.load((0, $cHoex.AnimatableColor).create(this.color, data.color));
        this.effect.load(data.effect);
        this.move.load(data.move);
        this.number.load(data.number);
        this.opacity.load(data.opacity);
        this.shape.load(data.shape);
        this.size.load(data.size);
        this.shadow.load(data.shadow);
        this.zIndex.load(data.zIndex);
        this.collisions.load(data.collisions);
        if (data.interactivity !== undefined) this.interactivity = (0, $b9FKP.deepExtend)({}, data.interactivity);
        const strokeToLoad = data.stroke;
        if (strokeToLoad) this.stroke = (0, $b9FKP.executeOnSingleOrMultiple)(strokeToLoad, (t)=>{
            const tmp = new (0, $5y8qA.Stroke)();
            tmp.load(t);
            return tmp;
        });
        if (this._container) {
            const updaters = this._engine.updaters.get(this._container);
            if (updaters) {
                for (const updater of updaters)if (updater.loadOptions) updater.loadOptions(this, data);
            }
            const interactors = this._engine.interactors.get(this._container);
            if (interactors) {
                for (const interactor of interactors)if (interactor.loadParticlesOptions) interactor.loadParticlesOptions(this, data);
            }
        }
    }
}

});
parcelRegister("eUPzq", function(module, exports) {

$parcel$export(module.exports, "Collisions", function () { return $adbe4c7a31e103ac$export$97ff58b0eb9a5ed0; });

var $2qdVq = parcelRequire("2qdVq");

var $k7yaC = parcelRequire("k7yaC");

var $gt1eT = parcelRequire("gt1eT");

var $8wHfp = parcelRequire("8wHfp");
class $adbe4c7a31e103ac$export$97ff58b0eb9a5ed0 {
    constructor(){
        this.absorb = new (0, $2qdVq.CollisionsAbsorb)();
        this.bounce = new (0, $gt1eT.ParticlesBounce)();
        this.enable = false;
        this.maxSpeed = 50;
        this.mode = "bounce";
        this.overlap = new (0, $k7yaC.CollisionsOverlap)();
    }
    load(data) {
        if (!data) return;
        this.absorb.load(data.absorb);
        this.bounce.load(data.bounce);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $8wHfp.setRangeValue)(data.maxSpeed);
        if (data.mode !== undefined) this.mode = data.mode;
        this.overlap.load(data.overlap);
    }
}

});
parcelRegister("2qdVq", function(module, exports) {

$parcel$export(module.exports, "CollisionsAbsorb", function () { return $1c38cfbbe428808c$export$dbafb70800ee3f9b; });
class $1c38cfbbe428808c$export$dbafb70800ee3f9b {
    constructor(){
        this.speed = 2;
    }
    load(data) {
        if (!data) return;
        if (data.speed !== undefined) this.speed = data.speed;
    }
}

});

parcelRegister("k7yaC", function(module, exports) {

$parcel$export(module.exports, "CollisionsOverlap", function () { return $ea5ef7991b16688a$export$7dac291125fc16da; });
class $ea5ef7991b16688a$export$7dac291125fc16da {
    constructor(){
        this.enable = true;
        this.retries = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.retries !== undefined) this.retries = data.retries;
    }
}

});

parcelRegister("gt1eT", function(module, exports) {

$parcel$export(module.exports, "ParticlesBounce", function () { return $bfd050d51b143d7e$export$e6dd54c89cd6ac88; });

var $kQpzQ = parcelRequire("kQpzQ");
class $bfd050d51b143d7e$export$e6dd54c89cd6ac88 {
    constructor(){
        this.horizontal = new (0, $kQpzQ.ParticlesBounceFactor)();
        this.vertical = new (0, $kQpzQ.ParticlesBounceFactor)();
    }
    load(data) {
        if (!data) return;
        this.horizontal.load(data.horizontal);
        this.vertical.load(data.vertical);
    }
}

});
parcelRegister("kQpzQ", function(module, exports) {

$parcel$export(module.exports, "ParticlesBounceFactor", function () { return $f2cc810bd0855479$export$855823db9a0085c; });

var $dusZm = parcelRequire("dusZm");
class $f2cc810bd0855479$export$855823db9a0085c extends (0, $dusZm.ValueWithRandom) {
    constructor(){
        super();
        this.value = 1;
    }
}

});
parcelRegister("dusZm", function(module, exports) {

$parcel$export(module.exports, "ValueWithRandom", function () { return $9d24903e86ab2ab9$export$2f74c042fca0b66d; });
$parcel$export(module.exports, "RangedAnimationValueWithRandom", function () { return $9d24903e86ab2ab9$export$8d0da1142c209427; });

var $4CK3F = parcelRequire("4CK3F");

var $8wHfp = parcelRequire("8wHfp");
class $9d24903e86ab2ab9$export$2f74c042fca0b66d {
    constructor(){
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if (data.value !== undefined) this.value = (0, $8wHfp.setRangeValue)(data.value);
    }
}
class $9d24903e86ab2ab9$export$a0fda83b6e14e586 extends $9d24903e86ab2ab9$export$2f74c042fca0b66d {
    constructor(){
        super();
        this.animation = new (0, $4CK3F.AnimationOptions)();
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}
class $9d24903e86ab2ab9$export$8d0da1142c209427 extends $9d24903e86ab2ab9$export$a0fda83b6e14e586 {
    constructor(){
        super();
        this.animation = new (0, $4CK3F.RangedAnimationOptions)();
    }
    load(data) {
        super.load(data);
    }
}

});




parcelRegister("4ew4q", function(module, exports) {

$parcel$export(module.exports, "Effect", function () { return $315158bcfcf3fe69$export$a32b0b1c1ac59d04; });

var $b9FKP = parcelRequire("b9FKP");
class $315158bcfcf3fe69$export$a32b0b1c1ac59d04 {
    constructor(){
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = [];
    }
    load(data) {
        if (!data) return;
        const options = data.options;
        if (options !== undefined) for(const effect in options){
            const item = options[effect];
            if (item) this.options[effect] = (0, $b9FKP.deepExtend)(this.options[effect] ?? {}, item);
        }
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}

});

parcelRegister("500nK", function(module, exports) {

$parcel$export(module.exports, "Move", function () { return $3a3d3fb39aa57b48$export$e49a5ad3dd6df925; });

var $1Cbg8 = parcelRequire("1Cbg8");

var $yeiCA = parcelRequire("yeiCA");

var $6bIr7 = parcelRequire("6bIr7");

var $laB4H = parcelRequire("laB4H");

var $fVGHe = parcelRequire("fVGHe");

var $aEDsA = parcelRequire("aEDsA");

var $9XDjp = parcelRequire("9XDjp");

var $gmix7 = parcelRequire("gmix7");

var $gH2dY = parcelRequire("gH2dY");

var $8wHfp = parcelRequire("8wHfp");
class $3a3d3fb39aa57b48$export$e49a5ad3dd6df925 {
    constructor(){
        this.angle = new (0, $yeiCA.MoveAngle)();
        this.attract = new (0, $6bIr7.MoveAttract)();
        this.center = new (0, $laB4H.MoveCenter)();
        this.decay = 0;
        this.distance = {};
        this.direction = "none";
        this.drift = 0;
        this.enable = false;
        this.gravity = new (0, $fVGHe.MoveGravity)();
        this.path = new (0, $aEDsA.MovePath)();
        this.outModes = new (0, $gmix7.OutModes)();
        this.random = false;
        this.size = false;
        this.speed = 2;
        this.spin = new (0, $gH2dY.Spin)();
        this.straight = false;
        this.trail = new (0, $9XDjp.MoveTrail)();
        this.vibrate = false;
        this.warp = false;
    }
    load(data) {
        if (!data) return;
        this.angle.load((0, $1Cbg8.isNumber)(data.angle) ? {
            value: data.angle
        } : data.angle);
        this.attract.load(data.attract);
        this.center.load(data.center);
        if (data.decay !== undefined) this.decay = (0, $8wHfp.setRangeValue)(data.decay);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.distance !== undefined) this.distance = (0, $1Cbg8.isNumber)(data.distance) ? {
            horizontal: data.distance,
            vertical: data.distance
        } : {
            ...data.distance
        };
        if (data.drift !== undefined) this.drift = (0, $8wHfp.setRangeValue)(data.drift);
        if (data.enable !== undefined) this.enable = data.enable;
        this.gravity.load(data.gravity);
        const outModes = data.outModes;
        if (outModes !== undefined) {
            if ((0, $1Cbg8.isObject)(outModes)) this.outModes.load(outModes);
            else this.outModes.load({
                default: outModes
            });
        }
        this.path.load(data.path);
        if (data.random !== undefined) this.random = data.random;
        if (data.size !== undefined) this.size = data.size;
        if (data.speed !== undefined) this.speed = (0, $8wHfp.setRangeValue)(data.speed);
        this.spin.load(data.spin);
        if (data.straight !== undefined) this.straight = data.straight;
        this.trail.load(data.trail);
        if (data.vibrate !== undefined) this.vibrate = data.vibrate;
        if (data.warp !== undefined) this.warp = data.warp;
    }
}

});
parcelRegister("yeiCA", function(module, exports) {

$parcel$export(module.exports, "MoveAngle", function () { return $066e44a48600d5f5$export$128f6c8d329dc399; });

var $8wHfp = parcelRequire("8wHfp");
class $066e44a48600d5f5$export$128f6c8d329dc399 {
    constructor(){
        this.offset = 0;
        this.value = 90;
    }
    load(data) {
        if (!data) return;
        if (data.offset !== undefined) this.offset = (0, $8wHfp.setRangeValue)(data.offset);
        if (data.value !== undefined) this.value = (0, $8wHfp.setRangeValue)(data.value);
    }
}

});

parcelRegister("6bIr7", function(module, exports) {

$parcel$export(module.exports, "MoveAttract", function () { return $48163d4f46dea899$export$6c54633883102b4b; });

var $8wHfp = parcelRequire("8wHfp");
class $48163d4f46dea899$export$6c54633883102b4b {
    constructor(){
        this.distance = 200;
        this.enable = false;
        this.rotate = {
            x: 3000,
            y: 3000
        };
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = (0, $8wHfp.setRangeValue)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.rotate) {
            const rotateX = data.rotate.x;
            if (rotateX !== undefined) this.rotate.x = rotateX;
            const rotateY = data.rotate.y;
            if (rotateY !== undefined) this.rotate.y = rotateY;
        }
    }
}

});

parcelRegister("laB4H", function(module, exports) {

$parcel$export(module.exports, "MoveCenter", function () { return $f6974a6fe6fb355c$export$7b60622f06eeec06; });
class $f6974a6fe6fb355c$export$7b60622f06eeec06 {
    constructor(){
        this.x = 50;
        this.y = 50;
        this.mode = "percent";
        this.radius = 0;
    }
    load(data) {
        if (!data) return;
        if (data.x !== undefined) this.x = data.x;
        if (data.y !== undefined) this.y = data.y;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}

});

parcelRegister("fVGHe", function(module, exports) {

$parcel$export(module.exports, "MoveGravity", function () { return $b98d4c7b641fd3cf$export$c6d1f1b3593b164c; });

var $8wHfp = parcelRequire("8wHfp");
class $b98d4c7b641fd3cf$export$c6d1f1b3593b164c {
    constructor(){
        this.acceleration = 9.81;
        this.enable = false;
        this.inverse = false;
        this.maxSpeed = 50;
    }
    load(data) {
        if (!data) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $8wHfp.setRangeValue)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.inverse !== undefined) this.inverse = data.inverse;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $8wHfp.setRangeValue)(data.maxSpeed);
    }
}

});

parcelRegister("aEDsA", function(module, exports) {

$parcel$export(module.exports, "MovePath", function () { return $7c1c3fbed570e778$export$bcc70636a6a97e73; });

var $dusZm = parcelRequire("dusZm");

var $b9FKP = parcelRequire("b9FKP");
class $7c1c3fbed570e778$export$bcc70636a6a97e73 {
    constructor(){
        this.clamp = true;
        this.delay = new (0, $dusZm.ValueWithRandom)();
        this.enable = false;
        this.options = {};
    }
    load(data) {
        if (!data) return;
        if (data.clamp !== undefined) this.clamp = data.clamp;
        this.delay.load(data.delay);
        if (data.enable !== undefined) this.enable = data.enable;
        this.generator = data.generator;
        if (data.options) this.options = (0, $b9FKP.deepExtend)(this.options, data.options);
    }
}

});

parcelRegister("9XDjp", function(module, exports) {

$parcel$export(module.exports, "MoveTrail", function () { return $74081e47641ee4f9$export$e428bb3fcf53809d; });

var $2UunS = parcelRequire("2UunS");
class $74081e47641ee4f9$export$e428bb3fcf53809d {
    constructor(){
        this.enable = false;
        this.length = 10;
        this.fill = new (0, $2UunS.MoveTrailFill)();
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.fill !== undefined) this.fill.load(data.fill);
        if (data.length !== undefined) this.length = data.length;
    }
}

});
parcelRegister("2UunS", function(module, exports) {

$parcel$export(module.exports, "MoveTrailFill", function () { return $21e8615e38f87b44$export$7518c5bd39f0f31a; });

var $ceG2E = parcelRequire("ceG2E");
class $21e8615e38f87b44$export$7518c5bd39f0f31a {
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $ceG2E.OptionsColor).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
    }
}

});


parcelRegister("gmix7", function(module, exports) {

$parcel$export(module.exports, "OutModes", function () { return $be8d13baf7880a99$export$647cf31ffff2d3; });
class $be8d13baf7880a99$export$647cf31ffff2d3 {
    constructor(){
        this.default = "out";
    }
    load(data) {
        if (!data) return;
        if (data.default !== undefined) this.default = data.default;
        this.bottom = data.bottom ?? data.default;
        this.left = data.left ?? data.default;
        this.right = data.right ?? data.default;
        this.top = data.top ?? data.default;
    }
}

});

parcelRegister("gH2dY", function(module, exports) {

$parcel$export(module.exports, "Spin", function () { return $c2726331e764abee$export$fcd783eeafc305c0; });

var $b9FKP = parcelRequire("b9FKP");

var $8wHfp = parcelRequire("8wHfp");
class $c2726331e764abee$export$fcd783eeafc305c0 {
    constructor(){
        this.acceleration = 0;
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $8wHfp.setRangeValue)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.position) this.position = (0, $b9FKP.deepExtend)({}, data.position);
    }
}

});


parcelRegister("3PdrB", function(module, exports) {

$parcel$export(module.exports, "Opacity", function () { return $2c909046848d06fa$export$588760baa0f6108e; });

var $5WmnD = parcelRequire("5WmnD");

var $dusZm = parcelRequire("dusZm");
class $2c909046848d06fa$export$588760baa0f6108e extends (0, $dusZm.RangedAnimationValueWithRandom) {
    constructor(){
        super();
        this.animation = new (0, $5WmnD.OpacityAnimation)();
        this.value = 1;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}

});
parcelRegister("5WmnD", function(module, exports) {

$parcel$export(module.exports, "OpacityAnimation", function () { return $4533bac83293b73d$export$3e55dc49e2356209; });

var $4CK3F = parcelRequire("4CK3F");
class $4533bac83293b73d$export$3e55dc49e2356209 extends (0, $4CK3F.RangedAnimationOptions) {
    constructor(){
        super();
        this.destroy = "none";
        this.speed = 2;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}

});


parcelRegister("d4DmF", function(module, exports) {

$parcel$export(module.exports, "ParticlesNumber", function () { return $984a2f141775021f$export$2335cf7e85f36cfd; });

var $lVl6w = parcelRequire("lVl6w");

var $TkwXE = parcelRequire("TkwXE");
class $984a2f141775021f$export$2335cf7e85f36cfd {
    constructor(){
        this.density = new (0, $lVl6w.ParticlesDensity)();
        this.limit = new (0, $TkwXE.ParticlesNumberLimit)();
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        this.density.load(data.density);
        this.limit.load(data.limit);
        if (data.value !== undefined) this.value = data.value;
    }
}

});
parcelRegister("lVl6w", function(module, exports) {

$parcel$export(module.exports, "ParticlesDensity", function () { return $ff5f4aae94094b20$export$c11b1f56b7022ac8; });
class $ff5f4aae94094b20$export$c11b1f56b7022ac8 {
    constructor(){
        this.enable = false;
        this.width = 1920;
        this.height = 1080;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        const width = data.width;
        if (width !== undefined) this.width = width;
        const height = data.height;
        if (height !== undefined) this.height = height;
    }
}

});

parcelRegister("TkwXE", function(module, exports) {

$parcel$export(module.exports, "ParticlesNumberLimit", function () { return $0a65101fc70fc4d4$export$924e931bcf950072; });
class $0a65101fc70fc4d4$export$924e931bcf950072 {
    constructor(){
        this.mode = "delete";
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}

});


parcelRegister("71DMI", function(module, exports) {

$parcel$export(module.exports, "Shadow", function () { return $51d77cd1a33e22cc$export$a24c14443968327c; });

var $ceG2E = parcelRequire("ceG2E");
class $51d77cd1a33e22cc$export$a24c14443968327c {
    constructor(){
        this.blur = 0;
        this.color = new (0, $ceG2E.OptionsColor)();
        this.enable = false;
        this.offset = {
            x: 0,
            y: 0
        };
        this.color.value = "#000";
    }
    load(data) {
        if (!data) return;
        if (data.blur !== undefined) this.blur = data.blur;
        this.color = (0, $ceG2E.OptionsColor).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.offset === undefined) return;
        if (data.offset.x !== undefined) this.offset.x = data.offset.x;
        if (data.offset.y !== undefined) this.offset.y = data.offset.y;
    }
}

});

parcelRegister("1Ts97", function(module, exports) {

$parcel$export(module.exports, "Shape", function () { return $1610c2b7b956a5c5$export$6428a7f2611ef1fa; });

var $b9FKP = parcelRequire("b9FKP");
class $1610c2b7b956a5c5$export$6428a7f2611ef1fa {
    constructor(){
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = "circle";
    }
    load(data) {
        if (!data) return;
        const options = data.options;
        if (options !== undefined) for(const shape in options){
            const item = options[shape];
            if (item) this.options[shape] = (0, $b9FKP.deepExtend)(this.options[shape] ?? {}, item);
        }
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}

});

parcelRegister("gOwDF", function(module, exports) {

$parcel$export(module.exports, "Size", function () { return $c3daa23856bd5c8b$export$cb6da89c6af1a8ec; });

var $dusZm = parcelRequire("dusZm");

var $5d6o4 = parcelRequire("5d6o4");
class $c3daa23856bd5c8b$export$cb6da89c6af1a8ec extends (0, $dusZm.RangedAnimationValueWithRandom) {
    constructor(){
        super();
        this.animation = new (0, $5d6o4.SizeAnimation)();
        this.value = 3;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}

});
parcelRegister("5d6o4", function(module, exports) {

$parcel$export(module.exports, "SizeAnimation", function () { return $3cb31f052da5c98d$export$231e08f1693c0669; });

var $4CK3F = parcelRequire("4CK3F");
class $3cb31f052da5c98d$export$231e08f1693c0669 extends (0, $4CK3F.RangedAnimationOptions) {
    constructor(){
        super();
        this.destroy = "none";
        this.speed = 5;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}

});


parcelRegister("5y8qA", function(module, exports) {

$parcel$export(module.exports, "Stroke", function () { return $40a6aa4b3d146867$export$18d19c7a3aa33064; });

var $cHoex = parcelRequire("cHoex");

var $8wHfp = parcelRequire("8wHfp");
class $40a6aa4b3d146867$export$18d19c7a3aa33064 {
    constructor(){
        this.width = 0;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $cHoex.AnimatableColor).create(this.color, data.color);
        if (data.width !== undefined) this.width = (0, $8wHfp.setRangeValue)(data.width);
        if (data.opacity !== undefined) this.opacity = (0, $8wHfp.setRangeValue)(data.opacity);
    }
}

});

parcelRegister("dIIqE", function(module, exports) {

$parcel$export(module.exports, "ZIndex", function () { return $9fd1d912f5642bfe$export$ccb31788083e2069; });

var $dusZm = parcelRequire("dusZm");
class $9fd1d912f5642bfe$export$ccb31788083e2069 extends (0, $dusZm.ValueWithRandom) {
    constructor(){
        super();
        this.opacityRate = 1;
        this.sizeRate = 1;
        this.velocityRate = 1;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.opacityRate !== undefined) this.opacityRate = data.opacityRate;
        if (data.sizeRate !== undefined) this.sizeRate = data.sizeRate;
        if (data.velocityRate !== undefined) this.velocityRate = data.velocityRate;
    }
}

});




parcelRegister("7Cxfx", function(module, exports) {

$parcel$export(module.exports, "drawLine", function () { return $58c5dfb1c8fabbe2$export$819db45aec5fcbe5; });
$parcel$export(module.exports, "paintBase", function () { return $58c5dfb1c8fabbe2$export$2837cdf5427f767e; });
$parcel$export(module.exports, "paintImage", function () { return $58c5dfb1c8fabbe2$export$a17334b9431a8cb2; });
$parcel$export(module.exports, "clear", function () { return $58c5dfb1c8fabbe2$export$42ffd38884aecdac; });
$parcel$export(module.exports, "drawParticle", function () { return $58c5dfb1c8fabbe2$export$fca8f175741ef351; });
$parcel$export(module.exports, "drawPlugin", function () { return $58c5dfb1c8fabbe2$export$ee9933e1bf4ba142; });
$parcel$export(module.exports, "drawParticlePlugin", function () { return $58c5dfb1c8fabbe2$export$3493f6d6277d918a; });
$parcel$export(module.exports, "alterHsl", function () { return $58c5dfb1c8fabbe2$export$fe1d034b0e82666; });

var $lr6PC = parcelRequire("lr6PC");
const $58c5dfb1c8fabbe2$var$origin = {
    x: 0,
    y: 0
};
function $58c5dfb1c8fabbe2$export$819db45aec5fcbe5(context, begin, end) {
    context.beginPath();
    context.moveTo(begin.x, begin.y);
    context.lineTo(end.x, end.y);
    context.closePath();
}
function $58c5dfb1c8fabbe2$export$2837cdf5427f767e(context, dimension, baseColor) {
    context.fillStyle = baseColor ?? "rgba(0,0,0,0)";
    context.fillRect($58c5dfb1c8fabbe2$var$origin.x, $58c5dfb1c8fabbe2$var$origin.y, dimension.width, dimension.height);
}
function $58c5dfb1c8fabbe2$export$a17334b9431a8cb2(context, dimension, image, opacity) {
    if (!image) return;
    context.globalAlpha = opacity;
    context.drawImage(image, $58c5dfb1c8fabbe2$var$origin.x, $58c5dfb1c8fabbe2$var$origin.y, dimension.width, dimension.height);
    context.globalAlpha = 1;
}
function $58c5dfb1c8fabbe2$export$42ffd38884aecdac(context, dimension) {
    context.clearRect($58c5dfb1c8fabbe2$var$origin.x, $58c5dfb1c8fabbe2$var$origin.y, dimension.width, dimension.height);
}
function $58c5dfb1c8fabbe2$export$fca8f175741ef351(data) {
    const { container: container, context: context, particle: particle, delta: delta, colorStyles: colorStyles, backgroundMask: backgroundMask, composite: composite, radius: radius, opacity: opacity, shadow: shadow, transform: transform } = data, pos = particle.getPosition(), defaultAngle = 0, angle = particle.rotation + (particle.pathRotation ? particle.velocity.angle : defaultAngle), rotateData = {
        sin: Math.sin(angle),
        cos: Math.cos(angle)
    }, defaultTransformFactor = 1, transformData = {
        a: rotateData.cos * (transform.a ?? defaultTransformFactor),
        b: rotateData.sin * (transform.b ?? defaultTransformFactor),
        c: -rotateData.sin * (transform.c ?? defaultTransformFactor),
        d: rotateData.cos * (transform.d ?? defaultTransformFactor)
    };
    context.setTransform(transformData.a, transformData.b, transformData.c, transformData.d, pos.x, pos.y);
    if (backgroundMask) context.globalCompositeOperation = composite;
    const shadowColor = particle.shadowColor;
    if (shadow.enable && shadowColor) {
        context.shadowBlur = shadow.blur;
        context.shadowColor = (0, $lr6PC.getStyleFromRgb)(shadowColor);
        context.shadowOffsetX = shadow.offset.x;
        context.shadowOffsetY = shadow.offset.y;
    }
    if (colorStyles.fill) context.fillStyle = colorStyles.fill;
    const minStrokeWidth = 0, strokeWidth = particle.strokeWidth ?? minStrokeWidth;
    context.lineWidth = strokeWidth;
    if (colorStyles.stroke) context.strokeStyle = colorStyles.stroke;
    const drawData = {
        container: container,
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        transformData: transformData,
        strokeWidth: strokeWidth
    };
    $58c5dfb1c8fabbe2$export$71b514a25c47df50(drawData);
    $58c5dfb1c8fabbe2$export$2808702213c51f09(drawData);
    $58c5dfb1c8fabbe2$export$27b58ff3abda0f8e(drawData);
    context.globalCompositeOperation = "source-over";
    context.resetTransform();
}
function $58c5dfb1c8fabbe2$export$27b58ff3abda0f8e(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, transformData: transformData } = data;
    if (!particle.effect) return;
    const drawer = container.effectDrawers.get(particle.effect);
    if (!drawer) return;
    drawer.draw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
}
function $58c5dfb1c8fabbe2$export$71b514a25c47df50(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, strokeWidth: strokeWidth, transformData: transformData } = data, minStrokeWidth = 0;
    if (!particle.shape) return;
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer) return;
    context.beginPath();
    drawer.draw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
    if (particle.shapeClose) context.closePath();
    if (strokeWidth > minStrokeWidth) context.stroke();
    if (particle.shapeFill) context.fill();
}
function $58c5dfb1c8fabbe2$export$2808702213c51f09(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, transformData: transformData } = data;
    if (!particle.shape) return;
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer?.afterDraw) return;
    drawer.afterDraw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
}
function $58c5dfb1c8fabbe2$export$ee9933e1bf4ba142(context, plugin, delta) {
    if (!plugin.draw) return;
    plugin.draw(context, delta);
}
function $58c5dfb1c8fabbe2$export$3493f6d6277d918a(context, plugin, particle, delta) {
    if (!plugin.drawParticle) return;
    plugin.drawParticle(context, particle, delta);
}
function $58c5dfb1c8fabbe2$export$fe1d034b0e82666(color, type, value) {
    const lFactor = 1;
    return {
        h: color.h,
        s: color.s,
        l: color.l + (type === "darken" ? -lFactor : lFactor) * value
    };
}

});


parcelRegister("86buA", function(module, exports) {
parcelRequire("kUZNn");
parcelRequire("iBE7f");
parcelRequire("1UmuA");
parcelRequire("c2Pci");
parcelRequire("eawO6");
parcelRequire("jPiu4");
parcelRequire("2ZPhh");
parcelRequire("lFd0T");
parcelRequire("hlbgJ");
parcelRequire("l0wlq");
parcelRequire("jlrjx");
parcelRequire("4eetc");
parcelRequire("c2F4y");
parcelRequire("irPHv");
parcelRequire("cyWmi");
parcelRequire("8L3RH");
parcelRequire("4yjHA");
parcelRequire("6kowR");
parcelRequire("fzBWT");
parcelRequire("4dgTp");
parcelRequire("5RauD");
parcelRequire("62qiT");
parcelRequire("cbntD");
parcelRequire("dZ3km");
parcelRequire("jJj9I");
parcelRequire("8XLxX");
parcelRequire("6e78Q");
parcelRequire("5jKjR");
parcelRequire("8gybF");
parcelRequire("99SCR");
parcelRequire("jyh5S");
parcelRequire("cqb9J");
parcelRequire("e2aCg");
parcelRequire("gNgzM");
parcelRequire("lvj5m");
parcelRequire("7iTvR");
parcelRequire("lUvgr");
parcelRequire("kcwqp");
parcelRequire("3uTeI");
parcelRequire("ioYiW");
parcelRequire("gFmZB");
parcelRequire("fXpUB");
parcelRequire("gXVU3");
parcelRequire("6565t");
parcelRequire("dlkoB");
parcelRequire("avwT4");
parcelRequire("lu2Jd");
parcelRequire("hFEUv");
parcelRequire("1SjNC");
parcelRequire("kuJgt");
parcelRequire("lKoP3");
parcelRequire("lpicp");
parcelRequire("l0raO");
parcelRequire("3QxcA");
parcelRequire("8ibiq");
parcelRequire("3qK1L");
parcelRequire("hl7u1");
parcelRequire("ep6AH");
parcelRequire("lNZnA");
parcelRequire("hp4G5");
parcelRequire("gTVjI");
parcelRequire("iC24K");
parcelRequire("9HMoW");
parcelRequire("5grBN");
parcelRequire("03a1M");
parcelRequire("dmBB6");
parcelRequire("54LRM");
parcelRequire("2NbP9");
parcelRequire("kFuRX");
parcelRequire("k5EEs");
parcelRequire("lEjBp");
parcelRequire("3SCHi");
parcelRequire("9biMe");
parcelRequire("f2B5o");
parcelRequire("3d7Wj");
parcelRequire("4kqXj");
parcelRequire("dkGMw");
parcelRequire("2SIDB");
parcelRequire("eTIK5");
parcelRequire("ixhdN");
parcelRequire("2nB8A");
parcelRequire("hjAqA");
parcelRequire("2vbJU");
parcelRequire("8GWGB");
parcelRequire("ha66G");
parcelRequire("j7uML");
parcelRequire("fRuSg");
parcelRequire("f1PXe");
parcelRequire("9u73I");
parcelRequire("e56Lh");
parcelRequire("cozVV");
parcelRequire("ewC35");
parcelRequire("8rbPL");
parcelRequire("2YPGz");
parcelRequire("7vPRq");
parcelRequire("53qP7");
parcelRequire("7SzhB");
parcelRequire("gnX38");
parcelRequire("4PlVK");

});
parcelRegister("kUZNn", function(module, exports) {

});

parcelRegister("iBE7f", function(module, exports) {

});

parcelRegister("1UmuA", function(module, exports) {

});

parcelRegister("c2Pci", function(module, exports) {

});

parcelRegister("eawO6", function(module, exports) {

});

parcelRegister("jPiu4", function(module, exports) {

});

parcelRegister("2ZPhh", function(module, exports) {

});

parcelRegister("lFd0T", function(module, exports) {

});

parcelRegister("hlbgJ", function(module, exports) {

});

parcelRegister("l0wlq", function(module, exports) {

});

parcelRegister("jlrjx", function(module, exports) {

});

parcelRegister("4eetc", function(module, exports) {

});

parcelRegister("c2F4y", function(module, exports) {

});

parcelRegister("irPHv", function(module, exports) {

});

parcelRegister("cyWmi", function(module, exports) {

});

parcelRegister("8L3RH", function(module, exports) {

});

parcelRegister("4yjHA", function(module, exports) {

});

parcelRegister("6kowR", function(module, exports) {

});

parcelRegister("fzBWT", function(module, exports) {

});

parcelRegister("4dgTp", function(module, exports) {

});

parcelRegister("5RauD", function(module, exports) {

});

parcelRegister("62qiT", function(module, exports) {

});

parcelRegister("cbntD", function(module, exports) {

});

parcelRegister("dZ3km", function(module, exports) {

});

parcelRegister("jJj9I", function(module, exports) {

});

parcelRegister("8XLxX", function(module, exports) {

});

parcelRegister("6e78Q", function(module, exports) {

});

parcelRegister("5jKjR", function(module, exports) {

});

parcelRegister("8gybF", function(module, exports) {

});

parcelRegister("99SCR", function(module, exports) {

});

parcelRegister("jyh5S", function(module, exports) {

});

parcelRegister("cqb9J", function(module, exports) {

});

parcelRegister("e2aCg", function(module, exports) {

});

parcelRegister("gNgzM", function(module, exports) {

});

parcelRegister("lvj5m", function(module, exports) {

});

parcelRegister("7iTvR", function(module, exports) {

});

parcelRegister("lUvgr", function(module, exports) {

});

parcelRegister("kcwqp", function(module, exports) {

});

parcelRegister("3uTeI", function(module, exports) {

});

parcelRegister("ioYiW", function(module, exports) {

});

parcelRegister("gFmZB", function(module, exports) {

});

parcelRegister("fXpUB", function(module, exports) {

});

parcelRegister("gXVU3", function(module, exports) {

});

parcelRegister("6565t", function(module, exports) {

});

parcelRegister("dlkoB", function(module, exports) {

});

parcelRegister("avwT4", function(module, exports) {

});

parcelRegister("lu2Jd", function(module, exports) {

});

parcelRegister("hFEUv", function(module, exports) {

});

parcelRegister("1SjNC", function(module, exports) {

});

parcelRegister("kuJgt", function(module, exports) {

});

parcelRegister("lKoP3", function(module, exports) {

});

parcelRegister("lpicp", function(module, exports) {

});

parcelRegister("l0raO", function(module, exports) {

});

parcelRegister("3QxcA", function(module, exports) {

});

parcelRegister("8ibiq", function(module, exports) {

});

parcelRegister("3qK1L", function(module, exports) {

});

parcelRegister("hl7u1", function(module, exports) {

});

parcelRegister("ep6AH", function(module, exports) {

});

parcelRegister("lNZnA", function(module, exports) {

});

parcelRegister("hp4G5", function(module, exports) {

});

parcelRegister("gTVjI", function(module, exports) {

});

parcelRegister("iC24K", function(module, exports) {

});

parcelRegister("9HMoW", function(module, exports) {

});

parcelRegister("5grBN", function(module, exports) {

});

parcelRegister("03a1M", function(module, exports) {

});

parcelRegister("dmBB6", function(module, exports) {

});

parcelRegister("54LRM", function(module, exports) {

});

parcelRegister("2NbP9", function(module, exports) {

});

parcelRegister("kFuRX", function(module, exports) {

});

parcelRegister("k5EEs", function(module, exports) {

});

parcelRegister("lEjBp", function(module, exports) {

});

parcelRegister("3SCHi", function(module, exports) {

});

parcelRegister("9biMe", function(module, exports) {

});

parcelRegister("f2B5o", function(module, exports) {

});

parcelRegister("3d7Wj", function(module, exports) {

});

parcelRegister("4kqXj", function(module, exports) {

});

parcelRegister("dkGMw", function(module, exports) {

});

parcelRegister("2SIDB", function(module, exports) {

});

parcelRegister("eTIK5", function(module, exports) {

});

parcelRegister("ixhdN", function(module, exports) {

});

parcelRegister("2nB8A", function(module, exports) {

});

parcelRegister("hjAqA", function(module, exports) {

});

parcelRegister("2vbJU", function(module, exports) {

});

parcelRegister("8GWGB", function(module, exports) {

});

parcelRegister("ha66G", function(module, exports) {

});

parcelRegister("j7uML", function(module, exports) {

});

parcelRegister("fRuSg", function(module, exports) {

});

parcelRegister("f1PXe", function(module, exports) {

});

parcelRegister("9u73I", function(module, exports) {

});

parcelRegister("e56Lh", function(module, exports) {

});

parcelRegister("cozVV", function(module, exports) {

});

parcelRegister("ewC35", function(module, exports) {

});

parcelRegister("8rbPL", function(module, exports) {

});

parcelRegister("2YPGz", function(module, exports) {

});

parcelRegister("7vPRq", function(module, exports) {

});

parcelRegister("53qP7", function(module, exports) {

});

parcelRegister("7SzhB", function(module, exports) {

});

parcelRegister("gnX38", function(module, exports) {

});

parcelRegister("4PlVK", function(module, exports) {

});



parcelRegister("88ZgS", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("5oj9n")).then(()=>parcelRequire("iFl0x"));

});

parcelRegister("gs7zA", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("1UnOy")).then(()=>parcelRequire("fmc9i"));

});

parcelRegister("eLQQ9", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("foTvv")).then(()=>parcelRequire("bOmST"));

});

parcelRegister("kRJI3", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("judiA")).then(()=>parcelRequire("jl5tA"));

});

parcelRegister("7dng1", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("9OMXX")).then(()=>parcelRequire("5Ywqw"));

});

parcelRegister("2a9sr", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("9mKZk")).then(()=>parcelRequire("gGRis"));

});

parcelRegister("8rrad", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("ei6WD")).then(()=>parcelRequire("i0IYW"));

});

parcelRegister("96b2u", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("l3ih5")).then(()=>parcelRequire("hTRTB"));

});

parcelRegister("h7qy4", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("918dt")).then(()=>parcelRequire("21mP9"));

});

parcelRegister("eIoUx", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("35jm5")).then(()=>parcelRequire("81pm5"));

});

parcelRegister("2BPir", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("1jIQB")).then(()=>parcelRequire("b5CiH"));

});

parcelRegister("2Svek", function(module, exports) {


module.exports = (parcelRequire("hKRz6"))((parcelRequire("dP3ew")).resolve("eARWC")).then(()=>parcelRequire("fskNs"));

});

parcelRegister("4up07", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");

var $9Yw4l = parcelRequire("9Yw4l");

var $cFNax = parcelRequire("cFNax");

var $4cXXK = parcelRequire("4cXXK");

var $detur = parcelRequire("detur");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $344d5b672616e01d$var$createInstance(defaultConfig) {
    var context = new $cFNax(defaultConfig);
    var instance = $9Yw4l($cFNax.prototype.request, context);
    // Copy axios.prototype to instance
    $eqkII.extend(instance, $cFNax.prototype, context);
    // Copy context to instance
    $eqkII.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $344d5b672616e01d$var$createInstance($4cXXK(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $344d5b672616e01d$var$axios = $344d5b672616e01d$var$createInstance($detur);
// Expose Axios class to allow class inheritance
$344d5b672616e01d$var$axios.Axios = $cFNax;

// Expose Cancel & CancelToken
$344d5b672616e01d$var$axios.Cancel = (parcelRequire("5WMJL"));

$344d5b672616e01d$var$axios.CancelToken = (parcelRequire("eloyC"));

$344d5b672616e01d$var$axios.isCancel = (parcelRequire("4Rz7o"));

$344d5b672616e01d$var$axios.VERSION = (parcelRequire("1evng")).version;
// Expose all/spread
$344d5b672616e01d$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$344d5b672616e01d$var$axios.spread = (parcelRequire("69tlW"));

// Expose isAxiosError
$344d5b672616e01d$var$axios.isAxiosError = (parcelRequire("1ztnx"));
module.exports = $344d5b672616e01d$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $344d5b672616e01d$var$axios;

});
parcelRegister("eqkII", function(module, exports) {
"use strict";

var $9Yw4l = parcelRequire("9Yw4l");
// utils is a library of generic helper functions non-specific to axios
var $a80390fb03da0476$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $a80390fb03da0476$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $a80390fb03da0476$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $a80390fb03da0476$var$isBuffer(val) {
    return val !== null && !$a80390fb03da0476$var$isUndefined(val) && val.constructor !== null && !$a80390fb03da0476$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $a80390fb03da0476$var$isArrayBuffer(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $a80390fb03da0476$var$isFormData(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $a80390fb03da0476$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $a80390fb03da0476$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $a80390fb03da0476$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $a80390fb03da0476$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $a80390fb03da0476$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $a80390fb03da0476$var$isPlainObject(val) {
    if ($a80390fb03da0476$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $a80390fb03da0476$var$isDate(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $a80390fb03da0476$var$isFile(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $a80390fb03da0476$var$isBlob(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $a80390fb03da0476$var$isFunction(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $a80390fb03da0476$var$isStream(val) {
    return $a80390fb03da0476$var$isObject(val) && $a80390fb03da0476$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $a80390fb03da0476$var$isURLSearchParams(val) {
    return $a80390fb03da0476$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $a80390fb03da0476$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $a80390fb03da0476$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $a80390fb03da0476$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($a80390fb03da0476$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $a80390fb03da0476$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($a80390fb03da0476$var$isPlainObject(result[key]) && $a80390fb03da0476$var$isPlainObject(val)) result[key] = $a80390fb03da0476$var$merge(result[key], val);
        else if ($a80390fb03da0476$var$isPlainObject(val)) result[key] = $a80390fb03da0476$var$merge({}, val);
        else if ($a80390fb03da0476$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$a80390fb03da0476$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $a80390fb03da0476$var$extend(a, b, thisArg) {
    $a80390fb03da0476$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $9Yw4l(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $a80390fb03da0476$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $a80390fb03da0476$var$isArray,
    isArrayBuffer: $a80390fb03da0476$var$isArrayBuffer,
    isBuffer: $a80390fb03da0476$var$isBuffer,
    isFormData: $a80390fb03da0476$var$isFormData,
    isArrayBufferView: $a80390fb03da0476$var$isArrayBufferView,
    isString: $a80390fb03da0476$var$isString,
    isNumber: $a80390fb03da0476$var$isNumber,
    isObject: $a80390fb03da0476$var$isObject,
    isPlainObject: $a80390fb03da0476$var$isPlainObject,
    isUndefined: $a80390fb03da0476$var$isUndefined,
    isDate: $a80390fb03da0476$var$isDate,
    isFile: $a80390fb03da0476$var$isFile,
    isBlob: $a80390fb03da0476$var$isBlob,
    isFunction: $a80390fb03da0476$var$isFunction,
    isStream: $a80390fb03da0476$var$isStream,
    isURLSearchParams: $a80390fb03da0476$var$isURLSearchParams,
    isStandardBrowserEnv: $a80390fb03da0476$var$isStandardBrowserEnv,
    forEach: $a80390fb03da0476$var$forEach,
    merge: $a80390fb03da0476$var$merge,
    extend: $a80390fb03da0476$var$extend,
    trim: $a80390fb03da0476$var$trim,
    stripBOM: $a80390fb03da0476$var$stripBOM
};

});
parcelRegister("9Yw4l", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("cFNax", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");

var $kh0QH = parcelRequire("kh0QH");

var $c6TJO = parcelRequire("c6TJO");

var $bigam = parcelRequire("bigam");

var $4cXXK = parcelRequire("4cXXK");

var $jIVa0 = parcelRequire("jIVa0");
var $939f744ac90f8047$var$validators = $jIVa0.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $939f744ac90f8047$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $c6TJO(),
        response: new $c6TJO()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $939f744ac90f8047$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $4cXXK(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $jIVa0.assertOptions(transitional, {
        silentJSONParsing: $939f744ac90f8047$var$validators.transitional($939f744ac90f8047$var$validators.boolean),
        forcedJSONParsing: $939f744ac90f8047$var$validators.transitional($939f744ac90f8047$var$validators.boolean),
        clarifyTimeoutError: $939f744ac90f8047$var$validators.transitional($939f744ac90f8047$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $bigam,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $bigam(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$939f744ac90f8047$var$Axios.prototype.getUri = function getUri(config) {
    config = $4cXXK(this.defaults, config);
    return $kh0QH(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$eqkII.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $939f744ac90f8047$var$Axios.prototype[method] = function(url, config) {
        return this.request($4cXXK(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eqkII.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $939f744ac90f8047$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($4cXXK(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $939f744ac90f8047$var$Axios;

});
parcelRegister("kh0QH", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
function $ec260dc25b59918a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eqkII.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eqkII.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eqkII.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eqkII.forEach(val, function parseValue(v) {
                if ($eqkII.isDate(v)) v = v.toISOString();
                else if ($eqkII.isObject(v)) v = JSON.stringify(v);
                parts.push($ec260dc25b59918a$var$encode(key) + "=" + $ec260dc25b59918a$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("c6TJO", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
function $8d1147f67c3d7f89$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $8d1147f67c3d7f89$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $8d1147f67c3d7f89$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $8d1147f67c3d7f89$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eqkII.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $8d1147f67c3d7f89$var$InterceptorManager;

});

parcelRegister("bigam", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");

var $8x1p9 = parcelRequire("8x1p9");

var $4Rz7o = parcelRequire("4Rz7o");

var $detur = parcelRequire("detur");

var $5WMJL = parcelRequire("5WMJL");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $838dea667f71be65$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $5WMJL("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $838dea667f71be65$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $8x1p9.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eqkII.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eqkII.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $detur.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $838dea667f71be65$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $8x1p9.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4Rz7o(reason)) {
            $838dea667f71be65$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $8x1p9.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("8x1p9", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");

var $detur = parcelRequire("detur");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $detur;
    /*eslint no-param-reassign:0*/ $eqkII.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("detur", function(module, exports) {

var $8fUyZ = parcelRequire("8fUyZ");
"use strict";

var $eqkII = parcelRequire("eqkII");

var $iaO40 = parcelRequire("iaO40");

var $lQyHN = parcelRequire("lQyHN");

var $flpjJ = parcelRequire("flpjJ");
var $9a2375415c108c8f$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $9a2375415c108c8f$var$setContentTypeIfUnset(headers, value) {
    if (!$eqkII.isUndefined(headers) && $eqkII.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $9a2375415c108c8f$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("j47eV"));
    else if (typeof $8fUyZ !== "undefined" && Object.prototype.toString.call($8fUyZ) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("j47eV"));
    return adapter;
}
function $9a2375415c108c8f$var$stringifySafely(rawValue, parser, encoder) {
    if ($eqkII.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eqkII.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $9a2375415c108c8f$var$defaults = {
    transitional: $flpjJ,
    adapter: $9a2375415c108c8f$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $iaO40(headers, "Accept");
            $iaO40(headers, "Content-Type");
            if ($eqkII.isFormData(data) || $eqkII.isArrayBuffer(data) || $eqkII.isBuffer(data) || $eqkII.isStream(data) || $eqkII.isFile(data) || $eqkII.isBlob(data)) return data;
            if ($eqkII.isArrayBufferView(data)) return data.buffer;
            if ($eqkII.isURLSearchParams(data)) {
                $9a2375415c108c8f$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($eqkII.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $9a2375415c108c8f$var$setContentTypeIfUnset(headers, "application/json");
                return $9a2375415c108c8f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $9a2375415c108c8f$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eqkII.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $lQyHN(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$eqkII.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $9a2375415c108c8f$var$defaults.headers[method] = {};
});
$eqkII.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $9a2375415c108c8f$var$defaults.headers[method] = $eqkII.merge($9a2375415c108c8f$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $9a2375415c108c8f$var$defaults;

});
parcelRegister("8fUyZ", function(module, exports) {
// shim for using process in browser
var $602b99c0bfe574cb$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $602b99c0bfe574cb$var$cachedSetTimeout;
var $602b99c0bfe574cb$var$cachedClearTimeout;
function $602b99c0bfe574cb$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $602b99c0bfe574cb$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $602b99c0bfe574cb$var$cachedSetTimeout = setTimeout;
        else $602b99c0bfe574cb$var$cachedSetTimeout = $602b99c0bfe574cb$var$defaultSetTimout;
    } catch (e) {
        $602b99c0bfe574cb$var$cachedSetTimeout = $602b99c0bfe574cb$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $602b99c0bfe574cb$var$cachedClearTimeout = clearTimeout;
        else $602b99c0bfe574cb$var$cachedClearTimeout = $602b99c0bfe574cb$var$defaultClearTimeout;
    } catch (e) {
        $602b99c0bfe574cb$var$cachedClearTimeout = $602b99c0bfe574cb$var$defaultClearTimeout;
    }
})();
function $602b99c0bfe574cb$var$runTimeout(fun) {
    if ($602b99c0bfe574cb$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($602b99c0bfe574cb$var$cachedSetTimeout === $602b99c0bfe574cb$var$defaultSetTimout || !$602b99c0bfe574cb$var$cachedSetTimeout) && setTimeout) {
        $602b99c0bfe574cb$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $602b99c0bfe574cb$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $602b99c0bfe574cb$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $602b99c0bfe574cb$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $602b99c0bfe574cb$var$runClearTimeout(marker) {
    if ($602b99c0bfe574cb$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($602b99c0bfe574cb$var$cachedClearTimeout === $602b99c0bfe574cb$var$defaultClearTimeout || !$602b99c0bfe574cb$var$cachedClearTimeout) && clearTimeout) {
        $602b99c0bfe574cb$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $602b99c0bfe574cb$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $602b99c0bfe574cb$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $602b99c0bfe574cb$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $602b99c0bfe574cb$var$queue = [];
var $602b99c0bfe574cb$var$draining = false;
var $602b99c0bfe574cb$var$currentQueue;
var $602b99c0bfe574cb$var$queueIndex = -1;
function $602b99c0bfe574cb$var$cleanUpNextTick() {
    if (!$602b99c0bfe574cb$var$draining || !$602b99c0bfe574cb$var$currentQueue) return;
    $602b99c0bfe574cb$var$draining = false;
    if ($602b99c0bfe574cb$var$currentQueue.length) $602b99c0bfe574cb$var$queue = $602b99c0bfe574cb$var$currentQueue.concat($602b99c0bfe574cb$var$queue);
    else $602b99c0bfe574cb$var$queueIndex = -1;
    if ($602b99c0bfe574cb$var$queue.length) $602b99c0bfe574cb$var$drainQueue();
}
function $602b99c0bfe574cb$var$drainQueue() {
    if ($602b99c0bfe574cb$var$draining) return;
    var timeout = $602b99c0bfe574cb$var$runTimeout($602b99c0bfe574cb$var$cleanUpNextTick);
    $602b99c0bfe574cb$var$draining = true;
    var len = $602b99c0bfe574cb$var$queue.length;
    while(len){
        $602b99c0bfe574cb$var$currentQueue = $602b99c0bfe574cb$var$queue;
        $602b99c0bfe574cb$var$queue = [];
        while(++$602b99c0bfe574cb$var$queueIndex < len)if ($602b99c0bfe574cb$var$currentQueue) $602b99c0bfe574cb$var$currentQueue[$602b99c0bfe574cb$var$queueIndex].run();
        $602b99c0bfe574cb$var$queueIndex = -1;
        len = $602b99c0bfe574cb$var$queue.length;
    }
    $602b99c0bfe574cb$var$currentQueue = null;
    $602b99c0bfe574cb$var$draining = false;
    $602b99c0bfe574cb$var$runClearTimeout(timeout);
}
$602b99c0bfe574cb$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $602b99c0bfe574cb$var$queue.push(new $602b99c0bfe574cb$var$Item(fun, args));
    if ($602b99c0bfe574cb$var$queue.length === 1 && !$602b99c0bfe574cb$var$draining) $602b99c0bfe574cb$var$runTimeout($602b99c0bfe574cb$var$drainQueue);
};
// v8 likes predictible objects
function $602b99c0bfe574cb$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$602b99c0bfe574cb$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$602b99c0bfe574cb$var$process.title = "browser";
$602b99c0bfe574cb$var$process.browser = true;
$602b99c0bfe574cb$var$process.env = {};
$602b99c0bfe574cb$var$process.argv = [];
$602b99c0bfe574cb$var$process.version = ""; // empty string to avoid regexp issues
$602b99c0bfe574cb$var$process.versions = {};
function $602b99c0bfe574cb$var$noop() {}
$602b99c0bfe574cb$var$process.on = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.addListener = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.once = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.off = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.removeListener = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.removeAllListeners = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.emit = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.prependListener = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.prependOnceListener = $602b99c0bfe574cb$var$noop;
$602b99c0bfe574cb$var$process.listeners = function(name) {
    return [];
};
$602b99c0bfe574cb$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$602b99c0bfe574cb$var$process.cwd = function() {
    return "/";
};
$602b99c0bfe574cb$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$602b99c0bfe574cb$var$process.umask = function() {
    return 0;
};

});

parcelRegister("iaO40", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eqkII.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("lQyHN", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("flpjJ", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("j47eV", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");

var $3sBOy = parcelRequire("3sBOy");

var $dVaxq = parcelRequire("dVaxq");

var $kh0QH = parcelRequire("kh0QH");

var $03xDS = parcelRequire("03xDS");

var $6PENl = parcelRequire("6PENl");

var $dQpVC = parcelRequire("dQpVC");

var $d602U = parcelRequire("d602U");

var $flpjJ = parcelRequire("flpjJ");

var $5WMJL = parcelRequire("5WMJL");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($eqkII.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $03xDS(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $kh0QH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $6PENl(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3sBOy(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($d602U("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($d602U("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $flpjJ;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($d602U(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eqkII.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $dQpVC(fullPath)) && config.xsrfCookieName ? $dVaxq.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eqkII.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eqkII.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $5WMJL("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3sBOy", function(module, exports) {
"use strict";

var $d602U = parcelRequire("d602U");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($d602U("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("d602U", function(module, exports) {
"use strict";

var $lQyHN = parcelRequire("lQyHN");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $lQyHN(error, config, code, request, response);
};

});


parcelRegister("dVaxq", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
module.exports = $eqkII.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eqkII.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eqkII.isString(path)) cookie.push("path=" + path);
            if ($eqkII.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("03xDS", function(module, exports) {
"use strict";

var $3cfJS = parcelRequire("3cfJS");

var $8yvcX = parcelRequire("8yvcX");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$3cfJS(requestedURL)) return $8yvcX(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("3cfJS", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("8yvcX", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("6PENl", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $4f97268366ac7389$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eqkII.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eqkII.trim(line.substr(0, i)).toLowerCase();
        val = $eqkII.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $4f97268366ac7389$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("dQpVC", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
module.exports = $eqkII.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eqkII.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("5WMJL", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $45482cb4ebbdd2c1$var$Cancel(message) {
    this.message = message;
}
$45482cb4ebbdd2c1$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$45482cb4ebbdd2c1$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $45482cb4ebbdd2c1$var$Cancel;

});




parcelRegister("4Rz7o", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("4cXXK", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($eqkII.isPlainObject(target) && $eqkII.isPlainObject(source)) return $eqkII.merge(target, source);
        else if ($eqkII.isPlainObject(source)) return $eqkII.merge({}, source);
        else if ($eqkII.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$eqkII.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$eqkII.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$eqkII.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$eqkII.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$eqkII.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $eqkII.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $eqkII.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("jIVa0", function(module, exports) {
"use strict";

var $1evng = parcelRequire("1evng");
var $e5be7737ff0eccdb$require$VERSION = $1evng.version;
var $e5be7737ff0eccdb$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $e5be7737ff0eccdb$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $e5be7737ff0eccdb$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $e5be7737ff0eccdb$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $e5be7737ff0eccdb$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$e5be7737ff0eccdb$var$deprecatedWarnings[opt]) {
            $e5be7737ff0eccdb$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $e5be7737ff0eccdb$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $e5be7737ff0eccdb$var$assertOptions,
    validators: $e5be7737ff0eccdb$var$validators
};

});
parcelRegister("1evng", function(module, exports) {
module.exports = {
    "version": "0.26.1"
};

});



parcelRegister("eloyC", function(module, exports) {
"use strict";

var $5WMJL = parcelRequire("5WMJL");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $a716136b676350a0$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $5WMJL(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $a716136b676350a0$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $a716136b676350a0$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $a716136b676350a0$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $a716136b676350a0$var$CancelToken.source = function source() {
    var cancel;
    var token = new $a716136b676350a0$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $a716136b676350a0$var$CancelToken;

});

parcelRegister("69tlW", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1ztnx", function(module, exports) {
"use strict";

var $eqkII = parcelRequire("eqkII");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $eqkII.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("hTT36", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $d0824650de2c6eb4$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0824650de2c6eb4$var$isValid;

var $d0824650de2c6eb4$var$_index = $d0824650de2c6eb4$require$_interopRequireDefault((parcelRequire("4yAbj")));

var $d0824650de2c6eb4$var$_index2 = $d0824650de2c6eb4$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $d0824650de2c6eb4$var$_index3 = $d0824650de2c6eb4$require$_interopRequireDefault((parcelRequire("ev56u")));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $d0824650de2c6eb4$var$isValid(dirtyDate) {
    (0, $d0824650de2c6eb4$var$_index3.default)(1, arguments);
    if (!(0, $d0824650de2c6eb4$var$_index.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $d0824650de2c6eb4$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});
parcelRegister("gDgMD", function(module, exports) {
function $c1bd4eb6337a1b74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $c1bd4eb6337a1b74$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4yAbj", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $3516674d225d26ef$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3516674d225d26ef$var$isDate;

var $3516674d225d26ef$var$_typeof2 = $3516674d225d26ef$require$_interopRequireDefault((parcelRequire("ctvU7")));

var $3516674d225d26ef$var$_index = $3516674d225d26ef$require$_interopRequireDefault((parcelRequire("ev56u")));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $3516674d225d26ef$var$isDate(value) {
    (0, $3516674d225d26ef$var$_index.default)(1, arguments);
    return value instanceof Date || (0, $3516674d225d26ef$var$_typeof2.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
module.exports = module.exports.default;

});
parcelRegister("ctvU7", function(module, exports) {
function $9150f0f7ecb45d0a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9150f0f7ecb45d0a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9150f0f7ecb45d0a$var$_typeof(o);
}
module.exports = $9150f0f7ecb45d0a$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ev56u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8e7eb6b9c7bf57e$var$requiredArgs;
function $a8e7eb6b9c7bf57e$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
module.exports = module.exports.default;

});


parcelRegister("5eXBC", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $3d0c7f00604825ed$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d0c7f00604825ed$var$toDate;

var $3d0c7f00604825ed$var$_typeof2 = $3d0c7f00604825ed$require$_interopRequireDefault((parcelRequire("ctvU7")));

var $3d0c7f00604825ed$var$_index = $3d0c7f00604825ed$require$_interopRequireDefault((parcelRequire("ev56u")));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $3d0c7f00604825ed$var$toDate(argument) {
    (0, $3d0c7f00604825ed$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $3d0c7f00604825ed$var$_typeof2.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});


parcelRegister("g0gcS", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $ba6937c07cd578d9$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba6937c07cd578d9$var$subMilliseconds;

var $ba6937c07cd578d9$var$_index = $ba6937c07cd578d9$require$_interopRequireDefault((parcelRequire("8l71R")));

var $ba6937c07cd578d9$var$_index2 = $ba6937c07cd578d9$require$_interopRequireDefault((parcelRequire("ev56u")));

var $ba6937c07cd578d9$var$_index3 = $ba6937c07cd578d9$require$_interopRequireDefault((parcelRequire("khNiu")));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $ba6937c07cd578d9$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $ba6937c07cd578d9$var$_index2.default)(2, arguments);
    var amount = (0, $ba6937c07cd578d9$var$_index3.default)(dirtyAmount);
    return (0, $ba6937c07cd578d9$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("8l71R", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $6125bcb7dbf0da7e$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6125bcb7dbf0da7e$var$addMilliseconds;

var $6125bcb7dbf0da7e$var$_index = $6125bcb7dbf0da7e$require$_interopRequireDefault((parcelRequire("khNiu")));

var $6125bcb7dbf0da7e$var$_index2 = $6125bcb7dbf0da7e$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $6125bcb7dbf0da7e$var$_index3 = $6125bcb7dbf0da7e$require$_interopRequireDefault((parcelRequire("ev56u")));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $6125bcb7dbf0da7e$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $6125bcb7dbf0da7e$var$_index3.default)(2, arguments);
    var timestamp = (0, $6125bcb7dbf0da7e$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $6125bcb7dbf0da7e$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});
parcelRegister("khNiu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec4ba2982238fc67$var$toInteger;
function $ec4ba2982238fc67$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});



parcelRegister("gMy09", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $c37b81030dce45c2$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c37b81030dce45c2$var$_index = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("70Ga5")));

var $c37b81030dce45c2$var$_index2 = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("d8lvW")));

var $c37b81030dce45c2$var$_index3 = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("7pBns")));

var $c37b81030dce45c2$var$_index4 = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("1xnnF")));

var $c37b81030dce45c2$var$_index5 = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("01vhe")));

var $c37b81030dce45c2$var$_index6 = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("3We0Y")));

var $c37b81030dce45c2$var$_index7 = $c37b81030dce45c2$require$_interopRequireDefault((parcelRequire("ee8tu")));
var $c37b81030dce45c2$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $c37b81030dce45c2$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $c37b81030dce45c2$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $c37b81030dce45c2$var$_index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $c37b81030dce45c2$var$_index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $c37b81030dce45c2$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $c37b81030dce45c2$var$_index3.default)(date);
        // Padding
        return (0, $c37b81030dce45c2$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $c37b81030dce45c2$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $c37b81030dce45c2$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $c37b81030dce45c2$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return $c37b81030dce45c2$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $c37b81030dce45c2$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c37b81030dce45c2$var$_index4.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $c37b81030dce45c2$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $c37b81030dce45c2$var$_index2.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $c37b81030dce45c2$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return $c37b81030dce45c2$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $c37b81030dce45c2$var$_index.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $c37b81030dce45c2$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $c37b81030dce45c2$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $c37b81030dce45c2$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $c37b81030dce45c2$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $c37b81030dce45c2$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $c37b81030dce45c2$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $c37b81030dce45c2$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $c37b81030dce45c2$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $c37b81030dce45c2$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $c37b81030dce45c2$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $c37b81030dce45c2$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return $c37b81030dce45c2$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $c37b81030dce45c2$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $c37b81030dce45c2$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return $c37b81030dce45c2$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return $c37b81030dce45c2$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $c37b81030dce45c2$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $c37b81030dce45c2$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $c37b81030dce45c2$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $c37b81030dce45c2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $c37b81030dce45c2$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $c37b81030dce45c2$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $c37b81030dce45c2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $c37b81030dce45c2$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $c37b81030dce45c2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $c37b81030dce45c2$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $c37b81030dce45c2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $c37b81030dce45c2$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $c37b81030dce45c2$var$_index6.default)(timestamp, token.length);
    }
};
function $c37b81030dce45c2$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $c37b81030dce45c2$var$_index6.default)(minutes, 2);
}
function $c37b81030dce45c2$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $c37b81030dce45c2$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $c37b81030dce45c2$var$formatTimezone(offset, dirtyDelimiter);
}
function $c37b81030dce45c2$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $c37b81030dce45c2$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $c37b81030dce45c2$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $c37b81030dce45c2$var$_default = $c37b81030dce45c2$var$formatters;
module.exports.default = $c37b81030dce45c2$var$_default;
module.exports = module.exports.default;

});
parcelRegister("70Ga5", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $51a93ce778ae94c3$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51a93ce778ae94c3$var$getUTCDayOfYear;

var $51a93ce778ae94c3$var$_index = $51a93ce778ae94c3$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $51a93ce778ae94c3$var$_index2 = $51a93ce778ae94c3$require$_interopRequireDefault((parcelRequire("ev56u")));
var $51a93ce778ae94c3$var$MILLISECONDS_IN_DAY = 86400000;
function $51a93ce778ae94c3$var$getUTCDayOfYear(dirtyDate) {
    (0, $51a93ce778ae94c3$var$_index2.default)(1, arguments);
    var date = (0, $51a93ce778ae94c3$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $51a93ce778ae94c3$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("d8lvW", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $98fcb5f8c9b06ee1$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98fcb5f8c9b06ee1$var$getUTCISOWeek;

var $98fcb5f8c9b06ee1$var$_index = $98fcb5f8c9b06ee1$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $98fcb5f8c9b06ee1$var$_index2 = $98fcb5f8c9b06ee1$require$_interopRequireDefault((parcelRequire("jB10s")));

var $98fcb5f8c9b06ee1$var$_index3 = $98fcb5f8c9b06ee1$require$_interopRequireDefault((parcelRequire("kTzr9")));

var $98fcb5f8c9b06ee1$var$_index4 = $98fcb5f8c9b06ee1$require$_interopRequireDefault((parcelRequire("ev56u")));
var $98fcb5f8c9b06ee1$var$MILLISECONDS_IN_WEEK = 604800000;
function $98fcb5f8c9b06ee1$var$getUTCISOWeek(dirtyDate) {
    (0, $98fcb5f8c9b06ee1$var$_index4.default)(1, arguments);
    var date = (0, $98fcb5f8c9b06ee1$var$_index.default)(dirtyDate);
    var diff = (0, $98fcb5f8c9b06ee1$var$_index2.default)(date).getTime() - (0, $98fcb5f8c9b06ee1$var$_index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $98fcb5f8c9b06ee1$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("jB10s", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $03ae7ceab8e0cd6a$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $03ae7ceab8e0cd6a$var$startOfUTCISOWeek;

var $03ae7ceab8e0cd6a$var$_index = $03ae7ceab8e0cd6a$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $03ae7ceab8e0cd6a$var$_index2 = $03ae7ceab8e0cd6a$require$_interopRequireDefault((parcelRequire("ev56u")));
function $03ae7ceab8e0cd6a$var$startOfUTCISOWeek(dirtyDate) {
    (0, $03ae7ceab8e0cd6a$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $03ae7ceab8e0cd6a$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("kTzr9", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $f3646ec2c5558111$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3646ec2c5558111$var$startOfUTCISOWeekYear;

var $f3646ec2c5558111$var$_index = $f3646ec2c5558111$require$_interopRequireDefault((parcelRequire("7pBns")));

var $f3646ec2c5558111$var$_index2 = $f3646ec2c5558111$require$_interopRequireDefault((parcelRequire("jB10s")));

var $f3646ec2c5558111$var$_index3 = $f3646ec2c5558111$require$_interopRequireDefault((parcelRequire("ev56u")));
function $f3646ec2c5558111$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $f3646ec2c5558111$var$_index3.default)(1, arguments);
    var year = (0, $f3646ec2c5558111$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $f3646ec2c5558111$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("7pBns", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $5657dc8da6a19c51$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5657dc8da6a19c51$var$getUTCISOWeekYear;

var $5657dc8da6a19c51$var$_index = $5657dc8da6a19c51$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $5657dc8da6a19c51$var$_index2 = $5657dc8da6a19c51$require$_interopRequireDefault((parcelRequire("ev56u")));

var $5657dc8da6a19c51$var$_index3 = $5657dc8da6a19c51$require$_interopRequireDefault((parcelRequire("jB10s")));
function $5657dc8da6a19c51$var$getUTCISOWeekYear(dirtyDate) {
    (0, $5657dc8da6a19c51$var$_index2.default)(1, arguments);
    var date = (0, $5657dc8da6a19c51$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5657dc8da6a19c51$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5657dc8da6a19c51$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("1xnnF", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $11eb026fc9e39ed3$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11eb026fc9e39ed3$var$getUTCWeek;

var $11eb026fc9e39ed3$var$_index = $11eb026fc9e39ed3$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $11eb026fc9e39ed3$var$_index2 = $11eb026fc9e39ed3$require$_interopRequireDefault((parcelRequire("gGFWZ")));

var $11eb026fc9e39ed3$var$_index3 = $11eb026fc9e39ed3$require$_interopRequireDefault((parcelRequire("3dfB9")));

var $11eb026fc9e39ed3$var$_index4 = $11eb026fc9e39ed3$require$_interopRequireDefault((parcelRequire("ev56u")));
var $11eb026fc9e39ed3$var$MILLISECONDS_IN_WEEK = 604800000;
function $11eb026fc9e39ed3$var$getUTCWeek(dirtyDate, options) {
    (0, $11eb026fc9e39ed3$var$_index4.default)(1, arguments);
    var date = (0, $11eb026fc9e39ed3$var$_index.default)(dirtyDate);
    var diff = (0, $11eb026fc9e39ed3$var$_index2.default)(date, options).getTime() - (0, $11eb026fc9e39ed3$var$_index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $11eb026fc9e39ed3$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("gGFWZ", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $c2611c10c116a547$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2611c10c116a547$var$startOfUTCWeek;

var $c2611c10c116a547$var$_index = $c2611c10c116a547$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $c2611c10c116a547$var$_index2 = $c2611c10c116a547$require$_interopRequireDefault((parcelRequire("ev56u")));

var $c2611c10c116a547$var$_index3 = $c2611c10c116a547$require$_interopRequireDefault((parcelRequire("khNiu")));

var $coR2I = parcelRequire("coR2I");
function $c2611c10c116a547$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $c2611c10c116a547$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $coR2I.getDefaultOptions)();
    var weekStartsOn = (0, $c2611c10c116a547$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $c2611c10c116a547$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("coR2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $9070df1b0ad9db7b$var$getDefaultOptions;
module.exports.setDefaultOptions = $9070df1b0ad9db7b$var$setDefaultOptions;
var $9070df1b0ad9db7b$var$defaultOptions = {};
function $9070df1b0ad9db7b$var$getDefaultOptions() {
    return $9070df1b0ad9db7b$var$defaultOptions;
}
function $9070df1b0ad9db7b$var$setDefaultOptions(newOptions) {
    $9070df1b0ad9db7b$var$defaultOptions = newOptions;
}

});


parcelRegister("3dfB9", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $256eaf7b685ab235$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $256eaf7b685ab235$var$startOfUTCWeekYear;

var $256eaf7b685ab235$var$_index = $256eaf7b685ab235$require$_interopRequireDefault((parcelRequire("01vhe")));

var $256eaf7b685ab235$var$_index2 = $256eaf7b685ab235$require$_interopRequireDefault((parcelRequire("ev56u")));

var $256eaf7b685ab235$var$_index3 = $256eaf7b685ab235$require$_interopRequireDefault((parcelRequire("gGFWZ")));

var $256eaf7b685ab235$var$_index4 = $256eaf7b685ab235$require$_interopRequireDefault((parcelRequire("khNiu")));

var $coR2I = parcelRequire("coR2I");
function $256eaf7b685ab235$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $256eaf7b685ab235$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $coR2I.getDefaultOptions)();
    var firstWeekContainsDate = (0, $256eaf7b685ab235$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $256eaf7b685ab235$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $256eaf7b685ab235$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("01vhe", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $00485b16148f9fdf$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00485b16148f9fdf$var$getUTCWeekYear;

var $00485b16148f9fdf$var$_index = $00485b16148f9fdf$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $00485b16148f9fdf$var$_index2 = $00485b16148f9fdf$require$_interopRequireDefault((parcelRequire("ev56u")));

var $00485b16148f9fdf$var$_index3 = $00485b16148f9fdf$require$_interopRequireDefault((parcelRequire("gGFWZ")));

var $00485b16148f9fdf$var$_index4 = $00485b16148f9fdf$require$_interopRequireDefault((parcelRequire("khNiu")));

var $coR2I = parcelRequire("coR2I");
function $00485b16148f9fdf$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $00485b16148f9fdf$var$_index2.default)(1, arguments);
    var date = (0, $00485b16148f9fdf$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $coR2I.getDefaultOptions)();
    var firstWeekContainsDate = (0, $00485b16148f9fdf$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $00485b16148f9fdf$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $00485b16148f9fdf$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("3We0Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2de1a8e1e713354e$var$addLeadingZeros;
function $2de1a8e1e713354e$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("ee8tu", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $a5b8f2649b5c4dbc$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5b8f2649b5c4dbc$var$_index = $a5b8f2649b5c4dbc$require$_interopRequireDefault((parcelRequire("3We0Y")));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $a5b8f2649b5c4dbc$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $a5b8f2649b5c4dbc$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a5b8f2649b5c4dbc$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $a5b8f2649b5c4dbc$var$_default = $a5b8f2649b5c4dbc$var$formatters;
module.exports.default = $a5b8f2649b5c4dbc$var$_default;
module.exports = module.exports.default;

});


parcelRegister("b4ORf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $810784b7721f75b0$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $810784b7721f75b0$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("k6Ia0", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $ea369f86cf8318ee$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea369f86cf8318ee$var$_index = $ea369f86cf8318ee$require$_interopRequireDefault((parcelRequire("aGbHR")));
var $ea369f86cf8318ee$var$_default = $ea369f86cf8318ee$var$_index.default;
module.exports.default = $ea369f86cf8318ee$var$_default;
module.exports = module.exports.default;

});
parcelRegister("aGbHR", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $7c66e8493a818554$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c66e8493a818554$var$_index = $7c66e8493a818554$require$_interopRequireDefault((parcelRequire("ck12W")));

var $7c66e8493a818554$var$_index2 = $7c66e8493a818554$require$_interopRequireDefault((parcelRequire("gppBr")));

var $7c66e8493a818554$var$_index3 = $7c66e8493a818554$require$_interopRequireDefault((parcelRequire("1OMFn")));

var $7c66e8493a818554$var$_index4 = $7c66e8493a818554$require$_interopRequireDefault((parcelRequire("8iDD7")));

var $7c66e8493a818554$var$_index5 = $7c66e8493a818554$require$_interopRequireDefault((parcelRequire("bWlLq")));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $7c66e8493a818554$var$locale = {
    code: "en-US",
    formatDistance: $7c66e8493a818554$var$_index.default,
    formatLong: $7c66e8493a818554$var$_index2.default,
    formatRelative: $7c66e8493a818554$var$_index3.default,
    localize: $7c66e8493a818554$var$_index4.default,
    match: $7c66e8493a818554$var$_index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $7c66e8493a818554$var$_default = $7c66e8493a818554$var$locale;
module.exports.default = $7c66e8493a818554$var$_default;
module.exports = module.exports.default;

});
parcelRegister("ck12W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8f882a1e19f7a5e6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $8f882a1e19f7a5e6$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8f882a1e19f7a5e6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $8f882a1e19f7a5e6$var$_default = $8f882a1e19f7a5e6$var$formatDistance;
module.exports.default = $8f882a1e19f7a5e6$var$_default;
module.exports = module.exports.default;

});

parcelRegister("gppBr", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $bf22d75e18274a65$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf22d75e18274a65$var$_index = $bf22d75e18274a65$require$_interopRequireDefault((parcelRequire("aboMT")));
var $bf22d75e18274a65$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $bf22d75e18274a65$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $bf22d75e18274a65$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $bf22d75e18274a65$var$formatLong = {
    date: (0, $bf22d75e18274a65$var$_index.default)({
        formats: $bf22d75e18274a65$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $bf22d75e18274a65$var$_index.default)({
        formats: $bf22d75e18274a65$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $bf22d75e18274a65$var$_index.default)({
        formats: $bf22d75e18274a65$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $bf22d75e18274a65$var$_default = $bf22d75e18274a65$var$formatLong;
module.exports.default = $bf22d75e18274a65$var$_default;
module.exports = module.exports.default;

});
parcelRegister("aboMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $769e28c8b6ac346c$var$buildFormatLongFn;
function $769e28c8b6ac346c$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("1OMFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $15303614d979f090$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $15303614d979f090$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $15303614d979f090$var$formatRelativeLocale[token];
};
var $15303614d979f090$var$_default = $15303614d979f090$var$formatRelative;
module.exports.default = $15303614d979f090$var$_default;
module.exports = module.exports.default;

});

parcelRegister("8iDD7", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $60aebee0b9611ca7$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60aebee0b9611ca7$var$_index = $60aebee0b9611ca7$require$_interopRequireDefault((parcelRequire("cyPYQ")));
var $60aebee0b9611ca7$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $60aebee0b9611ca7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $60aebee0b9611ca7$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $60aebee0b9611ca7$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $60aebee0b9611ca7$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $60aebee0b9611ca7$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $60aebee0b9611ca7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $60aebee0b9611ca7$var$localize = {
    ordinalNumber: $60aebee0b9611ca7$var$ordinalNumber,
    era: (0, $60aebee0b9611ca7$var$_index.default)({
        values: $60aebee0b9611ca7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $60aebee0b9611ca7$var$_index.default)({
        values: $60aebee0b9611ca7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $60aebee0b9611ca7$var$_index.default)({
        values: $60aebee0b9611ca7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $60aebee0b9611ca7$var$_index.default)({
        values: $60aebee0b9611ca7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $60aebee0b9611ca7$var$_index.default)({
        values: $60aebee0b9611ca7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $60aebee0b9611ca7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $60aebee0b9611ca7$var$_default = $60aebee0b9611ca7$var$localize;
module.exports.default = $60aebee0b9611ca7$var$_default;
module.exports = module.exports.default;

});
parcelRegister("cyPYQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9250fb35caec1927$var$buildLocalizeFn;
function $9250fb35caec1927$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("bWlLq", function(module, exports) {
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $8b15fe57387e59b4$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b15fe57387e59b4$var$_index = $8b15fe57387e59b4$require$_interopRequireDefault((parcelRequire("3IWxu")));

var $8b15fe57387e59b4$var$_index2 = $8b15fe57387e59b4$require$_interopRequireDefault((parcelRequire("g7d6P")));
var $8b15fe57387e59b4$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $8b15fe57387e59b4$var$parseOrdinalNumberPattern = /\d+/i;
var $8b15fe57387e59b4$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $8b15fe57387e59b4$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $8b15fe57387e59b4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $8b15fe57387e59b4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8b15fe57387e59b4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $8b15fe57387e59b4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $8b15fe57387e59b4$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $8b15fe57387e59b4$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $8b15fe57387e59b4$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $8b15fe57387e59b4$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $8b15fe57387e59b4$var$match = {
    ordinalNumber: (0, $8b15fe57387e59b4$var$_index2.default)({
        matchPattern: $8b15fe57387e59b4$var$matchOrdinalNumberPattern,
        parsePattern: $8b15fe57387e59b4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $8b15fe57387e59b4$var$_index.default)({
        matchPatterns: $8b15fe57387e59b4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8b15fe57387e59b4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $8b15fe57387e59b4$var$_index.default)({
        matchPatterns: $8b15fe57387e59b4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8b15fe57387e59b4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $8b15fe57387e59b4$var$_index.default)({
        matchPatterns: $8b15fe57387e59b4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8b15fe57387e59b4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $8b15fe57387e59b4$var$_index.default)({
        matchPatterns: $8b15fe57387e59b4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8b15fe57387e59b4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $8b15fe57387e59b4$var$_index.default)({
        matchPatterns: $8b15fe57387e59b4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8b15fe57387e59b4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $8b15fe57387e59b4$var$_default = $8b15fe57387e59b4$var$match;
module.exports.default = $8b15fe57387e59b4$var$_default;
module.exports = module.exports.default;

});
parcelRegister("3IWxu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b62e3d14f04cf00$var$buildMatchFn;
function $2b62e3d14f04cf00$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $2b62e3d14f04cf00$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $2b62e3d14f04cf00$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $2b62e3d14f04cf00$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $2b62e3d14f04cf00$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("g7d6P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bbb77800925e5b22$var$buildMatchPatternFn;
function $bbb77800925e5b22$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});




parcelRegister("ewWTB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a941bd548567d23a$var$assign;
function $a941bd548567d23a$var$assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("5TVeh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $44be7b6137e2776d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $44be7b6137e2776d$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jZjY3")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("jvVhJ")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("jvVhJ")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("fwGtS")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("jNp5p")).default; });
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7TcGh = parcelRequire("7TcGh");

var $jvVhJ = parcelRequire("jvVhJ");
var $jZjY3 = parcelRequire("jZjY3");

var $fwGtS = parcelRequire("fwGtS");

var $jNp5p = parcelRequire("jNp5p");
"use client";
function $44be7b6137e2776d$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $7TcGh.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $44be7b6137e2776d$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("7TcGh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5be7819b70f3ba2d$export$2e2bcd8739ae039; });

var $ghKUO = parcelRequire("ghKUO");
parcelRequire("dFWbn");
parcelRequire("f2Y41");
parcelRequire("3mTpA");

parcelRequire("fJDtB");
parcelRequire("fS7An");
parcelRequire("fPRBH");
var $5be7819b70f3ba2d$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $5be7819b70f3ba2d$export$2e2bcd8739ae039 = (0, $ghKUO.default).bind();
$5be7819b70f3ba2d$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $5be7819b70f3ba2d$export$2e2bcd8739ae039[tagName] = $5be7819b70f3ba2d$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("ghKUO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdb2a04aa9f239d2$export$2e2bcd8739ae039; });

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $3mTpA = parcelRequire("3mTpA");
parcelRequire("jvVhJ");
var $jZjY3 = parcelRequire("jZjY3");

var $fJDtB = parcelRequire("fJDtB");

var $fS7An = parcelRequire("fS7An");

var $fPRBH = parcelRequire("fPRBH");
var $bdb2a04aa9f239d2$var$testOmitPropsOnStringTag = (0, $3mTpA.default);
var $bdb2a04aa9f239d2$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $bdb2a04aa9f239d2$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $bdb2a04aa9f239d2$var$testOmitPropsOnStringTag : $bdb2a04aa9f239d2$var$testOmitPropsOnComponent;
};
var $bdb2a04aa9f239d2$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $bdb2a04aa9f239d2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $bdb2a04aa9f239d2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fJDtB.registerStyles)(cache, serialized, isStringTag);
    (0, $fPRBH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fJDtB.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $bdb2a04aa9f239d2$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $bdb2a04aa9f239d2$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $bdb2a04aa9f239d2$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $jZjY3.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $f2Y41.useContext((0, $jZjY3.T));
            }
            if (typeof props.className === "string") className = (0, $fJDtB.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fS7An.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $bdb2a04aa9f239d2$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, /*#__PURE__*/ $f2Y41.createElement($bdb2a04aa9f239d2$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $f2Y41.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $asN9r.default)({}, options, nextOptions, {
                shouldForwardProp: $bdb2a04aa9f239d2$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("asN9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79e2a556c19fb066$export$2e2bcd8739ae039; });
function $79e2a556c19fb066$export$2e2bcd8739ae039() {
    $79e2a556c19fb066$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $79e2a556c19fb066$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("3mTpA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273e68cbfaee7953$export$2e2bcd8739ae039; });

var $cC7DW = parcelRequire("cC7DW");
var $273e68cbfaee7953$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $273e68cbfaee7953$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cC7DW.default)(function(prop) {
    return $273e68cbfaee7953$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("cC7DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92eef66aa3fb0fbe$export$2e2bcd8739ae039; });
function $92eef66aa3fb0fbe$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jvVhJ", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $e34d592f43619c1a$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $e34d592f43619c1a$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $e34d592f43619c1a$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $e34d592f43619c1a$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jZjY3")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("jZjY3")).w; });

var $jZjY3 = parcelRequire("jZjY3");

var $f2Y41 = parcelRequire("f2Y41");

var $fJDtB = parcelRequire("fJDtB");

var $fPRBH = parcelRequire("fPRBH");

var $fS7An = parcelRequire("fS7An");
parcelRequire("kaWmH");
parcelRequire("dFWbn");
parcelRequire("9kpSX");

parcelRequire("d6J3N");
var $e34d592f43619c1a$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $e34d592f43619c1a$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $jZjY3.h).call(props, "css")) // $FlowFixMe
    return $f2Y41.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jZjY3.E);
    createElementArgArray[1] = (0, $jZjY3.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $f2Y41.createElement.apply(null, createElementArgArray);
};
var $e34d592f43619c1a$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e34d592f43619c1a$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jZjY3.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $fS7An.serializeStyles)([
        styles
    ], undefined, $f2Y41.useContext((0, $jZjY3.T)));
    if (!(0, $jZjY3.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $f2Y41.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $f2Y41.useRef();
    (0, $fPRBH.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fPRBH.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $fJDtB.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e34d592f43619c1a$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $fS7An.serializeStyles)(args);
}
var $e34d592f43619c1a$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $e34d592f43619c1a$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $e34d592f43619c1a$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e34d592f43619c1a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $fJDtB.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e34d592f43619c1a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $fPRBH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $fJDtB.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $e34d592f43619c1a$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jZjY3.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $fS7An.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $fJDtB.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e34d592f43619c1a$var$merge(cache.registered, css, $e34d592f43619c1a$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $f2Y41.useContext((0, $jZjY3.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, /*#__PURE__*/ $f2Y41.createElement($e34d592f43619c1a$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $e34d592f43619c1a$var$isBrowser, $e34d592f43619c1a$var$isTestEnv, $e34d592f43619c1a$var$globalContext, $e34d592f43619c1a$var$globalKey;

});
parcelRegister("jZjY3", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $e8d333f5cdc3a133$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $e8d333f5cdc3a133$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $e8d333f5cdc3a133$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e8d333f5cdc3a133$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e8d333f5cdc3a133$export$971d5caa766a69d7; });
$parcel$export(module.exports, "a", function () { return $e8d333f5cdc3a133$export$407448d2b89b1813; });
$parcel$export(module.exports, "c", function () { return $e8d333f5cdc3a133$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e8d333f5cdc3a133$export$a9c23c6ac3fc3eca; });

var $f2Y41 = parcelRequire("f2Y41");

var $kaWmH = parcelRequire("kaWmH");

var $asN9r = parcelRequire("asN9r");

var $9kpSX = parcelRequire("9kpSX");

var $3FrvL = parcelRequire("3FrvL");

var $fJDtB = parcelRequire("fJDtB");

var $fS7An = parcelRequire("fS7An");

var $fPRBH = parcelRequire("fPRBH");
var $e8d333f5cdc3a133$export$23f2a1d2818174ef = true;
var $e8d333f5cdc3a133$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e8d333f5cdc3a133$var$EmotionCacheContext = /* #__PURE__ */ $f2Y41.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $kaWmH.default)({
    key: "css"
}) : null);
var $e8d333f5cdc3a133$export$e7094788287c5e9b = $e8d333f5cdc3a133$var$EmotionCacheContext.Provider;
var $e8d333f5cdc3a133$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $f2Y41.useContext)($e8d333f5cdc3a133$var$EmotionCacheContext);
};
var $e8d333f5cdc3a133$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $f2Y41.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $f2Y41.useContext)($e8d333f5cdc3a133$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e8d333f5cdc3a133$export$23f2a1d2818174ef) $e8d333f5cdc3a133$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $f2Y41.useContext)($e8d333f5cdc3a133$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $kaWmH.default)({
                key: "css"
            });
            return /*#__PURE__*/ $f2Y41.createElement($e8d333f5cdc3a133$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e8d333f5cdc3a133$export$971d5caa766a69d7 = /* #__PURE__ */ $f2Y41.createContext({});
var $e8d333f5cdc3a133$export$3b14a55fb2447963 = function useTheme() {
    return $f2Y41.useContext($e8d333f5cdc3a133$export$971d5caa766a69d7);
};
var $e8d333f5cdc3a133$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $asN9r.default)({}, outerTheme, theme);
};
var $e8d333f5cdc3a133$var$createCacheWithTheme = /* #__PURE__ */ (0, $9kpSX.default)(function(outerTheme) {
    return (0, $9kpSX.default)(function(theme) {
        return $e8d333f5cdc3a133$var$getTheme(outerTheme, theme);
    });
});
var $e8d333f5cdc3a133$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $f2Y41.useContext($e8d333f5cdc3a133$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e8d333f5cdc3a133$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $f2Y41.createElement($e8d333f5cdc3a133$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e8d333f5cdc3a133$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $f2Y41.useContext($e8d333f5cdc3a133$export$971d5caa766a69d7);
        return /*#__PURE__*/ $f2Y41.createElement(Component, (0, $asN9r.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $f2Y41.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3FrvL.default)(WithTheme, Component);
}
var $e8d333f5cdc3a133$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $e8d333f5cdc3a133$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e8d333f5cdc3a133$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e8d333f5cdc3a133$var$getLastPart(match[1]);
    return undefined;
};
var $e8d333f5cdc3a133$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e8d333f5cdc3a133$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $e8d333f5cdc3a133$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $e8d333f5cdc3a133$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e8d333f5cdc3a133$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e8d333f5cdc3a133$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e8d333f5cdc3a133$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $e8d333f5cdc3a133$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $e8d333f5cdc3a133$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e8d333f5cdc3a133$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e8d333f5cdc3a133$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e8d333f5cdc3a133$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fJDtB.registerStyles)(cache, serialized, isStringTag);
    (0, $fPRBH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fJDtB.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e8d333f5cdc3a133$var$Emotion = /* #__PURE__ */ $e8d333f5cdc3a133$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e8d333f5cdc3a133$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $fJDtB.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $fS7An.serializeStyles)(registeredStyles, undefined, $f2Y41.useContext($e8d333f5cdc3a133$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e8d333f5cdc3a133$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $e8d333f5cdc3a133$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, /*#__PURE__*/ $f2Y41.createElement($e8d333f5cdc3a133$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $f2Y41.createElement(WrappedComponent, newProps));
});
var $e8d333f5cdc3a133$export$a9c23c6ac3fc3eca = $e8d333f5cdc3a133$var$Emotion;

});
parcelRegister("kaWmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb0203e9be3218d3$export$2e2bcd8739ae039; });

var $gRmfo = parcelRequire("gRmfo");

var $9AauJ = parcelRequire("9AauJ");
parcelRequire("9kpSX");
parcelRequire("cC7DW");
var $eb0203e9be3218d3$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $9AauJ.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $9AauJ.token)(character)) break;
        (0, $9AauJ.next)();
    }
    return (0, $9AauJ.slice)(begin, (0, $9AauJ.position));
};
var $eb0203e9be3218d3$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $9AauJ.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $9AauJ.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $eb0203e9be3218d3$var$identifierWithPointTracking((0, $9AauJ.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $9AauJ.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $9AauJ.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $9AauJ.from)(character);
    }
    while (character = (0, $9AauJ.next)());
    return parsed;
};
var $eb0203e9be3218d3$var$getRules = function getRules(value, points) {
    return (0, $9AauJ.dealloc)($eb0203e9be3218d3$var$toRules((0, $9AauJ.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $eb0203e9be3218d3$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $eb0203e9be3218d3$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$eb0203e9be3218d3$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $eb0203e9be3218d3$var$fixedElements.set(element, true);
    var points = [];
    var rules = $eb0203e9be3218d3$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $eb0203e9be3218d3$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $eb0203e9be3218d3$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $eb0203e9be3218d3$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($eb0203e9be3218d3$var$ignoreFlag) > -1;
};
var $eb0203e9be3218d3$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($eb0203e9be3218d3$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $eb0203e9be3218d3$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $eb0203e9be3218d3$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$eb0203e9be3218d3$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $eb0203e9be3218d3$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $eb0203e9be3218d3$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$eb0203e9be3218d3$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $eb0203e9be3218d3$var$nullifyElement(element);
    } else if ($eb0203e9be3218d3$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $eb0203e9be3218d3$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $eb0203e9be3218d3$var$prefix(value, length) {
    switch((0, $9AauJ.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $9AauJ.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $9AauJ.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MOZ) + value + (0, $9AauJ.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + value + value;
        // order
        case 6165:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.replace)(value, /(\w+).+(:[^]+)/, (0, $9AauJ.WEBKIT) + "box-$1$2" + (0, $9AauJ.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + "flex-item-" + (0, $9AauJ.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + "flex-line-pack" + (0, $9AauJ.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + (0, $9AauJ.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + (0, $9AauJ.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $9AauJ.WEBKIT) + "box-" + (0, $9AauJ.replace)(value, "-grow", "") + (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + (0, $9AauJ.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $9AauJ.WEBKIT) + (0, $9AauJ.replace)(value, /([^-])(transform)/g, "$1" + (0, $9AauJ.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $9AauJ.replace)((0, $9AauJ.replace)((0, $9AauJ.replace)(value, /(zoom-|grab)/, (0, $9AauJ.WEBKIT) + "$1"), /(image-set)/, (0, $9AauJ.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9AauJ.replace)(value, /(image-set\([^]*)/, (0, $9AauJ.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $9AauJ.replace)((0, $9AauJ.replace)(value, /(.+:)(flex-)?(.*)/, (0, $9AauJ.WEBKIT) + "box-pack:$3" + (0, $9AauJ.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $9AauJ.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9AauJ.replace)(value, /(.+)-inline(.+)/, (0, $9AauJ.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9AauJ.strlen)(value) - 1 - length > 6) switch((0, $9AauJ.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9AauJ.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9AauJ.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $9AauJ.WEBKIT) + "$2-$3" + "$1" + (0, $9AauJ.MOZ) + ((0, $9AauJ.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9AauJ.indexof)(value, "stretch") ? $eb0203e9be3218d3$var$prefix((0, $9AauJ.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $9AauJ.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $9AauJ.charat)(value, (0, $9AauJ.strlen)(value) - 3 - (~(0, $9AauJ.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $9AauJ.replace)(value, ":", ":" + (0, $9AauJ.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $9AauJ.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $9AauJ.WEBKIT) + ((0, $9AauJ.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $9AauJ.WEBKIT) + "$2$3" + "$1" + (0, $9AauJ.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $9AauJ.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + (0, $9AauJ.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + (0, $9AauJ.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + (0, $9AauJ.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $9AauJ.WEBKIT) + value + (0, $9AauJ.MS) + value + value;
    }
    return value;
}
var $eb0203e9be3218d3$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $9AauJ.DECLARATION:
                element["return"] = $eb0203e9be3218d3$var$prefix(element.value, element.length);
                break;
            case 0, $9AauJ.KEYFRAMES:
                return (0, $9AauJ.serialize)([
                    (0, $9AauJ.copy)(element, {
                        value: (0, $9AauJ.replace)(element.value, "@", "@" + (0, $9AauJ.WEBKIT))
                    })
                ], callback);
            case 0, $9AauJ.RULESET:
                if (element.length) return (0, $9AauJ.combine)(element.props, function(value) {
                    switch((0, $9AauJ.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $9AauJ.serialize)([
                                (0, $9AauJ.copy)(element, {
                                    props: [
                                        (0, $9AauJ.replace)(value, /:(read-\w+)/, ":" + (0, $9AauJ.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $9AauJ.serialize)([
                                (0, $9AauJ.copy)(element, {
                                    props: [
                                        (0, $9AauJ.replace)(value, /:(plac\w+)/, ":" + (0, $9AauJ.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $9AauJ.copy)(element, {
                                    props: [
                                        (0, $9AauJ.replace)(value, /:(plac\w+)/, ":" + (0, $9AauJ.MOZ) + "$1")
                                    ]
                                }),
                                (0, $9AauJ.copy)(element, {
                                    props: [
                                        (0, $9AauJ.replace)(value, /:(plac\w+)/, (0, $9AauJ.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $eb0203e9be3218d3$var$defaultStylisPlugins = [
    $eb0203e9be3218d3$var$prefixer
];
var $eb0203e9be3218d3$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $eb0203e9be3218d3$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $eb0203e9be3218d3$var$compat,
        $eb0203e9be3218d3$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $9AauJ.stringify),
        (0, $9AauJ.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $9AauJ.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $9AauJ.serialize)((0, $9AauJ.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $gRmfo.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("gRmfo", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $c462da67eff30eb7$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $c462da67eff30eb7$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $c462da67eff30eb7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $c462da67eff30eb7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($c462da67eff30eb7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $c462da67eff30eb7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("9AauJ", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $071a61a96d03b9b5$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $071a61a96d03b9b5$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $071a61a96d03b9b5$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $071a61a96d03b9b5$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $071a61a96d03b9b5$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $071a61a96d03b9b5$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $071a61a96d03b9b5$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $071a61a96d03b9b5$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $071a61a96d03b9b5$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $071a61a96d03b9b5$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $071a61a96d03b9b5$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $071a61a96d03b9b5$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $071a61a96d03b9b5$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $071a61a96d03b9b5$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $071a61a96d03b9b5$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $071a61a96d03b9b5$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $071a61a96d03b9b5$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $071a61a96d03b9b5$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $071a61a96d03b9b5$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $071a61a96d03b9b5$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $071a61a96d03b9b5$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $071a61a96d03b9b5$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $071a61a96d03b9b5$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $071a61a96d03b9b5$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $071a61a96d03b9b5$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $071a61a96d03b9b5$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $071a61a96d03b9b5$export$38bcb760f1d4871c; });
var $071a61a96d03b9b5$export$71ad59f2e432cfe8 = "-ms-";
var $071a61a96d03b9b5$export$2c0f367103c8d01c = "-moz-";
var $071a61a96d03b9b5$export$39dfd62a25e0fe93 = "-webkit-";
var $071a61a96d03b9b5$export$a29989082612d0d9 = "comm";
var $071a61a96d03b9b5$export$aa3a2e812ca8570d = "rule";
var $071a61a96d03b9b5$export$527d108ccf083c2b = "decl";
var $071a61a96d03b9b5$export$d3d35020fa5b54f0 = "@page";
var $071a61a96d03b9b5$export$500415a86c544f73 = "@media";
var $071a61a96d03b9b5$export$a763edbf796b780a = "@import";
var $071a61a96d03b9b5$export$2790aeb8b4e5c826 = "@charset";
var $071a61a96d03b9b5$export$1cc683e23b84b133 = "@viewport";
var $071a61a96d03b9b5$export$9447a5efea57e862 = "@supports";
var $071a61a96d03b9b5$export$ef011b4e114b1fba = "@document";
var $071a61a96d03b9b5$export$6aad947bda0f3f46 = "@namespace";
var $071a61a96d03b9b5$export$b44a8529a35fcb60 = "@keyframes";
var $071a61a96d03b9b5$export$2c16de31893252e6 = "@font-face";
var $071a61a96d03b9b5$export$3d846dd52e150c6f = "@counter-style";
var $071a61a96d03b9b5$export$22314bfbb57653fe = "@font-feature-values";
var $071a61a96d03b9b5$export$d773506282b3cfe6 = "@layer";
var $071a61a96d03b9b5$export$2335f513bbd82c6d = Math.abs;
var $071a61a96d03b9b5$export$6788812c4e6611e6 = String.fromCharCode;
var $071a61a96d03b9b5$export$e6e34fd1f2686227 = Object.assign;
function $071a61a96d03b9b5$export$d6af199866bfb566(e, r) {
    return $071a61a96d03b9b5$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $071a61a96d03b9b5$export$a9db5e087081082d(e, 0)) << 2 ^ $071a61a96d03b9b5$export$a9db5e087081082d(e, 1)) << 2 ^ $071a61a96d03b9b5$export$a9db5e087081082d(e, 2)) << 2 ^ $071a61a96d03b9b5$export$a9db5e087081082d(e, 3) : 0;
}
function $071a61a96d03b9b5$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $071a61a96d03b9b5$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $071a61a96d03b9b5$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $071a61a96d03b9b5$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $071a61a96d03b9b5$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $071a61a96d03b9b5$export$36776f635604f274(e) {
    return e.length;
}
function $071a61a96d03b9b5$export$f9084667e487ed46(e) {
    return e.length;
}
function $071a61a96d03b9b5$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $071a61a96d03b9b5$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $071a61a96d03b9b5$export$53f1d5ea8de3d7c = 1;
var $071a61a96d03b9b5$export$4e0c71f277ca26b3 = 1;
var $071a61a96d03b9b5$export$f24224f1c91d8156 = 0;
var $071a61a96d03b9b5$export$5880b8b5730aff45 = 0;
var $071a61a96d03b9b5$export$c0306caf338ac095 = 0;
var $071a61a96d03b9b5$export$30a86d91af8ff6e6 = "";
function $071a61a96d03b9b5$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $071a61a96d03b9b5$export$53f1d5ea8de3d7c,
        column: $071a61a96d03b9b5$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $071a61a96d03b9b5$export$784d13d8ee351f07(e, r) {
    return $071a61a96d03b9b5$export$e6e34fd1f2686227($071a61a96d03b9b5$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $071a61a96d03b9b5$export$eba6f6f03b0a92e7() {
    return $071a61a96d03b9b5$export$c0306caf338ac095;
}
function $071a61a96d03b9b5$export$232faf9add678146() {
    $071a61a96d03b9b5$export$c0306caf338ac095 = $071a61a96d03b9b5$export$5880b8b5730aff45 > 0 ? $071a61a96d03b9b5$export$a9db5e087081082d($071a61a96d03b9b5$export$30a86d91af8ff6e6, --$071a61a96d03b9b5$export$5880b8b5730aff45) : 0;
    if ($071a61a96d03b9b5$export$4e0c71f277ca26b3--, $071a61a96d03b9b5$export$c0306caf338ac095 === 10) $071a61a96d03b9b5$export$4e0c71f277ca26b3 = 1, $071a61a96d03b9b5$export$53f1d5ea8de3d7c--;
    return $071a61a96d03b9b5$export$c0306caf338ac095;
}
function $071a61a96d03b9b5$export$48cfd1e771a65c4f() {
    $071a61a96d03b9b5$export$c0306caf338ac095 = $071a61a96d03b9b5$export$5880b8b5730aff45 < $071a61a96d03b9b5$export$f24224f1c91d8156 ? $071a61a96d03b9b5$export$a9db5e087081082d($071a61a96d03b9b5$export$30a86d91af8ff6e6, $071a61a96d03b9b5$export$5880b8b5730aff45++) : 0;
    if ($071a61a96d03b9b5$export$4e0c71f277ca26b3++, $071a61a96d03b9b5$export$c0306caf338ac095 === 10) $071a61a96d03b9b5$export$4e0c71f277ca26b3 = 1, $071a61a96d03b9b5$export$53f1d5ea8de3d7c++;
    return $071a61a96d03b9b5$export$c0306caf338ac095;
}
function $071a61a96d03b9b5$export$4d3fb11e950abb9e() {
    return $071a61a96d03b9b5$export$a9db5e087081082d($071a61a96d03b9b5$export$30a86d91af8ff6e6, $071a61a96d03b9b5$export$5880b8b5730aff45);
}
function $071a61a96d03b9b5$export$e88cb2efb12ae807() {
    return $071a61a96d03b9b5$export$5880b8b5730aff45;
}
function $071a61a96d03b9b5$export$58adb3bec8346d0f(e, r) {
    return $071a61a96d03b9b5$export$2f35ab04d2335697($071a61a96d03b9b5$export$30a86d91af8ff6e6, e, r);
}
function $071a61a96d03b9b5$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $071a61a96d03b9b5$export$2de70f21292aac9e(e) {
    return $071a61a96d03b9b5$export$53f1d5ea8de3d7c = $071a61a96d03b9b5$export$4e0c71f277ca26b3 = 1, $071a61a96d03b9b5$export$f24224f1c91d8156 = $071a61a96d03b9b5$export$36776f635604f274($071a61a96d03b9b5$export$30a86d91af8ff6e6 = e), $071a61a96d03b9b5$export$5880b8b5730aff45 = 0, [];
}
function $071a61a96d03b9b5$export$45918ac1574455b1(e) {
    return $071a61a96d03b9b5$export$30a86d91af8ff6e6 = "", e;
}
function $071a61a96d03b9b5$export$410ac95b9ec204b8(e) {
    return $071a61a96d03b9b5$export$87c2784dc9fc4ab($071a61a96d03b9b5$export$58adb3bec8346d0f($071a61a96d03b9b5$export$5880b8b5730aff45 - 1, $071a61a96d03b9b5$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $071a61a96d03b9b5$export$660b2ee2d4fb4eff(e) {
    return $071a61a96d03b9b5$export$45918ac1574455b1($071a61a96d03b9b5$export$5f8c09e3ae6f64e1($071a61a96d03b9b5$export$2de70f21292aac9e(e)));
}
function $071a61a96d03b9b5$export$7af1228ff777d175(e) {
    while($071a61a96d03b9b5$export$c0306caf338ac095 = $071a61a96d03b9b5$export$4d3fb11e950abb9e())if ($071a61a96d03b9b5$export$c0306caf338ac095 < 33) $071a61a96d03b9b5$export$48cfd1e771a65c4f();
    else break;
    return $071a61a96d03b9b5$export$9e1725a4cfeada27(e) > 2 || $071a61a96d03b9b5$export$9e1725a4cfeada27($071a61a96d03b9b5$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $071a61a96d03b9b5$export$5f8c09e3ae6f64e1(e) {
    while($071a61a96d03b9b5$export$48cfd1e771a65c4f())switch($071a61a96d03b9b5$export$9e1725a4cfeada27($071a61a96d03b9b5$export$c0306caf338ac095)){
        case 0:
            $071a61a96d03b9b5$export$10d8903dec122b9d($071a61a96d03b9b5$export$c2ab62c7bf24634($071a61a96d03b9b5$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $071a61a96d03b9b5$export$10d8903dec122b9d($071a61a96d03b9b5$export$410ac95b9ec204b8($071a61a96d03b9b5$export$c0306caf338ac095), e);
            break;
        default:
            $071a61a96d03b9b5$export$10d8903dec122b9d($071a61a96d03b9b5$export$6788812c4e6611e6($071a61a96d03b9b5$export$c0306caf338ac095), e);
    }
    return e;
}
function $071a61a96d03b9b5$export$955ba06d119e085e(e, r) {
    while(--r && $071a61a96d03b9b5$export$48cfd1e771a65c4f())if ($071a61a96d03b9b5$export$c0306caf338ac095 < 48 || $071a61a96d03b9b5$export$c0306caf338ac095 > 102 || $071a61a96d03b9b5$export$c0306caf338ac095 > 57 && $071a61a96d03b9b5$export$c0306caf338ac095 < 65 || $071a61a96d03b9b5$export$c0306caf338ac095 > 70 && $071a61a96d03b9b5$export$c0306caf338ac095 < 97) break;
    return $071a61a96d03b9b5$export$58adb3bec8346d0f(e, $071a61a96d03b9b5$export$e88cb2efb12ae807() + (r < 6 && $071a61a96d03b9b5$export$4d3fb11e950abb9e() == 32 && $071a61a96d03b9b5$export$48cfd1e771a65c4f() == 32));
}
function $071a61a96d03b9b5$export$c889f2fcc19dbf12(e) {
    while($071a61a96d03b9b5$export$48cfd1e771a65c4f())switch($071a61a96d03b9b5$export$c0306caf338ac095){
        case e:
            return $071a61a96d03b9b5$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $071a61a96d03b9b5$export$c889f2fcc19dbf12($071a61a96d03b9b5$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $071a61a96d03b9b5$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $071a61a96d03b9b5$export$48cfd1e771a65c4f();
            break;
    }
    return $071a61a96d03b9b5$export$5880b8b5730aff45;
}
function $071a61a96d03b9b5$export$4254d4e2b3745c4c(e, r) {
    while($071a61a96d03b9b5$export$48cfd1e771a65c4f())if (e + $071a61a96d03b9b5$export$c0306caf338ac095 === 57) break;
    else if (e + $071a61a96d03b9b5$export$c0306caf338ac095 === 84 && $071a61a96d03b9b5$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $071a61a96d03b9b5$export$58adb3bec8346d0f(r, $071a61a96d03b9b5$export$5880b8b5730aff45 - 1) + "*" + $071a61a96d03b9b5$export$6788812c4e6611e6(e === 47 ? e : $071a61a96d03b9b5$export$48cfd1e771a65c4f());
}
function $071a61a96d03b9b5$export$c2ab62c7bf24634(e) {
    while(!$071a61a96d03b9b5$export$9e1725a4cfeada27($071a61a96d03b9b5$export$4d3fb11e950abb9e()))$071a61a96d03b9b5$export$48cfd1e771a65c4f();
    return $071a61a96d03b9b5$export$58adb3bec8346d0f(e, $071a61a96d03b9b5$export$5880b8b5730aff45);
}
function $071a61a96d03b9b5$export$ef7acd7185315e22(e) {
    return $071a61a96d03b9b5$export$45918ac1574455b1($071a61a96d03b9b5$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $071a61a96d03b9b5$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $071a61a96d03b9b5$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $071a61a96d03b9b5$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $071a61a96d03b9b5$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($071a61a96d03b9b5$export$f8e21b1e77979a08(j += $071a61a96d03b9b5$export$77ad94ebf1c2b9ed($071a61a96d03b9b5$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $071a61a96d03b9b5$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $071a61a96d03b9b5$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $071a61a96d03b9b5$export$955ba06d119e085e($071a61a96d03b9b5$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($071a61a96d03b9b5$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $071a61a96d03b9b5$export$10d8903dec122b9d($071a61a96d03b9b5$export$4a34f930e789283c($071a61a96d03b9b5$export$4254d4e2b3745c4c($071a61a96d03b9b5$export$48cfd1e771a65c4f(), $071a61a96d03b9b5$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $071a61a96d03b9b5$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $071a61a96d03b9b5$export$36776f635604f274(j) - l) $071a61a96d03b9b5$export$10d8903dec122b9d(p > 32 ? $071a61a96d03b9b5$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $071a61a96d03b9b5$export$f8483753829ec8f3($071a61a96d03b9b5$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $071a61a96d03b9b5$export$10d8903dec122b9d(y = $071a61a96d03b9b5$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $071a61a96d03b9b5$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $071a61a96d03b9b5$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $071a61a96d03b9b5$export$98e6a39c04603d36(e, y, y, n && $071a61a96d03b9b5$export$10d8903dec122b9d($071a61a96d03b9b5$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $071a61a96d03b9b5$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $071a61a96d03b9b5$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $071a61a96d03b9b5$export$232faf9add678146() == 125) continue;
            }
            switch(j += $071a61a96d03b9b5$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($071a61a96d03b9b5$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($071a61a96d03b9b5$export$4d3fb11e950abb9e() === 45) j += $071a61a96d03b9b5$export$410ac95b9ec204b8($071a61a96d03b9b5$export$48cfd1e771a65c4f());
                    v = $071a61a96d03b9b5$export$4d3fb11e950abb9e(), o = l = $071a61a96d03b9b5$export$36776f635604f274(g = j += $071a61a96d03b9b5$export$c2ab62c7bf24634($071a61a96d03b9b5$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $071a61a96d03b9b5$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $071a61a96d03b9b5$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $071a61a96d03b9b5$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $071a61a96d03b9b5$export$2f35ab04d2335697(e, v + 1, v = $071a61a96d03b9b5$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $071a61a96d03b9b5$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $071a61a96d03b9b5$export$35059013cd4a06db(e, r, a, s === 0 ? $071a61a96d03b9b5$export$aa3a2e812ca8570d : i, f, o, l);
}
function $071a61a96d03b9b5$export$4a34f930e789283c(e, r, a) {
    return $071a61a96d03b9b5$export$35059013cd4a06db(e, r, a, $071a61a96d03b9b5$export$a29989082612d0d9, $071a61a96d03b9b5$export$6788812c4e6611e6($071a61a96d03b9b5$export$eba6f6f03b0a92e7()), $071a61a96d03b9b5$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $071a61a96d03b9b5$export$f8483753829ec8f3(e, r, a, n) {
    return $071a61a96d03b9b5$export$35059013cd4a06db(e, r, a, $071a61a96d03b9b5$export$527d108ccf083c2b, $071a61a96d03b9b5$export$2f35ab04d2335697(e, 0, n), $071a61a96d03b9b5$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $071a61a96d03b9b5$export$82e9f45cca5ba907(n, c, s) {
    switch($071a61a96d03b9b5$export$d6af199866bfb566(n, c)){
        case 5103:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $071a61a96d03b9b5$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$2c0f367103c8d01c + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($071a61a96d03b9b5$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "box-$1$2" + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "flex-item-" + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$071a61a96d03b9b5$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "grid-row-" + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "flex-line-pack" + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "box-" + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "-grow", "") + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $071a61a96d03b9b5$export$39dfd62a25e0fe93 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed($071a61a96d03b9b5$export$77ad94ebf1c2b9ed($071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed($071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "box-pack:$3" + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$071a61a96d03b9b5$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "grid-column-align" + $071a61a96d03b9b5$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $071a61a96d03b9b5$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$071a61a96d03b9b5$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$071a61a96d03b9b5$export$f8e21b1e77979a08(s, "span") ? $071a61a96d03b9b5$export$4659b591c19bdf3d(s, /\d+/) : +$071a61a96d03b9b5$export$4659b591c19bdf3d(s, /\d+/) - +$071a61a96d03b9b5$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $071a61a96d03b9b5$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $071a61a96d03b9b5$export$71ad59f2e432cfe8 + $071a61a96d03b9b5$export$77ad94ebf1c2b9ed($071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($071a61a96d03b9b5$export$36776f635604f274(n) - 1 - c > 6) switch($071a61a96d03b9b5$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($071a61a96d03b9b5$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $071a61a96d03b9b5$export$2c0f367103c8d01c + ($071a61a96d03b9b5$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$071a61a96d03b9b5$export$f8e21b1e77979a08(n, "stretch") ? $071a61a96d03b9b5$export$82e9f45cca5ba907($071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $071a61a96d03b9b5$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $071a61a96d03b9b5$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($071a61a96d03b9b5$export$a9db5e087081082d(n, c + 6) === 121) return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, ":", ":" + $071a61a96d03b9b5$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($071a61a96d03b9b5$export$a9db5e087081082d(n, $071a61a96d03b9b5$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + ($071a61a96d03b9b5$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, ":", ":" + $071a61a96d03b9b5$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $071a61a96d03b9b5$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $071a61a96d03b9b5$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $071a61a96d03b9b5$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $071a61a96d03b9b5$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $071a61a96d03b9b5$export$a763edbf796b780a:
        case $071a61a96d03b9b5$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $071a61a96d03b9b5$export$a29989082612d0d9:
            return "";
        case $071a61a96d03b9b5$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $071a61a96d03b9b5$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $071a61a96d03b9b5$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $071a61a96d03b9b5$export$36776f635604f274(a = $071a61a96d03b9b5$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $071a61a96d03b9b5$export$5a7767152ae0305f(e) {
    var r = $071a61a96d03b9b5$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $071a61a96d03b9b5$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $071a61a96d03b9b5$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $071a61a96d03b9b5$export$527d108ccf083c2b:
                n.return = $071a61a96d03b9b5$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $071a61a96d03b9b5$export$b44a8529a35fcb60:
                return $071a61a96d03b9b5$export$dfdc1655ccc5b9cb([
                    $071a61a96d03b9b5$export$784d13d8ee351f07(n, {
                        value: $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $071a61a96d03b9b5$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $071a61a96d03b9b5$export$aa3a2e812ca8570d:
                if (n.length) return $071a61a96d03b9b5$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($071a61a96d03b9b5$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $071a61a96d03b9b5$export$dfdc1655ccc5b9cb([
                                $071a61a96d03b9b5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $071a61a96d03b9b5$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $071a61a96d03b9b5$export$dfdc1655ccc5b9cb([
                                $071a61a96d03b9b5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $071a61a96d03b9b5$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $071a61a96d03b9b5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $071a61a96d03b9b5$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $071a61a96d03b9b5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $071a61a96d03b9b5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $071a61a96d03b9b5$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $071a61a96d03b9b5$export$76a88f7de6507443(e) {
    switch(e.type){
        case $071a61a96d03b9b5$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $071a61a96d03b9b5$export$1be1fc439b849fdf($071a61a96d03b9b5$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($071a61a96d03b9b5$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $071a61a96d03b9b5$export$2f35ab04d2335697(r, 1, $071a61a96d03b9b5$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $071a61a96d03b9b5$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $071a61a96d03b9b5$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $071a61a96d03b9b5$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("9kpSX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6caa0f9c7a42f4b8$export$2e2bcd8739ae039; });
var $6caa0f9c7a42f4b8$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("3FrvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aba8a9d6211f4c6$export$2e2bcd8739ae039; });

var $d6J3N = parcelRequire("d6J3N");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2aba8a9d6211f4c6$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($d6J3N)))(targetComponent, sourceComponent);
};

});
parcelRegister("d6J3N", function(module, exports) {
"use strict";

var $eqKcA = parcelRequire("eqKcA");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $98aec9f0578e878d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $98aec9f0578e878d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $98aec9f0578e878d$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $98aec9f0578e878d$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $98aec9f0578e878d$var$TYPE_STATICS = {};
$98aec9f0578e878d$var$TYPE_STATICS[$eqKcA.ForwardRef] = $98aec9f0578e878d$var$FORWARD_REF_STATICS;
$98aec9f0578e878d$var$TYPE_STATICS[$eqKcA.Memo] = $98aec9f0578e878d$var$MEMO_STATICS;
function $98aec9f0578e878d$var$getStatics(component) {
    // React v16.11 and below
    if ($eqKcA.isMemo(component)) return $98aec9f0578e878d$var$MEMO_STATICS;
     // React v16.12 and above
    return $98aec9f0578e878d$var$TYPE_STATICS[component["$$typeof"]] || $98aec9f0578e878d$var$REACT_STATICS;
}
var $98aec9f0578e878d$var$defineProperty = Object.defineProperty;
var $98aec9f0578e878d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $98aec9f0578e878d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $98aec9f0578e878d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $98aec9f0578e878d$var$getPrototypeOf = Object.getPrototypeOf;
var $98aec9f0578e878d$var$objectPrototype = Object.prototype;
function $98aec9f0578e878d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($98aec9f0578e878d$var$objectPrototype) {
            var inheritedComponent = $98aec9f0578e878d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $98aec9f0578e878d$var$objectPrototype) $98aec9f0578e878d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $98aec9f0578e878d$var$getOwnPropertyNames(sourceComponent);
        if ($98aec9f0578e878d$var$getOwnPropertySymbols) keys = keys.concat($98aec9f0578e878d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $98aec9f0578e878d$var$getStatics(targetComponent);
        var sourceStatics = $98aec9f0578e878d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$98aec9f0578e878d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $98aec9f0578e878d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $98aec9f0578e878d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $98aec9f0578e878d$var$hoistNonReactStatics;

});
parcelRegister("eqKcA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("rwG8S"));

});



parcelRegister("fJDtB", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $b749ae30687ddad6$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $b749ae30687ddad6$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $b749ae30687ddad6$export$6f077d94b33a01aa; });
var $b749ae30687ddad6$var$isBrowser = true;
function $b749ae30687ddad6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $b749ae30687ddad6$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b749ae30687ddad6$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $b749ae30687ddad6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $b749ae30687ddad6$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("fS7An", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $b8e1c8891ae1eb7d$export$6321afa313b251b5; });

var $1Z6Wf = parcelRequire("1Z6Wf");

var $eSopv = parcelRequire("eSopv");

var $cC7DW = parcelRequire("cC7DW");
var $b8e1c8891ae1eb7d$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $b8e1c8891ae1eb7d$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $b8e1c8891ae1eb7d$var$hyphenateRegex = /[A-Z]|^ms/g;
var $b8e1c8891ae1eb7d$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $b8e1c8891ae1eb7d$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $b8e1c8891ae1eb7d$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $b8e1c8891ae1eb7d$var$processStyleName = /* #__PURE__ */ (0, $cC7DW.default)(function(styleName) {
    return $b8e1c8891ae1eb7d$var$isCustomProperty(styleName) ? styleName : styleName.replace($b8e1c8891ae1eb7d$var$hyphenateRegex, "-$&").toLowerCase();
});
var $b8e1c8891ae1eb7d$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($b8e1c8891ae1eb7d$var$animationRegex, function(match, p1, p2) {
                $b8e1c8891ae1eb7d$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $b8e1c8891ae1eb7d$var$cursor
                };
                return p1;
            });
    }
    if ((0, $eSopv.default)[key] !== 1 && !$b8e1c8891ae1eb7d$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $b8e1c8891ae1eb7d$var$contentValuePattern, $b8e1c8891ae1eb7d$var$contentValues, $b8e1c8891ae1eb7d$var$oldProcessStyleValue, $b8e1c8891ae1eb7d$var$msPattern, $b8e1c8891ae1eb7d$var$hyphenPattern, $b8e1c8891ae1eb7d$var$hyphenatedCache;
var $b8e1c8891ae1eb7d$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $b8e1c8891ae1eb7d$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $b8e1c8891ae1eb7d$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $b8e1c8891ae1eb7d$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $b8e1c8891ae1eb7d$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $b8e1c8891ae1eb7d$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $b8e1c8891ae1eb7d$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $b8e1c8891ae1eb7d$var$cursor;
                var result = interpolation(mergedProps);
                $b8e1c8891ae1eb7d$var$cursor = previousCursor;
                return $b8e1c8891ae1eb7d$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $b8e1c8891ae1eb7d$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $b8e1c8891ae1eb7d$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($b8e1c8891ae1eb7d$var$isProcessableValue(value)) string += $b8e1c8891ae1eb7d$var$processStyleName(_key) + ":" + $b8e1c8891ae1eb7d$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($b8e1c8891ae1eb7d$var$isProcessableValue(value[_i])) string += $b8e1c8891ae1eb7d$var$processStyleName(_key) + ":" + $b8e1c8891ae1eb7d$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $b8e1c8891ae1eb7d$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $b8e1c8891ae1eb7d$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $b8e1c8891ae1eb7d$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $b8e1c8891ae1eb7d$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $b8e1c8891ae1eb7d$var$cursor;
var $b8e1c8891ae1eb7d$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $b8e1c8891ae1eb7d$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $b8e1c8891ae1eb7d$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $b8e1c8891ae1eb7d$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $b8e1c8891ae1eb7d$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $b8e1c8891ae1eb7d$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1Z6Wf.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $b8e1c8891ae1eb7d$var$cursor
    };
};

});
parcelRegister("1Z6Wf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1720dec329380374$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1720dec329380374$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("eSopv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad490b3a3fd8496b$export$2e2bcd8739ae039; });
var $ad490b3a3fd8496b$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fPRBH", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b87533afcad6d226$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b87533afcad6d226$export$811a713a7276cb9d; });

var $f2Y41 = parcelRequire("f2Y41");
var $b87533afcad6d226$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b87533afcad6d226$var$useInsertionEffect = $f2Y41.useInsertionEffect ? $f2Y41.useInsertionEffect : false;
var $b87533afcad6d226$export$db21c7ffa21794e7 = $b87533afcad6d226$var$useInsertionEffect || $b87533afcad6d226$var$syncFallback;
var $b87533afcad6d226$export$811a713a7276cb9d = $b87533afcad6d226$var$useInsertionEffect || $f2Y41.useLayoutEffect;

});





parcelRegister("fwGtS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4dacc001708c894$export$2e2bcd8739ae039; });
parcelRequire("f2Y41");


var $jZjY3 = parcelRequire("jZjY3");

var $kaWmH = parcelRequire("kaWmH");

var $ge3KO = parcelRequire("ge3KO");
"use client";
let $b4dacc001708c894$var$cache;
if (typeof document === "object") $b4dacc001708c894$var$cache = (0, $kaWmH.default)({
    key: "css",
    prepend: true
});
function $b4dacc001708c894$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $b4dacc001708c894$var$cache ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $jZjY3.C), {
        value: $b4dacc001708c894$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("ge3KO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cp2FO"));

});


parcelRegister("jNp5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6960d863adba769$export$2e2bcd8739ae039; });
parcelRequire("f2Y41");


var $jvVhJ = parcelRequire("jvVhJ");

var $ge3KO = parcelRequire("ge3KO");
"use client";
function $e6960d863adba769$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $e6960d863adba769$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($e6960d863adba769$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $jvVhJ.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("izihI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gl072")).default; });

var $gl072 = parcelRequire("gl072");

});
parcelRegister("gl072", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be4eb1d6bd7d826b$export$2e2bcd8739ae039; });

var $aahau = parcelRequire("aahau");
function $be4eb1d6bd7d826b$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $aahau.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("1H7Jh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7FGG5")).default; });

var $7FGG5 = parcelRequire("7FGG5");
$parcel$exportWildcard(module.exports, $7FGG5);

});
parcelRegister("7FGG5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $595d77aeb7756a73$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $595d77aeb7756a73$export$2e2bcd8739ae039; });

var $lalVm = parcelRequire("lalVm");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $595d77aeb7756a73$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $595d77aeb7756a73$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($595d77aeb7756a73$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $595d77aeb7756a73$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $595d77aeb7756a73$export$aad197c7121a6651(Component) || fallback;
}
function $595d77aeb7756a73$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $595d77aeb7756a73$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $595d77aeb7756a73$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $595d77aeb7756a73$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $lalVm.ForwardRef:
            return $595d77aeb7756a73$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $lalVm.Memo:
            return $595d77aeb7756a73$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("lalVm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gGFtU"));

});
parcelRegister("gGFtU", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $c260bef1a3f06264$export$a7c73072b1a182ae; }, function (v) { return $c260bef1a3f06264$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c260bef1a3f06264$export$9f27bc3417b4524d; }, function (v) { return $c260bef1a3f06264$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c260bef1a3f06264$export$db77ccec0bb4ccac; }, function (v) { return $c260bef1a3f06264$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c260bef1a3f06264$export$8392c0c9d3dcbd35; }, function (v) { return $c260bef1a3f06264$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c260bef1a3f06264$export$ffb0004e005737fa; }, function (v) { return $c260bef1a3f06264$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c260bef1a3f06264$export$b624eff549462981; }, function (v) { return $c260bef1a3f06264$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c260bef1a3f06264$export$7897aa7841a5380c; }, function (v) { return $c260bef1a3f06264$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c260bef1a3f06264$export$602eac185826482c; }, function (v) { return $c260bef1a3f06264$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c260bef1a3f06264$export$e2c29f18771995cb; }, function (v) { return $c260bef1a3f06264$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c260bef1a3f06264$export$5f8d39834fd61797; }, function (v) { return $c260bef1a3f06264$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c260bef1a3f06264$export$74bf444e3cd11ea5; }, function (v) { return $c260bef1a3f06264$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $c260bef1a3f06264$export$998bcd577473dd93; }, function (v) { return $c260bef1a3f06264$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c260bef1a3f06264$export$92387174baf9b227; }, function (v) { return $c260bef1a3f06264$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c260bef1a3f06264$export$ec112efeb987d9c6; }, function (v) { return $c260bef1a3f06264$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c260bef1a3f06264$export$b706b080d889d2c9; }, function (v) { return $c260bef1a3f06264$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c260bef1a3f06264$export$5be5a87408f70ddc; }, function (v) { return $c260bef1a3f06264$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c260bef1a3f06264$export$45a5e7f76e0caa8d; }, function (v) { return $c260bef1a3f06264$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c260bef1a3f06264$export$455c2e768291efa6; }, function (v) { return $c260bef1a3f06264$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c260bef1a3f06264$export$9522e17588c12572; }, function (v) { return $c260bef1a3f06264$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c260bef1a3f06264$export$2110ac352bb060b9; }, function (v) { return $c260bef1a3f06264$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c260bef1a3f06264$export$56885ab8b9c456ab; }, function (v) { return $c260bef1a3f06264$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c260bef1a3f06264$export$d927fcb6adf8f9de; }, function (v) { return $c260bef1a3f06264$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c260bef1a3f06264$export$b82d16f27459e05a; }, function (v) { return $c260bef1a3f06264$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c260bef1a3f06264$export$522c17b4f5e123e8; }, function (v) { return $c260bef1a3f06264$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c260bef1a3f06264$export$1aabd8a0274ecfd6; }, function (v) { return $c260bef1a3f06264$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $c260bef1a3f06264$export$3d6c20d97e46b957; }, function (v) { return $c260bef1a3f06264$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c260bef1a3f06264$export$9b621391a187a31a; }, function (v) { return $c260bef1a3f06264$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c260bef1a3f06264$export$f5bbd400c2f4426f; }, function (v) { return $c260bef1a3f06264$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c260bef1a3f06264$export$a7c73072b1a182ae;
var $c260bef1a3f06264$export$9f27bc3417b4524d;
var $c260bef1a3f06264$export$db77ccec0bb4ccac;
var $c260bef1a3f06264$export$8392c0c9d3dcbd35;
var $c260bef1a3f06264$export$ffb0004e005737fa;
var $c260bef1a3f06264$export$b624eff549462981;
var $c260bef1a3f06264$export$7897aa7841a5380c;
var $c260bef1a3f06264$export$602eac185826482c;
var $c260bef1a3f06264$export$e2c29f18771995cb;
var $c260bef1a3f06264$export$5f8d39834fd61797;
var $c260bef1a3f06264$export$74bf444e3cd11ea5;
var $c260bef1a3f06264$export$998bcd577473dd93;
var $c260bef1a3f06264$export$92387174baf9b227;
var $c260bef1a3f06264$export$ec112efeb987d9c6;
var $c260bef1a3f06264$export$b706b080d889d2c9;
var $c260bef1a3f06264$export$5be5a87408f70ddc;
var $c260bef1a3f06264$export$45a5e7f76e0caa8d;
var $c260bef1a3f06264$export$455c2e768291efa6;
var $c260bef1a3f06264$export$9522e17588c12572;
var $c260bef1a3f06264$export$2110ac352bb060b9;
var $c260bef1a3f06264$export$56885ab8b9c456ab;
var $c260bef1a3f06264$export$d927fcb6adf8f9de;
var $c260bef1a3f06264$export$b82d16f27459e05a;
var $c260bef1a3f06264$export$522c17b4f5e123e8;
var $c260bef1a3f06264$export$1aabd8a0274ecfd6;
var $c260bef1a3f06264$export$3d6c20d97e46b957;
var $c260bef1a3f06264$export$9b621391a187a31a;
var $c260bef1a3f06264$export$f5bbd400c2f4426f;
"use strict";
var $c260bef1a3f06264$var$b = Symbol.for("react.element"), $c260bef1a3f06264$var$c = Symbol.for("react.portal"), $c260bef1a3f06264$var$d = Symbol.for("react.fragment"), $c260bef1a3f06264$var$e = Symbol.for("react.strict_mode"), $c260bef1a3f06264$var$f = Symbol.for("react.profiler"), $c260bef1a3f06264$var$g = Symbol.for("react.provider"), $c260bef1a3f06264$var$h = Symbol.for("react.context"), $c260bef1a3f06264$var$k = Symbol.for("react.server_context"), $c260bef1a3f06264$var$l = Symbol.for("react.forward_ref"), $c260bef1a3f06264$var$m = Symbol.for("react.suspense"), $c260bef1a3f06264$var$n = Symbol.for("react.suspense_list"), $c260bef1a3f06264$var$p = Symbol.for("react.memo"), $c260bef1a3f06264$var$q = Symbol.for("react.lazy"), $c260bef1a3f06264$var$t = Symbol.for("react.offscreen"), $c260bef1a3f06264$var$u;
$c260bef1a3f06264$var$u = Symbol.for("react.module.reference");
function $c260bef1a3f06264$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $c260bef1a3f06264$var$b:
                switch(a = a.type, a){
                    case $c260bef1a3f06264$var$d:
                    case $c260bef1a3f06264$var$f:
                    case $c260bef1a3f06264$var$e:
                    case $c260bef1a3f06264$var$m:
                    case $c260bef1a3f06264$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c260bef1a3f06264$var$k:
                            case $c260bef1a3f06264$var$h:
                            case $c260bef1a3f06264$var$l:
                            case $c260bef1a3f06264$var$q:
                            case $c260bef1a3f06264$var$p:
                            case $c260bef1a3f06264$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $c260bef1a3f06264$var$c:
                return r;
        }
    }
}
$c260bef1a3f06264$export$a7c73072b1a182ae = $c260bef1a3f06264$var$h;
$c260bef1a3f06264$export$9f27bc3417b4524d = $c260bef1a3f06264$var$g;
$c260bef1a3f06264$export$db77ccec0bb4ccac = $c260bef1a3f06264$var$b;
$c260bef1a3f06264$export$8392c0c9d3dcbd35 = $c260bef1a3f06264$var$l;
$c260bef1a3f06264$export$ffb0004e005737fa = $c260bef1a3f06264$var$d;
$c260bef1a3f06264$export$b624eff549462981 = $c260bef1a3f06264$var$q;
$c260bef1a3f06264$export$7897aa7841a5380c = $c260bef1a3f06264$var$p;
$c260bef1a3f06264$export$602eac185826482c = $c260bef1a3f06264$var$c;
$c260bef1a3f06264$export$e2c29f18771995cb = $c260bef1a3f06264$var$f;
$c260bef1a3f06264$export$5f8d39834fd61797 = $c260bef1a3f06264$var$e;
$c260bef1a3f06264$export$74bf444e3cd11ea5 = $c260bef1a3f06264$var$m;
$c260bef1a3f06264$export$998bcd577473dd93 = $c260bef1a3f06264$var$n;
$c260bef1a3f06264$export$92387174baf9b227 = function() {
    return !1;
};
$c260bef1a3f06264$export$ec112efeb987d9c6 = function() {
    return !1;
};
$c260bef1a3f06264$export$b706b080d889d2c9 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$h;
};
$c260bef1a3f06264$export$5be5a87408f70ddc = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$g;
};
$c260bef1a3f06264$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c260bef1a3f06264$var$b;
};
$c260bef1a3f06264$export$455c2e768291efa6 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$l;
};
$c260bef1a3f06264$export$9522e17588c12572 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$d;
};
$c260bef1a3f06264$export$2110ac352bb060b9 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$q;
};
$c260bef1a3f06264$export$56885ab8b9c456ab = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$p;
};
$c260bef1a3f06264$export$d927fcb6adf8f9de = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$c;
};
$c260bef1a3f06264$export$b82d16f27459e05a = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$f;
};
$c260bef1a3f06264$export$522c17b4f5e123e8 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$e;
};
$c260bef1a3f06264$export$1aabd8a0274ecfd6 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$m;
};
$c260bef1a3f06264$export$3d6c20d97e46b957 = function(a) {
    return $c260bef1a3f06264$var$v(a) === $c260bef1a3f06264$var$n;
};
$c260bef1a3f06264$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c260bef1a3f06264$var$d || a === $c260bef1a3f06264$var$f || a === $c260bef1a3f06264$var$e || a === $c260bef1a3f06264$var$m || a === $c260bef1a3f06264$var$n || a === $c260bef1a3f06264$var$t || "object" === typeof a && null !== a && (a.$$typeof === $c260bef1a3f06264$var$q || a.$$typeof === $c260bef1a3f06264$var$p || a.$$typeof === $c260bef1a3f06264$var$g || a.$$typeof === $c260bef1a3f06264$var$h || a.$$typeof === $c260bef1a3f06264$var$l || a.$$typeof === $c260bef1a3f06264$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$c260bef1a3f06264$export$f5bbd400c2f4426f = $c260bef1a3f06264$var$v;

});




parcelRegister("hBrK5", function(module, exports) {
function $cd0b6970d59e1329$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $cd0b6970d59e1329$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bAOL4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hjRti")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("iCGVI")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("7ZFy0")).default; });

var $hjRti = parcelRequire("hjRti");

var $iCGVI = parcelRequire("iCGVI");

var $7ZFy0 = parcelRequire("7ZFy0");

});
parcelRegister("hjRti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9bdb058fa6549e3$export$2e2bcd8739ae039; });

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $cAicU = parcelRequire("cAicU");

var $iCGVI = parcelRequire("iCGVI");

var $lNKHb = parcelRequire("lNKHb");

var $5yptQ = parcelRequire("5yptQ");

var $iKUML = parcelRequire("iKUML");

var $eYiFE = parcelRequire("eYiFE");

var $7ZFy0 = parcelRequire("7ZFy0");
const $c9bdb058fa6549e3$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $c9bdb058fa6549e3$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $bKcdJ.default)(options, $c9bdb058fa6549e3$var$_excluded);
    const breakpoints = (0, $iCGVI.default)(breakpointsInput);
    const spacing = (0, $5yptQ.default)(spacingInput);
    let muiTheme = (0, $cAicU.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $asN9r.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $asN9r.default)({}, (0, $lNKHb.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $7ZFy0.default);
    muiTheme = args.reduce((acc, argument)=>(0, $cAicU.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $asN9r.default)({}, (0, $eYiFE.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $iKUML.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $c9bdb058fa6549e3$export$2e2bcd8739ae039 = $c9bdb058fa6549e3$var$createTheme;

});
parcelRegister("bKcdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88cd785867e185e8$export$2e2bcd8739ae039; });
function $88cd785867e185e8$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("cAicU", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $9296f86b458673ee$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $9296f86b458673ee$export$2e2bcd8739ae039; });

var $asN9r = parcelRequire("asN9r");
function $9296f86b458673ee$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $9296f86b458673ee$var$deepClone(source) {
    if (!$9296f86b458673ee$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $9296f86b458673ee$var$deepClone(source[key]);
    });
    return output;
}
function $9296f86b458673ee$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $asN9r.default)({}, target) : target;
    if ($9296f86b458673ee$export$53b83ca8eaab0383(target) && $9296f86b458673ee$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($9296f86b458673ee$export$53b83ca8eaab0383(source[key]) && key in target && $9296f86b458673ee$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $9296f86b458673ee$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $9296f86b458673ee$export$53b83ca8eaab0383(source[key]) ? $9296f86b458673ee$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("iCGVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8ed1398de3816e3$export$2e2bcd8739ae039; });

var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");
const $d8ed1398de3816e3$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $d8ed1398de3816e3$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $d8ed1398de3816e3$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $asN9r.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $d8ed1398de3816e3$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $bKcdJ.default)(breakpoints, $d8ed1398de3816e3$var$_excluded);
    const sortedValues = $d8ed1398de3816e3$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $asN9r.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("lNKHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdf26556c10ef8ed$export$2e2bcd8739ae039; });
const $fdf26556c10ef8ed$var$shape = {
    borderRadius: 4
};
var $fdf26556c10ef8ed$export$2e2bcd8739ae039 = $fdf26556c10ef8ed$var$shape;

});

parcelRegister("5yptQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40b3e49247b80cce$export$2e2bcd8739ae039; });

var $bmohe = parcelRequire("bmohe");
function $40b3e49247b80cce$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $bmohe.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("bmohe", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $845494ace60000fc$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $845494ace60000fc$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $845494ace60000fc$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $845494ace60000fc$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $845494ace60000fc$export$6f98e8eaf0be1996; });


var $4Um5Q = parcelRequire("4Um5Q");

var $8V3ZT = parcelRequire("8V3ZT");

var $b4g7k = parcelRequire("b4g7k");

var $62F0S = parcelRequire("62F0S");
const $845494ace60000fc$var$properties = {
    m: "margin",
    p: "padding"
};
const $845494ace60000fc$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $845494ace60000fc$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $845494ace60000fc$var$getCssProperties = (0, $62F0S.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($845494ace60000fc$var$aliases[prop]) prop = $845494ace60000fc$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $845494ace60000fc$var$properties[a];
    const direction = $845494ace60000fc$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $845494ace60000fc$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $845494ace60000fc$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $845494ace60000fc$var$spacingKeys = [
    ...$845494ace60000fc$export$aab52a0dde05ad8a,
    ...$845494ace60000fc$export$f8397d44f03ab6ad
];
function $845494ace60000fc$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $8V3ZT.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $845494ace60000fc$export$1def6f833384e3d1(theme) {
    return $845494ace60000fc$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $845494ace60000fc$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $845494ace60000fc$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $845494ace60000fc$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $845494ace60000fc$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $845494ace60000fc$var$getCssProperties(prop);
    const styleFromPropValue = $845494ace60000fc$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $4Um5Q.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $845494ace60000fc$var$style(props, keys) {
    const transformer = $845494ace60000fc$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$845494ace60000fc$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $b4g7k.default), {});
}
function $845494ace60000fc$export$7ede87f9b603dd3c(props) {
    return $845494ace60000fc$var$style(props, $845494ace60000fc$export$aab52a0dde05ad8a);
}
$845494ace60000fc$export$7ede87f9b603dd3c.propTypes = {};
$845494ace60000fc$export$7ede87f9b603dd3c.filterProps = $845494ace60000fc$export$aab52a0dde05ad8a;
function $845494ace60000fc$export$6f98e8eaf0be1996(props) {
    return $845494ace60000fc$var$style(props, $845494ace60000fc$export$f8397d44f03ab6ad);
}
$845494ace60000fc$export$6f98e8eaf0be1996.propTypes = {};
$845494ace60000fc$export$6f98e8eaf0be1996.filterProps = $845494ace60000fc$export$f8397d44f03ab6ad;
function $845494ace60000fc$var$spacing(props) {
    return $845494ace60000fc$var$style(props, $845494ace60000fc$var$spacingKeys);
}
$845494ace60000fc$var$spacing.propTypes = {};
$845494ace60000fc$var$spacing.filterProps = $845494ace60000fc$var$spacingKeys;
var $845494ace60000fc$export$2e2bcd8739ae039 = $845494ace60000fc$var$spacing;

});
parcelRegister("4Um5Q", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $392d87a5f690c91f$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $392d87a5f690c91f$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $392d87a5f690c91f$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $392d87a5f690c91f$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $392d87a5f690c91f$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $392d87a5f690c91f$export$980e6a259d807490; });

var $asN9r = parcelRequire("asN9r");


var $cAicU = parcelRequire("cAicU");

var $b4g7k = parcelRequire("b4g7k");
const $392d87a5f690c91f$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $392d87a5f690c91f$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$392d87a5f690c91f$export$68c286be0e7e55b7[key]}px)`
};
function $392d87a5f690c91f$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $392d87a5f690c91f$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $392d87a5f690c91f$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $392d87a5f690c91f$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $392d87a5f690c91f$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $392d87a5f690c91f$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $asN9r.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $b4g7k.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $392d87a5f690c91f$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $392d87a5f690c91f$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $392d87a5f690c91f$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $392d87a5f690c91f$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $cAicU.default)(prev, next), {});
    return $392d87a5f690c91f$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $392d87a5f690c91f$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $392d87a5f690c91f$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $392d87a5f690c91f$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $392d87a5f690c91f$export$2e2bcd8739ae039 = $392d87a5f690c91f$var$breakpoints;

});
parcelRegister("b4g7k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80ec91f253fb99ff$export$2e2bcd8739ae039; });

var $cAicU = parcelRequire("cAicU");
function $80ec91f253fb99ff$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $cAicU.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $80ec91f253fb99ff$export$2e2bcd8739ae039 = $80ec91f253fb99ff$var$merge;

});


parcelRegister("8V3ZT", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $67e6bf647a41646e$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $67e6bf647a41646e$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $67e6bf647a41646e$export$2e2bcd8739ae039; });

var $gl072 = parcelRequire("gl072");


var $4Um5Q = parcelRequire("4Um5Q");
function $67e6bf647a41646e$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $67e6bf647a41646e$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $67e6bf647a41646e$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $67e6bf647a41646e$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $67e6bf647a41646e$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $67e6bf647a41646e$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $67e6bf647a41646e$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $gl072.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4Um5Q.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $67e6bf647a41646e$export$2e2bcd8739ae039 = $67e6bf647a41646e$var$style;

});

parcelRegister("62F0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4662be507f23c65b$export$2e2bcd8739ae039; });
function $4662be507f23c65b$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("iKUML", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $da789246aae62a0c$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $da789246aae62a0c$export$2e2bcd8739ae039; });

var $gl072 = parcelRequire("gl072");

var $b4g7k = parcelRequire("b4g7k");

var $8V3ZT = parcelRequire("8V3ZT");

var $4Um5Q = parcelRequire("4Um5Q");

var $eYiFE = parcelRequire("eYiFE");
function $da789246aae62a0c$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $da789246aae62a0c$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $da789246aae62a0c$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $8V3ZT.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $8V3ZT.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $8V3ZT.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $gl072.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4Um5Q.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $eYiFE.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $4Um5Q.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $da789246aae62a0c$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $b4g7k.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $4Um5Q.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($da789246aae62a0c$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $b4g7k.default)(css, breakpointsValues);
                        }
                    } else css = (0, $b4g7k.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $4Um5Q.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $da789246aae62a0c$var$styleFunctionSx = $da789246aae62a0c$export$7d53d8bf2911e013();
$da789246aae62a0c$var$styleFunctionSx.filterProps = [
    "sx"
];
var $da789246aae62a0c$export$2e2bcd8739ae039 = $da789246aae62a0c$var$styleFunctionSx;

});
parcelRegister("eYiFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae6526ebbb468a3f$export$2e2bcd8739ae039; });

var $bmohe = parcelRequire("bmohe");

var $cAAEV = parcelRequire("cAAEV");

var $2Mrmv = parcelRequire("2Mrmv");

var $7mVcC = parcelRequire("7mVcC");

var $fBTta = parcelRequire("fBTta");
const $ae6526ebbb468a3f$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $cAAEV.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $cAAEV.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $cAAEV.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $cAAEV.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $cAAEV.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $cAAEV.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $cAAEV.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $7mVcC.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $7mVcC.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $7mVcC.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $bmohe.padding)
    },
    pt: {
        style: (0, $bmohe.padding)
    },
    pr: {
        style: (0, $bmohe.padding)
    },
    pb: {
        style: (0, $bmohe.padding)
    },
    pl: {
        style: (0, $bmohe.padding)
    },
    px: {
        style: (0, $bmohe.padding)
    },
    py: {
        style: (0, $bmohe.padding)
    },
    padding: {
        style: (0, $bmohe.padding)
    },
    paddingTop: {
        style: (0, $bmohe.padding)
    },
    paddingRight: {
        style: (0, $bmohe.padding)
    },
    paddingBottom: {
        style: (0, $bmohe.padding)
    },
    paddingLeft: {
        style: (0, $bmohe.padding)
    },
    paddingX: {
        style: (0, $bmohe.padding)
    },
    paddingY: {
        style: (0, $bmohe.padding)
    },
    paddingInline: {
        style: (0, $bmohe.padding)
    },
    paddingInlineStart: {
        style: (0, $bmohe.padding)
    },
    paddingInlineEnd: {
        style: (0, $bmohe.padding)
    },
    paddingBlock: {
        style: (0, $bmohe.padding)
    },
    paddingBlockStart: {
        style: (0, $bmohe.padding)
    },
    paddingBlockEnd: {
        style: (0, $bmohe.padding)
    },
    m: {
        style: (0, $bmohe.margin)
    },
    mt: {
        style: (0, $bmohe.margin)
    },
    mr: {
        style: (0, $bmohe.margin)
    },
    mb: {
        style: (0, $bmohe.margin)
    },
    ml: {
        style: (0, $bmohe.margin)
    },
    mx: {
        style: (0, $bmohe.margin)
    },
    my: {
        style: (0, $bmohe.margin)
    },
    margin: {
        style: (0, $bmohe.margin)
    },
    marginTop: {
        style: (0, $bmohe.margin)
    },
    marginRight: {
        style: (0, $bmohe.margin)
    },
    marginBottom: {
        style: (0, $bmohe.margin)
    },
    marginLeft: {
        style: (0, $bmohe.margin)
    },
    marginX: {
        style: (0, $bmohe.margin)
    },
    marginY: {
        style: (0, $bmohe.margin)
    },
    marginInline: {
        style: (0, $bmohe.margin)
    },
    marginInlineStart: {
        style: (0, $bmohe.margin)
    },
    marginInlineEnd: {
        style: (0, $bmohe.margin)
    },
    marginBlock: {
        style: (0, $bmohe.margin)
    },
    marginBlockStart: {
        style: (0, $bmohe.margin)
    },
    marginBlockEnd: {
        style: (0, $bmohe.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $2Mrmv.gap)
    },
    rowGap: {
        style: (0, $2Mrmv.rowGap)
    },
    columnGap: {
        style: (0, $2Mrmv.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $fBTta.sizingTransform)
    },
    maxWidth: {
        style: (0, $fBTta.maxWidth)
    },
    minWidth: {
        transform: (0, $fBTta.sizingTransform)
    },
    height: {
        transform: (0, $fBTta.sizingTransform)
    },
    maxHeight: {
        transform: (0, $fBTta.sizingTransform)
    },
    minHeight: {
        transform: (0, $fBTta.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $ae6526ebbb468a3f$export$2e2bcd8739ae039 = $ae6526ebbb468a3f$var$defaultSxConfig;

});
parcelRegister("cAAEV", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $92a5488c1c98afde$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $92a5488c1c98afde$export$7a57f79000377ca2; });


var $8V3ZT = parcelRequire("8V3ZT");

var $6QPNn = parcelRequire("6QPNn");

var $bmohe = parcelRequire("bmohe");

var $4Um5Q = parcelRequire("4Um5Q");
function $92a5488c1c98afde$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $92a5488c1c98afde$var$createBorderStyle(prop, transform) {
    return (0, $8V3ZT.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $92a5488c1c98afde$export$1edee58a52776cd9 = $92a5488c1c98afde$var$createBorderStyle("border", $92a5488c1c98afde$export$34e2febe53ae29cc);
const $92a5488c1c98afde$export$f9a7b6bd24892946 = $92a5488c1c98afde$var$createBorderStyle("borderTop", $92a5488c1c98afde$export$34e2febe53ae29cc);
const $92a5488c1c98afde$export$5abca33e6be905d2 = $92a5488c1c98afde$var$createBorderStyle("borderRight", $92a5488c1c98afde$export$34e2febe53ae29cc);
const $92a5488c1c98afde$export$e2ce9f12a980a822 = $92a5488c1c98afde$var$createBorderStyle("borderBottom", $92a5488c1c98afde$export$34e2febe53ae29cc);
const $92a5488c1c98afde$export$47658cca1a909427 = $92a5488c1c98afde$var$createBorderStyle("borderLeft", $92a5488c1c98afde$export$34e2febe53ae29cc);
const $92a5488c1c98afde$export$e7fb0694ba2404fc = $92a5488c1c98afde$var$createBorderStyle("borderColor");
const $92a5488c1c98afde$export$126a92c968acdb85 = $92a5488c1c98afde$var$createBorderStyle("borderTopColor");
const $92a5488c1c98afde$export$85cc51cb8fbb8c0e = $92a5488c1c98afde$var$createBorderStyle("borderRightColor");
const $92a5488c1c98afde$export$340b0327727f6d1a = $92a5488c1c98afde$var$createBorderStyle("borderBottomColor");
const $92a5488c1c98afde$export$60beef91a985b4bf = $92a5488c1c98afde$var$createBorderStyle("borderLeftColor");
const $92a5488c1c98afde$export$f9258c55612cbed7 = $92a5488c1c98afde$var$createBorderStyle("outline", $92a5488c1c98afde$export$34e2febe53ae29cc);
const $92a5488c1c98afde$export$621fe586efeb64b9 = $92a5488c1c98afde$var$createBorderStyle("outlineColor");
const $92a5488c1c98afde$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $bmohe.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $bmohe.getValue)(transformer, propValue)
            });
        return (0, $4Um5Q.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$92a5488c1c98afde$export$7a57f79000377ca2.propTypes = {};
$92a5488c1c98afde$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $92a5488c1c98afde$var$borders = (0, $6QPNn.default)($92a5488c1c98afde$export$1edee58a52776cd9, $92a5488c1c98afde$export$f9a7b6bd24892946, $92a5488c1c98afde$export$5abca33e6be905d2, $92a5488c1c98afde$export$e2ce9f12a980a822, $92a5488c1c98afde$export$47658cca1a909427, $92a5488c1c98afde$export$e7fb0694ba2404fc, $92a5488c1c98afde$export$126a92c968acdb85, $92a5488c1c98afde$export$85cc51cb8fbb8c0e, $92a5488c1c98afde$export$340b0327727f6d1a, $92a5488c1c98afde$export$60beef91a985b4bf, $92a5488c1c98afde$export$7a57f79000377ca2, $92a5488c1c98afde$export$f9258c55612cbed7, $92a5488c1c98afde$export$621fe586efeb64b9);
var $92a5488c1c98afde$export$2e2bcd8739ae039 = $92a5488c1c98afde$var$borders;

});
parcelRegister("6QPNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fcfc6e5d37da8ed$export$2e2bcd8739ae039; });

var $b4g7k = parcelRequire("b4g7k");
function $4fcfc6e5d37da8ed$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $b4g7k.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $4fcfc6e5d37da8ed$export$2e2bcd8739ae039 = $4fcfc6e5d37da8ed$var$compose;

});


parcelRegister("2Mrmv", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $206549fbb5d01e55$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $206549fbb5d01e55$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $206549fbb5d01e55$export$8a833ffa5f5dbeda; });

var $8V3ZT = parcelRequire("8V3ZT");

var $6QPNn = parcelRequire("6QPNn");

var $bmohe = parcelRequire("bmohe");

var $4Um5Q = parcelRequire("4Um5Q");

const $206549fbb5d01e55$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $bmohe.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $bmohe.getValue)(transformer, propValue)
            });
        return (0, $4Um5Q.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$206549fbb5d01e55$export$5df9adcb0db95e1e.propTypes = {};
$206549fbb5d01e55$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $206549fbb5d01e55$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $bmohe.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $bmohe.getValue)(transformer, propValue)
            });
        return (0, $4Um5Q.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$206549fbb5d01e55$export$ec60d70ff941a580.propTypes = {};
$206549fbb5d01e55$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $206549fbb5d01e55$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $bmohe.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $bmohe.getValue)(transformer, propValue)
            });
        return (0, $4Um5Q.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$206549fbb5d01e55$export$8a833ffa5f5dbeda.propTypes = {};
$206549fbb5d01e55$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $206549fbb5d01e55$export$baf44164ca3a34e8 = (0, $8V3ZT.default)({
    prop: "gridColumn"
});
const $206549fbb5d01e55$export$8f7213a1cd01e832 = (0, $8V3ZT.default)({
    prop: "gridRow"
});
const $206549fbb5d01e55$export$b0e0abbc49ba668 = (0, $8V3ZT.default)({
    prop: "gridAutoFlow"
});
const $206549fbb5d01e55$export$bcd8b929d4b4142 = (0, $8V3ZT.default)({
    prop: "gridAutoColumns"
});
const $206549fbb5d01e55$export$e5039a674e14c828 = (0, $8V3ZT.default)({
    prop: "gridAutoRows"
});
const $206549fbb5d01e55$export$42bd9088661ffb03 = (0, $8V3ZT.default)({
    prop: "gridTemplateColumns"
});
const $206549fbb5d01e55$export$920682ae05b999bc = (0, $8V3ZT.default)({
    prop: "gridTemplateRows"
});
const $206549fbb5d01e55$export$1b88fbdd482fd33a = (0, $8V3ZT.default)({
    prop: "gridTemplateAreas"
});
const $206549fbb5d01e55$export$bdb486e40d52d26f = (0, $8V3ZT.default)({
    prop: "gridArea"
});
const $206549fbb5d01e55$var$grid = (0, $6QPNn.default)($206549fbb5d01e55$export$5df9adcb0db95e1e, $206549fbb5d01e55$export$ec60d70ff941a580, $206549fbb5d01e55$export$8a833ffa5f5dbeda, $206549fbb5d01e55$export$baf44164ca3a34e8, $206549fbb5d01e55$export$8f7213a1cd01e832, $206549fbb5d01e55$export$b0e0abbc49ba668, $206549fbb5d01e55$export$bcd8b929d4b4142, $206549fbb5d01e55$export$e5039a674e14c828, $206549fbb5d01e55$export$42bd9088661ffb03, $206549fbb5d01e55$export$920682ae05b999bc, $206549fbb5d01e55$export$1b88fbdd482fd33a, $206549fbb5d01e55$export$bdb486e40d52d26f);
var $206549fbb5d01e55$export$2e2bcd8739ae039 = $206549fbb5d01e55$var$grid;

});

parcelRegister("7mVcC", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $55d6f5b0bb6c5862$export$dbaffd4420ea0ac6; });

var $8V3ZT = parcelRequire("8V3ZT");

var $6QPNn = parcelRequire("6QPNn");
function $55d6f5b0bb6c5862$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $55d6f5b0bb6c5862$export$35e9368ef982300f = (0, $8V3ZT.default)({
    prop: "color",
    themeKey: "palette",
    transform: $55d6f5b0bb6c5862$export$dbaffd4420ea0ac6
});
const $55d6f5b0bb6c5862$export$2506f56c10355b33 = (0, $8V3ZT.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $55d6f5b0bb6c5862$export$dbaffd4420ea0ac6
});
const $55d6f5b0bb6c5862$export$8c5a050822fd698c = (0, $8V3ZT.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $55d6f5b0bb6c5862$export$dbaffd4420ea0ac6
});
const $55d6f5b0bb6c5862$var$palette = (0, $6QPNn.default)($55d6f5b0bb6c5862$export$35e9368ef982300f, $55d6f5b0bb6c5862$export$2506f56c10355b33, $55d6f5b0bb6c5862$export$8c5a050822fd698c);
var $55d6f5b0bb6c5862$export$2e2bcd8739ae039 = $55d6f5b0bb6c5862$var$palette;

});

parcelRegister("fBTta", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $b5d556cf1f8151d0$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $b5d556cf1f8151d0$export$488fda99655ff65a; });

var $8V3ZT = parcelRequire("8V3ZT");

var $6QPNn = parcelRequire("6QPNn");

var $4Um5Q = parcelRequire("4Um5Q");
function $b5d556cf1f8151d0$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $b5d556cf1f8151d0$export$7e3df82ee760448c = (0, $8V3ZT.default)({
    prop: "width",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $4Um5Q.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $b5d556cf1f8151d0$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $4Um5Q.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$b5d556cf1f8151d0$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $b5d556cf1f8151d0$export$ee148fbbe8357dd2 = (0, $8V3ZT.default)({
    prop: "minWidth",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$ac607276a8fe9f0a = (0, $8V3ZT.default)({
    prop: "height",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$dc0d8bd0b94f8570 = (0, $8V3ZT.default)({
    prop: "maxHeight",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$a43cf604e12f3b17 = (0, $8V3ZT.default)({
    prop: "minHeight",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$ffed9f14fb65e276 = (0, $8V3ZT.default)({
    prop: "size",
    cssProperty: "width",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$905076ed6620e671 = (0, $8V3ZT.default)({
    prop: "size",
    cssProperty: "height",
    transform: $b5d556cf1f8151d0$export$8afece71750ec241
});
const $b5d556cf1f8151d0$export$6ccc93f785106a58 = (0, $8V3ZT.default)({
    prop: "boxSizing"
});
const $b5d556cf1f8151d0$var$sizing = (0, $6QPNn.default)($b5d556cf1f8151d0$export$7e3df82ee760448c, $b5d556cf1f8151d0$export$488fda99655ff65a, $b5d556cf1f8151d0$export$ee148fbbe8357dd2, $b5d556cf1f8151d0$export$ac607276a8fe9f0a, $b5d556cf1f8151d0$export$dc0d8bd0b94f8570, $b5d556cf1f8151d0$export$a43cf604e12f3b17, $b5d556cf1f8151d0$export$6ccc93f785106a58);
var $b5d556cf1f8151d0$export$2e2bcd8739ae039 = $b5d556cf1f8151d0$var$sizing;

});



parcelRegister("7ZFy0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d1e755a633b3a97$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $5d1e755a633b3a97$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("8wVSe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iKUML")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("iKUML")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("4k52v")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("eYiFE")).default; });

var $iKUML = parcelRequire("iKUML");

var $4k52v = parcelRequire("4k52v");

var $eYiFE = parcelRequire("eYiFE");

});
parcelRegister("4k52v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $325cf06457b33874$export$2e2bcd8739ae039; });

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $cAicU = parcelRequire("cAicU");

var $eYiFE = parcelRequire("eYiFE");
const $325cf06457b33874$var$_excluded = [
    "sx"
];
const $325cf06457b33874$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $eYiFE.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $325cf06457b33874$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $bKcdJ.default)(props, $325cf06457b33874$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $325cf06457b33874$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cAicU.isPlainObject)(result)) return systemProps;
        return (0, $asN9r.default)({}, systemProps, result);
    };
    else finalSx = (0, $asN9r.default)({}, systemProps, inSx);
    return (0, $asN9r.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("cQ5f5", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $958e686558c2ea73$export$a7c73072b1a182ae; }, function (v) { return $958e686558c2ea73$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $958e686558c2ea73$export$9f27bc3417b4524d; }, function (v) { return $958e686558c2ea73$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $958e686558c2ea73$export$db77ccec0bb4ccac; }, function (v) { return $958e686558c2ea73$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $958e686558c2ea73$export$8392c0c9d3dcbd35; }, function (v) { return $958e686558c2ea73$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $958e686558c2ea73$export$ffb0004e005737fa; }, function (v) { return $958e686558c2ea73$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $958e686558c2ea73$export$b624eff549462981; }, function (v) { return $958e686558c2ea73$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $958e686558c2ea73$export$7897aa7841a5380c; }, function (v) { return $958e686558c2ea73$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $958e686558c2ea73$export$602eac185826482c; }, function (v) { return $958e686558c2ea73$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $958e686558c2ea73$export$e2c29f18771995cb; }, function (v) { return $958e686558c2ea73$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $958e686558c2ea73$export$5f8d39834fd61797; }, function (v) { return $958e686558c2ea73$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $958e686558c2ea73$export$74bf444e3cd11ea5; }, function (v) { return $958e686558c2ea73$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $958e686558c2ea73$export$998bcd577473dd93; }, function (v) { return $958e686558c2ea73$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $958e686558c2ea73$export$92387174baf9b227; }, function (v) { return $958e686558c2ea73$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $958e686558c2ea73$export$ec112efeb987d9c6; }, function (v) { return $958e686558c2ea73$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $958e686558c2ea73$export$b706b080d889d2c9; }, function (v) { return $958e686558c2ea73$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $958e686558c2ea73$export$5be5a87408f70ddc; }, function (v) { return $958e686558c2ea73$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $958e686558c2ea73$export$45a5e7f76e0caa8d; }, function (v) { return $958e686558c2ea73$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $958e686558c2ea73$export$455c2e768291efa6; }, function (v) { return $958e686558c2ea73$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $958e686558c2ea73$export$9522e17588c12572; }, function (v) { return $958e686558c2ea73$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $958e686558c2ea73$export$2110ac352bb060b9; }, function (v) { return $958e686558c2ea73$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $958e686558c2ea73$export$56885ab8b9c456ab; }, function (v) { return $958e686558c2ea73$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $958e686558c2ea73$export$d927fcb6adf8f9de; }, function (v) { return $958e686558c2ea73$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $958e686558c2ea73$export$b82d16f27459e05a; }, function (v) { return $958e686558c2ea73$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $958e686558c2ea73$export$522c17b4f5e123e8; }, function (v) { return $958e686558c2ea73$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $958e686558c2ea73$export$1aabd8a0274ecfd6; }, function (v) { return $958e686558c2ea73$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $958e686558c2ea73$export$3d6c20d97e46b957; }, function (v) { return $958e686558c2ea73$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $958e686558c2ea73$export$9b621391a187a31a; }, function (v) { return $958e686558c2ea73$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $958e686558c2ea73$export$f5bbd400c2f4426f; }, function (v) { return $958e686558c2ea73$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $958e686558c2ea73$export$a7c73072b1a182ae;
var $958e686558c2ea73$export$9f27bc3417b4524d;
var $958e686558c2ea73$export$db77ccec0bb4ccac;
var $958e686558c2ea73$export$8392c0c9d3dcbd35;
var $958e686558c2ea73$export$ffb0004e005737fa;
var $958e686558c2ea73$export$b624eff549462981;
var $958e686558c2ea73$export$7897aa7841a5380c;
var $958e686558c2ea73$export$602eac185826482c;
var $958e686558c2ea73$export$e2c29f18771995cb;
var $958e686558c2ea73$export$5f8d39834fd61797;
var $958e686558c2ea73$export$74bf444e3cd11ea5;
var $958e686558c2ea73$export$998bcd577473dd93;
var $958e686558c2ea73$export$92387174baf9b227;
var $958e686558c2ea73$export$ec112efeb987d9c6;
var $958e686558c2ea73$export$b706b080d889d2c9;
var $958e686558c2ea73$export$5be5a87408f70ddc;
var $958e686558c2ea73$export$45a5e7f76e0caa8d;
var $958e686558c2ea73$export$455c2e768291efa6;
var $958e686558c2ea73$export$9522e17588c12572;
var $958e686558c2ea73$export$2110ac352bb060b9;
var $958e686558c2ea73$export$56885ab8b9c456ab;
var $958e686558c2ea73$export$d927fcb6adf8f9de;
var $958e686558c2ea73$export$b82d16f27459e05a;
var $958e686558c2ea73$export$522c17b4f5e123e8;
var $958e686558c2ea73$export$1aabd8a0274ecfd6;
var $958e686558c2ea73$export$3d6c20d97e46b957;
var $958e686558c2ea73$export$9b621391a187a31a;
var $958e686558c2ea73$export$f5bbd400c2f4426f;
"use strict";
var $958e686558c2ea73$var$b = Symbol.for("react.element"), $958e686558c2ea73$var$c = Symbol.for("react.portal"), $958e686558c2ea73$var$d = Symbol.for("react.fragment"), $958e686558c2ea73$var$e = Symbol.for("react.strict_mode"), $958e686558c2ea73$var$f = Symbol.for("react.profiler"), $958e686558c2ea73$var$g = Symbol.for("react.provider"), $958e686558c2ea73$var$h = Symbol.for("react.context"), $958e686558c2ea73$var$k = Symbol.for("react.server_context"), $958e686558c2ea73$var$l = Symbol.for("react.forward_ref"), $958e686558c2ea73$var$m = Symbol.for("react.suspense"), $958e686558c2ea73$var$n = Symbol.for("react.suspense_list"), $958e686558c2ea73$var$p = Symbol.for("react.memo"), $958e686558c2ea73$var$q = Symbol.for("react.lazy"), $958e686558c2ea73$var$t = Symbol.for("react.offscreen"), $958e686558c2ea73$var$u;
$958e686558c2ea73$var$u = Symbol.for("react.module.reference");
function $958e686558c2ea73$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $958e686558c2ea73$var$b:
                switch(a = a.type, a){
                    case $958e686558c2ea73$var$d:
                    case $958e686558c2ea73$var$f:
                    case $958e686558c2ea73$var$e:
                    case $958e686558c2ea73$var$m:
                    case $958e686558c2ea73$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $958e686558c2ea73$var$k:
                            case $958e686558c2ea73$var$h:
                            case $958e686558c2ea73$var$l:
                            case $958e686558c2ea73$var$q:
                            case $958e686558c2ea73$var$p:
                            case $958e686558c2ea73$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $958e686558c2ea73$var$c:
                return r;
        }
    }
}
$958e686558c2ea73$export$a7c73072b1a182ae = $958e686558c2ea73$var$h;
$958e686558c2ea73$export$9f27bc3417b4524d = $958e686558c2ea73$var$g;
$958e686558c2ea73$export$db77ccec0bb4ccac = $958e686558c2ea73$var$b;
$958e686558c2ea73$export$8392c0c9d3dcbd35 = $958e686558c2ea73$var$l;
$958e686558c2ea73$export$ffb0004e005737fa = $958e686558c2ea73$var$d;
$958e686558c2ea73$export$b624eff549462981 = $958e686558c2ea73$var$q;
$958e686558c2ea73$export$7897aa7841a5380c = $958e686558c2ea73$var$p;
$958e686558c2ea73$export$602eac185826482c = $958e686558c2ea73$var$c;
$958e686558c2ea73$export$e2c29f18771995cb = $958e686558c2ea73$var$f;
$958e686558c2ea73$export$5f8d39834fd61797 = $958e686558c2ea73$var$e;
$958e686558c2ea73$export$74bf444e3cd11ea5 = $958e686558c2ea73$var$m;
$958e686558c2ea73$export$998bcd577473dd93 = $958e686558c2ea73$var$n;
$958e686558c2ea73$export$92387174baf9b227 = function() {
    return !1;
};
$958e686558c2ea73$export$ec112efeb987d9c6 = function() {
    return !1;
};
$958e686558c2ea73$export$b706b080d889d2c9 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$h;
};
$958e686558c2ea73$export$5be5a87408f70ddc = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$g;
};
$958e686558c2ea73$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $958e686558c2ea73$var$b;
};
$958e686558c2ea73$export$455c2e768291efa6 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$l;
};
$958e686558c2ea73$export$9522e17588c12572 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$d;
};
$958e686558c2ea73$export$2110ac352bb060b9 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$q;
};
$958e686558c2ea73$export$56885ab8b9c456ab = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$p;
};
$958e686558c2ea73$export$d927fcb6adf8f9de = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$c;
};
$958e686558c2ea73$export$b82d16f27459e05a = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$f;
};
$958e686558c2ea73$export$522c17b4f5e123e8 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$e;
};
$958e686558c2ea73$export$1aabd8a0274ecfd6 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$m;
};
$958e686558c2ea73$export$3d6c20d97e46b957 = function(a) {
    return $958e686558c2ea73$var$v(a) === $958e686558c2ea73$var$n;
};
$958e686558c2ea73$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $958e686558c2ea73$var$d || a === $958e686558c2ea73$var$f || a === $958e686558c2ea73$var$e || a === $958e686558c2ea73$var$m || a === $958e686558c2ea73$var$n || a === $958e686558c2ea73$var$t || "object" === typeof a && null !== a && (a.$$typeof === $958e686558c2ea73$var$q || a.$$typeof === $958e686558c2ea73$var$p || a.$$typeof === $958e686558c2ea73$var$g || a.$$typeof === $958e686558c2ea73$var$h || a.$$typeof === $958e686558c2ea73$var$l || a.$$typeof === $958e686558c2ea73$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$958e686558c2ea73$export$f5bbd400c2f4426f = $958e686558c2ea73$var$v;

});

parcelRegister("2bsw6", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $1972baaeb06943ed$export$306c0aa65ff9ec16; }, function (v) { return $1972baaeb06943ed$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1972baaeb06943ed$export$306c0aa65ff9ec16;
"use strict";

var $f2Y41 = parcelRequire("f2Y41");
function $1972baaeb06943ed$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1972baaeb06943ed$var$k = "function" === typeof Object.is ? Object.is : $1972baaeb06943ed$var$h, $1972baaeb06943ed$var$l = $f2Y41.useState, $1972baaeb06943ed$var$m = $f2Y41.useEffect, $1972baaeb06943ed$var$n = $f2Y41.useLayoutEffect, $1972baaeb06943ed$var$p = $f2Y41.useDebugValue;
function $1972baaeb06943ed$var$q(a, b) {
    var d = b(), f = $1972baaeb06943ed$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $1972baaeb06943ed$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $1972baaeb06943ed$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $1972baaeb06943ed$var$m(function() {
        $1972baaeb06943ed$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $1972baaeb06943ed$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $1972baaeb06943ed$var$p(d);
    return d;
}
function $1972baaeb06943ed$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$1972baaeb06943ed$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $1972baaeb06943ed$var$t(a, b) {
    return b();
}
var $1972baaeb06943ed$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $1972baaeb06943ed$var$t : $1972baaeb06943ed$var$q;
$1972baaeb06943ed$export$306c0aa65ff9ec16 = void 0 !== $f2Y41.useSyncExternalStore ? $f2Y41.useSyncExternalStore : $1972baaeb06943ed$var$u;

});

parcelRegister("h9TKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7de86b5b0d5428e$export$2e2bcd8739ae039; });

var $g22wg = parcelRequire("g22wg");
var $c7de86b5b0d5428e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c7de86b5b0d5428e$var$index = (0, $g22wg.default)(function(prop) {
    return $c7de86b5b0d5428e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $c7de86b5b0d5428e$export$2e2bcd8739ae039 = $c7de86b5b0d5428e$var$index;

});
parcelRegister("g22wg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $babec98b58433bc9$export$2e2bcd8739ae039; });
function $babec98b58433bc9$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $babec98b58433bc9$export$2e2bcd8739ae039 = $babec98b58433bc9$var$memoize;

});


parcelRegister("8XAxF", function(module, exports) {

$parcel$export(module.exports, "removeElement", function () { return removeElement; });
$parcel$export(module.exports, "elementClosest", function () { return elementClosest; });
$parcel$export(module.exports, "elementMatches", function () { return elementMatches; });
$parcel$export(module.exports, "applyStyle", function () { return applyStyle; });
$parcel$export(module.exports, "getEventTargetViaRoot", function () { return getEventTargetViaRoot; });
$parcel$export(module.exports, "getElRoot", function () { return getElRoot; });
$parcel$export(module.exports, "getUniqueDomId", function () { return getUniqueDomId; });
$parcel$export(module.exports, "whenTransitionDone", function () { return whenTransitionDone; });
$parcel$export(module.exports, "createAriaClickAttrs", function () { return createAriaClickAttrs; });
$parcel$export(module.exports, "disableCursor", function () { return disableCursor; });
$parcel$export(module.exports, "enableCursor", function () { return enableCursor; });
$parcel$export(module.exports, "preventSelection", function () { return preventSelection; });
$parcel$export(module.exports, "allowSelection", function () { return allowSelection; });
$parcel$export(module.exports, "preventContextMenu", function () { return preventContextMenu; });
$parcel$export(module.exports, "allowContextMenu", function () { return allowContextMenu; });
$parcel$export(module.exports, "compareNumbers", function () { return compareNumbers; });
$parcel$export(module.exports, "addWeeks", function () { return addWeeks; });
$parcel$export(module.exports, "addDays", function () { return addDays; });
$parcel$export(module.exports, "diffWeeks", function () { return diffWeeks; });
$parcel$export(module.exports, "diffDays", function () { return diffDays; });
$parcel$export(module.exports, "startOfDay", function () { return startOfDay; });
$parcel$export(module.exports, "createEventInstance", function () { return createEventInstance; });
$parcel$export(module.exports, "mapHash", function () { return mapHash; });
$parcel$export(module.exports, "isPropsEqual", function () { return isPropsEqual; });
$parcel$export(module.exports, "createDuration", function () { return createDuration; });
$parcel$export(module.exports, "addDurations", function () { return addDurations; });
$parcel$export(module.exports, "multiplyDuration", function () { return multiplyDuration; });
$parcel$export(module.exports, "asRoughMs", function () { return asRoughMs; });
$parcel$export(module.exports, "wholeDivideDurations", function () { return wholeDivideDurations; });
$parcel$export(module.exports, "buildIsoString", function () { return buildIsoString; });
$parcel$export(module.exports, "formatIsoTimeString", function () { return formatIsoTimeString; });
$parcel$export(module.exports, "memoize", function () { return memoize; });
$parcel$export(module.exports, "createFormatter", function () { return createFormatter; });
$parcel$export(module.exports, "identity", function () { return identity; });
$parcel$export(module.exports, "BASE_OPTION_DEFAULTS", function () { return BASE_OPTION_DEFAULTS; });
$parcel$export(module.exports, "createEmptyEventStore", function () { return createEmptyEventStore; });
$parcel$export(module.exports, "eventTupleToStore", function () { return eventTupleToStore; });
$parcel$export(module.exports, "getRelevantEvents", function () { return getRelevantEvents; });
$parcel$export(module.exports, "refineEventDef", function () { return refineEventDef; });
$parcel$export(module.exports, "parseEventDef", function () { return parseEventDef; });
$parcel$export(module.exports, "diffDates", function () { return diffDates; });
$parcel$export(module.exports, "intersectRanges", function () { return intersectRanges; });
$parcel$export(module.exports, "rangeContainsRange", function () { return rangeContainsRange; });
$parcel$export(module.exports, "rangeContainsMarker", function () { return rangeContainsMarker; });
$parcel$export(module.exports, "hasBgRendering", function () { return hasBgRendering; });
$parcel$export(module.exports, "getElSeg", function () { return getElSeg; });
$parcel$export(module.exports, "sortEventSegs", function () { return sortEventSegs; });
$parcel$export(module.exports, "buildSegTimeText", function () { return buildSegTimeText; });
$parcel$export(module.exports, "getSegMeta", function () { return getSegMeta; });
$parcel$export(module.exports, "buildEventRangeKey", function () { return buildEventRangeKey; });
$parcel$export(module.exports, "getSegAnchorAttrs", function () { return getSegAnchorAttrs; });
$parcel$export(module.exports, "EventApi", function () { return EventApi; });
$parcel$export(module.exports, "isDateSpansEqual", function () { return isDateSpansEqual; });
$parcel$export(module.exports, "triggerDateSelect", function () { return triggerDateSelect; });
$parcel$export(module.exports, "getDefaultEventEnd", function () { return getDefaultEventEnd; });
$parcel$export(module.exports, "applyMutationToEventStore", function () { return applyMutationToEventStore; });
$parcel$export(module.exports, "CalendarApi", function () { return CalendarApi; });
$parcel$export(module.exports, "buildEventApis", function () { return buildEventApis; });
$parcel$export(module.exports, "pointInsideRect", function () { return pointInsideRect; });
$parcel$export(module.exports, "intersectRects", function () { return intersectRects; });
$parcel$export(module.exports, "constrainPoint", function () { return constrainPoint; });
$parcel$export(module.exports, "getRectCenter", function () { return getRectCenter; });
$parcel$export(module.exports, "diffPoints", function () { return diffPoints; });
$parcel$export(module.exports, "Splitter", function () { return Splitter; });
$parcel$export(module.exports, "buildNavLinkAttrs", function () { return buildNavLinkAttrs; });
$parcel$export(module.exports, "computeInnerRect", function () { return computeInnerRect; });
$parcel$export(module.exports, "computeRect", function () { return computeRect; });
$parcel$export(module.exports, "getClippingParents", function () { return getClippingParents; });
$parcel$export(module.exports, "Emitter", function () { return Emitter; });
$parcel$export(module.exports, "PositionCache", function () { return PositionCache; });
$parcel$export(module.exports, "ScrollController", function () { return ScrollController; });
$parcel$export(module.exports, "ElementScrollController", function () { return ElementScrollController; });
$parcel$export(module.exports, "WindowScrollController", function () { return WindowScrollController; });
$parcel$export(module.exports, "ViewContextType", function () { return ViewContextType; });
$parcel$export(module.exports, "BaseComponent", function () { return BaseComponent; });
$parcel$export(module.exports, "setRef", function () { return setRef; });
$parcel$export(module.exports, "DateComponent", function () { return DateComponent; });
$parcel$export(module.exports, "createPlugin", function () { return createPlugin; });
$parcel$export(module.exports, "RenderHook", function () { return RenderHook; });
$parcel$export(module.exports, "ViewRoot", function () { return ViewRoot; });
$parcel$export(module.exports, "DateProfileGenerator", function () { return DateProfileGenerator; });
$parcel$export(module.exports, "CalendarDataProvider", function () { return CalendarDataProvider; });
$parcel$export(module.exports, "SegHierarchy", function () { return SegHierarchy; });
$parcel$export(module.exports, "intersectSpans", function () { return intersectSpans; });
$parcel$export(module.exports, "buildEntryKey", function () { return buildEntryKey; });
$parcel$export(module.exports, "binarySearch", function () { return binarySearch; });
$parcel$export(module.exports, "getEntrySpanEnd", function () { return getEntrySpanEnd; });
$parcel$export(module.exports, "groupIntersectingEntries", function () { return groupIntersectingEntries; });
$parcel$export(module.exports, "Interaction", function () { return Interaction; });
$parcel$export(module.exports, "interactionSettingsToStore", function () { return interactionSettingsToStore; });
$parcel$export(module.exports, "interactionSettingsStore", function () { return interactionSettingsStore; });
$parcel$export(module.exports, "ElementDragging", function () { return ElementDragging; });
$parcel$export(module.exports, "config", function () { return config; });
$parcel$export(module.exports, "parseDragMeta", function () { return parseDragMeta; });
$parcel$export(module.exports, "CalendarContent", function () { return CalendarContent; });
$parcel$export(module.exports, "CalendarRoot", function () { return CalendarRoot; });
$parcel$export(module.exports, "NowTimer", function () { return NowTimer; });
$parcel$export(module.exports, "DayHeader", function () { return DayHeader; });
$parcel$export(module.exports, "DaySeriesModel", function () { return DaySeriesModel; });
$parcel$export(module.exports, "DayTableModel", function () { return DayTableModel; });
$parcel$export(module.exports, "Slicer", function () { return Slicer; });
$parcel$export(module.exports, "isInteractionValid", function () { return isInteractionValid; });
$parcel$export(module.exports, "isDateSelectionValid", function () { return isDateSelectionValid; });
$parcel$export(module.exports, "RefMap", function () { return RefMap; });
$parcel$export(module.exports, "renderScrollShim", function () { return renderScrollShim; });
$parcel$export(module.exports, "getStickyHeaderDates", function () { return getStickyHeaderDates; });
$parcel$export(module.exports, "getStickyFooterScrollbar", function () { return getStickyFooterScrollbar; });
$parcel$export(module.exports, "SimpleScrollGrid", function () { return SimpleScrollGrid; });
$parcel$export(module.exports, "EventRoot", function () { return EventRoot; });
$parcel$export(module.exports, "StandardEvent", function () { return StandardEvent; });
$parcel$export(module.exports, "NowIndicatorRoot", function () { return NowIndicatorRoot; });
$parcel$export(module.exports, "DayCellContent", function () { return DayCellContent; });
$parcel$export(module.exports, "DayCellRoot", function () { return DayCellRoot; });
$parcel$export(module.exports, "renderFill", function () { return renderFill; });
$parcel$export(module.exports, "BgEvent", function () { return BgEvent; });
$parcel$export(module.exports, "WeekNumberRoot", function () { return WeekNumberRoot; });
$parcel$export(module.exports, "MoreLinkRoot", function () { return MoreLinkRoot; });
$parcel$export(module.exports, "computeEarliestSegStart", function () { return computeEarliestSegStart; });
/*!
FullCalendar v5.11.5
Docs & License: https://fullcalendar.io/
(c) 2022 Adam Shaw
*/ 

var $4nqhV = parcelRequire("4nqhV");

var $3jFHS = parcelRequire("3jFHS");
// no public types yet. when there are, export from:
// import {} from './api-type-deps'
var EventSourceApi = /** @class */ function() {
    function EventSourceApi(context, internalEventSource) {
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    EventSourceApi.prototype.remove = function() {
        this.context.dispatch({
            type: "REMOVE_EVENT_SOURCE",
            sourceId: this.internalEventSource.sourceId
        });
    };
    EventSourceApi.prototype.refetch = function() {
        this.context.dispatch({
            type: "FETCH_EVENT_SOURCES",
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    };
    Object.defineProperty(EventSourceApi.prototype, "id", {
        get: function() {
            return this.internalEventSource.publicId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSourceApi.prototype, "url", {
        get: function() {
            return this.internalEventSource.meta.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSourceApi.prototype, "format", {
        get: function() {
            return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
        },
        enumerable: false,
        configurable: true
    });
    return EventSourceApi;
}();
function removeElement(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function elementClosest(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if (elementMatches(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function elementMatches(el, selector) {
    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function findElements(container, selector) {
    var containers = container instanceof HTMLElement ? [
        container
    ] : container;
    var allMatches = [];
    for(var i = 0; i < containers.length; i += 1){
        var matches = containers[i].querySelectorAll(selector);
        for(var j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function findDirectChildren(parent, selector) {
    var parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    var allMatches = [];
    for(var i = 0; i < parents.length; i += 1){
        var childNodes = parents[i].children; // only ever elements
        for(var j = 0; j < childNodes.length; j += 1){
            var childNode = childNodes[j];
            if (!selector || elementMatches(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
var PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function applyStyle(el, props) {
    for(var propName in props)applyStyleProp(el, propName, props[propName]);
}
function applyStyleProp(el, name, val) {
    if (val == null) el.style[name] = "";
    else if (typeof val === "number" && PIXEL_PROP_RE.test(name)) el.style[name] = val + "px";
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function getEventTargetViaRoot(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Shadow DOM consuderations
// ----------------------------------------------------------------------------------------------------------------
function getElRoot(el) {
    return el.getRootNode ? el.getRootNode() : document;
}
// Unique ID for DOM attribute
var guid$1 = 0;
function getUniqueDomId() {
    guid$1 += 1;
    return "fc-dom-" + guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function buildDelegationHandler(selector, handler) {
    return function(ev) {
        var matchedChild = elementClosest(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function listenBySelector(container, eventType, selector, handler) {
    var attachedHandler = buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return function() {
        container.removeEventListener(eventType, attachedHandler);
    };
}
function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return listenBySelector(container, "mouseover", selector, function(mouseOverEv, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            var realOnMouseLeave_1 = function(mouseLeaveEv) {
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener("mouseleave", realOnMouseLeave_1);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener("mouseleave", realOnMouseLeave_1);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
var transitionEventNames = [
    "webkitTransitionEnd",
    "otransitionend",
    "oTransitionEnd",
    "msTransitionEnd",
    "transitionend"
];
// triggered only when the next single subsequent transition finishes
function whenTransitionDone(el, callback) {
    var realCallback = function(ev) {
        callback(ev);
        transitionEventNames.forEach(function(eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    transitionEventNames.forEach(function(eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function createAriaClickAttrs(handler) {
    return (0, $4nqhV.__assign)({
        onClick: handler
    }, createAriaKeyboardAttrs(handler));
}
function createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown: function(ev) {
            if (ev.key === "Enter" || ev.key === " ") {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
var guidNumber = 0;
function guid() {
    guidNumber += 1;
    return String(guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    document.body.classList.add("fc-not-allowed");
}
// Returns the mouse cursor to its original look
function enableCursor() {
    document.body.classList.remove("fc-not-allowed");
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function preventSelection(el) {
    el.classList.add("fc-unselectable");
    el.addEventListener("selectstart", preventDefault);
}
function allowSelection(el) {
    el.classList.remove("fc-unselectable");
    el.removeEventListener("selectstart", preventDefault);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function preventContextMenu(el) {
    el.addEventListener("contextmenu", preventDefault);
}
function allowContextMenu(el) {
    el.removeEventListener("contextmenu", preventDefault);
}
function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === "string") tokens = input.split(/\s*,\s*/);
    else if (typeof input === "function") tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === "string") specs.push(token.charAt(0) === "-" ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === "function") specs.push({
            func: token
        });
    }
    return specs;
}
function compareByFieldSpecs(obj0, obj1, fieldSpecs) {
    var i;
    var cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return flexibleCompare(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function flexibleCompare(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === "string" || typeof b === "string") return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function padStart(val, len) {
    var s = String(val);
    return "000".substr(0, len - s.length) + s;
}
function formatWithOrdinals(formatter, args, fallbackText) {
    if (typeof formatter === "function") return formatter.apply(void 0, args);
    if (typeof formatter === "string") return args.reduce(function(str, arg, index) {
        return str.replace("$" + index, arg || "");
    }, formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function compareNumbers(a, b) {
    return a - b;
}
function isInt(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function computeSmallestCellWidth(cellEl) {
    var allWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-frame");
    var contentWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-cushion");
    if (!allWidthEl) throw new Error("needs fc-scrollgrid-shrink-frame className"); // TODO: use const
    if (!contentWidthEl) throw new Error("needs fc-scrollgrid-shrink-cushion className");
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
var DAY_IDS = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
// Adding
function addWeeks(m, n) {
    var a = dateToUtcArray(m);
    a[2] += n * 7;
    return arrayToUtcDate(a);
}
function addDays(m, n) {
    var a = dateToUtcArray(m);
    a[2] += n;
    return arrayToUtcDate(a);
}
function addMs(m, n) {
    var a = dateToUtcArray(m);
    a[6] += n;
    return arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function diffWeeks(m0, m1) {
    return diffDays(m0, m1) / 7;
}
function diffDays(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function diffDayAndTime(m0, m1) {
    var m0day = startOfDay(m0);
    var m1day = startOfDay(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round(diffDays(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function diffWholeWeeks(m0, m1) {
    var d = diffWholeDays(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function diffWholeDays(m0, m1) {
    if (timeAsMs(m0) === timeAsMs(m1)) return Math.round(diffDays(m0, m1));
    return null;
}
// Start-Of
function startOfDay(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function startOfHour(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function startOfMinute(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function startOfSecond(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function weekOfYear(marker, dow, doy) {
    var y = marker.getUTCFullYear();
    var w = weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return weekOfGivenYear(marker, y - 1, dow, doy);
    var nextW = weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function weekOfGivenYear(marker, year, dow, doy) {
    var firstWeekStart = arrayToUtcDate([
        year,
        0,
        1 + firstWeekOffset(year, dow, doy)
    ]);
    var dayStart = startOfDay(marker);
    var days = Math.round(diffDays(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC.apply(Date, a));
}
// Other Utils
function isValidDate(m) {
    return !isNaN(m.valueOf());
}
function timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
function createEventInstance(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: guid(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexPropsMap) {
    var dest = {};
    if (complexPropsMap) for(var name_1 in complexPropsMap){
        var complexObjs = [];
        // collect the trailing object values, stopping when a non-object is discovered
        for(var i = propObjs.length - 1; i >= 0; i -= 1){
            var val = propObjs[i][name_1];
            if (typeof val === "object" && val) complexObjs.unshift(val);
            else if (val !== undefined) {
                dest[name_1] = val; // if there were no objects, this value will be used
                break;
            }
        }
        // if the trailing values were objects, use the merged value
        if (complexObjs.length) dest[name_1] = mergeProps(complexObjs);
    }
    // copy values into the destination, going from last to first
    for(var i = propObjs.length - 1; i >= 0; i -= 1){
        var props = propObjs[i];
        for(var name_2 in props)if (!(name_2 in dest)) dest[name_2] = props[name_2];
    }
    return dest;
}
function filterHash(hash, func) {
    var filtered = {};
    for(var key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function mapHash(hash, func) {
    var newHash = {};
    for(var key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function arrayToHash(a) {
    var hash = {};
    for(var _i = 0, a_1 = a; _i < a_1.length; _i++){
        var item = a_1[_i];
        hash[item] = true;
    }
    return hash;
}
function buildHashFromArray(a, func) {
    var hash = {};
    for(var i = 0; i < a.length; i += 1){
        var tuple = func(a[i], i);
        hash[tuple[0]] = tuple[1];
    }
    return hash;
}
function hashValuesToArray(obj) {
    var a = [];
    for(var key in obj)a.push(obj[key]);
    return a;
}
function isPropsEqual(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(var key in obj0)if (hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(var key in obj1)if (hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
function getUnequalProps(obj0, obj1) {
    var keys = [];
    for(var key in obj0){
        if (hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(var key in obj1){
        if (hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function compareObjs(oldProps, newProps, equalityFuncs) {
    if (equalityFuncs === void 0) equalityFuncs = {};
    if (oldProps === newProps) return true;
    for(var key in newProps){
        if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(var key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function collectFromHash(hash, startIndex, endIndex, step) {
    if (startIndex === void 0) startIndex = 0;
    if (step === void 0) step = 1;
    var res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(var i = startIndex; i < endIndex; i += step){
        var val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
function parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(var i = 0; i < recurringTypes.length; i += 1){
        var parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            var allDay = refined.allDay;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function expandRecurring(eventStore, framingRange, context) {
    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
    var defs = eventStore.defs, instances = eventStore.instances;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = filterHash(instances, function(instance) {
        return !defs[instance.defId].recurringDef;
    });
    for(var defId in defs){
        var def = defs[defId];
        if (def.recurringDef) {
            var duration = def.recurringDef.duration;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            var starts = expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for(var _i = 0, starts_1 = starts; _i < starts_1.length; _i++){
                var start = starts_1[_i];
                var instance = createEventInstance(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map(startOfDay);
    return markers;
}
var INTERNAL_UNITS = [
    "years",
    "months",
    "days",
    "milliseconds"
];
var PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function createDuration(input, unit) {
    var _a;
    if (typeof input === "string") return parseString(input);
    if (typeof input === "object" && input) return parseObject(input);
    if (typeof input === "number") return parseObject((_a = {}, _a[unit || "milliseconds"] = input, _a));
    return null;
}
function parseString(s) {
    var m = PARSE_RE.exec(s);
    if (m) {
        var sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function parseObject(obj) {
    var duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    var weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function asCleanDays(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function addDurations(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function subtractDurations(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function multiplyDuration(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function asRoughYears(dur) {
    return asRoughDays(dur) / 365;
}
function asRoughMonths(dur) {
    return asRoughDays(dur) / 30;
}
function asRoughDays(dur) {
    return asRoughMs(dur) / 864e5;
}
function asRoughMinutes(dur) {
    return asRoughMs(dur) / 60000;
}
function asRoughSeconds(dur) {
    return asRoughMs(dur) / 1000;
}
function asRoughMs(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function wholeDivideDurations(numerator, denominator) {
    var res = null;
    for(var i = 0; i < INTERNAL_UNITS.length; i += 1){
        var unit = INTERNAL_UNITS[i];
        if (denominator[unit]) {
            var localRes = numerator[unit] / denominator[unit];
            if (!isInt(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function greatestDurationDenominator(dur) {
    var ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: "millisecond",
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: "second",
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: "minute",
            value: ms / 60000
        };
        if (ms) return {
            unit: "hour",
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: "week",
            value: dur.days / 7
        };
        return {
            unit: "day",
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: "month",
        value: dur.months
    };
    if (dur.years) return {
        unit: "year",
        value: dur.years
    };
    return {
        unit: "millisecond",
        value: 0
    };
}
// timeZoneOffset is in minutes
function buildIsoString(marker, timeZoneOffset, stripZeroTime) {
    if (stripZeroTime === void 0) stripZeroTime = false;
    var s = marker.toISOString();
    s = s.replace(".000", "");
    if (stripZeroTime) s = s.replace("T00:00:00Z", "");
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace("Z", "");
        else if (timeZoneOffset !== 0) s = s.replace("Z", formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function formatDayString(marker) {
    return marker.toISOString().replace(/T.*$/, "");
}
// TODO: use Date::toISOString and use everything after the T?
function formatIsoTimeString(marker) {
    return padStart(marker.getUTCHours(), 2) + ":" + padStart(marker.getUTCMinutes(), 2) + ":" + padStart(marker.getUTCSeconds(), 2);
}
function formatTimeZoneOffset(minutes, doIso) {
    if (doIso === void 0) doIso = false;
    var sign = minutes < 0 ? "-" : "+";
    var abs = Math.abs(minutes);
    var hours = Math.floor(abs / 60);
    var mins = Math.round(abs % 60);
    if (doIso) return sign + padStart(hours, 2) + ":" + padStart(mins, 2);
    return "GMT" + sign + hours + (mins ? ":" + padStart(mins, 2) : "");
}
// TODO: new util arrayify?
function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function isArraysEqual(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    var len = a0.length;
    var i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
function memoize(workerFunc, resEquality, teardownFunc) {
    var currentArgs;
    var currentRes;
    return function() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!isArraysEqual(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function memoizeObjArg(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArg;
    var currentRes;
    return function(newArg) {
        if (!currentArg) currentRes = workerFunc.call(_this, newArg);
        else if (!isPropsEqual(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.call(_this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function memoizeArraylike(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgSets = [];
    var currentResults = [];
    return function(newArgSets) {
        var currentLen = currentArgSets.length;
        var newLen = newArgSets.length;
        var i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!isArraysEqual(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                var res = workerFunc.apply(_this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function memoizeHashlike(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgHash = {};
    var currentResHash = {};
    return function(newArgHash) {
        var newResHash = {};
        for(var key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
            else if (!isArraysEqual(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                var res = workerFunc.apply(_this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
var EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 0,
    omitZeroMinute: 0,
    meridiem: 0,
    omitCommas: 0
};
var STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
var MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
var COMMA_RE = /,/g; // we need re for globalness
var MULTI_SPACE_RE = /\s+/g;
var LTR_RE = /\u200e/g; // control character
var UTC_RE = /UTC|GMT/;
var NativeFormatter = /** @class */ function() {
    function NativeFormatter(formatSettings) {
        var standardDateProps = {};
        var extendedSettings = {};
        var severity = 0;
        for(var name_1 in formatSettings)if (name_1 in EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name_1] = formatSettings[name_1];
            severity = Math.max(EXTENDED_SETTINGS_AND_SEVERITIES[name_1], severity);
        } else {
            standardDateProps[name_1] = formatSettings[name_1];
            if (name_1 in STANDARD_DATE_PROP_SEVERITIES) severity = Math.max(STANDARD_DATE_PROP_SEVERITIES[name_1], severity);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.severity = severity;
        this.buildFormattingFunc = memoize(buildFormattingFunc);
    }
    NativeFormatter.prototype.format = function(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    };
    NativeFormatter.prototype.formatRange = function(start, end, context, betterDefaultSeparator) {
        var _a = this, standardDateProps = _a.standardDateProps, extendedSettings = _a.extendedSettings;
        var diffSeverity = computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        var biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === "numeric" || standardDateProps.year === "2-digit") && (standardDateProps.month === "numeric" || standardDateProps.month === "2-digit") && (standardDateProps.day === "numeric" || standardDateProps.day === "2-digit")) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        var full0 = this.format(start, context);
        var full1 = this.format(end, context);
        if (full0 === full1) return full0;
        var partialDateProps = computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        var partialFormattingFunc = buildFormattingFunc(partialDateProps, extendedSettings, context);
        var partial0 = partialFormattingFunc(start);
        var partial1 = partialFormattingFunc(end);
        var insertion = findCommonInsertion(full0, partial0, full1, partial1);
        var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || "";
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    };
    NativeFormatter.prototype.getLargestUnit = function() {
        switch(this.severity){
            case 7:
            case 6:
            case 5:
                return "year";
            case 4:
                return "month";
            case 3:
                return "week";
            case 2:
                return "day";
            default:
                return "time"; // really?
        }
    };
    return NativeFormatter;
}();
function buildFormattingFunc(standardDateProps, extendedSettings, context) {
    var standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === "short") return function(date) {
        return formatTimeZoneOffset(date.timeZoneOffset);
    };
    if (standardDatePropCnt === 0 && extendedSettings.week) return function(date) {
        return formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    };
    return buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = (0, $4nqhV.__assign)({}, standardDateProps); // copy
    extendedSettings = (0, $4nqhV.__assign)({}, extendedSettings); // copy
    sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = "UTC"; // we leverage the only guaranteed timeZone for our UTC markers
    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    var zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        var zeroProps = (0, $4nqhV.__assign)({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return function(date) {
        var marker = date.marker;
        var format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        var s = format.format(marker);
        return postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = "2-digit";
        if (!standardDateProps.minute) standardDateProps.minute = "2-digit";
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === "long") standardDateProps.timeZoneName = "short";
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace(LTR_RE, ""); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === "short") s = injectTzoStr(s, context.timeZone === "UTC" || date.timeZoneOffset == null ? "UTC" : formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace(COMMA_RE, "").trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(":00", ""); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace(MERIDIEM_RE, "").trim();
    else if (extendedSettings.meridiem === "narrow") s = s.replace(MERIDIEM_RE, function(m0, m1) {
        return m1.toLocaleLowerCase();
    });
    else if (extendedSettings.meridiem === "short") s = s.replace(MERIDIEM_RE, function(m0, m1) {
        return m1.toLocaleLowerCase() + "m";
    });
    else if (extendedSettings.meridiem === "lowercase") s = s.replace(MERIDIEM_RE, function(m0) {
        return m0.toLocaleLowerCase();
    });
    s = s.replace(MULTI_SPACE_RE, " ");
    s = s.trim();
    return s;
}
function injectTzoStr(s, tzoStr) {
    var replaced = false;
    s = s.replace(UTC_RE, function() {
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += " " + tzoStr;
    return s;
}
function formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    var parts = [];
    if (display === "long") parts.push(weekTextLong);
    else if (display === "short" || display === "narrow") parts.push(weekText);
    if (display === "long" || display === "short") parts.push(" ");
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === "rtl") parts.reverse();
    return parts.join("");
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if (timeAsMs(d0) !== timeAsMs(d1)) return 1;
    return 0;
}
function computePartialFormattingOptions(options, biggestUnit) {
    var partialOptions = {};
    for(var name_2 in options)if (!(name_2 in STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    STANDARD_DATE_PROP_SEVERITIES[name_2] <= biggestUnit) partialOptions[name_2] = options[name_2];
    return partialOptions;
}
function findCommonInsertion(full0, partial0, full1, partial1) {
    var i0 = 0;
    while(i0 < full0.length){
        var found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        var before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        var after0 = full0.substr(i0);
        var i1 = 0;
        while(i1 < full1.length){
            var found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            var before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            var after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function expandZonedMarker(dateInfo, calendarSystem) {
    var a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    var startInfo = expandZonedMarker(start, context.calendarSystem);
    var endInfo = end ? expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ var CmdFormatter = /** @class */ function() {
    function CmdFormatter(cmdStr) {
        this.cmdStr = cmdStr;
    }
    CmdFormatter.prototype.format = function(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    };
    CmdFormatter.prototype.formatRange = function(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    };
    return CmdFormatter;
}();
var FuncFormatter = /** @class */ function() {
    function FuncFormatter(func) {
        this.func = func;
    }
    FuncFormatter.prototype.format = function(date, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    };
    FuncFormatter.prototype.formatRange = function(start, end, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    };
    return FuncFormatter;
}();
function createFormatter(input) {
    if (typeof input === "object" && input) return new NativeFormatter(input);
    if (typeof input === "string") return new CmdFormatter(input);
    if (typeof input === "function") return new FuncFormatter(input);
    return null;
}
// base options
// ------------
var BASE_OPTION_REFINERS = {
    navLinkDayClick: identity,
    navLinkWeekClick: identity,
    duration: createDuration,
    bootstrapFontAwesome: identity,
    buttonIcons: identity,
    customButtons: identity,
    defaultAllDayEventDuration: createDuration,
    defaultTimedEventDuration: createDuration,
    nextDayThreshold: createDuration,
    scrollTime: createDuration,
    scrollTimeReset: Boolean,
    slotMinTime: createDuration,
    slotMaxTime: createDuration,
    dayPopoverFormat: createFormatter,
    slotDuration: createDuration,
    snapDuration: createDuration,
    headerToolbar: identity,
    footerToolbar: identity,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: createFormatter,
    dayHeaderClassNames: identity,
    dayHeaderContent: identity,
    dayHeaderDidMount: identity,
    dayHeaderWillUnmount: identity,
    dayCellClassNames: identity,
    dayCellContent: identity,
    dayCellDidMount: identity,
    dayCellWillUnmount: identity,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: identity,
    weekNumbers: Boolean,
    weekNumberClassNames: identity,
    weekNumberContent: identity,
    weekNumberDidMount: identity,
    weekNumberWillUnmount: identity,
    editable: Boolean,
    viewClassNames: identity,
    viewDidMount: identity,
    viewWillUnmount: identity,
    nowIndicator: Boolean,
    nowIndicatorClassNames: identity,
    nowIndicatorContent: identity,
    nowIndicatorDidMount: identity,
    nowIndicatorWillUnmount: identity,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: identity,
    locale: identity,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: identity,
    eventOrder: parseFieldSpecs,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: identity,
    contentHeight: identity,
    direction: String,
    weekNumberFormat: createFormatter,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: identity,
    initialDate: identity,
    now: identity,
    eventDataTransform: identity,
    stickyHeaderDates: identity,
    stickyFooterScrollbar: identity,
    viewHeight: identity,
    defaultAllDay: Boolean,
    eventSourceFailure: identity,
    eventSourceSuccess: identity,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: identity,
    eventConstraint: identity,
    eventAllow: identity,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: identity,
    eventContent: identity,
    eventDidMount: identity,
    eventWillUnmount: identity,
    selectConstraint: identity,
    selectOverlap: identity,
    selectAllow: identity,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: identity,
    slotLaneClassNames: identity,
    slotLaneContent: identity,
    slotLaneDidMount: identity,
    slotLaneWillUnmount: identity,
    slotLabelClassNames: identity,
    slotLabelContent: identity,
    slotLabelDidMount: identity,
    slotLabelWillUnmount: identity,
    dayMaxEvents: identity,
    dayMaxEventRows: identity,
    dayMinWidth: Number,
    slotLabelInterval: createDuration,
    allDayText: String,
    allDayClassNames: identity,
    allDayContent: identity,
    allDayDidMount: identity,
    allDayWillUnmount: identity,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: createFormatter,
    rerenderDelay: Number,
    moreLinkText: identity,
    moreLinkHint: identity,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: identity,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: createDuration,
    hiddenDays: identity,
    monthMode: Boolean,
    fixedWeekCount: Boolean,
    validRange: identity,
    visibleRange: identity,
    titleFormat: identity,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: identity,
    navLinkHint: identity,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: identity,
    moreLinkClassNames: identity,
    moreLinkContent: identity,
    moreLinkDidMount: identity,
    moreLinkWillUnmount: identity
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
var BASE_OPTION_DEFAULTS = {
    eventDisplay: "auto",
    defaultRangeSeparator: " - ",
    titleRangeSeparator: " \u2013 ",
    defaultTimedEventDuration: "01:00:00",
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: "00:00:00",
    dayHeaders: true,
    initialView: "",
    aspectRatio: 1.35,
    headerToolbar: {
        start: "title",
        center: "",
        end: "today prev,next"
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: "local",
    editable: false,
    nowIndicator: false,
    scrollTime: "06:00:00",
    scrollTimeReset: true,
    slotMinTime: "00:00:00",
    slotMaxTime: "24:00:00",
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: "start",
    endParam: "end",
    timeZoneParam: "timeZone",
    timeZone: "local",
    locales: [],
    locale: "",
    themeSystem: "standard",
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: "*",
    eventOrder: "start,-duration,allDay,title",
    dayPopoverFormat: {
        month: "long",
        day: "numeric",
        year: "numeric"
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30
};
// calendar listeners
// ------------------
var CALENDAR_LISTENER_REFINERS = {
    datesSet: identity,
    eventsSet: identity,
    eventAdd: identity,
    eventChange: identity,
    eventRemove: identity,
    windowResize: identity,
    eventClick: identity,
    eventMouseEnter: identity,
    eventMouseLeave: identity,
    select: identity,
    unselect: identity,
    loading: identity,
    // internal
    _unmount: identity,
    _beforeprint: identity,
    _afterprint: identity,
    _noEventDrop: identity,
    _noEventResize: identity,
    _resize: identity,
    _scrollRequest: identity
};
// calendar-specific options
// -------------------------
var CALENDAR_OPTION_REFINERS = {
    buttonText: identity,
    buttonHints: identity,
    views: identity,
    plugins: identity,
    initialEvents: identity,
    events: identity,
    eventSources: identity
};
var COMPLEX_OPTION_COMPARATORS = {
    headerToolbar: isMaybeObjectsEqual,
    footerToolbar: isMaybeObjectsEqual,
    buttonText: isMaybeObjectsEqual,
    buttonHints: isMaybeObjectsEqual,
    buttonIcons: isMaybeObjectsEqual,
    dateIncrement: isMaybeObjectsEqual
};
function isMaybeObjectsEqual(a, b) {
    if (typeof a === "object" && typeof b === "object" && a && b) return isPropsEqual(a, b);
    return a === b;
}
// view-specific options
// ---------------------
var VIEW_OPTION_REFINERS = {
    type: String,
    component: identity,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: identity,
    usesMinMaxTime: Boolean,
    classNames: identity,
    content: identity,
    didMount: identity,
    willUnmount: identity
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function mergeRawOptions(optionSets) {
    return mergeProps(optionSets, COMPLEX_OPTION_COMPARATORS);
}
function refineProps(input, refiners) {
    var refined = {};
    var extra = {};
    for(var propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(var propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function identity(raw) {
    return raw;
}
function parseEvents(rawEvents, eventSource, context, allowOpenRange) {
    var eventStore = createEmptyEventStore();
    var eventRefiners = buildEventRefiners(context);
    for(var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++){
        var rawEvent = rawEvents_1[_i];
        var tuple = parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners);
        if (tuple) eventTupleToStore(tuple, eventStore);
    }
    return eventStore;
}
function eventTupleToStore(tuple, eventStore) {
    if (eventStore === void 0) eventStore = createEmptyEventStore();
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function getRelevantEvents(eventStore, instanceId) {
    var instance = eventStore.instances[instanceId];
    if (instance) {
        var def_1 = eventStore.defs[instance.defId];
        // get events/instances with same group
        var newStore = filterEventStoreDefs(eventStore, function(lookDef) {
            return isEventDefsGrouped(def_1, lookDef);
        });
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def_1.defId] = def_1;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return createEmptyEventStore();
}
function isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function createEmptyEventStore() {
    return {
        defs: {},
        instances: {}
    };
}
function mergeEventStores(store0, store1) {
    return {
        defs: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, store0.defs), store1.defs),
        instances: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, store0.instances), store1.instances)
    };
}
function filterEventStoreDefs(eventStore, filterFunc) {
    var defs = filterHash(eventStore.defs, filterFunc);
    var instances = filterHash(eventStore.instances, function(instance) {
        return defs[instance.defId] // still exists?
        ;
    });
    return {
        defs: defs,
        instances: instances
    };
}
function excludeSubEventStore(master, sub) {
    var defs = master.defs, instances = master.instances;
    var filteredDefs = {};
    var filteredInstances = {};
    for(var defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(var instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function normalizeConstraint(input, context) {
    if (Array.isArray(input)) return parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === "object" && input) return parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function parseClassNames(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
var EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: identity,
    overlap: identity,
    allow: identity,
    className: parseClassNames,
    classNames: parseClassNames,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
var EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: "",
    borderColor: "",
    textColor: "",
    classNames: []
};
function createEventUi(refined, context) {
    var constraint = normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || "",
        borderColor: refined.borderColor || refined.color || "",
        textColor: refined.textColor || "",
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function combineEventUis(uis) {
    return uis.reduce(combineTwoEventUis, EMPTY_EVENT_UI);
}
function combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === "boolean" ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
var EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
var EVENT_DATE_REFINERS = {
    start: identity,
    end: identity,
    date: identity,
    allDay: Boolean
};
var EVENT_REFINERS = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, EVENT_NON_DATE_REFINERS), EVENT_DATE_REFINERS), {
    extendedProps: identity
});
function parseEvent(raw, eventSource, context, allowOpenRange, refiners) {
    if (refiners === void 0) refiners = buildEventRefiners(context);
    var _a = refineEventDef(raw, context, refiners), refined = _a.refined, extra = _a.extra;
    var defaultAllDay = computeIsDefaultAllDay(eventSource, context);
    var recurringRes = parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : "", recurringRes.allDay, Boolean(recurringRes.duration), context);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    var singleRes = parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : "", singleRes.allDay, singleRes.hasEnd, context);
        var instance = createEventInstance(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function refineEventDef(raw, context, refiners) {
    if (refiners === void 0) refiners = buildEventRefiners(context);
    return refineProps(raw, refiners);
}
function buildEventRefiners(context) {
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, EVENT_UI_REFINERS), EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function parseEventDef(refined, extra, sourceId, allDay, hasEnd, context) {
    var def = {
        title: refined.title || "",
        groupId: refined.groupId || "",
        publicId: refined.id || "",
        url: refined.url || "",
        recurringDef: null,
        defId: guid(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: createEventUi(refined, context),
        extendedProps: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, refined.extendedProps || {}), extra)
    };
    for(var _i = 0, _a = context.pluginHooks.eventDefMemberAdders; _i < _a.length; _i++){
        var memberAdder = _a[_i];
        (0, $4nqhV.__assign)(def, memberAdder(refined));
    }
    // help out EventApi from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    var allDay = refined.allDay;
    var startMeta;
    var startMarker = null;
    var hasEnd = false;
    var endMeta;
    var endMarker = null;
    var startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = startOfDay(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = startOfDay(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function computeIsDefaultAllDay(eventSource, context) {
    var res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function computeAlignedDayRange(timedRange) {
    var dayCnt = Math.floor(diffDays(timedRange.start, timedRange.end)) || 1;
    var start = startOfDay(timedRange.start);
    var end = addDays(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function computeVisibleDayRange(timedRange, nextDayThreshold) {
    if (nextDayThreshold === void 0) nextDayThreshold = createDuration(0);
    var startDay = null;
    var endDay = null;
    if (timedRange.end) {
        endDay = startOfDay(timedRange.end);
        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= asRoughMs(nextDayThreshold)) endDay = addDays(endDay, 1);
    }
    if (timedRange.start) {
        startDay = startOfDay(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = addDays(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function isMultiDayRange(range) {
    var visibleRange = computeVisibleDayRange(range);
    return diffDays(visibleRange.start, visibleRange.end) > 1;
}
function diffDates(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === "year") return createDuration(dateEnv.diffWholeYears(date0, date1), "year");
    if (largeUnit === "month") return createDuration(dateEnv.diffWholeMonths(date0, date1), "month");
    return diffDayAndTime(date0, date1); // returns a duration
}
function parseRange(input, dateEnv) {
    var start = null;
    var end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function invertRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var start = constraintRange.start; // the end of the previous range. the start of the new range
    var i;
    var dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort(compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function intersectRanges(range0, range1) {
    var start = range0.start, end = range0.end;
    var newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function rangesEqual(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function rangesIntersect(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function rangeContainsRange(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function rangeContainsMarker(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function sliceEventStore(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    var inverseBgByGroupId = {};
    var inverseBgByDefId = {};
    var defByGroupId = {};
    var bgRanges = [];
    var fgRanges = [];
    var eventUis = compileEventUis(eventStore.defs, eventUiBases);
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        var ui = eventUis[def.defId];
        if (ui.display === "inverse-background") {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def = eventStore.defs[instance.defId];
        var ui = eventUis[def.defId];
        var origRange = instance.range;
        var normalRange = !def.allDay && nextDayThreshold ? computeVisibleDayRange(origRange, nextDayThreshold) : origRange;
        var slicedRange = intersectRanges(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === "inverse-background") {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== "none") (ui.display === "background" ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(var groupId in inverseBgByGroupId){
        var ranges = inverseBgByGroupId[groupId];
        var invertedRanges = invertRanges(ranges, framingRange);
        for(var _i = 0, invertedRanges_1 = invertedRanges; _i < invertedRanges_1.length; _i++){
            var invertedRange = invertedRanges_1[_i];
            var def = defByGroupId[groupId];
            var ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(var defId in inverseBgByDefId){
        var ranges = inverseBgByDefId[defId];
        var invertedRanges = invertRanges(ranges, framingRange);
        for(var _a = 0, invertedRanges_2 = invertedRanges; _a < invertedRanges_2.length; _a++){
            var invertedRange = invertedRanges_2[_a];
            bgRanges.push({
                def: eventStore.defs[defId],
                ui: eventUis[defId],
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function hasBgRendering(def) {
    return def.ui.display === "background" || def.ui.display === "inverse-background";
}
function setElSeg(el, seg) {
    el.fcSeg = seg;
}
function getElSeg(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function compileEventUis(eventDefs, eventUiBases) {
    return mapHash(eventDefs, function(eventDef) {
        return compileEventUi(eventDef, eventUiBases);
    });
}
function compileEventUi(eventDef, eventUiBases) {
    var uis = [];
    if (eventUiBases[""]) uis.push(eventUiBases[""]);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return combineEventUis(uis);
}
function sortEventSegs(segs, eventOrderSpecs) {
    var objs = segs.map(buildSegCompareObj);
    objs.sort(function(obj0, obj1) {
        return compareByFieldSpecs(obj0, obj1, eventOrderSpecs);
    });
    return objs.map(function(c) {
        return c._seg;
    });
}
// returns a object with all primitive props that can be compared
function buildSegCompareObj(seg) {
    var eventRange = seg.eventRange;
    var eventDef = eventRange.def;
    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    var end = range.end ? range.end.valueOf() : 0; // "
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function computeSegDraggable(seg, context) {
    var pluginHooks = context.pluginHooks;
    var transformers = pluginHooks.isDraggableTransformers;
    var _a = seg.eventRange, def = _a.def, ui = _a.ui;
    var val = ui.startEditable;
    for(var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++){
        var transformer = transformers_1[_i];
        val = transformer(val, def, ui, context);
    }
    return val;
}
function computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function buildSegTimeText(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    var dateEnv = context.dateEnv, options = context.options;
    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    var wholeEventStart = eventInstance.range.start;
    var wholeEventEnd = eventInstance.range.end;
    var segStart = startOverride || seg.start || seg.eventRange.range.start;
    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
    var isStartDay = startOfDay(wholeEventStart).valueOf() === startOfDay(segStart).valueOf();
    var isEndDay = startOfDay(addMs(wholeEventEnd, -1)).valueOf() === startOfDay(addMs(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return "";
}
function getSegMeta(seg, todayRange, nowDate) {
    var segRange = seg.eventRange.range;
    return {
        isPast: segRange.end < (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && rangeContainsMarker(todayRange, segRange.start)
    };
}
function getEventClassNames(props) {
    var classNames = [
        "fc-event"
    ];
    if (props.isMirror) classNames.push("fc-event-mirror");
    if (props.isDraggable) classNames.push("fc-event-draggable");
    if (props.isStartResizable || props.isEndResizable) classNames.push("fc-event-resizable");
    if (props.isDragging) classNames.push("fc-event-dragging");
    if (props.isResizing) classNames.push("fc-event-resizing");
    if (props.isSelected) classNames.push("fc-event-selected");
    if (props.isStart) classNames.push("fc-event-start");
    if (props.isEnd) classNames.push("fc-event-end");
    if (props.isPast) classNames.push("fc-event-past");
    if (props.isToday) classNames.push("fc-event-today");
    if (props.isFuture) classNames.push("fc-event-future");
    return classNames;
}
function buildEventRangeKey(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : eventRange.def.defId + ":" + eventRange.range.start.toISOString();
// inverse-background events don't have specific instances. TODO: better solution
}
function getSegAnchorAttrs(seg, context) {
    var _a = seg.eventRange, def = _a.def, instance = _a.instance;
    var url = def.url;
    if (url) return {
        href: url
    };
    var emitter = context.emitter, options = context.options;
    var eventInteractive = options.eventInteractive;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers("eventClick"));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return createAriaKeyboardAttrs(function(ev) {
        emitter.trigger("eventClick", {
            el: ev.target,
            event: new EventApi(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
var STANDARD_PROPS = {
    start: identity,
    end: identity,
    allDay: Boolean
};
function parseDateSpan(raw, dateEnv, defaultDuration) {
    var span = parseOpenDateSpan(raw, dateEnv);
    var range = span.range;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function parseOpenDateSpan(raw, dateEnv) {
    var _a = refineProps(raw, STANDARD_PROPS), standardProps = _a.refined, extra = _a.extra;
    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    var allDay = standardProps.allDay;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return (0, $4nqhV.__assign)({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function isDateSpansEqual(span0, span1) {
    return rangesEqual(span0.range, span1.range) && span0.allDay === span1.allDay && isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function isSpanPropsEqual(span0, span1) {
    for(var propName in span1)if (propName !== "range" && propName !== "allDay") {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(var propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function buildDateSpanApi(span, dateEnv) {
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function buildRangeApiWithTimeZone(range, dateEnv, omitTime) {
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function fabricateEventRange(dateSpan, eventUiBases, context) {
    var res = refineEventDef({
        editable: false
    }, context);
    var def = parseEventDef(res.refined, res.extra, "", dateSpan.allDay, true, context);
    return {
        def: def,
        ui: compileEventUi(def, eventUiBases),
        instance: createEventInstance(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
function triggerDateSelect(selection, pev, context) {
    context.emitter.trigger("select", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function triggerDateUnselect(pev, context) {
    context.emitter.trigger("unselect", {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function buildDateSpanApiWithContext(dateSpan, context) {
    var props = {};
    for(var _i = 0, _a = context.pluginHooks.dateSpanTransforms; _i < _a.length; _i++){
        var transform = _a[_i];
        (0, $4nqhV.__assign)(props, transform(dateSpan, context));
    }
    (0, $4nqhV.__assign)(props, buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function getDefaultEventEnd(allDay, marker, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var end = marker;
    if (allDay) {
        end = startOfDay(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function applyMutationToEventStore(eventStore, eventConfigBase, mutation, context) {
    var eventConfigs = compileEventUis(eventStore.defs, eventConfigBase);
    var dest = createEmptyEventStore();
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        dest.defs[defId] = applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    var standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    var copy = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventDef), standardProps), {
        ui: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, copy.extendedProps), mutation.extendedProps);
    for(var _i = 0, _a = context.pluginHooks.eventDefMutationAppliers; _i < _a.length; _i++){
        var applier = _a[_i];
        applier(copy, mutation, context);
    }
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    var dateEnv = context.dateEnv;
    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    var copy = (0, $4nqhV.__assign)({}, eventInstance);
    if (forceAllDay) copy.range = computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: getDefaultEventEnd(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: startOfDay(copy.range.start),
        end: startOfDay(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = getDefaultEventEnd(eventDef.allDay, copy.range.start, context);
    return copy;
}
// no public types yet. when there are, export from:
// import {} from './api-type-deps'
var ViewApi = /** @class */ function() {
    function ViewApi(type, getCurrentData, dateEnv) {
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    Object.defineProperty(ViewApi.prototype, "calendar", {
        get: function() {
            return this.getCurrentData().calendarApi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "title", {
        get: function() {
            return this.getCurrentData().viewTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "activeStart", {
        get: function() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "activeEnd", {
        get: function() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "currentStart", {
        get: function() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "currentEnd", {
        get: function() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
        },
        enumerable: false,
        configurable: true
    });
    ViewApi.prototype.getOption = function(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    };
    return ViewApi;
}();
var EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: identity,
    eventDataTransform: identity,
    // for any network-related sources
    success: identity,
    failure: identity
};
function parseEventSource(raw, context, refiners) {
    if (refiners === void 0) refiners = buildEventSourceRefiners(context);
    var rawObj;
    if (typeof raw === "string") rawObj = {
        url: raw
    };
    else if (typeof raw === "function" || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === "object" && raw) rawObj = raw;
    if (rawObj) {
        var _a = refineProps(rawObj, refiners), refined = _a.refined, extra = _a.extra;
        var metaRes = buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: "",
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || "",
            sourceId: guid(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: createEventUi(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function buildEventSourceRefiners(context) {
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, EVENT_UI_REFINERS), EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function buildEventSourceMeta(raw, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    for(var i = defs.length - 1; i >= 0; i -= 1){
        var def = defs[i];
        var meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case "CHANGE_DATE":
            return action.dateMarker;
        default:
            return currentDate;
    }
}
function getInitialDate(options, dateEnv) {
    var initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return getNow(options.now, dateEnv); // getNow already returns unzoned
}
function getNow(nowInput, dateEnv) {
    if (typeof nowInput === "function") nowInput = nowInput();
    if (nowInput == null) return dateEnv.createNowMarker();
    return dateEnv.createMarker(nowInput);
}
var CalendarApi = /** @class */ function() {
    function CalendarApi() {}
    CalendarApi.prototype.getCurrentData = function() {
        return this.currentDataManager.getCurrentData();
    };
    CalendarApi.prototype.dispatch = function(action) {
        return this.currentDataManager.dispatch(action);
    };
    Object.defineProperty(CalendarApi.prototype, "view", {
        get: function() {
            return this.getCurrentData().viewApi;
        } // for public API
        ,
        enumerable: false,
        configurable: true
    });
    CalendarApi.prototype.batchRendering = function(callback) {
        callback();
    };
    CalendarApi.prototype.updateSize = function() {
        this.trigger("_resize", true);
    };
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.setOption = function(name, val) {
        this.dispatch({
            type: "SET_OPTION",
            optionName: name,
            rawOptionValue: val
        });
    };
    CalendarApi.prototype.getOption = function(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    };
    CalendarApi.prototype.getAvailableLocaleCodes = function() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    };
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.on = function(handlerName, handler) {
        var currentDataManager = this.currentDataManager;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn("Unknown listener name '" + handlerName + "'");
    };
    CalendarApi.prototype.off = function(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    };
    // not meant for public use
    CalendarApi.prototype.trigger = function(handlerName) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this.currentDataManager.emitter).trigger.apply(_a, (0, $4nqhV.__spreadArray)([
            handlerName
        ], args));
    };
    // View
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.changeView = function(viewType, dateOrRange) {
        var _this = this;
        this.batchRendering(function() {
            _this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    _this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType
                    });
                    _this.dispatch({
                        type: "SET_OPTION",
                        optionName: "visibleRange",
                        rawOptionValue: dateOrRange
                    });
                } else {
                    var dateEnv = _this.getCurrentData().dateEnv;
                    _this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else _this.dispatch({
                type: "CHANGE_VIEW_TYPE",
                viewType: viewType
            });
        });
    };
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    CalendarApi.prototype.zoomTo = function(dateMarker, viewType) {
        var state = this.getCurrentData();
        var spec;
        viewType = viewType || "day"; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: dateMarker
        });
    };
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    CalendarApi.prototype.getUnitViewSpec = function(unit) {
        var _a = this.getCurrentData(), viewSpecs = _a.viewSpecs, toolbarConfig = _a.toolbarConfig;
        var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        var i;
        var spec;
        for(var viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    };
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.prev = function() {
        this.unselect();
        this.dispatch({
            type: "PREV"
        });
    };
    CalendarApi.prototype.next = function() {
        this.unselect();
        this.dispatch({
            type: "NEXT"
        });
    };
    CalendarApi.prototype.prevYear = function() {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    };
    CalendarApi.prototype.nextYear = function() {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    };
    CalendarApi.prototype.today = function() {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: getNow(state.calendarOptions.now, state.dateEnv)
        });
    };
    CalendarApi.prototype.gotoDate = function(zonedDateInput) {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    };
    CalendarApi.prototype.incrementDate = function(deltaInput) {
        var state = this.getCurrentData();
        var delta = createDuration(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: "CHANGE_DATE",
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    };
    // for external API
    CalendarApi.prototype.getDate = function() {
        var state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    };
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.formatDate = function(d, formatter) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.format(dateEnv.createMarker(d), createFormatter(formatter));
    };
    // `settings` is for formatter AND isEndExclusive
    CalendarApi.prototype.formatRange = function(d0, d1, settings) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), createFormatter(settings), settings);
    };
    CalendarApi.prototype.formatIso = function(d, omitTime) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    };
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    // NOTE: args were changed from v3
    CalendarApi.prototype.select = function(dateOrObj, endDate) {
        var selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        var state = this.getCurrentData();
        var selection = parseDateSpan(selectionInput, state.dateEnv, createDuration({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: "SELECT_DATES",
                selection: selection
            });
            triggerDateSelect(selection, null, state);
        }
    };
    // public method
    CalendarApi.prototype.unselect = function(pev) {
        var state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: "UNSELECT_DATES"
            });
            triggerDateUnselect(pev, state);
        }
    };
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.addEvent = function(eventInput, sourceInput) {
        if (eventInput instanceof EventApi) {
            var def = eventInput._def;
            var instance = eventInput._instance;
            var currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: "ADD_EVENTS",
                    eventStore: eventTupleToStore({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        var state = this.getCurrentData();
        var eventSource;
        if (sourceInput instanceof EventSourceApi) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === "boolean") {
            if (sourceInput) eventSource = hashValuesToArray(state.eventSources)[0];
        } else if (sourceInput != null) {
            var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn('Could not find an event source with ID "' + sourceInput + '"'); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        var tuple = parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            var newEventApi = new EventApi(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: "ADD_EVENTS",
                eventStore: eventTupleToStore(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    };
    CalendarApi.prototype.triggerEventAdd = function(eventApi) {
        var _this = this;
        var emitter = this.getCurrentData().emitter;
        emitter.trigger("eventAdd", {
            event: eventApi,
            relatedEvents: [],
            revert: function() {
                _this.dispatch({
                    type: "REMOVE_EVENTS",
                    eventStore: eventApiToStore(eventApi)
                });
            }
        });
    };
    // TODO: optimize
    CalendarApi.prototype.getEventById = function(id) {
        var state = this.getCurrentData();
        var _a = state.eventStore, defs = _a.defs, instances = _a.instances;
        id = String(id);
        for(var defId in defs){
            var def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new EventApi(state, def, null);
                for(var instanceId in instances){
                    var instance = instances[instanceId];
                    if (instance.defId === def.defId) return new EventApi(state, def, instance);
                }
            }
        }
        return null;
    };
    CalendarApi.prototype.getEvents = function() {
        var currentData = this.getCurrentData();
        return buildEventApis(currentData.eventStore, currentData);
    };
    CalendarApi.prototype.removeAllEvents = function() {
        this.dispatch({
            type: "REMOVE_ALL_EVENTS"
        });
    };
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.getEventSources = function() {
        var state = this.getCurrentData();
        var sourceHash = state.eventSources;
        var sourceApis = [];
        for(var internalId in sourceHash)sourceApis.push(new EventSourceApi(state, sourceHash[internalId]));
        return sourceApis;
    };
    CalendarApi.prototype.getEventSourceById = function(id) {
        var state = this.getCurrentData();
        var sourceHash = state.eventSources;
        id = String(id);
        for(var sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new EventSourceApi(state, sourceHash[sourceId]);
        }
        return null;
    };
    CalendarApi.prototype.addEventSource = function(sourceInput) {
        var state = this.getCurrentData();
        if (sourceInput instanceof EventSourceApi) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: "ADD_EVENT_SOURCES",
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        var eventSource = parseEventSource(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: "ADD_EVENT_SOURCES",
                sources: [
                    eventSource
                ]
            });
            return new EventSourceApi(state, eventSource);
        }
        return null;
    };
    CalendarApi.prototype.removeAllEventSources = function() {
        this.dispatch({
            type: "REMOVE_ALL_EVENT_SOURCES"
        });
    };
    CalendarApi.prototype.refetchEvents = function() {
        this.dispatch({
            type: "FETCH_EVENT_SOURCES",
            isRefetch: true
        });
    };
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.scrollToTime = function(timeInput) {
        var time = createDuration(timeInput);
        if (time) this.trigger("_scrollRequest", {
            time: time
        });
    };
    return CalendarApi;
}();
var EventApi = /** @class */ function() {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    function EventApi(context, def, instance) {
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ EventApi.prototype.setProp = function(name, val) {
        var _a, _b;
        if (name in EVENT_DATE_REFINERS) console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
        else if (name === "id") {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in EVENT_NON_DATE_REFINERS) {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: (_a = {}, _a[name] = val, _a)
            });
        } else if (name in EVENT_UI_REFINERS) {
            var ui = EVENT_UI_REFINERS[name](val);
            if (name === "color") ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === "editable") ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = (_b = {}, _b[name] = val, _b);
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn("Could not set prop '" + name + "'. Use setExtendedProp instead.");
    };
    EventApi.prototype.setExtendedProp = function(name, val) {
        var _a;
        this.mutate({
            extendedProps: (_a = {}, _a[name] = val, _a)
        });
    };
    EventApi.prototype.setStart = function(startInput, options) {
        if (options === void 0) options = {};
        var dateEnv = this._context.dateEnv;
        var start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            var instanceRange = this._instance.range;
            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    };
    EventApi.prototype.setEnd = function(endInput, options) {
        if (options === void 0) options = {};
        var dateEnv = this._context.dateEnv;
        var end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                var endDelta = diffDates(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    };
    EventApi.prototype.setDates = function(startInput, endInput, options) {
        if (options === void 0) options = {};
        var dateEnv = this._context.dateEnv;
        var standardProps = {
            allDay: options.allDay
        };
        var start = dateEnv.createMarker(startInput);
        var end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            var instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = computeAlignedDayRange(instanceRange);
            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                var endDelta = diffDates(instanceRange.end, end, dateEnv, options.granularity);
                if (durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    };
    EventApi.prototype.moveStart = function(deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    };
    EventApi.prototype.moveEnd = function(deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    };
    EventApi.prototype.moveDates = function(deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    };
    EventApi.prototype.setAllDay = function(allDay, options) {
        if (options === void 0) options = {};
        var standardProps = {
            allDay: allDay
        };
        var maintainDuration = options.maintainDuration;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    };
    EventApi.prototype.formatRange = function(formatInput) {
        var dateEnv = this._context.dateEnv;
        var instance = this._instance;
        var formatter = createFormatter(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    };
    EventApi.prototype.mutate = function(mutation) {
        var instance = this._instance;
        if (instance) {
            var def = this._def;
            var context_1 = this._context;
            var eventStore_1 = context_1.getCurrentData().eventStore;
            var relevantEvents = getRelevantEvents(eventStore_1, instance.instanceId);
            var eventConfigBase = {
                "": {
                    display: "",
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: "",
                    borderColor: "",
                    textColor: "",
                    classNames: []
                }
            };
            relevantEvents = applyMutationToEventStore(relevantEvents, eventConfigBase, mutation, context_1);
            var oldEvent = new EventApi(context_1, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context_1.dispatch({
                type: "MERGE_EVENTS",
                eventStore: relevantEvents
            });
            context_1.emitter.trigger("eventChange", {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: buildEventApis(relevantEvents, context_1, instance),
                revert: function() {
                    context_1.dispatch({
                        type: "RESET_EVENTS",
                        eventStore: eventStore_1
                    });
                }
            });
        }
    };
    EventApi.prototype.remove = function() {
        var context = this._context;
        var asStore = eventApiToStore(this);
        context.dispatch({
            type: "REMOVE_EVENTS",
            eventStore: asStore
        });
        context.emitter.trigger("eventRemove", {
            event: this,
            relatedEvents: [],
            revert: function() {
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: asStore
                });
            }
        });
    };
    Object.defineProperty(EventApi.prototype, "source", {
        get: function() {
            var sourceId = this._def.sourceId;
            if (sourceId) return new EventSourceApi(this._context, this._context.getCurrentData().eventSources[sourceId]);
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "start", {
        get: function() {
            return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "end", {
        get: function() {
            return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "startStr", {
        get: function() {
            var instance = this._instance;
            if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
                omitTime: this._def.allDay,
                forcedTzo: instance.forcedStartTzo
            });
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "endStr", {
        get: function() {
            var instance = this._instance;
            if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
                omitTime: this._def.allDay,
                forcedTzo: instance.forcedEndTzo
            });
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "id", {
        // computable props that all access the def
        // TODO: find a TypeScript-compatible way to do this at scale
        get: function() {
            return this._def.publicId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "groupId", {
        get: function() {
            return this._def.groupId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "allDay", {
        get: function() {
            return this._def.allDay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "title", {
        get: function() {
            return this._def.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "url", {
        get: function() {
            return this._def.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "display", {
        get: function() {
            return this._def.ui.display || "auto";
        } // bad. just normalize the type earlier
        ,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "startEditable", {
        get: function() {
            return this._def.ui.startEditable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "durationEditable", {
        get: function() {
            return this._def.ui.durationEditable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "constraint", {
        get: function() {
            return this._def.ui.constraints[0] || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "overlap", {
        get: function() {
            return this._def.ui.overlap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "allow", {
        get: function() {
            return this._def.ui.allows[0] || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "backgroundColor", {
        get: function() {
            return this._def.ui.backgroundColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "borderColor", {
        get: function() {
            return this._def.ui.borderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "textColor", {
        get: function() {
            return this._def.ui.textColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "classNames", {
        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
        get: function() {
            return this._def.ui.classNames;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "extendedProps", {
        get: function() {
            return this._def.extendedProps;
        },
        enumerable: false,
        configurable: true
    });
    EventApi.prototype.toPlainObject = function(settings) {
        if (settings === void 0) settings = {};
        var def = this._def;
        var ui = def.ui;
        var _a = this, startStr = _a.startStr, endStr = _a.endStr;
        var res = {};
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== "auto") res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) (0, $4nqhV.__assign)(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    };
    EventApi.prototype.toJSON = function() {
        return this.toPlainObject();
    };
    return EventApi;
}();
function eventApiToStore(eventApi) {
    var _a, _b;
    var def = eventApi._def;
    var instance = eventApi._instance;
    return {
        defs: (_a = {}, _a[def.defId] = def, _a),
        instances: instance ? (_b = {}, _b[instance.instanceId] = instance, _b) : {}
    };
}
function buildEventApis(eventStore, context, excludeInstance) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var eventApis = [];
    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : "";
    for(var id in instances){
        var instance = instances[id];
        var def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new EventApi(context, def, instance));
    }
    return eventApis;
}
var calendarSystemClassMap = {};
function registerCalendarSystem(name, theClass) {
    calendarSystemClassMap[name] = theClass;
}
function createCalendarSystem(name) {
    return new calendarSystemClassMap[name]();
}
var GregorianCalendarSystem = /** @class */ function() {
    function GregorianCalendarSystem() {}
    GregorianCalendarSystem.prototype.getMarkerYear = function(d) {
        return d.getUTCFullYear();
    };
    GregorianCalendarSystem.prototype.getMarkerMonth = function(d) {
        return d.getUTCMonth();
    };
    GregorianCalendarSystem.prototype.getMarkerDay = function(d) {
        return d.getUTCDate();
    };
    GregorianCalendarSystem.prototype.arrayToMarker = function(arr) {
        return arrayToUtcDate(arr);
    };
    GregorianCalendarSystem.prototype.markerToArray = function(marker) {
        return dateToUtcArray(marker);
    };
    return GregorianCalendarSystem;
}();
registerCalendarSystem("gregory", GregorianCalendarSystem);
var ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function parse(str) {
    var m = ISO_RE.exec(str);
    if (m) {
        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0." + m[12]) * 1000 : 0));
        if (isValidDate(marker)) {
            var timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === "-" ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
var DateEnv = /** @class */ function() {
    function DateEnv(settings) {
        var timeZone = this.timeZone = settings.timeZone;
        var isNamedTimeZone = timeZone !== "local" && timeZone !== "UTC";
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === "ISO") {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === "number") this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === "function") this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    DateEnv.prototype.createMarker = function(input) {
        var meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    };
    DateEnv.prototype.createNowMarker = function() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return arrayToUtcDate(dateToLocalArray(new Date()));
    };
    DateEnv.prototype.createMarkerMeta = function(input) {
        if (typeof input === "string") return this.parse(input);
        var marker = null;
        if (typeof input === "number") marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = arrayToUtcDate(input);
        if (marker === null || !isValidDate(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    };
    DateEnv.prototype.parse = function(s) {
        var parts = parse(s);
        if (parts === null) return null;
        var marker = parts.marker;
        var forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    };
    // Accessors
    DateEnv.prototype.getYear = function(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    };
    DateEnv.prototype.getMonth = function(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    };
    // Adding / Subtracting
    DateEnv.prototype.add = function(marker, dur) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.subtract = function(marker, dur) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.addYears = function(marker, n) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.addMonths = function(marker, n) {
        var a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    };
    // Diffing Whole Units
    DateEnv.prototype.diffWholeYears = function(m0, m1) {
        var calendarSystem = this.calendarSystem;
        if (timeAsMs(m0) === timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    };
    DateEnv.prototype.diffWholeMonths = function(m0, m1) {
        var calendarSystem = this.calendarSystem;
        if (timeAsMs(m0) === timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    };
    // Range / Duration
    DateEnv.prototype.greatestWholeUnit = function(m0, m1) {
        var n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: "year",
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: "month",
            value: n
        };
        n = diffWholeWeeks(m0, m1);
        if (n !== null) return {
            unit: "week",
            value: n
        };
        n = diffWholeDays(m0, m1);
        if (n !== null) return {
            unit: "day",
            value: n
        };
        n = diffHours(m0, m1);
        if (isInt(n)) return {
            unit: "hour",
            value: n
        };
        n = diffMinutes(m0, m1);
        if (isInt(n)) return {
            unit: "minute",
            value: n
        };
        n = diffSeconds(m0, m1);
        if (isInt(n)) return {
            unit: "second",
            value: n
        };
        return {
            unit: "millisecond",
            value: m1.valueOf() - m0.valueOf()
        };
    };
    DateEnv.prototype.countDurationsBetween = function(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        var diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / asRoughMonths(d);
        }
        if (d.days) {
            diff = diffWholeDays(m0, m1);
            if (diff !== null) return diff / asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / asRoughMs(d);
    };
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    DateEnv.prototype.startOf = function(m, unit) {
        if (unit === "year") return this.startOfYear(m);
        if (unit === "month") return this.startOfMonth(m);
        if (unit === "week") return this.startOfWeek(m);
        if (unit === "day") return startOfDay(m);
        if (unit === "hour") return startOfHour(m);
        if (unit === "minute") return startOfMinute(m);
        if (unit === "second") return startOfSecond(m);
        return null;
    };
    DateEnv.prototype.startOfYear = function(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    };
    DateEnv.prototype.startOfMonth = function(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    };
    DateEnv.prototype.startOfWeek = function(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    };
    // Week Number
    DateEnv.prototype.computeWeekNumber = function(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return weekOfYear(marker, this.weekDow, this.weekDoy);
    };
    // TODO: choke on timeZoneName: long
    DateEnv.prototype.format = function(marker, formatter, dateOptions) {
        if (dateOptions === void 0) dateOptions = {};
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    };
    DateEnv.prototype.formatRange = function(start, end, formatter, dateOptions) {
        if (dateOptions === void 0) dateOptions = {};
        if (dateOptions.isEndExclusive) end = addMs(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    };
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ DateEnv.prototype.formatIso = function(marker, extraOptions) {
        if (extraOptions === void 0) extraOptions = {};
        var timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return buildIsoString(marker, timeZoneOffset, extraOptions.omitTime);
    };
    // TimeZone
    DateEnv.prototype.timestampToMarker = function(ms) {
        if (this.timeZone === "local") return arrayToUtcDate(dateToLocalArray(new Date(ms)));
        if (this.timeZone === "UTC" || !this.namedTimeZoneImpl) return new Date(ms);
        return arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    };
    DateEnv.prototype.offsetForMarker = function(m) {
        if (this.timeZone === "local") return -arrayToLocalDate(dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === "UTC") return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m));
        return null;
    };
    // Conversion
    DateEnv.prototype.toDate = function(m, forcedTzo) {
        if (this.timeZone === "local") return arrayToLocalDate(dateToUtcArray(m));
        if (this.timeZone === "UTC") return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m)) * 60000);
    };
    return DateEnv;
}();
var globalLocales = [];
var MINIMAL_RAW_EN_LOCALE = {
    code: "en",
    week: {
        dow: 0,
        doy: 4
    },
    direction: "ltr",
    buttonText: {
        prev: "prev",
        next: "next",
        prevYear: "prev year",
        nextYear: "next year",
        year: "year",
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        list: "list"
    },
    weekText: "W",
    weekTextLong: "Week",
    closeHint: "Close",
    timeHint: "Time",
    eventHint: "Event",
    allDayText: "all-day",
    moreLinkText: "more",
    noEventsText: "No events to display"
};
var RAW_EN_LOCALE = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: "Previous $0",
        next: "Next $0",
        today: function(buttonText, unit) {
            return unit === "day" ? "Today" : "This " + buttonText;
        }
    },
    viewHint: "$0 view",
    navLinkHint: "Go to $0",
    moreLinkHint: function(eventCnt) {
        return "Show " + eventCnt + " more event" + (eventCnt === 1 ? "" : "s");
    }
});
function organizeRawLocales(explicitRawLocales) {
    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : "en";
    var allRawLocales = globalLocales.concat(explicitRawLocales);
    var rawLocaleMap = {
        en: RAW_EN_LOCALE
    };
    for(var _i = 0, allRawLocales_1 = allRawLocales; _i < allRawLocales_1.length; _i++){
        var rawLocale = allRawLocales_1[_i];
        rawLocaleMap[rawLocale.code] = rawLocale;
    }
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function buildLocale(inputSingular, available) {
    if (typeof inputSingular === "object" && !Array.isArray(inputSingular)) return parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return queryLocale(inputSingular, available);
}
function queryLocale(codeArg, available) {
    var codes = [].concat(codeArg || []); // will convert to array
    var raw = queryRawLocale(codes, available) || RAW_EN_LOCALE;
    return parseLocale(codeArg, codes, raw);
}
function queryRawLocale(codes, available) {
    for(var i = 0; i < codes.length; i += 1){
        var parts = codes[i].toLocaleLowerCase().split("-");
        for(var j = parts.length; j > 0; j -= 1){
            var simpleId = parts.slice(0, j).join("-");
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function parseLocale(codeArg, codes, raw) {
    var merged = mergeProps([
        MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        "buttonText"
    ]);
    delete merged.code; // don't want this part of the options
    var week = merged.week;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
function formatDate(dateInput, options) {
    if (options === void 0) options = {};
    var dateEnv = buildDateEnv$1(options);
    var formatter = createFormatter(options);
    var dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return "";
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function formatRange(startInput, endInput, options) {
    var dateEnv = buildDateEnv$1(typeof options === "object" && options ? options : {}); // pass in if non-null object
    var formatter = createFormatter(options);
    var startMeta = dateEnv.createMarkerMeta(startInput);
    var endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return "";
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: BASE_OPTION_DEFAULTS.defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function buildDateEnv$1(settings) {
    var locale = buildLocale(settings.locale || "en", organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new DateEnv((0, $4nqhV.__assign)((0, $4nqhV.__assign)({
        timeZone: BASE_OPTION_DEFAULTS.timeZone,
        calendarSystem: "gregory"
    }, settings), {
        locale: locale
    }));
}
var DEF_DEFAULTS = {
    startTime: "09:00",
    endTime: "17:00",
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: "inverse-background",
    classNames: "fc-non-business",
    groupId: "_businessHours"
};
/*
TODO: pass around as EventDefHash!!!
*/ function parseBusinessHours(input, context) {
    return parseEvents(refineInputs(input), null, context);
}
function refineInputs(input) {
    var rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter(function(rawDef) {
        return rawDef.daysOfWeek;
    });
    else if (typeof input === "object" && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map(function(rawDef) {
        return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, DEF_DEFAULTS), rawDef);
    });
    return rawDefs;
}
function pointInsideRect(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function translateRect(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
var canVGrowWithinCell;
function getCanVGrowWithinCell() {
    if (canVGrowWithinCell == null) canVGrowWithinCell = computeCanVGrowWithinCell();
    return canVGrowWithinCell;
}
function computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === "undefined") return true;
    var el = document.createElement("div");
    el.style.position = "absolute";
    el.style.top = "0px";
    el.style.left = "0px";
    el.innerHTML = "<table><tr><td><div></div></td></tr></table>";
    el.querySelector("table").style.height = "100px";
    el.querySelector("div").style.height = "100%";
    document.body.appendChild(el);
    var div = el.querySelector("div");
    var possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
var EMPTY_EVENT_STORE = createEmptyEventStore(); // for purecomponents. TODO: keep elsewhere
var Splitter = /** @class */ function() {
    function Splitter() {
        this.getKeysForEventDefs = memoize(this._getKeysForEventDefs);
        this.splitDateSelection = memoize(this._splitDateSpan);
        this.splitEventStore = memoize(this._splitEventStore);
        this.splitIndividualUi = memoize(this._splitIndividualUi);
        this.splitEventDrag = memoize(this._splitInteraction);
        this.splitEventResize = memoize(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    Splitter.prototype.splitProps = function(props) {
        var _this = this;
        var keyInfos = this.getKeyInfo(props);
        var defKeys = this.getKeysForEventDefs(props.eventStore);
        var dateSelections = this.splitDateSelection(props.dateSelection);
        var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        var eventStores = this.splitEventStore(props.eventStore, defKeys);
        var eventDrags = this.splitEventDrag(props.eventDrag);
        var eventResizes = this.splitEventResize(props.eventResize);
        var splitProps = {};
        this.eventUiBuilders = mapHash(keyInfos, function(info, key) {
            return _this.eventUiBuilders[key] || memoize(buildEventUiForKey);
        });
        for(var key in keyInfos){
            var keyInfo = keyInfos[key];
            var eventStore = eventStores[key] || EMPTY_EVENT_STORE;
            var buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[""], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : "",
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    };
    Splitter.prototype._splitDateSpan = function(dateSpan) {
        var dateSpans = {};
        if (dateSpan) {
            var keys = this.getKeysForDateSpan(dateSpan);
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var key = keys_1[_i];
                dateSpans[key] = dateSpan;
            }
        }
        return dateSpans;
    };
    Splitter.prototype._getKeysForEventDefs = function(eventStore) {
        var _this = this;
        return mapHash(eventStore.defs, function(eventDef) {
            return _this.getKeysForEventDef(eventDef);
        });
    };
    Splitter.prototype._splitEventStore = function(eventStore, defKeys) {
        var defs = eventStore.defs, instances = eventStore.instances;
        var splitStores = {};
        for(var defId in defs)for(var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++){
            var key = _a[_i];
            if (!splitStores[key]) splitStores[key] = createEmptyEventStore();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(var instanceId in instances){
            var instance = instances[instanceId];
            for(var _b = 0, _c = defKeys[instance.defId]; _b < _c.length; _b++){
                var key = _c[_b];
                if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
            }
        }
        return splitStores;
    };
    Splitter.prototype._splitIndividualUi = function(eventUiBases, defKeys) {
        var splitHashes = {};
        for(var defId in eventUiBases){
            if (defId) for(var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++){
                var key = _a[_i];
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    };
    Splitter.prototype._splitInteraction = function(interaction) {
        var splitStates = {};
        if (interaction) {
            var affectedStores_1 = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            var mutatedStores_1 = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            var populate = function(key) {
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores_1[key] || EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores_1[key] || EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(var key in affectedStores_1)populate(key);
            for(var key in mutatedStores_1)populate(key);
        }
        return splitStates;
    };
    return Splitter;
}();
function buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    var baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    var stuff = {
        "": combineEventUis(baseParts)
    };
    if (individualUi) (0, $4nqhV.__assign)(stuff, individualUi);
    return stuff;
}
function getDateMeta(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && !rangeContainsMarker(dateProfile.activeRange, date)),
        isOther: Boolean(dateProfile && !rangeContainsMarker(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && rangeContainsMarker(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function getDayClassNames(meta, theme) {
    var classNames = [
        "fc-day",
        "fc-day-" + DAY_IDS[meta.dow]
    ];
    if (meta.isDisabled) classNames.push("fc-day-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-day-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-day-past");
        if (meta.isFuture) classNames.push("fc-day-future");
        if (meta.isOther) classNames.push("fc-day-other");
    }
    return classNames;
}
function getSlotClassNames(meta, theme) {
    var classNames = [
        "fc-slot",
        "fc-slot-" + DAY_IDS[meta.dow]
    ];
    if (meta.isDisabled) classNames.push("fc-slot-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-slot-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-slot-past");
        if (meta.isFuture) classNames.push("fc-slot-future");
    }
    return classNames;
}
var DAY_FORMAT = createFormatter({
    year: "numeric",
    month: "long",
    day: "numeric"
});
var WEEK_FORMAT = createFormatter({
    week: "long"
});
function buildNavLinkAttrs(context, dateMarker, viewType, isTabbable) {
    if (viewType === void 0) viewType = "day";
    if (isTabbable === void 0) isTabbable = true;
    var dateEnv = context.dateEnv, options = context.options, calendarApi = context.calendarApi;
    var dateStr = dateEnv.format(dateMarker, viewType === "week" ? WEEK_FORMAT : DAY_FORMAT);
    if (options.navLinks) {
        var zonedDate = dateEnv.toDate(dateMarker);
        var handleInteraction = function(ev) {
            var customAction = viewType === "day" ? options.navLinkDayClick : viewType === "week" ? options.navLinkWeekClick : null;
            if (typeof customAction === "function") customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === "string") viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return (0, $4nqhV.__assign)({
            title: formatWithOrdinals(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            "data-navlink": ""
        }, isTabbable ? createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        "aria-label": dateStr
    };
}
var _isRtlScrollbarOnLeft = null;
function getIsRtlScrollbarOnLeft() {
    if (_isRtlScrollbarOnLeft === null) _isRtlScrollbarOnLeft = computeIsRtlScrollbarOnLeft();
    return _isRtlScrollbarOnLeft;
}
function computeIsRtlScrollbarOnLeft() {
    var outerEl = document.createElement("div");
    applyStyle(outerEl, {
        position: "absolute",
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: "scroll",
        direction: "rtl"
    });
    outerEl.innerHTML = "<div></div>";
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    removeElement(outerEl);
    return res;
}
var _scrollbarWidths;
function getScrollbarWidths() {
    if (!_scrollbarWidths) _scrollbarWidths = computeScrollbarWidths();
    return _scrollbarWidths;
}
function computeScrollbarWidths() {
    var el = document.createElement("div");
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    var res = computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function computeEdges(el, getPadding) {
    if (getPadding === void 0) getPadding = false;
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var badScrollbarWidths = computeScrollbarWidthsForEl(el); // includes border!
    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if (getIsRtlScrollbarOnLeft() && computedStyle.direction === "rtl") res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function computeInnerRect(el, goWithinPadding, doFromWindowViewport) {
    if (goWithinPadding === void 0) goWithinPadding = false;
    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : computeRect(el);
    var edges = computeEdges(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function computeRect(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset
    };
}
function computeClippedClientRect(el) {
    var clippingParents = getClippingParents(el);
    var rect = el.getBoundingClientRect();
    for(var _i = 0, clippingParents_1 = clippingParents; _i < clippingParents_1.length; _i++){
        var clippingParent = clippingParents_1[_i];
        var intersection = intersectRects(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
function computeHeightAndMargins(el) {
    return el.getBoundingClientRect().height + computeVMargins(el);
}
function computeVMargins(el) {
    var computed = window.getComputedStyle(el);
    return parseInt(computed.marginTop, 10) + parseInt(computed.marginBottom, 10);
}
// does not return window
function getClippingParents(el) {
    var parents = [];
    while(el instanceof HTMLElement){
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === "fixed") break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
// given a function that resolves a result asynchronously.
// the function can either call passed-in success and failure callbacks,
// or it can return a promise.
// if you need to pass additional params to func, bind them first.
function unpromisify(func, success, failure) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function() {
        if (!isResolved) {
            isResolved = true;
            success.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
    };
    var wrappedFailure = function() {
        if (!isResolved) {
            isResolved = true;
            if (failure) failure.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === "function") res.then(wrappedSuccess, wrappedFailure);
}
var Emitter = /** @class */ function() {
    function Emitter() {
        this.handlers = {};
        this.thisContext = null;
    }
    Emitter.prototype.setThisContext = function(thisContext) {
        this.thisContext = thisContext;
    };
    Emitter.prototype.setOptions = function(options) {
        this.options = options;
    };
    Emitter.prototype.on = function(type, handler) {
        addToHash(this.handlers, type, handler);
    };
    Emitter.prototype.off = function(type, handler) {
        removeFromHash(this.handlers, type, handler);
    };
    Emitter.prototype.trigger = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var attachedHandlers = this.handlers[type] || [];
        var optionHandler = this.options && this.options[type];
        var handlers = [].concat(optionHandler || [], attachedHandlers);
        for(var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++){
            var handler = handlers_1[_a];
            handler.apply(this.thisContext, args);
        }
    };
    Emitter.prototype.hasHandlers = function(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    };
    return Emitter;
}();
function addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter(function(func) {
            return func !== handler;
        });
    } else delete hash[type]; // remove all handler funcs for this type
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ var PositionCache = /** @class */ function() {
    function PositionCache(originEl, els, isHorizontal, isVertical) {
        this.els = els;
        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    PositionCache.prototype.buildElHorizontals = function(originClientLeft) {
        var lefts = [];
        var rights = [];
        for(var _i = 0, _a = this.els; _i < _a.length; _i++){
            var el = _a[_i];
            var rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    };
    // Populates the top/bottom internal coordinate arrays
    PositionCache.prototype.buildElVerticals = function(originClientTop) {
        var tops = [];
        var bottoms = [];
        for(var _i = 0, _a = this.els; _i < _a.length; _i++){
            var el = _a[_i];
            var rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    };
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    PositionCache.prototype.leftToIndex = function(leftPosition) {
        var _a = this, lefts = _a.lefts, rights = _a.rights;
        var len = lefts.length;
        var i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    };
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    PositionCache.prototype.topToIndex = function(topPosition) {
        var _a = this, tops = _a.tops, bottoms = _a.bottoms;
        var len = tops.length;
        var i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    };
    // Gets the width of the element at the given index
    PositionCache.prototype.getWidth = function(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    };
    // Gets the height of the element at the given index
    PositionCache.prototype.getHeight = function(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    };
    return PositionCache;
}();
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ var ScrollController = /** @class */ function() {
    function ScrollController() {}
    ScrollController.prototype.getMaxScrollTop = function() {
        return this.getScrollHeight() - this.getClientHeight();
    };
    ScrollController.prototype.getMaxScrollLeft = function() {
        return this.getScrollWidth() - this.getClientWidth();
    };
    ScrollController.prototype.canScrollVertically = function() {
        return this.getMaxScrollTop() > 0;
    };
    ScrollController.prototype.canScrollHorizontally = function() {
        return this.getMaxScrollLeft() > 0;
    };
    ScrollController.prototype.canScrollUp = function() {
        return this.getScrollTop() > 0;
    };
    ScrollController.prototype.canScrollDown = function() {
        return this.getScrollTop() < this.getMaxScrollTop();
    };
    ScrollController.prototype.canScrollLeft = function() {
        return this.getScrollLeft() > 0;
    };
    ScrollController.prototype.canScrollRight = function() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    };
    return ScrollController;
}();
var ElementScrollController = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ElementScrollController, _super);
    function ElementScrollController(el) {
        var _this = _super.call(this) || this;
        _this.el = el;
        return _this;
    }
    ElementScrollController.prototype.getScrollTop = function() {
        return this.el.scrollTop;
    };
    ElementScrollController.prototype.getScrollLeft = function() {
        return this.el.scrollLeft;
    };
    ElementScrollController.prototype.setScrollTop = function(top) {
        this.el.scrollTop = top;
    };
    ElementScrollController.prototype.setScrollLeft = function(left) {
        this.el.scrollLeft = left;
    };
    ElementScrollController.prototype.getScrollWidth = function() {
        return this.el.scrollWidth;
    };
    ElementScrollController.prototype.getScrollHeight = function() {
        return this.el.scrollHeight;
    };
    ElementScrollController.prototype.getClientHeight = function() {
        return this.el.clientHeight;
    };
    ElementScrollController.prototype.getClientWidth = function() {
        return this.el.clientWidth;
    };
    return ElementScrollController;
}(ScrollController);
var WindowScrollController = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(WindowScrollController, _super);
    function WindowScrollController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WindowScrollController.prototype.getScrollTop = function() {
        return window.pageYOffset;
    };
    WindowScrollController.prototype.getScrollLeft = function() {
        return window.pageXOffset;
    };
    WindowScrollController.prototype.setScrollTop = function(n) {
        window.scroll(window.pageXOffset, n);
    };
    WindowScrollController.prototype.setScrollLeft = function(n) {
        window.scroll(n, window.pageYOffset);
    };
    WindowScrollController.prototype.getScrollWidth = function() {
        return document.documentElement.scrollWidth;
    };
    WindowScrollController.prototype.getScrollHeight = function() {
        return document.documentElement.scrollHeight;
    };
    WindowScrollController.prototype.getClientHeight = function() {
        return document.documentElement.clientHeight;
    };
    WindowScrollController.prototype.getClientWidth = function() {
        return document.documentElement.clientWidth;
    };
    return WindowScrollController;
}(ScrollController);
var Theme = /** @class */ function() {
    function Theme(calendarOptions) {
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    Theme.prototype.setIconOverride = function(iconOverrideHash) {
        var iconClassesCopy;
        var buttonName;
        if (typeof iconOverrideHash === "object" && iconOverrideHash) {
            iconClassesCopy = (0, $4nqhV.__assign)({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    };
    Theme.prototype.applyIconOverridePrefix = function(className) {
        var prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    };
    Theme.prototype.getClass = function(key) {
        return this.classes[key] || "";
    };
    Theme.prototype.getIconClass = function(buttonName, isRtl) {
        var className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return this.baseIconClass + " " + className;
        return "";
    };
    Theme.prototype.getCustomButtonIconClass = function(customButtonProps) {
        var className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return this.baseIconClass + " " + this.applyIconOverridePrefix(className);
        }
        return "";
    };
    return Theme;
}();
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = "";
Theme.prototype.iconOverridePrefix = "";
var ScrollResponder = /** @class */ function() {
    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
        var _this = this;
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = function(request) {
            _this.queuedRequest = (0, $4nqhV.__assign)({}, _this.queuedRequest || {}, request);
            _this.drain();
        };
        emitter.on("_scrollRequest", this.handleScrollRequest);
        this.fireInitialScroll();
    }
    ScrollResponder.prototype.detach = function() {
        this.emitter.off("_scrollRequest", this.handleScrollRequest);
    };
    ScrollResponder.prototype.update = function(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    };
    ScrollResponder.prototype.fireInitialScroll = function() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    };
    ScrollResponder.prototype.drain = function() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    };
    return ScrollResponder;
}();
var ViewContextType = (0, $3jFHS.createContext)({}); // for Components
function buildViewContext(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === "rtl",
        addResizeHandler: function(handler) {
            emitter.on("_resize", handler);
        },
        removeResizeHandler: function(handler) {
            emitter.off("_resize", handler);
        },
        createScrollResponder: function(execFunc) {
            return new ScrollResponder(execFunc, emitter, createDuration(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ var PureComponent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(PureComponent, _super);
    function PureComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PureComponent.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        if (this.debug) // eslint-disable-next-line no-console
        console.log(getUnequalProps(nextProps, this.props), getUnequalProps(nextState, this.state));
        return !compareObjs(this.props, nextProps, this.propEquality) || !compareObjs(this.state, nextState, this.stateEquality);
    };
    // HACK for freakin' React StrictMode
    PureComponent.prototype.safeSetState = function(newState) {
        if (!compareObjs(this.state, (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, this.state), newState), this.stateEquality)) this.setState(newState);
    };
    PureComponent.addPropsEquality = addPropsEquality;
    PureComponent.addStateEquality = addStateEquality;
    PureComponent.contextType = ViewContextType;
    return PureComponent;
}((0, $3jFHS.Component));
PureComponent.prototype.propEquality = {};
PureComponent.prototype.stateEquality = {};
var BaseComponent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(BaseComponent, _super);
    function BaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseComponent.contextType = ViewContextType;
    return BaseComponent;
}(PureComponent);
function addPropsEquality(propEquality) {
    var hash = Object.create(this.prototype.propEquality);
    (0, $4nqhV.__assign)(hash, propEquality);
    this.prototype.propEquality = hash;
}
function addStateEquality(stateEquality) {
    var hash = Object.create(this.prototype.stateEquality);
    (0, $4nqhV.__assign)(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function setRef(ref, current) {
    if (typeof ref === "function") ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ var DateComponent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DateComponent, _super);
    function DateComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uid = guid();
        return _this;
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.prepareHits = function() {};
    DateComponent.prototype.queryHit = function(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    };
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.isValidSegDownEl = function(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !elementClosest(el, ".fc-event-mirror");
    };
    DateComponent.prototype.isValidDateDownEl = function(el) {
        return !elementClosest(el, ".fc-event:not(.fc-bg-event)") && !elementClosest(el, ".fc-more-link") && // a "more.." link
        !elementClosest(el, "a[data-navlink]") && // a clickable nav link
        !elementClosest(el, ".fc-popover"); // hack
    };
    return DateComponent;
}(BaseComponent);
// TODO: easier way to add new hooks? need to update a million things
function createPlugin(input) {
    return {
        id: guid(),
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || "",
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        contentTypeHandlers: input.contentTypeHandlers || {},
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function buildPluginHooks(pluginDefs, globalDefs) {
    var isAdded = {};
    var hooks = {
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: "",
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        contentTypeHandlers: {},
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for(var _i = 0, defs_1 = defs; _i < defs_1.length; _i++){
            var def = defs_1[_i];
            if (!isAdded[def.id]) {
                isAdded[def.id] = true;
                addDefs(def.deps);
                hooks = combineHooks(hooks, def);
            }
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function buildBuildPluginHooks() {
    var currentOverrideDefs = [];
    var currentGlobalDefs = [];
    var currentHooks;
    return function(overrideDefs, globalDefs) {
        if (!currentHooks || !isArraysEqual(overrideDefs, currentOverrideDefs) || !isArraysEqual(globalDefs, currentGlobalDefs)) currentHooks = buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function combineHooks(hooks0, hooks1) {
    return {
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        contentTypeHandlers: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.contentTypeHandlers), hooks1.contentTypeHandlers),
        listenerRefiners: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
var StandardTheme = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(StandardTheme, _super);
    function StandardTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardTheme;
}(Theme);
StandardTheme.prototype.classes = {
    root: "fc-theme-standard",
    tableCellShaded: "fc-cell-shaded",
    buttonGroup: "fc-button-group",
    button: "fc-button fc-button-primary",
    buttonActive: "fc-button-active"
};
StandardTheme.prototype.baseIconClass = "fc-icon";
StandardTheme.prototype.iconClasses = {
    close: "fc-icon-x",
    prev: "fc-icon-chevron-left",
    next: "fc-icon-chevron-right",
    prevYear: "fc-icon-chevrons-left",
    nextYear: "fc-icon-chevrons-right"
};
StandardTheme.prototype.rtlIconClasses = {
    prev: "fc-icon-chevron-right",
    next: "fc-icon-chevron-left",
    prevYear: "fc-icon-chevrons-right",
    nextYear: "fc-icon-chevrons-left"
};
StandardTheme.prototype.iconOverrideOption = "buttonIcons"; // TODO: make TS-friendly
StandardTheme.prototype.iconOverrideCustomButtonOption = "icon";
StandardTheme.prototype.iconOverridePrefix = "fc-icon-";
function compileViewDefs(defaultConfigs, overrideConfigs) {
    var hash = {};
    var viewType;
    for(viewType in defaultConfigs)ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    var viewDef = buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    var defaultConfig = defaultConfigs[viewType];
    var overrideConfig = overrideConfigs[viewType];
    var queryProp = function(name) {
        return defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    };
    var theComponent = queryProp("component");
    var superType = queryProp("superType");
    var superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error("Can't have a custom view type that references itself");
        superDef = ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
/* eslint max-classes-per-file: off */ // NOTE: in JSX, you should always use this class with <HookProps> arg. otherwise, will default to any???
var RenderHook = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(RenderHook, _super);
    function RenderHook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = (0, $3jFHS.createRef)();
        _this.handleRootEl = function(el) {
            setRef(_this.rootElRef, el);
            if (_this.props.elRef) setRef(_this.props.elRef, el);
        };
        return _this;
    }
    RenderHook.prototype.render = function() {
        var _this = this;
        var props = this.props;
        var hookProps = props.hookProps;
        return (0, $3jFHS.createElement)(MountHook, {
            hookProps: hookProps,
            didMount: props.didMount,
            willUnmount: props.willUnmount,
            elRef: this.handleRootEl
        }, function(rootElRef) {
            return (0, $3jFHS.createElement)(ContentHook, {
                hookProps: hookProps,
                content: props.content,
                defaultContent: props.defaultContent,
                backupElRef: _this.rootElRef
            }, function(innerElRef, innerContent) {
                return props.children(rootElRef, normalizeClassNames(props.classNames, hookProps), innerElRef, innerContent);
            });
        });
    };
    return RenderHook;
}(BaseComponent);
// TODO: rename to be about function, not default. use in above type
// for forcing rerender of components that use the ContentHook
var CustomContentRenderContext = (0, $3jFHS.createContext)(0);
function ContentHook(props) {
    return (0, $3jFHS.createElement)(CustomContentRenderContext.Consumer, null, function(renderId) {
        return (0, $3jFHS.createElement)(ContentHookInner, (0, $4nqhV.__assign)({
            renderId: renderId
        }, props));
    });
}
var ContentHookInner = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ContentHookInner, _super);
    function ContentHookInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerElRef = (0, $3jFHS.createRef)();
        return _this;
    }
    ContentHookInner.prototype.render = function() {
        return this.props.children(this.innerElRef, this.renderInnerContent());
    };
    ContentHookInner.prototype.componentDidMount = function() {
        this.updateCustomContent();
    };
    ContentHookInner.prototype.componentDidUpdate = function() {
        this.updateCustomContent();
    };
    ContentHookInner.prototype.componentWillUnmount = function() {
        if (this.customContentInfo && this.customContentInfo.destroy) this.customContentInfo.destroy();
    };
    ContentHookInner.prototype.renderInnerContent = function() {
        var customContentInfo = this.customContentInfo; // only populated if using non-[p]react node(s)
        var innerContent = this.getInnerContent();
        var meta = this.getContentMeta(innerContent);
        // initial run, or content-type changing? (from vue -> react for example)
        if (!customContentInfo || customContentInfo.contentKey !== meta.contentKey) {
            // clearing old value
            if (customContentInfo) {
                if (customContentInfo.destroy) customContentInfo.destroy();
                customContentInfo = this.customContentInfo = null;
            }
            // assigning new value
            if (meta.contentKey) customContentInfo = this.customContentInfo = (0, $4nqhV.__assign)({
                contentKey: meta.contentKey,
                contentVal: innerContent[meta.contentKey]
            }, meta.buildLifecycleFuncs());
        // updating
        } else if (customContentInfo) customContentInfo.contentVal = innerContent[meta.contentKey];
        return customContentInfo ? [] // signal that something was specified
         : innerContent; // assume a [p]react vdom node. use it
    };
    ContentHookInner.prototype.getInnerContent = function() {
        var props = this.props;
        var innerContent = normalizeContent(props.content, props.hookProps);
        if (innerContent === undefined) innerContent = normalizeContent(props.defaultContent, props.hookProps);
        return innerContent == null ? null : innerContent; // convert undefined to null (better for React)
    };
    ContentHookInner.prototype.getContentMeta = function(innerContent) {
        var contentTypeHandlers = this.context.pluginHooks.contentTypeHandlers;
        var contentKey = "";
        var buildLifecycleFuncs = null;
        if (innerContent) {
            for(var searchKey in contentTypeHandlers)if (innerContent[searchKey] !== undefined) {
                contentKey = searchKey;
                buildLifecycleFuncs = contentTypeHandlers[searchKey];
                break;
            }
        }
        return {
            contentKey: contentKey,
            buildLifecycleFuncs: buildLifecycleFuncs
        };
    };
    ContentHookInner.prototype.updateCustomContent = function() {
        if (this.customContentInfo) this.customContentInfo.render(this.innerElRef.current || this.props.backupElRef.current, this.customContentInfo.contentVal);
    };
    return ContentHookInner;
}(BaseComponent);
var MountHook = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(MountHook, _super);
    function MountHook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function(rootEl) {
            _this.rootEl = rootEl;
            if (_this.props.elRef) setRef(_this.props.elRef, rootEl);
        };
        return _this;
    }
    MountHook.prototype.render = function() {
        return this.props.children(this.handleRootEl);
    };
    MountHook.prototype.componentDidMount = function() {
        var callback = this.props.didMount;
        if (callback) callback((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, this.props.hookProps), {
            el: this.rootEl
        }));
    };
    MountHook.prototype.componentWillUnmount = function() {
        var callback = this.props.willUnmount;
        if (callback) callback((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, this.props.hookProps), {
            el: this.rootEl
        }));
    };
    return MountHook;
}(BaseComponent);
function buildClassNameNormalizer() {
    var currentGenerator;
    var currentHookProps;
    var currentClassNames = [];
    return function(generator, hookProps) {
        if (!currentHookProps || !isPropsEqual(currentHookProps, hookProps) || generator !== currentGenerator) {
            currentGenerator = generator;
            currentHookProps = hookProps;
            currentClassNames = normalizeClassNames(generator, hookProps);
        }
        return currentClassNames;
    };
}
function normalizeClassNames(classNames, hookProps) {
    if (typeof classNames === "function") classNames = classNames(hookProps);
    return parseClassNames(classNames);
}
function normalizeContent(input, hookProps) {
    if (typeof input === "function") return input(hookProps, (0, $3jFHS.createElement)); // give the function the vdom-creation func
    return input;
}
var ViewRoot = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ViewRoot, _super);
    function ViewRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.normalizeClassNames = buildClassNameNormalizer();
        return _this;
    }
    ViewRoot.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = {
            view: context.viewApi
        };
        var customClassNames = this.normalizeClassNames(options.viewClassNames, hookProps);
        return (0, $3jFHS.createElement)(MountHook, {
            hookProps: hookProps,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount,
            elRef: props.elRef
        }, function(rootElRef) {
            return props.children(rootElRef, [
                "fc-" + props.viewSpec.type + "-view",
                "fc-view"
            ].concat(customClassNames));
        });
    };
    return ViewRoot;
}(BaseComponent);
function parseViewConfigs(inputs) {
    return mapHash(inputs, parseViewConfig);
}
function parseViewConfig(input) {
    var rawOptions = typeof input === "function" ? {
        component: input
    } : input;
    var component = rawOptions.component;
    if (rawOptions.content) component = createViewHookComponent(rawOptions);
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function createViewHookComponent(options) {
    return function(viewProps) {
        return (0, $3jFHS.createElement)(ViewContextType.Consumer, null, function(context) {
            return (0, $3jFHS.createElement)(ViewRoot, {
                viewSpec: context.viewSpec
            }, function(viewElRef, viewClassNames) {
                var hookProps = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                });
                return (0, $3jFHS.createElement)(RenderHook, {
                    hookProps: hookProps,
                    classNames: options.classNames,
                    content: options.content,
                    didMount: options.didMount,
                    willUnmount: options.willUnmount,
                    elRef: viewElRef
                }, function(rootElRef, customClassNames, innerElRef, innerContent) {
                    return (0, $3jFHS.createElement)("div", {
                        className: viewClassNames.concat(customClassNames).join(" "),
                        ref: rootElRef
                    }, innerContent);
                });
            });
        });
    };
}
function buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var defaultConfigs = parseViewConfigs(defaultInputs);
    var overrideConfigs = parseViewConfigs(optionOverrides.views);
    var viewDefs = compileViewDefs(defaultConfigs, overrideConfigs);
    return mapHash(viewDefs, function(viewDef) {
        return buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults);
    });
}
function buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    var duration = null;
    var durationUnit = "";
    var singleUnit = "";
    var singleUnitOverrides = {};
    if (durationInput) {
        duration = createDurationCached(durationInput);
        if (duration) {
            var denom = greatestDurationDenominator(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    var queryButtonText = function(optionsSubset) {
        var buttonTextMap = optionsSubset.buttonText || {};
        var buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    var queryButtonTitle = function(optionsSubset) {
        var buttonHints = optionsSubset.buttonHints || {};
        var buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText(BASE_OPTION_DEFAULTS) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle(BASE_OPTION_DEFAULTS)
    };
}
// hack to get memoization working
var durationInputMap = {};
function createDurationCached(durationInput) {
    var json = JSON.stringify(durationInput);
    var res = durationInputMap[json];
    if (res === undefined) {
        res = createDuration(durationInput);
        durationInputMap[json] = res;
    }
    return res;
}
var DateProfileGenerator = /** @class */ function() {
    function DateProfileGenerator(props) {
        this.props = props;
        this.nowDate = getNow(props.nowInput, props.dateEnv);
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    DateProfileGenerator.prototype.buildPrev = function(currentDateProfile, currentDate, forceToValid) {
        var dateEnv = this.props.dateEnv;
        var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    };
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    DateProfileGenerator.prototype.buildNext = function(currentDateProfile, currentDate, forceToValid) {
        var dateEnv = this.props.dateEnv;
        var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    };
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    DateProfileGenerator.prototype.build = function(currentDate, direction, forceToValid) {
        if (forceToValid === void 0) forceToValid = true;
        var props = this.props;
        var validRange;
        var currentInfo;
        var isRangeAllDay;
        var renderRange;
        var activeRange;
        var isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = intersectRanges(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = intersectRanges(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = rangesIntersect(currentInfo.range, validRange);
        return {
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange: validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange: activeRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange: renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    };
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildValidRange = function() {
        var input = this.props.validRangeInput;
        var simpleInput = typeof input === "function" ? input.call(this.props.calendarApi, this.nowDate) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    };
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    DateProfileGenerator.prototype.buildCurrentRangeInfo = function(date, direction) {
        var props = this.props;
        var duration = null;
        var unit = null;
        var range = null;
        var dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = "day";
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = greatestDurationDenominator(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    };
    DateProfileGenerator.prototype.getFallbackDuration = function() {
        return createDuration({
            day: 1
        });
    };
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    DateProfileGenerator.prototype.adjustActiveRange = function(range) {
        var _a = this.props, dateEnv = _a.dateEnv, usesMinMaxTime = _a.usesMinMaxTime, slotMinTime = _a.slotMinTime, slotMaxTime = _a.slotMaxTime;
        var start = range.start, end = range.end;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if (asRoughDays(slotMinTime) < 0) {
                start = startOfDay(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if (asRoughDays(slotMaxTime) > 1) {
                end = startOfDay(end); // necessary?
                end = addDays(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    };
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    DateProfileGenerator.prototype.buildRangeFromDuration = function(date, direction, duration, unit) {
        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
        var start;
        var end;
        var res;
        // compute what the alignment should be
        if (!dateAlignment) {
            var dateIncrement = this.props.dateIncrement;
            if (dateIncrement) {
                // use the smaller of the two units
                if (asRoughMs(dateIncrement) < asRoughMs(duration)) dateAlignment = greatestDurationDenominator(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if (asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = startOfDay(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    };
    // Builds the "current" range when a dayCount is specified.
    DateProfileGenerator.prototype.buildRangeFromDayCount = function(date, direction, dayCount) {
        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
        var runningCount = 0;
        var start = date;
        var end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = startOfDay(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = addDays(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    };
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    DateProfileGenerator.prototype.buildCustomVisibleRange = function(date) {
        var props = this.props;
        var input = props.visibleRangeInput;
        var simpleInput = typeof input === "function" ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        var range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    };
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildRenderRange = function(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    };
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    DateProfileGenerator.prototype.buildDateIncrement = function(fallback) {
        var dateIncrement = this.props.dateIncrement;
        var customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return createDuration(1, customAlignment);
        if (fallback) return fallback;
        return createDuration({
            days: 1
        });
    };
    DateProfileGenerator.prototype.refineRange = function(rangeInput) {
        if (rangeInput) {
            var range = parseRange(rangeInput, this.props.dateEnv);
            if (range) range = computeVisibleDayRange(range);
            return range;
        }
        return null;
    };
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    DateProfileGenerator.prototype.initHiddenDays = function() {
        var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        var dayCnt = 0;
        var i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error("invalid hiddenDays"); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    };
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    DateProfileGenerator.prototype.trimHiddenDays = function(range) {
        var start = range.start, end = range.end;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    };
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    DateProfileGenerator.prototype.isHiddenDay = function(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    };
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    DateProfileGenerator.prototype.skipHiddenDays = function(date, inc, isExclusive) {
        if (inc === void 0) inc = 1;
        if (isExclusive === void 0) isExclusive = false;
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = addDays(date, inc);
        return date;
    };
    return DateProfileGenerator;
}();
function reduceViewType(viewType, action) {
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            viewType = action.viewType;
    }
    return viewType;
}
function reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    var _a;
    switch(action.type){
        case "SET_OPTION":
            return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, dynamicOptionOverrides), (_a = {}, _a[action.optionName] = action.rawOptionValue, _a));
        default:
            return dynamicOptionOverrides;
    }
}
function reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    var dp;
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case "CHANGE_DATE":
            return dateProfileGenerator.build(action.dateMarker);
        case "PREV":
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case "NEXT":
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function initEventSources(calendarOptions, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null;
    return addSources({}, parseInitialSources(calendarOptions, context), activeRange, context);
}
function reduceEventSources(eventSources, action, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case "ADD_EVENT_SOURCES":
            return addSources(eventSources, action.sources, activeRange, context);
        case "REMOVE_EVENT_SOURCE":
            return removeSource(eventSources, action.sourceId);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case "FETCH_EVENT_SOURCES":
            return fetchSourcesByIds(eventSources, action.sourceIds ? arrayToHash(action.sourceIds) : excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case "RECEIVE_EVENTS":
        case "RECEIVE_EVENT_ERROR":
            return receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case "REMOVE_ALL_EVENT_SOURCES":
            return {};
        default:
            return eventSources;
    }
}
function reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return fetchSourcesByIds(eventSources, excludeStaticSources(eventSources, context), activeRange, true, context);
}
function computeEventSourcesLoading(eventSources) {
    for(var sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function addSources(eventSourceHash, sources, fetchRange, context) {
    var hash = {};
    for(var _i = 0, sources_1 = sources; _i < sources_1.length; _i++){
        var source = sources_1[_i];
        hash[source.sourceId] = source;
    }
    if (fetchRange) hash = fetchDirtySources(hash, fetchRange, context);
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventSourceHash), hash);
}
function removeSource(eventSourceHash, sourceId) {
    return filterHash(eventSourceHash, function(eventSource) {
        return eventSource.sourceId !== sourceId;
    });
}
function fetchDirtySources(sourceHash, fetchRange, context) {
    return fetchSourcesByIds(sourceHash, filterHash(sourceHash, function(eventSource) {
        return isSourceDirty(eventSource, fetchRange, context);
    }), fetchRange, false, context);
}
function isSourceDirty(eventSource, fetchRange, context) {
    if (!doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    var nextSources = {};
    for(var sourceId in prevSources){
        var source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function fetchSource(eventSource, fetchRange, isRefetch, context) {
    var options = context.options, calendarApi = context.calendarApi;
    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    var fetchId = guid();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, function(res) {
        var rawEvents = res.rawEvents;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.xhr) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.xhr) || rawEvents;
        context.dispatch({
            type: "RECEIVE_EVENTS",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, function(error) {
        console.warn(error.message, error);
        if (options.eventSourceFailure) options.eventSourceFailure.call(calendarApi, error);
        if (eventSource.failure) eventSource.failure(error);
        context.dispatch({
            type: "RECEIVE_EVENT_ERROR",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    var _a;
    var eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, sourceHash), (_a = {}, _a[sourceId] = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventSource), {
        isFetching: false,
        fetchRange: fetchRange
    }), _a));
    return sourceHash;
}
function excludeStaticSources(eventSources, context) {
    return filterHash(eventSources, function(eventSource) {
        return doesSourceNeedRange(eventSource, context);
    });
}
function parseInitialSources(rawOptions, context) {
    var refiners = buildEventSourceRefiners(context);
    var rawSources = [].concat(rawOptions.eventSources || []);
    var sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for(var _i = 0, rawSources_1 = rawSources; _i < rawSources_1.length; _i++){
        var rawSource = rawSources_1[_i];
        var source = parseEventSource(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function doesSourceNeedRange(eventSource, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function reduceEventStore(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case "RECEIVE_EVENTS":
            return receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case "ADD_EVENTS":
            return addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case "RESET_EVENTS":
            return action.eventStore;
        case "MERGE_EVENTS":
            return mergeEventStores(eventStore, action.eventStore);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case "REMOVE_EVENTS":
            return excludeSubEventStore(eventStore, action.eventStore);
        case "REMOVE_EVENT_SOURCE":
            return excludeEventsBySourceId(eventStore, action.sourceId);
        case "REMOVE_ALL_EVENT_SOURCES":
            return filterEventStoreDefs(eventStore, function(eventDef) {
                return !eventDef.sourceId // only keep events with no source id
                ;
            });
        case "REMOVE_ALL_EVENTS":
            return createEmptyEventStore();
        default:
            return eventStore;
    }
}
function receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        var subset = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = expandRecurring(subset, fetchRange, context);
        return mergeEventStores(excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function transformRawEvents(rawEvents, eventSource, context) {
    var calEachTransform = context.options.eventDataTransform;
    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function transformEachRawEvent(rawEvents, func) {
    var refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for(var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++){
            var rawEvent = rawEvents_1[_i];
            var refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = expandRecurring(subset, expandRange, context);
    return mergeEventStores(eventStore, subset);
}
function rezoneEventStoreDates(eventStore, oldDateEnv, newDateEnv) {
    var defs = eventStore.defs;
    var instances = mapHash(eventStore.instances, function(instance) {
        var def = defs[instance.defId];
        if (def.allDay || def.recurringDef) return instance; // isn't dependent on timezone
        return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function excludeEventsBySourceId(eventStore, sourceId) {
    return filterEventStoreDefs(eventStore, function(eventDef) {
        return eventDef.sourceId !== sourceId;
    });
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: filterHash(eventStore.instances, function(instance) {
            return !removals[instance.instanceId];
        })
    };
}
function reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case "UNSELECT_DATES":
            return null;
        case "SELECT_DATES":
            return action.selection;
        default:
            return currentSelection;
    }
}
function reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case "UNSELECT_EVENT":
            return "";
        case "SELECT_EVENT":
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function reduceEventDrag(currentDrag, action) {
    var newDrag;
    switch(action.type){
        case "UNSET_EVENT_DRAG":
            return null;
        case "SET_EVENT_DRAG":
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function reduceEventResize(currentResize, action) {
    var newResize;
    switch(action.type){
        case "UNSET_EVENT_RESIZE":
            return null;
        case "SET_EVENT_RESIZE":
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var header = calendarOptions.headerToolbar ? parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    var footer = calendarOptions.footerToolbar ? parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var sectionWidgets = {};
    var viewsWithButtons = [];
    var hasTitle = false;
    for(var sectionName in sectionStrHash){
        var sectionStr = sectionStrHash[sectionName];
        var sectionRes = parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push.apply(viewsWithButtons, sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var isRtl = calendarOptions.direction === "rtl";
    var calendarCustomButtons = calendarOptions.customButtons || {};
    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    var calendarButtonText = calendarOptions.buttonText || {};
    var calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    var calendarButtonHints = calendarOptions.buttonHints || {};
    var sectionSubstrs = sectionStr ? sectionStr.split(" ") : [];
    var viewsWithButtons = [];
    var hasTitle = false;
    var widgets = sectionSubstrs.map(function(buttonGroupStr) {
        return buttonGroupStr.split(",").map(function(buttonName) {
            if (buttonName === "title") {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            var customButtonProps;
            var viewSpec;
            var buttonClick;
            var buttonIcon; // only one of these will be set
            var buttonText; // "
            var buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = function(ev) {
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = function() {
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                var textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = formatWithOrdinals(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = function() {
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === "prevYear" || buttonName === "nextYear") {
                    var prevOrNext = buttonName === "prevYear" ? "prev" : "next";
                    buttonHint = formatWithOrdinals(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || "year",
                        "year"
                    ], calendarButtonText[buttonName]);
                } else buttonHint = function(navUnit) {
                    return formatWithOrdinals(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
                };
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        });
    });
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
var eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta: function(refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch: function(arg, success) {
        success({
            rawEvents: arg.eventSource.meta
        });
    }
};
var arrayEventSourcePlugin = createPlugin({
    eventSourceDefs: [
        eventSourceDef$2
    ]
});
var eventSourceDef$1 = {
    parseMeta: function(refined) {
        if (typeof refined.events === "function") return refined.events;
        return null;
    },
    fetch: function(arg, success, failure) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.eventSource.meta;
        unpromisify(func.bind(null, buildRangeApiWithTimeZone(arg.range, dateEnv)), function(rawEvents) {
            success({
                rawEvents: rawEvents
            }); // needs an object response
        }, failure);
    }
};
var funcEventSourcePlugin = createPlugin({
    eventSourceDefs: [
        eventSourceDef$1
    ]
});
function requestJson(method, url, params, successCallback, failureCallback) {
    method = method.toUpperCase();
    var body = null;
    if (method === "GET") url = injectQueryStringParams(url, params);
    else body = encodeParams(params);
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    if (method !== "GET") xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 400) {
            var parsed = false;
            var res = void 0;
            try {
                res = JSON.parse(xhr.responseText);
                parsed = true;
            } catch (err) {
            // will handle parsed=false
            }
            if (parsed) successCallback(res, xhr);
            else failureCallback("Failure parsing JSON", xhr);
        } else failureCallback("Request failed", xhr);
    };
    xhr.onerror = function() {
        failureCallback("Request failed", xhr);
    };
    xhr.send(body);
}
function injectQueryStringParams(url, params) {
    return url + (url.indexOf("?") === -1 ? "?" : "&") + encodeParams(params);
}
function encodeParams(params) {
    var parts = [];
    for(var key in params)parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    return parts.join("&");
}
var JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: identity,
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
var eventSourceDef = {
    parseMeta: function(refined) {
        if (refined.url && (refined.format === "json" || !refined.format)) return {
            url: refined.url,
            format: "json",
            method: (refined.method || "GET").toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch: function(arg, success, failure) {
        var meta = arg.eventSource.meta;
        var requestParams = buildRequestParams(meta, arg.range, arg.context);
        requestJson(meta.method, meta.url, requestParams, function(rawEvents, xhr) {
            success({
                rawEvents: rawEvents,
                xhr: xhr
            });
        }, function(errorMessage, xhr) {
            failure({
                message: errorMessage,
                xhr: xhr
            });
        });
    }
};
var jsonFeedEventSourcePlugin = createPlugin({
    eventSourceRefiners: JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        eventSourceDef
    ]
});
function buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === "function") // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    (0, $4nqhV.__assign)(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== "local") params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
var SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: identity,
    startTime: createDuration,
    endTime: createDuration,
    duration: createDuration,
    startRecur: identity,
    endRecur: identity
};
var recurring = {
    parse: function(refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            var recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null
            };
            var duration = void 0;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = subtractDurations(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand: function(typeData, framingRange, dateEnv) {
        var clippedFramingRange = intersectRanges(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
        return [];
    }
};
var simpleRecurringEventsPlugin = createPlugin({
    recurringTypes: [
        recurring
    ],
    eventRefiners: SIMPLE_RECURRING_REFINERS
});
function expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
    var dowHash = daysOfWeek ? arrayToHash(daysOfWeek) : null;
    var dayMarker = startOfDay(framingRange.start);
    var endMarker = framingRange.end;
    var instanceStarts = [];
    while(dayMarker < endMarker){
        var instanceStart = void 0;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = dateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(instanceStart);
        }
        dayMarker = addDays(dayMarker, 1);
    }
    return instanceStarts;
}
var changeHandlerPlugin = createPlugin({
    optionChangeHandlers: {
        events: function(events, context) {
            handleEventSources([
                events
            ], context);
        },
        eventSources: handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function handleEventSources(inputs, context) {
    var unfoundSources = hashValuesToArray(context.getCurrentData().eventSources);
    var newInputs = [];
    for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
        var input = inputs_1[_i];
        var inputFound = false;
        for(var i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for(var _a = 0, unfoundSources_1 = unfoundSources; _a < unfoundSources_1.length; _a++){
        var unfoundSource = unfoundSources_1[_a];
        context.dispatch({
            type: "REMOVE_EVENT_SOURCE",
            sourceId: unfoundSource.sourceId
        });
    }
    for(var _b = 0, newInputs_1 = newInputs; _b < newInputs_1.length; _b++){
        var newInput = newInputs_1[_b];
        context.calendarApi.addEventSource(newInput);
    }
}
function handleDateProfile(dateProfile, context) {
    context.emitter.trigger("datesSet", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, buildRangeApiWithTimeZone(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function handleEventStore(eventStore, context) {
    var emitter = context.emitter;
    if (emitter.hasHandlers("eventsSet")) emitter.trigger("eventsSet", buildEventApis(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ var globalPlugins = [
    arrayEventSourcePlugin,
    funcEventSourcePlugin,
    jsonFeedEventSourcePlugin,
    simpleRecurringEventsPlugin,
    changeHandlerPlugin,
    createPlugin({
        isLoadingFuncs: [
            function(state) {
                return computeEventSourcesLoading(state.eventSources);
            }
        ],
        contentTypeHandlers: {
            html: buildHtmlRenderer,
            domNodes: buildDomNodeRenderer
        },
        propSetHandlers: {
            dateProfile: handleDateProfile,
            eventStore: handleEventStore
        }
    })
];
function buildHtmlRenderer() {
    var currentEl = null;
    var currentHtml = "";
    function render(el, html) {
        if (el !== currentEl || html !== currentHtml) el.innerHTML = html;
        currentEl = el;
        currentHtml = html;
    }
    function destroy() {
        currentEl.innerHTML = "";
        currentEl = null;
        currentHtml = "";
    }
    return {
        render: render,
        destroy: destroy
    };
}
function buildDomNodeRenderer() {
    var currentEl = null;
    var currentDomNodes = [];
    function render(el, domNodes) {
        var newDomNodes = Array.prototype.slice.call(domNodes);
        if (el !== currentEl || !isArraysEqual(currentDomNodes, newDomNodes)) {
            // append first, remove second (for scroll resetting)
            for(var _i = 0, newDomNodes_1 = newDomNodes; _i < newDomNodes_1.length; _i++){
                var newNode = newDomNodes_1[_i];
                el.appendChild(newNode);
            }
            destroy();
        }
        currentEl = el;
        currentDomNodes = newDomNodes;
    }
    function destroy() {
        currentDomNodes.forEach(removeElement);
        currentDomNodes = [];
        currentEl = null;
    }
    return {
        render: render,
        destroy: destroy
    };
}
var DelayedRunner = /** @class */ function() {
    function DelayedRunner(drainedOption) {
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    DelayedRunner.prototype.request = function(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    };
    DelayedRunner.prototype.pause = function(scope) {
        if (scope === void 0) scope = "";
        var pauseDepths = this.pauseDepths;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    };
    DelayedRunner.prototype.resume = function(scope, force) {
        if (scope === void 0) scope = "";
        var pauseDepths = this.pauseDepths;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                var depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    };
    DelayedRunner.prototype.isPaused = function() {
        return Object.keys(this.pauseDepths).length;
    };
    DelayedRunner.prototype.tryDrain = function() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    };
    DelayedRunner.prototype.clear = function() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    };
    DelayedRunner.prototype.clearTimeout = function() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    };
    DelayedRunner.prototype.drained = function() {
        if (this.drainedOption) this.drainedOption();
    };
    return DelayedRunner;
}();
var TaskRunner = /** @class */ function() {
    function TaskRunner(runTaskOption, drainedOption) {
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new DelayedRunner(this.drain.bind(this));
    }
    TaskRunner.prototype.request = function(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    };
    TaskRunner.prototype.pause = function(scope) {
        this.delayedRunner.pause(scope);
    };
    TaskRunner.prototype.resume = function(scope, force) {
        this.delayedRunner.resume(scope, force);
    };
    TaskRunner.prototype.drain = function() {
        var queue = this.queue;
        while(queue.length){
            var completedTasks = [];
            var task = void 0;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    };
    TaskRunner.prototype.runTask = function(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    };
    TaskRunner.prototype.drained = function(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    };
    return TaskRunner;
}();
// Computes what the title at the top of the calendarApi should be for this view
function buildTitle(dateProfile, viewOptions, dateEnv) {
    var range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, createFormatter(viewOptions.titleFormat || buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function buildTitleFormat(dateProfile) {
    var currentRangeUnit = dateProfile.currentRangeUnit;
    if (currentRangeUnit === "year") return {
        year: "numeric"
    };
    if (currentRangeUnit === "month") return {
        year: "numeric",
        month: "long"
    }; // like "September 2014"
    var days = diffWholeDays(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    // one day. longer, like "September 9 2014"
    return {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
var CalendarDataManager = /** @class */ function() {
    function CalendarDataManager(props) {
        var _this = this;
        this.computeOptionsData = memoize(this._computeOptionsData);
        this.computeCurrentViewData = memoize(this._computeCurrentViewData);
        this.organizeRawLocales = memoize(organizeRawLocales);
        this.buildLocale = memoize(buildLocale);
        this.buildPluginHooks = buildBuildPluginHooks();
        this.buildDateEnv = memoize(buildDateEnv);
        this.buildTheme = memoize(buildTheme);
        this.parseToolbars = memoize(parseToolbars);
        this.buildViewSpecs = memoize(buildViewSpecs);
        this.buildDateProfileGenerator = memoizeObjArg(buildDateProfileGenerator);
        this.buildViewApi = memoize(buildViewApi);
        this.buildViewUiProps = memoizeObjArg(buildViewUiProps);
        this.buildEventUiBySource = memoize(buildEventUiBySource, isPropsEqual);
        this.buildEventUiBases = memoize(buildEventUiBases);
        this.parseContextBusinessHours = memoizeObjArg(parseContextBusinessHours);
        this.buildTitle = memoize(buildTitle);
        this.emitter = new Emitter();
        this.actionRunner = new TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.getCurrentData = function() {
            return _this.data;
        };
        this.dispatch = function(action) {
            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        var dynamicOptionOverrides = {};
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        var currentDate = getInitialDate(optionsData.calendarOptions, optionsData.dateEnv);
        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!rangeContainsMarker(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        // needs to be after setThisContext
        for(var _i = 0, _a = optionsData.pluginHooks.contextInit; _i < _a.length; _i++){
            var callback = _a[_i];
            callback(calendarContext);
        }
        // NOT DRY
        var eventSources = initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        var initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: createEmptyEventStore(),
            renderableEventStore: createEmptyEventStore(),
            dateSelection: null,
            eventSelection: "",
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        var contextAndState = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, calendarContext), initialState);
        for(var _b = 0, _c = optionsData.pluginHooks.reducers; _b < _c.length; _b++){
            var reducer = _c[_b];
            (0, $4nqhV.__assign)(initialState, reducer(null, null, contextAndState));
        }
        if (computeIsLoading(initialState, calendarContext)) this.emitter.trigger("loading", true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    CalendarDataManager.prototype.resetOptions = function(optionOverrides, append) {
        var props = this.props;
        props.optionOverrides = append ? (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, props.optionOverrides), optionOverrides) : optionOverrides;
        this.actionRunner.request({
            type: "NOTHING"
        });
    };
    CalendarDataManager.prototype._handleAction = function(action) {
        var _a = this, props = _a.props, state = _a.state, emitter = _a.emitter;
        var dynamicOptionOverrides = reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = reduceViewType(state.currentViewType, action);
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        var currentDate = state.currentDate, dateProfile = state.dateProfile;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = reduceCurrentDate(currentDate, action);
        dateProfile = reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === "PREV" || // TODO: move this logic into DateProfileGenerator
        action.type === "NEXT" || // "
        !rangeContainsMarker(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        var eventSources = reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        var eventStore = reduceEventStore(state.eventStore, action, eventSources, dateProfile, calendarContext);
        var isEventsLoading = computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        var renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        var _b = this.buildViewUiProps(calendarContext), eventUiSingleBase = _b.eventUiSingleBase, selectionConfig = _b.selectionConfig; // will memoize obj
        var eventUiBySource = this.buildEventUiBySource(eventSources);
        var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        var newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: reduceDateSelection(state.dateSelection, action),
            eventSelection: reduceSelectedEvent(state.eventSelection, action),
            eventDrag: reduceEventDrag(state.eventDrag, action),
            eventResize: reduceEventResize(state.eventResize, action)
        };
        var contextAndState = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, calendarContext), newState);
        for(var _i = 0, _c = optionsData.pluginHooks.reducers; _i < _c.length; _i++){
            var reducer = _c[_i];
            (0, $4nqhV.__assign)(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        }
        var wasLoading = computeIsLoading(state, calendarContext);
        var isLoading = computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger("loading", true);
        else if (wasLoading && !isLoading) emitter.trigger("loading", false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    };
    CalendarDataManager.prototype.updateData = function() {
        var _a = this, props = _a.props, state = _a.state;
        var oldData = this.data;
        var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        var data = this.data = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        var oldCalendarOptions = oldData && oldData.calendarOptions;
        var newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = rezoneEventStoreDates(data.eventStore, oldData.dateEnv, data.dateEnv);
            }
            for(var optionName in changeHandlers)if (oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        if (props.onData) props.onData(data);
    };
    CalendarDataManager.prototype._computeOptionsData = function(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        var _a = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, pluginHooks = _a.pluginHooks, localeDefaults = _a.localeDefaults, availableLocaleData = _a.availableLocaleData, extra = _a.extra;
        warnUnknownOptions(extra);
        var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        var viewSpecs = this.buildViewSpecs(pluginHooks.views, optionOverrides, dynamicOptionOverrides, localeDefaults);
        var theme = this.buildTheme(refinedOptions, pluginHooks);
        var toolbarConfig = this.parseToolbars(refinedOptions, optionOverrides, theme, viewSpecs, calendarApi);
        return {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    };
    // always called from behind a memoizer
    CalendarDataManager.prototype.processRawCalendarOptions = function(optionOverrides, dynamicOptionOverrides) {
        var _a = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            optionOverrides,
            dynamicOptionOverrides
        ]), locales = _a.locales, locale = _a.locale;
        var availableLocaleData = this.organizeRawLocales(locales);
        var availableRawLocales = availableLocaleData.map;
        var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], globalPlugins);
        var refiners = this.currentCalendarOptionsRefiners = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        var extra = {};
        var raw = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        var refined = {};
        var currentRaw = this.currentCalendarOptionsInput;
        var currentRefined = this.currentCalendarOptionsRefined;
        var anyChanges = false;
        for(var optionName in raw)if (optionName !== "plugins") {
            if (raw[optionName] === currentRaw[optionName] || COMPLEX_OPTION_COMPARATORS[optionName] && optionName in currentRaw && COMPLEX_OPTION_COMPARATORS[optionName](currentRaw[optionName], raw[optionName])) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    };
    CalendarDataManager.prototype._computeCurrentViewData = function(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        var viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error('viewType "' + viewType + "\" is not available. Please make sure you've loaded all neccessary plugins");
        var _a = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, extra = _a.extra;
        warnUnknownOptions(extra);
        var dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            nowInput: refinedOptions.now,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            monthMode: refinedOptions.monthMode,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    };
    CalendarDataManager.prototype.processRawViewOptions = function(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        var raw = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        var refiners = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), VIEW_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        var refined = {};
        var currentRaw = this.currentViewOptionsInput;
        var currentRefined = this.currentViewOptionsRefined;
        var anyChanges = false;
        var extra = {};
        for(var optionName in raw)if (raw[optionName] === currentRaw[optionName] || COMPLEX_OPTION_COMPARATORS[optionName] && COMPLEX_OPTION_COMPARATORS[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || COMPLEX_OPTION_COMPARATORS[optionName] && COMPLEX_OPTION_COMPARATORS[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    };
    return CalendarDataManager;
}();
function buildDateEnv(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    var locale = buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new DateEnv({
        calendarSystem: "gregory",
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function buildTheme(options, pluginHooks) {
    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || StandardTheme;
    return new ThemeClass(options);
}
function buildDateProfileGenerator(props) {
    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || DateProfileGenerator;
    return new DateProfileGeneratorClass(props);
}
function buildViewApi(type, getCurrentData, dateEnv) {
    return new ViewApi(type, getCurrentData, dateEnv);
}
function buildEventUiBySource(eventSources) {
    return mapHash(eventSources, function(eventSource) {
        return eventSource.ui;
    });
}
function buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    var eventUiBases = {
        "": eventUiSingleBase
    };
    for(var defId in eventDefs){
        var def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function buildViewUiProps(calendarContext) {
    var options = calendarContext.options;
    return {
        eventUiSingleBase: createEventUi({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === "boolean" ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: createEventUi({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === "boolean" ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function computeIsLoading(state, context) {
    for(var _i = 0, _a = context.pluginHooks.isLoadingFuncs; _i < _a.length; _i++){
        var isLoadingFunc = _a[_i];
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function parseContextBusinessHours(calendarContext) {
    return parseBusinessHours(calendarContext.options.businessHours, calendarContext);
}
function warnUnknownOptions(options, viewName) {
    for(var optionName in options)console.warn("Unknown option '" + optionName + "'" + (viewName ? " for view '" + viewName + "'" : ""));
}
// TODO: move this to react plugin?
var CalendarDataProvider = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(CalendarDataProvider, _super);
    function CalendarDataProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleData = function(data) {
            if (!_this.dataManager) // eslint-disable-next-line react/no-direct-mutation-state
            _this.state = data; // can't use setState yet
            else _this.setState(data);
        };
        _this.dataManager = new CalendarDataManager({
            optionOverrides: props.optionOverrides,
            calendarApi: props.calendarApi,
            onData: _this.handleData
        });
        return _this;
    }
    CalendarDataProvider.prototype.render = function() {
        return this.props.children(this.state);
    };
    CalendarDataProvider.prototype.componentDidUpdate = function(prevProps) {
        var newOptionOverrides = this.props.optionOverrides;
        if (newOptionOverrides !== prevProps.optionOverrides) this.dataManager.resetOptions(newOptionOverrides);
    };
    return CalendarDataProvider;
}((0, $3jFHS.Component));
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function sliceEvents(props, allDay) {
    return sliceEventStore(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
var NamedTimeZoneImpl = /** @class */ function() {
    function NamedTimeZoneImpl(timeZoneName) {
        this.timeZoneName = timeZoneName;
    }
    return NamedTimeZoneImpl;
}();
var SegHierarchy = /** @class */ function() {
    function SegHierarchy() {
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    SegHierarchy.prototype.addSegs = function(inputs) {
        var hiddenEntries = [];
        for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
            var input = inputs_1[_i];
            this.insertEntry(input, hiddenEntries);
        }
        return hiddenEntries;
    };
    SegHierarchy.prototype.insertEntry = function(entry, hiddenEntries) {
        var insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) {
            this.insertEntryAt(entry, insertion);
            return 1;
        }
        return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    };
    SegHierarchy.prototype.isInsertionValid = function(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + entry.thickness <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    };
    // returns number of new entries inserted
    SegHierarchy.prototype.handleInvalidInsertion = function(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        hiddenEntries.push(entry);
        return 0;
    };
    SegHierarchy.prototype.splitEntry = function(entry, barrier, hiddenEntries) {
        var partCnt = 0;
        var splitHiddenEntries = [];
        var entrySpan = entry.span;
        var barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) partCnt += this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, splitHiddenEntries);
        if (entrySpan.end > barrierSpan.end) partCnt += this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, splitHiddenEntries);
        if (partCnt) {
            hiddenEntries.push.apply(hiddenEntries, (0, $4nqhV.__spreadArray)([
                {
                    index: entry.index,
                    thickness: entry.thickness,
                    span: intersectSpans(barrierSpan, entrySpan)
                }
            ], splitHiddenEntries));
            return partCnt;
        }
        hiddenEntries.push(entry);
        return 0;
    };
    SegHierarchy.prototype.insertEntryAt = function(entry, insertion) {
        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
        if (insertion.lateral === -1) {
            // create a new level
            insertAt(levelCoords, insertion.level, insertion.levelCoord);
            insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[buildEntryKey(entry)] = insertion.stackCnt;
    };
    SegHierarchy.prototype.findInsertion = function(newEntry) {
        var _a = this, levelCoords = _a.levelCoords, entriesByLevel = _a.entriesByLevel, strictOrder = _a.strictOrder, stackCnts = _a.stackCnts;
        var levelCnt = levelCoords.length;
        var candidateCoord = 0;
        var touchingLevel = -1;
        var touchingLateral = -1;
        var touchingEntry = null;
        var stackCnt = 0;
        for(var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            var trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + newEntry.thickness) break;
            var trackingEntries = entriesByLevel[trackingLevel];
            var trackingEntry = void 0;
            var searchRes = binarySearch(trackingEntries, newEntry.span.start, getEntrySpanEnd); // find first entry after newEntry's end
            var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                var trackingEntryBottom = trackingCoord + trackingEntry.thickness;
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[buildEntryKey(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        var destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        var destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = binarySearch(entriesByLevel[destLevel], newEntry.span.end, getEntrySpanEnd)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    };
    // sorted by levelCoord (lowest to highest)
    SegHierarchy.prototype.toRects = function() {
        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
        var levelCnt = entriesByLevel.length;
        var rects = [];
        for(var level = 0; level < levelCnt; level += 1){
            var entries = entriesByLevel[level];
            var levelCoord = levelCoords[level];
            for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
                var entry = entries_1[_i];
                rects.push((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, entry), {
                    levelCoord: levelCoord
                }));
            }
        }
        return rects;
    };
    return SegHierarchy;
}();
function getEntrySpanEnd(entry) {
    return entry.span.end;
}
function buildEntryKey(entry) {
    return entry.index + ":" + entry.span.start;
}
// returns groups with entries sorted by input order
function groupIntersectingEntries(entries) {
    var merges = [];
    for(var _i = 0, entries_2 = entries; _i < entries_2.length; _i++){
        var entry = entries_2[_i];
        var filteredMerges = [];
        var hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for(var _a = 0, merges_1 = merges; _a < merges_1.length; _a++){
            var merge = merges_1[_a];
            if (intersectSpans(merge.span, hungryMerge.span)) hungryMerge = {
                entries: merge.entries.concat(hungryMerge.entries),
                span: joinSpans(merge.span, hungryMerge.span)
            };
            else filteredMerges.push(merge);
        }
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function intersectSpans(span0, span1) {
    var start = Math.max(span0.start, span1.start);
    var end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function binarySearch(a, searchVal, getItemVal) {
    var startIndex = 0;
    var endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        var middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
var Interaction = /** @class */ function() {
    function Interaction(settings) {
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    Interaction.prototype.destroy = function() {};
    return Interaction;
}();
function parseInteractionSettings(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function interactionSettingsToStore(settings) {
    var _a;
    return _a = {}, _a[settings.component.uid] = settings, _a;
}
// global state
var interactionSettingsStore = {};
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ var ElementDragging = /** @class */ function() {
    function ElementDragging(el, selector) {
        this.emitter = new Emitter();
    }
    ElementDragging.prototype.destroy = function() {};
    ElementDragging.prototype.setMirrorIsVisible = function(bool) {
    // optional if subclass doesn't want to support a mirror
    };
    ElementDragging.prototype.setMirrorNeedsRevert = function(bool) {
    // optional if subclass doesn't want to support a mirror
    };
    ElementDragging.prototype.setAutoScrollEnabled = function(bool) {
    // optional
    };
    return ElementDragging;
}();
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
var config = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ var DRAG_META_REFINERS = {
    startTime: createDuration,
    duration: createDuration,
    create: Boolean,
    sourceId: String
};
function parseDragMeta(raw) {
    var _a = refineProps(raw, DRAG_META_REFINERS), refined = _a.refined, extra = _a.extra;
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
var ToolbarSection = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ToolbarSection, _super);
    function ToolbarSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarSection.prototype.render = function() {
        var _this = this;
        var children = this.props.widgetGroups.map(function(widgetGroup) {
            return _this.renderWidgetGroup(widgetGroup);
        });
        return (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
            "div",
            {
                className: "fc-toolbar-chunk"
            }
        ], children));
    };
    ToolbarSection.prototype.renderWidgetGroup = function(widgetGroup) {
        var props = this.props;
        var theme = this.context.theme;
        var children = [];
        var isOnlyButtons = true;
        for(var _i = 0, widgetGroup_1 = widgetGroup; _i < widgetGroup_1.length; _i++){
            var widget = widgetGroup_1[_i];
            var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon, buttonHint = widget.buttonHint;
            if (buttonName === "title") {
                isOnlyButtons = false;
                children.push((0, $3jFHS.createElement)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                var isPressed = buttonName === props.activeButton;
                var isDisabled = !props.isTodayEnabled && buttonName === "today" || !props.isPrevEnabled && buttonName === "prev" || !props.isNextEnabled && buttonName === "next";
                var buttonClasses = [
                    "fc-" + buttonName + "-button",
                    theme.getClass("button")
                ];
                if (isPressed) buttonClasses.push(theme.getClass("buttonActive"));
                children.push((0, $3jFHS.createElement)("button", {
                    type: "button",
                    title: typeof buttonHint === "function" ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(" "),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $3jFHS.createElement)("span", {
                    className: buttonIcon
                }) : "")));
            }
        }
        if (children.length > 1) {
            var groupClassName = isOnlyButtons && theme.getClass("buttonGroup") || "";
            return (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
                "div",
                {
                    className: groupClassName
                }
            ], children));
        }
        return children[0];
    };
    return ToolbarSection;
}(BaseComponent);
var Toolbar = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(Toolbar, _super);
    function Toolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toolbar.prototype.render = function() {
        var _a = this.props, model = _a.model, extraClassName = _a.extraClassName;
        var forceLtr = false;
        var startContent;
        var endContent;
        var sectionWidgets = model.sectionWidgets;
        var centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        var classNames = [
            extraClassName || "",
            "fc-toolbar",
            forceLtr ? "fc-toolbar-ltr" : ""
        ];
        return (0, $3jFHS.createElement)("div", {
            className: classNames.join(" ")
        }, this.renderSection("start", startContent || []), this.renderSection("center", centerContent || []), this.renderSection("end", endContent || []));
    };
    Toolbar.prototype.renderSection = function(key, widgetGroups) {
        var props = this.props;
        return (0, $3jFHS.createElement)(ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    };
    return Toolbar;
}(BaseComponent);
// TODO: do function component?
var ViewContainer = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ViewContainer, _super);
    function ViewContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            availableWidth: null
        };
        _this.handleEl = function(el) {
            _this.el = el;
            setRef(_this.props.elRef, el);
            _this.updateAvailableWidth();
        };
        _this.handleResize = function() {
            _this.updateAvailableWidth();
        };
        return _this;
    }
    ViewContainer.prototype.render = function() {
        var _a = this, props = _a.props, state = _a.state;
        var aspectRatio = props.aspectRatio;
        var classNames = [
            "fc-view-harness",
            aspectRatio || props.liquid || props.height ? "fc-view-harness-active" // harness controls the height
             : "fc-view-harness-passive"
        ];
        var height = "";
        var paddingBottom = "";
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = 1 / aspectRatio * 100 + "%";
        } else height = props.height || "";
        return (0, $3jFHS.createElement)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(" "),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    };
    ViewContainer.prototype.componentDidMount = function() {
        this.context.addResizeHandler(this.handleResize);
    };
    ViewContainer.prototype.componentWillUnmount = function() {
        this.context.removeResizeHandler(this.handleResize);
    };
    ViewContainer.prototype.updateAvailableWidth = function() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    };
    return ViewContainer;
}(BaseComponent);
/*
Detects when the user clicks on an event within a DateComponent
*/ var EventClicking = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(EventClicking, _super);
    function EventClicking(settings) {
        var _this = _super.call(this, settings) || this;
        _this.handleSegClick = function(ev, segEl) {
            var component = _this.component;
            var context = component.context;
            var seg = getElSeg(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                var hasUrlContainer = elementClosest(ev.target, ".fc-event-forced-url");
                var url = hasUrlContainer ? hasUrlContainer.querySelector("a[href]").href : "";
                context.emitter.trigger("eventClick", {
                    el: segEl,
                    event: new EventApi(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        _this.destroy = listenBySelector(settings.el, "click", ".fc-event", _this.handleSegClick);
        return _this;
    }
    return EventClicking;
}(Interaction);
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ var EventHovering = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(EventHovering, _super);
    function EventHovering(settings) {
        var _this = _super.call(this, settings) || this;
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        _this.handleEventElRemove = function(el) {
            if (el === _this.currentSegEl) _this.handleSegLeave(null, _this.currentSegEl);
        };
        _this.handleSegEnter = function(ev, segEl) {
            if (getElSeg(segEl)) {
                _this.currentSegEl = segEl;
                _this.triggerEvent("eventMouseEnter", ev, segEl);
            }
        };
        _this.handleSegLeave = function(ev, segEl) {
            if (_this.currentSegEl) {
                _this.currentSegEl = null;
                _this.triggerEvent("eventMouseLeave", ev, segEl);
            }
        };
        _this.removeHoverListeners = listenToHoverBySelector(settings.el, ".fc-event", _this.handleSegEnter, _this.handleSegLeave);
        return _this;
    }
    EventHovering.prototype.destroy = function() {
        this.removeHoverListeners();
    };
    EventHovering.prototype.triggerEvent = function(publicEvName, ev, segEl) {
        var component = this.component;
        var context = component.context;
        var seg = getElSeg(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new EventApi(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    };
    return EventHovering;
}(Interaction);
var CalendarContent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(CalendarContent, _super);
    function CalendarContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildViewContext = memoize(buildViewContext);
        _this.buildViewPropTransformers = memoize(buildViewPropTransformers);
        _this.buildToolbarProps = memoize(buildToolbarProps);
        _this.headerRef = (0, $3jFHS.createRef)();
        _this.footerRef = (0, $3jFHS.createRef)();
        _this.interactionsStore = {};
        // eslint-disable-next-line
        _this.state = {
            viewLabelId: getUniqueDomId()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        _this.registerInteractiveComponent = function(component, settingsInput) {
            var settings = parseInteractionSettings(component, settingsInput);
            var DEFAULT_INTERACTIONS = [
                EventClicking,
                EventHovering
            ];
            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
            var interactions = interactionClasses.map(function(TheInteractionClass) {
                return new TheInteractionClass(settings);
            });
            _this.interactionsStore[component.uid] = interactions;
            interactionSettingsStore[component.uid] = settings;
        };
        _this.unregisterInteractiveComponent = function(component) {
            var listeners = _this.interactionsStore[component.uid];
            if (listeners) {
                for(var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++){
                    var listener = listeners_1[_i];
                    listener.destroy();
                }
                delete _this.interactionsStore[component.uid];
            }
            delete interactionSettingsStore[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        _this.resizeRunner = new DelayedRunner(function() {
            _this.props.emitter.trigger("_resize", true); // should window resizes be considered "forced" ?
            _this.props.emitter.trigger("windowResize", {
                view: _this.props.viewApi
            });
        });
        _this.handleWindowResize = function(ev) {
            var options = _this.props.options;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) _this.resizeRunner.request(options.windowResizeDelay);
        };
        return _this;
    }
    /*
    renders INSIDE of an outer div
    */ CalendarContent.prototype.render = function() {
        var props = this.props;
        var toolbarConfig = props.toolbarConfig, options = props.options;
        var toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, getNow(props.options.now, props.dateEnv), props.viewTitle);
        var viewVGrow = false;
        var viewHeight = "";
        var viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = "";
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        var viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : "";
        return (0, $3jFHS.createElement)(ViewContextType.Provider, {
            value: viewContext
        }, toolbarConfig.header && (0, $3jFHS.createElement)(Toolbar, (0, $4nqhV.__assign)({
            ref: this.headerRef,
            extraClassName: "fc-header-toolbar",
            model: toolbarConfig.header,
            titleId: viewLabelId
        }, toolbarProps)), (0, $3jFHS.createElement)(ViewContainer, {
            liquid: viewVGrow,
            height: viewHeight,
            aspectRatio: viewAspectRatio,
            labeledById: viewLabelId
        }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $3jFHS.createElement)(Toolbar, (0, $4nqhV.__assign)({
            ref: this.footerRef,
            extraClassName: "fc-footer-toolbar",
            model: toolbarConfig.footer,
            titleId: ""
        }, toolbarProps)));
    };
    CalendarContent.prototype.componentDidMount = function() {
        var props = this.props;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map(function(CalendarInteractionClass) {
            return new CalendarInteractionClass(props);
        });
        window.addEventListener("resize", this.handleWindowResize);
        var propSetHandlers = props.pluginHooks.propSetHandlers;
        for(var propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    };
    CalendarContent.prototype.componentDidUpdate = function(prevProps) {
        var props = this.props;
        var propSetHandlers = props.pluginHooks.propSetHandlers;
        for(var propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    };
    CalendarContent.prototype.componentWillUnmount = function() {
        window.removeEventListener("resize", this.handleWindowResize);
        this.resizeRunner.clear();
        for(var _i = 0, _a = this.calendarInteractions; _i < _a.length; _i++){
            var interaction = _a[_i];
            interaction.destroy();
        }
        this.props.emitter.trigger("_unmount");
    };
    CalendarContent.prototype.buildAppendContent = function() {
        var props = this.props;
        var children = props.pluginHooks.viewContainerAppends.map(function(buildAppendContent) {
            return buildAppendContent(props);
        });
        return (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
            (0, $3jFHS.Fragment),
            {}
        ], children));
    };
    CalendarContent.prototype.renderView = function(props) {
        var pluginHooks = props.pluginHooks;
        var viewSpec = props.viewSpec;
        var viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for(var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++){
            var transformer = transformers_1[_i];
            (0, $4nqhV.__assign)(viewProps, transformer.transform(viewProps, props));
        }
        var ViewComponent = viewSpec.component;
        return (0, $3jFHS.createElement)(ViewComponent, (0, $4nqhV.__assign)({}, viewProps));
    };
    return CalendarContent;
}(PureComponent);
function buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !rangeContainsMarker(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function buildViewPropTransformers(theClasses) {
    return theClasses.map(function(TheClass) {
        return new TheClass();
    });
}
var CalendarRoot = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(CalendarRoot, _super);
    function CalendarRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            forPrint: false
        };
        _this.handleBeforePrint = function() {
            _this.setState({
                forPrint: true
            });
        };
        _this.handleAfterPrint = function() {
            _this.setState({
                forPrint: false
            });
        };
        return _this;
    }
    CalendarRoot.prototype.render = function() {
        var props = this.props;
        var options = props.options;
        var forPrint = this.state.forPrint;
        var isHeightAuto = forPrint || options.height === "auto" || options.contentHeight === "auto";
        var height = !isHeightAuto && options.height != null ? options.height : "";
        var classNames = [
            "fc",
            forPrint ? "fc-media-print" : "fc-media-screen",
            "fc-direction-" + options.direction,
            props.theme.getClass("root")
        ];
        if (!getCanVGrowWithinCell()) classNames.push("fc-liquid-hack");
        return props.children(classNames, height, isHeightAuto, forPrint);
    };
    CalendarRoot.prototype.componentDidMount = function() {
        var emitter = this.props.emitter;
        emitter.on("_beforeprint", this.handleBeforePrint);
        emitter.on("_afterprint", this.handleAfterPrint);
    };
    CalendarRoot.prototype.componentWillUnmount = function() {
        var emitter = this.props.emitter;
        emitter.off("_beforeprint", this.handleBeforePrint);
        emitter.off("_afterprint", this.handleAfterPrint);
    };
    return CalendarRoot;
}(BaseComponent);
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return createFormatter({
        weekday: "short"
    }); // "Sat"
    if (dayCnt > 1) return createFormatter({
        weekday: "short",
        month: "numeric",
        day: "numeric",
        omitCommas: true
    }); // "Sat 11/12"
    return createFormatter({
        weekday: "long"
    }); // "Saturday"
}
var CLASS_NAME = "fc-col-header-cell"; // do the cushion too? no
function renderInner$1(hookProps) {
    return hookProps.text;
}
var TableDateCell = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableDateCell, _super);
    function TableDateCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDateCell.prototype.render = function() {
        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options, theme = _a.theme, viewApi = _a.viewApi;
        var props = this.props;
        var date = props.date, dateProfile = props.dateProfile;
        var dayMeta = getDateMeta(date, props.todayRange, null, dateProfile);
        var classNames = [
            CLASS_NAME
        ].concat(getDayClassNames(dayMeta, theme));
        var text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        var navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? buildNavLinkAttrs(this.context, date) : {};
        var hookProps = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({
            date: dateEnv.toDate(date),
            view: viewApi
        }, props.extraHookProps), {
            text: text
        }), dayMeta);
        return (0, $3jFHS.createElement)(RenderHook, {
            hookProps: hookProps,
            classNames: options.dayHeaderClassNames,
            content: options.dayHeaderContent,
            defaultContent: renderInner$1,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, function(rootElRef, customClassNames, innerElRef, innerContent) {
            return (0, $3jFHS.createElement)("th", (0, $4nqhV.__assign)({
                ref: rootElRef,
                role: "columnheader",
                className: classNames.concat(customClassNames).join(" "),
                "data-date": !dayMeta.isDisabled ? formatDayString(date) : undefined,
                colSpan: props.colSpan
            }, props.extraDataAttrs), (0, $3jFHS.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $3jFHS.createElement)("a", (0, $4nqhV.__assign)({
                ref: innerElRef,
                className: [
                    "fc-col-header-cell-cushion",
                    props.isSticky ? "fc-sticky" : ""
                ].join(" ")
            }, navLinkAttrs), innerContent)));
        });
    };
    return TableDateCell;
}(BaseComponent);
var WEEKDAY_FORMAT = createFormatter({
    weekday: "long"
});
var TableDowCell = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableDowCell, _super);
    function TableDowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDowCell.prototype.render = function() {
        var props = this.props;
        var _a = this.context, dateEnv = _a.dateEnv, theme = _a.theme, viewApi = _a.viewApi, options = _a.options;
        var date = addDays(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        var dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        var classNames = [
            CLASS_NAME
        ].concat(getDayClassNames(dateMeta, theme), props.extraClassNames || []);
        var text = dateEnv.format(date, props.dayHeaderFormat);
        var hookProps = (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraHookProps), {
            text: text
        });
        return (0, $3jFHS.createElement)(RenderHook, {
            hookProps: hookProps,
            classNames: options.dayHeaderClassNames,
            content: options.dayHeaderContent,
            defaultContent: renderInner$1,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, function(rootElRef, customClassNames, innerElRef, innerContent) {
            return (0, $3jFHS.createElement)("th", (0, $4nqhV.__assign)({
                ref: rootElRef,
                role: "columnheader",
                className: classNames.concat(customClassNames).join(" "),
                colSpan: props.colSpan
            }, props.extraDataAttrs), (0, $3jFHS.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $3jFHS.createElement)("a", {
                "aria-label": dateEnv.format(date, WEEKDAY_FORMAT),
                className: [
                    "fc-col-header-cell-cushion",
                    props.isSticky ? "fc-sticky" : ""
                ].join(" "),
                ref: innerElRef
            }, innerContent)));
        });
    };
    return TableDowCell;
}(BaseComponent);
var NowTimer = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(NowTimer, _super);
    function NowTimer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.initialNowDate = getNow(context.options.now, context.dateEnv);
        _this.initialNowQueriedMs = new Date().valueOf();
        _this.state = _this.computeTiming().currentState;
        return _this;
    }
    NowTimer.prototype.render = function() {
        var _a = this, props = _a.props, state = _a.state;
        return props.children(state.nowDate, state.todayRange);
    };
    NowTimer.prototype.componentDidMount = function() {
        this.setTimeout();
    };
    NowTimer.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    };
    NowTimer.prototype.componentWillUnmount = function() {
        this.clearTimeout();
    };
    NowTimer.prototype.computeTiming = function() {
        var _a = this, props = _a.props, context = _a.context;
        var unroundedNow = addMs(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
        var currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
        var nextUnitStart = context.dateEnv.add(currentUnitStart, createDuration(1, props.unit));
        var waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            currentState: {
                nowDate: currentUnitStart,
                todayRange: buildDayRange(currentUnitStart)
            },
            nextState: {
                nowDate: nextUnitStart,
                todayRange: buildDayRange(nextUnitStart)
            },
            waitMs: waitMs
        };
    };
    NowTimer.prototype.setTimeout = function() {
        var _this = this;
        var _a = this.computeTiming(), nextState = _a.nextState, waitMs = _a.waitMs;
        this.timeoutId = setTimeout(function() {
            _this.setState(nextState, function() {
                _this.setTimeout();
            });
        }, waitMs);
    };
    NowTimer.prototype.clearTimeout = function() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    };
    NowTimer.contextType = ViewContextType;
    return NowTimer;
}((0, $3jFHS.Component));
function buildDayRange(date) {
    var start = startOfDay(date);
    var end = addDays(start, 1);
    return {
        start: start,
        end: end
    };
}
var DayHeader = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayHeader, _super);
    function DayHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createDayHeaderFormatter = memoize(createDayHeaderFormatter);
        return _this;
    }
    DayHeader.prototype.render = function() {
        var context = this.context;
        var _a = this.props, dates = _a.dates, dateProfile = _a.dateProfile, datesRepDistinctDays = _a.datesRepDistinctDays, renderIntro = _a.renderIntro;
        var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $3jFHS.createElement)(NowTimer, {
            unit: "day"
        }, function(nowDate, todayRange) {
            return (0, $3jFHS.createElement)("tr", {
                role: "row"
            }, renderIntro && renderIntro("day"), dates.map(function(date) {
                return datesRepDistinctDays ? (0, $3jFHS.createElement)(TableDateCell, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $3jFHS.createElement)(TableDowCell, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                });
            }));
        });
    };
    return DayHeader;
}(BaseComponent);
function createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dateCnt);
}
var DaySeriesModel = /** @class */ function() {
    function DaySeriesModel(range, dateProfileGenerator) {
        var date = range.start;
        var end = range.end;
        var indices = [];
        var dates = [];
        var dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = addDays(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    DaySeriesModel.prototype.sliceRange = function(range) {
        var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        var lastIndex = this.getDateDayIndex(addDays(range.end, -1)); // inclusive last index
        var clippedFirstIndex = Math.max(0, firstIndex);
        var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    };
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    DaySeriesModel.prototype.getDateDayIndex = function(date) {
        var indices = this.indices;
        var dayOffset = Math.floor(diffDays(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    };
    return DaySeriesModel;
}();
var DayTableModel = /** @class */ function() {
    function DayTableModel(daySeries, breakOnWeeks) {
        var dates = daySeries.dates;
        var daysPerRow;
        var firstDay;
        var rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    DayTableModel.prototype.buildCells = function() {
        var rows = [];
        for(var row = 0; row < this.rowCnt; row += 1){
            var cells = [];
            for(var col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    };
    DayTableModel.prototype.buildCell = function(row, col) {
        var date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    };
    DayTableModel.prototype.buildHeaderDates = function() {
        var dates = [];
        for(var col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    };
    DayTableModel.prototype.sliceRange = function(range) {
        var colCnt = this.colCnt;
        var seriesSeg = this.daySeries.sliceRange(range);
        var segs = [];
        if (seriesSeg) {
            var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
            var index = firstIndex;
            while(index <= lastIndex){
                var row = Math.floor(index / colCnt);
                var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    };
    return DayTableModel;
}();
var Slicer = /** @class */ function() {
    function Slicer() {
        this.sliceBusinessHours = memoize(this._sliceBusinessHours);
        this.sliceDateSelection = memoize(this._sliceDateSpan);
        this.sliceEventStore = memoize(this._sliceEventStore);
        this.sliceEventDrag = memoize(this._sliceInteraction);
        this.sliceEventResize = memoize(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    Slicer.prototype.sliceProps = function(props, dateProfile, nextDayThreshold, context) {
        var extraArgs = [];
        for(var _i = 4; _i < arguments.length; _i++)extraArgs[_i - 4] = arguments[_i];
        var eventUiBases = props.eventUiBases;
        var eventSegs = this.sliceEventStore.apply(this, (0, $4nqhV.__spreadArray)([
            props.eventStore,
            eventUiBases,
            dateProfile,
            nextDayThreshold
        ], extraArgs));
        return {
            dateSelectionSegs: this.sliceDateSelection.apply(this, (0, $4nqhV.__spreadArray)([
                props.dateSelection,
                eventUiBases,
                context
            ], extraArgs)),
            businessHourSegs: this.sliceBusinessHours.apply(this, (0, $4nqhV.__spreadArray)([
                props.businessHours,
                dateProfile,
                nextDayThreshold,
                context
            ], extraArgs)),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag.apply(this, (0, $4nqhV.__spreadArray)([
                props.eventDrag,
                eventUiBases,
                dateProfile,
                nextDayThreshold
            ], extraArgs)),
            eventResize: this.sliceEventResize.apply(this, (0, $4nqhV.__spreadArray)([
                props.eventResize,
                eventUiBases,
                dateProfile,
                nextDayThreshold
            ], extraArgs)),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    };
    Slicer.prototype.sliceNowDate = function(date, context) {
        var extraArgs = [];
        for(var _i = 2; _i < arguments.length; _i++)extraArgs[_i - 2] = arguments[_i];
        return this._sliceDateSpan.apply(this, (0, $4nqhV.__spreadArray)([
            {
                range: {
                    start: date,
                    end: addMs(date, 1)
                },
                allDay: false
            },
            {},
            context
        ], extraArgs));
    };
    Slicer.prototype._sliceBusinessHours = function(businessHours, dateProfile, nextDayThreshold, context) {
        var extraArgs = [];
        for(var _i = 4; _i < arguments.length; _i++)extraArgs[_i - 4] = arguments[_i];
        if (!businessHours) return [];
        return this._sliceEventStore.apply(this, (0, $4nqhV.__spreadArray)([
            expandRecurring(businessHours, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
            {},
            dateProfile,
            nextDayThreshold
        ], extraArgs)).bg;
    };
    Slicer.prototype._sliceEventStore = function(eventStore, eventUiBases, dateProfile, nextDayThreshold) {
        var extraArgs = [];
        for(var _i = 4; _i < arguments.length; _i++)extraArgs[_i - 4] = arguments[_i];
        if (eventStore) {
            var rangeRes = sliceEventStore(eventStore, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    };
    Slicer.prototype._sliceInteraction = function(interaction, eventUiBases, dateProfile, nextDayThreshold) {
        var extraArgs = [];
        for(var _i = 4; _i < arguments.length; _i++)extraArgs[_i - 4] = arguments[_i];
        if (!interaction) return null;
        var rangeRes = sliceEventStore(interaction.mutatedEvents, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    };
    Slicer.prototype._sliceDateSpan = function(dateSpan, eventUiBases, context) {
        var extraArgs = [];
        for(var _i = 3; _i < arguments.length; _i++)extraArgs[_i - 3] = arguments[_i];
        if (!dateSpan) return [];
        var eventRange = fabricateEventRange(dateSpan, eventUiBases, context);
        var segs = this.sliceRange.apply(this, (0, $4nqhV.__spreadArray)([
            dateSpan.range
        ], extraArgs));
        for(var _a = 0, segs_1 = segs; _a < segs_1.length; _a++){
            var seg = segs_1[_a];
            seg.eventRange = eventRange;
        }
        return segs;
    };
    /*
    "complete" seg means it has component and eventRange
    */ Slicer.prototype.sliceEventRanges = function(eventRanges, extraArgs) {
        var segs = [];
        for(var _i = 0, eventRanges_1 = eventRanges; _i < eventRanges_1.length; _i++){
            var eventRange = eventRanges_1[_i];
            segs.push.apply(segs, this.sliceEventRange(eventRange, extraArgs));
        }
        return segs;
    };
    /*
    "complete" seg means it has component and eventRange
    */ Slicer.prototype.sliceEventRange = function(eventRange, extraArgs) {
        var dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === "list-item") dateRange = {
            start: dateRange.start,
            end: addDays(dateRange.start, 1)
        };
        var segs = this.sliceRange.apply(this, (0, $4nqhV.__spreadArray)([
            dateRange
        ], extraArgs));
        for(var _i = 0, segs_2 = segs; _i < segs_2.length; _i++){
            var seg = segs_2[_i];
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    };
    return Slicer;
}();
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function computeActiveRange(dateProfile, isComponentAllDay) {
    var range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: addMs(range.start, dateProfile.slotMinTime.milliseconds),
        end: addMs(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionValid(interaction, dateProfile, context) {
    var instances = interaction.mutatedEvents.instances;
    for(var instanceId in instances){
        if (!rangeContainsRange(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function isDateSelectionValid(dateSelection, dateProfile, context) {
    if (!rangeContainsRange(dateProfile.validRange, dateSelection.range)) return false;
    return isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function isNewPropsValid(newProps, context) {
    var calendarState = context.getCurrentData();
    var props = (0, $4nqhV.__assign)({
        businessHours: calendarState.businessHours,
        dateSelection: "",
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: "",
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || isPropsValid)(props, context);
}
function isPropsValid(state, context, dateSpanMeta, filterConfig) {
    if (dateSpanMeta === void 0) dateSpanMeta = {};
    if (state.eventDrag && !isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var currentState = context.getCurrentData();
    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    var subjectEventStore = interaction.mutatedEvents;
    var subjectDefs = subjectEventStore.defs;
    var subjectInstances = subjectEventStore.instances;
    var subjectConfigs = compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        "": currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = mapHash(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    var otherEventStore = excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    var otherDefs = otherEventStore.defs;
    var otherInstances = otherEventStore.instances;
    var otherConfigs = compileEventUis(otherDefs, state.eventUiBases);
    for(var subjectInstanceId in subjectInstances){
        var subjectInstance = subjectInstances[subjectInstanceId];
        var subjectRange = subjectInstance.range;
        var subjectConfig = subjectConfigs[subjectInstance.defId];
        var subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        var eventOverlap = context.options.eventOverlap;
        var eventOverlapFunc = typeof eventOverlap === "function" ? eventOverlap : null;
        for(var otherInstanceId in otherInstances){
            var otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if (rangesIntersect(subjectRange, otherInstance.range)) {
                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new EventApi(context, otherDefs[otherInstance.defId], otherInstance), new EventApi(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for(var _i = 0, _a = subjectConfig.allows; _i < _a.length; _i++){
            var subjectAllow = _a[_i];
            var subjectDateSpan = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            var origDef = calendarEventStore.defs[subjectDef.defId];
            var origInstance = calendarEventStore.instances[subjectInstanceId];
            var eventApi = void 0;
            if (origDef) eventApi = new EventApi(context, origDef, origInstance);
            else eventApi = new EventApi(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow(buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var relevantEventStore = state.eventStore;
    var relevantDefs = relevantEventStore.defs;
    var relevantInstances = relevantEventStore.instances;
    var selection = state.dateSelection;
    var selectionRange = selection.range;
    var selectionConfig = context.getCurrentData().selectionConfig;
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    var selectOverlap = context.options.selectOverlap;
    var selectOverlapFunc = typeof selectOverlap === "function" ? selectOverlap : null;
    for(var relevantInstanceId in relevantInstances){
        var relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if (rangesIntersect(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new EventApi(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for(var _i = 0, _a = selectionConfig.allows; _i < _a.length; _i++){
        var selectionAllow = _a[_i];
        var fullDateSpan = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, dateSpanMeta), selection);
        if (!selectionAllow(buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for(var _i = 0, constraints_1 = constraints; _i < constraints_1.length; _i++){
        var constraint = constraints_1[_i];
        if (!anyRangesContainRange(constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === "businessHours") return eventStoreToRanges(expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === "string") return eventStoreToRanges(filterEventStoreDefs(otherEventStore, function(eventDef) {
        return eventDef.groupId === constraint;
    }));
    if (typeof constraint === "object" && constraint) return eventStoreToRanges(expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function eventStoreToRanges(eventStore) {
    var instances = eventStore.instances;
    var ranges = [];
    for(var instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function anyRangesContainRange(outerRanges, innerRange) {
    for(var _i = 0, outerRanges_1 = outerRanges; _i < outerRanges_1.length; _i++){
        var outerRange = outerRanges_1[_i];
        if (rangeContainsRange(outerRange, innerRange)) return true;
    }
    return false;
}
var VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
var Scroller = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(Scroller, _super);
    function Scroller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEl = function(el) {
            _this.el = el;
            setRef(_this.props.elRef, el);
        };
        return _this;
    }
    Scroller.prototype.render = function() {
        var props = this.props;
        var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
        var isAbsolute = liquid && liquidIsAbsolute;
        var className = [
            "fc-scroller"
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push("fc-scroller-liquid-absolute");
            else className.push("fc-scroller-liquid");
        }
        return (0, $3jFHS.createElement)("div", {
            ref: this.handleEl,
            className: className.join(" "),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || "",
                right: isAbsolute && -(props.overcomeRight || 0) || "",
                bottom: isAbsolute && -(props.overcomeBottom || 0) || "",
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || "",
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || "",
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || "",
                maxHeight: props.maxHeight || ""
            }
        }, props.children);
    };
    Scroller.prototype.needsXScrolling = function() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        var el = this.el;
        var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        var children = el.children;
        for(var i = 0; i < children.length; i += 1){
            var childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    };
    Scroller.prototype.needsYScrolling = function() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        var el = this.el;
        var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        var children = el.children;
        for(var i = 0; i < children.length; i += 1){
            var childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    };
    Scroller.prototype.getXScrollbarWidth = function() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    };
    Scroller.prototype.getYScrollbarWidth = function() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    };
    return Scroller;
}(BaseComponent);
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ var RefMap = /** @class */ function() {
    function RefMap(masterCallback) {
        var _this = this;
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = function(val, key) {
            var _a = _this, depths = _a.depths, currentMap = _a.currentMap;
            var removed = false;
            var added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete _this.callbackMap[key];
                    removed = true;
                }
            }
            if (_this.masterCallback) {
                if (removed) _this.masterCallback(null, String(key));
                if (added) _this.masterCallback(val, String(key));
            }
        };
    }
    RefMap.prototype.createRef = function(key) {
        var _this = this;
        var refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = function(val) {
            _this.handleValue(val, String(key));
        };
        return refCallback;
    };
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    RefMap.prototype.collect = function(startIndex, endIndex, step) {
        return collectFromHash(this.currentMap, startIndex, endIndex, step);
    };
    RefMap.prototype.getAll = function() {
        return hashValuesToArray(this.currentMap);
    };
    return RefMap;
}();
function computeShrinkWidth(chunkEls) {
    var shrinkCells = findElements(chunkEls, ".fc-scrollgrid-shrink");
    var largestWidth = 0;
    for(var _i = 0, shrinkCells_1 = shrinkCells; _i < shrinkCells_1.length; _i++){
        var shrinkCell = shrinkCells_1[_i];
        largestWidth = Math.max(largestWidth, computeSmallestCellWidth(shrinkCell));
    }
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function getSectionHasLiquidHeight(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function getAllowYScrolling(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    getSectionHasLiquidHeight(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function renderChunkContent(sectionConfig, chunkConfig, arg, isHeader) {
    var expandRows = arg.expandRows;
    var content = typeof chunkConfig.content === "function" ? chunkConfig.content(arg) : (0, $3jFHS.createElement)("table", {
        role: "presentation",
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
        ].join(" "),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ""
        }
    }, arg.tableColGroupNode, (0, $3jFHS.createElement)(isHeader ? "thead" : "tbody", {
        role: "presentation"
    }, typeof chunkConfig.rowContent === "function" ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function isColPropsEqual(cols0, cols1) {
    return isArraysEqual(cols0, cols1, isPropsEqual);
}
function renderMicroColGroup(cols, shrinkWidth) {
    var colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for(var _i = 0, cols_1 = cols; _i < cols_1.length; _i++){
        var colProps = cols_1[_i];
        var span = colProps.span || 1;
        for(var i = 0; i < span; i += 1)colNodes.push((0, $3jFHS.createElement)("col", {
            style: {
                width: colProps.width === "shrink" ? sanitizeShrinkWidth(shrinkWidth) : colProps.width || "",
                minWidth: colProps.minWidth || ""
            }
        }));
    }
    return (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
        "colgroup",
        {}
    ], colNodes));
}
function sanitizeShrinkWidth(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function hasShrinkWidth(cols) {
    for(var _i = 0, cols_2 = cols; _i < cols_2.length; _i++){
        var col = cols_2[_i];
        if (col.width === "shrink") return true;
    }
    return false;
}
function getScrollGridClassNames(liquid, context) {
    var classNames = [
        "fc-scrollgrid",
        context.theme.getClass("table")
    ];
    if (liquid) classNames.push("fc-scrollgrid-liquid");
    return classNames;
}
function getSectionClassNames(sectionConfig, wholeTableVGrow) {
    var classNames = [
        "fc-scrollgrid-section",
        "fc-scrollgrid-section-" + sectionConfig.type,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push("fc-scrollgrid-section-liquid");
    if (sectionConfig.isSticky) classNames.push("fc-scrollgrid-section-sticky");
    return classNames;
}
function renderScrollShim(arg) {
    return (0, $3jFHS.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function getStickyHeaderDates(options) {
    var stickyHeaderDates = options.stickyHeaderDates;
    if (stickyHeaderDates == null || stickyHeaderDates === "auto") stickyHeaderDates = options.height === "auto" || options.viewHeight === "auto";
    return stickyHeaderDates;
}
function getStickyFooterScrollbar(options) {
    var stickyFooterScrollbar = options.stickyFooterScrollbar;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === "auto") stickyFooterScrollbar = options.height === "auto" || options.viewHeight === "auto";
    return stickyFooterScrollbar;
}
var SimpleScrollGrid = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(SimpleScrollGrid, _super);
    function SimpleScrollGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processCols = memoize(function(a) {
            return a;
        }, isColPropsEqual); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        _this.renderMicroColGroup = memoize(renderMicroColGroup);
        _this.scrollerRefs = new RefMap();
        _this.scrollerElRefs = new RefMap(_this._handleScrollerEl.bind(_this));
        _this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        _this.handleSizing = function() {
            _this.safeSetState((0, $4nqhV.__assign)({
                shrinkWidth: _this.computeShrinkWidth()
            }, _this.computeScrollerDims()));
        };
        return _this;
    }
    SimpleScrollGrid.prototype.render = function() {
        var _a = this, props = _a.props, state = _a.state, context = _a.context;
        var sectionConfigs = props.sections || [];
        var cols = this.processCols(props.cols);
        var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        var classNames = getScrollGridClassNames(props.liquid, context);
        if (props.collapsibleWidth) classNames.push("fc-scrollgrid-collapsible");
        // TODO: make DRY
        var configCnt = sectionConfigs.length;
        var configI = 0;
        var currentConfig;
        var headSectionNodes = [];
        var bodySectionNodes = [];
        var footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "header"){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "body"){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "footer"){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        var isBuggy = !getCanVGrowWithinCell();
        var roleAttrs = {
            role: "rowgroup"
        };
        return (0, $3jFHS.createElement)("table", {
            role: "grid",
            className: classNames.join(" "),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
            "thead",
            roleAttrs
        ], headSectionNodes)), Boolean(!isBuggy && bodySectionNodes.length) && (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
            "tbody",
            roleAttrs
        ], bodySectionNodes)), Boolean(!isBuggy && footSectionNodes.length) && (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
            "tfoot",
            roleAttrs
        ], footSectionNodes)), isBuggy && (0, $3jFHS.createElement).apply(void 0, (0, $4nqhV.__spreadArray)((0, $4nqhV.__spreadArray)((0, $4nqhV.__spreadArray)([
            "tbody",
            roleAttrs
        ], headSectionNodes), bodySectionNodes), footSectionNodes)));
    };
    SimpleScrollGrid.prototype.renderSection = function(sectionConfig, microColGroupNode, isHeader) {
        if ("outerContent" in sectionConfig) return (0, $3jFHS.createElement)((0, $3jFHS.Fragment), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $3jFHS.createElement)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: getSectionClassNames(sectionConfig, this.props.liquid).join(" ")
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    };
    SimpleScrollGrid.prototype.renderChunkTd = function(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ("outerContent" in chunkConfig) return chunkConfig.outerContent;
        var props = this.props;
        var _a = this.state, forceYScrollbars = _a.forceYScrollbars, scrollerClientWidths = _a.scrollerClientWidths, scrollerClientHeights = _a.scrollerClientHeights;
        var needsYScrolling = getAllowYScrolling(props, sectionConfig); // TODO: do lazily. do in section config?
        var isLiquid = getSectionHasLiquidHeight(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        var overflowY = !props.liquid ? "visible" : forceYScrollbars ? "scroll" : !needsYScrolling ? "hidden" : "auto";
        var sectionKey = sectionConfig.key;
        var content = renderChunkContent(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: "",
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: function() {}
        }, isHeader);
        return (0, $3jFHS.createElement)(isHeader ? "th" : "td", {
            ref: chunkConfig.elRef,
            role: "presentation"
        }, (0, $3jFHS.createElement)("div", {
            className: "fc-scroller-harness" + (isLiquid ? " fc-scroller-harness-liquid" : "")
        }, (0, $3jFHS.createElement)(Scroller, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? "visible" : "hidden" /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    };
    SimpleScrollGrid.prototype._handleScrollerEl = function(scrollerEl, key) {
        var section = getSectionByKey(this.props.sections, key);
        if (section) setRef(section.chunk.scrollerElRef, scrollerEl);
    };
    SimpleScrollGrid.prototype.componentDidMount = function() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    };
    SimpleScrollGrid.prototype.componentDidUpdate = function() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    };
    SimpleScrollGrid.prototype.componentWillUnmount = function() {
        this.context.removeResizeHandler(this.handleSizing);
    };
    SimpleScrollGrid.prototype.computeShrinkWidth = function() {
        return hasShrinkWidth(this.props.cols) ? computeShrinkWidth(this.scrollerElRefs.getAll()) : 0;
    };
    SimpleScrollGrid.prototype.computeScrollerDims = function() {
        var scrollbarWidth = getScrollbarWidths();
        var _a = this, scrollerRefs = _a.scrollerRefs, scrollerElRefs = _a.scrollerElRefs;
        var forceYScrollbars = false;
        var scrollerClientWidths = {};
        var scrollerClientHeights = {};
        for(var sectionKey in scrollerRefs.currentMap){
            var scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for(var _i = 0, _b = this.props.sections; _i < _b.length; _i++){
            var section = _b[_i];
            var sectionKey = section.key;
            var scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    };
    return SimpleScrollGrid;
}(BaseComponent);
SimpleScrollGrid.addStateEquality({
    scrollerClientWidths: isPropsEqual,
    scrollerClientHeights: isPropsEqual
});
function getSectionByKey(sections, key) {
    for(var _i = 0, sections_1 = sections; _i < sections_1.length; _i++){
        var section = sections_1[_i];
        if (section.key === key) return section;
    }
    return null;
}
var EventRoot = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(EventRoot, _super);
    function EventRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elRef = (0, $3jFHS.createRef)();
        return _this;
    }
    EventRoot.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var seg = props.seg;
        var eventRange = seg.eventRange;
        var ui = eventRange.ui;
        var hookProps = {
            event: new EventApi(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        var standardClassNames = getEventClassNames(hookProps).concat(ui.classNames);
        return (0, $3jFHS.createElement)(RenderHook, {
            hookProps: hookProps,
            classNames: options.eventClassNames,
            content: options.eventContent,
            defaultContent: props.defaultContent,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount,
            elRef: this.elRef
        }, function(rootElRef, customClassNames, innerElRef, innerContent) {
            return props.children(rootElRef, standardClassNames.concat(customClassNames), innerElRef, innerContent, hookProps);
        });
    };
    EventRoot.prototype.componentDidMount = function() {
        setElSeg(this.elRef.current, this.props.seg);
    };
    /*
    need to re-assign seg to the element if seg changes, even if the element is the same
    */ EventRoot.prototype.componentDidUpdate = function(prevProps) {
        var seg = this.props.seg;
        if (seg !== prevProps.seg) setElSeg(this.elRef.current, seg);
    };
    return EventRoot;
}(BaseComponent);
// should not be a purecomponent
var StandardEvent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(StandardEvent, _super);
    function StandardEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StandardEvent.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var seg = props.seg;
        var timeFormat = context.options.eventTimeFormat || props.defaultTimeFormat;
        var timeText = buildSegTimeText(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $3jFHS.createElement)(EventRoot, {
            seg: seg,
            timeText: timeText,
            disableDragging: props.disableDragging,
            disableResizing: props.disableResizing,
            defaultContent: props.defaultContent || renderInnerContent$1,
            isDragging: props.isDragging,
            isResizing: props.isResizing,
            isDateSelecting: props.isDateSelecting,
            isSelected: props.isSelected,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday
        }, function(rootElRef, classNames, innerElRef, innerContent, hookProps) {
            return (0, $3jFHS.createElement)("a", (0, $4nqhV.__assign)({
                className: props.extraClassNames.concat(classNames).join(" "),
                style: {
                    borderColor: hookProps.borderColor,
                    backgroundColor: hookProps.backgroundColor
                },
                ref: rootElRef
            }, getSegAnchorAttrs(seg, context)), (0, $3jFHS.createElement)("div", {
                className: "fc-event-main",
                ref: innerElRef,
                style: {
                    color: hookProps.textColor
                }
            }, innerContent), hookProps.isStartResizable && (0, $3jFHS.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), hookProps.isEndResizable && (0, $3jFHS.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            }));
        });
    };
    return StandardEvent;
}(BaseComponent);
function renderInnerContent$1(innerProps) {
    return (0, $3jFHS.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $3jFHS.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $3jFHS.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, $3jFHS.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $3jFHS.createElement)((0, $3jFHS.Fragment), null, "\xa0"))));
}
var NowIndicatorRoot = function(props) {
    return (0, $3jFHS.createElement)(ViewContextType.Consumer, null, function(context) {
        var options = context.options;
        var hookProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $3jFHS.createElement)(RenderHook, {
            hookProps: hookProps,
            classNames: options.nowIndicatorClassNames,
            content: options.nowIndicatorContent,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
};
var DAY_NUM_FORMAT = createFormatter({
    day: "numeric"
});
var DayCellContent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayCellContent, _super);
    function DayCellContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayCellContent.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = refineDayCellHookProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraProps: props.extraHookProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv
        });
        return (0, $3jFHS.createElement)(ContentHook, {
            hookProps: hookProps,
            content: options.dayCellContent,
            defaultContent: props.defaultContent
        }, props.children);
    };
    return DayCellContent;
}(BaseComponent);
function refineDayCellHookProps(raw) {
    var date = raw.date, dateEnv = raw.dateEnv;
    var dayMeta = getDateMeta(date, raw.todayRange, null, raw.dateProfile);
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        dayNumberText: raw.showDayNumber ? dateEnv.format(date, DAY_NUM_FORMAT) : ""
    }), raw.extraProps);
}
var DayCellRoot = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayCellRoot, _super);
    function DayCellRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refineHookProps = memoizeObjArg(refineDayCellHookProps);
        _this.normalizeClassNames = buildClassNameNormalizer();
        return _this;
    }
    DayCellRoot.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = this.refineHookProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraProps: props.extraHookProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv
        });
        var classNames = getDayClassNames(hookProps, context.theme).concat(hookProps.isDisabled ? [] // don't use custom classNames if disabled
         : this.normalizeClassNames(options.dayCellClassNames, hookProps));
        var dataAttrs = hookProps.isDisabled ? {} : {
            "data-date": formatDayString(props.date)
        };
        return (0, $3jFHS.createElement)(MountHook, {
            hookProps: hookProps,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount,
            elRef: props.elRef
        }, function(rootElRef) {
            return props.children(rootElRef, classNames, dataAttrs, hookProps.isDisabled);
        });
    };
    return DayCellRoot;
}(BaseComponent);
function renderFill(fillType) {
    return (0, $3jFHS.createElement)("div", {
        className: "fc-" + fillType
    });
}
var BgEvent = function(props) {
    return (0, $3jFHS.createElement)(EventRoot, {
        defaultContent: renderInnerContent,
        seg: props.seg /* uselesss i think */ ,
        timeText: "",
        disableDragging: true,
        disableResizing: true,
        isDragging: false,
        isResizing: false,
        isDateSelecting: false,
        isSelected: false,
        isPast: props.isPast,
        isFuture: props.isFuture,
        isToday: props.isToday
    }, function(rootElRef, classNames, innerElRef, innerContent, hookProps) {
        return (0, $3jFHS.createElement)("div", {
            ref: rootElRef,
            className: [
                "fc-bg-event"
            ].concat(classNames).join(" "),
            style: {
                backgroundColor: hookProps.backgroundColor
            }
        }, innerContent);
    });
};
function renderInnerContent(props) {
    var title = props.event.title;
    return title && (0, $3jFHS.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
var WeekNumberRoot = function(props) {
    return (0, $3jFHS.createElement)(ViewContextType.Consumer, null, function(context) {
        var dateEnv = context.dateEnv, options = context.options;
        var date = props.date;
        var format = options.weekNumberFormat || props.defaultFormat;
        var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        var text = dateEnv.format(date, format);
        var hookProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $3jFHS.createElement)(RenderHook, {
            hookProps: hookProps,
            classNames: options.weekNumberClassNames,
            content: options.weekNumberContent,
            defaultContent: renderInner,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
};
function renderInner(innerProps) {
    return innerProps.text;
}
var PADDING_FROM_VIEWPORT = 10;
var Popover = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            titleId: getUniqueDomId()
        };
        _this.handleRootEl = function(el) {
            _this.rootEl = el;
            if (_this.props.elRef) setRef(_this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        _this.handleDocumentMouseDown = function(ev) {
            // only hide the popover if the click happened outside the popover
            var target = getEventTargetViaRoot(ev);
            if (!_this.rootEl.contains(target)) _this.handleCloseClick();
        };
        _this.handleDocumentKeyDown = function(ev) {
            if (ev.key === "Escape") _this.handleCloseClick();
        };
        _this.handleCloseClick = function() {
            var onClose = _this.props.onClose;
            if (onClose) onClose();
        };
        return _this;
    }
    Popover.prototype.render = function() {
        var _a = this.context, theme = _a.theme, options = _a.options;
        var _b = this, props = _b.props, state = _b.state;
        var classNames = [
            "fc-popover",
            theme.getClass("popover")
        ].concat(props.extraClassNames || []);
        return (0, $3jFHS.createPortal)((0, $3jFHS.createElement)("div", (0, $4nqhV.__assign)({
            id: props.id,
            className: classNames.join(" "),
            "aria-labelledby": state.titleId
        }, props.extraAttrs, {
            ref: this.handleRootEl
        }), (0, $3jFHS.createElement)("div", {
            className: "fc-popover-header " + theme.getClass("popoverHeader")
        }, (0, $3jFHS.createElement)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $3jFHS.createElement)("span", {
            className: "fc-popover-close " + theme.getIconClass("close"),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $3jFHS.createElement)("div", {
            className: "fc-popover-body " + theme.getClass("popoverContent")
        }, props.children)), props.parentEl);
    };
    Popover.prototype.componentDidMount = function() {
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
        document.addEventListener("keydown", this.handleDocumentKeyDown);
        this.updateSize();
    };
    Popover.prototype.componentWillUnmount = function() {
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    };
    Popover.prototype.updateSize = function() {
        var isRtl = this.context.isRtl;
        var _a = this.props, alignmentEl = _a.alignmentEl, alignGridTop = _a.alignGridTop;
        var rootEl = this.rootEl;
        var alignmentRect = computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            var popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            var popoverTop = alignGridTop ? elementClosest(alignmentEl, ".fc-scrollgrid").getBoundingClientRect().top : alignmentRect.top;
            var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, PADDING_FROM_VIEWPORT);
            var origin_1 = rootEl.offsetParent.getBoundingClientRect();
            applyStyle(rootEl, {
                top: popoverTop - origin_1.top,
                left: popoverLeft - origin_1.left
            });
        }
    };
    return Popover;
}(BaseComponent);
var MorePopover = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(MorePopover, _super);
    function MorePopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function(rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) _this.context.registerInteractiveComponent(_this, {
                el: rootEl,
                useEventCenter: false
            });
            else _this.context.unregisterInteractiveComponent(_this);
        };
        return _this;
    }
    MorePopover.prototype.render = function() {
        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv;
        var props = this.props;
        var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
        var title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $3jFHS.createElement)(DayCellRoot, {
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange,
            elRef: this.handleRootEl
        }, function(rootElRef, dayClassNames, dataAttrs) {
            return (0, $3jFHS.createElement)(Popover, {
                elRef: rootElRef,
                id: props.id,
                title: title,
                extraClassNames: [
                    "fc-more-popover"
                ].concat(dayClassNames),
                extraAttrs: dataAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, (0, $3jFHS.createElement)(DayCellContent, {
                date: startDate,
                dateProfile: dateProfile,
                todayRange: todayRange
            }, function(innerElRef, innerContent) {
                return innerContent && (0, $3jFHS.createElement)("div", {
                    className: "fc-more-popover-misc",
                    ref: innerElRef
                }, innerContent);
            }), props.children);
        });
    };
    MorePopover.prototype.queryHit = function(positionLeft, positionTop, elWidth, elHeight) {
        var _a = this, rootEl = _a.rootEl, props = _a.props;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: (0, $4nqhV.__assign)({
                allDay: true,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    };
    return MorePopover;
}(DateComponent);
var MoreLinkRoot = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(MoreLinkRoot, _super);
    function MoreLinkRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.linkElRef = (0, $3jFHS.createRef)();
        _this.state = {
            isPopoverOpen: false,
            popoverId: getUniqueDomId()
        };
        _this.handleClick = function(ev) {
            var _a = _this, props = _a.props, context = _a.context;
            var moreLinkClick = context.options.moreLinkClick;
            var date = computeRange(props).start;
            function buildPublicSeg(seg) {
                var _a = seg.eventRange, def = _a.def, instance = _a.instance, range = _a.range;
                return {
                    event: new EventApi(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === "function") moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === "popover") _this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === "string") context.calendarApi.zoomTo(date, moreLinkClick);
        };
        _this.handlePopoverClose = function() {
            _this.setState({
                isPopoverOpen: false
            });
        };
        return _this;
    }
    MoreLinkRoot.prototype.render = function() {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        return (0, $3jFHS.createElement)(ViewContextType.Consumer, null, function(context) {
            var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
            var moreLinkText = options.moreLinkText;
            var moreCnt = props.moreCnt;
            var range = computeRange(props);
            var text = typeof moreLinkText === "function" // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : "+" + moreCnt + " " + moreLinkText;
            var title = formatWithOrdinals(options.moreLinkHint, [
                moreCnt
            ], text);
            var hookProps = {
                num: moreCnt,
                shortText: "+" + moreCnt,
                text: text,
                view: viewApi
            };
            return (0, $3jFHS.createElement)((0, $3jFHS.Fragment), null, Boolean(props.moreCnt) && (0, $3jFHS.createElement)(RenderHook, {
                elRef: _this.linkElRef,
                hookProps: hookProps,
                classNames: options.moreLinkClassNames,
                content: options.moreLinkContent,
                defaultContent: props.defaultContent || renderMoreLinkInner,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, function(rootElRef, customClassNames, innerElRef, innerContent) {
                return props.children(rootElRef, [
                    "fc-more-link"
                ].concat(customClassNames), innerElRef, innerContent, _this.handleClick, title, state.isPopoverOpen, state.isPopoverOpen ? state.popoverId : "");
            }), state.isPopoverOpen && (0, $3jFHS.createElement)(MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: _this.parentEl,
                alignmentEl: props.alignmentElRef.current,
                alignGridTop: props.alignGridTop,
                onClose: _this.handlePopoverClose
            }, props.popoverContent()));
        });
    };
    MoreLinkRoot.prototype.componentDidMount = function() {
        this.updateParentEl();
    };
    MoreLinkRoot.prototype.componentDidUpdate = function() {
        this.updateParentEl();
    };
    MoreLinkRoot.prototype.updateParentEl = function() {
        if (this.linkElRef.current) this.parentEl = elementClosest(this.linkElRef.current, ".fc-view-harness");
    };
    return MoreLinkRoot;
}(BaseComponent);
function renderMoreLinkInner(props) {
    return props.text;
}
function computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: addDays(props.allDayDate, 1)
    };
    var hiddenSegs = props.hiddenSegs;
    return {
        start: computeEarliestSegStart(hiddenSegs),
        end: computeLatestSegEnd(hiddenSegs)
    };
}
function computeEarliestSegStart(segs) {
    return segs.reduce(pickEarliestStart).eventRange.range.start;
}
function pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function computeLatestSegEnd(segs) {
    return segs.reduce(pickLatestEnd).eventRange.range.end;
}
function pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
// exports
// --------------------------------------------------------------------------------------------------
var version = "5.11.5"; // important to type it, so .d.ts has generic string

});
parcelRegister("4nqhV", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $32fdb3acdaad2fc5$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $32fdb3acdaad2fc5$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__awaiter", function () { return $32fdb3acdaad2fc5$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $32fdb3acdaad2fc5$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__read", function () { return $32fdb3acdaad2fc5$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $32fdb3acdaad2fc5$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $32fdb3acdaad2fc5$var$extendStatics = function(d, b) {
    $32fdb3acdaad2fc5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $32fdb3acdaad2fc5$var$extendStatics(d, b);
};
function $32fdb3acdaad2fc5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $32fdb3acdaad2fc5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $32fdb3acdaad2fc5$export$18ce0697a983be9b = function() {
    $32fdb3acdaad2fc5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32fdb3acdaad2fc5$export$18ce0697a983be9b.apply(this, arguments);
};
function $32fdb3acdaad2fc5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $32fdb3acdaad2fc5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $32fdb3acdaad2fc5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $32fdb3acdaad2fc5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $32fdb3acdaad2fc5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $32fdb3acdaad2fc5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $32fdb3acdaad2fc5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $32fdb3acdaad2fc5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $32fdb3acdaad2fc5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $32fdb3acdaad2fc5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $32fdb3acdaad2fc5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $32fdb3acdaad2fc5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $32fdb3acdaad2fc5$export$45d3717a4c69092e(o, m, p);
}
function $32fdb3acdaad2fc5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $32fdb3acdaad2fc5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $32fdb3acdaad2fc5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($32fdb3acdaad2fc5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $32fdb3acdaad2fc5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $32fdb3acdaad2fc5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $32fdb3acdaad2fc5$export$10c90e4f7922046c(v) {
    return this instanceof $32fdb3acdaad2fc5$export$10c90e4f7922046c ? (this.v = v, this) : new $32fdb3acdaad2fc5$export$10c90e4f7922046c(v);
}
function $32fdb3acdaad2fc5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $32fdb3acdaad2fc5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $32fdb3acdaad2fc5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $32fdb3acdaad2fc5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $32fdb3acdaad2fc5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $32fdb3acdaad2fc5$export$19a8beecd37a4c45 === "function" ? $32fdb3acdaad2fc5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $32fdb3acdaad2fc5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $32fdb3acdaad2fc5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $32fdb3acdaad2fc5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $32fdb3acdaad2fc5$export$45d3717a4c69092e(result, mod, k);
    }
    $32fdb3acdaad2fc5$var$__setModuleDefault(result, mod);
    return result;
}
function $32fdb3acdaad2fc5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $32fdb3acdaad2fc5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $32fdb3acdaad2fc5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $32fdb3acdaad2fc5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $32fdb3acdaad2fc5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $32fdb3acdaad2fc5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $32fdb3acdaad2fc5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $32fdb3acdaad2fc5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $32fdb3acdaad2fc5$export$2e2bcd8739ae039 = {
    __extends: $32fdb3acdaad2fc5$export$a8ba968b8961cb8a,
    __assign: $32fdb3acdaad2fc5$export$18ce0697a983be9b,
    __rest: $32fdb3acdaad2fc5$export$3c9a16f847548506,
    __decorate: $32fdb3acdaad2fc5$export$29e00dfd3077644b,
    __param: $32fdb3acdaad2fc5$export$d5ad3fd78186038f,
    __metadata: $32fdb3acdaad2fc5$export$f1db080c865becb9,
    __awaiter: $32fdb3acdaad2fc5$export$1050f835b63b671e,
    __generator: $32fdb3acdaad2fc5$export$67ebef60e6f28a6,
    __createBinding: $32fdb3acdaad2fc5$export$45d3717a4c69092e,
    __exportStar: $32fdb3acdaad2fc5$export$f33643c0debef087,
    __values: $32fdb3acdaad2fc5$export$19a8beecd37a4c45,
    __read: $32fdb3acdaad2fc5$export$8d051b38c9118094,
    __spread: $32fdb3acdaad2fc5$export$afc72e2116322959,
    __spreadArrays: $32fdb3acdaad2fc5$export$6388937ca91ccae8,
    __spreadArray: $32fdb3acdaad2fc5$export$1216008129fb82ed,
    __await: $32fdb3acdaad2fc5$export$10c90e4f7922046c,
    __asyncGenerator: $32fdb3acdaad2fc5$export$e427f37a30a4de9b,
    __asyncDelegator: $32fdb3acdaad2fc5$export$bbd80228419bb833,
    __asyncValues: $32fdb3acdaad2fc5$export$e3b29a3d6162315f,
    __makeTemplateObject: $32fdb3acdaad2fc5$export$4fb47efe1390b86f,
    __importStar: $32fdb3acdaad2fc5$export$c21735bcef00d192,
    __importDefault: $32fdb3acdaad2fc5$export$da59b14a69baef04,
    __classPrivateFieldGet: $32fdb3acdaad2fc5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $32fdb3acdaad2fc5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $32fdb3acdaad2fc5$export$81fdc39f203e4e04,
    __addDisposableResource: $32fdb3acdaad2fc5$export$88ac25d8e944e405,
    __disposeResources: $32fdb3acdaad2fc5$export$8f076105dc360e92
};

});

parcelRegister("3jFHS", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $26a37f8b88fa9a88$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "createElement", function () { return $26a37f8b88fa9a88$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $26a37f8b88fa9a88$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $26a37f8b88fa9a88$export$ffb0004e005737fa; });
$parcel$export(module.exports, "createContext", function () { return $26a37f8b88fa9a88$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "createPortal", function () { return $26a37f8b88fa9a88$export$d39a5bbd09211389; });
/// <reference types="@fullcalendar/core-preact" />
if (typeof FullCalendarVDom === "undefined") throw new Error("Please import the top-level fullcalendar lib before attempting to import a plugin.");
var $26a37f8b88fa9a88$export$16fa2f45be04daa8 = FullCalendarVDom.Component;
var $26a37f8b88fa9a88$export$c8a8987d4410bf2d = FullCalendarVDom.createElement;
var $26a37f8b88fa9a88$export$b3890eb0ae9dca99 = FullCalendarVDom.render;
var $26a37f8b88fa9a88$export$7d1e3a5e95ceca43 = FullCalendarVDom.createRef;
var $26a37f8b88fa9a88$export$ffb0004e005737fa = FullCalendarVDom.Fragment;
var $26a37f8b88fa9a88$export$fd42f52fd3ae1109 = FullCalendarVDom.createContext;
var $26a37f8b88fa9a88$export$d39a5bbd09211389 = FullCalendarVDom.createPortal;
var $26a37f8b88fa9a88$export$cd75ccfd720a3cd4 = FullCalendarVDom.flushSync;
var $26a37f8b88fa9a88$export$502457920280e6be = FullCalendarVDom.unmountComponentAtNode;

});


parcelRegister("d2yo0", function(module, exports) {

$parcel$export(module.exports, "TableView", function () { return TableView; });
$parcel$export(module.exports, "Table", function () { return Table; });
$parcel$export(module.exports, "DayTableSlicer", function () { return DayTableSlicer; });
$parcel$export(module.exports, "DayTable", function () { return DayTable; });
$parcel$export(module.exports, "DayGridView", function () { return DayTableView; });
$parcel$export(module.exports, "buildDayTableModel", function () { return buildDayTableModel; });
$parcel$export(module.exports, "default", function () { return $97e622a2538140da$export$2e2bcd8739ae039; });
/*!
FullCalendar v5.11.5
Docs & License: https://fullcalendar.io/
(c) 2022 Adam Shaw
*/ 

var $8XAxF = parcelRequire("8XAxF");

var $4nqhV = parcelRequire("4nqhV");
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var TableView = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableView, _super);
    function TableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerElRef = (0, $8XAxF.createRef)();
        return _this;
    }
    TableView.prototype.renderSimpleLayout = function(headerRowContent, bodyContent) {
        var _a = this, props = _a.props, context = _a.context;
        var sections = [];
        var stickyHeaderDates = (0, $8XAxF.getStickyHeaderDates)(context.options);
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: "fc-col-header",
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $8XAxF.createElement)((0, $8XAxF.ViewRoot), {
            viewSpec: context.viewSpec
        }, function(rootElRef, classNames) {
            return (0, $8XAxF.createElement)("div", {
                ref: rootElRef,
                className: [
                    "fc-daygrid"
                ].concat(classNames).join(" ")
            }, (0, $8XAxF.createElement)((0, $8XAxF.SimpleScrollGrid), {
                liquid: !props.isHeightAuto && !props.forPrint,
                collapsibleWidth: props.forPrint,
                cols: [],
                sections: sections
            }));
        });
    };
    TableView.prototype.renderHScrollLayout = function(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
        var _a = this, props = _a.props, context = _a.context;
        var stickyHeaderDates = !props.forPrint && (0, $8XAxF.getStickyHeaderDates)(context.options);
        var stickyFooterScrollbar = !props.forPrint && (0, $8XAxF.getStickyFooterScrollbar)(context.options);
        var sections = [];
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: "main",
                    elRef: this.headerElRef,
                    tableClassName: "fc-col-header",
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            chunks: [
                {
                    key: "main",
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: "footer",
            key: "footer",
            isSticky: true,
            chunks: [
                {
                    key: "main",
                    content: (0, $8XAxF.renderScrollShim)
                }
            ]
        });
        return (0, $8XAxF.createElement)((0, $8XAxF.ViewRoot), {
            viewSpec: context.viewSpec
        }, function(rootElRef, classNames) {
            return (0, $8XAxF.createElement)("div", {
                ref: rootElRef,
                className: [
                    "fc-daygrid"
                ].concat(classNames).join(" ")
            }, (0, $8XAxF.createElement)(ScrollGrid, {
                liquid: !props.isHeightAuto && !props.forPrint,
                collapsibleWidth: props.forPrint,
                colGroups: [
                    {
                        cols: [
                            {
                                span: colCnt,
                                minWidth: dayMinWidth
                            }
                        ]
                    }
                ],
                sections: sections
            }));
        });
    };
    return TableView;
}((0, $8XAxF.DateComponent));
function splitSegsByRow(segs, rowCnt) {
    var byRow = [];
    for(var i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        byRow[seg.row].push(seg);
    }
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    var byCol = [];
    for(var i = 0; i < colCnt; i += 1)byCol[i] = [];
    for(var _i = 0, segs_2 = segs; _i < segs_2.length; _i++){
        var seg = segs_2[_i];
        byCol[seg.firstCol].push(seg);
    }
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    var byRow = [];
    if (!ui) for(var i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(var i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for(var _i = 0, _a = ui.segs; _i < _a.length; _i++){
            var seg = _a[_i];
            byRow[seg.row].segs.push(seg);
        }
    }
    return byRow;
}
var TableCellTop = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableCellTop, _super);
    function TableCellTop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCellTop.prototype.render = function() {
        var props = this.props;
        var navLinkAttrs = (0, $8XAxF.buildNavLinkAttrs)(this.context, props.date);
        return (0, $8XAxF.createElement)((0, $8XAxF.DayCellContent), {
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraHookProps: props.extraHookProps,
            defaultContent: renderTopInner
        }, function(innerElRef, innerContent) {
            return (innerContent || props.forceDayTop) && (0, $8XAxF.createElement)("div", {
                className: "fc-daygrid-day-top",
                ref: innerElRef
            }, (0, $8XAxF.createElement)("a", (0, $4nqhV.__assign)({
                id: props.dayNumberId,
                className: "fc-daygrid-day-number"
            }, navLinkAttrs), innerContent || (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, "\xa0")));
        });
    };
    return TableCellTop;
}((0, $8XAxF.BaseComponent));
function renderTopInner(props) {
    return props.dayNumberText;
}
var DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $8XAxF.createFormatter)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "narrow"
});
function hasListItemDisplay(seg) {
    var display = seg.eventRange.ui.display;
    return display === "list-item" || display === "auto" && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
var TableBlockEvent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableBlockEvent, _super);
    function TableBlockEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBlockEvent.prototype.render = function() {
        var props = this.props;
        return (0, $8XAxF.createElement)((0, $8XAxF.StandardEvent), (0, $4nqhV.__assign)({}, props, {
            extraClassNames: [
                "fc-daygrid-event",
                "fc-daygrid-block-event",
                "fc-h-event"
            ],
            defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    };
    return TableBlockEvent;
}((0, $8XAxF.BaseComponent));
var TableListItemEvent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableListItemEvent, _super);
    function TableListItemEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableListItemEvent.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var timeFormat = context.options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
        var timeText = (0, $8XAxF.buildSegTimeText)(props.seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $8XAxF.createElement)((0, $8XAxF.EventRoot), {
            seg: props.seg,
            timeText: timeText,
            defaultContent: renderInnerContent,
            isDragging: props.isDragging,
            isResizing: false,
            isDateSelecting: false,
            isSelected: props.isSelected,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday
        }, function(rootElRef, classNames, innerElRef, innerContent) {
            return (0, $8XAxF.createElement)("a", (0, $4nqhV.__assign)({
                className: [
                    "fc-daygrid-event",
                    "fc-daygrid-dot-event"
                ].concat(classNames).join(" "),
                ref: rootElRef
            }, (0, $8XAxF.getSegAnchorAttrs)(props.seg, context)), innerContent);
        });
    };
    return TableListItemEvent;
}((0, $8XAxF.BaseComponent));
function renderInnerContent(innerProps) {
    return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, (0, $8XAxF.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: innerProps.borderColor || innerProps.backgroundColor
        }
    }), innerProps.timeText && (0, $8XAxF.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $8XAxF.createElement)("div", {
        className: "fc-event-title"
    }, innerProps.event.title || (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, "\xa0")));
}
var TableCellMoreLink = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableCellMoreLink, _super);
    function TableCellMoreLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.compileSegs = (0, $8XAxF.memoize)(compileSegs);
        return _this;
    }
    TableCellMoreLink.prototype.render = function() {
        var props = this.props;
        var _a = this.compileSegs(props.singlePlacements), allSegs = _a.allSegs, invisibleSegs = _a.invisibleSegs;
        return (0, $8XAxF.createElement)((0, $8XAxF.MoreLinkRoot), {
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: function() {
                var isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, allSegs.map(function(seg) {
                    var instanceId = seg.eventRange.instance.instanceId;
                    return (0, $8XAxF.createElement)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? "hidden" : ""
                        }
                    }, hasListItemDisplay(seg) ? (0, $8XAxF.createElement)(TableListItemEvent, (0, $4nqhV.__assign)({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $8XAxF.getSegMeta)(seg, props.todayRange))) : (0, $8XAxF.createElement)(TableBlockEvent, (0, $4nqhV.__assign)({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $8XAxF.getSegMeta)(seg, props.todayRange))));
                }));
            }
        }, function(rootElRef, classNames, innerElRef, innerContent, handleClick, title, isExpanded, popoverId) {
            return (0, $8XAxF.createElement)("a", (0, $4nqhV.__assign)({
                ref: rootElRef,
                className: [
                    "fc-daygrid-more-link"
                ].concat(classNames).join(" "),
                title: title,
                "aria-expanded": isExpanded,
                "aria-controls": popoverId
            }, (0, $8XAxF.createAriaClickAttrs)(handleClick)), innerContent);
        });
    };
    return TableCellMoreLink;
}((0, $8XAxF.BaseComponent));
function compileSegs(singlePlacements) {
    var allSegs = [];
    var invisibleSegs = [];
    for(var _i = 0, singlePlacements_1 = singlePlacements; _i < singlePlacements_1.length; _i++){
        var placement = singlePlacements_1[_i];
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
var DEFAULT_WEEK_NUM_FORMAT = (0, $8XAxF.createFormatter)({
    week: "narrow"
});
var TableCell = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = (0, $8XAxF.createRef)();
        _this.state = {
            dayNumberId: (0, $8XAxF.getUniqueDomId)()
        };
        _this.handleRootEl = function(el) {
            (0, $8XAxF.setRef)(_this.rootElRef, el);
            (0, $8XAxF.setRef)(_this.props.elRef, el);
        };
        return _this;
    }
    TableCell.prototype.render = function() {
        var _a = this, context = _a.context, props = _a.props, state = _a.state, rootElRef = _a.rootElRef;
        var date = props.date, dateProfile = props.dateProfile;
        var navLinkAttrs = (0, $8XAxF.buildNavLinkAttrs)(context, date, "week");
        return (0, $8XAxF.createElement)((0, $8XAxF.DayCellRoot), {
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraHookProps: props.extraHookProps,
            elRef: this.handleRootEl
        }, function(dayElRef, dayClassNames, rootDataAttrs, isDisabled) {
            return (0, $8XAxF.createElement)("td", (0, $4nqhV.__assign)({
                ref: dayElRef,
                role: "gridcell",
                className: [
                    "fc-daygrid-day"
                ].concat(dayClassNames, props.extraClassNames || []).join(" ")
            }, rootDataAttrs, props.extraDataAttrs, props.showDayNumber ? {
                "aria-labelledby": state.dayNumberId
            } : {}), (0, $8XAxF.createElement)("div", {
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                ref: props.innerElRef /* different from hook system! RENAME */ 
            }, props.showWeekNumber && (0, $8XAxF.createElement)((0, $8XAxF.WeekNumberRoot), {
                date: date,
                defaultFormat: DEFAULT_WEEK_NUM_FORMAT
            }, function(weekElRef, weekClassNames, innerElRef, innerContent) {
                return (0, $8XAxF.createElement)("a", (0, $4nqhV.__assign)({
                    ref: weekElRef,
                    className: [
                        "fc-daygrid-week-number"
                    ].concat(weekClassNames).join(" ")
                }, navLinkAttrs), innerContent);
            }), !isDisabled && (0, $8XAxF.createElement)(TableCellTop, {
                date: date,
                dateProfile: dateProfile,
                showDayNumber: props.showDayNumber,
                dayNumberId: state.dayNumberId,
                forceDayTop: props.forceDayTop,
                todayRange: props.todayRange,
                extraHookProps: props.extraHookProps
            }), (0, $8XAxF.createElement)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $8XAxF.createElement)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $8XAxF.createElement)(TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $8XAxF.createElement)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
        });
    };
    return TableCell;
}((0, $8XAxF.DateComponent));
function computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, eventInstanceHeights, maxContentHeight, cells) {
    var hierarchy = new DayGridSegHierarchy();
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === "number") hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === "number") {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    var segInputs = [];
    var unknownHeightSegs = [];
    for(var i = 0; i < segs.length; i += 1){
        var seg = segs[i];
        var instanceId = seg.eventRange.instance.instanceId;
        var eventHeight = eventInstanceHeights[instanceId];
        if (eventHeight != null) segInputs.push({
            index: i,
            thickness: eventHeight,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var segRects = hierarchy.toRects();
    var _a = placeRects(segRects, segs, cells), singleColPlacements = _a.singleColPlacements, multiColPlacements = _a.multiColPlacements, leftoverMargins = _a.leftoverMargins;
    var moreCnts = [];
    var moreMarginTops = [];
    // add segs with unknown heights
    for(var _i = 0, unknownHeightSegs_1 = unknownHeightSegs; _i < unknownHeightSegs_1.length; _i++){
        var seg = unknownHeightSegs_1[_i];
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(var col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(var col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for(var _b = 0, hiddenEntries_1 = hiddenEntries; _b < hiddenEntries_1.length; _b++){
        var hiddenEntry = hiddenEntries_1[_b];
        var seg = segs[hiddenEntry.index];
        var hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(var col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(var col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    var rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    var singleColPlacements = [];
    var multiColPlacements = [];
    var leftoverMargins = [];
    for(var col = 0; col < cells.length; col += 1){
        var rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        var singlePlacements = [];
        var currentHeight = 0;
        var currentMarginTop = 0;
        for(var _i = 0, rects_1 = rects; _i < rects_1.length; _i++){
            var rect = rects_1[_i];
            var seg = segs[rect.index];
            singlePlacements.push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        var multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for(var _a = 0, rects_2 = rects; _a < rects_2.length; _a++){
            var rect = rects_2[_a];
            var seg = segs[rect.index];
            var isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            var isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function groupRectsByEachCol(rects, colCnt) {
    var rectsByEachCol = [];
    for(var col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for(var _i = 0, rects_3 = rects; _i < rects_3.length; _i++){
        var rect = rects_3[_i];
        for(var col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    }
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    var eventRange = seg.eventRange;
    var origRange = eventRange.range;
    var slicedRange = (0, $8XAxF.intersectRanges)(origRange, {
        start: cells[spanStart].date,
        end: (0, $8XAxF.addDays)(cells[spanEnd - 1].date, 1)
    });
    return (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
var DayGridSegHierarchy = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayGridSegHierarchy, _super);
    function DayGridSegHierarchy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // config
        _this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        _this.forceHidden = {};
        return _this;
    }
    DayGridSegHierarchy.prototype.addSegs = function(segInputs) {
        var _this = this;
        var hiddenSegs = _super.prototype.addSegs.call(this, segInputs);
        var entriesByLevel = this.entriesByLevel;
        var excludeHidden = function(entry) {
            return !_this.forceHidden[(0, $8XAxF.buildEntryKey)(entry)];
        };
        // remove the forced-hidden segs
        for(var level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    };
    DayGridSegHierarchy.prototype.handleInvalidInsertion = function(insertion, entry, hiddenEntries) {
        var _a = this, entriesByLevel = _a.entriesByLevel, forceHidden = _a.forceHidden;
        var touchingEntry = insertion.touchingEntry, touchingLevel = insertion.touchingLevel, touchingLateral = insertion.touchingLateral;
        if (this.hiddenConsumes && touchingEntry) {
            var touchingEntryId = (0, $8XAxF.buildEntryKey)(touchingEntry);
            // if not already hidden
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    var placeholderEntry = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, touchingEntry), {
                        span: (0, $8XAxF.intersectSpans)(touchingEntry.span, entry.span)
                    });
                    var placeholderEntryId = (0, $8XAxF.buildEntryKey)(placeholderEntry);
                    forceHidden[placeholderEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = placeholderEntry; // replace touchingEntry with our placeholder
                    this.splitEntry(touchingEntry, entry, hiddenEntries); // split up the touchingEntry, reinsert it
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        return _super.prototype.handleInvalidInsertion.call(this, insertion, entry, hiddenEntries);
    };
    return DayGridSegHierarchy;
}((0, $8XAxF.SegHierarchy));
var TableRow = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableRow, _super);
    function TableRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cellElRefs = new (0, $8XAxF.RefMap)(); // the <td>
        _this.frameElRefs = new (0, $8XAxF.RefMap)(); // the fc-daygrid-day-frame
        _this.fgElRefs = new (0, $8XAxF.RefMap)(); // the fc-daygrid-day-events
        _this.segHarnessRefs = new (0, $8XAxF.RefMap)(); // indexed by "instanceId:firstCol"
        _this.rootElRef = (0, $8XAxF.createRef)();
        _this.state = {
            framePositions: null,
            maxContentHeight: null,
            eventInstanceHeights: {}
        };
        return _this;
    }
    TableRow.prototype.render = function() {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state, context = _a.context;
        var options = context.options;
        var colCnt = props.cells.length;
        var businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
        var bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
        var highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        var mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        var _b = computeFgSegPlacement((0, $8XAxF.sortEventSegs)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.eventInstanceHeights, state.maxContentHeight, props.cells), singleColPlacements = _b.singleColPlacements, multiColPlacements = _b.multiColPlacements, moreCnts = _b.moreCnts, moreMarginTops = _b.moreMarginTops;
        var isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $8XAxF.createElement)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map(function(cell, col) {
            var normalFgNodes = _this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            var mirrorFgNodes = _this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $8XAxF.createElement)(TableCell, {
                key: cell.key,
                elRef: _this.cellElRefs.createRef(cell.key),
                innerElRef: _this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraHookProps: cell.extraHookProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: _this.fgElRefs.createRef(cell.key),
                fgContent: (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, normalFgNodes), (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, mirrorFgNodes)),
                bgContent: (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, _this.renderFillSegs(highlightSegsByCol[col], "highlight"), _this.renderFillSegs(businessHoursByCol[col], "non-business"), _this.renderFillSegs(bgEventSegsByCol[col], "bg-event"))
            });
        }));
    };
    TableRow.prototype.componentDidMount = function() {
        this.updateSizing(true);
    };
    TableRow.prototype.componentDidUpdate = function(prevProps, prevState) {
        var currentProps = this.props;
        this.updateSizing(!(0, $8XAxF.isPropsEqual)(prevProps, currentProps));
    };
    TableRow.prototype.getHighlightSegs = function() {
        var props = this.props;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    };
    TableRow.prototype.getMirrorSegs = function() {
        var props = this.props;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    };
    TableRow.prototype.renderFgSegs = function(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        var context = this.context;
        var eventSelection = this.props.eventSelection;
        var framePositions = this.state.framePositions;
        var defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        var isMirror = isDragging || isResizing || isDateSelecting;
        var nodes = [];
        if (framePositions) for(var _i = 0, segPlacements_1 = segPlacements; _i < segPlacements_1.length; _i++){
            var placement = segPlacements_1[_i];
            var seg = placement.seg;
            var instanceId = seg.eventRange.instance.instanceId;
            var key = instanceId + ":" + col;
            var isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            var isAbsolute = placement.isAbsolute;
            var left = "";
            var right = "";
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $8XAxF.createElement)("div", {
                className: "fc-daygrid-event-harness" + (isAbsolute ? " fc-daygrid-event-harness-abs" : ""),
                key: key,
                ref: isMirror ? null : this.segHarnessRefs.createRef(key),
                style: {
                    visibility: isVisible ? "" : "hidden",
                    marginTop: isAbsolute ? "" : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : "",
                    left: left,
                    right: right
                }
            }, hasListItemDisplay(seg) ? (0, $8XAxF.createElement)(TableListItemEvent, (0, $4nqhV.__assign)({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $8XAxF.getSegMeta)(seg, todayRange))) : (0, $8XAxF.createElement)(TableBlockEvent, (0, $4nqhV.__assign)({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $8XAxF.getSegMeta)(seg, todayRange)))));
        }
        return nodes;
    };
    TableRow.prototype.renderFillSegs = function(segs, fillType) {
        var isRtl = this.context.isRtl;
        var todayRange = this.props.todayRange;
        var framePositions = this.state.framePositions;
        var nodes = [];
        if (framePositions) for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
            var seg = segs_1[_i];
            var leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $8XAxF.createElement)("div", {
                key: (0, $8XAxF.buildEventRangeKey)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === "bg-event" ? (0, $8XAxF.createElement)((0, $8XAxF.BgEvent), (0, $4nqhV.__assign)({
                seg: seg
            }, (0, $8XAxF.getSegMeta)(seg, todayRange))) : (0, $8XAxF.renderFill)(fillType)));
        }
        return (0, $8XAxF.createElement).apply(void 0, (0, $4nqhV.__spreadArray)([
            (0, $8XAxF.Fragment),
            {}
        ], nodes));
    };
    TableRow.prototype.updateSizing = function(isExternalSizingChange) {
        var _a = this, props = _a.props, frameElRefs = _a.frameElRefs;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                var frameEls = props.cells.map(function(cell) {
                    return frameElRefs.currentMap[cell.key];
                });
                if (frameEls.length) {
                    var originEl = this.rootElRef.current;
                    this.setState({
                        framePositions: new (0, $8XAxF.PositionCache)(originEl, frameEls, true, false)
                    });
                }
            }
            var oldInstanceHeights = this.state.eventInstanceHeights;
            var newInstanceHeights = this.queryEventInstanceHeights();
            var limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                eventInstanceHeights: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, oldInstanceHeights), newInstanceHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    };
    TableRow.prototype.queryEventInstanceHeights = function() {
        var segElMap = this.segHarnessRefs.currentMap;
        var eventInstanceHeights = {};
        // get the max height amongst instance segs
        for(var key in segElMap){
            var height = Math.round(segElMap[key].getBoundingClientRect().height);
            var instanceId = key.split(":")[0]; // deconstruct how renderFgSegs makes the key
            eventInstanceHeights[instanceId] = Math.max(eventInstanceHeights[instanceId] || 0, height);
        }
        return eventInstanceHeights;
    };
    TableRow.prototype.computeMaxContentHeight = function() {
        var firstKey = this.props.cells[0].key;
        var cellEl = this.cellElRefs.currentMap[firstKey];
        var fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    };
    TableRow.prototype.getCellEls = function() {
        var elMap = this.cellElRefs.currentMap;
        return this.props.cells.map(function(cell) {
            return elMap[cell.key];
        });
    };
    return TableRow;
}((0, $8XAxF.DateComponent));
TableRow.addStateEquality({
    eventInstanceHeights: (0, $8XAxF.isPropsEqual)
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    var topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map(function(seg) {
        return {
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        };
    });
}
function buildAbsoluteTopHash(colPlacements) {
    var topsByInstanceId = {};
    for(var _i = 0, colPlacements_1 = colPlacements; _i < colPlacements_1.length; _i++){
        var placements = colPlacements_1[_i];
        for(var _a = 0, placements_1 = placements; _a < placements_1.length; _a++){
            var placement = placements_1[_a];
            topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
        }
    }
    return topsByInstanceId;
}
var Table = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(Table, _super);
    function Table() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitBusinessHourSegs = (0, $8XAxF.memoize)(splitSegsByRow);
        _this.splitBgEventSegs = (0, $8XAxF.memoize)(splitSegsByRow);
        _this.splitFgEventSegs = (0, $8XAxF.memoize)(splitSegsByRow);
        _this.splitDateSelectionSegs = (0, $8XAxF.memoize)(splitSegsByRow);
        _this.splitEventDrag = (0, $8XAxF.memoize)(splitInteractionByRow);
        _this.splitEventResize = (0, $8XAxF.memoize)(splitInteractionByRow);
        _this.rowRefs = new (0, $8XAxF.RefMap)();
        _this.handleRootEl = function(rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) _this.context.registerInteractiveComponent(_this, {
                el: rootEl,
                isHitComboAllowed: _this.props.isHitComboAllowed
            });
            else _this.context.unregisterInteractiveComponent(_this);
        };
        return _this;
    }
    Table.prototype.render = function() {
        var _this = this;
        var props = this.props;
        var dateProfile = props.dateProfile, dayMaxEventRows = props.dayMaxEventRows, dayMaxEvents = props.dayMaxEvents, expandRows = props.expandRows;
        var rowCnt = props.cells.length;
        var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        var eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        var eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        var limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        var classNames = [
            "fc-daygrid-body",
            limitViaBalanced ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
            expandRows ? "" : "fc-daygrid-body-natural"
        ];
        return (0, $8XAxF.createElement)("div", {
            className: classNames.join(" "),
            ref: this.handleRootEl,
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $8XAxF.createElement)((0, $8XAxF.NowTimer), {
            unit: "day"
        }, function(nowDate, todayRange) {
            return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, (0, $8XAxF.createElement)("table", {
                role: "presentation",
                className: "fc-scrollgrid-sync-table",
                style: {
                    width: props.clientWidth,
                    minWidth: props.tableMinWidth,
                    height: expandRows ? props.clientHeight : ""
                }
            }, props.colGroupNode, (0, $8XAxF.createElement)("tbody", {
                role: "presentation"
            }, props.cells.map(function(cells, row) {
                return (0, $8XAxF.createElement)(TableRow, {
                    ref: _this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row].filter(isSegAllDay),
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: dayMaxEvents,
                    dayMaxEventRows: dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    forPrint: props.forPrint
                });
            }))));
        }));
    };
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    Table.prototype.prepareHits = function() {
        this.rowPositions = new (0, $8XAxF.PositionCache)(this.rootEl, this.rowRefs.collect().map(function(rowObj) {
            return rowObj.getCellEls()[0];
        }), false, true);
        this.colPositions = new (0, $8XAxF.PositionCache)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    };
    Table.prototype.queryHit = function(positionLeft, positionTop) {
        var _a = this, colPositions = _a.colPositions, rowPositions = _a.rowPositions;
        var col = colPositions.leftToIndex(positionLeft);
        var row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            var cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: (0, $4nqhV.__assign)({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    };
    Table.prototype.getCellEl = function(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    };
    Table.prototype.getCellRange = function(row, col) {
        var start = this.props.cells[row][col].date;
        var end = (0, $8XAxF.addDays)(start, 1);
        return {
            start: start,
            end: end
        };
    };
    return Table;
}((0, $8XAxF.DateComponent));
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
var DayTableSlicer = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayTableSlicer, _super);
    function DayTableSlicer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceDayIfListItem = true;
        return _this;
    }
    DayTableSlicer.prototype.sliceRange = function(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    };
    return DayTableSlicer;
}((0, $8XAxF.Slicer));
var DayTable = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayTable, _super);
    function DayTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slicer = new DayTableSlicer();
        _this.tableRef = (0, $8XAxF.createRef)();
        return _this;
    }
    DayTable.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        return (0, $8XAxF.createElement)(Table, (0, $4nqhV.__assign)({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    };
    return DayTable;
}((0, $8XAxF.DateComponent));
var DayTableView = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayTableView, _super);
    function DayTableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayTableModel = (0, $8XAxF.memoize)(buildDayTableModel);
        _this.headerRef = (0, $8XAxF.createRef)();
        _this.tableRef = (0, $8XAxF.createRef)();
        return _this;
    }
    DayTableView.prototype.render = function() {
        var _this = this;
        var _a = this.context, options = _a.options, dateProfileGenerator = _a.dateProfileGenerator;
        var props = this.props;
        var dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        var headerContent = options.dayHeaders && (0, $8XAxF.createElement)((0, $8XAxF.DayHeader), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        var bodyContent = function(contentArg) {
            return (0, $8XAxF.createElement)(DayTable, {
                ref: _this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: _this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        };
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    };
    return DayTableView;
}(TableView);
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    var daySeries = new (0, $8XAxF.DaySeriesModel)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $8XAxF.DayTableModel)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
var TableDateProfileGenerator = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TableDateProfileGenerator, _super);
    function TableDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    TableDateProfileGenerator.prototype.buildRenderRange = function(currentRange, currentRangeUnit, isRangeAllDay) {
        var dateEnv = this.props.dateEnv;
        var renderRange = _super.prototype.buildRenderRange.call(this, currentRange, currentRangeUnit, isRangeAllDay);
        var start = renderRange.start;
        var end = renderRange.end;
        var endOfWeek;
        // year and month views should be aligned with weeks. this is already done for week
        if (/^(year|month)$/.test(currentRangeUnit)) {
            start = dateEnv.startOfWeek(start);
            // make end-of-week if not already
            endOfWeek = dateEnv.startOfWeek(end);
            if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $8XAxF.addWeeks)(endOfWeek, 1);
        }
        // ensure 6 weeks
        if (this.props.monthMode && this.props.fixedWeekCount) {
            var rowCnt = Math.ceil((0, $8XAxF.diffWeeks)(start, end));
            end = (0, $8XAxF.addWeeks)(end, 6 - rowCnt);
        }
        return {
            start: start,
            end: end
        };
    };
    return TableDateProfileGenerator;
}((0, $8XAxF.DateProfileGenerator));
var main = (0, $8XAxF.createPlugin)({
    initialView: "dayGridMonth",
    views: {
        dayGrid: {
            component: DayTableView,
            dateProfileGeneratorClass: TableDateProfileGenerator
        },
        dayGridDay: {
            type: "dayGrid",
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: "dayGrid",
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: "dayGrid",
            duration: {
                months: 1
            },
            monthMode: true,
            fixedWeekCount: true
        }
    }
});
var $97e622a2538140da$export$2e2bcd8739ae039 = main;

});

parcelRegister("MPJvb", function(module, exports) {

$parcel$export(module.exports, "TimeColsView", function () { return TimeColsView; });
$parcel$export(module.exports, "TimeColsSlatsCoords", function () { return TimeColsSlatsCoords; });
$parcel$export(module.exports, "TimeCols", function () { return TimeCols; });
$parcel$export(module.exports, "DayTimeColsSlicer", function () { return DayTimeColsSlicer; });
$parcel$export(module.exports, "DayTimeCols", function () { return DayTimeCols; });
$parcel$export(module.exports, "buildDayRanges", function () { return buildDayRanges; });
$parcel$export(module.exports, "buildSlatMetas", function () { return buildSlatMetas; });
$parcel$export(module.exports, "DayTimeColsView", function () { return DayTimeColsView; });
$parcel$export(module.exports, "buildTimeColsModel", function () { return buildTimeColsModel; });
$parcel$export(module.exports, "default", function () { return $092c9ce2edced379$export$2e2bcd8739ae039; });
/*!
FullCalendar v5.11.5
Docs & License: https://fullcalendar.io/
(c) 2022 Adam Shaw
*/ 

var $8XAxF = parcelRequire("8XAxF");

var $4nqhV = parcelRequire("4nqhV");

var $d2yo0 = parcelRequire("d2yo0");
var AllDaySplitter = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(AllDaySplitter, _super);
    function AllDaySplitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllDaySplitter.prototype.getKeyInfo = function() {
        return {
            allDay: {},
            timed: {}
        };
    };
    AllDaySplitter.prototype.getKeysForDateSpan = function(dateSpan) {
        if (dateSpan.allDay) return [
            "allDay"
        ];
        return [
            "timed"
        ];
    };
    AllDaySplitter.prototype.getKeysForEventDef = function(eventDef) {
        if (!eventDef.allDay) return [
            "timed"
        ];
        if ((0, $8XAxF.hasBgRendering)(eventDef)) return [
            "timed",
            "allDay"
        ];
        return [
            "allDay"
        ];
    };
    return AllDaySplitter;
}((0, $8XAxF.Splitter));
var DEFAULT_SLAT_LABEL_FORMAT = (0, $8XAxF.createFormatter)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "short"
});
function TimeColsAxisCell(props) {
    var classNames = [
        "fc-timegrid-slot",
        "fc-timegrid-slot-label",
        props.isLabeled ? "fc-scrollgrid-shrink" : "fc-timegrid-slot-minor"
    ];
    return (0, $8XAxF.createElement)((0, $8XAxF.ViewContextType).Consumer, null, function(context) {
        if (!props.isLabeled) return (0, $8XAxF.createElement)("td", {
            className: classNames.join(" "),
            "data-time": props.isoTimeStr
        });
        var dateEnv = context.dateEnv, options = context.options, viewApi = context.viewApi;
        var labelFormat = options.slotLabelFormat == null ? DEFAULT_SLAT_LABEL_FORMAT : Array.isArray(options.slotLabelFormat) ? (0, $8XAxF.createFormatter)(options.slotLabelFormat[0]) : (0, $8XAxF.createFormatter)(options.slotLabelFormat);
        var hookProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat)
        };
        return (0, $8XAxF.createElement)((0, $8XAxF.RenderHook), {
            hookProps: hookProps,
            classNames: options.slotLabelClassNames,
            content: options.slotLabelContent,
            defaultContent: renderInnerContent,
            didMount: options.slotLabelDidMount,
            willUnmount: options.slotLabelWillUnmount
        }, function(rootElRef, customClassNames, innerElRef, innerContent) {
            return (0, $8XAxF.createElement)("td", {
                ref: rootElRef,
                className: classNames.concat(customClassNames).join(" "),
                "data-time": props.isoTimeStr
            }, (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame"
            }, (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-slot-label-cushion fc-scrollgrid-shrink-cushion",
                ref: innerElRef
            }, innerContent)));
        });
    });
}
function renderInnerContent(props) {
    return props.text;
}
var TimeBodyAxis = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeBodyAxis, _super);
    function TimeBodyAxis() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeBodyAxis.prototype.render = function() {
        return this.props.slatMetas.map(function(slatMeta) {
            return (0, $8XAxF.createElement)("tr", {
                key: slatMeta.key
            }, (0, $8XAxF.createElement)(TimeColsAxisCell, (0, $4nqhV.__assign)({}, slatMeta)));
        });
    };
    return TimeBodyAxis;
}((0, $8XAxF.BaseComponent));
var DEFAULT_WEEK_NUM_FORMAT = (0, $8XAxF.createFormatter)({
    week: "short"
});
var AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
var TimeColsView = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColsView, _super);
    function TimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allDaySplitter = new AllDaySplitter(); // for use by subclasses
        _this.headerElRef = (0, $8XAxF.createRef)();
        _this.rootElRef = (0, $8XAxF.createRef)();
        _this.scrollerElRef = (0, $8XAxF.createRef)();
        _this.state = {
            slatCoords: null
        };
        _this.handleScrollTopRequest = function(scrollTop) {
            var scrollerEl = _this.scrollerElRef.current;
            if (scrollerEl) scrollerEl.scrollTop = scrollTop;
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ _this.renderHeadAxis = function(rowKey, frameHeight) {
            if (frameHeight === void 0) frameHeight = "";
            var options = _this.context.options;
            var dateProfile = _this.props.dateProfile;
            var range = dateProfile.renderRange;
            var dayCnt = (0, $8XAxF.diffDays)(range.start, range.end);
            var navLinkAttrs = dayCnt === 1 // only do in day views (to avoid doing in week views that dont need it)
             ? (0, $8XAxF.buildNavLinkAttrs)(_this.context, range.start, "week") : {};
            if (options.weekNumbers && rowKey === "day") return (0, $8XAxF.createElement)((0, $8XAxF.WeekNumberRoot), {
                date: range.start,
                defaultFormat: DEFAULT_WEEK_NUM_FORMAT
            }, function(rootElRef, classNames, innerElRef, innerContent) {
                return (0, $8XAxF.createElement)("th", {
                    ref: rootElRef,
                    "aria-hidden": true,
                    className: [
                        "fc-timegrid-axis",
                        "fc-scrollgrid-shrink"
                    ].concat(classNames).join(" ")
                }, (0, $8XAxF.createElement)("div", {
                    className: "fc-timegrid-axis-frame fc-scrollgrid-shrink-frame fc-timegrid-axis-frame-liquid",
                    style: {
                        height: frameHeight
                    }
                }, (0, $8XAxF.createElement)("a", (0, $4nqhV.__assign)({
                    ref: innerElRef,
                    className: "fc-timegrid-axis-cushion fc-scrollgrid-shrink-cushion fc-scrollgrid-sync-inner"
                }, navLinkAttrs), innerContent)));
            });
            return (0, $8XAxF.createElement)("th", {
                "aria-hidden": true,
                className: "fc-timegrid-axis"
            }, (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-axis-frame",
                style: {
                    height: frameHeight
                }
            }));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        _this.renderTableRowAxis = function(rowHeight) {
            var _a = _this.context, options = _a.options, viewApi = _a.viewApi;
            var hookProps = {
                text: options.allDayText,
                view: viewApi
            };
            return(// TODO: make reusable hook. used in list view too
            (0, $8XAxF.createElement)((0, $8XAxF.RenderHook), {
                hookProps: hookProps,
                classNames: options.allDayClassNames,
                content: options.allDayContent,
                defaultContent: renderAllDayInner,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            }, function(rootElRef, classNames, innerElRef, innerContent) {
                return (0, $8XAxF.createElement)("td", {
                    ref: rootElRef,
                    "aria-hidden": true,
                    className: [
                        "fc-timegrid-axis",
                        "fc-scrollgrid-shrink"
                    ].concat(classNames).join(" ")
                }, (0, $8XAxF.createElement)("div", {
                    className: "fc-timegrid-axis-frame fc-scrollgrid-shrink-frame" + (rowHeight == null ? " fc-timegrid-axis-frame-liquid" : ""),
                    style: {
                        height: rowHeight
                    }
                }, (0, $8XAxF.createElement)("span", {
                    className: "fc-timegrid-axis-cushion fc-scrollgrid-shrink-cushion fc-scrollgrid-sync-inner",
                    ref: innerElRef
                }, innerContent)));
            }));
        };
        _this.handleSlatCoords = function(slatCoords) {
            _this.setState({
                slatCoords: slatCoords
            });
        };
        return _this;
    }
    // rendering
    // ----------------------------------------------------------------------------------------------------
    TimeColsView.prototype.renderSimpleLayout = function(headerRowContent, allDayContent, timeContent) {
        var _a = this, context = _a.context, props = _a.props;
        var sections = [];
        var stickyHeaderDates = (0, $8XAxF.getStickyHeaderDates)(context.options);
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: "fc-col-header",
                rowContent: headerRowContent
            }
        });
        if (allDayContent) {
            sections.push({
                type: "body",
                key: "all-day",
                chunk: {
                    content: allDayContent
                }
            });
            sections.push({
                type: "body",
                key: "all-day-divider",
                outerContent: (0, $8XAxF.createElement)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $8XAxF.createElement)("td", {
                    className: "fc-timegrid-divider " + context.theme.getClass("tableCellShaded")
                }))
            });
        }
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent
            }
        });
        return (0, $8XAxF.createElement)((0, $8XAxF.ViewRoot), {
            viewSpec: context.viewSpec,
            elRef: this.rootElRef
        }, function(rootElRef, classNames) {
            return (0, $8XAxF.createElement)("div", {
                className: [
                    "fc-timegrid"
                ].concat(classNames).join(" "),
                ref: rootElRef
            }, (0, $8XAxF.createElement)((0, $8XAxF.SimpleScrollGrid), {
                liquid: !props.isHeightAuto && !props.forPrint,
                collapsibleWidth: props.forPrint,
                cols: [
                    {
                        width: "shrink"
                    }
                ],
                sections: sections
            }));
        });
    };
    TimeColsView.prototype.renderHScrollLayout = function(headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        var _this = this;
        var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
        var _a = this, context = _a.context, props = _a.props;
        var stickyHeaderDates = !props.forPrint && (0, $8XAxF.getStickyHeaderDates)(context.options);
        var stickyFooterScrollbar = !props.forPrint && (0, $8XAxF.getStickyFooterScrollbar)(context.options);
        var sections = [];
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            syncRowHeights: true,
            chunks: [
                {
                    key: "axis",
                    rowContent: function(arg) {
                        return (0, $8XAxF.createElement)("tr", {
                            role: "presentation"
                        }, _this.renderHeadAxis("day", arg.rowSyncHeights[0]));
                    }
                },
                {
                    key: "cols",
                    elRef: this.headerElRef,
                    tableClassName: "fc-col-header",
                    rowContent: headerRowContent
                }
            ]
        });
        if (allDayContent) {
            sections.push({
                type: "body",
                key: "all-day",
                syncRowHeights: true,
                chunks: [
                    {
                        key: "axis",
                        rowContent: function(contentArg) {
                            return (0, $8XAxF.createElement)("tr", {
                                role: "presentation"
                            }, _this.renderTableRowAxis(contentArg.rowSyncHeights[0]));
                        }
                    },
                    {
                        key: "cols",
                        content: allDayContent
                    }
                ]
            });
            sections.push({
                key: "all-day-divider",
                type: "body",
                outerContent: (0, $8XAxF.createElement)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $8XAxF.createElement)("td", {
                    colSpan: 2,
                    className: "fc-timegrid-divider " + context.theme.getClass("tableCellShaded")
                }))
            });
        }
        var isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: "axis",
                    content: function(arg) {
                        return(// TODO: make this now-indicator arrow more DRY with TimeColsContent
                        (0, $8XAxF.createElement)("div", {
                            className: "fc-timegrid-axis-chunk"
                        }, (0, $8XAxF.createElement)("table", {
                            "aria-hidden": true,
                            style: {
                                height: arg.expandRows ? arg.clientHeight : ""
                            }
                        }, arg.tableColGroupNode, (0, $8XAxF.createElement)("tbody", null, (0, $8XAxF.createElement)(TimeBodyAxis, {
                            slatMetas: slatMetas
                        }))), (0, $8XAxF.createElement)("div", {
                            className: "fc-timegrid-now-indicator-container"
                        }, (0, $8XAxF.createElement)((0, $8XAxF.NowTimer), {
                            unit: isNowIndicator ? "minute" : "day" /* hacky */ 
                        }, function(nowDate) {
                            var nowIndicatorTop = isNowIndicator && slatCoords && slatCoords.safeComputeTop(nowDate); // might return void
                            if (typeof nowIndicatorTop === "number") return (0, $8XAxF.createElement)((0, $8XAxF.NowIndicatorRoot), {
                                isAxis: true,
                                date: nowDate
                            }, function(rootElRef, classNames, innerElRef, innerContent) {
                                return (0, $8XAxF.createElement)("div", {
                                    ref: rootElRef,
                                    className: [
                                        "fc-timegrid-now-indicator-arrow"
                                    ].concat(classNames).join(" "),
                                    style: {
                                        top: nowIndicatorTop
                                    }
                                }, innerContent);
                            });
                            return null;
                        }))));
                    }
                },
                {
                    key: "cols",
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            key: "footer",
            type: "footer",
            isSticky: true,
            chunks: [
                {
                    key: "axis",
                    content: (0, $8XAxF.renderScrollShim)
                },
                {
                    key: "cols",
                    content: (0, $8XAxF.renderScrollShim)
                }
            ]
        });
        return (0, $8XAxF.createElement)((0, $8XAxF.ViewRoot), {
            viewSpec: context.viewSpec,
            elRef: this.rootElRef
        }, function(rootElRef, classNames) {
            return (0, $8XAxF.createElement)("div", {
                className: [
                    "fc-timegrid"
                ].concat(classNames).join(" "),
                ref: rootElRef
            }, (0, $8XAxF.createElement)(ScrollGrid, {
                liquid: !props.isHeightAuto && !props.forPrint,
                collapsibleWidth: false,
                colGroups: [
                    {
                        width: "shrink",
                        cols: [
                            {
                                width: "shrink"
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                span: colCnt,
                                minWidth: dayMinWidth
                            }
                        ]
                    }
                ],
                sections: sections
            }));
        });
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/ TimeColsView.prototype.getAllDayMaxEventProps = function() {
        var _a = this.context.options, dayMaxEvents = _a.dayMaxEvents, dayMaxEventRows = _a.dayMaxEventRows;
        if (dayMaxEvents === true || dayMaxEventRows === true) {
            dayMaxEvents = undefined;
            dayMaxEventRows = AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return {
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows
        };
    };
    return TimeColsView;
}((0, $8XAxF.DateComponent));
function renderAllDayInner(hookProps) {
    return hookProps.text;
}
var TimeColsSlatsCoords = /** @class */ function() {
    function TimeColsSlatsCoords(positions, dateProfile, slotDuration) {
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    TimeColsSlatsCoords.prototype.safeComputeTop = function(date) {
        var dateProfile = this.dateProfile;
        if ((0, $8XAxF.rangeContainsMarker)(dateProfile.currentRange, date)) {
            var startOfDayDate = (0, $8XAxF.startOfDay)(date);
            var timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= (0, $8XAxF.asRoughMs)(dateProfile.slotMinTime) && timeMs < (0, $8XAxF.asRoughMs)(dateProfile.slotMaxTime)) return this.computeTimeTop((0, $8XAxF.createDuration)(timeMs));
        }
        return null;
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    TimeColsSlatsCoords.prototype.computeDateTop = function(when, startOfDayDate) {
        if (!startOfDayDate) startOfDayDate = (0, $8XAxF.startOfDay)(when);
        return this.computeTimeTop((0, $8XAxF.createDuration)(when.valueOf() - startOfDayDate.valueOf()));
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    TimeColsSlatsCoords.prototype.computeTimeTop = function(duration) {
        var _a = this, positions = _a.positions, dateProfile = _a.dateProfile;
        var len = positions.els.length;
        // floating-point value of # of slots covered
        var slatCoverage = (duration.milliseconds - (0, $8XAxF.asRoughMs)(dateProfile.slotMinTime)) / (0, $8XAxF.asRoughMs)(this.slotDuration);
        var slatIndex;
        var slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] + positions.getHeight(slatIndex) * slatRemainder;
    };
    return TimeColsSlatsCoords;
}();
var TimeColsSlatsBody = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColsSlatsBody, _super);
    function TimeColsSlatsBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColsSlatsBody.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var slatElRefs = props.slatElRefs;
        return (0, $8XAxF.createElement)("tbody", null, props.slatMetas.map(function(slatMeta, i) {
            var hookProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi
            };
            var classNames = [
                "fc-timegrid-slot",
                "fc-timegrid-slot-lane",
                slatMeta.isLabeled ? "" : "fc-timegrid-slot-minor"
            ];
            return (0, $8XAxF.createElement)("tr", {
                key: slatMeta.key,
                ref: slatElRefs.createRef(slatMeta.key)
            }, props.axis && (0, $8XAxF.createElement)(TimeColsAxisCell, (0, $4nqhV.__assign)({}, slatMeta)), (0, $8XAxF.createElement)((0, $8XAxF.RenderHook), {
                hookProps: hookProps,
                classNames: options.slotLaneClassNames,
                content: options.slotLaneContent,
                didMount: options.slotLaneDidMount,
                willUnmount: options.slotLaneWillUnmount
            }, function(rootElRef, customClassNames, innerElRef, innerContent) {
                return (0, $8XAxF.createElement)("td", {
                    ref: rootElRef,
                    className: classNames.concat(customClassNames).join(" "),
                    "data-time": slatMeta.isoTimeStr
                }, innerContent);
            }));
        }));
    };
    return TimeColsSlatsBody;
}((0, $8XAxF.BaseComponent));
/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/ var TimeColsSlats = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColsSlats, _super);
    function TimeColsSlats() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = (0, $8XAxF.createRef)();
        _this.slatElRefs = new (0, $8XAxF.RefMap)();
        return _this;
    }
    TimeColsSlats.prototype.render = function() {
        var _a = this, props = _a.props, context = _a.context;
        return (0, $8XAxF.createElement)("div", {
            ref: this.rootElRef,
            className: "fc-timegrid-slots"
        }, (0, $8XAxF.createElement)("table", {
            "aria-hidden": true,
            className: context.theme.getClass("table"),
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth,
                height: props.minHeight
            }
        }, props.tableColGroupNode /* relies on there only being a single <col> for the axis */ , (0, $8XAxF.createElement)(TimeColsSlatsBody, {
            slatElRefs: this.slatElRefs,
            axis: props.axis,
            slatMetas: props.slatMetas
        })));
    };
    TimeColsSlats.prototype.componentDidMount = function() {
        this.updateSizing();
    };
    TimeColsSlats.prototype.componentDidUpdate = function() {
        this.updateSizing();
    };
    TimeColsSlats.prototype.componentWillUnmount = function() {
        if (this.props.onCoords) this.props.onCoords(null);
    };
    TimeColsSlats.prototype.updateSizing = function() {
        var _a = this, context = _a.context, props = _a.props;
        if (props.onCoords && props.clientWidth !== null // means sizing has stabilized
        ) {
            var rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) props.onCoords(new TimeColsSlatsCoords(new (0, $8XAxF.PositionCache)(this.rootElRef.current, collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
        }
    };
    return TimeColsSlats;
}((0, $8XAxF.BaseComponent));
function collectSlatEls(elMap, slatMetas) {
    return slatMetas.map(function(slatMeta) {
        return elMap[slatMeta.key];
    });
}
function splitSegsByCol(segs, colCnt) {
    var segsByCol = [];
    var i;
    for(i = 0; i < colCnt; i += 1)segsByCol.push([]);
    if (segs) for(i = 0; i < segs.length; i += 1)segsByCol[segs[i].col].push(segs[i]);
    return segsByCol;
}
function splitInteractionByCol(ui, colCnt) {
    var byRow = [];
    if (!ui) for(var i = 0; i < colCnt; i += 1)byRow[i] = null;
    else {
        for(var i = 0; i < colCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for(var _i = 0, _a = ui.segs; _i < _a.length; _i++){
            var seg = _a[_i];
            byRow[seg.col].segs.push(seg);
        }
    }
    return byRow;
}
var TimeColMoreLink = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColMoreLink, _super);
    function TimeColMoreLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = (0, $8XAxF.createRef)();
        return _this;
    }
    TimeColMoreLink.prototype.render = function() {
        var _this = this;
        var props = this.props;
        return (0, $8XAxF.createElement)((0, $8XAxF.MoreLinkRoot), {
            allDayDate: null,
            moreCnt: props.hiddenSegs.length,
            allSegs: props.hiddenSegs,
            hiddenSegs: props.hiddenSegs,
            alignmentElRef: this.rootElRef,
            defaultContent: renderMoreLinkInner,
            extraDateSpan: props.extraDateSpan,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            popoverContent: function() {
                return renderPlainFgSegs(props.hiddenSegs, props);
            }
        }, function(rootElRef, classNames, innerElRef, innerContent, handleClick, title, isExpanded, popoverId) {
            return (0, $8XAxF.createElement)("a", {
                ref: function(el) {
                    (0, $8XAxF.setRef)(rootElRef, el);
                    (0, $8XAxF.setRef)(_this.rootElRef, el);
                },
                className: [
                    "fc-timegrid-more-link"
                ].concat(classNames).join(" "),
                style: {
                    top: props.top,
                    bottom: props.bottom
                },
                onClick: handleClick,
                title: title,
                "aria-expanded": isExpanded,
                "aria-controls": popoverId
            }, (0, $8XAxF.createElement)("div", {
                ref: innerElRef,
                className: "fc-timegrid-more-link-inner fc-sticky"
            }, innerContent));
        });
    };
    return TimeColMoreLink;
}((0, $8XAxF.BaseComponent));
function renderMoreLinkInner(props) {
    return props.shortText;
}
// segInputs assumed sorted
function buildPositioning(segInputs, strictOrder, maxStackCnt) {
    var hierarchy = new (0, $8XAxF.SegHierarchy)();
    if (strictOrder != null) hierarchy.strictOrder = strictOrder;
    if (maxStackCnt != null) hierarchy.maxStackCnt = maxStackCnt;
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var hiddenGroups = (0, $8XAxF.groupIntersectingEntries)(hiddenEntries);
    var web = buildWeb(hierarchy);
    web = stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    var segRects = webToRects(web);
    return {
        segRects: segRects,
        hiddenGroups: hiddenGroups
    };
}
function buildWeb(hierarchy) {
    var entriesByLevel = hierarchy.entriesByLevel;
    var buildNode = cacheable(function(level, lateral) {
        return level + ":" + lateral;
    }, function(level, lateral) {
        var siblingRange = findNextLevelSegs(hierarchy, level, lateral);
        var nextLevelRes = buildNodes(siblingRange, buildNode);
        var entry = entriesByLevel[level][lateral];
        return [
            (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, entry), {
                nextLevelNodes: nextLevelRes[0]
            }),
            entry.thickness + nextLevelRes[1]
        ];
    });
    return buildNodes(entriesByLevel.length ? {
        level: 0,
        lateralStart: 0,
        lateralEnd: entriesByLevel[0].length
    } : null, buildNode)[0];
}
function buildNodes(siblingRange, buildNode) {
    if (!siblingRange) return [
        [],
        0
    ];
    var level = siblingRange.level, lateralStart = siblingRange.lateralStart, lateralEnd = siblingRange.lateralEnd;
    var lateral = lateralStart;
    var pairs = [];
    while(lateral < lateralEnd){
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort(cmpDescPressures);
    return [
        pairs.map(extractNode),
        pairs[0][1]
    ];
}
function cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function extractNode(a) {
    return a[0];
}
function findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    var levelCoords = hierarchy.levelCoords, entriesByLevel = hierarchy.entriesByLevel;
    var subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    var afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    var levelCnt = levelCoords.length;
    var level = subjectLevel;
    // skip past levels that are too high up
    for(; level < levelCnt && levelCoords[level] < afterSubject; level += 1); // do nothing
    for(; level < levelCnt; level += 1){
        var entries = entriesByLevel[level];
        var entry = void 0;
        var searchIndex = (0, $8XAxF.binarySearch)(entries, subjectEntry.span.start, (0, $8XAxF.getEntrySpanEnd));
        var lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        var lateralEnd = lateralStart;
        while((entry = entries[lateralEnd]) && // but not past the whole seg list
        entry.span.start < subjectEntry.span.end)lateralEnd += 1;
        if (lateralStart < lateralEnd) return {
            level: level,
            lateralStart: lateralStart,
            lateralEnd: lateralEnd
        };
    }
    return null;
}
function stretchWeb(topLevelNodes, totalThickness) {
    var stretchNode = cacheable(function(node, startCoord, prevThickness) {
        return (0, $8XAxF.buildEntryKey)(node);
    }, function(node, startCoord, prevThickness) {
        var nextLevelNodes = node.nextLevelNodes, thickness = node.thickness;
        var allThickness = thickness + prevThickness;
        var thicknessFraction = thickness / allThickness;
        var endCoord;
        var newChildren = [];
        if (!nextLevelNodes.length) endCoord = totalThickness;
        else for(var _i = 0, nextLevelNodes_1 = nextLevelNodes; _i < nextLevelNodes_1.length; _i++){
            var childNode = nextLevelNodes_1[_i];
            if (endCoord === undefined) {
                var res = stretchNode(childNode, startCoord, allThickness);
                endCoord = res[0];
                newChildren.push(res[1]);
            } else {
                var res = stretchNode(childNode, endCoord, 0);
                newChildren.push(res[1]);
            }
        }
        var newThickness = (endCoord - startCoord) * thicknessFraction;
        return [
            endCoord - newThickness,
            (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, node), {
                thickness: newThickness,
                nextLevelNodes: newChildren
            })
        ];
    });
    return topLevelNodes.map(function(node) {
        return stretchNode(node, 0, 0)[1];
    });
}
// not sorted in any particular order
function webToRects(topLevelNodes) {
    var rects = [];
    var processNode = cacheable(function(node, levelCoord, stackDepth) {
        return (0, $8XAxF.buildEntryKey)(node);
    }, function(node, levelCoord, stackDepth) {
        var rect = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, node), {
            levelCoord: levelCoord,
            stackDepth: stackDepth,
            stackForward: 0
        });
        rects.push(rect);
        return rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1;
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        var stackForward = 0;
        for(var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++){
            var node = nodes_1[_i];
            stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        }
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function cacheable(keyFunc, workFunc) {
    var cache = {};
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var key = keyFunc.apply(void 0, args);
        return key in cache ? cache[key] : cache[key] = workFunc.apply(void 0, args);
    };
}
function computeSegVCoords(segs, colDate, slatCoords, eventMinHeight) {
    if (slatCoords === void 0) slatCoords = null;
    if (eventMinHeight === void 0) eventMinHeight = 0;
    var vcoords = [];
    if (slatCoords) for(var i = 0; i < segs.length; i += 1){
        var seg = segs[i];
        var spanStart = slatCoords.computeDateTop(seg.start, colDate);
        var spanEnd = Math.max(spanStart + (eventMinHeight || 0), slatCoords.computeDateTop(seg.end, colDate));
        vcoords.push({
            start: Math.round(spanStart),
            end: Math.round(spanEnd)
        });
    }
    return vcoords;
}
function computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack) {
    var segInputs = [];
    var dumbSegs = []; // segs without coords
    for(var i = 0; i < segs.length; i += 1){
        var vcoords = segVCoords[i];
        if (vcoords) segInputs.push({
            index: i,
            thickness: 1,
            span: vcoords
        });
        else dumbSegs.push(segs[i]);
    }
    var _a = buildPositioning(segInputs, eventOrderStrict, eventMaxStack), segRects = _a.segRects, hiddenGroups = _a.hiddenGroups;
    var segPlacements = [];
    for(var _i = 0, segRects_1 = segRects; _i < segRects_1.length; _i++){
        var segRect = segRects_1[_i];
        segPlacements.push({
            seg: segs[segRect.index],
            rect: segRect
        });
    }
    for(var _b = 0, dumbSegs_1 = dumbSegs; _b < dumbSegs_1.length; _b++){
        var dumbSeg = dumbSegs_1[_b];
        segPlacements.push({
            seg: dumbSeg,
            rect: null
        });
    }
    return {
        segPlacements: segPlacements,
        hiddenGroups: hiddenGroups
    };
}
var DEFAULT_TIME_FORMAT = (0, $8XAxF.createFormatter)({
    hour: "numeric",
    minute: "2-digit",
    meridiem: false
});
var TimeColEvent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColEvent, _super);
    function TimeColEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColEvent.prototype.render = function() {
        var classNames = [
            "fc-timegrid-event",
            "fc-v-event"
        ];
        if (this.props.isShort) classNames.push("fc-timegrid-event-short");
        return (0, $8XAxF.createElement)((0, $8XAxF.StandardEvent), (0, $4nqhV.__assign)({}, this.props, {
            defaultTimeFormat: DEFAULT_TIME_FORMAT,
            extraClassNames: classNames
        }));
    };
    return TimeColEvent;
}((0, $8XAxF.BaseComponent));
var TimeColMisc = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColMisc, _super);
    function TimeColMisc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColMisc.prototype.render = function() {
        var props = this.props;
        return (0, $8XAxF.createElement)((0, $8XAxF.DayCellContent), {
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            extraHookProps: props.extraHookProps
        }, function(innerElRef, innerContent) {
            return innerContent && (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-col-misc",
                ref: innerElRef
            }, innerContent);
        });
    };
    return TimeColMisc;
}((0, $8XAxF.BaseComponent));
var TimeCol = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeCol, _super);
    function TimeCol() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortEventSegs = (0, $8XAxF.memoize)((0, $8XAxF.sortEventSegs));
        return _this;
    }
    // TODO: memoize event-placement?
    TimeCol.prototype.render = function() {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var isSelectMirror = context.options.selectMirror;
        var mirrorSegs = props.eventDrag && props.eventDrag.segs || props.eventResize && props.eventResize.segs || isSelectMirror && props.dateSelectionSegs || [];
        var interactionAffectedInstances = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        var sortedFgSegs = this.sortEventSegs(props.fgEventSegs, context.options.eventOrder);
        return (0, $8XAxF.createElement)((0, $8XAxF.DayCellRoot), {
            elRef: props.elRef,
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            extraHookProps: props.extraHookProps
        }, function(rootElRef, classNames, dataAttrs) {
            return (0, $8XAxF.createElement)("td", (0, $4nqhV.__assign)({
                ref: rootElRef,
                role: "gridcell",
                className: [
                    "fc-timegrid-col"
                ].concat(classNames, props.extraClassNames || []).join(" ")
            }, dataAttrs, props.extraDataAttrs), (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-col-frame"
            }, (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-col-bg"
            }, _this.renderFillSegs(props.businessHourSegs, "non-business"), _this.renderFillSegs(props.bgEventSegs, "bg-event"), _this.renderFillSegs(props.dateSelectionSegs, "highlight")), (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-col-events"
            }, _this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)), (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-col-events"
            }, _this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror))), (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-now-indicator-container"
            }, _this.renderNowIndicator(props.nowIndicatorSegs)), (0, $8XAxF.createElement)(TimeColMisc, {
                date: props.date,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraHookProps: props.extraHookProps
            })));
        });
    };
    TimeCol.prototype.renderFgSegs = function(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting) {
        var props = this.props;
        if (props.forPrint) return renderPlainFgSegs(sortedFgSegs, props);
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting);
    };
    TimeCol.prototype.renderPositionedFgSegs = function(segs, segIsInvisible, isDragging, isResizing, isDateSelecting) {
        var _this = this;
        var _a = this.context.options, eventMaxStack = _a.eventMaxStack, eventShortHeight = _a.eventShortHeight, eventOrderStrict = _a.eventOrderStrict, eventMinHeight = _a.eventMinHeight;
        var _b = this.props, date = _b.date, slatCoords = _b.slatCoords, eventSelection = _b.eventSelection, todayRange = _b.todayRange, nowDate = _b.nowDate;
        var isMirror = isDragging || isResizing || isDateSelecting;
        var segVCoords = computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        var _c = computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack), segPlacements = _c.segPlacements, hiddenGroups = _c.hiddenGroups;
        return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, this.renderHiddenGroups(hiddenGroups, segs), segPlacements.map(function(segPlacement) {
            var seg = segPlacement.seg, rect = segPlacement.rect;
            var instanceId = seg.eventRange.instance.instanceId;
            var isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
            var vStyle = computeSegVStyle(rect && rect.span);
            var hStyle = !isMirror && rect ? _this.computeSegHStyle(rect) : {
                left: 0,
                right: 0
            };
            var isInset = Boolean(rect) && rect.stackForward > 0;
            var isShort = Boolean(rect) && rect.span.end - rect.span.start < eventShortHeight; // look at other places for this problem
            return (0, $8XAxF.createElement)("div", {
                className: "fc-timegrid-event-harness" + (isInset ? " fc-timegrid-event-harness-inset" : ""),
                key: instanceId,
                style: (0, $4nqhV.__assign)((0, $4nqhV.__assign)({
                    visibility: isVisible ? "" : "hidden"
                }, vStyle), hStyle)
            }, (0, $8XAxF.createElement)(TimeColEvent, (0, $4nqhV.__assign)({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                isShort: isShort
            }, (0, $8XAxF.getSegMeta)(seg, todayRange, nowDate))));
        }));
    };
    // will already have eventMinHeight applied because segInputs already had it
    TimeCol.prototype.renderHiddenGroups = function(hiddenGroups, segs) {
        var _a = this.props, extraDateSpan = _a.extraDateSpan, dateProfile = _a.dateProfile, todayRange = _a.todayRange, nowDate = _a.nowDate, eventSelection = _a.eventSelection, eventDrag = _a.eventDrag, eventResize = _a.eventResize;
        return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, hiddenGroups.map(function(hiddenGroup) {
            var positionCss = computeSegVStyle(hiddenGroup.span);
            var hiddenSegs = compileSegsFromEntries(hiddenGroup.entries, segs);
            return (0, $8XAxF.createElement)(TimeColMoreLink, {
                key: (0, $8XAxF.buildIsoString)((0, $8XAxF.computeEarliestSegStart)(hiddenSegs)),
                hiddenSegs: hiddenSegs,
                top: positionCss.top,
                bottom: positionCss.bottom,
                extraDateSpan: extraDateSpan,
                dateProfile: dateProfile,
                todayRange: todayRange,
                nowDate: nowDate,
                eventSelection: eventSelection,
                eventDrag: eventDrag,
                eventResize: eventResize
            });
        }));
    };
    TimeCol.prototype.renderFillSegs = function(segs, fillType) {
        var _a = this, props = _a.props, context = _a.context;
        var segVCoords = computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        var children = segVCoords.map(function(vcoords, i) {
            var seg = segs[i];
            return (0, $8XAxF.createElement)("div", {
                key: (0, $8XAxF.buildEventRangeKey)(seg.eventRange),
                className: "fc-timegrid-bg-harness",
                style: computeSegVStyle(vcoords)
            }, fillType === "bg-event" ? (0, $8XAxF.createElement)((0, $8XAxF.BgEvent), (0, $4nqhV.__assign)({
                seg: seg
            }, (0, $8XAxF.getSegMeta)(seg, props.todayRange, props.nowDate))) : (0, $8XAxF.renderFill)(fillType));
        });
        return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, children);
    };
    TimeCol.prototype.renderNowIndicator = function(segs) {
        var _a = this.props, slatCoords = _a.slatCoords, date = _a.date;
        if (!slatCoords) return null;
        return segs.map(function(seg, i) {
            return (0, $8XAxF.createElement)((0, $8XAxF.NowIndicatorRoot), {
                isAxis: false,
                date: date,
                // key doesn't matter. will only ever be one
                key: i
            }, function(rootElRef, classNames, innerElRef, innerContent) {
                return (0, $8XAxF.createElement)("div", {
                    ref: rootElRef,
                    className: [
                        "fc-timegrid-now-indicator-line"
                    ].concat(classNames).join(" "),
                    style: {
                        top: slatCoords.computeDateTop(seg.start, date)
                    }
                }, innerContent);
            });
        });
    };
    TimeCol.prototype.computeSegHStyle = function(segHCoords) {
        var _a = this.context, isRtl = _a.isRtl, options = _a.options;
        var shouldOverlap = options.slotEventOverlap;
        var nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        var farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        var left; // amount of space from left edge, a fraction of the total width
        var right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) // double the width, but don't go beyond the maximum forward coordinate (1.0)
        farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        } else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        var props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + "%",
            right: right * 100 + "%"
        };
        if (shouldOverlap && !segHCoords.stackForward) // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[isRtl ? "marginLeft" : "marginRight"] = 20; // 10 is a guesstimate of the icon's width
        return props;
    };
    return TimeCol;
}((0, $8XAxF.BaseComponent));
function renderPlainFgSegs(sortedFgSegs, _a) {
    var todayRange = _a.todayRange, nowDate = _a.nowDate, eventSelection = _a.eventSelection, eventDrag = _a.eventDrag, eventResize = _a.eventResize;
    var hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) || (eventResize ? eventResize.affectedInstances : null) || {};
    return (0, $8XAxF.createElement)((0, $8XAxF.Fragment), null, sortedFgSegs.map(function(seg) {
        var instanceId = seg.eventRange.instance.instanceId;
        return (0, $8XAxF.createElement)("div", {
            key: instanceId,
            style: {
                visibility: hiddenInstances[instanceId] ? "hidden" : ""
            }
        }, (0, $8XAxF.createElement)(TimeColEvent, (0, $4nqhV.__assign)({
            seg: seg,
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: instanceId === eventSelection,
            isShort: false
        }, (0, $8XAxF.getSegMeta)(seg, todayRange, nowDate))));
    }));
}
function computeSegVStyle(segVCoords) {
    if (!segVCoords) return {
        top: "",
        bottom: ""
    };
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end
    };
}
function compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map(function(segEntry) {
        return allSegs[segEntry.index];
    });
}
var TimeColsContent = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeColsContent, _super);
    function TimeColsContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitFgEventSegs = (0, $8XAxF.memoize)(splitSegsByCol);
        _this.splitBgEventSegs = (0, $8XAxF.memoize)(splitSegsByCol);
        _this.splitBusinessHourSegs = (0, $8XAxF.memoize)(splitSegsByCol);
        _this.splitNowIndicatorSegs = (0, $8XAxF.memoize)(splitSegsByCol);
        _this.splitDateSelectionSegs = (0, $8XAxF.memoize)(splitSegsByCol);
        _this.splitEventDrag = (0, $8XAxF.memoize)(splitInteractionByCol);
        _this.splitEventResize = (0, $8XAxF.memoize)(splitInteractionByCol);
        _this.rootElRef = (0, $8XAxF.createRef)();
        _this.cellElRefs = new (0, $8XAxF.RefMap)();
        return _this;
    }
    TimeColsContent.prototype.render = function() {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var nowIndicatorTop = context.options.nowIndicator && props.slatCoords && props.slatCoords.safeComputeTop(props.nowDate); // might return void
        var colCnt = props.cells.length;
        var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        var nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        var eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        var eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (0, $8XAxF.createElement)("div", {
            className: "fc-timegrid-cols",
            ref: this.rootElRef
        }, (0, $8XAxF.createElement)("table", {
            role: "presentation",
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth
            }
        }, props.tableColGroupNode, (0, $8XAxF.createElement)("tbody", {
            role: "presentation"
        }, (0, $8XAxF.createElement)("tr", {
            role: "row"
        }, props.axis && (0, $8XAxF.createElement)("td", {
            "aria-hidden": true,
            className: "fc-timegrid-col fc-timegrid-axis"
        }, (0, $8XAxF.createElement)("div", {
            className: "fc-timegrid-col-frame"
        }, (0, $8XAxF.createElement)("div", {
            className: "fc-timegrid-now-indicator-container"
        }, typeof nowIndicatorTop === "number" && (0, $8XAxF.createElement)((0, $8XAxF.NowIndicatorRoot), {
            isAxis: true,
            date: props.nowDate
        }, function(rootElRef, classNames, innerElRef, innerContent) {
            return (0, $8XAxF.createElement)("div", {
                ref: rootElRef,
                className: [
                    "fc-timegrid-now-indicator-arrow"
                ].concat(classNames).join(" "),
                style: {
                    top: nowIndicatorTop
                }
            }, innerContent);
        })))), props.cells.map(function(cell, i) {
            return (0, $8XAxF.createElement)(TimeCol, {
                key: cell.key,
                elRef: _this.cellElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                nowDate: props.nowDate,
                todayRange: props.todayRange,
                extraHookProps: cell.extraHookProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                fgEventSegs: fgEventSegsByRow[i],
                bgEventSegs: bgEventSegsByRow[i],
                businessHourSegs: businessHourSegsByRow[i],
                nowIndicatorSegs: nowIndicatorSegsByRow[i],
                dateSelectionSegs: dateSelectionSegsByRow[i],
                eventDrag: eventDragByRow[i],
                eventResize: eventResizeByRow[i],
                slatCoords: props.slatCoords,
                eventSelection: props.eventSelection,
                forPrint: props.forPrint
            });
        })))));
    };
    TimeColsContent.prototype.componentDidMount = function() {
        this.updateCoords();
    };
    TimeColsContent.prototype.componentDidUpdate = function() {
        this.updateCoords();
    };
    TimeColsContent.prototype.updateCoords = function() {
        var props = this.props;
        if (props.onColCoords && props.clientWidth !== null // means sizing has stabilized
        ) props.onColCoords(new (0, $8XAxF.PositionCache)(this.rootElRef.current, collectCellEls(this.cellElRefs.currentMap, props.cells), true, false));
    };
    return TimeColsContent;
}((0, $8XAxF.BaseComponent));
function collectCellEls(elMap, cells) {
    return cells.map(function(cell) {
        return elMap[cell.key];
    });
}
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/ var TimeCols = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(TimeCols, _super);
    function TimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processSlotOptions = (0, $8XAxF.memoize)(processSlotOptions);
        _this.state = {
            slatCoords: null
        };
        _this.handleRootEl = function(el) {
            if (el) _this.context.registerInteractiveComponent(_this, {
                el: el,
                isHitComboAllowed: _this.props.isHitComboAllowed
            });
            else _this.context.unregisterInteractiveComponent(_this);
        };
        _this.handleScrollRequest = function(request) {
            var onScrollTopRequest = _this.props.onScrollTopRequest;
            var slatCoords = _this.state.slatCoords;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    var top_1 = slatCoords.computeTimeTop(request.time);
                    top_1 = Math.ceil(top_1); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top_1) top_1 += 1; // to overcome top border that slots beyond the first have. looks better
                    onScrollTopRequest(top_1);
                }
                return true;
            }
            return false;
        };
        _this.handleColCoords = function(colCoords) {
            _this.colCoords = colCoords;
        };
        _this.handleSlatCoords = function(slatCoords) {
            _this.setState({
                slatCoords: slatCoords
            });
            if (_this.props.onSlatCoords) _this.props.onSlatCoords(slatCoords);
        };
        return _this;
    }
    TimeCols.prototype.render = function() {
        var _a = this, props = _a.props, state = _a.state;
        return (0, $8XAxF.createElement)("div", {
            className: "fc-timegrid-body",
            ref: this.handleRootEl,
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $8XAxF.createElement)(TimeColsSlats, {
            axis: props.axis,
            dateProfile: props.dateProfile,
            slatMetas: props.slatMetas,
            clientWidth: props.clientWidth,
            minHeight: props.expandRows ? props.clientHeight : "",
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.axis ? props.tableColGroupNode : null,
            onCoords: this.handleSlatCoords
        }), (0, $8XAxF.createElement)(TimeColsContent, {
            cells: props.cells,
            axis: props.axis,
            dateProfile: props.dateProfile,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            todayRange: props.todayRange,
            nowDate: props.nowDate,
            nowIndicatorSegs: props.nowIndicatorSegs,
            clientWidth: props.clientWidth,
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.tableColGroupNode,
            slatCoords: state.slatCoords,
            onColCoords: this.handleColCoords,
            forPrint: props.forPrint
        }));
    };
    TimeCols.prototype.componentDidMount = function() {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    };
    TimeCols.prototype.componentDidUpdate = function(prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    };
    TimeCols.prototype.componentWillUnmount = function() {
        this.scrollResponder.detach();
    };
    TimeCols.prototype.queryHit = function(positionLeft, positionTop) {
        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options;
        var colCoords = this.colCoords;
        var dateProfile = this.props.dateProfile;
        var slatCoords = this.state.slatCoords;
        var _b = this.processSlotOptions(this.props.slotDuration, options.snapDuration), snapDuration = _b.snapDuration, snapsPerSlot = _b.snapsPerSlot;
        var colIndex = colCoords.leftToIndex(positionLeft);
        var slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            var cell = this.props.cells[colIndex];
            var slatTop = slatCoords.positions.tops[slatIndex];
            var slatHeight = slatCoords.positions.getHeight(slatIndex);
            var partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            var dayDate = this.props.cells[colIndex].date;
            var time = (0, $8XAxF.addDurations)(dateProfile.slotMinTime, (0, $8XAxF.multiplyDuration)(snapDuration, snapIndex));
            var start = dateEnv.add(dayDate, time);
            var end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: (0, $4nqhV.__assign)({
                    range: {
                        start: start,
                        end: end
                    },
                    allDay: false
                }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight
                },
                layer: 0
            };
        }
        return null;
    };
    return TimeCols;
}((0, $8XAxF.DateComponent));
function processSlotOptions(slotDuration, snapDurationOverride) {
    var snapDuration = snapDurationOverride || slotDuration;
    var snapsPerSlot = (0, $8XAxF.wholeDivideDurations)(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
    // TODO: say warning?
    }
    return {
        snapDuration: snapDuration,
        snapsPerSlot: snapsPerSlot
    };
}
var DayTimeColsSlicer = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayTimeColsSlicer, _super);
    function DayTimeColsSlicer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayTimeColsSlicer.prototype.sliceRange = function(range, dayRanges) {
        var segs = [];
        for(var col = 0; col < dayRanges.length; col += 1){
            var segRange = (0, $8XAxF.intersectRanges)(range, dayRanges[col]);
            if (segRange) segs.push({
                start: segRange.start,
                end: segRange.end,
                isStart: segRange.start.valueOf() === range.start.valueOf(),
                isEnd: segRange.end.valueOf() === range.end.valueOf(),
                col: col
            });
        }
        return segs;
    };
    return DayTimeColsSlicer;
}((0, $8XAxF.Slicer));
var DayTimeCols = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayTimeCols, _super);
    function DayTimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayRanges = (0, $8XAxF.memoize)(buildDayRanges);
        _this.slicer = new DayTimeColsSlicer();
        _this.timeColsRef = (0, $8XAxF.createRef)();
        return _this;
    }
    DayTimeCols.prototype.render = function() {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var dateProfile = props.dateProfile, dayTableModel = props.dayTableModel;
        var isNowIndicator = context.options.nowIndicator;
        var dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (0, $8XAxF.createElement)((0, $8XAxF.NowTimer), {
            unit: isNowIndicator ? "minute" : "day"
        }, function(nowDate, todayRange) {
            return (0, $8XAxF.createElement)(TimeCols, (0, $4nqhV.__assign)({
                ref: _this.timeColsRef
            }, _this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), {
                forPrint: props.forPrint,
                axis: props.axis,
                dateProfile: dateProfile,
                slatMetas: props.slatMetas,
                slotDuration: props.slotDuration,
                cells: dayTableModel.cells[0],
                tableColGroupNode: props.tableColGroupNode,
                tableMinWidth: props.tableMinWidth,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                expandRows: props.expandRows,
                nowDate: nowDate,
                nowIndicatorSegs: isNowIndicator && _this.slicer.sliceNowDate(nowDate, context, dayRanges),
                todayRange: todayRange,
                onScrollTopRequest: props.onScrollTopRequest,
                onSlatCoords: props.onSlatCoords
            }));
        });
    };
    return DayTimeCols;
}((0, $8XAxF.DateComponent));
function buildDayRanges(dayTableModel, dateProfile, dateEnv) {
    var ranges = [];
    for(var _i = 0, _a = dayTableModel.headerDates; _i < _a.length; _i++){
        var date = _a[_i];
        ranges.push({
            start: dateEnv.add(date, dateProfile.slotMinTime),
            end: dateEnv.add(date, dateProfile.slotMaxTime)
        });
    }
    return ranges;
}
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var STOCK_SUB_DURATIONS = [
    {
        hours: 1
    },
    {
        minutes: 30
    },
    {
        minutes: 15
    },
    {
        seconds: 30
    },
    {
        seconds: 15
    }
];
function buildSlatMetas(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    var dayStart = new Date(0);
    var slatTime = slotMinTime;
    var slatIterator = (0, $8XAxF.createDuration)(0);
    var labelInterval = explicitLabelInterval || computeLabelInterval(slotDuration);
    var metas = [];
    while((0, $8XAxF.asRoughMs)(slatTime) < (0, $8XAxF.asRoughMs)(slotMaxTime)){
        var date = dateEnv.add(dayStart, slatTime);
        var isLabeled = (0, $8XAxF.wholeDivideDurations)(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: (0, $8XAxF.formatIsoTimeString)(date),
            isLabeled: isLabeled
        });
        slatTime = (0, $8XAxF.addDurations)(slatTime, slotDuration);
        slatIterator = (0, $8XAxF.addDurations)(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function computeLabelInterval(slotDuration) {
    var i;
    var labelInterval;
    var slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for(i = STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1){
        labelInterval = (0, $8XAxF.createDuration)(STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = (0, $8XAxF.wholeDivideDurations)(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) return labelInterval;
    }
    return slotDuration; // fall back
}
var DayTimeColsView = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DayTimeColsView, _super);
    function DayTimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildTimeColsModel = (0, $8XAxF.memoize)(buildTimeColsModel);
        _this.buildSlatMetas = (0, $8XAxF.memoize)(buildSlatMetas);
        return _this;
    }
    DayTimeColsView.prototype.render = function() {
        var _this = this;
        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv, dateProfileGenerator = _a.dateProfileGenerator;
        var props = this.props;
        var dateProfile = props.dateProfile;
        var dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        var splitProps = this.allDaySplitter.splitProps(props);
        var slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        var dayMinWidth = options.dayMinWidth;
        var hasAttachedAxis = !dayMinWidth;
        var hasDetachedAxis = dayMinWidth;
        var headerContent = options.dayHeaders && (0, $8XAxF.createElement)((0, $8XAxF.DayHeader), {
            dates: dayTableModel.headerDates,
            dateProfile: dateProfile,
            datesRepDistinctDays: true,
            renderIntro: hasAttachedAxis ? this.renderHeadAxis : null
        });
        var allDayContent = options.allDaySlot !== false && function(contentArg) {
            return (0, $8XAxF.createElement)((0, $d2yo0.DayTable), (0, $4nqhV.__assign)({}, splitProps.allDay, {
                dateProfile: dateProfile,
                dayTableModel: dayTableModel,
                nextDayThreshold: options.nextDayThreshold,
                tableMinWidth: contentArg.tableMinWidth,
                colGroupNode: contentArg.tableColGroupNode,
                renderRowIntro: hasAttachedAxis ? _this.renderTableRowAxis : null,
                showWeekNumbers: false,
                expandRows: false,
                headerAlignElRef: _this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            }, _this.getAllDayMaxEventProps()));
        };
        var timeGridContent = function(contentArg) {
            return (0, $8XAxF.createElement)(DayTimeCols, (0, $4nqhV.__assign)({}, splitProps.timed, {
                dayTableModel: dayTableModel,
                dateProfile: dateProfile,
                axis: hasAttachedAxis,
                slotDuration: options.slotDuration,
                slatMetas: slatMetas,
                forPrint: props.forPrint,
                tableColGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                onSlatCoords: _this.handleSlatCoords,
                expandRows: contentArg.expandRows,
                onScrollTopRequest: _this.handleScrollTopRequest
            }));
        };
        return hasDetachedAxis ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords) : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    };
    return DayTimeColsView;
}(TimeColsView);
function buildTimeColsModel(dateProfile, dateProfileGenerator) {
    var daySeries = new (0, $8XAxF.DaySeriesModel)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $8XAxF.DayTableModel)(daySeries, false);
}
var OPTION_REFINERS = {
    allDaySlot: Boolean
};
var main = (0, $8XAxF.createPlugin)({
    initialView: "timeGridWeek",
    optionRefiners: OPTION_REFINERS,
    views: {
        timeGrid: {
            component: DayTimeColsView,
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: "00:30:00",
            slotEventOverlap: true
        },
        timeGridDay: {
            type: "timeGrid",
            duration: {
                days: 1
            }
        },
        timeGridWeek: {
            type: "timeGrid",
            duration: {
                weeks: 1
            }
        }
    }
});
var $092c9ce2edced379$export$2e2bcd8739ae039 = main;

});

parcelRegister("6TVh2", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("2RV4g", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $216ccc76bae9f614$export$a7c73072b1a182ae; }, function (v) { return $216ccc76bae9f614$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $216ccc76bae9f614$export$9f27bc3417b4524d; }, function (v) { return $216ccc76bae9f614$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $216ccc76bae9f614$export$db77ccec0bb4ccac; }, function (v) { return $216ccc76bae9f614$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $216ccc76bae9f614$export$8392c0c9d3dcbd35; }, function (v) { return $216ccc76bae9f614$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $216ccc76bae9f614$export$ffb0004e005737fa; }, function (v) { return $216ccc76bae9f614$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $216ccc76bae9f614$export$b624eff549462981; }, function (v) { return $216ccc76bae9f614$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $216ccc76bae9f614$export$7897aa7841a5380c; }, function (v) { return $216ccc76bae9f614$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $216ccc76bae9f614$export$602eac185826482c; }, function (v) { return $216ccc76bae9f614$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $216ccc76bae9f614$export$e2c29f18771995cb; }, function (v) { return $216ccc76bae9f614$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $216ccc76bae9f614$export$5f8d39834fd61797; }, function (v) { return $216ccc76bae9f614$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $216ccc76bae9f614$export$74bf444e3cd11ea5; }, function (v) { return $216ccc76bae9f614$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $216ccc76bae9f614$export$92387174baf9b227; }, function (v) { return $216ccc76bae9f614$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $216ccc76bae9f614$export$ec112efeb987d9c6; }, function (v) { return $216ccc76bae9f614$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $216ccc76bae9f614$export$b706b080d889d2c9; }, function (v) { return $216ccc76bae9f614$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $216ccc76bae9f614$export$5be5a87408f70ddc; }, function (v) { return $216ccc76bae9f614$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $216ccc76bae9f614$export$45a5e7f76e0caa8d; }, function (v) { return $216ccc76bae9f614$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $216ccc76bae9f614$export$455c2e768291efa6; }, function (v) { return $216ccc76bae9f614$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $216ccc76bae9f614$export$9522e17588c12572; }, function (v) { return $216ccc76bae9f614$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $216ccc76bae9f614$export$2110ac352bb060b9; }, function (v) { return $216ccc76bae9f614$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $216ccc76bae9f614$export$56885ab8b9c456ab; }, function (v) { return $216ccc76bae9f614$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $216ccc76bae9f614$export$d927fcb6adf8f9de; }, function (v) { return $216ccc76bae9f614$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $216ccc76bae9f614$export$b82d16f27459e05a; }, function (v) { return $216ccc76bae9f614$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $216ccc76bae9f614$export$522c17b4f5e123e8; }, function (v) { return $216ccc76bae9f614$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $216ccc76bae9f614$export$1aabd8a0274ecfd6; }, function (v) { return $216ccc76bae9f614$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $216ccc76bae9f614$export$9b621391a187a31a; }, function (v) { return $216ccc76bae9f614$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $216ccc76bae9f614$export$f5bbd400c2f4426f; }, function (v) { return $216ccc76bae9f614$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $216ccc76bae9f614$export$a7c73072b1a182ae;
var $216ccc76bae9f614$export$9f27bc3417b4524d;
var $216ccc76bae9f614$export$db77ccec0bb4ccac;
var $216ccc76bae9f614$export$8392c0c9d3dcbd35;
var $216ccc76bae9f614$export$ffb0004e005737fa;
var $216ccc76bae9f614$export$b624eff549462981;
var $216ccc76bae9f614$export$7897aa7841a5380c;
var $216ccc76bae9f614$export$602eac185826482c;
var $216ccc76bae9f614$export$e2c29f18771995cb;
var $216ccc76bae9f614$export$5f8d39834fd61797;
var $216ccc76bae9f614$export$74bf444e3cd11ea5;
var $216ccc76bae9f614$export$92387174baf9b227;
var $216ccc76bae9f614$export$ec112efeb987d9c6;
var $216ccc76bae9f614$export$b706b080d889d2c9;
var $216ccc76bae9f614$export$5be5a87408f70ddc;
var $216ccc76bae9f614$export$45a5e7f76e0caa8d;
var $216ccc76bae9f614$export$455c2e768291efa6;
var $216ccc76bae9f614$export$9522e17588c12572;
var $216ccc76bae9f614$export$2110ac352bb060b9;
var $216ccc76bae9f614$export$56885ab8b9c456ab;
var $216ccc76bae9f614$export$d927fcb6adf8f9de;
var $216ccc76bae9f614$export$b82d16f27459e05a;
var $216ccc76bae9f614$export$522c17b4f5e123e8;
var $216ccc76bae9f614$export$1aabd8a0274ecfd6;
var $216ccc76bae9f614$export$9b621391a187a31a;
var $216ccc76bae9f614$export$f5bbd400c2f4426f;
"use strict";
var $216ccc76bae9f614$var$b = 60103, $216ccc76bae9f614$var$c = 60106, $216ccc76bae9f614$var$d = 60107, $216ccc76bae9f614$var$e = 60108, $216ccc76bae9f614$var$f = 60114, $216ccc76bae9f614$var$g = 60109, $216ccc76bae9f614$var$h = 60110, $216ccc76bae9f614$var$k = 60112, $216ccc76bae9f614$var$l = 60113, $216ccc76bae9f614$var$m = 60120, $216ccc76bae9f614$var$n = 60115, $216ccc76bae9f614$var$p = 60116, $216ccc76bae9f614$var$q = 60121, $216ccc76bae9f614$var$r = 60122, $216ccc76bae9f614$var$u = 60117, $216ccc76bae9f614$var$v = 60129, $216ccc76bae9f614$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $216ccc76bae9f614$var$x = Symbol.for;
    $216ccc76bae9f614$var$b = $216ccc76bae9f614$var$x("react.element");
    $216ccc76bae9f614$var$c = $216ccc76bae9f614$var$x("react.portal");
    $216ccc76bae9f614$var$d = $216ccc76bae9f614$var$x("react.fragment");
    $216ccc76bae9f614$var$e = $216ccc76bae9f614$var$x("react.strict_mode");
    $216ccc76bae9f614$var$f = $216ccc76bae9f614$var$x("react.profiler");
    $216ccc76bae9f614$var$g = $216ccc76bae9f614$var$x("react.provider");
    $216ccc76bae9f614$var$h = $216ccc76bae9f614$var$x("react.context");
    $216ccc76bae9f614$var$k = $216ccc76bae9f614$var$x("react.forward_ref");
    $216ccc76bae9f614$var$l = $216ccc76bae9f614$var$x("react.suspense");
    $216ccc76bae9f614$var$m = $216ccc76bae9f614$var$x("react.suspense_list");
    $216ccc76bae9f614$var$n = $216ccc76bae9f614$var$x("react.memo");
    $216ccc76bae9f614$var$p = $216ccc76bae9f614$var$x("react.lazy");
    $216ccc76bae9f614$var$q = $216ccc76bae9f614$var$x("react.block");
    $216ccc76bae9f614$var$r = $216ccc76bae9f614$var$x("react.server.block");
    $216ccc76bae9f614$var$u = $216ccc76bae9f614$var$x("react.fundamental");
    $216ccc76bae9f614$var$v = $216ccc76bae9f614$var$x("react.debug_trace_mode");
    $216ccc76bae9f614$var$w = $216ccc76bae9f614$var$x("react.legacy_hidden");
}
function $216ccc76bae9f614$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $216ccc76bae9f614$var$b:
                switch(a = a.type, a){
                    case $216ccc76bae9f614$var$d:
                    case $216ccc76bae9f614$var$f:
                    case $216ccc76bae9f614$var$e:
                    case $216ccc76bae9f614$var$l:
                    case $216ccc76bae9f614$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $216ccc76bae9f614$var$h:
                            case $216ccc76bae9f614$var$k:
                            case $216ccc76bae9f614$var$p:
                            case $216ccc76bae9f614$var$n:
                            case $216ccc76bae9f614$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $216ccc76bae9f614$var$c:
                return t;
        }
    }
}
var $216ccc76bae9f614$var$z = $216ccc76bae9f614$var$g, $216ccc76bae9f614$var$A = $216ccc76bae9f614$var$b, $216ccc76bae9f614$var$B = $216ccc76bae9f614$var$k, $216ccc76bae9f614$var$C = $216ccc76bae9f614$var$d, $216ccc76bae9f614$var$D = $216ccc76bae9f614$var$p, $216ccc76bae9f614$var$E = $216ccc76bae9f614$var$n, $216ccc76bae9f614$var$F = $216ccc76bae9f614$var$c, $216ccc76bae9f614$var$G = $216ccc76bae9f614$var$f, $216ccc76bae9f614$var$H = $216ccc76bae9f614$var$e, $216ccc76bae9f614$var$I = $216ccc76bae9f614$var$l;
$216ccc76bae9f614$export$a7c73072b1a182ae = $216ccc76bae9f614$var$h;
$216ccc76bae9f614$export$9f27bc3417b4524d = $216ccc76bae9f614$var$z;
$216ccc76bae9f614$export$db77ccec0bb4ccac = $216ccc76bae9f614$var$A;
$216ccc76bae9f614$export$8392c0c9d3dcbd35 = $216ccc76bae9f614$var$B;
$216ccc76bae9f614$export$ffb0004e005737fa = $216ccc76bae9f614$var$C;
$216ccc76bae9f614$export$b624eff549462981 = $216ccc76bae9f614$var$D;
$216ccc76bae9f614$export$7897aa7841a5380c = $216ccc76bae9f614$var$E;
$216ccc76bae9f614$export$602eac185826482c = $216ccc76bae9f614$var$F;
$216ccc76bae9f614$export$e2c29f18771995cb = $216ccc76bae9f614$var$G;
$216ccc76bae9f614$export$5f8d39834fd61797 = $216ccc76bae9f614$var$H;
$216ccc76bae9f614$export$74bf444e3cd11ea5 = $216ccc76bae9f614$var$I;
$216ccc76bae9f614$export$92387174baf9b227 = function() {
    return !1;
};
$216ccc76bae9f614$export$ec112efeb987d9c6 = function() {
    return !1;
};
$216ccc76bae9f614$export$b706b080d889d2c9 = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$h;
};
$216ccc76bae9f614$export$5be5a87408f70ddc = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$g;
};
$216ccc76bae9f614$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $216ccc76bae9f614$var$b;
};
$216ccc76bae9f614$export$455c2e768291efa6 = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$k;
};
$216ccc76bae9f614$export$9522e17588c12572 = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$d;
};
$216ccc76bae9f614$export$2110ac352bb060b9 = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$p;
};
$216ccc76bae9f614$export$56885ab8b9c456ab = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$n;
};
$216ccc76bae9f614$export$d927fcb6adf8f9de = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$c;
};
$216ccc76bae9f614$export$b82d16f27459e05a = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$f;
};
$216ccc76bae9f614$export$522c17b4f5e123e8 = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$e;
};
$216ccc76bae9f614$export$1aabd8a0274ecfd6 = function(a) {
    return $216ccc76bae9f614$var$y(a) === $216ccc76bae9f614$var$l;
};
$216ccc76bae9f614$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $216ccc76bae9f614$var$d || a === $216ccc76bae9f614$var$f || a === $216ccc76bae9f614$var$v || a === $216ccc76bae9f614$var$e || a === $216ccc76bae9f614$var$l || a === $216ccc76bae9f614$var$m || a === $216ccc76bae9f614$var$w || "object" === typeof a && null !== a && (a.$$typeof === $216ccc76bae9f614$var$p || a.$$typeof === $216ccc76bae9f614$var$n || a.$$typeof === $216ccc76bae9f614$var$g || a.$$typeof === $216ccc76bae9f614$var$h || a.$$typeof === $216ccc76bae9f614$var$k || a.$$typeof === $216ccc76bae9f614$var$u || a.$$typeof === $216ccc76bae9f614$var$q || a[0] === $216ccc76bae9f614$var$r) ? !0 : !1;
};
$216ccc76bae9f614$export$f5bbd400c2f4426f = $216ccc76bae9f614$var$y;

});

parcelRegister("hPN9t", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $cfbd539cc3f75d04$var$hasElementType = typeof Element !== "undefined";
var $cfbd539cc3f75d04$var$hasMap = typeof Map === "function";
var $cfbd539cc3f75d04$var$hasSet = typeof Set === "function";
var $cfbd539cc3f75d04$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $cfbd539cc3f75d04$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$cfbd539cc3f75d04$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($cfbd539cc3f75d04$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$cfbd539cc3f75d04$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($cfbd539cc3f75d04$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($cfbd539cc3f75d04$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($cfbd539cc3f75d04$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$cfbd539cc3f75d04$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $cfbd539cc3f75d04$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("jKgMX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports["default"] = void 0;

var $e5ff561155a23866$var$_reactFastCompare = $e5ff561155a23866$var$_interopRequireDefault((parcelRequire("hPN9t")));

var $gryJc = parcelRequire("gryJc");
function $e5ff561155a23866$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e5ff561155a23866$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e5ff561155a23866$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e5ff561155a23866$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e5ff561155a23866$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e5ff561155a23866$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e5ff561155a23866$var$_toConsumableArray(arr) {
    return $e5ff561155a23866$var$_arrayWithoutHoles(arr) || $e5ff561155a23866$var$_iterableToArray(arr) || $e5ff561155a23866$var$_unsupportedIterableToArray(arr) || $e5ff561155a23866$var$_nonIterableSpread();
}
function $e5ff561155a23866$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e5ff561155a23866$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e5ff561155a23866$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e5ff561155a23866$var$_arrayLikeToArray(o, minLen);
}
function $e5ff561155a23866$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e5ff561155a23866$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e5ff561155a23866$var$_arrayLikeToArray(arr);
}
function $e5ff561155a23866$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e5ff561155a23866$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e5ff561155a23866$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e5ff561155a23866$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e5ff561155a23866$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e5ff561155a23866$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e5ff561155a23866$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e5ff561155a23866$var$defaultConfig = {
    color: "#dee4fd",
    radius: [
        0.5,
        3.0
    ],
    speed: [
        1.0,
        3.0
    ],
    wind: [
        -0.5,
        2.0
    ],
    changeFrequency: 200,
    rotationSpeed: [
        -1,
        1.0
    ]
};
module.exports.defaultConfig = $e5ff561155a23866$var$defaultConfig;
/**
 * An individual snowflake that will update it's location every call to `update`
 * and draw itself to the canvas every call to `draw`.
 */ var $e5ff561155a23866$var$Snowflake = /*#__PURE__*/ function() {
    function Snowflake(canvas) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $e5ff561155a23866$var$_classCallCheck(this, Snowflake);
        $e5ff561155a23866$var$_defineProperty(this, "config", void 0);
        $e5ff561155a23866$var$_defineProperty(this, "params", void 0);
        $e5ff561155a23866$var$_defineProperty(this, "framesSinceLastUpdate", void 0);
        $e5ff561155a23866$var$_defineProperty(this, "image", void 0);
        // Set custom config
        this.updateConfig(config); // Setting initial parameters
        var _this$config = this.config, radius = _this$config.radius, wind = _this$config.wind, speed = _this$config.speed, rotationSpeed = _this$config.rotationSpeed;
        this.params = {
            x: (0, $gryJc.random)(0, canvas.offsetWidth),
            y: (0, $gryJc.random)(-canvas.offsetHeight, 0),
            rotation: (0, $gryJc.random)(0, 360),
            radius: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(radius)),
            speed: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(speed)),
            wind: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(wind)),
            rotationSpeed: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(rotationSpeed)),
            nextSpeed: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(wind)),
            nextWind: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(speed)),
            nextRotationSpeed: $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(rotationSpeed))
        };
        this.framesSinceLastUpdate = 0;
    }
    $e5ff561155a23866$var$_createClass(Snowflake, [
        {
            key: "selectImage",
            value: function selectImage() {
                if (this.config.images && this.config.images.length > 0) this.image = (0, $gryJc.randomElement)(this.config.images);
                else this.image = undefined;
            }
        },
        {
            key: "updateConfig",
            value: function updateConfig(config) {
                var previousConfig = this.config;
                this.config = $e5ff561155a23866$var$_objectSpread($e5ff561155a23866$var$_objectSpread({}, $e5ff561155a23866$var$defaultConfig), config);
                this.config.changeFrequency = (0, $gryJc.random)(this.config.changeFrequency, this.config.changeFrequency * 1.5); // Update the radius if the config has changed, it won't gradually update on it's own
                if (this.params && !(0, $e5ff561155a23866$var$_reactFastCompare["default"])(this.config.radius, previousConfig === null || previousConfig === void 0 ? void 0 : previousConfig.radius)) this.params.radius = $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(this.config.radius));
                if (!(0, $e5ff561155a23866$var$_reactFastCompare["default"])(this.config.images, previousConfig === null || previousConfig === void 0 ? void 0 : previousConfig.images)) this.selectImage();
            }
        },
        {
            key: "updateTargetParams",
            value: function updateTargetParams() {
                this.params.nextSpeed = $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(this.config.speed));
                this.params.nextWind = $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(this.config.wind));
                if (this.image) this.params.nextRotationSpeed = $gryJc.random.apply(void 0, $e5ff561155a23866$var$_toConsumableArray(this.config.rotationSpeed));
            }
        },
        {
            key: "update",
            value: function update(canvas) {
                var framesPassed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                var _this$params = this.params, x = _this$params.x, y = _this$params.y, rotation = _this$params.rotation, rotationSpeed = _this$params.rotationSpeed, nextRotationSpeed = _this$params.nextRotationSpeed, wind = _this$params.wind, speed = _this$params.speed, nextWind = _this$params.nextWind, nextSpeed = _this$params.nextSpeed, radius = _this$params.radius; // Update current location, wrapping around if going off the canvas
                this.params.x = (x + wind * framesPassed) % (canvas.offsetWidth + radius * 2);
                if (this.params.x > canvas.offsetWidth + radius) this.params.x = -radius;
                this.params.y = (y + speed * framesPassed) % (canvas.offsetHeight + radius * 2);
                if (this.params.y > canvas.offsetHeight + radius) this.params.y = -radius; // Apply rotation
                if (this.image) this.params.rotation = (rotation + rotationSpeed) % 360;
                 // Update the wind, speed and rotation towards the desired values
                this.params.speed = (0, $gryJc.lerp)(speed, nextSpeed, 0.01);
                this.params.wind = (0, $gryJc.lerp)(wind, nextWind, 0.01);
                this.params.rotationSpeed = (0, $gryJc.lerp)(rotationSpeed, nextRotationSpeed, 0.01);
                if (this.framesSinceLastUpdate++ > this.config.changeFrequency) {
                    this.updateTargetParams();
                    this.framesSinceLastUpdate = 0;
                }
            }
        },
        {
            key: "getImageOffscreenCanvas",
            value: function getImageOffscreenCanvas(image, size) {
                var _sizes$size;
                if (image instanceof HTMLImageElement && image.loading) return image;
                var sizes = Snowflake.offscreenCanvases.get(image);
                if (!sizes) {
                    sizes = {};
                    Snowflake.offscreenCanvases.set(image, sizes);
                }
                if (!(size in sizes)) {
                    var _canvas$getContext;
                    var canvas = document.createElement("canvas");
                    canvas.width = size;
                    canvas.height = size;
                    (_canvas$getContext = canvas.getContext("2d")) === null || _canvas$getContext === void 0 || _canvas$getContext.drawImage(image, 0, 0, size, size);
                    sizes[size] = canvas;
                }
                return (_sizes$size = sizes[size]) !== null && _sizes$size !== void 0 ? _sizes$size : image;
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                if (this.image) {
                    // ctx.save()
                    // ctx.translate(this.params.x, this.params.y)
                    ctx.setTransform(1, 0, 0, 1, this.params.x, this.params.y);
                    var radius = Math.ceil(this.params.radius);
                    ctx.rotate(this.params.rotation * Math.PI / 180);
                    ctx.drawImage(this.getImageOffscreenCanvas(this.image, radius), -Math.ceil(radius / 2), -Math.ceil(radius / 2), radius, radius); // ctx.restore()
                } else {
                    ctx.beginPath();
                    ctx.arc(this.params.x, this.params.y, this.params.radius, 0, 2 * Math.PI);
                    ctx.fillStyle = this.config.color;
                    ctx.closePath();
                    ctx.fill();
                }
            }
        }
    ]);
    return Snowflake;
}();
$e5ff561155a23866$var$_defineProperty($e5ff561155a23866$var$Snowflake, "offscreenCanvases", new WeakMap());
var $e5ff561155a23866$var$_default = $e5ff561155a23866$var$Snowflake;
module.exports["default"] = $e5ff561155a23866$var$_default;

});
parcelRegister("gryJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSize = $bf8a1b3655aa48f8$var$getSize;
module.exports.lerp = $bf8a1b3655aa48f8$var$lerp;
module.exports.random = $bf8a1b3655aa48f8$var$random;
module.exports.randomElement = $bf8a1b3655aa48f8$var$randomElement;
/**
 * Enhanced random function, selects a random value between a minimum and maximum. If the values provided are both
 * integers then the number returned will be an integer, otherwise the return number will be a decimal.
 * @param min The minimum value
 * @param max The maximum value
 */ function $bf8a1b3655aa48f8$var$random(min, max) {
    var randomNumber = Math.random() * (max - min + 1) + min;
    if (!Number.isInteger(min) || !Number.isInteger(max)) return randomNumber;
    else return Math.floor(randomNumber);
}
/**
 * Linear interpolation function to gradually step towards a target value
 * @param start The current value
 * @param end The target value
 * @param normal The rate of change between 0 and 1 (0 = no change, 1 = instant)
 */ function $bf8a1b3655aa48f8$var$lerp(start, end, normal) {
    return (1 - normal) * start + normal * end;
}
/**
 * Gets the height and width of the provided HTML element
 * @param element The html element to measure
 */ function $bf8a1b3655aa48f8$var$getSize(element) {
    if (!element) return {
        height: 0,
        width: 0
    };
    return {
        height: element.offsetHeight,
        width: element.offsetWidth
    };
}
/**
 * Selects a random item from an array of inputs.
 *
 * @param items The array of items to choose from
 * @returns A random item selected from the array
 */ function $bf8a1b3655aa48f8$var$randomElement(items) {
    var index = Math.floor(Math.random() * items.length);
    return items[index];
}

});


parcelRegister("80LJg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d5358d3069f512b$var$toDate;

var $5d5358d3069f512b$var$_assertString = $5d5358d3069f512b$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $5d5358d3069f512b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5d5358d3069f512b$var$toDate(date) {
    (0, $5d5358d3069f512b$var$_assertString.default)(date);
    date = Date.parse(date);
    return !isNaN(date) ? new Date(date) : null;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("G0UOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07e4a21d05c8ae8b$var$assertString;
function $07e4a21d05c8ae8b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $07e4a21d05c8ae8b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $07e4a21d05c8ae8b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $07e4a21d05c8ae8b$var$_typeof(obj);
}
function $07e4a21d05c8ae8b$var$assertString(input) {
    var isString = typeof input === "string" || input instanceof String;
    if (!isString) {
        var invalidType = $07e4a21d05c8ae8b$var$_typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("bNf7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $023739cbe2a64c9e$var$toFloat;

var $023739cbe2a64c9e$var$_isFloat = $023739cbe2a64c9e$var$_interopRequireDefault((parcelRequire("fB1zQ")));
function $023739cbe2a64c9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $023739cbe2a64c9e$var$toFloat(str) {
    if (!(0, $023739cbe2a64c9e$var$_isFloat.default)(str)) return NaN;
    return parseFloat(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("fB1zQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5ab88e5455fb5f9$var$isFloat;
module.exports.locales = void 0;

var $b5ab88e5455fb5f9$var$_assertString = $b5ab88e5455fb5f9$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $3LVJg = parcelRequire("3LVJg");
function $b5ab88e5455fb5f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5ab88e5455fb5f9$var$isFloat(str, options) {
    (0, $b5ab88e5455fb5f9$var$_assertString.default)(str);
    options = options || {};
    var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? $3LVJg.decimal[options.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (str === "" || str === "." || str === "," || str === "-" || str === "+") return false;
    var value = parseFloat(str.replace(",", "."));
    return float.test(str) && (!options.hasOwnProperty("min") || value >= options.min) && (!options.hasOwnProperty("max") || value <= options.max) && (!options.hasOwnProperty("lt") || value < options.lt) && (!options.hasOwnProperty("gt") || value > options.gt);
}
var $b5ab88e5455fb5f9$var$locales = Object.keys($3LVJg.decimal);
module.exports.locales = $b5ab88e5455fb5f9$var$locales;

});
parcelRegister("3LVJg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.commaDecimal = module.exports.dotDecimal = module.exports.bengaliLocales = module.exports.farsiLocales = module.exports.arabicLocales = module.exports.englishLocales = module.exports.decimal = module.exports.alphanumeric = module.exports.alpha = void 0;
var $2bf28ab0abdb9b88$var$alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
};
module.exports.alpha = $2bf28ab0abdb9b88$var$alpha;
var $2bf28ab0abdb9b88$var$alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
};
module.exports.alphanumeric = $2bf28ab0abdb9b88$var$alphanumeric;
var $2bf28ab0abdb9b88$var$decimal = {
    "en-US": ".",
    ar: "\u066B"
};
module.exports.decimal = $2bf28ab0abdb9b88$var$decimal;
var $2bf28ab0abdb9b88$var$englishLocales = [
    "AU",
    "GB",
    "HK",
    "IN",
    "NZ",
    "ZA",
    "ZM"
];
module.exports.englishLocales = $2bf28ab0abdb9b88$var$englishLocales;
for(var $2bf28ab0abdb9b88$var$locale, $2bf28ab0abdb9b88$var$i = 0; $2bf28ab0abdb9b88$var$i < $2bf28ab0abdb9b88$var$englishLocales.length; $2bf28ab0abdb9b88$var$i++){
    $2bf28ab0abdb9b88$var$locale = "en-".concat($2bf28ab0abdb9b88$var$englishLocales[$2bf28ab0abdb9b88$var$i]);
    $2bf28ab0abdb9b88$var$alpha[$2bf28ab0abdb9b88$var$locale] = $2bf28ab0abdb9b88$var$alpha["en-US"];
    $2bf28ab0abdb9b88$var$alphanumeric[$2bf28ab0abdb9b88$var$locale] = $2bf28ab0abdb9b88$var$alphanumeric["en-US"];
    $2bf28ab0abdb9b88$var$decimal[$2bf28ab0abdb9b88$var$locale] = $2bf28ab0abdb9b88$var$decimal["en-US"];
} // Source: http://www.localeplanet.com/java/
var $2bf28ab0abdb9b88$var$arabicLocales = [
    "AE",
    "BH",
    "DZ",
    "EG",
    "IQ",
    "JO",
    "KW",
    "LB",
    "LY",
    "MA",
    "QM",
    "QA",
    "SA",
    "SD",
    "SY",
    "TN",
    "YE"
];
module.exports.arabicLocales = $2bf28ab0abdb9b88$var$arabicLocales;
for(var $2bf28ab0abdb9b88$var$_locale, $2bf28ab0abdb9b88$var$_i = 0; $2bf28ab0abdb9b88$var$_i < $2bf28ab0abdb9b88$var$arabicLocales.length; $2bf28ab0abdb9b88$var$_i++){
    $2bf28ab0abdb9b88$var$_locale = "ar-".concat($2bf28ab0abdb9b88$var$arabicLocales[$2bf28ab0abdb9b88$var$_i]);
    $2bf28ab0abdb9b88$var$alpha[$2bf28ab0abdb9b88$var$_locale] = $2bf28ab0abdb9b88$var$alpha.ar;
    $2bf28ab0abdb9b88$var$alphanumeric[$2bf28ab0abdb9b88$var$_locale] = $2bf28ab0abdb9b88$var$alphanumeric.ar;
    $2bf28ab0abdb9b88$var$decimal[$2bf28ab0abdb9b88$var$_locale] = $2bf28ab0abdb9b88$var$decimal.ar;
}
var $2bf28ab0abdb9b88$var$farsiLocales = [
    "IR",
    "AF"
];
module.exports.farsiLocales = $2bf28ab0abdb9b88$var$farsiLocales;
for(var $2bf28ab0abdb9b88$var$_locale2, $2bf28ab0abdb9b88$var$_i2 = 0; $2bf28ab0abdb9b88$var$_i2 < $2bf28ab0abdb9b88$var$farsiLocales.length; $2bf28ab0abdb9b88$var$_i2++){
    $2bf28ab0abdb9b88$var$_locale2 = "fa-".concat($2bf28ab0abdb9b88$var$farsiLocales[$2bf28ab0abdb9b88$var$_i2]);
    $2bf28ab0abdb9b88$var$alphanumeric[$2bf28ab0abdb9b88$var$_locale2] = $2bf28ab0abdb9b88$var$alphanumeric.fa;
    $2bf28ab0abdb9b88$var$decimal[$2bf28ab0abdb9b88$var$_locale2] = $2bf28ab0abdb9b88$var$decimal.ar;
}
var $2bf28ab0abdb9b88$var$bengaliLocales = [
    "BD",
    "IN"
];
module.exports.bengaliLocales = $2bf28ab0abdb9b88$var$bengaliLocales;
for(var $2bf28ab0abdb9b88$var$_locale3, $2bf28ab0abdb9b88$var$_i3 = 0; $2bf28ab0abdb9b88$var$_i3 < $2bf28ab0abdb9b88$var$bengaliLocales.length; $2bf28ab0abdb9b88$var$_i3++){
    $2bf28ab0abdb9b88$var$_locale3 = "bn-".concat($2bf28ab0abdb9b88$var$bengaliLocales[$2bf28ab0abdb9b88$var$_i3]);
    $2bf28ab0abdb9b88$var$alpha[$2bf28ab0abdb9b88$var$_locale3] = $2bf28ab0abdb9b88$var$alpha.bn;
    $2bf28ab0abdb9b88$var$alphanumeric[$2bf28ab0abdb9b88$var$_locale3] = $2bf28ab0abdb9b88$var$alphanumeric.bn;
    $2bf28ab0abdb9b88$var$decimal[$2bf28ab0abdb9b88$var$_locale3] = $2bf28ab0abdb9b88$var$decimal["en-US"];
} // Source: https://en.wikipedia.org/wiki/Decimal_mark
var $2bf28ab0abdb9b88$var$dotDecimal = [
    "ar-EG",
    "ar-LB",
    "ar-LY"
];
module.exports.dotDecimal = $2bf28ab0abdb9b88$var$dotDecimal;
var $2bf28ab0abdb9b88$var$commaDecimal = [
    "bg-BG",
    "cs-CZ",
    "da-DK",
    "de-DE",
    "el-GR",
    "en-ZM",
    "es-ES",
    "fr-CA",
    "fr-FR",
    "id-ID",
    "it-IT",
    "ku-IQ",
    "hi-IN",
    "hu-HU",
    "nb-NO",
    "nn-NO",
    "nl-NL",
    "pl-PL",
    "pt-PT",
    "ru-RU",
    "kk-KZ",
    "si-LK",
    "sl-SI",
    "sr-RS@latin",
    "sr-RS",
    "sv-SE",
    "tr-TR",
    "uk-UA",
    "vi-VN"
];
module.exports.commaDecimal = $2bf28ab0abdb9b88$var$commaDecimal;
for(var $2bf28ab0abdb9b88$var$_i4 = 0; $2bf28ab0abdb9b88$var$_i4 < $2bf28ab0abdb9b88$var$dotDecimal.length; $2bf28ab0abdb9b88$var$_i4++)$2bf28ab0abdb9b88$var$decimal[$2bf28ab0abdb9b88$var$dotDecimal[$2bf28ab0abdb9b88$var$_i4]] = $2bf28ab0abdb9b88$var$decimal["en-US"];
for(var $2bf28ab0abdb9b88$var$_i5 = 0; $2bf28ab0abdb9b88$var$_i5 < $2bf28ab0abdb9b88$var$commaDecimal.length; $2bf28ab0abdb9b88$var$_i5++)$2bf28ab0abdb9b88$var$decimal[$2bf28ab0abdb9b88$var$commaDecimal[$2bf28ab0abdb9b88$var$_i5]] = ",";
$2bf28ab0abdb9b88$var$alpha["fr-CA"] = $2bf28ab0abdb9b88$var$alpha["fr-FR"];
$2bf28ab0abdb9b88$var$alphanumeric["fr-CA"] = $2bf28ab0abdb9b88$var$alphanumeric["fr-FR"];
$2bf28ab0abdb9b88$var$alpha["pt-BR"] = $2bf28ab0abdb9b88$var$alpha["pt-PT"];
$2bf28ab0abdb9b88$var$alphanumeric["pt-BR"] = $2bf28ab0abdb9b88$var$alphanumeric["pt-PT"];
$2bf28ab0abdb9b88$var$decimal["pt-BR"] = $2bf28ab0abdb9b88$var$decimal["pt-PT"]; // see #862
$2bf28ab0abdb9b88$var$alpha["pl-Pl"] = $2bf28ab0abdb9b88$var$alpha["pl-PL"];
$2bf28ab0abdb9b88$var$alphanumeric["pl-Pl"] = $2bf28ab0abdb9b88$var$alphanumeric["pl-PL"];
$2bf28ab0abdb9b88$var$decimal["pl-Pl"] = $2bf28ab0abdb9b88$var$decimal["pl-PL"]; // see #1455
$2bf28ab0abdb9b88$var$alpha["fa-AF"] = $2bf28ab0abdb9b88$var$alpha.fa;

});



parcelRegister("i0Thm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1d31b5c551b99b7$var$toInt;

var $d1d31b5c551b99b7$var$_assertString = $d1d31b5c551b99b7$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $d1d31b5c551b99b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d1d31b5c551b99b7$var$toInt(str, radix) {
    (0, $d1d31b5c551b99b7$var$_assertString.default)(str);
    return parseInt(str, radix || 10);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jy2rd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3b31573455f7c8a$var$toBoolean;

var $e3b31573455f7c8a$var$_assertString = $e3b31573455f7c8a$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $e3b31573455f7c8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e3b31573455f7c8a$var$toBoolean(str, strict) {
    (0, $e3b31573455f7c8a$var$_assertString.default)(str);
    if (strict) return str === "1" || /^true$/i.test(str);
    return str !== "0" && !/^false$/i.test(str) && str !== "";
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2rAei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c7a34d5b0691f39$var$equals;

var $1c7a34d5b0691f39$var$_assertString = $1c7a34d5b0691f39$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1c7a34d5b0691f39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c7a34d5b0691f39$var$equals(str, comparison) {
    (0, $1c7a34d5b0691f39$var$_assertString.default)(str);
    return str === comparison;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7BDCw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $589ab8df35064adf$var$contains;

var $589ab8df35064adf$var$_assertString = $589ab8df35064adf$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $589ab8df35064adf$var$_toString = $589ab8df35064adf$var$_interopRequireDefault((parcelRequire("9Q2f6")));

var $589ab8df35064adf$var$_merge = $589ab8df35064adf$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $589ab8df35064adf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $589ab8df35064adf$var$defaulContainsOptions = {
    ignoreCase: false,
    minOccurrences: 1
};
function $589ab8df35064adf$var$contains(str, elem, options) {
    (0, $589ab8df35064adf$var$_assertString.default)(str);
    options = (0, $589ab8df35064adf$var$_merge.default)(options, $589ab8df35064adf$var$defaulContainsOptions);
    if (options.ignoreCase) return str.toLowerCase().split((0, $589ab8df35064adf$var$_toString.default)(elem).toLowerCase()).length > options.minOccurrences;
    return str.split((0, $589ab8df35064adf$var$_toString.default)(elem)).length > options.minOccurrences;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("9Q2f6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $729ab5bdd167312d$var$toString;
function $729ab5bdd167312d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $729ab5bdd167312d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $729ab5bdd167312d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $729ab5bdd167312d$var$_typeof(obj);
}
function $729ab5bdd167312d$var$toString(input) {
    if ($729ab5bdd167312d$var$_typeof(input) === "object" && input !== null) {
        if (typeof input.toString === "function") input = input.toString();
        else input = "[object Object]";
    } else if (input === null || typeof input === "undefined" || isNaN(input) && !input.length) input = "";
    return String(input);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aXHNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7fb163acb42581c3$var$merge;
function $7fb163acb42581c3$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === "undefined") obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("2sqX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ca31a348b964377$var$matches;

var $1ca31a348b964377$var$_assertString = $1ca31a348b964377$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1ca31a348b964377$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1ca31a348b964377$var$matches(str, pattern, modifiers) {
    (0, $1ca31a348b964377$var$_assertString.default)(str);
    if (Object.prototype.toString.call(pattern) !== "[object RegExp]") pattern = new RegExp(pattern, modifiers);
    return !!str.match(pattern);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2Nl9T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2090920358e4fade$var$isEmail;

var $2090920358e4fade$var$_assertString = $2090920358e4fade$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $2090920358e4fade$var$_isByteLength = $2090920358e4fade$var$_interopRequireDefault((parcelRequire("5CAcv")));

var $2090920358e4fade$var$_isFQDN = $2090920358e4fade$var$_interopRequireDefault((parcelRequire("T9GCh")));

var $2090920358e4fade$var$_isIP = $2090920358e4fade$var$_interopRequireDefault((parcelRequire("dexNN")));

var $2090920358e4fade$var$_merge = $2090920358e4fade$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $2090920358e4fade$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2090920358e4fade$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: "",
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $2090920358e4fade$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $2090920358e4fade$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $2090920358e4fade$var$gmailUserPart = /^[a-z\d]+$/;
var $2090920358e4fade$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $2090920358e4fade$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $2090920358e4fade$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $2090920358e4fade$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $2090920358e4fade$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1"); // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
     // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
         // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $2090920358e4fade$var$isEmail(str, options) {
    (0, $2090920358e4fade$var$_assertString.default)(str);
    options = (0, $2090920358e4fade$var$_merge.default)(options, $2090920358e4fade$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($2090920358e4fade$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1]; // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, "").replace(/(^<|>$)/g, ""); // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(" ")) display_name = display_name.slice(0, -1);
            if (!$2090920358e4fade$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $2090920358e4fade$var$defaultMaxEmailLength) return false;
    var parts = str.split("@");
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join("@");
    if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase(); // Removing sub-address from username before gmail validation
        var username = user.split("+")[0]; // Dots are not included in gmail length restriction
        if (!(0, $2090920358e4fade$var$_isByteLength.default)(username.replace(/\./g, ""), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split(".");
        for(var i = 0; i < _user_parts.length; i++){
            if (!$2090920358e4fade$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $2090920358e4fade$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $2090920358e4fade$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $2090920358e4fade$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $2090920358e4fade$var$_isIP.default)(domain)) {
            if (!domain.startsWith("[") || !domain.endsWith("]")) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $2090920358e4fade$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $2090920358e4fade$var$quotedEmailUserUtf8.test(user) : $2090920358e4fade$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $2090920358e4fade$var$emailUserUtf8Part : $2090920358e4fade$var$emailUserPart;
    var user_parts = user.split(".");
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("5CAcv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $417c9510c3e80f0a$var$isByteLength;

var $417c9510c3e80f0a$var$_assertString = $417c9510c3e80f0a$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $417c9510c3e80f0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $417c9510c3e80f0a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $417c9510c3e80f0a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $417c9510c3e80f0a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $417c9510c3e80f0a$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $417c9510c3e80f0a$var$isByteLength(str, options) {
    (0, $417c9510c3e80f0a$var$_assertString.default)(str);
    var min;
    var max;
    if ($417c9510c3e80f0a$var$_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === "undefined" || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("T9GCh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a5ca6ada04fe1d2$var$isFQDN;

var $0a5ca6ada04fe1d2$var$_assertString = $0a5ca6ada04fe1d2$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $0a5ca6ada04fe1d2$var$_merge = $0a5ca6ada04fe1d2$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $0a5ca6ada04fe1d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a5ca6ada04fe1d2$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $0a5ca6ada04fe1d2$var$isFQDN(str, options) {
    (0, $0a5ca6ada04fe1d2$var$_assertString.default)(str);
    options = (0, $0a5ca6ada04fe1d2$var$_merge.default)(options, $0a5ca6ada04fe1d2$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === ".") str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf("*.") === 0) str = str.substring(2);
    var parts = str.split(".");
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
         // disallow spaces
        if (/\s/.test(tld)) return false;
    } // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
         // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
         // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dexNN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a26cd907293100f$var$isIP;

var $9a26cd907293100f$var$_assertString = $9a26cd907293100f$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $9a26cd907293100f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $9a26cd907293100f$var$IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var $9a26cd907293100f$var$IPv4AddressFormat = "(".concat($9a26cd907293100f$var$IPv4SegmentFormat, "[.]){3}").concat($9a26cd907293100f$var$IPv4SegmentFormat);
var $9a26cd907293100f$var$IPv4AddressRegExp = new RegExp("^".concat($9a26cd907293100f$var$IPv4AddressFormat, "$"));
var $9a26cd907293100f$var$IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var $9a26cd907293100f$var$IPv6AddressRegExp = new RegExp("^(" + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){7}(?:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){6}(?:").concat($9a26cd907293100f$var$IPv4AddressFormat, "|:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){5}(?::").concat($9a26cd907293100f$var$IPv4AddressFormat, "|(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){4}(?:(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){0,1}:").concat($9a26cd907293100f$var$IPv4AddressFormat, "|(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){3}(?:(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){0,2}:").concat($9a26cd907293100f$var$IPv4AddressFormat, "|(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){2}(?:(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){0,3}:").concat($9a26cd907293100f$var$IPv4AddressFormat, "|(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($9a26cd907293100f$var$IPv6SegmentFormat, ":){1}(?:(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){0,4}:").concat($9a26cd907293100f$var$IPv4AddressFormat, "|(:").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($9a26cd907293100f$var$IPv6SegmentFormat, "){0,5}:").concat($9a26cd907293100f$var$IPv4AddressFormat, "|(?::").concat($9a26cd907293100f$var$IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
function $9a26cd907293100f$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    (0, $9a26cd907293100f$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $9a26cd907293100f$var$isIP(str, 4) || $9a26cd907293100f$var$isIP(str, 6);
    if (version === "4") return $9a26cd907293100f$var$IPv4AddressRegExp.test(str);
    if (version === "6") return $9a26cd907293100f$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("2Djua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1eae56b273a53c34$var$isURL;

var $1eae56b273a53c34$var$_assertString = $1eae56b273a53c34$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $1eae56b273a53c34$var$_isFQDN = $1eae56b273a53c34$var$_interopRequireDefault((parcelRequire("T9GCh")));

var $1eae56b273a53c34$var$_isIP = $1eae56b273a53c34$var$_interopRequireDefault((parcelRequire("dexNN")));

var $1eae56b273a53c34$var$_merge = $1eae56b273a53c34$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $1eae56b273a53c34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1eae56b273a53c34$var$_slicedToArray(arr, i) {
    return $1eae56b273a53c34$var$_arrayWithHoles(arr) || $1eae56b273a53c34$var$_iterableToArrayLimit(arr, i) || $1eae56b273a53c34$var$_unsupportedIterableToArray(arr, i) || $1eae56b273a53c34$var$_nonIterableRest();
}
function $1eae56b273a53c34$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1eae56b273a53c34$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1eae56b273a53c34$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1eae56b273a53c34$var$_arrayLikeToArray(o, minLen);
}
function $1eae56b273a53c34$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1eae56b273a53c34$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1eae56b273a53c34$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/*
options for isURL method

require_protocol - if set as true isURL will return false if protocol is not present in the URL
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
protocols - valid protocols can be modified with this option
require_host - if set as false isURL will not check if host is present in the URL
require_port - if set as true isURL will check if port is present in the URL
allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

*/ var $1eae56b273a53c34$var$default_url_options = {
    protocols: [
        "http",
        "https",
        "ftp"
    ],
    require_tld: true,
    require_protocol: false,
    require_host: true,
    require_port: false,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
    allow_fragments: true,
    allow_query_components: true,
    validate_length: true
};
var $1eae56b273a53c34$var$wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
function $1eae56b273a53c34$var$isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
}
function $1eae56b273a53c34$var$checkHost(host, matches) {
    for(var i = 0; i < matches.length; i++){
        var match = matches[i];
        if (host === match || $1eae56b273a53c34$var$isRegExp(match) && match.test(host)) return true;
    }
    return false;
}
function $1eae56b273a53c34$var$isURL(url, options) {
    (0, $1eae56b273a53c34$var$_assertString.default)(url);
    if (!url || /[\s<>]/.test(url)) return false;
    if (url.indexOf("mailto:") === 0) return false;
    options = (0, $1eae56b273a53c34$var$_merge.default)(options, $1eae56b273a53c34$var$default_url_options);
    if (options.validate_length && url.length >= 2083) return false;
    if (!options.allow_fragments && url.includes("#")) return false;
    if (!options.allow_query_components && (url.includes("?") || url.includes("&"))) return false;
    var protocol, auth, host, hostname, port, port_str, split, ipv6;
    split = url.split("#");
    url = split.shift();
    split = url.split("?");
    url = split.shift();
    split = url.split("://");
    if (split.length > 1) {
        protocol = split.shift().toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) return false;
    } else if (options.require_protocol) return false;
    else if (url.slice(0, 2) === "//") {
        if (!options.allow_protocol_relative_urls) return false;
        split[0] = url.slice(2);
    }
    url = split.join("://");
    if (url === "") return false;
    split = url.split("/");
    url = split.shift();
    if (url === "" && !options.require_host) return true;
    split = url.split("@");
    if (split.length > 1) {
        if (options.disallow_auth) return false;
        if (split[0] === "") return false;
        auth = split.shift();
        if (auth.indexOf(":") >= 0 && auth.split(":").length > 2) return false;
        var _auth$split = auth.split(":"), _auth$split2 = $1eae56b273a53c34$var$_slicedToArray(_auth$split, 2), user = _auth$split2[0], password = _auth$split2[1];
        if (user === "" && password === "") return false;
    }
    hostname = split.join("@");
    port_str = null;
    ipv6 = null;
    var ipv6_match = hostname.match($1eae56b273a53c34$var$wrapped_ipv6);
    if (ipv6_match) {
        host = "";
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
    } else {
        split = hostname.split(":");
        host = split.shift();
        if (split.length) port_str = split.join(":");
    }
    if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) return false;
    } else if (options.require_port) return false;
    if (options.host_whitelist) return $1eae56b273a53c34$var$checkHost(host, options.host_whitelist);
    if (host === "" && !options.require_host) return true;
    if (!(0, $1eae56b273a53c34$var$_isIP.default)(host) && !(0, $1eae56b273a53c34$var$_isFQDN.default)(host, options) && (!ipv6 || !(0, $1eae56b273a53c34$var$_isIP.default)(ipv6, 6))) return false;
    host = host || ipv6;
    if (options.host_blacklist && $1eae56b273a53c34$var$checkHost(host, options.host_blacklist)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jxiV0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e38fc6336c797f17$var$isMACAddress;

var $e38fc6336c797f17$var$_assertString = $e38fc6336c797f17$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $e38fc6336c797f17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e38fc6336c797f17$var$macAddress48 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
var $e38fc6336c797f17$var$macAddress48NoSeparators = /^([0-9a-fA-F]){12}$/;
var $e38fc6336c797f17$var$macAddress48WithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;
var $e38fc6336c797f17$var$macAddress64 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/;
var $e38fc6336c797f17$var$macAddress64NoSeparators = /^([0-9a-fA-F]){16}$/;
var $e38fc6336c797f17$var$macAddress64WithDots = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
function $e38fc6336c797f17$var$isMACAddress(str, options) {
    (0, $e38fc6336c797f17$var$_assertString.default)(str);
    if (options !== null && options !== void 0 && options.eui) options.eui = String(options.eui);
    /**
   * @deprecated `no_colons` TODO: remove it in the next major
  */ if (options !== null && options !== void 0 && options.no_colons || options !== null && options !== void 0 && options.no_separators) {
        if (options.eui === "48") return $e38fc6336c797f17$var$macAddress48NoSeparators.test(str);
        if (options.eui === "64") return $e38fc6336c797f17$var$macAddress64NoSeparators.test(str);
        return $e38fc6336c797f17$var$macAddress48NoSeparators.test(str) || $e38fc6336c797f17$var$macAddress64NoSeparators.test(str);
    }
    if ((options === null || options === void 0 ? void 0 : options.eui) === "48") return $e38fc6336c797f17$var$macAddress48.test(str) || $e38fc6336c797f17$var$macAddress48WithDots.test(str);
    if ((options === null || options === void 0 ? void 0 : options.eui) === "64") return $e38fc6336c797f17$var$macAddress64.test(str) || $e38fc6336c797f17$var$macAddress64WithDots.test(str);
    return $e38fc6336c797f17$var$isMACAddress(str, {
        eui: "48"
    }) || $e38fc6336c797f17$var$isMACAddress(str, {
        eui: "64"
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kpZsd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edd5cff42ae1c798$var$isIPRange;

var $edd5cff42ae1c798$var$_assertString = $edd5cff42ae1c798$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $edd5cff42ae1c798$var$_isIP = $edd5cff42ae1c798$var$_interopRequireDefault((parcelRequire("dexNN")));
function $edd5cff42ae1c798$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $edd5cff42ae1c798$var$subnetMaybe = /^\d{1,3}$/;
var $edd5cff42ae1c798$var$v4Subnet = 32;
var $edd5cff42ae1c798$var$v6Subnet = 128;
function $edd5cff42ae1c798$var$isIPRange(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    (0, $edd5cff42ae1c798$var$_assertString.default)(str);
    var parts = str.split("/"); // parts[0] -> ip, parts[1] -> subnet
    if (parts.length !== 2) return false;
    if (!$edd5cff42ae1c798$var$subnetMaybe.test(parts[1])) return false;
     // Disallow preceding 0 i.e. 01, 02, ...
    if (parts[1].length > 1 && parts[1].startsWith("0")) return false;
    var isValidIP = (0, $edd5cff42ae1c798$var$_isIP.default)(parts[0], version);
    if (!isValidIP) return false;
     // Define valid subnet according to IP's version
    var expectedSubnet = null;
    switch(String(version)){
        case "4":
            expectedSubnet = $edd5cff42ae1c798$var$v4Subnet;
            break;
        case "6":
            expectedSubnet = $edd5cff42ae1c798$var$v6Subnet;
            break;
        default:
            expectedSubnet = (0, $edd5cff42ae1c798$var$_isIP.default)(parts[0], "6") ? $edd5cff42ae1c798$var$v6Subnet : $edd5cff42ae1c798$var$v4Subnet;
    }
    return parts[1] <= expectedSubnet && parts[1] >= 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ixWQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d808f461607ab64d$var$isDate;

var $d808f461607ab64d$var$_merge = $d808f461607ab64d$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $d808f461607ab64d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d808f461607ab64d$var$_slicedToArray(arr, i) {
    return $d808f461607ab64d$var$_arrayWithHoles(arr) || $d808f461607ab64d$var$_iterableToArrayLimit(arr, i) || $d808f461607ab64d$var$_unsupportedIterableToArray(arr, i) || $d808f461607ab64d$var$_nonIterableRest();
}
function $d808f461607ab64d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d808f461607ab64d$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d808f461607ab64d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d808f461607ab64d$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $d808f461607ab64d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d808f461607ab64d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d808f461607ab64d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d808f461607ab64d$var$_arrayLikeToArray(o, minLen);
}
function $d808f461607ab64d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d808f461607ab64d$var$default_date_options = {
    format: "YYYY/MM/DD",
    delimiters: [
        "/",
        "-"
    ],
    strictMode: false
};
function $d808f461607ab64d$var$isValidFormat(format) {
    return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
}
function $d808f461607ab64d$var$zip(date, format) {
    var zippedArr = [], len = Math.min(date.length, format.length);
    for(var i = 0; i < len; i++)zippedArr.push([
        date[i],
        format[i]
    ]);
    return zippedArr;
}
function $d808f461607ab64d$var$isDate(input, options) {
    if (typeof options === "string") // Allow backward compatbility for old format isDate(input [, format])
    options = (0, $d808f461607ab64d$var$_merge.default)({
        format: options
    }, $d808f461607ab64d$var$default_date_options);
    else options = (0, $d808f461607ab64d$var$_merge.default)(options, $d808f461607ab64d$var$default_date_options);
    if (typeof input === "string" && $d808f461607ab64d$var$isValidFormat(options.format)) {
        var formatDelimiter = options.delimiters.find(function(delimiter) {
            return options.format.indexOf(delimiter) !== -1;
        });
        var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function(delimiter) {
            return input.indexOf(delimiter) !== -1;
        });
        var dateAndFormat = $d808f461607ab64d$var$zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
        var dateObj = {};
        var _iterator = $d808f461607ab64d$var$_createForOfIteratorHelper(dateAndFormat), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $d808f461607ab64d$var$_slicedToArray(_step.value, 2), dateWord = _step$value[0], formatWord = _step$value[1];
                if (dateWord.length !== formatWord.length) return false;
                dateObj[formatWord.charAt(0)] = dateWord;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var fullYear = dateObj.y;
        if (dateObj.y.length === 2) {
            var parsedYear = parseInt(dateObj.y, 10);
            if (isNaN(parsedYear)) return false;
            var currentYearLastTwoDigits = new Date().getFullYear() % 100;
            if (parsedYear < currentYearLastTwoDigits) fullYear = "20".concat(dateObj.y);
            else fullYear = "19".concat(dateObj.y);
        }
        return new Date("".concat(fullYear, "-").concat(dateObj.m, "-").concat(dateObj.d)).getDate() === +dateObj.d;
    }
    if (!options.strictMode) return Object.prototype.toString.call(input) === "[object Date]" && isFinite(input);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9lfTy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cd267a88b7a5ac8$var$isTime;

var $6cd267a88b7a5ac8$var$_merge = $6cd267a88b7a5ac8$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $6cd267a88b7a5ac8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6cd267a88b7a5ac8$var$default_time_options = {
    hourFormat: "hour24",
    mode: "default"
};
var $6cd267a88b7a5ac8$var$formats = {
    hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
    },
    hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
    }
};
function $6cd267a88b7a5ac8$var$isTime(input, options) {
    options = (0, $6cd267a88b7a5ac8$var$_merge.default)(options, $6cd267a88b7a5ac8$var$default_time_options);
    if (typeof input !== "string") return false;
    return $6cd267a88b7a5ac8$var$formats[options.hourFormat][options.mode].test(input);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hZaLR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1807d097312edee$var$isBoolean;

var $d1807d097312edee$var$_assertString = $d1807d097312edee$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $d1807d097312edee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d1807d097312edee$var$defaultOptions = {
    loose: false
};
var $d1807d097312edee$var$strictBooleans = [
    "true",
    "false",
    "1",
    "0"
];
var $d1807d097312edee$var$looseBooleans = [].concat($d1807d097312edee$var$strictBooleans, [
    "yes",
    "no"
]);
function $d1807d097312edee$var$isBoolean(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d1807d097312edee$var$defaultOptions;
    (0, $d1807d097312edee$var$_assertString.default)(str);
    if (options.loose) return $d1807d097312edee$var$looseBooleans.includes(str.toLowerCase());
    return $d1807d097312edee$var$strictBooleans.includes(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2e4Ic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19f08b474e5a8eb7$var$isLocale;

var $19f08b474e5a8eb7$var$_assertString = $19f08b474e5a8eb7$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $19f08b474e5a8eb7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
  = 3ALPHA              ; selected ISO 639 codes
    *2("-" 3ALPHA)      ; permanently reserved
 */ var $19f08b474e5a8eb7$var$extlang = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})";
/*
  = 2*3ALPHA            ; shortest ISO 639 code
    ["-" extlang]       ; sometimes followed by
                        ; extended language subtags
  / 4ALPHA              ; or reserved for future use
  / 5*8ALPHA            ; or registered language subtag
 */ var $19f08b474e5a8eb7$var$language = "(([a-zA-Z]{2,3}(-".concat($19f08b474e5a8eb7$var$extlang, ")?)|([a-zA-Z]{5,8}))");
/*
  = 4ALPHA              ; ISO 15924 code
 */ var $19f08b474e5a8eb7$var$script = "([A-Za-z]{4})";
/*
  = 2ALPHA              ; ISO 3166-1 code
  / 3DIGIT              ; UN M.49 code
 */ var $19f08b474e5a8eb7$var$region = "([A-Za-z]{2}|\\d{3})";
/*
  = 5*8alphanum         ; registered variants
  / (DIGIT 3alphanum)
 */ var $19f08b474e5a8eb7$var$variant = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))";
/*
  = DIGIT               ; 0 - 9
  / %x41-57             ; A - W
  / %x59-5A             ; Y - Z
  / %x61-77             ; a - w
  / %x79-7A             ; y - z
 */ var $19f08b474e5a8eb7$var$singleton = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])";
/*
  = singleton 1*("-" (2*8alphanum))
                        ; Single alphanumerics
                        ; "x" reserved for private use
 */ var $19f08b474e5a8eb7$var$extension = "(".concat($19f08b474e5a8eb7$var$singleton, "(-[A-Za-z0-9]{2,8})+)");
/*
  = "x" 1*("-" (1*8alphanum))
 */ var $19f08b474e5a8eb7$var$privateuse = "(x(-[A-Za-z0-9]{1,8})+)"; // irregular tags do not match the 'langtag' production and would not
// otherwise be considered 'well-formed'. These tags are all valid, but
// most are deprecated in favor of more modern subtags or subtag combination
var $19f08b474e5a8eb7$var$irregular = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))"; // regular tags match the 'langtag' production, but their subtags are not
// extended language or variant subtags: their meaning is defined by
// their registration and all of these are deprecated in favor of a more
// modern subtag or sequence of subtags
var $19f08b474e5a8eb7$var$regular = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))";
/*
  = irregular           ; non-redundant tags registered
  / regular             ; during the RFC 3066 era

 */ var $19f08b474e5a8eb7$var$grandfathered = "(".concat($19f08b474e5a8eb7$var$irregular, "|").concat($19f08b474e5a8eb7$var$regular, ")");
/*
  RFC 5646 defines delimitation of subtags via a hyphen:

      "Subtag" refers to a specific section of a tag, delimited by a
      hyphen, such as the subtags 'zh', 'Hant', and 'CN' in the tag "zh-
      Hant-CN".  Examples of subtags in this document are enclosed in
      single quotes ('Hant')

  However, we need to add "_" to maintain the existing behaviour.
 */ var $19f08b474e5a8eb7$var$delimiter = "(-|_)";
/*
  = language
    ["-" script]
    ["-" region]
    *("-" variant)
    *("-" extension)
    ["-" privateuse]
 */ var $19f08b474e5a8eb7$var$langtag = "".concat($19f08b474e5a8eb7$var$language, "(").concat($19f08b474e5a8eb7$var$delimiter).concat($19f08b474e5a8eb7$var$script, ")?(").concat($19f08b474e5a8eb7$var$delimiter).concat($19f08b474e5a8eb7$var$region, ")?(").concat($19f08b474e5a8eb7$var$delimiter).concat($19f08b474e5a8eb7$var$variant, ")*(").concat($19f08b474e5a8eb7$var$delimiter).concat($19f08b474e5a8eb7$var$extension, ")*(").concat($19f08b474e5a8eb7$var$delimiter).concat($19f08b474e5a8eb7$var$privateuse, ")?");
/*
  Regex implementation based on BCP RFC 5646
  Tags for Identifying Languages
  https://www.rfc-editor.org/rfc/rfc5646.html
 */ var $19f08b474e5a8eb7$var$languageTagRegex = new RegExp("(^".concat($19f08b474e5a8eb7$var$privateuse, "$)|(^").concat($19f08b474e5a8eb7$var$grandfathered, "$)|(^").concat($19f08b474e5a8eb7$var$langtag, "$)"));
function $19f08b474e5a8eb7$var$isLocale(str) {
    (0, $19f08b474e5a8eb7$var$_assertString.default)(str);
    return $19f08b474e5a8eb7$var$languageTagRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aV0rk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f2f91986035baf3$var$isAlpha;
module.exports.locales = void 0;

var $7f2f91986035baf3$var$_assertString = $7f2f91986035baf3$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $3LVJg = parcelRequire("3LVJg");
function $7f2f91986035baf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7f2f91986035baf3$var$isAlpha(_str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, $7f2f91986035baf3$var$_assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
        if (ignore instanceof RegExp) str = str.replace(ignore, "");
        else if (typeof ignore === "string") str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), ""); // escape regex for ignore
        else throw new Error("ignore should be instance of a String or RegExp");
    }
    if (locale in $3LVJg.alpha) return $3LVJg.alpha[locale].test(str);
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $7f2f91986035baf3$var$locales = Object.keys($3LVJg.alpha);
module.exports.locales = $7f2f91986035baf3$var$locales;

});

parcelRegister("eXdnG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae30f4935a89ed4d$var$isAlphanumeric;
module.exports.locales = void 0;

var $ae30f4935a89ed4d$var$_assertString = $ae30f4935a89ed4d$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $3LVJg = parcelRequire("3LVJg");
function $ae30f4935a89ed4d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae30f4935a89ed4d$var$isAlphanumeric(_str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, $ae30f4935a89ed4d$var$_assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
        if (ignore instanceof RegExp) str = str.replace(ignore, "");
        else if (typeof ignore === "string") str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), ""); // escape regex for ignore
        else throw new Error("ignore should be instance of a String or RegExp");
    }
    if (locale in $3LVJg.alphanumeric) return $3LVJg.alphanumeric[locale].test(str);
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $ae30f4935a89ed4d$var$locales = Object.keys($3LVJg.alphanumeric);
module.exports.locales = $ae30f4935a89ed4d$var$locales;

});

parcelRegister("kpyBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edc0fb84cdb378db$var$isNumeric;

var $edc0fb84cdb378db$var$_assertString = $edc0fb84cdb378db$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $3LVJg = parcelRequire("3LVJg");
function $edc0fb84cdb378db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $edc0fb84cdb378db$var$numericNoSymbols = /^[0-9]+$/;
function $edc0fb84cdb378db$var$isNumeric(str, options) {
    (0, $edc0fb84cdb378db$var$_assertString.default)(str);
    if (options && options.no_symbols) return $edc0fb84cdb378db$var$numericNoSymbols.test(str);
    return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? $3LVJg.decimal[options.locale] : ".", "])?[0-9]+$")).test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8LM6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $662807240794e953$var$isPassportNumber;

var $662807240794e953$var$_assertString = $662807240794e953$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $662807240794e953$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Reference:
 * https://en.wikipedia.org/ -- Wikipedia
 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
 * https://countrycode.org/ -- Country Codes
 */ var $662807240794e953$var$passportRegexByCountryCode = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{2,3}\d{7,8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/ // UNITED STATES
};
/**
 * Check if str is a valid passport number
 * relative to provided ISO Country Code.
 *
 * @param {string} str
 * @param {string} countryCode
 * @return {boolean}
 */ function $662807240794e953$var$isPassportNumber(str, countryCode) {
    (0, $662807240794e953$var$_assertString.default)(str);
    /** Remove All Whitespaces, Convert to UPPERCASE */ var normalizedStr = str.replace(/\s/g, "").toUpperCase();
    return countryCode.toUpperCase() in $662807240794e953$var$passportRegexByCountryCode && $662807240794e953$var$passportRegexByCountryCode[countryCode].test(normalizedStr);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("fmlzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2e9a53e92db7a6b$var$isPort;

var $b2e9a53e92db7a6b$var$_isInt = $b2e9a53e92db7a6b$var$_interopRequireDefault((parcelRequire("vYRBE")));
function $b2e9a53e92db7a6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2e9a53e92db7a6b$var$isPort(str) {
    return (0, $b2e9a53e92db7a6b$var$_isInt.default)(str, {
        min: 0,
        max: 65535
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("vYRBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06021b9caf61ad1e$var$isInt;

var $06021b9caf61ad1e$var$_assertString = $06021b9caf61ad1e$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $06021b9caf61ad1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $06021b9caf61ad1e$var$int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var $06021b9caf61ad1e$var$intLeadingZeroes = /^[-+]?[0-9]+$/;
function $06021b9caf61ad1e$var$isInt(str, options) {
    (0, $06021b9caf61ad1e$var$_assertString.default)(str);
    options = options || {}; // Get the regex to use for testing, based on whether
    // leading zeroes are allowed or not.
    var regex = options.hasOwnProperty("allow_leading_zeroes") && !options.allow_leading_zeroes ? $06021b9caf61ad1e$var$int : $06021b9caf61ad1e$var$intLeadingZeroes; // Check min/max/lt/gt
    var minCheckPassed = !options.hasOwnProperty("min") || str >= options.min;
    var maxCheckPassed = !options.hasOwnProperty("max") || str <= options.max;
    var ltCheckPassed = !options.hasOwnProperty("lt") || str < options.lt;
    var gtCheckPassed = !options.hasOwnProperty("gt") || str > options.gt;
    return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("cXOxh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97023212d4e7185e$var$isLowercase;

var $97023212d4e7185e$var$_assertString = $97023212d4e7185e$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $97023212d4e7185e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97023212d4e7185e$var$isLowercase(str) {
    (0, $97023212d4e7185e$var$_assertString.default)(str);
    return str === str.toLowerCase();
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("cq4cL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90ab2cc054aed967$var$isUppercase;

var $90ab2cc054aed967$var$_assertString = $90ab2cc054aed967$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $90ab2cc054aed967$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $90ab2cc054aed967$var$isUppercase(str) {
    (0, $90ab2cc054aed967$var$_assertString.default)(str);
    return str === str.toUpperCase();
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4BlyC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $359b56fd024066a9$var$isIMEI;

var $359b56fd024066a9$var$_assertString = $359b56fd024066a9$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $359b56fd024066a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $359b56fd024066a9$var$imeiRegexWithoutHypens = /^[0-9]{15}$/;
var $359b56fd024066a9$var$imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
function $359b56fd024066a9$var$isIMEI(str, options) {
    (0, $359b56fd024066a9$var$_assertString.default)(str);
    options = options || {}; // default regex for checking imei is the one without hyphens
    var imeiRegex = $359b56fd024066a9$var$imeiRegexWithoutHypens;
    if (options.allow_hyphens) imeiRegex = $359b56fd024066a9$var$imeiRegexWithHypens;
    if (!imeiRegex.test(str)) return false;
    str = str.replace(/-/g, "");
    var sum = 0, mul = 2, l = 14;
    for(var i = 0; i < l; i++){
        var digit = str.substring(l - i - 1, l - i);
        var tp = parseInt(digit, 10) * mul;
        if (tp >= 10) sum += tp % 10 + 1;
        else sum += tp;
        if (mul === 1) mul += 1;
        else mul -= 1;
    }
    var chk = (10 - sum % 10) % 10;
    if (chk !== parseInt(str.substring(14, 15), 10)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("6HqiH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e0b28fa7017fdc1$var$isAscii;

var $4e0b28fa7017fdc1$var$_assertString = $4e0b28fa7017fdc1$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $4e0b28fa7017fdc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-control-regex */ var $4e0b28fa7017fdc1$var$ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */ function $4e0b28fa7017fdc1$var$isAscii(str) {
    (0, $4e0b28fa7017fdc1$var$_assertString.default)(str);
    return $4e0b28fa7017fdc1$var$ascii.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5Hlr6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $426198adae6d8312$var$isFullWidth;
module.exports.fullWidth = void 0;

var $426198adae6d8312$var$_assertString = $426198adae6d8312$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $426198adae6d8312$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $426198adae6d8312$var$fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
module.exports.fullWidth = $426198adae6d8312$var$fullWidth;
function $426198adae6d8312$var$isFullWidth(str) {
    (0, $426198adae6d8312$var$_assertString.default)(str);
    return $426198adae6d8312$var$fullWidth.test(str);
}

});

parcelRegister("dD68v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ec3ad6c0e530d46$var$isHalfWidth;
module.exports.halfWidth = void 0;

var $9ec3ad6c0e530d46$var$_assertString = $9ec3ad6c0e530d46$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $9ec3ad6c0e530d46$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9ec3ad6c0e530d46$var$halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
module.exports.halfWidth = $9ec3ad6c0e530d46$var$halfWidth;
function $9ec3ad6c0e530d46$var$isHalfWidth(str) {
    (0, $9ec3ad6c0e530d46$var$_assertString.default)(str);
    return $9ec3ad6c0e530d46$var$halfWidth.test(str);
}

});

parcelRegister("dsvgn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9cc624150aaaedde$var$isVariableWidth;

var $9cc624150aaaedde$var$_assertString = $9cc624150aaaedde$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $5Hlr6 = parcelRequire("5Hlr6");

var $dD68v = parcelRequire("dD68v");
function $9cc624150aaaedde$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9cc624150aaaedde$var$isVariableWidth(str) {
    (0, $9cc624150aaaedde$var$_assertString.default)(str);
    return $5Hlr6.fullWidth.test(str) && $dD68v.halfWidth.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dQ2d3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a131d879b1a6039d$var$isMultibyte;

var $a131d879b1a6039d$var$_assertString = $a131d879b1a6039d$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $a131d879b1a6039d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-control-regex */ var $a131d879b1a6039d$var$multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */ function $a131d879b1a6039d$var$isMultibyte(str) {
    (0, $a131d879b1a6039d$var$_assertString.default)(str);
    return $a131d879b1a6039d$var$multibyte.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("87eNp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e8a745aaf24d7a5$var$isSemVer;

var $5e8a745aaf24d7a5$var$_assertString = $5e8a745aaf24d7a5$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $5e8a745aaf24d7a5$var$_multilineRegex = $5e8a745aaf24d7a5$var$_interopRequireDefault((parcelRequire("k4Qhg")));
function $5e8a745aaf24d7a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Regular Expression to match
 * semantic versioning (SemVer)
 * built from multi-line, multi-parts regexp
 * Reference: https://semver.org/
 */ var $5e8a745aaf24d7a5$var$semanticVersioningRegex = (0, $5e8a745aaf24d7a5$var$_multilineRegex.default)([
    "^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)",
    "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))",
    "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"
], "i");
function $5e8a745aaf24d7a5$var$isSemVer(str) {
    (0, $5e8a745aaf24d7a5$var$_assertString.default)(str);
    return $5e8a745aaf24d7a5$var$semanticVersioningRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("k4Qhg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9dcbb93ed9c783e$var$multilineRegexp;
/**
 * Build RegExp object from an array
 * of multiple/multi-line regexp parts
 *
 * @param {string[]} parts
 * @param {string} flags
 * @return {object} - RegExp object
 */ function $e9dcbb93ed9c783e$var$multilineRegexp(parts, flags) {
    var regexpAsStringLiteral = parts.join("");
    return new RegExp(regexpAsStringLiteral, flags);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("eYk3J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae663a9c33b607c2$var$isSurrogatePair;

var $ae663a9c33b607c2$var$_assertString = $ae663a9c33b607c2$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $ae663a9c33b607c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ae663a9c33b607c2$var$surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
function $ae663a9c33b607c2$var$isSurrogatePair(str) {
    (0, $ae663a9c33b607c2$var$_assertString.default)(str);
    return $ae663a9c33b607c2$var$surrogatePair.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8xjBa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63709ba1ec9c08ab$var$isDecimal;

var $63709ba1ec9c08ab$var$_merge = $63709ba1ec9c08ab$var$_interopRequireDefault((parcelRequire("aXHNC")));

var $63709ba1ec9c08ab$var$_assertString = $63709ba1ec9c08ab$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $63709ba1ec9c08ab$var$_includes = $63709ba1ec9c08ab$var$_interopRequireDefault((parcelRequire("jVgQy")));

var $3LVJg = parcelRequire("3LVJg");
function $63709ba1ec9c08ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $63709ba1ec9c08ab$var$decimalRegExp(options) {
    var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat($3LVJg.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? "" : "?", "$"));
    return regExp;
}
var $63709ba1ec9c08ab$var$default_decimal_options = {
    force_decimal: false,
    decimal_digits: "1,",
    locale: "en-US"
};
var $63709ba1ec9c08ab$var$blacklist = [
    "",
    "-",
    "+"
];
function $63709ba1ec9c08ab$var$isDecimal(str, options) {
    (0, $63709ba1ec9c08ab$var$_assertString.default)(str);
    options = (0, $63709ba1ec9c08ab$var$_merge.default)(options, $63709ba1ec9c08ab$var$default_decimal_options);
    if (options.locale in $3LVJg.decimal) return !(0, $63709ba1ec9c08ab$var$_includes.default)($63709ba1ec9c08ab$var$blacklist, str.replace(/ /g, "")) && $63709ba1ec9c08ab$var$decimalRegExp(options).test(str);
    throw new Error("Invalid locale '".concat(options.locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("jVgQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e8106898569ab4db$var$includes = function includes(arr, val) {
    return arr.some(function(arrVal) {
        return val === arrVal;
    });
};
var $e8106898569ab4db$var$_default = $e8106898569ab4db$var$includes;
module.exports.default = $e8106898569ab4db$var$_default;
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("ijVHf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d566c1ae5ed723e1$var$isHexadecimal;

var $d566c1ae5ed723e1$var$_assertString = $d566c1ae5ed723e1$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $d566c1ae5ed723e1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d566c1ae5ed723e1$var$hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
function $d566c1ae5ed723e1$var$isHexadecimal(str) {
    (0, $d566c1ae5ed723e1$var$_assertString.default)(str);
    return $d566c1ae5ed723e1$var$hexadecimal.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lE2DI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc1f618d4111c8c1$var$isOctal;

var $fc1f618d4111c8c1$var$_assertString = $fc1f618d4111c8c1$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $fc1f618d4111c8c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fc1f618d4111c8c1$var$octal = /^(0o)?[0-7]+$/i;
function $fc1f618d4111c8c1$var$isOctal(str) {
    (0, $fc1f618d4111c8c1$var$_assertString.default)(str);
    return $fc1f618d4111c8c1$var$octal.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("e4PHM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3f98bfc13a6109c$var$isDivisibleBy;

var $a3f98bfc13a6109c$var$_assertString = $a3f98bfc13a6109c$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $a3f98bfc13a6109c$var$_toFloat = $a3f98bfc13a6109c$var$_interopRequireDefault((parcelRequire("bNf7m")));
function $a3f98bfc13a6109c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a3f98bfc13a6109c$var$isDivisibleBy(str, num) {
    (0, $a3f98bfc13a6109c$var$_assertString.default)(str);
    return (0, $a3f98bfc13a6109c$var$_toFloat.default)(str) % parseInt(num, 10) === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("c3ees", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c60ce13b561d087$var$isHexColor;

var $8c60ce13b561d087$var$_assertString = $8c60ce13b561d087$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $8c60ce13b561d087$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8c60ce13b561d087$var$hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
function $8c60ce13b561d087$var$isHexColor(str) {
    (0, $8c60ce13b561d087$var$_assertString.default)(str);
    return $8c60ce13b561d087$var$hexcolor.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("3mSUx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $273e0555e697d3c1$var$isRgbColor;

var $273e0555e697d3c1$var$_assertString = $273e0555e697d3c1$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $273e0555e697d3c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $273e0555e697d3c1$var$rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
var $273e0555e697d3c1$var$rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
var $273e0555e697d3c1$var$rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/;
var $273e0555e697d3c1$var$rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
function $273e0555e697d3c1$var$isRgbColor(str) {
    var includePercentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, $273e0555e697d3c1$var$_assertString.default)(str);
    if (!includePercentValues) return $273e0555e697d3c1$var$rgbColor.test(str) || $273e0555e697d3c1$var$rgbaColor.test(str);
    return $273e0555e697d3c1$var$rgbColor.test(str) || $273e0555e697d3c1$var$rgbaColor.test(str) || $273e0555e697d3c1$var$rgbColorPercent.test(str) || $273e0555e697d3c1$var$rgbaColorPercent.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("YCcJx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b633d4e05cf69c0$var$isHSL;

var $0b633d4e05cf69c0$var$_assertString = $0b633d4e05cf69c0$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $0b633d4e05cf69c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0b633d4e05cf69c0$var$hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
var $0b633d4e05cf69c0$var$hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
function $0b633d4e05cf69c0$var$isHSL(str) {
    (0, $0b633d4e05cf69c0$var$_assertString.default)(str); // Strip duplicate spaces before calling the validation regex (See  #1598 for more info)
    var strippedStr = str.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
    if (strippedStr.indexOf(",") !== -1) return $0b633d4e05cf69c0$var$hslComma.test(strippedStr);
    return $0b633d4e05cf69c0$var$hslSpace.test(strippedStr);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("d8NWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9912c4cd32575512$var$isISRC;

var $9912c4cd32575512$var$_assertString = $9912c4cd32575512$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $9912c4cd32575512$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var $9912c4cd32575512$var$isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
function $9912c4cd32575512$var$isISRC(str) {
    (0, $9912c4cd32575512$var$_assertString.default)(str);
    return $9912c4cd32575512$var$isrc.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ffjn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b197488e0e67ff37$var$isIBAN;
module.exports.locales = void 0;

var $b197488e0e67ff37$var$_assertString = $b197488e0e67ff37$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $b197488e0e67ff37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * List of country codes with
 * corresponding IBAN regular expression
 * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
 */ var $b197488e0e67ff37$var$ibanRegexThroughCountryCode = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
};
/**
 * Check if the country codes passed are valid using the
 * ibanRegexThroughCountryCode as a reference
 *
 * @param {array} countryCodeArray
 * @return {boolean}
 */ function $b197488e0e67ff37$var$hasOnlyValidCountryCodes(countryCodeArray) {
    var countryCodeArrayFilteredWithObjectIbanCode = countryCodeArray.filter(function(countryCode) {
        return !(countryCode in $b197488e0e67ff37$var$ibanRegexThroughCountryCode);
    });
    if (countryCodeArrayFilteredWithObjectIbanCode.length > 0) return false;
    return true;
}
/**
 * Check whether string has correct universal IBAN format
 * The IBAN consists of up to 34 alphanumeric characters, as follows:
 * Country Code using ISO 3166-1 alpha-2, two letters
 * check digits, two digits and
 * Basic Bank Account Number (BBAN), up to 30 alphanumeric characters.
 * NOTE: Permitted IBAN characters are: digits [0-9] and the 26 latin alphabetic [A-Z]
 *
 * @param {string} str - string under validation
 * @param {object} options - object to pass the countries to be either whitelisted or blacklisted
 * @return {boolean}
 */ function $b197488e0e67ff37$var$hasValidIbanFormat(str, options) {
    // Strip white spaces and hyphens
    var strippedStr = str.replace(/[\s\-]+/gi, "").toUpperCase();
    var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
    var isoCountryCodeInIbanRegexCodeObject = isoCountryCode in $b197488e0e67ff37$var$ibanRegexThroughCountryCode;
    if (options.whitelist) {
        if (!$b197488e0e67ff37$var$hasOnlyValidCountryCodes(options.whitelist)) return false;
        var isoCountryCodeInWhiteList = options.whitelist.includes(isoCountryCode);
        if (!isoCountryCodeInWhiteList) return false;
    }
    if (options.blacklist) {
        var isoCountryCodeInBlackList = options.blacklist.includes(isoCountryCode);
        if (isoCountryCodeInBlackList) return false;
    }
    return isoCountryCodeInIbanRegexCodeObject && $b197488e0e67ff37$var$ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
}
/**
   * Check whether string has valid IBAN Checksum
   * by performing basic mod-97 operation and
   * the remainder should equal 1
   * -- Start by rearranging the IBAN by moving the four initial characters to the end of the string
   * -- Replace each letter in the string with two digits, A -> 10, B = 11, Z = 35
   * -- Interpret the string as a decimal integer and
   * -- compute the remainder on division by 97 (mod 97)
   * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
   *
   * @param {string} str
   * @return {boolean}
   */ function $b197488e0e67ff37$var$hasValidIbanChecksum(str) {
    var strippedStr = str.replace(/[^A-Z0-9]+/gi, "").toUpperCase(); // Keep only digits and A-Z latin alphabetic
    var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
    var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function(char) {
        return char.charCodeAt(0) - 55;
    });
    var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function(acc, value) {
        return Number(acc + value) % 97;
    }, "");
    return remainder === 1;
}
function $b197488e0e67ff37$var$isIBAN(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $b197488e0e67ff37$var$_assertString.default)(str);
    return $b197488e0e67ff37$var$hasValidIbanFormat(str, options) && $b197488e0e67ff37$var$hasValidIbanChecksum(str);
}
var $b197488e0e67ff37$var$locales = Object.keys($b197488e0e67ff37$var$ibanRegexThroughCountryCode);
module.exports.locales = $b197488e0e67ff37$var$locales;

});

parcelRegister("lE5QL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc21df199f1862f0$var$isBIC;

var $fc21df199f1862f0$var$_assertString = $fc21df199f1862f0$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $47ueG = parcelRequire("47ueG");
function $fc21df199f1862f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://en.wikipedia.org/wiki/ISO_9362
var $fc21df199f1862f0$var$isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
function $fc21df199f1862f0$var$isBIC(str) {
    (0, $fc21df199f1862f0$var$_assertString.default)(str); // toUpperCase() should be removed when a new major version goes out that changes
    // the regex to [A-Z] (per the spec).
    var countryCode = str.slice(4, 6).toUpperCase();
    if (!$47ueG.CountryCodes.has(countryCode) && countryCode !== "XK") return false;
    return $fc21df199f1862f0$var$isBICReg.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("47ueG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fff4518e76cca36$var$isISO31661Alpha2;
module.exports.CountryCodes = void 0;

var $2fff4518e76cca36$var$_assertString = $2fff4518e76cca36$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $2fff4518e76cca36$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var $2fff4518e76cca36$var$validISO31661Alpha2CountriesCodes = new Set([
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
]);
function $2fff4518e76cca36$var$isISO31661Alpha2(str) {
    (0, $2fff4518e76cca36$var$_assertString.default)(str);
    return $2fff4518e76cca36$var$validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
}
var $2fff4518e76cca36$var$CountryCodes = $2fff4518e76cca36$var$validISO31661Alpha2CountriesCodes;
module.exports.CountryCodes = $2fff4518e76cca36$var$CountryCodes;

});


parcelRegister("6XFar", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51182fc76a338c60$var$isMD5;

var $51182fc76a338c60$var$_assertString = $51182fc76a338c60$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $51182fc76a338c60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $51182fc76a338c60$var$md5 = /^[a-f0-9]{32}$/;
function $51182fc76a338c60$var$isMD5(str) {
    (0, $51182fc76a338c60$var$_assertString.default)(str);
    return $51182fc76a338c60$var$md5.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("22yTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17c6d69011a81d8e$var$isHash;

var $17c6d69011a81d8e$var$_assertString = $17c6d69011a81d8e$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $17c6d69011a81d8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $17c6d69011a81d8e$var$lengths = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
};
function $17c6d69011a81d8e$var$isHash(str, algorithm) {
    (0, $17c6d69011a81d8e$var$_assertString.default)(str);
    var hash = new RegExp("^[a-fA-F0-9]{".concat($17c6d69011a81d8e$var$lengths[algorithm], "}$"));
    return hash.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kqU6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee01c0a7a24eb76b$var$isJWT;

var $ee01c0a7a24eb76b$var$_assertString = $ee01c0a7a24eb76b$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $ee01c0a7a24eb76b$var$_isBase = $ee01c0a7a24eb76b$var$_interopRequireDefault((parcelRequire("FZlcs")));
function $ee01c0a7a24eb76b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee01c0a7a24eb76b$var$isJWT(str) {
    (0, $ee01c0a7a24eb76b$var$_assertString.default)(str);
    var dotSplit = str.split(".");
    var len = dotSplit.length;
    if (len !== 3) return false;
    return dotSplit.reduce(function(acc, currElem) {
        return acc && (0, $ee01c0a7a24eb76b$var$_isBase.default)(currElem, {
            urlSafe: true
        });
    }, true);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("FZlcs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07e3697b61761d10$var$isBase64;

var $07e3697b61761d10$var$_assertString = $07e3697b61761d10$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $07e3697b61761d10$var$_merge = $07e3697b61761d10$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $07e3697b61761d10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $07e3697b61761d10$var$notBase64 = /[^A-Z0-9+\/=]/i;
var $07e3697b61761d10$var$urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
var $07e3697b61761d10$var$defaultBase64Options = {
    urlSafe: false
};
function $07e3697b61761d10$var$isBase64(str, options) {
    (0, $07e3697b61761d10$var$_assertString.default)(str);
    options = (0, $07e3697b61761d10$var$_merge.default)(options, $07e3697b61761d10$var$defaultBase64Options);
    var len = str.length;
    if (options.urlSafe) return $07e3697b61761d10$var$urlSafeBase64.test(str);
    if (len % 4 !== 0 || $07e3697b61761d10$var$notBase64.test(str)) return false;
    var firstPaddingChar = str.indexOf("=");
    return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === "=";
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("kr3HT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee09345ff7af212d$var$isJSON;

var $ee09345ff7af212d$var$_assertString = $ee09345ff7af212d$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $ee09345ff7af212d$var$_merge = $ee09345ff7af212d$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $ee09345ff7af212d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee09345ff7af212d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ee09345ff7af212d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ee09345ff7af212d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ee09345ff7af212d$var$_typeof(obj);
}
var $ee09345ff7af212d$var$default_json_options = {
    allow_primitives: false
};
function $ee09345ff7af212d$var$isJSON(str, options) {
    (0, $ee09345ff7af212d$var$_assertString.default)(str);
    try {
        options = (0, $ee09345ff7af212d$var$_merge.default)(options, $ee09345ff7af212d$var$default_json_options);
        var primitives = [];
        if (options.allow_primitives) primitives = [
            null,
            false,
            true
        ];
        var obj = JSON.parse(str);
        return primitives.includes(obj) || !!obj && $ee09345ff7af212d$var$_typeof(obj) === "object";
    } catch (e) {
    /* ignore */ }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("iRJWq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbc0d03d7e8f1734$var$isEmpty;

var $dbc0d03d7e8f1734$var$_assertString = $dbc0d03d7e8f1734$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $dbc0d03d7e8f1734$var$_merge = $dbc0d03d7e8f1734$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $dbc0d03d7e8f1734$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dbc0d03d7e8f1734$var$default_is_empty_options = {
    ignore_whitespace: false
};
function $dbc0d03d7e8f1734$var$isEmpty(str, options) {
    (0, $dbc0d03d7e8f1734$var$_assertString.default)(str);
    options = (0, $dbc0d03d7e8f1734$var$_merge.default)(options, $dbc0d03d7e8f1734$var$default_is_empty_options);
    return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9Xy9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74041cd77656ffaa$var$isLength;

var $74041cd77656ffaa$var$_assertString = $74041cd77656ffaa$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $74041cd77656ffaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $74041cd77656ffaa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $74041cd77656ffaa$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $74041cd77656ffaa$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $74041cd77656ffaa$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $74041cd77656ffaa$var$isLength(str, options) {
    (0, $74041cd77656ffaa$var$_assertString.default)(str);
    var min;
    var max;
    if ($74041cd77656ffaa$var$_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isLength(str, min [, max])
        min = arguments[1] || 0;
        max = arguments[2];
    }
    var presentationSequences = str.match(/(\uFE0F|\uFE0E)/g) || [];
    var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
    var len = str.length - presentationSequences.length - surrogatePairs.length;
    return len >= min && (typeof max === "undefined" || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("by6IX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $868815f5a3d24d76$var$isUUID;

var $868815f5a3d24d76$var$_assertString = $868815f5a3d24d76$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $868815f5a3d24d76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $868815f5a3d24d76$var$uuid = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};
function $868815f5a3d24d76$var$isUUID(str, version) {
    (0, $868815f5a3d24d76$var$_assertString.default)(str);
    var pattern = $868815f5a3d24d76$var$uuid[![
        undefined,
        null
    ].includes(version) ? version : "all"];
    return !!pattern && pattern.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("cyH15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $924a072d4d340bfd$var$isMongoId;

var $924a072d4d340bfd$var$_assertString = $924a072d4d340bfd$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $924a072d4d340bfd$var$_isHexadecimal = $924a072d4d340bfd$var$_interopRequireDefault((parcelRequire("ijVHf")));
function $924a072d4d340bfd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $924a072d4d340bfd$var$isMongoId(str) {
    (0, $924a072d4d340bfd$var$_assertString.default)(str);
    return (0, $924a072d4d340bfd$var$_isHexadecimal.default)(str) && str.length === 24;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7jcRv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $552448e6279a0482$var$isAfter;

var $552448e6279a0482$var$_toDate = $552448e6279a0482$var$_interopRequireDefault((parcelRequire("80LJg")));
function $552448e6279a0482$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $552448e6279a0482$var$isAfter(date, options) {
    // For backwards compatibility:
    // isAfter(str [, date]), i.e. `options` could be used as argument for the legacy `date`
    var comparisonDate = (options === null || options === void 0 ? void 0 : options.comparisonDate) || options || Date().toString();
    var comparison = (0, $552448e6279a0482$var$_toDate.default)(comparisonDate);
    var original = (0, $552448e6279a0482$var$_toDate.default)(date);
    return !!(original && comparison && original > comparison);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("3LA1R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2be1b57937d642a8$var$isBefore;

var $2be1b57937d642a8$var$_assertString = $2be1b57937d642a8$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $2be1b57937d642a8$var$_toDate = $2be1b57937d642a8$var$_interopRequireDefault((parcelRequire("80LJg")));
function $2be1b57937d642a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2be1b57937d642a8$var$isBefore(str) {
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
    (0, $2be1b57937d642a8$var$_assertString.default)(str);
    var comparison = (0, $2be1b57937d642a8$var$_toDate.default)(date);
    var original = (0, $2be1b57937d642a8$var$_toDate.default)(str);
    return !!(original && comparison && original < comparison);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jJbsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5cb1bc42fa94606$var$isIn;

var $e5cb1bc42fa94606$var$_assertString = $e5cb1bc42fa94606$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $e5cb1bc42fa94606$var$_toString = $e5cb1bc42fa94606$var$_interopRequireDefault((parcelRequire("9Q2f6")));
function $e5cb1bc42fa94606$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e5cb1bc42fa94606$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e5cb1bc42fa94606$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e5cb1bc42fa94606$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e5cb1bc42fa94606$var$_typeof(obj);
}
function $e5cb1bc42fa94606$var$isIn(str, options) {
    (0, $e5cb1bc42fa94606$var$_assertString.default)(str);
    var i;
    if (Object.prototype.toString.call(options) === "[object Array]") {
        var array = [];
        for(i in options)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if (({}).hasOwnProperty.call(options, i)) array[i] = (0, $e5cb1bc42fa94606$var$_toString.default)(options[i]);
        return array.indexOf(str) >= 0;
    } else if ($e5cb1bc42fa94606$var$_typeof(options) === "object") return options.hasOwnProperty(str);
    else if (options && typeof options.indexOf === "function") return options.indexOf(str) >= 0;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("d6ls8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $989c79ff26d5707f$var$isLuhnNumber;

var $989c79ff26d5707f$var$_assertString = $989c79ff26d5707f$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $989c79ff26d5707f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $989c79ff26d5707f$var$isLuhnNumber(str) {
    (0, $989c79ff26d5707f$var$_assertString.default)(str);
    var sanitized = str.replace(/[- ]+/g, "");
    var sum = 0;
    var digit;
    var tmpNum;
    var shouldDouble;
    for(var i = sanitized.length - 1; i >= 0; i--){
        digit = sanitized.substring(i, i + 1);
        tmpNum = parseInt(digit, 10);
        if (shouldDouble) {
            tmpNum *= 2;
            if (tmpNum >= 10) sum += tmpNum % 10 + 1;
            else sum += tmpNum;
        } else sum += tmpNum;
        shouldDouble = !shouldDouble;
    }
    return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("6fSL5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48de9eab4a754b11$var$isCreditCard;

var $48de9eab4a754b11$var$_assertString = $48de9eab4a754b11$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $48de9eab4a754b11$var$_isLuhnNumber = $48de9eab4a754b11$var$_interopRequireDefault((parcelRequire("d6ls8")));
function $48de9eab4a754b11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $48de9eab4a754b11$var$cards = {
    amex: /^3[47][0-9]{13}$/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    // /^[25][1-7][0-9]{14}$/;
    unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
    visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
};
var $48de9eab4a754b11$var$allCards = function() {
    var tmpCardsArray = [];
    for(var cardProvider in $48de9eab4a754b11$var$cards)// istanbul ignore else
    if ($48de9eab4a754b11$var$cards.hasOwnProperty(cardProvider)) tmpCardsArray.push($48de9eab4a754b11$var$cards[cardProvider]);
    return tmpCardsArray;
}();
function $48de9eab4a754b11$var$isCreditCard(card) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $48de9eab4a754b11$var$_assertString.default)(card);
    var provider = options.provider;
    var sanitized = card.replace(/[- ]+/g, "");
    if (provider && provider.toLowerCase() in $48de9eab4a754b11$var$cards) {
        // specific provider in the list
        if (!$48de9eab4a754b11$var$cards[provider.toLowerCase()].test(sanitized)) return false;
    } else if (provider && !(provider.toLowerCase() in $48de9eab4a754b11$var$cards)) /* specific provider not in the list */ throw new Error("".concat(provider, " is not a valid credit card provider."));
    else if (!$48de9eab4a754b11$var$allCards.some(function(cardProvider) {
        return cardProvider.test(sanitized);
    })) // no specific provider
    return false;
    return (0, $48de9eab4a754b11$var$_isLuhnNumber.default)(card);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9shKI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e247fd9769a493c$var$isIdentityCard;

var $6e247fd9769a493c$var$_assertString = $6e247fd9769a493c$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $6e247fd9769a493c$var$_isInt = $6e247fd9769a493c$var$_interopRequireDefault((parcelRequire("vYRBE")));
function $6e247fd9769a493c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e247fd9769a493c$var$validators = {
    PL: function PL(str) {
        (0, $6e247fd9769a493c$var$_assertString.default)(str);
        var weightOfDigits = {
            1: 1,
            2: 3,
            3: 7,
            4: 9,
            5: 1,
            6: 3,
            7: 7,
            8: 9,
            9: 1,
            10: 3,
            11: 0
        };
        if (str != null && str.length === 11 && (0, $6e247fd9769a493c$var$_isInt.default)(str, {
            allow_leading_zeroes: true
        })) {
            var digits = str.split("").slice(0, -1);
            var sum = digits.reduce(function(acc, digit, index) {
                return acc + Number(digit) * weightOfDigits[index + 1];
            }, 0);
            var modulo = sum % 10;
            var lastDigit = Number(str.charAt(str.length - 1));
            if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) return true;
        }
        return false;
    },
    ES: function ES(str) {
        (0, $6e247fd9769a493c$var$_assertString.default)(str);
        var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
        var charsValue = {
            X: 0,
            Y: 1,
            Z: 2
        };
        var controlDigits = [
            "T",
            "R",
            "W",
            "A",
            "G",
            "M",
            "Y",
            "F",
            "P",
            "D",
            "X",
            "B",
            "N",
            "J",
            "Z",
            "S",
            "Q",
            "V",
            "H",
            "L",
            "C",
            "K",
            "E"
        ]; // sanitize user input
        var sanitized = str.trim().toUpperCase(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
         // validate the control digit
        var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function(char) {
            return charsValue[char];
        });
        return sanitized.endsWith(controlDigits[number % 23]);
    },
    FI: function FI(str) {
        // https://dvv.fi/en/personal-identity-code#:~:text=control%20character%20for%20a-,personal,-identity%20code%20calculated
        (0, $6e247fd9769a493c$var$_assertString.default)(str);
        if (str.length !== 11) return false;
        if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) return false;
        var checkDigits = "0123456789ABCDEFHJKLMNPRSTUVWXY";
        var idAsNumber = parseInt(str.slice(0, 6), 10) * 1000 + parseInt(str.slice(7, 10), 10);
        var remainder = idAsNumber % 31;
        var checkDigit = checkDigits[remainder];
        return checkDigit === str.slice(10, 11);
    },
    IN: function IN(str) {
        var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/; // multiplication table
        var d = [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ],
            [
                1,
                2,
                3,
                4,
                0,
                6,
                7,
                8,
                9,
                5
            ],
            [
                2,
                3,
                4,
                0,
                1,
                7,
                8,
                9,
                5,
                6
            ],
            [
                3,
                4,
                0,
                1,
                2,
                8,
                9,
                5,
                6,
                7
            ],
            [
                4,
                0,
                1,
                2,
                3,
                9,
                5,
                6,
                7,
                8
            ],
            [
                5,
                9,
                8,
                7,
                6,
                0,
                4,
                3,
                2,
                1
            ],
            [
                6,
                5,
                9,
                8,
                7,
                1,
                0,
                4,
                3,
                2
            ],
            [
                7,
                6,
                5,
                9,
                8,
                2,
                1,
                0,
                4,
                3
            ],
            [
                8,
                7,
                6,
                5,
                9,
                3,
                2,
                1,
                0,
                4
            ],
            [
                9,
                8,
                7,
                6,
                5,
                4,
                3,
                2,
                1,
                0
            ]
        ]; // permutation table
        var p = [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ],
            [
                1,
                5,
                7,
                6,
                2,
                8,
                3,
                0,
                9,
                4
            ],
            [
                5,
                8,
                0,
                3,
                7,
                9,
                6,
                1,
                4,
                2
            ],
            [
                8,
                9,
                1,
                6,
                0,
                4,
                3,
                5,
                2,
                7
            ],
            [
                9,
                4,
                5,
                3,
                1,
                2,
                6,
                8,
                7,
                0
            ],
            [
                4,
                2,
                8,
                6,
                5,
                7,
                3,
                9,
                0,
                1
            ],
            [
                2,
                7,
                9,
                3,
                8,
                0,
                6,
                4,
                1,
                5
            ],
            [
                7,
                0,
                4,
                6,
                9,
                1,
                3,
                2,
                5,
                8
            ]
        ]; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
        var c = 0;
        var invertedArray = sanitized.replace(/\s/g, "").split("").map(Number).reverse();
        invertedArray.forEach(function(val, i) {
            c = d[c][p[i % 8][val]];
        });
        return c === 0;
    },
    IR: function IR(str) {
        if (!str.match(/^\d{10}$/)) return false;
        str = "0000".concat(str).slice(str.length - 6);
        if (parseInt(str.slice(3, 9), 10) === 0) return false;
        var lastNumber = parseInt(str.slice(9, 10), 10);
        var sum = 0;
        for(var i = 0; i < 9; i++)sum += parseInt(str.slice(i, i + 1), 10) * (10 - i);
        sum %= 11;
        return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
    },
    IT: function IT(str) {
        if (str.length !== 9) return false;
        if (str === "CA00000AA") return false; // https://it.wikipedia.org/wiki/Carta_d%27identit%C3%A0_elettronica_italiana
        return str.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
    },
    NO: function NO(str) {
        var sanitized = str.trim();
        if (isNaN(Number(sanitized))) return false;
        if (sanitized.length !== 11) return false;
        if (sanitized === "00000000000") return false; // https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
        var f = sanitized.split("").map(Number);
        var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
        var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
        if (k1 !== f[9] || k2 !== f[10]) return false;
        return true;
    },
    TH: function TH(str) {
        if (!str.match(/^[1-8]\d{12}$/)) return false; // validate check digit
        var sum = 0;
        for(var i = 0; i < 12; i++)sum += parseInt(str[i], 10) * (13 - i);
        return str[12] === ((11 - sum % 11) % 10).toString();
    },
    LK: function LK(str) {
        var old_nic = /^[1-9]\d{8}[vx]$/i;
        var new_nic = /^[1-9]\d{11}$/i;
        if (str.length === 10 && old_nic.test(str)) return true;
        else if (str.length === 12 && new_nic.test(str)) return true;
        return false;
    },
    "he-IL": function heIL(str) {
        var DNI = /^\d{9}$/; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
        var id = sanitized;
        var sum = 0, incNum;
        for(var i = 0; i < id.length; i++){
            incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2
            sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
        }
        return sum % 10 === 0;
    },
    "ar-LY": function arLY(str) {
        // Libya National Identity Number NIN is 12 digits, the first digit is either 1 or 2
        var NIN = /^(1|2)\d{11}$/; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!NIN.test(sanitized)) return false;
        return true;
    },
    "ar-TN": function arTN(str) {
        var DNI = /^\d{8}$/; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
        return true;
    },
    "zh-CN": function zhCN(str) {
        var provincesAndCities = [
            "11",
            "12",
            "13",
            "14",
            "15",
            "21",
            "22",
            "23",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "50",
            "51",
            "52",
            "53",
            "54",
            "61",
            "62",
            "63",
            "64",
            "65",
            "71",
            "81",
            "82",
            "91" // 国外
        ];
        var powers = [
            "7",
            "9",
            "10",
            "5",
            "8",
            "4",
            "2",
            "1",
            "6",
            "3",
            "7",
            "9",
            "10",
            "5",
            "8",
            "4",
            "2"
        ];
        var parityBit = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2"
        ];
        var checkAddressCode = function checkAddressCode(addressCode) {
            return provincesAndCities.includes(addressCode);
        };
        var checkBirthDayCode = function checkBirthDayCode(birDayCode) {
            var yyyy = parseInt(birDayCode.substring(0, 4), 10);
            var mm = parseInt(birDayCode.substring(4, 6), 10);
            var dd = parseInt(birDayCode.substring(6), 10);
            var xdata = new Date(yyyy, mm - 1, dd);
            if (xdata > new Date()) return false; // eslint-disable-next-line max-len
            else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) return true;
            return false;
        };
        var getParityBit = function getParityBit(idCardNo) {
            var id17 = idCardNo.substring(0, 17);
            var power = 0;
            for(var i = 0; i < 17; i++)power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
            var mod = power % 11;
            return parityBit[mod];
        };
        var checkParityBit = function checkParityBit(idCardNo) {
            return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
        };
        var check15IdCardNo = function check15IdCardNo(idCardNo) {
            var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
            if (!check) return false;
            var addressCode = idCardNo.substring(0, 2);
            check = checkAddressCode(addressCode);
            if (!check) return false;
            var birDayCode = "19".concat(idCardNo.substring(6, 12));
            check = checkBirthDayCode(birDayCode);
            if (!check) return false;
            return true;
        };
        var check18IdCardNo = function check18IdCardNo(idCardNo) {
            var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
            if (!check) return false;
            var addressCode = idCardNo.substring(0, 2);
            check = checkAddressCode(addressCode);
            if (!check) return false;
            var birDayCode = idCardNo.substring(6, 14);
            check = checkBirthDayCode(birDayCode);
            if (!check) return false;
            return checkParityBit(idCardNo);
        };
        var checkIdCardNo = function checkIdCardNo(idCardNo) {
            var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
            if (!check) return false;
            if (idCardNo.length === 15) return check15IdCardNo(idCardNo);
            return check18IdCardNo(idCardNo);
        };
        return checkIdCardNo(str);
    },
    "zh-HK": function zhHK(str) {
        // sanitize user input
        str = str.trim(); // HKID number starts with 1 or 2 letters, followed by 6 digits,
        // then a checksum contained in square / round brackets or nothing
        var regexHKID = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/;
        var regexIsDigit = /^[0-9]$/; // convert the user input to all uppercase and apply regex
        str = str.toUpperCase();
        if (!regexHKID.test(str)) return false;
        str = str.replace(/\[|\]|\(|\)/g, "");
        if (str.length === 8) str = "3".concat(str);
        var checkSumVal = 0;
        for(var i = 0; i <= 7; i++){
            var convertedChar = void 0;
            if (!regexIsDigit.test(str[i])) convertedChar = (str[i].charCodeAt(0) - 55) % 11;
            else convertedChar = str[i];
            checkSumVal += convertedChar * (9 - i);
        }
        checkSumVal %= 11;
        var checkSumConverted;
        if (checkSumVal === 0) checkSumConverted = "0";
        else if (checkSumVal === 1) checkSumConverted = "A";
        else checkSumConverted = String(11 - checkSumVal);
        if (checkSumConverted === str[str.length - 1]) return true;
        return false;
    },
    "zh-TW": function zhTW(str) {
        var ALPHABET_CODES = {
            A: 10,
            B: 11,
            C: 12,
            D: 13,
            E: 14,
            F: 15,
            G: 16,
            H: 17,
            I: 34,
            J: 18,
            K: 19,
            L: 20,
            M: 21,
            N: 22,
            O: 35,
            P: 23,
            Q: 24,
            R: 25,
            S: 26,
            T: 27,
            U: 28,
            V: 29,
            W: 32,
            X: 30,
            Y: 31,
            Z: 33
        };
        var sanitized = str.trim().toUpperCase();
        if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
        return Array.from(sanitized).reduce(function(sum, number, index) {
            if (index === 0) {
                var code = ALPHABET_CODES[number];
                return code % 10 * 9 + Math.floor(code / 10);
            }
            if (index === 9) return (10 - sum % 10 - Number(number)) % 10 === 0;
            return sum + Number(number) * (9 - index);
        }, 0);
    }
};
function $6e247fd9769a493c$var$isIdentityCard(str, locale) {
    (0, $6e247fd9769a493c$var$_assertString.default)(str);
    if (locale in $6e247fd9769a493c$var$validators) return $6e247fd9769a493c$var$validators[locale](str);
    else if (locale === "any") {
        for(var key in $6e247fd9769a493c$var$validators)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($6e247fd9769a493c$var$validators.hasOwnProperty(key)) {
            var validator = $6e247fd9769a493c$var$validators[key];
            if (validator(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2BQhf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e67969febb80b94$var$isEAN;

var $1e67969febb80b94$var$_assertString = $1e67969febb80b94$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1e67969febb80b94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The most commonly used EAN standard is
 * the thirteen-digit EAN-13, while the
 * less commonly used 8-digit EAN-8 barcode was
 * introduced for use on small packages.
 * Also EAN/UCC-14 is used for Grouping of individual
 * trade items above unit level(Intermediate, Carton or Pallet).
 * For more info about EAN-14 checkout: https://www.gtin.info/itf-14-barcodes/
 * EAN consists of:
 * GS1 prefix, manufacturer code, product code and check digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number
 * Reference: https://www.gtin.info/
 */ /**
 * Define EAN Lenghts; 8 for EAN-8; 13 for EAN-13; 14 for EAN-14
 * and Regular Expression for valid EANs (EAN-8, EAN-13, EAN-14),
 * with exact numberic matching of 8 or 13 or 14 digits [0-9]
 */ var $1e67969febb80b94$var$LENGTH_EAN_8 = 8;
var $1e67969febb80b94$var$LENGTH_EAN_14 = 14;
var $1e67969febb80b94$var$validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
/**
 * Get position weight given:
 * EAN length and digit index/position
 *
 * @param {number} length
 * @param {number} index
 * @return {number}
 */ function $1e67969febb80b94$var$getPositionWeightThroughLengthAndIndex(length, index) {
    if (length === $1e67969febb80b94$var$LENGTH_EAN_8 || length === $1e67969febb80b94$var$LENGTH_EAN_14) return index % 2 === 0 ? 3 : 1;
    return index % 2 === 0 ? 1 : 3;
}
/**
 * Calculate EAN Check Digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number#Calculation_of_checksum_digit
 *
 * @param {string} ean
 * @return {number}
 */ function $1e67969febb80b94$var$calculateCheckDigit(ean) {
    var checksum = ean.slice(0, -1).split("").map(function(char, index) {
        return Number(char) * $1e67969febb80b94$var$getPositionWeightThroughLengthAndIndex(ean.length, index);
    }).reduce(function(acc, partialSum) {
        return acc + partialSum;
    }, 0);
    var remainder = 10 - checksum % 10;
    return remainder < 10 ? remainder : 0;
}
/**
 * Check if string is valid EAN:
 * Matches EAN-8/EAN-13/EAN-14 regex
 * Has valid check digit.
 *
 * @param {string} str
 * @return {boolean}
 */ function $1e67969febb80b94$var$isEAN(str) {
    (0, $1e67969febb80b94$var$_assertString.default)(str);
    var actualCheckDigit = Number(str.slice(-1));
    return $1e67969febb80b94$var$validEanRegex.test(str) && actualCheckDigit === $1e67969febb80b94$var$calculateCheckDigit(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2WYjl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $225fc80b5318d73b$var$isISIN;

var $225fc80b5318d73b$var$_assertString = $225fc80b5318d73b$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $225fc80b5318d73b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $225fc80b5318d73b$var$isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/; // this link details how the check digit is calculated:
// https://www.isin.org/isin-format/. it is a little bit
// odd in that it works with digits, not numbers. in order
// to make only one pass through the ISIN characters, the
// each alpha character is handled as 2 characters within
// the loop.
function $225fc80b5318d73b$var$isISIN(str) {
    (0, $225fc80b5318d73b$var$_assertString.default)(str);
    if (!$225fc80b5318d73b$var$isin.test(str)) return false;
    var double = true;
    var sum = 0; // convert values
    for(var i = str.length - 2; i >= 0; i--)if (str[i] >= "A" && str[i] <= "Z") {
        var value = str[i].charCodeAt(0) - 55;
        var lo = value % 10;
        var hi = Math.trunc(value / 10); // letters have two digits, so handle the low order
        // and high order digits separately.
        for(var _i = 0, _arr = [
            lo,
            hi
        ]; _i < _arr.length; _i++){
            var digit = _arr[_i];
            if (double) {
                if (digit >= 5) sum += 1 + (digit - 5) * 2;
                else sum += digit * 2;
            } else sum += digit;
            double = !double;
        }
    } else {
        var _digit = str[i].charCodeAt(0) - "0".charCodeAt(0);
        if (double) {
            if (_digit >= 5) sum += 1 + (_digit - 5) * 2;
            else sum += _digit * 2;
        } else sum += _digit;
        double = !double;
    }
    var check = Math.trunc((sum + 9) / 10) * 10 - sum;
    return +str[str.length - 1] === check;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("905An", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68d87259c5db1cd7$var$isISBN;

var $68d87259c5db1cd7$var$_assertString = $68d87259c5db1cd7$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $68d87259c5db1cd7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $68d87259c5db1cd7$var$possibleIsbn10 = /^(?:[0-9]{9}X|[0-9]{10})$/;
var $68d87259c5db1cd7$var$possibleIsbn13 = /^(?:[0-9]{13})$/;
var $68d87259c5db1cd7$var$factor = [
    1,
    3
];
function $68d87259c5db1cd7$var$isISBN(isbn, options) {
    (0, $68d87259c5db1cd7$var$_assertString.default)(isbn); // For backwards compatibility:
    // isISBN(str [, version]), i.e. `options` could be used as argument for the legacy `version`
    var version = String((options === null || options === void 0 ? void 0 : options.version) || options);
    if (!(options !== null && options !== void 0 && options.version || options)) return $68d87259c5db1cd7$var$isISBN(isbn, {
        version: 10
    }) || $68d87259c5db1cd7$var$isISBN(isbn, {
        version: 13
    });
    var sanitizedIsbn = isbn.replace(/[\s-]+/g, "");
    var checksum = 0;
    if (version === "10") {
        if (!$68d87259c5db1cd7$var$possibleIsbn10.test(sanitizedIsbn)) return false;
        for(var i = 0; i < version - 1; i++)checksum += (i + 1) * sanitizedIsbn.charAt(i);
        if (sanitizedIsbn.charAt(9) === "X") checksum += 100;
        else checksum += 10 * sanitizedIsbn.charAt(9);
        if (checksum % 11 === 0) return true;
    } else if (version === "13") {
        if (!$68d87259c5db1cd7$var$possibleIsbn13.test(sanitizedIsbn)) return false;
        for(var _i = 0; _i < 12; _i++)checksum += $68d87259c5db1cd7$var$factor[_i % 2] * sanitizedIsbn.charAt(_i);
        if (sanitizedIsbn.charAt(12) - (10 - checksum % 10) % 10 === 0) return true;
    }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2pkna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c0db826f6421d64$var$isISSN;

var $1c0db826f6421d64$var$_assertString = $1c0db826f6421d64$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1c0db826f6421d64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1c0db826f6421d64$var$issn = "^\\d{4}-?\\d{3}[\\dX]$";
function $1c0db826f6421d64$var$isISSN(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $1c0db826f6421d64$var$_assertString.default)(str);
    var testIssn = $1c0db826f6421d64$var$issn;
    testIssn = options.require_hyphen ? testIssn.replace("?", "") : testIssn;
    testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, "i");
    if (!testIssn.test(str)) return false;
    var digits = str.replace("-", "").toUpperCase();
    var checksum = 0;
    for(var i = 0; i < digits.length; i++){
        var digit = digits[i];
        checksum += (digit === "X" ? 10 : +digit) * (8 - i);
    }
    return checksum % 11 === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kk69h", function(module, exports) {
"use strict";
function $ecba71e962b68965$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ecba71e962b68965$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ecba71e962b68965$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ecba71e962b68965$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecba71e962b68965$var$isTaxID;

var $ecba71e962b68965$var$_assertString = $ecba71e962b68965$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $ecba71e962b68965$var$algorithms = $ecba71e962b68965$var$_interopRequireWildcard((parcelRequire("12Tm6")));

var $ecba71e962b68965$var$_isDate = $ecba71e962b68965$var$_interopRequireDefault((parcelRequire("ixWQq")));
function $ecba71e962b68965$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $ecba71e962b68965$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $ecba71e962b68965$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $ecba71e962b68965$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ecba71e962b68965$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ecba71e962b68965$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ecba71e962b68965$var$_toConsumableArray(arr) {
    return $ecba71e962b68965$var$_arrayWithoutHoles(arr) || $ecba71e962b68965$var$_iterableToArray(arr) || $ecba71e962b68965$var$_unsupportedIterableToArray(arr) || $ecba71e962b68965$var$_nonIterableSpread();
}
function $ecba71e962b68965$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ecba71e962b68965$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ecba71e962b68965$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ecba71e962b68965$var$_arrayLikeToArray(o, minLen);
}
function $ecba71e962b68965$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ecba71e962b68965$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ecba71e962b68965$var$_arrayLikeToArray(arr);
}
function $ecba71e962b68965$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * TIN Validation
 * Validates Tax Identification Numbers (TINs) from the US, EU member states and the United Kingdom.
 *
 * EU-UK:
 * National TIN validity is calculated using public algorithms as made available by DG TAXUD.
 *
 * See `https://ec.europa.eu/taxation_customs/tin/specs/FS-TIN%20Algorithms-Public.docx` for more information.
 *
 * US:
 * An Employer Identification Number (EIN), also known as a Federal Tax Identification Number,
 *  is used to identify a business entity.
 *
 * NOTES:
 *  - Prefix 47 is being reserved for future use
 *  - Prefixes 26, 27, 45, 46 and 47 were previously assigned by the Philadelphia campus.
 *
 * See `http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/How-EINs-are-Assigned-and-Valid-EIN-Prefixes`
 * for more information.
 */ // Locale functions
/*
 * bg-BG validation function
 * (Edinen graždanski nomer (EGN/ЕГН), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last) digit
 */ function $ecba71e962b68965$var$bgBgCheck(tin) {
    // Extract full year, normalize month and check birth date validity
    var century_year = tin.slice(0, 2);
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 40) {
        month -= 40;
        century_year = "20".concat(century_year);
    } else if (month > 20) {
        month -= 20;
        century_year = "18".concat(century_year);
    } else century_year = "19".concat(century_year);
    if (month < 10) month = "0".concat(month);
    var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // split digits into an array for further processing
    var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
    }); // Calculate checksum by multiplying digits with fixed values
    var multip_lookup = [
        2,
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var checksum = 0;
    for(var i = 0; i < multip_lookup.length; i++)checksum += digits[i] * multip_lookup[i];
    checksum = checksum % 11 === 10 ? 0 : checksum % 11;
    return checksum === digits[9];
}
/**
 * Check if an input is a valid Canadian SIN (Social Insurance Number)
 *
 * The Social Insurance Number (SIN) is a 9 digit number that
 * you need to work in Canada or to have access to government programs and benefits.
 *
 * https://en.wikipedia.org/wiki/Social_Insurance_Number
 * https://www.canada.ca/en/employment-social-development/services/sin.html
 * https://www.codercrunch.com/challenge/819302488/sin-validator
 *
 * @param {string} input
 * @return {boolean}
 */ function $ecba71e962b68965$var$isCanadianSIN(input) {
    var digitsArray = input.split("");
    var even = digitsArray.filter(function(_, idx) {
        return idx % 2;
    }).map(function(i) {
        return Number(i) * 2;
    }).join("").split("");
    var total = digitsArray.filter(function(_, idx) {
        return !(idx % 2);
    }).concat(even).map(function(i) {
        return Number(i);
    }).reduce(function(acc, cur) {
        return acc + cur;
    });
    return total % 10 === 0;
}
/*
 * cs-CZ validation function
 * (Rodné číslo (RČ), persons only)
 * Checks if birth date (first six digits) is valid and divisibility by 11
 * Material not in DG TAXUD document sourced from:
 * -`https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm`
 * -`https://www.mvcr.cz/clanek/rady-a-sluzby-dokumenty-rodne-cislo.aspx`
 */ function $ecba71e962b68965$var$csCzCheck(tin) {
    tin = tin.replace(/\W/, ""); // Extract full year from TIN length
    var full_year = parseInt(tin.slice(0, 2), 10);
    if (tin.length === 10) {
        if (full_year < 54) full_year = "20".concat(full_year);
        else full_year = "19".concat(full_year);
    } else {
        if (tin.slice(6) === "000") return false;
         // Three-zero serial not assigned before 1954
        if (full_year < 54) full_year = "19".concat(full_year);
        else return false; // No 18XX years seen in any of the resources
    } // Add missing zero if needed
    if (full_year.length === 3) full_year = [
        full_year.slice(0, 2),
        "0",
        full_year.slice(2)
    ].join("");
     // Extract month from TIN and normalize
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 50) month -= 50;
    if (month > 20) {
        // Month-plus-twenty was only introduced in 2004
        if (parseInt(full_year, 10) < 2004) return false;
        month -= 20;
    }
    if (month < 10) month = "0".concat(month);
     // Check date validity
    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // Verify divisibility by 11
    if (tin.length === 10) {
        if (parseInt(tin, 10) % 11 !== 0) {
            // Some numbers up to and including 1985 are still valid if
            // check (last) digit equals 0 and modulo of first 9 digits equals 10
            var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;
            if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
                if (parseInt(tin.slice(9), 10) !== 0) return false;
            } else return false;
        }
    }
    return true;
}
/*
 * de-AT validation function
 * (Abgabenkontonummer, persons/entities)
 * Verify TIN validity by calling luhnCheck()
 */ function $ecba71e962b68965$var$deAtCheck(tin) {
    return $ecba71e962b68965$var$algorithms.luhnCheck(tin);
}
/*
 * de-DE validation function
 * (Steueridentifikationsnummer (Steuer-IdNr.), persons only)
 * Tests for single duplicate/triplicate value, then calculates ISO 7064 check (last) digit
 * Partial implementation of spec (same result with both algorithms always)
 */ function $ecba71e962b68965$var$deDeCheck(tin) {
    // Split digits into an array for further processing
    var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
    }); // Fill array with strings of number positions
    var occurences = [];
    for(var i = 0; i < digits.length - 1; i++){
        occurences.push("");
        for(var j = 0; j < digits.length - 1; j++)if (digits[i] === digits[j]) occurences[i] += j;
    } // Remove digits with one occurence and test for only one duplicate/triplicate
    occurences = occurences.filter(function(a) {
        return a.length > 1;
    });
    if (occurences.length !== 2 && occurences.length !== 3) return false;
     // In case of triplicate value only two digits are allowed next to each other
    if (occurences[0].length === 3) {
        var trip_locations = occurences[0].split("").map(function(a) {
            return parseInt(a, 10);
        });
        var recurrent = 0; // Amount of neighbour occurences
        for(var _i = 0; _i < trip_locations.length - 1; _i++)if (trip_locations[_i] + 1 === trip_locations[_i + 1]) recurrent += 1;
        if (recurrent === 2) return false;
    }
    return $ecba71e962b68965$var$algorithms.iso7064Check(tin);
}
/*
 * dk-DK validation function
 * (CPR-nummer (personnummer), persons only)
 * Checks if birth date (first six digits) is valid and assigned to century (seventh) digit,
 * and calculates check (last) digit
 */ function $ecba71e962b68965$var$dkDkCheck(tin) {
    tin = tin.replace(/\W/, ""); // Extract year, check if valid for given century digit and add century
    var year = parseInt(tin.slice(4, 6), 10);
    var century_digit = tin.slice(6, 7);
    switch(century_digit){
        case "0":
        case "1":
        case "2":
        case "3":
            year = "19".concat(year);
            break;
        case "4":
        case "9":
            if (year < 37) year = "20".concat(year);
            else year = "19".concat(year);
            break;
        default:
            if (year < 37) year = "20".concat(year);
            else if (year > 58) year = "18".concat(year);
            else return false;
            break;
    } // Add missing zero if needed
    if (year.length === 3) year = [
        year.slice(0, 2),
        "0",
        year.slice(2)
    ].join("");
     // Check date validity
    var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // Split digits into an array for further processing
    var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    var weight = 4; // Multiply by weight and add to checksum
    for(var i = 0; i < 9; i++){
        checksum += digits[i] * weight;
        weight -= 1;
        if (weight === 1) weight = 7;
    }
    checksum %= 11;
    if (checksum === 1) return false;
    return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
}
/*
 * el-CY validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons only)
 * Verify TIN validity by calculating ASCII value of check (last) character
 */ function $ecba71e962b68965$var$elCyCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.slice(0, 8).split("").map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0; // add digits in even places
    for(var i = 1; i < digits.length; i += 2)checksum += digits[i];
     // add digits in odd places
    for(var _i2 = 0; _i2 < digits.length; _i2 += 2)if (digits[_i2] < 2) checksum += 1 - digits[_i2];
    else {
        checksum += 2 * (digits[_i2] - 2) + 5;
        if (digits[_i2] > 4) checksum += 2;
    }
    return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
}
/*
 * el-GR validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons/entities)
 * Verify TIN validity by calculating check (last) digit
 * Algorithm not in DG TAXUD document- sourced from:
 * - `http://epixeirisi.gr/%CE%9A%CE%A1%CE%99%CE%A3%CE%99%CE%9C%CE%91-%CE%98%CE%95%CE%9C%CE%91%CE%A4%CE%91-%CE%A6%CE%9F%CE%A1%CE%9F%CE%9B%CE%9F%CE%93%CE%99%CE%91%CE%A3-%CE%9A%CE%91%CE%99-%CE%9B%CE%9F%CE%93%CE%99%CE%A3%CE%A4%CE%99%CE%9A%CE%97%CE%A3/23791/%CE%91%CF%81%CE%B9%CE%B8%CE%BC%CF%8C%CF%82-%CE%A6%CE%BF%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%B9%CE%BA%CE%BF%CF%8D-%CE%9C%CE%B7%CF%84%CF%81%CF%8E%CE%BF%CF%85`
 */ function $ecba71e962b68965$var$elGrCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    for(var i = 0; i < 8; i++)checksum += digits[i] * Math.pow(2, 8 - i);
    return checksum % 11 % 10 === digits[8];
}
/*
 * en-GB validation function (should go here if needed)
 * (National Insurance Number (NINO) or Unique Taxpayer Reference (UTR),
 * persons/entities respectively)
 */ /*
 * en-IE validation function
 * (Personal Public Service Number (PPS No), persons only)
 * Verify TIN validity by calculating check (second to last) character
 */ function $ecba71e962b68965$var$enIeCheck(tin) {
    var checksum = $ecba71e962b68965$var$algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 7).map(function(a) {
        return parseInt(a, 10);
    }), 8);
    if (tin.length === 9 && tin[8] !== "W") checksum += (tin[8].charCodeAt(0) - 64) * 9;
    checksum %= 23;
    if (checksum === 0) return tin[7].toUpperCase() === "W";
    return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
} // Valid US IRS campus prefixes
var $ecba71e962b68965$var$enUsCampusPrefix = {
    andover: [
        "10",
        "12"
    ],
    atlanta: [
        "60",
        "67"
    ],
    austin: [
        "50",
        "53"
    ],
    brookhaven: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "11",
        "13",
        "14",
        "16",
        "21",
        "22",
        "23",
        "25",
        "34",
        "51",
        "52",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "65"
    ],
    cincinnati: [
        "30",
        "32",
        "35",
        "36",
        "37",
        "38",
        "61"
    ],
    fresno: [
        "15",
        "24"
    ],
    internet: [
        "20",
        "26",
        "27",
        "45",
        "46",
        "47"
    ],
    kansas: [
        "40",
        "44"
    ],
    memphis: [
        "94",
        "95"
    ],
    ogden: [
        "80",
        "90"
    ],
    philadelphia: [
        "33",
        "39",
        "41",
        "42",
        "43",
        "46",
        "48",
        "62",
        "63",
        "64",
        "66",
        "68",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "91",
        "92",
        "93",
        "98",
        "99"
    ],
    sba: [
        "31"
    ]
}; // Return an array of all US IRS campus prefixes
function $ecba71e962b68965$var$enUsGetPrefixes() {
    var prefixes = [];
    for(var location in $ecba71e962b68965$var$enUsCampusPrefix)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
    // istanbul ignore else
    if ($ecba71e962b68965$var$enUsCampusPrefix.hasOwnProperty(location)) prefixes.push.apply(prefixes, $ecba71e962b68965$var$_toConsumableArray($ecba71e962b68965$var$enUsCampusPrefix[location]));
    return prefixes;
}
/*
 * en-US validation function
 * Verify that the TIN starts with a valid IRS campus prefix
 */ function $ecba71e962b68965$var$enUsCheck(tin) {
    return $ecba71e962b68965$var$enUsGetPrefixes().indexOf(tin.slice(0, 2)) !== -1;
}
/*
 * es-ES validation function
 * (Documento Nacional de Identidad (DNI)
 * or Número de Identificación de Extranjero (NIE), persons only)
 * Verify TIN validity by calculating check (last) character
 */ function $ecba71e962b68965$var$esEsCheck(tin) {
    // Split characters into an array for further processing
    var chars = tin.toUpperCase().split(""); // Replace initial letter if needed
    if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
        var lead_replace = 0;
        switch(chars[0]){
            case "Y":
                lead_replace = 1;
                break;
            case "Z":
                lead_replace = 2;
                break;
            default:
        }
        chars.splice(0, 1, lead_replace); // Fill with zeros if smaller than proper
    } else while(chars.length < 9)chars.unshift(0);
     // Calculate checksum and check according to lookup
    var lookup = [
        "T",
        "R",
        "W",
        "A",
        "G",
        "M",
        "Y",
        "F",
        "P",
        "D",
        "X",
        "B",
        "N",
        "J",
        "Z",
        "S",
        "Q",
        "V",
        "H",
        "L",
        "C",
        "K",
        "E"
    ];
    chars = chars.join("");
    var checksum = parseInt(chars.slice(0, 8), 10) % 23;
    return chars[8] === lookup[checksum];
}
/*
 * et-EE validation function
 * (Isikukood (IK), persons only)
 * Checks if birth date (century digit and six following) is valid and calculates check (last) digit
 * Material not in DG TAXUD document sourced from:
 * - `https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf`
 */ function $ecba71e962b68965$var$etEeCheck(tin) {
    // Extract year and add century
    var full_year = tin.slice(1, 3);
    var century_digit = tin.slice(0, 1);
    switch(century_digit){
        case "1":
        case "2":
            full_year = "18".concat(full_year);
            break;
        case "3":
        case "4":
            full_year = "19".concat(full_year);
            break;
        default:
            full_year = "20".concat(full_year);
            break;
    } // Check date validity
    var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // Split digits into an array for further processing
    var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    var weight = 1; // Multiply by weight and add to checksum
    for(var i = 0; i < 10; i++){
        checksum += digits[i] * weight;
        weight += 1;
        if (weight === 10) weight = 1;
    } // Do again if modulo 11 of checksum is 10
    if (checksum % 11 === 10) {
        checksum = 0;
        weight = 3;
        for(var _i3 = 0; _i3 < 10; _i3++){
            checksum += digits[_i3] * weight;
            weight += 1;
            if (weight === 10) weight = 1;
        }
        if (checksum % 11 === 10) return digits[10] === 0;
    }
    return checksum % 11 === digits[10];
}
/*
 * fi-FI validation function
 * (Henkilötunnus (HETU), persons only)
 * Checks if birth date (first six digits plus century symbol) is valid
 * and calculates check (last) digit
 */ function $ecba71e962b68965$var$fiFiCheck(tin) {
    // Extract year and add century
    var full_year = tin.slice(4, 6);
    var century_symbol = tin.slice(6, 7);
    switch(century_symbol){
        case "+":
            full_year = "18".concat(full_year);
            break;
        case "-":
            full_year = "19".concat(full_year);
            break;
        default:
            full_year = "20".concat(full_year);
            break;
    } // Check date validity
    var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // Calculate check character
    var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;
    if (checksum < 10) return checksum === parseInt(tin.slice(10), 10);
    checksum -= 10;
    var letters_lookup = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y"
    ];
    return letters_lookup[checksum] === tin.slice(10);
}
/*
 * fr/nl-BE validation function
 * (Numéro national (N.N.), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last two) digits
 */ function $ecba71e962b68965$var$frBeCheck(tin) {
    // Zero month/day value is acceptable
    if (tin.slice(2, 4) !== "00" || tin.slice(4, 6) !== "00") {
        // Extract date from first six digits of TIN
        var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));
        if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YY/MM/DD")) return false;
    }
    var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
    var checkdigits = parseInt(tin.slice(9, 11), 10);
    if (checksum !== checkdigits) {
        checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;
        if (checksum !== checkdigits) return false;
    }
    return true;
}
/*
 * fr-FR validation function
 * (Numéro fiscal de référence (numéro SPI), persons only)
 * Verify TIN validity by calculating check (last three) digits
 */ function $ecba71e962b68965$var$frFrCheck(tin) {
    tin = tin.replace(/\s/g, "");
    var checksum = parseInt(tin.slice(0, 10), 10) % 511;
    var checkdigits = parseInt(tin.slice(10, 13), 10);
    return checksum === checkdigits;
}
/*
 * fr/lb-LU validation function
 * (numéro d’identification personnelle, persons only)
 * Verify birth date validity and run Luhn and Verhoeff checks
 */ function $ecba71e962b68965$var$frLuCheck(tin) {
    // Extract date and check validity
    var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // Run Luhn check
    if (!$ecba71e962b68965$var$algorithms.luhnCheck(tin.slice(0, 12))) return false;
     // Remove Luhn check digit and run Verhoeff check
    return $ecba71e962b68965$var$algorithms.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
}
/*
 * hr-HR validation function
 * (Osobni identifikacijski broj (OIB), persons/entities)
 * Verify TIN validity by calling iso7064Check(digits)
 */ function $ecba71e962b68965$var$hrHrCheck(tin) {
    return $ecba71e962b68965$var$algorithms.iso7064Check(tin);
}
/*
 * hu-HU validation function
 * (Adóazonosító jel, persons only)
 * Verify TIN validity by calculating check (last) digit
 */ function $ecba71e962b68965$var$huHuCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 8;
    for(var i = 1; i < 9; i++)checksum += digits[i] * (i + 1);
    return checksum % 11 === digits[9];
}
/*
 * lt-LT validation function (should go here if needed)
 * (Asmens kodas, persons/entities respectively)
 * Current validation check is alias of etEeCheck- same format applies
 */ /*
 * it-IT first/last name validity check
 * Accepts it-IT TIN-encoded names as a three-element character array and checks their validity
 * Due to lack of clarity between resources ("Are only Italian consonants used?
 * What happens if a person has X in their name?" etc.) only two test conditions
 * have been implemented:
 * Vowels may only be followed by other vowels or an X character
 * and X characters after vowels may only be followed by other X characters.
 */ function $ecba71e962b68965$var$itItNameCheck(name) {
    // true at the first occurence of a vowel
    var vowelflag = false; // true at the first occurence of an X AFTER vowel
    // (to properly handle last names with X as consonant)
    var xflag = false;
    for(var i = 0; i < 3; i++){
        if (!vowelflag && /[AEIOU]/.test(name[i])) vowelflag = true;
        else if (!xflag && vowelflag && name[i] === "X") xflag = true;
        else if (i > 0) {
            if (vowelflag && !xflag) {
                if (!/[AEIOU]/.test(name[i])) return false;
            }
            if (xflag) {
                if (!/X/.test(name[i])) return false;
            }
        }
    }
    return true;
}
/*
 * it-IT validation function
 * (Codice fiscale (TIN-IT), persons only)
 * Verify name, birth date and codice catastale validity
 * and calculate check character.
 * Material not in DG-TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/Italian_fiscal_code`
 */ function $ecba71e962b68965$var$itItCheck(tin) {
    // Capitalize and split characters into an array for further processing
    var chars = tin.toUpperCase().split(""); // Check first and last name validity calling itItNameCheck()
    if (!$ecba71e962b68965$var$itItNameCheck(chars.slice(0, 3))) return false;
    if (!$ecba71e962b68965$var$itItNameCheck(chars.slice(3, 6))) return false;
     // Convert letters in number spaces back to numbers if any
    var number_locations = [
        6,
        7,
        9,
        10,
        12,
        13,
        14
    ];
    var number_replace = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
    };
    for(var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++){
        var i = _number_locations[_i4];
        if (chars[i] in number_replace) chars.splice(i, 1, number_replace[chars[i]]);
    } // Extract month and day, and check date validity
    var month_replace = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
    };
    var month = month_replace[chars[8]];
    var day = parseInt(chars[9] + chars[10], 10);
    if (day > 40) day -= 40;
    if (day < 10) day = "0".concat(day);
    var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YY/MM/DD")) return false;
     // Calculate check character by adding up even and odd characters as numbers
    var checksum = 0;
    for(var _i5 = 1; _i5 < chars.length - 1; _i5 += 2){
        var char_to_int = parseInt(chars[_i5], 10);
        if (isNaN(char_to_int)) char_to_int = chars[_i5].charCodeAt(0) - 65;
        checksum += char_to_int;
    }
    var odd_convert = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
    };
    for(var _i6 = 0; _i6 < chars.length - 1; _i6 += 2){
        var _char_to_int = 0;
        if (chars[_i6] in odd_convert) _char_to_int = odd_convert[chars[_i6]];
        else {
            var multiplier = parseInt(chars[_i6], 10);
            _char_to_int = 2 * multiplier + 1;
            if (multiplier > 4) _char_to_int += 2;
        }
        checksum += _char_to_int;
    }
    if (String.fromCharCode(65 + checksum % 26) !== chars[15]) return false;
    return true;
}
/*
 * lv-LV validation function
 * (Personas kods (PK), persons only)
 * Check validity of birth date and calculate check (last) digit
 * Support only for old format numbers (not starting with '32', issued before 2017/07/01)
 * Material not in DG TAXUD document sourced from:
 * `https://boot.ritakafija.lv/forums/index.php?/topic/88314-personas-koda-algoritms-%C4%8Deksumma/`
 */ function $ecba71e962b68965$var$lvLvCheck(tin) {
    tin = tin.replace(/\W/, ""); // Extract date from TIN
    var day = tin.slice(0, 2);
    if (day !== "32") {
        // No date/checksum check if new format
        var month = tin.slice(2, 4);
        if (month !== "00") {
            // No date check if unknown month
            var full_year = tin.slice(4, 6);
            switch(tin[6]){
                case "0":
                    full_year = "18".concat(full_year);
                    break;
                case "1":
                    full_year = "19".concat(full_year);
                    break;
                default:
                    full_year = "20".concat(full_year);
                    break;
            } // Check date validity
            var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);
            if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
        } // Calculate check digit
        var checksum = 1101;
        var multip_lookup = [
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
        ];
        for(var i = 0; i < tin.length - 1; i++)checksum -= parseInt(tin[i], 10) * multip_lookup[i];
        return parseInt(tin[10], 10) === checksum % 11;
    }
    return true;
}
/*
 * mt-MT validation function
 * (Identity Card Number or Unique Taxpayer Reference, persons/entities)
 * Verify Identity Card Number structure (no other tests found)
 */ function $ecba71e962b68965$var$mtMtCheck(tin) {
    if (tin.length !== 9) {
        // No tests for UTR
        var chars = tin.toUpperCase().split(""); // Fill with zeros if smaller than proper
        while(chars.length < 8)chars.unshift(0);
         // Validate format according to last character
        switch(tin[7]){
            case "A":
            case "P":
                if (parseInt(chars[6], 10) === 0) return false;
                break;
            default:
                var first_part = parseInt(chars.join("").slice(0, 5), 10);
                if (first_part > 32000) return false;
                var second_part = parseInt(chars.join("").slice(5, 7), 10);
                if (first_part === second_part) return false;
        }
    }
    return true;
}
/*
 * nl-NL validation function
 * (Burgerservicenummer (BSN) or Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN),
 * persons/entities respectively)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $ecba71e962b68965$var$nlNlCheck(tin) {
    return $ecba71e962b68965$var$algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11 === parseInt(tin[8], 10);
}
/*
 * pl-PL validation function
 * (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)
 * or Numer identyfikacji podatkowej (NIP), persons/entities)
 * Verify TIN validity by validating birth date (PESEL) and calculating check (last) digit
 */ function $ecba71e962b68965$var$plPlCheck(tin) {
    // NIP
    if (tin.length === 10) {
        // Calculate last digit by multiplying with lookup
        var lookup = [
            6,
            5,
            7,
            2,
            3,
            4,
            5,
            6,
            7
        ];
        var _checksum = 0;
        for(var i = 0; i < lookup.length; i++)_checksum += parseInt(tin[i], 10) * lookup[i];
        _checksum %= 11;
        if (_checksum === 10) return false;
        return _checksum === parseInt(tin[9], 10);
    } // PESEL
    // Extract full year using month
    var full_year = tin.slice(0, 2);
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 80) {
        full_year = "18".concat(full_year);
        month -= 80;
    } else if (month > 60) {
        full_year = "22".concat(full_year);
        month -= 60;
    } else if (month > 40) {
        full_year = "21".concat(full_year);
        month -= 40;
    } else if (month > 20) {
        full_year = "20".concat(full_year);
        month -= 20;
    } else full_year = "19".concat(full_year);
     // Add leading zero to month if needed
    if (month < 10) month = "0".concat(month);
     // Check date validity
    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
     // Calculate last digit by mulitplying with odd one-digit numbers except 5
    var checksum = 0;
    var multiplier = 1;
    for(var _i7 = 0; _i7 < tin.length - 1; _i7++){
        checksum += parseInt(tin[_i7], 10) * multiplier % 10;
        multiplier += 2;
        if (multiplier > 10) multiplier = 1;
        else if (multiplier === 5) multiplier += 2;
    }
    checksum = 10 - checksum % 10;
    return checksum === parseInt(tin[10], 10);
}
/*
* pt-BR validation function
* (Cadastro de Pessoas Físicas (CPF, persons)
* Cadastro Nacional de Pessoas Jurídicas (CNPJ, entities)
* Both inputs will be validated
*/ function $ecba71e962b68965$var$ptBrCheck(tin) {
    if (tin.length === 11) {
        var _sum;
        var remainder;
        _sum = 0;
        if (tin === "11111111111" || tin === "22222222222" || tin === "33333333333" || tin === "44444444444" || tin === "55555555555" || tin === "66666666666" || tin === "77777777777" || tin === "88888888888" || tin === "99999999999" || tin === "00000000000") return false;
        for(var i = 1; i <= 9; i++)_sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
        _sum = 0;
        for(var _i8 = 1; _i8 <= 10; _i8++)_sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
        return true;
    }
    if (tin === "00000000000000" || tin === "11111111111111" || tin === "22222222222222" || tin === "33333333333333" || tin === "44444444444444" || tin === "55555555555555" || tin === "66666666666666" || tin === "77777777777777" || tin === "88888888888888" || tin === "99999999999999") return false;
    var length = tin.length - 2;
    var identifiers = tin.substring(0, length);
    var verificators = tin.substring(length);
    var sum = 0;
    var pos = length - 7;
    for(var _i9 = length; _i9 >= 1; _i9--){
        sum += identifiers.charAt(length - _i9) * pos;
        pos -= 1;
        if (pos < 2) pos = 9;
    }
    var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(verificators.charAt(0), 10)) return false;
    length += 1;
    identifiers = tin.substring(0, length);
    sum = 0;
    pos = length - 7;
    for(var _i10 = length; _i10 >= 1; _i10--){
        sum += identifiers.charAt(length - _i10) * pos;
        pos -= 1;
        if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(verificators.charAt(1), 10)) return false;
    return true;
}
/*
 * pt-PT validation function
 * (Número de identificação fiscal (NIF), persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $ecba71e962b68965$var$ptPtCheck(tin) {
    var checksum = 11 - $ecba71e962b68965$var$algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11;
    if (checksum > 9) return parseInt(tin[8], 10) === 0;
    return checksum === parseInt(tin[8], 10);
}
/*
 * ro-RO validation function
 * (Cod Numeric Personal (CNP) or Cod de înregistrare fiscală (CIF),
 * persons only)
 * Verify CNP validity by calculating check (last) digit (test not found for CIF)
 * Material not in DG TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/National_identification_number#Romania`
 */ function $ecba71e962b68965$var$roRoCheck(tin) {
    if (tin.slice(0, 4) !== "9000") {
        // No test found for this format
        // Extract full year using century digit if possible
        var full_year = tin.slice(1, 3);
        switch(tin[0]){
            case "1":
            case "2":
                full_year = "19".concat(full_year);
                break;
            case "3":
            case "4":
                full_year = "18".concat(full_year);
                break;
            case "5":
            case "6":
                full_year = "20".concat(full_year);
                break;
            default:
        } // Check date validity
        var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
        if (date.length === 8) {
            if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YY/MM/DD")) return false;
        } else if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
         // Calculate check digit
        var digits = tin.split("").map(function(a) {
            return parseInt(a, 10);
        });
        var multipliers = [
            2,
            7,
            9,
            1,
            4,
            6,
            3,
            5,
            8,
            2,
            7,
            9
        ];
        var checksum = 0;
        for(var i = 0; i < multipliers.length; i++)checksum += digits[i] * multipliers[i];
        if (checksum % 11 === 10) return digits[12] === 1;
        return digits[12] === checksum % 11;
    }
    return true;
}
/*
 * sk-SK validation function
 * (Rodné číslo (RČ) or bezvýznamové identifikačné číslo (BIČ), persons only)
 * Checks validity of pre-1954 birth numbers (rodné číslo) only
 * Due to the introduction of the pseudo-random BIČ it is not possible to test
 * post-1954 birth numbers without knowing whether they are BIČ or RČ beforehand
 */ function $ecba71e962b68965$var$skSkCheck(tin) {
    if (tin.length === 9) {
        tin = tin.replace(/\W/, "");
        if (tin.slice(6) === "000") return false;
         // Three-zero serial not assigned before 1954
        // Extract full year from TIN length
        var full_year = parseInt(tin.slice(0, 2), 10);
        if (full_year > 53) return false;
        if (full_year < 10) full_year = "190".concat(full_year);
        else full_year = "19".concat(full_year);
         // Extract month from TIN and normalize
        var month = parseInt(tin.slice(2, 4), 10);
        if (month > 50) month -= 50;
        if (month < 10) month = "0".concat(month);
         // Check date validity
        var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
        if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
    }
    return true;
}
/*
 * sl-SI validation function
 * (Davčna številka, persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $ecba71e962b68965$var$slSiCheck(tin) {
    var checksum = 11 - $ecba71e962b68965$var$algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 7).map(function(a) {
        return parseInt(a, 10);
    }), 8) % 11;
    if (checksum === 10) return parseInt(tin[7], 10) === 0;
    return checksum === parseInt(tin[7], 10);
}
/*
 * sv-SE validation function
 * (Personnummer or samordningsnummer, persons only)
 * Checks validity of birth date and calls luhnCheck() to validate check (last) digit
 */ function $ecba71e962b68965$var$svSeCheck(tin) {
    // Make copy of TIN and normalize to two-digit year form
    var tin_copy = tin.slice(0);
    if (tin.length > 11) tin_copy = tin_copy.slice(2);
     // Extract date of birth
    var full_year = "";
    var month = tin_copy.slice(2, 4);
    var day = parseInt(tin_copy.slice(4, 6), 10);
    if (tin.length > 11) full_year = tin.slice(0, 4);
    else {
        full_year = tin.slice(0, 2);
        if (tin.length === 11 && day < 60) {
            // Extract full year from centenarian symbol
            // Should work just fine until year 10000 or so
            var current_year = new Date().getFullYear().toString();
            var current_century = parseInt(current_year.slice(0, 2), 10);
            current_year = parseInt(current_year, 10);
            if (tin[6] === "-") {
                if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) full_year = "".concat(current_century - 1).concat(full_year);
                else full_year = "".concat(current_century).concat(full_year);
            } else {
                full_year = "".concat(current_century - 1).concat(full_year);
                if (current_year - parseInt(full_year, 10) < 100) return false;
            }
        }
    } // Normalize day and check date validity
    if (day > 60) day -= 60;
    if (day < 10) day = "0".concat(day);
    var date = "".concat(full_year, "/").concat(month, "/").concat(day);
    if (date.length === 8) {
        if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YY/MM/DD")) return false;
    } else if (!(0, $ecba71e962b68965$var$_isDate.default)(date, "YYYY/MM/DD")) return false;
    return $ecba71e962b68965$var$algorithms.luhnCheck(tin.replace(/\W/, ""));
} // Locale lookup objects
/*
 * Tax id regex formats for various locales
 *
 * Where not explicitly specified in DG-TAXUD document both
 * uppercase and lowercase letters are acceptable.
 */ var $ecba71e962b68965$var$taxIdFormat = {
    "bg-BG": /^\d{10}$/,
    "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
    "de-AT": /^\d{9}$/,
    "de-DE": /^[1-9]\d{10}$/,
    "dk-DK": /^\d{6}-{0,1}\d{4}$/,
    "el-CY": /^[09]\d{7}[A-Z]$/,
    "el-GR": /^([0-4]|[7-9])\d{8}$/,
    "en-CA": /^\d{9}$/,
    "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
    "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
    "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    "fr-BE": /^\d{11}$/,
    "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    "fr-LU": /^\d{13}$/,
    "hr-HR": /^\d{11}$/,
    "hu-HU": /^8\d{9}$/,
    "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    "lv-LV": /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    "nl-NL": /^\d{9}$/,
    "pl-PL": /^\d{10,11}$/,
    "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
    "pt-PT": /^\d{9}$/,
    "ro-RO": /^\d{13}$/,
    "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
    "sl-SI": /^[1-9]\d{7}$/,
    "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
}; // taxIdFormat locale aliases
$ecba71e962b68965$var$taxIdFormat["lb-LU"] = $ecba71e962b68965$var$taxIdFormat["fr-LU"];
$ecba71e962b68965$var$taxIdFormat["lt-LT"] = $ecba71e962b68965$var$taxIdFormat["et-EE"];
$ecba71e962b68965$var$taxIdFormat["nl-BE"] = $ecba71e962b68965$var$taxIdFormat["fr-BE"];
$ecba71e962b68965$var$taxIdFormat["fr-CA"] = $ecba71e962b68965$var$taxIdFormat["en-CA"]; // Algorithmic tax id check functions for various locales
var $ecba71e962b68965$var$taxIdCheck = {
    "bg-BG": $ecba71e962b68965$var$bgBgCheck,
    "cs-CZ": $ecba71e962b68965$var$csCzCheck,
    "de-AT": $ecba71e962b68965$var$deAtCheck,
    "de-DE": $ecba71e962b68965$var$deDeCheck,
    "dk-DK": $ecba71e962b68965$var$dkDkCheck,
    "el-CY": $ecba71e962b68965$var$elCyCheck,
    "el-GR": $ecba71e962b68965$var$elGrCheck,
    "en-CA": $ecba71e962b68965$var$isCanadianSIN,
    "en-IE": $ecba71e962b68965$var$enIeCheck,
    "en-US": $ecba71e962b68965$var$enUsCheck,
    "es-ES": $ecba71e962b68965$var$esEsCheck,
    "et-EE": $ecba71e962b68965$var$etEeCheck,
    "fi-FI": $ecba71e962b68965$var$fiFiCheck,
    "fr-BE": $ecba71e962b68965$var$frBeCheck,
    "fr-FR": $ecba71e962b68965$var$frFrCheck,
    "fr-LU": $ecba71e962b68965$var$frLuCheck,
    "hr-HR": $ecba71e962b68965$var$hrHrCheck,
    "hu-HU": $ecba71e962b68965$var$huHuCheck,
    "it-IT": $ecba71e962b68965$var$itItCheck,
    "lv-LV": $ecba71e962b68965$var$lvLvCheck,
    "mt-MT": $ecba71e962b68965$var$mtMtCheck,
    "nl-NL": $ecba71e962b68965$var$nlNlCheck,
    "pl-PL": $ecba71e962b68965$var$plPlCheck,
    "pt-BR": $ecba71e962b68965$var$ptBrCheck,
    "pt-PT": $ecba71e962b68965$var$ptPtCheck,
    "ro-RO": $ecba71e962b68965$var$roRoCheck,
    "sk-SK": $ecba71e962b68965$var$skSkCheck,
    "sl-SI": $ecba71e962b68965$var$slSiCheck,
    "sv-SE": $ecba71e962b68965$var$svSeCheck
}; // taxIdCheck locale aliases
$ecba71e962b68965$var$taxIdCheck["lb-LU"] = $ecba71e962b68965$var$taxIdCheck["fr-LU"];
$ecba71e962b68965$var$taxIdCheck["lt-LT"] = $ecba71e962b68965$var$taxIdCheck["et-EE"];
$ecba71e962b68965$var$taxIdCheck["nl-BE"] = $ecba71e962b68965$var$taxIdCheck["fr-BE"];
$ecba71e962b68965$var$taxIdCheck["fr-CA"] = $ecba71e962b68965$var$taxIdCheck["en-CA"]; // Regexes for locales where characters should be omitted before checking format
var $ecba71e962b68965$var$allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
var $ecba71e962b68965$var$sanitizeRegexes = {
    "de-AT": $ecba71e962b68965$var$allsymbols,
    "de-DE": /[\/\\]/g,
    "fr-BE": $ecba71e962b68965$var$allsymbols
}; // sanitizeRegexes locale aliases
$ecba71e962b68965$var$sanitizeRegexes["nl-BE"] = $ecba71e962b68965$var$sanitizeRegexes["fr-BE"];
/*
 * Validator function
 * Return true if the passed string is a valid tax identification number
 * for the specified locale.
 * Throw an error exception if the locale is not supported.
 */ function $ecba71e962b68965$var$isTaxID(str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    (0, $ecba71e962b68965$var$_assertString.default)(str); // Copy TIN to avoid replacement if sanitized
    var strcopy = str.slice(0);
    if (locale in $ecba71e962b68965$var$taxIdFormat) {
        if (locale in $ecba71e962b68965$var$sanitizeRegexes) strcopy = strcopy.replace($ecba71e962b68965$var$sanitizeRegexes[locale], "");
        if (!$ecba71e962b68965$var$taxIdFormat[locale].test(strcopy)) return false;
        if (locale in $ecba71e962b68965$var$taxIdCheck) return $ecba71e962b68965$var$taxIdCheck[locale](strcopy);
         // Fallthrough; not all locales have algorithmic checks
        return true;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("12Tm6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iso7064Check = $0c30ead24b04fcbc$var$iso7064Check;
module.exports.luhnCheck = $0c30ead24b04fcbc$var$luhnCheck;
module.exports.reverseMultiplyAndSum = $0c30ead24b04fcbc$var$reverseMultiplyAndSum;
module.exports.verhoeffCheck = $0c30ead24b04fcbc$var$verhoeffCheck;
/**
 * Algorithmic validation functions
 * May be used as is or implemented in the workflow of other validators.
 */ /*
 * ISO 7064 validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to ISO 7064 (MOD 11, 10).
 */ function $0c30ead24b04fcbc$var$iso7064Check(str) {
    var checkvalue = 10;
    for(var i = 0; i < str.length - 1; i++)checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 9 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
    checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
    return checkvalue === parseInt(str[10], 10);
}
/*
 * Luhn (mod 10) validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to the Luhn algorithm.
 */ function $0c30ead24b04fcbc$var$luhnCheck(str) {
    var checksum = 0;
    var second = false;
    for(var i = str.length - 1; i >= 0; i--){
        if (second) {
            var product = parseInt(str[i], 10) * 2;
            if (product > 9) // sum digits of product and add to checksum
            checksum += product.toString().split("").map(function(a) {
                return parseInt(a, 10);
            }).reduce(function(a, b) {
                return a + b;
            }, 0);
            else checksum += product;
        } else checksum += parseInt(str[i], 10);
        second = !second;
    }
    return checksum % 10 === 0;
}
/*
 * Reverse TIN multiplication and summation helper function
 * Called with an array of single-digit integers and a base multiplier
 * to calculate the sum of the digits multiplied in reverse.
 * Normally used in variations of MOD 11 algorithmic checks.
 */ function $0c30ead24b04fcbc$var$reverseMultiplyAndSum(digits, base) {
    var total = 0;
    for(var i = 0; i < digits.length; i++)total += digits[i] * (base - i);
    return total;
}
/*
 * Verhoeff validation helper function
 * Called with a string of numbers
 * to validate according to the Verhoeff algorithm.
 */ function $0c30ead24b04fcbc$var$verhoeffCheck(str) {
    var d_table = [
        [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        [
            1,
            2,
            3,
            4,
            0,
            6,
            7,
            8,
            9,
            5
        ],
        [
            2,
            3,
            4,
            0,
            1,
            7,
            8,
            9,
            5,
            6
        ],
        [
            3,
            4,
            0,
            1,
            2,
            8,
            9,
            5,
            6,
            7
        ],
        [
            4,
            0,
            1,
            2,
            3,
            9,
            5,
            6,
            7,
            8
        ],
        [
            5,
            9,
            8,
            7,
            6,
            0,
            4,
            3,
            2,
            1
        ],
        [
            6,
            5,
            9,
            8,
            7,
            1,
            0,
            4,
            3,
            2
        ],
        [
            7,
            6,
            5,
            9,
            8,
            2,
            1,
            0,
            4,
            3
        ],
        [
            8,
            7,
            6,
            5,
            9,
            3,
            2,
            1,
            0,
            4
        ],
        [
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1,
            0
        ]
    ];
    var p_table = [
        [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        [
            1,
            5,
            7,
            6,
            2,
            8,
            3,
            0,
            9,
            4
        ],
        [
            5,
            8,
            0,
            3,
            7,
            9,
            6,
            1,
            4,
            2
        ],
        [
            8,
            9,
            1,
            6,
            0,
            4,
            3,
            5,
            2,
            7
        ],
        [
            9,
            4,
            5,
            3,
            1,
            2,
            6,
            8,
            7,
            0
        ],
        [
            4,
            2,
            8,
            6,
            5,
            7,
            3,
            9,
            0,
            1
        ],
        [
            2,
            7,
            9,
            3,
            8,
            0,
            6,
            4,
            1,
            5
        ],
        [
            7,
            0,
            4,
            6,
            9,
            1,
            3,
            2,
            5,
            8
        ]
    ]; // Copy (to prevent replacement) and reverse
    var str_copy = str.split("").reverse().join("");
    var checksum = 0;
    for(var i = 0; i < str_copy.length; i++)checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
    return checksum === 0;
}

});


parcelRegister("2Crc0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e84394c4d32239f$var$isMobilePhone;
module.exports.locales = void 0;

var $1e84394c4d32239f$var$_assertString = $1e84394c4d32239f$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1e84394c4d32239f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ var $1e84394c4d32239f$var$phones = {
    "am-AM": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7\d{9}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?09[567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+244)\d{9}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[789]\d{6}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38|8)?0\d{9}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
/* eslint-enable max-len */ // aliases
$1e84394c4d32239f$var$phones["en-CA"] = $1e84394c4d32239f$var$phones["en-US"];
$1e84394c4d32239f$var$phones["fr-CA"] = $1e84394c4d32239f$var$phones["en-CA"];
$1e84394c4d32239f$var$phones["fr-BE"] = $1e84394c4d32239f$var$phones["nl-BE"];
$1e84394c4d32239f$var$phones["zh-HK"] = $1e84394c4d32239f$var$phones["en-HK"];
$1e84394c4d32239f$var$phones["zh-MO"] = $1e84394c4d32239f$var$phones["en-MO"];
$1e84394c4d32239f$var$phones["ga-IE"] = $1e84394c4d32239f$var$phones["en-IE"];
$1e84394c4d32239f$var$phones["fr-CH"] = $1e84394c4d32239f$var$phones["de-CH"];
$1e84394c4d32239f$var$phones["it-CH"] = $1e84394c4d32239f$var$phones["fr-CH"];
function $1e84394c4d32239f$var$isMobilePhone(str, locale, options) {
    (0, $1e84394c4d32239f$var$_assertString.default)(str);
    if (options && options.strictMode && !str.startsWith("+")) return false;
    if (Array.isArray(locale)) return locale.some(function(key) {
        // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($1e84394c4d32239f$var$phones.hasOwnProperty(key)) {
            var phone = $1e84394c4d32239f$var$phones[key];
            if (phone.test(str)) return true;
        }
        return false;
    });
    else if (locale in $1e84394c4d32239f$var$phones) return $1e84394c4d32239f$var$phones[locale].test(str); // alias falsey locale as 'any'
    else if (!locale || locale === "any") {
        for(var key in $1e84394c4d32239f$var$phones)// istanbul ignore else
        if ($1e84394c4d32239f$var$phones.hasOwnProperty(key)) {
            var phone = $1e84394c4d32239f$var$phones[key];
            if (phone.test(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $1e84394c4d32239f$var$locales = Object.keys($1e84394c4d32239f$var$phones);
module.exports.locales = $1e84394c4d32239f$var$locales;

});

parcelRegister("cXfyP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $96e710c6d3b193ac$var$isEthereumAddress;

var $96e710c6d3b193ac$var$_assertString = $96e710c6d3b193ac$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $96e710c6d3b193ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $96e710c6d3b193ac$var$eth = /^(0x)[0-9a-f]{40}$/i;
function $96e710c6d3b193ac$var$isEthereumAddress(str) {
    (0, $96e710c6d3b193ac$var$_assertString.default)(str);
    return $96e710c6d3b193ac$var$eth.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("76NuI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52cf7c7e9f64c2d7$var$isCurrency;

var $52cf7c7e9f64c2d7$var$_merge = $52cf7c7e9f64c2d7$var$_interopRequireDefault((parcelRequire("aXHNC")));

var $52cf7c7e9f64c2d7$var$_assertString = $52cf7c7e9f64c2d7$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $52cf7c7e9f64c2d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52cf7c7e9f64c2d7$var$currencyRegex(options) {
    var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
    options.digits_after_decimal.forEach(function(digit, index) {
        if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
    });
    var symbol = "(".concat(options.symbol.replace(/\W/, function(m) {
        return "\\".concat(m);
    }), ")").concat(options.require_symbol ? "" : "?"), negative = "-?", whole_dollar_amount_without_sep = "[1-9]\\d*", whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"), valid_whole_dollar_amounts = [
        "0",
        whole_dollar_amount_without_sep,
        whole_dollar_amount_with_sep
    ], whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join("|"), ")?"), decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? "" : "?");
    var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ""); // default is negative sign before symbol, but there are two other options (besides parens)
    if (options.allow_negatives && !options.parens_for_negatives) {
        if (options.negative_sign_after_digits) pattern += negative;
        else if (options.negative_sign_before_digits) pattern = negative + pattern;
    } // South African Rand, for example, uses R 123 (space) and R-123 (no space)
    if (options.allow_negative_sign_placeholder) pattern = "( (?!\\-))?".concat(pattern);
    else if (options.allow_space_after_symbol) pattern = " ?".concat(pattern);
    else if (options.allow_space_after_digits) pattern += "( (?!$))?";
    if (options.symbol_after_digits) pattern += symbol;
    else pattern = symbol + pattern;
    if (options.allow_negatives) {
        if (options.parens_for_negatives) pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
        else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) pattern = negative + pattern;
    } // ensure there's a dollar and/or decimal amount, and that
    // it doesn't start with a space or a negative sign followed by a space
    return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}
var $52cf7c7e9f64c2d7$var$default_currency_options = {
    symbol: "$",
    require_symbol: false,
    allow_space_after_symbol: false,
    symbol_after_digits: false,
    allow_negatives: true,
    parens_for_negatives: false,
    negative_sign_before_digits: false,
    negative_sign_after_digits: false,
    allow_negative_sign_placeholder: false,
    thousands_separator: ",",
    decimal_separator: ".",
    allow_decimal: true,
    require_decimal: false,
    digits_after_decimal: [
        2
    ],
    allow_space_after_digits: false
};
function $52cf7c7e9f64c2d7$var$isCurrency(str, options) {
    (0, $52cf7c7e9f64c2d7$var$_assertString.default)(str);
    options = (0, $52cf7c7e9f64c2d7$var$_merge.default)(options, $52cf7c7e9f64c2d7$var$default_currency_options);
    return $52cf7c7e9f64c2d7$var$currencyRegex(options).test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("d7JFz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98df5ad202ea01f3$var$isBtcAddress;

var $98df5ad202ea01f3$var$_assertString = $98df5ad202ea01f3$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $98df5ad202ea01f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $98df5ad202ea01f3$var$bech32 = /^(bc1)[a-z0-9]{25,39}$/;
var $98df5ad202ea01f3$var$base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
function $98df5ad202ea01f3$var$isBtcAddress(str) {
    (0, $98df5ad202ea01f3$var$_assertString.default)(str);
    return $98df5ad202ea01f3$var$bech32.test(str) || $98df5ad202ea01f3$var$base58.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bANpD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $870962cc215f62c5$var$isISO6391;

var $870962cc215f62c5$var$_assertString = $870962cc215f62c5$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $870962cc215f62c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $870962cc215f62c5$var$isISO6391Set = new Set([
    "aa",
    "ab",
    "ae",
    "af",
    "ak",
    "am",
    "an",
    "ar",
    "as",
    "av",
    "ay",
    "az",
    "az",
    "ba",
    "be",
    "bg",
    "bh",
    "bi",
    "bm",
    "bn",
    "bo",
    "br",
    "bs",
    "ca",
    "ce",
    "ch",
    "co",
    "cr",
    "cs",
    "cu",
    "cv",
    "cy",
    "da",
    "de",
    "dv",
    "dz",
    "ee",
    "el",
    "en",
    "eo",
    "es",
    "et",
    "eu",
    "fa",
    "ff",
    "fi",
    "fj",
    "fo",
    "fr",
    "fy",
    "ga",
    "gd",
    "gl",
    "gn",
    "gu",
    "gv",
    "ha",
    "he",
    "hi",
    "ho",
    "hr",
    "ht",
    "hu",
    "hy",
    "hz",
    "ia",
    "id",
    "ie",
    "ig",
    "ii",
    "ik",
    "io",
    "is",
    "it",
    "iu",
    "ja",
    "jv",
    "ka",
    "kg",
    "ki",
    "kj",
    "kk",
    "kl",
    "km",
    "kn",
    "ko",
    "kr",
    "ks",
    "ku",
    "kv",
    "kw",
    "ky",
    "la",
    "lb",
    "lg",
    "li",
    "ln",
    "lo",
    "lt",
    "lu",
    "lv",
    "mg",
    "mh",
    "mi",
    "mk",
    "ml",
    "mn",
    "mr",
    "ms",
    "mt",
    "my",
    "na",
    "nb",
    "nd",
    "ne",
    "ng",
    "nl",
    "nn",
    "no",
    "nr",
    "nv",
    "ny",
    "oc",
    "oj",
    "om",
    "or",
    "os",
    "pa",
    "pi",
    "pl",
    "ps",
    "pt",
    "qu",
    "rm",
    "rn",
    "ro",
    "ru",
    "rw",
    "sa",
    "sc",
    "sd",
    "se",
    "sg",
    "si",
    "sk",
    "sl",
    "sm",
    "sn",
    "so",
    "sq",
    "sr",
    "ss",
    "st",
    "su",
    "sv",
    "sw",
    "ta",
    "te",
    "tg",
    "th",
    "ti",
    "tk",
    "tl",
    "tn",
    "to",
    "tr",
    "ts",
    "tt",
    "tw",
    "ty",
    "ug",
    "uk",
    "ur",
    "uz",
    "ve",
    "vi",
    "vo",
    "wa",
    "wo",
    "xh",
    "yi",
    "yo",
    "za",
    "zh",
    "zu"
]);
function $870962cc215f62c5$var$isISO6391(str) {
    (0, $870962cc215f62c5$var$_assertString.default)(str);
    return $870962cc215f62c5$var$isISO6391Set.has(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bFpZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87e7aee739baefcc$var$isISO8601;

var $87e7aee739baefcc$var$_assertString = $87e7aee739baefcc$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $87e7aee739baefcc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ // from http://goo.gl/0ejHHW
var $87e7aee739baefcc$var$iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/; // same as above, except with a strict 'T' separator between date and time
var $87e7aee739baefcc$var$iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */ var $87e7aee739baefcc$var$isValidDate = function isValidDate(str) {
    // str must have passed the ISO8601 check
    // this check is meant to catch invalid dates
    // like 2009-02-31
    // first check for ordinal dates
    var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (ordinalMatch) {
        var oYear = Number(ordinalMatch[1]);
        var oDay = Number(ordinalMatch[2]); // if is leap year
        if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
        return oDay <= 365;
    }
    var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
    var year = match[1];
    var month = match[2];
    var day = match[3];
    var monthString = month ? "0".concat(month).slice(-2) : month;
    var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare
    var d = new Date("".concat(year, "-").concat(monthString || "01", "-").concat(dayString || "01"));
    if (month && day) return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
    return true;
};
function $87e7aee739baefcc$var$isISO8601(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $87e7aee739baefcc$var$_assertString.default)(str);
    var check = options.strictSeparator ? $87e7aee739baefcc$var$iso8601StrictSeparator.test(str) : $87e7aee739baefcc$var$iso8601.test(str);
    if (check && options.strict) return $87e7aee739baefcc$var$isValidDate(str);
    return check;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ZtoyI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b8c7fe084738ce9$var$isRFC3339;

var $0b8c7fe084738ce9$var$_assertString = $0b8c7fe084738ce9$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $0b8c7fe084738ce9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */ var $0b8c7fe084738ce9$var$dateFullYear = /[0-9]{4}/;
var $0b8c7fe084738ce9$var$dateMonth = /(0[1-9]|1[0-2])/;
var $0b8c7fe084738ce9$var$dateMDay = /([12]\d|0[1-9]|3[01])/;
var $0b8c7fe084738ce9$var$timeHour = /([01][0-9]|2[0-3])/;
var $0b8c7fe084738ce9$var$timeMinute = /[0-5][0-9]/;
var $0b8c7fe084738ce9$var$timeSecond = /([0-5][0-9]|60)/;
var $0b8c7fe084738ce9$var$timeSecFrac = /(\.[0-9]+)?/;
var $0b8c7fe084738ce9$var$timeNumOffset = new RegExp("[-+]".concat($0b8c7fe084738ce9$var$timeHour.source, ":").concat($0b8c7fe084738ce9$var$timeMinute.source));
var $0b8c7fe084738ce9$var$timeOffset = new RegExp("([zZ]|".concat($0b8c7fe084738ce9$var$timeNumOffset.source, ")"));
var $0b8c7fe084738ce9$var$partialTime = new RegExp("".concat($0b8c7fe084738ce9$var$timeHour.source, ":").concat($0b8c7fe084738ce9$var$timeMinute.source, ":").concat($0b8c7fe084738ce9$var$timeSecond.source).concat($0b8c7fe084738ce9$var$timeSecFrac.source));
var $0b8c7fe084738ce9$var$fullDate = new RegExp("".concat($0b8c7fe084738ce9$var$dateFullYear.source, "-").concat($0b8c7fe084738ce9$var$dateMonth.source, "-").concat($0b8c7fe084738ce9$var$dateMDay.source));
var $0b8c7fe084738ce9$var$fullTime = new RegExp("".concat($0b8c7fe084738ce9$var$partialTime.source).concat($0b8c7fe084738ce9$var$timeOffset.source));
var $0b8c7fe084738ce9$var$rfc3339 = new RegExp("^".concat($0b8c7fe084738ce9$var$fullDate.source, "[ tT]").concat($0b8c7fe084738ce9$var$fullTime.source, "$"));
function $0b8c7fe084738ce9$var$isRFC3339(str) {
    (0, $0b8c7fe084738ce9$var$_assertString.default)(str);
    return $0b8c7fe084738ce9$var$rfc3339.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dv52h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d42139aa2fb0ffb$var$isISO31661Alpha3;

var $9d42139aa2fb0ffb$var$_assertString = $9d42139aa2fb0ffb$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $9d42139aa2fb0ffb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
var $9d42139aa2fb0ffb$var$validISO31661Alpha3CountriesCodes = new Set([
    "AFG",
    "ALA",
    "ALB",
    "DZA",
    "ASM",
    "AND",
    "AGO",
    "AIA",
    "ATA",
    "ATG",
    "ARG",
    "ARM",
    "ABW",
    "AUS",
    "AUT",
    "AZE",
    "BHS",
    "BHR",
    "BGD",
    "BRB",
    "BLR",
    "BEL",
    "BLZ",
    "BEN",
    "BMU",
    "BTN",
    "BOL",
    "BES",
    "BIH",
    "BWA",
    "BVT",
    "BRA",
    "IOT",
    "BRN",
    "BGR",
    "BFA",
    "BDI",
    "KHM",
    "CMR",
    "CAN",
    "CPV",
    "CYM",
    "CAF",
    "TCD",
    "CHL",
    "CHN",
    "CXR",
    "CCK",
    "COL",
    "COM",
    "COG",
    "COD",
    "COK",
    "CRI",
    "CIV",
    "HRV",
    "CUB",
    "CUW",
    "CYP",
    "CZE",
    "DNK",
    "DJI",
    "DMA",
    "DOM",
    "ECU",
    "EGY",
    "SLV",
    "GNQ",
    "ERI",
    "EST",
    "ETH",
    "FLK",
    "FRO",
    "FJI",
    "FIN",
    "FRA",
    "GUF",
    "PYF",
    "ATF",
    "GAB",
    "GMB",
    "GEO",
    "DEU",
    "GHA",
    "GIB",
    "GRC",
    "GRL",
    "GRD",
    "GLP",
    "GUM",
    "GTM",
    "GGY",
    "GIN",
    "GNB",
    "GUY",
    "HTI",
    "HMD",
    "VAT",
    "HND",
    "HKG",
    "HUN",
    "ISL",
    "IND",
    "IDN",
    "IRN",
    "IRQ",
    "IRL",
    "IMN",
    "ISR",
    "ITA",
    "JAM",
    "JPN",
    "JEY",
    "JOR",
    "KAZ",
    "KEN",
    "KIR",
    "PRK",
    "KOR",
    "KWT",
    "KGZ",
    "LAO",
    "LVA",
    "LBN",
    "LSO",
    "LBR",
    "LBY",
    "LIE",
    "LTU",
    "LUX",
    "MAC",
    "MKD",
    "MDG",
    "MWI",
    "MYS",
    "MDV",
    "MLI",
    "MLT",
    "MHL",
    "MTQ",
    "MRT",
    "MUS",
    "MYT",
    "MEX",
    "FSM",
    "MDA",
    "MCO",
    "MNG",
    "MNE",
    "MSR",
    "MAR",
    "MOZ",
    "MMR",
    "NAM",
    "NRU",
    "NPL",
    "NLD",
    "NCL",
    "NZL",
    "NIC",
    "NER",
    "NGA",
    "NIU",
    "NFK",
    "MNP",
    "NOR",
    "OMN",
    "PAK",
    "PLW",
    "PSE",
    "PAN",
    "PNG",
    "PRY",
    "PER",
    "PHL",
    "PCN",
    "POL",
    "PRT",
    "PRI",
    "QAT",
    "REU",
    "ROU",
    "RUS",
    "RWA",
    "BLM",
    "SHN",
    "KNA",
    "LCA",
    "MAF",
    "SPM",
    "VCT",
    "WSM",
    "SMR",
    "STP",
    "SAU",
    "SEN",
    "SRB",
    "SYC",
    "SLE",
    "SGP",
    "SXM",
    "SVK",
    "SVN",
    "SLB",
    "SOM",
    "ZAF",
    "SGS",
    "SSD",
    "ESP",
    "LKA",
    "SDN",
    "SUR",
    "SJM",
    "SWZ",
    "SWE",
    "CHE",
    "SYR",
    "TWN",
    "TJK",
    "TZA",
    "THA",
    "TLS",
    "TGO",
    "TKL",
    "TON",
    "TTO",
    "TUN",
    "TUR",
    "TKM",
    "TCA",
    "TUV",
    "UGA",
    "UKR",
    "ARE",
    "GBR",
    "USA",
    "UMI",
    "URY",
    "UZB",
    "VUT",
    "VEN",
    "VNM",
    "VGB",
    "VIR",
    "WLF",
    "ESH",
    "YEM",
    "ZMB",
    "ZWE"
]);
function $9d42139aa2fb0ffb$var$isISO31661Alpha3(str) {
    (0, $9d42139aa2fb0ffb$var$_assertString.default)(str);
    return $9d42139aa2fb0ffb$var$validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ip6Vk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d65feeaf48b78a5b$var$isISO4217;
module.exports.CurrencyCodes = void 0;

var $d65feeaf48b78a5b$var$_assertString = $d65feeaf48b78a5b$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $d65feeaf48b78a5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_4217
var $d65feeaf48b78a5b$var$validISO4217CurrencyCodes = new Set([
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BOV",
    "BRL",
    "BSD",
    "BTN",
    "BWP",
    "BYN",
    "BZD",
    "CAD",
    "CDF",
    "CHE",
    "CHF",
    "CHW",
    "CLF",
    "CLP",
    "CNY",
    "COP",
    "COU",
    "CRC",
    "CUC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EGP",
    "ERN",
    "ETB",
    "EUR",
    "FJD",
    "FKP",
    "GBP",
    "GEL",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KGS",
    "KHR",
    "KMF",
    "KPW",
    "KRW",
    "KWD",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRU",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MXV",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SDG",
    "SEK",
    "SGD",
    "SHP",
    "SLL",
    "SOS",
    "SRD",
    "SSP",
    "STN",
    "SVC",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USD",
    "USN",
    "UYI",
    "UYU",
    "UYW",
    "UZS",
    "VES",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XAG",
    "XAU",
    "XBA",
    "XBB",
    "XBC",
    "XBD",
    "XCD",
    "XDR",
    "XOF",
    "XPD",
    "XPF",
    "XPT",
    "XSU",
    "XTS",
    "XUA",
    "XXX",
    "YER",
    "ZAR",
    "ZMW",
    "ZWL"
]);
function $d65feeaf48b78a5b$var$isISO4217(str) {
    (0, $d65feeaf48b78a5b$var$_assertString.default)(str);
    return $d65feeaf48b78a5b$var$validISO4217CurrencyCodes.has(str.toUpperCase());
}
var $d65feeaf48b78a5b$var$CurrencyCodes = $d65feeaf48b78a5b$var$validISO4217CurrencyCodes;
module.exports.CurrencyCodes = $d65feeaf48b78a5b$var$CurrencyCodes;

});

parcelRegister("frcxl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3d31a2c67a18b52$var$isBase32;

var $b3d31a2c67a18b52$var$_assertString = $b3d31a2c67a18b52$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $b3d31a2c67a18b52$var$_merge = $b3d31a2c67a18b52$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $b3d31a2c67a18b52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b3d31a2c67a18b52$var$base32 = /^[A-Z2-7]+=*$/;
var $b3d31a2c67a18b52$var$crockfordBase32 = /^[A-HJKMNP-TV-Z0-9]+$/;
var $b3d31a2c67a18b52$var$defaultBase32Options = {
    crockford: false
};
function $b3d31a2c67a18b52$var$isBase32(str, options) {
    (0, $b3d31a2c67a18b52$var$_assertString.default)(str);
    options = (0, $b3d31a2c67a18b52$var$_merge.default)(options, $b3d31a2c67a18b52$var$defaultBase32Options);
    if (options.crockford) return $b3d31a2c67a18b52$var$crockfordBase32.test(str);
    var len = str.length;
    if (len % 8 === 0 && $b3d31a2c67a18b52$var$base32.test(str)) return true;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7sShw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56f5412012c89e0e$var$isBase58;

var $56f5412012c89e0e$var$_assertString = $56f5412012c89e0e$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $56f5412012c89e0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Accepted chars - 123456789ABCDEFGH JKLMN PQRSTUVWXYZabcdefghijk mnopqrstuvwxyz
var $56f5412012c89e0e$var$base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;
function $56f5412012c89e0e$var$isBase58(str) {
    (0, $56f5412012c89e0e$var$_assertString.default)(str);
    if ($56f5412012c89e0e$var$base58Reg.test(str)) return true;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("6K2Bh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e890e4cd3a994e0$var$isDataURI;

var $4e890e4cd3a994e0$var$_assertString = $4e890e4cd3a994e0$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $4e890e4cd3a994e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4e890e4cd3a994e0$var$validMediaType = /^[a-z]+\/[a-z0-9\-\+\._]+$/i;
var $4e890e4cd3a994e0$var$validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var $4e890e4cd3a994e0$var$validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
function $4e890e4cd3a994e0$var$isDataURI(str) {
    (0, $4e890e4cd3a994e0$var$_assertString.default)(str);
    var data = str.split(",");
    if (data.length < 2) return false;
    var attributes = data.shift().trim().split(";");
    var schemeAndMediaType = attributes.shift();
    if (schemeAndMediaType.slice(0, 5) !== "data:") return false;
    var mediaType = schemeAndMediaType.slice(5);
    if (mediaType !== "" && !$4e890e4cd3a994e0$var$validMediaType.test(mediaType)) return false;
    for(var i = 0; i < attributes.length; i++){
        if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === "base64") && !$4e890e4cd3a994e0$var$validAttribute.test(attributes[i])) return false;
    }
    for(var _i = 0; _i < data.length; _i++){
        if (!$4e890e4cd3a994e0$var$validData.test(data[_i])) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Z46oc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b78e133c64bb258$var$isMagnetURI;

var $0b78e133c64bb258$var$_assertString = $0b78e133c64bb258$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $0b78e133c64bb258$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0b78e133c64bb258$var$magnetURIComponent = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
function $0b78e133c64bb258$var$isMagnetURI(url) {
    (0, $0b78e133c64bb258$var$_assertString.default)(url);
    if (url.indexOf("magnet:?") !== 0) return false;
    return $0b78e133c64bb258$var$magnetURIComponent.test(url);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("efaxe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5eaa370130ddc54$var$isMailtoURI;

var $a5eaa370130ddc54$var$_trim = $a5eaa370130ddc54$var$_interopRequireDefault((parcelRequire("1PIcn")));

var $a5eaa370130ddc54$var$_isEmail = $a5eaa370130ddc54$var$_interopRequireDefault((parcelRequire("2Nl9T")));

var $a5eaa370130ddc54$var$_assertString = $a5eaa370130ddc54$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $a5eaa370130ddc54$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a5eaa370130ddc54$var$_slicedToArray(arr, i) {
    return $a5eaa370130ddc54$var$_arrayWithHoles(arr) || $a5eaa370130ddc54$var$_iterableToArrayLimit(arr, i) || $a5eaa370130ddc54$var$_unsupportedIterableToArray(arr, i) || $a5eaa370130ddc54$var$_nonIterableRest();
}
function $a5eaa370130ddc54$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a5eaa370130ddc54$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a5eaa370130ddc54$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a5eaa370130ddc54$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $a5eaa370130ddc54$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a5eaa370130ddc54$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a5eaa370130ddc54$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a5eaa370130ddc54$var$_arrayLikeToArray(o, minLen);
}
function $a5eaa370130ddc54$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a5eaa370130ddc54$var$parseMailtoQueryString(queryString) {
    var allowedParams = new Set([
        "subject",
        "body",
        "cc",
        "bcc"
    ]), query = {
        cc: "",
        bcc: ""
    };
    var isParseFailed = false;
    var queryParams = queryString.split("&");
    if (queryParams.length > 4) return false;
    var _iterator = $a5eaa370130ddc54$var$_createForOfIteratorHelper(queryParams), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var q = _step.value;
            var _q$split = q.split("="), _q$split2 = $a5eaa370130ddc54$var$_slicedToArray(_q$split, 2), key = _q$split2[0], value = _q$split2[1]; // checked for invalid and duplicated query params
            if (key && !allowedParams.has(key)) {
                isParseFailed = true;
                break;
            }
            if (value && (key === "cc" || key === "bcc")) query[key] = value;
            if (key) allowedParams.delete(key);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return isParseFailed ? false : query;
}
function $a5eaa370130ddc54$var$isMailtoURI(url, options) {
    (0, $a5eaa370130ddc54$var$_assertString.default)(url);
    if (url.indexOf("mailto:") !== 0) return false;
    var _url$replace$split = url.replace("mailto:", "").split("?"), _url$replace$split2 = $a5eaa370130ddc54$var$_slicedToArray(_url$replace$split, 2), _url$replace$split2$ = _url$replace$split2[0], to = _url$replace$split2$ === void 0 ? "" : _url$replace$split2$, _url$replace$split2$2 = _url$replace$split2[1], queryString = _url$replace$split2$2 === void 0 ? "" : _url$replace$split2$2;
    if (!to && !queryString) return true;
    var query = $a5eaa370130ddc54$var$parseMailtoQueryString(queryString);
    if (!query) return false;
    return "".concat(to, ",").concat(query.cc, ",").concat(query.bcc).split(",").every(function(email) {
        email = (0, $a5eaa370130ddc54$var$_trim.default)(email, " ");
        if (email) return (0, $a5eaa370130ddc54$var$_isEmail.default)(email, options);
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("1PIcn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $155cd6c6cf0d68e2$var$trim;

var $155cd6c6cf0d68e2$var$_rtrim = $155cd6c6cf0d68e2$var$_interopRequireDefault((parcelRequire("8rcRs")));

var $155cd6c6cf0d68e2$var$_ltrim = $155cd6c6cf0d68e2$var$_interopRequireDefault((parcelRequire("8rtqA")));
function $155cd6c6cf0d68e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $155cd6c6cf0d68e2$var$trim(str, chars) {
    return (0, $155cd6c6cf0d68e2$var$_rtrim.default)((0, $155cd6c6cf0d68e2$var$_ltrim.default)(str, chars), chars);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("8rcRs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $624ad250718fd586$var$rtrim;

var $624ad250718fd586$var$_assertString = $624ad250718fd586$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $624ad250718fd586$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $624ad250718fd586$var$rtrim(str, chars) {
    (0, $624ad250718fd586$var$_assertString.default)(str);
    if (chars) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
        var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return str.replace(pattern, "");
    } // Use a faster and more safe than regex trim method https://blog.stevenlevithan.com/archives/faster-trim-javascript
    var strIndex = str.length - 1;
    while(/\s/.test(str.charAt(strIndex)))strIndex -= 1;
    return str.slice(0, strIndex + 1);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8rtqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6257ac12a946ed17$var$ltrim;

var $6257ac12a946ed17$var$_assertString = $6257ac12a946ed17$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $6257ac12a946ed17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6257ac12a946ed17$var$ltrim(str, chars) {
    (0, $6257ac12a946ed17$var$_assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
    return str.replace(pattern, "");
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});



parcelRegister("a1QJl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74d2e6879f9c5997$var$isMimeType;

var $74d2e6879f9c5997$var$_assertString = $74d2e6879f9c5997$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $74d2e6879f9c5997$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/ // Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var $74d2e6879f9c5997$var$mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"
var $74d2e6879f9c5997$var$mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"
var $74d2e6879f9c5997$var$mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
function $74d2e6879f9c5997$var$isMimeType(str) {
    (0, $74d2e6879f9c5997$var$_assertString.default)(str);
    return $74d2e6879f9c5997$var$mimeTypeSimple.test(str) || $74d2e6879f9c5997$var$mimeTypeText.test(str) || $74d2e6879f9c5997$var$mimeTypeMultipart.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aHsKa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ca437695db8fb11$var$isLatLong;

var $7ca437695db8fb11$var$_assertString = $7ca437695db8fb11$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $7ca437695db8fb11$var$_merge = $7ca437695db8fb11$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $7ca437695db8fb11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7ca437695db8fb11$var$lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var $7ca437695db8fb11$var$long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
var $7ca437695db8fb11$var$latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
var $7ca437695db8fb11$var$longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
var $7ca437695db8fb11$var$defaultLatLongOptions = {
    checkDMS: false
};
function $7ca437695db8fb11$var$isLatLong(str, options) {
    (0, $7ca437695db8fb11$var$_assertString.default)(str);
    options = (0, $7ca437695db8fb11$var$_merge.default)(options, $7ca437695db8fb11$var$defaultLatLongOptions);
    if (!str.includes(",")) return false;
    var pair = str.split(",");
    if (pair[0].startsWith("(") && !pair[1].endsWith(")") || pair[1].endsWith(")") && !pair[0].startsWith("(")) return false;
    if (options.checkDMS) return $7ca437695db8fb11$var$latDMS.test(pair[0]) && $7ca437695db8fb11$var$longDMS.test(pair[1]);
    return $7ca437695db8fb11$var$lat.test(pair[0]) && $7ca437695db8fb11$var$long.test(pair[1]);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2q1xR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c2f354f72719bf3$var$isPostalCode;
module.exports.locales = void 0;

var $1c2f354f72719bf3$var$_assertString = $1c2f354f72719bf3$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1c2f354f72719bf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// common patterns
var $1c2f354f72719bf3$var$threeDigit = /^\d{3}$/;
var $1c2f354f72719bf3$var$fourDigit = /^\d{4}$/;
var $1c2f354f72719bf3$var$fiveDigit = /^\d{5}$/;
var $1c2f354f72719bf3$var$sixDigit = /^\d{6}$/;
var $1c2f354f72719bf3$var$patterns = {
    AD: /^AD\d{3}$/,
    AT: $1c2f354f72719bf3$var$fourDigit,
    AU: $1c2f354f72719bf3$var$fourDigit,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BE: $1c2f354f72719bf3$var$fourDigit,
    BG: $1c2f354f72719bf3$var$fourDigit,
    BR: /^\d{5}-\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: $1c2f354f72719bf3$var$fourDigit,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: $1c2f354f72719bf3$var$fiveDigit,
    DK: $1c2f354f72719bf3$var$fourDigit,
    DO: $1c2f354f72719bf3$var$fiveDigit,
    DZ: $1c2f354f72719bf3$var$fiveDigit,
    EE: $1c2f354f72719bf3$var$fiveDigit,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: $1c2f354f72719bf3$var$fiveDigit,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: $1c2f354f72719bf3$var$fourDigit,
    ID: $1c2f354f72719bf3$var$fiveDigit,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: $1c2f354f72719bf3$var$threeDigit,
    IT: $1c2f354f72719bf3$var$fiveDigit,
    JP: /^\d{3}\-\d{4}$/,
    KE: $1c2f354f72719bf3$var$fiveDigit,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: $1c2f354f72719bf3$var$fourDigit,
    LV: /^LV\-\d{4}$/,
    LK: $1c2f354f72719bf3$var$fiveDigit,
    MG: $1c2f354f72719bf3$var$threeDigit,
    MX: $1c2f354f72719bf3$var$fiveDigit,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: $1c2f354f72719bf3$var$fiveDigit,
    NL: /^\d{4}\s?[a-z]{2}$/i,
    NO: $1c2f354f72719bf3$var$fourDigit,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: $1c2f354f72719bf3$var$fourDigit,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: $1c2f354f72719bf3$var$sixDigit,
    RU: $1c2f354f72719bf3$var$sixDigit,
    SA: $1c2f354f72719bf3$var$fiveDigit,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: $1c2f354f72719bf3$var$sixDigit,
    SI: $1c2f354f72719bf3$var$fourDigit,
    SK: /^\d{3}\s?\d{2}$/,
    TH: $1c2f354f72719bf3$var$fiveDigit,
    TN: $1c2f354f72719bf3$var$fourDigit,
    TW: /^\d{3}(\d{2})?$/,
    UA: $1c2f354f72719bf3$var$fiveDigit,
    US: /^\d{5}(-\d{4})?$/,
    ZA: $1c2f354f72719bf3$var$fourDigit,
    ZM: $1c2f354f72719bf3$var$fiveDigit
};
var $1c2f354f72719bf3$var$locales = Object.keys($1c2f354f72719bf3$var$patterns);
module.exports.locales = $1c2f354f72719bf3$var$locales;
function $1c2f354f72719bf3$var$isPostalCode(str, locale) {
    (0, $1c2f354f72719bf3$var$_assertString.default)(str);
    if (locale in $1c2f354f72719bf3$var$patterns) return $1c2f354f72719bf3$var$patterns[locale].test(str);
    else if (locale === "any") {
        for(var key in $1c2f354f72719bf3$var$patterns)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($1c2f354f72719bf3$var$patterns.hasOwnProperty(key)) {
            var pattern = $1c2f354f72719bf3$var$patterns[key];
            if (pattern.test(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}

});

parcelRegister("5EWEe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41ee2e70f35230af$var$escape;

var $41ee2e70f35230af$var$_assertString = $41ee2e70f35230af$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $41ee2e70f35230af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41ee2e70f35230af$var$escape(str) {
    (0, $41ee2e70f35230af$var$_assertString.default)(str);
    return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("l3DBq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f548990e7ebe0299$var$unescape;

var $f548990e7ebe0299$var$_assertString = $f548990e7ebe0299$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $f548990e7ebe0299$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f548990e7ebe0299$var$unescape(str) {
    (0, $f548990e7ebe0299$var$_assertString.default)(str);
    return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&"); // &amp; replacement has to be the last one to prevent
// bugs with intermediate strings containing escape sequences
// See: https://github.com/validatorjs/validator.js/issues/1827
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("gYqHl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c5b6f59b21da7db0$var$stripLow;

var $c5b6f59b21da7db0$var$_assertString = $c5b6f59b21da7db0$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $c5b6f59b21da7db0$var$_blacklist = $c5b6f59b21da7db0$var$_interopRequireDefault((parcelRequire("5tIZs")));
function $c5b6f59b21da7db0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c5b6f59b21da7db0$var$stripLow(str, keep_new_lines) {
    (0, $c5b6f59b21da7db0$var$_assertString.default)(str);
    var chars = keep_new_lines ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
    return (0, $c5b6f59b21da7db0$var$_blacklist.default)(str, chars);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("5tIZs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fd28f4f2a7e59f3$var$blacklist;

var $3fd28f4f2a7e59f3$var$_assertString = $3fd28f4f2a7e59f3$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $3fd28f4f2a7e59f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3fd28f4f2a7e59f3$var$blacklist(str, chars) {
    (0, $3fd28f4f2a7e59f3$var$_assertString.default)(str);
    return str.replace(new RegExp("[".concat(chars, "]+"), "g"), "");
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("9lu9s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cdd76b2d943a98f$var$whitelist;

var $6cdd76b2d943a98f$var$_assertString = $6cdd76b2d943a98f$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $6cdd76b2d943a98f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6cdd76b2d943a98f$var$whitelist(str, chars) {
    (0, $6cdd76b2d943a98f$var$_assertString.default)(str);
    return str.replace(new RegExp("[^".concat(chars, "]+"), "g"), "");
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2VKoZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2224e62275b7eead$var$isWhitelisted;

var $2224e62275b7eead$var$_assertString = $2224e62275b7eead$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $2224e62275b7eead$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2224e62275b7eead$var$isWhitelisted(str, chars) {
    (0, $2224e62275b7eead$var$_assertString.default)(str);
    for(var i = str.length - 1; i >= 0; i--){
        if (chars.indexOf(str[i]) === -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hEc4p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd8f88f6cc3fc182$var$normalizeEmail;

var $cd8f88f6cc3fc182$var$_merge = $cd8f88f6cc3fc182$var$_interopRequireDefault((parcelRequire("aXHNC")));
function $cd8f88f6cc3fc182$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cd8f88f6cc3fc182$var$default_normalize_email_options = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: true,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: true,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: true,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: true,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: true,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: true,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: true,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: true,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: true
}; // List of domains used by iCloud
var $cd8f88f6cc3fc182$var$icloud_domains = [
    "icloud.com",
    "me.com"
]; // List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
var $cd8f88f6cc3fc182$var$outlookdotcom_domains = [
    "hotmail.at",
    "hotmail.be",
    "hotmail.ca",
    "hotmail.cl",
    "hotmail.co.il",
    "hotmail.co.nz",
    "hotmail.co.th",
    "hotmail.co.uk",
    "hotmail.com",
    "hotmail.com.ar",
    "hotmail.com.au",
    "hotmail.com.br",
    "hotmail.com.gr",
    "hotmail.com.mx",
    "hotmail.com.pe",
    "hotmail.com.tr",
    "hotmail.com.vn",
    "hotmail.cz",
    "hotmail.de",
    "hotmail.dk",
    "hotmail.es",
    "hotmail.fr",
    "hotmail.hu",
    "hotmail.id",
    "hotmail.ie",
    "hotmail.in",
    "hotmail.it",
    "hotmail.jp",
    "hotmail.kr",
    "hotmail.lv",
    "hotmail.my",
    "hotmail.ph",
    "hotmail.pt",
    "hotmail.sa",
    "hotmail.sg",
    "hotmail.sk",
    "live.be",
    "live.co.uk",
    "live.com",
    "live.com.ar",
    "live.com.mx",
    "live.de",
    "live.es",
    "live.eu",
    "live.fr",
    "live.it",
    "live.nl",
    "msn.com",
    "outlook.at",
    "outlook.be",
    "outlook.cl",
    "outlook.co.il",
    "outlook.co.nz",
    "outlook.co.th",
    "outlook.com",
    "outlook.com.ar",
    "outlook.com.au",
    "outlook.com.br",
    "outlook.com.gr",
    "outlook.com.pe",
    "outlook.com.tr",
    "outlook.com.vn",
    "outlook.cz",
    "outlook.de",
    "outlook.dk",
    "outlook.es",
    "outlook.fr",
    "outlook.hu",
    "outlook.id",
    "outlook.ie",
    "outlook.in",
    "outlook.it",
    "outlook.jp",
    "outlook.kr",
    "outlook.lv",
    "outlook.my",
    "outlook.ph",
    "outlook.pt",
    "outlook.sa",
    "outlook.sg",
    "outlook.sk",
    "passport.com"
]; // List of domains used by Yahoo Mail
// This list is likely incomplete
var $cd8f88f6cc3fc182$var$yahoo_domains = [
    "rocketmail.com",
    "yahoo.ca",
    "yahoo.co.uk",
    "yahoo.com",
    "yahoo.de",
    "yahoo.fr",
    "yahoo.in",
    "yahoo.it",
    "ymail.com"
]; // List of domains used by yandex.ru
var $cd8f88f6cc3fc182$var$yandex_domains = [
    "yandex.ru",
    "yandex.ua",
    "yandex.kz",
    "yandex.com",
    "yandex.by",
    "ya.ru"
]; // replace single dots, but not multiple consecutive dots
function $cd8f88f6cc3fc182$var$dotsReplacer(match) {
    if (match.length > 1) return match;
    return "";
}
function $cd8f88f6cc3fc182$var$normalizeEmail(email, options) {
    options = (0, $cd8f88f6cc3fc182$var$_merge.default)(options, $cd8f88f6cc3fc182$var$default_normalize_email_options);
    var raw_parts = email.split("@");
    var domain = raw_parts.pop();
    var user = raw_parts.join("@");
    var parts = [
        user,
        domain
    ]; // The domain is always lowercased, as it's case-insensitive per RFC 1035
    parts[1] = parts[1].toLowerCase();
    if (parts[1] === "gmail.com" || parts[1] === "googlemail.com") {
        // Address is GMail
        if (options.gmail_remove_subaddress) parts[0] = parts[0].split("+")[0];
        if (options.gmail_remove_dots) // this does not replace consecutive dots like example..email@gmail.com
        parts[0] = parts[0].replace(/\.+/g, $cd8f88f6cc3fc182$var$dotsReplacer);
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.gmail_lowercase) parts[0] = parts[0].toLowerCase();
        parts[1] = options.gmail_convert_googlemaildotcom ? "gmail.com" : parts[1];
    } else if ($cd8f88f6cc3fc182$var$icloud_domains.indexOf(parts[1]) >= 0) {
        // Address is iCloud
        if (options.icloud_remove_subaddress) parts[0] = parts[0].split("+")[0];
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.icloud_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($cd8f88f6cc3fc182$var$outlookdotcom_domains.indexOf(parts[1]) >= 0) {
        // Address is Outlook.com
        if (options.outlookdotcom_remove_subaddress) parts[0] = parts[0].split("+")[0];
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.outlookdotcom_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($cd8f88f6cc3fc182$var$yahoo_domains.indexOf(parts[1]) >= 0) {
        // Address is Yahoo
        if (options.yahoo_remove_subaddress) {
            var components = parts[0].split("-");
            parts[0] = components.length > 1 ? components.slice(0, -1).join("-") : components[0];
        }
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.yahoo_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($cd8f88f6cc3fc182$var$yandex_domains.indexOf(parts[1]) >= 0) {
        if (options.all_lowercase || options.yandex_lowercase) parts[0] = parts[0].toLowerCase();
        parts[1] = "yandex.ru"; // all yandex domains are equal, 1st preferred
    } else if (options.all_lowercase) // Any other address
    parts[0] = parts[0].toLowerCase();
    return parts.join("@");
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4SWTk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $38e9e3318f456752$var$isSlug;

var $38e9e3318f456752$var$_assertString = $38e9e3318f456752$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $38e9e3318f456752$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $38e9e3318f456752$var$charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
function $38e9e3318f456752$var$isSlug(str) {
    (0, $38e9e3318f456752$var$_assertString.default)(str);
    return $38e9e3318f456752$var$charsetRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2hf3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a88d918c423157b$var$isLicensePlate;

var $1a88d918c423157b$var$_assertString = $1a88d918c423157b$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $1a88d918c423157b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1a88d918c423157b$var$validators = {
    "cs-CZ": function csCZ(str) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
    },
    "de-DE": function deDE(str) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
    },
    "de-LI": function deLI(str) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
    },
    "en-IN": function enIN(str) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(str);
    },
    "es-AR": function esAR(str) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(str);
    },
    "fi-FI": function fiFI(str) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
    },
    "hu-HU": function huHU(str) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(str);
    },
    "pt-BR": function ptBR(str) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
    },
    "pt-PT": function ptPT(str) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
    },
    "sq-AL": function sqAL(str) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
    },
    "sv-SE": function svSE(str) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(str.trim());
    }
};
function $1a88d918c423157b$var$isLicensePlate(str, locale) {
    (0, $1a88d918c423157b$var$_assertString.default)(str);
    if (locale in $1a88d918c423157b$var$validators) return $1a88d918c423157b$var$validators[locale](str);
    else if (locale === "any") {
        for(var key in $1a88d918c423157b$var$validators){
            /* eslint guard-for-in: 0 */ var validator = $1a88d918c423157b$var$validators[key];
            if (validator(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aMZVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7dae6c6958561d7f$var$isStrongPassword;

var $7dae6c6958561d7f$var$_merge = $7dae6c6958561d7f$var$_interopRequireDefault((parcelRequire("aXHNC")));

var $7dae6c6958561d7f$var$_assertString = $7dae6c6958561d7f$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $7dae6c6958561d7f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7dae6c6958561d7f$var$upperCaseRegex = /^[A-Z]$/;
var $7dae6c6958561d7f$var$lowerCaseRegex = /^[a-z]$/;
var $7dae6c6958561d7f$var$numberRegex = /^[0-9]$/;
var $7dae6c6958561d7f$var$symbolRegex = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/;
var $7dae6c6958561d7f$var$defaultOptions = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: false,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
};
/* Counts number of occurrences of each char in a string
 * could be moved to util/ ?
*/ function $7dae6c6958561d7f$var$countChars(str) {
    var result = {};
    Array.from(str).forEach(function(char) {
        var curVal = result[char];
        if (curVal) result[char] += 1;
        else result[char] = 1;
    });
    return result;
}
/* Return information about a password */ function $7dae6c6958561d7f$var$analyzePassword(password) {
    var charMap = $7dae6c6958561d7f$var$countChars(password);
    var analysis = {
        length: password.length,
        uniqueChars: Object.keys(charMap).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
    };
    Object.keys(charMap).forEach(function(char) {
        /* istanbul ignore else */ if ($7dae6c6958561d7f$var$upperCaseRegex.test(char)) analysis.uppercaseCount += charMap[char];
        else if ($7dae6c6958561d7f$var$lowerCaseRegex.test(char)) analysis.lowercaseCount += charMap[char];
        else if ($7dae6c6958561d7f$var$numberRegex.test(char)) analysis.numberCount += charMap[char];
        else if ($7dae6c6958561d7f$var$symbolRegex.test(char)) analysis.symbolCount += charMap[char];
    });
    return analysis;
}
function $7dae6c6958561d7f$var$scorePassword(analysis, scoringOptions) {
    var points = 0;
    points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
    points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;
    if (analysis.lowercaseCount > 0) points += scoringOptions.pointsForContainingLower;
    if (analysis.uppercaseCount > 0) points += scoringOptions.pointsForContainingUpper;
    if (analysis.numberCount > 0) points += scoringOptions.pointsForContainingNumber;
    if (analysis.symbolCount > 0) points += scoringOptions.pointsForContainingSymbol;
    return points;
}
function $7dae6c6958561d7f$var$isStrongPassword(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, $7dae6c6958561d7f$var$_assertString.default)(str);
    var analysis = $7dae6c6958561d7f$var$analyzePassword(str);
    options = (0, $7dae6c6958561d7f$var$_merge.default)(options || {}, $7dae6c6958561d7f$var$defaultOptions);
    if (options.returnScore) return $7dae6c6958561d7f$var$scorePassword(analysis, options);
    return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8i7BV", function(module, exports) {
"use strict";
function $6095e884a2637eb3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6095e884a2637eb3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6095e884a2637eb3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6095e884a2637eb3$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6095e884a2637eb3$var$isVAT;
module.exports.vatMatchers = void 0;

var $6095e884a2637eb3$var$_assertString = $6095e884a2637eb3$var$_interopRequireDefault((parcelRequire("G0UOe")));

var $6095e884a2637eb3$var$algorithms = $6095e884a2637eb3$var$_interopRequireWildcard((parcelRequire("12Tm6")));
function $6095e884a2637eb3$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $6095e884a2637eb3$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $6095e884a2637eb3$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $6095e884a2637eb3$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6095e884a2637eb3$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6095e884a2637eb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6095e884a2637eb3$var$CH = function CH(str) {
    // @see {@link https://www.ech.ch/de/ech/ech-0097/5.2.0}
    var hasValidCheckNumber = function hasValidCheckNumber(digits) {
        var lastDigit = digits.pop(); // used as check number
        var weights = [
            5,
            4,
            3,
            2,
            7,
            6,
            5,
            4
        ];
        var calculatedCheckNumber = (11 - digits.reduce(function(acc, el, idx) {
            return acc + el * weights[idx];
        }, 0) % 11) % 11;
        return lastDigit === calculatedCheckNumber;
    }; // @see {@link https://www.estv.admin.ch/estv/de/home/mehrwertsteuer/uid/mwst-uid-nummer.html}
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(str) && hasValidCheckNumber(str.match(/\d/g).map(function(el) {
        return +el;
    }));
};
var $6095e884a2637eb3$var$PT = function PT(str) {
    var match = str.match(/^(PT)?(\d{9})$/);
    if (!match) return false;
    var tin = match[2];
    var checksum = 11 - $6095e884a2637eb3$var$algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11;
    if (checksum > 9) return parseInt(tin[8], 10) === 0;
    return checksum === parseInt(tin[8], 10);
};
var $6095e884a2637eb3$var$vatMatchers = {
    /**
   * European Union VAT identification numbers
   */ AT: function AT(str) {
        return /^(AT)?U\d{8}$/.test(str);
    },
    BE: function BE(str) {
        return /^(BE)?\d{10}$/.test(str);
    },
    BG: function BG(str) {
        return /^(BG)?\d{9,10}$/.test(str);
    },
    HR: function HR(str) {
        return /^(HR)?\d{11}$/.test(str);
    },
    CY: function CY(str) {
        return /^(CY)?\w{9}$/.test(str);
    },
    CZ: function CZ(str) {
        return /^(CZ)?\d{8,10}$/.test(str);
    },
    DK: function DK(str) {
        return /^(DK)?\d{8}$/.test(str);
    },
    EE: function EE(str) {
        return /^(EE)?\d{9}$/.test(str);
    },
    FI: function FI(str) {
        return /^(FI)?\d{8}$/.test(str);
    },
    FR: function FR(str) {
        return /^(FR)?\w{2}\d{9}$/.test(str);
    },
    DE: function DE(str) {
        return /^(DE)?\d{9}$/.test(str);
    },
    EL: function EL(str) {
        return /^(EL)?\d{9}$/.test(str);
    },
    HU: function HU(str) {
        return /^(HU)?\d{8}$/.test(str);
    },
    IE: function IE(str) {
        return /^(IE)?\d{7}\w{1}(W)?$/.test(str);
    },
    IT: function IT(str) {
        return /^(IT)?\d{11}$/.test(str);
    },
    LV: function LV(str) {
        return /^(LV)?\d{11}$/.test(str);
    },
    LT: function LT(str) {
        return /^(LT)?\d{9,12}$/.test(str);
    },
    LU: function LU(str) {
        return /^(LU)?\d{8}$/.test(str);
    },
    MT: function MT(str) {
        return /^(MT)?\d{8}$/.test(str);
    },
    NL: function NL(str) {
        return /^(NL)?\d{9}B\d{2}$/.test(str);
    },
    PL: function PL(str) {
        return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(str);
    },
    PT: $6095e884a2637eb3$var$PT,
    RO: function RO(str) {
        return /^(RO)?\d{2,10}$/.test(str);
    },
    SK: function SK(str) {
        return /^(SK)?\d{10}$/.test(str);
    },
    SI: function SI(str) {
        return /^(SI)?\d{8}$/.test(str);
    },
    ES: function ES(str) {
        return /^(ES)?\w\d{7}[A-Z]$/.test(str);
    },
    SE: function SE(str) {
        return /^(SE)?\d{12}$/.test(str);
    },
    /**
   * VAT numbers of non-EU countries
   */ AL: function AL(str) {
        return /^(AL)?\w{9}[A-Z]$/.test(str);
    },
    MK: function MK(str) {
        return /^(MK)?\d{13}$/.test(str);
    },
    AU: function AU(str) {
        return /^(AU)?\d{11}$/.test(str);
    },
    BY: function BY(str) {
        return /^(УНП )?\d{9}$/.test(str);
    },
    CA: function CA(str) {
        return /^(CA)?\d{9}$/.test(str);
    },
    IS: function IS(str) {
        return /^(IS)?\d{5,6}$/.test(str);
    },
    IN: function IN(str) {
        return /^(IN)?\d{15}$/.test(str);
    },
    ID: function ID(str) {
        return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(str);
    },
    IL: function IL(str) {
        return /^(IL)?\d{9}$/.test(str);
    },
    KZ: function KZ(str) {
        return /^(KZ)?\d{9}$/.test(str);
    },
    NZ: function NZ(str) {
        return /^(NZ)?\d{9}$/.test(str);
    },
    NG: function NG(str) {
        return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(str);
    },
    NO: function NO(str) {
        return /^(NO)?\d{9}MVA$/.test(str);
    },
    PH: function PH(str) {
        return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(str);
    },
    RU: function RU(str) {
        return /^(RU)?(\d{10}|\d{12})$/.test(str);
    },
    SM: function SM(str) {
        return /^(SM)?\d{5}$/.test(str);
    },
    SA: function SA(str) {
        return /^(SA)?\d{15}$/.test(str);
    },
    RS: function RS(str) {
        return /^(RS)?\d{9}$/.test(str);
    },
    CH: $6095e884a2637eb3$var$CH,
    TR: function TR(str) {
        return /^(TR)?\d{10}$/.test(str);
    },
    UA: function UA(str) {
        return /^(UA)?\d{12}$/.test(str);
    },
    GB: function GB(str) {
        return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(str);
    },
    UZ: function UZ(str) {
        return /^(UZ)?\d{9}$/.test(str);
    },
    /**
   * VAT numbers of Latin American countries
   */ AR: function AR(str) {
        return /^(AR)?\d{11}$/.test(str);
    },
    BO: function BO(str) {
        return /^(BO)?\d{7}$/.test(str);
    },
    BR: function BR(str) {
        return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(str);
    },
    CL: function CL(str) {
        return /^(CL)?\d{8}-\d{1}$/.test(str);
    },
    CO: function CO(str) {
        return /^(CO)?\d{10}$/.test(str);
    },
    CR: function CR(str) {
        return /^(CR)?\d{9,12}$/.test(str);
    },
    EC: function EC(str) {
        return /^(EC)?\d{13}$/.test(str);
    },
    SV: function SV(str) {
        return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(str);
    },
    GT: function GT(str) {
        return /^(GT)?\d{7}-\d{1}$/.test(str);
    },
    HN: function HN(str) {
        return /^(HN)?$/.test(str);
    },
    MX: function MX(str) {
        return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(str);
    },
    NI: function NI(str) {
        return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(str);
    },
    PA: function PA(str) {
        return /^(PA)?$/.test(str);
    },
    PY: function PY(str) {
        return /^(PY)?\d{6,8}-\d{1}$/.test(str);
    },
    PE: function PE(str) {
        return /^(PE)?\d{11}$/.test(str);
    },
    DO: function DO(str) {
        return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(str);
    },
    UY: function UY(str) {
        return /^(UY)?\d{12}$/.test(str);
    },
    VE: function VE(str) {
        return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(str);
    }
};
module.exports.vatMatchers = $6095e884a2637eb3$var$vatMatchers;
function $6095e884a2637eb3$var$isVAT(str, countryCode) {
    (0, $6095e884a2637eb3$var$_assertString.default)(str);
    (0, $6095e884a2637eb3$var$_assertString.default)(countryCode);
    if (countryCode in $6095e884a2637eb3$var$vatMatchers) return $6095e884a2637eb3$var$vatMatchers[countryCode](str);
    throw new Error("Invalid country code: '".concat(countryCode, "'"));
}

});

parcelRegister("fjTYl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b2740c4d1a1f7b76$var$resolveConfig;
    }
});

const $b2740c4d1a1f7b76$var$_negateValue = /*#__PURE__*/ $b2740c4d1a1f7b76$var$_interop_require_default((parcelRequire("kkOiR")));

const $b2740c4d1a1f7b76$var$_corePluginList = /*#__PURE__*/ $b2740c4d1a1f7b76$var$_interop_require_default((parcelRequire("bRPdA")));

const $b2740c4d1a1f7b76$var$_configurePlugins = /*#__PURE__*/ $b2740c4d1a1f7b76$var$_interop_require_default((parcelRequire("51lYh")));

const $b2740c4d1a1f7b76$var$_colors = /*#__PURE__*/ $b2740c4d1a1f7b76$var$_interop_require_default((parcelRequire("kxNAG")));

var $7rCZL = parcelRequire("7rCZL");

var $c0Win = parcelRequire("c0Win");

var $hTHBb = parcelRequire("hTHBb");

const $b2740c4d1a1f7b76$var$_isPlainObject = /*#__PURE__*/ $b2740c4d1a1f7b76$var$_interop_require_default((parcelRequire("7bcY9")));

var $egWYG = parcelRequire("egWYG");

var $13fOF = parcelRequire("13fOF");

var $13yIk = parcelRequire("13yIk");

const $b2740c4d1a1f7b76$var$_toColorValue = /*#__PURE__*/ $b2740c4d1a1f7b76$var$_interop_require_default((parcelRequire("6f4U1")));
function $b2740c4d1a1f7b76$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2740c4d1a1f7b76$var$isFunction(input) {
    return typeof input === "function";
}
function $b2740c4d1a1f7b76$var$mergeWith(target, ...sources) {
    let customizer = sources.pop();
    for (let source of sources)for(let k in source){
        let merged = customizer(target[k], source[k]);
        if (merged === undefined) {
            if ((0, $b2740c4d1a1f7b76$var$_isPlainObject.default)(target[k]) && (0, $b2740c4d1a1f7b76$var$_isPlainObject.default)(source[k])) target[k] = $b2740c4d1a1f7b76$var$mergeWith({}, target[k], source[k], customizer);
            else target[k] = source[k];
        } else target[k] = merged;
    }
    return target;
}
const $b2740c4d1a1f7b76$var$configUtils = {
    colors: $b2740c4d1a1f7b76$var$_colors.default,
    negative (scale) {
        // TODO: Log that this function isn't really needed anymore?
        return Object.keys(scale).filter((key)=>scale[key] !== "0").reduce((negativeScale, key)=>{
            let negativeValue = (0, $b2740c4d1a1f7b76$var$_negateValue.default)(scale[key]);
            if (negativeValue !== undefined) negativeScale[`-${key}`] = negativeValue;
            return negativeScale;
        }, {});
    },
    breakpoints (screens) {
        return Object.keys(screens).filter((key)=>typeof screens[key] === "string").reduce((breakpoints, key)=>({
                ...breakpoints,
                [`screen-${key}`]: screens[key]
            }), {});
    }
};
function $b2740c4d1a1f7b76$var$value(valueToResolve, ...args) {
    return $b2740c4d1a1f7b76$var$isFunction(valueToResolve) ? valueToResolve(...args) : valueToResolve;
}
function $b2740c4d1a1f7b76$var$collectExtends(items) {
    return items.reduce((merged, { extend: extend })=>{
        return $b2740c4d1a1f7b76$var$mergeWith(merged, extend, (mergedValue, extendValue)=>{
            if (mergedValue === undefined) return [
                extendValue
            ];
            if (Array.isArray(mergedValue)) return [
                extendValue,
                ...mergedValue
            ];
            return [
                extendValue,
                mergedValue
            ];
        });
    }, {});
}
function $b2740c4d1a1f7b76$var$mergeThemes(themes) {
    return {
        ...themes.reduce((merged, theme)=>(0, $7rCZL.defaults)(merged, theme), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: $b2740c4d1a1f7b76$var$collectExtends(themes)
    };
}
function $b2740c4d1a1f7b76$var$mergeExtensionCustomizer(merged, value) {
    // When we have an array of objects, we do want to merge it
    if (Array.isArray(merged) && (0, $b2740c4d1a1f7b76$var$_isPlainObject.default)(merged[0])) return merged.concat(value);
    // When the incoming value is an array, and the existing config is an object, prepend the existing object
    if (Array.isArray(value) && (0, $b2740c4d1a1f7b76$var$_isPlainObject.default)(value[0]) && (0, $b2740c4d1a1f7b76$var$_isPlainObject.default)(merged)) return [
        merged,
        ...value
    ];
    // Override arrays (for example for font-families, box-shadows, ...)
    if (Array.isArray(value)) return value;
    // Execute default behaviour
    return undefined;
}
function $b2740c4d1a1f7b76$var$mergeExtensions({ extend: extend, ...theme }) {
    return $b2740c4d1a1f7b76$var$mergeWith(theme, extend, (themeValue, extensions)=>{
        // The `extend` property is an array, so we need to check if it contains any functions
        if (!$b2740c4d1a1f7b76$var$isFunction(themeValue) && !extensions.some($b2740c4d1a1f7b76$var$isFunction)) return $b2740c4d1a1f7b76$var$mergeWith({}, themeValue, ...extensions, $b2740c4d1a1f7b76$var$mergeExtensionCustomizer);
        return (resolveThemePath, utils)=>$b2740c4d1a1f7b76$var$mergeWith({}, ...[
                themeValue,
                ...extensions
            ].map((e)=>$b2740c4d1a1f7b76$var$value(e, resolveThemePath, utils)), $b2740c4d1a1f7b76$var$mergeExtensionCustomizer);
    });
}
/**
 *
 * @param {string} key
 * @return {Iterable<string[] & {alpha: string | undefined}>}
 */ function* $b2740c4d1a1f7b76$var$toPaths(key) {
    let path = (0, $c0Win.toPath)(key);
    if (path.length === 0) return;
    yield path;
    if (Array.isArray(key)) return;
    let pattern = /^(.*?)\s*\/\s*([^/]+)$/;
    let matches = key.match(pattern);
    if (matches !== null) {
        let [, prefix, alpha] = matches;
        let newPath = (0, $c0Win.toPath)(prefix);
        newPath.alpha = alpha;
        yield newPath;
    }
}
function $b2740c4d1a1f7b76$var$resolveFunctionKeys(object) {
    // theme('colors.red.500 / 0.5') -> ['colors', 'red', '500 / 0', '5]
    const resolvePath = (key, defaultValue)=>{
        for (const path of $b2740c4d1a1f7b76$var$toPaths(key)){
            let index = 0;
            let val = object;
            while(val !== undefined && val !== null && index < path.length){
                val = val[path[index++]];
                let shouldResolveAsFn = $b2740c4d1a1f7b76$var$isFunction(val) && (path.alpha === undefined || index <= path.length - 1);
                val = shouldResolveAsFn ? val(resolvePath, $b2740c4d1a1f7b76$var$configUtils) : val;
            }
            if (val !== undefined) {
                if (path.alpha !== undefined) {
                    let normalized = (0, $13fOF.parseColorFormat)(val);
                    return (0, $13yIk.withAlphaValue)(normalized, path.alpha, (0, $b2740c4d1a1f7b76$var$_toColorValue.default)(normalized));
                }
                if ((0, $b2740c4d1a1f7b76$var$_isPlainObject.default)(val)) return (0, $egWYG.cloneDeep)(val);
                return val;
            }
        }
        return defaultValue;
    };
    Object.assign(resolvePath, {
        theme: resolvePath,
        ...$b2740c4d1a1f7b76$var$configUtils
    });
    return Object.keys(object).reduce((resolved, key)=>{
        resolved[key] = $b2740c4d1a1f7b76$var$isFunction(object[key]) ? object[key](resolvePath, $b2740c4d1a1f7b76$var$configUtils) : object[key];
        return resolved;
    }, {});
}
function $b2740c4d1a1f7b76$var$extractPluginConfigs(configs) {
    let allConfigs = [];
    configs.forEach((config)=>{
        allConfigs = [
            ...allConfigs,
            config
        ];
        var _config_plugins;
        const plugins = (_config_plugins = config === null || config === void 0 ? void 0 : config.plugins) !== null && _config_plugins !== void 0 ? _config_plugins : [];
        if (plugins.length === 0) return;
        plugins.forEach((plugin)=>{
            if (plugin.__isOptionsFunction) plugin = plugin();
            var _plugin_config;
            allConfigs = [
                ...allConfigs,
                ...$b2740c4d1a1f7b76$var$extractPluginConfigs([
                    (_plugin_config = plugin === null || plugin === void 0 ? void 0 : plugin.config) !== null && _plugin_config !== void 0 ? _plugin_config : {}
                ])
            ];
        });
    });
    return allConfigs;
}
function $b2740c4d1a1f7b76$var$resolveCorePlugins(corePluginConfigs) {
    const result = [
        ...corePluginConfigs
    ].reduceRight((resolved, corePluginConfig)=>{
        if ($b2740c4d1a1f7b76$var$isFunction(corePluginConfig)) return corePluginConfig({
            corePlugins: resolved
        });
        return (0, $b2740c4d1a1f7b76$var$_configurePlugins.default)(corePluginConfig, resolved);
    }, $b2740c4d1a1f7b76$var$_corePluginList.default);
    return result;
}
function $b2740c4d1a1f7b76$var$resolvePluginLists(pluginLists) {
    const result = [
        ...pluginLists
    ].reduceRight((resolved, pluginList)=>{
        return [
            ...resolved,
            ...pluginList
        ];
    }, []);
    return result;
}
function $b2740c4d1a1f7b76$var$resolveConfig(configs) {
    let allConfigs = [
        ...$b2740c4d1a1f7b76$var$extractPluginConfigs(configs),
        {
            prefix: "",
            important: false,
            separator: ":"
        }
    ];
    var _t_theme, _c_plugins;
    return (0, $hTHBb.normalizeConfig)((0, $7rCZL.defaults)({
        theme: $b2740c4d1a1f7b76$var$resolveFunctionKeys($b2740c4d1a1f7b76$var$mergeExtensions($b2740c4d1a1f7b76$var$mergeThemes(allConfigs.map((t)=>{
            return (_t_theme = t === null || t === void 0 ? void 0 : t.theme) !== null && _t_theme !== void 0 ? _t_theme : {};
        })))),
        corePlugins: $b2740c4d1a1f7b76$var$resolveCorePlugins(allConfigs.map((c)=>c.corePlugins)),
        plugins: $b2740c4d1a1f7b76$var$resolvePluginLists(configs.map((c)=>{
            return (_c_plugins = c === null || c === void 0 ? void 0 : c.plugins) !== null && _c_plugins !== void 0 ? _c_plugins : [];
        }))
    }, ...allConfigs));
}

});
parcelRegister("kkOiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ecdcb210e936f242$var$negateValue;
    }
});
function $ecdcb210e936f242$var$negateValue(value) {
    value = `${value}`;
    if (value === "0") return "0";
    // Flip sign of numbers
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(value)) return value.replace(/^[+-]?/, (sign)=>sign === "-" ? "" : "-");
    // What functions we support negating numeric values for
    // var() isn't inherently a numeric function but we support it anyway
    // The trigonometric functions are omitted because you'll need to use calc(…) with them _anyway_
    // to produce generally useful results and that will be covered already
    let numericFunctions = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
    ];
    for (const fn of numericFunctions){
        if (value.includes(`${fn}(`)) return `calc(${value} * -1)`;
    }
}

});

parcelRegister("bRPdA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8a3c5fd26d34ea4c$var$_default;
    }
});
const $8a3c5fd26d34ea4c$var$_default = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "size",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "textWrap",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "contain",
    "content",
    "forcedColorAdjust"
];

});

parcelRegister("51lYh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3a7e16c973f2308a$var$_default;
    }
});
function $3a7e16c973f2308a$var$_default(pluginConfig, plugins) {
    if (pluginConfig === undefined) return plugins;
    const pluginNames = Array.isArray(pluginConfig) ? pluginConfig : [
        ...new Set(plugins.filter((pluginName)=>{
            return pluginConfig !== false && pluginConfig[pluginName] !== false;
        }).concat(Object.keys(pluginConfig).filter((pluginName)=>{
            return pluginConfig[pluginName] !== false;
        })))
    ];
    return pluginNames;
}

});

parcelRegister("kxNAG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ef4d5b5d64805235$var$_default;
    }
});

const $ef4d5b5d64805235$var$_log = /*#__PURE__*/ $ef4d5b5d64805235$var$_interop_require_default((parcelRequire("eiBF2")));
function $ef4d5b5d64805235$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef4d5b5d64805235$var$warn({ version: version, from: from, to: to }) {
    $ef4d5b5d64805235$var$_log.default.warn(`${from}-color-renamed`, [
        `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
        "Update your configuration file to silence this warning."
    ]);
}
const $ef4d5b5d64805235$var$_default = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
    },
    gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
    },
    zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
    },
    neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
    },
    stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
    },
    red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
    },
    teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
    },
    sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
    },
    get lightBlue () {
        $ef4d5b5d64805235$var$warn({
            version: "v2.2",
            from: "lightBlue",
            to: "sky"
        });
        return this.sky;
    },
    get warmGray () {
        $ef4d5b5d64805235$var$warn({
            version: "v3.0",
            from: "warmGray",
            to: "stone"
        });
        return this.stone;
    },
    get trueGray () {
        $ef4d5b5d64805235$var$warn({
            version: "v3.0",
            from: "trueGray",
            to: "neutral"
        });
        return this.neutral;
    },
    get coolGray () {
        $ef4d5b5d64805235$var$warn({
            version: "v3.0",
            from: "coolGray",
            to: "gray"
        });
        return this.gray;
    },
    get blueGray () {
        $ef4d5b5d64805235$var$warn({
            version: "v3.0",
            from: "blueGray",
            to: "slate"
        });
        return this.slate;
    }
};

});
parcelRegister("eiBF2", function(module, exports) {

var $8fUyZ = parcelRequire("8fUyZ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a68ff5cfc7b1da06$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$a68ff5cfc7b1da06$var$_export(module.exports, {
    dim: function() {
        return $a68ff5cfc7b1da06$var$dim;
    },
    default: function() {
        return $a68ff5cfc7b1da06$var$_default;
    }
});

const $a68ff5cfc7b1da06$var$_picocolors = /*#__PURE__*/ $a68ff5cfc7b1da06$var$_interop_require_default((parcelRequire("9nBeH")));
function $a68ff5cfc7b1da06$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $a68ff5cfc7b1da06$var$alreadyShown = new Set();
function $a68ff5cfc7b1da06$var$log(type, messages, key) {
    typeof $8fUyZ !== "undefined" && undefined;
    if (key && $a68ff5cfc7b1da06$var$alreadyShown.has(key)) return;
    if (key) $a68ff5cfc7b1da06$var$alreadyShown.add(key);
    console.warn("");
    messages.forEach((message)=>console.warn(type, "-", message));
}
function $a68ff5cfc7b1da06$var$dim(input) {
    return $a68ff5cfc7b1da06$var$_picocolors.default.dim(input);
}
const $a68ff5cfc7b1da06$var$_default = {
    info (key, messages) {
        $a68ff5cfc7b1da06$var$log($a68ff5cfc7b1da06$var$_picocolors.default.bold($a68ff5cfc7b1da06$var$_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    warn (key, messages) {
        $a68ff5cfc7b1da06$var$log($a68ff5cfc7b1da06$var$_picocolors.default.bold($a68ff5cfc7b1da06$var$_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    risk (key, messages) {
        $a68ff5cfc7b1da06$var$log($a68ff5cfc7b1da06$var$_picocolors.default.bold($a68ff5cfc7b1da06$var$_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    }
};

});
parcelRegister("9nBeH", function(module, exports) {
var $6d43255efc2e2a9f$var$x = String;
var $6d43255efc2e2a9f$var$create = function() {
    return {
        isColorSupported: false,
        reset: $6d43255efc2e2a9f$var$x,
        bold: $6d43255efc2e2a9f$var$x,
        dim: $6d43255efc2e2a9f$var$x,
        italic: $6d43255efc2e2a9f$var$x,
        underline: $6d43255efc2e2a9f$var$x,
        inverse: $6d43255efc2e2a9f$var$x,
        hidden: $6d43255efc2e2a9f$var$x,
        strikethrough: $6d43255efc2e2a9f$var$x,
        black: $6d43255efc2e2a9f$var$x,
        red: $6d43255efc2e2a9f$var$x,
        green: $6d43255efc2e2a9f$var$x,
        yellow: $6d43255efc2e2a9f$var$x,
        blue: $6d43255efc2e2a9f$var$x,
        magenta: $6d43255efc2e2a9f$var$x,
        cyan: $6d43255efc2e2a9f$var$x,
        white: $6d43255efc2e2a9f$var$x,
        gray: $6d43255efc2e2a9f$var$x,
        bgBlack: $6d43255efc2e2a9f$var$x,
        bgRed: $6d43255efc2e2a9f$var$x,
        bgGreen: $6d43255efc2e2a9f$var$x,
        bgYellow: $6d43255efc2e2a9f$var$x,
        bgBlue: $6d43255efc2e2a9f$var$x,
        bgMagenta: $6d43255efc2e2a9f$var$x,
        bgCyan: $6d43255efc2e2a9f$var$x,
        bgWhite: $6d43255efc2e2a9f$var$x
    };
};
module.exports = $6d43255efc2e2a9f$var$create();
module.exports.createColors = $6d43255efc2e2a9f$var$create;

});



parcelRegister("7rCZL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "defaults", {
    enumerable: true,
    get: function() {
        return $56b94da3365b2632$var$defaults;
    }
});
function $56b94da3365b2632$var$defaults(target, ...sources) {
    for (let source of sources){
        for(let k in source){
            var _target_hasOwnProperty;
            if (!(target === null || target === void 0 ? void 0 : (_target_hasOwnProperty = target.hasOwnProperty) === null || _target_hasOwnProperty === void 0 ? void 0 : _target_hasOwnProperty.call(target, k))) target[k] = source[k];
        }
        for (let k of Object.getOwnPropertySymbols(source)){
            var _target_hasOwnProperty1;
            if (!(target === null || target === void 0 ? void 0 : (_target_hasOwnProperty1 = target.hasOwnProperty) === null || _target_hasOwnProperty1 === void 0 ? void 0 : _target_hasOwnProperty1.call(target, k))) target[k] = source[k];
        }
    }
    return target;
}

});

parcelRegister("c0Win", function(module, exports) {
/**
 * Parse a path string into an array of path segments.
 *
 * Square bracket notation `a[b]` may be used to "escape" dots that would otherwise be interpreted as path separators.
 *
 * Example:
 * a -> ['a']
 * a.b.c -> ['a', 'b', 'c']
 * a[b].c -> ['a', 'b', 'c']
 * a[b.c].e.f -> ['a', 'b.c', 'e', 'f']
 * a[b][c][d] -> ['a', 'b', 'c', 'd']
 *
 * @param {string|string[]} path
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "toPath", {
    enumerable: true,
    get: function() {
        return $8bf2b45cede859e4$var$toPath;
    }
});
function $8bf2b45cede859e4$var$toPath(path) {
    if (Array.isArray(path)) return path;
    let openBrackets = path.split("[").length - 1;
    let closedBrackets = path.split("]").length - 1;
    if (openBrackets !== closedBrackets) throw new Error(`Path is invalid. Has unbalanced brackets: ${path}`);
    return path.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
}

});

parcelRegister("hTHBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "normalizeConfig", {
    enumerable: true,
    get: function() {
        return $d0796489debad535$var$normalizeConfig;
    }
});

var $5UX1h = parcelRequire("5UX1h");

const $d0796489debad535$var$_log = /*#__PURE__*/ $d0796489debad535$var$_interop_require_wildcard((parcelRequire("eiBF2")));
function $d0796489debad535$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d0796489debad535$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d0796489debad535$var$_interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d0796489debad535$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d0796489debad535$var$normalizeConfig(config) {
    // Quick structure validation
    /**
   * type FilePath = string
   * type RawFile = { raw: string, extension?: string }
   * type ExtractorFn = (content: string) => Array<string>
   * type TransformerFn = (content: string) => string
   *
   * type Content =
   *   | Array<FilePath | RawFile>
   *   | {
   *       files: Array<FilePath | RawFile>,
   *       extract?: ExtractorFn | { [extension: string]: ExtractorFn }
   *       transform?: TransformerFn | { [extension: string]: TransformerFn }
   *   }
   */ let valid = (()=>{
        // `config.purge` should not exist anymore
        if (config.purge) return false;
        // `config.content` should exist
        if (!config.content) return false;
        // `config.content` should be an object or an array
        if (!Array.isArray(config.content) && !(typeof config.content === "object" && config.content !== null)) return false;
        // When `config.content` is an array, it should consist of FilePaths or RawFiles
        if (Array.isArray(config.content)) return config.content.every((path)=>{
            // `path` can be a string
            if (typeof path === "string") return true;
            // `path` can be an object { raw: string, extension?: string }
            // `raw` must be a string
            if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== "string") return false;
            // `extension` (if provided) should also be a string
            if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== "string") return false;
            return true;
        });
        // When `config.content` is an object
        if (typeof config.content === "object" && config.content !== null) {
            // Only `files`, `relative`, `extract`, and `transform` can exist in `config.content`
            if (Object.keys(config.content).some((key)=>![
                    "files",
                    "relative",
                    "extract",
                    "transform"
                ].includes(key))) return false;
            // `config.content.files` should exist of FilePaths or RawFiles
            if (Array.isArray(config.content.files)) {
                if (!config.content.files.every((path)=>{
                    // `path` can be a string
                    if (typeof path === "string") return true;
                    // `path` can be an object { raw: string, extension?: string }
                    // `raw` must be a string
                    if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== "string") return false;
                    // `extension` (if provided) should also be a string
                    if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== "string") return false;
                    return true;
                })) return false;
                // `config.content.extract` is optional, and can be a Function or a Record<String, Function>
                if (typeof config.content.extract === "object") for (let value of Object.values(config.content.extract)){
                    if (typeof value !== "function") return false;
                }
                else if (!(config.content.extract === undefined || typeof config.content.extract === "function")) return false;
                // `config.content.transform` is optional, and can be a Function or a Record<String, Function>
                if (typeof config.content.transform === "object") for (let value of Object.values(config.content.transform)){
                    if (typeof value !== "function") return false;
                }
                else if (!(config.content.transform === undefined || typeof config.content.transform === "function")) return false;
                // `config.content.relative` is optional and can be a boolean
                if (typeof config.content.relative !== "boolean" && typeof config.content.relative !== "undefined") return false;
            }
            return true;
        }
        return false;
    })();
    if (!valid) $d0796489debad535$var$_log.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]);
    // Normalize the `safelist`
    config.safelist = (()=>{
        var _purge_options;
        let { content: content, purge: purge, safelist: safelist } = config;
        if (Array.isArray(safelist)) return safelist;
        if (Array.isArray(content === null || content === void 0 ? void 0 : content.safelist)) return content.safelist;
        if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.safelist)) return purge.safelist;
        if (Array.isArray(purge === null || purge === void 0 ? void 0 : (_purge_options = purge.options) === null || _purge_options === void 0 ? void 0 : _purge_options.safelist)) return purge.options.safelist;
        return [];
    })();
    // Normalize the `blocklist`
    config.blocklist = (()=>{
        let { blocklist: blocklist } = config;
        if (Array.isArray(blocklist)) {
            if (blocklist.every((item)=>typeof item === "string")) return blocklist;
            $d0796489debad535$var$_log.default.warn("blocklist-invalid", [
                "The `blocklist` option must be an array of strings.",
                "https://tailwindcss.com/docs/content-configuration#discarding-classes"
            ]);
        }
        return [];
    })();
    // Normalize prefix option
    if (typeof config.prefix === "function") {
        $d0796489debad535$var$_log.default.warn("prefix-function", [
            "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
            "Update `prefix` in your configuration to be a string to eliminate this warning.",
            "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]);
        config.prefix = "";
    } else {
        var _config_prefix;
        config.prefix = (_config_prefix = config.prefix) !== null && _config_prefix !== void 0 ? _config_prefix : "";
    }
    // Normalize the `content`
    config.content = {
        relative: (()=>{
            let { content: content } = config;
            if (content === null || content === void 0 ? void 0 : content.relative) return content.relative;
            return (0, $5UX1h.flagEnabled)(config, "relativeContentPathsByDefault");
        })(),
        files: (()=>{
            let { content: content, purge: purge } = config;
            if (Array.isArray(purge)) return purge;
            if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.content)) return purge.content;
            if (Array.isArray(content)) return content;
            if (Array.isArray(content === null || content === void 0 ? void 0 : content.content)) return content.content;
            if (Array.isArray(content === null || content === void 0 ? void 0 : content.files)) return content.files;
            return [];
        })(),
        extract: (()=>{
            let extract = (()=>{
                var _config_purge, _config_content, _config_purge1, _config_purge_extract, _config_content1, _config_content_extract, _config_purge2, _config_purge_options, _config_content2, _config_content_options;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : _config_purge.extract) return config.purge.extract;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : _config_content.extract) return config.content.extract;
                if ((_config_purge1 = config.purge) === null || _config_purge1 === void 0 ? void 0 : (_config_purge_extract = _config_purge1.extract) === null || _config_purge_extract === void 0 ? void 0 : _config_purge_extract.DEFAULT) return config.purge.extract.DEFAULT;
                if ((_config_content1 = config.content) === null || _config_content1 === void 0 ? void 0 : (_config_content_extract = _config_content1.extract) === null || _config_content_extract === void 0 ? void 0 : _config_content_extract.DEFAULT) return config.content.extract.DEFAULT;
                if ((_config_purge2 = config.purge) === null || _config_purge2 === void 0 ? void 0 : (_config_purge_options = _config_purge2.options) === null || _config_purge_options === void 0 ? void 0 : _config_purge_options.extractors) return config.purge.options.extractors;
                if ((_config_content2 = config.content) === null || _config_content2 === void 0 ? void 0 : (_config_content_options = _config_content2.options) === null || _config_content_options === void 0 ? void 0 : _config_content_options.extractors) return config.content.options.extractors;
                return {};
            })();
            let extractors = {};
            let defaultExtractor = (()=>{
                var _config_purge, _config_purge_options, _config_content, _config_content_options;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : (_config_purge_options = _config_purge.options) === null || _config_purge_options === void 0 ? void 0 : _config_purge_options.defaultExtractor) return config.purge.options.defaultExtractor;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : (_config_content_options = _config_content.options) === null || _config_content_options === void 0 ? void 0 : _config_content_options.defaultExtractor) return config.content.options.defaultExtractor;
                return undefined;
            })();
            if (defaultExtractor !== undefined) extractors.DEFAULT = defaultExtractor;
            // Functions
            if (typeof extract === "function") extractors.DEFAULT = extract;
            else if (Array.isArray(extract)) {
                for (let { extensions: extensions, extractor: extractor } of extract !== null && extract !== void 0 ? extract : [])for (let extension of extensions)extractors[extension] = extractor;
            } else if (typeof extract === "object" && extract !== null) Object.assign(extractors, extract);
            return extractors;
        })(),
        transform: (()=>{
            let transform = (()=>{
                var _config_purge, _config_content, _config_purge1, _config_purge_transform, _config_content1, _config_content_transform;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : _config_purge.transform) return config.purge.transform;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : _config_content.transform) return config.content.transform;
                if ((_config_purge1 = config.purge) === null || _config_purge1 === void 0 ? void 0 : (_config_purge_transform = _config_purge1.transform) === null || _config_purge_transform === void 0 ? void 0 : _config_purge_transform.DEFAULT) return config.purge.transform.DEFAULT;
                if ((_config_content1 = config.content) === null || _config_content1 === void 0 ? void 0 : (_config_content_transform = _config_content1.transform) === null || _config_content_transform === void 0 ? void 0 : _config_content_transform.DEFAULT) return config.content.transform.DEFAULT;
                return {};
            })();
            let transformers = {};
            if (typeof transform === "function") transformers.DEFAULT = transform;
            if (typeof transform === "object" && transform !== null) Object.assign(transformers, transform);
            return transformers;
        })()
    };
    // Validate globs to prevent bogus globs.
    // E.g.: `./src/*.{html}` is invalid, the `{html}` should just be `html`
    for (let file of config.content.files)if (typeof file === "string" && /{([^,]*?)}/g.test(file)) {
        $d0796489debad535$var$_log.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, $d0796489debad535$var$_log.dim)(file)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, $d0796489debad535$var$_log.dim)(file.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
    }
    return config;
}

});
parcelRegister("5UX1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $44eff6c2d547903c$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$44eff6c2d547903c$var$_export(module.exports, {
    flagEnabled: function() {
        return $44eff6c2d547903c$var$flagEnabled;
    },
    issueFlagNotices: function() {
        return $44eff6c2d547903c$var$issueFlagNotices;
    },
    default: function() {
        return $44eff6c2d547903c$var$_default;
    }
});

const $44eff6c2d547903c$var$_picocolors = /*#__PURE__*/ $44eff6c2d547903c$var$_interop_require_default((parcelRequire("9nBeH")));

const $44eff6c2d547903c$var$_log = /*#__PURE__*/ $44eff6c2d547903c$var$_interop_require_default((parcelRequire("eiBF2")));
function $44eff6c2d547903c$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $44eff6c2d547903c$var$defaults = {
    optimizeUniversalDefaults: false,
    generalizedModifiers: true,
    disableColorOpacityUtilitiesByDefault: false,
    relativeContentPathsByDefault: false
};
let $44eff6c2d547903c$var$featureFlags = {
    future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
    ],
    experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
    ]
};
function $44eff6c2d547903c$var$flagEnabled(config, flag) {
    if ($44eff6c2d547903c$var$featureFlags.future.includes(flag)) {
        var _config_future;
        var _config_future_flag, _ref;
        return config.future === "all" || ((_ref = (_config_future_flag = config === null || config === void 0 ? void 0 : (_config_future = config.future) === null || _config_future === void 0 ? void 0 : _config_future[flag]) !== null && _config_future_flag !== void 0 ? _config_future_flag : $44eff6c2d547903c$var$defaults[flag]) !== null && _ref !== void 0 ? _ref : false);
    }
    if ($44eff6c2d547903c$var$featureFlags.experimental.includes(flag)) {
        var _config_experimental;
        var _config_experimental_flag, _ref1;
        return config.experimental === "all" || ((_ref1 = (_config_experimental_flag = config === null || config === void 0 ? void 0 : (_config_experimental = config.experimental) === null || _config_experimental === void 0 ? void 0 : _config_experimental[flag]) !== null && _config_experimental_flag !== void 0 ? _config_experimental_flag : $44eff6c2d547903c$var$defaults[flag]) !== null && _ref1 !== void 0 ? _ref1 : false);
    }
    return false;
}
function $44eff6c2d547903c$var$experimentalFlagsEnabled(config) {
    if (config.experimental === "all") return $44eff6c2d547903c$var$featureFlags.experimental;
    var _config_experimental;
    return Object.keys((_config_experimental = config === null || config === void 0 ? void 0 : config.experimental) !== null && _config_experimental !== void 0 ? _config_experimental : {}).filter((flag)=>$44eff6c2d547903c$var$featureFlags.experimental.includes(flag) && config.experimental[flag]);
}
function $44eff6c2d547903c$var$issueFlagNotices(config) {
    if ($44eff6c2d547903c$var$experimentalFlagsEnabled(config).length > 0) {
        let changes = $44eff6c2d547903c$var$experimentalFlagsEnabled(config).map((s)=>$44eff6c2d547903c$var$_picocolors.default.yellow(s)).join(", ");
        $44eff6c2d547903c$var$_log.default.warn("experimental-flags-enabled", [
            `You have enabled experimental features: ${changes}`,
            "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
    }
}
const $44eff6c2d547903c$var$_default = $44eff6c2d547903c$var$featureFlags;

});


parcelRegister("7bcY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $53a39ee950246c3b$var$isPlainObject;
    }
});
function $53a39ee950246c3b$var$isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || Object.getPrototypeOf(prototype) === null;
}

});

parcelRegister("egWYG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "cloneDeep", {
    enumerable: true,
    get: function() {
        return $a6404f13bdc6afe8$var$cloneDeep;
    }
});
function $a6404f13bdc6afe8$var$cloneDeep(value) {
    if (Array.isArray(value)) return value.map((child)=>$a6404f13bdc6afe8$var$cloneDeep(child));
    if (typeof value === "object" && value !== null) return Object.fromEntries(Object.entries(value).map(([k, v])=>[
            k,
            $a6404f13bdc6afe8$var$cloneDeep(v)
        ]));
    return value;
}

});

parcelRegister("13fOF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $0c42570d5f8f1bdf$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$0c42570d5f8f1bdf$var$_export(module.exports, {
    updateAllClasses: function() {
        return $0c42570d5f8f1bdf$var$updateAllClasses;
    },
    asValue: function() {
        return $0c42570d5f8f1bdf$var$asValue;
    },
    parseColorFormat: function() {
        return $0c42570d5f8f1bdf$var$parseColorFormat;
    },
    asColor: function() {
        return $0c42570d5f8f1bdf$var$asColor;
    },
    asLookupValue: function() {
        return $0c42570d5f8f1bdf$var$asLookupValue;
    },
    typeMap: function() {
        return $0c42570d5f8f1bdf$var$typeMap;
    },
    coerceValue: function() {
        return $0c42570d5f8f1bdf$var$coerceValue;
    },
    getMatchingTypes: function() {
        return $0c42570d5f8f1bdf$var$getMatchingTypes;
    }
});

const $0c42570d5f8f1bdf$var$_escapeCommas = /*#__PURE__*/ $0c42570d5f8f1bdf$var$_interop_require_default((parcelRequire("68UpC")));

var $13yIk = parcelRequire("13yIk");

var $5WKeE = parcelRequire("5WKeE");

const $0c42570d5f8f1bdf$var$_negateValue = /*#__PURE__*/ $0c42570d5f8f1bdf$var$_interop_require_default((parcelRequire("kkOiR")));

var $j7hpL = parcelRequire("j7hpL");

var $5UX1h = parcelRequire("5UX1h");
function $0c42570d5f8f1bdf$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0c42570d5f8f1bdf$var$updateAllClasses(selectors, updateClass) {
    selectors.walkClasses((sel)=>{
        sel.value = updateClass(sel.value);
        if (sel.raws && sel.raws.value) sel.raws.value = (0, $0c42570d5f8f1bdf$var$_escapeCommas.default)(sel.raws.value);
    });
}
function $0c42570d5f8f1bdf$var$resolveArbitraryValue(modifier, validate) {
    if (!$0c42570d5f8f1bdf$var$isArbitraryValue(modifier)) return undefined;
    let value = modifier.slice(1, -1);
    if (!validate(value)) return undefined;
    return (0, $5WKeE.normalize)(value);
}
function $0c42570d5f8f1bdf$var$asNegativeValue(modifier, lookup = {}, validate) {
    let positiveValue = lookup[modifier];
    if (positiveValue !== undefined) return (0, $0c42570d5f8f1bdf$var$_negateValue.default)(positiveValue);
    if ($0c42570d5f8f1bdf$var$isArbitraryValue(modifier)) {
        let resolved = $0c42570d5f8f1bdf$var$resolveArbitraryValue(modifier, validate);
        if (resolved === undefined) return undefined;
        return (0, $0c42570d5f8f1bdf$var$_negateValue.default)(resolved);
    }
}
function $0c42570d5f8f1bdf$var$asValue(modifier, options = {}, { validate: validate = ()=>true } = {}) {
    var _options_values;
    let value = (_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier];
    if (value !== undefined) return value;
    if (options.supportsNegativeValues && modifier.startsWith("-")) return $0c42570d5f8f1bdf$var$asNegativeValue(modifier.slice(1), options.values, validate);
    return $0c42570d5f8f1bdf$var$resolveArbitraryValue(modifier, validate);
}
function $0c42570d5f8f1bdf$var$isArbitraryValue(input) {
    return input.startsWith("[") && input.endsWith("]");
}
function $0c42570d5f8f1bdf$var$splitUtilityModifier(modifier) {
    let slashIdx = modifier.lastIndexOf("/");
    // If the `/` is inside an arbitrary, we want to find the previous one if any
    // This logic probably isn't perfect but it should work for most cases
    let arbitraryStartIdx = modifier.lastIndexOf("[", slashIdx);
    let arbitraryEndIdx = modifier.indexOf("]", slashIdx);
    let isNextToArbitrary = modifier[slashIdx - 1] === "]" || modifier[slashIdx + 1] === "[";
    // Backtrack to the previous `/` if the one we found was inside an arbitrary
    if (!isNextToArbitrary) {
        if (arbitraryStartIdx !== -1 && arbitraryEndIdx !== -1) {
            if (arbitraryStartIdx < slashIdx && slashIdx < arbitraryEndIdx) slashIdx = modifier.lastIndexOf("/", arbitraryStartIdx);
        }
    }
    if (slashIdx === -1 || slashIdx === modifier.length - 1) return [
        modifier,
        undefined
    ];
    let arbitrary = $0c42570d5f8f1bdf$var$isArbitraryValue(modifier);
    // The modifier could be of the form `[foo]/[bar]`
    // We want to handle this case properly
    // without affecting `[foo/bar]`
    if (arbitrary && !modifier.includes("]/[")) return [
        modifier,
        undefined
    ];
    return [
        modifier.slice(0, slashIdx),
        modifier.slice(slashIdx + 1)
    ];
}
function $0c42570d5f8f1bdf$var$parseColorFormat(value) {
    if (typeof value === "string" && value.includes("<alpha-value>")) {
        let oldValue = value;
        return ({ opacityValue: opacityValue = 1 })=>oldValue.replace("<alpha-value>", opacityValue);
    }
    return value;
}
function $0c42570d5f8f1bdf$var$unwrapArbitraryModifier(modifier) {
    return (0, $5WKeE.normalize)(modifier.slice(1, -1));
}
function $0c42570d5f8f1bdf$var$asColor(modifier, options = {}, { tailwindConfig: tailwindConfig = {} } = {}) {
    var _options_values;
    if (((_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier]) !== undefined) {
        var _options_values1;
        return $0c42570d5f8f1bdf$var$parseColorFormat((_options_values1 = options.values) === null || _options_values1 === void 0 ? void 0 : _options_values1[modifier]);
    }
    // TODO: Hoist this up to getMatchingTypes or something
    // We do this here because we need the alpha value (if any)
    let [color, alpha] = $0c42570d5f8f1bdf$var$splitUtilityModifier(modifier);
    if (alpha !== undefined) {
        var _options_values2, _tailwindConfig_theme, _tailwindConfig_theme_opacity;
        var _options_values_color;
        let normalizedColor = (_options_values_color = (_options_values2 = options.values) === null || _options_values2 === void 0 ? void 0 : _options_values2[color]) !== null && _options_values_color !== void 0 ? _options_values_color : $0c42570d5f8f1bdf$var$isArbitraryValue(color) ? color.slice(1, -1) : undefined;
        if (normalizedColor === undefined) return undefined;
        normalizedColor = $0c42570d5f8f1bdf$var$parseColorFormat(normalizedColor);
        if ($0c42570d5f8f1bdf$var$isArbitraryValue(alpha)) return (0, $13yIk.withAlphaValue)(normalizedColor, $0c42570d5f8f1bdf$var$unwrapArbitraryModifier(alpha));
        if (((_tailwindConfig_theme = tailwindConfig.theme) === null || _tailwindConfig_theme === void 0 ? void 0 : (_tailwindConfig_theme_opacity = _tailwindConfig_theme.opacity) === null || _tailwindConfig_theme_opacity === void 0 ? void 0 : _tailwindConfig_theme_opacity[alpha]) === undefined) return undefined;
        return (0, $13yIk.withAlphaValue)(normalizedColor, tailwindConfig.theme.opacity[alpha]);
    }
    return $0c42570d5f8f1bdf$var$asValue(modifier, options, {
        validate: $5WKeE.color
    });
}
function $0c42570d5f8f1bdf$var$asLookupValue(modifier, options = {}) {
    var _options_values;
    return (_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier];
}
function $0c42570d5f8f1bdf$var$guess(validate) {
    return (modifier, options)=>{
        return $0c42570d5f8f1bdf$var$asValue(modifier, options, {
            validate: validate
        });
    };
}
let $0c42570d5f8f1bdf$var$typeMap = {
    any: $0c42570d5f8f1bdf$var$asValue,
    color: $0c42570d5f8f1bdf$var$asColor,
    url: $0c42570d5f8f1bdf$var$guess($5WKeE.url),
    image: $0c42570d5f8f1bdf$var$guess($5WKeE.image),
    length: $0c42570d5f8f1bdf$var$guess($5WKeE.length),
    percentage: $0c42570d5f8f1bdf$var$guess($5WKeE.percentage),
    position: $0c42570d5f8f1bdf$var$guess($5WKeE.position),
    lookup: $0c42570d5f8f1bdf$var$asLookupValue,
    "generic-name": $0c42570d5f8f1bdf$var$guess($5WKeE.genericName),
    "family-name": $0c42570d5f8f1bdf$var$guess($5WKeE.familyName),
    number: $0c42570d5f8f1bdf$var$guess($5WKeE.number),
    "line-width": $0c42570d5f8f1bdf$var$guess($5WKeE.lineWidth),
    "absolute-size": $0c42570d5f8f1bdf$var$guess($5WKeE.absoluteSize),
    "relative-size": $0c42570d5f8f1bdf$var$guess($5WKeE.relativeSize),
    shadow: $0c42570d5f8f1bdf$var$guess($5WKeE.shadow),
    size: $0c42570d5f8f1bdf$var$guess($j7hpL.backgroundSize)
};
let $0c42570d5f8f1bdf$var$supportedTypes = Object.keys($0c42570d5f8f1bdf$var$typeMap);
function $0c42570d5f8f1bdf$var$splitAtFirst(input, delim) {
    let idx = input.indexOf(delim);
    if (idx === -1) return [
        undefined,
        input
    ];
    return [
        input.slice(0, idx),
        input.slice(idx + 1)
    ];
}
function $0c42570d5f8f1bdf$var$coerceValue(types, modifier, options, tailwindConfig) {
    if (options.values && modifier in options.values) for (let { type: type } of types !== null && types !== void 0 ? types : []){
        let result = $0c42570d5f8f1bdf$var$typeMap[type](modifier, options, {
            tailwindConfig: tailwindConfig
        });
        if (result === undefined) continue;
        return [
            result,
            type,
            null
        ];
    }
    if ($0c42570d5f8f1bdf$var$isArbitraryValue(modifier)) {
        let arbitraryValue = modifier.slice(1, -1);
        let [explicitType, value] = $0c42570d5f8f1bdf$var$splitAtFirst(arbitraryValue, ":");
        // It could be that this resolves to `url(https` which is not a valid
        // identifier. We currently only support "simple" words with dashes or
        // underscores. E.g.: family-name
        if (!/^[\w-_]+$/g.test(explicitType)) value = arbitraryValue;
        else if (explicitType !== undefined && !$0c42570d5f8f1bdf$var$supportedTypes.includes(explicitType)) return [];
        if (value.length > 0 && $0c42570d5f8f1bdf$var$supportedTypes.includes(explicitType)) return [
            $0c42570d5f8f1bdf$var$asValue(`[${value}]`, options),
            explicitType,
            null
        ];
    }
    let matches = $0c42570d5f8f1bdf$var$getMatchingTypes(types, modifier, options, tailwindConfig);
    // Find first matching type
    for (let match of matches)return match;
    return [];
}
function* $0c42570d5f8f1bdf$var$getMatchingTypes(types, rawModifier, options, tailwindConfig) {
    let modifiersEnabled = (0, $5UX1h.flagEnabled)(tailwindConfig, "generalizedModifiers");
    let [modifier, utilityModifier] = $0c42570d5f8f1bdf$var$splitUtilityModifier(rawModifier);
    let canUseUtilityModifier = modifiersEnabled && options.modifiers != null && (options.modifiers === "any" || typeof options.modifiers === "object" && (utilityModifier && $0c42570d5f8f1bdf$var$isArbitraryValue(utilityModifier) || utilityModifier in options.modifiers));
    if (!canUseUtilityModifier) {
        modifier = rawModifier;
        utilityModifier = undefined;
    }
    if (utilityModifier !== undefined && modifier === "") modifier = "DEFAULT";
    // Check the full value first
    // TODO: Move to asValue… somehow
    if (utilityModifier !== undefined) {
        if (typeof options.modifiers === "object") {
            var _options_modifiers;
            var _options_modifiers_utilityModifier;
            let configValue = (_options_modifiers_utilityModifier = (_options_modifiers = options.modifiers) === null || _options_modifiers === void 0 ? void 0 : _options_modifiers[utilityModifier]) !== null && _options_modifiers_utilityModifier !== void 0 ? _options_modifiers_utilityModifier : null;
            if (configValue !== null) utilityModifier = configValue;
            else if ($0c42570d5f8f1bdf$var$isArbitraryValue(utilityModifier)) utilityModifier = $0c42570d5f8f1bdf$var$unwrapArbitraryModifier(utilityModifier);
        }
    }
    for (let { type: type } of types !== null && types !== void 0 ? types : []){
        let result = $0c42570d5f8f1bdf$var$typeMap[type](modifier, options, {
            tailwindConfig: tailwindConfig
        });
        if (result === undefined) continue;
        yield [
            result,
            type,
            utilityModifier !== null && utilityModifier !== void 0 ? utilityModifier : null
        ];
    }
}

});
parcelRegister("68UpC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $478f3fbd82bbe607$var$escapeCommas;
    }
});
function $478f3fbd82bbe607$var$escapeCommas(className) {
    return className.replace(/\\,/g, "\\2c ");
}

});

parcelRegister("13yIk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $0c50ffb84902cf07$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$0c50ffb84902cf07$var$_export(module.exports, {
    withAlphaValue: function() {
        return $0c50ffb84902cf07$var$withAlphaValue;
    },
    default: function() {
        return $0c50ffb84902cf07$var$withAlphaVariable;
    }
});

var $j5xos = parcelRequire("j5xos");
function $0c50ffb84902cf07$var$withAlphaValue(color, alphaValue, defaultValue) {
    if (typeof color === "function") return color({
        opacityValue: alphaValue
    });
    let parsed = (0, $j5xos.parseColor)(color, {
        loose: true
    });
    if (parsed === null) return defaultValue;
    return (0, $j5xos.formatColor)({
        ...parsed,
        alpha: alphaValue
    });
}
function $0c50ffb84902cf07$var$withAlphaVariable({ color: color, property: property, variable: variable }) {
    let properties = [].concat(property);
    if (typeof color === "function") return {
        [variable]: "1",
        ...Object.fromEntries(properties.map((p)=>{
            return [
                p,
                color({
                    opacityVariable: variable,
                    opacityValue: `var(${variable})`
                })
            ];
        }))
    };
    const parsed = (0, $j5xos.parseColor)(color);
    if (parsed === null) return Object.fromEntries(properties.map((p)=>[
            p,
            color
        ]));
    if (parsed.alpha !== undefined) // Has an alpha value, return color as-is
    return Object.fromEntries(properties.map((p)=>[
            p,
            color
        ]));
    return {
        [variable]: "1",
        ...Object.fromEntries(properties.map((p)=>{
            return [
                p,
                (0, $j5xos.formatColor)({
                    ...parsed,
                    alpha: `var(${variable})`
                })
            ];
        }))
    };
}

});
parcelRegister("j5xos", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $de586330ccb0be57$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$de586330ccb0be57$var$_export(module.exports, {
    parseColor: function() {
        return $de586330ccb0be57$var$parseColor;
    },
    formatColor: function() {
        return $de586330ccb0be57$var$formatColor;
    }
});

const $de586330ccb0be57$var$_colorNames = /*#__PURE__*/ $de586330ccb0be57$var$_interop_require_default((parcelRequire("b9Zho")));
function $de586330ccb0be57$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $de586330ccb0be57$var$HEX = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i;
let $de586330ccb0be57$var$SHORT_HEX = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i;
let $de586330ccb0be57$var$VALUE = /(?:\d+|\d*\.\d+)%?/;
let $de586330ccb0be57$var$SEP = /(?:\s*,\s*|\s+)/;
let $de586330ccb0be57$var$ALPHA_SEP = /\s*[,/]\s*/;
let $de586330ccb0be57$var$CUSTOM_PROPERTY = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/;
let $de586330ccb0be57$var$RGB = new RegExp(`^(rgba?)\\(\\s*(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source})(?:${$de586330ccb0be57$var$SEP.source}(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source}))?(?:${$de586330ccb0be57$var$SEP.source}(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source}))?(?:${$de586330ccb0be57$var$ALPHA_SEP.source}(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source}))?\\s*\\)$`);
let $de586330ccb0be57$var$HSL = new RegExp(`^(hsla?)\\(\\s*((?:${$de586330ccb0be57$var$VALUE.source})(?:deg|rad|grad|turn)?|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source})(?:${$de586330ccb0be57$var$SEP.source}(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source}))?(?:${$de586330ccb0be57$var$SEP.source}(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source}))?(?:${$de586330ccb0be57$var$ALPHA_SEP.source}(${$de586330ccb0be57$var$VALUE.source}|${$de586330ccb0be57$var$CUSTOM_PROPERTY.source}))?\\s*\\)$`);
function $de586330ccb0be57$var$parseColor(value, { loose: loose = false } = {}) {
    var _match_, _match__toString;
    if (typeof value !== "string") return null;
    value = value.trim();
    if (value === "transparent") return {
        mode: "rgb",
        color: [
            "0",
            "0",
            "0"
        ],
        alpha: "0"
    };
    if (value in $de586330ccb0be57$var$_colorNames.default) return {
        mode: "rgb",
        color: $de586330ccb0be57$var$_colorNames.default[value].map((v)=>v.toString())
    };
    let hex = value.replace($de586330ccb0be57$var$SHORT_HEX, (_, r, g, b, a)=>[
            "#",
            r,
            r,
            g,
            g,
            b,
            b,
            a ? a + a : ""
        ].join("")).match($de586330ccb0be57$var$HEX);
    if (hex !== null) return {
        mode: "rgb",
        color: [
            parseInt(hex[1], 16),
            parseInt(hex[2], 16),
            parseInt(hex[3], 16)
        ].map((v)=>v.toString()),
        alpha: hex[4] ? (parseInt(hex[4], 16) / 255).toString() : undefined
    };
    var _value_match;
    let match = (_value_match = value.match($de586330ccb0be57$var$RGB)) !== null && _value_match !== void 0 ? _value_match : value.match($de586330ccb0be57$var$HSL);
    if (match === null) return null;
    let color = [
        match[2],
        match[3],
        match[4]
    ].filter(Boolean).map((v)=>v.toString());
    // rgba(var(--my-color), 0.1)
    // hsla(var(--my-color), 0.1)
    if (color.length === 2 && color[0].startsWith("var(")) return {
        mode: match[1],
        color: [
            color[0]
        ],
        alpha: color[1]
    };
    if (!loose && color.length !== 3) return null;
    if (color.length < 3 && !color.some((part)=>/^var\(.*?\)$/.test(part))) return null;
    return {
        mode: match[1],
        color: color,
        alpha: (_match_ = match[5]) === null || _match_ === void 0 ? void 0 : (_match__toString = _match_.toString) === null || _match__toString === void 0 ? void 0 : _match__toString.call(_match_)
    };
}
function $de586330ccb0be57$var$formatColor({ mode: mode, color: color, alpha: alpha }) {
    let hasAlpha = alpha !== undefined;
    if (mode === "rgba" || mode === "hsla") return `${mode}(${color.join(", ")}${hasAlpha ? `, ${alpha}` : ""})`;
    return `${mode}(${color.join(" ")}${hasAlpha ? ` / ${alpha}` : ""})`;
}

});
parcelRegister("b9Zho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $820011c9408ce2e6$var$_default;
    }
});
const $820011c9408ce2e6$var$_default = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};

});



parcelRegister("5WKeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $45463beb91896874$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$45463beb91896874$var$_export(module.exports, {
    normalize: function() {
        return $45463beb91896874$var$normalize;
    },
    url: function() {
        return $45463beb91896874$var$url;
    },
    number: function() {
        return $45463beb91896874$var$number;
    },
    percentage: function() {
        return $45463beb91896874$var$percentage;
    },
    length: function() {
        return $45463beb91896874$var$length;
    },
    lineWidth: function() {
        return $45463beb91896874$var$lineWidth;
    },
    shadow: function() {
        return $45463beb91896874$var$shadow;
    },
    color: function() {
        return $45463beb91896874$var$color;
    },
    image: function() {
        return $45463beb91896874$var$image;
    },
    gradient: function() {
        return $45463beb91896874$var$gradient;
    },
    position: function() {
        return $45463beb91896874$var$position;
    },
    familyName: function() {
        return $45463beb91896874$var$familyName;
    },
    genericName: function() {
        return $45463beb91896874$var$genericName;
    },
    absoluteSize: function() {
        return $45463beb91896874$var$absoluteSize;
    },
    relativeSize: function() {
        return $45463beb91896874$var$relativeSize;
    }
});

var $j5xos = parcelRequire("j5xos");

var $9PovW = parcelRequire("9PovW");

var $g9xXi = parcelRequire("g9xXi");
let $45463beb91896874$var$cssFunctions = [
    "min",
    "max",
    "clamp",
    "calc"
];
// Ref: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Types
function $45463beb91896874$var$isCSSFunction(value) {
    return $45463beb91896874$var$cssFunctions.some((fn)=>new RegExp(`^${fn}\\(.*\\)`).test(value));
}
// These properties accept a `<dashed-ident>` as one of the values. This means that you can use them
// as: `timeline-scope: --tl;`
//
// Without the `var(--tl)`, in these cases we don't want to normalize the value, and you should add
// the `var()` yourself.
//
// More info:
// - https://drafts.csswg.org/scroll-animations/#propdef-timeline-scope
// - https://developer.mozilla.org/en-US/docs/Web/CSS/timeline-scope#dashed-ident
//
const $45463beb91896874$var$AUTO_VAR_INJECTION_EXCEPTIONS = new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline"
]);
function $45463beb91896874$var$normalize(value, context = null, isRoot = true) {
    let isVarException = context && $45463beb91896874$var$AUTO_VAR_INJECTION_EXCEPTIONS.has(context.property);
    if (value.startsWith("--") && !isVarException) return `var(${value})`;
    // Keep raw strings if it starts with `url(`
    if (value.includes("url(")) return value.split(/(url\(.*?\))/g).filter(Boolean).map((part)=>{
        if (/^url\(.*?\)$/.test(part)) return part;
        return $45463beb91896874$var$normalize(part, context, false);
    }).join("");
    // Convert `_` to ` `, except for escaped underscores `\_`
    value = value.replace(/([^\\])_+/g, (fullMatch, characterBefore)=>characterBefore + " ".repeat(fullMatch.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_");
    // Remove leftover whitespace
    if (isRoot) value = value.trim();
    value = $45463beb91896874$var$normalizeMathOperatorSpacing(value);
    return value;
}
/**
 * Add spaces around operators inside math functions
 * like calc() that do not follow an operator, '(', or `,`.
 *
 * @param {string} value
 * @returns {string}
 */ function $45463beb91896874$var$normalizeMathOperatorSpacing(value) {
    let preventFormattingInFunctions = [
        "theme"
    ];
    let preventFormattingKeywords = [
        "min-content",
        "max-content",
        "fit-content",
        // Env
        "safe-area-inset-top",
        "safe-area-inset-right",
        "safe-area-inset-bottom",
        "safe-area-inset-left",
        "titlebar-area-x",
        "titlebar-area-y",
        "titlebar-area-width",
        "titlebar-area-height",
        "keyboard-inset-top",
        "keyboard-inset-right",
        "keyboard-inset-bottom",
        "keyboard-inset-left",
        "keyboard-inset-width",
        "keyboard-inset-height",
        "radial-gradient",
        "linear-gradient",
        "conic-gradient",
        "repeating-radial-gradient",
        "repeating-linear-gradient",
        "repeating-conic-gradient"
    ];
    return value.replace(/(calc|min|max|clamp)\(.+\)/g, (match)=>{
        let result = "";
        function lastChar() {
            let char = result.trimEnd();
            return char[char.length - 1];
        }
        for(let i = 0; i < match.length; i++){
            function peek(word) {
                return word.split("").every((char, j)=>match[i + j] === char);
            }
            function consumeUntil(chars) {
                let minIndex = Infinity;
                for (let char of chars){
                    let index = match.indexOf(char, i);
                    if (index !== -1 && index < minIndex) minIndex = index;
                }
                let result = match.slice(i, minIndex);
                i += result.length - 1;
                return result;
            }
            let char = match[i];
            // Handle `var(--variable)`
            if (peek("var")) // When we consume until `)`, then we are dealing with this scenario:
            //   `var(--example)`
            //
            // When we consume until `,`, then we are dealing with this scenario:
            //   `var(--example, 1rem)`
            //
            //   In this case we do want to "format", the default value as well
            result += consumeUntil([
                ")",
                ","
            ]);
            else if (preventFormattingKeywords.some((keyword)=>peek(keyword))) {
                let keyword = preventFormattingKeywords.find((keyword)=>peek(keyword));
                result += keyword;
                i += keyword.length - 1;
            } else if (preventFormattingInFunctions.some((fn)=>peek(fn))) result += consumeUntil([
                ")"
            ]);
            else if (peek("[")) result += consumeUntil([
                "]"
            ]);
            else if ([
                "+",
                "-",
                "*",
                "/"
            ].includes(char) && ![
                "(",
                "+",
                "-",
                "*",
                "/",
                ","
            ].includes(lastChar())) result += ` ${char} `;
            else result += char;
        }
        // Simplify multiple spaces
        return result.replace(/\s+/g, " ");
    });
}
function $45463beb91896874$var$url(value) {
    return value.startsWith("url(");
}
function $45463beb91896874$var$number(value) {
    return !isNaN(Number(value)) || $45463beb91896874$var$isCSSFunction(value);
}
function $45463beb91896874$var$percentage(value) {
    return value.endsWith("%") && $45463beb91896874$var$number(value.slice(0, -1)) || $45463beb91896874$var$isCSSFunction(value);
}
// Please refer to MDN when updating this list:
// https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/Values_and_units
// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Container_Queries#container_query_length_units
let $45463beb91896874$var$lengthUnits = [
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
];
let $45463beb91896874$var$lengthUnitsPattern = `(?:${$45463beb91896874$var$lengthUnits.join("|")})`;
function $45463beb91896874$var$length(value) {
    return value === "0" || new RegExp(`^[+-]?[0-9]*\.?[0-9]+(?:[eE][+-]?[0-9]+)?${$45463beb91896874$var$lengthUnitsPattern}$`).test(value) || $45463beb91896874$var$isCSSFunction(value);
}
let $45463beb91896874$var$lineWidths = new Set([
    "thin",
    "medium",
    "thick"
]);
function $45463beb91896874$var$lineWidth(value) {
    return $45463beb91896874$var$lineWidths.has(value);
}
function $45463beb91896874$var$shadow(value) {
    let parsedShadows = (0, $9PovW.parseBoxShadowValue)($45463beb91896874$var$normalize(value));
    for (let parsedShadow of parsedShadows){
        if (!parsedShadow.valid) return false;
    }
    return true;
}
function $45463beb91896874$var$color(value) {
    let colors = 0;
    let result = (0, $g9xXi.splitAtTopLevelOnly)(value, "_").every((part)=>{
        part = $45463beb91896874$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ((0, $j5xos.parseColor)(part, {
            loose: true
        }) !== null) return colors++, true;
        return false;
    });
    if (!result) return false;
    return colors > 0;
}
function $45463beb91896874$var$image(value) {
    let images = 0;
    let result = (0, $g9xXi.splitAtTopLevelOnly)(value, ",").every((part)=>{
        part = $45463beb91896874$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ($45463beb91896874$var$url(part) || $45463beb91896874$var$gradient(part) || [
            "element(",
            "image(",
            "cross-fade(",
            "image-set("
        ].some((fn)=>part.startsWith(fn))) {
            images++;
            return true;
        }
        return false;
    });
    if (!result) return false;
    return images > 0;
}
let $45463beb91896874$var$gradientTypes = new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
]);
function $45463beb91896874$var$gradient(value) {
    value = $45463beb91896874$var$normalize(value);
    for (let type of $45463beb91896874$var$gradientTypes){
        if (value.startsWith(`${type}(`)) return true;
    }
    return false;
}
let $45463beb91896874$var$validPositions = new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
]);
function $45463beb91896874$var$position(value) {
    let positions = 0;
    let result = (0, $g9xXi.splitAtTopLevelOnly)(value, "_").every((part)=>{
        part = $45463beb91896874$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ($45463beb91896874$var$validPositions.has(part) || $45463beb91896874$var$length(part) || $45463beb91896874$var$percentage(part)) {
            positions++;
            return true;
        }
        return false;
    });
    if (!result) return false;
    return positions > 0;
}
function $45463beb91896874$var$familyName(value) {
    let fonts = 0;
    let result = (0, $g9xXi.splitAtTopLevelOnly)(value, ",").every((part)=>{
        part = $45463beb91896874$var$normalize(part);
        if (part.startsWith("var(")) return true;
        // If it contains spaces, then it should be quoted
        if (part.includes(" ")) {
            if (!/(['"])([^"']+)\1/g.test(part)) return false;
        }
        // If it starts with a number, it's invalid
        if (/^\d/g.test(part)) return false;
        fonts++;
        return true;
    });
    if (!result) return false;
    return fonts > 0;
}
let $45463beb91896874$var$genericNames = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
]);
function $45463beb91896874$var$genericName(value) {
    return $45463beb91896874$var$genericNames.has(value);
}
let $45463beb91896874$var$absoluteSizes = new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large"
]);
function $45463beb91896874$var$absoluteSize(value) {
    return $45463beb91896874$var$absoluteSizes.has(value);
}
let $45463beb91896874$var$relativeSizes = new Set([
    "larger",
    "smaller"
]);
function $45463beb91896874$var$relativeSize(value) {
    return $45463beb91896874$var$relativeSizes.has(value);
}

});
parcelRegister("9PovW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $727be47bbffd1d93$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$727be47bbffd1d93$var$_export(module.exports, {
    parseBoxShadowValue: function() {
        return $727be47bbffd1d93$var$parseBoxShadowValue;
    },
    formatBoxShadowValue: function() {
        return $727be47bbffd1d93$var$formatBoxShadowValue;
    }
});

var $g9xXi = parcelRequire("g9xXi");
let $727be47bbffd1d93$var$KEYWORDS = new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
let $727be47bbffd1d93$var$SPACE = /\ +(?![^(]*\))/g // Similar to the one above, but with spaces instead.
;
let $727be47bbffd1d93$var$LENGTH = /^-?(\d+|\.\d+)(.*?)$/g;
function $727be47bbffd1d93$var$parseBoxShadowValue(input) {
    let shadows = (0, $g9xXi.splitAtTopLevelOnly)(input, ",");
    return shadows.map((shadow)=>{
        let value = shadow.trim();
        let result = {
            raw: value
        };
        let parts = value.split($727be47bbffd1d93$var$SPACE);
        let seen = new Set();
        for (let part of parts){
            // Reset index, since the regex is stateful.
            $727be47bbffd1d93$var$LENGTH.lastIndex = 0;
            // Keyword
            if (!seen.has("KEYWORD") && $727be47bbffd1d93$var$KEYWORDS.has(part)) {
                result.keyword = part;
                seen.add("KEYWORD");
            } else if ($727be47bbffd1d93$var$LENGTH.test(part)) {
                if (!seen.has("X")) {
                    result.x = part;
                    seen.add("X");
                } else if (!seen.has("Y")) {
                    result.y = part;
                    seen.add("Y");
                } else if (!seen.has("BLUR")) {
                    result.blur = part;
                    seen.add("BLUR");
                } else if (!seen.has("SPREAD")) {
                    result.spread = part;
                    seen.add("SPREAD");
                }
            } else if (!result.color) result.color = part;
            else {
                if (!result.unknown) result.unknown = [];
                result.unknown.push(part);
            }
        }
        // Check if valid
        result.valid = result.x !== undefined && result.y !== undefined;
        return result;
    });
}
function $727be47bbffd1d93$var$formatBoxShadowValue(shadows) {
    return shadows.map((shadow)=>{
        if (!shadow.valid) return shadow.raw;
        return [
            shadow.keyword,
            shadow.x,
            shadow.y,
            shadow.blur,
            shadow.spread,
            shadow.color
        ].filter(Boolean).join(" ");
    }).join(", ");
}

});
parcelRegister("g9xXi", function(module, exports) {
/**
 * This splits a string on a top-level character.
 *
 * Regex doesn't support recursion (at least not the JS-flavored version).
 * So we have to use a tiny state machine to keep track of paren placement.
 *
 * Expected behavior using commas:
 * var(--a, 0 0 1px rgb(0, 0, 0)), 0 0 1px rgb(0, 0, 0)
 *       ─┬─             ┬  ┬    ┬
 *        x              x  x    ╰──────── Split because top-level
 *        ╰──────────────┴──┴───────────── Ignored b/c inside >= 1 levels of parens
 *
 * @param {string} input
 * @param {string} separator
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "splitAtTopLevelOnly", {
    enumerable: true,
    get: function() {
        return $bc27d3743c4c7d3e$var$splitAtTopLevelOnly;
    }
});
function $bc27d3743c4c7d3e$var$splitAtTopLevelOnly(input, separator) {
    let stack = [];
    let parts = [];
    let lastPos = 0;
    let isEscaped = false;
    for(let idx = 0; idx < input.length; idx++){
        let char = input[idx];
        if (stack.length === 0 && char === separator[0] && !isEscaped) {
            if (separator.length === 1 || input.slice(idx, idx + separator.length) === separator) {
                parts.push(input.slice(lastPos, idx));
                lastPos = idx + separator.length;
            }
        }
        if (isEscaped) isEscaped = false;
        else if (char === "\\") isEscaped = true;
        if (char === "(" || char === "[" || char === "{") stack.push(char);
        else if (char === ")" && stack[stack.length - 1] === "(" || char === "]" && stack[stack.length - 1] === "[" || char === "}" && stack[stack.length - 1] === "{") stack.pop();
    }
    parts.push(input.slice(lastPos));
    return parts;
}

});



parcelRegister("j7hpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "backgroundSize", {
    enumerable: true,
    get: function() {
        return $deac2df0fa95ba85$var$backgroundSize;
    }
});

var $5WKeE = parcelRequire("5WKeE");

var $g9xXi = parcelRequire("g9xXi");
function $deac2df0fa95ba85$var$backgroundSize(value) {
    let keywordValues = [
        "cover",
        "contain"
    ];
    // the <length-percentage> type will probably be a css function
    // so we have to use `splitAtTopLevelOnly`
    return (0, $g9xXi.splitAtTopLevelOnly)(value, ",").every((part)=>{
        let sizes = (0, $g9xXi.splitAtTopLevelOnly)(part, "_").filter(Boolean);
        if (sizes.length === 1 && keywordValues.includes(sizes[0])) return true;
        if (sizes.length !== 1 && sizes.length !== 2) return false;
        return sizes.every((size)=>(0, $5WKeE.length)(size) || (0, $5WKeE.percentage)(size) || size === "auto");
    });
}

});


parcelRegister("6f4U1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $48b7f258fb97d937$var$toColorValue;
    }
});
function $48b7f258fb97d937$var$toColorValue(maybeFunction) {
    return typeof maybeFunction === "function" ? maybeFunction({}) : maybeFunction;
}

});


parcelRegister("dy6Kc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9dd3ae8f87a77c09$var$getAllConfigs;
    }
});

const $9dd3ae8f87a77c09$var$_configfull = /*#__PURE__*/ $9dd3ae8f87a77c09$var$_interop_require_default((parcelRequire("9XxG9")));

var $5UX1h = parcelRequire("5UX1h");
function $9dd3ae8f87a77c09$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9dd3ae8f87a77c09$var$getAllConfigs(config) {
    var _config_presets;
    const configs = ((_config_presets = config === null || config === void 0 ? void 0 : config.presets) !== null && _config_presets !== void 0 ? _config_presets : [
        $9dd3ae8f87a77c09$var$_configfull.default
    ]).slice().reverse().flatMap((preset)=>$9dd3ae8f87a77c09$var$getAllConfigs(preset instanceof Function ? preset() : preset));
    const features = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
            theme: {
                ringColor: ({ theme: theme })=>({
                        DEFAULT: "#3b82f67f",
                        ...theme("colors")
                    })
            }
        },
        disableColorOpacityUtilitiesByDefault: {
            corePlugins: {
                backgroundOpacity: false,
                borderOpacity: false,
                divideOpacity: false,
                placeholderOpacity: false,
                ringOpacity: false,
                textOpacity: false
            }
        }
    };
    const experimentals = Object.keys(features).filter((feature)=>(0, $5UX1h.flagEnabled)(config, feature)).map((feature)=>features[feature]);
    return [
        config,
        ...experimentals,
        ...configs
    ];
}

});
parcelRegister("9XxG9", function(module, exports) {
module.exports = {
    content: [],
    presets: [],
    darkMode: "media",
    theme: {
        accentColor: ({ theme: theme })=>({
                ...theme("colors"),
                auto: "auto"
            }),
        animation: {
            none: "none",
            spin: "spin 1s linear infinite",
            ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
            pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            bounce: "bounce 1s infinite"
        },
        aria: {
            busy: 'busy="true"',
            checked: 'checked="true"',
            disabled: 'disabled="true"',
            expanded: 'expanded="true"',
            hidden: 'hidden="true"',
            pressed: 'pressed="true"',
            readonly: 'readonly="true"',
            required: 'required="true"',
            selected: 'selected="true"'
        },
        aspectRatio: {
            auto: "auto",
            square: "1 / 1",
            video: "16 / 9"
        },
        backdropBlur: ({ theme: theme })=>theme("blur"),
        backdropBrightness: ({ theme: theme })=>theme("brightness"),
        backdropContrast: ({ theme: theme })=>theme("contrast"),
        backdropGrayscale: ({ theme: theme })=>theme("grayscale"),
        backdropHueRotate: ({ theme: theme })=>theme("hueRotate"),
        backdropInvert: ({ theme: theme })=>theme("invert"),
        backdropOpacity: ({ theme: theme })=>theme("opacity"),
        backdropSaturate: ({ theme: theme })=>theme("saturate"),
        backdropSepia: ({ theme: theme })=>theme("sepia"),
        backgroundColor: ({ theme: theme })=>theme("colors"),
        backgroundImage: {
            none: "none",
            "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
            "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
            "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
            "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
            "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
            "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
            "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
            "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
        },
        backgroundOpacity: ({ theme: theme })=>theme("opacity"),
        backgroundPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        backgroundSize: {
            auto: "auto",
            cover: "cover",
            contain: "contain"
        },
        blur: {
            0: "0",
            none: "0",
            sm: "4px",
            DEFAULT: "8px",
            md: "12px",
            lg: "16px",
            xl: "24px",
            "2xl": "40px",
            "3xl": "64px"
        },
        borderColor: ({ theme: theme })=>({
                ...theme("colors"),
                DEFAULT: theme("colors.gray.200", "currentColor")
            }),
        borderOpacity: ({ theme: theme })=>theme("opacity"),
        borderRadius: {
            none: "0px",
            sm: "0.125rem",
            DEFAULT: "0.25rem",
            md: "0.375rem",
            lg: "0.5rem",
            xl: "0.75rem",
            "2xl": "1rem",
            "3xl": "1.5rem",
            full: "9999px"
        },
        borderSpacing: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        borderWidth: {
            DEFAULT: "1px",
            0: "0px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        boxShadow: {
            sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
            DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
            inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
            none: "none"
        },
        boxShadowColor: ({ theme: theme })=>theme("colors"),
        brightness: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        caretColor: ({ theme: theme })=>theme("colors"),
        colors: ({ colors: colors })=>({
                inherit: colors.inherit,
                current: colors.current,
                transparent: colors.transparent,
                black: colors.black,
                white: colors.white,
                slate: colors.slate,
                gray: colors.gray,
                zinc: colors.zinc,
                neutral: colors.neutral,
                stone: colors.stone,
                red: colors.red,
                orange: colors.orange,
                amber: colors.amber,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                sky: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose
            }),
        columns: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            "3xs": "16rem",
            "2xs": "18rem",
            xs: "20rem",
            sm: "24rem",
            md: "28rem",
            lg: "32rem",
            xl: "36rem",
            "2xl": "42rem",
            "3xl": "48rem",
            "4xl": "56rem",
            "5xl": "64rem",
            "6xl": "72rem",
            "7xl": "80rem"
        },
        container: {},
        content: {
            none: "none"
        },
        contrast: {
            0: "0",
            50: ".5",
            75: ".75",
            100: "1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        cursor: {
            auto: "auto",
            default: "default",
            pointer: "pointer",
            wait: "wait",
            text: "text",
            move: "move",
            help: "help",
            "not-allowed": "not-allowed",
            none: "none",
            "context-menu": "context-menu",
            progress: "progress",
            cell: "cell",
            crosshair: "crosshair",
            "vertical-text": "vertical-text",
            alias: "alias",
            copy: "copy",
            "no-drop": "no-drop",
            grab: "grab",
            grabbing: "grabbing",
            "all-scroll": "all-scroll",
            "col-resize": "col-resize",
            "row-resize": "row-resize",
            "n-resize": "n-resize",
            "e-resize": "e-resize",
            "s-resize": "s-resize",
            "w-resize": "w-resize",
            "ne-resize": "ne-resize",
            "nw-resize": "nw-resize",
            "se-resize": "se-resize",
            "sw-resize": "sw-resize",
            "ew-resize": "ew-resize",
            "ns-resize": "ns-resize",
            "nesw-resize": "nesw-resize",
            "nwse-resize": "nwse-resize",
            "zoom-in": "zoom-in",
            "zoom-out": "zoom-out"
        },
        divideColor: ({ theme: theme })=>theme("borderColor"),
        divideOpacity: ({ theme: theme })=>theme("borderOpacity"),
        divideWidth: ({ theme: theme })=>theme("borderWidth"),
        dropShadow: {
            sm: "0 1px 1px rgb(0 0 0 / 0.05)",
            DEFAULT: [
                "0 1px 2px rgb(0 0 0 / 0.1)",
                "0 1px 1px rgb(0 0 0 / 0.06)"
            ],
            md: [
                "0 4px 3px rgb(0 0 0 / 0.07)",
                "0 2px 2px rgb(0 0 0 / 0.06)"
            ],
            lg: [
                "0 10px 8px rgb(0 0 0 / 0.04)",
                "0 4px 3px rgb(0 0 0 / 0.1)"
            ],
            xl: [
                "0 20px 13px rgb(0 0 0 / 0.03)",
                "0 8px 5px rgb(0 0 0 / 0.08)"
            ],
            "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
            none: "0 0 #0000"
        },
        fill: ({ theme: theme })=>({
                none: "none",
                ...theme("colors")
            }),
        flex: {
            1: "1 1 0%",
            auto: "1 1 auto",
            initial: "0 1 auto",
            none: "none"
        },
        flexBasis: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%"
            }),
        flexGrow: {
            0: "0",
            DEFAULT: "1"
        },
        flexShrink: {
            0: "0",
            DEFAULT: "1"
        },
        fontFamily: {
            sans: [
                "ui-sans-serif",
                "system-ui",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"'
            ],
            serif: [
                "ui-serif",
                "Georgia",
                "Cambria",
                '"Times New Roman"',
                "Times",
                "serif"
            ],
            mono: [
                "ui-monospace",
                "SFMono-Regular",
                "Menlo",
                "Monaco",
                "Consolas",
                '"Liberation Mono"',
                '"Courier New"',
                "monospace"
            ]
        },
        fontSize: {
            xs: [
                "0.75rem",
                {
                    lineHeight: "1rem"
                }
            ],
            sm: [
                "0.875rem",
                {
                    lineHeight: "1.25rem"
                }
            ],
            base: [
                "1rem",
                {
                    lineHeight: "1.5rem"
                }
            ],
            lg: [
                "1.125rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            xl: [
                "1.25rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            "2xl": [
                "1.5rem",
                {
                    lineHeight: "2rem"
                }
            ],
            "3xl": [
                "1.875rem",
                {
                    lineHeight: "2.25rem"
                }
            ],
            "4xl": [
                "2.25rem",
                {
                    lineHeight: "2.5rem"
                }
            ],
            "5xl": [
                "3rem",
                {
                    lineHeight: "1"
                }
            ],
            "6xl": [
                "3.75rem",
                {
                    lineHeight: "1"
                }
            ],
            "7xl": [
                "4.5rem",
                {
                    lineHeight: "1"
                }
            ],
            "8xl": [
                "6rem",
                {
                    lineHeight: "1"
                }
            ],
            "9xl": [
                "8rem",
                {
                    lineHeight: "1"
                }
            ]
        },
        fontWeight: {
            thin: "100",
            extralight: "200",
            light: "300",
            normal: "400",
            medium: "500",
            semibold: "600",
            bold: "700",
            extrabold: "800",
            black: "900"
        },
        gap: ({ theme: theme })=>theme("spacing"),
        gradientColorStops: ({ theme: theme })=>theme("colors"),
        gradientColorStopPositions: {
            "0%": "0%",
            "5%": "5%",
            "10%": "10%",
            "15%": "15%",
            "20%": "20%",
            "25%": "25%",
            "30%": "30%",
            "35%": "35%",
            "40%": "40%",
            "45%": "45%",
            "50%": "50%",
            "55%": "55%",
            "60%": "60%",
            "65%": "65%",
            "70%": "70%",
            "75%": "75%",
            "80%": "80%",
            "85%": "85%",
            "90%": "90%",
            "95%": "95%",
            "100%": "100%"
        },
        grayscale: {
            0: "0",
            DEFAULT: "100%"
        },
        gridAutoColumns: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridAutoRows: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridColumn: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridColumnEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridColumnStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRow: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridRowEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRowStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridTemplateColumns: {
            none: "none",
            subgrid: "subgrid",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        gridTemplateRows: {
            none: "none",
            subgrid: "subgrid",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        height: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        hueRotate: {
            0: "0deg",
            15: "15deg",
            30: "30deg",
            60: "60deg",
            90: "90deg",
            180: "180deg"
        },
        inset: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        invert: {
            0: "0",
            DEFAULT: "100%"
        },
        keyframes: {
            spin: {
                to: {
                    transform: "rotate(360deg)"
                }
            },
            ping: {
                "75%, 100%": {
                    transform: "scale(2)",
                    opacity: "0"
                }
            },
            pulse: {
                "50%": {
                    opacity: ".5"
                }
            },
            bounce: {
                "0%, 100%": {
                    transform: "translateY(-25%)",
                    animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
                },
                "50%": {
                    transform: "none",
                    animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
                }
            }
        },
        letterSpacing: {
            tighter: "-0.05em",
            tight: "-0.025em",
            normal: "0em",
            wide: "0.025em",
            wider: "0.05em",
            widest: "0.1em"
        },
        lineHeight: {
            none: "1",
            tight: "1.25",
            snug: "1.375",
            normal: "1.5",
            relaxed: "1.625",
            loose: "2",
            3: ".75rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem"
        },
        listStyleType: {
            none: "none",
            disc: "disc",
            decimal: "decimal"
        },
        listStyleImage: {
            none: "none"
        },
        margin: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing")
            }),
        lineClamp: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6"
        },
        maxHeight: ({ theme: theme })=>({
                ...theme("spacing"),
                none: "none",
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        maxWidth: ({ theme: theme, breakpoints: breakpoints })=>({
                ...theme("spacing"),
                none: "none",
                xs: "20rem",
                sm: "24rem",
                md: "28rem",
                lg: "32rem",
                xl: "36rem",
                "2xl": "42rem",
                "3xl": "48rem",
                "4xl": "56rem",
                "5xl": "64rem",
                "6xl": "72rem",
                "7xl": "80rem",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content",
                prose: "65ch",
                ...breakpoints(theme("screens"))
            }),
        minHeight: ({ theme: theme })=>({
                ...theme("spacing"),
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        minWidth: ({ theme: theme })=>({
                ...theme("spacing"),
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        objectPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        opacity: {
            0: "0",
            5: "0.05",
            10: "0.1",
            15: "0.15",
            20: "0.2",
            25: "0.25",
            30: "0.3",
            35: "0.35",
            40: "0.4",
            45: "0.45",
            50: "0.5",
            55: "0.55",
            60: "0.6",
            65: "0.65",
            70: "0.7",
            75: "0.75",
            80: "0.8",
            85: "0.85",
            90: "0.9",
            95: "0.95",
            100: "1"
        },
        order: {
            first: "-9999",
            last: "9999",
            none: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12"
        },
        outlineColor: ({ theme: theme })=>theme("colors"),
        outlineOffset: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        outlineWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        padding: ({ theme: theme })=>theme("spacing"),
        placeholderColor: ({ theme: theme })=>theme("colors"),
        placeholderOpacity: ({ theme: theme })=>theme("opacity"),
        ringColor: ({ theme: theme })=>({
                DEFAULT: theme("colors.blue.500", "#3b82f6"),
                ...theme("colors")
            }),
        ringOffsetColor: ({ theme: theme })=>theme("colors"),
        ringOffsetWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        ringOpacity: ({ theme: theme })=>({
                DEFAULT: "0.5",
                ...theme("opacity")
            }),
        ringWidth: {
            DEFAULT: "3px",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        rotate: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg",
            45: "45deg",
            90: "90deg",
            180: "180deg"
        },
        saturate: {
            0: "0",
            50: ".5",
            100: "1",
            150: "1.5",
            200: "2"
        },
        scale: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5"
        },
        screens: {
            sm: "640px",
            md: "768px",
            lg: "1024px",
            xl: "1280px",
            "2xl": "1536px"
        },
        scrollMargin: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        scrollPadding: ({ theme: theme })=>theme("spacing"),
        sepia: {
            0: "0",
            DEFAULT: "100%"
        },
        skew: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg"
        },
        space: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        spacing: {
            px: "1px",
            0: "0px",
            0.5: "0.125rem",
            1: "0.25rem",
            1.5: "0.375rem",
            2: "0.5rem",
            2.5: "0.625rem",
            3: "0.75rem",
            3.5: "0.875rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem",
            11: "2.75rem",
            12: "3rem",
            14: "3.5rem",
            16: "4rem",
            20: "5rem",
            24: "6rem",
            28: "7rem",
            32: "8rem",
            36: "9rem",
            40: "10rem",
            44: "11rem",
            48: "12rem",
            52: "13rem",
            56: "14rem",
            60: "15rem",
            64: "16rem",
            72: "18rem",
            80: "20rem",
            96: "24rem"
        },
        stroke: ({ theme: theme })=>({
                none: "none",
                ...theme("colors")
            }),
        strokeWidth: {
            0: "0",
            1: "1",
            2: "2"
        },
        supports: {},
        data: {},
        textColor: ({ theme: theme })=>theme("colors"),
        textDecorationColor: ({ theme: theme })=>theme("colors"),
        textDecorationThickness: {
            auto: "auto",
            "from-font": "from-font",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        textIndent: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        textOpacity: ({ theme: theme })=>theme("opacity"),
        textUnderlineOffset: {
            auto: "auto",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        transformOrigin: {
            center: "center",
            top: "top",
            "top-right": "top right",
            right: "right",
            "bottom-right": "bottom right",
            bottom: "bottom",
            "bottom-left": "bottom left",
            left: "left",
            "top-left": "top left"
        },
        transitionDelay: {
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionDuration: {
            DEFAULT: "150ms",
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionProperty: {
            none: "none",
            all: "all",
            DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
            colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
            opacity: "opacity",
            shadow: "box-shadow",
            transform: "transform"
        },
        transitionTimingFunction: {
            DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
            linear: "linear",
            in: "cubic-bezier(0.4, 0, 1, 1)",
            out: "cubic-bezier(0, 0, 0.2, 1)",
            "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
        },
        translate: ({ theme: theme })=>({
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        size: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        width: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                screen: "100vw",
                svw: "100svw",
                lvw: "100lvw",
                dvw: "100dvw",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        willChange: {
            auto: "auto",
            scroll: "scroll-position",
            contents: "contents",
            transform: "transform"
        },
        zIndex: {
            auto: "auto",
            0: "0",
            10: "10",
            20: "20",
            30: "30",
            40: "40",
            50: "50"
        }
    },
    plugins: []
};

});


parcelRegister("3Y59v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2e3af8daddde48b0$var$_default;
    }
});
function $2e3af8daddde48b0$var$createPlugin(plugin, config) {
    return {
        handler: plugin,
        config: config
    };
}
$2e3af8daddde48b0$var$createPlugin.withOptions = function(pluginFunction, configFunction = ()=>({})) {
    const optionsFunction = function(options) {
        return {
            __options: options,
            handler: pluginFunction(options),
            config: configFunction(options)
        };
    };
    optionsFunction.__isOptionsFunction = true;
    // Expose plugin dependencies so that `object-hash` returns a different
    // value if anything here changes, to ensure a rebuild is triggered.
    optionsFunction.__pluginFunction = pluginFunction;
    optionsFunction.__configFunction = configFunction;
    return optionsFunction;
};
const $2e3af8daddde48b0$var$_default = $2e3af8daddde48b0$var$createPlugin;

});

parcelRegister("kOiDa", function(module, exports) {

var $bYJeg = parcelRequire("bYJeg");

var $ekqU3 = parcelRequire("ekqU3");

var $kDXKg = parcelRequire("kDXKg");

var $9Laho = parcelRequire("9Laho");
const [$f266eddb860a3d53$var$baseFontSize, { lineHeight: $f266eddb860a3d53$var$baseLineHeight }] = $kDXKg.fontSize.base;
const { spacing: $f266eddb860a3d53$var$spacing, borderWidth: $f266eddb860a3d53$var$borderWidth, borderRadius: $f266eddb860a3d53$var$borderRadius } = $kDXKg;
function $f266eddb860a3d53$var$resolveColor(color, opacityVariableName) {
    return color.replace("<alpha-value>", `var(${opacityVariableName}, 1)`);
}
const $f266eddb860a3d53$var$forms = $ekqU3.withOptions(function(options = {
    strategy: undefined
}) {
    return function({ addBase: addBase, addComponents: addComponents, theme: theme }) {
        const strategy = options.strategy === undefined ? [
            "base",
            "class"
        ] : [
            options.strategy
        ];
        const rules = [
            {
                base: [
                    "[type='text']",
                    "input:where(:not([type]))",
                    "[type='email']",
                    "[type='url']",
                    "[type='password']",
                    "[type='number']",
                    "[type='date']",
                    "[type='datetime-local']",
                    "[type='month']",
                    "[type='search']",
                    "[type='tel']",
                    "[type='time']",
                    "[type='week']",
                    "[multiple]",
                    "textarea",
                    "select"
                ],
                class: [
                    ".form-input",
                    ".form-textarea",
                    ".form-select",
                    ".form-multiselect"
                ],
                styles: {
                    appearance: "none",
                    "background-color": "#fff",
                    "border-color": $f266eddb860a3d53$var$resolveColor(theme("colors.gray.500", $9Laho.gray[500]), "--tw-border-opacity"),
                    "border-width": $f266eddb860a3d53$var$borderWidth["DEFAULT"],
                    "border-radius": $f266eddb860a3d53$var$borderRadius.none,
                    "padding-top": $f266eddb860a3d53$var$spacing[2],
                    "padding-right": $f266eddb860a3d53$var$spacing[3],
                    "padding-bottom": $f266eddb860a3d53$var$spacing[2],
                    "padding-left": $f266eddb860a3d53$var$spacing[3],
                    "font-size": $f266eddb860a3d53$var$baseFontSize,
                    "line-height": $f266eddb860a3d53$var$baseLineHeight,
                    "--tw-shadow": "0 0 #0000",
                    "&:focus": {
                        outline: "2px solid transparent",
                        "outline-offset": "2px",
                        "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                        "--tw-ring-offset-width": "0px",
                        "--tw-ring-offset-color": "#fff",
                        "--tw-ring-color": $f266eddb860a3d53$var$resolveColor(theme("colors.blue.600", $9Laho.blue[600]), "--tw-ring-opacity"),
                        "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                        "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                        "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`,
                        "border-color": $f266eddb860a3d53$var$resolveColor(theme("colors.blue.600", $9Laho.blue[600]), "--tw-border-opacity")
                    }
                }
            },
            {
                base: [
                    "input::placeholder",
                    "textarea::placeholder"
                ],
                class: [
                    ".form-input::placeholder",
                    ".form-textarea::placeholder"
                ],
                styles: {
                    color: $f266eddb860a3d53$var$resolveColor(theme("colors.gray.500", $9Laho.gray[500]), "--tw-text-opacity"),
                    opacity: "1"
                }
            },
            {
                base: [
                    "::-webkit-datetime-edit-fields-wrapper"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit-fields-wrapper"
                ],
                styles: {
                    padding: "0"
                }
            },
            {
                // Unfortunate hack until https://bugs.webkit.org/show_bug.cgi?id=198959 is fixed.
                // This sucks because users can't change line-height with a utility on date inputs now.
                // Reference: https://github.com/twbs/bootstrap/pull/31993
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "min-height": "1.5em"
                }
            },
            {
                // In Safari on iOS date and time inputs are centered instead of left-aligned and can't be
                // changed with `text-align` utilities on the input by default. Resetting this to `inherit`
                // makes them left-aligned by default and makes it possible to override the alignment with
                // utility classes without using an arbitrary variant to target the pseudo-elements.
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "text-align": "inherit"
                }
            },
            {
                // In Safari on macOS date time inputs that are set to `display: block` have unexpected
                // extra bottom spacing. This can be corrected by setting the `::-webkit-datetime-edit`
                // pseudo-element to `display: inline-flex`, instead of the browser default of
                // `display: inline-block`.
                base: [
                    "::-webkit-datetime-edit"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit"
                ],
                styles: {
                    display: "inline-flex"
                }
            },
            {
                // In Safari on macOS date time inputs are 4px taller than normal inputs
                // This is because there is extra padding on the datetime-edit and datetime-edit-{part}-field pseudo elements
                // See https://github.com/tailwindlabs/tailwindcss-forms/issues/95
                base: [
                    "::-webkit-datetime-edit",
                    "::-webkit-datetime-edit-year-field",
                    "::-webkit-datetime-edit-month-field",
                    "::-webkit-datetime-edit-day-field",
                    "::-webkit-datetime-edit-hour-field",
                    "::-webkit-datetime-edit-minute-field",
                    "::-webkit-datetime-edit-second-field",
                    "::-webkit-datetime-edit-millisecond-field",
                    "::-webkit-datetime-edit-meridiem-field"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit",
                    ".form-input::-webkit-datetime-edit-year-field",
                    ".form-input::-webkit-datetime-edit-month-field",
                    ".form-input::-webkit-datetime-edit-day-field",
                    ".form-input::-webkit-datetime-edit-hour-field",
                    ".form-input::-webkit-datetime-edit-minute-field",
                    ".form-input::-webkit-datetime-edit-second-field",
                    ".form-input::-webkit-datetime-edit-millisecond-field",
                    ".form-input::-webkit-datetime-edit-meridiem-field"
                ],
                styles: {
                    "padding-top": 0,
                    "padding-bottom": 0
                }
            },
            {
                base: [
                    "select"
                ],
                class: [
                    ".form-select"
                ],
                styles: {
                    "background-image": `url("${$bYJeg(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="${$f266eddb860a3d53$var$resolveColor(theme("colors.gray.500", $9Laho.gray[500]), "--tw-stroke-opacity")}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4"/></svg>`)}")`,
                    "background-position": `right ${$f266eddb860a3d53$var$spacing[2]} center`,
                    "background-repeat": `no-repeat`,
                    "background-size": `1.5em 1.5em`,
                    "padding-right": $f266eddb860a3d53$var$spacing[10],
                    "print-color-adjust": `exact`
                }
            },
            {
                base: [
                    "[multiple]",
                    '[size]:where(select:not([size="1"]))'
                ],
                class: [
                    '.form-select:where([size]:not([size="1"]))'
                ],
                styles: {
                    "background-image": "initial",
                    "background-position": "initial",
                    "background-repeat": "unset",
                    "background-size": "initial",
                    "padding-right": $f266eddb860a3d53$var$spacing[3],
                    "print-color-adjust": "unset"
                }
            },
            {
                base: [
                    `[type='checkbox']`,
                    `[type='radio']`
                ],
                class: [
                    ".form-checkbox",
                    ".form-radio"
                ],
                styles: {
                    appearance: "none",
                    padding: "0",
                    "print-color-adjust": "exact",
                    display: "inline-block",
                    "vertical-align": "middle",
                    "background-origin": "border-box",
                    "user-select": "none",
                    "flex-shrink": "0",
                    height: $f266eddb860a3d53$var$spacing[4],
                    width: $f266eddb860a3d53$var$spacing[4],
                    color: $f266eddb860a3d53$var$resolveColor(theme("colors.blue.600", $9Laho.blue[600]), "--tw-text-opacity"),
                    "background-color": "#fff",
                    "border-color": $f266eddb860a3d53$var$resolveColor(theme("colors.gray.500", $9Laho.gray[500]), "--tw-border-opacity"),
                    "border-width": $f266eddb860a3d53$var$borderWidth["DEFAULT"],
                    "--tw-shadow": "0 0 #0000"
                }
            },
            {
                base: [
                    `[type='checkbox']`
                ],
                class: [
                    ".form-checkbox"
                ],
                styles: {
                    "border-radius": $f266eddb860a3d53$var$borderRadius["none"]
                }
            },
            {
                base: [
                    `[type='radio']`
                ],
                class: [
                    ".form-radio"
                ],
                styles: {
                    "border-radius": "100%"
                }
            },
            {
                base: [
                    `[type='checkbox']:focus`,
                    `[type='radio']:focus`
                ],
                class: [
                    ".form-checkbox:focus",
                    ".form-radio:focus"
                ],
                styles: {
                    outline: "2px solid transparent",
                    "outline-offset": "2px",
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": "2px",
                    "--tw-ring-offset-color": "#fff",
                    "--tw-ring-color": $f266eddb860a3d53$var$resolveColor(theme("colors.blue.600", $9Laho.blue[600]), "--tw-ring-opacity"),
                    "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                    "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                    "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`,
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-checkbox:checked",
                    ".form-radio:checked"
                ],
                styles: {
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`
                ],
                class: [
                    ".form-checkbox:checked"
                ],
                styles: {
                    "background-image": `url("${$bYJeg(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>`)}")`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-radio:checked"
                ],
                styles: {
                    "background-image": `url("${$bYJeg(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='checkbox']:checked:hover`,
                    `[type='checkbox']:checked:focus`,
                    `[type='radio']:checked:hover`,
                    `[type='radio']:checked:focus`
                ],
                class: [
                    ".form-checkbox:checked:hover",
                    ".form-checkbox:checked:focus",
                    ".form-radio:checked:hover",
                    ".form-radio:checked:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate`
                ],
                class: [
                    ".form-checkbox:indeterminate"
                ],
                styles: {
                    "background-image": `url("${$bYJeg(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h8"/></svg>`)}")`,
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate:hover`,
                    `[type='checkbox']:indeterminate:focus`
                ],
                class: [
                    ".form-checkbox:indeterminate:hover",
                    ".form-checkbox:indeterminate:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='file']`
                ],
                class: null,
                styles: {
                    background: "unset",
                    "border-color": "inherit",
                    "border-width": "0",
                    "border-radius": "0",
                    padding: "0",
                    "font-size": "unset",
                    "line-height": "inherit"
                }
            },
            {
                base: [
                    `[type='file']:focus`
                ],
                class: null,
                styles: {
                    outline: [
                        `1px solid ButtonText`,
                        `1px auto -webkit-focus-ring-color`
                    ]
                }
            }
        ];
        const getStrategyRules = (strategy)=>rules.map((rule)=>{
                if (rule[strategy] === null) return null;
                return {
                    [rule[strategy]]: rule.styles
                };
            }).filter(Boolean);
        if (strategy.includes("base")) addBase(getStrategyRules("base"));
        if (strategy.includes("class")) addComponents(getStrategyRules("class"));
    };
});
module.exports = $f266eddb860a3d53$var$forms;

});
parcelRegister("bYJeg", function(module, exports) {

var $dkllf = parcelRequire("dkllf");
var $8b8861dc50d423ab$var$REGEX = {
    whitespace: /\s+/g,
    urlHexPairs: /%[\dA-F]{2}/g,
    quotes: /"/g
};
function $8b8861dc50d423ab$var$collapseWhitespace(str) {
    return str.trim().replace($8b8861dc50d423ab$var$REGEX.whitespace, " ");
}
function $8b8861dc50d423ab$var$dataURIPayload(string) {
    return encodeURIComponent(string).replace($8b8861dc50d423ab$var$REGEX.urlHexPairs, $8b8861dc50d423ab$var$specialHexEncode);
}
// `#` gets converted to `%23`, so quite a few CSS named colors are shorter than
// their equivalent URL-encoded hex codes.
function $8b8861dc50d423ab$var$colorCodeToShorterNames(string) {
    Object.keys($dkllf).forEach(function(key) {
        if ($dkllf[key].test(string)) string = string.replace($dkllf[key], key);
    });
    return string;
}
function $8b8861dc50d423ab$var$specialHexEncode(match) {
    switch(match){
        case "%20":
            return " ";
        case "%3D":
            return "=";
        case "%3A":
            return ":";
        case "%2F":
            return "/";
        default:
            return match.toLowerCase(); // compresses better
    }
}
function $8b8861dc50d423ab$var$svgToTinyDataUri(svgString) {
    if (typeof svgString !== "string") throw new TypeError("Expected a string, but received " + typeof svgString);
    // Strip the Byte-Order Mark if the SVG has one
    if (svgString.charCodeAt(0) === 0xfeff) svgString = svgString.slice(1);
    var body = $8b8861dc50d423ab$var$colorCodeToShorterNames($8b8861dc50d423ab$var$collapseWhitespace(svgString)).replace($8b8861dc50d423ab$var$REGEX.quotes, "'");
    return "data:image/svg+xml," + $8b8861dc50d423ab$var$dataURIPayload(body);
}
$8b8861dc50d423ab$var$svgToTinyDataUri.toSrcset = function toSrcset(svgString) {
    return $8b8861dc50d423ab$var$svgToTinyDataUri(svgString).replace(/ /g, "%20");
};
module.exports = $8b8861dc50d423ab$var$svgToTinyDataUri;

});
parcelRegister("dkllf", function(module, exports) {
module.exports = {
    aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    azure: /#f0ffff(ff)?(?!\w)/gi,
    beige: /#f5f5dc(ff)?(?!\w)/gi,
    bisque: /#ffe4c4(ff)?(?!\w)/gi,
    black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
    blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
    brown: /#a52a2a(ff)?(?!\w)/gi,
    coral: /#ff7f50(ff)?(?!\w)/gi,
    cornsilk: /#fff8dc(ff)?(?!\w)/gi,
    crimson: /#dc143c(ff)?(?!\w)/gi,
    cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    darkblue: /#00008b(ff)?(?!\w)/gi,
    darkcyan: /#008b8b(ff)?(?!\w)/gi,
    darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
    darkred: /#8b0000(ff)?(?!\w)/gi,
    deeppink: /#ff1493(ff)?(?!\w)/gi,
    dimgrey: /#696969(ff)?(?!\w)/gi,
    gold: /#ffd700(ff)?(?!\w)/gi,
    green: /#008000(ff)?(?!\w)/gi,
    grey: /#808080(ff)?(?!\w)/gi,
    honeydew: /#f0fff0(ff)?(?!\w)/gi,
    hotpink: /#ff69b4(ff)?(?!\w)/gi,
    indigo: /#4b0082(ff)?(?!\w)/gi,
    ivory: /#fffff0(ff)?(?!\w)/gi,
    khaki: /#f0e68c(ff)?(?!\w)/gi,
    lavender: /#e6e6fa(ff)?(?!\w)/gi,
    lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
    linen: /#faf0e6(ff)?(?!\w)/gi,
    maroon: /#800000(ff)?(?!\w)/gi,
    moccasin: /#ffe4b5(ff)?(?!\w)/gi,
    navy: /#000080(ff)?(?!\w)/gi,
    oldlace: /#fdf5e6(ff)?(?!\w)/gi,
    olive: /#808000(ff)?(?!\w)/gi,
    orange: /#ffa500(ff)?(?!\w)/gi,
    orchid: /#da70d6(ff)?(?!\w)/gi,
    peru: /#cd853f(ff)?(?!\w)/gi,
    pink: /#ffc0cb(ff)?(?!\w)/gi,
    plum: /#dda0dd(ff)?(?!\w)/gi,
    purple: /#800080(ff)?(?!\w)/gi,
    red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
    salmon: /#fa8072(ff)?(?!\w)/gi,
    seagreen: /#2e8b57(ff)?(?!\w)/gi,
    seashell: /#fff5ee(ff)?(?!\w)/gi,
    sienna: /#a0522d(ff)?(?!\w)/gi,
    silver: /#c0c0c0(ff)?(?!\w)/gi,
    skyblue: /#87ceeb(ff)?(?!\w)/gi,
    snow: /#fffafa(ff)?(?!\w)/gi,
    tan: /#d2b48c(ff)?(?!\w)/gi,
    teal: /#008080(ff)?(?!\w)/gi,
    thistle: /#d8bfd8(ff)?(?!\w)/gi,
    tomato: /#ff6347(ff)?(?!\w)/gi,
    violet: /#ee82ee(ff)?(?!\w)/gi,
    wheat: /#f5deb3(ff)?(?!\w)/gi,
    white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi
};

});


parcelRegister("ekqU3", function(module, exports) {

var $k3VIB = parcelRequire("k3VIB");
module.exports = ($k3VIB.__esModule ? $k3VIB : {
    default: $k3VIB
}).default;

});
parcelRegister("k3VIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e9b0dc1b89d4ce68$var$_default;
    }
});

const $e9b0dc1b89d4ce68$var$_createPlugin = /*#__PURE__*/ $e9b0dc1b89d4ce68$var$_interop_require_default((parcelRequire("3Y59v")));
function $e9b0dc1b89d4ce68$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e9b0dc1b89d4ce68$var$_default = $e9b0dc1b89d4ce68$var$_createPlugin.default;

});


parcelRegister("kDXKg", function(module, exports) {

var $6eDYo = parcelRequire("6eDYo");
module.exports = ($6eDYo.__esModule ? $6eDYo : {
    default: $6eDYo
}).default;

});
parcelRegister("6eDYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $48a30eaea849c349$var$_default;
    }
});

var $egWYG = parcelRequire("egWYG");

const $48a30eaea849c349$var$_configfull = /*#__PURE__*/ $48a30eaea849c349$var$_interop_require_default((parcelRequire("9XxG9")));
function $48a30eaea849c349$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $48a30eaea849c349$var$_default = (0, $egWYG.cloneDeep)($48a30eaea849c349$var$_configfull.default.theme);

});


parcelRegister("9Laho", function(module, exports) {

var $kxNAG = parcelRequire("kxNAG");
module.exports = ($kxNAG.__esModule ? $kxNAG : {
    default: $kxNAG
}).default;

});


parcelRegister("ejmpc", function(module, exports) {
/* eslint-disable @typescript-eslint/no-var-requires */ 
var $bYJeg = parcelRequire("bYJeg");

var $ekqU3 = parcelRequire("ekqU3");

var $kDXKg = parcelRequire("kDXKg");

var $9Laho = parcelRequire("9Laho");
const [$a6b4384cc0aeb06f$var$baseFontSize, { lineHeight: $a6b4384cc0aeb06f$var$baseLineHeight }] = $kDXKg.fontSize.base;
const { spacing: $a6b4384cc0aeb06f$var$spacing, borderWidth: $a6b4384cc0aeb06f$var$borderWidth, borderRadius: $a6b4384cc0aeb06f$var$borderRadius, boxShadow: $a6b4384cc0aeb06f$var$boxShadow } = $kDXKg;
module.exports = $ekqU3.withOptions(function(options = {}) {
    // Enable forms and tooltip by default if not specified in options
    const { charts: charts = false, forms: forms = true, tooltips: tooltips = true } = options;
    return function({ addBase: addBase, addComponents: addComponents, theme: theme }) {
        // tooltip and popover styles
        if (tooltips) addBase({
            // remove from v2.x+ END
            [[
                ".tooltip-arrow",
                ".tooltip-arrow:before"
            ]]: {
                position: "absolute",
                width: "8px",
                height: "8px",
                background: "inherit"
            },
            [[
                ".tooltip-arrow"
            ]]: {
                visibility: "hidden"
            },
            [[
                ".tooltip-arrow:before"
            ]]: {
                content: '""',
                visibility: "visible",
                transform: "rotate(45deg)"
            },
            [`[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before`]: {
                "border-style": "solid",
                "border-color": $9Laho.gray[200]
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before`]: {
                "border-bottom-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before`]: {
                "border-bottom-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before`]: {
                "border-top-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before`]: {
                "border-top-width": "1px",
                "border-right-width": "1px"
            },
            [`.tooltip[data-popper-placement^='top'] > .tooltip-arrow`]: {
                bottom: "-4px"
            },
            [`.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow`]: {
                top: "-4px"
            },
            [`.tooltip[data-popper-placement^='left'] > .tooltip-arrow`]: {
                right: "-4px"
            },
            [`.tooltip[data-popper-placement^='right'] > .tooltip-arrow`]: {
                left: "-4px"
            },
            [".tooltip.invisible > .tooltip-arrow:before"]: {
                visibility: "hidden"
            },
            [[
                "[data-popper-arrow]",
                "[data-popper-arrow]:before"
            ]]: {
                position: "absolute",
                width: "8px",
                height: "8px",
                background: "inherit"
            },
            ["[data-popper-arrow]"]: {
                visibility: "hidden"
            },
            ["[data-popper-arrow]:before"]: {
                content: '""',
                visibility: "visible",
                transform: "rotate(45deg)"
            },
            ["[data-popper-arrow]:after"]: {
                content: '""',
                visibility: "visible",
                transform: "rotate(45deg)",
                position: "absolute",
                width: "9px",
                height: "9px",
                background: "inherit"
            },
            [`[role="tooltip"] > [data-popper-arrow]:before`]: {
                "border-style": "solid",
                "border-color": $9Laho.gray[200]
            },
            [`.dark [role="tooltip"] > [data-popper-arrow]:before`]: {
                "border-style": "solid",
                "border-color": $9Laho.gray[600]
            },
            [`[role="tooltip"] > [data-popper-arrow]:after`]: {
                "border-style": "solid",
                "border-color": $9Laho.gray[200]
            },
            [`.dark [role="tooltip"] > [data-popper-arrow]:after`]: {
                "border-style": "solid",
                "border-color": $9Laho.gray[600]
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before`]: {
                "border-bottom-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after`]: {
                "border-bottom-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before`]: {
                "border-bottom-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after`]: {
                "border-bottom-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before`]: {
                "border-top-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after`]: {
                "border-top-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before`]: {
                "border-top-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after`]: {
                "border-top-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]`]: {
                bottom: "-5px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]`]: {
                top: "-5px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]`]: {
                right: "-5px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]`]: {
                left: "-5px"
            },
            ['[role="tooltip"].invisible > [data-popper-arrow]:before']: {
                visibility: "hidden"
            },
            ['[role="tooltip"].invisible > [data-popper-arrow]:after']: {
                visibility: "hidden"
            }
        });
        // form styles
        if (forms) addBase({
            [[
                "[type='text']",
                "[type='email']",
                "[type='url']",
                "[type='password']",
                "[type='number']",
                "[type='date']",
                "[type='datetime-local']",
                "[type='month']",
                "[type='search']",
                "[type='tel']",
                "[type='time']",
                "[type='week']",
                "[multiple]",
                "textarea",
                "select"
            ]]: {
                appearance: "none",
                "background-color": "#fff",
                "border-color": theme("colors.gray.500", $9Laho.gray[500]),
                "border-width": $a6b4384cc0aeb06f$var$borderWidth["DEFAULT"],
                "border-radius": $a6b4384cc0aeb06f$var$borderRadius.none,
                "padding-top": $a6b4384cc0aeb06f$var$spacing[2],
                "padding-right": $a6b4384cc0aeb06f$var$spacing[3],
                "padding-bottom": $a6b4384cc0aeb06f$var$spacing[2],
                "padding-left": $a6b4384cc0aeb06f$var$spacing[3],
                "font-size": $a6b4384cc0aeb06f$var$baseFontSize,
                "line-height": $a6b4384cc0aeb06f$var$baseLineHeight,
                "--tw-shadow": "0 0 #0000",
                "&:focus": {
                    outline: "2px solid transparent",
                    "outline-offset": "2px",
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": "0px",
                    "--tw-ring-offset-color": "#fff",
                    "--tw-ring-color": theme("colors.blue.600", $9Laho.blue[600]),
                    "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                    "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                    "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`,
                    "border-color": theme("colors.blue.600", $9Laho.blue[600])
                }
            },
            [[
                "input::placeholder",
                "textarea::placeholder"
            ]]: {
                color: theme("colors.gray.500", $9Laho.gray[500]),
                opacity: "1"
            },
            ["::-webkit-datetime-edit-fields-wrapper"]: {
                padding: "0"
            },
            ["::-webkit-date-and-time-value"]: {
                "min-height": "1.5em"
            },
            ["select:not([size])"]: {
                "background-image": `url("${$bYJeg(`<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="${theme("colors.gray.500", $9Laho.gray[500])}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                          </svg>`)}")`,
                "background-position": `right ${$a6b4384cc0aeb06f$var$spacing[3]} center`,
                "background-repeat": `no-repeat`,
                "background-size": `0.75em 0.75em`,
                "padding-right": $a6b4384cc0aeb06f$var$spacing[10],
                "print-color-adjust": `exact`
            },
            ["[multiple]"]: {
                "background-image": "initial",
                "background-position": "initial",
                "background-repeat": "unset",
                "background-size": "initial",
                "padding-right": $a6b4384cc0aeb06f$var$spacing[3],
                "print-color-adjust": "unset"
            },
            [[
                `[type='checkbox']`,
                `[type='radio']`
            ]]: {
                appearance: "none",
                padding: "0",
                "print-color-adjust": "exact",
                display: "inline-block",
                "vertical-align": "middle",
                "background-origin": "border-box",
                "user-select": "none",
                "flex-shrink": "0",
                height: $a6b4384cc0aeb06f$var$spacing[4],
                width: $a6b4384cc0aeb06f$var$spacing[4],
                color: theme("colors.blue.600", $9Laho.blue[600]),
                "background-color": "#fff",
                "border-color": theme("colors.gray.500", $9Laho.gray[500]),
                "border-width": $a6b4384cc0aeb06f$var$borderWidth["DEFAULT"],
                "--tw-shadow": "0 0 #0000"
            },
            [`[type='checkbox']`]: {
                "border-radius": $a6b4384cc0aeb06f$var$borderRadius["none"]
            },
            [`[type='radio']`]: {
                "border-radius": "100%"
            },
            [[
                `[type='checkbox']:focus`,
                `[type='radio']:focus`
            ]]: {
                outline: "2px solid transparent",
                "outline-offset": "2px",
                "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                "--tw-ring-offset-width": "2px",
                "--tw-ring-offset-color": "#fff",
                "--tw-ring-color": theme("colors.blue.600", $9Laho.blue[600]),
                "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`
            },
            [[
                `[type='checkbox']:checked`,
                `[type='radio']:checked`,
                `.dark [type='checkbox']:checked`,
                `.dark [type='radio']:checked`
            ]]: {
                "border-color": `transparent`,
                "background-color": `currentColor`,
                "background-size": `0.55em 0.55em`,
                "background-position": `center`,
                "background-repeat": `no-repeat`
            },
            [`[type='checkbox']:checked`]: {
                "background-image": `url("${$bYJeg(`<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M1 5.917 5.724 10.5 15 1.5"/>
                            </svg>`)}")`,
                "background-repeat": `no-repeat`,
                "background-size": `0.55em 0.55em`,
                "print-color-adjust": `exact`
            },
            [`[type='radio']:checked`]: {
                "background-image": `url("${$bYJeg(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                "background-size": `1em 1em`
            },
            [`.dark [type='radio']:checked`]: {
                "background-image": `url("${$bYJeg(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                "background-size": `1em 1em`
            },
            [`[type='checkbox']:indeterminate`]: {
                "background-image": `url("${$bYJeg(`<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                            <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M1 5.917 5.724 10.5 15 1.5"/>
                            </svg>`)}")`,
                "background-color": `currentColor`,
                "border-color": `transparent`,
                "background-position": `center`,
                "background-repeat": `no-repeat`,
                "background-size": `0.55em 0.55em`,
                "print-color-adjust": `exact`
            },
            [[
                `[type='checkbox']:indeterminate:hover`,
                `[type='checkbox']:indeterminate:focus`
            ]]: {
                "border-color": "transparent",
                "background-color": "currentColor"
            },
            [`[type='file']`]: {
                background: "unset",
                "border-color": "inherit",
                "border-width": "0",
                "border-radius": "0",
                padding: "0",
                "font-size": "unset",
                "line-height": "inherit"
            },
            [`[type='file']:focus`]: {
                outline: `1px auto inherit`
            },
            [[
                `input[type=file]::file-selector-button`
            ]]: {
                color: "white",
                background: theme("colors.gray.800", $9Laho.gray[800]),
                border: 0,
                "font-weight": theme("fontWeight.medium"),
                "font-size": theme("fontSize.sm"),
                cursor: "pointer",
                "padding-top": $a6b4384cc0aeb06f$var$spacing[2.5],
                "padding-bottom": $a6b4384cc0aeb06f$var$spacing[2.5],
                "padding-left": $a6b4384cc0aeb06f$var$spacing[8],
                "padding-right": $a6b4384cc0aeb06f$var$spacing[4],
                "margin-inline-start": "-1rem",
                "margin-inline-end": "1rem",
                "&:hover": {
                    background: theme("colors.gray.700", $9Laho.gray[700])
                }
            },
            [[
                `.dark input[type=file]::file-selector-button`
            ]]: {
                color: "white",
                background: theme("colors.gray.600", $9Laho.gray[600]),
                "&:hover": {
                    background: theme("colors.gray.500", $9Laho.gray[500])
                }
            },
            [[
                `input[type="range"]::-webkit-slider-thumb`
            ]]: {
                height: $a6b4384cc0aeb06f$var$spacing[5],
                width: $a6b4384cc0aeb06f$var$spacing[5],
                background: theme("colors.blue.600", $9Laho.blue[600]),
                "border-radius": $a6b4384cc0aeb06f$var$borderRadius.full,
                border: 0,
                appearance: "none",
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                cursor: "pointer"
            },
            [[
                `input[type="range"]:disabled::-webkit-slider-thumb`
            ]]: {
                background: theme("colors.gray.400", $9Laho.gray[400])
            },
            [[
                `.dark input[type="range"]:disabled::-webkit-slider-thumb`
            ]]: {
                background: theme("colors.gray.500", $9Laho.gray[500])
            },
            [[
                `input[type="range"]:focus::-webkit-slider-thumb`
            ]]: {
                outline: "2px solid transparent",
                "outline-offset": "2px",
                "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
                "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
                "box-shadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
                "--tw-ring-opacity": 1,
                "--tw-ring-color": "rgb(164 202 254 / var(--tw-ring-opacity))"
            },
            [[
                `input[type="range"]::-moz-range-thumb`
            ]]: {
                height: $a6b4384cc0aeb06f$var$spacing[5],
                width: $a6b4384cc0aeb06f$var$spacing[5],
                background: theme("colors.blue.600", $9Laho.blue[600]),
                "border-radius": $a6b4384cc0aeb06f$var$borderRadius.full,
                border: 0,
                appearance: "none",
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                cursor: "pointer"
            },
            [[
                `input[type="range"]:disabled::-moz-range-thumb`
            ]]: {
                background: theme("colors.gray.400", $9Laho.gray[400])
            },
            [[
                `.dark input[type="range"]:disabled::-moz-range-thumb`
            ]]: {
                background: theme("colors.gray.500", $9Laho.gray[500])
            },
            [[
                `input[type="range"]::-moz-range-progress`
            ]]: {
                background: theme("colors.blue.500", $9Laho.blue[500])
            },
            [[
                `input[type="range"]::-ms-fill-lower`
            ]]: {
                background: theme("colors.blue.500", $9Laho.blue[500])
            },
            [[
                `input[type="range"].range-sm::-webkit-slider-thumb`
            ]]: {
                height: $a6b4384cc0aeb06f$var$spacing[4],
                width: $a6b4384cc0aeb06f$var$spacing[4]
            },
            [[
                `input[type="range"].range-lg::-webkit-slider-thumb`
            ]]: {
                height: $a6b4384cc0aeb06f$var$spacing[6],
                width: $a6b4384cc0aeb06f$var$spacing[6]
            },
            [[
                `input[type="range"].range-sm::-moz-range-thumb`
            ]]: {
                height: $a6b4384cc0aeb06f$var$spacing[4],
                width: $a6b4384cc0aeb06f$var$spacing[4]
            },
            [[
                `input[type="range"].range-lg::-moz-range-thumb`
            ]]: {
                height: $a6b4384cc0aeb06f$var$spacing[6],
                width: $a6b4384cc0aeb06f$var$spacing[6]
            },
            // remove from v2.x+
            [[
                ".toggle-bg:after"
            ]]: {
                content: '""',
                position: "absolute",
                top: $a6b4384cc0aeb06f$var$spacing[0.5],
                left: $a6b4384cc0aeb06f$var$spacing[0.5],
                background: "white",
                "border-color": theme("colors.gray.300", $9Laho.gray[300]),
                "border-width": $a6b4384cc0aeb06f$var$borderWidth["DEFAULT"],
                "border-radius": $a6b4384cc0aeb06f$var$borderRadius.full,
                height: theme("height.5"),
                width: theme("width.5"),
                "transition-property": "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter",
                "transition-duration": ".15s",
                "box-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)"
            },
            [[
                "input:checked + .toggle-bg:after"
            ]]: {
                transform: "translateX(100%);",
                "border-color": "white"
            },
            [[
                "input:checked + .toggle-bg"
            ]]: {
                background: theme("colors.blue.600", $9Laho.gray[600]),
                "border-color": theme("colors.blue.600", $9Laho.gray[600])
            }
        });
        // chart styles
        if (charts) addComponents({
            ".apexcharts-canvas .apexcharts-tooltip": {
                backgroundColor: "white",
                color: `${theme("colors.gray.500", $9Laho.gray[500])}`,
                border: "0 !important",
                borderRadius: `${theme("borderRadius.DEFAULT", $a6b4384cc0aeb06f$var$borderRadius.DEFAULT)}`,
                // padding: `${theme('spacing.3', spacing[3])}`,
                boxShadow: `${theme("boxShadow.md", $a6b4384cc0aeb06f$var$boxShadow.md)}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip": {
                backgroundColor: `${theme("colors.gray.700", $9Laho.gray[700])}`,
                color: `${theme("colors.gray.400", $9Laho.gray[400])}`,
                borderColor: "transparent",
                boxShadow: `${theme("boxShadow.md", $a6b4384cc0aeb06f$var$boxShadow.md)}`
            },
            ".apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title": {
                paddingTop: `${theme("spacing.2", $a6b4384cc0aeb06f$var$spacing[2])}`,
                paddingBottom: `${theme("spacing.2", $a6b4384cc0aeb06f$var$spacing[2])}`,
                paddingRight: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                paddingLeft: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                marginBottom: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                backgroundColor: `${theme("colors.gray.100", $9Laho.gray[100])}`,
                borderBottomColor: `${theme("colors.gray.200", $9Laho.gray[200])}`,
                fontSize: `${theme("fontSize.sm", $kDXKg.fontSize.sm)} !important`,
                fontWeight: `${theme("fontWeight.normal", $kDXKg.fontWeight.normal)}`,
                color: `${theme("colors.gray.500", $9Laho.gray[500])}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title": {
                backgroundColor: `${theme("colors.gray.600", $9Laho.gray[600])}`,
                borderColor: `${theme("colors.gray.500", $9Laho.gray[500])}`,
                color: `${theme("colors.gray.400", $9Laho.gray[400])}`
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip": {
                color: `${theme("colors.gray.500", $9Laho.gray[500])}`,
                paddingTop: `${theme("spacing.2", $a6b4384cc0aeb06f$var$spacing[2])}`,
                paddingBottom: `${theme("spacing.2", $a6b4384cc0aeb06f$var$spacing[2])}`,
                paddingRight: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                paddingLeft: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                borderColor: `transparent`,
                backgroundColor: "white",
                borderRadius: `${theme("borderRadius.DEFAULT", $a6b4384cc0aeb06f$var$borderRadius.DEFAULT)}`,
                boxShadow: `${theme("boxShadow.md", $a6b4384cc0aeb06f$var$boxShadow.md)}`
            },
            ".dark .apexcharts-canvas .apexcharts-xaxistooltip": {
                color: `${theme("colors.gray.400", $9Laho.gray[400])}`,
                backgroundColor: `${theme("colors.gray.700", $9Laho.gray[700])}`
            },
            ".apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-label": {
                color: `${theme("colors.gray.500", $9Laho.gray[500])}`,
                fontSize: `${theme("fontSize.sm", $kDXKg.fontSize.sm)}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-label": {
                color: `${theme("colors.gray.400", $9Laho.gray[400])}`
            },
            ".apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-value": {
                color: `${theme("colors.gray.900", $9Laho.gray[900])}`,
                fontSize: `${theme("fontSize.sm", $kDXKg.fontSize.sm)}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-value": {
                color: "white"
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip-text": {
                fontWeight: `${theme("fontWeight.normal", $kDXKg.fontWeight.normal)}`,
                fontSize: `${theme("fontSize.sm", $kDXKg.fontSize.sm)} !important`
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip:after, .apexcharts-canvas .apexcharts-xaxistooltip:before": {
                borderBottomColor: "white"
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip:after": {
                borderWidth: "8px",
                marginLeft: "-8px"
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip:before": {
                borderWidth: "10px",
                marginLeft: "-10px"
            },
            ".dark .apexcharts-canvas .apexcharts-xaxistooltip:after, .dark .apexcharts-canvas .apexcharts-xaxistooltip:before": {
                borderBottomColor: `${theme("colors.gray.700", $9Laho.gray[700])}`
            },
            ".apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-y-group": {
                padding: "0"
            },
            ".apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active": {
                paddingLeft: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                paddingRight: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                paddingBottom: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`,
                backgroundColor: "white !important",
                color: `${theme("colors.gray.500", $9Laho.gray[500])} !important`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active": {
                backgroundColor: `${theme("colors.gray.700", $9Laho.gray[700])} !important`,
                color: `${theme("colors.gray.400", $9Laho.gray[400])} !important`
            },
            ".apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active:first-of-type": {
                paddingTop: `${theme("spacing.3", $a6b4384cc0aeb06f$var$spacing[3])}`
            },
            ".apexcharts-canvas .apexcharts-legend": {
                padding: "0 !important"
            },
            ".apexcharts-canvas .apexcharts-legend-text": {
                fontSize: `${theme("fontSize.xs", $kDXKg.fontSize.xs)}`,
                fontWeight: `${theme("fontWeight.medium", $kDXKg.fontWeight.medium)} !important`,
                paddingLeft: `${theme("spacing.5", $a6b4384cc0aeb06f$var$spacing[5])}`,
                color: `${theme("colors.gray.500", $9Laho.gray[500])} !important`
            },
            ".apexcharts-canvas .apexcharts-legend-text:not(.apexcharts-inactive-legend):hover": {
                color: `${theme("colors.gray.900", $9Laho.gray[900])} !important`
            },
            ".dark .apexcharts-canvas .apexcharts-legend-text": {
                color: `${theme("colors.gray.400", $9Laho.gray[400])} !important`
            },
            ".dark .apexcharts-canvas .apexcharts-legend-text:not(.apexcharts-inactive-legend):hover": {
                color: `white !important`
            },
            ".apexcharts-canvas .apexcharts-legend-series": {
                marginLeft: `${theme("spacing.2", $a6b4384cc0aeb06f$var$spacing[2])}`,
                marginRight: `${theme("spacing.2", $a6b4384cc0aeb06f$var$spacing[2])}`,
                marginBottom: `${theme("spacing.1", $a6b4384cc0aeb06f$var$spacing[1])} !important`,
                display: "flex",
                alignItems: "center"
            },
            ".apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-value": {
                fill: `${theme("colors.gray.900", $9Laho.gray[900])} !important`,
                fontSize: `${theme("fontSize.3xl")}`,
                fontWeight: `${theme("fontWeight.bold", $kDXKg.fontWeight.bold)}`
            },
            ".dark .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-value": {
                fill: `white !important`
            },
            ".apexcharts-canvas .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-label": {
                fill: `${theme("colors.gray.500", $9Laho.gray[500])} !important`,
                fontSize: `${theme("fontSize.base")}`,
                fontWeight: `${theme("fontWeight.normal", $kDXKg.fontWeight.normal)}`
            },
            ".dark .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-label": {
                fill: `${theme("colors.gray.400", $9Laho.gray[400])} !important`
            },
            ".apexcharts-canvas .apexcharts-datalabels .apexcharts-text.apexcharts-pie-label": {
                fontSize: `${theme("fontSize.xs")} !important`,
                fontWeight: `${theme("fontWeight.semibold", $kDXKg.fontWeight.semibold)} !important`,
                textShadow: `${theme("boxShadow.none", $a6b4384cc0aeb06f$var$boxShadow.none)} !important`,
                filter: `none !important`
            },
            ".apexcharts-gridline, .apexcharts-xcrosshairs, .apexcharts-ycrosshairs": {
                stroke: `${theme("colors.gray.200", $9Laho.gray[200])} !important`
            },
            ".dark .apexcharts-gridline, .dark .apexcharts-xcrosshairs, .dark .apexcharts-ycrosshairs": {
                stroke: `${theme("colors.gray.700", $9Laho.gray[700])} !important`
            }
        });
    };
}, function(options = {}) {
    // Enable forms and tooltip by default if not specified in options
    const { charts: charts = false, forms: forms = true, tooltips: tooltips = true } = options;
    const safelist = [
        "w-64",
        "w-1/2",
        "rounded-l-lg",
        "rounded-r-lg",
        "bg-gray-200",
        "grid-cols-4",
        "grid-cols-7",
        "h-6",
        "leading-6",
        "h-9",
        "leading-9",
        "shadow-lg"
    ];
    if (charts) safelist.push({
        pattern: /^apexcharts-.*$/
    });
    return {
        safelist: safelist,
        darkMode: "class",
        theme: {
            extend: {
                height: {
                    modal: "calc(100% - 2rem)"
                },
                boxShadow: {
                    "sm-light": "0 2px 5px 0px rgba(255, 255, 255, 0.08)"
                },
                colors: {
                    transparent: "transparent",
                    white: "#ffffff",
                    black: "#000000",
                    gray: {
                        50: "#F9FAFB",
                        100: "#F3F4F6",
                        200: "#E5E7EB",
                        300: "#D1D5DB",
                        400: "#9CA3AF",
                        500: "#6B7280",
                        600: "#4B5563",
                        700: "#374151",
                        800: "#1F2937",
                        900: "#111827"
                    },
                    red: {
                        50: "#FDF2F2",
                        100: "#FDE8E8",
                        200: "#FBD5D5",
                        300: "#F8B4B4",
                        400: "#F98080",
                        500: "#F05252",
                        600: "#E02424",
                        700: "#C81E1E",
                        800: "#9B1C1C",
                        900: "#771D1D"
                    },
                    orange: {
                        50: "#FFF8F1",
                        100: "#FEECDC",
                        200: "#FCD9BD",
                        300: "#FDBA8C",
                        400: "#FF8A4C",
                        500: "#FF5A1F",
                        600: "#D03801",
                        700: "#B43403",
                        800: "#8A2C0D",
                        900: "#771D1D"
                    },
                    yellow: {
                        50: "#FDFDEA",
                        100: "#FDF6B2",
                        200: "#FCE96A",
                        300: "#FACA15",
                        400: "#E3A008",
                        500: "#C27803",
                        600: "#9F580A",
                        700: "#8E4B10",
                        800: "#723B13",
                        900: "#633112"
                    },
                    green: {
                        50: "#F3FAF7",
                        100: "#DEF7EC",
                        200: "#BCF0DA",
                        300: "#84E1BC",
                        400: "#31C48D",
                        500: "#0E9F6E",
                        600: "#057A55",
                        700: "#046C4E",
                        800: "#03543F",
                        900: "#014737"
                    },
                    teal: {
                        50: "#EDFAFA",
                        100: "#D5F5F6",
                        200: "#AFECEF",
                        300: "#7EDCE2",
                        400: "#16BDCA",
                        500: "#0694A2",
                        600: "#047481",
                        700: "#036672",
                        800: "#05505C",
                        900: "#014451"
                    },
                    blue: {
                        50: "#EBF5FF",
                        100: "#E1EFFE",
                        200: "#C3DDFD",
                        300: "#A4CAFE",
                        400: "#76A9FA",
                        500: "#3F83F8",
                        600: "#1C64F2",
                        700: "#1A56DB",
                        800: "#1E429F",
                        900: "#233876"
                    },
                    indigo: {
                        50: "#F0F5FF",
                        100: "#E5EDFF",
                        200: "#CDDBFE",
                        300: "#B4C6FC",
                        400: "#8DA2FB",
                        500: "#6875F5",
                        600: "#5850EC",
                        700: "#5145CD",
                        800: "#42389D",
                        900: "#362F78"
                    },
                    purple: {
                        50: "#F6F5FF",
                        100: "#EDEBFE",
                        200: "#DCD7FE",
                        300: "#CABFFD",
                        400: "#AC94FA",
                        500: "#9061F9",
                        600: "#7E3AF2",
                        700: "#6C2BD9",
                        800: "#5521B5",
                        900: "#4A1D96"
                    },
                    pink: {
                        50: "#FDF2F8",
                        100: "#FCE8F3",
                        200: "#FAD1E8",
                        300: "#F8B4D9",
                        400: "#F17EB8",
                        500: "#E74694",
                        600: "#D61F69",
                        700: "#BF125D",
                        800: "#99154B",
                        900: "#751A3D"
                    }
                }
            }
        }
    };
});

});

parcelRegister("fUXYh", function(module, exports) {

var $ekqU3 = parcelRequire("ekqU3");

var $bRVYW = parcelRequire("bRVYW");

var $iXnoR = parcelRequire("iXnoR");

var $dm4Bt = parcelRequire("dm4Bt");

var $U8wA4 = parcelRequire("U8wA4");
var $b96a9b06b373e315$require$commonTrailingPseudos = $U8wA4.commonTrailingPseudos;
const $b96a9b06b373e315$var$computed = {
};
function $b96a9b06b373e315$var$inWhere(selector, { className: className, modifier: modifier, prefix: prefix }) {
    let prefixedNot = prefix(`.not-${className}`).slice(1);
    let selectorPrefix = selector.startsWith(">") ? `${modifier === "DEFAULT" ? `.${className}` : `.${className}-${modifier}`} ` : "";
    // Parse the selector, if every component ends in the same pseudo element(s) then move it to the end
    let [trailingPseudo, rebuiltSelector] = $b96a9b06b373e315$require$commonTrailingPseudos(selector);
    if (trailingPseudo) return `:where(${selectorPrefix}${rebuiltSelector}):not(:where([class~="${prefixedNot}"],[class~="${prefixedNot}"] *))${trailingPseudo}`;
    return `:where(${selectorPrefix}${selector}):not(:where([class~="${prefixedNot}"],[class~="${prefixedNot}"] *))`;
}
function $b96a9b06b373e315$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
function $b96a9b06b373e315$var$configToCss(config = {}, { target: target, className: className, modifier: modifier, prefix: prefix }) {
    function updateSelector(k, v) {
        if (target === "legacy") return [
            k,
            v
        ];
        if (Array.isArray(v)) return [
            k,
            v
        ];
        if ($b96a9b06b373e315$var$isObject(v)) {
            let nested = Object.values(v).some($b96a9b06b373e315$var$isObject);
            if (nested) return [
                $b96a9b06b373e315$var$inWhere(k, {
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                }),
                v,
                Object.fromEntries(Object.entries(v).map(([k, v])=>updateSelector(k, v)))
            ];
            return [
                $b96a9b06b373e315$var$inWhere(k, {
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                }),
                v
            ];
        }
        return [
            k,
            v
        ];
    }
    return Object.fromEntries(Object.entries($bRVYW({}, ...Object.keys(config).filter((key)=>$b96a9b06b373e315$var$computed[key]).map((key)=>$b96a9b06b373e315$var$computed[key](config[key])), ...$iXnoR(config.css || {}))).map(([k, v])=>updateSelector(k, v)));
}
module.exports = $ekqU3.withOptions(({ className: className = "prose", target: target = "modern" } = {})=>{
    return function({ addVariant: addVariant, addComponents: addComponents, theme: theme, prefix: prefix }) {
        let modifiers = theme("typography");
        let options = {
            className: className,
            prefix: prefix
        };
        for (let [name, ...selectors] of [
            [
                "headings",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "th"
            ],
            [
                "h1"
            ],
            [
                "h2"
            ],
            [
                "h3"
            ],
            [
                "h4"
            ],
            [
                "h5"
            ],
            [
                "h6"
            ],
            [
                "p"
            ],
            [
                "a"
            ],
            [
                "blockquote"
            ],
            [
                "figure"
            ],
            [
                "figcaption"
            ],
            [
                "strong"
            ],
            [
                "em"
            ],
            [
                "kbd"
            ],
            [
                "code"
            ],
            [
                "pre"
            ],
            [
                "ol"
            ],
            [
                "ul"
            ],
            [
                "li"
            ],
            [
                "table"
            ],
            [
                "thead"
            ],
            [
                "tr"
            ],
            [
                "th"
            ],
            [
                "td"
            ],
            [
                "img"
            ],
            [
                "video"
            ],
            [
                "hr"
            ],
            [
                "lead",
                '[class~="lead"]'
            ]
        ]){
            selectors = selectors.length === 0 ? [
                name
            ] : selectors;
            let selector = target === "legacy" ? selectors.map((selector)=>`& ${selector}`) : selectors.join(", ");
            addVariant(`${className}-${name}`, target === "legacy" ? selector : `& :is(${$b96a9b06b373e315$var$inWhere(selector, options)})`);
        }
        addComponents(Object.keys(modifiers).map((modifier)=>({
                [modifier === "DEFAULT" ? `.${className}` : `.${className}-${modifier}`]: $b96a9b06b373e315$var$configToCss(modifiers[modifier], {
                    target: target,
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                })
            })));
    };
}, ()=>{
    return {
        theme: {
            typography: $dm4Bt
        }
    };
});

});
parcelRegister("bRVYW", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("iXnoR", function(module, exports) {
/**
 * lodash 4.4.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $dccfe37109aa005d$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $dccfe37109aa005d$var$isArray(value) ? value : [
        value
    ];
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $dccfe37109aa005d$var$isArray = Array.isArray;
module.exports = $dccfe37109aa005d$var$castArray;

});

parcelRegister("dm4Bt", function(module, exports) {

var $9Laho = parcelRequire("9Laho");
const $9b90e68f2e811d62$var$round = (num)=>num.toFixed(7).replace(/(\.[0-9]+?)0+$/, "$1").replace(/\.0$/, "");
const $9b90e68f2e811d62$var$rem = (px)=>`${$9b90e68f2e811d62$var$round(px / 16)}rem`;
const $9b90e68f2e811d62$var$em = (px, base)=>`${$9b90e68f2e811d62$var$round(px / base)}em`;
const $9b90e68f2e811d62$var$hexToRgb = (hex)=>{
    hex = hex.replace("#", "");
    hex = hex.length === 3 ? hex.replace(/./g, "$&$&") : hex;
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r} ${g} ${b}`;
};
let $9b90e68f2e811d62$var$defaultModifiers = {
    sm: {
        css: [
            {
                fontSize: $9b90e68f2e811d62$var$rem(14),
                lineHeight: $9b90e68f2e811d62$var$round(24 / 14),
                p: {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 14)
                },
                '[class~="lead"]': {
                    fontSize: $9b90e68f2e811d62$var$em(18, 14),
                    lineHeight: $9b90e68f2e811d62$var$round(28 / 18),
                    marginTop: $9b90e68f2e811d62$var$em(16, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 18)
                },
                blockquote: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(20, 18)
                },
                h1: {
                    fontSize: $9b90e68f2e811d62$var$em(30, 14),
                    marginTop: "0",
                    marginBottom: $9b90e68f2e811d62$var$em(24, 30),
                    lineHeight: $9b90e68f2e811d62$var$round(1.2)
                },
                h2: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 14),
                    marginTop: $9b90e68f2e811d62$var$em(32, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(1.4)
                },
                h3: {
                    fontSize: $9b90e68f2e811d62$var$em(18, 14),
                    marginTop: $9b90e68f2e811d62$var$em(28, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 18),
                    lineHeight: $9b90e68f2e811d62$var$round(28 / 18)
                },
                h4: {
                    marginTop: $9b90e68f2e811d62$var$em(20, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 14),
                    lineHeight: $9b90e68f2e811d62$var$round(20 / 14)
                },
                img: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 14)
                },
                picture: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 14)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 14)
                },
                kbd: {
                    fontSize: $9b90e68f2e811d62$var$em(12, 14),
                    borderRadius: $9b90e68f2e811d62$var$rem(5),
                    paddingTop: $9b90e68f2e811d62$var$em(2, 14),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(5, 14),
                    paddingBottom: $9b90e68f2e811d62$var$em(2, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(5, 14)
                },
                code: {
                    fontSize: $9b90e68f2e811d62$var$em(12, 14)
                },
                "h2 code": {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20)
                },
                "h3 code": {
                    fontSize: $9b90e68f2e811d62$var$em(16, 18)
                },
                pre: {
                    fontSize: $9b90e68f2e811d62$var$em(12, 14),
                    lineHeight: $9b90e68f2e811d62$var$round(20 / 12),
                    marginTop: $9b90e68f2e811d62$var$em(20, 12),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 12),
                    borderRadius: $9b90e68f2e811d62$var$rem(4),
                    paddingTop: $9b90e68f2e811d62$var$em(8, 12),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 12),
                    paddingBottom: $9b90e68f2e811d62$var$em(8, 12),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 12)
                },
                ol: {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(22, 14)
                },
                ul: {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(22, 14)
                },
                li: {
                    marginTop: $9b90e68f2e811d62$var$em(4, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(4, 14)
                },
                "ol > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(6, 14)
                },
                "ul > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(6, 14)
                },
                "> ul > li p": {
                    marginTop: $9b90e68f2e811d62$var$em(8, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 14)
                },
                "> ul > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(16, 14)
                },
                "> ol > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(16, 14)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9b90e68f2e811d62$var$em(8, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 14)
                },
                dl: {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 14)
                },
                dt: {
                    marginTop: $9b90e68f2e811d62$var$em(16, 14)
                },
                dd: {
                    marginTop: $9b90e68f2e811d62$var$em(4, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(22, 14)
                },
                hr: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 14)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9b90e68f2e811d62$var$em(12, 14),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5)
                },
                "thead th": {
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 12),
                    paddingBottom: $9b90e68f2e811d62$var$em(8, 12),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 12)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9b90e68f2e811d62$var$em(8, 12),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 12),
                    paddingBottom: $9b90e68f2e811d62$var$em(8, 12),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 12)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 14)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9b90e68f2e811d62$var$em(12, 14),
                    lineHeight: $9b90e68f2e811d62$var$round(16 / 12),
                    marginTop: $9b90e68f2e811d62$var$em(8, 12)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    base: {
        css: [
            {
                fontSize: $9b90e68f2e811d62$var$rem(16),
                lineHeight: $9b90e68f2e811d62$var$round(1.75),
                p: {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 16)
                },
                '[class~="lead"]': {
                    fontSize: $9b90e68f2e811d62$var$em(20, 16),
                    lineHeight: $9b90e68f2e811d62$var$round(1.6),
                    marginTop: $9b90e68f2e811d62$var$em(24, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20)
                },
                blockquote: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(20, 20)
                },
                h1: {
                    fontSize: $9b90e68f2e811d62$var$em(36, 16),
                    marginTop: "0",
                    marginBottom: $9b90e68f2e811d62$var$em(32, 36),
                    lineHeight: $9b90e68f2e811d62$var$round(40 / 36)
                },
                h2: {
                    fontSize: $9b90e68f2e811d62$var$em(24, 16),
                    marginTop: $9b90e68f2e811d62$var$em(48, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(32 / 24)
                },
                h3: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 16),
                    marginTop: $9b90e68f2e811d62$var$em(32, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(1.6)
                },
                h4: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 16),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5)
                },
                img: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 16)
                },
                picture: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 16)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 16)
                },
                kbd: {
                    fontSize: $9b90e68f2e811d62$var$em(14, 16),
                    borderRadius: $9b90e68f2e811d62$var$rem(5),
                    paddingTop: $9b90e68f2e811d62$var$em(3, 16),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(6, 16),
                    paddingBottom: $9b90e68f2e811d62$var$em(3, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(6, 16)
                },
                code: {
                    fontSize: $9b90e68f2e811d62$var$em(14, 16)
                },
                "h2 code": {
                    fontSize: $9b90e68f2e811d62$var$em(21, 24)
                },
                "h3 code": {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20)
                },
                pre: {
                    fontSize: $9b90e68f2e811d62$var$em(14, 16),
                    lineHeight: $9b90e68f2e811d62$var$round(24 / 14),
                    marginTop: $9b90e68f2e811d62$var$em(24, 14),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 14),
                    borderRadius: $9b90e68f2e811d62$var$rem(6),
                    paddingTop: $9b90e68f2e811d62$var$em(12, 14),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(16, 14),
                    paddingBottom: $9b90e68f2e811d62$var$em(12, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(16, 14)
                },
                ol: {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(26, 16)
                },
                ul: {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(26, 16)
                },
                li: {
                    marginTop: $9b90e68f2e811d62$var$em(8, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 16)
                },
                "ol > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(6, 16)
                },
                "ul > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(6, 16)
                },
                "> ul > li p": {
                    marginTop: $9b90e68f2e811d62$var$em(12, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 16)
                },
                "> ul > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(20, 16)
                },
                "> ol > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(20, 16)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9b90e68f2e811d62$var$em(12, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 16)
                },
                dl: {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 16)
                },
                dt: {
                    marginTop: $9b90e68f2e811d62$var$em(20, 16)
                },
                dd: {
                    marginTop: $9b90e68f2e811d62$var$em(8, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(26, 16)
                },
                hr: {
                    marginTop: $9b90e68f2e811d62$var$em(48, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(48, 16)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9b90e68f2e811d62$var$em(14, 16),
                    lineHeight: $9b90e68f2e811d62$var$round(24 / 14)
                },
                "thead th": {
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(8, 14),
                    paddingBottom: $9b90e68f2e811d62$var$em(8, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 14)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9b90e68f2e811d62$var$em(8, 14),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(8, 14),
                    paddingBottom: $9b90e68f2e811d62$var$em(8, 14),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 14)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 16)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9b90e68f2e811d62$var$em(14, 16),
                    lineHeight: $9b90e68f2e811d62$var$round(20 / 14),
                    marginTop: $9b90e68f2e811d62$var$em(12, 14)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    lg: {
        css: [
            {
                fontSize: $9b90e68f2e811d62$var$rem(18),
                lineHeight: $9b90e68f2e811d62$var$round(32 / 18),
                p: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18)
                },
                '[class~="lead"]': {
                    fontSize: $9b90e68f2e811d62$var$em(22, 18),
                    lineHeight: $9b90e68f2e811d62$var$round(32 / 22),
                    marginTop: $9b90e68f2e811d62$var$em(24, 22),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 22)
                },
                blockquote: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 24),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(24, 24)
                },
                h1: {
                    fontSize: $9b90e68f2e811d62$var$em(48, 18),
                    marginTop: "0",
                    marginBottom: $9b90e68f2e811d62$var$em(40, 48),
                    lineHeight: $9b90e68f2e811d62$var$round(1)
                },
                h2: {
                    fontSize: $9b90e68f2e811d62$var$em(30, 18),
                    marginTop: $9b90e68f2e811d62$var$em(56, 30),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 30),
                    lineHeight: $9b90e68f2e811d62$var$round(40 / 30)
                },
                h3: {
                    fontSize: $9b90e68f2e811d62$var$em(24, 18),
                    marginTop: $9b90e68f2e811d62$var$em(40, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5)
                },
                h4: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(8, 18),
                    lineHeight: $9b90e68f2e811d62$var$round(28 / 18)
                },
                img: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 18)
                },
                picture: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 18)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 18)
                },
                kbd: {
                    fontSize: $9b90e68f2e811d62$var$em(16, 18),
                    borderRadius: $9b90e68f2e811d62$var$rem(5),
                    paddingTop: $9b90e68f2e811d62$var$em(4, 18),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(8, 18),
                    paddingBottom: $9b90e68f2e811d62$var$em(4, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 18)
                },
                code: {
                    fontSize: $9b90e68f2e811d62$var$em(16, 18)
                },
                "h2 code": {
                    fontSize: $9b90e68f2e811d62$var$em(26, 30)
                },
                "h3 code": {
                    fontSize: $9b90e68f2e811d62$var$em(21, 24)
                },
                pre: {
                    fontSize: $9b90e68f2e811d62$var$em(16, 18),
                    lineHeight: $9b90e68f2e811d62$var$round(1.75),
                    marginTop: $9b90e68f2e811d62$var$em(32, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 16),
                    borderRadius: $9b90e68f2e811d62$var$rem(6),
                    paddingTop: $9b90e68f2e811d62$var$em(16, 16),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(24, 16),
                    paddingBottom: $9b90e68f2e811d62$var$em(16, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(24, 16)
                },
                ol: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(28, 18)
                },
                ul: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(28, 18)
                },
                li: {
                    marginTop: $9b90e68f2e811d62$var$em(12, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 18)
                },
                "ol > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 18)
                },
                "ul > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 18)
                },
                "> ul > li p": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 18)
                },
                "> ul > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18)
                },
                "> ol > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 18)
                },
                dl: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 18)
                },
                dt: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 18)
                },
                dd: {
                    marginTop: $9b90e68f2e811d62$var$em(12, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(28, 18)
                },
                hr: {
                    marginTop: $9b90e68f2e811d62$var$em(56, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(56, 18)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9b90e68f2e811d62$var$em(16, 18),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5)
                },
                "thead th": {
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 16),
                    paddingBottom: $9b90e68f2e811d62$var$em(12, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 16)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9b90e68f2e811d62$var$em(12, 16),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 16),
                    paddingBottom: $9b90e68f2e811d62$var$em(12, 16),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 16)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 18)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9b90e68f2e811d62$var$em(16, 18),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5),
                    marginTop: $9b90e68f2e811d62$var$em(16, 16)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    xl: {
        css: [
            {
                fontSize: $9b90e68f2e811d62$var$rem(20),
                lineHeight: $9b90e68f2e811d62$var$round(1.8),
                p: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20)
                },
                '[class~="lead"]': {
                    fontSize: $9b90e68f2e811d62$var$em(24, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5),
                    marginTop: $9b90e68f2e811d62$var$em(24, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 24)
                },
                blockquote: {
                    marginTop: $9b90e68f2e811d62$var$em(48, 30),
                    marginBottom: $9b90e68f2e811d62$var$em(48, 30),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(32, 30)
                },
                h1: {
                    fontSize: $9b90e68f2e811d62$var$em(56, 20),
                    marginTop: "0",
                    marginBottom: $9b90e68f2e811d62$var$em(48, 56),
                    lineHeight: $9b90e68f2e811d62$var$round(1)
                },
                h2: {
                    fontSize: $9b90e68f2e811d62$var$em(36, 20),
                    marginTop: $9b90e68f2e811d62$var$em(56, 36),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 36),
                    lineHeight: $9b90e68f2e811d62$var$round(40 / 36)
                },
                h3: {
                    fontSize: $9b90e68f2e811d62$var$em(30, 20),
                    marginTop: $9b90e68f2e811d62$var$em(48, 30),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 30),
                    lineHeight: $9b90e68f2e811d62$var$round(40 / 30)
                },
                h4: {
                    marginTop: $9b90e68f2e811d62$var$em(36, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(1.6)
                },
                img: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 20)
                },
                picture: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 20)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 20)
                },
                kbd: {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20),
                    borderRadius: $9b90e68f2e811d62$var$rem(5),
                    paddingTop: $9b90e68f2e811d62$var$em(5, 20),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(8, 20),
                    paddingBottom: $9b90e68f2e811d62$var$em(5, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 20)
                },
                code: {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20)
                },
                "h2 code": {
                    fontSize: $9b90e68f2e811d62$var$em(31, 36)
                },
                "h3 code": {
                    fontSize: $9b90e68f2e811d62$var$em(27, 30)
                },
                pre: {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(32 / 18),
                    marginTop: $9b90e68f2e811d62$var$em(36, 18),
                    marginBottom: $9b90e68f2e811d62$var$em(36, 18),
                    borderRadius: $9b90e68f2e811d62$var$rem(8),
                    paddingTop: $9b90e68f2e811d62$var$em(20, 18),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(24, 18),
                    paddingBottom: $9b90e68f2e811d62$var$em(20, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(24, 18)
                },
                ol: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(32, 20)
                },
                ul: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(32, 20)
                },
                li: {
                    marginTop: $9b90e68f2e811d62$var$em(12, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 20)
                },
                "ol > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 20)
                },
                "ul > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 20)
                },
                "> ul > li p": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 20)
                },
                "> ul > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20)
                },
                "> ol > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 20)
                },
                dl: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 20)
                },
                dt: {
                    marginTop: $9b90e68f2e811d62$var$em(24, 20)
                },
                dd: {
                    marginTop: $9b90e68f2e811d62$var$em(12, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(32, 20)
                },
                hr: {
                    marginTop: $9b90e68f2e811d62$var$em(56, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(56, 20)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(28 / 18)
                },
                "thead th": {
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 18),
                    paddingBottom: $9b90e68f2e811d62$var$em(16, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 18)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9b90e68f2e811d62$var$em(16, 18),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 18),
                    paddingBottom: $9b90e68f2e811d62$var$em(16, 18),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 18)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 20)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9b90e68f2e811d62$var$em(18, 20),
                    lineHeight: $9b90e68f2e811d62$var$round(28 / 18),
                    marginTop: $9b90e68f2e811d62$var$em(18, 18)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    "2xl": {
        css: [
            {
                fontSize: $9b90e68f2e811d62$var$rem(24),
                lineHeight: $9b90e68f2e811d62$var$round(40 / 24),
                p: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 24)
                },
                '[class~="lead"]': {
                    fontSize: $9b90e68f2e811d62$var$em(30, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(44 / 30),
                    marginTop: $9b90e68f2e811d62$var$em(32, 30),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 30)
                },
                blockquote: {
                    marginTop: $9b90e68f2e811d62$var$em(64, 36),
                    marginBottom: $9b90e68f2e811d62$var$em(64, 36),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(40, 36)
                },
                h1: {
                    fontSize: $9b90e68f2e811d62$var$em(64, 24),
                    marginTop: "0",
                    marginBottom: $9b90e68f2e811d62$var$em(56, 64),
                    lineHeight: $9b90e68f2e811d62$var$round(1)
                },
                h2: {
                    fontSize: $9b90e68f2e811d62$var$em(48, 24),
                    marginTop: $9b90e68f2e811d62$var$em(72, 48),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 48),
                    lineHeight: $9b90e68f2e811d62$var$round(52 / 48)
                },
                h3: {
                    fontSize: $9b90e68f2e811d62$var$em(36, 24),
                    marginTop: $9b90e68f2e811d62$var$em(56, 36),
                    marginBottom: $9b90e68f2e811d62$var$em(24, 36),
                    lineHeight: $9b90e68f2e811d62$var$round(44 / 36)
                },
                h4: {
                    marginTop: $9b90e68f2e811d62$var$em(40, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(1.5)
                },
                img: {
                    marginTop: $9b90e68f2e811d62$var$em(48, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(48, 24)
                },
                picture: {
                    marginTop: $9b90e68f2e811d62$var$em(48, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(48, 24)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $9b90e68f2e811d62$var$em(48, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(48, 24)
                },
                kbd: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 24),
                    borderRadius: $9b90e68f2e811d62$var$rem(6),
                    paddingTop: $9b90e68f2e811d62$var$em(6, 24),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(8, 24),
                    paddingBottom: $9b90e68f2e811d62$var$em(6, 24),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(8, 24)
                },
                code: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 24)
                },
                "h2 code": {
                    fontSize: $9b90e68f2e811d62$var$em(42, 48)
                },
                "h3 code": {
                    fontSize: $9b90e68f2e811d62$var$em(32, 36)
                },
                pre: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(1.8),
                    marginTop: $9b90e68f2e811d62$var$em(40, 20),
                    marginBottom: $9b90e68f2e811d62$var$em(40, 20),
                    borderRadius: $9b90e68f2e811d62$var$rem(8),
                    paddingTop: $9b90e68f2e811d62$var$em(24, 20),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(32, 20),
                    paddingBottom: $9b90e68f2e811d62$var$em(24, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(32, 20)
                },
                ol: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 24),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(38, 24)
                },
                ul: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 24),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(38, 24)
                },
                li: {
                    marginTop: $9b90e68f2e811d62$var$em(12, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(12, 24)
                },
                "ol > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(10, 24)
                },
                "ul > li": {
                    paddingInlineStart: $9b90e68f2e811d62$var$em(10, 24)
                },
                "> ul > li p": {
                    marginTop: $9b90e68f2e811d62$var$em(20, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(20, 24)
                },
                "> ul > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(32, 24)
                },
                "> ol > li > p:first-child": {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $9b90e68f2e811d62$var$em(32, 24)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9b90e68f2e811d62$var$em(16, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(16, 24)
                },
                dl: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 24)
                },
                dt: {
                    marginTop: $9b90e68f2e811d62$var$em(32, 24)
                },
                dd: {
                    marginTop: $9b90e68f2e811d62$var$em(12, 24),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(38, 24)
                },
                hr: {
                    marginTop: $9b90e68f2e811d62$var$em(72, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(72, 24)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(1.4)
                },
                "thead th": {
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 20),
                    paddingBottom: $9b90e68f2e811d62$var$em(16, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 20)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9b90e68f2e811d62$var$em(16, 20),
                    paddingInlineEnd: $9b90e68f2e811d62$var$em(12, 20),
                    paddingBottom: $9b90e68f2e811d62$var$em(16, 20),
                    paddingInlineStart: $9b90e68f2e811d62$var$em(12, 20)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $9b90e68f2e811d62$var$em(48, 24),
                    marginBottom: $9b90e68f2e811d62$var$em(48, 24)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9b90e68f2e811d62$var$em(20, 24),
                    lineHeight: $9b90e68f2e811d62$var$round(1.6),
                    marginTop: $9b90e68f2e811d62$var$em(20, 20)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    // Gray color themes
    slate: {
        css: {
            "--tw-prose-body": $9Laho.slate[700],
            "--tw-prose-headings": $9Laho.slate[900],
            "--tw-prose-lead": $9Laho.slate[600],
            "--tw-prose-links": $9Laho.slate[900],
            "--tw-prose-bold": $9Laho.slate[900],
            "--tw-prose-counters": $9Laho.slate[500],
            "--tw-prose-bullets": $9Laho.slate[300],
            "--tw-prose-hr": $9Laho.slate[200],
            "--tw-prose-quotes": $9Laho.slate[900],
            "--tw-prose-quote-borders": $9Laho.slate[200],
            "--tw-prose-captions": $9Laho.slate[500],
            "--tw-prose-kbd": $9Laho.slate[900],
            "--tw-prose-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.slate[900]),
            "--tw-prose-code": $9Laho.slate[900],
            "--tw-prose-pre-code": $9Laho.slate[200],
            "--tw-prose-pre-bg": $9Laho.slate[800],
            "--tw-prose-th-borders": $9Laho.slate[300],
            "--tw-prose-td-borders": $9Laho.slate[200],
            "--tw-prose-invert-body": $9Laho.slate[300],
            "--tw-prose-invert-headings": $9Laho.white,
            "--tw-prose-invert-lead": $9Laho.slate[400],
            "--tw-prose-invert-links": $9Laho.white,
            "--tw-prose-invert-bold": $9Laho.white,
            "--tw-prose-invert-counters": $9Laho.slate[400],
            "--tw-prose-invert-bullets": $9Laho.slate[600],
            "--tw-prose-invert-hr": $9Laho.slate[700],
            "--tw-prose-invert-quotes": $9Laho.slate[100],
            "--tw-prose-invert-quote-borders": $9Laho.slate[700],
            "--tw-prose-invert-captions": $9Laho.slate[400],
            "--tw-prose-invert-kbd": $9Laho.white,
            "--tw-prose-invert-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.white),
            "--tw-prose-invert-code": $9Laho.white,
            "--tw-prose-invert-pre-code": $9Laho.slate[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $9Laho.slate[600],
            "--tw-prose-invert-td-borders": $9Laho.slate[700]
        }
    },
    gray: {
        css: {
            "--tw-prose-body": $9Laho.gray[700],
            "--tw-prose-headings": $9Laho.gray[900],
            "--tw-prose-lead": $9Laho.gray[600],
            "--tw-prose-links": $9Laho.gray[900],
            "--tw-prose-bold": $9Laho.gray[900],
            "--tw-prose-counters": $9Laho.gray[500],
            "--tw-prose-bullets": $9Laho.gray[300],
            "--tw-prose-hr": $9Laho.gray[200],
            "--tw-prose-quotes": $9Laho.gray[900],
            "--tw-prose-quote-borders": $9Laho.gray[200],
            "--tw-prose-captions": $9Laho.gray[500],
            "--tw-prose-kbd": $9Laho.gray[900],
            "--tw-prose-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.gray[900]),
            "--tw-prose-code": $9Laho.gray[900],
            "--tw-prose-pre-code": $9Laho.gray[200],
            "--tw-prose-pre-bg": $9Laho.gray[800],
            "--tw-prose-th-borders": $9Laho.gray[300],
            "--tw-prose-td-borders": $9Laho.gray[200],
            "--tw-prose-invert-body": $9Laho.gray[300],
            "--tw-prose-invert-headings": $9Laho.white,
            "--tw-prose-invert-lead": $9Laho.gray[400],
            "--tw-prose-invert-links": $9Laho.white,
            "--tw-prose-invert-bold": $9Laho.white,
            "--tw-prose-invert-counters": $9Laho.gray[400],
            "--tw-prose-invert-bullets": $9Laho.gray[600],
            "--tw-prose-invert-hr": $9Laho.gray[700],
            "--tw-prose-invert-quotes": $9Laho.gray[100],
            "--tw-prose-invert-quote-borders": $9Laho.gray[700],
            "--tw-prose-invert-captions": $9Laho.gray[400],
            "--tw-prose-invert-kbd": $9Laho.white,
            "--tw-prose-invert-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.white),
            "--tw-prose-invert-code": $9Laho.white,
            "--tw-prose-invert-pre-code": $9Laho.gray[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $9Laho.gray[600],
            "--tw-prose-invert-td-borders": $9Laho.gray[700]
        }
    },
    zinc: {
        css: {
            "--tw-prose-body": $9Laho.zinc[700],
            "--tw-prose-headings": $9Laho.zinc[900],
            "--tw-prose-lead": $9Laho.zinc[600],
            "--tw-prose-links": $9Laho.zinc[900],
            "--tw-prose-bold": $9Laho.zinc[900],
            "--tw-prose-counters": $9Laho.zinc[500],
            "--tw-prose-bullets": $9Laho.zinc[300],
            "--tw-prose-hr": $9Laho.zinc[200],
            "--tw-prose-quotes": $9Laho.zinc[900],
            "--tw-prose-quote-borders": $9Laho.zinc[200],
            "--tw-prose-captions": $9Laho.zinc[500],
            "--tw-prose-kbd": $9Laho.zinc[900],
            "--tw-prose-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.zinc[900]),
            "--tw-prose-code": $9Laho.zinc[900],
            "--tw-prose-pre-code": $9Laho.zinc[200],
            "--tw-prose-pre-bg": $9Laho.zinc[800],
            "--tw-prose-th-borders": $9Laho.zinc[300],
            "--tw-prose-td-borders": $9Laho.zinc[200],
            "--tw-prose-invert-body": $9Laho.zinc[300],
            "--tw-prose-invert-headings": $9Laho.white,
            "--tw-prose-invert-lead": $9Laho.zinc[400],
            "--tw-prose-invert-links": $9Laho.white,
            "--tw-prose-invert-bold": $9Laho.white,
            "--tw-prose-invert-counters": $9Laho.zinc[400],
            "--tw-prose-invert-bullets": $9Laho.zinc[600],
            "--tw-prose-invert-hr": $9Laho.zinc[700],
            "--tw-prose-invert-quotes": $9Laho.zinc[100],
            "--tw-prose-invert-quote-borders": $9Laho.zinc[700],
            "--tw-prose-invert-captions": $9Laho.zinc[400],
            "--tw-prose-invert-kbd": $9Laho.white,
            "--tw-prose-invert-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.white),
            "--tw-prose-invert-code": $9Laho.white,
            "--tw-prose-invert-pre-code": $9Laho.zinc[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $9Laho.zinc[600],
            "--tw-prose-invert-td-borders": $9Laho.zinc[700]
        }
    },
    neutral: {
        css: {
            "--tw-prose-body": $9Laho.neutral[700],
            "--tw-prose-headings": $9Laho.neutral[900],
            "--tw-prose-lead": $9Laho.neutral[600],
            "--tw-prose-links": $9Laho.neutral[900],
            "--tw-prose-bold": $9Laho.neutral[900],
            "--tw-prose-counters": $9Laho.neutral[500],
            "--tw-prose-bullets": $9Laho.neutral[300],
            "--tw-prose-hr": $9Laho.neutral[200],
            "--tw-prose-quotes": $9Laho.neutral[900],
            "--tw-prose-quote-borders": $9Laho.neutral[200],
            "--tw-prose-captions": $9Laho.neutral[500],
            "--tw-prose-kbd": $9Laho.neutral[900],
            "--tw-prose-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.neutral[900]),
            "--tw-prose-code": $9Laho.neutral[900],
            "--tw-prose-pre-code": $9Laho.neutral[200],
            "--tw-prose-pre-bg": $9Laho.neutral[800],
            "--tw-prose-th-borders": $9Laho.neutral[300],
            "--tw-prose-td-borders": $9Laho.neutral[200],
            "--tw-prose-invert-body": $9Laho.neutral[300],
            "--tw-prose-invert-headings": $9Laho.white,
            "--tw-prose-invert-lead": $9Laho.neutral[400],
            "--tw-prose-invert-links": $9Laho.white,
            "--tw-prose-invert-bold": $9Laho.white,
            "--tw-prose-invert-counters": $9Laho.neutral[400],
            "--tw-prose-invert-bullets": $9Laho.neutral[600],
            "--tw-prose-invert-hr": $9Laho.neutral[700],
            "--tw-prose-invert-quotes": $9Laho.neutral[100],
            "--tw-prose-invert-quote-borders": $9Laho.neutral[700],
            "--tw-prose-invert-captions": $9Laho.neutral[400],
            "--tw-prose-invert-kbd": $9Laho.white,
            "--tw-prose-invert-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.white),
            "--tw-prose-invert-code": $9Laho.white,
            "--tw-prose-invert-pre-code": $9Laho.neutral[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $9Laho.neutral[600],
            "--tw-prose-invert-td-borders": $9Laho.neutral[700]
        }
    },
    stone: {
        css: {
            "--tw-prose-body": $9Laho.stone[700],
            "--tw-prose-headings": $9Laho.stone[900],
            "--tw-prose-lead": $9Laho.stone[600],
            "--tw-prose-links": $9Laho.stone[900],
            "--tw-prose-bold": $9Laho.stone[900],
            "--tw-prose-counters": $9Laho.stone[500],
            "--tw-prose-bullets": $9Laho.stone[300],
            "--tw-prose-hr": $9Laho.stone[200],
            "--tw-prose-quotes": $9Laho.stone[900],
            "--tw-prose-quote-borders": $9Laho.stone[200],
            "--tw-prose-captions": $9Laho.stone[500],
            "--tw-prose-kbd": $9Laho.stone[900],
            "--tw-prose-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.stone[900]),
            "--tw-prose-code": $9Laho.stone[900],
            "--tw-prose-pre-code": $9Laho.stone[200],
            "--tw-prose-pre-bg": $9Laho.stone[800],
            "--tw-prose-th-borders": $9Laho.stone[300],
            "--tw-prose-td-borders": $9Laho.stone[200],
            "--tw-prose-invert-body": $9Laho.stone[300],
            "--tw-prose-invert-headings": $9Laho.white,
            "--tw-prose-invert-lead": $9Laho.stone[400],
            "--tw-prose-invert-links": $9Laho.white,
            "--tw-prose-invert-bold": $9Laho.white,
            "--tw-prose-invert-counters": $9Laho.stone[400],
            "--tw-prose-invert-bullets": $9Laho.stone[600],
            "--tw-prose-invert-hr": $9Laho.stone[700],
            "--tw-prose-invert-quotes": $9Laho.stone[100],
            "--tw-prose-invert-quote-borders": $9Laho.stone[700],
            "--tw-prose-invert-captions": $9Laho.stone[400],
            "--tw-prose-invert-kbd": $9Laho.white,
            "--tw-prose-invert-kbd-shadows": $9b90e68f2e811d62$var$hexToRgb($9Laho.white),
            "--tw-prose-invert-code": $9Laho.white,
            "--tw-prose-invert-pre-code": $9Laho.stone[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $9Laho.stone[600],
            "--tw-prose-invert-td-borders": $9Laho.stone[700]
        }
    },
    // Link-only themes (for backward compatibility)
    red: {
        css: {
            "--tw-prose-links": $9Laho.red[600],
            "--tw-prose-invert-links": $9Laho.red[500]
        }
    },
    orange: {
        css: {
            "--tw-prose-links": $9Laho.orange[600],
            "--tw-prose-invert-links": $9Laho.orange[500]
        }
    },
    amber: {
        css: {
            "--tw-prose-links": $9Laho.amber[600],
            "--tw-prose-invert-links": $9Laho.amber[500]
        }
    },
    yellow: {
        css: {
            "--tw-prose-links": $9Laho.yellow[600],
            "--tw-prose-invert-links": $9Laho.yellow[500]
        }
    },
    lime: {
        css: {
            "--tw-prose-links": $9Laho.lime[600],
            "--tw-prose-invert-links": $9Laho.lime[500]
        }
    },
    green: {
        css: {
            "--tw-prose-links": $9Laho.green[600],
            "--tw-prose-invert-links": $9Laho.green[500]
        }
    },
    emerald: {
        css: {
            "--tw-prose-links": $9Laho.emerald[600],
            "--tw-prose-invert-links": $9Laho.emerald[500]
        }
    },
    teal: {
        css: {
            "--tw-prose-links": $9Laho.teal[600],
            "--tw-prose-invert-links": $9Laho.teal[500]
        }
    },
    cyan: {
        css: {
            "--tw-prose-links": $9Laho.cyan[600],
            "--tw-prose-invert-links": $9Laho.cyan[500]
        }
    },
    sky: {
        css: {
            "--tw-prose-links": $9Laho.sky[600],
            "--tw-prose-invert-links": $9Laho.sky[500]
        }
    },
    blue: {
        css: {
            "--tw-prose-links": $9Laho.blue[600],
            "--tw-prose-invert-links": $9Laho.blue[500]
        }
    },
    indigo: {
        css: {
            "--tw-prose-links": $9Laho.indigo[600],
            "--tw-prose-invert-links": $9Laho.indigo[500]
        }
    },
    violet: {
        css: {
            "--tw-prose-links": $9Laho.violet[600],
            "--tw-prose-invert-links": $9Laho.violet[500]
        }
    },
    purple: {
        css: {
            "--tw-prose-links": $9Laho.purple[600],
            "--tw-prose-invert-links": $9Laho.purple[500]
        }
    },
    fuchsia: {
        css: {
            "--tw-prose-links": $9Laho.fuchsia[600],
            "--tw-prose-invert-links": $9Laho.fuchsia[500]
        }
    },
    pink: {
        css: {
            "--tw-prose-links": $9Laho.pink[600],
            "--tw-prose-invert-links": $9Laho.pink[500]
        }
    },
    rose: {
        css: {
            "--tw-prose-links": $9Laho.rose[600],
            "--tw-prose-invert-links": $9Laho.rose[500]
        }
    },
    // Invert (for dark mode)
    invert: {
        css: {
            "--tw-prose-body": "var(--tw-prose-invert-body)",
            "--tw-prose-headings": "var(--tw-prose-invert-headings)",
            "--tw-prose-lead": "var(--tw-prose-invert-lead)",
            "--tw-prose-links": "var(--tw-prose-invert-links)",
            "--tw-prose-bold": "var(--tw-prose-invert-bold)",
            "--tw-prose-counters": "var(--tw-prose-invert-counters)",
            "--tw-prose-bullets": "var(--tw-prose-invert-bullets)",
            "--tw-prose-hr": "var(--tw-prose-invert-hr)",
            "--tw-prose-quotes": "var(--tw-prose-invert-quotes)",
            "--tw-prose-quote-borders": "var(--tw-prose-invert-quote-borders)",
            "--tw-prose-captions": "var(--tw-prose-invert-captions)",
            "--tw-prose-kbd": "var(--tw-prose-invert-kbd)",
            "--tw-prose-kbd-shadows": "var(--tw-prose-invert-kbd-shadows)",
            "--tw-prose-code": "var(--tw-prose-invert-code)",
            "--tw-prose-pre-code": "var(--tw-prose-invert-pre-code)",
            "--tw-prose-pre-bg": "var(--tw-prose-invert-pre-bg)",
            "--tw-prose-th-borders": "var(--tw-prose-invert-th-borders)",
            "--tw-prose-td-borders": "var(--tw-prose-invert-td-borders)"
        }
    }
};
module.exports = {
    DEFAULT: {
        css: [
            {
                color: "var(--tw-prose-body)",
                maxWidth: "65ch",
                p: {},
                '[class~="lead"]': {
                    color: "var(--tw-prose-lead)"
                },
                a: {
                    color: "var(--tw-prose-links)",
                    textDecoration: "underline",
                    fontWeight: "500"
                },
                strong: {
                    color: "var(--tw-prose-bold)",
                    fontWeight: "600"
                },
                "a strong": {
                    color: "inherit"
                },
                "blockquote strong": {
                    color: "inherit"
                },
                "thead th strong": {
                    color: "inherit"
                },
                ol: {
                    listStyleType: "decimal"
                },
                'ol[type="A"]': {
                    listStyleType: "upper-alpha"
                },
                'ol[type="a"]': {
                    listStyleType: "lower-alpha"
                },
                'ol[type="A" s]': {
                    listStyleType: "upper-alpha"
                },
                'ol[type="a" s]': {
                    listStyleType: "lower-alpha"
                },
                'ol[type="I"]': {
                    listStyleType: "upper-roman"
                },
                'ol[type="i"]': {
                    listStyleType: "lower-roman"
                },
                'ol[type="I" s]': {
                    listStyleType: "upper-roman"
                },
                'ol[type="i" s]': {
                    listStyleType: "lower-roman"
                },
                'ol[type="1"]': {
                    listStyleType: "decimal"
                },
                ul: {
                    listStyleType: "disc"
                },
                "ol > li::marker": {
                    fontWeight: "400",
                    color: "var(--tw-prose-counters)"
                },
                "ul > li::marker": {
                    color: "var(--tw-prose-bullets)"
                },
                dt: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                hr: {
                    borderColor: "var(--tw-prose-hr)",
                    borderTopWidth: 1
                },
                blockquote: {
                    fontWeight: "500",
                    fontStyle: "italic",
                    color: "var(--tw-prose-quotes)",
                    borderInlineStartWidth: "0.25rem",
                    borderInlineStartColor: "var(--tw-prose-quote-borders)",
                    quotes: '"\\201C""\\201D""\\2018""\\2019"'
                },
                "blockquote p:first-of-type::before": {
                    content: "open-quote"
                },
                "blockquote p:last-of-type::after": {
                    content: "close-quote"
                },
                h1: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "800"
                },
                "h1 strong": {
                    fontWeight: "900",
                    color: "inherit"
                },
                h2: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "700"
                },
                "h2 strong": {
                    fontWeight: "800",
                    color: "inherit"
                },
                h3: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                "h3 strong": {
                    fontWeight: "700",
                    color: "inherit"
                },
                h4: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                "h4 strong": {
                    fontWeight: "700",
                    color: "inherit"
                },
                img: {},
                picture: {
                    display: "block"
                },
                video: {},
                kbd: {
                    fontWeight: "500",
                    fontFamily: "inherit",
                    color: "var(--tw-prose-kbd)",
                    boxShadow: "0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%), 0 3px 0 rgb(var(--tw-prose-kbd-shadows) / 10%)"
                },
                code: {
                    color: "var(--tw-prose-code)",
                    fontWeight: "600"
                },
                "code::before": {
                    content: '"`"'
                },
                "code::after": {
                    content: '"`"'
                },
                "a code": {
                    color: "inherit"
                },
                "h1 code": {
                    color: "inherit"
                },
                "h2 code": {
                    color: "inherit"
                },
                "h3 code": {
                    color: "inherit"
                },
                "h4 code": {
                    color: "inherit"
                },
                "blockquote code": {
                    color: "inherit"
                },
                "thead th code": {
                    color: "inherit"
                },
                pre: {
                    color: "var(--tw-prose-pre-code)",
                    backgroundColor: "var(--tw-prose-pre-bg)",
                    overflowX: "auto",
                    fontWeight: "400"
                },
                "pre code": {
                    backgroundColor: "transparent",
                    borderWidth: "0",
                    borderRadius: "0",
                    padding: "0",
                    fontWeight: "inherit",
                    color: "inherit",
                    fontSize: "inherit",
                    fontFamily: "inherit",
                    lineHeight: "inherit"
                },
                "pre code::before": {
                    content: "none"
                },
                "pre code::after": {
                    content: "none"
                },
                table: {
                    width: "100%",
                    tableLayout: "auto",
                    textAlign: "start",
                    marginTop: $9b90e68f2e811d62$var$em(32, 16),
                    marginBottom: $9b90e68f2e811d62$var$em(32, 16)
                },
                thead: {
                    borderBottomWidth: "1px",
                    borderBottomColor: "var(--tw-prose-th-borders)"
                },
                "thead th": {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600",
                    verticalAlign: "bottom"
                },
                "tbody tr": {
                    borderBottomWidth: "1px",
                    borderBottomColor: "var(--tw-prose-td-borders)"
                },
                "tbody tr:last-child": {
                    borderBottomWidth: "0"
                },
                "tbody td": {
                    verticalAlign: "baseline"
                },
                tfoot: {
                    borderTopWidth: "1px",
                    borderTopColor: "var(--tw-prose-th-borders)"
                },
                "tfoot td": {
                    verticalAlign: "top"
                },
                "figure > *": {},
                figcaption: {
                    color: "var(--tw-prose-captions)"
                }
            },
            $9b90e68f2e811d62$var$defaultModifiers.gray.css,
            ...$9b90e68f2e811d62$var$defaultModifiers.base.css
        ]
    },
    ...$9b90e68f2e811d62$var$defaultModifiers
};

});

parcelRegister("U8wA4", function(module, exports) {

var $fpcZL = parcelRequire("fpcZL");

var $4dCpD = parcelRequire("4dCpD");
const $0a8bd7dd6187fc0e$var$parseSelector = $4dCpD();
module.exports = {
    isUsableColor (color, values) {
        return $fpcZL(values) && color !== "gray" && values[600];
    },
    /**
   * @param {string} selector
   */ commonTrailingPseudos (selector) {
        let ast = $0a8bd7dd6187fc0e$var$parseSelector.astSync(selector);
        /** @type {import('postcss-selector-parser').Pseudo[][]} */ let matrix = [];
        // Put the pseudo elements in reverse order in a sparse, column-major 2D array
        for (let [i, sel] of ast.nodes.entries())for (const [j, child] of [
            ...sel.nodes
        ].reverse().entries()){
            // We only care about pseudo elements
            if (child.type !== "pseudo" || !child.value.startsWith("::")) break;
            matrix[j] = matrix[j] || [];
            matrix[j][i] = child;
        }
        let trailingPseudos = $4dCpD.selector();
        // At this point the pseudo elements are in a column-major 2D array
        // This means each row contains one "column" of pseudo elements from each selector
        // We can compare all the pseudo elements in a row to see if they are the same
        for (const pseudos of matrix){
            // It's a sparse 2D array so there are going to be holes in the rows
            // We skip those
            if (!pseudos) continue;
            let values = new Set([
                ...pseudos.map((p)=>p.value)
            ]);
            // The pseudo elements are not the same
            if (values.size > 1) break;
            pseudos.forEach((pseudo)=>pseudo.remove());
            trailingPseudos.prepend(pseudos[0]);
        }
        if (trailingPseudos.nodes.length) return [
            trailingPseudos.toString(),
            ast.toString()
        ];
        return [
            null,
            selector
        ];
    }
};

});
parcelRegister("fpcZL", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $b37345612d3e76d1$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $b37345612d3e76d1$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b37345612d3e76d1$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $b37345612d3e76d1$var$funcProto = Function.prototype, $b37345612d3e76d1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b37345612d3e76d1$var$funcToString = $b37345612d3e76d1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b37345612d3e76d1$var$hasOwnProperty = $b37345612d3e76d1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b37345612d3e76d1$var$objectCtorString = $b37345612d3e76d1$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b37345612d3e76d1$var$objectToString = $b37345612d3e76d1$var$objectProto.toString;
/** Built-in value references. */ var $b37345612d3e76d1$var$getPrototype = $b37345612d3e76d1$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b37345612d3e76d1$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b37345612d3e76d1$var$isPlainObject(value) {
    if (!$b37345612d3e76d1$var$isObjectLike(value) || $b37345612d3e76d1$var$objectToString.call(value) != $b37345612d3e76d1$var$objectTag || $b37345612d3e76d1$var$isHostObject(value)) return false;
    var proto = $b37345612d3e76d1$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $b37345612d3e76d1$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $b37345612d3e76d1$var$funcToString.call(Ctor) == $b37345612d3e76d1$var$objectCtorString;
}
module.exports = $b37345612d3e76d1$var$isPlainObject;

});

parcelRegister("4dCpD", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $31262c3c51d5e4fd$var$_processor = $31262c3c51d5e4fd$var$_interopRequireDefault((parcelRequire("68haR")));

var $31262c3c51d5e4fd$var$selectors = $31262c3c51d5e4fd$var$_interopRequireWildcard((parcelRequire("k8vqG")));
function $31262c3c51d5e4fd$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $31262c3c51d5e4fd$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $31262c3c51d5e4fd$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $31262c3c51d5e4fd$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $31262c3c51d5e4fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $31262c3c51d5e4fd$var$parser = function parser(processor) {
    return new $31262c3c51d5e4fd$var$_processor["default"](processor);
};
Object.assign($31262c3c51d5e4fd$var$parser, $31262c3c51d5e4fd$var$selectors);
delete $31262c3c51d5e4fd$var$parser.__esModule;
var $31262c3c51d5e4fd$var$_default = $31262c3c51d5e4fd$var$parser;
module.exports["default"] = $31262c3c51d5e4fd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("68haR", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $4770cfe0d424ddff$var$_parser = $4770cfe0d424ddff$var$_interopRequireDefault((parcelRequire("2x8ZR")));
function $4770cfe0d424ddff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $4770cfe0d424ddff$var$Processor = /*#__PURE__*/ function() {
    function Processor(func, options) {
        this.func = func || function noop() {};
        this.funcRes = null;
        this.options = options;
    }
    var _proto = Processor.prototype;
    _proto._shouldUpdateSelector = function _shouldUpdateSelector(rule, options) {
        if (options === void 0) options = {};
        var merged = Object.assign({}, this.options, options);
        if (merged.updateSelector === false) return false;
        else return typeof rule !== "string";
    };
    _proto._isLossy = function _isLossy(options) {
        if (options === void 0) options = {};
        var merged = Object.assign({}, this.options, options);
        if (merged.lossless === false) return true;
        else return false;
    };
    _proto._root = function _root(rule, options) {
        if (options === void 0) options = {};
        var parser = new $4770cfe0d424ddff$var$_parser["default"](rule, this._parseOptions(options));
        return parser.root;
    };
    _proto._parseOptions = function _parseOptions(options) {
        return {
            lossy: this._isLossy(options)
        };
    };
    _proto._run = function _run(rule, options) {
        var _this = this;
        if (options === void 0) options = {};
        return new Promise(function(resolve, reject) {
            try {
                var root = _this._root(rule, options);
                Promise.resolve(_this.func(root)).then(function(transform) {
                    var string = undefined;
                    if (_this._shouldUpdateSelector(rule, options)) {
                        string = root.toString();
                        rule.selector = string;
                    }
                    return {
                        transform: transform,
                        root: root,
                        string: string
                    };
                }).then(resolve, reject);
            } catch (e) {
                reject(e);
                return;
            }
        });
    };
    _proto._runSync = function _runSync(rule, options) {
        if (options === void 0) options = {};
        var root = this._root(rule, options);
        var transform = this.func(root);
        if (transform && typeof transform.then === "function") throw new Error("Selector processor returned a promise to a synchronous call.");
        var string = undefined;
        if (options.updateSelector && typeof rule !== "string") {
            string = root.toString();
            rule.selector = string;
        }
        return {
            transform: transform,
            root: root,
            string: string
        };
    } /**
   * Process rule into a selector AST.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {Promise<parser.Root>} The AST of the selector after processing it.
   */ ;
    _proto.ast = function ast(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.root;
        });
    } /**
   * Process rule into a selector AST synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {parser.Root} The AST of the selector after processing it.
   */ ;
    _proto.astSync = function astSync(rule, options) {
        return this._runSync(rule, options).root;
    } /**
   * Process a selector into a transformed value asynchronously
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {Promise<any>} The value returned by the processor.
   */ ;
    _proto.transform = function transform(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.transform;
        });
    } /**
   * Process a selector into a transformed value synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {any} The value returned by the processor.
   */ ;
    _proto.transformSync = function transformSync(rule, options) {
        return this._runSync(rule, options).transform;
    } /**
   * Process a selector into a new selector string asynchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {string} the selector after processing.
   */ ;
    _proto.process = function process(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.string || result.root.toString();
        });
    } /**
   * Process a selector into a new selector string synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {string} the selector after processing.
   */ ;
    _proto.processSync = function processSync(rule, options) {
        var result = this._runSync(rule, options);
        return result.string || result.root.toString();
    };
    return Processor;
}();
module.exports["default"] = $4770cfe0d424ddff$var$Processor;
module.exports = module.exports.default;

});
parcelRegister("2x8ZR", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $1d85a462c66bf340$var$_root = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("7gl1Z")));

var $1d85a462c66bf340$var$_selector = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("dRMm5")));

var $1d85a462c66bf340$var$_className = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("kp4zM")));

var $1d85a462c66bf340$var$_comment = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("kPEv5")));

var $1d85a462c66bf340$var$_id = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("hAgLj")));

var $1d85a462c66bf340$var$_tag = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("eBASB")));

var $1d85a462c66bf340$var$_string = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("gCW3v")));

var $1d85a462c66bf340$var$_pseudo = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("aJZwf")));

var $1d85a462c66bf340$var$_attribute = $1d85a462c66bf340$var$_interopRequireWildcard((parcelRequire("7IfkN")));

var $1d85a462c66bf340$var$_universal = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("6Wm91")));

var $1d85a462c66bf340$var$_combinator = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("1WlCQ")));

var $1d85a462c66bf340$var$_nesting = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("i0cQl")));

var $1d85a462c66bf340$var$_sortAscending = $1d85a462c66bf340$var$_interopRequireDefault((parcelRequire("3jKYf")));

var $1d85a462c66bf340$var$_tokenize = $1d85a462c66bf340$var$_interopRequireWildcard((parcelRequire("km27S")));

var $1d85a462c66bf340$var$tokens = $1d85a462c66bf340$var$_interopRequireWildcard((parcelRequire("hqgto")));

var $1d85a462c66bf340$var$types = $1d85a462c66bf340$var$_interopRequireWildcard((parcelRequire("7rSK2")));

var $luBnX = parcelRequire("luBnX");
var $1d85a462c66bf340$var$_WHITESPACE_TOKENS, $1d85a462c66bf340$var$_Object$assign;
function $1d85a462c66bf340$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $1d85a462c66bf340$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $1d85a462c66bf340$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $1d85a462c66bf340$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1d85a462c66bf340$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1d85a462c66bf340$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1d85a462c66bf340$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1d85a462c66bf340$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1d85a462c66bf340$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $1d85a462c66bf340$var$WHITESPACE_TOKENS = ($1d85a462c66bf340$var$_WHITESPACE_TOKENS = {}, $1d85a462c66bf340$var$_WHITESPACE_TOKENS[$1d85a462c66bf340$var$tokens.space] = true, $1d85a462c66bf340$var$_WHITESPACE_TOKENS[$1d85a462c66bf340$var$tokens.cr] = true, $1d85a462c66bf340$var$_WHITESPACE_TOKENS[$1d85a462c66bf340$var$tokens.feed] = true, $1d85a462c66bf340$var$_WHITESPACE_TOKENS[$1d85a462c66bf340$var$tokens.newline] = true, $1d85a462c66bf340$var$_WHITESPACE_TOKENS[$1d85a462c66bf340$var$tokens.tab] = true, $1d85a462c66bf340$var$_WHITESPACE_TOKENS);
var $1d85a462c66bf340$var$WHITESPACE_EQUIV_TOKENS = Object.assign({}, $1d85a462c66bf340$var$WHITESPACE_TOKENS, ($1d85a462c66bf340$var$_Object$assign = {}, $1d85a462c66bf340$var$_Object$assign[$1d85a462c66bf340$var$tokens.comment] = true, $1d85a462c66bf340$var$_Object$assign));
function $1d85a462c66bf340$var$tokenStart(token) {
    return {
        line: token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_LINE],
        column: token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_COL]
    };
}
function $1d85a462c66bf340$var$tokenEnd(token) {
    return {
        line: token[$1d85a462c66bf340$var$_tokenize.FIELDS.END_LINE],
        column: token[$1d85a462c66bf340$var$_tokenize.FIELDS.END_COL]
    };
}
function $1d85a462c66bf340$var$getSource(startLine, startColumn, endLine, endColumn) {
    return {
        start: {
            line: startLine,
            column: startColumn
        },
        end: {
            line: endLine,
            column: endColumn
        }
    };
}
function $1d85a462c66bf340$var$getTokenSource(token) {
    return $1d85a462c66bf340$var$getSource(token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_LINE], token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_COL], token[$1d85a462c66bf340$var$_tokenize.FIELDS.END_LINE], token[$1d85a462c66bf340$var$_tokenize.FIELDS.END_COL]);
}
function $1d85a462c66bf340$var$getTokenSourceSpan(startToken, endToken) {
    if (!startToken) return undefined;
    return $1d85a462c66bf340$var$getSource(startToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_LINE], startToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_COL], endToken[$1d85a462c66bf340$var$_tokenize.FIELDS.END_LINE], endToken[$1d85a462c66bf340$var$_tokenize.FIELDS.END_COL]);
}
function $1d85a462c66bf340$var$unescapeProp(node, prop) {
    var value = node[prop];
    if (typeof value !== "string") return;
    if (value.indexOf("\\") !== -1) {
        (0, $luBnX.ensureObject)(node, "raws");
        node[prop] = (0, $luBnX.unesc)(value);
        if (node.raws[prop] === undefined) node.raws[prop] = value;
    }
    return node;
}
function $1d85a462c66bf340$var$indexesOf(array, item) {
    var i = -1;
    var indexes = [];
    while((i = array.indexOf(item, i + 1)) !== -1)indexes.push(i);
    return indexes;
}
function $1d85a462c66bf340$var$uniqs() {
    var list = Array.prototype.concat.apply([], arguments);
    return list.filter(function(item, i) {
        return i === list.indexOf(item);
    });
}
var $1d85a462c66bf340$var$Parser = /*#__PURE__*/ function() {
    function Parser(rule, options) {
        if (options === void 0) options = {};
        this.rule = rule;
        this.options = Object.assign({
            lossy: false,
            safe: false
        }, options);
        this.position = 0;
        this.css = typeof this.rule === "string" ? this.rule : this.rule.selector;
        this.tokens = (0, $1d85a462c66bf340$var$_tokenize["default"])({
            css: this.css,
            error: this._errorGenerator(),
            safe: this.options.safe
        });
        var rootSource = $1d85a462c66bf340$var$getTokenSourceSpan(this.tokens[0], this.tokens[this.tokens.length - 1]);
        this.root = new $1d85a462c66bf340$var$_root["default"]({
            source: rootSource
        });
        this.root.errorGenerator = this._errorGenerator();
        var selector = new $1d85a462c66bf340$var$_selector["default"]({
            source: {
                start: {
                    line: 1,
                    column: 1
                }
            }
        });
        this.root.append(selector);
        this.current = selector;
        this.loop();
    }
    var _proto = Parser.prototype;
    _proto._errorGenerator = function _errorGenerator() {
        var _this = this;
        return function(message, errorOptions) {
            if (typeof _this.rule === "string") return new Error(message);
            return _this.rule.error(message, errorOptions);
        };
    };
    _proto.attribute = function attribute() {
        var attr = [];
        var startingToken = this.currToken;
        this.position++;
        while(this.position < this.tokens.length && this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] !== $1d85a462c66bf340$var$tokens.closeSquare){
            attr.push(this.currToken);
            this.position++;
        }
        if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] !== $1d85a462c66bf340$var$tokens.closeSquare) return this.expected("closing square bracket", this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
        var len = attr.length;
        var node = {
            source: $1d85a462c66bf340$var$getSource(startingToken[1], startingToken[2], this.currToken[3], this.currToken[4]),
            sourceIndex: startingToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
        };
        if (len === 1 && !~[
            $1d85a462c66bf340$var$tokens.word
        ].indexOf(attr[0][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE])) return this.expected("attribute", attr[0][$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
        var pos = 0;
        var spaceBefore = "";
        var commentBefore = "";
        var lastAdded = null;
        var spaceAfterMeaningfulToken = false;
        while(pos < len){
            var token = attr[pos];
            var content = this.content(token);
            var next = attr[pos + 1];
            switch(token[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE]){
                case $1d85a462c66bf340$var$tokens.space:
                    // if (
                    //     len === 1 ||
                    //     pos === 0 && this.content(next) === '|'
                    // ) {
                    //     return this.expected('attribute', token[TOKEN.START_POS], content);
                    // }
                    spaceAfterMeaningfulToken = true;
                    if (this.options.lossy) break;
                    if (lastAdded) {
                        (0, $luBnX.ensureObject)(node, "spaces", lastAdded);
                        var prevContent = node.spaces[lastAdded].after || "";
                        node.spaces[lastAdded].after = prevContent + content;
                        var existingComment = (0, $luBnX.getProp)(node, "raws", "spaces", lastAdded, "after") || null;
                        if (existingComment) node.raws.spaces[lastAdded].after = existingComment + content;
                    } else {
                        spaceBefore = spaceBefore + content;
                        commentBefore = commentBefore + content;
                    }
                    break;
                case $1d85a462c66bf340$var$tokens.asterisk:
                    if (next[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    } else if ((!node.namespace || lastAdded === "namespace" && !spaceAfterMeaningfulToken) && next) {
                        if (spaceBefore) {
                            (0, $luBnX.ensureObject)(node, "spaces", "attribute");
                            node.spaces.attribute.before = spaceBefore;
                            spaceBefore = "";
                        }
                        if (commentBefore) {
                            (0, $luBnX.ensureObject)(node, "raws", "spaces", "attribute");
                            node.raws.spaces.attribute.before = spaceBefore;
                            commentBefore = "";
                        }
                        node.namespace = (node.namespace || "") + content;
                        var rawValue = (0, $luBnX.getProp)(node, "raws", "namespace") || null;
                        if (rawValue) node.raws.namespace += content;
                        lastAdded = "namespace";
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $1d85a462c66bf340$var$tokens.dollar:
                    if (lastAdded === "value") {
                        var oldRawValue = (0, $luBnX.getProp)(node, "raws", "value");
                        node.value += "$";
                        if (oldRawValue) node.raws.value = oldRawValue + "$";
                        break;
                    }
                // Falls through
                case $1d85a462c66bf340$var$tokens.caret:
                    if (next[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $1d85a462c66bf340$var$tokens.combinator:
                    if (content === "~" && next[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    }
                    if (content !== "|") {
                        spaceAfterMeaningfulToken = false;
                        break;
                    }
                    if (next[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    } else if (!node.namespace && !node.attribute) node.namespace = true;
                    spaceAfterMeaningfulToken = false;
                    break;
                case $1d85a462c66bf340$var$tokens.word:
                    if (next && this.content(next) === "|" && attr[pos + 2] && attr[pos + 2][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] !== $1d85a462c66bf340$var$tokens.equals && // this look-ahead probably fails with comment nodes involved.
                    !node.operator && !node.namespace) {
                        node.namespace = content;
                        lastAdded = "namespace";
                    } else if (!node.attribute || lastAdded === "attribute" && !spaceAfterMeaningfulToken) {
                        if (spaceBefore) {
                            (0, $luBnX.ensureObject)(node, "spaces", "attribute");
                            node.spaces.attribute.before = spaceBefore;
                            spaceBefore = "";
                        }
                        if (commentBefore) {
                            (0, $luBnX.ensureObject)(node, "raws", "spaces", "attribute");
                            node.raws.spaces.attribute.before = commentBefore;
                            commentBefore = "";
                        }
                        node.attribute = (node.attribute || "") + content;
                        var _rawValue = (0, $luBnX.getProp)(node, "raws", "attribute") || null;
                        if (_rawValue) node.raws.attribute += content;
                        lastAdded = "attribute";
                    } else if (!node.value && node.value !== "" || lastAdded === "value" && !spaceAfterMeaningfulToken) {
                        var _unescaped = (0, $luBnX.unesc)(content);
                        var _oldRawValue = (0, $luBnX.getProp)(node, "raws", "value") || "";
                        var oldValue = node.value || "";
                        node.value = oldValue + _unescaped;
                        node.quoteMark = null;
                        if (_unescaped !== content || _oldRawValue) {
                            (0, $luBnX.ensureObject)(node, "raws");
                            node.raws.value = (_oldRawValue || oldValue) + content;
                        }
                        lastAdded = "value";
                    } else {
                        var insensitive = content === "i" || content === "I";
                        if ((node.value || node.value === "") && (node.quoteMark || spaceAfterMeaningfulToken)) {
                            node.insensitive = insensitive;
                            if (!insensitive || content === "I") {
                                (0, $luBnX.ensureObject)(node, "raws");
                                node.raws.insensitiveFlag = content;
                            }
                            lastAdded = "insensitive";
                            if (spaceBefore) {
                                (0, $luBnX.ensureObject)(node, "spaces", "insensitive");
                                node.spaces.insensitive.before = spaceBefore;
                                spaceBefore = "";
                            }
                            if (commentBefore) {
                                (0, $luBnX.ensureObject)(node, "raws", "spaces", "insensitive");
                                node.raws.spaces.insensitive.before = commentBefore;
                                commentBefore = "";
                            }
                        } else if (node.value || node.value === "") {
                            lastAdded = "value";
                            node.value += content;
                            if (node.raws.value) node.raws.value += content;
                        }
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $1d85a462c66bf340$var$tokens.str:
                    if (!node.attribute || !node.operator) return this.error("Expected an attribute followed by an operator preceding the string.", {
                        index: token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
                    });
                    var _unescapeValue = (0, $1d85a462c66bf340$var$_attribute.unescapeValue)(content), unescaped = _unescapeValue.unescaped, quoteMark = _unescapeValue.quoteMark;
                    node.value = unescaped;
                    node.quoteMark = quoteMark;
                    lastAdded = "value";
                    (0, $luBnX.ensureObject)(node, "raws");
                    node.raws.value = content;
                    spaceAfterMeaningfulToken = false;
                    break;
                case $1d85a462c66bf340$var$tokens.equals:
                    if (!node.attribute) return this.expected("attribute", token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS], content);
                    if (node.value) return this.error('Unexpected "=" found; an operator was already defined.', {
                        index: token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
                    });
                    node.operator = node.operator ? node.operator + content : content;
                    lastAdded = "operator";
                    spaceAfterMeaningfulToken = false;
                    break;
                case $1d85a462c66bf340$var$tokens.comment:
                    if (lastAdded) {
                        if (spaceAfterMeaningfulToken || next && next[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.space || lastAdded === "insensitive") {
                            var lastComment = (0, $luBnX.getProp)(node, "spaces", lastAdded, "after") || "";
                            var rawLastComment = (0, $luBnX.getProp)(node, "raws", "spaces", lastAdded, "after") || lastComment;
                            (0, $luBnX.ensureObject)(node, "raws", "spaces", lastAdded);
                            node.raws.spaces[lastAdded].after = rawLastComment + content;
                        } else {
                            var lastValue = node[lastAdded] || "";
                            var rawLastValue = (0, $luBnX.getProp)(node, "raws", lastAdded) || lastValue;
                            (0, $luBnX.ensureObject)(node, "raws");
                            node.raws[lastAdded] = rawLastValue + content;
                        }
                    } else commentBefore = commentBefore + content;
                    break;
                default:
                    return this.error('Unexpected "' + content + '" found.', {
                        index: token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
                    });
            }
            pos++;
        }
        $1d85a462c66bf340$var$unescapeProp(node, "attribute");
        $1d85a462c66bf340$var$unescapeProp(node, "namespace");
        this.newNode(new $1d85a462c66bf340$var$_attribute["default"](node));
        this.position++;
    } /**
   * return a node containing meaningless garbage up to (but not including) the specified token position.
   * if the token position is negative, all remaining tokens are consumed.
   *
   * This returns an array containing a single string node if all whitespace,
   * otherwise an array of comment nodes with space before and after.
   *
   * These tokens are not added to the current selector, the caller can add them or use them to amend
   * a previous node's space metadata.
   *
   * In lossy mode, this returns only comments.
   */ ;
    _proto.parseWhitespaceEquivalentTokens = function parseWhitespaceEquivalentTokens(stopPosition) {
        if (stopPosition < 0) stopPosition = this.tokens.length;
        var startPosition = this.position;
        var nodes = [];
        var space = "";
        var lastComment = undefined;
        do {
            if ($1d85a462c66bf340$var$WHITESPACE_TOKENS[this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE]]) {
                if (!this.options.lossy) space += this.content();
            } else if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.comment) {
                var spaces = {};
                if (space) {
                    spaces.before = space;
                    space = "";
                }
                lastComment = new $1d85a462c66bf340$var$_comment["default"]({
                    value: this.content(),
                    source: $1d85a462c66bf340$var$getTokenSource(this.currToken),
                    sourceIndex: this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS],
                    spaces: spaces
                });
                nodes.push(lastComment);
            }
        }while (++this.position < stopPosition);
        if (space) {
            if (lastComment) lastComment.spaces.after = space;
            else if (!this.options.lossy) {
                var firstToken = this.tokens[startPosition];
                var lastToken = this.tokens[this.position - 1];
                nodes.push(new $1d85a462c66bf340$var$_string["default"]({
                    value: "",
                    source: $1d85a462c66bf340$var$getSource(firstToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_LINE], firstToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_COL], lastToken[$1d85a462c66bf340$var$_tokenize.FIELDS.END_LINE], lastToken[$1d85a462c66bf340$var$_tokenize.FIELDS.END_COL]),
                    sourceIndex: firstToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS],
                    spaces: {
                        before: space,
                        after: ""
                    }
                }));
            }
        }
        return nodes;
    } /**
   * 
   * @param {*} nodes 
   */ ;
    _proto.convertWhitespaceNodesToSpace = function convertWhitespaceNodesToSpace(nodes, requiredSpace) {
        var _this2 = this;
        if (requiredSpace === void 0) requiredSpace = false;
        var space = "";
        var rawSpace = "";
        nodes.forEach(function(n) {
            var spaceBefore = _this2.lossySpace(n.spaces.before, requiredSpace);
            var rawSpaceBefore = _this2.lossySpace(n.rawSpaceBefore, requiredSpace);
            space += spaceBefore + _this2.lossySpace(n.spaces.after, requiredSpace && spaceBefore.length === 0);
            rawSpace += spaceBefore + n.value + _this2.lossySpace(n.rawSpaceAfter, requiredSpace && rawSpaceBefore.length === 0);
        });
        if (rawSpace === space) rawSpace = undefined;
        var result = {
            space: space,
            rawSpace: rawSpace
        };
        return result;
    };
    _proto.isNamedCombinator = function isNamedCombinator(position) {
        if (position === void 0) position = this.position;
        return this.tokens[position + 0] && this.tokens[position + 0][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.slash && this.tokens[position + 1] && this.tokens[position + 1][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.word && this.tokens[position + 2] && this.tokens[position + 2][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.slash;
    };
    _proto.namedCombinator = function namedCombinator() {
        if (this.isNamedCombinator()) {
            var nameRaw = this.content(this.tokens[this.position + 1]);
            var name = (0, $luBnX.unesc)(nameRaw).toLowerCase();
            var raws = {};
            if (name !== nameRaw) raws.value = "/" + nameRaw + "/";
            var node = new $1d85a462c66bf340$var$_combinator["default"]({
                value: "/" + name + "/",
                source: $1d85a462c66bf340$var$getSource(this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_LINE], this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_COL], this.tokens[this.position + 2][$1d85a462c66bf340$var$_tokenize.FIELDS.END_LINE], this.tokens[this.position + 2][$1d85a462c66bf340$var$_tokenize.FIELDS.END_COL]),
                sourceIndex: this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS],
                raws: raws
            });
            this.position = this.position + 3;
            return node;
        } else this.unexpected();
    };
    _proto.combinator = function combinator() {
        var _this3 = this;
        if (this.content() === "|") return this.namespace();
         // We need to decide between a space that's a descendant combinator and meaningless whitespace at the end of a selector.
        var nextSigTokenPos = this.locateNextMeaningfulToken(this.position);
        if (nextSigTokenPos < 0 || this.tokens[nextSigTokenPos][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.comma) {
            var nodes = this.parseWhitespaceEquivalentTokens(nextSigTokenPos);
            if (nodes.length > 0) {
                var last = this.current.last;
                if (last) {
                    var _this$convertWhitespa = this.convertWhitespaceNodesToSpace(nodes), space = _this$convertWhitespa.space, rawSpace = _this$convertWhitespa.rawSpace;
                    if (rawSpace !== undefined) last.rawSpaceAfter += rawSpace;
                    last.spaces.after += space;
                } else nodes.forEach(function(n) {
                    return _this3.newNode(n);
                });
            }
            return;
        }
        var firstToken = this.currToken;
        var spaceOrDescendantSelectorNodes = undefined;
        if (nextSigTokenPos > this.position) spaceOrDescendantSelectorNodes = this.parseWhitespaceEquivalentTokens(nextSigTokenPos);
        var node;
        if (this.isNamedCombinator()) node = this.namedCombinator();
        else if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.combinator) {
            node = new $1d85a462c66bf340$var$_combinator["default"]({
                value: this.content(),
                source: $1d85a462c66bf340$var$getTokenSource(this.currToken),
                sourceIndex: this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
            });
            this.position++;
        } else if ($1d85a462c66bf340$var$WHITESPACE_TOKENS[this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE]]) ;
        else if (!spaceOrDescendantSelectorNodes) this.unexpected();
        if (node) {
            if (spaceOrDescendantSelectorNodes) {
                var _this$convertWhitespa2 = this.convertWhitespaceNodesToSpace(spaceOrDescendantSelectorNodes), _space = _this$convertWhitespa2.space, _rawSpace = _this$convertWhitespa2.rawSpace;
                node.spaces.before = _space;
                node.rawSpaceBefore = _rawSpace;
            }
        } else {
            // descendant combinator
            var _this$convertWhitespa3 = this.convertWhitespaceNodesToSpace(spaceOrDescendantSelectorNodes, true), _space2 = _this$convertWhitespa3.space, _rawSpace2 = _this$convertWhitespa3.rawSpace;
            if (!_rawSpace2) _rawSpace2 = _space2;
            var spaces = {};
            var raws = {
                spaces: {}
            };
            if (_space2.endsWith(" ") && _rawSpace2.endsWith(" ")) {
                spaces.before = _space2.slice(0, _space2.length - 1);
                raws.spaces.before = _rawSpace2.slice(0, _rawSpace2.length - 1);
            } else if (_space2.startsWith(" ") && _rawSpace2.startsWith(" ")) {
                spaces.after = _space2.slice(1);
                raws.spaces.after = _rawSpace2.slice(1);
            } else raws.value = _rawSpace2;
            node = new $1d85a462c66bf340$var$_combinator["default"]({
                value: " ",
                source: $1d85a462c66bf340$var$getTokenSourceSpan(firstToken, this.tokens[this.position - 1]),
                sourceIndex: firstToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS],
                spaces: spaces,
                raws: raws
            });
        }
        if (this.currToken && this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.space) {
            node.spaces.after = this.optionalSpace(this.content());
            this.position++;
        }
        return this.newNode(node);
    };
    _proto.comma = function comma() {
        if (this.position === this.tokens.length - 1) {
            this.root.trailingComma = true;
            this.position++;
            return;
        }
        this.current._inferEndPosition();
        var selector = new $1d85a462c66bf340$var$_selector["default"]({
            source: {
                start: $1d85a462c66bf340$var$tokenStart(this.tokens[this.position + 1])
            }
        });
        this.current.parent.append(selector);
        this.current = selector;
        this.position++;
    };
    _proto.comment = function comment() {
        var current = this.currToken;
        this.newNode(new $1d85a462c66bf340$var$_comment["default"]({
            value: this.content(),
            source: $1d85a462c66bf340$var$getTokenSource(current),
            sourceIndex: current[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.error = function error(message, opts) {
        throw this.root.error(message, opts);
    };
    _proto.missingBackslash = function missingBackslash() {
        return this.error("Expected a backslash preceding the semicolon.", {
            index: this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
        });
    };
    _proto.missingParenthesis = function missingParenthesis() {
        return this.expected("opening parenthesis", this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.missingSquareBracket = function missingSquareBracket() {
        return this.expected("opening square bracket", this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.unexpected = function unexpected() {
        return this.error("Unexpected '" + this.content() + "'. Escaping special characters with \\ may help.", this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.namespace = function namespace() {
        var before = this.prevToken && this.content(this.prevToken) || true;
        if (this.nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.word) {
            this.position++;
            return this.word(before);
        } else if (this.nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.asterisk) {
            this.position++;
            return this.universal(before);
        }
    };
    _proto.nesting = function nesting() {
        if (this.nextToken) {
            var nextContent = this.content(this.nextToken);
            if (nextContent === "|") {
                this.position++;
                return;
            }
        }
        var current = this.currToken;
        this.newNode(new $1d85a462c66bf340$var$_nesting["default"]({
            value: this.content(),
            source: $1d85a462c66bf340$var$getTokenSource(current),
            sourceIndex: current[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.parentheses = function parentheses() {
        var last = this.current.last;
        var unbalanced = 1;
        this.position++;
        if (last && last.type === $1d85a462c66bf340$var$types.PSEUDO) {
            var selector = new $1d85a462c66bf340$var$_selector["default"]({
                source: {
                    start: $1d85a462c66bf340$var$tokenStart(this.tokens[this.position - 1])
                }
            });
            var cache = this.current;
            last.append(selector);
            this.current = selector;
            while(this.position < this.tokens.length && unbalanced){
                if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.openParenthesis) unbalanced++;
                if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.closeParenthesis) unbalanced--;
                if (unbalanced) this.parse();
                else {
                    this.current.source.end = $1d85a462c66bf340$var$tokenEnd(this.currToken);
                    this.current.parent.source.end = $1d85a462c66bf340$var$tokenEnd(this.currToken);
                    this.position++;
                }
            }
            this.current = cache;
        } else {
            // I think this case should be an error. It's used to implement a basic parse of media queries
            // but I don't think it's a good idea.
            var parenStart = this.currToken;
            var parenValue = "(";
            var parenEnd;
            while(this.position < this.tokens.length && unbalanced){
                if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.openParenthesis) unbalanced++;
                if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.closeParenthesis) unbalanced--;
                parenEnd = this.currToken;
                parenValue += this.parseParenthesisToken(this.currToken);
                this.position++;
            }
            if (last) last.appendToPropertyAndEscape("value", parenValue, parenValue);
            else this.newNode(new $1d85a462c66bf340$var$_string["default"]({
                value: parenValue,
                source: $1d85a462c66bf340$var$getSource(parenStart[$1d85a462c66bf340$var$_tokenize.FIELDS.START_LINE], parenStart[$1d85a462c66bf340$var$_tokenize.FIELDS.START_COL], parenEnd[$1d85a462c66bf340$var$_tokenize.FIELDS.END_LINE], parenEnd[$1d85a462c66bf340$var$_tokenize.FIELDS.END_COL]),
                sourceIndex: parenStart[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
            }));
        }
        if (unbalanced) return this.expected("closing parenthesis", this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.pseudo = function pseudo() {
        var _this4 = this;
        var pseudoStr = "";
        var startingToken = this.currToken;
        while(this.currToken && this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.colon){
            pseudoStr += this.content();
            this.position++;
        }
        if (!this.currToken) return this.expected([
            "pseudo-class",
            "pseudo-element"
        ], this.position - 1);
        if (this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.word) this.splitWord(false, function(first, length) {
            pseudoStr += first;
            _this4.newNode(new $1d85a462c66bf340$var$_pseudo["default"]({
                value: pseudoStr,
                source: $1d85a462c66bf340$var$getTokenSourceSpan(startingToken, _this4.currToken),
                sourceIndex: startingToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
            }));
            if (length > 1 && _this4.nextToken && _this4.nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.openParenthesis) _this4.error("Misplaced parenthesis.", {
                index: _this4.nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
            });
        });
        else return this.expected([
            "pseudo-class",
            "pseudo-element"
        ], this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.space = function space() {
        var content = this.content(); // Handle space before and after the selector
        if (this.position === 0 || this.prevToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.comma || this.prevToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.openParenthesis || this.current.nodes.every(function(node) {
            return node.type === "comment";
        })) {
            this.spaces = this.optionalSpace(content);
            this.position++;
        } else if (this.position === this.tokens.length - 1 || this.nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.comma || this.nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.closeParenthesis) {
            this.current.last.spaces.after = this.optionalSpace(content);
            this.position++;
        } else this.combinator();
    };
    _proto.string = function string() {
        var current = this.currToken;
        this.newNode(new $1d85a462c66bf340$var$_string["default"]({
            value: this.content(),
            source: $1d85a462c66bf340$var$getTokenSource(current),
            sourceIndex: current[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.universal = function universal(namespace) {
        var nextToken = this.nextToken;
        if (nextToken && this.content(nextToken) === "|") {
            this.position++;
            return this.namespace();
        }
        var current = this.currToken;
        this.newNode(new $1d85a462c66bf340$var$_universal["default"]({
            value: this.content(),
            source: $1d85a462c66bf340$var$getTokenSource(current),
            sourceIndex: current[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS]
        }), namespace);
        this.position++;
    };
    _proto.splitWord = function splitWord(namespace, firstCallback) {
        var _this5 = this;
        var nextToken = this.nextToken;
        var word = this.content();
        while(nextToken && ~[
            $1d85a462c66bf340$var$tokens.dollar,
            $1d85a462c66bf340$var$tokens.caret,
            $1d85a462c66bf340$var$tokens.equals,
            $1d85a462c66bf340$var$tokens.word
        ].indexOf(nextToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE])){
            this.position++;
            var current = this.content();
            word += current;
            if (current.lastIndexOf("\\") === current.length - 1) {
                var next = this.nextToken;
                if (next && next[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.space) {
                    word += this.requiredSpace(this.content(next));
                    this.position++;
                }
            }
            nextToken = this.nextToken;
        }
        var hasClass = $1d85a462c66bf340$var$indexesOf(word, ".").filter(function(i) {
            // Allow escaped dot within class name
            var escapedDot = word[i - 1] === "\\"; // Allow decimal numbers percent in @keyframes
            var isKeyframesPercent = /^\d+\.\d+%$/.test(word);
            return !escapedDot && !isKeyframesPercent;
        });
        var hasId = $1d85a462c66bf340$var$indexesOf(word, "#").filter(function(i) {
            return word[i - 1] !== "\\";
        }); // Eliminate Sass interpolations from the list of id indexes
        var interpolations = $1d85a462c66bf340$var$indexesOf(word, "#{");
        if (interpolations.length) hasId = hasId.filter(function(hashIndex) {
            return !~interpolations.indexOf(hashIndex);
        });
        var indices = (0, $1d85a462c66bf340$var$_sortAscending["default"])($1d85a462c66bf340$var$uniqs([
            0
        ].concat(hasClass, hasId)));
        indices.forEach(function(ind, i) {
            var index = indices[i + 1] || word.length;
            var value = word.slice(ind, index);
            if (i === 0 && firstCallback) return firstCallback.call(_this5, value, indices.length);
            var node;
            var current = _this5.currToken;
            var sourceIndex = current[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS] + indices[i];
            var source = $1d85a462c66bf340$var$getSource(current[1], current[2] + ind, current[3], current[2] + (index - 1));
            if (~hasClass.indexOf(ind)) {
                var classNameOpts = {
                    value: value.slice(1),
                    source: source,
                    sourceIndex: sourceIndex
                };
                node = new $1d85a462c66bf340$var$_className["default"]($1d85a462c66bf340$var$unescapeProp(classNameOpts, "value"));
            } else if (~hasId.indexOf(ind)) {
                var idOpts = {
                    value: value.slice(1),
                    source: source,
                    sourceIndex: sourceIndex
                };
                node = new $1d85a462c66bf340$var$_id["default"]($1d85a462c66bf340$var$unescapeProp(idOpts, "value"));
            } else {
                var tagOpts = {
                    value: value,
                    source: source,
                    sourceIndex: sourceIndex
                };
                $1d85a462c66bf340$var$unescapeProp(tagOpts, "value");
                node = new $1d85a462c66bf340$var$_tag["default"](tagOpts);
            }
            _this5.newNode(node, namespace); // Ensure that the namespace is used only once
            namespace = null;
        });
        this.position++;
    };
    _proto.word = function word(namespace) {
        var nextToken = this.nextToken;
        if (nextToken && this.content(nextToken) === "|") {
            this.position++;
            return this.namespace();
        }
        return this.splitWord(namespace);
    };
    _proto.loop = function loop() {
        while(this.position < this.tokens.length)this.parse(true);
        this.current._inferEndPosition();
        return this.root;
    };
    _proto.parse = function parse(throwOnParenthesis) {
        switch(this.currToken[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE]){
            case $1d85a462c66bf340$var$tokens.space:
                this.space();
                break;
            case $1d85a462c66bf340$var$tokens.comment:
                this.comment();
                break;
            case $1d85a462c66bf340$var$tokens.openParenthesis:
                this.parentheses();
                break;
            case $1d85a462c66bf340$var$tokens.closeParenthesis:
                if (throwOnParenthesis) this.missingParenthesis();
                break;
            case $1d85a462c66bf340$var$tokens.openSquare:
                this.attribute();
                break;
            case $1d85a462c66bf340$var$tokens.dollar:
            case $1d85a462c66bf340$var$tokens.caret:
            case $1d85a462c66bf340$var$tokens.equals:
            case $1d85a462c66bf340$var$tokens.word:
                this.word();
                break;
            case $1d85a462c66bf340$var$tokens.colon:
                this.pseudo();
                break;
            case $1d85a462c66bf340$var$tokens.comma:
                this.comma();
                break;
            case $1d85a462c66bf340$var$tokens.asterisk:
                this.universal();
                break;
            case $1d85a462c66bf340$var$tokens.ampersand:
                this.nesting();
                break;
            case $1d85a462c66bf340$var$tokens.slash:
            case $1d85a462c66bf340$var$tokens.combinator:
                this.combinator();
                break;
            case $1d85a462c66bf340$var$tokens.str:
                this.string();
                break;
            // These cases throw; no break needed.
            case $1d85a462c66bf340$var$tokens.closeSquare:
                this.missingSquareBracket();
            case $1d85a462c66bf340$var$tokens.semicolon:
                this.missingBackslash();
            default:
                this.unexpected();
        }
    } /**
   * Helpers
   */ ;
    _proto.expected = function expected(description, index, found) {
        if (Array.isArray(description)) {
            var last = description.pop();
            description = description.join(", ") + " or " + last;
        }
        var an = /^[aeiou]/.test(description[0]) ? "an" : "a";
        if (!found) return this.error("Expected " + an + " " + description + ".", {
            index: index
        });
        return this.error("Expected " + an + " " + description + ', found "' + found + '" instead.', {
            index: index
        });
    };
    _proto.requiredSpace = function requiredSpace(space) {
        return this.options.lossy ? " " : space;
    };
    _proto.optionalSpace = function optionalSpace(space) {
        return this.options.lossy ? "" : space;
    };
    _proto.lossySpace = function lossySpace(space, required) {
        if (this.options.lossy) return required ? " " : "";
        else return space;
    };
    _proto.parseParenthesisToken = function parseParenthesisToken(token) {
        var content = this.content(token);
        if (token[$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE] === $1d85a462c66bf340$var$tokens.space) return this.requiredSpace(content);
        else return content;
    };
    _proto.newNode = function newNode(node, namespace) {
        if (namespace) {
            if (/^ +$/.test(namespace)) {
                if (!this.options.lossy) this.spaces = (this.spaces || "") + namespace;
                namespace = true;
            }
            node.namespace = namespace;
            $1d85a462c66bf340$var$unescapeProp(node, "namespace");
        }
        if (this.spaces) {
            node.spaces.before = this.spaces;
            this.spaces = "";
        }
        return this.current.append(node);
    };
    _proto.content = function content(token) {
        if (token === void 0) token = this.currToken;
        return this.css.slice(token[$1d85a462c66bf340$var$_tokenize.FIELDS.START_POS], token[$1d85a462c66bf340$var$_tokenize.FIELDS.END_POS]);
    };
    /**
   * returns the index of the next non-whitespace, non-comment token.
   * returns -1 if no meaningful token is found.
   */ _proto.locateNextMeaningfulToken = function locateNextMeaningfulToken(startPosition) {
        if (startPosition === void 0) startPosition = this.position + 1;
        var searchPosition = startPosition;
        while(searchPosition < this.tokens.length){
            if ($1d85a462c66bf340$var$WHITESPACE_EQUIV_TOKENS[this.tokens[searchPosition][$1d85a462c66bf340$var$_tokenize.FIELDS.TYPE]]) {
                searchPosition++;
                continue;
            } else return searchPosition;
        }
        return -1;
    };
    $1d85a462c66bf340$var$_createClass(Parser, [
        {
            key: "currToken",
            get: function get() {
                return this.tokens[this.position];
            }
        },
        {
            key: "nextToken",
            get: function get() {
                return this.tokens[this.position + 1];
            }
        },
        {
            key: "prevToken",
            get: function get() {
                return this.tokens[this.position - 1];
            }
        }
    ]);
    return Parser;
}();
module.exports["default"] = $1d85a462c66bf340$var$Parser;
module.exports = module.exports.default;

});
parcelRegister("7gl1Z", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $549a575f5416031d$var$_container = $549a575f5416031d$var$_interopRequireDefault((parcelRequire("bQEWD")));

var $7rSK2 = parcelRequire("7rSK2");
function $549a575f5416031d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $549a575f5416031d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $549a575f5416031d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $549a575f5416031d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $549a575f5416031d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $549a575f5416031d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $549a575f5416031d$var$_setPrototypeOf(subClass, superClass);
}
function $549a575f5416031d$var$_setPrototypeOf(o, p) {
    $549a575f5416031d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $549a575f5416031d$var$_setPrototypeOf(o, p);
}
var $549a575f5416031d$var$Root = /*#__PURE__*/ function(_Container) {
    $549a575f5416031d$var$_inheritsLoose(Root, _Container);
    function Root(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $7rSK2.ROOT;
        return _this;
    }
    var _proto = Root.prototype;
    _proto.toString = function toString() {
        var str = this.reduce(function(memo, selector) {
            memo.push(String(selector));
            return memo;
        }, []).join(",");
        return this.trailingComma ? str + "," : str;
    };
    _proto.error = function error(message, options) {
        if (this._error) return this._error(message, options);
        else return new Error(message);
    };
    $549a575f5416031d$var$_createClass(Root, [
        {
            key: "errorGenerator",
            set: function set(handler) {
                this._error = handler;
            }
        }
    ]);
    return Root;
}($549a575f5416031d$var$_container["default"]);
module.exports["default"] = $549a575f5416031d$var$Root;
module.exports = module.exports.default;

});
parcelRegister("bQEWD", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $8a044fd47fb3ea55$var$_node = $8a044fd47fb3ea55$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $8a044fd47fb3ea55$var$types = $8a044fd47fb3ea55$var$_interopRequireWildcard((parcelRequire("7rSK2")));
function $8a044fd47fb3ea55$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $8a044fd47fb3ea55$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $8a044fd47fb3ea55$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $8a044fd47fb3ea55$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8a044fd47fb3ea55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8a044fd47fb3ea55$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $8a044fd47fb3ea55$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
function $8a044fd47fb3ea55$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8a044fd47fb3ea55$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8a044fd47fb3ea55$var$_arrayLikeToArray(o, minLen);
}
function $8a044fd47fb3ea55$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8a044fd47fb3ea55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8a044fd47fb3ea55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8a044fd47fb3ea55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8a044fd47fb3ea55$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8a044fd47fb3ea55$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8a044fd47fb3ea55$var$_setPrototypeOf(subClass, superClass);
}
function $8a044fd47fb3ea55$var$_setPrototypeOf(o, p) {
    $8a044fd47fb3ea55$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8a044fd47fb3ea55$var$_setPrototypeOf(o, p);
}
var $8a044fd47fb3ea55$var$Container = /*#__PURE__*/ function(_Node) {
    $8a044fd47fb3ea55$var$_inheritsLoose(Container, _Node);
    function Container(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Container.prototype;
    _proto.append = function append(selector) {
        selector.parent = this;
        this.nodes.push(selector);
        return this;
    };
    _proto.prepend = function prepend(selector) {
        selector.parent = this;
        this.nodes.unshift(selector);
        return this;
    };
    _proto.at = function at(index) {
        return this.nodes[index];
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        return this.nodes.indexOf(child);
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.at(child).parent = undefined;
        this.nodes.splice(child, 1);
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $8a044fd47fb3ea55$var$_createForOfIteratorHelperLoose(this.nodes), _step; !(_step = _iterator()).done;){
            var node = _step.value;
            node.parent = undefined;
        }
        this.nodes = [];
        return this;
    };
    _proto.empty = function empty() {
        return this.removeAll();
    };
    _proto.insertAfter = function insertAfter(oldNode, newNode) {
        newNode.parent = this;
        var oldIndex = this.index(oldNode);
        this.nodes.splice(oldIndex + 1, 0, newNode);
        newNode.parent = this;
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (oldIndex <= index) this.indexes[id] = index + 1;
        }
        return this;
    };
    _proto.insertBefore = function insertBefore(oldNode, newNode) {
        newNode.parent = this;
        var oldIndex = this.index(oldNode);
        this.nodes.splice(oldIndex, 0, newNode);
        newNode.parent = this;
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (index <= oldIndex) this.indexes[id] = index + 1;
        }
        return this;
    };
    _proto._findChildAtPosition = function _findChildAtPosition(line, col) {
        var found = undefined;
        this.each(function(node) {
            if (node.atPosition) {
                var foundChild = node.atPosition(line, col);
                if (foundChild) {
                    found = foundChild;
                    return false;
                }
            } else if (node.isAtPosition(line, col)) {
                found = node;
                return false;
            }
        });
        return found;
    } /**
   * Return the most specific node at the line and column number given.
   * The source location is based on the original parsed location, locations aren't
   * updated as selector nodes are mutated.
   * 
   * Note that this location is relative to the location of the first character
   * of the selector, and not the location of the selector in the overall document
   * when used in conjunction with postcss.
   *
   * If not found, returns undefined.
   * @param {number} line The line number of the node to find. (1-based index)
   * @param {number} col  The column number of the node to find. (1-based index)
   */ ;
    _proto.atPosition = function atPosition(line, col) {
        if (this.isAtPosition(line, col)) return this._findChildAtPosition(line, col) || this;
        else return undefined;
    };
    _proto._inferEndPosition = function _inferEndPosition() {
        if (this.last && this.last.source && this.last.source.end) {
            this.source = this.source || {};
            this.source.end = this.source.end || {};
            Object.assign(this.source.end, this.last.source.end);
        }
    };
    _proto.each = function each(callback) {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach++;
        var id = this.lastEach;
        this.indexes[id] = 0;
        if (!this.length) return undefined;
        var index, result;
        while(this.indexes[id] < this.length){
            index = this.indexes[id];
            result = callback(this.at(index), index);
            if (result === false) break;
            this.indexes[id] += 1;
        }
        delete this.indexes[id];
        if (result === false) return false;
    };
    _proto.walk = function walk(callback) {
        return this.each(function(node, i) {
            var result = callback(node, i);
            if (result !== false && node.length) result = node.walk(callback);
            if (result === false) return false;
        });
    };
    _proto.walkAttributes = function walkAttributes(callback) {
        var _this2 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.ATTRIBUTE) return callback.call(_this2, selector);
        });
    };
    _proto.walkClasses = function walkClasses(callback) {
        var _this3 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.CLASS) return callback.call(_this3, selector);
        });
    };
    _proto.walkCombinators = function walkCombinators(callback) {
        var _this4 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.COMBINATOR) return callback.call(_this4, selector);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        var _this5 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.COMMENT) return callback.call(_this5, selector);
        });
    };
    _proto.walkIds = function walkIds(callback) {
        var _this6 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.ID) return callback.call(_this6, selector);
        });
    };
    _proto.walkNesting = function walkNesting(callback) {
        var _this7 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.NESTING) return callback.call(_this7, selector);
        });
    };
    _proto.walkPseudos = function walkPseudos(callback) {
        var _this8 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.PSEUDO) return callback.call(_this8, selector);
        });
    };
    _proto.walkTags = function walkTags(callback) {
        var _this9 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.TAG) return callback.call(_this9, selector);
        });
    };
    _proto.walkUniversals = function walkUniversals(callback) {
        var _this10 = this;
        return this.walk(function(selector) {
            if (selector.type === $8a044fd47fb3ea55$var$types.UNIVERSAL) return callback.call(_this10, selector);
        });
    };
    _proto.split = function split(callback) {
        var _this11 = this;
        var current = [];
        return this.reduce(function(memo, node, index) {
            var split = callback.call(_this11, node);
            current.push(node);
            if (split) {
                memo.push(current);
                current = [];
            } else if (index === _this11.length - 1) memo.push(current);
            return memo;
        }, []);
    };
    _proto.map = function map(callback) {
        return this.nodes.map(callback);
    };
    _proto.reduce = function reduce(callback, memo) {
        return this.nodes.reduce(callback, memo);
    };
    _proto.every = function every(callback) {
        return this.nodes.every(callback);
    };
    _proto.some = function some(callback) {
        return this.nodes.some(callback);
    };
    _proto.filter = function filter(callback) {
        return this.nodes.filter(callback);
    };
    _proto.sort = function sort(callback) {
        return this.nodes.sort(callback);
    };
    _proto.toString = function toString() {
        return this.map(String).join("");
    };
    $8a044fd47fb3ea55$var$_createClass(Container, [
        {
            key: "first",
            get: function get() {
                return this.at(0);
            }
        },
        {
            key: "last",
            get: function get() {
                return this.at(this.length - 1);
            }
        },
        {
            key: "length",
            get: function get() {
                return this.nodes.length;
            }
        }
    ]);
    return Container;
}($8a044fd47fb3ea55$var$_node["default"]);
module.exports["default"] = $8a044fd47fb3ea55$var$Container;
module.exports = module.exports.default;

});
parcelRegister("cVa0h", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $luBnX = parcelRequire("luBnX");
function $968291640d17d0cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $968291640d17d0cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $968291640d17d0cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $968291640d17d0cd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $968291640d17d0cd$var$cloneNode = function cloneNode(obj, parent) {
    if (typeof obj !== "object" || obj === null) return obj;
    var cloned = new obj.constructor();
    for(var i in obj){
        if (!obj.hasOwnProperty(i)) continue;
        var value = obj[i];
        var type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (value instanceof Array) cloned[i] = value.map(function(j) {
            return cloneNode(j, cloned);
        });
        else cloned[i] = cloneNode(value, cloned);
    }
    return cloned;
};
var $968291640d17d0cd$var$Node = /*#__PURE__*/ function() {
    function Node(opts) {
        if (opts === void 0) opts = {};
        Object.assign(this, opts);
        this.spaces = this.spaces || {};
        this.spaces.before = this.spaces.before || "";
        this.spaces.after = this.spaces.after || "";
    }
    var _proto = Node.prototype;
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        if (this.parent) {
            for(var index in arguments)this.parent.insertBefore(this, arguments[index]);
            this.remove();
        }
        return this;
    };
    _proto.next = function next() {
        return this.parent.at(this.parent.index(this) + 1);
    };
    _proto.prev = function prev() {
        return this.parent.at(this.parent.index(this) - 1);
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $968291640d17d0cd$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    } /**
   * Some non-standard syntax doesn't follow normal escaping rules for css.
   * This allows non standard syntax to be appended to an existing property
   * by specifying the escaped value. By specifying the escaped value,
   * illegal characters are allowed to be directly inserted into css output.
   * @param {string} name the property to set
   * @param {any} value the unescaped value of the property
   * @param {string} valueEscaped optional. the escaped value of the property.
   */ ;
    _proto.appendToPropertyAndEscape = function appendToPropertyAndEscape(name, value, valueEscaped) {
        if (!this.raws) this.raws = {};
        var originalValue = this[name];
        var originalEscaped = this.raws[name];
        this[name] = originalValue + value; // this may trigger a setter that updates raws, so it has to be set first.
        if (originalEscaped || valueEscaped !== value) this.raws[name] = (originalEscaped || originalValue) + valueEscaped;
        else delete this.raws[name]; // delete any escaped value that was created by the setter.
    } /**
   * Some non-standard syntax doesn't follow normal escaping rules for css.
   * This allows the escaped value to be specified directly, allowing illegal
   * characters to be directly inserted into css output.
   * @param {string} name the property to set
   * @param {any} value the unescaped value of the property
   * @param {string} valueEscaped the escaped value of the property.
   */ ;
    _proto.setPropertyAndEscape = function setPropertyAndEscape(name, value, valueEscaped) {
        if (!this.raws) this.raws = {};
        this[name] = value; // this may trigger a setter that updates raws, so it has to be set first.
        this.raws[name] = valueEscaped;
    } /**
   * When you want a value to passed through to CSS directly. This method
   * deletes the corresponding raw value causing the stringifier to fallback
   * to the unescaped value.
   * @param {string} name the property to set.
   * @param {any} value The value that is both escaped and unescaped.
   */ ;
    _proto.setPropertyWithoutEscape = function setPropertyWithoutEscape(name, value) {
        this[name] = value; // this may trigger a setter that updates raws, so it has to be set first.
        if (this.raws) delete this.raws[name];
    } /**
   *
   * @param {number} line The number (starting with 1)
   * @param {number} column The column number (starting with 1)
   */ ;
    _proto.isAtPosition = function isAtPosition(line, column) {
        if (this.source && this.source.start && this.source.end) {
            if (this.source.start.line > line) return false;
            if (this.source.end.line < line) return false;
            if (this.source.start.line === line && this.source.start.column > column) return false;
            if (this.source.end.line === line && this.source.end.column < column) return false;
            return true;
        }
        return undefined;
    };
    _proto.stringifyProperty = function stringifyProperty(name) {
        return this.raws && this.raws[name] || this[name];
    };
    _proto.valueToString = function valueToString() {
        return String(this.stringifyProperty("value"));
    };
    _proto.toString = function toString() {
        return [
            this.rawSpaceBefore,
            this.valueToString(),
            this.rawSpaceAfter
        ].join("");
    };
    $968291640d17d0cd$var$_createClass(Node, [
        {
            key: "rawSpaceBefore",
            get: function get() {
                var rawSpace = this.raws && this.raws.spaces && this.raws.spaces.before;
                if (rawSpace === undefined) rawSpace = this.spaces && this.spaces.before;
                return rawSpace || "";
            },
            set: function set(raw) {
                (0, $luBnX.ensureObject)(this, "raws", "spaces");
                this.raws.spaces.before = raw;
            }
        },
        {
            key: "rawSpaceAfter",
            get: function get() {
                var rawSpace = this.raws && this.raws.spaces && this.raws.spaces.after;
                if (rawSpace === undefined) rawSpace = this.spaces.after;
                return rawSpace || "";
            },
            set: function set(raw) {
                (0, $luBnX.ensureObject)(this, "raws", "spaces");
                this.raws.spaces.after = raw;
            }
        }
    ]);
    return Node;
}();
module.exports["default"] = $968291640d17d0cd$var$Node;
module.exports = module.exports.default;

});
parcelRegister("luBnX", function(module, exports) {

$parcel$export(module.exports, "ensureObject", function () { return $fa59664772ac19b1$export$b5478a1684008f71; }, function (v) { return $fa59664772ac19b1$export$b5478a1684008f71 = v; });
$parcel$export(module.exports, "getProp", function () { return $fa59664772ac19b1$export$88c9ddb45cea7241; }, function (v) { return $fa59664772ac19b1$export$88c9ddb45cea7241 = v; });
$parcel$export(module.exports, "unesc", function () { return $fa59664772ac19b1$export$9db703a29422957e; }, function (v) { return $fa59664772ac19b1$export$9db703a29422957e = v; });
var $fa59664772ac19b1$export$1e511d4a378977f5;
var $fa59664772ac19b1$export$f46565c3d339d23a;
var $fa59664772ac19b1$export$b5478a1684008f71;
var $fa59664772ac19b1$export$88c9ddb45cea7241;
var $fa59664772ac19b1$export$9db703a29422957e;
"use strict";
$fa59664772ac19b1$export$1e511d4a378977f5 = true;
$fa59664772ac19b1$export$f46565c3d339d23a = $fa59664772ac19b1$export$b5478a1684008f71 = $fa59664772ac19b1$export$88c9ddb45cea7241 = $fa59664772ac19b1$export$9db703a29422957e = void 0;

var $fa59664772ac19b1$var$_unesc = $fa59664772ac19b1$var$_interopRequireDefault((parcelRequire("jrlMh")));
$fa59664772ac19b1$export$9db703a29422957e = $fa59664772ac19b1$var$_unesc["default"];

var $fa59664772ac19b1$var$_getProp = $fa59664772ac19b1$var$_interopRequireDefault((parcelRequire("cIUf6")));
$fa59664772ac19b1$export$88c9ddb45cea7241 = $fa59664772ac19b1$var$_getProp["default"];

var $fa59664772ac19b1$var$_ensureObject = $fa59664772ac19b1$var$_interopRequireDefault((parcelRequire("cr15P")));
$fa59664772ac19b1$export$b5478a1684008f71 = $fa59664772ac19b1$var$_ensureObject["default"];

var $fa59664772ac19b1$var$_stripComments = $fa59664772ac19b1$var$_interopRequireDefault((parcelRequire("fqt5M")));
$fa59664772ac19b1$export$f46565c3d339d23a = $fa59664772ac19b1$var$_stripComments["default"];
function $fa59664772ac19b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("jrlMh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $e2716e8c8cb4d489$var$unesc;
// Many thanks for this post which made this migration much easier.
// https://mathiasbynens.be/notes/css-escapes
/**
 * 
 * @param {string} str 
 * @returns {[string, number]|undefined}
 */ function $e2716e8c8cb4d489$var$gobbleHex(str) {
    var lower = str.toLowerCase();
    var hex = "";
    var spaceTerminated = false;
    for(var i = 0; i < 6 && lower[i] !== undefined; i++){
        var code = lower.charCodeAt(i); // check to see if we are dealing with a valid hex char [a-f|0-9]
        var valid = code >= 97 && code <= 102 || code >= 48 && code <= 57; // https://drafts.csswg.org/css-syntax/#consume-escaped-code-point
        spaceTerminated = code === 32;
        if (!valid) break;
        hex += lower[i];
    }
    if (hex.length === 0) return undefined;
    var codePoint = parseInt(hex, 16);
    var isSurrogate = codePoint >= 0xD800 && codePoint <= 0xDFFF; // Add special case for
    // "If this number is zero, or is for a surrogate, or is greater than the maximum allowed code point"
    // https://drafts.csswg.org/css-syntax/#maximum-allowed-code-point
    if (isSurrogate || codePoint === 0x0000 || codePoint > 0x10FFFF) return [
        "\uFFFD",
        hex.length + (spaceTerminated ? 1 : 0)
    ];
    return [
        String.fromCodePoint(codePoint),
        hex.length + (spaceTerminated ? 1 : 0)
    ];
}
var $e2716e8c8cb4d489$var$CONTAINS_ESCAPE = /\\/;
function $e2716e8c8cb4d489$var$unesc(str) {
    var needToProcess = $e2716e8c8cb4d489$var$CONTAINS_ESCAPE.test(str);
    if (!needToProcess) return str;
    var ret = "";
    for(var i = 0; i < str.length; i++){
        if (str[i] === "\\") {
            var gobbled = $e2716e8c8cb4d489$var$gobbleHex(str.slice(i + 1, i + 7));
            if (gobbled !== undefined) {
                ret += gobbled[0];
                i += gobbled[1];
                continue;
            } // Retain a pair of \\ if double escaped `\\\\`
            // https://github.com/postcss/postcss-selector-parser/commit/268c9a7656fb53f543dc620aa5b73a30ec3ff20e
            if (str[i + 1] === "\\") {
                ret += "\\";
                i++;
                continue;
            } // if \\ is at the end of the string retain it
            // https://github.com/postcss/postcss-selector-parser/commit/01a6b346e3612ce1ab20219acc26abdc259ccefb
            if (str.length === i + 1) ret += str[i];
            continue;
        }
        ret += str[i];
    }
    return ret;
}
module.exports = module.exports.default;

});

parcelRegister("cIUf6", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $943538b195b03152$var$getProp;
function $943538b195b03152$var$getProp(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)props[_key - 1] = arguments[_key];
    while(props.length > 0){
        var prop = props.shift();
        if (!obj[prop]) return undefined;
        obj = obj[prop];
    }
    return obj;
}
module.exports = module.exports.default;

});

parcelRegister("cr15P", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $90d8dab4eff8055d$var$ensureObject;
function $90d8dab4eff8055d$var$ensureObject(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)props[_key - 1] = arguments[_key];
    while(props.length > 0){
        var prop = props.shift();
        if (!obj[prop]) obj[prop] = {};
        obj = obj[prop];
    }
}
module.exports = module.exports.default;

});

parcelRegister("fqt5M", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $b3afd9d356ccf2d4$var$stripComments;
function $b3afd9d356ccf2d4$var$stripComments(str) {
    var s = "";
    var commentStart = str.indexOf("/*");
    var lastEnd = 0;
    while(commentStart >= 0){
        s = s + str.slice(lastEnd, commentStart);
        var commentEnd = str.indexOf("*/", commentStart + 2);
        if (commentEnd < 0) return s;
        lastEnd = commentEnd + 2;
        commentStart = str.indexOf("/*", lastEnd);
    }
    s = s + str.slice(lastEnd);
    return s;
}
module.exports = module.exports.default;

});



parcelRegister("7rSK2", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $56c58492d88db298$export$1e511d4a378977f5; }, function (v) { return $56c58492d88db298$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "UNIVERSAL", function () { return $56c58492d88db298$export$1b322f0de0b7013c; }, function (v) { return $56c58492d88db298$export$1b322f0de0b7013c = v; });
$parcel$export(module.exports, "ATTRIBUTE", function () { return $56c58492d88db298$export$77a31abf1489fff; }, function (v) { return $56c58492d88db298$export$77a31abf1489fff = v; });
$parcel$export(module.exports, "CLASS", function () { return $56c58492d88db298$export$6120d77db9a8f6cb; }, function (v) { return $56c58492d88db298$export$6120d77db9a8f6cb = v; });
$parcel$export(module.exports, "COMBINATOR", function () { return $56c58492d88db298$export$79b4952c4e8820f9; }, function (v) { return $56c58492d88db298$export$79b4952c4e8820f9 = v; });
$parcel$export(module.exports, "COMMENT", function () { return $56c58492d88db298$export$a29989082612d0d9; }, function (v) { return $56c58492d88db298$export$a29989082612d0d9 = v; });
$parcel$export(module.exports, "ID", function () { return $56c58492d88db298$export$8be180ec26319f9f; }, function (v) { return $56c58492d88db298$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "NESTING", function () { return $56c58492d88db298$export$cc64a2a6b37abd26; }, function (v) { return $56c58492d88db298$export$cc64a2a6b37abd26 = v; });
$parcel$export(module.exports, "PSEUDO", function () { return $56c58492d88db298$export$92b96eef0c524913; }, function (v) { return $56c58492d88db298$export$92b96eef0c524913 = v; });
$parcel$export(module.exports, "ROOT", function () { return $56c58492d88db298$export$fbea82a1c0574ef4; }, function (v) { return $56c58492d88db298$export$fbea82a1c0574ef4 = v; });
$parcel$export(module.exports, "SELECTOR", function () { return $56c58492d88db298$export$c63acf214e1d55ea; }, function (v) { return $56c58492d88db298$export$c63acf214e1d55ea = v; });
$parcel$export(module.exports, "STRING", function () { return $56c58492d88db298$export$a0e01ba2ebef17f2; }, function (v) { return $56c58492d88db298$export$a0e01ba2ebef17f2 = v; });
$parcel$export(module.exports, "TAG", function () { return $56c58492d88db298$export$2680f340d0781853; }, function (v) { return $56c58492d88db298$export$2680f340d0781853 = v; });
var $56c58492d88db298$export$1e511d4a378977f5;
var $56c58492d88db298$export$1b322f0de0b7013c;
var $56c58492d88db298$export$77a31abf1489fff;
var $56c58492d88db298$export$6120d77db9a8f6cb;
var $56c58492d88db298$export$79b4952c4e8820f9;
var $56c58492d88db298$export$a29989082612d0d9;
var $56c58492d88db298$export$8be180ec26319f9f;
var $56c58492d88db298$export$cc64a2a6b37abd26;
var $56c58492d88db298$export$92b96eef0c524913;
var $56c58492d88db298$export$fbea82a1c0574ef4;
var $56c58492d88db298$export$c63acf214e1d55ea;
var $56c58492d88db298$export$a0e01ba2ebef17f2;
var $56c58492d88db298$export$2680f340d0781853;
"use strict";
$56c58492d88db298$export$1e511d4a378977f5 = true;
$56c58492d88db298$export$1b322f0de0b7013c = $56c58492d88db298$export$77a31abf1489fff = $56c58492d88db298$export$6120d77db9a8f6cb = $56c58492d88db298$export$79b4952c4e8820f9 = $56c58492d88db298$export$a29989082612d0d9 = $56c58492d88db298$export$8be180ec26319f9f = $56c58492d88db298$export$cc64a2a6b37abd26 = $56c58492d88db298$export$92b96eef0c524913 = $56c58492d88db298$export$fbea82a1c0574ef4 = $56c58492d88db298$export$c63acf214e1d55ea = $56c58492d88db298$export$a0e01ba2ebef17f2 = $56c58492d88db298$export$2680f340d0781853 = void 0;
var $56c58492d88db298$var$TAG = "tag";
$56c58492d88db298$export$2680f340d0781853 = $56c58492d88db298$var$TAG;
var $56c58492d88db298$var$STRING = "string";
$56c58492d88db298$export$a0e01ba2ebef17f2 = $56c58492d88db298$var$STRING;
var $56c58492d88db298$var$SELECTOR = "selector";
$56c58492d88db298$export$c63acf214e1d55ea = $56c58492d88db298$var$SELECTOR;
var $56c58492d88db298$var$ROOT = "root";
$56c58492d88db298$export$fbea82a1c0574ef4 = $56c58492d88db298$var$ROOT;
var $56c58492d88db298$var$PSEUDO = "pseudo";
$56c58492d88db298$export$92b96eef0c524913 = $56c58492d88db298$var$PSEUDO;
var $56c58492d88db298$var$NESTING = "nesting";
$56c58492d88db298$export$cc64a2a6b37abd26 = $56c58492d88db298$var$NESTING;
var $56c58492d88db298$var$ID = "id";
$56c58492d88db298$export$8be180ec26319f9f = $56c58492d88db298$var$ID;
var $56c58492d88db298$var$COMMENT = "comment";
$56c58492d88db298$export$a29989082612d0d9 = $56c58492d88db298$var$COMMENT;
var $56c58492d88db298$var$COMBINATOR = "combinator";
$56c58492d88db298$export$79b4952c4e8820f9 = $56c58492d88db298$var$COMBINATOR;
var $56c58492d88db298$var$CLASS = "class";
$56c58492d88db298$export$6120d77db9a8f6cb = $56c58492d88db298$var$CLASS;
var $56c58492d88db298$var$ATTRIBUTE = "attribute";
$56c58492d88db298$export$77a31abf1489fff = $56c58492d88db298$var$ATTRIBUTE;
var $56c58492d88db298$var$UNIVERSAL = "universal";
$56c58492d88db298$export$1b322f0de0b7013c = $56c58492d88db298$var$UNIVERSAL;

});



parcelRegister("dRMm5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $a185bbf181f8a55b$var$_container = $a185bbf181f8a55b$var$_interopRequireDefault((parcelRequire("bQEWD")));

var $7rSK2 = parcelRequire("7rSK2");
function $a185bbf181f8a55b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a185bbf181f8a55b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $a185bbf181f8a55b$var$_setPrototypeOf(subClass, superClass);
}
function $a185bbf181f8a55b$var$_setPrototypeOf(o, p) {
    $a185bbf181f8a55b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a185bbf181f8a55b$var$_setPrototypeOf(o, p);
}
var $a185bbf181f8a55b$var$Selector = /*#__PURE__*/ function(_Container) {
    $a185bbf181f8a55b$var$_inheritsLoose(Selector, _Container);
    function Selector(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $7rSK2.SELECTOR;
        return _this;
    }
    return Selector;
}($a185bbf181f8a55b$var$_container["default"]);
module.exports["default"] = $a185bbf181f8a55b$var$Selector;
module.exports = module.exports.default;

});

parcelRegister("kp4zM", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $eda9b126423c0f8a$var$_cssesc = $eda9b126423c0f8a$var$_interopRequireDefault((parcelRequire("3NpeD")));

var $luBnX = parcelRequire("luBnX");

var $eda9b126423c0f8a$var$_node = $eda9b126423c0f8a$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $7rSK2 = parcelRequire("7rSK2");
function $eda9b126423c0f8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $eda9b126423c0f8a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eda9b126423c0f8a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eda9b126423c0f8a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eda9b126423c0f8a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $eda9b126423c0f8a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $eda9b126423c0f8a$var$_setPrototypeOf(subClass, superClass);
}
function $eda9b126423c0f8a$var$_setPrototypeOf(o, p) {
    $eda9b126423c0f8a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda9b126423c0f8a$var$_setPrototypeOf(o, p);
}
var $eda9b126423c0f8a$var$ClassName = /*#__PURE__*/ function(_Node) {
    $eda9b126423c0f8a$var$_inheritsLoose(ClassName, _Node);
    function ClassName(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $7rSK2.CLASS;
        _this._constructed = true;
        return _this;
    }
    var _proto = ClassName.prototype;
    _proto.valueToString = function valueToString() {
        return "." + _Node.prototype.valueToString.call(this);
    };
    $eda9b126423c0f8a$var$_createClass(ClassName, [
        {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(v) {
                if (this._constructed) {
                    var escaped = (0, $eda9b126423c0f8a$var$_cssesc["default"])(v, {
                        isIdentifier: true
                    });
                    if (escaped !== v) {
                        (0, $luBnX.ensureObject)(this, "raws");
                        this.raws.value = escaped;
                    } else if (this.raws) delete this.raws.value;
                }
                this._value = v;
            }
        }
    ]);
    return ClassName;
}($eda9b126423c0f8a$var$_node["default"]);
module.exports["default"] = $eda9b126423c0f8a$var$ClassName;
module.exports = module.exports.default;

});
parcelRegister("3NpeD", function(module, exports) {
/*! https://mths.be/cssesc v3.0.0 by @mathias */ "use strict";
var $2c3985da4422de2a$var$object = {};
var $2c3985da4422de2a$var$hasOwnProperty = $2c3985da4422de2a$var$object.hasOwnProperty;
var $2c3985da4422de2a$var$merge = function merge(options, defaults) {
    if (!options) return defaults;
    var result = {};
    for(var key in defaults)// `if (defaults.hasOwnProperty(key) { … }` is not needed here, since
    // only recognized option names are used.
    result[key] = $2c3985da4422de2a$var$hasOwnProperty.call(options, key) ? options[key] : defaults[key];
    return result;
};
var $2c3985da4422de2a$var$regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
var $2c3985da4422de2a$var$regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
var $2c3985da4422de2a$var$regexAlwaysEscape = /['"\\]/;
var $2c3985da4422de2a$var$regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
// https://mathiasbynens.be/notes/css-escapes#css
var $2c3985da4422de2a$var$cssesc = function cssesc(string, options) {
    options = $2c3985da4422de2a$var$merge(options, cssesc.options);
    if (options.quotes != "single" && options.quotes != "double") options.quotes = "single";
    var quote = options.quotes == "double" ? '"' : "'";
    var isIdentifier = options.isIdentifier;
    var firstChar = string.charAt(0);
    var output = "";
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var character = string.charAt(counter++);
        var codePoint = character.charCodeAt();
        var value = void 0;
        // If it’s not a printable ASCII character…
        if (codePoint < 0x20 || codePoint > 0x7E) {
            if (codePoint >= 0xD800 && codePoint <= 0xDBFF && counter < length) {
                // It’s a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // next character is low surrogate
                codePoint = ((codePoint & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000;
                else // It’s an unmatched surrogate; only append this code unit, in case
                // the next code unit is the high surrogate of a surrogate pair.
                counter--;
            }
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else {
            if (options.escapeEverything) {
                if ($2c3985da4422de2a$var$regexAnySingleEscape.test(character)) value = "\\" + character;
                else value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            } else if (/[\t\n\f\r\x0B]/.test(character)) value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            else if (character == "\\" || !isIdentifier && (character == '"' && quote == character || character == "'" && quote == character) || isIdentifier && $2c3985da4422de2a$var$regexSingleEscape.test(character)) value = "\\" + character;
            else value = character;
        }
        output += value;
    }
    if (isIdentifier) {
        if (/^-[-\d]/.test(output)) output = "\\-" + output.slice(1);
        else if (/\d/.test(firstChar)) output = "\\3" + firstChar + " " + output.slice(1);
    }
    // Remove spaces after `\HEX` escapes that are not followed by a hex digit,
    // since they’re redundant. Note that this is only possible if the escape
    // sequence isn’t preceded by an odd number of backslashes.
    output = output.replace($2c3985da4422de2a$var$regexExcessiveSpaces, function($0, $1, $2) {
        if ($1 && $1.length % 2) // It’s not safe to remove the space, so don’t.
        return $0;
        // Strip the space.
        return ($1 || "") + $2;
    });
    if (!isIdentifier && options.wrap) return quote + output + quote;
    return output;
};
// Expose default options (so they can be overridden globally).
$2c3985da4422de2a$var$cssesc.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
};
$2c3985da4422de2a$var$cssesc.version = "3.0.0";
module.exports = $2c3985da4422de2a$var$cssesc;

});


parcelRegister("kPEv5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $f2a7fc990330b013$var$_node = $f2a7fc990330b013$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $7rSK2 = parcelRequire("7rSK2");
function $f2a7fc990330b013$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f2a7fc990330b013$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $f2a7fc990330b013$var$_setPrototypeOf(subClass, superClass);
}
function $f2a7fc990330b013$var$_setPrototypeOf(o, p) {
    $f2a7fc990330b013$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f2a7fc990330b013$var$_setPrototypeOf(o, p);
}
var $f2a7fc990330b013$var$Comment = /*#__PURE__*/ function(_Node) {
    $f2a7fc990330b013$var$_inheritsLoose(Comment, _Node);
    function Comment(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $7rSK2.COMMENT;
        return _this;
    }
    return Comment;
}($f2a7fc990330b013$var$_node["default"]);
module.exports["default"] = $f2a7fc990330b013$var$Comment;
module.exports = module.exports.default;

});

parcelRegister("hAgLj", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $ccd2cd14809a6386$var$_node = $ccd2cd14809a6386$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $7rSK2 = parcelRequire("7rSK2");
function $ccd2cd14809a6386$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ccd2cd14809a6386$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ccd2cd14809a6386$var$_setPrototypeOf(subClass, superClass);
}
function $ccd2cd14809a6386$var$_setPrototypeOf(o, p) {
    $ccd2cd14809a6386$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ccd2cd14809a6386$var$_setPrototypeOf(o, p);
}
var $ccd2cd14809a6386$var$ID = /*#__PURE__*/ function(_Node) {
    $ccd2cd14809a6386$var$_inheritsLoose(ID, _Node);
    function ID(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $7rSK2.ID;
        return _this;
    }
    var _proto = ID.prototype;
    _proto.valueToString = function valueToString() {
        return "#" + _Node.prototype.valueToString.call(this);
    };
    return ID;
}($ccd2cd14809a6386$var$_node["default"]);
module.exports["default"] = $ccd2cd14809a6386$var$ID;
module.exports = module.exports.default;

});

parcelRegister("eBASB", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $aa2120ea9670167c$var$_namespace = $aa2120ea9670167c$var$_interopRequireDefault((parcelRequire("1Yplf")));

var $7rSK2 = parcelRequire("7rSK2");
function $aa2120ea9670167c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $aa2120ea9670167c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $aa2120ea9670167c$var$_setPrototypeOf(subClass, superClass);
}
function $aa2120ea9670167c$var$_setPrototypeOf(o, p) {
    $aa2120ea9670167c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aa2120ea9670167c$var$_setPrototypeOf(o, p);
}
var $aa2120ea9670167c$var$Tag = /*#__PURE__*/ function(_Namespace) {
    $aa2120ea9670167c$var$_inheritsLoose(Tag, _Namespace);
    function Tag(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = $7rSK2.TAG;
        return _this;
    }
    return Tag;
}($aa2120ea9670167c$var$_namespace["default"]);
module.exports["default"] = $aa2120ea9670167c$var$Tag;
module.exports = module.exports.default;

});
parcelRegister("1Yplf", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $16ff0d600a0bd61a$var$_cssesc = $16ff0d600a0bd61a$var$_interopRequireDefault((parcelRequire("3NpeD")));

var $luBnX = parcelRequire("luBnX");

var $16ff0d600a0bd61a$var$_node = $16ff0d600a0bd61a$var$_interopRequireDefault((parcelRequire("cVa0h")));
function $16ff0d600a0bd61a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $16ff0d600a0bd61a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $16ff0d600a0bd61a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $16ff0d600a0bd61a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $16ff0d600a0bd61a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $16ff0d600a0bd61a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $16ff0d600a0bd61a$var$_setPrototypeOf(subClass, superClass);
}
function $16ff0d600a0bd61a$var$_setPrototypeOf(o, p) {
    $16ff0d600a0bd61a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $16ff0d600a0bd61a$var$_setPrototypeOf(o, p);
}
var $16ff0d600a0bd61a$var$Namespace = /*#__PURE__*/ function(_Node) {
    $16ff0d600a0bd61a$var$_inheritsLoose(Namespace, _Node);
    function Namespace() {
        return _Node.apply(this, arguments) || this;
    }
    var _proto = Namespace.prototype;
    _proto.qualifiedName = function qualifiedName(value) {
        if (this.namespace) return this.namespaceString + "|" + value;
        else return value;
    };
    _proto.valueToString = function valueToString() {
        return this.qualifiedName(_Node.prototype.valueToString.call(this));
    };
    $16ff0d600a0bd61a$var$_createClass(Namespace, [
        {
            key: "namespace",
            get: function get() {
                return this._namespace;
            },
            set: function set(namespace) {
                if (namespace === true || namespace === "*" || namespace === "&") {
                    this._namespace = namespace;
                    if (this.raws) delete this.raws.namespace;
                    return;
                }
                var escaped = (0, $16ff0d600a0bd61a$var$_cssesc["default"])(namespace, {
                    isIdentifier: true
                });
                this._namespace = namespace;
                if (escaped !== namespace) {
                    (0, $luBnX.ensureObject)(this, "raws");
                    this.raws.namespace = escaped;
                } else if (this.raws) delete this.raws.namespace;
            }
        },
        {
            key: "ns",
            get: function get() {
                return this._namespace;
            },
            set: function set(namespace) {
                this.namespace = namespace;
            }
        },
        {
            key: "namespaceString",
            get: function get() {
                if (this.namespace) {
                    var ns = this.stringifyProperty("namespace");
                    if (ns === true) return "";
                    else return ns;
                } else return "";
            }
        }
    ]);
    return Namespace;
}($16ff0d600a0bd61a$var$_node["default"]);
module.exports["default"] = $16ff0d600a0bd61a$var$Namespace;
module.exports = module.exports.default;

});


parcelRegister("gCW3v", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $c1ad3a8dd0e6fed7$var$_node = $c1ad3a8dd0e6fed7$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $7rSK2 = parcelRequire("7rSK2");
function $c1ad3a8dd0e6fed7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c1ad3a8dd0e6fed7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $c1ad3a8dd0e6fed7$var$_setPrototypeOf(subClass, superClass);
}
function $c1ad3a8dd0e6fed7$var$_setPrototypeOf(o, p) {
    $c1ad3a8dd0e6fed7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c1ad3a8dd0e6fed7$var$_setPrototypeOf(o, p);
}
var $c1ad3a8dd0e6fed7$var$String = /*#__PURE__*/ function(_Node) {
    $c1ad3a8dd0e6fed7$var$_inheritsLoose(String, _Node);
    function String(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $7rSK2.STRING;
        return _this;
    }
    return String;
}($c1ad3a8dd0e6fed7$var$_node["default"]);
module.exports["default"] = $c1ad3a8dd0e6fed7$var$String;
module.exports = module.exports.default;

});

parcelRegister("aJZwf", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $7d1dd3c3933755cc$var$_container = $7d1dd3c3933755cc$var$_interopRequireDefault((parcelRequire("bQEWD")));

var $7rSK2 = parcelRequire("7rSK2");
function $7d1dd3c3933755cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7d1dd3c3933755cc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $7d1dd3c3933755cc$var$_setPrototypeOf(subClass, superClass);
}
function $7d1dd3c3933755cc$var$_setPrototypeOf(o, p) {
    $7d1dd3c3933755cc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7d1dd3c3933755cc$var$_setPrototypeOf(o, p);
}
var $7d1dd3c3933755cc$var$Pseudo = /*#__PURE__*/ function(_Container) {
    $7d1dd3c3933755cc$var$_inheritsLoose(Pseudo, _Container);
    function Pseudo(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $7rSK2.PSEUDO;
        return _this;
    }
    var _proto = Pseudo.prototype;
    _proto.toString = function toString() {
        var params = this.length ? "(" + this.map(String).join(",") + ")" : "";
        return [
            this.rawSpaceBefore,
            this.stringifyProperty("value"),
            params,
            this.rawSpaceAfter
        ].join("");
    };
    return Pseudo;
}($7d1dd3c3933755cc$var$_container["default"]);
module.exports["default"] = $7d1dd3c3933755cc$var$Pseudo;
module.exports = module.exports.default;

});

parcelRegister("7IfkN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $59d8899252fbf235$export$1e511d4a378977f5; }, function (v) { return $59d8899252fbf235$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "unescapeValue", function () { return $59d8899252fbf235$export$1cd2dcb7d1153f00; }, function (v) { return $59d8899252fbf235$export$1cd2dcb7d1153f00 = v; });
$parcel$export(module.exports, "default", function () { return $59d8899252fbf235$export$2e2bcd8739ae039; }, function (v) { return $59d8899252fbf235$export$2e2bcd8739ae039 = v; });
var $59d8899252fbf235$export$1e511d4a378977f5;
var $59d8899252fbf235$export$1cd2dcb7d1153f00;
var $59d8899252fbf235$export$2e2bcd8739ae039;
"use strict";
$59d8899252fbf235$export$1e511d4a378977f5 = true;
$59d8899252fbf235$export$1cd2dcb7d1153f00 = $59d8899252fbf235$var$unescapeValue;
$59d8899252fbf235$export$2e2bcd8739ae039 = void 0;

var $59d8899252fbf235$var$_cssesc = $59d8899252fbf235$var$_interopRequireDefault((parcelRequire("3NpeD")));

var $59d8899252fbf235$var$_unesc = $59d8899252fbf235$var$_interopRequireDefault((parcelRequire("jrlMh")));

var $59d8899252fbf235$var$_namespace = $59d8899252fbf235$var$_interopRequireDefault((parcelRequire("1Yplf")));

var $7rSK2 = parcelRequire("7rSK2");
var $59d8899252fbf235$var$_CSSESC_QUOTE_OPTIONS;
function $59d8899252fbf235$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $59d8899252fbf235$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $59d8899252fbf235$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $59d8899252fbf235$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $59d8899252fbf235$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $59d8899252fbf235$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $59d8899252fbf235$var$_setPrototypeOf(subClass, superClass);
}
function $59d8899252fbf235$var$_setPrototypeOf(o, p) {
    $59d8899252fbf235$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $59d8899252fbf235$var$_setPrototypeOf(o, p);
}

var $4t8qa = parcelRequire("4t8qa");
var $59d8899252fbf235$var$WRAPPED_IN_QUOTES = /^('|")([^]*)\1$/;
var $59d8899252fbf235$var$warnOfDeprecatedValueAssignment = $4t8qa(function() {}, "Assigning an attribute a value containing characters that might need to be escaped is deprecated. Call attribute.setValue() instead.");
var $59d8899252fbf235$var$warnOfDeprecatedQuotedAssignment = $4t8qa(function() {}, "Assigning attr.quoted is deprecated and has no effect. Assign to attr.quoteMark instead.");
var $59d8899252fbf235$var$warnOfDeprecatedConstructor = $4t8qa(function() {}, "Constructing an Attribute selector with a value without specifying quoteMark is deprecated. Note: The value should be unescaped now.");
function $59d8899252fbf235$var$unescapeValue(value) {
    var deprecatedUsage = false;
    var quoteMark = null;
    var unescaped = value;
    var m = unescaped.match($59d8899252fbf235$var$WRAPPED_IN_QUOTES);
    if (m) {
        quoteMark = m[1];
        unescaped = m[2];
    }
    unescaped = (0, $59d8899252fbf235$var$_unesc["default"])(unescaped);
    if (unescaped !== value) deprecatedUsage = true;
    return {
        deprecatedUsage: deprecatedUsage,
        unescaped: unescaped,
        quoteMark: quoteMark
    };
}
function $59d8899252fbf235$var$handleDeprecatedContructorOpts(opts) {
    if (opts.quoteMark !== undefined) return opts;
    if (opts.value === undefined) return opts;
    $59d8899252fbf235$var$warnOfDeprecatedConstructor();
    var _unescapeValue = $59d8899252fbf235$var$unescapeValue(opts.value), quoteMark = _unescapeValue.quoteMark, unescaped = _unescapeValue.unescaped;
    if (!opts.raws) opts.raws = {};
    if (opts.raws.value === undefined) opts.raws.value = opts.value;
    opts.value = unescaped;
    opts.quoteMark = quoteMark;
    return opts;
}
var $59d8899252fbf235$var$Attribute = /*#__PURE__*/ function(_Namespace) {
    $59d8899252fbf235$var$_inheritsLoose(Attribute, _Namespace);
    function Attribute(opts) {
        var _this;
        if (opts === void 0) opts = {};
        _this = _Namespace.call(this, $59d8899252fbf235$var$handleDeprecatedContructorOpts(opts)) || this;
        _this.type = $7rSK2.ATTRIBUTE;
        _this.raws = _this.raws || {};
        Object.defineProperty(_this.raws, "unquoted", {
            get: $4t8qa(function() {
                return _this.value;
            }, "attr.raws.unquoted is deprecated. Call attr.value instead."),
            set: $4t8qa(function() {
                return _this.value;
            }, "Setting attr.raws.unquoted is deprecated and has no effect. attr.value is unescaped by default now.")
        });
        _this._constructed = true;
        return _this;
    }
    /**
   * Returns the Attribute's value quoted such that it would be legal to use
   * in the value of a css file. The original value's quotation setting
   * used for stringification is left unchanged. See `setValue(value, options)`
   * if you want to control the quote settings of a new value for the attribute.
   *
   * You can also change the quotation used for the current value by setting quoteMark.
   *
   * Options:
   *   * quoteMark {'"' | "'" | null} - Use this value to quote the value. If this
   *     option is not set, the original value for quoteMark will be used. If
   *     indeterminate, a double quote is used. The legal values are:
   *     * `null` - the value will be unquoted and characters will be escaped as necessary.
   *     * `'` - the value will be quoted with a single quote and single quotes are escaped.
   *     * `"` - the value will be quoted with a double quote and double quotes are escaped.
   *   * preferCurrentQuoteMark {boolean} - if true, prefer the source quote mark
   *     over the quoteMark option value.
   *   * smart {boolean} - if true, will select a quote mark based on the value
   *     and the other options specified here. See the `smartQuoteMark()`
   *     method.
   **/ var _proto = Attribute.prototype;
    _proto.getQuotedValue = function getQuotedValue(options) {
        if (options === void 0) options = {};
        var quoteMark = this._determineQuoteMark(options);
        var cssescopts = $59d8899252fbf235$var$CSSESC_QUOTE_OPTIONS[quoteMark];
        var escaped = (0, $59d8899252fbf235$var$_cssesc["default"])(this._value, cssescopts);
        return escaped;
    };
    _proto._determineQuoteMark = function _determineQuoteMark(options) {
        return options.smart ? this.smartQuoteMark(options) : this.preferredQuoteMark(options);
    } /**
   * Set the unescaped value with the specified quotation options. The value
   * provided must not include any wrapping quote marks -- those quotes will
   * be interpreted as part of the value and escaped accordingly.
   */ ;
    _proto.setValue = function setValue(value, options) {
        if (options === void 0) options = {};
        this._value = value;
        this._quoteMark = this._determineQuoteMark(options);
        this._syncRawValue();
    } /**
   * Intelligently select a quoteMark value based on the value's contents. If
   * the value is a legal CSS ident, it will not be quoted. Otherwise a quote
   * mark will be picked that minimizes the number of escapes.
   *
   * If there's no clear winner, the quote mark from these options is used,
   * then the source quote mark (this is inverted if `preferCurrentQuoteMark` is
   * true). If the quoteMark is unspecified, a double quote is used.
   *
   * @param options This takes the quoteMark and preferCurrentQuoteMark options
   * from the quoteValue method.
   */ ;
    _proto.smartQuoteMark = function smartQuoteMark(options) {
        var v = this.value;
        var numSingleQuotes = v.replace(/[^']/g, "").length;
        var numDoubleQuotes = v.replace(/[^"]/g, "").length;
        if (numSingleQuotes + numDoubleQuotes === 0) {
            var escaped = (0, $59d8899252fbf235$var$_cssesc["default"])(v, {
                isIdentifier: true
            });
            if (escaped === v) return Attribute.NO_QUOTE;
            else {
                var pref = this.preferredQuoteMark(options);
                if (pref === Attribute.NO_QUOTE) {
                    // pick a quote mark that isn't none and see if it's smaller
                    var quote = this.quoteMark || options.quoteMark || Attribute.DOUBLE_QUOTE;
                    var opts = $59d8899252fbf235$var$CSSESC_QUOTE_OPTIONS[quote];
                    var quoteValue = (0, $59d8899252fbf235$var$_cssesc["default"])(v, opts);
                    if (quoteValue.length < escaped.length) return quote;
                }
                return pref;
            }
        } else if (numDoubleQuotes === numSingleQuotes) return this.preferredQuoteMark(options);
        else if (numDoubleQuotes < numSingleQuotes) return Attribute.DOUBLE_QUOTE;
        else return Attribute.SINGLE_QUOTE;
    } /**
   * Selects the preferred quote mark based on the options and the current quote mark value.
   * If you want the quote mark to depend on the attribute value, call `smartQuoteMark(opts)`
   * instead.
   */ ;
    _proto.preferredQuoteMark = function preferredQuoteMark(options) {
        var quoteMark = options.preferCurrentQuoteMark ? this.quoteMark : options.quoteMark;
        if (quoteMark === undefined) quoteMark = options.preferCurrentQuoteMark ? options.quoteMark : this.quoteMark;
        if (quoteMark === undefined) quoteMark = Attribute.DOUBLE_QUOTE;
        return quoteMark;
    };
    _proto._syncRawValue = function _syncRawValue() {
        var rawValue = (0, $59d8899252fbf235$var$_cssesc["default"])(this._value, $59d8899252fbf235$var$CSSESC_QUOTE_OPTIONS[this.quoteMark]);
        if (rawValue === this._value) {
            if (this.raws) delete this.raws.value;
        } else this.raws.value = rawValue;
    };
    _proto._handleEscapes = function _handleEscapes(prop, value) {
        if (this._constructed) {
            var escaped = (0, $59d8899252fbf235$var$_cssesc["default"])(value, {
                isIdentifier: true
            });
            if (escaped !== value) this.raws[prop] = escaped;
            else delete this.raws[prop];
        }
    };
    _proto._spacesFor = function _spacesFor(name) {
        var attrSpaces = {
            before: "",
            after: ""
        };
        var spaces = this.spaces[name] || {};
        var rawSpaces = this.raws.spaces && this.raws.spaces[name] || {};
        return Object.assign(attrSpaces, spaces, rawSpaces);
    };
    _proto._stringFor = function _stringFor(name, spaceName, concat) {
        if (spaceName === void 0) spaceName = name;
        if (concat === void 0) concat = $59d8899252fbf235$var$defaultAttrConcat;
        var attrSpaces = this._spacesFor(spaceName);
        return concat(this.stringifyProperty(name), attrSpaces);
    } /**
   * returns the offset of the attribute part specified relative to the
   * start of the node of the output string.
   *
   * * "ns" - alias for "namespace"
   * * "namespace" - the namespace if it exists.
   * * "attribute" - the attribute name
   * * "attributeNS" - the start of the attribute or its namespace
   * * "operator" - the match operator of the attribute
   * * "value" - The value (string or identifier)
   * * "insensitive" - the case insensitivity flag;
   * @param part One of the possible values inside an attribute.
   * @returns -1 if the name is invalid or the value doesn't exist in this attribute.
   */ ;
    _proto.offsetOf = function offsetOf(name) {
        var count = 1;
        var attributeSpaces = this._spacesFor("attribute");
        count += attributeSpaces.before.length;
        if (name === "namespace" || name === "ns") return this.namespace ? count : -1;
        if (name === "attributeNS") return count;
        count += this.namespaceString.length;
        if (this.namespace) count += 1;
        if (name === "attribute") return count;
        count += this.stringifyProperty("attribute").length;
        count += attributeSpaces.after.length;
        var operatorSpaces = this._spacesFor("operator");
        count += operatorSpaces.before.length;
        var operator = this.stringifyProperty("operator");
        if (name === "operator") return operator ? count : -1;
        count += operator.length;
        count += operatorSpaces.after.length;
        var valueSpaces = this._spacesFor("value");
        count += valueSpaces.before.length;
        var value = this.stringifyProperty("value");
        if (name === "value") return value ? count : -1;
        count += value.length;
        count += valueSpaces.after.length;
        var insensitiveSpaces = this._spacesFor("insensitive");
        count += insensitiveSpaces.before.length;
        if (name === "insensitive") return this.insensitive ? count : -1;
        return -1;
    };
    _proto.toString = function toString() {
        var _this2 = this;
        var selector = [
            this.rawSpaceBefore,
            "["
        ];
        selector.push(this._stringFor("qualifiedAttribute", "attribute"));
        if (this.operator && (this.value || this.value === "")) {
            selector.push(this._stringFor("operator"));
            selector.push(this._stringFor("value"));
            selector.push(this._stringFor("insensitiveFlag", "insensitive", function(attrValue, attrSpaces) {
                if (attrValue.length > 0 && !_this2.quoted && attrSpaces.before.length === 0 && !(_this2.spaces.value && _this2.spaces.value.after)) attrSpaces.before = " ";
                return $59d8899252fbf235$var$defaultAttrConcat(attrValue, attrSpaces);
            }));
        }
        selector.push("]");
        selector.push(this.rawSpaceAfter);
        return selector.join("");
    };
    $59d8899252fbf235$var$_createClass(Attribute, [
        {
            key: "quoted",
            get: function get() {
                var qm = this.quoteMark;
                return qm === "'" || qm === '"';
            },
            set: function set(value) {
                $59d8899252fbf235$var$warnOfDeprecatedQuotedAssignment();
            }
        },
        {
            key: "quoteMark",
            get: function get() {
                return this._quoteMark;
            },
            set: function set(quoteMark) {
                if (!this._constructed) {
                    this._quoteMark = quoteMark;
                    return;
                }
                if (this._quoteMark !== quoteMark) {
                    this._quoteMark = quoteMark;
                    this._syncRawValue();
                }
            }
        },
        {
            key: "qualifiedAttribute",
            get: function get() {
                return this.qualifiedName(this.raws.attribute || this.attribute);
            }
        },
        {
            key: "insensitiveFlag",
            get: function get() {
                return this.insensitive ? "i" : "";
            }
        },
        {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(v) {
                if (this._constructed) {
                    var _unescapeValue2 = $59d8899252fbf235$var$unescapeValue(v), deprecatedUsage = _unescapeValue2.deprecatedUsage, unescaped = _unescapeValue2.unescaped, quoteMark = _unescapeValue2.quoteMark;
                    if (deprecatedUsage) $59d8899252fbf235$var$warnOfDeprecatedValueAssignment();
                    if (unescaped === this._value && quoteMark === this._quoteMark) return;
                    this._value = unescaped;
                    this._quoteMark = quoteMark;
                    this._syncRawValue();
                } else this._value = v;
            }
        },
        {
            key: "attribute",
            get: function get() {
                return this._attribute;
            },
            set: function set(name) {
                this._handleEscapes("attribute", name);
                this._attribute = name;
            }
        }
    ]);
    return Attribute;
}($59d8899252fbf235$var$_namespace["default"]);
$59d8899252fbf235$export$2e2bcd8739ae039 = $59d8899252fbf235$var$Attribute;
$59d8899252fbf235$var$Attribute.NO_QUOTE = null;
$59d8899252fbf235$var$Attribute.SINGLE_QUOTE = "'";
$59d8899252fbf235$var$Attribute.DOUBLE_QUOTE = '"';
var $59d8899252fbf235$var$CSSESC_QUOTE_OPTIONS = ($59d8899252fbf235$var$_CSSESC_QUOTE_OPTIONS = {
    "'": {
        quotes: "single",
        wrap: true
    },
    '"': {
        quotes: "double",
        wrap: true
    }
}, $59d8899252fbf235$var$_CSSESC_QUOTE_OPTIONS[null] = {
    isIdentifier: true
}, $59d8899252fbf235$var$_CSSESC_QUOTE_OPTIONS);
function $59d8899252fbf235$var$defaultAttrConcat(attrValue, attrSpaces) {
    return "" + attrSpaces.before + attrValue + attrSpaces.after;
}

});
parcelRegister("4t8qa", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $3410672026ede700$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $3410672026ede700$var$deprecate(fn, msg) {
    if ($3410672026ede700$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($3410672026ede700$var$config("throwDeprecation")) throw new Error(msg);
            else if ($3410672026ede700$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $3410672026ede700$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});


parcelRegister("6Wm91", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $50d9565064e04e28$var$_namespace = $50d9565064e04e28$var$_interopRequireDefault((parcelRequire("1Yplf")));

var $7rSK2 = parcelRequire("7rSK2");
function $50d9565064e04e28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $50d9565064e04e28$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $50d9565064e04e28$var$_setPrototypeOf(subClass, superClass);
}
function $50d9565064e04e28$var$_setPrototypeOf(o, p) {
    $50d9565064e04e28$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $50d9565064e04e28$var$_setPrototypeOf(o, p);
}
var $50d9565064e04e28$var$Universal = /*#__PURE__*/ function(_Namespace) {
    $50d9565064e04e28$var$_inheritsLoose(Universal, _Namespace);
    function Universal(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = $7rSK2.UNIVERSAL;
        _this.value = "*";
        return _this;
    }
    return Universal;
}($50d9565064e04e28$var$_namespace["default"]);
module.exports["default"] = $50d9565064e04e28$var$Universal;
module.exports = module.exports.default;

});

parcelRegister("1WlCQ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $169bfb94e81bc5e0$var$_node = $169bfb94e81bc5e0$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $7rSK2 = parcelRequire("7rSK2");
function $169bfb94e81bc5e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $169bfb94e81bc5e0$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $169bfb94e81bc5e0$var$_setPrototypeOf(subClass, superClass);
}
function $169bfb94e81bc5e0$var$_setPrototypeOf(o, p) {
    $169bfb94e81bc5e0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $169bfb94e81bc5e0$var$_setPrototypeOf(o, p);
}
var $169bfb94e81bc5e0$var$Combinator = /*#__PURE__*/ function(_Node) {
    $169bfb94e81bc5e0$var$_inheritsLoose(Combinator, _Node);
    function Combinator(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $7rSK2.COMBINATOR;
        return _this;
    }
    return Combinator;
}($169bfb94e81bc5e0$var$_node["default"]);
module.exports["default"] = $169bfb94e81bc5e0$var$Combinator;
module.exports = module.exports.default;

});

parcelRegister("i0cQl", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $d1b230828a6d3c8b$var$_node = $d1b230828a6d3c8b$var$_interopRequireDefault((parcelRequire("cVa0h")));

var $7rSK2 = parcelRequire("7rSK2");
function $d1b230828a6d3c8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d1b230828a6d3c8b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d1b230828a6d3c8b$var$_setPrototypeOf(subClass, superClass);
}
function $d1b230828a6d3c8b$var$_setPrototypeOf(o, p) {
    $d1b230828a6d3c8b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d1b230828a6d3c8b$var$_setPrototypeOf(o, p);
}
var $d1b230828a6d3c8b$var$Nesting = /*#__PURE__*/ function(_Node) {
    $d1b230828a6d3c8b$var$_inheritsLoose(Nesting, _Node);
    function Nesting(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $7rSK2.NESTING;
        _this.value = "&";
        return _this;
    }
    return Nesting;
}($d1b230828a6d3c8b$var$_node["default"]);
module.exports["default"] = $d1b230828a6d3c8b$var$Nesting;
module.exports = module.exports.default;

});

parcelRegister("3jKYf", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $26a794d965d016c4$var$sortAscending;
function $26a794d965d016c4$var$sortAscending(list) {
    return list.sort(function(a, b) {
        return a - b;
    });
}
module.exports = module.exports.default;

});

parcelRegister("km27S", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $ed1782e63cafba37$export$1e511d4a378977f5; }, function (v) { return $ed1782e63cafba37$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $ed1782e63cafba37$export$2e2bcd8739ae039; }, function (v) { return $ed1782e63cafba37$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "FIELDS", function () { return $ed1782e63cafba37$export$e6909ad44e61103d; }, function (v) { return $ed1782e63cafba37$export$e6909ad44e61103d = v; });
var $ed1782e63cafba37$export$1e511d4a378977f5;
var $ed1782e63cafba37$export$2e2bcd8739ae039;
var $ed1782e63cafba37$export$e6909ad44e61103d;
"use strict";
$ed1782e63cafba37$export$1e511d4a378977f5 = true;
$ed1782e63cafba37$export$2e2bcd8739ae039 = $ed1782e63cafba37$var$tokenize;
$ed1782e63cafba37$export$e6909ad44e61103d = void 0;

var $ed1782e63cafba37$var$t = $ed1782e63cafba37$var$_interopRequireWildcard((parcelRequire("hqgto")));
var $ed1782e63cafba37$var$_unescapable, $ed1782e63cafba37$var$_wordDelimiters;
function $ed1782e63cafba37$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $ed1782e63cafba37$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $ed1782e63cafba37$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $ed1782e63cafba37$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $ed1782e63cafba37$var$unescapable = ($ed1782e63cafba37$var$_unescapable = {}, $ed1782e63cafba37$var$_unescapable[$ed1782e63cafba37$var$t.tab] = true, $ed1782e63cafba37$var$_unescapable[$ed1782e63cafba37$var$t.newline] = true, $ed1782e63cafba37$var$_unescapable[$ed1782e63cafba37$var$t.cr] = true, $ed1782e63cafba37$var$_unescapable[$ed1782e63cafba37$var$t.feed] = true, $ed1782e63cafba37$var$_unescapable);
var $ed1782e63cafba37$var$wordDelimiters = ($ed1782e63cafba37$var$_wordDelimiters = {}, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.space] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.tab] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.newline] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.cr] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.feed] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.ampersand] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.asterisk] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.bang] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.comma] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.colon] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.semicolon] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.openParenthesis] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.closeParenthesis] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.openSquare] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.closeSquare] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.singleQuote] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.doubleQuote] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.plus] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.pipe] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.tilde] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.greaterThan] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.equals] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.dollar] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.caret] = true, $ed1782e63cafba37$var$_wordDelimiters[$ed1782e63cafba37$var$t.slash] = true, $ed1782e63cafba37$var$_wordDelimiters);
var $ed1782e63cafba37$var$hex = {};
var $ed1782e63cafba37$var$hexChars = "0123456789abcdefABCDEF";
for(var $ed1782e63cafba37$var$i = 0; $ed1782e63cafba37$var$i < $ed1782e63cafba37$var$hexChars.length; $ed1782e63cafba37$var$i++)$ed1782e63cafba37$var$hex[$ed1782e63cafba37$var$hexChars.charCodeAt($ed1782e63cafba37$var$i)] = true;
/**
 *  Returns the last index of the bar css word
 * @param {string} css The string in which the word begins
 * @param {number} start The index into the string where word's first letter occurs
 */ function $ed1782e63cafba37$var$consumeWord(css, start) {
    var next = start;
    var code;
    do {
        code = css.charCodeAt(next);
        if ($ed1782e63cafba37$var$wordDelimiters[code]) return next - 1;
        else if (code === $ed1782e63cafba37$var$t.backslash) next = $ed1782e63cafba37$var$consumeEscape(css, next) + 1;
        else // All other characters are part of the word
        next++;
    }while (next < css.length);
    return next - 1;
}
/**
 *  Returns the last index of the escape sequence
 * @param {string} css The string in which the sequence begins
 * @param {number} start The index into the string where escape character (`\`) occurs.
 */ function $ed1782e63cafba37$var$consumeEscape(css, start) {
    var next = start;
    var code = css.charCodeAt(next + 1);
    if ($ed1782e63cafba37$var$unescapable[code]) ;
    else if ($ed1782e63cafba37$var$hex[code]) {
        var hexDigits = 0; // consume up to 6 hex chars
        do {
            next++;
            hexDigits++;
            code = css.charCodeAt(next + 1);
        }while ($ed1782e63cafba37$var$hex[code] && hexDigits < 6); // if fewer than 6 hex chars, a trailing space ends the escape
        if (hexDigits < 6 && code === $ed1782e63cafba37$var$t.space) next++;
    } else // the next char is part of the current word
    next++;
    return next;
}
var $ed1782e63cafba37$var$FIELDS = {
    TYPE: 0,
    START_LINE: 1,
    START_COL: 2,
    END_LINE: 3,
    END_COL: 4,
    START_POS: 5,
    END_POS: 6
};
$ed1782e63cafba37$export$e6909ad44e61103d = $ed1782e63cafba37$var$FIELDS;
function $ed1782e63cafba37$var$tokenize(input) {
    var tokens = [];
    var css = input.css.valueOf();
    var _css = css, length = _css.length;
    var offset = -1;
    var line = 1;
    var start = 0;
    var end = 0;
    var code, content, endColumn, endLine, escaped, escapePos, last, lines, next, nextLine, nextOffset, quote, tokenType;
    function unclosed(what, fix) {
        if (input.safe) {
            // fyi: this is never set to true.
            css += fix;
            next = css.length - 1;
        } else throw input.error("Unclosed " + what, line, start - offset, start);
    }
    while(start < length){
        code = css.charCodeAt(start);
        if (code === $ed1782e63cafba37$var$t.newline) {
            offset = start;
            line += 1;
        }
        switch(code){
            case $ed1782e63cafba37$var$t.space:
            case $ed1782e63cafba37$var$t.tab:
            case $ed1782e63cafba37$var$t.newline:
            case $ed1782e63cafba37$var$t.cr:
            case $ed1782e63cafba37$var$t.feed:
                next = start;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                    if (code === $ed1782e63cafba37$var$t.newline) {
                        offset = next;
                        line += 1;
                    }
                }while (code === $ed1782e63cafba37$var$t.space || code === $ed1782e63cafba37$var$t.newline || code === $ed1782e63cafba37$var$t.tab || code === $ed1782e63cafba37$var$t.cr || code === $ed1782e63cafba37$var$t.feed);
                tokenType = $ed1782e63cafba37$var$t.space;
                endLine = line;
                endColumn = next - offset - 1;
                end = next;
                break;
            case $ed1782e63cafba37$var$t.plus:
            case $ed1782e63cafba37$var$t.greaterThan:
            case $ed1782e63cafba37$var$t.tilde:
            case $ed1782e63cafba37$var$t.pipe:
                next = start;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $ed1782e63cafba37$var$t.plus || code === $ed1782e63cafba37$var$t.greaterThan || code === $ed1782e63cafba37$var$t.tilde || code === $ed1782e63cafba37$var$t.pipe);
                tokenType = $ed1782e63cafba37$var$t.combinator;
                endLine = line;
                endColumn = start - offset;
                end = next;
                break;
            // Consume these characters as single tokens.
            case $ed1782e63cafba37$var$t.asterisk:
            case $ed1782e63cafba37$var$t.ampersand:
            case $ed1782e63cafba37$var$t.bang:
            case $ed1782e63cafba37$var$t.comma:
            case $ed1782e63cafba37$var$t.equals:
            case $ed1782e63cafba37$var$t.dollar:
            case $ed1782e63cafba37$var$t.caret:
            case $ed1782e63cafba37$var$t.openSquare:
            case $ed1782e63cafba37$var$t.closeSquare:
            case $ed1782e63cafba37$var$t.colon:
            case $ed1782e63cafba37$var$t.semicolon:
            case $ed1782e63cafba37$var$t.openParenthesis:
            case $ed1782e63cafba37$var$t.closeParenthesis:
                next = start;
                tokenType = code;
                endLine = line;
                endColumn = start - offset;
                end = next + 1;
                break;
            case $ed1782e63cafba37$var$t.singleQuote:
            case $ed1782e63cafba37$var$t.doubleQuote:
                quote = code === $ed1782e63cafba37$var$t.singleQuote ? "'" : '"';
                next = start;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) unclosed("quote", quote);
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $ed1782e63cafba37$var$t.backslash){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                tokenType = $ed1782e63cafba37$var$t.str;
                endLine = line;
                endColumn = start - offset;
                end = next + 1;
                break;
            default:
                if (code === $ed1782e63cafba37$var$t.slash && css.charCodeAt(start + 1) === $ed1782e63cafba37$var$t.asterisk) {
                    next = css.indexOf("*/", start + 2) + 1;
                    if (next === 0) unclosed("comment", "*/");
                    content = css.slice(start, next + 1);
                    lines = content.split("\n");
                    last = lines.length - 1;
                    if (last > 0) {
                        nextLine = line + last;
                        nextOffset = next - lines[last].length;
                    } else {
                        nextLine = line;
                        nextOffset = offset;
                    }
                    tokenType = $ed1782e63cafba37$var$t.comment;
                    line = nextLine;
                    endLine = nextLine;
                    endColumn = next - nextOffset;
                } else if (code === $ed1782e63cafba37$var$t.slash) {
                    next = start;
                    tokenType = code;
                    endLine = line;
                    endColumn = start - offset;
                    end = next + 1;
                } else {
                    next = $ed1782e63cafba37$var$consumeWord(css, start);
                    tokenType = $ed1782e63cafba37$var$t.word;
                    endLine = line;
                    endColumn = next - offset;
                }
                end = next + 1;
                break;
        } // Ensure that the token structure remains consistent
        tokens.push([
            tokenType,
            line,
            start - offset,
            endLine,
            endColumn,
            start,
            end // [6] End position
        ]); // Reset offset for the next token
        if (nextOffset) {
            offset = nextOffset;
            nextOffset = null;
        }
        start = end;
    }
    return tokens;
}

});
parcelRegister("hqgto", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $caf1a49659ab2a3a$export$1e511d4a378977f5; }, function (v) { return $caf1a49659ab2a3a$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "combinator", function () { return $caf1a49659ab2a3a$export$bc8905068a6d4174; }, function (v) { return $caf1a49659ab2a3a$export$bc8905068a6d4174 = v; });
$parcel$export(module.exports, "word", function () { return $caf1a49659ab2a3a$export$ac351257249182a8; }, function (v) { return $caf1a49659ab2a3a$export$ac351257249182a8 = v; });
$parcel$export(module.exports, "comment", function () { return $caf1a49659ab2a3a$export$4a34f930e789283c; }, function (v) { return $caf1a49659ab2a3a$export$4a34f930e789283c = v; });
$parcel$export(module.exports, "str", function () { return $caf1a49659ab2a3a$export$42d51816ce590c93; }, function (v) { return $caf1a49659ab2a3a$export$42d51816ce590c93 = v; });
$parcel$export(module.exports, "tab", function () { return $caf1a49659ab2a3a$export$62d58b1c91e8e902; }, function (v) { return $caf1a49659ab2a3a$export$62d58b1c91e8e902 = v; });
$parcel$export(module.exports, "newline", function () { return $caf1a49659ab2a3a$export$2ddee7401a648d43; }, function (v) { return $caf1a49659ab2a3a$export$2ddee7401a648d43 = v; });
$parcel$export(module.exports, "feed", function () { return $caf1a49659ab2a3a$export$93d5e4db1316498e; }, function (v) { return $caf1a49659ab2a3a$export$93d5e4db1316498e = v; });
$parcel$export(module.exports, "cr", function () { return $caf1a49659ab2a3a$export$cbfbec548517f2b6; }, function (v) { return $caf1a49659ab2a3a$export$cbfbec548517f2b6 = v; });
$parcel$export(module.exports, "backslash", function () { return $caf1a49659ab2a3a$export$799abffcbb2717d6; }, function (v) { return $caf1a49659ab2a3a$export$799abffcbb2717d6 = v; });
$parcel$export(module.exports, "bang", function () { return $caf1a49659ab2a3a$export$87bdb54b7ea1f8e2; }, function (v) { return $caf1a49659ab2a3a$export$87bdb54b7ea1f8e2 = v; });
$parcel$export(module.exports, "slash", function () { return $caf1a49659ab2a3a$export$6882e7e72b50612e; }, function (v) { return $caf1a49659ab2a3a$export$6882e7e72b50612e = v; });
$parcel$export(module.exports, "doubleQuote", function () { return $caf1a49659ab2a3a$export$730a07918a7a7d93; }, function (v) { return $caf1a49659ab2a3a$export$730a07918a7a7d93 = v; });
$parcel$export(module.exports, "singleQuote", function () { return $caf1a49659ab2a3a$export$1909b7b8a28995a9; }, function (v) { return $caf1a49659ab2a3a$export$1909b7b8a28995a9 = v; });
$parcel$export(module.exports, "space", function () { return $caf1a49659ab2a3a$export$a941ed4b947d12f8; }, function (v) { return $caf1a49659ab2a3a$export$a941ed4b947d12f8 = v; });
$parcel$export(module.exports, "greaterThan", function () { return $caf1a49659ab2a3a$export$f517ea36c68d4644; }, function (v) { return $caf1a49659ab2a3a$export$f517ea36c68d4644 = v; });
$parcel$export(module.exports, "pipe", function () { return $caf1a49659ab2a3a$export$a4627e546088548d; }, function (v) { return $caf1a49659ab2a3a$export$a4627e546088548d = v; });
$parcel$export(module.exports, "equals", function () { return $caf1a49659ab2a3a$export$e9bab7fafb253603; }, function (v) { return $caf1a49659ab2a3a$export$e9bab7fafb253603 = v; });
$parcel$export(module.exports, "plus", function () { return $caf1a49659ab2a3a$export$f25d54de1f4102d2; }, function (v) { return $caf1a49659ab2a3a$export$f25d54de1f4102d2 = v; });
$parcel$export(module.exports, "caret", function () { return $caf1a49659ab2a3a$export$e88cb2efb12ae807; }, function (v) { return $caf1a49659ab2a3a$export$e88cb2efb12ae807 = v; });
$parcel$export(module.exports, "tilde", function () { return $caf1a49659ab2a3a$export$a611fa4b0fba35ad; }, function (v) { return $caf1a49659ab2a3a$export$a611fa4b0fba35ad = v; });
$parcel$export(module.exports, "dollar", function () { return $caf1a49659ab2a3a$export$8fe35dc8637e3206; }, function (v) { return $caf1a49659ab2a3a$export$8fe35dc8637e3206 = v; });
$parcel$export(module.exports, "closeSquare", function () { return $caf1a49659ab2a3a$export$7b6078f56cfde01c; }, function (v) { return $caf1a49659ab2a3a$export$7b6078f56cfde01c = v; });
$parcel$export(module.exports, "openSquare", function () { return $caf1a49659ab2a3a$export$9ddc23fa6328dffe; }, function (v) { return $caf1a49659ab2a3a$export$9ddc23fa6328dffe = v; });
$parcel$export(module.exports, "closeParenthesis", function () { return $caf1a49659ab2a3a$export$aa2a86779c63174c; }, function (v) { return $caf1a49659ab2a3a$export$aa2a86779c63174c = v; });
$parcel$export(module.exports, "openParenthesis", function () { return $caf1a49659ab2a3a$export$c9fe493072ea3774; }, function (v) { return $caf1a49659ab2a3a$export$c9fe493072ea3774 = v; });
$parcel$export(module.exports, "semicolon", function () { return $caf1a49659ab2a3a$export$62fa27d385e555f3; }, function (v) { return $caf1a49659ab2a3a$export$62fa27d385e555f3 = v; });
$parcel$export(module.exports, "colon", function () { return $caf1a49659ab2a3a$export$3f956a517cb1b4c7; }, function (v) { return $caf1a49659ab2a3a$export$3f956a517cb1b4c7 = v; });
$parcel$export(module.exports, "comma", function () { return $caf1a49659ab2a3a$export$55e60fd3fa53db0b; }, function (v) { return $caf1a49659ab2a3a$export$55e60fd3fa53db0b = v; });
$parcel$export(module.exports, "at", function () { return $caf1a49659ab2a3a$export$493d36ec626b6698; }, function (v) { return $caf1a49659ab2a3a$export$493d36ec626b6698 = v; });
$parcel$export(module.exports, "asterisk", function () { return $caf1a49659ab2a3a$export$c0ec2bc372804b43; }, function (v) { return $caf1a49659ab2a3a$export$c0ec2bc372804b43 = v; });
$parcel$export(module.exports, "ampersand", function () { return $caf1a49659ab2a3a$export$1014e5a0857b6a20; }, function (v) { return $caf1a49659ab2a3a$export$1014e5a0857b6a20 = v; });
var $caf1a49659ab2a3a$export$1e511d4a378977f5;
var $caf1a49659ab2a3a$export$bc8905068a6d4174;
var $caf1a49659ab2a3a$export$ac351257249182a8;
var $caf1a49659ab2a3a$export$4a34f930e789283c;
var $caf1a49659ab2a3a$export$42d51816ce590c93;
var $caf1a49659ab2a3a$export$62d58b1c91e8e902;
var $caf1a49659ab2a3a$export$2ddee7401a648d43;
var $caf1a49659ab2a3a$export$93d5e4db1316498e;
var $caf1a49659ab2a3a$export$cbfbec548517f2b6;
var $caf1a49659ab2a3a$export$799abffcbb2717d6;
var $caf1a49659ab2a3a$export$87bdb54b7ea1f8e2;
var $caf1a49659ab2a3a$export$6882e7e72b50612e;
var $caf1a49659ab2a3a$export$730a07918a7a7d93;
var $caf1a49659ab2a3a$export$1909b7b8a28995a9;
var $caf1a49659ab2a3a$export$a941ed4b947d12f8;
var $caf1a49659ab2a3a$export$f517ea36c68d4644;
var $caf1a49659ab2a3a$export$a4627e546088548d;
var $caf1a49659ab2a3a$export$e9bab7fafb253603;
var $caf1a49659ab2a3a$export$f25d54de1f4102d2;
var $caf1a49659ab2a3a$export$e88cb2efb12ae807;
var $caf1a49659ab2a3a$export$a611fa4b0fba35ad;
var $caf1a49659ab2a3a$export$8fe35dc8637e3206;
var $caf1a49659ab2a3a$export$7b6078f56cfde01c;
var $caf1a49659ab2a3a$export$9ddc23fa6328dffe;
var $caf1a49659ab2a3a$export$aa2a86779c63174c;
var $caf1a49659ab2a3a$export$c9fe493072ea3774;
var $caf1a49659ab2a3a$export$62fa27d385e555f3;
var $caf1a49659ab2a3a$export$3f956a517cb1b4c7;
var $caf1a49659ab2a3a$export$55e60fd3fa53db0b;
var $caf1a49659ab2a3a$export$493d36ec626b6698;
var $caf1a49659ab2a3a$export$c0ec2bc372804b43;
var $caf1a49659ab2a3a$export$1014e5a0857b6a20;
"use strict";
$caf1a49659ab2a3a$export$1e511d4a378977f5 = true;
$caf1a49659ab2a3a$export$bc8905068a6d4174 = $caf1a49659ab2a3a$export$ac351257249182a8 = $caf1a49659ab2a3a$export$4a34f930e789283c = $caf1a49659ab2a3a$export$42d51816ce590c93 = $caf1a49659ab2a3a$export$62d58b1c91e8e902 = $caf1a49659ab2a3a$export$2ddee7401a648d43 = $caf1a49659ab2a3a$export$93d5e4db1316498e = $caf1a49659ab2a3a$export$cbfbec548517f2b6 = $caf1a49659ab2a3a$export$799abffcbb2717d6 = $caf1a49659ab2a3a$export$87bdb54b7ea1f8e2 = $caf1a49659ab2a3a$export$6882e7e72b50612e = $caf1a49659ab2a3a$export$730a07918a7a7d93 = $caf1a49659ab2a3a$export$1909b7b8a28995a9 = $caf1a49659ab2a3a$export$a941ed4b947d12f8 = $caf1a49659ab2a3a$export$f517ea36c68d4644 = $caf1a49659ab2a3a$export$a4627e546088548d = $caf1a49659ab2a3a$export$e9bab7fafb253603 = $caf1a49659ab2a3a$export$f25d54de1f4102d2 = $caf1a49659ab2a3a$export$e88cb2efb12ae807 = $caf1a49659ab2a3a$export$a611fa4b0fba35ad = $caf1a49659ab2a3a$export$8fe35dc8637e3206 = $caf1a49659ab2a3a$export$7b6078f56cfde01c = $caf1a49659ab2a3a$export$9ddc23fa6328dffe = $caf1a49659ab2a3a$export$aa2a86779c63174c = $caf1a49659ab2a3a$export$c9fe493072ea3774 = $caf1a49659ab2a3a$export$62fa27d385e555f3 = $caf1a49659ab2a3a$export$3f956a517cb1b4c7 = $caf1a49659ab2a3a$export$55e60fd3fa53db0b = $caf1a49659ab2a3a$export$493d36ec626b6698 = $caf1a49659ab2a3a$export$c0ec2bc372804b43 = $caf1a49659ab2a3a$export$1014e5a0857b6a20 = void 0;
var $caf1a49659ab2a3a$var$ampersand = 38; // `&`.charCodeAt(0);
$caf1a49659ab2a3a$export$1014e5a0857b6a20 = $caf1a49659ab2a3a$var$ampersand;
var $caf1a49659ab2a3a$var$asterisk = 42; // `*`.charCodeAt(0);
$caf1a49659ab2a3a$export$c0ec2bc372804b43 = $caf1a49659ab2a3a$var$asterisk;
var $caf1a49659ab2a3a$var$at = 64; // `@`.charCodeAt(0);
$caf1a49659ab2a3a$export$493d36ec626b6698 = $caf1a49659ab2a3a$var$at;
var $caf1a49659ab2a3a$var$comma = 44; // `,`.charCodeAt(0);
$caf1a49659ab2a3a$export$55e60fd3fa53db0b = $caf1a49659ab2a3a$var$comma;
var $caf1a49659ab2a3a$var$colon = 58; // `:`.charCodeAt(0);
$caf1a49659ab2a3a$export$3f956a517cb1b4c7 = $caf1a49659ab2a3a$var$colon;
var $caf1a49659ab2a3a$var$semicolon = 59; // `;`.charCodeAt(0);
$caf1a49659ab2a3a$export$62fa27d385e555f3 = $caf1a49659ab2a3a$var$semicolon;
var $caf1a49659ab2a3a$var$openParenthesis = 40; // `(`.charCodeAt(0);
$caf1a49659ab2a3a$export$c9fe493072ea3774 = $caf1a49659ab2a3a$var$openParenthesis;
var $caf1a49659ab2a3a$var$closeParenthesis = 41; // `)`.charCodeAt(0);
$caf1a49659ab2a3a$export$aa2a86779c63174c = $caf1a49659ab2a3a$var$closeParenthesis;
var $caf1a49659ab2a3a$var$openSquare = 91; // `[`.charCodeAt(0);
$caf1a49659ab2a3a$export$9ddc23fa6328dffe = $caf1a49659ab2a3a$var$openSquare;
var $caf1a49659ab2a3a$var$closeSquare = 93; // `]`.charCodeAt(0);
$caf1a49659ab2a3a$export$7b6078f56cfde01c = $caf1a49659ab2a3a$var$closeSquare;
var $caf1a49659ab2a3a$var$dollar = 36; // `$`.charCodeAt(0);
$caf1a49659ab2a3a$export$8fe35dc8637e3206 = $caf1a49659ab2a3a$var$dollar;
var $caf1a49659ab2a3a$var$tilde = 126; // `~`.charCodeAt(0);
$caf1a49659ab2a3a$export$a611fa4b0fba35ad = $caf1a49659ab2a3a$var$tilde;
var $caf1a49659ab2a3a$var$caret = 94; // `^`.charCodeAt(0);
$caf1a49659ab2a3a$export$e88cb2efb12ae807 = $caf1a49659ab2a3a$var$caret;
var $caf1a49659ab2a3a$var$plus = 43; // `+`.charCodeAt(0);
$caf1a49659ab2a3a$export$f25d54de1f4102d2 = $caf1a49659ab2a3a$var$plus;
var $caf1a49659ab2a3a$var$equals = 61; // `=`.charCodeAt(0);
$caf1a49659ab2a3a$export$e9bab7fafb253603 = $caf1a49659ab2a3a$var$equals;
var $caf1a49659ab2a3a$var$pipe = 124; // `|`.charCodeAt(0);
$caf1a49659ab2a3a$export$a4627e546088548d = $caf1a49659ab2a3a$var$pipe;
var $caf1a49659ab2a3a$var$greaterThan = 62; // `>`.charCodeAt(0);
$caf1a49659ab2a3a$export$f517ea36c68d4644 = $caf1a49659ab2a3a$var$greaterThan;
var $caf1a49659ab2a3a$var$space = 32; // ` `.charCodeAt(0);
$caf1a49659ab2a3a$export$a941ed4b947d12f8 = $caf1a49659ab2a3a$var$space;
var $caf1a49659ab2a3a$var$singleQuote = 39; // `'`.charCodeAt(0);
$caf1a49659ab2a3a$export$1909b7b8a28995a9 = $caf1a49659ab2a3a$var$singleQuote;
var $caf1a49659ab2a3a$var$doubleQuote = 34; // `"`.charCodeAt(0);
$caf1a49659ab2a3a$export$730a07918a7a7d93 = $caf1a49659ab2a3a$var$doubleQuote;
var $caf1a49659ab2a3a$var$slash = 47; // `/`.charCodeAt(0);
$caf1a49659ab2a3a$export$6882e7e72b50612e = $caf1a49659ab2a3a$var$slash;
var $caf1a49659ab2a3a$var$bang = 33; // `!`.charCodeAt(0);
$caf1a49659ab2a3a$export$87bdb54b7ea1f8e2 = $caf1a49659ab2a3a$var$bang;
var $caf1a49659ab2a3a$var$backslash = 92; // '\\'.charCodeAt(0);
$caf1a49659ab2a3a$export$799abffcbb2717d6 = $caf1a49659ab2a3a$var$backslash;
var $caf1a49659ab2a3a$var$cr = 13; // '\r'.charCodeAt(0);
$caf1a49659ab2a3a$export$cbfbec548517f2b6 = $caf1a49659ab2a3a$var$cr;
var $caf1a49659ab2a3a$var$feed = 12; // '\f'.charCodeAt(0);
$caf1a49659ab2a3a$export$93d5e4db1316498e = $caf1a49659ab2a3a$var$feed;
var $caf1a49659ab2a3a$var$newline = 10; // '\n'.charCodeAt(0);
$caf1a49659ab2a3a$export$2ddee7401a648d43 = $caf1a49659ab2a3a$var$newline;
var $caf1a49659ab2a3a$var$tab = 9; // '\t'.charCodeAt(0);
// Expose aliases primarily for readability.
$caf1a49659ab2a3a$export$62d58b1c91e8e902 = $caf1a49659ab2a3a$var$tab;
var $caf1a49659ab2a3a$var$str = $caf1a49659ab2a3a$var$singleQuote; // No good single character representation!
$caf1a49659ab2a3a$export$42d51816ce590c93 = $caf1a49659ab2a3a$var$str;
var $caf1a49659ab2a3a$var$comment = -1;
$caf1a49659ab2a3a$export$4a34f930e789283c = $caf1a49659ab2a3a$var$comment;
var $caf1a49659ab2a3a$var$word = -2;
$caf1a49659ab2a3a$export$ac351257249182a8 = $caf1a49659ab2a3a$var$word;
var $caf1a49659ab2a3a$var$combinator = -3;
$caf1a49659ab2a3a$export$bc8905068a6d4174 = $caf1a49659ab2a3a$var$combinator;

});




parcelRegister("k8vqG", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7rSK2 = parcelRequire("7rSK2");
Object.keys($7rSK2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7rSK2[key]) return;
    module.exports[key] = $7rSK2[key];
});

var $hIU6s = parcelRequire("hIU6s");
Object.keys($hIU6s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hIU6s[key]) return;
    module.exports[key] = $hIU6s[key];
});

var $jC9AW = parcelRequire("jC9AW");
Object.keys($jC9AW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jC9AW[key]) return;
    module.exports[key] = $jC9AW[key];
});

});
parcelRegister("hIU6s", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $ce7210a24eb453ff$export$1e511d4a378977f5; }, function (v) { return $ce7210a24eb453ff$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "universal", function () { return $ce7210a24eb453ff$export$253a18498b608cc0; }, function (v) { return $ce7210a24eb453ff$export$253a18498b608cc0 = v; });
$parcel$export(module.exports, "tag", function () { return $ce7210a24eb453ff$export$2b067c6666111485; }, function (v) { return $ce7210a24eb453ff$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "string", function () { return $ce7210a24eb453ff$export$22b082955e083ec3; }, function (v) { return $ce7210a24eb453ff$export$22b082955e083ec3 = v; });
$parcel$export(module.exports, "selector", function () { return $ce7210a24eb453ff$export$aea217a45095ce11; }, function (v) { return $ce7210a24eb453ff$export$aea217a45095ce11 = v; });
$parcel$export(module.exports, "root", function () { return $ce7210a24eb453ff$export$e8e78c978b129247; }, function (v) { return $ce7210a24eb453ff$export$e8e78c978b129247 = v; });
$parcel$export(module.exports, "pseudo", function () { return $ce7210a24eb453ff$export$4a40d01fa098dd92; }, function (v) { return $ce7210a24eb453ff$export$4a40d01fa098dd92 = v; });
$parcel$export(module.exports, "nesting", function () { return $ce7210a24eb453ff$export$3c4951fc6df31dde; }, function (v) { return $ce7210a24eb453ff$export$3c4951fc6df31dde = v; });
$parcel$export(module.exports, "id", function () { return $ce7210a24eb453ff$export$d560c7e4a29451c2; }, function (v) { return $ce7210a24eb453ff$export$d560c7e4a29451c2 = v; });
$parcel$export(module.exports, "comment", function () { return $ce7210a24eb453ff$export$4a34f930e789283c; }, function (v) { return $ce7210a24eb453ff$export$4a34f930e789283c = v; });
$parcel$export(module.exports, "combinator", function () { return $ce7210a24eb453ff$export$bc8905068a6d4174; }, function (v) { return $ce7210a24eb453ff$export$bc8905068a6d4174 = v; });
$parcel$export(module.exports, "className", function () { return $ce7210a24eb453ff$export$2913c0c0b5623090; }, function (v) { return $ce7210a24eb453ff$export$2913c0c0b5623090 = v; });
$parcel$export(module.exports, "attribute", function () { return $ce7210a24eb453ff$export$af4b9a83f4b00434; }, function (v) { return $ce7210a24eb453ff$export$af4b9a83f4b00434 = v; });
var $ce7210a24eb453ff$export$1e511d4a378977f5;
var $ce7210a24eb453ff$export$253a18498b608cc0;
var $ce7210a24eb453ff$export$2b067c6666111485;
var $ce7210a24eb453ff$export$22b082955e083ec3;
var $ce7210a24eb453ff$export$aea217a45095ce11;
var $ce7210a24eb453ff$export$e8e78c978b129247;
var $ce7210a24eb453ff$export$4a40d01fa098dd92;
var $ce7210a24eb453ff$export$3c4951fc6df31dde;
var $ce7210a24eb453ff$export$d560c7e4a29451c2;
var $ce7210a24eb453ff$export$4a34f930e789283c;
var $ce7210a24eb453ff$export$bc8905068a6d4174;
var $ce7210a24eb453ff$export$2913c0c0b5623090;
var $ce7210a24eb453ff$export$af4b9a83f4b00434;
"use strict";
$ce7210a24eb453ff$export$1e511d4a378977f5 = true;
$ce7210a24eb453ff$export$253a18498b608cc0 = $ce7210a24eb453ff$export$2b067c6666111485 = $ce7210a24eb453ff$export$22b082955e083ec3 = $ce7210a24eb453ff$export$aea217a45095ce11 = $ce7210a24eb453ff$export$e8e78c978b129247 = $ce7210a24eb453ff$export$4a40d01fa098dd92 = $ce7210a24eb453ff$export$3c4951fc6df31dde = $ce7210a24eb453ff$export$d560c7e4a29451c2 = $ce7210a24eb453ff$export$4a34f930e789283c = $ce7210a24eb453ff$export$bc8905068a6d4174 = $ce7210a24eb453ff$export$2913c0c0b5623090 = $ce7210a24eb453ff$export$af4b9a83f4b00434 = void 0;

var $ce7210a24eb453ff$var$_attribute = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("7IfkN")));

var $ce7210a24eb453ff$var$_className = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("kp4zM")));

var $ce7210a24eb453ff$var$_combinator = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("1WlCQ")));

var $ce7210a24eb453ff$var$_comment = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("kPEv5")));

var $ce7210a24eb453ff$var$_id = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("hAgLj")));

var $ce7210a24eb453ff$var$_nesting = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("i0cQl")));

var $ce7210a24eb453ff$var$_pseudo = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("aJZwf")));

var $ce7210a24eb453ff$var$_root = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("7gl1Z")));

var $ce7210a24eb453ff$var$_selector = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("dRMm5")));

var $ce7210a24eb453ff$var$_string = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("gCW3v")));

var $ce7210a24eb453ff$var$_tag = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("eBASB")));

var $ce7210a24eb453ff$var$_universal = $ce7210a24eb453ff$var$_interopRequireDefault((parcelRequire("6Wm91")));
function $ce7210a24eb453ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $ce7210a24eb453ff$var$attribute = function attribute(opts) {
    return new $ce7210a24eb453ff$var$_attribute["default"](opts);
};
$ce7210a24eb453ff$export$af4b9a83f4b00434 = $ce7210a24eb453ff$var$attribute;
var $ce7210a24eb453ff$var$className = function className(opts) {
    return new $ce7210a24eb453ff$var$_className["default"](opts);
};
$ce7210a24eb453ff$export$2913c0c0b5623090 = $ce7210a24eb453ff$var$className;
var $ce7210a24eb453ff$var$combinator = function combinator(opts) {
    return new $ce7210a24eb453ff$var$_combinator["default"](opts);
};
$ce7210a24eb453ff$export$bc8905068a6d4174 = $ce7210a24eb453ff$var$combinator;
var $ce7210a24eb453ff$var$comment = function comment(opts) {
    return new $ce7210a24eb453ff$var$_comment["default"](opts);
};
$ce7210a24eb453ff$export$4a34f930e789283c = $ce7210a24eb453ff$var$comment;
var $ce7210a24eb453ff$var$id = function id(opts) {
    return new $ce7210a24eb453ff$var$_id["default"](opts);
};
$ce7210a24eb453ff$export$d560c7e4a29451c2 = $ce7210a24eb453ff$var$id;
var $ce7210a24eb453ff$var$nesting = function nesting(opts) {
    return new $ce7210a24eb453ff$var$_nesting["default"](opts);
};
$ce7210a24eb453ff$export$3c4951fc6df31dde = $ce7210a24eb453ff$var$nesting;
var $ce7210a24eb453ff$var$pseudo = function pseudo(opts) {
    return new $ce7210a24eb453ff$var$_pseudo["default"](opts);
};
$ce7210a24eb453ff$export$4a40d01fa098dd92 = $ce7210a24eb453ff$var$pseudo;
var $ce7210a24eb453ff$var$root = function root(opts) {
    return new $ce7210a24eb453ff$var$_root["default"](opts);
};
$ce7210a24eb453ff$export$e8e78c978b129247 = $ce7210a24eb453ff$var$root;
var $ce7210a24eb453ff$var$selector = function selector(opts) {
    return new $ce7210a24eb453ff$var$_selector["default"](opts);
};
$ce7210a24eb453ff$export$aea217a45095ce11 = $ce7210a24eb453ff$var$selector;
var $ce7210a24eb453ff$var$string = function string(opts) {
    return new $ce7210a24eb453ff$var$_string["default"](opts);
};
$ce7210a24eb453ff$export$22b082955e083ec3 = $ce7210a24eb453ff$var$string;
var $ce7210a24eb453ff$var$tag = function tag(opts) {
    return new $ce7210a24eb453ff$var$_tag["default"](opts);
};
$ce7210a24eb453ff$export$2b067c6666111485 = $ce7210a24eb453ff$var$tag;
var $ce7210a24eb453ff$var$universal = function universal(opts) {
    return new $ce7210a24eb453ff$var$_universal["default"](opts);
};
$ce7210a24eb453ff$export$253a18498b608cc0 = $ce7210a24eb453ff$var$universal;

});

parcelRegister("jC9AW", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $e4790240257e2087$export$1e511d4a378977f5; }, function (v) { return $e4790240257e2087$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "isNode", function () { return $e4790240257e2087$export$8ee0fc9ee280b4ee; }, function (v) { return $e4790240257e2087$export$8ee0fc9ee280b4ee = v; });
$parcel$export(module.exports, "isPseudoElement", function () { return $e4790240257e2087$export$50c377054049744f; }, function (v) { return $e4790240257e2087$export$50c377054049744f = v; });
$parcel$export(module.exports, "isPseudoClass", function () { return $e4790240257e2087$export$4f9a537d87bfe39; }, function (v) { return $e4790240257e2087$export$4f9a537d87bfe39 = v; });
$parcel$export(module.exports, "isContainer", function () { return $e4790240257e2087$export$16f58a42b9d38aa; }, function (v) { return $e4790240257e2087$export$16f58a42b9d38aa = v; });
$parcel$export(module.exports, "isNamespace", function () { return $e4790240257e2087$export$f7be8ad7c940f0dc; }, function (v) { return $e4790240257e2087$export$f7be8ad7c940f0dc = v; });
$parcel$export(module.exports, "isUniversal", function () { return $e4790240257e2087$export$c7e5a35eb76305e; }, function (v) { return $e4790240257e2087$export$c7e5a35eb76305e = v; });
$parcel$export(module.exports, "isTag", function () { return $e4790240257e2087$export$3bf645f08efe3292; }, function (v) { return $e4790240257e2087$export$3bf645f08efe3292 = v; });
$parcel$export(module.exports, "isString", function () { return $e4790240257e2087$export$844ec244b1367d54; }, function (v) { return $e4790240257e2087$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSelector", function () { return $e4790240257e2087$export$faef9c3580d96b22; }, function (v) { return $e4790240257e2087$export$faef9c3580d96b22 = v; });
$parcel$export(module.exports, "isRoot", function () { return $e4790240257e2087$export$e3140dc7d0c35e48; }, function (v) { return $e4790240257e2087$export$e3140dc7d0c35e48 = v; });
$parcel$export(module.exports, "isPseudo", function () { return $e4790240257e2087$export$128e5790e44a4eef; }, function (v) { return $e4790240257e2087$export$128e5790e44a4eef = v; });
$parcel$export(module.exports, "isNesting", function () { return $e4790240257e2087$export$c0384a4fd85c6979; }, function (v) { return $e4790240257e2087$export$c0384a4fd85c6979 = v; });
$parcel$export(module.exports, "isIdentifier", function () { return $e4790240257e2087$export$8ce3792bf42f8358; }, function (v) { return $e4790240257e2087$export$8ce3792bf42f8358 = v; });
$parcel$export(module.exports, "isComment", function () { return $e4790240257e2087$export$3ab01370f5e64ac8; }, function (v) { return $e4790240257e2087$export$3ab01370f5e64ac8 = v; });
$parcel$export(module.exports, "isCombinator", function () { return $e4790240257e2087$export$d16bf37c1d7d3358; }, function (v) { return $e4790240257e2087$export$d16bf37c1d7d3358 = v; });
$parcel$export(module.exports, "isClassName", function () { return $e4790240257e2087$export$d53f3db2f43345df; }, function (v) { return $e4790240257e2087$export$d53f3db2f43345df = v; });
$parcel$export(module.exports, "isAttribute", function () { return $e4790240257e2087$export$7500d9bbb9458138; }, function (v) { return $e4790240257e2087$export$7500d9bbb9458138 = v; });
var $e4790240257e2087$export$1e511d4a378977f5;
var $e4790240257e2087$export$8ee0fc9ee280b4ee;
var $e4790240257e2087$export$50c377054049744f;
var $e4790240257e2087$export$4f9a537d87bfe39;
var $e4790240257e2087$export$16f58a42b9d38aa;
var $e4790240257e2087$export$f7be8ad7c940f0dc;
var $e4790240257e2087$export$c7e5a35eb76305e;
var $e4790240257e2087$export$3bf645f08efe3292;
var $e4790240257e2087$export$844ec244b1367d54;
var $e4790240257e2087$export$faef9c3580d96b22;
var $e4790240257e2087$export$e3140dc7d0c35e48;
var $e4790240257e2087$export$128e5790e44a4eef;
var $e4790240257e2087$export$c0384a4fd85c6979;
var $e4790240257e2087$export$8ce3792bf42f8358;
var $e4790240257e2087$export$3ab01370f5e64ac8;
var $e4790240257e2087$export$d16bf37c1d7d3358;
var $e4790240257e2087$export$d53f3db2f43345df;
var $e4790240257e2087$export$7500d9bbb9458138;
"use strict";
$e4790240257e2087$export$1e511d4a378977f5 = true;
$e4790240257e2087$export$8ee0fc9ee280b4ee = $e4790240257e2087$var$isNode;
$e4790240257e2087$export$50c377054049744f = $e4790240257e2087$var$isPseudoElement;
$e4790240257e2087$export$4f9a537d87bfe39 = $e4790240257e2087$var$isPseudoClass;
$e4790240257e2087$export$16f58a42b9d38aa = $e4790240257e2087$var$isContainer;
$e4790240257e2087$export$f7be8ad7c940f0dc = $e4790240257e2087$var$isNamespace;
$e4790240257e2087$export$c7e5a35eb76305e = $e4790240257e2087$export$3bf645f08efe3292 = $e4790240257e2087$export$844ec244b1367d54 = $e4790240257e2087$export$faef9c3580d96b22 = $e4790240257e2087$export$e3140dc7d0c35e48 = $e4790240257e2087$export$128e5790e44a4eef = $e4790240257e2087$export$c0384a4fd85c6979 = $e4790240257e2087$export$8ce3792bf42f8358 = $e4790240257e2087$export$3ab01370f5e64ac8 = $e4790240257e2087$export$d16bf37c1d7d3358 = $e4790240257e2087$export$d53f3db2f43345df = $e4790240257e2087$export$7500d9bbb9458138 = void 0;

var $7rSK2 = parcelRequire("7rSK2");
var $e4790240257e2087$var$_IS_TYPE;
var $e4790240257e2087$var$IS_TYPE = ($e4790240257e2087$var$_IS_TYPE = {}, $e4790240257e2087$var$_IS_TYPE[$7rSK2.ATTRIBUTE] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.CLASS] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.COMBINATOR] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.COMMENT] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.ID] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.NESTING] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.PSEUDO] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.ROOT] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.SELECTOR] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.STRING] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.TAG] = true, $e4790240257e2087$var$_IS_TYPE[$7rSK2.UNIVERSAL] = true, $e4790240257e2087$var$_IS_TYPE);
function $e4790240257e2087$var$isNode(node) {
    return typeof node === "object" && $e4790240257e2087$var$IS_TYPE[node.type];
}
function $e4790240257e2087$var$isNodeType(type, node) {
    return $e4790240257e2087$var$isNode(node) && node.type === type;
}
var $e4790240257e2087$var$isAttribute = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.ATTRIBUTE);
$e4790240257e2087$export$7500d9bbb9458138 = $e4790240257e2087$var$isAttribute;
var $e4790240257e2087$var$isClassName = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.CLASS);
$e4790240257e2087$export$d53f3db2f43345df = $e4790240257e2087$var$isClassName;
var $e4790240257e2087$var$isCombinator = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.COMBINATOR);
$e4790240257e2087$export$d16bf37c1d7d3358 = $e4790240257e2087$var$isCombinator;
var $e4790240257e2087$var$isComment = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.COMMENT);
$e4790240257e2087$export$3ab01370f5e64ac8 = $e4790240257e2087$var$isComment;
var $e4790240257e2087$var$isIdentifier = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.ID);
$e4790240257e2087$export$8ce3792bf42f8358 = $e4790240257e2087$var$isIdentifier;
var $e4790240257e2087$var$isNesting = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.NESTING);
$e4790240257e2087$export$c0384a4fd85c6979 = $e4790240257e2087$var$isNesting;
var $e4790240257e2087$var$isPseudo = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.PSEUDO);
$e4790240257e2087$export$128e5790e44a4eef = $e4790240257e2087$var$isPseudo;
var $e4790240257e2087$var$isRoot = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.ROOT);
$e4790240257e2087$export$e3140dc7d0c35e48 = $e4790240257e2087$var$isRoot;
var $e4790240257e2087$var$isSelector = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.SELECTOR);
$e4790240257e2087$export$faef9c3580d96b22 = $e4790240257e2087$var$isSelector;
var $e4790240257e2087$var$isString = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.STRING);
$e4790240257e2087$export$844ec244b1367d54 = $e4790240257e2087$var$isString;
var $e4790240257e2087$var$isTag = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.TAG);
$e4790240257e2087$export$3bf645f08efe3292 = $e4790240257e2087$var$isTag;
var $e4790240257e2087$var$isUniversal = $e4790240257e2087$var$isNodeType.bind(null, $7rSK2.UNIVERSAL);
$e4790240257e2087$export$c7e5a35eb76305e = $e4790240257e2087$var$isUniversal;
function $e4790240257e2087$var$isPseudoElement(node) {
    return $e4790240257e2087$var$isPseudo(node) && node.value && (node.value.startsWith("::") || node.value.toLowerCase() === ":before" || node.value.toLowerCase() === ":after" || node.value.toLowerCase() === ":first-letter" || node.value.toLowerCase() === ":first-line");
}
function $e4790240257e2087$var$isPseudoClass(node) {
    return $e4790240257e2087$var$isPseudo(node) && !$e4790240257e2087$var$isPseudoElement(node);
}
function $e4790240257e2087$var$isContainer(node) {
    return !!($e4790240257e2087$var$isNode(node) && node.walk);
}
function $e4790240257e2087$var$isNamespace(node) {
    return $e4790240257e2087$var$isAttribute(node) || $e4790240257e2087$var$isTag(node);
}

});





parcelRegister("aT86D", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7ed554200cafbef0$var$ReactIs, $7ed554200cafbef0$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("ewWP8"))();

});


var $ge3KO = parcelRequire("ge3KO");
var $dda2239619d6df9c$export$882461b6382ed46c;
var $dda2239619d6df9c$export$757ceba2d55c277e;
"use strict";
var $5021361ff788fb77$exports = {};
"use strict";
function $5021361ff788fb77$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($5021361ff788fb77$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$5021361ff788fb77$var$checkDCE();

$5021361ff788fb77$exports = (parcelRequire("f915p"));


var $dda2239619d6df9c$var$i;
$dda2239619d6df9c$export$882461b6382ed46c = $5021361ff788fb77$exports.createRoot;
$dda2239619d6df9c$export$757ceba2d55c277e = $5021361ff788fb77$exports.hydrateRoot;



var $ge3KO = parcelRequire("ge3KO");
/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $8e4ac05122853833$export$2e2bcd8739ae039 = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();


/**
 * @ignore - do not document.
 */ // Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
(0, $8e4ac05122853833$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ = (0, $8e4ac05122853833$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ || {
    key: undefined
};
class $8173e232d95b4d5b$export$2c56d2e2ae515eeb {
    static getLicenseInfo() {
        // eslint-disable-next-line no-underscore-dangle
        return (0, $8e4ac05122853833$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__;
    }
    static getLicenseKey() {
        return $8173e232d95b4d5b$export$2c56d2e2ae515eeb.getLicenseInfo().key;
    }
    static setLicenseKey(key) {
        const licenseInfo = $8173e232d95b4d5b$export$2c56d2e2ae515eeb.getLicenseInfo();
        licenseInfo.key = key;
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $866d0efb57a01972$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $444c9e424d20ca0b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $444c9e424d20ca0b$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $444c9e424d20ca0b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $444c9e424d20ca0b$var$isGlobalObj(window) || typeof self == "object" && $444c9e424d20ca0b$var$isGlobalObj(self) || typeof $parcel$global == "object" && $444c9e424d20ca0b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $444c9e424d20ca0b$export$256479dc0cea61c4() {
    return $444c9e424d20ca0b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $444c9e424d20ca0b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $444c9e424d20ca0b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $f380c6c63e13cddf$var$PREFIX = "Sentry Logger ";
const $f380c6c63e13cddf$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $f380c6c63e13cddf$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $f380c6c63e13cddf$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($f380c6c63e13cddf$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $f380c6c63e13cddf$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $f380c6c63e13cddf$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $866d0efb57a01972$export$16a28057038b10ef) $f380c6c63e13cddf$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $f380c6c63e13cddf$export$cda52e2a8927a2ca(()=>{
                (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).console[name](`${$f380c6c63e13cddf$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $f380c6c63e13cddf$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $f380c6c63e13cddf$export$af88d00dbe7f521 = $f380c6c63e13cddf$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f12abffb275f404d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $1c69755c87707ddf$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $1c69755c87707ddf$export$7740643b9eeaf0c4() {
    return Date.now() / $1c69755c87707ddf$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $1c69755c87707ddf$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $1c69755c87707ddf$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $1c69755c87707ddf$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $1c69755c87707ddf$export$ee52dced521e3e18 = $1c69755c87707ddf$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $1c69755c87707ddf$export$c5907b5a8838db13 = $1c69755c87707ddf$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $1c69755c87707ddf$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $1c69755c87707ddf$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $1c69755c87707ddf$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $1c69755c87707ddf$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $1c69755c87707ddf$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $1c69755c87707ddf$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $6eb20d3436b639ce$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$e6127cc7fe7395c3(wat) {
    switch($6eb20d3436b639ce$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $6eb20d3436b639ce$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$var$isBuiltin(wat, className) {
    return $6eb20d3436b639ce$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$9f9636d330b71954(wat) {
    return $6eb20d3436b639ce$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$ef9e2056653f0c8e(wat) {
    return $6eb20d3436b639ce$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$12e869b2a583f783(wat) {
    return $6eb20d3436b639ce$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$844ec244b1367d54(wat) {
    return $6eb20d3436b639ce$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$c3825b437cbdea5c(wat) {
    return wat === null || $6eb20d3436b639ce$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$53b83ca8eaab0383(wat) {
    return $6eb20d3436b639ce$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $6eb20d3436b639ce$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $6eb20d3436b639ce$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$49841c62b9eff15(wat) {
    return $6eb20d3436b639ce$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $6eb20d3436b639ce$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$bc2894c7158efbac(wat) {
    return $6eb20d3436b639ce$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6eb20d3436b639ce$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $cc2b0812a7e75fd4$var$WINDOW = (0, $444c9e424d20ca0b$export$256479dc0cea61c4)();
const $cc2b0812a7e75fd4$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cc2b0812a7e75fd4$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cc2b0812a7e75fd4$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cc2b0812a7e75fd4$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cc2b0812a7e75fd4$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($cc2b0812a7e75fd4$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $6eb20d3436b639ce$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $cc2b0812a7e75fd4$export$1cfafeee2987818b() {
    try {
        return $cc2b0812a7e75fd4$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cc2b0812a7e75fd4$export$c660c1f3ab49225c(selector) {
    if ($cc2b0812a7e75fd4$var$WINDOW.document && $cc2b0812a7e75fd4$var$WINDOW.document.querySelector) return $cc2b0812a7e75fd4$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cc2b0812a7e75fd4$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cc2b0812a7e75fd4$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $5ba26d97ad14420c$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $5ba26d97ad14420c$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5ba26d97ad14420c$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $6eb20d3436b639ce$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $5ba26d97ad14420c$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6eb20d3436b639ce$export$844ec244b1367d54)(value)) return false;
    if ((0, $6eb20d3436b639ce$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $6eb20d3436b639ce$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $5ba26d97ad14420c$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$5ba26d97ad14420c$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $971efa3a19c35af1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $971efa3a19c35af1$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $971efa3a19c35af1$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $866d0efb57a01972$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $971efa3a19c35af1$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $971efa3a19c35af1$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $971efa3a19c35af1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $971efa3a19c35af1$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $971efa3a19c35af1$export$62ff257738bf57f5(value) {
    if ((0, $6eb20d3436b639ce$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$971efa3a19c35af1$var$getOwnProperties(value)
    };
    else if ((0, $6eb20d3436b639ce$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $971efa3a19c35af1$var$serializeEventTarget(value.target),
            currentTarget: $971efa3a19c35af1$var$serializeEventTarget(value.currentTarget),
            ...$971efa3a19c35af1$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $6eb20d3436b639ce$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $971efa3a19c35af1$var$serializeEventTarget(target) {
    try {
        return (0, $6eb20d3436b639ce$export$45a5e7f76e0caa8d)(target) ? (0, $cc2b0812a7e75fd4$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $971efa3a19c35af1$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $971efa3a19c35af1$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($971efa3a19c35af1$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $5ba26d97ad14420c$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $5ba26d97ad14420c$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $971efa3a19c35af1$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $971efa3a19c35af1$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $971efa3a19c35af1$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($971efa3a19c35af1$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $971efa3a19c35af1$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($971efa3a19c35af1$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $971efa3a19c35af1$var$isPojo(input) {
    if (!(0, $6eb20d3436b639ce$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $971efa3a19c35af1$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6eb20d3436b639ce$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $585c5f81398b071f$export$19f53698e68b2496() {
    const gbl = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $585c5f81398b071f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $585c5f81398b071f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $585c5f81398b071f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $585c5f81398b071f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $585c5f81398b071f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $585c5f81398b071f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $585c5f81398b071f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $585c5f81398b071f$export$d364f2020ab30578(input) {
    const match = input.match($585c5f81398b071f$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $585c5f81398b071f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $5ba26d97ad14420c$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $5ba26d97ad14420c$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $5ba26d97ad14420c$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $585c5f81398b071f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $971efa3a19c35af1$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $585c5f81398b071f$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $5264f3533ff55e7a$export$849dbeeeda01ae98 = "production";





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $0c4a60aa51d054a5$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($0c4a60aa51d054a5$var$States || ($0c4a60aa51d054a5$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $0c4a60aa51d054a5$export$1fda8aa4d135f8aa(value) {
    return new $0c4a60aa51d054a5$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $0c4a60aa51d054a5$export$78e43115b553f358(reason) {
    return new $0c4a60aa51d054a5$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $0c4a60aa51d054a5$export$6f292d4960313241 {
    constructor(executor){
        $0c4a60aa51d054a5$export$6f292d4960313241.prototype.__init.call(this);
        $0c4a60aa51d054a5$export$6f292d4960313241.prototype.__init2.call(this);
        $0c4a60aa51d054a5$export$6f292d4960313241.prototype.__init3.call(this);
        $0c4a60aa51d054a5$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $0c4a60aa51d054a5$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $0c4a60aa51d054a5$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $0c4a60aa51d054a5$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($0c4a60aa51d054a5$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($0c4a60aa51d054a5$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $0c4a60aa51d054a5$var$States.PENDING) return;
            if ((0, $6eb20d3436b639ce$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $0c4a60aa51d054a5$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $0c4a60aa51d054a5$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $0c4a60aa51d054a5$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $d09d18b69e8facdc$export$3c4238858b85e8ac() {
    return (0, $444c9e424d20ca0b$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $d09d18b69e8facdc$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $d09d18b69e8facdc$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $d09d18b69e8facdc$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $0c4a60aa51d054a5$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $f12abffb275f404d$export$16a28057038b10ef) && processor.id && result === null && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $6eb20d3436b639ce$export$f5b060c2914b97c8)(result)) result.then((final)=>$d09d18b69e8facdc$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $d09d18b69e8facdc$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $0a85196b42ee4cba$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $1c69755c87707ddf$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $585c5f81398b071f$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$0a85196b42ee4cba$var$sessionToJSON(session)
    };
    if (context) $0a85196b42ee4cba$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $0a85196b42ee4cba$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $1c69755c87707ddf$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $585c5f81398b071f$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $0a85196b42ee4cba$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $0a85196b42ee4cba$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $0a85196b42ee4cba$var$sessionToJSON(session) {
    return (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $3eb3c7cf955d7641$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $24c1b78d34d63117$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $24c1b78d34d63117$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $24c1b78d34d63117$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $3922f028d1f0b5d7$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $3922f028d1f0b5d7$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $3922f028d1f0b5d7$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $3922f028d1f0b5d7$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $3922f028d1f0b5d7$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($3922f028d1f0b5d7$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $3922f028d1f0b5d7$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $3922f028d1f0b5d7$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $3922f028d1f0b5d7$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $3922f028d1f0b5d7$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $3922f028d1f0b5d7$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($3922f028d1f0b5d7$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($3922f028d1f0b5d7$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $3922f028d1f0b5d7$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $3922f028d1f0b5d7$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $3922f028d1f0b5d7$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $3922f028d1f0b5d7$var$defaultFunctionName;
        return fn.name || $3922f028d1f0b5d7$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $3922f028d1f0b5d7$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $3922f028d1f0b5d7$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $24c1b78d34d63117$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $945327a834d3a1ba$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $945327a834d3a1ba$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $945327a834d3a1ba$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $945327a834d3a1ba$export$a3295358bff77e(object, depth);
    if ($945327a834d3a1ba$var$jsonSize(normalized) > maxSize) return $945327a834d3a1ba$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $945327a834d3a1ba$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $3eb3c7cf955d7641$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $6eb20d3436b639ce$export$c9f5652083b8129d)(value)) return value;
    const stringified = $945327a834d3a1ba$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $945327a834d3a1ba$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $971efa3a19c35af1$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $945327a834d3a1ba$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $945327a834d3a1ba$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $6eb20d3436b639ce$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $6eb20d3436b639ce$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $3922f028d1f0b5d7$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $945327a834d3a1ba$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $945327a834d3a1ba$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $945327a834d3a1ba$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $945327a834d3a1ba$var$jsonSize(value) {
    return $945327a834d3a1ba$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $945327a834d3a1ba$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}









const $2756a0a7536a25ea$export$9ca9946bd449ac06 = "baggage";
const $2756a0a7536a25ea$export$6e69537d67fa20f = "sentry-";
const $2756a0a7536a25ea$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $2756a0a7536a25ea$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $2756a0a7536a25ea$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $6eb20d3436b639ce$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $2756a0a7536a25ea$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $2756a0a7536a25ea$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($2756a0a7536a25ea$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($2756a0a7536a25ea$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $2756a0a7536a25ea$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$2756a0a7536a25ea$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $2756a0a7536a25ea$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $2756a0a7536a25ea$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $2756a0a7536a25ea$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $2756a0a7536a25ea$export$bdd844ddb2def819) {
            (0, $866d0efb57a01972$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $4058f4d819de4cf1$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $4058f4d819de4cf1$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($4058f4d819de4cf1$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $4058f4d819de4cf1$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $4058f4d819de4cf1$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $2756a0a7536a25ea$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $585c5f81398b071f$export$19f53698e68b2496)(),
            spanId: (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $585c5f81398b071f$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16),
            spanId: (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $4058f4d819de4cf1$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $4058f4d819de4cf1$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $2756a0a7536a25ea$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $585c5f81398b071f$export$19f53698e68b2496)(),
        spanId: (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $585c5f81398b071f$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16),
        spanId: (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $4058f4d819de4cf1$export$f35d907436da45cf(traceId = (0, $585c5f81398b071f$export$19f53698e68b2496)(), spanId = (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $629ef6feba2990f3$export$208d5b368507fb8b = 0x0;
const $629ef6feba2990f3$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $629ef6feba2990f3$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $629ef6feba2990f3$export$92d8c23565496537(span);
    return (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $629ef6feba2990f3$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $629ef6feba2990f3$export$5caecac1caaf3a71(span);
    return (0, $4058f4d819de4cf1$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $629ef6feba2990f3$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $629ef6feba2990f3$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $629ef6feba2990f3$var$ensureTimestampInSeconds(input.getTime());
    return (0, $1c69755c87707ddf$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $629ef6feba2990f3$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $629ef6feba2990f3$export$92d8c23565496537(span) {
    if ($629ef6feba2990f3$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $629ef6feba2990f3$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $629ef6feba2990f3$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $629ef6feba2990f3$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $49924d6ecd0805c4$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $585c5f81398b071f$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $1c69755c87707ddf$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $49924d6ecd0805c4$var$applyClientOptions(prepared, options);
    $49924d6ecd0805c4$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $49924d6ecd0805c4$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $49924d6ecd0805c4$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $585c5f81398b071f$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $a7844b2ce8519311$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $0b72889724ed69e6$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $0b72889724ed69e6$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $0b72889724ed69e6$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $d09d18b69e8facdc$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $d09d18b69e8facdc$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $49924d6ecd0805c4$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $49924d6ecd0805c4$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $49924d6ecd0805c4$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $5264f3533ff55e7a$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $5ba26d97ad14420c$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $5ba26d97ad14420c$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $5ba26d97ad14420c$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $49924d6ecd0805c4$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $49924d6ecd0805c4$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $49924d6ecd0805c4$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $49924d6ecd0805c4$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $49924d6ecd0805c4$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $49924d6ecd0805c4$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $49924d6ecd0805c4$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $945327a834d3a1ba$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $945327a834d3a1ba$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $945327a834d3a1ba$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $945327a834d3a1ba$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $945327a834d3a1ba$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $629ef6feba2990f3$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $945327a834d3a1ba$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $49924d6ecd0805c4$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $a7844b2ce8519311$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $49924d6ecd0805c4$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($49924d6ecd0805c4$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($49924d6ecd0805c4$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $49924d6ecd0805c4$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $a7844b2ce8519311$export$775b6bb06e53a214) || typeof hint === "function";
}
const $49924d6ecd0805c4$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $49924d6ecd0805c4$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$49924d6ecd0805c4$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $ff70bab8e0f5d056$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().captureException(exception, (0, $49924d6ecd0805c4$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $ff70bab8e0f5d056$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $ff70bab8e0f5d056$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $ff70bab8e0f5d056$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $ff70bab8e0f5d056$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $ff70bab8e0f5d056$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $ff70bab8e0f5d056$export$9a4fed82c350c2bd(callback) {
    return (0, $6a55bc962b8f461d$export$70d775fb1f267027)(()=>{
        return callback((0, $6a55bc962b8f461d$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $ff70bab8e0f5d056$export$e57ac09b143d92a2(span, callback) {
    return $ff70bab8e0f5d056$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $ff70bab8e0f5d056$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $ff70bab8e0f5d056$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $ff70bab8e0f5d056$export$c7be4b0125a10cba();
    const client = $ff70bab8e0f5d056$export$6bb76d6eba7e258c();
    if (!client) (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $585c5f81398b071f$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $ff70bab8e0f5d056$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $ff70bab8e0f5d056$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $1c69755c87707ddf$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $ff70bab8e0f5d056$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $1c69755c87707ddf$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $6eb20d3436b639ce$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $ff70bab8e0f5d056$export$4909b86c8034bf73(timeout) {
    const client = $ff70bab8e0f5d056$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $ff70bab8e0f5d056$export$8360e631d277ea4d(timeout) {
    const client = $ff70bab8e0f5d056$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $ff70bab8e0f5d056$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $ff70bab8e0f5d056$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $ff70bab8e0f5d056$export$3f95c6f800b78024() {
    return !!$ff70bab8e0f5d056$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $ff70bab8e0f5d056$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $ff70bab8e0f5d056$export$c0d84948cecf78d8(context) {
    const client = $ff70bab8e0f5d056$export$6bb76d6eba7e258c();
    const isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)();
    const currentScope = $ff70bab8e0f5d056$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $5264f3533ff55e7a$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $0a85196b42ee4cba$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $0a85196b42ee4cba$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $ff70bab8e0f5d056$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $ff70bab8e0f5d056$export$17a5be43989a0bc1() {
    const isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)();
    const currentScope = $ff70bab8e0f5d056$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $0a85196b42ee4cba$export$56521d9ba90f62ee)(session);
    $ff70bab8e0f5d056$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $ff70bab8e0f5d056$var$_sendSessionUpdate() {
    const isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)();
    const currentScope = $ff70bab8e0f5d056$export$c7be4b0125a10cba();
    const client = $ff70bab8e0f5d056$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $ff70bab8e0f5d056$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $ff70bab8e0f5d056$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $ff70bab8e0f5d056$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $fbca0cda9bc299c1$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $30e8d42ca2ee98d9$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
        environment: options.environment || (0, $5264f3533ff55e7a$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $30e8d42ca2ee98d9$export$a117f995597e25df(span) {
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $30e8d42ca2ee98d9$export$366bad00d6815eed((0, $629ef6feba2990f3$export$92d8c23565496537)(span).trace_id || "", client, (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $fbca0cda9bc299c1$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $629ef6feba2990f3$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $629ef6feba2990f3$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $0b72889724ed69e6$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $0b72889724ed69e6$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $0b72889724ed69e6$var$applySpanToEvent(event, span);
    $0b72889724ed69e6$var$applyFingerprintToEvent(event, fingerprint);
    $0b72889724ed69e6$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $0b72889724ed69e6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $0b72889724ed69e6$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $0b72889724ed69e6$export$b1a120a2871faa46(data, "extra", extra);
    $0b72889724ed69e6$export$b1a120a2871faa46(data, "tags", tags);
    $0b72889724ed69e6$export$b1a120a2871faa46(data, "user", user);
    $0b72889724ed69e6$export$b1a120a2871faa46(data, "contexts", contexts);
    $0b72889724ed69e6$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $0b72889724ed69e6$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $0b72889724ed69e6$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $971efa3a19c35af1$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $971efa3a19c35af1$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $971efa3a19c35af1$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $971efa3a19c35af1$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $0b72889724ed69e6$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $0b72889724ed69e6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $0b72889724ed69e6$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $629ef6feba2990f3$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $fbca0cda9bc299c1$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $30e8d42ca2ee98d9$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $629ef6feba2990f3$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $0b72889724ed69e6$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $585c5f81398b071f$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $a7844b2ce8519311$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $a7844b2ce8519311$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $a7844b2ce8519311$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $a7844b2ce8519311$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $a7844b2ce8519311$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $a7844b2ce8519311$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $0a85196b42ee4cba$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $a7844b2ce8519311$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $6eb20d3436b639ce$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $a7844b2ce8519311$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $a7844b2ce8519311$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $1c69755c87707ddf$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $0b72889724ed69e6$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $d09d18b69e8facdc$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $d09d18b69e8facdc$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $585c5f81398b071f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $585c5f81398b071f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $585c5f81398b071f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $a7844b2ce8519311$export$aa55d5ab8e05984f() {
    if (!$a7844b2ce8519311$var$globalScope) $a7844b2ce8519311$var$globalScope = new $a7844b2ce8519311$export$775b6bb06e53a214();
    return $a7844b2ce8519311$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $a7844b2ce8519311$export$c83048efd17527d6(scope) {
    $a7844b2ce8519311$var$globalScope = scope;
}
function $a7844b2ce8519311$var$generatePropagationContext() {
    return {
        traceId: (0, $585c5f81398b071f$export$19f53698e68b2496)(),
        spanId: (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16)
    };
}



const $c6e8177700af97c3$export$31499a9cd224b78c = "7.113.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $6a55bc962b8f461d$export$24a86ef7798177e4 = parseFloat((0, $c6e8177700af97c3$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $6a55bc962b8f461d$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $6a55bc962b8f461d$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $6a55bc962b8f461d$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $a7844b2ce8519311$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $a7844b2ce8519311$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $6eb20d3436b639ce$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $585c5f81398b071f$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $585c5f81398b071f$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $585c5f81398b071f$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $6a55bc962b8f461d$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $1c69755c87707ddf$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $f380c6c63e13cddf$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $6a55bc962b8f461d$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $6a55bc962b8f461d$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $f12abffb275f404d$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $0a85196b42ee4cba$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $5264f3533ff55e7a$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $0a85196b42ee4cba$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $0a85196b42ee4cba$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $6a55bc962b8f461d$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $6a55bc962b8f461d$export$19eade501500c6c1() {
    (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $6a55bc962b8f461d$export$4188a14ad302d1bc(hub) {
    const registry = $6a55bc962b8f461d$export$19eade501500c6c1();
    const oldHub = $6a55bc962b8f461d$export$bfa8a924a84a76b7(registry);
    $6a55bc962b8f461d$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $6a55bc962b8f461d$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $6a55bc962b8f461d$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $6a55bc962b8f461d$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $6a55bc962b8f461d$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $6a55bc962b8f461d$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $6a55bc962b8f461d$var$getGlobalHub(registry = $6a55bc962b8f461d$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$6a55bc962b8f461d$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $6a55bc962b8f461d$export$bfa8a924a84a76b7(registry).isOlderThan($6a55bc962b8f461d$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $6a55bc962b8f461d$export$849f05434e95d2f2(registry, new $6a55bc962b8f461d$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $6a55bc962b8f461d$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $6a55bc962b8f461d$export$236689a79f5aa020(carrier, parent = $6a55bc962b8f461d$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$6a55bc962b8f461d$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $6a55bc962b8f461d$export$bfa8a924a84a76b7(carrier).isOlderThan($6a55bc962b8f461d$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $6a55bc962b8f461d$export$849f05434e95d2f2(carrier, new $6a55bc962b8f461d$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $6a55bc962b8f461d$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $6a55bc962b8f461d$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $6a55bc962b8f461d$export$70d775fb1f267027(callback, options = {}) {
    const registry = $6a55bc962b8f461d$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $6a55bc962b8f461d$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $6a55bc962b8f461d$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $444c9e424d20ca0b$export$7e223ec222791509)("hub", ()=>new $6a55bc962b8f461d$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $6a55bc962b8f461d$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $6d0c47d1c5cefe70$var$handlers = {};
const $6d0c47d1c5cefe70$var$instrumented = {};
/** Add a handler function. */ function $6d0c47d1c5cefe70$export$a4e09611e30da72e(type, handler) {
    $6d0c47d1c5cefe70$var$handlers[type] = $6d0c47d1c5cefe70$var$handlers[type] || [];
    $6d0c47d1c5cefe70$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $6d0c47d1c5cefe70$export$b17eab759a1cb5fe() {
    Object.keys($6d0c47d1c5cefe70$var$handlers).forEach((key)=>{
        $6d0c47d1c5cefe70$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $6d0c47d1c5cefe70$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$6d0c47d1c5cefe70$var$instrumented[type]) {
        instrumentFn();
        $6d0c47d1c5cefe70$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $6d0c47d1c5cefe70$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $6d0c47d1c5cefe70$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $866d0efb57a01972$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $3922f028d1f0b5d7$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $63059ef1c9d55f9f$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63059ef1c9d55f9f$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $63059ef1c9d55f9f$var$instrumentError);
}
function $63059ef1c9d55f9f$var$instrumentError() {
    $63059ef1c9d55f9f$var$_oldOnErrorHandler = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).onerror;
    (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("error", handlerData);
        if ($63059ef1c9d55f9f$var$_oldOnErrorHandler && !$63059ef1c9d55f9f$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $63059ef1c9d55f9f$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $3e6eadf97f6fe5e1$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3e6eadf97f6fe5e1$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $3e6eadf97f6fe5e1$var$instrumentUnhandledRejection);
}
function $3e6eadf97f6fe5e1$var$instrumentUnhandledRejection() {
    $3e6eadf97f6fe5e1$var$_oldOnUnhandledRejectionHandler = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($3e6eadf97f6fe5e1$var$_oldOnUnhandledRejectionHandler && !$3e6eadf97f6fe5e1$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $3e6eadf97f6fe5e1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $7afb9fcab45a7ce0$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $7afb9fcab45a7ce0$export$8e9a29865c0a1226 = (0, $4058f4d819de4cf1$export$8e9a29865c0a1226);


let $e0af819bf7dfef51$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $e0af819bf7dfef51$export$637857c1d87b640c() {
    if ($e0af819bf7dfef51$var$errorsInstrumented) return;
    $e0af819bf7dfef51$var$errorsInstrumented = true;
    (0, $63059ef1c9d55f9f$export$55b5c3ba2194f0c6)($e0af819bf7dfef51$var$errorCallback);
    (0, $3e6eadf97f6fe5e1$export$8bf4fc6858821a4e)($e0af819bf7dfef51$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $e0af819bf7dfef51$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$e0af819bf7dfef51$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $51e24223ae2427cb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $51e24223ae2427cb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $51e24223ae2427cb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $6eb20d3436b639ce$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $742a7e474e77ee8a$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $ef2f9c97cfc00acf$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
    const scope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $ef2f9c97cfc00acf$var$normalizeContext(context);
    const activeSpan = $ef2f9c97cfc00acf$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $51e24223ae2427cb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $ef2f9c97cfc00acf$export$a1bd95187356f372(context, callback) {
    const spanContext = $ef2f9c97cfc00acf$var$normalizeContext(context);
    return (0, $6a55bc962b8f461d$export$70d775fb1f267027)(()=>{
        return (0, $ff70bab8e0f5d056$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $ef2f9c97cfc00acf$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $51e24223ae2427cb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $629ef6feba2990f3$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $ef2f9c97cfc00acf$export$cb9e396e6b90b703 = $ef2f9c97cfc00acf$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $ef2f9c97cfc00acf$export$c10292ad04b92aea(context, callback) {
    const spanContext = $ef2f9c97cfc00acf$var$normalizeContext(context);
    return (0, $6a55bc962b8f461d$export$70d775fb1f267027)(()=>{
        return (0, $ff70bab8e0f5d056$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $ef2f9c97cfc00acf$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $51e24223ae2427cb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $629ef6feba2990f3$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $ef2f9c97cfc00acf$export$63dbba021a6b4047(context) {
    if (!(0, $742a7e474e77ee8a$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $ef2f9c97cfc00acf$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $ef2f9c97cfc00acf$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $ef2f9c97cfc00acf$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $ef2f9c97cfc00acf$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)().getSpan();
}
const $ef2f9c97cfc00acf$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $4058f4d819de4cf1$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $f12abffb275f404d$export$16a28057038b10ef) && traceparentData) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $6a55bc962b8f461d$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $ef2f9c97cfc00acf$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $742a7e474e77ee8a$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $30e8d42ca2ee98d9$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $629ef6feba2990f3$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $ef2f9c97cfc00acf$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $ef2f9c97cfc00acf$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $629ef6feba2990f3$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $ef2f9c97cfc00acf$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $ef2f9c97cfc00acf$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $ef2f9c97cfc00acf$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $971efa3a19c35af1$export$e73679ffaf56810e)(span, $ef2f9c97cfc00acf$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $971efa3a19c35af1$export$e73679ffaf56810e)(span, $ef2f9c97cfc00acf$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $ef2f9c97cfc00acf$export$c08fbc656a245d03(span) {
    return {
        scope: span[$ef2f9c97cfc00acf$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$ef2f9c97cfc00acf$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $7e1d38eb989abedf$var$SPAN_METRIC_SUMMARY;
function $7e1d38eb989abedf$var$getMetricStorageForSpan(span) {
    return $7e1d38eb989abedf$var$SPAN_METRIC_SUMMARY ? $7e1d38eb989abedf$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $7e1d38eb989abedf$export$2e7205e45c58797d(span) {
    const storage = $7e1d38eb989abedf$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $971efa3a19c35af1$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $7e1d38eb989abedf$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $ef2f9c97cfc00acf$export$1be426a8e585c83e)();
    if (span) {
        const storage = $7e1d38eb989abedf$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$7e1d38eb989abedf$var$SPAN_METRIC_SUMMARY) $7e1d38eb989abedf$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $7e1d38eb989abedf$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $34e240d20f3b495d$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $34e240d20f3b495d$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $34e240d20f3b495d$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $34e240d20f3b495d$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $34e240d20f3b495d$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $fa62835634708153$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($fa62835634708153$export$beb8e6a823e89c5d || ($fa62835634708153$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $fa62835634708153$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $fa62835634708153$export$ac65c70d78fcdb55 = $fa62835634708153$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $fa62835634708153$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $fa62835634708153$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $8425bdc572860109$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $8425bdc572860109$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $585c5f81398b071f$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $585c5f81398b071f$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $1c69755c87707ddf$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $34e240d20f3b495d$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $34e240d20f3b495d$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $34e240d20f3b495d$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $34e240d20f3b495d$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $34e240d20f3b495d$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $34e240d20f3b495d$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $629ef6feba2990f3$export$eb571cd9b5d98de8) : (0, $629ef6feba2990f3$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $8425bdc572860109$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $fbca0cda9bc299c1$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $f12abffb275f404d$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $629ef6feba2990f3$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $fa62835634708153$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $fbca0cda9bc299c1$export$c4c6a79b1260ca1b)(this);
        if ((0, $f12abffb275f404d$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $629ef6feba2990f3$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $629ef6feba2990f3$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $629ef6feba2990f3$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $34e240d20f3b495d$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $34e240d20f3b495d$export$cca8dd30f57f805e],
            _metrics_summary: (0, $7e1d38eb989abedf$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $34e240d20f3b495d$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $78a014755b8bd0a4$export$febc5573c75cefb0 extends (0, $8425bdc572860109$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $34e240d20f3b495d$export$d7a7d984b0791405] && {
                source: this._attributes[0, $34e240d20f3b495d$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $34e240d20f3b495d$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $34e240d20f3b495d$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $34e240d20f3b495d$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $8425bdc572860109$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $629ef6feba2990f3$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $30e8d42ca2ee98d9$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $629ef6feba2990f3$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $629ef6feba2990f3$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $ef2f9c97cfc00acf$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $629ef6feba2990f3$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $971efa3a19c35af1$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $30e8d42ca2ee98d9$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $7e1d38eb989abedf$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $3f87ac44abd54a5b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $3f87ac44abd54a5b$var$FINISH_REASON_TAG = "finishReason";
const $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $3f87ac44abd54a5b$export$370d6113c18ba86c extends (0, $8425bdc572860109$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $629ef6feba2990f3$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $3f87ac44abd54a5b$export$b279e6bd7040371f extends (0, $78a014755b8bd0a4$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $3f87ac44abd54a5b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $3f87ac44abd54a5b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $3f87ac44abd54a5b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $629ef6feba2990f3$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($3f87ac44abd54a5b$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $629ef6feba2990f3$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $629ef6feba2990f3$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $f12abffb275f404d$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $3f87ac44abd54a5b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $1c69755c87707ddf$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $3f87ac44abd54a5b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $87922b2095a5090a$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $742a7e474e77ee8a$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $34e240d20f3b495d$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $34e240d20f3b495d$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $34e240d20f3b495d$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $34e240d20f3b495d$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$87922b2095a5090a$export$2603c8d332a51c42(sampleRate)) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $f12abffb275f404d$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $629ef6feba2990f3$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $87922b2095a5090a$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $6eb20d3436b639ce$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $08bda2861f6e5e94$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $629ef6feba2990f3$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $08bda2861f6e5e94$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $78a014755b8bd0a4$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $87922b2095a5090a$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $08bda2861f6e5e94$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $3f87ac44abd54a5b$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $87922b2095a5090a$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $08bda2861f6e5e94$export$653d0ef2bad9cdf9() {
    const carrier = (0, $6a55bc962b8f461d$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $08bda2861f6e5e94$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $08bda2861f6e5e94$var$traceHeaders;
    (0, $e0af819bf7dfef51$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $56c0fba3df7b578a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $aed9529decbb5187$export$56d8a8a25bd48b81 = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $b1e97925e6c64aa9$export$6f18f55521af71a1() {
    if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
        if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $629ef6feba2990f3$export$92d8c23565496537)(activeTransaction);
            (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $d7f16582c6287dbc$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $e7067fbc7ebebd0c$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $432dc8799d5478a2$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $432dc8799d5478a2$export$6431553786c94949 = ()=>{
    if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $432dc8799d5478a2$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1b85a3e04301a0d2$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $432dc8799d5478a2$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b83a9fa080324fee$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $432dc8799d5478a2$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.prerendering || (0, $1b85a3e04301a0d2$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $e7067fbc7ebebd0c$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $43d9cec1b3533be3$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d2ac8ebf40481780$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $846da2524421f6a1$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $b83a9fa080324fee$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $43d9cec1b3533be3$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $d7f16582c6287dbc$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $d2ac8ebf40481780$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $61704f6b3c0f7db9$var$firstHiddenTime = -1;
const $61704f6b3c0f7db9$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.visibilityState) $61704f6b3c0f7db9$var$firstHiddenTime = (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $61704f6b3c0f7db9$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $d2ac8ebf40481780$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $61704f6b3c0f7db9$var$firstHiddenTime = timeStamp;
    }, true);
};
const $61704f6b3c0f7db9$export$443f86b2c77012c4 = ()=>{
    if ($61704f6b3c0f7db9$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $61704f6b3c0f7db9$var$initHiddenTime();
        $61704f6b3c0f7db9$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $61704f6b3c0f7db9$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $c27c8b9acb336aef$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $61704f6b3c0f7db9$export$443f86b2c77012c4)();
    const metric = (0, $b83a9fa080324fee$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $43d9cec1b3533be3$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $d7f16582c6287dbc$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $d2ac8ebf40481780$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $d607c8a2d07998c1$var$interactionCountEstimate = 0;
let $d607c8a2d07998c1$var$minKnownInteractionId = Infinity;
let $d607c8a2d07998c1$var$maxKnownInteractionId = 0;
const $d607c8a2d07998c1$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $d607c8a2d07998c1$var$minKnownInteractionId = Math.min($d607c8a2d07998c1$var$minKnownInteractionId, e.interactionId);
            $d607c8a2d07998c1$var$maxKnownInteractionId = Math.max($d607c8a2d07998c1$var$maxKnownInteractionId, e.interactionId);
            $d607c8a2d07998c1$var$interactionCountEstimate = $d607c8a2d07998c1$var$maxKnownInteractionId ? ($d607c8a2d07998c1$var$maxKnownInteractionId - $d607c8a2d07998c1$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $d607c8a2d07998c1$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $d607c8a2d07998c1$export$8a962f2683a476d1 = ()=>{
    return $d607c8a2d07998c1$var$po ? $d607c8a2d07998c1$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $d607c8a2d07998c1$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $d607c8a2d07998c1$var$po) return;
    $d607c8a2d07998c1$var$po = (0, $43d9cec1b3533be3$export$d1203567a167490e)("event", $d607c8a2d07998c1$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $bb0eb3031087ab65$var$getInteractionCountForNavigation = ()=>{
    return (0, $d607c8a2d07998c1$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $bb0eb3031087ab65$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $bb0eb3031087ab65$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $bb0eb3031087ab65$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $bb0eb3031087ab65$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $bb0eb3031087ab65$var$longestInteractionList[$bb0eb3031087ab65$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $bb0eb3031087ab65$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $bb0eb3031087ab65$var$longestInteractionList.length < $bb0eb3031087ab65$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $bb0eb3031087ab65$var$longestInteractionMap[interaction.id] = interaction;
            $bb0eb3031087ab65$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $bb0eb3031087ab65$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $bb0eb3031087ab65$var$longestInteractionList.splice($bb0eb3031087ab65$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $bb0eb3031087ab65$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $bb0eb3031087ab65$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($bb0eb3031087ab65$var$longestInteractionList.length - 1, Math.floor($bb0eb3031087ab65$var$getInteractionCountForNavigation() / 50));
    return $bb0eb3031087ab65$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $bb0eb3031087ab65$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $d607c8a2d07998c1$export$67d90cda6b78a2eb)();
    const metric = (0, $b83a9fa080324fee$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $bb0eb3031087ab65$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$bb0eb3031087ab65$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $bb0eb3031087ab65$var$processEntry(entry);
            }
        });
        const inp = $bb0eb3031087ab65$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $43d9cec1b3533be3$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $d7f16582c6287dbc$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $d2ac8ebf40481780$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $bb0eb3031087ab65$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fc1c39ac1e76093$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $8fc1c39ac1e76093$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $61704f6b3c0f7db9$export$443f86b2c77012c4)();
    const metric = (0, $b83a9fa080324fee$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $1b85a3e04301a0d2$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $43d9cec1b3533be3$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $d7f16582c6287dbc$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$8fc1c39ac1e76093$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $8fc1c39ac1e76093$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $d2ac8ebf40481780$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f701af9ce7cf6dc9$var$whenReady = (callback)=>{
    if (!(0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) return;
    if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$f701af9ce7cf6dc9$var$whenReady(callback), true);
    else if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$f701af9ce7cf6dc9$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f701af9ce7cf6dc9$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $b83a9fa080324fee$export$3c29b44508a0612b)("TTFB");
    const report = (0, $d7f16582c6287dbc$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $f701af9ce7cf6dc9$var$whenReady(()=>{
        const navEntry = (0, $432dc8799d5478a2$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $1b85a3e04301a0d2$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $a13a50f36d91fa48$var$handlers = {};
const $a13a50f36d91fa48$var$instrumented = {};
let $a13a50f36d91fa48$var$_previousCls;
let $a13a50f36d91fa48$var$_previousFid;
let $a13a50f36d91fa48$var$_previousLcp;
let $a13a50f36d91fa48$var$_previousTtfb;
let $a13a50f36d91fa48$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $a13a50f36d91fa48$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $a13a50f36d91fa48$var$addMetricObserver("cls", callback, $a13a50f36d91fa48$var$instrumentCls, $a13a50f36d91fa48$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $a13a50f36d91fa48$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $a13a50f36d91fa48$var$addMetricObserver("lcp", callback, $a13a50f36d91fa48$var$instrumentLcp, $a13a50f36d91fa48$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $a13a50f36d91fa48$export$699d9529c099a797(callback) {
    return $a13a50f36d91fa48$var$addMetricObserver("ttfb", callback, $a13a50f36d91fa48$var$instrumentTtfb, $a13a50f36d91fa48$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $a13a50f36d91fa48$export$2707d7471c0b918f(callback) {
    return $a13a50f36d91fa48$var$addMetricObserver("fid", callback, $a13a50f36d91fa48$var$instrumentFid, $a13a50f36d91fa48$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $a13a50f36d91fa48$export$da3b76aa2022cbd7(callback) {
    return $a13a50f36d91fa48$var$addMetricObserver("inp", callback, $a13a50f36d91fa48$var$instrumentInp, $a13a50f36d91fa48$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $a13a50f36d91fa48$export$69816c1a049f8db6(type, callback) {
    $a13a50f36d91fa48$var$addHandler(type, callback);
    if (!$a13a50f36d91fa48$var$instrumented[type]) {
        $a13a50f36d91fa48$var$instrumentPerformanceObserver(type);
        $a13a50f36d91fa48$var$instrumented[type] = true;
    }
    return $a13a50f36d91fa48$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $a13a50f36d91fa48$var$triggerHandlers(type, data) {
    const typeHandlers = $a13a50f36d91fa48$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $3922f028d1f0b5d7$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $a13a50f36d91fa48$var$instrumentCls() {
    return (0, $846da2524421f6a1$export$a7873055838e5ad8)((metric)=>{
        $a13a50f36d91fa48$var$triggerHandlers("cls", {
            metric: metric
        });
        $a13a50f36d91fa48$var$_previousCls = metric;
    });
}
function $a13a50f36d91fa48$var$instrumentFid() {
    return (0, $c27c8b9acb336aef$export$39705a25c49af873)((metric)=>{
        $a13a50f36d91fa48$var$triggerHandlers("fid", {
            metric: metric
        });
        $a13a50f36d91fa48$var$_previousFid = metric;
    });
}
function $a13a50f36d91fa48$var$instrumentLcp() {
    return (0, $8fc1c39ac1e76093$export$947b1626ab8d5632)((metric)=>{
        $a13a50f36d91fa48$var$triggerHandlers("lcp", {
            metric: metric
        });
        $a13a50f36d91fa48$var$_previousLcp = metric;
    });
}
function $a13a50f36d91fa48$var$instrumentTtfb() {
    return (0, $f701af9ce7cf6dc9$export$33a01e6c5f2c7e33)((metric)=>{
        $a13a50f36d91fa48$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $a13a50f36d91fa48$var$_previousTtfb = metric;
    });
}
function $a13a50f36d91fa48$var$instrumentInp() {
    return (0, $bb0eb3031087ab65$export$7df4b36ecaed99e1)((metric)=>{
        $a13a50f36d91fa48$var$triggerHandlers("inp", {
            metric: metric
        });
        $a13a50f36d91fa48$var$_previousInp = metric;
    });
}
function $a13a50f36d91fa48$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $a13a50f36d91fa48$var$addHandler(type, callback);
    let stopListening;
    if (!$a13a50f36d91fa48$var$instrumented[type]) {
        stopListening = instrumentFn();
        $a13a50f36d91fa48$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $a13a50f36d91fa48$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $a13a50f36d91fa48$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $43d9cec1b3533be3$export$d1203567a167490e)(type, (entries)=>{
        $a13a50f36d91fa48$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $a13a50f36d91fa48$var$addHandler(type, handler) {
    $a13a50f36d91fa48$var$handlers[type] = $a13a50f36d91fa48$var$handlers[type] || [];
    $a13a50f36d91fa48$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $a13a50f36d91fa48$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $a13a50f36d91fa48$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $9781e7c2fbdbcc85$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9781e7c2fbdbcc85$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9781e7c2fbdbcc85$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9781e7c2fbdbcc85$export$b892860177f70a30(str) {
    const match = $9781e7c2fbdbcc85$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $f380c6c63e13cddf$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9781e7c2fbdbcc85$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9781e7c2fbdbcc85$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $9781e7c2fbdbcc85$var$validateDsn(dsn) {
    if (!(0, $866d0efb57a01972$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9781e7c2fbdbcc85$var$isValidProtocol(protocol)) {
        (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9781e7c2fbdbcc85$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $9781e7c2fbdbcc85$export$b892860177f70a30(from) : $9781e7c2fbdbcc85$var$dsnFromComponents(from);
    if (!components || !$9781e7c2fbdbcc85$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $dfe4042267fdebb0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $dfe4042267fdebb0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $dfe4042267fdebb0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $dfe4042267fdebb0$export$604a45d95a155e2b(envelope, types) {
    return $dfe4042267fdebb0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $dfe4042267fdebb0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $dfe4042267fdebb0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $dfe4042267fdebb0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $dfe4042267fdebb0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $945327a834d3a1ba$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $dfe4042267fdebb0$var$concatBuffers(parts);
}
function $dfe4042267fdebb0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $dfe4042267fdebb0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $dfe4042267fdebb0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $dfe4042267fdebb0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $dfe4042267fdebb0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $dfe4042267fdebb0$export$b11169581eeaf237(type) {
    return $dfe4042267fdebb0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $dfe4042267fdebb0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $dfe4042267fdebb0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $971efa3a19c35af1$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $23bc5a3159240be5$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(dsn);
    const items = spans.map($23bc5a3159240be5$var$createSpanItem);
    return (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(headers, items);
}
function $23bc5a3159240be5$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $0575129e5ef02178$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $0f9bb201bd5c10af$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $0f9bb201bd5c10af$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $0f9bb201bd5c10af$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $0f9bb201bd5c10af$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $667b65db70afede9$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $667b65db70afede9$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $70e7a953caa0e8f5$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $70e7a953caa0e8f5$var$msToSec(time) {
    return time / 1000;
}
function $70e7a953caa0e8f5$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $aed9529decbb5187$export$56d8a8a25bd48b81) && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).addEventListener && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance;
}
let $70e7a953caa0e8f5$var$_performanceCursor = 0;
let $70e7a953caa0e8f5$var$_measurements = {};
let $70e7a953caa0e8f5$var$_lcpEntry;
let $70e7a953caa0e8f5$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $70e7a953caa0e8f5$export$7c69f0412d101b88() {
    const performance = $70e7a953caa0e8f5$var$getBrowserPerformanceAPI();
    if (performance && (0, $1c69755c87707ddf$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $70e7a953caa0e8f5$var$_trackFID();
        const clsCallback = $70e7a953caa0e8f5$var$_trackCLS();
        const lcpCallback = $70e7a953caa0e8f5$var$_trackLCP();
        const ttfbCallback = $70e7a953caa0e8f5$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $70e7a953caa0e8f5$export$f396d19077034ad2() {
    (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $70e7a953caa0e8f5$var$msToSec((0, $1c69755c87707ddf$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $70e7a953caa0e8f5$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $70e7a953caa0e8f5$export$e27543e0976315e4() {
    (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $70e7a953caa0e8f5$var$msToSec((0, $1c69755c87707ddf$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $70e7a953caa0e8f5$var$msToSec(entry.duration);
                const span = {
                    description: (0, $cc2b0812a7e75fd4$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $cc2b0812a7e75fd4$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $70e7a953caa0e8f5$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $70e7a953caa0e8f5$var$getBrowserPerformanceAPI();
    if (performance && (0, $1c69755c87707ddf$export$baf075a948ffc0bf)) {
        const inpCallback = $70e7a953caa0e8f5$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $70e7a953caa0e8f5$var$_trackCLS() {
    return (0, $a13a50f36d91fa48$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $70e7a953caa0e8f5$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $70e7a953caa0e8f5$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $70e7a953caa0e8f5$var$_trackLCP() {
    return (0, $a13a50f36d91fa48$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $70e7a953caa0e8f5$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $70e7a953caa0e8f5$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $70e7a953caa0e8f5$var$_trackFID() {
    return (0, $a13a50f36d91fa48$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $70e7a953caa0e8f5$var$msToSec((0, $1c69755c87707ddf$export$baf075a948ffc0bf));
        const startTime = $70e7a953caa0e8f5$var$msToSec(entry.startTime);
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $70e7a953caa0e8f5$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $70e7a953caa0e8f5$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $70e7a953caa0e8f5$var$_trackTtfb() {
    return (0, $a13a50f36d91fa48$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $70e7a953caa0e8f5$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $70e7a953caa0e8f5$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $70e7a953caa0e8f5$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $a13a50f36d91fa48$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $70e7a953caa0e8f5$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $70e7a953caa0e8f5$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $70e7a953caa0e8f5$var$msToSec((0, $1c69755c87707ddf$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $70e7a953caa0e8f5$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $8425bdc572860109$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $cc2b0812a7e75fd4$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $70e7a953caa0e8f5$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $23bc5a3159240be5$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $70e7a953caa0e8f5$export$5f8fa6b3467a7443(transaction) {
    const performance = $70e7a953caa0e8f5$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $aed9529decbb5187$export$56d8a8a25bd48b81).performance.getEntries || !(0, $1c69755c87707ddf$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $70e7a953caa0e8f5$var$msToSec((0, $1c69755c87707ddf$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $629ef6feba2990f3$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($70e7a953caa0e8f5$var$_performanceCursor).forEach((entry)=>{
        const startTime = $70e7a953caa0e8f5$var$msToSec(entry.startTime);
        const duration = $70e7a953caa0e8f5$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $70e7a953caa0e8f5$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $70e7a953caa0e8f5$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $61704f6b3c0f7db9$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $70e7a953caa0e8f5$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $70e7a953caa0e8f5$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $70e7a953caa0e8f5$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $70e7a953caa0e8f5$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $70e7a953caa0e8f5$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $70e7a953caa0e8f5$var$_addTtfbRequestTimeToMeasurements($70e7a953caa0e8f5$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$70e7a953caa0e8f5$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $70e7a953caa0e8f5$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $70e7a953caa0e8f5$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $70e7a953caa0e8f5$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $70e7a953caa0e8f5$var$_measurements["mark.fid"];
        if (fidMark && $70e7a953caa0e8f5$var$_measurements["fid"]) {
            // create span for FID
            (0, $667b65db70afede9$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $70e7a953caa0e8f5$var$msToSec($70e7a953caa0e8f5$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $70e7a953caa0e8f5$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $70e7a953caa0e8f5$var$_measurements)) delete $70e7a953caa0e8f5$var$_measurements.cls;
        Object.keys($70e7a953caa0e8f5$var$_measurements).forEach((measurementName)=>{
            (0, $0575129e5ef02178$export$7cc31b475d33a706)(measurementName, $70e7a953caa0e8f5$var$_measurements[measurementName].value, $70e7a953caa0e8f5$var$_measurements[measurementName].unit);
        });
        $70e7a953caa0e8f5$var$_tagMetricInfo(transaction);
    }
    $70e7a953caa0e8f5$var$_lcpEntry = undefined;
    $70e7a953caa0e8f5$var$_clsEntry = undefined;
    $70e7a953caa0e8f5$var$_measurements = {};
}
/** Create measure related spans */ function $70e7a953caa0e8f5$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $667b65db70afede9$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70e7a953caa0e8f5$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $70e7a953caa0e8f5$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $70e7a953caa0e8f5$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $70e7a953caa0e8f5$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $70e7a953caa0e8f5$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $70e7a953caa0e8f5$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $70e7a953caa0e8f5$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $667b65db70afede9$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $70e7a953caa0e8f5$var$msToSec(start),
        endTimestamp: timeOrigin + $70e7a953caa0e8f5$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70e7a953caa0e8f5$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $667b65db70afede9$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $70e7a953caa0e8f5$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $70e7a953caa0e8f5$var$msToSec(entry.responseEnd)
        });
        (0, $667b65db70afede9$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $70e7a953caa0e8f5$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $70e7a953caa0e8f5$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $70e7a953caa0e8f5$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $70e7a953caa0e8f5$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $70e7a953caa0e8f5$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $70e7a953caa0e8f5$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $667b65db70afede9$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $70e7a953caa0e8f5$var$_trackNavigator(transaction) {
    const navigator = (0, $aed9529decbb5187$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $667b65db70afede9$export$27169ccae1b439e3)(connection.rtt)) $70e7a953caa0e8f5$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $667b65db70afede9$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $667b65db70afede9$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $70e7a953caa0e8f5$var$_tagMetricInfo(transaction) {
    if ($70e7a953caa0e8f5$var$_lcpEntry) {
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($70e7a953caa0e8f5$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $cc2b0812a7e75fd4$export$5647df6b7814ac86)($70e7a953caa0e8f5$var$_lcpEntry.element));
        if ($70e7a953caa0e8f5$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $70e7a953caa0e8f5$var$_lcpEntry.id);
        if ($70e7a953caa0e8f5$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $70e7a953caa0e8f5$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $70e7a953caa0e8f5$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($70e7a953caa0e8f5$var$_clsEntry && $70e7a953caa0e8f5$var$_clsEntry.sources) {
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $70e7a953caa0e8f5$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $cc2b0812a7e75fd4$export$5647df6b7814ac86)(source.node)));
    }
}
function $70e7a953caa0e8f5$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $70e7a953caa0e8f5$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $70e7a953caa0e8f5$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $432dc8799d5478a2$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $70e7a953caa0e8f5$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $742a7e474e77ee8a$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $87922b2095a5090a$export$2603c8d332a51c42)(sampleRate)) {
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $d438491a2227c0aa$var$WINDOW = (0, $444c9e424d20ca0b$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $d438491a2227c0aa$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $d438491a2227c0aa$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $d438491a2227c0aa$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $d438491a2227c0aa$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $d438491a2227c0aa$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d438491a2227c0aa$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $d438491a2227c0aa$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$d438491a2227c0aa$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($d438491a2227c0aa$export$18cf36ed71d733e7($d438491a2227c0aa$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $d438491a2227c0aa$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $d438491a2227c0aa$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $866d0efb57a01972$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $d438491a2227c0aa$export$531055a6c684a70a() {
    return "ReportingObserver" in $d438491a2227c0aa$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $d438491a2227c0aa$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$d438491a2227c0aa$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4a65b18730c1a634$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $4a65b18730c1a634$var$instrumentFetch);
}
function $4a65b18730c1a634$var$instrumentFetch() {
    if (!(0, $d438491a2227c0aa$export$c82d238e23c40b21)()) return;
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)((0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $4a65b18730c1a634$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $4a65b18730c1a634$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $4a65b18730c1a634$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($4a65b18730c1a634$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $4a65b18730c1a634$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $4a65b18730c1a634$var$getUrlFromResource(url),
            method: $4a65b18730c1a634$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $4a65b18730c1a634$var$getUrlFromResource(arg),
        method: $4a65b18730c1a634$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $54d1953ab2b6fc81$var$WINDOW = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
const $54d1953ab2b6fc81$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $54d1953ab2b6fc81$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $54d1953ab2b6fc81$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $54d1953ab2b6fc81$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$54d1953ab2b6fc81$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $6eb20d3436b639ce$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $54d1953ab2b6fc81$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$54d1953ab2b6fc81$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$54d1953ab2b6fc81$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $971efa3a19c35af1$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $971efa3a19c35af1$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$54d1953ab2b6fc81$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $6eb20d3436b639ce$export$844ec244b1367d54)(header) && (0, $6eb20d3436b639ce$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$54d1953ab2b6fc81$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $54d1953ab2b6fc81$var$parseUrl(url) {
    if ((0, $6eb20d3436b639ce$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $bad90d6ff9b1dab8$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $742a7e474e77ee8a$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $bad90d6ff9b1dab8$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $bad90d6ff9b1dab8$var$getFullURL(url);
    const host = fullUrl ? (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $ef2f9c97cfc00acf$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $34e240d20f3b495d$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $bad90d6ff9b1dab8$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $bad90d6ff9b1dab8$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $629ef6feba2990f3$export$7e9f8ae9e4a328ab)(span) : (0, $4058f4d819de4cf1$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $2756a0a7536a25ea$export$56766feef403f365)(dsc || (span ? (0, $30e8d42ca2ee98d9$export$a117f995597e25df)(span) : (0, $30e8d42ca2ee98d9$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $6eb20d3436b639ce$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $6eb20d3436b639ce$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $2756a0a7536a25ea$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $2756a0a7536a25ea$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $bad90d6ff9b1dab8$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $bad90d6ff9b1dab8$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $fa62835634708153$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $45035e12b9b3ee66$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $45035e12b9b3ee66$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $45035e12b9b3ee66$export$15bd0305d05ad07b,
    tracePropagationTargets: $45035e12b9b3ee66$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $45035e12b9b3ee66$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $45035e12b9b3ee66$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $45035e12b9b3ee66$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$45035e12b9b3ee66$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $4a65b18730c1a634$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $bad90d6ff9b1dab8$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $45035e12b9b3ee66$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $45035e12b9b3ee66$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $54d1953ab2b6fc81$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $45035e12b9b3ee66$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $45035e12b9b3ee66$var$addHTTPTimings(createdSpan);
    });
}
function $45035e12b9b3ee66$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $45035e12b9b3ee66$var$addHTTPTimings(span) {
    const { url: url } = (0, $629ef6feba2990f3$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($45035e12b9b3ee66$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $45035e12b9b3ee66$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $45035e12b9b3ee66$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $45035e12b9b3ee66$var$getAbsoluteTime(time = 0) {
    return (((0, $1c69755c87707ddf$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $45035e12b9b3ee66$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $45035e12b9b3ee66$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $1c69755c87707ddf$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $45035e12b9b3ee66$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $45035e12b9b3ee66$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $5ba26d97ad14420c$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $45035e12b9b3ee66$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $45035e12b9b3ee66$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $54d1953ab2b6fc81$export$55b6bb1e45c6cf59];
    if (!(0, $742a7e474e77ee8a$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $fa62835634708153$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
    const isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)();
    const fullUrl = $45035e12b9b3ee66$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $ef2f9c97cfc00acf$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $34e240d20f3b495d$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $629ef6feba2990f3$export$7e9f8ae9e4a328ab)(span) : (0, $4058f4d819de4cf1$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $2756a0a7536a25ea$export$56766feef403f365)(dsc || (span ? (0, $30e8d42ca2ee98d9$export$a117f995597e25df)(span) : (0, $30e8d42ca2ee98d9$export$366bad00d6815eed)(traceId, client, scope)));
        $45035e12b9b3ee66$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $45035e12b9b3ee66$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $2756a0a7536a25ea$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $45035e12b9b3ee66$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $a80def4440a289c8$var$WINDOW = (0, $444c9e424d20ca0b$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a80def4440a289c8$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a80def4440a289c8$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a80def4440a289c8$var$WINDOW && !!$a80def4440a289c8$var$WINDOW.history.pushState && !!$a80def4440a289c8$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $08836e65fa97523f$var$WINDOW = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
let $08836e65fa97523f$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $08836e65fa97523f$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $08836e65fa97523f$var$instrumentHistory);
}
function $08836e65fa97523f$var$instrumentHistory() {
    if (!(0, $a80def4440a289c8$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $08836e65fa97523f$var$WINDOW.onpopstate;
    $08836e65fa97523f$var$WINDOW.onpopstate = function(...args) {
        const to = $08836e65fa97523f$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $08836e65fa97523f$var$lastHref;
        $08836e65fa97523f$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $08836e65fa97523f$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $08836e65fa97523f$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)($08836e65fa97523f$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)($08836e65fa97523f$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




/**
 * Default function implementing pageload and navigation transactions
 */ function $c125713471079200$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $aed9529decbb5187$export$56d8a8a25bd48b81) || !(0, $aed9529decbb5187$export$56d8a8a25bd48b81).location) {
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $1c69755c87707ddf$export$baf075a948ffc0bf) ? (0, $1c69755c87707ddf$export$baf075a948ffc0bf) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $08836e65fa97523f$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $4b78ee6af91951c6$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $4b78ee6af91951c6$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $3f87ac44abd54a5b$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $c125713471079200$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $45035e12b9b3ee66$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $4b78ee6af91951c6$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $4b78ee6af91951c6$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $4b78ee6af91951c6$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $08bda2861f6e5e94$export$653d0ef2bad9cdf9)();
        if (0, $56c0fba3df7b578a$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$4b78ee6af91951c6$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $70e7a953caa0e8f5$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $70e7a953caa0e8f5$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $70e7a953caa0e8f5$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $70e7a953caa0e8f5$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $56c0fba3df7b578a$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $b1e97925e6c64aa9$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $45035e12b9b3ee66$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $4b78ee6af91951c6$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $4b78ee6af91951c6$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $4058f4d819de4cf1$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $aed9529decbb5187$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $08bda2861f6e5e94$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) {
                (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $70e7a953caa0e8f5$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $aed9529decbb5187$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: this._latestRoute.context ? $4b78ee6af91951c6$var$getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, $08bda2861f6e5e94$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
            const currentScope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($4b78ee6af91951c6$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $4b78ee6af91951c6$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $4b78ee6af91951c6$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("event", handleEntries);
        (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("first-input", handleEntries);
    }
}
/** Returns the value of a meta tag */ function $4b78ee6af91951c6$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $cc2b0812a7e75fd4$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $4b78ee6af91951c6$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $34e240d20f3b495d$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $34e240d20f3b495d$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $4b78ee6af91951c6$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}








const $2c2fa06c877a3c5f$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $2c2fa06c877a3c5f$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $2c2fa06c877a3c5f$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $585c5f81398b071f$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $2c2fa06c877a3c5f$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $2c2fa06c877a3c5f$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $2c2fa06c877a3c5f$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $2c2fa06c877a3c5f$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $2c2fa06c877a3c5f$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $2c2fa06c877a3c5f$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($2c2fa06c877a3c5f$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $d09d18b69e8facdc$export$8e4e25f54d456511), (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c));
        $2c2fa06c877a3c5f$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $2c2fa06c877a3c5f$export$2d8f5188773bcddd(integration) {
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $2c2fa06c877a3c5f$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $2c2fa06c877a3c5f$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $2c2fa06c877a3c5f$export$2323046b9414659f(fn) {
    return fn;
}


let $102f14e235f86122$var$originalFunctionToString;
const $102f14e235f86122$var$INTEGRATION_NAME = "FunctionToString";
const $102f14e235f86122$var$SETUP_CLIENTS = new WeakMap();
const $102f14e235f86122$var$_functionToStringIntegration = ()=>{
    return {
        name: $102f14e235f86122$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $102f14e235f86122$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $971efa3a19c35af1$export$e6cc1e135e2092e5)(this);
                    const context = $102f14e235f86122$var$SETUP_CLIENTS.has((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $102f14e235f86122$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $102f14e235f86122$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $102f14e235f86122$export$7918117e9202e4fb = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($102f14e235f86122$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $102f14e235f86122$export$da4704525c20ae79 = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($102f14e235f86122$var$INTEGRATION_NAME, $102f14e235f86122$export$7918117e9202e4fb);


const $a02f70b1fa9c1e2b$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a02f70b1fa9c1e2b$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a02f70b1fa9c1e2b$var$_getIngestEndpoint(dsn) {
    return `${$a02f70b1fa9c1e2b$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a02f70b1fa9c1e2b$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $971efa3a19c35af1$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a02f70b1fa9c1e2b$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a02f70b1fa9c1e2b$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$a02f70b1fa9c1e2b$var$_getIngestEndpoint(dsn)}?${$a02f70b1fa9c1e2b$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a02f70b1fa9c1e2b$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9781e7c2fbdbcc85$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$a02f70b1fa9c1e2b$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $17dfacf866495c76$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $17dfacf866495c76$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $17dfacf866495c76$var$INTEGRATION_NAME = "InboundFilters";
const $17dfacf866495c76$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $17dfacf866495c76$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $17dfacf866495c76$var$_mergeOptions(options, clientOptions);
            return $17dfacf866495c76$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $17dfacf866495c76$export$cb3c5c2ceb9818ba = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($17dfacf866495c76$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $17dfacf866495c76$export$2ffbb5359dcc6be4 = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($17dfacf866495c76$var$INTEGRATION_NAME, $17dfacf866495c76$export$cb3c5c2ceb9818ba);
function $17dfacf866495c76$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $17dfacf866495c76$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $17dfacf866495c76$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $17dfacf866495c76$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $17dfacf866495c76$var$_isSentryError(event)) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($17dfacf866495c76$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($17dfacf866495c76$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($17dfacf866495c76$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}.\nUrl: ${$17dfacf866495c76$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$17dfacf866495c76$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}.\nUrl: ${$17dfacf866495c76$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $17dfacf866495c76$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $17dfacf866495c76$var$_getPossibleEventMessages(event).some((message)=>(0, $5ba26d97ad14420c$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $17dfacf866495c76$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $5ba26d97ad14420c$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $17dfacf866495c76$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $17dfacf866495c76$var$_getEventFilterUrl(event);
    return !url ? false : (0, $5ba26d97ad14420c$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $17dfacf866495c76$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $17dfacf866495c76$var$_getEventFilterUrl(event);
    return !url ? true : (0, $5ba26d97ad14420c$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $17dfacf866495c76$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $f12abffb275f404d$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $17dfacf866495c76$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $17dfacf866495c76$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $17dfacf866495c76$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $17dfacf866495c76$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $585c5f81398b071f$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $80d9fdf3b6d6ac84$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $f12abffb275f404d$export$16a28057038b10ef) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $f380c6c63e13cddf$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $80d9fdf3b6d6ac84$export$ecb76f41d43c0e43(client);
    $80d9fdf3b6d6ac84$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $80d9fdf3b6d6ac84$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $80d9fdf3b6d6ac84$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $7869509ac5668368$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $c6e8177700af97c3$export$31499a9cd224b78c)
            })),
        version: (0, $c6e8177700af97c3$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $f97119f28cb81551$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $f97119f28cb81551$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $dfe4042267fdebb0$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $f97119f28cb81551$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $dfe4042267fdebb0$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $f97119f28cb81551$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $dfe4042267fdebb0$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $4d8615ec70902d68$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $971efa3a19c35af1$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $4d8615ec70902d68$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $4d8615ec70902d68$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $4d8615ec70902d68$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $4d8615ec70902d68$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $4d8615ec70902d68$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $4d8615ec70902d68$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $4d8615ec70902d68$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $4d8615ec70902d68$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $4d8615ec70902d68$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $4d8615ec70902d68$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $4d8615ec70902d68$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $4d8615ec70902d68$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $4d8615ec70902d68$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $08919dc49bde49b7$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(dsn);
    const item = $08919dc49bde49b7$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $08919dc49bde49b7$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $4d8615ec70902d68$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $ab85251a76e5b699$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $ab85251a76e5b699$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9781e7c2fbdbcc85$export$128827c3562ec0cb)(options.dsn);
        else (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $a02f70b1fa9c1e2b$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $585c5f81398b071f$export$6de4ffac6a2f1098)(exception)) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log($ab85251a76e5b699$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $6eb20d3436b639ce$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $6eb20d3436b639ce$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $585c5f81398b071f$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log($ab85251a76e5b699$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $0a85196b42ee4cba$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $0c4a60aa51d054a5$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $2c2fa06c877a3c5f$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $2c2fa06c877a3c5f$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $f97119f28cb81551$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $dfe4042267fdebb0$export$d650323442802f6f)(env, (0, $dfe4042267fdebb0$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $f97119f28cb81551$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $08919dc49bde49b7$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $2c2fa06c877a3c5f$export$51abed9797baa598)(this, integrations);
        (0, $2c2fa06c877a3c5f$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $0a85196b42ee4cba$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $0c4a60aa51d054a5$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $6a55bc962b8f461d$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $49924d6ecd0805c4$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $30e8d42ca2ee98d9$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $f12abffb275f404d$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $ab85251a76e5b699$var$isTransactionEvent(event);
        const isError = $ab85251a76e5b699$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $0c4a60aa51d054a5$export$78e43115b553f358)(new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $ab85251a76e5b699$var$processBeforeSend(options, prepared, hint);
            return $ab85251a76e5b699$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $ab85251a76e5b699$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $6eb20d3436b639ce$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $6eb20d3436b639ce$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $6eb20d3436b639ce$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $ab85251a76e5b699$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($ab85251a76e5b699$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($ab85251a76e5b699$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $ab85251a76e5b699$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $ab85251a76e5b699$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $ab85251a76e5b699$export$9aac0b9f77928fbf(callback) {
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $8cfab509699cb710$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $1c69755c87707ddf$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1096ce969d0ca021$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1096ce969d0ca021$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d09a34927a3f376d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $5cbed19a88ad1020$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $5cbed19a88ad1020$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $5cbed19a88ad1020$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $5cbed19a88ad1020$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $6eb20d3436b639ce$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $5cbed19a88ad1020$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $945327a834d3a1ba$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $5cbed19a88ad1020$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $5cbed19a88ad1020$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $5cbed19a88ad1020$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $5cbed19a88ad1020$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $5cbed19a88ad1020$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $5cbed19a88ad1020$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $5cbed19a88ad1020$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($5cbed19a88ad1020$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $5cbed19a88ad1020$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $5cbed19a88ad1020$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $5cbed19a88ad1020$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $585c5f81398b071f$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $0c4a60aa51d054a5$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $5cbed19a88ad1020$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $5cbed19a88ad1020$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $0c4a60aa51d054a5$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $5cbed19a88ad1020$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $6eb20d3436b639ce$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $5cbed19a88ad1020$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $6eb20d3436b639ce$export$ef9e2056653f0c8e)(exception) || (0, $6eb20d3436b639ce$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $5cbed19a88ad1020$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $6eb20d3436b639ce$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $5cbed19a88ad1020$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $585c5f81398b071f$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $6eb20d3436b639ce$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $5cbed19a88ad1020$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $6eb20d3436b639ce$export$53b83ca8eaab0383)(exception) || (0, $6eb20d3436b639ce$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $5cbed19a88ad1020$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $585c5f81398b071f$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $5cbed19a88ad1020$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $585c5f81398b071f$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $585c5f81398b071f$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $5cbed19a88ad1020$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $5cbed19a88ad1020$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $6eb20d3436b639ce$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $5cbed19a88ad1020$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $971efa3a19c35af1$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $6eb20d3436b639ce$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $6eb20d3436b639ce$export$9671ea99bd126ace)(exception)) {
        const className = $5cbed19a88ad1020$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $5cbed19a88ad1020$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81 = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
let $b5b9a5d09d13b5e5$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $b5b9a5d09d13b5e5$export$b79738ab10c590b2() {
    return $b5b9a5d09d13b5e5$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $b5b9a5d09d13b5e5$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b5b9a5d09d13b5e5$var$ignoreOnError++;
    setTimeout(()=>{
        $b5b9a5d09d13b5e5$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $b5b9a5d09d13b5e5$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $971efa3a19c35af1$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$b5b9a5d09d13b5e5$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b5b9a5d09d13b5e5$export$1265a142ff5ba165();
            (0, $ff70bab8e0f5d056$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $585c5f81398b071f$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $585c5f81398b071f$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $ff70bab8e0f5d056$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $971efa3a19c35af1$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $971efa3a19c35af1$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $3c6db1bbac199c0a$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $3c6db1bbac199c0a$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $3c6db1bbac199c0a$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $ec8f35f0c0eb0367$export$1df9218a526d318d extends (0, $ab85251a76e5b699$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1096ce969d0ca021$export$8ad33f488b1ab046)();
        (0, $7869509ac5668368$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document) (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $5cbed19a88ad1020$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $5cbed19a88ad1020$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $3c6db1bbac199c0a$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $8cfab509699cb710$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9781e7c2fbdbcc85$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $29baa297628f40c4$var$WINDOW = (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1);
const $29baa297628f40c4$var$DEBOUNCE_DURATION = 1000;
let $29baa297628f40c4$var$debounceTimerID;
let $29baa297628f40c4$var$lastCapturedEventType;
let $29baa297628f40c4$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $29baa297628f40c4$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $29baa297628f40c4$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $29baa297628f40c4$export$3014bbf0af0e1d4a() {
    if (!$29baa297628f40c4$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $6d0c47d1c5cefe70$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $29baa297628f40c4$var$makeDOMEventHandler(triggerDOMHandler, true);
    $29baa297628f40c4$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $29baa297628f40c4$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $29baa297628f40c4$var$WINDOW[target] && $29baa297628f40c4$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $971efa3a19c35af1$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $29baa297628f40c4$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $971efa3a19c35af1$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $29baa297628f40c4$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $29baa297628f40c4$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $29baa297628f40c4$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $29baa297628f40c4$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $29baa297628f40c4$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $29baa297628f40c4$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($29baa297628f40c4$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $971efa3a19c35af1$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $971efa3a19c35af1$export$e73679ffaf56810e)(target, "_sentryId", (0, $585c5f81398b071f$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$29baa297628f40c4$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $29baa297628f40c4$var$lastCapturedEventType = event.type;
            $29baa297628f40c4$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($29baa297628f40c4$var$debounceTimerID);
        $29baa297628f40c4$var$debounceTimerID = $29baa297628f40c4$var$WINDOW.setTimeout(()=>{
            $29baa297628f40c4$var$lastCapturedEventTargetId = undefined;
            $29baa297628f40c4$var$lastCapturedEventType = undefined;
        }, $29baa297628f40c4$var$DEBOUNCE_DURATION);
    };
}
function $29baa297628f40c4$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $fdcf3bcb93747f4c$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $6d0c47d1c5cefe70$export$a4e09611e30da72e)(type, handler);
    (0, $6d0c47d1c5cefe70$export$e18d6c5462c01368)(type, $fdcf3bcb93747f4c$var$instrumentConsole);
}
function $fdcf3bcb93747f4c$var$instrumentConsole() {
    if (!("console" in (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1))) return;
    (0, $f380c6c63e13cddf$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).console)) return;
        (0, $971efa3a19c35af1$export$9563e054e6f787fb)((0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $f380c6c63e13cddf$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $6d0c47d1c5cefe70$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $f380c6c63e13cddf$export$77c4ce905194557b)[level];
                log && log.apply((0, $444c9e424d20ca0b$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $0a58bd69353784ff$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $0a58bd69353784ff$export$e01cef29b4327697(level) {
    return $0a58bd69353784ff$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $0a58bd69353784ff$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $0a58bd69353784ff$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $95bb693e2196218f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $95bb693e2196218f$var$INTEGRATION_NAME = "Breadcrumbs";
const $95bb693e2196218f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $95bb693e2196218f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $fdcf3bcb93747f4c$export$1d6e0d073f9e6723)($95bb693e2196218f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $29baa297628f40c4$export$5aeffd3db2cf9df7)($95bb693e2196218f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $54d1953ab2b6fc81$export$26ace48dd54c9aea)($95bb693e2196218f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $4a65b18730c1a634$export$f75d3c772c923df0)($95bb693e2196218f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $08836e65fa97523f$export$3f18c56c58114e75)($95bb693e2196218f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $95bb693e2196218f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $95bb693e2196218f$export$c079d904b326663a = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($95bb693e2196218f$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $95bb693e2196218f$export$2dc68d50d56fbbd = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($95bb693e2196218f$var$INTEGRATION_NAME, $95bb693e2196218f$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $95bb693e2196218f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client) return;
        (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $585c5f81398b071f$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $95bb693e2196218f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $95bb693e2196218f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$95bb693e2196218f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$95bb693e2196218f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $95bb693e2196218f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $95bb693e2196218f$var$_isEvent(event) ? event.target : event;
            target = (0, $cc2b0812a7e75fd4$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cc2b0812a7e75fd4$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $95bb693e2196218f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $0a58bd69353784ff$export$d771ef054122c30a)(handlerData.level),
            message: (0, $5ba26d97ad14420c$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $5ba26d97ad14420c$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $95bb693e2196218f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $54d1953ab2b6fc81$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $95bb693e2196218f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $95bb693e2196218f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $0f9bb201bd5c10af$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $ff70bab8e0f5d056$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $95bb693e2196218f$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $bcd9adea2faaaf26$var$INTEGRATION_NAME = "Dedupe";
const $bcd9adea2faaaf26$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $bcd9adea2faaaf26$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($bcd9adea2faaaf26$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $bcd9adea2faaaf26$export$6d39aa44cd0c7567 = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($bcd9adea2faaaf26$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $bcd9adea2faaaf26$export$688d98c249d31ad3 = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($bcd9adea2faaaf26$var$INTEGRATION_NAME, $bcd9adea2faaaf26$export$6d39aa44cd0c7567);
function $bcd9adea2faaaf26$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($bcd9adea2faaaf26$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($bcd9adea2faaaf26$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $bcd9adea2faaaf26$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$bcd9adea2faaaf26$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$bcd9adea2faaaf26$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $bcd9adea2faaaf26$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $bcd9adea2faaaf26$var$_getExceptionFromEvent(previousEvent);
    const currentException = $bcd9adea2faaaf26$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$bcd9adea2faaaf26$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$bcd9adea2faaaf26$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $bcd9adea2faaaf26$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $bcd9adea2faaaf26$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $bcd9adea2faaaf26$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $bcd9adea2faaaf26$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $bcd9adea2faaaf26$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $bcd9adea2faaaf26$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $828815bb722390c2$var$INTEGRATION_NAME = "GlobalHandlers";
const $828815bb722390c2$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $828815bb722390c2$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $828815bb722390c2$var$_installGlobalOnErrorHandler(client);
                $828815bb722390c2$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $828815bb722390c2$var$_installGlobalOnUnhandledRejectionHandler(client);
                $828815bb722390c2$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $828815bb722390c2$export$66acc70e8cf2b71a = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($828815bb722390c2$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $828815bb722390c2$export$204155decbc90e5a = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($828815bb722390c2$var$INTEGRATION_NAME, $828815bb722390c2$export$66acc70e8cf2b71a);
function $828815bb722390c2$var$_installGlobalOnErrorHandler(client) {
    (0, $63059ef1c9d55f9f$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $828815bb722390c2$var$getOptions();
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client || (0, $b5b9a5d09d13b5e5$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $6eb20d3436b639ce$export$844ec244b1367d54)(msg) ? $828815bb722390c2$var$_eventFromIncompleteOnError(msg, url, line, column) : $828815bb722390c2$var$_enhanceEventWithInitialFrame((0, $5cbed19a88ad1020$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $ff70bab8e0f5d056$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $828815bb722390c2$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $3e6eadf97f6fe5e1$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $828815bb722390c2$var$getOptions();
        if ((0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)() !== client || (0, $b5b9a5d09d13b5e5$export$b79738ab10c590b2)()) return;
        const error = $828815bb722390c2$var$_getUnhandledRejectionError(e);
        const event = (0, $6eb20d3436b639ce$export$c3825b437cbdea5c)(error) ? $828815bb722390c2$var$_eventFromRejectionWithPrimitive(error) : (0, $5cbed19a88ad1020$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $ff70bab8e0f5d056$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $828815bb722390c2$var$_getUnhandledRejectionError(error) {
    if ((0, $6eb20d3436b639ce$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $828815bb722390c2$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $828815bb722390c2$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $6eb20d3436b639ce$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $828815bb722390c2$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $828815bb722390c2$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $6eb20d3436b639ce$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $cc2b0812a7e75fd4$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $828815bb722390c2$var$globalHandlerLog(type) {
    (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $828815bb722390c2$var$getOptions() {
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $ff01c13bdef1bcb2$var$INTEGRATION_NAME = "HttpContext";
const $ff01c13bdef1bcb2$var$_httpContextIntegration = ()=>{
    return {
        name: $ff01c13bdef1bcb2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).navigator && !(0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location && !(0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $ff01c13bdef1bcb2$export$1378794447170364 = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($ff01c13bdef1bcb2$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ff01c13bdef1bcb2$export$5d2ee9a544b09a94 = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($ff01c13bdef1bcb2$var$INTEGRATION_NAME, $ff01c13bdef1bcb2$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $9c54c8c19f94961e$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $6eb20d3436b639ce$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $9c54c8c19f94961e$var$truncateAggregateExceptions($9c54c8c19f94961e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $9c54c8c19f94961e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $6eb20d3436b639ce$export$49034edbe6b62415)(error[key], Error)) {
        $9c54c8c19f94961e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $9c54c8c19f94961e$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $9c54c8c19f94961e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $6eb20d3436b639ce$export$49034edbe6b62415)(childError, Error)) {
            $9c54c8c19f94961e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $9c54c8c19f94961e$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $9c54c8c19f94961e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $9c54c8c19f94961e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $9c54c8c19f94961e$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $9c54c8c19f94961e$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $5ba26d97ad14420c$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $5d94adc61bdf9124$var$DEFAULT_KEY = "cause";
const $5d94adc61bdf9124$var$DEFAULT_LIMIT = 5;
const $5d94adc61bdf9124$var$INTEGRATION_NAME = "LinkedErrors";
const $5d94adc61bdf9124$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $5d94adc61bdf9124$var$DEFAULT_LIMIT;
    const key = options.key || $5d94adc61bdf9124$var$DEFAULT_KEY;
    return {
        name: $5d94adc61bdf9124$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9c54c8c19f94961e$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $5cbed19a88ad1020$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $5d94adc61bdf9124$export$ebabb00eb7f3a395 = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($5d94adc61bdf9124$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5d94adc61bdf9124$export$8d1e60aaf616fb4f = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($5d94adc61bdf9124$var$INTEGRATION_NAME, $5d94adc61bdf9124$export$ebabb00eb7f3a395);





const $4df485d8b36b7c23$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $4df485d8b36b7c23$var$INTEGRATION_NAME = "TryCatch";
const $4df485d8b36b7c23$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4df485d8b36b7c23$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $971efa3a19c35af1$export$9563e054e6f787fb)((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81), "setTimeout", $4df485d8b36b7c23$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $971efa3a19c35af1$export$9563e054e6f787fb)((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81), "setInterval", $4df485d8b36b7c23$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $971efa3a19c35af1$export$9563e054e6f787fb)((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81), "requestAnimationFrame", $4df485d8b36b7c23$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81)) (0, $971efa3a19c35af1$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $4df485d8b36b7c23$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4df485d8b36b7c23$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4df485d8b36b7c23$var$_wrapEventTarget);
            }
        }
    };
};
const $4df485d8b36b7c23$export$59bfe9f1c76150e = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($4df485d8b36b7c23$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4df485d8b36b7c23$export$f1a018517668e6d3 = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($4df485d8b36b7c23$var$INTEGRATION_NAME, $4df485d8b36b7c23$export$59bfe9f1c76150e);
function $4df485d8b36b7c23$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $b5b9a5d09d13b5e5$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $3922f028d1f0b5d7$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4df485d8b36b7c23$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $b5b9a5d09d13b5e5$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $3922f028d1f0b5d7$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $4df485d8b36b7c23$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $971efa3a19c35af1$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $3922f028d1f0b5d7$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $971efa3a19c35af1$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $3922f028d1f0b5d7$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $b5b9a5d09d13b5e5$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4df485d8b36b7c23$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $b5b9a5d09d13b5e5$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $3922f028d1f0b5d7$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $b5b9a5d09d13b5e5$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $3922f028d1f0b5d7$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $971efa3a19c35af1$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $75848c54fe5d29f5$var$UNKNOWN_FUNCTION = "?";
const $75848c54fe5d29f5$var$OPERA10_PRIORITY = 10;
const $75848c54fe5d29f5$var$OPERA11_PRIORITY = 20;
const $75848c54fe5d29f5$var$CHROME_PRIORITY = 30;
const $75848c54fe5d29f5$var$WINJS_PRIORITY = 40;
const $75848c54fe5d29f5$var$GECKO_PRIORITY = 50;
function $75848c54fe5d29f5$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $75848c54fe5d29f5$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $75848c54fe5d29f5$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $75848c54fe5d29f5$var$chromeStackParserFn = (line)=>{
    const parts = $75848c54fe5d29f5$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $75848c54fe5d29f5$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $75848c54fe5d29f5$var$extractSafariExtensionDetails(parts[1] || $75848c54fe5d29f5$var$UNKNOWN_FUNCTION, parts[2]);
        return $75848c54fe5d29f5$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $75848c54fe5d29f5$export$263a749fff749872 = [
    $75848c54fe5d29f5$var$CHROME_PRIORITY,
    $75848c54fe5d29f5$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $75848c54fe5d29f5$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $75848c54fe5d29f5$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $75848c54fe5d29f5$var$gecko = (line)=>{
    const parts = $75848c54fe5d29f5$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $75848c54fe5d29f5$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $75848c54fe5d29f5$var$UNKNOWN_FUNCTION;
        [func, filename] = $75848c54fe5d29f5$var$extractSafariExtensionDetails(func, filename);
        return $75848c54fe5d29f5$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $75848c54fe5d29f5$export$cdba47a5dd2804d = [
    $75848c54fe5d29f5$var$GECKO_PRIORITY,
    $75848c54fe5d29f5$var$gecko
];
const $75848c54fe5d29f5$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $75848c54fe5d29f5$var$winjs = (line)=>{
    const parts = $75848c54fe5d29f5$var$winjsRegex.exec(line);
    return parts ? $75848c54fe5d29f5$var$createFrame(parts[2], parts[1] || $75848c54fe5d29f5$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $75848c54fe5d29f5$export$179460296da408e8 = [
    $75848c54fe5d29f5$var$WINJS_PRIORITY,
    $75848c54fe5d29f5$var$winjs
];
const $75848c54fe5d29f5$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $75848c54fe5d29f5$var$opera10 = (line)=>{
    const parts = $75848c54fe5d29f5$var$opera10Regex.exec(line);
    return parts ? $75848c54fe5d29f5$var$createFrame(parts[2], parts[3] || $75848c54fe5d29f5$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $75848c54fe5d29f5$export$f892b52c880ffc7a = [
    $75848c54fe5d29f5$var$OPERA10_PRIORITY,
    $75848c54fe5d29f5$var$opera10
];
const $75848c54fe5d29f5$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $75848c54fe5d29f5$var$opera11 = (line)=>{
    const parts = $75848c54fe5d29f5$var$opera11Regex.exec(line);
    return parts ? $75848c54fe5d29f5$var$createFrame(parts[5], parts[3] || parts[4] || $75848c54fe5d29f5$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $75848c54fe5d29f5$export$af11af13f09fb0dc = [
    $75848c54fe5d29f5$var$OPERA11_PRIORITY,
    $75848c54fe5d29f5$var$opera11
];
const $75848c54fe5d29f5$export$7197c0fe6554c079 = [
    $75848c54fe5d29f5$export$263a749fff749872,
    $75848c54fe5d29f5$export$cdba47a5dd2804d,
    $75848c54fe5d29f5$export$179460296da408e8
];
const $75848c54fe5d29f5$export$2b2b997d81bf3907 = (0, $3922f028d1f0b5d7$export$a5739666fb2d03d4)(...$75848c54fe5d29f5$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $75848c54fe5d29f5$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $75848c54fe5d29f5$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5c0ae87d45c575be$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5c0ae87d45c575be$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5c0ae87d45c575be$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5c0ae87d45c575be$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5c0ae87d45c575be$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5c0ae87d45c575be$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5c0ae87d45c575be$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5c0ae87d45c575be$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $316167c12a31349a$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $0c4a60aa51d054a5$export$78e43115b553f358)(new (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $0c4a60aa51d054a5$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $0c4a60aa51d054a5$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $2661f68912b032bf$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $2661f68912b032bf$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $316167c12a31349a$export$85a4f67f852183e6)(options.bufferSize || $2661f68912b032bf$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $dfe4042267fdebb0$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $dfe4042267fdebb0$export$b11169581eeaf237)(type);
            if ((0, $5c0ae87d45c575be$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $2661f68912b032bf$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $0c4a60aa51d054a5$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $dfe4042267fdebb0$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $dfe4042267fdebb0$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $2661f68912b032bf$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $dfe4042267fdebb0$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $dfe4042267fdebb0$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5c0ae87d45c575be$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $3b7efdf8c0aa2a21$export$5949942ba2a7c0e2)) {
                (0, $f12abffb275f404d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $0c4a60aa51d054a5$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $2661f68912b032bf$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $f7663dc099187bf9$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $f7663dc099187bf9$export$8be2119ce08e3379() {
    if ($f7663dc099187bf9$var$cachedFetchImpl) return $f7663dc099187bf9$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $d438491a2227c0aa$export$18cf36ed71d733e7)((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).fetch)) return $f7663dc099187bf9$var$cachedFetchImpl = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).fetch.bind((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81));
    const document = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $f7663dc099187bf9$var$cachedFetchImpl = fetchImpl.bind((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $f7663dc099187bf9$export$d499686d2dd738c6() {
    $f7663dc099187bf9$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9740da337c30b19a$export$b2311068c46d7cc8(options, nativeFetch = (0, $f7663dc099187bf9$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $f7663dc099187bf9$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $0c4a60aa51d054a5$export$78e43115b553f358)(e);
        }
    }
    return (0, $2661f68912b032bf$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $260a24f9165774b5$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $260a24f9165774b5$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $0c4a60aa51d054a5$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $260a24f9165774b5$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $2661f68912b032bf$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $28025e50b43f88bb$export$5ef831fccfce35e5 = [
    (0, $17dfacf866495c76$export$cb3c5c2ceb9818ba)(),
    (0, $102f14e235f86122$export$7918117e9202e4fb)(),
    (0, $4df485d8b36b7c23$export$59bfe9f1c76150e)(),
    (0, $95bb693e2196218f$export$c079d904b326663a)(),
    (0, $828815bb722390c2$export$66acc70e8cf2b71a)(),
    (0, $5d94adc61bdf9124$export$ebabb00eb7f3a395)(),
    (0, $bcd9adea2faaaf26$export$6d39aa44cd0c7567)(),
    (0, $ff01c13bdef1bcb2$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $28025e50b43f88bb$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$28025e50b43f88bb$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $28025e50b43f88bb$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $28025e50b43f88bb$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $3922f028d1f0b5d7$export$1d5cf88b347146d4)(options.stackParser || (0, $75848c54fe5d29f5$export$2b2b997d81bf3907)),
        integrations: (0, $2c2fa06c877a3c5f$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $d438491a2227c0aa$export$edf3cb81fd7d2a3e)() ? (0, $9740da337c30b19a$export$b2311068c46d7cc8) : (0, $260a24f9165774b5$export$5e1441cee30d5a39))
    };
    (0, $80d9fdf3b6d6ac84$export$5333c3f1c58d9bc1)((0, $ec8f35f0c0eb0367$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $28025e50b43f88bb$var$startSessionTracking();
}
const $28025e50b43f88bb$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document) {
        (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $a02f70b1fa9c1e2b$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document.head || (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $28025e50b43f88bb$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $28025e50b43f88bb$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28025e50b43f88bb$export$4997ffc0176396a6(fn) {
    return (0, $b5b9a5d09d13b5e5$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $28025e50b43f88bb$var$startSessionTracking() {
    if (typeof (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $d09a34927a3f376d$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $ff70bab8e0f5d056$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $ff70bab8e0f5d056$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $08836e65fa97523f$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $ff70bab8e0f5d056$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $ff70bab8e0f5d056$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $28025e50b43f88bb$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $9b36b65c9ab22250$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $7869509ac5668368$export$b9f95b027256052c)(opts, "react");
    (0, $28025e50b43f88bb$export$2cd8252107eb640b)(opts);
}









const $2e5947a0c145f418$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $2e5947a0c145f418$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $3f87ac44abd54a5b$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $45035e12b9b3ee66$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $2e5947a0c145f418$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $56c0fba3df7b578a$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $08bda2861f6e5e94$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$2e5947a0c145f418$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $70e7a953caa0e8f5$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $70e7a953caa0e8f5$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $70e7a953caa0e8f5$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $70e7a953caa0e8f5$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $2e5947a0c145f418$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $2e5947a0c145f418$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $4058f4d819de4cf1$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $aed9529decbb5187$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $08bda2861f6e5e94$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) {
            (0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $70e7a953caa0e8f5$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $2e5947a0c145f418$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $56c0fba3df7b578a$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $629ef6feba2990f3$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $629ef6feba2990f3$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $1c69755c87707ddf$export$baf075a948ffc0bf) ? (0, $1c69755c87707ddf$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: "url"
                    }
                };
                $2e5947a0c145f418$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location) (0, $08836e65fa97523f$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $aed9529decbb5187$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $2e5947a0c145f418$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $b1e97925e6c64aa9$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $2e5947a0c145f418$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $2e5947a0c145f418$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $45035e12b9b3ee66$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $2e5947a0c145f418$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $ef2f9c97cfc00acf$export$1be426a8e585c83e)();
    const op = span && (0, $629ef6feba2990f3$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $2e5947a0c145f418$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $ef2f9c97cfc00acf$export$1be426a8e585c83e)();
    const op = span && (0, $629ef6feba2990f3$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $2e5947a0c145f418$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $cc2b0812a7e75fd4$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $2e5947a0c145f418$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $56c0fba3df7b578a$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $aed9529decbb5187$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: latestRoute.context ? $2e5947a0c145f418$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $08bda2861f6e5e94$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $6a55bc962b8f461d$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, $aed9529decbb5187$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $2e5947a0c145f418$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $2e5947a0c145f418$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $2e5947a0c145f418$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $ff70bab8e0f5d056$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $7afb9fcab45a7ce0$export$a7feb32fdd923295)();
        const currentScope = (0, $ff70bab8e0f5d056$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($2e5947a0c145f418$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $2e5947a0c145f418$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $2e5947a0c145f418$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("event", handleEntries);
    (0, $a13a50f36d91fa48$export$69816c1a049f8db6)("first-input", handleEntries);
}
function $2e5947a0c145f418$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $34e240d20f3b495d$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $34e240d20f3b495d$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}













































var $4dee7ebe5acc1414$exports = {};

$parcel$export($4dee7ebe5acc1414$exports, "FunctionToString", function () { return $102f14e235f86122$export$da4704525c20ae79; });
$parcel$export($4dee7ebe5acc1414$exports, "InboundFilters", function () { return $17dfacf866495c76$export$2ffbb5359dcc6be4; });
$parcel$export($4dee7ebe5acc1414$exports, "LinkedErrors", function () { return $bd08397abd59fa5e$export$8d1e60aaf616fb4f; });






/**
 * Extracts stack frames from the error.stack string
 */ function $b365f6fdcacf2547$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $b365f6fdcacf2547$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $b365f6fdcacf2547$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $b365f6fdcacf2547$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $971efa3a19c35af1$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $b365f6fdcacf2547$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $6eb20d3436b639ce$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $6eb20d3436b639ce$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $945327a834d3a1ba$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $b365f6fdcacf2547$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $b365f6fdcacf2547$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $585c5f81398b071f$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $585c5f81398b071f$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $b365f6fdcacf2547$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $b365f6fdcacf2547$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $6eb20d3436b639ce$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $bd08397abd59fa5e$var$DEFAULT_KEY = "cause";
const $bd08397abd59fa5e$var$DEFAULT_LIMIT = 5;
const $bd08397abd59fa5e$var$INTEGRATION_NAME = "LinkedErrors";
const $bd08397abd59fa5e$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $bd08397abd59fa5e$var$DEFAULT_LIMIT;
    const key = options.key || $bd08397abd59fa5e$var$DEFAULT_KEY;
    return {
        name: $bd08397abd59fa5e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9c54c8c19f94961e$export$b91c38ed7d8ae9b2)((0, $b365f6fdcacf2547$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $bd08397abd59fa5e$export$ebabb00eb7f3a395 = (0, $2c2fa06c877a3c5f$export$2323046b9414659f)($bd08397abd59fa5e$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $bd08397abd59fa5e$export$8d1e60aaf616fb4f = (0, $2c2fa06c877a3c5f$export$afa219bf23651160)($bd08397abd59fa5e$var$INTEGRATION_NAME, $bd08397abd59fa5e$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $04bfafdab16651c3$export$99d02219d259eb94 = $4dee7ebe5acc1414$exports;
















var $37be790949261384$exports = {};

$parcel$export($37be790949261384$exports, "GlobalHandlers", function () { return $828815bb722390c2$export$204155decbc90e5a; });
$parcel$export($37be790949261384$exports, "TryCatch", function () { return $4df485d8b36b7c23$export$f1a018517668e6d3; });
$parcel$export($37be790949261384$exports, "Breadcrumbs", function () { return $95bb693e2196218f$export$2dc68d50d56fbbd; });
$parcel$export($37be790949261384$exports, "LinkedErrors", function () { return $5d94adc61bdf9124$export$8d1e60aaf616fb4f; });
$parcel$export($37be790949261384$exports, "HttpContext", function () { return $ff01c13bdef1bcb2$export$5d2ee9a544b09a94; });
$parcel$export($37be790949261384$exports, "Dedupe", function () { return $bcd9adea2faaaf26$export$688d98c249d31ad3; });






 /* eslint-disable deprecation/deprecation */ 









let $99a1ca1dc36bbd23$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).Sentry && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).Sentry.Integrations) $99a1ca1dc36bbd23$var$windowIntegrations = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $99a1ca1dc36bbd23$export$99d02219d259eb94 = {
    ...$99a1ca1dc36bbd23$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $04bfafdab16651c3$export$99d02219d259eb94),
    ...$37be790949261384$exports
};





var $d6J3N = parcelRequire("d6J3N");

var $f2Y41 = parcelRequire("f2Y41");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $579d7a1f169a434f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $f7d2f1a319d5028e$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $f7d2f1a319d5028e$var$activeTransaction;
let $f7d2f1a319d5028e$var$_useEffect;
let $f7d2f1a319d5028e$var$_useLocation;
let $f7d2f1a319d5028e$var$_useNavigationType;
let $f7d2f1a319d5028e$var$_createRoutesFromChildren;
let $f7d2f1a319d5028e$var$_matchRoutes;
let $f7d2f1a319d5028e$var$_customStartTransaction;
let $f7d2f1a319d5028e$var$_startTransactionOnLocationChange;
let $f7d2f1a319d5028e$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $f7d2f1a319d5028e$export$47113a480541ff59(options) {
    const integration = (0, $2e5947a0c145f418$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $2e5947a0c145f418$export$7d159749bd9969ad)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81) && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $2e5947a0c145f418$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: "url",
                    [(0, $34e240d20f3b495d$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $34e240d20f3b495d$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $f7d2f1a319d5028e$var$_useEffect = useEffect;
            $f7d2f1a319d5028e$var$_useLocation = useLocation;
            $f7d2f1a319d5028e$var$_useNavigationType = useNavigationType;
            $f7d2f1a319d5028e$var$_matchRoutes = matchRoutes;
            $f7d2f1a319d5028e$var$_createRoutesFromChildren = createRoutesFromChildren;
            $f7d2f1a319d5028e$var$_stripBasename = stripBasename || false;
            $f7d2f1a319d5028e$var$_customStartTransaction = startNavigationCallback;
            $f7d2f1a319d5028e$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $f7d2f1a319d5028e$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81) && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location && (0, $b5b9a5d09d13b5e5$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $f7d2f1a319d5028e$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: "url",
                [(0, $34e240d20f3b495d$export$1a413bd9a88fdb09)]: "pageload",
                [(0, $34e240d20f3b495d$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $f7d2f1a319d5028e$var$_useEffect = useEffect;
        $f7d2f1a319d5028e$var$_useLocation = useLocation;
        $f7d2f1a319d5028e$var$_useNavigationType = useNavigationType;
        $f7d2f1a319d5028e$var$_matchRoutes = matchRoutes;
        $f7d2f1a319d5028e$var$_createRoutesFromChildren = createRoutesFromChildren;
        $f7d2f1a319d5028e$var$_stripBasename = stripBasename || false;
        $f7d2f1a319d5028e$var$_customStartTransaction = customStartTransaction;
        $f7d2f1a319d5028e$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $f7d2f1a319d5028e$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $f7d2f1a319d5028e$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $f7d2f1a319d5028e$var$_stripBasename ? $f7d2f1a319d5028e$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $f7d2f1a319d5028e$var$_stripBasename ? $f7d2f1a319d5028e$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $0f9bb201bd5c10af$export$69dd85280a8d374c)(pathBuilder) !== (0, $0f9bb201bd5c10af$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($f7d2f1a319d5028e$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($f7d2f1a319d5028e$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $f7d2f1a319d5028e$var$_stripBasename ? $f7d2f1a319d5028e$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $f7d2f1a319d5028e$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $f7d2f1a319d5028e$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $f7d2f1a319d5028e$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $34e240d20f3b495d$export$d7a7d984b0791405), source);
    }
}
function $f7d2f1a319d5028e$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $f7d2f1a319d5028e$var$_matchRoutes(routes, location, basename);
    if ($f7d2f1a319d5028e$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($f7d2f1a319d5028e$var$activeTransaction) $f7d2f1a319d5028e$var$activeTransaction.end();
        const [name, source] = $f7d2f1a319d5028e$var$getNormalizedName(routes, location, branches, basename);
        $f7d2f1a319d5028e$var$activeTransaction = $f7d2f1a319d5028e$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $34e240d20f3b495d$export$d7a7d984b0791405)]: source,
                [(0, $34e240d20f3b495d$export$1a413bd9a88fdb09)]: "navigation",
                [(0, $34e240d20f3b495d$export$cca8dd30f57f805e)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7d2f1a319d5028e$export$c6111e8561a02a8b(Routes) {
    if (!$f7d2f1a319d5028e$var$_useEffect || !$f7d2f1a319d5028e$var$_useLocation || !$f7d2f1a319d5028e$var$_useNavigationType || !$f7d2f1a319d5028e$var$_createRoutesFromChildren || !$f7d2f1a319d5028e$var$_matchRoutes || !$f7d2f1a319d5028e$var$_customStartTransaction) {
        (0, $579d7a1f169a434f$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$f7d2f1a319d5028e$var$_useEffect}. useLocation: ${$f7d2f1a319d5028e$var$_useLocation}. useNavigationType: ${$f7d2f1a319d5028e$var$_useNavigationType}.
      createRoutesFromChildren: ${$f7d2f1a319d5028e$var$_createRoutesFromChildren}. matchRoutes: ${$f7d2f1a319d5028e$var$_matchRoutes}. customStartTransaction: ${$f7d2f1a319d5028e$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $f7d2f1a319d5028e$var$_useLocation();
        const navigationType = $f7d2f1a319d5028e$var$_useNavigationType();
        $f7d2f1a319d5028e$var$_useEffect(()=>{
            const routes = $f7d2f1a319d5028e$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $f7d2f1a319d5028e$var$updatePageloadTransaction($f7d2f1a319d5028e$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $f7d2f1a319d5028e$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $f2Y41.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $f7d2f1a319d5028e$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($d6J3N)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $f7d2f1a319d5028e$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$f7d2f1a319d5028e$var$_useEffect || !$f7d2f1a319d5028e$var$_useLocation || !$f7d2f1a319d5028e$var$_useNavigationType || !$f7d2f1a319d5028e$var$_matchRoutes || !$f7d2f1a319d5028e$var$_customStartTransaction) {
        (0, $579d7a1f169a434f$export$16a28057038b10ef) && (0, $f380c6c63e13cddf$export$af88d00dbe7f521).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $f7d2f1a319d5028e$var$_useLocation();
        const navigationType = $f7d2f1a319d5028e$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $f7d2f1a319d5028e$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $f7d2f1a319d5028e$var$updatePageloadTransaction($f7d2f1a319d5028e$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $f7d2f1a319d5028e$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $f2Y41.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $f7d2f1a319d5028e$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $f7d2f1a319d5028e$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $f7d2f1a319d5028e$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $f7d2f1a319d5028e$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($f7d2f1a319d5028e$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $f7d2f1a319d5028e$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $f7d2f1a319d5028e$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($f7d2f1a319d5028e$var$activeTransaction) return $f7d2f1a319d5028e$var$activeTransaction;
    const span = (0, $ef2f9c97cfc00acf$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $fbca0cda9bc299c1$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $629ef6feba2990f3$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}


// TYPES
// UTILS
const $cc3bb96fe5c1fe35$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $cc3bb96fe5c1fe35$export$8793edee2d425525() {
    return undefined;
}
function $cc3bb96fe5c1fe35$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $cc3bb96fe5c1fe35$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $cc3bb96fe5c1fe35$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $cc3bb96fe5c1fe35$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $cc3bb96fe5c1fe35$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $cc3bb96fe5c1fe35$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$cc3bb96fe5c1fe35$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $cc3bb96fe5c1fe35$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($cc3bb96fe5c1fe35$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $cc3bb96fe5c1fe35$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $cc3bb96fe5c1fe35$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $cc3bb96fe5c1fe35$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $cc3bb96fe5c1fe35$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $cc3bb96fe5c1fe35$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($cc3bb96fe5c1fe35$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $cc3bb96fe5c1fe35$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$cc3bb96fe5c1fe35$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $cc3bb96fe5c1fe35$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($cc3bb96fe5c1fe35$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($cc3bb96fe5c1fe35$export$5fcb678681417b54(mutation.options.mutationKey) !== $cc3bb96fe5c1fe35$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$cc3bb96fe5c1fe35$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $cc3bb96fe5c1fe35$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $cc3bb96fe5c1fe35$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $cc3bb96fe5c1fe35$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$cc3bb96fe5c1fe35$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $cc3bb96fe5c1fe35$export$2f07189bb9fa26a7(a, b) {
    return $cc3bb96fe5c1fe35$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $cc3bb96fe5c1fe35$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$cc3bb96fe5c1fe35$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $cc3bb96fe5c1fe35$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $cc3bb96fe5c1fe35$export$7a8558113332b71e(a) && $cc3bb96fe5c1fe35$export$7a8558113332b71e(b);
    if (array || $cc3bb96fe5c1fe35$export$53b83ca8eaab0383(a) && $cc3bb96fe5c1fe35$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $cc3bb96fe5c1fe35$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $cc3bb96fe5c1fe35$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $cc3bb96fe5c1fe35$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $cc3bb96fe5c1fe35$export$53b83ca8eaab0383(o) {
    if (!$cc3bb96fe5c1fe35$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$cc3bb96fe5c1fe35$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $cc3bb96fe5c1fe35$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $cc3bb96fe5c1fe35$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $cc3bb96fe5c1fe35$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $cc3bb96fe5c1fe35$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $cc3bb96fe5c1fe35$export$4304cb76768ca134(callback) {
    $cc3bb96fe5c1fe35$export$e772c8ff12451969(0).then(callback);
}
function $cc3bb96fe5c1fe35$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $cc3bb96fe5c1fe35$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $cc3bb96fe5c1fe35$export$77a71fc411098696(prevData, data);
    return data;
}




const $e3a8e70aadc15658$export$1cf3d545f2d4635c = console;



function $7141903f22b57d82$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $cc3bb96fe5c1fe35$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $cc3bb96fe5c1fe35$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $7141903f22b57d82$export$520687f44db6e1ab = $7141903f22b57d82$export$316a8efd03cd1458();


class $b5fde98bda829a05$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $2635e9a022b2e9a8$export$86f1af424b2ca4de extends (0, $b5fde98bda829a05$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $cc3bb96fe5c1fe35$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $2635e9a022b2e9a8$export$6bf54661be5b02cf = new $2635e9a022b2e9a8$export$86f1af424b2ca4de();




const $03f3c720401810f3$var$onlineEvents = [
    "online",
    "offline"
];
class $03f3c720401810f3$export$58774fb55d5ff7fc extends (0, $b5fde98bda829a05$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $cc3bb96fe5c1fe35$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $03f3c720401810f3$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $03f3c720401810f3$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $03f3c720401810f3$export$b113e788b2dd3fdc = new $03f3c720401810f3$export$58774fb55d5ff7fc();



function $d8f0e796caac6481$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $d8f0e796caac6481$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $03f3c720401810f3$export$b113e788b2dd3fdc).isOnline() : true;
}
class $d8f0e796caac6481$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $d8f0e796caac6481$export$986cc6445c1d323(value) {
    return value instanceof $d8f0e796caac6481$export$a8430ed4188f35a9;
}
function $d8f0e796caac6481$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $d8f0e796caac6481$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $2635e9a022b2e9a8$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $03f3c720401810f3$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $d8f0e796caac6481$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $cc3bb96fe5c1fe35$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($d8f0e796caac6481$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}



class $7d6c6e93dceb0227$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $cc3bb96fe5c1fe35$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $cc3bb96fe5c1fe35$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $bc40c4af855e53c4$export$62297b13309008b2 extends (0, $7d6c6e93dceb0227$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $e3a8e70aadc15658$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $bc40c4af855e53c4$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $cc3bb96fe5c1fe35$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $cc3bb96fe5c1fe35$export$8793edee2d425525)).catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $cc3bb96fe5c1fe35$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $cc3bb96fe5c1fe35$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $d8f0e796caac6481$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $d8f0e796caac6481$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $d8f0e796caac6481$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $d8f0e796caac6481$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $d8f0e796caac6481$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $bc40c4af855e53c4$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}




// CLASS
class $7eff32c8357eedd0$export$5dde0cd941da8468 extends (0, $b5fde98bda829a05$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $cc3bb96fe5c1fe35$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $bc40c4af855e53c4$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $cc3bb96fe5c1fe35$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $cc3bb96fe5c1fe35$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}







// CLASS
class $5e5cb0f9cd7047cf$export$17b8b19c814bcf56 extends (0, $7d6c6e93dceb0227$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $e3a8e70aadc15658$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $5e5cb0f9cd7047cf$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $d8f0e796caac6481$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $d8f0e796caac6481$export$61b92f63f30245cf)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $5e5cb0f9cd7047cf$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}




// CLASS
class $2c1408ae039c3c1d$export$1fcfd9a244434844 extends (0, $b5fde98bda829a05$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $5e5cb0f9cd7047cf$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $cc3bb96fe5c1fe35$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $cc3bb96fe5c1fe35$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $2ae52427c7915063$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $2ae52427c7915063$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $2ae52427c7915063$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $2ae52427c7915063$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $2ae52427c7915063$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $2ae52427c7915063$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $2ae52427c7915063$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $2ae52427c7915063$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $2ae52427c7915063$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $2ae52427c7915063$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $1feca0faf99b89fc$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $7eff32c8357eedd0$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $2c1408ae039c3c1d$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $e3a8e70aadc15658$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $2635e9a022b2e9a8$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $2635e9a022b2e9a8$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $03f3c720401810f3$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $03f3c720401810f3$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $cc3bb96fe5c1fe35$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $cc3bb96fe5c1fe35$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $cc3bb96fe5c1fe35$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $cc3bb96fe5c1fe35$export$8793edee2d425525)).catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $cc3bb96fe5c1fe35$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $cc3bb96fe5c1fe35$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $cc3bb96fe5c1fe35$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $cc3bb96fe5c1fe35$export$8793edee2d425525)).catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $cc3bb96fe5c1fe35$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $2ae52427c7915063$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $cc3bb96fe5c1fe35$export$8793edee2d425525)).catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $cc3bb96fe5c1fe35$export$5fcb678681417b54)(queryKey) === (0, $cc3bb96fe5c1fe35$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $cc3bb96fe5c1fe35$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $cc3bb96fe5c1fe35$export$5fcb678681417b54)(mutationKey) === (0, $cc3bb96fe5c1fe35$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $cc3bb96fe5c1fe35$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $cc3bb96fe5c1fe35$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $f2Y41 = parcelRequire("f2Y41");
"use client";
const $935108cabed32909$export$2fba198b5b2e37fa = /*#__PURE__*/ $f2Y41.createContext(undefined);
const $935108cabed32909$var$QueryClientSharingContext = /*#__PURE__*/ $f2Y41.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $935108cabed32909$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $935108cabed32909$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $935108cabed32909$export$2fba198b5b2e37fa;
}
const $935108cabed32909$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $f2Y41.useContext($935108cabed32909$var$getQueryClientContext(context, $f2Y41.useContext($935108cabed32909$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $935108cabed32909$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $f2Y41.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $935108cabed32909$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $f2Y41.createElement($935108cabed32909$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $f2Y41.createElement(Context.Provider, {
        value: client
    }, children));
};



var $f2Y41 = parcelRequire("f2Y41");
/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $f2Y41 = parcelRequire("f2Y41");
/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $23dfbc71b7beba8d$var$_extends() {
    $23dfbc71b7beba8d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23dfbc71b7beba8d$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $23dfbc71b7beba8d$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($23dfbc71b7beba8d$export$e19cd5f9376f8cee || ($23dfbc71b7beba8d$export$e19cd5f9376f8cee = {}));
const $23dfbc71b7beba8d$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $23dfbc71b7beba8d$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $23dfbc71b7beba8d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $23dfbc71b7beba8d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $23dfbc71b7beba8d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $23dfbc71b7beba8d$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $23dfbc71b7beba8d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $23dfbc71b7beba8d$export$fe53371bee54353d(to);
    }
    return $23dfbc71b7beba8d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $23dfbc71b7beba8d$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $23dfbc71b7beba8d$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $23dfbc71b7beba8d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $23dfbc71b7beba8d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $23dfbc71b7beba8d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $23dfbc71b7beba8d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $23dfbc71b7beba8d$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $23dfbc71b7beba8d$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $23dfbc71b7beba8d$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $23dfbc71b7beba8d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $23dfbc71b7beba8d$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $23dfbc71b7beba8d$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $23dfbc71b7beba8d$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $23dfbc71b7beba8d$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $23dfbc71b7beba8d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $23dfbc71b7beba8d$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($23dfbc71b7beba8d$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Push;
        let location = $23dfbc71b7beba8d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $23dfbc71b7beba8d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Replace;
        let location = $23dfbc71b7beba8d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $23dfbc71b7beba8d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $23dfbc71b7beba8d$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $23dfbc71b7beba8d$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($23dfbc71b7beba8d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($23dfbc71b7beba8d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $23dfbc71b7beba8d$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($23dfbc71b7beba8d$var$ResultType || ($23dfbc71b7beba8d$var$ResultType = {}));
const $23dfbc71b7beba8d$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $23dfbc71b7beba8d$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $23dfbc71b7beba8d$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $23dfbc71b7beba8d$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $23dfbc71b7beba8d$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($23dfbc71b7beba8d$var$isIndexRoute(route)) {
            let indexRoute = $23dfbc71b7beba8d$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $23dfbc71b7beba8d$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $23dfbc71b7beba8d$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $23dfbc71b7beba8d$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $23dfbc71b7beba8d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $23dfbc71b7beba8d$var$flattenRoutes(routes);
    $23dfbc71b7beba8d$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $23dfbc71b7beba8d$var$decodePath(pathname);
        matches = $23dfbc71b7beba8d$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $23dfbc71b7beba8d$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $23dfbc71b7beba8d$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $23dfbc71b7beba8d$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $23dfbc71b7beba8d$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $23dfbc71b7beba8d$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $23dfbc71b7beba8d$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $23dfbc71b7beba8d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $23dfbc71b7beba8d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $23dfbc71b7beba8d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $23dfbc71b7beba8d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $23dfbc71b7beba8d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $23dfbc71b7beba8d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $23dfbc71b7beba8d$var$paramRe = /^:[\w-]+$/;
const $23dfbc71b7beba8d$var$dynamicSegmentValue = 3;
const $23dfbc71b7beba8d$var$indexRouteValue = 2;
const $23dfbc71b7beba8d$var$emptySegmentValue = 1;
const $23dfbc71b7beba8d$var$staticSegmentValue = 10;
const $23dfbc71b7beba8d$var$splatPenalty = -2;
const $23dfbc71b7beba8d$var$isSplat = (s)=>s === "*";
function $23dfbc71b7beba8d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($23dfbc71b7beba8d$var$isSplat)) initialScore += $23dfbc71b7beba8d$var$splatPenalty;
    if (index) initialScore += $23dfbc71b7beba8d$var$indexRouteValue;
    return segments.filter((s)=>!$23dfbc71b7beba8d$var$isSplat(s)).reduce((score, segment)=>score + ($23dfbc71b7beba8d$var$paramRe.test(segment) ? $23dfbc71b7beba8d$var$dynamicSegmentValue : segment === "" ? $23dfbc71b7beba8d$var$emptySegmentValue : $23dfbc71b7beba8d$var$staticSegmentValue), initialScore);
}
function $23dfbc71b7beba8d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $23dfbc71b7beba8d$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $23dfbc71b7beba8d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $23dfbc71b7beba8d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $23dfbc71b7beba8d$export$a5c6d149b50c1d86($23dfbc71b7beba8d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $23dfbc71b7beba8d$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $23dfbc71b7beba8d$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $23dfbc71b7beba8d$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $23dfbc71b7beba8d$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $23dfbc71b7beba8d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $23dfbc71b7beba8d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $23dfbc71b7beba8d$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $23dfbc71b7beba8d$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $23dfbc71b7beba8d$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $23dfbc71b7beba8d$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $23dfbc71b7beba8d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $23dfbc71b7beba8d$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $23dfbc71b7beba8d$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $23dfbc71b7beba8d$var$normalizeSearch(search),
        hash: $23dfbc71b7beba8d$var$normalizeHash(hash)
    };
}
function $23dfbc71b7beba8d$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $23dfbc71b7beba8d$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $23dfbc71b7beba8d$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $23dfbc71b7beba8d$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $23dfbc71b7beba8d$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $23dfbc71b7beba8d$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $23dfbc71b7beba8d$export$8ccf933b0513f8d0(toArg);
    else {
        to = $23dfbc71b7beba8d$var$_extends({}, toArg);
        $23dfbc71b7beba8d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $23dfbc71b7beba8d$var$getInvalidPathError("?", "pathname", "search", to));
        $23dfbc71b7beba8d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $23dfbc71b7beba8d$var$getInvalidPathError("#", "pathname", "hash", to));
        $23dfbc71b7beba8d$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $23dfbc71b7beba8d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $23dfbc71b7beba8d$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $23dfbc71b7beba8d$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $23dfbc71b7beba8d$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $23dfbc71b7beba8d$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $23dfbc71b7beba8d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $23dfbc71b7beba8d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $23dfbc71b7beba8d$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $23dfbc71b7beba8d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $23dfbc71b7beba8d$export$42a99a7a4bc0e76a extends Error {
}
class $23dfbc71b7beba8d$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $23dfbc71b7beba8d$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $23dfbc71b7beba8d$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $23dfbc71b7beba8d$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $23dfbc71b7beba8d$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $23dfbc71b7beba8d$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $23dfbc71b7beba8d$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $23dfbc71b7beba8d$var$unwrapTrackedPromise(value) {
    if (!$23dfbc71b7beba8d$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $23dfbc71b7beba8d$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $23dfbc71b7beba8d$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $23dfbc71b7beba8d$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $23dfbc71b7beba8d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $23dfbc71b7beba8d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $23dfbc71b7beba8d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $23dfbc71b7beba8d$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $23dfbc71b7beba8d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $23dfbc71b7beba8d$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $23dfbc71b7beba8d$var$validMutationMethods = new Set($23dfbc71b7beba8d$var$validMutationMethodsArr);
const $23dfbc71b7beba8d$var$validRequestMethodsArr = [
    "get",
    ...$23dfbc71b7beba8d$var$validMutationMethodsArr
];
const $23dfbc71b7beba8d$var$validRequestMethods = new Set($23dfbc71b7beba8d$var$validRequestMethodsArr);
const $23dfbc71b7beba8d$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $23dfbc71b7beba8d$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $23dfbc71b7beba8d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $23dfbc71b7beba8d$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $23dfbc71b7beba8d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $23dfbc71b7beba8d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $23dfbc71b7beba8d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $23dfbc71b7beba8d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $23dfbc71b7beba8d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $23dfbc71b7beba8d$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $23dfbc71b7beba8d$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $23dfbc71b7beba8d$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $23dfbc71b7beba8d$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $23dfbc71b7beba8d$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $23dfbc71b7beba8d$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $23dfbc71b7beba8d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $23dfbc71b7beba8d$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $23dfbc71b7beba8d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $23dfbc71b7beba8d$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $23dfbc71b7beba8d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $23dfbc71b7beba8d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$23dfbc71b7beba8d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $23dfbc71b7beba8d$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $23dfbc71b7beba8d$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $23dfbc71b7beba8d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $23dfbc71b7beba8d$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $23dfbc71b7beba8d$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($23dfbc71b7beba8d$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $23dfbc71b7beba8d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $23dfbc71b7beba8d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $23dfbc71b7beba8d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $23dfbc71b7beba8d$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $23dfbc71b7beba8d$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $23dfbc71b7beba8d$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $23dfbc71b7beba8d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $23dfbc71b7beba8d$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $23dfbc71b7beba8d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $23dfbc71b7beba8d$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $23dfbc71b7beba8d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $23dfbc71b7beba8d$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $23dfbc71b7beba8d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $23dfbc71b7beba8d$var$findNearestBoundary(matches).route.id,
            {
                type: $23dfbc71b7beba8d$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $23dfbc71b7beba8d$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $23dfbc71b7beba8d$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $23dfbc71b7beba8d$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $23dfbc71b7beba8d$var$_extends({
            matches: matches
        }, $23dfbc71b7beba8d$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $23dfbc71b7beba8d$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $23dfbc71b7beba8d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $23dfbc71b7beba8d$var$ResultType.error,
            error: $23dfbc71b7beba8d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($23dfbc71b7beba8d$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $23dfbc71b7beba8d$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($23dfbc71b7beba8d$var$isDeferredResult(result)) throw $23dfbc71b7beba8d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($23dfbc71b7beba8d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $23dfbc71b7beba8d$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $23dfbc71b7beba8d$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $23dfbc71b7beba8d$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $23dfbc71b7beba8d$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $23dfbc71b7beba8d$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $23dfbc71b7beba8d$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $23dfbc71b7beba8d$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($23dfbc71b7beba8d$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $23dfbc71b7beba8d$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $23dfbc71b7beba8d$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $23dfbc71b7beba8d$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $23dfbc71b7beba8d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $23dfbc71b7beba8d$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $23dfbc71b7beba8d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $23dfbc71b7beba8d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $23dfbc71b7beba8d$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $23dfbc71b7beba8d$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $23dfbc71b7beba8d$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $23dfbc71b7beba8d$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $23dfbc71b7beba8d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($23dfbc71b7beba8d$var$isRedirectResult(actionResult) || $23dfbc71b7beba8d$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $23dfbc71b7beba8d$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($23dfbc71b7beba8d$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $23dfbc71b7beba8d$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $23dfbc71b7beba8d$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($23dfbc71b7beba8d$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($23dfbc71b7beba8d$var$isDeferredResult(actionResult)) throw $23dfbc71b7beba8d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $23dfbc71b7beba8d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $23dfbc71b7beba8d$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $23dfbc71b7beba8d$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $23dfbc71b7beba8d$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $23dfbc71b7beba8d$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $23dfbc71b7beba8d$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $23dfbc71b7beba8d$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $23dfbc71b7beba8d$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $23dfbc71b7beba8d$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $23dfbc71b7beba8d$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $23dfbc71b7beba8d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $23dfbc71b7beba8d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $23dfbc71b7beba8d$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($23dfbc71b7beba8d$var$isDeferredResult(result)) result = await $23dfbc71b7beba8d$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $23dfbc71b7beba8d$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($23dfbc71b7beba8d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $23dfbc71b7beba8d$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($23dfbc71b7beba8d$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $23dfbc71b7beba8d$export$3e9cee6b33872309(!$23dfbc71b7beba8d$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $23dfbc71b7beba8d$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $23dfbc71b7beba8d$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $23dfbc71b7beba8d$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $23dfbc71b7beba8d$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($23dfbc71b7beba8d$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $23dfbc71b7beba8d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Replace : $23dfbc71b7beba8d$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $23dfbc71b7beba8d$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($23dfbc71b7beba8d$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $23dfbc71b7beba8d$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $23dfbc71b7beba8d$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $23dfbc71b7beba8d$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $23dfbc71b7beba8d$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($23dfbc71b7beba8d$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $23dfbc71b7beba8d$var$ResultType.redirect,
                        response: $23dfbc71b7beba8d$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $23dfbc71b7beba8d$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $23dfbc71b7beba8d$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $23dfbc71b7beba8d$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $23dfbc71b7beba8d$var$ResultType.error,
                    error: $23dfbc71b7beba8d$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $23dfbc71b7beba8d$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $23dfbc71b7beba8d$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $23dfbc71b7beba8d$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $23dfbc71b7beba8d$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $23dfbc71b7beba8d$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $23dfbc71b7beba8d$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $23dfbc71b7beba8d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $23dfbc71b7beba8d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $23dfbc71b7beba8d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $23dfbc71b7beba8d$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $23dfbc71b7beba8d$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $23dfbc71b7beba8d$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $23dfbc71b7beba8d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$23dfbc71b7beba8d$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $23dfbc71b7beba8d$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $23dfbc71b7beba8d$export$4d0306f8f6a4585b = Symbol("deferred");
function $23dfbc71b7beba8d$export$3336b097a6fbc59a(routes, opts) {
    $23dfbc71b7beba8d$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $23dfbc71b7beba8d$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $23dfbc71b7beba8d$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $23dfbc71b7beba8d$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $23dfbc71b7beba8d$var$createLocation("", $23dfbc71b7beba8d$export$fe53371bee54353d(url), null, "default");
        let matches = $23dfbc71b7beba8d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$23dfbc71b7beba8d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $23dfbc71b7beba8d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $23dfbc71b7beba8d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $23dfbc71b7beba8d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $23dfbc71b7beba8d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($23dfbc71b7beba8d$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $23dfbc71b7beba8d$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $23dfbc71b7beba8d$var$createLocation("", $23dfbc71b7beba8d$export$fe53371bee54353d(url), null, "default");
        let matches = $23dfbc71b7beba8d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$23dfbc71b7beba8d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $23dfbc71b7beba8d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $23dfbc71b7beba8d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $23dfbc71b7beba8d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $23dfbc71b7beba8d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $23dfbc71b7beba8d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if ($23dfbc71b7beba8d$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$23dfbc71b7beba8d$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $23dfbc71b7beba8d$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($23dfbc71b7beba8d$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $23dfbc71b7beba8d$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $23dfbc71b7beba8d$var$isResponse(result) ? result : $23dfbc71b7beba8d$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($23dfbc71b7beba8d$var$isHandlerResult(e) && $23dfbc71b7beba8d$var$isResponse(e.result)) {
                if (e.type === $23dfbc71b7beba8d$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($23dfbc71b7beba8d$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $23dfbc71b7beba8d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $23dfbc71b7beba8d$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $23dfbc71b7beba8d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($23dfbc71b7beba8d$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($23dfbc71b7beba8d$var$isDeferredResult(result)) {
            let error = $23dfbc71b7beba8d$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $23dfbc71b7beba8d$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($23dfbc71b7beba8d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($23dfbc71b7beba8d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $23dfbc71b7beba8d$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $23dfbc71b7beba8d$var$_extends({}, context, {
                statusCode: $23dfbc71b7beba8d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $23dfbc71b7beba8d$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $23dfbc71b7beba8d$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $23dfbc71b7beba8d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? $23dfbc71b7beba8d$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $23dfbc71b7beba8d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $23dfbc71b7beba8d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $23dfbc71b7beba8d$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $23dfbc71b7beba8d$var$callDataStrategyImpl(unstable_dataStrategy || $23dfbc71b7beba8d$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($23dfbc71b7beba8d$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $23dfbc71b7beba8d$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($23dfbc71b7beba8d$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $23dfbc71b7beba8d$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $23dfbc71b7beba8d$export$fec11da027c70692(routes, context, error) {
    let newContext = $23dfbc71b7beba8d$var$_extends({}, context, {
        statusCode: $23dfbc71b7beba8d$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $23dfbc71b7beba8d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $23dfbc71b7beba8d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $23dfbc71b7beba8d$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $23dfbc71b7beba8d$export$cae722b0cc860f13(to ? to : ".", $23dfbc71b7beba8d$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $23dfbc71b7beba8d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$23dfbc71b7beba8d$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $23dfbc71b7beba8d$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $23dfbc71b7beba8d$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $23dfbc71b7beba8d$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$23dfbc71b7beba8d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$23dfbc71b7beba8d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $23dfbc71b7beba8d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $23dfbc71b7beba8d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $23dfbc71b7beba8d$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$23dfbc71b7beba8d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$23dfbc71b7beba8d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $23dfbc71b7beba8d$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $23dfbc71b7beba8d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $23dfbc71b7beba8d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $23dfbc71b7beba8d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $23dfbc71b7beba8d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($23dfbc71b7beba8d$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $23dfbc71b7beba8d$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $23dfbc71b7beba8d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $23dfbc71b7beba8d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $23dfbc71b7beba8d$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $23dfbc71b7beba8d$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $23dfbc71b7beba8d$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($23dfbc71b7beba8d$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $23dfbc71b7beba8d$var$shouldRevalidateLoader(match, $23dfbc71b7beba8d$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $23dfbc71b7beba8d$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $23dfbc71b7beba8d$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $23dfbc71b7beba8d$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $23dfbc71b7beba8d$var$shouldRevalidateLoader(fetcherMatch, $23dfbc71b7beba8d$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $23dfbc71b7beba8d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $23dfbc71b7beba8d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $23dfbc71b7beba8d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $23dfbc71b7beba8d$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $23dfbc71b7beba8d$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $23dfbc71b7beba8d$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$23dfbc71b7beba8d$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $23dfbc71b7beba8d$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $23dfbc71b7beba8d$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $23dfbc71b7beba8d$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $23dfbc71b7beba8d$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $23dfbc71b7beba8d$var$ResultType.data,
                    result: undefined
                });
            };
            return $23dfbc71b7beba8d$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$23dfbc71b7beba8d$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $23dfbc71b7beba8d$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $23dfbc71b7beba8d$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $23dfbc71b7beba8d$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $23dfbc71b7beba8d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $23dfbc71b7beba8d$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $23dfbc71b7beba8d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $23dfbc71b7beba8d$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $23dfbc71b7beba8d$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $23dfbc71b7beba8d$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($23dfbc71b7beba8d$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $23dfbc71b7beba8d$var$ResultType.error,
                error: e
            };
        }
        if (type === $23dfbc71b7beba8d$var$ResultType.error) return {
            type: $23dfbc71b7beba8d$var$ResultType.error,
            error: new $23dfbc71b7beba8d$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $23dfbc71b7beba8d$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $23dfbc71b7beba8d$var$ResultType.error) return {
        type: $23dfbc71b7beba8d$var$ResultType.error,
        error: result,
        statusCode: $23dfbc71b7beba8d$export$972111febbeef05b(result) ? result.status : status
    };
    if ($23dfbc71b7beba8d$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $23dfbc71b7beba8d$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $23dfbc71b7beba8d$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $23dfbc71b7beba8d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $23dfbc71b7beba8d$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$23dfbc71b7beba8d$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $23dfbc71b7beba8d$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $23dfbc71b7beba8d$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($23dfbc71b7beba8d$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $23dfbc71b7beba8d$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $23dfbc71b7beba8d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($23dfbc71b7beba8d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $23dfbc71b7beba8d$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $23dfbc71b7beba8d$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $23dfbc71b7beba8d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $23dfbc71b7beba8d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $23dfbc71b7beba8d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $23dfbc71b7beba8d$export$3e9cee6b33872309(!$23dfbc71b7beba8d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($23dfbc71b7beba8d$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $23dfbc71b7beba8d$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $23dfbc71b7beba8d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($23dfbc71b7beba8d$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $23dfbc71b7beba8d$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $23dfbc71b7beba8d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $23dfbc71b7beba8d$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($23dfbc71b7beba8d$var$isErrorResult(result)) {
            let boundaryMatch = $23dfbc71b7beba8d$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $23dfbc71b7beba8d$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($23dfbc71b7beba8d$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $23dfbc71b7beba8d$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($23dfbc71b7beba8d$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $23dfbc71b7beba8d$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $23dfbc71b7beba8d$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $23dfbc71b7beba8d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $23dfbc71b7beba8d$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $23dfbc71b7beba8d$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $23dfbc71b7beba8d$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $23dfbc71b7beba8d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $23dfbc71b7beba8d$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $23dfbc71b7beba8d$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $23dfbc71b7beba8d$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $23dfbc71b7beba8d$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($23dfbc71b7beba8d$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $23dfbc71b7beba8d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(path) : path;
    return $23dfbc71b7beba8d$export$fe53371bee54353d($23dfbc71b7beba8d$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $23dfbc71b7beba8d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $23dfbc71b7beba8d$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $23dfbc71b7beba8d$var$ResultType.data || result.type === $23dfbc71b7beba8d$var$ResultType.error);
}
function $23dfbc71b7beba8d$var$isRedirectHandlerResult(result) {
    return $23dfbc71b7beba8d$var$isResponse(result.result) && $23dfbc71b7beba8d$var$redirectStatusCodes.has(result.result.status);
}
function $23dfbc71b7beba8d$var$isDeferredResult(result) {
    return result.type === $23dfbc71b7beba8d$var$ResultType.deferred;
}
function $23dfbc71b7beba8d$var$isErrorResult(result) {
    return result.type === $23dfbc71b7beba8d$var$ResultType.error;
}
function $23dfbc71b7beba8d$var$isRedirectResult(result) {
    return (result && result.type) === $23dfbc71b7beba8d$var$ResultType.redirect;
}
function $23dfbc71b7beba8d$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $23dfbc71b7beba8d$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $23dfbc71b7beba8d$var$isRedirectResponse(result) {
    if (!$23dfbc71b7beba8d$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $23dfbc71b7beba8d$var$isValidMethod(method) {
    return $23dfbc71b7beba8d$var$validRequestMethods.has(method.toLowerCase());
}
function $23dfbc71b7beba8d$var$isMutationMethod(method) {
    return $23dfbc71b7beba8d$var$validMutationMethods.has(method.toLowerCase());
}
async function $23dfbc71b7beba8d$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$23dfbc71b7beba8d$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($23dfbc71b7beba8d$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $23dfbc71b7beba8d$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $23dfbc71b7beba8d$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $23dfbc71b7beba8d$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $23dfbc71b7beba8d$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $23dfbc71b7beba8d$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $23dfbc71b7beba8d$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $23dfbc71b7beba8d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $23dfbc71b7beba8d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $23dfbc71b7beba8d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $23dfbc71b7beba8d$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $23dfbc71b7beba8d$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $23dfbc71b7beba8d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $23dfbc71b7beba8d$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $23dfbc71b7beba8d$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $23dfbc71b7beba8d$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $23dfbc71b7beba8d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $23dfbc71b7beba8d$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $23dfbc71b7beba8d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($23dfbc71b7beba8d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $23dfbc71b7beba8d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($23dfbc71b7beba8d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $23dfbc71b7beba8d$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $c5383ff45095a6a6$var$_extends() {
    $c5383ff45095a6a6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c5383ff45095a6a6$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $c5383ff45095a6a6$export$3add0d5dce533e2e = /*#__PURE__*/ $f2Y41.createContext(null);
const $c5383ff45095a6a6$export$145dfa71566a64dc = /*#__PURE__*/ $f2Y41.createContext(null);
const $c5383ff45095a6a6$var$AwaitContext = /*#__PURE__*/ $f2Y41.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $c5383ff45095a6a6$export$26749e8557646306 = /*#__PURE__*/ $f2Y41.createContext(null);
const $c5383ff45095a6a6$export$c7914228fb69b0f5 = /*#__PURE__*/ $f2Y41.createContext(null);
const $c5383ff45095a6a6$export$9072aa6dd1f93057 = /*#__PURE__*/ $f2Y41.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $c5383ff45095a6a6$var$RouteErrorContext = /*#__PURE__*/ $f2Y41.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $c5383ff45095a6a6$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $f2Y41.useContext($c5383ff45095a6a6$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $c5383ff45095a6a6$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $23dfbc71b7beba8d$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $c5383ff45095a6a6$export$9c954a9d03d32f4a() {
    return $f2Y41.useContext($c5383ff45095a6a6$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $c5383ff45095a6a6$export$45d76561a5302f2b() {
    !$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return $f2Y41.useContext($c5383ff45095a6a6$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $c5383ff45095a6a6$export$1b3f31771c5d07c() {
    return $f2Y41.useContext($c5383ff45095a6a6$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $c5383ff45095a6a6$export$6c330e8992e8a295(pattern) {
    !$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $c5383ff45095a6a6$export$45d76561a5302f2b();
    return $f2Y41.useMemo(()=>(0, $23dfbc71b7beba8d$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $c5383ff45095a6a6$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $c5383ff45095a6a6$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $f2Y41.useContext($c5383ff45095a6a6$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f2Y41.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $c5383ff45095a6a6$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $c5383ff45095a6a6$var$useNavigateStable() : $c5383ff45095a6a6$var$useNavigateUnstable();
}
function $c5383ff45095a6a6$var$useNavigateUnstable() {
    !$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let dataRouterContext = $f2Y41.useContext($c5383ff45095a6a6$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $f2Y41.useContext($c5383ff45095a6a6$export$26749e8557646306);
    let { matches: matches } = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $c5383ff45095a6a6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $23dfbc71b7beba8d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $f2Y41.useRef(false);
    $c5383ff45095a6a6$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $f2Y41.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $23dfbc71b7beba8d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $23dfbc71b7beba8d$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $c5383ff45095a6a6$var$OutletContext = /*#__PURE__*/ $f2Y41.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $c5383ff45095a6a6$export$4138103a3ae699cc() {
    return $f2Y41.useContext($c5383ff45095a6a6$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $c5383ff45095a6a6$export$a3be3530d8e40d0b(context) {
    let outlet = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $c5383ff45095a6a6$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $c5383ff45095a6a6$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $f2Y41.useContext($c5383ff45095a6a6$export$26749e8557646306);
    let { matches: matches } = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $c5383ff45095a6a6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $23dfbc71b7beba8d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $f2Y41.useMemo(()=>(0, $23dfbc71b7beba8d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $c5383ff45095a6a6$export$5d3fca4a98652595(routes, locationArg) {
    return $c5383ff45095a6a6$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $c5383ff45095a6a6$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $f2Y41.useContext($c5383ff45095a6a6$export$26749e8557646306);
    let { matches: parentMatches } = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $c5383ff45095a6a6$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $23dfbc71b7beba8d$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $23dfbc71b7beba8d$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $c5383ff45095a6a6$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $23dfbc71b7beba8d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $23dfbc71b7beba8d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $c5383ff45095a6a6$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $23dfbc71b7beba8d$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $c5383ff45095a6a6$var$DefaultErrorComponent() {
    let error = $c5383ff45095a6a6$export$ed527bf60f6e05f2();
    let message = (0, $23dfbc71b7beba8d$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, /*#__PURE__*/ $f2Y41.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $f2Y41.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $f2Y41.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $c5383ff45095a6a6$var$defaultErrorElement = /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$DefaultErrorComponent, null);
class $c5383ff45095a6a6$var$RenderErrorBoundary extends $f2Y41.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $c5383ff45095a6a6$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $f2Y41.useContext($c5383ff45095a6a6$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $c5383ff45095a6a6$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $c5383ff45095a6a6$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $c5383ff45095a6a6$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $f2Y41.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $c5383ff45095a6a6$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($c5383ff45095a6a6$var$DataRouterHook || {});
var $c5383ff45095a6a6$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($c5383ff45095a6a6$var$DataRouterStateHook || {});
function $c5383ff45095a6a6$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c5383ff45095a6a6$var$useDataRouterContext(hookName) {
    let ctx = $f2Y41.useContext($c5383ff45095a6a6$export$3add0d5dce533e2e);
    !ctx && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c5383ff45095a6a6$var$useDataRouterState(hookName) {
    let state = $f2Y41.useContext($c5383ff45095a6a6$export$145dfa71566a64dc);
    !state && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return state;
}
function $c5383ff45095a6a6$var$useRouteContext(hookName) {
    let route = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    !route && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $c5383ff45095a6a6$var$useCurrentRouteId(hookName) {
    let route = $c5383ff45095a6a6$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $c5383ff45095a6a6$export$5fc8298006ad9e58() {
    return $c5383ff45095a6a6$var$useCurrentRouteId($c5383ff45095a6a6$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $c5383ff45095a6a6$export$d0fd4b7106de2769() {
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $c5383ff45095a6a6$export$600dc272ed516c15() {
    let dataRouterContext = $c5383ff45095a6a6$var$useDataRouterContext($c5383ff45095a6a6$var$DataRouterHook.UseRevalidator);
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseRevalidator);
    return $f2Y41.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $c5383ff45095a6a6$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseMatches);
    return $f2Y41.useMemo(()=>matches.map((m)=>(0, $23dfbc71b7beba8d$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $c5383ff45095a6a6$export$1448a5050d252c4d() {
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseLoaderData);
    let routeId = $c5383ff45095a6a6$var$useCurrentRouteId($c5383ff45095a6a6$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $c5383ff45095a6a6$export$fd5d37484eab868d(routeId) {
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $c5383ff45095a6a6$export$fdc00f3f26066d5e() {
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseActionData);
    let routeId = $c5383ff45095a6a6$var$useCurrentRouteId($c5383ff45095a6a6$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $c5383ff45095a6a6$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $f2Y41.useContext($c5383ff45095a6a6$var$RouteErrorContext);
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseRouteError);
    let routeId = $c5383ff45095a6a6$var$useCurrentRouteId($c5383ff45095a6a6$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $c5383ff45095a6a6$export$78a72ddb39bdd145() {
    let value = $f2Y41.useContext($c5383ff45095a6a6$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $c5383ff45095a6a6$export$17f53340677d5831() {
    let value = $f2Y41.useContext($c5383ff45095a6a6$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $c5383ff45095a6a6$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $c5383ff45095a6a6$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $c5383ff45095a6a6$var$useDataRouterContext($c5383ff45095a6a6$var$DataRouterHook.UseBlocker);
    let state = $c5383ff45095a6a6$var$useDataRouterState($c5383ff45095a6a6$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $f2Y41.useState("");
    let blockerFunction = $f2Y41.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $c5383ff45095a6a6$var$_extends({}, currentLocation, {
                pathname: (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $c5383ff45095a6a6$var$_extends({}, nextLocation, {
                pathname: (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $f2Y41.useEffect(()=>{
        let key = String(++$c5383ff45095a6a6$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $f2Y41.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $23dfbc71b7beba8d$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $c5383ff45095a6a6$var$useNavigateStable() {
    let { router: router } = $c5383ff45095a6a6$var$useDataRouterContext($c5383ff45095a6a6$var$DataRouterHook.UseNavigateStable);
    let id = $c5383ff45095a6a6$var$useCurrentRouteId($c5383ff45095a6a6$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $f2Y41.useRef(false);
    $c5383ff45095a6a6$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $f2Y41.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $c5383ff45095a6a6$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $c5383ff45095a6a6$var$alreadyWarned = {};
function $c5383ff45095a6a6$var$warningOnce(key, cond, message) {
    if (!cond && !$c5383ff45095a6a6$var$alreadyWarned[key]) $c5383ff45095a6a6$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c5383ff45095a6a6$var$START_TRANSITION = "startTransition";
const $c5383ff45095a6a6$var$startTransitionImpl = $f2Y41[$c5383ff45095a6a6$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c5383ff45095a6a6$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $f2Y41.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $f2Y41.useCallback((newState)=>{
        if (v7_startTransition && $c5383ff45095a6a6$var$startTransitionImpl) $c5383ff45095a6a6$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $f2Y41.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $f2Y41.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $f2Y41.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $f2Y41.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $c5383ff45095a6a6$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $c5383ff45095a6a6$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $c5383ff45095a6a6$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $f2Y41.useRef();
    if (historyRef.current == null) historyRef.current = (0, $23dfbc71b7beba8d$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $f2Y41.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $f2Y41.useCallback((newState)=>{
        v7_startTransition && $c5383ff45095a6a6$var$startTransitionImpl ? $c5383ff45095a6a6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f2Y41.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $c5383ff45095a6a6$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $f2Y41.useContext($c5383ff45095a6a6$export$26749e8557646306);
    let { matches: matches } = $f2Y41.useContext($c5383ff45095a6a6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $c5383ff45095a6a6$export$45d76561a5302f2b();
    let navigate = $c5383ff45095a6a6$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $23dfbc71b7beba8d$export$cae722b0cc860f13)(to, (0, $23dfbc71b7beba8d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $f2Y41.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $c5383ff45095a6a6$export$910ae8079b2c2852(props) {
    return $c5383ff45095a6a6$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $c5383ff45095a6a6$export$e7b0ac011bb776c6(_props) {
    (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $c5383ff45095a6a6$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $23dfbc71b7beba8d$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$c5383ff45095a6a6$export$9c954a9d03d32f4a() && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $f2Y41.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $c5383ff45095a6a6$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $23dfbc71b7beba8d$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $f2Y41.useMemo(()=>{
        let trailingPathname = (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $c5383ff45095a6a6$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $c5383ff45095a6a6$export$5d3fca4a98652595($c5383ff45095a6a6$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $c5383ff45095a6a6$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$ResolveAwait, null, children));
}
var $c5383ff45095a6a6$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($c5383ff45095a6a6$var$AwaitRenderStatus || {});
const $c5383ff45095a6a6$var$neverSettledPromise = new Promise(()=>{});
class $c5383ff45095a6a6$var$AwaitErrorBoundary extends $f2Y41.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $c5383ff45095a6a6$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $c5383ff45095a6a6$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $c5383ff45095a6a6$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $c5383ff45095a6a6$var$AwaitRenderStatus.error : promise._data !== undefined ? $c5383ff45095a6a6$var$AwaitRenderStatus.success : $c5383ff45095a6a6$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $c5383ff45095a6a6$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $c5383ff45095a6a6$var$AwaitRenderStatus.error && promise._error instanceof (0, $23dfbc71b7beba8d$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $c5383ff45095a6a6$var$neverSettledPromise;
        if (status === $c5383ff45095a6a6$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $c5383ff45095a6a6$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $c5383ff45095a6a6$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $f2Y41.createElement($c5383ff45095a6a6$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $c5383ff45095a6a6$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $c5383ff45095a6a6$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $c5383ff45095a6a6$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $f2Y41.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $f2Y41.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $f2Y41.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $c5383ff45095a6a6$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $c5383ff45095a6a6$export$e7b0ac011bb776c6) && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $c5383ff45095a6a6$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $c5383ff45095a6a6$export$daf73786167a7f72(matches) {
    return $c5383ff45095a6a6$var$_renderMatches(matches);
}
function $c5383ff45095a6a6$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $f2Y41.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $f2Y41.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $f2Y41.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $c5383ff45095a6a6$export$f30f7e456d254e83(routes, opts) {
    return (0, $23dfbc71b7beba8d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c5383ff45095a6a6$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $23dfbc71b7beba8d$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $c5383ff45095a6a6$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}

/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $f2Y41 = parcelRequire("f2Y41");



function $68992f44774c46b5$var$_extends() {
    $68992f44774c46b5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68992f44774c46b5$var$_extends.apply(this, arguments);
}
function $68992f44774c46b5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $68992f44774c46b5$var$defaultMethod = "get";
const $68992f44774c46b5$var$defaultEncType = "application/x-www-form-urlencoded";
function $68992f44774c46b5$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $68992f44774c46b5$var$isButtonElement(object) {
    return $68992f44774c46b5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $68992f44774c46b5$var$isFormElement(object) {
    return $68992f44774c46b5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $68992f44774c46b5$var$isInputElement(object) {
    return $68992f44774c46b5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $68992f44774c46b5$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $68992f44774c46b5$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$68992f44774c46b5$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $68992f44774c46b5$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $68992f44774c46b5$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $68992f44774c46b5$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $68992f44774c46b5$var$_formDataSupportsSubmitter = null;
function $68992f44774c46b5$var$isFormDataSubmitterSupported() {
    if ($68992f44774c46b5$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $68992f44774c46b5$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $68992f44774c46b5$var$_formDataSupportsSubmitter = true;
    }
    return $68992f44774c46b5$var$_formDataSupportsSubmitter;
}
const $68992f44774c46b5$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $68992f44774c46b5$var$getFormEncType(encType) {
    if (encType != null && !$68992f44774c46b5$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $68992f44774c46b5$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($68992f44774c46b5$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $68992f44774c46b5$var$defaultMethod;
        encType = $68992f44774c46b5$var$getFormEncType(target.getAttribute("enctype")) || $68992f44774c46b5$var$defaultEncType;
        formData = new FormData(target);
    } else if ($68992f44774c46b5$var$isButtonElement(target) || $68992f44774c46b5$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $68992f44774c46b5$var$defaultMethod;
        encType = $68992f44774c46b5$var$getFormEncType(target.getAttribute("formenctype")) || $68992f44774c46b5$var$getFormEncType(form.getAttribute("enctype")) || $68992f44774c46b5$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$68992f44774c46b5$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($68992f44774c46b5$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $68992f44774c46b5$var$defaultMethod;
        action = null;
        encType = $68992f44774c46b5$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $68992f44774c46b5$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $68992f44774c46b5$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $68992f44774c46b5$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $68992f44774c46b5$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $68992f44774c46b5$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $68992f44774c46b5$export$1f3f55432a00e06d(routes, opts) {
    return (0, $23dfbc71b7beba8d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $68992f44774c46b5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $23dfbc71b7beba8d$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $68992f44774c46b5$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $c5383ff45095a6a6$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $68992f44774c46b5$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $23dfbc71b7beba8d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $68992f44774c46b5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $23dfbc71b7beba8d$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $68992f44774c46b5$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $c5383ff45095a6a6$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $68992f44774c46b5$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $68992f44774c46b5$var$_extends({}, state, {
        errors: $68992f44774c46b5$var$deserializeErrors(state.errors)
    });
    return state;
}
function $68992f44774c46b5$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $23dfbc71b7beba8d$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $68992f44774c46b5$export$7ad602f0e94e62d1 = /*#__PURE__*/ $f2Y41.createContext({
    isTransitioning: false
});
const $68992f44774c46b5$export$148fd98d095596d4 = /*#__PURE__*/ $f2Y41.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $68992f44774c46b5$var$START_TRANSITION = "startTransition";
const $68992f44774c46b5$var$startTransitionImpl = $f2Y41[$68992f44774c46b5$var$START_TRANSITION];
const $68992f44774c46b5$var$FLUSH_SYNC = "flushSync";
const $68992f44774c46b5$var$flushSyncImpl = $5021361ff788fb77$exports[$68992f44774c46b5$var$FLUSH_SYNC];
const $68992f44774c46b5$var$USE_ID = "useId";
const $68992f44774c46b5$var$useIdImpl = $f2Y41[$68992f44774c46b5$var$USE_ID];
function $68992f44774c46b5$var$startTransitionSafe(cb) {
    if ($68992f44774c46b5$var$startTransitionImpl) $68992f44774c46b5$var$startTransitionImpl(cb);
    else cb();
}
function $68992f44774c46b5$var$flushSyncSafe(cb) {
    if ($68992f44774c46b5$var$flushSyncImpl) $68992f44774c46b5$var$flushSyncImpl(cb);
    else cb();
}
class $68992f44774c46b5$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $68992f44774c46b5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $f2Y41.useState(router.state);
    let [pendingState, setPendingState] = $f2Y41.useState();
    let [vtContext, setVtContext] = $f2Y41.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $f2Y41.useState();
    let [transition, setTransition] = $f2Y41.useState();
    let [interruption, setInterruption] = $f2Y41.useState();
    let fetcherData = $f2Y41.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $f2Y41.useCallback((cb)=>{
        if (v7_startTransition) $68992f44774c46b5$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $f2Y41.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $68992f44774c46b5$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $68992f44774c46b5$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $68992f44774c46b5$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $68992f44774c46b5$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $68992f44774c46b5$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $f2Y41.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $f2Y41.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $68992f44774c46b5$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $f2Y41.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $f2Y41.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $f2Y41.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $f2Y41.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $f2Y41.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $f2Y41.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, /*#__PURE__*/ $f2Y41.createElement((0, $c5383ff45095a6a6$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $f2Y41.createElement((0, $c5383ff45095a6a6$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $f2Y41.createElement($68992f44774c46b5$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $f2Y41.createElement($68992f44774c46b5$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $f2Y41.createElement((0, $c5383ff45095a6a6$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $f2Y41.createElement($68992f44774c46b5$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $68992f44774c46b5$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $c5383ff45095a6a6$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $68992f44774c46b5$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $f2Y41.useRef();
    if (historyRef.current == null) historyRef.current = (0, $23dfbc71b7beba8d$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $f2Y41.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $f2Y41.useCallback((newState)=>{
        v7_startTransition && $68992f44774c46b5$var$startTransitionImpl ? $68992f44774c46b5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f2Y41.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f2Y41.createElement((0, $c5383ff45095a6a6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $68992f44774c46b5$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $f2Y41.useRef();
    if (historyRef.current == null) historyRef.current = (0, $23dfbc71b7beba8d$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $f2Y41.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $f2Y41.useCallback((newState)=>{
        v7_startTransition && $68992f44774c46b5$var$startTransitionImpl ? $68992f44774c46b5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f2Y41.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f2Y41.createElement((0, $c5383ff45095a6a6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $68992f44774c46b5$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $f2Y41.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $f2Y41.useCallback((newState)=>{
        v7_startTransition && $68992f44774c46b5$var$startTransitionImpl ? $68992f44774c46b5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f2Y41.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f2Y41.createElement((0, $c5383ff45095a6a6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $68992f44774c46b5$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $68992f44774c46b5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $68992f44774c46b5$export$a6c7ac8248d6e38a = /*#__PURE__*/ $f2Y41.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $68992f44774c46b5$var$_objectWithoutPropertiesLoose(_ref7, $68992f44774c46b5$var$_excluded);
    let { basename: basename } = $f2Y41.useContext((0, $c5383ff45095a6a6$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $68992f44774c46b5$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($68992f44774c46b5$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $c5383ff45095a6a6$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $68992f44774c46b5$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $f2Y41.createElement("a", $68992f44774c46b5$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $68992f44774c46b5$export$b0d92dbee9b5b60d = /*#__PURE__*/ $f2Y41.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $68992f44774c46b5$var$_objectWithoutPropertiesLoose(_ref8, $68992f44774c46b5$var$_excluded2);
    let path = (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    let routerState = $f2Y41.useContext((0, $c5383ff45095a6a6$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $f2Y41.useContext((0, $c5383ff45095a6a6$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $68992f44774c46b5$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $f2Y41.createElement($68992f44774c46b5$export$a6c7ac8248d6e38a, $68992f44774c46b5$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $68992f44774c46b5$export$a7fed597f4b8afd8 = /*#__PURE__*/ $f2Y41.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $68992f44774c46b5$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $68992f44774c46b5$var$_objectWithoutPropertiesLoose(_ref9, $68992f44774c46b5$var$_excluded3);
    let submit = $68992f44774c46b5$export$47c85c6e3a081d3();
    let formAction = $68992f44774c46b5$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $f2Y41.createElement("form", $68992f44774c46b5$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $68992f44774c46b5$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $68992f44774c46b5$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $68992f44774c46b5$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($68992f44774c46b5$var$DataRouterHook || ($68992f44774c46b5$var$DataRouterHook = {}));
var $68992f44774c46b5$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($68992f44774c46b5$var$DataRouterStateHook || ($68992f44774c46b5$var$DataRouterStateHook = {}));
// Internal hooks
function $68992f44774c46b5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $68992f44774c46b5$var$useDataRouterContext(hookName) {
    let ctx = $f2Y41.useContext((0, $c5383ff45095a6a6$export$3add0d5dce533e2e));
    !ctx && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $68992f44774c46b5$var$useDataRouterState(hookName) {
    let state = $f2Y41.useContext((0, $c5383ff45095a6a6$export$145dfa71566a64dc));
    !state && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $68992f44774c46b5$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    let location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    let path = (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $f2Y41.useCallback((event)=>{
        if ($68992f44774c46b5$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $23dfbc71b7beba8d$export$fe53371bee54353d)(location) === (0, $23dfbc71b7beba8d$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $68992f44774c46b5$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $f2Y41.useRef($68992f44774c46b5$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $f2Y41.useRef(false);
    let location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    let searchParams = $f2Y41.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $68992f44774c46b5$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    let setSearchParams = $f2Y41.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $68992f44774c46b5$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $68992f44774c46b5$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $68992f44774c46b5$var$fetcherId = 0;
let $68992f44774c46b5$var$getUniqueFetcherId = ()=>"__" + String(++$68992f44774c46b5$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $68992f44774c46b5$export$47c85c6e3a081d3() {
    let { router: router } = $68992f44774c46b5$var$useDataRouterContext($68992f44774c46b5$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $f2Y41.useContext((0, $c5383ff45095a6a6$export$26749e8557646306));
    let currentRouteId = (0, $c5383ff45095a6a6$export$5fc8298006ad9e58)();
    return $f2Y41.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $68992f44774c46b5$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $68992f44774c46b5$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $68992f44774c46b5$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $68992f44774c46b5$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $f2Y41.useContext((0, $c5383ff45095a6a6$export$26749e8557646306));
    let routeContext = $f2Y41.useContext((0, $c5383ff45095a6a6$export$9072aa6dd1f93057));
    !routeContext && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $68992f44774c46b5$var$_extends({}, (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $23dfbc71b7beba8d$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $23dfbc71b7beba8d$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $68992f44774c46b5$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $68992f44774c46b5$var$useDataRouterContext($68992f44774c46b5$var$DataRouterHook.UseFetcher);
    let state = $68992f44774c46b5$var$useDataRouterState($68992f44774c46b5$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $f2Y41.useContext($68992f44774c46b5$export$148fd98d095596d4);
    let route = $f2Y41.useContext((0, $c5383ff45095a6a6$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    !route && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $68992f44774c46b5$var$useIdImpl ? $68992f44774c46b5$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $f2Y41.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($68992f44774c46b5$var$getUniqueFetcherId());
    // Registration/cleanup
    $f2Y41.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $f2Y41.useCallback((href, opts)=>{
        !routeId && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $68992f44774c46b5$export$47c85c6e3a081d3();
    let submit = $f2Y41.useCallback((target, opts)=>{
        submitImpl(target, $68992f44774c46b5$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $f2Y41.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $f2Y41.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $f2Y41.createElement($68992f44774c46b5$export$a7fed597f4b8afd8, $68992f44774c46b5$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $23dfbc71b7beba8d$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $f2Y41.useMemo(()=>$68992f44774c46b5$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $68992f44774c46b5$export$fa996778a3a31087() {
    let state = $68992f44774c46b5$var$useDataRouterState($68992f44774c46b5$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $68992f44774c46b5$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $68992f44774c46b5$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $68992f44774c46b5$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $68992f44774c46b5$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $68992f44774c46b5$var$useDataRouterContext($68992f44774c46b5$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $68992f44774c46b5$var$useDataRouterState($68992f44774c46b5$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $f2Y41.useContext((0, $c5383ff45095a6a6$export$26749e8557646306));
    let location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    let matches = (0, $c5383ff45095a6a6$export$2378eb7f5ff86053)();
    let navigation = (0, $c5383ff45095a6a6$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $f2Y41.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $68992f44774c46b5$var$usePageHide($f2Y41.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $68992f44774c46b5$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $68992f44774c46b5$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($68992f44774c46b5$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $f2Y41.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $68992f44774c46b5$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $68992f44774c46b5$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $f2Y41.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($68992f44774c46b5$var$_extends({}, location, {
                    pathname: (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($68992f44774c46b5$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $f2Y41.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $68992f44774c46b5$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $f2Y41.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $68992f44774c46b5$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $f2Y41.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $68992f44774c46b5$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $c5383ff45095a6a6$export$b273b3273281a049)(when);
    $f2Y41.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $f2Y41.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $68992f44774c46b5$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $f2Y41.useContext($68992f44774c46b5$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $23dfbc71b7beba8d$export$3e9cee6b33872309)(false);
    let { basename: basename } = $68992f44774c46b5$var$useDataRouterContext($68992f44774c46b5$var$DataRouterHook.useViewTransitionState);
    let path = (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $23dfbc71b7beba8d$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $23dfbc71b7beba8d$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $23dfbc71b7beba8d$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $ge3KO = parcelRequire("ge3KO");


var $ge3KO = parcelRequire("ge3KO");

var $jZjY3 = parcelRequire("jZjY3");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");
function $39d3f7a539975594$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $asN9r.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $asN9r.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $asN9r.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $39d3f7a539975594$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}


function $8c3d2262a19b09ff$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $39d3f7a539975594$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}



var $hjRti = parcelRequire("hjRti");

var $f2Y41 = parcelRequire("f2Y41");
parcelRequire("jvVhJ");
var $jZjY3 = parcelRequire("jZjY3");
"use client";
function $150a4f96e5d5582c$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $150a4f96e5d5582c$var$useTheme(defaultTheme = null) {
    const contextTheme = $f2Y41.useContext((0, $jZjY3.T));
    return !contextTheme || $150a4f96e5d5582c$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $150a4f96e5d5582c$export$2e2bcd8739ae039 = $150a4f96e5d5582c$var$useTheme;


"use client";
const $e65a75724f3a2622$export$35e57303dbd8a66 = (0, $hjRti.default)();
function $e65a75724f3a2622$var$useTheme(defaultTheme = $e65a75724f3a2622$export$35e57303dbd8a66) {
    return (0, $150a4f96e5d5582c$export$2e2bcd8739ae039)(defaultTheme);
}
var $e65a75724f3a2622$export$2e2bcd8739ae039 = $e65a75724f3a2622$var$useTheme;


"use client";
function $013a09cb63d6ec53$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $e65a75724f3a2622$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $8c3d2262a19b09ff$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $aahau = parcelRequire("aahau");

var $cAicU = parcelRequire("cAicU");

var $iKUML = parcelRequire("iKUML");
var $eYiFE = parcelRequire("eYiFE");

var $hjRti = parcelRequire("hjRti");


var $asN9r = parcelRequire("asN9r");
function $38b281a1bc98b9e6$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $asN9r.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $aahau = parcelRequire("aahau");

var $cAicU = parcelRequire("cAicU");
var $dee2dd5afa9d03f4$exports = {};
"use strict";

var $gDgMD = parcelRequire("gDgMD");
Object.defineProperty($dee2dd5afa9d03f4$exports, "__esModule", {
    value: true
});
$dee2dd5afa9d03f4$exports.alpha = $dee2dd5afa9d03f4$var$alpha;
$dee2dd5afa9d03f4$exports.blend = $dee2dd5afa9d03f4$var$blend;
$dee2dd5afa9d03f4$exports.colorChannel = void 0;
$dee2dd5afa9d03f4$exports.darken = $dee2dd5afa9d03f4$var$darken;
$dee2dd5afa9d03f4$exports.decomposeColor = $dee2dd5afa9d03f4$var$decomposeColor;
$dee2dd5afa9d03f4$exports.emphasize = $dee2dd5afa9d03f4$var$emphasize;
$dee2dd5afa9d03f4$exports.getContrastRatio = $dee2dd5afa9d03f4$var$getContrastRatio;
$dee2dd5afa9d03f4$exports.getLuminance = $dee2dd5afa9d03f4$var$getLuminance;
$dee2dd5afa9d03f4$exports.hexToRgb = $dee2dd5afa9d03f4$var$hexToRgb;
$dee2dd5afa9d03f4$exports.hslToRgb = $dee2dd5afa9d03f4$var$hslToRgb;
$dee2dd5afa9d03f4$exports.lighten = $dee2dd5afa9d03f4$var$lighten;
$dee2dd5afa9d03f4$exports.private_safeAlpha = $dee2dd5afa9d03f4$var$private_safeAlpha;
$dee2dd5afa9d03f4$exports.private_safeColorChannel = void 0;
$dee2dd5afa9d03f4$exports.private_safeDarken = $dee2dd5afa9d03f4$var$private_safeDarken;
$dee2dd5afa9d03f4$exports.private_safeEmphasize = $dee2dd5afa9d03f4$var$private_safeEmphasize;
$dee2dd5afa9d03f4$exports.private_safeLighten = $dee2dd5afa9d03f4$var$private_safeLighten;
$dee2dd5afa9d03f4$exports.recomposeColor = $dee2dd5afa9d03f4$var$recomposeColor;
$dee2dd5afa9d03f4$exports.rgbToHex = $dee2dd5afa9d03f4$var$rgbToHex;

var $dee2dd5afa9d03f4$var$_formatMuiErrorMessage2 = $gDgMD((parcelRequire("1gl5Q")));

var $dee2dd5afa9d03f4$var$_clamp = $gDgMD((parcelRequire("1B8UC")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $dee2dd5afa9d03f4$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $dee2dd5afa9d03f4$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $dee2dd5afa9d03f4$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $dee2dd5afa9d03f4$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $dee2dd5afa9d03f4$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $dee2dd5afa9d03f4$var$decomposeColor($dee2dd5afa9d03f4$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $dee2dd5afa9d03f4$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $dee2dd5afa9d03f4$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $dee2dd5afa9d03f4$var$colorChannel = (color)=>{
    const decomposedColor = $dee2dd5afa9d03f4$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
$dee2dd5afa9d03f4$exports.colorChannel = $dee2dd5afa9d03f4$var$colorChannel;
const $dee2dd5afa9d03f4$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $dee2dd5afa9d03f4$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $dee2dd5afa9d03f4$exports.private_safeColorChannel = $dee2dd5afa9d03f4$var$private_safeColorChannel;
function $dee2dd5afa9d03f4$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $dee2dd5afa9d03f4$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $dee2dd5afa9d03f4$var$decomposeColor(color);
    return `#${values.map((n, i)=>$dee2dd5afa9d03f4$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $dee2dd5afa9d03f4$var$hslToRgb(color) {
    color = $dee2dd5afa9d03f4$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $dee2dd5afa9d03f4$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $dee2dd5afa9d03f4$var$getLuminance(color) {
    color = $dee2dd5afa9d03f4$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $dee2dd5afa9d03f4$var$decomposeColor($dee2dd5afa9d03f4$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $dee2dd5afa9d03f4$var$getContrastRatio(foreground, background) {
    const lumA = $dee2dd5afa9d03f4$var$getLuminance(foreground);
    const lumB = $dee2dd5afa9d03f4$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $dee2dd5afa9d03f4$var$alpha(color, value) {
    color = $dee2dd5afa9d03f4$var$decomposeColor(color);
    value = $dee2dd5afa9d03f4$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $dee2dd5afa9d03f4$var$recomposeColor(color);
}
function $dee2dd5afa9d03f4$var$private_safeAlpha(color, value, warning) {
    try {
        return $dee2dd5afa9d03f4$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $dee2dd5afa9d03f4$var$darken(color, coefficient) {
    color = $dee2dd5afa9d03f4$var$decomposeColor(color);
    coefficient = $dee2dd5afa9d03f4$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $dee2dd5afa9d03f4$var$recomposeColor(color);
}
function $dee2dd5afa9d03f4$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $dee2dd5afa9d03f4$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $dee2dd5afa9d03f4$var$lighten(color, coefficient) {
    color = $dee2dd5afa9d03f4$var$decomposeColor(color);
    coefficient = $dee2dd5afa9d03f4$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $dee2dd5afa9d03f4$var$recomposeColor(color);
}
function $dee2dd5afa9d03f4$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $dee2dd5afa9d03f4$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $dee2dd5afa9d03f4$var$emphasize(color, coefficient = 0.15) {
    return $dee2dd5afa9d03f4$var$getLuminance(color) > 0.5 ? $dee2dd5afa9d03f4$var$darken(color, coefficient) : $dee2dd5afa9d03f4$var$lighten(color, coefficient);
}
function $dee2dd5afa9d03f4$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $dee2dd5afa9d03f4$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $dee2dd5afa9d03f4$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $dee2dd5afa9d03f4$var$decomposeColor(background);
    const overlayColor = $dee2dd5afa9d03f4$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $dee2dd5afa9d03f4$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}


const $30770034f25d7f41$var$common = {
    black: "#000",
    white: "#fff"
};
var $30770034f25d7f41$export$2e2bcd8739ae039 = $30770034f25d7f41$var$common;


const $f881fc7d2d93978f$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $f881fc7d2d93978f$export$2e2bcd8739ae039 = $f881fc7d2d93978f$var$grey;


const $6c190f0ccba41dc4$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $6c190f0ccba41dc4$export$2e2bcd8739ae039 = $6c190f0ccba41dc4$var$purple;


const $cf44c6f0ea989a5a$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $cf44c6f0ea989a5a$export$2e2bcd8739ae039 = $cf44c6f0ea989a5a$var$red;


const $ca0166d663e84aa2$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $ca0166d663e84aa2$export$2e2bcd8739ae039 = $ca0166d663e84aa2$var$orange;


const $dddce87659c5cbcc$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $dddce87659c5cbcc$export$2e2bcd8739ae039 = $dddce87659c5cbcc$var$blue;


const $2174caa215c8ea14$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $2174caa215c8ea14$export$2e2bcd8739ae039 = $2174caa215c8ea14$var$lightBlue;


const $c06929441bb2ffa2$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $c06929441bb2ffa2$export$2e2bcd8739ae039 = $c06929441bb2ffa2$var$green;


const $56fbe5002996032a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $56fbe5002996032a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $30770034f25d7f41$export$2e2bcd8739ae039).white,
        default: (0, $30770034f25d7f41$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $56fbe5002996032a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $30770034f25d7f41$export$2e2bcd8739ae039).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $30770034f25d7f41$export$2e2bcd8739ae039).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $56fbe5002996032a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $dee2dd5afa9d03f4$exports.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $dee2dd5afa9d03f4$exports.darken)(intent.main, tonalOffsetDark);
    }
}
function $56fbe5002996032a$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dddce87659c5cbcc$export$2e2bcd8739ae039)[200],
        light: (0, $dddce87659c5cbcc$export$2e2bcd8739ae039)[50],
        dark: (0, $dddce87659c5cbcc$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $dddce87659c5cbcc$export$2e2bcd8739ae039)[700],
        light: (0, $dddce87659c5cbcc$export$2e2bcd8739ae039)[400],
        dark: (0, $dddce87659c5cbcc$export$2e2bcd8739ae039)[800]
    };
}
function $56fbe5002996032a$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $6c190f0ccba41dc4$export$2e2bcd8739ae039)[200],
        light: (0, $6c190f0ccba41dc4$export$2e2bcd8739ae039)[50],
        dark: (0, $6c190f0ccba41dc4$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $6c190f0ccba41dc4$export$2e2bcd8739ae039)[500],
        light: (0, $6c190f0ccba41dc4$export$2e2bcd8739ae039)[300],
        dark: (0, $6c190f0ccba41dc4$export$2e2bcd8739ae039)[700]
    };
}
function $56fbe5002996032a$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $cf44c6f0ea989a5a$export$2e2bcd8739ae039)[500],
        light: (0, $cf44c6f0ea989a5a$export$2e2bcd8739ae039)[300],
        dark: (0, $cf44c6f0ea989a5a$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $cf44c6f0ea989a5a$export$2e2bcd8739ae039)[700],
        light: (0, $cf44c6f0ea989a5a$export$2e2bcd8739ae039)[400],
        dark: (0, $cf44c6f0ea989a5a$export$2e2bcd8739ae039)[800]
    };
}
function $56fbe5002996032a$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2174caa215c8ea14$export$2e2bcd8739ae039)[400],
        light: (0, $2174caa215c8ea14$export$2e2bcd8739ae039)[300],
        dark: (0, $2174caa215c8ea14$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $2174caa215c8ea14$export$2e2bcd8739ae039)[700],
        light: (0, $2174caa215c8ea14$export$2e2bcd8739ae039)[500],
        dark: (0, $2174caa215c8ea14$export$2e2bcd8739ae039)[900]
    };
}
function $56fbe5002996032a$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $c06929441bb2ffa2$export$2e2bcd8739ae039)[400],
        light: (0, $c06929441bb2ffa2$export$2e2bcd8739ae039)[300],
        dark: (0, $c06929441bb2ffa2$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $c06929441bb2ffa2$export$2e2bcd8739ae039)[800],
        light: (0, $c06929441bb2ffa2$export$2e2bcd8739ae039)[500],
        dark: (0, $c06929441bb2ffa2$export$2e2bcd8739ae039)[900]
    };
}
function $56fbe5002996032a$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ca0166d663e84aa2$export$2e2bcd8739ae039)[400],
        light: (0, $ca0166d663e84aa2$export$2e2bcd8739ae039)[300],
        dark: (0, $ca0166d663e84aa2$export$2e2bcd8739ae039)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $ca0166d663e84aa2$export$2e2bcd8739ae039)[500],
        dark: (0, $ca0166d663e84aa2$export$2e2bcd8739ae039)[900]
    };
}
function $56fbe5002996032a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $bKcdJ.default)(palette, $56fbe5002996032a$var$_excluded);
    const primary = palette.primary || $56fbe5002996032a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $56fbe5002996032a$var$getDefaultSecondary(mode);
    const error = palette.error || $56fbe5002996032a$var$getDefaultError(mode);
    const info = palette.info || $56fbe5002996032a$var$getDefaultInfo(mode);
    const success = palette.success || $56fbe5002996032a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $56fbe5002996032a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $dee2dd5afa9d03f4$exports.getContrastRatio)(background, $56fbe5002996032a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $56fbe5002996032a$export$55ce6f3a06c59543.text.primary : $56fbe5002996032a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $asN9r.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $aahau.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $aahau.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $56fbe5002996032a$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $56fbe5002996032a$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $56fbe5002996032a$export$55ce6f3a06c59543,
        light: $56fbe5002996032a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $cAicU.default)((0, $asN9r.default)({
        // A collection of common colors.
        common: (0, $asN9r.default)({}, (0, $30770034f25d7f41$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $f881fc7d2d93978f$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $cAicU = parcelRequire("cAicU");
const $3bd20d6900a133c3$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $3bd20d6900a133c3$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3bd20d6900a133c3$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $3bd20d6900a133c3$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3bd20d6900a133c3$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $3bd20d6900a133c3$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $bKcdJ.default)(_ref, $3bd20d6900a133c3$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $asN9r.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $3bd20d6900a133c3$var$defaultFontFamily ? {
            letterSpacing: `${$3bd20d6900a133c3$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3bd20d6900a133c3$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3bd20d6900a133c3$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $cAicU.default)((0, $asN9r.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $13c0fa42087ebc2f$var$shadowKeyUmbraOpacity = 0.2;
const $13c0fa42087ebc2f$var$shadowKeyPenumbraOpacity = 0.14;
const $13c0fa42087ebc2f$var$shadowAmbientShadowOpacity = 0.12;
function $13c0fa42087ebc2f$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$13c0fa42087ebc2f$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$13c0fa42087ebc2f$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$13c0fa42087ebc2f$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $13c0fa42087ebc2f$var$shadows = [
    "none",
    $13c0fa42087ebc2f$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $13c0fa42087ebc2f$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $13c0fa42087ebc2f$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $13c0fa42087ebc2f$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $13c0fa42087ebc2f$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $13c0fa42087ebc2f$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $13c0fa42087ebc2f$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $13c0fa42087ebc2f$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $13c0fa42087ebc2f$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $13c0fa42087ebc2f$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $13c0fa42087ebc2f$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $13c0fa42087ebc2f$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $13c0fa42087ebc2f$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $13c0fa42087ebc2f$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $13c0fa42087ebc2f$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $13c0fa42087ebc2f$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $13c0fa42087ebc2f$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $13c0fa42087ebc2f$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $13c0fa42087ebc2f$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $13c0fa42087ebc2f$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $13c0fa42087ebc2f$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $13c0fa42087ebc2f$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $13c0fa42087ebc2f$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $13c0fa42087ebc2f$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $13c0fa42087ebc2f$export$2e2bcd8739ae039 = $13c0fa42087ebc2f$var$shadows;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");
const $5b2db6b92fb325e2$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $5b2db6b92fb325e2$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $5b2db6b92fb325e2$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $5b2db6b92fb325e2$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $5b2db6b92fb325e2$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $5b2db6b92fb325e2$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $asN9r.default)({}, $5b2db6b92fb325e2$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $asN9r.default)({}, $5b2db6b92fb325e2$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $bKcdJ.default)(options, $5b2db6b92fb325e2$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $5b2db6b92fb325e2$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $5b2db6b92fb325e2$var$formatMs(delay)}`).join(",");
    };
    return (0, $asN9r.default)({
        getAutoHeightDuration: $5b2db6b92fb325e2$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $efb638af0c9c4038$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $efb638af0c9c4038$export$2e2bcd8739ae039 = $efb638af0c9c4038$var$zIndex;


const $ce605d53bd47975e$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ce605d53bd47975e$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $bKcdJ.default)(options, $ce605d53bd47975e$var$_excluded);
    if (options.vars) throw new Error((0, $aahau.default)(18));
    const palette = (0, $56fbe5002996032a$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $hjRti.default)(options);
    let muiTheme = (0, $cAicU.default)(systemTheme, {
        mixins: (0, $38b281a1bc98b9e6$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $13c0fa42087ebc2f$export$2e2bcd8739ae039).slice(),
        typography: (0, $3bd20d6900a133c3$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $5b2db6b92fb325e2$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $asN9r.default)({}, (0, $efb638af0c9c4038$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $cAicU.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $cAicU.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $asN9r.default)({}, (0, $eYiFE.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $iKUML.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ce605d53bd47975e$var$warnedOnce = false;
function $ce605d53bd47975e$export$c469355549431d9b(...args) {
    return $ce605d53bd47975e$var$createTheme(...args);
}
var $ce605d53bd47975e$export$2e2bcd8739ae039 = $ce605d53bd47975e$var$createTheme;


"use client";
const $c48003953c749b7a$var$defaultTheme = (0, $ce605d53bd47975e$export$2e2bcd8739ae039)();
var $c48003953c749b7a$export$2e2bcd8739ae039 = $c48003953c749b7a$var$defaultTheme;


var $052d61a03cfc8b91$export$2e2bcd8739ae039 = "$$material";


"use client";
function $b7748db3784530dd$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $013a09cb63d6ec53$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $c48003953c749b7a$export$2e2bcd8739ae039,
        themeId: (0, $052d61a03cfc8b91$export$2e2bcd8739ae039)
    });
}



var $ge3KO = parcelRequire("ge3KO");
const $bb8fb7867c1e81db$var$_excluded = [
    "localeText"
];
const $bb8fb7867c1e81db$export$544976378534cf9 = /*#__PURE__*/ $f2Y41.createContext(null);
const $bb8fb7867c1e81db$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $bKcdJ.default)(inProps, $bb8fb7867c1e81db$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = $f2Y41.useContext($bb8fb7867c1e81db$export$544976378534cf9) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $f2Y41.useMemo(()=>(0, $asN9r.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $f2Y41.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            "MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`",
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $f2Y41.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $f2Y41.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($bb8fb7867c1e81db$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};


/* eslint-disable class-methods-use-this */ function $aae07cb3fa09534a$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $1a14283acdfb87e7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1a14283acdfb87e7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a14283acdfb87e7$export$2e2bcd8739ae039(o);
}


function $e912b0c64a070462$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $623cd31f1b422257$export$2e2bcd8739ae039(argument) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $057e28a7bcd7463e$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}






function $f96bbde01ba29d4c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



function $b086b24f1f7a9402$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $f96bbde01ba29d4c$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}





var $1818c0788b6ee39a$var$MILLISECONDS_IN_MINUTE = 60000;
function $1818c0788b6ee39a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $f96bbde01ba29d4c$export$2e2bcd8739ae039)(dirtyDate, amount * $1818c0788b6ee39a$var$MILLISECONDS_IN_MINUTE);
}





var $b36fa09f08376b72$var$MILLISECONDS_IN_HOUR = 3600000;
function $b36fa09f08376b72$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $f96bbde01ba29d4c$export$2e2bcd8739ae039)(dirtyDate, amount * $b36fa09f08376b72$var$MILLISECONDS_IN_HOUR);
}





function $3de5231e15023496$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $057e28a7bcd7463e$export$2e2bcd8739ae039)(dirtyDate, days);
}





function $b4913fcc6bdb1810$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $e1f3845a10a6a9e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b4913fcc6bdb1810$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $2c28bfd9bdcad410$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $7af4ee9d46606c52$var$defaultOptions = {};
function $7af4ee9d46606c52$export$430a3269e24b912e() {
    return $7af4ee9d46606c52$var$defaultOptions;
}
function $7af4ee9d46606c52$export$95365be1b0704abc(newOptions) {
    $7af4ee9d46606c52$var$defaultOptions = newOptions;
}





function $43b013221f3f7aeb$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $da03cdc35d14078d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $e5b3cfd7c133e91f$export$2e2bcd8739ae039(value) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $52552ac2a147d426$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $e5b3cfd7c133e91f$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}





function $d3915e7617ed4456$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $f96bbde01ba29d4c$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $519887af93f15cca$var$MILLISECONDS_IN_DAY = 86400000;
function $519887af93f15cca$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $519887af93f15cca$var$MILLISECONDS_IN_DAY) + 1;
}





function $8b767dbd023a776c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $10d72654d9f8b41b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b767dbd023a776c$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b767dbd023a776c$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $23c168802b7367c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $10d72654d9f8b41b$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b767dbd023a776c$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $4504a8905bc22f24$var$MILLISECONDS_IN_WEEK = 604800000;
function $4504a8905bc22f24$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8b767dbd023a776c$export$2e2bcd8739ae039)(date).getTime() - (0, $23c168802b7367c2$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4504a8905bc22f24$var$MILLISECONDS_IN_WEEK) + 1;
}








function $3c6664b0b66784b4$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $3b5981a9696b248a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $b45eecc13a977074$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $3b5981a9696b248a$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $26f8128b27ef6a84$var$MILLISECONDS_IN_WEEK = 604800000;
function $26f8128b27ef6a84$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)(date, options).getTime() - (0, $b45eecc13a977074$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $26f8128b27ef6a84$var$MILLISECONDS_IN_WEEK) + 1;
}



function $c6c0e3ff4398216e$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $32aed402bd427ef6$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $32aed402bd427ef6$export$2e2bcd8739ae039 = $32aed402bd427ef6$var$formatters;


var $ed45a6b58c745883$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $ed45a6b58c745883$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $3b5981a9696b248a$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $10d72654d9f8b41b$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $26f8128b27ef6a84$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $4504a8905bc22f24$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $519887af93f15cca$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $ed45a6b58c745883$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $ed45a6b58c745883$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $ed45a6b58c745883$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $ed45a6b58c745883$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $ed45a6b58c745883$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $ed45a6b58c745883$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $32aed402bd427ef6$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $ed45a6b58c745883$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $ed45a6b58c745883$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $ed45a6b58c745883$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $ed45a6b58c745883$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $ed45a6b58c745883$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $ed45a6b58c745883$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $ed45a6b58c745883$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $ed45a6b58c745883$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $ed45a6b58c745883$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $ed45a6b58c745883$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $ed45a6b58c745883$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(minutes, 2);
}
function $ed45a6b58c745883$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $ed45a6b58c745883$var$formatTimezone(offset, dirtyDelimiter);
}
function $ed45a6b58c745883$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $c6c0e3ff4398216e$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $ed45a6b58c745883$export$2e2bcd8739ae039 = $ed45a6b58c745883$var$formatters;


var $e611160a87383778$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $e611160a87383778$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $e611160a87383778$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $e611160a87383778$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $e611160a87383778$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $e611160a87383778$var$timeLongFormatter(timePattern, formatLong));
};
var $e611160a87383778$var$longFormatters = {
    p: $e611160a87383778$var$timeLongFormatter,
    P: $e611160a87383778$var$dateTimeLongFormatter
};
var $e611160a87383778$export$2e2bcd8739ae039 = $e611160a87383778$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $68d32ed92f1780db$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $3888dd0cfb281202$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $3888dd0cfb281202$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $3888dd0cfb281202$export$c6cc36aa33304772(token) {
    return $3888dd0cfb281202$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $3888dd0cfb281202$export$c6b49d6dceb604a1(token) {
    return $3888dd0cfb281202$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $3888dd0cfb281202$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $6509bf9d69ff4a3a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $6509bf9d69ff4a3a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6509bf9d69ff4a3a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $6509bf9d69ff4a3a$export$2e2bcd8739ae039 = $6509bf9d69ff4a3a$var$formatDistance;


function $5f036d23028c0fac$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $fb7a03ea05021186$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $fb7a03ea05021186$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $fb7a03ea05021186$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $fb7a03ea05021186$var$formatLong = {
    date: (0, $5f036d23028c0fac$export$2e2bcd8739ae039)({
        formats: $fb7a03ea05021186$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $5f036d23028c0fac$export$2e2bcd8739ae039)({
        formats: $fb7a03ea05021186$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $5f036d23028c0fac$export$2e2bcd8739ae039)({
        formats: $fb7a03ea05021186$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fb7a03ea05021186$export$2e2bcd8739ae039 = $fb7a03ea05021186$var$formatLong;


var $ba192188e63e0b01$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $ba192188e63e0b01$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ba192188e63e0b01$var$formatRelativeLocale[token];
};
var $ba192188e63e0b01$export$2e2bcd8739ae039 = $ba192188e63e0b01$var$formatRelative;


function $d4d44c74afe1d557$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $14b2ca9d0756a8fe$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $14b2ca9d0756a8fe$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $14b2ca9d0756a8fe$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $14b2ca9d0756a8fe$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $14b2ca9d0756a8fe$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $14b2ca9d0756a8fe$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $14b2ca9d0756a8fe$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $14b2ca9d0756a8fe$var$localize = {
    ordinalNumber: $14b2ca9d0756a8fe$var$ordinalNumber,
    era: (0, $d4d44c74afe1d557$export$2e2bcd8739ae039)({
        values: $14b2ca9d0756a8fe$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $d4d44c74afe1d557$export$2e2bcd8739ae039)({
        values: $14b2ca9d0756a8fe$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $d4d44c74afe1d557$export$2e2bcd8739ae039)({
        values: $14b2ca9d0756a8fe$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $d4d44c74afe1d557$export$2e2bcd8739ae039)({
        values: $14b2ca9d0756a8fe$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $d4d44c74afe1d557$export$2e2bcd8739ae039)({
        values: $14b2ca9d0756a8fe$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $14b2ca9d0756a8fe$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $14b2ca9d0756a8fe$export$2e2bcd8739ae039 = $14b2ca9d0756a8fe$var$localize;


function $5a5da10cee2acf25$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $5a5da10cee2acf25$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $5a5da10cee2acf25$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $5a5da10cee2acf25$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $5a5da10cee2acf25$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $300c4741d5fc29fc$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $2c02d1efa839b750$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2c02d1efa839b750$var$parseOrdinalNumberPattern = /\d+/i;
var $2c02d1efa839b750$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $2c02d1efa839b750$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $2c02d1efa839b750$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $2c02d1efa839b750$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2c02d1efa839b750$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $2c02d1efa839b750$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2c02d1efa839b750$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $2c02d1efa839b750$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $2c02d1efa839b750$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2c02d1efa839b750$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2c02d1efa839b750$var$match = {
    ordinalNumber: (0, $300c4741d5fc29fc$export$2e2bcd8739ae039)({
        matchPattern: $2c02d1efa839b750$var$matchOrdinalNumberPattern,
        parsePattern: $2c02d1efa839b750$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5a5da10cee2acf25$export$2e2bcd8739ae039)({
        matchPatterns: $2c02d1efa839b750$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c02d1efa839b750$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $5a5da10cee2acf25$export$2e2bcd8739ae039)({
        matchPatterns: $2c02d1efa839b750$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c02d1efa839b750$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5a5da10cee2acf25$export$2e2bcd8739ae039)({
        matchPatterns: $2c02d1efa839b750$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c02d1efa839b750$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $5a5da10cee2acf25$export$2e2bcd8739ae039)({
        matchPatterns: $2c02d1efa839b750$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c02d1efa839b750$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $5a5da10cee2acf25$export$2e2bcd8739ae039)({
        matchPatterns: $2c02d1efa839b750$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2c02d1efa839b750$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2c02d1efa839b750$export$2e2bcd8739ae039 = $2c02d1efa839b750$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b29686030002c990$var$locale = {
    code: "en-US",
    formatDistance: (0, $6509bf9d69ff4a3a$export$2e2bcd8739ae039),
    formatLong: (0, $fb7a03ea05021186$export$2e2bcd8739ae039),
    formatRelative: (0, $ba192188e63e0b01$export$2e2bcd8739ae039),
    localize: (0, $14b2ca9d0756a8fe$export$2e2bcd8739ae039),
    match: (0, $2c02d1efa839b750$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b29686030002c990$export$2e2bcd8739ae039 = $b29686030002c990$var$locale;


var $11c73620e3946d30$export$2e2bcd8739ae039 = (0, $b29686030002c990$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $016afe2497ddcf15$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $016afe2497ddcf15$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $016afe2497ddcf15$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $016afe2497ddcf15$var$doubleQuoteRegExp = /''/g;
var $016afe2497ddcf15$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $016afe2497ddcf15$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $11c73620e3946d30$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $52552ac2a147d426$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $68d32ed92f1780db$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $d3915e7617ed4456$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($016afe2497ddcf15$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $e611160a87383778$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($016afe2497ddcf15$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $016afe2497ddcf15$var$cleanEscapedString(substring);
        var formatter = (0, $ed45a6b58c745883$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $3888dd0cfb281202$export$c6b49d6dceb604a1)(substring)) (0, $3888dd0cfb281202$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $3888dd0cfb281202$export$c6cc36aa33304772)(substring)) (0, $3888dd0cfb281202$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($016afe2497ddcf15$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $016afe2497ddcf15$var$cleanEscapedString(input) {
    var matched = input.match($016afe2497ddcf15$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($016afe2497ddcf15$var$doubleQuoteRegExp, "'");
}




function $d98e4446641620e5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}




function $23fd7a21803b63e4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}




function $38e0d60ca069f3a5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $9cdf9842f312371a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}




function $06ba3ec9afa6fb3e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}




function $2a96ebeb48c91e25$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $122757576789d508$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
}






function $382e693b33dc1e37$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}







function $fdaa11732e7d2cb9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $382e693b33dc1e37$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $382e693b33dc1e37$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $2eb42595a95fee9f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $fdaa11732e7d2cb9$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $382e693b33dc1e37$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $667912e0977a03b1$var$MILLISECONDS_IN_WEEK = 604800000;
function $667912e0977a03b1$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $382e693b33dc1e37$export$2e2bcd8739ae039)(date, options).getTime() - (0, $2eb42595a95fee9f$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $667912e0977a03b1$var$MILLISECONDS_IN_WEEK) + 1;
}




function $e9c8d6dc3423cf10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    return (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $cb9113cdcbfba2ec$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $29affcf2b2a53764$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $f778754b137edf54$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $74f52af975a975f2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $11742558fbc4a6fe$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $74f52af975a975f2$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $74f52af975a975f2$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $6d422daadeab8ab6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $6a02b7eb86d7d709$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $095cf185dd159b93$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $b5f0a912068894c3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $095cf185dd159b93$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $095cf185dd159b93$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}




function $22063f549fb15875$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $5d89a7a782b080b9$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $22063f549fb15875$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $22063f549fb15875$export$2e2bcd8739ae039)(o, minLen);
}


function $ce2c97a995e260e8$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $5d89a7a782b080b9$export$2e2bcd8739ae039)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}





function $7283669ee1bb00fd$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}







function $3de3f998b209e608$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $888a480a6b8ed2ee$export$2e2bcd8739ae039(o, p) {
    $888a480a6b8ed2ee$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $888a480a6b8ed2ee$export$2e2bcd8739ae039(o, p);
}


function $4cbcb6406e9c00b4$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $888a480a6b8ed2ee$export$2e2bcd8739ae039)(subClass, superClass);
}


function $4a3faec747183332$export$2e2bcd8739ae039(o) {
    $4a3faec747183332$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4a3faec747183332$export$2e2bcd8739ae039(o);
}


function $3e4cd63e66edd4db$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3e4cd63e66edd4db$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $af12f7087a0667d8$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3de3f998b209e608$export$2e2bcd8739ae039)(self);
}


function $9a883d355d6d521c$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $3e4cd63e66edd4db$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $4a3faec747183332$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4a3faec747183332$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $af12f7087a0667d8$export$2e2bcd8739ae039)(this, result);
    };
}


function $00aae2dd90ab1888$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $170ea1a8eb715b8c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $89fc5a2109771035$export$2e2bcd8739ae039(t) {
    var i = (0, $170ea1a8eb715b8c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $d8274a91c4ffb49e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $89fc5a2109771035$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $d8274a91c4ffb49e$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $d8274a91c4ffb49e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d8274a91c4ffb49e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $3d2a22ffe0c45568$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $89fc5a2109771035$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $41d7a02e27459282$var$TIMEZONE_UNIT_PRIORITY = 10;
var $41d7a02e27459282$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Setter);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $41d7a02e27459282$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($41d7a02e27459282$export$81d53e3678089a6);
var $41d7a02e27459282$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this2), "priority", $41d7a02e27459282$var$TIMEZONE_UNIT_PRIORITY);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($41d7a02e27459282$export$81d53e3678089a6);












var $e277ee0d99f49c23$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Parser);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $41d7a02e27459282$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $1b2b84c6abc687ef$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $b6ca4c76ce566a2f$export$dfd9b671c89acc8e = 7;
var $b6ca4c76ce566a2f$export$3913210603d8e9ae = 365.2425;
var $b6ca4c76ce566a2f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $b6ca4c76ce566a2f$export$91246f0b9bd9beff = 60000;
var $b6ca4c76ce566a2f$export$7f72910d6dfd237a = 3600000;
var $b6ca4c76ce566a2f$export$397c2d5776aa9055 = 1000;
var $b6ca4c76ce566a2f$export$4dec998e48f9c246 = -$b6ca4c76ce566a2f$export$81caae6e1cc7a622;
var $b6ca4c76ce566a2f$export$f2f5ae5a8e2d8f9f = 60;
var $b6ca4c76ce566a2f$export$3c58128db900d44e = 3;
var $b6ca4c76ce566a2f$export$80d7e435f744f319 = 12;
var $b6ca4c76ce566a2f$export$4db7641526e3241f = 4;
var $b6ca4c76ce566a2f$export$698aec755e92c695 = 3600;
var $b6ca4c76ce566a2f$export$a77c1a7ebebe2a5a = 60;
var $b6ca4c76ce566a2f$export$815a9362476d2fe3 = $b6ca4c76ce566a2f$export$698aec755e92c695 * 24;
var $b6ca4c76ce566a2f$export$34804a017b31e2fe = $b6ca4c76ce566a2f$export$815a9362476d2fe3 * 7;
var $b6ca4c76ce566a2f$export$7271e9e3478110d1 = $b6ca4c76ce566a2f$export$815a9362476d2fe3 * $b6ca4c76ce566a2f$export$3913210603d8e9ae;
var $b6ca4c76ce566a2f$export$8e6600bbdee7dabb = $b6ca4c76ce566a2f$export$7271e9e3478110d1 / 12;
var $b6ca4c76ce566a2f$export$be1dccf2de902d31 = $b6ca4c76ce566a2f$export$8e6600bbdee7dabb * 3;


var $50632467d5d4ab1c$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $50632467d5d4ab1c$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $85a3443f7289a5e2$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $85a3443f7289a5e2$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $85a3443f7289a5e2$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $b6ca4c76ce566a2f$export$7f72910d6dfd237a) + minutes * (0, $b6ca4c76ce566a2f$export$91246f0b9bd9beff) + seconds * (0, $b6ca4c76ce566a2f$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $85a3443f7289a5e2$export$d931c43c4608a164(dateString) {
    return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $85a3443f7289a5e2$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $85a3443f7289a5e2$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388((0, $50632467d5d4ab1c$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $85a3443f7289a5e2$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $85a3443f7289a5e2$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $85a3443f7289a5e2$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $85a3443f7289a5e2$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $3c6403bdc69a8fed$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $85a3443f7289a5e2$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));












var $b5eb68f03f911abe$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $3b5981a9696b248a$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $85a3443f7289a5e2$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $5f027a4cef1d96a4$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $85a3443f7289a5e2$export$2c9307b2e29c533c)(4, dateString);
                return (0, $85a3443f7289a5e2$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $8b767dbd023a776c$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $80e1063660e641ae$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $85a3443f7289a5e2$export$2c9307b2e29c533c)(4, dateString);
                return (0, $85a3443f7289a5e2$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $ddd89c2fa3e42254$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $14e63fc18d008279$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $23bb8acaeda4824a$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $ac28810e2658cfb1$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));















function $e393d37153756894$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $26f8128b27ef6a84$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $afc62203cfc102d7$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $3c6664b0b66784b4$export$2e2bcd8739ae039)((0, $e393d37153756894$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));















function $1615a10d81ad57fb$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $4504a8905bc22f24$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $3256dbb5062fb53f$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $8b767dbd023a776c$export$2e2bcd8739ae039)((0, $1615a10d81ad57fb$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $949c173b0eeca18e$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $949c173b0eeca18e$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $949c173b0eeca18e$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $85a3443f7289a5e2$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $949c173b0eeca18e$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $949c173b0eeca18e$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $9a5e7dc9c5ad2b27$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $85a3443f7289a5e2$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));













function $f5932acf5cac5a4a$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $70b4aa974957c625$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f5932acf5cac5a4a$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $23c0d9d99ddc1af1$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f5932acf5cac5a4a$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $88c559b247ae354a$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f5932acf5cac5a4a$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));













function $2b8dad779565b198$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $65fe0977b08bc8c5$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $2b8dad779565b198$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $ff2fd744257a06fe$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $85a3443f7289a5e2$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $6fcd97394b92ac28$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $85a3443f7289a5e2$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $4718c50e792324f1$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $85a3443f7289a5e2$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $3866d7e4c7fdea6d$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $4623e66fc7d0de0a$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $fef2d3e91ed9cfec$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $1eafbcc0bdb26340$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $46095c6d6daa2a44$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $767a6ca59534f665$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $85a3443f7289a5e2$export$cc7cc9e2a3ff9388)((0, $50632467d5d4ab1c$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $72fcd63b2c675744$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $85a3443f7289a5e2$export$4f84e3a82c7b538)((0, $85a3443f7289a5e2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $ba45f58ef0e89611$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));











var $bde8c8246a712930$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $85a3443f7289a5e2$export$6497f4c0ecdfba8e)((0, $50632467d5d4ab1c$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $30ede6a1af3b6a1e$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $85a3443f7289a5e2$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));










var $5acdd248a5ec8ba9$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $85a3443f7289a5e2$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $e277ee0d99f49c23$export$7acfa6ed01010e37));


var $e0f355e898527a64$export$19131010e7fd8373 = {
    G: new (0, $1b2b84c6abc687ef$export$8e5a1d3f85a9688)(),
    y: new (0, $3c6403bdc69a8fed$export$48d352de7cd4a988)(),
    Y: new (0, $b5eb68f03f911abe$export$b8ef38dfcf05d5db)(),
    R: new (0, $5f027a4cef1d96a4$export$951d1df011fde06f)(),
    u: new (0, $80e1063660e641ae$export$bad9d2ea38e8f1a)(),
    Q: new (0, $ddd89c2fa3e42254$export$5cb0f701186dde1d)(),
    q: new (0, $14e63fc18d008279$export$300c0c2990e20e6d)(),
    M: new (0, $23bb8acaeda4824a$export$400dd8b40ef138a3)(),
    L: new (0, $ac28810e2658cfb1$export$1d7eaa53eaa5deba)(),
    w: new (0, $afc62203cfc102d7$export$c4005ffc174e07c0)(),
    I: new (0, $3256dbb5062fb53f$export$6fc8dbedd560a6af)(),
    d: new (0, $949c173b0eeca18e$export$e8d4b28a20981dd2)(),
    D: new (0, $9a5e7dc9c5ad2b27$export$6cfe0d613455f615)(),
    E: new (0, $70b4aa974957c625$export$1b03c8b76262f7bd)(),
    e: new (0, $23c0d9d99ddc1af1$export$44d1c127ab42c480)(),
    c: new (0, $88c559b247ae354a$export$e447a647caaaec1d)(),
    i: new (0, $65fe0977b08bc8c5$export$693fb1e525095b2a)(),
    a: new (0, $ff2fd744257a06fe$export$8d1e08492351df91)(),
    b: new (0, $6fcd97394b92ac28$export$73ca2bd0a17d273)(),
    B: new (0, $4718c50e792324f1$export$bb9212adf05373db)(),
    h: new (0, $3866d7e4c7fdea6d$export$8a04050a727a1756)(),
    H: new (0, $4623e66fc7d0de0a$export$e56f4dea2c3e56dd)(),
    K: new (0, $fef2d3e91ed9cfec$export$cbbe855312f87d77)(),
    k: new (0, $1eafbcc0bdb26340$export$6008046d2b34b6a5)(),
    m: new (0, $46095c6d6daa2a44$export$2b52670d9e2be53)(),
    s: new (0, $767a6ca59534f665$export$94d46d540cf1366a)(),
    S: new (0, $72fcd63b2c675744$export$b8e6f8b2d70893b1)(),
    X: new (0, $ba45f58ef0e89611$export$104d901d49fea29b)(),
    x: new (0, $bde8c8246a712930$export$12910e5204b52b9)(),
    t: new (0, $30ede6a1af3b6a1e$export$2cd8bf877a05e96)(),
    T: new (0, $5acdd248a5ec8ba9$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4451ff85a7fe9f66$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4451ff85a7fe9f66$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4451ff85a7fe9f66$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4451ff85a7fe9f66$var$doubleQuoteRegExp = /''/g;
var $4451ff85a7fe9f66$var$notWhitespaceRegExp = /\S/;
var $4451ff85a7fe9f66$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4451ff85a7fe9f66$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $11c73620e3946d30$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $41d7a02e27459282$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($4451ff85a7fe9f66$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $e611160a87383778$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $e611160a87383778$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4451ff85a7fe9f66$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $ce2c97a995e260e8$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $3888dd0cfb281202$export$c6b49d6dceb604a1)(token)) (0, $3888dd0cfb281202$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $3888dd0cfb281202$export$c6cc36aa33304772)(token)) (0, $3888dd0cfb281202$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $e0f355e898527a64$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($4451ff85a7fe9f66$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $4451ff85a7fe9f66$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $4451ff85a7fe9f66$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $d3915e7617ed4456$export$2e2bcd8739ae039)(date, (0, $68d32ed92f1780db$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $ce2c97a995e260e8$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $7283669ee1bb00fd$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $4451ff85a7fe9f66$var$cleanEscapedString(input) {
    return input.match($4451ff85a7fe9f66$var$escapedStringRegExp)[1].replace($4451ff85a7fe9f66$var$doubleQuoteRegExp, "'");
}





function $2cc71e2af65195f2$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}





function $51c5ff09bdbe4792$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $7f568f586fc1d022$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $18b40054bc301b0e$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $23fd7a21803b63e4$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $e92939a6fb166874$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $dc6f952588a04796$export$2e2bcd8739ae039(dirtyDate, dirtyMilliseconds) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
}





function $629d20814529add6$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $016a503334b4bc50$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $1998d501cf11367e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $f277db5687bb9f32$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $19f629ea86cab1d0$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}




var $7iyvN = parcelRequire("7iyvN");

var $asN9r = parcelRequire("asN9r");
/* eslint-disable class-methods-use-this */ const $a7ef671bc0bfda76$var$formatTokenMap = {
    // Year
    y: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    yy: "year",
    yyy: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    yyyy: "year",
    // Month
    M: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    MM: "month",
    MMMM: {
        sectionType: "month",
        contentType: "letter"
    },
    MMM: {
        sectionType: "month",
        contentType: "letter"
    },
    L: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    LL: "month",
    LLL: {
        sectionType: "month",
        contentType: "letter"
    },
    LLLL: {
        sectionType: "month",
        contentType: "letter"
    },
    // Day of the month
    d: {
        sectionType: "day",
        contentType: "digit",
        maxLength: 2
    },
    dd: "day",
    do: {
        sectionType: "day",
        contentType: "digit-with-letter"
    },
    // Day of the week
    E: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEEEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    i: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    ii: "weekDay",
    iii: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    iiii: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    e: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    ee: "weekDay",
    eee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    eeee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    eeeee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    eeeeee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    c: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    cc: "weekDay",
    ccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    cccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    ccccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    cccccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    // Meridiem
    a: "meridiem",
    aa: "meridiem",
    aaa: "meridiem",
    // Hours
    H: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    HH: "hours",
    h: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    hh: "hours",
    // Minutes
    m: {
        sectionType: "minutes",
        contentType: "digit",
        maxLength: 2
    },
    mm: "minutes",
    // Seconds
    s: {
        sectionType: "seconds",
        contentType: "digit",
        maxLength: 2
    },
    ss: "seconds"
};
const $a7ef671bc0bfda76$var$defaultFormats = {
    year: "yyyy",
    month: "LLLL",
    monthShort: "MMM",
    dayOfMonth: "d",
    dayOfMonthFull: "do",
    weekday: "EEEE",
    weekdayShort: "EEEEEE",
    hours24h: "HH",
    hours12h: "hh",
    meridiem: "aa",
    minutes: "mm",
    seconds: "ss",
    fullDate: "PP",
    keyboardDate: "P",
    shortDate: "MMM d",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    fullTime: "p",
    fullTime12h: "hh:mm aa",
    fullTime24h: "HH:mm",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aa",
    keyboardDateTime24h: "P HH:mm"
};
class $a7ef671bc0bfda76$export$e330e9acbbe873f1 {
    constructor(props){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = false;
        this.lib = "date-fns";
        this.locale = void 0;
        this.formats = void 0;
        this.formatTokenMap = $a7ef671bc0bfda76$var$formatTokenMap;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.longFormatters = void 0;
        this.date = (value)=>{
            if (typeof value === "undefined") return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.getInvalidDate = ()=>new Date("Invalid Date");
        this.getTimezone = ()=>{
            return "default";
        };
        this.setTimezone = (value)=>{
            return value;
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale?.code || "en-US";
        };
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            if (this.locale) return /a/.test(this.locale.formatLong.time({
                width: "short"
            }));
            // By default, date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = this.longFormatters[firstCharacter];
                    return longFormatter(token, this.locale.formatLong);
                }
                return token;
            }).join("");
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDayOfWeek = (value)=>{
            return value.getDay() + 1;
        };
        const { locale: locale, formats: formats, longFormatters: longFormatters } = props;
        this.locale = locale;
        this.formats = (0, $asN9r.default)({}, $a7ef671bc0bfda76$var$defaultFormats, formats);
        this.longFormatters = longFormatters;
    }
}


class $98c8899302adcdc5$export$81f56c0329a1921d extends (0, $a7ef671bc0bfda76$export$e330e9acbbe873f1) {
    constructor({ locale: locale, formats: formats } = {}){
        if (typeof (0, $057e28a7bcd7463e$export$2e2bcd8739ae039) !== "function") throw new Error([
            "MUI: The `date-fns` package v3.x is not compatible with this adapter.",
            "Please, install v2.x of the package or use the `AdapterDateFnsV3` instead."
        ].join("\n"));
        super({
            locale: locale ?? (0, $b29686030002c990$export$2e2bcd8739ae039),
            formats: formats,
            longFormatters: (/*@__PURE__*/$parcel$interopDefault($7iyvN))
        });
        this.parse = (value, format)=>{
            if (value === "") return null;
            return (0, $4451ff85a7fe9f66$export$2e2bcd8739ae039)(value, format, new Date(), {
                locale: this.locale
            });
        };
        this.isValid = (value)=>{
            if (value == null) return false;
            return (0, $52552ac2a147d426$export$2e2bcd8739ae039)(value);
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return (0, $016afe2497ddcf15$export$2e2bcd8739ae039)(value, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return (0, $f778754b137edf54$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $6d422daadeab8ab6$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $6a02b7eb86d7d709$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $11742558fbc4a6fe$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $b5f0a912068894c3$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfter = (value, comparing)=>{
            return (0, $cb9113cdcbfba2ec$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfterYear = (value, comparing)=>{
            return (0, $cb9113cdcbfba2ec$export$2e2bcd8739ae039)(value, (0, $da03cdc35d14078d$export$2e2bcd8739ae039)(comparing));
        };
        this.isAfterDay = (value, comparing)=>{
            return (0, $cb9113cdcbfba2ec$export$2e2bcd8739ae039)(value, (0, $2c28bfd9bdcad410$export$2e2bcd8739ae039)(comparing));
        };
        this.isBefore = (value, comparing)=>{
            return (0, $29affcf2b2a53764$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isBeforeYear = (value, comparing)=>{
            return (0, $29affcf2b2a53764$export$2e2bcd8739ae039)(value, this.startOfYear(comparing));
        };
        this.isBeforeDay = (value, comparing)=>{
            return (0, $29affcf2b2a53764$export$2e2bcd8739ae039)(value, this.startOfDay(comparing));
        };
        this.isWithinRange = (value, [start, end])=>{
            return (0, $19f629ea86cab1d0$export$2e2bcd8739ae039)(value, {
                start: start,
                end: end
            });
        };
        this.startOfYear = (value)=>{
            return (0, $f277db5687bb9f32$export$2e2bcd8739ae039)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $016a503334b4bc50$export$2e2bcd8739ae039)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $382e693b33dc1e37$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.startOfDay = (value)=>{
            return (0, $74f52af975a975f2$export$2e2bcd8739ae039)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $da03cdc35d14078d$export$2e2bcd8739ae039)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $1998d501cf11367e$export$2e2bcd8739ae039)(value);
        };
        this.endOfWeek = (value)=>{
            return (0, $43b013221f3f7aeb$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.endOfDay = (value)=>{
            return (0, $2c28bfd9bdcad410$export$2e2bcd8739ae039)(value);
        };
        this.addYears = (value, amount)=>{
            return (0, $e1f3845a10a6a9e9$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMonths = (value, amount)=>{
            return (0, $b4913fcc6bdb1810$export$2e2bcd8739ae039)(value, amount);
        };
        this.addWeeks = (value, amount)=>{
            return (0, $3de5231e15023496$export$2e2bcd8739ae039)(value, amount);
        };
        this.addDays = (value, amount)=>{
            return (0, $057e28a7bcd7463e$export$2e2bcd8739ae039)(value, amount);
        };
        this.addHours = (value, amount)=>{
            return (0, $b36fa09f08376b72$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMinutes = (value, amount)=>{
            return (0, $1818c0788b6ee39a$export$2e2bcd8739ae039)(value, amount);
        };
        this.addSeconds = (value, amount)=>{
            return (0, $b086b24f1f7a9402$export$2e2bcd8739ae039)(value, amount);
        };
        this.getYear = (value)=>{
            return (0, $e9c8d6dc3423cf10$export$2e2bcd8739ae039)(value);
        };
        this.getMonth = (value)=>{
            return (0, $06ba3ec9afa6fb3e$export$2e2bcd8739ae039)(value);
        };
        this.getDate = (value)=>{
            return (0, $d98e4446641620e5$export$2e2bcd8739ae039)(value);
        };
        this.getHours = (value)=>{
            return (0, $38e0d60ca069f3a5$export$2e2bcd8739ae039)(value);
        };
        this.getMinutes = (value)=>{
            return (0, $9cdf9842f312371a$export$2e2bcd8739ae039)(value);
        };
        this.getSeconds = (value)=>{
            return (0, $2a96ebeb48c91e25$export$2e2bcd8739ae039)(value);
        };
        this.getMilliseconds = (value)=>{
            return (0, $122757576789d508$export$2e2bcd8739ae039)(value);
        };
        this.setYear = (value, year)=>{
            return (0, $629d20814529add6$export$2e2bcd8739ae039)(value, year);
        };
        this.setMonth = (value, month)=>{
            return (0, $18b40054bc301b0e$export$2e2bcd8739ae039)(value, month);
        };
        this.setDate = (value, date)=>{
            return (0, $2cc71e2af65195f2$export$2e2bcd8739ae039)(value, date);
        };
        this.setHours = (value, hours)=>{
            return (0, $51c5ff09bdbe4792$export$2e2bcd8739ae039)(value, hours);
        };
        this.setMinutes = (value, minutes)=>{
            return (0, $7f568f586fc1d022$export$2e2bcd8739ae039)(value, minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return (0, $e92939a6fb166874$export$2e2bcd8739ae039)(value, seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return (0, $dc6f952588a04796$export$2e2bcd8739ae039)(value, milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return (0, $23fd7a21803b63e4$export$2e2bcd8739ae039)(value);
        };
        this.getWeekArray = (value)=>{
            const start = this.startOfWeek(this.startOfMonth(value));
            const end = this.endOfWeek(this.endOfMonth(value));
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(this.isBefore(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return (0, $667912e0977a03b1$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
    }
}




var $f2Y41 = parcelRequire("f2Y41");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f14fedbe4e80ae23$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f14fedbe4e80ae23$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f14fedbe4e80ae23$var$noop = function() {};
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var $f14fedbe4e80ae23$var$UNDEFINED = /*#__NOINLINE__*/ $f14fedbe4e80ae23$var$noop();
var $f14fedbe4e80ae23$var$OBJECT = Object;
var $f14fedbe4e80ae23$var$isUndefined = function(v) {
    return v === $f14fedbe4e80ae23$var$UNDEFINED;
};
var $f14fedbe4e80ae23$var$isFunction = function(v) {
    return typeof v == "function";
};
var $f14fedbe4e80ae23$var$mergeObjects = function(a, b) {
    return $f14fedbe4e80ae23$var$OBJECT.assign({}, a, b);
};
var $f14fedbe4e80ae23$var$STR_UNDEFINED = "undefined";
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var $f14fedbe4e80ae23$var$hasWindow = function() {
    return typeof window != $f14fedbe4e80ae23$var$STR_UNDEFINED;
};
var $f14fedbe4e80ae23$var$hasDocument = function() {
    return typeof document != $f14fedbe4e80ae23$var$STR_UNDEFINED;
};
var $f14fedbe4e80ae23$var$hasRequestAnimationFrame = function() {
    return $f14fedbe4e80ae23$var$hasWindow() && typeof window["requestAnimationFrame"] != $f14fedbe4e80ae23$var$STR_UNDEFINED;
};
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $f14fedbe4e80ae23$var$table = new WeakMap();
// counter of the key
var $f14fedbe4e80ae23$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var $f14fedbe4e80ae23$var$stableHash = function(arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if ($f14fedbe4e80ae23$var$OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $f14fedbe4e80ae23$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$f14fedbe4e80ae23$var$counter + "~";
        $f14fedbe4e80ae23$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $f14fedbe4e80ae23$var$stableHash(arg[index]) + ",";
            $f14fedbe4e80ae23$var$table.set(arg, result);
        }
        if (constructor == $f14fedbe4e80ae23$var$OBJECT) {
            // Object, sort keys.
            result = "#";
            var keys = $f14fedbe4e80ae23$var$OBJECT.keys(arg).sort();
            while(!$f14fedbe4e80ae23$var$isUndefined(index = keys.pop()))if (!$f14fedbe4e80ae23$var$isUndefined(arg[index])) result += index + ":" + $f14fedbe4e80ae23$var$stableHash(arg[index]) + ",";
            $f14fedbe4e80ae23$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */ var $f14fedbe4e80ae23$var$online = true;
var $f14fedbe4e80ae23$var$isOnline = function() {
    return $f14fedbe4e80ae23$var$online;
};
var $f14fedbe4e80ae23$var$hasWin = $f14fedbe4e80ae23$var$hasWindow();
var $f14fedbe4e80ae23$var$hasDoc = $f14fedbe4e80ae23$var$hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var $f14fedbe4e80ae23$var$onWindowEvent = $f14fedbe4e80ae23$var$hasWin && window.addEventListener ? window.addEventListener.bind(window) : $f14fedbe4e80ae23$var$noop;
var $f14fedbe4e80ae23$var$onDocumentEvent = $f14fedbe4e80ae23$var$hasDoc ? document.addEventListener.bind(document) : $f14fedbe4e80ae23$var$noop;
var $f14fedbe4e80ae23$var$offWindowEvent = $f14fedbe4e80ae23$var$hasWin && window.removeEventListener ? window.removeEventListener.bind(window) : $f14fedbe4e80ae23$var$noop;
var $f14fedbe4e80ae23$var$offDocumentEvent = $f14fedbe4e80ae23$var$hasDoc ? document.removeEventListener.bind(document) : $f14fedbe4e80ae23$var$noop;
var $f14fedbe4e80ae23$var$isVisible = function() {
    var visibilityState = $f14fedbe4e80ae23$var$hasDoc && document.visibilityState;
    return $f14fedbe4e80ae23$var$isUndefined(visibilityState) || visibilityState !== "hidden";
};
var $f14fedbe4e80ae23$var$initFocus = function(callback) {
    // focus revalidate
    $f14fedbe4e80ae23$var$onDocumentEvent("visibilitychange", callback);
    $f14fedbe4e80ae23$var$onWindowEvent("focus", callback);
    return function() {
        $f14fedbe4e80ae23$var$offDocumentEvent("visibilitychange", callback);
        $f14fedbe4e80ae23$var$offWindowEvent("focus", callback);
    };
};
var $f14fedbe4e80ae23$var$initReconnect = function(callback) {
    // revalidate on reconnected
    var onOnline = function() {
        $f14fedbe4e80ae23$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function() {
        $f14fedbe4e80ae23$var$online = false;
    };
    $f14fedbe4e80ae23$var$onWindowEvent("online", onOnline);
    $f14fedbe4e80ae23$var$onWindowEvent("offline", onOffline);
    return function() {
        $f14fedbe4e80ae23$var$offWindowEvent("online", onOnline);
        $f14fedbe4e80ae23$var$offWindowEvent("offline", onOffline);
    };
};
var $f14fedbe4e80ae23$var$preset = {
    isOnline: $f14fedbe4e80ae23$var$isOnline,
    isVisible: $f14fedbe4e80ae23$var$isVisible
};
var $f14fedbe4e80ae23$var$defaultConfigOptions = {
    initFocus: $f14fedbe4e80ae23$var$initFocus,
    initReconnect: $f14fedbe4e80ae23$var$initReconnect
};
var $f14fedbe4e80ae23$var$IS_SERVER = !$f14fedbe4e80ae23$var$hasWindow() || "Deno" in window;
// Polyfill requestAnimationFrame
var $f14fedbe4e80ae23$var$rAF = function(f) {
    return $f14fedbe4e80ae23$var$hasRequestAnimationFrame() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var $f14fedbe4e80ae23$var$useIsomorphicLayoutEffect = $f14fedbe4e80ae23$var$IS_SERVER ? (0, $f2Y41.useEffect) : (0, $f2Y41.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
var $f14fedbe4e80ae23$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var $f14fedbe4e80ae23$var$slowConnection = !$f14fedbe4e80ae23$var$IS_SERVER && $f14fedbe4e80ae23$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($f14fedbe4e80ae23$var$navigatorConnection.effectiveType) || $f14fedbe4e80ae23$var$navigatorConnection.saveData);
var $f14fedbe4e80ae23$var$serialize = function(key) {
    if ($f14fedbe4e80ae23$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $f14fedbe4e80ae23$var$stableHash(key) : "";
    var infoKey = key ? "$swr$" + key : "";
    return [
        key,
        args,
        infoKey
    ];
};
// Global state used to deduplicate requests and store listeners
var $f14fedbe4e80ae23$var$SWRGlobalState = new WeakMap();
var $f14fedbe4e80ae23$var$FOCUS_EVENT = 0;
var $f14fedbe4e80ae23$var$RECONNECT_EVENT = 1;
var $f14fedbe4e80ae23$var$MUTATE_EVENT = 2;
var $f14fedbe4e80ae23$var$broadcastState = function(cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) broadcast = true;
    var _a = $f14fedbe4e80ae23$var$SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) for(var i = 0; i < updaters.length; ++i)updaters[i](data, error, isValidating);
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) return revalidators[0]($f14fedbe4e80ae23$var$MUTATE_EVENT).then(function() {
            return cache.get(key);
        });
    }
    return cache.get(key);
};
// Global timestamp.
var $f14fedbe4e80ae23$var$__timestamp = 0;
var $f14fedbe4e80ae23$var$getTimestamp = function() {
    return ++$f14fedbe4e80ae23$var$__timestamp;
};
var $f14fedbe4e80ae23$var$internalMutate = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $f14fedbe4e80ae23$var$__awaiter(void 0, void 0, void 0, function() {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
        return $f14fedbe4e80ae23$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === "boolean" ? {
                        revalidate: _opts
                    } : _opts || {};
                    populateCache = $f14fedbe4e80ae23$var$isUndefined(options.populateCache) ? true : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    customOptimisticData = options.optimisticData;
                    _a = $f14fedbe4e80ae23$var$serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key) return [
                        2 /*return*/ 
                    ];
                    _b = $f14fedbe4e80ae23$var$SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) // Revalidate and broadcast state.
                    return [
                        2 /*return*/ ,
                        $f14fedbe4e80ae23$var$broadcastState(cache, key, cache.get(key), $f14fedbe4e80ae23$var$UNDEFINED, $f14fedbe4e80ae23$var$UNDEFINED, revalidate, true)
                    ];
                    data = _data;
                    beforeMutationTs = $f14fedbe4e80ae23$var$getTimestamp();
                    MUTATION[key] = [
                        beforeMutationTs,
                        0
                    ];
                    hasCustomOptimisticData = !$f14fedbe4e80ae23$var$isUndefined(customOptimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasCustomOptimisticData) {
                        optimisticData = $f14fedbe4e80ae23$var$isFunction(customOptimisticData) ? customOptimisticData(rollbackData) : customOptimisticData;
                        cache.set(key, optimisticData);
                        $f14fedbe4e80ae23$var$broadcastState(cache, key, optimisticData);
                    }
                    if ($f14fedbe4e80ae23$var$isFunction(data)) // `data` is a function, call it passing current cache value.
                    try {
                        data = data(cache.get(key));
                    } catch (err) {
                        // If it throws an error synchronously, we shouldn't update the cache.
                        error = err;
                    }
                    if (!(data && $f14fedbe4e80ae23$var$isFunction(data.then))) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        data.catch(function(err) {
                            error = err;
                        })
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error) throw error;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                    } else if (error && hasCustomOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if ($f14fedbe4e80ae23$var$isFunction(populateCache)) data = populateCache(data, rollbackData);
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, $f14fedbe4e80ae23$var$mergeObjects(cache.get(keyInfo), {
                            error: error
                        }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = $f14fedbe4e80ae23$var$getTimestamp();
                    return [
                        4 /*yield*/ ,
                        $f14fedbe4e80ae23$var$broadcastState(cache, key, data, error, $f14fedbe4e80ae23$var$UNDEFINED, revalidate, !!populateCache)
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error) throw error;
                    return [
                        2 /*return*/ ,
                        populateCache ? res : data
                    ];
            }
        });
    });
};
var $f14fedbe4e80ae23$var$revalidateAllKeys = function(revalidators, type) {
    for(var key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
var $f14fedbe4e80ae23$var$initCache = function(provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$f14fedbe4e80ae23$var$SWRGlobalState.has(provider)) {
        var opts = $f14fedbe4e80ae23$var$mergeObjects($f14fedbe4e80ae23$var$defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = $f14fedbe4e80ae23$var$internalMutate.bind($f14fedbe4e80ae23$var$UNDEFINED, provider);
        var unmount = $f14fedbe4e80ae23$var$noop;
        // Update the state if it's new, or the provider has been extended.
        $f14fedbe4e80ae23$var$SWRGlobalState.set(provider, [
            EVENT_REVALIDATORS,
            {},
            {},
            {},
            mutate
        ]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!$f14fedbe4e80ae23$var$IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind($f14fedbe4e80ae23$var$UNDEFINED, $f14fedbe4e80ae23$var$revalidateAllKeys.bind($f14fedbe4e80ae23$var$UNDEFINED, EVENT_REVALIDATORS, $f14fedbe4e80ae23$var$FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind($f14fedbe4e80ae23$var$UNDEFINED, $f14fedbe4e80ae23$var$revalidateAllKeys.bind($f14fedbe4e80ae23$var$UNDEFINED, EVENT_REVALIDATORS, $f14fedbe4e80ae23$var$RECONNECT_EVENT)));
            unmount = function() {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                $f14fedbe4e80ae23$var$SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            unmount
        ];
    }
    return [
        provider,
        $f14fedbe4e80ae23$var$SWRGlobalState.get(provider)[4]
    ];
};
// error retry
var $f14fedbe4e80ae23$var$onErrorRetry = function(_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$f14fedbe4e80ae23$var$isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var $f14fedbe4e80ae23$var$_a = $f14fedbe4e80ae23$var$initCache(new Map()), $f14fedbe4e80ae23$var$cache = $f14fedbe4e80ae23$var$_a[0], $f14fedbe4e80ae23$export$57e795267c26e600 = $f14fedbe4e80ae23$var$_a[1];
// Default config
var $f14fedbe4e80ae23$var$defaultConfig = $f14fedbe4e80ae23$var$mergeObjects({
    // events
    onLoadingSlow: $f14fedbe4e80ae23$var$noop,
    onSuccess: $f14fedbe4e80ae23$var$noop,
    onError: $f14fedbe4e80ae23$var$noop,
    onErrorRetry: $f14fedbe4e80ae23$var$onErrorRetry,
    onDiscarded: $f14fedbe4e80ae23$var$noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $f14fedbe4e80ae23$var$slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $f14fedbe4e80ae23$var$slowConnection ? 5000 : 3000,
    // providers
    compare: function(currentData, newData) {
        return $f14fedbe4e80ae23$var$stableHash(currentData) == $f14fedbe4e80ae23$var$stableHash(newData);
    },
    isPaused: function() {
        return false;
    },
    cache: $f14fedbe4e80ae23$var$cache,
    mutate: $f14fedbe4e80ae23$export$57e795267c26e600,
    fallback: {}
}, // use web preset by default
$f14fedbe4e80ae23$var$preset);
var $f14fedbe4e80ae23$var$mergeConfigs = function(a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = $f14fedbe4e80ae23$var$mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $f14fedbe4e80ae23$var$mergeObjects(f1, f2);
    }
    return v;
};
var $f14fedbe4e80ae23$var$SWRConfigContext = (0, $f2Y41.createContext)({});
var $f14fedbe4e80ae23$var$SWRConfig$1 = function(props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = $f14fedbe4e80ae23$var$mergeConfigs((0, $f2Y41.useContext)($f14fedbe4e80ae23$var$SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0, $f2Y41.useState)(function() {
        return provider ? $f14fedbe4e80ae23$var$initCache(provider(extendedConfig.cache || $f14fedbe4e80ae23$var$cache), value) : $f14fedbe4e80ae23$var$UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $f14fedbe4e80ae23$var$useIsomorphicLayoutEffect(function() {
        return cacheContext ? cacheContext[2] : $f14fedbe4e80ae23$var$UNDEFINED;
    }, []);
    return (0, $f2Y41.createElement)($f14fedbe4e80ae23$var$SWRConfigContext.Provider, $f14fedbe4e80ae23$var$mergeObjects(props, {
        value: extendedConfig
    }));
};
/**
 * An implementation of state with dependency-tracking.
 */ var $f14fedbe4e80ae23$var$useStateWithDeps = function(state, unmountedRef) {
    var rerender = (0, $f2Y41.useState)({})[1];
    var stateRef = (0, $f2Y41.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0, $f2Y41.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */ var setState = (0, $f2Y41.useCallback)(function(payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for(var _ in payload){
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) rerender({});
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    $f14fedbe4e80ae23$var$useIsomorphicLayoutEffect(function() {
        stateRef.current = state;
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
var $f14fedbe4e80ae23$var$normalize = function(args) {
    return $f14fedbe4e80ae23$var$isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
var $f14fedbe4e80ae23$export$f1dc0e282d4c1c0 = function() {
    return $f14fedbe4e80ae23$var$mergeObjects($f14fedbe4e80ae23$var$defaultConfig, (0, $f2Y41.useContext)($f14fedbe4e80ae23$var$SWRConfigContext));
};
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var $f14fedbe4e80ae23$var$withArgs = function(hook) {
    return function useSWRArgs() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // Get the default and inherited configuration.
        var fallbackConfig = $f14fedbe4e80ae23$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        var _a = $f14fedbe4e80ae23$var$normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = $f14fedbe4e80ae23$var$mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) for(var i = use.length; i-- > 0;)next = use[i](next);
        return next(key, fn || config.fetcher, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var $f14fedbe4e80ae23$var$subscribeCallback = function(key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function() {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
var $f14fedbe4e80ae23$var$WITH_DEDUPE = {
    dedupe: true
};
var $f14fedbe4e80ae23$var$useSWRHandler = function(_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = $f14fedbe4e80ae23$var$SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = $f14fedbe4e80ae23$var$serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0, $f2Y41.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0, $f2Y41.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0, $f2Y41.useRef)(key);
    var fetcherRef = (0, $f2Y41.useRef)(fetcher);
    var configRef = (0, $f2Y41.useRef)(config);
    var getConfig = function() {
        return configRef.current;
    };
    var isActive = function() {
        return getConfig().isVisible() && getConfig().isOnline();
    };
    var patchFetchInfo = function(info) {
        return cache.set(keyInfo, $f14fedbe4e80ae23$var$mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = $f14fedbe4e80ae23$var$isUndefined(fallbackData) ? config.fallback[key] : fallbackData;
    var data = $f14fedbe4e80ae23$var$isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function() {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !$f14fedbe4e80ae23$var$isUndefined(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return $f14fedbe4e80ae23$var$isUndefined(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return $f14fedbe4e80ae23$var$isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function() {
        if (!key || !fetcher) return false;
        if (info.isValidating) return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = $f14fedbe4e80ae23$var$useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0, $f2Y41.useCallback)(function(revalidateOpts) {
        return $f14fedbe4e80ae23$var$__awaiter(void 0, void 0, void 0, function() {
            var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
            var _a;
            return $f14fedbe4e80ae23$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        currentFetcher = fetcherRef.current;
                        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return [
                            2 /*return*/ ,
                            false
                        ];
                        loading = true;
                        opts = revalidateOpts || {};
                        shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                        isCurrentKeyMounted = function() {
                            return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
                        };
                        cleanupState = function() {
                            // Check if it's still the same request before deleting.
                            var requestInfo = FETCH[key];
                            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
                        };
                        newState = {
                            isValidating: false
                        };
                        finishRequestAndUpdateState = function() {
                            patchFetchInfo({
                                isValidating: false
                            });
                            // We can only set state if it's safe (still mounted with the same key).
                            if (isCurrentKeyMounted()) setState(newState);
                        };
                        // Start fetching. Change the `isValidating` state, update the cache.
                        patchFetchInfo({
                            isValidating: true
                        });
                        setState({
                            isValidating: true
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (shouldStartNewRequest) {
                            // Tell all other hooks to change the `isValidating` state.
                            $f14fedbe4e80ae23$var$broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                            // If no cache being rendered currently (it shows a blank page),
                            // we trigger the loading slow event.
                            if (config.loadingTimeout && !cache.get(key)) setTimeout(function() {
                                if (loading && isCurrentKeyMounted()) getConfig().onLoadingSlow(key, config);
                            }, config.loadingTimeout);
                            // Start the request and save the timestamp.
                            FETCH[key] = [
                                currentFetcher.apply(void 0, fnArgs),
                                $f14fedbe4e80ae23$var$getTimestamp()
                            ];
                        }
                        _a = FETCH[key], newData = _a[0], startAt = _a[1];
                        return [
                            4 /*yield*/ ,
                            newData
                        ];
                    case 2:
                        newData = _b.sent();
                        if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                        // If there're other ongoing request(s), started after the current one,
                        // we need to ignore the current one to avoid possible race conditions:
                        //   req1------------------>res1        (current one)
                        //        req2---------------->res2
                        // the request that fired later will always be kept.
                        // The timestamp maybe be `undefined` or a number
                        if (!FETCH[key] || FETCH[key][1] !== startAt) {
                            if (shouldStartNewRequest) {
                                if (isCurrentKeyMounted()) getConfig().onDiscarded(key);
                            }
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        // Clear error.
                        patchFetchInfo({
                            error: $f14fedbe4e80ae23$var$UNDEFINED
                        });
                        newState.error = $f14fedbe4e80ae23$var$UNDEFINED;
                        mutationInfo = MUTATION[key];
                        if (!$f14fedbe4e80ae23$var$isUndefined(mutationInfo) && // case 1
                        (startAt <= mutationInfo[0] || // case 2
                        startAt <= mutationInfo[1] || // case 3
                        mutationInfo[1] === 0)) {
                            finishRequestAndUpdateState();
                            if (shouldStartNewRequest) {
                                if (isCurrentKeyMounted()) getConfig().onDiscarded(key);
                            }
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        // Deep compare with latest state to avoid extra re-renders.
                        // For local state, compare and assign.
                        if (!compare(stateRef.current.data, newData)) newState.data = newData;
                        else // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // For global state, it's possible that the key has changed.
                        // https://github.com/vercel/swr/pull/1058
                        if (!compare(cache.get(key), newData)) cache.set(key, newData);
                        // Trigger the successful callback if it's the original request.
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) getConfig().onSuccess(newData, key, config);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _b.sent();
                        cleanupState();
                        // Not paused, we continue handling the error. Otherwise discard it.
                        if (!getConfig().isPaused()) {
                            // Get a new error, don't use deep comparison for errors.
                            patchFetchInfo({
                                error: err_1
                            });
                            newState.error = err_1;
                            // Error event and retry logic. Only for the actual request, not
                            // deduped ones.
                            if (shouldStartNewRequest && isCurrentKeyMounted()) {
                                getConfig().onError(err_1, key, config);
                                if (typeof config.shouldRetryOnError === "boolean" && config.shouldRetryOnError || $f14fedbe4e80ae23$var$isFunction(config.shouldRetryOnError) && config.shouldRetryOnError(err_1)) // When retrying, dedupe is always enabled
                                {
                                    if (isActive()) // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        // Mark loading as stopped.
                        loading = false;
                        // Update the current hook's state.
                        finishRequestAndUpdateState();
                        // Here is the source of the request, need to tell all other hooks to
                        // update their states.
                        if (isCurrentKeyMounted() && shouldStartNewRequest) $f14fedbe4e80ae23$var$broadcastState(cache, key, newState.data, newState.error, false);
                        return [
                            2 /*return*/ ,
                            true
                        ];
                }
            });
        });
    }, // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0, $f2Y41.useCallback)(// By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    $f14fedbe4e80ae23$var$internalMutate.bind($f14fedbe4e80ae23$var$UNDEFINED, cache, function() {
        return keyRef.current;
    }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    $f14fedbe4e80ae23$var$useIsomorphicLayoutEffect(function() {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    $f14fedbe4e80ae23$var$useIsomorphicLayoutEffect(function() {
        if (!key) return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind($f14fedbe4e80ae23$var$UNDEFINED, $f14fedbe4e80ae23$var$WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function(updatedData, updatedError, updatedIsValidating) {
            setState($f14fedbe4e80ae23$var$mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData) ? $f14fedbe4e80ae23$var$UNDEFINED : {
                data: updatedData
            }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function(type) {
            if (type == $f14fedbe4e80ae23$var$FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == $f14fedbe4e80ae23$var$RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == $f14fedbe4e80ae23$var$MUTATE_EVENT) return revalidate();
            return;
        };
        var unsubUpdate = $f14fedbe4e80ae23$var$subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = $f14fedbe4e80ae23$var$subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) setState({
            data: data,
            error: error,
            isValidating: isValidating
        });
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if ($f14fedbe4e80ae23$var$isUndefined(data) || $f14fedbe4e80ae23$var$IS_SERVER) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            $f14fedbe4e80ae23$var$rAF(softRevalidate);
        }
        return function() {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [
        key,
        revalidate
    ]);
    // Polling
    $f14fedbe4e80ae23$var$useIsomorphicLayoutEffect(function() {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = $f14fedbe4e80ae23$var$isFunction(refreshInterval) ? refreshInterval(data) : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($f14fedbe4e80ae23$var$WITH_DEDUPE).then(next);
            else // Schedule next interval to check again.
            next();
        }
        next();
        return function() {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        revalidate
    ]);
    // Display debug info in React DevTools.
    (0, $f2Y41.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && $f14fedbe4e80ae23$var$isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw $f14fedbe4e80ae23$var$isUndefined(error) ? revalidate($f14fedbe4e80ae23$var$WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return data;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var $f14fedbe4e80ae23$export$4c7bbecdacc3ca2c = $f14fedbe4e80ae23$var$OBJECT.defineProperty($f14fedbe4e80ae23$var$SWRConfig$1, "default", {
    value: $f14fedbe4e80ae23$var$defaultConfig
});
var $f14fedbe4e80ae23$export$dbab534a48e651ef = function(key) {
    return $f14fedbe4e80ae23$var$serialize(key)[0];
};
var $f14fedbe4e80ae23$export$2e2bcd8739ae039 = $f14fedbe4e80ae23$var$withArgs($f14fedbe4e80ae23$var$useSWRHandler);



var $ge3KO = parcelRequire("ge3KO");

var $k6Ukq = parcelRequire("k6Ukq");

var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

var $k6Ukq = parcelRequire("k6Ukq");
const $c93fae517a66484d$export$2e2bcd8739ae039 = (t)=>{
    const i = t.id ?? "tsparticles";
    return (0, $f2Y41.useEffect)(()=>{
        let e;
        return (0, $k6Ukq.tsParticles).load({
            id: i,
            url: t.url,
            options: t.options
        }).then((l)=>{
            var a;
            e = l, (a = t.particlesLoaded) == null || a.call(t, l);
        }), ()=>{
            e == null || e.destroy();
        };
    }, [
        i,
        t,
        t.url,
        t.options
    ]), /* @__PURE__ */ (0, $ge3KO.jsx)("div", {
        id: i,
        className: t.className
    });
};


parcelRequire("ge3KO");
parcelRequire("f2Y41");
async function $a5aa093e53f76fb7$export$972a5b41ed1202df(t) {
    await t((0, $k6Ukq.tsParticles));
}



var $f2Y41 = parcelRequire("f2Y41");












async function $b0a4e5e1aac6ef08$export$85493d8c5e7176fb(engine, refresh = true) {
    const { loadDestroyUpdater: loadDestroyUpdater } = await (parcelRequire("88ZgS")), { loadRollUpdater: loadRollUpdater } = await (parcelRequire("gs7zA")), { loadTiltUpdater: loadTiltUpdater } = await (parcelRequire("eLQQ9")), { loadTwinkleUpdater: loadTwinkleUpdater } = await (parcelRequire("kRJI3")), { loadWobbleUpdater: loadWobbleUpdater } = await (parcelRequire("7dng1")), { loadTextShape: loadTextShape } = await (parcelRequire("2a9sr")), { loadExternalTrailInteraction: loadExternalTrailInteraction } = await (parcelRequire("8rrad")), { loadAbsorbersPlugin: loadAbsorbersPlugin } = await (parcelRequire("96b2u")), { loadEmittersPlugin: loadEmittersPlugin } = await (parcelRequire("h7qy4")), { loadEmittersShapeCircle: loadEmittersShapeCircle } = await (parcelRequire("eIoUx")), { loadEmittersShapeSquare: loadEmittersShapeSquare } = await (parcelRequire("2BPir")), { loadSlim: loadSlim } = await (parcelRequire("2Svek"));
    await loadDestroyUpdater(engine, false);
    await loadRollUpdater(engine, false);
    await loadTiltUpdater(engine, false);
    await loadTwinkleUpdater(engine, false);
    await loadWobbleUpdater(engine, false);
    await loadTextShape(engine, false);
    await loadExternalTrailInteraction(engine, false);
    await loadAbsorbersPlugin(engine, false);
    await loadEmittersPlugin(engine, false);
    await loadEmittersShapeCircle(engine, false);
    await loadEmittersShapeSquare(engine, false);
    await loadSlim(engine, refresh);
}


const $6768843c119694ab$export$684cde6f0dee35a = {
    autoPlay: false,
    particles: {
        number: {
            value: 0
        },
        color: {
            value: [
                "#00FFFC",
                "#FC00FF",
                "#fffc00"
            ]
        },
        shape: {
            type: [
                "circle",
                "square"
            ],
            options: {}
        },
        opacity: {
            value: {
                min: 0,
                max: 1
            },
            animation: {
                enable: true,
                speed: 2,
                startValue: "max",
                destroy: "min"
            }
        },
        size: {
            value: {
                min: 2,
                max: 4
            }
        },
        links: {
            enable: false
        },
        life: {
            duration: {
                sync: true,
                value: 5
            },
            count: 1
        },
        move: {
            enable: true,
            gravity: {
                enable: true,
                acceleration: 10
            },
            speed: {
                min: 10,
                max: 20
            },
            decay: 0.1,
            direction: "none",
            straight: false,
            outModes: {
                default: "destroy",
                top: "none"
            }
        },
        rotate: {
            value: {
                min: 0,
                max: 360
            },
            direction: "random",
            move: true,
            animation: {
                enable: true,
                speed: 60
            }
        },
        tilt: {
            direction: "random",
            enable: true,
            move: true,
            value: {
                min: 0,
                max: 360
            },
            animation: {
                enable: true,
                speed: 60
            }
        },
        roll: {
            darken: {
                enable: true,
                value: 25
            },
            enable: true,
            speed: {
                min: 15,
                max: 25
            }
        },
        wobble: {
            distance: 30,
            enable: true,
            move: true,
            speed: {
                min: -15,
                max: 15
            }
        }
    },
    emitters: {
        position: {
            x: 0,
            y: 0
        },
        life: {
            count: 1,
            duration: 0.1,
            delay: 0.4
        },
        rate: {
            delay: 0.1,
            quantity: 150
        },
        size: {
            width: 0,
            height: 0
        }
    }
};


const $c628013fe8295b09$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $c628013fe8295b09$export$2e2bcd8739ae039 = {
    randomUUID: $c628013fe8295b09$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $589fa66a3bced355$var$getRandomValues;
const $589fa66a3bced355$var$rnds8 = new Uint8Array(16);
function $589fa66a3bced355$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$589fa66a3bced355$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $589fa66a3bced355$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$589fa66a3bced355$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $589fa66a3bced355$var$getRandomValues($589fa66a3bced355$var$rnds8);
}


var $3474eafdc2e63aff$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $d5d343aa93c49c90$var$validate(uuid) {
    return typeof uuid === "string" && (0, $3474eafdc2e63aff$export$2e2bcd8739ae039).test(uuid);
}
var $d5d343aa93c49c90$export$2e2bcd8739ae039 = $d5d343aa93c49c90$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $96b16492d134642d$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$96b16492d134642d$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $96b16492d134642d$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $96b16492d134642d$var$byteToHex[arr[offset + 0]] + $96b16492d134642d$var$byteToHex[arr[offset + 1]] + $96b16492d134642d$var$byteToHex[arr[offset + 2]] + $96b16492d134642d$var$byteToHex[arr[offset + 3]] + "-" + $96b16492d134642d$var$byteToHex[arr[offset + 4]] + $96b16492d134642d$var$byteToHex[arr[offset + 5]] + "-" + $96b16492d134642d$var$byteToHex[arr[offset + 6]] + $96b16492d134642d$var$byteToHex[arr[offset + 7]] + "-" + $96b16492d134642d$var$byteToHex[arr[offset + 8]] + $96b16492d134642d$var$byteToHex[arr[offset + 9]] + "-" + $96b16492d134642d$var$byteToHex[arr[offset + 10]] + $96b16492d134642d$var$byteToHex[arr[offset + 11]] + $96b16492d134642d$var$byteToHex[arr[offset + 12]] + $96b16492d134642d$var$byteToHex[arr[offset + 13]] + $96b16492d134642d$var$byteToHex[arr[offset + 14]] + $96b16492d134642d$var$byteToHex[arr[offset + 15]];
}
function $96b16492d134642d$var$stringify(arr, offset = 0) {
    const uuid = $96b16492d134642d$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $d5d343aa93c49c90$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $96b16492d134642d$export$2e2bcd8739ae039 = $96b16492d134642d$var$stringify;


function $e843bba77db96df0$var$v4(options, buf, offset) {
    if ((0, $c628013fe8295b09$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $c628013fe8295b09$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $589fa66a3bced355$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $96b16492d134642d$export$8fb373d660548968)(rnds);
}
var $e843bba77db96df0$export$2e2bcd8739ae039 = $e843bba77db96df0$var$v4;


const $67bfd1b00f19d8e6$export$e73c8bd0f20705a = ()=>(0, $e843bba77db96df0$export$2e2bcd8739ae039)();



var $f2Y41 = parcelRequire("f2Y41");
const $e0b7fdb4f7d93cbe$var$localStorageJoy = ()=>"joy" in localStorage && localStorage.joy === "true";
function $e0b7fdb4f7d93cbe$export$60240ee1e969690a() {
    const [prefersJoy, setPrefersJoy] = (0, $f2Y41.useState)($e0b7fdb4f7d93cbe$var$localStorageJoy());
    (0, $f2Y41.useEffect)(()=>{
        function handleChangeStorage() {
            setPrefersJoy($e0b7fdb4f7d93cbe$var$localStorageJoy());
        }
        window.addEventListener("storage", handleChangeStorage);
        return ()=>window.removeEventListener("storage", handleChangeStorage);
    }, []);
    return prefersJoy;
}


const $3d94fb79f2ee28b7$export$a82258c354612e2e = /*#__PURE__*/ (0, $f2Y41.createContext)({
    triggerConfetti: ()=>null
});
const $3d94fb79f2ee28b7$export$c5dd32a4fefa6a4c = ({ children: children })=>{
    const [init, setInit] = (0, $f2Y41.useState)(false);
    const [confettiTrigger, setConfettiTrigger] = (0, $f2Y41.useState)("");
    const confettiOptions = (0, $6768843c119694ab$export$684cde6f0dee35a);
    const triggerConfetti = ()=>{
        confettiOptions.autoPlay = true;
        setConfettiTrigger((0, $67bfd1b00f19d8e6$export$e73c8bd0f20705a)()) // Toggle to force re-render
        ;
    };
    const joy = (0, $e0b7fdb4f7d93cbe$export$60240ee1e969690a)();
    // this should be run only once per application lifetime
    (0, $f2Y41.useEffect)(()=>{
        (0, $a5aa093e53f76fb7$export$972a5b41ed1202df)(async (engine)=>{
            // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
            // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
            // starting from v2 you can add only the features you need reducing the bundle size
            //await loadAll(engine);
            await (0, $b0a4e5e1aac6ef08$export$85493d8c5e7176fb)(engine);
        // await loadSlim(engine);
        //await loadBasic(engine);
        }).then(()=>{
            setInit(true);
        });
    }, []);
    const particlesLoaded = async (container)=>{};
    if (!joy || !init) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($3d94fb79f2ee28b7$export$a82258c354612e2e.Provider, {
        value: {
            triggerConfetti: triggerConfetti
        },
        children: [
            children,
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c93fae517a66484d$export$2e2bcd8739ae039), {
                id: "tsparticles",
                particlesLoaded: particlesLoaded,
                options: confettiOptions
            }, confettiTrigger)
        ]
    });
};
const $3d94fb79f2ee28b7$export$81073d529bbe4dc7 = ()=>(0, $f2Y41.useContext)($3d94fb79f2ee28b7$export$a82258c354612e2e);



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

const $2a43c47d1f6a2316$export$a94f9e4f07f0c0a6 = /*#__PURE__*/ (0, $f2Y41.createContext)([]);
const $2a43c47d1f6a2316$export$34a983b74b78907c = (flag)=>{
    const featureFlagContext = (0, $f2Y41.useContext)($2a43c47d1f6a2316$export$a94f9e4f07f0c0a6);
    return featureFlagContext.includes(flag);
};
const $2a43c47d1f6a2316$export$ec0c43a58fca1a2 = ({ children: children })=>{
    let featureFlags = JSON.parse(localStorage.getItem("featureFlags")) || [];
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const newFeatureFlag = searchParams.get("featureFlag");
    if (newFeatureFlag && !featureFlags.includes(newFeatureFlag)) {
        featureFlags = [
            ...featureFlags,
            newFeatureFlag
        ];
        localStorage.setItem("featureFlags", JSON.stringify(featureFlags));
    }
    if (searchParams.get("featureFlagReset")) {
        localStorage.removeItem("featureFlags");
        featureFlags = [];
    }
    return /*#__PURE__*/ (0, $ge3KO.jsx)($2a43c47d1f6a2316$export$a94f9e4f07f0c0a6.Provider, {
        value: featureFlags,
        children: children
    });
};



var $f2Y41 = parcelRequire("f2Y41");

const $327d9d25f6dd0131$export$7ddbcfece0404bf4 = ({ children: children })=>{
    // This component was created because google calendar lazily inserts parameters when storing links, breaking the URL and breaking the router
    // Example: &sa=D&source=calendar&ust=&usg
    const location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const wellformedPathname = (str)=>{
        const index = str.indexOf("&");
        if (index !== -1) return str.substring(0, index) + "?&" + str.substring(index + 1);
        return str;
    };
    const isMalformedPathname = (str)=>str.indexOf("&") !== -1 && str.indexOf("?") === -1;
    (0, $f2Y41.useEffect)(()=>{
        if (isMalformedPathname(location.pathname)) navigate(wellformedPathname(location.pathname));
    }, []);
    return children;
};




var $f2Y41 = parcelRequire("f2Y41");
function $b5ba0fceafa93186$export$6adef2d23f66960d(prefersDarkMode) {
    return (0, $f2Y41.useMemo)(()=>(0, $ce605d53bd47975e$export$2e2bcd8739ae039)({
            palette: {
                mode: prefersDarkMode ? "dark" : "light"
            },
            components: {
                MuiInput: {
                    styleOverrides: {
                        root: {
                            "&.Mui-focused": {
                                input: {
                                    "box-shadow": "none"
                                }
                            }
                        }
                    }
                },
                MuiDatePicker: {
                    styleOverrides: {
                        root: {
                        }
                    }
                }
            },
            typography: {
                fontFamily: [
                    '"Inter var"',
                    "-apple-system",
                    "BlinkMacSystemFont",
                    '"Segoe UI"',
                    "Roboto",
                    "Helvetica Neue",
                    "Arial",
                    '"Noto Sans"',
                    "sans-serif",
                    '"Apple Color Emoji"',
                    '"Segoe UI Emoji"',
                    '"Segoe UI Symbol"',
                    '"Noto Color Emoji"'
                ].join(",")
            }
        }), [
        prefersDarkMode
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");
function $8256098bd6a934fe$export$ac490adb58a50dde() {
    if (localStorage.theme === "dark" || !("theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches) return true;
    else return false;
}
function $8256098bd6a934fe$export$56a913221adb0e51() {
    const [prefersDarkMode, setPrefersDarkMode] = (0, $f2Y41.useState)($8256098bd6a934fe$export$ac490adb58a50dde());
    (0, $f2Y41.useEffect)(()=>{
        function handleChangeStorage() {
            setPrefersDarkMode($8256098bd6a934fe$export$ac490adb58a50dde());
        }
        window.addEventListener("storage", handleChangeStorage);
        return ()=>window.removeEventListener("storage", handleChangeStorage);
    }, []);
    return prefersDarkMode;
}


function $0c4d35b57f451404$export$6cd5d5c1dae69a36() {
    const prefersDarkMode = (0, $8256098bd6a934fe$export$56a913221adb0e51)();
    const theme = (0, $b5ba0fceafa93186$export$6adef2d23f66960d)(prefersDarkMode);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $327d9d25f6dd0131$export$7ddbcfece0404bf4), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f14fedbe4e80ae23$export$4c7bbecdacc3ca2c), {
            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $bb8fb7867c1e81db$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $98c8899302adcdc5$export$81f56c0329a1921d),
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $jZjY3.a), {
                    theme: theme,
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a43c47d1f6a2316$export$ec0c43a58fca1a2), {
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3d94fb79f2ee28b7$export$c5dd32a4fefa6a4c), {
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c5383ff45095a6a6$export$910ae8079b2c2852), {})
                        })
                    })
                })
            })
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $05f1c351b568e291$var$extendStatics = function(d, b) {
    $05f1c351b568e291$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $05f1c351b568e291$var$extendStatics(d, b);
};
function $05f1c351b568e291$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $05f1c351b568e291$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $05f1c351b568e291$var$__assign = function() {
    $05f1c351b568e291$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $05f1c351b568e291$var$__assign.apply(this, arguments);
};
function $05f1c351b568e291$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $05f1c351b568e291$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $05f1c351b568e291$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $05f1c351b568e291$var$e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var $05f1c351b568e291$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $05f1c351b568e291$var$i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $05f1c351b568e291$var$o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $05f1c351b568e291$var$n = $05f1c351b568e291$var$o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
$05f1c351b568e291$var$i($05f1c351b568e291$var$n);
var $05f1c351b568e291$var$a = $05f1c351b568e291$var$i($05f1c351b568e291$var$o(function(e, i) {
    var o = $05f1c351b568e291$var$t && $05f1c351b568e291$var$t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = $05f1c351b568e291$var$t && $05f1c351b568e291$var$t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = $05f1c351b568e291$var$t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            $05f1c351b568e291$var$n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? ($05f1c351b568e291$var$n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), $05f1c351b568e291$var$n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($05f1c351b568e291$var$n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $05f1c351b568e291$var$n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), $05f1c351b568e291$var$n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const $05f1c351b568e291$var$r = {
    timeoutInSeconds: 60
}, $05f1c351b568e291$var$s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, $05f1c351b568e291$var$c = ()=>Date.now();
class $05f1c351b568e291$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $05f1c351b568e291$export$7d465be8efa67280.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new $05f1c351b568e291$export$7d465be8efa67280(e, t);
    }
}
class $05f1c351b568e291$export$cf0c46b07324e9c5 extends $05f1c351b568e291$export$7d465be8efa67280 {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, $05f1c351b568e291$export$cf0c46b07324e9c5.prototype);
    }
}
class $05f1c351b568e291$export$66d311bf29d5c89c extends $05f1c351b568e291$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $05f1c351b568e291$export$66d311bf29d5c89c.prototype);
    }
}
class $05f1c351b568e291$export$ebbb83fe03f719a4 extends $05f1c351b568e291$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $05f1c351b568e291$export$ebbb83fe03f719a4.prototype);
    }
}
class $05f1c351b568e291$export$f1f681f0fb26bb55 extends $05f1c351b568e291$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $05f1c351b568e291$export$f1f681f0fb26bb55.prototype);
    }
}
class $05f1c351b568e291$export$c59494f4dae44ada extends $05f1c351b568e291$export$7d465be8efa67280 {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, $05f1c351b568e291$export$c59494f4dae44ada.prototype);
    }
}
class $05f1c351b568e291$export$ac1d2a00f8e0a046 extends $05f1c351b568e291$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$05f1c351b568e291$var$g(e, [
            "default"
        ])}', scope: '${$05f1c351b568e291$var$g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $05f1c351b568e291$export$ac1d2a00f8e0a046.prototype);
    }
}
function $05f1c351b568e291$var$g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $05f1c351b568e291$var$w = ()=>window.crypto, $05f1c351b568e291$var$y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($05f1c351b568e291$var$w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, $05f1c351b568e291$var$k = (e)=>btoa(e), $05f1c351b568e291$var$v = (t)=>{
    var { clientId: i } = t, o = $05f1c351b568e291$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, $05f1c351b568e291$var$b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $05f1c351b568e291$var$_ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, $05f1c351b568e291$var$I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        $05f1c351b568e291$var$_(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, $05f1c351b568e291$var$S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, $05f1c351b568e291$var$O = async (e, t, i, o, n, a, r = 1e4)=>n ? $05f1c351b568e291$var$S(e, t, i, o, r, n, a) : $05f1c351b568e291$var$I(e, o, r);
async function $05f1c351b568e291$var$T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = $05f1c351b568e291$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? $05f1c351b568e291$var$v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await $05f1c351b568e291$var$O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = $05f1c351b568e291$var$e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new $05f1c351b568e291$export$c59494f4dae44ada(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new $05f1c351b568e291$export$ac1d2a00f8e0a046(o, n);
            throw new $05f1c351b568e291$export$7d465be8efa67280(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $05f1c351b568e291$var$s))
        }
    }, i, u);
}
const $05f1c351b568e291$var$j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $05f1c351b568e291$var$C {
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new $05f1c351b568e291$var$C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new $05f1c351b568e291$var$C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
}
class $05f1c351b568e291$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $05f1c351b568e291$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $05f1c351b568e291$var$x {
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || $05f1c351b568e291$var$c;
    }
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new $05f1c351b568e291$var$C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $05f1c351b568e291$var$C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = $05f1c351b568e291$var$C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
}
class $05f1c351b568e291$var$Z {
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $05f1c351b568e291$var$K = (e)=>"number" == typeof e, $05f1c351b568e291$var$W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $05f1c351b568e291$var$E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse($05f1c351b568e291$var$b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], $05f1c351b568e291$var$W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse($05f1c351b568e291$var$b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$05f1c351b568e291$var$K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$05f1c351b568e291$var$K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$05f1c351b568e291$var$K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && $05f1c351b568e291$var$K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $05f1c351b568e291$var$K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $05f1c351b568e291$var$R = $05f1c351b568e291$var$o(function(e, i) {
    var o = $05f1c351b568e291$var$t && $05f1c351b568e291$var$t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
$05f1c351b568e291$var$i($05f1c351b568e291$var$R), $05f1c351b568e291$var$R.encode, $05f1c351b568e291$var$R.parse, $05f1c351b568e291$var$R.getAll;
var $05f1c351b568e291$var$U = $05f1c351b568e291$var$R.get, $05f1c351b568e291$var$L = $05f1c351b568e291$var$R.set, $05f1c351b568e291$var$D = $05f1c351b568e291$var$R.remove;
const $05f1c351b568e291$var$X = {
    get (e) {
        const t = $05f1c351b568e291$var$U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $05f1c351b568e291$var$L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $05f1c351b568e291$var$D(e, i);
    }
}, $05f1c351b568e291$var$N = {
    get (e) {
        const t = $05f1c351b568e291$var$X.get(e);
        return t || $05f1c351b568e291$var$X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $05f1c351b568e291$var$L(`_legacy_${e}`, JSON.stringify(t), o), $05f1c351b568e291$var$X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $05f1c351b568e291$var$D(e, i), $05f1c351b568e291$var$X.remove(e, t), $05f1c351b568e291$var$X.remove(`_legacy_${e}`, t);
    }
}, $05f1c351b568e291$var$J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $05f1c351b568e291$var$F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $05f1c351b568e291$var$H, $05f1c351b568e291$var$Y, $05f1c351b568e291$var$G, $05f1c351b568e291$var$V, $05f1c351b568e291$var$M = ($05f1c351b568e291$var$H = "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", $05f1c351b568e291$var$Y = null, $05f1c351b568e291$var$G = !1, function(e) {
    return $05f1c351b568e291$var$V = $05f1c351b568e291$var$V || $05f1c351b568e291$var$F($05f1c351b568e291$var$H, $05f1c351b568e291$var$Y, $05f1c351b568e291$var$G), new Worker($05f1c351b568e291$var$V, e);
});
const $05f1c351b568e291$var$A = {};
class $05f1c351b568e291$var$B {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const $05f1c351b568e291$var$$ = {
    memory: ()=>(new $05f1c351b568e291$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $05f1c351b568e291$export$40ef2cb682e70737
}, $05f1c351b568e291$var$q = (e)=>$05f1c351b568e291$var$$[e], $05f1c351b568e291$var$Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = $05f1c351b568e291$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, $05f1c351b568e291$var$ee = new $05f1c351b568e291$var$a;
class $05f1c351b568e291$var$te {
    constructor(e){
        let t, i;
        if (this.userCache = (new $05f1c351b568e291$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $05f1c351b568e291$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$05f1c351b568e291$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $05f1c351b568e291$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$05f1c351b568e291$var$q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = $05f1c351b568e291$var$q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $05f1c351b568e291$var$X : $05f1c351b568e291$var$N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : $05f1c351b568e291$var$J;
        var n;
        this.scope = $05f1c351b568e291$var$j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $05f1c351b568e291$var$Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $05f1c351b568e291$var$c, this.cacheManager = new $05f1c351b568e291$var$x(i, i.allKeys ? void 0 : new $05f1c351b568e291$var$B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $05f1c351b568e291$var$M);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $05f1c351b568e291$var$s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$05f1c351b568e291$var$v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return $05f1c351b568e291$var$E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = $05f1c351b568e291$var$k($05f1c351b568e291$var$y()), n = $05f1c351b568e291$var$k($05f1c351b568e291$var$y()), a = $05f1c351b568e291$var$y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $05f1c351b568e291$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: $05f1c351b568e291$var$j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new $05f1c351b568e291$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new $05f1c351b568e291$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i($05f1c351b568e291$export$7d465be8efa67280.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new $05f1c351b568e291$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = $05f1c351b568e291$var$Q(t), { openUrl: n, fragment: a, appState: r } = o, s = $05f1c351b568e291$var$e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = $05f1c351b568e291$var$e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new $05f1c351b568e291$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new $05f1c351b568e291$export$cf0c46b07324e9c5(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new $05f1c351b568e291$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $05f1c351b568e291$var$j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = $05f1c351b568e291$var$A[t];
            return i || (i = e().finally(()=>{
                delete $05f1c351b568e291$var$A[t], i = null;
            }), $05f1c351b568e291$var$A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = $05f1c351b568e291$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>$05f1c351b568e291$var$ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $05f1c351b568e291$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await $05f1c351b568e291$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $05f1c351b568e291$var$j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, $05f1c351b568e291$var$r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new $05f1c351b568e291$var$C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = $05f1c351b568e291$var$e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${$05f1c351b568e291$var$v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = $05f1c351b568e291$var$Q(t), { openUrl: o } = i, n = $05f1c351b568e291$var$e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $05f1c351b568e291$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new $05f1c351b568e291$export$66d311bf29d5c89c), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n($05f1c351b568e291$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new $05f1c351b568e291$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $05f1c351b568e291$var$C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $05f1c351b568e291$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = $05f1c351b568e291$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $05f1c351b568e291$var$C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new $05f1c351b568e291$var$C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await $05f1c351b568e291$var$T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
}
class $05f1c351b568e291$export$1f44aaf2ec115b54 {
}
/**
 * The initial auth state.
 */ var $05f1c351b568e291$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var $05f1c351b568e291$var$stub = function() {
    throw new Error("You forgot to wrap your component in <Auth0Provider>.");
};
/**
 * @ignore
 */ var $05f1c351b568e291$export$1b5d8f0c33515521 = $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, $05f1c351b568e291$var$initialAuthState), {
    buildAuthorizeUrl: $05f1c351b568e291$var$stub,
    buildLogoutUrl: $05f1c351b568e291$var$stub,
    getAccessTokenSilently: $05f1c351b568e291$var$stub,
    getAccessTokenWithPopup: $05f1c351b568e291$var$stub,
    getIdTokenClaims: $05f1c351b568e291$var$stub,
    loginWithRedirect: $05f1c351b568e291$var$stub,
    loginWithPopup: $05f1c351b568e291$var$stub,
    logout: $05f1c351b568e291$var$stub,
    handleRedirectCallback: $05f1c351b568e291$var$stub
});
/**
 * The Auth0 Context
 */ var $05f1c351b568e291$export$419e9d660c2a6030 = (0, $f2Y41.createContext)($05f1c351b568e291$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $05f1c351b568e291$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $05f1c351b568e291$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $05f1c351b568e291$var$CODE_RE = /[?&]code=[^&]+/;
var $05f1c351b568e291$var$STATE_RE = /[?&]state=[^&]+/;
var $05f1c351b568e291$var$ERROR_RE = /[?&]error=[^&]+/;
var $05f1c351b568e291$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($05f1c351b568e291$var$CODE_RE.test(searchParams) || $05f1c351b568e291$var$ERROR_RE.test(searchParams)) && $05f1c351b568e291$var$STATE_RE.test(searchParams);
};
var $05f1c351b568e291$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === "object" && "error" in error && typeof error.error === "string") {
            if ("error_description" in error && typeof error.error_description === "string") return new $05f1c351b568e291$export$bdc0f363b754b88f(error.error, error.error_description);
            return new $05f1c351b568e291$export$bdc0f363b754b88f(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var $05f1c351b568e291$var$loginError = $05f1c351b568e291$var$normalizeErrorFn("Login failed");
var $05f1c351b568e291$var$tokenError = $05f1c351b568e291$var$normalizeErrorFn("Get access token failed");
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $05f1c351b568e291$var$deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version");
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version");
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $05f1c351b568e291$var$reducer = function(state, action) {
    switch(action.type){
        case "LOGIN_POPUP_STARTED":
            return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, state), {
                isLoading: true
            });
        case "LOGIN_POPUP_COMPLETE":
        case "INITIALISED":
            return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case "HANDLE_REDIRECT_COMPLETE":
        case "GET_ACCESS_TOKEN_COMPLETE":
            if (state.user === action.user) return state;
            return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case "LOGOUT":
            return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case "ERROR":
            return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $05f1c351b568e291$var$toAuth0ClientOptions = function(opts) {
    $05f1c351b568e291$var$deprecateRedirectUri(opts);
    return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, opts), {
        auth0Client: {
            name: "auth0-react",
            version: "2.2.4"
        }
    });
};
/**
 * @ignore
 */ var $05f1c351b568e291$var$defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var $05f1c351b568e291$export$6aefaad9cc4faf3c = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? $05f1c351b568e291$var$defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? $05f1c351b568e291$export$419e9d660c2a6030 : _b, clientOpts = $05f1c351b568e291$var$__rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, $f2Y41.useState)(function() {
        return new $05f1c351b568e291$var$te($05f1c351b568e291$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, $f2Y41.useReducer)($05f1c351b568e291$var$reducer, $05f1c351b568e291$var$initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, $f2Y41.useRef)(false);
    (0, $f2Y41.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return $05f1c351b568e291$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!($05f1c351b568e291$var$hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: "INITIALISED",
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            dispatch({
                                type: "ERROR",
                                error: $05f1c351b568e291$var$loginError(error_1)
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback
    ]);
    var loginWithRedirect = (0, $f2Y41.useCallback)(function(opts) {
        $05f1c351b568e291$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $f2Y41.useCallback)(function(options, config) {
        return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $05f1c351b568e291$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: "LOGIN_POPUP_STARTED"
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({
                            type: "ERROR",
                            error: $05f1c351b568e291$var$loginError(error_2)
                        });
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: "LOGIN_POPUP_COMPLETE",
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, $f2Y41.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
            return $05f1c351b568e291$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: "LOGOUT"
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $f2Y41.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $05f1c351b568e291$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $05f1c351b568e291$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $f2Y41.useCallback)(function(opts, config) {
        return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $05f1c351b568e291$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $05f1c351b568e291$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $f2Y41.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, $f2Y41.useCallback)(function(url) {
        return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return $05f1c351b568e291$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $05f1c351b568e291$var$tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "HANDLE_REDIRECT_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, $f2Y41.useMemo)(function() {
        return $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $05f1c351b568e291$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $05f1c351b568e291$export$419e9d660c2a6030;
    return (0, $f2Y41.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $05f1c351b568e291$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $05f1c351b568e291$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Component, $05f1c351b568e291$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $05f1c351b568e291$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null);
};
/**
* @ignore
*/ var $05f1c351b568e291$var$defaultOnBeforeAuthentication = function() {
    return $05f1c351b568e291$var$__awaiter(void 0, void 0, void 0, function() {
        return $05f1c351b568e291$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $05f1c351b568e291$var$defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $05f1c351b568e291$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $05f1c351b568e291$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $05f1c351b568e291$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $05f1c351b568e291$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $05f1c351b568e291$export$419e9d660c2a6030 : _d;
        var _e = $05f1c351b568e291$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $f2Y41.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, loginOptions), {
                appState: $05f1c351b568e291$var$__assign($05f1c351b568e291$var$__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === "function" ? returnTo() : returnTo
                })
            });
            (function() {
                return $05f1c351b568e291$var$__awaiter(_this, void 0, void 0, function() {
                    return $05f1c351b568e291$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Component, $05f1c351b568e291$var$__assign({}, props)) : onRedirecting();
    };
};



var $f2Y41 = parcelRequire("f2Y41");


var $9141604a407be72f$exports = {};

$9141604a407be72f$exports = (parcelRequire("4up07"));




var $f2Y41 = parcelRequire("f2Y41");

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $d92826804bd5f1db$var$__assign = function() {
    $d92826804bd5f1db$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d92826804bd5f1db$var$__assign.apply(this, arguments);
};
function $d92826804bd5f1db$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d92826804bd5f1db$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d92826804bd5f1db$var$noop = function() {};
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var $d92826804bd5f1db$var$UNDEFINED = /*#__NOINLINE__*/ $d92826804bd5f1db$var$noop();
var $d92826804bd5f1db$var$OBJECT = Object;
var $d92826804bd5f1db$var$isUndefined = function(v) {
    return v === $d92826804bd5f1db$var$UNDEFINED;
};
var $d92826804bd5f1db$var$isFunction = function(v) {
    return typeof v == "function";
};
var $d92826804bd5f1db$var$STR_UNDEFINED = "undefined";
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var $d92826804bd5f1db$var$hasWindow = function() {
    return typeof window != $d92826804bd5f1db$var$STR_UNDEFINED;
};
var $d92826804bd5f1db$var$IS_SERVER = !$d92826804bd5f1db$var$hasWindow() || "Deno" in window;
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var $d92826804bd5f1db$var$useIsomorphicLayoutEffect = $d92826804bd5f1db$var$IS_SERVER ? (0, $f2Y41.useEffect) : (0, $f2Y41.useLayoutEffect);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $d92826804bd5f1db$var$table = new WeakMap();
// counter of the key
var $d92826804bd5f1db$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var $d92826804bd5f1db$var$stableHash = function(arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if ($d92826804bd5f1db$var$OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $d92826804bd5f1db$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$d92826804bd5f1db$var$counter + "~";
        $d92826804bd5f1db$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $d92826804bd5f1db$var$stableHash(arg[index]) + ",";
            $d92826804bd5f1db$var$table.set(arg, result);
        }
        if (constructor == $d92826804bd5f1db$var$OBJECT) {
            // Object, sort keys.
            result = "#";
            var keys = $d92826804bd5f1db$var$OBJECT.keys(arg).sort();
            while(!$d92826804bd5f1db$var$isUndefined(index = keys.pop()))if (!$d92826804bd5f1db$var$isUndefined(arg[index])) result += index + ":" + $d92826804bd5f1db$var$stableHash(arg[index]) + ",";
            $d92826804bd5f1db$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
var $d92826804bd5f1db$var$serialize = function(key) {
    if ($d92826804bd5f1db$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $d92826804bd5f1db$var$stableHash(key) : "";
    var infoKey = key ? "$swr$" + key : "";
    return [
        key,
        args,
        infoKey
    ];
};
var $d92826804bd5f1db$var$normalize = function(args) {
    return $d92826804bd5f1db$var$isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
// Create a custom hook with a middleware
var $d92826804bd5f1db$var$withMiddleware = function(useSWR, middleware) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _a = $d92826804bd5f1db$var$normalize(args), key = _a[0], fn = _a[1], config = _a[2];
        var uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, $d92826804bd5f1db$var$__assign($d92826804bd5f1db$var$__assign({}, config), {
            use: uses
        }));
    };
};
// We have to several type castings here because `useSWRInfinite` is a special
var $d92826804bd5f1db$var$INFINITE_PREFIX = "$inf$";
var $d92826804bd5f1db$var$getFirstPageKey = function(getKey) {
    return $d92826804bd5f1db$var$serialize(getKey ? getKey(0, null) : null)[0];
};
var $d92826804bd5f1db$export$dbab534a48e651ef = function(getKey) {
    return $d92826804bd5f1db$var$INFINITE_PREFIX + $d92826804bd5f1db$var$getFirstPageKey(getKey);
};
var $d92826804bd5f1db$export$f27219e7b43e81d = function(useSWRNext) {
    return function(getKey, fn, config) {
        var rerender = (0, $f2Y41.useState)({})[1];
        var didMountRef = (0, $f2Y41.useRef)(false);
        var dataRef = (0, $f2Y41.useRef)();
        var cache = config.cache, _a = config.initialSize, initialSize = _a === void 0 ? 1 : _a, _b = config.revalidateAll, revalidateAll = _b === void 0 ? false : _b, _c = config.persistSize, persistSize = _c === void 0 ? false : _c, _d = config.revalidateFirstPage, revalidateFirstPage = _d === void 0 ? true : _d, _e = config.revalidateOnMount, revalidateOnMount = _e === void 0 ? false : _e;
        // The serialized key of the first page.
        var firstPageKey = null;
        try {
            firstPageKey = $d92826804bd5f1db$var$getFirstPageKey(getKey);
        } catch (err) {
        // not ready
        }
        // We use cache to pass extra info (context) to fetcher so it can be globally
        // shared. The key of the context data is based on the first page key.
        var contextCacheKey = null;
        // Page size is also cached to share the page data between hooks with the
        // same key.
        var pageSizeCacheKey = null;
        if (firstPageKey) {
            contextCacheKey = "$ctx$" + firstPageKey;
            pageSizeCacheKey = "$len$" + firstPageKey;
        }
        var resolvePageSize = (0, $f2Y41.useCallback)(function() {
            var cachedPageSize = cache.get(pageSizeCacheKey);
            return $d92826804bd5f1db$var$isUndefined(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            pageSizeCacheKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        var lastPageSizeRef = (0, $f2Y41.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        $d92826804bd5f1db$var$useIsomorphicLayoutEffect(function() {
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (firstPageKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            cache.set(pageSizeCacheKey, persistSize ? lastPageSizeRef.current : initialSize);
        // `initialSize` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            firstPageKey
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        var shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        var swr = useSWRNext(firstPageKey ? $d92826804bd5f1db$var$INFINITE_PREFIX + firstPageKey : null, function() {
            return $d92826804bd5f1db$var$__awaiter(void 0, void 0, void 0, function() {
                var _a, forceRevalidateAll, originalData, data, pageSize, previousPageData, i, _b, pageKey, pageArgs, pageData, shouldFetchPage;
                return $d92826804bd5f1db$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            _a = cache.get(contextCacheKey) || [], forceRevalidateAll = _a[0], originalData = _a[1];
                            data = [];
                            pageSize = resolvePageSize();
                            previousPageData = null;
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < pageSize)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _b = $d92826804bd5f1db$var$serialize(getKey(i, previousPageData)), pageKey = _b[0], pageArgs = _b[1];
                            if (!pageKey) // `pageKey` is falsy, stop fetching new pages.
                            return [
                                3 /*break*/ ,
                                5
                            ];
                            pageData = cache.get(pageKey);
                            shouldFetchPage = revalidateAll || forceRevalidateAll || $d92826804bd5f1db$var$isUndefined(pageData) || revalidateFirstPage && !i && !$d92826804bd5f1db$var$isUndefined(dataRef.current) || shouldRevalidateOnMount || originalData && !$d92826804bd5f1db$var$isUndefined(originalData[i]) && !config.compare(originalData[i], pageData);
                            if (!(fn && shouldFetchPage)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                fn.apply(void 0, pageArgs)
                            ];
                        case 2:
                            pageData = _c.sent();
                            cache.set(pageKey, pageData);
                            _c.label = 3;
                        case 3:
                            data.push(pageData);
                            previousPageData = pageData;
                            _c.label = 4;
                        case 4:
                            ++i;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 5:
                            // once we executed the data fetching based on the context, clear the context
                            cache.delete(contextCacheKey);
                            // return the data
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        }, config);
        // update dataRef
        $d92826804bd5f1db$var$useIsomorphicLayoutEffect(function() {
            dataRef.current = swr.data;
        }, [
            swr.data
        ]);
        var mutate = (0, $f2Y41.useCallback)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var data = args[0];
            // Default to true.
            var shouldRevalidate = args[1] !== false;
            // It is possible that the key is still falsy.
            if (!contextCacheKey) return;
            if (shouldRevalidate) {
                if (!$d92826804bd5f1db$var$isUndefined(data)) {
                    // We only revalidate the pages that are changed
                    var originalData = dataRef.current;
                    cache.set(contextCacheKey, [
                        false,
                        originalData
                    ]);
                } else // Calling `mutate()`, we revalidate all pages
                cache.set(contextCacheKey, [
                    true
                ]);
            }
            return args.length ? swr.mutate(data, shouldRevalidate) : swr.mutate();
        }, // swr.mutate is always the same reference
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            contextCacheKey
        ]);
        // Function to load pages data from the cache based on the page size.
        var resolvePagesFromCache = function(pageSize) {
            // return an array of page data
            var data = [];
            var previousPageData = null;
            for(var i = 0; i < pageSize; ++i){
                var pageKey = $d92826804bd5f1db$var$serialize(getKey(i, previousPageData))[0];
                // Get the cached page data.
                var pageData = pageKey ? cache.get(pageKey) : $d92826804bd5f1db$var$UNDEFINED;
                // Return the current data if we can't get it from the cache.
                if ($d92826804bd5f1db$var$isUndefined(pageData)) return dataRef.current;
                data.push(pageData);
                previousPageData = pageData;
            }
            // Return the data
            return data;
        };
        // Extend the SWR API
        var setSize = (0, $f2Y41.useCallback)(function(arg) {
            // It is possible that the key is still falsy.
            if (!pageSizeCacheKey) return;
            var size;
            if ($d92826804bd5f1db$var$isFunction(arg)) size = arg(resolvePageSize());
            else if (typeof arg == "number") size = arg;
            if (typeof size != "number") return;
            cache.set(pageSizeCacheKey, size);
            lastPageSizeRef.current = size;
            rerender({});
            return mutate(resolvePagesFromCache(size));
        }, // `cache` and `rerender` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            pageSizeCacheKey,
            resolvePageSize,
            mutate
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get error () {
                return swr.error;
            },
            get data () {
                return swr.data;
            },
            get isValidating () {
                return swr.isValidating;
            }
        };
    };
};
var $d92826804bd5f1db$export$2e2bcd8739ae039 = $d92826804bd5f1db$var$withMiddleware((0, $f14fedbe4e80ae23$export$2e2bcd8739ae039), $d92826804bd5f1db$export$f27219e7b43e81d);


const $b2d06586a86d14b7$var$isMultiTenant = ()=>true;
const $b2d06586a86d14b7$export$99915ff5fc5148d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9141604a407be72f$exports))).create({
    withCredentials: $b2d06586a86d14b7$var$isMultiTenant()
});
const $b2d06586a86d14b7$export$47fdd40111eda34c = async (url = "", getAccessTokenSilently, timeout = 30000)=>{
    const accessToken = getAccessTokenSilently ? await getAccessTokenSilently() : undefined;
    const controller = new AbortController();
    const timeoutFn = setTimeout(()=>{
        controller.abort();
    }, timeout);
    const response = await $b2d06586a86d14b7$export$99915ff5fc5148d2.get(url, {
        signal: controller.signal,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
    clearTimeout(timeoutFn);
    return response.data;
};
const $b2d06586a86d14b7$export$121604ee484c30df = async (url = "", body = {}, getAccessTokenSilently, timeout = 30000)=>{
    const accessToken = getAccessTokenSilently ? await getAccessTokenSilently() : undefined;
    const controller = new AbortController();
    const timeoutFn = setTimeout(()=>{
        controller.abort();
    }, timeout);
    const response = await $b2d06586a86d14b7$export$99915ff5fc5148d2.post(url, body, {
        signal: controller.signal,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
        }
    });
    clearTimeout(timeoutFn);
    return response.data;
};
const $b2d06586a86d14b7$export$bb0968b4d41ab5a0 = (resource, params = null, options = {})=>{
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const swrOptions = {
        fetcher: $b2d06586a86d14b7$export$47fdd40111eda34c,
        fallbackData: {
            data: [],
            fallback: true
        },
        ...options
    };
    const { data: data, error: error, mutate: mutate } = (0, $f14fedbe4e80ae23$export$2e2bcd8739ae039)([
        `${undefined}/${resource}${params ? `?${params}` : ""}`,
        getAccessTokenSilently,
        options?.timeout
    ], swrOptions);
    return {
        data: data?.data,
        mutate: mutate,
        isLoading: !error && !!data.fallback,
        isError: error
    };
};
const $b2d06586a86d14b7$export$5e6f0c8ad2e7309c = (resource, params = null, options = {}, fetcherFunc = $b2d06586a86d14b7$export$47fdd40111eda34c)=>{
    const pageSize = options.pageSize;
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const getKey = (pageIndex, previousPageData)=>{
        if (!resource) return false;
        // reached the end
        if (pageIndex > 0 && (!previousPageData || previousPageData?.data?.length === 0)) return null;
        // offset = 0 if pageIndex = 0, otherwise is calculated
        const offset = pageIndex * pageSize;
        const url = `${$b2d06586a86d14b7$export$3bb0762bb9063ee8(resource)}?offset=${offset}&limit=${pageSize}${params ? `&${params}` : ""}`;
        return [
            url,
            getAccessTokenSilently
        ];
    };
    const { data: data, error: error, isValidating: isValidating, mutate: mutate, size: size, setSize: setSize } = (0, $d92826804bd5f1db$export$2e2bcd8739ae039)(getKey, fetcherFunc);
    return {
        data: data,
        error: error,
        isValidating: isValidating,
        mutate: mutate,
        size: size,
        setSize: setSize
    };
};
const $b2d06586a86d14b7$export$70bb55947bcc94e6 = (resource, params = null, options = {})=>{
    return $b2d06586a86d14b7$export$5e6f0c8ad2e7309c(resource, params, options, (url, getAccessTokenSilently)=>$b2d06586a86d14b7$export$47fdd40111eda34c(url, getAccessTokenSilently));
};
const $b2d06586a86d14b7$export$8669dbfa51c00391 = (resource, params = null, options = {})=>{
    return $b2d06586a86d14b7$export$5e6f0c8ad2e7309c(resource, params, options, (url, getAccessTokenSilently)=>$b2d06586a86d14b7$export$121604ee484c30df(url, options.body, getAccessTokenSilently));
};
function $b2d06586a86d14b7$export$7e974a91e79f266e(resource, id, options = {}) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const swrOptions = {
        fetcher: $b2d06586a86d14b7$export$47fdd40111eda34c,
        fallbackData: {
            data: {},
            fallback: true
        },
        ...options
    };
    const { data: data, error: error, mutate: mutate } = (0, $f14fedbe4e80ae23$export$2e2bcd8739ae039)(id && [
        $b2d06586a86d14b7$export$7ae26f9c219725a7(resource, id),
        getAccessTokenSilently,
        options?.timeout
    ], swrOptions);
    return {
        data: data?.data,
        mutate: mutate,
        isLoading: !error && !!data.fallback,
        isError: error
    };
}
function $b2d06586a86d14b7$export$7ae26f9c219725a7(resource, id) {
    return `${undefined}/${resource}/${id}`;
}
function $b2d06586a86d14b7$export$3bb0762bb9063ee8(resource) {
    return `${undefined}/${resource}`;
}
function $b2d06586a86d14b7$export$7138c24907de3954(resource) {
    return $b2d06586a86d14b7$export$3bb0762bb9063ee8(resource);
}
function $b2d06586a86d14b7$export$88f1fdfae738af54(resource, id) {
    return $b2d06586a86d14b7$export$7ae26f9c219725a7(resource, id);
}
const $b2d06586a86d14b7$export$99b32c99608275e1 = async (resource, id, getAccessTokenSilently)=>{
    const accessToken = await getAccessTokenSilently();
    return await $b2d06586a86d14b7$export$99915ff5fc5148d2.get($b2d06586a86d14b7$export$7ae26f9c219725a7(resource, id), {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
};
const $b2d06586a86d14b7$export$5edc9d665968dd86 = async (resource, data, getAccessTokenSilently)=>{
    const accessToken = await getAccessTokenSilently();
    return await $b2d06586a86d14b7$export$99915ff5fc5148d2.post($b2d06586a86d14b7$export$7138c24907de3954(resource), data, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
};
const $b2d06586a86d14b7$export$74524c73191a667c = async (resource, id, data, getAccessTokenSilently)=>{
    const accessToken = await getAccessTokenSilently();
    return await $b2d06586a86d14b7$export$99915ff5fc5148d2.patch($b2d06586a86d14b7$export$88f1fdfae738af54(resource, id), data, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
};
const $b2d06586a86d14b7$export$60acb8fd13afd60d = async (resource, id, getAccessTokenSilently)=>{
    const accessToken = await getAccessTokenSilently();
    return await $b2d06586a86d14b7$export$99915ff5fc5148d2.delete($b2d06586a86d14b7$export$88f1fdfae738af54(resource, id), {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
};
function $b2d06586a86d14b7$export$605093bfb55effda() {
    const { cache: cache, mutate: mutate } = (0, $f14fedbe4e80ae23$export$f1dc0e282d4c1c0)();
    return (matcher, ...args)=>{
        if (!(cache instanceof Map)) throw new Error("matchMutate requires the cache provider to be a Map instance");
        const keys = [];
        for (const key of cache.keys())if (matcher.test(key)) keys.push(key);
        const mutations = keys.map((key)=>mutate(key, ...args));
        // console.dir(mutations)
        return Promise.all(mutations);
    };
}


const $a7c01d819f290997$var$defaultContext = {
    currentUser: {},
    isLoading: true,
    authorizedPractices: [],
    practiceId: "",
    practiceName: "",
    changePractice: (id)=>{}
};
const $a7c01d819f290997$export$1d3893771befa5cc = /*#__PURE__*/ (0, $f2Y41.createContext)($a7c01d819f290997$var$defaultContext);
const $a7c01d819f290997$export$9df4dac00da58539 = ({ children: children })=>{
    // TODO: expose logout from here?
    const { isLoading: isLoadingAuth0User, getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { mutate: mutate } = (0, $f14fedbe4e80ae23$export$f1dc0e282d4c1c0)();
    const isCurrentPractice = (practiceId)=>{
        return context.practiceId === practiceId;
    };
    const clearCache = ()=>{
        mutate(()=>true, undefined, {
            rollbackOnError: false
        });
        localStorage.removeItem("bookmarkId");
    };
    const changePractice = async (practiceId)=>{
        if (isCurrentPractice(practiceId)) return;
        const accessToken = await getAccessTokenSilently();
        const authHeaders = {
            Authorization: `Bearer ${accessToken}`
        };
        const authorizationResponse = await (0, $b2d06586a86d14b7$export$99915ff5fc5148d2).post((0, $b2d06586a86d14b7$export$7138c24907de3954)("authorizations"), {
            id: practiceId
        }, {
            headers: authHeaders
        });
        if (authorizationResponse.status === 200) {
            localStorage.removeItem("bookmarkId");
            // refetch current user metadata
            const currentUserResponse = await (0, $b2d06586a86d14b7$export$99915ff5fc5148d2).get((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("authorizations"), {
                headers: authHeaders
            });
            // get authorized practices for user (populate dropdown)
            const authorizedPracticesResponse = await (0, $b2d06586a86d14b7$export$99915ff5fc5148d2).get((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("authorizations/practices"), {
                headers: authHeaders
            });
            // Store in LS for re-authz to same practice
            localStorage.setItem("practiceId", authorizationResponse?.data?.data?.practice_id);
            clearCache();
            setContext({
                ...context,
                currentUser: currentUserResponse?.data?.data,
                isLoading: false,
                authorizedPractices: authorizedPracticesResponse?.data?.data,
                practiceName: authorizationResponse?.data?.data?.practice_name,
                practiceId: authorizationResponse?.data?.data?.practice_id
            });
        }
    };
    const getAuthorizedPractices = async ()=>{
        const accessToken = await getAccessTokenSilently();
        // get list of authorized practices for user (to populate dropdown)
        const authorizedPracticesResponse = await (0, $b2d06586a86d14b7$export$99915ff5fc5148d2).get((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("authorizations/practices"), {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        const authorizedPractices = authorizedPracticesResponse?.data?.data;
        setContext({
            ...context,
            authorizedPractices: authorizedPractices
        });
        return authorizedPractices;
    };
    const [context, setContext] = (0, $f2Y41.useState)({
        ...$a7c01d819f290997$var$defaultContext,
        changePractice: changePractice
    });
    // biome-ignore lint/correctness/useExhaustiveDependencies: No need to specify functions.
    (0, $f2Y41.useEffect)(()=>{
        const authorizeDefault = async ()=>{
            if (isLoadingAuth0User) return;
            // Prefer LS for default practiceId
            if (localStorage.practiceId) await changePractice(localStorage.practiceId);
            else {
                const authorizedPractices = await getAuthorizedPractices();
                await changePractice(authorizedPractices[0]?.id);
            }
        };
        authorizeDefault();
        return ()=>{};
    }, [
        isLoadingAuth0User
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($a7c01d819f290997$export$1d3893771befa5cc.Provider, {
        value: context,
        children: children
    });
};


const $601cdae3149c9149$export$d7f6d67ddc77dc09 = [
    "Admin",
    "Manager"
];
const $601cdae3149c9149$export$e1e2c63f62dbf768 = [
    "Admin",
    "Manager",
    "QaUser"
];
const $601cdae3149c9149$export$75a0747bd4daccc1 = [
    "Manager",
    "User",
    "QaUser"
];
const $601cdae3149c9149$export$fc970ed23da99565 = (currentUser)=>$601cdae3149c9149$export$d7f6d67ddc77dc09.includes(currentUser?.role);
const $601cdae3149c9149$export$3fc5baa28a2e276c = (currentUser)=>$601cdae3149c9149$export$e1e2c63f62dbf768.includes(currentUser?.role);
const $601cdae3149c9149$export$d540efe9354f0ccc = (currentUser)=>$601cdae3149c9149$export$75a0747bd4daccc1.includes(currentUser?.role);
const $601cdae3149c9149$export$787d093fc14ee6d5 = ()=>{
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const { isLoading: isLoadingCurrentUser } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingCurrentUser) return;
        if (!$601cdae3149c9149$export$fc970ed23da99565) navigate("/401");
    }, [
        isLoadingCurrentUser,
        navigate
    ]);
    if (isLoadingCurrentUser) return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "p-4 text-bold dark:text-gray-200",
        children: "Authorizing..."
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c5383ff45095a6a6$export$910ae8079b2c2852), {});
};



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");
const $46e0cc986bfa765c$export$f01b3d7c7bbe3997 = ({ component: component })=>{
    const { user: user, error: error, logout: logout } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    (0, $f2Y41.useEffect)(()=>{
        if (error) {
            localStorage.removeItem("practiceId");
            logout();
        }
    }, [
        error,
        logout
    ]);
    (0, $f2Y41.useEffect)(()=>{
        user;
    }, [
        user
    ]);
    const Component = (0, $05f1c351b568e291$export$2cfd0b285ff12c70)(component, {
        onRedirecting: ()=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "p-4 text-bold dark:text-gray-200",
                children: "Authorizing..."
            })
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)(Component, {});
};



var $ge3KO = parcelRequire("ge3KO");
function $2173b5262bd4822b$export$5dcb52b4331c1c19() {
    return /*#__PURE__*/ (0, $ge3KO.jsx)("section", {
        className: "bg-white dark:bg-gray-900 h-full",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6",
            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mx-auto max-w-screen-sm text-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h1", {
                        className: "mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-white",
                        children: "401"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: " text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white",
                        children: "Where there's a will,"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: "mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white",
                        children: "there's a Waypoints."
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: " text-lg font-light text-gray-500 dark:text-gray-400",
                        children: "You are not authorized to access this instance of Waypoints."
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: "mb-4 text-lg font-light text-gray-500 dark:text-gray-400",
                        children: "Please ask your manager to add you."
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: "text-white text-xs",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                            target: "_blank",
                            href: "https://http.cat/401",
                            children: "Until then, please enjoy this cat."
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                        href: "/logout",
                        className: "inline-flex text-gray-500 dark dark:text-gray-200 ring-1 ring-black dark:ring-gray-200 bg-primary-600 hover:bg-primary-800 hover:dark:bg-gray-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4",
                        children: "Try Again"
                    })
                ]
            })
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
// THIS FILE IS AUTO GENERATED
var $23010cd930dba01e$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
var $a7dee575fbdcc111$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $a7dee575fbdcc111$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext($a7dee575fbdcc111$export$4a4ef469214f8641);


var $b9cadf0191c5a549$var$__assign = undefined && undefined.__assign || function() {
    $b9cadf0191c5a549$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9cadf0191c5a549$var$__assign.apply(this, arguments);
};
var $b9cadf0191c5a549$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b9cadf0191c5a549$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(node.tag, $b9cadf0191c5a549$var$__assign({
            key: i
        }, node.attr), $b9cadf0191c5a549$var$Tree2Element(node.child));
    });
}
function $b9cadf0191c5a549$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($b9cadf0191c5a549$export$a188ecdd443fe91a, $b9cadf0191c5a549$var$__assign({
            attr: $b9cadf0191c5a549$var$__assign({}, data.attr)
        }, props), $b9cadf0191c5a549$var$Tree2Element(data.child));
    };
}
function $b9cadf0191c5a549$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $b9cadf0191c5a549$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("svg", $b9cadf0191c5a549$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $b9cadf0191c5a549$var$__assign($b9cadf0191c5a549$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("title", null, title), props.children);
    };
    return (0, $a7dee575fbdcc111$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $a7dee575fbdcc111$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $a7dee575fbdcc111$export$4a4ef469214f8641));
}





function $723979f296abdb2d$export$e595992411f5c02a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1616b9216a43fb0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e6d8237181e00077(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3aeebe8b6f1cc33e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3a2 2 0 100 4h12a2 2 0 100-4H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6f83bf99372fbcd3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8caebc6ff0d0430c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$96f1a82baba7093a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1fa3103c1c5d6557(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e4809f59ca2a128d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9ff1465f533afd67(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c9a14e78b2b1f074(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4ca7c62f11466803(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2b20727e5912ad2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6c6b6b9f8f5a91bb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$31801311ce602829(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$44823d2571c03dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c028df114e2fa02d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6064eca56d8c2f2b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b0956ae05b241014(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$806bdd8b2264b4b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cca193d174c7132f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 110-2h4a1 1 0 011 1v4a1 1 0 11-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 112 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 110 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5920573bf6788f03(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ff4935f40e26150f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.707 4.879A3 3 0 018.828 4H15a3 3 0 013 3v6a3 3 0 01-3 3H8.828a3 3 0 01-2.12-.879l-4.415-4.414a1 1 0 010-1.414l4.414-4.414zm4 2.414a1 1 0 00-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 101.414 1.414L12 11.414l1.293 1.293a1 1 0 001.414-1.414L13.414 10l1.293-1.293a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e28f2a2c7e30adf0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$36f610f8755cf7a9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$698a7e2929d11b59(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b36b2fcbdda93171(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a1a78df56bb5cc24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$41e89177efacfc84(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b0d4c76cbf142aad(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7de3bb00a8e64801(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$741c1f85a6ac9236(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3a1 1 0 011-1h.01a1 1 0 010 2H7a1 1 0 01-1-1zm2 3a1 1 0 00-2 0v1a2 2 0 00-2 2v1a2 2 0 00-2 2v.683a3.7 3.7 0 011.055.485 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0A3.7 3.7 0 0118 12.683V12a2 2 0 00-2-2V9a2 2 0 00-2-2V6a1 1 0 10-2 0v1h-1V6a1 1 0 10-2 0v1H8V6zm10 8.868a3.704 3.704 0 01-4.055-.036 1.704 1.704 0 00-1.89 0 3.704 3.704 0 01-4.11 0 1.704 1.704 0 00-1.89 0A3.704 3.704 0 012 14.868V17a1 1 0 001 1h14a1 1 0 001-1v-2.132zM9 3a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm3 0a1 1 0 011-1h.01a1 1 0 110 2H13a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a80e2e8768f87e1c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm6 7a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 3a1 1 0 100 2h.01a1 1 0 100-2H10zm-4 1a1 1 0 011-1h.01a1 1 0 110 2H7a1 1 0 01-1-1zm1-4a1 1 0 100 2h.01a1 1 0 100-2H7zm2 1a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm4-4a1 1 0 100 2h.01a1 1 0 100-2H13zM9 9a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zM7 8a1 1 0 000 2h.01a1 1 0 000-2H7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a8dd2a1b239e1efc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b552fe7536c0468(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5b48aea6a5d28211(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5fc6f7a01356c78(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3b19e7533bd47087(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a539f63fddd2ff89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$11c9a8f8a5220484(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$25bd53cba2ba6c18(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9ee77f1a6b0d0868(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$91d8a3592edef97c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$821b175cea1ab476(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$465a2544ec8efb2d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f89f8be16753f14e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$73db59c891acec22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$599e6847ae015d98(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$56f537fdeb34c3ff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$82bcb26f2eb59c71(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bc7bbedc50c1784b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9c9cff50a495d467(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$67618f207c809719(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7H7v6h6V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c4feac27add68d88(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3420b5a53052a835(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a1 1 0 000 2h2a1 1 0 100-2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6bbc8f9b392ffba2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4d723aca6ba2ca1e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3ad63978a64a1c12(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$135234ef6e2e252e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2907af10138d6928(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h2v5a1 1 0 11-2 0v-5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$70a67f4aa0b384c8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a0d4f634fafa9da7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c14e40369440c485(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$94d80bdcad4ade0f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$dbbf324bcaf1a86e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$34085e77bdcb811c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$806f98416c4dde09(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f075bf49289e5f68(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bf9504f03cdbf56f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 4a1 1 0 000 2 1 1 0 011 1v1H7a1 1 0 000 2h1v3a3 3 0 106 0v-1a1 1 0 10-2 0v1a1 1 0 11-2 0v-3h3a1 1 0 100-2h-3V7a3 3 0 00-3-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3b19a3c8fef62243(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b7b8c9b0681ba790(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ce38a25d18f7a335(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-14a3 3 0 00-3 3v2H7a1 1 0 000 2h1v1a1 1 0 01-1 1 1 1 0 100 2h6a1 1 0 100-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 100-2h-1V7a1 1 0 112 0 1 1 0 102 0 3 3 0 00-3-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$10ba64a33c3140(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 5a1 1 0 100 2h1a2 2 0 011.732 1H7a1 1 0 100 2h2.732A2 2 0 018 11H7a1 1 0 00-.707 1.707l3 3a1 1 0 001.414-1.414l-1.483-1.484A4.008 4.008 0 0011.874 10H13a1 1 0 100-2h-1.126a3.976 3.976 0 00-.41-1H13a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c51e6e971092dc01(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7.858 5.485a1 1 0 00-1.715 1.03L7.633 9H7a1 1 0 100 2h1.834l.166.277V12H7a1 1 0 100 2h2v1a1 1 0 102 0v-1h2a1 1 0 100-2h-2v-.723l.166-.277H13a1 1 0 100-2h-.634l1.492-2.486a1 1 0 10-1.716-1.029L10.034 9h-.068L7.858 5.485z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e5092cb7c25f978a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d23380055ddd43ad(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$87f13ed817cfc818(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6c9b9f8b1a919f4a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cd86a9b3fdf305c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$aa22a76202610e66(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a556134e0ac5efca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d66da83af5d303c5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8a940bc68c2a4426(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm1 8a1 1 0 100 2h6a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$24702b07da71ceb8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f6d4956163b38d6d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$984afc0ca91a7c3d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cd9c5eb3ad11c851(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ee9668e7c3eca25a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1058c1fe955ce89c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$12e36d03ee575f24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e303554b451e92b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5566a4bb3712a33a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$51882ba6c6e74fe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3a3a3872e2858be0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bc4391ff83d57f70(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5f3b9f56a5dc0b7b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c7210d045332793(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$88017a8724b08283(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9de34d3478cf8bf6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12a2 2 0 100-4 2 2 0 000 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9d2e184d04a37896(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ce00796f13e2d35b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm3 2h6v4H7V5zm8 8v2h1v-2h-1zm-2-2H7v4h6v-4zm2 0h1V9h-1v2zm1-4V5h-1v2h1zM5 5v2H4V5h1zm0 4H4v2h1V9zm-1 4h1v2H4v-2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$17b5ecef89093acc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$77ed4813822302b3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e90136adc3010307(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$81b964db4a204a77(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b18c5d0d55619c04(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1H8a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bb19e0bd21666749(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1.586l-.293-.293a1 1 0 10-1.414 1.414l2 2 .002.002a.997.997 0 001.41 0l.002-.002 2-2a1 1 0 00-1.414-1.414l-.293.293V9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a3da265d52fd5ee4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$44a6304247590c9e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm4 6a1 1 0 100 2h4a1 1 0 100-2H8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7f5d6f4588753434(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$987d7c7460d30045(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7ca6230f131d91d8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1c088659bb919526(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f6b0d1e625ecd289(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$88f2258a787e92e4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5545989e51ba8dfd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d1db4af156bb87a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7e81ce36bbe2881(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8a3870f9d3ad7ef1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6a40c65ea9f1dd2e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e5a90b2c292d5311(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$56517490a03a7c7e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c92acead88745256(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c32caa62b5742142(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f2488a63c3a17e89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6742698e6e680854(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$dd2b424713e2bf80(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f3ac4ef68f8ca6a2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c9b7245affcd2f86(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$463407f42827341d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a2c41ffab906ca2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4ed73b6785a33eca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$dac529e19af6d6cf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b2494b9c2a218715(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c0d54fc8bddd39c1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bec07a9f4c8edda3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7db18fd659e2e3d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8988e7bfa72cce56(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$84c5199511ace80c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$81885adcf21ead19(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2bf4b21c38df7f54(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e69bc80efd0eaa81(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b2a60a29aef9b8a5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7e4aa2af55f6be66(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8202af743e62c68c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$60de943027b9489e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ee2d91085825fb3f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d61f62e80319a325(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8895c5d66ef3d9ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cbf23f3f659aea07(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c17fd1a7f6b67eaf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4f6bab266349124d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1a03443ed59e7d58(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.414 7l3.293-3.293a1 1 0 00-1.414-1.414L13 5.586V4a1 1 0 10-2 0v4.003a.996.996 0 00.617.921A.997.997 0 0012 9h4a1 1 0 100-2h-1.586z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4453b11472e39abe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 3.293a1 1 0 010 1.414L15.414 6l1.293 1.293a1 1 0 01-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 11-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 011.414-1.414L14 4.586l1.293-1.293a1 1 0 011.414 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1f7c880f08634530(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$99c434ee04b7ab49(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$42dca44771d02c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7deaefb3cf5eb13e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c48ecf3035cedb98(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$23e190fd95eceb8c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$875ee70bdd91102a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8356c4270a0b46b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4c3fc2ec1da6e090(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b0ea481df3fb0c2c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$baced853c6e72667(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f48de02c79584b89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f58ad40e99a784e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$498794c34ca73670(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2bb03edf0fab11b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d099eeef45bbd1dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$689380b85771be43(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a1d13b33271dad4c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.445 14.832A1 1 0 0010 14v-2.798l5.445 3.63A1 1 0 0017 14V6a1 1 0 00-1.555-.832L10 8.798V6a1 1 0 00-1.555-.832l-6 4a1 1 0 000 1.664l6 4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8e66494bf0d777ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1zM3 15a2 2 0 114 0 2 2 0 01-4 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e8e5a132439a2536(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 7.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L13 8.586V5h3a2 2 0 012 2v5a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2h3v3.586L9.707 7.293zM11 3a1 1 0 112 0v2h-2V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9a2 2 0 00-2 2v5a2 2 0 002 2h8a2 2 0 002-2H4V9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cf7db0dc06f0082a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4579df701420ceaf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1zm-5 8.274l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274zm10 0l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$214b071b33afce1f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 2a3.5 3.5 0 101.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 101.414 1.414l8.128-8.127a1 1 0 00-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 005.5 2zM4 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.828 11.414a1 1 0 00-1.414 1.414l3.879 3.88a1 1 0 001.414-1.415l-3.879-3.879z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$eadf3426c0e4ee2a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9a2 2 0 114 0 2 2 0 01-4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a48dcd8df5ff9e7f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1ee02bf8c29613c1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$fd572c1e49d934b0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2bd8b8521c235b78(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2d6a975087cf711e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1d5b572a57944885(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1ec8700161c55b46(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$54a71e5a057b4abf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2726fb438bc26c57(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8106702344c81adf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$412fadf898aea0c0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3b9a7f115dfaacec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$393795b12e2c4440(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c6e5d194d3d67cc6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cb776b3ecd184bdc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$34124a9e13eee937(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$442843c5ba15ec2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$82bbc63dfb664336(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$51b66d37206c4027(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f38978416fdef409(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2e66429b3b3b953e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7d21f05b33bd9222(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$75d37acb85fa981c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$81b7aad39a547c71(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1f78418738f63817(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d1b30753338fe6a7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f29b85c6ef070fc3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$634b57f6a737a15a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 11.236 11.618 14z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f0a104d065dbc773(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$70736c562dbf9b63(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$64d0fea70ca7fd0b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$91a5efbfe15324f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$aa59e72748f2a674(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5681c304b619578a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$79cbfa7dee2f56c9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5d3ec567cf898fe0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$261194ae3e8ebf48(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c34b0ba546a3447e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b2784890812388db(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$12d22beb83fd49e5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.649 3.084A1 1 0 015.163 4.4 13.95 13.95 0 004 10c0 1.993.416 3.886 1.164 5.6a1 1 0 01-1.832.8A15.95 15.95 0 012 10c0-2.274.475-4.44 1.332-6.4a1 1 0 011.317-.516zM12.96 7a3 3 0 00-2.342 1.126l-.328.41-.111-.279A2 2 0 008.323 7H8a1 1 0 000 2h.323l.532 1.33-1.035 1.295a1 1 0 01-.781.375H7a1 1 0 100 2h.039a3 3 0 002.342-1.126l.328-.41.111.279A2 2 0 0011.677 14H12a1 1 0 100-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0112.961 9H13a1 1 0 100-2h-.039zm1.874-2.6a1 1 0 011.833-.8A15.95 15.95 0 0118 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 11-1.832-.8A13.949 13.949 0 0016 10c0-1.993-.416-3.886-1.165-5.6z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$35271e75fceb5db6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4f6275e657af0efd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4zM8 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM15 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a13b88d40b1ae72b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$22b98413b535cc7c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bd7739bbef2e5957(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e37b53d4d50481f2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ed1e84a0f52a9980(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$194dd78d20966171(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4b20f156351c40e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c467cab8758a9d22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$32abdacd93e10754(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c1006eae2f1f2117(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3b654b93b8eaafa1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14l9-5-9-5-9 5 9 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$302321a7cf8aaab7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ddaef686ca07d5b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$573bfde2789b368e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d864043cef723fc4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$759c92c41b27fa68(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a553c143cc6a1dcc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c32fa367633d4782(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9d950d97eaa2dc0c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 14l-7 7m0 0l-7-7m7 7V3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$77502adb99fcd8be(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 19l-7-7m0 0l7-7m-7 7h18"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$43ee2ef66c8b8e2b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 17l-4 4m0 0l-4-4m4 4V3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1bb3de3273a6bbbc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16l-4-4m0 0l4-4m-4 4h18"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$747238c57992b0fa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 8l4 4m0 0l-4 4m4-4H3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9ae14de14453be11(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7l4-4m0 0l4 4m-4-4v18"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7fe3cf94b6c37b86(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14 5l7 7m0 0l-7 7m7-7H3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$edd013531fbf328b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 13l-5 5m0 0l-5-5m5 5V6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f9e89ef05ff1e642(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 17l-5-5m0 0l5-5m-5 5h12"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a8382a1d4f4231d0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 7l5 5m0 0l-5 5m5-5H6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8b8e5ec668020790(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 11l5-5m0 0l5 5m-5-5v12"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$37783468f17d7e06(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 10l7-7m0 0l7 7m-7-7v18"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$71b2a981d2dc5a89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c3958e2accb9505f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2b1665291f9426e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2a67b527cad24254(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6230605be3cd312c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6aa7adc449ea9ac1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$aa56ce8610ca0973(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$89af2c065e935128(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5c6fc4cffa55c8e0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$699f3cbce545b829(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9600caf141b56c6c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6d7863967f733fd2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a8f06d871bb8ff04(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a14f597a22dfb652(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bc66cc383b33e539(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2339a628f526c798(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$63adca778605083e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$60d1a6cba488b43e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4bf4bc27c733f770(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$fd3d36f9af4a2d22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$648b47e2700df345(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$87552753cb819673(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9a1a8b2d6ab58608(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ef381511b9802793(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 13l4 4L19 7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$843b49bd6b617f13(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 13l-7 7-7-7m14-8l-7 7-7-7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$311129baf32aa0f4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 19l-7-7 7-7m8 14l-7-7 7-7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1dd423af30d22815(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 5l7 7-7 7M5 5l7 7-7 7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5a4bfc02972f8d18(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 11l7-7 7 7M5 19l7-7 7 7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$726570e851b9b2cd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 9l-7 7-7-7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$225198a30aa903b0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 19l-7-7 7-7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$32bd0c97674edac4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5l7 7-7 7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4ac96d5b34ade2ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 15l7-7 7 7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b6bd5a8435dcbca1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f14832772bf880a6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2ba8ccdcab0e616e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$45835242b592cd1c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$57c839bd5c10f27e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$14ab61214d497117(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ad194596f65c17e3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$95f7fa9af5af5c5f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3ef2b4dc34dd1b97(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$266f9105f7102553(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7605f2a0a0e42a6d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d8a2cd69e22c099b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$66d9acb599bec3ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$55893c9ddbe40fa5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cddd23206823c35e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8786a39881183e0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$38ad824b7b8e65a3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d9ae4181216cc699(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$66c3463e55dcbe4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9cfb3dae36717a7b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$623a3d2132280bf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$5e2d18ca48c47a2c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 8l3 5m0 0l3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9e50f44972efffee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$63c518c5c6655281(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7e9e9af9e40742f5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4b6a7fc8a9dd822b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a6bb6360e617313(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d261b6b1bf079a61(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f49709fd8cb2bdef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f52ac7053cfb06e5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$554cf636834bc190(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2c400cab9db7234d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$33d3ea68c57ccac5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$88a0ce635623423b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$46defa4b99687dde(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b7276669fe8648a1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$dc0ab8e9a0025c66(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8f3e11ccd8ff435c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d5d20029b1ae2443(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8954b48bb16c05c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b3f86842ddc8e736(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$785f712f582b0a87(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$da499d267704229a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1a511bea4dc53cd9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$47a98ad04b9ceb7d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b1315ffccbeb0a06(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4019ad0228cf230d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$fb454e6e54087dd4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c07775ff2eb6c0d4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4961240bcf09d56c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$42ac69defe0a3a62(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f7f8f4754d6fa5c3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ead0b900fd8492c3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8d95205c77e0d121(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8d11e77cc24ab0c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$35086476398b52fa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$eeb6c67b408173c4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$190f02bee8e6dfd5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$60b8e31e1ab4f13f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6c9a2eaac757cff4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$82a7a70703ff591b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f22d36bc7c696ca9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e3f45496c5d4c3d2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9a4b7d4053502a5d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7e6e46892ce723ca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3dfc45b469d0543a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1f24ede243ed424b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$fd7ff23bfa325726(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2b04b527c1d0cfff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2abc6ba285576b1d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3233d5737fd94d2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$15ba218cd88c8e97(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$fcc249d5b70ddfb9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 10V3L4 14h7v7l9-11h-7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e9beb6593c21e917(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c08d9f90a8c01db0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$40df62d89f8a1f8a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b5b9ce2fb8075bc4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ae9bf1281c0351da(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e0b05a7e06db0251(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b55987900f03246f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1225ebf3ee76e3af(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8c16ada7d4e0406e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b32a9b96771375a9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h8m-8 6h16"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$abf966088a43bd1f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h16M4 18h7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$da5d2f8929020d76(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h16m-7 6h7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$647fd3269e3039e7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 8h16M4 16h16"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2bd8a9c73fd2676c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h16M4 18h16"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a02e9358a8aa6c02(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e53b0edee4c217cf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$40d0c59d9f485e91(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 12H6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$46e87f9e84b73ba5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20 12H4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f2f033b31c4b285b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$71f15506002a994f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a176df79cb5bccaa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$97464d2616c888b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a7e8e785037407a5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a29d459c879d2161(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$26b2ebf8af58bb20(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$bae7f04c7b50169c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$db398ed4e926add(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$71c1e16122a9c364(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$fe4844e7a46dcb0b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cea050e9b1647ea3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f9281e86d45abe41(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4ac3e3159a1ea478(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a2600351beaba61b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1fd0e5cd177844d0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c2f3dc183739b679(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6v6m0 0v6m0-6h6m-6 0H6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$27cd1afdf7f4470e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4v16m8-8H4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8e3fa82e64613981(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7c2ff654888109a5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2c1a56235b45c575(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$14b2948a4697c3d0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6ecd9dfa82703f92(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d6c359237fdf0ef5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8778d03d001c08b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1539538aa947590d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3cd9c09d0e2a3900(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$476eadb88ccdc078(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2e9054e64d154a0a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1f7393268d72960b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$74c669f6c1a8dbea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b24682e10ecc3cfc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c6b0b380f3bd0b51(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8f1e55149d6d480(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$95160e01025dc9f1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$c497e92f9daf2211(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$26904acaf32bbce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 9l4-4 4 4m0 6l-4 4-4-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f4e04312d2259bb9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b376f5f65166f995(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9a8507825bdd2f91(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8927dade1d459b75(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$818c2aa86e65d95b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$69df15749a11cc63(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$56769e3c0edd4341(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a596fec8b6be169(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e69af8987144f130(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$56ffc74343637818(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$dd0215ba83434816(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$3825d84a8e4d21d3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b4b43fa2d2d13635(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$f504e31bc263edf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4d7c47a64329e6ef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e308f2eab00c1b30(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9d0b9223d56458eb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4d5acb6d0e505d38(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8659c3b8427c8f40(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$af8e2a2f66fd87ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$d24da1e1100de865(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4e4f93cdb6186760(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6da42b8dd06bd3a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$41652c4b4064cf52(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$85f455b1fdd17024(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$977f21cb77022072(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$7d22a43f76f0716a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$2aa33c7ef0d9ee99(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$108e9c7cba15e175(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$6b9c00199eba78cb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b43c831e161e8d5d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$283424b2088457d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9a46aceb737bef54(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$1faf08453613948f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$ce336552817cabd3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$4785171460d5141d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$263506651404f09a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$8e7cff432beaa79e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.871 4A17.926 17.926 0 003 12c0 2.874.673 5.59 1.871 8m14.13 0a17.926 17.926 0 001.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 01.961.725l1.586 5.55a1 1 0 00.961.725H15m1-7h-.08a2 2 0 00-1.519.698L9.6 15.302A2 2 0 018.08 16H8"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$9e2aa154c42f8bbd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$e8dc65fa92b0ea8e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$b583873e3ce2016c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$cc1fd7cd1c186957(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$dc219b7cbc961f91(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 10h16M4 14h16M4 18h16"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$251ab14050546fc2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$be25cc99a7fe8eed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$a5ba443f95c9a06(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$21ba956edc026b2e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$395d0e58f53a4128(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 18L18 6M6 6l12 12"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$93b7e834a1b4c546(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                }
            }
        ]
    })(props);
}
function $723979f296abdb2d$export$398147329b12d800(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"
                }
            }
        ]
    })(props);
}


var $f95b7696b9ef9ea5$var$CLASS_PART_SEPARATOR = "-";
function $f95b7696b9ef9ea5$export$e3a687438e51f555(config) {
    var classMap = $f95b7696b9ef9ea5$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($f95b7696b9ef9ea5$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $f95b7696b9ef9ea5$var$getGroupRecursive(classParts, classMap) || $f95b7696b9ef9ea5$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $f95b7696b9ef9ea5$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $f95b7696b9ef9ea5$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($f95b7696b9ef9ea5$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })?.classGroupId;
}
var $f95b7696b9ef9ea5$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $f95b7696b9ef9ea5$var$getGroupIdForArbitraryProperty(className) {
    if ($f95b7696b9ef9ea5$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $f95b7696b9ef9ea5$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $f95b7696b9ef9ea5$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $f95b7696b9ef9ea5$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $f95b7696b9ef9ea5$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $f95b7696b9ef9ea5$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $f95b7696b9ef9ea5$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($f95b7696b9ef9ea5$var$isThemeGetter(classDefinition)) {
                $f95b7696b9ef9ea5$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $f95b7696b9ef9ea5$var$processClassesRecursively(classGroup, $f95b7696b9ef9ea5$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $f95b7696b9ef9ea5$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($f95b7696b9ef9ea5$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $f95b7696b9ef9ea5$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $f95b7696b9ef9ea5$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}


// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $3bca683143bd61d3$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}


var $81986c603f3787c9$export$61823b46426d06fa = "!";
function $81986c603f3787c9$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($81986c603f3787c9$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $81986c603f3787c9$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}


function $d2605b7c47a13bd4$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $3bca683143bd61d3$export$cf6a7cbaa5f64437)(config.cacheSize),
        splitModifiers: (0, $81986c603f3787c9$export$b5f40ac45a8dd583)(config),
        ...(0, $f95b7696b9ef9ea5$export$e3a687438e51f555)(config)
    };
}



var $7a3bca73b9bec939$var$SPLIT_CLASSES_REGEX = /\s+/;
function $7a3bca73b9bec939$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($7a3bca73b9bec939$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $81986c603f3787c9$export$4f247a60f8a83b3a)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $81986c603f3787c9$export$61823b46426d06fa) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}


/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $089cdfeed300423f$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $089cdfeed300423f$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $089cdfeed300423f$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $089cdfeed300423f$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}


function $e93f9aabeada7494$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $d2605b7c47a13bd4$export$56ab4ba5b0b25eb0)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $7a3bca73b9bec939$export$b41084d9255a3248)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $089cdfeed300423f$export$a8bbfb445e1f163f).apply(null, arguments));
    };
}


function $fc67a3ebd25bd0be$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}


var $2319a4b0cc2d23f1$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $2319a4b0cc2d23f1$var$fractionRegex = /^\d+\/\d+$/;
var $2319a4b0cc2d23f1$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $2319a4b0cc2d23f1$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $2319a4b0cc2d23f1$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $2319a4b0cc2d23f1$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $2319a4b0cc2d23f1$export$38db3d147cb3433(value) {
    return $2319a4b0cc2d23f1$export$7e4aa119212bc614(value) || $2319a4b0cc2d23f1$var$stringLengths.has(value) || $2319a4b0cc2d23f1$var$fractionRegex.test(value) || $2319a4b0cc2d23f1$export$f5e3af6d4c0fbe38(value);
}
function $2319a4b0cc2d23f1$export$f5e3af6d4c0fbe38(value) {
    return $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "length", $2319a4b0cc2d23f1$var$isLengthOnly);
}
function $2319a4b0cc2d23f1$export$92dbd3a305a7cb8b(value) {
    return $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "size", $2319a4b0cc2d23f1$var$isNever);
}
function $2319a4b0cc2d23f1$export$57d00f225f425549(value) {
    return $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "position", $2319a4b0cc2d23f1$var$isNever);
}
function $2319a4b0cc2d23f1$export$478a5386e985802b(value) {
    return $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "url", $2319a4b0cc2d23f1$var$isUrl);
}
function $2319a4b0cc2d23f1$export$ea45ce4f1b2d6088(value) {
    return $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "number", $2319a4b0cc2d23f1$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $2319a4b0cc2d23f1$export$cd3ce15f42623f06 = $2319a4b0cc2d23f1$export$ea45ce4f1b2d6088;
function $2319a4b0cc2d23f1$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $2319a4b0cc2d23f1$export$e50269385c77c348(value) {
    return value.endsWith("%") && $2319a4b0cc2d23f1$export$7e4aa119212bc614(value.slice(0, -1));
}
function $2319a4b0cc2d23f1$export$a287f47fed4544b8(value) {
    return $2319a4b0cc2d23f1$var$isIntegerOnly(value) || $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "number", $2319a4b0cc2d23f1$var$isIntegerOnly);
}
function $2319a4b0cc2d23f1$export$5534a8576501817d(value) {
    return $2319a4b0cc2d23f1$var$arbitraryValueRegex.test(value);
}
function $2319a4b0cc2d23f1$export$ebb65efc98a3b5f7() {
    return true;
}
function $2319a4b0cc2d23f1$export$a40791c6b7db5bcc(value) {
    return $2319a4b0cc2d23f1$var$tshirtUnitRegex.test(value);
}
function $2319a4b0cc2d23f1$export$d01106465b385604(value) {
    return $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, "", $2319a4b0cc2d23f1$var$isShadow);
}
function $2319a4b0cc2d23f1$var$getIsArbitraryValue(value, label, testValue) {
    var result = $2319a4b0cc2d23f1$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $2319a4b0cc2d23f1$var$isLengthOnly(value) {
    return $2319a4b0cc2d23f1$var$lengthUnitRegex.test(value);
}
function $2319a4b0cc2d23f1$var$isNever() {
    return false;
}
function $2319a4b0cc2d23f1$var$isUrl(value) {
    return value.startsWith("url(");
}
function $2319a4b0cc2d23f1$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $2319a4b0cc2d23f1$var$isShadow(value) {
    return $2319a4b0cc2d23f1$var$shadowRegex.test(value);
}


function $8d36ea5839cb2551$export$ed30944e0fe6ae5c() {
    var colors = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("colors");
    var spacing = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("spacing");
    var blur = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("blur");
    var brightness = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("brightness");
    var borderColor = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("borderColor");
    var borderRadius = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("borderRadius");
    var borderSpacing = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("borderSpacing");
    var borderWidth = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("borderWidth");
    var contrast = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("contrast");
    var grayscale = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("grayscale");
    var hueRotate = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("hueRotate");
    var invert = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("invert");
    var gap = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("gap");
    var gradientColorStops = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("gradientColorStops");
    var gradientColorStopPositions = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("gradientColorStopPositions");
    var inset = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("inset");
    var margin = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("margin");
    var opacity = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("opacity");
    var padding = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("padding");
    var saturate = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("saturate");
    var scale = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("scale");
    var sepia = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("sepia");
    var skew = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("skew");
    var space = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("space");
    var translate = (0, $fc67a3ebd25bd0be$export$e176af7b8eefe933)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $2319a4b0cc2d23f1$export$7e4aa119212bc614),
            (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $2319a4b0cc2d23f1$export$7e4aa119212bc614),
            (0, $2319a4b0cc2d23f1$export$ea45ce4f1b2d6088)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $2319a4b0cc2d23f1$export$7e4aa119212bc614),
            (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $2319a4b0cc2d23f1$export$ebb65efc98a3b5f7)
            ],
            spacing: [
                (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
            ],
            blur: [
                "none",
                "",
                (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc),
                (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc),
                (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $2319a4b0cc2d23f1$export$e50269385c77c348),
                (0, $2319a4b0cc2d23f1$export$f5e3af6d4c0fbe38)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $2319a4b0cc2d23f1$export$a287f47fed4544b8)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $2319a4b0cc2d23f1$export$a287f47fed4544b8)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $2319a4b0cc2d23f1$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $2319a4b0cc2d23f1$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $2319a4b0cc2d23f1$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $2319a4b0cc2d23f1$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc)
                            ]
                        },
                        (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc),
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc),
                        (0, $2319a4b0cc2d23f1$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $2319a4b0cc2d23f1$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $2319a4b0cc2d23f1$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $2319a4b0cc2d23f1$export$7e4aa119212bc614),
                        (0, $2319a4b0cc2d23f1$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $2319a4b0cc2d23f1$export$57d00f225f425549)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $2319a4b0cc2d23f1$export$92dbd3a305a7cb8b)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $2319a4b0cc2d23f1$export$478a5386e985802b)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d),
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc),
                        (0, $2319a4b0cc2d23f1$export$d01106465b385604)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $2319a4b0cc2d23f1$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $2319a4b0cc2d23f1$export$a40791c6b7db5bcc),
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $2319a4b0cc2d23f1$export$a287f47fed4544b8),
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $2319a4b0cc2d23f1$export$5534a8576501817d)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $2319a4b0cc2d23f1$export$38db3d147cb3433),
                        (0, $2319a4b0cc2d23f1$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}


var $a58741766239bf1a$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $e93f9aabeada7494$export$ea2d4fba4d1bd27f)((0, $8d36ea5839cb2551$export$ed30944e0fe6ae5c));



/**
 * Check if provided parameter is plain object
 * @param item
 * @returns boolean
 */ function $7b2e6ff52600979d$var$isObject(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $7b2e6ff52600979d$var$cloneDeep(source) {
    if (!$7b2e6ff52600979d$var$isObject(source)) return source;
    const output = {
        ...source
    };
    Object.keys(source).forEach((key)=>{
        output[key] = $7b2e6ff52600979d$var$cloneDeep(source[key]);
    });
    return output;
}
function $7b2e6ff52600979d$export$dd702b3c8240390c(target, source) {
    if ($7b2e6ff52600979d$var$isObject(source) && Object.keys(source).length === 0) return $7b2e6ff52600979d$var$cloneDeep({
        ...target,
        ...source
    });
    const output = {
        ...target,
        ...source
    };
    if ($7b2e6ff52600979d$var$isObject(source) && $7b2e6ff52600979d$var$isObject(target)) Object.keys(source).forEach((key)=>{
        if ($7b2e6ff52600979d$var$isObject(source[key]) && key in target && $7b2e6ff52600979d$var$isObject(target[key])) output[key] = $7b2e6ff52600979d$export$dd702b3c8240390c(target[key], source[key]);
        else output[key] = $7b2e6ff52600979d$var$isObject(source[key]) ? $7b2e6ff52600979d$var$cloneDeep(source[key]) : source[key];
    });
    return output;
}



var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");
const $044fa893a7447b7f$export$a861b49308956350 = (0, $f2Y41.createContext)(undefined);
function $044fa893a7447b7f$export$33b38874135ce337() {
    const context = (0, $f2Y41.useContext)($044fa893a7447b7f$export$a861b49308956350);
    if (!context) throw new Error("useAccordionContext should be used within the AccordionPanelContext provider!");
    return context;
}


const $15bf9c900c66c20d$export$985b9a77379b54a0 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const { isOpen: isOpen } = (0, $044fa893a7447b7f$export$33b38874135ce337)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.accordion.content, customTheme);
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        "data-testid": "flowbite-accordion-content",
        hidden: !isOpen,
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

const $7d3bd515ef9a0631$export$7cad6f17fd6e117b = ({ children: children, ...props })=>{
    const { alwaysOpen: alwaysOpen } = props;
    const [isOpen, setOpen] = (0, $f2Y41.useState)(props.isOpen);
    const provider = alwaysOpen ? {
        ...props,
        isOpen: isOpen,
        setOpen: ()=>setOpen(!isOpen)
    } : props;
    return (0, $ge3KO.jsx)((0, $044fa893a7447b7f$export$a861b49308956350).Provider, {
        value: provider,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");




const $714fdd9a42e30a5a$export$aa045c814f8dfd58 = ({ as: Heading = "h2", children: children, className: className, theme: customTheme = {}, ...props })=>{
    const { arrowIcon: ArrowIcon, flush: flush, isOpen: isOpen, setOpen: setOpen } = (0, $044fa893a7447b7f$export$33b38874135ce337)();
    const onClick = ()=>typeof setOpen !== "undefined" && setOpen();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.accordion.title, customTheme);
    return (0, $ge3KO.jsxs)("button", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.flush[flush ? "on" : "off"], theme.open[isOpen ? "on" : "off"], className),
        onClick: onClick,
        type: "button",
        ...props,
        children: [
            (0, $ge3KO.jsx)(Heading, {
                className: theme.heading,
                "data-testid": "flowbite-accordion-heading",
                children: children
            }),
            ArrowIcon && (0, $ge3KO.jsx)(ArrowIcon, {
                "aria-hidden": true,
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.arrow.base, theme.arrow.open[isOpen ? "on" : "off"]),
                "data-testid": "flowbite-accordion-arrow"
            })
        ]
    });
};


const $8266bbe54b82b8e7$var$AccordionComponent = ({ alwaysOpen: alwaysOpen = false, arrowIcon: arrowIcon = (0, $723979f296abdb2d$export$56f537fdeb34c3ff), children: children, flush: flush = false, collapseAll: collapseAll = false, className: className, theme: customTheme = {}, ...props })=>{
    const [isOpen, setOpen] = (0, $f2Y41.useState)(collapseAll ? -1 : 0);
    const panels = (0, $f2Y41.useMemo)(()=>(0, $f2Y41.Children).map(children, (child, i)=>(0, $f2Y41.cloneElement)(child, {
                alwaysOpen: alwaysOpen,
                arrowIcon: arrowIcon,
                flush: flush,
                isOpen: isOpen === i,
                setOpen: ()=>setOpen(isOpen === i ? -1 : i)
            })), [
        alwaysOpen,
        arrowIcon,
        children,
        flush,
        isOpen
    ]);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.accordion.root, customTheme);
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.flush[flush ? "on" : "off"], className),
        "data-testid": "flowbite-accordion",
        ...props,
        children: panels
    });
};
$8266bbe54b82b8e7$var$AccordionComponent.displayName = "Accordion";
(0, $7d3bd515ef9a0631$export$7cad6f17fd6e117b).displayName = "Accordion.Panel";
(0, $714fdd9a42e30a5a$export$aa045c814f8dfd58).displayName = "Accordion.Title";
(0, $15bf9c900c66c20d$export$985b9a77379b54a0).displayName = "Accordion.Content";
const $8266bbe54b82b8e7$export$a766cd26d0d69044 = Object.assign($8266bbe54b82b8e7$var$AccordionComponent, {
    Panel: (0, $7d3bd515ef9a0631$export$7cad6f17fd6e117b),
    Title: (0, $714fdd9a42e30a5a$export$aa045c814f8dfd58),
    Content: (0, $15bf9c900c66c20d$export$985b9a77379b54a0)
});



var $ge3KO = parcelRequire("ge3KO");




const $fb7444a142b0b434$export$caec2af78bcc877f = ({ additionalContent: additionalContent, children: children, className: className, color: color = "info", icon: Icon, onDismiss: onDismiss, rounded: rounded = true, theme: customTheme = {}, withBorderAccent: withBorderAccent, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.alert, customTheme);
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.color[color], rounded && theme.rounded, withBorderAccent && theme.borderAccent, className),
        role: "alert",
        ...props,
        children: [
            (0, $ge3KO.jsxs)("div", {
                className: theme.wrapper,
                "data-testid": "flowbite-alert-wrapper",
                children: [
                    Icon && (0, $ge3KO.jsx)(Icon, {
                        className: theme.icon,
                        "data-testid": "flowbite-alert-icon"
                    }),
                    (0, $ge3KO.jsx)("div", {
                        children: children
                    }),
                    typeof onDismiss === "function" && (0, $ge3KO.jsx)("button", {
                        "aria-label": "Dismiss",
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.closeButton.base, theme.closeButton.color[color]),
                        onClick: onDismiss,
                        type: "button",
                        children: (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$c467cab8758a9d22), {
                            "aria-hidden": true,
                            className: theme.closeButton.icon
                        })
                    })
                ]
            }),
            additionalContent && (0, $ge3KO.jsx)("div", {
                children: additionalContent
            })
        ]
    });
};
$fb7444a142b0b434$export$caec2af78bcc877f.displayName = "Alert";



var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");



const $505444cc28f58c9b$export$5b26ebaf2b105908 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.avatar.group, customTheme);
    return (0, $ge3KO.jsx)("div", {
        "data-testid": "avatar-group-element",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: children
    });
};
$505444cc28f58c9b$export$5b26ebaf2b105908.displayName = "Avatar.Group";



var $ge3KO = parcelRequire("ge3KO");



const $29f5b5ec08ed46a5$export$5105d46845389b5f = ({ className: className, href: href, theme: customTheme = {}, total: total, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.avatar.groupCounter, customTheme);
    return (0, $ge3KO.jsxs)("a", {
        href: href,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            "+",
            total
        ]
    });
};
$29f5b5ec08ed46a5$export$5105d46845389b5f.displayName = "Avatar.GroupCounter";


const $e877b1f1ea469658$var$AvatarComponent = ({ alt: alt = "", bordered: bordered = false, children: children, className: className, color: color = "light", img: img, placeholderInitials: placeholderInitials = "", rounded: rounded = false, size: size = "md", stacked: stacked = false, status: status, statusPosition: statusPosition = "top-left", theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.avatar, customTheme);
    const imgClassName = (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.img.base, bordered && theme.root.bordered, bordered && theme.root.color[color], rounded && theme.root.rounded, stacked && theme.root.stacked, theme.root.img.on, theme.root.size[size]);
    const imgProps = {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(imgClassName, theme.root.img.on),
        "data-testid": "flowbite-avatar-img"
    };
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
        "data-testid": "flowbite-avatar",
        ...props,
        children: [
            (0, $ge3KO.jsxs)("div", {
                className: "relative",
                children: [
                    img ? typeof img === "string" ? (0, $ge3KO.jsx)("img", {
                        alt: alt,
                        src: img,
                        ...imgProps
                    }) : img({
                        alt: alt,
                        ...imgProps
                    }) : placeholderInitials ? (0, $ge3KO.jsx)("div", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.img.off, theme.root.initials.base, stacked && theme.root.stacked, bordered && theme.root.bordered, bordered && theme.root.color[color], theme.root.size[size], rounded && theme.root.rounded),
                        "data-testid": "flowbite-avatar-initials-placeholder",
                        children: (0, $ge3KO.jsx)("span", {
                            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.initials.text),
                            "data-testid": "flowbite-avatar-initials-placeholder-text",
                            children: placeholderInitials
                        })
                    }) : (0, $ge3KO.jsx)("div", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(imgClassName, theme.root.img.off),
                        "data-testid": "flowbite-avatar-img",
                        children: (0, $ge3KO.jsx)("svg", {
                            className: theme.root.img.placeholder,
                            fill: "currentColor",
                            viewBox: "0 0 20 20",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: (0, $ge3KO.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                                clipRule: "evenodd"
                            })
                        })
                    }),
                    status && (0, $ge3KO.jsx)("span", {
                        "data-testid": "flowbite-avatar-status",
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.status.base, theme.root.status[status], theme.root.statusPosition[statusPosition])
                    })
                ]
            }),
            children && (0, $ge3KO.jsx)("div", {
                children: children
            })
        ]
    });
};
$e877b1f1ea469658$var$AvatarComponent.displayName = "Avatar";
const $e877b1f1ea469658$export$e2255cf6045e8d47 = Object.assign($e877b1f1ea469658$var$AvatarComponent, {
    Group: (0, $505444cc28f58c9b$export$5b26ebaf2b105908),
    Counter: (0, $29f5b5ec08ed46a5$export$5105d46845389b5f)
});



var $ge3KO = parcelRequire("ge3KO");



const $197441659db424a5$export$37acb3580601e69a = ({ children: children, color: color = "info", href: href, icon: Icon, size: size = "xs", className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.badge, customTheme);
    const Content = ()=>(0, $ge3KO.jsxs)("span", {
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.color[color], theme.icon[Icon ? "on" : "off"], theme.root.size[size], className),
            "data-testid": "flowbite-badge",
            ...props,
            children: [
                Icon && (0, $ge3KO.jsx)(Icon, {
                    "aria-hidden": true,
                    className: theme.icon.size[size],
                    "data-testid": "flowbite-badge-icon"
                }),
                children && (0, $ge3KO.jsx)("span", {
                    children: children
                })
            ]
        });
    return href ? (0, $ge3KO.jsx)("a", {
        className: theme.root.href,
        href: href,
        children: (0, $ge3KO.jsx)(Content, {})
    }) : (0, $ge3KO.jsx)(Content, {});
};
$197441659db424a5$export$37acb3580601e69a.displayName = "Badge";





var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




const $33187ef2c149fdd3$export$c13f210c706eb549 = (0, $f2Y41.forwardRef)(({ children: children, className: className, href: href, icon: Icon, theme: customTheme = {}, ...props }, ref)=>{
    const isLink = typeof href !== "undefined";
    const Component = isLink ? "a" : "span";
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.breadcrumb.item, customTheme);
    return (0, $ge3KO.jsxs)("li", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$32bd0c97674edac4), {
                "aria-hidden": true,
                className: theme.chevron,
                "data-testid": "flowbite-breadcrumb-separator"
            }),
            (0, $ge3KO.jsxs)(Component, {
                ref: ref,
                className: theme.href[isLink ? "on" : "off"],
                "data-testid": "flowbite-breadcrumb-item",
                href: href,
                children: [
                    Icon && (0, $ge3KO.jsx)(Icon, {
                        "aria-hidden": true,
                        className: theme.icon
                    }),
                    children
                ]
            })
        ]
    });
});
$33187ef2c149fdd3$export$c13f210c706eb549.displayName = "Breadcrumb.Item";


const $5b4cfec3dd23697f$var$BreadcrumbComponent = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.breadcrumb.root, customTheme);
    return (0, $ge3KO.jsx)("nav", {
        "aria-label": "Breadcrumb",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: (0, $ge3KO.jsx)("ol", {
            className: theme.list,
            children: children
        })
    });
};
$5b4cfec3dd23697f$var$BreadcrumbComponent.displayName = "Breadcrumb";
const $5b4cfec3dd23697f$export$dabcc1ec9dd9d1cc = Object.assign($5b4cfec3dd23697f$var$BreadcrumbComponent, {
    Item: (0, $33187ef2c149fdd3$export$c13f210c706eb549)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




var $f2Y41 = parcelRequire("f2Y41");
const $4a372b92c86fbb77$export$b0bb876e969289cd = (0, $f2Y41.forwardRef)(({ children: children, as: Component = "button", href: href, ...props }, ref)=>{
    const BaseComponent = href ? "a" : Component ?? "button";
    const type = Component === "button" ? "button" : undefined;
    return (0, $f2Y41.createElement)(BaseComponent, {
        ref: ref,
        href: href,
        type: type,
        ...props
    }, children);
});
$4a372b92c86fbb77$export$b0bb876e969289cd.displayName = "Button";



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $097ae9b94a420c86$var$ButtonGroup = ({ children: children, className: className, outline: outline, pill: pill, theme: customTheme = {}, ...props })=>{
    const items = (0, $f2Y41.useMemo)(()=>(0, $f2Y41.Children).map(children, (child, index)=>(0, $f2Y41.cloneElement)(child, {
                outline: outline,
                pill: pill,
                positionInGroup: index === 0 ? "start" : index === children.length - 1 ? "end" : "middle"
            })), [
        children,
        outline,
        pill
    ]);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.buttonGroup, customTheme);
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        role: "group",
        ...props,
        children: items
    });
};
$097ae9b94a420c86$var$ButtonGroup.displayName = "Button.Group";
var $097ae9b94a420c86$export$2e2bcd8739ae039 = $097ae9b94a420c86$var$ButtonGroup;


const $0cf428739f88aba9$var$ButtonComponent = (0, $f2Y41.forwardRef)(({ children: children, className: className, color: color = "info", disabled: disabled = false, fullSized: fullSized, isProcessing: isProcessing = false, processingLabel: processingLabel = "Loading...", processingSpinner: processingSpinner, gradientDuoTone: gradientDuoTone, gradientMonochrome: gradientMonochrome, label: label, outline: outline = false, pill: pill = false, positionInGroup: positionInGroup = "none", size: size = "md", theme: customTheme = {}, ...props }, ref)=>{
    const { buttonGroup: groupTheme, button: buttonTheme } = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme;
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)(buttonTheme, customTheme);
    const theirProps = props;
    return (0, $ge3KO.jsx)((0, $4a372b92c86fbb77$export$b0bb876e969289cd), {
        disabled: disabled,
        ref: ref,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, disabled && theme.disabled, !gradientDuoTone && !gradientMonochrome && theme.color[color], gradientDuoTone && !gradientMonochrome && theme.gradientDuoTone[gradientDuoTone], !gradientDuoTone && gradientMonochrome && theme.gradient[gradientMonochrome], outline && (theme.outline.color[color] ?? theme.outline.color.default), theme.pill[pill ? "on" : "off"], fullSized && theme.fullSized, groupTheme.position[positionInGroup], className),
        ...theirProps,
        children: (0, $ge3KO.jsx)("span", {
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.inner.base, theme.outline[outline ? "on" : "off"], theme.outline.pill[outline && pill ? "on" : "off"], theme.size[size], outline && !theme.outline.color[color] && theme.inner.outline, isProcessing && theme.isProcessing, isProcessing && theme.inner.isProcessingPadding[size], theme.inner.position[positionInGroup]),
            children: (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                children: [
                    isProcessing && (0, $ge3KO.jsx)("span", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.spinnerSlot, theme.spinnerLeftPosition[size]),
                        children: processingSpinner || (0, $ge3KO.jsx)((0, $57cd14b1871feb0c$export$7f7cbe89f1eacd2), {
                            size: size
                        })
                    }),
                    typeof children !== "undefined" ? children : (0, $ge3KO.jsx)("span", {
                        "data-testid": "flowbite-button-label",
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.label),
                        children: isProcessing ? processingLabel : label
                    })
                ]
            })
        })
    });
});
$0cf428739f88aba9$var$ButtonComponent.displayName = "ButtonComponent";
const $0cf428739f88aba9$export$353f5b6fc5456de1 = Object.assign($0cf428739f88aba9$var$ButtonComponent, {
    Group: (0, $097ae9b94a420c86$export$2e2bcd8739ae039)
});





var $ge3KO = parcelRequire("ge3KO");



const $67837a25474984cb$export$30a06c8d3562193f = (keys)=>(obj)=>{
        const result = {};
        Object.keys(obj).forEach((key)=>{
            //@ts-expect-error - Somehow TS does not like this.
            if (keys.includes(key)) return;
            //@ts-expect-error - Somehow TS does not like this.
            result[key] = obj[key];
        });
        return result;
    };


const $12bac3892b1cf3f1$export$60332b2344f7fe41 = (props)=>{
    const { children: children, className: className, horizontal: horizontal, href: href, theme: customTheme = {} } = props;
    const Component = typeof href === "undefined" ? "div" : "a";
    const theirProps = $12bac3892b1cf3f1$var$removeCustomProps(props);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.card, customTheme);
    return (0, $ge3KO.jsxs)(Component, {
        "data-testid": "flowbite-card",
        href: href,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.horizontal[horizontal ? "on" : "off"], href && theme.root.href, className),
        ...theirProps,
        children: [
            (0, $ge3KO.jsx)($12bac3892b1cf3f1$var$Image, {
                ...props
            }),
            (0, $ge3KO.jsx)("div", {
                className: theme.root.children,
                children: children
            })
        ]
    });
};
const $12bac3892b1cf3f1$var$Image = ({ theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.card, customTheme);
    if (props.renderImage) return props.renderImage(theme, props.horizontal ?? false);
    if (props.imgSrc) return (0, $ge3KO.jsx)("img", {
        "data-testid": "flowbite-card-image",
        alt: props.imgAlt ?? "",
        src: props.imgSrc,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.img.base, theme.img.horizontal[props.horizontal ? "on" : "off"])
    });
    return null;
};
const $12bac3892b1cf3f1$var$removeCustomProps = (0, $67837a25474984cb$export$30a06c8d3562193f)([
    "renderImage",
    "imgSrc",
    "imgAlt",
    "children",
    "className",
    "horizontal",
    "href",
    "theme"
]);





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


var $f2Y41 = parcelRequire("f2Y41");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $c438064faab0862e$var$n = function(t, e) {
    return ($c438064faab0862e$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    })(t, e);
};
var $c438064faab0862e$var$o, $c438064faab0862e$var$r, $c438064faab0862e$var$i = (function(t) {
    /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
        var e = {}.hasOwnProperty;
        function n() {
            for(var t = [], o = 0; o < arguments.length; o++){
                var r = arguments[o];
                if (r) {
                    var i = typeof r;
                    if ("string" === i || "number" === i) t.push(r);
                    else if (Array.isArray(r) && r.length) {
                        var s = n.apply(null, r);
                        s && t.push(s);
                    } else if ("object" === i) for(var l in r)e.call(r, l) && r[l] && t.push(l);
                }
            }
            return t.join(" ");
        }
        t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    }();
}($c438064faab0862e$var$r = {
    path: $c438064faab0862e$var$o,
    exports: {},
    require: function(t, e) {
        return function() {
            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == e && $c438064faab0862e$var$r.path);
    }
}, $c438064faab0862e$var$r.exports), $c438064faab0862e$var$r.exports);
function $c438064faab0862e$var$s(t, e, n) {
    var o, r, i, s, l;
    function a() {
        var c = Date.now() - s;
        c < e && c >= 0 ? o = setTimeout(a, e - c) : (o = null, n || (l = t.apply(i, r), i = r = null));
    }
    null == e && (e = 100);
    var c = function() {
        i = this, r = arguments, s = Date.now();
        var c = n && !o;
        return o || (o = setTimeout(a, e)), c && (l = t.apply(i, r), i = r = null), l;
    };
    return c.clear = function() {
        o && (clearTimeout(o), o = null);
    }, c.flush = function() {
        o && (l = t.apply(i, r), i = r = null, clearTimeout(o), o = null);
    }, c;
}
$c438064faab0862e$var$s.debounce = $c438064faab0862e$var$s;
var $c438064faab0862e$var$l = $c438064faab0862e$var$s;
!function(t, e) {
    void 0 === e && (e = {});
    var n = e.insertAt;
    if (t && "undefined" != typeof document) {
        var o = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
        r.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
}(".indiana-scroll-container {\n  overflow: auto; }\n  .indiana-scroll-container--dragging {\n    scroll-behavior: auto !important; }\n    .indiana-scroll-container--dragging > * {\n      pointer-events: none;\n      cursor: -webkit-grab;\n      cursor: grab; }\n  .indiana-scroll-container--hide-scrollbars {\n    overflow: hidden;\n    overflow: -moz-scrollbars-none;\n    -ms-overflow-style: none;\n    scrollbar-width: none; }\n    .indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n      display: none !important;\n      height: 0 !important;\n      width: 0 !important;\n      background: transparent !important;\n      -webkit-appearance: none !important; }\n  .indiana-scroll-container--native-scroll {\n    overflow: auto; }\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab; }\n");
var $c438064faab0862e$var$a, $c438064faab0862e$var$c = ($c438064faab0862e$var$a = "indiana-scroll-container", function(t, e) {
    if (!t) return $c438064faab0862e$var$a;
    var n;
    "string" == typeof t ? n = t : e = t;
    var o = $c438064faab0862e$var$a;
    return n && (o += "__" + n), o + (e ? Object.keys(e).reduce(function(t, n) {
        var r = e[n];
        return r && (t += " " + ("boolean" == typeof r ? o + "--" + n : o + "--" + n + "_" + r)), t;
    }, "") : "");
}), $c438064faab0862e$var$p = function(e) {
    function o(n) {
        var o = e.call(this, n) || this;
        return o.onEndScroll = function() {
            o.scrolling = !1, !o.pressed && o.started && o.processEnd();
        }, o.onScroll = function(t) {
            var e = o.container.current;
            e.scrollLeft === o.scrollLeft && e.scrollTop === o.scrollTop || (o.scrolling = !0, o.processScroll(t), o.onEndScroll());
        }, o.onTouchStart = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.isDraggable(t.target)) {
                if (o.internal = !0, e && o.scrolling) o.pressed = !0;
                else {
                    var n = t.touches[0];
                    o.processClick(t, n.clientX, n.clientY), !e && o.props.stopPropagation && t.stopPropagation();
                }
            }
        }, o.onTouchEnd = function(t) {
            var e = o.props.nativeMobileScroll;
            o.pressed && (!o.started || o.scrolling && e ? o.pressed = !1 : o.processEnd(), o.forceUpdate());
        }, o.onTouchMove = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.pressed && (!e || !o.isMobile)) {
                var n = t.touches[0];
                n && o.processMove(t, n.clientX, n.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation();
            }
        }, o.onMouseDown = function(t) {
            o.isDraggable(t.target) && o.isScrollable() && (o.internal = !0, -1 !== o.props.buttons.indexOf(t.button) && (o.processClick(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation()));
        }, o.onMouseMove = function(t) {
            o.pressed && (o.processMove(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.onMouseUp = function(t) {
            o.pressed && (o.started ? o.processEnd() : (o.internal = !1, o.pressed = !1, o.forceUpdate(), o.props.onClick && o.props.onClick(t)), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.container = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createRef(), o.onEndScroll = $c438064faab0862e$var$l(o.onEndScroll, 300), o.scrolling = !1, o.started = !1, o.pressed = !1, o.internal = !1, o.getRef = o.getRef.bind(o), o;
    }
    return function(t, e) {
        function o() {
            this.constructor = t;
        }
        $c438064faab0862e$var$n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o);
    }(o, e), o.prototype.componentDidMount = function() {
        var t = this.props.nativeMobileScroll, e = this.container.current;
        window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), window.addEventListener("touchend", this.onTouchEnd), e.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), e.addEventListener("mousedown", this.onMouseDown, {
            passive: !1
        }), t && (this.isMobile = this.isMobileDevice(), this.isMobile && this.forceUpdate());
    }, o.prototype.componentWillUnmount = function() {
        window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
    }, o.prototype.getElement = function() {
        return this.container.current;
    }, o.prototype.isMobileDevice = function() {
        return void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile");
    }, o.prototype.isDraggable = function(t) {
        var e = this.props.ignoreElements;
        if (e) {
            var n = t.closest(e);
            return null === n || n.contains(this.getElement());
        }
        return !0;
    }, o.prototype.isScrollable = function() {
        var t = this.container.current;
        return t && (t.scrollWidth > t.clientWidth || t.scrollHeight > t.clientHeight);
    }, o.prototype.processClick = function(t, e, n) {
        var o = this.container.current;
        this.scrollLeft = o.scrollLeft, this.scrollTop = o.scrollTop, this.clientX = e, this.clientY = n, this.pressed = !0;
    }, o.prototype.processStart = function(t) {
        void 0 === t && (t = !0);
        var e = this.props.onStartScroll;
        this.started = !0, t && document.body.classList.add("indiana-dragging"), e && e({
            external: !this.internal
        }), this.forceUpdate();
    }, o.prototype.processScroll = function(t) {
        if (this.started) {
            var e = this.props.onScroll;
            e && e({
                external: !this.internal
            });
        } else this.processStart(!1);
    }, o.prototype.processMove = function(t, e, n) {
        var o = this.props, r = o.horizontal, i = o.vertical, s = o.activationDistance, l = o.onScroll, a = this.container.current;
        this.started ? (r && (a.scrollLeft -= e - this.clientX), i && (a.scrollTop -= n - this.clientY), l && l({
            external: !this.internal
        }), this.clientX = e, this.clientY = n, this.scrollLeft = a.scrollLeft, this.scrollTop = a.scrollTop) : (r && Math.abs(e - this.clientX) > s || i && Math.abs(n - this.clientY) > s) && (this.clientX = e, this.clientY = n, this.processStart());
    }, o.prototype.processEnd = function() {
        var t = this.props.onEndScroll;
        this.container.current && t && t({
            external: !this.internal
        }), this.pressed = !1, this.started = !1, this.scrolling = !1, this.internal = !1, document.body.classList.remove("indiana-dragging"), this.forceUpdate();
    }, o.prototype.getRef = function(t) {
        [
            this.container,
            this.props.innerRef
        ].forEach(function(e) {
            e && ("function" == typeof e ? e(t) : e.current = t);
        });
    }, o.prototype.render = function() {
        var e = this.props, n = e.children, o = e.draggingClassName, r = e.className, s = e.style, l = e.hideScrollbars, a = e.component;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(a, {
            className: $c438064faab0862e$var$i(r, this.pressed && o, $c438064faab0862e$var$c({
                dragging: this.pressed,
                "hide-scrollbars": l,
                "native-scroll": this.isMobile
            })),
            style: s,
            ref: this.getRef,
            onScroll: this.onScroll
        }, n);
    }, o.defaultProps = {
        nativeMobileScroll: !0,
        hideScrollbars: !0,
        activationDistance: 10,
        vertical: !0,
        horizontal: !0,
        stopPropagation: !1,
        style: {},
        component: "div",
        buttons: [
            0
        ]
    }, o;
}((0, $f2Y41.PureComponent));
var $c438064faab0862e$export$2e2bcd8739ae039 = $c438064faab0862e$var$p;




const $6b69c1c5f02d726c$export$7383f122bf48ec30 = ()=>{
    return typeof window !== "undefined";
};



const $822a747c12ccf60d$export$144901db2ea8e967 = ({ children: children, indicators: indicators = true, leftControl: leftControl, rightControl: rightControl, slide: slide = true, slideInterval: slideInterval, className: className, theme: customTheme = {}, onSlideChange: onSlideChange = null, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.carousel, customTheme);
    const isDeviceMobile = (0, $6b69c1c5f02d726c$export$7383f122bf48ec30)() && navigator.userAgent.indexOf("IEMobile") !== -1;
    const carouselContainer = (0, $f2Y41.useRef)(null);
    const [activeItem, setActiveItem] = (0, $f2Y41.useState)(0);
    const [isDragging, setIsDragging] = (0, $f2Y41.useState)(false);
    const didMountRef = (0, $f2Y41.useRef)(false);
    const items = (0, $f2Y41.useMemo)(()=>(0, $f2Y41.Children).map(children, (child)=>(0, $f2Y41.cloneElement)(child, {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.item.base, child.props.className)
            })), [
        children,
        theme.item.base
    ]);
    const navigateTo = (0, $f2Y41.useCallback)((item)=>()=>{
            if (!items) return;
            item = (item + items.length) % items.length;
            if (carouselContainer.current) carouselContainer.current.scrollLeft = carouselContainer.current.clientWidth * item;
            setActiveItem(item);
        }, [
        items
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (carouselContainer.current && !isDragging && carouselContainer.current.scrollLeft !== 0) setActiveItem(Math.round(carouselContainer.current.scrollLeft / carouselContainer.current.clientWidth));
    }, [
        isDragging
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (slide) {
            const intervalId = setInterval(()=>!isDragging && navigateTo(activeItem + 1)(), slideInterval ?? 3000);
            return ()=>clearInterval(intervalId);
        }
    }, [
        activeItem,
        isDragging,
        navigateTo,
        slide,
        slideInterval
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (didMountRef.current) onSlideChange && onSlideChange(activeItem);
        else didMountRef.current = true;
    }, [
        onSlideChange,
        activeItem
    ]);
    const handleDragging = (dragging)=>()=>setIsDragging(dragging);
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
        "data-testid": "carousel",
        ...props,
        children: [
            (0, $ge3KO.jsx)((0, $c438064faab0862e$export$2e2bcd8739ae039), {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.scrollContainer.base, (isDeviceMobile || !isDragging) && theme.scrollContainer.snap),
                draggingClassName: "cursor-grab",
                innerRef: carouselContainer,
                onEndScroll: handleDragging(false),
                onStartScroll: handleDragging(true),
                vertical: false,
                children: items?.map((item, index)=>(0, $ge3KO.jsx)("div", {
                        className: theme.item.wrapper,
                        "data-active": activeItem === index,
                        "data-testid": "carousel-item",
                        children: item
                    }, index))
            }),
            indicators && (0, $ge3KO.jsx)("div", {
                className: theme.indicators.wrapper,
                children: items?.map((_, index)=>(0, $ge3KO.jsx)("button", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.indicators.base, theme.indicators.active[index === activeItem ? "on" : "off"]),
                        onClick: navigateTo(index),
                        "data-testid": "carousel-indicator",
                        "aria-label": `Slide ${index + 1}`
                    }, index))
            }),
            items && (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                children: [
                    (0, $ge3KO.jsx)("div", {
                        className: theme.root.leftControl,
                        children: (0, $ge3KO.jsx)("button", {
                            className: "group",
                            "data-testid": "carousel-left-control",
                            onClick: navigateTo(activeItem - 1),
                            type: "button",
                            "aria-label": "Previous slide",
                            children: leftControl ? leftControl : (0, $ge3KO.jsx)($822a747c12ccf60d$var$DefaultLeftControl, {})
                        })
                    }),
                    (0, $ge3KO.jsx)("div", {
                        className: theme.root.rightControl,
                        children: (0, $ge3KO.jsx)("button", {
                            className: "group",
                            "data-testid": "carousel-right-control",
                            onClick: navigateTo(activeItem + 1),
                            type: "button",
                            "aria-label": "Next slide",
                            children: rightControl ? rightControl : (0, $ge3KO.jsx)($822a747c12ccf60d$var$DefaultRightControl, {})
                        })
                    })
                ]
            })
        ]
    });
};
const $822a747c12ccf60d$var$DefaultLeftControl = ()=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.carousel;
    return (0, $ge3KO.jsx)("span", {
        className: theme.control.base,
        children: (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$225198a30aa903b0), {
            className: theme.control.icon
        })
    });
};
const $822a747c12ccf60d$var$DefaultRightControl = ()=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.carousel;
    return (0, $ge3KO.jsx)("span", {
        className: theme.control.base,
        children: (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$32bd0c97674edac4), {
            className: theme.control.icon
        })
    });
};
$822a747c12ccf60d$export$144901db2ea8e967.displayName = "Carousel";





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $8afa75565a685682$export$48513f6b9f8ce62d = (0, $f2Y41.forwardRef)(({ className: className, theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.checkbox, customTheme);
    return (0, $ge3KO.jsx)("input", {
        ref: ref,
        type: "checkbox",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
        ...props
    });
});
$8afa75565a685682$export$48513f6b9f8ce62d.displayName = "Checkbox";





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

const $3356a69a96939017$export$20ec2254f76fa604 = {
    root: {
        base: "divide-y divide-gray-200 border-gray-200 dark:divide-gray-700 dark:border-gray-700",
        flush: {
            off: "rounded-lg border",
            on: "border-b"
        }
    },
    content: {
        base: "py-5 px-5 last:rounded-b-lg dark:bg-gray-900 first:rounded-t-lg"
    },
    title: {
        arrow: {
            base: "h-6 w-6 shrink-0",
            open: {
                off: "",
                on: "rotate-180"
            }
        },
        base: "flex w-full items-center justify-between first:rounded-t-lg last:rounded-b-lg py-5 px-5 text-left font-medium text-gray-500 dark:text-gray-400",
        flush: {
            off: "hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:hover:bg-gray-800 dark:focus:ring-gray-800",
            on: "bg-transparent dark:bg-transparent"
        },
        heading: "",
        open: {
            off: "",
            on: "text-gray-900 bg-gray-100 dark:bg-gray-800 dark:text-white"
        }
    }
};


const $792a23f43bf25624$export$9d77d9665d829e89 = {
    base: "flex flex-col gap-2 p-4 text-sm",
    borderAccent: "border-t-4",
    closeButton: {
        base: "-mx-1.5 -my-1.5 ml-auto inline-flex h-8 w-8 rounded-lg p-1.5 focus:ring-2",
        icon: "w-5 h-5",
        color: {
            info: "bg-cyan-100 text-cyan-500 hover:bg-cyan-200 focus:ring-cyan-400 dark:bg-cyan-200 dark:text-cyan-600 dark:hover:bg-cyan-300",
            gray: "bg-gray-100 text-gray-500 hover:bg-gray-200 focus:ring-gray-400 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white",
            failure: "bg-red-100 text-red-500 hover:bg-red-200 focus:ring-red-400 dark:bg-red-200 dark:text-red-600 dark:hover:bg-red-300",
            success: "bg-green-100 text-green-500 hover:bg-green-200 focus:ring-green-400 dark:bg-green-200 dark:text-green-600 dark:hover:bg-green-300",
            warning: "bg-yellow-100 text-yellow-500 hover:bg-yellow-200 focus:ring-yellow-400 dark:bg-yellow-200 dark:text-yellow-600 dark:hover:bg-yellow-300",
            red: "bg-red-100 text-red-500 hover:bg-red-200 focus:ring-red-400 dark:bg-red-200 dark:text-red-600 dark:hover:bg-red-300",
            green: "bg-green-100 text-green-500 hover:bg-green-200 focus:ring-green-400 dark:bg-green-200 dark:text-green-600 dark:hover:bg-green-300",
            yellow: "bg-yellow-100 text-yellow-500 hover:bg-yellow-200 focus:ring-yellow-400 dark:bg-yellow-200 dark:text-yellow-600 dark:hover:bg-yellow-300",
            blue: "bg-cyan-100 text-cyan-500 hover:bg-cyan-200 focus:ring-cyan-400 dark:bg-cyan-200 dark:text-cyan-600 dark:hover:bg-cyan-300",
            cyan: "bg-cyan-100 text-cyan-500 hover:bg-cyan-200 focus:ring-cyan-400 dark:bg-cyan-200 dark:text-cyan-600 dark:hover:bg-cyan-300",
            pink: "bg-pink-100 text-pink-500 hover:bg-pink-200 focus:ring-pink-400 dark:bg-pink-200 dark:text-pink-600 dark:hover:bg-pink-300",
            lime: "bg-lime-100 text-lime-500 hover:bg-lime-200 focus:ring-lime-400 dark:bg-lime-200 dark:text-lime-600 dark:hover:bg-lime-300",
            dark: "bg-gray-100 text-gray-500 hover:bg-gray-200 focus:ring-gray-400 dark:bg-gray-200 dark:text-gray-600 dark:hover:bg-gray-300",
            indigo: "bg-indigo-100 text-indigo-500 hover:bg-indigo-200 focus:ring-indigo-400 dark:bg-indigo-200 dark:text-indigo-600 dark:hover:bg-indigo-300",
            purple: "bg-purple-100 text-purple-500 hover:bg-purple-200 focus:ring-purple-400 dark:bg-purple-200 dark:text-purple-600 dark:hover:bg-purple-300",
            teal: "bg-teal-100 text-teal-500 hover:bg-teal-200 focus:ring-teal-400 dark:bg-teal-200 dark:text-teal-600 dark:hover:bg-teal-300",
            light: "bg-gray-50 text-gray-500 hover:bg-gray-100 focus:ring-gray-200 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-700 dark:hover:text-white"
        }
    },
    color: {
        info: "text-cyan-700 bg-cyan-100 border-cyan-500 dark:bg-cyan-200 dark:text-cyan-800",
        gray: "text-gray-700 bg-gray-100 border-gray-500 dark:bg-gray-700 dark:text-gray-300",
        failure: "text-red-700 bg-red-100 border-red-500 dark:bg-red-200 dark:text-red-800",
        success: "text-green-700 bg-green-100 border-green-500 dark:bg-green-200 dark:text-green-800",
        warning: "text-yellow-700 bg-yellow-100 border-yellow-500 dark:bg-yellow-200 dark:text-yellow-800",
        red: "text-red-700 bg-red-100 border-red-500 dark:bg-red-200 dark:text-red-800",
        green: "text-green-700 bg-green-100 border-green-500 dark:bg-green-200 dark:text-green-800",
        yellow: "text-yellow-700 bg-yellow-100 border-yellow-500 dark:bg-yellow-200 dark:text-yellow-800",
        blue: "text-cyan-700 bg-cyan-100 border-cyan-500 dark:bg-cyan-200 dark:text-cyan-800",
        cyan: "text-cyan-700 bg-cyan-100 border-cyan-500 dark:bg-cyan-200 dark:text-cyan-800",
        pink: "text-pink-700 bg-pink-100 border-pink-500 dark:bg-pink-200 dark:text-pink-800",
        lime: "text-lime-700 bg-lime-100 border-lime-500 dark:bg-lime-200 dark:text-lime-800",
        dark: "text-gray-200 bg-gray-800 border-gray-600 dark:bg-gray-900 dark:text-gray-300",
        indigo: "text-indigo-700 bg-indigo-100 border-indigo-500 dark:bg-indigo-200 dark:text-indigo-800",
        purple: "text-purple-700 bg-purple-100 border-purple-500 dark:bg-purple-200 dark:text-purple-800",
        teal: "text-teal-700 bg-teal-100 border-teal-500 dark:bg-teal-200 dark:text-teal-800",
        light: "text-gray-600 bg-gray-50 border-gray-400 dark:bg-gray-500 dark:text-gray-200"
    },
    icon: "mr-3 inline h-5 w-5 flex-shrink-0",
    rounded: "rounded-lg",
    wrapper: "flex items-center"
};


const $8e3f380ba545f3d4$export$9975d21893c10e66 = {
    root: {
        base: "flex justify-center items-center space-x-4 rounded",
        bordered: "p-1 ring-2",
        rounded: "rounded-full",
        color: {
            dark: "ring-gray-800 dark:ring-gray-800",
            failure: "ring-red-500 dark:ring-red-700",
            gray: "ring-gray-500 dark:ring-gray-400",
            info: "ring-cyan-400 dark:ring-cyan-800",
            light: "ring-gray-300 dark:ring-gray-500",
            purple: "ring-purple-500 dark:ring-purple-600",
            success: "ring-green-500 dark:ring-green-500",
            warning: "ring-yellow-300 dark:ring-yellow-500",
            pink: "ring-pink-500 dark:ring-pink-500"
        },
        img: {
            base: "rounded",
            off: "relative overflow-hidden bg-gray-100 dark:bg-gray-600",
            on: "",
            placeholder: "absolute w-auto h-auto text-gray-400 -bottom-1"
        },
        size: {
            xs: "w-6 h-6",
            sm: "w-8 h-8",
            md: "w-10 h-10",
            lg: "w-20 h-20",
            xl: "w-36 h-36"
        },
        stacked: "ring-2 ring-gray-300 dark:ring-gray-500",
        statusPosition: {
            "bottom-left": "-bottom-1 -left-1",
            "bottom-center": "-bottom-1 center",
            "bottom-right": "-bottom-1 -right-1",
            "top-left": "-top-1 -left-1",
            "top-center": "-top-1 center",
            "top-right": "-top-1 -right-1",
            "center-right": "center -right-1",
            center: "center center",
            "center-left": "center -left-1"
        },
        status: {
            away: "bg-yellow-400",
            base: "absolute h-3.5 w-3.5 rounded-full border-2 border-white dark:border-gray-800",
            busy: "bg-red-400",
            offline: "bg-gray-400",
            online: "bg-green-400"
        },
        initials: {
            text: "font-medium text-gray-600 dark:text-gray-300",
            base: "inline-flex overflow-hidden relative justify-center items-center bg-gray-100 dark:bg-gray-600"
        }
    },
    group: {
        base: "flex -space-x-4"
    },
    groupCounter: {
        base: "relative flex items-center justify-center w-10 h-10 text-xs font-medium text-white bg-gray-700 rounded-full ring-2 ring-gray-300 hover:bg-gray-600 dark:ring-gray-500"
    }
};


const $7ee601a1d8112e79$export$eb6e7cbc82d0f88b = {
    root: {
        base: "flex h-fit items-center gap-1 font-semibold",
        color: {
            info: "bg-cyan-100 text-cyan-800 dark:bg-cyan-200 dark:text-cyan-800 group-hover:bg-cyan-200 dark:group-hover:bg-cyan-300",
            gray: "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300 group-hover:bg-gray-200 dark:group-hover:bg-gray-600",
            failure: "bg-red-100 text-red-800 dark:bg-red-200 dark:text-red-900 group-hover:bg-red-200 dark:group-hover:bg-red-300",
            success: "bg-green-100 text-green-800 dark:bg-green-200 dark:text-green-900 group-hover:bg-green-200 dark:group-hover:bg-green-300",
            warning: "bg-yellow-100 text-yellow-800 dark:bg-yellow-200 dark:text-yellow-900 group-hover:bg-yellow-200 dark:group-hover:bg-yellow-300",
            indigo: "bg-indigo-100 text-indigo-800 dark:bg-indigo-200 dark:text-indigo-900 group-hover:bg-indigo-200 dark:group-hover:bg-indigo-300",
            purple: "bg-purple-100 text-purple-800 dark:bg-purple-200 dark:text-purple-900 group-hover:bg-purple-200 dark:group-hover:bg-purple-300",
            pink: "bg-pink-100 text-pink-800 dark:bg-pink-200 dark:text-pink-900 group-hover:bg-pink-200 dark:group-hover:bg-pink-300",
            blue: "bg-cyan-100 text-cyan-800 dark:bg-cyan-200 dark:text-cyan-900 group-hover:bg-cyan-200 dark:group-hover:bg-cyan-300",
            cyan: "bg-cyan-100 text-cyan-800 dark:bg-cyan-200 dark:text-cyan-900 group-hover:bg-cyan-200 dark:group-hover:bg-cyan-300",
            dark: "bg-gray-600 text-gray-100 dark:bg-gray-900 dark:text-gray-200 group-hover:bg-gray-500 dark:group-hover:bg-gray-700",
            light: "bg-gray-200 text-gray-800 dark:bg-gray-400 dark:text-gray-900 group-hover:bg-gray-300 dark:group-hover:bg-gray-500",
            green: "bg-green-100 text-green-800 dark:bg-green-200 dark:text-green-900 group-hover:bg-green-200 dark:group-hover:bg-green-300",
            lime: "bg-lime-100 text-lime-800 dark:bg-lime-200 dark:text-lime-900 group-hover:bg-lime-200 dark:group-hover:bg-lime-300",
            red: "bg-red-100 text-red-800 dark:bg-red-200 dark:text-red-900 group-hover:bg-red-200 dark:group-hover:bg-red-300",
            teal: "bg-teal-100 text-teal-800 dark:bg-teal-200 dark:text-teal-900 group-hover:bg-teal-200 dark:group-hover:bg-teal-300",
            yellow: "bg-yellow-100 text-yellow-800 dark:bg-yellow-200 dark:text-yellow-900 group-hover:bg-yellow-200 dark:group-hover:bg-yellow-300"
        },
        href: "group",
        size: {
            xs: "p-1 text-xs",
            sm: "p-1.5 text-sm"
        }
    },
    icon: {
        off: "rounded px-2 py-0.5",
        on: "rounded-full p-1.5",
        size: {
            xs: "w-3 h-3",
            sm: "w-3.5 h-3.5"
        }
    }
};


const $aea18d3a3e5e307b$export$e2d8c6f6af55009 = {
    root: {
        base: "",
        list: "flex items-center"
    },
    item: {
        base: "group flex items-center",
        chevron: "mx-1 h-6 w-6 text-gray-400 group-first:hidden md:mx-2",
        href: {
            off: "flex items-center text-sm font-medium text-gray-500 dark:text-gray-400",
            on: "flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
        },
        icon: "mr-2 h-4 w-4"
    }
};


const $afcde2d5db636df7$export$577deec5d331f6be = {
    base: "group flex h-min items-center justify-center p-0.5 text-center font-medium relative focus:z-10 focus:outline-none",
    fullSized: "w-full",
    color: {
        dark: "text-white bg-gray-800 border border-transparent enabled:hover:bg-gray-900 focus:ring-4 focus:ring-gray-300 dark:bg-gray-800 dark:enabled:hover:bg-gray-700 dark:focus:ring-gray-800 dark:border-gray-700",
        failure: "text-white bg-red-700 border border-transparent enabled:hover:bg-red-800 focus:ring-4 focus:ring-red-300 dark:bg-red-600 dark:enabled:hover:bg-red-700 dark:focus:ring-red-900",
        gray: "text-gray-900 bg-white border border-gray-200 enabled:hover:bg-gray-100 enabled:hover:text-cyan-700 :ring-cyan-700 focus:text-cyan-700 dark:bg-transparent dark:text-gray-400 dark:border-gray-600 dark:enabled:hover:text-white dark:enabled:hover:bg-gray-700 focus:ring-2",
        info: "text-white bg-cyan-700 border border-transparent enabled:hover:bg-cyan-800 focus:ring-4 focus:ring-cyan-300 dark:bg-cyan-600 dark:enabled:hover:bg-cyan-700 dark:focus:ring-cyan-800",
        light: "text-gray-900 bg-white border border-gray-300 enabled:hover:bg-gray-100 focus:ring-4 focus:ring-cyan-300 :bg-gray-600 dark:text-white dark:border-gray-600 dark:enabled:hover:bg-gray-700 dark:enabled:hover:border-gray-700 dark:focus:ring-gray-700",
        purple: "text-white bg-purple-700 border border-transparent enabled:hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:enabled:hover:bg-purple-700 dark:focus:ring-purple-900",
        success: "text-white bg-green-700 border border-transparent enabled:hover:bg-green-800 focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:enabled:hover:bg-green-700 dark:focus:ring-green-800",
        warning: "text-white bg-yellow-400 border border-transparent enabled:hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 dark:focus:ring-yellow-900",
        blue: "text-cyan-900 bg-white border border-cyan-300 enabled:hover:bg-cyan-100 focus:ring-4 focus:ring-cyan-300 :bg-cyan-600 dark:text-white dark:border-cyan-600 dark:enabled:hover:bg-cyan-700 dark:enabled:hover:border-cyan-700 dark:focus:ring-cyan-700",
        cyan: "text-cyan-900 bg-white border border-cyan-300 enabled:hover:bg-cyan-100 focus:ring-4 focus:ring-cyan-300 :bg-cyan-600 dark:text-white dark:border-cyan-600 dark:enabled:hover:bg-cyan-700 dark:enabled:hover:border-cyan-700 dark:focus:ring-cyan-700",
        green: "text-green-900 bg-white border border-green-300 enabled:hover:bg-green-100 focus:ring-4 focus:ring-green-300 :bg-green-600 dark:text-white dark:border-green-600 dark:enabled:hover:bg-green-700 dark:enabled:hover:border-green-700 dark:focus:ring-green-700",
        indigo: "text-indigo-900 bg-white border border-indigo-300 enabled:hover:bg-indigo-100 focus:ring-4 focus:ring-indigo-300 :bg-indigo-600 dark:text-white dark:border-indigo-600 dark:enabled:hover:bg-indigo-700 dark:enabled:hover:border-indigo-700 dark:focus:ring-indigo-700",
        lime: "text-lime-900 bg-white border border-lime-300 enabled:hover:bg-lime-100 focus:ring-4 focus:ring-lime-300 :bg-lime-600 dark:text-white dark:border-lime-600 dark:enabled:hover:bg-lime-700 dark:enabled:hover:border-lime-700 dark:focus:ring-lime-700",
        pink: "text-pink-900 bg-white border border-pink-300 enabled:hover:bg-pink-100 focus:ring-4 focus:ring-pink-300 :bg-pink-600 dark:text-white dark:border-pink-600 dark:enabled:hover:bg-pink-700 dark:enabled:hover:border-pink-700 dark:focus:ring-pink-700",
        red: "text-red-900 bg-white border border-red-300 enabled:hover:bg-red-100 focus:ring-4 focus:ring-red-300 :bg-red-600 dark:text-white dark:border-red-600 dark:enabled:hover:bg-red-700 dark:enabled:hover:border-red-700 dark:focus:ring-red-700",
        teal: "text-teal-900 bg-white border border-teal-300 enabled:hover:bg-teal-100 focus:ring-4 focus:ring-teal-300 :bg-teal-600 dark:text-white dark:border-teal-600 dark:enabled:hover:bg-teal-700 dark:enabled:hover:border-teal-700 dark:focus:ring-teal-700",
        yellow: "text-yellow-900 bg-white border border-yellow-300 enabled:hover:bg-yellow-100 focus:ring-4 focus:ring-yellow-300 :bg-yellow-600 dark:text-white dark:border-yellow-600 dark:enabled:hover:bg-yellow-700 dark:enabled:hover:border-yellow-700 dark:focus:ring-yellow-700"
    },
    disabled: "cursor-not-allowed opacity-50",
    isProcessing: "cursor-wait",
    spinnerSlot: "absolute h-full top-0 flex items-center animate-fade-in",
    spinnerLeftPosition: {
        xs: "left-2",
        sm: "left-3",
        md: "left-4",
        lg: "left-5",
        xl: "left-6"
    },
    gradient: {
        cyan: "text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800",
        failure: "text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-red-300 dark:focus:ring-red-800",
        info: "text-white bg-gradient-to-r from-cyan-500 via-cyan-600 to-cyan-700 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800 ",
        lime: "text-gray-900 bg-gradient-to-r from-lime-200 via-lime-400 to-lime-500 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800",
        pink: "text-white bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-pink-300 dark:focus:ring-pink-800",
        purple: "text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-purple-300 dark:focus:ring-purple-800",
        success: "text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-green-300 dark:focus:ring-green-800",
        teal: "text-white bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 enabled:hover:bg-gradient-to-br focus:ring-4 focus:ring-teal-300 dark:focus:ring-teal-800"
    },
    gradientDuoTone: {
        cyanToBlue: "text-white bg-gradient-to-r from-cyan-500 to-cyan-500 enabled:hover:bg-gradient-to-bl focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800",
        greenToBlue: "text-white bg-gradient-to-br from-green-400 to-cyan-600 enabled:hover:bg-gradient-to-bl focus:ring-4 focus:ring-green-200 dark:focus:ring-green-800",
        pinkToOrange: "text-white bg-gradient-to-br from-pink-500 to-orange-400 enabled:hover:bg-gradient-to-bl focus:ring-4 focus:ring-pink-200 dark:focus:ring-pink-800",
        purpleToBlue: "text-white bg-gradient-to-br from-purple-600 to-cyan-500 enabled:hover:bg-gradient-to-bl focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800",
        purpleToPink: "text-white bg-gradient-to-r from-purple-500 to-pink-500 enabled:hover:bg-gradient-to-l focus:ring-4 focus:ring-purple-200 dark:focus:ring-purple-800",
        redToYellow: "text-gray-900 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 enabled:hover:bg-gradient-to-bl focus:ring-4 focus:ring-red-100 dark:focus:ring-red-400",
        tealToLime: "text-gray-900 bg-gradient-to-r from-teal-200 to-lime-200 enabled:hover:bg-gradient-to-l enabled:hover:from-teal-200 enabled:hover:to-lime-200 enabled:hover:text-gray-900 focus:ring-4 focus:ring-lime-200 dark:focus:ring-teal-700"
    },
    inner: {
        base: "flex items-stretch transition-all duration-200",
        position: {
            none: "",
            start: "rounded-r-none",
            middle: "rounded-none",
            end: "rounded-l-none"
        },
        outline: "border border-transparent",
        isProcessingPadding: {
            xs: "pl-8",
            sm: "pl-10",
            md: "pl-12",
            lg: "pl-16",
            xl: "pl-20"
        }
    },
    label: "ml-2 inline-flex h-4 w-4 items-center justify-center rounded-full bg-cyan-200 text-xs font-semibold text-cyan-800",
    outline: {
        color: {
            gray: "border border-gray-900 dark:border-white",
            default: "border-0",
            light: ""
        },
        off: "",
        on: "flex justify-center bg-white text-gray-900 transition-all duration-75 ease-in group-enabled:group-hover:bg-opacity-0 group-enabled:group-hover:text-inherit dark:bg-gray-900 dark:text-white w-full",
        pill: {
            off: "rounded-md",
            on: "rounded-full"
        }
    },
    pill: {
        off: "rounded-lg",
        on: "rounded-full"
    },
    size: {
        xs: "text-xs px-2 py-1",
        sm: "text-sm px-3 py-1.5",
        md: "text-sm px-4 py-2",
        lg: "text-base px-5 py-2.5",
        xl: "text-base px-6 py-3"
    }
};
const $afcde2d5db636df7$export$275abf48d41cf5c3 = {
    base: "inline-flex",
    position: {
        none: "focus:ring-2",
        start: "rounded-r-none",
        middle: "rounded-none border-l-0 pl-0",
        end: "rounded-l-none border-l-0 pl-0"
    }
};


const $cfc70a2d3dd9e444$export$880f7b1201440c23 = {
    root: {
        base: "flex rounded-lg border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800",
        children: "flex h-full flex-col justify-center gap-4 p-6",
        horizontal: {
            off: "flex-col",
            on: "flex-col md:max-w-xl md:flex-row"
        },
        href: "hover:bg-gray-100 dark:hover:bg-gray-700"
    },
    img: {
        base: "",
        horizontal: {
            off: "rounded-t-lg",
            on: "h-96 w-full rounded-t-lg object-cover md:h-auto md:w-48 md:rounded-none md:rounded-l-lg"
        }
    }
};


const $623e8aee9643dc7e$export$ebf43257906065ef = {
    root: {
        base: "relative h-full w-full",
        leftControl: "absolute top-0 left-0 flex h-full items-center justify-center px-4 focus:outline-none",
        rightControl: "absolute top-0 right-0 flex h-full items-center justify-center px-4 focus:outline-none"
    },
    indicators: {
        active: {
            off: "bg-white/50 hover:bg-white dark:bg-gray-800/50 dark:hover:bg-gray-800",
            on: "bg-white dark:bg-gray-800"
        },
        base: "h-3 w-3 rounded-full",
        wrapper: "absolute bottom-5 left-1/2 flex -translate-x-1/2 space-x-3"
    },
    item: {
        base: "absolute top-1/2 left-1/2 block w-full -translate-x-1/2 -translate-y-1/2",
        wrapper: "w-full flex-shrink-0 transform cursor-grab snap-center"
    },
    control: {
        base: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/30 group-hover:bg-white/50 group-focus:outline-none group-focus:ring-4 group-focus:ring-white dark:bg-gray-800/30 dark:group-hover:bg-gray-800/60 dark:group-focus:ring-gray-800/70 sm:h-10 sm:w-10",
        icon: "h-5 w-5 text-white dark:text-gray-800 sm:h-6 sm:w-6"
    },
    scrollContainer: {
        base: "flex h-full snap-mandatory overflow-y-hidden overflow-x-scroll scroll-smooth rounded-lg",
        snap: "snap-x"
    }
};


const $002b5682da83ea32$export$86286d8c37984115 = {
    root: {
        base: "h-4 w-4 rounded border border-gray-300 bg-gray-100 focus:ring-2 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:focus:ring-cyan-600 text-cyan-600"
    }
};


const $61fa4ccee747ab1c$export$8198429d552ab9d3 = {
    root: {
        base: "rounded-lg p-2.5 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-700",
        icon: "h-5 w-5"
    }
};


const $2500835a15980349$export$96b7b3eba8db5710 = {
    arrowIcon: "ml-2 h-4 w-4",
    content: "py-1 focus:outline-none",
    floating: {
        animation: "transition-opacity",
        arrow: {
            base: "absolute z-10 h-2 w-2 rotate-45",
            style: {
                dark: "bg-gray-900 dark:bg-gray-700",
                light: "bg-white",
                auto: "bg-white dark:bg-gray-700"
            },
            placement: "-4px"
        },
        base: "z-10 w-fit rounded divide-y divide-gray-100 shadow focus:outline-none",
        content: "py-1 text-sm text-gray-700 dark:text-gray-200",
        divider: "my-1 h-px bg-gray-100 dark:bg-gray-600",
        header: "block py-2 px-4 text-sm text-gray-700 dark:text-gray-200",
        hidden: "invisible opacity-0",
        item: {
            container: "",
            base: "flex items-center justify-start py-2 px-4 text-sm text-gray-700 cursor-pointer w-full hover:bg-gray-100 focus:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 focus:outline-none dark:hover:text-white dark:focus:bg-gray-600 dark:focus:text-white",
            icon: "mr-2 h-4 w-4"
        },
        style: {
            dark: "bg-gray-900 text-white dark:bg-gray-700",
            light: "border border-gray-200 bg-white text-gray-900",
            auto: "border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white"
        },
        target: "w-fit"
    },
    inlineWrapper: "flex items-center"
};


const $cd728becf947021d$export$c06044ee878e9e2d = {
    root: {
        base: "flex"
    },
    field: {
        base: "relative w-full",
        input: {
            base: "rounded-lg overflow-hidden block w-full border disabled:cursor-not-allowed disabled:opacity-50",
            sizes: {
                sm: "sm:text-xs",
                md: "text-sm",
                lg: "sm:text-md"
            },
            colors: {
                gray: "bg-gray-50 border-gray-300 text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
                info: "border-cyan-500 bg-cyan-50 text-cyan-900 placeholder-cyan-700 focus:border-cyan-500 focus:ring-cyan-500 dark:border-cyan-400 dark:bg-cyan-100 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
                failure: "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500 dark:border-red-400 dark:bg-red-100 dark:focus:border-red-500 dark:focus:ring-red-500",
                warning: "border-yellow-500 bg-yellow-50 text-yellow-900 placeholder-yellow-700 focus:border-yellow-500 focus:ring-yellow-500 dark:border-yellow-400 dark:bg-yellow-100 dark:focus:border-yellow-500 dark:focus:ring-yellow-500",
                success: "border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500 dark:border-green-400 dark:bg-green-100 dark:focus:border-green-500 dark:focus:ring-green-500"
            }
        }
    }
};


const $17df55e3dd86193b$export$7c3a1d5410930fce = {
    root: {
        base: "w-full rounded-lg bg-white shadow dark:bg-gray-800 md:flex md:items-center md:justify-between",
        container: "w-full p-6",
        bgDark: "bg-gray-800"
    },
    groupLink: {
        base: "flex flex-wrap text-sm text-gray-500 dark:text-white",
        link: {
            base: "last:mr-0 md:mr-6",
            href: "hover:underline"
        },
        col: "flex-col space-y-4"
    },
    icon: {
        base: "text-gray-500 dark:hover:text-white",
        size: "h-5 w-5"
    },
    title: {
        base: "mb-6 text-sm font-semibold uppercase text-gray-500 dark:text-white"
    },
    divider: {
        base: "w-full my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8"
    },
    copyright: {
        base: "text-sm text-gray-500 dark:text-gray-400 sm:text-center",
        href: "ml-1 hover:underline",
        span: "ml-1"
    },
    brand: {
        base: "mb-4 flex items-center sm:mb-0",
        img: "mr-3 h-8",
        span: "self-center whitespace-nowrap text-2xl font-semibold text-gray-800 dark:text-white"
    }
};


const $4b278acf8935794a$export$ff1c82ae18b9659d = {
    root: {
        base: "mt-2 text-sm",
        colors: {
            gray: "text-gray-500 dark:text-gray-400",
            info: "text-cyan-700 dark:text-cyan-800",
            success: "text-green-600 dark:text-green-500",
            failure: "text-red-600 dark:text-red-500",
            warning: "text-yellow-500 dark:text-yellow-600"
        }
    }
};


const $ef5746cb5f7585bd$export$14ed602d656a5999 = {
    root: {
        base: "text-sm font-medium",
        disabled: "opacity-50",
        colors: {
            default: "text-gray-900 dark:text-gray-300",
            info: "text-cyan-500 dark:text-cyan-600",
            failure: "text-red-700 dark:text-red-500",
            warning: "text-yellow-500 dark:text-yellow-600",
            success: "text-green-700 dark:text-green-500"
        }
    }
};


const $4253a8acdffc6a9c$export$8887fc452c4a328a = {
    root: {
        base: "list-none rounded-lg border border-gray-200 bg-white text-sm font-medium text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-white text-left"
    },
    item: {
        base: "[&>*]:first:rounded-t-lg [&>*]:last:rounded-b-lg [&>*]:last:border-b-0",
        link: {
            base: "flex w-full border-b border-gray-200 py-2 px-4 dark:border-gray-600",
            active: {
                off: "hover:bg-gray-100 hover:text-cyan-700 focus:text-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:text-white dark:focus:ring-gray-500",
                on: "bg-cyan-700 text-white dark:bg-gray-800"
            },
            href: {
                off: "",
                on: ""
            },
            icon: "mr-2 h-4 w-4 fill-current"
        }
    }
};


const $d9ef52181bfa20b2$export$158ae9a07be41c05 = {
    root: {
        base: "fixed top-0 right-0 left-0 z-50 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
        show: {
            on: "flex bg-gray-900 bg-opacity-50 dark:bg-opacity-80",
            off: "hidden"
        },
        sizes: {
            sm: "max-w-sm",
            md: "max-w-md",
            lg: "max-w-lg",
            xl: "max-w-xl",
            "2xl": "max-w-2xl",
            "3xl": "max-w-3xl",
            "4xl": "max-w-4xl",
            "5xl": "max-w-5xl",
            "6xl": "max-w-6xl",
            "7xl": "max-w-7xl"
        },
        positions: {
            "top-left": "items-start justify-start",
            "top-center": "items-start justify-center",
            "top-right": "items-start justify-end",
            "center-left": "items-center justify-start",
            center: "items-center justify-center",
            "center-right": "items-center justify-end",
            "bottom-right": "items-end justify-end",
            "bottom-center": "items-end justify-center",
            "bottom-left": "items-end justify-start"
        }
    },
    content: {
        base: "relative h-full w-full p-4 md:h-auto",
        inner: "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-[90vh]"
    },
    body: {
        base: "p-6 flex-1 overflow-auto",
        popup: "pt-0"
    },
    header: {
        base: "flex items-start justify-between rounded-t dark:border-gray-600 border-b p-5",
        popup: "p-2 border-b-0",
        title: "text-xl font-medium text-gray-900 dark:text-white",
        close: {
            base: "ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white",
            icon: "h-5 w-5"
        }
    },
    footer: {
        base: "flex items-center space-x-2 rounded-b border-gray-200 p-6 dark:border-gray-600",
        popup: "border-t"
    }
};


const $10283e7659011f65$export$4eebf7df9a5a8c41 = {
    root: {
        base: "bg-white px-2 py-2.5 dark:border-gray-700 dark:bg-gray-800 sm:px-4",
        rounded: {
            on: "rounded",
            off: ""
        },
        bordered: {
            on: "border",
            off: ""
        },
        inner: {
            base: "mx-auto flex flex-wrap items-center justify-between",
            fluid: {
                on: "",
                off: "container"
            }
        }
    },
    brand: {
        base: "flex items-center"
    },
    collapse: {
        base: "w-full md:block md:w-auto",
        list: "mt-4 flex flex-col md:mt-0 md:flex-row md:space-x-8 md:text-sm md:font-medium",
        hidden: {
            on: "hidden",
            off: ""
        }
    },
    link: {
        base: "block py-2 pr-4 pl-3 md:p-0",
        active: {
            on: "bg-cyan-700 text-white dark:text-white md:bg-transparent md:text-cyan-700",
            off: "border-b border-gray-100  text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white md:border-0 md:hover:bg-transparent md:hover:text-cyan-700 md:dark:hover:bg-transparent md:dark:hover:text-white"
        },
        disabled: {
            on: "text-gray-400 hover:cursor-not-allowed dark:text-gray-600",
            off: ""
        }
    },
    toggle: {
        base: "inline-flex items-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 md:hidden",
        icon: "h-6 w-6 shrink-0"
    }
};


const $c89bca5cc1d2539f$export$623cb20d291a4b05 = {
    base: "",
    layout: {
        table: {
            base: "text-sm text-gray-700 dark:text-gray-400",
            span: "font-semibold text-gray-900 dark:text-white"
        }
    },
    pages: {
        base: "xs:mt-0 mt-2 inline-flex items-center -space-x-px",
        showIcon: "inline-flex",
        previous: {
            base: "ml-0 rounded-l-lg border border-gray-300 bg-white py-2 px-3 leading-tight text-gray-500 enabled:hover:bg-gray-100 enabled:hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 enabled:dark:hover:bg-gray-700 enabled:dark:hover:text-white",
            icon: "h-5 w-5"
        },
        next: {
            base: "rounded-r-lg border border-gray-300 bg-white py-2 px-3 leading-tight text-gray-500 enabled:hover:bg-gray-100 enabled:hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 enabled:dark:hover:bg-gray-700 enabled:dark:hover:text-white",
            icon: "h-5 w-5"
        },
        selector: {
            base: "w-12 border border-gray-300 bg-white py-2 leading-tight text-gray-500 enabled:hover:bg-gray-100 enabled:hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 enabled:dark:hover:bg-gray-700 enabled:dark:hover:text-white",
            active: "bg-cyan-50 text-cyan-600 hover:bg-cyan-100 hover:text-cyan-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white",
            disabled: "opacity-50 cursor-normal"
        }
    }
};


const $08d5dcf072c6dabd$export$dc04d8e6a17afea1 = {
    base: "w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700",
    label: "mb-1 flex justify-between font-medium dark:text-white",
    bar: "rounded-full text-center font-medium leading-none text-cyan-300 dark:text-cyan-100 space-x-2",
    color: {
        dark: "bg-gray-600 dark:bg-gray-300",
        blue: "bg-cyan-600",
        red: "bg-red-600 dark:bg-red-500",
        green: "bg-green-600 dark:bg-green-500",
        yellow: "bg-yellow-400",
        indigo: "bg-indigo-600 dark:bg-indigo-500",
        purple: "bg-purple-600 dark:bg-purple-500"
    },
    size: {
        sm: "h-1.5",
        md: "h-2.5",
        lg: "h-4",
        xl: "h-6"
    }
};


const $775e6dcd74c2b92a$export$f0b387b940941887 = {
    root: {
        base: "h-4 w-4 border border-gray-300 focus:ring-2 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:focus:bg-cyan-600 dark:focus:ring-cyan-600 text-cyan-600"
    }
};


const $af543070cd097a31$export$639e51dd73cfbd1b = {
    root: {
        base: "flex"
    },
    field: {
        base: "relative w-full",
        input: {
            base: "w-full bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700",
            sizes: {
                sm: "h-1 range-sm",
                md: "h-2",
                lg: "h-3 range-lg"
            }
        }
    }
};


const $41959aa3119d47f1$export$b092fa29ee05c66b = {
    root: {
        base: "flex items-center"
    },
    advanced: {
        base: "flex items-center",
        label: "text-sm font-medium text-cyan-600 dark:text-cyan-500",
        progress: {
            base: "mx-4 h-5 w-2/4 rounded bg-gray-200 dark:bg-gray-700",
            fill: "h-5 rounded bg-yellow-400",
            label: "text-sm font-medium text-cyan-600 dark:text-cyan-500"
        }
    },
    star: {
        empty: "text-gray-300 dark:text-gray-500",
        filled: "text-yellow-400",
        sizes: {
            sm: "w-5 h-5",
            md: "w-7 h-7",
            lg: "w-10 h-10"
        }
    }
};


const $054797800202864e$export$21af0fc3c16183e1 = {
    base: "flex",
    addon: "inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-gray-400",
    field: {
        base: "relative w-full",
        icon: {
            base: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3",
            svg: "h-5 w-5 text-gray-500 dark:text-gray-400"
        },
        select: {
            base: "block w-full border disabled:cursor-not-allowed disabled:opacity-50",
            withIcon: {
                on: "pl-10",
                off: ""
            },
            withAddon: {
                on: "rounded-r-lg",
                off: "rounded-lg"
            },
            withShadow: {
                on: "shadow-sm dark:shadow-sm-light",
                off: ""
            },
            sizes: {
                sm: "p-2 sm:text-xs",
                md: "p-2.5 text-sm",
                lg: "sm:text-md p-4"
            },
            colors: {
                gray: "bg-gray-50 border-gray-300 text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
                info: "border-cyan-500 bg-cyan-50 text-cyan-900 placeholder-cyan-700 focus:border-cyan-500 focus:ring-cyan-500 dark:border-cyan-400 dark:bg-cyan-100 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
                failure: "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500 dark:border-red-400 dark:bg-red-100 dark:focus:border-red-500 dark:focus:ring-red-500",
                warning: "border-yellow-500 bg-yellow-50 text-yellow-900 placeholder-yellow-700 focus:border-yellow-500 focus:ring-yellow-500 dark:border-yellow-400 dark:bg-yellow-100 dark:focus:border-yellow-500 dark:focus:ring-yellow-500",
                success: "border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500 dark:border-green-400 dark:bg-green-100 dark:focus:border-green-500 dark:focus:ring-green-500"
            }
        }
    }
};


const $e7ca116a8db65c16$export$50b945f4d55f86d5 = {
    root: {
        base: "h-full",
        collapsed: {
            on: "w-16",
            off: "w-64"
        },
        inner: "h-full overflow-y-auto overflow-x-hidden rounded bg-gray-50 py-4 px-3 dark:bg-gray-800"
    },
    collapse: {
        button: "group flex w-full items-center rounded-lg p-2 text-base font-normal text-gray-900 transition duration-75 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700",
        icon: {
            base: "h-6 w-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white",
            open: {
                off: "",
                on: "text-gray-900"
            }
        },
        label: {
            base: "ml-3 flex-1 whitespace-nowrap text-left",
            icon: "h-6 w-6"
        },
        list: "space-y-2 py-2"
    },
    cta: {
        base: "mt-6 rounded-lg p-4 bg-gray-100 dark:bg-gray-700",
        color: {
            blue: "bg-cyan-50 dark:bg-cyan-900",
            dark: "bg-dark-50 dark:bg-dark-900",
            failure: "bg-red-50 dark:bg-red-900",
            gray: "bg-alternative-50 dark:bg-alternative-900",
            green: "bg-green-50 dark:bg-green-900",
            light: "bg-light-50 dark:bg-light-900",
            red: "bg-red-50 dark:bg-red-900",
            purple: "bg-purple-50 dark:bg-purple-900",
            success: "bg-green-50 dark:bg-green-900",
            yellow: "bg-yellow-50 dark:bg-yellow-900",
            warning: "bg-yellow-50 dark:bg-yellow-900"
        }
    },
    item: {
        base: "flex items-center justify-center rounded-lg p-2 text-base font-normal text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700",
        active: "bg-gray-100 dark:bg-gray-700",
        collapsed: {
            insideCollapse: "group w-full pl-8 transition duration-75",
            noIcon: "font-bold"
        },
        content: {
            base: "px-3 flex-1 whitespace-nowrap"
        },
        icon: {
            base: "h-6 w-6 flex-shrink-0 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white",
            active: "text-gray-700 dark:text-gray-100"
        },
        label: "",
        listItem: ""
    },
    items: "",
    itemGroup: "mt-4 space-y-2 border-t border-gray-200 pt-4 first:mt-0 first:border-t-0 first:pt-0 dark:border-gray-700",
    logo: {
        base: "mb-5 flex items-center pl-2.5",
        collapsed: {
            on: "hidden",
            off: "self-center whitespace-nowrap text-xl font-semibold dark:text-white"
        },
        img: "mr-3 h-6 sm:h-7"
    }
};


const $d92ca5725041cca1$export$d76156e68e556d3f = {
    base: "inline animate-spin text-gray-200",
    color: {
        failure: "fill-red-600",
        gray: "fill-gray-600",
        info: "fill-cyan-600",
        pink: "fill-pink-600",
        purple: "fill-purple-600",
        success: "fill-green-500",
        warning: "fill-yellow-400"
    },
    light: {
        off: {
            base: "dark:text-gray-600",
            color: {
                failure: "",
                gray: "dark:fill-gray-300",
                info: "",
                pink: "",
                purple: "",
                success: "",
                warning: ""
            }
        },
        on: {
            base: "",
            color: {
                failure: "",
                gray: "",
                info: "",
                pink: "",
                purple: "",
                success: "",
                warning: ""
            }
        }
    },
    size: {
        xs: "w-3 h-3",
        sm: "w-4 h-4",
        md: "w-6 h-6",
        lg: "w-8 h-8",
        xl: "w-10 h-10"
    }
};


const $0ac3bbccb47aa4ea$export$c3ab10e3d5a9b0d3 = {
    base: "flex flex-col gap-2",
    tablist: {
        base: "flex text-center",
        styles: {
            default: "flex-wrap border-b border-gray-200 dark:border-gray-700",
            underline: "flex-wrap -mb-px border-b border-gray-200 dark:border-gray-700",
            pills: "flex-wrap font-medium text-sm text-gray-500 dark:text-gray-400 space-x-2",
            fullWidth: "w-full text-sm font-medium divide-x divide-gray-200 shadow grid grid-flow-col dark:divide-gray-700 dark:text-gray-400 rounded-none"
        },
        tabitem: {
            base: "flex items-center justify-center p-4 rounded-t-lg text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 focus:ring-4 focus:ring-cyan-300 focus:outline-none",
            styles: {
                default: {
                    base: "rounded-t-lg",
                    active: {
                        on: "bg-gray-100 text-cyan-600 dark:bg-gray-800 dark:text-cyan-500",
                        off: "text-gray-500 hover:bg-gray-50 hover:text-gray-600 dark:text-gray-400 dark:hover:bg-gray-800  dark:hover:text-gray-300"
                    }
                },
                underline: {
                    base: "rounded-t-lg",
                    active: {
                        on: "text-cyan-600 rounded-t-lg border-b-2 border-cyan-600 active dark:text-cyan-500 dark:border-cyan-500",
                        off: "border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                    }
                },
                pills: {
                    base: "",
                    active: {
                        on: "rounded-lg bg-cyan-600 text-white",
                        off: "rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white"
                    }
                },
                fullWidth: {
                    base: "ml-0 first:ml-0 w-full rounded-none flex",
                    active: {
                        on: "p-4 text-gray-900 bg-gray-100 active dark:bg-gray-700 dark:text-white rounded-none",
                        off: "bg-white hover:text-gray-700 hover:bg-gray-50 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700 rounded-none"
                    }
                }
            },
            icon: "mr-2 h-5 w-5"
        }
    },
    tabpanel: "py-3"
};


const $8626724a52ee6955$export$3339219781bb5161 = {
    root: {
        base: "w-full text-left text-sm text-gray-500 dark:text-gray-400",
        shadow: "absolute bg-white dark:bg-black w-full h-full top-0 left-0 rounded-lg drop-shadow-md -z-10",
        wrapper: "relative"
    },
    body: {
        base: "group/body",
        cell: {
            base: "group-first/body:group-first/row:first:rounded-tl-lg group-first/body:group-first/row:last:rounded-tr-lg group-last/body:group-last/row:first:rounded-bl-lg group-last/body:group-last/row:last:rounded-br-lg px-6 py-4"
        }
    },
    head: {
        base: "group/head text-xs uppercase text-gray-700 dark:text-gray-400",
        cell: {
            base: "group-first/head:first:rounded-tl-lg group-first/head:last:rounded-tr-lg bg-gray-50 dark:bg-gray-700 px-6 py-3"
        }
    },
    row: {
        base: "group/row",
        hovered: "hover:bg-gray-50 dark:hover:bg-gray-600",
        striped: "odd:bg-white even:bg-gray-50 odd:dark:bg-gray-800 even:dark:bg-gray-700"
    }
};


const $705e205994c4e00a$export$4e48e2ce56dbbaad = {
    base: "flex",
    addon: "inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-gray-400",
    field: {
        base: "relative w-full",
        icon: {
            base: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3",
            svg: "h-5 w-5 text-gray-500 dark:text-gray-400"
        },
        rightIcon: {
            base: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3",
            svg: "h-5 w-5 text-gray-500 dark:text-gray-400"
        },
        input: {
            base: "block w-full border disabled:cursor-not-allowed disabled:opacity-50",
            sizes: {
                sm: "p-2 sm:text-xs",
                md: "p-2.5 text-sm",
                lg: "sm:text-md p-4"
            },
            colors: {
                gray: "bg-gray-50 border-gray-300 text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
                info: "border-cyan-500 bg-cyan-50 text-cyan-900 placeholder-cyan-700 focus:border-cyan-500 focus:ring-cyan-500 dark:border-cyan-400 dark:bg-cyan-100 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
                failure: "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500 dark:border-red-400 dark:bg-red-100 dark:focus:border-red-500 dark:focus:ring-red-500",
                warning: "border-yellow-500 bg-yellow-50 text-yellow-900 placeholder-yellow-700 focus:border-yellow-500 focus:ring-yellow-500 dark:border-yellow-400 dark:bg-yellow-100 dark:focus:border-yellow-500 dark:focus:ring-yellow-500",
                success: "border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500 dark:border-green-400 dark:bg-green-100 dark:focus:border-green-500 dark:focus:ring-green-500"
            },
            withRightIcon: {
                on: "pr-10",
                off: ""
            },
            withIcon: {
                on: "pl-10",
                off: ""
            },
            withAddon: {
                on: "rounded-r-lg",
                off: "rounded-lg"
            },
            withShadow: {
                on: "shadow-sm dark:shadow-sm-light",
                off: ""
            }
        }
    }
};


const $d3b16b0e7b0cc252$export$394b8322fab774c1 = {
    base: "block w-full rounded-lg border disabled:cursor-not-allowed disabled:opacity-50",
    colors: {
        gray: "bg-gray-50 border-gray-300 text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
        info: "border-cyan-500 bg-cyan-50 text-cyan-900 placeholder-cyan-700 focus:border-cyan-500 focus:ring-cyan-500 dark:border-cyan-400 dark:bg-cyan-100 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
        failure: "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500 dark:border-red-400 dark:bg-red-100 dark:focus:border-red-500 dark:focus:ring-red-500",
        warning: "border-yellow-500 bg-yellow-50 text-yellow-900 placeholder-yellow-700 focus:border-yellow-500 focus:ring-yellow-500 dark:border-yellow-400 dark:bg-yellow-100 dark:focus:border-yellow-500 dark:focus:ring-yellow-500",
        success: "border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500 dark:border-green-400 dark:bg-green-100 dark:focus:border-green-500 dark:focus:ring-green-500"
    },
    withShadow: {
        on: "shadow-sm dark:shadow-sm-light",
        off: ""
    }
};


const $f8feefc32f2d1851$export$f3eca8e756802d3 = {
    root: {
        direction: {
            horizontal: "items-base sm:flex",
            vertical: "relative border-l border-gray-200 dark:border-gray-700"
        }
    },
    item: {
        root: {
            horizontal: "relative mb-6 sm:mb-0",
            vertical: "mb-10 ml-6"
        },
        content: {
            root: {
                base: "mt-3 sm:pr-8"
            },
            body: "mb-4 text-base font-normal text-gray-500 dark:text-gray-400",
            time: "mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500",
            title: "text-lg font-semibold text-gray-900 dark:text-white"
        },
        point: {
            horizontal: "flex items-center",
            line: "hidden h-0.5 w-full bg-gray-200 dark:bg-gray-700 sm:flex",
            marker: {
                base: {
                    horizontal: "absolute -left-1.5 h-3 w-3 rounded-full border border-white bg-gray-200 dark:border-gray-900 dark:bg-gray-700",
                    vertical: "absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border border-white bg-gray-200 dark:border-gray-900 dark:bg-gray-700"
                },
                icon: {
                    base: "h-3 w-3 text-cyan-600 dark:text-cyan-300",
                    wrapper: "absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full bg-cyan-200 ring-8 ring-white dark:bg-cyan-900 dark:ring-gray-900"
                }
            },
            vertical: ""
        }
    }
};


const $e09e559492a0c018$export$abf90907e077d91f = {
    root: {
        base: "flex w-full max-w-xs items-center rounded-lg bg-white p-4 text-gray-500 shadow dark:bg-gray-800 dark:text-gray-400",
        closed: "opacity-0 ease-out"
    },
    toggle: {
        base: "-mx-1.5 -my-1.5 ml-auto inline-flex h-8 w-8 rounded-lg bg-white p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 focus:ring-2 focus:ring-gray-300 dark:bg-gray-800 dark:text-gray-500 dark:hover:bg-gray-700 dark:hover:text-white",
        icon: "h-5 w-5 shrink-0"
    }
};


const $d83ff2e4e09ad824$export$4a11172a3c7440f1 = {
    root: {
        base: "group relative flex items-center rounded-lg focus:outline-none",
        active: {
            on: "cursor-pointer",
            off: "cursor-not-allowed opacity-50"
        },
        label: "ml-3 text-sm font-medium text-gray-900 dark:text-gray-300"
    },
    toggle: {
        base: "toggle-bg h-6 w-11 rounded-full border group-focus:ring-4 group-focus:ring-cyan-500/25",
        checked: {
            on: "after:translate-x-full after:border-white",
            off: "border-gray-200 bg-gray-200 dark:border-gray-600 dark:bg-gray-700",
            color: {
                blue: " bg-cyan-700 border-cyan-700",
                dark: "bg-dark-700 border-dark-900",
                failure: "bg-red-700 border-red-900",
                gray: "bg-gray-500 border-gray-600",
                green: "bg-green-600 border-green-700",
                light: "bg-light-700 border-light-900",
                red: "bg-red-700 border-red-900",
                purple: "bg-purple-700 border-purple-900",
                success: "bg-green-500 border-green-500",
                yellow: "bg-yellow-400 border-yellow-400",
                warning: "bg-yellow-600 border-yellow-600",
                cyan: "bg-cyan-500 border-cyan-500",
                lime: "bg-lime-400 border-lime-400",
                indigo: "bg-indigo-400 border-indigo-400",
                teal: "bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4",
                info: "bg-cyan-600 border-cyan-600",
                pink: "bg-pink-600 border-pink-600"
            }
        }
    }
};


const $be9630fa6028a275$export$7472a7883840b563 = {
    target: "w-fit",
    animation: "transition-opacity",
    arrow: {
        base: "absolute z-10 h-2 w-2 rotate-45",
        style: {
            dark: "bg-gray-900 dark:bg-gray-700",
            light: "bg-white",
            auto: "bg-white dark:bg-gray-700"
        },
        placement: "-4px"
    },
    base: "absolute inline-block z-10 rounded-lg py-2 px-3 text-sm font-medium shadow-sm",
    hidden: "invisible opacity-0",
    style: {
        dark: "bg-gray-900 text-white dark:bg-gray-700",
        light: "border border-gray-200 bg-white text-gray-900",
        auto: "border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white"
    },
    content: "relative z-20"
};


const $a7de543205d03443$export$bca14c5b3b88a9c9 = {
    accordion: (0, $3356a69a96939017$export$20ec2254f76fa604),
    alert: (0, $792a23f43bf25624$export$9d77d9665d829e89),
    avatar: (0, $8e3f380ba545f3d4$export$9975d21893c10e66),
    badge: (0, $7ee601a1d8112e79$export$eb6e7cbc82d0f88b),
    breadcrumb: (0, $aea18d3a3e5e307b$export$e2d8c6f6af55009),
    button: (0, $afcde2d5db636df7$export$577deec5d331f6be),
    buttonGroup: (0, $afcde2d5db636df7$export$275abf48d41cf5c3),
    card: (0, $cfc70a2d3dd9e444$export$880f7b1201440c23),
    carousel: (0, $623e8aee9643dc7e$export$ebf43257906065ef),
    checkbox: (0, $002b5682da83ea32$export$86286d8c37984115),
    darkThemeToggle: (0, $61fa4ccee747ab1c$export$8198429d552ab9d3),
    dropdown: (0, $2500835a15980349$export$96b7b3eba8db5710),
    fileInput: (0, $cd728becf947021d$export$c06044ee878e9e2d),
    footer: (0, $17df55e3dd86193b$export$7c3a1d5410930fce),
    helperText: (0, $4b278acf8935794a$export$ff1c82ae18b9659d),
    label: (0, $ef5746cb5f7585bd$export$14ed602d656a5999),
    listGroup: (0, $4253a8acdffc6a9c$export$8887fc452c4a328a),
    modal: (0, $d9ef52181bfa20b2$export$158ae9a07be41c05),
    navbar: (0, $10283e7659011f65$export$4eebf7df9a5a8c41),
    pagination: (0, $c89bca5cc1d2539f$export$623cb20d291a4b05),
    progress: (0, $08d5dcf072c6dabd$export$dc04d8e6a17afea1),
    radio: (0, $775e6dcd74c2b92a$export$f0b387b940941887),
    rangeSlider: (0, $af543070cd097a31$export$639e51dd73cfbd1b),
    rating: (0, $41959aa3119d47f1$export$b092fa29ee05c66b),
    select: (0, $054797800202864e$export$21af0fc3c16183e1),
    textInput: (0, $705e205994c4e00a$export$4e48e2ce56dbbaad),
    textarea: (0, $d3b16b0e7b0cc252$export$394b8322fab774c1),
    toggleSwitch: (0, $d83ff2e4e09ad824$export$4a11172a3c7440f1),
    sidebar: (0, $e7ca116a8db65c16$export$50b945f4d55f86d5),
    spinner: (0, $d92ca5725041cca1$export$d76156e68e556d3f),
    tab: (0, $0ac3bbccb47aa4ea$export$c3ab10e3d5a9b0d3),
    table: (0, $8626724a52ee6955$export$3339219781bb5161),
    timeline: (0, $f8feefc32f2d1851$export$f3eca8e756802d3),
    toast: (0, $e09e559492a0c018$export$abf90907e077d91f),
    tooltip: (0, $be9630fa6028a275$export$7472a7883840b563)
};


const $28249a7df305c468$export$2c657da244d00bd6 = (0, $f2Y41.createContext)({
    theme: $a7de543205d03443$export$bca14c5b3b88a9c9
});
const $28249a7df305c468$export$d8964aec282183a3 = ({ children: children, value: value })=>{
    return (0, $ge3KO.jsx)($28249a7df305c468$export$2c657da244d00bd6.Provider, {
        value: value,
        children: children
    });
};
const $28249a7df305c468$export$93d4e7f90805808f = ()=>{
    return (0, $f2Y41.useContext)($28249a7df305c468$export$2c657da244d00bd6);
};
const $28249a7df305c468$var$prefersColorScheme = ()=>{
    if (!(0, $6b69c1c5f02d726c$export$7383f122bf48ec30)()) return "light";
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};
const $28249a7df305c468$export$45fd42032771846f = ()=>{
    const onToggleMode = ()=>{
        const newMode = mode === "dark" ? "light" : "dark";
        setModeOnBody(newMode);
        setMode(newMode);
    };
    const setModeOnBody = (0, $f2Y41.useCallback)((mode)=>{
        if (!(0, $6b69c1c5f02d726c$export$7383f122bf48ec30)()) return;
        if (mode === "dark") document.documentElement.classList.add("dark");
        else document.documentElement.classList.remove("dark");
    }, []);
    const { mode: initialMode, toggleMode: toggleMode = onToggleMode } = (0, $f2Y41.useContext)($28249a7df305c468$export$2c657da244d00bd6);
    const [mode, setMode] = (0, $f2Y41.useState)("light");
    (0, $f2Y41.useEffect)(()=>{
        if (initialMode) {
            setModeOnBody(initialMode);
            setMode(initialMode);
        } else setMode($28249a7df305c468$var$prefersColorScheme());
    }, [
        initialMode,
        setModeOnBody,
        setMode
    ]);
    return [
        mode,
        setMode,
        toggleMode
    ];
};



const $14072a0dc0ca5bb3$export$28560c96d8697973 = ({ className: className, theme: customTheme = {}, iconDark: IconDark = (0, $723979f296abdb2d$export$442843c5ba15ec2f), iconLight: IconLight = (0, $723979f296abdb2d$export$7e4aa2af55f6be66), ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.darkThemeToggle, customTheme);
    const { mode: mode, toggleMode: toggleMode } = (0, $f2Y41.useContext)((0, $28249a7df305c468$export$2c657da244d00bd6));
    return (0, $ge3KO.jsx)("button", {
        "aria-label": "Toggle dark mode",
        "data-testid": "dark-theme-toggle",
        onClick: toggleMode,
        type: "button",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
        ...props,
        children: mode === "dark" ? (0, $ge3KO.jsx)(IconLight, {
            "aria-label": "Currently dark mode",
            className: theme.root.icon
        }) : (0, $ge3KO.jsx)(IconDark, {
            "aria-label": "Currently light mode",
            className: theme.root.icon
        })
    });
};
$14072a0dc0ca5bb3$export$28560c96d8697973.displayName = "DarkThemeToggle";



var $ge3KO = parcelRequire("ge3KO");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $1587d54f9cddca51$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $1587d54f9cddca51$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $1587d54f9cddca51$export$803cd8101b6c182b = /*#__PURE__*/ $1587d54f9cddca51$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $1587d54f9cddca51$export$27b07d8a310ed8b5[0], side + "-" + $1587d54f9cddca51$export$27b07d8a310ed8b5[1]), []);
const $1587d54f9cddca51$export$96ec731ed4dcb222 = Math.min;
const $1587d54f9cddca51$export$8960430cfd85939f = Math.max;
const $1587d54f9cddca51$export$2077e0241d6afd3c = Math.round;
const $1587d54f9cddca51$export$a3fe094919f356fd = Math.floor;
const $1587d54f9cddca51$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $1587d54f9cddca51$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $1587d54f9cddca51$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $1587d54f9cddca51$export$7d15b64cf5a3a4c4(start, value, end) {
    return $1587d54f9cddca51$export$8960430cfd85939f(start, $1587d54f9cddca51$export$96ec731ed4dcb222(value, end));
}
function $1587d54f9cddca51$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $1587d54f9cddca51$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $1587d54f9cddca51$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $1587d54f9cddca51$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $1587d54f9cddca51$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $1587d54f9cddca51$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($1587d54f9cddca51$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $1587d54f9cddca51$export$2b57e0052a6d6d4c(placement) {
    return $1587d54f9cddca51$export$8a000a963141ac32($1587d54f9cddca51$export$f28e8f882010718a(placement));
}
function $1587d54f9cddca51$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $1587d54f9cddca51$export$f0989780f32bfcda(placement);
    const alignmentAxis = $1587d54f9cddca51$export$2b57e0052a6d6d4c(placement);
    const length = $1587d54f9cddca51$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $1587d54f9cddca51$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $1587d54f9cddca51$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $1587d54f9cddca51$export$496432a3699e50b1(placement) {
    const oppositePlacement = $1587d54f9cddca51$export$9c5e28bad23365fa(placement);
    return [
        $1587d54f9cddca51$export$2b182c584985588b(placement),
        oppositePlacement,
        $1587d54f9cddca51$export$2b182c584985588b(oppositePlacement)
    ];
}
function $1587d54f9cddca51$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$1587d54f9cddca51$var$oppositeAlignmentMap[alignment]);
}
function $1587d54f9cddca51$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $1587d54f9cddca51$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $1587d54f9cddca51$export$f0989780f32bfcda(placement);
    let list = $1587d54f9cddca51$var$getSideList($1587d54f9cddca51$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($1587d54f9cddca51$export$2b182c584985588b));
    }
    return list;
}
function $1587d54f9cddca51$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$1587d54f9cddca51$var$oppositeSideMap[side]);
}
function $1587d54f9cddca51$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $1587d54f9cddca51$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $1587d54f9cddca51$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $1587d54f9cddca51$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $1492b4532cbfe294$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1587d54f9cddca51$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $1587d54f9cddca51$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $1587d54f9cddca51$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $1492b4532cbfe294$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $1492b4532cbfe294$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $1492b4532cbfe294$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $1492b4532cbfe294$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $1587d54f9cddca51$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1587d54f9cddca51$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1587d54f9cddca51$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $1492b4532cbfe294$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1587d54f9cddca51$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1587d54f9cddca51$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $1587d54f9cddca51$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1587d54f9cddca51$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $1492b4532cbfe294$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $1587d54f9cddca51$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $1492b4532cbfe294$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1587d54f9cddca51$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1587d54f9cddca51$export$803cd8101b6c182b) ? $1492b4532cbfe294$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $1492b4532cbfe294$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1587d54f9cddca51$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1587d54f9cddca51$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1587d54f9cddca51$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1587d54f9cddca51$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $1492b4532cbfe294$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1587d54f9cddca51$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $1587d54f9cddca51$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $1587d54f9cddca51$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $1492b4532cbfe294$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1587d54f9cddca51$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $1492b4532cbfe294$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $1492b4532cbfe294$var$isAnySideFullyClipped(overflow) {
    return (0, $1587d54f9cddca51$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $1492b4532cbfe294$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $1492b4532cbfe294$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $1492b4532cbfe294$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $1492b4532cbfe294$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $1492b4532cbfe294$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $1492b4532cbfe294$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $1492b4532cbfe294$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $1492b4532cbfe294$var$getBoundingRect(rects) {
    const minX = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1587d54f9cddca51$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1587d54f9cddca51$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $1492b4532cbfe294$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1587d54f9cddca51$export$ee05aea0aeecbad4)($1492b4532cbfe294$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $1492b4532cbfe294$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $1492b4532cbfe294$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1587d54f9cddca51$export$ee05aea0aeecbad4)($1492b4532cbfe294$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1587d54f9cddca51$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1587d54f9cddca51$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $1587d54f9cddca51$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $1492b4532cbfe294$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $1587d54f9cddca51$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $1492b4532cbfe294$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $1492b4532cbfe294$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $1492b4532cbfe294$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $1492b4532cbfe294$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1587d54f9cddca51$export$f28e8f882010718a)((0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $1587d54f9cddca51$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1587d54f9cddca51$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1587d54f9cddca51$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $1492b4532cbfe294$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1587d54f9cddca51$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $1587d54f9cddca51$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $1492b4532cbfe294$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1587d54f9cddca51$export$fef61f332f2c0afc)(options, state);
            const overflow = await $1492b4532cbfe294$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1587d54f9cddca51$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $1587d54f9cddca51$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $1587d54f9cddca51$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $1587d54f9cddca51$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $1587d54f9cddca51$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $1587d54f9cddca51$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $1587d54f9cddca51$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1587d54f9cddca51$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1587d54f9cddca51$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $865db79e060f8dc3$export$651544f548703224(node) {
    if ($865db79e060f8dc3$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $865db79e060f8dc3$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $865db79e060f8dc3$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($865db79e060f8dc3$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $865db79e060f8dc3$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $865db79e060f8dc3$export$38b2d434cce3ea22(value).Node;
}
function $865db79e060f8dc3$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $865db79e060f8dc3$export$38b2d434cce3ea22(value).Element;
}
function $865db79e060f8dc3$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $865db79e060f8dc3$export$38b2d434cce3ea22(value).HTMLElement;
}
function $865db79e060f8dc3$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $865db79e060f8dc3$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $865db79e060f8dc3$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $865db79e060f8dc3$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $865db79e060f8dc3$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($865db79e060f8dc3$export$651544f548703224(element));
}
function $865db79e060f8dc3$export$d6c4e8150c35fed1(element) {
    const webkit = $865db79e060f8dc3$export$78551043582a6a98();
    const css = $865db79e060f8dc3$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $865db79e060f8dc3$export$940d8225183e1404(element) {
    let currentNode = $865db79e060f8dc3$export$4e12058fc4d51d56(element);
    while($865db79e060f8dc3$export$1b3bfaa9684536aa(currentNode) && !$865db79e060f8dc3$export$d1162fb0b6d4cd51(currentNode)){
        if ($865db79e060f8dc3$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $865db79e060f8dc3$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $865db79e060f8dc3$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $865db79e060f8dc3$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($865db79e060f8dc3$export$651544f548703224(node));
}
function $865db79e060f8dc3$export$3735103072e4a80(element) {
    return $865db79e060f8dc3$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $865db79e060f8dc3$export$dc8fc79fa2800137(element) {
    if ($865db79e060f8dc3$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $865db79e060f8dc3$export$4e12058fc4d51d56(node) {
    if ($865db79e060f8dc3$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $865db79e060f8dc3$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $865db79e060f8dc3$export$e495491855dc5418(node);
    return $865db79e060f8dc3$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $865db79e060f8dc3$export$7cd01a57c8ca906c(node) {
    const parentNode = $865db79e060f8dc3$export$4e12058fc4d51d56(node);
    if ($865db79e060f8dc3$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($865db79e060f8dc3$export$1b3bfaa9684536aa(parentNode) && $865db79e060f8dc3$export$989e911fa9af580a(parentNode)) return parentNode;
    return $865db79e060f8dc3$export$7cd01a57c8ca906c(parentNode);
}
function $865db79e060f8dc3$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $865db79e060f8dc3$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $865db79e060f8dc3$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $865db79e060f8dc3$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $865db79e060f8dc3$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $865db79e060f8dc3$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $022d15fe75fec75f$var$getCssDimensions(element) {
    const css = (0, $865db79e060f8dc3$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1587d54f9cddca51$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $1587d54f9cddca51$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $022d15fe75fec75f$var$unwrapElement(element) {
    return !(0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $022d15fe75fec75f$var$getScale(element) {
    const domElement = $022d15fe75fec75f$var$unwrapElement(element);
    if (!(0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(domElement)) return (0, $1587d54f9cddca51$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $022d15fe75fec75f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1587d54f9cddca51$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1587d54f9cddca51$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $022d15fe75fec75f$var$noOffsets = /*#__PURE__*/ (0, $1587d54f9cddca51$export$a397704b5e280835)(0);
function $022d15fe75fec75f$var$getVisualOffsets(element) {
    const win = (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(element);
    if (!(0, $865db79e060f8dc3$export$78551043582a6a98)() || !win.visualViewport) return $022d15fe75fec75f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $022d15fe75fec75f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $022d15fe75fec75f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $022d15fe75fec75f$var$unwrapElement(element);
    let scale = (0, $1587d54f9cddca51$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(offsetParent)) scale = $022d15fe75fec75f$var$getScale(offsetParent);
        } else scale = $022d15fe75fec75f$var$getScale(element);
    }
    const visualOffsets = $022d15fe75fec75f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $022d15fe75fec75f$var$getVisualOffsets(domElement) : (0, $1587d54f9cddca51$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $022d15fe75fec75f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $865db79e060f8dc3$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $1587d54f9cddca51$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $022d15fe75fec75f$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $022d15fe75fec75f$var$isTopLayer(floating) {
    return $022d15fe75fec75f$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $022d15fe75fec75f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $865db79e060f8dc3$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $022d15fe75fec75f$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1587d54f9cddca51$export$a397704b5e280835)(1);
    const offsets = (0, $1587d54f9cddca51$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $865db79e060f8dc3$export$651544f548703224)(offsetParent) !== "body" || (0, $865db79e060f8dc3$export$989e911fa9af580a)(documentElement)) scroll = (0, $865db79e060f8dc3$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $022d15fe75fec75f$var$getBoundingClientRect(offsetParent);
            scale = $022d15fe75fec75f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $022d15fe75fec75f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $022d15fe75fec75f$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $022d15fe75fec75f$var$getBoundingClientRect((0, $865db79e060f8dc3$export$e495491855dc5418)(element)).left + (0, $865db79e060f8dc3$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $022d15fe75fec75f$var$getDocumentRect(element) {
    const html = (0, $865db79e060f8dc3$export$e495491855dc5418)(element);
    const scroll = (0, $865db79e060f8dc3$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1587d54f9cddca51$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1587d54f9cddca51$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $022d15fe75fec75f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $865db79e060f8dc3$export$3735103072e4a80)(body).direction === "rtl") x += (0, $1587d54f9cddca51$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $022d15fe75fec75f$var$getViewportRect(element, strategy) {
    const win = (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(element);
    const html = (0, $865db79e060f8dc3$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $865db79e060f8dc3$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $022d15fe75fec75f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $022d15fe75fec75f$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(element) ? $022d15fe75fec75f$var$getScale(element) : (0, $1587d54f9cddca51$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $022d15fe75fec75f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $022d15fe75fec75f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $022d15fe75fec75f$var$getDocumentRect((0, $865db79e060f8dc3$export$e495491855dc5418)(element));
    else if ((0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $022d15fe75fec75f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $022d15fe75fec75f$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $1587d54f9cddca51$export$ee05aea0aeecbad4)(rect);
}
function $022d15fe75fec75f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $865db79e060f8dc3$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(parentNode) || (0, $865db79e060f8dc3$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $865db79e060f8dc3$export$3735103072e4a80)(parentNode).position === "fixed" || $022d15fe75fec75f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $022d15fe75fec75f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $865db79e060f8dc3$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(el) && (0, $865db79e060f8dc3$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $865db79e060f8dc3$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $865db79e060f8dc3$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $865db79e060f8dc3$export$45a5e7f76e0caa8d)(currentNode) && !(0, $865db79e060f8dc3$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $865db79e060f8dc3$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $865db79e060f8dc3$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $865db79e060f8dc3$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $022d15fe75fec75f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $865db79e060f8dc3$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $022d15fe75fec75f$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $022d15fe75fec75f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $022d15fe75fec75f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1587d54f9cddca51$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1587d54f9cddca51$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $022d15fe75fec75f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $022d15fe75fec75f$var$getDimensions(element) {
    const { width: width, height: height } = $022d15fe75fec75f$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $022d15fe75fec75f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $865db79e060f8dc3$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $022d15fe75fec75f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1587d54f9cddca51$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $865db79e060f8dc3$export$651544f548703224)(offsetParent) !== "body" || (0, $865db79e060f8dc3$export$989e911fa9af580a)(documentElement)) scroll = (0, $865db79e060f8dc3$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $022d15fe75fec75f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $022d15fe75fec75f$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $022d15fe75fec75f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(element) || (0, $865db79e060f8dc3$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $022d15fe75fec75f$var$getOffsetParent(element, polyfill) {
    const window = (0, $865db79e060f8dc3$export$38b2d434cce3ea22)(element);
    if (!(0, $865db79e060f8dc3$export$1b3bfaa9684536aa)(element) || $022d15fe75fec75f$var$isTopLayer(element)) return window;
    let offsetParent = $022d15fe75fec75f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $865db79e060f8dc3$export$71535ffaa902797f)(offsetParent) && (0, $865db79e060f8dc3$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $022d15fe75fec75f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $865db79e060f8dc3$export$651544f548703224)(offsetParent) === "html" || (0, $865db79e060f8dc3$export$651544f548703224)(offsetParent) === "body" && (0, $865db79e060f8dc3$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $865db79e060f8dc3$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $865db79e060f8dc3$export$940d8225183e1404)(element) || window;
}
const $022d15fe75fec75f$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $022d15fe75fec75f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $022d15fe75fec75f$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $022d15fe75fec75f$var$isRTL(element) {
    return (0, $865db79e060f8dc3$export$3735103072e4a80)(element).direction === "rtl";
}
const $022d15fe75fec75f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $022d15fe75fec75f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $865db79e060f8dc3$export$e495491855dc5418,
    getClippingRect: $022d15fe75fec75f$var$getClippingRect,
    getOffsetParent: $022d15fe75fec75f$var$getOffsetParent,
    getElementRects: $022d15fe75fec75f$var$getElementRects,
    getClientRects: $022d15fe75fec75f$var$getClientRects,
    getDimensions: $022d15fe75fec75f$var$getDimensions,
    getScale: $022d15fe75fec75f$var$getScale,
    isElement: $865db79e060f8dc3$export$45a5e7f76e0caa8d,
    isRTL: $022d15fe75fec75f$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $022d15fe75fec75f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $865db79e060f8dc3$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1587d54f9cddca51$export$a3fe094919f356fd)(top);
        const insetRight = (0, $1587d54f9cddca51$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $1587d54f9cddca51$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $1587d54f9cddca51$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1587d54f9cddca51$export$8960430cfd85939f)(0, (0, $1587d54f9cddca51$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $022d15fe75fec75f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $022d15fe75fec75f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $865db79e060f8dc3$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $865db79e060f8dc3$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $022d15fe75fec75f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $022d15fe75fec75f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $022d15fe75fec75f$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
// `OffsetOptions` in the core library were originally already `Derivable`. For
// backwards-compatibility, re-define it here to use the DOM Derivable type.
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $022d15fe75fec75f$export$37b6bde19b108ecc = (0, $1492b4532cbfe294$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $022d15fe75fec75f$export$cc800923e997bb8 = (0, $1492b4532cbfe294$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $022d15fe75fec75f$export$91fb6ecbd551914 = (0, $1492b4532cbfe294$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $022d15fe75fec75f$export$fba63a578e423eb = (0, $1492b4532cbfe294$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $022d15fe75fec75f$export$8a83211c878a3f1f = (0, $1492b4532cbfe294$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $022d15fe75fec75f$export$346677f925de839c = (0, $1492b4532cbfe294$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $022d15fe75fec75f$export$fe8985bb6374093c = (0, $1492b4532cbfe294$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $022d15fe75fec75f$export$f2120bbfa5450bd2 = (0, $1492b4532cbfe294$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $022d15fe75fec75f$export$18c8ad048e32c7d5 = (0, $1492b4532cbfe294$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $022d15fe75fec75f$export$7bf07e38f3dc4b69 = (0, $1492b4532cbfe294$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $022d15fe75fec75f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $022d15fe75fec75f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $1492b4532cbfe294$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $f2Y41 = parcelRequire("f2Y41");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $2adec4136592c363$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $022d15fe75fec75f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $022d15fe75fec75f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $2adec4136592c363$var$index = typeof document !== "undefined" ? (0, $f2Y41.useLayoutEffect) : (0, $f2Y41.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $2adec4136592c363$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$2adec4136592c363$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$2adec4136592c363$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $2adec4136592c363$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $2adec4136592c363$var$roundByDPR(element, value) {
    const dpr = $2adec4136592c363$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $2adec4136592c363$var$useLatestRef(value) {
    const ref = $f2Y41.useRef(value);
    $2adec4136592c363$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $2adec4136592c363$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $f2Y41.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $f2Y41.useState(middleware);
    if (!$2adec4136592c363$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $f2Y41.useState(null);
    const [_floating, _setFloating] = $f2Y41.useState(null);
    const setReference = $f2Y41.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $f2Y41.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $f2Y41.useRef(null);
    const floatingRef = $f2Y41.useRef(null);
    const dataRef = $f2Y41.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $2adec4136592c363$var$useLatestRef(whileElementsMounted);
    const platformRef = $2adec4136592c363$var$useLatestRef(platform);
    const update = $f2Y41.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $022d15fe75fec75f$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$2adec4136592c363$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $5021361ff788fb77$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $2adec4136592c363$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $f2Y41.useRef(false);
    $2adec4136592c363$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $2adec4136592c363$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $f2Y41.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $f2Y41.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $f2Y41.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $2adec4136592c363$var$roundByDPR(elements.floating, data.x);
        const y = $2adec4136592c363$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$2adec4136592c363$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $f2Y41.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");
var $c3578876bbfeac12$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $c3578876bbfeac12$var$counterMap = new WeakMap();
var $c3578876bbfeac12$var$uncontrolledNodes = new WeakMap();
var $c3578876bbfeac12$var$markerMap = {};
var $c3578876bbfeac12$var$lockCount = 0;
var $c3578876bbfeac12$var$unwrapHost = function(node) {
    return node && (node.host || $c3578876bbfeac12$var$unwrapHost(node.parentNode));
};
var $c3578876bbfeac12$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $c3578876bbfeac12$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $c3578876bbfeac12$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $c3578876bbfeac12$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$c3578876bbfeac12$var$markerMap[markerName]) $c3578876bbfeac12$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $c3578876bbfeac12$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($c3578876bbfeac12$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $c3578876bbfeac12$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $c3578876bbfeac12$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $c3578876bbfeac12$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $c3578876bbfeac12$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $c3578876bbfeac12$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$c3578876bbfeac12$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $c3578876bbfeac12$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $c3578876bbfeac12$var$lockCount--;
        if (!$c3578876bbfeac12$var$lockCount) {
            // clear
            $c3578876bbfeac12$var$counterMap = new WeakMap();
            $c3578876bbfeac12$var$counterMap = new WeakMap();
            $c3578876bbfeac12$var$uncontrolledNodes = new WeakMap();
            $c3578876bbfeac12$var$markerMap = {};
        }
    };
};
var $c3578876bbfeac12$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $c3578876bbfeac12$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $c3578876bbfeac12$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $c3578876bbfeac12$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $c3578876bbfeac12$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $c3578876bbfeac12$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $c3578876bbfeac12$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $c3578876bbfeac12$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($c3578876bbfeac12$export$cc95fea82d705fca() ? $c3578876bbfeac12$export$59151cc8db999a24 : $c3578876bbfeac12$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $b9b7d29ce522908f$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $b9b7d29ce522908f$var$candidateSelector = /* #__PURE__ */ $b9b7d29ce522908f$var$candidateSelectors.join(",");
var $b9b7d29ce522908f$var$NoElement = typeof Element === "undefined";
var $b9b7d29ce522908f$var$matches = $b9b7d29ce522908f$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $b9b7d29ce522908f$var$getRootNode = !$b9b7d29ce522908f$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $b9b7d29ce522908f$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $b9b7d29ce522908f$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $b9b7d29ce522908f$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($b9b7d29ce522908f$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($b9b7d29ce522908f$var$candidateSelector));
    if (includeContainer && $b9b7d29ce522908f$var$matches.call(el, $b9b7d29ce522908f$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $b9b7d29ce522908f$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($b9b7d29ce522908f$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $b9b7d29ce522908f$var$matches.call(element, $b9b7d29ce522908f$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$b9b7d29ce522908f$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $b9b7d29ce522908f$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $b9b7d29ce522908f$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $b9b7d29ce522908f$var$isContentEditable(node)) && !$b9b7d29ce522908f$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $b9b7d29ce522908f$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $b9b7d29ce522908f$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$b9b7d29ce522908f$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $b9b7d29ce522908f$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $b9b7d29ce522908f$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $b9b7d29ce522908f$var$isHiddenInput = function isHiddenInput(node) {
    return $b9b7d29ce522908f$var$isInput(node) && node.type === "hidden";
};
var $b9b7d29ce522908f$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $b9b7d29ce522908f$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $b9b7d29ce522908f$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $b9b7d29ce522908f$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $b9b7d29ce522908f$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $b9b7d29ce522908f$var$isRadio = function isRadio(node) {
    return $b9b7d29ce522908f$var$isInput(node) && node.type === "radio";
};
var $b9b7d29ce522908f$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $b9b7d29ce522908f$var$isRadio(node) && !$b9b7d29ce522908f$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $b9b7d29ce522908f$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $b9b7d29ce522908f$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $b9b7d29ce522908f$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $b9b7d29ce522908f$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $b9b7d29ce522908f$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $b9b7d29ce522908f$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($b9b7d29ce522908f$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $b9b7d29ce522908f$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $b9b7d29ce522908f$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($b9b7d29ce522908f$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $b9b7d29ce522908f$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $b9b7d29ce522908f$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $b9b7d29ce522908f$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $b9b7d29ce522908f$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $b9b7d29ce522908f$var$isInert(node) || $b9b7d29ce522908f$var$isHiddenInput(node) || $b9b7d29ce522908f$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $b9b7d29ce522908f$var$isDetailsWithSummary(node) || $b9b7d29ce522908f$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $b9b7d29ce522908f$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($b9b7d29ce522908f$var$isNonTabbableRadio(node) || $b9b7d29ce522908f$export$a4672efddb4181b8(node) < 0 || !$b9b7d29ce522908f$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $b9b7d29ce522908f$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $b9b7d29ce522908f$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $b9b7d29ce522908f$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($b9b7d29ce522908f$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $b9b7d29ce522908f$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $b9b7d29ce522908f$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $b9b7d29ce522908f$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $b9b7d29ce522908f$var$isValidShadowRootTabbable
    });
    else candidates = $b9b7d29ce522908f$var$getCandidates(container, options.includeContainer, $b9b7d29ce522908f$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $b9b7d29ce522908f$var$sortByOrder(candidates);
};
var $b9b7d29ce522908f$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $b9b7d29ce522908f$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $b9b7d29ce522908f$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $b9b7d29ce522908f$var$getCandidates(container, options.includeContainer, $b9b7d29ce522908f$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $b9b7d29ce522908f$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($b9b7d29ce522908f$var$matches.call(node, $b9b7d29ce522908f$var$candidateSelector) === false) return false;
    return $b9b7d29ce522908f$var$isNodeMatchingSelectorTabbable(options, node);
};
var $b9b7d29ce522908f$var$focusableCandidateSelector = /* #__PURE__ */ $b9b7d29ce522908f$var$candidateSelectors.concat("iframe").join(",");
var $b9b7d29ce522908f$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($b9b7d29ce522908f$var$matches.call(node, $b9b7d29ce522908f$var$focusableCandidateSelector) === false) return false;
    return $b9b7d29ce522908f$var$isNodeMatchingSelectorFocusable(options, node);
};



function $61cd97d3d660dea1$var$_extends() {
    $61cd97d3d660dea1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $61cd97d3d660dea1$var$_extends.apply(this, arguments);
}
var $61cd97d3d660dea1$var$index = typeof document !== "undefined" ? (0, $f2Y41.useLayoutEffect) : (0, $f2Y41.useEffect);
let $61cd97d3d660dea1$var$serverHandoffComplete = false;
let $61cd97d3d660dea1$var$count = 0;
const $61cd97d3d660dea1$var$genId = ()=>"floating-ui-" + $61cd97d3d660dea1$var$count++;
function $61cd97d3d660dea1$var$useFloatingId() {
    const [id, setId] = $f2Y41.useState(()=>$61cd97d3d660dea1$var$serverHandoffComplete ? $61cd97d3d660dea1$var$genId() : undefined);
    $61cd97d3d660dea1$var$index(()=>{
        if (id == null) setId($61cd97d3d660dea1$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f2Y41.useEffect(()=>{
        if (!$61cd97d3d660dea1$var$serverHandoffComplete) $61cd97d3d660dea1$var$serverHandoffComplete = true;
    }, []);
    return id;
}
// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const $61cd97d3d660dea1$var$useReactId = $f2Y41[/*#__PURE__*/ "useId".toString()];
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */ const $61cd97d3d660dea1$export$f680877a34711e37 = $61cd97d3d660dea1$var$useReactId || $61cd97d3d660dea1$var$useFloatingId;
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $61cd97d3d660dea1$export$33511391554732bc = /*#__PURE__*/ $f2Y41.forwardRef(function FloatingArrow(_ref, ref) {
    let { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = _ref;
    const clipPathId = $61cd97d3d660dea1$export$f680877a34711e37();
    if (!floating) return null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    strokeWidth *= 2;
    const halfStrokeWidth = strokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const [side, alignment] = placement.split("-");
    const isRTL = (0, $022d15fe75fec75f$export$722a64dea1b767dc).isRTL(floating);
    const isCustomShape = !!d;
    const isVerticalSide = side === "top" || side === "bottom";
    const yOffsetProp = staticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = staticOffset && alignment === "end" ? "right" : "left";
    if (staticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $f2Y41.createElement("svg", $61cd97d3d660dea1$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + strokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + strokeWidth / 2 + "px)",
            transform: "" + rotation + (transform != null ? transform : ""),
            ...restStyle
        }
    }), strokeWidth > 0 && /*#__PURE__*/ $f2Y41.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        stroke: strokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $f2Y41.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $f2Y41.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + strokeWidth,
        height: width
    })));
});
function $61cd97d3d660dea1$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $61cd97d3d660dea1$var$FloatingNodeContext = /*#__PURE__*/ $f2Y41.createContext(null);
const $61cd97d3d660dea1$var$FloatingTreeContext = /*#__PURE__*/ $f2Y41.createContext(null);
const $61cd97d3d660dea1$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $f2Y41.useContext($61cd97d3d660dea1$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const $61cd97d3d660dea1$export$db0c2a7c7a2a4f69 = ()=>$f2Y41.useContext($61cd97d3d660dea1$var$FloatingTreeContext);
/**
 * Registers a node into the floating tree, returning its id.
 */ function $61cd97d3d660dea1$export$9b136e0e758a42f4(customParentId) {
    const id = $61cd97d3d660dea1$export$f680877a34711e37();
    const tree = $61cd97d3d660dea1$export$db0c2a7c7a2a4f69();
    const reactParentId = $61cd97d3d660dea1$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $61cd97d3d660dea1$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $61cd97d3d660dea1$export$ca00a83b5b253862(_ref) {
    let { children: children, id: id } = _ref;
    const parentId = $61cd97d3d660dea1$export$165209eae06d3488();
    return /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FloatingNodeContext.Provider, {
        value: $f2Y41.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $61cd97d3d660dea1$export$587b60129641c4c8(_ref2) {
    let { children: children } = _ref2;
    const nodesRef = $f2Y41.useRef([]);
    const addNode = $f2Y41.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $f2Y41.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $f2Y41.useState(()=>$61cd97d3d660dea1$var$createPubSub())[0];
    return /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FloatingTreeContext.Provider, {
        value: $f2Y41.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            nodesRef,
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $61cd97d3d660dea1$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Avoid Chrome DevTools blue warning.
function $61cd97d3d660dea1$var$getPlatform() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $61cd97d3d660dea1$var$getUserAgent() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
function $61cd97d3d660dea1$var$getWindow(value) {
    return $61cd97d3d660dea1$var$getDocument(value).defaultView || window;
}
function $61cd97d3d660dea1$var$isElement(value) {
    return value ? value instanceof Element || value instanceof $61cd97d3d660dea1$var$getWindow(value).Element : false;
}
function $61cd97d3d660dea1$var$isHTMLElement(value) {
    return value ? value instanceof HTMLElement || value instanceof $61cd97d3d660dea1$var$getWindow(value).HTMLElement : false;
}
function $61cd97d3d660dea1$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $61cd97d3d660dea1$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $61cd97d3d660dea1$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    const androidRe = /Android/i;
    if ((androidRe.test($61cd97d3d660dea1$var$getPlatform()) || androidRe.test($61cd97d3d660dea1$var$getUserAgent())) && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $61cd97d3d660dea1$var$isVirtualPointerEvent(event) {
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function $61cd97d3d660dea1$var$isSafari() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $61cd97d3d660dea1$var$isMac() {
    return $61cd97d3d660dea1$var$getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $61cd97d3d660dea1$var$isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $61cd97d3d660dea1$var$isReactEvent(event) {
    return "nativeEvent" in event;
}
function $61cd97d3d660dea1$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode && child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && $61cd97d3d660dea1$var$isShadowRoot(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $61cd97d3d660dea1$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $61cd97d3d660dea1$var$useLatestRef(value) {
    const ref = (0, $f2Y41.useRef)(value);
    $61cd97d3d660dea1$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $61cd97d3d660dea1$var$safePolygonIdentifier = /*#__PURE__*/ $61cd97d3d660dea1$var$createAttribute("safe-polygon");
function $61cd97d3d660dea1$var$getDelay(value, prop, pointerType) {
    if (pointerType && !$61cd97d3d660dea1$var$isMouseLikePointerType(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $61cd97d3d660dea1$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: { domReference: domReference, floating: floating }, refs: refs } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $61cd97d3d660dea1$export$db0c2a7c7a2a4f69();
    const parentId = $61cd97d3d660dea1$export$165209eae06d3488();
    const handleCloseRef = $61cd97d3d660dea1$var$useLatestRef(handleClose);
    const delayRef = $61cd97d3d660dea1$var$useLatestRef(delay);
    const pointerTypeRef = $f2Y41.useRef();
    const timeoutRef = $f2Y41.useRef();
    const handlerRef = $f2Y41.useRef();
    const restTimeoutRef = $f2Y41.useRef();
    const blockMouseMoveRef = $f2Y41.useRef(true);
    const performedPointerEventsMutationRef = $f2Y41.useRef(false);
    const unbindMouseMoveRef = $f2Y41.useRef(()=>{});
    const isHoverOpen = $f2Y41.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When dismissing before opening, clear the delay timeouts to cancel it
    // from showing.
    $f2Y41.useEffect(()=>{
        if (!enabled) return;
        function onDismiss() {
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            blockMouseMoveRef.current = true;
        }
        events.on("dismiss", onDismiss);
        return ()=>{
            events.off("dismiss", onDismiss);
        };
    }, [
        enabled,
        events
    ]);
    $f2Y41.useEffect(()=>{
        if (!enabled || !handleCloseRef.current || !open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event);
        }
        const html = $61cd97d3d660dea1$var$getDocument(floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    const closeWithDelay = $f2Y41.useCallback(function(event, runElseBranch) {
        if (runElseBranch === void 0) runElseBranch = true;
        const closeDelay = $61cd97d3d660dea1$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>onOpenChange(false, event), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $f2Y41.useCallback(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    }, []);
    const clearPointerEvents = $f2Y41.useCallback(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = $61cd97d3d660dea1$var$getDocument(refs.floating.current).body;
            body.style.pointerEvents = "";
            body.removeAttribute($61cd97d3d660dea1$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    }, [
        refs
    ]);
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $f2Y41.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !$61cd97d3d660dea1$var$isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && $61cd97d3d660dea1$var$getDelay(delayRef.current, "open") === 0) return;
            const openDelay = $61cd97d3d660dea1$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = setTimeout(()=>{
                onOpenChange(true, event);
            }, openDelay);
            else onOpenChange(true, event);
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = $61cd97d3d660dea1$var$getDocument(floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...context,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        // Should the event expose that it was closed by `safePolygon`?
                        closeWithDelay(event);
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !$61cd97d3d660dea1$var$contains(floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...context,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ($61cd97d3d660dea1$var$isElement(domReference)) {
            const ref = domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            floating == null || floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                floating == null || floating.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        domReference,
        floating,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $61cd97d3d660dea1$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            const body = $61cd97d3d660dea1$var$getDocument(floating).body;
            body.setAttribute($61cd97d3d660dea1$var$safePolygonIdentifier, "");
            body.style.pointerEvents = "none";
            performedPointerEventsMutationRef.current = true;
            if ($61cd97d3d660dea1$var$isElement(domReference) && floating) {
                var _tree$nodesRef$curren, _tree$nodesRef$curren2;
                const ref = domReference;
                const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                ref.style.pointerEvents = "auto";
                floating.style.pointerEvents = "auto";
                return ()=>{
                    ref.style.pointerEvents = "";
                    floating.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        floating,
        domReference,
        tree,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $f2Y41.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            reference: {
                onPointerDown: setPointerRef,
                onPointerEnter: setPointerRef,
                onMouseMove (event) {
                    if (open || restMs === 0) return;
                    clearTimeout(restTimeoutRef.current);
                    restTimeoutRef.current = setTimeout(()=>{
                        if (!blockMouseMoveRef.current) onOpenChange(true, event.nativeEvent);
                    }, restMs);
                }
            },
            floating: {
                onMouseEnter () {
                    clearTimeout(timeoutRef.current);
                },
                onMouseLeave (event) {
                    events.emit("dismiss", {
                        type: "mouseLeave",
                        data: {
                            returnFocus: false
                        }
                    });
                    closeWithDelay(event.nativeEvent, false);
                }
            }
        };
    }, [
        events,
        enabled,
        restMs,
        open,
        onOpenChange,
        closeWithDelay
    ]);
}
const $61cd97d3d660dea1$var$FloatingDelayGroupContext = /*#__PURE__*/ $f2Y41.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: ()=>{},
    setState: ()=>{},
    isInstantPhase: false
});
const $61cd97d3d660dea1$export$e2411914b150383d = ()=>$f2Y41.useContext($61cd97d3d660dea1$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ const $61cd97d3d660dea1$export$718279509ff1e241 = (_ref)=>{
    let { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = _ref;
    const [state, setState] = $f2Y41.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $f2Y41.useRef(null);
    const setCurrentId = $f2Y41.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $61cd97d3d660dea1$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else setState({
                isInstantPhase: true
            });
        } else {
            setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId
    ]);
    return /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FloatingDelayGroupContext.Provider, {
        value: $f2Y41.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setState,
            setCurrentId
        ])
    }, children);
};
const $61cd97d3d660dea1$export$560fc8be89c8b4a8 = (_ref2, _ref3)=>{
    let { open: open, onOpenChange: onOpenChange } = _ref2;
    let { id: id } = _ref3;
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = $61cd97d3d660dea1$export$e2411914b150383d();
    $61cd97d3d660dea1$var$index(()=>{
        if (currentId) {
            setState({
                delay: {
                    open: 1,
                    close: $61cd97d3d660dea1$var$getDelay(initialDelay, "close")
                }
            });
            if (currentId !== id) onOpenChange(false);
        }
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            } else unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (open) setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
};
/**
 * Find the real active element. Traverses into shadowRoots.
 */ function $61cd97d3d660dea1$var$activeElement(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null){
        var _activeElement, _activeElement$shadow;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
let $61cd97d3d660dea1$var$rafId = 0;
function $61cd97d3d660dea1$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($61cd97d3d660dea1$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $61cd97d3d660dea1$var$rafId = requestAnimationFrame(exec);
}
function $61cd97d3d660dea1$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $61cd97d3d660dea1$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $61cd97d3d660dea1$var$getTarget(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $61cd97d3d660dea1$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $61cd97d3d660dea1$var$isTypeableElement(element) {
    return $61cd97d3d660dea1$var$isHTMLElement(element) && element.matches($61cd97d3d660dea1$var$TYPEABLE_SELECTOR);
}
function $61cd97d3d660dea1$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $61cd97d3d660dea1$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $61cd97d3d660dea1$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $b9b7d29ce522908f$export$17100aea90429aa7)(container, $61cd97d3d660dea1$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf($61cd97d3d660dea1$var$activeElement($61cd97d3d660dea1$var$getDocument(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $61cd97d3d660dea1$var$getNextTabbable() {
    return $61cd97d3d660dea1$var$getTabbableIn(document.body, "next");
}
function $61cd97d3d660dea1$var$getPreviousTabbable() {
    return $61cd97d3d660dea1$var$getTabbableIn(document.body, "prev");
}
function $61cd97d3d660dea1$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$61cd97d3d660dea1$var$contains(containerElement, relatedTarget);
}
function $61cd97d3d660dea1$var$disableFocusInside(container) {
    const tabbableElements = (0, $b9b7d29ce522908f$export$17100aea90429aa7)(container, $61cd97d3d660dea1$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $61cd97d3d660dea1$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $61cd97d3d660dea1$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $61cd97d3d660dea1$var$timeoutId;
function $61cd97d3d660dea1$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($61cd97d3d660dea1$var$timeoutId);
    }
}
const $61cd97d3d660dea1$var$FocusGuard = /*#__PURE__*/ $f2Y41.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $f2Y41.useState();
    $61cd97d3d660dea1$var$index(()=>{
        if ($61cd97d3d660dea1$var$isSafari()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $61cd97d3d660dea1$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $61cd97d3d660dea1$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$61cd97d3d660dea1$var$createAttribute("focus-guard")]: "",
        style: $61cd97d3d660dea1$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $f2Y41.createElement("span", $61cd97d3d660dea1$var$_extends({}, props, restProps));
});
const $61cd97d3d660dea1$var$PortalContext = /*#__PURE__*/ $f2Y41.createContext(null);
function $61cd97d3d660dea1$export$ac107512f3c5cca6(_temp) {
    let { id: id, root: root } = _temp === void 0 ? {} : _temp;
    const [portalNode, setPortalNode] = $f2Y41.useState(null);
    const uniqueId = $61cd97d3d660dea1$export$f680877a34711e37();
    const portalContext = $61cd97d3d660dea1$var$usePortalContext();
    const data = $f2Y41.useMemo(()=>({
            id: id,
            root: root,
            portalContext: portalContext,
            uniqueId: uniqueId
        }), [
        id,
        root,
        portalContext,
        uniqueId
    ]);
    const dataRef = $f2Y41.useRef();
    $61cd97d3d660dea1$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
        };
    }, [
        portalNode,
        data
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (dataRef.current === data) return;
        dataRef.current = data;
        const { id: id, root: root, portalContext: portalContext, uniqueId: uniqueId } = data;
        const existingIdRoot = id ? document.getElementById(id) : null;
        const attr = $61cd97d3d660dea1$var$createAttribute("portal");
        if (existingIdRoot) {
            const subRoot = document.createElement("div");
            subRoot.id = uniqueId;
            subRoot.setAttribute(attr, "");
            existingIdRoot.appendChild(subRoot);
            setPortalNode(subRoot);
        } else {
            let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
            if (container && !$61cd97d3d660dea1$var$isElement(container)) container = container.current;
            container = container || document.body;
            let idWrapper = null;
            if (id) {
                idWrapper = document.createElement("div");
                idWrapper.id = id;
                container.appendChild(idWrapper);
            }
            const subRoot = document.createElement("div");
            subRoot.id = uniqueId;
            subRoot.setAttribute(attr, "");
            container = idWrapper || container;
            container.appendChild(subRoot);
            setPortalNode(subRoot);
        }
    }, [
        data
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $61cd97d3d660dea1$export$31fa5d718fa2ac09(_ref) {
    let { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = _ref;
    const portalNode = $61cd97d3d660dea1$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $f2Y41.useState(null);
    const beforeOutsideRef = $f2Y41.useRef(null);
    const afterOutsideRef = $f2Y41.useRef(null);
    const beforeInsideRef = $f2Y41.useRef(null);
    const afterInsideRef = $f2Y41.useRef(null);
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $f2Y41.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $61cd97d3d660dea1$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $61cd97d3d660dea1$var$enableFocusInside : $61cd97d3d660dea1$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        focusManagerState == null ? void 0 : focusManagerState.modal
    ]);
    return /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$PortalContext.Provider, {
        value: $f2Y41.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($61cd97d3d660dea1$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $61cd97d3d660dea1$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $f2Y41.createElement("span", {
        "aria-owns": portalNode.id,
        style: $61cd97d3d660dea1$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ (0, $5021361ff788fb77$exports.createPortal)(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($61cd97d3d660dea1$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $61cd97d3d660dea1$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent));
            }
        }
    }));
}
const $61cd97d3d660dea1$var$usePortalContext = ()=>$f2Y41.useContext($61cd97d3d660dea1$var$PortalContext);
const $61cd97d3d660dea1$var$VisuallyHiddenDismiss = /*#__PURE__*/ $f2Y41.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $f2Y41.createElement("button", $61cd97d3d660dea1$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $61cd97d3d660dea1$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $61cd97d3d660dea1$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = (0, $c3578876bbfeac12$export$cc95fea82d705fca)() ? _guards : true;
    const orderRef = $61cd97d3d660dea1$var$useLatestRef(order);
    const initialFocusRef = $61cd97d3d660dea1$var$useLatestRef(initialFocus);
    const returnFocusRef = $61cd97d3d660dea1$var$useLatestRef(returnFocus);
    const tree = $61cd97d3d660dea1$export$db0c2a7c7a2a4f69();
    const portalContext = $61cd97d3d660dea1$var$usePortalContext();
    // Controlled by `useListNavigation`.
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    const startDismissButtonRef = $f2Y41.useRef(null);
    const endDismissButtonRef = $f2Y41.useRef(null);
    const preventReturnFocusRef = $f2Y41.useRef(false);
    const previouslyFocusedElementRef = $f2Y41.useRef(null);
    const isPointerDownRef = $f2Y41.useRef(false);
    const isInsidePortal = portalContext != null;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isTypeableCombobox = domReference && domReference.getAttribute("role") === "combobox" && $61cd97d3d660dea1$var$isTypeableElement(domReference);
    const getTabbableContent = $f2Y41.useCallback(function(container) {
        if (container === void 0) container = floating;
        return container ? (0, $b9b7d29ce522908f$export$17100aea90429aa7)(container, $61cd97d3d660dea1$var$getTabbableOptions()) : [];
    }, [
        floating
    ]);
    const getTabbableElements = $f2Y41.useCallback((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floating && type === "floating") return floating;
            return content;
        }).filter(Boolean).flat();
    }, [
        domReference,
        floating,
        orderRef,
        getTabbableContent
    ]);
    $f2Y41.useEffect(()=>{
        if (disabled || !modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ($61cd97d3d660dea1$var$contains(floating, $61cd97d3d660dea1$var$activeElement($61cd97d3d660dea1$var$getDocument(floating))) && getTabbableContent().length === 0 && !isTypeableCombobox) $61cd97d3d660dea1$var$stopEvent(event);
                const els = getTabbableElements();
                const target = $61cd97d3d660dea1$var$getTarget(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    $61cd97d3d660dea1$var$stopEvent(event);
                    if (event.shiftKey) $61cd97d3d660dea1$var$enqueueFocus(els[els.length - 1]);
                    else $61cd97d3d660dea1$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floating && event.shiftKey) {
                    $61cd97d3d660dea1$var$stopEvent(event);
                    $61cd97d3d660dea1$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = $61cd97d3d660dea1$var$getDocument(floating);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        refs,
        isTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $f2Y41.useEffect(()=>{
        if (disabled || !closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !($61cd97d3d660dea1$var$contains(domReference, relatedTarget) || $61cd97d3d660dea1$var$contains(floating, relatedTarget) || $61cd97d3d660dea1$var$contains(relatedTarget, floating) || $61cd97d3d660dea1$var$contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($61cd97d3d660dea1$var$createAttribute("focus-guard")) || tree && ($61cd97d3d660dea1$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return $61cd97d3d660dea1$var$contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || $61cd97d3d660dea1$var$contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $61cd97d3d660dea1$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== previouslyFocusedElementRef.current) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event);
                }
            });
        }
        if (floating && $61cd97d3d660dea1$var$isHTMLElement(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            !modal && floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                !modal && floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut
    ]);
    $f2Y41.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null ? void 0 : (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $61cd97d3d660dea1$var$createAttribute("portal") + "]")) || []);
        if (floating && modal) {
            const insideNodes = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current
            ].filter((x)=>x != null);
            const suppressorFn = guards ? (0, $c3578876bbfeac12$export$6e33d16126ed003c) : (0, $c3578876bbfeac12$export$9845d4b6bdad192b);
            const cleanup = suppressorFn(orderRef.current.includes("reference") || isTypeableCombobox ? insideNodes.concat(domReference || []) : insideNodes, undefined, $61cd97d3d660dea1$var$createAttribute("inert"));
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isTypeableCombobox,
        guards
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (disabled || !floating) return;
        const doc = $61cd97d3d660dea1$var$getDocument(floating);
        const previouslyFocusedElement = $61cd97d3d660dea1$var$activeElement(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floating);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
            const focusAlreadyInsideFloatingEl = $61cd97d3d660dea1$var$contains(floating, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $61cd97d3d660dea1$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floating
            });
        });
    }, [
        disabled,
        open,
        floating,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (disabled || !floating) return;
        let preventReturnFocusScroll = false;
        const doc = $61cd97d3d660dea1$var$getDocument(floating);
        const previouslyFocusedElement = $61cd97d3d660dea1$var$activeElement(doc);
        const contextData = dataRef.current;
        previouslyFocusedElementRef.current = previouslyFocusedElement;
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onDismiss(payload) {
            if (payload.type === "escapeKey" && refs.domReference.current) previouslyFocusedElementRef.current = refs.domReference.current;
            if ([
                "referencePress",
                "escapeKey"
            ].includes(payload.type)) return;
            const returnFocus = payload.data.returnFocus;
            if (typeof returnFocus === "object") {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = returnFocus.preventScroll;
            } else preventReturnFocusRef.current = !returnFocus;
        }
        events.on("dismiss", onDismiss);
        return ()=>{
            events.off("dismiss", onDismiss);
            const activeEl = $61cd97d3d660dea1$var$activeElement(doc);
            const shouldFocusReference = $61cd97d3d660dea1$var$contains(floating, activeEl) || tree && $61cd97d3d660dea1$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return $61cd97d3d660dea1$var$contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            }) || contextData.openEvent && [
                "click",
                "mousedown"
            ].includes(contextData.openEvent.type);
            if (shouldFocusReference && refs.domReference.current) previouslyFocusedElementRef.current = refs.domReference.current;
            if (// eslint-disable-next-line react-hooks/exhaustive-deps
            returnFocusRef.current && $61cd97d3d660dea1$var$isHTMLElement(previouslyFocusedElementRef.current) && !preventReturnFocusRef.current) $61cd97d3d660dea1$var$enqueueFocus(previouslyFocusedElementRef.current, {
                // When dismissing nested floating elements, by the time the rAF has
                // executed, the menus will all have been unmounted. When they try
                // to get focused, the calls get ignored — leaving the root
                // reference focused as desired.
                cancelPrevious: false,
                preventScroll: preventReturnFocusScroll
            });
        };
    }, [
        disabled,
        floating,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $61cd97d3d660dea1$var$index(()=>{
        if (disabled || !portalContext) return;
        portalContext.setFocusManagerState({
            ...context,
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        closeOnFocusOut,
        context
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (disabled) return;
        if (floating && typeof MutationObserver === "function") {
            const handleMutation = ()=>{
                const tabIndex = floating.getAttribute("tabindex");
                if (orderRef.current.includes("floating") || $61cd97d3d660dea1$var$activeElement($61cd97d3d660dea1$var$getDocument(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
                    if (tabIndex !== "0") floating.setAttribute("tabindex", "0");
                } else if (tabIndex !== "-1") floating.setAttribute("tabindex", "-1");
            };
            handleMutation();
            const observer = new MutationObserver(handleMutation);
            observer.observe(floating, {
                childList: true,
                subtree: true,
                attributes: true
            });
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        disabled,
        floating,
        refs,
        orderRef,
        getTabbableContent
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && !isTypeableCombobox && (isInsidePortal || modal);
    return /*#__PURE__*/ $f2Y41.createElement($f2Y41.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $61cd97d3d660dea1$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($61cd97d3d660dea1$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $61cd97d3d660dea1$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $61cd97d3d660dea1$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($61cd97d3d660dea1$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $61cd97d3d660dea1$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
function $61cd97d3d660dea1$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $61cd97d3d660dea1$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $61cd97d3d660dea1$var$FloatingListContext = /*#__PURE__*/ $f2Y41.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $61cd97d3d660dea1$export$ffe15b0e64951704(_ref) {
    let { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = _ref;
    const [map, setMap] = $f2Y41.useState(()=>new Map());
    const register = $f2Y41.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $f2Y41.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $61cd97d3d660dea1$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($61cd97d3d660dea1$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$61cd97d3d660dea1$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $f2Y41.createElement($61cd97d3d660dea1$var$FloatingListContext.Provider, {
        value: $f2Y41.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
function $61cd97d3d660dea1$export$dcdc7ff5149f7d1a(_temp) {
    let { label: label } = _temp === void 0 ? {} : _temp;
    const [index$1, setIndex] = $f2Y41.useState(null);
    const componentRef = $f2Y41.useRef(null);
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $f2Y41.useContext($61cd97d3d660dea1$var$FloatingListContext);
    const ref = $f2Y41.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $f2Y41.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
const $61cd97d3d660dea1$var$identifier = /*#__PURE__*/ $61cd97d3d660dea1$var$createAttribute("scroll-lock");
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $61cd97d3d660dea1$export$a35954495955337b = /*#__PURE__*/ $f2Y41.forwardRef(function FloatingOverlay(_ref, ref) {
    let { lockScroll: lockScroll = false, ...rest } = _ref;
    $61cd97d3d660dea1$var$index(()=>{
        var _window$visualViewpor, _window$visualViewpor2;
        if (!lockScroll) return;
        const alreadyLocked = document.body.hasAttribute($61cd97d3d660dea1$var$identifier);
        if (alreadyLocked) return;
        document.body.setAttribute($61cd97d3d660dea1$var$identifier, "");
        // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (!/iP(hone|ad|od)|iOS/.test($61cd97d3d660dea1$var$getPlatform())) {
            Object.assign(document.body.style, {
                overflow: "hidden",
                [paddingProp]: scrollbarWidth + "px"
            });
            return ()=>{
                document.body.removeAttribute($61cd97d3d660dea1$var$identifier);
                Object.assign(document.body.style, {
                    overflow: "",
                    [paddingProp]: ""
                });
            };
        }
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        const scrollX = window.pageXOffset;
        const scrollY = window.pageYOffset;
        Object.assign(document.body.style, {
            position: "fixed",
            overflow: "hidden",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0",
            [paddingProp]: scrollbarWidth + "px"
        });
        return ()=>{
            Object.assign(document.body.style, {
                position: "",
                overflow: "",
                top: "",
                left: "",
                right: "",
                [paddingProp]: ""
            });
            document.body.removeAttribute($61cd97d3d660dea1$var$identifier);
            window.scrollTo(scrollX, scrollY);
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $f2Y41.createElement("div", $61cd97d3d660dea1$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $61cd97d3d660dea1$var$isButtonTarget(event) {
    return $61cd97d3d660dea1$var$isHTMLElement(event.target) && event.target.tagName === "BUTTON";
}
function $61cd97d3d660dea1$var$isSpaceIgnored(element) {
    return $61cd97d3d660dea1$var$isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $61cd97d3d660dea1$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $f2Y41.useRef();
    const didKeyDownRef = $f2Y41.useRef(false);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    pointerTypeRef.current = event.pointerType;
                },
                onMouseDown (event) {
                    // Ignore all buttons except for the "main" button.
                    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                    if (event.button !== 0) return;
                    if ($61cd97d3d660dea1$var$isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (eventOption === "click") return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent);
                    else {
                        // Prevent stealing focus from the floating element
                        event.preventDefault();
                        onOpenChange(true, event.nativeEvent);
                    }
                },
                onClick (event) {
                    if (eventOption === "mousedown" && pointerTypeRef.current) {
                        pointerTypeRef.current = undefined;
                        return;
                    }
                    if ($61cd97d3d660dea1$var$isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent);
                    else onOpenChange(true, event.nativeEvent);
                },
                onKeyDown (event) {
                    pointerTypeRef.current = undefined;
                    if (event.defaultPrevented || !keyboardHandlers || $61cd97d3d660dea1$var$isButtonTarget(event)) return;
                    if (event.key === " " && !$61cd97d3d660dea1$var$isSpaceIgnored(domReference)) {
                        // Prevent scrolling
                        event.preventDefault();
                        didKeyDownRef.current = true;
                    }
                    if (event.key === "Enter") {
                        if (open && toggle) onOpenChange(false, event.nativeEvent);
                        else onOpenChange(true, event.nativeEvent);
                    }
                },
                onKeyUp (event) {
                    if (event.defaultPrevented || !keyboardHandlers || $61cd97d3d660dea1$var$isButtonTarget(event) || $61cd97d3d660dea1$var$isSpaceIgnored(domReference)) return;
                    if (event.key === " " && didKeyDownRef.current) {
                        didKeyDownRef.current = false;
                        if (open && toggle) onOpenChange(false, event.nativeEvent);
                        else onOpenChange(true, event.nativeEvent);
                    }
                }
            }
        };
    }, [
        enabled,
        dataRef,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        domReference,
        toggle,
        open,
        onOpenChange
    ]);
}
// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const $61cd97d3d660dea1$var$useInsertionEffect = $f2Y41[/*#__PURE__*/ "useInsertionEffect".toString()];
const $61cd97d3d660dea1$var$useSafeInsertionEffect = $61cd97d3d660dea1$var$useInsertionEffect || ((fn)=>fn());
function $61cd97d3d660dea1$var$useEffectEvent(callback) {
    const ref = $f2Y41.useRef(()=>{});
    $61cd97d3d660dea1$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $f2Y41.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $61cd97d3d660dea1$var$createVirtualElement(domRef, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domRef.current || undefined,
        getBoundingClientRect () {
            var _domRef$current, _data$dataRef$current;
            const domRect = ((_domRef$current = domRef.current) == null ? void 0 : _domRef$current.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $61cd97d3d660dea1$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $61cd97d3d660dea1$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, refs: refs, dataRef: dataRef, elements: { floating: floating } } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $f2Y41.useRef(false);
    const cleanupListenerRef = $f2Y41.useRef(null);
    const [pointerType, setPointerType] = $f2Y41.useState();
    const [reactive, setReactive] = $f2Y41.useState([]);
    const setReference = $61cd97d3d660dea1$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$61cd97d3d660dea1$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($61cd97d3d660dea1$var$createVirtualElement(refs.domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $61cd97d3d660dea1$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = $61cd97d3d660dea1$var$isMouseLikePointerType(pointerType) ? floating : open;
    const addListener = $f2Y41.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = $61cd97d3d660dea1$var$getWindow(refs.floating.current);
        function handleMouseMove(event) {
            const target = $61cd97d3d660dea1$var$getTarget(event);
            if (!$61cd97d3d660dea1$var$contains(refs.floating.current, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $61cd97d3d660dea1$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(refs.domReference.current);
    }, [
        dataRef,
        enabled,
        openCheck,
        refs,
        setReference,
        x,
        y
    ]);
    $f2Y41.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $f2Y41.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $f2Y41.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            reference: {
                onPointerDown: setPointerTypeRef,
                onPointerEnter: setPointerTypeRef,
                onMouseMove: handleReferenceEnterOrMove,
                onMouseEnter: handleReferenceEnterOrMove
            }
        };
    }, [
        enabled,
        handleReferenceEnterOrMove
    ]);
}
/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */ function $61cd97d3d660dea1$var$isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
const $61cd97d3d660dea1$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $61cd97d3d660dea1$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $61cd97d3d660dea1$var$normalizeBubblesProp = (bubbles)=>{
    var _bubbles$escapeKey, _bubbles$outsidePress;
    return {
        escapeKeyBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$escapeKey = bubbles == null ? void 0 : bubbles.escapeKey) != null ? _bubbles$escapeKey : false,
        outsidePressBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$outsidePress = bubbles == null ? void 0 : bubbles.outsidePress) != null ? _bubbles$outsidePress : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $61cd97d3d660dea1$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, nodeId: nodeId, elements: { reference: reference, domReference: domReference, floating: floating }, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles } = props;
    const tree = $61cd97d3d660dea1$export$db0c2a7c7a2a4f69();
    const nested = $61cd97d3d660dea1$export$165209eae06d3488() != null;
    const outsidePressFn = $61cd97d3d660dea1$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $f2Y41.useRef(false);
    const { escapeKeyBubbles: escapeKeyBubbles, outsidePressBubbles: outsidePressBubbles } = $61cd97d3d660dea1$var$normalizeBubblesProp(bubbles);
    const closeOnEscapeKeyDown = $61cd97d3d660dea1$var$useEffectEvent((event)=>{
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        const children = tree ? $61cd97d3d660dea1$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        events.emit("dismiss", {
            type: "escapeKey",
            data: {
                returnFocus: {
                    preventScroll: false
                }
            }
        });
        onOpenChange(false, $61cd97d3d660dea1$var$isReactEvent(event) ? event.nativeEvent : event);
    });
    const closeOnPressOutside = $61cd97d3d660dea1$var$useEffectEvent((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = $61cd97d3d660dea1$var$getTarget(event);
        // Check if the click occurred on the scrollbar
        if ($61cd97d3d660dea1$var$isHTMLElement(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = $61cd97d3d660dea1$var$getWindow(floating).getComputedStyle(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const targetIsInsideChildren = tree && $61cd97d3d660dea1$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return $61cd97d3d660dea1$var$isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ($61cd97d3d660dea1$var$isEventTargetWithin(event, floating) || $61cd97d3d660dea1$var$isEventTargetWithin(event, domReference) || targetIsInsideChildren) return;
        const children = tree ? $61cd97d3d660dea1$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        events.emit("dismiss", {
            type: "outsidePress",
            data: {
                returnFocus: nested ? {
                    preventScroll: true
                } : $61cd97d3d660dea1$var$isVirtualClick(event) || $61cd97d3d660dea1$var$isVirtualPointerEvent(event)
            }
        });
        onOpenChange(false, event);
    });
    $f2Y41.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event);
        }
        const doc = $61cd97d3d660dea1$var$getDocument(floating);
        escapeKey && doc.addEventListener("keydown", closeOnEscapeKeyDown);
        outsidePress && doc.addEventListener(outsidePressEvent, closeOnPressOutside);
        let ancestors = [];
        if (ancestorScroll) {
            if ($61cd97d3d660dea1$var$isElement(domReference)) ancestors = (0, $865db79e060f8dc3$export$3b57c1601291186b)(domReference);
            if ($61cd97d3d660dea1$var$isElement(floating)) ancestors = ancestors.concat((0, $865db79e060f8dc3$export$3b57c1601291186b)(floating));
            if (!$61cd97d3d660dea1$var$isElement(reference) && reference && reference.contextElement) ancestors = ancestors.concat((0, $865db79e060f8dc3$export$3b57c1601291186b)(reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener("keydown", closeOnEscapeKeyDown);
            outsidePress && doc.removeEventListener(outsidePressEvent, closeOnPressOutside);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
        };
    }, [
        dataRef,
        floating,
        domReference,
        reference,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        closeOnPressOutside
    ]);
    $f2Y41.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onKeyDown: closeOnEscapeKeyDown,
                [$61cd97d3d660dea1$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    if (referencePress) {
                        events.emit("dismiss", {
                            type: "referencePress",
                            data: {
                                returnFocus: false
                            }
                        });
                        onOpenChange(false, event.nativeEvent);
                    }
                }
            },
            floating: {
                onKeyDown: closeOnEscapeKeyDown,
                [$61cd97d3d660dea1$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                    insideReactTreeRef.current = true;
                }
            }
        };
    }, [
        enabled,
        events,
        referencePress,
        outsidePressEvent,
        referencePressEvent,
        onOpenChange,
        closeOnEscapeKeyDown
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */ function $61cd97d3d660dea1$export$4e02a5c1d08bac65(options) {
    var _options$elements;
    if (options === void 0) options = {};
    const { open: open = false, onOpenChange: unstable_onOpenChange, nodeId: nodeId } = options;
    const [_domReference, setDomReference] = $f2Y41.useState(null);
    const domReference = ((_options$elements = options.elements) == null ? void 0 : _options$elements.reference) || _domReference;
    const position = (0, $2adec4136592c363$export$4e02a5c1d08bac65)(options);
    const tree = $61cd97d3d660dea1$export$db0c2a7c7a2a4f69();
    const onOpenChange = $61cd97d3d660dea1$var$useEffectEvent((open, event)=>{
        if (open) dataRef.current.openEvent = event;
        unstable_onOpenChange == null || unstable_onOpenChange(open, event);
    });
    const domReferenceRef = $f2Y41.useRef(null);
    const dataRef = $f2Y41.useRef({});
    const events = $f2Y41.useState(()=>$61cd97d3d660dea1$var$createPubSub())[0];
    const floatingId = $61cd97d3d660dea1$export$f680877a34711e37();
    const setPositionReference = $f2Y41.useCallback((node)=>{
        const positionReference = $61cd97d3d660dea1$var$isElement(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        position.refs.setReference(positionReference);
    }, [
        position.refs
    ]);
    const setReference = $f2Y41.useCallback((node)=>{
        if ($61cd97d3d660dea1$var$isElement(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ($61cd97d3d660dea1$var$isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !$61cd97d3d660dea1$var$isElement(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $f2Y41.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $f2Y41.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $f2Y41.useMemo(()=>({
            ...position,
            refs: refs,
            elements: elements,
            dataRef: dataRef,
            nodeId: nodeId,
            floatingId: floatingId,
            events: events,
            open: open,
            onOpenChange: onOpenChange
        }), [
        position,
        nodeId,
        floatingId,
        events,
        open,
        onOpenChange,
        refs,
        elements
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $f2Y41.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $61cd97d3d660dea1$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, refs: refs, elements: { floating: floating, domReference: domReference } } = context;
    const { enabled: enabled = true, keyboardOnly: keyboardOnly = true } = props;
    const pointerTypeRef = $f2Y41.useRef("");
    const blockFocusRef = $f2Y41.useRef(false);
    const timeoutRef = $f2Y41.useRef();
    $f2Y41.useEffect(()=>{
        if (!enabled) return;
        const doc = $61cd97d3d660dea1$var$getDocument(floating);
        const win = doc.defaultView || window;
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && $61cd97d3d660dea1$var$isHTMLElement(domReference) && domReference === $61cd97d3d660dea1$var$activeElement($61cd97d3d660dea1$var$getDocument(domReference))) blockFocusRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        return ()=>{
            win.removeEventListener("blur", onBlur);
        };
    }, [
        floating,
        domReference,
        open,
        enabled
    ]);
    $f2Y41.useEffect(()=>{
        if (!enabled) return;
        function onDismiss(payload) {
            if (payload.type === "referencePress" || payload.type === "escapeKey") blockFocusRef.current = true;
        }
        events.on("dismiss", onDismiss);
        return ()=>{
            events.off("dismiss", onDismiss);
        };
    }, [
        events,
        enabled
    ]);
    $f2Y41.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (_ref) {
                    let { pointerType: pointerType } = _ref;
                    pointerTypeRef.current = pointerType;
                    blockFocusRef.current = !!(pointerType && keyboardOnly);
                },
                onMouseLeave () {
                    blockFocusRef.current = false;
                },
                onFocus (event) {
                    var _dataRef$current$open;
                    if (blockFocusRef.current) return;
                    // Dismiss with click should ignore the subsequent `focus` trigger,
                    // but only if the click originated inside the reference element.
                    if (event.type === "focus" && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === "mousedown" && $61cd97d3d660dea1$var$isEventTargetWithin(dataRef.current.openEvent, domReference)) return;
                    onOpenChange(true, event.nativeEvent);
                },
                onBlur (event) {
                    blockFocusRef.current = false;
                    const relatedTarget = event.relatedTarget;
                    // Hit the non-modal focus management portal guard. Focus will be
                    // moved into the floating element immediately after.
                    const movedToFocusGuard = $61cd97d3d660dea1$var$isElement(relatedTarget) && relatedTarget.hasAttribute($61cd97d3d660dea1$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                    // Wait for the window blur listener to fire.
                    timeoutRef.current = setTimeout(()=>{
                        // When focusing the reference element (e.g. regular click), then
                        // clicking into the floating element, prevent it from hiding.
                        // Note: it must be focusable, e.g. `tabindex="-1"`.
                        if ($61cd97d3d660dea1$var$contains(refs.floating.current, relatedTarget) || $61cd97d3d660dea1$var$contains(domReference, relatedTarget) || movedToFocusGuard) return;
                        onOpenChange(false, event.nativeEvent);
                    });
                }
            }
        };
    }, [
        enabled,
        keyboardOnly,
        domReference,
        refs,
        dataRef,
        onOpenChange
    ]);
}
function $61cd97d3d660dea1$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    return {
        ...elementKey === "floating" && {
            tabIndex: -1
        },
        ...userProps,
        ...propsList.map((value)=>value ? value[elementKey] : null).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/react#interaction-hooks
 */ function $61cd97d3d660dea1$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    // The dependencies are a dynamic array, so we can't use the linter's
    // suggestion to add it to the deps array.
    const deps = propsList;
    const getReferenceProps = $f2Y41.useCallback((userProps)=>$61cd97d3d660dea1$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getFloatingProps = $f2Y41.useCallback((userProps)=>$61cd97d3d660dea1$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getItemProps = $f2Y41.useCallback((userProps)=>$61cd97d3d660dea1$var$mergeProps(userProps, propsList, "item"), // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key)=>key == null ? void 0 : key.item));
    return $f2Y41.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $61cd97d3d660dea1$var$isPreventScrollSupported = false;
const $61cd97d3d660dea1$var$ARROW_UP = "ArrowUp";
const $61cd97d3d660dea1$var$ARROW_DOWN = "ArrowDown";
const $61cd97d3d660dea1$var$ARROW_LEFT = "ArrowLeft";
const $61cd97d3d660dea1$var$ARROW_RIGHT = "ArrowRight";
function $61cd97d3d660dea1$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $61cd97d3d660dea1$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do {
        var _list$index, _list$index2;
        index = index + (decrement ? -amount : amount);
    }while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute("disabled")) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute("aria-disabled")) === "true"));
    return index;
}
function $61cd97d3d660dea1$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $61cd97d3d660dea1$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $61cd97d3d660dea1$var$ARROW_UP || key === $61cd97d3d660dea1$var$ARROW_DOWN;
    const horizontal = key === $61cd97d3d660dea1$var$ARROW_LEFT || key === $61cd97d3d660dea1$var$ARROW_RIGHT;
    return $61cd97d3d660dea1$var$doSwitch(orientation, vertical, horizontal);
}
function $61cd97d3d660dea1$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $61cd97d3d660dea1$var$ARROW_DOWN;
    const horizontal = rtl ? key === $61cd97d3d660dea1$var$ARROW_LEFT : key === $61cd97d3d660dea1$var$ARROW_RIGHT;
    return $61cd97d3d660dea1$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key == " " || key === "";
}
function $61cd97d3d660dea1$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $61cd97d3d660dea1$var$ARROW_LEFT : key === $61cd97d3d660dea1$var$ARROW_RIGHT;
    const horizontal = key === $61cd97d3d660dea1$var$ARROW_DOWN;
    return $61cd97d3d660dea1$var$doSwitch(orientation, vertical, horizontal);
}
function $61cd97d3d660dea1$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $61cd97d3d660dea1$var$ARROW_RIGHT : key === $61cd97d3d660dea1$var$ARROW_LEFT;
    const horizontal = key === $61cd97d3d660dea1$var$ARROW_UP;
    return $61cd97d3d660dea1$var$doSwitch(orientation, vertical, horizontal);
}
function $61cd97d3d660dea1$var$getMinIndex(listRef, disabledIndices) {
    return $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $61cd97d3d660dea1$var$getMaxIndex(listRef, disabledIndices) {
    return $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $61cd97d3d660dea1$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, refs: refs, elements: { domReference: domReference, floating: floating } } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true } = props;
    const parentId = $61cd97d3d660dea1$export$165209eae06d3488();
    const tree = $61cd97d3d660dea1$export$db0c2a7c7a2a4f69();
    const onNavigate = $61cd97d3d660dea1$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $f2Y41.useRef(focusItemOnOpen);
    const indexRef = $f2Y41.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $f2Y41.useRef(null);
    const isPointerModalityRef = $f2Y41.useRef(true);
    const previousOnNavigateRef = $f2Y41.useRef(onNavigate);
    const previousMountedRef = $f2Y41.useRef(!!floating);
    const forceSyncFocus = $f2Y41.useRef(false);
    const forceScrollIntoViewRef = $f2Y41.useRef(false);
    const disabledIndicesRef = $61cd97d3d660dea1$var$useLatestRef(disabledIndices);
    const latestOpenRef = $61cd97d3d660dea1$var$useLatestRef(open);
    const scrollItemIntoViewRef = $61cd97d3d660dea1$var$useLatestRef(scrollItemIntoView);
    const [activeId, setActiveId] = $f2Y41.useState();
    const focusItem = $61cd97d3d660dea1$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        const item = listRef.current[indexRef.current];
        if (!item) return;
        if (virtual) setActiveId(item.id);
        else $61cd97d3d660dea1$var$enqueueFocus(item, {
            preventScroll: true,
            // Mac Safari does not move the virtual cursor unless the focus call
            // is sync. However, for the very first focus call, we need to wait
            // for the position to be ready in order to prevent unwanted
            // scrolling. This means the virtual cursor will not move to the first
            // item when first opening the floating element, but will on
            // subsequent calls. `preventScroll` is supported in modern Safari,
            // so we can use that instead.
            // iOS Safari must be async or the first item will not be focused.
            sync: $61cd97d3d660dea1$var$isMac() && $61cd97d3d660dea1$var$isSafari() ? $61cd97d3d660dea1$var$isPreventScrollSupported || forceSyncFocus.current : false
        });
        requestAnimationFrame(()=>{
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $61cd97d3d660dea1$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $61cd97d3d660dea1$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $61cd97d3d660dea1$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $61cd97d3d660dea1$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndex != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $61cd97d3d660dea1$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $61cd97d3d660dea1$var$getMinIndex(listRef, disabledIndicesRef.current) : $61cd97d3d660dea1$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$61cd97d3d660dea1$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        floating,
        activeIndex,
        selectedIndex,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $61cd97d3d660dea1$var$index(()=>{
        if (!enabled) return;
        if (previousMountedRef.current && !floating && tree) {
            var _nodes$find, _nodes$find$context;
            const nodes = tree.nodesRef.current;
            const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null ? void 0 : (_nodes$find$context = _nodes$find.context) == null ? void 0 : _nodes$find$context.elements.floating;
            const activeEl = $61cd97d3d660dea1$var$activeElement($61cd97d3d660dea1$var$getDocument(floating));
            const treeContainsActiveEl = nodes.some((node)=>node.context && $61cd97d3d660dea1$var$contains(node.context.elements.floating, activeEl));
            if (parent && !treeContainsActiveEl) parent.focus({
                preventScroll: true
            });
        }
    }, [
        enabled,
        floating,
        tree,
        parentId
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!floating;
    });
    $61cd97d3d660dea1$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $f2Y41.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $61cd97d3d660dea1$var$enqueueFocus(refs.floating.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        refs,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        const disabledIndices = disabledIndicesRef.current;
        function onKeyDown(event) {
            isPointerModalityRef.current = false;
            forceSyncFocus.current = true;
            // If the floating element is animating out, ignore navigation. Otherwise,
            // the `activeIndex` gets set to 0 despite not being open so the next time
            // the user ArrowDowns, the first item won't be focused.
            if (!latestOpenRef.current && event.currentTarget === refs.floating.current) return;
            if (nested && $61cd97d3d660dea1$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
                $61cd97d3d660dea1$var$stopEvent(event);
                onOpenChange(false, event.nativeEvent);
                if ($61cd97d3d660dea1$var$isHTMLElement(domReference)) domReference.focus();
                return;
            }
            const currentIndex = indexRef.current;
            const minIndex = $61cd97d3d660dea1$var$getMinIndex(listRef, disabledIndices);
            const maxIndex = $61cd97d3d660dea1$var$getMaxIndex(listRef, disabledIndices);
            if (event.key === "Home") {
                $61cd97d3d660dea1$var$stopEvent(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === "End") {
                $61cd97d3d660dea1$var$stopEvent(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
            // Grid navigation.
            if (cols > 1) {
                const prevIndex = indexRef.current;
                if (event.key === $61cd97d3d660dea1$var$ARROW_UP) {
                    $61cd97d3d660dea1$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = maxIndex;
                    else {
                        indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
                            const col = prevIndex % cols;
                            const maxCol = maxIndex % cols;
                            const offset = maxIndex - (maxCol - col);
                            if (maxCol === col) indexRef.current = maxIndex;
                            else indexRef.current = maxCol > col ? offset : offset - cols;
                        }
                    }
                    if ($61cd97d3d660dea1$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                if (event.key === $61cd97d3d660dea1$var$ARROW_DOWN) {
                    $61cd97d3d660dea1$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = minIndex;
                    else {
                        indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                        if (loop && prevIndex + cols > maxIndex) indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex % cols - cols,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                    }
                    if ($61cd97d3d660dea1$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                // Remains on the same row/column.
                if (orientation === "both") {
                    const prevRow = Math.floor(prevIndex / cols);
                    if (event.key === $61cd97d3d660dea1$var$ARROW_RIGHT) {
                        $61cd97d3d660dea1$var$stopEvent(event);
                        if (prevIndex % cols !== cols - 1) {
                            indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices
                            });
                            if (loop && $61cd97d3d660dea1$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex - prevIndex % cols - 1,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        if ($61cd97d3d660dea1$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    if (event.key === $61cd97d3d660dea1$var$ARROW_LEFT) {
                        $61cd97d3d660dea1$var$stopEvent(event);
                        if (prevIndex % cols !== 0) {
                            indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices,
                                decrement: true
                            });
                            if (loop && $61cd97d3d660dea1$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex + (cols - prevIndex % cols),
                                decrement: true,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex + (cols - prevIndex % cols),
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if ($61cd97d3d660dea1$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    const lastRow = Math.floor(maxIndex / cols) === prevRow;
                    if ($61cd97d3d660dea1$var$isIndexOutOfBounds(listRef, indexRef.current)) {
                        if (loop && lastRow) indexRef.current = event.key === $61cd97d3d660dea1$var$ARROW_LEFT ? maxIndex : $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        else indexRef.current = prevIndex;
                    }
                    onNavigate(indexRef.current);
                    return;
                }
            }
            if ($61cd97d3d660dea1$var$isMainOrientationKey(event.key, orientation)) {
                $61cd97d3d660dea1$var$stopEvent(event);
                // Reset the index if no item is focused.
                if (open && !virtual && $61cd97d3d660dea1$var$activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
                    indexRef.current = $61cd97d3d660dea1$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                    onNavigate(indexRef.current);
                    return;
                }
                if ($61cd97d3d660dea1$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                    if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else indexRef.current = Math.min(maxIndex, $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    }));
                } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.max(minIndex, $61cd97d3d660dea1$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                }));
                if ($61cd97d3d660dea1$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
                else onNavigate(indexRef.current);
            }
        }
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && $61cd97d3d660dea1$var$isVirtualClick(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && $61cd97d3d660dea1$var$isVirtualPointerEvent(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
            "aria-activedescendant": activeId
        };
        return {
            reference: {
                ...ariaActiveDescendantProp,
                onKeyDown (event) {
                    isPointerModalityRef.current = false;
                    const isArrowKey = event.key.indexOf("Arrow") === 0;
                    if (virtual && open) return onKeyDown(event);
                    // If a floating element should not open on arrow key down, avoid
                    // setting `activeIndex` while it's closed.
                    if (!open && !openOnArrowKeyDown && isArrowKey) return;
                    const isNavigationKey = isArrowKey || event.key === "Enter" || event.key.trim() === "";
                    const isMainKey = $61cd97d3d660dea1$var$isMainOrientationKey(event.key, orientation);
                    const isCrossKey = $61cd97d3d660dea1$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                    if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                    if (nested) {
                        if (isCrossKey) {
                            $61cd97d3d660dea1$var$stopEvent(event);
                            if (open) {
                                indexRef.current = $61cd97d3d660dea1$var$getMinIndex(listRef, disabledIndices);
                                onNavigate(indexRef.current);
                            } else onOpenChange(true, event.nativeEvent);
                        }
                        return;
                    }
                    if (isMainKey) {
                        if (selectedIndex != null) indexRef.current = selectedIndex;
                        $61cd97d3d660dea1$var$stopEvent(event);
                        if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent);
                        else onKeyDown(event);
                        if (open) onNavigate(indexRef.current);
                    }
                },
                onFocus () {
                    if (open) onNavigate(null);
                },
                onPointerDown: checkVirtualPointer,
                onMouseDown: checkVirtualMouse,
                onClick: checkVirtualMouse
            },
            floating: {
                "aria-orientation": orientation === "both" ? undefined : orientation,
                ...ariaActiveDescendantProp,
                onKeyDown: onKeyDown,
                onPointerMove () {
                    isPointerModalityRef.current = true;
                }
            },
            item: item
        };
    }, [
        domReference,
        refs,
        activeId,
        disabledIndicesRef,
        latestOpenRef,
        listRef,
        enabled,
        orientation,
        rtl,
        virtual,
        open,
        hasActiveIndex,
        nested,
        selectedIndex,
        openOnArrowKeyDown,
        allowEscape,
        cols,
        loop,
        focusItemOnOpen,
        onNavigate,
        onOpenChange,
        item
    ]);
}
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/useMergeRefs
 */ function $61cd97d3d660dea1$export$74665b213cb5c4cf(refs) {
    return $f2Y41.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $61cd97d3d660dea1$export$f66572793fa256a1(context, props) {
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const referenceId = $61cd97d3d660dea1$export$f680877a34711e37();
    return $f2Y41.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            role: role
        };
        if (!enabled) return {};
        if (role === "tooltip") return {
            reference: {
                "aria-describedby": open ? floatingId : undefined
            },
            floating: floatingProps
        };
        return {
            reference: {
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": role === "alertdialog" ? "dialog" : role,
                "aria-controls": open ? floatingId : undefined,
                ...role === "listbox" && {
                    role: "combobox"
                },
                ...role === "menu" && {
                    id: referenceId
                }
            },
            floating: {
                ...floatingProps,
                ...role === "menu" && {
                    "aria-labelledby": referenceId
                }
            }
        };
    }, [
        enabled,
        role,
        open,
        floatingId,
        referenceId
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $61cd97d3d660dea1$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $61cd97d3d660dea1$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $61cd97d3d660dea1$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $f2Y41.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $f2Y41.useEffect(()=>{
        if (!open) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $61cd97d3d660dea1$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [initiated, setInitiated] = $f2Y41.useState(false);
    const [status, setStatus] = $f2Y41.useState("unmounted");
    const isMounted = $61cd97d3d660dea1$var$useDelayUnmount(open, closeDuration);
    // `initiated` check prevents this `setState` call from breaking
    // <FloatingPortal />. This call is necessary to ensure subsequent opens
    // after the initial one allows the correct side animation to play when the
    // placement has changed.
    $61cd97d3d660dea1$var$index(()=>{
        if (initiated && !isMounted) setStatus("unmounted");
    }, [
        initiated,
        isMounted
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        } else {
            setInitiated(true);
            setStatus("close");
        }
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $61cd97d3d660dea1$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $f2Y41.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $f2Y41.useState(()=>({
            ...$61cd97d3d660dea1$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$61cd97d3d660dea1$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $61cd97d3d660dea1$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $61cd97d3d660dea1$var$useLatestRef(unstable_initial);
    const openRef = $61cd97d3d660dea1$var$useLatestRef(unstable_open);
    const closeRef = $61cd97d3d660dea1$var$useLatestRef(unstable_close);
    const commonRef = $61cd97d3d660dea1$var$useLatestRef(unstable_common);
    $61cd97d3d660dea1$var$index(()=>{
        const initialStyles = $61cd97d3d660dea1$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $61cd97d3d660dea1$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $61cd97d3d660dea1$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $61cd97d3d660dea1$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($61cd97d3d660dea1$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($61cd97d3d660dea1$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $61cd97d3d660dea1$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $f2Y41.useRef();
    const stringRef = $f2Y41.useRef("");
    const prevIndexRef = $f2Y41.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $f2Y41.useRef(null);
    const onMatch = $61cd97d3d660dea1$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $61cd97d3d660dea1$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $61cd97d3d660dea1$var$useLatestRef(findMatch);
    const ignoreKeysRef = $61cd97d3d660dea1$var$useLatestRef(ignoreKeys);
    $61cd97d3d660dea1$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $61cd97d3d660dea1$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        function setTypingChange(value) {
            if (value) {
                if (!dataRef.current.typing) {
                    dataRef.current.typing = value;
                    onTypingChange(value);
                }
            } else if (dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        }
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        function onKeyDown(event) {
            const listContent = listRef.current;
            if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
                if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
                else if (event.key === " ") $61cd97d3d660dea1$var$stopEvent(event);
            }
            if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
            event.key.length !== 1 || // Modifier key.
            event.ctrlKey || event.metaKey || event.altKey) return;
            if (open && event.key !== " ") {
                $61cd97d3d660dea1$var$stopEvent(event);
                setTypingChange(true);
            }
            // Bail out if the list contains a word like "llama" or "aaron". TODO:
            // allow it in this case, too.
            const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
                var _text$, _text$2;
                return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
            });
            // Allows the user to cycle through items that start with the same letter
            // in rapid succession.
            if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
                stringRef.current = "";
                prevIndexRef.current = matchIndexRef.current;
            }
            stringRef.current += event.key;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(()=>{
                stringRef.current = "";
                prevIndexRef.current = matchIndexRef.current;
                setTypingChange(false);
            }, resetMs);
            const prevIndex = prevIndexRef.current;
            const index = getMatchingIndex(listContent, [
                ...listContent.slice((prevIndex || 0) + 1),
                ...listContent.slice(0, (prevIndex || 0) + 1)
            ], stringRef.current);
            if (index !== -1) {
                onMatch(index);
                matchIndexRef.current = index;
            } else if (event.key !== " ") {
                stringRef.current = "";
                setTypingChange(false);
            }
        }
        return {
            reference: {
                onKeyDown: onKeyDown
            },
            floating: {
                onKeyDown: onKeyDown,
                onKeyUp (event) {
                    if (event.key === " ") setTypingChange(false);
                }
            }
        };
    }, [
        enabled,
        open,
        dataRef,
        listRef,
        resetMs,
        ignoreKeysRef,
        findMatchRef,
        onMatch,
        onTypingChange
    ]);
}
function $61cd97d3d660dea1$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $61cd97d3d660dea1$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = props;
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $022d15fe75fec75f$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            const overflow = await (0, $022d15fe75fec75f$export$37b6bde19b108ecc)($61cd97d3d660dea1$var$getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            const refOverflow = await (0, $022d15fe75fec75f$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
            el.style.maxHeight = maxHeight + "px";
            el.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) (0, $5021361ff788fb77$exports.flushSync)(()=>onFallbackChange(true));
                else (0, $5021361ff788fb77$exports.flushSync)(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $022d15fe75fec75f$export$37b6bde19b108ecc)($61cd97d3d660dea1$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, el.offsetHeight), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $61cd97d3d660dea1$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $61cd97d3d660dea1$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $f2Y41.useRef(false);
    const prevScrollTopRef = $f2Y41.useRef(null);
    const initialOverflowRef = $f2Y41.useRef(null);
    $f2Y41.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                (0, $5021361ff788fb77$exports.flushSync)(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test($61cd97d3d660dea1$var$getUserAgent())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    return $f2Y41.useMemo(()=>{
        if (!enabled) return {};
        return {
            floating: {
                onKeyDown () {
                    controlledScrollingRef.current = true;
                },
                onWheel () {
                    controlledScrollingRef.current = false;
                },
                onPointerMove () {
                    controlledScrollingRef.current = false;
                },
                onScroll () {
                    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                    if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                    if (prevScrollTopRef.current !== null) {
                        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) (0, $5021361ff788fb77$exports.flushSync)(()=>onChange((d)=>d + scrollDiff));
                    }
                    // [Firefox] Wait for the height change to have been applied.
                    requestAnimationFrame(()=>{
                        prevScrollTopRef.current = el.scrollTop;
                    });
                }
            }
        };
    }, [
        enabled,
        overflowRef,
        elements.floating,
        scrollRef,
        onChange
    ]);
}
function $61cd97d3d660dea1$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $61cd97d3d660dea1$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safePolygon
 */ function $61cd97d3d660dea1$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $61cd97d3d660dea1$var$getTarget(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = $61cd97d3d660dea1$var$contains(elements.floating, target);
            const isOverReferenceEl = $61cd97d3d660dea1$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $61cd97d3d660dea1$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && $61cd97d3d660dea1$var$isElement(event.relatedTarget) && $61cd97d3d660dea1$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $61cd97d3d660dea1$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($61cd97d3d660dea1$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            else if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$61cd97d3d660dea1$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");


const $fe56980464f0d899$export$c713454b46b9927 = ({ className: className, ...props })=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.dropdown.floating.divider;
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
        ...props
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $2fa52006e8da0778$export$19b44e77c853705e = ({ children: children, className: className, ...props })=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.dropdown.floating.header;
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            (0, $ge3KO.jsx)("div", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
                ...props,
                children: children
            }),
            (0, $ge3KO.jsx)((0, $fe56980464f0d899$export$c713454b46b9927), {})
        ]
    });
};



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





const $347b1c4ec3308fec$export$6648d5fa18559e7f = ({ children: children, className: className, icon: Icon, onClick: onClick, theme: customTheme = {}, ...props })=>{
    const { ref: ref, index: index } = (0, $61cd97d3d660dea1$export$dcdc7ff5149f7d1a)({
        label: typeof children === "string" ? children : undefined
    });
    const { activeIndex: activeIndex, dismissOnClick: dismissOnClick, getItemProps: getItemProps, handleSelect: handleSelect } = (0, $f2Y41.useContext)((0, $eaf3c764e2dfdeb4$export$df140987c38a308d));
    const isActive = activeIndex === index;
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.dropdown.floating.item, customTheme);
    return (0, $ge3KO.jsx)("li", {
        role: "menuitem",
        className: theme.container,
        children: (0, $ge3KO.jsxs)((0, $4a372b92c86fbb77$export$b0bb876e969289cd), {
            ref: ref,
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
            ...props,
            ...getItemProps({
                onClick: ()=>{
                    onClick && onClick();
                    dismissOnClick && handleSelect(null);
                }
            }),
            tabIndex: isActive ? 0 : -1,
            children: [
                Icon && (0, $ge3KO.jsx)(Icon, {
                    className: theme.icon
                }),
                children
            ]
        })
    });
};





const $b22ddd23bfdd8353$export$e2eb4c264cf71a83 = ({ arrowRef: arrowRef, placement: placement })=>{
    const middleware = [];
    middleware.push((0, $022d15fe75fec75f$export$cc800923e997bb8)(8));
    middleware.push(placement === "auto" ? (0, $022d15fe75fec75f$export$91fb6ecbd551914)() : (0, $022d15fe75fec75f$export$8a83211c878a3f1f)());
    middleware.push((0, $022d15fe75fec75f$export$fba63a578e423eb)({
        padding: 8
    }));
    if (arrowRef?.current) middleware.push((0, $2adec4136592c363$export$f2120bbfa5450bd2)({
        element: arrowRef.current
    }));
    return middleware;
};
const $b22ddd23bfdd8353$export$a9fe23cfa43a7b55 = ({ placement: placement })=>{
    return placement === "auto" ? undefined : placement;
};
const $b22ddd23bfdd8353$export$98fe55eaa3d1484b = ({ placement: placement })=>{
    return ({
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
    })[placement.split("-")[0]];
};


const $b6cdb4560fed9dc0$export$7c8357aca0b07c46 = ({ open: open, arrowRef: arrowRef, placement: placement = "top", setOpen: setOpen })=>{
    return (0, $61cd97d3d660dea1$export$4e02a5c1d08bac65)({
        placement: (0, $b22ddd23bfdd8353$export$a9fe23cfa43a7b55)({
            placement: placement
        }),
        open: open,
        onOpenChange: setOpen,
        whileElementsMounted: (0, $022d15fe75fec75f$export$deee3a793edee05f),
        middleware: (0, $b22ddd23bfdd8353$export$e2eb4c264cf71a83)({
            placement: placement,
            arrowRef: arrowRef
        })
    });
};
const $b6cdb4560fed9dc0$export$9e2dc8ad341d7fa1 = ({ context: context, trigger: trigger, role: role = "tooltip", interactions: interactions = [] })=>{
    return (0, $61cd97d3d660dea1$export$a519f7794e446ddd)([
        (0, $61cd97d3d660dea1$export$98524f11226063fc)(context, {
            enabled: trigger === "click"
        }),
        (0, $61cd97d3d660dea1$export$ae780daf29e6d456)(context, {
            enabled: trigger === "hover",
            handleClose: (0, $61cd97d3d660dea1$export$7484214ab62358d2)()
        }),
        (0, $61cd97d3d660dea1$export$fcdf1ba5fafc089b)(context),
        (0, $61cd97d3d660dea1$export$f66572793fa256a1)(context, {
            role: role
        }),
        ...interactions
    ]);
};


const $eaf3c764e2dfdeb4$var$icons = {
    top: (0, $723979f296abdb2d$export$4ac96d5b34ade2ea),
    right: (0, $723979f296abdb2d$export$32bd0c97674edac4),
    bottom: (0, $723979f296abdb2d$export$726570e851b9b2cd),
    left: (0, $723979f296abdb2d$export$225198a30aa903b0)
};
const $eaf3c764e2dfdeb4$var$Trigger = ({ refs: refs, children: children, inline: inline, theme: theme, disabled: disabled, setButtonWidth: setButtonWidth, getReferenceProps: getReferenceProps, renderTrigger: renderTrigger, ...buttonProps })=>{
    const ref = refs.reference;
    const a11yProps = getReferenceProps();
    (0, $f2Y41.useEffect)(()=>{
        if (ref.current) setButtonWidth?.(ref.current.clientWidth);
    }, [
        ref,
        setButtonWidth
    ]);
    if (renderTrigger) {
        const triggerElement = renderTrigger(theme);
        return (0, $f2Y41.cloneElement)(triggerElement, {
            ref: refs.setReference,
            disabled: disabled,
            ...a11yProps,
            ...triggerElement.props
        });
    }
    return inline ? (0, $ge3KO.jsx)("button", {
        type: "button",
        ref: refs.setReference,
        className: theme?.inlineWrapper,
        disabled: disabled,
        ...a11yProps,
        children: children
    }) : (0, $ge3KO.jsx)((0, $0cf428739f88aba9$export$353f5b6fc5456de1), {
        ...buttonProps,
        disabled: disabled,
        type: "button",
        ref: refs.setReference,
        ...a11yProps,
        children: children
    });
};
const $eaf3c764e2dfdeb4$export$df140987c38a308d = (0, $f2Y41.createContext)({});
const $eaf3c764e2dfdeb4$var$DropdownComponent = ({ children: children, className: className, dismissOnClick: dismissOnClick = true, theme: customTheme = {}, renderTrigger: renderTrigger, ...props })=>{
    const [open, setOpen] = (0, $f2Y41.useState)(false);
    const [activeIndex, setActiveIndex] = (0, $f2Y41.useState)(null);
    const [selectedIndex, setSelectedIndex] = (0, $f2Y41.useState)(null);
    const [buttonWidth, setButtonWidth] = (0, $f2Y41.useState)(undefined);
    const elementsRef = (0, $f2Y41.useRef)([]);
    const labelsRef = (0, $f2Y41.useRef)([]);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.dropdown, customTheme);
    const theirProps = props;
    const dataTestId = props["data-testid"] || "flowbite-dropdown-target";
    const { placement: placement = props.inline ? "bottom-start" : "bottom", trigger: trigger = "click", label: label, inline: inline, arrowIcon: arrowIcon = true, ...buttonProps } = theirProps;
    const handleSelect = (0, $f2Y41.useCallback)((index)=>{
        setSelectedIndex(index);
        setOpen(false);
    }, []);
    const handleTypeaheadMatch = (0, $f2Y41.useCallback)((index)=>{
        if (open) setActiveIndex(index);
        else handleSelect(index);
    }, [
        open,
        handleSelect
    ]);
    const { context: context, floatingStyles: floatingStyles, refs: refs } = (0, $b6cdb4560fed9dc0$export$7c8357aca0b07c46)({
        open: open,
        setOpen: setOpen,
        placement: placement
    });
    const listNav = (0, $61cd97d3d660dea1$export$b5d22cac4ad33f40)(context, {
        listRef: elementsRef,
        activeIndex: activeIndex,
        selectedIndex: selectedIndex,
        onNavigate: setActiveIndex
    });
    const typeahead = (0, $61cd97d3d660dea1$export$d8d674d50b73ba93)(context, {
        listRef: labelsRef,
        activeIndex: activeIndex,
        selectedIndex: selectedIndex,
        onMatch: handleTypeaheadMatch
    });
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps, getItemProps: getItemProps } = (0, $b6cdb4560fed9dc0$export$9e2dc8ad341d7fa1)({
        context: context,
        role: "menu",
        trigger: trigger,
        interactions: [
            listNav,
            typeahead
        ]
    });
    const Icon = (0, $f2Y41.useMemo)(()=>{
        const [p] = placement.split("-");
        return $eaf3c764e2dfdeb4$var$icons[p] ?? (0, $723979f296abdb2d$export$726570e851b9b2cd);
    }, [
        placement
    ]);
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            (0, $ge3KO.jsxs)($eaf3c764e2dfdeb4$var$Trigger, {
                ...buttonProps,
                refs: refs,
                inline: inline,
                theme: theme,
                "data-testid": dataTestId,
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.floating.target, buttonProps.className),
                setButtonWidth: setButtonWidth,
                getReferenceProps: getReferenceProps,
                renderTrigger: renderTrigger,
                children: [
                    label,
                    arrowIcon && (0, $ge3KO.jsx)(Icon, {
                        className: theme.arrowIcon
                    })
                ]
            }),
            (0, $ge3KO.jsx)($eaf3c764e2dfdeb4$export$df140987c38a308d.Provider, {
                value: {
                    activeIndex: activeIndex,
                    dismissOnClick: dismissOnClick,
                    getItemProps: getItemProps,
                    handleSelect: handleSelect
                },
                children: open && (0, $ge3KO.jsx)((0, $61cd97d3d660dea1$export$8aeee49171ded61a), {
                    context: context,
                    modal: false,
                    children: (0, $ge3KO.jsx)("div", {
                        ref: refs.setFloating,
                        style: {
                            ...floatingStyles,
                            minWidth: buttonWidth
                        },
                        "data-testid": "flowbite-dropdown",
                        "aria-expanded": open,
                        ...getFloatingProps({
                            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.floating.base, theme.floating.animation, "duration-100", !open && theme.floating.hidden, theme.floating.style.auto, className)
                        }),
                        children: (0, $ge3KO.jsx)((0, $61cd97d3d660dea1$export$ffe15b0e64951704), {
                            elementsRef: elementsRef,
                            labelsRef: labelsRef,
                            children: (0, $ge3KO.jsx)("ul", {
                                className: theme.content,
                                tabIndex: -1,
                                children: children
                            })
                        })
                    })
                })
            })
        ]
    });
};
$eaf3c764e2dfdeb4$var$DropdownComponent.displayName = "Dropdown";
(0, $347b1c4ec3308fec$export$6648d5fa18559e7f).displayName = "Dropdown.Item";
(0, $2fa52006e8da0778$export$19b44e77c853705e).displayName = "Dropdown.Header";
(0, $fe56980464f0d899$export$c713454b46b9927).displayName = "Dropdown.Divider";
const $eaf3c764e2dfdeb4$export$931cbfb6bfb85fc = Object.assign($eaf3c764e2dfdeb4$var$DropdownComponent, {
    Item: (0, $347b1c4ec3308fec$export$6648d5fa18559e7f),
    Header: (0, $2fa52006e8da0778$export$19b44e77c853705e),
    Divider: (0, $fe56980464f0d899$export$c713454b46b9927)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $9150e15bc3eb2021$export$b57af79a4ab2a1c6 = (0, $f2Y41.forwardRef)(({ className: className, color: color = "gray", helperText: helperText, sizing: sizing = "md", theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.fileInput, customTheme);
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            (0, $ge3KO.jsx)("div", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
                children: (0, $ge3KO.jsx)("div", {
                    className: theme.field.base,
                    children: (0, $ge3KO.jsx)("input", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.field.input.base, theme.field.input.colors[color], theme.field.input.sizes[sizing]),
                        ...props,
                        type: "file",
                        ref: ref
                    })
                })
            }),
            helperText && (0, $ge3KO.jsx)((0, $12dfa92164d7ac8e$export$7bc3de131d90901c), {
                color: color,
                children: helperText
            })
        ]
    });
});
$9150e15bc3eb2021$export$b57af79a4ab2a1c6.displayName = "FileInput";





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $4aaffa6840c6c9e8$export$f22d08063dd5599 = ({ children: children, theme: theme = {} })=>{
    const { theme: customTheme = {}, dark: dark } = theme;
    const [mode, setMode, toggleMode] = (0, $28249a7df305c468$export$45fd42032771846f)();
    const mergedTheme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $a7de543205d03443$export$bca14c5b3b88a9c9), customTheme);
    (0, $f2Y41.useEffect)(()=>{
        if (dark) {
            setMode("dark");
            document.documentElement.classList.add("dark");
        } else {
            setMode("light");
            document.documentElement.classList.remove("dark");
        }
    }, [
        dark,
        setMode
    ]);
    const themeContextValue = (0, $f2Y41.useMemo)(()=>({
            theme: mergedTheme,
            mode: mode,
            toggleMode: toggleMode
        }), [
        mode,
        toggleMode,
        mergedTheme
    ]);
    return (0, $ge3KO.jsx)((0, $28249a7df305c468$export$2c657da244d00bd6).Provider, {
        value: themeContextValue,
        children: children
    });
};
$4aaffa6840c6c9e8$export$f22d08063dd5599.displayName = "Flowbite";





var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");



const $7293cde9d42ea1d5$export$24029a261c7ba068 = ({ alt: alt, className: className, children: children, href: href, name: name, src: src, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.brand, customTheme);
    return (0, $ge3KO.jsx)("div", {
        children: href ? (0, $ge3KO.jsxs)("a", {
            "data-testid": "flowbite-footer-brand",
            href: href,
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
            ...props,
            children: [
                (0, $ge3KO.jsx)("img", {
                    alt: alt,
                    src: src,
                    className: theme.img
                }),
                (0, $ge3KO.jsx)("span", {
                    "data-testid": "flowbite-footer-brand-span",
                    className: theme.span,
                    children: name
                }),
                children
            ]
        }) : (0, $ge3KO.jsx)("img", {
            alt: alt,
            "data-testid": "flowbite-footer-brand",
            src: src,
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.img, className),
            ...props
        })
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $65119661f0b8fb45$export$df7cab0b2ee9fc5f = ({ by: by, className: className, href: href, theme: customTheme = {}, year: year, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.copyright, customTheme);
    return (0, $ge3KO.jsxs)("div", {
        "data-testid": "flowbite-footer-copyright",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            "\xa9 ",
            year,
            href ? (0, $ge3KO.jsx)("a", {
                href: href,
                className: theme.href,
                children: by
            }) : (0, $ge3KO.jsx)("span", {
                "data-testid": "flowbite-footer-copyright-span",
                className: theme.span,
                children: by
            })
        ]
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $3feab2d481a7d74a$export$3e9753e910d67bc5 = ({ className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.divider, customTheme);
    return (0, $ge3KO.jsx)("hr", {
        "data-testid": "footer-divider",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $b87127ffcd827a17$export$91debe384e43eb23 = ({ ariaLabel: ariaLabel, className: className, href: href, icon: Icon, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.icon, customTheme);
    return (0, $ge3KO.jsx)("div", {
        children: href ? (0, $ge3KO.jsx)("a", {
            "aria-label": ariaLabel,
            "data-testid": "flowbite-footer-icon",
            href: href,
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
            ...props,
            children: (0, $ge3KO.jsx)(Icon, {
                className: theme.size
            })
        }) : (0, $ge3KO.jsx)(Icon, {
            "data-testid": "flowbite-footer-icon",
            className: theme.size,
            ...props
        })
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $4094a356780c65c9$export$e0513c91be1318ca = ({ as: Component = "a", children: children, className: className, href: href, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.groupLink.link, customTheme);
    return (0, $ge3KO.jsx)("li", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        children: (0, $ge3KO.jsx)(Component, {
            href: href,
            className: theme.href,
            ...props,
            children: children
        })
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $1191f0882e295491$export$829375b02a3d91a4 = ({ children: children, className: className, col: col = false, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.groupLink, customTheme);
    return (0, $ge3KO.jsx)("ul", {
        "data-testid": "footer-groupLink",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, col && theme.col, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $1fc379ecc8615838$export$53e4a0ea45e729a2 = ({ as: Component = "h2", className: className, theme: customTheme = {}, title: title, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer.title, customTheme);
    return (0, $ge3KO.jsx)(Component, {
        "data-testid": "flowbite-footer-title",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: title
    });
};


const $10bc4e914472d8ba$export$189e3f0ab56ac948 = ({ bgDark: bgDark = false, children: children, className: className, container: container = false, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.footer, customTheme);
    return (0, $ge3KO.jsx)("footer", {
        "data-testid": "flowbite-footer",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, bgDark && theme.root.bgDark, container && theme.root.container, className),
        ...props,
        children: children
    });
};
$10bc4e914472d8ba$export$189e3f0ab56ac948.displayName = "Footer";
(0, $65119661f0b8fb45$export$df7cab0b2ee9fc5f).displayName = "Footer.Copyright";
(0, $4094a356780c65c9$export$e0513c91be1318ca).displayName = "Footer.Link";
(0, $7293cde9d42ea1d5$export$24029a261c7ba068).displayName = "Footer.Brand";
(0, $1191f0882e295491$export$829375b02a3d91a4).displayName = "Footer.LinkGroup";
(0, $b87127ffcd827a17$export$91debe384e43eb23).displayName = "Footer.Icon";
(0, $1fc379ecc8615838$export$53e4a0ea45e729a2).displayName = "Footer.Title";
(0, $3feab2d481a7d74a$export$3e9753e910d67bc5).displayName = "Footer.Divider";
const $10bc4e914472d8ba$export$a06f1c675e846f6f = Object.assign($10bc4e914472d8ba$export$189e3f0ab56ac948, {
    Copyright: (0, $65119661f0b8fb45$export$df7cab0b2ee9fc5f),
    Link: (0, $4094a356780c65c9$export$e0513c91be1318ca),
    LinkGroup: (0, $1191f0882e295491$export$829375b02a3d91a4),
    Brand: (0, $7293cde9d42ea1d5$export$24029a261c7ba068),
    Icon: (0, $b87127ffcd827a17$export$91debe384e43eb23),
    Title: (0, $1fc379ecc8615838$export$53e4a0ea45e729a2),
    Divider: (0, $3feab2d481a7d74a$export$3e9753e910d67bc5)
});





var $ge3KO = parcelRequire("ge3KO");



const $12dfa92164d7ac8e$export$7bc3de131d90901c = ({ children: children, className: className, color: color = "default", theme: customTheme = {}, value: value, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.helperText, customTheme);
    return (0, $ge3KO.jsx)("p", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.colors[color], className),
        ...props,
        children: value ?? children ?? ""
    });
};
$12dfa92164d7ac8e$export$7bc3de131d90901c.displayName = "HelperText";





var $ge3KO = parcelRequire("ge3KO");



const $b88ad61807b700bd$export$b04be29aa201d4f5 = ({ children: children, className: className, color: color = "default", disabled: disabled = false, theme: customTheme = {}, value: value, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.label, customTheme);
    return (0, $ge3KO.jsx)("label", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.colors[color], disabled && theme.root.disabled, className),
        "data-testid": "flowbite-label",
        ...props,
        children: value ?? children ?? ""
    });
};
$b88ad61807b700bd$export$b04be29aa201d4f5.displayName = "Label";





var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");



const $f5b555560b08056e$export$3175656842a28549 = ({ active: isActive, children: children, className: className, href: href, icon: Icon, onClick: onClick, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.listGroup.item, customTheme);
    const isLink = typeof href !== "undefined";
    const Component = isLink ? "a" : "button";
    return (0, $ge3KO.jsx)("li", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        children: (0, $ge3KO.jsxs)(Component, {
            href: href,
            onClick: onClick,
            type: isLink ? undefined : "button",
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.link.active[isActive ? "on" : "off"], theme.link.base, theme.link.href[isLink ? "on" : "off"]),
            ...props,
            children: [
                Icon && (0, $ge3KO.jsx)(Icon, {
                    "aria-hidden": true,
                    "data-testid": "flowbite-list-group-item-icon",
                    className: theme.link.icon
                }),
                children
            ]
        })
    });
};


const $e786b48f423c4711$var$ListGroupComponent = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.listGroup, customTheme);
    return (0, $ge3KO.jsx)("ul", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
        ...props,
        children: children
    });
};
$e786b48f423c4711$var$ListGroupComponent.displayName = "ListGroup";
(0, $f5b555560b08056e$export$3175656842a28549).displayName = "ListGroup.Item";
const $e786b48f423c4711$export$9cc9809463a041c4 = Object.assign($e786b48f423c4711$var$ListGroupComponent, {
    Item: (0, $f5b555560b08056e$export$3175656842a28549)
});



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");
const $0082ec5cadcf0f4f$export$ab57792b9b6974a6 = (0, $f2Y41.createContext)(undefined);
function $0082ec5cadcf0f4f$export$4cc1699d46f42cae() {
    const context = (0, $f2Y41.useContext)($0082ec5cadcf0f4f$export$ab57792b9b6974a6);
    if (!context) throw new Error("useModalContext should be used within the ModalContext provider!");
    return context;
}


const $accd72966c3409a7$export$cb540d8b0ef7906c = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.modal.body, customTheme);
    const { popup: popup } = (0, $0082ec5cadcf0f4f$export$4cc1699d46f42cae)();
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, popup && [
            theme.popup
        ], className),
        ...props,
        children: children
    });
};




var $ge3KO = parcelRequire("ge3KO");




const $ce24eba8bd605ce2$export$519437715052e656 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.modal.footer, customTheme);
    const { popup: popup } = (0, $0082ec5cadcf0f4f$export$4cc1699d46f42cae)();
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, !popup && theme.popup, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");





const $e89beaa5b1f12882$export$f50a68e3694789ee = ({ as: Component = "h3", children: children, className: className, theme: customTheme = {}, id: id, ...props })=>{
    const innerHeaderId = (0, $f2Y41.useId)();
    const headerId = id || innerHeaderId;
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.modal.header, customTheme);
    const { popup: popup, onClose: onClose, setHeaderId: setHeaderId } = (0, $0082ec5cadcf0f4f$export$4cc1699d46f42cae)();
    (0, $f2Y41.useLayoutEffect)(()=>{
        setHeaderId(headerId);
        return ()=>setHeaderId(undefined);
    }, [
        headerId,
        setHeaderId
    ]);
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, popup && theme.popup, className),
        ...props,
        children: [
            (0, $ge3KO.jsx)(Component, {
                id: headerId,
                className: theme.title,
                children: children
            }),
            (0, $ge3KO.jsx)("button", {
                "aria-label": "Close",
                className: theme.close.base,
                type: "button",
                onClick: onClose,
                children: (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$395d0e58f53a4128), {
                    "aria-hidden": true,
                    className: theme.close.icon
                })
            })
        ]
    });
};


const $8f1dc7e66b396417$var$ModalComponent = (0, $f2Y41.forwardRef)(({ children: children, className: className, dismissible: dismissible = false, onClose: onClose, popup: popup, position: position = "center", root: root, show: show, size: size = "2xl", theme: customTheme = {}, initialFocus: initialFocus, ...props }, theirRef)=>{
    const [headerId, setHeaderId] = (0, $f2Y41.useState)(undefined);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.modal, customTheme);
    const { context: context } = (0, $61cd97d3d660dea1$export$4e02a5c1d08bac65)({
        open: show,
        onOpenChange: ()=>onClose && onClose()
    });
    const ref = (0, $61cd97d3d660dea1$export$74665b213cb5c4cf)([
        context.refs.setFloating,
        theirRef
    ]);
    const click = (0, $61cd97d3d660dea1$export$98524f11226063fc)(context);
    const dismiss = (0, $61cd97d3d660dea1$export$fcdf1ba5fafc089b)(context, {
        outsidePressEvent: "mousedown",
        enabled: dismissible
    });
    const role = (0, $61cd97d3d660dea1$export$f66572793fa256a1)(context);
    const { getFloatingProps: getFloatingProps } = (0, $61cd97d3d660dea1$export$a519f7794e446ddd)([
        click,
        dismiss,
        role
    ]);
    if (!show) return null;
    return (0, $ge3KO.jsx)((0, $0082ec5cadcf0f4f$export$ab57792b9b6974a6).Provider, {
        value: {
            popup: popup,
            onClose: onClose,
            setHeaderId: setHeaderId
        },
        children: (0, $ge3KO.jsx)((0, $61cd97d3d660dea1$export$31fa5d718fa2ac09), {
            root: root,
            children: (0, $ge3KO.jsx)((0, $61cd97d3d660dea1$export$a35954495955337b), {
                lockScroll: true,
                "data-testid": "modal-overlay",
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.positions[position], show ? theme.root.show.on : theme.root.show.off, className),
                ...props,
                children: (0, $ge3KO.jsx)((0, $61cd97d3d660dea1$export$8aeee49171ded61a), {
                    context: context,
                    initialFocus: initialFocus,
                    children: (0, $ge3KO.jsx)("div", {
                        ref: ref,
                        ...getFloatingProps(props),
                        "aria-labelledby": headerId,
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.content.base, theme.root.sizes[size]),
                        children: (0, $ge3KO.jsx)("div", {
                            className: theme.content.inner,
                            children: children
                        })
                    })
                })
            })
        })
    });
});
$8f1dc7e66b396417$var$ModalComponent.displayName = "Modal";
(0, $e89beaa5b1f12882$export$f50a68e3694789ee).displayName = "Modal.Header";
(0, $accd72966c3409a7$export$cb540d8b0ef7906c).displayName = "Modal.Body";
(0, $ce24eba8bd605ce2$export$519437715052e656).displayName = "Modal.Footer";
const $8f1dc7e66b396417$export$2b77a92f1a5ad772 = Object.assign($8f1dc7e66b396417$var$ModalComponent, {
    Header: (0, $e89beaa5b1f12882$export$f50a68e3694789ee),
    Body: (0, $accd72966c3409a7$export$cb540d8b0ef7906c),
    Footer: (0, $ce24eba8bd605ce2$export$519437715052e656)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");



const $d808e3df3e4a8ff5$export$2df9f3e5f6d355f6 = ({ as: Component = "a", children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.navbar.brand, customTheme);
    return (0, $ge3KO.jsx)(Component, {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");
const $a0a2df70e97abaa4$export$fef0478b4574e50b = (0, $f2Y41.createContext)(undefined);
function $a0a2df70e97abaa4$export$d1a1b51809dfb828() {
    const context = (0, $f2Y41.useContext)($a0a2df70e97abaa4$export$fef0478b4574e50b);
    if (!context) throw new Error("useNavBarContext should be used within the NavbarContext provider!");
    return context;
}


const $dc57ebc5bef230d2$export$7a2269fac7840bc6 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const { isOpen: isOpen } = (0, $a0a2df70e97abaa4$export$d1a1b51809dfb828)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.navbar.collapse, customTheme);
    return (0, $ge3KO.jsx)("div", {
        "data-testid": "flowbite-navbar-collapse",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.hidden[!isOpen ? "on" : "off"], className),
        ...props,
        children: (0, $ge3KO.jsx)("ul", {
            className: theme.list,
            children: children
        })
    });
};




var $ge3KO = parcelRequire("ge3KO");



const $1dd51db7dc6d1257$export$fb5c67133171be94 = ({ active: active, as: Component = "a", disabled: disabled, children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.navbar.link, customTheme);
    return (0, $ge3KO.jsx)("li", {
        children: (0, $ge3KO.jsx)(Component, {
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, active && theme.active.on, !active && !disabled && theme.active.off, theme.disabled[disabled ? "on" : "off"], className),
            ...props,
            children: children
        })
    });
};



var $ge3KO = parcelRequire("ge3KO");
// THIS FILE IS AUTO GENERATED

function $d0460410ed1b8c13$export$234682c484fa017b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fe048120c985aaf1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9d2c4bc6a98de362(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1a8606bd957fa86c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b639da62c6f374dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a60cca0104d552e8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2e61d3f7bd624640(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e04704f3fcfc7c3f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9498d94104d0054a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bef366ec8ab322ce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bb9cf6f60d4c73ef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$428e976b7a3526b3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8aad0216c446161e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2033bce3692e1fc9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$88f20ff533d16abc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$508d14099b04e75d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d459b2fbc96e58e2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f848f9f48485c08d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dda5e4f6cdb63f80(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2d0d3f192940660d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$647680c51dc210e0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8059cbacaba90341(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d9b843a03db31317(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$db8aa52a7507afe3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6de2e28f464da442(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$275eec079a6b96b2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b32f0556ba4b44b5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f7a591d669a7fbbe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$11a29207eb66a480(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bd5f75a84ec9835f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6329e84305da454d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ebd4a35546505217(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$adbce069b17dcb81(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7711773c07d7017(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3ca550421473a235(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cd063178f523a5f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$240648476f956375(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$65fee04349afe961(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ced838091e969db(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b6a13be099936038(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$618cc307af4539b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4ed5568c06306c08(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cd4c5ffeb1cccc1e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$954b67eeccc8b1ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e735adbeeb3230c7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d911942443b4a527(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b4fb2c885960f461(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3ef2b7aa6b07d6db(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$92ae26e5d1749d9c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$688ef9913003a1c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$67647f94de0c8f86(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3d665d9b3d2c8276(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$76a7ffc1ac758767(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$adcc74575f686169(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7eea8ce0af9e1c95(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$133b7808f0fee39d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6bb23a112e4d7020(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e67b77b8a8b9046(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$36f8655a4003a0f9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3acf77a659d2e7ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$91c4fae4b2bd4f52(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$de72d87b4a75b77e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$56cb606745d09938(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$349dbe8a22ff5eb2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dc3e7f0aa9954438(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1089497f17afe372(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b64a5a55b7a97d73(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4abb6c738245206b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 332 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$50ca50b11eb76c44(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$307bb41d117010c3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9d1d0945832808f9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$77cec9c8c476d460(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5f23688fe40293f9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6bc9f8cf9aab40a3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d70447c492a0b1aa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$30ad21390a324bae(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e088fc03da9cf0ff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$74518604dd4250e2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c5fdc949b3468073(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9dfb87adb48de82f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$148b91376ea8ec6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1904f4b5192138dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$43aa4e06a7990573(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ba0ece6956ac1b5a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$21079c7c26d21551(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af8c0ffa978bb3f5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1646e145e9150a09(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d49a660c8e8e5781(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$28f66a8516818b1b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d6f7a5ac18f3f44e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5963f016f54c7b2e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a5569b969f3af041(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$19a24c98f6f20a47(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a0a76259652c515b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$221f611774571fe1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e61b4311c35e219b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a5b44311b859571f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dd10ce1adc9e74b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dad5868fb0b2e3f7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a6527de8cf897fc3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$65f96babc8ff21ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a82e5626c7969e98(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f82df3e46343623a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2a6697b232fb89ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$27c528b85b5b5e29(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$92a55f38cc8698b1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$177b11b7169bf0a9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$61d68dc881719ffa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8329f668068ff784(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$19816187c96c7b4d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3a79149bae5ff2c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$26a354b78cbc5441(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$332a283fa6186fe4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e820f210f1032f50(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e1f91bac1c7349ec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8758296fccd0c7c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2bcd88593cc8c30(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ea30cc5ef8131d22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$352057e1d946b4d5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$67341f15d3b20e55(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b38d57afc2b6d653(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9173d57bed24aae1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e4bd5d7609e2c32(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6c793bd6e59730a3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$238096ee50b5e63b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f8cad16358df1d4a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$caa27467dd17229a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b0736d5d25668fd4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d81057b5b59530d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f3439b50d3ae6ea6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3d5adf44147c7092(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5202cbdd3b22c5b0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6ba612ed7c84020f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$86820ea3f284da1e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fb6e5b2cd5d7b3f4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2dc5ef935738c92c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4fe6a881ef14bd5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$303ac9daa503f826(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b3ee90f37c7e65d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7feda2bd92c83fa9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$501189eda5be2c9c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8a3699491f7359fb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$94111e1126c6d7ec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4932e85b5dca929f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4fc372b646af0f39(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7125fede0c093b93(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$be3802830ab684a3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ab892337ec6bb5d7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$878fbdbbe375ecdc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$14e5e217cf6e6e16(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d50c83991276d95(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$99ea636842ca0e93(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$932225845e028b3d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$77cd5a260fdc5797(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e16be3d2108bd898(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$20964eb047378376(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$658d7fb5b17ac420(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6bda359a73c29d9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$68abc6e394c6e62d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3a35f5a9b9be92b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$10a8a8c4cfd3216(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bcbd9323e7f5bf36(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e8f38a9f620cdb0b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3ee1c978e1fb785c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b764660ff4d85d3c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$873e85c510f44f2b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$111dcf18451445d7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$799ed8ec1547cfe9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$243f7556f3223d1e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9820b80f471af6fa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aed3886ad1d24f74(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a414c802b090194(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e4dbfc0202efe2cd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bd6a21c11fa864ec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bc390a3ef32b7092(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$84cd223eef0fd2ca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eba41f4454ec8b30(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2c4ac7939e83df3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$97e95612cba0a81f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e2c810433b109609(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c59e11e6b22e106c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a303efc029403058(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$35498bbe6921eec4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f60dbc2b635c1c59(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8a1593628edd831f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$41899df33542a2be(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$526556b9c6e240b2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$21af1844dd35f1e0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ebcacad6766b253e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8341df9661bf91fa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$34e1370e4167fd2d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c29f205eeb216a22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3d9a4cf298da16b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d4c356e358759126(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bee6728bb893b490(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c07529d52eea75f2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e9eb752f50fc1ef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e2a89b7cae6e32ca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6e73b065a7f3966(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b825006c2c45acfa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1921a9ceaf9a3ba6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f07004f6c25d5741(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fffae81cab98d597(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$392c5b4cdd32f281(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$136171bb82ae26e7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c79c73beba10454f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3e91224536174671(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b57b98c971527520(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aa118879b6bd2268(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5fbf6598e062d2e8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9f6e72b7f5401e8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c3a0dd8dc62cfb19(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$99cad12772e9d80e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$960a706ce6727c28(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1c51253bd89071f5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7aea1ee29b82f9fb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c9aaf2c2ac64744d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b1c350913c58b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$721b9423fb56def0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$70bb0e586152a838(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fbd3f553128db0c7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6f1af36faae96486(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2d6ff0d3d44969ee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$74e3a6a04d33c3e3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$854e9f1aff9b6ede(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d60383aca7ea4c79(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dce187c636e3890a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6d3cc99f938d0fe3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4ba8283d28a8a182(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$60129ac9d1165f52(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4b2fd850075dc2be(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b1356b9bce294113(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$29b738bbc20c2412(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$389042fb966dba5c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2c4a78461dc0cf59(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b11209e2c4ab00ec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$71bdedbeea916642(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9274d53a981d6a0c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2cf8fc7fece73612(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6856b326fc427be7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7dced4cf5ff4090(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d1f5c59e6e6b3c5e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$554c17eb7c9eac86(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2a4d42cec5e3bafb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d457837693990e03(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7abc57296a0638fb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a6037ec28762b42b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8549d03d51c26107(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d15f2898ded36ab0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c281c807203272a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$728f1f98b3a4b68(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9a74b85353800265(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4a4654d9c3bb924a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ee561ec60b7286e4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ba7ff4edaf03cbb9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$943664f37de85fa1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a9d146add5cc2fd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e00697aab2d3acc7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$204c133d47af9002(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dc19d2b245dc2afd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c1b65b2abb6c1e18(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d86375296b9f3052(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$392093ae455946d4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$35341ff2fb09059a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$997b4b4154d29071(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$476939ee6c6ad8b8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bc48d8d73bd1893f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b176466d77265418(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c80e651e9ac0d5ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$703f79b65fecd689(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$541b94fb08545e3e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b76d9b3a7b3f80d9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$55b53b8793009f7d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$261670bd83c04261(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4c8484664e235bff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6dfd4cf2dbdb65f6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$30ad71988a4278b5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c299d44d1474960d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5bfeac63a4d15937(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7df8abfb584272a1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c418a003f2e3ad45(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$54c998bbb3dfc0e2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a4832aa88022917f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$95e1cffda4c04907(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7575df6e48a61209(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$44e45a0d83a1ce87(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1cbd24285f13d7df(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e4dbdf30553f8310(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7c822204cf96eb60(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4e7b622a5d284b0e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bae86ffcf4daa792(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$14b428db3bb983dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$65e5be6be2a07340(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a8dbee2eff8ecddf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1ff9faced4d8c03a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d56c0e6762152b4f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c13125d5a16d7c01(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$453b6cec903155f5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$73dd776dacd5f924(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc011f5069531834(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a5284556de63c7a8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3b34098fa5d7ef6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$38b01875b6eed479(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aba0f88d21eafff6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d43d2b166db81bff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f6e3d5437dbb9986(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9df09f185279b805(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ee5c2381f7946f4d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f18e0fc678dd75f2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$60bc6ae4457de7de(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$89c304c710a38e7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af76d7b010a26e8b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4d43d8c600c8ca7b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a1732d6b954e3b02(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc75c3533e77714a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$787e97fbc2b7b6b6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ef8ad54224b533c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4f4e8adcf3be2ae3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cadc441081c852a8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$95561afd3dddff79(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6124f1d9ee0066b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5bac773a2014b7c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cd4397dd09495b85(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5ef6c923f8fde0ff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$16c08f8248288da6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f9960e6af1b751c1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$24e92616541526da(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$de334815977fbd9c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4f4182622913a5ad(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4e7bba6e095688bc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d487b60233f04a34(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$44e3fdf035e437db(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dfe6e781634ce4d0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fcab6b00770a3a15(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$538d8798f6b8934d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b8ef9493b5eb1bc9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$785f971de7d4d781(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$335cded6cbf4cab9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9c9161b496c89a8c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e2dfb807ead12c96(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b9399ee8f371caa0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2c870281319eac74(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$70c1d25bec5fc395(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5730f877ae3e4076(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3dbcfc80d428d8e6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$362deb2533de26b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dfb4cca1983ee63b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6467537afaa430dc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5249250c8fcb6e56(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5c50e86902d5d379(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ecd7bd7f2fa0af52(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$99ee8600a59217b1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d2ee658abc931da3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b60a256e0f1fa69(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e20c34c623219280(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ab4d776e1c95246(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aae13aa06356aa53(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c670c91f34a1f61b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d8e090ebf200c03f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$266d5d392696db32(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ce9ad95c2fbdcac2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e8704cbb10d5c627(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b49bb060ae0ebdb6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$825bb0eabc61ee4d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$272a9813a70b5c43(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3b92ae4d47440a7c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$57bea6b37e6c8d52(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$55cd385588278474(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9ba38b596c7a21ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5758cfc9be171dd9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7745d12915d6144e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4fb372d6797211a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c973100c98b4f304(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$844d514c3522d2ac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3a87873fa9a9b247(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e3350e263ca9e36(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1f2d5a08a03f075d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$df4b80832f9614f1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b88008982d3081a4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c769af5381b4e3ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e8ea3b6917a483b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$58f31fbb8ef26bef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1917975c8f5c4b40(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c33af552afacb4f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9af917ab358491c7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$23c43aff42085c27(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$789a8fd0ab4cbf56(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cb5c0752b0ab408(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$400ac2f00fae14a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$76e5a21d96d41d15(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d8e5ca8a77c75c96(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6d3cf642b9d42d4c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4b4bc17c3dd6c08(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$decd7842c9d1ede7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$335454b1ac004a5f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fe5b5742dfb73b87(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8b235d2d7b3c248d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f6b328dce6aa5e06(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c1f149e4ef637f2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b594bee1d095b0c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f918ad1cf1067b36(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5663a6a05d888372(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$188f9f01665834e8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9dfdc3e1bd2ae63(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$48ae60e267f6cd8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e0d3811fb895d57(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f1c057abd0781d0f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$60a7adde962f9564(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$253cc2588274c62b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b79ab4b871fc8d8b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$edd0233e5556c748(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$78be8c022e888d53(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c9742ebc0add1ef6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5a04454b9099eda6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4794c284553ab45d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$18df1417950d92e6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e7d38a927d0e4dd9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6012047755c32a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$70d2ea4410d05cb0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7a1f3e5a23cd8e2a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$315de38a03f83af1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c2a01b48f4b4abc7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$991c485e8ac27c2c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40a555a77e91e0bb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$413df6d10abeadc5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4e7172a69d6f9168(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9da03d5989b9a13(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d5dfd0dcd359455(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4b0598b289d0af90(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4a030416a044a320(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$be8736ccaebc1c29(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1439d56936d3e5d2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e20ec0fdc2961f4c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ba9064c548852dfb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b262faf60e071ddb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9c7acca7b4d51e62(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ef01b7072e794a41(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$30be2e5392012719(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9332f5539f5cf61e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e936a79950c9d32a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$945e075572f0a730(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$31345b66adfb8543(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a3e0051d31cc1b6c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6efdf479188f016c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$31caf2bfeb901b38(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fbfa28a91277ecd0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5f75b2270ab4832a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d0b3e1b7f4e2c93(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b4f490b97452e95b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a24e38d0e3ab6591(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d09a1880b0a5bf43(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ff9bfbe1f4aaddad(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e14223bd824d4fb2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$59909f1ab41d5358(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$df897ab02ced6f7b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7a819f9a766d7db1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$229b7b5bba788e51(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c5345b5ff96f628a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ed6e1332c4ab076(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$62321fbb4286e601(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aa168d6fee06e28a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2809220bdc983a8e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$10254a2754ae91b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d64dc4b269c678bb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d0846b6e38af4c0d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8d243e34f3c6d650(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c977a447a56b9b3a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a83c273d1f7b5d8d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c13b93c0a5039f22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$21eb8402e8104dca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$553ab745e767aa94(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c9b106f9836d60c9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$62099594ecf02996(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d4faa989ea136bed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$341f2afe4ffba46a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2e29038ce6081c8d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e2b08bacb4c893a4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f2dc91ee2d55bfae(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ae2ef48ea5765ec6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$521cb395d68152d2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$35bc2ddf1fc5b3d8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eb94252dcc72ffe4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$69fda21276d25ee3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6f3fe1bd144babd6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4cb2d7f8c884ab1d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6a4ccfeb24a94c24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$815859589bb08692(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$915d5bbf633d001(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ddd6fee63ab173b0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2d850ebe2b03b8c7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ec872812febfcfc6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$413ba06f37ea3e59(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$33e8f3fad23cffa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5bb1d51914590b1e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f42af43ff6e3542f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a3807e00b4dd414e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1075b65575beb07e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ef58f8b87e2ce414(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d57a15b8e2a26f72(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bbe559d82fdb061d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8024848ff6f253f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1be3806c1a70e0fc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$16b742c62f53b79d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$84fd713cf20e91c1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ecd24cbb9d40575(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f1d9380089a3396f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$95d0ca9efeb01a8d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$efdc20074fd6a469(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fa48ce95eb7e7ac2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$82e208afd98f301(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6473473810cdb596(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2476858ba0b783f7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c527c97626042d14(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2654eaf6d66f0c84(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$805335e4708175de(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e3567a2432fa69e6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4d074478660cbc7e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$80f7aba987ab49d9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3075bcbba141cbfc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$79727c1733813801(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$43f2b59ad22dd2ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ecebc998c89e074e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$80359ad62c3b17bf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$37c5fe5aed842f86(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$85ac0c627d1bc055(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1b87637587df1355(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3845972519eadb60(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b26749598beb3626(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3827d06226cdd616(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c57a27a6aeed6e33(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e16389116c2c144e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e90dc9eaf8f00fa0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4a77dd0717798d0f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$43f5471b402b17a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ae6bc502dd5cef6c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d5404172ccff01f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6289358eb966e440(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$30aa4a3061d0b292(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$661ab7533b64a9ca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$34359405fde13ac9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$83d622d6a4cd28b2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a3860c392d6bddd2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e458ab1a646e3dde(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e66eab2d5aff1c88(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$684b7fd9ac6464eb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1a09cf100c78cec3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9a354f338624c68(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$87cbe5d13b4daa07(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a512ee4dd344b283(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d9cd1b48e8880c07(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$be688c59c29ccf91(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1b682b7f00b5ab05(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6b17b06958e02a2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$adcbb5eeb0a3e396(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6075580821d446e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7c34499494e32c1c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$66a7a6b990622657(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ff0d3263ff443d2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f2a2307105a849ee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$984bd92f2af2a809(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5163deae35af913c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d83a36819b1e8cf3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eb48077e980393a2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ce3a31133f4ab85f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9b9912dfd77582f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$253c0cbad52c13a5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c1267fe88b5ba1c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$403a73e3cbdbfc42(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fa7974c0903e53ab(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3493f2e5e89a1f7b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$33212df478ebc296(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cdd2c3db4a69f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bb60222b05fa0fc7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3daaa5d3308fc20e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2bcd821c5c9a8e70(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc61a15700066862(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$71bf6bd4a346322a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$20f83a3bbc844893(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$23d7368429d9afdd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2efb1c912427b3e3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4b4ebcde55f82b87(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7a75d3a70720081c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a235611a038693ae(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1ad69770875f849a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$942f1b37aea8305d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e938daf4a25ea485(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d4763dfdbf0e8d55(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d5bae5bd9329b125(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5fae9df12704d8eb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$64c58011afe82182(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7a12f299d178bb2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9d4027e06c4d734e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9d277dc8a10d3efc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8e0cb20ce167e583(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$70f5a6bd3f2eb86d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$93aaf26d51c7b009(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b8c54209cb1dd3f6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9442965a4fb5930c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e5a2faf0bf3c90c4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$92685f421e2b01e6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6aed26bd22a68fad(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3041856cc3e21d7a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f215a5d8195dd4c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$df8df22127146e33(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$67431772a29b7dfe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d2413a9c8c6eb2b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$499bcc9a26a78845(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9bc0c88d02069a7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$126b98e4eb17dabe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2fb7d214348d9fd1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7eacbaf0c64c46f2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4848f651234d8546(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$15a8b0633f31cacc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f9afddd2baf87576(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$596bbd13ae16427d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d43b030b56eb5219(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c28159520c371b4e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f510385f0adcd732(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$52ea391bba7252fd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d2a72fd94d2ca6dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d3e16733bfb9b843(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b038787ba10bd020(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6c56fa07caa9e188(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e89653e7dcb7974f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$58ff4a20db792df(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aaa77d612d668d18(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$24b6e48a50519c3e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5c1a0fe3692b02a6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6032041f7a4e7020(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$18a7a18cbcbb34fc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$66fa1069e39115ee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40806b20d5c8e672(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$70aabef93b48dfdb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1f057ece72df830(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8383684eb47b7f22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ee622268b12e7975(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d07e2368fdeee53d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8c83e2b17a7c4fee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$94eb7f00433fd484(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d56ab7de8a802984(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e3c2c8e2c56ab6b2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7f2c2d5772ea68d0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a3e44aaa57a4355e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4bb836523893a2a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$44c79c24ade40dbd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$655d74c42768c896(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$79d175568ffcd490(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9fec1a050c7f04d8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2103984014184eec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e5137f57b2028707(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5107bab3c3504a6a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c77e21cfc2cf4611(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$22d40c0ccc25eb75(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fd944ea663c21248(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$554cde48e3201feb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3ec8d59e24522cf2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8ea0c45b428aa771(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$522d0905b40cf634(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f4976fec89e4181d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4def111daebe6ba1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bab019d97ffe5dde(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b14440ec779f4718(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$224bb71507792040(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d617c49323c25b84(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$24c1d33bc6e3dfa2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$66ee6749d99e4683(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$176f2ec7a84540e3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$97765879a6fc99d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f352b3bdaff7a87f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2b26acf95194a97f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$96399d169f9abbff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4f461b03155ad99c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b083b6dd5069b672(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ad7c7f4fc27c8a15(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$517c715da9c98565(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e2c9b051a85001a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$63952a58199fd15c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$faf4472c6380dae6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fde0a1cf5f1a3b28(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9edd89bfc8da583b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e961a617818319f0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d2a73a3fb3f6fc9d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b80ceae03349f4d1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8daea534bf271be0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$86c693657e026bb4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c8bfe36484488d1f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8fbdce5e37222d6f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e61273362341ef92(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d9409f0916918998(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ddce018a3ab77493(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4cbc8822fbb09123(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$778172420e7a3d96(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b9bd7f04562d591d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e982a87239268e93(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$30953fe55e8cd01c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9ffedb5c5bbd1513(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bd3d23e4adc477d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5b2684adefd5f5cb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$351364a53b7dfa6f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5a394be70d148382(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dd9f2ceb9aa3601f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$84b994329adb5c8e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9c8a4b70a96a5723(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$635adda816567dd3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$972159a4023575d2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$effc5ff4eeaede10(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3bdbce66738d37cc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$481f5bfda0b5eb6d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3d4448ed0ce22555(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f000517333bf87aa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a0122b6f9bdd377d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b840d506d53e9e30(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d617cac3b4d47374(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4df994aeac3e28b6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e9421378a6f5724d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$589a7d5a487dbc0e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$15caa91100bd929d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$929003d9b59893dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b6c2d1bb8fbbab09(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9cc0d99ded85e7a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a6cc6e7b8b546fa7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d6f603d308e65054(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$17fe8a0b34591e23(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b43a86d0317e6aa2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$346d72db87ce8636(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f27def171b42578(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9f1c91fb5d816094(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c0894200ea7cfb11(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e4ac98987ebe8637(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4623cc6d03fec9b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7cb40eeae90c1ff5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3f8bf73e8cdef86b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bdcd3cdb68f2814b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$808c1415d09fe8a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2fff4d325381540e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$625bbb32f0691da4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4bc2bca25e754ea4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ebe1027707271e12(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c5adb495a1d68919(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1ecb758a8f999051(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3a0c0f1606c371c0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4b78504e121ddf15(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bd9c14022dfff48e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$46474f8d26a110b6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3dde60be8a356251(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$18fdaf54c3fac9c1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$44d49e000d9cf0b6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f7a34cfd0bf7b545(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a4f6d3ea2f80dadc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$979b59841eae246e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f73d27ac6bb41458(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$be2efbf2e74e0e51(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7e655ba007ceb1c0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ec35920fb3cd345(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bc4ee92f134e87e0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$45a6176621eaeca3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e7f43f090143da2e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e93e1cd2ae18487d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ff710f3796a2ee17(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8894b1457682f02(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7de3b355ee1dbd84(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$450195716cce1438(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1cc8df97f20b45cc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$129069175627b2d3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$22d36de14703ac04(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$113c89d3bd1229f6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$908995c5a4980829(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6cc00d8bac885cee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1b3963528a89ca4b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5375b03d19a2d623(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f8ab461bb664dadf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9823cea9e3c6ce7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$79990c8f4fa0ecc9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c276a3d690386aee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1f9930318f794c5f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5435f655207223df(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40806d7425e9ab6c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$57196506d2b2e5ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8131653f99bd1f71(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a9eda89970f5c419(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1a46c70ce22a6d1b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c6217a91e4e6dffb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bc1afbe51f83b00c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$11a72fb8e7d11ad4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6992c2e0f69cd4c8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f3346863417282bf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$93aef09849c5301e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$afb11df1f978c82a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2a0682d28c7e7a66(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$49b9c5b8af6c0b89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bfa91ba00240f944(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$707dffbb3f3d1881(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6f64c75c0fc3b2d9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4a07cc3f89b05135(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d062f0819569bb3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$236416bd6f25c1c3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7cfe2a6ba24d358a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$856d920a124495b0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$72582f593864239f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6b6c424677bfe7ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bbe6498702d4f883(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d1c53b585ce6025(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bce32c68ec53cdfa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$310df7ed078a7e8f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ddbac058eee2b5bf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9a3d91d944643b9a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b0f53bffcebb6d4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$729f5191a3159283(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d4cfbd7a6ea7df02(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$694ac33c162255d4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4ddf4c16e67cf04b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$96a6e7c58bc18c95(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$63abb7e0197c0c5f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$13f400e2989e8f44(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$787b38bedd09096e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$59cb06b612fbac9e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8e398a6c8d6fca75(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b7dcd77e2f65dc8f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f74aa50127543618(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6df5d6c5ca5e2737(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ac1908d3c1d58bf1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$49a6ec22cd48853a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$de588a973176a01e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7ae6364794330229(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dc9604bd9f4b4578(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8e2d755eea330d06(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3af2fc6996232640(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d445137d57fa8d7a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$445f4cb2b9cecc29(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$49d04d309e0925(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$de235f023d22f42d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$765b7f0ce4560236(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7d54f3dfd3ef4e6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bc78a48404bb6904(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ea6c7fd3c3b09d1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b0f9dc77753b3918(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6b7b353e7831748e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$91db19058dfc9ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2324996943fdca9b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3b95fdea990ed632(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3aa86f954ec6bf90(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3c93896dffda8a99(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5cb6f7af20005eeb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e5c35d0267730ce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fa10d5968af283f0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3cbb3de00db17d3d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3b91546a89fc68cf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1a7de5b8fa55dbce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1385260f35dfb633(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a499b675936102b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$630f00aee09664a2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$281ba90a15847ca2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dc689852b4b2fc9f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cc6c03b556d54a0e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1ba41a4d0c08cbc7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ae6628959b00dd8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$23eb935ee0a3be14(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$833093d4625530dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8df50037e8582fde(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b493827ee1bc567(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$19f8c50a0dd4b534(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9b42b320b692ea94(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$716ac702f5e64ba2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3367e19086a221da(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b31d26078417b4c3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$917392ac12f8d88e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f7db28fe1cd74a34(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e034a1d86f392886(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a226e218f9adeb3b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$43c37cc6737c8c7b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b6d027b0cf3f07ce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af41853971014b68(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f4095d5e028080a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b702269dd01d3c44(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a7b3b526e6d93c9b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$58bd1ef98319c555(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5b2ac739706c702a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e5df89e953934b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d2053a22b2d3eaef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$272de24c43527378(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b9e88d3a7e42252f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5b8a1c2fdad9f4b8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d19635818aab3e47(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3bcbbf2445951223(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7fbfbd801e75b095(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e8031db6594f77b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dfe531f37595541e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a5b31d4d43b6cb24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b394ec00b8d992a9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4ac9fd49ea64018(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dd50a9e1c4f017(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7aca4f1b3c690f1b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ca6b5c17ff5bedd0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$63f72f1f020e987d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$168b624a6789d3ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$470e155847a28068(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b6d2942bdce83901(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$95e8fbd2f19b4f1d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$752c1c157c0101d8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a5f785235be44fc5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$69d7d4b4f326de07(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$67b2d3e6e61f6690(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$49a5bc918a71fa0e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7997d591ef414164(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5c716cf18b9e0b3a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f12ec37c0c3a83e2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40945e016d358d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2a4a80896c881950(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fd54e107361e4796(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$62bca6f186720fda(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e8e7c01d22d99b74(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b4acee7ae8a1884b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$32b40f26ef41c965(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$83787f134fa947f8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$acccd27717a4631c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b59adca75f0c2207(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$658469e37987a31c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2f42c05c3332e276(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3c8b3af5e9b56963(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4b4182350283484a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$45b3416e982d2bf8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ee4649b3c633be80(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1d38c0a265eb9531(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e2d7db26d649377(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d820e482fd166f2d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$59d11657cce8c05e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ce168743e55d405(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e054564f7268701a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f08b75faedceafe4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e62b3ee73b569a40(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5efadee52b15e24d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$973a8d9d9794fee2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e880d6961a330ae0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aa56d7f5ac1117d7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5d69b5dca2add088(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fff70200cd5e6aa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e36e372e0eae0f82(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$498ac0e7d8c9ff40(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$901ae8e2d8321727(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c0f6c0d1ba31eaf2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c76db9ad21be09b5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c770b14aacb92966(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6ef0e37f54f9a76a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d457e761575ba88e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2720a6713037cbd3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7381393aaba7551b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a52605404808b09b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$55a0517989af6023(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d6f1661cfc17b079(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$586f3a040834f655(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3fbec10bc0226efe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$273bb7b960e2cedb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7fb3d57f77d52c31(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cc23d7bc85c85282(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5cb90fed77689254(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5cdeec14073999e2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d3e478bb09847d76(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f9d425582f88a88f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8dbcbb6e14bea198(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a06cd1e52e8150ca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6f179d97cbddd931(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$de2cf07c7ef0066b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e87c0cec51faec43(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a4374448eeb8cf3f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9b0efd3ca35d08fa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f7de524c97e799f5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$acf4198ffc0fe28d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2bab172e801439ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cc554eb8dfc074(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a33899442a8c41b5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$658fa18c5766710b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$364d85b0bf8fc03e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e2035b9993bf6ab7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$756b66f8e049b417(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d0aaca669a402fc9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$768d4c39afa888ef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$840c8f690fd8a019(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a0921a82a8ec075c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$779d80d47245a473(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$48b7b13ece304abe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a4332e7a31f0720c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$56b149ce3c5b37c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$94676da45317dffe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$512387c2aa50f7bd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b55d458cec72212a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c9fd561243976dc4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$53ef39dae73ac75c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$53ebb9e1fb2e729f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$294f349ebf8bfcab(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$22417506d6b48f5a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40001d4a5c04efa9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$85a34bca0e459f83(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$50b51b812bbd359(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cf0f71edd0785c08(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b4fd33aa671f4f13(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a2cedf8e48340a86(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3603e3c4376204aa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f3fe2fcd31766181(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8b5ba1d65eec22a0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4bf0dbb5fe7af6bf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1bde5e10961dadfd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c0d8305ad7260a2d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9da86c85d410428d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2189a26a44e8b46(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8282bfa2b1ddb06c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$168456ce4a6ea9f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cc41fed89a9b595b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$736fd1b655cb627f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6784dc7b7dc3ef08(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6cb7cac6f2232ded(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d8302a7d1b4ac04(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9eb8458822c189ee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e798fb8b383939b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f74d674912d9eedd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a749ea8fcdff5135(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f535eb3263b94a3d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a6ed5440ff58e04f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2383c42f0a54cfab(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$220fe0356e995c64(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f32ad9cd296c8a80(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$153c4fad9bd7172e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b2b4bd271bbe6698(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$222a6902d26e1e75(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ee787fb5731c2926(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7482902f82093ed0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9257a0478b200b3d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1b6cbd1b11066e8d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2b38587f417e298a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fdb708264960efaa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$58bf71ac2a2aeaa8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8e424259806474a5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1efd2cc16e4dedd6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4892f523d6ad53ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$806b364bd1e3bdf1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e43f1db2e2c239d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c9d182cb7a3c69fe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b44e22a228e36ba0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ff415d934c06c80(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4d80909935de340d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$916558a5f995ee4f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$45c075ee4becc081(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9cc73d47d7aad394(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$42351a3c2894cf5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$409df95b5018c2c3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6138fab980390b09(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a046b0460093f1b4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eb9ccd8711b9c1ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7ea6fc24130654d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6cd79b873f0de6d3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5dabd9a6fe2dd01(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$235e095b43396be(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cac8765f549bea9a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f80a5f83ecc745ec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$90a220bd5df1e33a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$384e3a27c353a6e0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af903078a78b556c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a6adcf4a68525eb6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a8d33066adef422b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a06a75a7f4188958(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7187782f71201d98(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$452b3f127dd10327(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c070b757680f080c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a7d98e37667fa751(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e94ae2527f6dcf01(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ac0d68d4555fe3df(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$43e4dfa8ddaa4c23(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8bad0eb24e25f31f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cf87e9c19623481d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4e3e01cab5da0a79(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$25a674107fe85743(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ea531fe08a5e0d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cf42ee590adc6d9b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40872a312a25ddac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$541c681251859af5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$11c9d641094a015f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f3cc1ae171fadd34(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$69b4a537fbe75044(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6a740a5e7f80c17a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8fcb214913bbbc9f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$31184b6c1ae4935b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ce6795e90e10dd4f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9634ed2850a4bf84(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cec757828e3126bc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$58bdeb8c3411cb1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3d24730def1e758c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$abefed0ffbdbe762(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$79cfa87cd8144e1a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d5db79568ea9d0f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e553bafa63a82faa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2c2c6463692bf3a2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dab6b6093277c68e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$60d6dff89885edf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2bbb516db43510c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ca142c2c04717ed2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$55e6a85ea77128a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$65f75e0b28dbbf71(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7f4f865278ff5f1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6cb3f106e1b8f9e4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3d5e9a0f324bd1c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c00df44db6b4c3f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$113528ba341fbdc2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2923d6a6a1ec6ff9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7f5baf88aaa85233(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f6c96658061e39fd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ca43c7086c7f06f2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6b6ff16b13b79b33(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bf927598bbe6812b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8420158a90599d41(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3f8462d8d549605c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5ab98f817fe966a4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d595308a43edf8be(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e24ba3eaf0c48774(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4db07d3bfde781de(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$766cffc230c22f9b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3505266dbd1bcd77(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$62b08bbbef6e5766(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7bdb11bd63f5822f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4dd288305ecf875f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9cca1bb17ca0689(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$796d541ececb948f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$75c9545bbca03aac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$56af6b77f6eeeb47(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$32ddcaf86c274d4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$deddd8f98c443142(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8489c14cd79c2346(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$14573ef51744aa9f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5446be80ec78295f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$51220ece21110de5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$806e1144c36f038(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1f05c1c945f17e1a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d115017321f97617(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8488dd50d87a6401(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9264219e9e255edd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6aea884d90e43649(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e4a92bc4da1d5300(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ab0ac4f21fa5f1f8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7ab0607af66309e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc7742a9a021fb35(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$948e093918c1be16(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2ef77c57b20653ac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a5e3da03f9202f50(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6918519520f5c458(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e99359f4f76d710(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b439711542a27adf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$97bf0e312bcad3ae(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6039a82146d40140(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6feb0de36ab93c2b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4fdbd8541e8362e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f25fa7f2d425d1a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5d5beaf6d8fb34e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9accc3da7456bf08(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2290c16c8705608d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7f7bfffaeabcf8b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$39d74fc6977712d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$831a15c0d02825d1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$54a35ef7497ec23c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c6614a13848fc130(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$168f33d47fa68e4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5ad1311777d08bf7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a264d96a77811d56(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4af1968b87271998(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$69142274fd8dc6e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d450d3fe8bfb47cb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e0e168838297bda(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e0d7f3b8ad460153(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e5e9dc5706fcc3d9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$54d6ebf38be0ea4a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d9a1659332b1bfee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$114b904332673615(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bfcacb770fba7910(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4a62ca7710ab7fe0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d989e2e83ae68f60(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$14a684f20205d35a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2229e9bb5322c4cc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c65d18f1eaaf1f5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7be95444fdf3ff7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a8edf92e31264d34(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3afd5dcce618f976(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a05ae554eb527377(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$262a55f98edec016(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8bbd2c94418a699c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c1869cb06b94a409(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$71e43c76a4f2a6a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5809dcf1c29d8d64(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f3b43ee66990b0c5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2aca090adacc02f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e724d61da6df676d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f1bd7d8688fe2593(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f2e8f14e9e223f44(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$80bc636527b83d90(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$38cb05c1bd5d61e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$98f5c2ed24efce34(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$83b9d41de076fcab(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a3e4350140dcb01a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c7afba266cbb3c76(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5b99a53171551017(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$87381de42de7a291(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f6fcdce587dd3cd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ab57c958bdec2de3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$465dc8f11e443782(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f22cf5002081c4e4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9d5e28ef378dfec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c00a9588c466153a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2d53e1cb973796c0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$287b0278148ebc85(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8b0faeaedb1bcf8d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$adb3b9ef0abeffca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5ca81b7588a1733c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c18056151fc48a27(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$60f1e510b97189d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ed8e642ae7d19146(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$51c309befd55fa4c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9ee8995d18f760d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fd3f3f6f68c8c3f9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c0857d3b8e97b760(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5d66b171302c9753(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$426029d5e8b46dba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e6f9cc1efc1f5580(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6e1b992cdfd521e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$217671547203a972(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c9a89236d744c5ee(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9eea1bf809281973(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$88927c9371c55277(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$63e8e3fb05af6081(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$613a2b39ffe64cf8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f24dd6252df17975(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$483795cb61f49e6c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7eb71bc053029ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c46f48cbfa3c416c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9a23fe4301d34c25(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c1d33fdee6d0951a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2677087c582811ac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b894db6514f0d4b3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$96af40a69ad09ed9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$56575a89ba7618b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$741d8b8a71557d39(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3e34ab22cc07ff1e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bbdcd08856ea1d4a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cd5c12430bb46353(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f042cace2575c209(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7a9def08afeaffb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7f4bb927bbeeb8c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8df11cae2976f24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e8f9837ae53207f0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$11c00bcbeae8039f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ac5edf6be5e0e66f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f81a91a51812674f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$96050688ad7317fe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d382d8c8d01afea7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e95bca611088f214(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fca8bb76239c1822(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$de5174ebf5312472(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5436970927d059eb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$44b4f667bcf02228(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$66fd526370fdcec7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f242b664423f2bc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$61e64a22eeaa0a8f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4f27d53dd791877d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1c92246c8198a2c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc125df2d586cbf6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$72b17e03018d23b8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$813bd815b7d2f2ac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bc98acf2a8e38e89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b8c30bf4dc85fe63(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$aece4aff644abbf7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f8edf00b8955cee3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 512H0V0h512v512z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$18af97c5f8188cb6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af6b0611627bbafe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7018253b37119bce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$23565508ef38c47b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6794f648eb82a068(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 536 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6fc2d6e3ec3d1f4c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$59b849b0063f1ea3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 464 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b10cdd809e0293b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$30a34595e735fcec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$50bc3766a9401b8f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1d35173c82643d22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9e685aba304bdb46(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f60d56a9ef02bfc1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bbc845e681b5284f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a1f067a7267c02a9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3603c3772e18cfec(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$df95ac8e242cff45(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1a1cc3c3a954aa49(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6edff20434a2f8d0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3360416734fef0fb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3cc6f99bc1cfda49(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b954acf87bc6074a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fbb7d2cea12740ea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$12a7f1972d8d4c03(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a265890bdae03675(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$89e6739fb2db0912(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cdc7db5b8102b82b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e4da91ab62c47c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fd5e1963069fc310(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e418e7b76837e2db(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1c30cd1f40335463(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a4cea262d7de8f2f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9566a31a188a1d2a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9b9a2a45b16858e1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e1295a2bf3ac9bfe(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bdafc27740eadc21(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$865b8713f57b5cb2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4bc4907a69e1e6d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$56fed6c977821eba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d06893f0a23d44d2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b7fe008594b7af82(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$33ab0a44bf2d07af(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8fa94bec0e5e2eea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c60e6df2484ff550(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eb6cabe96ee523b2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b62830ae44cf0f5a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$26045ed63339e52e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6b939703a999a67e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b3c55fdab9fa8d87(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9c7cf89d41e43718(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8a23ba0f1521d15d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8824fdbace275a60(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f055894158bad867(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2fb0c0f82ef7c733(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$38b5a7b390b5ac24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d9d5a44d1ae03fb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d6697f106d5b9904(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$edb01e61a8d5a5b5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c08e518681c0d7ce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$96137932fef63498(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b798a7b162c5c9b4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3e88441678665567(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$414d0a4978e2a1b7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$223e8a9b6f6a9a25(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f6fe2d4bfaeead99(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d63d378ac0b484e9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$416f7bdabf5bba23(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f44bc8857f8d236c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$262785cb42fc3519(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1e39497672ba75cc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c963126955c9b450(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$76a12c212a3eccab(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$79a6e398ff0a1a6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e7ea4eb0fcf4a62c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3a0f6e89db936f73(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bd4c2e2b934aa57e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$56513749b1987e54(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5cf8e246d8574df(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$88ede226754815c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9b8289cb488f2a9f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ba98c853f8e1c288(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$525562011d95e4b1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9dfaa464655f400e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9b907d455a048(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40825e3f854e2a12(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$153b6d835441e4d3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3cae14cbba25f29a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d83745a439b30801(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b429d798b0906f6c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$218d0841c6a2a3bc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3f3188c4893e432a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d894d3c54a16c925(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$26fd8d844a4c6034(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a44edf4a5af5c495(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b001820c1a9e451b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1b40d2afdd1271e5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d21d352a00d0a56(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$85d5161c19725407(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$93b6b51967790cdb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$420f5d848a13c6a1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$90658f9b38dddece(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1111ba79c69e8279(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$82608d63f8d4b320(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$535930ffab70845b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$febdd348661d80d6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$42d39c1b423a27a5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c5c93228533aa3a3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$15f97d627e47efac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$16a3e34a0304c707(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8e5916b43491b076(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4c5974ffe8ab0b45(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6319ea498a7338de(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4557a0ce5af4f14(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2806f39eb0cead5c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b151e394fd974c4d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$70c0ef8d4b7493(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$92be558e240a3caf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a82d675523e055ad(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4cc866f0fe356422(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1d88e19fbe2c3e23(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$85891b371051e94e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7b618467b84e336c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$52162d17d0632c1c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6f1c2186976ccbdc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e32d950a98e2d997(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ee1d4eea267beae7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$128bb89f6c8f234d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8fbecdbba0edfc8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$33119bfca853c681(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40042b557155b575(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8bb8533b34c82f7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6ee8104850ccdb7e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7fde332e70794230(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eb7d54f2273fe79d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$47e0c0ebfd13849b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ea316a7aaf03aaf1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$62f0ef36d9819a5b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9d8651cf89eef12a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8d1007693f54c91d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$358fe34e57344352(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4cfe7e0e5344f3d9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c969c2616bc1a25a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cb237b29edfc06b1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bb14a25af6b752dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$71910ae30ee49d05(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$10f6c95a0bb24a4c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$50c80985855f1c71(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1625b27f80b66812(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$99ce48d8c49f2b30(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e60a6d2df08c085b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ec3c15d8ed28a60c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c3e438226a2157b3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ef462821a68f99dc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$46f7f409c1fd23ae(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ef9f19f550927896(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$831554f64458174f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f91c7154458b4a9f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f01d775338658e4b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$db316d5371fe4a0a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c74375a443a78055(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c5e6ea2fdb226814(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f26650e13730a281(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9f653ffe874b69dd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d7efd83f1126ec79(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a7f46e37ef0e974c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$743a88e35e7ac7e3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f5086598d78bfc82(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3254300f8c82b432(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$91548bcf99b6d52c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b643ed2651f0d0a9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7058c4269e98e100(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2d9ff997d8a85124(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$db471fabb1a6a100(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$33f3a27f2178a327(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$36412178ca0c376f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c64ecb7b7b8b925e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5d2ee7bf1394f0fb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$49d2de23aab95755(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3e0f59efded1db9a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b1ed0ffdacb98c44(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8406ee1234d6a8a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b7f85e46a919bb06(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5853b2d821c77f98(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c03b8223e3976b0d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4ff68d2e121d62fc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d9ed785018e360e8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d027ddc93a40978b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$173a9fa49c7b2f3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5d4d27cd3a6d5135(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$acfd8b7611e9b1f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f061250f565712d1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$54d15e6beb85431a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2a6bf79bc39814fa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$81835db8bd2df09f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c68d807ed32cae60(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4075b0f347a2d09a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6f25da67fd8efe91(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5a3188919e2053b9(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6e71c5684ea58b89(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3064491c5a8c0483(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$edbf213132157471(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$86fc3c58f460446f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6ec9fa0fb38c86fd(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$be1ebd0337d95e43(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e3981c44743b0895(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8d52fd4c27fa6dc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$9bc0a87d5b62cd8c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$40491ba4edabdd0a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b9294986fc48dca8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5a5e07a186f32ca7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c65c7b8f0fc92eda(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7b2cc9bf21315ec3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f9202cf82fd9eab4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b10219fc0ff0cce0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$13768daaed22298a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7b0ac212f89c68c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$19c297fff6fb5dff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$23cec331d09487aa(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bebbc44110c18789(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$28a9a1108069450a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$317afaae54024526(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$97057def7bee8f9e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$da984129a3cbb991(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$812781f4cf4b27ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$731d6b92de21df9d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af040e9d2caecb85(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6a33732b316705f2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a55032b3b1c23009(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f4c528f054c7ff72(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ca4342d506ea426b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a32efee11b37c12c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$497970128c778a28(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$29ba91dea9b8ebcf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$81c9ec060677df05(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$4d3be2edb8f9dc8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$295a982357c5e5d4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$64c2b3df73889309(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$96714d354e735c0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ba4bd216f8b48c99(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$bb4fe96b1d26e68a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$477c6a7ee36f351d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3c89c22e80f80404(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$85a3bb9767caa349(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$951f67bbabe0d1d1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6ed4cf646a52055a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$24602f7464de83e4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$54cd2a8159d99cf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7f087edb87fb37c7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cf253cf6524b6225(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$feab698b70556aa1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$29acb190b352a37a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6dab0ebd31f6f2a8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eda6de933afbe61c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5d2be867b7f2ecef(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d571f73f880e47ba(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$359320ae870fce20(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fe4119e56a958cea(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$60dcf19d5cacb4c1(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$69dfde95f8670d1c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$808a1f8535287032(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$61857ac7677b8e39(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$94365b333a0f109a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f53487078d2e7f22(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc9689d21b445349(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ce9a9420b5065032(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$612739dda657fbae(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b0c9d65c644d1ef0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$da7692c996bf9499(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c948b622f533301a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f29171566001fd51(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6da060b08561c869(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f5813afdee155b13(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$27a8df98cfd34858(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f0964d20e88bf7ca(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$166e88b0ab23fd83(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f3655b226cbe53c2(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c40adf946ffc4fb5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ffeb79950df97819(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3905412f99a0ae36(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ff4dbf4f3aa6a680(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c7de8b9cb3c00984(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$95de54f08b2f7e53(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c1b93539a5346e83(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$ea348ccabdd59377(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$563f34f54b65b046(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d3bf37bc50245067(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f877c16efbd617f0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$dd9144e07c5eae27(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b9eef507b7aaf00(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e21c37d819b5119d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$61a86d1017d38061(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d1b956dc99327ba3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$50713933c2e94575(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cddb99fb7b709dfb(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$89e3847cfcd0d6c6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$af5f825962c6a5d5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6cb8e2e8b0760921(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2a2392a69898b2cf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$df4eae8e22713de4(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d469fdadd4438c4b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fe375e3124217a4a(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$443b0b982c8d5612(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6c7271623637b29c(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$2381378b0f69a36f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$1b2f439d7ed93e02(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$486fe0e9eb7c08fc(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e9c40b50e1ea56f6(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5e08de13dfcfdcd8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cf30c24861a866cf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c5b6974992a60977(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cc9bf86a371f6078(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$adbbf3f45b2bcdce(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$271ea6491c706222(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a4faf6ef2c3db77f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5c36a7f41bd697c7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d3fc0ded09abd00d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f6e37bb674fb9a25(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$45657b6a101793ac(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$5163b4180710c195(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7435a00bec420bbf(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$b3baa2aee8eea58f(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c4584ce0ca5148ab(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eea9f0ad241714ff(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7362b5c5191c73d5(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$3e2d8d8caac02898(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eec11f193d33cf48(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$82dbd8de9eb01fa7(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$c65a0b34799d5161(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a878803ef9442705(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$721b743d8768259d(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$7d1cb412d8ce6000(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$572aeed70cb57a3b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e76e3169a10165ed(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$eef3dda8d7738f8b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$90c79ab0b1be8a32(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$45125a72067d642b(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$8ea87ffeb2f9d2f8(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$a20abd2188c598c0(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$e688613f971a1103(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$d71ee8a10dddb24(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$91c3383150071b62(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$6449d066b0a27a3e(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$f7a6436e3f2f5377(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$cfd0247d570b5bb3(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function $d0460410ed1b8c13$export$fc720bbebba6d013(props) {
    return (0, $b9cadf0191c5a549$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
                }
            }
        ]
    })(props);
}






const $0f6fa2990da00af7$export$e018030c18c7f90a = ({ barIcon: BarIcon = (0, $d0460410ed1b8c13$export$43f2b59ad22dd2ed), className: className, theme: customTheme = {}, ...props })=>{
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $a0a2df70e97abaa4$export$d1a1b51809dfb828)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.navbar.toggle, customTheme);
    const handleClick = ()=>{
        setIsOpen(!isOpen);
    };
    return (0, $ge3KO.jsxs)("button", {
        "data-testid": "flowbite-navbar-toggle",
        onClick: handleClick,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            (0, $ge3KO.jsx)("span", {
                className: "sr-only",
                children: "Open main menu"
            }),
            (0, $ge3KO.jsx)(BarIcon, {
                "aria-hidden": true,
                className: theme.icon
            })
        ]
    });
};


const $c0986d5b1a7f5003$var$NavbarComponent = ({ border: border, children: children, className: className, fluid: fluid = false, menuOpen: menuOpen, rounded: rounded, theme: customTheme = {}, ...props })=>{
    const [isOpen, setIsOpen] = (0, $f2Y41.useState)(menuOpen);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.navbar.root, customTheme);
    return (0, $ge3KO.jsx)((0, $a0a2df70e97abaa4$export$fef0478b4574e50b).Provider, {
        value: {
            isOpen: isOpen,
            setIsOpen: setIsOpen
        },
        children: (0, $ge3KO.jsx)("nav", {
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.bordered[border ? "on" : "off"], theme.rounded[rounded ? "on" : "off"], className),
            ...props,
            children: (0, $ge3KO.jsx)("div", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.inner.base, theme.inner.fluid[fluid ? "on" : "off"]),
                children: children
            })
        })
    });
};
$c0986d5b1a7f5003$var$NavbarComponent.displayName = "Navbar";
(0, $d808e3df3e4a8ff5$export$2df9f3e5f6d355f6).displayName = "Navbar.Brand";
(0, $dc57ebc5bef230d2$export$7a2269fac7840bc6).displayName = "Navbar.Collapse";
(0, $1dd51db7dc6d1257$export$fb5c67133171be94).displayName = "Navbar.Link";
(0, $0f6fa2990da00af7$export$e018030c18c7f90a).displayName = "Navbar.Toggle";
const $c0986d5b1a7f5003$export$42cfbb80f7861e77 = Object.assign($c0986d5b1a7f5003$var$NavbarComponent, {
    Brand: (0, $d808e3df3e4a8ff5$export$2df9f3e5f6d355f6),
    Collapse: (0, $dc57ebc5bef230d2$export$7a2269fac7840bc6),
    Link: (0, $1dd51db7dc6d1257$export$fb5c67133171be94),
    Toggle: (0, $0f6fa2990da00af7$export$e018030c18c7f90a)
});





var $ge3KO = parcelRequire("ge3KO");




const $386f8d37ff5dba6e$export$d02631cccf789723 = (start, end)=>{
    if (start >= end) return [];
    return [
        ...Array(end - start + 1).keys()
    ].map((key)=>key + start);
};



var $ge3KO = parcelRequire("ge3KO");



const $5d514385a067463b$export$c3639e97caabff2c = ({ active: active, children: children, className: className, onClick: onClick, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.pagination, customTheme);
    return (0, $ge3KO.jsx)("button", {
        type: "button",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(active && theme.pages.selector.active, className),
        onClick: onClick,
        ...props,
        children: children
    });
};
$5d514385a067463b$export$c3639e97caabff2c.displayName = "Pagination.Button";
const $5d514385a067463b$export$1f1b920a94aec4db = ({ children: children, className: className, onClick: onClick, theme: customTheme = {}, disabled: disabled = false, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.pagination, customTheme);
    return (0, $ge3KO.jsx)("button", {
        type: "button",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(disabled && theme.pages.selector.disabled, className),
        disabled: disabled,
        onClick: onClick,
        ...props,
        children: children
    });
};
$5d514385a067463b$export$1f1b920a94aec4db.displayName = "Pagination.Navigation";


const $c03b4220957ebffc$var$PaginationComponent = ({ className: className, currentPage: currentPage, layout: layout = "pagination", nextLabel: nextLabel = "Next", onPageChange: onPageChange, previousLabel: previousLabel = "Previous", renderPaginationButton: renderPaginationButton = (props)=>(0, $ge3KO.jsx)((0, $5d514385a067463b$export$c3639e97caabff2c), {
        ...props
    }), showIcons: showIcon = false, theme: customTheme = {}, totalPages: totalPages, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.pagination, customTheme);
    const firstPage = Math.max(1, currentPage - 3);
    const lastPage = Math.min(currentPage + 3, totalPages);
    const goToNextPage = ()=>{
        onPageChange(Math.min(currentPage + 1, totalPages));
    };
    const goToPreviousPage = ()=>{
        onPageChange(Math.max(currentPage - 1, 1));
    };
    return (0, $ge3KO.jsxs)("nav", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            layout === "table" && (0, $ge3KO.jsxs)("div", {
                className: theme.layout.table.base,
                children: [
                    "Showing ",
                    (0, $ge3KO.jsx)("span", {
                        className: theme.layout.table.span,
                        children: firstPage
                    }),
                    " to\xa0",
                    (0, $ge3KO.jsx)("span", {
                        className: theme.layout.table.span,
                        children: lastPage
                    }),
                    " of\xa0",
                    (0, $ge3KO.jsx)("span", {
                        className: theme.layout.table.span,
                        children: totalPages
                    }),
                    " Entries"
                ]
            }),
            (0, $ge3KO.jsxs)("ul", {
                className: theme.pages.base,
                children: [
                    (0, $ge3KO.jsx)("li", {
                        children: (0, $ge3KO.jsxs)((0, $5d514385a067463b$export$1f1b920a94aec4db), {
                            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.pages.previous.base, showIcon && theme.pages.showIcon),
                            onClick: goToPreviousPage,
                            disabled: currentPage === 1,
                            children: [
                                showIcon && (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$82bcb26f2eb59c71), {
                                    "aria-hidden": true,
                                    className: theme.pages.previous.icon
                                }),
                                previousLabel
                            ]
                        })
                    }),
                    layout === "pagination" && (0, $386f8d37ff5dba6e$export$d02631cccf789723)(firstPage, lastPage).map((page)=>(0, $ge3KO.jsx)("li", {
                            "aria-current": page === currentPage ? "page" : undefined,
                            children: renderPaginationButton({
                                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.pages.selector.base, currentPage === page && theme.pages.selector.active),
                                active: page === currentPage,
                                onClick: ()=>onPageChange(page),
                                children: page
                            })
                        }, page)),
                    (0, $ge3KO.jsx)("li", {
                        children: (0, $ge3KO.jsxs)((0, $5d514385a067463b$export$1f1b920a94aec4db), {
                            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.pages.next.base, showIcon && theme.pages.showIcon),
                            onClick: goToNextPage,
                            disabled: currentPage === totalPages,
                            children: [
                                nextLabel,
                                showIcon && (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$bc7bbedc50c1784b), {
                                    "aria-hidden": true,
                                    className: theme.pages.next.icon
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
$c03b4220957ebffc$var$PaginationComponent.displayName = "Pagination";
const $c03b4220957ebffc$export$68f5e1453c188a82 = Object.assign($c03b4220957ebffc$var$PaginationComponent, {
    Button: (0, $5d514385a067463b$export$c3639e97caabff2c)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $0328122a2e82414d$export$b25a304ec7d746bb = ({ className: className, color: color = "blue", labelProgress: labelProgress = false, labelText: labelText = false, progress: progress, progressLabelPosition: progressLabelPosition = "inside", size: size = "md", textLabel: textLabel = "progressbar", textLabelPosition: textLabelPosition = "inside", theme: customTheme = {}, ...props })=>{
    const id = (0, $f2Y41.useId)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.progress, customTheme);
    return (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: (0, $ge3KO.jsxs)("div", {
            id: id,
            "aria-label": textLabel,
            "aria-valuenow": progress,
            role: "progressbar",
            ...props,
            children: [
                (textLabel && labelText && textLabelPosition === "outside" || progress > 0 && labelProgress && progressLabelPosition === "outside") && (0, $ge3KO.jsxs)("div", {
                    className: theme.label,
                    "data-testid": "flowbite-progress-outer-label-container",
                    children: [
                        textLabel && labelText && textLabelPosition === "outside" && (0, $ge3KO.jsx)("span", {
                            "data-testid": "flowbite-progress-outer-text-label",
                            children: textLabel
                        }),
                        labelProgress && progressLabelPosition === "outside" && (0, $ge3KO.jsxs)("span", {
                            "data-testid": "flowbite-progress-outer-progress-label",
                            children: [
                                progress,
                                "%"
                            ]
                        })
                    ]
                }),
                (0, $ge3KO.jsx)("div", {
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.size[size], className),
                    children: (0, $ge3KO.jsxs)("div", {
                        style: {
                            width: `${progress}%`
                        },
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.bar, theme.color[color], theme.size[size]),
                        children: [
                            textLabel && labelText && textLabelPosition === "inside" && (0, $ge3KO.jsx)("span", {
                                "data-testid": "flowbite-progress-inner-text-label",
                                children: textLabel
                            }),
                            progress > 0 && labelProgress && progressLabelPosition === "inside" && (0, $ge3KO.jsxs)("span", {
                                "data-testid": "flowbite-progress-inner-progress-label",
                                children: [
                                    progress,
                                    "%"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
$0328122a2e82414d$export$b25a304ec7d746bb.displayName = "Progress";





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $dc85522e471a1e81$export$d7b12c4107be0d61 = (0, $f2Y41.forwardRef)(({ className: className, theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.radio, customTheme);
    return (0, $ge3KO.jsx)("input", {
        ref: ref,
        type: "radio",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
        ...props
    });
});
$dc85522e471a1e81$export$d7b12c4107be0d61.displayName = "Radio";





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $934397f830f8d0f8$export$826424dabc3dd705 = (0, $f2Y41.forwardRef)(({ className: className, sizing: sizing = "md", theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.rangeSlider, customTheme);
    return (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: (0, $ge3KO.jsx)("div", {
            "data-testid": "flowbite-range-slider",
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
            children: (0, $ge3KO.jsx)("div", {
                className: theme.field.base,
                children: (0, $ge3KO.jsx)("input", {
                    ref: ref,
                    type: "range",
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.field.input.base, theme.field.input.sizes[sizing]),
                    ...props
                })
            })
        })
    });
});
$934397f830f8d0f8$export$826424dabc3dd705.displayName = "RangeSlider";





var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");



const $e0da32753893de15$export$92ccece9f76b17b = ({ children: children, className: className, percentFilled: percentFilled = 0, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.rating.advanced, customTheme);
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            (0, $ge3KO.jsx)("span", {
                className: theme.label,
                children: children
            }),
            (0, $ge3KO.jsx)("div", {
                className: theme.progress.base,
                children: (0, $ge3KO.jsx)("div", {
                    className: theme.progress.fill,
                    "data-testid": "flowbite-rating-fill",
                    style: {
                        width: `${percentFilled}%`
                    }
                })
            }),
            (0, $ge3KO.jsx)("span", {
                className: theme.progress.label,
                children: `${percentFilled}%`
            })
        ]
    });
};



var $f2Y41 = parcelRequire("f2Y41");
const $ea4d74f54106e9f0$export$b7e1e32c32b5303c = (0, $f2Y41.createContext)(undefined);
function $ea4d74f54106e9f0$export$29f418d1e38a26a2() {
    const context = (0, $f2Y41.useContext)($ea4d74f54106e9f0$export$b7e1e32c32b5303c);
    if (!context) throw new Error("useRatingContext should be used within the RatingContext provider!");
    return context;
}



var $ge3KO = parcelRequire("ge3KO");





const $7baf2b6cd316b441$export$d22c29c9a4f5b412 = ({ className: className, filled: filled = true, starIcon: Icon = (0, $723979f296abdb2d$export$393795b12e2c4440), theme: customTheme = {}, ...props })=>{
    const { size: size = "sm" } = (0, $ea4d74f54106e9f0$export$29f418d1e38a26a2)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.rating.star, customTheme);
    return (0, $ge3KO.jsx)(Icon, {
        "data-testid": "flowbite-rating-star",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.sizes[size], theme[filled ? "filled" : "empty"], className),
        ...props
    });
};


const $08dd9c4d00c0bc37$var$RatingComponent = ({ children: children, className: className, size: size = "sm", theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.rating, customTheme);
    return (0, $ge3KO.jsx)((0, $ea4d74f54106e9f0$export$b7e1e32c32b5303c).Provider, {
        value: {
            size: size
        },
        children: (0, $ge3KO.jsx)("div", {
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
            ...props,
            children: children
        })
    });
};
$08dd9c4d00c0bc37$var$RatingComponent.displayName = "Rating";
(0, $7baf2b6cd316b441$export$d22c29c9a4f5b412).displayName = "Rating.Star";
(0, $e0da32753893de15$export$92ccece9f76b17b).displayName = "Rating.Advanced";
const $08dd9c4d00c0bc37$export$8ba663d22f9191ae = Object.assign($08dd9c4d00c0bc37$var$RatingComponent, {
    Star: (0, $7baf2b6cd316b441$export$d22c29c9a4f5b412),
    Advanced: (0, $e0da32753893de15$export$92ccece9f76b17b)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $13b84a395cbc9d2f$export$ef9b1a59e592288f = (0, $f2Y41.forwardRef)(({ addon: addon, children: children, className: className, color: color = "gray", helperText: helperText, icon: Icon, shadow: shadow, sizing: sizing = "md", theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.select, customTheme);
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        children: [
            addon && (0, $ge3KO.jsx)("span", {
                className: theme.addon,
                children: addon
            }),
            (0, $ge3KO.jsxs)("div", {
                className: theme.field.base,
                children: [
                    Icon && (0, $ge3KO.jsx)("div", {
                        className: theme.field.icon.base,
                        children: (0, $ge3KO.jsx)(Icon, {
                            className: theme.field.icon.svg
                        })
                    }),
                    (0, $ge3KO.jsx)("select", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.field.select.base, theme.field.select.colors[color], theme.field.select.withIcon[Icon ? "on" : "off"], theme.field.select.withAddon[addon ? "on" : "off"], theme.field.select.withShadow[shadow ? "on" : "off"], theme.field.select.sizes[sizing]),
                        ...props,
                        ref: ref,
                        children: children
                    }),
                    helperText && (0, $ge3KO.jsx)((0, $12dfa92164d7ac8e$export$7bc3de131d90901c), {
                        color: color,
                        children: helperText
                    })
                ]
            })
        ]
    });
});
$13b84a395cbc9d2f$export$ef9b1a59e592288f.displayName = "Select";





var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");
const $3d1a7893f7cadb38$export$1e0197c05a154c40 = (0, $f2Y41.createContext)(undefined);
function $3d1a7893f7cadb38$export$861cd542ff836f0d() {
    const context = (0, $f2Y41.useContext)($3d1a7893f7cadb38$export$1e0197c05a154c40);
    if (!context) throw new Error("useSidebarContext should be used within the SidebarContext provider!");
    return context;
}


const $a204aa22e6a9c4b4$export$99f444e05bcbe00c = ({ children: children, color: color = "info", className: className, theme: customTheme = {}, ...props })=>{
    const { isCollapsed: isCollapsed } = (0, $3d1a7893f7cadb38$export$861cd542ff836f0d)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.cta, customTheme);
    return (0, $ge3KO.jsx)("div", {
        "data-testid": "sidebar-cta",
        hidden: isCollapsed,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.color[color], className),
        ...props,
        children: children
    });
};
$a204aa22e6a9c4b4$export$99f444e05bcbe00c.displayName = "Sidebar.CTA";



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");






var $f2Y41 = parcelRequire("f2Y41");
const $957cd5283f3a1d10$export$1ab6d537b7142b14 = (0, $f2Y41.createContext)(undefined);
function $957cd5283f3a1d10$export$10c5efea80782023() {
    const context = (0, $f2Y41.useContext)($957cd5283f3a1d10$export$1ab6d537b7142b14);
    if (!context) throw new Error("useSidebarItemContext should be used within the SidebarItemContext provider!");
    return context;
}


const $992295b3f27a3331$export$fd0e4660f6b21723 = ({ children: children, className: className, icon: Icon, label: label, open: open = false, theme: customTheme = {}, ...props })=>{
    const id = (0, $f2Y41.useId)();
    const { isCollapsed: isCollapsed } = (0, $3d1a7893f7cadb38$export$861cd542ff836f0d)();
    const [isOpen, setOpen] = (0, $f2Y41.useState)(open);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.collapse, customTheme);
    (0, $f2Y41.useEffect)(()=>setOpen(open), [
        open
    ]);
    const Wrapper = ({ children: children })=>(0, $ge3KO.jsx)("li", {
            children: isCollapsed && !isOpen ? (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                content: label,
                placement: "right",
                children: children
            }) : children
        });
    return (0, $ge3KO.jsxs)(Wrapper, {
        children: [
            (0, $ge3KO.jsxs)("button", {
                id: `flowbite-sidebar-collapse-${id}`,
                onClick: ()=>setOpen(!isOpen),
                title: label,
                type: "button",
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.button, className),
                ...props,
                children: [
                    Icon && (0, $ge3KO.jsx)(Icon, {
                        "aria-hidden": true,
                        "data-testid": "flowbite-sidebar-collapse-icon",
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.icon.base, theme.icon.open[isOpen ? "on" : "off"])
                    }),
                    isCollapsed ? (0, $ge3KO.jsx)("span", {
                        className: "sr-only",
                        children: label
                    }) : (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                        children: [
                            (0, $ge3KO.jsx)("span", {
                                "data-testid": "flowbite-sidebar-collapse-label",
                                className: theme.label.base,
                                children: label
                            }),
                            (0, $ge3KO.jsx)((0, $723979f296abdb2d$export$56f537fdeb34c3ff), {
                                "aria-hidden": true,
                                className: theme.label.icon
                            })
                        ]
                    })
                ]
            }),
            (0, $ge3KO.jsx)("ul", {
                "aria-labelledby": `flowbite-sidebar-collapse-${id}`,
                hidden: !isOpen,
                className: theme.list,
                children: (0, $ge3KO.jsx)((0, $957cd5283f3a1d10$export$1ab6d537b7142b14).Provider, {
                    value: {
                        isInsideCollapse: true
                    },
                    children: children
                })
            })
        ]
    });
};
$992295b3f27a3331$export$fd0e4660f6b21723.displayName = "Sidebar.Collapse";




var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");





const $5bec14f6a6f63166$var$ListItem = ({ id: id, isCollapsed: isCollapsed, tooltipChildren: tooltipChildren, children: wrapperChildren, ...props })=>(0, $ge3KO.jsx)("li", {
        ...props,
        children: isCollapsed ? (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
            content: (0, $ge3KO.jsx)($5bec14f6a6f63166$var$TooltipContent, {
                id: id,
                children: tooltipChildren
            }),
            placement: "right",
            children: wrapperChildren
        }) : wrapperChildren
    });
const $5bec14f6a6f63166$var$TooltipContent = ({ id: id, children: children })=>(0, $ge3KO.jsx)($5bec14f6a6f63166$var$Children, {
        id: id,
        children: children
    });
const $5bec14f6a6f63166$var$Children = ({ id: id, children: children })=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.item;
    return (0, $ge3KO.jsx)("span", {
        "data-testid": "flowbite-sidebar-item-content",
        id: `flowbite-sidebar-item-${id}`,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.content.base),
        children: children
    });
};
const $5bec14f6a6f63166$export$b09fc4897b18f7d8 = (0, $f2Y41.forwardRef)(({ active: isActive, as: Component = "a", children: children, className: className, icon: Icon, label: label, labelColor: labelColor = "info", theme: customTheme = {}, ...props }, ref)=>{
    const id = (0, $f2Y41.useId)();
    const { isCollapsed: isCollapsed } = (0, $3d1a7893f7cadb38$export$861cd542ff836f0d)();
    const { isInsideCollapse: isInsideCollapse } = (0, $957cd5283f3a1d10$export$10c5efea80782023)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.item, customTheme);
    return (0, $ge3KO.jsx)($5bec14f6a6f63166$var$ListItem, {
        className: theme.listItem,
        id: id,
        isCollapsed: isCollapsed,
        tooltipChildren: children,
        children: (0, $ge3KO.jsxs)(Component, {
            "aria-labelledby": `flowbite-sidebar-item-${id}`,
            ref: ref,
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, isActive && theme.active, !isCollapsed && isInsideCollapse && theme.collapsed?.insideCollapse, className),
            ...props,
            children: [
                Icon && (0, $ge3KO.jsx)(Icon, {
                    "aria-hidden": true,
                    "data-testid": "flowbite-sidebar-item-icon",
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.icon?.base, isActive && theme.icon?.active)
                }),
                isCollapsed && !Icon && (0, $ge3KO.jsx)("span", {
                    className: theme.collapsed?.noIcon,
                    children: children.charAt(0).toLocaleUpperCase() ?? "?"
                }),
                !isCollapsed && (0, $ge3KO.jsx)($5bec14f6a6f63166$var$Children, {
                    id: id,
                    children: children
                }),
                !isCollapsed && label && (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                    color: labelColor,
                    "data-testid": "flowbite-sidebar-label",
                    hidden: isCollapsed,
                    className: theme.label,
                    children: label
                })
            ]
        })
    });
});
$5bec14f6a6f63166$export$b09fc4897b18f7d8.displayName = "Sidebar.Item";



var $ge3KO = parcelRequire("ge3KO");



const $83d6d825ca1764e7$export$4ba10f28707ceb8a = ({ children: children, className: className, ...props })=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.itemGroup;
    return (0, $ge3KO.jsx)("ul", {
        "data-testid": "flowbite-sidebar-item-group",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
        ...props,
        children: (0, $ge3KO.jsx)((0, $957cd5283f3a1d10$export$1ab6d537b7142b14).Provider, {
            value: {
                isInsideCollapse: false
            },
            children: children
        })
    });
};
$83d6d825ca1764e7$export$4ba10f28707ceb8a.displayName = "Sidebar.ItemGroup";



var $ge3KO = parcelRequire("ge3KO");


const $e5a47433b00d38ce$export$fddb90075af4c1bb = ({ children: children, className: className, ...props })=>{
    const theme = (0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.items;
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
        "data-testid": "flowbite-sidebar-items",
        ...props,
        children: children
    });
};
$e5a47433b00d38ce$export$fddb90075af4c1bb.displayName = "Sidebar.Items";



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




const $8f54ec4ab5490fc2$var$SidebarLogo = ({ children: children, className: className, href: href, img: img, imgAlt: imgAlt = "", theme: customTheme = {}, ...props })=>{
    const id = (0, $f2Y41.useId)();
    const { isCollapsed: isCollapsed } = (0, $3d1a7893f7cadb38$export$861cd542ff836f0d)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar.logo, customTheme);
    return (0, $ge3KO.jsxs)("a", {
        "aria-labelledby": `flowbite-sidebar-logo-${id}`,
        href: href,
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: [
            (0, $ge3KO.jsx)("img", {
                alt: imgAlt,
                src: img,
                className: theme.img
            }),
            (0, $ge3KO.jsx)("span", {
                className: theme.collapsed[isCollapsed ? "on" : "off"],
                id: `flowbite-sidebar-logo-${id}`,
                children: children
            })
        ]
    });
};
$8f54ec4ab5490fc2$var$SidebarLogo.displayName = "Sidebar.Logo";
var $8f54ec4ab5490fc2$export$2e2bcd8739ae039 = $8f54ec4ab5490fc2$var$SidebarLogo;


const $359adea973ef4d33$var$SidebarComponent = ({ children: children, as: Component = "nav", collapseBehavior: collapseBehavior = "collapse", collapsed: isCollapsed = false, theme: customTheme = {}, className: className, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.sidebar, customTheme);
    return (0, $ge3KO.jsx)((0, $3d1a7893f7cadb38$export$1e0197c05a154c40).Provider, {
        value: {
            isCollapsed: isCollapsed
        },
        children: (0, $ge3KO.jsx)(Component, {
            "aria-label": "Sidebar",
            hidden: isCollapsed && collapseBehavior === "hide",
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.collapsed[isCollapsed ? "on" : "off"], className),
            ...props,
            children: (0, $ge3KO.jsx)("div", {
                className: theme.root.inner,
                children: children
            })
        })
    });
};
$359adea973ef4d33$var$SidebarComponent.displayName = "Sidebar";
const $359adea973ef4d33$export$1ba59dacbcbf90fe = Object.assign($359adea973ef4d33$var$SidebarComponent, {
    Collapse: (0, $992295b3f27a3331$export$fd0e4660f6b21723),
    CTA: (0, $a204aa22e6a9c4b4$export$99f444e05bcbe00c),
    Item: (0, $5bec14f6a6f63166$export$b09fc4897b18f7d8),
    Items: (0, $e5a47433b00d38ce$export$fddb90075af4c1bb),
    ItemGroup: (0, $83d6d825ca1764e7$export$4ba10f28707ceb8a),
    Logo: (0, $8f54ec4ab5490fc2$export$2e2bcd8739ae039)
});



var $ge3KO = parcelRequire("ge3KO");



const $57cd14b1871feb0c$export$7f7cbe89f1eacd2 = ({ className: className, color: color = "info", light: light, size: size = "md", theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.spinner, customTheme);
    return (0, $ge3KO.jsx)("span", {
        role: "status",
        ...props,
        children: (0, $ge3KO.jsxs)("svg", {
            fill: "none",
            viewBox: "0 0 100 101",
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.color[color], theme.light[light ? "on" : "off"].base, theme.light[light ? "on" : "off"].color[color], theme.size[size], className),
            children: [
                (0, $ge3KO.jsx)("path", {
                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                    fill: "currentColor"
                }),
                (0, $ge3KO.jsx)("path", {
                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                    fill: "currentFill"
                })
            ]
        })
    });
};
$57cd14b1871feb0c$export$7f7cbe89f1eacd2.displayName = "Spinner";



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");
const $3e957f5643639dda$export$17043b9d35150718 = ({ children: children, className: className })=>(0, $ge3KO.jsx)("div", {
        className: className,
        children: children
    });
$3e957f5643639dda$export$17043b9d35150718.displayName = "Tabs.Item";


const $a6fc85b69bfdca94$export$fb3aab15d866de8f = (0, $f2Y41.forwardRef)(({ children: children, className: className, onActiveTabChange: onActiveTabChange, style: style = "default", theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.tab, customTheme);
    const id = (0, $f2Y41.useId)();
    const tabs = (0, $f2Y41.useMemo)(()=>(0, $f2Y41.Children).map(children, ({ props: props })=>props), [
        children
    ]);
    const tabRefs = (0, $f2Y41.useRef)([]);
    const [activeTab, setActiveTab] = (0, $f2Y41.useState)(Math.max(0, tabs.findIndex((tab)=>tab.active)));
    const [focusedTab, setFocusedTab] = (0, $f2Y41.useState)(-1);
    const setActiveTabWithCallback = (activeTab)=>{
        setActiveTab(activeTab);
        if (onActiveTabChange) onActiveTabChange(activeTab);
    };
    const handleClick = ({ target: target })=>{
        setActiveTabWithCallback(target);
        setFocusedTab(target);
    };
    const handleKeyboard = ({ event: event, target: target })=>{
        if (event.key === "ArrowLeft") setFocusedTab(Math.max(0, focusedTab - 1));
        if (event.key === "ArrowRight") setFocusedTab(Math.min(tabs.length - 1, focusedTab + 1));
        if (event.key === "Enter") {
            setActiveTabWithCallback(target);
            setFocusedTab(target);
        }
    };
    const tabItemStyle = theme.tablist.tabitem.styles[style];
    (0, $f2Y41.useEffect)(()=>{
        tabRefs.current[focusedTab]?.focus();
    }, [
        focusedTab
    ]);
    (0, $f2Y41.useImperativeHandle)(ref, ()=>({
            setActiveTab: setActiveTabWithCallback
        }));
    return (0, $ge3KO.jsxs)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        children: [
            (0, $ge3KO.jsx)("div", {
                "aria-label": "Tabs",
                role: "tablist",
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.tablist.base, theme.tablist.styles[style], className),
                ...props,
                children: tabs.map((tab, index)=>(0, $ge3KO.jsxs)("button", {
                        type: "button",
                        "aria-controls": `${id}-tabpanel-${index}`,
                        "aria-selected": index === activeTab,
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.tablist.tabitem.base, tabItemStyle.base, index === activeTab && tabItemStyle.active.on, index !== activeTab && !tab.disabled && tabItemStyle.active.off),
                        disabled: tab.disabled,
                        id: `${id}-tab-${index}`,
                        onClick: ()=>handleClick({
                                target: index
                            }),
                        onKeyDown: (event)=>handleKeyboard({
                                event: event,
                                target: index
                            }),
                        ref: (element)=>tabRefs.current[index] = element,
                        role: "tab",
                        tabIndex: index === focusedTab ? 0 : -1,
                        children: [
                            tab.icon && (0, $ge3KO.jsx)(tab.icon, {
                                className: theme.tablist.tabitem.icon
                            }),
                            tab.title
                        ]
                    }, index))
            }),
            (0, $ge3KO.jsx)("div", {
                children: tabs.map((tab, index)=>(0, $ge3KO.jsx)("div", {
                        "aria-labelledby": `${id}-tab-${index}`,
                        className: theme.tabpanel,
                        hidden: index !== activeTab,
                        id: `${id}-tabpanel-${index}`,
                        role: "tabpanel",
                        tabIndex: 0,
                        children: tab.children
                    }, index))
            })
        ]
    });
});
$a6fc85b69bfdca94$export$fb3aab15d866de8f.displayName = "Tabs.Group";
const $a6fc85b69bfdca94$export$b2539bed5023c21c = {
    Group: $a6fc85b69bfdca94$export$fb3aab15d866de8f,
    Item: (0, $3e957f5643639dda$export$17043b9d35150718)
};



var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");



const $68bd60ba24c90d10$export$76ccd210b9029917 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.table.body, customTheme);
    return (0, $ge3KO.jsx)("tbody", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $f2679dfac93d22d2$export$1e4baea7053fc0e3 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.table.body.cell, customTheme);
    return (0, $ge3KO.jsx)("td", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: children
    });
};



var $f2Y41 = parcelRequire("f2Y41");
const $c67f2a308dcabdcb$export$93e4b0b2cc49b648 = (0, $f2Y41.createContext)(undefined);
function $c67f2a308dcabdcb$export$3cb274deb6c2d854() {
    const context = (0, $f2Y41.useContext)($c67f2a308dcabdcb$export$93e4b0b2cc49b648);
    if (!context) throw new Error("useTableContext should be used within the TableContext provider!");
    return context;
}



var $ge3KO = parcelRequire("ge3KO");



const $e302af2701e1d4d0$export$2f4a7be4f0dcc2 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.table, customTheme);
    return (0, $ge3KO.jsx)("thead", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.head.base, className),
        ...props,
        children: (0, $ge3KO.jsx)("tr", {
            children: children
        })
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $8863714bdd2baf65$export$495ce8e5800ddac3 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.table.head.cell, customTheme);
    return (0, $ge3KO.jsx)("th", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");




const $495a4154f3bdd23a$export$b05581f4e764e162 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const { hoverable: hoverable, striped: striped } = (0, $c67f2a308dcabdcb$export$3cb274deb6c2d854)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.table.row, customTheme);
    return (0, $ge3KO.jsx)("tr", {
        "data-testid": "table-row-element",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, striped && theme.striped, hoverable && theme.hovered, className),
        ...props,
        children: children
    });
};


const $1246381bbeb0cfa4$var$TableComponent = ({ children: children, className: className, hoverable: hoverable, striped: striped, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.table, customTheme);
    return (0, $ge3KO.jsx)("div", {
        "data-testid": "table-element",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.wrapper),
        children: (0, $ge3KO.jsxs)((0, $c67f2a308dcabdcb$export$93e4b0b2cc49b648).Provider, {
            value: {
                striped: striped,
                hoverable: hoverable
            },
            children: [
                (0, $ge3KO.jsx)("div", {
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.shadow, className)
                }),
                (0, $ge3KO.jsx)("table", {
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, className),
                    ...props,
                    children: children
                })
            ]
        })
    });
};
$1246381bbeb0cfa4$var$TableComponent.displayName = "Table";
(0, $e302af2701e1d4d0$export$2f4a7be4f0dcc2).displayName = "Table.Head";
(0, $68bd60ba24c90d10$export$76ccd210b9029917).displayName = "Table.Body";
(0, $495a4154f3bdd23a$export$b05581f4e764e162).displayName = "Table.Row";
(0, $f2679dfac93d22d2$export$1e4baea7053fc0e3).displayName = "Table.Cell";
(0, $8863714bdd2baf65$export$495ce8e5800ddac3).displayName = "Table.HeadCell";
const $1246381bbeb0cfa4$export$54ec01a60f47d33d = Object.assign($1246381bbeb0cfa4$var$TableComponent, {
    Head: (0, $e302af2701e1d4d0$export$2f4a7be4f0dcc2),
    Body: (0, $68bd60ba24c90d10$export$76ccd210b9029917),
    Row: (0, $495a4154f3bdd23a$export$b05581f4e764e162),
    Cell: (0, $f2679dfac93d22d2$export$1e4baea7053fc0e3),
    HeadCell: (0, $8863714bdd2baf65$export$495ce8e5800ddac3)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $36441da6cd5bbe8d$export$c86715117507e8e5 = (0, $f2Y41.forwardRef)(({ addon: addon, className: className, color: color = "gray", helperText: helperText, icon: Icon, rightIcon: RightIcon, shadow: shadow, sizing: sizing = "md", theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.textInput, customTheme);
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            (0, $ge3KO.jsxs)("div", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
                children: [
                    addon && (0, $ge3KO.jsx)("span", {
                        className: theme.addon,
                        children: addon
                    }),
                    (0, $ge3KO.jsxs)("div", {
                        className: theme.field.base,
                        children: [
                            Icon && (0, $ge3KO.jsx)("div", {
                                className: theme.field.icon.base,
                                children: (0, $ge3KO.jsx)(Icon, {
                                    className: theme.field.icon.svg
                                })
                            }),
                            RightIcon && (0, $ge3KO.jsx)("div", {
                                "data-testid": "right-icon",
                                className: theme.field.rightIcon.base,
                                children: (0, $ge3KO.jsx)(RightIcon, {
                                    className: theme.field.rightIcon.svg
                                })
                            }),
                            (0, $ge3KO.jsx)("input", {
                                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.field.input.base, theme.field.input.colors[color], theme.field.input.sizes[sizing], theme.field.input.withIcon[Icon ? "on" : "off"], theme.field.input.withRightIcon[RightIcon ? "on" : "off"], theme.field.input.withAddon[addon ? "on" : "off"], theme.field.input.withShadow[shadow ? "on" : "off"]),
                                ...props,
                                ref: ref
                            })
                        ]
                    })
                ]
            }),
            helperText && (0, $ge3KO.jsx)((0, $12dfa92164d7ac8e$export$7bc3de131d90901c), {
                color: color,
                children: helperText
            })
        ]
    });
});
$36441da6cd5bbe8d$export$c86715117507e8e5.displayName = "TextInput";





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $61ba78db3d684ce1$export$379139ebc1c2b235 = (0, $f2Y41.forwardRef)(({ className: className, color: color = "gray", helperText: helperText, shadow: shadow, theme: customTheme = {}, ...props }, ref)=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.textarea, customTheme);
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            (0, $ge3KO.jsx)("textarea", {
                ref: ref,
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, theme.colors[color], theme.withShadow[shadow ? "on" : "off"], className),
                ...props
            }),
            helperText && (0, $ge3KO.jsx)((0, $12dfa92164d7ac8e$export$7bc3de131d90901c), {
                color: color,
                children: helperText
            })
        ]
    });
});
$61ba78db3d684ce1$export$379139ebc1c2b235.displayName = "Textarea";





var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");



const $2fe4330586998a63$export$de66035ba408dfc9 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline.item.content, customTheme).body;
    return (0, $ge3KO.jsx)("div", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");
const $4044afbcedda886f$export$5f6a83ea6fb0e5e4 = (0, $f2Y41.createContext)(undefined);
function $4044afbcedda886f$export$603ced84cd615914() {
    const context = (0, $f2Y41.useContext)($4044afbcedda886f$export$5f6a83ea6fb0e5e4);
    if (!context) throw new Error("useTimelineContext should be used within the TimelineContext providor!");
    return context;
}


const $517e3f3d94300048$export$f1ff8dd3576a84d9 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline.item.content, customTheme);
    const { horizontal: horizontal } = (0, $4044afbcedda886f$export$603ced84cd615914)();
    return (0, $ge3KO.jsx)("div", {
        "data-testid": "timeline-content",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(horizontal && theme.root.base, className),
        ...props,
        children: children
    });
};




var $ge3KO = parcelRequire("ge3KO");




const $0293fd3a580585f6$export$c187897b30d9e78 = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline.item, customTheme);
    const { horizontal: horizontal } = (0, $4044afbcedda886f$export$603ced84cd615914)();
    return (0, $ge3KO.jsx)("li", {
        "data-testid": "timeline-item",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(horizontal && theme.root.horizontal, !horizontal && theme.root.vertical, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");




const $b80584d018ed58e3$export$3bc3267be998a837 = ({ children: children, className: className, icon: Icon, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline.item.point, customTheme);
    const { horizontal: horizontal } = (0, $4044afbcedda886f$export$603ced84cd615914)();
    return (0, $ge3KO.jsxs)("div", {
        "data-testid": "timeline-point",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(horizontal && theme.horizontal, !horizontal && theme.vertical, className),
        ...props,
        children: [
            children,
            Icon ? (0, $ge3KO.jsx)("span", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.marker.icon.wrapper),
                children: (0, $ge3KO.jsx)(Icon, {
                    "aria-hidden": true,
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.marker.icon.base)
                })
            }) : (0, $ge3KO.jsx)("div", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(horizontal && theme.marker.base.horizontal, !horizontal && theme.marker.base.vertical)
            }),
            horizontal && (0, $ge3KO.jsx)("div", {
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.line)
            })
        ]
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $82b4ddbe197ea9e3$export$7607c85ed2be50b = ({ children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline.item.content, customTheme).time;
    return (0, $ge3KO.jsx)("time", {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
        ...props,
        children: children
    });
};



var $ge3KO = parcelRequire("ge3KO");



const $7326954435728842$export$58e6fb6912ac1da4 = ({ as: Tag = "h3", children: children, className: className, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline.item.content, customTheme).title;
    return (0, $ge3KO.jsx)(Tag, {
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme, className),
        ...props,
        children: children
    });
};


const $8e1a429f9f844851$var$TimelineComponent = ({ children: children, className: className, horizontal: horizontal, theme: customTheme = {}, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.timeline, customTheme);
    return (0, $ge3KO.jsx)((0, $4044afbcedda886f$export$5f6a83ea6fb0e5e4).Provider, {
        value: {
            horizontal: horizontal
        },
        children: (0, $ge3KO.jsx)("ol", {
            "data-testid": "timeline-component",
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(horizontal && theme.root.direction.horizontal, !horizontal && theme.root.direction.vertical, className),
            ...props,
            children: children
        })
    });
};
$8e1a429f9f844851$var$TimelineComponent.displayName = "Timeline";
(0, $0293fd3a580585f6$export$c187897b30d9e78).displayName = "Timeline.Item";
(0, $b80584d018ed58e3$export$3bc3267be998a837).displayName = "Timeline.Point";
(0, $517e3f3d94300048$export$f1ff8dd3576a84d9).displayName = "Timeline.Content";
(0, $82b4ddbe197ea9e3$export$7607c85ed2be50b).displayName = "Timeline.Time";
(0, $7326954435728842$export$58e6fb6912ac1da4).displayName = "Timeline.Title";
(0, $2fe4330586998a63$export$de66035ba408dfc9).displayName = "Timeline.Body";
const $8e1a429f9f844851$export$e6a97ba2cae5bb94 = Object.assign($8e1a429f9f844851$var$TimelineComponent, {
    Item: (0, $0293fd3a580585f6$export$c187897b30d9e78),
    Point: (0, $b80584d018ed58e3$export$3bc3267be998a837),
    Content: (0, $517e3f3d94300048$export$f1ff8dd3576a84d9),
    Time: (0, $82b4ddbe197ea9e3$export$7607c85ed2be50b),
    Title: (0, $7326954435728842$export$58e6fb6912ac1da4),
    Body: (0, $2fe4330586998a63$export$de66035ba408dfc9)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




var $f2Y41 = parcelRequire("f2Y41");
const $c972f5d13a29c893$export$29d4e2ed4674ecfc = (0, $f2Y41.createContext)(undefined);
function $c972f5d13a29c893$export$91b3d218c74c79e4() {
    const context = (0, $f2Y41.useContext)($c972f5d13a29c893$export$29d4e2ed4674ecfc);
    if (!context) throw new Error("useToastContext should be used within the ToastContext provider!");
    return context;
}



var $ge3KO = parcelRequire("ge3KO");





const $b988c24e3b6a5aaa$export$6d0c323ce337aaf0 = ({ className: className, onClick: onClick, theme: customTheme = {}, xIcon: XIcon = (0, $723979f296abdb2d$export$c467cab8758a9d22), onDismiss: onDismiss, ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.toast.toggle, customTheme);
    const { duration: duration, isClosed: isClosed, isRemoved: isRemoved, setIsClosed: setIsClosed, setIsRemoved: setIsRemoved } = (0, $c972f5d13a29c893$export$91b3d218c74c79e4)();
    const handleClick = (e)=>{
        if (onClick) onClick(e);
        if (onDismiss) {
            onDismiss();
            return;
        }
        setIsClosed(!isClosed);
        setTimeout(()=>setIsRemoved(!isRemoved), duration);
    };
    return (0, $ge3KO.jsx)("button", {
        "aria-label": "Close",
        onClick: handleClick,
        type: "button",
        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, className),
        ...props,
        children: (0, $ge3KO.jsx)(XIcon, {
            "aria-hidden": true,
            className: theme.icon
        })
    });
};


const $d9e2ab74db88f2d5$var$durationClasses = {
    75: "duration-75",
    100: "duration-100",
    150: "duration-150",
    200: "duration-200",
    300: "duration-300",
    500: "duration-500",
    700: "duration-700",
    1000: "duration-1000"
};
const $d9e2ab74db88f2d5$var$ToastComponent = ({ children: children, className: className, duration: duration = 300, theme: customTheme = {}, ...props })=>{
    const [isClosed, setIsClosed] = (0, $f2Y41.useState)(false);
    const [isRemoved, setIsRemoved] = (0, $f2Y41.useState)(false);
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.toast, customTheme);
    if (isRemoved) return null;
    return (0, $ge3KO.jsx)((0, $c972f5d13a29c893$export$29d4e2ed4674ecfc).Provider, {
        value: {
            duration: duration,
            isClosed: isClosed,
            isRemoved: isRemoved,
            setIsClosed: setIsClosed,
            setIsRemoved: setIsRemoved
        },
        children: (0, $ge3KO.jsx)("div", {
            "data-testid": "flowbite-toast",
            role: "alert",
            className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, $d9e2ab74db88f2d5$var$durationClasses[duration], isClosed && theme.root.closed, className),
            ...props,
            children: children
        })
    });
};
$d9e2ab74db88f2d5$var$ToastComponent.displayName = "Toast";
(0, $b988c24e3b6a5aaa$export$6d0c323ce337aaf0).displayName = "Toast.Toggle";
const $d9e2ab74db88f2d5$export$8d8dc7d5f743331b = Object.assign($d9e2ab74db88f2d5$var$ToastComponent, {
    Toggle: (0, $b988c24e3b6a5aaa$export$6d0c323ce337aaf0)
});





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



const $5a26ab83e41b91de$export$fb4216da1f591b95 = ({ checked: checked, className: className, color: color = "blue", disabled: disabled, label: label, name: name, onChange: onChange, theme: customTheme = {}, ...props })=>{
    const id = (0, $f2Y41.useId)();
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.toggleSwitch, customTheme);
    const toggle = ()=>onChange(!checked);
    const handleClick = (event)=>{
        event.preventDefault();
        toggle();
    };
    const handleKeyPress = (event)=>{
        event.preventDefault();
    };
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            name && checked && (0, $ge3KO.jsx)("input", {
                checked: checked,
                hidden: true,
                name: name,
                readOnly: true,
                type: "checkbox",
                className: "sr-only"
            }),
            (0, $ge3KO.jsxs)("button", {
                "aria-checked": checked,
                "aria-labelledby": `${id}-flowbite-toggleswitch-label`,
                disabled: disabled,
                id: `${id}-flowbite-toggleswitch`,
                onClick: handleClick,
                onKeyPress: handleKeyPress,
                role: "switch",
                tabIndex: 0,
                type: "button",
                className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.root.base, theme.root.active[disabled ? "off" : "on"], className),
                ...props,
                children: [
                    (0, $ge3KO.jsx)("div", {
                        "data-testid": "flowbite-toggleswitch-toggle",
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.toggle.base, theme.toggle.checked[checked ? "on" : "off"], !disabled && checked && theme.toggle.checked.color[color])
                    }),
                    (0, $ge3KO.jsx)("span", {
                        "data-testid": "flowbite-toggleswitch-label",
                        id: `${id}-flowbite-toggleswitch-label`,
                        className: theme.root.label,
                        children: label
                    })
                ]
            })
        ]
    });
};
$5a26ab83e41b91de$export$fb4216da1f591b95.displayName = "ToggleSwitch";





var $ge3KO = parcelRequire("ge3KO");


var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");



const $6064324e361d0192$export$86b685c13563328b = ({ animation: animation = "duration-300", arrow: arrow = true, children: children, className: className, content: content, placement: placement = "top", style: style = "dark", theme: theme, trigger: trigger = "hover", minWidth: minWidth, ...props })=>{
    const arrowRef = (0, $f2Y41.useRef)(null);
    const [open, setOpen] = (0, $f2Y41.useState)(false);
    const floatingProperties = (0, $b6cdb4560fed9dc0$export$7c8357aca0b07c46)({
        open: open,
        placement: placement,
        arrowRef: arrowRef,
        setOpen: setOpen
    });
    const { context: context, middlewareData: { arrow: { x: arrowX, y: arrowY } = {} }, refs: refs, strategy: strategy, update: update, x: x, y: y } = floatingProperties;
    const focus = (0, $61cd97d3d660dea1$export$f8168d8dd8fd66e6)(context);
    const { getFloatingProps: getFloatingProps, getReferenceProps: getReferenceProps } = (0, $b6cdb4560fed9dc0$export$9e2dc8ad341d7fa1)({
        context: context,
        role: "tooltip",
        trigger: trigger,
        interactions: [
            focus
        ]
    });
    (0, $f2Y41.useEffect)(()=>{
        if (refs.reference.current && refs.floating.current && open) return (0, $022d15fe75fec75f$export$deee3a793edee05f)(refs.reference.current, refs.floating.current, update);
    }, [
        open,
        refs.floating,
        refs.reference,
        update
    ]);
    return (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            (0, $ge3KO.jsx)("div", {
                ref: refs.setReference,
                className: theme.target,
                "data-testid": "flowbite-tooltip-target",
                ...getReferenceProps(),
                children: children
            }),
            (0, $ge3KO.jsxs)("div", {
                ref: refs.setFloating,
                "data-testid": "flowbite-tooltip",
                ...getFloatingProps({
                    className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.base, animation && `${theme.animation} ${animation}`, !open && theme.hidden, theme.style[style], className),
                    style: {
                        position: strategy,
                        top: y ?? " ",
                        left: x ?? " ",
                        minWidth: minWidth
                    },
                    ...props
                }),
                children: [
                    (0, $ge3KO.jsx)("div", {
                        className: theme.content,
                        children: content
                    }),
                    arrow && (0, $ge3KO.jsx)("div", {
                        className: (0, $a58741766239bf1a$export$b4660bb6000dfbc9)(theme.arrow.base, style === "dark" && theme.arrow.style.dark, style === "light" && theme.arrow.style.light, style === "auto" && theme.arrow.style.auto),
                        "data-testid": "flowbite-tooltip-arrow",
                        ref: arrowRef,
                        style: {
                            top: arrowY ?? " ",
                            left: arrowX ?? " ",
                            right: " ",
                            bottom: " ",
                            [(0, $b22ddd23bfdd8353$export$98fe55eaa3d1484b)({
                                placement: floatingProperties.placement
                            })]: theme.arrow.placement
                        },
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
};





const $a49035198e9995d4$export$28c660c63b792dea = ({ animation: animation = "duration-300", arrow: arrow = true, children: children, className: className, content: content, placement: placement = "top", style: style = "dark", theme: customTheme = {}, trigger: trigger = "hover", ...props })=>{
    const theme = (0, $7b2e6ff52600979d$export$dd702b3c8240390c)((0, $28249a7df305c468$export$93d4e7f90805808f)().theme.tooltip, customTheme);
    return (0, $ge3KO.jsx)((0, $6064324e361d0192$export$86b685c13563328b), {
        animation: animation,
        arrow: arrow,
        content: content,
        placement: placement,
        style: style,
        theme: theme,
        trigger: trigger,
        className: className,
        ...props,
        children: children
    });
};
$a49035198e9995d4$export$28c660c63b792dea.displayName = "Tooltip";










function $6538fada2412b751$export$441fbf304cc1216d() {
    const { state: state } = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $ge3KO.jsx)("section", {
        className: "bg-white dark:bg-gray-900 h-full",
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "float-right",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                        content: state,
                        trigger: "click",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            strokeWidth: 1.5,
                            stroke: "currentColor",
                            className: "w-6 h-6",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0112 12.75zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 01-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 002.248-2.354M12 12.75a2.25 2.25 0 01-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 00-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 01.4-2.253M12 8.25a2.25 2.25 0 00-2.248 2.146M12 8.25a2.25 2.25 0 012.248 2.146M8.683 5a6.032 6.032 0 01-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0115.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 00-.575-1.752M4.921 6a24.048 24.048 0 00-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 01-5.223 1.082"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "mx-auto max-w-screen-sm text-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h1", {
                            className: "mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-white",
                            children: "404"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                            className: "mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white",
                            children: "Waypoints has lost its way."
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                            className: "mb-4 text-lg font-light text-gray-500 dark:text-gray-400",
                            children: "Is your VPN connected?"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                            href: "/auth",
                            className: "inline-flex text-gray-500 dark dark:text-gray-200 ring-1 ring-black dark:ring-gray-200 bg-primary-600 hover:bg-primary-800 hover:dark:bg-gray-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4",
                            children: "Try again"
                        })
                    ]
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");

var $ge3KO = parcelRequire("ge3KO");
var $785afa6b592087b8$exports = {};

$parcel$export($785afa6b592087b8$exports, "AcademicCapIcon", function () { return $d3925b99b9a7815a$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "AdjustmentsIcon", function () { return $db9452650296377d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "AnnotationIcon", function () { return $efc5df77e4f794c1$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArchiveIcon", function () { return $1af22fe9a058afab$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowCircleDownIcon", function () { return $01b3999b36f3568e$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowCircleLeftIcon", function () { return $94901b3eb0845500$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowCircleRightIcon", function () { return $21b632533a8d639b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowCircleUpIcon", function () { return $daebe9bfc398d571$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowDownIcon", function () { return $7095058aea4310d1$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowLeftIcon", function () { return $edea62bb6d6d7bff$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowNarrowDownIcon", function () { return $4e0efccbfe8391fd$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowNarrowLeftIcon", function () { return $06bec88141a1cc50$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowNarrowRightIcon", function () { return $d4179988fa03f9ba$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowNarrowUpIcon", function () { return $b763e11fa48c3e80$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowRightIcon", function () { return $81bf745977072c21$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowSmDownIcon", function () { return $fb735cb67f8d8761$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowSmLeftIcon", function () { return $a6960f19f7ce4627$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowSmRightIcon", function () { return $ec57b59f5b93ec8d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowSmUpIcon", function () { return $4dd96a6d1fb8bf7d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowUpIcon", function () { return $8855437d050e7efc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ArrowsExpandIcon", function () { return $1679101798c55686$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "AtSymbolIcon", function () { return $99304345a2a560ac$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BackspaceIcon", function () { return $b2b938567b371fd3$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BadgeCheckIcon", function () { return $db40d386572eb2eb$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BanIcon", function () { return $5c83f9df0ab06eb0$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BeakerIcon", function () { return $0910d692867c022f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BellIcon", function () { return $24fed06f83d1e9ab$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BookOpenIcon", function () { return $e07ed5a24c4c9d74$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BookmarkAltIcon", function () { return $cca66b5c67dc50e6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BookmarkIcon", function () { return $cc28880231d293af$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "BriefcaseIcon", function () { return $6869ca92924088d4$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CakeIcon", function () { return $d1944e2cb9d83c61$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CalculatorIcon", function () { return $6396ba80f977e121$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CalendarIcon", function () { return $492388e9c47d257b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CameraIcon", function () { return $1a043dbf97bf00f3$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CashIcon", function () { return $af9c81586a4ec7ca$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChartBarIcon", function () { return $157140fb4d02f92e$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChartPieIcon", function () { return $0119b085273cd379$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChartSquareBarIcon", function () { return $59e35d1a7064bf64$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChatAlt2Icon", function () { return $c12b2b38683564e0$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChatAltIcon", function () { return $57be9eca594eb68b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChatIcon", function () { return $2551df2bc67131c9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CheckCircleIcon", function () { return $ef47fd468241cd19$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CheckIcon", function () { return $f6629802b98d9a06$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronDoubleDownIcon", function () { return $b96b5c2ac917c256$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronDoubleLeftIcon", function () { return $dfee790095be9917$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronDoubleRightIcon", function () { return $a2dc3562c0a332bc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronDoubleUpIcon", function () { return $bd132e0e38f15094$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronDownIcon", function () { return $d56cce15519a3861$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronLeftIcon", function () { return $9305fe526ba78702$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronRightIcon", function () { return $cad42915b0882b12$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChevronUpIcon", function () { return $6582f2a6e35dffd9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ChipIcon", function () { return $ec57c41eccdcab33$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ClipboardCheckIcon", function () { return $3d88f8c56531ea69$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ClipboardCopyIcon", function () { return $fc4cfbbbbc8daef0$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ClipboardListIcon", function () { return $f492c1956b9b0dad$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ClipboardIcon", function () { return $1ae501856415166c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ClockIcon", function () { return $225cd034a57d6fe4$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CloudDownloadIcon", function () { return $ab56e1c0ef107f69$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CloudUploadIcon", function () { return $d4d93233ea0e353c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CloudIcon", function () { return $e59ac982030322bc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CodeIcon", function () { return $43c7e1ff56f2c655$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CogIcon", function () { return $56b9a59aadb40c5f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CollectionIcon", function () { return $823976ccfe1814ab$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ColorSwatchIcon", function () { return $fd30437052936cc9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CreditCardIcon", function () { return $d61a3e797b94d80f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CubeTransparentIcon", function () { return $fe821e20a3a48a36$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CubeIcon", function () { return $9dc2179e4fde560c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CurrencyBangladeshiIcon", function () { return $f4823ec39558a819$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CurrencyDollarIcon", function () { return $b433fd3ba0fab33b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CurrencyEuroIcon", function () { return $11659f8018ee404b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CurrencyPoundIcon", function () { return $ce6a3b3b0d54eb8d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CurrencyRupeeIcon", function () { return $fbc5cedfbbd3bdac$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CurrencyYenIcon", function () { return $f052cc5755ec906d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "CursorClickIcon", function () { return $8a91c5fa6dbcea33$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DatabaseIcon", function () { return $8e8353c5ea347e74$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DesktopComputerIcon", function () { return $8349dc6af2b14e22$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DeviceMobileIcon", function () { return $c19c3170ed0faaae$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DeviceTabletIcon", function () { return $8aafb285d86820b9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentAddIcon", function () { return $c1a6cac6eb4ab013$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentDownloadIcon", function () { return $4db5bcf3713b24c5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentDuplicateIcon", function () { return $a88c6d3e8c6b7c6f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentRemoveIcon", function () { return $a162b7effcc1287a$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentReportIcon", function () { return $2489820ada05a920$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentSearchIcon", function () { return $6f6d74284deefb67$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentTextIcon", function () { return $9b2402d2885426d7$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DocumentIcon", function () { return $a2e5c2ed3b14c366$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DotsCircleHorizontalIcon", function () { return $a37a2d49cbac79a6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DotsHorizontalIcon", function () { return $e9da778be72cbe0b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DotsVerticalIcon", function () { return $21cc2d12396ff199$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DownloadIcon", function () { return $3107d20b1a3f92f9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "DuplicateIcon", function () { return $903872ecbea6bfa4$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "EmojiHappyIcon", function () { return $34e9ecb9e4e3124b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "EmojiSadIcon", function () { return $80b4042b18f582a9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ExclamationCircleIcon", function () { return $f9a3427ebf6f11b3$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ExclamationIcon", function () { return $b39d158e907899c6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ExternalLinkIcon", function () { return $2ba1c7f258247205$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "EyeOffIcon", function () { return $14d4e2aa13a97de6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "EyeIcon", function () { return $ae143896da4e96e6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FastForwardIcon", function () { return $fd4605c8f4ccce68$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FilmIcon", function () { return $e75c5f29d72610bc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FilterIcon", function () { return $284e2f86a8900218$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FingerPrintIcon", function () { return $02c0178d2a345cdf$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FireIcon", function () { return $74b5c1e3dce035db$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FlagIcon", function () { return $bbfbbadee379457c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FolderAddIcon", function () { return $cf56403e3227debe$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FolderDownloadIcon", function () { return $e490fadd156d8f79$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FolderOpenIcon", function () { return $59d7c3067d0e0b2a$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FolderRemoveIcon", function () { return $466bcf79d9945451$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "FolderIcon", function () { return $4b86d676d28acd16$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "GiftIcon", function () { return $4caaedaa18f8715b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "GlobeAltIcon", function () { return $2c672208645ba52d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "GlobeIcon", function () { return $5b41ebeffc20b7aa$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "HandIcon", function () { return $4a27e65937007049$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "HashtagIcon", function () { return $82b2ba605cfa8255$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "HeartIcon", function () { return $5a9d311039473524$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "HomeIcon", function () { return $ba4805e0fe67c4a9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "IdentificationIcon", function () { return $bcba575abf5b0e05$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "InboxInIcon", function () { return $8cd47aab2aea03b3$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "InboxIcon", function () { return $90342894daf93212$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "InformationCircleIcon", function () { return $23ed955328927767$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "KeyIcon", function () { return $8cd6a57f2c394dcc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LibraryIcon", function () { return $7979fbc81d6e23bf$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LightBulbIcon", function () { return $679291a80e6494f8$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LightningBoltIcon", function () { return $828cc5e222111c8c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LinkIcon", function () { return $be9eeec9710474d1$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LocationMarkerIcon", function () { return $b041181e9c681b23$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LockClosedIcon", function () { return $bb8eec4b1aa59b46$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LockOpenIcon", function () { return $7ab10fe99cf67623$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LoginIcon", function () { return $d2296563ed9ee209$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "LogoutIcon", function () { return $032b470b556e0590$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MailOpenIcon", function () { return $8c457732d0f54d89$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MailIcon", function () { return $be5d9f6b7ac407fc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MapIcon", function () { return $40e11667ecd8b877$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MenuAlt1Icon", function () { return $60ffa98443856fe5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MenuAlt2Icon", function () { return $b20f580d97ce709f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MenuAlt3Icon", function () { return $9a712ca1b70d80fc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MenuAlt4Icon", function () { return $e6a4ab726191fb85$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MenuIcon", function () { return $3ca0138d386a89b7$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MicrophoneIcon", function () { return $5098b2a41665049c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MinusCircleIcon", function () { return $3a568e41358ca77c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MinusSmIcon", function () { return $d66c1ab7ebda84e2$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MinusIcon", function () { return $e52e51f51b33948f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MoonIcon", function () { return $0e812b187da158b1$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "MusicNoteIcon", function () { return $03cd281931e34816$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "NewspaperIcon", function () { return $431ff152d5ec2b74$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "OfficeBuildingIcon", function () { return $fe7bd221dcce92a0$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PaperAirplaneIcon", function () { return $6699f029449d39ae$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PaperClipIcon", function () { return $a99d137b091de198$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PauseIcon", function () { return $c15d34f1dbec1282$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PencilAltIcon", function () { return $05e6a33d825c5c06$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PencilIcon", function () { return $bf2d0e7706307648$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PhoneIncomingIcon", function () { return $010a5d23b369ff4d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PhoneMissedCallIcon", function () { return $9fc5e9b76400ef01$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PhoneOutgoingIcon", function () { return $995de9df238072a9$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PhoneIcon", function () { return $8639672d4fbfea75$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PhotographIcon", function () { return $cfeac43e6810c072$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PlayIcon", function () { return $b5b7e8347998291c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PlusCircleIcon", function () { return $d85e3f0109065bc6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PlusSmIcon", function () { return $db8e900ce1b9622b$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PlusIcon", function () { return $0db9efff570f81ae$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PresentationChartBarIcon", function () { return $db8a4b7b354df0d5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PresentationChartLineIcon", function () { return $4b3649b8eef7668e$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PrinterIcon", function () { return $42de420ff501fca4$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "PuzzleIcon", function () { return $6a23afbf26f4bdcc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "QrcodeIcon", function () { return $220aee607431ab32$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "QuestionMarkCircleIcon", function () { return $41bbdf691453e588$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ReceiptRefundIcon", function () { return $5102be8a36779761$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ReceiptTaxIcon", function () { return $9e68090a317b7ac0$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "RefreshIcon", function () { return $ce04cd6fec08b5d5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ReplyIcon", function () { return $09eea1faceeda14e$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "RewindIcon", function () { return $94bd07be6c090821$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "RssIcon", function () { return $626bf9525b53df6a$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SaveAsIcon", function () { return $97ddbc0887aba310$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SaveIcon", function () { return $407e715318d77af4$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ScaleIcon", function () { return $7fbc6c942733df3d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ScissorsIcon", function () { return $8c9d924a44d75932$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SearchCircleIcon", function () { return $69f5ba3c0f4305af$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SearchIcon", function () { return $6b4cc9fdf609188d$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SelectorIcon", function () { return $9b9afc70d87893a1$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ServerIcon", function () { return $4fcb4c6fb26b138f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ShareIcon", function () { return $a37c4c95d8c06f80$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ShieldCheckIcon", function () { return $b6210bd1654cb840$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ShieldExclamationIcon", function () { return $36ccc78ae34500e0$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ShoppingBagIcon", function () { return $cd660327faa4029c$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ShoppingCartIcon", function () { return $46b83e12943d6e59$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SortAscendingIcon", function () { return $51738c369cbe2dbd$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SortDescendingIcon", function () { return $ff72700759bf23cf$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SparklesIcon", function () { return $a2e2310fbcc990b5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SpeakerphoneIcon", function () { return $c2779ad762e69e19$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "StarIcon", function () { return $a64e2b1e12210ccb$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "StatusOfflineIcon", function () { return $a1561b00c3d68826$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "StatusOnlineIcon", function () { return $76227593d1e9ff04$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "StopIcon", function () { return $4ad1836e73ec9fa3$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SunIcon", function () { return $4221ae8fa91ea051$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SupportIcon", function () { return $766f3c2df1af4739$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SwitchHorizontalIcon", function () { return $5ff2428679c55861$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "SwitchVerticalIcon", function () { return $00f746563b9bda28$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TableIcon", function () { return $a4f71ce759a29fa2$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TagIcon", function () { return $25c0a1e5aaf50daf$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TemplateIcon", function () { return $0551bad37369f20e$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TerminalIcon", function () { return $154b5438450f0341$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ThumbDownIcon", function () { return $8062ef983e1993e7$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ThumbUpIcon", function () { return $912582c9e416b0e4$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TicketIcon", function () { return $aa8cd38df5de6325$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TranslateIcon", function () { return $292762fa5c026c1f$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TrashIcon", function () { return $2e97c473f811a628$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TrendingDownIcon", function () { return $915f6edc00deabec$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TrendingUpIcon", function () { return $f218403482e792d2$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "TruckIcon", function () { return $35ba30a79c312d01$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UploadIcon", function () { return $ddbad23863d18c91$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UserAddIcon", function () { return $08333886350b5f94$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UserCircleIcon", function () { return $6f0870b045c87ef6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UserGroupIcon", function () { return $f5463dc5456d1e45$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UserRemoveIcon", function () { return $3872970a7226267a$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UserIcon", function () { return $3a14717d6f323ed5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "UsersIcon", function () { return $d411d8c712330d41$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "VariableIcon", function () { return $f1beb4d7fcdc49bc$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "VideoCameraIcon", function () { return $73110c95c05c6277$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ViewBoardsIcon", function () { return $45c39f668a7b16ae$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ViewGridAddIcon", function () { return $63d5d42871020be5$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ViewGridIcon", function () { return $328c72db0bc047a6$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ViewListIcon", function () { return $b406d193180f1d76$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "VolumeOffIcon", function () { return $f3211e179910af73$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "VolumeUpIcon", function () { return $f554c94d030d6384$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "WifiIcon", function () { return $f2aa2ed4388ccc9a$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "XCircleIcon", function () { return $341f92d1daab99e1$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "XIcon", function () { return $36f904a99bc777ce$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ZoomInIcon", function () { return $4d2ee6011295c289$export$2e2bcd8739ae039; });
$parcel$export($785afa6b592087b8$exports, "ZoomOutIcon", function () { return $0325c04a55d8f460$export$2e2bcd8739ae039; });

var $f2Y41 = parcelRequire("f2Y41");
function $d3925b99b9a7815a$var$AcademicCapIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
    }));
}
const $d3925b99b9a7815a$var$ForwardRef = $f2Y41.forwardRef($d3925b99b9a7815a$var$AcademicCapIcon);
var $d3925b99b9a7815a$export$2e2bcd8739ae039 = $d3925b99b9a7815a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $db9452650296377d$var$AdjustmentsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
    }));
}
const $db9452650296377d$var$ForwardRef = $f2Y41.forwardRef($db9452650296377d$var$AdjustmentsIcon);
var $db9452650296377d$export$2e2bcd8739ae039 = $db9452650296377d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $efc5df77e4f794c1$var$AnnotationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z",
        clipRule: "evenodd"
    }));
}
const $efc5df77e4f794c1$var$ForwardRef = $f2Y41.forwardRef($efc5df77e4f794c1$var$AnnotationIcon);
var $efc5df77e4f794c1$export$2e2bcd8739ae039 = $efc5df77e4f794c1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1af22fe9a058afab$var$ArchiveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M4 3a2 2 0 100 4h12a2 2 0 100-4H4z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $1af22fe9a058afab$var$ForwardRef = $f2Y41.forwardRef($1af22fe9a058afab$var$ArchiveIcon);
var $1af22fe9a058afab$export$2e2bcd8739ae039 = $1af22fe9a058afab$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $01b3999b36f3568e$var$ArrowCircleDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z",
        clipRule: "evenodd"
    }));
}
const $01b3999b36f3568e$var$ForwardRef = $f2Y41.forwardRef($01b3999b36f3568e$var$ArrowCircleDownIcon);
var $01b3999b36f3568e$export$2e2bcd8739ae039 = $01b3999b36f3568e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $94901b3eb0845500$var$ArrowCircleLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z",
        clipRule: "evenodd"
    }));
}
const $94901b3eb0845500$var$ForwardRef = $f2Y41.forwardRef($94901b3eb0845500$var$ArrowCircleLeftIcon);
var $94901b3eb0845500$export$2e2bcd8739ae039 = $94901b3eb0845500$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $21b632533a8d639b$var$ArrowCircleRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        clipRule: "evenodd"
    }));
}
const $21b632533a8d639b$var$ForwardRef = $f2Y41.forwardRef($21b632533a8d639b$var$ArrowCircleRightIcon);
var $21b632533a8d639b$export$2e2bcd8739ae039 = $21b632533a8d639b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $daebe9bfc398d571$var$ArrowCircleUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z",
        clipRule: "evenodd"
    }));
}
const $daebe9bfc398d571$var$ForwardRef = $f2Y41.forwardRef($daebe9bfc398d571$var$ArrowCircleUpIcon);
var $daebe9bfc398d571$export$2e2bcd8739ae039 = $daebe9bfc398d571$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7095058aea4310d1$var$ArrowDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $7095058aea4310d1$var$ForwardRef = $f2Y41.forwardRef($7095058aea4310d1$var$ArrowDownIcon);
var $7095058aea4310d1$export$2e2bcd8739ae039 = $7095058aea4310d1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $edea62bb6d6d7bff$var$ArrowLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
        clipRule: "evenodd"
    }));
}
const $edea62bb6d6d7bff$var$ForwardRef = $f2Y41.forwardRef($edea62bb6d6d7bff$var$ArrowLeftIcon);
var $edea62bb6d6d7bff$export$2e2bcd8739ae039 = $edea62bb6d6d7bff$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4e0efccbfe8391fd$var$ArrowNarrowDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $4e0efccbfe8391fd$var$ForwardRef = $f2Y41.forwardRef($4e0efccbfe8391fd$var$ArrowNarrowDownIcon);
var $4e0efccbfe8391fd$export$2e2bcd8739ae039 = $4e0efccbfe8391fd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $06bec88141a1cc50$var$ArrowNarrowLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
        clipRule: "evenodd"
    }));
}
const $06bec88141a1cc50$var$ForwardRef = $f2Y41.forwardRef($06bec88141a1cc50$var$ArrowNarrowLeftIcon);
var $06bec88141a1cc50$export$2e2bcd8739ae039 = $06bec88141a1cc50$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d4179988fa03f9ba$var$ArrowNarrowRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $d4179988fa03f9ba$var$ForwardRef = $f2Y41.forwardRef($d4179988fa03f9ba$var$ArrowNarrowRightIcon);
var $d4179988fa03f9ba$export$2e2bcd8739ae039 = $d4179988fa03f9ba$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b763e11fa48c3e80$var$ArrowNarrowUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $b763e11fa48c3e80$var$ForwardRef = $f2Y41.forwardRef($b763e11fa48c3e80$var$ArrowNarrowUpIcon);
var $b763e11fa48c3e80$export$2e2bcd8739ae039 = $b763e11fa48c3e80$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $81bf745977072c21$var$ArrowRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $81bf745977072c21$var$ForwardRef = $f2Y41.forwardRef($81bf745977072c21$var$ArrowRightIcon);
var $81bf745977072c21$export$2e2bcd8739ae039 = $81bf745977072c21$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fb735cb67f8d8761$var$ArrowSmDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $fb735cb67f8d8761$var$ForwardRef = $f2Y41.forwardRef($fb735cb67f8d8761$var$ArrowSmDownIcon);
var $fb735cb67f8d8761$export$2e2bcd8739ae039 = $fb735cb67f8d8761$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a6960f19f7ce4627$var$ArrowSmLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z",
        clipRule: "evenodd"
    }));
}
const $a6960f19f7ce4627$var$ForwardRef = $f2Y41.forwardRef($a6960f19f7ce4627$var$ArrowSmLeftIcon);
var $a6960f19f7ce4627$export$2e2bcd8739ae039 = $a6960f19f7ce4627$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ec57b59f5b93ec8d$var$ArrowSmRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $ec57b59f5b93ec8d$var$ForwardRef = $f2Y41.forwardRef($ec57b59f5b93ec8d$var$ArrowSmRightIcon);
var $ec57b59f5b93ec8d$export$2e2bcd8739ae039 = $ec57b59f5b93ec8d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4dd96a6d1fb8bf7d$var$ArrowSmUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $4dd96a6d1fb8bf7d$var$ForwardRef = $f2Y41.forwardRef($4dd96a6d1fb8bf7d$var$ArrowSmUpIcon);
var $4dd96a6d1fb8bf7d$export$2e2bcd8739ae039 = $4dd96a6d1fb8bf7d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8855437d050e7efc$var$ArrowUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $8855437d050e7efc$var$ForwardRef = $f2Y41.forwardRef($8855437d050e7efc$var$ArrowUpIcon);
var $8855437d050e7efc$export$2e2bcd8739ae039 = $8855437d050e7efc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1679101798c55686$var$ArrowsExpandIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 110-2h4a1 1 0 011 1v4a1 1 0 11-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 112 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 110 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z",
        clipRule: "evenodd"
    }));
}
const $1679101798c55686$var$ForwardRef = $f2Y41.forwardRef($1679101798c55686$var$ArrowsExpandIcon);
var $1679101798c55686$export$2e2bcd8739ae039 = $1679101798c55686$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $99304345a2a560ac$var$AtSymbolIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z",
        clipRule: "evenodd"
    }));
}
const $99304345a2a560ac$var$ForwardRef = $f2Y41.forwardRef($99304345a2a560ac$var$AtSymbolIcon);
var $99304345a2a560ac$export$2e2bcd8739ae039 = $99304345a2a560ac$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b2b938567b371fd3$var$BackspaceIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6.707 4.879A3 3 0 018.828 4H15a3 3 0 013 3v6a3 3 0 01-3 3H8.828a3 3 0 01-2.12-.879l-4.415-4.414a1 1 0 010-1.414l4.414-4.414zm4 2.414a1 1 0 00-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 101.414 1.414L12 11.414l1.293 1.293a1 1 0 001.414-1.414L13.414 10l1.293-1.293a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293z",
        clipRule: "evenodd"
    }));
}
const $b2b938567b371fd3$var$ForwardRef = $f2Y41.forwardRef($b2b938567b371fd3$var$BackspaceIcon);
var $b2b938567b371fd3$export$2e2bcd8739ae039 = $b2b938567b371fd3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $db40d386572eb2eb$var$BadgeCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $db40d386572eb2eb$var$ForwardRef = $f2Y41.forwardRef($db40d386572eb2eb$var$BadgeCheckIcon);
var $db40d386572eb2eb$export$2e2bcd8739ae039 = $db40d386572eb2eb$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5c83f9df0ab06eb0$var$BanIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z",
        clipRule: "evenodd"
    }));
}
const $5c83f9df0ab06eb0$var$ForwardRef = $f2Y41.forwardRef($5c83f9df0ab06eb0$var$BanIcon);
var $5c83f9df0ab06eb0$export$2e2bcd8739ae039 = $5c83f9df0ab06eb0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0910d692867c022f$var$BeakerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z",
        clipRule: "evenodd"
    }));
}
const $0910d692867c022f$var$ForwardRef = $f2Y41.forwardRef($0910d692867c022f$var$BeakerIcon);
var $0910d692867c022f$export$2e2bcd8739ae039 = $0910d692867c022f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $24fed06f83d1e9ab$var$BellIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
    }));
}
const $24fed06f83d1e9ab$var$ForwardRef = $f2Y41.forwardRef($24fed06f83d1e9ab$var$BellIcon);
var $24fed06f83d1e9ab$export$2e2bcd8739ae039 = $24fed06f83d1e9ab$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e07ed5a24c4c9d74$var$BookOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"
    }));
}
const $e07ed5a24c4c9d74$var$ForwardRef = $f2Y41.forwardRef($e07ed5a24c4c9d74$var$BookOpenIcon);
var $e07ed5a24c4c9d74$export$2e2bcd8739ae039 = $e07ed5a24c4c9d74$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cca66b5c67dc50e6$var$BookmarkAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z",
        clipRule: "evenodd"
    }));
}
const $cca66b5c67dc50e6$var$ForwardRef = $f2Y41.forwardRef($cca66b5c67dc50e6$var$BookmarkAltIcon);
var $cca66b5c67dc50e6$export$2e2bcd8739ae039 = $cca66b5c67dc50e6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cc28880231d293af$var$BookmarkIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"
    }));
}
const $cc28880231d293af$var$ForwardRef = $f2Y41.forwardRef($cc28880231d293af$var$BookmarkIcon);
var $cc28880231d293af$export$2e2bcd8739ae039 = $cc28880231d293af$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6869ca92924088d4$var$BriefcaseIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"
    }));
}
const $6869ca92924088d4$var$ForwardRef = $f2Y41.forwardRef($6869ca92924088d4$var$BriefcaseIcon);
var $6869ca92924088d4$export$2e2bcd8739ae039 = $6869ca92924088d4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d1944e2cb9d83c61$var$CakeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 3a1 1 0 011-1h.01a1 1 0 010 2H7a1 1 0 01-1-1zm2 3a1 1 0 00-2 0v1a2 2 0 00-2 2v1a2 2 0 00-2 2v.683a3.7 3.7 0 011.055.485 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0A3.7 3.7 0 0118 12.683V12a2 2 0 00-2-2V9a2 2 0 00-2-2V6a1 1 0 10-2 0v1h-1V6a1 1 0 10-2 0v1H8V6zm10 8.868a3.704 3.704 0 01-4.055-.036 1.704 1.704 0 00-1.89 0 3.704 3.704 0 01-4.11 0 1.704 1.704 0 00-1.89 0A3.704 3.704 0 012 14.868V17a1 1 0 001 1h14a1 1 0 001-1v-2.132zM9 3a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm3 0a1 1 0 011-1h.01a1 1 0 110 2H13a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $d1944e2cb9d83c61$var$ForwardRef = $f2Y41.forwardRef($d1944e2cb9d83c61$var$CakeIcon);
var $d1944e2cb9d83c61$export$2e2bcd8739ae039 = $d1944e2cb9d83c61$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6396ba80f977e121$var$CalculatorIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm6 7a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 3a1 1 0 100 2h.01a1 1 0 100-2H10zm-4 1a1 1 0 011-1h.01a1 1 0 110 2H7a1 1 0 01-1-1zm1-4a1 1 0 100 2h.01a1 1 0 100-2H7zm2 1a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm4-4a1 1 0 100 2h.01a1 1 0 100-2H13zM9 9a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zM7 8a1 1 0 000 2h.01a1 1 0 000-2H7z",
        clipRule: "evenodd"
    }));
}
const $6396ba80f977e121$var$ForwardRef = $f2Y41.forwardRef($6396ba80f977e121$var$CalculatorIcon);
var $6396ba80f977e121$export$2e2bcd8739ae039 = $6396ba80f977e121$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $492388e9c47d257b$var$CalendarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
        clipRule: "evenodd"
    }));
}
const $492388e9c47d257b$var$ForwardRef = $f2Y41.forwardRef($492388e9c47d257b$var$CalendarIcon);
var $492388e9c47d257b$export$2e2bcd8739ae039 = $492388e9c47d257b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1a043dbf97bf00f3$var$CameraIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z",
        clipRule: "evenodd"
    }));
}
const $1a043dbf97bf00f3$var$ForwardRef = $f2Y41.forwardRef($1a043dbf97bf00f3$var$CameraIcon);
var $1a043dbf97bf00f3$export$2e2bcd8739ae039 = $1a043dbf97bf00f3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $af9c81586a4ec7ca$var$CashIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z",
        clipRule: "evenodd"
    }));
}
const $af9c81586a4ec7ca$var$ForwardRef = $f2Y41.forwardRef($af9c81586a4ec7ca$var$CashIcon);
var $af9c81586a4ec7ca$export$2e2bcd8739ae039 = $af9c81586a4ec7ca$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $157140fb4d02f92e$var$ChartBarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"
    }));
}
const $157140fb4d02f92e$var$ForwardRef = $f2Y41.forwardRef($157140fb4d02f92e$var$ChartBarIcon);
var $157140fb4d02f92e$export$2e2bcd8739ae039 = $157140fb4d02f92e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0119b085273cd379$var$ChartPieIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"
    }));
}
const $0119b085273cd379$var$ForwardRef = $f2Y41.forwardRef($0119b085273cd379$var$ChartPieIcon);
var $0119b085273cd379$export$2e2bcd8739ae039 = $0119b085273cd379$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $59e35d1a7064bf64$var$ChartSquareBarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z",
        clipRule: "evenodd"
    }));
}
const $59e35d1a7064bf64$var$ForwardRef = $f2Y41.forwardRef($59e35d1a7064bf64$var$ChartSquareBarIcon);
var $59e35d1a7064bf64$export$2e2bcd8739ae039 = $59e35d1a7064bf64$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c12b2b38683564e0$var$ChatAlt2Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
    }));
}
const $c12b2b38683564e0$var$ForwardRef = $f2Y41.forwardRef($c12b2b38683564e0$var$ChatAlt2Icon);
var $c12b2b38683564e0$export$2e2bcd8739ae039 = $c12b2b38683564e0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $57be9eca594eb68b$var$ChatAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z",
        clipRule: "evenodd"
    }));
}
const $57be9eca594eb68b$var$ForwardRef = $f2Y41.forwardRef($57be9eca594eb68b$var$ChatAltIcon);
var $57be9eca594eb68b$export$2e2bcd8739ae039 = $57be9eca594eb68b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2551df2bc67131c9$var$ChatIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
        clipRule: "evenodd"
    }));
}
const $2551df2bc67131c9$var$ForwardRef = $f2Y41.forwardRef($2551df2bc67131c9$var$ChatIcon);
var $2551df2bc67131c9$export$2e2bcd8739ae039 = $2551df2bc67131c9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ef47fd468241cd19$var$CheckCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $ef47fd468241cd19$var$ForwardRef = $f2Y41.forwardRef($ef47fd468241cd19$var$CheckCircleIcon);
var $ef47fd468241cd19$export$2e2bcd8739ae039 = $ef47fd468241cd19$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f6629802b98d9a06$var$CheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $f6629802b98d9a06$var$ForwardRef = $f2Y41.forwardRef($f6629802b98d9a06$var$CheckIcon);
var $f6629802b98d9a06$export$2e2bcd8739ae039 = $f6629802b98d9a06$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b96b5c2ac917c256$var$ChevronDoubleDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $b96b5c2ac917c256$var$ForwardRef = $f2Y41.forwardRef($b96b5c2ac917c256$var$ChevronDoubleDownIcon);
var $b96b5c2ac917c256$export$2e2bcd8739ae039 = $b96b5c2ac917c256$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $dfee790095be9917$var$ChevronDoubleLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
        clipRule: "evenodd"
    }));
}
const $dfee790095be9917$var$ForwardRef = $f2Y41.forwardRef($dfee790095be9917$var$ChevronDoubleLeftIcon);
var $dfee790095be9917$export$2e2bcd8739ae039 = $dfee790095be9917$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a2dc3562c0a332bc$var$ChevronDoubleRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $a2dc3562c0a332bc$var$ForwardRef = $f2Y41.forwardRef($a2dc3562c0a332bc$var$ChevronDoubleRightIcon);
var $a2dc3562c0a332bc$export$2e2bcd8739ae039 = $a2dc3562c0a332bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bd132e0e38f15094$var$ChevronDoubleUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $bd132e0e38f15094$var$ForwardRef = $f2Y41.forwardRef($bd132e0e38f15094$var$ChevronDoubleUpIcon);
var $bd132e0e38f15094$export$2e2bcd8739ae039 = $bd132e0e38f15094$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d56cce15519a3861$var$ChevronDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $d56cce15519a3861$var$ForwardRef = $f2Y41.forwardRef($d56cce15519a3861$var$ChevronDownIcon);
var $d56cce15519a3861$export$2e2bcd8739ae039 = $d56cce15519a3861$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9305fe526ba78702$var$ChevronLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $9305fe526ba78702$var$ForwardRef = $f2Y41.forwardRef($9305fe526ba78702$var$ChevronLeftIcon);
var $9305fe526ba78702$export$2e2bcd8739ae039 = $9305fe526ba78702$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cad42915b0882b12$var$ChevronRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $cad42915b0882b12$var$ForwardRef = $f2Y41.forwardRef($cad42915b0882b12$var$ChevronRightIcon);
var $cad42915b0882b12$export$2e2bcd8739ae039 = $cad42915b0882b12$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6582f2a6e35dffd9$var$ChevronUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
        clipRule: "evenodd"
    }));
}
const $6582f2a6e35dffd9$var$ForwardRef = $f2Y41.forwardRef($6582f2a6e35dffd9$var$ChevronUpIcon);
var $6582f2a6e35dffd9$export$2e2bcd8739ae039 = $6582f2a6e35dffd9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ec57c41eccdcab33$var$ChipIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M13 7H7v6h6V7z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z",
        clipRule: "evenodd"
    }));
}
const $ec57c41eccdcab33$var$ForwardRef = $f2Y41.forwardRef($ec57c41eccdcab33$var$ChipIcon);
var $ec57c41eccdcab33$export$2e2bcd8739ae039 = $ec57c41eccdcab33$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3d88f8c56531ea69$var$ClipboardCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $3d88f8c56531ea69$var$ForwardRef = $f2Y41.forwardRef($3d88f8c56531ea69$var$ClipboardCheckIcon);
var $3d88f8c56531ea69$export$2e2bcd8739ae039 = $3d88f8c56531ea69$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fc4cfbbbbc8daef0$var$ClipboardCopyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8 2a1 1 0 000 2h2a1 1 0 100-2H8z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z"
    }));
}
const $fc4cfbbbbc8daef0$var$ForwardRef = $f2Y41.forwardRef($fc4cfbbbbc8daef0$var$ClipboardCopyIcon);
var $fc4cfbbbbc8daef0$export$2e2bcd8739ae039 = $fc4cfbbbbc8daef0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f492c1956b9b0dad$var$ClipboardListIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z",
        clipRule: "evenodd"
    }));
}
const $f492c1956b9b0dad$var$ForwardRef = $f2Y41.forwardRef($f492c1956b9b0dad$var$ClipboardListIcon);
var $f492c1956b9b0dad$export$2e2bcd8739ae039 = $f492c1956b9b0dad$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1ae501856415166c$var$ClipboardIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
    }));
}
const $1ae501856415166c$var$ForwardRef = $f2Y41.forwardRef($1ae501856415166c$var$ClipboardIcon);
var $1ae501856415166c$export$2e2bcd8739ae039 = $1ae501856415166c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $225cd034a57d6fe4$var$ClockIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
        clipRule: "evenodd"
    }));
}
const $225cd034a57d6fe4$var$ForwardRef = $f2Y41.forwardRef($225cd034a57d6fe4$var$ClockIcon);
var $225cd034a57d6fe4$export$2e2bcd8739ae039 = $225cd034a57d6fe4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ab56e1c0ef107f69$var$CloudDownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z",
        clipRule: "evenodd"
    }));
}
const $ab56e1c0ef107f69$var$ForwardRef = $f2Y41.forwardRef($ab56e1c0ef107f69$var$CloudDownloadIcon);
var $ab56e1c0ef107f69$export$2e2bcd8739ae039 = $ab56e1c0ef107f69$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d4d93233ea0e353c$var$CloudUploadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 13h2v5a1 1 0 11-2 0v-5z"
    }));
}
const $d4d93233ea0e353c$var$ForwardRef = $f2Y41.forwardRef($d4d93233ea0e353c$var$CloudUploadIcon);
var $d4d93233ea0e353c$export$2e2bcd8739ae039 = $d4d93233ea0e353c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e59ac982030322bc$var$CloudIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"
    }));
}
const $e59ac982030322bc$var$ForwardRef = $f2Y41.forwardRef($e59ac982030322bc$var$CloudIcon);
var $e59ac982030322bc$export$2e2bcd8739ae039 = $e59ac982030322bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $43c7e1ff56f2c655$var$CodeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $43c7e1ff56f2c655$var$ForwardRef = $f2Y41.forwardRef($43c7e1ff56f2c655$var$CodeIcon);
var $43c7e1ff56f2c655$export$2e2bcd8739ae039 = $43c7e1ff56f2c655$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $56b9a59aadb40c5f$var$CogIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
        clipRule: "evenodd"
    }));
}
const $56b9a59aadb40c5f$var$ForwardRef = $f2Y41.forwardRef($56b9a59aadb40c5f$var$CogIcon);
var $56b9a59aadb40c5f$export$2e2bcd8739ae039 = $56b9a59aadb40c5f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $823976ccfe1814ab$var$CollectionIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"
    }));
}
const $823976ccfe1814ab$var$ForwardRef = $f2Y41.forwardRef($823976ccfe1814ab$var$CollectionIcon);
var $823976ccfe1814ab$export$2e2bcd8739ae039 = $823976ccfe1814ab$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fd30437052936cc9$var$ColorSwatchIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z",
        clipRule: "evenodd"
    }));
}
const $fd30437052936cc9$var$ForwardRef = $f2Y41.forwardRef($fd30437052936cc9$var$ColorSwatchIcon);
var $fd30437052936cc9$export$2e2bcd8739ae039 = $fd30437052936cc9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d61a3e797b94d80f$var$CreditCardIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
        clipRule: "evenodd"
    }));
}
const $d61a3e797b94d80f$var$ForwardRef = $f2Y41.forwardRef($d61a3e797b94d80f$var$CreditCardIcon);
var $d61a3e797b94d80f$export$2e2bcd8739ae039 = $d61a3e797b94d80f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fe821e20a3a48a36$var$CubeTransparentIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z",
        clipRule: "evenodd"
    }));
}
const $fe821e20a3a48a36$var$ForwardRef = $f2Y41.forwardRef($fe821e20a3a48a36$var$CubeTransparentIcon);
var $fe821e20a3a48a36$export$2e2bcd8739ae039 = $fe821e20a3a48a36$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9dc2179e4fde560c$var$CubeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z"
    }));
}
const $9dc2179e4fde560c$var$ForwardRef = $f2Y41.forwardRef($9dc2179e4fde560c$var$CubeIcon);
var $9dc2179e4fde560c$export$2e2bcd8739ae039 = $9dc2179e4fde560c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f4823ec39558a819$var$CurrencyBangladeshiIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 4a1 1 0 000 2 1 1 0 011 1v1H7a1 1 0 000 2h1v3a3 3 0 106 0v-1a1 1 0 10-2 0v1a1 1 0 11-2 0v-3h3a1 1 0 100-2h-3V7a3 3 0 00-3-3z",
        clipRule: "evenodd"
    }));
}
const $f4823ec39558a819$var$ForwardRef = $f2Y41.forwardRef($f4823ec39558a819$var$CurrencyBangladeshiIcon);
var $f4823ec39558a819$export$2e2bcd8739ae039 = $f4823ec39558a819$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b433fd3ba0fab33b$var$CurrencyDollarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z",
        clipRule: "evenodd"
    }));
}
const $b433fd3ba0fab33b$var$ForwardRef = $f2Y41.forwardRef($b433fd3ba0fab33b$var$CurrencyDollarIcon);
var $b433fd3ba0fab33b$export$2e2bcd8739ae039 = $b433fd3ba0fab33b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $11659f8018ee404b$var$CurrencyEuroIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z",
        clipRule: "evenodd"
    }));
}
const $11659f8018ee404b$var$ForwardRef = $f2Y41.forwardRef($11659f8018ee404b$var$CurrencyEuroIcon);
var $11659f8018ee404b$export$2e2bcd8739ae039 = $11659f8018ee404b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ce6a3b3b0d54eb8d$var$CurrencyPoundIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-14a3 3 0 00-3 3v2H7a1 1 0 000 2h1v1a1 1 0 01-1 1 1 1 0 100 2h6a1 1 0 100-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 100-2h-1V7a1 1 0 112 0 1 1 0 102 0 3 3 0 00-3-3z",
        clipRule: "evenodd"
    }));
}
const $ce6a3b3b0d54eb8d$var$ForwardRef = $f2Y41.forwardRef($ce6a3b3b0d54eb8d$var$CurrencyPoundIcon);
var $ce6a3b3b0d54eb8d$export$2e2bcd8739ae039 = $ce6a3b3b0d54eb8d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fbc5cedfbbd3bdac$var$CurrencyRupeeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 5a1 1 0 100 2h1a2 2 0 011.732 1H7a1 1 0 100 2h2.732A2 2 0 018 11H7a1 1 0 00-.707 1.707l3 3a1 1 0 001.414-1.414l-1.483-1.484A4.008 4.008 0 0011.874 10H13a1 1 0 100-2h-1.126a3.976 3.976 0 00-.41-1H13a1 1 0 100-2H7z",
        clipRule: "evenodd"
    }));
}
const $fbc5cedfbbd3bdac$var$ForwardRef = $f2Y41.forwardRef($fbc5cedfbbd3bdac$var$CurrencyRupeeIcon);
var $fbc5cedfbbd3bdac$export$2e2bcd8739ae039 = $fbc5cedfbbd3bdac$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f052cc5755ec906d$var$CurrencyYenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7.858 5.485a1 1 0 00-1.715 1.03L7.633 9H7a1 1 0 100 2h1.834l.166.277V12H7a1 1 0 100 2h2v1a1 1 0 102 0v-1h2a1 1 0 100-2h-2v-.723l.166-.277H13a1 1 0 100-2h-.634l1.492-2.486a1 1 0 10-1.716-1.029L10.034 9h-.068L7.858 5.485z",
        clipRule: "evenodd"
    }));
}
const $f052cc5755ec906d$var$ForwardRef = $f2Y41.forwardRef($f052cc5755ec906d$var$CurrencyYenIcon);
var $f052cc5755ec906d$export$2e2bcd8739ae039 = $f052cc5755ec906d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8a91c5fa6dbcea33$var$CursorClickIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z",
        clipRule: "evenodd"
    }));
}
const $8a91c5fa6dbcea33$var$ForwardRef = $f2Y41.forwardRef($8a91c5fa6dbcea33$var$CursorClickIcon);
var $8a91c5fa6dbcea33$export$2e2bcd8739ae039 = $8a91c5fa6dbcea33$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8e8353c5ea347e74$var$DatabaseIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z"
    }));
}
const $8e8353c5ea347e74$var$ForwardRef = $f2Y41.forwardRef($8e8353c5ea347e74$var$DatabaseIcon);
var $8e8353c5ea347e74$export$2e2bcd8739ae039 = $8e8353c5ea347e74$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8349dc6af2b14e22$var$DesktopComputerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z",
        clipRule: "evenodd"
    }));
}
const $8349dc6af2b14e22$var$ForwardRef = $f2Y41.forwardRef($8349dc6af2b14e22$var$DesktopComputerIcon);
var $8349dc6af2b14e22$export$2e2bcd8739ae039 = $8349dc6af2b14e22$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c19c3170ed0faaae$var$DeviceMobileIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
}
const $c19c3170ed0faaae$var$ForwardRef = $f2Y41.forwardRef($c19c3170ed0faaae$var$DeviceMobileIcon);
var $c19c3170ed0faaae$export$2e2bcd8739ae039 = $c19c3170ed0faaae$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8aafb285d86820b9$var$DeviceTabletIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
}
const $8aafb285d86820b9$var$ForwardRef = $f2Y41.forwardRef($8aafb285d86820b9$var$DeviceTabletIcon);
var $8aafb285d86820b9$export$2e2bcd8739ae039 = $8aafb285d86820b9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c1a6cac6eb4ab013$var$DocumentAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z",
        clipRule: "evenodd"
    }));
}
const $c1a6cac6eb4ab013$var$ForwardRef = $f2Y41.forwardRef($c1a6cac6eb4ab013$var$DocumentAddIcon);
var $c1a6cac6eb4ab013$export$2e2bcd8739ae039 = $c1a6cac6eb4ab013$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4db5bcf3713b24c5$var$DocumentDownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z",
        clipRule: "evenodd"
    }));
}
const $4db5bcf3713b24c5$var$ForwardRef = $f2Y41.forwardRef($4db5bcf3713b24c5$var$DocumentDownloadIcon);
var $4db5bcf3713b24c5$export$2e2bcd8739ae039 = $4db5bcf3713b24c5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a88c6d3e8c6b7c6f$var$DocumentDuplicateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
    }));
}
const $a88c6d3e8c6b7c6f$var$ForwardRef = $f2Y41.forwardRef($a88c6d3e8c6b7c6f$var$DocumentDuplicateIcon);
var $a88c6d3e8c6b7c6f$export$2e2bcd8739ae039 = $a88c6d3e8c6b7c6f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a162b7effcc1287a$var$DocumentRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm1 8a1 1 0 100 2h6a1 1 0 100-2H7z",
        clipRule: "evenodd"
    }));
}
const $a162b7effcc1287a$var$ForwardRef = $f2Y41.forwardRef($a162b7effcc1287a$var$DocumentRemoveIcon);
var $a162b7effcc1287a$export$2e2bcd8739ae039 = $a162b7effcc1287a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2489820ada05a920$var$DocumentReportIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z",
        clipRule: "evenodd"
    }));
}
const $2489820ada05a920$var$ForwardRef = $f2Y41.forwardRef($2489820ada05a920$var$DocumentReportIcon);
var $2489820ada05a920$export$2e2bcd8739ae039 = $2489820ada05a920$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6f6d74284deefb67$var$DocumentSearchIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
        clipRule: "evenodd"
    }));
}
const $6f6d74284deefb67$var$ForwardRef = $f2Y41.forwardRef($6f6d74284deefb67$var$DocumentSearchIcon);
var $6f6d74284deefb67$export$2e2bcd8739ae039 = $6f6d74284deefb67$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9b2402d2885426d7$var$DocumentTextIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
        clipRule: "evenodd"
    }));
}
const $9b2402d2885426d7$var$ForwardRef = $f2Y41.forwardRef($9b2402d2885426d7$var$DocumentTextIcon);
var $9b2402d2885426d7$export$2e2bcd8739ae039 = $9b2402d2885426d7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a2e5c2ed3b14c366$var$DocumentIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
        clipRule: "evenodd"
    }));
}
const $a2e5c2ed3b14c366$var$ForwardRef = $f2Y41.forwardRef($a2e5c2ed3b14c366$var$DocumentIcon);
var $a2e5c2ed3b14c366$export$2e2bcd8739ae039 = $a2e5c2ed3b14c366$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a37a2d49cbac79a6$var$DotsCircleHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
        clipRule: "evenodd"
    }));
}
const $a37a2d49cbac79a6$var$ForwardRef = $f2Y41.forwardRef($a37a2d49cbac79a6$var$DotsCircleHorizontalIcon);
var $a37a2d49cbac79a6$export$2e2bcd8739ae039 = $a37a2d49cbac79a6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e9da778be72cbe0b$var$DotsHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
    }));
}
const $e9da778be72cbe0b$var$ForwardRef = $f2Y41.forwardRef($e9da778be72cbe0b$var$DotsHorizontalIcon);
var $e9da778be72cbe0b$export$2e2bcd8739ae039 = $e9da778be72cbe0b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $21cc2d12396ff199$var$DotsVerticalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
    }));
}
const $21cc2d12396ff199$var$ForwardRef = $f2Y41.forwardRef($21cc2d12396ff199$var$DotsVerticalIcon);
var $21cc2d12396ff199$export$2e2bcd8739ae039 = $21cc2d12396ff199$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3107d20b1a3f92f9$var$DownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $3107d20b1a3f92f9$var$ForwardRef = $f2Y41.forwardRef($3107d20b1a3f92f9$var$DownloadIcon);
var $3107d20b1a3f92f9$export$2e2bcd8739ae039 = $3107d20b1a3f92f9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $903872ecbea6bfa4$var$DuplicateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"
    }));
}
const $903872ecbea6bfa4$var$ForwardRef = $f2Y41.forwardRef($903872ecbea6bfa4$var$DuplicateIcon);
var $903872ecbea6bfa4$export$2e2bcd8739ae039 = $903872ecbea6bfa4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $34e9ecb9e4e3124b$var$EmojiHappyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z",
        clipRule: "evenodd"
    }));
}
const $34e9ecb9e4e3124b$var$ForwardRef = $f2Y41.forwardRef($34e9ecb9e4e3124b$var$EmojiHappyIcon);
var $34e9ecb9e4e3124b$export$2e2bcd8739ae039 = $34e9ecb9e4e3124b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $80b4042b18f582a9$var$EmojiSadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z",
        clipRule: "evenodd"
    }));
}
const $80b4042b18f582a9$var$ForwardRef = $f2Y41.forwardRef($80b4042b18f582a9$var$EmojiSadIcon);
var $80b4042b18f582a9$export$2e2bcd8739ae039 = $80b4042b18f582a9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f9a3427ebf6f11b3$var$ExclamationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $f9a3427ebf6f11b3$var$ForwardRef = $f2Y41.forwardRef($f9a3427ebf6f11b3$var$ExclamationCircleIcon);
var $f9a3427ebf6f11b3$export$2e2bcd8739ae039 = $f9a3427ebf6f11b3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b39d158e907899c6$var$ExclamationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $b39d158e907899c6$var$ForwardRef = $f2Y41.forwardRef($b39d158e907899c6$var$ExclamationIcon);
var $b39d158e907899c6$export$2e2bcd8739ae039 = $b39d158e907899c6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2ba1c7f258247205$var$ExternalLinkIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
    }));
}
const $2ba1c7f258247205$var$ForwardRef = $f2Y41.forwardRef($2ba1c7f258247205$var$ExternalLinkIcon);
var $2ba1c7f258247205$export$2e2bcd8739ae039 = $2ba1c7f258247205$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $14d4e2aa13a97de6$var$EyeOffIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
    }));
}
const $14d4e2aa13a97de6$var$ForwardRef = $f2Y41.forwardRef($14d4e2aa13a97de6$var$EyeOffIcon);
var $14d4e2aa13a97de6$export$2e2bcd8739ae039 = $14d4e2aa13a97de6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ae143896da4e96e6$var$EyeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10 12a2 2 0 100-4 2 2 0 000 4z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
        clipRule: "evenodd"
    }));
}
const $ae143896da4e96e6$var$ForwardRef = $f2Y41.forwardRef($ae143896da4e96e6$var$EyeIcon);
var $ae143896da4e96e6$export$2e2bcd8739ae039 = $ae143896da4e96e6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fd4605c8f4ccce68$var$FastForwardIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z"
    }));
}
const $fd4605c8f4ccce68$var$ForwardRef = $f2Y41.forwardRef($fd4605c8f4ccce68$var$FastForwardIcon);
var $fd4605c8f4ccce68$export$2e2bcd8739ae039 = $fd4605c8f4ccce68$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e75c5f29d72610bc$var$FilmIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm3 2h6v4H7V5zm8 8v2h1v-2h-1zm-2-2H7v4h6v-4zm2 0h1V9h-1v2zm1-4V5h-1v2h1zM5 5v2H4V5h1zm0 4H4v2h1V9zm-1 4h1v2H4v-2z",
        clipRule: "evenodd"
    }));
}
const $e75c5f29d72610bc$var$ForwardRef = $f2Y41.forwardRef($e75c5f29d72610bc$var$FilmIcon);
var $e75c5f29d72610bc$export$2e2bcd8739ae039 = $e75c5f29d72610bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $284e2f86a8900218$var$FilterIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z",
        clipRule: "evenodd"
    }));
}
const $284e2f86a8900218$var$ForwardRef = $f2Y41.forwardRef($284e2f86a8900218$var$FilterIcon);
var $284e2f86a8900218$export$2e2bcd8739ae039 = $284e2f86a8900218$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $02c0178d2a345cdf$var$FingerPrintIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z",
        clipRule: "evenodd"
    }));
}
const $02c0178d2a345cdf$var$ForwardRef = $f2Y41.forwardRef($02c0178d2a345cdf$var$FingerPrintIcon);
var $02c0178d2a345cdf$export$2e2bcd8739ae039 = $02c0178d2a345cdf$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $74b5c1e3dce035db$var$FireIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z",
        clipRule: "evenodd"
    }));
}
const $74b5c1e3dce035db$var$ForwardRef = $f2Y41.forwardRef($74b5c1e3dce035db$var$FireIcon);
var $74b5c1e3dce035db$export$2e2bcd8739ae039 = $74b5c1e3dce035db$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bbfbbadee379457c$var$FlagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z",
        clipRule: "evenodd"
    }));
}
const $bbfbbadee379457c$var$ForwardRef = $f2Y41.forwardRef($bbfbbadee379457c$var$FlagIcon);
var $bbfbbadee379457c$export$2e2bcd8739ae039 = $bbfbbadee379457c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cf56403e3227debe$var$FolderAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1H8a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V9z"
    }));
}
const $cf56403e3227debe$var$ForwardRef = $f2Y41.forwardRef($cf56403e3227debe$var$FolderAddIcon);
var $cf56403e3227debe$export$2e2bcd8739ae039 = $cf56403e3227debe$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e490fadd156d8f79$var$FolderDownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1.586l-.293-.293a1 1 0 10-1.414 1.414l2 2 .002.002a.997.997 0 001.41 0l.002-.002 2-2a1 1 0 00-1.414-1.414l-.293.293V9z"
    }));
}
const $e490fadd156d8f79$var$ForwardRef = $f2Y41.forwardRef($e490fadd156d8f79$var$FolderDownloadIcon);
var $e490fadd156d8f79$export$2e2bcd8739ae039 = $e490fadd156d8f79$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $59d7c3067d0e0b2a$var$FolderOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"
    }));
}
const $59d7c3067d0e0b2a$var$ForwardRef = $f2Y41.forwardRef($59d7c3067d0e0b2a$var$FolderOpenIcon);
var $59d7c3067d0e0b2a$export$2e2bcd8739ae039 = $59d7c3067d0e0b2a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $466bcf79d9945451$var$FolderRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm4 6a1 1 0 100 2h4a1 1 0 100-2H8z"
    }));
}
const $466bcf79d9945451$var$ForwardRef = $f2Y41.forwardRef($466bcf79d9945451$var$FolderRemoveIcon);
var $466bcf79d9945451$export$2e2bcd8739ae039 = $466bcf79d9945451$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4b86d676d28acd16$var$FolderIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
    }));
}
const $4b86d676d28acd16$var$ForwardRef = $f2Y41.forwardRef($4b86d676d28acd16$var$FolderIcon);
var $4b86d676d28acd16$export$2e2bcd8739ae039 = $4b86d676d28acd16$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4caaedaa18f8715b$var$GiftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z"
    }));
}
const $4caaedaa18f8715b$var$ForwardRef = $f2Y41.forwardRef($4caaedaa18f8715b$var$GiftIcon);
var $4caaedaa18f8715b$export$2e2bcd8739ae039 = $4caaedaa18f8715b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2c672208645ba52d$var$GlobeAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
        clipRule: "evenodd"
    }));
}
const $2c672208645ba52d$var$ForwardRef = $f2Y41.forwardRef($2c672208645ba52d$var$GlobeAltIcon);
var $2c672208645ba52d$export$2e2bcd8739ae039 = $2c672208645ba52d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5b41ebeffc20b7aa$var$GlobeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z",
        clipRule: "evenodd"
    }));
}
const $5b41ebeffc20b7aa$var$ForwardRef = $f2Y41.forwardRef($5b41ebeffc20b7aa$var$GlobeIcon);
var $5b41ebeffc20b7aa$export$2e2bcd8739ae039 = $5b41ebeffc20b7aa$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4a27e65937007049$var$HandIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z",
        clipRule: "evenodd"
    }));
}
const $4a27e65937007049$var$ForwardRef = $f2Y41.forwardRef($4a27e65937007049$var$HandIcon);
var $4a27e65937007049$export$2e2bcd8739ae039 = $4a27e65937007049$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $82b2ba605cfa8255$var$HashtagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z",
        clipRule: "evenodd"
    }));
}
const $82b2ba605cfa8255$var$ForwardRef = $f2Y41.forwardRef($82b2ba605cfa8255$var$HashtagIcon);
var $82b2ba605cfa8255$export$2e2bcd8739ae039 = $82b2ba605cfa8255$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5a9d311039473524$var$HeartIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
        clipRule: "evenodd"
    }));
}
const $5a9d311039473524$var$ForwardRef = $f2Y41.forwardRef($5a9d311039473524$var$HeartIcon);
var $5a9d311039473524$export$2e2bcd8739ae039 = $5a9d311039473524$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ba4805e0fe67c4a9$var$HomeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
    }));
}
const $ba4805e0fe67c4a9$var$ForwardRef = $f2Y41.forwardRef($ba4805e0fe67c4a9$var$HomeIcon);
var $ba4805e0fe67c4a9$export$2e2bcd8739ae039 = $ba4805e0fe67c4a9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bcba575abf5b0e05$var$IdentificationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $bcba575abf5b0e05$var$ForwardRef = $f2Y41.forwardRef($bcba575abf5b0e05$var$IdentificationIcon);
var $bcba575abf5b0e05$export$2e2bcd8739ae039 = $bcba575abf5b0e05$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8cd47aab2aea03b3$var$InboxInIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
    }));
}
const $8cd47aab2aea03b3$var$ForwardRef = $f2Y41.forwardRef($8cd47aab2aea03b3$var$InboxInIcon);
var $8cd47aab2aea03b3$export$2e2bcd8739ae039 = $8cd47aab2aea03b3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $90342894daf93212$var$InboxIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z",
        clipRule: "evenodd"
    }));
}
const $90342894daf93212$var$ForwardRef = $f2Y41.forwardRef($90342894daf93212$var$InboxIcon);
var $90342894daf93212$export$2e2bcd8739ae039 = $90342894daf93212$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $23ed955328927767$var$InformationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
        clipRule: "evenodd"
    }));
}
const $23ed955328927767$var$ForwardRef = $f2Y41.forwardRef($23ed955328927767$var$InformationCircleIcon);
var $23ed955328927767$export$2e2bcd8739ae039 = $23ed955328927767$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8cd6a57f2c394dcc$var$KeyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
        clipRule: "evenodd"
    }));
}
const $8cd6a57f2c394dcc$var$ForwardRef = $f2Y41.forwardRef($8cd6a57f2c394dcc$var$KeyIcon);
var $8cd6a57f2c394dcc$export$2e2bcd8739ae039 = $8cd6a57f2c394dcc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7979fbc81d6e23bf$var$LibraryIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $7979fbc81d6e23bf$var$ForwardRef = $f2Y41.forwardRef($7979fbc81d6e23bf$var$LibraryIcon);
var $7979fbc81d6e23bf$export$2e2bcd8739ae039 = $7979fbc81d6e23bf$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $679291a80e6494f8$var$LightBulbIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z"
    }));
}
const $679291a80e6494f8$var$ForwardRef = $f2Y41.forwardRef($679291a80e6494f8$var$LightBulbIcon);
var $679291a80e6494f8$export$2e2bcd8739ae039 = $679291a80e6494f8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $828cc5e222111c8c$var$LightningBoltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z",
        clipRule: "evenodd"
    }));
}
const $828cc5e222111c8c$var$ForwardRef = $f2Y41.forwardRef($828cc5e222111c8c$var$LightningBoltIcon);
var $828cc5e222111c8c$export$2e2bcd8739ae039 = $828cc5e222111c8c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $be9eeec9710474d1$var$LinkIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
        clipRule: "evenodd"
    }));
}
const $be9eeec9710474d1$var$ForwardRef = $f2Y41.forwardRef($be9eeec9710474d1$var$LinkIcon);
var $be9eeec9710474d1$export$2e2bcd8739ae039 = $be9eeec9710474d1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b041181e9c681b23$var$LocationMarkerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
        clipRule: "evenodd"
    }));
}
const $b041181e9c681b23$var$ForwardRef = $f2Y41.forwardRef($b041181e9c681b23$var$LocationMarkerIcon);
var $b041181e9c681b23$export$2e2bcd8739ae039 = $b041181e9c681b23$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bb8eec4b1aa59b46$var$LockClosedIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
        clipRule: "evenodd"
    }));
}
const $bb8eec4b1aa59b46$var$ForwardRef = $f2Y41.forwardRef($bb8eec4b1aa59b46$var$LockClosedIcon);
var $bb8eec4b1aa59b46$export$2e2bcd8739ae039 = $bb8eec4b1aa59b46$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7ab10fe99cf67623$var$LockOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z"
    }));
}
const $7ab10fe99cf67623$var$ForwardRef = $f2Y41.forwardRef($7ab10fe99cf67623$var$LockOpenIcon);
var $7ab10fe99cf67623$export$2e2bcd8739ae039 = $7ab10fe99cf67623$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d2296563ed9ee209$var$LoginIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $d2296563ed9ee209$var$ForwardRef = $f2Y41.forwardRef($d2296563ed9ee209$var$LoginIcon);
var $d2296563ed9ee209$export$2e2bcd8739ae039 = $d2296563ed9ee209$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $032b470b556e0590$var$LogoutIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z",
        clipRule: "evenodd"
    }));
}
const $032b470b556e0590$var$ForwardRef = $f2Y41.forwardRef($032b470b556e0590$var$LogoutIcon);
var $032b470b556e0590$export$2e2bcd8739ae039 = $032b470b556e0590$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8c457732d0f54d89$var$MailOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z",
        clipRule: "evenodd"
    }));
}
const $8c457732d0f54d89$var$ForwardRef = $f2Y41.forwardRef($8c457732d0f54d89$var$MailOpenIcon);
var $8c457732d0f54d89$export$2e2bcd8739ae039 = $8c457732d0f54d89$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $be5d9f6b7ac407fc$var$MailIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
    }));
}
const $be5d9f6b7ac407fc$var$ForwardRef = $f2Y41.forwardRef($be5d9f6b7ac407fc$var$MailIcon);
var $be5d9f6b7ac407fc$export$2e2bcd8739ae039 = $be5d9f6b7ac407fc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $40e11667ecd8b877$var$MapIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z",
        clipRule: "evenodd"
    }));
}
const $40e11667ecd8b877$var$ForwardRef = $f2Y41.forwardRef($40e11667ecd8b877$var$MapIcon);
var $40e11667ecd8b877$export$2e2bcd8739ae039 = $40e11667ecd8b877$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $60ffa98443856fe5$var$MenuAlt1Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $60ffa98443856fe5$var$ForwardRef = $f2Y41.forwardRef($60ffa98443856fe5$var$MenuAlt1Icon);
var $60ffa98443856fe5$export$2e2bcd8739ae039 = $60ffa98443856fe5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b20f580d97ce709f$var$MenuAlt2Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $b20f580d97ce709f$var$ForwardRef = $f2Y41.forwardRef($b20f580d97ce709f$var$MenuAlt2Icon);
var $b20f580d97ce709f$export$2e2bcd8739ae039 = $b20f580d97ce709f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9a712ca1b70d80fc$var$MenuAlt3Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $9a712ca1b70d80fc$var$ForwardRef = $f2Y41.forwardRef($9a712ca1b70d80fc$var$MenuAlt3Icon);
var $9a712ca1b70d80fc$export$2e2bcd8739ae039 = $9a712ca1b70d80fc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e6a4ab726191fb85$var$MenuAlt4Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $e6a4ab726191fb85$var$ForwardRef = $f2Y41.forwardRef($e6a4ab726191fb85$var$MenuAlt4Icon);
var $e6a4ab726191fb85$export$2e2bcd8739ae039 = $e6a4ab726191fb85$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3ca0138d386a89b7$var$MenuIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $3ca0138d386a89b7$var$ForwardRef = $f2Y41.forwardRef($3ca0138d386a89b7$var$MenuIcon);
var $3ca0138d386a89b7$export$2e2bcd8739ae039 = $3ca0138d386a89b7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5098b2a41665049c$var$MicrophoneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z",
        clipRule: "evenodd"
    }));
}
const $5098b2a41665049c$var$ForwardRef = $f2Y41.forwardRef($5098b2a41665049c$var$MicrophoneIcon);
var $5098b2a41665049c$export$2e2bcd8739ae039 = $5098b2a41665049c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3a568e41358ca77c$var$MinusCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z",
        clipRule: "evenodd"
    }));
}
const $3a568e41358ca77c$var$ForwardRef = $f2Y41.forwardRef($3a568e41358ca77c$var$MinusCircleIcon);
var $3a568e41358ca77c$export$2e2bcd8739ae039 = $3a568e41358ca77c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d66c1ab7ebda84e2$var$MinusSmIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $d66c1ab7ebda84e2$var$ForwardRef = $f2Y41.forwardRef($d66c1ab7ebda84e2$var$MinusSmIcon);
var $d66c1ab7ebda84e2$export$2e2bcd8739ae039 = $d66c1ab7ebda84e2$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e52e51f51b33948f$var$MinusIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $e52e51f51b33948f$var$ForwardRef = $f2Y41.forwardRef($e52e51f51b33948f$var$MinusIcon);
var $e52e51f51b33948f$export$2e2bcd8739ae039 = $e52e51f51b33948f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0e812b187da158b1$var$MoonIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
    }));
}
const $0e812b187da158b1$var$ForwardRef = $f2Y41.forwardRef($0e812b187da158b1$var$MoonIcon);
var $0e812b187da158b1$export$2e2bcd8739ae039 = $0e812b187da158b1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $03cd281931e34816$var$MusicNoteIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"
    }));
}
const $03cd281931e34816$var$ForwardRef = $f2Y41.forwardRef($03cd281931e34816$var$MusicNoteIcon);
var $03cd281931e34816$export$2e2bcd8739ae039 = $03cd281931e34816$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $431ff152d5ec2b74$var$NewspaperIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z"
    }));
}
const $431ff152d5ec2b74$var$ForwardRef = $f2Y41.forwardRef($431ff152d5ec2b74$var$NewspaperIcon);
var $431ff152d5ec2b74$export$2e2bcd8739ae039 = $431ff152d5ec2b74$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fe7bd221dcce92a0$var$OfficeBuildingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
        clipRule: "evenodd"
    }));
}
const $fe7bd221dcce92a0$var$ForwardRef = $f2Y41.forwardRef($fe7bd221dcce92a0$var$OfficeBuildingIcon);
var $fe7bd221dcce92a0$export$2e2bcd8739ae039 = $fe7bd221dcce92a0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6699f029449d39ae$var$PaperAirplaneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
    }));
}
const $6699f029449d39ae$var$ForwardRef = $f2Y41.forwardRef($6699f029449d39ae$var$PaperAirplaneIcon);
var $6699f029449d39ae$export$2e2bcd8739ae039 = $6699f029449d39ae$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a99d137b091de198$var$PaperClipIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
        clipRule: "evenodd"
    }));
}
const $a99d137b091de198$var$ForwardRef = $f2Y41.forwardRef($a99d137b091de198$var$PaperClipIcon);
var $a99d137b091de198$export$2e2bcd8739ae039 = $a99d137b091de198$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c15d34f1dbec1282$var$PauseIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $c15d34f1dbec1282$var$ForwardRef = $f2Y41.forwardRef($c15d34f1dbec1282$var$PauseIcon);
var $c15d34f1dbec1282$export$2e2bcd8739ae039 = $c15d34f1dbec1282$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $05e6a33d825c5c06$var$PencilAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
        clipRule: "evenodd"
    }));
}
const $05e6a33d825c5c06$var$ForwardRef = $f2Y41.forwardRef($05e6a33d825c5c06$var$PencilAltIcon);
var $05e6a33d825c5c06$export$2e2bcd8739ae039 = $05e6a33d825c5c06$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bf2d0e7706307648$var$PencilIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
    }));
}
const $bf2d0e7706307648$var$ForwardRef = $f2Y41.forwardRef($bf2d0e7706307648$var$PencilIcon);
var $bf2d0e7706307648$export$2e2bcd8739ae039 = $bf2d0e7706307648$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $010a5d23b369ff4d$var$PhoneIncomingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M14.414 7l3.293-3.293a1 1 0 00-1.414-1.414L13 5.586V4a1 1 0 10-2 0v4.003a.996.996 0 00.617.921A.997.997 0 0012 9h4a1 1 0 100-2h-1.586z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
    }));
}
const $010a5d23b369ff4d$var$ForwardRef = $f2Y41.forwardRef($010a5d23b369ff4d$var$PhoneIncomingIcon);
var $010a5d23b369ff4d$export$2e2bcd8739ae039 = $010a5d23b369ff4d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9fc5e9b76400ef01$var$PhoneMissedCallIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M16.707 3.293a1 1 0 010 1.414L15.414 6l1.293 1.293a1 1 0 01-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 11-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 011.414-1.414L14 4.586l1.293-1.293a1 1 0 011.414 0z"
    }));
}
const $9fc5e9b76400ef01$var$ForwardRef = $f2Y41.forwardRef($9fc5e9b76400ef01$var$PhoneMissedCallIcon);
var $9fc5e9b76400ef01$export$2e2bcd8739ae039 = $9fc5e9b76400ef01$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $995de9df238072a9$var$PhoneOutgoingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
    }));
}
const $995de9df238072a9$var$ForwardRef = $f2Y41.forwardRef($995de9df238072a9$var$PhoneOutgoingIcon);
var $995de9df238072a9$export$2e2bcd8739ae039 = $995de9df238072a9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8639672d4fbfea75$var$PhoneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
    }));
}
const $8639672d4fbfea75$var$ForwardRef = $f2Y41.forwardRef($8639672d4fbfea75$var$PhoneIcon);
var $8639672d4fbfea75$export$2e2bcd8739ae039 = $8639672d4fbfea75$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cfeac43e6810c072$var$PhotographIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
        clipRule: "evenodd"
    }));
}
const $cfeac43e6810c072$var$ForwardRef = $f2Y41.forwardRef($cfeac43e6810c072$var$PhotographIcon);
var $cfeac43e6810c072$export$2e2bcd8739ae039 = $cfeac43e6810c072$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b5b7e8347998291c$var$PlayIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
        clipRule: "evenodd"
    }));
}
const $b5b7e8347998291c$var$ForwardRef = $f2Y41.forwardRef($b5b7e8347998291c$var$PlayIcon);
var $b5b7e8347998291c$export$2e2bcd8739ae039 = $b5b7e8347998291c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d85e3f0109065bc6$var$PlusCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z",
        clipRule: "evenodd"
    }));
}
const $d85e3f0109065bc6$var$ForwardRef = $f2Y41.forwardRef($d85e3f0109065bc6$var$PlusCircleIcon);
var $d85e3f0109065bc6$export$2e2bcd8739ae039 = $d85e3f0109065bc6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $db8e900ce1b9622b$var$PlusSmIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
        clipRule: "evenodd"
    }));
}
const $db8e900ce1b9622b$var$ForwardRef = $f2Y41.forwardRef($db8e900ce1b9622b$var$PlusSmIcon);
var $db8e900ce1b9622b$export$2e2bcd8739ae039 = $db8e900ce1b9622b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0db9efff570f81ae$var$PlusIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
        clipRule: "evenodd"
    }));
}
const $0db9efff570f81ae$var$ForwardRef = $f2Y41.forwardRef($0db9efff570f81ae$var$PlusIcon);
var $0db9efff570f81ae$export$2e2bcd8739ae039 = $0db9efff570f81ae$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $db8a4b7b354df0d5$var$PresentationChartBarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z",
        clipRule: "evenodd"
    }));
}
const $db8a4b7b354df0d5$var$ForwardRef = $f2Y41.forwardRef($db8a4b7b354df0d5$var$PresentationChartBarIcon);
var $db8a4b7b354df0d5$export$2e2bcd8739ae039 = $db8a4b7b354df0d5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4b3649b8eef7668e$var$PresentationChartLineIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $4b3649b8eef7668e$var$ForwardRef = $f2Y41.forwardRef($4b3649b8eef7668e$var$PresentationChartLineIcon);
var $4b3649b8eef7668e$export$2e2bcd8739ae039 = $4b3649b8eef7668e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $42de420ff501fca4$var$PrinterIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z",
        clipRule: "evenodd"
    }));
}
const $42de420ff501fca4$var$ForwardRef = $f2Y41.forwardRef($42de420ff501fca4$var$PrinterIcon);
var $42de420ff501fca4$export$2e2bcd8739ae039 = $42de420ff501fca4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6a23afbf26f4bdcc$var$PuzzleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"
    }));
}
const $6a23afbf26f4bdcc$var$ForwardRef = $f2Y41.forwardRef($6a23afbf26f4bdcc$var$PuzzleIcon);
var $6a23afbf26f4bdcc$export$2e2bcd8739ae039 = $6a23afbf26f4bdcc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $220aee607431ab32$var$QrcodeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z"
    }));
}
const $220aee607431ab32$var$ForwardRef = $f2Y41.forwardRef($220aee607431ab32$var$QrcodeIcon);
var $220aee607431ab32$export$2e2bcd8739ae039 = $220aee607431ab32$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $41bbdf691453e588$var$QuestionMarkCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
}
const $41bbdf691453e588$var$ForwardRef = $f2Y41.forwardRef($41bbdf691453e588$var$QuestionMarkCircleIcon);
var $41bbdf691453e588$export$2e2bcd8739ae039 = $41bbdf691453e588$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5102be8a36779761$var$ReceiptRefundIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z",
        clipRule: "evenodd"
    }));
}
const $5102be8a36779761$var$ForwardRef = $f2Y41.forwardRef($5102be8a36779761$var$ReceiptRefundIcon);
var $5102be8a36779761$export$2e2bcd8739ae039 = $5102be8a36779761$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9e68090a317b7ac0$var$ReceiptTaxIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
        clipRule: "evenodd"
    }));
}
const $9e68090a317b7ac0$var$ForwardRef = $f2Y41.forwardRef($9e68090a317b7ac0$var$ReceiptTaxIcon);
var $9e68090a317b7ac0$export$2e2bcd8739ae039 = $9e68090a317b7ac0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ce04cd6fec08b5d5$var$RefreshIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
        clipRule: "evenodd"
    }));
}
const $ce04cd6fec08b5d5$var$ForwardRef = $f2Y41.forwardRef($ce04cd6fec08b5d5$var$RefreshIcon);
var $ce04cd6fec08b5d5$export$2e2bcd8739ae039 = $ce04cd6fec08b5d5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $09eea1faceeda14e$var$ReplyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $09eea1faceeda14e$var$ForwardRef = $f2Y41.forwardRef($09eea1faceeda14e$var$ReplyIcon);
var $09eea1faceeda14e$export$2e2bcd8739ae039 = $09eea1faceeda14e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $94bd07be6c090821$var$RewindIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8.445 14.832A1 1 0 0010 14v-2.798l5.445 3.63A1 1 0 0017 14V6a1 1 0 00-1.555-.832L10 8.798V6a1 1 0 00-1.555-.832l-6 4a1 1 0 000 1.664l6 4z"
    }));
}
const $94bd07be6c090821$var$ForwardRef = $f2Y41.forwardRef($94bd07be6c090821$var$RewindIcon);
var $94bd07be6c090821$export$2e2bcd8739ae039 = $94bd07be6c090821$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $626bf9525b53df6a$var$RssIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1zM3 15a2 2 0 114 0 2 2 0 01-4 0z"
    }));
}
const $626bf9525b53df6a$var$ForwardRef = $f2Y41.forwardRef($626bf9525b53df6a$var$RssIcon);
var $626bf9525b53df6a$export$2e2bcd8739ae039 = $626bf9525b53df6a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $97ddbc0887aba310$var$SaveAsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9.707 7.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L13 8.586V5h3a2 2 0 012 2v5a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2h3v3.586L9.707 7.293zM11 3a1 1 0 112 0v2h-2V3z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M4 9a2 2 0 00-2 2v5a2 2 0 002 2h8a2 2 0 002-2H4V9z"
    }));
}
const $97ddbc0887aba310$var$ForwardRef = $f2Y41.forwardRef($97ddbc0887aba310$var$SaveAsIcon);
var $97ddbc0887aba310$export$2e2bcd8739ae039 = $97ddbc0887aba310$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $407e715318d77af4$var$SaveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"
    }));
}
const $407e715318d77af4$var$ForwardRef = $f2Y41.forwardRef($407e715318d77af4$var$SaveIcon);
var $407e715318d77af4$export$2e2bcd8739ae039 = $407e715318d77af4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7fbc6c942733df3d$var$ScaleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1zm-5 8.274l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274zm10 0l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274z",
        clipRule: "evenodd"
    }));
}
const $7fbc6c942733df3d$var$ForwardRef = $f2Y41.forwardRef($7fbc6c942733df3d$var$ScaleIcon);
var $7fbc6c942733df3d$export$2e2bcd8739ae039 = $7fbc6c942733df3d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8c9d924a44d75932$var$ScissorsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5.5 2a3.5 3.5 0 101.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 101.414 1.414l8.128-8.127a1 1 0 00-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 005.5 2zM4 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M12.828 11.414a1 1 0 00-1.414 1.414l3.879 3.88a1 1 0 001.414-1.415l-3.879-3.879z"
    }));
}
const $8c9d924a44d75932$var$ForwardRef = $f2Y41.forwardRef($8c9d924a44d75932$var$ScissorsIcon);
var $8c9d924a44d75932$export$2e2bcd8739ae039 = $8c9d924a44d75932$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $69f5ba3c0f4305af$var$SearchCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 9a2 2 0 114 0 2 2 0 01-4 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z",
        clipRule: "evenodd"
    }));
}
const $69f5ba3c0f4305af$var$ForwardRef = $f2Y41.forwardRef($69f5ba3c0f4305af$var$SearchCircleIcon);
var $69f5ba3c0f4305af$export$2e2bcd8739ae039 = $69f5ba3c0f4305af$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6b4cc9fdf609188d$var$SearchIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        clipRule: "evenodd"
    }));
}
const $6b4cc9fdf609188d$var$ForwardRef = $f2Y41.forwardRef($6b4cc9fdf609188d$var$SearchIcon);
var $6b4cc9fdf609188d$export$2e2bcd8739ae039 = $6b4cc9fdf609188d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9b9afc70d87893a1$var$SelectorIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $9b9afc70d87893a1$var$ForwardRef = $f2Y41.forwardRef($9b9afc70d87893a1$var$SelectorIcon);
var $9b9afc70d87893a1$export$2e2bcd8739ae039 = $9b9afc70d87893a1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4fcb4c6fb26b138f$var$ServerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z",
        clipRule: "evenodd"
    }));
}
const $4fcb4c6fb26b138f$var$ForwardRef = $f2Y41.forwardRef($4fcb4c6fb26b138f$var$ServerIcon);
var $4fcb4c6fb26b138f$export$2e2bcd8739ae039 = $4fcb4c6fb26b138f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a37c4c95d8c06f80$var$ShareIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"
    }));
}
const $a37c4c95d8c06f80$var$ForwardRef = $f2Y41.forwardRef($a37c4c95d8c06f80$var$ShareIcon);
var $a37c4c95d8c06f80$export$2e2bcd8739ae039 = $a37c4c95d8c06f80$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b6210bd1654cb840$var$ShieldCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $b6210bd1654cb840$var$ForwardRef = $f2Y41.forwardRef($b6210bd1654cb840$var$ShieldCheckIcon);
var $b6210bd1654cb840$export$2e2bcd8739ae039 = $b6210bd1654cb840$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $36ccc78ae34500e0$var$ShieldExclamationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z",
        clipRule: "evenodd"
    }));
}
const $36ccc78ae34500e0$var$ForwardRef = $f2Y41.forwardRef($36ccc78ae34500e0$var$ShieldExclamationIcon);
var $36ccc78ae34500e0$export$2e2bcd8739ae039 = $36ccc78ae34500e0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cd660327faa4029c$var$ShoppingBagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z",
        clipRule: "evenodd"
    }));
}
const $cd660327faa4029c$var$ForwardRef = $f2Y41.forwardRef($cd660327faa4029c$var$ShoppingBagIcon);
var $cd660327faa4029c$export$2e2bcd8739ae039 = $cd660327faa4029c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $46b83e12943d6e59$var$ShoppingCartIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
    }));
}
const $46b83e12943d6e59$var$ForwardRef = $f2Y41.forwardRef($46b83e12943d6e59$var$ShoppingCartIcon);
var $46b83e12943d6e59$export$2e2bcd8739ae039 = $46b83e12943d6e59$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $51738c369cbe2dbd$var$SortAscendingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
    }));
}
const $51738c369cbe2dbd$var$ForwardRef = $f2Y41.forwardRef($51738c369cbe2dbd$var$SortAscendingIcon);
var $51738c369cbe2dbd$export$2e2bcd8739ae039 = $51738c369cbe2dbd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ff72700759bf23cf$var$SortDescendingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
    }));
}
const $ff72700759bf23cf$var$ForwardRef = $f2Y41.forwardRef($ff72700759bf23cf$var$SortDescendingIcon);
var $ff72700759bf23cf$export$2e2bcd8739ae039 = $ff72700759bf23cf$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a2e2310fbcc990b5$var$SparklesIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z",
        clipRule: "evenodd"
    }));
}
const $a2e2310fbcc990b5$var$ForwardRef = $f2Y41.forwardRef($a2e2310fbcc990b5$var$SparklesIcon);
var $a2e2310fbcc990b5$export$2e2bcd8739ae039 = $a2e2310fbcc990b5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c2779ad762e69e19$var$SpeakerphoneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z",
        clipRule: "evenodd"
    }));
}
const $c2779ad762e69e19$var$ForwardRef = $f2Y41.forwardRef($c2779ad762e69e19$var$SpeakerphoneIcon);
var $c2779ad762e69e19$export$2e2bcd8739ae039 = $c2779ad762e69e19$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a64e2b1e12210ccb$var$StarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
    }));
}
const $a64e2b1e12210ccb$var$ForwardRef = $f2Y41.forwardRef($a64e2b1e12210ccb$var$StarIcon);
var $a64e2b1e12210ccb$export$2e2bcd8739ae039 = $a64e2b1e12210ccb$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a1561b00c3d68826$var$StatusOfflineIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"
    }));
}
const $a1561b00c3d68826$var$ForwardRef = $f2Y41.forwardRef($a1561b00c3d68826$var$StatusOfflineIcon);
var $a1561b00c3d68826$export$2e2bcd8739ae039 = $a1561b00c3d68826$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $76227593d1e9ff04$var$StatusOnlineIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z",
        clipRule: "evenodd"
    }));
}
const $76227593d1e9ff04$var$ForwardRef = $f2Y41.forwardRef($76227593d1e9ff04$var$StatusOnlineIcon);
var $76227593d1e9ff04$export$2e2bcd8739ae039 = $76227593d1e9ff04$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4ad1836e73ec9fa3$var$StopIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z",
        clipRule: "evenodd"
    }));
}
const $4ad1836e73ec9fa3$var$ForwardRef = $f2Y41.forwardRef($4ad1836e73ec9fa3$var$StopIcon);
var $4ad1836e73ec9fa3$export$2e2bcd8739ae039 = $4ad1836e73ec9fa3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4221ae8fa91ea051$var$SunIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
        clipRule: "evenodd"
    }));
}
const $4221ae8fa91ea051$var$ForwardRef = $f2Y41.forwardRef($4221ae8fa91ea051$var$SunIcon);
var $4221ae8fa91ea051$export$2e2bcd8739ae039 = $4221ae8fa91ea051$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $766f3c2df1af4739$var$SupportIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z",
        clipRule: "evenodd"
    }));
}
const $766f3c2df1af4739$var$ForwardRef = $f2Y41.forwardRef($766f3c2df1af4739$var$SupportIcon);
var $766f3c2df1af4739$export$2e2bcd8739ae039 = $766f3c2df1af4739$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5ff2428679c55861$var$SwitchHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z"
    }));
}
const $5ff2428679c55861$var$ForwardRef = $f2Y41.forwardRef($5ff2428679c55861$var$SwitchHorizontalIcon);
var $5ff2428679c55861$export$2e2bcd8739ae039 = $5ff2428679c55861$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $00f746563b9bda28$var$SwitchVerticalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
    }));
}
const $00f746563b9bda28$var$ForwardRef = $f2Y41.forwardRef($00f746563b9bda28$var$SwitchVerticalIcon);
var $00f746563b9bda28$export$2e2bcd8739ae039 = $00f746563b9bda28$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a4f71ce759a29fa2$var$TableIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z",
        clipRule: "evenodd"
    }));
}
const $a4f71ce759a29fa2$var$ForwardRef = $f2Y41.forwardRef($a4f71ce759a29fa2$var$TableIcon);
var $a4f71ce759a29fa2$export$2e2bcd8739ae039 = $a4f71ce759a29fa2$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $25c0a1e5aaf50daf$var$TagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
}
const $25c0a1e5aaf50daf$var$ForwardRef = $f2Y41.forwardRef($25c0a1e5aaf50daf$var$TagIcon);
var $25c0a1e5aaf50daf$export$2e2bcd8739ae039 = $25c0a1e5aaf50daf$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0551bad37369f20e$var$TemplateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
    }));
}
const $0551bad37369f20e$var$ForwardRef = $f2Y41.forwardRef($0551bad37369f20e$var$TemplateIcon);
var $0551bad37369f20e$export$2e2bcd8739ae039 = $0551bad37369f20e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $154b5438450f0341$var$TerminalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z",
        clipRule: "evenodd"
    }));
}
const $154b5438450f0341$var$ForwardRef = $f2Y41.forwardRef($154b5438450f0341$var$TerminalIcon);
var $154b5438450f0341$export$2e2bcd8739ae039 = $154b5438450f0341$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8062ef983e1993e7$var$ThumbDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z"
    }));
}
const $8062ef983e1993e7$var$ForwardRef = $f2Y41.forwardRef($8062ef983e1993e7$var$ThumbDownIcon);
var $8062ef983e1993e7$export$2e2bcd8739ae039 = $8062ef983e1993e7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $912582c9e416b0e4$var$ThumbUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
    }));
}
const $912582c9e416b0e4$var$ForwardRef = $f2Y41.forwardRef($912582c9e416b0e4$var$ThumbUpIcon);
var $912582c9e416b0e4$export$2e2bcd8739ae039 = $912582c9e416b0e4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $aa8cd38df5de6325$var$TicketIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z"
    }));
}
const $aa8cd38df5de6325$var$ForwardRef = $f2Y41.forwardRef($aa8cd38df5de6325$var$TicketIcon);
var $aa8cd38df5de6325$export$2e2bcd8739ae039 = $aa8cd38df5de6325$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $292762fa5c026c1f$var$TranslateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 11.236 11.618 14z",
        clipRule: "evenodd"
    }));
}
const $292762fa5c026c1f$var$ForwardRef = $f2Y41.forwardRef($292762fa5c026c1f$var$TranslateIcon);
var $292762fa5c026c1f$export$2e2bcd8739ae039 = $292762fa5c026c1f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2e97c473f811a628$var$TrashIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $2e97c473f811a628$var$ForwardRef = $f2Y41.forwardRef($2e97c473f811a628$var$TrashIcon);
var $2e97c473f811a628$export$2e2bcd8739ae039 = $2e97c473f811a628$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $915f6edc00deabec$var$TrendingDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z",
        clipRule: "evenodd"
    }));
}
const $915f6edc00deabec$var$ForwardRef = $f2Y41.forwardRef($915f6edc00deabec$var$TrendingDownIcon);
var $915f6edc00deabec$export$2e2bcd8739ae039 = $915f6edc00deabec$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f218403482e792d2$var$TrendingUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z",
        clipRule: "evenodd"
    }));
}
const $f218403482e792d2$var$ForwardRef = $f2Y41.forwardRef($f218403482e792d2$var$TrendingUpIcon);
var $f218403482e792d2$export$2e2bcd8739ae039 = $f218403482e792d2$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $35ba30a79c312d01$var$TruckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
    }));
}
const $35ba30a79c312d01$var$ForwardRef = $f2Y41.forwardRef($35ba30a79c312d01$var$TruckIcon);
var $35ba30a79c312d01$export$2e2bcd8739ae039 = $35ba30a79c312d01$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ddbad23863d18c91$var$UploadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $ddbad23863d18c91$var$ForwardRef = $f2Y41.forwardRef($ddbad23863d18c91$var$UploadIcon);
var $ddbad23863d18c91$export$2e2bcd8739ae039 = $ddbad23863d18c91$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $08333886350b5f94$var$UserAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z"
    }));
}
const $08333886350b5f94$var$ForwardRef = $f2Y41.forwardRef($08333886350b5f94$var$UserAddIcon);
var $08333886350b5f94$export$2e2bcd8739ae039 = $08333886350b5f94$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6f0870b045c87ef6$var$UserCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
        clipRule: "evenodd"
    }));
}
const $6f0870b045c87ef6$var$ForwardRef = $f2Y41.forwardRef($6f0870b045c87ef6$var$UserCircleIcon);
var $6f0870b045c87ef6$export$2e2bcd8739ae039 = $6f0870b045c87ef6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f5463dc5456d1e45$var$UserGroupIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
    }));
}
const $f5463dc5456d1e45$var$ForwardRef = $f2Y41.forwardRef($f5463dc5456d1e45$var$UserGroupIcon);
var $f5463dc5456d1e45$export$2e2bcd8739ae039 = $f5463dc5456d1e45$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3872970a7226267a$var$UserRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z"
    }));
}
const $3872970a7226267a$var$ForwardRef = $f2Y41.forwardRef($3872970a7226267a$var$UserRemoveIcon);
var $3872970a7226267a$export$2e2bcd8739ae039 = $3872970a7226267a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3a14717d6f323ed5$var$UserIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
        clipRule: "evenodd"
    }));
}
const $3a14717d6f323ed5$var$ForwardRef = $f2Y41.forwardRef($3a14717d6f323ed5$var$UserIcon);
var $3a14717d6f323ed5$export$2e2bcd8739ae039 = $3a14717d6f323ed5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d411d8c712330d41$var$UsersIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
    }));
}
const $d411d8c712330d41$var$ForwardRef = $f2Y41.forwardRef($d411d8c712330d41$var$UsersIcon);
var $d411d8c712330d41$export$2e2bcd8739ae039 = $d411d8c712330d41$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f1beb4d7fcdc49bc$var$VariableIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4.649 3.084A1 1 0 015.163 4.4 13.95 13.95 0 004 10c0 1.993.416 3.886 1.164 5.6a1 1 0 01-1.832.8A15.95 15.95 0 012 10c0-2.274.475-4.44 1.332-6.4a1 1 0 011.317-.516zM12.96 7a3 3 0 00-2.342 1.126l-.328.41-.111-.279A2 2 0 008.323 7H8a1 1 0 000 2h.323l.532 1.33-1.035 1.295a1 1 0 01-.781.375H7a1 1 0 100 2h.039a3 3 0 002.342-1.126l.328-.41.111.279A2 2 0 0011.677 14H12a1 1 0 100-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0112.961 9H13a1 1 0 100-2h-.039zm1.874-2.6a1 1 0 011.833-.8A15.95 15.95 0 0118 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 11-1.832-.8A13.949 13.949 0 0016 10c0-1.993-.416-3.886-1.165-5.6z",
        clipRule: "evenodd"
    }));
}
const $f1beb4d7fcdc49bc$var$ForwardRef = $f2Y41.forwardRef($f1beb4d7fcdc49bc$var$VariableIcon);
var $f1beb4d7fcdc49bc$export$2e2bcd8739ae039 = $f1beb4d7fcdc49bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $73110c95c05c6277$var$VideoCameraIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
    }));
}
const $73110c95c05c6277$var$ForwardRef = $f2Y41.forwardRef($73110c95c05c6277$var$VideoCameraIcon);
var $73110c95c05c6277$export$2e2bcd8739ae039 = $73110c95c05c6277$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $45c39f668a7b16ae$var$ViewBoardsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M2 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4zM8 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM15 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z"
    }));
}
const $45c39f668a7b16ae$var$ForwardRef = $f2Y41.forwardRef($45c39f668a7b16ae$var$ViewBoardsIcon);
var $45c39f668a7b16ae$export$2e2bcd8739ae039 = $45c39f668a7b16ae$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $63d5d42871020be5$var$ViewGridAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"
    }));
}
const $63d5d42871020be5$var$ForwardRef = $f2Y41.forwardRef($63d5d42871020be5$var$ViewGridAddIcon);
var $63d5d42871020be5$export$2e2bcd8739ae039 = $63d5d42871020be5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $328c72db0bc047a6$var$ViewGridIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
    }));
}
const $328c72db0bc047a6$var$ForwardRef = $f2Y41.forwardRef($328c72db0bc047a6$var$ViewGridIcon);
var $328c72db0bc047a6$export$2e2bcd8739ae039 = $328c72db0bc047a6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b406d193180f1d76$var$ViewListIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $b406d193180f1d76$var$ForwardRef = $f2Y41.forwardRef($b406d193180f1d76$var$ViewListIcon);
var $b406d193180f1d76$export$2e2bcd8739ae039 = $b406d193180f1d76$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f3211e179910af73$var$VolumeOffIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $f3211e179910af73$var$ForwardRef = $f2Y41.forwardRef($f3211e179910af73$var$VolumeOffIcon);
var $f3211e179910af73$export$2e2bcd8739ae039 = $f3211e179910af73$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f554c94d030d6384$var$VolumeUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z",
        clipRule: "evenodd"
    }));
}
const $f554c94d030d6384$var$ForwardRef = $f2Y41.forwardRef($f554c94d030d6384$var$VolumeUpIcon);
var $f554c94d030d6384$export$2e2bcd8739ae039 = $f554c94d030d6384$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f2aa2ed4388ccc9a$var$WifiIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $f2aa2ed4388ccc9a$var$ForwardRef = $f2Y41.forwardRef($f2aa2ed4388ccc9a$var$WifiIcon);
var $f2aa2ed4388ccc9a$export$2e2bcd8739ae039 = $f2aa2ed4388ccc9a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $341f92d1daab99e1$var$XCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
        clipRule: "evenodd"
    }));
}
const $341f92d1daab99e1$var$ForwardRef = $f2Y41.forwardRef($341f92d1daab99e1$var$XCircleIcon);
var $341f92d1daab99e1$export$2e2bcd8739ae039 = $341f92d1daab99e1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $36f904a99bc777ce$var$XIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $36f904a99bc777ce$var$ForwardRef = $f2Y41.forwardRef($36f904a99bc777ce$var$XIcon);
var $36f904a99bc777ce$export$2e2bcd8739ae039 = $36f904a99bc777ce$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4d2ee6011295c289$var$ZoomInIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z",
        clipRule: "evenodd"
    }));
}
const $4d2ee6011295c289$var$ForwardRef = $f2Y41.forwardRef($4d2ee6011295c289$var$ZoomInIcon);
var $4d2ee6011295c289$export$2e2bcd8739ae039 = $4d2ee6011295c289$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0325c04a55d8f460$var$ZoomOutIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        fillRule: "evenodd",
        d: "M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $0325c04a55d8f460$var$ForwardRef = $f2Y41.forwardRef($0325c04a55d8f460$var$ZoomOutIcon);
var $0325c04a55d8f460$export$2e2bcd8739ae039 = $0325c04a55d8f460$var$ForwardRef;




var $8e586341ed5745cf$exports = {};

$parcel$export($8e586341ed5745cf$exports, "AcademicCapIcon", function () { return $380867445ff69bba$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "AdjustmentsIcon", function () { return $1866f07883b79d71$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "AnnotationIcon", function () { return $9f986cc0471cd3be$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArchiveIcon", function () { return $66e2ec5354cb20a0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowCircleDownIcon", function () { return $607066fc1119a9de$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowCircleLeftIcon", function () { return $b7d5f76cfb8e60fb$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowCircleRightIcon", function () { return $b28153ad1ae03a43$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowCircleUpIcon", function () { return $ccbf1090ff59cdcc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowDownIcon", function () { return $003c31da04c7c688$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowLeftIcon", function () { return $9400836f1b8530da$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowNarrowDownIcon", function () { return $7cccc3ad2ac13e42$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowNarrowLeftIcon", function () { return $2e966edf4cb1a436$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowNarrowRightIcon", function () { return $87e7b862c6e09711$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowNarrowUpIcon", function () { return $af542f6e073960ea$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowRightIcon", function () { return $e8a2679353a9987c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowSmDownIcon", function () { return $034d76b5eb275e6d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowSmLeftIcon", function () { return $661034651b33e390$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowSmRightIcon", function () { return $d17eaa6dbbd1b109$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowSmUpIcon", function () { return $7cc4147e086f587f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowUpIcon", function () { return $edafd7dfda1f9869$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ArrowsExpandIcon", function () { return $2b6991b4412a7bd1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "AtSymbolIcon", function () { return $95e97b67bdf9b329$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BackspaceIcon", function () { return $989a98553afcfd0f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BadgeCheckIcon", function () { return $88f8cb17ae941e92$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BanIcon", function () { return $b4a4aa74b32d44df$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BeakerIcon", function () { return $c894b5cd71944d85$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BellIcon", function () { return $2fc55f54712dc8c9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BookOpenIcon", function () { return $c94fa264e3708c29$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BookmarkAltIcon", function () { return $71ad25bc968842a5$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BookmarkIcon", function () { return $7a6be7c7e223ec19$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "BriefcaseIcon", function () { return $7834817f82e012e9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CakeIcon", function () { return $2b00c5073f686be9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CalculatorIcon", function () { return $46362d496cefe343$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CalendarIcon", function () { return $2cf237bbed3f4e6d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CameraIcon", function () { return $af6b820ec356d814$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CashIcon", function () { return $6fe29d0ab30bc5f0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChartBarIcon", function () { return $2f2964f72fc75cf9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChartPieIcon", function () { return $427552637ec61ff7$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChartSquareBarIcon", function () { return $f3a5b3c9293e16fe$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChatAlt2Icon", function () { return $b5e0b36ea69da192$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChatAltIcon", function () { return $0407a0df89050106$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChatIcon", function () { return $d6baaa2d3b09bb28$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CheckCircleIcon", function () { return $1b079dd816430294$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CheckIcon", function () { return $fafc9458db481e47$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronDoubleDownIcon", function () { return $08faa4925a475485$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronDoubleLeftIcon", function () { return $a286a93af0c79b08$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronDoubleRightIcon", function () { return $232e984b72f2e690$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronDoubleUpIcon", function () { return $86c90423e909235e$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronDownIcon", function () { return $1f980c767093f688$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronLeftIcon", function () { return $60de2a624844e287$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronRightIcon", function () { return $f95ce8396b92a53e$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChevronUpIcon", function () { return $144ecc46f24317bc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ChipIcon", function () { return $2d512d8b1cb3dc35$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ClipboardCheckIcon", function () { return $07bdcb76b10afbba$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ClipboardCopyIcon", function () { return $994c8fc4cbd6f2af$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ClipboardListIcon", function () { return $f0b6374804311366$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ClipboardIcon", function () { return $13eb762117c13df3$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ClockIcon", function () { return $2612fa3b4b939ffc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CloudDownloadIcon", function () { return $86916d24bfb64780$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CloudUploadIcon", function () { return $921ae3a32c25dd5b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CloudIcon", function () { return $512beb486b65ee5c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CodeIcon", function () { return $181a92cbef651c6b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CogIcon", function () { return $5eb5c59bd4bde394$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CollectionIcon", function () { return $cb366a06286fe6b0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ColorSwatchIcon", function () { return $04d72d98c63ced1f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CreditCardIcon", function () { return $fd3a16b6423c14a4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CubeTransparentIcon", function () { return $319f2c3a487a352d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CubeIcon", function () { return $16c3457f9570ca27$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CurrencyBangladeshiIcon", function () { return $f411b35c964540c7$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CurrencyDollarIcon", function () { return $5289c4e5944a7ec0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CurrencyEuroIcon", function () { return $edf51db2848091cc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CurrencyPoundIcon", function () { return $10a6b12f84fa31e6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CurrencyRupeeIcon", function () { return $b4094ae9a6a3bb77$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CurrencyYenIcon", function () { return $94f36e1be1df0da0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "CursorClickIcon", function () { return $c4b0a65bdf6405eb$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DatabaseIcon", function () { return $bf976c8ddbd70ec0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DesktopComputerIcon", function () { return $1900adb81699e30d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DeviceMobileIcon", function () { return $a38fc182c81a1b73$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DeviceTabletIcon", function () { return $cef6feb730836f3a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentAddIcon", function () { return $f0af8089560f4d8b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentDownloadIcon", function () { return $e3077f9be828659a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentDuplicateIcon", function () { return $20661ec6de732dce$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentRemoveIcon", function () { return $c7819911749b0ca4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentReportIcon", function () { return $a26d7a79dfc3ff85$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentSearchIcon", function () { return $7399576a6d396a43$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentTextIcon", function () { return $44de4fce481b8a9f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DocumentIcon", function () { return $2b5070ce5fe4282d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DotsCircleHorizontalIcon", function () { return $fb9eb3e29c92cf4a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DotsHorizontalIcon", function () { return $de320a6e2977a291$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DotsVerticalIcon", function () { return $207780583ff605f6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DownloadIcon", function () { return $35bf3c31bc6a1304$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "DuplicateIcon", function () { return $281dbb0145fb8fbf$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "EmojiHappyIcon", function () { return $a7137d7ffb23fe01$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "EmojiSadIcon", function () { return $bb85d7ca43369979$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ExclamationCircleIcon", function () { return $c1ac02fb92947ddd$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ExclamationIcon", function () { return $62af8c3c834dbe70$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ExternalLinkIcon", function () { return $f27071e0a21578db$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "EyeOffIcon", function () { return $56704984f866251b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "EyeIcon", function () { return $21d6d4908910124d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FastForwardIcon", function () { return $dda3b9186e0ed43b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FilmIcon", function () { return $7ec54a839322616d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FilterIcon", function () { return $69afc93c70f432a0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FingerPrintIcon", function () { return $55d588d867c97180$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FireIcon", function () { return $72bd83a7ae9ab820$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FlagIcon", function () { return $61f5049c9ffce44d$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FolderAddIcon", function () { return $2b6c6feb1e5a06c4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FolderDownloadIcon", function () { return $1c24ba3acf8f8741$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FolderOpenIcon", function () { return $f3f31ecfc57b0f76$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FolderRemoveIcon", function () { return $693851365e813cdc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "FolderIcon", function () { return $3ed1b3dc3c25a177$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "GiftIcon", function () { return $ce33fcbcf673ace2$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "GlobeAltIcon", function () { return $b45563bde55e1e8b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "GlobeIcon", function () { return $dd167d64cb5b05ec$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "HandIcon", function () { return $f61349a7edd5dbd7$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "HashtagIcon", function () { return $ea047d7333bc5185$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "HeartIcon", function () { return $dbba45d109e3eb6c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "HomeIcon", function () { return $eddd1c88790019b4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "IdentificationIcon", function () { return $a0e8799b8384d82c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "InboxInIcon", function () { return $46e90ecaeef22821$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "InboxIcon", function () { return $413493fce7fbde62$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "InformationCircleIcon", function () { return $d613c39e3c685885$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "KeyIcon", function () { return $17b217220a3ecef6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LibraryIcon", function () { return $793f9f9805b99121$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LightBulbIcon", function () { return $d1a9cecc78aeee09$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LightningBoltIcon", function () { return $10835fae1bee76ac$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LinkIcon", function () { return $a639068eabe310f1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LocationMarkerIcon", function () { return $c89324b8257c3a6a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LockClosedIcon", function () { return $74db8e259bbc8607$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LockOpenIcon", function () { return $f7adefdd39ab2587$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LoginIcon", function () { return $d38db750053653b2$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "LogoutIcon", function () { return $f0df21b5277beb14$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MailOpenIcon", function () { return $e99715e9e5e05749$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MailIcon", function () { return $64a995915ed701d1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MapIcon", function () { return $8cb3ecbddfc6922a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MenuAlt1Icon", function () { return $3c5cae76508edc7e$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MenuAlt2Icon", function () { return $1fc2c2eab1ee21d8$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MenuAlt3Icon", function () { return $72799eed99306be8$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MenuAlt4Icon", function () { return $7e8a9fc49a3eea26$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MenuIcon", function () { return $5d4f177f2ad49a93$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MicrophoneIcon", function () { return $0fe0e789a3e9da49$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MinusCircleIcon", function () { return $3df1da9770584c96$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MinusSmIcon", function () { return $8d8b716b1f3278f9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MinusIcon", function () { return $8444ae4bc0736fdd$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MoonIcon", function () { return $d0efdb9932c013ae$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "MusicNoteIcon", function () { return $03d78081a6ae1fe5$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "NewspaperIcon", function () { return $3274b46291e4879e$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "OfficeBuildingIcon", function () { return $8f5d03c899e9276a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PaperAirplaneIcon", function () { return $64420b868819649c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PaperClipIcon", function () { return $3fc9e2fba8d59b78$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PauseIcon", function () { return $6b3269349279077f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PencilAltIcon", function () { return $9da693eb0d1c27a7$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PencilIcon", function () { return $a5e2e9594a99aace$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PhoneIncomingIcon", function () { return $12d2273ae2630954$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PhoneMissedCallIcon", function () { return $a690289613ab88f4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PhoneOutgoingIcon", function () { return $604acd0805401c25$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PhoneIcon", function () { return $685b7d4a9d698f2a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PhotographIcon", function () { return $b4480991806d0143$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PlayIcon", function () { return $d1de718650823f09$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PlusCircleIcon", function () { return $ee9273d07eac7330$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PlusSmIcon", function () { return $941a87b0981c7446$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PlusIcon", function () { return $4b6ab616db315ff8$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PresentationChartBarIcon", function () { return $746031ae8fa1516a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PresentationChartLineIcon", function () { return $32832e3fca8bdfa3$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PrinterIcon", function () { return $c4ded3e7ebde6131$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "PuzzleIcon", function () { return $a77d7dd31b1bec61$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "QrcodeIcon", function () { return $52ccd452731e47bc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "QuestionMarkCircleIcon", function () { return $3510d94202e415bc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ReceiptRefundIcon", function () { return $0f36186b31e4db46$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ReceiptTaxIcon", function () { return $23c2dceef30bcf18$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "RefreshIcon", function () { return $d94b97f5b0c21944$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ReplyIcon", function () { return $415088ee1216f0d8$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "RewindIcon", function () { return $82062c8e123332b2$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "RssIcon", function () { return $fece26d87548bfc4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SaveAsIcon", function () { return $dc51f0fb9ae56d3a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SaveIcon", function () { return $c18a3d012ce527e9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ScaleIcon", function () { return $52e1081ae309509f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ScissorsIcon", function () { return $ac00f60dfc72dea1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SearchCircleIcon", function () { return $36f4602694959627$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SearchIcon", function () { return $6dde497c8a0a789f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SelectorIcon", function () { return $a2e54268d6820edc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ServerIcon", function () { return $4cedd2a2fbf93119$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ShareIcon", function () { return $8753bf8fffaf83b6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ShieldCheckIcon", function () { return $a685243db2303b85$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ShieldExclamationIcon", function () { return $b1d4f209c1facca4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ShoppingBagIcon", function () { return $561ff3afb16b77cf$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ShoppingCartIcon", function () { return $00a240f7c56aeb25$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SortAscendingIcon", function () { return $5250e5a73ed0a1e1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SortDescendingIcon", function () { return $f2671cdcf9df0348$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SparklesIcon", function () { return $7b6446f142a8d538$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SpeakerphoneIcon", function () { return $73e6b578fc54b4b9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "StarIcon", function () { return $e12159b96e99ae14$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "StatusOfflineIcon", function () { return $ca1ff4af9f287bb1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "StatusOnlineIcon", function () { return $89a167b364fe430f$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "StopIcon", function () { return $6cd1323acafd4cf6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SunIcon", function () { return $3b3b2a62f4ef65fd$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SupportIcon", function () { return $55ab35d3dac85ee4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SwitchHorizontalIcon", function () { return $fe8f0d827d1c50ec$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "SwitchVerticalIcon", function () { return $5ed19a40da1e6b8c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TableIcon", function () { return $a530a5b929960634$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TagIcon", function () { return $b17b087e8ef7016c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TemplateIcon", function () { return $42fe4581bf7a19d0$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TerminalIcon", function () { return $dd1926b550ffbee9$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ThumbDownIcon", function () { return $995a4d2aea4e7824$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ThumbUpIcon", function () { return $d65fb0699aeeaa05$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TicketIcon", function () { return $877437626669d84e$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TranslateIcon", function () { return $89cb732bc6a191c7$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TrashIcon", function () { return $f3be71fadbe74fb4$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TrendingDownIcon", function () { return $2f8d8afb58291aa8$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TrendingUpIcon", function () { return $ff269a99de83d910$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "TruckIcon", function () { return $19f99d90bc0f1ffc$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UploadIcon", function () { return $665b9cd26560b922$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UserAddIcon", function () { return $9a7a32db9df475c6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UserCircleIcon", function () { return $409eb6fc9c6a2d80$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UserGroupIcon", function () { return $9babdb9833a5aa4b$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UserRemoveIcon", function () { return $e37976393d66ace5$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UserIcon", function () { return $89a988fed0d1159a$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "UsersIcon", function () { return $30670fdc031ff068$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "VariableIcon", function () { return $a005ecf32adff1ff$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "VideoCameraIcon", function () { return $95c09c158534d408$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ViewBoardsIcon", function () { return $5e7f701b77b252dd$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ViewGridAddIcon", function () { return $046cb31f76ea58a6$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ViewGridIcon", function () { return $4c58855ec53dacfd$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ViewListIcon", function () { return $3864103d312aca82$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "VolumeOffIcon", function () { return $d264c4d5be4aacf8$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "VolumeUpIcon", function () { return $7787a644b4a2e7f7$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "WifiIcon", function () { return $455f523f749c24e1$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "XCircleIcon", function () { return $552c4fbc911a9b8c$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "XIcon", function () { return $ad688b80368a215e$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ZoomInIcon", function () { return $8dbe681d7195a365$export$2e2bcd8739ae039; });
$parcel$export($8e586341ed5745cf$exports, "ZoomOutIcon", function () { return $869649043f5485c4$export$2e2bcd8739ae039; });

var $f2Y41 = parcelRequire("f2Y41");
function $380867445ff69bba$var$AcademicCapIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M12 14l9-5-9-5-9 5 9 5z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    }));
}
const $380867445ff69bba$var$ForwardRef = $f2Y41.forwardRef($380867445ff69bba$var$AcademicCapIcon);
var $380867445ff69bba$export$2e2bcd8739ae039 = $380867445ff69bba$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1866f07883b79d71$var$AdjustmentsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    }));
}
const $1866f07883b79d71$var$ForwardRef = $f2Y41.forwardRef($1866f07883b79d71$var$AdjustmentsIcon);
var $1866f07883b79d71$export$2e2bcd8739ae039 = $1866f07883b79d71$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9f986cc0471cd3be$var$AnnotationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
    }));
}
const $9f986cc0471cd3be$var$ForwardRef = $f2Y41.forwardRef($9f986cc0471cd3be$var$AnnotationIcon);
var $9f986cc0471cd3be$export$2e2bcd8739ae039 = $9f986cc0471cd3be$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $66e2ec5354cb20a0$var$ArchiveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
    }));
}
const $66e2ec5354cb20a0$var$ForwardRef = $f2Y41.forwardRef($66e2ec5354cb20a0$var$ArchiveIcon);
var $66e2ec5354cb20a0$export$2e2bcd8739ae039 = $66e2ec5354cb20a0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $607066fc1119a9de$var$ArrowCircleDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
    }));
}
const $607066fc1119a9de$var$ForwardRef = $f2Y41.forwardRef($607066fc1119a9de$var$ArrowCircleDownIcon);
var $607066fc1119a9de$export$2e2bcd8739ae039 = $607066fc1119a9de$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b7d5f76cfb8e60fb$var$ArrowCircleLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
    }));
}
const $b7d5f76cfb8e60fb$var$ForwardRef = $f2Y41.forwardRef($b7d5f76cfb8e60fb$var$ArrowCircleLeftIcon);
var $b7d5f76cfb8e60fb$export$2e2bcd8739ae039 = $b7d5f76cfb8e60fb$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b28153ad1ae03a43$var$ArrowCircleRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $b28153ad1ae03a43$var$ForwardRef = $f2Y41.forwardRef($b28153ad1ae03a43$var$ArrowCircleRightIcon);
var $b28153ad1ae03a43$export$2e2bcd8739ae039 = $b28153ad1ae03a43$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ccbf1090ff59cdcc$var$ArrowCircleUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
    }));
}
const $ccbf1090ff59cdcc$var$ForwardRef = $f2Y41.forwardRef($ccbf1090ff59cdcc$var$ArrowCircleUpIcon);
var $ccbf1090ff59cdcc$export$2e2bcd8739ae039 = $ccbf1090ff59cdcc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $003c31da04c7c688$var$ArrowDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 14l-7 7m0 0l-7-7m7 7V3"
    }));
}
const $003c31da04c7c688$var$ForwardRef = $f2Y41.forwardRef($003c31da04c7c688$var$ArrowDownIcon);
var $003c31da04c7c688$export$2e2bcd8739ae039 = $003c31da04c7c688$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9400836f1b8530da$var$ArrowLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19l-7-7m0 0l7-7m-7 7h18"
    }));
}
const $9400836f1b8530da$var$ForwardRef = $f2Y41.forwardRef($9400836f1b8530da$var$ArrowLeftIcon);
var $9400836f1b8530da$export$2e2bcd8739ae039 = $9400836f1b8530da$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7cccc3ad2ac13e42$var$ArrowNarrowDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 17l-4 4m0 0l-4-4m4 4V3"
    }));
}
const $7cccc3ad2ac13e42$var$ForwardRef = $f2Y41.forwardRef($7cccc3ad2ac13e42$var$ArrowNarrowDownIcon);
var $7cccc3ad2ac13e42$export$2e2bcd8739ae039 = $7cccc3ad2ac13e42$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2e966edf4cb1a436$var$ArrowNarrowLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 16l-4-4m0 0l4-4m-4 4h18"
    }));
}
const $2e966edf4cb1a436$var$ForwardRef = $f2Y41.forwardRef($2e966edf4cb1a436$var$ArrowNarrowLeftIcon);
var $2e966edf4cb1a436$export$2e2bcd8739ae039 = $2e966edf4cb1a436$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $87e7b862c6e09711$var$ArrowNarrowRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 8l4 4m0 0l-4 4m4-4H3"
    }));
}
const $87e7b862c6e09711$var$ForwardRef = $f2Y41.forwardRef($87e7b862c6e09711$var$ArrowNarrowRightIcon);
var $87e7b862c6e09711$export$2e2bcd8739ae039 = $87e7b862c6e09711$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $af542f6e073960ea$var$ArrowNarrowUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7l4-4m0 0l4 4m-4-4v18"
    }));
}
const $af542f6e073960ea$var$ForwardRef = $f2Y41.forwardRef($af542f6e073960ea$var$ArrowNarrowUpIcon);
var $af542f6e073960ea$export$2e2bcd8739ae039 = $af542f6e073960ea$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e8a2679353a9987c$var$ArrowRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14 5l7 7m0 0l-7 7m7-7H3"
    }));
}
const $e8a2679353a9987c$var$ForwardRef = $f2Y41.forwardRef($e8a2679353a9987c$var$ArrowRightIcon);
var $e8a2679353a9987c$export$2e2bcd8739ae039 = $e8a2679353a9987c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $034d76b5eb275e6d$var$ArrowSmDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 13l-5 5m0 0l-5-5m5 5V6"
    }));
}
const $034d76b5eb275e6d$var$ForwardRef = $f2Y41.forwardRef($034d76b5eb275e6d$var$ArrowSmDownIcon);
var $034d76b5eb275e6d$export$2e2bcd8739ae039 = $034d76b5eb275e6d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $661034651b33e390$var$ArrowSmLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 17l-5-5m0 0l5-5m-5 5h12"
    }));
}
const $661034651b33e390$var$ForwardRef = $f2Y41.forwardRef($661034651b33e390$var$ArrowSmLeftIcon);
var $661034651b33e390$export$2e2bcd8739ae039 = $661034651b33e390$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d17eaa6dbbd1b109$var$ArrowSmRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 7l5 5m0 0l-5 5m5-5H6"
    }));
}
const $d17eaa6dbbd1b109$var$ForwardRef = $f2Y41.forwardRef($d17eaa6dbbd1b109$var$ArrowSmRightIcon);
var $d17eaa6dbbd1b109$export$2e2bcd8739ae039 = $d17eaa6dbbd1b109$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7cc4147e086f587f$var$ArrowSmUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 11l5-5m0 0l5 5m-5-5v12"
    }));
}
const $7cc4147e086f587f$var$ForwardRef = $f2Y41.forwardRef($7cc4147e086f587f$var$ArrowSmUpIcon);
var $7cc4147e086f587f$export$2e2bcd8739ae039 = $7cc4147e086f587f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $edafd7dfda1f9869$var$ArrowUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 10l7-7m0 0l7 7m-7-7v18"
    }));
}
const $edafd7dfda1f9869$var$ForwardRef = $f2Y41.forwardRef($edafd7dfda1f9869$var$ArrowUpIcon);
var $edafd7dfda1f9869$export$2e2bcd8739ae039 = $edafd7dfda1f9869$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2b6991b4412a7bd1$var$ArrowsExpandIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
    }));
}
const $2b6991b4412a7bd1$var$ForwardRef = $f2Y41.forwardRef($2b6991b4412a7bd1$var$ArrowsExpandIcon);
var $2b6991b4412a7bd1$export$2e2bcd8739ae039 = $2b6991b4412a7bd1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $95e97b67bdf9b329$var$AtSymbolIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
    }));
}
const $95e97b67bdf9b329$var$ForwardRef = $f2Y41.forwardRef($95e97b67bdf9b329$var$AtSymbolIcon);
var $95e97b67bdf9b329$export$2e2bcd8739ae039 = $95e97b67bdf9b329$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $989a98553afcfd0f$var$BackspaceIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"
    }));
}
const $989a98553afcfd0f$var$ForwardRef = $f2Y41.forwardRef($989a98553afcfd0f$var$BackspaceIcon);
var $989a98553afcfd0f$export$2e2bcd8739ae039 = $989a98553afcfd0f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $88f8cb17ae941e92$var$BadgeCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
    }));
}
const $88f8cb17ae941e92$var$ForwardRef = $f2Y41.forwardRef($88f8cb17ae941e92$var$BadgeCheckIcon);
var $88f8cb17ae941e92$export$2e2bcd8739ae039 = $88f8cb17ae941e92$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b4a4aa74b32d44df$var$BanIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
    }));
}
const $b4a4aa74b32d44df$var$ForwardRef = $f2Y41.forwardRef($b4a4aa74b32d44df$var$BanIcon);
var $b4a4aa74b32d44df$export$2e2bcd8739ae039 = $b4a4aa74b32d44df$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c894b5cd71944d85$var$BeakerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
    }));
}
const $c894b5cd71944d85$var$ForwardRef = $f2Y41.forwardRef($c894b5cd71944d85$var$BeakerIcon);
var $c894b5cd71944d85$export$2e2bcd8739ae039 = $c894b5cd71944d85$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2fc55f54712dc8c9$var$BellIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    }));
}
const $2fc55f54712dc8c9$var$ForwardRef = $f2Y41.forwardRef($2fc55f54712dc8c9$var$BellIcon);
var $2fc55f54712dc8c9$export$2e2bcd8739ae039 = $2fc55f54712dc8c9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c94fa264e3708c29$var$BookOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
    }));
}
const $c94fa264e3708c29$var$ForwardRef = $f2Y41.forwardRef($c94fa264e3708c29$var$BookOpenIcon);
var $c94fa264e3708c29$export$2e2bcd8739ae039 = $c94fa264e3708c29$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $71ad25bc968842a5$var$BookmarkAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    }));
}
const $71ad25bc968842a5$var$ForwardRef = $f2Y41.forwardRef($71ad25bc968842a5$var$BookmarkAltIcon);
var $71ad25bc968842a5$export$2e2bcd8739ae039 = $71ad25bc968842a5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7a6be7c7e223ec19$var$BookmarkIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
    }));
}
const $7a6be7c7e223ec19$var$ForwardRef = $f2Y41.forwardRef($7a6be7c7e223ec19$var$BookmarkIcon);
var $7a6be7c7e223ec19$export$2e2bcd8739ae039 = $7a6be7c7e223ec19$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7834817f82e012e9$var$BriefcaseIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    }));
}
const $7834817f82e012e9$var$ForwardRef = $f2Y41.forwardRef($7834817f82e012e9$var$BriefcaseIcon);
var $7834817f82e012e9$export$2e2bcd8739ae039 = $7834817f82e012e9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2b00c5073f686be9$var$CakeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"
    }));
}
const $2b00c5073f686be9$var$ForwardRef = $f2Y41.forwardRef($2b00c5073f686be9$var$CakeIcon);
var $2b00c5073f686be9$export$2e2bcd8739ae039 = $2b00c5073f686be9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $46362d496cefe343$var$CalculatorIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    }));
}
const $46362d496cefe343$var$ForwardRef = $f2Y41.forwardRef($46362d496cefe343$var$CalculatorIcon);
var $46362d496cefe343$export$2e2bcd8739ae039 = $46362d496cefe343$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2cf237bbed3f4e6d$var$CalendarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    }));
}
const $2cf237bbed3f4e6d$var$ForwardRef = $f2Y41.forwardRef($2cf237bbed3f4e6d$var$CalendarIcon);
var $2cf237bbed3f4e6d$export$2e2bcd8739ae039 = $2cf237bbed3f4e6d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $af6b820ec356d814$var$CameraIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
    }));
}
const $af6b820ec356d814$var$ForwardRef = $f2Y41.forwardRef($af6b820ec356d814$var$CameraIcon);
var $af6b820ec356d814$export$2e2bcd8739ae039 = $af6b820ec356d814$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6fe29d0ab30bc5f0$var$CashIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
    }));
}
const $6fe29d0ab30bc5f0$var$ForwardRef = $f2Y41.forwardRef($6fe29d0ab30bc5f0$var$CashIcon);
var $6fe29d0ab30bc5f0$export$2e2bcd8739ae039 = $6fe29d0ab30bc5f0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2f2964f72fc75cf9$var$ChartBarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    }));
}
const $2f2964f72fc75cf9$var$ForwardRef = $f2Y41.forwardRef($2f2964f72fc75cf9$var$ChartBarIcon);
var $2f2964f72fc75cf9$export$2e2bcd8739ae039 = $2f2964f72fc75cf9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $427552637ec61ff7$var$ChartPieIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
    }));
}
const $427552637ec61ff7$var$ForwardRef = $f2Y41.forwardRef($427552637ec61ff7$var$ChartPieIcon);
var $427552637ec61ff7$export$2e2bcd8739ae039 = $427552637ec61ff7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f3a5b3c9293e16fe$var$ChartSquareBarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    }));
}
const $f3a5b3c9293e16fe$var$ForwardRef = $f2Y41.forwardRef($f3a5b3c9293e16fe$var$ChartSquareBarIcon);
var $f3a5b3c9293e16fe$export$2e2bcd8739ae039 = $f3a5b3c9293e16fe$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b5e0b36ea69da192$var$ChatAlt2Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
    }));
}
const $b5e0b36ea69da192$var$ForwardRef = $f2Y41.forwardRef($b5e0b36ea69da192$var$ChatAlt2Icon);
var $b5e0b36ea69da192$export$2e2bcd8739ae039 = $b5e0b36ea69da192$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0407a0df89050106$var$ChatAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
    }));
}
const $0407a0df89050106$var$ForwardRef = $f2Y41.forwardRef($0407a0df89050106$var$ChatAltIcon);
var $0407a0df89050106$export$2e2bcd8739ae039 = $0407a0df89050106$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d6baaa2d3b09bb28$var$ChatIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    }));
}
const $d6baaa2d3b09bb28$var$ForwardRef = $f2Y41.forwardRef($d6baaa2d3b09bb28$var$ChatIcon);
var $d6baaa2d3b09bb28$export$2e2bcd8739ae039 = $d6baaa2d3b09bb28$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1b079dd816430294$var$CheckCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $1b079dd816430294$var$ForwardRef = $f2Y41.forwardRef($1b079dd816430294$var$CheckCircleIcon);
var $1b079dd816430294$export$2e2bcd8739ae039 = $1b079dd816430294$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fafc9458db481e47$var$CheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 13l4 4L19 7"
    }));
}
const $fafc9458db481e47$var$ForwardRef = $f2Y41.forwardRef($fafc9458db481e47$var$CheckIcon);
var $fafc9458db481e47$export$2e2bcd8739ae039 = $fafc9458db481e47$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $08faa4925a475485$var$ChevronDoubleDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 13l-7 7-7-7m14-8l-7 7-7-7"
    }));
}
const $08faa4925a475485$var$ForwardRef = $f2Y41.forwardRef($08faa4925a475485$var$ChevronDoubleDownIcon);
var $08faa4925a475485$export$2e2bcd8739ae039 = $08faa4925a475485$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a286a93af0c79b08$var$ChevronDoubleLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
    }));
}
const $a286a93af0c79b08$var$ForwardRef = $f2Y41.forwardRef($a286a93af0c79b08$var$ChevronDoubleLeftIcon);
var $a286a93af0c79b08$export$2e2bcd8739ae039 = $a286a93af0c79b08$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $232e984b72f2e690$var$ChevronDoubleRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 5l7 7-7 7M5 5l7 7-7 7"
    }));
}
const $232e984b72f2e690$var$ForwardRef = $f2Y41.forwardRef($232e984b72f2e690$var$ChevronDoubleRightIcon);
var $232e984b72f2e690$export$2e2bcd8739ae039 = $232e984b72f2e690$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $86c90423e909235e$var$ChevronDoubleUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 11l7-7 7 7M5 19l7-7 7 7"
    }));
}
const $86c90423e909235e$var$ForwardRef = $f2Y41.forwardRef($86c90423e909235e$var$ChevronDoubleUpIcon);
var $86c90423e909235e$export$2e2bcd8739ae039 = $86c90423e909235e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1f980c767093f688$var$ChevronDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 9l-7 7-7-7"
    }));
}
const $1f980c767093f688$var$ForwardRef = $f2Y41.forwardRef($1f980c767093f688$var$ChevronDownIcon);
var $1f980c767093f688$export$2e2bcd8739ae039 = $1f980c767093f688$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $60de2a624844e287$var$ChevronLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 19l-7-7 7-7"
    }));
}
const $60de2a624844e287$var$ForwardRef = $f2Y41.forwardRef($60de2a624844e287$var$ChevronLeftIcon);
var $60de2a624844e287$export$2e2bcd8739ae039 = $60de2a624844e287$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f95ce8396b92a53e$var$ChevronRightIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 5l7 7-7 7"
    }));
}
const $f95ce8396b92a53e$var$ForwardRef = $f2Y41.forwardRef($f95ce8396b92a53e$var$ChevronRightIcon);
var $f95ce8396b92a53e$export$2e2bcd8739ae039 = $f95ce8396b92a53e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $144ecc46f24317bc$var$ChevronUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 15l7-7 7 7"
    }));
}
const $144ecc46f24317bc$var$ForwardRef = $f2Y41.forwardRef($144ecc46f24317bc$var$ChevronUpIcon);
var $144ecc46f24317bc$export$2e2bcd8739ae039 = $144ecc46f24317bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2d512d8b1cb3dc35$var$ChipIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
    }));
}
const $2d512d8b1cb3dc35$var$ForwardRef = $f2Y41.forwardRef($2d512d8b1cb3dc35$var$ChipIcon);
var $2d512d8b1cb3dc35$export$2e2bcd8739ae039 = $2d512d8b1cb3dc35$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $07bdcb76b10afbba$var$ClipboardCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    }));
}
const $07bdcb76b10afbba$var$ForwardRef = $f2Y41.forwardRef($07bdcb76b10afbba$var$ClipboardCheckIcon);
var $07bdcb76b10afbba$export$2e2bcd8739ae039 = $07bdcb76b10afbba$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $994c8fc4cbd6f2af$var$ClipboardCopyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
    }));
}
const $994c8fc4cbd6f2af$var$ForwardRef = $f2Y41.forwardRef($994c8fc4cbd6f2af$var$ClipboardCopyIcon);
var $994c8fc4cbd6f2af$export$2e2bcd8739ae039 = $994c8fc4cbd6f2af$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f0b6374804311366$var$ClipboardListIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    }));
}
const $f0b6374804311366$var$ForwardRef = $f2Y41.forwardRef($f0b6374804311366$var$ClipboardListIcon);
var $f0b6374804311366$export$2e2bcd8739ae039 = $f0b6374804311366$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $13eb762117c13df3$var$ClipboardIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
    }));
}
const $13eb762117c13df3$var$ForwardRef = $f2Y41.forwardRef($13eb762117c13df3$var$ClipboardIcon);
var $13eb762117c13df3$export$2e2bcd8739ae039 = $13eb762117c13df3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2612fa3b4b939ffc$var$ClockIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $2612fa3b4b939ffc$var$ForwardRef = $f2Y41.forwardRef($2612fa3b4b939ffc$var$ClockIcon);
var $2612fa3b4b939ffc$export$2e2bcd8739ae039 = $2612fa3b4b939ffc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $86916d24bfb64780$var$CloudDownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
    }));
}
const $86916d24bfb64780$var$ForwardRef = $f2Y41.forwardRef($86916d24bfb64780$var$CloudDownloadIcon);
var $86916d24bfb64780$export$2e2bcd8739ae039 = $86916d24bfb64780$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $921ae3a32c25dd5b$var$CloudUploadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    }));
}
const $921ae3a32c25dd5b$var$ForwardRef = $f2Y41.forwardRef($921ae3a32c25dd5b$var$CloudUploadIcon);
var $921ae3a32c25dd5b$export$2e2bcd8739ae039 = $921ae3a32c25dd5b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $512beb486b65ee5c$var$CloudIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
    }));
}
const $512beb486b65ee5c$var$ForwardRef = $f2Y41.forwardRef($512beb486b65ee5c$var$CloudIcon);
var $512beb486b65ee5c$export$2e2bcd8739ae039 = $512beb486b65ee5c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $181a92cbef651c6b$var$CodeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
    }));
}
const $181a92cbef651c6b$var$ForwardRef = $f2Y41.forwardRef($181a92cbef651c6b$var$CodeIcon);
var $181a92cbef651c6b$export$2e2bcd8739ae039 = $181a92cbef651c6b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5eb5c59bd4bde394$var$CogIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }));
}
const $5eb5c59bd4bde394$var$ForwardRef = $f2Y41.forwardRef($5eb5c59bd4bde394$var$CogIcon);
var $5eb5c59bd4bde394$export$2e2bcd8739ae039 = $5eb5c59bd4bde394$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cb366a06286fe6b0$var$CollectionIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    }));
}
const $cb366a06286fe6b0$var$ForwardRef = $f2Y41.forwardRef($cb366a06286fe6b0$var$CollectionIcon);
var $cb366a06286fe6b0$export$2e2bcd8739ae039 = $cb366a06286fe6b0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $04d72d98c63ced1f$var$ColorSwatchIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
    }));
}
const $04d72d98c63ced1f$var$ForwardRef = $f2Y41.forwardRef($04d72d98c63ced1f$var$ColorSwatchIcon);
var $04d72d98c63ced1f$export$2e2bcd8739ae039 = $04d72d98c63ced1f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fd3a16b6423c14a4$var$CreditCardIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    }));
}
const $fd3a16b6423c14a4$var$ForwardRef = $f2Y41.forwardRef($fd3a16b6423c14a4$var$CreditCardIcon);
var $fd3a16b6423c14a4$export$2e2bcd8739ae039 = $fd3a16b6423c14a4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $319f2c3a487a352d$var$CubeTransparentIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
    }));
}
const $319f2c3a487a352d$var$ForwardRef = $f2Y41.forwardRef($319f2c3a487a352d$var$CubeTransparentIcon);
var $319f2c3a487a352d$export$2e2bcd8739ae039 = $319f2c3a487a352d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $16c3457f9570ca27$var$CubeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
    }));
}
const $16c3457f9570ca27$var$ForwardRef = $f2Y41.forwardRef($16c3457f9570ca27$var$CubeIcon);
var $16c3457f9570ca27$export$2e2bcd8739ae039 = $16c3457f9570ca27$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f411b35c964540c7$var$CurrencyBangladeshiIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $f411b35c964540c7$var$ForwardRef = $f2Y41.forwardRef($f411b35c964540c7$var$CurrencyBangladeshiIcon);
var $f411b35c964540c7$export$2e2bcd8739ae039 = $f411b35c964540c7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5289c4e5944a7ec0$var$CurrencyDollarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $5289c4e5944a7ec0$var$ForwardRef = $f2Y41.forwardRef($5289c4e5944a7ec0$var$CurrencyDollarIcon);
var $5289c4e5944a7ec0$export$2e2bcd8739ae039 = $5289c4e5944a7ec0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $edf51db2848091cc$var$CurrencyEuroIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $edf51db2848091cc$var$ForwardRef = $f2Y41.forwardRef($edf51db2848091cc$var$CurrencyEuroIcon);
var $edf51db2848091cc$export$2e2bcd8739ae039 = $edf51db2848091cc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $10a6b12f84fa31e6$var$CurrencyPoundIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $10a6b12f84fa31e6$var$ForwardRef = $f2Y41.forwardRef($10a6b12f84fa31e6$var$CurrencyPoundIcon);
var $10a6b12f84fa31e6$export$2e2bcd8739ae039 = $10a6b12f84fa31e6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b4094ae9a6a3bb77$var$CurrencyRupeeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $b4094ae9a6a3bb77$var$ForwardRef = $f2Y41.forwardRef($b4094ae9a6a3bb77$var$CurrencyRupeeIcon);
var $b4094ae9a6a3bb77$export$2e2bcd8739ae039 = $b4094ae9a6a3bb77$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $94f36e1be1df0da0$var$CurrencyYenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 8l3 5m0 0l3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $94f36e1be1df0da0$var$ForwardRef = $f2Y41.forwardRef($94f36e1be1df0da0$var$CurrencyYenIcon);
var $94f36e1be1df0da0$export$2e2bcd8739ae039 = $94f36e1be1df0da0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c4b0a65bdf6405eb$var$CursorClickIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
    }));
}
const $c4b0a65bdf6405eb$var$ForwardRef = $f2Y41.forwardRef($c4b0a65bdf6405eb$var$CursorClickIcon);
var $c4b0a65bdf6405eb$export$2e2bcd8739ae039 = $c4b0a65bdf6405eb$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bf976c8ddbd70ec0$var$DatabaseIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
    }));
}
const $bf976c8ddbd70ec0$var$ForwardRef = $f2Y41.forwardRef($bf976c8ddbd70ec0$var$DatabaseIcon);
var $bf976c8ddbd70ec0$export$2e2bcd8739ae039 = $bf976c8ddbd70ec0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1900adb81699e30d$var$DesktopComputerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    }));
}
const $1900adb81699e30d$var$ForwardRef = $f2Y41.forwardRef($1900adb81699e30d$var$DesktopComputerIcon);
var $1900adb81699e30d$export$2e2bcd8739ae039 = $1900adb81699e30d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a38fc182c81a1b73$var$DeviceMobileIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
    }));
}
const $a38fc182c81a1b73$var$ForwardRef = $f2Y41.forwardRef($a38fc182c81a1b73$var$DeviceMobileIcon);
var $a38fc182c81a1b73$export$2e2bcd8739ae039 = $a38fc182c81a1b73$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $cef6feb730836f3a$var$DeviceTabletIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    }));
}
const $cef6feb730836f3a$var$ForwardRef = $f2Y41.forwardRef($cef6feb730836f3a$var$DeviceTabletIcon);
var $cef6feb730836f3a$export$2e2bcd8739ae039 = $cef6feb730836f3a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f0af8089560f4d8b$var$DocumentAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    }));
}
const $f0af8089560f4d8b$var$ForwardRef = $f2Y41.forwardRef($f0af8089560f4d8b$var$DocumentAddIcon);
var $f0af8089560f4d8b$export$2e2bcd8739ae039 = $f0af8089560f4d8b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e3077f9be828659a$var$DocumentDownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    }));
}
const $e3077f9be828659a$var$ForwardRef = $f2Y41.forwardRef($e3077f9be828659a$var$DocumentDownloadIcon);
var $e3077f9be828659a$export$2e2bcd8739ae039 = $e3077f9be828659a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $20661ec6de732dce$var$DocumentDuplicateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
    }));
}
const $20661ec6de732dce$var$ForwardRef = $f2Y41.forwardRef($20661ec6de732dce$var$DocumentDuplicateIcon);
var $20661ec6de732dce$export$2e2bcd8739ae039 = $20661ec6de732dce$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c7819911749b0ca4$var$DocumentRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    }));
}
const $c7819911749b0ca4$var$ForwardRef = $f2Y41.forwardRef($c7819911749b0ca4$var$DocumentRemoveIcon);
var $c7819911749b0ca4$export$2e2bcd8739ae039 = $c7819911749b0ca4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a26d7a79dfc3ff85$var$DocumentReportIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    }));
}
const $a26d7a79dfc3ff85$var$ForwardRef = $f2Y41.forwardRef($a26d7a79dfc3ff85$var$DocumentReportIcon);
var $a26d7a79dfc3ff85$export$2e2bcd8739ae039 = $a26d7a79dfc3ff85$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7399576a6d396a43$var$DocumentSearchIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
    }));
}
const $7399576a6d396a43$var$ForwardRef = $f2Y41.forwardRef($7399576a6d396a43$var$DocumentSearchIcon);
var $7399576a6d396a43$export$2e2bcd8739ae039 = $7399576a6d396a43$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $44de4fce481b8a9f$var$DocumentTextIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    }));
}
const $44de4fce481b8a9f$var$ForwardRef = $f2Y41.forwardRef($44de4fce481b8a9f$var$DocumentTextIcon);
var $44de4fce481b8a9f$export$2e2bcd8739ae039 = $44de4fce481b8a9f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2b5070ce5fe4282d$var$DocumentIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    }));
}
const $2b5070ce5fe4282d$var$ForwardRef = $f2Y41.forwardRef($2b5070ce5fe4282d$var$DocumentIcon);
var $2b5070ce5fe4282d$export$2e2bcd8739ae039 = $2b5070ce5fe4282d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fb9eb3e29c92cf4a$var$DotsCircleHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $fb9eb3e29c92cf4a$var$ForwardRef = $f2Y41.forwardRef($fb9eb3e29c92cf4a$var$DotsCircleHorizontalIcon);
var $fb9eb3e29c92cf4a$export$2e2bcd8739ae039 = $fb9eb3e29c92cf4a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $de320a6e2977a291$var$DotsHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
    }));
}
const $de320a6e2977a291$var$ForwardRef = $f2Y41.forwardRef($de320a6e2977a291$var$DotsHorizontalIcon);
var $de320a6e2977a291$export$2e2bcd8739ae039 = $de320a6e2977a291$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $207780583ff605f6$var$DotsVerticalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
    }));
}
const $207780583ff605f6$var$ForwardRef = $f2Y41.forwardRef($207780583ff605f6$var$DotsVerticalIcon);
var $207780583ff605f6$export$2e2bcd8739ae039 = $207780583ff605f6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $35bf3c31bc6a1304$var$DownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    }));
}
const $35bf3c31bc6a1304$var$ForwardRef = $f2Y41.forwardRef($35bf3c31bc6a1304$var$DownloadIcon);
var $35bf3c31bc6a1304$export$2e2bcd8739ae039 = $35bf3c31bc6a1304$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $281dbb0145fb8fbf$var$DuplicateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
    }));
}
const $281dbb0145fb8fbf$var$ForwardRef = $f2Y41.forwardRef($281dbb0145fb8fbf$var$DuplicateIcon);
var $281dbb0145fb8fbf$export$2e2bcd8739ae039 = $281dbb0145fb8fbf$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a7137d7ffb23fe01$var$EmojiHappyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $a7137d7ffb23fe01$var$ForwardRef = $f2Y41.forwardRef($a7137d7ffb23fe01$var$EmojiHappyIcon);
var $a7137d7ffb23fe01$export$2e2bcd8739ae039 = $a7137d7ffb23fe01$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $bb85d7ca43369979$var$EmojiSadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $bb85d7ca43369979$var$ForwardRef = $f2Y41.forwardRef($bb85d7ca43369979$var$EmojiSadIcon);
var $bb85d7ca43369979$export$2e2bcd8739ae039 = $bb85d7ca43369979$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c1ac02fb92947ddd$var$ExclamationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $c1ac02fb92947ddd$var$ForwardRef = $f2Y41.forwardRef($c1ac02fb92947ddd$var$ExclamationCircleIcon);
var $c1ac02fb92947ddd$export$2e2bcd8739ae039 = $c1ac02fb92947ddd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $62af8c3c834dbe70$var$ExclamationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    }));
}
const $62af8c3c834dbe70$var$ForwardRef = $f2Y41.forwardRef($62af8c3c834dbe70$var$ExclamationIcon);
var $62af8c3c834dbe70$export$2e2bcd8739ae039 = $62af8c3c834dbe70$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f27071e0a21578db$var$ExternalLinkIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
    }));
}
const $f27071e0a21578db$var$ForwardRef = $f2Y41.forwardRef($f27071e0a21578db$var$ExternalLinkIcon);
var $f27071e0a21578db$export$2e2bcd8739ae039 = $f27071e0a21578db$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $56704984f866251b$var$EyeOffIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
    }));
}
const $56704984f866251b$var$ForwardRef = $f2Y41.forwardRef($56704984f866251b$var$EyeOffIcon);
var $56704984f866251b$export$2e2bcd8739ae039 = $56704984f866251b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $21d6d4908910124d$var$EyeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }));
}
const $21d6d4908910124d$var$ForwardRef = $f2Y41.forwardRef($21d6d4908910124d$var$EyeIcon);
var $21d6d4908910124d$export$2e2bcd8739ae039 = $21d6d4908910124d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $dda3b9186e0ed43b$var$FastForwardIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"
    }));
}
const $dda3b9186e0ed43b$var$ForwardRef = $f2Y41.forwardRef($dda3b9186e0ed43b$var$FastForwardIcon);
var $dda3b9186e0ed43b$export$2e2bcd8739ae039 = $dda3b9186e0ed43b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7ec54a839322616d$var$FilmIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"
    }));
}
const $7ec54a839322616d$var$ForwardRef = $f2Y41.forwardRef($7ec54a839322616d$var$FilmIcon);
var $7ec54a839322616d$export$2e2bcd8739ae039 = $7ec54a839322616d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $69afc93c70f432a0$var$FilterIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    }));
}
const $69afc93c70f432a0$var$ForwardRef = $f2Y41.forwardRef($69afc93c70f432a0$var$FilterIcon);
var $69afc93c70f432a0$export$2e2bcd8739ae039 = $69afc93c70f432a0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $55d588d867c97180$var$FingerPrintIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
    }));
}
const $55d588d867c97180$var$ForwardRef = $f2Y41.forwardRef($55d588d867c97180$var$FingerPrintIcon);
var $55d588d867c97180$export$2e2bcd8739ae039 = $55d588d867c97180$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $72bd83a7ae9ab820$var$FireIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
    }));
}
const $72bd83a7ae9ab820$var$ForwardRef = $f2Y41.forwardRef($72bd83a7ae9ab820$var$FireIcon);
var $72bd83a7ae9ab820$export$2e2bcd8739ae039 = $72bd83a7ae9ab820$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $61f5049c9ffce44d$var$FlagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
    }));
}
const $61f5049c9ffce44d$var$ForwardRef = $f2Y41.forwardRef($61f5049c9ffce44d$var$FlagIcon);
var $61f5049c9ffce44d$export$2e2bcd8739ae039 = $61f5049c9ffce44d$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2b6c6feb1e5a06c4$var$FolderAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }));
}
const $2b6c6feb1e5a06c4$var$ForwardRef = $f2Y41.forwardRef($2b6c6feb1e5a06c4$var$FolderAddIcon);
var $2b6c6feb1e5a06c4$export$2e2bcd8739ae039 = $2b6c6feb1e5a06c4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1c24ba3acf8f8741$var$FolderDownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }));
}
const $1c24ba3acf8f8741$var$ForwardRef = $f2Y41.forwardRef($1c24ba3acf8f8741$var$FolderDownloadIcon);
var $1c24ba3acf8f8741$export$2e2bcd8739ae039 = $1c24ba3acf8f8741$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f3f31ecfc57b0f76$var$FolderOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
    }));
}
const $f3f31ecfc57b0f76$var$ForwardRef = $f2Y41.forwardRef($f3f31ecfc57b0f76$var$FolderOpenIcon);
var $f3f31ecfc57b0f76$export$2e2bcd8739ae039 = $f3f31ecfc57b0f76$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $693851365e813cdc$var$FolderRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }));
}
const $693851365e813cdc$var$ForwardRef = $f2Y41.forwardRef($693851365e813cdc$var$FolderRemoveIcon);
var $693851365e813cdc$export$2e2bcd8739ae039 = $693851365e813cdc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3ed1b3dc3c25a177$var$FolderIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
    }));
}
const $3ed1b3dc3c25a177$var$ForwardRef = $f2Y41.forwardRef($3ed1b3dc3c25a177$var$FolderIcon);
var $3ed1b3dc3c25a177$export$2e2bcd8739ae039 = $3ed1b3dc3c25a177$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ce33fcbcf673ace2$var$GiftIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
    }));
}
const $ce33fcbcf673ace2$var$ForwardRef = $f2Y41.forwardRef($ce33fcbcf673ace2$var$GiftIcon);
var $ce33fcbcf673ace2$export$2e2bcd8739ae039 = $ce33fcbcf673ace2$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b45563bde55e1e8b$var$GlobeAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
    }));
}
const $b45563bde55e1e8b$var$ForwardRef = $f2Y41.forwardRef($b45563bde55e1e8b$var$GlobeAltIcon);
var $b45563bde55e1e8b$export$2e2bcd8739ae039 = $b45563bde55e1e8b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $dd167d64cb5b05ec$var$GlobeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $dd167d64cb5b05ec$var$ForwardRef = $f2Y41.forwardRef($dd167d64cb5b05ec$var$GlobeIcon);
var $dd167d64cb5b05ec$export$2e2bcd8739ae039 = $dd167d64cb5b05ec$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f61349a7edd5dbd7$var$HandIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
    }));
}
const $f61349a7edd5dbd7$var$ForwardRef = $f2Y41.forwardRef($f61349a7edd5dbd7$var$HandIcon);
var $f61349a7edd5dbd7$export$2e2bcd8739ae039 = $f61349a7edd5dbd7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ea047d7333bc5185$var$HashtagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
    }));
}
const $ea047d7333bc5185$var$ForwardRef = $f2Y41.forwardRef($ea047d7333bc5185$var$HashtagIcon);
var $ea047d7333bc5185$export$2e2bcd8739ae039 = $ea047d7333bc5185$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $dbba45d109e3eb6c$var$HeartIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
    }));
}
const $dbba45d109e3eb6c$var$ForwardRef = $f2Y41.forwardRef($dbba45d109e3eb6c$var$HeartIcon);
var $dbba45d109e3eb6c$export$2e2bcd8739ae039 = $dbba45d109e3eb6c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $eddd1c88790019b4$var$HomeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    }));
}
const $eddd1c88790019b4$var$ForwardRef = $f2Y41.forwardRef($eddd1c88790019b4$var$HomeIcon);
var $eddd1c88790019b4$export$2e2bcd8739ae039 = $eddd1c88790019b4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a0e8799b8384d82c$var$IdentificationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
    }));
}
const $a0e8799b8384d82c$var$ForwardRef = $f2Y41.forwardRef($a0e8799b8384d82c$var$IdentificationIcon);
var $a0e8799b8384d82c$export$2e2bcd8739ae039 = $a0e8799b8384d82c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $46e90ecaeef22821$var$InboxInIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
    }));
}
const $46e90ecaeef22821$var$ForwardRef = $f2Y41.forwardRef($46e90ecaeef22821$var$InboxInIcon);
var $46e90ecaeef22821$export$2e2bcd8739ae039 = $46e90ecaeef22821$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $413493fce7fbde62$var$InboxIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
    }));
}
const $413493fce7fbde62$var$ForwardRef = $f2Y41.forwardRef($413493fce7fbde62$var$InboxIcon);
var $413493fce7fbde62$export$2e2bcd8739ae039 = $413493fce7fbde62$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d613c39e3c685885$var$InformationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $d613c39e3c685885$var$ForwardRef = $f2Y41.forwardRef($d613c39e3c685885$var$InformationCircleIcon);
var $d613c39e3c685885$export$2e2bcd8739ae039 = $d613c39e3c685885$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $17b217220a3ecef6$var$KeyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
    }));
}
const $17b217220a3ecef6$var$ForwardRef = $f2Y41.forwardRef($17b217220a3ecef6$var$KeyIcon);
var $17b217220a3ecef6$export$2e2bcd8739ae039 = $17b217220a3ecef6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $793f9f9805b99121$var$LibraryIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
    }));
}
const $793f9f9805b99121$var$ForwardRef = $f2Y41.forwardRef($793f9f9805b99121$var$LibraryIcon);
var $793f9f9805b99121$export$2e2bcd8739ae039 = $793f9f9805b99121$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d1a9cecc78aeee09$var$LightBulbIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
    }));
}
const $d1a9cecc78aeee09$var$ForwardRef = $f2Y41.forwardRef($d1a9cecc78aeee09$var$LightBulbIcon);
var $d1a9cecc78aeee09$export$2e2bcd8739ae039 = $d1a9cecc78aeee09$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $10835fae1bee76ac$var$LightningBoltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 10V3L4 14h7v7l9-11h-7z"
    }));
}
const $10835fae1bee76ac$var$ForwardRef = $f2Y41.forwardRef($10835fae1bee76ac$var$LightningBoltIcon);
var $10835fae1bee76ac$export$2e2bcd8739ae039 = $10835fae1bee76ac$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a639068eabe310f1$var$LinkIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    }));
}
const $a639068eabe310f1$var$ForwardRef = $f2Y41.forwardRef($a639068eabe310f1$var$LinkIcon);
var $a639068eabe310f1$export$2e2bcd8739ae039 = $a639068eabe310f1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c89324b8257c3a6a$var$LocationMarkerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    }));
}
const $c89324b8257c3a6a$var$ForwardRef = $f2Y41.forwardRef($c89324b8257c3a6a$var$LocationMarkerIcon);
var $c89324b8257c3a6a$export$2e2bcd8739ae039 = $c89324b8257c3a6a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $74db8e259bbc8607$var$LockClosedIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
    }));
}
const $74db8e259bbc8607$var$ForwardRef = $f2Y41.forwardRef($74db8e259bbc8607$var$LockClosedIcon);
var $74db8e259bbc8607$export$2e2bcd8739ae039 = $74db8e259bbc8607$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f7adefdd39ab2587$var$LockOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
    }));
}
const $f7adefdd39ab2587$var$ForwardRef = $f2Y41.forwardRef($f7adefdd39ab2587$var$LockOpenIcon);
var $f7adefdd39ab2587$export$2e2bcd8739ae039 = $f7adefdd39ab2587$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d38db750053653b2$var$LoginIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
    }));
}
const $d38db750053653b2$var$ForwardRef = $f2Y41.forwardRef($d38db750053653b2$var$LoginIcon);
var $d38db750053653b2$export$2e2bcd8739ae039 = $d38db750053653b2$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f0df21b5277beb14$var$LogoutIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    }));
}
const $f0df21b5277beb14$var$ForwardRef = $f2Y41.forwardRef($f0df21b5277beb14$var$LogoutIcon);
var $f0df21b5277beb14$export$2e2bcd8739ae039 = $f0df21b5277beb14$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e99715e9e5e05749$var$MailOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
    }));
}
const $e99715e9e5e05749$var$ForwardRef = $f2Y41.forwardRef($e99715e9e5e05749$var$MailOpenIcon);
var $e99715e9e5e05749$export$2e2bcd8739ae039 = $e99715e9e5e05749$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $64a995915ed701d1$var$MailIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    }));
}
const $64a995915ed701d1$var$ForwardRef = $f2Y41.forwardRef($64a995915ed701d1$var$MailIcon);
var $64a995915ed701d1$export$2e2bcd8739ae039 = $64a995915ed701d1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8cb3ecbddfc6922a$var$MapIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
    }));
}
const $8cb3ecbddfc6922a$var$ForwardRef = $f2Y41.forwardRef($8cb3ecbddfc6922a$var$MapIcon);
var $8cb3ecbddfc6922a$export$2e2bcd8739ae039 = $8cb3ecbddfc6922a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3c5cae76508edc7e$var$MenuAlt1Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6h16M4 12h8m-8 6h16"
    }));
}
const $3c5cae76508edc7e$var$ForwardRef = $f2Y41.forwardRef($3c5cae76508edc7e$var$MenuAlt1Icon);
var $3c5cae76508edc7e$export$2e2bcd8739ae039 = $3c5cae76508edc7e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $1fc2c2eab1ee21d8$var$MenuAlt2Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6h16M4 12h16M4 18h7"
    }));
}
const $1fc2c2eab1ee21d8$var$ForwardRef = $f2Y41.forwardRef($1fc2c2eab1ee21d8$var$MenuAlt2Icon);
var $1fc2c2eab1ee21d8$export$2e2bcd8739ae039 = $1fc2c2eab1ee21d8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $72799eed99306be8$var$MenuAlt3Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6h16M4 12h16m-7 6h7"
    }));
}
const $72799eed99306be8$var$ForwardRef = $f2Y41.forwardRef($72799eed99306be8$var$MenuAlt3Icon);
var $72799eed99306be8$export$2e2bcd8739ae039 = $72799eed99306be8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7e8a9fc49a3eea26$var$MenuAlt4Icon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 8h16M4 16h16"
    }));
}
const $7e8a9fc49a3eea26$var$ForwardRef = $f2Y41.forwardRef($7e8a9fc49a3eea26$var$MenuAlt4Icon);
var $7e8a9fc49a3eea26$export$2e2bcd8739ae039 = $7e8a9fc49a3eea26$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5d4f177f2ad49a93$var$MenuIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6h16M4 12h16M4 18h16"
    }));
}
const $5d4f177f2ad49a93$var$ForwardRef = $f2Y41.forwardRef($5d4f177f2ad49a93$var$MenuIcon);
var $5d4f177f2ad49a93$export$2e2bcd8739ae039 = $5d4f177f2ad49a93$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0fe0e789a3e9da49$var$MicrophoneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
    }));
}
const $0fe0e789a3e9da49$var$ForwardRef = $f2Y41.forwardRef($0fe0e789a3e9da49$var$MicrophoneIcon);
var $0fe0e789a3e9da49$export$2e2bcd8739ae039 = $0fe0e789a3e9da49$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3df1da9770584c96$var$MinusCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $3df1da9770584c96$var$ForwardRef = $f2Y41.forwardRef($3df1da9770584c96$var$MinusCircleIcon);
var $3df1da9770584c96$export$2e2bcd8739ae039 = $3df1da9770584c96$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8d8b716b1f3278f9$var$MinusSmIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18 12H6"
    }));
}
const $8d8b716b1f3278f9$var$ForwardRef = $f2Y41.forwardRef($8d8b716b1f3278f9$var$MinusSmIcon);
var $8d8b716b1f3278f9$export$2e2bcd8739ae039 = $8d8b716b1f3278f9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8444ae4bc0736fdd$var$MinusIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20 12H4"
    }));
}
const $8444ae4bc0736fdd$var$ForwardRef = $f2Y41.forwardRef($8444ae4bc0736fdd$var$MinusIcon);
var $8444ae4bc0736fdd$export$2e2bcd8739ae039 = $8444ae4bc0736fdd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d0efdb9932c013ae$var$MoonIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
    }));
}
const $d0efdb9932c013ae$var$ForwardRef = $f2Y41.forwardRef($d0efdb9932c013ae$var$MoonIcon);
var $d0efdb9932c013ae$export$2e2bcd8739ae039 = $d0efdb9932c013ae$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $03d78081a6ae1fe5$var$MusicNoteIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
    }));
}
const $03d78081a6ae1fe5$var$ForwardRef = $f2Y41.forwardRef($03d78081a6ae1fe5$var$MusicNoteIcon);
var $03d78081a6ae1fe5$export$2e2bcd8739ae039 = $03d78081a6ae1fe5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3274b46291e4879e$var$NewspaperIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
    }));
}
const $3274b46291e4879e$var$ForwardRef = $f2Y41.forwardRef($3274b46291e4879e$var$NewspaperIcon);
var $3274b46291e4879e$export$2e2bcd8739ae039 = $3274b46291e4879e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8f5d03c899e9276a$var$OfficeBuildingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    }));
}
const $8f5d03c899e9276a$var$ForwardRef = $f2Y41.forwardRef($8f5d03c899e9276a$var$OfficeBuildingIcon);
var $8f5d03c899e9276a$export$2e2bcd8739ae039 = $8f5d03c899e9276a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $64420b868819649c$var$PaperAirplaneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
    }));
}
const $64420b868819649c$var$ForwardRef = $f2Y41.forwardRef($64420b868819649c$var$PaperAirplaneIcon);
var $64420b868819649c$export$2e2bcd8739ae039 = $64420b868819649c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3fc9e2fba8d59b78$var$PaperClipIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
    }));
}
const $3fc9e2fba8d59b78$var$ForwardRef = $f2Y41.forwardRef($3fc9e2fba8d59b78$var$PaperClipIcon);
var $3fc9e2fba8d59b78$export$2e2bcd8739ae039 = $3fc9e2fba8d59b78$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6b3269349279077f$var$PauseIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $6b3269349279077f$var$ForwardRef = $f2Y41.forwardRef($6b3269349279077f$var$PauseIcon);
var $6b3269349279077f$export$2e2bcd8739ae039 = $6b3269349279077f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9da693eb0d1c27a7$var$PencilAltIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    }));
}
const $9da693eb0d1c27a7$var$ForwardRef = $f2Y41.forwardRef($9da693eb0d1c27a7$var$PencilAltIcon);
var $9da693eb0d1c27a7$export$2e2bcd8739ae039 = $9da693eb0d1c27a7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a5e2e9594a99aace$var$PencilIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    }));
}
const $a5e2e9594a99aace$var$ForwardRef = $f2Y41.forwardRef($a5e2e9594a99aace$var$PencilIcon);
var $a5e2e9594a99aace$export$2e2bcd8739ae039 = $a5e2e9594a99aace$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $12d2273ae2630954$var$PhoneIncomingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
    }));
}
const $12d2273ae2630954$var$ForwardRef = $f2Y41.forwardRef($12d2273ae2630954$var$PhoneIncomingIcon);
var $12d2273ae2630954$export$2e2bcd8739ae039 = $12d2273ae2630954$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a690289613ab88f4$var$PhoneMissedCallIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
    }));
}
const $a690289613ab88f4$var$ForwardRef = $f2Y41.forwardRef($a690289613ab88f4$var$PhoneMissedCallIcon);
var $a690289613ab88f4$export$2e2bcd8739ae039 = $a690289613ab88f4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $604acd0805401c25$var$PhoneOutgoingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
    }));
}
const $604acd0805401c25$var$ForwardRef = $f2Y41.forwardRef($604acd0805401c25$var$PhoneOutgoingIcon);
var $604acd0805401c25$export$2e2bcd8739ae039 = $604acd0805401c25$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $685b7d4a9d698f2a$var$PhoneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
    }));
}
const $685b7d4a9d698f2a$var$ForwardRef = $f2Y41.forwardRef($685b7d4a9d698f2a$var$PhoneIcon);
var $685b7d4a9d698f2a$export$2e2bcd8739ae039 = $685b7d4a9d698f2a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b4480991806d0143$var$PhotographIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    }));
}
const $b4480991806d0143$var$ForwardRef = $f2Y41.forwardRef($b4480991806d0143$var$PhotographIcon);
var $b4480991806d0143$export$2e2bcd8739ae039 = $b4480991806d0143$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d1de718650823f09$var$PlayIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $d1de718650823f09$var$ForwardRef = $f2Y41.forwardRef($d1de718650823f09$var$PlayIcon);
var $d1de718650823f09$export$2e2bcd8739ae039 = $d1de718650823f09$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ee9273d07eac7330$var$PlusCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $ee9273d07eac7330$var$ForwardRef = $f2Y41.forwardRef($ee9273d07eac7330$var$PlusCircleIcon);
var $ee9273d07eac7330$export$2e2bcd8739ae039 = $ee9273d07eac7330$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $941a87b0981c7446$var$PlusSmIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
    }));
}
const $941a87b0981c7446$var$ForwardRef = $f2Y41.forwardRef($941a87b0981c7446$var$PlusSmIcon);
var $941a87b0981c7446$export$2e2bcd8739ae039 = $941a87b0981c7446$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4b6ab616db315ff8$var$PlusIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4v16m8-8H4"
    }));
}
const $4b6ab616db315ff8$var$ForwardRef = $f2Y41.forwardRef($4b6ab616db315ff8$var$PlusIcon);
var $4b6ab616db315ff8$export$2e2bcd8739ae039 = $4b6ab616db315ff8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $746031ae8fa1516a$var$PresentationChartBarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
    }));
}
const $746031ae8fa1516a$var$ForwardRef = $f2Y41.forwardRef($746031ae8fa1516a$var$PresentationChartBarIcon);
var $746031ae8fa1516a$export$2e2bcd8739ae039 = $746031ae8fa1516a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $32832e3fca8bdfa3$var$PresentationChartLineIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
    }));
}
const $32832e3fca8bdfa3$var$ForwardRef = $f2Y41.forwardRef($32832e3fca8bdfa3$var$PresentationChartLineIcon);
var $32832e3fca8bdfa3$export$2e2bcd8739ae039 = $32832e3fca8bdfa3$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c4ded3e7ebde6131$var$PrinterIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
    }));
}
const $c4ded3e7ebde6131$var$ForwardRef = $f2Y41.forwardRef($c4ded3e7ebde6131$var$PrinterIcon);
var $c4ded3e7ebde6131$export$2e2bcd8739ae039 = $c4ded3e7ebde6131$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a77d7dd31b1bec61$var$PuzzleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
    }));
}
const $a77d7dd31b1bec61$var$ForwardRef = $f2Y41.forwardRef($a77d7dd31b1bec61$var$PuzzleIcon);
var $a77d7dd31b1bec61$export$2e2bcd8739ae039 = $a77d7dd31b1bec61$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $52ccd452731e47bc$var$QrcodeIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
    }));
}
const $52ccd452731e47bc$var$ForwardRef = $f2Y41.forwardRef($52ccd452731e47bc$var$QrcodeIcon);
var $52ccd452731e47bc$export$2e2bcd8739ae039 = $52ccd452731e47bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3510d94202e415bc$var$QuestionMarkCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $3510d94202e415bc$var$ForwardRef = $f2Y41.forwardRef($3510d94202e415bc$var$QuestionMarkCircleIcon);
var $3510d94202e415bc$export$2e2bcd8739ae039 = $3510d94202e415bc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $0f36186b31e4db46$var$ReceiptRefundIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"
    }));
}
const $0f36186b31e4db46$var$ForwardRef = $f2Y41.forwardRef($0f36186b31e4db46$var$ReceiptRefundIcon);
var $0f36186b31e4db46$export$2e2bcd8739ae039 = $0f36186b31e4db46$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $23c2dceef30bcf18$var$ReceiptTaxIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"
    }));
}
const $23c2dceef30bcf18$var$ForwardRef = $f2Y41.forwardRef($23c2dceef30bcf18$var$ReceiptTaxIcon);
var $23c2dceef30bcf18$export$2e2bcd8739ae039 = $23c2dceef30bcf18$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d94b97f5b0c21944$var$RefreshIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    }));
}
const $d94b97f5b0c21944$var$ForwardRef = $f2Y41.forwardRef($d94b97f5b0c21944$var$RefreshIcon);
var $d94b97f5b0c21944$export$2e2bcd8739ae039 = $d94b97f5b0c21944$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $415088ee1216f0d8$var$ReplyIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
    }));
}
const $415088ee1216f0d8$var$ForwardRef = $f2Y41.forwardRef($415088ee1216f0d8$var$ReplyIcon);
var $415088ee1216f0d8$export$2e2bcd8739ae039 = $415088ee1216f0d8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $82062c8e123332b2$var$RewindIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"
    }));
}
const $82062c8e123332b2$var$ForwardRef = $f2Y41.forwardRef($82062c8e123332b2$var$RewindIcon);
var $82062c8e123332b2$export$2e2bcd8739ae039 = $82062c8e123332b2$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fece26d87548bfc4$var$RssIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"
    }));
}
const $fece26d87548bfc4$var$ForwardRef = $f2Y41.forwardRef($fece26d87548bfc4$var$RssIcon);
var $fece26d87548bfc4$export$2e2bcd8739ae039 = $fece26d87548bfc4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $dc51f0fb9ae56d3a$var$SaveAsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3"
    }));
}
const $dc51f0fb9ae56d3a$var$ForwardRef = $f2Y41.forwardRef($dc51f0fb9ae56d3a$var$SaveAsIcon);
var $dc51f0fb9ae56d3a$export$2e2bcd8739ae039 = $dc51f0fb9ae56d3a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $c18a3d012ce527e9$var$SaveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
    }));
}
const $c18a3d012ce527e9$var$ForwardRef = $f2Y41.forwardRef($c18a3d012ce527e9$var$SaveIcon);
var $c18a3d012ce527e9$export$2e2bcd8739ae039 = $c18a3d012ce527e9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $52e1081ae309509f$var$ScaleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
    }));
}
const $52e1081ae309509f$var$ForwardRef = $f2Y41.forwardRef($52e1081ae309509f$var$ScaleIcon);
var $52e1081ae309509f$export$2e2bcd8739ae039 = $52e1081ae309509f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ac00f60dfc72dea1$var$ScissorsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z"
    }));
}
const $ac00f60dfc72dea1$var$ForwardRef = $f2Y41.forwardRef($ac00f60dfc72dea1$var$ScissorsIcon);
var $ac00f60dfc72dea1$export$2e2bcd8739ae039 = $ac00f60dfc72dea1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $36f4602694959627$var$SearchCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $36f4602694959627$var$ForwardRef = $f2Y41.forwardRef($36f4602694959627$var$SearchCircleIcon);
var $36f4602694959627$export$2e2bcd8739ae039 = $36f4602694959627$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6dde497c8a0a789f$var$SearchIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    }));
}
const $6dde497c8a0a789f$var$ForwardRef = $f2Y41.forwardRef($6dde497c8a0a789f$var$SearchIcon);
var $6dde497c8a0a789f$export$2e2bcd8739ae039 = $6dde497c8a0a789f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a2e54268d6820edc$var$SelectorIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 9l4-4 4 4m0 6l-4 4-4-4"
    }));
}
const $a2e54268d6820edc$var$ForwardRef = $f2Y41.forwardRef($a2e54268d6820edc$var$SelectorIcon);
var $a2e54268d6820edc$export$2e2bcd8739ae039 = $a2e54268d6820edc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4cedd2a2fbf93119$var$ServerIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
    }));
}
const $4cedd2a2fbf93119$var$ForwardRef = $f2Y41.forwardRef($4cedd2a2fbf93119$var$ServerIcon);
var $4cedd2a2fbf93119$export$2e2bcd8739ae039 = $4cedd2a2fbf93119$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8753bf8fffaf83b6$var$ShareIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
    }));
}
const $8753bf8fffaf83b6$var$ForwardRef = $f2Y41.forwardRef($8753bf8fffaf83b6$var$ShareIcon);
var $8753bf8fffaf83b6$export$2e2bcd8739ae039 = $8753bf8fffaf83b6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a685243db2303b85$var$ShieldCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
    }));
}
const $a685243db2303b85$var$ForwardRef = $f2Y41.forwardRef($a685243db2303b85$var$ShieldCheckIcon);
var $a685243db2303b85$export$2e2bcd8739ae039 = $a685243db2303b85$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b1d4f209c1facca4$var$ShieldExclamationIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"
    }));
}
const $b1d4f209c1facca4$var$ForwardRef = $f2Y41.forwardRef($b1d4f209c1facca4$var$ShieldExclamationIcon);
var $b1d4f209c1facca4$export$2e2bcd8739ae039 = $b1d4f209c1facca4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $561ff3afb16b77cf$var$ShoppingBagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
    }));
}
const $561ff3afb16b77cf$var$ForwardRef = $f2Y41.forwardRef($561ff3afb16b77cf$var$ShoppingBagIcon);
var $561ff3afb16b77cf$export$2e2bcd8739ae039 = $561ff3afb16b77cf$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $00a240f7c56aeb25$var$ShoppingCartIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
    }));
}
const $00a240f7c56aeb25$var$ForwardRef = $f2Y41.forwardRef($00a240f7c56aeb25$var$ShoppingCartIcon);
var $00a240f7c56aeb25$export$2e2bcd8739ae039 = $00a240f7c56aeb25$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5250e5a73ed0a1e1$var$SortAscendingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    }));
}
const $5250e5a73ed0a1e1$var$ForwardRef = $f2Y41.forwardRef($5250e5a73ed0a1e1$var$SortAscendingIcon);
var $5250e5a73ed0a1e1$export$2e2bcd8739ae039 = $5250e5a73ed0a1e1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f2671cdcf9df0348$var$SortDescendingIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
    }));
}
const $f2671cdcf9df0348$var$ForwardRef = $f2Y41.forwardRef($f2671cdcf9df0348$var$SortDescendingIcon);
var $f2671cdcf9df0348$export$2e2bcd8739ae039 = $f2671cdcf9df0348$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7b6446f142a8d538$var$SparklesIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
    }));
}
const $7b6446f142a8d538$var$ForwardRef = $f2Y41.forwardRef($7b6446f142a8d538$var$SparklesIcon);
var $7b6446f142a8d538$export$2e2bcd8739ae039 = $7b6446f142a8d538$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $73e6b578fc54b4b9$var$SpeakerphoneIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
    }));
}
const $73e6b578fc54b4b9$var$ForwardRef = $f2Y41.forwardRef($73e6b578fc54b4b9$var$SpeakerphoneIcon);
var $73e6b578fc54b4b9$export$2e2bcd8739ae039 = $73e6b578fc54b4b9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e12159b96e99ae14$var$StarIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
    }));
}
const $e12159b96e99ae14$var$ForwardRef = $f2Y41.forwardRef($e12159b96e99ae14$var$StarIcon);
var $e12159b96e99ae14$export$2e2bcd8739ae039 = $e12159b96e99ae14$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ca1ff4af9f287bb1$var$StatusOfflineIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
    }));
}
const $ca1ff4af9f287bb1$var$ForwardRef = $f2Y41.forwardRef($ca1ff4af9f287bb1$var$StatusOfflineIcon);
var $ca1ff4af9f287bb1$export$2e2bcd8739ae039 = $ca1ff4af9f287bb1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $89a167b364fe430f$var$StatusOnlineIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
    }));
}
const $89a167b364fe430f$var$ForwardRef = $f2Y41.forwardRef($89a167b364fe430f$var$StatusOnlineIcon);
var $89a167b364fe430f$export$2e2bcd8739ae039 = $89a167b364fe430f$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $6cd1323acafd4cf6$var$StopIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
    }));
}
const $6cd1323acafd4cf6$var$ForwardRef = $f2Y41.forwardRef($6cd1323acafd4cf6$var$StopIcon);
var $6cd1323acafd4cf6$export$2e2bcd8739ae039 = $6cd1323acafd4cf6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3b3b2a62f4ef65fd$var$SunIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
    }));
}
const $3b3b2a62f4ef65fd$var$ForwardRef = $f2Y41.forwardRef($3b3b2a62f4ef65fd$var$SunIcon);
var $3b3b2a62f4ef65fd$export$2e2bcd8739ae039 = $3b3b2a62f4ef65fd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $55ab35d3dac85ee4$var$SupportIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
    }));
}
const $55ab35d3dac85ee4$var$ForwardRef = $f2Y41.forwardRef($55ab35d3dac85ee4$var$SupportIcon);
var $55ab35d3dac85ee4$export$2e2bcd8739ae039 = $55ab35d3dac85ee4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $fe8f0d827d1c50ec$var$SwitchHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
    }));
}
const $fe8f0d827d1c50ec$var$ForwardRef = $f2Y41.forwardRef($fe8f0d827d1c50ec$var$SwitchHorizontalIcon);
var $fe8f0d827d1c50ec$export$2e2bcd8739ae039 = $fe8f0d827d1c50ec$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5ed19a40da1e6b8c$var$SwitchVerticalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
    }));
}
const $5ed19a40da1e6b8c$var$ForwardRef = $f2Y41.forwardRef($5ed19a40da1e6b8c$var$SwitchVerticalIcon);
var $5ed19a40da1e6b8c$export$2e2bcd8739ae039 = $5ed19a40da1e6b8c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a530a5b929960634$var$TableIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
    }));
}
const $a530a5b929960634$var$ForwardRef = $f2Y41.forwardRef($a530a5b929960634$var$TableIcon);
var $a530a5b929960634$export$2e2bcd8739ae039 = $a530a5b929960634$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $b17b087e8ef7016c$var$TagIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    }));
}
const $b17b087e8ef7016c$var$ForwardRef = $f2Y41.forwardRef($b17b087e8ef7016c$var$TagIcon);
var $b17b087e8ef7016c$export$2e2bcd8739ae039 = $b17b087e8ef7016c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $42fe4581bf7a19d0$var$TemplateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
    }));
}
const $42fe4581bf7a19d0$var$ForwardRef = $f2Y41.forwardRef($42fe4581bf7a19d0$var$TemplateIcon);
var $42fe4581bf7a19d0$export$2e2bcd8739ae039 = $42fe4581bf7a19d0$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $dd1926b550ffbee9$var$TerminalIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    }));
}
const $dd1926b550ffbee9$var$ForwardRef = $f2Y41.forwardRef($dd1926b550ffbee9$var$TerminalIcon);
var $dd1926b550ffbee9$export$2e2bcd8739ae039 = $dd1926b550ffbee9$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $995a4d2aea4e7824$var$ThumbDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
    }));
}
const $995a4d2aea4e7824$var$ForwardRef = $f2Y41.forwardRef($995a4d2aea4e7824$var$ThumbDownIcon);
var $995a4d2aea4e7824$export$2e2bcd8739ae039 = $995a4d2aea4e7824$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d65fb0699aeeaa05$var$ThumbUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
    }));
}
const $d65fb0699aeeaa05$var$ForwardRef = $f2Y41.forwardRef($d65fb0699aeeaa05$var$ThumbUpIcon);
var $d65fb0699aeeaa05$export$2e2bcd8739ae039 = $d65fb0699aeeaa05$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $877437626669d84e$var$TicketIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    }));
}
const $877437626669d84e$var$ForwardRef = $f2Y41.forwardRef($877437626669d84e$var$TicketIcon);
var $877437626669d84e$export$2e2bcd8739ae039 = $877437626669d84e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $89cb732bc6a191c7$var$TranslateIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
    }));
}
const $89cb732bc6a191c7$var$ForwardRef = $f2Y41.forwardRef($89cb732bc6a191c7$var$TranslateIcon);
var $89cb732bc6a191c7$export$2e2bcd8739ae039 = $89cb732bc6a191c7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $f3be71fadbe74fb4$var$TrashIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    }));
}
const $f3be71fadbe74fb4$var$ForwardRef = $f2Y41.forwardRef($f3be71fadbe74fb4$var$TrashIcon);
var $f3be71fadbe74fb4$export$2e2bcd8739ae039 = $f3be71fadbe74fb4$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $2f8d8afb58291aa8$var$TrendingDownIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
    }));
}
const $2f8d8afb58291aa8$var$ForwardRef = $f2Y41.forwardRef($2f8d8afb58291aa8$var$TrendingDownIcon);
var $2f8d8afb58291aa8$export$2e2bcd8739ae039 = $2f8d8afb58291aa8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ff269a99de83d910$var$TrendingUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
    }));
}
const $ff269a99de83d910$var$ForwardRef = $f2Y41.forwardRef($ff269a99de83d910$var$TrendingUpIcon);
var $ff269a99de83d910$export$2e2bcd8739ae039 = $ff269a99de83d910$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $19f99d90bc0f1ffc$var$TruckIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        d: "M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
    }));
}
const $19f99d90bc0f1ffc$var$ForwardRef = $f2Y41.forwardRef($19f99d90bc0f1ffc$var$TruckIcon);
var $19f99d90bc0f1ffc$export$2e2bcd8739ae039 = $19f99d90bc0f1ffc$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $665b9cd26560b922$var$UploadIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
    }));
}
const $665b9cd26560b922$var$ForwardRef = $f2Y41.forwardRef($665b9cd26560b922$var$UploadIcon);
var $665b9cd26560b922$export$2e2bcd8739ae039 = $665b9cd26560b922$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9a7a32db9df475c6$var$UserAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
    }));
}
const $9a7a32db9df475c6$var$ForwardRef = $f2Y41.forwardRef($9a7a32db9df475c6$var$UserAddIcon);
var $9a7a32db9df475c6$export$2e2bcd8739ae039 = $9a7a32db9df475c6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $409eb6fc9c6a2d80$var$UserCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $409eb6fc9c6a2d80$var$ForwardRef = $f2Y41.forwardRef($409eb6fc9c6a2d80$var$UserCircleIcon);
var $409eb6fc9c6a2d80$export$2e2bcd8739ae039 = $409eb6fc9c6a2d80$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $9babdb9833a5aa4b$var$UserGroupIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    }));
}
const $9babdb9833a5aa4b$var$ForwardRef = $f2Y41.forwardRef($9babdb9833a5aa4b$var$UserGroupIcon);
var $9babdb9833a5aa4b$export$2e2bcd8739ae039 = $9babdb9833a5aa4b$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $e37976393d66ace5$var$UserRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
    }));
}
const $e37976393d66ace5$var$ForwardRef = $f2Y41.forwardRef($e37976393d66ace5$var$UserRemoveIcon);
var $e37976393d66ace5$export$2e2bcd8739ae039 = $e37976393d66ace5$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $89a988fed0d1159a$var$UserIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    }));
}
const $89a988fed0d1159a$var$ForwardRef = $f2Y41.forwardRef($89a988fed0d1159a$var$UserIcon);
var $89a988fed0d1159a$export$2e2bcd8739ae039 = $89a988fed0d1159a$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $30670fdc031ff068$var$UsersIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    }));
}
const $30670fdc031ff068$var$ForwardRef = $f2Y41.forwardRef($30670fdc031ff068$var$UsersIcon);
var $30670fdc031ff068$export$2e2bcd8739ae039 = $30670fdc031ff068$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $a005ecf32adff1ff$var$VariableIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.871 4A17.926 17.926 0 003 12c0 2.874.673 5.59 1.871 8m14.13 0a17.926 17.926 0 001.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 01.961.725l1.586 5.55a1 1 0 00.961.725H15m1-7h-.08a2 2 0 00-1.519.698L9.6 15.302A2 2 0 018.08 16H8"
    }));
}
const $a005ecf32adff1ff$var$ForwardRef = $f2Y41.forwardRef($a005ecf32adff1ff$var$VariableIcon);
var $a005ecf32adff1ff$export$2e2bcd8739ae039 = $a005ecf32adff1ff$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $95c09c158534d408$var$VideoCameraIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
    }));
}
const $95c09c158534d408$var$ForwardRef = $f2Y41.forwardRef($95c09c158534d408$var$VideoCameraIcon);
var $95c09c158534d408$export$2e2bcd8739ae039 = $95c09c158534d408$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $5e7f701b77b252dd$var$ViewBoardsIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
    }));
}
const $5e7f701b77b252dd$var$ForwardRef = $f2Y41.forwardRef($5e7f701b77b252dd$var$ViewBoardsIcon);
var $5e7f701b77b252dd$export$2e2bcd8739ae039 = $5e7f701b77b252dd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $046cb31f76ea58a6$var$ViewGridAddIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
    }));
}
const $046cb31f76ea58a6$var$ForwardRef = $f2Y41.forwardRef($046cb31f76ea58a6$var$ViewGridAddIcon);
var $046cb31f76ea58a6$export$2e2bcd8739ae039 = $046cb31f76ea58a6$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $4c58855ec53dacfd$var$ViewGridIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
    }));
}
const $4c58855ec53dacfd$var$ForwardRef = $f2Y41.forwardRef($4c58855ec53dacfd$var$ViewGridIcon);
var $4c58855ec53dacfd$export$2e2bcd8739ae039 = $4c58855ec53dacfd$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $3864103d312aca82$var$ViewListIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6h16M4 10h16M4 14h16M4 18h16"
    }));
}
const $3864103d312aca82$var$ForwardRef = $f2Y41.forwardRef($3864103d312aca82$var$ViewListIcon);
var $3864103d312aca82$export$2e2bcd8739ae039 = $3864103d312aca82$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $d264c4d5be4aacf8$var$VolumeOffIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
    }));
}
const $d264c4d5be4aacf8$var$ForwardRef = $f2Y41.forwardRef($d264c4d5be4aacf8$var$VolumeOffIcon);
var $d264c4d5be4aacf8$export$2e2bcd8739ae039 = $d264c4d5be4aacf8$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $7787a644b4a2e7f7$var$VolumeUpIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
    }));
}
const $7787a644b4a2e7f7$var$ForwardRef = $f2Y41.forwardRef($7787a644b4a2e7f7$var$VolumeUpIcon);
var $7787a644b4a2e7f7$export$2e2bcd8739ae039 = $7787a644b4a2e7f7$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $455f523f749c24e1$var$WifiIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
    }));
}
const $455f523f749c24e1$var$ForwardRef = $f2Y41.forwardRef($455f523f749c24e1$var$WifiIcon);
var $455f523f749c24e1$export$2e2bcd8739ae039 = $455f523f749c24e1$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $552c4fbc911a9b8c$var$XCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $552c4fbc911a9b8c$var$ForwardRef = $f2Y41.forwardRef($552c4fbc911a9b8c$var$XCircleIcon);
var $552c4fbc911a9b8c$export$2e2bcd8739ae039 = $552c4fbc911a9b8c$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $ad688b80368a215e$var$XIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
    }));
}
const $ad688b80368a215e$var$ForwardRef = $f2Y41.forwardRef($ad688b80368a215e$var$XIcon);
var $ad688b80368a215e$export$2e2bcd8739ae039 = $ad688b80368a215e$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $8dbe681d7195a365$var$ZoomInIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
    }));
}
const $8dbe681d7195a365$var$ForwardRef = $f2Y41.forwardRef($8dbe681d7195a365$var$ZoomInIcon);
var $8dbe681d7195a365$export$2e2bcd8739ae039 = $8dbe681d7195a365$var$ForwardRef;



var $f2Y41 = parcelRequire("f2Y41");
function $869649043f5485c4$var$ZoomOutIcon(props, svgRef) {
    return /*#__PURE__*/ $f2Y41.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $f2Y41.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"
    }));
}
const $869649043f5485c4$var$ForwardRef = $f2Y41.forwardRef($869649043f5485c4$var$ZoomOutIcon);
var $869649043f5485c4$export$2e2bcd8739ae039 = $869649043f5485c4$var$ForwardRef;




const $7e2c281be9fe9de6$export$501b3ffe9d0bcd91 = (props)=>{
    const defaultClasses = "w-6 h-6 text-gray-600";
    const { icon: icon, className: className = defaultClasses, outline: outline = false, extraClasses: extraClasses } = props;
    const Icon = outline ? $8e586341ed5745cf$exports[icon] : $785afa6b592087b8$exports[icon];
    return /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, {
        className: className + " " + extraClasses
    });
};


function $38f9efe7437397ea$export$dbd093c273051430(props) {
    props = {
        outline: false,
        bgColorClass: "bg-topo-green",
        bgHoverColorClass: "hover:bg-topo-green-600",
        focusRingColorClass: "focus:ring-topo-green-500",
        ...props
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
        type: "button",
        className: `inline-flex items-center p-2 pr-4 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white ${props.bgColorClass} ${props.bgHoverColorClass} focus:outline-none focus:ring-2 focus:ring-offset-2 ${props.focusRingColorClass} ${props.className}`,
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: props.icon,
                className: `h-5 w-7 mr-1 text-white ${props.iconClassName}`,
                outline: props.outline
            }),
            props.text
        ]
    });
}




function $4426f6ea82d5b247$export$c67a8869b938d43b() {
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    // TODO: drive this off env.PRACTICE_ID presence?
    const multiTenantEnabled = false;
    const networkManagementTenantId = undefined;
    const networkManagement = [];
    const siteManagement = [];
    const contentLinks = [];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "p-6",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("h5", {
                className: "text-2xl mb-4 font-bold tracking-tight text-gray-900 dark:text-gray-200 flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                        icon: "CogIcon",
                        className: "h-5 mr-2 self-center"
                    }),
                    "Admin"
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "grid grid-cols-1 gap-2",
                children: [
                    multiTenantEnabled && practiceId === networkManagementTenantId && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                className: "text-xl font-bold mb-4",
                                children: "Network Management"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex flex-col space-y-2 w-48",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue",
                                        to: "/admin/users",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "UsersIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Users"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/team_xrefs",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "UserGroupIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Team External References"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/practices",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "HeartIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Practices"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/sponsors",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "OfficeBuildingIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Sponsors"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/studies",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "ClipboardListIcon",
                                            // icon="ViewfinderCircleIcon"
                                            className: "flex-grow p-4 self-center",
                                            text: "Studies"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/indications",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "ExclamationCircleIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Indications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/sync-configuration",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "ShareIcon",
                                            className: "text-justify flex-grow p-4 self-center",
                                            text: "Sync Configuration"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                className: "text-xl font-bold mb-4",
                                children: "Site Management"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex flex-col space-y-2 w-48",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue",
                                        to: "/admin/quality-assurance",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "ClipboardIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Quality Assurance"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/dashboard",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "ChartBarIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "DashboardDemo"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                className: "text-xl font-bold mb-4",
                                children: "Content Management"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex flex-col space-y-2 w-48",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue",
                                        to: "/uploads",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "CloudUploadIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Uploads"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/events",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "RssIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Events"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        className: "flex flex-grow text-blue mb-4",
                                        to: "/admin/comments",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                            icon: "SpeakerphoneIcon",
                                            className: "flex-grow p-4 self-center",
                                            text: "Comments"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
var $48358001e7c1220f$exports = {};
"use strict";
Object.defineProperty($48358001e7c1220f$exports, "__esModule", {
    value: true
});
$48358001e7c1220f$exports.isLowerCase = $48358001e7c1220f$exports.isUpperCase = $48358001e7c1220f$exports.upperCaseFirst = $48358001e7c1220f$exports.localeUpperCase = $48358001e7c1220f$exports.upperCase = $48358001e7c1220f$exports.titleCase = $48358001e7c1220f$exports.swapCase = $48358001e7c1220f$exports.spongeCase = $48358001e7c1220f$exports.lowerCaseFirst = $48358001e7c1220f$exports.localeLowerCase = $48358001e7c1220f$exports.lowerCase = $48358001e7c1220f$exports.snakeCase = $48358001e7c1220f$exports.sentenceCase = $48358001e7c1220f$exports.pathCase = $48358001e7c1220f$exports.pascalCase = $48358001e7c1220f$exports.paramCase = $48358001e7c1220f$exports.noCase = $48358001e7c1220f$exports.headerCase = $48358001e7c1220f$exports.dotCase = $48358001e7c1220f$exports.constantCase = $48358001e7c1220f$exports.capitalCase = $48358001e7c1220f$exports.camelCase = void 0;

var $4nqhV = parcelRequire("4nqhV");

var $4nqhV = parcelRequire("4nqhV");
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $72009fffcc5cd254$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $72009fffcc5cd254$export$206cd6ecad4fcdde(str, locale) {
    var lang = $72009fffcc5cd254$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $72009fffcc5cd254$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $72009fffcc5cd254$export$61d6efbc6547e8eb(str);
}
function $72009fffcc5cd254$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}


// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $772640e4a1725071$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $772640e4a1725071$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $772640e4a1725071$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $772640e4a1725071$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $772640e4a1725071$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $72009fffcc5cd254$export$61d6efbc6547e8eb) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $772640e4a1725071$var$replace($772640e4a1725071$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $772640e4a1725071$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}


function $01f44eb67b57fc21$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $01f44eb67b57fc21$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $01f44eb67b57fc21$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $772640e4a1725071$export$a596972587f860c8)(input, (0, $4nqhV.__assign)({
        delimiter: "",
        transform: $01f44eb67b57fc21$export$66a4dfea2695736
    }, options));
}


function $cdcdf06bf9578c65$export$1c6885769b2bad6f(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $01f44eb67b57fc21$export$66a4dfea2695736)(input, index);
}
function $cdcdf06bf9578c65$export$f3c8e8146a7dbf93(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $01f44eb67b57fc21$export$c27cf446dc44c0b9)(input);
}
function $cdcdf06bf9578c65$export$8a7688a96d852767(input, options) {
    if (options === void 0) options = {};
    return (0, $01f44eb67b57fc21$export$26c6f48841fe1a8a)(input, (0, $4nqhV.__assign)({
        transform: $cdcdf06bf9578c65$export$1c6885769b2bad6f
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

/**
 * Upper case the first character of an input string.
 */ function $dded7f43b2f3e76f$export$688230ca06b60d9d(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}


function $a51689dc4d76953f$export$2a6bd1f4c244c979(input) {
    return (0, $dded7f43b2f3e76f$export$688230ca06b60d9d)(input.toLowerCase());
}
function $a51689dc4d76953f$export$7fed55d4315c6715(input, options) {
    if (options === void 0) options = {};
    return (0, $772640e4a1725071$export$a596972587f860c8)(input, (0, $4nqhV.__assign)({
        delimiter: " ",
        transform: $a51689dc4d76953f$export$2a6bd1f4c244c979
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $e888ed060de79de7$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    az: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    lt: {
        regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
        map: {
            i\u0307: "I",
            j\u0307: "J",
            \u012F\u0307: "\u012E",
            i\u0307\u0300: "\xcc",
            i\u0307\u0301: "\xcd",
            i\u0307\u0303: "\u0128"
        }
    }
};
function $e888ed060de79de7$export$41a02e171a5184fc(str, locale) {
    var lang = $e888ed060de79de7$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $e888ed060de79de7$export$5b4b56d38b0b3c58(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $e888ed060de79de7$export$5b4b56d38b0b3c58(str);
}
function $e888ed060de79de7$export$5b4b56d38b0b3c58(str) {
    return str.toUpperCase();
}


function $37706e264d527e5f$export$f44cdeb23aa06bbd(input, options) {
    if (options === void 0) options = {};
    return (0, $772640e4a1725071$export$a596972587f860c8)(input, (0, $4nqhV.__assign)({
        delimiter: "_",
        transform: (0, $e888ed060de79de7$export$5b4b56d38b0b3c58)
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

function $77d10e6674e17a72$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $772640e4a1725071$export$a596972587f860c8)(input, (0, $4nqhV.__assign)({
        delimiter: "."
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

function $2dc84a93dee55b41$export$e434c8e1873659bf(input, options) {
    if (options === void 0) options = {};
    return (0, $a51689dc4d76953f$export$7fed55d4315c6715)(input, (0, $4nqhV.__assign)({
        delimiter: "-"
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

function $ec651d998521c063$export$c68d52815ae74c39(input, options) {
    if (options === void 0) options = {};
    return (0, $77d10e6674e17a72$export$e1b697368b9a68f5)(input, (0, $4nqhV.__assign)({
        delimiter: "-"
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

function $9b5c7897d2d2a635$export$a5cc9254bc4d91c0(input, options) {
    if (options === void 0) options = {};
    return (0, $77d10e6674e17a72$export$e1b697368b9a68f5)(input, (0, $4nqhV.__assign)({
        delimiter: "/"
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");


function $0af98298458b837b$export$69c57745bdd126a5(input, index) {
    var result = input.toLowerCase();
    if (index === 0) return (0, $dded7f43b2f3e76f$export$688230ca06b60d9d)(result);
    return result;
}
function $0af98298458b837b$export$da1ec1d734312f9f(input, options) {
    if (options === void 0) options = {};
    return (0, $772640e4a1725071$export$a596972587f860c8)(input, (0, $4nqhV.__assign)({
        delimiter: " ",
        transform: $0af98298458b837b$export$69c57745bdd126a5
    }, options));
}


var $4nqhV = parcelRequire("4nqhV");

function $2f528e33d53cc561$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $77d10e6674e17a72$export$e1b697368b9a68f5)(input, (0, $4nqhV.__assign)({
        delimiter: "_"
    }, options));
}



/**
 * Lower case the first character of an input string.
 */ function $6afade3b450bc02f$export$d433db62168b4e14(input) {
    return input.charAt(0).toLowerCase() + input.substr(1);
}


function $e7b7437abb6edf97$export$d5641a7fa412991a(input) {
    var result = "";
    for(var i = 0; i < input.length; i++)result += Math.random() > 0.5 ? input[i].toUpperCase() : input[i].toLowerCase();
    return result;
}


function $0cbd4f3454e5ac90$export$8c20c666decc2148(input) {
    var result = "";
    for(var i = 0; i < input.length; i++){
        var lower = input[i].toLowerCase();
        result += input[i] === lower ? input[i].toUpperCase() : lower;
    }
    return result;
}


var $40dc5d76e95a50af$var$SMALL_WORDS = /\b(?:an?d?|a[st]|because|but|by|en|for|i[fn]|neither|nor|o[fnr]|only|over|per|so|some|tha[tn]|the|to|up|upon|vs?\.?|versus|via|when|with|without|yet)\b/i;
var $40dc5d76e95a50af$var$TOKENS = /[^\s:–—-]+|./g;
var $40dc5d76e95a50af$var$WHITESPACE = /\s/;
var $40dc5d76e95a50af$var$IS_MANUAL_CASE = /.(?=[A-Z]|\..)/;
var $40dc5d76e95a50af$var$ALPHANUMERIC_PATTERN = /[A-Za-z0-9\u00C0-\u00FF]/;
function $40dc5d76e95a50af$export$348afa8c9ff47183(input) {
    var result = "";
    var m;
    // tslint:disable-next-line
    while((m = $40dc5d76e95a50af$var$TOKENS.exec(input)) !== null){
        var token = m[0], index = m.index;
        if (// Ignore already capitalized words.
        !$40dc5d76e95a50af$var$IS_MANUAL_CASE.test(token) && // Ignore small words except at beginning or end.
        (!$40dc5d76e95a50af$var$SMALL_WORDS.test(token) || index === 0 || index + token.length === input.length) && // Ignore URLs.
        (input.charAt(index + token.length) !== ":" || $40dc5d76e95a50af$var$WHITESPACE.test(input.charAt(index + token.length + 1)))) {
            // Find and uppercase first word character, skips over *modifiers*.
            result += token.replace($40dc5d76e95a50af$var$ALPHANUMERIC_PATTERN, function(m) {
                return m.toUpperCase();
            });
            continue;
        }
        result += token;
    }
    return result;
}




/**
 * Returns a boolean indicating whether the string is upper case.
 */ function $cd01c33444fe339b$export$aebd617640818cda(input) {
    return input.toUpperCase() === input && input.toLowerCase() !== input;
}


/**
 * Returns a boolean indicating whether the string is lower case.
 */ function $08f7a4e5d66ff928$export$7b6804e8df61fcf5(input) {
    return input.toLowerCase() === input && input.toUpperCase() !== input;
}


// Core
$48358001e7c1220f$exports.camelCase = $cdcdf06bf9578c65$export$8a7688a96d852767;
$48358001e7c1220f$exports.capitalCase = $a51689dc4d76953f$export$7fed55d4315c6715;
$48358001e7c1220f$exports.constantCase = $37706e264d527e5f$export$f44cdeb23aa06bbd;
$48358001e7c1220f$exports.dotCase = $77d10e6674e17a72$export$e1b697368b9a68f5;
$48358001e7c1220f$exports.headerCase = $2dc84a93dee55b41$export$e434c8e1873659bf;
$48358001e7c1220f$exports.noCase = $772640e4a1725071$export$a596972587f860c8;
$48358001e7c1220f$exports.paramCase = $ec651d998521c063$export$c68d52815ae74c39;
$48358001e7c1220f$exports.pascalCase = $01f44eb67b57fc21$export$26c6f48841fe1a8a;
$48358001e7c1220f$exports.pathCase = $9b5c7897d2d2a635$export$a5cc9254bc4d91c0;
$48358001e7c1220f$exports.sentenceCase = $0af98298458b837b$export$da1ec1d734312f9f;
$48358001e7c1220f$exports.snakeCase = $2f528e33d53cc561$export$feae9a740c003485;
// Extended
$48358001e7c1220f$exports.lowerCase = $72009fffcc5cd254$export$61d6efbc6547e8eb;
$48358001e7c1220f$exports.localeLowerCase = $72009fffcc5cd254$export$206cd6ecad4fcdde;
$48358001e7c1220f$exports.lowerCaseFirst = $6afade3b450bc02f$export$d433db62168b4e14;
$48358001e7c1220f$exports.spongeCase = $e7b7437abb6edf97$export$d5641a7fa412991a;
$48358001e7c1220f$exports.swapCase = $0cbd4f3454e5ac90$export$8c20c666decc2148;
$48358001e7c1220f$exports.titleCase = $40dc5d76e95a50af$export$348afa8c9ff47183;
$48358001e7c1220f$exports.upperCase = $e888ed060de79de7$export$5b4b56d38b0b3c58;
$48358001e7c1220f$exports.localeUpperCase = $e888ed060de79de7$export$41a02e171a5184fc;
$48358001e7c1220f$exports.upperCaseFirst = $dded7f43b2f3e76f$export$688230ca06b60d9d;
$48358001e7c1220f$exports.isUpperCase = $cd01c33444fe339b$export$aebd617640818cda;
$48358001e7c1220f$exports.isLowerCase = $08f7a4e5d66ff928$export$7b6804e8df61fcf5;



const $17235661ec5f519b$export$b94aa994a2f01789 = (input)=>{
    if (!input) return "";
    return (0, $48358001e7c1220f$exports.titleCase)(input?.split("_")?.join(" "));
};
const $17235661ec5f519b$export$6f72bf0393042ad9 = (name)=>{
    if (!name) return "";
    const initials = `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`;
    return initials;
};
const $17235661ec5f519b$export$cc8b315fc368b20a = (input)=>{
    return input.charAt(0).toLowerCase() + input.slice(1) // Lowercase the first character
    .replace(/\W+/g, " ") // Remove all excess white space and replace & , . etc.
    .replace(/([a-z])([A-Z])([a-z])/g, "$1 $2$3") // Put a space at the position of a camelCase -> camel Case
    .split(/\B(?=[A-Z]{2,})/) // Now split the multi-uppercases customerID -> customer,ID
    .join(" ") // And join back with spaces.
    .split(" ") // Split all the spaces again, this time we're fully converted
    .join("_") // And finally snake_case things up
    .toLowerCase() // With a nice lower case
    ;
};


var $31fa34d95f8e4f00$exports = {};

$31fa34d95f8e4f00$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "utahAvatar.8e2c83a7.png";


const $2a0b772244d08cba$var$utah = new URL($31fa34d95f8e4f00$exports);
function $2a0b772244d08cba$export$e2255cf6045e8d47(props) {
    const { name: name, initials: initials } = props;
    const derivedInitials = (0, $17235661ec5f519b$export$6f72bf0393042ad9)(name);
    const upperCaseInitials = initials ? (0, $48358001e7c1220f$exports.upperCase)(initials) : (0, $48358001e7c1220f$exports.upperCase)(derivedInitials);
    if (initials || derivedInitials) return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        title: initials || derivedInitials,
        className: `bg-topo-navy z-100 text-white select-none flex justify-center items-center border-1 rounded-full h-8 w-8 pt-[0.05rem] pl-[0.02rem] text-sm dark:border-gray-700 cursor-pointer ${props.className}`,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
            className: "z-100",
            children: upperCaseInitials
        })
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        title: "Unknown User",
        className: `bg-topo-navy z-100 text-white select-none flex justify-center items-center border-1 rounded-full h-8 w-8 pt-[0.05rem] pl-[0.02rem] text-sm dark:border-gray-700 cursor-pointer ${props.className}`,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
            className: "z-100",
            children: "?"
        })
    });
}






var $53d9fabda7c69fdf$var$MILLISECONDS_IN_DAY = 86400000;
function $53d9fabda7c69fdf$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $74f52af975a975f2$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $74f52af975a975f2$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $68d32ed92f1780db$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $68d32ed92f1780db$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $53d9fabda7c69fdf$var$MILLISECONDS_IN_DAY);
}









function $827d644bb829cda7$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDate);
    var baseDate = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyBaseDate);
    var defaultOptions = (0, $7af4ee9d46606c52$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $11c73620e3946d30$export$2e2bcd8739ae039);
    var weekStartsOn = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    if (!locale.formatRelative) throw new RangeError("locale must contain formatRelative property");
    var diff = (0, $53d9fabda7c69fdf$export$2e2bcd8739ae039)(date, baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    var token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    var utcDate = (0, $d3915e7617ed4456$export$2e2bcd8739ae039)(date, (0, $68d32ed92f1780db$export$2e2bcd8739ae039)(date));
    var utcBaseDate = (0, $d3915e7617ed4456$export$2e2bcd8739ae039)(baseDate, (0, $68d32ed92f1780db$export$2e2bcd8739ae039)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $016afe2497ddcf15$export$2e2bcd8739ae039)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}




function $b96a98eff2e03a49$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $aae07cb3fa09534a$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $b96a98eff2e03a49$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $b96a98eff2e03a49$var$parseYear(dateStrings.date, additionalDigits);
        date = $b96a98eff2e03a49$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $b96a98eff2e03a49$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $b96a98eff2e03a49$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $b96a98eff2e03a49$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $b96a98eff2e03a49$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $b96a98eff2e03a49$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $b96a98eff2e03a49$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $b96a98eff2e03a49$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($b96a98eff2e03a49$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($b96a98eff2e03a49$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($b96a98eff2e03a49$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $b96a98eff2e03a49$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b96a98eff2e03a49$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $b96a98eff2e03a49$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($b96a98eff2e03a49$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $b96a98eff2e03a49$var$parseDateUnit(captures[1]);
    var month = $b96a98eff2e03a49$var$parseDateUnit(captures[2]) - 1;
    var day = $b96a98eff2e03a49$var$parseDateUnit(captures[3]);
    var week = $b96a98eff2e03a49$var$parseDateUnit(captures[4]);
    var dayOfWeek = $b96a98eff2e03a49$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$b96a98eff2e03a49$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b96a98eff2e03a49$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$b96a98eff2e03a49$var$validateDate(year, month, day) || !$b96a98eff2e03a49$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $b96a98eff2e03a49$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $b96a98eff2e03a49$var$parseTime(timeString) {
    var captures = timeString.match($b96a98eff2e03a49$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $b96a98eff2e03a49$var$parseTimeUnit(captures[1]);
    var minutes = $b96a98eff2e03a49$var$parseTimeUnit(captures[2]);
    var seconds = $b96a98eff2e03a49$var$parseTimeUnit(captures[3]);
    if (!$b96a98eff2e03a49$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $b6ca4c76ce566a2f$export$7f72910d6dfd237a) + minutes * (0, $b6ca4c76ce566a2f$export$91246f0b9bd9beff) + seconds * 1000;
}
function $b96a98eff2e03a49$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $b96a98eff2e03a49$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($b96a98eff2e03a49$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$b96a98eff2e03a49$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $b6ca4c76ce566a2f$export$7f72910d6dfd237a) + minutes * (0, $b6ca4c76ce566a2f$export$91246f0b9bd9beff));
}
function $b96a98eff2e03a49$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $b96a98eff2e03a49$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b96a98eff2e03a49$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b96a98eff2e03a49$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($b96a98eff2e03a49$var$daysInMonths[month] || ($b96a98eff2e03a49$var$isLeapYearIndex(year) ? 29 : 28));
}
function $b96a98eff2e03a49$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($b96a98eff2e03a49$var$isLeapYearIndex(year) ? 366 : 365);
}
function $b96a98eff2e03a49$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $b96a98eff2e03a49$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $b96a98eff2e03a49$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}



function $0566dafe416d2341$export$2e2bcd8739ae039(argument) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(1, arguments);
    if (typeof argument === "string") {
        var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
        if (parts) // Group 8 matches the sign
        return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
        return new Date(NaN);
    }
    return (0, $623cd31f1b422257$export$2e2bcd8739ae039)(argument);
}


// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
var $25cc23eeb838e334$exports = {};
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $25cc23eeb838e334$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty($25cc23eeb838e334$exports, "__esModule", {
    value: true
});
$25cc23eeb838e334$exports.default = $25cc23eeb838e334$var$format;

var $25cc23eeb838e334$var$_index = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("hTT36")));

var $25cc23eeb838e334$var$_index2 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("g0gcS")));

var $25cc23eeb838e334$var$_index3 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("5eXBC")));

var $25cc23eeb838e334$var$_index4 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("gMy09")));

var $25cc23eeb838e334$var$_index5 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("7iyvN")));

var $25cc23eeb838e334$var$_index6 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("b4ORf")));
var $57885bbf1fe1b849$exports = {};
"use strict";
Object.defineProperty($57885bbf1fe1b849$exports, "__esModule", {
    value: true
});
$57885bbf1fe1b849$exports.isProtectedDayOfYearToken = $57885bbf1fe1b849$var$isProtectedDayOfYearToken;
$57885bbf1fe1b849$exports.isProtectedWeekYearToken = $57885bbf1fe1b849$var$isProtectedWeekYearToken;
$57885bbf1fe1b849$exports.throwProtectedError = $57885bbf1fe1b849$var$throwProtectedError;
var $57885bbf1fe1b849$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $57885bbf1fe1b849$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $57885bbf1fe1b849$var$isProtectedDayOfYearToken(token) {
    return $57885bbf1fe1b849$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $57885bbf1fe1b849$var$isProtectedWeekYearToken(token) {
    return $57885bbf1fe1b849$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $57885bbf1fe1b849$var$throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}



var $25cc23eeb838e334$var$_index8 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("khNiu")));

var $25cc23eeb838e334$var$_index9 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("ev56u")));

var $coR2I = parcelRequire("coR2I");

var $25cc23eeb838e334$var$_index11 = $25cc23eeb838e334$require$_interopRequireDefault((parcelRequire("k6Ia0")));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $25cc23eeb838e334$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $25cc23eeb838e334$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $25cc23eeb838e334$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $25cc23eeb838e334$var$doubleQuoteRegExp = /''/g;
var $25cc23eeb838e334$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $25cc23eeb838e334$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $25cc23eeb838e334$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $coR2I.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $25cc23eeb838e334$var$_index11.default;
    var firstWeekContainsDate = (0, $25cc23eeb838e334$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $25cc23eeb838e334$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $25cc23eeb838e334$var$_index3.default)(dirtyDate);
    if (!(0, $25cc23eeb838e334$var$_index.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $25cc23eeb838e334$var$_index6.default)(originalDate);
    var utcDate = (0, $25cc23eeb838e334$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($25cc23eeb838e334$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = $25cc23eeb838e334$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($25cc23eeb838e334$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $25cc23eeb838e334$var$cleanEscapedString(substring);
        var formatter = $25cc23eeb838e334$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $57885bbf1fe1b849$exports.isProtectedWeekYearToken)(substring)) (0, $57885bbf1fe1b849$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $57885bbf1fe1b849$exports.isProtectedDayOfYearToken)(substring)) (0, $57885bbf1fe1b849$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($25cc23eeb838e334$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $25cc23eeb838e334$var$cleanEscapedString(input) {
    var matched = input.match($25cc23eeb838e334$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($25cc23eeb838e334$var$doubleQuoteRegExp, "'");
}
$25cc23eeb838e334$exports = $25cc23eeb838e334$exports.default;


/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $9893684d4a52c615$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $9893684d4a52c615$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $9893684d4a52c615$var$partsTimeZone(dtf, date) : $9893684d4a52c615$var$hackyTimeZone(dtf, date);
}
function $9893684d4a52c615$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === "timeZoneName") return formatted[i].value;
    }
}
function $9893684d4a52c615$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : "";
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $9893684d4a52c615$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        "en-US"
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $7535d23336e1ed3b$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $7535d23336e1ed3b$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $7535d23336e1ed3b$var$partsOffset(dtf, date) : $7535d23336e1ed3b$var$hackyOffset(dtf, date);
}
var $7535d23336e1ed3b$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $7535d23336e1ed3b$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $7535d23336e1ed3b$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $7535d23336e1ed3b$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $7535d23336e1ed3b$var$dtfCache = {};
function $7535d23336e1ed3b$var$getDateTimeFormat(timeZone) {
    if (!$7535d23336e1ed3b$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: "America/New_York",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $7535d23336e1ed3b$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return $7535d23336e1ed3b$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $68e142884de1fb1d$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


var $9f8cb249de9f6f43$var$MILLISECONDS_IN_HOUR = 3600000;
var $9f8cb249de9f6f43$var$MILLISECONDS_IN_MINUTE = 60000;
var $9f8cb249de9f6f43$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $9f8cb249de9f6f43$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $9f8cb249de9f6f43$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $9f8cb249de9f6f43$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$9f8cb249de9f6f43$var$validateTimezone(hours)) return NaN;
        return -(hours * $9f8cb249de9f6f43$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $9f8cb249de9f6f43$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$9f8cb249de9f6f43$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $9f8cb249de9f6f43$var$MILLISECONDS_IN_HOUR + minutes * $9f8cb249de9f6f43$var$MILLISECONDS_IN_MINUTE;
        return token[1] === "+" ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($9f8cb249de9f6f43$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $9f8cb249de9f6f43$var$toUtcDate(date);
        var offset = $9f8cb249de9f6f43$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $9f8cb249de9f6f43$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $9f8cb249de9f6f43$var$toUtcDate(date) {
    return (0, $68e142884de1fb1d$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $9f8cb249de9f6f43$var$calcOffset(date, timezoneString) {
    var tokens = (0, $7535d23336e1ed3b$export$2e2bcd8739ae039)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $68e142884de1fb1d$export$2e2bcd8739ae039)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $9f8cb249de9f6f43$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $9f8cb249de9f6f43$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $9f8cb249de9f6f43$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $9f8cb249de9f6f43$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $9f8cb249de9f6f43$var$validIANATimezoneCache = {};
function $9f8cb249de9f6f43$var$isValidTimezoneIANAString(timeZoneString) {
    if ($9f8cb249de9f6f43$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $9f8cb249de9f6f43$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


var $4971486321fe3617$var$MILLISECONDS_IN_MINUTE = 60000;
var $4971486321fe3617$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $4971486321fe3617$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4971486321fe3617$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $4971486321fe3617$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4971486321fe3617$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $4971486321fe3617$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4971486321fe3617$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $4971486321fe3617$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4971486321fe3617$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $4971486321fe3617$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4971486321fe3617$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4971486321fe3617$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return (0, $9893684d4a52c615$export$2e2bcd8739ae039)("short", date, options);
            // Long
            case "zzzz":
            default:
                return (0, $9893684d4a52c615$export$2e2bcd8739ae039)("long", date, options);
        }
    }
};
function $4971486321fe3617$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $9f8cb249de9f6f43$export$2e2bcd8739ae039)(timeZone, originalDate, true) / $4971486321fe3617$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError("Invalid time zone specified: " + timeZone);
    return timeZoneOffset;
}
function $4971486321fe3617$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
function $4971486321fe3617$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = $4971486321fe3617$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $4971486321fe3617$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $4971486321fe3617$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + $4971486321fe3617$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $4971486321fe3617$var$formatTimezone(offset, dirtyDelimeter);
}
function $4971486321fe3617$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + $4971486321fe3617$var$addLeadingZeros(minutes, 2);
}
var $4971486321fe3617$export$2e2bcd8739ae039 = $4971486321fe3617$var$formatters;



var $khNiu = parcelRequire("khNiu");

var $b4ORf = parcelRequire("b4ORf");

/** Regex to identify the presence of a time zone specifier in a date string */ var $1b0afc0a6d66776c$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $1b0afc0a6d66776c$export$2e2bcd8739ae039 = $1b0afc0a6d66776c$var$tzPattern;


var $602739ebc1f09f9e$var$MILLISECONDS_IN_HOUR = 3600000;
var $602739ebc1f09f9e$var$MILLISECONDS_IN_MINUTE = 60000;
var $602739ebc1f09f9e$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $602739ebc1f09f9e$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $1b0afc0a6d66776c$export$2e2bcd8739ae039)
};
function $602739ebc1f09f9e$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $602739ebc1f09f9e$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($khNiu)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") return new Date(argument);
    else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $602739ebc1f09f9e$var$splitDateString(argument);
    var parseYearResult = $602739ebc1f09f9e$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $602739ebc1f09f9e$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $602739ebc1f09f9e$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $9f8cb249de9f6f43$export$2e2bcd8739ae039)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($b4ORf)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($b4ORf)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $602739ebc1f09f9e$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $602739ebc1f09f9e$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $602739ebc1f09f9e$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $602739ebc1f09f9e$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $602739ebc1f09f9e$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $602739ebc1f09f9e$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $602739ebc1f09f9e$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $602739ebc1f09f9e$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $602739ebc1f09f9e$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $602739ebc1f09f9e$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $602739ebc1f09f9e$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$602739ebc1f09f9e$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $602739ebc1f09f9e$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$602739ebc1f09f9e$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $602739ebc1f09f9e$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$602739ebc1f09f9e$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $602739ebc1f09f9e$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$602739ebc1f09f9e$var$validateWeekDate(year, week)) return new Date(NaN);
        return $602739ebc1f09f9e$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $602739ebc1f09f9e$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$602739ebc1f09f9e$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $602739ebc1f09f9e$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $602739ebc1f09f9e$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $602739ebc1f09f9e$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!$602739ebc1f09f9e$var$validateTime(hours)) return NaN;
        return hours % 24 * $602739ebc1f09f9e$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $602739ebc1f09f9e$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!$602739ebc1f09f9e$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $602739ebc1f09f9e$var$MILLISECONDS_IN_HOUR + minutes * $602739ebc1f09f9e$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $602739ebc1f09f9e$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!$602739ebc1f09f9e$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $602739ebc1f09f9e$var$MILLISECONDS_IN_HOUR + minutes * $602739ebc1f09f9e$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $602739ebc1f09f9e$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $602739ebc1f09f9e$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $602739ebc1f09f9e$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $602739ebc1f09f9e$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $602739ebc1f09f9e$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $602739ebc1f09f9e$var$isLeapYearIndex(year);
        if (isLeapYear && date > $602739ebc1f09f9e$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $602739ebc1f09f9e$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $602739ebc1f09f9e$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $602739ebc1f09f9e$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $602739ebc1f09f9e$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $602739ebc1f09f9e$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


var $2e4659035f49ffc0$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $2e4659035f49ffc0$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($2e4659035f49ffc0$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $602739ebc1f09f9e$export$2e2bcd8739ae039)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $4971486321fe3617$export$2e2bcd8739ae039)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($25cc23eeb838e334$exports)))(dirtyDate, formatStr, options);
}






var $cc6be247bea160b9$exports = {};
"use strict";

var $gDgMD = parcelRequire("gDgMD");
var $cc6be247bea160b9$require$_interopRequireDefault = $gDgMD.default;
Object.defineProperty($cc6be247bea160b9$exports, "__esModule", {
    value: true
});
$cc6be247bea160b9$exports.default = $cc6be247bea160b9$var$cloneObject;

var $cc6be247bea160b9$var$_index = $cc6be247bea160b9$require$_interopRequireDefault((parcelRequire("ewWTB")));
function $cc6be247bea160b9$var$cloneObject(object) {
    return (0, $cc6be247bea160b9$var$_index.default)({}, object);
}
$cc6be247bea160b9$exports = $cc6be247bea160b9$exports.default;






function $d054c02382423b6c$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === "string" && !date.match((0, $1b0afc0a6d66776c$export$2e2bcd8739ae039))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($cc6be247bea160b9$exports)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $602739ebc1f09f9e$export$2e2bcd8739ae039)(date, extendedOptions);
    }
    var d = (0, $602739ebc1f09f9e$export$2e2bcd8739ae039)(date, options);
    var utc = (0, $68e142884de1fb1d$export$2e2bcd8739ae039)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $9f8cb249de9f6f43$export$2e2bcd8739ae039)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}





const $0dcae3260236e0d2$export$130c2d9632f0fc1d = (d1, d2)=>(0, $f778754b137edf54$export$2e2bcd8739ae039)((0, $b96a98eff2e03a49$export$2e2bcd8739ae039)(d1), (0, $b96a98eff2e03a49$export$2e2bcd8739ae039)(d2));
const $0dcae3260236e0d2$export$440e2e4cd4ac8a22 = (dateString)=>dateString.replace("Z", "");
const $0dcae3260236e0d2$export$9cc585672c9cb4ef = (dateString)=>{
    if (dateString === null || dateString === undefined) return "";
    return $0dcae3260236e0d2$export$440e2e4cd4ac8a22(new Date(dateString).toISOString());
};
const $0dcae3260236e0d2$export$11aaca13b5be2907 = ()=>new Date().toLocaleTimeString(undefined, {
        timeZoneName: "short"
    }).split(" ")[2];
function $0dcae3260236e0d2$export$1d9850e26a13908a(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $b96a98eff2e03a49$export$2e2bcd8739ae039)(dateString), "M/d/yy");
}
function $0dcae3260236e0d2$export$ef8314cde2aa2eb2(dateString) {
    if (dateString === null || dateString === undefined) return null;
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "yyyy-MM-dd");
}
function $0dcae3260236e0d2$export$709bb038489fb0(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "yyyy-MM-dd h:mma zzz");
}
function $0dcae3260236e0d2$export$3573c25f30e0099d(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "yyyy-MM-dd'T'HH:mm:ss");
}
const $0dcae3260236e0d2$var$formatRelativeLocale = {
    lastWeek: "'Last' eeee",
    yesterday: "'Yesterday'",
    today: "'Today'",
    tomorrow: "'Tomorrow'",
    nextWeek: "'Next' eeee",
    other: "dd.MM.yyyy"
};
const $0dcae3260236e0d2$var$locale = {
    ...(0, $b29686030002c990$export$2e2bcd8739ae039),
    formatRelative: (token)=>$0dcae3260236e0d2$var$formatRelativeLocale[token]
};
function $0dcae3260236e0d2$export$a4b1ac1b7ff01dbc(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $827d644bb829cda7$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), new Date(), {
        locale: $0dcae3260236e0d2$var$locale
    });
}
function $0dcae3260236e0d2$export$328aec9e3e2287e0(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $827d644bb829cda7$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), new Date());
}
function $0dcae3260236e0d2$export$d207855dff529fc9(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "M/d/yyyy h:mm a zzz");
}
function $0dcae3260236e0d2$export$d7bfe45c43ac0f65(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "M/d/yyyy HH:mma");
}
function $0dcae3260236e0d2$export$d66c499300451a3b(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "h:mma zzz M/d/yy");
}
function $0dcae3260236e0d2$export$de04ca861cf68a2e(dateString) {
    if (dateString === null || dateString === undefined) return "";
    return (0, $2e4659035f49ffc0$export$2e2bcd8739ae039)((0, $0566dafe416d2341$export$2e2bcd8739ae039)(dateString), "h:mma");
}


function $29ca84b747c9e87f$export$4b2997e216293ac3() {
    const { data: patientComments, mutate: patientCommentsMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patient_comments", "", {
        refreshInterval: 250,
        refreshWhenHidden: true
    });
    const [uniqueNames, setUniqueNames] = (0, $f2Y41.useState)([]);
    (0, $f2Y41.useEffect)(()=>{
        setUniqueNames([
            ...new Map(patientComments.map((comment)=>[
                    comment["created_by_user_id"],
                    comment
                ])).values()
        ]);
    }, [
        patientComments
    ]);
    const commentPatientText = (comment)=>{
        if (comment.patient?.given_name && comment.patient?.family_name) return `${comment.patient?.given_name} ${comment.patient?.family_name}`;
        else return `MRN: ${comment.patient?.mrn}`;
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "mt-10 p-6 rounded-lg border border-gray-200 shadow-md",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("h5", {
                className: "text-2xl font-bold tracking-tight flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                        icon: "SpeakerphoneIcon",
                        className: "h-5 mr-2 self-center"
                    }),
                    "Comments"
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "px-7 mt-2",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "text-2xl font-semibold leading-none"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex flex-col items-start justify-center mb-5 space",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex flex-row flex-wrap",
                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-center justify-start",
                                children: [
                                    uniqueNames.reverse().map((comment)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "-mr-2",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                content: comment?.created_by?.name,
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a0b772244d08cba$export$e2255cf6045e8d47), {
                                                    name: comment?.created_by?.name,
                                                    className: "border-2 border-white rounded-full h-7 w-7 dark:border-gray-800"
                                                })
                                            })
                                        })),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-sm text-gray-500 dark:text-gray-400 ml-4",
                                        children: patientComments[0] && /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                            children: [
                                                "Last comment by",
                                                " ",
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                    className: "font-medium text-green-700 no-underline cursor-pointer hover:underline dark:text-green-500",
                                                    children: patientComments[0]?.created_by?.name
                                                }),
                                                " ",
                                                "at",
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                    title: patientComments[0]?.created_at,
                                                    children: [
                                                        " ",
                                                        (0, $0dcae3260236e0d2$export$d66c499300451a3b)(patientComments[0]?.created_at),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    patientComments.map((comment)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex flex-col space-y-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-center space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a0b772244d08cba$export$e2255cf6045e8d47), {
                                            name: comment.created_by?.name,
                                            className: "border-2 border-white rounded-full h-7 w-7 dark:border-gray-800"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex-1 min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                                    className: "text-sm font-semibold text-gray-900 truncate dark:text-white",
                                                    children: [
                                                        comment.created_by?.name,
                                                        " commented on ",
                                                        commentPatientText(comment)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                    title: comment.created_at,
                                                    className: "text-xs text-gray-500 truncate dark:text-gray-400",
                                                    children: (0, $0dcae3260236e0d2$export$d66c499300451a3b)(comment.created_at)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("ul", {
                                    className: "pl-10 text-sm text-gray-900 list-outside dark:text-gray-400",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                        children: comment.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                    className: "ml-10 ",
                                    to: `/patients/${comment.patient_id}`,
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                        className: "mr-4 inline-flex items-center justify-center h-6 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-1 focus:ring-green-900 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800",
                                        children: [
                                            "View Patient",
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "ChevronRightIcon",
                                                className: "h5 w-5 text-blue-100"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }))
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $aT86D = parcelRequire("aT86D");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");
/* eslint-disable */ const $4e7f2b38220c2171$var$_keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $4e7f2b38220c2171$var$utf8Encode(str) {
    for(let n = 0; n < str.length; n++){
        const c = str.charCodeAt(n);
        if (c >= 128) throw new Error("ASCII only support");
    }
    return str;
}
const $4e7f2b38220c2171$export$c62426fdd000a97e = (input)=>{
    let output = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while(i < input.length){
        enc1 = $4e7f2b38220c2171$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $4e7f2b38220c2171$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $4e7f2b38220c2171$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $4e7f2b38220c2171$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) output = output + String.fromCharCode(chr2);
        if (enc4 != 64) output = output + String.fromCharCode(chr3);
    }
    return output;
};
const $4e7f2b38220c2171$export$e510a73ee562749 = (input)=>{
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = $4e7f2b38220c2171$var$utf8Encode(input);
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output = output + $4e7f2b38220c2171$var$_keyStr.charAt(enc1) + $4e7f2b38220c2171$var$_keyStr.charAt(enc2) + $4e7f2b38220c2171$var$_keyStr.charAt(enc3) + $4e7f2b38220c2171$var$_keyStr.charAt(enc4);
    }
    return output;
};


/* eslint-disable */ // See "precomputation" in notes
const $d8555398df39e710$var$k = [];
let $d8555398df39e710$var$i = 0;
for(; $d8555398df39e710$var$i < 64;)$d8555398df39e710$var$k[$d8555398df39e710$var$i] = 0 | Math.sin(++$d8555398df39e710$var$i % Math.PI) * 4294967296;
function $d8555398df39e710$export$a58ec6a60c09ca72(s) {
    const words = [];
    let b, c, d, j = unescape(encodeURI(s)) + "\x80", a = j.length;
    const h = [
        b = 0x67452301,
        c = 0xefcdab89,
        ~b,
        ~c
    ];
    s = --a / 4 + 2 | 15;
    // See "Length bits" in notes
    words[--s] = a * 8;
    for(; ~a;)// a !== -1
    words[a >> 2] |= j.charCodeAt(a) << 8 * a--;
    for($d8555398df39e710$var$i = j = 0; $d8555398df39e710$var$i < s; $d8555398df39e710$var$i += 16){
        a = h;
        for(; j < 64; a = [
            d = a[3],
            b + ((d = a[0] + [
                b & c | ~b & d,
                d & b | ~d & c,
                b ^ c ^ d,
                c ^ (b | ~d)
            ][a = j >> 4] + $d8555398df39e710$var$k[j] + ~~words[$d8555398df39e710$var$i | [
                j,
                5 * j + 1,
                3 * j + 5,
                7 * j
            ][a] & 15]) << (a = [
                7,
                12,
                17,
                22,
                5,
                9,
                14,
                20,
                4,
                11,
                16,
                23,
                6,
                10,
                15,
                21
            ][4 * a + j++ % 4]) | d >>> -a),
            b,
            c
        ]){
            b = a[1] | 0;
            c = a[2];
        }
        // See "Integer safety" in notes
        for(j = 4; j;)h[--j] += a[j];
    // j === 0
    }
    for(s = ""; j < 32;)s += (h[j >> 3] >> (1 ^ j++) * 4 & 15).toString(16);
    return s;
}


// eslint-disable-next-line @typescript-eslint/naming-convention
let $e5595203f547d249$export$4d5a447ae2d3c7bc = /*#__PURE__*/ function(LICENSE_STATUS) {
    LICENSE_STATUS["NotFound"] = "NotFound";
    LICENSE_STATUS["Invalid"] = "Invalid";
    LICENSE_STATUS["ExpiredAnnual"] = "ExpiredAnnual";
    LICENSE_STATUS["ExpiredAnnualGrace"] = "ExpiredAnnualGrace";
    LICENSE_STATUS["ExpiredVersion"] = "ExpiredVersion";
    LICENSE_STATUS["Valid"] = "Valid";
    LICENSE_STATUS["OutOfScope"] = "OutOfScope";
    return LICENSE_STATUS;
}({});


const $a80a967188cde76c$export$57aff84a372c3edc = [
    "pro",
    "premium"
];


const $c1b2d5b397c786ea$export$328a1b19c1ed31de = [
    /**
 * A license is outdated if the current version of the software was released after the expiry date of the license.
 * But the license can be used indefinitely with an older version of the software.
 */ "perpetual",
    /**
 * On development, a license is outdated if the expiry date has been reached
 * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
 */ "annual",
    /**
 * TODO 2025 remove, legacy name of annual.
 */ "subscription"
];


const $8202d0b9de3f3ebd$var$getDefaultReleaseDate = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
function $8202d0b9de3f3ebd$export$4c9b7f7dacd07671(releaseDate = $8202d0b9de3f3ebd$var$getDefaultReleaseDate()) {
    return (0, $4e7f2b38220c2171$export$e510a73ee562749)(releaseDate.getTime().toString());
}
const $8202d0b9de3f3ebd$var$expiryReg = /^.*EXPIRY=([0-9]+),.*$/;
/**
 * Format: ORDER:${orderNumber},EXPIRY=${expiryTimestamp},KEYVERSION=1
 */ const $8202d0b9de3f3ebd$var$decodeLicenseVersion1 = (license)=>{
    let expiryTimestamp;
    try {
        expiryTimestamp = parseInt(license.match($8202d0b9de3f3ebd$var$expiryReg)[1], 10);
        if (!expiryTimestamp || Number.isNaN(expiryTimestamp)) expiryTimestamp = null;
    } catch (err) {
        expiryTimestamp = null;
    }
    return {
        scope: "pro",
        licensingModel: "perpetual",
        expiryTimestamp: expiryTimestamp
    };
};
/**
 * Format: O=${orderNumber},E=${expiryTimestamp},S=${scope},LM=${licensingModel},KV=2`;
 */ const $8202d0b9de3f3ebd$var$decodeLicenseVersion2 = (license)=>{
    const licenseInfo = {
        scope: null,
        licensingModel: null,
        expiryTimestamp: null
    };
    license.split(",").map((token)=>token.split("=")).filter((el)=>el.length === 2).forEach(([key, value])=>{
        if (key === "S") licenseInfo.scope = value;
        if (key === "LM") licenseInfo.licensingModel = value;
        if (key === "E") {
            const expiryTimestamp = parseInt(value, 10);
            if (expiryTimestamp && !Number.isNaN(expiryTimestamp)) licenseInfo.expiryTimestamp = expiryTimestamp;
        }
    });
    return licenseInfo;
};
/**
 * Decode the license based on its key version and return a version-agnostic `MuiLicense` object.
 */ const $8202d0b9de3f3ebd$var$decodeLicense = (encodedLicense)=>{
    const license = (0, $4e7f2b38220c2171$export$c62426fdd000a97e)(encodedLicense);
    if (license.includes("KEYVERSION=1")) return $8202d0b9de3f3ebd$var$decodeLicenseVersion1(license);
    if (license.includes("KV=2")) return $8202d0b9de3f3ebd$var$decodeLicenseVersion2(license);
    return null;
};
function $8202d0b9de3f3ebd$export$65cf4e2e0f5c4c60({ releaseInfo: releaseInfo, licenseKey: licenseKey, acceptedScopes: acceptedScopes }) {
    if (!releaseInfo) throw new Error("MUI X: The release information is missing. Not able to validate license.");
    if (!licenseKey) return {
        status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).NotFound
    };
    const hash = licenseKey.substr(0, 32);
    const encoded = licenseKey.substr(32);
    if (hash !== (0, $d8555398df39e710$export$a58ec6a60c09ca72)(encoded)) return {
        status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid
    };
    const license = $8202d0b9de3f3ebd$var$decodeLicense(encoded);
    if (license == null) {
        console.error("MUI X: Error checking license. Key version not found!");
        return {
            status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.licensingModel == null || !(0, $c1b2d5b397c786ea$export$328a1b19c1ed31de).includes(license.licensingModel)) {
        console.error("MUI X: Error checking license. Licensing model not found or invalid!");
        return {
            status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.expiryTimestamp == null) {
        console.error("MUI X: Error checking license. Expiry timestamp not found or invalid!");
        return {
            status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    license.licensingModel;
    {
        const pkgTimestamp = parseInt((0, $4e7f2b38220c2171$export$c62426fdd000a97e)(releaseInfo), 10);
        if (Number.isNaN(pkgTimestamp)) throw new Error("MUI X: The release information is invalid. Not able to validate license.");
        if (license.expiryTimestamp < pkgTimestamp) return {
            status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredVersion
        };
    }
    if (license.scope == null || !(0, $a80a967188cde76c$export$57aff84a372c3edc).includes(license.scope)) {
        console.error("Error checking license. scope not found or invalid!");
        return {
            status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (!acceptedScopes.includes(license.scope)) return {
        status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).OutOfScope
    };
    return {
        status: (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Valid
    };
}



function $127b23f6ace9e748$var$showError(message) {
    console.error([
        "*************************************************************",
        "",
        ...message,
        "",
        "*************************************************************"
    ].join("\n"));
}
function $127b23f6ace9e748$export$e03bc902b0abb5bd() {
    $127b23f6ace9e748$var$showError([
        "MUI X: Invalid license key.",
        "",
        "Your MUI X license key format isn't valid. It could be because the license key is missing a character or has a typo.",
        "",
        "To solve the issue, you need to double check that `setLicenseKey()` is called with the right argument",
        "Please check the license key installation https://mui.com/r/x-license-key-installation."
    ]);
}
function $127b23f6ace9e748$export$d0a8365d54384f87() {
    $127b23f6ace9e748$var$showError([
        "MUI X: License key plan mismatch.",
        "",
        "Your use of MUI X is not compatible with the plan of your license key. The feature you are trying to use is not included in the plan of your license key. This happens if you try to use `DataGridPremium` with a license key for the Pro plan.",
        "",
        "To solve the issue, you can upgrade your plan from Pro to Premium at https://mui.com/r/x-get-license?scope=premium.",
        "Of if you didn't intend to use Premium features, you can replace the import of `@mui/x-data-grid-premium` with `@mui/x-data-grid-pro`."
    ]);
}
function $127b23f6ace9e748$export$bfbf7dff305ffa2a({ plan: plan, packageName: packageName }) {
    $127b23f6ace9e748$var$showError([
        "MUI X: Missing license key.",
        "",
        `The license key is missing. You might not be allowed to use \`${packageName}\` which is part of MUI X ${plan}.`,
        "",
        "To solve the issue, you can check the free trial conditions: https://mui.com/r/x-license-trial.",
        "If you are eligible no actions are required. If you are not eligible to the free trial, you need to purchase a license https://mui.com/r/x-get-license or stop using the software immediately."
    ]);
}
function $127b23f6ace9e748$export$242a1b9acf4255b9({ packageName: packageName }) {
    $127b23f6ace9e748$var$showError([
        "MUI X: Expired package version.",
        "",
        `You have installed a version of \`${packageName}\` that is outside of the maintenance plan of your license key. By default, commercial licenses provide access to new versions released during the first year after the purchase.`,
        "",
        "To solve the issue, you can renew your license https://mui.com/r/x-get-license or install an older version of the npm package that is compatible with your license key."
    ]);
}
function $127b23f6ace9e748$export$1ba1f66631f7b541({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    $127b23f6ace9e748$var$showError([
        "MUI X: Expired license key.",
        "",
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        "",
        "To solve the problem you can either:",
        "",
        "- Renew your license https://mui.com/r/x-get-license and use the new key",
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        "",
        "Note that your license is perpetual in production environments with any version released before your license term ends.",
        "",
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ""
    ]);
}
function $127b23f6ace9e748$export$89cdc76bbf22084e({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    throw new Error([
        "MUI X: Expired license key.",
        "",
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        "",
        "To solve the problem you can either:",
        "",
        "- Renew your license https://mui.com/r/x-get-license and use the new key",
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        "",
        "Note that your license is perpetual in production environments with any version released before your license term ends.",
        "",
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ""
    ].join("\n"));
}




var $f2Y41 = parcelRequire("f2Y41");
const $d407891717e349ab$var$MuiLicenseInfoContext = /*#__PURE__*/ $f2Y41.createContext({
    key: undefined
});
var $d407891717e349ab$export$2e2bcd8739ae039 = $d407891717e349ab$var$MuiLicenseInfoContext;


const $833e87c557c1a10f$export$dc1f6c076f2a5d88 = {};
function $833e87c557c1a10f$export$bd780281ba7bfd9(packageName, releaseInfo) {
    const { key: contextKey } = $f2Y41.useContext((0, $d407891717e349ab$export$2e2bcd8739ae039));
    return $f2Y41.useMemo(()=>{
        const licenseKey = contextKey ?? (0, $8173e232d95b4d5b$export$2c56d2e2ae515eeb).getLicenseKey();
        // Cache the response to not trigger the error twice.
        if ($833e87c557c1a10f$export$dc1f6c076f2a5d88[packageName] && $833e87c557c1a10f$export$dc1f6c076f2a5d88[packageName].key === licenseKey) return $833e87c557c1a10f$export$dc1f6c076f2a5d88[packageName].licenseVerifier;
        const acceptedScopes = packageName.includes("premium") ? [
            "premium"
        ] : [
            "pro",
            "premium"
        ];
        const plan = packageName.includes("premium") ? "Premium" : "Pro";
        const licenseStatus = (0, $8202d0b9de3f3ebd$export$65cf4e2e0f5c4c60)({
            releaseInfo: releaseInfo,
            licenseKey: licenseKey,
            acceptedScopes: acceptedScopes
        });
        const fullPackageName = `@mui/${packageName}`;
        if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Valid) ;
        else if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid) (0, $127b23f6ace9e748$export$e03bc902b0abb5bd)();
        else if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).OutOfScope) (0, $127b23f6ace9e748$export$d0a8365d54384f87)();
        else if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).NotFound) (0, $127b23f6ace9e748$export$bfbf7dff305ffa2a)({
            plan: plan,
            packageName: fullPackageName
        });
        else if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace) (0, $127b23f6ace9e748$export$1ba1f66631f7b541)((0, $asN9r.default)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredAnnual) (0, $127b23f6ace9e748$export$89cdc76bbf22084e)((0, $asN9r.default)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredVersion) (0, $127b23f6ace9e748$export$242a1b9acf4255b9)({
            packageName: fullPackageName
        });
        $833e87c557c1a10f$export$dc1f6c076f2a5d88[packageName] = {
            key: licenseKey,
            licenseVerifier: licenseStatus
        };
        return licenseStatus;
    }, [
        packageName,
        releaseInfo,
        contextKey
    ]);
}

parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
function $dac79d818b84db2a$var$getLicenseErrorMessage(licenseStatus) {
    switch(licenseStatus){
        case (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace:
        case (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredAnnual:
            return "MUI X Expired license key";
        case (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).ExpiredVersion:
            return "MUI X Expired package version";
        case (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Invalid:
            return "MUI X Invalid license key";
        case (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).OutOfScope:
            return "MUI X License key plan mismatch";
        case (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).NotFound:
            return "MUI X Missing license key";
        default:
            throw new Error("Unhandled MUI X license status.");
    }
}
function $dac79d818b84db2a$export$e94943a72132ebdf(props) {
    const { packageName: packageName, releaseInfo: releaseInfo } = props;
    const licenseStatus = (0, $833e87c557c1a10f$export$bd780281ba7bfd9)(packageName, releaseInfo);
    if (licenseStatus.status === (0, $e5595203f547d249$export$4d5a447ae2d3c7bc).Valid) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        style: {
            position: "absolute",
            pointerEvents: "none",
            color: "#8282829e",
            zIndex: 100000,
            width: "100%",
            textAlign: "center",
            bottom: "50%",
            right: 0,
            letterSpacing: 5,
            fontSize: 24
        },
        children: $dac79d818b84db2a$var$getLicenseErrorMessage(licenseStatus.status)
    });
}



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $5TVeh = parcelRequire("5TVeh");

var $cAicU = parcelRequire("cAicU");



var $hjRti = parcelRequire("hjRti");

var $iKUML = parcelRequire("iKUML");
const $9fbf223b1fba2160$var$_excluded = [
    "ownerState"
], $9fbf223b1fba2160$var$_excluded2 = [
    "variants"
], $9fbf223b1fba2160$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $9fbf223b1fba2160$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9fbf223b1fba2160$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9fbf223b1fba2160$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $9fbf223b1fba2160$export$35e57303dbd8a66 = (0, $hjRti.default)();
const $9fbf223b1fba2160$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $9fbf223b1fba2160$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $9fbf223b1fba2160$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $9fbf223b1fba2160$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $9fbf223b1fba2160$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $bKcdJ.default)(_ref, $9fbf223b1fba2160$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $asN9r.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$9fbf223b1fba2160$var$processStyleArg(resolvedStyle, (0, $asN9r.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $bKcdJ.default)(resolvedStylesArg, $9fbf223b1fba2160$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $asN9r.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $asN9r.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $9fbf223b1fba2160$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9fbf223b1fba2160$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9fbf223b1fba2160$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9fbf223b1fba2160$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $iKUML.default)((0, $asN9r.default)({}, props, {
            theme: $9fbf223b1fba2160$var$resolveTheme((0, $asN9r.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5TVeh.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9fbf223b1fba2160$var$defaultOverridesResolver($9fbf223b1fba2160$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $bKcdJ.default)(inputOptions, $9fbf223b1fba2160$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $9fbf223b1fba2160$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9fbf223b1fba2160$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5TVeh.default)(tag, (0, $asN9r.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $cAicU.isPlainObject)(stylesArg)) return (props)=>$9fbf223b1fba2160$var$processStyleArg(stylesArg, (0, $asN9r.default)({}, props, {
                    theme: $9fbf223b1fba2160$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $9fbf223b1fba2160$var$resolveTheme((0, $asN9r.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $9fbf223b1fba2160$var$processStyleArg(slotStyle, (0, $asN9r.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $9fbf223b1fba2160$var$resolveTheme((0, $asN9r.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $9fbf223b1fba2160$var$processStyleArg({
                    variants: themeVariants
                }, (0, $asN9r.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $90ca805a8f1be5a9$var$styled = (0, $9fbf223b1fba2160$export$2e2bcd8739ae039)();
var $90ca805a8f1be5a9$export$2e2bcd8739ae039 = $90ca805a8f1be5a9$var$styled;


function $8919b282e93103e3$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

function $24a8e0c05af27d75$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $24a8e0c05af27d75$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $24a8e0c05af27d75$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $24a8e0c05af27d75$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $24a8e0c05af27d75$export$2e2bcd8739ae039 = $24a8e0c05af27d75$export$4f5d2d50c9deca37;



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $3b6584a40cdd4f24$var$useEnhancedEffect = typeof window !== "undefined" ? $f2Y41.useLayoutEffect : $f2Y41.useEffect;
var $3b6584a40cdd4f24$export$2e2bcd8739ae039 = $3b6584a40cdd4f24$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b8da6eb696d47660$var$useEventCallback(fn) {
    const ref = $f2Y41.useRef(fn);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $f2Y41.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b8da6eb696d47660$export$2e2bcd8739ae039 = $b8da6eb696d47660$var$useEventCallback;




var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
const $144bec24a50df06b$export$e00c5fe7e13db7ba = /*#__PURE__*/ $f2Y41.createContext(undefined);


const $cf36a17b199a9f82$export$8b0f8e71b71b7ed3 = ()=>{
    const contextValue = $f2Y41.useContext((0, $144bec24a50df06b$export$e00c5fe7e13db7ba));
    if (!contextValue) throw new Error("MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
    return contextValue;
};


const $2623c775f29c0462$var$defaultGenerator = (componentName)=>componentName;
const $2623c775f29c0462$var$createClassNameGenerator = ()=>{
    let generate = $2623c775f29c0462$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $2623c775f29c0462$var$defaultGenerator;
        }
    };
};
const $2623c775f29c0462$var$ClassNameGenerator = $2623c775f29c0462$var$createClassNameGenerator();
var $2623c775f29c0462$export$2e2bcd8739ae039 = $2623c775f29c0462$var$ClassNameGenerator;


const $bd62ffdd337a5f37$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $bd62ffdd337a5f37$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $bd62ffdd337a5f37$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $2623c775f29c0462$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $bd62ffdd337a5f37$export$34c0130b1f3e8ae3(slot) {
    return $bd62ffdd337a5f37$export$9d6b9120de57c54[slot] !== undefined;
}


function $66a5d15e460293e4$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $2276c81b0f2e6e46$export$a2aa36217b862c23(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiDataGrid", slot);
}
const $2276c81b0f2e6e46$export$2100d54e36406477 = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiDataGrid", [
    "actionsCell",
    "aggregationColumnHeader",
    "aggregationColumnHeader--alignLeft",
    "aggregationColumnHeader--alignCenter",
    "aggregationColumnHeader--alignRight",
    "aggregationColumnHeaderLabel",
    "autoHeight",
    "autosizing",
    "booleanCell",
    "cell--editable",
    "cell--editing",
    "cell--flex",
    "cell--textCenter",
    "cell--textLeft",
    "cell--textRight",
    "cell--rangeTop",
    "cell--rangeBottom",
    "cell--rangeLeft",
    "cell--rangeRight",
    "cell--pinnedLeft",
    "cell--pinnedRight",
    "cell--selectionMode",
    "cell",
    "cellCheckbox",
    "cellEmpty",
    "cellSkeleton",
    "cellOffsetLeft",
    "checkboxInput",
    "columnHeader",
    "columnHeader--alignCenter",
    "columnHeader--alignLeft",
    "columnHeader--alignRight",
    "columnHeader--dragging",
    "columnHeader--moving",
    "columnHeader--numeric",
    "columnHeader--sortable",
    "columnHeader--sorted",
    "columnHeader--filtered",
    "columnHeader--pinnedLeft",
    "columnHeader--pinnedRight",
    "columnHeader--last",
    "columnHeaderCheckbox",
    "columnHeaderDraggableContainer",
    "columnHeaderTitle",
    "columnHeaderTitleContainer",
    "columnHeaderTitleContainerContent",
    "columnHeader--filledGroup",
    "columnHeader--emptyGroup",
    "columnHeaders",
    "columnSeparator--resizable",
    "columnSeparator--resizing",
    "columnSeparator--sideLeft",
    "columnSeparator--sideRight",
    "columnSeparator",
    "columnsManagement",
    "columnsManagementRow",
    "columnsManagementHeader",
    "columnsManagementFooter",
    "container--top",
    "container--bottom",
    "detailPanel",
    "detailPanels",
    "detailPanelToggleCell",
    "detailPanelToggleCell--expanded",
    "footerCell",
    "panel",
    "panelHeader",
    "panelWrapper",
    "panelContent",
    "panelFooter",
    "paper",
    "editBooleanCell",
    "editInputCell",
    "filler",
    "filler--borderTop",
    "filler--pinnedLeft",
    "filler--pinnedRight",
    "filterForm",
    "filterFormDeleteIcon",
    "filterFormLogicOperatorInput",
    "filterFormColumnInput",
    "filterFormOperatorInput",
    "filterFormValueInput",
    "filterIcon",
    "footerContainer",
    "headerFilterRow",
    "iconButtonContainer",
    "iconSeparator",
    "main",
    "main--hasPinnedRight",
    "menu",
    "menuIcon",
    "menuIconButton",
    "menuOpen",
    "menuList",
    "overlay",
    "overlayWrapper",
    "overlayWrapperInner",
    "root",
    "root--densityStandard",
    "root--densityComfortable",
    "root--densityCompact",
    "root--disableUserSelection",
    "row",
    "row--editable",
    "row--editing",
    "row--firstVisible",
    "row--lastVisible",
    "row--dragging",
    "row--dynamicHeight",
    "row--detailPanelExpanded",
    "rowReorderCellPlaceholder",
    "rowCount",
    "rowReorderCellContainer",
    "rowReorderCell",
    "rowReorderCell--draggable",
    "scrollArea--left",
    "scrollArea--right",
    "scrollArea",
    "scrollbar",
    "scrollbar--vertical",
    "scrollbar--horizontal",
    "scrollbarFiller",
    "scrollbarFiller--header",
    "scrollbarFiller--borderTop",
    "scrollbarFiller--pinnedRight",
    "selectedRowCount",
    "sortIcon",
    "toolbarContainer",
    "toolbarFilterList",
    "virtualScroller",
    "virtualScrollerContent",
    "virtualScrollerContent--overflowed",
    "virtualScrollerRenderZone",
    "pinnedColumns",
    "withVerticalBorder",
    "withBorderColor",
    "cell--withRightBorder",
    "cell--withLeftBorder",
    "columnHeader--withRightBorder",
    "columnHeader--withLeftBorder",
    "treeDataGroupingCell",
    "treeDataGroupingCellToggle",
    "groupingCriteriaCell",
    "groupingCriteriaCellToggle",
    "pinnedRows",
    "pinnedRows--top",
    "pinnedRows--bottom",
    "pinnedRowsRenderZone"
]);



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
const $a4832b93f7e3ab58$export$70c437c2dab15e52 = /*#__PURE__*/ $f2Y41.createContext(undefined);


function $33728c8b9d37d8bf$export$2d14edd3a7db3bbf() {
    const apiRef = $f2Y41.useContext((0, $a4832b93f7e3ab58$export$70c437c2dab15e52));
    if (apiRef === undefined) throw new Error([
        "MUI X: Could not find the data grid context.",
        "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.",
        "This can also happen if you are bundling multiple versions of the data grid."
    ].join("\n"));
    return apiRef;
}



var $f2Y41 = parcelRequire("f2Y41");
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $4720520417e6e887$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $4720520417e6e887$export$c16cf791cc6bf0c7 {
    constructor(timeout = $4720520417e6e887$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $4720520417e6e887$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === "function") unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}


class $cb87885cb3242b93$export$86b678dc9d8f7603 {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === "function") unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}


/**
 * Signal to the underlying logic what version of the public component API
 * of the data grid is exposed.
 */ var $71512ea7dac91a28$export$544be0bdf85b5af1 = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    return GridSignature;
}($71512ea7dac91a28$export$544be0bdf85b5af1 || {});
// We use class to make it easier to detect in heap snapshots by name
class $71512ea7dac91a28$var$ObjectToBeRetainedByReact {
}
function $71512ea7dac91a28$export$4c5a9251aa47d2f8(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useGridApiEventHandler(apiRef, eventName, handler, options) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== "undefined" ? new (0, $cb87885cb3242b93$export$86b678dc9d8f7603)() : new (0, $4720520417e6e887$export$c16cf791cc6bf0c7)();
        const [objectRetainedByReact] = $f2Y41.useState(new $71512ea7dac91a28$var$ObjectToBeRetainedByReact());
        const subscription = $f2Y41.useRef(null);
        const handlerRef = $f2Y41.useRef();
        handlerRef.current = handler;
        const cleanupTokenRef = $f2Y41.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                subscription.current?.();
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $f2Y41.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    if (!event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                subscription.current?.();
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const $71512ea7dac91a28$var$registryContainer = {
    registry: null
};
const $71512ea7dac91a28$export$c5af18cc30c6146f = ()=>{
    $71512ea7dac91a28$var$registryContainer.registry?.reset();
    $71512ea7dac91a28$var$registryContainer.registry = null;
};
const $71512ea7dac91a28$export$223e28bfc0254c87 = $71512ea7dac91a28$export$4c5a9251aa47d2f8($71512ea7dac91a28$var$registryContainer);
const $71512ea7dac91a28$var$optionsSubscriberOptions = {
    isFirst: true
};
function $71512ea7dac91a28$export$d55ddab8b28954db(apiRef, eventName, handler) {
    // Validate that only one per event name?
    $71512ea7dac91a28$export$223e28bfc0254c87(apiRef, eventName, handler, $71512ea7dac91a28$var$optionsSubscriberOptions);
}



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
"use client";
const $b051a6871807a6e6$var$UNINITIALIZED = {};
function $b051a6871807a6e6$export$2e2bcd8739ae039(init, initArg) {
    const ref = $f2Y41.useRef($b051a6871807a6e6$var$UNINITIALIZED);
    if (ref.current === $b051a6871807a6e6$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $f2Y41 = parcelRequire("f2Y41");
"use client";
const $33567b05615fab88$var$EMPTY = [];
function $33567b05615fab88$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $f2Y41.useEffect(fn, $33567b05615fab88$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


const $a93eb5ccff318341$export$baf331755d84b871 = (message, gravity = "warning")=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === "error") console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};
const $a93eb5ccff318341$export$eeb37579de885205 = (method, message)=>{
    var args;
    return method;
};


const $e24e91c53f2440b0$var$is = Object.is;
function $e24e91c53f2440b0$export$84d14f151b531ccb(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$e24e91c53f2440b0$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    /* eslint-enable no-restricted-syntax */ /* eslint-enable guard-for-in */ return aLength === bLength;
}


const $193e08cc82c187d1$var$stateNotInitializedWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: `useGridSelector` has been called before the initialization of the state.",
    "This hook can only be used inside the context of the grid."
]);
function $193e08cc82c187d1$var$isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
function $193e08cc82c187d1$var$applySelector(apiRef, selector) {
    if ($193e08cc82c187d1$var$isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
}
const $193e08cc82c187d1$var$defaultCompare = Object.is;
const $193e08cc82c187d1$export$8da4c691e5695191 = (0, $e24e91c53f2440b0$export$84d14f151b531ccb);
const $193e08cc82c187d1$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null
    });
const $193e08cc82c187d1$export$f96fd476863f2e4a = (apiRef, selector, equals = $193e08cc82c187d1$var$defaultCompare)=>{
    const refs = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)($193e08cc82c187d1$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $f2Y41.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $193e08cc82c187d1$var$applySelector(apiRef, selector));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    (0, $33567b05615fab88$export$2e2bcd8739ae039)(()=>{
        return apiRef.current.store.subscribe(()=>{
            const newState = $193e08cc82c187d1$var$applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
    });
    return state;
};


const $13cd7539f33578ca$export$26d8768b83a52ffd = (state)=>state.dimensions;


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $3aa7588999df3515$var$NOT_FOUND = "NOT_FOUND";
function $3aa7588999df3515$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $3aa7588999df3515$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $3aa7588999df3515$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $3aa7588999df3515$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $3aa7588999df3515$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $3aa7588999df3515$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $3aa7588999df3515$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $3aa7588999df3515$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $3aa7588999df3515$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $3aa7588999df3515$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $3aa7588999df3515$var$createSingletonCache(comparator) : $3aa7588999df3515$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $3aa7588999df3515$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $6082a7088d10c5de$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $6082a7088d10c5de$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $6082a7088d10c5de$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $6082a7088d10c5de$export$595d22ed68ca2841 = /* #__PURE__ */ $6082a7088d10c5de$export$5943f4447f6ef248((0, $3aa7588999df3515$export$281bff7f05488aa2));
var $6082a7088d10c5de$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $6082a7088d10c5de$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};



const $a8687ecb01faf148$var$cache = new WeakMap();
const $a8687ecb01faf148$var$missingInstanceIdWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.",
    "To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`."
]);
function $a8687ecb01faf148$var$checkIsAPIRef(value) {
    return "current" in value && "instanceId" in value.current;
}
const $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID = {
    id: "default"
};
const $a8687ecb01faf148$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...rest)=>{
    if (rest.length > 0) throw new Error("Unsupported number of selectors");
    let selector;
    if (a && b && c && d && e && f) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $a8687ecb01faf148$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        const ve = e(state, instanceId);
        return f(va, vb, vc, vd, ve);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $a8687ecb01faf148$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        return e(va, vb, vc, vd);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $a8687ecb01faf148$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        return d(va, vb, vc);
    };
    else if (a && b && c) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $a8687ecb01faf148$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        return c(va, vb);
    };
    else if (a && b) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $a8687ecb01faf148$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        return b(va);
    };
    else throw new Error("Missing arguments");
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $a8687ecb01faf148$export$2a3ca4704a61d1f4 = (...args)=>{
    const selector = (stateOrApiRef, instanceId)=>{
        const isAPIRef = $a8687ecb01faf148$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId ?? $a8687ecb01faf148$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const cacheArgsInit = $a8687ecb01faf148$var$cache.get(cacheKey);
        const cacheArgs = cacheArgsInit ?? new Map();
        const cacheFn = cacheArgs?.get(args);
        if (cacheArgs && cacheFn) // We pass the cache key because the called selector might have as
        // dependency another selector created with this `createSelector`.
        return cacheFn(state, cacheKey);
        const fn = (0, $6082a7088d10c5de$export$595d22ed68ca2841)(...args);
        if (!cacheArgsInit) $a8687ecb01faf148$var$cache.set(cacheKey, cacheArgs);
        cacheArgs.set(args, fn);
        return fn(state, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};


const $a8df3c1fd8492eab$export$44e428f429332330 = 0.7;
const $a8df3c1fd8492eab$export$ff72d9a37c8f7b58 = 1.3;
const $a8df3c1fd8492eab$var$DENSITY_FACTORS = {
    compact: $a8df3c1fd8492eab$export$44e428f429332330,
    comfortable: $a8df3c1fd8492eab$export$ff72d9a37c8f7b58,
    standard: 1
};
const $a8df3c1fd8492eab$export$806a039ece4425b4 = (state)=>state.density;
const $a8df3c1fd8492eab$export$c646201fb1d3e7a6 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($a8df3c1fd8492eab$export$806a039ece4425b4, (density)=>$a8df3c1fd8492eab$var$DENSITY_FACTORS[density]);



let $49d1610712424e75$export$64f54b460f67389c = /*#__PURE__*/ function(GridPinnedColumnPosition) {
    GridPinnedColumnPosition["LEFT"] = "left";
    GridPinnedColumnPosition["RIGHT"] = "right";
    return GridPinnedColumnPosition;
}({});
const $49d1610712424e75$export$77439b544edbbd66 = {
    left: [],
    right: []
};


/**
 * Get the theme state
 * @category Core
 */ const $d5a82fb76b99c1de$export$d09b5c13721ec87f = (state)=>state.theme;


const $b22d10f7b8994eba$export$858d15abb6cddc08 = (state)=>state.columns;
const $b22d10f7b8994eba$export$d8a3dfbb129c80db = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b22d10f7b8994eba$export$858d15abb6cddc08, (columnsState)=>columnsState.orderedFields);
const $b22d10f7b8994eba$export$8a3a9a6db584d7fd = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b22d10f7b8994eba$export$858d15abb6cddc08, (columnsState)=>columnsState.lookup);
const $b22d10f7b8994eba$export$da85f06e3c19f1fd = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$d8a3dfbb129c80db, $b22d10f7b8994eba$export$8a3a9a6db584d7fd, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const $b22d10f7b8994eba$export$eb0d33595fe29bb4 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b22d10f7b8994eba$export$858d15abb6cddc08, (columnsState)=>columnsState.columnVisibilityModel);
const $b22d10f7b8994eba$export$16a65a9447d3dda9 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$da85f06e3c19f1fd, $b22d10f7b8994eba$export$eb0d33595fe29bb4, (columns, columnVisibilityModel)=>columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const $b22d10f7b8994eba$export$c9491722e1d6e8d3 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$16a65a9447d3dda9, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const $b22d10f7b8994eba$export$1eea0bd4db853467 = (state)=>state.pinnedColumns;
const $b22d10f7b8994eba$export$297e8079713afa11 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$858d15abb6cddc08, $b22d10f7b8994eba$export$1eea0bd4db853467, $b22d10f7b8994eba$export$c9491722e1d6e8d3, (0, $d5a82fb76b99c1de$export$d09b5c13721ec87f), (columnsState, model, visibleColumnFields, theme)=>{
    const visiblePinnedFields = $b22d10f7b8994eba$var$filterVisibleColumns(model, visibleColumnFields, theme.direction === "rtl");
    const visiblePinnedColumns = {
        left: visiblePinnedFields.left.map((field)=>columnsState.lookup[field]),
        right: visiblePinnedFields.right.map((field)=>columnsState.lookup[field])
    };
    return visiblePinnedColumns;
});
function $b22d10f7b8994eba$var$filterVisibleColumns(pinnedColumns, columns, invert) {
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return 0, $49d1610712424e75$export$77439b544edbbd66;
    if (pinnedColumns.left?.length === 0 && pinnedColumns.right?.length === 0) return 0, $49d1610712424e75$export$77439b544edbbd66;
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return {
        left: rightPinnedColumns,
        right: leftPinnedColumns
    };
    return {
        left: leftPinnedColumns,
        right: rightPinnedColumns
    };
}
const $b22d10f7b8994eba$export$fce7d810e48021e3 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$16a65a9447d3dda9, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const $b22d10f7b8994eba$export$ab20f9d33edc7794 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b22d10f7b8994eba$export$16a65a9447d3dda9, $b22d10f7b8994eba$export$fce7d810e48021e3, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth;
});
const $b22d10f7b8994eba$export$2cad659ba95fed71 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$da85f06e3c19f1fd, (columns)=>columns.filter((col)=>col.filterable));
const $b22d10f7b8994eba$export$e84218276cc24419 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$da85f06e3c19f1fd, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
const $b22d10f7b8994eba$export$7aac81e7227448b4 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b22d10f7b8994eba$export$da85f06e3c19f1fd, (columns)=>columns.some((column)=>column.colSpan !== undefined));




"use client";
class $7982601b7fbfa734$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $7982601b7fbfa734$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $7982601b7fbfa734$export$2e2bcd8739ae039() {
    const timeout = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)($7982601b7fbfa734$export$786b4da70f00938b.create).current;
    (0, $33567b05615fab88$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


var $0743a989307d7610$exports = {};
"use strict";

var $gDgMD = parcelRequire("gDgMD");
Object.defineProperty($0743a989307d7610$exports, "__esModule", {
    value: true
});
$0743a989307d7610$exports.default = $0743a989307d7610$var$createStyled;
$0743a989307d7610$exports.shouldForwardProp = $0743a989307d7610$var$shouldForwardProp;
$0743a989307d7610$exports.systemDefaultTheme = void 0;

var $0743a989307d7610$var$_extends2 = $gDgMD((parcelRequire("dFWbn")));

var $0743a989307d7610$var$_objectWithoutPropertiesLoose2 = $gDgMD((parcelRequire("hBrK5")));

var $0743a989307d7610$var$_styledEngine = $0743a989307d7610$var$_interopRequireWildcard((parcelRequire("5TVeh")));

var $cAicU = parcelRequire("cAicU");

var $0743a989307d7610$var$_capitalize = $gDgMD((parcelRequire("izihI")));

var $0743a989307d7610$var$_getDisplayName = $gDgMD((parcelRequire("1H7Jh")));

var $0743a989307d7610$var$_createTheme = $gDgMD((parcelRequire("bAOL4")));

var $0743a989307d7610$var$_styleFunctionSx = $gDgMD((parcelRequire("8wVSe")));
const $0743a989307d7610$var$_excluded = [
    "ownerState"
], $0743a989307d7610$var$_excluded2 = [
    "variants"
], $0743a989307d7610$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $0743a989307d7610$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0743a989307d7610$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $0743a989307d7610$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $0743a989307d7610$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $0743a989307d7610$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0743a989307d7610$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $0743a989307d7610$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $0743a989307d7610$var$systemDefaultTheme = $0743a989307d7610$exports.systemDefaultTheme = (0, $0743a989307d7610$var$_createTheme.default)();
const $0743a989307d7610$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0743a989307d7610$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0743a989307d7610$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0743a989307d7610$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $0743a989307d7610$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $0743a989307d7610$var$_objectWithoutPropertiesLoose2.default)(_ref, $0743a989307d7610$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $0743a989307d7610$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$0743a989307d7610$var$processStyleArg(resolvedStyle, (0, $0743a989307d7610$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $0743a989307d7610$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $0743a989307d7610$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $0743a989307d7610$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $0743a989307d7610$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $0743a989307d7610$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0743a989307d7610$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $0743a989307d7610$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $0743a989307d7610$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $0743a989307d7610$var$_styleFunctionSx.default)((0, $0743a989307d7610$var$_extends2.default)({}, props, {
            theme: $0743a989307d7610$var$resolveTheme((0, $0743a989307d7610$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $0743a989307d7610$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0743a989307d7610$var$defaultOverridesResolver($0743a989307d7610$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $0743a989307d7610$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $0743a989307d7610$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0743a989307d7610$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0743a989307d7610$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $0743a989307d7610$var$_styledEngine.default)(tag, (0, $0743a989307d7610$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $cAicU.isPlainObject)(stylesArg)) return (props)=>$0743a989307d7610$var$processStyleArg(stylesArg, (0, $0743a989307d7610$var$_extends2.default)({}, props, {
                    theme: $0743a989307d7610$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0743a989307d7610$var$resolveTheme((0, $0743a989307d7610$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $0743a989307d7610$var$processStyleArg(slotStyle, (0, $0743a989307d7610$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $0743a989307d7610$var$resolveTheme((0, $0743a989307d7610$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $0743a989307d7610$var$processStyleArg({
                    variants: themeVariants
                }, (0, $0743a989307d7610$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}




// copied from @mui/system/createStyled
function $be173d695deaaa4f$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $be173d695deaaa4f$export$2e2bcd8739ae039 = $be173d695deaaa4f$var$slotShouldForwardProp;


const $4773145d8cae4871$var$rootShouldForwardProp = (prop)=>(0, $be173d695deaaa4f$export$2e2bcd8739ae039)(prop) && prop !== "classes";
var $4773145d8cae4871$export$2e2bcd8739ae039 = $4773145d8cae4871$var$rootShouldForwardProp;



"use client";
const $701b5b4e63c11d4d$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($0743a989307d7610$exports)))({
    themeId: (0, $052d61a03cfc8b91$export$2e2bcd8739ae039),
    defaultTheme: $c48003953c749b7a$export$2e2bcd8739ae039,
    rootShouldForwardProp: $4773145d8cae4871$export$2e2bcd8739ae039
});
var $701b5b4e63c11d4d$export$2e2bcd8739ae039 = $701b5b4e63c11d4d$var$styled;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $aahau = parcelRequire("aahau");

var $f2Y41 = parcelRequire("f2Y41");





var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $71559b3d0d8c73fb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $e8cbed3bfd60af6f$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $a97899720a0a78b2$export$2e2bcd8739ae039(node) {
    const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $f2Y41 = parcelRequire("f2Y41");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $89e0f791fe6ff375$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $b5011b61ae0cb30b$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $f2Y41.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $89e0f791fe6ff375$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $73935b95a2fff670$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $73935b95a2fff670$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $73935b95a2fff670$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $73935b95a2fff670$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $73935b95a2fff670$export$d1710922ecaf577a = /*#__PURE__*/ $f2Y41.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $bKcdJ.default)(props, $73935b95a2fff670$var$_excluded);
    const { current: isControlled } = $f2Y41.useRef(value != null);
    const inputRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $f2Y41.useRef(null);
    const calculateTextareaStyles = $f2Y41.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $a97899720a0a78b2$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $73935b95a2fff670$var$getStyleValue(computedStyle.paddingBottom) + $73935b95a2fff670$var$getStyleValue(computedStyle.paddingTop);
        const border = $73935b95a2fff670$var$getStyleValue(computedStyle.borderBottomWidth) + $73935b95a2fff670$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $f2Y41.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($73935b95a2fff670$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $71559b3d0d8c73fb$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $a97899720a0a78b2$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("textarea", (0, $asN9r.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ge3KO.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $asN9r.default)({}, $73935b95a2fff670$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $4d97b08b1822aa9b$export$e28348cc2430497(element) {
    return typeof element === "string";
}



function $56a7f7c98f7e3f58$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $f2Y41 = parcelRequire("f2Y41");
/**
 * @ignore - internal component.
 */ const $0e13fdb8d49639b9$var$FormControlContext = /*#__PURE__*/ $f2Y41.createContext(undefined);
var $0e13fdb8d49639b9$export$2e2bcd8739ae039 = $0e13fdb8d49639b9$var$FormControlContext;



var $f2Y41 = parcelRequire("f2Y41");

"use client";
function $f8c3e0729018c4ff$export$2e2bcd8739ae039() {
    return $f2Y41.useContext((0, $0e13fdb8d49639b9$export$2e2bcd8739ae039));
}





var $gl072 = parcelRequire("gl072");
var $baa577b6b7474d92$export$2e2bcd8739ae039 = (0, $gl072.default);



"use client";
var $ed21878ae3c5e88a$export$2e2bcd8739ae039 = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039);



"use client";
var $678399b549f398d4$export$2e2bcd8739ae039 = (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039);



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");

parcelRequire("f2Y41");


var $jNp5p = parcelRequire("jNp5p");


var $ge3KO = parcelRequire("ge3KO");
"use client";
function $88882e6e1260c2c0$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $e65a75724f3a2622$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $jNp5p.default), {
        styles: globalStyles
    });
}
var $88882e6e1260c2c0$export$2e2bcd8739ae039 = $88882e6e1260c2c0$var$GlobalStyles;





var $ge3KO = parcelRequire("ge3KO");
"use client";
function $43cc2a39c2f0d49b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $88882e6e1260c2c0$export$2e2bcd8739ae039), (0, $asN9r.default)({}, props, {
        defaultTheme: (0, $c48003953c749b7a$export$2e2bcd8739ae039),
        themeId: (0, $052d61a03cfc8b91$export$2e2bcd8739ae039)
    }));
}
var $43cc2a39c2f0d49b$export$2e2bcd8739ae039 = $43cc2a39c2f0d49b$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $e46b17d83ec63e21$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $e46b17d83ec63e21$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($e46b17d83ec63e21$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $e46b17d83ec63e21$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $e46b17d83ec63e21$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $3879b8acfd0d0428$export$ef57d5c8ca2278f6(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiInputBase", slot);
}
const $3879b8acfd0d0428$var$inputBaseClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $3879b8acfd0d0428$export$2e2bcd8739ae039 = $3879b8acfd0d0428$var$inputBaseClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $6d303477181c22f4$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $6d303477181c22f4$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $6d303477181c22f4$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $6d303477181c22f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $3879b8acfd0d0428$export$ef57d5c8ca2278f6), classes);
};
const $6d303477181c22f4$export$298a043133d72a38 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $6d303477181c22f4$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $asN9r.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $6d303477181c22f4$export$a1ad29c901026019 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $6d303477181c22f4$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $asN9r.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $asN9r.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $6d303477181c22f4$var$inputGlobalStyles = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $43cc2a39c2f0d49b$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $6d303477181c22f4$var$InputBase = /*#__PURE__*/ $f2Y41.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $bKcdJ.default)(props, $6d303477181c22f4$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $f2Y41.useRef(value != null);
    const inputRef = $f2Y41.useRef();
    const handleInputRefWarning = $f2Y41.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $f2Y41.useState(false);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $f2Y41.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $f2Y41.useCallback((obj)=>{
        if ((0, $e46b17d83ec63e21$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $678399b549f398d4$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $aahau.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $f2Y41.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $asN9r.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $asN9r.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $73935b95a2fff670$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $f2Y41.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $asN9r.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $6d303477181c22f4$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $6d303477181c22f4$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $6d303477181c22f4$export$a1ad29c901026019;
    inputProps = (0, $asN9r.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $6d303477181c22f4$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ge3KO.jsxs)(Root, (0, $asN9r.default)({}, rootProps, !(0, $4d97b08b1822aa9b$export$e28348cc2430497)(Root) && {
                ownerState: (0, $asN9r.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0e13fdb8d49639b9$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)(Input, (0, $asN9r.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $4d97b08b1822aa9b$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $asN9r.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $asN9r.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $6d303477181c22f4$export$2e2bcd8739ae039 = $6d303477181c22f4$var$InputBase;






var $ge3KO = parcelRequire("ge3KO");
const $aebd27a090315feb$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const $aebd27a090315feb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "editInputCell"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $aebd27a090315feb$var$GridEditInputCellRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$2e2bcd8739ae039), {
    name: "MuiDataGrid",
    slot: "EditInputCell",
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme: theme })=>(0, $asN9r.default)({}, theme.typography.body2, {
        padding: "1px 0",
        "& input": {
            padding: "0 16px",
            height: "100%"
        }
    }));
const $aebd27a090315feb$export$cd10ed3250a4d414 = /*#__PURE__*/ $f2Y41.forwardRef((props, ref)=>{
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange } = props, other = (0, $bKcdJ.default)(props, $aebd27a090315feb$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const inputRef = $f2Y41.useRef();
    const [valueState, setValueState] = $f2Y41.useState(value);
    const classes = $aebd27a090315feb$var$useUtilityClasses(rootProps);
    const handleChange = $f2Y41.useCallback(async (event)=>{
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $f2Y41.useEffect(()=>{
        if (meta?.changeReason !== "debouncedSetEditCellValue") setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($aebd27a090315feb$var$GridEditInputCellRoot, (0, $asN9r.default)({
        ref: ref,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === "number" ? colDef.type : "text",
        value: valueState ?? "",
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other));
});
const $aebd27a090315feb$export$d1015f41e7e48c2e = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)($aebd27a090315feb$export$cd10ed3250a4d414, (0, $asN9r.default)({}, params));



var $asN9r = parcelRequire("asN9r");

const $c24e05fccf11e052$var$sortModelDisableMultiColumnsSortingWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.",
    "If you are using the community version of the `DataGrid`, this prop is always `true`."
], "error");
const $c24e05fccf11e052$export$13eeac5ac15e0be5 = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) return [
        model[0]
    ];
    return model;
};
const $c24e05fccf11e052$export$3fc28d475ac000c0 = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $asN9r.default)({}, state, {
            sorting: (0, $asN9r.default)({}, state.sorting, {
                sortModel: $c24e05fccf11e052$export$13eeac5ac15e0be5(sortModel, disableMultipleColumnsSorting)
            })
        });
const $c24e05fccf11e052$var$isDesc = (direction)=>direction === "desc";
/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $c24e05fccf11e052$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column || sortItem.sort === null) return null;
    let comparator;
    if (column.getSortComparator) comparator = column.getSortComparator(sortItem.sort);
    else comparator = $c24e05fccf11e052$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    if (!comparator) return null;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: apiRef.current.getRowNode(id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $c24e05fccf11e052$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const $c24e05fccf11e052$export$b29e353d1a72dfda = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$c24e05fccf11e052$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$c24e05fccf11e052$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const $c24e05fccf11e052$export$b3d84351ab2e3580 = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const $c24e05fccf11e052$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $c24e05fccf11e052$var$collator = new Intl.Collator();
const $c24e05fccf11e052$export$db324d0b741f4529 = (value1, value2)=>{
    const nillResult = $c24e05fccf11e052$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === "string") return $c24e05fccf11e052$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const $c24e05fccf11e052$export$ecfdaa3722003888 = (value1, value2)=>{
    const nillResult = $c24e05fccf11e052$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const $c24e05fccf11e052$export$74e685f55e96d6bc = (value1, value2)=>{
    const nillResult = $c24e05fccf11e052$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $f2Y41 = parcelRequire("f2Y41");
"use client";
let $2599ce271b2f22b2$var$globalId = 0;
function $2599ce271b2f22b2$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $f2Y41.useState(idOverride);
    const id = idOverride || defaultId;
    $f2Y41.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $2599ce271b2f22b2$var$globalId += 1;
            setDefaultId(`mui-${$2599ce271b2f22b2$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $2599ce271b2f22b2$var$maybeReactUseId = $f2Y41["useId".toString()];
function $2599ce271b2f22b2$export$2e2bcd8739ae039(idOverride) {
    if ($2599ce271b2f22b2$var$maybeReactUseId !== undefined) {
        const reactId = $2599ce271b2f22b2$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $2599ce271b2f22b2$var$useGlobalId(idOverride);
}





var $ge3KO = parcelRequire("ge3KO");
const $64c9f1e3086437a0$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "clearButton",
    "InputProps",
    "variant"
];
function $64c9f1e3086437a0$export$99d1f108a3f21b3(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, clearButton: clearButton, InputProps: InputProps, variant: variant = "standard" } = props, others = (0, $bKcdJ.default)(props, $64c9f1e3086437a0$var$_excluded);
    const filterTimeout = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const [filterValueState, setFilterValueState] = $f2Y41.useState(item.value ?? "");
    const [applying, setIsApplying] = $f2Y41.useState(false);
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $f2Y41.useCallback((event)=>{
        const { value: value } = event.target;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $asN9r.default)({}, item, {
                value: value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        id,
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $f2Y41.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value === undefined) setFilterValueState(String(item.value ?? ""));
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTextField, (0, $asN9r.default)({
        id: id,
        label: apiRef.current.getLocaleText("filterPanelInputLabel"),
        placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
        value: filterValueState,
        onChange: onFilterChange,
        variant: variant,
        type: type || "text",
        InputProps: (0, $asN9r.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $asN9r.default)({
                tabIndex: tabIndex
            }, InputProps?.inputProps)
        }),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, rootProps.slotProps?.baseTextField));
}


function $2b59f632c4f96fc9$export$7e4aa119212bc614(value) {
    return typeof value === "number" && !Number.isNaN(value);
}
function $2b59f632c4f96fc9$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $2b59f632c4f96fc9$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}
function $2b59f632c4f96fc9$export$c43914e0cb16a981() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = "__some_random_key_you_are_not_going_to_use__";
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $2b59f632c4f96fc9$export$7c57da42ce8e346f(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));
function $2b59f632c4f96fc9$export$d02631cccf789723(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
function $2b59f632c4f96fc9$export$78fdc9adc3f30400(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$2b59f632c4f96fc9$export$78fdc9adc3f30400(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$2b59f632c4f96fc9$export$78fdc9adc3f30400(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$2b59f632c4f96fc9$export$78fdc9adc3f30400(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $2b59f632c4f96fc9$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function $2b59f632c4f96fc9$export$ffd8c9a5b80f1e57(seed, min, max) {
    const random = $2b59f632c4f96fc9$var$mulberry32(seed);
    return ()=>min + (max - min) * random();
}
function $2b59f632c4f96fc9$export$b7d58db314e0ac27(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
function $2b59f632c4f96fc9$export$ec5767fa5c351320(_) {} /* eslint-enable @typescript-eslint/no-unused-vars */ 



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
"use client";
function $715e70489ae77e41$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $f2Y41.useRef(controlled !== undefined);
    const [valueState, setValue] = $f2Y41.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $f2Y41.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $f2Y41 = parcelRequire("f2Y41");
"use client";
const $41e3424fd3b32970$var$usePreviousProps = (value)=>{
    const ref = $f2Y41.useRef({});
    $f2Y41.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $41e3424fd3b32970$export$2e2bcd8739ae039 = $41e3424fd3b32970$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $280f1223365e8458$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $280f1223365e8458$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $280f1223365e8458$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $280f1223365e8458$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $280f1223365e8458$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $280f1223365e8458$var$defaultFilterOptions = $280f1223365e8458$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $280f1223365e8458$var$pageSize = 5;
const $280f1223365e8458$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $280f1223365e8458$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $280f1223365e8458$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $280f1223365e8458$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $f2Y41.useRef(false);
    const firstFocus = $f2Y41.useRef(true);
    const inputRef = $f2Y41.useRef(null);
    const listboxRef = $f2Y41.useRef(null);
    const [anchorEl, setAnchorEl] = $f2Y41.useState(null);
    const [focusedTag, setFocusedTag] = $f2Y41.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $f2Y41.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $715e70489ae77e41$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $715e70489ae77e41$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $f2Y41.useState(false);
    const resetInputValue = $f2Y41.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $715e70489ae77e41$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $f2Y41.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $41e3424fd3b32970$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $f2Y41.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $f2Y41.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $280f1223365e8458$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $f2Y41.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $280f1223365e8458$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $280f1223365e8458$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((node)=>{
        (0, $89e0f791fe6ff375$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $f2Y41.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $f2Y41.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $280f1223365e8458$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$280f1223365e8458$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $280f1223365e8458$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $asN9r.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $asN9r.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}





var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");

function $66f637e77bc39d4e$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $e33f74ac43da3383$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e33f74ac43da3383$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e33f74ac43da3383$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $5d5efb9f469ba885$export$8960430cfd85939f = Math.max;
var $5d5efb9f469ba885$export$96ec731ed4dcb222 = Math.min;
var $5d5efb9f469ba885$export$2077e0241d6afd3c = Math.round;



function $24f1535e471c73ee$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $9a471243e8bff1ec$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $24f1535e471c73ee$export$2e2bcd8739ae039)());
}


function $9f9e272ea0209784$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $5d5efb9f469ba885$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $5d5efb9f469ba885$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(element) ? (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $9a471243e8bff1ec$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $efef5860407c3586$export$2e2bcd8739ae039(node) {
    var win = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c08bdb8ba89b6ccb$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $021ad34f5a1b9587$export$2e2bcd8739ae039(node) {
    if (node === (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(node) || !(0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(node)) return (0, $efef5860407c3586$export$2e2bcd8739ae039)(node);
    else return (0, $c08bdb8ba89b6ccb$export$2e2bcd8739ae039)(node);
}


function $39c87821a0d3de02$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $888d26fb1b80e540$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $dba55a45465b40fc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $9f9e272ea0209784$export$2e2bcd8739ae039)((0, $888d26fb1b80e540$export$2e2bcd8739ae039)(element)).left + (0, $efef5860407c3586$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cfd767f1eb3e13c7$export$2e2bcd8739ae039(element) {
    return (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $6a561ed22b05952a$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bd6fea97ee534b62$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $5d5efb9f469ba885$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $5d5efb9f469ba885$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bd6fea97ee534b62$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(offsetParent) && $bd6fea97ee534b62$var$isElementScaled(offsetParent);
    var documentElement = (0, $888d26fb1b80e540$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $9f9e272ea0209784$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $39c87821a0d3de02$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $6a561ed22b05952a$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $021ad34f5a1b9587$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $9f9e272ea0209784$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $dba55a45465b40fc$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad77636420b7e63f$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $9f9e272ea0209784$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $543650ae784143e6$export$2e2bcd8739ae039(element) {
    if ((0, $39c87821a0d3de02$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $e33f74ac43da3383$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $888d26fb1b80e540$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $dde208ca0d3fa11c$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $39c87821a0d3de02$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(node) && (0, $6a561ed22b05952a$export$2e2bcd8739ae039)(node)) return node;
    return $dde208ca0d3fa11c$export$2e2bcd8739ae039((0, $543650ae784143e6$export$2e2bcd8739ae039)(node));
}





function $fee866e70870dcbd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $dde208ca0d3fa11c$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $6a561ed22b05952a$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($fee866e70870dcbd$export$2e2bcd8739ae039((0, $543650ae784143e6$export$2e2bcd8739ae039)(target)));
}







function $31fefcdc3d5848a4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $39c87821a0d3de02$export$2e2bcd8739ae039)(element)) >= 0;
}




function $9a1b4fddd5a28aa0$var$getTrueOffsetParent(element) {
    if (!(0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $9a1b4fddd5a28aa0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $24f1535e471c73ee$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $24f1535e471c73ee$export$2e2bcd8739ae039)());
    if (isIE && (0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $543650ae784143e6$export$2e2bcd8739ae039)(element);
    if ((0, $e33f74ac43da3383$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $39c87821a0d3de02$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $9a1b4fddd5a28aa0$export$2e2bcd8739ae039(element) {
    var window = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(element);
    var offsetParent = $9a1b4fddd5a28aa0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $31fefcdc3d5848a4$export$2e2bcd8739ae039)(offsetParent) && (0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $9a1b4fddd5a28aa0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $39c87821a0d3de02$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $39c87821a0d3de02$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $9a1b4fddd5a28aa0$var$getContainingBlock(element) || window;
}


var $51b538bbb2e746e0$export$1e95b668f3b82d = "top";
var $51b538bbb2e746e0$export$40e543e69a8b3fbb = "bottom";
var $51b538bbb2e746e0$export$79ffe56a765070d2 = "right";
var $51b538bbb2e746e0$export$eabcd2c8791e7bf4 = "left";
var $51b538bbb2e746e0$export$dfb5619354ba860 = "auto";
var $51b538bbb2e746e0$export$aec2ce47c367b8c3 = [
    $51b538bbb2e746e0$export$1e95b668f3b82d,
    $51b538bbb2e746e0$export$40e543e69a8b3fbb,
    $51b538bbb2e746e0$export$79ffe56a765070d2,
    $51b538bbb2e746e0$export$eabcd2c8791e7bf4
];
var $51b538bbb2e746e0$export$b3571188c770cc5a = "start";
var $51b538bbb2e746e0$export$bd5df0f255a350f8 = "end";
var $51b538bbb2e746e0$export$390fd549c5303b4d = "clippingParents";
var $51b538bbb2e746e0$export$d7b7311ec04a3e8f = "viewport";
var $51b538bbb2e746e0$export$ae5ab1c730825774 = "popper";
var $51b538bbb2e746e0$export$ca50aac9f3ba507f = "reference";
var $51b538bbb2e746e0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $51b538bbb2e746e0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $51b538bbb2e746e0$export$b3571188c770cc5a,
        placement + "-" + $51b538bbb2e746e0$export$bd5df0f255a350f8
    ]);
}, []);
var $51b538bbb2e746e0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($51b538bbb2e746e0$export$aec2ce47c367b8c3, [
    $51b538bbb2e746e0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $51b538bbb2e746e0$export$b3571188c770cc5a,
        placement + "-" + $51b538bbb2e746e0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $51b538bbb2e746e0$export$421679a7c3d56e = "beforeRead";
var $51b538bbb2e746e0$export$aafa59e2e03f2942 = "read";
var $51b538bbb2e746e0$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $51b538bbb2e746e0$export$c65e99957a05207c = "beforeMain";
var $51b538bbb2e746e0$export$f22da7240b7add18 = "main";
var $51b538bbb2e746e0$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $51b538bbb2e746e0$export$8d4d2d70e7d46032 = "beforeWrite";
var $51b538bbb2e746e0$export$68d8715fc104d294 = "write";
var $51b538bbb2e746e0$export$70a6e5159acce2e6 = "afterWrite";
var $51b538bbb2e746e0$export$d087d3878fdf71d5 = [
    $51b538bbb2e746e0$export$421679a7c3d56e,
    $51b538bbb2e746e0$export$aafa59e2e03f2942,
    $51b538bbb2e746e0$export$6964f6c886723980,
    $51b538bbb2e746e0$export$c65e99957a05207c,
    $51b538bbb2e746e0$export$f22da7240b7add18,
    $51b538bbb2e746e0$export$bab79516f2d662fe,
    $51b538bbb2e746e0$export$8d4d2d70e7d46032,
    $51b538bbb2e746e0$export$68d8715fc104d294,
    $51b538bbb2e746e0$export$70a6e5159acce2e6
];


function $200f5250995241b7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $200f5250995241b7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $200f5250995241b7$var$order(modifiers); // order based on phase
    return (0, $51b538bbb2e746e0$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $b95bf9b372a1d8a1$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $12d4d77d893f781d$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $edc25aa6a25ffabb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $edc25aa6a25ffabb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $edc25aa6a25ffabb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $edc25aa6a25ffabb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $edc25aa6a25ffabb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(reference) ? (0, $fee866e70870dcbd$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $fee866e70870dcbd$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $fee866e70870dcbd$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $200f5250995241b7$export$2e2bcd8739ae039)((0, $12d4d77d893f781d$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$edc25aa6a25ffabb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bd6fea97ee534b62$export$2e2bcd8739ae039)(reference, (0, $9a1b4fddd5a28aa0$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $ad77636420b7e63f$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $b95bf9b372a1d8a1$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$edc25aa6a25ffabb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $edc25aa6a25ffabb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $edc25aa6a25ffabb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $bf789ed0abaa3eab$var$passive = {
    passive: true
};
function $bf789ed0abaa3eab$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $bf789ed0abaa3eab$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $bf789ed0abaa3eab$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $bf789ed0abaa3eab$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $bf789ed0abaa3eab$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $bf789ed0abaa3eab$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $bf789ed0abaa3eab$var$effect,
    data: {}
};



function $fde4fb7d33536bb1$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $85409252a79984f0$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $74effd40d5392019$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $91ace7357794979e$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $85409252a79984f0$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $51b538bbb2e746e0$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $51b538bbb2e746e0$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $51b538bbb2e746e0$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $74effd40d5392019$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $51b538bbb2e746e0$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $51b538bbb2e746e0$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $f7143f4a5a7dc0a7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $91ace7357794979e$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f7143f4a5a7dc0a7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $f7143f4a5a7dc0a7$var$popperOffsets,
    data: {}
};










var $2a1b164d645419aa$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2a1b164d645419aa$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $5d5efb9f469ba885$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $5d5efb9f469ba885$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $2a1b164d645419aa$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4);
    var sideY = (0, $51b538bbb2e746e0$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9a1b4fddd5a28aa0$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $888d26fb1b80e540$export$2e2bcd8739ae039)(popper);
            if ((0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $51b538bbb2e746e0$export$1e95b668f3b82d) || (placement === (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4) || placement === (0, $51b538bbb2e746e0$export$79ffe56a765070d2)) && variation === (0, $51b538bbb2e746e0$export$bd5df0f255a350f8)) {
            sideY = (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4) || (placement === (0, $51b538bbb2e746e0$export$1e95b668f3b82d) || placement === (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb)) && variation === (0, $51b538bbb2e746e0$export$bd5df0f255a350f8)) {
            sideX = (0, $51b538bbb2e746e0$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2a1b164d645419aa$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2a1b164d645419aa$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $2a1b164d645419aa$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $85409252a79984f0$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2a1b164d645419aa$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2a1b164d645419aa$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2a1b164d645419aa$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $2a1b164d645419aa$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $31b8db5006cb8311$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(element) || !(0, $39c87821a0d3de02$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $31b8db5006cb8311$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(element) || !(0, $39c87821a0d3de02$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $31b8db5006cb8311$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $31b8db5006cb8311$var$applyStyles,
    effect: $31b8db5006cb8311$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ac59f33800dc30d0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4),
        (0, $51b538bbb2e746e0$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4),
        (0, $51b538bbb2e746e0$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ac59f33800dc30d0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $51b538bbb2e746e0$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ac59f33800dc30d0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ac59f33800dc30d0$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ac59f33800dc30d0$var$offset
};


var $b3ff66407458f339$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $b3ff66407458f339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $b3ff66407458f339$var$hash[matched];
    });
}



var $b1db8cbba535ea9a$var$hash = {
    start: "end",
    end: "start"
};
function $b1db8cbba535ea9a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b1db8cbba535ea9a$var$hash[matched];
    });
}







function $81c32dc82e504a68$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $66f637e77bc39d4e$export$2e2bcd8739ae039)(element);
    var html = (0, $888d26fb1b80e540$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $9a471243e8bff1ec$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $dba55a45465b40fc$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $0d1aa672cde41a41$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $888d26fb1b80e540$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $efef5860407c3586$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $5d5efb9f469ba885$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $5d5efb9f469ba885$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $dba55a45465b40fc$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $5d5efb9f469ba885$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $931a45026078242f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $e33f74ac43da3383$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $5ba070e7f745ad08$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $7606f54f6d48b8ad$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $9f9e272ea0209784$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $7606f54f6d48b8ad$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $51b538bbb2e746e0$export$d7b7311ec04a3e8f) ? (0, $5ba070e7f745ad08$export$2e2bcd8739ae039)((0, $81c32dc82e504a68$export$2e2bcd8739ae039)(element, strategy)) : (0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(clippingParent) ? $7606f54f6d48b8ad$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $5ba070e7f745ad08$export$2e2bcd8739ae039)((0, $0d1aa672cde41a41$export$2e2bcd8739ae039)((0, $888d26fb1b80e540$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $7606f54f6d48b8ad$var$getClippingParents(element) {
    var clippingParents = (0, $fee866e70870dcbd$export$2e2bcd8739ae039)((0, $543650ae784143e6$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cfd767f1eb3e13c7$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $e33f74ac43da3383$export$1b3bfaa9684536aa)(element) ? (0, $9a1b4fddd5a28aa0$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(clippingParent) && (0, $931a45026078242f$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $39c87821a0d3de02$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $7606f54f6d48b8ad$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $7606f54f6d48b8ad$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $7606f54f6d48b8ad$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $5d5efb9f469ba885$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $5d5efb9f469ba885$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $5d5efb9f469ba885$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $5d5efb9f469ba885$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $7606f54f6d48b8ad$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $f513fa4e2cdd6c50$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $16e21c9f778ee9f9$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f513fa4e2cdd6c50$export$2e2bcd8739ae039)(), paddingObject);
}


function $c18557a82e027779$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $0017524108bea6f3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $51b538bbb2e746e0$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $51b538bbb2e746e0$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $51b538bbb2e746e0$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $16e21c9f778ee9f9$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c18557a82e027779$export$2e2bcd8739ae039)(padding, (0, $51b538bbb2e746e0$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $51b538bbb2e746e0$export$ae5ab1c730825774) ? (0, $51b538bbb2e746e0$export$ca50aac9f3ba507f) : (0, $51b538bbb2e746e0$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7606f54f6d48b8ad$export$2e2bcd8739ae039)((0, $e33f74ac43da3383$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $888d26fb1b80e540$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $9f9e272ea0209784$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $91ace7357794979e$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $5ba070e7f745ad08$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $51b538bbb2e746e0$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $51b538bbb2e746e0$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $51b538bbb2e746e0$export$79ffe56a765070d2),
                (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $51b538bbb2e746e0$export$1e95b668f3b82d),
                (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $4c6aead83ee38ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $51b538bbb2e746e0$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $85409252a79984f0$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $51b538bbb2e746e0$export$368f9a87e87fa4e1) : (0, $51b538bbb2e746e0$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $85409252a79984f0$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $51b538bbb2e746e0$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $0017524108bea6f3$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $e9e2813ecb12cd1e$var$getExpandedFallbackPlacements(placement) {
    if ((0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(placement) === (0, $51b538bbb2e746e0$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $b3ff66407458f339$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b1db8cbba535ea9a$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b1db8cbba535ea9a$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $e9e2813ecb12cd1e$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $b3ff66407458f339$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $e9e2813ecb12cd1e$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(placement) === (0, $51b538bbb2e746e0$export$dfb5619354ba860) ? (0, $4c6aead83ee38ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $85409252a79984f0$export$2e2bcd8739ae039)(placement) === (0, $51b538bbb2e746e0$export$b3571188c770cc5a);
        var isVertical = [
            (0, $51b538bbb2e746e0$export$1e95b668f3b82d),
            (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $0017524108bea6f3$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $51b538bbb2e746e0$export$79ffe56a765070d2) : (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb) : (0, $51b538bbb2e746e0$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $b3ff66407458f339$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $b3ff66407458f339$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $e9e2813ecb12cd1e$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $e9e2813ecb12cd1e$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $a44781209abecc63$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $8d49c20af694a287$export$f28d906d67a997f3(min, value, max) {
    return (0, $5d5efb9f469ba885$export$8960430cfd85939f)(min, (0, $5d5efb9f469ba885$export$96ec731ed4dcb222)(value, max));
}
function $8d49c20af694a287$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8d49c20af694a287$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $50d8fed428e1ca83$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $0017524108bea6f3$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $85409252a79984f0$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $74effd40d5392019$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $a44781209abecc63$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $51b538bbb2e746e0$export$1e95b668f3b82d) : (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb) : (0, $51b538bbb2e746e0$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $51b538bbb2e746e0$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $51b538bbb2e746e0$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad77636420b7e63f$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f513fa4e2cdd6c50$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $8d49c20af694a287$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9a1b4fddd5a28aa0$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $8d49c20af694a287$export$f28d906d67a997f3)(tether ? (0, $5d5efb9f469ba885$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $5d5efb9f469ba885$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $51b538bbb2e746e0$export$1e95b668f3b82d) : (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb) : (0, $51b538bbb2e746e0$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $51b538bbb2e746e0$export$1e95b668f3b82d),
            (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $8d49c20af694a287$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $8d49c20af694a287$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $50d8fed428e1ca83$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $50d8fed428e1ca83$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $ca2109fec2a0262e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $16e21c9f778ee9f9$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c18557a82e027779$export$2e2bcd8739ae039)(padding, (0, $51b538bbb2e746e0$export$aec2ce47c367b8c3)));
};
function $ca2109fec2a0262e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $fde4fb7d33536bb1$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $74effd40d5392019$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4),
        (0, $51b538bbb2e746e0$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $ca2109fec2a0262e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad77636420b7e63f$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $51b538bbb2e746e0$export$1e95b668f3b82d) : (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb) : (0, $51b538bbb2e746e0$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9a1b4fddd5a28aa0$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $8d49c20af694a287$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $ca2109fec2a0262e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $931a45026078242f$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $ca2109fec2a0262e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $ca2109fec2a0262e$var$arrow,
    effect: $ca2109fec2a0262e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $5fd79752fd50c8dd$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $5fd79752fd50c8dd$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $51b538bbb2e746e0$export$1e95b668f3b82d),
        (0, $51b538bbb2e746e0$export$79ffe56a765070d2),
        (0, $51b538bbb2e746e0$export$40e543e69a8b3fbb),
        (0, $51b538bbb2e746e0$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $5fd79752fd50c8dd$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $0017524108bea6f3$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $0017524108bea6f3$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $5fd79752fd50c8dd$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $5fd79752fd50c8dd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $5fd79752fd50c8dd$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $5fd79752fd50c8dd$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $5fd79752fd50c8dd$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $5fd79752fd50c8dd$var$hide
};




var $dc82db6162dc1c2f$export$d34966752335dd47 = [
    (0, $bf789ed0abaa3eab$export$2e2bcd8739ae039),
    (0, $f7143f4a5a7dc0a7$export$2e2bcd8739ae039),
    (0, $2a1b164d645419aa$export$2e2bcd8739ae039),
    (0, $31b8db5006cb8311$export$2e2bcd8739ae039),
    (0, $ac59f33800dc30d0$export$2e2bcd8739ae039),
    (0, $e9e2813ecb12cd1e$export$2e2bcd8739ae039),
    (0, $50d8fed428e1ca83$export$2e2bcd8739ae039),
    (0, $ca2109fec2a0262e$export$2e2bcd8739ae039),
    (0, $5fd79752fd50c8dd$export$2e2bcd8739ae039)
];
var $dc82db6162dc1c2f$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $edc25aa6a25ffabb$export$ed5e13716264f202)({
    defaultModifiers: $dc82db6162dc1c2f$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules





var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");
"use client";
function $46ca2500633dfaec$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $46ca2500633dfaec$export$602eac185826482c = /*#__PURE__*/ $f2Y41.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $f2Y41.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(/*#__PURE__*/ $f2Y41.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($46ca2500633dfaec$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $89e0f791fe6ff375$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $89e0f791fe6ff375$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $f2Y41.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $f2Y41.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ge3KO.jsx)($f2Y41.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f2Y41.Fragment, {
        children: mountNode ? /*#__PURE__*/ $5021361ff788fb77$exports.createPortal(children, mountNode) : mountNode
    });
});



const $5c4080eea2a15dc4$var$GLOBAL_CLASS_PREFIX = "base";
function $5c4080eea2a15dc4$var$buildStateClass(state) {
    return `${$5c4080eea2a15dc4$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $5c4080eea2a15dc4$var$buildSlotClass(componentName, slot) {
    return `${$5c4080eea2a15dc4$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $5c4080eea2a15dc4$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $bd62ffdd337a5f37$export$9d6b9120de57c54)[slot];
    return globalStateClass ? $5c4080eea2a15dc4$var$buildStateClass(globalStateClass) : $5c4080eea2a15dc4$var$buildSlotClass(componentName, slot);
}
function $5c4080eea2a15dc4$export$34c0130b1f3e8ae3(slot) {
    return (0, $bd62ffdd337a5f37$export$9d6b9120de57c54)[slot] !== undefined;
}



function $e409dc8aaf688b1f$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $5c4080eea2a15dc4$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $555aba44e831a950$var$COMPONENT_NAME = "Popper";
function $555aba44e831a950$export$1b69b6cd0fa638a1(slot) {
    return (0, $5c4080eea2a15dc4$export$1d132570e11858b0)($555aba44e831a950$var$COMPONENT_NAME, slot);
}
const $555aba44e831a950$export$b6aa214021e734b0 = (0, $e409dc8aaf688b1f$export$de4f15803c389669)($555aba44e831a950$var$COMPONENT_NAME, [
    "root"
]);



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");


var $asN9r = parcelRequire("asN9r");

function $96f0d45fc1553f60$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $4d97b08b1822aa9b$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $asN9r.default)({}, otherProps, {
        ownerState: (0, $asN9r.default)({}, otherProps.ownerState, ownerState)
    });
}



var $asN9r = parcelRequire("asN9r");

/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $6d542b62ee05ff94$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $18a7997601ec618d$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $875e5e431946caaa$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $asN9r.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $asN9r.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $6d542b62ee05ff94$export$24d5698b57eff81c)((0, $asN9r.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $18a7997601ec618d$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $18a7997601ec618d$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $asN9r.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $asN9r.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $30d77110231590d4$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $24a0362e4a254e17$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $24a0362e4a254e17$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $bKcdJ.default)(parameters, $24a0362e4a254e17$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $30d77110231590d4$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $875e5e431946caaa$export$b01d1e419b049226)((0, $asN9r.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $96f0d45fc1553f60$export$b089efb01a7bdf50)(elementType, (0, $asN9r.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $f2Y41 = parcelRequire("f2Y41");

var $ge3KO = parcelRequire("ge3KO");
"use client";
const $a74fa00177c0d9e2$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $a74fa00177c0d9e2$var$ClassNameConfiguratorContext = /*#__PURE__*/ $f2Y41.createContext($a74fa00177c0d9e2$var$defaultContextValue);
function $a74fa00177c0d9e2$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $f2Y41.useContext($a74fa00177c0d9e2$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $a74fa00177c0d9e2$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $f2Y41.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($a74fa00177c0d9e2$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $b9f04fd7a0a597ee$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $b9f04fd7a0a597ee$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $b9f04fd7a0a597ee$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $b9f04fd7a0a597ee$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $b9f04fd7a0a597ee$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $b9f04fd7a0a597ee$var$isVirtualElement(element) {
    return !$b9f04fd7a0a597ee$var$isHTMLElement(element);
}
const $b9f04fd7a0a597ee$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $a74fa00177c0d9e2$export$b0f7603cd2f9ee15)((0, $555aba44e831a950$export$1b69b6cd0fa638a1)));
};
const $b9f04fd7a0a597ee$var$defaultPopperOptions = {};
const $b9f04fd7a0a597ee$var$PopperTooltip = /*#__PURE__*/ $f2Y41.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $bKcdJ.default)(props, $b9f04fd7a0a597ee$var$_excluded);
    const tooltipRef = $f2Y41.useRef(null);
    const ownRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $f2Y41.useRef(null);
    const handlePopperRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $f2Y41.useRef(handlePopperRef);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $f2Y41.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $b9f04fd7a0a597ee$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $f2Y41.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $f2Y41.useState($b9f04fd7a0a597ee$var$resolveAnchorEl(anchorEl));
    $f2Y41.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $f2Y41.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($b9f04fd7a0a597ee$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $dc82db6162dc1c2f$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $asN9r.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $b9f04fd7a0a597ee$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)(Root, (0, $asN9r.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $b9f04fd7a0a597ee$export$badac9ada3a0bdf9 = /*#__PURE__*/ $f2Y41.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $b9f04fd7a0a597ee$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $bKcdJ.default)(props, $b9f04fd7a0a597ee$var$_excluded2);
    const [exited, setExited] = $f2Y41.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $b9f04fd7a0a597ee$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $b9f04fd7a0a597ee$var$isHTMLElement(resolvedAnchorEl) ? (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $46ca2500633dfaec$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($b9f04fd7a0a597ee$var$PopperTooltip, (0, $asN9r.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $asN9r.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});


var $bf15813490697af2$exports = {};
"use strict";
"use client";
Object.defineProperty($bf15813490697af2$exports, "__esModule", {
    value: true
});
$bf15813490697af2$exports.default = void 0;

var $bf15813490697af2$var$React = $bf15813490697af2$var$_interopRequireWildcard((parcelRequire("f2Y41")));
parcelRequire("jvVhJ");
var $jZjY3 = parcelRequire("jZjY3");
function $bf15813490697af2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bf15813490697af2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $bf15813490697af2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $bf15813490697af2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $bf15813490697af2$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $bf15813490697af2$var$useTheme(defaultTheme = null) {
    const contextTheme = $bf15813490697af2$var$React.useContext($jZjY3.T);
    return !contextTheme || $bf15813490697af2$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $bf15813490697af2$var$_default = $bf15813490697af2$exports.default = $bf15813490697af2$var$useTheme;






var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
const $f1981fac35ac3785$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $f1981fac35ac3785$var$PopperRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $b9f04fd7a0a597ee$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $f1981fac35ac3785$var$Popper = /*#__PURE__*/ $f2Y41.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($bf15813490697af2$exports)))();
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $bKcdJ.default)(props, $f1981fac35ac3785$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $asN9r.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f1981fac35ac3785$var$PopperRoot, (0, $asN9r.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $f1981fac35ac3785$export$2e2bcd8739ae039 = $f1981fac35ac3785$var$Popper;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








function $4fd5901f71aa5ebe$export$6816d4fc0981ec7(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiListSubheader", slot);
}
const $4fd5901f71aa5ebe$var$listSubheaderClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $4fd5901f71aa5ebe$export$2e2bcd8739ae039 = $4fd5901f71aa5ebe$var$listSubheaderClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $479a7dc070e66170$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $479a7dc070e66170$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $4fd5901f71aa5ebe$export$6816d4fc0981ec7), classes);
};
const $479a7dc070e66170$var$ListSubheaderRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $479a7dc070e66170$var$ListSubheader = /*#__PURE__*/ $f2Y41.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $bKcdJ.default)(props, $479a7dc070e66170$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $479a7dc070e66170$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($479a7dc070e66170$var$ListSubheaderRoot, (0, $asN9r.default)({
        as: component,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$479a7dc070e66170$var$ListSubheader.muiSkipListHighlight = true;
var $479a7dc070e66170$export$2e2bcd8739ae039 = $479a7dc070e66170$var$ListSubheader;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");







// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $c488d803c77ea0a3$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $c488d803c77ea0a3$export$2e2bcd8739ae039 = $c488d803c77ea0a3$var$getOverlayAlpha;






function $7b877db1b813bf60$export$29cdb466b9b6f20b(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiPaper", slot);
}
const $7b877db1b813bf60$var$paperClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $7b877db1b813bf60$export$2e2bcd8739ae039 = $7b877db1b813bf60$var$paperClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $641b436f34e2d9e2$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $641b436f34e2d9e2$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $7b877db1b813bf60$export$29cdb466b9b6f20b), classes);
};
const $641b436f34e2d9e2$var$PaperRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $asN9r.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $asN9r.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $dee2dd5afa9d03f4$exports.alpha)("#fff", (0, $c488d803c77ea0a3$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $dee2dd5afa9d03f4$exports.alpha)("#fff", (0, $c488d803c77ea0a3$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $641b436f34e2d9e2$var$Paper = /*#__PURE__*/ $f2Y41.forwardRef(function Paper(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $bKcdJ.default)(props, $641b436f34e2d9e2$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $641b436f34e2d9e2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($641b436f34e2d9e2$var$PaperRoot, (0, $asN9r.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other));
});
var $641b436f34e2d9e2$export$2e2bcd8739ae039 = $641b436f34e2d9e2$var$Paper;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");









"use client";
var $61987fa9c93c65fe$export$2e2bcd8739ae039 = (0, $b8da6eb696d47660$export$2e2bcd8739ae039);



var $f2Y41 = parcelRequire("f2Y41");

"use client";
let $20dde4d744df916b$var$hadKeyboardEvent = true;
let $20dde4d744df916b$var$hadFocusVisibleRecently = false;
const $20dde4d744df916b$var$hadFocusVisibleRecentlyTimeout = new (0, $7982601b7fbfa734$export$786b4da70f00938b)();
const $20dde4d744df916b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $20dde4d744df916b$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $20dde4d744df916b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $20dde4d744df916b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $20dde4d744df916b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $20dde4d744df916b$var$handlePointerDown() {
    $20dde4d744df916b$var$hadKeyboardEvent = false;
}
function $20dde4d744df916b$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($20dde4d744df916b$var$hadFocusVisibleRecently) $20dde4d744df916b$var$hadKeyboardEvent = true;
    }
}
function $20dde4d744df916b$var$prepare(doc) {
    doc.addEventListener("keydown", $20dde4d744df916b$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $20dde4d744df916b$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $20dde4d744df916b$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $20dde4d744df916b$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $20dde4d744df916b$var$handleVisibilityChange, true);
}
function $20dde4d744df916b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $20dde4d744df916b$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $20dde4d744df916b$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $20dde4d744df916b$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $20dde4d744df916b$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $20dde4d744df916b$var$handleVisibilityChange, true);
}
function $20dde4d744df916b$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $20dde4d744df916b$var$hadKeyboardEvent || $20dde4d744df916b$var$focusTriggersKeyboardModality(target);
}
function $20dde4d744df916b$export$2e2bcd8739ae039() {
    const ref = $f2Y41.useCallback((node)=>{
        if (node != null) $20dde4d744df916b$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $f2Y41.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $20dde4d744df916b$var$hadFocusVisibleRecently = true;
            $20dde4d744df916b$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $20dde4d744df916b$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($20dde4d744df916b$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $8b351fb7b939ea19$export$2e2bcd8739ae039 = (0, $20dde4d744df916b$export$2e2bcd8739ae039);



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");


function $c667c70d22b9c5fb$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $888a480a6b8ed2ee$export$2e2bcd8739ae039)(subClass, superClass);
}




var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
var $3d14d57129272124$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext(null);



var $f2Y41 = parcelRequire("f2Y41");
function $8ada48a990ac5d55$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $f2Y41.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $f2Y41.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $8ada48a990ac5d55$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $8ada48a990ac5d55$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $8ada48a990ac5d55$export$fa71e2345c31d7a2(props, onExited) {
    return $8ada48a990ac5d55$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $f2Y41.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $8ada48a990ac5d55$var$getProp(child, "appear", props),
            enter: $8ada48a990ac5d55$var$getProp(child, "enter", props),
            exit: $8ada48a990ac5d55$var$getProp(child, "exit", props)
        });
    });
}
function $8ada48a990ac5d55$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $8ada48a990ac5d55$export$bbc8a025727ea824(nextProps.children);
    var children = $8ada48a990ac5d55$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $f2Y41.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $f2Y41.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $f2Y41.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $8ada48a990ac5d55$var$getProp(child, "exit", nextProps),
            enter: $8ada48a990ac5d55$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $f2Y41.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $f2Y41.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $f2Y41.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $8ada48a990ac5d55$var$getProp(child, "exit", nextProps),
            enter: $8ada48a990ac5d55$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $dc1f8d071e4a3207$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $dc1f8d071e4a3207$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $dc1f8d071e4a3207$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $c667c70d22b9c5fb$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3de3f998b209e608$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $8ada48a990ac5d55$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $8ada48a990ac5d55$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $8ada48a990ac5d55$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $asN9r.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $bKcdJ.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $dc1f8d071e4a3207$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $3d14d57129272124$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $3d14d57129272124$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Component);
$dc1f8d071e4a3207$var$TransitionGroup.propTypes = {};
$dc1f8d071e4a3207$var$TransitionGroup.defaultProps = $dc1f8d071e4a3207$var$defaultProps;
var $dc1f8d071e4a3207$export$2e2bcd8739ae039 = $dc1f8d071e4a3207$var$TransitionGroup;




var $jvVhJ = parcelRequire("jvVhJ");




var $f2Y41 = parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
"use client";
function $4e108cb07a92cd07$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $f2Y41.useState(false);
    const rippleClassName = (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $f2Y41.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
            className: childClassName
        })
    });
}
var $4e108cb07a92cd07$export$2e2bcd8739ae039 = $4e108cb07a92cd07$var$Ripple;




function $27765976fc96e10b$export$b464606f735ab902(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiTouchRipple", slot);
}
const $27765976fc96e10b$var$touchRippleClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $27765976fc96e10b$export$2e2bcd8739ae039 = $27765976fc96e10b$var$touchRippleClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $4420589b79006284$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $4420589b79006284$var$_ = (t)=>t, $4420589b79006284$var$_t, $4420589b79006284$var$_t2, $4420589b79006284$var$_t3, $4420589b79006284$var$_t4;
const $4420589b79006284$var$DURATION = 550;
const $4420589b79006284$export$95d0c9356b2231a3 = 80;
const $4420589b79006284$var$enterKeyframe = (0, $jvVhJ.keyframes)($4420589b79006284$var$_t || ($4420589b79006284$var$_t = $4420589b79006284$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $4420589b79006284$var$exitKeyframe = (0, $jvVhJ.keyframes)($4420589b79006284$var$_t2 || ($4420589b79006284$var$_t2 = $4420589b79006284$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $4420589b79006284$var$pulsateKeyframe = (0, $jvVhJ.keyframes)($4420589b79006284$var$_t3 || ($4420589b79006284$var$_t3 = $4420589b79006284$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $4420589b79006284$export$f6b7418508c72c25 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $4420589b79006284$export$676cfe7b12693c4b = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $4e108cb07a92cd07$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($4420589b79006284$var$_t4 || ($4420589b79006284$var$_t4 = $4420589b79006284$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $27765976fc96e10b$export$2e2bcd8739ae039).rippleVisible, $4420589b79006284$var$enterKeyframe, $4420589b79006284$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $27765976fc96e10b$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $27765976fc96e10b$export$2e2bcd8739ae039).child, (0, $27765976fc96e10b$export$2e2bcd8739ae039).childLeaving, $4420589b79006284$var$exitKeyframe, $4420589b79006284$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $27765976fc96e10b$export$2e2bcd8739ae039).childPulsate, $4420589b79006284$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $4420589b79006284$var$TouchRipple = /*#__PURE__*/ $f2Y41.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $bKcdJ.default)(props, $4420589b79006284$var$_excluded);
    const [ripples, setRipples] = $f2Y41.useState([]);
    const nextKey = $f2Y41.useRef(0);
    const rippleCallback = $f2Y41.useRef(null);
    $f2Y41.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $f2Y41.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $f2Y41.useRef(null);
    const container = $f2Y41.useRef(null);
    const startCommit = $f2Y41.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ge3KO.jsx)($4420589b79006284$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.ripple, (0, $27765976fc96e10b$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $27765976fc96e10b$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $27765976fc96e10b$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.child, (0, $27765976fc96e10b$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.childLeaving, (0, $27765976fc96e10b$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.childPulsate, (0, $27765976fc96e10b$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $4420589b79006284$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $f2Y41.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($4420589b79006284$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $f2Y41.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $f2Y41.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $f2Y41.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($4420589b79006284$export$f6b7418508c72c25, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)((0, $27765976fc96e10b$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dc1f8d071e4a3207$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $4420589b79006284$export$2e2bcd8739ae039 = $4420589b79006284$var$TouchRipple;




function $7b737c135b79bb37$export$fccb0498dcd99783(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiButtonBase", slot);
}
const $7b737c135b79bb37$var$buttonBaseClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $7b737c135b79bb37$export$2e2bcd8739ae039 = $7b737c135b79bb37$var$buttonBaseClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $1e60465a41fa8bc1$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $1e60465a41fa8bc1$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $7b737c135b79bb37$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $1e60465a41fa8bc1$export$7ec0dcc5e3cdcd36 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $7b737c135b79bb37$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $1e60465a41fa8bc1$var$ButtonBase = /*#__PURE__*/ $f2Y41.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $bKcdJ.default)(props, $1e60465a41fa8bc1$var$_excluded);
    const buttonRef = $f2Y41.useRef(null);
    const rippleRef = $f2Y41.useRef(null);
    const handleRippleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $8b351fb7b939ea19$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $f2Y41.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $f2Y41.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $f2Y41.useState(false);
    $f2Y41.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $f2Y41.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $61987fa9c93c65fe$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $61987fa9c93c65fe$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $f2Y41.useRef(false);
    const handleKeyDown = (0, $61987fa9c93c65fe$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $61987fa9c93c65fe$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $asN9r.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $1e60465a41fa8bc1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($1e60465a41fa8bc1$export$7ec0dcc5e3cdcd36, (0, $asN9r.default)({
        as: ComponentProp,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ge3KO.jsx)((0, $4420589b79006284$export$2e2bcd8739ae039), (0, $asN9r.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $1e60465a41fa8bc1$export$2e2bcd8739ae039 = $1e60465a41fa8bc1$var$ButtonBase;





function $31db0b0020852c31$export$5e8702d71474f093(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiIconButton", slot);
}
const $31db0b0020852c31$var$iconButtonClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $31db0b0020852c31$export$2e2bcd8739ae039 = $31db0b0020852c31$var$iconButtonClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $f3e02ef6e96bfc63$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $f3e02ef6e96bfc63$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $31db0b0020852c31$export$5e8702d71474f093), classes);
};
const $f3e02ef6e96bfc63$var$IconButtonRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $1e60465a41fa8bc1$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $asN9r.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $asN9r.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $asN9r.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $31db0b0020852c31$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f3e02ef6e96bfc63$var$IconButton = /*#__PURE__*/ $f2Y41.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $bKcdJ.default)(props, $f3e02ef6e96bfc63$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $f3e02ef6e96bfc63$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f3e02ef6e96bfc63$var$IconButtonRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $f3e02ef6e96bfc63$export$2e2bcd8739ae039 = $f3e02ef6e96bfc63$var$IconButton;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




parcelRequire("f2Y41");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");








function $6381d7f384f542cb$export$c7c50641356bdfa5(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiSvgIcon", slot);
}
const $6381d7f384f542cb$var$svgIconClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $6381d7f384f542cb$export$2e2bcd8739ae039 = $6381d7f384f542cb$var$svgIconClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $8a5e400acba19c00$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $8a5e400acba19c00$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $6381d7f384f542cb$export$c7c50641356bdfa5), classes);
};
const $8a5e400acba19c00$var$SvgIconRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $8a5e400acba19c00$var$SvgIcon = /*#__PURE__*/ $f2Y41.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $bKcdJ.default)(props, $8a5e400acba19c00$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $f2Y41.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $8a5e400acba19c00$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($8a5e400acba19c00$var$SvgIconRoot, (0, $asN9r.default)({
        as: component,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$8a5e400acba19c00$var$SvgIcon.muiName = "SvgIcon";
var $8a5e400acba19c00$export$2e2bcd8739ae039 = $8a5e400acba19c00$var$SvgIcon;



var $ge3KO = parcelRequire("ge3KO");
"use client";
function $8fda59987ff84c61$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a5e400acba19c00$export$2e2bcd8739ae039), (0, $asN9r.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $8a5e400acba19c00$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $f2Y41.memo(/*#__PURE__*/ $f2Y41.forwardRef(Component));
}



var $ge3KO = parcelRequire("ge3KO");
"use client";
var $277c66dec3c3a86a$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");










function $1330082cb1cfffbd$export$31444911e4ee6fdd(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiChip", slot);
}
const $1330082cb1cfffbd$var$chipClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $1330082cb1cfffbd$export$2e2bcd8739ae039 = $1330082cb1cfffbd$var$chipClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $4ba053864d7f4c37$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $4ba053864d7f4c37$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            "label",
            `label${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(variant)}Color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $1330082cb1cfffbd$export$31444911e4ee6fdd), classes);
};
const $4ba053864d7f4c37$var$ChipRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(variant)}Color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $asN9r.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).icon}`]: (0, $asN9r.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $asN9r.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: (0, $asN9r.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $1330082cb1cfffbd$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $4ba053864d7f4c37$var$ChipLabel = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $4ba053864d7f4c37$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $4ba053864d7f4c37$var$Chip = /*#__PURE__*/ $f2Y41.forwardRef(function Chip(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $bKcdJ.default)(props, $4ba053864d7f4c37$var$_excluded);
    const chipRef = $f2Y41.useRef(null);
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $4ba053864d7f4c37$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $4ba053864d7f4c37$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $1e60465a41fa8bc1$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $asN9r.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $f2Y41.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $4ba053864d7f4c37$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $1e60465a41fa8bc1$export$2e2bcd8739ae039) ? (0, $asN9r.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $f2Y41.isValidElement(deleteIconProp) ? /*#__PURE__*/ $f2Y41.cloneElement(deleteIconProp, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ge3KO.jsx)((0, $277c66dec3c3a86a$export$2e2bcd8739ae039), {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $f2Y41.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $f2Y41.cloneElement(avatarProp, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $f2Y41.isValidElement(iconProp)) icon = /*#__PURE__*/ $f2Y41.cloneElement(iconProp, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($4ba053864d7f4c37$var$ChipRoot, (0, $asN9r.default)({
        as: component,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ge3KO.jsx)($4ba053864d7f4c37$var$ChipLabel, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $4ba053864d7f4c37$export$2e2bcd8739ae039 = $4ba053864d7f4c37$var$Chip;



var $asN9r = parcelRequire("asN9r");



function $1667ac5b9922e98c$export$cdb270390122322b(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiInput", slot);
}
const $1667ac5b9922e98c$var$inputClasses = (0, $asN9r.default)({}, (0, $3879b8acfd0d0428$export$2e2bcd8739ae039), (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $1667ac5b9922e98c$export$2e2bcd8739ae039 = $1667ac5b9922e98c$var$inputClasses;




var $asN9r = parcelRequire("asN9r");



function $5472b43da99cd994$export$89922944c7227687(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiOutlinedInput", slot);
}
const $5472b43da99cd994$var$outlinedInputClasses = (0, $asN9r.default)({}, (0, $3879b8acfd0d0428$export$2e2bcd8739ae039), (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $5472b43da99cd994$export$2e2bcd8739ae039 = $5472b43da99cd994$var$outlinedInputClasses;



var $asN9r = parcelRequire("asN9r");



function $98404974968caf68$export$3331e419f1a48437(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiFilledInput", slot);
}
const $98404974968caf68$var$filledInputClasses = (0, $asN9r.default)({}, (0, $3879b8acfd0d0428$export$2e2bcd8739ae039), (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $98404974968caf68$export$2e2bcd8739ae039 = $98404974968caf68$var$filledInputClasses;


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $84e1b7df1e0ed30f$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $c9fe8a8d8bc68788$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");




function $a9e911e8634675ad$export$ff8356348e0cc878(name) {
    return 0, $b7748db3784530dd$export$2e2bcd8739ae039;
}




function $a89a1f33c92e9424$export$8ee01529667e66d9(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiAutocomplete", slot);
}
const $a89a1f33c92e9424$var$autocompleteClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $a89a1f33c92e9424$export$2e2bcd8739ae039 = $a89a1f33c92e9424$var$autocompleteClasses;





var $ge3KO = parcelRequire("ge3KO");
"use client";
var $ed33687cff4d0a4c$var$_ClearIcon, $ed33687cff4d0a4c$var$_ArrowDropDownIcon;
const $ed33687cff4d0a4c$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $ed33687cff4d0a4c$var$_excluded2 = [
    "ref"
];
const $ed33687cff4d0a4c$var$useThemeProps = (0, $a9e911e8634675ad$export$ff8356348e0cc878)("MuiAutocomplete");
const $ed33687cff4d0a4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $a89a1f33c92e9424$export$8ee01529667e66d9), classes);
};
const $ed33687cff4d0a4c$var$AutocompleteRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).focused} .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: "visible"
    },
    /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
        [`&:hover .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        }
    },
    [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: "calc(100% - 6px)"
    },
    [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).inputRoot}`]: {
        flexWrap: "wrap",
        [`.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        "& .MuiInput-input": {
            padding: "4px 4px 4px 0px"
        }
    },
    [`& .${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).root}.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).input}`]: {
            padding: "2px 4px 3px 0"
        }
    },
    [`& .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
            padding: "7.5px 4px 7.5px 5px"
        },
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).root}.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px 2.5px 8px"
        }
    },
    [`& .${(0, $98404974968caf68$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $98404974968caf68$export$2e2bcd8739ae039).input}`]: {
            padding: "7px 4px"
        },
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $98404974968caf68$export$2e2bcd8739ae039).root}.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $98404974968caf68$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px"
        }
    },
    [`& .${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $98404974968caf68$export$2e2bcd8739ae039).root}.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $98404974968caf68$export$2e2bcd8739ae039).root}.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).hiddenLabel}.${(0, $3879b8acfd0d0428$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: "ellipsis",
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: "calc(100% - 4px)"
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        }
    ]
});
const $ed33687cff4d0a4c$var$AutocompleteEndAdornment = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -50%)"
});
const $ed33687cff4d0a4c$var$AutocompleteClearIndicator = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $ed33687cff4d0a4c$var$AutocompletePopupIndicator = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $asN9r.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: "rotate(180deg)"
            }
        }
    ]
});
const $ed33687cff4d0a4c$var$AutocompletePopper = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f1981fac35ac3785$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: "absolute"
                }
            }
        ]
    }));
const $ed33687cff4d0a4c$var$AutocompletePaper = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $641b436f34e2d9e2$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $asN9r.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $ed33687cff4d0a4c$var$AutocompleteLoading = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $ed33687cff4d0a4c$var$AutocompleteNoOptions = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $ed33687cff4d0a4c$var$AutocompleteListbox = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $ed33687cff4d0a4c$var$AutocompleteGroupLabel = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $479a7dc070e66170$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $ed33687cff4d0a4c$var$AutocompleteGroupUl = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $a89a1f33c92e9424$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $ed33687cff4d0a4c$var$Autocomplete = /*#__PURE__*/ $f2Y41.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = $ed33687cff4d0a4c$var$useThemeProps({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $ed33687cff4d0a4c$var$_ClearIcon || ($ed33687cff4d0a4c$var$_ClearIcon = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $84e1b7df1e0ed30f$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $641b436f34e2d9e2$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $f1981fac35ac3785$export$2e2bcd8739ae039), popupIcon: popupIcon = $ed33687cff4d0a4c$var$_ArrowDropDownIcon || ($ed33687cff4d0a4c$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c9fe8a8d8bc68788$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $bKcdJ.default)(props, $ed33687cff4d0a4c$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $280f1223365e8458$export$1e40b3ca02d92d21)((0, $asN9r.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $bKcdJ.default)(_getListboxProps, $ed33687cff4d0a4c$var$_excluded2);
    const combinedListboxRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $asN9r.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $ed33687cff4d0a4c$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $asN9r.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $4ba053864d7f4c37$export$2e2bcd8739ae039), (0, $asN9r.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        return /*#__PURE__*/ (0, $f2Y41.createElement)("li", (0, $asN9r.default)({}, props2, {
            key: props2.key
        }), getOptionLabel(option));
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $asN9r.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    const renderAutocompletePopperChildren = (children)=>/*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompletePopper, (0, $asN9r.default)({
            as: PopperComponent,
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            ownerState: ownerState,
            role: "presentation",
            anchorEl: anchorEl,
            open: popupOpen
        }, popperSlotProps, {
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
            children: /*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompletePaper, (0, $asN9r.default)({
                ownerState: ownerState,
                as: PaperComponent
            }, paperSlotProps, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                children: children
            }))
        }));
    let autocompletePopper = null;
    if (groupedOptions.length > 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteListbox, (0, $asN9r.default)({
        as: ListboxComponent,
        className: classes.listbox,
        ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
        ref: combinedListboxRef,
        children: groupedOptions.map((option, index)=>{
            if (groupBy) return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
            });
            return renderListOption(option, index);
        })
    })));
    else if (loading && groupedOptions.length === 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteLoading, {
        className: classes.loading,
        ownerState: ownerState,
        children: loadingText
    }));
    else if (groupedOptions.length === 0 && !freeSolo && !loading) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteNoOptions, {
        className: classes.noOptions,
        ownerState: ownerState,
        role: "presentation",
        onMouseDown: (event)=>{
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
        },
        children: noOptionsText
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteRoot, (0, $asN9r.default)({
                ref: ref,
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $asN9r.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ge3KO.jsxs)($ed33687cff4d0a4c$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompleteClearIndicator, (0, $asN9r.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ge3KO.jsx)($ed33687cff4d0a4c$var$AutocompletePopupIndicator, (0, $asN9r.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $asN9r.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? autocompletePopper : null
        ]
    });
});
var $ed33687cff4d0a4c$export$2e2bcd8739ae039 = $ed33687cff4d0a4c$var$Autocomplete;





var $ge3KO = parcelRequire("ge3KO");
const $c064f2c4f98a101c$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
function $c064f2c4f98a101c$export$fec959c3691e0645(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant } = props, other = (0, $bKcdJ.default)(props, $c064f2c4f98a101c$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const [filterValueState, setFilterValueState] = $f2Y41.useState(item.value || []);
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    $f2Y41.useEffect(()=>{
        const itemValue = item.value ?? [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $f2Y41.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $asN9r.default)({}, item, {
            value: [
                ...value
            ]
        }));
    }, [
        applyValue,
        item
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ed33687cff4d0a4c$export$2e2bcd8739ae039), (0, $asN9r.default)({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue: inputValue } = params;
            return inputValue == null || inputValue === "" ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseChip, (0, $asN9r.default)({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, getTagProps({
                    index: index
                })))),
        renderInput: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTextField, (0, $asN9r.default)({}, params, {
                label: apiRef.current.getLocaleText("filterPanelInputLabel"),
                placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
                InputLabelProps: (0, $asN9r.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || "text"
            }, TextFieldProps, rootProps.slotProps?.baseTextField))
    }, other));
}



var $asN9r = parcelRequire("asN9r");
/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $7c6ca0d6d67acde3$export$90be184ccbab1c7a = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($7c6ca0d6d67acde3$export$90be184ccbab1c7a || {});



const $26effb3530f86687$export$7ea23129b8e10cdb = ()=>({
        items: [],
        logicOperator: (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And
    }); /**
 * @param {GridRowId} rowId The id of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 */  /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ 



function $bdaf3f2601b2042f$export$fbb0da9fc679f98a(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}



let $6989b4da95410729$var$hasEval;
function $6989b4da95410729$var$getHasEval() {
    if ($6989b4da95410729$var$hasEval !== undefined) return $6989b4da95410729$var$hasEval;
    try {
        $6989b4da95410729$var$hasEval = new Function("return true")();
    } catch (_) {
        $6989b4da95410729$var$hasEval = false;
    }
    return $6989b4da95410729$var$hasEval;
}
const $6989b4da95410729$export$eb76493d113de092 = (item, apiRef)=>{
    const cleanItem = (0, $asN9r.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const $6989b4da95410729$var$filterModelDisableMultiColumnsFilteringWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.",
    "If you are using the community version of the `DataGrid`, this prop is always `true`."
], "error");
const $6989b4da95410729$var$filterModelMissingItemIdWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)("MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.", "error");
const $6989b4da95410729$var$filterModelMissingItemOperatorWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)("MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.", "error");
const $6989b4da95410729$export$2a370a0aad2ac7e1 = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        $6989b4da95410729$var$filterModelDisableMultiColumnsFilteringWarning();
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemsWithoutIds) $6989b4da95410729$var$filterModelMissingItemIdWarning();
    if (hasItemWithoutOperator) $6989b4da95410729$var$filterModelMissingItemOperatorWarning();
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $asN9r.default)({}, model, {
        items: items.map((item)=>$6989b4da95410729$export$eb76493d113de092(item, apiRef))
    });
    if (model.items !== items) return (0, $asN9r.default)({}, model, {
        items: items
    });
    return model;
};
const $6989b4da95410729$export$f4189e6c713e6dd8 = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $asN9r.default)({}, filteringState, {
            filterModel: $6989b4da95410729$export$2a370a0aad2ac7e1(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const $6989b4da95410729$export$626da389515c02b3 = (value)=>{
    if (typeof value === "string") return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return value;
};
const $6989b4da95410729$var$getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? filterItem.value?.map((x)=>parser(x, undefined, column, apiRef)) : parser(filterItem.value, undefined, column, apiRef);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $6989b4da95410729$export$626da389515c02b3(parsedValue);
    const newFilterItem = (0, $asN9r.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!filterOperators?.length) throw new Error(`MUI X: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI X: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const publicApiRef = (0, $bdaf3f2601b2042f$export$fbb0da9fc679f98a)(apiRef);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== "function") return null;
    return {
        item: newFilterItem,
        fn: (row)=>{
            let value = apiRef.current.getRowValue(row, column);
            if (ignoreDiacritics) value = $6989b4da95410729$export$626da389515c02b3(value);
            return applyFilterOnRow(value, row, column, publicApiRef);
        }
    };
};
let $6989b4da95410729$var$filterItemsApplierId = 1;
/**
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $6989b4da95410729$var$buildAggregatedFilterItemsApplier = (filterModel, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$6989b4da95410729$var$getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$6989b4da95410729$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.fn(row);
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, for example `{ [dynamicKey]: value }`.
    const filterItemCore = new Function("appliers", "row", "shouldApplyFilter", `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join("\n")}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i} ? false : appliers[${i}].fn(row),`).join("\n")}
};

return result$$;`.replaceAll("$$", String($6989b4da95410729$var$filterItemsApplierId)));
    $6989b4da95410729$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(appliers, row, shouldApplyItem);
    return filterItem;
};
const $6989b4da95410729$export$cabca178b367efe0 = (filterModel)=>{
    return filterModel.quickFilterExcludeHiddenColumns ?? true;
};
/**
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $6989b4da95410729$var$buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    const quickFilterValues = filterModel.quickFilterValues?.filter(Boolean) ?? [];
    if (quickFilterValues.length === 0) return null;
    const columnFields = $6989b4da95410729$export$cabca178b367efe0(filterModel) ? (0, $b22d10f7b8994eba$export$c9491722e1d6e8d3)(apiRef) : (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $bdaf3f2601b2042f$export$fbb0da9fc679f98a)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column?.getApplyQuickFilterFn;
        if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $6989b4da95410729$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        /* eslint-disable no-restricted-syntax, no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = apiRef.current.getRowValue(row, column);
                if (applier.fn === null) continue;
                if (ignoreDiacritics) value = $6989b4da95410729$export$626da389515c02b3(value);
                const isMatching = applier.fn(value, row, column, publicApiRef);
                if (isMatching) {
                    result[filterValue] = true;
                    continue outer;
                }
            }
            result[filterValue] = false;
        }
        /* eslint-enable no-restricted-syntax, no-labels */ return result;
    };
};
const $6989b4da95410729$export$1c795c7c9654905e = (filterModel, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $6989b4da95410729$var$buildAggregatedFilterItemsApplier(filterModel, apiRef, disableEval);
    const isRowMatchingQuickFilter = $6989b4da95410729$var$buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        result.passingFilterItems = isRowMatchingFilterItems?.(row, shouldApplyFilter) ?? null;
        result.passingQuickFilterValues = isRowMatchingQuickFilter?.(row, shouldApplyFilter) ?? null;
    };
};
const $6989b4da95410729$var$isNotNull = (result)=>result != null;
const $6989b4da95410729$var$filterModelItems = (cache, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$6989b4da95410729$var$getFilterCallbackFromItem(item, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $6989b4da95410729$export$8d82b4490466f182 = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache)=>{
    const cleanedFilterItems = $6989b4da95410729$var$filterModelItems(cache, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($6989b4da95410729$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($6989b4da95410729$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = filterModel.logicOperator ?? (0, $26effb3530f86687$export$7ea23129b8e10cdb)().logicOperator;
        if (logicOperator === (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = filterModel.quickFilterLogicOperator ?? (0, $26effb3530f86687$export$7ea23129b8e10cdb)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};


const $83e90461781fd067$export$4326c0ebf0c2f84b = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $2b59f632c4f96fc9$export$7c57da42ce8e346f)(value), "i");
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $6989b4da95410729$export$626da389515c02b3)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
const $83e90461781fd067$export$dff3a5bcde5c5e41 = (disableTrim = false)=>[
        {
            value: "contains",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp((0, $2b59f632c4f96fc9$export$7c57da42ce8e346f)(filterItemValue), "i");
                return (value)=>{
                    return value != null ? filterRegex.test(String(value)) : false;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3)
        },
        {
            value: "equals",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const collator = new Intl.Collator(undefined, {
                    sensitivity: "base",
                    usage: "search"
                });
                return (value)=>{
                    return value != null ? collator.compare(filterItemValue, value.toString()) === 0 : false;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3)
        },
        {
            value: "startsWith",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $2b59f632c4f96fc9$export$7c57da42ce8e346f)(filterItemValue)}.*$`, "i");
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3)
        },
        {
            value: "endsWith",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $2b59f632c4f96fc9$export$7c57da42ce8e346f)(filterItemValue)}$`, "i");
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3)
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value === "" || value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value !== "" && value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isAnyOf",
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: "base",
                    usage: "search"
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || "") === 0;
                    }) : false;
            },
            InputComponent: (0, $c064f2c4f98a101c$export$fec959c3691e0645)
        }
    ];


const $ca322ee82df9e13b$export$db6fa9d0a45573e4 = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    editable: false,
    sortComparator: (0, $c24e05fccf11e052$export$db324d0b741f4529),
    type: "string",
    align: "left",
    filterOperators: (0, $83e90461781fd067$export$dff3a5bcde5c5e41)(),
    renderEditCell: (0, $aebd27a090315feb$export$d1015f41e7e48c2e),
    getApplyQuickFilterFn: (0, $83e90461781fd067$export$4326c0ebf0c2f84b)
};



var $asN9r = parcelRequire("asN9r");




const $e91df4c28077932f$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $e91df4c28077932f$export$78c55b2f3096aac8 = (value)=>{
    if (value == null || Number.isNaN(value) || value === "") return null;
    return (columnValue)=>{
        return $e91df4c28077932f$var$parseNumericValue(columnValue) === $e91df4c28077932f$var$parseNumericValue(value);
    };
};
const $e91df4c28077932f$export$37d963e5ee49abc6 = ()=>[
        {
            value: "=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $e91df4c28077932f$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: "!=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $e91df4c28077932f$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: ">",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $e91df4c28077932f$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: ">=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $e91df4c28077932f$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: "<",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $e91df4c28077932f$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: "<=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $e91df4c28077932f$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, $64c9f1e3086437a0$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isAnyOf",
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, $c064f2c4f98a101c$export$fec959c3691e0645),
            InputComponentProps: {
                type: "number"
            }
        }
    ];



const $59b5744ace9b4f07$export$ba08f73736670f91 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "number",
    align: "right",
    headerAlign: "right",
    sortComparator: (0, $c24e05fccf11e052$export$ecfdaa3722003888),
    valueParser: (value)=>value === "" ? null : Number(value),
    valueFormatter: (value)=>(0, $2b59f632c4f96fc9$export$7e4aa119212bc614)(value) ? value.toLocaleString() : value || "",
    filterOperators: (0, $e91df4c28077932f$export$37d963e5ee49abc6)(),
    getApplyQuickFilterFn: (0, $e91df4c28077932f$export$78c55b2f3096aac8)
});



var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $0905910566af1164$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $0905910566af1164$var$convertFilterItemValueToInputValue(itemValue, inputType) {
    if (itemValue == null) return "";
    const dateCopy = new Date(itemValue);
    if (Number.isNaN(dateCopy.getTime())) return "";
    if (inputType === "date") return dateCopy.toISOString().substring(0, 10);
    if (inputType === "datetime-local") {
        // The date picker expects the date to be in the local timezone.
        // But .toISOString() converts it to UTC with zero offset.
        // So we need to subtract the timezone offset.
        dateCopy.setMinutes(dateCopy.getMinutes() - dateCopy.getTimezoneOffset());
        return dateCopy.toISOString().substring(0, 19);
    }
    return dateCopy.toISOString().substring(0, 10);
}
function $0905910566af1164$export$f82b14e11ca0a1b4(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, InputProps: InputProps, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $bKcdJ.default)(props, $0905910566af1164$var$_excluded);
    const filterTimeout = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const [filterValueState, setFilterValueState] = $f2Y41.useState(()=>$0905910566af1164$var$convertFilterItemValueToInputValue(item.value, type));
    const [applying, setIsApplying] = $f2Y41.useState(false);
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $f2Y41.useCallback((event)=>{
        filterTimeout.clear();
        const value = event.target.value;
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const date = new Date(value);
            applyValue((0, $asN9r.default)({}, item, {
                value: Number.isNaN(date.getTime()) ? undefined : date
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $f2Y41.useEffect(()=>{
        const value = $0905910566af1164$var$convertFilterItemValueToInputValue(item.value, type);
        setFilterValueState(value);
    }, [
        item.value,
        type
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTextField, (0, $asN9r.default)({
        fullWidth: true,
        id: id,
        label: apiRef.current.getLocaleText("filterPanelInputLabel"),
        placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || "text",
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: (0, $asN9r.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $asN9r.default)({
                max: type === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31",
                tabIndex: tabIndex
            }, InputProps?.inputProps)
        })
    }, other, rootProps.slotProps?.baseTextField));
}


function $3833f97e2932c598$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const date = new Date(filterItem.value);
    if (showTime) date.setSeconds(0, 0);
    else {
        // In GMT-X timezone, the date will be one day behind.
        // For 2022-08-16:
        // GMT+2: Tue Aug 16 2022 02:00:00 GMT+0200
        // GMT-4: Mon Aug 15 2022 20:00:00 GMT-0400
        //
        // We need to add the offset before resetting the hours.
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        date.setHours(0, 0, 0, 0);
    }
    const time = date.getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        if (showTime) dateCopy.setSeconds(0, 0);
        else dateCopy.setHours(0, 0, 0, 0);
        return compareFn(dateCopy.getTime(), time);
    };
}
const $3833f97e2932c598$export$2fa54515db89172d = (showTime)=>[
        {
            value: "is",
            getApplyFilterFn: (filterItem)=>{
                return $3833f97e2932c598$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, $0905910566af1164$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "not",
            getApplyFilterFn: (filterItem)=>{
                return $3833f97e2932c598$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, $0905910566af1164$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "after",
            getApplyFilterFn: (filterItem)=>{
                return $3833f97e2932c598$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, $0905910566af1164$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "onOrAfter",
            getApplyFilterFn: (filterItem)=>{
                return $3833f97e2932c598$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, $0905910566af1164$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "before",
            getApplyFilterFn: (filterItem)=>{
                return $3833f97e2932c598$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, $0905910566af1164$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "onOrBefore",
            getApplyFilterFn: (filterItem)=>{
                return $3833f97e2932c598$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, $0905910566af1164$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $940de6043a3a5604$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const $940de6043a3a5604$var$StyledInputBase = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$2e2bcd8739ae039))({
    fontSize: "inherit"
});
const $940de6043a3a5604$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "editInputCell"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $940de6043a3a5604$export$b4fb7433f4444e3f(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, inputProps: inputProps, onValueChange: onValueChange } = props, other = (0, $bKcdJ.default)(props, $940de6043a3a5604$var$_excluded);
    const isDateTime = colDef.type === "dateTime";
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const inputRef = $f2Y41.useRef();
    const valueTransformed = $f2Y41.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp ?? "").toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = "";
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $f2Y41.useState(valueTransformed);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $940de6043a3a5604$var$useUtilityClasses(ownerState);
    const parseValueToDate = $f2Y41.useCallback((value)=>{
        if (value === "") return null;
        const [date, time] = value.split("T");
        const [year, month, day] = date.split("-");
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(":");
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $f2Y41.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $f2Y41.useEffect(()=>{
        setValueState((state)=>{
            if (valueTransformed.parsed !== state.parsed && valueTransformed.parsed?.getTime() !== state.parsed?.getTime()) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($940de6043a3a5604$var$StyledInputBase, (0, $asN9r.default)({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? "datetime-local" : "date",
        inputProps: (0, $asN9r.default)({
            max: isDateTime ? "9999-12-31T23:59" : "9999-12-31"
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
const $940de6043a3a5604$export$b815d37f7a90225c = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)($940de6043a3a5604$export$b4fb7433f4444e3f, (0, $asN9r.default)({}, params));


function $8a187d58fc9127da$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI X: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        "Use `valueGetter` to transform the value into a `Date` object.",
        `Row ID: ${rowId}, field: "${field}".`
    ].join("\n"));
}
const $8a187d58fc9127da$export$c46cd449e66842a5 = (value, row, column, apiRef)=>{
    if (!value) return "";
    const rowId = apiRef.current.getRowId(row);
    $8a187d58fc9127da$var$throwIfNotDateObject({
        value: value,
        columnType: "date",
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleDateString();
};
const $8a187d58fc9127da$export$a62990620750ce8c = (value, row, column, apiRef)=>{
    if (!value) return "";
    const rowId = apiRef.current.getRowId(row);
    $8a187d58fc9127da$var$throwIfNotDateObject({
        value: value,
        columnType: "dateTime",
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleString();
};
const $8a187d58fc9127da$export$4c3b89749ea40e50 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "date",
    sortComparator: (0, $c24e05fccf11e052$export$74e685f55e96d6bc),
    valueFormatter: $8a187d58fc9127da$export$c46cd449e66842a5,
    filterOperators: (0, $3833f97e2932c598$export$2fa54515db89172d)(),
    renderEditCell: (0, $940de6043a3a5604$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $8a187d58fc9127da$export$5bc7079eed6f3d7f = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "dateTime",
    sortComparator: (0, $c24e05fccf11e052$export$74e685f55e96d6bc),
    valueFormatter: $8a187d58fc9127da$export$a62990620750ce8c,
    filterOperators: (0, $3833f97e2932c598$export$2fa54515db89172d)(true),
    renderEditCell: (0, $940de6043a3a5604$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});



var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");






var $asN9r = parcelRequire("asN9r");

const $b2a98a8b3d22f914$var$gridRowsStateSelector = (state)=>state.rows;
const $b2a98a8b3d22f914$export$1641ef9d08e265ca = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $b2a98a8b3d22f914$export$3c966d405f950b08 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.loading);
const $b2a98a8b3d22f914$export$800ab0a68a9efc4f = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const $b2a98a8b3d22f914$export$37767f9110c99048 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
const $b2a98a8b3d22f914$export$451ff98f7dd9f13f = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToIdLookup);
const $b2a98a8b3d22f914$export$de9a43d646a9821d = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.tree);
const $b2a98a8b3d22f914$export$c263d91fb644e7a0 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $b2a98a8b3d22f914$export$eb24598525413286 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $b2a98a8b3d22f914$export$4cdbe576751dd8e2 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] + 1;
});
const $b2a98a8b3d22f914$export$c7dcaab5e573753 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $b2a98a8b3d22f914$export$e8db8ec5e43400fa = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$var$gridRowsStateSelector, (rows)=>rows?.additionalRowGroups);
const $b2a98a8b3d22f914$export$ffe7071c481e32b0 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($b2a98a8b3d22f914$export$e8db8ec5e43400fa, (additionalRowGroups)=>{
    const rawPinnedRows = additionalRowGroups?.pinnedRows;
    return {
        bottom: rawPinnedRows?.bottom?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? [],
        top: rawPinnedRows?.top?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? []
    };
});
const $b2a98a8b3d22f914$export$8e3fb3525d7db988 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($b2a98a8b3d22f914$export$ffe7071c481e32b0, (pinnedRows)=>{
    return (pinnedRows?.top?.length || 0) + (pinnedRows?.bottom?.length || 0);
});



const $5a37f1a88e056eac$export$433b924dc2506913 = `auto-generated-group-node-root`;
const $5a37f1a88e056eac$export$e8632b32bb8837db = Symbol("mui.id_autogenerated");
const $5a37f1a88e056eac$export$96a607054e9bfd0c = ()=>({
        type: "group",
        id: $5a37f1a88e056eac$export$433b924dc2506913,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function $5a37f1a88e056eac$export$de0419c0281531ca(id, row, detailErrorMessage = "A row was provided without id in the rows prop:") {
    if (id == null) throw new Error([
        "MUI X: The data grid component requires all rows to have a unique `id` property.",
        "Alternatively, you can use the `getRowId` prop to specify a custom id for each row.",
        detailErrorMessage,
        JSON.stringify(row)
    ].join("\n"));
}
const $5a37f1a88e056eac$export$a95fb784d0ca2e72 = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $5a37f1a88e056eac$export$de0419c0281531ca(id, rowModel, detailErrorMessage);
    return id;
};
const $5a37f1a88e056eac$export$3496927f169f2d35 = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: "full",
        rows: []
    };
    const dataRowIdToModelLookup = {};
    const dataRowIdToIdLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $5a37f1a88e056eac$export$a95fb784d0ca2e72(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        dataRowIdToIdLookup[id] = id;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
const $5a37f1a88e056eac$export$e6ee03f0394a9759 = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$5a37f1a88e056eac$export$433b924dc2506913];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const $5a37f1a88e056eac$export$4dcb6d8dd06e4f39 = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName } = apiRef.current.applyStrategyProcessor("rowTreeCreation", {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors("hydrateRows", {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: "partial",
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $asN9r.default)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $5a37f1a88e056eac$export$e6ee03f0394a9759({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp
    });
};
const $5a37f1a88e056eac$export$fc9d832f40054590 = (rowNode)=>rowNode.type === "skeletonRow" || rowNode.type === "footer" || rowNode.type === "group" && rowNode.isAutoGenerated || rowNode.type === "pinnedRow" && rowNode.isAutoGenerated;
const $5a37f1a88e056eac$export$9380f4bcafb87e49 = (tree, parentId, skipAutoGeneratedRows)=>{
    const node = tree[parentId];
    if (node.type !== "group") return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$5a37f1a88e056eac$export$fc9d832f40054590(tree[child])) validDescendants.push(child);
        const childDescendants = $5a37f1a88e056eac$export$9380f4bcafb87e49(tree, child, skipAutoGeneratedRows);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
const $5a37f1a88e056eac$export$b593607f8b00d104 = ({ previousCache: previousCache, getRowId: getRowId, updates: updates })=>{
    if (previousCache.updates.type === "full") throw new Error("MUI X: Unable to prepare a partial update if a full update is not applied yet.");
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $5a37f1a88e056eac$export$a95fb784d0ca2e72(update, getRowId, "A row was provided without id when calling updateRows():");
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $asN9r.default)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: "partial",
        actions: {
            insert: [
                ...previousCache.updates.actions.insert ?? []
            ],
            modify: [
                ...previousCache.updates.actions.modify ?? []
            ],
            remove: [
                ...previousCache.updates.actions.remove ?? []
            ]
        },
        idToActionLookup: (0, $asN9r.default)({}, previousCache.updates.idToActionLookup)
    };
    const dataRowIdToModelLookup = (0, $asN9r.default)({}, previousCache.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $asN9r.default)({}, previousCache.dataRowIdToIdLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === "delete") {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === "remove" || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            delete dataRowIdToIdLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === "remove") {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $asN9r.default)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === "remove") {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
        dataRowIdToIdLookup[id] = id;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
function $5a37f1a88e056eac$export$d299da5915ed6fec(apiRef) {
    const pinnedRows = (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0)(apiRef);
    const topPinnedRowsHeight = pinnedRows?.top?.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0) || 0;
    const bottomPinnedRowsHeight = pinnedRows?.bottom?.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0) || 0;
    return {
        top: topPinnedRowsHeight,
        bottom: bottomPinnedRowsHeight
    };
}
function $5a37f1a88e056eac$export$5475857f45a72a6e(apiRef) {
    const dimensions = (0, $13cd7539f33578ca$export$26d8768b83a52ffd)(apiRef.current.state);
    return `var(--DataGrid-overlayHeight, ${2 * dimensions.rowHeight}px)`;
}



var $ge3KO = parcelRequire("ge3KO");
const $f01adba72841abed$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "hideDescendantCount"
];
const $f01adba72841abed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "booleanCell"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $f01adba72841abed$var$GridBooleanCellRaw(props) {
    const { value: value } = props, other = (0, $bKcdJ.default)(props, $f01adba72841abed$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $f01adba72841abed$var$useUtilityClasses(ownerState);
    const Icon = $f2Y41.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, (0, $asN9r.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
        "data-value": Boolean(value)
    }, other));
}
const $f01adba72841abed$export$9cc4d0e939884340 = /*#__PURE__*/ $f2Y41.memo($f01adba72841abed$var$GridBooleanCellRaw);
const $f01adba72841abed$export$6c5a2392a8d4c6d6 = (params)=>{
    if (params.field !== "__row_group_by_columns_group__" && (0, $5a37f1a88e056eac$export$fc9d832f40054590)(params.rowNode)) return "";
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f01adba72841abed$export$9cc4d0e939884340, (0, $asN9r.default)({}, params));
};



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $0bbc8a57a861431d$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $0bbc8a57a861431d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "editBooleanCell"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $0bbc8a57a861431d$export$22bee653ea92336f(props) {
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $bKcdJ.default)(props, $0bbc8a57a861431d$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const inputRef = $f2Y41.useRef(null);
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const [valueState, setValueState] = $f2Y41.useState(value);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $0bbc8a57a861431d$var$useUtilityClasses(ownerState);
    const handleChange = $f2Y41.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $f2Y41.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("label", (0, $asN9r.default)({
        htmlFor: id,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseCheckbox, (0, $asN9r.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, rootProps.slotProps?.baseCheckbox))
    }));
}
const $0bbc8a57a861431d$export$9ef52be99fb661 = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)($0bbc8a57a861431d$export$22bee653ea92336f, (0, $asN9r.default)({}, params));




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $8bab3381cb000b49$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "variant",
    "InputLabelProps"
];
const $8bab3381cb000b49$var$BooleanOperatorContainer = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div")({
    display: "flex",
    alignItems: "center",
    width: "100%",
    [`& button`]: {
        margin: "auto 0px 5px 5px"
    }
});
function $8bab3381cb000b49$export$f1030df85ee00af9(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, clearButton: clearButton, tabIndex: tabIndex, label: labelProp, variant: variant = "standard" } = props, others = (0, $bKcdJ.default)(props, $8bab3381cb000b49$var$_excluded);
    const [filterValueState, setFilterValueState] = $f2Y41.useState(item.value || "");
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const labelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const selectId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const onFilterChange = $f2Y41.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(value);
        applyValue((0, $asN9r.default)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $f2Y41.useEffect(()=>{
        setFilterValueState(item.value || "");
    }, [
        item.value
    ]);
    const label = labelProp ?? apiRef.current.getLocaleText("filterPanelInputLabel");
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($8bab3381cb000b49$var$BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseInputLabel, (0, $asN9r.default)({}, rootProps.slotProps?.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)(rootProps.slots.baseSelect, (0, $asN9r.default)({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: variant,
                        notched: variant === "outlined" ? true : undefined,
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex: tabIndex
                        }
                    }, others /* FIXME: typing error */ , baseSelectProps, {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText("filterValueAny")
                            })),
                            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText("filterValueTrue")
                            })),
                            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText("filterValueFalse")
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}


const $4fe074f7c418bd6c$export$906a46f6c2359ef6 = ()=>[
        {
            value: "is",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const valueAsBoolean = String(filterItem.value) === "true";
                return (value)=>{
                    return Boolean(value) === valueAsBoolean;
                };
            },
            InputComponent: (0, $8bab3381cb000b49$export$f1030df85ee00af9)
        }
    ];


const $a4f8291e52b61094$var$gridBooleanFormatter = (value, row, column, apiRef)=>{
    return value ? apiRef.current.getLocaleText("booleanCellTrueLabel") : apiRef.current.getLocaleText("booleanCellFalseLabel");
};
const $a4f8291e52b61094$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case "true":
        case "yes":
        case "1":
            return true;
        case "false":
        case "no":
        case "0":
        case "null":
        case "undefined":
            return false;
        default:
            return undefined;
    }
};
const $a4f8291e52b61094$export$220b51460e149ea9 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "boolean",
    display: "flex",
    align: "center",
    headerAlign: "center",
    renderCell: (0, $f01adba72841abed$export$6c5a2392a8d4c6d6),
    renderEditCell: (0, $0bbc8a57a861431d$export$9ef52be99fb661),
    sortComparator: (0, $c24e05fccf11e052$export$ecfdaa3722003888),
    valueFormatter: $a4f8291e52b61094$var$gridBooleanFormatter,
    filterOperators: (0, $4fe074f7c418bd6c$export$906a46f6c2359ef6)(),
    getApplyQuickFilterFn: undefined,
    // @ts-ignore
    aggregable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$a4f8291e52b61094$var$stringToBoolean(value)
});



var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $191aa0090bd3a8f3$export$66744c3b0d0c6217 = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($191aa0090bd3a8f3$export$66744c3b0d0c6217 || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $191aa0090bd3a8f3$export$73fccbaa325472ee = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($191aa0090bd3a8f3$export$73fccbaa325472ee || {});


/**
 * @deprecated there is no meaninfuly logic abstracted, use event.key directly.
 */ const $19fd75f0cc198aff$export$a6587fe901c3baf7 = (key)=>key === "Escape";
const $19fd75f0cc198aff$export$34e5042f80daa3dd = (key)=>key === "Tab";
function $19fd75f0cc198aff$export$b3f2c64190cf8c4(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $19fd75f0cc198aff$export$b7d709ba679d3811 = [
    "Meta",
    "Control",
    "Shift"
];
const $19fd75f0cc198aff$export$cb76cac5e13767b3 = [
    "Enter",
    "Escape",
    "Tab"
];
const $19fd75f0cc198aff$export$88516d667267d515 = [
    "Enter",
    "Tab"
];
const $19fd75f0cc198aff$export$6ac2fcffa1f825f7 = (key)=>$19fd75f0cc198aff$export$b7d709ba679d3811.indexOf(key) > -1;
const $19fd75f0cc198aff$export$a8f5f024431d9642 = (event)=>$19fd75f0cc198aff$export$b3f2c64190cf8c4(event) || event.key === "Enter" || event.key === "Backspace" || event.key === "Delete";
const $19fd75f0cc198aff$export$f6a96f75820f81fd = (key)=>$19fd75f0cc198aff$export$cb76cac5e13767b3.indexOf(key) > -1;
const $19fd75f0cc198aff$export$d3e9cf1edead7ecb = (key)=>$19fd75f0cc198aff$export$88516d667267d515.indexOf(key) > -1;
const $19fd75f0cc198aff$export$e13d96c38a470518 = (key)=>key.indexOf("Arrow") === 0 || key.indexOf("Page") === 0 || key === " " || key === "Home" || key === "End";
const $19fd75f0cc198aff$export$130b789831072f4c = (event)=>!!event.key;
const $19fd75f0cc198aff$export$81301abbcd0c8143 = (key)=>$19fd75f0cc198aff$export$34e5042f80daa3dd(key) || $19fd75f0cc198aff$export$a6587fe901c3baf7(key);
function $19fd75f0cc198aff$export$dc044e3b830c7edc(event) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "v" && !event.shiftKey && !event.altKey) return true;
    return false;
}



var $c1e8ba2aebe0d5a9$export$bad6b7a934346f26 = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($c1e8ba2aebe0d5a9$export$bad6b7a934346f26 || {});
var $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31 = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31 || {});
var $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c || {});



var $asN9r = parcelRequire("asN9r");
function $25d5c231c9438bdc$export$74006a51f68c6262(colDef) {
    return colDef?.type === "singleSelect";
}
function $25d5c231c9438bdc$export$b871910a1101d890(column, additionalParams) {
    if (!column) return undefined;
    return typeof column.valueOptions === "function" ? column.valueOptions((0, $asN9r.default)({
        field: column.field
    }, additionalParams)) : column.valueOptions;
}
function $25d5c231c9438bdc$export$b31a7985e33f7505(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}




var $ge3KO = parcelRequire("ge3KO");
const $28b0929c4436a2c6$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen"
], $28b0929c4436a2c6$var$_excluded2 = [
    "MenuProps"
];
function $28b0929c4436a2c6$var$isKeyboardEvent(event) {
    return !!event.key;
}
function $28b0929c4436a2c6$export$df7446df636ddbed(props) {
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Cell } = props, other = (0, $bKcdJ.default)(props, $28b0929c4436a2c6$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const ref = $f2Y41.useRef();
    const inputRef = $f2Y41.useRef();
    const [open, setOpen] = $f2Y41.useState(initialOpen);
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const _ref = rootProps.slotProps?.baseSelect || {}, { MenuProps: MenuProps } = _ref, otherBaseSelectProps = (0, $bKcdJ.default)(_ref, $28b0929c4436a2c6$var$_excluded2);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current?.focus();
    }, [
        hasFocus
    ]);
    if (!(0, $25d5c231c9438bdc$export$74006a51f68c6262)(colDef)) return null;
    const valueOptions = (0, $25d5c231c9438bdc$export$b871910a1101d890)(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) return null;
    const getOptionValue = colDef.getOptionValue;
    const getOptionLabel = colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $25d5c231c9438bdc$export$74006a51f68c6262)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $25d5c231c9438bdc$export$b31a7985e33f7505)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Row) {
            setOpen(false);
            return;
        }
        if (reason === "backdropClick" || (0, $19fd75f0cc198aff$export$a6587fe901c3baf7)(event.key)) {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent("cellEditStop", (0, $asN9r.default)({}, params, {
                reason: (0, $19fd75f0cc198aff$export$a6587fe901c3baf7)(event.key) ? (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).escapeKeyDown : (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($28b0929c4436a2c6$var$isKeyboardEvent(event) && event.key === "Enter") return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelect, (0, $asN9r.default)({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: (0, $asN9r.default)({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map((valueOption)=>{
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $f2Y41.createElement)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, rootProps.slotProps?.baseSelectOption || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $28b0929c4436a2c6$export$13060fab7d49b7a1 = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)($28b0929c4436a2c6$export$df7446df636ddbed, (0, $asN9r.default)({}, params));



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $b2cc084efc64f4a6$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "placeholder",
    "tabIndex",
    "label",
    "variant",
    "isFilterActive",
    "clearButton",
    "InputLabelProps"
];
const $b2cc084efc64f4a6$var$renderSingleSelectOptions = ({ column: column, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = [
        "",
        ...(0, $25d5c231c9438bdc$export$b871910a1101d890)(column) || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        let label = getOptionLabel(option);
        if (label === "") label = "\u2003"; // To force the height of the empty option
        return /*#__PURE__*/ (0, $f2Y41.createElement)(OptionComponent, (0, $asN9r.default)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
const $b2cc084efc64f4a6$var$SingleSelectOperatorContainer = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div")({
    display: "flex",
    alignItems: "flex-end",
    width: "100%",
    [`& button`]: {
        margin: "auto 0px 5px 5px"
    }
});
function $b2cc084efc64f4a6$export$760eb819dd95d361(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, placeholder: placeholder, tabIndex: tabIndex, label: labelProp, variant: variant = "standard", clearButton: clearButton } = props, others = (0, $bKcdJ.default)(props, $b2cc084efc64f4a6$var$_excluded);
    const filterValue = item.value ?? "";
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const labelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const isSelectNative = rootProps.slotProps?.baseSelect?.native ?? false;
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $25d5c231c9438bdc$export$74006a51f68c6262)(column)) resolvedColumn = column;
    }
    const getOptionValue = resolvedColumn?.getOptionValue;
    const getOptionLabel = resolvedColumn?.getOptionLabel;
    const currentValueOptions = $f2Y41.useMemo(()=>{
        return (0, $25d5c231c9438bdc$export$b871910a1101d890)(resolvedColumn);
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $f2Y41.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $25d5c231c9438bdc$export$b31a7985e33f7505)(value, currentValueOptions, getOptionValue);
        applyValue((0, $asN9r.default)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    if (!(0, $25d5c231c9438bdc$export$74006a51f68c6262)(resolvedColumn)) return null;
    const label = labelProp ?? apiRef.current.getLocaleText("filterPanelInputLabel");
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($b2cc084efc64f4a6$var$SingleSelectOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseInputLabel, (0, $asN9r.default)({}, rootProps.slotProps?.baseInputLabel, {
                        id: labelId,
                        htmlFor: id,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelect, (0, $asN9r.default)({
                        id: id,
                        label: label,
                        labelId: labelId,
                        value: filterValue,
                        onChange: onFilterChange,
                        variant: variant,
                        type: type || "text",
                        inputProps: {
                            tabIndex: tabIndex,
                            ref: focusElementRef,
                            placeholder: placeholder ?? apiRef.current.getLocaleText("filterPanelInputPlaceholder")
                        },
                        native: isSelectNative,
                        notched: variant === "outlined" ? true : undefined
                    }, others /* FIXME: typing error */ , rootProps.slotProps?.baseSelect, {
                        children: $b2cc084efc64f4a6$var$renderSingleSelectOptions({
                            column: resolvedColumn,
                            OptionComponent: rootProps.slots.baseSelectOption,
                            getOptionLabel: getOptionLabel,
                            getOptionValue: getOptionValue,
                            isSelectNative: isSelectNative,
                            baseSelectOptionProps: rootProps.slotProps?.baseSelectOption
                        })
                    }))
                ]
            }),
            clearButton
        ]
    });
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $7ef4140787c18aa3$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
const $7ef4140787c18aa3$var$filter = (0, $280f1223365e8458$export$f76f94b238d946d8)();
function $7ef4140787c18aa3$export$a61be354e4fcf2c5(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = "standard" } = props, other = (0, $bKcdJ.default)(props, $7ef4140787c18aa3$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $25d5c231c9438bdc$export$74006a51f68c6262)(column)) resolvedColumn = column;
    }
    const getOptionValue = resolvedColumn?.getOptionValue;
    const getOptionLabel = resolvedColumn?.getOptionLabel;
    const isOptionEqualToValue = $f2Y41.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $f2Y41.useMemo(()=>{
        return (0, $25d5c231c9438bdc$export$b871910a1101d890)(resolvedColumn) || [];
    }, [
        resolvedColumn
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $f2Y41.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        return item.value.reduce((acc, value)=>{
            const resolvedValue = resolvedValueOptions.find((v)=>getOptionValue(v) === value);
            if (resolvedValue != null) acc.push(resolvedValue);
            return acc;
        }, []);
    }, [
        getOptionValue,
        item.value,
        resolvedValueOptions
    ]);
    const handleChange = $f2Y41.useCallback((event, value)=>{
        applyValue((0, $asN9r.default)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ed33687cff4d0a4c$export$2e2bcd8739ae039), (0, $asN9r.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: $7ef4140787c18aa3$var$filter,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseChip, (0, $asN9r.default)({
                    variant: "outlined",
                    size: "small",
                    label: getOptionLabel(option)
                }, getTagProps({
                    index: index
                })))),
        renderInput: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTextField, (0, $asN9r.default)({}, params, {
                label: apiRef.current.getLocaleText("filterPanelInputLabel"),
                placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
                InputLabelProps: (0, $asN9r.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, rootProps.slotProps?.baseTextField))
    }, other));
}



const $d9bbddfa23b8a35e$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $2b59f632c4f96fc9$export$a6cdc56e425d0d0a)(value)) return value;
    return value.value;
};
const $d9bbddfa23b8a35e$export$fe632a61ba1bdc90 = ()=>[
        {
            value: "is",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === "") return null;
                return (value)=>$d9bbddfa23b8a35e$var$parseObjectValue(value) === $d9bbddfa23b8a35e$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $b2cc084efc64f4a6$export$760eb819dd95d361)
        },
        {
            value: "not",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === "") return null;
                return (value)=>$d9bbddfa23b8a35e$var$parseObjectValue(value) !== $d9bbddfa23b8a35e$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $b2cc084efc64f4a6$export$760eb819dd95d361)
        },
        {
            value: "isAnyOf",
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($d9bbddfa23b8a35e$var$parseObjectValue);
                return (value)=>filterItemValues.includes($d9bbddfa23b8a35e$var$parseObjectValue(value));
            },
            InputComponent: (0, $7ef4140787c18aa3$export$a61be354e4fcf2c5)
        }
    ];




const $02f5717a67705bda$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === "object";
};
const $02f5717a67705bda$var$defaultGetOptionValue = (value)=>{
    return (0, $2b59f632c4f96fc9$export$a6cdc56e425d0d0a)(value) ? value.value : value;
};
const $02f5717a67705bda$var$defaultGetOptionLabel = (value)=>{
    return (0, $2b59f632c4f96fc9$export$a6cdc56e425d0d0a)(value) ? value.label : String(value);
};
const $02f5717a67705bda$export$7acf0d6e5e468a51 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "singleSelect",
    getOptionLabel: $02f5717a67705bda$var$defaultGetOptionLabel,
    getOptionValue: $02f5717a67705bda$var$defaultGetOptionValue,
    valueFormatter (value, row, colDef, apiRef) {
        // const { id, field, value, api } = params;
        const rowId = apiRef.current.getRowId(row);
        if (!(0, $25d5c231c9438bdc$export$74006a51f68c6262)(colDef)) return "";
        const valueOptions = (0, $25d5c231c9438bdc$export$b871910a1101d890)(colDef, {
            id: rowId,
            row: row
        });
        if (value == null) return "";
        if (!valueOptions) return value;
        if (!$02f5717a67705bda$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : "";
    },
    renderEditCell: (0, $28b0929c4436a2c6$export$13060fab7d49b7a1),
    filterOperators: (0, $d9bbddfa23b8a35e$export$fe632a61ba1bdc90)(),
    // @ts-ignore
    pastedValueParser: (value, row, column)=>{
        const colDef = column;
        const valueOptions = (0, $25d5c231c9438bdc$export$b871910a1101d890)(colDef) || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});



var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");
var $fd140aca466316b3$exports = {};
"use strict";

$fd140aca466316b3$exports = (parcelRequire("cQ5f5"));




var $d2f68c0cafd1caa3$export$2e2bcd8739ae039 = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039);



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $f2Y41 = parcelRequire("f2Y41");
"use client";
/**
 * @ignore - internal component.
 */ const $ea2be9ee151cf4ec$var$ListContext = /*#__PURE__*/ $f2Y41.createContext({});
var $ea2be9ee151cf4ec$export$2e2bcd8739ae039 = $ea2be9ee151cf4ec$var$ListContext;




function $5e8675b498544c42$export$c6bd6795ed6e3203(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiList", slot);
}
const $5e8675b498544c42$var$listClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $5e8675b498544c42$export$2e2bcd8739ae039 = $5e8675b498544c42$var$listClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $b30e7865c1edb8e3$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $b30e7865c1edb8e3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $5e8675b498544c42$export$c6bd6795ed6e3203), classes);
};
const $b30e7865c1edb8e3$var$ListRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $b30e7865c1edb8e3$var$List = /*#__PURE__*/ $f2Y41.forwardRef(function List(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $bKcdJ.default)(props, $b30e7865c1edb8e3$var$_excluded);
    const context = $f2Y41.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $asN9r.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $b30e7865c1edb8e3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ea2be9ee151cf4ec$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)($b30e7865c1edb8e3$var$ListRoot, (0, $asN9r.default)({
            as: component,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $b30e7865c1edb8e3$export$2e2bcd8739ae039 = $b30e7865c1edb8e3$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $d358ba0f6d54243e$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $02f0ec96bf65c29f$export$2e2bcd8739ae039 = (0, $d358ba0f6d54243e$export$2e2bcd8739ae039);





var $ge3KO = parcelRequire("ge3KO");
"use client";
const $d203149adb48b43d$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $d203149adb48b43d$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $d203149adb48b43d$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $d203149adb48b43d$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $d203149adb48b43d$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$d203149adb48b43d$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $d203149adb48b43d$var$MenuList = /*#__PURE__*/ $f2Y41.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $bKcdJ.default)(props, $d203149adb48b43d$var$_excluded);
    const listRef = $f2Y41.useRef(null);
    const textCriteriaRef = $f2Y41.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $678399b549f398d4$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $f2Y41.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $02f0ec96bf65c29f$export$2e2bcd8739ae039)((0, $d2f68c0cafd1caa3$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $d2f68c0cafd1caa3$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $d203149adb48b43d$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $d203149adb48b43d$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $d203149adb48b43d$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $d203149adb48b43d$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $d203149adb48b43d$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $d203149adb48b43d$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $d203149adb48b43d$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $d203149adb48b43d$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $d203149adb48b43d$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $d203149adb48b43d$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $d203149adb48b43d$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $f2Y41.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $f2Y41.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $f2Y41.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $f2Y41.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b30e7865c1edb8e3$export$2e2bcd8739ae039), (0, $asN9r.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $d203149adb48b43d$export$2e2bcd8739ae039 = $d203149adb48b43d$var$MenuList;


parcelRequire("f2Y41");



"use client";
function $3f2663da8e8af7d6$export$2e2bcd8739ae039() {
    const theme = (0, $e65a75724f3a2622$export$2e2bcd8739ae039)((0, $c48003953c749b7a$export$2e2bcd8739ae039));
    return theme[0, $052d61a03cfc8b91$export$2e2bcd8739ae039] || theme;
}





var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $f2Y41 = parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
"use client";
function $5081c4cca9a52611$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $5081c4cca9a52611$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $5081c4cca9a52611$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $f2Y41.useRef(false);
    const nodeRef = $f2Y41.useRef(null);
    const activatedRef = $f2Y41.useRef(false);
    const syntheticEventRef = $f2Y41.useRef(false);
    $f2Y41.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $5081c4cca9a52611$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $f2Y41.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $5081c4cca9a52611$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $f2Y41.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $5081c4cca9a52611$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f2Y41.Fragment, {
        children: /*#__PURE__*/ $f2Y41.cloneElement(children, childrenProps)
    });
}




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




var $bKcdJ = parcelRequire("bKcdJ");



var $f2Y41 = parcelRequire("f2Y41");

var $855a6514dc8db9f9$export$2e2bcd8739ae039 = {
    disabled: false
};




var $64316e7bc0e0bc98$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $c608aef789663cd5$export$bb38bb9a1161268 = "unmounted";
var $c608aef789663cd5$export$84cbff306f539230 = "exited";
var $c608aef789663cd5$export$df38205c966be359 = "entering";
var $c608aef789663cd5$export$78e9e6e3e014d60a = "entered";
var $c608aef789663cd5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $c608aef789663cd5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $c667c70d22b9c5fb$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $c608aef789663cd5$export$84cbff306f539230;
                _this.appearStatus = $c608aef789663cd5$export$df38205c966be359;
            } else initialStatus = $c608aef789663cd5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $c608aef789663cd5$export$bb38bb9a1161268;
        else initialStatus = $c608aef789663cd5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $c608aef789663cd5$export$bb38bb9a1161268) return {
            status: $c608aef789663cd5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $c608aef789663cd5$export$df38205c966be359 && status !== $c608aef789663cd5$export$78e9e6e3e014d60a) nextStatus = $c608aef789663cd5$export$df38205c966be359;
            } else if (status === $c608aef789663cd5$export$df38205c966be359 || status === $c608aef789663cd5$export$78e9e6e3e014d60a) nextStatus = $c608aef789663cd5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $c608aef789663cd5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($5021361ff788fb77$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $64316e7bc0e0bc98$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $c608aef789663cd5$export$84cbff306f539230) this.setState({
            status: $c608aef789663cd5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($5021361ff788fb77$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $855a6514dc8db9f9$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c608aef789663cd5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $c608aef789663cd5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $c608aef789663cd5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($5021361ff788fb77$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $855a6514dc8db9f9$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c608aef789663cd5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $c608aef789663cd5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $c608aef789663cd5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($5021361ff788fb77$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $c608aef789663cd5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bKcdJ.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $3d14d57129272124$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Component);
$c608aef789663cd5$var$Transition.contextType = (0, $3d14d57129272124$export$2e2bcd8739ae039);
$c608aef789663cd5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $c608aef789663cd5$var$noop() {}
$c608aef789663cd5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $c608aef789663cd5$var$noop,
    onEntering: $c608aef789663cd5$var$noop,
    onEntered: $c608aef789663cd5$var$noop,
    onExit: $c608aef789663cd5$var$noop,
    onExiting: $c608aef789663cd5$var$noop,
    onExited: $c608aef789663cd5$var$noop
};
$c608aef789663cd5$var$Transition.UNMOUNTED = $c608aef789663cd5$export$bb38bb9a1161268;
$c608aef789663cd5$var$Transition.EXITED = $c608aef789663cd5$export$84cbff306f539230;
$c608aef789663cd5$var$Transition.ENTERING = $c608aef789663cd5$export$df38205c966be359;
$c608aef789663cd5$var$Transition.ENTERED = $c608aef789663cd5$export$78e9e6e3e014d60a;
$c608aef789663cd5$var$Transition.EXITING = $c608aef789663cd5$export$4aacc83d4d59139f;
var $c608aef789663cd5$export$2e2bcd8739ae039 = $c608aef789663cd5$var$Transition;



const $3319049c64cfe8b6$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $3319049c64cfe8b6$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $ge3KO = parcelRequire("ge3KO");
"use client";
const $eb1588ef279b9dec$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $eb1588ef279b9dec$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $eb1588ef279b9dec$var$styles = {
    entering: {
        opacity: 1,
        transform: $eb1588ef279b9dec$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $eb1588ef279b9dec$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $eb1588ef279b9dec$var$Grow = /*#__PURE__*/ $f2Y41.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c608aef789663cd5$export$2e2bcd8739ae039) } = props, other = (0, $bKcdJ.default)(props, $eb1588ef279b9dec$var$_excluded);
    const timer = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const autoTimeout = $f2Y41.useRef();
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const nodeRef = $f2Y41.useRef(null);
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $3319049c64cfe8b6$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $3319049c64cfe8b6$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $eb1588ef279b9dec$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $3319049c64cfe8b6$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $eb1588ef279b9dec$var$isWebKit154 ? duration : duration * 0.666,
                delay: $eb1588ef279b9dec$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $eb1588ef279b9dec$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)(TransitionComponent, (0, $asN9r.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $f2Y41.cloneElement(children, (0, $asN9r.default)({
                style: (0, $asN9r.default)({
                    opacity: 0,
                    transform: $eb1588ef279b9dec$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $eb1588ef279b9dec$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$eb1588ef279b9dec$var$Grow.muiSupportAuto = true;
var $eb1588ef279b9dec$export$2e2bcd8739ae039 = $eb1588ef279b9dec$var$Grow;









var $ge3KO = parcelRequire("ge3KO");
const $f1a3f9a2e160d201$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $f1a3f9a2e160d201$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "menu"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $f1a3f9a2e160d201$var$GridMenuRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f1981fac35ac3785$export$2e2bcd8739ae039), {
    name: "MuiDataGrid",
    slot: "Menu",
    overridesResolver: (_, styles)=>styles.menu
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuList}`]: {
            outline: 0
        }
    }));
const $f1a3f9a2e160d201$var$transformOrigin = {
    "bottom-start": "top left",
    "bottom-end": "top right"
};
function $f1a3f9a2e160d201$export$237948c71948075(props) {
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $bKcdJ.default)(props, $f1a3f9a2e160d201$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $f1a3f9a2e160d201$var$useUtilityClasses(rootProps);
    const savedFocusRef = $f2Y41.useRef(null);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            savedFocusRef.current?.focus?.();
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $f2Y41.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? "menuOpen" : "menuClose";
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target?.contains(event.target))) return;
        onClose(event);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f1a3f9a2e160d201$var$GridMenuRoot, (0, $asN9r.default)({
        as: rootProps.slots.basePopper,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, rootProps.slotProps?.basePopper, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $5081c4cca9a52611$export$58385c17fee43f89), {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $eb1588ef279b9dec$export$2e2bcd8739ae039), (0, $asN9r.default)({}, TransitionProps, {
                    style: {
                        transformOrigin: $f1a3f9a2e160d201$var$transformOrigin[placement]
                    },
                    onExited: handleExited(TransitionProps?.onExited),
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $641b436f34e2d9e2$export$2e2bcd8739ae039), {
                        children: children
                    })
                }))
            })
    }));
}





var $ge3KO = parcelRequire("ge3KO");
const $91b84f9ed5292146$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const $91b84f9ed5292146$var$hasActions = (colDef)=>typeof colDef.getActions === "function";
function $91b84f9ed5292146$export$e8966cddc2f9f685(props) {
    const { colDef: colDef, id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = "bottom-end", focusElementRef: focusElementRef } = props, other = (0, $bKcdJ.default)(props, $91b84f9ed5292146$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $f2Y41.useState(-1);
    const [open, setOpen] = $f2Y41.useState(false);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootRef = $f2Y41.useRef(null);
    const buttonRef = $f2Y41.useRef(null);
    const ignoreCallToFocus = $f2Y41.useRef(false);
    const touchRippleRefs = $f2Y41.useRef({});
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const menuId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const buttonId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    if (!$91b84f9ed5292146$var$hasActions(colDef)) throw new Error("MUI X: Missing the `getActions` property in the `GridColDef`.");
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $f2Y41.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref?.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $f2Y41.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    $f2Y41.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    $f2Y41.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    $f2Y41.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            if (index < 0 || index > options.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = theme.direction === "rtl" ? -1 : 1;
            const indexMod = (direction === "left" ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return options[index + indexMod]?.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === "ArrowRight") newIndex = getNewIndex(focusedButtonIndex, "right");
        else if (event.key === "ArrowLeft") newIndex = getNewIndex(focusedButtonIndex, "left");
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") event.preventDefault();
        if ([
            "Tab",
            "Escape"
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $f2Y41.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText("actionsCellMore"),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: showMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f1a3f9a2e160d201$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d203149adb48b43d$export$2e2bcd8739ae039), {
                    id: menuId,
                    className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $f2Y41.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
const $91b84f9ed5292146$export$974043ff7a6a1028 = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)($91b84f9ed5292146$export$e8966cddc2f9f685, (0, $asN9r.default)({}, params));


const $bad448ba77ed9294$export$e2523ab9efeb7465 = "actions";
const $bad448ba77ed9294$export$cc51a5e65f00f971 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    width: 100,
    display: "flex",
    align: "center",
    headerAlign: "center",
    headerName: "",
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, $91b84f9ed5292146$export$974043ff7a6a1028),
    getApplyQuickFilterFn: undefined
});


const $d4fa2c69603ee632$export$9459349d75dc87fe = "string";
const $d4fa2c69603ee632$export$625c4e4511cf2d66 = ()=>{
    const nativeColumnTypes = {
        string: (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4),
        number: (0, $59b5744ace9b4f07$export$ba08f73736670f91),
        date: (0, $8a187d58fc9127da$export$4c3b89749ea40e50),
        dateTime: (0, $8a187d58fc9127da$export$5bc7079eed6f3d7f),
        boolean: (0, $a4f8291e52b61094$export$220b51460e149ea9),
        singleSelect: (0, $02f5717a67705bda$export$7acf0d6e5e468a51),
        [(0, $bad448ba77ed9294$export$e2523ab9efeb7465)]: (0, $bad448ba77ed9294$export$cc51a5e65f00f971),
        custom: (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4)
    };
    return nativeColumnTypes;
};






const $08de99050f04470e$export$372ceb7d0877dfb4 = (state)=>state.headerFiltering;
const $08de99050f04470e$export$5e071b12b66f124d = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($08de99050f04470e$export$372ceb7d0877dfb4, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
(headerFilteringState)=>headerFilteringState?.enabled ?? false);
const $08de99050f04470e$export$d5104e3dccc7c49d = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($08de99050f04470e$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.editing);
const $08de99050f04470e$export$c564e60305059ea4 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($08de99050f04470e$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.menuOpen);



const $60b55b5d22f1422b$export$6f71a66e6e099ab2 = (state)=>state.columnGrouping;
const $60b55b5d22f1422b$export$78f140ad2e1dbc2b = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($60b55b5d22f1422b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.unwrappedGroupingModel ?? {});
const $60b55b5d22f1422b$export$bdc2ff4432d8b29b = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($60b55b5d22f1422b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.lookup ?? {});
const $60b55b5d22f1422b$export$8f859ed1f2777746 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($60b55b5d22f1422b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.headerStructure ?? []);
const $60b55b5d22f1422b$export$4cf0369c079b29be = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($60b55b5d22f1422b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.maxDepth ?? 0);


const $977688d2f2933ee3$export$cd7252624d377ce0 = [
    "maxWidth",
    "minWidth",
    "width",
    "flex"
];
const $977688d2f2933ee3$var$COLUMN_TYPES = (0, $d4fa2c69603ee632$export$625c4e4511cf2d66)();
function $977688d2f2933ee3$export$1719bda669685455({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const $977688d2f2933ee3$export$cd8dc1fa232954ad = (rawState, dimensions)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute there minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        const newColumn = (0, $asN9r.default)({}, rawState.lookup[columnField]);
        if (rawState.columnVisibilityModel[columnField] === false) newColumn.computedWidth = 0;
        else {
            let computedWidth;
            if (newColumn.flex && newColumn.flex > 0) {
                totalFlexUnits += newColumn.flex;
                computedWidth = 0;
                flexColumns.push(newColumn);
            } else computedWidth = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(newColumn.width || (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4).width, newColumn.minWidth || (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4).minWidth, newColumn.maxWidth || (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4).maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
            newColumn.computedWidth = computedWidth;
        }
        columnsLookup[columnField] = newColumn;
    });
    const availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    const initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        const computedColumnWidths = $977688d2f2933ee3$export$1719bda669685455({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return (0, $asN9r.default)({}, rawState, {
        lookup: columnsLookup
    });
};
const $977688d2f2933ee3$export$6e8a0938c76079c7 = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $asN9r.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $asN9r.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $asN9r.default)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function $977688d2f2933ee3$var$getDefaultColTypeDef(type) {
    let colDef = $977688d2f2933ee3$var$COLUMN_TYPES[0, $d4fa2c69603ee632$export$9459349d75dc87fe];
    if (type && $977688d2f2933ee3$var$COLUMN_TYPES[type]) colDef = $977688d2f2933ee3$var$COLUMN_TYPES[type];
    return colDef;
}
const $977688d2f2933ee3$export$f3ba81d24bd05452 = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnVisibilityModel: columnVisibilityModel = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false })=>{
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $b22d10f7b8994eba$export$858d15abb6cddc08)(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $asN9r.default)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key)=>(0, $asN9r.default)({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $asN9r.default)({}, $977688d2f2933ee3$var$getDefaultColTypeDef(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $asN9r.default)({}, $977688d2f2933ee3$var$getDefaultColTypeDef(newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $977688d2f2933ee3$export$cd7252624d377ce0.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $asN9r.default)({}, existingState, newColumn, {
            hasBeenResized: hasBeenResized
        });
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors("hydrateColumns", columnsState);
    const columnsStateWithPortableColumns = $977688d2f2933ee3$export$6e8a0938c76079c7(columnsStateWithPreProcessing, initialState);
    return $977688d2f2933ee3$export$cd8dc1fa232954ad(columnsStateWithPortableColumns, apiRef.current.getRootDimensions?.() ?? undefined);
};
function $977688d2f2933ee3$export$6143417adb92779f({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    for(let i = firstRowToRender; i < lastRowToRender; i += 1){
        const row = visibleRows[i];
        if (row) {
            const rowId = visibleRows[i].id;
            const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
            if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
        }
    }
    return firstNonSpannedColumnToRender;
}
function $977688d2f2933ee3$export$659109c29172602f(apiRef, props) {
    const densityFactor = (0, $a8df3c1fd8492eab$export$c646201fb1d3e7a6)(apiRef);
    const maxDepth = (0, $60b55b5d22f1422b$export$4cf0369c079b29be)(apiRef);
    const isHeaderFilteringEnabled = (0, $08de99050f04470e$export$5e071b12b66f124d)(apiRef);
    const columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight * (1 + (maxDepth ?? 0)) + filterHeadersHeight;
}



var $f2Y41 = parcelRequire("f2Y41");

function $677f46584a711a96$export$fa306e0bc9a9d6b4(component) {
    return /*#__PURE__*/ $f2Y41.memo(component, (0, $e24e91c53f2440b0$export$84d14f151b531ccb));
}



var $ge3KO = parcelRequire("ge3KO");
const $ae9a1c17fef92bab$var$CLIFF = 1;
const $ae9a1c17fef92bab$var$SLOP = 1.5;
const $ae9a1c17fef92bab$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            "scrollArea",
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $ae9a1c17fef92bab$var$GridScrollAreaRawRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ScrollArea",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollArea--left"]}`]: styles["scrollArea--left"]
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollArea--right"]}`]: styles["scrollArea--right"]
            },
            styles.scrollArea
        ]
})(()=>({
        position: "absolute",
        top: 0,
        zIndex: 101,
        width: 20,
        bottom: 0,
        [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollArea--left"]}`]: {
            left: 0
        },
        [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollArea--right"]}`]: {
            right: 0
        }
    }));
function $ae9a1c17fef92bab$var$GridScrollAreaRaw(props) {
    const { scrollDirection: scrollDirection } = props;
    const rootRef = $f2Y41.useRef(null);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const timeout = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const densityFactor = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $a8df3c1fd8492eab$export$c646201fb1d3e7a6));
    const columnsTotalWidth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$ab20f9d33edc7794));
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const scrollPosition = $f2Y41.useRef({
        left: 0,
        top: 0
    });
    const getCanScrollMore = ()=>{
        if (scrollDirection === "left") // Only render if the user has not reached yet the start of the list
        return scrollPosition.current.left > 0;
        if (scrollDirection === "right") {
            // Only render if the user has not reached yet the end of the list
            const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    const [dragging, setDragging] = $f2Y41.useState(false);
    const [canScrollMore, setCanScrollMore] = $f2Y41.useState(getCanScrollMore);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $asN9r.default)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $ae9a1c17fef92bab$var$useUtilityClasses(ownerState);
    const totalHeaderHeight = (0, $977688d2f2933ee3$export$659109c29172602f)(apiRef, rootProps);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const style = {
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    };
    if (scrollDirection === "left") style.left = dimensions.leftPinnedWidth;
    else if (scrollDirection === "right") style.right = dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    const handleScrolling = (newScrollPosition)=>{
        scrollPosition.current = newScrollPosition;
        setCanScrollMore(getCanScrollMore);
    };
    const handleDragOver = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === "left") offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === "right") offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error("MUI X: Wrong drag direction");
        offset = (offset - $ae9a1c17fef92bab$var$CLIFF) * $ae9a1c17fef92bab$var$SLOP + $ae9a1c17fef92bab$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    const handleColumnHeaderDragStart = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(()=>{
        setDragging(true);
    });
    const handleColumnHeaderDragEnd = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(()=>{
        setDragging(false);
    });
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "scrollPositionChange", handleScrolling);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragStart", handleColumnHeaderDragStart);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragEnd", handleColumnHeaderDragEnd);
    if (!dragging || !canScrollMore) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)($ae9a1c17fef92bab$var$GridScrollAreaRawRoot, {
        ref: rootRef,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root),
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
}
const $ae9a1c17fef92bab$export$40bcbdb719b20690 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($ae9a1c17fef92bab$var$GridScrollAreaRaw);








var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $f2Y41 = parcelRequire("f2Y41");
const $ce64d818c6a4c305$export$37099e7a34cbf988 = /*#__PURE__*/ $f2Y41.createContext(undefined);
function $ce64d818c6a4c305$export$e1fd9274eb96ee18() {
    const privateApiRef = $f2Y41.useContext($ce64d818c6a4c305$export$37099e7a34cbf988);
    if (privateApiRef === undefined) throw new Error([
        "MUI X: Could not find the data grid private context.",
        "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.",
        "This can also happen if you are bundling multiple versions of the data grid."
    ].join("\n"));
    return privateApiRef;
}





var $f2Y41 = parcelRequire("f2Y41");

const $bea48bb7ec9bef87$var$isDevEnvironment = false;
const $bea48bb7ec9bef87$var$noop = ()=>{};
function $bea48bb7ec9bef87$export$683480f191c0e3ea(ref, fn, enabled) {
    const fnRef = $f2Y41.useRef(null);
    fnRef.current = fn;
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (enabled === false || typeof ResizeObserver === "undefined") return $bea48bb7ec9bef87$var$noop;
        let frameID = 0;
        const target = ref.current;
        const observer = new ResizeObserver((entries)=>{
            // See https://github.com/mui/mui-x/issues/8733
            // In dev, we avoid the React warning by moving the task to the next frame.
            // In prod, we want the task to run in the same frame as to avoid tear.
            if ($bea48bb7ec9bef87$var$isDevEnvironment) frameID = requestAnimationFrame(()=>{
                fnRef.current(entries);
            });
            else fnRef.current(entries);
        });
        if (target) observer.observe(target);
        return ()=>{
            if (frameID) cancelAnimationFrame(frameID);
            observer.disconnect();
        };
    }, [
        ref,
        enabled
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");

const $966a5e767f8d7c81$var$noop = ()=>{};
const $966a5e767f8d7c81$export$a3576ea6e6df583c = (condition, effect)=>{
    const didRun = $f2Y41.useRef(false);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (didRun.current || !condition) return $966a5e767f8d7c81$var$noop;
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};






const $f90986e9ff221f63$export$ce21bef7bd3a9c4e = (state)=>state.focus;
const $f90986e9ff221f63$export$74af8aada6269d3 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$ce21bef7bd3a9c4e, (focusState)=>focusState.cell);
const $f90986e9ff221f63$export$cefd405855792f4a = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeader);
const $f90986e9ff221f63$export$50853df99eaddaf5 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeaderFilter);
const $f90986e9ff221f63$export$3eeedc3f7263df61 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnGroupHeader);
const $f90986e9ff221f63$export$3ab3abde27f70192 = (state)=>state.tabIndex;
const $f90986e9ff221f63$export$2c47652a1f657d56 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$3ab3abde27f70192, (state)=>state.cell);
const $f90986e9ff221f63$export$29da670438604dbd = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$3ab3abde27f70192, (state)=>state.columnHeader);
const $f90986e9ff221f63$export$441ae2090306a1e2 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$3ab3abde27f70192, (state)=>state.columnHeaderFilter);
const $f90986e9ff221f63$export$37a54bd010f498d2 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($f90986e9ff221f63$export$3ab3abde27f70192, (state)=>state.columnGroupHeader);



var $f2Y41 = parcelRequire("f2Y41");





/**
 * @category Sorting
 * @ignore - do not document.
 */ const $5f97fdc29401641a$var$gridSortingStateSelector = (state)=>state.sorting;
const $5f97fdc29401641a$export$e4979ad0a2db8752 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($5f97fdc29401641a$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const $5f97fdc29401641a$export$8919e81647813e61 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($5f97fdc29401641a$export$e4979ad0a2db8752, (0, $b2a98a8b3d22f914$export$37767f9110c99048), (0, $b2a98a8b3d22f914$export$de9a43d646a9821d), (sortedIds, idRowsLookup, rowTree)=>sortedIds.reduce((acc, id)=>{
        const model = idRowsLookup[id];
        if (model) acc.push({
            id: id,
            model: model
        });
        const rowNode = rowTree[id];
        if (rowNode && (0, $5a37f1a88e056eac$export$fc9d832f40054590)(rowNode)) acc.push({
            id: id,
            model: {
                [(0, $5a37f1a88e056eac$export$e8632b32bb8837db)]: id
            }
        });
        return acc;
    }, []));
const $5f97fdc29401641a$export$55dcc66b73d9a0f9 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($5f97fdc29401641a$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
const $5f97fdc29401641a$export$4dfdcc434a6c5081 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($5f97fdc29401641a$export$55dcc66b73d9a0f9, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});




/**
 * @category Filtering
 */ const $896120ab6e9a1a0e$var$gridFilterStateSelector = (state)=>state.filter;
const $896120ab6e9a1a0e$export$280aedb9454597a5 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($896120ab6e9a1a0e$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
const $896120ab6e9a1a0e$export$6f9fe133e2c56816 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($896120ab6e9a1a0e$export$280aedb9454597a5, (filterModel)=>filterModel.quickFilterValues);
const $896120ab6e9a1a0e$export$7dcadad908a379a4 = (state)=>state.visibleRowsLookup;
const $896120ab6e9a1a0e$export$6d031b6e8cbaf41c = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($896120ab6e9a1a0e$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const $896120ab6e9a1a0e$export$28e99d5260ff82e7 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($896120ab6e9a1a0e$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const $896120ab6e9a1a0e$export$2f31562143a3e5d4 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$7dcadad908a379a4, (0, $5f97fdc29401641a$export$8919e81647813e61), (visibleRowsLookup, sortedRows)=>sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false));
const $896120ab6e9a1a0e$export$7a99837e2fd93e42 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$2f31562143a3e5d4, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const $896120ab6e9a1a0e$export$cd53824a2b232e36 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$6d031b6e8cbaf41c, (0, $5f97fdc29401641a$export$8919e81647813e61), (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const $896120ab6e9a1a0e$export$4e2a9d76902d271c = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const $896120ab6e9a1a0e$export$b8a7110d1a4c4623 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$2f31562143a3e5d4, (0, $b2a98a8b3d22f914$export$de9a43d646a9821d), (0, $b2a98a8b3d22f914$export$4cdbe576751dd8e2), (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>rowTree[row.id]?.depth === 0);
});
const $896120ab6e9a1a0e$export$96919017bbfaec0d = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($896120ab6e9a1a0e$export$2f31562143a3e5d4, (visibleSortedRows)=>visibleSortedRows.length);
const $896120ab6e9a1a0e$export$f88efd30675963d1 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($896120ab6e9a1a0e$export$b8a7110d1a4c4623, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const $896120ab6e9a1a0e$export$c7447bfbd4ecafcc = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$280aedb9454597a5, (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd), (filterModel, columnLookup)=>filterModel.items?.filter((item)=>{
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!column?.filterOperators || column?.filterOperators?.length === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && item.value?.toString() !== "";
    }));
const $896120ab6e9a1a0e$export$6b2da1ecc84b757a = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($896120ab6e9a1a0e$export$c7447bfbd4ecafcc, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});




const $927c2859d574eba1$var$MAX_PAGE_SIZE = 100;
const $927c2859d574eba1$export$d515e179bb47bd84 = (autoPageSize)=>autoPageSize ? 0 : 100;
const $927c2859d574eba1$export$b287f0ca5dbff6af = (rowCount, pageSize, page)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    if (rowCount === -1) // With unknown row-count, we can assume a page after the current one
    return page + 2;
    return 0;
};
const $927c2859d574eba1$export$73aa7e9d0fff5ee4 = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const $927c2859d574eba1$export$41142e40198ee144 = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const $927c2859d574eba1$export$d3cf54bfe8b6931 = (pageSize, signatureProp)=>{
    if (signatureProp === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid && pageSize > $927c2859d574eba1$var$MAX_PAGE_SIZE) throw new Error([
        "MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.",
        "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
    ].join("\n"));
};


const $85e4c16509a27697$export$24c945ea033ce6cf = (state)=>state.pagination;
const $85e4c16509a27697$export$ccc9f04e59d0d8e6 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($85e4c16509a27697$export$24c945ea033ce6cf, (pagination)=>pagination.paginationModel);
const $85e4c16509a27697$export$946e4ae85da77ef6 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($85e4c16509a27697$export$24c945ea033ce6cf, (pagination)=>pagination.rowCount);
const $85e4c16509a27697$export$4dee702a38e33bdb = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($85e4c16509a27697$export$24c945ea033ce6cf, (pagination)=>pagination.meta);
const $85e4c16509a27697$export$1f7f64fcb62ccdad = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($85e4c16509a27697$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.page);
const $85e4c16509a27697$export$721a46720a2de097 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($85e4c16509a27697$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.pageSize);
const $85e4c16509a27697$export$b81026f1aaf843a4 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($85e4c16509a27697$export$ccc9f04e59d0d8e6, $85e4c16509a27697$export$946e4ae85da77ef6, (paginationModel, rowCount)=>(0, $927c2859d574eba1$export$b287f0ca5dbff6af)(rowCount, paginationModel.pageSize, paginationModel.page));
const $85e4c16509a27697$export$b76c99ac6ae901da = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($85e4c16509a27697$export$ccc9f04e59d0d8e6, (0, $b2a98a8b3d22f914$export$de9a43d646a9821d), (0, $b2a98a8b3d22f914$export$4cdbe576751dd8e2), (0, $896120ab6e9a1a0e$export$2f31562143a3e5d4), (0, $896120ab6e9a1a0e$export$b8a7110d1a4c4623), (paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const $85e4c16509a27697$export$abcd649e974e3e96 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)((0, $896120ab6e9a1a0e$export$2f31562143a3e5d4), $85e4c16509a27697$export$b76c99ac6ae901da, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $85e4c16509a27697$export$c1f6a976375edd4a = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)((0, $896120ab6e9a1a0e$export$7a99837e2fd93e42), $85e4c16509a27697$export$b76c99ac6ae901da, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});



const $5102b0c2afb145a4$export$79b9fa322a34430b = (apiRef, props)=>{
    let rows;
    let range;
    if (props.pagination && props.paginationMode === "client") {
        range = (0, $85e4c16509a27697$export$b76c99ac6ae901da)(apiRef);
        rows = (0, $85e4c16509a27697$export$abcd649e974e3e96)(apiRef);
    } else {
        rows = (0, $896120ab6e9a1a0e$export$2f31562143a3e5d4)(apiRef);
        if (rows.length === 0) range = null;
        else range = {
            firstRowIndex: 0,
            lastRowIndex: rows.length - 1
        };
    }
    return {
        rows: rows,
        range: range
    };
};
const $5102b0c2afb145a4$export$d1914c80ff11e37a = (apiRef, props)=>{
    const response = $5102b0c2afb145a4$export$79b9fa322a34430b(apiRef, props);
    return $f2Y41.useMemo(()=>({
            rows: response.rows,
            range: response.range
        }), [
        response.rows,
        response.range
    ]);
};






const $622635e380529094$export$f663bee74a6091fc = (state)=>state.rowSelection;
const $622635e380529094$export$2e16a09b9ae82bd3 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($622635e380529094$export$f663bee74a6091fc, (selection)=>selection.length);
const $622635e380529094$export$dd53f67f8b4cd8b1 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($622635e380529094$export$f663bee74a6091fc, (0, $b2a98a8b3d22f914$export$37767f9110c99048), (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const $622635e380529094$export$d5aede24ebfe3c98 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($622635e380529094$export$f663bee74a6091fc, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));


const $7662854de25f6bb1$export$4f32bfc70efeb4ab = (state)=>state.rowsMeta;





const $de91a359006882c0$export$38fd8a77b05bfddf = (state)=>state.virtualization;
const $de91a359006882c0$export$fb3400598da0ae89 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($de91a359006882c0$export$38fd8a77b05bfddf, (state)=>state.enabled);
const $de91a359006882c0$export$ad2aa1e9d465cafa = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($de91a359006882c0$export$38fd8a77b05bfddf, (state)=>state.enabledForColumns);
const $de91a359006882c0$export$4cf9f333a030f780 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($de91a359006882c0$export$38fd8a77b05bfddf, (state)=>state.renderContext);
const $de91a359006882c0$export$3a5705edd3d1af7e = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)((state)=>state.virtualization.renderContext.firstColumnIndex, (state)=>state.virtualization.renderContext.lastColumnIndex, (firstColumnIndex, lastColumnIndex)=>({
        firstColumnIndex: firstColumnIndex,
        lastColumnIndex: lastColumnIndex
    }));



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
function $4de327342af16ad7$export$739f6b6a65e76d6c(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}


const $0833e448acfcf31e$export$27eb37bbcd78f450 = {
    firstRowIndex: 0,
    lastRowIndex: 0,
    firstColumnIndex: 0,
    lastColumnIndex: 0
};
const $0833e448acfcf31e$export$42963ad70bb69f54 = (state, props)=>{
    const virtualization = {
        enabled: !props.disableVirtualization,
        enabledForColumns: true,
        renderContext: $0833e448acfcf31e$export$27eb37bbcd78f450
    };
    return (0, $asN9r.default)({}, state, {
        virtualization: virtualization
    });
};
function $0833e448acfcf31e$export$aa0d6df32cccbd53(apiRef, props) {
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                virtualization: (0, $asN9r.default)({}, state.virtualization, {
                    enabled: enabled
                })
            }));
    };
    const setColumnVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                virtualization: (0, $asN9r.default)({}, state.virtualization, {
                    enabledForColumns: enabled
                })
            }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, api, "public");
    /*
   * EFFECTS
   */ /* eslint-disable react-hooks/exhaustive-deps */ $f2Y41.useEffect(()=>{
        setVirtualization(!props.disableVirtualization);
    }, [
        props.disableVirtualization
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }



var $ge3KO = parcelRequire("ge3KO");
const $0ef91cf32c4de50f$var$MINIMUM_COLUMN_WIDTH = 50;
var $0ef91cf32c4de50f$var$ScrollDirection = /*#__PURE__*/ function(ScrollDirection) {
    ScrollDirection[ScrollDirection["NONE"] = 0] = "NONE";
    ScrollDirection[ScrollDirection["UP"] = 1] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 2] = "DOWN";
    ScrollDirection[ScrollDirection["LEFT"] = 3] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 4] = "RIGHT";
    return ScrollDirection;
}($0ef91cf32c4de50f$var$ScrollDirection || {});
const $0ef91cf32c4de50f$var$EMPTY_SCROLL_POSITION = {
    top: 0,
    left: 0
};
const $0ef91cf32c4de50f$export$68a3509179402d90 = Object.freeze(new Map());
const $0ef91cf32c4de50f$var$createScrollCache = (mode, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)=>({
        direction: $0ef91cf32c4de50f$var$ScrollDirection.NONE,
        buffer: $0ef91cf32c4de50f$var$bufferForDirection(mode, $0ef91cf32c4de50f$var$ScrollDirection.NONE, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)
    });
const $0ef91cf32c4de50f$var$isJSDOM = typeof window !== "undefined" ? /jsdom/.test(window.navigator.userAgent) : false;
const $0ef91cf32c4de50f$export$fbe94079134c8d27 = ()=>{
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$16a65a9447d3dda9));
    const enabled = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $de91a359006882c0$export$fb3400598da0ae89)) && !$0ef91cf32c4de50f$var$isJSDOM;
    const enabledForColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $de91a359006882c0$export$ad2aa1e9d465cafa)) && !$0ef91cf32c4de50f$var$isJSDOM;
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const outerSize = dimensions.viewportOuterSize;
    const pinnedRows = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0));
    const pinnedColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$297e8079713afa11));
    const hasBottomPinnedRows = pinnedRows.bottom.length > 0;
    const [panels, setPanels] = $f2Y41.useState($0ef91cf32c4de50f$export$68a3509179402d90);
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const cellFocus = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$74af8aada6269d3));
    const cellTabIndex = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$2c47652a1f657d56));
    const rowsMeta = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $7662854de25f6bb1$export$4f32bfc70efeb4ab));
    const selectedRowsLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $622635e380529094$export$d5aede24ebfe3c98));
    const currentPage = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, rootProps);
    const gridRootRef = apiRef.current.rootElementRef;
    const mainRef = apiRef.current.mainElementRef;
    const scrollerRef = apiRef.current.virtualScrollerRef;
    const scrollbarVerticalRef = $f2Y41.useRef(null);
    const scrollbarHorizontalRef = $f2Y41.useRef(null);
    const contentHeight = dimensions.contentSize.height;
    const columnsTotalWidth = dimensions.columnsTotalWidth;
    const hasColSpan = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$7aac81e7227448b4));
    (0, $bea48bb7ec9bef87$export$683480f191c0e3ea)(mainRef, ()=>apiRef.current.resize());
    /*
   * Scroll context logic
   * ====================
   * We only render the cells contained in the `renderContext`. However, when the user starts scrolling the grid
   * in a direction, we want to render as many cells as possible in that direction, as to avoid presenting white
   * areas if the user scrolls too fast/far and the viewport ends up in a region we haven't rendered yet. To render
   * more cells, we store some offsets to add to the viewport in `scrollCache.buffer`. Those offsets make the render
   * context wider in the direction the user is going, but also makes the buffer around the viewport `0` for the
   * dimension (horizontal or vertical) in which the user is not scrolling. So if the normal viewport is 8 columns
   * wide, with a 1 column buffer (10 columns total), then we want it to be exactly 8 columns wide during vertical
   * scroll.
   * However, we don't want the rows in the old context to re-render from e.g. 10 columns to 8 columns, because that's
   * work that's not necessary. Thus we store the context at the start of the scroll in `frozenContext`, and the rows
   * that are part of this old context will keep their same render context as to avoid re-rendering.
   */ const scrollPosition = $f2Y41.useRef($0ef91cf32c4de50f$var$EMPTY_SCROLL_POSITION);
    const previousContextScrollPosition = $f2Y41.useRef($0ef91cf32c4de50f$var$EMPTY_SCROLL_POSITION);
    const previousRowContext = $f2Y41.useRef((0, $0833e448acfcf31e$export$27eb37bbcd78f450));
    const renderContext = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $de91a359006882c0$export$4cf9f333a030f780));
    const scrollTimeout = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const frozenContext = $f2Y41.useRef(undefined);
    const scrollCache = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)(()=>$0ef91cf32c4de50f$var$createScrollCache(theme.direction, rootProps.rowBufferPx, rootProps.columnBufferPx, dimensions.rowHeight * 15, $0ef91cf32c4de50f$var$MINIMUM_COLUMN_WIDTH * 6)).current;
    const focusedCell = {
        rowIndex: $f2Y41.useMemo(()=>cellFocus ? currentPage.rows.findIndex((row)=>row.id === cellFocus.id) : -1, [
            cellFocus,
            currentPage.rows
        ]),
        columnIndex: $f2Y41.useMemo(()=>cellFocus ? visibleColumns.findIndex((column)=>column.field === cellFocus.field) : -1, [
            cellFocus,
            visibleColumns
        ])
    };
    const updateRenderContext = $f2Y41.useCallback((nextRenderContext)=>{
        if ($0ef91cf32c4de50f$export$6eb241d16b36f3b8(nextRenderContext, apiRef.current.state.virtualization.renderContext)) return;
        const didRowsIntervalChange = nextRenderContext.firstRowIndex !== previousRowContext.current.firstRowIndex || nextRenderContext.lastRowIndex !== previousRowContext.current.lastRowIndex;
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                virtualization: (0, $asN9r.default)({}, state.virtualization, {
                    renderContext: nextRenderContext
                })
            });
        });
        // The lazy-loading hook is listening to `renderedRowsIntervalChange`,
        // but only does something if the dimensions are also available.
        // So we wait until we have valid dimensions before publishing the first event.
        if (dimensions.isReady && didRowsIntervalChange) {
            previousRowContext.current = nextRenderContext;
            apiRef.current.publishEvent("renderedRowsIntervalChange", nextRenderContext);
        }
        previousContextScrollPosition.current = scrollPosition.current;
    }, [
        apiRef,
        dimensions.isReady
    ]);
    const triggerUpdateRenderContext = ()=>{
        const newScroll = {
            top: scrollerRef.current.scrollTop,
            left: scrollerRef.current.scrollLeft
        };
        const dx = newScroll.left - scrollPosition.current.left;
        const dy = newScroll.top - scrollPosition.current.top;
        const isScrolling = dx !== 0 || dy !== 0;
        scrollPosition.current = newScroll;
        const direction = isScrolling ? $0ef91cf32c4de50f$var$directionForDelta(dx, dy) : $0ef91cf32c4de50f$var$ScrollDirection.NONE;
        // Since previous render, we have scrolled...
        const rowScroll = Math.abs(scrollPosition.current.top - previousContextScrollPosition.current.top);
        const columnScroll = Math.abs(scrollPosition.current.left - previousContextScrollPosition.current.left);
        // PERF: use the computed minimum column width instead of a static one
        const didCrossThreshold = rowScroll >= dimensions.rowHeight || columnScroll >= $0ef91cf32c4de50f$var$MINIMUM_COLUMN_WIDTH;
        const didChangeDirection = scrollCache.direction !== direction;
        const shouldUpdate = didCrossThreshold || didChangeDirection;
        if (!shouldUpdate) return renderContext;
        // Render a new context
        if (didChangeDirection) switch(direction){
            case $0ef91cf32c4de50f$var$ScrollDirection.NONE:
            case $0ef91cf32c4de50f$var$ScrollDirection.LEFT:
            case $0ef91cf32c4de50f$var$ScrollDirection.RIGHT:
                frozenContext.current = undefined;
                break;
            default:
                frozenContext.current = renderContext;
                break;
        }
        scrollCache.direction = direction;
        scrollCache.buffer = $0ef91cf32c4de50f$var$bufferForDirection(theme.direction, direction, rootProps.rowBufferPx, rootProps.columnBufferPx, dimensions.rowHeight * 15, $0ef91cf32c4de50f$var$MINIMUM_COLUMN_WIDTH * 6);
        const inputs = $0ef91cf32c4de50f$var$inputsSelector(apiRef, rootProps, enabled, enabledForColumns);
        const nextRenderContext = $0ef91cf32c4de50f$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        // Prevents batching render context changes
        $5021361ff788fb77$exports.flushSync(()=>{
            updateRenderContext(nextRenderContext);
        });
        scrollTimeout.start(1000, triggerUpdateRenderContext);
        return nextRenderContext;
    };
    const forceUpdateRenderContext = ()=>{
        const inputs = $0ef91cf32c4de50f$var$inputsSelector(apiRef, rootProps, enabled, enabledForColumns);
        const nextRenderContext = $0ef91cf32c4de50f$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        updateRenderContext(nextRenderContext);
    };
    const handleScroll = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = event.currentTarget;
        // On iOS and macOS, negative offsets are possible when swiping past the start
        if (scrollTop < 0) return;
        if (theme.direction === "ltr") {
            if (scrollLeft < 0) return;
        }
        if (theme.direction === "rtl") {
            if (scrollLeft > 0) return;
        }
        const nextRenderContext = triggerUpdateRenderContext();
        apiRef.current.publishEvent("scrollPositionChange", {
            top: scrollTop,
            left: scrollLeft,
            renderContext: nextRenderContext
        });
    });
    const handleWheel = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        apiRef.current.publishEvent("virtualScrollerWheel", {}, event);
    });
    const handleTouchMove = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        apiRef.current.publishEvent("virtualScrollerTouchMove", {}, event);
    });
    const getRows = (params = {})=>{
        if (!params.rows && !currentPage.range) return [];
        const baseRenderContext = params.renderContext ?? renderContext;
        const isLastSection = !hasBottomPinnedRows && params.position === undefined || hasBottomPinnedRows && params.position === "bottom";
        const isPinnedSection = params.position !== undefined;
        let rowIndexOffset;
        // FIXME: Why is the switch check exhaustiveness not validated with typescript-eslint?
        // eslint-disable-next-line default-case
        switch(params.position){
            case "top":
                rowIndexOffset = 0;
                break;
            case "bottom":
                rowIndexOffset = pinnedRows.top.length + currentPage.rows.length;
                break;
            case undefined:
                rowIndexOffset = pinnedRows.top.length;
                break;
        }
        const rowModels = params.rows ?? currentPage.rows;
        const firstRowToRender = baseRenderContext.firstRowIndex;
        const lastRowToRender = Math.min(baseRenderContext.lastRowIndex, rowModels.length);
        const rowIndexes = params.rows ? (0, $2b59f632c4f96fc9$export$d02631cccf789723)(0, params.rows.length) : (0, $2b59f632c4f96fc9$export$d02631cccf789723)(firstRowToRender, lastRowToRender);
        let virtualRowIndex = -1;
        if (!isPinnedSection && focusedCell.rowIndex !== -1) {
            if (focusedCell.rowIndex < firstRowToRender) {
                virtualRowIndex = focusedCell.rowIndex;
                rowIndexes.unshift(virtualRowIndex);
            }
            if (focusedCell.rowIndex >= lastRowToRender) {
                virtualRowIndex = focusedCell.rowIndex;
                rowIndexes.push(virtualRowIndex);
            }
        }
        const rows = [];
        const rowProps = rootProps.slotProps?.row;
        const columnPositions = (0, $b22d10f7b8994eba$export$fce7d810e48021e3)(apiRef);
        rowIndexes.forEach((rowIndexInPage)=>{
            const { id: id, model: model } = rowModels[rowIndexInPage];
            // NOTE: This is an expensive feature, the colSpan code could be optimized.
            if (hasColSpan) {
                const minFirstColumn = pinnedColumns.left.length;
                const maxLastColumn = visibleColumns.length - pinnedColumns.right.length;
                apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
                if (pinnedColumns.left.length > 0) apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: 0,
                    maxLastColumn: pinnedColumns.left.length,
                    columns: visibleColumns
                });
                if (pinnedColumns.right.length > 0) apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: visibleColumns.length - pinnedColumns.right.length,
                    maxLastColumn: visibleColumns.length,
                    columns: visibleColumns
                });
            }
            const hasFocus = cellFocus?.id === id;
            const baseRowHeight = !apiRef.current.rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : "auto";
            let isSelected;
            if (selectedRowsLookup[id] == null) isSelected = false;
            else isSelected = apiRef.current.isRowSelectable(id);
            let isFirstVisible = false;
            if (params.position === undefined) isFirstVisible = rowIndexInPage === 0;
            let isLastVisible = false;
            if (isLastSection) {
                if (!isPinnedSection) {
                    const lastIndex = currentPage.rows.length - 1;
                    const isLastVisibleRowIndex = rowIndexInPage === lastIndex;
                    if (isLastVisibleRowIndex) isLastVisible = true;
                } else isLastVisible = rowIndexInPage === rowModels.length - 1;
            }
            const isVirtualRow = rowIndexInPage === virtualRowIndex;
            const isNotVisible = isVirtualRow;
            let tabbableCell = null;
            if (cellTabIndex !== null && cellTabIndex.id === id) {
                const cellParams = apiRef.current.getCellParams(id, cellTabIndex.field);
                tabbableCell = cellParams.cellMode === "view" ? cellTabIndex.field : null;
            }
            let currentRenderContext = baseRenderContext;
            if (!isPinnedSection && frozenContext.current && rowIndexInPage >= frozenContext.current.firstRowIndex && rowIndexInPage < frozenContext.current.lastRowIndex) currentRenderContext = frozenContext.current;
            const offsetLeft = $0ef91cf32c4de50f$export$fe1f1566870c3cbc(columnPositions, currentRenderContext, theme.direction, pinnedColumns.left.length);
            const rowIndex = (currentPage?.range?.firstRowIndex || 0) + rowIndexOffset + rowIndexInPage;
            rows.push(/*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.row, (0, $asN9r.default)({
                row: model,
                rowId: id,
                index: rowIndex,
                selected: isSelected,
                offsetTop: params.rows ? undefined : rowsMeta.positions[rowIndexInPage],
                offsetLeft: offsetLeft,
                dimensions: dimensions,
                rowHeight: baseRowHeight,
                tabbableCell: tabbableCell,
                pinnedColumns: pinnedColumns,
                visibleColumns: visibleColumns,
                renderContext: currentRenderContext,
                focusedColumnIndex: hasFocus ? focusedCell.columnIndex : undefined,
                isFirstVisible: isFirstVisible,
                isLastVisible: isLastVisible,
                isNotVisible: isNotVisible
            }, rowProps), id));
            const panel = panels.get(id);
            if (panel) rows.push(panel);
            if (isLastVisible) rows.push(apiRef.current.getInfiniteLoadingTriggerElement?.({
                lastRowId: id
            }));
        });
        return rows;
    };
    const needsHorizontalScrollbar = outerSize.width && columnsTotalWidth >= outerSize.width;
    const scrollerStyle = $f2Y41.useMemo(()=>({
            overflowX: !needsHorizontalScrollbar ? "hidden" : undefined,
            overflowY: rootProps.autoHeight ? "hidden" : undefined
        }), [
        needsHorizontalScrollbar,
        rootProps.autoHeight
    ]);
    const contentSize = $f2Y41.useMemo(()=>{
        // In cases where the columns exceed the available width,
        // the horizontal scrollbar should be shown even when there're no rows.
        // Keeping 1px as minimum height ensures that the scrollbar will visible if necessary.
        const height = Math.max(contentHeight, 1);
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : "auto",
            height: height
        };
        if (rootProps.autoHeight) {
            if (currentPage.rows.length === 0) size.height = (0, $5a37f1a88e056eac$export$5475857f45a72a6e)(apiRef); // Give room to show the overlay when there no rows.
            else size.height = contentHeight;
        }
        return size;
    }, [
        apiRef,
        columnsTotalWidth,
        contentHeight,
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        currentPage.rows.length
    ]);
    $f2Y41.useEffect(()=>{
        apiRef.current.publishEvent("virtualScrollerContentSizeChange");
    }, [
        apiRef,
        contentSize
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        // FIXME: Is this really necessary?
        apiRef.current.resize();
    }, [
        apiRef,
        rowsMeta.currentPageTotalHeight
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (enabled) {
            // TODO a scroll reset should not be necessary
            scrollerRef.current.scrollLeft = 0;
            scrollerRef.current.scrollTop = 0;
        }
    }, [
        enabled,
        gridRootRef,
        scrollerRef
    ]);
    (0, $966a5e767f8d7c81$export$a3576ea6e6df583c)(outerSize.width !== 0, ()=>{
        const inputs = $0ef91cf32c4de50f$var$inputsSelector(apiRef, rootProps, enabled, enabledForColumns);
        const initialRenderContext = $0ef91cf32c4de50f$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        updateRenderContext(initialRenderContext);
        apiRef.current.publishEvent("scrollPositionChange", {
            top: scrollPosition.current.top,
            left: scrollPosition.current.left,
            renderContext: initialRenderContext
        });
    });
    apiRef.current.register("private", {
        updateRenderContext: forceUpdateRenderContext
    });
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnsChange", forceUpdateRenderContext);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "filteredRowsSet", forceUpdateRenderContext);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowExpansionChange", forceUpdateRenderContext);
    return {
        renderContext: renderContext,
        setPanels: setPanels,
        getRows: getRows,
        getContainerProps: ()=>({
                ref: mainRef
            }),
        getScrollerProps: ()=>({
                ref: scrollerRef,
                tabIndex: -1,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove,
                style: scrollerStyle,
                role: "presentation"
            }),
        getContentProps: ()=>({
                style: contentSize,
                role: "presentation"
            }),
        getRenderZoneProps: ()=>({
                role: "rowgroup"
            }),
        getScrollbarVerticalProps: ()=>({
                ref: scrollbarVerticalRef,
                role: "presentation"
            }),
        getScrollbarHorizontalProps: ()=>({
                ref: scrollbarHorizontalRef,
                role: "presentation"
            })
    };
};
function $0ef91cf32c4de50f$var$inputsSelector(apiRef, rootProps, enabled, enabledForColumns) {
    const dimensions = (0, $13cd7539f33578ca$export$26d8768b83a52ffd)(apiRef.current.state);
    const currentPage = (0, $5102b0c2afb145a4$export$79b9fa322a34430b)(apiRef, rootProps);
    const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
    const lastRowId = apiRef.current.state.rows.dataRowIds.at(-1);
    const lastColumn = visibleColumns.at(-1);
    return {
        enabled: enabled,
        enabledForColumns: enabledForColumns,
        apiRef: apiRef,
        autoHeight: rootProps.autoHeight,
        rowBufferPx: rootProps.rowBufferPx,
        columnBufferPx: rootProps.columnBufferPx,
        leftPinnedWidth: dimensions.leftPinnedWidth,
        columnsTotalWidth: dimensions.columnsTotalWidth,
        viewportInnerWidth: dimensions.viewportInnerSize.width,
        viewportInnerHeight: dimensions.viewportInnerSize.height,
        lastRowHeight: lastRowId !== undefined ? apiRef.current.unstable_getRowHeight(lastRowId) : 0,
        lastColumnWidth: lastColumn?.computedWidth ?? 0,
        rowsMeta: (0, $7662854de25f6bb1$export$4f32bfc70efeb4ab)(apiRef.current.state),
        columnPositions: (0, $b22d10f7b8994eba$export$fce7d810e48021e3)(apiRef),
        rows: currentPage.rows,
        range: currentPage.range,
        pinnedColumns: (0, $b22d10f7b8994eba$export$297e8079713afa11)(apiRef),
        visibleColumns: visibleColumns
    };
}
function $0ef91cf32c4de50f$var$computeRenderContext(inputs, scrollPosition, scrollCache) {
    let renderContext;
    if (!inputs.enabled) renderContext = {
        firstRowIndex: 0,
        lastRowIndex: inputs.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: inputs.visibleColumns.length
    };
    else {
        const { top: top, left: left } = scrollPosition;
        const realLeft = Math.abs(left) + inputs.leftPinnedWidth;
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        const firstRowIndex = Math.min($0ef91cf32c4de50f$var$getNearestIndexToRender(inputs, top, {
            atStart: true,
            lastPosition: inputs.rowsMeta.positions[inputs.rowsMeta.positions.length - 1] + inputs.lastRowHeight
        }), inputs.rowsMeta.positions.length - 1);
        const lastRowIndex = inputs.autoHeight ? firstRowIndex + inputs.rows.length : $0ef91cf32c4de50f$var$getNearestIndexToRender(inputs, top + inputs.viewportInnerHeight);
        let firstColumnIndex = 0;
        let lastColumnIndex = inputs.columnPositions.length;
        if (inputs.enabledForColumns) {
            let hasRowWithAutoHeight = false;
            const [firstRowToRender, lastRowToRender] = $0ef91cf32c4de50f$var$getIndexesToRender({
                firstIndex: firstRowIndex,
                lastIndex: lastRowIndex,
                minFirstIndex: 0,
                maxLastIndex: inputs.rows.length,
                bufferBefore: scrollCache.buffer.rowBefore,
                bufferAfter: scrollCache.buffer.rowAfter,
                positions: inputs.rowsMeta.positions,
                lastSize: inputs.lastRowHeight
            });
            for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
                const row = inputs.rows[i];
                hasRowWithAutoHeight = inputs.apiRef.current.rowHasAutoHeight(row.id);
            }
            if (!hasRowWithAutoHeight) {
                firstColumnIndex = $0ef91cf32c4de50f$var$binarySearch(realLeft, inputs.columnPositions, {
                    atStart: true,
                    lastPosition: inputs.columnsTotalWidth
                });
                lastColumnIndex = $0ef91cf32c4de50f$var$binarySearch(realLeft + inputs.viewportInnerWidth, inputs.columnPositions);
            }
        }
        renderContext = {
            firstRowIndex: firstRowIndex,
            lastRowIndex: lastRowIndex,
            firstColumnIndex: firstColumnIndex,
            lastColumnIndex: lastColumnIndex
        };
    }
    const actualRenderContext = $0ef91cf32c4de50f$var$deriveRenderContext(inputs, renderContext, scrollCache);
    return actualRenderContext;
}
function $0ef91cf32c4de50f$var$getNearestIndexToRender(inputs, offset, options) {
    const lastMeasuredIndexRelativeToAllRows = inputs.apiRef.current.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if (inputs.range?.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= inputs.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(lastMeasuredIndexRelativeToAllRows - (inputs.range?.firstRowIndex || 0), 0, inputs.rowsMeta.positions.length);
    if (allRowsMeasured || inputs.rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $0ef91cf32c4de50f$var$binarySearch(offset, inputs.rowsMeta.positions, options);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $0ef91cf32c4de50f$var$exponentialSearch(offset, inputs.rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage, options);
}
/**
 * Accepts as input a raw render context (the area visible in the viewport) and adds
 * computes the actual render context based on pinned elements, buffer dimensions and
 * spanning.
 */ function $0ef91cf32c4de50f$var$deriveRenderContext(inputs, nextRenderContext, scrollCache) {
    const [firstRowToRender, lastRowToRender] = $0ef91cf32c4de50f$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstRowIndex,
        lastIndex: nextRenderContext.lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: inputs.rows.length,
        bufferBefore: scrollCache.buffer.rowBefore,
        bufferAfter: scrollCache.buffer.rowAfter,
        positions: inputs.rowsMeta.positions,
        lastSize: inputs.lastRowHeight
    });
    const [initialFirstColumnToRender, lastColumnToRender] = $0ef91cf32c4de50f$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstColumnIndex,
        lastIndex: nextRenderContext.lastColumnIndex,
        minFirstIndex: inputs.pinnedColumns.left.length,
        maxLastIndex: inputs.visibleColumns.length - inputs.pinnedColumns.right.length,
        bufferBefore: scrollCache.buffer.columnBefore,
        bufferAfter: scrollCache.buffer.columnAfter,
        positions: inputs.columnPositions,
        lastSize: inputs.lastColumnWidth
    });
    const firstColumnToRender = (0, $977688d2f2933ee3$export$6143417adb92779f)({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef: inputs.apiRef,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: inputs.rows
    });
    return {
        firstRowIndex: firstRowToRender,
        lastRowIndex: lastRowToRender,
        firstColumnIndex: firstColumnToRender,
        lastColumnIndex: lastColumnToRender
    };
}
/**
 * Use binary search to avoid looping through all possible positions.
 * The `options.atStart` provides the possibility to match for the first element that
 * intersects the screen, even if said element's start position is before `offset`. In
 * other words, we search for `offset + width`.
 */ function $0ef91cf32c4de50f$var$binarySearch(offset, positions, options, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const position = positions[pivot];
    let isBefore;
    if (options?.atStart) {
        const width = (pivot === positions.length - 1 ? options.lastPosition : positions[pivot + 1]) - position;
        isBefore = offset - width < position;
    } else isBefore = offset <= position;
    return isBefore ? $0ef91cf32c4de50f$var$binarySearch(offset, positions, options, sliceStart, pivot) : $0ef91cf32c4de50f$var$binarySearch(offset, positions, options, pivot + 1, sliceEnd);
}
function $0ef91cf32c4de50f$var$exponentialSearch(offset, positions, index, options) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $0ef91cf32c4de50f$var$binarySearch(offset, positions, options, Math.floor(index / 2), Math.min(index, positions.length));
}
function $0ef91cf32c4de50f$var$getIndexesToRender({ firstIndex: firstIndex, lastIndex: lastIndex, bufferBefore: bufferBefore, bufferAfter: bufferAfter, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex, positions: positions, lastSize: lastSize }) {
    const firstPosition = positions[firstIndex] - bufferBefore;
    const lastPosition = positions[lastIndex] + bufferAfter;
    const firstIndexPadded = $0ef91cf32c4de50f$var$binarySearch(firstPosition, positions, {
        atStart: true,
        lastPosition: positions[positions.length - 1] + lastSize
    });
    const lastIndexPadded = $0ef91cf32c4de50f$var$binarySearch(lastPosition, positions);
    return [
        (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(firstIndexPadded, minFirstIndex, maxLastIndex),
        (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(lastIndexPadded, minFirstIndex, maxLastIndex)
    ];
}
function $0ef91cf32c4de50f$export$6eb241d16b36f3b8(context1, context2) {
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
}
function $0ef91cf32c4de50f$export$fe1f1566870c3cbc(columnPositions, renderContext, direction, pinnedLeftLength) {
    const factor = direction === "ltr" ? 1 : -1;
    const left = factor * (columnPositions[renderContext.firstColumnIndex] ?? 0) - (columnPositions[pinnedLeftLength] ?? 0);
    return Math.abs(left);
}
function $0ef91cf32c4de50f$var$directionForDelta(dx, dy) {
    if (dx === 0 && dy === 0) return $0ef91cf32c4de50f$var$ScrollDirection.NONE;
    /* eslint-disable */ if (Math.abs(dy) >= Math.abs(dx)) {
        if (dy > 0) return $0ef91cf32c4de50f$var$ScrollDirection.DOWN;
        else return $0ef91cf32c4de50f$var$ScrollDirection.UP;
    } else {
        if (dx > 0) return $0ef91cf32c4de50f$var$ScrollDirection.RIGHT;
        else return $0ef91cf32c4de50f$var$ScrollDirection.LEFT;
    }
/* eslint-enable */ }
function $0ef91cf32c4de50f$var$bufferForDirection(mode, direction, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    if (mode === "rtl") switch(direction){
        case $0ef91cf32c4de50f$var$ScrollDirection.LEFT:
            direction = $0ef91cf32c4de50f$var$ScrollDirection.RIGHT;
            break;
        case $0ef91cf32c4de50f$var$ScrollDirection.RIGHT:
            direction = $0ef91cf32c4de50f$var$ScrollDirection.LEFT;
            break;
        default:
    }
    switch(direction){
        case $0ef91cf32c4de50f$var$ScrollDirection.NONE:
            return {
                rowAfter: rowBufferPx,
                rowBefore: rowBufferPx,
                columnAfter: columnBufferPx,
                columnBefore: columnBufferPx
            };
        case $0ef91cf32c4de50f$var$ScrollDirection.LEFT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: horizontalBuffer
            };
        case $0ef91cf32c4de50f$var$ScrollDirection.RIGHT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: horizontalBuffer,
                columnBefore: 0
            };
        case $0ef91cf32c4de50f$var$ScrollDirection.UP:
            return {
                rowAfter: 0,
                rowBefore: verticalBuffer,
                columnAfter: 0,
                columnBefore: 0
            };
        case $0ef91cf32c4de50f$var$ScrollDirection.DOWN:
            return {
                rowAfter: verticalBuffer,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: 0
            };
        default:
            // eslint unable to figure out enum exhaustiveness
            throw new Error("unreachable");
    }
}



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");














var $ge3KO = parcelRequire("ge3KO");
const $b0c8d8f683c4dc04$var$GridOverlayWrapperRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "OverlayWrapper",
    shouldForwardProp: (prop)=>prop !== "overlayType",
    overridesResolver: (props, styles)=>styles.overlayWrapper
})(({ overlayType: overlayType })=>({
        position: "sticky",
        // To stay in place while scrolling
        top: "var(--DataGrid-headersTotalHeight)",
        left: 0,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === "loadingOverlay" ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    }));
const $b0c8d8f683c4dc04$var$GridOverlayWrapperInner = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "OverlayWrapperInner",
    shouldForwardProp: (prop)=>prop !== "overlayType",
    overridesResolver: (props, styles)=>styles.overlayWrapperInner
})({});
const $b0c8d8f683c4dc04$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "overlayWrapper"
        ],
        inner: [
            "overlayWrapperInner"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $b0c8d8f683c4dc04$var$GridOverlayWrapper(props) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const currentPage = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, rootProps);
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    let height = dimensions.viewportOuterSize.height - dimensions.headersTotalHeight - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    if (rootProps.autoHeight && currentPage.rows.length === 0 || height === 0) height = (0, $5a37f1a88e056eac$export$5475857f45a72a6e)(apiRef);
    const classes = $b0c8d8f683c4dc04$var$useUtilityClasses((0, $asN9r.default)({}, props, {
        classes: rootProps.classes
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsx)($b0c8d8f683c4dc04$var$GridOverlayWrapperRoot, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root),
        overlayType: props.overlayType,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($b0c8d8f683c4dc04$var$GridOverlayWrapperInner, (0, $asN9r.default)({
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.inner),
            style: {
                height: height,
                width: dimensions.viewportOuterSize.width
            }
        }, props))
    });
}
function $b0c8d8f683c4dc04$export$867f5fc44327bee5() {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const totalRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$1641ef9d08e265ca));
    const visibleRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$96919017bbfaec0d));
    const loading = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$3c966d405f950b08));
    const showNoRowsOverlay = !loading && totalRowCount === 0;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    let overlay = null;
    let overlayType = "";
    if (showNoRowsOverlay) {
        overlay = /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.noRowsOverlay, (0, $asN9r.default)({}, rootProps.slotProps?.noRowsOverlay));
        overlayType = "noRowsOverlay";
    }
    if (showNoResultsOverlay) {
        overlay = /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.noResultsOverlay, (0, $asN9r.default)({}, rootProps.slotProps?.noResultsOverlay));
        overlayType = "noResultsOverlay";
    }
    if (loading) {
        overlay = /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.loadingOverlay, (0, $asN9r.default)({}, rootProps.slotProps?.loadingOverlay));
        overlayType = "loadingOverlay";
    }
    if (overlay === null) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)($b0c8d8f683c4dc04$var$GridOverlayWrapper, {
        overlayType: overlayType,
        children: overlay
    });
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");









const $330dcabfc9b8bbf2$export$5479c2fb8e9fd070 = (state)=>state.columnMenu;



var $ge3KO = parcelRequire("ge3KO");
function $1acc267978f2e34e$var$GridHeaders() {
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$16a65a9447d3dda9));
    const filterColumnLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$6b2da1ecc84b757a));
    const sortColumnLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$4dfdcc434a6c5081));
    const columnHeaderTabIndexState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$29da670438604dbd));
    const cellTabIndexState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$2c47652a1f657d56));
    const columnGroupHeaderTabIndexState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$37a54bd010f498d2));
    const columnHeaderFocus = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$cefd405855792f4a));
    const columnGroupHeaderFocus = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$3eeedc3f7263df61));
    const headerGroupingMaxDepth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $60b55b5d22f1422b$export$4cf0369c079b29be));
    const columnMenuState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $330dcabfc9b8bbf2$export$5479c2fb8e9fd070));
    const columnVisibility = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4));
    const columnGroupsHeaderStructure = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $60b55b5d22f1422b$export$8f859ed1f2777746));
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && cellTabIndexState === null);
    const columnsContainerRef = $f2Y41.useRef(null);
    apiRef.current.register("private", {
        columnHeadersContainerRef: columnsContainerRef
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnHeaders, (0, $asN9r.default)({
        ref: columnsContainerRef,
        visibleColumns: visibleColumns,
        filterColumnLookup: filterColumnLookup,
        sortColumnLookup: sortColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, rootProps.slotProps?.columnHeaders));
}
const $1acc267978f2e34e$export$151397d1f4bb9231 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($1acc267978f2e34e$var$GridHeaders);



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");









function $c75ea6ead94140f4$export$cfcdc2e1121f7851(props) {
    if (props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid) // DataGrid Community has multiple row selection enabled only if checkbox selection is enabled.
    return props.checkboxSelection && props.disableMultipleRowSelection !== true;
    return !props.disableMultipleRowSelection;
}


const $b73d65e466a8ad79$export$89716d1110d32214 = ()=>{
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$16a65a9447d3dda9));
    const totalRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$1641ef9d08e265ca));
    const headerGroupingMaxDepth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $60b55b5d22f1422b$export$4cf0369c079b29be));
    const pinnedRowsCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$8e3fb3525d7db988));
    let role = "grid";
    if (rootProps.treeData) role = "treegrid";
    return {
        role: role,
        "aria-colcount": visibleColumns.length,
        "aria-rowcount": headerGroupingMaxDepth + 1 + pinnedRowsCount + totalRowCount,
        "aria-multiselectable": (0, $c75ea6ead94140f4$export$cfcdc2e1121f7851)(rootProps)
    };
};



var $ge3KO = parcelRequire("ge3KO");
const $88255e4cff151513$var$Element = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "Main",
    overridesResolver: (props, styles)=>styles.main
})({
    flexGrow: 1,
    position: "relative",
    overflow: "hidden"
});
const $88255e4cff151513$export$74039dccf215bc2a = /*#__PURE__*/ $f2Y41.forwardRef((props, ref)=>{
    const ariaAttributes = (0, $b73d65e466a8ad79$export$89716d1110d32214)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $ge3KO.jsx)($88255e4cff151513$var$Element, (0, $asN9r.default)({
        ref: ref,
        ownerState: rootProps,
        className: props.className,
        tabIndex: -1
    }, ariaAttributes, {
        children: props.children
    }));
});



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $35a08623daf4650b$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "topContainer"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), {});
};
const $35a08623daf4650b$var$Element = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    position: "sticky",
    zIndex: 4,
    top: 0,
    "&::after": {
        content: '" "',
        position: "absolute",
        zIndex: 5,
        bottom: 0,
        left: 0,
        right: 0,
        height: 1,
        width: "var(--DataGrid-rowWidth)",
        backgroundColor: "var(--DataGrid-rowBorderColor)"
    }
});
function $35a08623daf4650b$export$820d93aabd2ee77d(props) {
    const classes = $35a08623daf4650b$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ge3KO.jsx)($35a08623daf4650b$var$Element, (0, $asN9r.default)({}, props, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, props.className, (0, $2276c81b0f2e6e46$export$2100d54e36406477)["container--top"]),
        role: "presentation"
    }));
}



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $3b6bacdfd65efd1f$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "bottomContainer"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), {});
};
const $3b6bacdfd65efd1f$var$Element = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    position: "sticky",
    zIndex: 4,
    bottom: "calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))"
});
function $3b6bacdfd65efd1f$export$7b1aa135d0232b20(props) {
    const classes = $3b6bacdfd65efd1f$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ge3KO.jsx)($3b6bacdfd65efd1f$var$Element, (0, $asN9r.default)({}, props, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, props.className, (0, $2276c81b0f2e6e46$export$2100d54e36406477)["container--bottom"]),
        role: "presentation"
    }));
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $45ee53f91433d943$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            "virtualScrollerContent",
            overflowedContent && "virtualScrollerContent--overflowed"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $45ee53f91433d943$var$VirtualScrollerContentRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "VirtualScrollerContent",
    overridesResolver: (props, styles)=>styles.virtualScrollerContent
})({});
const $45ee53f91433d943$export$97d48eb8ba00afb8 = /*#__PURE__*/ $f2Y41.forwardRef(function GridVirtualScrollerContent(props, ref) {
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const overflowedContent = !rootProps.autoHeight && props.style?.minHeight === "auto";
    const classes = $45ee53f91433d943$var$useUtilityClasses(rootProps, overflowedContent);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($45ee53f91433d943$var$VirtualScrollerContentRoot, (0, $asN9r.default)({
        ref: ref
    }, props, {
        ownerState: rootProps,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, props.className)
    }));
});


parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $259e444869933c26$var$Filler = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    display: "flex",
    flexDirection: "row",
    width: "var(--DataGrid-rowWidth)",
    boxSizing: "border-box"
});
const $259e444869933c26$var$Pinned = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    position: "sticky",
    height: "100%",
    boxSizing: "border-box",
    borderTop: "1px solid var(--DataGrid-rowBorderColor)",
    backgroundColor: "var(--DataGrid-pinnedBackground)"
});
const $259e444869933c26$var$PinnedLeft = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)($259e444869933c26$var$Pinned)({
    left: 0,
    borderRight: "1px solid var(--DataGrid-rowBorderColor)"
});
const $259e444869933c26$var$PinnedRight = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)($259e444869933c26$var$Pinned)({
    right: 0,
    borderLeft: "1px solid var(--DataGrid-rowBorderColor)"
});
const $259e444869933c26$var$Main = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    flexGrow: 1,
    borderTop: "1px solid var(--DataGrid-rowBorderColor)"
});
function $259e444869933c26$var$GridVirtualScrollerFiller() {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const { viewportOuterSize: viewportOuterSize, minimumSize: minimumSize, hasScrollX: hasScrollX, hasScrollY: hasScrollY, scrollbarSize: scrollbarSize, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const scrollbarHeight = hasScrollX ? scrollbarSize : 0;
    const expandedHeight = viewportOuterSize.height - minimumSize.height - scrollbarHeight;
    const height = Math.max(scrollbarHeight, expandedHeight);
    if (height === 0) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($259e444869933c26$var$Filler, {
        className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).filler,
        role: "presentation",
        style: {
            height: height
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)($259e444869933c26$var$PinnedLeft, {
                className: (0, $2276c81b0f2e6e46$export$2100d54e36406477)["filler--pinnedLeft"],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)($259e444869933c26$var$Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)($259e444869933c26$var$PinnedRight, {
                className: (0, $2276c81b0f2e6e46$export$2100d54e36406477)["filler--pinnedRight"],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
const $259e444869933c26$export$832a8b454433e1c8 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($259e444869933c26$var$GridVirtualScrollerFiller);



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");










var $ge3KO = parcelRequire("ge3KO");
const $7294ba086f245c8a$var$_excluded = [
    "className"
];
const $7294ba086f245c8a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "virtualScrollerRenderZone"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $7294ba086f245c8a$var$VirtualScrollerRenderZoneRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "VirtualScrollerRenderZone",
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: "absolute",
    display: "flex",
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: "column"
});
const $7294ba086f245c8a$export$95930d31e6a9269f = /*#__PURE__*/ $f2Y41.forwardRef(function GridVirtualScrollerRenderZone(props, ref) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $7294ba086f245c8a$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $7294ba086f245c8a$var$useUtilityClasses(rootProps);
    const offsetTop = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, ()=>{
        const renderContext = (0, $de91a359006882c0$export$4cf9f333a030f780)(apiRef);
        const rowsMeta = (0, $7662854de25f6bb1$export$4f32bfc70efeb4ab)(apiRef.current.state);
        return rowsMeta.positions[renderContext.firstRowIndex] ?? 0;
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)($7294ba086f245c8a$var$VirtualScrollerRenderZoneRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps,
        style: {
            transform: `translate3d(0, ${offsetTop}px, 0)`
        }
    }, other));
});



var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $dd7715b8f6067ca4$var$useUtilityClasses = (ownerState, position)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "scrollbar",
            `scrollbar--${position}`
        ],
        content: [
            "scrollbarContent"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $dd7715b8f6067ca4$var$Scrollbar = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    position: "absolute",
    display: "inline-block",
    zIndex: 6,
    "& > div": {
        display: "inline-block"
    },
    // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
    // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
    // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
    // don't have a method to find the required size for scrollbars on those platforms.
    "--size": "calc(max(var(--DataGrid-scrollbarSize), 14px))"
});
const $dd7715b8f6067ca4$var$ScrollbarVertical = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)($dd7715b8f6067ca4$var$Scrollbar)({
    width: "var(--size)",
    height: "calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))",
    overflowY: "auto",
    overflowX: "hidden",
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    "& > div": {
        width: "var(--size)"
    },
    top: "var(--DataGrid-topContainerHeight)",
    right: "0px"
});
const $dd7715b8f6067ca4$var$ScrollbarHorizontal = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)($dd7715b8f6067ca4$var$Scrollbar)({
    width: "100%",
    height: "var(--size)",
    overflowY: "hidden",
    overflowX: "auto",
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    "& > div": {
        height: "var(--size)"
    },
    bottom: "0px"
});
const $dd7715b8f6067ca4$var$Content = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    display: "inline-block"
});
const $dd7715b8f6067ca4$export$96aeae8bf32b76b8 = /*#__PURE__*/ $f2Y41.forwardRef(function GridVirtualScrollbar(props, ref) {
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const isLocked = $f2Y41.useRef(false);
    const lastPosition = $f2Y41.useRef(0);
    const scrollbarRef = $f2Y41.useRef(null);
    const contentRef = $f2Y41.useRef(null);
    const classes = $dd7715b8f6067ca4$var$useUtilityClasses(rootProps, props.position);
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const propertyDimension = props.position === "vertical" ? "height" : "width";
    const propertyScroll = props.position === "vertical" ? "scrollTop" : "scrollLeft";
    const hasScroll = props.position === "vertical" ? dimensions.hasScrollX : dimensions.hasScrollY;
    const contentSize = dimensions.minimumSize[propertyDimension] + (hasScroll ? dimensions.scrollbarSize : 0);
    const scrollbarSize = props.position === "vertical" ? dimensions.viewportInnerSize.height : dimensions.viewportOuterSize.width;
    const scrollbarInnerSize = scrollbarSize * (contentSize / dimensions.viewportOuterSize[propertyDimension]);
    const onScrollerScroll = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (scroller[propertyScroll] === lastPosition.current) return;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        const value = scroller[propertyScroll] / contentSize;
        scrollbar[propertyScroll] = value * scrollbarInnerSize;
        lastPosition.current = scroller[propertyScroll];
    });
    const onScrollbarScroll = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        const value = scrollbar[propertyScroll] / scrollbarInnerSize;
        scroller[propertyScroll] = value * contentSize;
    });
    (0, $33567b05615fab88$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        scroller.addEventListener("scroll", onScrollerScroll, {
            capture: true
        });
        scrollbar.addEventListener("scroll", onScrollbarScroll, {
            capture: true
        });
        return ()=>{
            scroller.removeEventListener("scroll", onScrollerScroll, {
                capture: true
            });
            scrollbar.removeEventListener("scroll", onScrollbarScroll, {
                capture: true
            });
        };
    });
    $f2Y41.useEffect(()=>{
        const content = contentRef.current;
        content.style.setProperty(propertyDimension, `${scrollbarInnerSize}px`);
    }, [
        scrollbarInnerSize,
        propertyDimension
    ]);
    const Container = props.position === "vertical" ? $dd7715b8f6067ca4$var$ScrollbarVertical : $dd7715b8f6067ca4$var$ScrollbarHorizontal;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(Container, {
        ref: (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(ref, scrollbarRef),
        className: classes.root,
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($dd7715b8f6067ca4$var$Content, {
            ref: contentRef,
            className: classes.content
        })
    });
});



var $ge3KO = parcelRequire("ge3KO");
const $7798873cda22cc6e$var$useUtilityClasses = (ownerState, dimensions)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "main",
            dimensions.rightPinnedWidth > 0 && "main--hasPinnedRight"
        ],
        scroller: [
            "virtualScroller"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $7798873cda22cc6e$var$Scroller = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "VirtualScroller",
    overridesResolver: (props, styles)=>styles.virtualScroller
})({
    position: "relative",
    height: "100%",
    overflow: "scroll",
    scrollbarWidth: "none" /* Firefox */ ,
    "&::-webkit-scrollbar": {
        display: "none" /* Safari and Chrome */ 
    },
    "@media print": {
        overflow: "hidden"
    },
    // See https://github.com/mui/mui-x/issues/10547
    zIndex: 0
});
function $7798873cda22cc6e$export$febd8ae712031b27(props) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const classes = $7798873cda22cc6e$var$useUtilityClasses(rootProps, dimensions);
    const virtualScroller = (0, $0ef91cf32c4de50f$export$fbe94079134c8d27)();
    const { getContainerProps: getContainerProps, getScrollerProps: getScrollerProps, getContentProps: getContentProps, getRenderZoneProps: getRenderZoneProps, getScrollbarVerticalProps: getScrollbarVerticalProps, getScrollbarHorizontalProps: getScrollbarHorizontalProps, getRows: getRows } = virtualScroller;
    const rows = getRows();
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $88255e4cff151513$export$74039dccf215bc2a), (0, $asN9r.default)({
        className: classes.root
    }, getContainerProps(), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ae9a1c17fef92bab$export$40bcbdb719b20690), {
                scrollDirection: "left"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ae9a1c17fef92bab$export$40bcbdb719b20690), {
                scrollDirection: "right"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)($7798873cda22cc6e$var$Scroller, (0, $asN9r.default)({
                className: classes.scroller
            }, getScrollerProps(), {
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $35a08623daf4650b$export$820d93aabd2ee77d), {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1acc267978f2e34e$export$151397d1f4bb9231), {}),
                            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.pinnedRows, {
                                position: "top",
                                virtualScroller: virtualScroller
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b0c8d8f683c4dc04$export$867f5fc44327bee5), {}),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $45ee53f91433d943$export$97d48eb8ba00afb8), (0, $asN9r.default)({}, getContentProps(), {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $7294ba086f245c8a$export$95930d31e6a9269f), (0, $asN9r.default)({}, getRenderZoneProps(), {
                            children: [
                                rows,
                                /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.detailPanels, {
                                    virtualScroller: virtualScroller
                                })
                            ]
                        }))
                    })),
                    rows.length > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $259e444869933c26$export$832a8b454433e1c8), {}),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3b6bacdfd65efd1f$export$7b1aa135d0232b20), {
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.pinnedRows, {
                            position: "bottom",
                            virtualScroller: virtualScroller
                        })
                    })
                ]
            })),
            dimensions.hasScrollY && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dd7715b8f6067ca4$export$96aeae8bf32b76b8), (0, $asN9r.default)({
                position: "vertical"
            }, getScrollbarVerticalProps())),
            dimensions.hasScrollX && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dd7715b8f6067ca4$export$96aeae8bf32b76b8), (0, $asN9r.default)({
                position: "horizontal"
            }, getScrollbarHorizontalProps())),
            props.children
        ]
    }));
}


var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");
function $248d6f2656fe196f$export$4fd26c08a15cabb4({ privateApiRef: privateApiRef, props: props, children: children }) {
    const apiRef = $f2Y41.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $144bec24a50df06b$export$e00c5fe7e13db7ba).Provider, {
        value: props,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ce64d818c6a4c305$export$37099e7a34cbf988).Provider, {
            value: privateApiRef,
            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a4832b93f7e3ab58$export$70c437c2dab15e52).Provider, {
                value: apiRef,
                children: children
            })
        })
    });
}


var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
function $e5465f61488c59e8$export$6d80c98441abb3ab() {
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.footer, (0, $asN9r.default)({}, rootProps.slotProps?.footer /* FIXME: typing error */ ));
}


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


const $89c72c98e1cc6fad$export$37e5474577e02878 = (state)=>state.preferencePanel;


var $3f22a63fe503dede$export$e7e5652452e44b = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    return GridPreferencePanelsValue;
}($3f22a63fe503dede$export$e7e5652452e44b || {});





var $ge3KO = parcelRequire("ge3KO");
const $865a3ece2c6d99c6$export$6cff59e5608ce17d = /*#__PURE__*/ $f2Y41.forwardRef(function GridPreferencesPanel(props, ref) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const columns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$da85f06e3c19f1fd));
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const preferencePanelState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $89c72c98e1cc6fad$export$37e5474577e02878));
    const panelContent = apiRef.current.unstable_applyPipeProcessors("preferencePanel", null, preferencePanelState.openedPanelValue ?? (0, $3f22a63fe503dede$export$e7e5652452e44b).filters);
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.panel, (0, $asN9r.default)({
        ref: ref,
        as: rootProps.slots.basePopper,
        open: columns.length > 0 && preferencePanelState.open,
        id: preferencePanelState.panelId,
        "aria-labelledby": preferencePanelState.labelId
    }, rootProps.slotProps?.panel, props, rootProps.slotProps?.basePopper, {
        children: panelContent
    }));
});



var $ge3KO = parcelRequire("ge3KO");
function $d3f1a76f387112bb$export$74ac40502a3200d3() {
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $865a3ece2c6d99c6$export$6cff59e5608ce17d), {}),
            rootProps.slots.toolbar && /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.toolbar, (0, $asN9r.default)({}, rootProps.slotProps?.toolbar))
        ]
    });
}


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $gl072 = parcelRequire("gl072");


var $asN9r = parcelRequire("asN9r");

var $aahau = parcelRequire("aahau");

var $fzDmb = parcelRequire("fzDmb");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $533e05963543ab3e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $fzDmb.default)(value, min, max);
}
function $533e05963543ab3e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $533e05963543ab3e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $533e05963543ab3e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $533e05963543ab3e$export$677b39864803984e($533e05963543ab3e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $aahau.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $aahau.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $533e05963543ab3e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $533e05963543ab3e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $533e05963543ab3e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $533e05963543ab3e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $533e05963543ab3e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $533e05963543ab3e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $533e05963543ab3e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$533e05963543ab3e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $533e05963543ab3e$export$29fb7152bd3f781a(color) {
    color = $533e05963543ab3e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $533e05963543ab3e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $533e05963543ab3e$export$c852d90bf7403b62(color) {
    color = $533e05963543ab3e$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $533e05963543ab3e$export$677b39864803984e($533e05963543ab3e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $533e05963543ab3e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $533e05963543ab3e$export$c852d90bf7403b62(foreground);
    const lumB = $533e05963543ab3e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $533e05963543ab3e$export$58f0f39f63f3cf42(color, value) {
    color = $533e05963543ab3e$export$677b39864803984e(color);
    value = $533e05963543ab3e$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $533e05963543ab3e$export$211a73f2b8c10ce4(color);
}
function $533e05963543ab3e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $533e05963543ab3e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $533e05963543ab3e$export$4b073707ff63303(color, coefficient) {
    color = $533e05963543ab3e$export$677b39864803984e(color);
    coefficient = $533e05963543ab3e$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $533e05963543ab3e$export$211a73f2b8c10ce4(color);
}
function $533e05963543ab3e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $533e05963543ab3e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $533e05963543ab3e$export$c0816ed86df316af(color, coefficient) {
    color = $533e05963543ab3e$export$677b39864803984e(color);
    coefficient = $533e05963543ab3e$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $533e05963543ab3e$export$211a73f2b8c10ce4(color);
}
function $533e05963543ab3e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $533e05963543ab3e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $533e05963543ab3e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $533e05963543ab3e$export$c852d90bf7403b62(color) > 0.5 ? $533e05963543ab3e$export$4b073707ff63303(color, coefficient) : $533e05963543ab3e$export$c0816ed86df316af(color, coefficient);
}
function $533e05963543ab3e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $533e05963543ab3e$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $533e05963543ab3e$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $533e05963543ab3e$export$677b39864803984e(background);
    const overlayColor = $533e05963543ab3e$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $533e05963543ab3e$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}



function $2166929197bf47fb$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === "light") return (0, $533e05963543ab3e$export$c0816ed86df316af)((0, $533e05963543ab3e$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.88);
    return (0, $533e05963543ab3e$export$4b073707ff63303)((0, $533e05963543ab3e$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.68);
}
const $2166929197bf47fb$var$columnHeadersStyles = {
    [`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnSeparator}, .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizing"]}`]: {
        visibility: "visible",
        width: "auto"
    }
};
const $2166929197bf47fb$var$columnHeaderStyles = {
    [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconButtonContainer}`]: {
        visibility: "visible",
        width: "auto"
    },
    [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`]: {
        width: "auto",
        visibility: "visible"
    }
};
const $2166929197bf47fb$export$42458c7ae3a97297 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).aggregationColumnHeader}`]: styles.aggregationColumnHeader
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["aggregationColumnHeader--alignLeft"]}`]: styles["aggregationColumnHeader--alignLeft"]
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["aggregationColumnHeader--alignCenter"]}`]: styles["aggregationColumnHeader--alignCenter"]
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["aggregationColumnHeader--alignRight"]}`]: styles["aggregationColumnHeader--alignRight"]
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).aggregationColumnHeaderLabel}`]: styles.aggregationColumnHeaderLabel
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["root--disableUserSelection"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: styles["root--disableUserSelection"]
            },
            {
                [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).autosizing}`]: styles.autosizing
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: styles.cell
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--editing"]}`]: styles["cell--editing"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--textCenter"]}`]: styles["cell--textCenter"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--textLeft"]}`]: styles["cell--textLeft"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--textRight"]}`]: styles["cell--textRight"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--rangeTop"]}`]: styles["cell--rangeTop"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--rangeBottom"]}`]: styles["cell--rangeBottom"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--rangeLeft"]}`]: styles["cell--rangeLeft"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--rangeRight"]}`]: styles["cell--rangeRight"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--withRightBorder"]}`]: styles["cell--withRightBorder"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignCenter"]}`]: styles["columnHeader--alignCenter"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignLeft"]}`]: styles["columnHeader--alignLeft"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignRight"]}`]: styles["columnHeader--alignRight"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--dragging"]}`]: styles["columnHeader--dragging"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--moving"]}`]: styles["columnHeader--moving"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--numeric"]}`]: styles["columnHeader--numeric"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--sortable"]}`]: styles["columnHeader--sortable"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--sorted"]}`]: styles["columnHeader--sorted"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--withRightBorder"]}`]: styles["columnHeader--withRightBorder"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizable"]}`]: styles["columnSeparator--resizable"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizing"]}`]: styles["columnSeparator--resizing"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--editable"]}`]: styles["row--editable"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--editing"]}`]: styles["row--editing"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--dragging"]}`]: styles["row--dragging"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).row}`]: styles.row
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["rowReorderCell--draggable"]}`]: styles["rowReorderCell--draggable"]
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).withBorderColor}`]: styles.withBorderColor
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["detailPanelToggleCell--expanded"]}`]: styles["detailPanelToggleCell--expanded"]
            },
            styles.root
        ]
})(({ theme: t })=>{
    const borderColor = $2166929197bf47fb$var$getBorderColor(t);
    const radius = t.shape.borderRadius;
    const containerBackground = t.vars ? t.vars.palette.background.default : t.mixins.MuiDataGrid?.containerBackground ?? t.palette.background.default;
    const pinnedBackground = t.mixins.MuiDataGrid?.pinnedBackground ?? containerBackground;
    const overlayBackground = t.vars ? `rgba(${t.vars.palette.background.defaultChannel} / ${t.vars.palette.action.disabledOpacity})` : (0, $533e05963543ab3e$export$58f0f39f63f3cf42)(t.palette.background.default, t.palette.action.disabledOpacity);
    const hoverOpacity = (t.vars || t).palette.action.hoverOpacity;
    const hoverColor = (t.vars || t).palette.action.hover;
    const selectedOpacity = (t.vars || t).palette.action.selectedOpacity;
    const selectedBackground = t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${selectedOpacity})` : (0, $533e05963543ab3e$export$58f0f39f63f3cf42)(t.palette.primary.main, selectedOpacity);
    const selectedHoverBackground = t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / calc(
                ${t.vars.palette.action.selectedOpacity} + 
                ${t.vars.palette.action.hoverOpacity}
              ))` : (0, $533e05963543ab3e$export$58f0f39f63f3cf42)(t.palette.primary.main, t.palette.action.selectedOpacity + t.palette.action.hoverOpacity);
    const pinnedHoverBackground = t.vars ? hoverColor : $2166929197bf47fb$var$blend(pinnedBackground, hoverColor, hoverOpacity);
    const pinnedSelectedBackground = t.vars ? selectedBackground : $2166929197bf47fb$var$blend(pinnedBackground, selectedBackground, selectedOpacity);
    const pinnedSelectedHoverBackground = t.vars ? hoverColor : $2166929197bf47fb$var$blend(pinnedSelectedBackground, hoverColor, hoverOpacity);
    const selectedStyles = {
        backgroundColor: selectedBackground,
        "&:hover": {
            backgroundColor: selectedHoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: selectedBackground
            }
        }
    };
    const gridStyle = (0, $asN9r.default)({
        "--unstable_DataGrid-radius": typeof radius === "number" ? `${radius}px` : radius,
        "--unstable_DataGrid-headWeight": t.typography.fontWeightMedium,
        "--unstable_DataGrid-overlayBackground": overlayBackground,
        "--DataGrid-containerBackground": containerBackground,
        "--DataGrid-pinnedBackground": pinnedBackground,
        "--DataGrid-rowBorderColor": borderColor,
        "--DataGrid-cellOffsetMultiplier": 2,
        "--DataGrid-width": "0px",
        "--DataGrid-hasScrollX": "0",
        "--DataGrid-hasScrollY": "0",
        "--DataGrid-scrollbarSize": "10px",
        "--DataGrid-rowWidth": "0px",
        "--DataGrid-columnsTotalWidth": "0px",
        "--DataGrid-leftPinnedWidth": "0px",
        "--DataGrid-rightPinnedWidth": "0px",
        "--DataGrid-headerHeight": "0px",
        "--DataGrid-headersTotalHeight": "0px",
        "--DataGrid-topContainerHeight": "0px",
        "--DataGrid-bottomContainerHeight": "0px",
        flex: 1,
        boxSizing: "border-box",
        position: "relative",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: borderColor,
        borderRadius: "var(--unstable_DataGrid-radius)",
        color: (t.vars || t).palette.text.primary
    }, t.typography.body2, {
        outline: "none",
        height: "100%",
        display: "flex",
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: "column",
        overflowAnchor: "none",
        // Keep the same scrolling position
        // The selector we really want here is `:first-child`, but emotion thinks it knows better than use what we
        // want and prints a warning to the console if we use it, about :first-child being "unsafe" in an SSR context.
        // https://github.com/emotion-js/emotion/issues/1105
        // Using `:first-of-type instead` is ironically less "safe" because if all our elements aren't `div`, this style
        // will fail to apply.
        [`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).main} > *:first-of-type`]: {
            borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
            borderTopRightRadius: "var(--unstable_DataGrid-radius)"
        },
        [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).autoHeight}`]: {
            height: "auto"
        },
        [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).autosizing}`]: {
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainerContent} > *`]: {
                overflow: "visible !important"
            },
            "@media (hover: hover)": {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconButtonContainer}`]: {
                    width: "0 !important",
                    visibility: "hidden !important"
                },
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`]: {
                    width: "0 !important",
                    visibility: "hidden !important"
                }
            },
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
                overflow: "visible !important",
                whiteSpace: "nowrap",
                minWidth: "max-content !important",
                maxWidth: "max-content !important"
            },
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).groupingCriteriaCell}`]: {
                width: "unset"
            },
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).treeDataGroupingCell}`]: {
                width: "unset"
            }
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
            WebkitTapHighlightColor: "transparent",
            lineHeight: null,
            padding: "0 10px",
            boxSizing: "border-box"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}:focus-within, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}:focus-within`]: {
            outline: `solid ${t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / 0.5)` : (0, $533e05963543ab3e$export$58f0f39f63f3cf42)(t.palette.primary.main, 0.5)} 1px`,
            outlineWidth: 1,
            outlineOffset: -1
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}:focus, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}:focus`]: {
            outline: `solid ${t.palette.primary.main} 1px`
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderCheckbox}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cellCheckbox}`]: {
            padding: 0,
            justifyContent: "center",
            alignItems: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--last"]}`]: {
            overflow: "hidden"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--sorted"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconButtonContainer}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--filtered"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconButtonContainer}`]: {
            visibility: "visible",
            width: "auto"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}:not(.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--sorted"]}) .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).sortIcon}`]: {
            opacity: 0,
            transition: t.transitions.create([
                "opacity"
            ], {
                duration: t.transitions.duration.shorter
            })
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            flex: 1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            // to anchor the aggregation label
            position: "relative"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainerContent}`]: {
            overflow: "hidden",
            display: "flex",
            alignItems: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--filledGroup"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            boxSizing: "border-box"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).sortIcon}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).filterIcon}`]: {
            fontSize: "inherit"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--sortable"]}`]: {
            cursor: "pointer"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignCenter"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            justifyContent: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignRight"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderDraggableContainer}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignRight"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            flexDirection: "row-reverse"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignCenter"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignRight"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`]: {
            marginRight: "auto",
            marginLeft: -6
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignRight"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--alignRight"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`]: {
            marginRight: "auto",
            marginLeft: -10
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--moving"]}`]: {
            backgroundColor: (t.vars || t).palette.action.hover
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--pinnedLeft"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--pinnedRight"]}`]: {
            position: "sticky",
            zIndex: 4,
            // Should be above the column separator
            background: "var(--DataGrid-pinnedBackground)"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnSeparator}`]: {
            visibility: "hidden",
            position: "absolute",
            zIndex: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: borderColor
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaders}`]: {
            width: "var(--DataGrid-rowWidth)"
        },
        "@media (hover: hover)": {
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaders}:hover`]: $2166929197bf47fb$var$columnHeadersStyles,
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}:hover`]: $2166929197bf47fb$var$columnHeaderStyles,
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}:not(.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--sorted"]}):hover .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).sortIcon}`]: {
                opacity: 0.5
            }
        },
        "@media (hover: none)": {
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaders}`]: $2166929197bf47fb$var$columnHeadersStyles,
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}`]: $2166929197bf47fb$var$columnHeaderStyles
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--sideLeft"]}`]: {
            left: -12
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--sideRight"]}`]: {
            right: -12
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizable"]}`]: {
            cursor: "col-resize",
            touchAction: "none",
            "&:hover": {
                color: (t.vars || t).palette.text.primary,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    color: borderColor
                }
            },
            [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizing"]}`]: {
                color: (t.vars || t).palette.text.primary
            },
            "& svg": {
                pointerEvents: "none"
            }
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconSeparator}`]: {
            color: "inherit"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`]: {
            width: 0,
            visibility: "hidden",
            fontSize: 20,
            marginRight: -10,
            display: "flex",
            alignItems: "center"
        },
        [`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuOpen}`]: {
            visibility: "visible",
            width: "auto"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).headerFilterRow}`]: {
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader}`]: {
                boxSizing: "border-box",
                borderTop: "1px solid var(--DataGrid-rowBorderColor)"
            }
        },
        /* Row styles */ [`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).row}`]: {
            display: "flex",
            width: "var(--DataGrid-rowWidth)",
            breakInside: "avoid",
            // Avoid the row to be broken in two different print pages.
            "--rowBorderColor": "var(--DataGrid-rowBorderColor)",
            [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--firstVisible"]}`]: {
                "--rowBorderColor": "transparent"
            },
            "&:hover": {
                backgroundColor: (t.vars || t).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&.Mui-selected": selectedStyles
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["container--top"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["container--bottom"]}`]: {
            "[role=row]": {
                background: "var(--DataGrid-containerBackground)"
            }
        },
        /* Cell styles */ [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
            height: "var(--height)",
            minWidth: "var(--width)",
            maxWidth: "var(--width)",
            lineHeight: "calc(var(--height) - 1px)",
            // -1px for the border
            boxSizing: "border-box",
            borderTop: `1px solid var(--rowBorderColor)`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            "&.Mui-selected": selectedStyles
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["virtualScrollerContent--overflowed"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--lastVisible"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
            borderTopColor: "transparent"
        },
        [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["root--disableUserSelection"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
            userSelect: "none"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--dynamicHeight"]} > .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
            whiteSpace: "initial",
            lineHeight: "inherit"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cellEmpty}`]: {
            padding: 0,
            height: "unset"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--selectionMode"]}`]: {
            cursor: "default"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--editing"]}`]: {
            padding: 1,
            display: "flex",
            boxShadow: t.shadows[2],
            backgroundColor: (t.vars || t).palette.background.paper,
            "&:focus-within": {
                outline: `solid ${(t.vars || t).palette.primary.main} 1px`,
                outlineOffset: "-1px"
            }
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--editing"]}`]: {
            boxShadow: t.shadows[2]
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--editing"]} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`]: {
            boxShadow: t.shadows[0],
            backgroundColor: (t.vars || t).palette.background.paper
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).editBooleanCell}`]: {
            display: "flex",
            height: "100%",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).booleanCell}[data-value="true"]`]: {
            color: (t.vars || t).palette.text.secondary
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).booleanCell}[data-value="false"]`]: {
            color: (t.vars || t).palette.text.disabled
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).actionsCell}`]: {
            display: "inline-flex",
            alignItems: "center",
            gridGap: t.spacing(1)
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).rowReorderCell}`]: {
            display: "inline-flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            opacity: (t.vars || t).palette.action.disabledOpacity
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["rowReorderCell--draggable"]}`]: {
            cursor: "move",
            opacity: 1
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).rowReorderCellContainer}`]: {
            padding: 0,
            display: "flex",
            alignItems: "stretch"
        },
        [`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).withBorderColor}`]: {
            borderColor: borderColor
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--withLeftBorder"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--withLeftBorder"]}`]: {
            borderLeftColor: "var(--DataGrid-rowBorderColor)",
            borderLeftWidth: "1px",
            borderLeftStyle: "solid"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--withRightBorder"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--withRightBorder"]}`]: {
            borderRightColor: "var(--DataGrid-rowBorderColor)",
            borderRightWidth: "1px",
            borderRightStyle: "solid"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--flex"]}`]: {
            display: "flex",
            alignItems: "center",
            lineHeight: "inherit"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--textLeft"]}`]: {
            textAlign: "left",
            justifyContent: "flex-start"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--textRight"]}`]: {
            textAlign: "right",
            justifyContent: "flex-end"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--textCenter"]}`]: {
            textAlign: "center",
            justifyContent: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedLeft"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedRight"]}`]: {
            position: "sticky",
            zIndex: 3,
            background: "var(--DataGrid-pinnedBackground)"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).virtualScrollerContent} .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).row}`]: {
            "&:hover": {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedLeft"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedRight"]}`]: {
                    backgroundColor: pinnedHoverBackground
                }
            },
            [`&.Mui-selected`]: {
                [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedLeft"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedRight"]}`]: {
                    backgroundColor: pinnedSelectedBackground
                },
                "&:hover": {
                    [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedLeft"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--pinnedRight"]}`]: {
                        backgroundColor: pinnedSelectedHoverBackground
                    }
                }
            }
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cellOffsetLeft}`]: {
            flex: "0 0 auto",
            display: "inline-block"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cellSkeleton}`]: {
            flex: "0 0 auto",
            height: "100%",
            display: "inline-flex",
            alignItems: "center"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderDraggableContainer}`]: {
            display: "flex",
            width: "100%",
            height: "100%"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
            display: "none"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--dragging"]}, & .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--dragging"]}`]: {
            background: (t.vars || t).palette.background.paper,
            padding: "0 12px",
            borderRadius: "var(--unstable_DataGrid-radius)",
            opacity: (t.vars || t).palette.action.disabledOpacity
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--dragging"]}`]: {
            background: (t.vars || t).palette.background.paper,
            padding: "0 12px",
            borderRadius: "var(--unstable_DataGrid-radius)",
            opacity: (t.vars || t).palette.action.disabledOpacity,
            [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
                display: "flex"
            }
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).treeDataGroupingCell}`]: {
            display: "flex",
            alignItems: "center",
            width: "100%"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).treeDataGroupingCellToggle}`]: {
            flex: "0 0 28px",
            alignSelf: "stretch",
            marginRight: t.spacing(2)
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).groupingCriteriaCell}`]: {
            display: "flex",
            alignItems: "center",
            width: "100%"
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).groupingCriteriaCellToggle}`]: {
            flex: "0 0 28px",
            alignSelf: "stretch",
            marginRight: t.spacing(2)
        },
        /* ScrollbarFiller styles */ [`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).scrollbarFiller}`]: {
            minWidth: "calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))",
            alignSelf: "stretch",
            [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollbarFiller--borderTop"]}`]: {
                borderTop: "1px solid var(--DataGrid-rowBorderColor)"
            },
            [`&.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollbarFiller--pinnedRight"]}`]: {
                backgroundColor: "var(--DataGrid-pinnedBackground)",
                position: "sticky",
                right: 0
            }
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).filler}`]: {
            flex: 1
        },
        [`& .${(0, $2276c81b0f2e6e46$export$2100d54e36406477)["filler--borderTop"]}`]: {
            borderTop: "1px solid var(--DataGrid-rowBorderColor)"
        }
    });
    return gridStyle;
});
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 */ function $2166929197bf47fb$var$blend(background, overlay, opacity, gamma = 1) {
    const f = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = (0, $533e05963543ab3e$export$677b39864803984e)(background);
    const overlayColor = (0, $533e05963543ab3e$export$677b39864803984e)(overlay);
    const rgb = [
        f(backgroundColor.values[0], overlayColor.values[0]),
        f(backgroundColor.values[1], overlayColor.values[1]),
        f(backgroundColor.values[2], overlayColor.values[2])
    ];
    return (0, $533e05963543ab3e$export$211a73f2b8c10ce4)({
        type: "rgb",
        values: rgb
    });
}








var $ge3KO = parcelRequire("ge3KO");
const $8ed2ee66cca3d652$var$_excluded = [
    "children",
    "className"
];
const $8ed2ee66cca3d652$var$useUtilityClasses = (ownerState)=>{
    const { autoHeight: autoHeight, density: density, classes: classes, showCellVerticalBorder: showCellVerticalBorder } = ownerState;
    const slots = {
        root: [
            "root",
            autoHeight && "autoHeight",
            `root--density${(0, $gl072.default)(density)}`,
            "withBorderColor",
            showCellVerticalBorder && "withVerticalBorder"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $8ed2ee66cca3d652$var$GridPanelAnchor = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    position: "absolute",
    top: `var(--DataGrid-headersTotalHeight)`,
    left: 0
});
const $8ed2ee66cca3d652$export$8cdbcd3b320d39bf = /*#__PURE__*/ $f2Y41.forwardRef(function GridRoot(props, ref) {
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const { children: children, className: className } = props, other = (0, $bKcdJ.default)(props, $8ed2ee66cca3d652$var$_excluded);
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const density = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $a8df3c1fd8492eab$export$806a039ece4425b4));
    const rootElementRef = apiRef.current.rootElementRef;
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(rootElementRef, ref);
    const ownerState = (0, $asN9r.default)({}, rootProps, {
        density: density
    });
    const classes = $8ed2ee66cca3d652$var$useUtilityClasses(ownerState);
    // Our implementation of <NoSsr />
    const [mountedState, setMountedState] = $f2Y41.useState(false);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        setMountedState(true);
    }, []);
    if (!mountedState) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $2166929197bf47fb$export$42458c7ae3a97297), (0, $asN9r.default)({
        ref: handleRef,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($8ed2ee66cca3d652$var$GridPanelAnchor, {
                role: "presentation",
                "data-id": "gridPanelAnchor"
            }),
            children
        ]
    }));
});




const $b5591cf353b711e9$export$1148b1624361a0f3 = [
    (props)=>props.autoPageSize && props.autoHeight && [
            "MUI X: `<DataGrid autoPageSize={true} autoHeight={true} />` are not valid props.",
            "You cannot use both the `autoPageSize` and `autoHeight` props at the same time because `autoHeight` scales the height of the Data Grid according to the `pageSize`.",
            "",
            "Please remove one of these two props."
        ].join("\n") || undefined,
    (props)=>props.paginationMode === "client" && props.paginationMeta != null && [
            'MUI X: Usage of the `paginationMeta` prop with client-side pagination (`paginationMode="client"`) has no effect.',
            '`paginationMeta` is only meant to be used with `paginationMode="server"`.'
        ].join("\n") || undefined,
    (props)=>props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid && props.paginationMode === "client" && (0, $2b59f632c4f96fc9$export$7e4aa119212bc614)(props.rowCount) && [
            'MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect.',
            '`rowCount` is only meant to be used with `paginationMode="server"`.'
        ].join("\n") || undefined,
    (props)=>props.paginationMode === "server" && props.rowCount == null && [
            "MUI X: The `rowCount` prop must be passed using `paginationMode='server'`",
            "For more detail, see http://mui.com/components/data-grid/pagination/#index-based-pagination"
        ].join("\n") || undefined
];
const $b5591cf353b711e9$var$warnedOnceCache = new Set();
const $b5591cf353b711e9$var$warnOnce = (message)=>{
    if (!$b5591cf353b711e9$var$warnedOnceCache.has(message)) {
        console.error(message);
        $b5591cf353b711e9$var$warnedOnceCache.add(message);
    }
};
const $b5591cf353b711e9$export$45855e0dd982478b = (props, validators)=>{
    var validator;
    return;
};
const $b5591cf353b711e9$export$f090597298dd5ce2 = ()=>{
    $b5591cf353b711e9$var$warnedOnceCache.clear();
};



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");
function $c022894dcf45b24a$export$e132ced8f644a612(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 






// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const $a71b6497c3b79ad3$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $c022894dcf45b24a$export$e132ced8f644a612)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI X: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(" > ")}`,
            `- ${parents.join(" > ")}`
        ].join("\n"));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $a71b6497c3b79ad3$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const $a71b6497c3b79ad3$export$ea425f87fd536c4d = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $a71b6497c3b79ad3$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const $a71b6497c3b79ad3$export$c41225ff45feeb0e = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>unwrappedGroupingModel[field] ?? [];
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>(0, $2b59f632c4f96fc9$export$78fdc9adc3f30400)(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    const haveDifferentContainers = (field1, field2)=>{
        if (pinnedFields?.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) return true;
        if (pinnedFields?.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) return true;
        return false;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = orderedColumns.reduce((structure, newField)=>{
            const groupId = getParents(newField)[depth] ?? null;
            if (structure.length === 0) return [
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            const lastGroup = structure[structure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            const prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || // Fix for https://github.com/mui/mui-x/issues/7041
            haveDifferentContainers(prevField, newField)) // It's a new group
            return [
                ...structure,
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            // It extends the previous group
            return [
                ...structure.slice(0, structure.length - 1),
                {
                    columnFields: [
                        ...lastGroup.columnFields,
                        newField
                    ],
                    groupId: groupId
                }
            ];
        }, []);
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};




const $a809912361717acd$var$_excluded = [
    "groupId",
    "children"
];
const $a809912361717acd$var$createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if ((0, $c022894dcf45b24a$export$e132ced8f644a612)(node)) return;
        const { groupId: groupId, children: children } = node, other = (0, $bKcdJ.default)(node, $a809912361717acd$var$_excluded);
        if (!groupId) throw new Error("MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.");
        const groupParam = (0, $asN9r.default)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $a809912361717acd$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI X: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = (0, $asN9r.default)({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return (0, $asN9r.default)({}, groupLookup);
};
const $a809912361717acd$export$21c841dc431b3cd0 = (state, props, apiRef)=>{
    if (!props.columnGroupingModel) return state;
    const columnFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
    const visibleColumnFields = (0, $b22d10f7b8994eba$export$c9491722e1d6e8d3)(apiRef);
    const groupLookup = $a809912361717acd$var$createGroupLookup(props.columnGroupingModel ?? []);
    const unwrappedGroupingModel = (0, $a71b6497c3b79ad3$export$ea425f87fd536c4d)(props.columnGroupingModel ?? []);
    const columnGroupsHeaderStructure = (0, $a71b6497c3b79ad3$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, apiRef.current.state.pinnedColumns ?? {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
    return (0, $asN9r.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
const $a809912361717acd$export$510984a37e2e33f3 = (apiRef, props)=>{
    /**
   * API METHODS
   */ const getColumnGroupPath = $f2Y41.useCallback((field)=>{
        const unwrappedGroupingModel = (0, $60b55b5d22f1422b$export$78f140ad2e1dbc2b)(apiRef);
        return unwrappedGroupingModel[field] ?? [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $f2Y41.useCallback(()=>{
        const columnGroupLookup = (0, $60b55b5d22f1422b$export$bdc2ff4432d8b29b)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnGroupingApi, "public");
    const handleColumnIndexChange = $f2Y41.useCallback(()=>{
        const unwrappedGroupingModel = (0, $a71b6497c3b79ad3$export$ea425f87fd536c4d)(props.columnGroupingModel ?? []);
        apiRef.current.setState((state)=>{
            const orderedFields = state.columns?.orderedFields ?? [];
            const pinnedColumns = state.pinnedColumns ?? {};
            const columnGroupsHeaderStructure = (0, $a71b6497c3b79ad3$export$c41225ff45feeb0e)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $asN9r.default)({}, state, {
                columnGrouping: (0, $asN9r.default)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $f2Y41.useCallback((columnGroupingModel)=>{
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = apiRef.current.getPinnedColumns?.() ?? {};
        const columnFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
        const visibleColumnFields = (0, $b22d10f7b8994eba$export$c9491722e1d6e8d3)(apiRef);
        const groupLookup = $a809912361717acd$var$createGroupLookup(columnGroupingModel ?? []);
        const unwrappedGroupingModel = (0, $a71b6497c3b79ad3$export$ea425f87fd536c4d)(columnGroupingModel ?? []);
        const columnGroupsHeaderStructure = (0, $a71b6497c3b79ad3$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnIndexChange", handleColumnIndexChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnsChange", ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnVisibilityModelChange", ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
function $2296f0a499200404$export$eb512164890e58f0(privateApiRef, name) {
    const logger = $f2Y41.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}




const $bca97ad3d37bdc8a$export$8574ffe06bf26347 = (state)=>(0, $asN9r.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
const $bca97ad3d37bdc8a$export$1fc2975c9a725449 = (apiRef)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridColumnMenu");
    /**
   * API METHODS
   */ const showColumnMenu = $f2Y41.useCallback((field)=>{
        const columnMenuState = (0, $330dcabfc9b8bbf2$export$5479c2fb8e9fd070)(apiRef.current.state);
        const newState = {
            open: true,
            field: field
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                if (state.columnMenu.open && state.columnMenu.field === field) return state;
                logger.debug("Opening Column Menu");
                return (0, $asN9r.default)({}, state, {
                    columnMenu: {
                        open: true,
                        field: field
                    }
                });
            });
            apiRef.current.hidePreferences();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = $f2Y41.useCallback(()=>{
        const columnMenuState = (0, $330dcabfc9b8bbf2$export$5479c2fb8e9fd070)(apiRef.current.state);
        if (columnMenuState.field) {
            const columnLookup = (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const newState = {
            open: false,
            field: undefined
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                logger.debug("Hiding Column Menu");
                return (0, $asN9r.default)({}, state, {
                    columnMenu: newState
                });
            });
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = $f2Y41.useCallback((field)=>{
        logger.debug("Toggle Column Menu");
        const columnMenu = (0, $330dcabfc9b8bbf2$export$5479c2fb8e9fd070)(apiRef.current.state);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnMenuApi, "public");
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnResizeStart", hideColumnMenu);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "virtualScrollerWheel", apiRef.current.hideColumnMenu);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "virtualScrollerTouchMove", apiRef.current.hideColumnMenu);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




function $6790963f450ce0fb$export$c8be9a8325efa7ee(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $6790963f450ce0fb$export$2a63f1401414fc1a(elem, className) {
    return elem.closest(`.${className}`);
}
function $6790963f450ce0fb$var$escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, "\\$&");
}
function $6790963f450ce0fb$export$94318ffb75913a0b(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$6790963f450ce0fb$var$escapeOperandAttributeSelector(field)}"]`);
}
function $6790963f450ce0fb$var$getGridRowElementSelector(id) {
    return `.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).row}[data-id="${$6790963f450ce0fb$var$escapeOperandAttributeSelector(String(id))}"]`;
}
function $6790963f450ce0fb$export$9bc8bb868a922a5f(root, id) {
    return root.querySelector($6790963f450ce0fb$var$getGridRowElementSelector(id));
}
function $6790963f450ce0fb$export$44827662627a59(root, { id: id, field: field }) {
    const rowSelector = $6790963f450ce0fb$var$getGridRowElementSelector(id);
    const cellSelector = `.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}[data-field="${$6790963f450ce0fb$var$escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
const $6790963f450ce0fb$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $6790963f450ce0fb$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $6790963f450ce0fb$export$8ce496ad3bfbe3a6(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function $6790963f450ce0fb$export$2c4260a98d98f894(colCellEl) {
    return colCellEl.getAttribute("data-field");
}
function $6790963f450ce0fb$export$a2d3aec9ff63900b(elem, field) {
    return elem.querySelector(`[data-field="${field}"]`);
}
function $6790963f450ce0fb$export$5d6880d172f0ecbb(colCellEl) {
    const fieldsString = colCellEl.getAttribute("data-fields");
    return fieldsString?.startsWith("|-") ? fieldsString.slice(2, -2).split("-|-") : [];
}
function $6790963f450ce0fb$export$1e5569d10c3ebc8b(elem, field) {
    return Array.from(elem.querySelectorAll(`[data-fields*="|-${field}-|"]`) ?? []);
}
function $6790963f450ce0fb$export$53d8041b57f0055(col, api) {
    const root = $6790963f450ce0fb$export$2a63f1401414fc1a(col, (0, $2276c81b0f2e6e46$export$2100d54e36406477).root);
    if (!root) throw new Error("MUI X: The root element is not found.");
    const ariaColIndex = col.getAttribute("aria-colindex");
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!api.virtualScrollerRef?.current) return [];
    $6790963f450ce0fb$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute("data-id");
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $6790963f450ce0fb$export$c16d6f1be06f3423(api, klass) {
    return api.rootElementRef.current.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)[klass]}`);
}
const $6790963f450ce0fb$var$findPinnedCells = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (colIndex === null) return [];
    const cells = [];
    $6790963f450ce0fb$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute("data-id");
        if (!rowId) return;
        rowElement.querySelectorAll(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)[position === "left" ? "cell--pinnedLeft" : "cell--pinnedRight"]}`).forEach((cell)=>{
            const currentColIndex = $6790963f450ce0fb$var$parseCellColIndex(cell);
            if (currentColIndex !== null && filterFn(currentColIndex)) cells.push(cell);
        });
    });
    return cells;
};
function $6790963f450ce0fb$export$71cc5934f05ca0a1(api, col) {
    const colIndex = $6790963f450ce0fb$var$parseCellColIndex(col);
    return $6790963f450ce0fb$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: "left",
        filterFn: (index)=>index > colIndex
    });
}
function $6790963f450ce0fb$export$2eb3bec73fd25ab(api, col) {
    const colIndex = $6790963f450ce0fb$var$parseCellColIndex(col);
    return $6790963f450ce0fb$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: "right",
        filterFn: (index)=>index < colIndex
    });
}
const $6790963f450ce0fb$var$findPinnedHeaders = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (!api.columnHeadersContainerRef?.current) return [];
    if (colIndex === null) return [];
    const elements = [];
    api.columnHeadersContainerRef.current.querySelectorAll(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477)[position === "left" ? "columnHeader--pinnedLeft" : "columnHeader--pinnedRight"]}`).forEach((element)=>{
        const currentColIndex = $6790963f450ce0fb$var$parseCellColIndex(element);
        if (currentColIndex !== null && filterFn(currentColIndex)) elements.push(element);
    });
    return elements;
};
function $6790963f450ce0fb$export$18b98bbb853bc2c4(api, col) {
    const colIndex = $6790963f450ce0fb$var$parseCellColIndex(col);
    return $6790963f450ce0fb$var$findPinnedHeaders({
        api: api,
        position: "left",
        colIndex: colIndex,
        filterFn: (index)=>index > colIndex
    });
}
function $6790963f450ce0fb$export$a2731c8163776b73(api, col) {
    const colIndex = $6790963f450ce0fb$var$parseCellColIndex(col);
    return $6790963f450ce0fb$var$findPinnedHeaders({
        api: api,
        position: "right",
        colIndex: colIndex,
        filterFn: (index)=>index < colIndex
    });
}
function $6790963f450ce0fb$export$5c4f873e8f18904d(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > div > [data-field="${field}"][role="columnheader"]`);
}
function $6790963f450ce0fb$export$ee9bd404f74f7c9(api, field) {
    const container = api.virtualScrollerRef.current;
    return Array.from(container.querySelectorAll(`:scope > div > div > div > [data-field="${field}"][role="gridcell"]`));
}
function $6790963f450ce0fb$var$queryRows(api) {
    return api.virtualScrollerRef.current.querySelectorAll(// Use > to ignore rows from nested data grids (for example in detail panel)
    `:scope > div > div > .${(0, $2276c81b0f2e6e46$export$2100d54e36406477).row}`);
}
function $6790963f450ce0fb$var$parseCellColIndex(col) {
    const ariaColIndex = col.getAttribute("aria-colindex");
    if (!ariaColIndex) return null;
    return Number(ariaColIndex) - 1;
}


const $e5ae51189a25ca34$export$9707fe779d390182 = {
    includeHeaders: true,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 




var $f2Y41 = parcelRequire("f2Y41");


const $64e59e98530d9a75$export$265f4c39182036e = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useNativeEventListener");
    const [added, setAdded] = $f2Y41.useState(false);
    const handlerRef = $f2Y41.useRef(handler);
    const targetElement = (0, $2b59f632c4f96fc9$export$f6e2535fb5126e54)(ref) ? ref() : ref?.current ?? null;
    const wrapHandler = $f2Y41.useCallback((event)=>{
        return handlerRef.current && handlerRef.current(event);
    }, []);
    $f2Y41.useEffect(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    $f2Y41.useEffect(()=>{
        if (targetElement && eventName && !added) {
            logger.debug(`Binding native ${eventName} event`);
            targetElement.addEventListener(eventName, wrapHandler, options);
            setAdded(true);
            const unsubscribe = ()=>{
                logger.debug(`Clearing native ${eventName} event`);
                targetElement.removeEventListener(eventName, wrapHandler, options);
            };
            apiRef.current.subscribeEvent("unmount", unsubscribe);
        }
    }, [
        targetElement,
        wrapHandler,
        eventName,
        added,
        logger,
        options,
        apiRef
    ]);
};



function $860d85d468c7ca8a$export$7e10cfd0168dec8f() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}






// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $b3578c0ad87c8811$var$cachedSupportsTouchActionNone = false;
function $b3578c0ad87c8811$var$doesSupportTouchActionNone() {
    if ($b3578c0ad87c8811$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== "undefined" && typeof CSS.supports === "function") $b3578c0ad87c8811$var$cachedSupportsTouchActionNone = CSS.supports("touch-action", "none");
        else $b3578c0ad87c8811$var$cachedSupportsTouchActionNone = true;
    }
    return $b3578c0ad87c8811$var$cachedSupportsTouchActionNone;
}
function $b3578c0ad87c8811$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $b3578c0ad87c8811$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === "Right") newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return newWidth;
}
function $b3578c0ad87c8811$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === "Left") return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $b3578c0ad87c8811$var$flipResizeDirection(side) {
    if (side === "Right") return "Left";
    return "Right";
}
function $b3578c0ad87c8811$var$getResizeDirection(separator, direction) {
    const side = separator.classList.contains((0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--sideRight"]) ? "Right" : "Left";
    if (direction === "rtl") // Resizing logic should be mirrored in the RTL case
    return $b3578c0ad87c8811$var$flipResizeDirection(side);
    return side;
}
function $b3578c0ad87c8811$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $b3578c0ad87c8811$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $f2Y41.useRef();
    const selector = ()=>(0, $de91a359006882c0$export$ad2aa1e9d465cafa)(apiRef);
    const value = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, selector);
    $f2Y41.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $860d85d468c7ca8a$export$7e10cfd0168dec8f)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $b3578c0ad87c8811$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (for example zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $b3578c0ad87c8811$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add((0, $2276c81b0f2e6e46$export$2100d54e36406477).autosizing);
    columns.forEach((column)=>{
        const cells = (0, $6790963f450ce0fb$export$ee9bd404f74f7c9)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            return cell.getBoundingClientRect().width ?? 0;
        });
        const filteredWidths = options.includeOutliers ? widths : $b3578c0ad87c8811$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $6790963f450ce0fb$export$5c4f873e8f18904d)(apiRef.current, column.field);
            if (header) {
                const title = header.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitle}`);
                const content = header.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
                const iconContainer = header.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).iconButtonContainer}`);
                const menuContainer = header.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).menuIcon}`);
                const element = title ?? content;
                const style = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
                const contentWidth = element.scrollWidth + 1;
                const width = contentWidth + paddingWidth + (iconContainer?.clientWidth ?? 0) + (menuContainer?.clientWidth ?? 0);
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(maxContent, min, max);
    });
    root.classList.remove((0, $2276c81b0f2e6e46$export$2100d54e36406477).autosizing);
    return widthByField;
}
const $b3578c0ad87c8811$export$ac6ed2ccd52f643f = (state)=>(0, $asN9r.default)({}, state, {
        columnResize: {
            resizingColumnField: ""
        }
    });
function $b3578c0ad87c8811$var$createResizeRefs() {
    return {
        colDef: undefined,
        initialColWidth: 0,
        initialTotalWidth: 0,
        previousMouseClickEvent: undefined,
        columnHeaderElement: undefined,
        headerFilterElement: undefined,
        groupHeaderElements: [],
        cellElements: [],
        leftPinnedCellsAfter: [],
        rightPinnedCellsBefore: [],
        fillerLeft: undefined,
        fillerRight: undefined,
        leftPinnedHeadersAfter: [],
        rightPinnedHeadersBefore: []
    };
}
const $b3578c0ad87c8811$export$6761a7afeb3daa64 = (apiRef, props)=>{
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridColumnResize");
    const refs = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)($b3578c0ad87c8811$var$createResizeRefs).current;
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $f2Y41.useRef();
    const resizeDirection = $f2Y41.useRef();
    const stopResizeEventTimeout = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const touchId = $f2Y41.useRef();
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${refs.colDef.field}`);
        const prevWidth = refs.columnHeaderElement.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        const columnWidthDiff = newWidth - refs.initialColWidth;
        const newTotalWidth = refs.initialTotalWidth + columnWidthDiff;
        apiRef.current.rootElementRef?.current?.style.setProperty("--DataGrid-rowWidth", `${newTotalWidth}px`);
        refs.colDef.computedWidth = newWidth;
        refs.colDef.width = newWidth;
        refs.colDef.flex = 0;
        refs.columnHeaderElement.style.width = `${newWidth}px`;
        refs.columnHeaderElement.style.minWidth = `${newWidth}px`;
        refs.columnHeaderElement.style.maxWidth = `${newWidth}px`;
        const headerFilterElement = refs.headerFilterElement;
        if (headerFilterElement) {
            headerFilterElement.style.width = `${newWidth}px`;
            headerFilterElement.style.minWidth = `${newWidth}px`;
            headerFilterElement.style.maxWidth = `${newWidth}px`;
        }
        refs.groupHeaderElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute("aria-colspan") === "1") finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
            div.style.minWidth = finalWidth;
            div.style.maxWidth = finalWidth;
        });
        refs.cellElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute("aria-colspan") === "1") finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.setProperty("--width", finalWidth);
        });
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors("isColumnPinned", false, refs.colDef.field);
        if (pinnedPosition === (0, $49d1610712424e75$export$64f54b460f67389c).LEFT) {
            $b3578c0ad87c8811$var$updateProperty(refs.fillerLeft, "width", widthDiff);
            refs.leftPinnedCellsAfter.forEach((cell)=>{
                $b3578c0ad87c8811$var$updateProperty(cell, "left", widthDiff);
            });
            refs.leftPinnedHeadersAfter.forEach((header)=>{
                $b3578c0ad87c8811$var$updateProperty(header, "left", widthDiff);
            });
        }
        if (pinnedPosition === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT) {
            $b3578c0ad87c8811$var$updateProperty(refs.fillerRight, "width", widthDiff);
            refs.rightPinnedCellsBefore.forEach((cell)=>{
                $b3578c0ad87c8811$var$updateProperty(cell, "right", widthDiff);
            });
            refs.rightPinnedHeadersBefore.forEach((header)=>{
                $b3578c0ad87c8811$var$updateProperty(header, "right", widthDiff);
            });
        }
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        // Prevent double-clicks from being interpreted as two separate clicks
        if (refs.previousMouseClickEvent) {
            const prevEvent = refs.previousMouseClickEvent;
            const prevTimeStamp = prevEvent.timeStamp;
            const prevClientX = prevEvent.clientX;
            const prevClientY = prevEvent.clientY;
            // Check if the current event is part of a double-click
            if (nativeEvent.timeStamp - prevTimeStamp < 300 && nativeEvent.clientX === prevClientX && nativeEvent.clientY === prevClientY) {
                refs.previousMouseClickEvent = undefined;
                return;
            }
        }
        if (refs.colDef) {
            apiRef.current.setColumnWidth(refs.colDef.field, refs.colDef.width);
            logger.debug(`Updating col ${refs.colDef.field} with new width: ${refs.colDef.width}`);
            const columnsState = (0, $b22d10f7b8994eba$export$858d15abb6cddc08)(apiRef.current.state);
            refs.groupHeaderElements.forEach((element)=>{
                const fields = (0, $6790963f450ce0fb$export$5d6880d172f0ecbb)(element);
                const div = element;
                const newWidth = fields.reduce((acc, field)=>{
                    if (columnsState.columnVisibilityModel[field] !== false) return acc + columnsState.lookup[field].computedWidth;
                    return acc;
                }, 0);
                const finalWidth = `${newWidth}px`;
                div.style.width = finalWidth;
                div.style.minWidth = finalWidth;
                div.style.maxWidth = finalWidth;
            });
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent("columnResizeStop", null, nativeEvent);
        });
    };
    const storeReferences = (colDef, separator, xStart)=>{
        const root = apiRef.current.rootElementRef.current;
        refs.initialColWidth = colDef.computedWidth;
        refs.initialTotalWidth = apiRef.current.getRootDimensions().rowWidth;
        refs.colDef = colDef;
        refs.columnHeaderElement = (0, $6790963f450ce0fb$export$a2d3aec9ff63900b)(apiRef.current.columnHeadersContainerRef.current, colDef.field);
        const headerFilterElement = root.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).headerFilterRow} [data-field="${colDef.field}"]`);
        if (headerFilterElement) refs.headerFilterElement = headerFilterElement;
        refs.groupHeaderElements = (0, $6790963f450ce0fb$export$1e5569d10c3ebc8b)(apiRef.current.columnHeadersContainerRef?.current, colDef.field);
        refs.cellElements = (0, $6790963f450ce0fb$export$53d8041b57f0055)(refs.columnHeaderElement, apiRef.current);
        refs.fillerLeft = (0, $6790963f450ce0fb$export$c16d6f1be06f3423)(apiRef.current, "filler--pinnedLeft");
        refs.fillerRight = (0, $6790963f450ce0fb$export$c16d6f1be06f3423)(apiRef.current, "filler--pinnedRight");
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors("isColumnPinned", false, refs.colDef.field);
        refs.leftPinnedCellsAfter = pinnedPosition !== (0, $49d1610712424e75$export$64f54b460f67389c).LEFT ? [] : (0, $6790963f450ce0fb$export$71cc5934f05ca0a1)(apiRef.current, refs.columnHeaderElement);
        refs.rightPinnedCellsBefore = pinnedPosition !== (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT ? [] : (0, $6790963f450ce0fb$export$2eb3bec73fd25ab)(apiRef.current, refs.columnHeaderElement);
        refs.leftPinnedHeadersAfter = pinnedPosition !== (0, $49d1610712424e75$export$64f54b460f67389c).LEFT ? [] : (0, $6790963f450ce0fb$export$18b98bbb853bc2c4)(apiRef.current, refs.columnHeaderElement);
        refs.rightPinnedHeadersBefore = pinnedPosition !== (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT ? [] : (0, $6790963f450ce0fb$export$a2731c8163776b73)(apiRef.current, refs.columnHeaderElement);
        resizeDirection.current = $b3578c0ad87c8811$var$getResizeDirection(separator, theme.direction);
        initialOffsetToSeparator.current = $b3578c0ad87c8811$var$computeOffsetToSeparator(xStart, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
    };
    const handleResizeMouseUp = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(finishResize);
    const handleResizeMouseMove = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $b3578c0ad87c8811$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent("columnResize", params, nativeEvent);
    });
    const handleTouchEnd = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $b3578c0ad87c8811$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $b3578c0ad87c8811$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === "mousemove" && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $b3578c0ad87c8811$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent("columnResize", params, nativeEvent);
    });
    const handleTouchStart = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        const cellSeparator = (0, $6790963f450ce0fb$export$2a63f1401414fc1a)(event.target, (0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizable"]);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$b3578c0ad87c8811$var$doesSupportTouchActionNone()) event.preventDefault();
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const columnHeaderElement = (0, $6790963f450ce0fb$export$2a63f1401414fc1a)(event.target, (0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader);
        const field = (0, $6790963f450ce0fb$export$2c4260a98d98f894)(columnHeaderElement);
        const colDef = apiRef.current.getColumn(field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent("columnResizeStart", {
            field: field
        }, event);
        storeReferences(colDef, cellSeparator, touch.clientX);
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(event.currentTarget);
        doc.addEventListener("touchmove", handleTouchMove);
        doc.addEventListener("touchend", handleTouchEnd);
    });
    const stopListening = $f2Y41.useCallback(()=>{
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty("cursor");
        doc.removeEventListener("mousemove", handleResizeMouseMove);
        doc.removeEventListener("mouseup", handleResizeMouseUp);
        doc.removeEventListener("touchmove", handleTouchMove);
        doc.removeEventListener("touchend", handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener("click", $b3578c0ad87c8811$var$preventClick, true);
        }, 100);
        if (refs.columnHeaderElement) refs.columnHeaderElement.style.pointerEvents = "unset";
    }, [
        apiRef,
        refs,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $f2Y41.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                columnResize: (0, $asN9r.default)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleResizeStop = $f2Y41.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                columnResize: (0, $asN9r.default)({}, state.columnResize, {
                    resizingColumnField: ""
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(({ colDef: colDef }, event)=>{
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains((0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnSeparator--resizable"])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent("columnResizeStart", {
            field: colDef.field
        }, event);
        storeReferences(colDef, event.currentTarget, event.clientX);
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = "col-resize";
        refs.previousMouseClickEvent = event.nativeEvent;
        doc.addEventListener("mousemove", handleResizeMouseMove);
        doc.addEventListener("mouseup", handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener("click", $b3578c0ad87c8811$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $asN9r.default)({}, props.autosizeOptions, {
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $b3578c0ad87c8811$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $f2Y41.useRef(false);
    const autosizeColumns = $f2Y41.useCallback(async (userOptions)=>{
        const root = apiRef.current.rootElementRef?.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $b22d10f7b8994eba$export$858d15abb6cddc08)(apiRef.current.state);
        const options = (0, $asN9r.default)({}, (0, $e5ae51189a25ca34$export$9707fe779d390182), userOptions, {
            columns: userOptions?.columns ?? state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            apiRef.current.unstable_setColumnVirtualization(false);
            await columnVirtualizationDisabled();
            const widthByField = $b3578c0ad87c8811$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $asN9r.default)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field]
                }));
            if (options.expand) {
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>total + (widthByField[column.field] ?? column.computedWidth ?? column.width), 0);
                const availableWidth = apiRef.current.getRootDimensions().viewportInnerSize.width;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
            newColumns.forEach((newColumn, index)=>{
                if (newColumn.width !== columns[index].width) {
                    const width = newColumn.width;
                    apiRef.current.publishEvent("columnWidthChange", {
                        element: apiRef.current.getColumnHeaderElement(newColumn.field),
                        colDef: newColumn,
                        width: width
                    });
                }
            });
        } finally{
            apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled
    ]);
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $33567b05615fab88$export$2e2bcd8739ae039)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $64e59e98530d9a75$export$265f4c39182036e)(apiRef, ()=>apiRef.current.columnHeadersContainerRef?.current, "touchstart", handleTouchStart, {
        passive: $b3578c0ad87c8811$var$doesSupportTouchActionNone()
    });
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, {
        autosizeColumns: autosizeColumns
    }, "public");
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnResizeStop", handleResizeStop);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnResizeStart", handleResizeStart);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnSeparatorMouseDown", handleColumnResizeMouseDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnSeparatorDoubleClick", handleColumnSeparatorDoubleClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnResize", props.onColumnResize);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnWidthChange", props.onColumnWidthChange);
};
function $b3578c0ad87c8811$var$updateProperty(element, property, delta) {
    if (!element) return;
    element.style[property] = `${parseInt(element.style[property], 10) + delta}px`;
}


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
const $f9629e0497ea16d6$export$c5623aa1c38918b6 = (callback)=>{
    const isFirstRender = $f2Y41.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};


const $338bdb77087fba68$export$98b68054bf03cb4 = (apiRef, group, callback)=>{
    const cleanup = $f2Y41.useRef();
    const id = $f2Y41.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $f2Y41.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $f9629e0497ea16d6$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};


var $f2Y41 = parcelRequire("f2Y41");

const $a14191cb88acd892$export$faa98381ad228894 = (apiRef, group, callback)=>{
    const cleanup = $f2Y41.useRef();
    const id = $f2Y41.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $f2Y41.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $f9629e0497ea16d6$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};






var $ge3KO = parcelRequire("ge3KO");
const $5dfff719897ebff3$export$8dcda879a58a8f96 = (state, props, apiRef)=>{
    const columnsState = (0, $977688d2f2933ee3$export$f3ba81d24bd05452)({
        apiRef: apiRef,
        columnsToUpsert: props.columns,
        initialState: props.initialState?.columns,
        columnVisibilityModel: props.columnVisibilityModel ?? props.initialState?.columns?.columnVisibilityModel ?? {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $asN9r.default)({}, state, {
        columns: columnsState,
        // In pro/premium, this part of the state is defined. We give it an empty but defined value
        // for the community version.
        pinnedColumns: state.pinnedColumns ?? (0, $49d1610712424e75$export$77439b544edbbd66)
    });
};
function $5dfff719897ebff3$export$fe9b9b8b4620abff(apiRef, props) {
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridColumns");
    const previousColumnsProp = $f2Y41.useRef(props.columns);
    apiRef.current.registerControlState({
        stateId: "visibleColumns",
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4),
        changeEvent: "columnVisibilityModelChange"
    });
    const setGridColumnsState = $f2Y41.useCallback((columnsState)=>{
        logger.debug("Updating columns state.");
        apiRef.current.setState($5dfff719897ebff3$var$mergeColumnsState(columnsState));
        apiRef.current.publishEvent("columnsChange", columnsState.orderedFields);
        apiRef.current.updateRenderContext?.();
        apiRef.current.forceUpdate();
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $f2Y41.useCallback((field)=>(0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $f2Y41.useCallback(()=>(0, $b22d10f7b8994eba$export$da85f06e3c19f1fd)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $f2Y41.useCallback(()=>(0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $f2Y41.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef) : (0, $b22d10f7b8994eba$export$da85f06e3c19f1fd)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $f2Y41.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $b22d10f7b8994eba$export$fce7d810e48021e3)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $f2Y41.useCallback((model)=>{
        const currentModel = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                    columns: (0, $977688d2f2933ee3$export$f3ba81d24bd05452)({
                        apiRef: apiRef,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.updateRenderContext?.();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef
    ]);
    const updateColumns = $f2Y41.useCallback((columns)=>{
        const columnsState = (0, $977688d2f2933ee3$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: columns,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState
    ]);
    const setColumnVisibility = $f2Y41.useCallback((field, isVisible)=>{
        const columnVisibilityModel = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
        const isCurrentlyVisible = columnVisibilityModel[field] ?? true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $asN9r.default)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $f2Y41.useCallback((field)=>{
        const allColumns = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $f2Y41.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $asN9r.default)({}, (0, $b22d10f7b8994eba$export$858d15abb6cddc08)(apiRef.current.state), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent("columnIndexChange", params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $f2Y41.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $b22d10f7b8994eba$export$858d15abb6cddc08)(apiRef.current.state);
        const column = columnsState.lookup[field];
        const newColumn = (0, $asN9r.default)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $977688d2f2933ee3$export$cd8dc1fa232954ad)((0, $asN9r.default)({}, columnsState, {
            lookup: (0, $asN9r.default)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), apiRef.current.getRootDimensions()));
        apiRef.current.publishEvent("columnWidthChange", {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnReorderApi, props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid ? "private" : "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys(props.initialState?.columns?.columnVisibilityModel ?? {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
        const columns = (0, $b22d10f7b8994eba$export$da85f06e3c19f1fd)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, $977688d2f2933ee3$export$cd7252624d377ce0).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $asN9r.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        props.initialState?.columns
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const columnVisibilityModelToImport = context.stateToRestore.columns?.columnVisibilityModel;
        const initialState = context.stateToRestore.columns;
        if (columnVisibilityModelToImport == null && initialState == null) return params;
        const columnsState = (0, $977688d2f2933ee3$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState($5dfff719897ebff3$var$mergeColumnsState(columnsState));
        if (initialState != null) apiRef.current.publishEvent("columnsChange", columnsState.orderedFields);
        return params;
    }, [
        apiRef
    ]);
    const preferencePanelPreProcessing = $f2Y41.useCallback((initialValue, value)=>{
        if (value === (0, $3f22a63fe503dede$export$e7e5652452e44b).columns) {
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $ge3KO.jsx)(ColumnsPanel, (0, $asN9r.default)({}, props.slotProps?.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        props.slotProps?.columnsPanel
    ]);
    const addColumnMenuItems = $f2Y41.useCallback((columnMenuItems)=>{
        if (props.disableColumnSelector) return columnMenuItems;
        return [
            ...columnMenuItems,
            "columnMenuColumnsItem"
        ];
    }, [
        props.disableColumnSelector
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "columnMenu", addColumnMenuItems);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "preferencePanel", preferencePanelPreProcessing);
    /*
   * EVENTS
   */ const prevInnerWidth = $f2Y41.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            setGridColumnsState((0, $977688d2f2933ee3$export$cd8dc1fa232954ad)((0, $b22d10f7b8994eba$export$858d15abb6cddc08)(apiRef.current.state), apiRef.current.getRootDimensions()));
        }
    };
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "viewportInnerSizeChange", handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $f2Y41.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $977688d2f2933ee3$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    (0, $338bdb77087fba68$export$98b68054bf03cb4)(apiRef, "hydrateColumns", hydrateColumns);
    /*
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns) return;
        const columnsState = (0, $977688d2f2933ee3$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns
    ]);
    $f2Y41.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
function $5dfff719897ebff3$var$mergeColumnsState(columnsState) {
    return (state)=>(0, $asN9r.default)({}, state, {
            columns: columnsState
        });
}


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





const $ef3e1313173c43db$export$d6d71dbaaa6fec72 = (state, props)=>(0, $asN9r.default)({}, state, {
        density: props.initialState?.density ?? props.density ?? "standard"
    });
const $ef3e1313173c43db$export$836c4be63cf7a42d = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useDensity");
    apiRef.current.registerControlState({
        stateId: "density",
        propModel: props.density,
        propOnChange: props.onDensityChange,
        stateSelector: (0, $a8df3c1fd8492eab$export$806a039ece4425b4),
        changeEvent: "densityChange"
    });
    const setDensity = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((newDensity)=>{
        const currentDensity = (0, $a8df3c1fd8492eab$export$806a039ece4425b4)(apiRef.current.state);
        if (currentDensity === newDensity) return;
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                density: newDensity
            }));
    });
    const densityApi = {
        setDensity: setDensity
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, densityApi, "public");
    const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const exportedDensity = (0, $a8df3c1fd8492eab$export$806a039ece4425b4)(apiRef.current.state);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `density` is controlled
        props.density != null || // Always export if the `density` has been initialized
        props.initialState?.density != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            density: exportedDensity
        });
    }, [
        apiRef,
        props.density,
        props.initialState?.density
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const restoredDensity = context.stateToRestore?.density ? context.stateToRestore.density : (0, $a8df3c1fd8492eab$export$806a039ece4425b4)(apiRef.current.state);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                density: restoredDensity
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    $f2Y41.useEffect(()=>{
        if (props.density) apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



function $05773f53a77af3fb$export$de363e709c412c8a(func, wait = 166) {
    let timeout;
    let lastArgs;
    const later = ()=>{
        timeout = undefined;
        func(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (timeout === undefined) timeout = setTimeout(later, wait);
    }
    throttled.clear = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
    };
    return throttled;
}












const $82c10198cc36e0b5$var$EMPTY_SIZE = {
    width: 0,
    height: 0
};
const $82c10198cc36e0b5$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $82c10198cc36e0b5$var$EMPTY_SIZE,
    viewportOuterSize: $82c10198cc36e0b5$var$EMPTY_SIZE,
    viewportInnerSize: $82c10198cc36e0b5$var$EMPTY_SIZE,
    contentSize: $82c10198cc36e0b5$var$EMPTY_SIZE,
    minimumSize: $82c10198cc36e0b5$var$EMPTY_SIZE,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    headerHeight: 0,
    headerFilterHeight: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    headersTotalHeight: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0
};
const $82c10198cc36e0b5$export$c29f872c616fae5b = (state)=>{
    const dimensions = $82c10198cc36e0b5$var$EMPTY_DIMENSIONS;
    return (0, $asN9r.default)({}, state, {
        dimensions: dimensions
    });
};
function $82c10198cc36e0b5$export$b8364994f9eec67d(apiRef, props) {
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useResizeContainer");
    const errorShown = $f2Y41.useRef(false);
    const rootDimensionsRef = $f2Y41.useRef($82c10198cc36e0b5$var$EMPTY_SIZE);
    const rowsMeta = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $7662854de25f6bb1$export$4f32bfc70efeb4ab));
    const pinnedColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$297e8079713afa11));
    const densityFactor = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $a8df3c1fd8492eab$export$c646201fb1d3e7a6));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    const headerHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const headerFilterHeight = Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor);
    const columnsTotalWidth = $82c10198cc36e0b5$var$roundToDecimalPlaces((0, $b22d10f7b8994eba$export$ab20f9d33edc7794)(apiRef), 6);
    const headersTotalHeight = (0, $977688d2f2933ee3$export$659109c29172602f)(apiRef, props);
    const leftPinnedWidth = pinnedColumns.left.reduce((w, col)=>w + col.computedWidth, 0);
    const rightPinnedWidth = pinnedColumns.right.reduce((w, col)=>w + col.computedWidth, 0);
    const [savedSize, setSavedSize] = $f2Y41.useState();
    const debouncedSetSavedSize = $f2Y41.useMemo(()=>(0, $05773f53a77af3fb$export$de363e709c412c8a)(setSavedSize, props.resizeThrottleMs), [
        props.resizeThrottleMs
    ]);
    const previousSize = $f2Y41.useRef();
    const getRootDimensions = ()=>apiRef.current.state.dimensions;
    const setDimensions = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((dimensions)=>{
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                dimensions: dimensions
            }));
    });
    const resize = $f2Y41.useCallback(()=>{
        const element = apiRef.current.mainElementRef.current;
        if (!element) return;
        const computedStyle = (0, $a97899720a0a78b2$export$2e2bcd8739ae039)(element).getComputedStyle(element);
        const height = parseFloat(computedStyle.height) || 0;
        const width = parseFloat(computedStyle.width) || 0;
        const hasHeightChanged = height !== previousSize.current?.height;
        const hasWidthChanged = width !== previousSize.current?.width;
        if (!previousSize.current || hasHeightChanged || hasWidthChanged) {
            const size = {
                width: width,
                height: height
            };
            apiRef.current.publishEvent("resize", size);
            previousSize.current = size;
        }
    }, [
        apiRef
    ]);
    const getViewportPageSize = $f2Y41.useCallback(()=>{
        const dimensions = (0, $13cd7539f33578ca$export$26d8768b83a52ffd)(apiRef.current.state);
        if (!dimensions.isReady) return 0;
        const currentPage = (0, $5102b0c2afb145a4$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (props.getRowHeight) {
            const renderContext = (0, $de91a359006882c0$export$4cf9f333a030f780)(apiRef);
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode,
        props.getRowHeight,
        rowHeight
    ]);
    const updateDimensions = $f2Y41.useCallback(()=>{
        const rootElement = apiRef.current.rootElementRef.current;
        const pinnedRowsHeight = (0, $5a37f1a88e056eac$export$d299da5915ed6fec)(apiRef);
        const scrollbarSize = $82c10198cc36e0b5$var$measureScrollbarSize(rootElement, columnsTotalWidth, props.scrollbarSize);
        const topContainerHeight = headersTotalHeight + pinnedRowsHeight.top;
        const bottomContainerHeight = pinnedRowsHeight.bottom;
        const nonPinnedColumnsTotalWidth = columnsTotalWidth - leftPinnedWidth - rightPinnedWidth;
        const contentSize = {
            width: nonPinnedColumnsTotalWidth,
            height: rowsMeta.currentPageTotalHeight
        };
        let viewportOuterSize;
        let viewportInnerSize;
        let hasScrollX = false;
        let hasScrollY = false;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: topContainerHeight + bottomContainerHeight + contentSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - (hasScrollY ? scrollbarSize : 0)),
                height: Math.max(0, viewportOuterSize.height - (hasScrollX ? scrollbarSize : 0))
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rootDimensionsRef.current.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - leftPinnedWidth - rightPinnedWidth),
                height: Math.max(0, viewportOuterSize.height - topContainerHeight - bottomContainerHeight)
            };
            const content = contentSize;
            const container = viewportInnerSize;
            const hasScrollXIfNoYScrollBar = content.width > container.width;
            const hasScrollYIfNoXScrollBar = content.height > container.height;
            if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
                hasScrollY = hasScrollYIfNoXScrollBar;
                hasScrollX = content.width + (hasScrollY ? scrollbarSize : 0) > container.width;
                // We recalculate the scroll y to consider the size of the x scrollbar.
                if (hasScrollX) hasScrollY = content.height + scrollbarSize > container.height;
            }
            if (hasScrollY) viewportInnerSize.width -= scrollbarSize;
            if (hasScrollX) viewportInnerSize.height -= scrollbarSize;
        }
        const rowWidth = Math.max(viewportOuterSize.width, columnsTotalWidth + (hasScrollY ? scrollbarSize : 0));
        const minimumSize = {
            width: columnsTotalWidth,
            height: topContainerHeight + contentSize.height + bottomContainerHeight
        };
        const newDimensions = {
            isReady: true,
            root: rootDimensionsRef.current,
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            contentSize: contentSize,
            minimumSize: minimumSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollbarSize: scrollbarSize,
            headerHeight: headerHeight,
            headerFilterHeight: headerFilterHeight,
            rowWidth: rowWidth,
            rowHeight: rowHeight,
            columnsTotalWidth: columnsTotalWidth,
            leftPinnedWidth: leftPinnedWidth,
            rightPinnedWidth: rightPinnedWidth,
            headersTotalHeight: headersTotalHeight,
            topContainerHeight: topContainerHeight,
            bottomContainerHeight: bottomContainerHeight
        };
        const prevDimensions = apiRef.current.state.dimensions;
        setDimensions(newDimensions);
        if (newDimensions.viewportInnerSize.width !== prevDimensions.viewportInnerSize.width || newDimensions.viewportInnerSize.height !== prevDimensions.viewportInnerSize.height) apiRef.current.publishEvent("viewportInnerSizeChange", newDimensions.viewportInnerSize);
        apiRef.current.updateRenderContext?.();
    }, [
        apiRef,
        setDimensions,
        props.scrollbarSize,
        props.autoHeight,
        rowsMeta.currentPageTotalHeight,
        rowHeight,
        headerHeight,
        headerFilterHeight,
        columnsTotalWidth,
        headersTotalHeight,
        leftPinnedWidth,
        rightPinnedWidth
    ]);
    const apiPublic = {
        resize: resize,
        getRootDimensions: getRootDimensions
    };
    const apiPrivate = {
        updateDimensions: updateDimensions,
        getViewportPageSize: getViewportPageSize
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, apiPublic, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, apiPrivate, "private");
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (savedSize) {
            updateDimensions();
            apiRef.current.publishEvent("debouncedResize", rootDimensionsRef.current);
        }
    }, [
        apiRef,
        savedSize,
        updateDimensions
    ]);
    const root = apiRef.current.rootElementRef.current;
    const dimensions = apiRef.current.state.dimensions;
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (!root) return;
        const set = (k, v)=>root.style.setProperty(k, v);
        set("--DataGrid-width", `${dimensions.viewportOuterSize.width}px`);
        set("--DataGrid-hasScrollX", `${Number(dimensions.hasScrollX)}`);
        set("--DataGrid-hasScrollY", `${Number(dimensions.hasScrollY)}`);
        set("--DataGrid-scrollbarSize", `${dimensions.scrollbarSize}px`);
        set("--DataGrid-rowWidth", `${dimensions.rowWidth}px`);
        set("--DataGrid-columnsTotalWidth", `${dimensions.columnsTotalWidth}px`);
        set("--DataGrid-leftPinnedWidth", `${dimensions.leftPinnedWidth}px`);
        set("--DataGrid-rightPinnedWidth", `${dimensions.rightPinnedWidth}px`);
        set("--DataGrid-headerHeight", `${dimensions.headerHeight}px`);
        set("--DataGrid-headersTotalHeight", `${dimensions.headersTotalHeight}px`);
        set("--DataGrid-topContainerHeight", `${dimensions.topContainerHeight}px`);
        set("--DataGrid-bottomContainerHeight", `${dimensions.bottomContainerHeight}px`);
        set("--height", `${dimensions.rowHeight}px`);
    }, [
        root,
        dimensions
    ]);
    const isFirstSizing = $f2Y41.useRef(true);
    const handleResize = $f2Y41.useCallback((size)=>{
        rootDimensionsRef.current = size;
        // jsdom has no layout capabilities
        const isJSDOM = /jsdom/.test(window.navigator.userAgent);
        if (size.height === 0 && !errorShown.current && !props.autoHeight && !isJSDOM) {
            logger.error([
                "The parent DOM element of the data grid has an empty height.",
                "Please make sure that this element has an intrinsic height.",
                "The grid displays with a height of 0px.",
                "",
                "More details: https://mui.com/r/x-data-grid-no-dimensions."
            ].join("\n"));
            errorShown.current = true;
        }
        if (size.width === 0 && !errorShown.current && !isJSDOM) {
            logger.error([
                "The parent DOM element of the data grid has an empty width.",
                "Please make sure that this element has an intrinsic width.",
                "The grid displays with a width of 0px.",
                "",
                "More details: https://mui.com/r/x-data-grid-no-dimensions."
            ].join("\n"));
            errorShown.current = true;
        }
        if (isFirstSizing.current) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        debouncedSetSavedSize(size);
    }, [
        props.autoHeight,
        debouncedSetSavedSize,
        logger
    ]);
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(updateDimensions, [
        updateDimensions
    ]);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "sortedRowsSet", updateDimensions);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "paginationModelChange", updateDimensions);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnsChange", updateDimensions);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "resize", handleResize);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "debouncedResize", props.onResize);
}
function $82c10198cc36e0b5$var$measureScrollbarSize(rootElement, columnsTotalWidth, scrollbarSize) {
    if (scrollbarSize !== undefined) return scrollbarSize;
    if (rootElement === null || columnsTotalWidth === 0) return 0;
    const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(rootElement);
    const scrollDiv = doc.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.className = "scrollDiv";
    rootElement.appendChild(scrollDiv);
    const size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    rootElement.removeChild(scrollDiv);
    return size;
}
// Get rid of floating point imprecision errors
// https://github.com/mui/mui-x/issues/9550#issuecomment-1619020477
function $82c10198cc36e0b5$var$roundToDecimalPlaces(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


var $bKcdJ = parcelRequire("bKcdJ");


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




// TODO v6: rename to gridEditingStateSelector
const $fc36377571b6d029$export$91ed78b95c9e6636 = (state)=>state.editRows;







const $ea1a71a37beb8e38$var$_excluded = [
    "id",
    "field"
], $ea1a71a37beb8e38$var$_excluded2 = [
    "id",
    "field"
];
const $ea1a71a37beb8e38$var$missingOnProcessRowUpdateErrorWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.",
    "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.",
    "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."
], "error");
const $ea1a71a37beb8e38$export$2c9a271ac5d3f446 = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $f2Y41.useState({});
    const cellModesModelRef = $f2Y41.useRef(cellModesModel);
    const prevCellModesModel = $f2Y41.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Cell) callback(...args);
        };
    const throwIfNotEditable = $f2Y41.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $f2Y41.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $f2Y41.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) return;
        const newParams = (0, $asN9r.default)({}, params, {
            reason: (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).cellDoubleClick
        });
        apiRef.current.publishEvent("cellEditStart", newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $f2Y41.useCallback((params, event)=>{
        if (params.cellMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View) return;
        const newParams = (0, $asN9r.default)({}, params, {
            reason: (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).cellFocusOut
        });
        apiRef.current.publishEvent("cellEditStop", newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        if (params.cellMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is deprecated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === "Escape") reason = (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).escapeKeyDown;
            else if (event.key === "Enter") reason = (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).enterKeyDown;
            else if (event.key === "Tab") {
                reason = event.shiftKey ? (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).shiftTabKeyDown : (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $asN9r.default)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent("cellEditStop", newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors("canStartEditing", true, {
                event: event,
                cellParams: params,
                editMode: "cell"
            });
            if (!canStartEditing) return;
            if ((0, $19fd75f0cc198aff$export$b3f2c64190cf8c4)(event)) reason = (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).printableKeyDown;
            else if ((0, $19fd75f0cc198aff$export$dc044e3b830c7edc)(event)) reason = (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).pasteKeyDown;
            else if (event.key === "Enter") reason = (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).enterKeyDown;
            else if (event.key === "Backspace" || event.key === "Delete") reason = (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).deleteKeyDown;
            if (reason) {
                const newParams = (0, $asN9r.default)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent("cellEditStart", newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $f2Y41.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).printableKeyDown || reason === (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).deleteKeyDown || reason === (0, $191aa0090bd3a8f3$export$66744c3b0d0c6217).pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $f2Y41.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).enterKeyDown) cellToFocusAfter = "below";
        else if (reason === (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).tabKeyDown) cellToFocusAfter = "right";
        else if (reason === (0, $191aa0090bd3a8f3$export$73fccbaa325472ee).shiftTabKeyDown) cellToFocusAfter = "left";
        const ignoreModifications = reason === "escapeKeyDown";
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    const runIfNoFieldErrors = (callback)=>async (...args)=>{
            if (callback) {
                const { id: id, field: field } = args[0];
                const editRowsState = apiRef.current.state.editRows;
                const hasFieldErrors = editRowsState[id][field]?.error;
                if (!hasFieldErrors) callback(...args);
            }
        };
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellDoubleClick", runIfEditModeIsCell(handleCellDoubleClick));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellFocusOut", runIfEditModeIsCell(handleCellFocusOut));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", runIfEditModeIsCell(handleCellKeyDown));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellEditStart", runIfEditModeIsCell(handleCellEditStart));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellEditStop", runIfEditModeIsCell(handleCellEditStop));
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "cellEditStart", props.onCellEditStart);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "cellEditStop", runIfNoFieldErrors(props.onCellEditStop));
    const getCellMode = $f2Y41.useCallback((id, field)=>{
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit : (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent("cellModesModelChange", newModel);
    });
    const updateFieldInCellModesModel = $f2Y41.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $asN9r.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $asN9r.default)({}, newModel[id], {
            [field]: (0, $asN9r.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $bKcdJ.default)(_newModel$id, [
                field
            ].map((0, $89fc5a2109771035$export$2e2bcd8739ae039))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $f2Y41.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $asN9r.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $asN9r.default)({}, newEditingState[id], {
                [field]: (0, $asN9r.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $asN9r.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = $f2Y41.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $bKcdJ.default)(params, $ea1a71a37beb8e38$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View);
        updateFieldInCellModesModel(id, field, (0, $asN9r.default)({
            mode: (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        let newValue = apiRef.current.getCellValue(id, field);
        if (deleteValue) {
            const fieldType = apiRef.current.getColumn(field).type;
            switch(fieldType){
                case "boolean":
                    newValue = false;
                    break;
                case "date":
                case "dateTime":
                case "number":
                    newValue = undefined;
                    break;
                case "singleSelect":
                    newValue = null;
                    break;
                case "string":
                default:
                    newValue = "";
                    break;
            }
        } else if (initialValue) newValue = initialValue;
        const newProps = {
            value: newValue,
            error: false,
            isProcessingProps: false
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
    });
    const stopCellEditMode = $f2Y41.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $bKcdJ.default)(params, $ea1a71a37beb8e38$var$_excluded2);
        throwIfNotInMode(id, field, (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit);
        updateFieldInCellModesModel(id, field, (0, $asN9r.default)({
            mode: (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = "none" } = params;
        throwIfNotInMode(id, field, (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== "none") apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $f2Y41.useCallback(async (params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        let newProps = (0, $asN9r.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? "debouncedSetEditCellValue" : "setEditCellValue"
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $asN9r.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View) return false;
        editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        newProps = (0, $asN9r.default)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        return !editingState[id]?.[field]?.error;
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $f2Y41.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : (0, $asN9r.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, editingApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, "private");
    $f2Y41.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        const idToIdLookup = (0, $b2a98a8b3d22f914$export$451ff98f7dd9f13f)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $2b59f632c4f96fc9$export$b7d58db314e0ac27)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                const prevMode = copyOfPrevCellModes[id]?.[field]?.mode || (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View;
                const originalId = idToIdLookup[id] ?? id;
                if (params.mode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit && prevMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View) updateStateToStartCellEditMode((0, $asN9r.default)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View && prevMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) updateStateToStopCellEditMode((0, $asN9r.default)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};





var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");










/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master detail](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $f76d1d28630372ab$export$535533732d8f5c0a = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($f76d1d28630372ab$export$535533732d8f5c0a || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $f76d1d28630372ab$export$723957c53726785f = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($f76d1d28630372ab$export$723957c53726785f || {});



const $a6ba8ed429658f47$var$_excluded = [
    "id"
], $a6ba8ed429658f47$var$_excluded2 = [
    "id"
];
const $a6ba8ed429658f47$var$missingOnProcessRowUpdateErrorWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.",
    "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.",
    "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."
], "error");
const $a6ba8ed429658f47$export$a43bf4f64ed7f919 = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $f2Y41.useState({});
    const rowModesModelRef = $f2Y41.useRef(rowModesModel);
    const prevRowModesModel = $f2Y41.useRef({});
    const focusTimeout = $f2Y41.useRef();
    const nextFocusedCell = $f2Y41.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Row) callback(...args);
        };
    const throwIfNotEditable = $f2Y41.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $f2Y41.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI X: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const hasFieldsWithErrors = $f2Y41.useCallback((rowId)=>{
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        return Object.values(editingState[rowId]).some((fieldProps)=>fieldProps.error);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $f2Y41.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $asN9r.default)({}, rowParams, {
            field: params.field,
            reason: (0, $f76d1d28630372ab$export$535533732d8f5c0a).cellDoubleClick
        });
        apiRef.current.publishEvent("rowEditStart", newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $f2Y41.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $f2Y41.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            if (nextFocusedCell.current?.id !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View) return;
                if (hasFieldsWithErrors(params.id)) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $asN9r.default)({}, rowParams, {
                    field: params.field,
                    reason: (0, $f76d1d28630372ab$export$723957c53726785f).rowFocusOut
                });
                apiRef.current.publishEvent("rowEditStop", newParams, event);
            }
        });
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    $f2Y41.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        if (params.cellMode === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is deprecated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === "Escape") reason = (0, $f76d1d28630372ab$export$723957c53726785f).escapeKeyDown;
            else if (event.key === "Enter") reason = (0, $f76d1d28630372ab$export$723957c53726785f).enterKeyDown;
            else if (event.key === "Tab") {
                const columnFields = (0, $b22d10f7b8994eba$export$c9491722e1d6e8d3)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === (0, $bad448ba77ed9294$export$e2523ab9efeb7465)) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, $f76d1d28630372ab$export$723957c53726785f).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, $f76d1d28630372ab$export$723957c53726785f).tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                if (reason !== (0, $f76d1d28630372ab$export$723957c53726785f).escapeKeyDown && hasFieldsWithErrors(params.id)) return;
                const newParams = (0, $asN9r.default)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent("rowEditStop", newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors("canStartEditing", true, {
                event: event,
                cellParams: params,
                editMode: "row"
            });
            if (!canStartEditing) return;
            if ((0, $19fd75f0cc198aff$export$b3f2c64190cf8c4)(event)) reason = (0, $f76d1d28630372ab$export$535533732d8f5c0a).printableKeyDown;
            else if ((0, $19fd75f0cc198aff$export$dc044e3b830c7edc)(event)) reason = (0, $f76d1d28630372ab$export$535533732d8f5c0a).printableKeyDown;
            else if (event.key === "Enter") reason = (0, $f76d1d28630372ab$export$535533732d8f5c0a).enterKeyDown;
            else if (event.key === "Backspace" || event.key === "Delete") reason = (0, $f76d1d28630372ab$export$535533732d8f5c0a).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $asN9r.default)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent("rowEditStart", newParams, event);
            }
        }
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    const handleRowEditStart = $f2Y41.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === (0, $f76d1d28630372ab$export$535533732d8f5c0a).printableKeyDown || reason === (0, $f76d1d28630372ab$export$535533732d8f5c0a).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $f2Y41.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, $f76d1d28630372ab$export$723957c53726785f).enterKeyDown) cellToFocusAfter = "below";
        else if (reason === (0, $f76d1d28630372ab$export$723957c53726785f).tabKeyDown) cellToFocusAfter = "right";
        else if (reason === (0, $f76d1d28630372ab$export$723957c53726785f).shiftTabKeyDown) cellToFocusAfter = "left";
        const ignoreModifications = reason === "escapeKeyDown";
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellDoubleClick", runIfEditModeIsRow(handleCellDoubleClick));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellFocusIn", runIfEditModeIsRow(handleCellFocusIn));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellFocusOut", runIfEditModeIsRow(handleCellFocusOut));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", runIfEditModeIsRow(handleCellKeyDown));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowEditStart", runIfEditModeIsRow(handleRowEditStart));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowEditStop", runIfEditModeIsRow(handleRowEditStop));
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "rowEditStart", props.onRowEditStart);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "rowEditStop", props.onRowEditStop);
    const getRowMode = $f2Y41.useCallback((id)=>{
        if (props.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Cell) return (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View;
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        const isEditing = editingState[id] && Object.keys(editingState[id]).length > 0;
        return isEditing ? (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit : (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent("rowModesModelChange", newModel);
    });
    const updateRowInRowModesModel = $f2Y41.useCallback((id, newProps)=>{
        const newModel = (0, $asN9r.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $asN9r.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $f2Y41.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $asN9r.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $asN9r.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $f2Y41.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $asN9r.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $asN9r.default)({}, newEditingState[id], {
                [field]: (0, $asN9r.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $asN9r.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = $f2Y41.useCallback((params)=>{
        const { id: id } = params, other = (0, $bKcdJ.default)(params, $a6ba8ed429658f47$var$_excluded);
        throwIfNotInMode(id, (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View);
        updateRowInRowModesModel(id, (0, $asN9r.default)({
            mode: (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const columnFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
        const newProps = columnFields.reduce((acc, field)=>{
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) newValue = deleteValue ? "" : initialValue;
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: false
            };
            return acc;
        }, {});
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
    });
    const stopRowEditMode = $f2Y41.useCallback((params)=>{
        const { id: id } = params, other = (0, $bKcdJ.default)(params, $a6ba8ed429658f47$var$_excluded2);
        throwIfNotInMode(id, (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit);
        updateRowInRowModesModel(id, (0, $asN9r.default)({
            mode: (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = "none" } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== "none" && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit;
            return;
        }
        if (hasFieldsWithErrors(id)) {
            prevRowModesModel.current[id].mode = (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevRowModesModel.current[id].mode = (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit;
                // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $f2Y41.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        let newProps = (0, $asN9r.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? "debouncedSetEditCellValue" : "setEditCellValue"
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $asN9r.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $bKcdJ.default)(_editingState$id, [
                    field
                ].map((0, $89fc5a2109771035$export$2e2bcd8739ae039)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
                    processedProps = (0, $asN9r.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $asN9r.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $bKcdJ.default)(_editingState$id2, [
                    thisField
                ].map((0, $89fc5a2109771035$export$2e2bcd8739ae039)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $asN9r.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit) {
                    editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $f2Y41.useCallback((id)=>{
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $asN9r.default)({}, row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            if (column.valueSetter) rowUpdate = column.valueSetter(fieldProps.value, rowUpdate, column, apiRef);
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, editingApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, "private");
    $f2Y41.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        const idToIdLookup = (0, $b2a98a8b3d22f914$export$451ff98f7dd9f13f)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $2b59f632c4f96fc9$export$b7d58db314e0ac27)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(rowModesModel).forEach(([id, params])=>{
            const prevMode = copyOfPrevRowModesModel[id]?.mode || (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View;
            const originalId = idToIdLookup[id] ?? id;
            if (params.mode === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit && prevMode === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View) updateStateToStartRowEditMode((0, $asN9r.default)({
                id: originalId
            }, params));
            else if (params.mode === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).View && prevMode === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit) updateStateToStopRowEditMode((0, $asN9r.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};




const $b28d4da3a0a58897$export$1094a2c822d71ffd = (state)=>(0, $asN9r.default)({}, state, {
        editRows: {}
    });
const $b28d4da3a0a58897$export$3a0db16b152b4c54 = (apiRef, props)=>{
    (0, $ea1a71a37beb8e38$export$2c9a271ac5d3f446)(apiRef, props);
    (0, $a6ba8ed429658f47$export$a43bf4f64ed7f919)(apiRef, props);
    const debounceMap = $f2Y41.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = $f2Y41.useCallback((params)=>{
        if ((0, $5a37f1a88e056eac$export$fc9d832f40054590)(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $f2Y41.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $f2Y41.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $f2Y41.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $f2Y41.useCallback((id, field)=>{
        return props.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $f2Y41.useCallback((id, field)=>{
        const editingState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        return editingState[id]?.[field] ?? null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, editingSharedApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, editingSharedPrivateApi, "private");
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");














var $bKcdJ = parcelRequire("bKcdJ");


var $f2Y41 = parcelRequire("f2Y41");

const $2478736619c33b8c$export$84214fbf04c4094 = "none";
const $2478736619c33b8c$export$8c4aa1977ad5d106 = {
    rowTreeCreation: "rowTree",
    filtering: "rowTree",
    sorting: "rowTree",
    visibleRowsLookupCreation: "rowTree"
};
const $2478736619c33b8c$export$594711f8e5fa9b04 = (apiRef)=>{
    const availableStrategies = $f2Y41.useRef(new Map());
    const strategiesCache = $f2Y41.useRef({});
    const registerStrategyProcessor = $f2Y41.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $bKcdJ.default)(_ref, [
                strategyName
            ].map((0, $89fc5a2109771035$export$2e2bcd8739ae039)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($2478736619c33b8c$export$8c4aa1977ad5d106[processorName])) apiRef.current.publishEvent("activeStrategyProcessorChange", processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $f2Y41.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($2478736619c33b8c$export$8c4aa1977ad5d106[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $f2Y41.useCallback((strategyGroup)=>{
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return availableStrategyEntry?.[0] ?? $2478736619c33b8c$export$84214fbf04c4094;
    }, []);
    const setStrategyAvailability = $f2Y41.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent("strategyAvailabilityChange");
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, strategyProcessingApi, "private");
};


var $f2Y41 = parcelRequire("f2Y41");

const $8a18de3db597e0e0$export$102a3f5a042c47c4 = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $f2Y41.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $f9629e0497ea16d6$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};





var $ge3KO = parcelRequire("ge3KO");
const $23bb249186e93114$export$a3e5a984fe72a5db = (state, props, apiRef)=>{
    const filterModel = props.filterModel ?? props.initialState?.filter?.filterModel ?? (0, $26effb3530f86687$export$7ea23129b8e10cdb)();
    return (0, $asN9r.default)({}, state, {
        filter: {
            filterModel: (0, $6989b4da95410729$export$2a370a0aad2ac7e1)(filterModel, props.disableMultipleColumnsFiltering, apiRef),
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        },
        visibleRowsLookup: {}
    });
};
const $23bb249186e93114$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $23bb249186e93114$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor("visibleRowsLookupCreation", {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $23bb249186e93114$var$createMemoizedValues() {
    return (0, $3aa7588999df3515$export$281bff7f05488aa2)(Object.values);
}
const $23bb249186e93114$export$42838275cbf666c4 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridFilter");
    apiRef.current.registerControlState({
        stateId: "filter",
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, $896120ab6e9a1a0e$export$280aedb9454597a5),
        changeEvent: "filterModelChange"
    });
    const updateFilteredRows = $f2Y41.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(state, apiRef.current.instanceId);
            const isRowMatchingFilters = props.filterMode === "client" ? (0, $6989b4da95410729$export$1c795c7c9654905e)(filterModel, apiRef, props.disableEval) : null;
            const filteringResult = apiRef.current.applyStrategyProcessor("filtering", {
                isRowMatchingFilters: isRowMatchingFilters,
                filterModel: filterModel ?? (0, $26effb3530f86687$export$7ea23129b8e10cdb)()
            });
            const newState = (0, $asN9r.default)({}, state, {
                filter: (0, $asN9r.default)({}, state.filter, filteringResult)
            });
            const visibleRowsLookupState = $23bb249186e93114$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $asN9r.default)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent("filteredRowsSet");
    }, [
        apiRef,
        props.filterMode,
        props.disableEval
    ]);
    const addColumnMenuItem = $f2Y41.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            "columnMenuFilterItem"
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const applyFilters = $f2Y41.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = $f2Y41.useCallback((item)=>{
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            items: items
        }), "upsertFilterItem");
    }, [
        apiRef
    ]);
    const upsertFilterItems = $f2Y41.useCallback((items)=>{
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = existingItems.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            items: existingItems
        }), "upsertFilterItems");
    }, [
        apiRef
    ]);
    const deleteFilterItem = $f2Y41.useCallback((itemToDelete)=>{
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            items: items
        }), "deleteFilterItem");
    }, [
        apiRef
    ]);
    const showFilterPanel = $f2Y41.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug("Displaying filter panel");
        if (targetColumnField) {
            const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = column.filterOperators?.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof filterOperator?.requiresFilterValue === "undefined" ? true : filterOperator?.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $6989b4da95410729$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $6989b4da95410729$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, $3f22a63fe503dede$export$e7e5652452e44b).filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $f2Y41.useCallback(()=>{
        logger.debug("Hiding filter panel");
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $f2Y41.useCallback((logicOperator)=>{
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            logicOperator: logicOperator
        }), "changeLogicOperator");
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $f2Y41.useCallback((values)=>{
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        if ((0, $2b59f632c4f96fc9$export$78fdc9adc3f30400)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $f2Y41.useCallback((model, reason)=>{
        const currentModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        if (currentModel !== model) {
            logger.debug("Setting filter model");
            apiRef.current.updateControlState("filter", (0, $6989b4da95410729$export$f4189e6c713e6dd8)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, filterApi, "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const filterModelToExport = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        props.initialState?.filter?.filterModel != null || // Export if the model is not equal to the default value
        !(0, $2b59f632c4f96fc9$export$78fdc9adc3f30400)(filterModelToExport, (0, $26effb3530f86687$export$7ea23129b8e10cdb)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        props.initialState?.filter?.filterModel
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const filterModel = context.stateToRestore.filter?.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState("filter", (0, $6989b4da95410729$export$f4189e6c713e6dd8)(filterModel, props.disableMultipleColumnsFiltering, apiRef), "restoreState");
        return (0, $asN9r.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $f2Y41.useCallback((initialValue, value)=>{
        if (value === (0, $3f22a63fe503dede$export$e7e5652452e44b).filters) {
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $ge3KO.jsx)(FilterPanel, (0, $asN9r.default)({}, props.slotProps?.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        props.slotProps?.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)($23bb249186e93114$var$createMemoizedValues);
    const flatFilteringMethod = $f2Y41.useCallback((params)=>{
        if (props.filterMode !== "client" || !params.isRowMatchingFilters) return {
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        };
        const dataRowIdToModelLookup = (0, $b2a98a8b3d22f914$export$37767f9110c99048)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $6989b4da95410729$export$8d82b4490466f182)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, apiRef, filterCache);
            filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = "auto-generated-group-footer-root";
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "columnMenu", addColumnMenuItem);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "preferencePanel", preferencePanelPreProcessing);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(apiRef, (0, $2478736619c33b8c$export$84214fbf04c4094), "filtering", flatFilteringMethod);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(apiRef, (0, $2478736619c33b8c$export$84214fbf04c4094), "visibleRowsLookupCreation", $23bb249186e93114$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $f2Y41.useCallback(()=>{
        logger.debug("onColUpdated - GridColumns changed, applying filters");
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        const columnsLookup = (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && columnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $f2Y41.useCallback((methodName)=>{
        if (methodName === "filtering") apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $f2Y41.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                visibleRowsLookup: $23bb249186e93114$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
    // Otherwise, the state is not consistent during the render
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowsSet", updateFilteredRows);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnsChange", handleColumnsChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "activeStrategyProcessorChange", handleStrategyProcessorChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowExpansionChange", updateVisibleRowsLookupState);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnVisibilityModelChange", ()=>{
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        if (filterModel.quickFilterValues && (0, $6989b4da95410729$export$cabca178b367efe0)(filterModel)) // re-apply filters because the quick filter results may have changed
        apiRef.current.unstable_applyFilters();
    });
    /**
   * 1ST RENDER
   */ (0, $f9629e0497ea16d6$export$c5623aa1c38918b6)(()=>{
        apiRef.current.unstable_applyFilters();
    });
    /**
   * EFFECTS
   */ (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");











const $17f8f143b062668f$export$bfde38b067fac467 = (state)=>(0, $asN9r.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const $17f8f143b062668f$export$8b69791fef06a777 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridFocus");
    const lastClickedCell = $f2Y41.useRef(null);
    const publishCellFocusOut = $f2Y41.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent("cellFocusOut", apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $f2Y41.useCallback((id, field)=>{
        const focusedCell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        if (focusedCell?.id === id && focusedCell?.field === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $asN9r.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent("cellFocusIn", apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $f2Y41.useCallback((field, event = {})=>{
        const cell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $asN9r.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $f2Y41.useCallback((field, event = {})=>{
        const cell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $asN9r.default)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $f2Y41.useCallback((field, depth, event = {})=>{
        const cell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        if (cell) apiRef.current.publishEvent("cellFocusOut", apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $f2Y41.useCallback(()=>(0, $f90986e9ff221f63$export$3eeedc3f7263df61)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $f2Y41.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
        const currentPage = (0, $5102b0c2afb145a4$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === "right") columnIndexToFocus += 1;
        else if (direction === "left") columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === "left" || direction === "below") columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === "right") columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $2b59f632c4f96fc9$export$7d15b64cf5a3a4c4)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $f2Y41.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === "Enter" || event.key === "Tab" || event.key === "Shift" || (0, $19fd75f0cc198aff$export$e13d96c38a470518)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $f2Y41.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $f2Y41.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $f90986e9ff221f63$export$3eeedc3f7263df61)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $f2Y41.useCallback((_, event)=>{
        if (event.relatedTarget?.className.includes((0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $f2Y41.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $f2Y41.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors("canUpdateFocus", true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if (cellParams?.id === focusedCell.id && cellParams?.field === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement?.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            apiRef.current.forceUpdate();
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $f2Y41.useCallback((params)=>{
        if (params.cellMode === "view") return;
        const cell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        if (cell?.id !== params.id || cell?.field !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = $f2Y41.useCallback(()=>{
        const cell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        // If the focused cell is in a row which does not exist anymore, then remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        apiRef
    ]);
    const handlePaginationModelChange = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(()=>{
        const currentFocusedCell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $5102b0c2afb145a4$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage) return;
        const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, focusApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, focusPrivateApi, "private");
    $f2Y41.useEffect(()=>{
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.addEventListener("mouseup", handleDocumentClick);
        return ()=>{
            doc.removeEventListener("mouseup", handleDocumentClick);
        };
    }, [
        apiRef,
        handleDocumentClick
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderBlur", handleBlur);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellDoubleClick", handleCellDoubleClick);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellMouseDown", handleCellMouseDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", handleCellKeyDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellModeChange", handleCellModeChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderFocus", handleColumnHeaderFocus);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnGroupHeaderFocus", handleColumnGroupHeaderFocus);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowsSet", handleRowSet);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "paginationModelChange", handlePaginationModelChange);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



const $51e80d1887f31449$export$e29505bd53a069c8 = (state, props)=>(0, $asN9r.default)({}, state, {
        headerFiltering: {
            enabled: props.headerFilters ?? false,
            editing: null,
            menuOpen: null
        }
    });
const $51e80d1887f31449$export$8ee3ddc1b48b5da9 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridHeaderFiltering");
    const setHeaderFilterState = $f2Y41.useCallback((headerFilterState)=>{
        apiRef.current.setState((state)=>{
            // Safety check to avoid MIT users from using it
            // This hook should ultimately be moved to the Pro package
            if (props.signature === "DataGrid") return state;
            return (0, $asN9r.default)({}, state, {
                headerFiltering: {
                    enabled: props.headerFilters ?? false,
                    editing: headerFilterState.editing ?? null,
                    menuOpen: headerFilterState.menuOpen ?? null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.signature,
        props.headerFilters
    ]);
    const startHeaderFilterEditMode = $f2Y41.useCallback((field)=>{
        logger.debug(`Starting edit mode on header filter for field: ${field}`);
        apiRef.current.setHeaderFilterState({
            editing: field
        });
    }, [
        apiRef,
        logger
    ]);
    const stopHeaderFilterEditMode = $f2Y41.useCallback(()=>{
        logger.debug(`Stopping edit mode on header filter`);
        apiRef.current.setHeaderFilterState({
            editing: null
        });
    }, [
        apiRef,
        logger
    ]);
    const showHeaderFilterMenu = $f2Y41.useCallback((field)=>{
        logger.debug(`Opening header filter menu for field: ${field}`);
        apiRef.current.setHeaderFilterState({
            menuOpen: field
        });
    }, [
        apiRef,
        logger
    ]);
    const hideHeaderFilterMenu = $f2Y41.useCallback(()=>{
        logger.debug(`Hiding header filter menu for active field`);
        let fieldToFocus = apiRef.current.state.headerFiltering.menuOpen;
        if (fieldToFocus) {
            const columnLookup = (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setHeaderFilterState({
                menuOpen: null
            });
            apiRef.current.setColumnHeaderFilterFocus(fieldToFocus);
        }
    }, [
        apiRef,
        logger
    ]);
    const headerFilterPrivateApi = {
        setHeaderFilterState: setHeaderFilterState
    };
    const headerFilterApi = {
        startHeaderFilterEditMode: startHeaderFilterEditMode,
        stopHeaderFilterEditMode: stopHeaderFilterEditMode,
        showHeaderFilterMenu: showHeaderFilterMenu,
        hideHeaderFilterMenu: hideHeaderFilterMenu
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, headerFilterApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, headerFilterPrivateApi, "private");
    /*
   * EFFECTS
   */ const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else apiRef.current.setHeaderFilterState({
            enabled: props.headerFilters ?? false
        });
    }, [
        apiRef,
        props.headerFilters
    ]);
};


var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





const $f9e4fc29d101a237$export$16d1dc8477d07e4 = (paginationState, signature, paginationModelProp)=>{
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = paginationModelProp?.pageSize ?? paginationModel.pageSize;
    const page = paginationModelProp?.page ?? paginationModel.page;
    const pageCount = (0, $927c2859d574eba1$export$b287f0ca5dbff6af)(rowCount, pageSize, page);
    if (paginationModelProp && (paginationModelProp?.page !== paginationModel.page || paginationModelProp?.pageSize !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = (0, $927c2859d574eba1$export$41142e40198ee144)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $asN9r.default)({}, paginationModel, {
        page: validPage
    });
    (0, $927c2859d574eba1$export$d3cf54bfe8b6931)(paginationModel.pageSize, signature);
    return paginationModel;
};
const $f9e4fc29d101a237$export$fb13b4a85293b054 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridPaginationModel");
    const densityFactor = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $a8df3c1fd8492eab$export$c646201fb1d3e7a6));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: "paginationModel",
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6),
        changeEvent: "paginationModelChange"
    });
    /**
   * API METHODS
   */ const setPage = $f2Y41.useCallback((page)=>{
        const currentModel = (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = $f2Y41.useCallback((pageSize)=>{
        const currentModel = (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $f2Y41.useCallback((paginationModel)=>{
        const currentModel = (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    paginationModel: $f9e4fc29d101a237$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }));
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, paginationModelApi, "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const paginationModel = (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        props.initialState?.pagination?.paginationModel != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $927c2859d574eba1$export$d515e179bb47bd84)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            pagination: (0, $asN9r.default)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        props.initialState?.pagination?.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const paginationModel = context.stateToRestore.pagination?.paginationModel ? (0, $asN9r.default)({}, (0, $927c2859d574eba1$export$73aa7e9d0fff5ee4)(props.autoPageSize), context.stateToRestore.pagination?.paginationModel) : (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    paginationModel: $f9e4fc29d101a237$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }));
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        const paginationModel = (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        if (apiRef.current.virtualScrollerRef?.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $f2Y41.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions();
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $f2Y41.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef);
        const pageCount = (0, $85e4c16509a27697$export$b81026f1aaf843a4)(apiRef);
        if (paginationModel.page > pageCount - 1) apiRef.current.setPage(Math.max(0, pageCount - 1));
    }, [
        apiRef
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "viewportInnerSizeChange", handleUpdateAutoPageSize);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "paginationModelChange", handlePaginationModelChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowCountChange", handleRowCountChange);
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>{
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    paginationModel: $f9e4fc29d101a237$export$16d1dc8477d07e4(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.paginationMode,
        props.signature
    ]);
    $f2Y41.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





const $6f63fb717ca4ad35$export$229d07cf557fa73f = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridRowCount");
    const visibleTopLevelRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$f88efd30675963d1));
    const rowCountState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$946e4ae85da77ef6));
    const paginationMeta = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$4dee702a38e33bdb));
    const paginationModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6));
    const previousPageSize = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)(()=>(0, $85e4c16509a27697$export$ccc9f04e59d0d8e6)(apiRef).pageSize);
    apiRef.current.registerControlState({
        stateId: "paginationRowCount",
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: (0, $85e4c16509a27697$export$946e4ae85da77ef6),
        changeEvent: "rowCountChange"
    });
    /**
   * API METHODS
   */ const setRowCount = $f2Y41.useCallback((newRowCount)=>{
        if (rowCountState === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger,
        rowCountState
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, paginationRowCountApi, "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const exportedRowCount = (0, $85e4c16509a27697$export$946e4ae85da77ef6)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        props.initialState?.pagination?.rowCount != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            pagination: (0, $asN9r.default)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        props.initialState?.pagination?.rowCount
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const restoredRowCount = context.stateToRestore.pagination?.rowCount ? context.stateToRestore.pagination.rowCount : (0, $85e4c16509a27697$export$946e4ae85da77ef6)(apiRef);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = $f2Y41.useCallback((model)=>{
        if (props.paginationMode === "client" || !previousPageSize.current) return;
        if (model.pageSize !== previousPageSize.current) {
            previousPageSize.current = model.pageSize;
            if (rowCountState === -1) // Row count unknown and page size changed, reset the page
            apiRef.current.setPage(0);
        }
    }, [
        props.paginationMode,
        previousPageSize,
        rowCountState,
        apiRef
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "paginationModelChange", handlePaginationModelChange);
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>{
        if (props.paginationMode === "client") apiRef.current.setRowCount(visibleTopLevelRowCount);
        else if (props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        props.paginationMode,
        visibleTopLevelRowCount,
        props.rowCount
    ]);
    const isLastPage = paginationMeta.hasNextPage === false;
    $f2Y41.useEffect(()=>{
        if (isLastPage && rowCountState === -1) apiRef.current.setRowCount(paginationModel.pageSize * paginationModel.page + visibleTopLevelRowCount);
    }, [
        apiRef,
        visibleTopLevelRowCount,
        isLastPage,
        rowCountState,
        paginationModel
    ]);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



const $5dbc36fa4118c1b2$export$3e4f856d83dbf104 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridPaginationMeta");
    const paginationMeta = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$4dee702a38e33bdb));
    apiRef.current.registerControlState({
        stateId: "paginationMeta",
        propModel: props.paginationMeta,
        propOnChange: props.onPaginationMetaChange,
        stateSelector: (0, $85e4c16509a27697$export$4dee702a38e33bdb),
        changeEvent: "paginationMetaChange"
    });
    /**
   * API METHODS
   */ const setPaginationMeta = $f2Y41.useCallback((newPaginationMeta)=>{
        if (paginationMeta === newPaginationMeta) return;
        logger.debug("Setting 'paginationMeta' to", newPaginationMeta);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    meta: newPaginationMeta
                })
            }));
    }, [
        apiRef,
        logger,
        paginationMeta
    ]);
    const paginationMetaApi = {
        setPaginationMeta: setPaginationMeta
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, paginationMetaApi, "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const exportedPaginationMeta = (0, $85e4c16509a27697$export$4dee702a38e33bdb)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
        props.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
        props.initialState?.pagination?.meta != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            pagination: (0, $asN9r.default)({}, prevState.pagination, {
                meta: exportedPaginationMeta
            })
        });
    }, [
        apiRef,
        props.paginationMeta,
        props.initialState?.pagination?.meta
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const restoredPaginationMeta = context.stateToRestore.pagination?.meta ? context.stateToRestore.pagination.meta : (0, $85e4c16509a27697$export$4dee702a38e33bdb)(apiRef);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                pagination: (0, $asN9r.default)({}, state.pagination, {
                    meta: restoredPaginationMeta
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>{
        if (props.paginationMeta) apiRef.current.setPaginationMeta(props.paginationMeta);
    }, [
        apiRef,
        props.paginationMeta
    ]);
};


const $c8086ac8482f7a3d$export$951a05deca7e869f = (state, props)=>{
    const paginationModel = (0, $asN9r.default)({}, (0, $927c2859d574eba1$export$73aa7e9d0fff5ee4)(props.autoPageSize), props.paginationModel ?? props.initialState?.pagination?.paginationModel);
    (0, $927c2859d574eba1$export$d3cf54bfe8b6931)(paginationModel.pageSize, props.signature);
    const rowCount = props.rowCount ?? props.initialState?.pagination?.rowCount;
    const meta = props.paginationMeta ?? props.initialState?.pagination?.meta ?? {};
    return (0, $asN9r.default)({}, state, {
        pagination: {
            paginationModel: paginationModel,
            rowCount: rowCount,
            meta: meta
        }
    });
};
const $c8086ac8482f7a3d$export$f1c8f1c02d202e22 = (apiRef, props)=>{
    (0, $5dbc36fa4118c1b2$export$3e4f856d83dbf104)(apiRef, props);
    (0, $f9e4fc29d101a237$export$fb13b4a85293b054)(apiRef, props);
    (0, $6f63fb717ca4ad35$export$229d07cf557fa73f)(apiRef, props);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




const $386ede2ee8d35d7d$export$a9f45f767b8ade48 = (state, props)=>(0, $asN9r.default)({}, state, {
        preferencePanel: props.initialState?.preferencePanel ?? {
            open: false
        }
    });
const $386ede2ee8d35d7d$export$343dd9a605dbb75b = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridPreferencesPanel");
    const hideTimeout = $f2Y41.useRef();
    const immediateTimeout = $f2Y41.useRef();
    /**
   * API METHODS
   */ const hidePreferences = $f2Y41.useCallback(()=>{
        logger.debug("Hiding Preferences Panel");
        const preferencePanelState = (0, $89c72c98e1cc6fad$export$37e5474577e02878)(apiRef.current.state);
        if (preferencePanelState.openedPanelValue) apiRef.current.publishEvent("preferencePanelClose", {
            openedPanelValue: preferencePanelState.openedPanelValue
        });
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    // This is to prevent the preferences from closing when you open a select box or another panel,
    // The issue is in MUI core V4 => Fixed in V5
    const doNotHidePanel = $f2Y41.useCallback(()=>{
        immediateTimeout.current = setTimeout(()=>clearTimeout(hideTimeout.current), 0);
    }, []);
    // This is a hack for the issue with Core V4, by delaying hiding the panel on the clickAwayListener,
    // we can cancel the action if the trigger element still need the panel...
    const hidePreferencesDelayed = $f2Y41.useCallback(()=>{
        hideTimeout.current = setTimeout(hidePreferences, 100);
    }, [
        hidePreferences
    ]);
    const showPreferences = $f2Y41.useCallback((newValue, panelId, labelId)=>{
        logger.debug("Opening Preferences Panel");
        doNotHidePanel();
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                preferencePanel: (0, $asN9r.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent("preferencePanelOpen", {
            openedPanelValue: newValue
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        doNotHidePanel,
        apiRef
    ]);
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferencesDelayed
    }, "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const preferencePanelToExport = (0, $89c72c98e1cc6fad$export$37e5474577e02878)(apiRef.current.state);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        props.initialState?.preferencePanel != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        props.initialState?.preferencePanel
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>{
        return ()=>{
            clearTimeout(hideTimeout.current);
            clearTimeout(immediateTimeout.current);
        };
    }, []);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");









var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $f6fd5f423bfa2516$var$_excluded = [
    "field",
    "id",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $f6fd5f423bfa2516$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "checkboxInput"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $f6fd5f423bfa2516$export$de9fc2d8e98d780 = /*#__PURE__*/ $f2Y41.forwardRef(function GridCellCheckboxRenderer(props, ref) {
    const { field: field, id: id, value: isChecked, rowNode: rowNode, hasFocus: hasFocus, tabIndex: tabIndex } = props, other = (0, $bKcdJ.default)(props, $f6fd5f423bfa2516$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $f6fd5f423bfa2516$var$useUtilityClasses(ownerState);
    const checkboxElement = $f2Y41.useRef(null);
    const rippleRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(checkboxElement, ref);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent("rowSelectionCheckboxChange", params, event);
    };
    $f2Y41.useLayoutEffect(()=>{
        if (tabIndex === 0) {
            const element = apiRef.current.getCellElement(id, field);
            if (element) element.tabIndex = -1;
        }
    }, [
        apiRef,
        tabIndex,
        id,
        field
    ]);
    $f2Y41.useEffect(()=>{
        if (hasFocus) {
            const input = checkboxElement.current?.querySelector("input");
            input?.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) // Only available in @mui/material v5.4.1 or later
        rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = $f2Y41.useCallback((event)=>{
        if (event.key === " ") // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
    }, []);
    if (rowNode.type === "footer" || rowNode.type === "pinnedRow") return null;
    const isSelectable = apiRef.current.isRowSelectable(id);
    const label = apiRef.current.getLocaleText(isChecked ? "checkboxSelectionUnselectRow" : "checkboxSelectionSelectRow");
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseCheckbox, (0, $asN9r.default)({
        ref: handleRef,
        tabIndex: tabIndex,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            "aria-label": label
        },
        onKeyDown: handleKeyDown,
        disabled: !isSelectable,
        touchRippleRef: rippleRef /* FIXME: typing error */ 
    }, rootProps.slotProps?.baseCheckbox, other));
});
const $f6fd5f423bfa2516$export$6df0a29182db5ff8 = $f6fd5f423bfa2516$export$de9fc2d8e98d780;



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");












var $ge3KO = parcelRequire("ge3KO");
const $b8cb52ec11675771$var$_excluded = [
    "field",
    "colDef"
];
const $b8cb52ec11675771$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "checkboxInput"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $b8cb52ec11675771$export$22c0c31c5dd8f5aa = /*#__PURE__*/ $f2Y41.forwardRef(function GridHeaderCheckbox(props, ref) {
    const other = (0, $bKcdJ.default)(props, $b8cb52ec11675771$var$_excluded);
    const [, forceUpdate] = $f2Y41.useState(false);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $b8cb52ec11675771$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$29da670438604dbd));
    const selection = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $622635e380529094$export$f663bee74a6091fc));
    const visibleRowIds = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$7a99837e2fd93e42));
    const paginatedVisibleRowIds = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$c1f6a976375edd4a));
    const filteredSelection = $f2Y41.useMemo(()=>{
        if (typeof rootProps.isRowSelectable !== "function") return selection;
        return selection.filter((id)=>{
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $f2Y41.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $f2Y41.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent("headerSelectionCheckboxChange", params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $f2Y41.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $f2Y41.useCallback((event)=>{
        if (event.key === " ") // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent("headerSelectionCheckboxChange", {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $f2Y41.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $f2Y41.useEffect(()=>{
        return apiRef.current.subscribeEvent("rowSelectionChange", handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked ? "checkboxSelectionUnselectAllRows" : "checkboxSelectionSelectAllRows");
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseCheckbox, (0, $asN9r.default)({
        ref: ref,
        indeterminate: isIndeterminate,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            "aria-label": label
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !(0, $c75ea6ead94140f4$export$cfcdc2e1121f7851)(rootProps)
    }, rootProps.slotProps?.baseCheckbox, other));
});





var $ge3KO = parcelRequire("ge3KO");
const $a75f25e717ae3a15$export$322dfed7a1df1b02 = "__check__";
const $a75f25e717ae3a15$export$b2e9ab6103a664ad = (0, $asN9r.default)({}, (0, $a4f8291e52b61094$export$220b51460e149ea9), {
    type: "custom",
    field: $a75f25e717ae3a15$export$322dfed7a1df1b02,
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: undefined,
    display: "flex",
    valueGetter: (value, row, column, apiRef)=>{
        const selectionLookup = (0, $622635e380529094$export$d5aede24ebfe3c98)(apiRef);
        const rowId = apiRef.current.getRowId(row);
        return selectionLookup[rowId] !== undefined;
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $b8cb52ec11675771$export$22c0c31c5dd8f5aa), (0, $asN9r.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $f6fd5f423bfa2516$export$6df0a29182db5ff8), (0, $asN9r.default)({}, params))
});





// Can't import from pro package - hence duplication
const $203fcf5e6d2a11a8$export$6e5a576305a34719 = "__detail_panel_toggle__";





const $f045245d84cc3310$var$getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (selectionModelProp == null) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const $f045245d84cc3310$export$73be1d69367eeb5b = (state, props)=>(0, $asN9r.default)({}, state, {
        rowSelection: props.rowSelection ? $f045245d84cc3310$var$getSelectionModelPropValue(props.rowSelectionModel) ?? [] : []
    });
const $f045245d84cc3310$export$3e2b6b991d9d83f0 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridSelection");
    const runIfRowSelectionIsEnabled = (callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        };
    const propRowSelectionModel = $f2Y41.useMemo(()=>{
        return $f045245d84cc3310$var$getSelectionModelPropValue(props.rowSelectionModel, (0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state));
    }, [
        apiRef,
        props.rowSelectionModel
    ]);
    const lastRowToggled = $f2Y41.useRef(null);
    apiRef.current.registerControlState({
        stateId: "rowSelection",
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: (0, $622635e380529094$export$f663bee74a6091fc),
        changeEvent: "rowSelectionChange"
    });
    const { checkboxSelection: checkboxSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = (0, $c75ea6ead94140f4$export$cfcdc2e1121f7851)(props);
    const visibleRows = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, props);
    const expandMouseRowRangeSelection = $f2Y41.useCallback((id)=>{
        let endId = id;
        const startId = lastRowToggled.current ?? id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $896120ab6e9a1a0e$export$7a99837e2fd93e42)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /**
   * API METHODS
   */ const setRowSelectionModel = $f2Y41.useCallback((model)=>{
        if (props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid && !canHaveMultipleSelection && Array.isArray(model) && model.length > 1) throw new Error([
            "MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection."
        ].join("\n"));
        const currentModel = (0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                    rowSelection: props.rowSelection ? model : []
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    const isRowSelected = $f2Y41.useCallback((id)=>(0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = $f2Y41.useCallback((id)=>{
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = apiRef.current.getRowNode(id);
        if (rowNode?.type === "footer" || rowNode?.type === "pinnedRow") return false;
        return true;
    }, [
        apiRef,
        propIsRowSelectable
    ]);
    const getSelectedRows = $f2Y41.useCallback(()=>(0, $622635e380529094$export$dd53f67f8b4cd8b1)(apiRef), [
        apiRef
    ]);
    const selectRow = $f2Y41.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            apiRef.current.setRowSelectionModel(isSelected ? [
                id
            ] : []);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = (0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state);
            const newSelection = selection.filter((el)=>el !== id);
            if (isSelected) newSelection.push(id);
            const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRows = $f2Y41.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) newSelection = isSelected ? selectableIds : [];
        else {
            // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
            const selectionLookup = (0, $asN9r.default)({}, (0, $622635e380529094$export$d5aede24ebfe3c98)(apiRef));
            selectableIds.forEach((id)=>{
                if (isSelected) selectionLookup[id] = id;
                else delete selectionLookup[id];
            });
            newSelection = Object.values(selectionLookup);
        }
        const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRowRange = $f2Y41.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $896120ab6e9a1a0e$export$7a99837e2fd93e42)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, selectionPublicApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, selectionPrivateApi, props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid ? "private" : "public");
    /**
   * EVENTS
   */ const removeOutdatedSelection = $f2Y41.useCallback(()=>{
        if (props.keepNonExistentRowsSelected) return;
        const currentSelection = (0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state);
        const rowsLookup = (0, $b2a98a8b3d22f914$export$37767f9110c99048)(apiRef);
        // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        const selectionLookup = (0, $asN9r.default)({}, (0, $622635e380529094$export$d5aede24ebfe3c98)(apiRef));
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (!rowsLookup[id]) {
                delete selectionLookup[id];
                hasChanged = true;
            }
        });
        if (hasChanged) apiRef.current.setRowSelectionModel(Object.values(selectionLookup));
    }, [
        apiRef,
        props.keepNonExistentRowsSelected
    ]);
    const handleSingleRowSelection = $f2Y41.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $19fd75f0cc198aff$export$130b789831072f4c)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $f2Y41.useCallback((params, event)=>{
        if (disableRowSelectionOnClick) return;
        const field = event.target.closest(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).cell}`)?.getAttribute("data-field");
        if (field === (0, $a75f25e717ae3a15$export$b2e9ab6103a664ad).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, $203fcf5e6d2a11a8$export$6e5a576305a34719)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $bad448ba77ed9294$export$e2523ab9efeb7465)) return;
        }
        const rowNode = apiRef.current.getRowNode(params.id);
        if (rowNode.type === "pinnedRow") return;
        if (event.shiftKey && canHaveMultipleSelection) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $f2Y41.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) window.getSelection()?.removeAllRanges();
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $f2Y41.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    const handleHeaderSelectionCheckboxChange = $f2Y41.useCallback((params)=>{
        const shouldLimitSelectionToCurrentPage = props.checkboxSelectionVisibleOnly && props.pagination;
        const rowsToBeSelected = shouldLimitSelectionToCurrentPage ? (0, $85e4c16509a27697$export$c1f6a976375edd4a)(apiRef) : (0, $896120ab6e9a1a0e$export$7a99837e2fd93e42)(apiRef);
        const filterModel = (0, $896120ab6e9a1a0e$export$280aedb9454597a5)(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value, filterModel?.items.length > 0);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination
    ]);
    const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $6790963f450ce0fb$export$8ce496ad3bfbe3a6)(event)) return;
        if ((0, $19fd75f0cc198aff$export$e13d96c38a470518)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === " " && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (event.key === "a" && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        visibleRows.rows,
        canHaveMultipleSelection
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "sortedRowsSet", runIfRowSelectionIsEnabled(removeOutdatedSelection));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowClick", runIfRowSelectionIsEnabled(handleRowClick));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowSelectionCheckboxChange", runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "headerSelectionCheckboxChange", handleHeaderSelectionCheckboxChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellMouseDown", runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", runIfRowSelectionIsEnabled(handleCellKeyDown));
    /**
   * EFFECTS
   */ $f2Y41.useEffect(()=>{
        if (propRowSelectionModel !== undefined) apiRef.current.setRowSelectionModel(propRowSelectionModel);
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection
    ]);
    $f2Y41.useEffect(()=>{
        if (!props.rowSelection) apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        props.rowSelection
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $f2Y41.useEffect(()=>{
        if (isStateControlled || !props.rowSelection) return;
        // props.isRowSelectable changed
        const currentSelection = (0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $f2Y41.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $622635e380529094$export$f663bee74a6091fc)(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");











var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

const $ba665b27813960ac$export$d217cc4e11b3c706 = {
    // Root
    noRowsLabel: "No rows",
    noResultsOverlayLabel: "No results found.",
    // Density selector toolbar button text
    toolbarDensity: "Density",
    toolbarDensityLabel: "Density",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comfortable",
    // Columns selector toolbar button text
    toolbarColumns: "Columns",
    toolbarColumnsLabel: "Select columns",
    // Filters toolbar button text
    toolbarFilters: "Filters",
    toolbarFiltersLabel: "Show filters",
    toolbarFiltersTooltipHide: "Hide filters",
    toolbarFiltersTooltipShow: "Show filters",
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: "Search",
    toolbarQuickFilterDeleteIconLabel: "Clear",
    // Export selector toolbar button text
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Download as CSV",
    toolbarExportPrint: "Print",
    toolbarExportExcel: "Download as Excel",
    // Columns management text
    columnsManagementSearchTitle: "Search",
    columnsManagementNoColumns: "No columns",
    columnsManagementShowHideAllText: "Show/Hide All",
    columnsManagementReset: "Reset",
    // Filter panel text
    filterPanelAddFilter: "Add filter",
    filterPanelRemoveAll: "Remove all",
    filterPanelDeleteIconLabel: "Delete",
    filterPanelLogicOperator: "Logic operator",
    filterPanelOperator: "Operator",
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "Columns",
    filterPanelInputLabel: "Value",
    filterPanelInputPlaceholder: "Filter value",
    // Filter operators text
    filterOperatorContains: "contains",
    filterOperatorEquals: "equals",
    filterOperatorStartsWith: "starts with",
    filterOperatorEndsWith: "ends with",
    filterOperatorIs: "is",
    filterOperatorNot: "is not",
    filterOperatorAfter: "is after",
    filterOperatorOnOrAfter: "is on or after",
    filterOperatorBefore: "is before",
    filterOperatorOnOrBefore: "is on or before",
    filterOperatorIsEmpty: "is empty",
    filterOperatorIsNotEmpty: "is not empty",
    filterOperatorIsAnyOf: "is any of",
    "filterOperator=": "=",
    "filterOperator!=": "!=",
    "filterOperator>": ">",
    "filterOperator>=": ">=",
    "filterOperator<": "<",
    "filterOperator<=": "<=",
    // Header filter operators text
    headerFilterOperatorContains: "Contains",
    headerFilterOperatorEquals: "Equals",
    headerFilterOperatorStartsWith: "Starts with",
    headerFilterOperatorEndsWith: "Ends with",
    headerFilterOperatorIs: "Is",
    headerFilterOperatorNot: "Is not",
    headerFilterOperatorAfter: "Is after",
    headerFilterOperatorOnOrAfter: "Is on or after",
    headerFilterOperatorBefore: "Is before",
    headerFilterOperatorOnOrBefore: "Is on or before",
    headerFilterOperatorIsEmpty: "Is empty",
    headerFilterOperatorIsNotEmpty: "Is not empty",
    headerFilterOperatorIsAnyOf: "Is any of",
    "headerFilterOperator=": "Equals",
    "headerFilterOperator!=": "Not equals",
    "headerFilterOperator>": "Greater than",
    "headerFilterOperator>=": "Greater than or equal to",
    "headerFilterOperator<": "Less than",
    "headerFilterOperator<=": "Less than or equal to",
    // Filter values text
    filterValueAny: "any",
    filterValueTrue: "true",
    filterValueFalse: "false",
    // Column menu text
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Show columns",
    columnMenuManageColumns: "Manage columns",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Hide column",
    columnMenuUnsort: "Unsort",
    columnMenuSortAsc: "Sort by ASC",
    columnMenuSortDesc: "Sort by DESC",
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: "Show filters",
    columnHeaderSortIconLabel: "Sort",
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: "Total Rows:",
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: "Checkbox selection",
    checkboxSelectionSelectAllRows: "Select all rows",
    checkboxSelectionUnselectAllRows: "Unselect all rows",
    checkboxSelectionSelectRow: "Select row",
    checkboxSelectionUnselectRow: "Unselect row",
    // Boolean cell text
    booleanCellTrueLabel: "yes",
    booleanCellFalseLabel: "no",
    // Actions cell more text
    actionsCellMore: "more",
    // Column pinning text
    pinToLeft: "Pin to left",
    pinToRight: "Pin to right",
    unpin: "Unpin",
    // Tree Data
    treeDataGroupingHeaderName: "Group",
    treeDataExpand: "see children",
    treeDataCollapse: "hide children",
    // Grouping columns
    groupingColumnHeaderName: "Group",
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: "Detail panel toggle",
    expandDetailPanel: "Expand",
    collapseDetailPanel: "Collapse",
    // Used core components translation keys
    MuiTablePagination: {},
    // Row reordering text
    rowReorderingHeaderName: "Row reordering",
    // Aggregation
    aggregationMenuItemHeader: "Aggregation",
    aggregationFunctionLabelSum: "sum",
    aggregationFunctionLabelAvg: "avg",
    aggregationFunctionLabelMin: "min",
    aggregationFunctionLabelMax: "max",
    aggregationFunctionLabelSize: "size"
};



var $asN9r = parcelRequire("asN9r");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");





"use client";
function $d544b111c993aff9$export$6105a25a68f1d9ae(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $41e3424fd3b32970$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}







function $95f76b17bd734729$export$aaccef17e6dab084(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiBadge", slot);
}
const $95f76b17bd734729$var$badgeClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
var $95f76b17bd734729$export$2e2bcd8739ae039 = $95f76b17bd734729$var$badgeClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $34e12ad74fb61570$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $34e12ad74fb61570$var$RADIUS_STANDARD = 10;
const $34e12ad74fb61570$var$RADIUS_DOT = 4;
const $34e12ad74fb61570$var$useThemeProps = (0, $a9e911e8634675ad$export$ff8356348e0cc878)("MuiBadge");
const $34e12ad74fb61570$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(overlap)}`,
            `overlap${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(overlap)}`,
            color !== "default" && `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $95f76b17bd734729$export$aaccef17e6dab084), classes);
};
const $34e12ad74fb61570$var$BadgeRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $34e12ad74fb61570$var$BadgeBadge = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $34e12ad74fb61570$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $34e12ad74fb61570$var$RADIUS_STANDARD * 2,
        borderRadius: $34e12ad74fb61570$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: "dot"
                },
                style: {
                    borderRadius: $34e12ad74fb61570$var$RADIUS_DOT,
                    height: $34e12ad74fb61570$var$RADIUS_DOT * 2,
                    minWidth: $34e12ad74fb61570$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $95f76b17bd734729$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $34e12ad74fb61570$var$Badge = /*#__PURE__*/ $f2Y41.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = $34e12ad74fb61570$var$useThemeProps({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $bKcdJ.default)(props, $34e12ad74fb61570$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $d544b111c993aff9$export$6105a25a68f1d9ae)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $41e3424fd3b32970$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = (0, $asN9r.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $34e12ad74fb61570$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $34e12ad74fb61570$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $34e12ad74fb61570$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)(RootSlot, (0, $asN9r.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $ge3KO.jsx)(BadgeSlot, (0, $asN9r.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $34e12ad74fb61570$export$2e2bcd8739ae039 = $34e12ad74fb61570$var$Badge;









var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $880894ea0c6fa4d3$var$_excluded = [
    "className"
];
const $880894ea0c6fa4d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "iconButtonContainer"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $880894ea0c6fa4d3$var$GridIconButtonContainerRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "IconButtonContainer",
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: "flex",
        visibility: "hidden",
        width: 0
    }));
const $880894ea0c6fa4d3$export$e67562d5b709404c = /*#__PURE__*/ $f2Y41.forwardRef(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $880894ea0c6fa4d3$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $880894ea0c6fa4d3$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($880894ea0c6fa4d3$var$GridIconButtonContainerRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
});



var $ge3KO = parcelRequire("ge3KO");
const $37f4650f5e79f594$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            "filterIcon"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $37f4650f5e79f594$export$35b5c67d267fafd7(props) {
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $asN9r.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $37f4650f5e79f594$var$useUtilityClasses(ownerState);
    const preferencePanel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $89c72c98e1cc6fad$export$37e5474577e02878));
    const labelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const panelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const toggleFilter = $f2Y41.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $89c72c98e1cc6fad$export$37e5474577e02878)(apiRef.current.state);
        if (open && openedPanelValue === (0, $3f22a63fe503dede$export$e7e5652452e44b).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const open = preferencePanel.open && preferencePanel.labelId === labelId;
    const iconButton = /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
        id: labelId,
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText("columnHeaderFiltersLabel"),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-controls": open ? panelId : undefined
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
        title: apiRef.current.getLocaleText("columnHeaderFiltersTooltipActive")(counter),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $880894ea0c6fa4d3$export$e67562d5b709404c), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34e12ad74fb61570$export$2e2bcd8739ae039), {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");







var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $cAicU = parcelRequire("cAicU");





var $4k52v = parcelRequire("4k52v");

var $hjRti = parcelRequire("hjRti");

var $4Um5Q = parcelRequire("4Um5Q");

var $bmohe = parcelRequire("bmohe");

var $ge3KO = parcelRequire("ge3KO");
const $5e83eaeffde665a6$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $5e83eaeffde665a6$var$defaultTheme = (0, $hjRti.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $5e83eaeffde665a6$var$defaultCreateStyledComponent = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $5e83eaeffde665a6$var$useThemePropsDefault(props) {
    return (0, $013a09cb63d6ec53$export$2e2bcd8739ae039)({
        props: props,
        name: "MuiStack",
        defaultTheme: $5e83eaeffde665a6$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $5e83eaeffde665a6$var$joinChildren(children, separator) {
    const childrenArray = $f2Y41.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $f2Y41.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $5e83eaeffde665a6$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $5e83eaeffde665a6$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $asN9r.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $4Um5Q.handleBreakpoints)({
        theme: theme
    }, (0, $4Um5Q.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $bmohe.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $4Um5Q.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $4Um5Q.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $bmohe.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$5e83eaeffde665a6$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $bmohe.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $cAicU.default)(styles, (0, $4Um5Q.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $4Um5Q.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $5e83eaeffde665a6$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $5e83eaeffde665a6$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $5e83eaeffde665a6$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (slot)=>(0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($5e83eaeffde665a6$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $f2Y41.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $4k52v.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $bKcdJ.default)(props, $5e83eaeffde665a6$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ge3KO.jsx)(StackRoot, (0, $asN9r.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            children: divider ? $5e83eaeffde665a6$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}




"use client";
const $609ffbeeec7e04a2$var$Stack = (0, $5e83eaeffde665a6$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $b7748db3784530dd$export$2e2bcd8739ae039)({
            props: inProps,
            name: "MuiStack"
        })
});
var $609ffbeeec7e04a2$export$2e2bcd8739ae039 = $609ffbeeec7e04a2$var$Stack;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $4k52v = parcelRequire("4k52v");






function $5afabb645176884d$export$24c1f8f60cbac79e(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiTypography", slot);
}
const $5afabb645176884d$var$typographyClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $5afabb645176884d$export$2e2bcd8739ae039 = $5afabb645176884d$var$typographyClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $dcdca1e07a1d8440$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $dcdca1e07a1d8440$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $5afabb645176884d$export$24c1f8f60cbac79e), classes);
};
const $dcdca1e07a1d8440$export$140e2f5526d3cad8 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $dcdca1e07a1d8440$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $dcdca1e07a1d8440$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $dcdca1e07a1d8440$var$transformDeprecatedColors = (color)=>{
    return $dcdca1e07a1d8440$var$colorTransformations[color] || color;
};
const $dcdca1e07a1d8440$var$Typography = /*#__PURE__*/ $f2Y41.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $dcdca1e07a1d8440$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $4k52v.default)((0, $asN9r.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $dcdca1e07a1d8440$var$defaultVariantMapping } = props, other = (0, $bKcdJ.default)(props, $dcdca1e07a1d8440$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $dcdca1e07a1d8440$var$defaultVariantMapping[variant]) || "span";
    const classes = $dcdca1e07a1d8440$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($dcdca1e07a1d8440$export$140e2f5526d3cad8, (0, $asN9r.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $dcdca1e07a1d8440$export$2e2bcd8739ae039 = $dcdca1e07a1d8440$var$Typography;







function $2766ec80f7f7895d$export$717666c39ec07e12(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiFormControlLabel", slot);
}
const $2766ec80f7f7895d$var$formControlLabelClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $2766ec80f7f7895d$export$2e2bcd8739ae039 = $2766ec80f7f7895d$var$formControlLabelClasses;




var $ge3KO = parcelRequire("ge3KO");
"use client";
const $a8dbe1f6d78216c3$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $a8dbe1f6d78216c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2766ec80f7f7895d$export$717666c39ec07e12), classes);
};
const $a8dbe1f6d78216c3$export$1b479270917a5676 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2766ec80f7f7895d$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $2766ec80f7f7895d$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $2766ec80f7f7895d$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $2766ec80f7f7895d$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $a8dbe1f6d78216c3$var$AsteriskComponent = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $2766ec80f7f7895d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $a8dbe1f6d78216c3$var$FormControlLabel = /*#__PURE__*/ $f2Y41.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $bKcdJ.default)(props, $a8dbe1f6d78216c3$var$_excluded);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $asN9r.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $a8dbe1f6d78216c3$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $dcdca1e07a1d8440$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dcdca1e07a1d8440$export$2e2bcd8739ae039), (0, $asN9r.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($a8dbe1f6d78216c3$export$1b479270917a5676, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $f2Y41.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $609ffbeeec7e04a2$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ge3KO.jsxs)($a8dbe1f6d78216c3$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $a8dbe1f6d78216c3$export$2e2bcd8739ae039 = $a8dbe1f6d78216c3$var$FormControlLabel;









const $999d92a0d39f56c7$export$bfa7dd6f7574dd6b = (a, b)=>{
    // Filter `false` values only, as `true` and not having a key are the same
    const aFalseValues = new Set(Object.keys(a).filter((key)=>a[key] === false));
    const bFalseValues = new Set(Object.keys(b).filter((key)=>b[key] === false));
    if (aFalseValues.size !== bFalseValues.size) return false;
    let result = true;
    aFalseValues.forEach((key)=>{
        if (!bFalseValues.has(key)) result = false;
    });
    return result;
};
const $999d92a0d39f56c7$export$cbdfd8d51f352d2a = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;



var $ge3KO = parcelRequire("ge3KO");
const $05fe9c724f5c3995$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "columnsManagement"
        ],
        header: [
            "columnsManagementHeader"
        ],
        footer: [
            "columnsManagementFooter"
        ],
        row: [
            "columnsManagementRow"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $05fe9c724f5c3995$var$collator = new Intl.Collator();
function $05fe9c724f5c3995$export$3710e0bb3d9954d(props) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const searchInputRef = $f2Y41.useRef(null);
    const columns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$da85f06e3c19f1fd));
    const initialColumnVisibilityModel = (0, $b051a6871807a6e6$export$2e2bcd8739ae039)(()=>(0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef)).current;
    const columnVisibilityModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4));
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const [searchValue, setSearchValue] = $f2Y41.useState("");
    const classes = $05fe9c724f5c3995$var$useUtilityClasses(rootProps);
    const { sort: sort, searchPredicate: searchPredicate = (0, $999d92a0d39f56c7$export$cbdfd8d51f352d2a), autoFocusSearchField: autoFocusSearchField = true, disableShowHideToggle: disableShowHideToggle = false, disableResetButton: disableResetButton = false, toggleAllMode: toggleAllMode = "all", getTogglableColumns: getTogglableColumns } = props;
    const isResetDisabled = $f2Y41.useMemo(()=>(0, $999d92a0d39f56c7$export$bfa7dd6f7574dd6b)(columnVisibilityModel, initialColumnVisibilityModel), [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    const sortedColumns = $f2Y41.useMemo(()=>{
        switch(sort){
            case "asc":
                return [
                    ...columns
                ].sort((a, b)=>$05fe9c724f5c3995$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case "desc":
                return [
                    ...columns
                ].sort((a, b)=>-$05fe9c724f5c3995$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const currentColumns = $f2Y41.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const toggleAllColumns = $f2Y41.useCallback((isVisible)=>{
        const currentModel = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
        const newModel = (0, $asN9r.default)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === "filteredOnly" ? currentColumns : columns).forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    const handleSearchValueChange = $f2Y41.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const hideableColumns = $f2Y41.useMemo(()=>currentColumns.filter((col)=>col.hideable), [
        currentColumns
    ]);
    const allHideableColumnsVisible = $f2Y41.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const allHideableColumnsHidden = $f2Y41.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] === false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const firstSwitchRef = $f2Y41.useRef(null);
    $f2Y41.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === "function") firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($05fe9c724f5c3995$var$GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTextField, (0, $asN9r.default)({
                    placeholder: apiRef.current.getLocaleText("columnsManagementSearchTitle"),
                    inputRef: searchInputRef,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "outlined",
                    size: "small",
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseInputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.quickFilterIcon, {})
                        }),
                        sx: {
                            pl: 1.5
                        }
                    },
                    fullWidth: true
                }, rootProps.slotProps?.baseTextField))
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)($05fe9c724f5c3995$var$GridColumnsManagementBody, {
                className: classes.root,
                ownerState: rootProps,
                children: [
                    currentColumns.map((column)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $a8dbe1f6d78216c3$export$2e2bcd8739ae039), {
                            className: classes.row,
                            control: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseCheckbox, (0, $asN9r.default)({
                                disabled: column.hideable === false,
                                checked: columnVisibilityModel[column.field] !== false,
                                onClick: toggleColumn,
                                name: column.field,
                                sx: {
                                    p: 0.5
                                },
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                            }, rootProps.slotProps?.baseCheckbox)),
                            label: column.headerName || column.field
                        }, column.field)),
                    currentColumns.length === 0 && /*#__PURE__*/ (0, $ge3KO.jsx)($05fe9c724f5c3995$var$GridColumnsManagementEmptyText, {
                        ownerState: rootProps,
                        children: apiRef.current.getLocaleText("columnsManagementNoColumns")
                    })
                ]
            }),
            (!disableShowHideToggle || !disableResetButton) && currentColumns.length > 0 ? /*#__PURE__*/ (0, $ge3KO.jsxs)($05fe9c724f5c3995$var$GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a8dbe1f6d78216c3$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseCheckbox, (0, $asN9r.default)({
                            disabled: hideableColumns.length === 0,
                            checked: allHideableColumnsVisible,
                            indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                            onClick: ()=>toggleAllColumns(!allHideableColumnsVisible),
                            name: apiRef.current.getLocaleText("columnsManagementShowHideAllText"),
                            sx: {
                                p: 0.5
                            }
                        }, rootProps.slotProps?.baseCheckbox)),
                        label: apiRef.current.getLocaleText("columnsManagementShowHideAllText")
                    }) : /*#__PURE__*/ (0, $ge3KO.jsx)("span", {}),
                    !disableResetButton ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
                        onClick: ()=>apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel),
                        disabled: isResetDisabled
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText("columnsManagementReset")
                    })) : null
                ]
            }) : null
        ]
    });
}
const $05fe9c724f5c3995$var$GridColumnsManagementBody = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ColumnsManagement",
    overridesResolver: (props, styles)=>styles.columnsManagement
})(({ theme: theme })=>({
        padding: theme.spacing(0, 3, 1.5),
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        flex: "1 1",
        maxHeight: 400,
        alignItems: "flex-start"
    }));
const $05fe9c724f5c3995$var$GridColumnsManagementHeader = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ColumnsManagementHeader",
    overridesResolver: (props, styles)=>styles.columnsManagementHeader
})(({ theme: theme })=>({
        padding: theme.spacing(1.5, 3)
    }));
const $05fe9c724f5c3995$var$GridColumnsManagementFooter = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ColumnsManagementFooter",
    overridesResolver: (props, styles)=>styles.columnsManagementFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1, 0.5, 3),
        display: "flex",
        justifyContent: "space-between",
        borderTop: `1px solid ${theme.palette.divider}`
    }));
const $05fe9c724f5c3995$var$GridColumnsManagementEmptyText = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        padding: theme.spacing(0.5, 0),
        color: theme.palette.grey[500]
    }));


var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $f2Y41 = parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $b84482192cce51f3$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $b84482192cce51f3$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $b84482192cce51f3$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $b84482192cce51f3$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $b84482192cce51f3$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $b84482192cce51f3$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($b84482192cce51f3$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $b84482192cce51f3$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$b84482192cce51f3$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $b84482192cce51f3$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $b84482192cce51f3$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $b84482192cce51f3$var$defaultGetTabbable, isEnabled: isEnabled = $b84482192cce51f3$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $f2Y41.useRef(false);
    const sentinelStart = $f2Y41.useRef(null);
    const sentinelEnd = $f2Y41.useRef(null);
    const nodeToRestore = $f2Y41.useRef(null);
    const reactFocusEventTarget = $f2Y41.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $f2Y41.useRef(false);
    const rootRef = $f2Y41.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $f2Y41.useRef(null);
    $f2Y41.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $f2Y41.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $f2Y41.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $f2Y41.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}







var $ge3KO = parcelRequire("ge3KO");
const $53a08902def58be1$var$_excluded = [
    "className",
    "slotProps"
];
const $53a08902def58be1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "panelWrapper"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $53a08902def58be1$var$GridPanelWrapperRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "PanelWrapper",
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    "&:focus": {
        outline: 0
    }
});
const $53a08902def58be1$var$isEnabled = ()=>true;
const $53a08902def58be1$export$6a36e1ca07bd502c = /*#__PURE__*/ $f2Y41.forwardRef(function GridPanelWrapper(props, ref) {
    const { className: className, slotProps: slotProps = {} } = props, other = (0, $bKcdJ.default)(props, $53a08902def58be1$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $53a08902def58be1$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b84482192cce51f3$export$34eba2437817a67b), (0, $asN9r.default)({
        open: true,
        disableEnforceFocus: true,
        isEnabled: $53a08902def58be1$var$isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($53a08902def58be1$var$GridPanelWrapperRoot, (0, $asN9r.default)({
            ref: ref,
            tabIndex: -1,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
            ownerState: rootProps
        }, other))
    }));
});





var $ge3KO = parcelRequire("ge3KO");
function $0ff983bdc0b3fe9c$export$39d43456ec96cf57(props) {
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $53a08902def58be1$export$6a36e1ca07bd502c), (0, $asN9r.default)({}, props, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $05fe9c724f5c3995$export$3710e0bb3d9954d), (0, $asN9r.default)({}, rootProps.slotProps?.columnsManagement))
    }));
}


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");
parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $6f3c9146951b6947$var$_excluded = [
    "className"
];
const $6f3c9146951b6947$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "panelContent"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $6f3c9146951b6947$var$GridPanelContentRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "PanelContent",
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    flex: "1 1",
    maxHeight: 400
});
function $6f3c9146951b6947$export$1b4102a66373332b(props) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $6f3c9146951b6947$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $6f3c9146951b6947$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($6f3c9146951b6947$var$GridPanelContentRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: rootProps
    }, other));
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");
parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $9da1ea7cab05a8f9$var$_excluded = [
    "className"
];
const $9da1ea7cab05a8f9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "panelFooter"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $9da1ea7cab05a8f9$var$GridPanelFooterRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "PanelFooter",
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5),
        display: "flex",
        justifyContent: "space-between"
    }));
function $9da1ea7cab05a8f9$export$18e44097a2744a(props) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $9da1ea7cab05a8f9$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $9da1ea7cab05a8f9$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($9da1ea7cab05a8f9$var$GridPanelFooterRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: rootProps
    }, other));
}




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $gl072 = parcelRequire("gl072");











var $ge3KO = parcelRequire("ge3KO");
const $31527bb7458d79be$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "readOnly",
    "children"
], $31527bb7458d79be$var$_excluded2 = [
    "InputComponentProps"
];
const $31527bb7458d79be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "filterForm"
        ],
        deleteIcon: [
            "filterFormDeleteIcon"
        ],
        logicOperatorInput: [
            "filterFormLogicOperatorInput"
        ],
        columnInput: [
            "filterFormColumnInput"
        ],
        operatorInput: [
            "filterFormOperatorInput"
        ],
        valueInput: [
            "filterFormValueInput"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $31527bb7458d79be$var$GridFilterFormRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FilterForm",
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme: theme })=>({
        display: "flex",
        padding: theme.spacing(1)
    }));
const $31527bb7458d79be$var$FilterFormDeleteIcon = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FilterFormDeleteIcon",
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme: theme })=>({
        flexShrink: 0,
        justifyContent: "flex-end",
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const $31527bb7458d79be$var$FilterFormLogicOperatorInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FilterFormLogicOperatorInput",
    overridesResolver: (_, styles)=>styles.filterFormLogicOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: "end"
});
const $31527bb7458d79be$var$FilterFormColumnInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FilterFormColumnInput",
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const $31527bb7458d79be$var$FilterFormOperatorInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FilterFormOperatorInput",
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 120
});
const $31527bb7458d79be$var$FilterFormValueInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FilterFormValueInput",
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const $31527bb7458d79be$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And:
            return "filterPanelOperatorAnd";
        case (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).Or:
            return "filterPanelOperatorOr";
        default:
            throw new Error("MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.");
    }
};
const $31527bb7458d79be$var$getColumnLabel = (col)=>col.headerName || col.field;
const $31527bb7458d79be$var$collator = new Intl.Collator();
const $31527bb7458d79be$export$4c95feba7016dbe7 = /*#__PURE__*/ $f2Y41.forwardRef(function GridFilterForm(props, ref) {
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And,
        (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {}, readOnly: readOnly } = props, other = (0, $bKcdJ.default)(props, $31527bb7458d79be$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const columnLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd));
    const filterableColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$2cad659ba95fed71));
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const columnSelectId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const columnSelectLabelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const operatorSelectId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const operatorSelectLabelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $31527bb7458d79be$var$useUtilityClasses(rootProps);
    const valueRef = $f2Y41.useRef(null);
    const filterSelectorRef = $f2Y41.useRef(null);
    const multiFilterOperator = filterModel.logicOperator ?? (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And;
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseFormControlProps = rootProps.slotProps?.baseFormControl || {};
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isBaseSelectNative = baseSelectProps.native ?? false;
    const baseInputLabelProps = rootProps.slotProps?.baseInputLabel || {};
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $bKcdJ.default)(valueInputProps, $31527bb7458d79be$var$_excluded2);
    const { filteredColumns: filteredColumns, selectedField: selectedField } = $f2Y41.useMemo(()=>{
        let itemField = item.field;
        // Yields a valid value if the current filter belongs to a column that is not filterable
        const selectedNonFilterableColumn = columnLookup[item.field].filterable === false ? columnLookup[item.field] : null;
        if (selectedNonFilterableColumn) return {
            filteredColumns: [
                selectedNonFilterableColumn
            ],
            selectedField: itemField
        };
        if (filterColumns === undefined || typeof filterColumns !== "function") return {
            filteredColumns: filterableColumns,
            selectedField: itemField
        };
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: filterModel?.items || []
        });
        return {
            filteredColumns: filterableColumns.filter((column)=>{
                const isFieldIncluded = filteredFields.includes(column.field);
                if (column.field === item.field && !isFieldIncluded) itemField = undefined;
                return isFieldIncluded;
            }),
            selectedField: itemField
        };
    }, [
        filterColumns,
        filterModel?.items,
        filterableColumns,
        item.field,
        columnLookup
    ]);
    const sortedFilteredColumns = $f2Y41.useMemo(()=>{
        switch(columnsSort){
            case "asc":
                return filteredColumns.sort((a, b)=>$31527bb7458d79be$var$collator.compare($31527bb7458d79be$var$getColumnLabel(a), $31527bb7458d79be$var$getColumnLabel(b)));
            case "desc":
                return filteredColumns.sort((a, b)=>-$31527bb7458d79be$var$collator.compare($31527bb7458d79be$var$getColumnLabel(a), $31527bb7458d79be$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $f2Y41.useMemo(()=>{
        if (!item.operator || !currentColumn) return null;
        return currentColumn.filterOperators?.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $f2Y41.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseFilterValue = !newOperator.InputComponent || newOperator.InputComponent !== currentOperator?.InputComponent || column.type !== currentColumn.type;
        let filterValue = eraseFilterValue ? undefined : item.value;
        // Check filter value against the new valueOptions
        if (column.type === "singleSelect" && filterValue !== undefined) {
            const colDef = column;
            const valueOptions = (0, $25d5c231c9438bdc$export$b871910a1101d890)(colDef);
            if (Array.isArray(filterValue)) filterValue = filterValue.filter((val)=>{
                return(// Only keep values that are in the new value options
                (0, $25d5c231c9438bdc$export$b31a7985e33f7505)(val, valueOptions, colDef?.getOptionValue) !== undefined);
            });
            else if ((0, $25d5c231c9438bdc$export$b31a7985e33f7505)(item.value, valueOptions, colDef?.getOptionValue) === undefined) // Reset the filter value if it is not in the new value options
            filterValue = undefined;
        }
        applyFilterChanges((0, $asN9r.default)({}, item, {
            field: field,
            operator: newOperator.value,
            value: filterValue
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $f2Y41.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn?.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !newOperator?.InputComponent || newOperator?.InputComponent !== currentOperator?.InputComponent;
        applyFilterChanges((0, $asN9r.default)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $f2Y41.useCallback((event)=>{
        const logicOperator = event.target.value === (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And.toString() ? (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And : (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        if (rootProps.disableMultipleColumnsFiltering) {
            if (item.value === undefined) deleteFilter(item);
            else // TODO v6: simplify the behavior by always remove the filter form
            applyFilterChanges((0, $asN9r.default)({}, item, {
                value: undefined
            }));
        } else deleteFilter(item);
    };
    $f2Y41.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator?.InputComponent) valueRef?.current?.focus();
                else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($31527bb7458d79be$var$GridFilterFormRoot, (0, $asN9r.default)({
        ref: ref,
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($31527bb7458d79be$var$FilterFormDeleteIcon, (0, $asN9r.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
                    "aria-label": apiRef.current.getLocaleText("filterPanelDeleteIconLabel"),
                    title: apiRef.current.getLocaleText("filterPanelDeleteIconLabel"),
                    onClick: handleDeleteFilter,
                    size: "small",
                    disabled: readOnly
                }, rootProps.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)($31527bb7458d79be$var$FilterFormLogicOperatorInput, (0, $asN9r.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, logicOperatorInputProps, {
                sx: (0, $asN9r.default)({
                    display: hasLogicOperatorColumn ? "flex" : "none",
                    visibility: showMultiFilterOperators ? "visible" : "hidden"
                }, baseFormControlProps.sx || {}, logicOperatorInputProps.sx || {}),
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelect, (0, $asN9r.default)({
                    inputProps: {
                        "aria-label": apiRef.current.getLocaleText("filterPanelLogicOperator")
                    },
                    value: multiFilterOperator ?? "",
                    onChange: changeLogicOperator,
                    disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                    native: isBaseSelectNative
                }, rootProps.slotProps?.baseSelect, {
                    children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $f2Y41.createElement)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, baseSelectOptionProps, {
                            native: isBaseSelectNative,
                            key: logicOperator.toString(),
                            value: logicOperator.toString()
                        }), apiRef.current.getLocaleText($31527bb7458d79be$var$getLogicOperatorLocaleKey(logicOperator))))
                }))
            })),
            /*#__PURE__*/ (0, $ge3KO.jsxs)($31527bb7458d79be$var$FilterFormColumnInput, (0, $asN9r.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseInputLabel, (0, $asN9r.default)({}, baseInputLabelProps, {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText("filterPanelColumns")
                    })),
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelect, (0, $asN9r.default)({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText("filterPanelColumns"),
                        value: selectedField ?? "",
                        onChange: changeColumn,
                        native: isBaseSelectNative,
                        disabled: readOnly
                    }, rootProps.slotProps?.baseSelect, {
                        children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $f2Y41.createElement)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: col.field,
                                value: col.field
                            }), $31527bb7458d79be$var$getColumnLabel(col)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $ge3KO.jsxs)($31527bb7458d79be$var$FilterFormOperatorInput, (0, $asN9r.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseInputLabel, (0, $asN9r.default)({}, baseInputLabelProps, {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText("filterPanelOperator")
                    })),
                    /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseSelect, (0, $asN9r.default)({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText("filterPanelOperator"),
                        id: operatorSelectId,
                        value: item.operator,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef,
                        disabled: readOnly
                    }, rootProps.slotProps?.baseSelect, {
                        children: currentColumn?.filterOperators?.map((operator)=>/*#__PURE__*/ (0, $f2Y41.createElement)(rootProps.slots.baseSelectOption, (0, $asN9r.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: operator.value,
                                value: operator.value
                            }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $gl072.default)(operator.value)}`)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)($31527bb7458d79be$var$FilterFormValueInput, (0, $asN9r.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator?.InputComponent ? /*#__PURE__*/ (0, $ge3KO.jsx)(currentOperator.InputComponent, (0, $asN9r.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef,
                    disabled: readOnly
                }, currentOperator.InputComponentProps, InputComponentProps), item.field) : null
            }))
        ]
    }));
});







var $ge3KO = parcelRequire("ge3KO");
const $21b0e7355a379ba9$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $21b0e7355a379ba9$export$7530149911670467 = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
const $21b0e7355a379ba9$export$32c6e72be8ad862c = /*#__PURE__*/ $f2Y41.forwardRef(function GridFilterPanel(props, ref) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const filterableColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$2cad659ba95fed71));
    const filterableColumnsLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$e84218276cc24419));
    const lastFilterRef = $f2Y41.useRef(null);
    const placeholderFilter = $f2Y41.useRef(null);
    const { logicOperators: logicOperators = [
        (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).And,
        (0, $7c6ca0d6d67acde3$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $bKcdJ.default)(props, $21b0e7355a379ba9$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $f2Y41.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $f2Y41.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === "function") {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: filterModel?.items || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>colDef.filterOperators?.length);
        if (!nextColumnWithOperator) return null;
        return $21b0e7355a379ba9$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel?.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $f2Y41.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== "function") return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $21b0e7355a379ba9$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $f2Y41.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const { readOnlyFilters: readOnlyFilters, validFilters: validFilters } = $f2Y41.useMemo(()=>items.reduce((acc, item)=>{
            if (filterableColumnsLookup[item.field]) acc.validFilters.push(item);
            else acc.readOnlyFilters.push(item);
            return acc;
        }, {
            readOnlyFilters: [],
            validFilters: []
        }), [
        items,
        filterableColumnsLookup
    ]);
    const addNewFilter = $f2Y41.useCallback(()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    }, [
        apiRef,
        getNewFilter,
        items
    ]);
    const deleteFilter = $f2Y41.useCallback((item)=>{
        const shouldCloseFilterPanel = validFilters.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        validFilters.length
    ]);
    const handleRemoveAll = $f2Y41.useCallback(()=>{
        if (validFilters.length === 1 && validFilters[0].value === undefined) {
            apiRef.current.deleteFilterItem(validFilters[0]);
            return apiRef.current.hideFilterPanel();
        }
        return apiRef.current.setFilterModel((0, $asN9r.default)({}, filterModel, {
            items: readOnlyFilters
        }), "removeAllFilterItems");
    }, [
        apiRef,
        readOnlyFilters,
        filterModel,
        validFilters
    ]);
    $f2Y41.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $f2Y41.useEffect(()=>{
        if (validFilters.length > 0) lastFilterRef.current.focus();
    }, [
        validFilters.length
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $53a08902def58be1$export$6a36e1ca07bd502c), (0, $asN9r.default)({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $6f3c9146951b6947$export$1b4102a66373332b), {
                children: [
                    readOnlyFilters.map((item, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $31527bb7458d79be$export$4c95feba7016dbe7), (0, $asN9r.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: index > 0,
                            disableMultiFilterOperator: index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: null,
                            readOnly: true,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index : item.id)),
                    validFilters.map((item, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $31527bb7458d79be$export$4c95feba7016dbe7), (0, $asN9r.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: readOnlyFilters.length + index > 0,
                            disableMultiFilterOperator: readOnlyFilters.length + index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: index === validFilters.length - 1 ? lastFilterRef : null,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index + readOnlyFilters.length : item.id))
                ]
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $9da1ea7cab05a8f9$export$18e44097a2744a), {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText("filterPanelAddFilter")
                    })) : /*#__PURE__*/ (0, $ge3KO.jsx)("span", {}),
                    !disableRemoveAllButton && validFilters.length > 0 ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText("filterPanelRemoveAll")
                    })) : null
                ]
            }) : null
        ]
    }));
});


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");







var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $74fca57e100330da$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $74fca57e100330da$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "selectedRowCount"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $74fca57e100330da$var$GridSelectedRowCountRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "SelectedRowCount",
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme: theme })=>({
        alignItems: "center",
        display: "flex",
        margin: theme.spacing(0, 2),
        visibility: "hidden",
        width: 0,
        height: 0,
        [theme.breakpoints.up("sm")]: {
            visibility: "visible",
            width: "auto",
            height: "auto"
        }
    }));
const $74fca57e100330da$export$e4c9f87515ca4b49 = /*#__PURE__*/ $f2Y41.forwardRef(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $bKcdJ.default)(props, $74fca57e100330da$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $74fca57e100330da$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText("footerRowSelected")(selectedRowCount);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($74fca57e100330da$var$GridSelectedRowCountRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: rowSelectedText
    }));
});



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $63323f83e7c39df7$var$_excluded = [
    "className"
];
const $63323f83e7c39df7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "footerContainer",
            "withBorderColor"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $63323f83e7c39df7$var$GridFooterContainerRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "FooterContainer",
    overridesResolver: (props, styles)=>styles.footerContainer
})({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 52,
    borderTop: "1px solid"
});
const $63323f83e7c39df7$export$dc81d5e0847a9805 = /*#__PURE__*/ $f2Y41.forwardRef(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $63323f83e7c39df7$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $63323f83e7c39df7$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($63323f83e7c39df7$var$GridFooterContainerRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
});




var $ge3KO = parcelRequire("ge3KO");
const $55f62be497184b51$export$6ef0bfefb022d11e = /*#__PURE__*/ $f2Y41.forwardRef(function GridFooter(props, ref) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const totalTopLevelRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$800ab0a68a9efc4f));
    const selectedRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $622635e380529094$export$2e16a09b9ae82bd3));
    const visibleTopLevelRowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$f88efd30675963d1));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $74fca57e100330da$export$e4c9f87515ca4b49), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.footerRowCount, (0, $asN9r.default)({}, rootProps.slotProps?.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.pagination, (0, $asN9r.default)({}, rootProps.slotProps?.pagination));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $63323f83e7c39df7$export$dc81d5e0847a9805), (0, $asN9r.default)({
        ref: ref
    }, props, {
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





var $jvVhJ = parcelRequire("jvVhJ");





function $d037fdde47641838$export$29cad1383b3f235d(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiCircularProgress", slot);
}
const $d037fdde47641838$var$circularProgressClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $d037fdde47641838$export$2e2bcd8739ae039 = $d037fdde47641838$var$circularProgressClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $f1cd6931732d8af8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $f1cd6931732d8af8$var$_ = (t)=>t, $f1cd6931732d8af8$var$_t, $f1cd6931732d8af8$var$_t2, $f1cd6931732d8af8$var$_t3, $f1cd6931732d8af8$var$_t4;
const $f1cd6931732d8af8$var$SIZE = 44;
const $f1cd6931732d8af8$var$circularRotateKeyframe = (0, $jvVhJ.keyframes)($f1cd6931732d8af8$var$_t || ($f1cd6931732d8af8$var$_t = $f1cd6931732d8af8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $f1cd6931732d8af8$var$circularDashKeyframe = (0, $jvVhJ.keyframes)($f1cd6931732d8af8$var$_t2 || ($f1cd6931732d8af8$var$_t2 = $f1cd6931732d8af8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $f1cd6931732d8af8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $d037fdde47641838$export$29cad1383b3f235d), classes);
};
const $f1cd6931732d8af8$var$CircularProgressRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $jvVhJ.css)($f1cd6931732d8af8$var$_t3 || ($f1cd6931732d8af8$var$_t3 = $f1cd6931732d8af8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $f1cd6931732d8af8$var$circularRotateKeyframe));
const $f1cd6931732d8af8$var$CircularProgressSVG = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $f1cd6931732d8af8$var$CircularProgressCircle = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $jvVhJ.css)($f1cd6931732d8af8$var$_t4 || ($f1cd6931732d8af8$var$_t4 = $f1cd6931732d8af8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $f1cd6931732d8af8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $f1cd6931732d8af8$var$CircularProgress = /*#__PURE__*/ $f2Y41.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $bKcdJ.default)(props, $f1cd6931732d8af8$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $f1cd6931732d8af8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($f1cd6931732d8af8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f1cd6931732d8af8$var$CircularProgressRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $asN9r.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($f1cd6931732d8af8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$f1cd6931732d8af8$var$SIZE / 2} ${$f1cd6931732d8af8$var$SIZE / 2} ${$f1cd6931732d8af8$var$SIZE} ${$f1cd6931732d8af8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ge3KO.jsx)($f1cd6931732d8af8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $f1cd6931732d8af8$var$SIZE,
                cy: $f1cd6931732d8af8$var$SIZE,
                r: ($f1cd6931732d8af8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $f1cd6931732d8af8$export$2e2bcd8739ae039 = $f1cd6931732d8af8$var$CircularProgress;



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $ab9ac73e051746f3$var$_excluded = [
    "className"
];
const $ab9ac73e051746f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "overlay"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $ab9ac73e051746f3$var$GridOverlayRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "Overlay",
    overridesResolver: (_, styles)=>styles.overlay
})({
    width: "100%",
    height: "100%",
    display: "flex",
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--unstable_DataGrid-overlayBackground)"
});
const $ab9ac73e051746f3$export$1c41ff9dbe11e487 = /*#__PURE__*/ $f2Y41.forwardRef(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $ab9ac73e051746f3$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $ab9ac73e051746f3$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($ab9ac73e051746f3$var$GridOverlayRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
});



var $ge3KO = parcelRequire("ge3KO");
const $40612179cff5ef84$export$69e47a4ea5ffa191 = /*#__PURE__*/ $f2Y41.forwardRef(function GridLoadingOverlay(props, ref) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab9ac73e051746f3$export$1c41ff9dbe11e487), (0, $asN9r.default)({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f1cd6931732d8af8$export$2e2bcd8739ae039), {})
    }));
});


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");
const $56dc7af5d946b575$export$a25f04494ce53510 = /*#__PURE__*/ $f2Y41.forwardRef(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const noRowsLabel = apiRef.current.getLocaleText("noRowsLabel");
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab9ac73e051746f3$export$1c41ff9dbe11e487), (0, $asN9r.default)({
        ref: ref
    }, props, {
        children: noRowsLabel
    }));
});


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");










var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");












function $d282071a3dd0a567$export$46f01d01378ec5a2(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiDivider", slot);
}
const $d282071a3dd0a567$var$dividerClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $d282071a3dd0a567$export$2e2bcd8739ae039 = $d282071a3dd0a567$var$dividerClasses;




function $08b4da1fe558c745$export$81478e24460c57f2(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiListItemIcon", slot);
}
const $08b4da1fe558c745$var$listItemIconClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $08b4da1fe558c745$export$2e2bcd8739ae039 = $08b4da1fe558c745$var$listItemIconClasses;




function $00ca2ceacfbcfe80$export$1061006a0db3aeb5(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiListItemText", slot);
}
const $00ca2ceacfbcfe80$var$listItemTextClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $00ca2ceacfbcfe80$export$2e2bcd8739ae039 = $00ca2ceacfbcfe80$var$listItemTextClasses;




function $fd6462651a868020$export$515f8c67b5305377(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiMenuItem", slot);
}
const $fd6462651a868020$var$menuItemClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $fd6462651a868020$export$2e2bcd8739ae039 = $fd6462651a868020$var$menuItemClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $32815546ad734a59$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $32815546ad734a59$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $32815546ad734a59$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $fd6462651a868020$export$515f8c67b5305377), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $32815546ad734a59$var$MenuItemRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $1e60465a41fa8bc1$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $32815546ad734a59$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $fd6462651a868020$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $fd6462651a868020$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $fd6462651a868020$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $fd6462651a868020$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $fd6462651a868020$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $d282071a3dd0a567$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $d282071a3dd0a567$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $00ca2ceacfbcfe80$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $00ca2ceacfbcfe80$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $08b4da1fe558c745$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $asN9r.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $08b4da1fe558c745$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $32815546ad734a59$var$MenuItem = /*#__PURE__*/ $f2Y41.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $bKcdJ.default)(props, $32815546ad734a59$var$_excluded);
    const context = $f2Y41.useContext((0, $ea2be9ee151cf4ec$export$2e2bcd8739ae039));
    const childContext = $f2Y41.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $f2Y41.useRef(null);
    (0, $678399b549f398d4$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $asN9r.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $32815546ad734a59$var$useUtilityClasses(props);
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ea2be9ee151cf4ec$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($32815546ad734a59$var$MenuItemRoot, (0, $asN9r.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $32815546ad734a59$export$2e2bcd8739ae039 = $32815546ad734a59$var$MenuItem;



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $cAicU = parcelRequire("cAicU");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $aahau = parcelRequire("aahau");

var $f2Y41 = parcelRequire("f2Y41");









var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");







var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
const $9e18942dda6584ee$var$_excluded = [
    "value"
];
const $9e18942dda6584ee$var$RtlContext = /*#__PURE__*/ $f2Y41.createContext();
function $9e18942dda6584ee$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $bKcdJ.default)(_ref, $9e18942dda6584ee$var$_excluded);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($9e18942dda6584ee$var$RtlContext.Provider, (0, $asN9r.default)({
        value: value != null ? value : true
    }, props));
}
const $9e18942dda6584ee$export$b2dd014b6c321cb = ()=>{
    const value = $f2Y41.useContext($9e18942dda6584ee$var$RtlContext);
    return value != null ? value : false;
};
var $9e18942dda6584ee$export$2e2bcd8739ae039 = $9e18942dda6584ee$var$RtlProvider;




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");












var $4c85269281918ba2$export$2e2bcd8739ae039 = (0, $71559b3d0d8c73fb$export$2e2bcd8739ae039);




var $afc1052648bc09f2$export$2e2bcd8739ae039 = (0, $a97899720a0a78b2$export$2e2bcd8739ae039);





var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $716d2a9107b2303a$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $5375ebb405445332$var$isOverflowing(container) {
    const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $a97899720a0a78b2$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $5375ebb405445332$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $5375ebb405445332$var$getPaddingRight(element) {
    return parseInt((0, $a97899720a0a78b2$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $5375ebb405445332$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $5375ebb405445332$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$5375ebb405445332$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $5375ebb405445332$export$e1bd0c6150f13d96(element, show);
    });
}
function $5375ebb405445332$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $5375ebb405445332$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($5375ebb405445332$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $d358ba0f6d54243e$export$2e2bcd8739ae039)((0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$5375ebb405445332$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$5375ebb405445332$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $a97899720a0a78b2$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $5375ebb405445332$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $5375ebb405445332$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $5375ebb405445332$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $5375ebb405445332$var$getHiddenSiblings(container);
        $5375ebb405445332$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $5375ebb405445332$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $5375ebb405445332$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $5375ebb405445332$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $5375ebb405445332$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $5375ebb405445332$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $5375ebb405445332$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $5375ebb405445332$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $79d9a10fad90b81c$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $79d9a10fad90b81c$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $79d9a10fad90b81c$var$defaultManager = new (0, $5375ebb405445332$export$ce11c4ecd08cea67)();
function $79d9a10fad90b81c$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $79d9a10fad90b81c$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $f2Y41.useRef({});
    const mountNodeRef = $f2Y41.useRef(null);
    const modalRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $f2Y41.useState(!open);
    const hasTransition = $79d9a10fad90b81c$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $79d9a10fad90b81c$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $f2Y41.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $5375ebb405445332$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $f2Y41.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $f2Y41.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $f2Y41.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $6d542b62ee05ff94$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $asN9r.default)({}, propsEventHandlers, otherHandlers);
        return (0, $asN9r.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $asN9r.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $716d2a9107b2303a$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $716d2a9107b2303a$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}








var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
"use client";
const $fde7478636e625b0$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $fde7478636e625b0$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $fde7478636e625b0$var$Fade = /*#__PURE__*/ $f2Y41.forwardRef(function Fade(props, ref) {
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c608aef789663cd5$export$2e2bcd8739ae039) } = props, other = (0, $bKcdJ.default)(props, $fde7478636e625b0$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $f2Y41.useRef(null);
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $3319049c64cfe8b6$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $3319049c64cfe8b6$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $3319049c64cfe8b6$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)(TransitionComponent, (0, $asN9r.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $f2Y41.cloneElement(children, (0, $asN9r.default)({
                style: (0, $asN9r.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $fde7478636e625b0$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $fde7478636e625b0$export$2e2bcd8739ae039 = $fde7478636e625b0$var$Fade;




function $c27a42b08f48eb2b$export$9927a91fd93152bd(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiBackdrop", slot);
}
const $c27a42b08f48eb2b$var$backdropClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $c27a42b08f48eb2b$export$2e2bcd8739ae039 = $c27a42b08f48eb2b$var$backdropClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $fc9f6666224df779$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $fc9f6666224df779$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $c27a42b08f48eb2b$export$9927a91fd93152bd), classes);
};
const $fc9f6666224df779$var$BackdropRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $fc9f6666224df779$var$Backdrop = /*#__PURE__*/ $f2Y41.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $fde7478636e625b0$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $bKcdJ.default)(props, $fc9f6666224df779$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $fc9f6666224df779$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(TransitionComponent, (0, $asN9r.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($fc9f6666224df779$var$BackdropRoot, (0, $asN9r.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $asN9r.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $fc9f6666224df779$export$2e2bcd8739ae039 = $fc9f6666224df779$var$Backdrop;




function $a88ec959dc127002$export$67960e22b12a638d(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiModal", slot);
}
const $a88ec959dc127002$var$modalClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $a88ec959dc127002$export$2e2bcd8739ae039 = $a88ec959dc127002$var$modalClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $c93da198a6a139f4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $c93da198a6a139f4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $a88ec959dc127002$export$67960e22b12a638d), classes);
};
const $c93da198a6a139f4$var$ModalRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $c93da198a6a139f4$var$ModalBackdrop = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $fc9f6666224df779$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $c93da198a6a139f4$var$Modal = /*#__PURE__*/ $f2Y41.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $c93da198a6a139f4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $bKcdJ.default)(props, $c93da198a6a139f4$var$_excluded);
    const propsWithDefaults = (0, $asN9r.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $79d9a10fad90b81c$export$33ffd74ebf07f060)((0, $asN9r.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $asN9r.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $c93da198a6a139f4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $c93da198a6a139f4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $asN9r.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $46ca2500633dfaec$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)(RootSlot, (0, $asN9r.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ge3KO.jsx)(BackdropSlot, (0, $asN9r.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b84482192cce51f3$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $f2Y41.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $c93da198a6a139f4$export$2e2bcd8739ae039 = $c93da198a6a139f4$var$Modal;





function $471b2c8f8b627d1d$export$88f455dd56c95edb(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiPopover", slot);
}
const $471b2c8f8b627d1d$var$popoverClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiPopover", [
    "root",
    "paper"
]);
var $471b2c8f8b627d1d$export$2e2bcd8739ae039 = $471b2c8f8b627d1d$var$popoverClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $4290200fde7300d3$var$_excluded = [
    "onEntering"
], $4290200fde7300d3$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $4290200fde7300d3$var$_excluded3 = [
    "slotProps"
];
function $4290200fde7300d3$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $4290200fde7300d3$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $4290200fde7300d3$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $4290200fde7300d3$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $4290200fde7300d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $471b2c8f8b627d1d$export$88f455dd56c95edb), classes);
};
const $4290200fde7300d3$export$bcce13685275fc99 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $c93da198a6a139f4$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $4290200fde7300d3$export$821346c38a2d9390 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $641b436f34e2d9e2$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $4290200fde7300d3$var$Popover = /*#__PURE__*/ $f2Y41.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $eb1588ef279b9dec$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $bKcdJ.default)(props.TransitionProps, $4290200fde7300d3$var$_excluded), other = (0, $bKcdJ.default)(props, $4290200fde7300d3$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $f2Y41.useRef();
    const handlePaperRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $asN9r.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $4290200fde7300d3$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $f2Y41.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $4290200fde7300d3$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $d2f68c0cafd1caa3$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $4290200fde7300d3$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $4290200fde7300d3$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $f2Y41.useCallback((elemRect)=>{
        return {
            vertical: $4290200fde7300d3$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $4290200fde7300d3$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $f2Y41.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $4290200fde7300d3$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $afc1052648bc09f2$export$2e2bcd8739ae039)($4290200fde7300d3$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $4290200fde7300d3$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $f2Y41.useState(open);
    const setPositioningStyles = $f2Y41.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $f2Y41.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $f2Y41.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $f2Y41.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $f2Y41.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $4c85269281918ba2$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $afc1052648bc09f2$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $d2f68c0cafd1caa3$export$2e2bcd8739ae039)($4290200fde7300d3$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $4290200fde7300d3$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $4290200fde7300d3$export$821346c38a2d9390;
    const paperProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $asN9r.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $asN9r.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $bKcdJ.default)(_useSlotProps, $4290200fde7300d3$var$_excluded3);
    return /*#__PURE__*/ (0, $ge3KO.jsx)(RootSlot, (0, $asN9r.default)({}, rootProps, !(0, $4d97b08b1822aa9b$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(TransitionComponent, (0, $asN9r.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ge3KO.jsx)(PaperSlot, (0, $asN9r.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $4290200fde7300d3$export$2e2bcd8739ae039 = $4290200fde7300d3$var$Popover;






function $4259e99a7458ffad$export$2cf86a63a84fe23d(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiMenu", slot);
}
const $4259e99a7458ffad$var$menuClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $4259e99a7458ffad$export$2e2bcd8739ae039 = $4259e99a7458ffad$var$menuClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $7a2d832bcd3f9533$var$_excluded = [
    "onEntering"
], $7a2d832bcd3f9533$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $7a2d832bcd3f9533$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $7a2d832bcd3f9533$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $7a2d832bcd3f9533$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $4259e99a7458ffad$export$2cf86a63a84fe23d), classes);
};
const $7a2d832bcd3f9533$var$MenuRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $4290200fde7300d3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $7a2d832bcd3f9533$export$4f7c51a5920c9f33 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $4290200fde7300d3$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $7a2d832bcd3f9533$var$MenuMenuList = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $d203149adb48b43d$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $7a2d832bcd3f9533$var$Menu = /*#__PURE__*/ $f2Y41.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $bKcdJ.default)(props.TransitionProps, $7a2d832bcd3f9533$var$_excluded), other = (0, $bKcdJ.default)(props, $7a2d832bcd3f9533$var$_excluded2);
    const isRtl = (0, $9e18942dda6584ee$export$b2dd014b6c321cb)();
    const ownerState = (0, $asN9r.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $7a2d832bcd3f9533$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $f2Y41.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $f2Y41.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $f2Y41.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $7a2d832bcd3f9533$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $24a0362e4a254e17$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)($7a2d832bcd3f9533$var$MenuRoot, (0, $asN9r.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $7a2d832bcd3f9533$var$RTL_ORIGIN : $7a2d832bcd3f9533$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $asN9r.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($7a2d832bcd3f9533$var$MenuMenuList, (0, $asN9r.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $7a2d832bcd3f9533$export$2e2bcd8739ae039 = $7a2d832bcd3f9533$var$Menu;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");







function $7d4851d3f3619702$export$1ee13051fd9e2ab5(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiNativeSelect", slot);
}
const $7d4851d3f3619702$var$nativeSelectClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $7d4851d3f3619702$export$2e2bcd8739ae039 = $7d4851d3f3619702$var$nativeSelectClasses;




var $ge3KO = parcelRequire("ge3KO");
"use client";
const $d2f6ebb263935281$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $d2f6ebb263935281$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $7d4851d3f3619702$export$1ee13051fd9e2ab5), classes);
};
const $d2f6ebb263935281$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $asN9r.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $7d4851d3f3619702$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $d2f6ebb263935281$var$NativeSelectSelect = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $4773145d8cae4871$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $7d4851d3f3619702$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($d2f6ebb263935281$export$c1eccd1617458c87);
const $d2f6ebb263935281$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $7d4851d3f3619702$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $d2f6ebb263935281$var$NativeSelectIcon = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($d2f6ebb263935281$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $d2f6ebb263935281$var$NativeSelectInput = /*#__PURE__*/ $f2Y41.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $bKcdJ.default)(props, $d2f6ebb263935281$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $d2f6ebb263935281$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($d2f6ebb263935281$var$NativeSelectSelect, (0, $asN9r.default)({
                ownerState: ownerState,
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ge3KO.jsx)($d2f6ebb263935281$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $d2f6ebb263935281$export$2e2bcd8739ae039 = $d2f6ebb263935281$var$NativeSelectInput;






"use client";
var $8c595a04ba37cd86$export$2e2bcd8739ae039 = (0, $715e70489ae77e41$export$2e2bcd8739ae039);




function $2edf08e13e38739a$export$2c0c1ee5a3392e(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiSelect", slot);
}
const $2edf08e13e38739a$var$selectClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $2edf08e13e38739a$export$2e2bcd8739ae039 = $2edf08e13e38739a$var$selectClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
var $44d16eb5ecb9e189$var$_span;
const $44d16eb5ecb9e189$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $44d16eb5ecb9e189$var$SelectSelect = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $2edf08e13e38739a$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $2edf08e13e38739a$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $2edf08e13e38739a$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $2edf08e13e38739a$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $d2f6ebb263935281$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $2edf08e13e38739a$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $44d16eb5ecb9e189$var$SelectIcon = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $d2f6ebb263935281$export$e7a817afd12a40d0));
const $44d16eb5ecb9e189$var$SelectNativeInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("input", {
    shouldForwardProp: (prop)=>(0, $be173d695deaaa4f$export$2e2bcd8739ae039)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $44d16eb5ecb9e189$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $44d16eb5ecb9e189$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $44d16eb5ecb9e189$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2edf08e13e38739a$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $44d16eb5ecb9e189$var$SelectInput = /*#__PURE__*/ $f2Y41.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $bKcdJ.default)(props, $44d16eb5ecb9e189$var$_excluded);
    const [value, setValueState] = (0, $8c595a04ba37cd86$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $8c595a04ba37cd86$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $f2Y41.useRef(null);
    const displayRef = $f2Y41.useRef(null);
    const [displayNode, setDisplayNode] = $f2Y41.useState(null);
    const { current: isOpenControlled } = $f2Y41.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $f2Y41.useState();
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $f2Y41.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $f2Y41.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $f2Y41.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $f2Y41.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $f2Y41.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $d2f68c0cafd1caa3$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $f2Y41.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $e46b17d83ec63e21$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $f2Y41.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $aahau.default)(2));
            selected = value.some((v)=>$44d16eb5ecb9e189$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $44d16eb5ecb9e189$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $f2Y41.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $asN9r.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $44d16eb5ecb9e189$var$useUtilityClasses(ownerState);
    const paperProps = (0, $asN9r.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($44d16eb5ecb9e189$var$SelectSelect, (0, $asN9r.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $44d16eb5ecb9e189$var$isEmpty(display) ? $44d16eb5ecb9e189$var$_span || ($44d16eb5ecb9e189$var$_span = /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)($44d16eb5ecb9e189$var$SelectNativeInput, (0, $asN9r.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ge3KO.jsx)($44d16eb5ecb9e189$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7a2d832bcd3f9533$export$2e2bcd8739ae039), (0, $asN9r.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $asN9r.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $asN9r.default)({}, MenuProps.slotProps, {
                    paper: (0, $asN9r.default)({}, paperProps, {
                        style: (0, $asN9r.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $44d16eb5ecb9e189$export$2e2bcd8739ae039 = $44d16eb5ecb9e189$var$SelectInput;






var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $cAicU = parcelRequire("cAicU");







var $ge3KO = parcelRequire("ge3KO");
"use client";
const $caa884ceadaca94e$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $caa884ceadaca94e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $1667ac5b9922e98c$export$cdb270390122322b), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $caa884ceadaca94e$var$InputRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $6d303477181c22f4$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $asN9r.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).disabled}, .${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $1667ac5b9922e98c$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $caa884ceadaca94e$var$InputInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $6d303477181c22f4$export$cf507b112810e72d)
})({});
const $caa884ceadaca94e$var$Input = /*#__PURE__*/ $f2Y41.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $bKcdJ.default)(props, $caa884ceadaca94e$var$_excluded);
    const classes = $caa884ceadaca94e$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $cAicU.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $caa884ceadaca94e$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $caa884ceadaca94e$var$InputInput;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6d303477181c22f4$export$2e2bcd8739ae039), (0, $asN9r.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$caa884ceadaca94e$var$Input.muiName = "Input";
var $caa884ceadaca94e$export$2e2bcd8739ae039 = $caa884ceadaca94e$var$Input;




var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $cAicU = parcelRequire("cAicU");









var $ge3KO = parcelRequire("ge3KO");
"use client";
const $9e7df65f73970a1e$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $9e7df65f73970a1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $98404974968caf68$export$3331e419f1a48437), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $9e7df65f73970a1e$var$FilledInputRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $6d303477181c22f4$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $asN9r.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $98404974968caf68$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $98404974968caf68$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $98404974968caf68$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $98404974968caf68$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $98404974968caf68$export$2e2bcd8739ae039).disabled}, .${(0, $98404974968caf68$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $98404974968caf68$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $asN9r.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $9e7df65f73970a1e$var$FilledInputInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $6d303477181c22f4$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $9e7df65f73970a1e$var$FilledInput = /*#__PURE__*/ $f2Y41.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $bKcdJ.default)(props, $9e7df65f73970a1e$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $9e7df65f73970a1e$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $cAicU.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $9e7df65f73970a1e$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $9e7df65f73970a1e$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6d303477181c22f4$export$2e2bcd8739ae039), (0, $asN9r.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$9e7df65f73970a1e$var$FilledInput.muiName = "Input";
var $9e7df65f73970a1e$export$2e2bcd8739ae039 = $9e7df65f73970a1e$var$FilledInput;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
"use client";
var $b1b4f1623d8fa420$var$_span;
const $b1b4f1623d8fa420$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $b1b4f1623d8fa420$var$NotchedOutlineRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("fieldset", {
    shouldForwardProp: (0, $4773145d8cae4871$export$2e2bcd8739ae039)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $b1b4f1623d8fa420$var$NotchedOutlineLegend = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("legend", {
    shouldForwardProp: (0, $4773145d8cae4871$export$2e2bcd8739ae039)
})(({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $asN9r.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $b1b4f1623d8fa420$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $bKcdJ.default)(props, $b1b4f1623d8fa420$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $asN9r.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)($b1b4f1623d8fa420$var$NotchedOutlineRoot, (0, $asN9r.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($b1b4f1623d8fa420$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                children: label
            }) : $b1b4f1623d8fa420$var$_span || ($b1b4f1623d8fa420$var$_span = /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}









var $ge3KO = parcelRequire("ge3KO");
"use client";
const $b1f7173b41fffbcb$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $b1f7173b41fffbcb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $5472b43da99cd994$export$89922944c7227687), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $b1f7173b41fffbcb$var$OutlinedInputRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $6d303477181c22f4$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $asN9r.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $5472b43da99cd994$export$2e2bcd8739ae039).focused} .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $5472b43da99cd994$export$2e2bcd8739ae039).error} .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $5472b43da99cd994$export$2e2bcd8739ae039).disabled} .${(0, $5472b43da99cd994$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $asN9r.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $b1f7173b41fffbcb$var$NotchedOutlineRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $b1b4f1623d8fa420$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $b1f7173b41fffbcb$var$OutlinedInputInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $6d303477181c22f4$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $6d303477181c22f4$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $b1f7173b41fffbcb$var$OutlinedInput = /*#__PURE__*/ $f2Y41.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $bKcdJ.default)(props, $b1f7173b41fffbcb$var$_excluded);
    const classes = $b1f7173b41fffbcb$var$useUtilityClasses(props);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $asN9r.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $b1f7173b41fffbcb$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $b1f7173b41fffbcb$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6d303477181c22f4$export$2e2bcd8739ae039), (0, $asN9r.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ge3KO.jsx)($b1f7173b41fffbcb$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $asN9r.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$b1f7173b41fffbcb$var$OutlinedInput.muiName = "Input";
var $b1f7173b41fffbcb$export$2e2bcd8739ae039 = $b1f7173b41fffbcb$var$OutlinedInput;






var $ge3KO = parcelRequire("ge3KO");
"use client";
const $03f203b075f5f43c$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $03f203b075f5f43c$var$_excluded2 = [
    "root"
];
const $03f203b075f5f43c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $03f203b075f5f43c$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) && prop !== "variant",
    slot: "Root"
};
const $03f203b075f5f43c$var$StyledInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $caa884ceadaca94e$export$2e2bcd8739ae039), $03f203b075f5f43c$var$styledRootConfig)("");
const $03f203b075f5f43c$var$StyledOutlinedInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $b1f7173b41fffbcb$export$2e2bcd8739ae039), $03f203b075f5f43c$var$styledRootConfig)("");
const $03f203b075f5f43c$var$StyledFilledInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $9e7df65f73970a1e$export$2e2bcd8739ae039), $03f203b075f5f43c$var$styledRootConfig)("");
const $03f203b075f5f43c$var$Select = /*#__PURE__*/ $f2Y41.forwardRef(function Select(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $c9fe8a8d8bc68788$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $bKcdJ.default)(props, $03f203b075f5f43c$var$_excluded);
    const inputComponent = native ? (0, $d2f6ebb263935281$export$2e2bcd8739ae039) : (0, $44d16eb5ecb9e189$export$2e2bcd8739ae039);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $asN9r.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $03f203b075f5f43c$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $bKcdJ.default)(classes, $03f203b075f5f43c$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ge3KO.jsx)($03f203b075f5f43c$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ge3KO.jsx)($03f203b075f5f43c$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ge3KO.jsx)($03f203b075f5f43c$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f2Y41.Fragment, {
        children: /*#__PURE__*/ $f2Y41.cloneElement(InputComponent, (0, $asN9r.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $asN9r.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $asN9r.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $cAicU.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$03f203b075f5f43c$var$Select.muiName = "Select";
var $03f203b075f5f43c$export$2e2bcd8739ae039 = $03f203b075f5f43c$var$Select;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $f2Y41 = parcelRequire("f2Y41");
"use client";
/**
 * @ignore - internal component.
 */ const $60744a31228741c8$var$TableContext = /*#__PURE__*/ $f2Y41.createContext();
var $60744a31228741c8$export$2e2bcd8739ae039 = $60744a31228741c8$var$TableContext;



var $f2Y41 = parcelRequire("f2Y41");
/**
 * @ignore - internal component.
 */ const $0b916dfdb4063259$var$Tablelvl2Context = /*#__PURE__*/ $f2Y41.createContext();
var $0b916dfdb4063259$export$2e2bcd8739ae039 = $0b916dfdb4063259$var$Tablelvl2Context;






function $94756a8031538227$export$33a0f07a16a10b1b(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiTableCell", slot);
}
const $94756a8031538227$var$tableCellClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $94756a8031538227$export$2e2bcd8739ae039 = $94756a8031538227$var$tableCellClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $5a2f75a50fbf9e4f$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $5a2f75a50fbf9e4f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(align)}`,
            padding !== "normal" && `padding${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(padding)}`,
            `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $94756a8031538227$export$33a0f07a16a10b1b), classes);
};
const $5a2f75a50fbf9e4f$var$TableCellRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $dee2dd5afa9d03f4$exports.lighten)((0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.divider, 1), 0.88) : (0, $dee2dd5afa9d03f4$exports.darken)((0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $94756a8031538227$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $5a2f75a50fbf9e4f$var$TableCell = /*#__PURE__*/ $f2Y41.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $bKcdJ.default)(props, $5a2f75a50fbf9e4f$var$_excluded);
    const table = $f2Y41.useContext((0, $60744a31228741c8$export$2e2bcd8739ae039));
    const tablelvl2 = $f2Y41.useContext((0, $0b916dfdb4063259$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $asN9r.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $5a2f75a50fbf9e4f$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $ge3KO.jsx)($5a2f75a50fbf9e4f$var$TableCellRoot, (0, $asN9r.default)({
        as: component,
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $5a2f75a50fbf9e4f$export$2e2bcd8739ae039 = $5a2f75a50fbf9e4f$var$TableCell;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");







function $f4051dd2c48d08ed$export$b12cb262231eef32(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiToolbar", slot);
}
const $f4051dd2c48d08ed$var$toolbarClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $f4051dd2c48d08ed$export$2e2bcd8739ae039 = $f4051dd2c48d08ed$var$toolbarClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $f950dd3c335ec490$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $f950dd3c335ec490$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $f4051dd2c48d08ed$export$b12cb262231eef32), classes);
};
const $f950dd3c335ec490$var$ToolbarRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $f950dd3c335ec490$var$Toolbar = /*#__PURE__*/ $f2Y41.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $bKcdJ.default)(props, $f950dd3c335ec490$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $f950dd3c335ec490$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($f950dd3c335ec490$var$ToolbarRoot, (0, $asN9r.default)({
        as: component,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $f950dd3c335ec490$export$2e2bcd8739ae039 = $f950dd3c335ec490$var$Toolbar;



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $b8c55344cb694e60$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $9403778c8587bb76$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");



parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $e65124054caf89a8$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $0f9fe520e9967837$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $873ee62d0bf4a804$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $873ee62d0bf4a804$var$TablePaginationActions = /*#__PURE__*/ $f2Y41.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $bKcdJ.default)(props, $873ee62d0bf4a804$var$_excluded);
    const isRtl = (0, $9e18942dda6584ee$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $0f9fe520e9967837$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $e65124054caf89a8$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $9403778c8587bb76$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $b8c55344cb694e60$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ge3KO.jsx)(FirstButtonSlot, (0, $asN9r.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel("first", page),
                title: getItemAriaLabel("first", page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ge3KO.jsx)(LastButtonIcon, (0, $asN9r.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $ge3KO.jsx)(FirstButtonIcon, (0, $asN9r.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)(PreviousButtonSlot, (0, $asN9r.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel("previous", page),
                title: getItemAriaLabel("previous", page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ge3KO.jsx)(NextButtonIcon, (0, $asN9r.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $ge3KO.jsx)(PreviousButtonIcon, (0, $asN9r.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)(NextButtonSlot, (0, $asN9r.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel("next", page),
                title: getItemAriaLabel("next", page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ge3KO.jsx)(PreviousButtonIcon, (0, $asN9r.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $ge3KO.jsx)(NextButtonIcon, (0, $asN9r.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $ge3KO.jsx)(LastButtonSlot, (0, $asN9r.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel("last", page),
                title: getItemAriaLabel("last", page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ge3KO.jsx)(FirstButtonIcon, (0, $asN9r.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $ge3KO.jsx)(LastButtonIcon, (0, $asN9r.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $873ee62d0bf4a804$export$2e2bcd8739ae039 = $873ee62d0bf4a804$var$TablePaginationActions;



"use client";
var $4affeda36512a992$export$2e2bcd8739ae039 = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039);




function $952bdd53e50a7a99$export$909e637b22246f4c(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiTablePagination", slot);
}
const $952bdd53e50a7a99$var$tablePaginationClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiTablePagination", [
    "root",
    "toolbar",
    "spacer",
    "selectLabel",
    "selectRoot",
    "select",
    "selectIcon",
    "input",
    "menuItem",
    "displayedRows",
    "actions"
]);
var $952bdd53e50a7a99$export$2e2bcd8739ae039 = $952bdd53e50a7a99$var$tablePaginationClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
var $1d4d831144fb8b85$var$_InputBase;
const $1d4d831144fb8b85$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $1d4d831144fb8b85$var$TablePaginationRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $5a2f75a50fbf9e4f$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: "auto",
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        "&:last-child": {
            padding: 0
        }
    }));
const $1d4d831144fb8b85$var$TablePaginationToolbar = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f950dd3c335ec490$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Toolbar",
    overridesResolver: (props, styles)=>(0, $asN9r.default)({
            [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $1d4d831144fb8b85$var$TablePaginationSpacer = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiTablePagination",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: "1 1 100%"
});
const $1d4d831144fb8b85$var$TablePaginationSelectLabel = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("p", {
    name: "MuiTablePagination",
    slot: "SelectLabel",
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $asN9r.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $1d4d831144fb8b85$var$TablePaginationSelect = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $03f203b075f5f43c$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Select",
    overridesResolver: (props, styles)=>(0, $asN9r.default)({
            [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: "inherit",
    fontSize: "inherit",
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: "right",
        textAlignLast: "right" // Align <select> on Chrome.
    }
});
const $1d4d831144fb8b85$var$TablePaginationMenuItem = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "MenuItem",
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $1d4d831144fb8b85$var$TablePaginationDisplayedRows = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("p", {
    name: "MuiTablePagination",
    slot: "DisplayedRows",
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $asN9r.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $1d4d831144fb8b85$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $1d4d831144fb8b85$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $1d4d831144fb8b85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        toolbar: [
            "toolbar"
        ],
        spacer: [
            "spacer"
        ],
        selectLabel: [
            "selectLabel"
        ],
        select: [
            "select"
        ],
        input: [
            "input"
        ],
        selectIcon: [
            "selectIcon"
        ],
        menuItem: [
            "menuItem"
        ],
        displayedRows: [
            "displayedRows"
        ],
        actions: [
            "actions"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $952bdd53e50a7a99$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $1d4d831144fb8b85$var$TablePagination = /*#__PURE__*/ $f2Y41.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTablePagination"
    });
    const { ActionsComponent: ActionsComponent = (0, $873ee62d0bf4a804$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $5a2f75a50fbf9e4f$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $1d4d831144fb8b85$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $1d4d831144fb8b85$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = "Rows per page:", nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $bKcdJ.default)(props, $1d4d831144fb8b85$var$_excluded);
    const ownerState = props;
    const classes = $1d4d831144fb8b85$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? "option" : $1d4d831144fb8b85$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $5a2f75a50fbf9e4f$export$2e2bcd8739ae039) || component === "td") colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $4affeda36512a992$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $4affeda36512a992$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)($1d4d831144fb8b85$var$TablePaginationRoot, (0, $asN9r.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)($1d4d831144fb8b85$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)($1d4d831144fb8b85$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ge3KO.jsx)($1d4d831144fb8b85$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ge3KO.jsx)($1d4d831144fb8b85$var$TablePaginationSelect, (0, $asN9r.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $1d4d831144fb8b85$var$_InputBase || ($1d4d831144fb8b85$var$_InputBase = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6d303477181c22f4$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $asN9r.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $f2Y41.createElement)(MenuItemComponent, (0, $asN9r.default)({}, !(0, $4d97b08b1822aa9b$export$e28348cc2430497)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $ge3KO.jsx)($1d4d831144fb8b85$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $1d4d831144fb8b85$export$2e2bcd8739ae039 = $1d4d831144fb8b85$var$TablePagination;







var $ge3KO = parcelRequire("ge3KO");
const $5ad7570b81564c00$var$GridPaginationRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $1d4d831144fb8b85$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).selectLabel}`]: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "block"
            }
        },
        [`& .${(0, $952bdd53e50a7a99$export$2e2bcd8739ae039).input}`]: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "inline-flex"
            }
        }
    }));
const $5ad7570b81564c00$var$wrapLabelDisplayedRows = (labelDisplayedRows, estimated)=>{
    return ({ from: from, to: to, count: count, page: page })=>labelDisplayedRows({
            from: from,
            to: to,
            count: count,
            page: page,
            estimated: estimated
        });
};
const $5ad7570b81564c00$var$defaultLabelDisplayedRows = ({ from: from, to: to, count: count, estimated: estimated })=>{
    if (!estimated) return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${estimated > to ? estimated : to}`}`;
};
// A mutable version of a readonly array.
const $5ad7570b81564c00$export$fa9a503101f8d472 = /*#__PURE__*/ $f2Y41.forwardRef(function GridPagination(props, ref) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const paginationModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$ccc9f04e59d0d8e6));
    const rowCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$946e4ae85da77ef6));
    const pageCount = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$b81026f1aaf843a4));
    const { paginationMode: paginationMode, loading: loading, estimatedRowCount: estimatedRowCount } = rootProps;
    const computedProps = $f2Y41.useMemo(()=>{
        if (rowCount === -1 && paginationMode === "server" && loading) return {
            backIconButtonProps: {
                disabled: true
            },
            nextIconButtonProps: {
                disabled: true
            }
        };
        return {};
    }, [
        loading,
        paginationMode,
        rowCount
    ]);
    const lastPage = $f2Y41.useMemo(()=>Math.max(0, pageCount - 1), [
        pageCount
    ]);
    const computedPage = $f2Y41.useMemo(()=>{
        if (rowCount === -1) return paginationModel.page;
        return paginationModel.page <= lastPage ? paginationModel.page : lastPage;
    }, [
        lastPage,
        paginationModel.page,
        rowCount
    ]);
    const handlePageSizeChange = $f2Y41.useCallback((event)=>{
        const pageSize = Number(event.target.value);
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $f2Y41.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === "number") {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    const locales = apiRef.current.getLocaleText("MuiTablePagination");
    const wrappedLabelDisplayedRows = $5ad7570b81564c00$var$wrapLabelDisplayedRows(locales.labelDisplayedRows || $5ad7570b81564c00$var$defaultLabelDisplayedRows, estimatedRowCount);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($5ad7570b81564c00$var$GridPaginationRoot, (0, $asN9r.default)({
        ref: ref,
        component: "div",
        count: rowCount,
        page: computedPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, computedProps, locales, {
        labelDisplayedRows: wrappedLabelDisplayedRows
    }, props));
});


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");











var $ge3KO = parcelRequire("ge3KO");
const $e96ff88f06c27373$var$_excluded = [
    "children",
    "className",
    "classes"
];
const $e96ff88f06c27373$export$e95ad8c1c287de86 = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiDataGrid", [
    "panel",
    "paper"
]);
const $e96ff88f06c27373$var$GridPanelRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f1981fac35ac3785$export$2e2bcd8739ae039), {
    name: "MuiDataGrid",
    slot: "Panel",
    overridesResolver: (props, styles)=>styles.panel
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $e96ff88f06c27373$var$GridPaperRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $641b436f34e2d9e2$export$2e2bcd8739ae039), {
    name: "MuiDataGrid",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: "flex",
        maxWidth: `calc(100vw - ${theme.spacing(0.5)})`,
        overflow: "auto"
    }));
const $e96ff88f06c27373$export$cf917897ad2588b = /*#__PURE__*/ $f2Y41.forwardRef((props, ref)=>{
    const { children: children, className: className } = props, other = (0, $bKcdJ.default)(props, $e96ff88f06c27373$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $e96ff88f06c27373$export$e95ad8c1c287de86;
    const [isPlaced, setIsPlaced] = $f2Y41.useState(false);
    const handleClickAway = $f2Y41.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = $f2Y41.useCallback((event)=>{
        if ((0, $19fd75f0cc198aff$export$a6587fe901c3baf7)(event.key)) apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = $f2Y41.useMemo(()=>[
            {
                name: "flip",
                enabled: false
            },
            {
                name: "isPlaced",
                enabled: true,
                phase: "main",
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const [anchorEl, setAnchorEl] = $f2Y41.useState(null);
    $f2Y41.useEffect(()=>{
        const panelAnchor = apiRef.current.rootElementRef?.current?.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) setAnchorEl(panelAnchor);
    }, [
        apiRef
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)($e96ff88f06c27373$var$GridPanelRoot, (0, $asN9r.default)({
        ref: ref,
        placement: "bottom-start",
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.panel),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $5081c4cca9a52611$export$58385c17fee43f89), {
            mouseEvent: "onMouseUp",
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, $ge3KO.jsx)($e96ff88f06c27373$var$GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




















var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $gl072 = parcelRequire("gl072");

// Based on https://stackoverflow.com/a/59518678
let $41c563574de4e297$var$cachedSupportsPreventScroll;
function $41c563574de4e297$export$ed1f8daf96fc68fb() {
    if ($41c563574de4e297$var$cachedSupportsPreventScroll === undefined) document.createElement("div").focus({
        get preventScroll () {
            $41c563574de4e297$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $41c563574de4e297$var$cachedSupportsPreventScroll;
}









var $f2Y41 = parcelRequire("f2Y41");



class $1544cfea3ebce330$export$f6bd549412d13610 extends Error {
}
function $1544cfea3ebce330$export$d5da41ef394db9ef(apiRef) {
    const getColumnHeaderParams = $f2Y41.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $f2Y41.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $1544cfea3ebce330$export$f6bd549412d13610(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $f2Y41.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $1544cfea3ebce330$export$f6bd549412d13610(`No row with id #${id} found`);
        const rawValue = row[field];
        const value = colDef?.valueGetter ? colDef.valueGetter(rawValue, row, colDef, apiRef) : rawValue;
        const cellFocus = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
        const cellTabIndex = (0, $f90986e9ff221f63$export$2c47652a1f657d56)(apiRef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: apiRef.current.getCellMode(id, field),
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            value: value,
            formattedValue: value,
            isEditable: false
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter(value, row, colDef, apiRef);
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellValue = $f2Y41.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if (!row) throw new $1544cfea3ebce330$export$f6bd549412d13610(`No row with id #${id} found`);
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowValue = $f2Y41.useCallback((row, colDef)=>{
        const field = colDef.field;
        if (!colDef || !colDef.valueGetter) return row[field];
        const value = row[colDef.field];
        return colDef.valueGetter(value, row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowFormattedValue = $f2Y41.useCallback((row, colDef)=>{
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    const getColumnHeaderElement = $f2Y41.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $6790963f450ce0fb$export$94318ffb75913a0b)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $f2Y41.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $6790963f450ce0fb$export$9bc8bb868a922a5f)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $f2Y41.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $6790963f450ce0fb$export$44827662627a59)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue: getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, paramsApi, "public");
}



const $5f42752ff27251f9$export$646c95cff4790794 = (pinnedPosition, indexInSection, sectionLength, showCellVerticalBorderRootProp, gridHasFiller)=>{
    const isSectionLastCell = indexInSection === sectionLength - 1;
    if (pinnedPosition === (0, $49d1610712424e75$export$64f54b460f67389c).LEFT && isSectionLastCell) return true;
    if (showCellVerticalBorderRootProp) {
        if (pinnedPosition === (0, $49d1610712424e75$export$64f54b460f67389c).LEFT) return true;
        if (pinnedPosition === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT) return !isSectionLastCell;
        // pinnedPosition === undefined, middle section
        return !isSectionLastCell || gridHasFiller;
    }
    return false;
};
const $5f42752ff27251f9$export$c01fd18a9a3d03b3 = (pinnedPosition, indexInSection)=>{
    return pinnedPosition === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT && indexInSection === 0;
};




var $ge3KO = parcelRequire("ge3KO");
const $35952bc45c850842$var$_excluded = [
    "column",
    "rowId",
    "editCellState",
    "align",
    "children",
    "colIndex",
    "width",
    "className",
    "style",
    "gridHasScrollX",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "pinnedOffset",
    "pinnedPosition",
    "sectionIndex",
    "sectionLength",
    "gridHasFiller",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $35952bc45c850842$var$_excluded2 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
let $35952bc45c850842$export$e3af1e8fb2237938 = /*#__PURE__*/ function(PinnedPosition) {
    PinnedPosition[PinnedPosition["NONE"] = 0] = "NONE";
    PinnedPosition[PinnedPosition["LEFT"] = 1] = "LEFT";
    PinnedPosition[PinnedPosition["RIGHT"] = 2] = "RIGHT";
    PinnedPosition[PinnedPosition["VIRTUAL"] = 3] = "VIRTUAL";
    return PinnedPosition;
}({});
const $35952bc45c850842$export$e4b557c91de463d4 = {
    [$35952bc45c850842$export$e3af1e8fb2237938.LEFT]: (0, $49d1610712424e75$export$64f54b460f67389c).LEFT,
    [$35952bc45c850842$export$e3af1e8fb2237938.RIGHT]: (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT,
    [$35952bc45c850842$export$e3af1e8fb2237938.NONE]: undefined,
    [$35952bc45c850842$export$e3af1e8fb2237938.VIRTUAL]: undefined
};
const $35952bc45c850842$var$EMPTY_CELL_PARAMS = {
    id: -1,
    field: "__unset__",
    row: {},
    rowNode: {
        id: -1,
        depth: 0,
        type: "leaf",
        parent: -1,
        groupingKey: null
    },
    colDef: {
        type: "string",
        field: "__unset__",
        computedWidth: 0
    },
    cellMode: (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).View,
    hasFocus: false,
    tabIndex: -1,
    value: null,
    formattedValue: "__unset__",
    isEditable: false,
    api: {}
};
const $35952bc45c850842$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            "cell",
            `cell--text${(0, $gl072.default)(align)}`,
            isSelected && "selected",
            isEditable && "cell--editable",
            showLeftBorder && "cell--withLeftBorder",
            showRightBorder && "cell--withRightBorder",
            pinnedPosition === $35952bc45c850842$export$e3af1e8fb2237938.LEFT && "cell--pinnedLeft",
            pinnedPosition === $35952bc45c850842$export$e3af1e8fb2237938.RIGHT && "cell--pinnedRight",
            isSelectionMode && !isEditable && "cell--selectionMode"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
let $35952bc45c850842$var$warnedOnce = false;
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $35952bc45c850842$var$GridCell = /*#__PURE__*/ $f2Y41.forwardRef((props, ref)=>{
    const { column: column, rowId: rowId, editCellState: editCellState, align: align, colIndex: colIndex, width: width, className: className, style: styleProp, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, pinnedOffset: pinnedOffset, pinnedPosition: pinnedPosition, sectionIndex: sectionIndex, sectionLength: sectionLength, gridHasFiller: gridHasFiller, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $bKcdJ.default)(props, $35952bc45c850842$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const field = column.field;
    const cellParamsWithAPI = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, ()=>{
        // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
        // associated with `rowId`/`fieldId`, but this selector runs after the state has been
        // updated, while `rowId`/`fieldId` reference an entry in the old state.
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof (0, $1544cfea3ebce330$export$f6bd549412d13610)) return $35952bc45c850842$var$EMPTY_CELL_PARAMS;
            throw e;
        }
    }, (0, $193e08cc82c187d1$export$8da4c691e5695191));
    const isSelected = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors("isCellSelected", false, {
            id: rowId,
            field: field
        }));
    const { cellMode: cellMode, hasFocus: hasFocus, isEditable: isEditable = false, value: value } = cellParamsWithAPI;
    const canManageOwnFocus = column.type === "actions" && column.getActions?.(apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled);
    const tabIndex = (cellMode === "view" || !isEditable) && !canManageOwnFocus ? cellParamsWithAPI.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    // There is a hidden grid state access in `applyPipeProcessor('cellClassName', ...)`
    const pipesClassName = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors("cellClassName", [], {
            id: rowId,
            field: field
        }).filter(Boolean).join(" "));
    const classNames = [
        pipesClassName
    ];
    if (column.cellClassName) classNames.push(typeof column.cellClassName === "function" ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (column.display === "flex") classNames.push((0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--flex"]);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    const valueToRender = cellParamsWithAPI.formattedValue ?? value;
    const cellRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(ref, cellRef);
    const focusElementRef = $f2Y41.useRef(null);
    const isSelectionMode = rootProps.cellSelection ?? false;
    const position = $35952bc45c850842$export$e4b557c91de463d4[pinnedPosition];
    const showLeftBorder = (0, $5f42752ff27251f9$export$c01fd18a9a3d03b3)(position, sectionIndex);
    const showRightBorder = (0, $5f42752ff27251f9$export$646c95cff4790794)(position, sectionIndex, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
    const ownerState = {
        align: align,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        pinnedPosition: pinnedPosition,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $35952bc45c850842$var$useUtilityClasses(ownerState);
    const publishMouseUp = $f2Y41.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || "");
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $f2Y41.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || "");
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $f2Y41.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || "");
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = $f2Y41.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        };
        const cellStyle = (0, $asN9r.default)({
            "--width": `${width}px`
        }, styleProp);
        if (pinnedPosition === $35952bc45c850842$export$e3af1e8fb2237938.LEFT) cellStyle.left = pinnedOffset;
        if (pinnedPosition === $35952bc45c850842$export$e3af1e8fb2237938.RIGHT) cellStyle.right = pinnedOffset;
        return cellStyle;
    }, [
        width,
        isNotVisible,
        styleProp,
        pinnedOffset,
        pinnedPosition
    ]);
    $f2Y41.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) return;
        const doc = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $41c563574de4e297$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (cellParamsWithAPI === $35952bc45c850842$var$EMPTY_CELL_PARAMS) return null;
    let handleFocus = other.onFocus;
    var event;
    let children;
    let title;
    if (editCellState === null && column.renderCell) children = column.renderCell(cellParamsWithAPI);
    if (editCellState !== null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $bKcdJ.default)(editCellState, $35952bc45c850842$var$_excluded2);
        const formattedValue = column.valueFormatter ? column.valueFormatter(editCellState.value, updatedRow, column, apiRef) : cellParamsWithAPI.formattedValue;
        const params = (0, $asN9r.default)({}, cellParamsWithAPI, {
            row: updatedRow,
            formattedValue: formattedValue
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $2276c81b0f2e6e46$export$2100d54e36406477)["cell--editing"]);
        classNames.push(rootClasses?.["cell--editing"]);
    }
    if (children === undefined) {
        const valueString = valueToRender?.toString();
        children = valueString;
        title = valueString;
    }
    if (/*#__PURE__*/ $f2Y41.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ $f2Y41.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish("cellDragEnter", onDragEnter),
        onDragOver: publish("cellDragOver", onDragOver)
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", (0, $asN9r.default)({
        ref: handleRef,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classNames, classes.root),
        role: "gridcell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        title: title,
        tabIndex: tabIndex,
        onClick: publish("cellClick", onClick),
        onDoubleClick: publish("cellDoubleClick", onDoubleClick),
        onMouseOver: publish("cellMouseOver", onMouseOver),
        onMouseDown: publishMouseDown("cellMouseDown"),
        onMouseUp: publishMouseUp("cellMouseUp"),
        onKeyDown: publish("cellKeyDown", onKeyDown),
        onKeyUp: publish("cellKeyUp", onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    }));
});
const $35952bc45c850842$export$1ce951ee41d30605 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($35952bc45c850842$var$GridCell);


parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
const $f3ba32ddcd3d7d8a$var$classes = {
    root: (0, $2276c81b0f2e6e46$export$2100d54e36406477).scrollbarFiller,
    header: (0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollbarFiller--header"],
    borderTop: (0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollbarFiller--borderTop"],
    pinnedRight: (0, $2276c81b0f2e6e46$export$2100d54e36406477)["scrollbarFiller--pinnedRight"]
};
function $f3ba32ddcd3d7d8a$export$69d401a304b172b5({ header: header, borderTop: borderTop = true, pinnedRight: pinnedRight }) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        role: "presentation",
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)($f3ba32ddcd3d7d8a$var$classes.root, header && $f3ba32ddcd3d7d8a$var$classes.header, borderTop && $f3ba32ddcd3d7d8a$var$classes.borderTop, pinnedRight && $f3ba32ddcd3d7d8a$var$classes.pinnedRight)
    });
}



const $fb712d330e521d74$export$29949f0e748b68b8 = (pinnedPosition, computedWidth, columnIndex, columnPositions, dimensions)=>{
    const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
    let pinnedOffset;
    switch(pinnedPosition){
        case (0, $49d1610712424e75$export$64f54b460f67389c).LEFT:
            pinnedOffset = columnPositions[columnIndex];
            break;
        case (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT:
            pinnedOffset = dimensions.columnsTotalWidth - columnPositions[columnIndex] - computedWidth + scrollbarWidth;
            break;
        default:
            pinnedOffset = 0;
            break;
    }
    return pinnedOffset;
};



var $ge3KO = parcelRequire("ge3KO");
const $e25064ca83d71b56$var$_excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "rowHeight",
    "className",
    "visibleColumns",
    "pinnedColumns",
    "offsetTop",
    "offsetLeft",
    "dimensions",
    "renderContext",
    "focusedColumnIndex",
    "isFirstVisible",
    "isLastVisible",
    "isNotVisible",
    "focusedCell",
    "tabbableCell",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $e25064ca83d71b56$var$useUtilityClasses = (ownerState)=>{
    const { editable: editable, editing: editing, selected: selected, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, rowHeight: rowHeight, classes: classes } = ownerState;
    const slots = {
        root: [
            "row",
            selected && "selected",
            editable && "row--editable",
            editing && "row--editing",
            isFirstVisible && "row--firstVisible",
            isLastVisible && "row--lastVisible",
            rowHeight === "auto" && "row--dynamicHeight"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $e25064ca83d71b56$var$EmptyCell({ width: width }) {
    if (!width) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        role: "presentation",
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)((0, $2276c81b0f2e6e46$export$2100d54e36406477).cell, (0, $2276c81b0f2e6e46$export$2100d54e36406477).cellEmpty),
        style: {
            "--width": `${width}px`
        }
    });
}
const $e25064ca83d71b56$var$GridRow = /*#__PURE__*/ $f2Y41.forwardRef(function GridRow(props, refProp) {
    const { selected: selected, rowId: rowId, row: row, index: index, style: styleProp, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, pinnedColumns: pinnedColumns, offsetLeft: offsetLeft, dimensions: dimensions, renderContext: renderContext, focusedColumnIndex: focusedColumnIndex, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, isNotVisible: isNotVisible, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $bKcdJ.default)(props, $e25064ca83d71b56$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const ref = $f2Y41.useRef(null);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const currentPage = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, rootProps);
    const sortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$4cdbe576751dd8e2));
    const headerGroupingMaxDepth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $60b55b5d22f1422b$export$4cf0369c079b29be));
    const columnPositions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$fce7d810e48021e3));
    const editRowsState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $fc36377571b6d029$export$91ed78b95c9e6636));
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(ref, refProp);
    const rowNode = apiRef.current.getRowNode(rowId);
    const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
    const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
    const hasFocusCell = focusedColumnIndex !== undefined;
    const hasVirtualFocusCellLeft = hasFocusCell && focusedColumnIndex >= pinnedColumns.left.length && focusedColumnIndex < renderContext.firstColumnIndex;
    const hasVirtualFocusCellRight = hasFocusCell && focusedColumnIndex < visibleColumns.length - pinnedColumns.right.length && focusedColumnIndex >= renderContext.lastColumnIndex;
    const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
    const ownerState = {
        selected: selected,
        isFirstVisible: isFirstVisible,
        isLastVisible: isLastVisible,
        classes: rootProps.classes,
        editing: apiRef.current.getRowMode(rowId) === (0, $c1e8ba2aebe0d5a9$export$d98c76b959bb0b5c).Edit,
        editable: rootProps.editMode === (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Row,
        rowHeight: rowHeight
    };
    const classes = $e25064ca83d71b56$var$useUtilityClasses(ownerState);
    $f2Y41.useLayoutEffect(()=>{
        if (rowHeight === "auto" && ref.current && typeof ResizeObserver === "undefined") // Fallback for IE
        apiRef.current.unstable_storeRowHeightMeasurement(rowId, ref.current.clientHeight);
    }, [
        apiRef,
        rowHeight,
        rowId
    ]);
    $f2Y41.useLayoutEffect(()=>{
        if (currentPage.range) {
            // The index prop is relative to the rows from all pages. As example, the index prop of the
            // first row is 5 if `paginationModel.pageSize=5` and `paginationModel.page=1`. However, the index used by the virtualization
            // doesn't care about pagination and considers the rows from the current page only, so the
            // first row always has index=0. We need to subtract the index of the first row to make it
            // compatible with the index used by the virtualization.
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // pinned rows are not part of the visible rows
            if (rowIndex != null) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        const rootElement = ref.current;
        const hasFixedHeight = rowHeight !== "auto";
        if (!rootElement || hasFixedHeight || typeof ResizeObserver === "undefined") return undefined;
        const resizeObserver = new ResizeObserver((entries)=>{
            const [entry] = entries;
            const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
            apiRef.current.unstable_storeRowHeightMeasurement(rowId, height);
        });
        resizeObserver.observe(rootElement);
        return ()=>resizeObserver.disconnect();
    }, [
        apiRef,
        currentPage.range,
        index,
        rowHeight,
        rowId
    ]);
    const publish = $f2Y41.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $6790963f450ce0fb$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $f2Y41.useCallback((event)=>{
        const cell = (0, $6790963f450ce0fb$export$2a63f1401414fc1a)(event.target, (0, $2276c81b0f2e6e46$export$2100d54e36406477).cell);
        const field = cell?.getAttribute("data-field");
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, $a75f25e717ae3a15$export$b2e9ab6103a664ad).field) return;
            // User opened a detail panel
            if (field === (0, $203fcf5e6d2a11a8$export$6e5a576305a34719)) return;
            // User reorders a row
            if (field === "__reorder__") return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $bad448ba77ed9294$export$e2523ab9efeb7465)) return;
        }
        publish("rowClick", onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const rowReordering = rootProps.rowReordering;
    const sizes = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, ()=>(0, $asN9r.default)({}, apiRef.current.unstable_getRowInternalSizes(rowId)), (0, $193e08cc82c187d1$export$8da4c691e5695191));
    let minHeight = rowHeight;
    if (minHeight === "auto" && sizes) {
        const numberOfBaseSizes = 1;
        const maximumSize = sizes.baseCenter ?? 0;
        if (maximumSize > 0 && numberOfBaseSizes > 1) minHeight = maximumSize;
    }
    const style = $f2Y41.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $asN9r.default)({}, styleProp, {
            maxHeight: rowHeight === "auto" ? "none" : rowHeight,
            minHeight: // max-height doesn't support "auto"
            minHeight,
            "--height": typeof rowHeight === "number" ? `${rowHeight}px` : rowHeight
        });
        if (sizes?.spacingTop) {
            const property = rootProps.rowSpacingType === "border" ? "borderTopWidth" : "marginTop";
            rowStyle[property] = sizes.spacingTop;
        }
        if (sizes?.spacingBottom) {
            const property = rootProps.rowSpacingType === "border" ? "borderBottomWidth" : "marginBottom";
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== "number") propertyValue = parseInt(propertyValue || "0", 10);
            propertyValue += sizes.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        minHeight,
        sizes,
        rootProps.rowSpacingType
    ]);
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors("rowClassName", [], rowId);
    if (typeof rootProps.getRowClassName === "function") {
        const indexRelativeToCurrentPage = index - (currentPage.range?.firstRowIndex || 0);
        const rowParams = (0, $asN9r.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const getCell = (column, indexInSection, indexRelativeToAllColumns, sectionLength, pinnedPosition = (0, $35952bc45c850842$export$e3af1e8fb2237938).NONE)=>{
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo?.spannedByColSpan) return null;
        const width = cellColSpanInfo?.cellProps.width ?? column.computedWidth;
        const colSpan = cellColSpanInfo?.cellProps.colSpan ?? 1;
        const pinnedOffset = (0, $fb712d330e521d74$export$29949f0e748b68b8)((0, $35952bc45c850842$export$e4b557c91de463d4)[pinnedPosition], column.computedWidth, indexRelativeToAllColumns, columnPositions, dimensions);
        if (rowNode?.type === "skeletonRow") return /*#__PURE__*/ (0, $ge3KO.jsx)(slots.skeletonCell, {
            width: width,
            height: rowHeight,
            field: column.field,
            align: column.align ?? "left"
        }, column.field);
        const editCellState = editRowsState[rowId]?.[column.field] ?? null;
        // when the cell is a reorder cell we are not allowing to reorder the col
        // fixes https://github.com/mui/mui-x/issues/11126
        const isReorderCell = column.field === "__reorder__";
        const isEditingRows = Object.keys(editRowsState).length > 0;
        const canReorderColumn = !(disableColumnReorder || column.disableReorder);
        const canReorderRow = rowReordering && !sortModel.length && treeDepth <= 1 && !isEditingRows;
        const disableDragEvents = !(canReorderColumn || isReorderCell && canReorderRow);
        const cellIsNotVisible = pinnedPosition === (0, $35952bc45c850842$export$e3af1e8fb2237938).VIRTUAL;
        return /*#__PURE__*/ (0, $ge3KO.jsx)(slots.cell, (0, $asN9r.default)({
            column: column,
            width: width,
            rowId: rowId,
            align: column.align || "left",
            colIndex: indexRelativeToAllColumns,
            colSpan: colSpan,
            disableDragEvents: disableDragEvents,
            editCellState: editCellState,
            isNotVisible: cellIsNotVisible,
            pinnedOffset: pinnedOffset,
            pinnedPosition: pinnedPosition,
            sectionIndex: indexInSection,
            sectionLength: sectionLength,
            gridHasFiller: gridHasFiller
        }, slotProps?.cell), column.field);
    };
    /* Start of rendering */ if (!rowNode) return null;
    const leftCells = pinnedColumns.left.map((column, i)=>{
        const indexRelativeToAllColumns = i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.left.length, (0, $35952bc45c850842$export$e3af1e8fb2237938).LEFT);
    });
    const rightCells = pinnedColumns.right.map((column, i)=>{
        const indexRelativeToAllColumns = visibleColumns.length - pinnedColumns.right.length + i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.right.length, (0, $35952bc45c850842$export$e3af1e8fb2237938).RIGHT);
    });
    const middleColumnsLength = visibleColumns.length - pinnedColumns.left.length - pinnedColumns.right.length;
    const cells = [];
    if (hasVirtualFocusCellLeft) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $35952bc45c850842$export$e3af1e8fb2237938).VIRTUAL));
    for(let i = renderContext.firstColumnIndex; i < renderContext.lastColumnIndex; i += 1){
        const column = visibleColumns[i];
        const indexInSection = i - pinnedColumns.left.length;
        cells.push(getCell(column, indexInSection, i, middleColumnsLength));
    }
    if (hasVirtualFocusCellRight) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $35952bc45c850842$export$e3af1e8fb2237938).VIRTUAL));
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish("rowDoubleClick", onDoubleClick),
        onMouseEnter: publish("rowMouseEnter", onMouseEnter),
        onMouseLeave: publish("rowMouseLeave", onMouseLeave),
        onMouseOut: publish("rowMouseOut", onMouseOut),
        onMouseOver: publish("rowMouseOver", onMouseOver)
    } : null;
    const expandedWidth = dimensions.viewportOuterSize.width - dimensions.columnsTotalWidth - scrollbarWidth;
    const emptyCellWidth = Math.max(0, expandedWidth);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
        ref: handleRef,
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(...rowClassNames, classes.root, className),
        "aria-rowindex": ariaRowIndex,
        "aria-selected": selected,
        style: style
    }, eventHandlers, other, {
        children: [
            leftCells,
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                role: "presentation",
                className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).cellOffsetLeft,
                style: {
                    width: offsetLeft
                }
            }),
            cells,
            emptyCellWidth > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)($e25064ca83d71b56$var$EmptyCell, {
                width: emptyCellWidth
            }),
            rightCells.length > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                role: "presentation",
                className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).filler
            }),
            rightCells,
            scrollbarWidth !== 0 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f3ba32ddcd3d7d8a$export$69d401a304b172b5), {
                pinnedRight: pinnedColumns.right.length > 0
            })
        ]
    }));
});
const $e25064ca83d71b56$export$1fc5a7f035870658 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($e25064ca83d71b56$var$GridRow);


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $69f08f1c39f7db7e$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $69f08f1c39f7db7e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "rowCount"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $69f08f1c39f7db7e$var$GridRowCountRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "RowCount",
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme: theme })=>({
        alignItems: "center",
        display: "flex",
        margin: theme.spacing(0, 2)
    }));
const $69f08f1c39f7db7e$export$b92875c9af3e0a77 = /*#__PURE__*/ $f2Y41.forwardRef(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $bKcdJ.default)(props, $69f08f1c39f7db7e$var$_excluded);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $69f08f1c39f7db7e$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText("footerTotalVisibleRows")(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($69f08f1c39f7db7e$var$GridRowCountRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            apiRef.current.getLocaleText("footerTotalRows"),
            " ",
            text
        ]
    }));
});


var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");
parcelRequire("f2Y41");


var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $jvVhJ = parcelRequire("jvVhJ");

function $0c9ef0948b182e87$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $0c9ef0948b182e87$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $0c9ef0948b182e87$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $0c9ef0948b182e87$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0c9ef0948b182e87$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0c9ef0948b182e87$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $0c9ef0948b182e87$export$8af1d214c6c2f0f1(length) * $0c9ef0948b182e87$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $0c9ef0948b182e87$export$8af1d214c6c2f0f1(length) * $0c9ef0948b182e87$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $0c9ef0948b182e87$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $0c9ef0948b182e87$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0c9ef0948b182e87$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $0c9ef0948b182e87$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $0c9ef0948b182e87$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}






function $8d6c5e9ce6a8aa94$export$c987db9fc844f86(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiSkeleton", slot);
}
const $8d6c5e9ce6a8aa94$var$skeletonClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $8d6c5e9ce6a8aa94$export$2e2bcd8739ae039 = $8d6c5e9ce6a8aa94$var$skeletonClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $77c2d0393f06bfb8$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $77c2d0393f06bfb8$var$_ = (t)=>t, $77c2d0393f06bfb8$var$_t, $77c2d0393f06bfb8$var$_t2, $77c2d0393f06bfb8$var$_t3, $77c2d0393f06bfb8$var$_t4;
const $77c2d0393f06bfb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $8d6c5e9ce6a8aa94$export$c987db9fc844f86), classes);
};
const $77c2d0393f06bfb8$var$pulseKeyframe = (0, $jvVhJ.keyframes)($77c2d0393f06bfb8$var$_t || ($77c2d0393f06bfb8$var$_t = $77c2d0393f06bfb8$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $77c2d0393f06bfb8$var$waveKeyframe = (0, $jvVhJ.keyframes)($77c2d0393f06bfb8$var$_t2 || ($77c2d0393f06bfb8$var$_t2 = $77c2d0393f06bfb8$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $77c2d0393f06bfb8$var$SkeletonRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $0c9ef0948b182e87$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $0c9ef0948b182e87$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $asN9r.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $533e05963543ab3e$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $jvVhJ.css)($77c2d0393f06bfb8$var$_t3 || ($77c2d0393f06bfb8$var$_t3 = $77c2d0393f06bfb8$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $77c2d0393f06bfb8$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $jvVhJ.css)($77c2d0393f06bfb8$var$_t4 || ($77c2d0393f06bfb8$var$_t4 = $77c2d0393f06bfb8$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $77c2d0393f06bfb8$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $77c2d0393f06bfb8$var$Skeleton = /*#__PURE__*/ $f2Y41.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $bKcdJ.default)(props, $77c2d0393f06bfb8$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $77c2d0393f06bfb8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($77c2d0393f06bfb8$var$SkeletonRoot, (0, $asN9r.default)({
        as: component,
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $asN9r.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $77c2d0393f06bfb8$export$2e2bcd8739ae039 = $77c2d0393f06bfb8$var$Skeleton;



var $gl072 = parcelRequire("gl072");





var $ge3KO = parcelRequire("ge3KO");
const $eb09dc42b7e8c216$var$_excluded = [
    "field",
    "align",
    "width",
    "height"
];
const $eb09dc42b7e8c216$var$randomWidth = (0, $2b59f632c4f96fc9$export$ffd8c9a5b80f1e57)(10000, 20, 80);
const $eb09dc42b7e8c216$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes } = ownerState;
    const slots = {
        root: [
            "cell",
            "cellSkeleton",
            `cell--text${(0, $gl072.default)(align)}`,
            "withBorderColor"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $eb09dc42b7e8c216$var$GridSkeletonCell(props) {
    const { align: align, width: width, height: height } = props, other = (0, $bKcdJ.default)(props, $eb09dc42b7e8c216$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes,
        align: align
    };
    const classes = $eb09dc42b7e8c216$var$useUtilityClasses(ownerState);
    const contentWidth = Math.round($eb09dc42b7e8c216$var$randomWidth());
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", (0, $asN9r.default)({
        className: classes.root,
        style: {
            height: height,
            maxWidth: width,
            minWidth: width
        }
    }, other, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $77c2d0393f06bfb8$export$2e2bcd8739ae039), {
            width: `${contentWidth}%`,
            height: 25
        })
    }));
}
const $eb09dc42b7e8c216$export$d922c88d466d9c21 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($eb09dc42b7e8c216$var$GridSkeletonCell);




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");







var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $c731cb98902dea45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            "sortIcon"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $c731cb98902dea45$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === "asc") Icon = icons.columnSortedAscendingIcon;
    else if (direction === "desc") Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, (0, $asN9r.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $c731cb98902dea45$var$GridColumnHeaderSortIconRaw(props) {
    const { direction: direction, index: index, sortingOrder: sortingOrder, disabled: disabled } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $asN9r.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $c731cb98902dea45$var$useUtilityClasses(ownerState);
    const iconElement = $c731cb98902dea45$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText("columnHeaderSortIconLabel"),
        title: apiRef.current.getLocaleText("columnHeaderSortIconLabel"),
        size: "small",
        disabled: disabled
    }, rootProps.slotProps?.baseIconButton, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $880894ea0c6fa4d3$export$e67562d5b709404c), {
        children: [
            index != null && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34e12ad74fb61570$export$2e2bcd8739ae039), {
                badgeContent: index,
                color: "default",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}
const $c731cb98902dea45$export$80cd75c5dceceac6 = /*#__PURE__*/ $f2Y41.memo($c731cb98902dea45$var$GridColumnHeaderSortIconRaw);



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $600939aefa56ee44$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            "menuIcon",
            open && "menuOpen"
        ],
        button: [
            "menuIconButton"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $600939aefa56ee44$export$941072bb8af39847 = /*#__PURE__*/ $f2Y41.memo((props)=>{
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $asN9r.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $600939aefa56ee44$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $f2Y41.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
            title: apiRef.current.getLocaleText("columnMenuLabel"),
            enterDelay: 1000
        }, rootProps.slotProps?.baseTooltip, {
            children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText("columnMenuLabel"),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "small"
                })
            }))
        }))
    });
});



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
function $61c09970d15e2cb5$export$c096196819b00a09({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target?.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f1a3f9a2e160d201$export$237948c71948075), {
        placement: `bottom-${colDef.align === "right" ? "start" : "end"}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(ContentComponent, (0, $asN9r.default)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}





var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $8fbf8968db5e840c$var$_excluded = [
    "className"
];
const $8fbf8968db5e840c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "columnHeaderTitle"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $8fbf8968db5e840c$var$GridColumnHeaderTitleRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaderTitle",
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontWeight: "var(--unstable_DataGrid-headWeight)"
});
const $8fbf8968db5e840c$var$ColumnHeaderInnerTitle = /*#__PURE__*/ $f2Y41.forwardRef(function ColumnHeaderInnerTitle(props, ref) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $8fbf8968db5e840c$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $8fbf8968db5e840c$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($8fbf8968db5e840c$var$GridColumnHeaderTitleRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $8fbf8968db5e840c$export$926bb04b6af55e42(props) {
    const { label: label, description: description } = props;
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const titleRef = $f2Y41.useRef(null);
    const [tooltip, setTooltip] = $f2Y41.useState("");
    const handleMouseOver = $f2Y41.useCallback(()=>{
        if (!description && titleRef?.current) {
            const isOver = (0, $6790963f450ce0fb$export$c8be9a8325efa7ee)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip("");
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
        title: description || tooltip
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($8fbf8968db5e840c$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $gl072 = parcelRequire("gl072");



var $ge3KO = parcelRequire("ge3KO");
const $6e433d1067a43054$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $6e433d1067a43054$export$71ed79b4ccf06d60 = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($6e433d1067a43054$export$71ed79b4ccf06d60 || {});
const $6e433d1067a43054$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            "columnSeparator",
            resizable && "columnSeparator--resizable",
            resizing && "columnSeparator--resizing",
            side && `columnSeparator--side${(0, $gl072.default)(side)}`
        ],
        icon: [
            "iconSeparator"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $6e433d1067a43054$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $6e433d1067a43054$export$71ed79b4ccf06d60.Right } = props, other = (0, $bKcdJ.default)(props, $6e433d1067a43054$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $asN9r.default)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $6e433d1067a43054$var$useUtilityClasses(ownerState);
    const stopClick = $f2Y41.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $ge3KO.jsx)("div", (0, $asN9r.default)({
        className: classes.root,
        style: {
            minHeight: height,
            opacity: rootProps.showColumnVerticalBorder ? 0 : 1
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $6e433d1067a43054$export$a264529bdbb7adb7 = /*#__PURE__*/ $f2Y41.memo($6e433d1067a43054$var$GridColumnHeaderSeparatorRaw);




var $ge3KO = parcelRequire("ge3KO");
const $9327625e676ffc65$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "style"
];
const $9327625e676ffc65$export$fd75c0d5b714072b = /*#__PURE__*/ $f2Y41.forwardRef(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, columnMenuOpen: columnMenuOpen, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, hasFocus: hasFocus, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps, style: style } = props, other = (0, $bKcdJ.default)(props, $9327625e676ffc65$var$_excluded);
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $f2Y41.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $f2Y41.useState(columnMenuOpen);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(headerCellRef, ref);
    let ariaSort = "none";
    if (sortDirection != null) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    $f2Y41.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    $f2Y41.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus?.focus();
            if (apiRef.current.columnHeadersContainerRef?.current) apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
        ref: handleRef,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, headerClassName),
        style: (0, $asN9r.default)({}, style, {
            height: height,
            width: width,
            minWidth: width,
            maxWidth: width
        }),
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort,
        "aria-label": headerComponent == null ? label : undefined
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8fbf8968db5e840c$export$926bb04b6af55e42), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6e433d1067a43054$export$a264529bdbb7adb7), (0, $asN9r.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});





var $ge3KO = parcelRequire("ge3KO");
const $37f9ca59652b66b9$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, filterItemsCounter: filterItemsCounter, pinnedPosition: pinnedPosition } = ownerState;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === "number";
    const slots = {
        root: [
            "columnHeader",
            colDef.headerAlign === "left" && "columnHeader--alignLeft",
            colDef.headerAlign === "center" && "columnHeader--alignCenter",
            colDef.headerAlign === "right" && "columnHeader--alignRight",
            colDef.sortable && "columnHeader--sortable",
            isDragging && "columnHeader--moving",
            isColumnSorted && "columnHeader--sorted",
            isColumnFiltered && "columnHeader--filtered",
            isColumnNumeric && "columnHeader--numeric",
            "withBorderColor",
            showRightBorder && "columnHeader--withRightBorder",
            showLeftBorder && "columnHeader--withLeftBorder",
            pinnedPosition === "left" && "columnHeader--pinnedLeft",
            pinnedPosition === "right" && "columnHeader--pinnedRight"
        ],
        draggableContainer: [
            "columnHeaderDraggableContainer"
        ],
        titleContainer: [
            "columnHeaderTitleContainer"
        ],
        titleContainerContent: [
            "columnHeaderTitleContainerContent"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $37f9ca59652b66b9$var$GridColumnHeaderItem(props) {
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, isLast: isLast, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide, style: style, pinnedPosition: pinnedPosition, indexInSection: indexInSection, sectionLength: sectionLength, gridHasFiller: gridHasFiller } = props;
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $f2Y41.useRef(null);
    const columnMenuId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const columnMenuButtonId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const iconButtonRef = $f2Y41.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $f2Y41.useState(columnMenuOpen);
    const isDraggable = $f2Y41.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const showLeftBorder = (0, $5f42752ff27251f9$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection);
    const showRightBorder = (0, $5f42752ff27251f9$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
    const ownerState = (0, $asN9r.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    const classes = $37f9ca59652b66b9$var$useUtilityClasses(ownerState);
    const publish = $f2Y41.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $6790963f450ce0fb$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $f2Y41.useMemo(()=>({
            onClick: publish("columnHeaderClick"),
            onDoubleClick: publish("columnHeaderDoubleClick"),
            onMouseOver: publish("columnHeaderOver"),
            // TODO remove as it's not used
            onMouseOut: publish("columnHeaderOut"),
            // TODO remove as it's not used
            onMouseEnter: publish("columnHeaderEnter"),
            // TODO remove as it's not used
            onMouseLeave: publish("columnHeaderLeave"),
            // TODO remove as it's not used
            onKeyDown: publish("columnHeaderKeyDown"),
            onFocus: publish("columnHeaderFocus"),
            onBlur: publish("columnHeaderBlur")
        }), [
        publish
    ]);
    const draggableEventHandlers = $f2Y41.useMemo(()=>isDraggable ? {
            onDragStart: publish("columnHeaderDragStart"),
            onDragEnter: publish("columnHeaderDragEnter"),
            onDragOver: publish("columnHeaderDragOver"),
            onDragEnd: publish("columnHeaderDragEnd")
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $f2Y41.useMemo(()=>({
            onMouseDown: publish("columnSeparatorMouseDown"),
            onDoubleClick: publish("columnSeparatorDoubleClick")
        }), [
        publish
    ]);
    $f2Y41.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $f2Y41.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $600939aefa56ee44$export$941072bb8af39847), {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $61c09970d15e2cb5$export$c096196819b00a09), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: rootProps.slotProps?.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $asN9r.default)({
                field: colDef.field,
                counter: filterItemsCounter
            }, rootProps.slotProps?.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c731cb98902dea45$export$80cd75c5dceceac6), {
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            })
        ]
    });
    $f2Y41.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus?.focus();
            if (apiRef.current.columnHeadersContainerRef?.current) apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === "function" ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = colDef.headerName ?? colDef.field;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9327625e676ffc65$export$fd75c0d5b714072b), (0, $asN9r.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(headerClassName, isLast && (0, $2276c81b0f2e6e46$export$2100d54e36406477)["columnHeader--last"]),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
const $37f9ca59652b66b9$export$10f6faff2f47edd = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($37f9ca59652b66b9$var$GridColumnHeaderItem);






var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");










var $ge3KO = parcelRequire("ge3KO");
const $3f14de19d962459b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, groupId: groupId, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            "columnHeader",
            headerAlign === "left" && "columnHeader--alignLeft",
            headerAlign === "center" && "columnHeader--alignCenter",
            headerAlign === "right" && "columnHeader--alignRight",
            isDragging && "columnHeader--moving",
            showRightBorder && "columnHeader--withRightBorder",
            showLeftBorder && "columnHeader--withLeftBorder",
            "withBorderColor",
            groupId === null ? "columnHeader--emptyGroup" : "columnHeader--filledGroup",
            pinnedPosition === "left" && "columnHeader--pinnedLeft",
            pinnedPosition === "right" && "columnHeader--pinnedRight"
        ],
        draggableContainer: [
            "columnHeaderDraggableContainer"
        ],
        titleContainer: [
            "columnHeaderTitleContainer",
            "withBorderColor"
        ],
        titleContainerContent: [
            "columnHeaderTitleContainerContent"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $3f14de19d962459b$export$ff426d40d02e21be(props) {
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn, pinnedPosition: pinnedPosition, style: style, indexInSection: indexInSection, sectionLength: sectionLength, gridHasFiller: gridHasFiller } = props;
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $f2Y41.useRef(null);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const columnGroupsLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $60b55b5d22f1422b$export$bdc2ff4432d8b29b));
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId ?? "", description: description = "", headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && columnGroupsLookup[groupId]?.renderHeaderGroup;
    const renderParams = $f2Y41.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const showLeftBorder = (0, $5f42752ff27251f9$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection);
    const showRightBorder = (0, $5f42752ff27251f9$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
    const ownerState = (0, $asN9r.default)({}, props, {
        classes: rootProps.classes,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName ?? groupId;
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $3f14de19d962459b$var$useUtilityClasses(ownerState);
    $f2Y41.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus?.focus();
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $f2Y41.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $6790963f450ce0fb$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $f2Y41.useMemo(()=>({
            onKeyDown: publish("columnGroupHeaderKeyDown"),
            onFocus: publish("columnGroupHeaderFocus"),
            onBlur: publish("columnGroupHeaderBlur")
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === "function" ? group.headerClassName(renderParams) : group.headerClassName;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9327625e676ffc65$export$fd75c0d5b714072b), (0, $asN9r.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: true,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join("-|-")}-|`,
        style: style
    }, mouseEventsHandlers));
}








var $ge3KO = parcelRequire("ge3KO");
const $9b1476f20ea6a843$export$7b391e1fd04597c4 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaderRow",
    overridesResolver: (_, styles)=>styles.columnHeaderRow
})({
    display: "flex"
});
const $9b1476f20ea6a843$export$dd7dbc7d3ee10272 = (props)=>{
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const [dragCol, setDragCol] = $f2Y41.useState("");
    const [resizeCol, setResizeCol] = $f2Y41.useState("");
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const hasVirtualization = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $de91a359006882c0$export$ad2aa1e9d465cafa));
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const columnPositions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$fce7d810e48021e3));
    const renderContext = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $de91a359006882c0$export$3a5705edd3d1af7e));
    const pinnedColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$297e8079713afa11));
    const offsetLeft = (0, $0ef91cf32c4de50f$export$fe1f1566870c3cbc)(columnPositions, renderContext, theme.direction, pinnedColumns.left.length);
    const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
    $f2Y41.useEffect(()=>{
        apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
    }, [
        apiRef
    ]);
    const handleColumnResizeStart = $f2Y41.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $f2Y41.useCallback(()=>setResizeCol(""), []);
    const handleColumnReorderStart = $f2Y41.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $f2Y41.useCallback(()=>setDragCol(""), []);
    const leftRenderContext = $f2Y41.useMemo(()=>{
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    const rightRenderContext = $f2Y41.useMemo(()=>{
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnResizeStart", handleColumnResizeStart);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnResizeStop", handleColumnResizeStop);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragStart", handleColumnReorderStart);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragEnd", handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: currentContext = renderContext, maxLastColumn: // TODO: `minFirstColumn` is not used anymore, could be refactored out.
        maxLastColumn = visibleColumns.length } = params || {};
        const firstColumnToRender = !hasVirtualization ? 0 : currentContext.firstColumnIndex;
        const lastColumnToRender = !hasVirtualization ? maxLastColumn : currentContext.lastColumnIndex;
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    const getFillers = (params, children, leftOverflow, borderTop = false)=>{
        const isPinnedRight = params?.position === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT;
        const isNotPinned = params?.position === undefined;
        const hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        const leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    role: "presentation",
                    className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)((0, $2276c81b0f2e6e46$export$2100d54e36406477).filler, borderTop && (0, $2276c81b0f2e6e46$export$2100d54e36406477)["filler--borderTop"])
                }),
                hasScrollbarFiller && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f3ba32ddcd3d7d8a$export$69d401a304b172b5), {
                    header: true,
                    borderTop: borderTop,
                    pinnedRight: isPinnedRight
                })
            ]
        });
    };
    const getCellOffsetStyle = ({ pinnedPosition: pinnedPosition, columnIndex: columnIndex, computedWidth: computedWidth })=>{
        let style;
        if (pinnedPosition === "left" || pinnedPosition === "right") {
            const pinnedOffset = (0, $fb712d330e521d74$export$29949f0e748b68b8)(pinnedPosition, computedWidth, columnIndex, columnPositions, dimensions);
            if (pinnedPosition === "left") style = {
                left: pinnedOffset
            };
            if (pinnedPosition === "right") style = {
                right: pinnedOffset
            };
        }
        return style;
    };
    const getColumnHeaders = (params, other = {})=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            const pinnedPosition = params?.position;
            const style = getCellOffsetStyle({
                pinnedPosition: pinnedPosition,
                columnIndex: columnIndex,
                computedWidth: colDef.computedWidth
            });
            columns.push(/*#__PURE__*/ (0, $ge3KO.jsx)((0, $37f9ca59652b66b9$export$10f6faff2f47edd), (0, $asN9r.default)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: dimensions.headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                style: style,
                indexInSection: i,
                sectionLength: renderedColumns.length,
                gridHasFiller: gridHasFiller
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    const getColumnHeadersRow = ()=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)($9b1476f20ea6a843$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            children: [
                leftRenderContext && getColumnHeaders({
                    position: (0, $49d1610712424e75$export$64f54b460f67389c).LEFT,
                    renderContext: leftRenderContext,
                    minFirstColumn: leftRenderContext.firstColumnIndex,
                    maxLastColumn: leftRenderContext.lastColumnIndex
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext,
                    minFirstColumn: pinnedColumns.left.length,
                    maxLastColumn: visibleColumns.length - pinnedColumns.right.length
                }),
                rightRenderContext && getColumnHeaders({
                    position: (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT,
                    renderContext: rightRenderContext,
                    minFirstColumn: rightRenderContext.firstColumnIndex,
                    maxLastColumn: rightRenderContext.lastColumnIndex
                }, {
                    disableReorder: true,
                    separatorSide: (0, $6e433d1067a43054$export$71ed79b4ccf06d60).Left
                })
            ]
        });
    };
    const getColumnGroupHeaders = ({ depth: depth, params: params })=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) return null;
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const rowStructure = columnGroupsHeaderStructure[depth];
        const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        const firstGroupToRender = apiRef.current.getColumnGroupPath(firstColumnFieldToRender)[depth] ?? null;
        const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
        const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        const lastGroupToRender = apiRef.current.getColumnGroupPath(lastColumnFieldToRender)[depth] ?? null;
        const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
        const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
            return (0, $asN9r.default)({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
            });
        }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
        const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
            const column = apiRef.current.getColumn(field);
            return acc + (column.computedWidth ?? 0);
        }, 0);
        let columnIndex = firstColumnToRender;
        const children = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields }, index)=>{
            const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            const headerInfo = {
                groupId: groupId,
                width: columnFields.reduce((acc, field)=>acc + apiRef.current.getColumn(field).computedWidth, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            const pinnedPosition = params.position;
            const style = getCellOffsetStyle({
                pinnedPosition: pinnedPosition,
                columnIndex: columnIndex,
                computedWidth: headerInfo.width
            });
            columnIndex += columnFields.length;
            let indexInSection = index;
            if (pinnedPosition === "left") // Group headers can expand to multiple columns, we need to adjust the index
            indexInSection = columnIndex - 1;
            return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3f14de19d962459b$export$ff426d40d02e21be), {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: headerInfo.colIndex === visibleColumns.length - headerInfo.fields.length,
                maxDepth: headerGroupingMaxDepth,
                height: dimensions.headerHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                style: style,
                indexInSection: indexInSection,
                sectionLength: renderedColumns.length,
                gridHasFiller: gridHasFiller
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    const getColumnGroupHeadersRows = ()=>{
        if (headerGroupingMaxDepth === 0) return null;
        const headerRows = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1)headerRows.push(/*#__PURE__*/ (0, $ge3KO.jsxs)($9b1476f20ea6a843$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": depth + 1,
            ownerState: rootProps,
            children: [
                leftRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $49d1610712424e75$export$64f54b460f67389c).LEFT,
                        renderContext: leftRenderContext,
                        minFirstColumn: leftRenderContext.firstColumnIndex,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }
                }),
                getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        renderContext: renderContext
                    }
                }),
                rightRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT,
                        renderContext: rightRenderContext,
                        minFirstColumn: rightRenderContext.firstColumnIndex,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }
                })
            ]
        }, depth));
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        getCellOffsetStyle: getCellOffsetStyle,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        isDragging: !!dragCol,
        getInnerProps: ()=>({
                role: "rowgroup"
            })
    };
};



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $d657ff3ce5eef59a$var$_excluded = [
    "className"
];
const $d657ff3ce5eef59a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "columnHeaders"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $d657ff3ce5eef59a$var$GridColumnHeadersRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaders",
    overridesResolver: (props, styles)=>styles.columnHeaders
})({
    display: "flex",
    flexDirection: "column",
    borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
    borderTopRightRadius: "var(--unstable_DataGrid-radius)"
});
const $d657ff3ce5eef59a$export$de91f7b8bf842ed8 = /*#__PURE__*/ $f2Y41.forwardRef(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $d657ff3ce5eef59a$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $d657ff3ce5eef59a$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($d657ff3ce5eef59a$var$GridColumnHeadersRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: rootProps
    }, other, {
        role: "presentation"
    }));
});



var $ge3KO = parcelRequire("ge3KO");
const $6b952e08192bb2f9$var$_excluded = [
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $6b952e08192bb2f9$var$GridColumnHeaders = /*#__PURE__*/ $f2Y41.forwardRef(function GridColumnHeaders(props, ref) {
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $bKcdJ.default)(props, $6b952e08192bb2f9$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $9b1476f20ea6a843$export$dd7dbc7d3ee10272)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $d657ff3ce5eef59a$export$de91f7b8bf842ed8), (0, $asN9r.default)({
        ref: ref
    }, other, getInnerProps(), {
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow()
        ]
    }));
});
const $6b952e08192bb2f9$export$4a3a74c44d0a6c04 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($6b952e08192bb2f9$var$GridColumnHeaders);



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
"use client";
const $66337a9aa2bd465a$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $66337a9aa2bd465a$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $d282071a3dd0a567$export$46f01d01378ec5a2), classes);
};
const $66337a9aa2bd465a$var$DividerRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $asN9r.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $asN9r.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $66337a9aa2bd465a$var$DividerWrapper = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $66337a9aa2bd465a$var$Divider = /*#__PURE__*/ $f2Y41.forwardRef(function Divider(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $bKcdJ.default)(props, $66337a9aa2bd465a$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $66337a9aa2bd465a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($66337a9aa2bd465a$var$DividerRoot, (0, $asN9r.default)({
        as: component,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ge3KO.jsx)($66337a9aa2bd465a$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $66337a9aa2bd465a$var$Divider.muiSkipListHighlight = true;
var $66337a9aa2bd465a$export$2e2bcd8739ae039 = $66337a9aa2bd465a$var$Divider;



const $cf564394cc9b5825$var$_excluded = [
    "displayOrder"
];
const $cf564394cc9b5825$export$2ba37d64bee4cf68 = (props)=>{
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $f2Y41.useMemo(()=>(0, $asN9r.default)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $f2Y41.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $asN9r.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $asN9r.default)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors("columnMenu", [], props.colDef);
    const userItems = $f2Y41.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $f2Y41.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps?.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps?.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $bKcdJ.default)(processedComponentProps, $cf564394cc9b5825$var$_excluded);
                itemProps = (0, $asN9r.default)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    (0, $66337a9aa2bd465a$export$2e2bcd8739ae039),
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems
    ]);
};



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");



var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $24847677536cf1cc$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $24847677536cf1cc$var$StyledMenuList = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $d203149adb48b43d$export$2e2bcd8739ae039))(()=>({
        minWidth: 248
    }));
const $24847677536cf1cc$export$595ece458604adc3 = /*#__PURE__*/ $f2Y41.forwardRef(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $bKcdJ.default)(props, $24847677536cf1cc$var$_excluded);
    const handleListKeyDown = $f2Y41.useCallback((event)=>{
        if ((0, $19fd75f0cc198aff$export$34e5042f80daa3dd)(event.key)) event.preventDefault();
        if ((0, $19fd75f0cc198aff$export$81301abbcd0c8143)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($24847677536cf1cc$var$StyledMenuList, (0, $asN9r.default)({
        id: id,
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)((0, $2276c81b0f2e6e46$export$2100d54e36406477).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        children: children
    }));
});



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


var $f2Y41 = parcelRequire("f2Y41");



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
"use client";
const $fe67a5c709d35788$var$_excluded = [
    "className"
];
const $fe67a5c709d35788$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $08b4da1fe558c745$export$81478e24460c57f2), classes);
};
const $fe67a5c709d35788$var$ListItemIconRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $fe67a5c709d35788$var$ListItemIcon = /*#__PURE__*/ $f2Y41.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $bKcdJ.default)(props, $fe67a5c709d35788$var$_excluded);
    const context = $f2Y41.useContext((0, $ea2be9ee151cf4ec$export$2e2bcd8739ae039));
    const ownerState = (0, $asN9r.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $fe67a5c709d35788$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($fe67a5c709d35788$var$ListItemIconRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $fe67a5c709d35788$export$2e2bcd8739ae039 = $fe67a5c709d35788$var$ListItemIcon;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");









var $ge3KO = parcelRequire("ge3KO");
"use client";
const $916fcf0d4f1c2cd1$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $916fcf0d4f1c2cd1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $00ca2ceacfbcfe80$export$1061006a0db3aeb5), classes);
};
const $916fcf0d4f1c2cd1$var$ListItemTextRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $00ca2ceacfbcfe80$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $00ca2ceacfbcfe80$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $916fcf0d4f1c2cd1$var$ListItemText = /*#__PURE__*/ $f2Y41.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $bKcdJ.default)(props, $916fcf0d4f1c2cd1$var$_excluded);
    const { dense: dense } = $f2Y41.useContext((0, $ea2be9ee151cf4ec$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $asN9r.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $916fcf0d4f1c2cd1$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $dcdca1e07a1d8440$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dcdca1e07a1d8440$export$2e2bcd8739ae039), (0, $asN9r.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $dcdca1e07a1d8440$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dcdca1e07a1d8440$export$2e2bcd8739ae039), (0, $asN9r.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($916fcf0d4f1c2cd1$var$ListItemTextRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $916fcf0d4f1c2cd1$export$2e2bcd8739ae039 = $916fcf0d4f1c2cd1$var$ListItemText;






var $ge3KO = parcelRequire("ge3KO");
function $8c9d24a8e18a16a9$export$43421c0d197b(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $f2Y41.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
        onClick: toggleColumn,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuHideIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText("columnMenuHideColumn")
            })
        ]
    });
}



var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
function $2d8b5437e74fd0af$export$dfc5e58327b7921f(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const showColumns = $f2Y41.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences((0, $3f22a63fe503dede$export$e7e5652452e44b).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
        onClick: showColumns,
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText("columnMenuManageColumns")
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
function $361aa0a827b439aa$export$fee567ee855db2cc(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8c9d24a8e18a16a9$export$43421c0d197b), (0, $asN9r.default)({}, props)),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2d8b5437e74fd0af$export$dfc5e58327b7921f), (0, $asN9r.default)({}, props))
        ]
    });
}



var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
function $ef925914924728c3$export$a4dd856446268ffe(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const showFilter = $f2Y41.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
        onClick: showFilter,
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuFilterIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText("columnMenuFilter")
            })
        ]
    });
}



var $f2Y41 = parcelRequire("f2Y41");









var $ge3KO = parcelRequire("ge3KO");
function $73b9a6477f59a00b$export$e58710c52f856e65(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const sortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const sortDirection = $f2Y41.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem?.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const onSortMenuItemClick = $f2Y41.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute("data-value") || null;
        apiRef.current.sortColumn(colDef.field, direction === sortDirection ? null : direction);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection
    ]);
    if (rootProps.disableColumnSorting || !colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === "function" ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            sortingOrder.includes("asc") && sortDirection !== "asc" ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                        children: getLabel("columnMenuSortAsc")
                    })
                ]
            }) : null,
            sortingOrder.includes("desc") && sortDirection !== "desc" ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                        children: getLabel("columnMenuSortDesc")
                    })
                ]
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                        children: apiRef.current.getLocaleText("columnMenuUnsort")
                    })
                ]
            }) : null
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
const $c593a601c719670d$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $c593a601c719670d$export$5983f95fe9d3e659 = {
    columnMenuSortItem: (0, $73b9a6477f59a00b$export$e58710c52f856e65),
    columnMenuFilterItem: (0, $ef925914924728c3$export$a4dd856446268ffe),
    columnMenuColumnsItem: (0, $361aa0a827b439aa$export$fee567ee855db2cc)
};
const $c593a601c719670d$export$c107bd4c779cece6 = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $c593a601c719670d$export$61ffa20907ac4a8e = /*#__PURE__*/ $f2Y41.forwardRef(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $bKcdJ.default)(props, $c593a601c719670d$var$_excluded);
    const orderedSlots = (0, $cf564394cc9b5825$export$2ba37d64bee4cf68)((0, $asN9r.default)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $24847677536cf1cc$export$595ece458604adc3), (0, $asN9r.default)({
        ref: ref
    }, other, {
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $ge3KO.jsx)(Component, (0, $asN9r.default)({}, otherProps), index))
    }));
});
const $c593a601c719670d$export$53fbb13480dfeb67 = /*#__PURE__*/ $f2Y41.forwardRef(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)($c593a601c719670d$export$61ffa20907ac4a8e, (0, $asN9r.default)({}, props, {
        ref: ref,
        defaultSlots: $c593a601c719670d$export$5983f95fe9d3e659,
        defaultSlotProps: $c593a601c719670d$export$c107bd4c779cece6
    }));
});


// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $01f553ab395ee0c4$export$aa888f5144097c35(_) {
    return null;
}


// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $aea5ebd6a0104d64$export$58309d5251e10b9e(_) {
    return null;
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
const $ee5c6f6674667887$export$82fb990ffc125278 = /*#__PURE__*/ $f2Y41.forwardRef(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText("noResultsOverlayLabel");
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab9ac73e051746f3$export$1c41ff9dbe11e487), (0, $asN9r.default)({
        ref: ref
    }, props, {
        children: noResultsOverlayLabel
    }));
});



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");











function $84931efd27be74c1$export$baa0faa0c7ad8085(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("PrivateSwitchBase", slot);
}
const $84931efd27be74c1$var$switchBaseClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $84931efd27be74c1$export$2e2bcd8739ae039 = $84931efd27be74c1$var$switchBaseClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $7000c767b8fb4f2d$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $7000c767b8fb4f2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $84931efd27be74c1$export$baa0faa0c7ad8085), classes);
};
const $7000c767b8fb4f2d$var$SwitchBaseRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $1e60465a41fa8bc1$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $asN9r.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $7000c767b8fb4f2d$var$SwitchBaseInput = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("input", {
    shouldForwardProp: (0, $4773145d8cae4871$export$2e2bcd8739ae039)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $7000c767b8fb4f2d$var$SwitchBase = /*#__PURE__*/ $f2Y41.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $bKcdJ.default)(props, $7000c767b8fb4f2d$var$_excluded);
    const [checked, setCheckedState] = (0, $8c595a04ba37cd86$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $asN9r.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $7000c767b8fb4f2d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($7000c767b8fb4f2d$var$SwitchBaseRoot, (0, $asN9r.default)({
        component: "span",
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)($7000c767b8fb4f2d$var$SwitchBaseInput, (0, $asN9r.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $7000c767b8fb4f2d$export$2e2bcd8739ae039 = $7000c767b8fb4f2d$var$SwitchBase;


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $c07aa91a2da8ebfd$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $1e91124607ea4e01$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
"use client";
var $9d013a2dd96d9507$export$2e2bcd8739ae039 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");







function $aa8564bd4b0c129f$export$6c57c6e16b4063b(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiCheckbox", slot);
}
const $aa8564bd4b0c129f$var$checkboxClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $aa8564bd4b0c129f$export$2e2bcd8739ae039 = $aa8564bd4b0c129f$var$checkboxClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $404a3673ec7c60a8$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $404a3673ec7c60a8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $aa8564bd4b0c129f$export$6c57c6e16b4063b), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $404a3673ec7c60a8$var$CheckboxRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $7000c767b8fb4f2d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $aa8564bd4b0c129f$export$2e2bcd8739ae039).checked}, &.${(0, $aa8564bd4b0c129f$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $aa8564bd4b0c129f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $404a3673ec7c60a8$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1e91124607ea4e01$export$2e2bcd8739ae039), {});
const $404a3673ec7c60a8$var$defaultIcon = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c07aa91a2da8ebfd$export$2e2bcd8739ae039), {});
const $404a3673ec7c60a8$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9d013a2dd96d9507$export$2e2bcd8739ae039), {});
const $404a3673ec7c60a8$var$Checkbox = /*#__PURE__*/ $f2Y41.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $404a3673ec7c60a8$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $404a3673ec7c60a8$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $404a3673ec7c60a8$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $bKcdJ.default)(props, $404a3673ec7c60a8$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $404a3673ec7c60a8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($404a3673ec7c60a8$var$CheckboxRoot, (0, $asN9r.default)({
        type: "checkbox",
        inputProps: (0, $asN9r.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $f2Y41.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $f2Y41.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $404a3673ec7c60a8$export$2e2bcd8739ae039 = $404a3673ec7c60a8$var$Checkbox;



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");











var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");










function $e9981a7cdc3b9dc4$export$f7d501e40371cd17(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiFormLabel", slot);
}
const $e9981a7cdc3b9dc4$var$formLabelClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $e9981a7cdc3b9dc4$export$2e2bcd8739ae039 = $e9981a7cdc3b9dc4$var$formLabelClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $061494166bd32450$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $061494166bd32450$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $e9981a7cdc3b9dc4$export$f7d501e40371cd17), classes);
};
const $061494166bd32450$export$aa5bc7f8a4705b27 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $asN9r.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $e9981a7cdc3b9dc4$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $e9981a7cdc3b9dc4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e9981a7cdc3b9dc4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $061494166bd32450$var$AsteriskComponent = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $e9981a7cdc3b9dc4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $061494166bd32450$var$FormLabel = /*#__PURE__*/ $f2Y41.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $bKcdJ.default)(props, $061494166bd32450$var$_excluded);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $asN9r.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $061494166bd32450$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($061494166bd32450$export$aa5bc7f8a4705b27, (0, $asN9r.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ge3KO.jsxs)($061494166bd32450$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $061494166bd32450$export$2e2bcd8739ae039 = $061494166bd32450$var$FormLabel;







function $44a3da1a7625f019$export$c1c4b4545ad2ea5f(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiInputLabel", slot);
}
const $44a3da1a7625f019$var$inputLabelClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $44a3da1a7625f019$export$2e2bcd8739ae039 = $44a3da1a7625f019$var$inputLabelClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $aae43ab4ed3de4cf$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $aae43ab4ed3de4cf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $44a3da1a7625f019$export$c1c4b4545ad2ea5f), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $aae43ab4ed3de4cf$var$InputLabelRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $061494166bd32450$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e9981a7cdc3b9dc4$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $asN9r.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $asN9r.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $asN9r.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $aae43ab4ed3de4cf$var$InputLabel = /*#__PURE__*/ $f2Y41.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $bKcdJ.default)(props, $aae43ab4ed3de4cf$var$_excluded);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $asN9r.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $aae43ab4ed3de4cf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($aae43ab4ed3de4cf$var$InputLabelRoot, (0, $asN9r.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $aae43ab4ed3de4cf$export$2e2bcd8739ae039 = $aae43ab4ed3de4cf$var$InputLabel;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








var $f2Y41 = parcelRequire("f2Y41");
function $6c1f7d3c96775f51$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $f2Y41.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $41583f85a12f6bfe$export$2e2bcd8739ae039 = (0, $6c1f7d3c96775f51$export$2e2bcd8739ae039);





function $054a383905268a46$export$149c8b8bab2289d1(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiFormControl", slot);
}
const $054a383905268a46$var$formControlClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $054a383905268a46$export$2e2bcd8739ae039 = $054a383905268a46$var$formControlClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $17c7dfb36f72f6e6$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $17c7dfb36f72f6e6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $054a383905268a46$export$149c8b8bab2289d1), classes);
};
const $17c7dfb36f72f6e6$var$FormControlRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $asN9r.default)({}, styles.root, styles[`margin${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $17c7dfb36f72f6e6$var$FormControl = /*#__PURE__*/ $f2Y41.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $bKcdJ.default)(props, $17c7dfb36f72f6e6$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $17c7dfb36f72f6e6$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $f2Y41.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $f2Y41.Children.forEach(children, (child)=>{
            if (!(0, $41583f85a12f6bfe$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $41583f85a12f6bfe$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $e46b17d83ec63e21$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $f2Y41.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $f2Y41.Children.forEach(children, (child)=>{
            if (!(0, $41583f85a12f6bfe$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $e46b17d83ec63e21$export$d652b828d7fdeff8)(child.props, true) || (0, $e46b17d83ec63e21$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $f2Y41.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $f2Y41.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0e13fdb8d49639b9$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($17c7dfb36f72f6e6$var$FormControlRoot, (0, $asN9r.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $17c7dfb36f72f6e6$export$2e2bcd8739ae039 = $17c7dfb36f72f6e6$var$FormControl;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");









function $5aa8d4f662a1fb83$export$a394fa61b1d583a9(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiFormHelperText", slot);
}
const $5aa8d4f662a1fb83$var$formHelperTextClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $5aa8d4f662a1fb83$export$2e2bcd8739ae039 = $5aa8d4f662a1fb83$var$formHelperTextClasses;




var $ge3KO = parcelRequire("ge3KO");
"use client";
var $48260c162e5931d8$var$_span;
const $48260c162e5931d8$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $48260c162e5931d8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $5aa8d4f662a1fb83$export$a394fa61b1d583a9), classes);
};
const $48260c162e5931d8$var$FormHelperTextRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $5aa8d4f662a1fb83$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $5aa8d4f662a1fb83$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $48260c162e5931d8$var$FormHelperText = /*#__PURE__*/ $f2Y41.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $bKcdJ.default)(props, $48260c162e5931d8$var$_excluded);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)();
    const fcs = (0, $56a7f7c98f7e3f58$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $asN9r.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $48260c162e5931d8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($48260c162e5931d8$var$FormHelperTextRoot, (0, $asN9r.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $48260c162e5931d8$var$_span || ($48260c162e5931d8$var$_span = /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $48260c162e5931d8$export$2e2bcd8739ae039 = $48260c162e5931d8$var$FormHelperText;





function $869a58adf2857d5c$export$c1bdcbaf0596aeda(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiTextField", slot);
}
const $869a58adf2857d5c$var$textFieldClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiTextField", [
    "root"
]);
var $869a58adf2857d5c$export$2e2bcd8739ae039 = $869a58adf2857d5c$var$textFieldClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $fc0dded12476a4e7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $fc0dded12476a4e7$var$variantComponent = {
    standard: (0, $caa884ceadaca94e$export$2e2bcd8739ae039),
    filled: (0, $9e7df65f73970a1e$export$2e2bcd8739ae039),
    outlined: (0, $b1f7173b41fffbcb$export$2e2bcd8739ae039)
};
const $fc0dded12476a4e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $869a58adf2857d5c$export$c1bdcbaf0596aeda), classes);
};
const $fc0dded12476a4e7$var$TextFieldRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $17c7dfb36f72f6e6$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $fc0dded12476a4e7$var$TextField = /*#__PURE__*/ $f2Y41.forwardRef(function TextField(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $bKcdJ.default)(props, $fc0dded12476a4e7$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $fc0dded12476a4e7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $fc0dded12476a4e7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ge3KO.jsx)(InputComponent, (0, $asN9r.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($fc0dded12476a4e7$var$TextFieldRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $aae43ab4ed3de4cf$export$2e2bcd8739ae039), (0, $asN9r.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $03f203b075f5f43c$export$2e2bcd8739ae039), (0, $asN9r.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $48260c162e5931d8$export$2e2bcd8739ae039), (0, $asN9r.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $fc0dded12476a4e7$export$2e2bcd8739ae039 = $fc0dded12476a4e7$var$TextField;





var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");











function $3b383d6948bac7b8$export$5a6f9035944c8119(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiButton", slot);
}
const $3b383d6948bac7b8$var$buttonClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $3b383d6948bac7b8$export$2e2bcd8739ae039 = $3b383d6948bac7b8$var$buttonClasses;



var $f2Y41 = parcelRequire("f2Y41");
/**
 * @ignore - internal component.
 */ const $65e93b7e1f4a18ac$var$ButtonGroupContext = /*#__PURE__*/ $f2Y41.createContext({});
var $65e93b7e1f4a18ac$export$2e2bcd8739ae039 = $65e93b7e1f4a18ac$var$ButtonGroupContext;



var $f2Y41 = parcelRequire("f2Y41");
/**
 * @ignore - internal component.
 */ const $ac8b753e4308184d$var$ButtonGroupButtonContext = /*#__PURE__*/ $f2Y41.createContext(undefined);
var $ac8b753e4308184d$export$2e2bcd8739ae039 = $ac8b753e4308184d$var$ButtonGroupButtonContext;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $dcc9a3491e8ff9e8$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $dcc9a3491e8ff9e8$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $3b383d6948bac7b8$export$5a6f9035944c8119), classes);
    return (0, $asN9r.default)({}, classes, composedClasses);
};
const $dcc9a3491e8ff9e8$var$commonIconStyles = (ownerState)=>(0, $asN9r.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $dcc9a3491e8ff9e8$var$ButtonRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $1e60465a41fa8bc1$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $4773145d8cae4871$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $asN9r.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $asN9r.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $asN9r.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $3b383d6948bac7b8$export$2e2bcd8739ae039).focusVisible}`]: (0, $asN9r.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $3b383d6948bac7b8$export$2e2bcd8739ae039).disabled}`]: (0, $asN9r.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $3b383d6948bac7b8$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $3b383d6948bac7b8$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $dcc9a3491e8ff9e8$var$ButtonStartIcon = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $dcc9a3491e8ff9e8$var$commonIconStyles(ownerState)));
const $dcc9a3491e8ff9e8$var$ButtonEndIcon = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $asN9r.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $dcc9a3491e8ff9e8$var$commonIconStyles(ownerState)));
const $dcc9a3491e8ff9e8$var$Button = /*#__PURE__*/ $f2Y41.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $f2Y41.useContext((0, $65e93b7e1f4a18ac$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $f2Y41.useContext((0, $ac8b753e4308184d$export$2e2bcd8739ae039));
    const resolvedProps = (0, $39d3f7a539975594$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $bKcdJ.default)(props, $dcc9a3491e8ff9e8$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $dcc9a3491e8ff9e8$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ge3KO.jsx)($dcc9a3491e8ff9e8$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ge3KO.jsx)($dcc9a3491e8ff9e8$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($dcc9a3491e8ff9e8$var$ButtonRoot, (0, $asN9r.default)({
        ownerState: ownerState,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $dcc9a3491e8ff9e8$export$2e2bcd8739ae039 = $dcc9a3491e8ff9e8$var$Button;




var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");










function $fe21f82c9d294315$export$4b135a4b3a6c4550(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiInputAdornment", slot);
}
const $fe21f82c9d294315$var$inputAdornmentClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $fe21f82c9d294315$export$2e2bcd8739ae039 = $fe21f82c9d294315$var$inputAdornmentClasses;




var $ge3KO = parcelRequire("ge3KO");
"use client";
var $916f8f5bbe8dca7d$var$_span;
const $916f8f5bbe8dca7d$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $916f8f5bbe8dca7d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $916f8f5bbe8dca7d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $fe21f82c9d294315$export$4b135a4b3a6c4550), classes);
};
const $916f8f5bbe8dca7d$var$InputAdornmentRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $916f8f5bbe8dca7d$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $fe21f82c9d294315$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $fe21f82c9d294315$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $916f8f5bbe8dca7d$var$InputAdornment = /*#__PURE__*/ $f2Y41.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $bKcdJ.default)(props, $916f8f5bbe8dca7d$var$_excluded);
    const muiFormControl = (0, $f8c3e0729018c4ff$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $asN9r.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $916f8f5bbe8dca7d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0e13fdb8d49639b9$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)($916f8f5bbe8dca7d$var$InputAdornmentRoot, (0, $asN9r.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dcdca1e07a1d8440$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $916f8f5bbe8dca7d$var$_span || ($916f8f5bbe8dca7d$var$_span = /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $916f8f5bbe8dca7d$export$2e2bcd8739ae039 = $916f8f5bbe8dca7d$var$InputAdornment;



var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





















function $7ade2c2c4b42f602$export$837848f5f6cee923(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiTooltip", slot);
}
const $7ade2c2c4b42f602$var$tooltipClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $7ade2c2c4b42f602$export$2e2bcd8739ae039 = $7ade2c2c4b42f602$var$tooltipClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $6359ad5f6bea7997$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $6359ad5f6bea7997$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $6359ad5f6bea7997$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $7ade2c2c4b42f602$export$837848f5f6cee923), classes);
};
const $6359ad5f6bea7997$var$TooltipPopper = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $f1981fac35ac3785$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $asN9r.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).arrow}`]: (0, $asN9r.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).arrow}`]: (0, $asN9r.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $6359ad5f6bea7997$var$TooltipTooltip = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $asN9r.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$6359ad5f6bea7997$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $asN9r.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $asN9r.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $asN9r.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $asN9r.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $asN9r.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $asN9r.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $asN9r.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $7ade2c2c4b42f602$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $asN9r.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $6359ad5f6bea7997$var$TooltipArrow = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $dee2dd5afa9d03f4$exports.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $6359ad5f6bea7997$var$hystersisOpen = false;
const $6359ad5f6bea7997$var$hystersisTimer = new (0, $7982601b7fbfa734$export$786b4da70f00938b)();
let $6359ad5f6bea7997$var$cursorPosition = {
    x: 0,
    y: 0
};
function $6359ad5f6bea7997$export$b9ee5a7ace0541f8() {
    $6359ad5f6bea7997$var$hystersisOpen = false;
    $6359ad5f6bea7997$var$hystersisTimer.clear();
}
function $6359ad5f6bea7997$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $6359ad5f6bea7997$var$Tooltip = /*#__PURE__*/ $f2Y41.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $eb1588ef279b9dec$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $bKcdJ.default)(props, $6359ad5f6bea7997$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $f2Y41.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const isRtl = (0, $9e18942dda6584ee$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $f2Y41.useState();
    const [arrowRef, setArrowRef] = $f2Y41.useState(null);
    const ignoreNonTouchEvents = $f2Y41.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const enterTimer = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const touchTimer = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $8c595a04ba37cd86$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $4affeda36512a992$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $f2Y41.useRef();
    const stopTouchInteraction = (0, $61987fa9c93c65fe$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $f2Y41.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $6359ad5f6bea7997$var$hystersisTimer.clear();
        $6359ad5f6bea7997$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $61987fa9c93c65fe$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $6359ad5f6bea7997$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $6359ad5f6bea7997$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $6359ad5f6bea7997$var$hystersisOpen && enterNextDelay) enterTimer.start($6359ad5f6bea7997$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8b351fb7b939ea19$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $f2Y41.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $f2Y41.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $ed21878ae3c5e88a$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $f2Y41.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $6359ad5f6bea7997$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $asN9r.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $6359ad5f6bea7997$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $6359ad5f6bea7997$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $6359ad5f6bea7997$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $6359ad5f6bea7997$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $f2Y41.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $asN9r.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $asN9r.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $6359ad5f6bea7997$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $6359ad5f6bea7997$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $eb1588ef279b9dec$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $6359ad5f6bea7997$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $6359ad5f6bea7997$var$TooltipArrow;
    const popperProps = (0, $96f0d45fc1553f60$export$b089efb01a7bdf50)(PopperComponent, (0, $asN9r.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $96f0d45fc1553f60$export$b089efb01a7bdf50)(TransitionComponent, (0, $asN9r.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $96f0d45fc1553f60$export$b089efb01a7bdf50)(TooltipComponent, (0, $asN9r.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $96f0d45fc1553f60$export$b089efb01a7bdf50)(ArrowComponent, (0, $asN9r.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ $f2Y41.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ge3KO.jsx)(PopperComponent, (0, $asN9r.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $f1981fac35ac3785$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $6359ad5f6bea7997$var$cursorPosition.y,
                            left: $6359ad5f6bea7997$var$cursorPosition.x,
                            right: $6359ad5f6bea7997$var$cursorPosition.x,
                            bottom: $6359ad5f6bea7997$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ge3KO.jsx)(TransitionComponent, (0, $asN9r.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)(TooltipComponent, (0, $asN9r.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ge3KO.jsx)(ArrowComponent, (0, $asN9r.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $6359ad5f6bea7997$export$2e2bcd8739ae039 = $6359ad5f6bea7997$var$Tooltip;






var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
const $af864de9dbf301d9$var$_excluded = [
    "sortingOrder"
];
const $af864de9dbf301d9$export$9e3e7f6bf3b8c7a7 = /*#__PURE__*/ $f2Y41.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $bKcdJ.default)(props, $af864de9dbf301d9$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === "asc" ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, (0, $asN9r.default)({}, other)) : null;
});


parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
const $641b6a7a7f7291e0$export$6de472a3df735882 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward");
const $641b6a7a7f7291e0$export$1f2d4db4a79871d4 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
const $641b6a7a7f7291e0$export$8da6370d9999894a = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight");
const $641b6a7a7f7291e0$export$5b6f85a3ddabf4ca = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const $641b6a7a7f7291e0$export$cb1a577169e125de = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList");
const $641b6a7a7f7291e0$export$4f4f59585ffe8deb = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt");
const $641b6a7a7f7291e0$export$d33e6ad54b379a5d = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
const $641b6a7a7f7291e0$export$3c3b03774b2ed8ce = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
const $641b6a7a7f7291e0$export$7a7700ab3e9c7e95 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const $641b6a7a7f7291e0$export$10a5a2f68ff67c50 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon");
const $641b6a7a7f7291e0$export$e918bd395b324de6 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M11 19V5h2v14z"
}), "Separator");
const $641b6a7a7f7291e0$export$3bcf566f7053b242 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline");
const $641b6a7a7f7291e0$export$adcade5d1a52a335 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows");
const $641b6a7a7f7291e0$export$60a4c153d2d7b084 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream");
const $641b6a7a7f7291e0$export$2fbf0de7557957a8 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical");
const $641b6a7a7f7291e0$export$cbefef3cfb8e2783 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const $641b6a7a7f7291e0$export$e483c1441c7fca0b = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
const $641b6a7a7f7291e0$export$d8fa92cc66e4dec8 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), "Remove");
const $641b6a7a7f7291e0$export$52992a9d5fa53c3c = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load");
const $641b6a7a7f7291e0$export$305773dd821bb81d = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag");
const $641b6a7a7f7291e0$export$78df866ac12db1bd = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt");
const $641b6a7a7f7291e0$export$1f9ec58b2f66f46d = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
const $641b6a7a7f7291e0$export$6eaba7fcfbaac527 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert");
const $641b6a7a7f7291e0$export$9267feb6a6149971 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), "VisibilityOff");
const $641b6a7a7f7291e0$export$109d60d29e96616d = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("g", {
    children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), "ViewColumn");
const $641b6a7a7f7291e0$export$ab03f96923842ba7 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
const $641b6a7a7f7291e0$export$4830297c7288dee4 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
const $641b6a7a7f7291e0$export$fc6ef585bd0ee189 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");
parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
const $9d71d10846a88bb7$var$_excluded = [
    "native"
];
function $9d71d10846a88bb7$export$2e2bcd8739ae039(_ref) {
    let { native: native } = _ref, props = (0, $bKcdJ.default)(_ref, $9d71d10846a88bb7$var$_excluded);
    if (native) return /*#__PURE__*/ (0, $ge3KO.jsx)("option", (0, $asN9r.default)({}, props));
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $32815546ad734a59$export$2e2bcd8739ae039), (0, $asN9r.default)({}, props));
}


const $cdf36cc150a70ecf$var$iconSlots = {
    booleanCellTrueIcon: (0, $641b6a7a7f7291e0$export$1f9ec58b2f66f46d),
    booleanCellFalseIcon: (0, $641b6a7a7f7291e0$export$cbefef3cfb8e2783),
    columnMenuIcon: (0, $641b6a7a7f7291e0$export$2fbf0de7557957a8),
    openFilterButtonIcon: (0, $641b6a7a7f7291e0$export$cb1a577169e125de),
    filterPanelDeleteIcon: (0, $641b6a7a7f7291e0$export$cbefef3cfb8e2783),
    columnFilteredIcon: (0, $641b6a7a7f7291e0$export$4f4f59585ffe8deb),
    columnSelectorIcon: (0, $641b6a7a7f7291e0$export$10a5a2f68ff67c50),
    columnUnsortedIcon: (0, $af864de9dbf301d9$export$9e3e7f6bf3b8c7a7),
    columnSortedAscendingIcon: (0, $641b6a7a7f7291e0$export$6de472a3df735882),
    columnSortedDescendingIcon: (0, $641b6a7a7f7291e0$export$1f2d4db4a79871d4),
    columnResizeIcon: (0, $641b6a7a7f7291e0$export$e918bd395b324de6),
    densityCompactIcon: (0, $641b6a7a7f7291e0$export$3bcf566f7053b242),
    densityStandardIcon: (0, $641b6a7a7f7291e0$export$adcade5d1a52a335),
    densityComfortableIcon: (0, $641b6a7a7f7291e0$export$60a4c153d2d7b084),
    exportIcon: (0, $641b6a7a7f7291e0$export$78df866ac12db1bd),
    moreActionsIcon: (0, $641b6a7a7f7291e0$export$6eaba7fcfbaac527),
    treeDataCollapseIcon: (0, $641b6a7a7f7291e0$export$5b6f85a3ddabf4ca),
    treeDataExpandIcon: (0, $641b6a7a7f7291e0$export$8da6370d9999894a),
    groupingCriteriaCollapseIcon: (0, $641b6a7a7f7291e0$export$5b6f85a3ddabf4ca),
    groupingCriteriaExpandIcon: (0, $641b6a7a7f7291e0$export$8da6370d9999894a),
    detailPanelExpandIcon: (0, $641b6a7a7f7291e0$export$e483c1441c7fca0b),
    detailPanelCollapseIcon: (0, $641b6a7a7f7291e0$export$d8fa92cc66e4dec8),
    rowReorderIcon: (0, $641b6a7a7f7291e0$export$305773dd821bb81d),
    quickFilterIcon: (0, $641b6a7a7f7291e0$export$d33e6ad54b379a5d),
    quickFilterClearIcon: (0, $641b6a7a7f7291e0$export$cbefef3cfb8e2783),
    columnMenuHideIcon: (0, $641b6a7a7f7291e0$export$9267feb6a6149971),
    columnMenuSortAscendingIcon: (0, $641b6a7a7f7291e0$export$6de472a3df735882),
    columnMenuSortDescendingIcon: (0, $641b6a7a7f7291e0$export$1f2d4db4a79871d4),
    columnMenuFilterIcon: (0, $641b6a7a7f7291e0$export$4f4f59585ffe8deb),
    columnMenuManageColumnsIcon: (0, $641b6a7a7f7291e0$export$109d60d29e96616d),
    columnMenuClearIcon: (0, $641b6a7a7f7291e0$export$ab03f96923842ba7),
    loadIcon: (0, $641b6a7a7f7291e0$export$52992a9d5fa53c3c),
    filterPanelAddIcon: (0, $641b6a7a7f7291e0$export$e483c1441c7fca0b),
    filterPanelRemoveAllIcon: (0, $641b6a7a7f7291e0$export$fc6ef585bd0ee189),
    columnReorderIcon: (0, $641b6a7a7f7291e0$export$305773dd821bb81d)
};
const $cdf36cc150a70ecf$var$materialSlots = (0, $asN9r.default)({}, $cdf36cc150a70ecf$var$iconSlots, {
    baseCheckbox: (0, $404a3673ec7c60a8$export$2e2bcd8739ae039),
    baseTextField: (0, $fc0dded12476a4e7$export$2e2bcd8739ae039),
    baseFormControl: (0, $17c7dfb36f72f6e6$export$2e2bcd8739ae039),
    baseSelect: (0, $03f203b075f5f43c$export$2e2bcd8739ae039),
    baseButton: (0, $dcc9a3491e8ff9e8$export$2e2bcd8739ae039),
    baseIconButton: (0, $f3e02ef6e96bfc63$export$2e2bcd8739ae039),
    baseInputAdornment: (0, $916f8f5bbe8dca7d$export$2e2bcd8739ae039),
    baseTooltip: (0, $6359ad5f6bea7997$export$2e2bcd8739ae039),
    basePopper: (0, $f1981fac35ac3785$export$2e2bcd8739ae039),
    baseInputLabel: (0, $aae43ab4ed3de4cf$export$2e2bcd8739ae039),
    baseSelectOption: (0, $9d71d10846a88bb7$export$2e2bcd8739ae039),
    baseChip: (0, $4ba053864d7f4c37$export$2e2bcd8739ae039)
});
var $cdf36cc150a70ecf$export$2e2bcd8739ae039 = $cdf36cc150a70ecf$var$materialSlots;


const $9fa0f0a5762213ca$export$8a57bda01657743f = (0, $asN9r.default)({}, (0, $cdf36cc150a70ecf$export$2e2bcd8739ae039), {
    cell: (0, $35952bc45c850842$export$1ce951ee41d30605),
    skeletonCell: (0, $eb09dc42b7e8c216$export$d922c88d466d9c21),
    columnHeaderFilterIconButton: (0, $37f4650f5e79f594$export$35b5c67d267fafd7),
    columnMenu: (0, $c593a601c719670d$export$53fbb13480dfeb67),
    columnHeaders: (0, $6b952e08192bb2f9$export$4a3a74c44d0a6c04),
    detailPanels: (0, $01f553ab395ee0c4$export$aa888f5144097c35),
    footer: (0, $55f62be497184b51$export$6ef0bfefb022d11e),
    footerRowCount: (0, $69f08f1c39f7db7e$export$b92875c9af3e0a77),
    toolbar: null,
    pinnedRows: (0, $aea5ebd6a0104d64$export$58309d5251e10b9e),
    loadingOverlay: (0, $40612179cff5ef84$export$69e47a4ea5ffa191),
    noResultsOverlay: (0, $ee5c6f6674667887$export$82fb990ffc125278),
    noRowsOverlay: (0, $56dc7af5d946b575$export$a25f04494ce53510),
    pagination: (0, $5ad7570b81564c00$export$fa9a503101f8d472),
    filterPanel: (0, $21b0e7355a379ba9$export$32c6e72be8ad862c),
    columnsPanel: (0, $0ff983bdc0b3fe9c$export$39d43456ec96cf57),
    columnsManagement: (0, $05fe9c724f5c3995$export$3710e0bb3d9954d),
    panel: (0, $e96ff88f06c27373$export$cf917897ad2588b),
    row: (0, $e25064ca83d71b56$export$1fc5a7f035870658)
});




var $asN9r = parcelRequire("asN9r");
function $c0dbf612fe4dcc20$export$247af54f7c54fca({ defaultSlots: defaultSlots, slots: slots }) {
    const overrides = slots;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $asN9r.default)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}

function $94f05c0be3151915$export$2e2bcd8739ae039(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");
/** Gathers props for the root element into a single `.forwardedProps` field */ function $cf2708d4c6363cc3$var$groupForwardedProps(props) {
    const keys = Object.keys(props);
    if (!keys.some((key)=>key.startsWith("aria-") || key.startsWith("data-"))) return props;
    const newProps = {};
    const forwardedProps = props.forwardedProps ?? {};
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (key.startsWith("aria-") || key.startsWith("data-")) forwardedProps[key] = props[key];
        else newProps[key] = props[key];
    }
    newProps.forwardedProps = forwardedProps;
    return newProps;
}
function $cf2708d4c6363cc3$export$1f264be2c424fccf(allProps) {
    return $f2Y41.useMemo(()=>{
        const themedProps = (0, $asN9r.default)({}, ((0, $94f05c0be3151915$export$2e2bcd8739ae039)(allProps), allProps));
        return $cf2708d4c6363cc3$var$groupForwardedProps(themedProps);
    }, [
        allProps
    ]);
}


const $bfac834c55a2f88a$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: "DataGrid"
};
const $bfac834c55a2f88a$export$2733e0e1a1d288e7 = {
    autoHeight: false,
    autoPageSize: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    columnBufferPx: 150,
    rowBufferPx: 150,
    rows: [],
    rowSelection: true,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnSelector: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleRowSelection: false,
    disableColumnSorting: false,
    disableMultipleColumnsSorting: false,
    disableRowSelectionOnClick: false,
    disableVirtualization: false,
    editMode: (0, $c1e8ba2aebe0d5a9$export$bad6b7a934346f26).Cell,
    filterMode: "client",
    filterDebounceMs: 150,
    columnHeaderHeight: 56,
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    logger: console,
    logLevel: "error",
    pagination: false,
    paginationMode: "client",
    rowHeight: 52,
    resizeThrottleMs: 60,
    pageSizeOptions: [
        25,
        50,
        100
    ],
    rowSpacingType: "margin",
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    sortingOrder: [
        "asc",
        "desc",
        null
    ],
    sortingMode: "client",
    throttleRowsMs: 0,
    disableColumnReorder: false,
    disableColumnResize: false,
    keepNonExistentRowsSelected: false,
    keepColumnPositionIfDraggedOutside: false,
    ignoreValueFormatterDuringExport: false,
    clipboardCopyCellDelimiter: "	",
    rowPositionsDebounceMs: 166,
    autosizeOnMount: false,
    disableAutosize: false
};
const $bfac834c55a2f88a$var$defaultSlots = (0, $9fa0f0a5762213ca$export$8a57bda01657743f);
const $bfac834c55a2f88a$export$23366c9f040a985 = (inProps)=>{
    const themedProps = (0, $cf2708d4c6363cc3$export$1f264be2c424fccf)(// eslint-disable-next-line material-ui/mui-name-matches-component-name
    (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiDataGrid"
    }));
    const localeText = $f2Y41.useMemo(()=>(0, $asN9r.default)({}, (0, $ba665b27813960ac$export$d217cc4e11b3c706), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $f2Y41.useMemo(()=>(0, $c0dbf612fe4dcc20$export$247af54f7c54fca)({
            defaultSlots: $bfac834c55a2f88a$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    return $f2Y41.useMemo(()=>(0, $asN9r.default)({}, $bfac834c55a2f88a$export$2733e0e1a1d288e7, themedProps, {
            localeText: localeText,
            slots: slots
        }, $bfac834c55a2f88a$var$DATA_GRID_FORCED_PROPS), [
        themedProps,
        localeText,
        slots
    ]);
};


const $6b452a5f7e5dca5a$export$4224c70cd0329965 = (state)=>(0, $asN9r.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: 0,
            positions: []
        }
    });
let $6b452a5f7e5dca5a$var$warnedOnceInvalidRowHeight = false;
const $6b452a5f7e5dca5a$var$getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === "number" && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
const $6b452a5f7e5dca5a$var$rowHeightWarning = [
    `MUI X: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join("\n");
const $6b452a5f7e5dca5a$var$getRowHeightWarning = [
    `MUI X: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join("\n");
const $6b452a5f7e5dca5a$export$8a4468671da3a64f = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = props;
    const rowsHeightLookup = $f2Y41.useRef(Object.create(null));
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    const lastMeasuredRowIndex = $f2Y41.useRef(-1);
    const hasRowWithAutoHeight = $f2Y41.useRef(false);
    const densityFactor = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $a8df3c1fd8492eab$export$c646201fb1d3e7a6));
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const paginationState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $85e4c16509a27697$export$24c945ea033ce6cf));
    const sortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const currentPage = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, props);
    const pinnedRows = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0));
    const validRowHeight = $6b452a5f7e5dca5a$var$getValidRowHeight(props.rowHeight, (0, $bfac834c55a2f88a$export$2733e0e1a1d288e7).rowHeight, $6b452a5f7e5dca5a$var$rowHeightWarning);
    const rowHeight = Math.floor(validRowHeight * densityFactor);
    const hydrateRowsMeta = $f2Y41.useCallback(()=>{
        hasRowWithAutoHeight.current = false;
        const calculateRowProcessedSizes = (row)=>{
            if (!rowsHeightLookup.current[row.id]) rowsHeightLookup.current[row.id] = {
                sizes: {
                    baseCenter: rowHeight
                },
                isResized: false,
                autoHeight: false,
                needsFirstMeasurement: true // Assume all rows will need to be measured by default
            };
            const { isResized: isResized, needsFirstMeasurement: needsFirstMeasurement, sizes: sizes } = rowsHeightLookup.current[row.id];
            let baseRowHeight = typeof rowHeight === "number" && rowHeight > 0 ? rowHeight : 52;
            const existingBaseRowHeight = sizes.baseCenter;
            if (isResized) // Do not recalculate resized row height and use the value from the lookup
            baseRowHeight = existingBaseRowHeight;
            else if (getRowHeightProp) {
                const rowHeightFromUser = getRowHeightProp((0, $asN9r.default)({}, row, {
                    densityFactor: densityFactor
                }));
                if (rowHeightFromUser === "auto") {
                    if (needsFirstMeasurement) {
                        const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight((0, $asN9r.default)({}, row, {
                            densityFactor: densityFactor
                        })) : rowHeight;
                        // If the row was not measured yet use the estimated row height
                        baseRowHeight = estimatedRowHeight ?? rowHeight;
                    } else baseRowHeight = existingBaseRowHeight;
                    hasRowWithAutoHeight.current = true;
                    rowsHeightLookup.current[row.id].autoHeight = true;
                } else {
                    // Default back to base rowHeight if getRowHeight returns invalid value.
                    baseRowHeight = $6b452a5f7e5dca5a$var$getValidRowHeight(rowHeightFromUser, rowHeight, $6b452a5f7e5dca5a$var$getRowHeightWarning);
                    rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
                    rowsHeightLookup.current[row.id].autoHeight = false;
                }
            } else rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
            const initialHeights = {
                baseCenter: baseRowHeight
            };
            if (getRowSpacing) {
                const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
                const spacing = getRowSpacing((0, $asN9r.default)({}, row, {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage: indexRelativeToCurrentPage
                }));
                initialHeights.spacingTop = spacing.top ?? 0;
                initialHeights.spacingBottom = spacing.bottom ?? 0;
            }
            const processedSizes = apiRef.current.unstable_applyPipeProcessors("rowHeight", initialHeights, row);
            rowsHeightLookup.current[row.id].sizes = processedSizes;
            return processedSizes;
        };
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            let otherSizes = 0;
            const processedSizes = calculateRowProcessedSizes(row);
            /* eslint-disable-next-line no-restricted-syntax, guard-for-in */ for(const key in processedSizes){
                const value = processedSizes[key];
                if (key !== "baseCenter") otherSizes += value;
            }
            return acc + processedSizes.baseCenter + otherSizes;
        }, 0);
        pinnedRows?.top?.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        pinnedRows?.bottom?.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                rowsMeta: {
                    currentPageTotalHeight: currentPageTotalHeight,
                    positions: positions
                }
            });
        });
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        currentPage.rows,
        rowHeight,
        getRowHeightProp,
        getRowSpacing,
        getEstimatedRowHeight,
        pinnedRows,
        densityFactor
    ]);
    const getRowHeight = $f2Y41.useCallback((rowId)=>{
        const height = rowsHeightLookup.current[rowId];
        return height ? height.sizes.baseCenter : rowHeight;
    }, [
        rowHeight
    ]);
    const getRowInternalSizes = (rowId)=>rowsHeightLookup.current[rowId]?.sizes;
    const setRowHeight = $f2Y41.useCallback((id, height)=>{
        rowsHeightLookup.current[id].sizes.baseCenter = height;
        rowsHeightLookup.current[id].isResized = true;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const debouncedHydrateRowsMeta = $f2Y41.useMemo(()=>(0, $71559b3d0d8c73fb$export$2e2bcd8739ae039)(hydrateRowsMeta, props.rowPositionsDebounceMs), [
        hydrateRowsMeta,
        props.rowPositionsDebounceMs
    ]);
    const storeMeasuredRowHeight = $f2Y41.useCallback((id, height)=>{
        if (!rowsHeightLookup.current[id] || !rowsHeightLookup.current[id].autoHeight) return;
        // Only trigger hydration if the value is different, otherwise we trigger a loop
        const needsHydration = rowsHeightLookup.current[id].sizes.baseCenter !== height;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        rowsHeightLookup.current[id].sizes.baseCenter = height;
        if (needsHydration) debouncedHydrateRowsMeta();
    }, [
        debouncedHydrateRowsMeta
    ]);
    const rowHasAutoHeight = $f2Y41.useCallback((id)=>{
        return rowsHeightLookup.current[id]?.autoHeight || false;
    }, []);
    const getLastMeasuredRowIndex = $f2Y41.useCallback(()=>{
        return lastMeasuredRowIndex.current;
    }, []);
    const setLastMeasuredRowIndex = $f2Y41.useCallback((index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    }, []);
    const resetRowHeights = $f2Y41.useCallback(()=>{
        rowsHeightLookup.current = {};
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    $f2Y41.useEffect(()=>{
        hydrateRowsMeta();
    }, [
        rowHeight,
        filterModel,
        paginationState,
        sortModel,
        hydrateRowsMeta
    ]);
    (0, $338bdb77087fba68$export$98b68054bf03cb4)(apiRef, "rowHeight", hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_getRowHeight: getRowHeight,
        unstable_getRowInternalSizes: getRowInternalSizes,
        unstable_setRowHeight: setRowHeight,
        unstable_storeRowHeightMeasurement: storeMeasuredRowHeight,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        rowHasAutoHeight: rowHasAutoHeight
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, rowsMetaApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, rowsMetaPrivateApi, "private");
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");










const $1b09114b7f40356b$export$1a6bb5bb341eadaa = (state, props, apiRef)=>{
    apiRef.current.caches.rows = (0, $5a37f1a88e056eac$export$3496927f169f2d35)({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $asN9r.default)({}, state, {
        rows: (0, $5a37f1a88e056eac$export$4dcb6d8dd06e4f39)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const $1b09114b7f40356b$export$dd1a4469bbd9394e = (apiRef, props)=>{
    var error;
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridRows");
    const currentPage = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, props);
    const lastUpdateMs = $f2Y41.useRef(Date.now());
    const lastRowCount = $f2Y41.useRef(props.rowCount);
    const timeout = (0, $7982601b7fbfa734$export$2e2bcd8739ae039)();
    const getRow = $f2Y41.useCallback((id)=>{
        const model = (0, $b2a98a8b3d22f914$export$37767f9110c99048)(apiRef)[id];
        if (model) return model;
        const node = apiRef.current.getRowNode(id);
        if (node && (0, $5a37f1a88e056eac$export$fc9d832f40054590)(node)) return {
            [(0, $5a37f1a88e056eac$export$e8632b32bb8837db)]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowIdProp = props.getRowId;
    const getRowId = $f2Y41.useCallback((row)=>{
        if ((0, $5a37f1a88e056eac$export$e8632b32bb8837db) in row) return row[0, $5a37f1a88e056eac$export$e8632b32bb8837db];
        if (getRowIdProp) return getRowIdProp(row);
        return row.id;
    }, [
        getRowIdProp
    ]);
    const lookup = $f2Y41.useMemo(()=>currentPage.rows.reduce((acc, { id: id }, index)=>{
            acc[id] = index;
            return acc;
        }, {}), [
        currentPage.rows
    ]);
    const throttledRowsChange = $f2Y41.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                    rows: (0, $5a37f1a88e056eac$export$4dcb6d8dd06e4f39)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef),
                        previousTreeDepths: (0, $b2a98a8b3d22f914$export$eb24598525413286)(apiRef)
                    })
                }));
            apiRef.current.publishEvent("rowsSet");
            apiRef.current.forceUpdate();
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $f2Y41.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = (0, $5a37f1a88e056eac$export$3496927f169f2d35)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $f2Y41.useCallback((updates)=>{
        if (props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid && updates.length > 1) throw new Error([
            "MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
        ].join("\n"));
        const nonPinnedRowsUpdates = [];
        updates.forEach((update)=>{
            const id = (0, $5a37f1a88e056eac$export$a95fb784d0ca2e72)(update, props.getRowId, "A row was provided without id when calling updateRows():");
            const rowNode = apiRef.current.getRowNode(id);
            if (rowNode?.type === "pinnedRow") {
                // @ts-ignore because otherwise `release:build` doesn't work
                const pinnedRowsCache = apiRef.current.caches.pinnedRows;
                const prevModel = pinnedRowsCache.idLookup[id];
                if (prevModel) pinnedRowsCache.idLookup[id] = (0, $asN9r.default)({}, prevModel, update);
            } else nonPinnedRowsUpdates.push(update);
        });
        const cache = (0, $5a37f1a88e056eac$export$b593607f8b00d104)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const getRowModels = $f2Y41.useCallback(()=>{
        const dataRows = (0, $b2a98a8b3d22f914$export$c7dcaab5e573753)(apiRef);
        const idRowsLookup = (0, $b2a98a8b3d22f914$export$37767f9110c99048)(apiRef);
        return new Map(dataRows.map((id)=>[
                id,
                idRowsLookup[id] ?? {}
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = $f2Y41.useCallback(()=>(0, $b2a98a8b3d22f914$export$1641ef9d08e265ca)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $f2Y41.useCallback(()=>(0, $b2a98a8b3d22f914$export$c7dcaab5e573753)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $f2Y41.useCallback((id)=>lookup[id], [
        lookup
    ]);
    const setRowChildrenExpansion = $f2Y41.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI X: No row with id #${id} found.`);
        if (currentNode.type !== "group") throw new Error("MUI X: Only group nodes can be expanded or collapsed.");
        const newNode = (0, $asN9r.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                rows: (0, $asN9r.default)({}, state.rows, {
                    tree: (0, $asN9r.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent("rowExpansionChange", newNode);
    }, [
        apiRef
    ]);
    const getRowNode = $f2Y41.useCallback((id)=>(0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef)[id] ?? null, [
        apiRef
    ]);
    const getRowGroupChildren = $f2Y41.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering })=>{
        const tree = (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $5f97fdc29401641a$export$e4979ad0a2db8752)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $5a37f1a88e056eac$export$fc9d832f40054590)(tree[id])) children.push(id);
            }
        } else children = (0, $5a37f1a88e056eac$export$9380f4bcafb87e49)(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $896120ab6e9a1a0e$export$6d031b6e8cbaf41c)(apiRef);
            children = children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = $f2Y41.useCallback((rowId, targetIndex)=>{
        const node = apiRef.current.getRowNode(rowId);
        if (!node) throw new Error(`MUI X: No row with id #${rowId} found.`);
        if (node.parent !== (0, $5a37f1a88e056eac$export$433b924dc2506913)) throw new Error(`MUI X: The row reordering do not support reordering of grouped rows yet.`);
        if (node.type !== "leaf") throw new Error(`MUI X: The row reordering do not support reordering of footer or grouping rows.`);
        apiRef.current.setState((state)=>{
            const group = (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(state, apiRef.current.instanceId)[0, $5a37f1a88e056eac$export$433b924dc2506913];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $asN9r.default)({}, state, {
                rows: (0, $asN9r.default)({}, state.rows, {
                    tree: (0, $asN9r.default)({}, state.rows.tree, {
                        [(0, $5a37f1a88e056eac$export$433b924dc2506913)]: (0, $asN9r.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent("rowsSet");
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = $f2Y41.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid && newRows.length > 1) throw new Error([
            "MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
        ].join("\n"));
        if (newRows.length === 0) return;
        const treeDepth = (0, $b2a98a8b3d22f914$export$4cdbe576751dd8e2)(apiRef);
        if (treeDepth > 1) throw new Error("`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping");
        const tree = (0, $asN9r.default)({}, (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef));
        const dataRowIdToModelLookup = (0, $asN9r.default)({}, (0, $b2a98a8b3d22f914$export$37767f9110c99048)(apiRef));
        const dataRowIdToIdLookup = (0, $asN9r.default)({}, (0, $b2a98a8b3d22f914$export$451ff98f7dd9f13f)(apiRef));
        const rootGroup = tree[0, $5a37f1a88e056eac$export$433b924dc2506913];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $5a37f1a88e056eac$export$a95fb784d0ca2e72)(rowModel, props.getRowId, "A row was provided without id when calling replaceRows().");
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete dataRowIdToIdLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: (0, $5a37f1a88e056eac$export$433b924dc2506913),
                type: "leaf",
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            dataRowIdToIdLookup[rowId] = rowId;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[0, $5a37f1a88e056eac$export$433b924dc2506913] = (0, $asN9r.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId]?.type === "leaf");
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                rows: (0, $asN9r.default)({}, state.rows, {
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIdToIdLookup: dataRowIdToIdLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent("rowsSet");
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow: getRow,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren
    };
    /**
   * EVENTS
   */ const groupRows = $f2Y41.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $asN9r.default)({}, apiRef.current.caches.rows, {
            updates: {
                type: "full",
                rows: (0, $b2a98a8b3d22f914$export$c7dcaab5e573753)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $5a37f1a88e056eac$export$3496927f169f2d35)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const handleStrategyProcessorChange = $f2Y41.useCallback((methodName)=>{
        if (methodName === "rowTreeCreation") groupRows();
    }, [
        groupRows
    ]);
    const handleStrategyActivityChange = $f2Y41.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy("rowTree") !== (0, $b2a98a8b3d22f914$export$c263d91fb644e7a0)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "activeStrategyProcessorChange", handleStrategyProcessorChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "strategyAvailabilityChange", handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $f2Y41.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors("hydrateRows", {
                tree: (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(state, apiRef.current.instanceId),
                treeDepths: (0, $b2a98a8b3d22f914$export$eb24598525413286)(state, apiRef.current.instanceId),
                dataRowIds: (0, $b2a98a8b3d22f914$export$c7dcaab5e573753)(state, apiRef.current.instanceId),
                dataRowIdToModelLookup: (0, $b2a98a8b3d22f914$export$37767f9110c99048)(state, apiRef.current.instanceId),
                dataRowIdToIdLookup: (0, $b2a98a8b3d22f914$export$451ff98f7dd9f13f)(state, apiRef.current.instanceId)
            });
            return (0, $asN9r.default)({}, state, {
                rows: (0, $asN9r.default)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $5a37f1a88e056eac$export$e6ee03f0394a9759)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent("rowsSet");
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $338bdb77087fba68$export$98b68054bf03cb4)(apiRef, "hydrateRows", applyHydrateRowsProcessor);
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, rowApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, rowProApi, props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid ? "private" : "public");
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        let isRowCountPropUpdated = false;
        if (props.rowCount !== lastRowCount.current) {
            isRowCountPropUpdated = true;
            lastRowCount.current = props.rowCount;
        }
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                        rows: (0, $asN9r.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                        rows: (0, $asN9r.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            if (!isRowCountPropUpdated) return;
        }
        logger.debug(`Updating all rows, new length ${props.rows.length}`);
        throttledRowsChange({
            cache: (0, $5a37f1a88e056eac$export$3496927f169f2d35)({
                rows: props.rows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");












const $9d85025507520b40$export$996e35c2eef351ae = (state, props)=>{
    const sortModel = props.sortModel ?? props.initialState?.sorting?.sortModel ?? [];
    return (0, $asN9r.default)({}, state, {
        sorting: {
            sortModel: (0, $c24e05fccf11e052$export$13eeac5ac15e0be5)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const $9d85025507520b40$export$951287757eb5d93c = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridSorting");
    apiRef.current.registerControlState({
        stateId: "sortModel",
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9),
        changeEvent: "sortModelChange"
    });
    const upsertSortModel = $f2Y41.useCallback((field, sortItem)=>{
        const sortModel = (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (sortItem?.sort == null) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $f2Y41.useCallback((col, directionOverride)=>{
        const sortModel = (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            const nextSort = directionOverride === undefined ? (0, $c24e05fccf11e052$export$b3d84351ab2e3580)(col.sortingOrder ?? props.sortingOrder, existing.sort) : directionOverride;
            return nextSort === undefined ? undefined : (0, $asN9r.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $c24e05fccf11e052$export$b3d84351ab2e3580)(col.sortingOrder ?? props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $f2Y41.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false || props.disableColumnSorting) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            "columnMenuSortItem"
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder,
        props.disableColumnSorting
    ]);
    /**
   * API METHODS
   */ const applySorting = $f2Y41.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === "server") {
                logger.debug("Skipping sorting rows as sortingMode = server");
                return (0, $asN9r.default)({}, state, {
                    sorting: (0, $asN9r.default)({}, state.sorting, {
                        sortedRows: (0, $5a37f1a88e056eac$export$9380f4bcafb87e49)((0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef), (0, $5a37f1a88e056eac$export$433b924dc2506913), false)
                    })
                });
            }
            const sortModel = (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(state, apiRef.current.instanceId);
            const sortRowList = (0, $c24e05fccf11e052$export$b29e353d1a72dfda)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor("sorting", {
                sortRowList: sortRowList
            });
            return (0, $asN9r.default)({}, state, {
                sorting: (0, $asN9r.default)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent("sortedRowsSet");
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $f2Y41.useCallback((model)=>{
        const currentModel = (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $c24e05fccf11e052$export$3fc28d475ac000c0)(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $f2Y41.useCallback((field, direction, allowMultipleSorting)=>{
        const column = apiRef.current.getColumn(field);
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = sortItem?.sort == null ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $f2Y41.useCallback(()=>(0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $f2Y41.useCallback(()=>{
        const sortedRows = (0, $5f97fdc29401641a$export$8919e81647813e61)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $f2Y41.useCallback(()=>(0, $5f97fdc29401641a$export$e4979ad0a2db8752)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $f2Y41.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, sortApi, "public");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const sortModelToExport = (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        props.initialState?.sorting?.sortModel != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        props.initialState?.sorting?.sortModel
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const sortModel = context.stateToRestore.sorting?.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $c24e05fccf11e052$export$3fc28d475ac000c0)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $asN9r.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $f2Y41.useCallback((params)=>{
        const rowTree = (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef);
        const rootGroupNode = rowTree[0, $5a37f1a88e056eac$export$433b924dc2506913];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(apiRef, (0, $2478736619c33b8c$export$84214fbf04c4094), "sorting", flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $f2Y41.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(field, undefined, allowMultipleSorting);
    }, [
        sortColumn,
        props.disableColumnSorting
    ]);
    const handleColumnHeaderKeyDown = $f2Y41.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        // Ctrl + Enter opens the column menu
        if (event.key === "Enter" && !event.ctrlKey && !event.metaKey) sortColumn(field, undefined, event.shiftKey);
    }, [
        sortColumn,
        props.disableColumnSorting
    ]);
    const handleColumnsChange = $f2Y41.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)(apiRef);
        const latestColumns = (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $f2Y41.useCallback((methodName)=>{
        if (methodName === "sorting") apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "columnMenu", addColumnMenuItem);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderClick", handleColumnHeaderClick);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderKeyDown", handleColumnHeaderKeyDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowsSet", apiRef.current.applySorting);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnsChange", handleColumnsChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "activeStrategyProcessorChange", handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $f9629e0497ea16d6$export$c5623aa1c38918b6)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $3b6584a40cdd4f24$export$2e2bcd8739ae039)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};


var $f2Y41 = parcelRequire("f2Y41");




function $b01276c06a502c54$var$sanitizeCellValue(value, delimiterCharacter, shouldAppendQuotes) {
    if (typeof value === "string") {
        if (shouldAppendQuotes) {
            const escapedValue = value.replace(/"/g, '""');
            // Make sure value containing delimiter or line break won't be split into multiple rows
            if ([
                delimiterCharacter,
                "\n",
                "\r",
                '"'
            ].some((delimiter)=>value.includes(delimiter))) return `"${escapedValue}"`;
            return escapedValue;
        }
        return value;
    }
    return value;
}
const $b01276c06a502c54$export$edda57d2a460473d = (cellParams, options)=>{
    const { delimiterCharacter: delimiterCharacter, ignoreValueFormatter: ignoreValueFormatter, shouldAppendQuotes: shouldAppendQuotes } = options;
    let value;
    if (ignoreValueFormatter) {
        const columnType = cellParams.colDef.type;
        if (columnType === "number") value = String(cellParams.value);
        else if (columnType === "date" || columnType === "dateTime") value = cellParams.value?.toISOString();
        else if (typeof cellParams.value?.toString === "function") value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $b01276c06a502c54$var$sanitizeCellValue(value, delimiterCharacter, shouldAppendQuotes);
};
const $b01276c06a502c54$var$objectFormattedValueWarning = (0, $a93eb5ccff318341$export$baf331755d84b871)([
    "MUI X: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.",
    "You can provide a `valueFormatter` with a string representation to be used."
]);
class $b01276c06a502c54$var$CSVRow {
    constructor(options){
        this.options = void 0;
        this.rowString = "";
        this.isEmpty = true;
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.delimiterCharacter;
        if (value === null || value === undefined) this.rowString += "";
        else if (typeof this.options.sanitizeCellValue === "function") this.rowString += this.options.sanitizeCellValue(value, this.options.delimiterCharacter, this.options.shouldAppendQuotes);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $b01276c06a502c54$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, delimiterCharacter: delimiterCharacter, ignoreValueFormatter: ignoreValueFormatter, shouldAppendQuotes: shouldAppendQuotes })=>{
    const row = new $b01276c06a502c54$var$CSVRow({
        delimiterCharacter: delimiterCharacter,
        shouldAppendQuotes: shouldAppendQuotes
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        row.addValue($b01276c06a502c54$export$edda57d2a460473d(cellParams, {
            delimiterCharacter: delimiterCharacter,
            ignoreValueFormatter: ignoreValueFormatter,
            shouldAppendQuotes: shouldAppendQuotes
        }));
    });
    return row.getRowString();
};
function $b01276c06a502c54$export$8bfbf32dccc29440(options) {
    const { columns: columns, rowIds: rowIds, delimiterCharacter: delimiterCharacter, includeHeaders: includeHeaders, includeColumnGroupsHeaders: includeColumnGroupsHeaders, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef, shouldAppendQuotes: shouldAppendQuotes } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$b01276c06a502c54$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            delimiterCharacter: delimiterCharacter,
            ignoreValueFormatter: ignoreValueFormatter,
            shouldAppendQuotes: shouldAppendQuotes
        })}\r\n`, "").trim();
    if (!includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== (0, $a75f25e717ae3a15$export$b2e9ab6103a664ad).field);
    const headerRows = [];
    if (includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $b01276c06a502c54$var$CSVRow({
                delimiterCharacter: delimiterCharacter,
                sanitizeCellValue: $b01276c06a502c54$var$sanitizeCellValue,
                shouldAppendQuotes: shouldAppendQuotes
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : "");
            });
        }
    }
    const mainHeaderRow = new $b01276c06a502c54$var$CSVRow({
        delimiterCharacter: delimiterCharacter,
        sanitizeCellValue: $b01276c06a502c54$var$sanitizeCellValue,
        shouldAppendQuotes: shouldAppendQuotes
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join("\r\n")}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}


function $20864ea749fa7e5a$var$writeToClipboardPolyfill(data) {
    const span = document.createElement("span");
    span.style.whiteSpace = "pre";
    span.style.userSelect = "all";
    span.style.opacity = "0px";
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand("copy");
    } finally{
        document.body.removeChild(span);
    }
}
function $20864ea749fa7e5a$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $20864ea749fa7e5a$var$writeToClipboardPolyfill(data);
    });
    else $20864ea749fa7e5a$var$writeToClipboardPolyfill(data);
}
function $20864ea749fa7e5a$var$hasNativeSelection(element) {
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if (window.getSelection()?.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const $20864ea749fa7e5a$export$a44b2f69ac6aef73 = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === "object" ? ignoreValueFormatterProp?.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $f2Y41.useCallback((event)=>{
        if (!((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "c" && !event.shiftKey && !event.altKey)) return;
        // Do nothing if there's a native selection
        if ($20864ea749fa7e5a$var$hasNativeSelection(event.target)) return;
        let textToCopy = "";
        const selectedRows = apiRef.current.getSelectedRows();
        if (selectedRows.size > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            // TODO: make it configurable
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false
        });
        else {
            const focusedCell = (0, $f90986e9ff221f63$export$74af8aada6269d3)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $b01276c06a502c54$export$edda57d2a460473d)(cellParams, {
                    delimiterCharacter: clipboardCopyCellDelimiter,
                    ignoreValueFormatter: ignoreValueFormatter,
                    shouldAppendQuotes: false
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors("clipboardCopy", textToCopy);
        if (textToCopy) {
            $20864ea749fa7e5a$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent("clipboardCopy", textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $64e59e98530d9a75$export$265f4c39182036e)(apiRef, apiRef.current.rootElementRef, "keydown", handleCopy);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "clipboardCopy", props.onClipboardCopy);
};


var $f2Y41 = parcelRequire("f2Y41");


const $ce30633c7c432f3e$export$ce7ce4871097b52e = (apiRef)=>{
    const lookup = $f2Y41.useRef({});
    const getCellColSpanInfo = (rowId, columnIndex)=>{
        return lookup.current[rowId]?.[columnIndex];
    };
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = $f2Y41.useCallback(({ rowId: rowId, minFirstColumn: minFirstColumn, maxLastColumn: maxLastColumn, columns: columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = $ce30633c7c432f3e$var$calculateCellColSpan({
                apiRef: apiRef,
                lookup: lookup.current,
                columnIndex: i,
                rowId: rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns: columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        apiRef
    ]);
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        calculateColSpan: calculateColSpan
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnSpanningPublicApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnSpanningPrivateApi, "private");
    const handleColumnReorderChange = $f2Y41.useCallback(()=>{
        // `colSpan` needs to be recalculated after column reordering
        lookup.current = {};
    }, []);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnOrderChange", handleColumnReorderChange);
};
function $ce30633c7c432f3e$var$calculateCellColSpan(params) {
    const { apiRef: apiRef, lookup: lookup, columnIndex: columnIndex, rowId: rowId, minFirstColumnIndex: minFirstColumnIndex, maxLastColumnIndex: maxLastColumnIndex, columns: columns } = params;
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const row = apiRef.current.getRow(rowId);
    const value = apiRef.current.getRowValue(row, column);
    const colSpan = typeof column.colSpan === "function" ? column.colSpan(value, row, column, apiRef) : column.colSpan;
    if (!colSpan || colSpan === 1) {
        $ce30633c7c432f3e$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: 1,
                width: column.computedWidth
            }
        });
        return {
            colSpan: 1
        };
    }
    let width = column.computedWidth;
    for(let j = 1; j < colSpan; j += 1){
        const nextColumnIndex = columnIndex + j;
        // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
        if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
            const nextColumn = columns[nextColumnIndex];
            width += nextColumn.computedWidth;
            $ce30633c7c432f3e$var$setCellColSpanInfo(lookup, rowId, columnIndex + j, {
                spannedByColSpan: true,
                rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                leftVisibleCellIndex: columnIndex
            });
        }
        $ce30633c7c432f3e$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: colSpan,
                width: width
            }
        });
    }
    return {
        colSpan: colSpan
    };
}
function $ce30633c7c432f3e$var$setCellColSpanInfo(lookup, rowId, columnIndex, cellColSpanInfo) {
    if (!lookup[rowId]) lookup[rowId] = {};
    lookup[rowId][columnIndex] = cellColSpanInfo;
}


var $f2Y41 = parcelRequire("f2Y41");


/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $272619b2282ac5aa$export$f95aebe89510930(blob, extension = "csv", filename = document.title || "untitled") {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ("download" in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement("a");
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error("MUI X: exportAs not supported.");
}






const $70f1d530e1408cd4$export$c5c7f3bb5f79a15d = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $b22d10f7b8994eba$export$da85f06e3c19f1fd)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const $70f1d530e1408cd4$export$99156d1572dee776 = ({ apiRef: apiRef })=>{
    const filteredSortedRowIds = (0, $896120ab6e9a1a0e$export$4e2a9d76902d271c)(apiRef);
    const rowTree = (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== "footer");
    const pinnedRows = (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0)(apiRef);
    const topPinnedRowsIds = pinnedRows?.top?.map((row)=>row.id) || [];
    const bottomPinnedRowsIds = pinnedRows?.bottom?.map((row)=>row.id) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");









var $ge3KO = parcelRequire("ge3KO");
const $41771d500e709bf7$export$9c3c7dbe6f1101cf = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbarExportContainer(props, ref) {
    const { children: children, slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const exportButtonId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const exportMenuId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const [open, setOpen] = $f2Y41.useState(false);
    const buttonRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if ((0, $19fd75f0cc198aff$export$34e5042f80daa3dd)(event.key)) event.preventDefault();
        if ((0, $19fd75f0cc198aff$export$81301abbcd0c8143)(event.key)) handleMenuClose();
    };
    if (children == null) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
                title: apiRef.current.getLocaleText("toolbarExportLabel"),
                enterDelay: 1000
            }, tooltipProps, rootProps.slotProps?.baseTooltip, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
                    ref: handleRef,
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText("toolbarExportLabel"),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, buttonProps, {
                    onClick: handleMenuOpen
                }, rootProps.slotProps?.baseButton, {
                    children: apiRef.current.getLocaleText("toolbarExport")
                }))
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f1a3f9a2e160d201$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d203149adb48b43d$export$2e2bcd8739ae039), {
                    id: exportMenuId,
                    className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: $f2Y41.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $f2Y41.isValidElement(child)) return child;
                        return /*#__PURE__*/ $f2Y41.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});



var $ge3KO = parcelRequire("ge3KO");
const $e53f14e1a9fb983f$var$_excluded = [
    "hideMenu",
    "options"
], $e53f14e1a9fb983f$var$_excluded2 = [
    "hideMenu",
    "options"
], $e53f14e1a9fb983f$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $e53f14e1a9fb983f$export$c0e66088a5c9ffbf(props) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $bKcdJ.default)(props, $e53f14e1a9fb983f$var$_excluded);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $32815546ad734a59$export$2e2bcd8739ae039), (0, $asN9r.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText("toolbarExportCSV")
    }));
}
function $e53f14e1a9fb983f$export$a6cd094b30f69b92(props) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $bKcdJ.default)(props, $e53f14e1a9fb983f$var$_excluded2);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $32815546ad734a59$export$2e2bcd8739ae039), (0, $asN9r.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText("toolbarExportPrint")
    }));
}
const $e53f14e1a9fb983f$export$ef68b449b329deb5 = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbarExport(props, ref) {
    const { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = props, other = (0, $bKcdJ.default)(props, $e53f14e1a9fb983f$var$_excluded3);
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors("exportMenu", [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $41771d500e709bf7$export$9c3c7dbe6f1101cf), (0, $asN9r.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $f2Y41.cloneElement(button.component, {
                key: index
            }))
    }));
});



var $ge3KO = parcelRequire("ge3KO");
const $e870a6e7ee59b151$export$6178dbab26611702 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridCsvExport");
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === "object" ? ignoreValueFormatterProp?.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $f2Y41.useCallback((options = {})=>{
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $70f1d530e1408cd4$export$c5c7f3bb5f79a15d)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = options.getRowsToExport ?? (0, $70f1d530e1408cd4$export$99156d1572dee776);
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $b01276c06a502c54$export$8bfbf32dccc29440)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            delimiterCharacter: options.delimiter || ",",
            includeHeaders: options.includeHeaders ?? true,
            includeColumnGroupsHeaders: options.includeColumnGroupsHeaders ?? true,
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef,
            shouldAppendQuotes: options.shouldAppendQuotes ?? true
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $f2Y41.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options?.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : "",
            csv
        ], {
            type: "text/csv"
        });
        (0, $272619b2282ac5aa$export$f95aebe89510930)(blob, "csv", options?.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, csvExportApi, "public");
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $f2Y41.useCallback((initialValue, options)=>{
        if (options.csvOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e53f14e1a9fb983f$export$c0e66088a5c9ffbf), {
                    options: options.csvOptions
                }),
                componentName: "csvExport"
            }
        ];
    }, []);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportMenu", addExportMenuButtons);
};


function $f67e3aa0584dc61e$export$8456f443918812d4(apiRef, props) {
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnHeaderClick", props.onColumnHeaderClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnHeaderDoubleClick", props.onColumnHeaderDoubleClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnHeaderOver", props.onColumnHeaderOver);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnHeaderOut", props.onColumnHeaderOut);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnHeaderEnter", props.onColumnHeaderEnter);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnHeaderLeave", props.onColumnHeaderLeave);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "cellClick", props.onCellClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "cellDoubleClick", props.onCellDoubleClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "cellKeyDown", props.onCellKeyDown);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "preferencePanelClose", props.onPreferencePanelClose);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "preferencePanelOpen", props.onPreferencePanelOpen);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "menuOpen", props.onMenuOpen);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "menuClose", props.onMenuClose);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "rowDoubleClick", props.onRowDoubleClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "rowClick", props.onRowClick);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "stateChange", props.onStateChange);
}


var $f2Y41 = parcelRequire("f2Y41");
const $6d7aa64a10dcc793$export$9f7c27985c4a3681 = (apiRef)=>{
    const rootElementRef = $f2Y41.useRef(null);
    const mainElementRef = $f2Y41.useRef(null);
    const virtualScrollerRef = $f2Y41.useRef(null);
    apiRef.current.register("public", {
        rootElementRef: rootElementRef
    });
    apiRef.current.register("private", {
        mainElementRef: mainElementRef,
        virtualScrollerRef: virtualScrollerRef
    });
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

const $a6413dba28a85158$export$46dae42d8096671d = (apiRef)=>{
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    if (!apiRef.current.state.theme) apiRef.current.state.theme = theme;
    const isFirstEffect = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstEffect.current) isFirstEffect.current = false;
        else apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                theme: theme
            }));
    }, [
        apiRef,
        theme
    ]);
};



var $f2Y41 = parcelRequire("f2Y41");


const $814dca75e09eacf8$var$forceDebug = (0, $2b59f632c4f96fc9$export$c43914e0cb16a981)() && window.localStorage.getItem("DEBUG") != null;
const $814dca75e09eacf8$var$noop = ()=>{};
const $814dca75e09eacf8$var$noopLogger = {
    debug: $814dca75e09eacf8$var$noop,
    info: $814dca75e09eacf8$var$noop,
    warn: $814dca75e09eacf8$var$noop,
    error: $814dca75e09eacf8$var$noop
};
const $814dca75e09eacf8$var$LOG_LEVELS = [
    "debug",
    "info",
    "warn",
    "error"
];
function $814dca75e09eacf8$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $814dca75e09eacf8$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI X: Log level ${logLevel} not recognized.`);
    const logger = $814dca75e09eacf8$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI X: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $814dca75e09eacf8$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $814dca75e09eacf8$export$db6c72f4003d67df = (apiRef, props)=>{
    const getLogger = $f2Y41.useCallback((name)=>{
        if ($814dca75e09eacf8$var$forceDebug) return $814dca75e09eacf8$var$getAppender(name, "debug", props.logger);
        if (!props.logLevel) return $814dca75e09eacf8$var$noopLogger;
        return $814dca75e09eacf8$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, {
        getLogger: getLogger
    }, "private");
};



var $f2Y41 = parcelRequire("f2Y41");
class $ceb6822bd5ead396$export$390f32400eaf98c9 {
    static create(value) {
        return new $ceb6822bd5ead396$export$390f32400eaf98c9(value);
    }
    constructor(_value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (value)=>{
            this.value = value;
            this.listeners.forEach((l)=>l(value));
        };
        this.value = _value;
        this.listeners = new Set();
    }
}




// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $81d26163cf6bb7ae$export$cc74486daaaef499 {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}


const $e85ee4153afd0005$var$SYMBOL_API_PRIVATE = Symbol("mui.api_private");
const $e85ee4153afd0005$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $e85ee4153afd0005$export$37686f243ec62a21(publicApi) {
    return publicApi[$e85ee4153afd0005$var$SYMBOL_API_PRIVATE];
}
let $e85ee4153afd0005$var$globalId = 0;
function $e85ee4153afd0005$var$createPrivateAPI(publicApiRef) {
    const existingPrivateApi = publicApiRef.current?.[$e85ee4153afd0005$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: (0, $ceb6822bd5ead396$export$390f32400eaf98c9).create(state),
        instanceId: {
            id: $e85ee4153afd0005$var$globalId
        }
    };
    $e85ee4153afd0005$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if (currentPrivateMethod?.spying === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === "public") {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if (currentPublicMethod?.spying === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register("private", {
        caches: {},
        eventManager: new (0, $81d26163cf6bb7ae$export$cc74486daaaef499)()
    });
    return privateApi;
}
function $e85ee4153afd0005$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$e85ee4153afd0005$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $e85ee4153afd0005$export$72d4a6c5ec1a4b32(inputApiRef, props) {
    const publicApiRef = $f2Y41.useRef();
    const privateApiRef = $f2Y41.useRef();
    if (!privateApiRef.current) privateApiRef.current = $e85ee4153afd0005$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $e85ee4153afd0005$var$createPublicAPI(privateApiRef);
    const publishEvent = $f2Y41.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($e85ee4153afd0005$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGridPro ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $f2Y41.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, "public");
    if (inputApiRef && !inputApiRef.current?.state) inputApiRef.current = publicApiRef.current;
    $f2Y41.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $f2Y41.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent("unmount");
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}



var $f2Y41 = parcelRequire("f2Y41");
const $703460b8b14b470f$export$9943f2ed4ddf85bf = (apiRef, props)=>{
    const getLocaleText = $f2Y41.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register("public", {
        getLocaleText: getLocaleText
    });
};



var $bKcdJ = parcelRequire("bKcdJ");


var $f2Y41 = parcelRequire("f2Y41");

const $15d559a151abbc0b$export$1c5794e7ed1dc58f = (apiRef)=>{
    const cache = $f2Y41.useRef({});
    const isRunning = $f2Y41.useRef(false);
    const runAppliers = $f2Y41.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $f2Y41.useCallback((group, id, processor)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {}
        };
        const groupCache = cache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            groupCache.processorsAsArray = Array.from(cache.current[group].processors.values());
            runAppliers(groupCache);
        }
        return ()=>{
            cache.current[group].processors.delete(id);
            cache.current[group].processorsAsArray = Array.from(cache.current[group].processors.values());
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = $f2Y41.useCallback((group, id, applier)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {}
        };
        cache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = cache.current[group].appliers, otherAppliers = (0, $bKcdJ.default)(_appliers, [
                id
            ].map((0, $89fc5a2109771035$export$2e2bcd8739ae039)));
            cache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $f2Y41.useCallback((group)=>{
        runAppliers(cache.current[group]);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $f2Y41.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!cache.current[group]) return value;
        const processors = cache.current[group].processorsAsArray;
        let result = value;
        for(let i = 0; i < processors.length; i += 1)result = processors[i](result, context);
        return result;
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, preProcessingPrivateApi, "private");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, preProcessingPublicApi, "public");
};




var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


const $925046c0395db26a$export$53c7ec825c1e4d3f = (apiRef)=>{
    const controlStateMapRef = $f2Y41.useRef({});
    const [, rawForceUpdate] = $f2Y41.useState();
    const registerControlState = $f2Y41.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $f2Y41.useCallback((state, reason)=>{
        let newState;
        if ((0, $2b59f632c4f96fc9$export$f6e2535fb5126e54)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(", ")} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            if (apiRef.current.publishEvent) apiRef.current.publishEvent("stateChange", newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) controlState.propOnChange(model, {
                reason: reason,
                api: apiRef.current
            });
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef
    ]);
    const updateControlState = $f2Y41.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $asN9r.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const forceUpdate = $f2Y41.useCallback(()=>rawForceUpdate(()=>apiRef.current.state), [
        apiRef
    ]);
    const publicStateApi = {
        setState: setState,
        forceUpdate: forceUpdate
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, publicStateApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, privateStateApi, "private");
};


const $97d6c186911014b8$export$b77462c86b28bbf0 = (inputApiRef, props)=>{
    const privateApiRef = (0, $e85ee4153afd0005$export$72d4a6c5ec1a4b32)(inputApiRef, props);
    (0, $6d7aa64a10dcc793$export$9f7c27985c4a3681)(privateApiRef);
    (0, $a6413dba28a85158$export$46dae42d8096671d)(privateApiRef);
    (0, $814dca75e09eacf8$export$db6c72f4003d67df)(privateApiRef, props);
    (0, $925046c0395db26a$export$53c7ec825c1e4d3f)(privateApiRef);
    (0, $15d559a151abbc0b$export$1c5794e7ed1dc58f)(privateApiRef);
    (0, $2478736619c33b8c$export$594711f8e5fa9b04)(privateApiRef);
    (0, $703460b8b14b470f$export$9943f2ed4ddf85bf)(privateApiRef, props);
    privateApiRef.current.register("private", {
        rootProps: props
    });
    return privateApiRef;
};


var $f2Y41 = parcelRequire("f2Y41");
const $a8b49b85bf61e69c$export$f9587d613f2caeec = (initializer, privateApiRef, props)=>{
    const isInitialized = $f2Y41.useRef(false);
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};


var $f2Y41 = parcelRequire("f2Y41");

















function $b4fdfe6bdee25f2c$var$enrichPageRowsWithPinnedRows(apiRef, rows) {
    const pinnedRows = (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0)(apiRef) || {};
    return [
        ...pinnedRows.top || [],
        ...rows,
        ...pinnedRows.bottom || []
    ];
}
const $b4fdfe6bdee25f2c$var$getLeftColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, direction: direction })=>{
    if (direction === "rtl") {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (direction === "ltr") {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const $b4fdfe6bdee25f2c$var$getRightColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, direction: direction })=>{
    if (direction === "rtl") {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (direction === "ltr") {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
const $b4fdfe6bdee25f2c$export$142b8bb1fe6da473 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridKeyboardNavigation");
    const initialCurrentPageRows = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, props).rows;
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const currentPageRows = $f2Y41.useMemo(()=>$b4fdfe6bdee25f2c$var$enrichPageRowsWithPinnedRows(apiRef, initialCurrentPageRows), [
        apiRef,
        initialCurrentPageRows
    ]);
    const headerFilteringEnabled = props.signature !== "DataGrid" && props.headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {number} rowIndex index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $f2Y41.useCallback((colIndex, rowId, closestColumnToUse = "left")=>{
        const visibleSortedRows = (0, $896120ab6e9a1a0e$export$2f31562143a3e5d4)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === "left") colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === "right") colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === rowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setCellFocus(rowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = $f2Y41.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $f2Y41.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $f2Y41.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $f2Y41.useCallback((rowIndex)=>{
        return currentPageRows[rowIndex]?.id;
    }, [
        currentPageRows
    ]);
    const handleColumnHeaderKeyDown = $f2Y41.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, $a75f25e717ae3a15$export$b2e9ab6103a664ad).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef).length - 1;
        const columnGroupMaxDepth = (0, $60b55b5d22f1422b$export$4cf0369c079b29be)(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case "ArrowDown":
                if (firstRowIndexInPage !== null) {
                    if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                    else goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                }
                break;
            case "ArrowRight":
                {
                    const rightColIndex = $b4fdfe6bdee25f2c$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case "ArrowLeft":
                {
                    const leftColIndex = $b4fdfe6bdee25f2c$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case "ArrowUp":
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case "PageDown":
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case "Home":
                goToHeader(firstColIndex, event);
                break;
            case "End":
                goToHeader(lastColIndex, event);
                break;
            case "Enter":
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case " ":
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        theme.direction,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $f2Y41.useCallback((params, event)=>{
        const isEditing = (0, $08de99050f04470e$export$d5104e3dccc7c49d)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $08de99050f04470e$export$c564e60305059ea4)(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !(0, $19fd75f0cc198aff$export$e13d96c38a470518)(event.key)) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case "ArrowDown":
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (firstRowIndexInPage !== null && rowId != null) goToCell(colIndexBefore, rowId);
                    break;
                }
            case "ArrowRight":
                {
                    const rightColIndex = $b4fdfe6bdee25f2c$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case "ArrowLeft":
                {
                    const leftColIndex = $b4fdfe6bdee25f2c$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case "ArrowUp":
                goToHeader(colIndexBefore, event);
                break;
            case "PageDown":
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case "Home":
                goToHeaderFilter(firstColIndex, event);
                break;
            case "End":
                goToHeaderFilter(lastColIndex, event);
                break;
            case " ":
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeaderFilter,
        theme.direction,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $f2Y41.useCallback((params, event)=>{
        const focusedColumnGroup = (0, $f90986e9ff221f63$export$3eeedc3f7263df61)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case "ArrowDown":
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case "ArrowUp":
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case "ArrowRight":
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case "ArrowLeft":
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case "PageDown":
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case "Home":
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case "End":
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case " ":
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $6790963f450ce0fb$export$8ce496ad3bfbe3a6)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === (0, $c1e8ba2aebe0d5a9$export$84e4fdd8f295ca31).Edit || !(0, $19fd75f0cc198aff$export$e13d96c38a470518)(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors("canUpdateFocus", true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (currentPageRows.length === 0) return;
        const direction = theme.direction;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case "ArrowDown":
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1));
                break;
            case "ArrowUp":
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case "ArrowRight":
                {
                    const rightColIndex = $b4fdfe6bdee25f2c$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: direction
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), direction === "rtl" ? "left" : "right");
                    break;
                }
            case "ArrowLeft":
                {
                    const leftColIndex = $b4fdfe6bdee25f2c$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: direction
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), direction === "rtl" ? "right" : "left");
                    break;
                }
            case "Tab":
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), "left");
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), "right");
                break;
            case " ":
                {
                    const field = params.field;
                    if (field === (0, $203fcf5e6d2a11a8$export$6e5a576305a34719)) break;
                    const colDef = params.colDef;
                    if (colDef && // `GRID_TREE_DATA_GROUPING_FIELD` from the Pro package
                    colDef.field === "__tree_data_group__") break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case "PageDown":
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case "PageUp":
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case "Home":
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case "End":
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows,
        theme.direction,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = $f2Y41.useCallback((initialValue, { event: event })=>{
        if (event.key === " ") // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "canStartEditing", checkIfCanStartEditing);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderKeyDown", handleColumnHeaderKeyDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "headerFilterKeyDown", handleHeaderFilterKeyDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnGroupHeaderKeyDown", handleColumnGroupHeaderKeyDown);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", handleCellKeyDown);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");















var $ge3KO = parcelRequire("ge3KO");
function $89bba07274b383fc$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $89bba07274b383fc$var$buildPrintWindow(title) {
    const iframeEl = document.createElement("iframe");
    iframeEl.style.position = "absolute";
    iframeEl.style.width = "0px";
    iframeEl.style.height = "0px";
    iframeEl.title = title || document.title;
    return iframeEl;
}
const $89bba07274b383fc$export$41205b2521d4edd4 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridPrintExport");
    const doc = $f2Y41.useRef(null);
    const previousGridState = $f2Y41.useRef(null);
    const previousColumnVisibility = $f2Y41.useRef({});
    const previousRows = $f2Y41.useRef([]);
    const previousVirtualizationState = $f2Y41.useRef();
    $f2Y41.useEffect(()=>{
        doc.current = (0, $e8cbed3bfd60af6f$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
    }, [
        apiRef
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $f2Y41.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $70f1d530e1408cd4$export$c5c7f3bb5f79a15d)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $b22d10f7b8994eba$export$da85f06e3c19f1fd)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[(0, $a75f25e717ae3a15$export$b2e9ab6103a664ad).field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $f2Y41.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.reduce((acc, id)=>{
            const row = apiRef.current.getRow(id);
            if (!row[0, $5a37f1a88e056eac$export$e8632b32bb8837db]) acc.push(row);
            return acc;
        }, []);
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $f2Y41.useCallback((printWindow, options)=>{
        const normalizeOptions = (0, $asN9r.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = (0, $7662854de25f6bb1$export$4f32bfc70efeb4ab)(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).main}`);
        gridMain.style.overflow = "visible";
        // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = "size";
        let gridToolbarElementHeight = gridRootElement.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).toolbarContainer}`)?.offsetHeight || 0;
        let gridFooterElementHeight = gridRootElement.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).footerContainer}`)?.offsetHeight || 0;
        if (normalizeOptions.hideToolbar) {
            gridClone.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).toolbarContainer}`)?.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter) {
            gridClone.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).footerContainer}`)?.remove();
            gridFooterElementHeight = 0;
        }
        // Expand container height to accommodate all rows
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + (0, $977688d2f2933ee3$export$659109c29172602f)(apiRef, props) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = "content-box";
        // the footer is always being placed at the bottom of the page as if all rows are exported
        // so if getRowsToExport is being used to only export a subset of rows then we need to
        // adjust the footer position to be correctly placed at the bottom of the grid
        const gridFooterElement = gridClone.querySelector(`.${(0, $2276c81b0f2e6e46$export$2100d54e36406477).footerContainer}`);
        gridFooterElement.style.position = "absolute";
        gridFooterElement.style.width = "100%";
        gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement("div");
        container.appendChild(gridClone);
        // To avoid an empty page in start on Chromium based browsers
        printDoc.body.style.marginTop = "0px";
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === "function" ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === "string") {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement("style");
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(" "));
        const stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === "ShadowRoot" ? rootCandidate : doc.current;
            const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if (node.tagName === "STYLE") {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = "";
                        // NOTE: for-of is not supported by IE
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === "string") styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute("href")) {
                    // If `href` tag is empty, avoid loading these links
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || "");
                    }
                    stylesheetLoadPromises.push(new Promise((resolve)=>{
                        newHeadStyleElements.addEventListener("load", ()=>resolve());
                    }));
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        }
        // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props
    ]);
    const handlePrintWindowAfterPrint = $f2Y41.useCallback((printWindow)=>{
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!previousGridState.current?.columns?.columnVisibilityModel) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                virtualization: previousVirtualizationState.current
            }));
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $f2Y41.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error("MUI X: No grid root element available.");
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $b22d10f7b8994eba$export$eb0d33595fe29bb4)(apiRef);
        previousRows.current = apiRef.current.getSortedRows().filter((row)=>!row[0, $5a37f1a88e056eac$export$e8632b32bb8837db]);
        if (props.pagination) {
            const visibleRowCount = (0, $896120ab6e9a1a0e$export$96919017bbfaec0d)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                    pagination: (0, $asN9r.default)({}, state.pagination, {
                        paginationModel: (0, $f9e4fc29d101a237$export$16d1dc8477d07e4)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        "DataGridPro", paginationModel)
                    })
                }));
        }
        previousVirtualizationState.current = apiRef.current.state.virtualization;
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                virtualization: (0, $asN9r.default)({}, state.virtualization, {
                    enabled: false,
                    enabledForColumns: false
                })
            }));
        await updateGridColumnsForPrint(options?.fields, options?.allColumns, options?.includeCheckboxes);
        updateGridRowsForPrint(options?.getRowsToExport ?? (0, $70f1d530e1408cd4$export$99156d1572dee776));
        await $89bba07274b383fc$var$raf(); // wait for the state changes to take action
        const printWindow = $89bba07274b383fc$var$buildPrintWindow(options?.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia("print");
            mediaQueryList.addEventListener("change", (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, printExportApi, "public");
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $f2Y41.useCallback((initialValue, options)=>{
        if (options.printOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e53f14e1a9fb983f$export$a6cd094b30f69b92), {
                    options: options.printOptions
                }),
                componentName: "printExport"
            }
        ];
    }, []);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportMenu", addExportMenuButtons);
};


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




const $c6440c503a1fb6d2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $f2Y41.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                "cellCheckbox"
            ],
            columnHeaderCheckbox: [
                "columnHeaderCheckbox"
            ]
        };
        return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $c6440c503a1fb6d2$export$fa1d7b0897c018ea = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $c6440c503a1fb6d2$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $f2Y41.useCallback((columnsState)=>{
        const selectionColumn = (0, $asN9r.default)({}, (0, $a75f25e717ae3a15$export$b2e9ab6103a664ad), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText("checkboxSelectionHeaderName")
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const haveSelectionColumn = columnsState.lookup[0, $a75f25e717ae3a15$export$322dfed7a1df1b02] != null;
        if (shouldHaveSelectionColumn && !haveSelectionColumn) {
            columnsState.lookup[0, $a75f25e717ae3a15$export$322dfed7a1df1b02] = selectionColumn;
            columnsState.orderedFields = [
                (0, $a75f25e717ae3a15$export$322dfed7a1df1b02),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && haveSelectionColumn) {
            delete columnsState.lookup[0, $a75f25e717ae3a15$export$322dfed7a1df1b02];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $a75f25e717ae3a15$export$322dfed7a1df1b02));
        } else if (shouldHaveSelectionColumn && haveSelectionColumn) columnsState.lookup[0, $a75f25e717ae3a15$export$322dfed7a1df1b02] = (0, $asN9r.default)({}, selectionColumn, columnsState.lookup[0, $a75f25e717ae3a15$export$322dfed7a1df1b02]);
        return columnsState;
    }, [
        apiRef,
        classes,
        props.checkboxSelection
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "hydrateColumns", updateSelectionColumn);
};


var $asN9r = parcelRequire("asN9r");


const $7cd92ed222fe9d9d$var$createFlatRowTree = (rows)=>{
    const tree = {
        [(0, $5a37f1a88e056eac$export$433b924dc2506913)]: (0, $asN9r.default)({}, (0, $5a37f1a88e056eac$export$96a607054e9bfd0c)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: (0, $5a37f1a88e056eac$export$433b924dc2506913),
            type: "leaf",
            groupingKey: null
        };
    }
    return {
        groupingName: (0, $2478736619c33b8c$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $7cd92ed222fe9d9d$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $asN9r.default)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: (0, $5a37f1a88e056eac$export$433b924dc2506913),
            type: "leaf",
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[0, $5a37f1a88e056eac$export$433b924dc2506913];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[0, $5a37f1a88e056eac$export$433b924dc2506913] = (0, $asN9r.default)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: (0, $2478736619c33b8c$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $7cd92ed222fe9d9d$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === "full") return $7cd92ed222fe9d9d$var$createFlatRowTree(params.updates.rows);
    return $7cd92ed222fe9d9d$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $7cd92ed222fe9d9d$export$cc1daa683bbe5702 = (apiRef)=>{
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(apiRef, (0, $2478736619c33b8c$export$84214fbf04c4094), "rowTreeCreation", $7cd92ed222fe9d9d$var$flatRowTreeCreationMethod);
};


var $f2Y41 = parcelRequire("f2Y41");










// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $5aa2c68e4a4e170e$var$scrollIntoView(dimensions) {
    const { clientHeight: clientHeight, scrollTop: scrollTop, offsetHeight: offsetHeight, offsetTop: offsetTop } = dimensions;
    const elementBottom = offsetTop + offsetHeight;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (offsetHeight > clientHeight) return offsetTop;
    if (elementBottom - clientHeight > scrollTop) return elementBottom - clientHeight;
    if (offsetTop < scrollTop) return offsetTop;
    return undefined;
}
const $5aa2c68e4a4e170e$export$d3441dc29db31b8c = (apiRef, props)=>{
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridScroll");
    const colRef = apiRef.current.columnHeadersContainerRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$2f31562143a3e5d4));
    const scrollToIndexes = $f2Y41.useCallback((params)=>{
        const dimensions = (0, $13cd7539f33578ca$export$26d8768b83a52ffd)(apiRef.current.state);
        const totalRowCount = (0, $b2a98a8b3d22f914$export$1641ef9d08e265ca)(apiRef);
        const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex !== undefined) {
            const columnPositions = (0, $b22d10f7b8994eba$export$fce7d810e48021e3)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== "undefined") {
                const rowId = visibleSortedRows[params.rowIndex]?.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === "undefined") cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $5aa2c68e4a4e170e$var$scrollIntoView({
                clientHeight: dimensions.viewportInnerSize.width,
                scrollTop: Math.abs(virtualScrollerRef.current.scrollLeft),
                offsetHeight: cellWidth,
                offsetTop: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex !== undefined) {
            const rowsMeta = (0, $7662854de25f6bb1$export$4f32bfc70efeb4ab)(apiRef.current.state);
            const page = (0, $85e4c16509a27697$export$1f7f64fcb62ccdad)(apiRef);
            const pageSize = (0, $85e4c16509a27697$export$721a46720a2de097)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            scrollCoordinates.top = $5aa2c68e4a4e170e$var$scrollIntoView({
                clientHeight: dimensions.viewportInnerSize.height,
                scrollTop: virtualScrollerRef.current.scrollTop,
                offsetHeight: targetOffsetHeight,
                offsetTop: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors("scrollToIndexes", scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows
    ]);
    const scroll = $f2Y41.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left !== undefined && colRef.current) {
            const direction = theme.direction === "rtl" ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top !== undefined) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        theme.direction,
        colRef,
        logger
    ]);
    const getScrollPosition = $f2Y41.useCallback(()=>{
        if (!virtualScrollerRef?.current) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, scrollApi, "public");
};


var $f2Y41 = parcelRequire("f2Y41");

const $3c601f02158a8077$export$971de86bde7f86a1 = (apiRef)=>{
    const exportState = $f2Y41.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors("exportState", {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $f2Y41.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors("restoreState", {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, statePersistenceApi, "public");
};



var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $a6484e1ecd03bb68$var$InfiniteLoadingTriggerElement = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div")({
    position: "sticky",
    left: 0,
    width: 0,
    height: 0
});
const $a6484e1ecd03bb68$export$ffcbb8895be5a582 = (apiRef, props)=>{
    const visibleColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$16a65a9447d3dda9));
    const currentPage = (0, $5102b0c2afb145a4$export$d1914c80ff11e37a)(apiRef, props);
    const observer = $f2Y41.useRef();
    const triggerElement = $f2Y41.useRef(null);
    const isEnabled = props.rowsLoadingMode === "client" && !!props.onRowsScrollEnd;
    const handleLoadMoreRows = (0, $b8da6eb696d47660$export$2e2bcd8739ae039)(([entry])=>{
        const currentRatio = entry.intersectionRatio;
        const isIntersecting = entry.isIntersecting;
        if (isIntersecting && currentRatio === 1) {
            const viewportPageSize = apiRef.current.getViewportPageSize();
            const rowScrollEndParams = {
                visibleColumns: visibleColumns,
                viewportPageSize: viewportPageSize,
                visibleRowsCount: currentPage.rows.length
            };
            apiRef.current.publishEvent("rowsScrollEnd", rowScrollEndParams);
            observer.current?.disconnect();
            // do not observe this node anymore
            triggerElement.current = null;
        }
    });
    const virtualScroller = apiRef.current.virtualScrollerRef.current;
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const marginBottom = props.scrollEndThreshold - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    $f2Y41.useEffect(()=>{
        if (!isEnabled) return;
        if (!virtualScroller) return;
        observer.current?.disconnect();
        observer.current = new IntersectionObserver(handleLoadMoreRows, {
            threshold: 1,
            root: virtualScroller,
            rootMargin: `0px 0px ${marginBottom}px 0px`
        });
        if (triggerElement.current) observer.current.observe(triggerElement.current);
    }, [
        virtualScroller,
        handleLoadMoreRows,
        isEnabled,
        marginBottom
    ]);
    const triggerRef = $f2Y41.useCallback((node)=>{
        // Prevent the infite loading working in combination with lazy loading
        if (!isEnabled) return;
        if (triggerElement.current !== node) {
            observer.current?.disconnect();
            triggerElement.current = node;
            if (triggerElement.current) observer.current?.observe(triggerElement.current);
        }
    }, [
        isEnabled
    ]);
    const getInfiniteLoadingTriggerElement = $f2Y41.useCallback(({ lastRowId: lastRowId })=>{
        if (!isEnabled) return null;
        return /*#__PURE__*/ (0, $ge3KO.jsx)($a6484e1ecd03bb68$var$InfiniteLoadingTriggerElement, {
            ref: triggerRef,
            role: "presentation"
        }, `trigger-${lastRowId}`);
    }, [
        isEnabled,
        triggerRef
    ]);
    const infiniteLoaderPrivateApi = {
        getInfiniteLoadingTriggerElement: getInfiniteLoadingTriggerElement
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, infiniteLoaderPrivateApi, "private");
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "rowsScrollEnd", props.onRowsScrollEnd);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




const $8bd9c4ec2a6ae6db$export$72ac47d6066a8a99 = (state)=>state.columnReorder;
const $8bd9c4ec2a6ae6db$export$78d24cc7373bc611 = (0, $a8687ecb01faf148$export$595d22ed68ca2841)($8bd9c4ec2a6ae6db$export$72ac47d6066a8a99, (columnReorder)=>columnReorder.dragCol);


const $7b36c927bd481439$var$CURSOR_MOVE_DIRECTION_LEFT = "left";
const $7b36c927bd481439$var$CURSOR_MOVE_DIRECTION_RIGHT = "right";
const $7b36c927bd481439$var$getCursorMoveDirectionX = (currentCoordinates, nextCoordinates)=>{
    return currentCoordinates.x <= nextCoordinates.x ? $7b36c927bd481439$var$CURSOR_MOVE_DIRECTION_RIGHT : $7b36c927bd481439$var$CURSOR_MOVE_DIRECTION_LEFT;
};
const $7b36c927bd481439$var$hasCursorPositionChanged = (currentCoordinates, nextCoordinates)=>currentCoordinates.x !== nextCoordinates.x || currentCoordinates.y !== nextCoordinates.y;
const $7b36c927bd481439$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        columnHeaderDragging: [
            "columnHeader--dragging"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $7b36c927bd481439$export$c111e737ab642862 = (state)=>(0, $asN9r.default)({}, state, {
        columnReorder: {
            dragCol: ""
        }
    });
const $7b36c927bd481439$export$e060c7667a4364d2 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridColumnReorder");
    const dragColNode = $f2Y41.useRef(null);
    const cursorPosition = $f2Y41.useRef({
        x: 0,
        y: 0
    });
    const originColumnIndex = $f2Y41.useRef(null);
    const forbiddenIndexes = $f2Y41.useRef({});
    const removeDnDStylesTimeout = $f2Y41.useRef();
    const ownerState = {
        classes: props.classes
    };
    const classes = $7b36c927bd481439$var$useUtilityClasses(ownerState);
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    $f2Y41.useEffect(()=>{
        return ()=>{
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    const handleDragStart = $f2Y41.useCallback((params, event)=>{
        if (props.disableColumnReorder || params.colDef.disableReorder) return;
        logger.debug(`Start dragging col ${params.field}`);
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragColNode.current = event.currentTarget;
        dragColNode.current.classList.add(classes.columnHeaderDragging);
        if (event.dataTransfer) event.dataTransfer.effectAllowed = "move";
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                columnReorder: (0, $asN9r.default)({}, state.columnReorder, {
                    dragCol: params.field
                })
            }));
        apiRef.current.forceUpdate();
        removeDnDStylesTimeout.current = setTimeout(()=>{
            dragColNode.current.classList.remove(classes.columnHeaderDragging);
        });
        originColumnIndex.current = apiRef.current.getColumnIndex(params.field, false);
        const draggingColumnGroupPath = apiRef.current.getColumnGroupPath(params.field);
        const columnIndex = originColumnIndex.current;
        const allColumns = apiRef.current.getAllColumns();
        const groupsLookup = apiRef.current.getAllGroupDetails();
        const getGroupPathFromColumnIndex = (colIndex)=>{
            const field = allColumns[colIndex].field;
            return apiRef.current.getColumnGroupPath(field);
        };
        // The limitingGroupId is the id of the group from which the dragged column should not escape
        let limitingGroupId = null;
        draggingColumnGroupPath.forEach((groupId)=>{
            if (!groupsLookup[groupId]?.freeReordering) {
                // Only consider group that are made of more than one column
                if (columnIndex > 0 && getGroupPathFromColumnIndex(columnIndex - 1).includes(groupId)) limitingGroupId = groupId;
                else if (columnIndex + 1 < allColumns.length && getGroupPathFromColumnIndex(columnIndex + 1).includes(groupId)) limitingGroupId = groupId;
            }
        });
        forbiddenIndexes.current = {};
        for(let indexToForbid = 0; indexToForbid < allColumns.length; indexToForbid += 1){
            const leftIndex = indexToForbid <= columnIndex ? indexToForbid - 1 : indexToForbid;
            const rightIndex = indexToForbid < columnIndex ? indexToForbid : indexToForbid + 1;
            if (limitingGroupId !== null) {
                // verify this indexToForbid will be linked to the limiting group. Otherwise forbid it
                let allowIndex = false;
                if (leftIndex >= 0 && getGroupPathFromColumnIndex(leftIndex).includes(limitingGroupId)) allowIndex = true;
                else if (rightIndex < allColumns.length && getGroupPathFromColumnIndex(rightIndex).includes(limitingGroupId)) allowIndex = true;
                if (!allowIndex) forbiddenIndexes.current[indexToForbid] = true;
            }
            // Verify we are not splitting another group
            if (leftIndex >= 0 && rightIndex < allColumns.length) getGroupPathFromColumnIndex(rightIndex).forEach((groupId)=>{
                if (getGroupPathFromColumnIndex(leftIndex).includes(groupId)) {
                    if (!draggingColumnGroupPath.includes(groupId)) // moving here split the group groupId in two distincts chunks
                    {
                        if (!groupsLookup[groupId]?.freeReordering) forbiddenIndexes.current[indexToForbid] = true;
                    }
                }
            });
        }
    }, [
        props.disableColumnReorder,
        classes.columnHeaderDragging,
        logger,
        apiRef
    ]);
    const handleDragEnter = $f2Y41.useCallback((params, event)=>{
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
    }, []);
    const handleDragOver = $f2Y41.useCallback((params, event)=>{
        const dragColField = (0, $8bd9c4ec2a6ae6db$export$78d24cc7373bc611)(apiRef);
        if (!dragColField) return;
        logger.debug(`Dragging over col ${params.field}`);
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        const coordinates = {
            x: event.clientX,
            y: event.clientY
        };
        if (params.field !== dragColField && $7b36c927bd481439$var$hasCursorPositionChanged(cursorPosition.current, coordinates)) {
            const targetColIndex = apiRef.current.getColumnIndex(params.field, false);
            const targetColVisibleIndex = apiRef.current.getColumnIndex(params.field, true);
            const targetCol = apiRef.current.getColumn(params.field);
            const dragColIndex = apiRef.current.getColumnIndex(dragColField, false);
            const visibleColumns = apiRef.current.getVisibleColumns();
            const allColumns = apiRef.current.getAllColumns();
            const cursorMoveDirectionX = $7b36c927bd481439$var$getCursorMoveDirectionX(cursorPosition.current, coordinates);
            const hasMovedLeft = cursorMoveDirectionX === $7b36c927bd481439$var$CURSOR_MOVE_DIRECTION_LEFT && (theme.direction === "rtl" ? dragColIndex < targetColIndex : targetColIndex < dragColIndex);
            const hasMovedRight = cursorMoveDirectionX === $7b36c927bd481439$var$CURSOR_MOVE_DIRECTION_RIGHT && (theme.direction === "rtl" ? targetColIndex < dragColIndex : dragColIndex < targetColIndex);
            if (hasMovedLeft || hasMovedRight) {
                let canBeReordered;
                let indexOffsetInHiddenColumns = 0;
                if (!targetCol.disableReorder) canBeReordered = true;
                else if (hasMovedLeft) canBeReordered = targetColVisibleIndex > 0 && !visibleColumns[targetColVisibleIndex - 1].disableReorder;
                else canBeReordered = targetColVisibleIndex < visibleColumns.length - 1 && !visibleColumns[targetColVisibleIndex + 1].disableReorder;
                if (forbiddenIndexes.current[targetColIndex]) {
                    let nextVisibleColumnField;
                    let indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                    if (hasMovedLeft) {
                        nextVisibleColumnField = targetColVisibleIndex > 0 ? visibleColumns[targetColVisibleIndex - 1].field : null;
                        while(indexWithOffset > 0 && allColumns[indexWithOffset].field !== nextVisibleColumnField && forbiddenIndexes.current[indexWithOffset]){
                            indexOffsetInHiddenColumns -= 1;
                            indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                        }
                    } else {
                        nextVisibleColumnField = targetColVisibleIndex + 1 < visibleColumns.length ? visibleColumns[targetColVisibleIndex + 1].field : null;
                        while(indexWithOffset < allColumns.length - 1 && allColumns[indexWithOffset].field !== nextVisibleColumnField && forbiddenIndexes.current[indexWithOffset]){
                            indexOffsetInHiddenColumns += 1;
                            indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                        }
                    }
                    if (forbiddenIndexes.current[indexWithOffset] || allColumns[indexWithOffset].field === nextVisibleColumnField) // If we ended up on a visible column, or a forbidden one, we cannot do the reorder
                    canBeReordered = false;
                }
                const canBeReorderedProcessed = apiRef.current.unstable_applyPipeProcessors("canBeReordered", canBeReordered, {
                    targetIndex: targetColVisibleIndex
                });
                if (canBeReorderedProcessed) apiRef.current.setColumnIndex(dragColField, targetColIndex + indexOffsetInHiddenColumns);
            }
            cursorPosition.current = coordinates;
        }
    }, [
        apiRef,
        logger,
        theme.direction
    ]);
    const handleDragEnd = $f2Y41.useCallback((params, event)=>{
        const dragColField = (0, $8bd9c4ec2a6ae6db$export$78d24cc7373bc611)(apiRef);
        if (props.disableColumnReorder || !dragColField) return;
        logger.debug("End dragging col");
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        dragColNode.current = null;
        // Check if the column was dropped outside the grid.
        if (event.dataTransfer.dropEffect === "none" && !props.keepColumnPositionIfDraggedOutside) {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setColumnIndex(dragColField, originColumnIndex.current);
            originColumnIndex.current = null;
        } else {
            // Emit the columnOrderChange event only once when the reordering stops.
            const columnOrderChangeParams = {
                column: apiRef.current.getColumn(dragColField),
                targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(dragColField),
                oldIndex: originColumnIndex.current
            };
            apiRef.current.publishEvent("columnOrderChange", columnOrderChangeParams);
        }
        apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                columnReorder: (0, $asN9r.default)({}, state.columnReorder, {
                    dragCol: ""
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        props.disableColumnReorder,
        props.keepColumnPositionIfDraggedOutside,
        logger,
        apiRef
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragStart", handleDragStart);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragEnter", handleDragEnter);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragOver", handleDragOver);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnHeaderDragEnd", handleDragEnd);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellDragEnter", handleDragEnter);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellDragOver", handleDragOver);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "columnOrderChange", props.onColumnOrderChange);
};



var $f2Y41 = parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

const $407212466300a479$export$eed79627d7deb3a5 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "custom",
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    disableReorder: true,
    align: "left",
    width: 200,
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = apiRef.current.getRowId(row);
        const rowNode = apiRef.current.getRowNode(rowId);
        return rowNode?.type === "group" || rowNode?.type === "leaf" ? rowNode.groupingKey : undefined;
    }
});
const $407212466300a479$export$9cce4aaa860dd90a = "__tree_data_group__";
const $407212466300a479$export$1a0175c947f58fd3 = {
    field: $407212466300a479$export$9cce4aaa860dd90a,
    editable: false,
    groupable: false
};


const $82a800c863c32a12$export$15cdd24474e74350 = (apiRef)=>{
    /**
   * EVENTS
   */ const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.colDef.field === (0, $407212466300a479$export$9cce4aaa860dd90a) && event.key === " " && !event.shiftKey) {
            if (params.rowNode.type !== "group") return;
            apiRef.current.setRowChildrenExpansion(params.id, !params.rowNode.childrenExpanded);
        }
    }, [
        apiRef
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", handleCellKeyDown);
};



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




const $768fdf0fcba13748$export$6bd6c3ee4fcd23bc = "tree-data";
const $768fdf0fcba13748$export$d431177e37819461 = (params)=>{
    const { apiRef: apiRef, rowTree: rowTree, disableChildrenFiltering: disableChildrenFiltering, isRowMatchingFilters: isRowMatchingFilters } = params;
    const filteredRowsLookup = {};
    const filteredDescendantCountLookup = {};
    const filterCache = {};
    const filterResults = {
        passingFilterItems: null,
        passingQuickFilterValues: null
    };
    const filterTreeNode = (node, isParentMatchingFilters, areAncestorsExpanded)=>{
        const shouldSkipFilters = disableChildrenFiltering && node.depth > 0;
        let isMatchingFilters;
        if (shouldSkipFilters) isMatchingFilters = null;
        else if (!isRowMatchingFilters || node.type === "footer") isMatchingFilters = true;
        else {
            const row = apiRef.current.getRow(node.id);
            isRowMatchingFilters(row, undefined, filterResults);
            isMatchingFilters = (0, $6989b4da95410729$export$8d82b4490466f182)([
                filterResults.passingFilterItems
            ], [
                filterResults.passingQuickFilterValues
            ], params.filterModel, params.apiRef, filterCache);
        }
        let filteredDescendantCount = 0;
        if (node.type === "group") node.children.forEach((childId)=>{
            const childNode = rowTree[childId];
            const childSubTreeSize = filterTreeNode(childNode, isMatchingFilters ?? isParentMatchingFilters, areAncestorsExpanded && !!node.childrenExpanded);
            filteredDescendantCount += childSubTreeSize;
        });
        let shouldPassFilters;
        switch(isMatchingFilters){
            case true:
                shouldPassFilters = true;
                break;
            case false:
                shouldPassFilters = filteredDescendantCount > 0;
                break;
            default:
                shouldPassFilters = isParentMatchingFilters;
                break;
        }
        filteredRowsLookup[node.id] = shouldPassFilters;
        if (!shouldPassFilters) return 0;
        filteredDescendantCountLookup[node.id] = filteredDescendantCount;
        if (node.type === "footer") return filteredDescendantCount;
        return filteredDescendantCount + 1;
    };
    const nodes = Object.values(rowTree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.depth === 0) filterTreeNode(node, true, true);
    }
    return {
        filteredRowsLookup: filteredRowsLookup,
        filteredDescendantCountLookup: filteredDescendantCountLookup
    };
};



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");


var $5TVeh = parcelRequire("5TVeh");

var $iKUML = parcelRequire("iKUML");
var $4k52v = parcelRequire("4k52v");


var $ge3KO = parcelRequire("ge3KO");
"use client";
const $5bba81b801667431$var$_excluded = [
    "className",
    "component"
];
function $5bba81b801667431$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5TVeh.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $iKUML.default));
    const Box = /*#__PURE__*/ $f2Y41.forwardRef(function Box(inProps, ref) {
        const theme = (0, $e65a75724f3a2622$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $4k52v.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $bKcdJ.default)(_extendSxProp, $5bba81b801667431$var$_excluded);
        return /*#__PURE__*/ (0, $ge3KO.jsx)(BoxRoot, (0, $asN9r.default)({
            as: component,
            ref: ref,
            className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}







const $903153c32f78f019$var$boxClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiBox", [
    "root"
]);
var $903153c32f78f019$export$2e2bcd8739ae039 = $903153c32f78f019$var$boxClasses;


"use client";
const $a9eb786abed59b0f$var$defaultTheme = (0, $ce605d53bd47975e$export$2e2bcd8739ae039)();
const $a9eb786abed59b0f$var$Box = (0, $5bba81b801667431$export$2e2bcd8739ae039)({
    themeId: (0, $052d61a03cfc8b91$export$2e2bcd8739ae039),
    defaultTheme: $a9eb786abed59b0f$var$defaultTheme,
    defaultClassName: (0, $903153c32f78f019$export$2e2bcd8739ae039).root,
    generateClassName: (0, $2623c775f29c0462$export$2e2bcd8739ae039).generate
});
var $a9eb786abed59b0f$export$2e2bcd8739ae039 = $a9eb786abed59b0f$var$Box;




const $20e60525650ed0ec$export$8b0f8e71b71b7ed3 = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3);



const $e87e8a83fc996e91$export$2d14edd3a7db3bbf = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf);



var $ge3KO = parcelRequire("ge3KO");
const $b9240f4d981503e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "treeDataGroupingCell"
        ],
        toggle: [
            "treeDataGroupingCellToggle"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $b9240f4d981503e5$export$27e53dafb413f7b(props) {
    const { id: id, field: field, formattedValue: formattedValue, rowNode: rowNode, hideDescendantCount: hideDescendantCount, offsetMultiplier: offsetMultiplier = 2 } = props;
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $e87e8a83fc996e91$export$2d14edd3a7db3bbf)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $b9240f4d981503e5$var$useUtilityClasses(ownerState);
    const filteredDescendantCountLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$28e99d5260ff82e7));
    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;
    const Icon = rowNode.childrenExpanded ? rootProps.slots.treeDataCollapseIcon : rootProps.slots.treeDataExpandIcon;
    const handleClick = (event)=>{
        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation(); // TODO remove event.stopPropagation
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $a9eb786abed59b0f$export$2e2bcd8739ae039), {
        className: classes.root,
        sx: {
            ml: rowNode.depth * offsetMultiplier
        },
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: classes.toggle,
                children: filteredDescendantCount > 0 && /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
                    size: "small",
                    onClick: handleClick,
                    tabIndex: -1,
                    "aria-label": rowNode.childrenExpanded ? apiRef.current.getLocaleText("treeDataCollapse") : apiRef.current.getLocaleText("treeDataExpand")
                }, rootProps?.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, {
                        fontSize: "inherit"
                    })
                }))
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                children: [
                    formattedValue === undefined ? rowNode.groupingKey : formattedValue,
                    !hideDescendantCount && filteredDescendantCount > 0 ? ` (${filteredDescendantCount})` : ""
                ]
            })
        ]
    });
}






var $asN9r = parcelRequire("asN9r");

const $a7bfa75fe95f9574$export$d5e283255c81e0fd = (path)=>{
    const pathStr = path.map((groupingCriteria)=>`${groupingCriteria.field}/${groupingCriteria.key}`).join("-");
    return `auto-generated-row-${pathStr}`;
};
const $a7bfa75fe95f9574$export$abc1fabe591b697e = ({ id: id, tree: tree })=>{
    const path = [];
    let node = tree[id];
    while(node.id !== (0, $5a37f1a88e056eac$export$433b924dc2506913)){
        path.push({
            field: node.type === "leaf" ? null : node.groupingField,
            key: node.groupingKey
        });
        node = tree[node.parent];
    }
    path.reverse();
    return path;
};
const $a7bfa75fe95f9574$export$5ba8ca32800e0e56 = (node, defaultGroupingExpansionDepth, isGroupExpandedByDefault)=>{
    let childrenExpanded;
    if (node.id === (0, $5a37f1a88e056eac$export$433b924dc2506913)) childrenExpanded = true;
    else if (isGroupExpandedByDefault) childrenExpanded = isGroupExpandedByDefault(node);
    else childrenExpanded = defaultGroupingExpansionDepth === -1 || defaultGroupingExpansionDepth > node.depth;
    node.childrenExpanded = childrenExpanded;
    return node;
};
const $a7bfa75fe95f9574$export$e179dd88ba706b74 = (node, tree, treeDepths, previousTree)=>{
    // 1. Insert node in the tree.
    tree[node.id] = node;
    // 2. Increment the `treeDepths` object for the node's depth.
    treeDepths[node.depth] = (treeDepths[node.depth] ?? 0) + 1;
    // 3. Register the new node in its parent.
    const parentNode = tree[node.parent];
    if (node.type === "group" || node.type === "leaf") {
        // For groups and leaves,
        // Register the node from its parents `children` and `childrenFromPath` properties.
        const groupingFieldName = node.groupingField ?? "__no_field__";
        const groupingKeyName = node.groupingKey ?? "__no_key__";
        const groupingField = parentNode.childrenFromPath?.[groupingFieldName];
        if (previousTree !== null && previousTree[parentNode.id] === tree[parentNode.id]) parentNode.children = [
            ...parentNode.children,
            node.id
        ];
        else parentNode.children.push(node.id);
        if (groupingField == null) parentNode.childrenFromPath[groupingFieldName] = {
            [groupingKeyName.toString()]: node.id
        };
        else groupingField[groupingKeyName.toString()] = node.id;
    } else if (node.type === "footer") // For footers,
    // Register the node from its parent `footerId` property.
    parentNode.footerId = node.id;
};
const $a7bfa75fe95f9574$export$a0e1f1bcb4742ea5 = ({ node: node, tree: tree, treeDepths: treeDepths })=>{
    // 1. Remove node from the tree.
    delete tree[node.id];
    // 2. Decrement the `treeDepths` object for the node's depth.
    const nodeDepth = node.depth;
    const currentNodeCount = treeDepths[nodeDepth];
    if (currentNodeCount === 1) delete treeDepths[nodeDepth];
    else treeDepths[nodeDepth] = currentNodeCount - 1;
    // 3. Unregister the new node in its parent.
    const parentNode = tree[node.parent];
    // For footers,
    // Unregister the node from its parent `footerId` property.
    if (node.type === "footer") tree[parentNode.id] = (0, $asN9r.default)({}, parentNode, {
        footerId: null
    });
    else {
        const groupingField = node.groupingField ?? "__no_field__";
        const groupingKey = node.groupingKey ?? "__no_key__";
        // TODO rows v6: Can we avoid this linear complexity ?
        const children = parentNode.children.filter((childId)=>childId !== node.id);
        const childrenFromPath = parentNode.childrenFromPath;
        delete childrenFromPath[groupingField][groupingKey.toString()];
        tree[parentNode.id] = (0, $asN9r.default)({}, parentNode, {
            children: children,
            childrenFromPath: childrenFromPath
        });
    }
};
const $a7bfa75fe95f9574$export$8401d879c7fe4ac0 = ({ node: node, updatedNode: updatedNode, previousTree: previousTree, tree: tree, treeDepths: treeDepths })=>{
    // 1. Set the new parent for all children from the old group
    node.children.forEach((childId)=>{
        tree[childId] = (0, $asN9r.default)({}, tree[childId], {
            parent: updatedNode.id
        });
    });
    // 2. Remove the old group from the tree
    $a7bfa75fe95f9574$export$a0e1f1bcb4742ea5({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    // 3. Add the new group in the tree
    const groupNode = (0, $asN9r.default)({}, node, updatedNode);
    $a7bfa75fe95f9574$export$e179dd88ba706b74(groupNode, tree, treeDepths, previousTree);
};
const $a7bfa75fe95f9574$export$3978044dae9c217d = ()=>({
        value: {},
        addAction (groupId, action) {
            if (!this.value[groupId]) this.value[groupId] = {};
            this.value[groupId][action] = true;
        }
    });
const $a7bfa75fe95f9574$export$9cf22cc325f95ed4 = ({ tree: tree, filteredRowsLookup: filteredRowsLookup })=>{
    if (!filteredRowsLookup) return {};
    const visibleRowsLookup = {};
    const handleTreeNode = (node, areAncestorsExpanded)=>{
        const isPassingFiltering = filteredRowsLookup[node.id];
        if (node.type === "group") node.children.forEach((childId)=>{
            const childNode = tree[childId];
            handleTreeNode(childNode, areAncestorsExpanded && !!node.childrenExpanded);
        });
        visibleRowsLookup[node.id] = isPassingFiltering && areAncestorsExpanded;
        // TODO rows v6: Should we keep storing the visibility status of footer independently or rely on the group visibility in the selector ?
        if (node.type === "group" && node.footerId != null) visibleRowsLookup[node.footerId] = isPassingFiltering && areAncestorsExpanded && !!node.childrenExpanded;
    };
    const nodes = Object.values(tree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.depth === 0) handleTreeNode(node, true);
    }
    return visibleRowsLookup;
};


const $f0aa2832ef608ac4$export$8234f639803f3161 = ({ id: id, path: path, updatedGroupsManager: updatedGroupsManager, previousTree: previousTree, tree: tree, treeDepths: treeDepths, onDuplicatePath: onDuplicatePath, isGroupExpandedByDefault: isGroupExpandedByDefault, defaultGroupingExpansionDepth: defaultGroupingExpansionDepth })=>{
    let parentNodeId = (0, $5a37f1a88e056eac$export$433b924dc2506913);
    for(let depth = 0; depth < path.length; depth += 1){
        const { key: key, field: field } = path[depth];
        const fieldWithDefaultValue = field ?? "__no_field__";
        const keyWithDefaultValue = key ?? "__no_key__";
        const existingNodeIdWithPartialPath = tree[parentNodeId].childrenFromPath?.[fieldWithDefaultValue]?.[keyWithDefaultValue.toString()];
        // When we reach the last step of the path,
        // We need to create a node for the row passed to `insertNodeInTree`
        if (depth === path.length - 1) {
            // If no node matches the full path,
            // We create a leaf node for the data row.
            if (existingNodeIdWithPartialPath == null) {
                const leafNode = {
                    type: "leaf",
                    id: id,
                    depth: depth,
                    parent: parentNodeId,
                    groupingKey: key
                };
                updatedGroupsManager?.addAction(parentNodeId, "insertChildren");
                (0, $a7bfa75fe95f9574$export$e179dd88ba706b74)(leafNode, tree, treeDepths, previousTree);
            } else {
                const existingNodeWithPartialPath = tree[existingNodeIdWithPartialPath];
                // If we already have an auto-generated group matching the partial path,
                // We replace it with the node from of data row passed to `insertNodeInTree`
                if (existingNodeWithPartialPath.type === "group" && existingNodeWithPartialPath.isAutoGenerated) {
                    updatedGroupsManager?.addAction(parentNodeId, "removeChildren");
                    updatedGroupsManager?.addAction(parentNodeId, "insertChildren");
                    (0, $a7bfa75fe95f9574$export$8401d879c7fe4ac0)({
                        tree: tree,
                        previousTree: previousTree,
                        treeDepths: treeDepths,
                        node: existingNodeWithPartialPath,
                        updatedNode: {
                            id: id,
                            isAutoGenerated: false
                        }
                    });
                } else // If we have another row matching the partial path, then there is a duplicate in the dataset.
                // We warn the user and skip the current row.
                onDuplicatePath?.(existingNodeIdWithPartialPath, id, path);
            }
        } else if (existingNodeIdWithPartialPath == null) {
            const nodeId = (0, $a7bfa75fe95f9574$export$d5e283255c81e0fd)(path.slice(0, depth + 1));
            const autoGeneratedGroupNode = {
                type: "group",
                id: nodeId,
                parent: parentNodeId,
                depth: depth,
                isAutoGenerated: true,
                groupingKey: key,
                groupingField: field,
                children: [],
                childrenFromPath: {},
                childrenExpanded: false
            };
            updatedGroupsManager?.addAction(parentNodeId, "insertChildren");
            (0, $a7bfa75fe95f9574$export$e179dd88ba706b74)((0, $a7bfa75fe95f9574$export$5ba8ca32800e0e56)(autoGeneratedGroupNode, defaultGroupingExpansionDepth, isGroupExpandedByDefault), tree, treeDepths, previousTree);
            parentNodeId = nodeId;
        } else {
            const currentGroupNode = tree[existingNodeIdWithPartialPath];
            // If the node matching the partial path is not a group, we turn it into a group
            if (currentGroupNode.type !== "group") {
                const groupNode = {
                    type: "group",
                    id: currentGroupNode.id,
                    parent: currentGroupNode.parent,
                    depth: currentGroupNode.depth,
                    isAutoGenerated: false,
                    groupingKey: key,
                    groupingField: field,
                    children: [],
                    childrenFromPath: {},
                    childrenExpanded: false
                };
                tree[existingNodeIdWithPartialPath] = (0, $a7bfa75fe95f9574$export$5ba8ca32800e0e56)(groupNode, defaultGroupingExpansionDepth, isGroupExpandedByDefault);
            }
            parentNodeId = currentGroupNode.id;
        }
    }
};


const $95f4a1e4836114cf$export$230dd60fadcbc35b = (params)=>{
    const dataRowIds = [];
    const tree = {
        [(0, $5a37f1a88e056eac$export$433b924dc2506913)]: (0, $5a37f1a88e056eac$export$96a607054e9bfd0c)()
    };
    const treeDepths = {};
    for(let i = 0; i < params.nodes.length; i += 1){
        const node = params.nodes[i];
        dataRowIds.push(node.id);
        (0, $f0aa2832ef608ac4$export$8234f639803f3161)({
            tree: tree,
            previousTree: params.previousTree,
            id: node.id,
            path: node.path,
            onDuplicatePath: params.onDuplicatePath,
            treeDepths: treeDepths,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth
        });
    }
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds
    };
};



// Single-linked list node
class $5b04a9a66748171c$var$Node {
    constructor(data, next){
        this.next = void 0;
        this.data = void 0;
        this.next = next;
        this.data = data;
    }
    insertAfter(list) {
        if (!list.first || !list.last) return;
        const next = this.next;
        this.next = list.first;
        list.last.next = next;
    }
}
// Single-linked list container
class $5b04a9a66748171c$var$List {
    constructor(first, last){
        this.first = void 0;
        this.last = void 0;
        this.first = first;
        this.last = last;
    }
    data() {
        const array = [];
        this.forEach((node)=>{
            array.push(node.data);
        });
        return array;
    }
    forEach(fn) {
        let current = this.first;
        while(current !== null){
            fn(current);
            current = current.next;
        }
    }
    static from(array) {
        if (array.length === 0) return new $5b04a9a66748171c$var$List(null, null);
        let index = 0;
        const first = new $5b04a9a66748171c$var$Node(array[index], null);
        let current = first;
        while(index + 1 < array.length){
            index += 1;
            const node = new $5b04a9a66748171c$var$Node(array[index], null);
            current.next = node;
            current = node;
        }
        return new $5b04a9a66748171c$var$List(first, current);
    }
}
const $5b04a9a66748171c$export$3da49b8141c52d70 = (params)=>{
    const { rowTree: rowTree, disableChildrenSorting: disableChildrenSorting, sortRowList: sortRowList, shouldRenderGroupBelowLeaves: shouldRenderGroupBelowLeaves } = params;
    const sortedGroupedByParentRows = new Map();
    const sortGroup = (node)=>{
        const shouldSortGroup = !!sortRowList && (!disableChildrenSorting || node.depth === -1);
        let sortedRowIds;
        if (shouldSortGroup) {
            for(let i = 0; i < node.children.length; i += 1){
                const childNode = rowTree[node.children[i]];
                if (childNode.type === "group") sortGroup(childNode);
            }
            sortedRowIds = sortRowList(node.children.map((childId)=>rowTree[childId]));
        } else if (shouldRenderGroupBelowLeaves) {
            const childrenLeaves = [];
            const childrenGroups = [];
            for(let i = 0; i < node.children.length; i += 1){
                const childId = node.children[i];
                const childNode = rowTree[childId];
                if (childNode.type === "group") {
                    sortGroup(childNode);
                    childrenGroups.push(childId);
                } else if (childNode.type === "leaf") childrenLeaves.push(childId);
            }
            sortedRowIds = [
                ...childrenLeaves,
                ...childrenGroups
            ];
        } else {
            for(let i = 0; i < node.children.length; i += 1){
                const childNode = rowTree[node.children[i]];
                if (childNode.type === "group") sortGroup(childNode);
            }
            sortedRowIds = [
                ...node.children
            ];
        }
        if (node.footerId != null) sortedRowIds.push(node.footerId);
        sortedGroupedByParentRows.set(node.id, sortedRowIds);
    };
    sortGroup(rowTree[0, $5a37f1a88e056eac$export$433b924dc2506913]);
    const rootList = $5b04a9a66748171c$var$List.from(sortedGroupedByParentRows.get((0, $5a37f1a88e056eac$export$433b924dc2506913)));
    rootList.forEach((node)=>{
        const children = sortedGroupedByParentRows.get(node.data);
        if (children?.length) node.insertAfter($5b04a9a66748171c$var$List.from(children));
    });
    return rootList.data();
};



var $asN9r = parcelRequire("asN9r");





const $f0b7477c1d983199$var$removeNodeAndCleanParent = ({ node: node, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    (0, $a7bfa75fe95f9574$export$a0e1f1bcb4742ea5)({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    if (node.type === "group" && node.footerId != null) (0, $a7bfa75fe95f9574$export$a0e1f1bcb4742ea5)({
        node: tree[node.footerId],
        tree: tree,
        treeDepths: treeDepths
    });
    const parentNode = tree[node.parent];
    updatedGroupsManager?.addAction(parentNode.id, "removeChildren");
    const shouldDeleteGroup = parentNode.id !== (0, $5a37f1a88e056eac$export$433b924dc2506913) && parentNode.children.length === 0;
    if (shouldDeleteGroup) {
        if (parentNode.isAutoGenerated) $f0b7477c1d983199$var$removeNodeAndCleanParent({
            node: parentNode,
            tree: tree,
            treeDepths: treeDepths
        });
        else tree[parentNode.id] = {
            type: "leaf",
            id: parentNode.id,
            depth: parentNode.depth,
            parent: parentNode.parent,
            groupingKey: parentNode.groupingKey
        };
    }
};
const $f0b7477c1d983199$var$replaceDataGroupWithAutoGeneratedGroup = ({ node: node, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    updatedGroupsManager?.addAction(node.parent, "removeChildren");
    updatedGroupsManager?.addAction(node.parent, "insertChildren");
    (0, $a7bfa75fe95f9574$export$8401d879c7fe4ac0)({
        previousTree: null,
        tree: tree,
        treeDepths: treeDepths,
        node: node,
        updatedNode: {
            id: (0, $a7bfa75fe95f9574$export$d5e283255c81e0fd)((0, $a7bfa75fe95f9574$export$abc1fabe591b697e)({
                id: node.id,
                tree: tree
            })),
            isAutoGenerated: true
        }
    });
};
const $f0b7477c1d983199$export$cf388a54c0cc8532 = ({ id: id, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    const node = tree[id];
    if (node.type === "group" && node.children.length > 0) $f0b7477c1d983199$var$replaceDataGroupWithAutoGeneratedGroup({
        node: node,
        tree: tree,
        treeDepths: treeDepths,
        updatedGroupsManager: updatedGroupsManager
    });
    else $f0b7477c1d983199$var$removeNodeAndCleanParent({
        node: node,
        tree: tree,
        treeDepths: treeDepths,
        updatedGroupsManager: updatedGroupsManager
    });
};



const $cf247ce349fec34c$export$95db6bdce2927ab = (params)=>{
    const tree = (0, $asN9r.default)({}, params.previousTree);
    const treeDepths = (0, $asN9r.default)({}, params.previousTreeDepth);
    const updatedGroupsManager = (0, $a7bfa75fe95f9574$export$3978044dae9c217d)();
    for(let i = 0; i < params.nodes.inserted.length; i += 1){
        const { id: id, path: path } = params.nodes.inserted[i];
        (0, $f0aa2832ef608ac4$export$8234f639803f3161)({
            previousTree: params.previousTree,
            tree: tree,
            treeDepths: treeDepths,
            updatedGroupsManager: updatedGroupsManager,
            id: id,
            path: path,
            onDuplicatePath: params.onDuplicatePath,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth
        });
    }
    for(let i = 0; i < params.nodes.removed.length; i += 1){
        const nodeId = params.nodes.removed[i];
        (0, $f0b7477c1d983199$export$cf388a54c0cc8532)({
            tree: tree,
            treeDepths: treeDepths,
            updatedGroupsManager: updatedGroupsManager,
            id: nodeId
        });
    }
    for(let i = 0; i < params.nodes.modified.length; i += 1){
        const { id: id, path: path } = params.nodes.modified[i];
        const pathInPreviousTree = (0, $a7bfa75fe95f9574$export$abc1fabe591b697e)({
            tree: tree,
            id: id
        });
        const isInSameGroup = (0, $2b59f632c4f96fc9$export$78fdc9adc3f30400)(pathInPreviousTree, path);
        if (!isInSameGroup) {
            (0, $f0b7477c1d983199$export$cf388a54c0cc8532)({
                tree: tree,
                treeDepths: treeDepths,
                updatedGroupsManager: updatedGroupsManager,
                id: id
            });
            (0, $f0aa2832ef608ac4$export$8234f639803f3161)({
                previousTree: params.previousTree,
                tree: tree,
                treeDepths: treeDepths,
                updatedGroupsManager: updatedGroupsManager,
                id: id,
                path: path,
                onDuplicatePath: params.onDuplicatePath,
                isGroupExpandedByDefault: params.isGroupExpandedByDefault,
                defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth
            });
        } else updatedGroupsManager?.addAction(tree[id].parent, "modifyChildren");
    }
    // TODO rows v6: Avoid walking the whole tree, we should be able to generate the new list only using slices.
    const dataRowIds = (0, $5a37f1a88e056eac$export$9380f4bcafb87e49)(tree, (0, $5a37f1a88e056eac$export$433b924dc2506913), true);
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds,
        updatedGroupsManager: updatedGroupsManager
    };
};




var $ge3KO = parcelRequire("ge3KO");
const $e48dc7017e7bfdef$var$_excluded = [
    "hideDescendantCount"
];
const $e48dc7017e7bfdef$export$7e966b04a1d3262a = (privateApiRef, props)=>{
    const setStrategyAvailability = $f2Y41.useCallback(()=>{
        privateApiRef.current.setStrategyAvailability("rowTree", (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc), props.treeData ? ()=>true : ()=>false);
    }, [
        privateApiRef,
        props.treeData
    ]);
    const getGroupingColDef = $f2Y41.useCallback(()=>{
        const groupingColDefProp = props.groupingColDef;
        let colDefOverride;
        if (typeof groupingColDefProp === "function") {
            const params = {
                groupingName: (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc),
                fields: []
            };
            colDefOverride = groupingColDefProp(params);
        } else colDefOverride = groupingColDefProp;
        const _ref = colDefOverride ?? {}, { hideDescendantCount: hideDescendantCount } = _ref, colDefOverrideProperties = (0, $bKcdJ.default)(_ref, $e48dc7017e7bfdef$var$_excluded);
        const commonProperties = (0, $asN9r.default)({}, (0, $407212466300a479$export$eed79627d7deb3a5), {
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $b9240f4d981503e5$export$27e53dafb413f7b), (0, $asN9r.default)({}, params, {
                    hideDescendantCount: hideDescendantCount
                })),
            headerName: privateApiRef.current.getLocaleText("treeDataGroupingHeaderName")
        });
        return (0, $asN9r.default)({}, commonProperties, colDefOverrideProperties, (0, $407212466300a479$export$1a0175c947f58fd3));
    }, [
        privateApiRef,
        props.groupingColDef
    ]);
    const updateGroupingColumn = $f2Y41.useCallback((columnsState)=>{
        const groupingColDefField = (0, $407212466300a479$export$1a0175c947f58fd3).field;
        const shouldHaveGroupingColumn = props.treeData;
        const prevGroupingColumn = columnsState.lookup[groupingColDefField];
        if (shouldHaveGroupingColumn) {
            const newGroupingColumn = getGroupingColDef();
            if (prevGroupingColumn) {
                newGroupingColumn.width = prevGroupingColumn.width;
                newGroupingColumn.flex = prevGroupingColumn.flex;
            }
            columnsState.lookup[groupingColDefField] = newGroupingColumn;
            if (prevGroupingColumn == null) {
                const index = columnsState.orderedFields[0] === (0, $a75f25e717ae3a15$export$322dfed7a1df1b02) ? 1 : 0;
                columnsState.orderedFields = [
                    ...columnsState.orderedFields.slice(0, index),
                    groupingColDefField,
                    ...columnsState.orderedFields.slice(index)
                ];
            }
        } else if (!shouldHaveGroupingColumn && prevGroupingColumn) {
            delete columnsState.lookup[groupingColDefField];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== groupingColDefField);
        }
        return columnsState;
    }, [
        props.treeData,
        getGroupingColDef
    ]);
    const createRowTreeForTreeData = $f2Y41.useCallback((params)=>{
        if (!props.getTreeDataPath) throw new Error("MUI X: No getTreeDataPath given.");
        const getRowTreeBuilderNode = (rowId)=>({
                id: rowId,
                path: props.getTreeDataPath(params.dataRowIdToModelLookup[rowId]).map((key)=>({
                        key: key,
                        field: null
                    }))
            });
        const onDuplicatePath = (firstId, secondId, path)=>{
            throw new Error([
                "MUI X: The path returned by `getTreeDataPath` should be unique.",
                `The rows with id #${firstId} and #${secondId} have the same.`,
                `Path: ${JSON.stringify(path.map((step)=>step.key))}.`
            ].join("\n"));
        };
        if (params.updates.type === "full") return (0, $95f4a1e4836114cf$export$230dd60fadcbc35b)({
            previousTree: params.previousTree,
            nodes: params.updates.rows.map(getRowTreeBuilderNode),
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc),
            onDuplicatePath: onDuplicatePath
        });
        return (0, $cf247ce349fec34c$export$95db6bdce2927ab)({
            nodes: {
                inserted: params.updates.actions.insert.map(getRowTreeBuilderNode),
                modified: params.updates.actions.modify.map(getRowTreeBuilderNode),
                removed: params.updates.actions.remove
            },
            previousTree: params.previousTree,
            previousTreeDepth: params.previousTreeDepths,
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc)
        });
    }, [
        props.getTreeDataPath,
        props.defaultGroupingExpansionDepth,
        props.isGroupExpandedByDefault
    ]);
    const filterRows = $f2Y41.useCallback((params)=>{
        const rowTree = (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(privateApiRef);
        return (0, $768fdf0fcba13748$export$d431177e37819461)({
            rowTree: rowTree,
            isRowMatchingFilters: params.isRowMatchingFilters,
            disableChildrenFiltering: props.disableChildrenFiltering,
            filterModel: params.filterModel,
            apiRef: privateApiRef
        });
    }, [
        privateApiRef,
        props.disableChildrenFiltering
    ]);
    const sortRows = $f2Y41.useCallback((params)=>{
        const rowTree = (0, $b2a98a8b3d22f914$export$de9a43d646a9821d)(privateApiRef);
        return (0, $5b04a9a66748171c$export$3da49b8141c52d70)({
            rowTree: rowTree,
            sortRowList: params.sortRowList,
            disableChildrenSorting: props.disableChildrenSorting,
            shouldRenderGroupBelowLeaves: false
        });
    }, [
        privateApiRef,
        props.disableChildrenSorting
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(privateApiRef, "hydrateColumns", updateGroupingColumn);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(privateApiRef, (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc), "rowTreeCreation", createRowTreeForTreeData);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(privateApiRef, (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc), "filtering", filterRows);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(privateApiRef, (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc), "sorting", sortRows);
    (0, $8a18de3db597e0e0$export$102a3f5a042c47c4)(privateApiRef, (0, $768fdf0fcba13748$export$6bd6c3ee4fcd23bc), "visibleRowsLookupCreation", (0, $a7bfa75fe95f9574$export$9cf22cc325f95ed4));
    /**
   * 1ST RENDER
   */ (0, $f9629e0497ea16d6$export$c5623aa1c38918b6)(()=>{
        setStrategyAvailability();
    });
    /**
   * EFFECTS
   */ const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (!isFirstRender.current) setStrategyAvailability();
        else isFirstRender.current = false;
    }, [
        setStrategyAvailability
    ]);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


const $1d569a482003f0fb$export$5fee0234a63f3519 = (state, props, apiRef)=>{
    apiRef.current.caches.columnPinning = {
        orderedFieldsBeforePinningColumns: null
    };
    let model;
    if (props.pinnedColumns) model = props.pinnedColumns;
    else if (props.initialState?.pinnedColumns) model = props.initialState.pinnedColumns;
    else model = {};
    return (0, $asN9r.default)({}, state, {
        pinnedColumns: model
    });
};
const $1d569a482003f0fb$export$2534ab700dd48c29 = (apiRef, props)=>{
    const pinnedColumns = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$1eea0bd4db853467));
    /**
   * PRE-PROCESSING
   */ const calculateScrollLeft = $f2Y41.useCallback((initialValue, params)=>{
        const visiblePinnedColumns = (0, $b22d10f7b8994eba$export$297e8079713afa11)(apiRef);
        if (!params.colIndex || visiblePinnedColumns.left.length === 0 && visiblePinnedColumns.right.length === 0) return initialValue;
        const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
        const columnsTotalWidth = (0, $b22d10f7b8994eba$export$ab20f9d33edc7794)(apiRef);
        const columnPositions = (0, $b22d10f7b8994eba$export$fce7d810e48021e3)(apiRef);
        const clientWidth = apiRef.current.virtualScrollerRef.current.clientWidth;
        // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
        const scrollLeft = Math.abs(apiRef.current.virtualScrollerRef.current.scrollLeft);
        const offsetWidth = visibleColumns[params.colIndex].computedWidth;
        const offsetLeft = columnPositions[params.colIndex];
        const leftPinnedColumnsWidth = columnPositions[visiblePinnedColumns.left.length];
        const rightPinnedColumnsWidth = columnsTotalWidth - columnPositions[columnPositions.length - visiblePinnedColumns.right.length];
        const elementBottom = offsetLeft + offsetWidth;
        if (elementBottom - (clientWidth - rightPinnedColumnsWidth) > scrollLeft) {
            const left = elementBottom - (clientWidth - rightPinnedColumnsWidth);
            return (0, $asN9r.default)({}, initialValue, {
                left: left
            });
        }
        if (offsetLeft < scrollLeft + leftPinnedColumnsWidth) {
            const left = offsetLeft - leftPinnedColumnsWidth;
            return (0, $asN9r.default)({}, initialValue, {
                left: left
            });
        }
        return initialValue;
    }, [
        apiRef
    ]);
    const addColumnMenuItems = $f2Y41.useCallback((columnMenuItems, colDef)=>{
        if (props.disableColumnPinning) return columnMenuItems;
        if (colDef.pinnable === false) return columnMenuItems;
        return [
            ...columnMenuItems,
            "columnMenuPinningItem"
        ];
    }, [
        props.disableColumnPinning
    ]);
    const checkIfCanBeReordered = $f2Y41.useCallback((initialValue, { targetIndex: targetIndex })=>{
        const visiblePinnedColumns = (0, $b22d10f7b8994eba$export$297e8079713afa11)(apiRef);
        if (visiblePinnedColumns.left.length === 0 && visiblePinnedColumns.right.length === 0) return initialValue;
        if (visiblePinnedColumns.left.length > 0 && targetIndex < visiblePinnedColumns.left.length) return false;
        if (visiblePinnedColumns.right.length > 0) {
            const visibleColumns = (0, $b22d10f7b8994eba$export$16a65a9447d3dda9)(apiRef);
            const firstRightPinnedColumnIndex = visibleColumns.length - visiblePinnedColumns.right.length;
            return targetIndex >= firstRightPinnedColumnIndex ? false : initialValue;
        }
        return initialValue;
    }, [
        apiRef
    ]);
    const stateExportPreProcessing = $f2Y41.useCallback((prevState, context)=>{
        const pinnedColumnsToExport = (0, $b22d10f7b8994eba$export$1eea0bd4db853467)(apiRef.current.state);
        const shouldExportPinnedColumns = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.pinnedColumns != null || // Always export if the model has been initialized
        props.initialState?.pinnedColumns != null || // Export if the model is not empty
        (pinnedColumnsToExport.left ?? []).length > 0 || (pinnedColumnsToExport.right ?? []).length > 0;
        if (!shouldExportPinnedColumns) return prevState;
        return (0, $asN9r.default)({}, prevState, {
            pinnedColumns: pinnedColumnsToExport
        });
    }, [
        apiRef,
        props.pinnedColumns,
        props.initialState?.pinnedColumns
    ]);
    const stateRestorePreProcessing = $f2Y41.useCallback((params, context)=>{
        const newPinnedColumns = context.stateToRestore.pinnedColumns;
        if (newPinnedColumns != null) $1d569a482003f0fb$var$setState(apiRef, newPinnedColumns);
        return params;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "scrollToIndexes", calculateScrollLeft);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "columnMenu", addColumnMenuItems);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "canBeReordered", checkIfCanBeReordered);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "exportState", stateExportPreProcessing);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "restoreState", stateRestorePreProcessing);
    apiRef.current.registerControlState({
        stateId: "pinnedColumns",
        propModel: props.pinnedColumns,
        propOnChange: props.onPinnedColumnsChange,
        stateSelector: (0, $b22d10f7b8994eba$export$1eea0bd4db853467),
        changeEvent: "pinnedColumnsChange"
    });
    const pinColumn = $f2Y41.useCallback((field, side)=>{
        if (apiRef.current.isColumnPinned(field) === side) return;
        const otherSide = side === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT ? (0, $49d1610712424e75$export$64f54b460f67389c).LEFT : (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT;
        const newPinnedColumns = {
            [side]: [
                ...pinnedColumns[side] || [],
                field
            ],
            [otherSide]: (pinnedColumns[otherSide] || []).filter((column)=>column !== field)
        };
        apiRef.current.setPinnedColumns(newPinnedColumns);
    }, [
        apiRef,
        pinnedColumns
    ]);
    const unpinColumn = $f2Y41.useCallback((field)=>{
        apiRef.current.setPinnedColumns({
            left: (pinnedColumns.left || []).filter((column)=>column !== field),
            right: (pinnedColumns.right || []).filter((column)=>column !== field)
        });
    }, [
        apiRef,
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const getPinnedColumns = $f2Y41.useCallback(()=>{
        return (0, $b22d10f7b8994eba$export$1eea0bd4db853467)(apiRef.current.state);
    }, [
        apiRef
    ]);
    const setPinnedColumns = $f2Y41.useCallback((newPinnedColumns)=>{
        $1d569a482003f0fb$var$setState(apiRef, newPinnedColumns);
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const isColumnPinned = $f2Y41.useCallback((field)=>{
        const leftPinnedColumns = pinnedColumns.left || [];
        if (leftPinnedColumns.includes(field)) return (0, $49d1610712424e75$export$64f54b460f67389c).LEFT;
        const rightPinnedColumns = pinnedColumns.right || [];
        if (rightPinnedColumns.includes(field)) return (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT;
        return false;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const columnPinningApi = {
        pinColumn: pinColumn,
        unpinColumn: unpinColumn,
        getPinnedColumns: getPinnedColumns,
        setPinnedColumns: setPinnedColumns,
        isColumnPinned: isColumnPinned
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, columnPinningApi, "public");
    const handleColumnOrderChange = (params)=>{
        if (!apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns) return;
        const { column: column, targetIndex: targetIndex, oldIndex: oldIndex } = params;
        const delta = targetIndex > oldIndex ? 1 : -1;
        const latestColumnFields = (0, $b22d10f7b8994eba$export$d8a3dfbb129c80db)(apiRef);
        /**
     * When a column X is reordered to somewhere else, the position where this column X is dropped
     * on must be moved to left or right to make room for it. The ^^^ below represents the column
     * which gave space to receive X.
     *
     * | X | B | C | D | -> | B | C | D | X | (for example X moved to after D, so delta=1)
     *              ^^^              ^^^
     *
     * | A | B | C | X | -> | X | A | B | C | (for example X moved before A, so delta=-1)
     *  ^^^                      ^^^
     *
     * If column P is pinned, it will not move to provide space. However, it will jump to the next
     * non-pinned column.
     *
     * | X | B | P | D | -> | B | D | P | X | (for example X moved to after D, with P pinned)
     *              ^^^          ^^^
     */ const siblingField = latestColumnFields[targetIndex - delta];
        const newOrderedFieldsBeforePinningColumns = [
            ...apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns
        ];
        // The index to start swapping fields
        let i = newOrderedFieldsBeforePinningColumns.findIndex((currentColumn)=>currentColumn === column.field);
        // The index of the field to swap with
        let j = i + delta;
        // When to stop swapping fields.
        // We stop one field before because the swap is done with i + 1 (if delta=1)
        const stop = newOrderedFieldsBeforePinningColumns.findIndex((currentColumn)=>currentColumn === siblingField);
        while(delta > 0 ? i < stop : i > stop){
            // If the field to swap with is a pinned column, jump to the next
            while(apiRef.current.isColumnPinned(newOrderedFieldsBeforePinningColumns[j]))j += delta;
            const temp = newOrderedFieldsBeforePinningColumns[i];
            newOrderedFieldsBeforePinningColumns[i] = newOrderedFieldsBeforePinningColumns[j];
            newOrderedFieldsBeforePinningColumns[j] = temp;
            i = j;
            j = i + delta;
        }
        apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
    };
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "columnOrderChange", handleColumnOrderChange);
    $f2Y41.useEffect(()=>{
        if (props.pinnedColumns) apiRef.current.setPinnedColumns(props.pinnedColumns);
    }, [
        apiRef,
        props.pinnedColumns
    ]);
};
function $1d569a482003f0fb$var$setState(apiRef, model) {
    apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
            pinnedColumns: model
        }));
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");

const $47a8c11a1e3a7632$export$47a2167ef2ac089d = (apiRef, props)=>{
    const { disableColumnPinning: disableColumnPinning } = props;
    let pinnedColumns;
    if (apiRef.current.state.columns) pinnedColumns = (0, $b22d10f7b8994eba$export$1eea0bd4db853467)(apiRef.current.state);
    else pinnedColumns = null;
    const prevAllPinnedColumns = $f2Y41.useRef([]);
    const reorderPinnedColumns = $f2Y41.useCallback((columnsState)=>{
        (0, $2b59f632c4f96fc9$export$ec5767fa5c351320)(pinnedColumns);
        if (columnsState.orderedFields.length === 0 || disableColumnPinning) return columnsState;
        // HACK: This is a hack needed because the pipe processors aren't pure enough. What
        // they should be is `gridState -> gridState` transformers, but they only transform a slice
        // of the state, not the full state. So if they need access to other parts of the state (like
        // the `state.columns.orderedFields` in this case), they might lag behind because the selectors
        // are selecting the old state in `apiRef`, not the state being computed in the current pipe processor.
        const savedState = apiRef.current.state;
        apiRef.current.state = (0, $asN9r.default)({}, savedState, {
            columns: columnsState
        });
        const visibleColumns = (0, $b22d10f7b8994eba$export$297e8079713afa11)(apiRef);
        apiRef.current.state = savedState;
        // HACK: Ends here //
        const leftPinnedColumns = visibleColumns.left.map((c)=>c.field);
        const rightPinnedColumns = visibleColumns.right.map((c)=>c.field);
        let newOrderedFields;
        const allPinnedColumns = [
            ...leftPinnedColumns,
            ...rightPinnedColumns
        ];
        const { orderedFieldsBeforePinningColumns: orderedFieldsBeforePinningColumns } = apiRef.current.caches.columnPinning;
        if (orderedFieldsBeforePinningColumns) {
            newOrderedFields = new Array(columnsState.orderedFields.length).fill(null);
            const newOrderedFieldsBeforePinningColumns = [
                ...newOrderedFields
            ];
            // Contains the fields not added to the orderedFields array yet
            const remainingFields = [
                ...columnsState.orderedFields
            ];
            // First, we check if the column was unpinned since the last processing.
            // If yes and it still exists, we move it back to the same position it was before pinning
            prevAllPinnedColumns.current.forEach((field)=>{
                if (!allPinnedColumns.includes(field) && columnsState.lookup[field]) {
                    // Get the position before pinning
                    const index = orderedFieldsBeforePinningColumns.indexOf(field);
                    newOrderedFields[index] = field;
                    newOrderedFieldsBeforePinningColumns[index] = field;
                    // This field was already consumed so we prevent from being added again
                    remainingFields.splice(remainingFields.indexOf(field), 1);
                }
            });
            // For columns still pinned, we keep stored their original positions
            allPinnedColumns.forEach((field)=>{
                let index = orderedFieldsBeforePinningColumns.indexOf(field);
                // If index = -1, the pinned field didn't exist in the last processing, it's possibly being added now
                // If index >= newOrderedFieldsBeforePinningColumns.length, then one or more columns were removed
                // In both cases, use the position from the columns array
                // TODO: detect removed columns and decrease the positions after it
                if (index === -1 || index >= newOrderedFieldsBeforePinningColumns.length) index = columnsState.orderedFields.indexOf(field);
                // The fallback above may make the column to be inserted in a position already occupied
                // In this case, put it in any empty slot available
                if (newOrderedFieldsBeforePinningColumns[index] !== null) {
                    index = 0;
                    while(newOrderedFieldsBeforePinningColumns[index] !== null)index += 1;
                }
                newOrderedFields[index] = field;
                newOrderedFieldsBeforePinningColumns[index] = field;
                // This field was already consumed so we prevent from being added again
                remainingFields.splice(remainingFields.indexOf(field), 1);
            });
            // The fields remaining are those that're neither pinnned nor were unpinned
            // For these, we spread them across both arrays making sure to not override existing values
            let i = 0;
            remainingFields.forEach((field)=>{
                while(newOrderedFieldsBeforePinningColumns[i] !== null)i += 1;
                newOrderedFieldsBeforePinningColumns[i] = field;
                newOrderedFields[i] = field;
            });
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
        } else {
            newOrderedFields = [
                ...columnsState.orderedFields
            ];
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = [
                ...columnsState.orderedFields
            ];
        }
        prevAllPinnedColumns.current = allPinnedColumns;
        const centerColumns = newOrderedFields.filter((field)=>{
            return !leftPinnedColumns.includes(field) && !rightPinnedColumns.includes(field);
        });
        return (0, $asN9r.default)({}, columnsState, {
            orderedFields: [
                ...leftPinnedColumns,
                ...centerColumns,
                ...rightPinnedColumns
            ]
        });
    }, [
        apiRef,
        disableColumnPinning,
        pinnedColumns
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "hydrateColumns", reorderPinnedColumns);
    const isColumnPinned = $f2Y41.useCallback((initialValue, field)=>apiRef.current.isColumnPinned(field), [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "isColumnPinned", isColumnPinned);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");






const $e5450c6ab5b66c44$export$2e51858b6eeff6ad = (state)=>state.detailPanel.expandedRowIds;
const $e5450c6ab5b66c44$export$16fba932632c70f0 = (state)=>state.detailPanel.contentCache;
const $e5450c6ab5b66c44$export$3a5feeef4c4a2bdc = (state)=>state.detailPanel.heightCache;
const $e5450c6ab5b66c44$export$f8466bb36c8b9813 = (0, $a8687ecb01faf148$export$2a3ca4704a61d1f4)($e5450c6ab5b66c44$export$3a5feeef4c4a2bdc, (heightCache)=>Object.entries(heightCache).reduce((acc, [id, { height: height }])=>{
        acc[id] = height || 0;
        return acc;
    }, {}));



var $ge3KO = parcelRequire("ge3KO");
const $137eb2df1a3471d6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isExpanded: isExpanded } = ownerState;
    const slots = {
        root: [
            "detailPanelToggleCell",
            isExpanded && "detailPanelToggleCell--expanded"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $137eb2df1a3471d6$export$817e5e2e8d6c93c(props) {
    const { id: id, value: isExpanded } = props;
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $e87e8a83fc996e91$export$2d14edd3a7db3bbf)();
    const ownerState = {
        classes: rootProps.classes,
        isExpanded: isExpanded
    };
    const classes = $137eb2df1a3471d6$var$useUtilityClasses(ownerState);
    const contentCache = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $e5450c6ab5b66c44$export$16fba932632c70f0));
    const hasContent = /*#__PURE__*/ $f2Y41.isValidElement(contentCache[id]);
    const Icon = isExpanded ? rootProps.slots.detailPanelCollapseIcon : rootProps.slots.detailPanelExpandIcon;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
        size: "small",
        tabIndex: -1,
        disabled: !hasContent,
        className: classes.root,
        "aria-label": isExpanded ? apiRef.current.getLocaleText("collapseDetailPanel") : apiRef.current.getLocaleText("expandDetailPanel")
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, {
            fontSize: "inherit"
        })
    }));
}




var $ge3KO = parcelRequire("ge3KO");
const $92eac178c0288cb2$export$6e5a576305a34719 = "__detail_panel_toggle__";
const $92eac178c0288cb2$export$cea0a90b26fb973d = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "custom",
    field: $92eac178c0288cb2$export$6e5a576305a34719,
    editable: false,
    sortable: false,
    filterable: false,
    resizable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    align: "left",
    width: 40,
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = apiRef.current.getRowId(row);
        const expandedRowIds = (0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad)(apiRef.current.state);
        return expandedRowIds.includes(rowId);
    },
    renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $137eb2df1a3471d6$export$817e5e2e8d6c93c), (0, $asN9r.default)({}, params)),
    renderHeader: ()=>null
});



const $370c4d15c799c127$export$c6a1049ecc0f594c = (state, props)=>{
    return (0, $asN9r.default)({}, state, {
        detailPanel: {
            heightCache: {},
            expandedRowIds: props.detailPanelExpandedRowIds ?? props.initialState?.detailPanel?.expandedRowIds ?? []
        }
    });
};
function $370c4d15c799c127$var$cacheContentAndHeight(apiRef, getDetailPanelContent, getDetailPanelHeight, previousHeightCache) {
    if (typeof getDetailPanelContent !== "function") return {};
    // TODO change to lazy approach using a Proxy
    // only call getDetailPanelContent when asked for an id
    const rowIds = (0, $b2a98a8b3d22f914$export$c7dcaab5e573753)(apiRef);
    const contentCache = rowIds.reduce((acc, id)=>{
        const params = apiRef.current.getRowParams(id);
        acc[id] = getDetailPanelContent(params);
        return acc;
    }, {});
    const heightCache = rowIds.reduce((acc, id)=>{
        if (contentCache[id] == null) return acc;
        const params = apiRef.current.getRowParams(id);
        const height = getDetailPanelHeight(params);
        const autoHeight = height === "auto";
        acc[id] = {
            autoHeight: autoHeight,
            height: autoHeight ? previousHeightCache[id]?.height : height
        };
        return acc;
    }, {});
    return {
        contentCache: contentCache,
        heightCache: heightCache
    };
}
const $370c4d15c799c127$export$b71d7525fdd57704 = (apiRef, props)=>{
    const expandedRowIds = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad));
    const contentCache = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $e5450c6ab5b66c44$export$16fba932632c70f0));
    const handleCellClick = $f2Y41.useCallback((params, event)=>{
        if (params.field !== (0, $92eac178c0288cb2$export$6e5a576305a34719) || props.getDetailPanelContent == null) return;
        const content = contentCache[params.id];
        if (!/*#__PURE__*/ $f2Y41.isValidElement(content)) return;
        // Ignore if the user didn't click specifically in the "i" button
        if (event.target === event.currentTarget) return;
        apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    const handleCellKeyDown = $f2Y41.useCallback((params, event)=>{
        if (props.getDetailPanelContent == null) return;
        if (params.field === (0, $92eac178c0288cb2$export$6e5a576305a34719) && event.key === " ") apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        props.getDetailPanelContent
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellClick", handleCellClick);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellKeyDown", handleCellKeyDown);
    apiRef.current.registerControlState({
        stateId: "detailPanels",
        propModel: props.detailPanelExpandedRowIds,
        propOnChange: props.onDetailPanelExpandedRowIdsChange,
        stateSelector: (0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad),
        changeEvent: "detailPanelsExpandedRowIdsChange"
    });
    const toggleDetailPanel = $f2Y41.useCallback((id)=>{
        if (props.getDetailPanelContent == null) return;
        const content = contentCache[id];
        if (!/*#__PURE__*/ $f2Y41.isValidElement(content)) return;
        const ids = apiRef.current.getExpandedDetailPanels();
        apiRef.current.setExpandedDetailPanels(ids.includes(id) ? ids.filter((rowId)=>rowId !== id) : [
            ...ids,
            id
        ]);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    const getExpandedDetailPanels = $f2Y41.useCallback(()=>(0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad)(apiRef.current.state), [
        apiRef
    ]);
    const setExpandedDetailPanels = $f2Y41.useCallback((ids)=>{
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                detailPanel: (0, $asN9r.default)({}, state.detailPanel, {
                    expandedRowIds: ids
                })
            });
        });
        apiRef.current.updateDimensions();
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const storeDetailPanelHeight = $f2Y41.useCallback((id, height)=>{
        const heightCache = (0, $e5450c6ab5b66c44$export$3a5feeef4c4a2bdc)(apiRef.current.state);
        if (!heightCache[id] || heightCache[id].height === height) return;
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                detailPanel: (0, $asN9r.default)({}, state.detailPanel, {
                    heightCache: (0, $asN9r.default)({}, heightCache, {
                        [id]: (0, $asN9r.default)({}, heightCache[id], {
                            height: height
                        })
                    })
                })
            });
        });
        apiRef.current.updateDimensions();
        apiRef.current.requestPipeProcessorsApplication("rowHeight");
    }, [
        apiRef
    ]);
    const detailPanelHasAutoHeight = $f2Y41.useCallback((id)=>{
        const heightCache = (0, $e5450c6ab5b66c44$export$3a5feeef4c4a2bdc)(apiRef.current.state);
        return heightCache[id] ? heightCache[id].autoHeight : false;
    }, [
        apiRef
    ]);
    const detailPanelPubicApi = {
        toggleDetailPanel: toggleDetailPanel,
        getExpandedDetailPanels: getExpandedDetailPanels,
        setExpandedDetailPanels: setExpandedDetailPanels
    };
    const detailPanelPrivateApi = {
        storeDetailPanelHeight: storeDetailPanelHeight,
        detailPanelHasAutoHeight: detailPanelHasAutoHeight
    };
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, detailPanelPubicApi, "public");
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, detailPanelPrivateApi, "private");
    $f2Y41.useEffect(()=>{
        if (props.detailPanelExpandedRowIds) {
            const currentModel = (0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad)(apiRef.current.state);
            if (currentModel !== props.detailPanelExpandedRowIds) apiRef.current.setExpandedDetailPanels(props.detailPanelExpandedRowIds);
        }
    }, [
        apiRef,
        props.detailPanelExpandedRowIds
    ]);
    const updateCachesAndForceUpdate = $f2Y41.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                detailPanel: (0, $asN9r.default)({}, state.detailPanel, $370c4d15c799c127$var$cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        apiRef.current.updateDimensions?.();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "sortedRowsSet", updateCachesAndForceUpdate);
    const previousGetDetailPanelContentProp = $f2Y41.useRef();
    const previousGetDetailPanelHeightProp = $f2Y41.useRef();
    const updateCachesIfNeeded = $f2Y41.useCallback(()=>{
        if (props.getDetailPanelContent === previousGetDetailPanelContentProp.current && props.getDetailPanelHeight === previousGetDetailPanelHeightProp.current) return;
        apiRef.current.setState((state)=>{
            return (0, $asN9r.default)({}, state, {
                detailPanel: (0, $asN9r.default)({}, state.detailPanel, $370c4d15c799c127$var$cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        apiRef.current.updateDimensions?.();
        previousGetDetailPanelContentProp.current = props.getDetailPanelContent;
        previousGetDetailPanelHeightProp.current = props.getDetailPanelHeight;
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    const addDetailHeight = $f2Y41.useCallback((initialValue, row)=>{
        if (!expandedRowIds || expandedRowIds.length === 0 || !expandedRowIds.includes(row.id)) {
            initialValue.detail = 0;
            return initialValue;
        }
        updateCachesIfNeeded();
        const heightCache = (0, $e5450c6ab5b66c44$export$f8466bb36c8b9813)(apiRef);
        initialValue.detail = heightCache[row.id] ?? 0; // Fallback to zero because the cache might not be ready yet (for example page was changed)
        return initialValue;
    }, [
        apiRef,
        expandedRowIds,
        updateCachesIfNeeded
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "rowHeight", addDetailHeight);
    const isFirstRender = $f2Y41.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        updateCachesIfNeeded();
    }
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




const $70c3fe472dafc643$export$77f589f94558bf61 = (privateApiRef, props)=>{
    const addToggleColumn = $f2Y41.useCallback((columnsState)=>{
        if (props.getDetailPanelContent == null) {
            // Remove the toggle column, when it exists
            if (columnsState.lookup[0, $92eac178c0288cb2$export$6e5a576305a34719]) {
                delete columnsState.lookup[0, $92eac178c0288cb2$export$6e5a576305a34719];
                columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $92eac178c0288cb2$export$6e5a576305a34719));
            }
            return columnsState;
        }
        // Don't add the toggle column if there's already one
        // The user might have manually added it to have it in a custom position
        if (columnsState.lookup[0, $92eac178c0288cb2$export$6e5a576305a34719]) return columnsState;
        // Otherwise, add the toggle column at the beginning
        columnsState.orderedFields = [
            (0, $92eac178c0288cb2$export$6e5a576305a34719),
            ...columnsState.orderedFields
        ];
        columnsState.lookup[0, $92eac178c0288cb2$export$6e5a576305a34719] = (0, $asN9r.default)({}, (0, $92eac178c0288cb2$export$cea0a90b26fb973d), {
            headerName: privateApiRef.current.getLocaleText("detailPanelToggle")
        });
        return columnsState;
    }, [
        privateApiRef,
        props.getDetailPanelContent
    ]);
    const addExpandedClassToRow = $f2Y41.useCallback((classes, id)=>{
        if (props.getDetailPanelContent == null) return classes;
        const expandedRowIds = (0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad)(privateApiRef.current.state);
        if (!expandedRowIds.includes(id)) return classes;
        return [
            ...classes,
            (0, $2276c81b0f2e6e46$export$2100d54e36406477)["row--detailPanelExpanded"]
        ];
    }, [
        privateApiRef,
        props.getDetailPanelContent
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(privateApiRef, "hydrateColumns", addToggleColumn);
    (0, $a14191cb88acd892$export$faa98381ad228894)(privateApiRef, "rowClassName", addExpandedClassToRow);
};



var $f2Y41 = parcelRequire("f2Y41");




var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $6c241fec4e7e04e8$var$useUtilityClasses = (ownerState)=>{
    const { isDraggable: isDraggable, classes: classes } = ownerState;
    const slots = {
        root: [
            "rowReorderCell",
            isDraggable && "rowReorderCell--draggable"
        ],
        placeholder: [
            "rowReorderCellPlaceholder"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
function $6c241fec4e7e04e8$export$5e56cf9b6277d9e5(params) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const sortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$4cdbe576751dd8e2));
    const editRowsState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $fc36377571b6d029$export$91ed78b95c9e6636));
    // eslint-disable-next-line no-underscore-dangle
    const cellValue = params.row.__reorder__ || params.id;
    // TODO: remove sortModel and treeDepth checks once row reorder is compatible
    const isDraggable = $f2Y41.useMemo(()=>!!rootProps.rowReordering && !sortModel.length && treeDepth === 1 && Object.keys(editRowsState).length === 0, [
        rootProps.rowReordering,
        sortModel,
        treeDepth,
        editRowsState
    ]);
    const ownerState = {
        isDraggable: isDraggable,
        classes: rootProps.classes
    };
    const classes = $6c241fec4e7e04e8$var$useUtilityClasses(ownerState);
    const publish = $f2Y41.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $6790963f450ce0fb$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(params.id)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(params.id), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        params.id
    ]);
    const draggableEventHandlers = isDraggable ? {
        onDragStart: publish("rowDragStart"),
        onDragOver: publish("rowDragOver"),
        onDragEnd: publish("rowDragEnd")
    } : null;
    if (params.rowNode.type === "footer") return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
        className: classes.root,
        draggable: isDraggable
    }, draggableEventHandlers, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.rowReorderIcon, {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: classes.placeholder,
                children: cellValue
            })
        ]
    }));
}
const $6c241fec4e7e04e8$export$1346ab9a2305631 = (params)=>{
    if (params.rowNode.type === "footer" || params.rowNode.type === "pinnedRow") return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)($6c241fec4e7e04e8$export$5e56cf9b6277d9e5, (0, $asN9r.default)({}, params));
};


const $396f1c0e14332f2c$export$778666d70e672a78 = (0, $asN9r.default)({}, (0, $ca322ee82df9e13b$export$db6fa9d0a45573e4), {
    type: "custom",
    field: "__reorder__",
    sortable: false,
    filterable: false,
    width: 50,
    align: "center",
    headerAlign: "center",
    disableColumnMenu: true,
    disableExport: true,
    disableReorder: true,
    resizable: false,
    // @ts-ignore
    aggregable: false,
    renderHeader: ()=>" ",
    renderCell: (0, $6c241fec4e7e04e8$export$1346ab9a2305631)
});


var $a33a53392e6cf74c$var$Direction = /*#__PURE__*/ function(Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    return Direction;
}($a33a53392e6cf74c$var$Direction || {});
let $a33a53392e6cf74c$var$previousMousePosition = null;
let $a33a53392e6cf74c$var$previousReorderState = {
    previousTargetId: null,
    dragDirection: null
};
const $a33a53392e6cf74c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        rowDragging: [
            "row--dragging"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $a33a53392e6cf74c$export$628fe35635cfd286 = (apiRef, props)=>{
    const logger = (0, $2296f0a499200404$export$eb512164890e58f0)(apiRef, "useGridRowReorder");
    const sortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$4cdbe576751dd8e2));
    const dragRowNode = $f2Y41.useRef(null);
    const originRowIndex = $f2Y41.useRef(null);
    const removeDnDStylesTimeout = $f2Y41.useRef();
    const ownerState = {
        classes: props.classes
    };
    const classes = $a33a53392e6cf74c$var$useUtilityClasses(ownerState);
    const [dragRowId, setDragRowId] = $f2Y41.useState("");
    $f2Y41.useEffect(()=>{
        return ()=>{
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    // TODO: remove sortModel check once row reorder is sorting compatible
    // remove treeDepth once row reorder is tree compatible
    const isRowReorderDisabled = $f2Y41.useMemo(()=>{
        return !props.rowReordering || !!sortModel.length || treeDepth !== 1;
    }, [
        props.rowReordering,
        sortModel,
        treeDepth
    ]);
    const handleDragStart = $f2Y41.useCallback((params, event)=>{
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        const editRowsState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        if (isRowReorderDisabled || Object.keys(editRowsState).length !== 0) return;
        logger.debug(`Start dragging row ${params.id}`);
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragRowNode.current = event.currentTarget;
        dragRowNode.current.classList.add(classes.rowDragging);
        setDragRowId(params.id);
        removeDnDStylesTimeout.current = setTimeout(()=>{
            dragRowNode.current.classList.remove(classes.rowDragging);
        });
        originRowIndex.current = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
        apiRef.current.setCellFocus(params.id, (0, $396f1c0e14332f2c$export$778666d70e672a78).field);
    }, [
        isRowReorderDisabled,
        classes.rowDragging,
        logger,
        apiRef
    ]);
    const handleDragOver = $f2Y41.useCallback((params, event)=>{
        if (dragRowId === "") return;
        const rowNode = apiRef.current.getRowNode(params.id);
        if (!rowNode || rowNode.type === "footer" || rowNode.type === "pinnedRow") return;
        logger.debug(`Dragging over row ${params.id}`);
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        const mouseMovementDiff = $a33a53392e6cf74c$var$previousMousePosition ? $a33a53392e6cf74c$var$previousMousePosition.y - event.clientY : event.clientY;
        if (params.id !== dragRowId) {
            const targetRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
            const dragDirection = mouseMovementDiff > 0 ? $a33a53392e6cf74c$var$Direction.DOWN : $a33a53392e6cf74c$var$Direction.UP;
            const currentReorderState = {
                dragDirection: dragDirection,
                previousTargetId: params.id
            };
            const isStateChanged = currentReorderState.dragDirection !== $a33a53392e6cf74c$var$previousReorderState.dragDirection || currentReorderState.previousTargetId !== $a33a53392e6cf74c$var$previousReorderState.previousTargetId;
            if ($a33a53392e6cf74c$var$previousReorderState.dragDirection === null || Math.abs(mouseMovementDiff) >= 1 && isStateChanged) {
                apiRef.current.setRowIndex(dragRowId, targetRowIndex);
                $a33a53392e6cf74c$var$previousReorderState = currentReorderState;
            }
        }
        $a33a53392e6cf74c$var$previousMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
    }, [
        apiRef,
        logger,
        dragRowId
    ]);
    const handleDragEnd = $f2Y41.useCallback((params, event)=>{
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        const editRowsState = (0, $fc36377571b6d029$export$91ed78b95c9e6636)(apiRef.current.state);
        if (dragRowId === "" || isRowReorderDisabled || Object.keys(editRowsState).length !== 0) return;
        logger.debug("End dragging row");
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        dragRowNode.current = null;
        $a33a53392e6cf74c$var$previousReorderState.dragDirection = null;
        // Check if the row was dropped outside the grid.
        if (event.dataTransfer.dropEffect === "none") {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setRowIndex(dragRowId, originRowIndex.current);
            originRowIndex.current = null;
        } else {
            // Emit the rowOrderChange event only once when the reordering stops.
            const rowOrderChangeParams = {
                row: apiRef.current.getRow(dragRowId),
                targetIndex: apiRef.current.getRowIndexRelativeToVisibleRows(params.id),
                oldIndex: originRowIndex.current
            };
            apiRef.current.publishEvent("rowOrderChange", rowOrderChangeParams);
        }
        setDragRowId("");
    }, [
        isRowReorderDisabled,
        logger,
        apiRef,
        dragRowId
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowDragStart", handleDragStart);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowDragOver", handleDragOver);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "rowDragEnd", handleDragEnd);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(apiRef, "cellDragOver", handleDragOver);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(apiRef, "rowOrderChange", props.onRowOrderChange);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




const $618e4240833e21eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $f2Y41.useMemo(()=>{
        const slots = {
            rowReorderCellContainer: [
                "rowReorderCellContainer"
            ],
            columnHeaderReorder: [
                "columnHeaderReorder"
            ]
        };
        return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $618e4240833e21eb$export$55f18eb0ec5c02d1 = (privateApiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $618e4240833e21eb$var$useUtilityClasses(ownerState);
    const updateReorderColumn = $f2Y41.useCallback((columnsState)=>{
        const reorderColumn = (0, $asN9r.default)({}, (0, $396f1c0e14332f2c$export$778666d70e672a78), {
            cellClassName: classes.rowReorderCellContainer,
            headerClassName: classes.columnHeaderReorder,
            headerName: privateApiRef.current.getLocaleText("rowReorderingHeaderName")
        });
        const shouldHaveReorderColumn = props.rowReordering;
        const haveReorderColumn = columnsState.lookup[reorderColumn.field] != null;
        if (shouldHaveReorderColumn && haveReorderColumn) return columnsState;
        if (shouldHaveReorderColumn && !haveReorderColumn) {
            columnsState.lookup[reorderColumn.field] = reorderColumn;
            columnsState.orderedFields = [
                reorderColumn.field,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveReorderColumn && haveReorderColumn) {
            delete columnsState.lookup[reorderColumn.field];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== reorderColumn.field);
        }
        return columnsState;
    }, [
        privateApiRef,
        classes,
        props.rowReordering
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(privateApiRef, "hydrateColumns", updateReorderColumn);
};



var $f2Y41 = parcelRequire("f2Y41");


function $c0e542f7e2a10d8d$var$findSkeletonRowsSection({ apiRef: apiRef, visibleRows: visibleRows, range: range }) {
    let { firstRowIndex: firstRowIndex, lastRowIndex: lastRowIndex } = range;
    const visibleRowsSection = visibleRows.slice(range.firstRowIndex, range.lastRowIndex);
    let startIndex = 0;
    let endIndex = visibleRowsSection.length - 1;
    let isSkeletonSectionFound = false;
    while(!isSkeletonSectionFound && firstRowIndex < lastRowIndex){
        const isStartingWithASkeletonRow = apiRef.current.getRowNode(visibleRowsSection[startIndex].id)?.type === "skeletonRow";
        const isEndingWithASkeletonRow = apiRef.current.getRowNode(visibleRowsSection[endIndex].id)?.type === "skeletonRow";
        if (isStartingWithASkeletonRow && isEndingWithASkeletonRow) isSkeletonSectionFound = true;
        if (!isStartingWithASkeletonRow) {
            startIndex += 1;
            firstRowIndex += 1;
        }
        if (!isEndingWithASkeletonRow) {
            endIndex -= 1;
            lastRowIndex -= 1;
        }
    }
    return isSkeletonSectionFound ? {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex
    } : undefined;
}
const $c0e542f7e2a10d8d$export$c805ba869d6a5 = (privateApiRef, props)=>{
    const sortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(privateApiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(privateApiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const renderedRowsIntervalCache = $f2Y41.useRef({
        firstRowToRender: 0,
        lastRowToRender: 0
    });
    const isDisabled = props.rowsLoadingMode !== "server";
    const handleRenderedRowsIntervalChange = $f2Y41.useCallback((params)=>{
        if (isDisabled) return;
        const fetchRowsParams = {
            firstRowToRender: params.firstRowIndex,
            lastRowToRender: params.lastRowIndex,
            sortModel: sortModel,
            filterModel: filterModel
        };
        if (renderedRowsIntervalCache.current.firstRowToRender === params.firstRowIndex && renderedRowsIntervalCache.current.lastRowToRender === params.lastRowIndex) return;
        renderedRowsIntervalCache.current = {
            firstRowToRender: params.firstRowIndex,
            lastRowToRender: params.lastRowIndex
        };
        if (sortModel.length === 0 && filterModel.items.length === 0) {
            const currentVisibleRows = (0, $5102b0c2afb145a4$export$79b9fa322a34430b)(privateApiRef, {
                pagination: props.pagination,
                paginationMode: props.paginationMode
            });
            const skeletonRowsSection = $c0e542f7e2a10d8d$var$findSkeletonRowsSection({
                apiRef: privateApiRef,
                visibleRows: currentVisibleRows.rows,
                range: {
                    firstRowIndex: params.firstRowIndex,
                    lastRowIndex: params.lastRowIndex
                }
            });
            if (!skeletonRowsSection) return;
            fetchRowsParams.firstRowToRender = skeletonRowsSection.firstRowIndex;
            fetchRowsParams.lastRowToRender = skeletonRowsSection.lastRowIndex;
        }
        privateApiRef.current.publishEvent("fetchRows", fetchRowsParams);
    }, [
        privateApiRef,
        isDisabled,
        props.pagination,
        props.paginationMode,
        sortModel,
        filterModel
    ]);
    const handleGridSortModelChange = $f2Y41.useCallback((newSortModel)=>{
        if (isDisabled) return;
        privateApiRef.current.requestPipeProcessorsApplication("hydrateRows");
        const renderContext = (0, $de91a359006882c0$export$4cf9f333a030f780)(privateApiRef);
        const fetchRowsParams = {
            firstRowToRender: renderContext.firstRowIndex,
            lastRowToRender: renderContext.lastRowIndex,
            sortModel: newSortModel,
            filterModel: filterModel
        };
        privateApiRef.current.publishEvent("fetchRows", fetchRowsParams);
    }, [
        privateApiRef,
        isDisabled,
        filterModel
    ]);
    const handleGridFilterModelChange = $f2Y41.useCallback((newFilterModel)=>{
        if (isDisabled) return;
        privateApiRef.current.requestPipeProcessorsApplication("hydrateRows");
        const renderContext = (0, $de91a359006882c0$export$4cf9f333a030f780)(privateApiRef);
        const fetchRowsParams = {
            firstRowToRender: renderContext.firstRowIndex,
            lastRowToRender: renderContext.lastRowIndex,
            sortModel: sortModel,
            filterModel: newFilterModel
        };
        privateApiRef.current.publishEvent("fetchRows", fetchRowsParams);
    }, [
        privateApiRef,
        isDisabled,
        sortModel
    ]);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(privateApiRef, "renderedRowsIntervalChange", handleRenderedRowsIntervalChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(privateApiRef, "sortModelChange", handleGridSortModelChange);
    (0, $71512ea7dac91a28$export$223e28bfc0254c87)(privateApiRef, "filterModelChange", handleGridFilterModelChange);
    (0, $71512ea7dac91a28$export$d55ddab8b28954db)(privateApiRef, "fetchRows", props.onFetchRows);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


const $4adb57d3a259180f$export$4fd3c65dfc13fe4b = "auto-generated-skeleton-row-root";
const $4adb57d3a259180f$var$getSkeletonRowId = (index)=>`${$4adb57d3a259180f$export$4fd3c65dfc13fe4b}-${index}`;
const $4adb57d3a259180f$export$220f673c81926201 = (privateApiRef, props)=>{
    const addSkeletonRows = $f2Y41.useCallback((groupingParams)=>{
        const rootGroup = groupingParams.tree[0, $5a37f1a88e056eac$export$433b924dc2506913];
        if (props.rowsLoadingMode !== "server" || !props.rowCount || rootGroup.children.length >= props.rowCount) return groupingParams;
        const tree = (0, $asN9r.default)({}, groupingParams.tree);
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        for(let i = 0; i < props.rowCount - rootGroup.children.length; i += 1){
            const skeletonId = $4adb57d3a259180f$var$getSkeletonRowId(i);
            rootGroupChildren.push(skeletonId);
            const skeletonRowNode = {
                type: "skeletonRow",
                id: skeletonId,
                parent: (0, $5a37f1a88e056eac$export$433b924dc2506913),
                depth: 0
            };
            tree[skeletonId] = skeletonRowNode;
        }
        tree[0, $5a37f1a88e056eac$export$433b924dc2506913] = (0, $asN9r.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        return (0, $asN9r.default)({}, groupingParams, {
            tree: tree
        });
    }, [
        props.rowCount,
        props.rowsLoadingMode
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(privateApiRef, "hydrateRows", addSkeletonRows);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


function $64c095b0c6968a14$var$createPinnedRowsInternalCache(pinnedRows, getRowId) {
    const cache = {
        topIds: [],
        bottomIds: [],
        idLookup: {}
    };
    pinnedRows?.top?.forEach((rowModel)=>{
        const id = (0, $5a37f1a88e056eac$export$a95fb784d0ca2e72)(rowModel, getRowId);
        cache.topIds.push(id);
        cache.idLookup[id] = rowModel;
    });
    pinnedRows?.bottom?.forEach((rowModel)=>{
        const id = (0, $5a37f1a88e056eac$export$a95fb784d0ca2e72)(rowModel, getRowId);
        cache.bottomIds.push(id);
        cache.idLookup[id] = rowModel;
    });
    return cache;
}
const $64c095b0c6968a14$export$68e0b9853cc25422 = (state, props, apiRef)=>{
    apiRef.current.caches.pinnedRows = $64c095b0c6968a14$var$createPinnedRowsInternalCache(props.pinnedRows, props.getRowId);
    return (0, $asN9r.default)({}, state, {
        rows: (0, $asN9r.default)({}, state.rows, {
            additionalRowGroups: (0, $asN9r.default)({}, state.rows?.additionalRowGroups, {
                pinnedRows: {
                    top: [],
                    bottom: []
                }
            })
        })
    });
};
const $64c095b0c6968a14$export$d37ff411a3231397 = (apiRef, props)=>{
    const setPinnedRows = $f2Y41.useCallback((newPinnedRows)=>{
        apiRef.current.caches.pinnedRows = $64c095b0c6968a14$var$createPinnedRowsInternalCache(newPinnedRows, props.getRowId);
        apiRef.current.requestPipeProcessorsApplication("hydrateRows");
    }, [
        apiRef,
        props.getRowId
    ]);
    (0, $4de327342af16ad7$export$739f6b6a65e76d6c)(apiRef, {
        unstable_setPinnedRows: setPinnedRows
    }, "public");
    const isFirstRender = $f2Y41.useRef(true);
    $f2Y41.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        apiRef.current.unstable_setPinnedRows(props.pinnedRows);
    }, [
        apiRef,
        props.pinnedRows
    ]);
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



function $b0a815b4c11c75d9$export$a9980a60d1e4cd4d({ groupingParams: groupingParams, rowModel: rowModel, rowId: rowId, position: position, apiRef: apiRef, isAutoGenerated: isAutoGenerated }) {
    const dataRowIdToModelLookup = (0, $asN9r.default)({}, groupingParams.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $asN9r.default)({}, groupingParams.dataRowIdToIdLookup);
    const tree = (0, $asN9r.default)({}, groupingParams.tree);
    const treeDepths = (0, $asN9r.default)({}, groupingParams.treeDepths);
    // TODO: warn if id is already present in `props.rows`
    const node = {
        type: "pinnedRow",
        id: rowId,
        depth: 0,
        parent: (0, $5a37f1a88e056eac$export$433b924dc2506913),
        isAutoGenerated: isAutoGenerated
    };
    (0, $a7bfa75fe95f9574$export$e179dd88ba706b74)(node, tree, treeDepths, null);
    if (!isAutoGenerated) {
        dataRowIdToModelLookup[rowId] = rowModel;
        dataRowIdToIdLookup[rowId] = rowId;
    }
    // Do not push it to ids list so that pagination is not affected by pinned rows
    apiRef.current.caches.rows.dataRowIdToModelLookup[rowId] = (0, $asN9r.default)({}, rowModel);
    apiRef.current.caches.rows.dataRowIdToIdLookup[rowId] = rowId;
    const previousPinnedRows = groupingParams.additionalRowGroups?.pinnedRows || {};
    const newPinnedRow = {
        id: rowId,
        model: rowModel
    };
    if (groupingParams.additionalRowGroups?.pinnedRows?.[position]?.includes(newPinnedRow)) return (0, $asN9r.default)({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths
    });
    return (0, $asN9r.default)({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths,
        additionalRowGroups: (0, $asN9r.default)({}, groupingParams.additionalRowGroups, {
            pinnedRows: (0, $asN9r.default)({}, previousPinnedRows, {
                [position]: [
                    ...previousPinnedRows[position] || [],
                    newPinnedRow
                ]
            })
        })
    });
}
const $b0a815b4c11c75d9$export$e392353a5909a7ad = (apiRef)=>{
    const addPinnedRows = $f2Y41.useCallback((groupingParams)=>{
        const pinnedRowsCache = apiRef.current.caches.pinnedRows || {};
        let newGroupingParams = (0, $asN9r.default)({}, groupingParams, {
            additionalRowGroups: (0, $asN9r.default)({}, groupingParams.additionalRowGroups, {
                // reset pinned rows state
                pinnedRows: {}
            })
        });
        pinnedRowsCache.topIds?.forEach((rowId)=>{
            newGroupingParams = $b0a815b4c11c75d9$export$a9980a60d1e4cd4d({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: "top",
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        pinnedRowsCache.bottomIds?.forEach((rowId)=>{
            newGroupingParams = $b0a815b4c11c75d9$export$a9980a60d1e4cd4d({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: "bottom",
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        // If row with the same `id` is present both in `rows` and `pinnedRows` - remove it from the root group children
        if (pinnedRowsCache.bottomIds?.length || pinnedRowsCache.topIds?.length) {
            const shouldKeepRow = (rowId)=>{
                if (newGroupingParams.tree[rowId] && newGroupingParams.tree[rowId].type === "pinnedRow") return false;
                return true;
            };
            const rootGroupNode = newGroupingParams.tree[0, $5a37f1a88e056eac$export$433b924dc2506913];
            newGroupingParams.tree[0, $5a37f1a88e056eac$export$433b924dc2506913] = (0, $asN9r.default)({}, rootGroupNode, {
                children: rootGroupNode.children.filter(shouldKeepRow)
            });
            newGroupingParams.dataRowIds = newGroupingParams.dataRowIds.filter(shouldKeepRow);
        }
        return newGroupingParams;
    }, [
        apiRef
    ]);
    (0, $a14191cb88acd892$export$faa98381ad228894)(apiRef, "hydrateRows", addPinnedRows);
};


const $a405ede6c1183d55$export$ae01925210967ff3 = (inputApiRef, props)=>{
    const apiRef = (0, $97d6c186911014b8$export$b77462c86b28bbf0)(inputApiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $c6440c503a1fb6d2$export$fa1d7b0897c018ea)(apiRef, props);
    (0, $618e4240833e21eb$export$55f18eb0ec5c02d1)(apiRef, props);
    (0, $e48dc7017e7bfdef$export$7e966b04a1d3262a)(apiRef, props);
    (0, $4adb57d3a259180f$export$220f673c81926201)(apiRef, props);
    (0, $b0a815b4c11c75d9$export$e392353a5909a7ad)(apiRef);
    (0, $70c3fe472dafc643$export$77f589f94558bf61)(apiRef, props);
    // The column pinning `hydrateColumns` pre-processor must be after every other `hydrateColumns` pre-processors
    // Because it changes the order of the columns.
    (0, $47a8c11a1e3a7632$export$47a2167ef2ac089d)(apiRef, props);
    (0, $7cd92ed222fe9d9d$export$cc1daa683bbe5702)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $82c10198cc36e0b5$export$c29f872c616fae5b), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $51e80d1887f31449$export$e29505bd53a069c8), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $f045245d84cc3310$export$73be1d69367eeb5b), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $370c4d15c799c127$export$c6a1049ecc0f594c), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $1d569a482003f0fb$export$5fee0234a63f3519), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $5dfff719897ebff3$export$8dcda879a58a8f96), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $64c095b0c6968a14$export$68e0b9853cc25422), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $1b09114b7f40356b$export$1a6bb5bb341eadaa), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $b28d4da3a0a58897$export$1094a2c822d71ffd), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $17f8f143b062668f$export$bfde38b067fac467), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $9d85025507520b40$export$996e35c2eef351ae), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $386ede2ee8d35d7d$export$a9f45f767b8ade48), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $23bb249186e93114$export$a3e5a984fe72a5db), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $ef3e1313173c43db$export$d6d71dbaaa6fec72), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $7b36c927bd481439$export$c111e737ab642862), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $b3578c0ad87c8811$export$ac6ed2ccd52f643f), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $c8086ac8482f7a3d$export$951a05deca7e869f), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $6b452a5f7e5dca5a$export$4224c70cd0329965), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $bca97ad3d37bdc8a$export$8574ffe06bf26347), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $a809912361717acd$export$21c841dc431b3cd0), apiRef, props);
    (0, $a8b49b85bf61e69c$export$f9587d613f2caeec)((0, $0833e448acfcf31e$export$42963ad70bb69f54), apiRef, props);
    (0, $51e80d1887f31449$export$8ee3ddc1b48b5da9)(apiRef, props);
    (0, $82a800c863c32a12$export$15cdd24474e74350)(apiRef);
    (0, $b4fdfe6bdee25f2c$export$142b8bb1fe6da473)(apiRef, props);
    (0, $f045245d84cc3310$export$3e2b6b991d9d83f0)(apiRef, props);
    (0, $1d569a482003f0fb$export$2534ab700dd48c29)(apiRef, props);
    (0, $64c095b0c6968a14$export$d37ff411a3231397)(apiRef, props);
    (0, $5dfff719897ebff3$export$fe9b9b8b4620abff)(apiRef, props);
    (0, $1b09114b7f40356b$export$dd1a4469bbd9394e)(apiRef, props);
    (0, $1544cfea3ebce330$export$d5da41ef394db9ef)(apiRef);
    (0, $370c4d15c799c127$export$b71d7525fdd57704)(apiRef, props);
    (0, $ce30633c7c432f3e$export$ce7ce4871097b52e)(apiRef);
    (0, $a809912361717acd$export$510984a37e2e33f3)(apiRef, props);
    (0, $b28d4da3a0a58897$export$3a0db16b152b4c54)(apiRef, props);
    (0, $17f8f143b062668f$export$8b69791fef06a777)(apiRef, props);
    (0, $386ede2ee8d35d7d$export$343dd9a605dbb75b)(apiRef, props);
    (0, $23bb249186e93114$export$42838275cbf666c4)(apiRef, props);
    (0, $9d85025507520b40$export$951287757eb5d93c)(apiRef, props);
    (0, $ef3e1313173c43db$export$836c4be63cf7a42d)(apiRef, props);
    (0, $7b36c927bd481439$export$e060c7667a4364d2)(apiRef, props);
    (0, $b3578c0ad87c8811$export$6761a7afeb3daa64)(apiRef, props);
    (0, $c8086ac8482f7a3d$export$f1c8f1c02d202e22)(apiRef, props);
    (0, $6b452a5f7e5dca5a$export$8a4468671da3a64f)(apiRef, props);
    (0, $a33a53392e6cf74c$export$628fe35635cfd286)(apiRef, props);
    (0, $5aa2c68e4a4e170e$export$d3441dc29db31b8c)(apiRef, props);
    (0, $a6484e1ecd03bb68$export$ffcbb8895be5a582)(apiRef, props);
    (0, $c0e542f7e2a10d8d$export$c805ba869d6a5)(apiRef, props);
    (0, $bca97ad3d37bdc8a$export$1fc2975c9a725449)(apiRef);
    (0, $e870a6e7ee59b151$export$6178dbab26611702)(apiRef, props);
    (0, $89bba07274b383fc$export$41205b2521d4edd4)(apiRef, props);
    (0, $20864ea749fa7e5a$export$a44b2f69ac6aef73)(apiRef, props);
    (0, $82c10198cc36e0b5$export$b8364994f9eec67d)(apiRef, props);
    (0, $f67e3aa0584dc61e$export$8456f443918812d4)(apiRef, props);
    (0, $3c601f02158a8077$export$971de86bde7f86a1)(apiRef);
    (0, $0833e448acfcf31e$export$aa0d6df32cccbd53)(apiRef, props);
    return apiRef;
};



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




var $asN9r = parcelRequire("asN9r");


var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $f2Y41 = parcelRequire("f2Y41");









var $ge3KO = parcelRequire("ge3KO");
function $a2491d410e9dc6dd$export$aaeeda42354cd97c(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $e87e8a83fc996e91$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const theme = (0, $3f2663da8e8af7d6$export$2e2bcd8739ae039)();
    const pinColumn = $f2Y41.useCallback((side)=>(event)=>{
            apiRef.current.pinColumn(colDef.field, side);
            onClick(event);
        }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    const unpinColumn = (event)=>{
        apiRef.current.unpinColumn(colDef.field);
        onClick(event);
    };
    const pinToLeftMenuItem = /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
        onClick: pinColumn((0, $49d1610712424e75$export$64f54b460f67389c).LEFT),
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuPinLeftIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText("pinToLeft")
            })
        ]
    });
    const pinToRightMenuItem = /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
        onClick: pinColumn((0, $49d1610712424e75$export$64f54b460f67389c).RIGHT),
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuPinRightIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText("pinToRight")
            })
        ]
    });
    if (!colDef) return null;
    const side = apiRef.current.isColumnPinned(colDef.field);
    if (side) {
        const otherSide = side === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT ? (0, $49d1610712424e75$export$64f54b460f67389c).LEFT : (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT;
        const label = otherSide === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT ? "pinToRight" : "pinToLeft";
        const Icon = side === (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT ? rootProps.slots.columnMenuPinLeftIcon : rootProps.slots.columnMenuPinRightIcon;
        return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
                    onClick: pinColumn(otherSide),
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)(Icon, {
                                fontSize: "small"
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                            children: apiRef.current.getLocaleText(label)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
                    onClick: unpinColumn,
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $916fcf0d4f1c2cd1$export$2e2bcd8739ae039), {
                            children: apiRef.current.getLocaleText("unpin")
                        })
                    ]
                })
            ]
        });
    }
    if (theme.direction === "rtl") return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            pinToRightMenuItem,
            pinToLeftMenuItem
        ]
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            pinToLeftMenuItem,
            pinToRightMenuItem
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
const $d5913d711cbb20c6$export$cd6960cce13e3545 = (0, $asN9r.default)({}, (0, $c593a601c719670d$export$5983f95fe9d3e659), {
    columnMenuPinningItem: (0, $a2491d410e9dc6dd$export$aaeeda42354cd97c)
});
const $d5913d711cbb20c6$export$6e9c8ed52623938a = (0, $asN9r.default)({}, (0, $c593a601c719670d$export$c107bd4c779cece6), {
    columnMenuPinningItem: {
        displayOrder: 15
    }
});
const $d5913d711cbb20c6$export$49bc76a234ac21c2 = /*#__PURE__*/ $f2Y41.forwardRef(function GridProColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c593a601c719670d$export$61ffa20907ac4a8e), (0, $asN9r.default)({
        ref: ref
    }, props, {
        defaultSlots: $d5913d711cbb20c6$export$cd6960cce13e3545,
        defaultSlotProps: $d5913d711cbb20c6$export$6e9c8ed52623938a
    }));
});



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $53945a0f307e868e$var$_excluded = [
    "getColumnsToRender",
    "renderContext",
    "leftRenderContext",
    "rightRenderContext",
    "pinnedColumns",
    "visibleColumns",
    "getCellOffsetStyle"
];
const $53945a0f307e868e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $f2Y41.useMemo(()=>{
        const slots = {
            headerFilterRow: [
                "headerFilterRow"
            ]
        };
        return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $53945a0f307e868e$var$filterItemsCache = Object.create(null);
const $53945a0f307e868e$export$dd7dbc7d3ee10272 = (props)=>{
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const { headerGroupingMaxDepth: headerGroupingMaxDepth, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const columnHeaderFilterTabIndexState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$441ae2090306a1e2));
    const _useGridColumnHeaders = (0, $9b1476f20ea6a843$export$dd7dbc7d3ee10272)((0, $asN9r.default)({}, props, {
        hasOtherElementInTabSequence: hasOtherElementInTabSequence || columnHeaderFilterTabIndexState !== null
    })), { getColumnsToRender: getColumnsToRender, renderContext: renderContext, leftRenderContext: leftRenderContext, rightRenderContext: rightRenderContext, pinnedColumns: pinnedColumns, visibleColumns: visibleColumns, getCellOffsetStyle: getCellOffsetStyle } = _useGridColumnHeaders, otherProps = (0, $bKcdJ.default)(_useGridColumnHeaders, $53945a0f307e868e$var$_excluded);
    const headerFiltersRef = $f2Y41.useRef(null);
    apiRef.current.register("private", {
        headerFiltersElementRef: headerFiltersRef
    });
    const headerFilterMenuRef = $f2Y41.useRef(null);
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const classes = $53945a0f307e868e$var$useUtilityClasses(rootProps);
    const disableHeaderFiltering = !rootProps.headerFilters;
    const dimensions = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $13cd7539f33578ca$export$26d8768b83a52ffd));
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
    const columnHeaderFilterFocus = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $f90986e9ff221f63$export$50853df99eaddaf5));
    const getFilterItem = $f2Y41.useCallback((colDef)=>{
        const filterModelItem = filterModel?.items.find((it)=>it.field === colDef.field && it.operator !== "isAnyOf");
        if (filterModelItem != null) // there's a valid `filterModelItem` for this column
        return filterModelItem;
        const defaultCachedItem = $53945a0f307e868e$var$filterItemsCache[colDef.field];
        if (defaultCachedItem != null) // there's a cached `defaultItem` for this column
        return defaultCachedItem;
        // there's no cached `defaultItem` for this column, let's generate one and cache it
        const defaultItem = (0, $21b0e7355a379ba9$export$7530149911670467)(colDef);
        $53945a0f307e868e$var$filterItemsCache[colDef.field] = defaultItem;
        return defaultItem;
    }, [
        filterModel
    ]);
    const getColumnFilters = (params)=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const filters = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const hasFocus = columnHeaderFilterFocus?.field === colDef.field;
            const isFirstColumn = columnIndex === 0;
            const tabIndexField = columnHeaderFilterTabIndexState?.field;
            const tabIndex = tabIndexField === colDef.field || isFirstColumn && !props.hasOtherElementInTabSequence ? 0 : -1;
            const headerClassName = typeof colDef.headerClassName === "function" ? colDef.headerClassName({
                field: colDef.field,
                colDef: colDef
            }) : colDef.headerClassName;
            const item = getFilterItem(colDef);
            const pinnedPosition = params?.position;
            const style = getCellOffsetStyle({
                pinnedPosition: pinnedPosition,
                columnIndex: columnIndex,
                computedWidth: colDef.computedWidth
            });
            filters.push(/*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.headerFilterCell, (0, $asN9r.default)({
                colIndex: columnIndex,
                height: dimensions.headerFilterHeight,
                width: colDef.computedWidth,
                colDef: colDef,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                headerFilterMenuRef: headerFilterMenuRef,
                headerClassName: headerClassName,
                "data-field": colDef.field,
                item: item,
                pinnedPosition: pinnedPosition,
                style: style,
                indexInSection: i,
                sectionLength: renderedColumns.length,
                gridHasFiller: gridHasFiller
            }, rootProps.slotProps?.headerFilterCell), `${colDef.field}-filter`));
        }
        return otherProps.getFillers(params, filters, 0, true);
    };
    const getColumnFiltersRow = ()=>{
        if (disableHeaderFiltering) return null;
        return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $9b1476f20ea6a843$export$7b391e1fd04597c4), {
            ref: headerFiltersRef,
            className: classes.headerFilterRow,
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 2,
            ownerState: rootProps,
            children: [
                leftRenderContext && getColumnFilters({
                    position: (0, $49d1610712424e75$export$64f54b460f67389c).LEFT,
                    renderContext: leftRenderContext,
                    minFirstColumn: leftRenderContext.firstColumnIndex,
                    maxLastColumn: leftRenderContext.lastColumnIndex
                }),
                getColumnFilters({
                    renderContext: renderContext,
                    minFirstColumn: pinnedColumns.left.length,
                    maxLastColumn: visibleColumns.length - pinnedColumns.right.length
                }),
                rightRenderContext && getColumnFilters({
                    position: (0, $49d1610712424e75$export$64f54b460f67389c).RIGHT,
                    renderContext: rightRenderContext,
                    minFirstColumn: rightRenderContext.firstColumnIndex,
                    maxLastColumn: rightRenderContext.lastColumnIndex
                })
            ]
        });
    };
    return (0, $asN9r.default)({}, otherProps, {
        getColumnFiltersRow: getColumnFiltersRow
    });
};



var $ge3KO = parcelRequire("ge3KO");
const $45d16251217486ee$var$_excluded = [
    "style",
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $45d16251217486ee$var$Filler = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div")({
    flex: 1,
    backgroundColor: "var(--DataGrid-containerBackground)"
});
const $45d16251217486ee$export$4a3a74c44d0a6c04 = /*#__PURE__*/ $f2Y41.forwardRef(function GridColumnHeaders(props, ref) {
    const { className: className, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $bKcdJ.default)(props, $45d16251217486ee$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnFiltersRow: getColumnFiltersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $53945a0f307e868e$export$dd7dbc7d3ee10272)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $d657ff3ce5eef59a$export$de91f7b8bf842ed8), (0, $asN9r.default)({
        ref: ref,
        className: className
    }, other, getInnerProps(), {
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow(),
            getColumnFiltersRow(),
            /*#__PURE__*/ (0, $ge3KO.jsx)($45d16251217486ee$var$Filler, {})
        ]
    }));
});



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




var $gl072 = parcelRequire("gl072");


var $ge3KO = parcelRequire("ge3KO");
function $6b62ee6ae18a27c6$export$5d70bc2c3a60b060({ open: open, field: field, target: target, applyFilterChanges: applyFilterChanges, operators: operators, item: item, id: id, labelledBy: labelledBy }) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const hideMenu = $f2Y41.useCallback(()=>{
        apiRef.current.hideHeaderFilterMenu();
    }, [
        apiRef
    ]);
    const handleListKeyDown = $f2Y41.useCallback((event)=>{
        if (event.key === "Tab") event.preventDefault();
        if (event.key === "Escape" || event.key === "Tab") hideMenu();
    }, [
        hideMenu
    ]);
    if (!target) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f1a3f9a2e160d201$export$237948c71948075), {
        placement: "bottom-end",
        open: open,
        target: target,
        onClose: hideMenu,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d203149adb48b43d$export$2e2bcd8739ae039), {
            "aria-labelledby": labelledBy,
            id: id,
            onKeyDown: handleListKeyDown,
            children: operators.map((op, i)=>{
                const label = op?.headerLabel ?? apiRef.current.getLocaleText(`headerFilterOperator${(0, $gl072.default)(op.value)}`);
                return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        applyFilterChanges((0, $asN9r.default)({}, item, {
                            operator: op.value
                        }));
                        hideMenu();
                    },
                    autoFocus: i === 0 ? open : false,
                    selected: op.value === item.operator,
                    children: label
                }, `${field}-${op.value}`);
            })
        })
    });
}



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $gl072 = parcelRequire("gl072");




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");
const $7db86980b5c174bb$var$_excluded = [
    "operators",
    "item",
    "field",
    "buttonRef",
    "headerFilterMenuRef",
    "disabled"
];
const $7db86980b5c174bb$var$sx = {
    width: 22,
    height: 22,
    margin: "auto 0 10px 5px"
};
function $7db86980b5c174bb$export$9b7bd6eff38238f5(props) {
    const { operators: operators, item: item, field: field, buttonRef: buttonRef, headerFilterMenuRef: headerFilterMenuRef, disabled: disabled = false } = props, others = (0, $bKcdJ.default)(props, $7db86980b5c174bb$var$_excluded);
    const buttonId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const menuId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const menuOpenField = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $08de99050f04470e$export$c564e60305059ea4));
    const open = Boolean(menuOpenField === field && headerFilterMenuRef.current);
    const handleClick = (event)=>{
        headerFilterMenuRef.current = event.currentTarget;
        apiRef.current.showHeaderFilterMenu(field);
    };
    if (!rootProps.slots.headerFilterMenu) return null;
    const label = apiRef.current.getLocaleText("filterPanelOperator");
    const labelString = label ? String(label) : undefined;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
                id: buttonId,
                ref: buttonRef,
                "aria-label": labelString,
                title: labelString,
                "aria-controls": menuId,
                "aria-expanded": open ? "true" : undefined,
                "aria-haspopup": "true",
                tabIndex: -1,
                size: "small",
                onClick: handleClick,
                sx: $7db86980b5c174bb$var$sx,
                disabled: disabled
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.openFilterButtonIcon, {
                    fontSize: "small"
                })
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.headerFilterMenu, (0, $asN9r.default)({
                field: field,
                open: open,
                item: item,
                target: headerFilterMenuRef.current,
                operators: operators,
                labelledBy: buttonId,
                id: menuId
            }, others))
        ]
    });
}



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
const $d8db733cfc754eb8$var$sx = {
    padding: "2px"
};
function $d8db733cfc754eb8$export$a92783e4bfd82db8(props) {
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
        tabIndex: -1,
        "aria-label": "Clear filter",
        size: "small",
        sx: $d8db733cfc754eb8$var$sx
    }, props, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnMenuClearIcon, {
            fontSize: "inherit"
        })
    }));
}



var $ge3KO = parcelRequire("ge3KO");
const $9006c5cfbe3715c8$var$_excluded = [
    "colIndex",
    "height",
    "hasFocus",
    "width",
    "headerClassName",
    "colDef",
    "item",
    "headerFilterMenuRef",
    "InputComponentProps",
    "showClearIcon",
    "pinnedPosition",
    "style",
    "indexInSection",
    "sectionLength",
    "gridHasFiller"
];
const $9006c5cfbe3715c8$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            "columnHeader",
            colDef.headerAlign === "left" && "columnHeader--alignLeft",
            colDef.headerAlign === "center" && "columnHeader--alignCenter",
            colDef.headerAlign === "right" && "columnHeader--alignRight",
            "withBorderColor",
            showRightBorder && "columnHeader--withRightBorder",
            showLeftBorder && "columnHeader--withLeftBorder",
            pinnedPosition === "left" && "columnHeader--pinnedLeft",
            pinnedPosition === "right" && "columnHeader--pinnedRight"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $9006c5cfbe3715c8$var$dateSx = {
    [`& input[value=""]:not(:focus)`]: {
        color: "transparent"
    }
};
const $9006c5cfbe3715c8$var$GridHeaderFilterCell = /*#__PURE__*/ $f2Y41.forwardRef((props, ref)=>{
    const { colIndex: colIndex, height: height, hasFocus: hasFocus, width: width, headerClassName: headerClassName, colDef: colDef, item: item, headerFilterMenuRef: headerFilterMenuRef, InputComponentProps: InputComponentProps, showClearIcon: showClearIcon = true, pinnedPosition: pinnedPosition, style: styleProp, indexInSection: indexInSection, sectionLength: sectionLength, gridHasFiller: gridHasFiller } = props, other = (0, $bKcdJ.default)(props, $9006c5cfbe3715c8$var$_excluded);
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const columnFields = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$c9491722e1d6e8d3));
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const cellRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(ref, cellRef);
    const inputRef = $f2Y41.useRef(null);
    const buttonRef = $f2Y41.useRef(null);
    const editingField = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $08de99050f04470e$export$d5104e3dccc7c49d));
    const isEditing = editingField === colDef.field;
    const menuOpenField = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $08de99050f04470e$export$c564e60305059ea4));
    const isMenuOpen = menuOpenField === colDef.field;
    // TODO: Support for `isAnyOf` operator
    const filterOperators = colDef.filterOperators?.filter((operator)=>operator.value !== "isAnyOf") ?? [];
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const filterableColumnsLookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$e84218276cc24419));
    const isFilterReadOnly = $f2Y41.useMemo(()=>{
        if (!filterModel?.items.length) return false;
        const filterModelItem = filterModel.items.find((it)=>it.field === colDef.field);
        return filterModelItem ? !filterableColumnsLookup[filterModelItem.field] : false;
    }, [
        colDef.field,
        filterModel,
        filterableColumnsLookup
    ]);
    const currentOperator = filterOperators[0];
    const InputComponent = colDef.filterable || isFilterReadOnly ? currentOperator.InputComponent : null;
    const applyFilterChanges = $f2Y41.useCallback((updatedItem)=>{
        if (item.value && !updatedItem.value) {
            apiRef.current.deleteFilterItem(updatedItem);
            return;
        }
        apiRef.current.upsertFilterItem(updatedItem);
    }, [
        apiRef,
        item
    ]);
    const clearFilterItem = $f2Y41.useCallback(()=>{
        apiRef.current.deleteFilterItem(item);
    }, [
        apiRef,
        item
    ]);
    let headerFilterComponent;
    if (colDef.renderHeaderFilter) headerFilterComponent = colDef.renderHeaderFilter((0, $asN9r.default)({}, props, {
        inputRef: inputRef
    }));
    $f2Y41.useLayoutEffect(()=>{
        if (hasFocus && !isMenuOpen) {
            let focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            if (isEditing && InputComponent) focusableElement = inputRef.current;
            const elementToFocus = focusableElement || cellRef.current;
            elementToFocus?.focus();
            apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
        }
    }, [
        InputComponent,
        apiRef,
        hasFocus,
        isEditing,
        isMenuOpen
    ]);
    const onKeyDown = $f2Y41.useCallback((event)=>{
        if (isMenuOpen || (0, $19fd75f0cc198aff$export$e13d96c38a470518)(event.key) || isFilterReadOnly) return;
        switch(event.key){
            case "Escape":
                if (isEditing) apiRef.current.stopHeaderFilterEditMode();
                break;
            case "Enter":
                if (isEditing) {
                    if (!event.defaultPrevented) {
                        apiRef.current.stopHeaderFilterEditMode();
                        break;
                    }
                }
                if (event.metaKey || event.ctrlKey) {
                    headerFilterMenuRef.current = buttonRef.current;
                    apiRef.current.showHeaderFilterMenu(colDef.field);
                    break;
                }
                apiRef.current.startHeaderFilterEditMode(colDef.field);
                break;
            case "Tab":
                if (isEditing) {
                    const fieldToFocus = columnFields[colIndex + (event.shiftKey ? -1 : 1)] ?? null;
                    if (fieldToFocus) {
                        apiRef.current.startHeaderFilterEditMode(fieldToFocus);
                        apiRef.current.setColumnHeaderFilterFocus(fieldToFocus, event);
                    }
                }
                break;
            default:
                if (isEditing || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) break;
                apiRef.current.startHeaderFilterEditMode(colDef.field);
                break;
        }
    }, [
        apiRef,
        colDef.field,
        colIndex,
        columnFields,
        headerFilterMenuRef,
        isEditing,
        isFilterReadOnly,
        isMenuOpen
    ]);
    const publish = $f2Y41.useCallback((eventName, propHandler)=>(event)=>{
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        colDef.field
    ]);
    const onMouseDown = $f2Y41.useCallback((event)=>{
        if (!hasFocus) {
            if (inputRef.current?.contains?.(event.target)) inputRef.current.focus();
            apiRef.current.setColumnHeaderFilterFocus(colDef.field, event);
        }
    }, [
        apiRef,
        colDef.field,
        hasFocus
    ]);
    const mouseEventsHandlers = $f2Y41.useMemo(()=>({
            onKeyDown: publish("headerFilterKeyDown", onKeyDown),
            onClick: publish("headerFilterClick"),
            onMouseDown: publish("headerFilterMouseDown", onMouseDown),
            onBlur: publish("headerFilterBlur")
        }), [
        onMouseDown,
        onKeyDown,
        publish
    ]);
    const showLeftBorder = (0, $5f42752ff27251f9$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection);
    const showRightBorder = (0, $5f42752ff27251f9$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
    const ownerState = (0, $asN9r.default)({}, rootProps, {
        pinnedPosition: pinnedPosition,
        colDef: colDef,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder
    });
    const classes = $9006c5cfbe3715c8$var$useUtilityClasses(ownerState);
    const isNoInputOperator = filterOperators?.find(({ value: value })=>item.operator === value)?.requiresFilterValue === false;
    const isApplied = Boolean(item?.value) || isNoInputOperator;
    const label = currentOperator.headerLabel ?? apiRef.current.getLocaleText(`headerFilterOperator${(0, $gl072.default)(item.operator)}`);
    const isFilterActive = isApplied || hasFocus;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, headerClassName),
        ref: handleRef,
        style: (0, $asN9r.default)({
            height: height,
            width: width,
            minWidth: width,
            maxWidth: width
        }, styleProp),
        role: "columnheader",
        "aria-colindex": colIndex + 1,
        "aria-label": headerFilterComponent == null ? colDef.headerName ?? colDef.field : undefined
    }, other, mouseEventsHandlers, {
        children: [
            headerFilterComponent,
            InputComponent && headerFilterComponent === undefined ? /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)(InputComponent, (0, $asN9r.default)({
                        apiRef: apiRef,
                        item: item,
                        inputRef: inputRef,
                        applyValue: applyFilterChanges,
                        onFocus: ()=>apiRef.current.startHeaderFilterEditMode(colDef.field),
                        onBlur: (event)=>{
                            apiRef.current.stopHeaderFilterEditMode();
                            // Blurring an input element should reset focus state only if `relatedTarget` is not the header filter cell
                            if (!event.relatedTarget?.className.includes("columnHeader")) apiRef.current.setState((state)=>(0, $asN9r.default)({}, state, {
                                    focus: {
                                        cell: null,
                                        columnHeader: null,
                                        columnHeaderFilter: null,
                                        columnGroupHeader: null
                                    }
                                }));
                        },
                        label: (0, $gl072.default)(label),
                        placeholder: "",
                        isFilterActive: isFilterActive,
                        clearButton: showClearIcon && isApplied ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d8db733cfc754eb8$export$a92783e4bfd82db8), {
                            onClick: clearFilterItem,
                            disabled: isFilterReadOnly
                        }) : null,
                        disabled: isFilterReadOnly || isNoInputOperator,
                        tabIndex: -1,
                        InputLabelProps: null,
                        sx: colDef.type === "date" || colDef.type === "dateTime" ? $9006c5cfbe3715c8$var$dateSx : undefined
                    }, isNoInputOperator ? {
                        value: ""
                    } : {}, currentOperator?.InputComponentProps, InputComponentProps)),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7db86980b5c174bb$export$9b7bd6eff38238f5), {
                        operators: filterOperators,
                        item: item,
                        field: colDef.field,
                        disabled: isFilterReadOnly,
                        applyFilterChanges: applyFilterChanges,
                        headerFilterMenuRef: headerFilterMenuRef,
                        buttonRef: buttonRef
                    })
                ]
            }) : null
        ]
    }));
});
const $9006c5cfbe3715c8$export$16e397805e5e4138 = (0, $677f46584a711a96$export$fa306e0bc9a9d6b4)($9006c5cfbe3715c8$var$GridHeaderFilterCell);



var $f2Y41 = parcelRequire("f2Y41");




const $efd1671fb1d4bdbc$export$e1fd9274eb96ee18 = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18);





var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $3652d6083645fceb$var$DetailPanel = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "DetailPanel",
    overridesResolver: (props, styles)=>styles.detailPanel
})(({ theme: theme })=>({
        width: "calc(var(--DataGrid-rowWidth) - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))",
        backgroundColor: (theme.vars || theme).palette.background.default,
        overflow: "auto"
    }));
function $3652d6083645fceb$export$904faaa9b81e46ab(props) {
    const { rowId: rowId, height: height, className: className, children: children } = props;
    const apiRef = (0, $efd1671fb1d4bdbc$export$e1fd9274eb96ee18)();
    const ref = $f2Y41.useRef(null);
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    const ownerState = rootProps;
    const hasAutoHeight = height === "auto";
    $f2Y41.useLayoutEffect(()=>{
        if (hasAutoHeight && typeof ResizeObserver === "undefined") // Fallback for IE
        apiRef.current.storeDetailPanelHeight(rowId, ref.current.clientHeight);
    }, [
        apiRef,
        hasAutoHeight,
        rowId
    ]);
    (0, $bea48bb7ec9bef87$export$683480f191c0e3ea)(ref, (entries)=>{
        const [entry] = entries;
        const observedHeight = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
        apiRef.current.storeDetailPanelHeight(rowId, observedHeight);
    }, hasAutoHeight);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($3652d6083645fceb$var$DetailPanel, {
        ref: ref,
        ownerState: ownerState,
        role: "presentation",
        style: {
            height: height
        },
        className: className,
        children: children
    });
}



var $ge3KO = parcelRequire("ge3KO");
const $db03f8d7bc36ed67$var$useUtilityClasses = ()=>{
    const slots = {
        detailPanel: [
            "detailPanel"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), {});
};
function $db03f8d7bc36ed67$export$aa888f5144097c35(props) {
    const rootProps = (0, $20e60525650ed0ec$export$8b0f8e71b71b7ed3)();
    if (!rootProps.getDetailPanelContent) return null;
    return /*#__PURE__*/ $f2Y41.createElement($db03f8d7bc36ed67$var$GridDetailPanelsImpl, props);
}
function $db03f8d7bc36ed67$var$GridDetailPanelsImpl({ virtualScroller: virtualScroller }) {
    const apiRef = (0, $efd1671fb1d4bdbc$export$e1fd9274eb96ee18)();
    const classes = $db03f8d7bc36ed67$var$useUtilityClasses();
    const { setPanels: setPanels } = virtualScroller;
    const expandedRowIds = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $e5450c6ab5b66c44$export$2e51858b6eeff6ad));
    const detailPanelsContent = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $e5450c6ab5b66c44$export$16fba932632c70f0));
    const detailPanelsHeights = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $e5450c6ab5b66c44$export$f8466bb36c8b9813));
    const getDetailPanel = $f2Y41.useCallback((rowId)=>{
        const content = detailPanelsContent[rowId];
        // Check if the id exists in the current page
        const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
        const exists = rowIndex !== undefined;
        if (!/*#__PURE__*/ $f2Y41.isValidElement(content) || !exists) return null;
        const hasAutoHeight = apiRef.current.detailPanelHasAutoHeight(rowId);
        const height = hasAutoHeight ? "auto" : detailPanelsHeights[rowId];
        return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3652d6083645fceb$export$904faaa9b81e46ab), {
            rowId: rowId,
            height: height,
            className: classes.detailPanel,
            children: content
        }, `panel-${rowId}`);
    }, [
        apiRef,
        classes.detailPanel,
        detailPanelsHeights,
        detailPanelsContent
    ]);
    $f2Y41.useEffect(()=>{
        if (expandedRowIds.length === 0) setPanels((0, $0ef91cf32c4de50f$export$68a3509179402d90));
        else setPanels(new Map(expandedRowIds.map((rowId)=>[
                rowId,
                getDetailPanel(rowId)
            ])));
    }, [
        expandedRowIds,
        setPanels,
        getDetailPanel
    ]);
    return null;
}



var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
const $173b654b1aad0a8b$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "pinnedRows"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), {});
};
function $173b654b1aad0a8b$export$58309d5251e10b9e({ position: position, virtualScroller: virtualScroller }) {
    const classes = $173b654b1aad0a8b$var$useUtilityClasses();
    const apiRef = (0, $ce64d818c6a4c305$export$e1fd9274eb96ee18)();
    const renderContext = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $de91a359006882c0$export$4cf9f333a030f780));
    const pinnedRowsData = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b2a98a8b3d22f914$export$ffe7071c481e32b0));
    const rows = pinnedRowsData[position];
    const pinnedRenderContext = $f2Y41.useMemo(()=>({
            firstRowIndex: 0,
            lastRowIndex: rows.length,
            firstColumnIndex: renderContext.firstColumnIndex,
            lastColumnIndex: renderContext.lastColumnIndex
        }), [
        rows,
        renderContext.firstColumnIndex,
        renderContext.lastColumnIndex
    ]);
    if (rows.length === 0) return null;
    const pinnedRows = virtualScroller.getRows({
        position: position,
        rows: rows,
        renderContext: pinnedRenderContext
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, (0, $2276c81b0f2e6e46$export$2100d54e36406477)[`pinnedRows--${position}`]),
        role: "presentation",
        children: pinnedRows
    });
}



var $asN9r = parcelRequire("asN9r");
parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
const $0ac94f42b695f372$export$8bcde6e7c950b7bb = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("g", {
    transform: "rotate(-30 15 10)",
    children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
        d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
        fillRule: "evenodd"
    })
}), "PushPinRight");
const $0ac94f42b695f372$export$934f0393007cf804 = (0, $8fda59987ff84c61$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ge3KO.jsx)("g", {
    transform: "rotate(30 8 12)",
    children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
        d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
        fillRule: "evenodd"
    })
}), "PushPinLeft");


const $15ec10ef059976d6$var$iconSlots = {
    columnMenuPinRightIcon: (0, $0ac94f42b695f372$export$8bcde6e7c950b7bb),
    columnMenuPinLeftIcon: (0, $0ac94f42b695f372$export$934f0393007cf804)
};
const $15ec10ef059976d6$var$materialSlots = (0, $asN9r.default)({}, $15ec10ef059976d6$var$iconSlots);
var $15ec10ef059976d6$export$2e2bcd8739ae039 = $15ec10ef059976d6$var$materialSlots;


const $5e916d02475c8046$export$c14e35b3658b0aa7 = (0, $asN9r.default)({}, (0, $9fa0f0a5762213ca$export$8a57bda01657743f), (0, $15ec10ef059976d6$export$2e2bcd8739ae039), {
    columnMenu: (0, $d5913d711cbb20c6$export$49bc76a234ac21c2),
    columnHeaders: (0, $45d16251217486ee$export$4a3a74c44d0a6c04),
    detailPanels: (0, $db03f8d7bc36ed67$export$aa888f5144097c35),
    headerFilterCell: (0, $9006c5cfbe3715c8$export$16e397805e5e4138),
    headerFilterMenu: (0, $6b62ee6ae18a27c6$export$5d70bc2c3a60b060),
    pinnedRows: (0, $173b654b1aad0a8b$export$58309d5251e10b9e)
});


const $4e219bc587b982c5$export$ebb4682394199754 = (0, $asN9r.default)({}, (0, $bfac834c55a2f88a$export$2733e0e1a1d288e7), {
    scrollEndThreshold: 80,
    treeData: false,
    defaultGroupingExpansionDepth: 0,
    autosizeOnMount: false,
    disableAutosize: false,
    disableColumnPinning: false,
    keepColumnPositionIfDraggedOutside: false,
    disableChildrenFiltering: false,
    disableChildrenSorting: false,
    rowReordering: false,
    rowsLoadingMode: "client",
    getDetailPanelHeight: ()=>500,
    headerFilters: false
});
const $4e219bc587b982c5$var$defaultSlots = (0, $5e916d02475c8046$export$c14e35b3658b0aa7);
const $4e219bc587b982c5$export$decfffa8129564f4 = (inProps)=>{
    const themedProps = (0, $cf2708d4c6363cc3$export$1f264be2c424fccf)(// eslint-disable-next-line material-ui/mui-name-matches-component-name
    (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiDataGrid"
    }));
    const localeText = $f2Y41.useMemo(()=>(0, $asN9r.default)({}, (0, $ba665b27813960ac$export$d217cc4e11b3c706), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $f2Y41.useMemo(()=>(0, $c0dbf612fe4dcc20$export$247af54f7c54fca)({
            defaultSlots: $4e219bc587b982c5$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    return $f2Y41.useMemo(()=>(0, $asN9r.default)({}, $4e219bc587b982c5$export$ebb4682394199754, themedProps, {
            localeText: localeText,
            slots: slots,
            signature: "DataGridPro"
        }), [
        themedProps,
        localeText,
        slots
    ]);
};



const $0c0adad9d0fe06ef$export$edcd7d0b4c3818f = ()=>{
    const releaseInfo = "MTcxNDYwMDgwMDAwMA==";
    return releaseInfo;
};



const $e16bb960bd1efa22$export$b15946ee5da4a136 = [
    ...(0, $b5591cf353b711e9$export$1148b1624361a0f3),
    (props)=>props.pagination && props.hideFooterRowCount && "MUI X: The `hideFooterRowCount` prop has no effect when the pagination is enabled." || undefined,
    (props)=>props.treeData && props.filterMode === "server" && 'MUI X: The `filterMode="server"` prop is not available when the `treeData` is enabled.' || undefined,
    (props)=>!props.pagination && props.checkboxSelectionVisibleOnly && "MUI X: The `checkboxSelectionVisibleOnly` prop has no effect when the pagination is not enabled." || undefined,
    (props)=>props.signature !== (0, $71512ea7dac91a28$export$544be0bdf85b5af1).DataGrid && props.paginationMode === "client" && props.rowsLoadingMode !== "server" && (0, $2b59f632c4f96fc9$export$7e4aa119212bc614)(props.rowCount) && 'MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect. `rowCount` is only meant to be used with `paginationMode="server"`.' || undefined
];



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $474f4e4597ff512d$var$releaseInfo = (0, $0c0adad9d0fe06ef$export$edcd7d0b4c3818f)();
const $474f4e4597ff512d$var$DataGridProRaw = /*#__PURE__*/ $f2Y41.forwardRef(function DataGridPro(inProps, ref) {
    const props = (0, $4e219bc587b982c5$export$decfffa8129564f4)(inProps);
    const privateApiRef = (0, $a405ede6c1183d55$export$ae01925210967ff3)(props.apiRef, props);
    (0, $833e87c557c1a10f$export$bd780281ba7bfd9)("x-data-grid-pro", $474f4e4597ff512d$var$releaseInfo);
    (0, $b5591cf353b711e9$export$45855e0dd982478b)(props, (0, $e16bb960bd1efa22$export$b15946ee5da4a136));
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $248d6f2656fe196f$export$4fd26c08a15cabb4), {
        privateApiRef: privateApiRef,
        props: props,
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $8ed2ee66cca3d652$export$8cdbcd3b320d39bf), (0, $asN9r.default)({
            className: props.className,
            style: props.style,
            sx: props.sx,
            ref: ref
        }, props.forwardedProps, {
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d3f1a76f387112bb$export$74ac40502a3200d3), {}),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7798873cda22cc6e$export$febd8ae712031b27), {
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $dac79d818b84db2a$export$e94943a72132ebdf), {
                        packageName: "x-data-grid-pro",
                        releaseInfo: $474f4e4597ff512d$var$releaseInfo
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e5465f61488c59e8$export$6d80c98441abb3ab), {})
            ]
        }))
    });
});
const $474f4e4597ff512d$export$97fd8aadf70de81f = /*#__PURE__*/ $f2Y41.memo($474f4e4597ff512d$var$DataGridProRaw);
$474f4e4597ff512d$var$DataGridProRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object.isRequired
    }),
    /**
   * The label of the Data Grid.
   */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string,
    /**
   * The id of the element containing a label for the Data Grid.
   */ "aria-labelledby": (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string,
    /**
   * If `true`, the Data Grid height is dynamic and follow the number of rows in the Data Grid.
   * @default false
   */ autoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string),
        expand: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
        includeHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
        includeOutliers: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
        outliersFactor: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the "Select All" header checkbox selects only the rows on the current page. To be used in combination with `checkboxSelection`.
   * It only works if the pagination is enabled.
   * @default false
   */ checkboxSelectionVisibleOnly: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string,
    /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */ columnBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    columnGroupingModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Set of columns of type [[GridColDef]][].
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object).isRequired,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * If above 0, the row children will be expanded up to this depth.
   * If equal to -1, all the row children will be expanded.
   * @default 0
   */ defaultGroupingExpansionDepth: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "comfortable",
        "compact",
        "standard"
    ]),
    /**
   * The row ids to show the detail panel.
   */ detailPanelExpandedRowIds: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string
    ]).isRequired),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the filtering will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */ disableChildrenFiltering: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the sorting will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */ disableChildrenSorting: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the column pinning is disabled.
   * @default false
   */ disableColumnPinning: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, reordering columns is disabled.
   * @default false
   */ disableColumnReorder: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */ disableColumnSorting: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, filtering with multiple columns is disabled.
   * @default false
   */ disableMultipleColumnsFiltering: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the sorting with multiple columns is disabled.
   * @default false
   */ disableMultipleColumnsSorting: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */ disableMultipleRowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "cell",
        "row"
    ]),
    /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */ estimatedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        warnIfFocusStateIsNotSynced: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "client",
        "server"
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        items: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
            field: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string
            ]),
            operator: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).any
        })).isRequired,
        logicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
            "and",
            "or"
        ]),
        quickFilterExcludeHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
        quickFilterLogicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
            "and",
            "or"
        ]),
        quickFilterValues: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).array
    }),
    /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */ forwardedProps: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Function that returns the height of the row detail panel.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {number | string} The height in pixels or "auto" to use the content height.
   * @default "() => 500"
   */ getDetailPanelHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Return the id of a given [[GridRowModel]].
   */ getRowId: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Determines the path of a row in the tree data.
   * For instance, a row with the path ["A", "B"] is the child of the row with the path ["A"].
   * Note that all paths must contain at least one element.
   * @template R
   * @param {R} row The row from which we want the path.
   * @returns {string[]} The path to the row.
   */ getTreeDataPath: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * The grouping column used by the tree data.
   */ groupingColDef: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object
    ]),
    /**
   * Override the height of the header filters.
   */ headerFilterHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * If `true`, enables the data grid filtering on header feature.
   * @default false
   */ headerFilters: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the row count in the footer is hidden.
   * It has no effect if the pagination is enabled.
   * @default false
   */ hideFooterRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ ignoreValueFormatterDuringExport: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
            clipboardExport: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
            csvExport: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool
    ]),
    /**
   * The initial state of the DataGridPro.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Determines if a group should be expanded after its creation.
   * This prop takes priority over the `defaultGroupingExpansionDepth` prop.
   * @param {GridGroupNode} node The node of the group to test.
   * @returns {boolean} A boolean indicating if the group is expanded.
   */ isGroupExpandedByDefault: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the cell is selectable.
   */ isRowSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * If `true`, moving the mouse pointer outside the grid before releasing the mouse button
   * in a column re-order action will not cause the column to jump back to its original position.
   * @default false
   */ keepColumnPositionIfDraggedOutside: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, a loading overlay is displayed.
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        debug: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func.isRequired,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func.isRequired,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func.isRequired,
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "debug",
        "error",
        "info",
        "warn",
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */ onDensityChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the detail panel of a row is opened or closed.
   * @param {GridRowId[]} ids The ids of the rows which have the detail panel open.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onDetailPanelExpandedRowIdsChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when rowCount is set and the next batch of virtualized rows is rendered.
   * @param {GridFetchRowsParams} params With all properties from [[GridFetchRowsParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFetchRows: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */ onPaginationMetaChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the pinned columns have changed.
   * @param {GridPinnedColumnFields} pinnedColumns The changed pinned columns.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPinnedColumnsChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when a row is being reordered.
   * @param {GridRowOrderChangeParams} params With all properties from [[GridRowOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when scrolling to the bottom of the grid viewport.
   * @param {GridRowScrollEndParams} params With all properties from [[GridRowScrollEndParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowsScrollEnd: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number.isRequired
        })
    ]).isRequired),
    /**
   * If `true`, pagination is enabled.
   * @default false
   */ pagination: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */ paginationMeta: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        hasNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool
    }),
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "client",
        "server"
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number.isRequired,
        pageSize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number.isRequired
    }),
    /**
   * The column fields to display pinned to left or right.
   */ pinnedColumns: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * Rows data to pin on top or bottom.
   */ pinnedRows: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object)
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */ resizeThrottleMs: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */ rowBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */ rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   */ rowPositionsDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * If `true`, the reordering of rows is enabled.
   * @default false
   */ rowReordering: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object),
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string
        ]).isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string
    ]),
    /**
   * Loading rows can be processed on the server or client-side.
   * Set it to 'client' if you would like enable infnite loading.
   * Set it to 'server' if you would like to enable lazy loading.
   * * @default "client"
   */ rowsLoadingMode: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "client",
        "server"
    ]),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "border",
        "margin"
    ]),
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Set the area in `px` at the bottom of the grid viewport where onRowsScrollEnd is called.
   * @default 80
   */ scrollEndThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * If `true`, the vertical borders of the cells are displayed.
   * @default false
   */ showCellVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If `true`, the right border of the column headers are displayed.
   * @default false
   */ showColumnVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * Overridable components.
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "client",
        "server"
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
        "asc",
        "desc"
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string.isRequired,
        sort: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOf([
            "asc",
            "desc"
        ])
    })),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).object
    ]),
    /**
   * If positive, the Data Grid will throttle updates coming from `apiRef.current.updateRows` and `apiRef.current.setRows`.
   * It can be useful if you have a high update rate but do not want to do heavy work like filtering / sorting or rendering on each  individual update.
   * @default 0
   */ throttleRowsMs: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * If `true`, the rows will be gathered in a tree structure according to the `getTreeDataPath` prop.
   * @default false
   */ treeData: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool
};




var $ge3KO = parcelRequire("ge3KO");
function $0bb17adeece2ee72$export$70d0618c8112500f(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "p-4 md:flex md:items-center md:justify-between",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-1 min-w-0",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                    className: "text-2xl font-bold leading-7 sm:text-3xl sm:truncate dark:text-gray-200",
                    children: props.title
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-4 flex md:mt-0 md:ml-4",
                children: props.children
            })
        ]
    });
}





function $158f6e50d612d360$export$363c7374d425f4ad() {
    const { data: data, isLoading: isLoading, isError: isError } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("conditions");
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 300
        },
        {
            field: "type",
            headerName: "Type",
            width: 120
        },
        {
            field: "source",
            headerName: "Source",
            width: 120
        },
        {
            field: "upload_id",
            headerName: "Upload",
            width: 120
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    const sortModel = [
        {
            field: "name",
            sort: "asc"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Conditions",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                    to: "/uploads",
                    className: "flex",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                        icon: "PlusCircleIcon",
                        text: "Upload Conditions"
                    })
                })
            }),
            isLoading ? "Loading.." : "",
            isError ? "Failed to load" : "",
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns,
                        sortModel: sortModel
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




const $ab3059e3726110c9$export$ce4ab0c55987d1ff = (...classes)=>{
    return classes.filter(Boolean).join(" ");
};


function $aacba43ee8d7e034$export$f9c0b4e215944762() {
    const refreshWhenHidden = false;
    const { data: events, mutate: eventsMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("events", "", {
        refreshInterval: 250,
        refreshWhenHidden: refreshWhenHidden
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "p-6",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("h5", {
                className: "text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-200 flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                        icon: "SpeakerphoneIcon",
                        className: "h-5 mr-2 self-center"
                    }),
                    "Events"
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flow-root mt-5",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("ul", {
                    role: "list",
                    className: "-mb-8",
                    children: events.map((event, eventIdx)=>/*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "relative pb-8",
                                children: [
                                    eventIdx !== events.length - 1 ? /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200  dark:bg-gray-600",
                                        "aria-hidden": "true"
                                    }) : null,
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "relative flex items-start space-x-3",
                                        children: event.name === "PatientCommentCreate" ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                                                            className: "h-10 w-10 rounded-full bg-gray-400 dark:bg-gray-600 flex items-center justify-center ring-8 ring-white",
                                                            src: event?.imageUrl,
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $57be9eca594eb68b$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 text-gray-400 dark:text-gray-700",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "min-w-0 flex-1",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "text-sm",
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "font-medium text-gray-900 dark:text-gray-200",
                                                                    children: event.created_by?.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                                                className: "mt-0.5 text-sm text-gray-500 dark:text-gray-400",
                                                                children: [
                                                                    "Commented ",
                                                                    event.date,
                                                                    " on",
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                                        className: "text-gray-700",
                                                                        to: `/patients/${event.meta.patient_id}`,
                                                                        children: "a patient"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                                        className: "whitespace-nowrap",
                                                                        children: [
                                                                            " ",
                                                                            "at ",
                                                                            event.created_at
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }) : event.type === "assignment" ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "relative px-1",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            className: "h-8 w-8 bg-gray-100  dark:bg-gray-600 rounded-full ring-8 ring-white flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6f0870b045c87ef6$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 text-gray-500 dark:text-gray-400  ",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "min-w-0 flex-1 py-1.5",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "text-sm text-gray-500 dark:text-gray-400",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                                href: event.person.href,
                                                                className: "font-medium text-gray-900 dark:text-gray-200",
                                                                children: event.person.name
                                                            }),
                                                            " ",
                                                            "assigned",
                                                            " ",
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                                href: event.assigned.href,
                                                                className: "font-medium text-gray-900 dark:text-gray-200",
                                                                children: event.assigned.name
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "whitespace-nowrap",
                                                                children: event.date
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }) : event.type === "tags" ? /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "relative px-1",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            className: "h-8 w-8 bg-gray-100  dark:bg-gray-600 rounded-full ring-8 ring-white flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $25c0a1e5aaf50daf$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 text-gray-500 dark:text-gray-400",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "min-w-0 flex-1 py-0",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "text-sm leading-8 text-gray-500 dark:text-gray-400",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                                className: "mr-0.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                                        href: event.person.href,
                                                                        className: "font-medium text-gray-900 dark:text-gray-200",
                                                                        children: event.person.name
                                                                    }),
                                                                    " ",
                                                                    "added tags"
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "mr-0.5",
                                                                children: event.tags.map((tag)=>/*#__PURE__*/ (0, $ge3KO.jsxs)((0, $f2Y41.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("a", {
                                                                                href: tag.href,
                                                                                className: "relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5 text-sm",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                                        className: "absolute flex-shrink-0 flex items-center justify-center",
                                                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                                            className: (0, $ab3059e3726110c9$export$ce4ab0c55987d1ff)(tag.color, "h-1.5 w-1.5 rounded-full"),
                                                                                            "aria-hidden": "true"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                                        className: "ml-3.5 font-medium text-gray-900 dark:text-gray-200",
                                                                                        children: tag.name
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            " "
                                                                        ]
                                                                    }, tag.name))
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "whitespace-nowrap",
                                                                children: event.date
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "relative px-1",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            className: "h-8 w-8 bg-gray-100 dark:bg-gray-600 rounded-full ring-8 ring-white dark:ring-gray-600 flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6f0870b045c87ef6$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 text-gray-500 dark:text-gray-400",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "min-w-0 flex-1 py-1.5",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "text-sm text-gray-500 dark:text-gray-400",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                                href: "#",
                                                                className: "font-medium text-gray-900 dark:text-gray-200",
                                                                children: event.name
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                children: " by "
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "inline font-medium text-gray-900 dark:text-gray-200",
                                                                children: event.created_by?.name || "Unknown User"
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                                className: "whitespace-nowrap",
                                                                children: [
                                                                    " ",
                                                                    "at ",
                                                                    event.created_at
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("pre", {
                                                                children: JSON.stringify(event.meta, null, 2)
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, event.id))
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");






function $1007a57a4247a8f3$export$2868d2a917920a44() {
    const { data: data, isLoading: isLoading, isError: isError } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("medications");
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 250
        },
        {
            field: "type",
            headerName: "Type",
            width: 120
        },
        {
            field: "source",
            headerName: "Source",
            width: 120
        },
        {
            field: "upload_id",
            headerName: "Upload",
            width: 120
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    const sortModel = [
        {
            field: "name",
            sort: "asc"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Medications",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                    to: "/uploads",
                    className: "flex",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                        icon: "PlusCircleIcon",
                        text: "Upload Conditions"
                    })
                })
            }),
            isLoading ? "Loading.." : "",
            isError ? "Failed to load" : "",
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns,
                        sortModel: sortModel
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

function $8eb36408212e470e$export$77e43c3894961eb() {
    const { data: data } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("metabase_iframes", "patient-finder");
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: data && /*#__PURE__*/ (0, $ge3KO.jsx)("iframe", {
            src: data,
            frameBorder: 0,
            className: "inset-0 w-full h-full",
            allowTransparency: true
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");
const $1680f2c298b4061f$var$_excluded = [
    "className",
    "children"
];
const $1680f2c298b4061f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "toolbarContainer"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $1680f2c298b4061f$var$GridToolbarContainerRoot = (0, $90ca805a8f1be5a9$export$2e2bcd8739ae039)("div", {
    name: "MuiDataGrid",
    slot: "ToolbarContainer",
    overridesResolver: (_, styles)=>styles.toolbarContainer
})(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        padding: theme.spacing(0.5, 0.5, 0)
    }));
const $1680f2c298b4061f$export$276ebf2f43e1afe0 = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbarContainer(props, ref) {
    const { className: className, children: children } = props, other = (0, $bKcdJ.default)(props, $1680f2c298b4061f$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $1680f2c298b4061f$var$useUtilityClasses(rootProps);
    if (!children) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)($1680f2c298b4061f$var$GridToolbarContainerRoot, (0, $asN9r.default)({
        ref: ref,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: rootProps
    }, other, {
        children: children
    }));
});



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $b8fdbc08d9d83345$export$9460f81121783d0f = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbarColumnsButton(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const columnButtonId = (0, $4affeda36512a992$export$2e2bcd8739ae039)();
    const columnPanelId = (0, $4affeda36512a992$export$2e2bcd8739ae039)();
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const preferencePanel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $89c72c98e1cc6fad$export$37e5474577e02878));
    const showColumns = (event)=>{
        if (preferencePanel.open && preferencePanel.openedPanelValue === (0, $3f22a63fe503dede$export$e7e5652452e44b).columns) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, $3f22a63fe503dede$export$e7e5652452e44b).columns, columnPanelId, columnButtonId);
        buttonProps.onClick?.(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnSelector) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === columnPanelId;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
        title: apiRef.current.getLocaleText("toolbarColumnsLabel"),
        enterDelay: 1000
    }, tooltipProps, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
            ref: ref,
            id: columnButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText("toolbarColumnsLabel"),
            "aria-haspopup": "menu",
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? columnPanelId : undefined,
            startIcon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.columnSelectorIcon, {})
        }, buttonProps, {
            onClick: showColumns
        }, rootProps.slotProps?.baseButton, {
            children: apiRef.current.getLocaleText("toolbarColumns")
        }))
    }));
});



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");













var $ge3KO = parcelRequire("ge3KO");
const $6483f3aa6dfcd604$export$39ae0f666777d9ba = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbarDensitySelector(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const density = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $a8df3c1fd8492eab$export$806a039ece4425b4));
    const densityButtonId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const densityMenuId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const [open, setOpen] = $f2Y41.useState(false);
    const buttonRef = $f2Y41.useRef(null);
    const handleRef = (0, $b5011b61ae0cb30b$export$2e2bcd8739ae039)(ref, buttonRef);
    const densityOptions = [
        {
            icon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.densityCompactIcon, {}),
            label: apiRef.current.getLocaleText("toolbarDensityCompact"),
            value: "compact"
        },
        {
            icon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.densityStandardIcon, {}),
            label: apiRef.current.getLocaleText("toolbarDensityStandard"),
            value: "standard"
        },
        {
            icon: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.densityComfortableIcon, {}),
            label: apiRef.current.getLocaleText("toolbarDensityComfortable"),
            value: "comfortable"
        }
    ];
    const startIcon = $f2Y41.useMemo(()=>{
        switch(density){
            case "compact":
                return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.densityCompactIcon, {});
            case "comfortable":
                return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.densityComfortableIcon, {});
            default:
                return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.densityStandardIcon, {});
        }
    }, [
        density,
        rootProps
    ]);
    const handleDensitySelectorOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleDensitySelectorClose = ()=>{
        setOpen(false);
    };
    const handleDensityUpdate = (newDensity)=>{
        apiRef.current.setDensity(newDensity);
        setOpen(false);
    };
    const handleListKeyDown = (event)=>{
        if ((0, $19fd75f0cc198aff$export$34e5042f80daa3dd)(event.key)) event.preventDefault();
        if ((0, $19fd75f0cc198aff$export$81301abbcd0c8143)(event.key)) setOpen(false);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableDensitySelector) return null;
    const densityElements = densityOptions.map((option, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)((0, $32815546ad734a59$export$2e2bcd8739ae039), {
            onClick: ()=>handleDensityUpdate(option.value),
            selected: option.value === density,
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fe67a5c709d35788$export$2e2bcd8739ae039), {
                    children: option.icon
                }),
                option.label
            ]
        }, index));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($f2Y41.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
                title: apiRef.current.getLocaleText("toolbarDensityLabel"),
                enterDelay: 1000
            }, tooltipProps, rootProps.slotProps?.baseTooltip, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
                    ref: handleRef,
                    size: "small",
                    startIcon: startIcon,
                    "aria-label": apiRef.current.getLocaleText("toolbarDensityLabel"),
                    "aria-haspopup": "menu",
                    "aria-expanded": open,
                    "aria-controls": open ? densityMenuId : undefined,
                    id: densityButtonId
                }, buttonProps, {
                    onClick: handleDensitySelectorOpen
                }, rootProps.slotProps?.baseButton, {
                    children: apiRef.current.getLocaleText("toolbarDensity")
                }))
            })),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f1a3f9a2e160d201$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                onClose: handleDensitySelectorClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d203149adb48b43d$export$2e2bcd8739ae039), {
                    id: densityMenuId,
                    className: (0, $2276c81b0f2e6e46$export$2100d54e36406477).menuList,
                    "aria-labelledby": densityButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: densityElements
                })
            })
        ]
    });
});



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");



var $gl072 = parcelRequire("gl072");










var $ge3KO = parcelRequire("ge3KO");
const $4e9d707e463edef0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "toolbarFilterList"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $4e9d707e463edef0$var$GridToolbarFilterListRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("ul", {
    name: "MuiDataGrid",
    slot: "ToolbarFilterList",
    overridesResolver: (_props, styles)=>styles.toolbarFilterList
})(({ theme: theme })=>({
        margin: theme.spacing(1, 1, 0.5),
        padding: theme.spacing(0, 1)
    }));
const $4e9d707e463edef0$export$eef6782de2aba6b = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbarFilterButton(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const activeFilters = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$c7447bfbd4ecafcc));
    const lookup = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $b22d10f7b8994eba$export$8a3a9a6db584d7fd));
    const preferencePanel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $89c72c98e1cc6fad$export$37e5474577e02878));
    const classes = $4e9d707e463edef0$var$useUtilityClasses(rootProps);
    const filterButtonId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const filterPanelId = (0, $2599ce271b2f22b2$export$2e2bcd8739ae039)();
    const tooltipContentNode = $f2Y41.useMemo(()=>{
        if (preferencePanel.open) return apiRef.current.getLocaleText("toolbarFiltersTooltipHide");
        if (activeFilters.length === 0) return apiRef.current.getLocaleText("toolbarFiltersTooltipShow");
        const getOperatorLabel = (item)=>lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator).label || apiRef.current.getLocaleText(`filterOperator${(0, $gl072.default)(item.operator)}`).toString();
        const getFilterItemValue = (item)=>{
            const { getValueAsString: getValueAsString } = lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator);
            return getValueAsString ? getValueAsString(item.value) : item.value;
        };
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            children: [
                apiRef.current.getLocaleText("toolbarFiltersTooltipActive")(activeFilters.length),
                /*#__PURE__*/ (0, $ge3KO.jsx)($4e9d707e463edef0$var$GridToolbarFilterListRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: activeFilters.map((item, index)=>(0, $asN9r.default)({}, lookup[item.field] && /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                            children: `${lookup[item.field].headerName || item.field}
                  ${getOperatorLabel(item)}
                  ${// implicit check for null and undefined
                            item.value != null ? getFilterItemValue(item) : ""}`
                        }, index)))
                })
            ]
        });
    }, [
        apiRef,
        rootProps,
        preferencePanel.open,
        activeFilters,
        lookup,
        classes
    ]);
    const toggleFilter = (event)=>{
        const { open: open, openedPanelValue: openedPanelValue } = preferencePanel;
        if (open && openedPanelValue === (0, $3f22a63fe503dede$export$e7e5652452e44b).filters) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, $3f22a63fe503dede$export$e7e5652452e44b).filters, filterPanelId, filterButtonId);
        buttonProps.onClick?.(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnFilter) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === filterPanelId;
    return /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseTooltip, (0, $asN9r.default)({
        title: tooltipContentNode,
        enterDelay: 1000
    }, tooltipProps, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseButton, (0, $asN9r.default)({
            ref: ref,
            id: filterButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText("toolbarFiltersLabel"),
            "aria-controls": isOpen ? filterPanelId : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            startIcon: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34e12ad74fb61570$export$2e2bcd8739ae039), {
                badgeContent: activeFilters.length,
                color: "primary",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.openFilterButtonIcon, {})
            })
        }, buttonProps, {
            onClick: toggleFilter
        }, rootProps.slotProps?.baseButton, {
            children: apiRef.current.getLocaleText("toolbarFilters")
        }))
    }));
});





var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $f2Y41 = parcelRequire("f2Y41");













var $ge3KO = parcelRequire("ge3KO");
const $9eb7c2ebe4fab68a$var$_excluded = [
    "quickFilterParser",
    "quickFilterFormatter",
    "debounceMs",
    "className"
];
const $9eb7c2ebe4fab68a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "toolbarQuickFilter"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $2276c81b0f2e6e46$export$a2aa36217b862c23), classes);
};
const $9eb7c2ebe4fab68a$var$GridToolbarQuickFilterRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
    name: "MuiDataGrid",
    slot: "ToolbarQuickFilter",
    overridesResolver: (props, styles)=>styles.toolbarQuickFilter
})(({ theme: theme })=>({
        width: "auto",
        paddingBottom: theme.spacing(0.5),
        "& input": {
            marginLeft: theme.spacing(0.5)
        },
        "& .MuiInput-underline:before": {
            borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        [`& input[type=search]::-ms-clear,
& input[type=search]::-ms-reveal`]: {
            /* clears the 'X' icon from IE */ display: "none",
            width: 0,
            height: 0
        },
        [`& input[type="search"]::-webkit-search-decoration,
  & input[type="search"]::-webkit-search-cancel-button,
  & input[type="search"]::-webkit-search-results-button,
  & input[type="search"]::-webkit-search-results-decoration`]: {
            /* clears the 'X' icon from Chrome */ display: "none"
        }
    }));
const $9eb7c2ebe4fab68a$var$defaultSearchValueParser = (searchText)=>searchText.split(" ").filter((word)=>word !== "");
const $9eb7c2ebe4fab68a$var$defaultSearchValueFormatter = (values)=>values.join(" ");
function $9eb7c2ebe4fab68a$export$d7fbfb032c6d5ccc(props) {
    const apiRef = (0, $33728c8b9d37d8bf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    const classes = $9eb7c2ebe4fab68a$var$useUtilityClasses(rootProps);
    const quickFilterValues = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$6f9fe133e2c56816));
    const { quickFilterParser: quickFilterParser = $9eb7c2ebe4fab68a$var$defaultSearchValueParser, quickFilterFormatter: quickFilterFormatter = $9eb7c2ebe4fab68a$var$defaultSearchValueFormatter, debounceMs: debounceMs = rootProps.filterDebounceMs, className: className } = props, other = (0, $bKcdJ.default)(props, $9eb7c2ebe4fab68a$var$_excluded);
    const [searchValue, setSearchValue] = $f2Y41.useState(()=>quickFilterFormatter(quickFilterValues ?? []));
    const prevQuickFilterValuesRef = $f2Y41.useRef(quickFilterValues);
    $f2Y41.useEffect(()=>{
        if (!(0, $2b59f632c4f96fc9$export$78fdc9adc3f30400)(prevQuickFilterValuesRef.current, quickFilterValues)) {
            // The model of quick filter value has been updated
            prevQuickFilterValuesRef.current = quickFilterValues;
            // Update the input value if needed to match the new model
            setSearchValue((prevSearchValue)=>(0, $2b59f632c4f96fc9$export$78fdc9adc3f30400)(quickFilterParser(prevSearchValue), quickFilterValues) ? prevSearchValue : quickFilterFormatter(quickFilterValues ?? []));
        }
    }, [
        quickFilterValues,
        quickFilterFormatter,
        quickFilterParser
    ]);
    const updateSearchValue = $f2Y41.useCallback((newSearchValue)=>{
        const newQuickFilterValues = quickFilterParser(newSearchValue);
        prevQuickFilterValuesRef.current = newQuickFilterValues;
        apiRef.current.setQuickFilterValues(newQuickFilterValues);
    }, [
        apiRef,
        quickFilterParser
    ]);
    const debouncedUpdateSearchValue = $f2Y41.useMemo(()=>(0, $71559b3d0d8c73fb$export$2e2bcd8739ae039)(updateSearchValue, debounceMs), [
        updateSearchValue,
        debounceMs
    ]);
    const handleSearchValueChange = $f2Y41.useCallback((event)=>{
        const newSearchValue = event.target.value;
        setSearchValue(newSearchValue);
        debouncedUpdateSearchValue(newSearchValue);
    }, [
        debouncedUpdateSearchValue
    ]);
    const handleSearchReset = $f2Y41.useCallback(()=>{
        setSearchValue("");
        updateSearchValue("");
    }, [
        updateSearchValue
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)($9eb7c2ebe4fab68a$var$GridToolbarQuickFilterRoot, (0, $asN9r.default)({
        as: rootProps.slots.baseTextField,
        ownerState: rootProps,
        variant: "standard",
        value: searchValue,
        onChange: handleSearchValueChange,
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(className, classes.root),
        placeholder: apiRef.current.getLocaleText("toolbarQuickFilterPlaceholder"),
        "aria-label": apiRef.current.getLocaleText("toolbarQuickFilterLabel"),
        type: "search"
    }, other, {
        InputProps: (0, $asN9r.default)({
            startAdornment: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.quickFilterIcon, {
                fontSize: "small"
            }),
            endAdornment: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.baseIconButton, (0, $asN9r.default)({
                "aria-label": apiRef.current.getLocaleText("toolbarQuickFilterDeleteIconLabel"),
                size: "small",
                sx: {
                    visibility: searchValue ? "visible" : "hidden"
                },
                onClick: handleSearchReset
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)(rootProps.slots.quickFilterClearIcon, {
                    fontSize: "small"
                })
            }))
        }, other.InputProps)
    }, rootProps.slotProps?.baseTextField));
}



var $ge3KO = parcelRequire("ge3KO");
const $95c56b12e832f314$var$_excluded = [
    "className",
    "csvOptions",
    "printOptions",
    "excelOptions",
    "showQuickFilter",
    "quickFilterProps"
];
const $95c56b12e832f314$export$6f17559aa1de380e = /*#__PURE__*/ $f2Y41.forwardRef(function GridToolbar(props, ref) {
    // TODO v7: think about where export option should be passed.
    // from slotProps={{ toolbarExport: { ...exportOption } }} seems to be more appropriate
    const { csvOptions: csvOptions, printOptions: printOptions, excelOptions: excelOptions, showQuickFilter: showQuickFilter = false, quickFilterProps: quickFilterProps = {} } = props, other = (0, $bKcdJ.default)(props, $95c56b12e832f314$var$_excluded);
    const rootProps = (0, $cf36a17b199a9f82$export$8b0f8e71b71b7ed3)();
    if (rootProps.disableColumnFilter && rootProps.disableColumnSelector && rootProps.disableDensitySelector && !showQuickFilter) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $1680f2c298b4061f$export$276ebf2f43e1afe0), (0, $asN9r.default)({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b8fdbc08d9d83345$export$9460f81121783d0f), {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4e9d707e463edef0$export$eef6782de2aba6b), {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6483f3aa6dfcd604$export$39ae0f666777d9ba), {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e53f14e1a9fb983f$export$ef68b449b329deb5), {
                csvOptions: csvOptions,
                printOptions: printOptions,
                excelOptions: excelOptions
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a9eb786abed59b0f$export$2e2bcd8739ae039), {
                sx: {
                    flex: 1
                }
            }),
            showQuickFilter && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9eb7c2ebe4fab68a$export$d7fbfb032c6d5ccc), (0, $asN9r.default)({}, quickFilterProps))
        ]
    }));
});



var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
function $0ebf01b6999927a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0ebf01b6999927a5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0ebf01b6999927a5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0ebf01b6999927a5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0ebf01b6999927a5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0ebf01b6999927a5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ebf01b6999927a5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $0ebf01b6999927a5$var$_setPrototypeOf(subClass, superClass);
}
function $0ebf01b6999927a5$var$_setPrototypeOf(o, p) {
    $0ebf01b6999927a5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ebf01b6999927a5$var$_setPrototypeOf(o, p);
}
function $0ebf01b6999927a5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0ebf01b6999927a5$var$debounce(func, wait) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var context = this;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            return func.apply(context, args);
        }, wait);
    };
}
function $0ebf01b6999927a5$var$parentHasClass(element, className) {
    while(element){
        if (element.classList && element.classList.contains(className)) return true;
        element = element.parentElement;
    }
    return false;
}
function $0ebf01b6999927a5$var$parentPosition(element) {
    var rect = element.getBoundingClientRect();
    return {
        x: rect.left,
        y: rect.top
    };
}
function $0ebf01b6999927a5$var$osm(x, y, z) {
    return "https://tile.openstreetmap.org/" + z + "/" + x + "/" + y + ".png";
}
var $0ebf01b6999927a5$var$ANIMATION_TIME = 300;
var $0ebf01b6999927a5$var$DIAGONAL_THROW_TIME = 1500;
var $0ebf01b6999927a5$var$SCROLL_PIXELS_FOR_ZOOM_LEVEL = 150;
var $0ebf01b6999927a5$var$MIN_DRAG_FOR_THROW = 40;
var $0ebf01b6999927a5$var$CLICK_TOLERANCE = 2;
var $0ebf01b6999927a5$var$DOUBLE_CLICK_DELAY = 300;
var $0ebf01b6999927a5$var$DEBOUNCE_DELAY = 60;
var $0ebf01b6999927a5$var$PINCH_RELEASE_THROW_DELAY = 300;
var $0ebf01b6999927a5$var$WARNING_DISPLAY_TIMEOUT = 300;
var $0ebf01b6999927a5$var$NOOP = function NOOP() {
    return true;
};
var $0ebf01b6999927a5$var$lng2tile = function lng2tile(lon, zoom) {
    return (lon + 180) / 360 * Math.pow(2, zoom);
};
var $0ebf01b6999927a5$var$lat2tile = function lat2tile(lat, zoom) {
    return (1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom);
};
function $0ebf01b6999927a5$var$tile2lng(x, z) {
    return x / Math.pow(2, z) * 360 - 180;
}
function $0ebf01b6999927a5$var$tile2lat(y, z) {
    var n = Math.PI - 2 * Math.PI * y / Math.pow(2, z);
    return 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
}
function $0ebf01b6999927a5$var$getMousePixel(dom, event) {
    var parent = $0ebf01b6999927a5$var$parentPosition(dom);
    return [
        event.clientX - parent.x,
        event.clientY - parent.y
    ];
}
function $0ebf01b6999927a5$var$easeOutQuad(t) {
    return t * (2 - t);
}
var $0ebf01b6999927a5$var$absoluteMinMax = [
    $0ebf01b6999927a5$var$tile2lat(Math.pow(2, 10), 10),
    $0ebf01b6999927a5$var$tile2lat(0, 10),
    $0ebf01b6999927a5$var$tile2lng(0, 10),
    $0ebf01b6999927a5$var$tile2lng(Math.pow(2, 10), 10)
];
var $0ebf01b6999927a5$var$hasWindow = typeof window !== "undefined";
var $0ebf01b6999927a5$var$performanceNow = $0ebf01b6999927a5$var$hasWindow && window.performance && window.performance.now ? function() {
    return window.performance.now();
} : function() {
    var timeStart = new Date().getTime();
    return function() {
        return new Date().getTime() - timeStart;
    };
}();
var $0ebf01b6999927a5$var$requestAnimationFrame = function requestAnimationFrame(callback) {
    if ($0ebf01b6999927a5$var$hasWindow) return (window.requestAnimationFrame || window.setTimeout)(callback);
    else {
        callback(new Date().getTime());
        return null;
    }
};
var $0ebf01b6999927a5$var$cancelAnimationFrame = function cancelAnimationFrame(animFrame) {
    return $0ebf01b6999927a5$var$hasWindow && animFrame ? (window.cancelAnimationFrame || window.clearTimeout)(animFrame) : false;
};
function $0ebf01b6999927a5$var$srcSet(dprs, url, x, y, z) {
    if (!dprs || dprs.length === 0) return "";
    return dprs.map(function(dpr) {
        return url(x, y, z, dpr) + (dpr === 1 ? "" : " " + dpr + "x");
    }).join(", ");
}
var $0ebf01b6999927a5$var$ImgTile = function ImgTile(_ref) {
    var tile = _ref.tile, tileLoaded = _ref.tileLoaded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("img", {
        src: tile.url,
        srcSet: tile.srcSet,
        width: tile.width,
        height: tile.height,
        loading: "lazy",
        onLoad: tileLoaded,
        alt: "",
        style: {
            position: "absolute",
            left: tile.left,
            top: tile.top,
            willChange: "transform",
            transformOrigin: "top left",
            opacity: 1
        }
    });
};
var $0ebf01b6999927a5$export$a5c7b93649eaf8f8 = /*#__PURE__*/ function(_Component) {
    $0ebf01b6999927a5$var$_inheritsLoose(Map, _Component);
    function Map(props) {
        var _ref2, _props$defaultZoom, _ref3, _props$defaultCenter, _ref4, _props$width, _ref5, _props$height;
        var _this;
        _this = _Component.call(this, props) || this;
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_containerRef", void 0);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_mousePosition", void 0);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_loadTracker", void 0);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_dragStart", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_mouseDown", false);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_moveEvents", []);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_lastClick", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_lastTap", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_lastWheel", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_touchStartPixel", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_touchStartMidPoint", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_touchStartDistance", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_secondTouchEnd", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_warningClearTimeout", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_isAnimating", false);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_animationStart", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_animationEnd", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_zoomStart", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_centerTarget", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_zoomTarget", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_zoomAround", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_animFrame", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_boundsSynced", false);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_minMaxCache", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_lastZoom", void 0);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_lastCenter", void 0);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_centerStart", void 0);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "_resizeObserver", null);
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "updateWidthHeight", function() {
            if (_this._containerRef) {
                var rect = _this._containerRef.getBoundingClientRect();
                if (rect && rect.width > 0 && rect.height > 0) {
                    _this.setState({
                        width: rect.width,
                        height: rect.height
                    });
                    return true;
                }
            }
            return false;
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "wa", function() {
            var _window;
            return (_window = window).addEventListener.apply(_window, arguments);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "wr", function() {
            var _window2;
            return (_window2 = window).removeEventListener.apply(_window2, arguments);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "bindMouseEvents", function() {
            _this.wa("mousedown", _this.handleMouseDown);
            _this.wa("mouseup", _this.handleMouseUp);
            _this.wa("mousemove", _this.handleMouseMove);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "bindTouchEvents", function() {
            _this.wa("touchstart", _this.handleTouchStart, {
                passive: false
            });
            _this.wa("touchmove", _this.handleTouchMove, {
                passive: false
            });
            _this.wa("touchend", _this.handleTouchEnd, {
                passive: false
            });
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "unbindMouseEvents", function() {
            _this.wr("mousedown", _this.handleMouseDown);
            _this.wr("mouseup", _this.handleMouseUp);
            _this.wr("mousemove", _this.handleMouseMove);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "unbindTouchEvents", function() {
            _this.wr("touchstart", _this.handleTouchStart);
            _this.wr("touchmove", _this.handleTouchMove);
            _this.wr("touchend", _this.handleTouchEnd);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "bindResizeEvent", function() {
            _this.wa("resize", _this.updateWidthHeight);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "unbindResizeEvent", function() {
            _this.wr("resize", _this.updateWidthHeight);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "bindWheelEvent", function() {
            if (_this._containerRef) _this._containerRef.addEventListener("wheel", _this.handleWheel, {
                passive: false
            });
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "unbindWheelEvent", function() {
            if (_this._containerRef) _this._containerRef.removeEventListener("wheel", _this.handleWheel);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "setCenterZoomTarget", function(center, zoom, fromProps, zoomAround, animationDuration) {
            if (fromProps === void 0) fromProps = false;
            if (zoomAround === void 0) zoomAround = null;
            if (animationDuration === void 0) animationDuration = $0ebf01b6999927a5$var$ANIMATION_TIME;
            if (_this.props.animate && (!fromProps || _this.distanceInScreens(center, zoom, _this.state.center, _this.state.zoom) <= _this.props.animateMaxScreens)) {
                if (_this._isAnimating) {
                    $0ebf01b6999927a5$var$cancelAnimationFrame(_this._animFrame);
                    var _this$animationStep = _this.animationStep($0ebf01b6999927a5$var$performanceNow()), centerStep = _this$animationStep.centerStep, zoomStep = _this$animationStep.zoomStep;
                    _this._centerStart = centerStep;
                    _this._zoomStart = zoomStep;
                } else {
                    _this._isAnimating = true;
                    _this._centerStart = _this.limitCenterAtZoom([
                        _this._lastCenter[0],
                        _this._lastCenter[1]
                    ], _this._lastZoom);
                    _this._zoomStart = _this._lastZoom;
                    _this.onAnimationStart();
                }
                _this._animationStart = $0ebf01b6999927a5$var$performanceNow();
                _this._animationEnd = _this._animationStart + animationDuration;
                if (zoomAround) {
                    _this._zoomAround = zoomAround;
                    _this._centerTarget = _this.calculateZoomCenter(_this._lastCenter, zoomAround, _this._lastZoom, zoom);
                } else {
                    _this._zoomAround = null;
                    _this._centerTarget = center;
                }
                _this._zoomTarget = zoom;
                _this._animFrame = $0ebf01b6999927a5$var$requestAnimationFrame(_this.animate);
            } else {
                _this.stopAnimating();
                if (zoomAround) {
                    var _center = _this.calculateZoomCenter(_this._lastCenter, zoomAround, _this._lastZoom, zoom);
                    _this.setCenterZoom(_center, zoom, fromProps);
                } else _this.setCenterZoom(center || _this.state.center, zoom, fromProps);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "setCenterZoomForChildren", function(center, zoom) {
            _this.setCenterZoomTarget(center || _this.state.center, zoom || _this.state.zoom, true);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "distanceInScreens", function(centerTarget, zoomTarget, center, zoom) {
            var _this$state = _this.state, width = _this$state.width, height = _this$state.height;
            var l1 = _this.latLngToPixel(center, center, zoom);
            var l2 = _this.latLngToPixel(centerTarget, center, zoom);
            var z1 = _this.latLngToPixel(center, center, zoomTarget);
            var z2 = _this.latLngToPixel(centerTarget, center, zoomTarget);
            var w = (Math.abs(l1[0] - l2[0]) + Math.abs(z1[0] - z2[0])) / 2 / width;
            var h = (Math.abs(l1[1] - l2[1]) + Math.abs(z1[1] - z2[1])) / 2 / height;
            return Math.sqrt(w * w + h * h);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "animationStep", function(timestamp) {
            if (!_this._animationEnd || !_this._animationStart || !_this._zoomTarget || !_this._zoomStart || !_this._centerStart || !_this._centerTarget) return {
                centerStep: _this.state.center,
                zoomStep: _this.state.zoom
            };
            var length = _this._animationEnd - _this._animationStart;
            var progress = Math.max(timestamp - _this._animationStart, 0);
            var percentage = $0ebf01b6999927a5$var$easeOutQuad(progress / length);
            var zoomDiff = (_this._zoomTarget - _this._zoomStart) * percentage;
            var zoomStep = _this._zoomStart + zoomDiff;
            if (_this._zoomAround) {
                var centerStep = _this.calculateZoomCenter(_this._centerStart, _this._zoomAround, _this._zoomStart, zoomStep);
                return {
                    centerStep: centerStep,
                    zoomStep: zoomStep
                };
            } else {
                var _centerStep = [
                    _this._centerStart[0] + (_this._centerTarget[0] - _this._centerStart[0]) * percentage,
                    _this._centerStart[1] + (_this._centerTarget[1] - _this._centerStart[1]) * percentage
                ];
                return {
                    centerStep: _centerStep,
                    zoomStep: zoomStep
                };
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "animate", function(timestamp) {
            if (!_this._animationEnd || timestamp >= _this._animationEnd) {
                _this._isAnimating = false;
                _this.setCenterZoom(_this._centerTarget, _this._zoomTarget, true);
                _this.onAnimationStop();
            } else {
                var _this$animationStep2 = _this.animationStep(timestamp), centerStep = _this$animationStep2.centerStep, zoomStep = _this$animationStep2.zoomStep;
                _this.setCenterZoom(centerStep, zoomStep);
                _this._animFrame = $0ebf01b6999927a5$var$requestAnimationFrame(_this.animate);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "stopAnimating", function() {
            if (_this._isAnimating) {
                _this._isAnimating = false;
                _this.onAnimationStop();
                $0ebf01b6999927a5$var$cancelAnimationFrame(_this._animFrame);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "limitCenterAtZoom", function(center, zoom) {
            var minMax = _this.getBoundsMinMax(zoom || _this.state.zoom);
            return [
                Math.max(Math.min(!center || isNaN(center[0]) ? _this.state.center[0] : center[0], minMax[1]), minMax[0]),
                Math.max(Math.min(!center || isNaN(center[1]) ? _this.state.center[1] : center[1], minMax[3]), minMax[2])
            ];
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "onAnimationStart", function() {
            _this.props.onAnimationStart && _this.props.onAnimationStart();
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "onAnimationStop", function() {
            _this.props.onAnimationStop && _this.props.onAnimationStop();
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "setCenterZoom", function(center, zoom, animationEnded) {
            if (animationEnded === void 0) animationEnded = false;
            var limitedCenter = _this.limitCenterAtZoom(center, zoom);
            if (zoom && Math.round(_this.state.zoom) !== Math.round(zoom)) {
                var tileValues = _this.tileValues(_this.state);
                var nextValues = _this.tileValues({
                    center: limitedCenter,
                    zoom: zoom,
                    width: _this.state.width,
                    height: _this.state.height
                });
                var oldTiles = _this.state.oldTiles;
                _this.setState({
                    oldTiles: oldTiles.filter(function(o) {
                        return o.roundedZoom !== tileValues.roundedZoom;
                    }).concat(tileValues)
                }, $0ebf01b6999927a5$var$NOOP);
                var loadTracker = {};
                for(var x = nextValues.tileMinX; x <= nextValues.tileMaxX; x++)for(var y = nextValues.tileMinY; y <= nextValues.tileMaxY; y++){
                    var key = x + "-" + y + "-" + nextValues.roundedZoom;
                    loadTracker[key] = false;
                }
                _this._loadTracker = loadTracker;
            }
            _this.setState({
                center: limitedCenter,
                zoom: zoom || _this.state.zoom
            }, $0ebf01b6999927a5$var$NOOP);
            var maybeZoom = _this.props.zoom ? _this.props.zoom : _this._lastZoom;
            var maybeCenter = _this.props.center ? _this.props.center : _this._lastCenter;
            if (zoom && (animationEnded || Math.abs(maybeZoom - zoom) > 0.001 || Math.abs(maybeCenter[0] - limitedCenter[0]) > 0.00001 || Math.abs(maybeCenter[1] - limitedCenter[1]) > 0.00001)) {
                _this._lastZoom = zoom;
                _this._lastCenter = [].concat(limitedCenter);
                _this.syncToProps(limitedCenter, zoom);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "getBoundsMinMax", function(zoom) {
            if (_this.props.limitBounds === "center") return $0ebf01b6999927a5$var$absoluteMinMax;
            var _this$state2 = _this.state, width = _this$state2.width, height = _this$state2.height;
            if (_this._minMaxCache && _this._minMaxCache[0] === zoom && _this._minMaxCache[1] === width && _this._minMaxCache[2] === height) return _this._minMaxCache[3];
            var pixelsAtZoom = Math.pow(2, zoom) * 256;
            var minLng = width > pixelsAtZoom ? 0 : $0ebf01b6999927a5$var$tile2lng(width / 512, zoom);
            var minLat = height > pixelsAtZoom ? 0 : $0ebf01b6999927a5$var$tile2lat(Math.pow(2, zoom) - height / 512, zoom);
            var maxLng = width > pixelsAtZoom ? 0 : $0ebf01b6999927a5$var$tile2lng(Math.pow(2, zoom) - width / 512, zoom);
            var maxLat = height > pixelsAtZoom ? 0 : $0ebf01b6999927a5$var$tile2lat(height / 512, zoom);
            var minMax = [
                minLat,
                maxLat,
                minLng,
                maxLng
            ];
            _this._minMaxCache = [
                zoom,
                width,
                height,
                minMax
            ];
            return minMax;
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "tileLoaded", function(key) {
            if (_this._loadTracker && key in _this._loadTracker) {
                _this._loadTracker[key] = true;
                var unloadedCount = Object.values(_this._loadTracker).filter(function(v) {
                    return !v;
                }).length;
                if (unloadedCount === 0) _this.setState({
                    oldTiles: []
                }, $0ebf01b6999927a5$var$NOOP);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleTouchStart", function(event) {
            if (!_this._containerRef) return;
            if (event.target && $0ebf01b6999927a5$var$parentHasClass(event.target, "pigeon-drag-block")) return;
            if (event.touches.length === 1) {
                var touch = event.touches[0];
                var pixel = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, touch);
                if (_this.coordsInside(pixel)) {
                    _this._touchStartPixel = [
                        pixel
                    ];
                    if (!_this.props.twoFingerDrag) {
                        _this.stopAnimating();
                        if (_this._lastTap && $0ebf01b6999927a5$var$performanceNow() - _this._lastTap < $0ebf01b6999927a5$var$DOUBLE_CLICK_DELAY) {
                            event.preventDefault();
                            var latLngNow = _this.pixelToLatLng(_this._touchStartPixel[0]);
                            _this.setCenterZoomTarget(null, Math.max(_this.props.minZoom, Math.min(_this.state.zoom + 1, _this.props.maxZoom)), false, latLngNow);
                        } else {
                            _this._lastTap = $0ebf01b6999927a5$var$performanceNow();
                            _this.trackMoveEvents(pixel);
                        }
                    }
                }
            } else if (event.touches.length === 2 && _this._touchStartPixel) {
                event.preventDefault();
                _this.stopTrackingMoveEvents();
                if (_this.state.pixelDelta || _this.state.zoomDelta) _this.sendDeltaChange();
                var t1 = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event.touches[0]);
                var t2 = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event.touches[1]);
                _this._touchStartPixel = [
                    t1,
                    t2
                ];
                _this._touchStartMidPoint = [
                    (t1[0] + t2[0]) / 2,
                    (t1[1] + t2[1]) / 2
                ];
                _this._touchStartDistance = Math.sqrt(Math.pow(t1[0] - t2[0], 2) + Math.pow(t1[1] - t2[1], 2));
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleTouchMove", function(event) {
            if (!_this._containerRef) {
                _this._touchStartPixel = null;
                return;
            }
            if (event.touches.length === 1 && _this._touchStartPixel) {
                var touch = event.touches[0];
                var pixel = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, touch);
                if (_this.props.twoFingerDrag) {
                    if (_this.coordsInside(pixel)) _this.showWarning("fingers");
                } else {
                    event.preventDefault();
                    _this.trackMoveEvents(pixel);
                    _this.setState({
                        pixelDelta: [
                            pixel[0] - _this._touchStartPixel[0][0],
                            pixel[1] - _this._touchStartPixel[0][1]
                        ]
                    }, $0ebf01b6999927a5$var$NOOP);
                }
            } else if (event.touches.length === 2 && _this._touchStartPixel && _this._touchStartMidPoint && _this._touchStartDistance) {
                var _this$state3 = _this.state, width = _this$state3.width, height = _this$state3.height, zoom = _this$state3.zoom;
                event.preventDefault();
                var t1 = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event.touches[0]);
                var t2 = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event.touches[1]);
                var midPoint = [
                    (t1[0] + t2[0]) / 2,
                    (t1[1] + t2[1]) / 2
                ];
                var midPointDiff = [
                    midPoint[0] - _this._touchStartMidPoint[0],
                    midPoint[1] - _this._touchStartMidPoint[1]
                ];
                var distance = Math.sqrt(Math.pow(t1[0] - t2[0], 2) + Math.pow(t1[1] - t2[1], 2));
                var zoomDelta = Math.max(_this.props.minZoom, Math.min(_this.props.maxZoom, zoom + Math.log2(distance / _this._touchStartDistance))) - zoom;
                var scale = Math.pow(2, zoomDelta);
                var centerDiffDiff = [
                    (width / 2 - midPoint[0]) * (scale - 1),
                    (height / 2 - midPoint[1]) * (scale - 1)
                ];
                _this.setState({
                    zoomDelta: zoomDelta,
                    pixelDelta: [
                        centerDiffDiff[0] + midPointDiff[0] * scale,
                        centerDiffDiff[1] + midPointDiff[1] * scale
                    ]
                }, $0ebf01b6999927a5$var$NOOP);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleTouchEnd", function(event) {
            if (!_this._containerRef) {
                _this._touchStartPixel = null;
                return;
            }
            if (_this._touchStartPixel) {
                var _this$props = _this.props, zoomSnap = _this$props.zoomSnap, twoFingerDrag = _this$props.twoFingerDrag, minZoom = _this$props.minZoom, maxZoom = _this$props.maxZoom;
                var zoomDelta = _this.state.zoomDelta;
                var _this$sendDeltaChange = _this.sendDeltaChange(), center = _this$sendDeltaChange.center, zoom = _this$sendDeltaChange.zoom;
                if (event.touches.length === 0) {
                    if (twoFingerDrag) _this.clearWarning();
                    else {
                        var oldTouchPixel = _this._touchStartPixel[0];
                        var newTouchPixel = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event.changedTouches[0]);
                        if (Math.abs(oldTouchPixel[0] - newTouchPixel[0]) > $0ebf01b6999927a5$var$CLICK_TOLERANCE || Math.abs(oldTouchPixel[1] - newTouchPixel[1]) > $0ebf01b6999927a5$var$CLICK_TOLERANCE) {
                            if (!_this._secondTouchEnd || $0ebf01b6999927a5$var$performanceNow() - _this._secondTouchEnd > $0ebf01b6999927a5$var$PINCH_RELEASE_THROW_DELAY) {
                                event.preventDefault();
                                _this.throwAfterMoving(newTouchPixel, center, zoom);
                            }
                        }
                        _this._touchStartPixel = null;
                        _this._secondTouchEnd = null;
                    }
                } else if (event.touches.length === 1) {
                    event.preventDefault();
                    var touch = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event.touches[0]);
                    _this._secondTouchEnd = $0ebf01b6999927a5$var$performanceNow();
                    _this._touchStartPixel = [
                        touch
                    ];
                    _this.trackMoveEvents(touch);
                    if (zoomSnap) {
                        var latLng = _this._touchStartMidPoint ? _this.pixelToLatLng(_this._touchStartMidPoint) : _this.state.center;
                        var zoomTarget;
                        if (twoFingerDrag && Math.round(_this.state.zoom) === Math.round(_this.state.zoom + zoomDelta)) zoomTarget = Math.round(_this.state.zoom);
                        else zoomTarget = zoomDelta > 0 ? Math.ceil(_this.state.zoom) : Math.floor(_this.state.zoom);
                        var _zoom = Math.max(minZoom, Math.min(zoomTarget, maxZoom));
                        _this.setCenterZoomTarget(latLng, _zoom, false, latLng);
                    }
                }
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleMouseDown", function(event) {
            if (!_this._containerRef) return;
            var pixel = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event);
            if (event.button === 0 && (!event.target || !$0ebf01b6999927a5$var$parentHasClass(event.target, "pigeon-drag-block")) && _this.coordsInside(pixel)) {
                _this.stopAnimating();
                event.preventDefault();
                if (_this._lastClick && $0ebf01b6999927a5$var$performanceNow() - _this._lastClick < $0ebf01b6999927a5$var$DOUBLE_CLICK_DELAY) {
                    if (!$0ebf01b6999927a5$var$parentHasClass(event.target, "pigeon-click-block")) {
                        var latLngNow = _this.pixelToLatLng(_this._mousePosition || pixel);
                        _this.setCenterZoomTarget(null, Math.max(_this.props.minZoom, Math.min(_this.state.zoom + 1, _this.props.maxZoom)), false, latLngNow);
                    }
                } else {
                    _this._lastClick = $0ebf01b6999927a5$var$performanceNow();
                    _this._mouseDown = true;
                    _this._dragStart = pixel;
                    _this.trackMoveEvents(pixel);
                }
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleMouseMove", function(event) {
            if (!_this._containerRef) return;
            _this._mousePosition = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event);
            if (_this._mouseDown && _this._dragStart) {
                _this.trackMoveEvents(_this._mousePosition);
                _this.setState({
                    pixelDelta: [
                        _this._mousePosition[0] - _this._dragStart[0],
                        _this._mousePosition[1] - _this._dragStart[1]
                    ]
                }, $0ebf01b6999927a5$var$NOOP);
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleMouseUp", function(event) {
            if (!_this._containerRef) {
                _this._mouseDown = false;
                return;
            }
            var pixelDelta = _this.state.pixelDelta;
            if (_this._mouseDown) {
                _this._mouseDown = false;
                var pixel = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event);
                if (_this.props.onClick && (!event.target || !$0ebf01b6999927a5$var$parentHasClass(event.target, "pigeon-click-block")) && (!pixelDelta || Math.abs(pixelDelta[0]) + Math.abs(pixelDelta[1]) <= $0ebf01b6999927a5$var$CLICK_TOLERANCE)) {
                    var latLng = _this.pixelToLatLng(pixel);
                    _this.props.onClick({
                        event: event,
                        latLng: latLng,
                        pixel: pixel
                    });
                    _this.setState({
                        pixelDelta: undefined
                    }, $0ebf01b6999927a5$var$NOOP);
                } else {
                    var _this$sendDeltaChange2 = _this.sendDeltaChange(), center = _this$sendDeltaChange2.center, zoom = _this$sendDeltaChange2.zoom;
                    _this.throwAfterMoving(pixel, center, zoom);
                }
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "stopTrackingMoveEvents", function() {
            _this._moveEvents = [];
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "trackMoveEvents", function(coords) {
            var timestamp = $0ebf01b6999927a5$var$performanceNow();
            if (_this._moveEvents.length === 0 || timestamp - _this._moveEvents[_this._moveEvents.length - 1].timestamp > 40) {
                _this._moveEvents.push({
                    timestamp: timestamp,
                    coords: coords
                });
                if (_this._moveEvents.length > 2) _this._moveEvents.shift();
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "throwAfterMoving", function(coords, center, zoom) {
            var _this$state4 = _this.state, width = _this$state4.width, height = _this$state4.height;
            var animate = _this.props.animate;
            var timestamp = $0ebf01b6999927a5$var$performanceNow();
            var lastEvent = _this._moveEvents.shift();
            if (lastEvent && animate) {
                var deltaMs = Math.max(timestamp - lastEvent.timestamp, 1);
                var delta = [
                    (coords[0] - lastEvent.coords[0]) / deltaMs * 120,
                    (coords[1] - lastEvent.coords[1]) / deltaMs * 120
                ];
                var distance = Math.sqrt(delta[0] * delta[0] + delta[1] * delta[1]);
                if (distance > $0ebf01b6999927a5$var$MIN_DRAG_FOR_THROW) {
                    var diagonal = Math.sqrt(width * width + height * height);
                    var throwTime = $0ebf01b6999927a5$var$DIAGONAL_THROW_TIME * distance / diagonal;
                    var lng = $0ebf01b6999927a5$var$tile2lng($0ebf01b6999927a5$var$lng2tile(center[1], zoom) - delta[0] / 256.0, zoom);
                    var lat = $0ebf01b6999927a5$var$tile2lat($0ebf01b6999927a5$var$lat2tile(center[0], zoom) - delta[1] / 256.0, zoom);
                    _this.setCenterZoomTarget([
                        lat,
                        lng
                    ], zoom, false, null, throwTime);
                }
            }
            _this.stopTrackingMoveEvents();
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "sendDeltaChange", function() {
            var _this$state5 = _this.state, center = _this$state5.center, zoom = _this$state5.zoom, pixelDelta = _this$state5.pixelDelta, zoomDelta = _this$state5.zoomDelta;
            var lat = center[0];
            var lng = center[1];
            if (pixelDelta || zoomDelta !== 0) {
                lng = $0ebf01b6999927a5$var$tile2lng($0ebf01b6999927a5$var$lng2tile(center[1], zoom + zoomDelta) - (pixelDelta ? pixelDelta[0] / 256.0 : 0), zoom + zoomDelta);
                lat = $0ebf01b6999927a5$var$tile2lat($0ebf01b6999927a5$var$lat2tile(center[0], zoom + zoomDelta) - (pixelDelta ? pixelDelta[1] / 256.0 : 0), zoom + zoomDelta);
                _this.setCenterZoom([
                    lat,
                    lng
                ], zoom + zoomDelta);
            }
            _this.setState({
                pixelDelta: undefined,
                zoomDelta: 0
            }, $0ebf01b6999927a5$var$NOOP);
            return {
                center: _this.limitCenterAtZoom([
                    lat,
                    lng
                ], zoom + zoomDelta),
                zoom: zoom + zoomDelta
            };
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "getBounds", function(center, zoom) {
            if (center === void 0) center = _this.state.center;
            if (zoom === void 0) zoom = _this.zoomPlusDelta();
            var _this$state6 = _this.state, width = _this$state6.width, height = _this$state6.height;
            return {
                ne: _this.pixelToLatLng([
                    width - 1,
                    0
                ], center, zoom),
                sw: _this.pixelToLatLng([
                    0,
                    height - 1
                ], center, zoom)
            };
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "syncToProps", function(center, zoom) {
            if (center === void 0) center = _this.state.center;
            if (zoom === void 0) zoom = _this.state.zoom;
            var onBoundsChanged = _this.props.onBoundsChanged;
            if (onBoundsChanged) {
                var bounds = _this.getBounds(center, zoom);
                onBoundsChanged({
                    center: center,
                    zoom: zoom,
                    bounds: bounds,
                    initial: !_this._boundsSynced
                });
                _this._boundsSynced = true;
            }
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "handleWheel", function(event) {
            var _this$props2 = _this.props, mouseEvents = _this$props2.mouseEvents, metaWheelZoom = _this$props2.metaWheelZoom, zoomSnap = _this$props2.zoomSnap, animate = _this$props2.animate;
            if (!mouseEvents) return;
            if (!metaWheelZoom || event.metaKey || event.ctrlKey) {
                event.preventDefault();
                var addToZoom = -event.deltaY / $0ebf01b6999927a5$var$SCROLL_PIXELS_FOR_ZOOM_LEVEL;
                if (!zoomSnap && _this._zoomTarget) {
                    var stillToAdd = _this._zoomTarget - _this.state.zoom;
                    _this.zoomAroundMouse(addToZoom + stillToAdd, event);
                } else {
                    if (animate) _this.zoomAroundMouse(addToZoom, event);
                    else if (!_this._lastWheel || $0ebf01b6999927a5$var$performanceNow() - _this._lastWheel > $0ebf01b6999927a5$var$ANIMATION_TIME) {
                        _this._lastWheel = $0ebf01b6999927a5$var$performanceNow();
                        _this.zoomAroundMouse(addToZoom, event);
                    }
                }
            } else _this.showWarning("wheel");
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "showWarning", function(warningType) {
            if (!_this.state.showWarning || _this.state.warningType !== warningType) _this.setState({
                showWarning: true,
                warningType: warningType
            });
            if (_this._warningClearTimeout) window.clearTimeout(_this._warningClearTimeout);
            _this._warningClearTimeout = window.setTimeout(_this.clearWarning, $0ebf01b6999927a5$var$WARNING_DISPLAY_TIMEOUT);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "clearWarning", function() {
            if (_this.state.showWarning) _this.setState({
                showWarning: false
            });
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "zoomAroundMouse", function(zoomDiff, event) {
            if (!_this._containerRef) return;
            var zoom = _this.state.zoom;
            var _this$props3 = _this.props, minZoom = _this$props3.minZoom, maxZoom = _this$props3.maxZoom, zoomSnap = _this$props3.zoomSnap;
            _this._mousePosition = $0ebf01b6999927a5$var$getMousePixel(_this._containerRef, event);
            if (!_this._mousePosition || zoom === minZoom && zoomDiff < 0 || zoom === maxZoom && zoomDiff > 0) return;
            var latLngNow = _this.pixelToLatLng(_this._mousePosition);
            var zoomTarget = zoom + zoomDiff;
            if (zoomSnap) zoomTarget = zoomDiff < 0 ? Math.floor(zoomTarget) : Math.ceil(zoomTarget);
            zoomTarget = Math.max(minZoom, Math.min(zoomTarget, maxZoom));
            _this.setCenterZoomTarget(null, zoomTarget, false, latLngNow);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "zoomPlusDelta", function() {
            return _this.state.zoom + _this.state.zoomDelta;
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "pixelToLatLng", function(pixel, center, zoom) {
            if (center === void 0) center = _this.state.center;
            if (zoom === void 0) zoom = _this.zoomPlusDelta();
            var _this$state7 = _this.state, width = _this$state7.width, height = _this$state7.height, pixelDelta = _this$state7.pixelDelta;
            var pointDiff = [
                (pixel[0] - width / 2 - (pixelDelta ? pixelDelta[0] : 0)) / 256.0,
                (pixel[1] - height / 2 - (pixelDelta ? pixelDelta[1] : 0)) / 256.0
            ];
            var tileX = $0ebf01b6999927a5$var$lng2tile(center[1], zoom) + pointDiff[0];
            var tileY = $0ebf01b6999927a5$var$lat2tile(center[0], zoom) + pointDiff[1];
            return [
                Math.max($0ebf01b6999927a5$var$absoluteMinMax[0], Math.min($0ebf01b6999927a5$var$absoluteMinMax[1], $0ebf01b6999927a5$var$tile2lat(tileY, zoom))),
                Math.max($0ebf01b6999927a5$var$absoluteMinMax[2], Math.min($0ebf01b6999927a5$var$absoluteMinMax[3], $0ebf01b6999927a5$var$tile2lng(tileX, zoom)))
            ];
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "latLngToPixel", function(latLng, center, zoom) {
            if (center === void 0) center = _this.state.center;
            if (zoom === void 0) zoom = _this.zoomPlusDelta();
            var _this$state8 = _this.state, width = _this$state8.width, height = _this$state8.height, pixelDelta = _this$state8.pixelDelta;
            var tileCenterX = $0ebf01b6999927a5$var$lng2tile(center[1], zoom);
            var tileCenterY = $0ebf01b6999927a5$var$lat2tile(center[0], zoom);
            var tileX = $0ebf01b6999927a5$var$lng2tile(latLng[1], zoom);
            var tileY = $0ebf01b6999927a5$var$lat2tile(latLng[0], zoom);
            return [
                (tileX - tileCenterX) * 256.0 + width / 2 + (pixelDelta ? pixelDelta[0] : 0),
                (tileY - tileCenterY) * 256.0 + height / 2 + (pixelDelta ? pixelDelta[1] : 0)
            ];
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "calculateZoomCenter", function(center, coords, oldZoom, newZoom) {
            var _this$state9 = _this.state, width = _this$state9.width, height = _this$state9.height;
            var pixelBefore = _this.latLngToPixel(coords, center, oldZoom);
            var pixelAfter = _this.latLngToPixel(coords, center, newZoom);
            var newCenter = _this.pixelToLatLng([
                width / 2 + pixelAfter[0] - pixelBefore[0],
                height / 2 + pixelAfter[1] - pixelBefore[1]
            ], center, newZoom);
            return _this.limitCenterAtZoom(newCenter, newZoom);
        });
        $0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$var$_assertThisInitialized(_this), "setRef", function(dom) {
            _this._containerRef = dom;
        });
        _this.syncToProps = $0ebf01b6999927a5$var$debounce(_this.syncToProps, $0ebf01b6999927a5$var$DEBOUNCE_DELAY);
        _this._lastZoom = (_ref2 = (_props$defaultZoom = props.defaultZoom) !== null && _props$defaultZoom !== void 0 ? _props$defaultZoom : props.zoom) !== null && _ref2 !== void 0 ? _ref2 : 14;
        _this._lastCenter = (_ref3 = (_props$defaultCenter = props.defaultCenter) !== null && _props$defaultCenter !== void 0 ? _props$defaultCenter : props.center) !== null && _ref3 !== void 0 ? _ref3 : [
            0,
            0
        ];
        _this.state = {
            zoom: _this._lastZoom,
            center: _this._lastCenter,
            width: (_ref4 = (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : props.defaultWidth) !== null && _ref4 !== void 0 ? _ref4 : -1,
            height: (_ref5 = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : props.defaultHeight) !== null && _ref5 !== void 0 ? _ref5 : -1,
            zoomDelta: 0,
            pixelDelta: undefined,
            oldTiles: [],
            showWarning: false,
            warningType: undefined
        };
        return _this;
    }
    var _proto = Map.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this.props.mouseEvents && this.bindMouseEvents();
        this.props.touchEvents && this.bindTouchEvents();
        if (!this.props.width || !this.props.height) {
            if (!this.updateWidthHeight()) $0ebf01b6999927a5$var$requestAnimationFrame(this.updateWidthHeight);
            this.bindResizeEvent();
        }
        this.bindWheelEvent();
        this.syncToProps();
        if (typeof window.ResizeObserver !== "undefined") {
            this._resizeObserver = new window.ResizeObserver(function() {
                _this2.updateWidthHeight();
            });
            this._resizeObserver.observe(this._containerRef);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.mouseEvents && this.unbindMouseEvents();
        this.props.touchEvents && this.unbindTouchEvents();
        this.unbindWheelEvent();
        if (!this.props.width || !this.props.height) this.unbindResizeEvent();
        if (this._resizeObserver) this._resizeObserver.disconnect();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _prevProps$center;
        if (this.props.mouseEvents !== prevProps.mouseEvents) this.props.mouseEvents ? this.bindMouseEvents() : this.unbindMouseEvents();
        if (this.props.touchEvents !== prevProps.touchEvents) this.props.touchEvents ? this.bindTouchEvents() : this.unbindTouchEvents();
        if (this.props.width && this.props.width !== prevProps.width) this.setState({
            width: this.props.width
        });
        if (this.props.height && this.props.height !== prevProps.height) this.setState({
            height: this.props.height
        });
        if (!this.props.center && !this.props.zoom) return;
        if ((!this.props.center || this.props.center[0] === (prevProps === null || prevProps === void 0 ? void 0 : (_prevProps$center = prevProps.center) === null || _prevProps$center === void 0 ? void 0 : _prevProps$center[0]) && this.props.center[1] === prevProps.center[1]) && this.props.zoom === prevProps.zoom) return;
        var currentCenter = this._isAnimating ? this._centerTarget : this.state.center;
        var currentZoom = this._isAnimating ? this._zoomTarget : this.state.zoom;
        if (currentCenter && currentZoom) {
            var _this$props$center, _this$props$zoom;
            var nextCenter = (_this$props$center = this.props.center) !== null && _this$props$center !== void 0 ? _this$props$center : currentCenter;
            var nextZoom = (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : currentZoom;
            if (Math.abs(nextZoom - currentZoom) > 0.001 || Math.abs(nextCenter[0] - currentCenter[0]) > 0.0001 || Math.abs(nextCenter[1] - currentCenter[1]) > 0.0001) this.setCenterZoomTarget(nextCenter, nextZoom, true);
        }
    };
    _proto.coordsInside = function coordsInside(pixel) {
        var _this$state10 = this.state, width = _this$state10.width, height = _this$state10.height;
        if (pixel[0] < 0 || pixel[1] < 0 || pixel[0] >= width || pixel[1] >= height) return false;
        var parent = this._containerRef;
        if (parent) {
            var pos = $0ebf01b6999927a5$var$parentPosition(parent);
            var element = document.elementFromPoint(pixel[0] + pos.x, pixel[1] + pos.y);
            return parent === element || parent.contains(element);
        } else return false;
    };
    _proto.tileValues = function tileValues(_ref6) {
        var center = _ref6.center, zoom = _ref6.zoom, pixelDelta = _ref6.pixelDelta, zoomDelta = _ref6.zoomDelta, width = _ref6.width, height = _ref6.height;
        var roundedZoom = Math.round(zoom + (zoomDelta || 0));
        var zoomDiff = zoom + (zoomDelta || 0) - roundedZoom;
        var scale = Math.pow(2, zoomDiff);
        var scaleWidth = width / scale;
        var scaleHeight = height / scale;
        var tileCenterX = $0ebf01b6999927a5$var$lng2tile(center[1], roundedZoom) - (pixelDelta ? pixelDelta[0] / 256.0 / scale : 0);
        var tileCenterY = $0ebf01b6999927a5$var$lat2tile(center[0], roundedZoom) - (pixelDelta ? pixelDelta[1] / 256.0 / scale : 0);
        var halfWidth = scaleWidth / 2 / 256.0;
        var halfHeight = scaleHeight / 2 / 256.0;
        var tileMinX = Math.floor(tileCenterX - halfWidth);
        var tileMaxX = Math.floor(tileCenterX + halfWidth);
        var tileMinY = Math.floor(tileCenterY - halfHeight);
        var tileMaxY = Math.floor(tileCenterY + halfHeight);
        return {
            tileMinX: tileMinX,
            tileMaxX: tileMaxX,
            tileMinY: tileMinY,
            tileMaxY: tileMaxY,
            tileCenterX: tileCenterX,
            tileCenterY: tileCenterY,
            roundedZoom: roundedZoom,
            zoomDelta: zoomDelta || 0,
            scaleWidth: scaleWidth,
            scaleHeight: scaleHeight,
            scale: scale
        };
    };
    _proto.renderTiles = function renderTiles() {
        var _this3 = this;
        var _this$state11 = this.state, oldTiles = _this$state11.oldTiles, width = _this$state11.width, height = _this$state11.height;
        var dprs = this.props.dprs;
        var mapUrl = this.props.provider || $0ebf01b6999927a5$var$osm;
        var _this$tileValues = this.tileValues(this.state), tileMinX = _this$tileValues.tileMinX, tileMaxX = _this$tileValues.tileMaxX, tileMinY = _this$tileValues.tileMinY, tileMaxY = _this$tileValues.tileMaxY, tileCenterX = _this$tileValues.tileCenterX, tileCenterY = _this$tileValues.tileCenterY, roundedZoom = _this$tileValues.roundedZoom, scaleWidth = _this$tileValues.scaleWidth, scaleHeight = _this$tileValues.scaleHeight, scale = _this$tileValues.scale;
        var tiles = [];
        for(var i = 0; i < oldTiles.length; i++){
            var old = oldTiles[i];
            var zoomDiff = old.roundedZoom - roundedZoom;
            if (Math.abs(zoomDiff) > 4 || zoomDiff === 0) continue;
            var pow = 1 / Math.pow(2, zoomDiff);
            var xDiff = -(tileMinX - old.tileMinX * pow) * 256;
            var yDiff = -(tileMinY - old.tileMinY * pow) * 256;
            var _xMin = Math.max(old.tileMinX, 0);
            var _yMin = Math.max(old.tileMinY, 0);
            var _xMax = Math.min(old.tileMaxX, Math.pow(2, old.roundedZoom) - 1);
            var _yMax = Math.min(old.tileMaxY, Math.pow(2, old.roundedZoom) - 1);
            for(var x = _xMin; x <= _xMax; x++)for(var y = _yMin; y <= _yMax; y++)tiles.push({
                key: x + "-" + y + "-" + old.roundedZoom,
                url: mapUrl(x, y, old.roundedZoom),
                srcSet: $0ebf01b6999927a5$var$srcSet(dprs, mapUrl, x, y, old.roundedZoom),
                left: xDiff + (x - old.tileMinX) * 256 * pow,
                top: yDiff + (y - old.tileMinY) * 256 * pow,
                width: 256 * pow,
                height: 256 * pow,
                active: false
            });
        }
        var xMin = Math.max(tileMinX, 0);
        var yMin = Math.max(tileMinY, 0);
        var xMax = Math.min(tileMaxX, Math.pow(2, roundedZoom) - 1);
        var yMax = Math.min(tileMaxY, Math.pow(2, roundedZoom) - 1);
        for(var _x = xMin; _x <= xMax; _x++)for(var _y = yMin; _y <= yMax; _y++)tiles.push({
            key: _x + "-" + _y + "-" + roundedZoom,
            url: mapUrl(_x, _y, roundedZoom),
            srcSet: $0ebf01b6999927a5$var$srcSet(dprs, mapUrl, _x, _y, roundedZoom),
            left: (_x - tileMinX) * 256,
            top: (_y - tileMinY) * 256,
            width: 256,
            height: 256,
            active: true
        });
        var boxStyle = {
            width: scaleWidth,
            height: scaleHeight,
            position: "absolute",
            top: "calc((100% - " + height + "px) / 2)",
            left: "calc((100% - " + width + "px) / 2)",
            overflow: "hidden",
            willChange: "transform",
            transform: "scale(" + scale + ", " + scale + ")",
            transformOrigin: "top left"
        };
        var boxClassname = this.props.boxClassname || "pigeon-tiles-box";
        var left = -((tileCenterX - tileMinX) * 256 - scaleWidth / 2);
        var top = -((tileCenterY - tileMinY) * 256 - scaleHeight / 2);
        var tilesStyle = {
            position: "absolute",
            width: (tileMaxX - tileMinX + 1) * 256,
            height: (tileMaxY - tileMinY + 1) * 256,
            willChange: "transform",
            transform: "translate(" + left + "px, " + top + "px)"
        };
        var Tile = this.props.tileComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
            style: boxStyle,
            className: boxClassname
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
            className: "pigeon-tiles",
            style: tilesStyle
        }, tiles.map(function(tile) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Tile, {
                key: tile.key,
                tile: tile,
                tileLoaded: function tileLoaded() {
                    return _this3.tileLoaded(tile.key);
                }
            });
        })));
    };
    _proto.renderOverlays = function renderOverlays() {
        var _this4 = this;
        var _this$state12 = this.state, width = _this$state12.width, height = _this$state12.height, center = _this$state12.center;
        var mapState = {
            bounds: this.getBounds(),
            zoom: this.zoomPlusDelta(),
            center: center,
            width: width,
            height: height
        };
        var childrenWithProps = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Children.map(this.props.children, function(child) {
            if (!child) return null;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).isValidElement(child)) return child;
            var _child$props = child.props, anchor = _child$props.anchor, position = _child$props.position, offset = _child$props.offset;
            var c = _this4.latLngToPixel(anchor || position || center);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).cloneElement(child, {
                left: c[0] - (offset ? offset[0] : 0),
                top: c[1] - (offset ? offset[1] : 0),
                latLngToPixel: _this4.latLngToPixel,
                pixelToLatLng: _this4.pixelToLatLng,
                setCenterZoom: _this4.setCenterZoomForChildren,
                mapProps: _this4.props,
                mapState: mapState
            });
        });
        var childrenStyle = {
            position: "absolute",
            width: width,
            height: height,
            top: "calc((100% - " + height + "px) / 2)",
            left: "calc((100% - " + width + "px) / 2)"
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
            className: "pigeon-overlays",
            style: childrenStyle
        }, childrenWithProps);
    };
    _proto.renderAttribution = function renderAttribution() {
        var _this$props4 = this.props, attribution = _this$props4.attribution, attributionPrefix = _this$props4.attributionPrefix;
        if (attribution === false) return null;
        var style = {
            position: "absolute",
            bottom: 0,
            right: 0,
            fontSize: "11px",
            padding: "2px 5px",
            background: "rgba(255, 255, 255, 0.7)",
            fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
            color: "#333"
        };
        var linkStyle = {
            color: "#0078A8",
            textDecoration: "none"
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
            key: "attr",
            className: "pigeon-attribution",
            style: style
        }, attributionPrefix === false ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("span", null, attributionPrefix || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("a", {
            href: "https://pigeon-maps.js.org/",
            style: linkStyle,
            target: "_blank",
            rel: "noreferrer noopener"
        }, "Pigeon"), " | "), attribution || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("span", null, " \xa9 ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("a", {
            href: "https://www.openstreetmap.org/copyright",
            style: linkStyle,
            target: "_blank",
            rel: "noreferrer noopener"
        }, "OpenStreetMap"), " contributors"));
    };
    _proto.renderWarning = function renderWarning() {
        var _this$props5 = this.props, metaWheelZoom = _this$props5.metaWheelZoom, metaWheelZoomWarning = _this$props5.metaWheelZoomWarning, twoFingerDrag = _this$props5.twoFingerDrag, twoFingerDragWarning = _this$props5.twoFingerDragWarning, warningZIndex = _this$props5.warningZIndex;
        var _this$state13 = this.state, showWarning = _this$state13.showWarning, warningType = _this$state13.warningType, width = _this$state13.width, height = _this$state13.height;
        if (metaWheelZoom && metaWheelZoomWarning || twoFingerDrag && twoFingerDragWarning) {
            var style = {
                position: "absolute",
                top: 0,
                left: 0,
                width: width,
                height: height,
                overflow: "hidden",
                pointerEvents: "none",
                opacity: showWarning ? 100 : 0,
                transition: "opacity 300ms",
                background: "rgba(0,0,0,0.5)",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 22,
                fontFamily: '"Arial", sans-serif',
                textAlign: "center",
                zIndex: warningZIndex
            };
            var meta = typeof window !== "undefined" && window.navigator && window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? "\u2318" : "ctrl";
            var warningText = warningType === "fingers" ? twoFingerDragWarning : metaWheelZoomWarning;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
                className: "pigeon-overlay-warning",
                style: style
            }, warningText.replace("META", meta));
        } else return null;
    };
    _proto.render = function render() {
        var _this$props6 = this.props, touchEvents = _this$props6.touchEvents, twoFingerDrag = _this$props6.twoFingerDrag;
        var _this$state14 = this.state, width = _this$state14.width, height = _this$state14.height;
        var containerStyle = {
            width: this.props.width ? width : "100%",
            height: this.props.height ? height : "100%",
            position: "relative",
            display: "inline-block",
            overflow: "hidden",
            background: "#dddddd",
            touchAction: touchEvents ? twoFingerDrag ? "pan-x pan-y" : "none" : "auto"
        };
        var hasSize = !!(width && height);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
            style: containerStyle,
            ref: this.setRef,
            dir: "ltr"
        }, hasSize && this.renderTiles(), hasSize && this.renderOverlays(), hasSize && this.renderAttribution(), hasSize && this.renderWarning());
    };
    return Map;
}((0, $f2Y41.Component));
$0ebf01b6999927a5$var$_defineProperty($0ebf01b6999927a5$export$a5c7b93649eaf8f8, "defaultProps", {
    animate: true,
    metaWheelZoom: false,
    metaWheelZoomWarning: "Use META + wheel to zoom!",
    twoFingerDrag: false,
    twoFingerDragWarning: "Use two fingers to move the map",
    zoomSnap: true,
    mouseEvents: true,
    touchEvents: true,
    warningZIndex: 100,
    animateMaxScreens: 5,
    minZoom: 1,
    maxZoom: 18,
    limitBounds: "center",
    dprs: [],
    tileComponent: $0ebf01b6999927a5$var$ImgTile
});
function $0ebf01b6999927a5$export$e98856a975cab58e(props) {
    var width = typeof props.width !== "undefined" ? props.width : typeof props.height !== "undefined" ? props.height * 29 / 34 : 29;
    var height = typeof props.height !== "undefined" ? props.height : typeof props.width !== "undefined" ? props.width * 34 / 29 : 34;
    var _useState = (0, $f2Y41.useState)(props.hover || false), internalHover = _useState[0], setInternalHover = _useState[1];
    var hover = typeof props.hover === "undefined" ? internalHover : props.hover;
    var color = props.color || "#93C0D0";
    var eventParameters = function eventParameters(event) {
        return {
            event: event,
            anchor: props.anchor,
            payload: props.payload
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        style: $0ebf01b6999927a5$var$_objectSpread2({
            position: "absolute",
            transform: "translate(" + (props.left - width / 2) + "px, " + (props.top - (height - 1)) + "px)",
            filter: hover ? "drop-shadow(0 0 4px rgba(0, 0, 0, .3))" : "",
            pointerEvents: "none",
            cursor: "pointer"
        }, props.style || {}),
        className: props.className ? props.className + " pigeon-click-block" : "pigeon-click-block",
        onClick: props.onClick ? function(event) {
            return props.onClick(eventParameters(event));
        } : null,
        onContextMenu: props.onContextMenu ? function(event) {
            return props.onContextMenu(eventParameters(event));
        } : null,
        onMouseOver: function onMouseOver(event) {
            props.onMouseOver && props.onMouseOver(eventParameters(event));
            setInternalHover(true);
        },
        onMouseOut: function onMouseOut(event) {
            props.onMouseOut && props.onMouseOut(eventParameters(event));
            setInternalHover(false);
        }
    }, props.children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 61 71",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("g", {
        style: {
            pointerEvents: "auto"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("path", {
        d: "M52 31.5C52 36.8395 49.18 42.314 45.0107 47.6094C40.8672 52.872 35.619 57.678 31.1763 61.6922C30.7916 62.0398 30.2084 62.0398 29.8237 61.6922C25.381 57.678 20.1328 52.872 15.9893 47.6094C11.82 42.314 9 36.8395 9 31.5C9 18.5709 18.6801 9 30.5 9C42.3199 9 52 18.5709 52 31.5Z",
        fill: color,
        stroke: "white",
        strokeWidth: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("circle", {
        cx: "30.5",
        cy: "30.5",
        r: "8.5",
        fill: "white",
        opacity: hover ? 0.98 : 0.6
    }))));
}
function $0ebf01b6999927a5$export$c6fdb837b070b4ff(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        style: $0ebf01b6999927a5$var$_objectSpread2({
            position: "absolute",
            transform: "translate(" + props.left + "px, " + props.top + "px)"
        }, props.style || {}),
        className: props.className ? props.className + " pigeon-click-block" : "pigeon-click-block"
    }, props.children);
}
var $0ebf01b6999927a5$var$defaultSvgAttributes = {
    fill: "#93c0d099",
    strokeWidth: "2",
    stroke: "white",
    r: "30"
};
function $0ebf01b6999927a5$var$PointComponent(props) {
    var latLngToPixel = props.latLngToPixel;
    var _props$coordinates = props.coordinates, y = _props$coordinates[0], x = _props$coordinates[1];
    var _latLngToPixel = latLngToPixel([
        x,
        y
    ]), cx = _latLngToPixel[0], cy = _latLngToPixel[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("circle", $0ebf01b6999927a5$var$_objectSpread2({
        cx: cx,
        cy: cy
    }, props.svgAttributes));
}
function $0ebf01b6999927a5$var$MultiPoint(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, props.coordinates.map(function(point, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$var$PointComponent, $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, props), {}, {
            coordinates: point,
            key: i
        }));
    }));
}
function $0ebf01b6999927a5$var$LineString(props) {
    var latLngToPixel = props.latLngToPixel;
    var p = "M" + props.coordinates.reduce(function(a, _ref) {
        var y = _ref[0], x = _ref[1];
        var _latLngToPixel2 = latLngToPixel([
            x,
            y
        ]), v = _latLngToPixel2[0], w = _latLngToPixel2[1];
        return a + " " + v + " " + w;
    }, "");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("path", $0ebf01b6999927a5$var$_objectSpread2({
        d: p
    }, props.svgAttributes));
}
function $0ebf01b6999927a5$var$MultiLineString(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, props.coordinates.map(function(line, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$var$LineString, $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, props), {}, {
            coordinates: line,
            key: i
        }));
    }));
}
function $0ebf01b6999927a5$var$Polygon(props) {
    var latLngToPixel = props.latLngToPixel;
    var p = props.coordinates.reduce(function(a, part) {
        return a + " M" + part.reduce(function(a, _ref2) {
            var y = _ref2[0], x = _ref2[1];
            var _latLngToPixel3 = latLngToPixel([
                x,
                y
            ]), v = _latLngToPixel3[0], w = _latLngToPixel3[1];
            return a + " " + v + " " + w;
        }, "") + "Z";
    }, "");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("path", $0ebf01b6999927a5$var$_objectSpread2({
        d: p
    }, props.svgAttributes));
}
function $0ebf01b6999927a5$var$MultiPolygon(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, props.coordinates.map(function(polygon, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$var$Polygon, $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, props), {}, {
            coordinates: polygon,
            key: i
        }));
    }));
}
function $0ebf01b6999927a5$var$GeometryCollection(props) {
    var renderer = {
        Point: $0ebf01b6999927a5$var$PointComponent,
        MultiPoint: $0ebf01b6999927a5$var$MultiPoint,
        LineString: $0ebf01b6999927a5$var$LineString,
        MultiLineString: $0ebf01b6999927a5$var$MultiLineString,
        Polygon: $0ebf01b6999927a5$var$Polygon,
        MultiPolygon: $0ebf01b6999927a5$var$MultiPolygon
    };
    var _props$geometry = props.geometry, type = _props$geometry.type, coordinates = _props$geometry.coordinates, geometries = _props$geometry.geometries;
    if (type === "GeometryCollection") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, geometries.map(function(geometry, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$var$GeometryCollection, $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({
            key: i
        }, props), {}, {
            geometry: geometry
        }));
    }));
    var Component = renderer[type];
    if (Component === undefined) {
        console.warn("The GeoJson Type " + type + " is not known");
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Component, {
        latLngToPixel: props.latLngToPixel,
        geometry: props.geometry,
        coordinates: coordinates,
        svgAttributes: props.svgAttributes
    });
}
function $0ebf01b6999927a5$export$f85d296e82545ce2(props) {
    var _useState = (0, $f2Y41.useState)(props.hover || false), internalHover = _useState[0], setInternalHover = _useState[1];
    var hover = props.hover !== undefined ? props.hover : internalHover;
    var callbackSvgAttributes = props.styleCallback && props.styleCallback(props.feature, hover);
    var svgAttributes = callbackSvgAttributes ? props.svgAttributes ? $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, props.svgAttributes), callbackSvgAttributes) : callbackSvgAttributes : props.svgAttributes ? props.svgAttributes : $0ebf01b6999927a5$var$defaultSvgAttributes;
    var eventParameters = function eventParameters(event) {
        return {
            event: event,
            anchor: props.anchor,
            payload: props.feature
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("g", {
        clipRule: "evenodd",
        style: {
            pointerEvents: "auto"
        },
        onClick: props.onClick ? function(event) {
            return props.onClick(eventParameters(event));
        } : null,
        onContextMenu: props.onContextMenu ? function(event) {
            return props.onContextMenu(eventParameters(event));
        } : null,
        onMouseOver: function onMouseOver(event) {
            props.onMouseOver && props.onMouseOver(eventParameters(event));
            setInternalHover(true);
        },
        onMouseOut: function onMouseOut(event) {
            props.onMouseOut && props.onMouseOut(eventParameters(event));
            setInternalHover(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$var$GeometryCollection, $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, props), props.feature), {}, {
        svgAttributes: svgAttributes
    })));
}
function $0ebf01b6999927a5$export$29ce0311c5beb608(props) {
    var _props$mapState = props.mapState, width = _props$mapState.width, height = _props$mapState.height;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        style: $0ebf01b6999927a5$var$_objectSpread2({
            position: "absolute",
            left: "0",
            top: "0",
            pointerEvents: "none",
            cursor: "pointer"
        }, props.style || {}),
        className: props.className ? props.className + " pigeon-click-block" : "pigeon-click-block"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 " + width + " " + height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props.data && props.data.features.map(function(feature, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$export$f85d296e82545ce2, $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({
            key: i
        }, props), {}, {
            feature: feature
        }));
    }), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Children.map(props.children, function(child) {
        if (!child) return null;
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).isValidElement(child)) return child;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).cloneElement(child, props);
    })));
}
function $0ebf01b6999927a5$export$21e04ca80d9335bb(props) {
    var _useState2 = (0, $f2Y41.useState)(props.data ? props.data : null), data = _useState2[0], setData = _useState2[1];
    (0, $f2Y41.useEffect)(function() {
        fetch(props.link).then(function(response) {
            return response.json();
        }).then(function(data) {
            return setData(data);
        });
    }, [
        props.link
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($0ebf01b6999927a5$export$29ce0311c5beb608, $0ebf01b6999927a5$var$_objectSpread2({
        data: data
    }, props)) : null;
}
function $0ebf01b6999927a5$var$isDescendentOf(element, ancestor) {
    while(element){
        if (element === ancestor) return true;
        element = element.parentElement;
    }
    return false;
}
var $0ebf01b6999927a5$var$defaultState = {
    isDragging: false,
    startX: undefined,
    startY: undefined,
    startLeft: undefined,
    startTop: undefined,
    deltaX: 0,
    deltaY: 0
};
function $0ebf01b6999927a5$export$f2a139e5d18b9882(props) {
    var dragRef = (0, $f2Y41.useRef)();
    var propsRef = (0, $f2Y41.useRef)(props);
    var stateRef = (0, $f2Y41.useRef)($0ebf01b6999927a5$var$_objectSpread2({}, $0ebf01b6999927a5$var$defaultState));
    var _useState = (0, $f2Y41.useState)($0ebf01b6999927a5$var$defaultState), _state = _useState[0], _setState = _useState[1];
    propsRef.current = props;
    var setState = function setState(stateUpdate) {
        var newState = $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, stateRef.current), stateUpdate);
        stateRef.current = newState;
        _setState(newState);
    };
    var _props$mapProps = props.mapProps, mouseEvents = _props$mapProps.mouseEvents, touchEvents = _props$mapProps.touchEvents;
    (0, $f2Y41.useEffect)(function() {
        var handleDragStart = function handleDragStart(event) {
            if ($0ebf01b6999927a5$var$isDescendentOf(event.target, dragRef.current)) {
                event.preventDefault();
                setState({
                    isDragging: true,
                    startX: ("touches" in event ? event.touches[0] : event).clientX,
                    startY: ("touches" in event ? event.touches[0] : event).clientY,
                    startLeft: propsRef.current.left,
                    startTop: propsRef.current.top,
                    deltaX: 0,
                    deltaY: 0
                });
                if (propsRef.current.onDragStart) {
                    var _propsRef$current = propsRef.current, _left = _propsRef$current.left, _top = _propsRef$current.top, offset = _propsRef$current.offset, pixelToLatLng = _propsRef$current.pixelToLatLng;
                    propsRef.current.onDragMove(pixelToLatLng([
                        _left + (offset ? offset[0] : 0),
                        _top + (offset ? offset[1] : 0)
                    ]));
                }
            }
        };
        var handleDragMove = function handleDragMove(event) {
            if (!stateRef.current.isDragging) return;
            event.preventDefault();
            var x = ("touches" in event ? event.touches[0] : event).clientX;
            var y = ("touches" in event ? event.touches[0] : event).clientY;
            var deltaX = x - stateRef.current.startX;
            var deltaY = y - stateRef.current.startY;
            setState({
                deltaX: deltaX,
                deltaY: deltaY
            });
            if (propsRef.current.onDragMove) {
                var _propsRef$current2 = propsRef.current, offset = _propsRef$current2.offset, pixelToLatLng = _propsRef$current2.pixelToLatLng;
                var _stateRef$current = stateRef.current, _startLeft = _stateRef$current.startLeft, _startTop = _stateRef$current.startTop;
                propsRef.current.onDragMove(pixelToLatLng([
                    _startLeft + deltaX + (offset ? offset[0] : 0),
                    _startTop + deltaY + (offset ? offset[1] : 0)
                ]));
            }
        };
        var handleDragEnd = function handleDragEnd(event) {
            var _propsRef$current$onD, _propsRef$current4;
            if (!stateRef.current.isDragging) return;
            event.preventDefault();
            var _propsRef$current3 = propsRef.current, offset = _propsRef$current3.offset, pixelToLatLng = _propsRef$current3.pixelToLatLng;
            var _stateRef$current2 = stateRef.current, deltaX = _stateRef$current2.deltaX, deltaY = _stateRef$current2.deltaY, startLeft = _stateRef$current2.startLeft, startTop = _stateRef$current2.startTop;
            (_propsRef$current$onD = (_propsRef$current4 = propsRef.current).onDragEnd) === null || _propsRef$current$onD === void 0 || _propsRef$current$onD.call(_propsRef$current4, pixelToLatLng([
                startLeft + deltaX + (offset ? offset[0] : 0),
                startTop + deltaY + (offset ? offset[1] : 0)
            ]));
            setState({
                isDragging: false,
                startX: undefined,
                startY: undefined,
                startLeft: undefined,
                startTop: undefined,
                deltaX: 0,
                deltaY: 0
            });
        };
        var wa = function wa(e, t, o) {
            return window.addEventListener(e, t, o);
        };
        var wr = function wr(e, t) {
            return window.removeEventListener(e, t);
        };
        if (mouseEvents) {
            wa("mousedown", handleDragStart);
            wa("mousemove", handleDragMove);
            wa("mouseup", handleDragEnd);
        }
        if (touchEvents) {
            wa("touchstart", handleDragStart, {
                passive: false
            });
            wa("touchmove", handleDragMove, {
                passive: false
            });
            wa("touchend", handleDragEnd, {
                passive: false
            });
        }
        return function() {
            if (mouseEvents) {
                wr("mousedown", handleDragStart);
                wr("mousemove", handleDragMove);
                wr("mouseup", handleDragEnd);
            }
            if (touchEvents) {
                wr("touchstart", handleDragStart);
                wr("touchmove", handleDragMove);
                wr("touchend", handleDragEnd);
            }
        };
    }, [
        mouseEvents,
        touchEvents
    ]);
    var left = props.left, top = props.top, className = props.className, style = props.style;
    var deltaX = _state.deltaX, deltaY = _state.deltaY, startLeft = _state.startLeft, startTop = _state.startTop, isDragging = _state.isDragging;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        style: $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({
            cursor: isDragging ? "grabbing" : "grab"
        }, style || {}), {}, {
            position: "absolute",
            transform: "translate(" + (isDragging ? startLeft + deltaX : left) + "px, " + (isDragging ? startTop + deltaY : top) + "px)"
        }),
        ref: dragRef,
        className: "pigeon-drag-block" + (className ? " " + className : "")
    }, props.children);
}
var $0ebf01b6999927a5$var$commonStyle = {
    position: "absolute",
    top: 10,
    left: 10
};
var $0ebf01b6999927a5$var$commonButtonStyle = {
    width: 28,
    height: 28,
    borderRadius: 2,
    boxShadow: "0 1px 4px -1px rgba(0,0,0,.3)",
    background: "white",
    lineHeight: "26px",
    fontSize: "20px",
    fontWeight: 700,
    color: "#666",
    marginBottom: 1,
    cursor: "pointer",
    border: "none",
    display: "block",
    outline: "none"
};
function $0ebf01b6999927a5$export$dd36b6cb96de1ba3(_ref) {
    var style = _ref.style, buttonStyle = _ref.buttonStyle, setCenterZoom = _ref.setCenterZoom, mapState = _ref.mapState, mapProps = _ref.mapProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        className: "pigeon-zoom-buttons pigeon-drag-block",
        style: style ? $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, $0ebf01b6999927a5$var$commonStyle), style) : $0ebf01b6999927a5$var$commonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("button", {
        className: "pigeon-zoom-in",
        type: "button",
        style: buttonStyle ? $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, $0ebf01b6999927a5$var$commonButtonStyle), buttonStyle) : $0ebf01b6999927a5$var$commonButtonStyle,
        onClick: function onClick() {
            return setCenterZoom(mapState.center, Math.min(mapState.zoom + 1, mapProps.maxZoom));
        }
    }, "+"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("button", {
        className: "pigeon-zoom-out",
        type: "button",
        style: buttonStyle ? $0ebf01b6999927a5$var$_objectSpread2($0ebf01b6999927a5$var$_objectSpread2({}, $0ebf01b6999927a5$var$commonButtonStyle), buttonStyle) : $0ebf01b6999927a5$var$commonButtonStyle,
        onClick: function onClick() {
            return setCenterZoom(mapState.center, Math.max(mapState.zoom - 1, mapProps.minZoom));
        }
    }, "\u2013"));
}


function $7db4d08de601cd5e$export$4fe7c69bb4e385db(x, y, z) {
    return "https://tile.openstreetmap.org/" + z + "/" + x + "/" + y + ".png";
}
function $7db4d08de601cd5e$export$1e3e020fc6bc2c1(x, y, z, dpr) {
    if (dpr === void 0) dpr = 1;
    return "https://stamen-tiles.a.ssl.fastly.net/toner/" + z + "/" + x + "/" + y + (dpr >= 2 ? "@2x" : "") + ".png";
}
function $7db4d08de601cd5e$export$39cfe06fb2f3c37c(x, y, z, dpr) {
    if (dpr === void 0) dpr = 1;
    return "https://stamen-tiles.a.ssl.fastly.net/terrain/" + z + "/" + x + "/" + y + (dpr >= 2 ? "@2x" : "") + ".jpg";
}
var $7db4d08de601cd5e$export$e4059fd0c5962790 = function maptiler(apiKey, map) {
    if (map === void 0) map = "streets";
    return function(x, y, z, dpr) {
        if (dpr === void 0) dpr = 1;
        return "https://api.maptiler.com/maps/" + map + "/256/" + z + "/" + x + "/" + y + (dpr >= 2 ? "@2x" : "") + ".png?key=" + apiKey;
    };
};
var $7db4d08de601cd5e$export$a225022bc81b135e = function stadiamaps(style) {
    if (style === void 0) style = "alidade_smooth";
    return function(x, y, z, dpr) {
        if (dpr === void 0) dpr = 1;
        return "https://tiles.stadiamaps.com/styles/" + style + "/" + z + "/" + x + "/" + y + (dpr >= 2 ? "@2x" : "") + ".png";
    };
};



const $a39efe5079b02b36$var$maptilerProvider = (0, $7db4d08de601cd5e$export$e4059fd0c5962790)("3gnsVB6Y3eU0swY5l1NV", "topo");
function $a39efe5079b02b36$export$d70af28cce04eac3(props) {
    const markers = props.markers;
    const mapProps = {
        defaultZoom: 3.75,
        markers: [],
        markCenter: false,
        center: {
            latitude: 37.0902,
            longitude: -95.7129
        },
        ...props
    };
    if (mapProps.markCenter) markers.push(props.center);
    const handleMarkerClick = (index)=>{
        for (const marker of markers)marker.showTitle = false;
        markers[index].showTitle = true;
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "p-4",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0ebf01b6999927a5$export$a5c7b93649eaf8f8), {
            provider: $a39efe5079b02b36$var$maptilerProvider,
            dprs: [
                1,
                2
            ],
            height: 400,
            defaultCenter: [
                mapProps.center?.latitude,
                mapProps.center?.longitude
            ],
            defaultZoom: mapProps.defaultZoom,
            children: markers?.map((marker, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $0ebf01b6999927a5$export$c6fdb837b070b4ff), {
                    offset: [
                        12,
                        24
                    ],
                    anchor: [
                        marker?.latitude,
                        marker?.longitude
                    ],
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        onClick: ()=>handleMarkerClick(index),
                        onKeyDown: ()=>handleMarkerClick(index),
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "LocationMarkerIcon"
                            }),
                            marker?.showTitle ?? marker.title
                        ]
                    })
                }, marker.title))
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");
function $4b62e8b2456b349f$export$7f7cbe89f1eacd2(props) {
    props = {
        ...props,
        textColor: "text-rose-700",
        bgColor: "bg-red-100"
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
        role: "status",
        className: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill"
            })
        ]
    });
}





var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
var $ab09d66e1a814f38$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $ab09d66e1a814f38$var$isDateObject = (value1)=>value1 instanceof Date;
var $ab09d66e1a814f38$var$isNullOrUndefined = (value1)=>value1 == null;
const $ab09d66e1a814f38$var$isObjectType = (value1)=>typeof value1 === "object";
var $ab09d66e1a814f38$var$isObject = (value1)=>!$ab09d66e1a814f38$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $ab09d66e1a814f38$var$isObjectType(value1) && !$ab09d66e1a814f38$var$isDateObject(value1);
var $ab09d66e1a814f38$var$getEventValue = (event)=>$ab09d66e1a814f38$var$isObject(event) && event.target ? $ab09d66e1a814f38$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $ab09d66e1a814f38$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $ab09d66e1a814f38$var$isNameInFieldArray = (names, name)=>names.has($ab09d66e1a814f38$var$getNodeParentName(name));
var $ab09d66e1a814f38$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $ab09d66e1a814f38$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $ab09d66e1a814f38$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $ab09d66e1a814f38$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($ab09d66e1a814f38$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $ab09d66e1a814f38$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$ab09d66e1a814f38$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $ab09d66e1a814f38$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $ab09d66e1a814f38$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $ab09d66e1a814f38$var$isUndefined = (val)=>val === undefined;
var $ab09d66e1a814f38$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$ab09d66e1a814f38$var$isObject(object)) return defaultValue;
    const result = $ab09d66e1a814f38$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$ab09d66e1a814f38$var$isNullOrUndefined(result) ? result : result[key], object);
    return $ab09d66e1a814f38$var$isUndefined(result) || result === object ? $ab09d66e1a814f38$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $ab09d66e1a814f38$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $ab09d66e1a814f38$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $ab09d66e1a814f38$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $ab09d66e1a814f38$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ab09d66e1a814f38$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useContext($ab09d66e1a814f38$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ab09d66e1a814f38$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($ab09d66e1a814f38$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $ab09d66e1a814f38$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $ab09d66e1a814f38$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $ab09d66e1a814f38$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $ab09d66e1a814f38$var$isEmptyObject = (value1)=>$ab09d66e1a814f38$var$isObject(value1) && !Object.keys(value1).length;
var $ab09d66e1a814f38$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $ab09d66e1a814f38$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $ab09d66e1a814f38$var$VALIDATION_MODE.all));
};
var $ab09d66e1a814f38$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $ab09d66e1a814f38$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $ab09d66e1a814f38$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $ab09d66e1a814f38$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ab09d66e1a814f38$export$606f11b2eb45ecc6(props) {
    const methods = $ab09d66e1a814f38$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(name);
    _name.current = name;
    $ab09d66e1a814f38$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $ab09d66e1a814f38$var$shouldSubscribeByName(_name.current, value1.name, exact) && $ab09d66e1a814f38$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $ab09d66e1a814f38$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $ab09d66e1a814f38$var$isString = (value1)=>typeof value1 === "string";
var $ab09d66e1a814f38$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($ab09d66e1a814f38$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $ab09d66e1a814f38$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $ab09d66e1a814f38$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $ab09d66e1a814f38$export$3c773aa2b84f29e0(props) {
    const methods = $ab09d66e1a814f38$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(name);
    _name.current = name;
    $ab09d66e1a814f38$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($ab09d66e1a814f38$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($ab09d66e1a814f38$var$cloneObject($ab09d66e1a814f38$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $ab09d66e1a814f38$var$isKey = (value1)=>/^\w*$/.test(value1);
var $ab09d66e1a814f38$var$stringToPath = (input)=>$ab09d66e1a814f38$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $ab09d66e1a814f38$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $ab09d66e1a814f38$var$isKey(path) ? [
        path
    ] : $ab09d66e1a814f38$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $ab09d66e1a814f38$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $ab09d66e1a814f38$export$e8c786024a2b0a79(props) {
    const methods = $ab09d66e1a814f38$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $ab09d66e1a814f38$var$isNameInFieldArray(control._names.array, name);
    const value1 = $ab09d66e1a814f38$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $ab09d66e1a814f38$export$3988ae62b71be9a3(control._formValues, name, $ab09d66e1a814f38$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $ab09d66e1a814f38$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$ab09d66e1a814f38$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $ab09d66e1a814f38$var$cloneObject($ab09d66e1a814f38$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $ab09d66e1a814f38$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($ab09d66e1a814f38$var$isUndefined($ab09d66e1a814f38$export$3988ae62b71be9a3(control._formValues, name))) $ab09d66e1a814f38$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        if ($ab09d66e1a814f38$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $ab09d66e1a814f38$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$ab09d66e1a814f38$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $ab09d66e1a814f38$var$getEventValue(event),
                        name: name
                    },
                    type: $ab09d66e1a814f38$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $ab09d66e1a814f38$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $ab09d66e1a814f38$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$ab09d66e1a814f38$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$ab09d66e1a814f38$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$ab09d66e1a814f38$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$ab09d66e1a814f38$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$ab09d66e1a814f38$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $ab09d66e1a814f38$export$bd0bf19f25da8474 = (props)=>props.render($ab09d66e1a814f38$export$e8c786024a2b0a79(props));
const $ab09d66e1a814f38$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $ab09d66e1a814f38$export$a7fed597f4b8afd8(props) {
    const methods = $ab09d66e1a814f38$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $ab09d66e1a814f38$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $ab09d66e1a814f38$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $ab09d66e1a814f38$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $ab09d66e1a814f38$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $ab09d66e1a814f38$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $ab09d66e1a814f38$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$ab09d66e1a814f38$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $ab09d66e1a814f38$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $ab09d66e1a814f38$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $ab09d66e1a814f38$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $ab09d66e1a814f38$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $ab09d66e1a814f38$var$VALIDATION_MODE.all,
        isOnTouch: mode === $ab09d66e1a814f38$var$VALIDATION_MODE.onTouched
    });
var $ab09d66e1a814f38$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $ab09d66e1a814f38$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $ab09d66e1a814f38$var$iterateFieldsByAction(currentField, action);
            } else if ($ab09d66e1a814f38$var$isObject(currentField)) $ab09d66e1a814f38$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $ab09d66e1a814f38$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $ab09d66e1a814f38$var$compact($ab09d66e1a814f38$export$3988ae62b71be9a3(errors, name));
    $ab09d66e1a814f38$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $ab09d66e1a814f38$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $ab09d66e1a814f38$var$isFileInput = (element)=>element.type === "file";
var $ab09d66e1a814f38$var$isFunction = (value1)=>typeof value1 === "function";
var $ab09d66e1a814f38$var$isHTMLElement = (value1)=>{
    if (!$ab09d66e1a814f38$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $ab09d66e1a814f38$var$isMessage = (value1)=>$ab09d66e1a814f38$var$isString(value1);
var $ab09d66e1a814f38$var$isRadioInput = (element)=>element.type === "radio";
var $ab09d66e1a814f38$var$isRegex = (value1)=>value1 instanceof RegExp;
const $ab09d66e1a814f38$var$defaultResult = {
    value: false,
    isValid: false
};
const $ab09d66e1a814f38$var$validResult = {
    value: true,
    isValid: true
};
var $ab09d66e1a814f38$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$ab09d66e1a814f38$var$isUndefined(options[0].attributes.value) ? $ab09d66e1a814f38$var$isUndefined(options[0].value) || options[0].value === "" ? $ab09d66e1a814f38$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $ab09d66e1a814f38$var$validResult : $ab09d66e1a814f38$var$defaultResult;
    }
    return $ab09d66e1a814f38$var$defaultResult;
};
const $ab09d66e1a814f38$var$defaultReturn = {
    isValid: false,
    value: null
};
var $ab09d66e1a814f38$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $ab09d66e1a814f38$var$defaultReturn) : $ab09d66e1a814f38$var$defaultReturn;
function $ab09d66e1a814f38$var$getValidateError(result, ref, type = "validate") {
    if ($ab09d66e1a814f38$var$isMessage(result) || Array.isArray(result) && result.every($ab09d66e1a814f38$var$isMessage) || $ab09d66e1a814f38$var$isBoolean(result) && !result) return {
        type: type,
        message: $ab09d66e1a814f38$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $ab09d66e1a814f38$var$getValueAndMessage = (validationData)=>$ab09d66e1a814f38$var$isObject(validationData) && !$ab09d66e1a814f38$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $ab09d66e1a814f38$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $ab09d66e1a814f38$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($ab09d66e1a814f38$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $ab09d66e1a814f38$var$isRadioInput(ref);
    const isCheckBox = $ab09d66e1a814f38$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $ab09d66e1a814f38$var$isFileInput(ref)) && $ab09d66e1a814f38$var$isUndefined(ref.value) && $ab09d66e1a814f38$var$isUndefined(inputValue) || $ab09d66e1a814f38$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $ab09d66e1a814f38$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.maxLength, minType = $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $ab09d66e1a814f38$var$isNullOrUndefined(inputValue)) || $ab09d66e1a814f38$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$ab09d66e1a814f38$var$getCheckboxValue(refs).isValid || isRadio && !$ab09d66e1a814f38$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $ab09d66e1a814f38$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $ab09d66e1a814f38$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$ab09d66e1a814f38$var$isNullOrUndefined(min) || !$ab09d66e1a814f38$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $ab09d66e1a814f38$var$getValueAndMessage(max);
        const minOutput = $ab09d66e1a814f38$var$getValueAndMessage(min);
        if (!$ab09d66e1a814f38$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$ab09d66e1a814f38$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$ab09d66e1a814f38$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($ab09d66e1a814f38$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($ab09d66e1a814f38$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.max, $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($ab09d66e1a814f38$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $ab09d66e1a814f38$var$getValueAndMessage(maxLength);
        const minLengthOutput = $ab09d66e1a814f38$var$getValueAndMessage(minLength);
        const exceedMax = !$ab09d66e1a814f38$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$ab09d66e1a814f38$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $ab09d66e1a814f38$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $ab09d66e1a814f38$var$getValueAndMessage(pattern);
        if ($ab09d66e1a814f38$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($ab09d66e1a814f38$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $ab09d66e1a814f38$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($ab09d66e1a814f38$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($ab09d66e1a814f38$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$ab09d66e1a814f38$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $ab09d66e1a814f38$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$ab09d66e1a814f38$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $ab09d66e1a814f38$var$appendAt = (data, value1)=>[
        ...data,
        ...$ab09d66e1a814f38$var$convertToArrayPayload(value1)
    ];
var $ab09d66e1a814f38$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $ab09d66e1a814f38$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$ab09d66e1a814f38$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $ab09d66e1a814f38$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($ab09d66e1a814f38$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $ab09d66e1a814f38$var$prependAt = (data, value1)=>[
        ...$ab09d66e1a814f38$var$convertToArrayPayload(value1),
        ...$ab09d66e1a814f38$var$convertToArrayPayload(data)
    ];
function $ab09d66e1a814f38$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $ab09d66e1a814f38$var$compact(temp).length ? temp : [];
}
var $ab09d66e1a814f38$var$removeArrayAt = (data, index)=>$ab09d66e1a814f38$var$isUndefined(index) ? [] : $ab09d66e1a814f38$var$removeAtIndexes(data, $ab09d66e1a814f38$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $ab09d66e1a814f38$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $ab09d66e1a814f38$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $ab09d66e1a814f38$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $ab09d66e1a814f38$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$ab09d66e1a814f38$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $ab09d66e1a814f38$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $ab09d66e1a814f38$var$isKey(path) ? [
        path
    ] : $ab09d66e1a814f38$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $ab09d66e1a814f38$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($ab09d66e1a814f38$var$isObject(childObject) && $ab09d66e1a814f38$var$isEmptyObject(childObject) || Array.isArray(childObject) && $ab09d66e1a814f38$var$isEmptyArray(childObject))) $ab09d66e1a814f38$var$unset(object, paths.slice(0, -1));
    return object;
}
var $ab09d66e1a814f38$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ab09d66e1a814f38$export$310131896651d559(props) {
    const methods = $ab09d66e1a814f38$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(control._getFieldArray(name).map($ab09d66e1a814f38$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $ab09d66e1a814f38$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $ab09d66e1a814f38$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($ab09d66e1a814f38$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $ab09d66e1a814f38$var$convertToArrayPayload($ab09d66e1a814f38$var$cloneObject(value1));
        const updatedFieldArrayValues = $ab09d66e1a814f38$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $ab09d66e1a814f38$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $ab09d66e1a814f38$var$appendAt(ids.current, appendValue.map($ab09d66e1a814f38$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$appendAt, {
            argA: $ab09d66e1a814f38$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $ab09d66e1a814f38$var$convertToArrayPayload($ab09d66e1a814f38$var$cloneObject(value1));
        const updatedFieldArrayValues = $ab09d66e1a814f38$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $ab09d66e1a814f38$var$getFocusFieldName(name, 0, options);
        ids.current = $ab09d66e1a814f38$var$prependAt(ids.current, prependValue.map($ab09d66e1a814f38$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$prependAt, {
            argA: $ab09d66e1a814f38$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $ab09d66e1a814f38$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $ab09d66e1a814f38$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $ab09d66e1a814f38$var$convertToArrayPayload($ab09d66e1a814f38$var$cloneObject(value1));
        const updatedFieldArrayValues = $ab09d66e1a814f38$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $ab09d66e1a814f38$var$getFocusFieldName(name, index, options);
        ids.current = $ab09d66e1a814f38$var$insert(ids.current, index, insertValue.map($ab09d66e1a814f38$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$insert, {
            argA: index,
            argB: $ab09d66e1a814f38$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ab09d66e1a814f38$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $ab09d66e1a814f38$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ab09d66e1a814f38$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $ab09d66e1a814f38$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $ab09d66e1a814f38$var$cloneObject(value1);
        const updatedFieldArrayValues = $ab09d66e1a814f38$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $ab09d66e1a814f38$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $ab09d66e1a814f38$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $ab09d66e1a814f38$var$convertToArrayPayload($ab09d66e1a814f38$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($ab09d66e1a814f38$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        control._state.action = false;
        $ab09d66e1a814f38$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$ab09d66e1a814f38$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $ab09d66e1a814f38$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $ab09d66e1a814f38$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $ab09d66e1a814f38$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $ab09d66e1a814f38$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($ab09d66e1a814f38$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $ab09d66e1a814f38$var$getValidationModes(control._options.mode).isOnSubmit)) $ab09d66e1a814f38$var$validateField(field, control._formValues, control._options.criteriaMode === $ab09d66e1a814f38$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$ab09d66e1a814f38$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $ab09d66e1a814f38$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $ab09d66e1a814f38$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        !$ab09d66e1a814f38$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $ab09d66e1a814f38$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $ab09d66e1a814f38$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $ab09d66e1a814f38$var$isPrimitive = (value1)=>$ab09d66e1a814f38$var$isNullOrUndefined(value1) || !$ab09d66e1a814f38$var$isObjectType(value1);
function $ab09d66e1a814f38$var$deepEqual(object1, object2) {
    if ($ab09d66e1a814f38$var$isPrimitive(object1) || $ab09d66e1a814f38$var$isPrimitive(object2)) return object1 === object2;
    if ($ab09d66e1a814f38$var$isDateObject(object1) && $ab09d66e1a814f38$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($ab09d66e1a814f38$var$isDateObject(val1) && $ab09d66e1a814f38$var$isDateObject(val2) || $ab09d66e1a814f38$var$isObject(val1) && $ab09d66e1a814f38$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$ab09d66e1a814f38$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $ab09d66e1a814f38$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $ab09d66e1a814f38$var$isRadioOrCheckbox = (ref)=>$ab09d66e1a814f38$var$isRadioInput(ref) || $ab09d66e1a814f38$var$isCheckBoxInput(ref);
var $ab09d66e1a814f38$var$live = (ref)=>$ab09d66e1a814f38$var$isHTMLElement(ref) && ref.isConnected;
var $ab09d66e1a814f38$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($ab09d66e1a814f38$var$isFunction(data[key])) return true;
    }
    return false;
};
function $ab09d66e1a814f38$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($ab09d66e1a814f38$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $ab09d66e1a814f38$var$isObject(data[key]) && !$ab09d66e1a814f38$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $ab09d66e1a814f38$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$ab09d66e1a814f38$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $ab09d66e1a814f38$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($ab09d66e1a814f38$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $ab09d66e1a814f38$var$isObject(data[key]) && !$ab09d66e1a814f38$var$objectHasFunction(data[key])) {
            if ($ab09d66e1a814f38$var$isUndefined(formValues) || $ab09d66e1a814f38$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $ab09d66e1a814f38$var$markFieldsDirty(data[key], []) : {
                ...$ab09d66e1a814f38$var$markFieldsDirty(data[key])
            };
            else $ab09d66e1a814f38$var$getDirtyFieldsFromDefaultValues(data[key], $ab09d66e1a814f38$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$ab09d66e1a814f38$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $ab09d66e1a814f38$var$getDirtyFields = (defaultValues, formValues)=>$ab09d66e1a814f38$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $ab09d66e1a814f38$var$markFieldsDirty(formValues));
var $ab09d66e1a814f38$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$ab09d66e1a814f38$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $ab09d66e1a814f38$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $ab09d66e1a814f38$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($ab09d66e1a814f38$var$isFileInput(ref)) return ref.files;
    if ($ab09d66e1a814f38$var$isRadioInput(ref)) return $ab09d66e1a814f38$var$getRadioValue(_f.refs).value;
    if ($ab09d66e1a814f38$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($ab09d66e1a814f38$var$isCheckBoxInput(ref)) return $ab09d66e1a814f38$var$getCheckboxValue(_f.refs).value;
    return $ab09d66e1a814f38$var$getFieldValueAs($ab09d66e1a814f38$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $ab09d66e1a814f38$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        field && $ab09d66e1a814f38$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $ab09d66e1a814f38$var$getRuleValue = (rule)=>$ab09d66e1a814f38$var$isUndefined(rule) ? rule : $ab09d66e1a814f38$var$isRegex(rule) ? rule.source : $ab09d66e1a814f38$var$isObject(rule) ? $ab09d66e1a814f38$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $ab09d66e1a814f38$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $ab09d66e1a814f38$var$schemaErrorLookup(errors, _fields, name) {
    const error = $ab09d66e1a814f38$export$3988ae62b71be9a3(errors, name);
    if (error || $ab09d66e1a814f38$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $ab09d66e1a814f38$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $ab09d66e1a814f38$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $ab09d66e1a814f38$var$unsetEmptyArray = (ref, name)=>!$ab09d66e1a814f38$var$compact($ab09d66e1a814f38$export$3988ae62b71be9a3(ref, name)).length && $ab09d66e1a814f38$var$unset(ref, name);
const $ab09d66e1a814f38$var$defaultOptions = {
    mode: $ab09d66e1a814f38$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $ab09d66e1a814f38$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $ab09d66e1a814f38$var$createFormControl(props = {}) {
    let _options = {
        ...$ab09d66e1a814f38$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $ab09d66e1a814f38$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $ab09d66e1a814f38$var$isObject(_options.defaultValues) || $ab09d66e1a814f38$var$isObject(_options.values) ? $ab09d66e1a814f38$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $ab09d66e1a814f38$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $ab09d66e1a814f38$var$createSubject(),
        array: $ab09d66e1a814f38$var$createSubject(),
        state: $ab09d66e1a814f38$var$createSubject()
    };
    const validationModeBeforeSubmit = $ab09d66e1a814f38$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $ab09d66e1a814f38$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $ab09d66e1a814f38$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $ab09d66e1a814f38$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $ab09d66e1a814f38$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$ab09d66e1a814f38$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $ab09d66e1a814f38$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $ab09d66e1a814f38$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $ab09d66e1a814f38$export$3988ae62b71be9a3(_formValues, name, $ab09d66e1a814f38$var$isUndefined(value1) ? $ab09d66e1a814f38$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $ab09d66e1a814f38$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $ab09d66e1a814f38$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name) && $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $ab09d66e1a814f38$var$deepEqual($ab09d66e1a814f38$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $ab09d66e1a814f38$var$unset(_formState.dirtyFields, name) : $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $ab09d66e1a814f38$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ab09d66e1a814f38$var$unset(_formState.errors, name);
        }
        if ((error ? !$ab09d66e1a814f38$var$deepEqual(previousFieldError, error) : previousFieldError) || !$ab09d66e1a814f38$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $ab09d66e1a814f38$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $ab09d66e1a814f38$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $ab09d66e1a814f38$export$3988ae62b71be9a3(errors, name);
            error ? $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ab09d66e1a814f38$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $ab09d66e1a814f38$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($ab09d66e1a814f38$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $ab09d66e1a814f38$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $ab09d66e1a814f38$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$ab09d66e1a814f38$var$live(ref)) : !$ab09d66e1a814f38$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, data), !$ab09d66e1a814f38$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$ab09d66e1a814f38$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $ab09d66e1a814f38$var$isUndefined(defaultValue) ? _defaultValues : $ab09d66e1a814f38$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$ab09d66e1a814f38$var$compact($ab09d66e1a814f38$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $ab09d66e1a814f38$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, $ab09d66e1a814f38$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $ab09d66e1a814f38$var$isHTMLElement(fieldReference.ref) && $ab09d66e1a814f38$var$isNullOrUndefined(value1) ? "" : value1;
                if ($ab09d66e1a814f38$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($ab09d66e1a814f38$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($ab09d66e1a814f38$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$ab09d66e1a814f38$var$isPrimitive(fieldValue) || field && !field._f) && !$ab09d66e1a814f38$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $ab09d66e1a814f38$var$cloneObject(value1);
        $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $ab09d66e1a814f38$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$ab09d66e1a814f38$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $ab09d66e1a814f38$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $ab09d66e1a814f38$var$getFieldValue(field._f) : $ab09d66e1a814f38$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $ab09d66e1a814f38$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $ab09d66e1a814f38$var$EVENTS.BLUR || event.type === $ab09d66e1a814f38$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$ab09d66e1a814f38$var$hasValidation(field._f) && !_options.resolver && !$ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $ab09d66e1a814f38$var$skipValidation(isBlurEvent, $ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $ab09d66e1a814f38$var$isWatched(name, _names, isBlurEvent);
            $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$ab09d66e1a814f38$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $ab09d66e1a814f38$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $ab09d66e1a814f38$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $ab09d66e1a814f38$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $ab09d66e1a814f38$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $ab09d66e1a814f38$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($ab09d66e1a814f38$var$isUndefined(name) ? name : fieldNames);
            isValid = $ab09d66e1a814f38$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$ab09d66e1a814f38$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$ab09d66e1a814f38$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $ab09d66e1a814f38$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $ab09d66e1a814f38$var$isUndefined(fieldNames) ? values : $ab09d66e1a814f38$var$isString(fieldNames) ? $ab09d66e1a814f38$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$ab09d66e1a814f38$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$ab09d66e1a814f38$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$ab09d66e1a814f38$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$ab09d66e1a814f38$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            isValidating: !!$ab09d66e1a814f38$export$3988ae62b71be9a3((formState || _formState).validatingFields, name),
            error: $ab09d66e1a814f38$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $ab09d66e1a814f38$var$convertToArrayPayload(name).forEach((inputName)=>$ab09d66e1a814f38$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$ab09d66e1a814f38$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $ab09d66e1a814f38$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $ab09d66e1a814f38$var$unset(_fields, fieldName);
                $ab09d66e1a814f38$var$unset(_formValues, fieldName);
            }
            !options.keepError && $ab09d66e1a814f38$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $ab09d66e1a814f38$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $ab09d66e1a814f38$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $ab09d66e1a814f38$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $ab09d66e1a814f38$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($ab09d66e1a814f38$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $ab09d66e1a814f38$var$isUndefined(value1) ? $ab09d66e1a814f38$var$getFieldValue(field ? field._f : $ab09d66e1a814f38$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $ab09d66e1a814f38$var$isBoolean(options.disabled);
        $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $ab09d66e1a814f38$var$getRuleValue(options.min),
                max: $ab09d66e1a814f38$var$getRuleValue(options.max),
                minLength: $ab09d66e1a814f38$var$getRuleValue(options.minLength),
                maxLength: $ab09d66e1a814f38$var$getRuleValue(options.maxLength),
                pattern: $ab09d66e1a814f38$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $ab09d66e1a814f38$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $ab09d66e1a814f38$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($ab09d66e1a814f38$var$live),
                                    fieldRef,
                                    ...Array.isArray($ab09d66e1a814f38$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($ab09d66e1a814f38$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $ab09d66e1a814f38$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($ab09d66e1a814f38$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $ab09d66e1a814f38$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $ab09d66e1a814f38$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $ab09d66e1a814f38$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $ab09d66e1a814f38$var$unset(_formState.errors, "root");
            if ($ab09d66e1a814f38$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $ab09d66e1a814f38$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name)) {
            if ($ab09d66e1a814f38$var$isUndefined(options.defaultValue)) setValue(name, $ab09d66e1a814f38$var$cloneObject($ab09d66e1a814f38$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $ab09d66e1a814f38$export$adaa4cf7ef1b65be(_defaultValues, name, $ab09d66e1a814f38$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $ab09d66e1a814f38$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $ab09d66e1a814f38$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $ab09d66e1a814f38$var$cloneObject($ab09d66e1a814f38$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $ab09d66e1a814f38$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $ab09d66e1a814f38$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $ab09d66e1a814f38$var$cloneObject(updatedValues);
        const isEmptyResetValues = $ab09d66e1a814f38$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$ab09d66e1a814f38$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $ab09d66e1a814f38$export$adaa4cf7ef1b65be(values, fieldName, $ab09d66e1a814f38$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $ab09d66e1a814f38$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($ab09d66e1a814f38$var$isWeb && $ab09d66e1a814f38$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($ab09d66e1a814f38$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $ab09d66e1a814f38$var$cloneObject(_defaultValues) : {} : $ab09d66e1a814f38$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$ab09d66e1a814f38$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $ab09d66e1a814f38$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $ab09d66e1a814f38$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($ab09d66e1a814f38$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $ab09d66e1a814f38$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$ab09d66e1a814f38$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $ab09d66e1a814f38$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $ab09d66e1a814f38$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $ab09d66e1a814f38$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$ab09d66e1a814f38$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $ab09d66e1a814f38$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($ab09d66e1a814f38$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        if (props.values && !$ab09d66e1a814f38$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $ab09d66e1a814f38$var$getProxyFormState(formState, control);
    return _formControl.current;
}



// via this very helpful article
// https://devtrium.com/posts/how-keyboard-shortcut#extracting-the-logic-into-a-reusable-custom-hook

var $f2Y41 = parcelRequire("f2Y41");
const $e11587f884e634f5$export$b65485ca34c366f3 = (keys, callback, node = null)=>{
    // implement the callback ref pattern
    const callbackRef = (0, $f2Y41.useRef)(callback);
    (0, $f2Y41.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    });
    // handle what happens on key press
    const handleKeyPress = (0, $f2Y41.useCallback)((event)=>{
        // check if one of the key is part of the ones we want
        if (keys.some((key)=>event.key === key)) callbackRef.current(event);
    }, [
        keys
    ]);
    (0, $f2Y41.useEffect)(()=>{
        // target is either the provided node or the document
        const targetNode = node ?? document;
        // attach the event listener
        targetNode && targetNode.addEventListener("keydown", handleKeyPress);
        // remove the event listener
        return ()=>targetNode && targetNode.removeEventListener("keydown", handleKeyPress);
    }, [
        handleKeyPress,
        node
    ]);
};


function $b9a0f42c8d991ed3$export$b1beaf1ac04ab5db(props) {
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: practice } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("admin/practices", props.practiceId);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    (0, $f2Y41.useEffect)(()=>{
        if (practice?.name !== undefined) reset(practice);
    }, [
        practice,
        reset
    ]);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/practices", props.practiceId, data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Practice",
        key: "practice"
    };
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        },
        {
            label: "Address",
            key: "address"
        },
        {
            label: "Esource Practice Slug",
            key: "xref_esource_practice_slug"
        },
        {
            label: "Waypoints Practice Slug",
            key: "waypoints_practice_slug"
        },
        {
            label: "Latitude",
            key: "latitude"
        },
        {
            label: "Longitude",
            key: "longitude"
        },
        {
            label: "Monday.com Workspace Id",
            key: "task_workspace_xref_id"
        },
        {
            label: "Monday.com Task Folder Id",
            key: "task_folder_xref_id"
        },
        {
            label: "Monday.com Practice Team Id",
            key: "task_team_xref_id"
        },
        {
            label: "Provider Support Phone Number",
            key: "provider_support_phone_number"
        },
        {
            label: "Tenancy",
            key: "multi_tenant",
            options: [
                {
                    label: "Multi-tenant",
                    value: true
                },
                {
                    label: "Single-tenant",
                    value: false
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "edit-practice-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "Edit ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    selected: true,
                                                                    disabled: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.value,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>closeModal(),
                onKeyUp: ()=>closeModal(),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
function $7ae9e3d9e79aec32$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $8b81a70c157af4cc$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $7ae9e3d9e79aec32$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $8b81a70c157af4cc$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}


function $d649f2b4cbccd3d1$export$fd183955ff4b45d9() {
    let [e] = (0, $f2Y41.useState)((0, $8b81a70c157af4cc$export$12b26c28a05aa001));
    return (0, $f2Y41.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
var $f5d08f005eec5ab7$var$i = Object.defineProperty;
var $f5d08f005eec5ab7$var$d = (t, e, n)=>e in t ? $f5d08f005eec5ab7$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $f5d08f005eec5ab7$var$r = (t, e, n)=>($f5d08f005eec5ab7$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $f5d08f005eec5ab7$var$o {
    constructor(){
        $f5d08f005eec5ab7$var$r(this, "current", this.detect());
        $f5d08f005eec5ab7$var$r(this, "handoffState", "pending");
        $f5d08f005eec5ab7$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3 = new $f5d08f005eec5ab7$var$o;


let $8bfa4e5c53a50bc6$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).isServer ? (0, $f2Y41.useEffect)(e, f) : (0, $f2Y41.useLayoutEffect)(e, f);
};


function $2cae1ff5dfbdd805$export$86c4283a11f23f95(e) {
    let r = (0, $f2Y41.useRef)(e);
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $937d0122ac3ce8be$export$90fc3a17d93f704c = function(t) {
    let e = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};



var $f2Y41 = parcelRequire("f2Y41");

function $94bcc444643f252a$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(a);
    (0, $f2Y41.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");

function $20a16c989554885c$export$80c2a3957bcb42ea() {
    let e = (0, $f2Y41.useRef)(!1);
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}



var $f2Y41 = parcelRequire("f2Y41");


function $52d1d7618fb1a91c$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(t), e = (0, $f2Y41.useRef)(!1);
    (0, $f2Y41.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $7ae9e3d9e79aec32$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");

function $225dec9ff04e4a5b$export$b204af158042fbac(r) {
    return (0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}


function $d6faca5411d2a17f$export$dd9fbcea3de0ae36(...e) {
    return (0, $f2Y41.useMemo)(()=>(0, $225dec9ff04e4a5b$export$b204af158042fbac)(...e), [
        ...e
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");

function $c44f382372d3bfa8$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $f2Y41 ? ((o)=>o.useSyncExternalStore)($f2Y41)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $c44f382372d3bfa8$export$44ab2b9f2d09b0fa() {
    let r = $c44f382372d3bfa8$var$s(), [e, n] = $f2Y41.useState((0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $f2Y41.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $f2Y41.useEffect(()=>(0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}



var $f2Y41 = parcelRequire("f2Y41");

let $ee0946aeccd5ac5d$var$u = Symbol();
function $ee0946aeccd5ac5d$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$ee0946aeccd5ac5d$var$u]: n
    });
}
function $ee0946aeccd5ac5d$export$f6a25a78204acc7e(...t) {
    let n = (0, $f2Y41.useRef)(t);
    (0, $f2Y41.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$ee0946aeccd5ac5d$var$u])) ? void 0 : c;
}



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");

function $f183e9735993ff40$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(r);
    (0, $f2Y41.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


var $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1 || {});
function $a2ca7c5cfdcfbeeb$export$19b797546aece48f() {
    let e = (0, $f2Y41.useRef)(0);
    return (0, $f183e9735993ff40$export$ee579bb285b8d4aa)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}



var $f2Y41 = parcelRequire("f2Y41");

function $45a97ea383d12e2a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $f2Y41.useRef)([]), r = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(u);
    (0, $f2Y41.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");
function $654761d306a09dd0$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}


function $01099572ffa9156b$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $01099572ffa9156b$export$4659b591c19bdf3d), t;
}


var $43f03f8737506038$export$617d79dae526d2cf = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))($43f03f8737506038$export$617d79dae526d2cf || {}), $43f03f8737506038$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($43f03f8737506038$export$80c0a745e59f7989 || {});
function $43f03f8737506038$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: f, mergeRefs: l }) {
    l = l != null ? l : $43f03f8737506038$var$k;
    let s = $43f03f8737506038$var$R(t, r);
    if (a) return $43f03f8737506038$var$m(s, e, n, f, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: u = !1, ...d } = s;
        if (u) return $43f03f8737506038$var$m(d, e, n, f, l);
    }
    if (y & 1) {
        let { unmount: u = !0, ...d } = s;
        return (0, $01099572ffa9156b$export$4659b591c19bdf3d)(u ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $43f03f8737506038$var$m({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, f, l);
            }
        });
    }
    return $43f03f8737506038$var$m(s, e, n, f, l);
}
function $43f03f8737506038$var$m(r, t = {}, e, n, o) {
    let { as: a = e, children: f, refName: l = "ref", ...s } = $43f03f8737506038$var$F(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, u = typeof f == "function" ? f(t) : f;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
    let d = {};
    if (t) {
        let i = !1, c = [];
        for (let [T, p] of Object.entries(t))typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
        i && (d["data-headlessui-state"] = c.join(" "));
    }
    if (a === (0, $f2Y41.Fragment) && Object.keys($43f03f8737506038$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $f2Y41.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let i = u.props, c = typeof (i == null ? void 0 : i.className) == "function" ? (...p)=>(0, $654761d306a09dd0$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className(...p), s.className) : (0, $654761d306a09dd0$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className, s.className), T = c ? {
            className: c
        } : {};
        return (0, $f2Y41.cloneElement)(u, Object.assign({}, $43f03f8737506038$var$R(u.props, $43f03f8737506038$export$8e16b83750b44988($43f03f8737506038$var$F(s, [
            "ref"
        ]))), d, y, {
            ref: o(u.ref, y.ref)
        }, T));
    }
    return (0, $f2Y41.createElement)(a, Object.assign({}, $43f03f8737506038$var$F(s, [
        "ref"
    ]), a !== (0, $f2Y41.Fragment) && y, a !== (0, $f2Y41.Fragment) && d), u);
}
function $43f03f8737506038$export$81218df071161f0a() {
    let r = (0, $f2Y41.useRef)([]), t = (0, $f2Y41.useCallback)((e)=>{
        for (let n of r.current)n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((n)=>n == null)) return r.current = e, t;
    };
}
function $43f03f8737506038$var$k(...r) {
    return r.every((t)=>t == null) ? void 0 : (t)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
    };
}
function $43f03f8737506038$var$R(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a, ...f) {
            let l = e[o];
            for (let s of l){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                s(a, ...f);
            }
        }
    });
    return t;
}
function $43f03f8737506038$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $f2Y41.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $43f03f8737506038$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $43f03f8737506038$var$F(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}


let $442d8163a4865c09$var$p = "div";
var $442d8163a4865c09$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($442d8163a4865c09$export$617d79dae526d2cf || {});
function $442d8163a4865c09$var$l(d, o) {
    var n;
    let { features: t = 1, ...e } = d, r = {
        ref: o,
        "aria-hidden": (t & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (t & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(t & 4) === 4 && (t & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: r,
        theirProps: e,
        slot: {},
        defaultTag: $442d8163a4865c09$var$p,
        name: "Hidden"
    });
}
let $442d8163a4865c09$export$8dc98ba7eadeaa56 = (0, $43f03f8737506038$export$e43f39796049410c)($442d8163a4865c09$var$l);


function $e10b69d66529b432$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}


let $fddbd516d459ec06$export$55abd4691b317664 = [];
(0, $e10b69d66529b432$export$a6a2315df743a26b)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $fddbd516d459ec06$export$55abd4691b317664[0] !== n.target && ($fddbd516d459ec06$export$55abd4691b317664.unshift(n.target), $fddbd516d459ec06$export$55abd4691b317664 = $fddbd516d459ec06$export$55abd4691b317664.filter((r)=>r != null && r.isConnected), $fddbd516d459ec06$export$55abd4691b317664.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});





let $4d75beccbbd4c437$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $4d75beccbbd4c437$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($4d75beccbbd4c437$export$807a7eae502106e7 || {}), $4d75beccbbd4c437$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($4d75beccbbd4c437$export$abf286375dfa6dbd || {}), $4d75beccbbd4c437$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($4d75beccbbd4c437$var$F || {});
function $4d75beccbbd4c437$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($4d75beccbbd4c437$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $4d75beccbbd4c437$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($4d75beccbbd4c437$export$27112a34f2f8402d || {});
function $4d75beccbbd4c437$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $225dec9ff04e4a5b$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $01099572ffa9156b$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($4d75beccbbd4c437$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($4d75beccbbd4c437$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $4d75beccbbd4c437$export$46388676ec35ab85(e) {
    let r = (0, $225dec9ff04e4a5b$export$b204af158042fbac)(e);
    (0, $8b81a70c157af4cc$export$12b26c28a05aa001)().nextFrame(()=>{
        r && !$4d75beccbbd4c437$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $4d75beccbbd4c437$export$5fed9cc43865dc7e(e);
    });
}
var $4d75beccbbd4c437$var$w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($4d75beccbbd4c437$var$w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $4d75beccbbd4c437$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $4d75beccbbd4c437$var$S = [
    "textarea",
    "input"
].join(",");
function $4d75beccbbd4c437$var$H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $4d75beccbbd4c437$var$S)) != null ? t : !1;
}
function $4d75beccbbd4c437$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $4d75beccbbd4c437$export$7fb6c844b485e870(e, r) {
    return $4d75beccbbd4c437$export$82e1f4f412218a1d($4d75beccbbd4c437$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $4d75beccbbd4c437$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? $4d75beccbbd4c437$export$20305e96f91bf103(e) : e : $4d75beccbbd4c437$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && $4d75beccbbd4c437$var$H(u) && u.select(), 2;
}





function $166a3602532ef737$var$P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let n = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && n.add(e.current);
    return n;
}
let $166a3602532ef737$var$X = "div";
var $166a3602532ef737$var$_ = ((r)=>(r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))($166a3602532ef737$var$_ || {});
function $166a3602532ef737$var$z(t, n) {
    let e = (0, $f2Y41.useRef)(null), o = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(e, n), { initialFocus: l, containers: c, features: r = 30, ...s } = t;
    (0, $c44f382372d3bfa8$export$44ab2b9f2d09b0fa)() || (r = 1);
    let i = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(e);
    $166a3602532ef737$var$Y({
        ownerDocument: i
    }, Boolean(r & 16));
    let u = $166a3602532ef737$var$Z({
        ownerDocument: i,
        container: e,
        initialFocus: l
    }, Boolean(r & 2));
    $166a3602532ef737$var$$({
        ownerDocument: i,
        container: e,
        containers: c,
        previousActiveElement: u
    }, Boolean(r & 8));
    let y = (0, $a2ca7c5cfdcfbeeb$export$19b797546aece48f)(), R = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((a)=>{
        let m = e.current;
        if (!m) return;
        ((B)=>B())(()=>{
            (0, $01099572ffa9156b$export$4659b591c19bdf3d)(y.current, {
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(m, (0, $4d75beccbbd4c437$export$807a7eae502106e7).First, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                },
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(m, (0, $4d75beccbbd4c437$export$807a7eae502106e7).Last, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                }
            });
        });
    }), h = (0, $d649f2b4cbccd3d1$export$fd183955ff4b45d9)(), H = (0, $f2Y41.useRef)(!1), j = {
        ref: o,
        onKeyDown (a) {
            a.key == "Tab" && (H.current = !0, h.requestAnimationFrame(()=>{
                H.current = !1;
            }));
        },
        onBlur (a) {
            let m = $166a3602532ef737$var$P(c);
            e.current instanceof HTMLElement && m.add(e.current);
            let T = a.relatedTarget;
            T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && ($166a3602532ef737$var$S(m, T) || (H.current ? (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(e.current, (0, $01099572ffa9156b$export$4659b591c19bdf3d)(y.current, {
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $4d75beccbbd4c437$export$807a7eae502106e7).Next,
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $4d75beccbbd4c437$export$807a7eae502106e7).Previous
            }) | (0, $4d75beccbbd4c437$export$807a7eae502106e7).WrapAround, {
                relativeTo: a.target
            }) : a.target instanceof HTMLElement && (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(a.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, Boolean(r & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Focusable
    }), (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: j,
        theirProps: s,
        defaultTag: $166a3602532ef737$var$X,
        name: "FocusTrap"
    }), Boolean(r & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Focusable
    }));
}
let $166a3602532ef737$var$D = (0, $43f03f8737506038$export$e43f39796049410c)($166a3602532ef737$var$z), $166a3602532ef737$export$34eba2437817a67b = Object.assign($166a3602532ef737$var$D, {
    features: $166a3602532ef737$var$_
});
function $166a3602532ef737$var$Q(t = !0) {
    let n = (0, $f2Y41.useRef)((0, $fddbd516d459ec06$export$55abd4691b317664).slice());
    return (0, $45a97ea383d12e2a$export$3c773aa2b84f29e0)(([e], [o])=>{
        o === !0 && e === !1 && (0, $7ae9e3d9e79aec32$export$a5ff0d6a738703ca)(()=>{
            n.current.splice(0);
        }), o === !1 && e === !0 && (n.current = (0, $fddbd516d459ec06$export$55abd4691b317664).slice());
    }, [
        t,
        (0, $fddbd516d459ec06$export$55abd4691b317664),
        n
    ]), (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = n.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function $166a3602532ef737$var$Y({ ownerDocument: t }, n) {
    let e = $166a3602532ef737$var$Q(n);
    (0, $45a97ea383d12e2a$export$3c773aa2b84f29e0)(()=>{
        n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(e());
    }, [
        n
    ]), (0, $52d1d7618fb1a91c$export$cd059ee7fd0e9f3d)(()=>{
        n && (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(e());
    });
}
function $166a3602532ef737$var$Z({ ownerDocument: t, container: n, initialFocus: e }, o) {
    let l = (0, $f2Y41.useRef)(null), c = (0, $20a16c989554885c$export$80c2a3957bcb42ea)();
    return (0, $45a97ea383d12e2a$export$3c773aa2b84f29e0)(()=>{
        if (!o) return;
        let r = n.current;
        r && (0, $7ae9e3d9e79aec32$export$a5ff0d6a738703ca)(()=>{
            if (!c.current) return;
            let s = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === s) {
                    l.current = s;
                    return;
                }
            } else if (r.contains(s)) {
                l.current = s;
                return;
            }
            e != null && e.current ? (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(e.current) : (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(r, (0, $4d75beccbbd4c437$export$807a7eae502106e7).First) === (0, $4d75beccbbd4c437$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), l;
}
function $166a3602532ef737$var$$({ ownerDocument: t, container: n, containers: e, previousActiveElement: o }, l) {
    let c = (0, $20a16c989554885c$export$80c2a3957bcb42ea)();
    (0, $94bcc444643f252a$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", (r)=>{
        if (!l || !c.current) return;
        let s = $166a3602532ef737$var$P(e);
        n.current instanceof HTMLElement && s.add(n.current);
        let i = o.current;
        if (!i) return;
        let u = r.target;
        u && u instanceof HTMLElement ? $166a3602532ef737$var$S(s, u) ? (o.current = u, (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(u)) : (r.preventDefault(), r.stopPropagation(), (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(i)) : (0, $4d75beccbbd4c437$export$5fed9cc43865dc7e)(o.current);
    }, !0);
}
function $166a3602532ef737$var$S(t, n) {
    for (let e of t)if (e.contains(n)) return !0;
    return !1;
}



var $f2Y41 = parcelRequire("f2Y41");








var $f2Y41 = parcelRequire("f2Y41");
let $37d4074b08e4688f$var$e = (0, $f2Y41.createContext)(!1);
function $37d4074b08e4688f$export$6ecd3efa4eebe261() {
    return (0, $f2Y41.useContext)($37d4074b08e4688f$var$e);
}
function $37d4074b08e4688f$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($37d4074b08e4688f$var$e.Provider, {
        value: o.force
    }, o.children);
}




function $af736e5a07684d0e$var$F(p) {
    let n = (0, $37d4074b08e4688f$export$6ecd3efa4eebe261)(), l = (0, $f2Y41.useContext)($af736e5a07684d0e$var$_), e = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(p), [a, o] = (0, $f2Y41.useState)(()=>{
        if (!n && l !== null || (0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, $f2Y41.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, $f2Y41.useEffect)(()=>{
        n || l !== null && o(l.current);
    }, [
        l,
        o,
        n
    ]), a;
}
let $af736e5a07684d0e$var$U = (0, $f2Y41.Fragment);
function $af736e5a07684d0e$var$N(p, n) {
    let l = p, e = (0, $f2Y41.useRef)(null), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)((0, $ee0946aeccd5ac5d$export$7029785b750eb74)((u)=>{
        e.current = u;
    }), n), o = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(e), t = $af736e5a07684d0e$var$F(e), [r] = (0, $f2Y41.useState)(()=>{
        var u;
        return (0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, $f2Y41.useContext)($af736e5a07684d0e$var$f), v = (0, $c44f382372d3bfa8$export$44ab2b9f2d09b0fa)();
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, $52d1d7618fb1a91c$export$cd059ee7fd0e9f3d)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), v ? !t || !r ? null : (0, $5021361ff788fb77$exports.createPortal)((0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a
        },
        theirProps: l,
        defaultTag: $af736e5a07684d0e$var$U,
        name: "Portal"
    }), r) : null;
}
let $af736e5a07684d0e$var$S = (0, $f2Y41.Fragment), $af736e5a07684d0e$var$_ = (0, $f2Y41.createContext)(null);
function $af736e5a07684d0e$var$j(p, n) {
    let { target: l, ...e } = p, o = {
        ref: (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(n)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($af736e5a07684d0e$var$_.Provider, {
        value: l
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: e,
        defaultTag: $af736e5a07684d0e$var$S,
        name: "Popover.Group"
    }));
}
let $af736e5a07684d0e$var$f = (0, $f2Y41.createContext)(null);
function $af736e5a07684d0e$export$26b8c35244a70b37() {
    let p = (0, $f2Y41.useContext)($af736e5a07684d0e$var$f), n = (0, $f2Y41.useRef)([]), l = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((o)=>(n.current.push(o), p && p.register(o), ()=>e(o))), e = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((o)=>{
        let t = n.current.indexOf(o);
        t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, $f2Y41.useMemo)(()=>({
            register: l,
            unregister: e,
            portals: n
        }), [
        l,
        e,
        n
    ]);
    return [
        n,
        (0, $f2Y41.useMemo)(()=>function({ children: t }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($af736e5a07684d0e$var$f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let $af736e5a07684d0e$var$D = (0, $43f03f8737506038$export$e43f39796049410c)($af736e5a07684d0e$var$N), $af736e5a07684d0e$var$I = (0, $43f03f8737506038$export$e43f39796049410c)($af736e5a07684d0e$var$j), $af736e5a07684d0e$export$602eac185826482c = Object.assign($af736e5a07684d0e$var$D, {
    Group: $af736e5a07684d0e$var$I
});



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
function $fc5e7c803cf0f686$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $fc5e7c803cf0f686$var$d = typeof Object.is == "function" ? Object.is : $fc5e7c803cf0f686$var$i, { useState: $fc5e7c803cf0f686$var$u, useEffect: $fc5e7c803cf0f686$var$h, useLayoutEffect: $fc5e7c803cf0f686$var$f, useDebugValue: $fc5e7c803cf0f686$var$p } = $f2Y41;
let $fc5e7c803cf0f686$var$S = !1, $fc5e7c803cf0f686$var$_ = !1;
function $fc5e7c803cf0f686$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $fc5e7c803cf0f686$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $fc5e7c803cf0f686$var$f(()=>{
        n.value = a, n.getSnapshot = t, $fc5e7c803cf0f686$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $fc5e7c803cf0f686$var$h(()=>($fc5e7c803cf0f686$var$r(n) && o({
            inst: n
        }), e(()=>{
            $fc5e7c803cf0f686$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $fc5e7c803cf0f686$var$p(a), a;
}
function $fc5e7c803cf0f686$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$fc5e7c803cf0f686$var$d(c, a);
    } catch  {
        return !0;
    }
}


function $38f2cb15acd503b3$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}


const $e26abe71783eb30e$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $e26abe71783eb30e$var$s = !$e26abe71783eb30e$var$r, $e26abe71783eb30e$var$c = $e26abe71783eb30e$var$s ? (0, $38f2cb15acd503b3$export$306c0aa65ff9ec16) : (0, $fc5e7c803cf0f686$export$306c0aa65ff9ec16), $e26abe71783eb30e$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $f2Y41 ? ((n)=>n.useSyncExternalStore)($f2Y41) : $e26abe71783eb30e$var$c;


function $de5f92f1841abbed$export$6ccbb43953eebf8(t) {
    return (0, $e26abe71783eb30e$export$306c0aa65ff9ec16)(t.subscribe, t.getSnapshot, t.getSnapshot);
}




function $a4bbad25dfa9e997$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $9d80bbf4e23bfea3$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}



function $b7b61fe673576792$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $b7b61fe673576792$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $b7b61fe673576792$export$d0a8044dce8ff2fc() {
    return $b7b61fe673576792$export$fedb369cb70207f1() || $b7b61fe673576792$export$a11b0059900ceec8();
}


function $807f784b12a43d37$export$e3a523dfabf27286() {
    return (0, $b7b61fe673576792$export$fedb369cb70207f1)() ? {
        before ({ doc: r, d: l, meta: c }) {
            function o(a) {
                return c.containers.flatMap((n)=>n()).some((n)=>n.contains(a));
            }
            l.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $8b81a70c157af4cc$export$12b26c28a05aa001)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), l.add(()=>l.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, n = null;
                l.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (n = i);
                    } catch  {}
                }, !0), l.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            l.style(e, "overscrollBehavior", "contain");
                        } else l.style(t.target, "touchAction", "none");
                    }
                }), l.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), l.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), n && n.isConnected && (n.scrollIntoView({
                        block: "nearest"
                    }), n = null);
                });
            });
        }
    } : {};
}


function $88ca3675c7246bd2$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $4f92c5e335b3b0e1$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $4f92c5e335b3b0e1$export$a4161f418919b5aa = (0, $a4bbad25dfa9e997$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $8b81a70c157af4cc$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $4f92c5e335b3b0e1$var$m(t)
        }, c = [
            (0, $807f784b12a43d37$export$e3a523dfabf27286)(),
            (0, $9d80bbf4e23bfea3$export$110627fb35ef9205)(),
            (0, $88ca3675c7246bd2$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$4f92c5e335b3b0e1$export$a4161f418919b5aa.subscribe(()=>{
    let e = $4f92c5e335b3b0e1$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $4f92c5e335b3b0e1$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $4f92c5e335b3b0e1$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $f0abf6bdceac87e3$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $de5f92f1841abbed$export$6ccbb43953eebf8)((0, $4f92c5e335b3b0e1$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $4f92c5e335b3b0e1$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $4f92c5e335b3b0e1$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}





var $f2Y41 = parcelRequire("f2Y41");



var $8fb4eba1dcb7930e$var$o;
let $8fb4eba1dcb7930e$export$f680877a34711e37 = ($8fb4eba1dcb7930e$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useId) != null ? $8fb4eba1dcb7930e$var$o : function() {
    let n = (0, $c44f382372d3bfa8$export$44ab2b9f2d09b0fa)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useState(n ? ()=>(0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).nextId() : null);
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        e === null && u((0, $f5d08f005eec5ab7$export$a7b6bc01c63cdfc3).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};



let $62d9f7ced91d456a$var$u = new Map, $62d9f7ced91d456a$var$t = new Map;
function $62d9f7ced91d456a$export$bbe4e2927a3450da(r, l = !0) {
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = $62d9f7ced91d456a$var$t.get(e)) != null ? d : 1;
            if (i === 1 ? $62d9f7ced91d456a$var$t.delete(e) : $62d9f7ced91d456a$var$t.set(e, i - 1), i !== 1) return;
            let n = $62d9f7ced91d456a$var$u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $62d9f7ced91d456a$var$u.delete(e));
        }
        let f = (o = $62d9f7ced91d456a$var$t.get(e)) != null ? o : 0;
        return $62d9f7ced91d456a$var$t.set(e, f + 1), f !== 0 || ($62d9f7ced91d456a$var$u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");



var $f2Y41 = parcelRequire("f2Y41");

function $be6575ec7e0f7372$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(r);
    (0, $f2Y41.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}



function $c7cd72187c2da439$export$71b2224f1ce5e08e(s, m, a = !0) {
    let i = (0, $f2Y41.useRef)(!1);
    (0, $f2Y41.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $4d75beccbbd4c437$export$ff1ec1c740b3c8d5)(t, (0, $4d75beccbbd4c437$export$27112a34f2f8402d).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, $f2Y41.useRef)(null);
    (0, $be6575ec7e0f7372$export$55d2b5df396a097b)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $be6575ec7e0f7372$export$55d2b5df396a097b)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $be6575ec7e0f7372$export$55d2b5df396a097b)("click", (e)=>{
        (0, $b7b61fe673576792$export$d0a8044dce8ff2fc)() || o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, $be6575ec7e0f7372$export$55d2b5df396a097b)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $f183e9735993ff40$export$ee579bb285b8d4aa)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}




var $f2Y41 = parcelRequire("f2Y41");



function $b0f5336b343de017$export$445f2d1a3d9b1b9f({ defaultContainers: o = [], portals: r, mainTreeNodeRef: u } = {}) {
    var f;
    let t = (0, $f2Y41.useRef)((f = u == null ? void 0 : u.current) != null ? f : null), l = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(t), c = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        var i, s, a;
        let n = [];
        for (let e of o)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (r != null && r.current) for (let e of r.current)n.push(e);
        for (let e of (i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some((L)=>e.contains(L)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: c,
        contains: (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((n)=>c().some((i)=>i.contains(n))),
        mainTreeNodeRef: t,
        MainTreeNode: (0, $f2Y41.useMemo)(()=>function() {
                return u != null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
                    features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Hidden,
                    ref: t
                });
            }, [
            t,
            u
        ])
    };
}
function $b0f5336b343de017$export$64db24433d7f4942() {
    let o = (0, $f2Y41.useRef)(null);
    return {
        mainTreeNodeRef: o,
        MainTreeNode: (0, $f2Y41.useMemo)(()=>function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
                    features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Hidden,
                    ref: o
                });
            }, [
            o
        ])
    };
}





var $f2Y41 = parcelRequire("f2Y41");
let $f7ac33105fd0ff19$var$n = (0, $f2Y41.createContext)(null);
$f7ac33105fd0ff19$var$n.displayName = "OpenClosedContext";
var $f7ac33105fd0ff19$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($f7ac33105fd0ff19$export$7254cc27399e90bd || {});
function $f7ac33105fd0ff19$export$fc6fdf0ecf360e() {
    return (0, $f2Y41.useContext)($f7ac33105fd0ff19$var$n);
}
function $f7ac33105fd0ff19$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($f7ac33105fd0ff19$var$n.Provider, {
        value: o
    }, r);
}




var $f2Y41 = parcelRequire("f2Y41");


let $9308ac15ff8766b9$var$a = (0, $f2Y41.createContext)(()=>{});
$9308ac15ff8766b9$var$a.displayName = "StackContext";
var $9308ac15ff8766b9$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($9308ac15ff8766b9$export$2dd25ef07fea092e || {});
function $9308ac15ff8766b9$export$59510f5936c4d8c4() {
    return (0, $f2Y41.useContext)($9308ac15ff8766b9$var$a);
}
function $9308ac15ff8766b9$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $9308ac15ff8766b9$export$59510f5936c4d8c4(), o = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($9308ac15ff8766b9$var$a.Provider, {
        value: o
    }, i);
}


function $d8956e419f398824$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $d8956e419f398824$var$i(l) ? !1 : t;
}
function $d8956e419f398824$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}





var $f2Y41 = parcelRequire("f2Y41");





let $fbcc63276b05bb72$var$d = (0, $f2Y41.createContext)(null);
function $fbcc63276b05bb72$var$f() {
    let r = (0, $f2Y41.useContext)($fbcc63276b05bb72$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $fbcc63276b05bb72$var$f), t;
    }
    return r;
}
function $fbcc63276b05bb72$export$babde88292020af7() {
    let [r, t] = (0, $f2Y41.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $f2Y41.useMemo)(()=>function(e) {
                let i = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, $f2Y41.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($fbcc63276b05bb72$var$d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let $fbcc63276b05bb72$var$I = "p";
function $fbcc63276b05bb72$var$S(r, t) {
    let a = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = $fbcc63276b05bb72$var$f(), s = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(t);
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: $fbcc63276b05bb72$var$I,
        name: n.name || "Description"
    });
}
let $fbcc63276b05bb72$var$h = (0, $43f03f8737506038$export$e43f39796049410c)($fbcc63276b05bb72$var$S), $fbcc63276b05bb72$export$393edc798c47379d = Object.assign($fbcc63276b05bb72$var$h, {});


var $a2773c9bee4148b2$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($a2773c9bee4148b2$export$4b0075e5ea5e1f26 || {});


var $8a2bf535d3f591d5$var$Me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($8a2bf535d3f591d5$var$Me || {}), $8a2bf535d3f591d5$var$we = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($8a2bf535d3f591d5$var$we || {});
let $8a2bf535d3f591d5$var$He = {
    [0] (o, e) {
        return o.titleId === e.id ? o : {
            ...o,
            titleId: e.id
        };
    }
}, $8a2bf535d3f591d5$var$I = (0, $f2Y41.createContext)(null);
$8a2bf535d3f591d5$var$I.displayName = "DialogContext";
function $8a2bf535d3f591d5$var$b(o) {
    let e = (0, $f2Y41.useContext)($8a2bf535d3f591d5$var$I);
    if (e === null) {
        let r = new Error(`<${o} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $8a2bf535d3f591d5$var$b), r;
    }
    return e;
}
function $8a2bf535d3f591d5$var$Be(o, e, r = ()=>[
        document.body
    ]) {
    (0, $f0abf6bdceac87e3$export$bb0ae4a42bcd9e0)(o, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                r
            ]
        };
    });
}
function $8a2bf535d3f591d5$var$Ge(o, e) {
    return (0, $01099572ffa9156b$export$4659b591c19bdf3d)(e.type, $8a2bf535d3f591d5$var$He, o, e);
}
let $8a2bf535d3f591d5$var$Ne = "div", $8a2bf535d3f591d5$var$Ue = (0, $43f03f8737506038$export$617d79dae526d2cf).RenderStrategy | (0, $43f03f8737506038$export$617d79dae526d2cf).Static;
function $8a2bf535d3f591d5$var$We(o, e) {
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-dialog-${r}`, open: n, onClose: l, initialFocus: s, role: a = "dialog", __demoMode: T = !1, ...m } = o, [M, f] = (0, $f2Y41.useState)(0), U = (0, $f2Y41.useRef)(!1);
    a = function() {
        return a === "dialog" || a === "alertdialog" ? a : (U.current || (U.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let E = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)();
    n === void 0 && E !== null && (n = (E & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open);
    let D = (0, $f2Y41.useRef)(null), ee = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(D, e), g = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(D), W = o.hasOwnProperty("open") || E !== null, $ = o.hasOwnProperty("onClose");
    if (!W && !$) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!$) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [h, te] = (0, $f2Y41.useReducer)($8a2bf535d3f591d5$var$Ge, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $f2Y41.createRef)()
    }), P = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>l(!1)), Y = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((t)=>te({
            type: 0,
            id: t
        })), S = (0, $c44f382372d3bfa8$export$44ab2b9f2d09b0fa)() ? T ? !1 : p === 0 : !1, x = M > 1, j = (0, $f2Y41.useContext)($8a2bf535d3f591d5$var$I) !== null, [oe, re] = (0, $af736e5a07684d0e$export$26b8c35244a70b37)(), ne = {
        get current () {
            var t;
            return (t = h.panelRef.current) != null ? t : D.current;
        }
    }, { resolveContainers: w, mainTreeNodeRef: L, MainTreeNode: le } = (0, $b0f5336b343de017$export$445f2d1a3d9b1b9f)({
        portals: oe,
        defaultContainers: [
            ne
        ]
    }), ae = x ? "parent" : "leaf", J = E !== null ? (E & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closing) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closing : !1, ie = (()=>j || J ? !1 : S)(), se = (0, $f2Y41.useCallback)(()=>{
        var t, c;
        return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? t : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, $62d9f7ced91d456a$export$bbe4e2927a3450da)(se, ie);
    let pe = (()=>x ? !0 : S)(), de = (0, $f2Y41.useCallback)(()=>{
        var t, c;
        return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find((d)=>d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, $62d9f7ced91d456a$export$bbe4e2927a3450da)(de, pe);
    let ue = (()=>!(!S || x))();
    (0, $c7cd72187c2da439$export$71b2224f1ce5e08e)(w, (t)=>{
        t.preventDefault(), P();
    }, ue);
    let fe = (()=>!(x || p !== 0))();
    (0, $94bcc444643f252a$export$7080b3e976bc91ab)(g == null ? void 0 : g.defaultView, "keydown", (t)=>{
        fe && (t.defaultPrevented || t.key === (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Escape && (t.preventDefault(), t.stopPropagation(), P()));
    });
    let ge = (()=>!(J || p !== 0 || j))();
    $8a2bf535d3f591d5$var$Be(g, ge, w), (0, $f2Y41.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let t = new ResizeObserver((c)=>{
            for (let d of c){
                let F = d.target.getBoundingClientRect();
                F.x === 0 && F.y === 0 && F.width === 0 && F.height === 0 && P();
            }
        });
        return t.observe(D.current), ()=>t.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [Te, ce] = (0, $fbcc63276b05bb72$export$babde88292020af7)(), De = (0, $f2Y41.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: Y
            },
            h
        ], [
        p,
        h,
        P,
        Y
    ]), X = (0, $f2Y41.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), me = {
        ref: ee,
        id: i,
        role: a,
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": h.titleId,
        "aria-describedby": Te
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $9308ac15ff8766b9$export$4aac1a6640027f56), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((t, c)=>{
            c === "Dialog" && (0, $01099572ffa9156b$export$4659b591c19bdf3d)(t, {
                [(0, $9308ac15ff8766b9$export$2dd25ef07fea092e).Add]: ()=>f((d)=>d + 1),
                [(0, $9308ac15ff8766b9$export$2dd25ef07fea092e).Remove]: ()=>f((d)=>d - 1)
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $37d4074b08e4688f$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $af736e5a07684d0e$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8a2bf535d3f591d5$var$I.Provider, {
        value: De
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $af736e5a07684d0e$export$602eac185826482c).Group, {
        target: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $37d4074b08e4688f$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(ce, {
        slot: X,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $166a3602532ef737$export$34eba2437817a67b), {
        initialFocus: s,
        containers: w,
        features: S ? (0, $01099572ffa9156b$export$4659b591c19bdf3d)(ae, {
            parent: (0, $166a3602532ef737$export$34eba2437817a67b).features.RestoreFocus,
            leaf: (0, $166a3602532ef737$export$34eba2437817a67b).features.All & ~(0, $166a3602532ef737$export$34eba2437817a67b).features.FocusLock
        }) : (0, $166a3602532ef737$export$34eba2437817a67b).features.None
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(re, null, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: me,
        theirProps: m,
        slot: X,
        defaultTag: $8a2bf535d3f591d5$var$Ne,
        features: $8a2bf535d3f591d5$var$Ue,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(le, null));
}
let $8a2bf535d3f591d5$var$$e = "div";
function $8a2bf535d3f591d5$var$Ye(o, e) {
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-dialog-overlay-${r}`, ...n } = o, [{ dialogState: l, close: s }] = $8a2bf535d3f591d5$var$b("Dialog.Overlay"), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(e), T = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((f)=>{
        if (f.target === f.currentTarget) {
            if ((0, $d8956e419f398824$export$db61f031a278447c)(f.currentTarget)) return f.preventDefault();
            f.preventDefault(), f.stopPropagation(), s();
        }
    }), m = (0, $f2Y41.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: $8a2bf535d3f591d5$var$$e,
        name: "Dialog.Overlay"
    });
}
let $8a2bf535d3f591d5$var$je = "div";
function $8a2bf535d3f591d5$var$Je(o, e) {
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-dialog-backdrop-${r}`, ...n } = o, [{ dialogState: l }, s] = $8a2bf535d3f591d5$var$b("Dialog.Backdrop"), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(e);
    (0, $f2Y41.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, $f2Y41.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $37d4074b08e4688f$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $af736e5a07684d0e$export$602eac185826482c), null, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: $8a2bf535d3f591d5$var$je,
        name: "Dialog.Backdrop"
    })));
}
let $8a2bf535d3f591d5$var$Xe = "div";
function $8a2bf535d3f591d5$var$Ke(o, e) {
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-dialog-panel-${r}`, ...n } = o, [{ dialogState: l }, s] = $8a2bf535d3f591d5$var$b("Dialog.Panel"), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(e, s.panelRef), T = (0, $f2Y41.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((f)=>{
        f.stopPropagation();
    });
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: $8a2bf535d3f591d5$var$Xe,
        name: "Dialog.Panel"
    });
}
let $8a2bf535d3f591d5$var$Ve = "h2";
function $8a2bf535d3f591d5$var$qe(o, e) {
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-dialog-title-${r}`, ...n } = o, [{ dialogState: l, setTitleId: s }] = $8a2bf535d3f591d5$var$b("Dialog.Title"), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(e);
    (0, $f2Y41.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, $f2Y41.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: $8a2bf535d3f591d5$var$Ve,
        name: "Dialog.Title"
    });
}
let $8a2bf535d3f591d5$var$ze = (0, $43f03f8737506038$export$e43f39796049410c)($8a2bf535d3f591d5$var$We), $8a2bf535d3f591d5$var$Qe = (0, $43f03f8737506038$export$e43f39796049410c)($8a2bf535d3f591d5$var$Je), $8a2bf535d3f591d5$var$Ze = (0, $43f03f8737506038$export$e43f39796049410c)($8a2bf535d3f591d5$var$Ke), $8a2bf535d3f591d5$var$et = (0, $43f03f8737506038$export$e43f39796049410c)($8a2bf535d3f591d5$var$Ye), $8a2bf535d3f591d5$var$tt = (0, $43f03f8737506038$export$e43f39796049410c)($8a2bf535d3f591d5$var$qe), $8a2bf535d3f591d5$export$3ddf2d174ce01153 = Object.assign($8a2bf535d3f591d5$var$ze, {
    Backdrop: $8a2bf535d3f591d5$var$Qe,
    Panel: $8a2bf535d3f591d5$var$Ze,
    Overlay: $8a2bf535d3f591d5$var$et,
    Title: $8a2bf535d3f591d5$var$tt,
    Description: (0, $fbcc63276b05bb72$export$393edc798c47379d)
});


var $f2Y41 = parcelRequire("f2Y41");



var $f2Y41 = parcelRequire("f2Y41");

function $d7a23c5d4bacb349$export$2879604e6aec4ab(a = 0) {
    let [l, r] = (0, $f2Y41.useState)(a), t = (0, $20a16c989554885c$export$80c2a3957bcb42ea)(), o = (0, $f2Y41.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, $f2Y41.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, $f2Y41.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, $f2Y41.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}









function $9bf4f97e09c855a2$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}


function $0a2a38d628dd855f$var$g(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $0a2a38d628dd855f$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $0a2a38d628dd855f$var$b(t, e) {
    let n = (0, $8b81a70c157af4cc$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: a } = getComputedStyle(t), [u, p] = [
        m,
        a
    ].map((l)=>{
        let [r = 0] = l.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T)=>T - i);
        return r;
    }), o = u + p;
    if (o !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let l = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), l());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $0a2a38d628dd855f$export$66bb15e2994e6a26(t, e, n, m) {
    let a = n ? "enter" : "leave", u = (0, $8b81a70c157af4cc$export$12b26c28a05aa001)(), p = m !== void 0 ? (0, $9bf4f97e09c855a2$export$d2de3aaeafa91619)(m) : ()=>{};
    a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, $01099572ffa9156b$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), l = (0, $01099572ffa9156b$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $01099572ffa9156b$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $0a2a38d628dd855f$var$v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $0a2a38d628dd855f$var$g(t, ...e.base, ...o, ...r), u.nextFrame(()=>{
        $0a2a38d628dd855f$var$v(t, ...e.base, ...o, ...r), $0a2a38d628dd855f$var$g(t, ...e.base, ...o, ...l), $0a2a38d628dd855f$var$b(t, ()=>($0a2a38d628dd855f$var$v(t, ...e.base, ...o), $0a2a38d628dd855f$var$g(t, ...e.base, ...e.entered), p()));
    }), u.dispose;
}







function $7a9acad577370a03$export$7b286972b8d8ccbf({ immediate: t, container: s, direction: n, classes: u, onStart: a, onStop: c }) {
    let l = (0, $20a16c989554885c$export$80c2a3957bcb42ea)(), d = (0, $d649f2b4cbccd3d1$export$fd183955ff4b45d9)(), e = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(n);
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        t && (e.current = "enter");
    }, [
        t
    ]), (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        let r = (0, $8b81a70c157af4cc$export$12b26c28a05aa001)();
        d.add(r.dispose);
        let i = s.current;
        if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add((0, $0a2a38d628dd855f$export$66bb15e2994e6a26)(i, u.current, e.current === "enter", ()=>{
            r.dispose(), c.current(e.current);
        })), r.dispose;
    }, [
        n
    ]);
}






function $39c8d3a34d35014d$var$S(t = "") {
    return t.split(/\s+/).filter((n)=>n.length > 1);
}
let $39c8d3a34d35014d$var$I = (0, $f2Y41.createContext)(null);
$39c8d3a34d35014d$var$I.displayName = "TransitionContext";
var $39c8d3a34d35014d$var$Se = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))($39c8d3a34d35014d$var$Se || {});
function $39c8d3a34d35014d$var$ye() {
    let t = (0, $f2Y41.useContext)($39c8d3a34d35014d$var$I);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function $39c8d3a34d35014d$var$xe() {
    let t = (0, $f2Y41.useContext)($39c8d3a34d35014d$var$M);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let $39c8d3a34d35014d$var$M = (0, $f2Y41.createContext)(null);
$39c8d3a34d35014d$var$M.displayName = "NestingContext";
function $39c8d3a34d35014d$var$U(t) {
    return "children" in t ? $39c8d3a34d35014d$var$U(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function $39c8d3a34d35014d$var$se(t, n) {
    let r = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(t), s = (0, $f2Y41.useRef)([]), R = (0, $20a16c989554885c$export$80c2a3957bcb42ea)(), D = (0, $d649f2b4cbccd3d1$export$fd183955ff4b45d9)(), p = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((i, e = (0, $43f03f8737506038$export$80c0a745e59f7989).Hidden)=>{
        let a = s.current.findIndex(({ el: o })=>o === i);
        a !== -1 && ((0, $01099572ffa9156b$export$4659b591c19bdf3d)(e, {
            [(0, $43f03f8737506038$export$80c0a745e59f7989).Unmount] () {
                s.current.splice(a, 1);
            },
            [(0, $43f03f8737506038$export$80c0a745e59f7989).Hidden] () {
                s.current[a].state = "hidden";
            }
        }), D.microTask(()=>{
            var o;
            !$39c8d3a34d35014d$var$U(s) && R.current && ((o = r.current) == null || o.call(r));
        }));
    }), x = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((i)=>{
        let e = s.current.find(({ el: a })=>a === i);
        return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
            el: i,
            state: "visible"
        }), ()=>p(i, (0, $43f03f8737506038$export$80c0a745e59f7989).Unmount);
    }), h = (0, $f2Y41.useRef)([]), v = (0, $f2Y41.useRef)(Promise.resolve()), u = (0, $f2Y41.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), g = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((i, e, a)=>{
        h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o])=>o !== i)), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                h.current.push(o);
            })
        ]), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                Promise.all(u.current[e].map(([f, N])=>N)).then(()=>o());
            })
        ]), e === "enter" ? v.current = v.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), d = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((i, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = h.current.shift()) == null || o();
        }).then(()=>a(e));
    });
    return (0, $f2Y41.useMemo)(()=>({
            children: s,
            register: x,
            unregister: p,
            onStart: g,
            onStop: d,
            wait: v,
            chains: u
        }), [
        x,
        p,
        s,
        g,
        d,
        u,
        v
    ]);
}
function $39c8d3a34d35014d$var$Ne() {}
let $39c8d3a34d35014d$var$Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $39c8d3a34d35014d$var$ae(t) {
    var r;
    let n = {};
    for (let s of $39c8d3a34d35014d$var$Pe)n[s] = (r = t[s]) != null ? r : $39c8d3a34d35014d$var$Ne;
    return n;
}
function $39c8d3a34d35014d$var$Re(t) {
    let n = (0, $f2Y41.useRef)($39c8d3a34d35014d$var$ae(t));
    return (0, $f2Y41.useEffect)(()=>{
        n.current = $39c8d3a34d35014d$var$ae(t);
    }, [
        t
    ]), n;
}
let $39c8d3a34d35014d$var$De = "div", $39c8d3a34d35014d$var$le = (0, $43f03f8737506038$export$617d79dae526d2cf).RenderStrategy;
function $39c8d3a34d35014d$var$He(t, n) {
    var Q, Y;
    let { beforeEnter: r, afterEnter: s, beforeLeave: R, afterLeave: D, enter: p, enterFrom: x, enterTo: h, entered: v, leave: u, leaveFrom: g, leaveTo: d, ...i } = t, e = (0, $f2Y41.useRef)(null), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(e, n), o = (Q = i.unmount) == null || Q ? (0, $43f03f8737506038$export$80c0a745e59f7989).Unmount : (0, $43f03f8737506038$export$80c0a745e59f7989).Hidden, { show: f, appear: N, initial: T } = $39c8d3a34d35014d$var$ye(), [l, j] = (0, $f2Y41.useState)(f ? "visible" : "hidden"), z = $39c8d3a34d35014d$var$xe(), { register: L, unregister: O } = z;
    (0, $f2Y41.useEffect)(()=>L(e), [
        L,
        e
    ]), (0, $f2Y41.useEffect)(()=>{
        if (o === (0, $43f03f8737506038$export$80c0a745e59f7989).Hidden && e.current) {
            if (f && l !== "visible") {
                j("visible");
                return;
            }
            return (0, $01099572ffa9156b$export$4659b591c19bdf3d)(l, {
                ["hidden"]: ()=>O(e),
                ["visible"]: ()=>L(e)
            });
        }
    }, [
        l,
        e,
        L,
        O,
        f,
        o
    ]);
    let k = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)({
        base: $39c8d3a34d35014d$var$S(i.className),
        enter: $39c8d3a34d35014d$var$S(p),
        enterFrom: $39c8d3a34d35014d$var$S(x),
        enterTo: $39c8d3a34d35014d$var$S(h),
        entered: $39c8d3a34d35014d$var$S(v),
        leave: $39c8d3a34d35014d$var$S(u),
        leaveFrom: $39c8d3a34d35014d$var$S(g),
        leaveTo: $39c8d3a34d35014d$var$S(d)
    }), V = $39c8d3a34d35014d$var$Re({
        beforeEnter: r,
        afterEnter: s,
        beforeLeave: R,
        afterLeave: D
    }), G = (0, $c44f382372d3bfa8$export$44ab2b9f2d09b0fa)();
    (0, $f2Y41.useEffect)(()=>{
        if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        l,
        G
    ]);
    let Te = T && !N, K = N && f && T, de = (()=>!G || Te ? "idle" : f ? "enter" : "leave")(), H = (0, $d7a23c5d4bacb349$export$2879604e6aec4ab)(0), fe = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((C)=>(0, $01099572ffa9156b$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.addFlag((0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Opening), V.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closing), V.current.beforeLeave();
            },
            idle: ()=>{}
        })), me = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((C)=>(0, $01099572ffa9156b$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.removeFlag((0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Opening), V.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closing), V.current.afterLeave();
            },
            idle: ()=>{}
        })), w = $39c8d3a34d35014d$var$se(()=>{
        j("hidden"), O(e);
    }, z), B = (0, $f2Y41.useRef)(!1);
    (0, $7a9acad577370a03$export$7b286972b8d8ccbf)({
        immediate: K,
        container: e,
        classes: k,
        direction: de,
        onStart: (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)((C)=>{
            B.current = !0, w.onStart(e, C, fe);
        }),
        onStop: (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)((C)=>{
            B.current = !1, w.onStop(e, C, me), C === "leave" && !$39c8d3a34d35014d$var$U(w) && (j("hidden"), O(e));
        })
    });
    let P = i, ce = {
        ref: a
    };
    return K ? P = {
        ...P,
        className: (0, $654761d306a09dd0$export$ce4ab0c55987d1ff)(i.className, ...k.current.enter, ...k.current.enterFrom)
    } : B.current && (P.className = (0, $654761d306a09dd0$export$ce4ab0c55987d1ff)(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($39c8d3a34d35014d$var$M.Provider, {
        value: w
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $f7ac33105fd0ff19$export$2a0ed818b175f558), {
        value: (0, $01099572ffa9156b$export$4659b591c19bdf3d)(l, {
            ["visible"]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closed
        }) | H.flags
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: ce,
        theirProps: P,
        defaultTag: $39c8d3a34d35014d$var$De,
        features: $39c8d3a34d35014d$var$le,
        visible: l === "visible",
        name: "Transition.Child"
    })));
}
function $39c8d3a34d35014d$var$Fe(t, n) {
    let { show: r, appear: s = !1, unmount: R = !0, ...D } = t, p = (0, $f2Y41.useRef)(null), x = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(p, n);
    (0, $c44f382372d3bfa8$export$44ab2b9f2d09b0fa)();
    let h = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)();
    if (r === void 0 && h !== null && (r = (h & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [v, u] = (0, $f2Y41.useState)(r ? "visible" : "hidden"), g = $39c8d3a34d35014d$var$se(()=>{
        u("hidden");
    }), [d, i] = (0, $f2Y41.useState)(!0), e = (0, $f2Y41.useRef)([
        r
    ]);
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
    }, [
        e,
        r
    ]);
    let a = (0, $f2Y41.useMemo)(()=>({
            show: r,
            appear: s,
            initial: d
        }), [
        r,
        s,
        d
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (r) u("visible");
        else if (!$39c8d3a34d35014d$var$U(g)) u("hidden");
        else {
            let T = p.current;
            if (!T) return;
            let l = T.getBoundingClientRect();
            l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
        }
    }, [
        r,
        g
    ]);
    let o = {
        unmount: R
    }, f = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }), N = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($39c8d3a34d35014d$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($39c8d3a34d35014d$var$I.Provider, {
        value: a
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ...o,
            as: (0, $f2Y41.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($39c8d3a34d35014d$var$ue, {
                ref: x,
                ...o,
                ...D,
                beforeEnter: f,
                beforeLeave: N
            })
        },
        theirProps: {},
        defaultTag: (0, $f2Y41.Fragment),
        features: $39c8d3a34d35014d$var$le,
        visible: v === "visible",
        name: "Transition"
    })));
}
function $39c8d3a34d35014d$var$_e(t, n) {
    let r = (0, $f2Y41.useContext)($39c8d3a34d35014d$var$I) !== null, s = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, !r && s ? (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($39c8d3a34d35014d$var$q, {
        ref: n,
        ...t
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($39c8d3a34d35014d$var$ue, {
        ref: n,
        ...t
    }));
}
let $39c8d3a34d35014d$var$q = (0, $43f03f8737506038$export$e43f39796049410c)($39c8d3a34d35014d$var$Fe), $39c8d3a34d35014d$var$ue = (0, $43f03f8737506038$export$e43f39796049410c)($39c8d3a34d35014d$var$He), $39c8d3a34d35014d$var$Le = (0, $43f03f8737506038$export$e43f39796049410c)($39c8d3a34d35014d$var$_e), $39c8d3a34d35014d$export$be58926105124dd4 = Object.assign($39c8d3a34d35014d$var$q, {
    Child: $39c8d3a34d35014d$var$Le,
    Root: $39c8d3a34d35014d$var$q
});





var $f2Y41 = parcelRequire("f2Y41");

// import "./styles.scss"

var $ge3KO = parcelRequire("ge3KO");
// state/index.ts
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $8861d614279eac2f$var$OrderedMap(content) {
    this.content = content;
}
$8861d614279eac2f$var$OrderedMap.prototype = {
    constructor: $8861d614279eac2f$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $8861d614279eac2f$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $8861d614279eac2f$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $8861d614279eac2f$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $8861d614279eac2f$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $8861d614279eac2f$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $8861d614279eac2f$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8861d614279eac2f$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $8861d614279eac2f$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8861d614279eac2f$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $8861d614279eac2f$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$8861d614279eac2f$var$OrderedMap.from = function(value) {
    if (value instanceof $8861d614279eac2f$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $8861d614279eac2f$var$OrderedMap(content);
};
var $8861d614279eac2f$export$2e2bcd8739ae039 = $8861d614279eac2f$var$OrderedMap;


function $d3a8f56ade4880df$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $d3a8f56ade4880df$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $d3a8f56ade4880df$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $d3a8f56ade4880df$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $d3a8f56ade4880df$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $d3a8f56ade4880df$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $d3a8f56ade4880df$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $d3a8f56ade4880df$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $d3a8f56ade4880df$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. (Not public.)
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $d3a8f56ade4880df$var$retIndex(0, pos);
        if (pos == this.size) return $d3a8f56ade4880df$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $d3a8f56ade4880df$var$retIndex(i + 1, end);
                return $d3a8f56ade4880df$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $d3a8f56ade4880df$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $d3a8f56ade4880df$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $d3a8f56ade4880df$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $d3a8f56ade4880df$export$ffb0004e005737fa.empty;
        if (nodes instanceof $d3a8f56ade4880df$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $d3a8f56ade4880df$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $d3a8f56ade4880df$export$ffb0004e005737fa.empty = new $d3a8f56ade4880df$export$ffb0004e005737fa([], 0);
const $d3a8f56ade4880df$var$found = {
    index: 0,
    offset: 0
};
function $d3a8f56ade4880df$var$retIndex(index, offset) {
    $d3a8f56ade4880df$var$found.index = index;
    $d3a8f56ade4880df$var$found.offset = offset;
    return $d3a8f56ade4880df$var$found;
}
function $d3a8f56ade4880df$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$d3a8f56ade4880df$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$d3a8f56ade4880df$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $d3a8f56ade4880df$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $d3a8f56ade4880df$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        return type.create(json.attrs);
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $d3a8f56ade4880df$export$c9d15bcfc6d42044.none;
        if (marks instanceof $d3a8f56ade4880df$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $d3a8f56ade4880df$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $d3a8f56ade4880df$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $d3a8f56ade4880df$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $d3a8f56ade4880df$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $d3a8f56ade4880df$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $d3a8f56ade4880df$export$b3f2e2de3a8baa1e($d3a8f56ade4880df$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $d3a8f56ade4880df$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $d3a8f56ade4880df$export$b3f2e2de3a8baa1e($d3a8f56ade4880df$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $d3a8f56ade4880df$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $d3a8f56ade4880df$export$b3f2e2de3a8baa1e.empty = new $d3a8f56ade4880df$export$b3f2e2de3a8baa1e($d3a8f56ade4880df$export$ffb0004e005737fa.empty, 0, 0);
function $d3a8f56ade4880df$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($d3a8f56ade4880df$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $d3a8f56ade4880df$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $d3a8f56ade4880df$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $d3a8f56ade4880df$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $d3a8f56ade4880df$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $d3a8f56ade4880df$export$6de0e778727af3f2("Inconsistent open depths");
    return $d3a8f56ade4880df$var$replaceOuter($from, $to, slice, 0);
}
function $d3a8f56ade4880df$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $d3a8f56ade4880df$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $d3a8f56ade4880df$var$close(node, $d3a8f56ade4880df$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $d3a8f56ade4880df$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $d3a8f56ade4880df$var$prepareSliceForReplace(slice, $from);
        return $d3a8f56ade4880df$var$close(node, $d3a8f56ade4880df$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $d3a8f56ade4880df$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $d3a8f56ade4880df$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $d3a8f56ade4880df$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $d3a8f56ade4880df$var$checkJoin(node, $after.node(depth));
    return node;
}
function $d3a8f56ade4880df$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $d3a8f56ade4880df$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $d3a8f56ade4880df$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$d3a8f56ade4880df$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $d3a8f56ade4880df$var$addNode($end.nodeBefore, target);
}
function $d3a8f56ade4880df$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $d3a8f56ade4880df$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $d3a8f56ade4880df$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $d3a8f56ade4880df$var$joinable($end, $to, depth + 1);
    let content = [];
    $d3a8f56ade4880df$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $d3a8f56ade4880df$var$checkJoin(openStart, openEnd);
        $d3a8f56ade4880df$var$addNode($d3a8f56ade4880df$var$close(openStart, $d3a8f56ade4880df$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $d3a8f56ade4880df$var$addNode($d3a8f56ade4880df$var$close(openStart, $d3a8f56ade4880df$var$replaceTwoWay($from, $start, depth + 1)), content);
        $d3a8f56ade4880df$var$addRange($start, $end, depth, content);
        if (openEnd) $d3a8f56ade4880df$var$addNode($d3a8f56ade4880df$var$close(openEnd, $d3a8f56ade4880df$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $d3a8f56ade4880df$var$addRange($to, null, depth, content);
    return new $d3a8f56ade4880df$export$ffb0004e005737fa(content);
}
function $d3a8f56ade4880df$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $d3a8f56ade4880df$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $d3a8f56ade4880df$var$joinable($from, $to, depth + 1);
        $d3a8f56ade4880df$var$addNode($d3a8f56ade4880df$var$close(type, $d3a8f56ade4880df$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $d3a8f56ade4880df$var$addRange($to, null, depth, content);
    return new $d3a8f56ade4880df$export$ffb0004e005737fa(content);
}
function $d3a8f56ade4880df$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($d3a8f56ade4880df$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $d3a8f56ade4880df$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $d3a8f56ade4880df$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $d3a8f56ade4880df$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $d3a8f56ade4880df$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        for(let i = 0; i < $d3a8f56ade4880df$var$resolveCache.length; i++){
            let cached = $d3a8f56ade4880df$var$resolveCache[i];
            if (cached.pos == pos && cached.doc == doc) return cached;
        }
        let result = $d3a8f56ade4880df$var$resolveCache[$d3a8f56ade4880df$var$resolveCachePos] = $d3a8f56ade4880df$export$b2a42f82e59e4b19.resolve(doc, pos);
        $d3a8f56ade4880df$var$resolveCachePos = ($d3a8f56ade4880df$var$resolveCachePos + 1) % $d3a8f56ade4880df$var$resolveCacheSize;
        return result;
    }
}
let $d3a8f56ade4880df$var$resolveCache = [], $d3a8f56ade4880df$var$resolveCachePos = 0, $d3a8f56ade4880df$var$resolveCacheSize = 12;
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $d3a8f56ade4880df$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $d3a8f56ade4880df$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $d3a8f56ade4880df$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $d3a8f56ade4880df$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $d3a8f56ade4880df$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $d3a8f56ade4880df$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $d3a8f56ade4880df$var$emptyAttrs) && $d3a8f56ade4880df$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $d3a8f56ade4880df$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $d3a8f56ade4880df$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $d3a8f56ade4880df$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $d3a8f56ade4880df$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $d3a8f56ade4880df$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $d3a8f56ade4880df$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $d3a8f56ade4880df$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $d3a8f56ade4880df$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $d3a8f56ade4880df$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $d3a8f56ade4880df$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise error when they do not.
    */ check() {
        this.type.checkContent(this.content);
        let copy = $d3a8f56ade4880df$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++)copy = this.marks[i].addToSet(copy);
        if (!$d3a8f56ade4880df$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = null;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $d3a8f56ade4880df$export$ffb0004e005737fa.fromJSON(schema, json.content);
        return schema.nodeType(json.type).create(json.attrs, content, marks);
    }
}
$d3a8f56ade4880df$export$85c928794f8d04d4.prototype.text = undefined;
class $d3a8f56ade4880df$var$TextNode extends $d3a8f56ade4880df$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $d3a8f56ade4880df$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $d3a8f56ade4880df$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $d3a8f56ade4880df$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $d3a8f56ade4880df$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $d3a8f56ade4880df$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $d3a8f56ade4880df$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $d3a8f56ade4880df$export$364ed450558d7ec4.empty;
        let expr = $d3a8f56ade4880df$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $d3a8f56ade4880df$var$dfa($d3a8f56ade4880df$var$nfa(expr));
        $d3a8f56ade4880df$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $d3a8f56ade4880df$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $d3a8f56ade4880df$export$364ed450558d7ec4.empty = new $d3a8f56ade4880df$export$364ed450558d7ec4(true);
class $d3a8f56ade4880df$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $d3a8f56ade4880df$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($d3a8f56ade4880df$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $d3a8f56ade4880df$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($d3a8f56ade4880df$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $d3a8f56ade4880df$var$parseExprSubscript(stream) {
    let expr = $d3a8f56ade4880df$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $d3a8f56ade4880df$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $d3a8f56ade4880df$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $d3a8f56ade4880df$var$parseExprRange(stream, expr) {
    let min = $d3a8f56ade4880df$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $d3a8f56ade4880df$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $d3a8f56ade4880df$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $d3a8f56ade4880df$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $d3a8f56ade4880df$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $d3a8f56ade4880df$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $d3a8f56ade4880df$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $d3a8f56ade4880df$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $d3a8f56ade4880df$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($d3a8f56ade4880df$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $d3a8f56ade4880df$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($d3a8f56ade4880df$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $d3a8f56ade4880df$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $d3a8f56ade4880df$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($d3a8f56ade4880df$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $d3a8f56ade4880df$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $d3a8f56ade4880df$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $d3a8f56ade4880df$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $d3a8f56ade4880df$var$initAttrs(attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $d3a8f56ade4880df$var$Attribute(attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $d3a8f56ade4880df$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $d3a8f56ade4880df$var$initAttrs(spec.attrs);
        this.defaultAttrs = $d3a8f56ade4880df$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $d3a8f56ade4880df$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $d3a8f56ade4880df$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $d3a8f56ade4880df$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $d3a8f56ade4880df$export$ffb0004e005737fa.from(content), $d3a8f56ade4880df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $d3a8f56ade4880df$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $d3a8f56ade4880df$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $d3a8f56ade4880df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $d3a8f56ade4880df$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($d3a8f56ade4880df$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $d3a8f56ade4880df$export$85c928794f8d04d4(this, attrs, content.append(after), $d3a8f56ade4880df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $d3a8f56ade4880df$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $d3a8f56ade4880df$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
// Attribute descriptors
class $d3a8f56ade4880df$var$Attribute {
    constructor(options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $d3a8f56ade4880df$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $d3a8f56ade4880df$var$initAttrs(spec.attrs);
        this.excluded = null;
        let defaults = $d3a8f56ade4880df$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $d3a8f56ade4880df$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $d3a8f56ade4880df$export$c9d15bcfc6d42044(this, $d3a8f56ade4880df$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $d3a8f56ade4880df$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $d3a8f56ade4880df$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $8861d614279eac2f$export$2e2bcd8739ae039).from(spec.nodes), instanceSpec.marks = (0, $8861d614279eac2f$export$2e2bcd8739ae039).from(spec.marks || {}), this.nodes = $d3a8f56ade4880df$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $d3a8f56ade4880df$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $d3a8f56ade4880df$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $d3a8f56ade4880df$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $d3a8f56ade4880df$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $d3a8f56ade4880df$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $d3a8f56ade4880df$var$TextNode(type, type.defaultAttrs, text, $d3a8f56ade4880df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $d3a8f56ade4880df$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $d3a8f56ade4880df$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $d3a8f56ade4880df$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $d3a8f56ade4880df$var$isTagRule(rule) {
    return rule.tag != null;
}
function $d3a8f56ade4880df$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $d3a8f56ade4880df$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        rules.forEach((rule)=>{
            if ($d3a8f56ade4880df$var$isTagRule(rule)) this.tags.push(rule);
            else if ($d3a8f56ade4880df$var$isStyleRule(rule)) this.styles.push(rule);
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $d3a8f56ade4880df$var$ParseContext(this, options, false);
        context.addAll(dom, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $d3a8f56ade4880df$var$ParseContext(this, options, true);
        context.addAll(dom, options.from, options.to);
        return $d3a8f56ade4880df$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($d3a8f56ade4880df$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $d3a8f56ade4880df$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $d3a8f56ade4880df$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $d3a8f56ade4880df$export$1059c6e7d2ce5669(schema, $d3a8f56ade4880df$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $d3a8f56ade4880df$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $d3a8f56ade4880df$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $d3a8f56ade4880df$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $d3a8f56ade4880df$var$OPT_PRESERVE_WS = 1, $d3a8f56ade4880df$var$OPT_PRESERVE_WS_FULL = 2, $d3a8f56ade4880df$var$OPT_OPEN_LEFT = 4;
function $d3a8f56ade4880df$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $d3a8f56ade4880df$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $d3a8f56ade4880df$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $d3a8f56ade4880df$var$OPT_PRESERVE_WS | $d3a8f56ade4880df$var$OPT_PRESERVE_WS_FULL : base & ~$d3a8f56ade4880df$var$OPT_OPEN_LEFT;
}
class $d3a8f56ade4880df$var$NodeContext {
    constructor(type, attrs, // Marks applied to this node itself
    marks, // Marks that can't apply here, but will be used in children if possible
    pendingMarks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.pendingMarks = pendingMarks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $d3a8f56ade4880df$export$c9d15bcfc6d42044.none;
        // Nested Marks with same type
        this.stashMarks = [];
        this.match = match || (options & $d3a8f56ade4880df$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($d3a8f56ade4880df$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $d3a8f56ade4880df$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $d3a8f56ade4880df$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($d3a8f56ade4880df$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    popFromStashMark(mark) {
        for(let i = this.stashMarks.length - 1; i >= 0; i--)if (mark.eq(this.stashMarks[i])) return this.stashMarks.splice(i, 1)[0];
    }
    applyPending(nextType) {
        for(let i = 0, pending = this.pendingMarks; i < pending.length; i++){
            let mark = pending[i];
            if ((this.type ? this.type.allowsMarkType(mark.type) : $d3a8f56ade4880df$var$markMayApply(mark.type, nextType)) && !mark.isInSet(this.activeMarks)) {
                this.activeMarks = mark.addToSet(this.activeMarks);
                this.pendingMarks = mark.removeFromSet(this.pendingMarks);
            }
        }
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$d3a8f56ade4880df$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $d3a8f56ade4880df$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $d3a8f56ade4880df$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $d3a8f56ade4880df$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $d3a8f56ade4880df$var$NodeContext(topNode.type, topNode.attrs, $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $d3a8f56ade4880df$var$NodeContext(null, null, $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $d3a8f56ade4880df$var$NodeContext(parser.schema.topNodeType, null, $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom) {
        if (dom.nodeType == 3) this.addTextNode(dom);
        else if (dom.nodeType == 1) this.addElement(dom);
    }
    withStyleRules(dom, f) {
        let style = dom.style;
        if (!style || !style.length) return f();
        let marks = this.readStyles(dom.style);
        if (!marks) return; // A style with ignore: true
        let [addMarks, removeMarks] = marks, top = this.top;
        for(let i = 0; i < removeMarks.length; i++)this.removePendingMark(removeMarks[i], top);
        for(let i = 0; i < addMarks.length; i++)this.addPendingMark(addMarks[i]);
        f();
        for(let i = 0; i < addMarks.length; i++)this.removePendingMark(addMarks[i], top);
        for(let i = 0; i < removeMarks.length; i++)this.addPendingMark(removeMarks[i]);
    }
    addTextNode(dom) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $d3a8f56ade4880df$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $d3a8f56ade4880df$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $d3a8f56ade4880df$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($d3a8f56ade4880df$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $d3a8f56ade4880df$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $d3a8f56ade4880df$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($d3a8f56ade4880df$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom);
                return;
            }
            if (rule && rule.skip) this.addAll(dom);
            else this.withStyleRules(dom, ()=>this.addAll(dom));
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else this.withStyleRules(dom, ()=>{
            this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : undefined);
        });
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"));
    }
    // Called for ignored nodes
    ignoreFallback(dom) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"));
    }
    // Run any style parser associated with the node's styles. Either
    // return an array of marks, or null to indicate some of the styles
    // had a rule with `ignore` set.
    readStyles(styles) {
        let add = $d3a8f56ade4880df$export$c9d15bcfc6d42044.none, remove = $d3a8f56ade4880df$export$c9d15bcfc6d42044.none;
        for(let i = 0, l = styles.length; i < l; i++){
            let name = styles.item(i);
            for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, styles.getPropertyValue(name), this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) this.top.pendingMarks.concat(this.top.activeMarks).forEach((m)=>{
                    if (rule.clearMark(m)) remove = m.addToSet(remove);
                });
                else add = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(add);
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return [
            add,
            remove
        ];
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, continueAfter) {
        let sync, nodeType, mark;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) sync = this.enter(nodeType, rule.attrs || null, rule.preserveWhitespace);
            else if (!this.insertNode(nodeType.create(rule.attrs))) this.leafFallback(dom);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            mark = markType.create(rule.attrs);
            this.addPendingMark(mark);
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM);
        }
        if (sync && this.sync(startIn)) this.open--;
        if (mark) this.removePendingMark(mark, startIn);
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return false;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)this.enterInner(route[i], null, false);
        return true;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) this.enterInner(block);
        }
        if (this.findPlace(node)) {
            this.closeExtra();
            let top = this.top;
            top.applyPending(node.type);
            if (top.match) top.match = top.match.matchType(node.type);
            let marks = top.activeMarks;
            for(let i = 0; i < node.marks.length; i++)if (!top.type || top.type.allowsMarkType(node.marks[i].type)) marks = node.marks[i].addToSet(marks);
            top.content.push(node.mark(marks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, preserveWS) {
        let ok = this.findPlace(type.create(attrs));
        if (ok) this.enterInner(type, attrs, true, preserveWS);
        return ok;
    }
    // Open a node of the given type
    enterInner(type, attrs = null, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.applyPending(type);
        top.match = top.match && top.match.matchType(type);
        let options = $d3a8f56ade4880df$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $d3a8f56ade4880df$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $d3a8f56ade4880df$var$OPT_OPEN_LEFT;
        this.nodes.push(new $d3a8f56ade4880df$var$NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
        this.open++;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    addPendingMark(mark) {
        let found = $d3a8f56ade4880df$var$findSameMarkInSet(mark, this.top.pendingMarks);
        if (found) this.top.stashMarks.push(found);
        this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
    }
    removePendingMark(mark, upto) {
        for(let depth = this.open; depth >= 0; depth--){
            let level = this.nodes[depth];
            let found = level.pendingMarks.lastIndexOf(mark);
            if (found > -1) level.pendingMarks = mark.removeFromSet(level.pendingMarks);
            else {
                level.activeMarks = mark.removeFromSet(level.activeMarks);
                let stashMark = level.popFromStashMark(mark);
                if (stashMark && level.type && level.type.allowsMarkType(stashMark.type)) level.activeMarks = stashMark.addToSet(level.activeMarks);
            }
            if (level == upto) break;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $d3a8f56ade4880df$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $d3a8f56ade4880df$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $d3a8f56ade4880df$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $d3a8f56ade4880df$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $d3a8f56ade4880df$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
function $d3a8f56ade4880df$var$findSameMarkInSet(mark, set) {
    for(let i = 0; i < set.length; i++){
        if (mark.eq(set[i])) return set[i];
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $d3a8f56ade4880df$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $d3a8f56ade4880df$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $d3a8f56ade4880df$export$3476b78f8f5a8b72.renderSpec($d3a8f56ade4880df$var$doc(options), this.nodes[node.type.name](node));
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $d3a8f56ade4880df$export$3476b78f8f5a8b72.renderSpec($d3a8f56ade4880df$var$doc(options), toDOM(mark, inline));
    }
    /**
    Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
    the spec has a hole (zero) in it, `contentDOM` will point at the
    node with the hole.
    */ static renderSpec(doc, structure, xmlNS = null) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $d3a8f56ade4880df$export$3476b78f8f5a8b72.renderSpec(doc, child, xmlNS);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $d3a8f56ade4880df$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $d3a8f56ade4880df$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $d3a8f56ade4880df$var$gatherToDOM(schema.marks);
    }
}
function $d3a8f56ade4880df$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $d3a8f56ade4880df$var$doc(options) {
    return options.document || window.document;
}



// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $82f7355673365313$var$lower16 = 0xffff;
const $82f7355673365313$var$factor16 = Math.pow(2, 16);
function $82f7355673365313$var$makeRecover(index, offset) {
    return index + offset * $82f7355673365313$var$factor16;
}
function $82f7355673365313$var$recoverIndex(value) {
    return value & $82f7355673365313$var$lower16;
}
function $82f7355673365313$var$recoverOffset(value) {
    return (value - (value & $82f7355673365313$var$lower16)) / $82f7355673365313$var$factor16;
}
const $82f7355673365313$var$DEL_BEFORE = 1, $82f7355673365313$var$DEL_AFTER = 2, $82f7355673365313$var$DEL_ACROSS = 4, $82f7355673365313$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $82f7355673365313$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $82f7355673365313$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($82f7355673365313$var$DEL_BEFORE | $82f7355673365313$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($82f7355673365313$var$DEL_AFTER | $82f7355673365313$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $82f7355673365313$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $82f7355673365313$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $82f7355673365313$export$c53d01c3ab9721b3.empty) return $82f7355673365313$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $82f7355673365313$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $82f7355673365313$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $82f7355673365313$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $82f7355673365313$var$DEL_AFTER : pos == end ? $82f7355673365313$var$DEL_BEFORE : $82f7355673365313$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $82f7355673365313$var$DEL_SIDE;
                return new $82f7355673365313$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $82f7355673365313$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $82f7355673365313$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $82f7355673365313$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $82f7355673365313$export$c53d01c3ab9721b3.empty : new $82f7355673365313$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $82f7355673365313$export$c53d01c3ab9721b3.empty = new $82f7355673365313$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $82f7355673365313$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $82f7355673365313$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $82f7355673365313$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $82f7355673365313$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $82f7355673365313$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $82f7355673365313$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $82f7355673365313$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $82f7355673365313$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $82f7355673365313$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $82f7355673365313$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $82f7355673365313$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $82f7355673365313$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $82f7355673365313$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $82f7355673365313$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $82f7355673365313$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $d3a8f56ade4880df$export$6de0e778727af3f2)) return $82f7355673365313$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $82f7355673365313$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($82f7355673365313$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $d3a8f56ade4880df$export$ffb0004e005737fa).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $82f7355673365313$export$d24ba56b0e3464a9 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $82f7355673365313$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $82f7355673365313$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $82f7355673365313$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $82f7355673365313$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $82f7355673365313$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("addMark", $82f7355673365313$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $82f7355673365313$export$94150db1311f67a9 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $82f7355673365313$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $82f7355673365313$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $82f7355673365313$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $82f7355673365313$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $82f7355673365313$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("removeMark", $82f7355673365313$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $82f7355673365313$export$adefd16c402fee4e extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $82f7355673365313$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $82f7355673365313$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $82f7355673365313$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $82f7355673365313$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $82f7355673365313$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $82f7355673365313$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("addNodeMark", $82f7355673365313$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $82f7355673365313$export$fdf7d1dc10724da2 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $82f7355673365313$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $82f7355673365313$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $82f7355673365313$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $82f7355673365313$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("removeNodeMark", $82f7355673365313$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $82f7355673365313$export$5c860b2e74034756 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $82f7355673365313$var$contentBetween(doc, this.from, this.to)) return $82f7355673365313$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $82f7355673365313$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $82f7355673365313$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $82f7355673365313$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $82f7355673365313$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty : new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $82f7355673365313$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty : new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $82f7355673365313$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $82f7355673365313$export$5c860b2e74034756(json.from, json.to, (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).fromJSON(schema, json.slice), !!json.structure);
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("replace", $82f7355673365313$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $82f7355673365313$export$444ba800d6024a98 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($82f7355673365313$var$contentBetween(doc, this.from, this.gapFrom) || $82f7355673365313$var$contentBetween(doc, this.gapTo, this.to))) return $82f7355673365313$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $82f7355673365313$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $82f7355673365313$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $82f7355673365313$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $82f7355673365313$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $82f7355673365313$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $82f7355673365313$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("replaceAround", $82f7355673365313$export$444ba800d6024a98);
function $82f7355673365313$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $82f7355673365313$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $82f7355673365313$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $82f7355673365313$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $82f7355673365313$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $d3a8f56ade4880df$export$b6a78689043c6521)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $82f7355673365313$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $82f7355673365313$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $82f7355673365313$export$5c860b2e74034756(cur, end, (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $82f7355673365313$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $82f7355673365313$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, true);
        tr.replace(cur, cur, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $82f7355673365313$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $82f7355673365313$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$82f7355673365313$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $82f7355673365313$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $82f7355673365313$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $82f7355673365313$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $82f7355673365313$var$findWrappingOutside(range, nodeType);
    let inner = around && $82f7355673365313$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($82f7355673365313$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($82f7355673365313$var$withAttrs));
}
function $82f7355673365313$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $82f7355673365313$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $82f7355673365313$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $82f7355673365313$var$wrap(tr, range, wrappers) {
    let content = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $82f7355673365313$export$444ba800d6024a98(start, end, start, end, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(content, 0, 0), wrappers.length, true));
}
function $82f7355673365313$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isTextblock && !node.hasMarkup(type, attrs) && $82f7355673365313$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $82f7355673365313$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $82f7355673365313$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $82f7355673365313$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $82f7355673365313$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $82f7355673365313$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $82f7355673365313$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $82f7355673365313$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $82f7355673365313$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $82f7355673365313$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $82f7355673365313$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $82f7355673365313$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, after = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $82f7355673365313$export$5c860b2e74034756(pos, pos, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $82f7355673365313$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $82f7355673365313$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $82f7355673365313$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && a.canAppend(b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $82f7355673365313$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $82f7355673365313$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $82f7355673365313$var$join(tr, pos, depth) {
    let step = new $82f7355673365313$export$5c860b2e74034756(pos - depth, pos + depth, (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty, true);
    tr.step(step);
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $82f7355673365313$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $82f7355673365313$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $82f7355673365313$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($82f7355673365313$var$fitsTrivially($from, $to, slice)) return new $82f7355673365313$export$5c860b2e74034756(from, to, slice);
    return new $82f7355673365313$var$Fitter($from, $to, slice).fit();
}
function $82f7355673365313$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $82f7355673365313$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(content, openStart, openEnd);
        if (moveInline > -1) return new $82f7355673365313$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $82f7355673365313$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $82f7355673365313$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $82f7355673365313$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $82f7355673365313$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($82f7355673365313$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $82f7355673365313$var$addToFragment(this.placed, frontierDepth, (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty : new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$82f7355673365313$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $82f7355673365313$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $82f7355673365313$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $82f7355673365313$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $82f7355673365313$var$addToFragment(this.placed, this.depth, (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, true);
        if (add.childCount) this.placed = $82f7355673365313$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $82f7355673365313$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($82f7355673365313$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $82f7355673365313$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($82f7355673365313$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $82f7355673365313$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $82f7355673365313$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $82f7355673365313$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, true));
    }
    return node.copy(frag);
}
function $82f7355673365313$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$82f7355673365313$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $82f7355673365313$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $82f7355673365313$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $82f7355673365313$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($82f7355673365313$var$fitsTrivially($from, $to, slice)) return tr.step(new $82f7355673365313$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $82f7355673365313$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $82f7355673365313$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($82f7355673365313$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $82f7355673365313$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($82f7355673365313$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, true));
    }
    return fragment;
}
function $82f7355673365313$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $82f7355673365313$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(node), 0, 0));
}
function $82f7355673365313$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $82f7355673365313$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $82f7355673365313$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $82f7355673365313$export$626399c38172f669 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $82f7355673365313$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $82f7355673365313$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $82f7355673365313$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $82f7355673365313$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $82f7355673365313$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $82f7355673365313$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("attr", $82f7355673365313$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $82f7355673365313$export$f50707b396300ac9 extends $82f7355673365313$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $82f7355673365313$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $82f7355673365313$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $82f7355673365313$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $82f7355673365313$export$f50707b396300ac9(json.attr, json.value);
    }
}
$82f7355673365313$export$fd55ce593607084a.jsonID("docAttr", $82f7355673365313$export$f50707b396300ac9);
/**
@internal
*/ let $82f7355673365313$export$88cc3a1dfce48dd3 = class extends Error {
};
$82f7355673365313$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$82f7355673365313$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$82f7355673365313$export$88cc3a1dfce48dd3.prototype.constructor = $82f7355673365313$export$88cc3a1dfce48dd3;
$82f7355673365313$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $82f7355673365313$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $82f7355673365313$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $82f7355673365313$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
        let step = $82f7355673365313$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $82f7355673365313$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $82f7355673365313$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $82f7355673365313$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $82f7355673365313$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $82f7355673365313$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $82f7355673365313$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $82f7355673365313$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $82f7355673365313$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $82f7355673365313$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $82f7355673365313$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $82f7355673365313$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $d3a8f56ade4880df$export$c9d15bcfc6d42044))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $82f7355673365313$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $82f7355673365313$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $82f7355673365313$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $82f7355673365313$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $82f7355673365313$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}


const $a24eacb5c8b3ccab$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $a24eacb5c8b3ccab$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $a24eacb5c8b3ccab$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty : content);
            if (i == 0) $a24eacb5c8b3ccab$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $a24eacb5c8b3ccab$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $a24eacb5c8b3ccab$export$c2b25f346d19bcbb($pos) : $a24eacb5c8b3ccab$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $a24eacb5c8b3ccab$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $a24eacb5c8b3ccab$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $a24eacb5c8b3ccab$var$findSelectionIn(doc, doc, 0, 0, 1) || new $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $a24eacb5c8b3ccab$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $a24eacb5c8b3ccab$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $a24eacb5c8b3ccab$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $a24eacb5c8b3ccab$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $a24eacb5c8b3ccab$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$a24eacb5c8b3ccab$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $a24eacb5c8b3ccab$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $a24eacb5c8b3ccab$var$warnedAboutTextSelection = false;
function $a24eacb5c8b3ccab$var$checkTextSelection($pos) {
    if (!$a24eacb5c8b3ccab$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $a24eacb5c8b3ccab$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $a24eacb5c8b3ccab$export$c2b25f346d19bcbb extends $a24eacb5c8b3ccab$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $a24eacb5c8b3ccab$var$checkTextSelection($anchor);
        $a24eacb5c8b3ccab$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $a24eacb5c8b3ccab$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $a24eacb5c8b3ccab$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
        super.replace(tr, content);
        if (content == (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $a24eacb5c8b3ccab$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $a24eacb5c8b3ccab$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $a24eacb5c8b3ccab$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $a24eacb5c8b3ccab$export$52baac22726c72bf.findFrom($head, bias, true) || $a24eacb5c8b3ccab$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $a24eacb5c8b3ccab$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($a24eacb5c8b3ccab$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $a24eacb5c8b3ccab$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $a24eacb5c8b3ccab$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$a24eacb5c8b3ccab$export$52baac22726c72bf.jsonID("text", $a24eacb5c8b3ccab$export$c2b25f346d19bcbb);
class $a24eacb5c8b3ccab$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $a24eacb5c8b3ccab$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $a24eacb5c8b3ccab$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $a24eacb5c8b3ccab$export$e2940151ac854c0b extends $a24eacb5c8b3ccab$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $a24eacb5c8b3ccab$export$52baac22726c72bf.near($pos);
        return new $a24eacb5c8b3ccab$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $a24eacb5c8b3ccab$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $a24eacb5c8b3ccab$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $a24eacb5c8b3ccab$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $a24eacb5c8b3ccab$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$a24eacb5c8b3ccab$export$e2940151ac854c0b.prototype.visible = false;
$a24eacb5c8b3ccab$export$52baac22726c72bf.jsonID("node", $a24eacb5c8b3ccab$export$e2940151ac854c0b);
class $a24eacb5c8b3ccab$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $a24eacb5c8b3ccab$var$TextBookmark(pos, pos) : new $a24eacb5c8b3ccab$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $a24eacb5c8b3ccab$export$e2940151ac854c0b.isSelectable(node)) return new $a24eacb5c8b3ccab$export$e2940151ac854c0b($pos);
        return $a24eacb5c8b3ccab$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95 extends $a24eacb5c8b3ccab$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
        if (content == (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $a24eacb5c8b3ccab$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $a24eacb5c8b3ccab$var$AllBookmark;
    }
}
$a24eacb5c8b3ccab$export$52baac22726c72bf.jsonID("all", $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95);
const $a24eacb5c8b3ccab$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $a24eacb5c8b3ccab$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $a24eacb5c8b3ccab$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $a24eacb5c8b3ccab$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $a24eacb5c8b3ccab$export$e2940151ac854c0b.isSelectable(child)) return $a24eacb5c8b3ccab$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $a24eacb5c8b3ccab$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $82f7355673365313$export$5c860b2e74034756) || step instanceof (0, $82f7355673365313$export$444ba800d6024a98))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($a24eacb5c8b3ccab$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $a24eacb5c8b3ccab$var$UPDATED_SEL = 1, $a24eacb5c8b3ccab$var$UPDATED_MARKS = 2, $a24eacb5c8b3ccab$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $a24eacb5c8b3ccab$export$febc5573c75cefb0 extends (0, $82f7355673365313$export$563a914cafbdc389) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $a24eacb5c8b3ccab$var$UPDATED_SEL) & ~$a24eacb5c8b3ccab$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $a24eacb5c8b3ccab$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $a24eacb5c8b3ccab$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $d3a8f56ade4880df$export$c9d15bcfc6d42044).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $a24eacb5c8b3ccab$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$a24eacb5c8b3ccab$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $d3a8f56ade4880df$export$c9d15bcfc6d42044).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($a24eacb5c8b3ccab$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $a24eacb5c8b3ccab$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $a24eacb5c8b3ccab$var$UPDATED_SCROLL) > 0;
    }
}
function $a24eacb5c8b3ccab$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $a24eacb5c8b3ccab$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $a24eacb5c8b3ccab$var$bind(desc.init, self);
        this.apply = $a24eacb5c8b3ccab$var$bind(desc.apply, self);
    }
}
const $a24eacb5c8b3ccab$var$baseFields = [
    new $a24eacb5c8b3ccab$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $a24eacb5c8b3ccab$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $a24eacb5c8b3ccab$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $a24eacb5c8b3ccab$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $a24eacb5c8b3ccab$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $a24eacb5c8b3ccab$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $a24eacb5c8b3ccab$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $a24eacb5c8b3ccab$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $a24eacb5c8b3ccab$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $a24eacb5c8b3ccab$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $a24eacb5c8b3ccab$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $a24eacb5c8b3ccab$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $a24eacb5c8b3ccab$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $a24eacb5c8b3ccab$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $a24eacb5c8b3ccab$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == "object") for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $a24eacb5c8b3ccab$var$Configuration(config.schema, config.plugins);
        let instance = new $a24eacb5c8b3ccab$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $d3a8f56ade4880df$export$85c928794f8d04d4).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $a24eacb5c8b3ccab$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $a24eacb5c8b3ccab$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $a24eacb5c8b3ccab$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $a24eacb5c8b3ccab$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $a24eacb5c8b3ccab$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $a24eacb5c8b3ccab$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $a24eacb5c8b3ccab$var$keys = Object.create(null);
function $a24eacb5c8b3ccab$var$createKey(name) {
    if (name in $a24eacb5c8b3ccab$var$keys) return name + "$" + ++$a24eacb5c8b3ccab$var$keys[name];
    $a24eacb5c8b3ccab$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $a24eacb5c8b3ccab$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $a24eacb5c8b3ccab$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}




// view/index.ts



const $41324cd97564f577$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $41324cd97564f577$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $41324cd97564f577$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $41324cd97564f577$var$textRange = function(node, from, to) {
    let range = $41324cd97564f577$var$reusedRange || ($41324cd97564f577$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $41324cd97564f577$var$clearReusedRange = function() {
    $41324cd97564f577$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $41324cd97564f577$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($41324cd97564f577$var$scanFor(node, off, targetNode, targetOff, -1) || $41324cd97564f577$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $41324cd97564f577$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $41324cd97564f577$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $41324cd97564f577$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $41324cd97564f577$var$hasBlockDesc(node) || $41324cd97564f577$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $41324cd97564f577$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $41324cd97564f577$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $41324cd97564f577$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $41324cd97564f577$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $41324cd97564f577$var$nodeSize(node);
        } else if (node.parentNode && !$41324cd97564f577$var$hasBlockDesc(node)) {
            offset = $41324cd97564f577$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $41324cd97564f577$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$41324cd97564f577$var$hasBlockDesc(node)) {
            offset = $41324cd97564f577$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $41324cd97564f577$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $41324cd97564f577$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $41324cd97564f577$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $41324cd97564f577$var$nodeSize(node);
    }
}
function $41324cd97564f577$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $41324cd97564f577$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $41324cd97564f577$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $41324cd97564f577$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $41324cd97564f577$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $41324cd97564f577$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        if (pos) return {
            node: pos.offsetNode,
            offset: pos.offset
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: range.startOffset
        };
    }
}
const $41324cd97564f577$var$nav = typeof navigator != "undefined" ? navigator : null;
const $41324cd97564f577$var$doc = typeof document != "undefined" ? document : null;
const $41324cd97564f577$var$agent = $41324cd97564f577$var$nav && $41324cd97564f577$var$nav.userAgent || "";
const $41324cd97564f577$var$ie_edge = /Edge\/(\d+)/.exec($41324cd97564f577$var$agent);
const $41324cd97564f577$var$ie_upto10 = /MSIE \d/.exec($41324cd97564f577$var$agent);
const $41324cd97564f577$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($41324cd97564f577$var$agent);
const $41324cd97564f577$var$ie = !!($41324cd97564f577$var$ie_upto10 || $41324cd97564f577$var$ie_11up || $41324cd97564f577$var$ie_edge);
const $41324cd97564f577$var$ie_version = $41324cd97564f577$var$ie_upto10 ? document.documentMode : $41324cd97564f577$var$ie_11up ? +$41324cd97564f577$var$ie_11up[1] : $41324cd97564f577$var$ie_edge ? +$41324cd97564f577$var$ie_edge[1] : 0;
const $41324cd97564f577$var$gecko = !$41324cd97564f577$var$ie && /gecko\/(\d+)/i.test($41324cd97564f577$var$agent);
$41324cd97564f577$var$gecko && (/Firefox\/(\d+)/.exec($41324cd97564f577$var$agent) || [
    0,
    0
])[1];
const $41324cd97564f577$var$_chrome = !$41324cd97564f577$var$ie && /Chrome\/(\d+)/.exec($41324cd97564f577$var$agent);
const $41324cd97564f577$var$chrome = !!$41324cd97564f577$var$_chrome;
const $41324cd97564f577$var$chrome_version = $41324cd97564f577$var$_chrome ? +$41324cd97564f577$var$_chrome[1] : 0;
const $41324cd97564f577$var$safari = !$41324cd97564f577$var$ie && !!$41324cd97564f577$var$nav && /Apple Computer/.test($41324cd97564f577$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $41324cd97564f577$var$ios = $41324cd97564f577$var$safari && (/Mobile\/\w+/.test($41324cd97564f577$var$agent) || !!$41324cd97564f577$var$nav && $41324cd97564f577$var$nav.maxTouchPoints > 2);
const $41324cd97564f577$var$mac = $41324cd97564f577$var$ios || ($41324cd97564f577$var$nav ? /Mac/.test($41324cd97564f577$var$nav.platform) : false);
const $41324cd97564f577$var$windows = $41324cd97564f577$var$nav ? /Win/.test($41324cd97564f577$var$nav.platform) : false;
const $41324cd97564f577$var$android = /Android \d/.test($41324cd97564f577$var$agent);
const $41324cd97564f577$var$webkit = !!$41324cd97564f577$var$doc && "webkitFontSmoothing" in $41324cd97564f577$var$doc.documentElement.style;
const $41324cd97564f577$var$webkit_version = $41324cd97564f577$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $41324cd97564f577$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $41324cd97564f577$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $41324cd97564f577$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $41324cd97564f577$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $41324cd97564f577$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $41324cd97564f577$var$windowRect(doc) : $41324cd97564f577$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $41324cd97564f577$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $41324cd97564f577$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $41324cd97564f577$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $41324cd97564f577$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $41324cd97564f577$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $41324cd97564f577$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $41324cd97564f577$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $41324cd97564f577$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $41324cd97564f577$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $41324cd97564f577$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $41324cd97564f577$var$scrollStack(view.dom)
    };
}
function $41324cd97564f577$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $41324cd97564f577$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $41324cd97564f577$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $41324cd97564f577$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $41324cd97564f577$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $41324cd97564f577$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $41324cd97564f577$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($41324cd97564f577$var$preventScrollSupported) return dom.focus($41324cd97564f577$var$preventScrollSupported);
    let stored = $41324cd97564f577$var$scrollStack(dom);
    dom.focus($41324cd97564f577$var$preventScrollSupported == null ? {
        get preventScroll () {
            $41324cd97564f577$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$41324cd97564f577$var$preventScrollSupported) {
        $41324cd97564f577$var$preventScrollSupported = false;
        $41324cd97564f577$var$restoreScrollStack(stored, 0);
    }
}
function $41324cd97564f577$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $41324cd97564f577$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $41324cd97564f577$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $41324cd97564f577$var$findOffsetInNode(closest, coordsClosest);
}
function $41324cd97564f577$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $41324cd97564f577$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($41324cd97564f577$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $41324cd97564f577$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $41324cd97564f577$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $41324cd97564f577$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $41324cd97564f577$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $41324cd97564f577$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true);
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM)) {
            let rect = desc.dom.getBoundingClientRect();
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $41324cd97564f577$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($41324cd97564f577$var$inRect(coords, rect)) return $41324cd97564f577$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $41324cd97564f577$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $41324cd97564f577$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$41324cd97564f577$var$inRect(coords, box)) return null;
        elt = $41324cd97564f577$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($41324cd97564f577$var$safari) {
        for(let p = elt; node && p; p = $41324cd97564f577$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $41324cd97564f577$var$targetKludge(elt, coords);
    if (node) {
        if ($41324cd97564f577$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($41324cd97564f577$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $41324cd97564f577$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $41324cd97564f577$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $41324cd97564f577$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $41324cd97564f577$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($41324cd97564f577$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $41324cd97564f577$var$nonZero) || target.getBoundingClientRect();
}
const $41324cd97564f577$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $41324cd97564f577$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $41324cd97564f577$var$webkit || $41324cd97564f577$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($41324cd97564f577$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $41324cd97564f577$var$singleRect($41324cd97564f577$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($41324cd97564f577$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $41324cd97564f577$var$singleRect($41324cd97564f577$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $41324cd97564f577$var$singleRect($41324cd97564f577$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $41324cd97564f577$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $41324cd97564f577$var$flattenV($41324cd97564f577$var$singleRect($41324cd97564f577$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $41324cd97564f577$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $41324cd97564f577$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $41324cd97564f577$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $41324cd97564f577$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $41324cd97564f577$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $41324cd97564f577$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $41324cd97564f577$var$textRange(before, $41324cd97564f577$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $41324cd97564f577$var$flattenV($41324cd97564f577$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $41324cd97564f577$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $41324cd97564f577$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $41324cd97564f577$var$flattenV($41324cd97564f577$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $41324cd97564f577$var$flattenV($41324cd97564f577$var$singleRect(node.nodeType == 3 ? $41324cd97564f577$var$textRange(node) : node, -side), side >= 0);
}
function $41324cd97564f577$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $41324cd97564f577$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $41324cd97564f577$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $41324cd97564f577$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $41324cd97564f577$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $41324cd97564f577$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $41324cd97564f577$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $41324cd97564f577$var$maybeRTL = /[\u0590-\u08ac]/;
function $41324cd97564f577$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$41324cd97564f577$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $41324cd97564f577$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $41324cd97564f577$var$cachedState = null;
let $41324cd97564f577$var$cachedDir = null;
let $41324cd97564f577$var$cachedResult = false;
function $41324cd97564f577$var$endOfTextblock(view, state, dir) {
    if ($41324cd97564f577$var$cachedState == state && $41324cd97564f577$var$cachedDir == dir) return $41324cd97564f577$var$cachedResult;
    $41324cd97564f577$var$cachedState = state;
    $41324cd97564f577$var$cachedDir = dir;
    return $41324cd97564f577$var$cachedResult = dir == "up" || dir == "down" ? $41324cd97564f577$var$endOfTextblockVertical(view, state, dir) : $41324cd97564f577$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $41324cd97564f577$var$NOT_DIRTY = 0, $41324cd97564f577$var$CHILD_DIRTY = 1, $41324cd97564f577$var$CONTENT_DIRTY = 2, $41324cd97564f577$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $41324cd97564f577$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $41324cd97564f577$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $41324cd97564f577$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $41324cd97564f577$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $41324cd97564f577$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $41324cd97564f577$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $41324cd97564f577$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $41324cd97564f577$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $41324cd97564f577$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, root, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = root.getSelection();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($41324cd97564f577$var$gecko || $41324cd97564f577$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $41324cd97564f577$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($41324cd97564f577$var$gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
            let after = domSel.focusNode.childNodes[domSel.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $41324cd97564f577$var$safari) && $41324cd97564f577$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) && $41324cd97564f577$var$isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $41324cd97564f577$var$CONTENT_DIRTY : $41324cd97564f577$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $41324cd97564f577$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $41324cd97564f577$var$CONTENT_DIRTY : $41324cd97564f577$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $41324cd97564f577$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $41324cd97564f577$var$CONTENT_DIRTY : $41324cd97564f577$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $41324cd97564f577$var$WidgetViewDesc extends $41324cd97564f577$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $41324cd97564f577$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $41324cd97564f577$var$CompositionViewDesc extends $41324cd97564f577$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $41324cd97564f577$var$MarkViewDesc extends $41324cd97564f577$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $d3a8f56ade4880df$export$3476b78f8f5a8b72).renderSpec(document, mark.type.spec.toDOM(mark, inline));
        return new $41324cd97564f577$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom);
    }
    parseRule() {
        if (this.dirty & $41324cd97564f577$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $41324cd97564f577$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $41324cd97564f577$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $41324cd97564f577$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $41324cd97564f577$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $41324cd97564f577$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $41324cd97564f577$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $41324cd97564f577$var$NodeViewDesc extends $41324cd97564f577$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) ({ dom: dom, contentDOM: contentDOM } = (0, $d3a8f56ade4880df$export$3476b78f8f5a8b72).renderSpec(document, node.type.spec.toDOM(node)));
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $41324cd97564f577$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $41324cd97564f577$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $41324cd97564f577$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $41324cd97564f577$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $41324cd97564f577$var$NOT_DIRTY && node.eq(this.node) && $41324cd97564f577$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $41324cd97564f577$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $41324cd97564f577$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $d3a8f56ade4880df$export$c9d15bcfc6d42044).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $41324cd97564f577$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $41324cd97564f577$var$renderDescs(this.contentDOM, this.children, view);
            if ($41324cd97564f577$var$ios) $41324cd97564f577$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $41324cd97564f577$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $41324cd97564f577$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $41324cd97564f577$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $41324cd97564f577$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $41324cd97564f577$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($41324cd97564f577$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $41324cd97564f577$var$patchOuterDeco(this.dom, this.nodeDOM, $41324cd97564f577$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $41324cd97564f577$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $41324cd97564f577$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $41324cd97564f577$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $41324cd97564f577$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $41324cd97564f577$var$TextViewDesc extends $41324cd97564f577$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $41324cd97564f577$var$NODE_DIRTY || this.dirty != $41324cd97564f577$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $41324cd97564f577$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $41324cd97564f577$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $41324cd97564f577$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $41324cd97564f577$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $41324cd97564f577$var$TrailingHackViewDesc extends $41324cd97564f577$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $41324cd97564f577$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $41324cd97564f577$var$CustomNodeViewDesc extends $41324cd97564f577$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $41324cd97564f577$var$NODE_DIRTY) return false;
        if (this.spec.update) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, root, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, root) : super.setSelection(anchor, head, root, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $41324cd97564f577$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $41324cd97564f577$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $41324cd97564f577$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $41324cd97564f577$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $41324cd97564f577$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $41324cd97564f577$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$41324cd97564f577$var$OuterDecoLevel.prototype = Object.create(null);
const $41324cd97564f577$var$noDeco = [
    new $41324cd97564f577$var$OuterDecoLevel
];
function $41324cd97564f577$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $41324cd97564f577$var$noDeco;
    let top = needsWrap ? $41324cd97564f577$var$noDeco[0] : new $41324cd97564f577$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $41324cd97564f577$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $41324cd97564f577$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $41324cd97564f577$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $41324cd97564f577$var$noDeco && curComputed == $41324cd97564f577$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $41324cd97564f577$var$noDeco[0];
                curDOM = parent;
            }
        }
        $41324cd97564f577$var$patchAttributes(curDOM, prev || $41324cd97564f577$var$noDeco[0], deco);
    }
    return curDOM;
}
function $41324cd97564f577$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $41324cd97564f577$var$applyOuterDeco(dom, deco, node) {
    return $41324cd97564f577$var$patchOuterDeco(dom, dom, $41324cd97564f577$var$noDeco, $41324cd97564f577$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $41324cd97564f577$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $41324cd97564f577$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $41324cd97564f577$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $41324cd97564f577$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $41324cd97564f577$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $41324cd97564f577$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $41324cd97564f577$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $41324cd97564f577$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $41324cd97564f577$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $41324cd97564f577$var$NODE_DIRTY && $41324cd97564f577$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $41324cd97564f577$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $41324cd97564f577$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content)) return null;
        let wrapper = $41324cd97564f577$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $41324cd97564f577$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $41324cd97564f577$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $41324cd97564f577$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $41324cd97564f577$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($41324cd97564f577$var$safari || $41324cd97564f577$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $41324cd97564f577$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $41324cd97564f577$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $41324cd97564f577$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $41324cd97564f577$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $41324cd97564f577$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($41324cd97564f577$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $41324cd97564f577$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $41324cd97564f577$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $41324cd97564f577$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $41324cd97564f577$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), $anchor, selection;
    if ($41324cd97564f577$var$selectionCollapsed(domSel)) {
        $anchor = $head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $41324cd97564f577$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        let anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
        $anchor = doc.resolve(anchor);
    }
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $41324cd97564f577$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $41324cd97564f577$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $41324cd97564f577$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $41324cd97564f577$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $41324cd97564f577$var$syncNodeSelection(view, sel);
    if (!$41324cd97564f577$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $41324cd97564f577$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $41324cd97564f577$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $41324cd97564f577$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($41324cd97564f577$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $41324cd97564f577$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $41324cd97564f577$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view.root, force);
        if ($41324cd97564f577$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $41324cd97564f577$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $41324cd97564f577$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $41324cd97564f577$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $41324cd97564f577$var$brokenSelectBetweenUneditable = $41324cd97564f577$var$safari || $41324cd97564f577$var$chrome && $41324cd97564f577$var$chrome_version < 63;
function $41324cd97564f577$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($41324cd97564f577$var$safari && after && after.contentEditable == "false") return $41324cd97564f577$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $41324cd97564f577$var$setEditable(after);
        else if (before) return $41324cd97564f577$var$setEditable(before);
    }
}
function $41324cd97564f577$var$setEditable(element) {
    element.contentEditable = "true";
    if ($41324cd97564f577$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $41324cd97564f577$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $41324cd97564f577$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$41324cd97564f577$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $41324cd97564f577$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setEnd(node.parentNode, $41324cd97564f577$var$domIndex(node) + 1);
    else range.setEnd(node, 0);
    range.collapse(false);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $41324cd97564f577$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $41324cd97564f577$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $41324cd97564f577$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $41324cd97564f577$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $41324cd97564f577$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).between($anchor, $head, bias);
}
function $41324cd97564f577$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $41324cd97564f577$var$hasSelection(view);
}
function $41324cd97564f577$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $41324cd97564f577$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $41324cd97564f577$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $41324cd97564f577$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).findFrom($start, dir);
}
function $41324cd97564f577$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $41324cd97564f577$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $41324cd97564f577$var$apply(view, new (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $41324cd97564f577$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)) return $41324cd97564f577$var$apply(view, next);
            return false;
        } else if (!($41324cd97564f577$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(node)) return $41324cd97564f577$var$apply(view, new (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($41324cd97564f577$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $41324cd97564f577$var$apply(view, new (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b) && sel.node.isInline) return $41324cd97564f577$var$apply(view, new (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $41324cd97564f577$var$moveSelectionBlock(view.state, dir);
        if (next) return $41324cd97564f577$var$apply(view, next);
        return false;
    }
}
function $41324cd97564f577$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $41324cd97564f577$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $41324cd97564f577$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $41324cd97564f577$var$skipIgnoredNodesBefore(view) : $41324cd97564f577$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $41324cd97564f577$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($41324cd97564f577$var$gecko && node.nodeType == 1 && offset < $41324cd97564f577$var$nodeLen(node) && $41324cd97564f577$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($41324cd97564f577$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($41324cd97564f577$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $41324cd97564f577$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $41324cd97564f577$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $41324cd97564f577$var$nodeLen(node);
            }
        }
    }
    if (force) $41324cd97564f577$var$setSelFocus(view, node, offset);
    else if (moveNode) $41324cd97564f577$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $41324cd97564f577$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $41324cd97564f577$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($41324cd97564f577$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($41324cd97564f577$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $41324cd97564f577$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $41324cd97564f577$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $41324cd97564f577$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $41324cd97564f577$var$setSelFocus(view, moveNode, moveOffset);
}
function $41324cd97564f577$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $41324cd97564f577$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$41324cd97564f577$var$hasBlockDesc(node)){
        offset = $41324cd97564f577$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $41324cd97564f577$var$textNodeBefore(node, offset) {
    while(node && !offset && !$41324cd97564f577$var$hasBlockDesc(node)){
        offset = $41324cd97564f577$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $41324cd97564f577$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $41324cd97564f577$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $41324cd97564f577$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if ($41324cd97564f577$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $41324cd97564f577$var$selectionToDOM(view);
    }, 50);
}
function $41324cd97564f577$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($41324cd97564f577$var$chrome || $41324cd97564f577$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $41324cd97564f577$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($41324cd97564f577$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $41324cd97564f577$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)) return $41324cd97564f577$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95) ? (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near(side, dir) : (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).findFrom(side, dir);
        return beyond ? $41324cd97564f577$var$apply(view, beyond) : false;
    }
    return false;
}
function $41324cd97564f577$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $41324cd97564f577$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $41324cd97564f577$var$safariDownArrowBug(view) {
    if (!$41324cd97564f577$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $41324cd97564f577$var$switchEditable(view, child, "true");
        setTimeout(()=>$41324cd97564f577$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $41324cd97564f577$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $41324cd97564f577$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $41324cd97564f577$var$getMods(event);
    if (code == 8 || $41324cd97564f577$var$mac && code == 72 && mods == "c") return $41324cd97564f577$var$stopNativeHorizontalDelete(view, -1) || $41324cd97564f577$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $41324cd97564f577$var$mac && code == 68 && mods == "c") return $41324cd97564f577$var$stopNativeHorizontalDelete(view, 1) || $41324cd97564f577$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $41324cd97564f577$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $41324cd97564f577$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $41324cd97564f577$var$selectHorizontally(view, dir, mods) || $41324cd97564f577$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $41324cd97564f577$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $41324cd97564f577$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $41324cd97564f577$var$selectHorizontally(view, dir, mods) || $41324cd97564f577$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $41324cd97564f577$var$mac && code == 80 && mods == "c") return $41324cd97564f577$var$selectVertically(view, -1, mods) || $41324cd97564f577$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $41324cd97564f577$var$mac && code == 78 && mods == "c") return $41324cd97564f577$var$safariDownArrowBug(view) || $41324cd97564f577$var$selectVertically(view, 1, mods) || $41324cd97564f577$var$skipIgnoredNodes(view, 1);
    else if (mods == ($41324cd97564f577$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $41324cd97564f577$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $d3a8f56ade4880df$export$3476b78f8f5a8b72).fromSchema(view.state.schema);
    let doc = $41324cd97564f577$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $41324cd97564f577$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $41324cd97564f577$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $d3a8f56ade4880df$export$3476b78f8f5a8b72).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $41324cd97564f577$var$readHTML(html);
        if ($41324cd97564f577$var$webkit) $41324cd97564f577$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $d3a8f56ade4880df$export$1059c6e7d2ce5669).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$41324cd97564f577$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $41324cd97564f577$var$addContext($41324cd97564f577$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).maxOpen($41324cd97564f577$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $41324cd97564f577$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $41324cd97564f577$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $41324cd97564f577$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $41324cd97564f577$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $41324cd97564f577$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $41324cd97564f577$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(result);
    }
    return fragment;
}
function $41324cd97564f577$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $41324cd97564f577$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $41324cd97564f577$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($41324cd97564f577$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $41324cd97564f577$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $41324cd97564f577$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, true);
    return node.copy(fragment.append(fill));
}
function $41324cd97564f577$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $41324cd97564f577$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $41324cd97564f577$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($41324cd97564f577$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)($41324cd97564f577$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $41324cd97564f577$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $41324cd97564f577$var$_detachedDoc = null;
function $41324cd97564f577$var$detachedDoc() {
    return $41324cd97564f577$var$_detachedDoc || ($41324cd97564f577$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
function $41324cd97564f577$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $41324cd97564f577$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $41324cd97564f577$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = html;
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $41324cd97564f577$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($41324cd97564f577$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\xa0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $41324cd97564f577$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $41324cd97564f577$var$handlers = {};
const $41324cd97564f577$var$editHandlers = {};
const $41324cd97564f577$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $41324cd97564f577$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastAndroidDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $41324cd97564f577$var$initInput(view) {
    for(let event in $41324cd97564f577$var$handlers){
        let handler = $41324cd97564f577$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($41324cd97564f577$var$eventBelongsToView(view, event) && !$41324cd97564f577$var$runCustomHandler(view, event) && (view.editable || !(event.type in $41324cd97564f577$var$editHandlers))) handler(view, event);
        }, $41324cd97564f577$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($41324cd97564f577$var$safari) view.dom.addEventListener("input", ()=>null);
    $41324cd97564f577$var$ensureListeners(view);
}
function $41324cd97564f577$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $41324cd97564f577$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $41324cd97564f577$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$41324cd97564f577$var$runCustomHandler(view, event));
    });
}
function $41324cd97564f577$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $41324cd97564f577$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $41324cd97564f577$var$dispatchEvent(view, event) {
    if (!$41324cd97564f577$var$runCustomHandler(view, event) && $41324cd97564f577$var$handlers[event.type] && (view.editable || !(event.type in $41324cd97564f577$var$editHandlers))) $41324cd97564f577$var$handlers[event.type](view, event);
}
$41324cd97564f577$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($41324cd97564f577$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($41324cd97564f577$var$android && $41324cd97564f577$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($41324cd97564f577$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $41324cd97564f577$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $41324cd97564f577$var$captureKeyDown(view, event)) event.preventDefault();
    else $41324cd97564f577$var$setSelectionOrigin(view, "key");
};
$41324cd97564f577$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$41324cd97564f577$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($41324cd97564f577$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $41324cd97564f577$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $41324cd97564f577$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $41324cd97564f577$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $41324cd97564f577$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $41324cd97564f577$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $41324cd97564f577$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(node)) {
        $41324cd97564f577$var$updateSelection(view, new (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)($pos), "pointer");
        return true;
    }
    return false;
}
function $41324cd97564f577$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $41324cd97564f577$var$updateSelection(view, (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $41324cd97564f577$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $41324cd97564f577$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $41324cd97564f577$var$selectClickedNode(view, inside) : $41324cd97564f577$var$selectClickedLeaf(view, inside));
}
function $41324cd97564f577$var$handleDoubleClick(view, pos, inside, event) {
    return $41324cd97564f577$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $41324cd97564f577$var$handleTripleClick(view, pos, inside, event) {
    return $41324cd97564f577$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $41324cd97564f577$var$defaultTripleClick(view, inside, event);
}
function $41324cd97564f577$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $41324cd97564f577$var$updateSelection(view, (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $41324cd97564f577$var$updateSelection(view, (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(node)) $41324cd97564f577$var$updateSelection(view, (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $41324cd97564f577$var$forceDOMFlush(view) {
    return $41324cd97564f577$var$endComposition(view);
}
const $41324cd97564f577$var$selectNodeModifier = $41324cd97564f577$var$mac ? "metaKey" : "ctrlKey";
$41324cd97564f577$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $41324cd97564f577$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $41324cd97564f577$var$isNear(event, view.input.lastClick) && !event[$41324cd97564f577$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($41324cd97564f577$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $41324cd97564f577$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $41324cd97564f577$var$handleDoubleClick : $41324cd97564f577$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $41324cd97564f577$var$setSelectionOrigin(view, "pointer");
};
class $41324cd97564f577$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$41324cd97564f577$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $41324cd97564f577$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $41324cd97564f577$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$41324cd97564f577$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($41324cd97564f577$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $41324cd97564f577$var$setSelectionOrigin(this.view, "pointer");
        else if ($41324cd97564f577$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $41324cd97564f577$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $41324cd97564f577$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $41324cd97564f577$var$updateSelection(this.view, (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $41324cd97564f577$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $41324cd97564f577$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$41324cd97564f577$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $41324cd97564f577$var$forceDOMFlush(view);
    $41324cd97564f577$var$setSelectionOrigin(view, "pointer");
};
$41324cd97564f577$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $41324cd97564f577$var$setSelectionOrigin(view, "pointer");
};
$41324cd97564f577$var$handlers.contextmenu = (view)=>$41324cd97564f577$var$forceDOMFlush(view);
function $41324cd97564f577$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($41324cd97564f577$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $41324cd97564f577$var$timeoutComposition = $41324cd97564f577$var$android ? 5000 : -1;
$41324cd97564f577$var$editHandlers.compositionstart = $41324cd97564f577$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$from;
        if (state.selection.empty && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $41324cd97564f577$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $41324cd97564f577$var$endComposition(view);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($41324cd97564f577$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        view.domSelection().collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $41324cd97564f577$var$scheduleComposeEnd(view, $41324cd97564f577$var$timeoutComposition);
};
$41324cd97564f577$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $41324cd97564f577$var$scheduleComposeEnd(view, 20);
    }
};
function $41324cd97564f577$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$41324cd97564f577$var$endComposition(view), delay);
}
function $41324cd97564f577$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $41324cd97564f577$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $41324cd97564f577$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $41324cd97564f577$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $41324cd97564f577$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $41324cd97564f577$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $41324cd97564f577$var$endComposition(view, forceUpdate = false) {
    if ($41324cd97564f577$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $41324cd97564f577$var$clearComposition(view);
    if (forceUpdate || view.docView && view.docView.dirty) {
        let sel = $41324cd97564f577$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $41324cd97564f577$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $41324cd97564f577$var$brokenClipboardAPI = $41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version < 15 || $41324cd97564f577$var$ios && $41324cd97564f577$var$webkit_version < 604;
$41324cd97564f577$var$handlers.copy = $41324cd97564f577$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $41324cd97564f577$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $41324cd97564f577$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $41324cd97564f577$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $41324cd97564f577$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $41324cd97564f577$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $41324cd97564f577$var$doPaste(view, target.value, null, plain, event);
        else $41324cd97564f577$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $41324cd97564f577$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $41324cd97564f577$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty))) return true;
    if (!slice) return false;
    let singleNode = $41324cd97564f577$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $41324cd97564f577$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$41324cd97564f577$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$41324cd97564f577$var$android) return;
    let data = $41324cd97564f577$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $41324cd97564f577$var$doPaste(view, $41324cd97564f577$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $41324cd97564f577$var$capturePaste(view, event);
};
class $41324cd97564f577$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $41324cd97564f577$var$dragCopyModifier = $41324cd97564f577$var$mac ? "altKey" : "ctrlKey";
$41324cd97564f577$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($41324cd97564f577$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $41324cd97564f577$var$serializeForClipboard(view, draggedSlice);
    event.dataTransfer.clearData();
    event.dataTransfer.setData($41324cd97564f577$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$41324cd97564f577$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $41324cd97564f577$var$Dragging(slice, !event[$41324cd97564f577$var$dragCopyModifier], node);
};
$41324cd97564f577$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$41324cd97564f577$var$editHandlers.dragover = $41324cd97564f577$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$41324cd97564f577$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($41324cd97564f577$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $41324cd97564f577$var$parseFromClipboard(view, $41324cd97564f577$var$getText(event.dataTransfer), $41324cd97564f577$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$41324cd97564f577$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $82f7355673365313$export$2819d598d048fc9c)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($41324cd97564f577$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$41324cd97564f577$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $41324cd97564f577$var$selectionToDOM(view);
        }, 20);
    }
};
$41324cd97564f577$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$41324cd97564f577$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($41324cd97564f577$var$chrome && $41324cd97564f577$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $41324cd97564f577$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $41324cd97564f577$var$editHandlers)$41324cd97564f577$var$handlers[prop] = $41324cd97564f577$var$editHandlers[prop];
function $41324cd97564f577$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $41324cd97564f577$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $41324cd97564f577$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $41324cd97564f577$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $41324cd97564f577$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $41324cd97564f577$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $41324cd97564f577$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $41324cd97564f577$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $41324cd97564f577$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $41324cd97564f577$var$InlineType && $41324cd97564f577$var$compareObjs(this.attrs, other.attrs) && $41324cd97564f577$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $41324cd97564f577$var$InlineType;
    }
    destroy() {}
}
class $41324cd97564f577$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $41324cd97564f577$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $41324cd97564f577$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $41324cd97564f577$var$NodeType && $41324cd97564f577$var$compareObjs(this.attrs, other.attrs) && $41324cd97564f577$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $41324cd97564f577$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $41324cd97564f577$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $41324cd97564f577$export$10e30b733df217ea(pos, pos, new $41324cd97564f577$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $41324cd97564f577$export$10e30b733df217ea(from, to, new $41324cd97564f577$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $41324cd97564f577$export$10e30b733df217ea(from, to, new $41324cd97564f577$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $41324cd97564f577$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $41324cd97564f577$var$WidgetType;
    }
}
const $41324cd97564f577$var$none = [], $41324cd97564f577$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $41324cd97564f577$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $41324cd97564f577$var$none;
        this.children = children.length ? children : $41324cd97564f577$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $41324cd97564f577$var$buildTree(decorations, doc, 0, $41324cd97564f577$var$noSpec) : $41324cd97564f577$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $41324cd97564f577$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $41324cd97564f577$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $41324cd97564f577$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $41324cd97564f577$export$93bf62eb445cec98(newLocal.sort($41324cd97564f577$var$byPos), $41324cd97564f577$var$none) : $41324cd97564f577$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $41324cd97564f577$var$empty) return $41324cd97564f577$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $41324cd97564f577$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $41324cd97564f577$var$buildTree(found, childNode, baseOffset + 1, $41324cd97564f577$var$noSpec));
            childIndex += 3;
        });
        let local = $41324cd97564f577$var$moveSpans(childIndex ? $41324cd97564f577$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $41324cd97564f577$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($41324cd97564f577$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $41324cd97564f577$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $41324cd97564f577$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $41324cd97564f577$export$93bf62eb445cec98(local, children) : $41324cd97564f577$var$empty;
    }
    forChild(offset, node) {
        if (this == $41324cd97564f577$var$empty) return this;
        if (node.isLeaf) return $41324cd97564f577$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $41324cd97564f577$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $41324cd97564f577$export$93bf62eb445cec98(local.sort($41324cd97564f577$var$byPos), $41324cd97564f577$var$none);
            return child ? new $41324cd97564f577$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $41324cd97564f577$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $41324cd97564f577$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $41324cd97564f577$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $41324cd97564f577$var$empty) return $41324cd97564f577$var$none;
        if (node.inlineContent || !this.local.some($41324cd97564f577$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $41324cd97564f577$var$InlineType)) result.push(this.local[i]);
        return result;
    }
}
/**
The empty set of decorations.
*/ $41324cd97564f577$export$93bf62eb445cec98.empty = new $41324cd97564f577$export$93bf62eb445cec98([], []);
/**
@internal
*/ $41324cd97564f577$export$93bf62eb445cec98.removeOverlap = $41324cd97564f577$var$removeOverlap;
const $41324cd97564f577$var$empty = $41324cd97564f577$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $41324cd97564f577$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $41324cd97564f577$var$noSpec));
        return $41324cd97564f577$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $41324cd97564f577$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $41324cd97564f577$var$empty) continue;
            if (result instanceof $41324cd97564f577$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $41324cd97564f577$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $41324cd97564f577$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $41324cd97564f577$var$removeOverlap(sorted ? result : result.sort($41324cd97564f577$var$byPos)) : $41324cd97564f577$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $41324cd97564f577$var$empty;
            case 1:
                return members[0];
            default:
                return new $41324cd97564f577$var$DecorationGroup(members.every((m)=>m instanceof $41324cd97564f577$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $41324cd97564f577$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
}
function $41324cd97564f577$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $41324cd97564f577$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $41324cd97564f577$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $41324cd97564f577$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $41324cd97564f577$export$93bf62eb445cec98(newLocal.sort($41324cd97564f577$var$byPos), children);
}
function $41324cd97564f577$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $41324cd97564f577$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $41324cd97564f577$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $41324cd97564f577$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $41324cd97564f577$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $41324cd97564f577$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $41324cd97564f577$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $41324cd97564f577$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $41324cd97564f577$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $41324cd97564f577$var$moveSpans(hasNulls ? $41324cd97564f577$var$withoutNulls(spans) : spans, -offset).sort($41324cd97564f577$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $41324cd97564f577$export$93bf62eb445cec98(locals, children) : $41324cd97564f577$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $41324cd97564f577$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $41324cd97564f577$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $41324cd97564f577$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $41324cd97564f577$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $41324cd97564f577$var$insertAhead(array, i, deco) {
    while(i < array.length && $41324cd97564f577$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $41324cd97564f577$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $41324cd97564f577$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($41324cd97564f577$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $41324cd97564f577$var$DecorationGroup.from(found);
}
const $41324cd97564f577$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $41324cd97564f577$var$useCharData = $41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11;
class $41324cd97564f577$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $41324cd97564f577$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $41324cd97564f577$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($41324cd97564f577$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $41324cd97564f577$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$41324cd97564f577$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $41324cd97564f577$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $41324cd97564f577$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $41324cd97564f577$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $41324cd97564f577$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $41324cd97564f577$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($41324cd97564f577$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $41324cd97564f577$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $41324cd97564f577$var$selectionCollapsed(sel) && (readSel = $41324cd97564f577$var$selectionFromDOM(view)) && readSel.eq((0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $41324cd97564f577$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $41324cd97564f577$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $41324cd97564f577$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $41324cd97564f577$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $41324cd97564f577$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $41324cd97564f577$var$cssChecked = new WeakMap();
let $41324cd97564f577$var$cssCheckWarned = false;
function $41324cd97564f577$var$checkCSS(view) {
    if ($41324cd97564f577$var$cssChecked.has(view)) return;
    $41324cd97564f577$var$cssChecked.set(view, null);
    if ([
        "normal",
        "nowrap",
        "pre-line"
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $41324cd97564f577$var$gecko;
        if ($41324cd97564f577$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $41324cd97564f577$var$cssCheckWarned = true;
    }
}
function $41324cd97564f577$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($41324cd97564f577$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $41324cd97564f577$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $41324cd97564f577$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $41324cd97564f577$var$rangeToSelectionRange(view, found) : null;
}
function $41324cd97564f577$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $41324cd97564f577$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$41324cd97564f577$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($41324cd97564f577$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $d3a8f56ade4880df$export$1059c6e7d2ce5669).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $41324cd97564f577$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $41324cd97564f577$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($41324cd97564f577$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $41324cd97564f577$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $41324cd97564f577$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $41324cd97564f577$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $41324cd97564f577$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($41324cd97564f577$var$chrome && $41324cd97564f577$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $41324cd97564f577$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $41324cd97564f577$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $41324cd97564f577$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (($41324cd97564f577$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $41324cd97564f577$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$41324cd97564f577$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $41324cd97564f577$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $41324cd97564f577$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    view.input.domChangeCount++;
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \xa0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($41324cd97564f577$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $41324cd97564f577$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $41324cd97564f577$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $41324cd97564f577$var$keyEvent(8, "Backspace")))) {
        if ($41324cd97564f577$var$android && $41324cd97564f577$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome Android will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($41324cd97564f577$var$chrome && $41324cd97564f577$var$android && change.endB == change.start) view.input.lastAndroidDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($41324cd97564f577$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $41324cd97564f577$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($41324cd97564f577$var$ie && $41324cd97564f577$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$41324cd97564f577$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $41324cd97564f577$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $41324cd97564f577$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome Android will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($41324cd97564f577$var$chrome && $41324cd97564f577$var$android && view.composing && sel.empty && (change.start != change.endB || view.input.lastAndroidDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $41324cd97564f577$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $41324cd97564f577$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $41324cd97564f577$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $41324cd97564f577$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $41324cd97564f577$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $41324cd97564f577$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($41324cd97564f577$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $41324cd97564f577$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $41324cd97564f577$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $41324cd97564f577$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $41324cd97564f577$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $41324cd97564f577$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $41324cd97564f577$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $41324cd97564f577$export$38b79e3fdcfcfd68 = $41324cd97564f577$var$serializeForClipboard;
/**
@internal
*/ const $41324cd97564f577$export$5d42ca91c11c9e4d = $41324cd97564f577$var$parseFromClipboard;
/**
@internal
*/ const $41324cd97564f577$export$76b14d3c719c32fc = $41324cd97564f577$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $41324cd97564f577$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $41324cd97564f577$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($41324cd97564f577$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $41324cd97564f577$var$getEditable(this);
        $41324cd97564f577$var$updateCursorWrapper(this);
        this.nodeViews = $41324cd97564f577$var$buildNodeViews(this);
        this.docView = $41324cd97564f577$var$docViewDesc(this.state.doc, $41324cd97564f577$var$computeDocDeco(this), $41324cd97564f577$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $41324cd97564f577$var$DOMObserver(this, (from, to, typeOver, added)=>$41324cd97564f577$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $41324cd97564f577$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $41324cd97564f577$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($41324cd97564f577$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $41324cd97564f577$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $41324cd97564f577$var$buildNodeViews(this);
            if ($41324cd97564f577$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $41324cd97564f577$var$ensureListeners(this);
        this.editable = $41324cd97564f577$var$getEditable(this);
        $41324cd97564f577$var$updateCursorWrapper(this);
        let innerDeco = $41324cd97564f577$var$viewDecorations(this), outerDeco = $41324cd97564f577$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $41324cd97564f577$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($41324cd97564f577$var$ie || $41324cd97564f577$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $41324cd97564f577$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $41324cd97564f577$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $41324cd97564f577$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $41324cd97564f577$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $41324cd97564f577$var$anchorInRightPlace(this))) $41324cd97564f577$var$selectionToDOM(this, forceSelUpdate);
            else {
                $41324cd97564f577$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $41324cd97564f577$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $41324cd97564f577$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $41324cd97564f577$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $41324cd97564f577$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($41324cd97564f577$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == "false") return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $41324cd97564f577$var$focusPreventScroll(this.dom);
        $41324cd97564f577$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $41324cd97564f577$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $41324cd97564f577$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $41324cd97564f577$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $41324cd97564f577$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $41324cd97564f577$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $41324cd97564f577$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $41324cd97564f577$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $41324cd97564f577$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $41324cd97564f577$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        return $41324cd97564f577$var$safari && this.root.nodeType === 11 && $41324cd97564f577$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $41324cd97564f577$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $41324cd97564f577$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $41324cd97564f577$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $41324cd97564f577$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $41324cd97564f577$export$10e30b733df217ea.widget(view.state.selection.head, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $41324cd97564f577$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $41324cd97564f577$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $41324cd97564f577$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $41324cd97564f577$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $41324cd97564f577$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}




// keymap/index.ts
var $499b21a09ea72ebb$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $499b21a09ea72ebb$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $499b21a09ea72ebb$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $499b21a09ea72ebb$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $499b21a09ea72ebb$var$i = 0; $499b21a09ea72ebb$var$i < 10; $499b21a09ea72ebb$var$i++)$499b21a09ea72ebb$export$e2253033e6e1df16[48 + $499b21a09ea72ebb$var$i] = $499b21a09ea72ebb$export$e2253033e6e1df16[96 + $499b21a09ea72ebb$var$i] = String($499b21a09ea72ebb$var$i);
// The function keys
for(var $499b21a09ea72ebb$var$i = 1; $499b21a09ea72ebb$var$i <= 24; $499b21a09ea72ebb$var$i++)$499b21a09ea72ebb$export$e2253033e6e1df16[$499b21a09ea72ebb$var$i + 111] = "F" + $499b21a09ea72ebb$var$i;
// And the alphabetic keys
for(var $499b21a09ea72ebb$var$i = 65; $499b21a09ea72ebb$var$i <= 90; $499b21a09ea72ebb$var$i++){
    $499b21a09ea72ebb$export$e2253033e6e1df16[$499b21a09ea72ebb$var$i] = String.fromCharCode($499b21a09ea72ebb$var$i + 32);
    $499b21a09ea72ebb$export$fba63a578e423eb[$499b21a09ea72ebb$var$i] = String.fromCharCode($499b21a09ea72ebb$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $499b21a09ea72ebb$var$code in $499b21a09ea72ebb$export$e2253033e6e1df16)if (!$499b21a09ea72ebb$export$fba63a578e423eb.hasOwnProperty($499b21a09ea72ebb$var$code)) $499b21a09ea72ebb$export$fba63a578e423eb[$499b21a09ea72ebb$var$code] = $499b21a09ea72ebb$export$e2253033e6e1df16[$499b21a09ea72ebb$var$code];
function $499b21a09ea72ebb$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $499b21a09ea72ebb$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $499b21a09ea72ebb$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $499b21a09ea72ebb$export$fba63a578e423eb : $499b21a09ea72ebb$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}



const $54e5867f52850bef$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $54e5867f52850bef$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($54e5867f52850bef$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $54e5867f52850bef$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$54e5867f52850bef$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $54e5867f52850bef$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $54e5867f52850bef$export$5043418e2ef368d5(bindings) {
    return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        props: {
            handleKeyDown: $54e5867f52850bef$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $54e5867f52850bef$export$53f558754f8b9fd1(bindings) {
    let map = $54e5867f52850bef$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $499b21a09ea72ebb$export$fb33aafd75404f4c)(event), baseName, direct = map[$54e5867f52850bef$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$54e5867f52850bef$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $499b21a09ea72ebb$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$54e5867f52850bef$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}




// model/index.ts



// transform/index.ts



// commands/index.ts



/**
Delete the selection, if there is one.
*/ const $0e30e03a0c1ecd8e$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $0e30e03a0c1ecd8e$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $0e30e03a0c1ecd8e$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $0e30e03a0c1ecd8e$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $0e30e03a0c1ecd8e$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $82f7355673365313$export$f1508b72cc76a09e)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if (!before.type.spec.isolating && $0e30e03a0c1ecd8e$var$deleteBarrier(state, $cut, dispatch)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($0e30e03a0c1ecd8e$var$textblockAt(before, "end") || (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(before))) {
        let delStep = (0, $82f7355673365313$export$ed6ac67359824afd)(state.doc, $cursor.before(), $cursor.after(), (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($0e30e03a0c1ecd8e$var$textblockAt(before, "end") ? (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $0e30e03a0c1ecd8e$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $0e30e03a0c1ecd8e$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $0e30e03a0c1ecd8e$var$findCutBefore($cursor);
    return $cut ? $0e30e03a0c1ecd8e$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $0e30e03a0c1ecd8e$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $0e30e03a0c1ecd8e$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $0e30e03a0c1ecd8e$var$findCutAfter($cursor);
    return $cut ? $0e30e03a0c1ecd8e$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $0e30e03a0c1ecd8e$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $82f7355673365313$export$ed6ac67359824afd)(state.doc, beforePos, afterPos, (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty);
    if (!step || step.from != beforePos || step instanceof (0, $82f7355673365313$export$5c860b2e74034756) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $0e30e03a0c1ecd8e$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $0e30e03a0c1ecd8e$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $0e30e03a0c1ecd8e$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $0e30e03a0c1ecd8e$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $0e30e03a0c1ecd8e$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $0e30e03a0c1ecd8e$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $0e30e03a0c1ecd8e$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $0e30e03a0c1ecd8e$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($0e30e03a0c1ecd8e$var$deleteBarrier(state, $cut, dispatch)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($0e30e03a0c1ecd8e$var$textblockAt(after, "start") || (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(after))) {
        let delStep = (0, $82f7355673365313$export$ed6ac67359824afd)(state.doc, $cursor.before(), $cursor.after(), (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($0e30e03a0c1ecd8e$var$textblockAt(after, "start") ? (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $0e30e03a0c1ecd8e$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $0e30e03a0c1ecd8e$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $0e30e03a0c1ecd8e$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $0e30e03a0c1ecd8e$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $82f7355673365313$export$f15f89fd9d8cc98a)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $82f7355673365313$export$41b1d4cb5ceb3147)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $0e30e03a0c1ecd8e$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b)) {
        if (sel.node.isTextblock || !(0, $82f7355673365313$export$f15f89fd9d8cc98a)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $82f7355673365313$export$41b1d4cb5ceb3147)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $0e30e03a0c1ecd8e$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $82f7355673365313$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $0e30e03a0c1ecd8e$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $0e30e03a0c1ecd8e$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $0e30e03a0c1ecd8e$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $0e30e03a0c1ecd8e$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $0e30e03a0c1ecd8e$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $0e30e03a0c1ecd8e$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $0e30e03a0c1ecd8e$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $82f7355673365313$export$5aaf008897aef029)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $82f7355673365313$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $0e30e03a0c1ecd8e$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $82f7355673365313$export$5aaf008897aef029)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.parent.isBlock) return false;
        if (dispatch) {
            let atEnd = $to.parentOffset == $to.parent.content.size;
            let tr = state.tr;
            if (state.selection instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb) || state.selection instanceof (0, $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95)) tr.deleteSelection();
            let deflt = $from.depth == 0 ? null : $0e30e03a0c1ecd8e$var$defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
            let splitType = splitNode && splitNode($to.parent, atEnd);
            let types = splitType ? [
                splitType
            ] : atEnd && deflt ? [
                {
                    type: deflt
                }
            ] : undefined;
            let can = (0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, types);
            if (!types && !can && (0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
                {
                    type: deflt
                }
            ] : undefined)) {
                if (deflt) types = [
                    {
                        type: deflt
                    }
                ];
                can = true;
            }
            if (can) {
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (!atEnd && !$from.parentOffset && $from.parent.type != deflt) {
                    let first = tr.mapping.map($from.before()), $first = tr.doc.resolve(first);
                    if (deflt && $from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $0e30e03a0c1ecd8e$export$e99155638ff4dff0 = $0e30e03a0c1ecd8e$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $0e30e03a0c1ecd8e$export$eeb429476568b72b = (state, dispatch)=>{
    return $0e30e03a0c1ecd8e$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $0e30e03a0c1ecd8e$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $0e30e03a0c1ecd8e$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $a24eacb5c8b3ccab$export$c15d9ba76bdbcd95)(state.doc)));
    return true;
};
function $0e30e03a0c1ecd8e$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $82f7355673365313$export$f15f89fd9d8cc98a)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount)).join($pos.pos).scrollIntoView());
    return true;
}
function $0e30e03a0c1ecd8e$var$deleteBarrier(state, $cut, dispatch) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    if (before.type.spec.isolating || after.type.spec.isolating) return false;
    if ($0e30e03a0c1ecd8e$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(conn[i].create(null, wrap));
            wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $82f7355673365313$export$444ba800d6024a98)($cut.pos - 1, end, $cut.pos, end, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(wrap, 1, 0), conn.length, true));
            let joinAt = end + 2 * conn.length;
            if ((0, $82f7355673365313$export$f15f89fd9d8cc98a)(tr.doc, joinAt)) tr.join(joinAt);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $82f7355673365313$export$f1508b72cc76a09e)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $0e30e03a0c1ecd8e$var$textblockAt(after, "start", true) && $0e30e03a0c1ecd8e$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $82f7355673365313$export$444ba800d6024a98)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $0e30e03a0c1ecd8e$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $0e30e03a0c1ecd8e$export$c3a64f3c9604a1b1 = $0e30e03a0c1ecd8e$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $0e30e03a0c1ecd8e$export$a66c1876556415e5 = $0e30e03a0c1ecd8e$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $0e30e03a0c1ecd8e$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $82f7355673365313$export$118cb9a83e81ba37)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $0e30e03a0c1ecd8e$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $0e30e03a0c1ecd8e$var$markApplies(doc, ranges, type) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $0e30e03a0c1ecd8e$export$797ad2667b8015a8(markType, attrs = null) {
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$0e30e03a0c1ecd8e$var$markApplies(state.doc, ranges, markType)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let has = false, tr = state.tr;
                for(let i = 0; !has && i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
                }
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (has) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $0e30e03a0c1ecd8e$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $82f7355673365313$export$f15f89fd9d8cc98a)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $0e30e03a0c1ecd8e$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $0e30e03a0c1ecd8e$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $0e30e03a0c1ecd8e$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $0e30e03a0c1ecd8e$var$backspace = $0e30e03a0c1ecd8e$export$146a774cdef7663a($0e30e03a0c1ecd8e$export$e9a518a637d1e641, $0e30e03a0c1ecd8e$export$979097b097459299, $0e30e03a0c1ecd8e$export$52b8a4af68d19794);
let $0e30e03a0c1ecd8e$var$del = $0e30e03a0c1ecd8e$export$146a774cdef7663a($0e30e03a0c1ecd8e$export$e9a518a637d1e641, $0e30e03a0c1ecd8e$export$bf432e340007f9ef, $0e30e03a0c1ecd8e$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $0e30e03a0c1ecd8e$export$eb36e8971b04df36 = {
    "Enter": $0e30e03a0c1ecd8e$export$146a774cdef7663a($0e30e03a0c1ecd8e$export$a5d02b4b65e94f91, $0e30e03a0c1ecd8e$export$d0f80ac1b4510888, $0e30e03a0c1ecd8e$export$a3574cc681852c08, $0e30e03a0c1ecd8e$export$e99155638ff4dff0),
    "Mod-Enter": $0e30e03a0c1ecd8e$export$634b78845598ff5b,
    "Backspace": $0e30e03a0c1ecd8e$var$backspace,
    "Mod-Backspace": $0e30e03a0c1ecd8e$var$backspace,
    "Shift-Backspace": $0e30e03a0c1ecd8e$var$backspace,
    "Delete": $0e30e03a0c1ecd8e$var$del,
    "Mod-Delete": $0e30e03a0c1ecd8e$var$del,
    "Mod-a": $0e30e03a0c1ecd8e$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $0e30e03a0c1ecd8e$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $0e30e03a0c1ecd8e$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $0e30e03a0c1ecd8e$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $0e30e03a0c1ecd8e$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $0e30e03a0c1ecd8e$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $0e30e03a0c1ecd8e$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $0e30e03a0c1ecd8e$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $0e30e03a0c1ecd8e$export$c3a64f3c9604a1b1,
    "Ctrl-e": $0e30e03a0c1ecd8e$export$a66c1876556415e5
};
for(let key in $0e30e03a0c1ecd8e$export$eb36e8971b04df36)$0e30e03a0c1ecd8e$export$f292ad8dbd5063c8[key] = $0e30e03a0c1ecd8e$export$eb36e8971b04df36[key];
const $0e30e03a0c1ecd8e$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $0e30e03a0c1ecd8e$export$4a0c2b85b1f0a889 = $0e30e03a0c1ecd8e$var$mac ? $0e30e03a0c1ecd8e$export$f292ad8dbd5063c8 : $0e30e03a0c1ecd8e$export$eb36e8971b04df36;




// schema-list/index.ts



const $62b287a5b09222dc$var$olDOM = [
    "ol",
    0
], $62b287a5b09222dc$var$ulDOM = [
    "ul",
    0
], $62b287a5b09222dc$var$liDOM = [
    "li",
    0
];
/**
An ordered list [node spec](https://prosemirror.net/docs/ref/#model.NodeSpec). Has a single
attribute, `order`, which determines the number at which the list
starts counting, and defaults to 1. Represented as an `<ol>`
element.
*/ const $62b287a5b09222dc$export$a5dc81035676e7a = {
    attrs: {
        order: {
            default: 1
        }
    },
    parseDOM: [
        {
            tag: "ol",
            getAttrs (dom) {
                return {
                    order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
                };
            }
        }
    ],
    toDOM (node) {
        return node.attrs.order == 1 ? $62b287a5b09222dc$var$olDOM : [
            "ol",
            {
                start: node.attrs.order
            },
            0
        ];
    }
};
/**
A bullet list node spec, represented in the DOM as `<ul>`.
*/ const $62b287a5b09222dc$export$a140c94e5ea26bee = {
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM () {
        return $62b287a5b09222dc$var$ulDOM;
    }
};
/**
A list item (`<li>`) spec.
*/ const $62b287a5b09222dc$export$76c7e83ecc9cdf05 = {
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM () {
        return $62b287a5b09222dc$var$liDOM;
    },
    defining: true
};
function $62b287a5b09222dc$var$add(obj, props) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    for(let prop in props)copy[prop] = props[prop];
    return copy;
}
/**
Convenience function for adding list-related node types to a map
specifying the nodes for a schema. Adds
[`orderedList`](https://prosemirror.net/docs/ref/#schema-list.orderedList) as `"ordered_list"`,
[`bulletList`](https://prosemirror.net/docs/ref/#schema-list.bulletList) as `"bullet_list"`, and
[`listItem`](https://prosemirror.net/docs/ref/#schema-list.listItem) as `"list_item"`.

`itemContent` determines the content expression for the list items.
If you want the commands defined in this module to apply to your
list structure, it should have a shape like `"paragraph block*"` or
`"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
given to assign a group name to the list node types, for example
`"block"`.
*/ function $62b287a5b09222dc$export$fa2e7d3d1550c2ea(nodes, itemContent, listGroup) {
    return nodes.append({
        ordered_list: $62b287a5b09222dc$var$add($62b287a5b09222dc$export$a5dc81035676e7a, {
            content: "list_item+",
            group: listGroup
        }),
        bullet_list: $62b287a5b09222dc$var$add($62b287a5b09222dc$export$a140c94e5ea26bee, {
            content: "list_item+",
            group: listGroup
        }),
        list_item: $62b287a5b09222dc$var$add($62b287a5b09222dc$export$76c7e83ecc9cdf05, {
            content: itemContent
        })
    });
}
/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/ function $62b287a5b09222dc$export$a8aef45c6262afee(listType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), doJoin = false, outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) == 0) return false;
            let $insert = state.doc.resolve(range.start - 2);
            outerRange = new (0, $d3a8f56ade4880df$export$7bc461ceb770fb16)($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) range = new (0, $d3a8f56ade4880df$export$7bc461ceb770fb16)($from, state.doc.resolve($to.end(range.depth)), range.depth);
            doJoin = true;
        }
        let wrap = (0, $82f7355673365313$export$118cb9a83e81ba37)(outerRange, listType, attrs, range);
        if (!wrap) return false;
        if (dispatch) dispatch($62b287a5b09222dc$var$doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView());
        return true;
    };
}
function $62b287a5b09222dc$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $82f7355673365313$export$444ba800d6024a98)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type == listType) found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Build a command that splits a non-empty textblock at the top level
of a list item by also splitting that list item.
*/ function $62b287a5b09222dc$export$e920ee2eb756d384(itemType, itemAttrs) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to, node: node } = state.selection;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        let grandParent = $from.node(-1);
        if (grandParent.type != itemType) return false;
        if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth == 3 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
                let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($from.node(d).copy(wrap));
                let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                wrap = wrap.append((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(itemType.createAndFill()));
                let start = $from.before($from.depth - (depthBefore - 1));
                let tr = state.tr.replace(start, $from.after(-depthAfter), new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (node, pos)=>{
                    if (sel > -1) return false;
                    if (node.isTextblock && node.content.size == 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near(tr.doc.resolve(sel)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        let tr = state.tr.delete($from.pos, $to.pos);
        let types = nextType ? [
            itemAttrs ? {
                type: itemType,
                attrs: itemAttrs
            } : null,
            {
                type: nextType
            }
        ] : undefined;
        if (!(0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, $from.pos, 2, types)) return false;
        if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        return true;
    };
}
/**
Acts like [`splitListItem`](https://prosemirror.net/docs/ref/#schema-list.splitListItem), but
without resetting the set of active marks at the cursor.
*/ function $62b287a5b09222dc$export$265ad35055c66d75(itemType, itemAttrs) {
    let split = $62b287a5b09222dc$export$e920ee2eb756d384(itemType, itemAttrs);
    return (state, dispatch)=>{
        return split(state, dispatch && ((tr)=>{
            let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/ function $62b287a5b09222dc$export$e74cd5adb935a538(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        if (!dispatch) return true;
        if ($from.node(range.depth - 1).type == itemType) return $62b287a5b09222dc$var$liftToOuterList(state, dispatch, itemType, range);
        else return $62b287a5b09222dc$var$liftOutOfList(state, dispatch, range);
    };
}
function $62b287a5b09222dc$var$liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new (0, $82f7355673365313$export$444ba800d6024a98)(end - 1, endOfList, end, endOfList, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $d3a8f56ade4880df$export$7bc461ceb770fb16)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $82f7355673365313$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    tr.lift(range, target);
    let after = tr.mapping.map(end, -1) - 1;
    if ((0, $82f7355673365313$export$f15f89fd9d8cc98a)(tr.doc, after)) tr.join(after);
    dispatch(tr.scrollIntoView());
    return true;
}
function $62b287a5b09222dc$var$liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for(let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty : (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(list)))) return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new (0, $82f7355673365313$export$444ba800d6024a98)(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((atStart ? (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty : (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(list.copy((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty))).append(atEnd ? (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty : (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(list.copy((0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/ function $62b287a5b09222dc$export$dd505f850a3798a4(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        let startIndex = range.startIndex;
        if (startIndex == 0) return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType) return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(nestedBefore ? itemType.create() : null);
            let slice = new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(itemType.create(null, (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new (0, $82f7355673365313$export$444ba800d6024a98)(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)).scrollIntoView());
        }
        return true;
    };
}




/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */ function $47959620e255098c$export$83e24c5933427696(config) {
    const { state: state, transaction: transaction } = config;
    let { selection: selection } = transaction;
    let { doc: doc } = transaction;
    let { storedMarks: storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks () {
            return storedMarks;
        },
        get selection () {
            return selection;
        },
        get doc () {
            return doc;
        },
        get tr () {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        }
    };
}
class $47959620e255098c$export$475014de15a4c342 {
    constructor(props){
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const { tr: tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            const method = (...args)=>{
                const callback = command(...args)(props);
                if (!tr.getMeta("preventDispatch") && !this.hasCustomState) view.dispatch(tr);
                return callback;
            };
            return [
                name,
                method
            ];
        }));
    }
    get chain() {
        return ()=>this.createChain();
    }
    get can() {
        return ()=>this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = ()=>{
            if (!hasStartTransaction && shouldDispatch && !tr.getMeta("preventDispatch") && !this.hasCustomState) view.dispatch(tr);
            return callbacks.every((callback)=>callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                const chainedCommand = (...args)=>{
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [
                    name,
                    chainedCommand
                ];
            })),
            run: run
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands: rawCommands, state: state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            return [
                name,
                (...args)=>command(...args)({
                        ...props,
                        dispatch: undefined
                    })
            ];
        }));
        return {
            ...formattedCommands,
            chain: ()=>this.createChain(tr, dispatch)
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const props = {
            tr: tr,
            editor: editor,
            view: view,
            state: $47959620e255098c$export$83e24c5933427696({
                state: state,
                transaction: tr
            }),
            dispatch: shouldDispatch ? ()=>undefined : undefined,
            chain: ()=>this.createChain(tr, shouldDispatch),
            can: ()=>this.createCan(tr),
            get commands () {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                    return [
                        name,
                        (...args)=>command(...args)(props)
                    ];
                }));
            }
        };
        return props;
    }
}
class $47959620e255098c$var$EventEmitter {
    constructor(){
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) this.callbacks[event] = [];
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) callbacks.forEach((callback)=>callback.apply(this, args));
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) this.callbacks[event] = callbacks.filter((callback)=>callback !== fn);
            else delete this.callbacks[event];
        }
        return this;
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}
/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */ function $47959620e255098c$export$f73578b718a57eaa(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) return $47959620e255098c$export$f73578b718a57eaa(extension.parent, field, context);
    if (typeof extension.config[field] === "function") {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent ? $47959620e255098c$export$f73578b718a57eaa(extension.parent, field, context) : null
        });
        return value;
    }
    return extension.config[field];
}
function $47959620e255098c$export$36e8c2990da8266f(extensions) {
    const baseExtensions = extensions.filter((extension)=>extension.type === "extension");
    const nodeExtensions = extensions.filter((extension)=>extension.type === "node");
    const markExtensions = extensions.filter((extension)=>extension.type === "mark");
    return {
        baseExtensions: baseExtensions,
        nodeExtensions: nodeExtensions,
        markExtensions: markExtensions
    };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */ function $47959620e255098c$export$6e54e3e69d60df3d(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $47959620e255098c$export$36e8c2990da8266f(extensions);
    const nodeAndMarkExtensions = [
        ...nodeExtensions,
        ...markExtensions
    ];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false
    };
    extensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        const addGlobalAttributes = $47959620e255098c$export$f73578b718a57eaa(extension, "addGlobalAttributes", context);
        if (!addGlobalAttributes) return;
        // TODO: remove `as GlobalAttributes`
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach((globalAttribute)=>{
            globalAttribute.types.forEach((type)=>{
                Object.entries(globalAttribute.attributes).forEach(([name, attribute])=>{
                    extensionAttributes.push({
                        type: type,
                        name: name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute
                        }
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        const addAttributes = $47959620e255098c$export$f73578b718a57eaa(extension, "addAttributes", context);
        if (!addAttributes) return;
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object.entries(attributes).forEach(([name, attribute])=>{
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === "function") mergedAttr.default = mergedAttr.default();
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) delete mergedAttr.default;
            extensionAttributes.push({
                type: extension.name,
                name: name,
                attribute: mergedAttr
            });
        });
    });
    return extensionAttributes;
}
function $47959620e255098c$export$d168cba70360dd3d(nameOrType, schema) {
    if (typeof nameOrType === "string") {
        if (!schema.nodes[nameOrType]) throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}
function $47959620e255098c$export$9f98db6234c4bd78(...objects) {
    return objects.filter((item)=>!!item).reduce((items, item)=>{
        const mergedAttributes = {
            ...items
        };
        Object.entries(item).forEach(([key, value])=>{
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === "class") {
                const valueClasses = value ? value.split(" ") : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(" ") : [];
                const insertClasses = valueClasses.filter((valueClass)=>!existingClasses.includes(valueClass));
                mergedAttributes[key] = [
                    ...existingClasses,
                    ...insertClasses
                ].join(" ");
            } else if (key === "style") mergedAttributes[key] = [
                mergedAttributes[key],
                value
            ].join("; ");
            else mergedAttributes[key] = value;
        });
        return mergedAttributes;
    }, {});
}
function $47959620e255098c$export$bc79d84a417d7b02(nodeOrMark, extensionAttributes) {
    return extensionAttributes.filter((item)=>item.attribute.rendered).map((item)=>{
        if (!item.attribute.renderHTML) return {
            [item.name]: nodeOrMark.attrs[item.name]
        };
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    }).reduce((attributes, attribute)=>$47959620e255098c$export$9f98db6234c4bd78(attributes, attribute), {});
}
function $47959620e255098c$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */ function $47959620e255098c$export$592682234826c0bd(value, context, ...props) {
    if ($47959620e255098c$export$f6e2535fb5126e54(value)) {
        if (context) return value.bind(context)(...props);
        return value(...props);
    }
    return value;
}
function $47959620e255098c$export$83b788b1a3698c03(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}
function $47959620e255098c$export$3004f64547af360e(value) {
    if (typeof value !== "string") return value;
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) return Number(value);
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */ function $47959620e255098c$export$7ce6b571718439ec(parseRule, extensionAttributes) {
    if (parseRule.style) return parseRule;
    return {
        ...parseRule,
        getAttrs: (node)=>{
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) return false;
            const newAttributes = extensionAttributes.reduce((items, item)=>{
                const value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : $47959620e255098c$export$3004f64547af360e(node.getAttribute(item.name));
                if (value === null || value === undefined) return items;
                return {
                    ...items,
                    [item.name]: value
                };
            }, {});
            return {
                ...oldAttributes,
                ...newAttributes
            };
        }
    };
}
function $47959620e255098c$var$cleanUpSchemaItem(data) {
    return Object.fromEntries(// @ts-ignore
    Object.entries(data).filter(([key, value])=>{
        if (key === "attrs" && $47959620e255098c$export$83b788b1a3698c03(value)) return false;
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */ function $47959620e255098c$export$71bc12a97b59a858(extensions, editor) {
    var _a;
    const allAttributes = $47959620e255098c$export$6e54e3e69d60df3d(extensions);
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $47959620e255098c$export$36e8c2990da8266f(extensions);
    const topNode = (_a = nodeExtensions.find((extension)=>$47959620e255098c$export$f73578b718a57eaa(extension, "topNode"))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraNodeFields = extensions.reduce((fields, e)=>{
            const extendNodeSchema = $47959620e255098c$export$f73578b718a57eaa(e, "extendNodeSchema", context);
            return {
                ...fields,
                ...extendNodeSchema ? extendNodeSchema(extension) : {}
            };
        }, {});
        const schema = $47959620e255098c$var$cleanUpSchemaItem({
            ...extraNodeFields,
            content: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "content", context)),
            marks: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "marks", context)),
            group: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "group", context)),
            inline: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "inline", context)),
            atom: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "atom", context)),
            selectable: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "selectable", context)),
            draggable: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "draggable", context)),
            code: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "code", context)),
            defining: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "defining", context)),
            isolating: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "isolating", context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "parseHTML", context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$47959620e255098c$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $47959620e255098c$export$f73578b718a57eaa(extension, "renderHTML", context);
        if (renderHTML) schema.toDOM = (node)=>renderHTML({
                node: node,
                HTMLAttributes: $47959620e255098c$export$bc79d84a417d7b02(node, extensionAttributes)
            });
        const renderText = $47959620e255098c$export$f73578b718a57eaa(extension, "renderText", context);
        if (renderText) schema.toText = renderText;
        return [
            extension.name,
            schema
        ];
    }));
    const marks = Object.fromEntries(markExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraMarkFields = extensions.reduce((fields, e)=>{
            const extendMarkSchema = $47959620e255098c$export$f73578b718a57eaa(e, "extendMarkSchema", context);
            return {
                ...fields,
                ...extendMarkSchema ? extendMarkSchema(extension) : {}
            };
        }, {});
        const schema = $47959620e255098c$var$cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "inclusive", context)),
            excludes: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "excludes", context)),
            group: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "group", context)),
            spanning: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "spanning", context)),
            code: $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "code", context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "parseHTML", context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$47959620e255098c$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $47959620e255098c$export$f73578b718a57eaa(extension, "renderHTML", context);
        if (renderHTML) schema.toDOM = (mark)=>renderHTML({
                mark: mark,
                HTMLAttributes: $47959620e255098c$export$bc79d84a417d7b02(mark, extensionAttributes)
            });
        return [
            extension.name,
            schema
        ];
    }));
    return new (0, $d3a8f56ade4880df$export$19342e026b58ebb7)({
        topNode: topNode,
        nodes: nodes,
        marks: marks
    });
}
/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */ function $47959620e255098c$export$ea18268b31f54e5(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}
function $47959620e255098c$export$79b791167b05aada(extension, enabled) {
    if (Array.isArray(enabled)) return enabled.some((enabledExtension)=>{
        const name = typeof enabledExtension === "string" ? enabledExtension : enabledExtension.name;
        return name === extension.name;
    });
    return enabled;
}
/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */ const $47959620e255098c$export$a3e238086d556fa9 = ($from, maxMatch = 500)=>{
    let textBefore = "";
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index)=>{
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node: node,
            pos: pos,
            parent: parent,
            index: index
        })) || node.textContent || "%leaf%";
        textBefore += chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};
function $47959620e255098c$export$49841c62b9eff15(value) {
    return Object.prototype.toString.call(value) === "[object RegExp]";
}
class $47959620e255098c$export$9b55e2b000ad65f2 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $47959620e255098c$var$inputRuleMatcherHandler = (text, find)=>{
    if ($47959620e255098c$export$49841c62b9eff15(find)) return find.exec(text);
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) return null;
    const result = [
        inputRuleMatch.text
    ];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function $47959620e255098c$var$run$1(config) {
    var _a;
    const { editor: editor, from: from, to: to, text: text, rules: rules, plugin: plugin } = config;
    const { view: view } = editor;
    if (view.composing) return false;
    const $from = view.state.doc.resolve(from);
    if (// check for code node
    $from.parent.type.spec.code || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find((mark)=>mark.type.spec.code))) return false;
    let matched = false;
    const textBefore = $47959620e255098c$export$a3e238086d556fa9($from) + text;
    rules.forEach((rule)=>{
        if (matched) return;
        const match = $47959620e255098c$var$inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) return;
        const tr = view.state.tr;
        const state = $47959620e255098c$export$83e24c5933427696({
            state: view.state,
            transaction: tr
        });
        const range = {
            from: from - (match[0].length - text.length),
            to: to
        };
        const { commands: commands, chain: chain, can: can } = new $47959620e255098c$export$475014de15a4c342({
            editor: editor,
            state: state
        });
        const handler = rule.handler({
            state: state,
            range: range,
            match: match,
            commands: commands,
            chain: chain,
            can: can
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) return;
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from: from,
            to: to,
            text: text
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */ function $47959620e255098c$export$f2a821f78e918151(props) {
    const { editor: editor, rules: rules } = props;
    const plugin = new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(plugin);
                if (stored) return stored;
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta("applyInputRules");
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) setTimeout(()=>{
                    const { from: from, text: text } = simulatedInputMeta;
                    const to = from + text.length;
                    $47959620e255098c$var$run$1({
                        editor: editor,
                        from: from,
                        to: to,
                        text: text,
                        rules: rules,
                        plugin: plugin
                    });
                });
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                return $47959620e255098c$var$run$1({
                    editor: editor,
                    from: from,
                    to: to,
                    text: text,
                    rules: rules,
                    plugin: plugin
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const { $cursor: $cursor } = view.state.selection;
                        if ($cursor) $47959620e255098c$var$run$1({
                            editor: editor,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: "",
                            rules: rules,
                            plugin: plugin
                        });
                    });
                    return false;
                }
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown (view, event) {
                if (event.key !== "Enter") return false;
                const { $cursor: $cursor } = view.state.selection;
                if ($cursor) return $47959620e255098c$var$run$1({
                    editor: editor,
                    from: $cursor.pos,
                    to: $cursor.pos,
                    text: "\n",
                    rules: rules,
                    plugin: plugin
                });
                return false;
            }
        },
        // @ts-ignore
        isInputRules: true
    });
    return plugin;
}
function $47959620e255098c$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ class $47959620e255098c$export$e75df4392d073e98 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $47959620e255098c$var$pasteRuleMatcherHandler = (text, find, event)=>{
    if ($47959620e255098c$export$49841c62b9eff15(find)) return [
        ...text.matchAll(find)
    ];
    const matches = find(text, event);
    if (!matches) return [];
    return matches.map((pasteRuleMatch)=>{
        const result = [
            pasteRuleMatch.text
        ];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function $47959620e255098c$var$run(config) {
    const { editor: editor, state: state, from: from, to: to, rule: rule, pasteEvent: pasteEvent, dropEvent: dropEvent } = config;
    const { commands: commands, chain: chain, can: can } = new $47959620e255098c$export$475014de15a4c342({
        editor: editor,
        state: state
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isTextblock || node.type.spec.code) return;
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, "\uFFFC");
        const matches = $47959620e255098c$var$pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach((match)=>{
            if (match.index === undefined) return;
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end)
            };
            const handler = rule.handler({
                state: state,
                range: range,
                match: match,
                commands: commands,
                chain: chain,
                can: can,
                pasteEvent: pasteEvent,
                dropEvent: dropEvent
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every((handler)=>handler !== null);
    return success;
}
const $47959620e255098c$var$createClipboardPasteEvent = (text)=>{
    var _a;
    const event = new ClipboardEvent("paste", {
        clipboardData: new DataTransfer()
    });
    (_a = event.clipboardData) === null || _a === void 0 || _a.setData("text/html", text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */ function $47959620e255098c$export$458282b0dddaaaa4(props) {
    const { editor: editor, rules: rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
    let dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
    const processEvent = ({ state: state, from: from, to: to, rule: rule, pasteEvt: pasteEvt })=>{
        const tr = state.tr;
        const chainableState = $47959620e255098c$export$83e24c5933427696({
            state: state,
            transaction: tr
        });
        const handler = $47959620e255098c$var$run({
            editor: editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule: rule,
            pasteEvent: pasteEvt,
            dropEvent: dropEvent
        });
        if (!handler || !tr.steps.length) return;
        dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
        pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
        return tr;
    };
    const plugins = rules.map((rule)=>{
        return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
            // we register a global drag handler to track the current drag source element
            view (view) {
                const handleDragstart = (event)=>{
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? view.dom.parentElement : null;
                };
                window.addEventListener("dragstart", handleDragstart);
                return {
                    destroy () {
                        window.removeEventListener("dragstart", handleDragstart);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event)=>{
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        return false;
                    },
                    paste: (_view, event)=>{
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData("text/html");
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes("data-pm-slice"));
                        return false;
                    }
                }
            },
            appendTransaction: (transactions, oldState, state)=>{
                const transaction = transactions[0];
                const isPaste = transaction.getMeta("uiEvent") === "paste" && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta("uiEvent") === "drop" && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta("applyPasteRules");
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) return;
                // Handle simulated paste
                if (isSimulatedPaste) {
                    const { from: from, text: text } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = $47959620e255098c$var$createClipboardPasteEvent(text);
                    return processEvent({
                        rule: rule,
                        state: state,
                        from: from,
                        to: {
                            b: to
                        },
                        pasteEvt: pasteEvt
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!$47959620e255098c$export$7e4aa119212bc614(from) || !to || from === to.b) return;
                return processEvent({
                    rule: rule,
                    state: state,
                    from: from,
                    to: to,
                    pasteEvt: pasteEvent
                });
            }
        });
    });
    return plugins;
}
function $47959620e255098c$export$15704658c784aef1(items) {
    const filtered = items.filter((el, index)=>items.indexOf(el) !== index);
    return [
        ...new Set(filtered)
    ];
}
class $47959620e255098c$var$ExtensionManager {
    constructor(extensions, editor){
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = $47959620e255098c$var$ExtensionManager.resolve(extensions);
        this.schema = $47959620e255098c$export$71bc12a97b59a858(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */ static resolve(extensions) {
        const resolvedExtensions = $47959620e255098c$var$ExtensionManager.sort($47959620e255098c$var$ExtensionManager.flatten(extensions));
        const duplicatedNames = $47959620e255098c$export$15704658c784aef1(resolvedExtensions.map((extension)=>extension.name));
        if (duplicatedNames.length) console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item)=>`'${item}'`).join(", ")}]. This can lead to issues.`);
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */ static flatten(extensions) {
        return extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage
            };
            const addExtensions = $47959620e255098c$export$f73578b718a57eaa(extension, "addExtensions", context);
            if (addExtensions) return [
                extension,
                ...this.flatten(addExtensions())
            ];
            return extension;
        })// `Infinity` will break TypeScript so we set a number that is probably high enough
        .flat(10);
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */ static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b)=>{
            const priorityA = $47959620e255098c$export$f73578b718a57eaa(a, "priority") || defaultPriority;
            const priorityB = $47959620e255098c$export$f73578b718a57eaa(b, "priority") || defaultPriority;
            if (priorityA > priorityB) return -1;
            if (priorityA < priorityB) return 1;
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */ get commands() {
        return this.extensions.reduce((commands, extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $47959620e255098c$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const addCommands = $47959620e255098c$export$f73578b718a57eaa(extension, "addCommands", context);
            if (!addCommands) return commands;
            return {
                ...commands,
                ...addCommands()
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */ get plugins() {
        const { editor: editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = $47959620e255098c$var$ExtensionManager.sort([
            ...this.extensions
        ].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $47959620e255098c$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const plugins = [];
            const addKeyboardShortcuts = $47959620e255098c$export$f73578b718a57eaa(extension, "addKeyboardShortcuts", context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === "mark" && extension.config.exitable) defaultBindings.ArrowRight = ()=>$47959620e255098c$export$c9d15bcfc6d42044.handleExit({
                    editor: editor,
                    mark: extension
                });
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method])=>{
                    return [
                        shortcut,
                        ()=>method({
                                editor: editor
                            })
                    ];
                }));
                defaultBindings = {
                    ...defaultBindings,
                    ...bindings
                };
            }
            const keyMapPlugin = (0, $54e5867f52850bef$export$5043418e2ef368d5)(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = $47959620e255098c$export$f73578b718a57eaa(extension, "addInputRules", context);
            if ($47959620e255098c$export$79b791167b05aada(extension, editor.options.enableInputRules) && addInputRules) inputRules.push(...addInputRules());
            const addPasteRules = $47959620e255098c$export$f73578b718a57eaa(extension, "addPasteRules", context);
            if ($47959620e255098c$export$79b791167b05aada(extension, editor.options.enablePasteRules) && addPasteRules) pasteRules.push(...addPasteRules());
            const addProseMirrorPlugins = $47959620e255098c$export$f73578b718a57eaa(extension, "addProseMirrorPlugins", context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        }).flat();
        return [
            $47959620e255098c$export$f2a821f78e918151({
                editor: editor,
                rules: inputRules
            }),
            ...$47959620e255098c$export$458282b0dddaaaa4({
                editor: editor,
                rules: pasteRules
            }),
            ...allPlugins
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */ get attributes() {
        return $47959620e255098c$export$6e54e3e69d60df3d(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */ get nodeViews() {
        const { editor: editor } = this;
        const { nodeExtensions: nodeExtensions } = $47959620e255098c$export$36e8c2990da8266f(this.extensions);
        return Object.fromEntries(nodeExtensions.filter((extension)=>!!$47959620e255098c$export$f73578b718a57eaa(extension, "addNodeView")).map((extension)=>{
            const extensionAttributes = this.attributes.filter((attribute)=>attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $47959620e255098c$export$d168cba70360dd3d(extension.name, this.schema)
            };
            const addNodeView = $47959620e255098c$export$f73578b718a57eaa(extension, "addNodeView", context);
            if (!addNodeView) return [];
            const nodeview = (node, view, getPos, decorations)=>{
                const HTMLAttributes = $47959620e255098c$export$bc79d84a417d7b02(node, extensionAttributes);
                return addNodeView()({
                    editor: editor,
                    node: node,
                    getPos: getPos,
                    decorations: decorations,
                    HTMLAttributes: HTMLAttributes,
                    extension: extension
                });
            };
            return [
                extension.name,
                nodeview
            ];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */ setupExtensions() {
        this.extensions.forEach((extension)=>{
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $47959620e255098c$export$ea18268b31f54e5(extension.name, this.schema)
            };
            if (extension.type === "mark") {
                const keepOnSplit = (_a = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "keepOnSplit", context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) this.splittableMarks.push(extension.name);
            }
            const onBeforeCreate = $47959620e255098c$export$f73578b718a57eaa(extension, "onBeforeCreate", context);
            const onCreate = $47959620e255098c$export$f73578b718a57eaa(extension, "onCreate", context);
            const onUpdate = $47959620e255098c$export$f73578b718a57eaa(extension, "onUpdate", context);
            const onSelectionUpdate = $47959620e255098c$export$f73578b718a57eaa(extension, "onSelectionUpdate", context);
            const onTransaction = $47959620e255098c$export$f73578b718a57eaa(extension, "onTransaction", context);
            const onFocus = $47959620e255098c$export$f73578b718a57eaa(extension, "onFocus", context);
            const onBlur = $47959620e255098c$export$f73578b718a57eaa(extension, "onBlur", context);
            const onDestroy = $47959620e255098c$export$f73578b718a57eaa(extension, "onDestroy", context);
            if (onBeforeCreate) this.editor.on("beforeCreate", onBeforeCreate);
            if (onCreate) this.editor.on("create", onCreate);
            if (onUpdate) this.editor.on("update", onUpdate);
            if (onSelectionUpdate) this.editor.on("selectionUpdate", onSelectionUpdate);
            if (onTransaction) this.editor.on("transaction", onTransaction);
            if (onFocus) this.editor.on("focus", onFocus);
            if (onBlur) this.editor.on("blur", onBlur);
            if (onDestroy) this.editor.on("destroy", onDestroy);
        });
    }
}
// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function $47959620e255098c$var$getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $47959620e255098c$export$53b83ca8eaab0383(value) {
    if ($47959620e255098c$var$getType(value) !== "Object") return false;
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function $47959620e255098c$export$dd702b3c8240390c(target, source) {
    const output = {
        ...target
    };
    if ($47959620e255098c$export$53b83ca8eaab0383(target) && $47959620e255098c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($47959620e255098c$export$53b83ca8eaab0383(source[key])) {
            if (!(key in target)) Object.assign(output, {
                [key]: source[key]
            });
            else output[key] = $47959620e255098c$export$dd702b3c8240390c(target[key], source[key]);
        } else Object.assign(output, {
            [key]: source[key]
        });
    });
    return output;
}
/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $47959620e255098c$export$eeddbf09bb970356 {
    constructor(config = {}){
        this.type = "extension";
        this.name = "extension";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $47959620e255098c$export$eeddbf09bb970356(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend();
        extension.parent = this.parent;
        extension.options = $47959620e255098c$export$dd702b3c8240390c(this.options, options);
        extension.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $47959620e255098c$export$eeddbf09bb970356({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */ function $47959620e255098c$export$6e5992a7455d9ef6(startNode, range, options) {
    const { from: from, to: to } = range;
    const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
    let text = "";
    startNode.nodesBetween(from, to, (node, pos, parent, index)=>{
        var _a;
        if (node.isBlock && pos > from) text += blockSeparator;
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) text += textSerializer({
                node: node,
                pos: pos,
                parent: parent,
                index: index,
                range: range
            });
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
    });
    return text;
}
/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */ function $47959620e255098c$export$fdd92b7d22ac071c(schema) {
    return Object.fromEntries(Object.entries(schema.nodes).filter(([, node])=>node.spec.toText).map(([name, node])=>[
            name,
            node.spec.toText
        ]));
}
const $47959620e255098c$var$ClipboardTextSerializer = $47959620e255098c$export$eeddbf09bb970356.create({
    name: "clipboardTextSerializer",
    addOptions () {
        return {
            blockSeparator: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
                key: new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("clipboardTextSerializer"),
                props: {
                    clipboardTextSerializer: ()=>{
                        const { editor: editor } = this;
                        const { state: state, schema: schema } = editor;
                        const { doc: doc, selection: selection } = state;
                        const { ranges: ranges } = selection;
                        const from = Math.min(...ranges.map((range)=>range.$from.pos));
                        const to = Math.max(...ranges.map((range)=>range.$to.pos));
                        const textSerializers = $47959620e255098c$export$fdd92b7d22ac071c(schema);
                        const range = {
                            from: from,
                            to: to
                        };
                        return $47959620e255098c$export$6e5992a7455d9ef6(doc, range, {
                            ...this.options.blockSeparator !== undefined ? {
                                blockSeparator: this.options.blockSeparator
                            } : {},
                            textSerializers: textSerializers
                        });
                    }
                }
            })
        ];
    }
});
const $47959620e255098c$var$blur = ()=>({ editor: editor, view: view })=>{
        requestAnimationFrame(()=>{
            var _a;
            if (!editor.isDestroyed) {
                view.dom.blur();
                // Browsers should remove the caret on blur but safari does not.
                // See: https://github.com/ueberdosis/tiptap/issues/2405
                (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 || _a.removeAllRanges();
            }
        });
        return true;
    };
const $47959620e255098c$var$clearContent = (emitUpdate = false)=>({ commands: commands })=>{
        return commands.setContent("", emitUpdate);
    };
const $47959620e255098c$var$clearNodes = ()=>({ state: state, tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { ranges: ranges } = selection;
        if (!dispatch) return true;
        ranges.forEach(({ $from: $from, $to: $to })=>{
            state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (node.type.isText) return;
                const { doc: doc, mapping: mapping } = tr;
                const $mappedFrom = doc.resolve(mapping.map(pos));
                const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
                const nodeRange = $mappedFrom.blockRange($mappedTo);
                if (!nodeRange) return;
                const targetLiftDepth = (0, $82f7355673365313$export$f1508b72cc76a09e)(nodeRange);
                if (node.type.isTextblock) {
                    const { defaultType: defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                    tr.setNodeMarkup(nodeRange.start, defaultType);
                }
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(nodeRange, targetLiftDepth);
            });
        });
        return true;
    };
const $47959620e255098c$var$command = (fn)=>(props)=>{
        return fn(props);
    };
const $47959620e255098c$var$createParagraphNear = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$d0f80ac1b4510888)(state, dispatch);
    };
const $47959620e255098c$var$cut = (originRange, targetPos)=>({ editor: editor, tr: tr })=>{
        const { state: state } = editor;
        const contentSlice = state.doc.slice(originRange.from, originRange.to);
        tr.deleteRange(originRange.from, originRange.to);
        const newPos = tr.mapping.map(targetPos);
        tr.insert(newPos, contentSlice.content);
        tr.setSelection(new (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)(tr.doc.resolve(newPos - 1)));
        return true;
    };
const $47959620e255098c$var$deleteCurrentNode = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const currentNode = selection.$anchor.node();
        // if there is content inside the current node, break out of this command
        if (currentNode.content.size > 0) return false;
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === currentNode.type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $47959620e255098c$var$deleteNode = (typeOrName)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $47959620e255098c$var$deleteRange = (range)=>({ tr: tr, dispatch: dispatch })=>{
        const { from: from, to: to } = range;
        if (dispatch) tr.delete(from, to);
        return true;
    };
const $47959620e255098c$var$deleteSelection = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$e9a518a637d1e641)(state, dispatch);
    };
const $47959620e255098c$var$enter = ()=>({ commands: commands })=>{
        return commands.keyboardShortcut("Enter");
    };
const $47959620e255098c$var$exitCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$634b78845598ff5b)(state, dispatch);
    };
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */ function $47959620e255098c$export$7aeb68f71172641d(object1, object2, options = {
    strict: true
}) {
    const keys = Object.keys(object2);
    if (!keys.length) return true;
    return keys.every((key)=>{
        if (options.strict) return object2[key] === object1[key];
        if ($47959620e255098c$export$49841c62b9eff15(object2[key])) return object2[key].test(object1[key]);
        return object2[key] === object1[key];
    });
}
function $47959620e255098c$var$findMarkInSet(marks, type, attributes = {}) {
    return marks.find((item)=>{
        return item.type === type && $47959620e255098c$export$7aeb68f71172641d(item.attrs, attributes);
    });
}
function $47959620e255098c$var$isMarkInSet(marks, type, attributes = {}) {
    return !!$47959620e255098c$var$findMarkInSet(marks, type, attributes);
}
function $47959620e255098c$export$8ceae6d06f5c4df5($pos, type, attributes = {}) {
    if (!$pos || !type) return;
    let start = $pos.parent.childAfter($pos.parentOffset);
    if ($pos.parentOffset === start.offset && start.offset !== 0) start = $pos.parent.childBefore($pos.parentOffset);
    if (!start.node) return;
    const mark = $47959620e255098c$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    if (!mark) return;
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    $47959620e255098c$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    while(startIndex > 0 && mark.isInSet($pos.parent.child(startIndex - 1).marks)){
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while(endIndex < $pos.parent.childCount && $47959620e255098c$var$isMarkInSet([
        ...$pos.parent.child(endIndex).marks
    ], type, attributes)){
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos
    };
}
function $47959620e255098c$export$b1269d6bf6e491ec(nameOrType, schema) {
    if (typeof nameOrType === "string") {
        if (!schema.marks[nameOrType]) throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.marks[nameOrType];
    }
    return nameOrType;
}
const $47959620e255098c$var$extendMarkRange = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { doc: doc, selection: selection } = tr;
        const { $from: $from, from: from, to: to } = selection;
        if (dispatch) {
            const range = $47959620e255098c$export$8ceae6d06f5c4df5($from, type, attributes);
            if (range && range.from <= from && range.to >= to) {
                const newSelection = (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(doc, range.from, range.to);
                tr.setSelection(newSelection);
            }
        }
        return true;
    };
const $47959620e255098c$var$first = (commands)=>(props)=>{
        const items = typeof commands === "function" ? commands(props) : commands;
        for(let i = 0; i < items.length; i += 1){
            if (items[i](props)) return true;
        }
        return false;
    };
function $47959620e255098c$export$38b50bf35e79aaf3(value) {
    return value instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb);
}
function $47959620e255098c$export$6fb785c609d82593(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}
function $47959620e255098c$export$225b0233b78e0d61(doc, position = null) {
    if (!position) return null;
    const selectionAtStart = (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).atStart(doc);
    const selectionAtEnd = (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).atEnd(doc);
    if (position === "start" || position === true) return selectionAtStart;
    if (position === "end") return selectionAtEnd;
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === "all") return (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(doc, $47959620e255098c$export$6fb785c609d82593(0, minPos, maxPos), $47959620e255098c$export$6fb785c609d82593(doc.content.size, minPos, maxPos));
    return (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(doc, $47959620e255098c$export$6fb785c609d82593(position, minPos, maxPos), $47959620e255098c$export$6fb785c609d82593(position, minPos, maxPos));
}
function $47959620e255098c$export$86c1a3f9ab33da5c() {
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const $47959620e255098c$var$focus = (position = null, options = {})=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        options = {
            scrollIntoView: true,
            ...options
        };
        const delayedFocus = ()=>{
            // focus within `requestAnimationFrame` breaks focus on iOS
            // so we have to call this
            if ($47959620e255098c$export$86c1a3f9ab33da5c()) view.dom.focus();
            // For React we have to focus asynchronously. Otherwise wild things happen.
            // see: https://github.com/ueberdosis/tiptap/issues/1520
            requestAnimationFrame(()=>{
                if (!editor.isDestroyed) {
                    view.focus();
                    if (options === null || options === void 0 ? void 0 : options.scrollIntoView) editor.commands.scrollIntoView();
                }
            });
        };
        if (view.hasFocus() && position === null || position === false) return true;
        // we don’t try to resolve a NodeSelection or CellSelection
        if (dispatch && position === null && !$47959620e255098c$export$38b50bf35e79aaf3(editor.state.selection)) {
            delayedFocus();
            return true;
        }
        // pass through tr.doc instead of editor.state.doc
        // since transactions could change the editors state before this command has been run
        const selection = $47959620e255098c$export$225b0233b78e0d61(tr.doc, position) || editor.state.selection;
        const isSameSelection = editor.state.selection.eq(selection);
        if (dispatch) {
            if (!isSameSelection) tr.setSelection(selection);
            // `tr.setSelection` resets the stored marks
            // so we’ll restore them if the selection is the same as before
            if (isSameSelection && tr.storedMarks) tr.setStoredMarks(tr.storedMarks);
            delayedFocus();
        }
        return true;
    };
const $47959620e255098c$var$forEach = (items, fn)=>(props)=>{
        return items.every((item, index)=>fn(item, {
                ...props,
                index: index
            }));
    };
const $47959620e255098c$var$insertContent = (value, options)=>({ tr: tr, commands: commands })=>{
        return commands.insertContentAt({
            from: tr.selection.from,
            to: tr.selection.to
        }, value, options);
    };
const $47959620e255098c$var$removeWhitespaces = (node)=>{
    const children = node.childNodes;
    for(let i = children.length - 1; i >= 0; i -= 1){
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
        else if (child.nodeType === 1) $47959620e255098c$var$removeWhitespaces(child);
    }
    return node;
};
function $47959620e255098c$export$1b93bf03550cde01(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
    return $47959620e255098c$var$removeWhitespaces(html);
}
/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */ function $47959620e255098c$export$12c64e96dddaee61(content, schema, options) {
    options = {
        slice: true,
        parseOptions: {},
        ...options
    };
    const isJSONContent = typeof content === "object" && content !== null;
    const isTextContent = typeof content === "string";
    if (isJSONContent) try {
        const isArrayContent = Array.isArray(content) && content.length > 0;
        // if the JSON Content is an array of nodes, create a fragment for each node
        if (isArrayContent) return (0, $d3a8f56ade4880df$export$ffb0004e005737fa).fromArray(content.map((item)=>schema.nodeFromJSON(item)));
        return schema.nodeFromJSON(content);
    } catch (error) {
        console.warn("[tiptap warn]: Invalid content.", "Passed value:", content, "Error:", error);
        return $47959620e255098c$export$12c64e96dddaee61("", schema, options);
    }
    if (isTextContent) {
        const parser = (0, $d3a8f56ade4880df$export$1059c6e7d2ce5669).fromSchema(schema);
        return options.slice ? parser.parseSlice($47959620e255098c$export$1b93bf03550cde01(content), options.parseOptions).content : parser.parse($47959620e255098c$export$1b93bf03550cde01(content), options.parseOptions);
    }
    return $47959620e255098c$export$12c64e96dddaee61("", schema, options);
}
// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function $47959620e255098c$export$bf93acd215057ab0(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) return;
    const step = tr.steps[last];
    if (!(step instanceof (0, $82f7355673365313$export$5c860b2e74034756) || step instanceof (0, $82f7355673365313$export$444ba800d6024a98))) return;
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end === 0) end = newTo;
    });
    tr.setSelection((0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near(tr.doc.resolve(end), bias));
}
const $47959620e255098c$var$isFragment = (nodeOrFragment)=>{
    return nodeOrFragment.toString().startsWith("<");
};
const $47959620e255098c$var$insertContentAt = (position, value, options)=>({ tr: tr, dispatch: dispatch, editor: editor })=>{
        if (dispatch) {
            options = {
                parseOptions: {},
                updateSelection: true,
                applyInputRules: false,
                applyPasteRules: false,
                ...options
            };
            const content = $47959620e255098c$export$12c64e96dddaee61(value, editor.schema, {
                parseOptions: {
                    preserveWhitespace: "full",
                    ...options.parseOptions
                }
            });
            // don’t dispatch an empty fragment because this can lead to strange errors
            if (content.toString() === "<>") return true;
            let { from: from, to: to } = typeof position === "number" ? {
                from: position,
                to: position
            } : {
                from: position.from,
                to: position.to
            };
            let isOnlyTextContent = true;
            let isOnlyBlockContent = true;
            const nodes = $47959620e255098c$var$isFragment(content) ? content : [
                content
            ];
            nodes.forEach((node)=>{
                // check if added node is valid
                node.check();
                isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
                isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
            });
            // check if we can replace the wrapping node by
            // the newly inserted content
            // example:
            // replace an empty paragraph by an inserted image
            // instead of inserting the image below the paragraph
            if (from === to && isOnlyBlockContent) {
                const { parent: parent } = tr.doc.resolve(from);
                const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
                if (isEmptyTextBlock) {
                    from -= 1;
                    to += 1;
                }
            }
            let newContent;
            // if there is only plain text we have to use `insertText`
            // because this will keep the current marks
            if (isOnlyTextContent) {
                // if value is string, we can use it directly
                // otherwise if it is an array, we have to join it
                if (Array.isArray(value)) newContent = value.map((v)=>v.text || "").join("");
                else if (typeof value === "object" && !!value && !!value.text) newContent = value.text;
                else newContent = value;
                tr.insertText(newContent, from, to);
            } else {
                newContent = content;
                tr.replaceWith(from, to, newContent);
            }
            // set cursor at end of inserted content
            if (options.updateSelection) $47959620e255098c$export$bf93acd215057ab0(tr, tr.steps.length - 1, -1);
            if (options.applyInputRules) tr.setMeta("applyInputRules", {
                from: from,
                text: newContent
            });
            if (options.applyPasteRules) tr.setMeta("applyPasteRules", {
                from: from,
                text: newContent
            });
        }
        return true;
    };
const $47959620e255098c$var$joinUp = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$4bb15e6d4372b393)(state, dispatch);
    };
const $47959620e255098c$var$joinDown = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$8dd967a262b064bb)(state, dispatch);
    };
const $47959620e255098c$var$joinBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$979097b097459299)(state, dispatch);
    };
const $47959620e255098c$var$joinForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$bf432e340007f9ef)(state, dispatch);
    };
const $47959620e255098c$var$joinItemBackward = ()=>({ tr: tr, state: state, dispatch: dispatch })=>{
        try {
            const point = (0, $82f7355673365313$export$41b1d4cb5ceb3147)(state.doc, state.selection.$from.pos, -1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $47959620e255098c$var$joinItemForward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $82f7355673365313$export$41b1d4cb5ceb3147)(state.doc, state.selection.$from.pos, 1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch (e) {
            return false;
        }
    };
const $47959620e255098c$var$joinTextblockBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$1dce4f5c74f5f90f)(state, dispatch);
    };
const $47959620e255098c$var$joinTextblockForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$e796bb96d22be2cd)(state, dispatch);
    };
function $47959620e255098c$export$6159e43e50a41987() {
    return typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
}
function $47959620e255098c$var$normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === "Space") result = " ";
    let alt;
    let ctrl;
    let shift;
    let meta;
    for(let i = 0; i < parts.length - 1; i += 1){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($47959620e255098c$export$86c1a3f9ab33da5c() || $47959620e255098c$export$6159e43e50a41987()) meta = true;
            else ctrl = true;
        } else throw new Error(`Unrecognized modifier name: ${mod}`);
    }
    if (alt) result = `Alt-${result}`;
    if (ctrl) result = `Ctrl-${result}`;
    if (meta) result = `Meta-${result}`;
    if (shift) result = `Shift-${result}`;
    return result;
}
const $47959620e255098c$var$keyboardShortcut = (name)=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        const keys = $47959620e255098c$var$normalizeKeyName(name).split(/-(?!$)/);
        const key = keys.find((item)=>![
                "Alt",
                "Ctrl",
                "Meta",
                "Shift"
            ].includes(item));
        const event = new KeyboardEvent("keydown", {
            key: key === "Space" ? " " : key,
            altKey: keys.includes("Alt"),
            ctrlKey: keys.includes("Ctrl"),
            metaKey: keys.includes("Meta"),
            shiftKey: keys.includes("Shift"),
            bubbles: true,
            cancelable: true
        });
        const capturedTransaction = editor.captureTransaction(()=>{
            view.someProp("handleKeyDown", (f)=>f(view, event));
        });
        capturedTransaction === null || capturedTransaction === void 0 || capturedTransaction.steps.forEach((step)=>{
            const newStep = step.map(tr.mapping);
            if (newStep && dispatch) tr.maybeStep(newStep);
        });
        return true;
    };
function $47959620e255098c$export$7a24a642b0c7ad29(state, typeOrName, attributes = {}) {
    const { from: from, to: to, empty: empty } = state.selection;
    const type = typeOrName ? $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isText) return;
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node: node,
            from: relativeFrom,
            to: relativeTo
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges.filter((nodeRange)=>{
        if (!type) return true;
        return type.name === nodeRange.node.type.name;
    }).filter((nodeRange)=>$47959620e255098c$export$7aeb68f71172641d(nodeRange.node.attrs, attributes, {
            strict: false
        }));
    if (empty) return !!matchedNodeRanges.length;
    const range = matchedNodeRanges.reduce((sum, nodeRange)=>sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}
const $47959620e255098c$var$lift = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $47959620e255098c$export$7a24a642b0c7ad29(state, type, attributes);
        if (!isActive) return false;
        return (0, $0e30e03a0c1ecd8e$export$590e8b2c435046d9)(state, dispatch);
    };
const $47959620e255098c$var$liftEmptyBlock = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$a3574cc681852c08)(state, dispatch);
    };
const $47959620e255098c$var$liftListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $62b287a5b09222dc$export$e74cd5adb935a538)(type)(state, dispatch);
    };
const $47959620e255098c$var$newlineInCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$a5d02b4b65e94f91)(state, dispatch);
    };
/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */ function $47959620e255098c$export$e501dfcf737a48e0(name, schema) {
    if (schema.nodes[name]) return "node";
    if (schema.marks[name]) return "mark";
    return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */ function $47959620e255098c$export$8694e5c03a4df8e6(obj, propOrProps) {
    const props = typeof propOrProps === "string" ? [
        propOrProps
    ] : propOrProps;
    return Object.keys(obj).reduce((newObj, prop)=>{
        if (!props.includes(prop)) newObj[prop] = obj[prop];
        return newObj;
    }, {});
}
const $47959620e255098c$var$resetAttributes = (typeOrName, attributes)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $47959620e255098c$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === "node") nodeType = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === "mark") markType = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, $47959620e255098c$export$8694e5c03a4df8e6(node.attrs, attributes));
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(pos, pos + node.nodeSize, markType.create($47959620e255098c$export$8694e5c03a4df8e6(mark.attrs, attributes)));
                });
            });
        });
        return true;
    };
const $47959620e255098c$var$scrollIntoView = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) tr.scrollIntoView();
        return true;
    };
const $47959620e255098c$var$selectAll = ()=>({ tr: tr, commands: commands })=>{
        return commands.setTextSelection({
            from: 0,
            to: tr.doc.content.size
        });
    };
const $47959620e255098c$var$selectNodeBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$52b8a4af68d19794)(state, dispatch);
    };
const $47959620e255098c$var$selectNodeForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$5835b52680b80cfd)(state, dispatch);
    };
const $47959620e255098c$var$selectParentNode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$a37f6aaa9169911d)(state, dispatch);
    };
// @ts-ignore
const $47959620e255098c$var$selectTextblockEnd = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$a66c1876556415e5)(state, dispatch);
    };
// @ts-ignore
const $47959620e255098c$var$selectTextblockStart = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $0e30e03a0c1ecd8e$export$c3a64f3c9604a1b1)(state, dispatch);
    };
/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */ function $47959620e255098c$export$37330def6e48b4c9(content, schema, parseOptions = {}) {
    return $47959620e255098c$export$12c64e96dddaee61(content, schema, {
        slice: false,
        parseOptions: parseOptions
    });
}
const $47959620e255098c$var$setContent = (content, emitUpdate = false, parseOptions = {})=>({ tr: tr, editor: editor, dispatch: dispatch })=>{
        const { doc: doc } = tr;
        const document1 = $47959620e255098c$export$37330def6e48b4c9(content, editor.schema, parseOptions);
        if (dispatch) tr.replaceWith(0, doc.content.size, document1).setMeta("preventUpdate", !emitUpdate);
        return true;
    };
function $47959620e255098c$export$2cd1d0e1f861bae0(state, typeOrName) {
    const type = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
    const { from: from, to: to, empty: empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) marks.push(...state.storedMarks);
        marks.push(...state.selection.$head.marks());
    } else state.doc.nodesBetween(from, to, (node)=>{
        marks.push(...node.marks);
    });
    const mark = marks.find((markItem)=>markItem.type.name === type.name);
    if (!mark) return {};
    return {
        ...mark.attrs
    };
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */ function $47959620e255098c$export$f945f1716a5df33d(oldDoc, transactions) {
    const transform = new (0, $82f7355673365313$export$563a914cafbdc389)(oldDoc);
    transactions.forEach((transaction)=>{
        transaction.steps.forEach((step)=>{
            transform.step(step);
        });
    });
    return transform;
}
/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */ function $47959620e255098c$export$6133a2de0e8ac885(match) {
    for(let i = 0; i < match.edgeCount; i += 1){
        const { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $47959620e255098c$export$f94ca194e830789c(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $47959620e255098c$export$6a2a251dde98a23(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */ function $47959620e255098c$export$fe09644e3bc6166b($pos, predicate) {
    for(let i = $pos.depth; i > 0; i -= 1){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
}
/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */ function $47959620e255098c$export$dc159056ffdb4c76(predicate) {
    return (selection)=>$47959620e255098c$export$fe09644e3bc6166b(selection.$from, predicate);
}
function $47959620e255098c$export$d1b60002472b2c81(fragment, schema) {
    const documentFragment = (0, $d3a8f56ade4880df$export$3476b78f8f5a8b72).fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement("div");
    container.appendChild(documentFragment);
    return container.innerHTML;
}
function $47959620e255098c$export$19a621270f26273c(extensions, editor) {
    const resolvedExtensions = $47959620e255098c$var$ExtensionManager.resolve(extensions);
    return $47959620e255098c$export$71bc12a97b59a858(resolvedExtensions, editor);
}
/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */ function $47959620e255098c$export$4f413073eb19378c(doc, extensions) {
    const schema = $47959620e255098c$export$19a621270f26273c(extensions);
    const contentNode = (0, $d3a8f56ade4880df$export$85c928794f8d04d4).fromJSON(schema, doc);
    return $47959620e255098c$export$d1b60002472b2c81(contentNode.content, schema);
}
/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */ function $47959620e255098c$export$d23738d50f257f47(html, extensions) {
    const schema = $47959620e255098c$export$19a621270f26273c(extensions);
    const dom = $47959620e255098c$export$1b93bf03550cde01(html);
    return (0, $d3a8f56ade4880df$export$1059c6e7d2ce5669).fromSchema(schema).parse(dom).toJSON();
}
/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */ function $47959620e255098c$export$c72d34660a162238(node, options) {
    const range = {
        from: 0,
        to: node.content.size
    };
    return $47959620e255098c$export$6e5992a7455d9ef6(node, range, options);
}
/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */ function $47959620e255098c$export$43625cf01e0b7b62(doc, extensions, options) {
    const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
    const schema = $47959620e255098c$export$19a621270f26273c(extensions);
    const contentNode = (0, $d3a8f56ade4880df$export$85c928794f8d04d4).fromJSON(schema, doc);
    return $47959620e255098c$export$c72d34660a162238(contentNode, {
        blockSeparator: blockSeparator,
        textSerializers: {
            ...$47959620e255098c$export$fdd92b7d22ac071c(schema),
            ...textSerializers
        }
    });
}
function $47959620e255098c$export$e8c6736926dcac42(state, typeOrName) {
    const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
    const { from: from, to: to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, (node)=>{
        nodes.push(node);
    });
    const node = nodes.reverse().find((nodeItem)=>nodeItem.type.name === type.name);
    if (!node) return {};
    return {
        ...node.attrs
    };
}
/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */ function $47959620e255098c$export$fe94072fee8a6976(state, typeOrName) {
    const schemaType = $47959620e255098c$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === "node") return $47959620e255098c$export$e8c6736926dcac42(state, typeOrName);
    if (schemaType === "mark") return $47959620e255098c$export$2cd1d0e1f861bae0(state, typeOrName);
    return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */ function $47959620e255098c$export$2e2262a44ac61957(array, by = JSON.stringify) {
    const seen = {};
    return array.filter((item)=>{
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
    });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */ function $47959620e255098c$var$simplifyChangedRanges(changes) {
    const uniqueChanges = $47959620e255098c$export$2e2262a44ac61957(changes);
    return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index)=>{
        const rest = uniqueChanges.filter((_, i)=>i !== index);
        return !rest.some((otherChange)=>{
            return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
        });
    });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */ function $47959620e255098c$export$ba396fc65ff2f439(transform) {
    const { mapping: mapping, steps: steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index)=>{
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from: from, to: to } = steps[index];
            if (from === undefined || to === undefined) return;
            ranges.push({
                from: from,
                to: to
            });
        } else stepMap.forEach((from, to)=>{
            ranges.push({
                from: from,
                to: to
            });
        });
        ranges.forEach(({ from: from, to: to })=>{
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd
                },
                newRange: {
                    from: newStart,
                    to: newEnd
                }
            });
        });
    });
    return $47959620e255098c$var$simplifyChangedRanges(changes);
}
function $47959620e255098c$export$d661e0733145fb37(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map((mark)=>{
        const output = {
            type: mark.type.name
        };
        if (Object.keys(mark.attrs).length) output.attrs = {
            ...mark.attrs
        };
        return output;
    });
    const attrs = {
        ...node.attrs
    };
    const output = {
        type: node.type.name,
        from: from,
        to: to
    };
    if (Object.keys(attrs).length) output.attrs = attrs;
    if (marks.length) output.marks = marks;
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset)=>{
            var _a;
            (_a = output.content) === null || _a === void 0 || _a.push($47959620e255098c$export$d661e0733145fb37(child, startOffset + offset + increment));
        });
    }
    if (node.text) output.text = node.text;
    return output;
}
function $47959620e255098c$export$c5fd7af7c5c1efa(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) doc.resolve(from).marks().forEach((mark)=>{
        const $pos = doc.resolve(from - 1);
        const range = $47959620e255098c$export$8ceae6d06f5c4df5($pos, mark.type);
        if (!range) return;
        marks.push({
            mark: mark,
            ...range
        });
    });
    else doc.nodesBetween(from, to, (node, pos)=>{
        if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) return;
        marks.push(...node.marks.map((mark)=>({
                from: pos,
                to: pos + node.nodeSize,
                mark: mark
            })));
    });
    return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */ const $47959620e255098c$export$ee90757e11fae7cd = (state, typeOrName, pos, maxDepth = 20)=>{
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while(currentDepth > 0 && node === null){
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) node = currentNode;
        else currentDepth -= 1;
    }
    return [
        node,
        currentDepth
    ];
};
/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */ function $47959620e255098c$export$49b565bbca5fba3a(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object.entries(attributes).filter(([name])=>{
        const extensionAttribute = extensionAttributes.find((item)=>{
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) return false;
        return extensionAttribute.attribute.keepOnSplit;
    }));
}
function $47959620e255098c$export$72001287e2a5b413(state, typeOrName, attributes = {}) {
    const { empty: empty, ranges: ranges } = state.selection;
    const type = typeOrName ? $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema) : null;
    if (empty) return !!(state.storedMarks || state.selection.$from.marks()).filter((mark)=>{
        if (!type) return true;
        return type.name === mark.type.name;
    }).find((mark)=>$47959620e255098c$export$7aeb68f71172641d(mark.attrs, attributes, {
            strict: false
        }));
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from: $from, $to: $to })=>{
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isText && !node.marks.length) return;
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map((mark)=>({
                    mark: mark,
                    from: relativeFrom,
                    to: relativeTo
                })));
        });
    });
    if (selectionRange === 0) return false;
    // calculate range of matched mark
    const matchedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return type.name === markRange.mark.type.name;
    }).filter((markRange)=>$47959620e255098c$export$7aeb68f71172641d(markRange.mark.attrs, attributes, {
            strict: false
        })).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    }).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}
function $47959620e255098c$export$39e04e72f972b885(state, name, attributes = {}) {
    if (!name) return $47959620e255098c$export$7a24a642b0c7ad29(state, null, attributes) || $47959620e255098c$export$72001287e2a5b413(state, null, attributes);
    const schemaType = $47959620e255098c$export$e501dfcf737a48e0(name, state.schema);
    if (schemaType === "node") return $47959620e255098c$export$7a24a642b0c7ad29(state, name, attributes);
    if (schemaType === "mark") return $47959620e255098c$export$72001287e2a5b413(state, name, attributes);
    return false;
}
const $47959620e255098c$export$6a042f9d56fb39ec = (state, nodeType)=>{
    const { $from: $from, $to: $to, $anchor: $anchor } = state.selection;
    if (nodeType) {
        const parentNode = $47959620e255098c$export$dc159056ffdb4c76((node)=>node.type.name === nodeType)(state.selection);
        if (!parentNode) return false;
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) return true;
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) return false;
    return true;
};
const $47959620e255098c$export$d0aa6c7595396956 = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) return false;
    return true;
};
function $47959620e255098c$export$ead95ff48ba53ffd(name, extensions) {
    const { nodeExtensions: nodeExtensions } = $47959620e255098c$export$36e8c2990da8266f(extensions);
    const extension = nodeExtensions.find((item)=>item.name === name);
    if (!extension) return false;
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage
    };
    const group = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "group", context));
    if (typeof group !== "string") return false;
    return group.split(" ").includes("list");
}
function $47959620e255098c$export$cd58ff1081f6abe9(node) {
    var _a;
    const defaultContent = (_a = node.type.createAndFill()) === null || _a === void 0 ? void 0 : _a.toJSON();
    const content = node.toJSON();
    return JSON.stringify(defaultContent) === JSON.stringify(content);
}
function $47959620e255098c$export$a8c1d2c13abf8822(value) {
    return value instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b);
}
function $47959620e255098c$export$660ecae6cde71645(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = $47959620e255098c$export$6fb785c609d82593(from, minPos, maxPos);
    const resolvedEnd = $47959620e255098c$export$6fb785c609d82593(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        x: x,
        y: y
    };
    return {
        ...data,
        toJSON: ()=>data
    };
}
function $47959620e255098c$var$canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection: selection } = tr;
    let cursor = null;
    if ($47959620e255098c$export$38b50bf35e79aaf3(selection)) cursor = selection.$cursor;
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark)=>mark.type.excludes(newMarkType));
    }
    const { ranges: ranges } = selection;
    return ranges.some(({ $from: $from, $to: $to })=>{
        let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent)=>{
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) return false;
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark)=>otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const $47959620e255098c$var$setMark = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        const type = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) {
            if (empty) {
                const oldAttributes = $47959620e255098c$export$2cd1d0e1f861bae0(state, type);
                tr.addStoredMark(type.create({
                    ...oldAttributes,
                    ...attributes
                }));
            } else ranges.forEach((range)=>{
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find((mark)=>mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) node.marks.forEach((mark)=>{
                        if (type === mark.type) tr.addMark(trimmedFrom, trimmedTo, type.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    });
                    else tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                });
            });
        }
        return $47959620e255098c$var$canSetMark(state, tr, type);
    };
const $47959620e255098c$var$setMeta = (key, value)=>({ tr: tr })=>{
        tr.setMeta(key, value);
        return true;
    };
const $47959620e255098c$var$setNode = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch, chain: chain })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        // TODO: use a fallback like insertContent?
        if (!type.isTextblock) {
            console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
            return false;
        }
        return chain()// try to convert node to default node if needed
        .command(({ commands: commands })=>{
            const canSetBlock = (0, $0e30e03a0c1ecd8e$export$36987f561c736aad)(type, attributes)(state);
            if (canSetBlock) return true;
            return commands.clearNodes();
        }).command(({ state: updatedState })=>{
            return (0, $0e30e03a0c1ecd8e$export$36987f561c736aad)(type, attributes)(updatedState, dispatch);
        }).run();
    };
const $47959620e255098c$var$setNodeSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const from = $47959620e255098c$export$6fb785c609d82593(position, 0, doc.content.size);
            const selection = (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(doc, from);
            tr.setSelection(selection);
        }
        return true;
    };
const $47959620e255098c$var$setTextSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const { from: from, to: to } = typeof position === "number" ? {
                from: position,
                to: position
            } : position;
            const minPos = (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).atStart(doc).from;
            const maxPos = (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).atEnd(doc).to;
            const resolvedFrom = $47959620e255098c$export$6fb785c609d82593(from, minPos, maxPos);
            const resolvedEnd = $47959620e255098c$export$6fb785c609d82593(to, minPos, maxPos);
            const selection = (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(doc, resolvedFrom, resolvedEnd);
            tr.setSelection(selection);
        }
        return true;
    };
const $47959620e255098c$var$sinkListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $62b287a5b09222dc$export$dd505f850a3798a4)(type)(state, dispatch);
    };
function $47959620e255098c$var$ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) {
        const filteredMarks = marks.filter((mark)=>splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const $47959620e255098c$var$splitBlock = ({ keepMarks: keepMarks = true } = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        const { selection: selection, doc: doc } = tr;
        const { $from: $from, $to: $to } = selection;
        const extensionAttributes = editor.extensionManager.attributes;
        const newAttributes = $47959620e255098c$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
        if (selection instanceof (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b) && selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $82f7355673365313$export$5aaf008897aef029)(doc, $from.pos)) return false;
            if (dispatch) {
                if (keepMarks) $47959620e255098c$var$ensureMarks(state, editor.extensionManager.splittableMarks);
                tr.split($from.pos).scrollIntoView();
            }
            return true;
        }
        if (!$from.parent.isBlock) return false;
        if (dispatch) {
            const atEnd = $to.parentOffset === $to.parent.content.size;
            if (selection instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)) tr.deleteSelection();
            const deflt = $from.depth === 0 ? undefined : $47959620e255098c$export$6133a2de0e8ac885($from.node(-1).contentMatchAt($from.indexAfter(-1)));
            let types = atEnd && deflt ? [
                {
                    type: deflt,
                    attrs: newAttributes
                }
            ] : undefined;
            let can = (0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, types);
            if (!types && !can && (0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
                {
                    type: deflt
                }
            ] : undefined)) {
                can = true;
                types = deflt ? [
                    {
                        type: deflt,
                        attrs: newAttributes
                    }
                ] : undefined;
            }
            if (can) {
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                    const first = tr.mapping.map($from.before());
                    const $first = tr.doc.resolve(first);
                    if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            if (keepMarks) $47959620e255098c$var$ensureMarks(state, editor.extensionManager.splittableMarks);
            tr.scrollIntoView();
        }
        return true;
    };
const $47959620e255098c$var$splitListItem = (typeOrName)=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        var _a;
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        const { $from: $from, $to: $to } = state.selection;
        // @ts-ignore
        // eslint-disable-next-line
        const node = state.selection.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        const grandParent = $from.node(-1);
        if (grandParent.type !== type) return false;
        const extensionAttributes = editor.extensionManager.attributes;
        if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
                // eslint-disable-next-line
                const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1)wrap = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from($from.node(d).copy(wrap));
                // eslint-disable-next-line
                const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                const newNextTypeAttributes = $47959620e255098c$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
                const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
                wrap = wrap.append((0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(type.createAndFill(null, nextType) || undefined));
                const start = $from.before($from.depth - (depthBefore - 1));
                tr.replace(start, $from.after(-depthAfter), new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos)=>{
                    if (sel > -1) return false;
                    if (n.isTextblock && n.content.size === 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).near(tr.doc.resolve(sel)));
                tr.scrollIntoView();
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const newTypeAttributes = $47959620e255098c$export$49b565bbca5fba3a(extensionAttributes, grandParent.type.name, grandParent.attrs);
        const newNextTypeAttributes = $47959620e255098c$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
        tr.delete($from.pos, $to.pos);
        const types = nextType ? [
            {
                type: type,
                attrs: newTypeAttributes
            },
            {
                type: nextType,
                attrs: newNextTypeAttributes
            }
        ] : [
            {
                type: type,
                attrs: newTypeAttributes
            }
        ];
        if (!(0, $82f7355673365313$export$5aaf008897aef029)(tr.doc, $from.pos, 2)) return false;
        if (dispatch) {
            const { selection: selection, storedMarks: storedMarks } = state;
            const { splittableMarks: splittableMarks } = editor.extensionManager;
            const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
            tr.split($from.pos, 2, types).scrollIntoView();
            if (!marks || !dispatch) return true;
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
        }
        return true;
    };
const $47959620e255098c$var$joinListBackwards = (tr, listType)=>{
    const list = $47959620e255098c$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) return true;
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && (0, $82f7355673365313$export$f15f89fd9d8cc98a)(tr.doc, list.pos);
    if (!canJoinBackwards) return true;
    tr.join(list.pos);
    return true;
};
const $47959620e255098c$var$joinListForwards = (tr, listType)=>{
    const list = $47959620e255098c$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) return true;
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && (0, $82f7355673365313$export$f15f89fd9d8cc98a)(tr.doc, after);
    if (!canJoinForwards) return true;
    tr.join(after);
    return true;
};
const $47959620e255098c$var$toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {})=>({ editor: editor, tr: tr, state: state, dispatch: dispatch, chain: chain, commands: commands, can: can })=>{
        const { extensions: extensions, splittableMarks: splittableMarks } = editor.extensionManager;
        const listType = $47959620e255098c$export$d168cba70360dd3d(listTypeOrName, state.schema);
        const itemType = $47959620e255098c$export$d168cba70360dd3d(itemTypeOrName, state.schema);
        const { selection: selection, storedMarks: storedMarks } = state;
        const { $from: $from, $to: $to } = selection;
        const range = $from.blockRange($to);
        const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
        if (!range) return false;
        const parentList = $47959620e255098c$export$dc159056ffdb4c76((node)=>$47959620e255098c$export$ead95ff48ba53ffd(node.type.name, extensions))(selection);
        if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
            // remove list
            if (parentList.node.type === listType) return commands.liftListItem(itemType);
            // change list type
            if ($47959620e255098c$export$ead95ff48ba53ffd(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) return chain().command(()=>{
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            }).command(()=>$47959620e255098c$var$joinListBackwards(tr, listType)).command(()=>$47959620e255098c$var$joinListForwards(tr, listType)).run();
        }
        if (!keepMarks || !marks || !dispatch) return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$47959620e255098c$var$joinListBackwards(tr, listType)).command(()=>$47959620e255098c$var$joinListForwards(tr, listType)).run();
        return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$47959620e255098c$var$joinListBackwards(tr, listType)).command(()=>$47959620e255098c$var$joinListForwards(tr, listType)).run();
    };
const $47959620e255098c$var$toggleMark = (typeOrName, attributes = {}, options = {})=>({ state: state, commands: commands })=>{
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const type = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const isActive = $47959620e255098c$export$72001287e2a5b413(state, type, attributes);
        if (isActive) return commands.unsetMark(type, {
            extendEmptyMarkRange: extendEmptyMarkRange
        });
        return commands.setMark(type, attributes);
    };
const $47959620e255098c$var$toggleNode = (typeOrName, toggleTypeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        const toggleType = $47959620e255098c$export$d168cba70360dd3d(toggleTypeOrName, state.schema);
        const isActive = $47959620e255098c$export$7a24a642b0c7ad29(state, type, attributes);
        if (isActive) return commands.setNode(toggleType);
        return commands.setNode(type, attributes);
    };
const $47959620e255098c$var$toggleWrap = (typeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $47959620e255098c$export$7a24a642b0c7ad29(state, type, attributes);
        if (isActive) return commands.lift(type);
        return commands.wrapIn(type, attributes);
    };
const $47959620e255098c$var$undoInputRule = ()=>({ state: state, dispatch: dispatch })=>{
        const plugins = state.plugins;
        for(let i = 0; i < plugins.length; i += 1){
            const plugin = plugins[i];
            let undoable;
            // @ts-ignore
            // eslint-disable-next-line
            if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
                if (dispatch) {
                    const tr = state.tr;
                    const toUndo = undoable.transform;
                    for(let j = toUndo.steps.length - 1; j >= 0; j -= 1)tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                    if (undoable.text) {
                        const marks = tr.doc.resolve(undoable.from).marks();
                        tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                    } else tr.delete(undoable.from, undoable.to);
                }
                return true;
            }
        }
        return false;
    };
const $47959620e255098c$var$unsetAllMarks = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        if (empty) return true;
        if (dispatch) ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
        return true;
    };
const $47959620e255098c$var$unsetMark = (typeOrName, options = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        var _a;
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const { selection: selection } = tr;
        const type = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { $from: $from, empty: empty, ranges: ranges } = selection;
        if (!dispatch) return true;
        if (empty && extendEmptyMarkRange) {
            let { from: from, to: to } = selection;
            const attrs = (_a = $from.marks().find((mark)=>mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
            const range = $47959620e255098c$export$8ceae6d06f5c4df5($from, type, attrs);
            if (range) {
                from = range.from;
                to = range.to;
            }
            tr.removeMark(from, to, type);
        } else ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
        tr.removeStoredMark(type);
        return true;
    };
const $47959620e255098c$var$updateAttributes = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $47959620e255098c$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === "node") nodeType = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === "mark") markType = $47959620e255098c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            const from = range.$from.pos;
            const to = range.$to.pos;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    ...attributes
                });
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) {
                        const trimmedFrom = Math.max(pos, from);
                        const trimmedTo = Math.min(pos + node.nodeSize, to);
                        tr.addMark(trimmedFrom, trimmedTo, markType.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    }
                });
            });
        });
        return true;
    };
const $47959620e255098c$var$wrapIn = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $0e30e03a0c1ecd8e$export$6e5e3c49755affd0)(type, attributes)(state, dispatch);
    };
const $47959620e255098c$var$wrapInList = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $47959620e255098c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $62b287a5b09222dc$export$a8aef45c6262afee)(type, attributes)(state, dispatch);
    };
var $47959620e255098c$var$commands = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blur: $47959620e255098c$var$blur,
    clearContent: $47959620e255098c$var$clearContent,
    clearNodes: $47959620e255098c$var$clearNodes,
    command: $47959620e255098c$var$command,
    createParagraphNear: $47959620e255098c$var$createParagraphNear,
    cut: $47959620e255098c$var$cut,
    deleteCurrentNode: $47959620e255098c$var$deleteCurrentNode,
    deleteNode: $47959620e255098c$var$deleteNode,
    deleteRange: $47959620e255098c$var$deleteRange,
    deleteSelection: $47959620e255098c$var$deleteSelection,
    enter: $47959620e255098c$var$enter,
    exitCode: $47959620e255098c$var$exitCode,
    extendMarkRange: $47959620e255098c$var$extendMarkRange,
    first: $47959620e255098c$var$first,
    focus: $47959620e255098c$var$focus,
    forEach: $47959620e255098c$var$forEach,
    insertContent: $47959620e255098c$var$insertContent,
    insertContentAt: $47959620e255098c$var$insertContentAt,
    joinUp: $47959620e255098c$var$joinUp,
    joinDown: $47959620e255098c$var$joinDown,
    joinBackward: $47959620e255098c$var$joinBackward,
    joinForward: $47959620e255098c$var$joinForward,
    joinItemBackward: $47959620e255098c$var$joinItemBackward,
    joinItemForward: $47959620e255098c$var$joinItemForward,
    joinTextblockBackward: $47959620e255098c$var$joinTextblockBackward,
    joinTextblockForward: $47959620e255098c$var$joinTextblockForward,
    keyboardShortcut: $47959620e255098c$var$keyboardShortcut,
    lift: $47959620e255098c$var$lift,
    liftEmptyBlock: $47959620e255098c$var$liftEmptyBlock,
    liftListItem: $47959620e255098c$var$liftListItem,
    newlineInCode: $47959620e255098c$var$newlineInCode,
    resetAttributes: $47959620e255098c$var$resetAttributes,
    scrollIntoView: $47959620e255098c$var$scrollIntoView,
    selectAll: $47959620e255098c$var$selectAll,
    selectNodeBackward: $47959620e255098c$var$selectNodeBackward,
    selectNodeForward: $47959620e255098c$var$selectNodeForward,
    selectParentNode: $47959620e255098c$var$selectParentNode,
    selectTextblockEnd: $47959620e255098c$var$selectTextblockEnd,
    selectTextblockStart: $47959620e255098c$var$selectTextblockStart,
    setContent: $47959620e255098c$var$setContent,
    setMark: $47959620e255098c$var$setMark,
    setMeta: $47959620e255098c$var$setMeta,
    setNode: $47959620e255098c$var$setNode,
    setNodeSelection: $47959620e255098c$var$setNodeSelection,
    setTextSelection: $47959620e255098c$var$setTextSelection,
    sinkListItem: $47959620e255098c$var$sinkListItem,
    splitBlock: $47959620e255098c$var$splitBlock,
    splitListItem: $47959620e255098c$var$splitListItem,
    toggleList: $47959620e255098c$var$toggleList,
    toggleMark: $47959620e255098c$var$toggleMark,
    toggleNode: $47959620e255098c$var$toggleNode,
    toggleWrap: $47959620e255098c$var$toggleWrap,
    undoInputRule: $47959620e255098c$var$undoInputRule,
    unsetAllMarks: $47959620e255098c$var$unsetAllMarks,
    unsetMark: $47959620e255098c$var$unsetMark,
    updateAttributes: $47959620e255098c$var$updateAttributes,
    wrapIn: $47959620e255098c$var$wrapIn,
    wrapInList: $47959620e255098c$var$wrapInList
});
const $47959620e255098c$var$Commands = $47959620e255098c$export$eeddbf09bb970356.create({
    name: "commands",
    addCommands () {
        return {
            ...$47959620e255098c$var$commands
        };
    }
});
const $47959620e255098c$var$Editable = $47959620e255098c$export$eeddbf09bb970356.create({
    name: "editable",
    addProseMirrorPlugins () {
        return [
            new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
                key: new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("editable"),
                props: {
                    editable: ()=>this.editor.options.editable
                }
            })
        ];
    }
});
const $47959620e255098c$var$FocusEvents = $47959620e255098c$export$eeddbf09bb970356.create({
    name: "focusEvents",
    addProseMirrorPlugins () {
        const { editor: editor } = this;
        return [
            new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
                key: new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("focusEvents"),
                props: {
                    handleDOMEvents: {
                        focus: (view, event)=>{
                            editor.isFocused = true;
                            const transaction = editor.state.tr.setMeta("focus", {
                                event: event
                            }).setMeta("addToHistory", false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event)=>{
                            editor.isFocused = false;
                            const transaction = editor.state.tr.setMeta("blur", {
                                event: event
                            }).setMeta("addToHistory", false);
                            view.dispatch(transaction);
                            return false;
                        }
                    }
                }
            })
        ];
    }
});
const $47959620e255098c$var$Keymap = $47959620e255098c$export$eeddbf09bb970356.create({
    name: "keymap",
    addKeyboardShortcuts () {
        const handleBackspace = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.undoInputRule(),
                    // maybe convert first text block node to default node
                    ()=>commands.command(({ tr: tr })=>{
                            const { selection: selection, doc: doc } = tr;
                            const { empty: empty, $anchor: $anchor } = selection;
                            const { pos: pos, parent: parent } = $anchor;
                            const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                            const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                            const parentPos = $anchor.pos - $anchor.parentOffset;
                            const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).atStart(doc).from === pos;
                            if (!empty || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === "paragraph" // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                            ) return false;
                            return commands.clearNodes();
                        }),
                    ()=>commands.deleteSelection(),
                    ()=>commands.joinBackward(),
                    ()=>commands.selectNodeBackward()
                ]);
        const handleDelete = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.deleteSelection(),
                    ()=>commands.deleteCurrentNode(),
                    ()=>commands.joinForward(),
                    ()=>commands.selectNodeForward()
                ]);
        const handleEnter = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.newlineInCode(),
                    ()=>commands.createParagraphNear(),
                    ()=>commands.liftEmptyBlock(),
                    ()=>commands.splitBlock()
                ]);
        const baseKeymap = {
            Enter: handleEnter,
            "Mod-Enter": ()=>this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            "Mod-Backspace": handleBackspace,
            "Shift-Backspace": handleBackspace,
            Delete: handleDelete,
            "Mod-Delete": handleDelete,
            "Mod-a": ()=>this.editor.commands.selectAll()
        };
        const pcKeymap = {
            ...baseKeymap
        };
        const macKeymap = {
            ...baseKeymap,
            "Ctrl-h": handleBackspace,
            "Alt-Backspace": handleBackspace,
            "Ctrl-d": handleDelete,
            "Ctrl-Alt-Backspace": handleDelete,
            "Alt-Delete": handleDelete,
            "Alt-d": handleDelete,
            "Ctrl-a": ()=>this.editor.commands.selectTextblockStart(),
            "Ctrl-e": ()=>this.editor.commands.selectTextblockEnd()
        };
        if ($47959620e255098c$export$86c1a3f9ab33da5c() || $47959620e255098c$export$6159e43e50a41987()) return macKeymap;
        return pcKeymap;
    },
    addProseMirrorPlugins () {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
                key: new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("clearDocument"),
                appendTransaction: (transactions, oldState, newState)=>{
                    const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
                    if (!docChanges) return;
                    const { empty: empty, from: from, to: to } = oldState.selection;
                    const allFrom = (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).atStart(oldState.doc).from;
                    const allEnd = (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) return;
                    const isEmpty = newState.doc.textBetween(0, newState.doc.content.size, " ", " ").length === 0;
                    if (!isEmpty) return;
                    const tr = newState.tr;
                    const state = $47959620e255098c$export$83e24c5933427696({
                        state: newState,
                        transaction: tr
                    });
                    const { commands: commands } = new $47959620e255098c$export$475014de15a4c342({
                        editor: this.editor,
                        state: state
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) return;
                    return tr;
                }
            })
        ];
    }
});
const $47959620e255098c$var$Tabindex = $47959620e255098c$export$eeddbf09bb970356.create({
    name: "tabindex",
    addProseMirrorPlugins () {
        return [
            new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
                key: new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("tabindex"),
                props: {
                    attributes: this.editor.isEditable ? {
                        tabindex: "0"
                    } : {}
                }
            })
        ];
    }
});
var $47959620e255098c$export$cc3e2d3244e01b7f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ClipboardTextSerializer: $47959620e255098c$var$ClipboardTextSerializer,
    Commands: $47959620e255098c$var$Commands,
    Editable: $47959620e255098c$var$Editable,
    FocusEvents: $47959620e255098c$var$FocusEvents,
    Keymap: $47959620e255098c$var$Keymap,
    Tabindex: $47959620e255098c$var$Tabindex
});
class $47959620e255098c$export$50c0270e74640068 {
    constructor(pos, editor, isBlock = false, node = null){
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get name() {
        return this.node.type.name;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can\u{2019}t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({
            from: from,
            to: to
        }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) return this.pos;
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to
        };
    }
    get to() {
        if (this.isBlock) return this.pos + this.size;
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) return null;
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new $47959620e255098c$export$50c0270e74640068($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.from - 3);
        return new $47959620e255098c$export$50c0270e74640068($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.to + 3);
        return new $47959620e255098c$export$50c0270e74640068($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset)=>{
            const isBlock = node.isBlock && !node.isTextblock;
            const targetPos = this.pos + offset + 1;
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) return;
            const childNodePos = new $47959620e255098c$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) childNodePos.actualDepth = this.depth + 1;
            children.push(new $47959620e255098c$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while(currentNode && !node){
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for(let index = 0; index < attrKeys.length; index += 1){
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) break;
                    }
                } else node = currentNode;
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) return nodes;
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */ this.children.forEach((childPos)=>{
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) return;
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every((key)=>attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) nodes.push(childPos);
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) return;
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const oldSelection = this.editor.state.selection;
        this.editor.chain().setTextSelection(this.from).updateAttributes(this.node.type.name, attributes).setTextSelection(oldSelection.from).run();
    }
}
const $47959620e255098c$var$style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function $47959620e255098c$export$48321b481dd8a36(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ""}]`);
    if (tiptapStyleTag !== null) return tiptapStyleTag;
    const styleNode = document.createElement("style");
    if (nonce) styleNode.setAttribute("nonce", nonce);
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ""}`, "");
    styleNode.innerHTML = style;
    document.getElementsByTagName("head")[0].appendChild(styleNode);
    return styleNode;
}
class $47959620e255098c$export$7cda8d932e2f33c0 extends $47959620e255098c$var$EventEmitter {
    constructor(options = {}){
        super();
        this.isFocused = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement("div"),
            content: "",
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            onBeforeCreate: ()=>null,
            onCreate: ()=>null,
            onUpdate: ()=>null,
            onSelectionUpdate: ()=>null,
            onTransaction: ()=>null,
            onFocus: ()=>null,
            onBlur: ()=>null,
            onDestroy: ()=>null
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on("beforeCreate", this.options.onBeforeCreate);
        this.emit("beforeCreate", {
            editor: this
        });
        this.createView();
        this.injectCSS();
        this.on("create", this.options.onCreate);
        this.on("update", this.options.onUpdate);
        this.on("selectionUpdate", this.options.onSelectionUpdate);
        this.on("transaction", this.options.onTransaction);
        this.on("focus", this.options.onFocus);
        this.on("blur", this.options.onBlur);
        this.on("destroy", this.options.onDestroy);
        window.setTimeout(()=>{
            if (this.isDestroyed) return;
            this.commands.focus(this.options.autofocus);
            this.emit("create", {
                editor: this
            });
        }, 0);
    }
    /**
     * Returns the editor storage.
     */ get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */ get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */ chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */ can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */ injectCSS() {
        if (this.options.injectCSS && document) this.css = $47959620e255098c$export$48321b481dd8a36($47959620e255098c$var$style, this.options.injectNonce);
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */ setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options
        };
        if (!this.view || !this.state || this.isDestroyed) return;
        if (this.options.editorProps) this.view.setProps(this.options.editorProps);
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */ setEditable(editable, emitUpdate = true) {
        this.setOptions({
            editable: editable
        });
        if (emitUpdate) this.emit("update", {
            editor: this,
            transaction: this.state.tr
        });
    }
    /**
     * Returns whether the editor is editable.
     */ get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */ get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     */ registerPlugin(plugin, handlePlugins) {
        const plugins = $47959620e255098c$export$f6e2535fb5126e54(handlePlugins) ? handlePlugins(plugin, [
            ...this.state.plugins
        ]) : [
            ...this.state.plugins,
            plugin
        ];
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKey The plugins name
     */ unregisterPlugin(nameOrPluginKey) {
        if (this.isDestroyed) return;
        // @ts-ignore
        const name = typeof nameOrPluginKey === "string" ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
        const state = this.state.reconfigure({
            // @ts-ignore
            plugins: this.state.plugins.filter((plugin)=>!plugin.key.startsWith(name))
        });
        this.view.updateState(state);
    }
    /**
     * Creates an extension manager.
     */ createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            $47959620e255098c$var$Editable,
            $47959620e255098c$var$ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
            }),
            $47959620e255098c$var$Commands,
            $47959620e255098c$var$FocusEvents,
            $47959620e255098c$var$Keymap,
            $47959620e255098c$var$Tabindex
        ] : [];
        const allExtensions = [
            ...coreExtensions,
            ...this.options.extensions
        ].filter((extension)=>{
            return [
                "extension",
                "node",
                "mark"
            ].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new $47959620e255098c$var$ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */ createCommandManager() {
        this.commandManager = new $47959620e255098c$export$475014de15a4c342({
            editor: this
        });
    }
    /**
     * Creates a ProseMirror schema.
     */ createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */ createView() {
        const doc = $47959620e255098c$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions);
        const selection = $47959620e255098c$export$225b0233b78e0d61(doc, this.options.autofocus);
        this.view = new (0, $41324cd97564f577$export$eece2fccabbb77c5)(this.options.element, {
            ...this.options.editorProps,
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: (0, $a24eacb5c8b3ccab$export$afa855cbfaff27f2).create({
                doc: doc,
                selection: selection || undefined
            })
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */ createNodeViews() {
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews
        });
    }
    /**
     * Prepend class name to element.
     */ prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */ dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) return;
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach((step)=>{
                var _a;
                return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
            });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.view.updateState(state);
        this.emit("transaction", {
            editor: this,
            transaction: transaction
        });
        if (selectionHasChanged) this.emit("selectionUpdate", {
            editor: this,
            transaction: transaction
        });
        const focus = transaction.getMeta("focus");
        const blur = transaction.getMeta("blur");
        if (focus) this.emit("focus", {
            editor: this,
            event: focus.event,
            transaction: transaction
        });
        if (blur) this.emit("blur", {
            editor: this,
            event: blur.event,
            transaction: transaction
        });
        if (!transaction.docChanged || transaction.getMeta("preventUpdate")) return;
        this.emit("update", {
            editor: this,
            transaction: transaction
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */ getAttributes(nameOrType) {
        return $47959620e255098c$export$fe94072fee8a6976(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === "string" ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === "string" ? attributesOrUndefined : nameOrAttributes;
        return $47959620e255098c$export$39e04e72f972b885(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */ getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */ getHTML() {
        return $47959620e255098c$export$d1b60002472b2c81(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */ getText(options) {
        const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
        return $47959620e255098c$export$c72d34660a162238(this.state.doc, {
            blockSeparator: blockSeparator,
            textSerializers: {
                ...$47959620e255098c$export$fdd92b7d22ac071c(this.schema),
                ...textSerializers
            }
        });
    }
    /**
     * Check if there is no content.
     */ get isEmpty() {
        return $47959620e255098c$export$cd58ff1081f6abe9(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */ getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */ destroy() {
        this.emit("destroy");
        if (this.view) this.view.destroy();
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */ get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new $47959620e255098c$export$50c0270e74640068($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $47959620e255098c$export$9f2cb743ab9131de(config) {
    return new $47959620e255098c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $47959620e255098c$export$592682234826c0bd(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $47959620e255098c$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $47959620e255098c$export$6ca56856dfeaf9b6(config) {
    return new $47959620e255098c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $47959620e255098c$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const { tr: tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) matchStart = end;
                else end = matchStart + match[1].length;
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            } else if (match[0]) tr.insert(start - 1, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            tr.scrollIntoView();
        }
    });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $47959620e255098c$export$cc081314d3f6ffb0(config) {
    return new $47959620e255098c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const $start = state.doc.resolve(range.from);
            const attributes = $47959620e255098c$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) return null;
            state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
        }
    });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $47959620e255098c$export$3ba5a5a15d18a35c(config) {
    return new $47959620e255098c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $47959620e255098c$export$f7316d89abe4e1c1(config) {
    return new $47959620e255098c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match, chain: chain })=>{
            const attributes = $47959620e255098c$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && (0, $82f7355673365313$export$118cb9a83e81ba37)(blockRange, config.type, attributes);
            if (!wrapping) return null;
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection: selection, storedMarks: storedMarks } = state;
                const { splittableMarks: splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                if (marks) {
                    const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */ const nodeType = config.type.name === "bulletList" || config.type.name === "orderedList" ? "listItem" : "taskList";
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before && before.type === config.type && (0, $82f7355673365313$export$f15f89fd9d8cc98a)(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) tr.join(range.from - 1);
        }
    });
}
/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $47959620e255098c$export$c9d15bcfc6d42044 {
    constructor(config = {}){
        this.type = "mark";
        this.name = "mark";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $47959620e255098c$export$c9d15bcfc6d42044(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend();
        extension.options = $47959620e255098c$export$dd702b3c8240390c(this.options, options);
        extension.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $47959620e255098c$export$c9d15bcfc6d42044({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    static handleExit({ editor: editor, mark: mark }) {
        const { tr: tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) return false;
            const removeMark = currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) tr.removeStoredMark(removeMark);
            tr.insertText(" ", currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}
/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $47959620e255098c$export$85c928794f8d04d4 {
    constructor(config = {}){
        this.type = "node";
        this.name = "node";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $47959620e255098c$export$85c928794f8d04d4(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend();
        extension.options = $47959620e255098c$export$dd702b3c8240390c(this.options, options);
        extension.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $47959620e255098c$export$85c928794f8d04d4({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $47959620e255098c$export$592682234826c0bd($47959620e255098c$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
function $47959620e255098c$var$isAndroid() {
    return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */ class $47959620e255098c$export$77c6811359a01a6f {
    constructor(component, props, options){
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view: view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest("[data-drag-handle]") : target.closest("[data-drag-handle]");
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) return;
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        (_g = event.dataTransfer) === null || _g === void 0 || _g.setDragImage(this.dom, x, y);
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(view.state.doc, this.getPos());
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) return false;
        if (typeof this.options.stopEvent === "function") return this.options.stopEvent({
            event: event
        });
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) return false;
        const isDragEvent = event.type.startsWith("drag");
        const isDropEvent = event.type === "drop";
        const isInput = [
            "INPUT",
            "BUTTON",
            "SELECT",
            "TEXTAREA"
        ].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) return true;
        const { isEditable: isEditable } = this.editor;
        const { isDragging: isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(this.node);
        const isCopyEvent = event.type === "copy";
        const isPasteEvent = event.type === "paste";
        const isCutEvent = event.type === "cut";
        const isClickEvent = event.type === "mousedown";
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent) event.preventDefault();
        if (isDraggable && isDragEvent && !isDragging) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest("[data-drag-handle]");
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener("dragend", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener("drop", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener("mouseup", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
            }
        }
        // these events are handled by prosemirror
        if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) return false;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) return true;
        if (typeof this.options.ignoreMutation === "function") return this.options.ignoreMutation({
            mutation: mutation
        });
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) return true;
        // ProseMirror should handle any selections
        if (mutation.type === "selection") return false;
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target) && mutation.type === "childList" && ($47959620e255098c$export$86c1a3f9ab33da5c() || $47959620e255098c$var$isAndroid()) && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes)
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every((node)=>node.isContentEditable)) return false;
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === "attributes") return true;
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) return false;
        return true;
    }
    updateAttributes(attributes) {
        this.editor.commands.command(({ tr: tr })=>{
            const pos = this.getPos();
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes
            });
            return true;
        });
    }
    deleteNode() {
        const from = this.getPos();
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({
            from: from,
            to: to
        });
    }
}
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ function $47959620e255098c$export$3845eb97abe74944(config) {
    return new $47959620e255098c$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match, pasteEvent: pasteEvent })=>{
            const attributes = $47959620e255098c$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $47959620e255098c$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
// source: https://stackoverflow.com/a/6969486
function $47959620e255098c$export$d3f82eb9fcc60fbc(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function $47959620e255098c$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ function $47959620e255098c$export$3cb77ada4d0e5bd5(config) {
    return new $47959620e255098c$export$e75df4392d073e98({
        find: config.find,
        handler ({ match: match, chain: chain, range: range, pasteEvent: pasteEvent }) {
            const attributes = $47959620e255098c$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) return null;
            if (match.input) chain().deleteRange(range).insertContentAt(range.from, {
                type: config.type.name,
                attrs: attributes
            });
        }
    });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ function $47959620e255098c$export$1aff23e8795559fa(config) {
    return new $47959620e255098c$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
class $47959620e255098c$export$254d9747e34ddc90 {
    constructor(transaction){
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps.slice(this.currentStep).reduce((newPosition, step)=>{
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) deleted = true;
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted: deleted
        };
    }
}


/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $31bd2e4c89b87b19$export$a7b06bfba60a8a78 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "listItem",
    addOptions () {
        return {
            HTMLAttributes: {},
            bulletListTypeName: "bulletList",
            orderedListTypeName: "orderedList"
        };
    },
    content: "paragraph block*",
    defining: true,
    parseHTML () {
        return [
            {
                tag: "li"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "li",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addKeyboardShortcuts () {
        return {
            Enter: ()=>this.editor.commands.splitListItem(this.name),
            Tab: ()=>this.editor.commands.sinkListItem(this.name),
            "Shift-Tab": ()=>this.editor.commands.liftListItem(this.name)
        };
    }
});



/**
 * This extension allows you to create text styles. It is required by default
 * for the `textColor` and `backgroundColor` extensions.
 * @see https://www.tiptap.dev/api/marks/text-style
 */ const $ec108066d24b69c9$export$1df879243bf2e42d = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "textStyle",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "span",
                getAttrs: (element)=>{
                    const hasStyles = element.hasAttribute("style");
                    if (!hasStyles) return false;
                    return {};
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "span",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            removeEmptyTextStyle: ()=>({ state: state, commands: commands })=>{
                    const attributes = (0, $47959620e255098c$export$2cd1d0e1f861bae0)(state, this.type);
                    const hasStyles = Object.entries(attributes).some(([, value])=>!!value);
                    if (hasStyles) return true;
                    return commands.unsetMark(this.name);
                }
        };
    }
});




/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $118dfc6e979fb612$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $118dfc6e979fb612$var$BOX_CLASS = "tippy-box";
var $118dfc6e979fb612$var$CONTENT_CLASS = "tippy-content";
var $118dfc6e979fb612$var$BACKDROP_CLASS = "tippy-backdrop";
var $118dfc6e979fb612$var$ARROW_CLASS = "tippy-arrow";
var $118dfc6e979fb612$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $118dfc6e979fb612$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $118dfc6e979fb612$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $118dfc6e979fb612$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $118dfc6e979fb612$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $118dfc6e979fb612$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $118dfc6e979fb612$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $118dfc6e979fb612$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $118dfc6e979fb612$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $118dfc6e979fb612$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $118dfc6e979fb612$var$normalizeToArray(value) {
    return [].concat(value);
}
function $118dfc6e979fb612$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $118dfc6e979fb612$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $118dfc6e979fb612$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $118dfc6e979fb612$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $118dfc6e979fb612$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $118dfc6e979fb612$var$div() {
    return document.createElement("div");
}
function $118dfc6e979fb612$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $118dfc6e979fb612$var$isType(value, type);
    });
}
function $118dfc6e979fb612$var$isNodeList(value) {
    return $118dfc6e979fb612$var$isType(value, "NodeList");
}
function $118dfc6e979fb612$var$isMouseEvent(value) {
    return $118dfc6e979fb612$var$isType(value, "MouseEvent");
}
function $118dfc6e979fb612$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $118dfc6e979fb612$var$getArrayOfElements(value) {
    if ($118dfc6e979fb612$var$isElement(value)) return [
        value
    ];
    if ($118dfc6e979fb612$var$isNodeList(value)) return $118dfc6e979fb612$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $118dfc6e979fb612$var$arrayFrom(document.querySelectorAll(value));
}
function $118dfc6e979fb612$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $118dfc6e979fb612$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $118dfc6e979fb612$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $118dfc6e979fb612$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $118dfc6e979fb612$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $118dfc6e979fb612$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $118dfc6e979fb612$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $118dfc6e979fb612$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $118dfc6e979fb612$var$currentInput = {
    isTouch: false
};
var $118dfc6e979fb612$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $118dfc6e979fb612$var$onDocumentTouchStart() {
    if ($118dfc6e979fb612$var$currentInput.isTouch) return;
    $118dfc6e979fb612$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $118dfc6e979fb612$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $118dfc6e979fb612$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $118dfc6e979fb612$var$lastMouseMoveTime < 20) {
        $118dfc6e979fb612$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $118dfc6e979fb612$var$onDocumentMouseMove);
    }
    $118dfc6e979fb612$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $118dfc6e979fb612$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($118dfc6e979fb612$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $118dfc6e979fb612$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $118dfc6e979fb612$var$onDocumentTouchStart, $118dfc6e979fb612$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $118dfc6e979fb612$var$onWindowBlur);
}
var $118dfc6e979fb612$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $118dfc6e979fb612$var$isIE11 = $118dfc6e979fb612$var$isBrowser ? !!window.msCrypto : false;
function $118dfc6e979fb612$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $118dfc6e979fb612$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $118dfc6e979fb612$var$getDevMessage(message) {
    return $118dfc6e979fb612$var$clean("\n  %ctippy.js\n\n  %c" + $118dfc6e979fb612$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $118dfc6e979fb612$var$getFormattedMessage(message) {
    return [
        $118dfc6e979fb612$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $118dfc6e979fb612$var$visitedMessages;
function $118dfc6e979fb612$var$resetVisitedMessages() {
    $118dfc6e979fb612$var$visitedMessages = new Set();
}
function $118dfc6e979fb612$var$warnWhen(condition, message) {
    if (condition && !$118dfc6e979fb612$var$visitedMessages.has(message)) {
        var _console;
        $118dfc6e979fb612$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $118dfc6e979fb612$var$getFormattedMessage(message));
    }
}
function $118dfc6e979fb612$var$errorWhen(condition, message) {
    if (condition && !$118dfc6e979fb612$var$visitedMessages.has(message)) {
        var _console2;
        $118dfc6e979fb612$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $118dfc6e979fb612$var$getFormattedMessage(message));
    }
}
function $118dfc6e979fb612$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $118dfc6e979fb612$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $118dfc6e979fb612$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $118dfc6e979fb612$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $118dfc6e979fb612$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $118dfc6e979fb612$var$defaultProps = Object.assign({
    appendTo: $118dfc6e979fb612$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $118dfc6e979fb612$var$pluginProps, $118dfc6e979fb612$var$renderProps);
var $118dfc6e979fb612$var$defaultKeys = Object.keys($118dfc6e979fb612$var$defaultProps);
var $118dfc6e979fb612$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $118dfc6e979fb612$var$defaultProps[key] = partialProps[key];
    });
};
function $118dfc6e979fb612$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $118dfc6e979fb612$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $118dfc6e979fb612$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($118dfc6e979fb612$var$getExtendedPassedProps(Object.assign({}, $118dfc6e979fb612$var$defaultProps, {
        plugins: plugins
    }))) : $118dfc6e979fb612$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $118dfc6e979fb612$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $118dfc6e979fb612$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $118dfc6e979fb612$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $118dfc6e979fb612$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $118dfc6e979fb612$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $118dfc6e979fb612$var$removeProperties($118dfc6e979fb612$var$defaultProps, Object.keys($118dfc6e979fb612$var$pluginProps));
        var didPassUnknownProp = !$118dfc6e979fb612$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $118dfc6e979fb612$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $118dfc6e979fb612$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $118dfc6e979fb612$var$dangerouslySetInnerHTML(element, html) {
    element[$118dfc6e979fb612$var$innerHTML()] = html;
}
function $118dfc6e979fb612$var$createArrowElement(value) {
    var arrow = $118dfc6e979fb612$var$div();
    if (value === true) arrow.className = $118dfc6e979fb612$var$ARROW_CLASS;
    else {
        arrow.className = $118dfc6e979fb612$var$SVG_ARROW_CLASS;
        if ($118dfc6e979fb612$var$isElement(value)) arrow.appendChild(value);
        else $118dfc6e979fb612$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $118dfc6e979fb612$var$setContent(content, props) {
    if ($118dfc6e979fb612$var$isElement(props.content)) {
        $118dfc6e979fb612$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $118dfc6e979fb612$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $118dfc6e979fb612$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $118dfc6e979fb612$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($118dfc6e979fb612$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($118dfc6e979fb612$var$ARROW_CLASS) || node.classList.contains($118dfc6e979fb612$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($118dfc6e979fb612$var$BACKDROP_CLASS);
        })
    };
}
function $118dfc6e979fb612$var$render(instance) {
    var popper = $118dfc6e979fb612$var$div();
    var box = $118dfc6e979fb612$var$div();
    box.className = $118dfc6e979fb612$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $118dfc6e979fb612$var$div();
    content.className = $118dfc6e979fb612$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $118dfc6e979fb612$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $118dfc6e979fb612$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $118dfc6e979fb612$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($118dfc6e979fb612$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($118dfc6e979fb612$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$118dfc6e979fb612$var$render.$$tippy = true;
var $118dfc6e979fb612$var$idCounter = 1;
var $118dfc6e979fb612$var$mouseMoveListeners = []; // Used by `hideAll()`
var $118dfc6e979fb612$var$mountedInstances = [];
function $118dfc6e979fb612$var$createTippy(reference, passedProps) {
    var props = $118dfc6e979fb612$var$evaluateProps(reference, Object.assign({}, $118dfc6e979fb612$var$defaultProps, $118dfc6e979fb612$var$getExtendedPassedProps($118dfc6e979fb612$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $118dfc6e979fb612$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $118dfc6e979fb612$var$idCounter++;
    var popperInstance = null;
    var plugins = $118dfc6e979fb612$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $118dfc6e979fb612$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $118dfc6e979fb612$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $118dfc6e979fb612$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $118dfc6e979fb612$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $118dfc6e979fb612$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $118dfc6e979fb612$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $118dfc6e979fb612$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $118dfc6e979fb612$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $118dfc6e979fb612$var$mouseMoveListeners = $118dfc6e979fb612$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($118dfc6e979fb612$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $118dfc6e979fb612$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($118dfc6e979fb612$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $118dfc6e979fb612$var$actualContains(el, actualTarget);
        })) {
            if ($118dfc6e979fb612$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $118dfc6e979fb612$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $118dfc6e979fb612$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $118dfc6e979fb612$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $118dfc6e979fb612$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $118dfc6e979fb612$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $118dfc6e979fb612$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $118dfc6e979fb612$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $118dfc6e979fb612$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $118dfc6e979fb612$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $118dfc6e979fb612$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $118dfc6e979fb612$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($118dfc6e979fb612$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $118dfc6e979fb612$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $118dfc6e979fb612$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($118dfc6e979fb612$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $118dfc6e979fb612$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $118dfc6e979fb612$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $dc82db6162dc1c2f$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $118dfc6e979fb612$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $118dfc6e979fb612$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $118dfc6e979fb612$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($118dfc6e979fb612$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $118dfc6e979fb612$var$evaluateProps(reference, Object.assign({}, prevProps, $118dfc6e979fb612$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $118dfc6e979fb612$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $118dfc6e979fb612$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $118dfc6e979fb612$var$currentInput.isTouch && !instance.props.touch;
        var duration = $118dfc6e979fb612$var$getValueAtIndexOrReturn(instance.props.duration, 0, $118dfc6e979fb612$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $118dfc6e979fb612$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $118dfc6e979fb612$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $118dfc6e979fb612$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $118dfc6e979fb612$var$pushIfUnique($118dfc6e979fb612$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $118dfc6e979fb612$var$getValueAtIndexOrReturn(instance.props.duration, 1, $118dfc6e979fb612$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $118dfc6e979fb612$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $118dfc6e979fb612$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $118dfc6e979fb612$var$pushIfUnique($118dfc6e979fb612$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $118dfc6e979fb612$var$mountedInstances = $118dfc6e979fb612$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $118dfc6e979fb612$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $118dfc6e979fb612$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $118dfc6e979fb612$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $118dfc6e979fb612$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $118dfc6e979fb612$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $118dfc6e979fb612$var$isElement(targets) ? instances[0] : instances;
}
$118dfc6e979fb612$var$tippy.defaultProps = $118dfc6e979fb612$var$defaultProps;
$118dfc6e979fb612$var$tippy.setDefaultProps = $118dfc6e979fb612$var$setDefaultProps;
$118dfc6e979fb612$var$tippy.currentInput = $118dfc6e979fb612$var$currentInput;
var $118dfc6e979fb612$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $118dfc6e979fb612$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $118dfc6e979fb612$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $118dfc6e979fb612$var$applyStylesModifier = Object.assign({}, (0, $31b8db5006cb8311$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $118dfc6e979fb612$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $118dfc6e979fb612$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $118dfc6e979fb612$var$tippy($118dfc6e979fb612$var$div(), Object.assign({}, $118dfc6e979fb612$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $118dfc6e979fb612$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $118dfc6e979fb612$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $118dfc6e979fb612$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $118dfc6e979fb612$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $118dfc6e979fb612$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $118dfc6e979fb612$var$tippy(targets, parentProps);
    var normalizedReturnValue = $118dfc6e979fb612$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $118dfc6e979fb612$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($118dfc6e979fb612$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $118dfc6e979fb612$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $118dfc6e979fb612$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $118dfc6e979fb612$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $118dfc6e979fb612$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $118dfc6e979fb612$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $118dfc6e979fb612$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $118dfc6e979fb612$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $118dfc6e979fb612$var$createBackdropElement() {
    var backdrop = $118dfc6e979fb612$var$div();
    backdrop.className = $118dfc6e979fb612$var$BACKDROP_CLASS;
    $118dfc6e979fb612$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $118dfc6e979fb612$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $118dfc6e979fb612$var$activeInstances = [];
function $118dfc6e979fb612$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $118dfc6e979fb612$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $118dfc6e979fb612$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $118dfc6e979fb612$var$storeMouseCoords);
}
function $118dfc6e979fb612$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $118dfc6e979fb612$var$storeMouseCoords);
}
var $118dfc6e979fb612$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $118dfc6e979fb612$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $118dfc6e979fb612$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $118dfc6e979fb612$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $118dfc6e979fb612$var$activeInstances = $118dfc6e979fb612$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($118dfc6e979fb612$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $118dfc6e979fb612$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($118dfc6e979fb612$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($118dfc6e979fb612$var$isMouseEvent(event)) $118dfc6e979fb612$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $118dfc6e979fb612$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $118dfc6e979fb612$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $118dfc6e979fb612$var$getInlineBoundingClientRect($118dfc6e979fb612$var$getBasePlacement(placement), reference.getBoundingClientRect(), $118dfc6e979fb612$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($118dfc6e979fb612$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($118dfc6e979fb612$var$isMouseEvent(event)) {
                    var rects = $118dfc6e979fb612$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $118dfc6e979fb612$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $118dfc6e979fb612$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $118dfc6e979fb612$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $118dfc6e979fb612$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $118dfc6e979fb612$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$118dfc6e979fb612$var$tippy.setDefaultProps({
    render: $118dfc6e979fb612$var$render
});
var $118dfc6e979fb612$export$2e2bcd8739ae039 = $118dfc6e979fb612$var$tippy;


class $25d75c61d759ea8d$export$1518b7671d88a5b3 {
    constructor({ editor: editor, element: element, view: view, tippyOptions: tippyOptions = {}, updateDelay: updateDelay = 250, shouldShow: shouldShow }){
        this.preventHide = false;
        this.shouldShow = ({ view: view, state: state, from: from, to: to })=>{
            const { doc: doc, selection: selection } = state;
            const { empty: empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length && (0, $47959620e255098c$export$38b50bf35e79aaf3)(state.selection);
            // When clicking on a element inside the bubble menu the editor "blur" event
            // is called and the bubble menu item is focussed. In this case we should
            // consider the menu as part of the editor and keep showing the menu
            const isChildOfMenu = this.element.contains(document.activeElement);
            const hasEditorFocus = view.hasFocus() || isChildOfMenu;
            if (!hasEditorFocus || empty || isEmptyTextBlock || !this.editor.isEditable) return false;
            return true;
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.dragstartHandler = ()=>{
            this.hide();
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            this.hide();
        };
        this.tippyBlurHandler = (event)=>{
            this.blurHandler({
                event: event
            });
        };
        this.handleDebouncedUpdate = (view, oldState)=>{
            const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
            const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
            if (!selectionChanged && !docChanged) return;
            if (this.updateDebounceTimer) clearTimeout(this.updateDebounceTimer);
            this.updateDebounceTimer = window.setTimeout(()=>{
                this.updateHandler(view, selectionChanged, docChanged, oldState);
            }, this.updateDelay);
        };
        this.updateHandler = (view, selectionChanged, docChanged, oldState)=>{
            var _a, _b, _c;
            const { state: state, composing: composing } = view;
            const { selection: selection } = state;
            const isSame = !selectionChanged && !docChanged;
            if (composing || isSame) return;
            this.createTooltip();
            // support for CellSelections
            const { ranges: ranges } = selection;
            const from = Math.min(...ranges.map((range)=>range.$from.pos));
            const to = Math.max(...ranges.map((range)=>range.$to.pos));
            const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
                editor: this.editor,
                view: view,
                state: state,
                oldState: oldState,
                from: from,
                to: to
            });
            if (!shouldShow) {
                this.hide();
                return;
            }
            (_b = this.tippy) === null || _b === void 0 || _b.setProps({
                getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (()=>{
                    if ((0, $47959620e255098c$export$a8c1d2c13abf8822)(state.selection)) {
                        let node = view.nodeDOM(from);
                        const nodeViewWrapper = node.dataset.nodeViewWrapper ? node : node.querySelector("[data-node-view-wrapper]");
                        if (nodeViewWrapper) node = nodeViewWrapper.firstChild;
                        if (node) return node.getBoundingClientRect();
                    }
                    return (0, $47959620e255098c$export$660ecae6cde71645)(view, from, to);
                })
            });
            this.show();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        this.updateDelay = updateDelay;
        if (shouldShow) this.shouldShow = shouldShow;
        this.element.addEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.view.dom.addEventListener("dragstart", this.dragstartHandler);
        this.editor.on("focus", this.focusHandler);
        this.editor.on("blur", this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = "visible";
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) return;
        this.tippy = (0, $118dfc6e979fb612$export$2e2bcd8739ae039)(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: "manual",
            placement: "top",
            hideOnClick: "toggle",
            ...this.tippyOptions
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler);
    }
    update(view, oldState) {
        const { state: state } = view;
        const hasValidSelection = state.selection.$from.pos !== state.selection.$to.pos;
        if (this.updateDelay > 0 && hasValidSelection) {
            this.handleDebouncedUpdate(view, oldState);
            return;
        }
        const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
        const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
        this.updateHandler(view, selectionChanged, docChanged, oldState);
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler);
        (_b = this.tippy) === null || _b === void 0 || _b.destroy();
        this.element.removeEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.view.dom.removeEventListener("dragstart", this.dragstartHandler);
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
    }
}
const $25d75c61d759ea8d$export$20c12548414ed018 = (options)=>{
    return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        key: typeof options.pluginKey === "string" ? new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)(options.pluginKey) : options.pluginKey,
        view: (view)=>new $25d75c61d759ea8d$export$1518b7671d88a5b3({
                view: view,
                ...options
            })
    });
};
/**
 * This extension allows you to create a bubble menu.
 * @see https://tiptap.dev/api/extensions/bubble-menu
 */ const $25d75c61d759ea8d$export$79c1bf6a55bce827 = (0, $47959620e255098c$export$eeddbf09bb970356).create({
    name: "bubbleMenu",
    addOptions () {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: "bubbleMenu",
            updateDelay: undefined,
            shouldShow: null
        };
    },
    addProseMirrorPlugins () {
        if (!this.options.element) return [];
        return [
            $25d75c61d759ea8d$export$20c12548414ed018({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                updateDelay: this.options.updateDelay,
                shouldShow: this.options.shouldShow
            })
        ];
    }
});



var $f2Y41 = parcelRequire("f2Y41");





class $a2ac14caa799141a$export$8787fd8a369cb5a5 {
    constructor({ editor: editor, element: element, view: view, tippyOptions: tippyOptions = {}, shouldShow: shouldShow }){
        this.preventHide = false;
        this.shouldShow = ({ view: view, state: state })=>{
            const { selection: selection } = state;
            const { $anchor: $anchor, empty: empty } = selection;
            const isRootDepth = $anchor.depth === 1;
            const isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent;
            if (!view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !this.editor.isEditable) return false;
            return true;
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            this.hide();
        };
        this.tippyBlurHandler = (event)=>{
            this.blurHandler({
                event: event
            });
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) this.shouldShow = shouldShow;
        this.element.addEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.editor.on("focus", this.focusHandler);
        this.editor.on("blur", this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = "visible";
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) return;
        this.tippy = (0, $118dfc6e979fb612$export$2e2bcd8739ae039)(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: "manual",
            placement: "right",
            hideOnClick: "toggle",
            ...this.tippyOptions
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler);
    }
    update(view, oldState) {
        var _a, _b, _c;
        const { state: state } = view;
        const { doc: doc, selection: selection } = state;
        const { from: from, to: to } = selection;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (isSame) return;
        this.createTooltip();
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view: view,
            state: state,
            oldState: oldState
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 || _b.setProps({
            getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (()=>(0, $47959620e255098c$export$660ecae6cde71645)(view, from, to))
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler);
        (_b = this.tippy) === null || _b === void 0 || _b.destroy();
        this.element.removeEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
    }
}
const $a2ac14caa799141a$export$5e50896e3f3c0d7b = (options)=>{
    return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        key: typeof options.pluginKey === "string" ? new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)(options.pluginKey) : options.pluginKey,
        view: (view)=>new $a2ac14caa799141a$export$8787fd8a369cb5a5({
                view: view,
                ...options
            })
    });
};
/**
 * This extension allows you to create a floating menu.
 * @see https://tiptap.dev/api/extensions/floating-menu
 */ const $a2ac14caa799141a$export$695cda69e78edecd = (0, $47959620e255098c$export$eeddbf09bb970356).create({
    name: "floatingMenu",
    addOptions () {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: "floatingMenu",
            shouldShow: null
        };
    },
    addProseMirrorPlugins () {
        if (!this.options.element) return [];
        return [
            $a2ac14caa799141a$export$5e50896e3f3c0d7b({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow
            })
        ];
    }
});


const $3230bda81207e15e$var$mergeRefs = (...refs)=>{
    return (node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
        });
    };
};
const $3230bda81207e15e$var$Portals = ({ renderers: renderers })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, Object.entries(renderers).map(([key, renderer])=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($5021361ff788fb77$exports))).createPortal(renderer.reactElement, renderer.element, key);
    }));
};
class $3230bda81207e15e$export$2a77c1f2ea046ea6 extends (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Component {
    constructor(props){
        super(props);
        this.editorContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createRef();
        this.initialized = false;
        this.state = {
            renderers: {}
        };
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate() {
        this.init();
    }
    init() {
        const { editor: editor } = this.props;
        if (editor && editor.options.element) {
            if (editor.contentComponent) return;
            const element = this.editorContentRef.current;
            element.append(...editor.options.element.childNodes);
            editor.setOptions({
                element: element
            });
            editor.contentComponent = this;
            editor.createNodeViews();
            this.initialized = true;
        }
    }
    maybeFlushSync(fn) {
        // Avoid calling flushSync until the editor is initialized.
        // Initialization happens during the componentDidMount or componentDidUpdate
        // lifecycle methods, and React doesn't allow calling flushSync from inside
        // a lifecycle method.
        if (this.initialized) (0, $5021361ff788fb77$exports.flushSync)(fn);
        else fn();
    }
    setRenderer(id, renderer) {
        this.maybeFlushSync(()=>{
            this.setState(({ renderers: renderers })=>({
                    renderers: {
                        ...renderers,
                        [id]: renderer
                    }
                }));
        });
    }
    removeRenderer(id) {
        this.maybeFlushSync(()=>{
            this.setState(({ renderers: renderers })=>{
                const nextRenderers = {
                    ...renderers
                };
                delete nextRenderers[id];
                return {
                    renderers: nextRenderers
                };
            });
        });
    }
    componentWillUnmount() {
        const { editor: editor } = this.props;
        if (!editor) return;
        this.initialized = false;
        if (!editor.isDestroyed) editor.view.setProps({
            nodeViews: {}
        });
        editor.contentComponent = null;
        if (!editor.options.element.firstChild) return;
        const newElement = document.createElement("div");
        newElement.append(...editor.options.element.childNodes);
        editor.setOptions({
            element: newElement
        });
    }
    render() {
        const { editor: editor, innerRef: innerRef, ...rest } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
            ref: $3230bda81207e15e$var$mergeRefs(innerRef, this.editorContentRef),
            ...rest
        }), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($3230bda81207e15e$var$Portals, {
            renderers: this.state.renderers
        }));
    }
}
// EditorContent should be re-created whenever the Editor instance changes
const $3230bda81207e15e$var$EditorContentWithKey = (0, $f2Y41.forwardRef)((props, ref)=>{
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).useMemo(()=>{
        return Math.floor(Math.random() * 0xFFFFFFFF).toString();
    }, [
        props.editor
    ]);
    // Can't use JSX here because it conflicts with the type definition of Vue's JSX, so use createElement
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($3230bda81207e15e$export$2a77c1f2ea046ea6, {
        key: key,
        innerRef: ref,
        ...props
    });
});
const $3230bda81207e15e$export$a92c4e92ed722350 = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).memo($3230bda81207e15e$var$EditorContentWithKey);
class $3230bda81207e15e$export$7cda8d932e2f33c0 extends (0, $47959620e255098c$export$7cda8d932e2f33c0) {
    constructor(){
        super(...arguments);
        this.contentComponent = null;
    }
}
/**
 * This hook allows you to create an editor instance.
 * @param options The editor options
 * @param deps The dependencies to watch for changes
 * @returns The editor instance
 * @example const editor = useEditor({ extensions: [...] })
 */ const $3230bda81207e15e$export$43711a1418203bbc = (options = {}, deps = [])=>{
    const editorRef = (0, $f2Y41.useRef)(null);
    const [, forceUpdate] = (0, $f2Y41.useState)({});
    const { onBeforeCreate: onBeforeCreate, onBlur: onBlur, onCreate: onCreate, onDestroy: onDestroy, onFocus: onFocus, onSelectionUpdate: onSelectionUpdate, onTransaction: onTransaction, onUpdate: onUpdate } = options;
    const onBeforeCreateRef = (0, $f2Y41.useRef)(onBeforeCreate);
    const onBlurRef = (0, $f2Y41.useRef)(onBlur);
    const onCreateRef = (0, $f2Y41.useRef)(onCreate);
    const onDestroyRef = (0, $f2Y41.useRef)(onDestroy);
    const onFocusRef = (0, $f2Y41.useRef)(onFocus);
    const onSelectionUpdateRef = (0, $f2Y41.useRef)(onSelectionUpdate);
    const onTransactionRef = (0, $f2Y41.useRef)(onTransaction);
    const onUpdateRef = (0, $f2Y41.useRef)(onUpdate);
    // This effect will handle updating the editor instance
    // when the event handlers change.
    (0, $f2Y41.useEffect)(()=>{
        if (!editorRef.current) return;
        if (onBeforeCreate) {
            editorRef.current.off("beforeCreate", onBeforeCreateRef.current);
            editorRef.current.on("beforeCreate", onBeforeCreate);
            onBeforeCreateRef.current = onBeforeCreate;
        }
        if (onBlur) {
            editorRef.current.off("blur", onBlurRef.current);
            editorRef.current.on("blur", onBlur);
            onBlurRef.current = onBlur;
        }
        if (onCreate) {
            editorRef.current.off("create", onCreateRef.current);
            editorRef.current.on("create", onCreate);
            onCreateRef.current = onCreate;
        }
        if (onDestroy) {
            editorRef.current.off("destroy", onDestroyRef.current);
            editorRef.current.on("destroy", onDestroy);
            onDestroyRef.current = onDestroy;
        }
        if (onFocus) {
            editorRef.current.off("focus", onFocusRef.current);
            editorRef.current.on("focus", onFocus);
            onFocusRef.current = onFocus;
        }
        if (onSelectionUpdate) {
            editorRef.current.off("selectionUpdate", onSelectionUpdateRef.current);
            editorRef.current.on("selectionUpdate", onSelectionUpdate);
            onSelectionUpdateRef.current = onSelectionUpdate;
        }
        if (onTransaction) {
            editorRef.current.off("transaction", onTransactionRef.current);
            editorRef.current.on("transaction", onTransaction);
            onTransactionRef.current = onTransaction;
        }
        if (onUpdate) {
            editorRef.current.off("update", onUpdateRef.current);
            editorRef.current.on("update", onUpdate);
            onUpdateRef.current = onUpdate;
        }
    }, [
        onBeforeCreate,
        onBlur,
        onCreate,
        onDestroy,
        onFocus,
        onSelectionUpdate,
        onTransaction,
        onUpdate,
        editorRef.current
    ]);
    (0, $f2Y41.useEffect)(()=>{
        let isMounted = true;
        const editor = new $3230bda81207e15e$export$7cda8d932e2f33c0(options);
        editorRef.current = editor;
        editorRef.current.on("transaction", ()=>{
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (isMounted) forceUpdate({});
                });
            });
        });
        return ()=>{
            isMounted = false;
            editor.destroy();
        };
    }, deps);
    return editorRef.current;
};
const $3230bda81207e15e$export$27b8dd149e32f6c7 = (0, $f2Y41.createContext)({
    editor: null
});
const $3230bda81207e15e$export$ce13247582c535f7 = $3230bda81207e15e$export$27b8dd149e32f6c7.Consumer;
const $3230bda81207e15e$export$96c4d2ffb4c40e50 = ()=>(0, $f2Y41.useContext)($3230bda81207e15e$export$27b8dd149e32f6c7);
const $3230bda81207e15e$export$b0c14a64ec1678d5 = ({ children: children, slotAfter: slotAfter, slotBefore: slotBefore, ...editorOptions })=>{
    const editor = $3230bda81207e15e$export$43711a1418203bbc(editorOptions);
    if (!editor) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($3230bda81207e15e$export$27b8dd149e32f6c7.Provider, {
        value: {
            editor: editor
        }
    }, slotBefore, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($3230bda81207e15e$export$ce13247582c535f7, null, ({ editor: currentEditor })=>(0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($3230bda81207e15e$export$a92c4e92ed722350, {
            editor: currentEditor
        })), children, slotAfter);
};
const $3230bda81207e15e$export$79c1bf6a55bce827 = (props)=>{
    const [element, setElement] = (0, $f2Y41.useState)(null);
    const { editor: currentEditor } = $3230bda81207e15e$export$96c4d2ffb4c40e50();
    (0, $f2Y41.useEffect)(()=>{
        var _a;
        if (!element) return;
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) return;
        const { pluginKey: pluginKey = "bubbleMenu", editor: editor, tippyOptions: tippyOptions = {}, updateDelay: updateDelay, shouldShow: shouldShow = null } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
            return;
        }
        const plugin = (0, $25d75c61d759ea8d$export$20c12548414ed018)({
            updateDelay: updateDelay,
            editor: menuEditor,
            element: element,
            pluginKey: pluginKey,
            shouldShow: shouldShow,
            tippyOptions: tippyOptions
        });
        menuEditor.registerPlugin(plugin);
        return ()=>menuEditor.unregisterPlugin(pluginKey);
    }, [
        props.editor,
        currentEditor,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        ref: setElement,
        className: props.className,
        style: {
            visibility: "hidden"
        }
    }, props.children);
};
const $3230bda81207e15e$export$695cda69e78edecd = (props)=>{
    const [element, setElement] = (0, $f2Y41.useState)(null);
    const { editor: currentEditor } = $3230bda81207e15e$export$96c4d2ffb4c40e50();
    (0, $f2Y41.useEffect)(()=>{
        var _a;
        if (!element) return;
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) return;
        const { pluginKey: pluginKey = "floatingMenu", editor: editor, tippyOptions: tippyOptions = {}, shouldShow: shouldShow = null } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn("FloatingMenu component is not rendered inside of an editor component or does not have editor prop.");
            return;
        }
        const plugin = (0, $a2ac14caa799141a$export$5e50896e3f3c0d7b)({
            pluginKey: pluginKey,
            editor: menuEditor,
            element: element,
            tippyOptions: tippyOptions,
            shouldShow: shouldShow
        });
        menuEditor.registerPlugin(plugin);
        return ()=>menuEditor.unregisterPlugin(pluginKey);
    }, [
        props.editor,
        currentEditor,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement("div", {
        ref: setElement,
        className: props.className,
        style: {
            visibility: "hidden"
        }
    }, props.children);
};
const $3230bda81207e15e$export$3fef6c3187641c77 = (0, $f2Y41.createContext)({
    onDragStart: undefined
});
const $3230bda81207e15e$export$b6657ee1f2411c6 = ()=>(0, $f2Y41.useContext)($3230bda81207e15e$export$3fef6c3187641c77);
const $3230bda81207e15e$export$e44d28a41a78cbbb = (props)=>{
    const Tag = props.as || "div";
    const { nodeViewContentRef: nodeViewContentRef } = $3230bda81207e15e$export$b6657ee1f2411c6();
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Tag, {
        ...props,
        ref: nodeViewContentRef,
        "data-node-view-content": "",
        style: {
            whiteSpace: "pre-wrap",
            ...props.style
        }
    });
};
const $3230bda81207e15e$export$d02cc1f3e4390991 = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).forwardRef((props, ref)=>{
    const { onDragStart: onDragStart } = $3230bda81207e15e$export$b6657ee1f2411c6();
    const Tag = props.as || "div";
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Tag, {
        ...props,
        ref: ref,
        "data-node-view-wrapper": "",
        onDragStart: onDragStart,
        style: {
            whiteSpace: "normal",
            ...props.style
        }
    });
});
/**
 * Check if a component is a class component.
 * @param Component
 * @returns {boolean}
 */ function $3230bda81207e15e$var$isClassComponent(Component) {
    return !!(typeof Component === "function" && Component.prototype && Component.prototype.isReactComponent);
}
/**
 * Check if a component is a forward ref component.
 * @param Component
 * @returns {boolean}
 */ function $3230bda81207e15e$var$isForwardRefComponent(Component) {
    var _a;
    return !!(typeof Component === "object" && ((_a = Component.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === "Symbol(react.forward_ref)");
}
/**
 * The ReactRenderer class. It's responsible for rendering React components inside the editor.
 * @example
 * new ReactRenderer(MyComponent, {
 *   editor,
 *   props: {
 *     foo: 'bar',
 *   },
 *   as: 'span',
 * })
*/ class $3230bda81207e15e$export$687d546b0584d31b {
    constructor(component, { editor: editor, props: props = {}, as: as = "div", className: className = "", attrs: attrs }){
        this.ref = null;
        this.id = Math.floor(Math.random() * 0xFFFFFFFF).toString();
        this.component = component;
        this.editor = editor;
        this.props = props;
        this.element = document.createElement(as);
        this.element.classList.add("react-renderer");
        if (className) this.element.classList.add(...className.split(" "));
        if (attrs) Object.keys(attrs).forEach((key)=>{
            this.element.setAttribute(key, attrs[key]);
        });
        this.render();
    }
    render() {
        var _a, _b;
        const Component = this.component;
        const props = this.props;
        if ($3230bda81207e15e$var$isClassComponent(Component) || $3230bda81207e15e$var$isForwardRefComponent(Component)) props.ref = (ref)=>{
            this.ref = ref;
        };
        this.reactElement = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Component, {
            ...props
        });
        (_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) === null || _b === void 0 || _b.setRenderer(this.id, this);
    }
    updateProps(props = {}) {
        this.props = {
            ...this.props,
            ...props
        };
        this.render();
    }
    destroy() {
        var _a, _b;
        (_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) === null || _b === void 0 || _b.removeRenderer(this.id);
    }
}
class $3230bda81207e15e$var$ReactNodeView extends (0, $47959620e255098c$export$77c6811359a01a6f) {
    mount() {
        const props = {
            editor: this.editor,
            node: this.node,
            decorations: this.decorations,
            selected: false,
            extension: this.extension,
            getPos: ()=>this.getPos(),
            updateAttributes: (attributes = {})=>this.updateAttributes(attributes),
            deleteNode: ()=>this.deleteNode()
        };
        if (!this.component.displayName) {
            const capitalizeFirstChar = (string)=>{
                return string.charAt(0).toUpperCase() + string.substring(1);
            };
            this.component.displayName = capitalizeFirstChar(this.extension.name);
        }
        const ReactNodeViewProvider = (componentProps)=>{
            const Component = this.component;
            const onDragStart = this.onDragStart.bind(this);
            const nodeViewContentRef = (element)=>{
                if (element && this.contentDOMElement && element.firstChild !== this.contentDOMElement) element.appendChild(this.contentDOMElement);
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($3230bda81207e15e$export$3fef6c3187641c77.Provider, {
                value: {
                    onDragStart: onDragStart,
                    nodeViewContentRef: nodeViewContentRef
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Component, {
                ...componentProps
            })));
        };
        ReactNodeViewProvider.displayName = "ReactNodeView";
        if (this.node.isLeaf) this.contentDOMElement = null;
        else if (this.options.contentDOMElementTag) this.contentDOMElement = document.createElement(this.options.contentDOMElementTag);
        else this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div");
        if (this.contentDOMElement) // For some reason the whiteSpace prop is not inherited properly in Chrome and Safari
        // With this fix it seems to work fine
        // See: https://github.com/ueberdosis/tiptap/issues/1197
        this.contentDOMElement.style.whiteSpace = "inherit";
        let as = this.node.isInline ? "span" : "div";
        if (this.options.as) as = this.options.as;
        const { className: className = "" } = this.options;
        this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
        this.editor.on("selectionUpdate", this.handleSelectionUpdate);
        this.renderer = new $3230bda81207e15e$export$687d546b0584d31b(ReactNodeViewProvider, {
            editor: this.editor,
            props: props,
            as: as,
            className: `node-${this.node.type.name} ${className}`.trim(),
            attrs: this.options.attrs
        });
    }
    get dom() {
        var _a;
        if (this.renderer.element.firstElementChild && !((_a = this.renderer.element.firstElementChild) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-node-view-wrapper"))) throw Error("Please use the NodeViewWrapper component for your node view.");
        return this.renderer.element;
    }
    get contentDOM() {
        if (this.node.isLeaf) return null;
        return this.contentDOMElement;
    }
    handleSelectionUpdate() {
        const { from: from, to: to } = this.editor.state.selection;
        if (from <= this.getPos() && to >= this.getPos() + this.node.nodeSize) {
            if (this.renderer.props.selected) return;
            this.selectNode();
        } else {
            if (!this.renderer.props.selected) return;
            this.deselectNode();
        }
    }
    update(node, decorations) {
        const updateProps = (props)=>{
            this.renderer.updateProps(props);
        };
        if (node.type !== this.node.type) return false;
        if (typeof this.options.update === "function") {
            const oldNode = this.node;
            const oldDecorations = this.decorations;
            this.node = node;
            this.decorations = decorations;
            return this.options.update({
                oldNode: oldNode,
                oldDecorations: oldDecorations,
                newNode: node,
                newDecorations: decorations,
                updateProps: ()=>updateProps({
                        node: node,
                        decorations: decorations
                    })
            });
        }
        if (node === this.node && this.decorations === decorations) return true;
        this.node = node;
        this.decorations = decorations;
        updateProps({
            node: node,
            decorations: decorations
        });
        return true;
    }
    selectNode() {
        this.renderer.updateProps({
            selected: true
        });
        this.renderer.element.classList.add("ProseMirror-selectednode");
    }
    deselectNode() {
        this.renderer.updateProps({
            selected: false
        });
        this.renderer.element.classList.remove("ProseMirror-selectednode");
    }
    destroy() {
        this.renderer.destroy();
        this.editor.off("selectionUpdate", this.handleSelectionUpdate);
        this.contentDOMElement = null;
    }
}
function $3230bda81207e15e$export$478a6cea73a8df20(component, options) {
    return (props)=>{
        // try to get the parent component
        // this is important for vue devtools to show the component hierarchy correctly
        // maybe it’s `undefined` because <editor-content> isn’t rendered yet
        if (!props.editor.contentComponent) return {};
        return new $3230bda81207e15e$var$ReactNodeView(component, props, options);
    };
}




/**
 * Matches a blockquote to a `>` as input.
 */ const $7a282c1a56b92fcf$export$55b9391925fcc072 = /^\s*>\s$/;
/**
 * This extension allows you to create blockquotes.
 * @see https://tiptap.dev/api/nodes/blockquote
 */ const $7a282c1a56b92fcf$export$29a7a275fe11687 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "blockquote",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    content: "block+",
    group: "block",
    defining: true,
    parseHTML () {
        return [
            {
                tag: "blockquote"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "blockquote",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBlockquote: ()=>({ commands: commands })=>{
                    return commands.wrapIn(this.name);
                },
            toggleBlockquote: ()=>({ commands: commands })=>{
                    return commands.toggleWrap(this.name);
                },
            unsetBlockquote: ()=>({ commands: commands })=>{
                    return commands.lift(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-b": ()=>this.editor.commands.toggleBlockquote()
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$f7316d89abe4e1c1)({
                find: $7a282c1a56b92fcf$export$55b9391925fcc072,
                type: this.type
            })
        ];
    }
});



/**
 * Matches bold text via `**` as input.
 */ const $75769c370d8d97c7$export$73ba4776eeca629e = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */ const $75769c370d8d97c7$export$47b75d481b90409 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */ const $75769c370d8d97c7$export$79cd1d2695dae26d = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */ const $75769c370d8d97c7$export$9b623891dbc7bd12 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */ const $75769c370d8d97c7$export$95aa4184327d6b72 = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "bold",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "strong"
            },
            {
                tag: "b",
                getAttrs: (node)=>node.style.fontWeight !== "normal" && null
            },
            {
                style: "font-weight",
                getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "strong",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBold: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleBold: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetBold: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-b": ()=>this.editor.commands.toggleBold(),
            "Mod-B": ()=>this.editor.commands.toggleBold()
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$9f2cb743ab9131de)({
                find: $75769c370d8d97c7$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $47959620e255098c$export$9f2cb743ab9131de)({
                find: $75769c370d8d97c7$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $47959620e255098c$export$3845eb97abe74944)({
                find: $75769c370d8d97c7$export$47b75d481b90409,
                type: this.type
            }),
            (0, $47959620e255098c$export$3845eb97abe74944)({
                find: $75769c370d8d97c7$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});



/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $ff735bb16037d402$var$ListItem = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "listItem",
    addOptions () {
        return {
            HTMLAttributes: {},
            bulletListTypeName: "bulletList",
            orderedListTypeName: "orderedList"
        };
    },
    content: "paragraph block*",
    defining: true,
    parseHTML () {
        return [
            {
                tag: "li"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "li",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addKeyboardShortcuts () {
        return {
            Enter: ()=>this.editor.commands.splitListItem(this.name),
            Tab: ()=>this.editor.commands.sinkListItem(this.name),
            "Shift-Tab": ()=>this.editor.commands.liftListItem(this.name)
        };
    }
});
/**
 * This extension allows you to create text styles. It is required by default
 * for the `textColor` and `backgroundColor` extensions.
 * @see https://www.tiptap.dev/api/marks/text-style
 */ const $ff735bb16037d402$var$TextStyle = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "textStyle",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "span",
                getAttrs: (element)=>{
                    const hasStyles = element.hasAttribute("style");
                    if (!hasStyles) return false;
                    return {};
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "span",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            removeEmptyTextStyle: ()=>({ state: state, commands: commands })=>{
                    const attributes = (0, $47959620e255098c$export$2cd1d0e1f861bae0)(state, this.type);
                    const hasStyles = Object.entries(attributes).some(([, value])=>!!value);
                    if (hasStyles) return true;
                    return commands.unsetMark(this.name);
                }
        };
    }
});
/**
 * Matches a bullet list to a dash or asterisk.
 */ const $ff735bb16037d402$export$55b9391925fcc072 = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */ const $ff735bb16037d402$export$546f606c73d35982 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "bulletList",
    addOptions () {
        return {
            itemTypeName: "listItem",
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: "block list",
    content () {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML () {
        return [
            {
                tag: "ul"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "ul",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleBulletList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($ff735bb16037d402$var$ListItem.name, this.editor.getAttributes($ff735bb16037d402$var$TextStyle.name)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-8": ()=>this.editor.commands.toggleBulletList()
        };
    },
    addInputRules () {
        let inputRule = (0, $47959620e255098c$export$f7316d89abe4e1c1)({
            find: $ff735bb16037d402$export$55b9391925fcc072,
            type: this.type
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $47959620e255098c$export$f7316d89abe4e1c1)({
            find: $ff735bb16037d402$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: ()=>{
                return this.editor.getAttributes($ff735bb16037d402$var$TextStyle.name);
            },
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});



/**
 * Matches inline code.
 */ const $3acccbf048a74b80$export$55b9391925fcc072 = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))$/;
/**
 * Matches inline code while pasting.
 */ const $3acccbf048a74b80$export$4ed30f8936af1979 = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))/g;
/**
 * This extension allows you to mark text as inline code.
 * @see https://tiptap.dev/api/marks/code
 */ const $3acccbf048a74b80$export$52f0f02147b12c03 = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "code",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    excludes: "_",
    code: true,
    exitable: true,
    parseHTML () {
        return [
            {
                tag: "code"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "code",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setCode: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleCode: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetCode: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-e": ()=>this.editor.commands.toggleCode()
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$9f2cb743ab9131de)({
                find: $3acccbf048a74b80$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $47959620e255098c$export$3845eb97abe74944)({
                find: $3acccbf048a74b80$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});




/**
 * Matches a code block with backticks.
 */ const $547a93f4ca6676d1$export$4f70c75119de8367 = /^```([a-z]+)?[\s\n]$/;
/**
 * Matches a code block with tildes.
 */ const $547a93f4ca6676d1$export$ab3d90a1a99abb84 = /^~~~([a-z]+)?[\s\n]$/;
/**
 * This extension allows you to create code blocks.
 * @see https://tiptap.dev/api/nodes/code-block
 */ const $547a93f4ca6676d1$export$6c415d1fdae3dfdb = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "codeBlock",
    addOptions () {
        return {
            languageClassPrefix: "language-",
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            HTMLAttributes: {}
        };
    },
    content: "text*",
    marks: "",
    group: "block",
    code: true,
    defining: true,
    addAttributes () {
        return {
            language: {
                default: null,
                parseHTML: (element)=>{
                    var _a;
                    const { languageClassPrefix: languageClassPrefix } = this.options;
                    const classNames = [
                        ...((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || []
                    ];
                    const languages = classNames.filter((className)=>className.startsWith(languageClassPrefix)).map((className)=>className.replace(languageClassPrefix, ""));
                    const language = languages[0];
                    if (!language) return null;
                    return language;
                },
                rendered: false
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: "pre",
                preserveWhitespace: "full"
            }
        ];
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        return [
            "pre",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            [
                "code",
                {
                    class: node.attrs.language ? this.options.languageClassPrefix + node.attrs.language : null
                },
                0
            ]
        ];
    },
    addCommands () {
        return {
            setCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.setNode(this.name, attributes);
                },
            toggleCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.toggleNode(this.name, "paragraph", attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Alt-c": ()=>this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: ()=>{
                const { empty: empty, $anchor: $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) return false;
                if (isAtStart || !$anchor.parent.textContent.length) return this.editor.commands.clearNodes();
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor: editor })=>{
                if (!this.options.exitOnTripleEnter) return false;
                const { state: state } = editor;
                const { selection: selection } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith("\n\n");
                if (!isAtEnd || !endsWithDoubleNewline) return false;
                return editor.chain().command(({ tr: tr })=>{
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                }).exitCode().run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor: editor })=>{
                if (!this.options.exitOnArrowDown) return false;
                const { state: state } = editor;
                const { selection: selection, doc: doc } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) return false;
                const after = $from.after();
                if (after === undefined) return false;
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) return false;
                return editor.commands.exitCode();
            }
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$cc081314d3f6ffb0)({
                find: $547a93f4ca6676d1$export$4f70c75119de8367,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            }),
            (0, $47959620e255098c$export$cc081314d3f6ffb0)({
                find: $547a93f4ca6676d1$export$ab3d90a1a99abb84,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            })
        ];
    },
    addProseMirrorPlugins () {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
                key: new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("codeBlockVSCodeHandler"),
                props: {
                    handlePaste: (view, event)=>{
                        if (!event.clipboardData) return false;
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) return false;
                        const text = event.clipboardData.getData("text/plain");
                        const vscode = event.clipboardData.getData("vscode-editor-data");
                        const vscodeData = vscode ? JSON.parse(vscode) : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) return false;
                        const { tr: tr } = view.state;
                        // create an empty code block´
                        // if the cursor is at the absolute end of the document, insert the code block before the cursor instead
                        // of replacing the selection as the replaceSelectionWith function will cause the insertion to
                        // happen at the previous node
                        if (view.state.selection.from === view.state.doc.nodeSize - (1 + view.state.selection.$to.depth * 2)) tr.insert(view.state.selection.from - 1, this.type.create({
                            language: language
                        }));
                        else tr.replaceSelectionWith(this.type.create({
                            language: language
                        }));
                        // put cursor inside the newly created code block
                        tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        // add text to code block
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        tr.insertText(text.replace(/\r\n?/g, "\n"));
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta("paste", true);
                        view.dispatch(tr);
                        return true;
                    }
                }
            })
        ];
    }
});



/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */ const $1c500e03269a40b3$export$b34a105447964f9f = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "doc",
    topNode: true,
    content: "block+"
});



// dropcursor/index.ts


/**
Create a plugin that, when added to a ProseMirror instance,
causes a decoration to show up at the drop position when something
is dragged over the editor.

Nodes may add a `disableDropCursor` property to their spec to
control the showing of a drop cursor inside them. This may be a
boolean or a function, which will be called with a view and a
position, and should return a boolean.
*/ function $2f0f802a248ec39c$export$b8e3092a3bfa2062(options = {}) {
    return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        view (editorView) {
            return new $2f0f802a248ec39c$var$DropCursorView(editorView, options);
        }
    });
}
class $2f0f802a248ec39c$var$DropCursorView {
    constructor(editorView, options){
        var _a;
        this.editorView = editorView;
        this.cursorPos = null;
        this.element = null;
        this.timeout = -1;
        this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
        this.color = options.color === false ? undefined : options.color || "black";
        this.class = options.class;
        this.handlers = [
            "dragover",
            "dragend",
            "drop",
            "dragleave"
        ].map((name)=>{
            let handler = (e)=>{
                this[name](e);
            };
            editorView.dom.addEventListener(name, handler);
            return {
                name: name,
                handler: handler
            };
        });
    }
    destroy() {
        this.handlers.forEach(({ name: name, handler: handler })=>this.editorView.dom.removeEventListener(name, handler));
    }
    update(editorView, prevState) {
        if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
            if (this.cursorPos > editorView.state.doc.content.size) this.setCursor(null);
            else this.updateOverlay();
        }
    }
    setCursor(pos) {
        if (pos == this.cursorPos) return;
        this.cursorPos = pos;
        if (pos == null) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        } else this.updateOverlay();
    }
    updateOverlay() {
        let $pos = this.editorView.state.doc.resolve(this.cursorPos);
        let isBlock = !$pos.parent.inlineContent, rect;
        if (isBlock) {
            let before = $pos.nodeBefore, after = $pos.nodeAfter;
            if (before || after) {
                let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
                if (node) {
                    let nodeRect = node.getBoundingClientRect();
                    let top = before ? nodeRect.bottom : nodeRect.top;
                    if (before && after) top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
                    rect = {
                        left: nodeRect.left,
                        right: nodeRect.right,
                        top: top - this.width / 2,
                        bottom: top + this.width / 2
                    };
                }
            }
        }
        if (!rect) {
            let coords = this.editorView.coordsAtPos(this.cursorPos);
            rect = {
                left: coords.left - this.width / 2,
                right: coords.left + this.width / 2,
                top: coords.top,
                bottom: coords.bottom
            };
        }
        let parent = this.editorView.dom.offsetParent;
        if (!this.element) {
            this.element = parent.appendChild(document.createElement("div"));
            if (this.class) this.element.className = this.class;
            this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
            if (this.color) this.element.style.backgroundColor = this.color;
        }
        this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
        this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
        let parentLeft, parentTop;
        if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
            parentLeft = -pageXOffset;
            parentTop = -pageYOffset;
        } else {
            let rect = parent.getBoundingClientRect();
            parentLeft = rect.left - parent.scrollLeft;
            parentTop = rect.top - parent.scrollTop;
        }
        this.element.style.left = rect.left - parentLeft + "px";
        this.element.style.top = rect.top - parentTop + "px";
        this.element.style.width = rect.right - rect.left + "px";
        this.element.style.height = rect.bottom - rect.top + "px";
    }
    scheduleRemoval(timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(()=>this.setCursor(null), timeout);
    }
    dragover(event) {
        if (!this.editorView.editable) return;
        let pos = this.editorView.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
        let disableDropCursor = node && node.type.spec.disableDropCursor;
        let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
        if (pos && !disabled) {
            let target = pos.pos;
            if (this.editorView.dragging && this.editorView.dragging.slice) {
                let point = (0, $82f7355673365313$export$2819d598d048fc9c)(this.editorView.state.doc, target, this.editorView.dragging.slice);
                if (point != null) target = point;
            }
            this.setCursor(target);
            this.scheduleRemoval(5000);
        }
    }
    dragend() {
        this.scheduleRemoval(20);
    }
    drop() {
        this.scheduleRemoval(20);
    }
    dragleave(event) {
        if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget)) this.setCursor(null);
    }
}




/**
 * This extension allows you to add a drop cursor to your editor.
 * A drop cursor is a line that appears when you drag and drop content
 * inbetween nodes.
 * @see https://tiptap.dev/api/extensions/dropcursor
 */ const $9d9a1d2dc85cedc5$export$bc16731f26f3900d = (0, $47959620e255098c$export$eeddbf09bb970356).create({
    name: "dropCursor",
    addOptions () {
        return {
            color: "currentColor",
            width: 1,
            class: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $2f0f802a248ec39c$export$b8e3092a3bfa2062)(this.options)
        ];
    }
});



// gapcursor/index.ts




/**
Gap cursor selections are represented using this class. Its
`$anchor` and `$head` properties both point at the cursor position.
*/ class $fa453e1876d257e6$export$3d3d259665dcb4d4 extends (0, $a24eacb5c8b3ccab$export$52baac22726c72bf) {
    /**
    Create a gap cursor.
    */ constructor($pos){
        super($pos, $pos);
    }
    map(doc, mapping) {
        let $pos = doc.resolve(mapping.map(this.head));
        return $fa453e1876d257e6$export$3d3d259665dcb4d4.valid($pos) ? new $fa453e1876d257e6$export$3d3d259665dcb4d4($pos) : (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near($pos);
    }
    content() {
        return (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e).empty;
    }
    eq(other) {
        return other instanceof $fa453e1876d257e6$export$3d3d259665dcb4d4 && other.head == this.head;
    }
    toJSON() {
        return {
            type: "gapcursor",
            pos: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for GapCursor.fromJSON");
        return new $fa453e1876d257e6$export$3d3d259665dcb4d4(doc.resolve(json.pos));
    }
    /**
    @internal
    */ getBookmark() {
        return new $fa453e1876d257e6$var$GapBookmark(this.anchor);
    }
    /**
    @internal
    */ static valid($pos) {
        let parent = $pos.parent;
        if (parent.isTextblock || !$fa453e1876d257e6$var$closedBefore($pos) || !$fa453e1876d257e6$var$closedAfter($pos)) return false;
        let override = parent.type.spec.allowGapCursor;
        if (override != null) return override;
        let deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    /**
    @internal
    */ static findGapCursorFrom($pos, dir, mustMove = false) {
        search: for(;;){
            if (!mustMove && $fa453e1876d257e6$export$3d3d259665dcb4d4.valid($pos)) return $pos;
            let pos = $pos.pos, next = null;
            // Scan up from this position
            for(let d = $pos.depth;; d--){
                let parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d == 0) return null;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($fa453e1876d257e6$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            // And then down into the next node
            for(;;){
                let inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !(0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($fa453e1876d257e6$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            return null;
        }
    }
}
$fa453e1876d257e6$export$3d3d259665dcb4d4.prototype.visible = false;
$fa453e1876d257e6$export$3d3d259665dcb4d4.findFrom = $fa453e1876d257e6$export$3d3d259665dcb4d4.findGapCursorFrom;
(0, $a24eacb5c8b3ccab$export$52baac22726c72bf).jsonID("gapcursor", $fa453e1876d257e6$export$3d3d259665dcb4d4);
class $fa453e1876d257e6$var$GapBookmark {
    constructor(pos){
        this.pos = pos;
    }
    map(mapping) {
        return new $fa453e1876d257e6$var$GapBookmark(mapping.map(this.pos));
    }
    resolve(doc) {
        let $pos = doc.resolve(this.pos);
        return $fa453e1876d257e6$export$3d3d259665dcb4d4.valid($pos) ? new $fa453e1876d257e6$export$3d3d259665dcb4d4($pos) : (0, $a24eacb5c8b3ccab$export$52baac22726c72bf).near($pos);
    }
}
function $fa453e1876d257e6$var$closedBefore($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.index(d), parent = $pos.node(d);
        // At the start of this parent, look at next one
        if (index == 0) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        // See if the node before (or its first ancestor) is closed
        for(let before = parent.child(index - 1);; before = before.lastChild){
            if (before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) return true;
            if (before.inlineContent) return false;
        }
    }
    // Hit start of document
    return true;
}
function $fa453e1876d257e6$var$closedAfter($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.indexAfter(d), parent = $pos.node(d);
        if (index == parent.childCount) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        for(let after = parent.child(index);; after = after.firstChild){
            if (after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) return true;
            if (after.inlineContent) return false;
        }
    }
    return true;
}
/**
Create a gap cursor plugin. When enabled, this will capture clicks
near and arrow-key-motion past places that don't have a normally
selectable position nearby, and create a gap cursor selection for
them. The cursor is drawn as an element with class
`ProseMirror-gapcursor`. You can either include
`style/gapcursor.css` from the package's directory or add your own
styles to make it visible.
*/ function $fa453e1876d257e6$export$54f46a1492d5247() {
    return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        props: {
            decorations: $fa453e1876d257e6$var$drawGapCursor,
            createSelectionBetween (_view, $anchor, $head) {
                return $anchor.pos == $head.pos && $fa453e1876d257e6$export$3d3d259665dcb4d4.valid($head) ? new $fa453e1876d257e6$export$3d3d259665dcb4d4($head) : null;
            },
            handleClick: $fa453e1876d257e6$var$handleClick,
            handleKeyDown: $fa453e1876d257e6$var$handleKeyDown,
            handleDOMEvents: {
                beforeinput: $fa453e1876d257e6$var$beforeinput
            }
        }
    });
}
const $fa453e1876d257e6$var$handleKeyDown = (0, $54e5867f52850bef$export$53f558754f8b9fd1)({
    "ArrowLeft": $fa453e1876d257e6$var$arrow("horiz", -1),
    "ArrowRight": $fa453e1876d257e6$var$arrow("horiz", 1),
    "ArrowUp": $fa453e1876d257e6$var$arrow("vert", -1),
    "ArrowDown": $fa453e1876d257e6$var$arrow("vert", 1)
});
function $fa453e1876d257e6$var$arrow(axis, dir) {
    const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
    return function(state, dispatch, view) {
        let sel = state.selection;
        let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
        if (sel instanceof (0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb)) {
            if (!view.endOfTextblock(dirStr) || $start.depth == 0) return false;
            mustMove = false;
            $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
        }
        let $found = $fa453e1876d257e6$export$3d3d259665dcb4d4.findGapCursorFrom($start, dir, mustMove);
        if (!$found) return false;
        if (dispatch) dispatch(state.tr.setSelection(new $fa453e1876d257e6$export$3d3d259665dcb4d4($found)));
        return true;
    };
}
function $fa453e1876d257e6$var$handleClick(view, pos, event) {
    if (!view || !view.editable) return false;
    let $pos = view.state.doc.resolve(pos);
    if (!$fa453e1876d257e6$export$3d3d259665dcb4d4.valid($pos)) return false;
    let clickPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (clickPos && clickPos.inside > -1 && (0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).isSelectable(view.state.doc.nodeAt(clickPos.inside))) return false;
    view.dispatch(view.state.tr.setSelection(new $fa453e1876d257e6$export$3d3d259665dcb4d4($pos)));
    return true;
}
// This is a hack that, when a composition starts while a gap cursor
// is active, quickly creates an inline context for the composition to
// happen in, to avoid it being aborted by the DOM selection being
// moved into a valid position.
function $fa453e1876d257e6$var$beforeinput(view, event) {
    if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof $fa453e1876d257e6$export$3d3d259665dcb4d4)) return false;
    let { $from: $from } = view.state.selection;
    let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
    if (!insert) return false;
    let frag = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).empty;
    for(let i = insert.length - 1; i >= 0; i--)frag = (0, $d3a8f56ade4880df$export$ffb0004e005737fa).from(insert[i].createAndFill(null, frag));
    let tr = view.state.tr.replace($from.pos, $from.pos, new (0, $d3a8f56ade4880df$export$b3f2e2de3a8baa1e)(frag, 0, 0));
    tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).near(tr.doc.resolve($from.pos + 1)));
    view.dispatch(tr);
    return false;
}
function $fa453e1876d257e6$var$drawGapCursor(state) {
    if (!(state.selection instanceof $fa453e1876d257e6$export$3d3d259665dcb4d4)) return null;
    let node = document.createElement("div");
    node.className = "ProseMirror-gapcursor";
    return (0, $41324cd97564f577$export$93bf62eb445cec98).create(state.doc, [
        (0, $41324cd97564f577$export$10e30b733df217ea).widget(state.selection.head, node, {
            key: "gapcursor"
        })
    ]);
}




/**
 * This extension allows you to add a gap cursor to your editor.
 * A gap cursor is a cursor that appears when you click on a place
 * where no content is present, for example inbetween nodes.
 * @see https://tiptap.dev/api/extensions/gapcursor
 */ const $ff5c7c750b8e1cbd$export$79c3dcaa03287f63 = (0, $47959620e255098c$export$eeddbf09bb970356).create({
    name: "gapCursor",
    addProseMirrorPlugins () {
        return [
            (0, $fa453e1876d257e6$export$54f46a1492d5247)()
        ];
    },
    extendNodeSchema (extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        return {
            allowGapCursor: (_a = (0, $47959620e255098c$export$592682234826c0bd)((0, $47959620e255098c$export$f73578b718a57eaa)(extension, "allowGapCursor", context))) !== null && _a !== void 0 ? _a : null
        };
    }
});



/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */ const $dd85d90465466667$export$d3d3fac13fa635d9 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "hardBreak",
    addOptions () {
        return {
            keepMarks: true,
            HTMLAttributes: {}
        };
    },
    inline: true,
    group: "inline",
    selectable: false,
    parseHTML () {
        return [
            {
                tag: "br"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "br",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    renderText () {
        return "\n";
    },
    addCommands () {
        return {
            setHardBreak: ()=>({ commands: commands, chain: chain, state: state, editor: editor })=>{
                    return commands.first([
                        ()=>commands.exitCode(),
                        ()=>commands.command(()=>{
                                const { selection: selection, storedMarks: storedMarks } = state;
                                if (selection.$from.parent.type.spec.isolating) return false;
                                const { keepMarks: keepMarks } = this.options;
                                const { splittableMarks: splittableMarks } = editor.extensionManager;
                                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                                return chain().insertContent({
                                    type: this.name
                                }).command(({ tr: tr, dispatch: dispatch })=>{
                                    if (dispatch && marks && keepMarks) {
                                        const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                                        tr.ensureMarks(filteredMarks);
                                    }
                                    return true;
                                }).run();
                            })
                    ]);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Enter": ()=>this.editor.commands.setHardBreak(),
            "Shift-Enter": ()=>this.editor.commands.setHardBreak()
        };
    }
});



/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */ const $e3a098df68c31f00$export$a8a3e93435678ff9 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "heading",
    addOptions () {
        return {
            levels: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            HTMLAttributes: {}
        };
    },
    content: "inline*",
    group: "block",
    defining: true,
    addAttributes () {
        return {
            level: {
                default: 1,
                rendered: false
            }
        };
    },
    parseHTML () {
        return this.options.levels.map((level)=>({
                tag: `h${level}`,
                attrs: {
                    level: level
                }
            }));
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel ? node.attrs.level : this.options.levels[0];
        return [
            `h${level}`,
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.setNode(this.name, attributes);
                },
            toggleHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.toggleNode(this.name, "paragraph", attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return this.options.levels.reduce((items, level)=>({
                ...items,
                [`Mod-Alt-${level}`]: ()=>this.editor.commands.toggleHeading({
                        level: level
                    })
            }), {});
    },
    addInputRules () {
        return this.options.levels.map((level)=>{
            return (0, $47959620e255098c$export$cc081314d3f6ffb0)({
                find: new RegExp(`^(#{1,${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level: level
                }
            });
        });
    }
});



// history/index.ts
var $8b82cea7f457792d$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $8b82cea7f457792d$var$RopeSequence = function RopeSequence() {};
$8b82cea7f457792d$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $8b82cea7f457792d$var$RopeSequence.from(other);
    return !this.length && other || other.length < $8b82cea7f457792d$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $8b82cea7f457792d$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$8b82cea7f457792d$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $8b82cea7f457792d$var$RopeSequence.from(other).append(this);
};
$8b82cea7f457792d$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $8b82cea7f457792d$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$8b82cea7f457792d$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $8b82cea7f457792d$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$8b82cea7f457792d$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$8b82cea7f457792d$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$8b82cea7f457792d$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$8b82cea7f457792d$var$RopeSequence.from = function from(values) {
    if (values instanceof $8b82cea7f457792d$var$RopeSequence) return values;
    return values && values.length ? new $8b82cea7f457792d$var$Leaf(values) : $8b82cea7f457792d$var$RopeSequence.empty;
};
var $8b82cea7f457792d$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $8b82cea7f457792d$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $8b82cea7f457792d$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($8b82cea7f457792d$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$8b82cea7f457792d$var$RopeSequence.empty = new $8b82cea7f457792d$var$Leaf([]);
var $8b82cea7f457792d$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($8b82cea7f457792d$var$RopeSequence);
var $8b82cea7f457792d$export$2e2bcd8739ae039 = $8b82cea7f457792d$var$RopeSequence;




// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $4a96abc388e5b6e2$var$max_empty_items = 500;
class $4a96abc388e5b6e2$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $4a96abc388e5b6e2$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $4a96abc388e5b6e2$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $4a96abc388e5b6e2$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $4a96abc388e5b6e2$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $4a96abc388e5b6e2$var$DEPTH_OVERFLOW) {
            oldItems = $4a96abc388e5b6e2$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $4a96abc388e5b6e2$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $82f7355673365313$export$f5f785078011b62);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $4a96abc388e5b6e2$var$Branch(this.items.append(array.map((map)=>new $4a96abc388e5b6e2$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $4a96abc388e5b6e2$var$Item(map, step, selection));
            } else rebasedItems.push(new $4a96abc388e5b6e2$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $4a96abc388e5b6e2$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $4a96abc388e5b6e2$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $4a96abc388e5b6e2$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $4a96abc388e5b6e2$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $4a96abc388e5b6e2$var$Branch((0, $8b82cea7f457792d$export$2e2bcd8739ae039).from(items.reverse()), events);
    }
}
$4a96abc388e5b6e2$var$Branch.empty = new $4a96abc388e5b6e2$var$Branch((0, $8b82cea7f457792d$export$2e2bcd8739ae039).empty, 0);
function $4a96abc388e5b6e2$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $4a96abc388e5b6e2$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $4a96abc388e5b6e2$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $4a96abc388e5b6e2$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $4a96abc388e5b6e2$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $4a96abc388e5b6e2$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($4a96abc388e5b6e2$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($4a96abc388e5b6e2$var$closeHistoryKey)) history = new $4a96abc388e5b6e2$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($4a96abc388e5b6e2$var$historyKey)) {
        if (appended.getMeta($4a96abc388e5b6e2$var$historyKey).redo) return new $4a96abc388e5b6e2$var$HistoryState(history.done.addTransform(tr, undefined, options, $4a96abc388e5b6e2$var$mustPreserveItems(state)), history.undone, $4a96abc388e5b6e2$var$rangesFor(tr.mapping.maps[tr.steps.length - 1]), history.prevTime, history.prevComposition);
        else return new $4a96abc388e5b6e2$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $4a96abc388e5b6e2$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$4a96abc388e5b6e2$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $4a96abc388e5b6e2$var$mapRanges(history.prevRanges, tr.mapping) : $4a96abc388e5b6e2$var$rangesFor(tr.mapping.maps[tr.steps.length - 1]);
        return new $4a96abc388e5b6e2$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $4a96abc388e5b6e2$var$mustPreserveItems(state)), $4a96abc388e5b6e2$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $4a96abc388e5b6e2$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $4a96abc388e5b6e2$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $4a96abc388e5b6e2$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $4a96abc388e5b6e2$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $4a96abc388e5b6e2$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $4a96abc388e5b6e2$var$rangesFor(map) {
    let result = [];
    map.forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $4a96abc388e5b6e2$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $4a96abc388e5b6e2$var$histTransaction(history, state, redo) {
    let preserveItems = $4a96abc388e5b6e2$var$mustPreserveItems(state);
    let histOptions = $4a96abc388e5b6e2$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $4a96abc388e5b6e2$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($4a96abc388e5b6e2$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $4a96abc388e5b6e2$var$cachedPreserveItems = false, $4a96abc388e5b6e2$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $4a96abc388e5b6e2$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($4a96abc388e5b6e2$var$cachedPreserveItemsPlugins != plugins) {
        $4a96abc388e5b6e2$var$cachedPreserveItems = false;
        $4a96abc388e5b6e2$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $4a96abc388e5b6e2$var$cachedPreserveItems = true;
            break;
        }
    }
    return $4a96abc388e5b6e2$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $4a96abc388e5b6e2$export$181a649d919c589e(tr) {
    return tr.setMeta($4a96abc388e5b6e2$var$closeHistoryKey, true);
}
const $4a96abc388e5b6e2$var$historyKey = new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("history");
const $4a96abc388e5b6e2$var$closeHistoryKey = new (0, $a24eacb5c8b3ccab$export$1692d8b0e89cecc3)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $4a96abc388e5b6e2$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $a24eacb5c8b3ccab$export$901cf72dabf2112a)({
        key: $4a96abc388e5b6e2$var$historyKey,
        state: {
            init () {
                return new $4a96abc388e5b6e2$var$HistoryState($4a96abc388e5b6e2$var$Branch.empty, $4a96abc388e5b6e2$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $4a96abc388e5b6e2$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $4a96abc388e5b6e2$export$21f930c44940fd98 : inputType == "historyRedo" ? $4a96abc388e5b6e2$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $4a96abc388e5b6e2$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $4a96abc388e5b6e2$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $4a96abc388e5b6e2$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $4a96abc388e5b6e2$export$21f930c44940fd98 = $4a96abc388e5b6e2$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $4a96abc388e5b6e2$export$1688e416fee0a49e = $4a96abc388e5b6e2$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $4a96abc388e5b6e2$export$24b5d280435f3a3f = $4a96abc388e5b6e2$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $4a96abc388e5b6e2$export$3774e54bae7be19b = $4a96abc388e5b6e2$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $4a96abc388e5b6e2$export$f8a176c2b9a10bdb(state) {
    let hist = $4a96abc388e5b6e2$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $4a96abc388e5b6e2$export$3ffe6b288e7d941b(state) {
    let hist = $4a96abc388e5b6e2$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}




/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */ const $e1d68a1a60af599c$export$84202caead5689ba = (0, $47959620e255098c$export$eeddbf09bb970356).create({
    name: "history",
    addOptions () {
        return {
            depth: 100,
            newGroupDelay: 500
        };
    },
    addCommands () {
        return {
            undo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $4a96abc388e5b6e2$export$21f930c44940fd98)(state, dispatch);
                },
            redo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $4a96abc388e5b6e2$export$1688e416fee0a49e)(state, dispatch);
                }
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $4a96abc388e5b6e2$export$55abd4691b317664)(this.options)
        ];
    },
    addKeyboardShortcuts () {
        return {
            "Mod-z": ()=>this.editor.commands.undo(),
            "Shift-Mod-z": ()=>this.editor.commands.redo(),
            "Mod-y": ()=>this.editor.commands.redo(),
            // Russian keyboard layouts
            "Mod-\u044F": ()=>this.editor.commands.undo(),
            "Shift-Mod-\u044F": ()=>this.editor.commands.redo()
        };
    }
});




/**
 * This extension allows you to insert horizontal rules.
 * @see https://www.tiptap.dev/api/nodes/horizontal-rule
 */ const $5c05edf4bbd4c3ce$export$841e9c95e6429474 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "horizontalRule",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: "block",
    parseHTML () {
        return [
            {
                tag: "hr"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "hr",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    addCommands () {
        return {
            setHorizontalRule: ()=>({ chain: chain, state: state })=>{
                    const { $to: $originTo } = state.selection;
                    const currentChain = chain();
                    if ($originTo.parentOffset === 0) currentChain.insertContentAt(Math.max($originTo.pos - 2, 0), {
                        type: this.name
                    });
                    else currentChain.insertContent({
                        type: this.name
                    });
                    return currentChain// set cursor after horizontal rule
                    .command(({ tr: tr, dispatch: dispatch })=>{
                        var _a;
                        if (dispatch) {
                            const { $to: $to } = tr.selection;
                            const posAfter = $to.end();
                            if ($to.nodeAfter) {
                                if ($to.nodeAfter.isTextblock) tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(tr.doc, $to.pos + 1));
                                else if ($to.nodeAfter.isBlock) tr.setSelection((0, $a24eacb5c8b3ccab$export$e2940151ac854c0b).create(tr.doc, $to.pos));
                                else tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(tr.doc, $to.pos));
                            } else {
                                // add node after horizontal rule if it’s the end of the document
                                const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                                if (node) {
                                    tr.insert(posAfter, node);
                                    tr.setSelection((0, $a24eacb5c8b3ccab$export$c2b25f346d19bcbb).create(tr.doc, posAfter + 1));
                                }
                            }
                            tr.scrollIntoView();
                        }
                        return true;
                    }).run();
                }
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$6ca56856dfeaf9b6)({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type
            })
        ];
    }
});



/**
 * Matches an italic to a *italic* on input.
 */ const $833b2246fcbb5c2b$export$73ba4776eeca629e = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */ const $833b2246fcbb5c2b$export$47b75d481b90409 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */ const $833b2246fcbb5c2b$export$79cd1d2695dae26d = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */ const $833b2246fcbb5c2b$export$9b623891dbc7bd12 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */ const $833b2246fcbb5c2b$export$1cfcf4275506b1c6 = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "italic",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "em"
            },
            {
                tag: "i",
                getAttrs: (node)=>node.style.fontStyle !== "normal" && null
            },
            {
                style: "font-style=italic"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "em",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setItalic: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleItalic: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetItalic: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-i": ()=>this.editor.commands.toggleItalic(),
            "Mod-I": ()=>this.editor.commands.toggleItalic()
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$9f2cb743ab9131de)({
                find: $833b2246fcbb5c2b$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $47959620e255098c$export$9f2cb743ab9131de)({
                find: $833b2246fcbb5c2b$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $47959620e255098c$export$3845eb97abe74944)({
                find: $833b2246fcbb5c2b$export$47b75d481b90409,
                type: this.type
            }),
            (0, $47959620e255098c$export$3845eb97abe74944)({
                find: $833b2246fcbb5c2b$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});




/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $5788b9aaf9ecd7bc$var$ListItem = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "listItem",
    addOptions () {
        return {
            HTMLAttributes: {},
            bulletListTypeName: "bulletList",
            orderedListTypeName: "orderedList"
        };
    },
    content: "paragraph block*",
    defining: true,
    parseHTML () {
        return [
            {
                tag: "li"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "li",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addKeyboardShortcuts () {
        return {
            Enter: ()=>this.editor.commands.splitListItem(this.name),
            Tab: ()=>this.editor.commands.sinkListItem(this.name),
            "Shift-Tab": ()=>this.editor.commands.liftListItem(this.name)
        };
    }
});
/**
 * This extension allows you to create text styles. It is required by default
 * for the `textColor` and `backgroundColor` extensions.
 * @see https://www.tiptap.dev/api/marks/text-style
 */ const $5788b9aaf9ecd7bc$var$TextStyle = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "textStyle",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "span",
                getAttrs: (element)=>{
                    const hasStyles = element.hasAttribute("style");
                    if (!hasStyles) return false;
                    return {};
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "span",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            removeEmptyTextStyle: ()=>({ state: state, commands: commands })=>{
                    const attributes = (0, $47959620e255098c$export$2cd1d0e1f861bae0)(state, this.type);
                    const hasStyles = Object.entries(attributes).some(([, value])=>!!value);
                    if (hasStyles) return true;
                    return commands.unsetMark(this.name);
                }
        };
    }
});
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */ const $5788b9aaf9ecd7bc$export$55b9391925fcc072 = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $5788b9aaf9ecd7bc$export$547f885a1fca4e31 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "orderedList",
    addOptions () {
        return {
            itemTypeName: "listItem",
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: "block list",
    content () {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes () {
        return {
            start: {
                default: 1,
                parseHTML: (element)=>{
                    return element.hasAttribute("start") ? parseInt(element.getAttribute("start") || "", 10) : 1;
                }
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: "ol"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        const { start: start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1 ? [
            "ol",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, attributesWithoutStart),
            0
        ] : [
            "ol",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleOrderedList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($5788b9aaf9ecd7bc$var$ListItem.name, this.editor.getAttributes($5788b9aaf9ecd7bc$var$TextStyle.name)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-7": ()=>this.editor.commands.toggleOrderedList()
        };
    },
    addInputRules () {
        let inputRule = (0, $47959620e255098c$export$f7316d89abe4e1c1)({
            find: $5788b9aaf9ecd7bc$export$55b9391925fcc072,
            type: this.type,
            getAttributes: (match)=>({
                    start: +match[1]
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1]
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $47959620e255098c$export$f7316d89abe4e1c1)({
            find: $5788b9aaf9ecd7bc$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: (match)=>({
                    start: +match[1],
                    ...this.editor.getAttributes($5788b9aaf9ecd7bc$var$TextStyle.name)
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1],
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});



/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */ const $a30f589d4502d9fc$export$358a232cca1ab2ac = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "paragraph",
    priority: 1000,
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: "block",
    content: "inline*",
    parseHTML () {
        return [
            {
                tag: "p"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "p",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setParagraph: ()=>({ commands: commands })=>{
                    return commands.setNode(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Alt-0": ()=>this.editor.commands.setParagraph()
        };
    }
});



/**
 * Matches a strike to a ~~strike~~ on input.
 */ const $7dbaf101e45065f8$export$55b9391925fcc072 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */ const $7dbaf101e45065f8$export$4ed30f8936af1979 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */ const $7dbaf101e45065f8$export$97176b8d51d2058f = (0, $47959620e255098c$export$c9d15bcfc6d42044).create({
    name: "strike",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "s"
            },
            {
                tag: "del"
            },
            {
                tag: "strike"
            },
            {
                style: "text-decoration",
                consuming: false,
                getAttrs: (style)=>style.includes("line-through") ? {} : false
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "s",
            (0, $47959620e255098c$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setStrike: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleStrike: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetStrike: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-s": ()=>this.editor.commands.toggleStrike()
        };
    },
    addInputRules () {
        return [
            (0, $47959620e255098c$export$9f2cb743ab9131de)({
                find: $7dbaf101e45065f8$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $47959620e255098c$export$3845eb97abe74944)({
                find: $7dbaf101e45065f8$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});



/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */ const $aa4e4bc41aae1f73$export$5f1af8db9871e1d6 = (0, $47959620e255098c$export$85c928794f8d04d4).create({
    name: "text",
    group: "inline"
});


/**
 * The starter kit is a collection of essential editor extensions.
 *
 * It’s a good starting point for building your own editor.
 */ const $ea4ee2370b5b830c$export$626064c5f1b71dc = (0, $47959620e255098c$export$eeddbf09bb970356).create({
    name: "starterKit",
    addExtensions () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const extensions = [];
        if (this.options.blockquote !== false) extensions.push((0, $7a282c1a56b92fcf$export$29a7a275fe11687).configure((_a = this.options) === null || _a === void 0 ? void 0 : _a.blockquote));
        if (this.options.bold !== false) extensions.push((0, $75769c370d8d97c7$export$95aa4184327d6b72).configure((_b = this.options) === null || _b === void 0 ? void 0 : _b.bold));
        if (this.options.bulletList !== false) extensions.push((0, $ff735bb16037d402$export$546f606c73d35982).configure((_c = this.options) === null || _c === void 0 ? void 0 : _c.bulletList));
        if (this.options.code !== false) extensions.push((0, $3acccbf048a74b80$export$52f0f02147b12c03).configure((_d = this.options) === null || _d === void 0 ? void 0 : _d.code));
        if (this.options.codeBlock !== false) extensions.push((0, $547a93f4ca6676d1$export$6c415d1fdae3dfdb).configure((_e = this.options) === null || _e === void 0 ? void 0 : _e.codeBlock));
        if (this.options.document !== false) extensions.push((0, $1c500e03269a40b3$export$b34a105447964f9f).configure((_f = this.options) === null || _f === void 0 ? void 0 : _f.document));
        if (this.options.dropcursor !== false) extensions.push((0, $9d9a1d2dc85cedc5$export$bc16731f26f3900d).configure((_g = this.options) === null || _g === void 0 ? void 0 : _g.dropcursor));
        if (this.options.gapcursor !== false) extensions.push((0, $ff5c7c750b8e1cbd$export$79c3dcaa03287f63).configure((_h = this.options) === null || _h === void 0 ? void 0 : _h.gapcursor));
        if (this.options.hardBreak !== false) extensions.push((0, $dd85d90465466667$export$d3d3fac13fa635d9).configure((_j = this.options) === null || _j === void 0 ? void 0 : _j.hardBreak));
        if (this.options.heading !== false) extensions.push((0, $e3a098df68c31f00$export$a8a3e93435678ff9).configure((_k = this.options) === null || _k === void 0 ? void 0 : _k.heading));
        if (this.options.history !== false) extensions.push((0, $e1d68a1a60af599c$export$84202caead5689ba).configure((_l = this.options) === null || _l === void 0 ? void 0 : _l.history));
        if (this.options.horizontalRule !== false) extensions.push((0, $5c05edf4bbd4c3ce$export$841e9c95e6429474).configure((_m = this.options) === null || _m === void 0 ? void 0 : _m.horizontalRule));
        if (this.options.italic !== false) extensions.push((0, $833b2246fcbb5c2b$export$1cfcf4275506b1c6).configure((_o = this.options) === null || _o === void 0 ? void 0 : _o.italic));
        if (this.options.listItem !== false) extensions.push((0, $31bd2e4c89b87b19$export$a7b06bfba60a8a78).configure((_p = this.options) === null || _p === void 0 ? void 0 : _p.listItem));
        if (this.options.orderedList !== false) extensions.push((0, $5788b9aaf9ecd7bc$export$547f885a1fca4e31).configure((_q = this.options) === null || _q === void 0 ? void 0 : _q.orderedList));
        if (this.options.paragraph !== false) extensions.push((0, $a30f589d4502d9fc$export$358a232cca1ab2ac).configure((_r = this.options) === null || _r === void 0 ? void 0 : _r.paragraph));
        if (this.options.strike !== false) extensions.push((0, $7dbaf101e45065f8$export$97176b8d51d2058f).configure((_s = this.options) === null || _s === void 0 ? void 0 : _s.strike));
        if (this.options.text !== false) extensions.push((0, $aa4e4bc41aae1f73$export$5f1af8db9871e1d6).configure((_t = this.options) === null || _t === void 0 ? void 0 : _t.text));
        return extensions;
    }
});



var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
parcelRequire("f2Y41");

var $ge3KO = parcelRequire("ge3KO");
function $f8a81571b59ad3d4$export$2e2bcd8739ae039({ title: title, onClickHandler: onClickHandler, isDisabled: isDisabled = false, isActive: isActive = false }) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
            type: "button",
            onClick: ()=>onClickHandler(),
            disabled: isDisabled,
            className: `${isActive ? "bg-topo-green-500  hover:bg-topo-green-600 focus:bg-topo-green-700  focus:ring-topo-green-800" : isDisabled ? "bg-gray-500 cursor-not-allowed" : "bg-topo-blue-500  hover:bg-topo-blue-600 focus:bg-topo-blue-700  focus:ring-topo-blue-800"} focus:outline-none focus:ring-2focus:ring-offset-2 text-white text-xs font-medium m-1 px-2.5 py-1.5 rounded-md`,
            children: title
        })
    });
}


const $31d506fa32506eae$var$Toolbar = ({ editor: editor })=>{
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "toolbar bg-gray-200 py-2 px-4 rounded-md shadow-md flex items-center justify-between",
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "toolbar-group space-x-1 flex-wrap",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Bold",
                    onClickHandler: ()=>editor.chain().focus().toggleBold().run(),
                    isDisabled: !editor.can().chain().focus().toggleBold().run(),
                    isActive: editor.isActive("bold")
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Italic",
                    onClickHandler: ()=>editor.chain().focus().toggleItalic().run(),
                    isDisabled: !editor.can().chain().focus().toggleItalic().run(),
                    isActive: editor.isActive("italic")
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Strike",
                    onClickHandler: ()=>editor.chain().focus().toggleStrike().run(),
                    isDisabled: !editor.can().chain().focus().toggleStrike().run(),
                    isActive: editor.isActive("strike")
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Paragraph",
                    onClickHandler: ()=>editor.chain().focus().setParagraph().run(),
                    isActive: editor.isActive("paragraph")
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "H1",
                    onClickHandler: ()=>editor.chain().focus().toggleHeading({
                            level: 1
                        }).run(),
                    isActive: editor.isActive("heading", {
                        level: 1
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "H2",
                    onClickHandler: ()=>editor.chain().focus().toggleHeading({
                            level: 2
                        }).run(),
                    isActive: editor.isActive("heading", {
                        level: 2
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "H3",
                    onClickHandler: ()=>editor.chain().focus().toggleHeading({
                            level: 3
                        }).run(),
                    isActive: editor.isActive("heading", {
                        level: 3
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Bullet list",
                    onClickHandler: ()=>editor.chain().focus().toggleBulletList().run(),
                    isActive: editor.isActive("bulletList")
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Ordered list",
                    onClickHandler: ()=>editor.chain().focus().toggleOrderedList().run(),
                    isActive: editor.isActive("orderedList")
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Horizontal rule",
                    onClickHandler: ()=>editor.chain().focus().setHorizontalRule().run()
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Hard break",
                    onClickHandler: ()=>editor.chain().focus().setHardBreak().run()
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Undo",
                    onClickHandler: ()=>editor.chain().focus().undo().run(),
                    isDisabled: !editor.can().chain().focus().undo().run()
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8a81571b59ad3d4$export$2e2bcd8739ae039), {
                    title: "Redo",
                    onClickHandler: ()=>editor.chain().focus().redo().run(),
                    isDisabled: !editor.can().chain().focus().redo().run()
                })
            ]
        })
    });
};
var $31d506fa32506eae$export$2e2bcd8739ae039 = $31d506fa32506eae$var$Toolbar;


function $118be3e6c62cb70b$export$2e2bcd8739ae039({ control: control, fieldName: fieldName, defaultValue: defaultValue }) {
    const { field: field } = (0, $ab09d66e1a814f38$export$e8c786024a2b0a79)({
        control: control,
        name: fieldName
    });
    const [showToolbar, setShowToolbar] = (0, $f2Y41.useState)(false);
    const extensions = [
        (0, $ec108066d24b69c9$export$1df879243bf2e42d).configure({
            types: [
                (0, $31bd2e4c89b87b19$export$a7b06bfba60a8a78).name
            ]
        }),
        (0, $ea4ee2370b5b830c$export$626064c5f1b71dc).configure({
            bulletList: {
                keepMarks: true
            },
            orderedList: {
                keepMarks: true
            }
        })
    ];
    const editor = (0, $3230bda81207e15e$export$43711a1418203bbc)({
        extensions: extensions,
        content: defaultValue || "",
        editorProps: {
            attributes: {
                class: "prose max-w-none [&_ol]:list-decimal [&_ul]:list-disc p-2 shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }
        },
        onUpdate: ({ editor: editor })=>{
            field.onChange(editor.getHTML()) // Update React Hook Form value on content change
            ;
        }
    });
    (0, $f2Y41.useEffect)(()=>{
        if (editor && defaultValue) editor.commands.setContent(defaultValue);
    }, [
        defaultValue,
        editor
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        onFocus: ()=>setShowToolbar(true),
        children: [
            showToolbar && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $31d506fa32506eae$export$2e2bcd8739ae039), {
                editor: editor
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3230bda81207e15e$export$a92c4e92ed722350), {
                editor: editor
            })
        ]
    });
}


function $fcc580328359cdf9$export$3061a4bb8e44ae96(props) {
    const { register: register, handleSubmit: handleSubmit, rese: rese, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    function wrapSubmit(data) {
        props.onSubmit(data);
        reset();
    }
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $f2Y41.Fragment),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed inset-0 overflow-hidden",
            onClose: props.setOpen,
            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "absolute inset-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153).Overlay, {
                        className: "absolute inset-0"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4).Child, {
                            as: (0, $f2Y41.Fragment),
                            enter: "transform transition ease-in-out duration-400 sm:duration-700",
                            enterFrom: "translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transform transition ease-in-out duration-400 sm:duration-700",
                            leaveFrom: "translate-x-0",
                            leaveTo: "translate-x-full",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "pointer-events-auto w-screen max-w-2xl",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                    className: "flex h-full flex-col overflow-y-scroll bg-white shadow-xl",
                                    onSubmit: handleSubmit(wrapSubmit),
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: " bg-topo-navy px-4 py-6 sm:px-6",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "flex items-start justify-between space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                className: "space-y-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153).Title, {
                                                                        className: "text-lg font-medium text-gray-100 ",
                                                                        children: [
                                                                            "Add New ",
                                                                            props.entity.label
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                                                        className: "text-sm text-gray-300",
                                                                        children: [
                                                                            "Get started by filling in the information below to add a new ",
                                                                            (0, $48358001e7c1220f$exports.lowerCase)(props.entity.label),
                                                                            "."
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "flex h-7 items-center",
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "text-gray-400 hover:text-gray-500",
                                                                    onClick: ()=>props.setOpen(false),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                            className: "sr-only",
                                                                            children: "Close panel"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $36f904a99bc777ce$export$2e2bcd8739ae039), {
                                                                            className: "h-6 w-6",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0",
                                                    children: props.fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("label", {
                                                                        htmlFor: field.key,
                                                                        className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                        children: [
                                                                            " ",
                                                                            field.label,
                                                                            " "
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: [
                                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                                            ...register(field.key),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                        value: option.value,
                                                                                        children: option.label
                                                                                    }, option.value))
                                                                            ]
                                                                        }),
                                                                        !field.options && field.type !== "wysiwyg" && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                            ...register(field.key),
                                                                            type: "text",
                                                                            id: field.key,
                                                                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                        }),
                                                                        field.type === "wysiwyg" && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $118be3e6c62cb70b$export$2e2bcd8739ae039), {
                                                                            control: control,
                                                                            fieldName: field.key,
                                                                            defaultValue: ""
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, field.key))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex justify-start space-x-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        type: "submit",
                                                        className: "inline-flex justify-center rounded-md border border-transparent bg-topo-green py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-500 focus:ring-offset-2",
                                                        children: "Save"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded-md border border-gray-300 bg-red-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
                                                        onClick: ()=>props.setOpen(false),
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}



function $6ed468b02c7be080$export$d78c9f5257943999(props) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const onSubmit = async (data)=>{
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/practices", data, getAccessTokenSilently);
        props.setOpen(false);
        props.refreshData();
        reset();
    };
    const entity = {
        label: "Practice",
        key: "practice"
    };
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Address",
            key: "address"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fcc580328359cdf9$export$3061a4bb8e44ae96), {
        entity: entity,
        fields: fields,
        onSubmit: onSubmit,
        open: props.open,
        setOpen: props.setOpen
    });
}


function $31a4d74716bbc6f6$export$aa329704653d4df7() {
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const [newSlideoverOpen, setNewSlideoverOpen] = (0, $f2Y41.useState)(searchParams.get("new") === "true");
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(searchParams.get("practice_id") !== undefined);
    const [markers, setMarkers] = (0, $f2Y41.useState)([]);
    const [practiceId, setPracticeId] = (0, $f2Y41.useState)();
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/practices");
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 150,
            display: "flex"
        },
        {
            field: "address",
            headerName: "Address",
            width: 350,
            display: "flex"
        },
        {
            field: "xref_esource_practice_slug",
            headerName: "Esource Practice Slug",
            width: 350,
            display: "flex"
        },
        {
            field: "provider_support_phone_number",
            headerName: "Provider Support Phone Number",
            width: 350,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params, handleShowPractice)
        }
    ];
    function toggleNewSlideoverOpen() {
        setNewSlideoverOpen(true);
    }
    const renderCellActions = (props, handleShowPractice)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>handleShowPractice(props.row.id),
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    const handleShowPractice = (practiceId)=>navigate(`/admin/practices/${practiceId}`);
    (0, $f2Y41.useEffect)(()=>{
        setMarkers(data.map((practice)=>practice?.latitude && practice?.longitude && {
                title: practice.name,
                latitude: practice.latitude,
                longitude: practice.longitude,
                showTitle: false
            }).filter((marker)=>marker !== null));
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Practices",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex",
                    onClick: toggleNewSlideoverOpen,
                    onKeyUp: toggleNewSlideoverOpen,
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                        icon: "PlusCircleIcon",
                        text: "Add Practice"
                    })
                })
            }),
            isError ? "Failed to load" : "",
            markers && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a39efe5079b02b36$export$d70af28cce04eac3), {
                markers: markers
            }),
            isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2 flex h-screen pl-4 pr-4",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex-grow",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                                rows: rows,
                                columns: columns,
                                onCellDoubleClick: (params, event)=>{
                                    event.defaultMuiPrevented = true;
                                    handleShowPractice(params.row?.id);
                                },
                                slots: {
                                    toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                                },
                                slotProps: {
                                    toolbar: {
                                        showQuickFilter: true
                                    }
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6ed468b02c7be080$export$d78c9f5257943999), {
                        open: newSlideoverOpen,
                        setOpen: setNewSlideoverOpen,
                        refreshData: mutate
                    })
                ]
            }),
            editModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b9a0f42c8d991ed3$export$b1beaf1ac04ab5db), {
                practiceId: practiceId,
                setOpen: setEditModalOpen,
                refreshData: mutate
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");












var $ge3KO = parcelRequire("ge3KO");





function $8c51bed1185bc926$export$86996bf4579bf53a(props) {
    const practiceLocation = props.practiceLocation;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: practiceLocation
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/practice_locations", data.id, data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Practice Location",
        key: "practice_location"
    };
    const fields = [
        {
            label: "Location Name",
            key: "name",
            required: true
        },
        {
            label: "Address",
            key: "address",
            required: true
        },
        {
            label: "Latitude",
            key: "latitude",
            required: true
        },
        {
            label: "Longitude",
            key: "longitude",
            required: true
        },
        {
            label: "Practice ID",
            key: "practice_id",
            hidden: true
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: `edit-${(0, $48358001e7c1220f$exports.snakeCase)(entity.key)}-modal`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "New ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        !field.hidden && /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key, {
                                                                required: field?.required || false
                                                            }),
                                                            type: field.hidden ? "hidden" : "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            placeholder: field?.placeholder
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>props.setOpen(false),
                onKeyUp: ()=>props.setOpen(false),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");





function $95a499f3c3b0ef1c$export$bee932b090cff163(props) {
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            practice_id: props.practiceId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/practice_locations", data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Practice Location",
        key: "practice_location"
    };
    const fields = [
        {
            label: "Location Name",
            key: "name",
            required: true
        },
        {
            label: "Address",
            key: "address",
            required: true
        },
        {
            label: "Latitude",
            key: "latitude",
            required: true
        },
        {
            label: "Longitude",
            key: "longitude",
            required: true
        },
        {
            label: "Practice ID",
            key: "practice_id",
            hidden: true
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: `edit-${(0, $48358001e7c1220f$exports.snakeCase)(entity.key)}-modal`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "New ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        !field.hidden && /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key, {
                                                                required: field?.required || false
                                                            }),
                                                            type: field.hidden ? "hidden" : "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            placeholder: field?.placeholder
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>props.setOpen(false),
                onKeyUp: ()=>props.setOpen(false),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");











class $d800b29e70f7e233$export$a06cf8c0066f0d4c extends (0, $b5fde98bda829a05$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($d800b29e70f7e233$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $d800b29e70f7e233$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $d800b29e70f7e233$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $cc3bb96fe5c1fe35$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $d800b29e70f7e233$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($d800b29e70f7e233$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $cc3bb96fe5c1fe35$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $cc3bb96fe5c1fe35$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $cc3bb96fe5c1fe35$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $cc3bb96fe5c1fe35$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $cc3bb96fe5c1fe35$export$6acf61af03e62db) || this.options.enabled === false || !(0, $cc3bb96fe5c1fe35$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $2635e9a022b2e9a8$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $d800b29e70f7e233$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $d800b29e70f7e233$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $d8f0e796caac6481$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $cc3bb96fe5c1fe35$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $cc3bb96fe5c1fe35$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $d800b29e70f7e233$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $cc3bb96fe5c1fe35$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $d8f0e796caac6481$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $7141903f22b57d82$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $d800b29e70f7e233$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $d800b29e70f7e233$var$shouldFetchOnMount(query, options) {
    return $d800b29e70f7e233$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $d800b29e70f7e233$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $d800b29e70f7e233$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $d800b29e70f7e233$var$isStale(query, options);
    }
    return false;
}
function $d800b29e70f7e233$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $d800b29e70f7e233$var$isStale(query, options);
}
function $d800b29e70f7e233$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $d800b29e70f7e233$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $cc3bb96fe5c1fe35$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



var $f2Y41 = parcelRequire("f2Y41");

var $168b0a19343c784a$exports = {};
"use strict";

$168b0a19343c784a$exports = (parcelRequire("2bsw6"));


"use client";
const $25461cb9cf5b28ed$export$306c0aa65ff9ec16 = (0, $168b0a19343c784a$exports.useSyncExternalStore);



var $f2Y41 = parcelRequire("f2Y41");
"use client";
function $ca0194be263f0cc8$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $ca0194be263f0cc8$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $f2Y41.createContext($ca0194be263f0cc8$var$createValue()); // HOOK
const $ca0194be263f0cc8$export$50dfac555130cafd = ()=>$f2Y41.useContext($ca0194be263f0cc8$var$QueryErrorResetBoundaryContext); // COMPONENT
const $ca0194be263f0cc8$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $f2Y41.useState(()=>$ca0194be263f0cc8$var$createValue());
    return /*#__PURE__*/ $f2Y41.createElement($ca0194be263f0cc8$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




var $f2Y41 = parcelRequire("f2Y41");
"use client";
const $b5afa7fdc0bfba65$var$IsRestoringContext = /*#__PURE__*/ $f2Y41.createContext(false);
const $b5afa7fdc0bfba65$export$4da0178d6b5f553 = ()=>$f2Y41.useContext($b5afa7fdc0bfba65$var$IsRestoringContext);
const $b5afa7fdc0bfba65$export$593807d4e94f9621 = $b5afa7fdc0bfba65$var$IsRestoringContext.Provider;



var $f2Y41 = parcelRequire("f2Y41");
function $9156fb037ec3c64d$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


"use client";
const $d8febf86e5d0e11d$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $d8febf86e5d0e11d$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $f2Y41.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $d8febf86e5d0e11d$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $9156fb037ec3c64d$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $6f3dc738e79a9c74$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $6f3dc738e79a9c74$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $6f3dc738e79a9c74$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $6f3dc738e79a9c74$export$e0a3f29513afe430(result, isRestoring);
const $6f3dc738e79a9c74$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


"use client";
function $7631a2b141334fd7$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $b5afa7fdc0bfba65$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $ca0194be263f0cc8$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $7141903f22b57d82$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $7141903f22b57d82$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $7141903f22b57d82$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $6f3dc738e79a9c74$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $d8febf86e5d0e11d$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $d8febf86e5d0e11d$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $f2Y41.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $25461cb9cf5b28ed$export$306c0aa65ff9ec16)($f2Y41.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $7141903f22b57d82$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $f2Y41.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $6f3dc738e79a9c74$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $6f3dc738e79a9c74$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $d8febf86e5d0e11d$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $6d7f79d5c7753eae$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $cc3bb96fe5c1fe35$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $7631a2b141334fd7$export$fff0865807e996c5)(parsedOptions, (0, $d800b29e70f7e233$export$a06cf8c0066f0d4c));
}



const $d306139d1442c366$export$1455baac8a7407b1 = ()=>{
    const queryCache = new (0, $7eff32c8357eedd0$export$5dde0cd941da8468)();
    queryCache.clear();
};
const $d306139d1442c366$export$fe1f5548f487c066 = (resource, params = null, options = {}, useQueryOptions = {})=>{
    // To get an access token, this must be called from within a component where it has context of auth provider
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const queryFn = async ()=>{
        const url = `${(0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)(resource)}${params ? `?${params}` : ""}`;
        const data = await (0, $b2d06586a86d14b7$export$47fdd40111eda34c)(url, getAccessTokenSilently);
        return data;
    };
    return (0, $6d7f79d5c7753eae$export$dd0a697e1782aedd)({
        queryKey: [
            resource,
            params
        ],
        queryFn: queryFn,
        initialData: {
            data: []
        },
        refetchOnWindowFocus: false,
        ...useQueryOptions
    });
};
const $d306139d1442c366$export$657be94be86c05b6 = (resource, id, options = {}, useQueryOptions = {})=>{
    if (id === undefined) return;
    // To get an access token, this must be called from within a component where it has context of auth provider
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const queryFn = async ()=>{
        const url = `${(0, $b2d06586a86d14b7$export$7ae26f9c219725a7)(resource, id)}${options?.params ? `?${options?.params}` : ""}`;
        const data = await (0, $b2d06586a86d14b7$export$47fdd40111eda34c)(url, getAccessTokenSilently);
        return data;
    };
    return (0, $6d7f79d5c7753eae$export$dd0a697e1782aedd)({
        queryKey: [
            resource,
            id
        ],
        queryFn: queryFn,
        initialData: {
            data: {}
        },
        refetchOnWindowFocus: false,
        ...useQueryOptions
    });
};



var $ge3KO = parcelRequire("ge3KO");









function $701d9da729f0e55d$export$2616650b2c76fcca(props) {
    const practiceStudy = props.practiceStudy;
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: study } } = (0, $d306139d1442c366$export$657be94be86c05b6)("admin/studies", practiceStudy.study_id);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: practiceStudy
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/practice_studies", data.id, data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        });
    };
    const entity = {
        label: "Practice Study",
        key: "practice_study"
    };
    const fields = [
        {
            label: "Study",
            key: "study_id",
            options: [
                {
                    key: study.id,
                    label: `${study?.name} (${study?.abbreviation})`
                }
            ],
            disabled: true
        },
        {
            label: "Topo Study Id",
            key: "topography_study_identifier",
            tooltip: "This id matches the Salesforce Opportunity Id and the CRIO Internal Study Number."
        },
        {
            label: "Status",
            key: "status",
            required: true,
            options: [
                {
                    label: "Contracting",
                    key: "Contracting"
                },
                {
                    label: "Prescreening",
                    key: "Prescreening"
                },
                {
                    label: "Enrolling",
                    key: "Enrolling"
                },
                {
                    label: "Maintenance",
                    key: "Maintenance"
                },
                {
                    label: "Closed",
                    key: "Closed"
                }
            ]
        },
        {
            label: "Esource Study Id",
            key: "xref_study_id"
        },
        {
            label: "Screening Visit Id",
            key: "xref_study_visit_id"
        },
        // TODO: add datepicker
        // { label: "Enrollment Start Date", key: "enrollment_start_dt" },
        // { label: "Enrollment End Date", key: "enrollment_end_dt" },
        {
            label: "Priority",
            key: "priority",
            options: [
                {
                    label: "Low",
                    key: "Low",
                    value: "Low"
                },
                {
                    label: "Medium",
                    key: "Medium",
                    value: "Medium"
                },
                {
                    label: "High",
                    key: "High",
                    value: "High"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: `edit-${(0, $48358001e7c1220f$exports.snakeCase)(entity.key)}-modal`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6 infline-flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    selected: true,
                                                                    disabled: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option?.key,
                                                                        children: option?.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>props.setOpen(false),
                onKeyUp: ()=>props.setOpen(false),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");









function $e7d1843d360ec3fe$export$3593aebca40dbb76(props) {
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: studies } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/studies");
    const { data: { data: practiceStudies } } = (0, $d306139d1442c366$export$fe1f5548f487c066)(`admin/practice_studies?practice_id=${practiceId}`);
    const practiceStudyOptions = studies.map((study)=>{
        if (!practiceStudies.some((practiceStudy)=>practiceStudy.study_id === study.id)) return {
            key: study.id,
            label: `${study.name} (${study.abbreviation})`
        };
        return {
            key: study.id,
            label: `${study.name} (${study.abbreviation})`,
            disabled: true
        };
    }).filter((study)=>study !== undefined);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            practice_id: props.practiceId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        data.practice_id = practiceId;
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/practice_studies", data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Practice Study",
        key: "practice_study"
    };
    const fields = [
        {
            label: "Study",
            key: "study_id",
            required: true,
            options: practiceStudyOptions
        },
        {
            label: "Topo Study Id",
            key: "topography_study_identifier",
            tooltip: "This id matches the Salesforce Opportunity Id and the CRIO Internal Study Number."
        },
        {
            label: "Status",
            key: "status",
            required: true,
            options: [
                {
                    label: "Contracting",
                    key: "Contracting"
                },
                {
                    label: "Prescreening",
                    key: "Prescreening"
                },
                {
                    label: "Enrolling",
                    key: "Enrolling"
                },
                {
                    label: "Maintenance",
                    key: "Maintenance"
                },
                {
                    label: "Closed",
                    key: "Closed"
                }
            ]
        },
        {
            label: "Esource Study Id",
            key: "xref_study_id"
        },
        {
            label: "Screening Visit Id",
            key: "xref_study_visit_id"
        },
        // TODO: add datepicker
        // { label: "Enrollment Start Date", key: "enrollment_start_dt" },
        // { label: "Enrollment End Date", key: "enrollment_end_dt" },
        {
            label: "Priority",
            key: "priority",
            options: [
                {
                    label: "Low",
                    key: "low"
                },
                {
                    label: "Medium",
                    key: "medium"
                },
                {
                    label: "High",
                    key: "high"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: `new-${(0, $48358001e7c1220f$exports.snakeCase)(entity.key)}-modal`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "New ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    selected: true,
                                                                    disabled: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option?.key,
                                                                        disabled: option?.disabled || false,
                                                                        children: option?.label
                                                                    }, option?.label))
                                                            ]
                                                        }, field.key)
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>props.setOpen(false),
                onKeyUp: ()=>props.setOpen(false),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $084480b62fc34a78$export$d40595ecb2c8894c(props) {
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const [practiceStudy, setPracticeStudy] = (0, $f2Y41.useState)();
    const [newStudyModalOpen, setNewStudyModalOpen] = (0, $f2Y41.useState)(false);
    const [editStudyModalOpen, setEditStudyModalOpen] = (0, $f2Y41.useState)(false);
    const { data: { data: practice_studies }, isFetching: isFetching, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practice_studies", `practice_id=${practiceId}`);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const mutatePracticeStudies = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "admin/practice_studies",
                `practice_id=${practiceId}`
            ]
        });
    };
    const rows = practice_studies;
    const columns = [
        {
            field: "study_name",
            headerName: "Name",
            width: 180,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.study.name
                })
        },
        {
            field: "study_abbreviation",
            headerName: "Abbr.",
            width: 100,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.study.abbreviation
                })
        },
        {
            field: "topography_study_identifier",
            headerName: "Topo Study Id",
            width: 150,
            display: "flex"
        },
        {
            field: "task_board_xref_id",
            headerName: "Monday Board ID",
            width: 150,
            display: "flex"
        },
        {
            field: "xref_study_id",
            headerName: "Esource Study Id",
            width: 150,
            display: "flex"
        },
        {
            field: "xref_study_visit_id",
            headerName: "Screening Visit Id",
            width: 150,
            display: "flex"
        },
        {
            field: "status",
            headerName: "Status",
            width: 100,
            display: "flex"
        },
        {
            field: "enrollment_start_dt",
            headerName: "Enroll Start",
            width: 120,
            display: "flex"
        },
        {
            field: "enrollment_end_dt",
            headerName: "Enroll End",
            width: 120,
            display: "flex"
        },
        {
            field: "priority",
            headerName: "Priority",
            width: 100,
            display: "flex"
        },
        {
            field: "enrollment_target",
            headerName: "Enroll Target",
            width: 120,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params)
        }
    ];
    const renderCellActions = (props)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>{
                setPracticeStudy(props.row);
                setEditStudyModalOpen(true);
            },
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-2 p-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex justify-between items-center ",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                    className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                                    children: "Studies"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    onClick: ()=>setNewStudyModalOpen(true),
                                    onKeyUp: ()=>setNewStudyModalOpen(true),
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                        icon: "PlusCircleIcon",
                                        text: "Add Practice Study",
                                        className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                    })
                                })
                            ]
                        })
                    }),
                    isFetching ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2 flex min-h-[200px]",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex-grow",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                                rows: rows,
                                columns: columns,
                                onCellDoubleClick: (params, event)=>{
                                    event.defaultMuiPrevented = true;
                                    setPracticeStudy(params.row);
                                    setEditStudyModalOpen(true);
                                },
                                slots: {
                                    toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                                },
                                slotProps: {
                                    toolbar: {
                                        showQuickFilter: true
                                    }
                                }
                            })
                        })
                    })
                ]
            }),
            newStudyModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e7d1843d360ec3fe$export$3593aebca40dbb76), {
                practiceId: practiceId,
                setOpen: setNewStudyModalOpen,
                refreshData: mutatePracticeStudies
            }),
            editStudyModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $701d9da729f0e55d$export$2616650b2c76fcca), {
                practiceStudy: practiceStudy,
                practiceId: practiceId,
                setOpen: setEditStudyModalOpen,
                refreshData: mutatePracticeStudies
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");






function $0632ddb7f023b718$export$9fbce9121a97856a(props) {
    const practiceUser = props.practiceUser;
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = (0, $f2Y41.useState)(false);
    const [userConfirmation, setUserConfirmation] = (0, $f2Y41.useState)("");
    const { data: { data: user } } = (0, $d306139d1442c366$export$657be94be86c05b6)("admin/users", practiceUser.user_id);
    const { register: register, handleSubmit: handleSubmit, reset: reset, getValues: getValues } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: practiceUser
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        data.practice_id = practiceId;
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/practice_users", data.id, data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        });
    };
    const confirmDelete = ()=>{
        setShowDeleteConfirmation(true);
    };
    const handleDelete = ()=>{
        if (userConfirmation === "delete user") // change this to update the deleted at field, don't actually delete
        (0, $b2d06586a86d14b7$export$74524c73191a667c)(`admin/${entity.key}s`, props.id, {
            deleted_at: new Date().toISOString().slice(0, -1)
        }, getAccessTokenSilently).then(()=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        });
    };
    const entity = {
        label: "Practice User",
        key: "practice_user"
    };
    const fields = [
        {
            label: "Name",
            key: "user_id",
            options: [
                {
                    key: user.id,
                    label: `${user.name}`
                }
            ],
            required: true,
            disabled: true
        },
        {
            label: "Role",
            key: "role",
            options: [
                {
                    label: "User",
                    key: "User",
                    description: "Access to the site's Waypoints."
                },
                {
                    label: "QA User",
                    key: "QaUser",
                    description: "User permissions and able to perform QA on other user's charts in Waypoints."
                },
                {
                    label: "Manager",
                    key: "Manager",
                    description: "View and manage all User metrics and QA responses in Waypoints."
                },
                {
                    label: "Admin",
                    key: "Admin",
                    description: "Ability to manage an entire site in Waypoints."
                },
                {
                    label: "Provider",
                    key: "Provider",
                    description: "Ability to view the site in Provider Dashboard."
                },
                {
                    label: "Provider Admin",
                    key: "ProviderAdmin",
                    description: "Ability to view and manage the site in Provider Dashboard."
                }
            ]
        },
        {
            label: "Position",
            key: "position",
            tooltip: "This is the position of the user with respect to the practice.",
            role: true
        },
        {
            label: "Phone",
            key: "phone"
        },
        {
            label: "Email",
            key: "email"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: `edit-${(0, $48358001e7c1220f$exports.snakeCase)(entity.key)}-modal`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("option", {
                                                                        value: option?.key,
                                                                        children: [
                                                                            option?.label,
                                                                            " ",
                                                                            option?.description && `- ${option?.description}`
                                                                        ]
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex justify-between pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        className: "text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800",
                                                        type: "button",
                                                        onClick: ()=>confirmDelete(),
                                                        children: "Delete"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                        type: "submit",
                                                        children: "Save"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: `${!showDeleteConfirmation ? "hidden" : undefined} flex justify-between pt-4 border-t border-gray-200 rounded-b dark:border-gray-700`,
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                    children: "Type `delete user` to confirm delete:"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        type: "text",
                                                        className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        onChange: (e)=>setUserConfirmation(e.target.value),
                                                        value: userConfirmation
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        className: "text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800",
                                                        type: "button",
                                                        onClick: handleDelete,
                                                        children: "Confirm Delete"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>props.setOpen(false),
                onKeyUp: ()=>props.setOpen(false),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");









function $cea6bbd67518f361$export$deb438b8a023b2b2(props) {
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: users } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/users");
    const { data: { data: practiceUsers } } = (0, $d306139d1442c366$export$fe1f5548f487c066)(`admin/practice_users?practice_id=${practiceId}`);
    const practiceUserOptions = users.map((user)=>{
        if (!practiceUsers.some((practiceUser)=>practiceUser.user_id === user.id)) return {
            key: user.id,
            label: user.name
        };
        return {
            key: user.id,
            label: user.name,
            disabled: true
        };
    }).filter((study)=>study !== undefined);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            practice_id: props.practiceId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        data.practice_id = practiceId;
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/practice_users", data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        });
    };
    const entity = {
        label: "Practice User",
        key: "practice_user"
    };
    const fields = [
        {
            label: "Name",
            key: "user_id",
            required: true,
            options: practiceUserOptions
        },
        {
            label: "Role",
            key: "role",
            options: [
                {
                    label: "User",
                    key: "User",
                    description: "Access to the site's Waypoints."
                },
                {
                    label: "QA User",
                    key: "QaUser",
                    description: "User permissions and able to perform QA on other user's charts in Waypoints."
                },
                {
                    label: "Manager",
                    key: "Manager",
                    description: "View and manage all User metrics and QA responses in Waypoints."
                },
                {
                    label: "Admin",
                    key: "Admin",
                    description: "Ability to manage an entire site in Waypoints."
                },
                {
                    label: "Provider",
                    key: "Provider",
                    description: "Ability to view the site in Provider Dashboard."
                },
                {
                    label: "Provider Admin",
                    key: "ProviderAdmin",
                    description: "Ability to view and manage the site in Provider Dashboard."
                }
            ]
        },
        {
            label: "Position",
            key: "position",
            tooltip: "This is the position of the user with respect to the practice.",
            role: true
        },
        {
            label: "Phone",
            key: "phone"
        },
        {
            label: "Email",
            key: "email"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: `new-${(0, $48358001e7c1220f$exports.snakeCase)(entity.key)}-modal`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "New ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "New ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("option", {
                                                                        value: option?.key,
                                                                        disabled: option?.disabled,
                                                                        children: [
                                                                            option?.label,
                                                                            " ",
                                                                            option?.description && `- ${option?.description}`
                                                                        ]
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>props.setOpen(false),
                onKeyUp: ()=>props.setOpen(false),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $05aa138acd350ac6$export$60da51724c851212(props) {
    const [practiceUser, setPracticeUser] = (0, $f2Y41.useState)();
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const [newUserModalOpen, setNewUserModalOpen] = (0, $f2Y41.useState)(false);
    const [editUserModalOpen, setEditUserModalOpen] = (0, $f2Y41.useState)(false);
    const { data: { data: practice_users }, isFetching: isFetching, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practice_users", `practice_id=${practiceId}`);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const mutatePracticeUsers = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "admin/practice_users",
                `practice_id=${practiceId}`
            ]
        });
    };
    const rows = practice_users;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 180,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.user?.name
                })
        },
        {
            field: "task_user_xref_id",
            headerName: "Monday ID",
            width: 150,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.user?.task_user_xref_id
                })
        },
        {
            field: "phone_extension_xref_id",
            headerName: "Extension",
            width: 120,
            display: "flex"
        },
        {
            field: "role",
            headerName: "Role",
            width: 150,
            display: "flex"
        },
        {
            field: "email",
            headerName: "Email",
            width: 180,
            display: "flex"
        },
        {
            field: "phone",
            headerName: "Phone",
            width: 120,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params)
        }
    ];
    const renderCellActions = (props)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>{
                setPracticeUser(props.row);
                setEditUserModalOpen(true);
            },
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-2 p-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex justify-between items-center ",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                    className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                                    children: "Users"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    onClick: ()=>setNewUserModalOpen(true),
                                    onKeyUp: ()=>setNewUserModalOpen(true),
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                        icon: "PlusCircleIcon",
                                        text: "Add Practice User",
                                        className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                    })
                                })
                            ]
                        })
                    }),
                    isFetching ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2 flex min-h-[200px]",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex-grow",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                                rows: rows,
                                columns: columns,
                                onCellDoubleClick: (params, event)=>{
                                    event.defaultMuiPrevented = true;
                                    setPracticeUser(params.row);
                                    setEditUserModalOpen(true);
                                },
                                slots: {
                                    toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                                },
                                slotProps: {
                                    toolbar: {
                                        showQuickFilter: true
                                    }
                                }
                            })
                        })
                    })
                ]
            }),
            newUserModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $cea6bbd67518f361$export$deb438b8a023b2b2), {
                practiceId: practiceId,
                setOpen: setNewUserModalOpen,
                refreshData: mutatePracticeUsers
            }),
            editUserModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0632ddb7f023b718$export$9fbce9121a97856a), {
                practiceUser: practiceUser,
                practiceId: practiceId,
                setOpen: setEditUserModalOpen,
                refreshData: mutatePracticeUsers
            })
        ]
    });
}


function $d4b05145b4844503$export$2f51d8dd59215465() {
    const { practiceId: practiceId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: practice, isLoading: isLoading, isError: isError, mutate: mutatePractice } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("admin/practices", practiceId);
    const { data: practice_locations, isLoading: practiceLocationsIsLoading, mutate: mutateLocations } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/practice_locations", `practice_id=${practiceId}`);
    const [practiceLocation, setPracticeLocation] = (0, $f2Y41.useState)();
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [newLocationModalOpen, setNewLocationModalOpen] = (0, $f2Y41.useState)(false);
    const [editLocationModalOpen, setEditLocationModalOpen] = (0, $f2Y41.useState)(false);
    const [addingStudy, setAddingStudy] = (0, $f2Y41.useState)(false);
    const { handleSubmit: handleSubmit, register: register, reset: reset, setValue: setValue, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 150
        },
        {
            field: "address",
            headerName: "Address",
            width: 150
        },
        {
            field: "latitude",
            headerName: "Latitude",
            width: 150
        },
        {
            field: "longitude",
            headerName: "Longitude",
            width: 150
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    const handleRefresh = ()=>{
        mutatePractice();
        mutateLocations();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between items-center pr-4 pl-4",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                            className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                            children: practice.name
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            onClick: ()=>setEditModalOpen(true),
                            onKeyUp: ()=>setEditModalOpen(true),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                icon: "PencilIcon",
                                text: "Edit Detail",
                                className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                            })
                        })
                    ]
                })
            }),
            isError ? "Failed to load" : "",
            isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "pl-4 pr-4",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $12bac3892b1cf3f1$export$60332b2344f7fe41), {
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "font-bold text-lg",
                            children: "Details"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.name || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Abbreviation"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.abbreviation || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Address"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.address || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Esource Practice Slug"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.xref_esource_practice_slug || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Waypoints Practice Slug"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.waypoints_practice_slug || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Latitude"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.latitude || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Longitude"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.longitude || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Monday.com Workspace id"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.task_workspace_xref_id || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Monday.com tasks folder id"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.task_folder_xref_id || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Monday.com practice team id"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.task_team_xref_id || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex items-center mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                    color: "gray",
                                                    size: "sm",
                                                    children: "Provider Support Phone Number"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2",
                                                    children: practice.provider_support_phone_number || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "text-gray-400 italic",
                                                        children: "Not provided"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $084480b62fc34a78$export$d40595ecb2c8894c), {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $05aa138acd350ac6$export$60da51724c851212), {}),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-2 p-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex justify-between items-center ",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                    className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                                    children: "Locations"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    onClick: ()=>setNewLocationModalOpen(true),
                                    onKeyUp: ()=>setNewLocationModalOpen(true),
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                        icon: "PlusCircleIcon",
                                        text: "Add Practice Location",
                                        className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                    })
                                })
                            ]
                        })
                    }),
                    practiceLocationsIsLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsxs)("table", {
                        className: "min-w-full divide-y divide-gray-200 dark:divide-gray-600",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("thead", {
                                className: "bg-gray-50 dark:bg-gray-700",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                            scope: "col",
                                            className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                            children: "Location Name"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                            scope: "col",
                                            className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                            scope: "col",
                                            className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                            children: "Latitude"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                            scope: "col",
                                            className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                            children: "Longitude"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                            scope: "col",
                                            className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("tbody", {
                                className: "bg-white dark:bg-gray-800",
                                children: practice_locations.map((practice_location, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                        className: index % 2 !== 0 ? "bg-gray-50" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                    className: "text-sm font-medium ",
                                                    children: practice_location.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                                children: practice_location.address
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                                children: practice_location.latitude
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                                children: practice_location.longitude
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        setPracticeLocation(practice_location);
                                                        setEditLocationModalOpen(true);
                                                    },
                                                    className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
                                                    children: [
                                                        "Edit",
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                            icon: "ArrowCircleRightIcon",
                                                            className: "ml-1 w-5 h-5 flex"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, practice_location.id))
                            })
                        ]
                    })
                ]
            }),
            practice?.latitude && practice?.longitude && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a39efe5079b02b36$export$d70af28cce04eac3), {
                defaultZoom: 8.5,
                center: {
                    latitude: practice.latitude,
                    longitude: practice.longitude
                },
                markers: practice_locations.map((practice_location)=>({
                        latitude: practice_location.latitude,
                        longitude: practice_location.longitude,
                        title: practice_location.name,
                        showTitle: true
                    }))
            }),
            editModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b9a0f42c8d991ed3$export$b1beaf1ac04ab5db), {
                practiceId: practiceId,
                setOpen: setEditModalOpen,
                refreshData: handleRefresh
            }),
            newLocationModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $95a499f3c3b0ef1c$export$bee932b090cff163), {
                practiceId: practiceId,
                setOpen: setNewLocationModalOpen,
                refreshData: mutateLocations
            }),
            editLocationModalOpen && practiceId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8c51bed1185bc926$export$86996bf4579bf53a), {
                practiceLocation: practiceLocation,
                practiceId: practiceId,
                setOpen: setEditLocationModalOpen,
                refreshData: mutateLocations
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


function $13e872420b476e64$export$39aeeeb7b8b59bbd() {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Practice Users"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $05aa138acd350ac6$export$60da51724c851212), {})
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");




function $4a94d3430f6d3232$export$14e6dd6bddecd72b() {
    const { data: data, isLoading: isLoading, isError: isError } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("procedures");
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 250
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 200,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 200,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Procedures"
            }),
            isLoading ? "Loading.." : "",
            isError ? "Failed to load" : "",
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");


parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");


const $dc67232e0e99ac39$export$41b4ed1d609e670b = {
    assign: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "A",
        strokeColor: "stroke-gray-600",
        icon: "UserAddIcon",
        fillColor: "fill-gray-600"
    },
    provider_referral: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "PR",
        strokeColor: "stroke-gray-600",
        icon: "UserAddIcon",
        fillColor: "fill-gray-600"
    },
    chart_review: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "CR",
        strokeColor: "stroke-green-100",
        icon: "DocumentTextIcon",
        fillColor: "fill-green-100"
    },
    provider_feedback: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "PF",
        strokeColor: "stroke-fuchsia-100",
        icon: "QuestionMarkCircleIcon",
        fillColor: "fill-fuchsia-100"
    },
    standard_of_care: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "SOC",
        strokeColor: "stroke-fuchsia-100",
        icon: "ClipboardCheckIcon",
        fillColor: "fill-fuchsia-100"
    },
    phone_call: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "PC",
        strokeColor: "stroke-purple-100",
        icon: "PhoneIcon",
        fillColor: "fill-purple-100"
    },
    left_voicemail: {
        textColor: "text-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "VM",
        strokeColor: "stroke-purple-100",
        icon: "PhoneMissedCallIcon"
    },
    callback: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "CB",
        strokeColor: "stroke-yellow-100",
        icon: "PhoneOutgoingIcon",
        fillColor: "fill-yellow-100"
    },
    follow_up: {
        textColor: "text-topo-blue-800",
        borderColor: "border-topo-blue-800",
        bgColor: "bg-blue-100",
        acronym: "FU",
        strokeColor: "stroke-orange-100",
        icon: "ClockIcon",
        fillColor: "fill-orange-100"
    },
    schedule_for_screen: {
        textColor: "text-yellow-900",
        borderColor: "border-yellow-900",
        bgColor: "bg-amber-100",
        acronym: "SS",
        strokeColor: "stroke-blue-100",
        icon: "CalendarIcon",
        fillColor: "fill-blue-100"
    },
    moved_to_esource: {
        textColor: "text-green-800",
        borderColor: "border-green-800",
        bgColor: "bg-green-100",
        acronym: "ME",
        strokeColor: "stroke-cyan-100",
        icon: "FolderAddIcon",
        fillColor: "fill-cyan-100"
    },
    disqualified: {
        textColor: "text-red-900",
        borderColor: "border-red-900",
        bgColor: "bg-red-300",
        acronym: "DQ",
        strokeColor: "stroke-red-400",
        icon: "ExclamationIcon",
        fillColor: "fill-red-400"
    }
};
const $dc67232e0e99ac39$export$cfd07d0d262760eb = Object.keys($dc67232e0e99ac39$export$41b4ed1d609e670b);
const $dc67232e0e99ac39$export$6f0947da043f45a6 = $dc67232e0e99ac39$export$cfd07d0d262760eb.map((status)=>(0, $17235661ec5f519b$export$b94aa994a2f01789)(status));



function $da10e49b852b9347$export$55c72165ec0b2743(props) {
    const textColor = (0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[props.status]?.textColor || "black";
    const bgColor = (0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[props.status]?.bgColor || "bg-blue-100";
    const statusAcronym = (0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[props.status]?.acronym || "N/A";
    const statusTitle = (0, $17235661ec5f519b$export$b94aa994a2f01789)(props.status ? props?.status : "Unknown Status");
    const tooltipPlacement = props.tooltipPlacement || "start";
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        title: statusTitle,
        className: "flex relative mr-1 bg-white border border-gray-200 rounded-full text-xs font-medium pl-2 py-1 w-min whitespace-nowrap dark:bg-gray-700",
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                    content: statusTitle,
                    style: "light",
                    placement: tooltipPlacement,
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: `${bgColor} ${textColor} flex absolute left-1 rounded-full h-5 w-7`,
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                            className: "flex m-auto font-small font-semibold",
                            children: statusAcronym
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "grow pl-6 mx-2 text-sm",
                    children: (0, $17235661ec5f519b$export$b94aa994a2f01789)(props.text || props.status || "N/A")
                })
            ]
        })
    });
}


function $a70863221a643bf5$export$5c08eb181db25a28(props) {
    const { data: usersData, isLoading: isLoadingUsers } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("users");
    const columnDefaults = {
        width: 150,
        headerClassName: "bg-gray-100 text-gray-500",
        display: "flex"
    };
    const columns = [
        {
            field: "study",
            headerName: "Study",
            ...columnDefaults,
            width: 225,
            renderCell: (params)=>$a70863221a643bf5$var$renderCellStudy(params, props.handleScreenNavigate)
        },
        {
            field: "assigned_to",
            headerName: "Assigned",
            ...columnDefaults,
            width: 225,
            renderCell: (params)=>$a70863221a643bf5$var$renderCellAssigned(params)
        },
        {
            field: "qa_assigned_to",
            headerName: "QA Assignee",
            ...columnDefaults,
            width: 225,
            renderCell: (params)=>$a70863221a643bf5$var$renderCellQaAssigned(params, usersData)
        },
        {
            field: "qa_review_status",
            headerName: "QA Review Status",
            ...columnDefaults,
            renderCell: (params)=>$a70863221a643bf5$var$renderCellQaStatus(params)
        },
        {
            field: "actions",
            headerName: "Actions",
            ...columnDefaults,
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>$a70863221a643bf5$var$renderCellActions(params, props.handleScreenNavigate, props.handleScreenStart)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex h-screen",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "flex-grow",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                rows: props.screens,
                columns: columns,
                disableDensitySelector: true,
                onCellDoubleClick: (params, event)=>{
                    event.defaultMuiPrevented = true;
                    props.handleScreenNavigate(params.row.id, params.row.patient_id);
                },
                initialState: {
                    filter: {
                        filterModel: {
                            items: [
                                {
                                    field: "study_status",
                                    operator: "isAnyOf",
                                    value: [
                                        "enrolling",
                                        "active"
                                    ]
                                }
                            ]
                        }
                    },
                    columns: {
                        columnVisibilityModel: {
                            // Hide these columns by default, the other columns will remain visible
                            indication: false
                        }
                    },
                    density: "comfortable"
                },
                sx: {
                    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                        outline: "none"
                    },
                    ".dark & .MuiDataGrid-columnHeader": {
                        backgroundColor: "rgb(55 65 81)",
                        color: "#FFFFFF"
                    }
                }
            })
        })
    });
}
function $a70863221a643bf5$var$renderCellQaAssigned(props, usersData) {
    const user = usersData.find((user)=>user.id === props.row?.qa_assigned_to_user_id);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-sm font-medium",
        children: user?.name || "None"
    });
}
function $a70863221a643bf5$var$renderCellAssigned(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-sm font-medium",
        children: props.row?.assigned_to?.name || "None"
    });
}
function $a70863221a643bf5$var$renderCellQaStatus(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-sm font-medium",
        children: props.row?.qa_status || "None"
    });
}
function $a70863221a643bf5$var$renderCellStudy(params, handleScreenNavigate) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
        to: "#",
        className: "text-sm font-medium hover:cursor-pointer w-full flex-col",
        onClick: ()=>handleScreenNavigate(params.row?.id, params.row?.patient_id),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da10e49b852b9347$export$55c72165ec0b2743), {
            text: params.row.study?.abbreviation?.substring(0, 13),
            status: params.row?.screen_status,
            tooltipPlacement: "right"
        })
    });
}
function $a70863221a643bf5$var$renderCellActions(props, handleScreenNavigate) {
    if (!handleScreenNavigate) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: "..."
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
        type: "button",
        onClick: ()=>handleScreenNavigate(props.row?.id, props.row?.patient_id),
        className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
        children: [
            "Review",
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "ArrowCircleRightIcon",
                className: "ml-1 w-5 h-5 flex"
            })
        ]
    });
}





var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");






function $84cc3a68d9541a98$export$30497a15bc25c6dd(props) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: screens, isLoading: isLoadingScreens, isError: isErrorScreens, mutate: mutateScreens } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/practice_studies", `practice_id=${practiceId}`);
    const { data: users, isLoading: isLoadingUsers, isError: isErrorUsers, mutate: mutateUsers } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/users", `practice_id=${practiceId}`);
    const [filteredUsers, setFilteredUsers] = (0, $f2Y41.useState)([]);
    (0, $f2Y41.useEffect)(()=>{
        setFilteredUsers(users.filter((user)=>user.role !== "Admin"));
    }, [
        users
    ]);
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            min_confidence_score: 0,
            max_confidence_score: 100,
            min_dt: "",
            max_dt: "",
            current_statuses: [
                "disqualified"
            ],
            study_id: "",
            current_assigned_to_users: [],
            assign_to_user_ids: [],
            batch_size: 10
        }
    });
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = async (data)=>{
        if (data.max_dt === "") data.max_dt = undefined;
        if (data.min_dt === "") data.min_dt = undefined;
        data.practice_id = practiceId;
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("qa_screens", data, getAccessTokenSilently);
        props.setOpen(false);
        props?.refreshData();
        reset();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "edit-practice-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Create QA Batch"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            onKeyUp: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Close Modal"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "screen",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Study"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("study_id"),
                                                            name: "study_id",
                                                            id: "study_id",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                screens?.map((screen)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: screen?.study?.id,
                                                                        children: screen?.study?.abbreviation
                                                                    }, screen?.study?.id))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "min_dt",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Minimum Screen Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                            name: "min_dt",
                                                            control: control,
                                                            defaultValue: "",
                                                            render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                    ...field,
                                                                    type: "datetime-local",
                                                                    sx: {
                                                                        width: 250,
                                                                        boxShadow: "none"
                                                                    },
                                                                    InputLabelProps: {
                                                                        shrink: true
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "max_dt",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Maximum Screen Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                            name: "max_dt",
                                                            control: control,
                                                            defaultValue: "",
                                                            render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                    ...field,
                                                                    type: "datetime-local",
                                                                    sx: {
                                                                        width: 250,
                                                                        boxShadow: "none"
                                                                    },
                                                                    InputLabelProps: {
                                                                        shrink: true
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "min_confidence_score",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Minimum Confidence Score"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            type: "number",
                                                            min: "0",
                                                            max: "100",
                                                            ...register("min_confidence_score"),
                                                            name: "min_confidence_score",
                                                            id: "min_confidence_score",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "max_confidence_score",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Maximum Confidence Score"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            type: "number",
                                                            min: "0",
                                                            max: "100",
                                                            ...register("max_confidence_score"),
                                                            name: "max_confidence_score",
                                                            id: "max_confidence_score",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "current_statuses",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Current Screen Statuses"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("current_statuses"),
                                                            name: "current_statuses",
                                                            id: "current_statuses",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            multiple: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "disqualified"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "assigned"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "chart_review"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "follow_up"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "provider_feedback"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "moved_to_esource"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "batch_size",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Number of Screens"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            type: "number",
                                                            min: "0",
                                                            max: "100",
                                                            ...register("batch_size"),
                                                            name: "batch_size",
                                                            id: "batch_size",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "current_assigned_to_users",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Users to QA"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("current_assigned_to_users"),
                                                            name: "current_assigned_to_users",
                                                            id: "current_assigned_to_users",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            multiple: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                filteredUsers?.map((user)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: user?.id,
                                                                        children: user?.name
                                                                    }, user?.id))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "assign_to_user_ids",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Users doing the QA"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("assign_to_user_ids"),
                                                            name: "assign_to_user_ids",
                                                            id: "assign_to_user_ids",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            multiple: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                filteredUsers?.map((user)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: user?.id,
                                                                        children: user?.name
                                                                    }, user?.id))
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Submit"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>closeModal(),
                onKeyUp: ()=>closeModal(),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $2c3dedf5e7eb0142$export$b6a37aeb9426baf8() {
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: qualityAssurances, mutate: qualityAssuranceMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("qa_screens", `practice_id=${practiceId}`);
    const [qualityAssuranceModalOpen, setQualityAssuranceModalOpen] = (0, $f2Y41.useState)(false);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-10 p-6 rounded-lg border border-gray-200 shadow-md",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("h5", {
                        className: "text-2xl font-bold tracking-tight flex flex-row",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "ClipboardIcon",
                                className: "h-5 mr-2 self-center"
                            }),
                            "Quality Assurance"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "px-7 mt-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "p-4 rounded-lg border border-gray-200 shadow-md bg-white dark:bg-transparent",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                                children: "Studies"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                onClick: ()=>setQualityAssuranceModalOpen(true),
                                onKeyUp: ()=>setQualityAssuranceModalOpen(true),
                                className: "right-justify",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                    icon: "PlusCircleIcon",
                                    text: "Add QA Screens"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a70863221a643bf5$export$5c08eb181db25a28), {
                        // patientId={patientId}
                        screens: qualityAssurances
                    })
                ]
            }),
            qualityAssuranceModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $84cc3a68d9541a98$export$30497a15bc25c6dd), {
                setOpen: setQualityAssuranceModalOpen,
                refreshData: qualityAssuranceMutate
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
const $325ea7629e2333b5$var$FileInput = ({ type: type, accept: accept, register: register, name: name, id: id, className: className, validateFileType: validateFileType, maxFileSize: maxFileSize = 5242880, ...rest })=>{
    const [error, setError] = (0, $f2Y41.useState)(null);
    const handleFileChange = (event)=>{
        const files = event.target.files;
        let totalSize = 0;
        // Calculate the total size of all selected files
        for(let i = 0; i < files.length; i++)totalSize += files[i].size;
        // Check if the total size exceeds the limit
        if (totalSize > maxFileSize) {
            setError(`Total file size exceeds the limit of ${maxFileSize / 1048576} MB.`);
            event.target.value = null // Clear the selected files
            ;
        } else setError(null) // No error, proceed with file upload
        ;
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                type: type,
                accept: accept,
                ...register(name, {
                    validate: {
                        fileType: validateFileType
                    }
                }),
                name: name,
                id: id,
                className: className,
                onChange: handleFileChange,
                ...rest
            }),
            error && /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                style: {
                    color: "red"
                },
                children: error
            })
        ]
    });
};
var $325ea7629e2333b5$export$2e2bcd8739ae039 = $325ea7629e2333b5$var$FileInput;




function $389b64958573779c$export$ed0b8acb121962dd(props) {
    const [previewUrl, setPreviewUrl] = (0, $f2Y41.useState)(null);
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: sponsor } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("sponsors", props.sponsorId);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    (0, $f2Y41.useEffect)(()=>{
        reset(sponsor);
    }, [
        sponsor
    ]);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/sponsors", props.sponsorId, data, getAccessTokenSilently).then((response)=>{
            if (data.logo_file[0]) {
                const formData = new FormData();
                formData.append("logo_file", data.logo_file[0], data.logo_file[0]?.name);
                (0, $b2d06586a86d14b7$export$5edc9d665968dd86)(`admin/sponsor_logos/${props.sponsorId}`, formData, getAccessTokenSilently);
            }
        }).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        });
    };
    const entity = {
        label: "Sponsor",
        key: "sponsor"
    };
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Edit Sponsor"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Close"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "name",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("name"),
                                                            type: "text",
                                                            name: "name",
                                                            id: "name",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="NN"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "abbreviation",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Abbreviation"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("abbreviation"),
                                                            type: "text",
                                                            name: "abbreviation",
                                                            id: "abbreviation",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="Green"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "location",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Location"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("location"),
                                                            type: "text",
                                                            name: "location",
                                                            id: "location",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "logo_file",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Logo"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "grid grid-cols-6 gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                                                                        src: previewUrl || sponsor.logo_url,
                                                                        alt: "Sponsor Logo",
                                                                        className: "w-full h-auto object-contain rounded-md"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                    className: "col-span-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                            htmlFor: "logo_file",
                                                                            className: "block mb-2 text-lg font-medium text-gray-900 dark:text-white",
                                                                            children: "Upload New Logo"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $325ea7629e2333b5$export$2e2bcd8739ae039), {
                                                                            type: "file",
                                                                            maxFileSize: 510,
                                                                            accept: "image/png, image/jpeg",
                                                                            register: register,
                                                                            name: "logo_file",
                                                                            id: "logo_file",
                                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                                            validateFileType: (files)=>{
                                                                                const fileArray = Array.from(files);
                                                                                return fileArray.every((file)=>[
                                                                                        "image/png",
                                                                                        "image/jpeg"
                                                                                    ].includes(file.type));
                                                                            },
                                                                            onChange: (e)=>{
                                                                                const file = e.target.files[0];
                                                                                if (file) {
                                                                                    // Check if the file size is within the limit (e.g., 5MB)
                                                                                    const maxFileSize = 5242880 // 5MB in bytes
                                                                                    ;
                                                                                    if (file.size > maxFileSize) {
                                                                                        alert("File size exceeds the limit of 5MB. Please select a smaller file.");
                                                                                        e.target.value = "" // clear the input file
                                                                                        ;
                                                                                        setPreviewUrl(null) // clear the preview url
                                                                                        ;
                                                                                        return;
                                                                                    }
                                                                                    const reader = new FileReader();
                                                                                    reader.onloadend = ()=>{
                                                                                        setPreviewUrl(reader.result);
                                                                                    };
                                                                                    reader.readAsDataURL(file);
                                                                                } else setPreviewUrl(null);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




function $2bb774571a6a0bdd$export$dd69c4256ab562fd(props) {
    const [previewUrl, setPreviewUrl] = (0, $f2Y41.useState)(null);
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onSubmit = async (data)=>{
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/sponsors", data, getAccessTokenSilently).then((response)=>{
            if (data.logo_file[0]) {
                const formData = new FormData();
                formData.append("logo_file", data.logo_file[0], data.logo_file[0]?.name);
                (0, $b2d06586a86d14b7$export$5edc9d665968dd86)(`admin/sponsor_logos/${response?.data?.data?.id}`, formData, getAccessTokenSilently);
            }
        }).then((response)=>{
            props.setOpen(false);
            props.refreshData();
            reset();
        });
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], ()=>props.setOpen(false));
    const entity = {
        label: "Sponsor",
        key: "sponsor"
    };
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Add Sponsor"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Close"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "name",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("name"),
                                                            type: "text",
                                                            name: "name",
                                                            id: "name",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="NN"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "abbreviation",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Abbreviation"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("abbreviation"),
                                                            type: "text",
                                                            name: "abbreviation",
                                                            id: "abbreviation",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="Green"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "location",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Location"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("location"),
                                                            type: "text",
                                                            name: "location",
                                                            id: "location",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "logo_file",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Logo"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "grid grid-cols-6 gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                                                                        src: previewUrl,
                                                                        alt: "Sponsor Logo",
                                                                        className: "w-full h-auto object-contain rounded-md"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                    className: "col-span-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                            htmlFor: "logo_file",
                                                                            className: "block mb-2 text-lg font-medium text-gray-900 dark:text-white",
                                                                            children: "Upload New Logo"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $325ea7629e2333b5$export$2e2bcd8739ae039), {
                                                                            type: "file",
                                                                            maxFileSize: 5242880,
                                                                            accept: "image/png, image/jpeg",
                                                                            register: register,
                                                                            name: "logo_file",
                                                                            id: "logo_file",
                                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                                            validateFileType: (files)=>{
                                                                                const fileArray = Array.from(files);
                                                                                return fileArray.every((file)=>[
                                                                                        "image/png",
                                                                                        "image/jpeg"
                                                                                    ].includes(file.type));
                                                                            },
                                                                            onChange: (e)=>{
                                                                                const file = e.target.files[0];
                                                                                if (file) {
                                                                                    // Check if the file size is within the limit (e.g., 5MB)
                                                                                    const maxFileSize = 5242880 // 5MB in bytes
                                                                                    ;
                                                                                    if (file.size > maxFileSize) {
                                                                                        alert("File size exceeds the limit of 5MB. Please select a smaller file.");
                                                                                        e.target.value = "" // clear the input file
                                                                                        ;
                                                                                        setPreviewUrl(null) // clear the preview url
                                                                                        ;
                                                                                        return;
                                                                                    }
                                                                                    const reader = new FileReader();
                                                                                    reader.onloadend = ()=>{
                                                                                        setPreviewUrl(reader.result);
                                                                                    };
                                                                                    reader.readAsDataURL(file);
                                                                                } else setPreviewUrl(null);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $62a25398f0d6957b$export$2d62f9e5f72f6e68() {
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const [newSlideoverOpen, setNewSlideoverOpen] = (0, $f2Y41.useState)(searchParams.get("new") === "true");
    const [newModalOpen, setNewModalOpen] = (0, $f2Y41.useState)(false);
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [sponsorId, setSponsorId] = (0, $f2Y41.useState)("");
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/sponsors");
    const rows = data;
    const columns = [
        {
            field: "logo_url",
            headerName: "Logo",
            width: 70,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                    src: params.row.logo_url,
                    alt: "sponsor logo"
                })
        },
        {
            field: "name",
            headerName: "Name",
            width: 250,
            display: "flex"
        },
        {
            field: "abbreviation",
            headerName: "Abbr",
            width: 150,
            display: "flex"
        },
        {
            field: "location",
            headerName: "Location",
            width: 250,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "pl-4 pr-4",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                        className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                        children: "Sponsors"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        onClick: ()=>setNewModalOpen(true),
                        onKeyUp: ()=>setNewModalOpen(true),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                            icon: "PlusCircleIcon",
                            text: "Add Sponsor",
                            className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                        })
                    })
                ]
            }),
            isError ? "Failed to load" : "",
            isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns,
                        onCellDoubleClick: (params, event)=>{
                            event.defaultMuiPrevented = true;
                            setSponsorId(params.row.id);
                            setEditModalOpen(true);
                        },
                        initialState: {
                            sorting: {
                                sortModel: [
                                    {
                                        field: "updated_at",
                                        sort: "desc"
                                    }
                                ]
                            }
                        },
                        slots: {
                            toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                        },
                        slotProps: {
                            toolbar: {
                                showQuickFilter: true
                            }
                        }
                    })
                })
            }),
            newModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2bb774571a6a0bdd$export$dd69c4256ab562fd), {
                setOpen: setNewModalOpen,
                refreshData: mutate
            }),
            editModalOpen && sponsorId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $389b64958573779c$export$ed0b8acb121962dd), {
                sponsorId: sponsorId,
                setOpen: setEditModalOpen,
                refreshData: mutate
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");





function $1c4fe8899a2494f0$export$272c97a1b11ba122() {
    const { data: data, isLoading: isLoading, isError: isError } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/ponsors");
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 250
        },
        {
            field: "abbreviation",
            headerName: "Abbr",
            width: 150
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 150,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 150,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Sponsors"
            }),
            isError ? "Failed to load" : "",
            isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




function $8e50c3caa513781d$export$75f991e6d712cb3f(props) {
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control, setValue: setValue } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: study, mutate: mutateStudy } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("admin/studies", props.studyId);
    const { data: sponsors } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/sponsors");
    const { data: indications } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/indications");
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    (0, $f2Y41.useEffect)(()=>{
        // extract only the ids
        const indicationIds = study.indications?.map((indication)=>indication.id);
        if (indicationIds) setValue("indication_ids", indicationIds);
    }, [
        study,
        setValue
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    (0, $f2Y41.useEffect)(()=>{
        reset(study);
    }, [
        study
    ]);
    const onSubmit = (data)=>{
        const indication_ids = data.indication_ids;
        data.indication_ids = undefined;
        data.indications = undefined;
        data.sponsor = undefined;
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/studies", props.studyId, data, getAccessTokenSilently).then(()=>{
            (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/studies/indications", props.studyId, {
                indication_ids: indication_ids
            }, getAccessTokenSilently);
        }).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Study",
        key: "study"
    };
    const fields = [
        {
            key: "name",
            label: "Name"
        },
        {
            key: "nickname",
            label: "Nickname"
        },
        {
            key: "abbreviation",
            label: "Abbreviation"
        },
        {
            key: "description",
            label: "Description"
        },
        {
            key: "protocol_version",
            label: "Protocol Version"
        },
        {
            key: "compound",
            label: "Compound"
        },
        {
            key: "call_script",
            label: "Call Script"
        },
        {
            key: "sponsor_id",
            label: "Sponsor",
            options: sponsors
        },
        {
            key: "indication_ids",
            label: "Indications",
            options: indications
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed pt-10 pb-10 z-50 left-0 right-0 items-center justify-center overflow-x-hidden md:inset-0",
                id: "edit-study-modal",
                children: study && sponsors && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-4xl px-4 md:h-auto mx-auto modal-container",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Editing ",
                                                study.name,
                                                " (",
                                                study.abbreviation,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Edit"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "name",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("name"),
                                                            type: "text",
                                                            name: "name",
                                                            id: "name",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="NN"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "nickname",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Nickname"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("nickname"),
                                                            type: "text",
                                                            name: "nickname",
                                                            id: "nickname",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="Green"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "abbreviation",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Abbreviation"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("abbreviation"),
                                                            type: "text",
                                                            name: "abbreviation",
                                                            id: "abbreviation",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="Green"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "description",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Description"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("description"),
                                                            type: "text",
                                                            name: "description",
                                                            id: "description",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "location",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Protocol Version"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("protocol_version"),
                                                            type: "text",
                                                            name: "protocol_version",
                                                            id: "protocol_version",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "indications",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Indications"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("indication_ids"),
                                                            name: "indication_ids",
                                                            id: "indication_ids",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true,
                                                            multiple: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    disabled: true
                                                                }),
                                                                indications?.map((indication)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: indication.id,
                                                                        selected: study.indications?.includes(indication.id),
                                                                        children: indication.name
                                                                    }, indication.id))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "call_script",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Call Script"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("textarea", {
                                                            ...register("call_script"),
                                                            name: "call_script",
                                                            id: "call_script",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "objectives",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Objectives"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("objectives"),
                                                            type: "text",
                                                            name: "objectives",
                                                            id: "objectives",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "study_type",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Study Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("study_type"),
                                                            name: "study_type",
                                                            id: "study_type",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Interventional"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Biomarker"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Registry"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Vaccine"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "sponsor_id",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Sponsor"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("sponsor_id"),
                                                            defaultValue: sponsors.find((sponsor)=>sponsor.id === study.sponsor_id)?.name,
                                                            name: "sponsor_id",
                                                            id: "sponsor_id",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                sponsors?.map((sponsor)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: sponsor.id,
                                                                        children: sponsor.name
                                                                    }, sponsor.id))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "provider_summary",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Trial Summary"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $118be3e6c62cb70b$export$2e2bcd8739ae039), {
                                                            control: control,
                                                            fieldName: "provider_summary",
                                                            defaultValue: study.provider_summary
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "ie_criteria",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Key Inclusion/Exclusion Criteria"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $118be3e6c62cb70b$export$2e2bcd8739ae039), {
                                                            control: control,
                                                            fieldName: "ie_criteria",
                                                            defaultValue: study.ie_criteria
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "how_you_can_help",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Patient Pitch"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $118be3e6c62cb70b$export$2e2bcd8739ae039), {
                                                            control: control,
                                                            fieldName: "how_you_can_help",
                                                            defaultValue: study.how_you_can_help
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "compound",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Compound/Asset"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register("compound"),
                                                            type: "text",
                                                            name: "compound",
                                                            id: "compound",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            // placeholder="example@company.com"
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "key_stats",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Study Specifics"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $118be3e6c62cb70b$export$2e2bcd8739ae039), {
                                                            control: control,
                                                            fieldName: "key_stats",
                                                            defaultValue: study.key_stats
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "hidden col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "criteria_summary",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Criteria Summary"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $118be3e6c62cb70b$export$2e2bcd8739ae039), {
                                                            control: control,
                                                            fieldName: "criteria_summary",
                                                            defaultValue: study.criteria_summary
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onKeyUp: ()=>closeModal(),
                onClick: ()=>closeModal(),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



function $c4a93668afcdcfbe$export$f97fa438ae6803ae(props) {
    const { data: sponsorsResponse } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/sponsors");
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const sponsors = sponsorsResponse.map((item)=>({
            value: item.id,
            label: item.name
        }));
    const onSubmit = async (data)=>{
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/studies", data, getAccessTokenSilently);
        props.setOpen(false);
        props.refreshData();
    };
    const entity = {
        label: "Study",
        key: "study"
    };
    const fields = [
        {
            key: "name",
            label: "Name"
        },
        {
            key: "nickname",
            label: "Nickname"
        },
        {
            key: "abbreviation",
            label: "Abbreviation"
        },
        {
            key: "description",
            label: "Description"
        },
        {
            key: "protocol_version",
            label: "Protocol Version"
        },
        {
            key: "compound",
            label: "Compound"
        },
        {
            key: "phase",
            label: "Phase"
        },
        {
            key: "call_script",
            label: "Call Script"
        },
        {
            key: "sponsor_id",
            label: "Sponsor",
            options: sponsors
        },
        {
            key: "ie_criteria",
            label: "I/E Criteria",
            type: "wysiwyg"
        },
        {
            key: "key_stats",
            label: "Key Stats",
            type: "wysiwyg"
        },
        {
            key: "criteria_summary",
            label: "Criteria Summary",
            type: "wysiwyg"
        },
        {
            key: "how_you_can_help",
            label: "How a provider can help:",
            type: "wysiwyg"
        },
        {
            key: "provider_summary",
            label: "Provider Summary",
            type: "wysiwyg"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $fcc580328359cdf9$export$3061a4bb8e44ae96), {
        entity: entity,
        fields: fields,
        onSubmit: onSubmit,
        open: props.open,
        setOpen: props.setOpen
    });
}


function $981563d490d2c503$export$ea415ab8f03c12d8() {
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const [newSlideoverOpen, setNewSlideoverOpen] = (0, $f2Y41.useState)(searchParams.get("new") === "true");
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [studyId, setStudyId] = (0, $f2Y41.useState)("");
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/studies");
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 150,
            display: "flex"
        },
        {
            field: "nickname",
            headerName: "Nickname",
            width: 150,
            display: "flex"
        },
        {
            field: "abbreviation",
            headerName: "Abbreviation",
            width: 150,
            display: "flex"
        },
        {
            field: "description",
            headerName: "Description",
            width: 400,
            display: "flex"
        },
        {
            field: "study_type",
            headerName: "Study Type",
            width: 150,
            display: "flex"
        },
        {
            field: "protocol_version",
            headerName: "Protocol Version",
            width: 150,
            display: "flex"
        },
        {
            field: "compound",
            headerName: "Compound",
            width: 150,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    function toggleNewSlideoverOpen() {
        setNewSlideoverOpen(true);
    }
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center pr-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                        className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                        children: "Studies"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        onClick: toggleNewSlideoverOpen,
                        onKeyUp: toggleNewSlideoverOpen,
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                            icon: "PlusCircleIcon",
                            text: "Add Study",
                            className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                        })
                    })
                ]
            }),
            isError ? "Failed to load" : "",
            isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns,
                        onCellDoubleClick: (params, event)=>{
                            event.defaultMuiPrevented = true;
                            navigate(`/admin/studies/${params.row.id}`);
                        // setStudyId(params.row.id)
                        // setEditModalOpen(true)
                        },
                        slots: {
                            toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                        },
                        slotProps: {
                            toolbar: {
                                showQuickFilter: true
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c4a93668afcdcfbe$export$f97fa438ae6803ae), {
                open: newSlideoverOpen,
                setOpen: setNewSlideoverOpen,
                refreshData: mutate
            }),
            editModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8e50c3caa513781d$export$75f991e6d712cb3f), {
                studyId: studyId,
                setOpen: setEditModalOpen,
                refreshData: mutate
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");
var $3d12054b9ed86c19$exports = {};
"use client";
"use strict";
var $3d12054b9ed86c19$var$Y = Object.create;
var $3d12054b9ed86c19$var$E = Object.defineProperty;
var $3d12054b9ed86c19$var$q = Object.getOwnPropertyDescriptor;
var $3d12054b9ed86c19$var$G = Object.getOwnPropertyNames;
var $3d12054b9ed86c19$var$K = Object.getPrototypeOf, $3d12054b9ed86c19$var$Z = Object.prototype.hasOwnProperty;
var $3d12054b9ed86c19$var$ee = (e, t)=>{
    for(var o in t)$3d12054b9ed86c19$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $3d12054b9ed86c19$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $3d12054b9ed86c19$var$G(t))!$3d12054b9ed86c19$var$Z.call(e, r) && r !== o && $3d12054b9ed86c19$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $3d12054b9ed86c19$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $3d12054b9ed86c19$var$W = (e, t, o)=>(o = e != null ? $3d12054b9ed86c19$var$Y($3d12054b9ed86c19$var$K(e)) : {}, $3d12054b9ed86c19$var$j(t || !e || !e.__esModule ? $3d12054b9ed86c19$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $3d12054b9ed86c19$var$te = (e)=>$3d12054b9ed86c19$var$j($3d12054b9ed86c19$var$E({}, "__esModule", {
        value: !0
    }), e);
var $3d12054b9ed86c19$var$Ve = {};
$3d12054b9ed86c19$var$ee($3d12054b9ed86c19$var$Ve, {
    CheckmarkIcon: ()=>$3d12054b9ed86c19$var$F,
    ErrorIcon: ()=>$3d12054b9ed86c19$var$w,
    LoaderIcon: ()=>$3d12054b9ed86c19$var$M,
    ToastBar: ()=>$3d12054b9ed86c19$var$$,
    ToastIcon: ()=>$3d12054b9ed86c19$var$U,
    Toaster: ()=>$3d12054b9ed86c19$var$J,
    default: ()=>$3d12054b9ed86c19$var$_e,
    resolveValue: ()=>$3d12054b9ed86c19$var$u,
    toast: ()=>$3d12054b9ed86c19$var$n,
    useToaster: ()=>$3d12054b9ed86c19$var$V,
    useToasterStore: ()=>$3d12054b9ed86c19$var$_
});
$3d12054b9ed86c19$exports = $3d12054b9ed86c19$var$te($3d12054b9ed86c19$var$Ve);
var $3d12054b9ed86c19$var$oe = (e)=>typeof e == "function", $3d12054b9ed86c19$var$u = (e, t)=>$3d12054b9ed86c19$var$oe(e) ? e(t) : e;
var $3d12054b9ed86c19$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $3d12054b9ed86c19$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $3d12054b9ed86c19$var$re = 20;
var $3d12054b9ed86c19$var$v = new Map, $3d12054b9ed86c19$var$se = 1e3, $3d12054b9ed86c19$var$X = (e)=>{
    if ($3d12054b9ed86c19$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $3d12054b9ed86c19$var$v.delete(e), $3d12054b9ed86c19$var$l({
            type: 4,
            toastId: e
        });
    }, $3d12054b9ed86c19$var$se);
    $3d12054b9ed86c19$var$v.set(e, t);
}, $3d12054b9ed86c19$var$ae = (e)=>{
    let t = $3d12054b9ed86c19$var$v.get(e);
    t && clearTimeout(t);
}, $3d12054b9ed86c19$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $3d12054b9ed86c19$var$re)
            };
        case 1:
            return t.toast.id && $3d12054b9ed86c19$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $3d12054b9ed86c19$var$H(e, {
                type: 1,
                toast: o
            }) : $3d12054b9ed86c19$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $3d12054b9ed86c19$var$X(s) : e.toasts.forEach((a)=>{
                $3d12054b9ed86c19$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $3d12054b9ed86c19$var$I = [], $3d12054b9ed86c19$var$D = {
    toasts: [],
    pausedAt: void 0
}, $3d12054b9ed86c19$var$l = (e)=>{
    $3d12054b9ed86c19$var$D = $3d12054b9ed86c19$var$H($3d12054b9ed86c19$var$D, e), $3d12054b9ed86c19$var$I.forEach((t)=>{
        t($3d12054b9ed86c19$var$D);
    });
}, $3d12054b9ed86c19$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $3d12054b9ed86c19$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("f2Y41")).useState)($3d12054b9ed86c19$var$D);
    (0, (parcelRequire("f2Y41")).useEffect)(()=>($3d12054b9ed86c19$var$I.push(o), ()=>{
            let r = $3d12054b9ed86c19$var$I.indexOf(o);
            r > -1 && $3d12054b9ed86c19$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $3d12054b9ed86c19$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $3d12054b9ed86c19$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $3d12054b9ed86c19$var$Q()
    }), $3d12054b9ed86c19$var$S = (e)=>(t, o)=>{
        let s = $3d12054b9ed86c19$var$ce(t, e, o);
        return $3d12054b9ed86c19$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $3d12054b9ed86c19$var$n = (e, t)=>$3d12054b9ed86c19$var$S("blank")(e, t);
$3d12054b9ed86c19$var$n.error = $3d12054b9ed86c19$var$S("error");
$3d12054b9ed86c19$var$n.success = $3d12054b9ed86c19$var$S("success");
$3d12054b9ed86c19$var$n.loading = $3d12054b9ed86c19$var$S("loading");
$3d12054b9ed86c19$var$n.custom = $3d12054b9ed86c19$var$S("custom");
$3d12054b9ed86c19$var$n.dismiss = (e)=>{
    $3d12054b9ed86c19$var$l({
        type: 3,
        toastId: e
    });
};
$3d12054b9ed86c19$var$n.remove = (e)=>$3d12054b9ed86c19$var$l({
        type: 4,
        toastId: e
    });
$3d12054b9ed86c19$var$n.promise = (e, t, o)=>{
    let s = $3d12054b9ed86c19$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($3d12054b9ed86c19$var$n.success($3d12054b9ed86c19$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $3d12054b9ed86c19$var$n.error($3d12054b9ed86c19$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $3d12054b9ed86c19$var$pe = (e, t)=>{
    $3d12054b9ed86c19$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $3d12054b9ed86c19$var$de = ()=>{
    $3d12054b9ed86c19$var$l({
        type: 5,
        time: Date.now()
    });
}, $3d12054b9ed86c19$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $3d12054b9ed86c19$var$_(e);
    (0, (parcelRequire("f2Y41")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $3d12054b9ed86c19$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$3d12054b9ed86c19$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("f2Y41")).useCallback)(()=>{
        o && $3d12054b9ed86c19$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("f2Y41")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $3d12054b9ed86c19$var$pe,
            startPause: $3d12054b9ed86c19$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $3d12054b9ed86c19$var$T = $3d12054b9ed86c19$var$W((parcelRequire("f2Y41")));
let $1ea6b43cfd4c80f3$var$e = {
    data: ""
}, $1ea6b43cfd4c80f3$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $1ea6b43cfd4c80f3$var$e, $1ea6b43cfd4c80f3$export$54aba348a7896325 = (e)=>{
    let r = $1ea6b43cfd4c80f3$var$t(e), l = r.data;
    return r.data = "", l;
}, $1ea6b43cfd4c80f3$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $1ea6b43cfd4c80f3$var$a = /\/\*[^]*?\*\/|  +/g, $1ea6b43cfd4c80f3$var$n = /\n+/g, $1ea6b43cfd4c80f3$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $1ea6b43cfd4c80f3$var$o(c, n) : n + "{" + $1ea6b43cfd4c80f3$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $1ea6b43cfd4c80f3$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $1ea6b43cfd4c80f3$var$o.p ? $1ea6b43cfd4c80f3$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $1ea6b43cfd4c80f3$var$c = {}, $1ea6b43cfd4c80f3$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $1ea6b43cfd4c80f3$var$s(e[r]);
        return t;
    }
    return e;
}, $1ea6b43cfd4c80f3$var$i = (e, t, r, i, p)=>{
    let u = $1ea6b43cfd4c80f3$var$s(e), d = $1ea6b43cfd4c80f3$var$c[u] || ($1ea6b43cfd4c80f3$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$1ea6b43cfd4c80f3$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $1ea6b43cfd4c80f3$var$l.exec(e.replace($1ea6b43cfd4c80f3$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($1ea6b43cfd4c80f3$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($1ea6b43cfd4c80f3$var$n, " ").trim();
            return o[0];
        })(e);
        $1ea6b43cfd4c80f3$var$c[d] = $1ea6b43cfd4c80f3$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $1ea6b43cfd4c80f3$var$c.g ? $1ea6b43cfd4c80f3$var$c.g : null;
    return r && ($1ea6b43cfd4c80f3$var$c.g = $1ea6b43cfd4c80f3$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($1ea6b43cfd4c80f3$var$c[d], t, i, f), d;
}, $1ea6b43cfd4c80f3$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $1ea6b43cfd4c80f3$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $1ea6b43cfd4c80f3$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $1ea6b43cfd4c80f3$var$i(l.unshift ? l.raw ? $1ea6b43cfd4c80f3$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $1ea6b43cfd4c80f3$var$t(r.target), r.g, r.o, r.k);
}
let $1ea6b43cfd4c80f3$var$d, $1ea6b43cfd4c80f3$var$f, $1ea6b43cfd4c80f3$var$g, $1ea6b43cfd4c80f3$export$442f1a04865e4790 = $1ea6b43cfd4c80f3$export$dbf350e5966cf602.bind({
    g: 1
}), $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e = $1ea6b43cfd4c80f3$export$dbf350e5966cf602.bind({
    k: 1
});
function $1ea6b43cfd4c80f3$export$de27182ff8187d6c(e, t, r, l) {
    $1ea6b43cfd4c80f3$var$o.p = t, $1ea6b43cfd4c80f3$var$d = e, $1ea6b43cfd4c80f3$var$f = r, $1ea6b43cfd4c80f3$var$g = l;
}
function $1ea6b43cfd4c80f3$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $1ea6b43cfd4c80f3$var$f && $1ea6b43cfd4c80f3$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $1ea6b43cfd4c80f3$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $1ea6b43cfd4c80f3$var$g && i[0] && $1ea6b43cfd4c80f3$var$g(c), $1ea6b43cfd4c80f3$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $3d12054b9ed86c19$var$y = $3d12054b9ed86c19$var$W((parcelRequire("f2Y41")));


var $3d12054b9ed86c19$var$me = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $3d12054b9ed86c19$var$ue = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3d12054b9ed86c19$var$le = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $3d12054b9ed86c19$var$w = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3d12054b9ed86c19$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$3d12054b9ed86c19$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$3d12054b9ed86c19$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $3d12054b9ed86c19$var$Te = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $3d12054b9ed86c19$var$M = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$3d12054b9ed86c19$var$Te} 1s linear infinite;
`;

var $3d12054b9ed86c19$var$fe = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $3d12054b9ed86c19$var$ye = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $3d12054b9ed86c19$var$F = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3d12054b9ed86c19$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$3d12054b9ed86c19$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $3d12054b9ed86c19$var$ge = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $3d12054b9ed86c19$var$he = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $3d12054b9ed86c19$var$xe = $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3d12054b9ed86c19$var$be = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$3d12054b9ed86c19$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $3d12054b9ed86c19$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $3d12054b9ed86c19$var$y.createElement($3d12054b9ed86c19$var$be, null, t) : t : o === "blank" ? null : $3d12054b9ed86c19$var$y.createElement($3d12054b9ed86c19$var$he, null, $3d12054b9ed86c19$var$y.createElement($3d12054b9ed86c19$var$M, {
        ...s
    }), o !== "loading" && $3d12054b9ed86c19$var$y.createElement($3d12054b9ed86c19$var$ge, null, o === "error" ? $3d12054b9ed86c19$var$y.createElement($3d12054b9ed86c19$var$w, {
        ...s
    }) : $3d12054b9ed86c19$var$y.createElement($3d12054b9ed86c19$var$F, {
        ...s
    })));
};
var $3d12054b9ed86c19$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $3d12054b9ed86c19$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $3d12054b9ed86c19$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $3d12054b9ed86c19$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $3d12054b9ed86c19$var$Ee = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $3d12054b9ed86c19$var$Re = (0, $1ea6b43cfd4c80f3$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $3d12054b9ed86c19$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $3d12054b9ed86c19$var$R() ? [
        $3d12054b9ed86c19$var$Pe,
        $3d12054b9ed86c19$var$Oe
    ] : [
        $3d12054b9ed86c19$var$Se(s),
        $3d12054b9ed86c19$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $1ea6b43cfd4c80f3$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $3d12054b9ed86c19$var$$ = $3d12054b9ed86c19$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $3d12054b9ed86c19$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $3d12054b9ed86c19$var$T.createElement($3d12054b9ed86c19$var$U, {
        toast: e
    }), c = $3d12054b9ed86c19$var$T.createElement($3d12054b9ed86c19$var$Re, {
        ...e.ariaProps
    }, $3d12054b9ed86c19$var$u(e.message, e));
    return $3d12054b9ed86c19$var$T.createElement($3d12054b9ed86c19$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $3d12054b9ed86c19$var$T.createElement($3d12054b9ed86c19$var$T.Fragment, null, a, c));
});


var $3d12054b9ed86c19$var$f = $3d12054b9ed86c19$var$W((parcelRequire("f2Y41")));
(0, $1ea6b43cfd4c80f3$export$de27182ff8187d6c)($3d12054b9ed86c19$var$f.createElement);
var $3d12054b9ed86c19$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $3d12054b9ed86c19$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $3d12054b9ed86c19$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $3d12054b9ed86c19$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $3d12054b9ed86c19$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $3d12054b9ed86c19$var$ke = $1ea6b43cfd4c80f3$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $3d12054b9ed86c19$var$L = 16, $3d12054b9ed86c19$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $3d12054b9ed86c19$var$V(o);
    return $3d12054b9ed86c19$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $3d12054b9ed86c19$var$L,
            left: $3d12054b9ed86c19$var$L,
            right: $3d12054b9ed86c19$var$L,
            bottom: $3d12054b9ed86c19$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $3d12054b9ed86c19$var$De(g, z);
        return $3d12054b9ed86c19$var$f.createElement($3d12054b9ed86c19$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $3d12054b9ed86c19$var$ke : "",
            style: O
        }, p.type === "custom" ? $3d12054b9ed86c19$var$u(p.message, p) : r ? r(p) : $3d12054b9ed86c19$var$f.createElement($3d12054b9ed86c19$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $3d12054b9ed86c19$var$_e = $3d12054b9ed86c19$var$n;








var $ge3KO = parcelRequire("ge3KO");

function $1e0a7cacb65353e4$export$bbecd8bea68ec649(props) {
    const { study: study } = props;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                className: "p-0 mt-4 ml-4 mr-2 mb-2 text-xl font-bold text-gray-900 dark:text-white flex",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                        icon: "DocumentTextIcon",
                        className: "text-gray-900 w-6 h-6"
                    }),
                    study?.abbreviation
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "ml-4 text-xs flex",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "font-medium mr-1",
                        children: "Name:"
                    }),
                    " ",
                    study?.name
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "ml-4 text-xs flex",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "font-medium mr-1",
                        children: "Description:"
                    }),
                    " ",
                    study?.description
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "ml-4 text-xs flex",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "font-medium mr-1",
                        children: "Indications:"
                    }),
                    " ",
                    study?.indications?.map((indication)=>indication.name).join(", ")
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "ml-4 text-xs flex",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "font-medium mr-1",
                        children: "Compound:"
                    }),
                    " ",
                    study?.compound
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
/**
 * @public
 */ const $4d8c17af02e3a371$export$22a697fb29aac98d = (0, $f2Y41.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $f2Y41 = parcelRequire("f2Y41");
const $b92f06ac647b6205$export$2285bbca2c666415 = (0, $f2Y41.createContext)({});



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
/**
 * @public
 */ const $cd7fbda68541d25e$export$f224e4635b6f8ce2 = (0, $f2Y41.createContext)(null);




var $f2Y41 = parcelRequire("f2Y41");
const $8a8d5cf9b7d8f3fb$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $e0c25c036b118aa5$export$700979bc83e7db82 = (0, $8a8d5cf9b7d8f3fb$export$4e09c449d6c407f7) ? (0, $f2Y41.useLayoutEffect) : (0, $f2Y41.useEffect);



var $f2Y41 = parcelRequire("f2Y41");
const $223a2f0b4fc6afd7$export$40f10139ecf1f171 = (0, $f2Y41.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $c96aab1dac0c1ff8$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


const $d75a1557b5f0e948$export$ed7b8fa9dbf0105d = "framerAppearId";
const $d75a1557b5f0e948$export$8592e1c077c890a6 = "data-" + (0, $c96aab1dac0c1ff8$export$9fd24a634729c672)($d75a1557b5f0e948$export$ed7b8fa9dbf0105d);


function $6cb4843a3154e02e$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $f2Y41.useContext)((0, $b92f06ac647b6205$export$2285bbca2c666415));
    const lazyContext = (0, $f2Y41.useContext)((0, $223a2f0b4fc6afd7$export$40f10139ecf1f171));
    const presenceContext = (0, $f2Y41.useContext)((0, $cd7fbda68541d25e$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $f2Y41.useContext)((0, $4d8c17af02e3a371$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $f2Y41.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $f2Y41.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $f2Y41.useRef)(Boolean(props[0, $d75a1557b5f0e948$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $e0c25c036b118aa5$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $f2Y41.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}



var $f2Y41 = parcelRequire("f2Y41");
function $e9f3c51b93aef056$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $60cae5a06d409434$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $f2Y41.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $e9f3c51b93aef056$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $f2Y41 = parcelRequire("f2Y41");

/**
 * Decides if the supplied variable is variant label
 */ function $91251829777887b6$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $70615b426cbd2b46$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $be85fa1d3cfb6437$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $be85fa1d3cfb6437$export$1405a65085f40b9 = [
    "initial",
    ...$be85fa1d3cfb6437$export$16e45afcc206d3a8
];


function $b269af27c9bfef57$export$4b3c3bd8d910d78d(props) {
    return (0, $70615b426cbd2b46$export$aa71198ceeaf53ce)(props.animate) || (0, $be85fa1d3cfb6437$export$1405a65085f40b9).some((name)=>(0, $91251829777887b6$export$720b90e312cea233)(props[name]));
}
function $b269af27c9bfef57$export$ce46fa4165cdec40(props) {
    return Boolean($b269af27c9bfef57$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $991b8a6b3fcfcd73$export$12fc32fc096a04a3(props, context) {
    if ((0, $b269af27c9bfef57$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $91251829777887b6$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $91251829777887b6$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $629a3cda01cc253f$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $991b8a6b3fcfcd73$export$12fc32fc096a04a3)(props, (0, $f2Y41.useContext)((0, $b92f06ac647b6205$export$2285bbca2c666415)));
    return (0, $f2Y41.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $629a3cda01cc253f$var$variantLabelsAsDependency(initial),
        $629a3cda01cc253f$var$variantLabelsAsDependency(animate)
    ]);
}
function $629a3cda01cc253f$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $0108631ccf3abd34$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $0108631ccf3abd34$export$65570e08d843624d = {};
for(const key in $0108631ccf3abd34$var$featureProps)$0108631ccf3abd34$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$0108631ccf3abd34$var$featureProps[key].some((name)=>!!props[name])
};


function $562e85960ba9863c$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $0108631ccf3abd34$export$65570e08d843624d)[key] = {
        ...(0, $0108631ccf3abd34$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $f2Y41 = parcelRequire("f2Y41");
const $bbb6b89781bcd2c0$export$a3579ca508007a95 = (0, $f2Y41.createContext)({});




var $f2Y41 = parcelRequire("f2Y41");
/**
 * Internal, exported only for usage in Framer
 */ const $e148fb33e18888cf$export$da5f7b802957459a = (0, $f2Y41.createContext)({});


const $98597d3ce63e730a$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $84a699809c9c1281$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $562e85960ba9863c$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $f2Y41.useContext)((0, $4d8c17af02e3a371$export$22a697fb29aac98d)),
            ...props,
            layoutId: $84a699809c9c1281$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $629a3cda01cc253f$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $8a8d5cf9b7d8f3fb$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $6cb4843a3154e02e$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $f2Y41.useContext)((0, $e148fb33e18888cf$export$da5f7b802957459a));
            const isStrict = (0, $f2Y41.useContext)((0, $223a2f0b4fc6afd7$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $f2Y41.createElement((0, $b92f06ac647b6205$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $f2Y41.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $60cae5a06d409434$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $f2Y41.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $98597d3ce63e730a$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $84a699809c9c1281$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $f2Y41.useContext)((0, $bbb6b89781bcd2c0$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $26028cae7631c06f$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $84a699809c9c1281$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $8b975ba659a8cf42$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $7d91ae4ac4368187$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $8b975ba659a8cf42$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");
const $fba9fe967fbf1215$export$91ddd985b97788d1 = {};
function $fba9fe967fbf1215$export$de9e7791c71225fd(correctors) {
    Object.assign($fba9fe967fbf1215$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $0ecc8bc19224a444$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $0ecc8bc19224a444$export$7b42a0094fb00b6e = new Set($0ecc8bc19224a444$export$280dc01950909d86);


function $7cabb04ddd4f1c5d$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $fba9fe967fbf1215$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $dbcf5d155a7a93bb$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $ea567687751041b1$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $ea567687751041b1$var$numTransforms = (0, $0ecc8bc19224a444$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $ea567687751041b1$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $ea567687751041b1$var$numTransforms; i++){
        const key = (0, $0ecc8bc19224a444$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $ea567687751041b1$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $ea94389b875d6314$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $ea94389b875d6314$export$9de1236619d9e756 = $ea94389b875d6314$var$checkStringStartsWith("--");
const $ea94389b875d6314$export$31f9caa2600b5723 = $ea94389b875d6314$var$checkStringStartsWith("var(--");
const $ea94389b875d6314$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $d1e14b7aca176c55$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $90953032fc0f5ac8$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $fd4de4d4090bd1e0$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $fd4de4d4090bd1e0$export$58f0f39f63f3cf42 = {
    ...$fd4de4d4090bd1e0$export$98e628dec113755e,
    transform: (v)=>(0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $fd4de4d4090bd1e0$export$dcdf75081b88279d = {
    ...$fd4de4d4090bd1e0$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $fd4a6c3490270dbc$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $fd4a6c3490270dbc$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $fd4a6c3490270dbc$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $fd4a6c3490270dbc$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $fd4a6c3490270dbc$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $aadbef2dd2f78d28$var$createUnitType = (unit)=>({
        test: (v)=>(0, $fd4a6c3490270dbc$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $aadbef2dd2f78d28$export$41fc368e1a942b97 = $aadbef2dd2f78d28$var$createUnitType("deg");
const $aadbef2dd2f78d28$export$626336c2cd4b14de = $aadbef2dd2f78d28$var$createUnitType("%");
const $aadbef2dd2f78d28$export$91c0eda1d06bf008 = $aadbef2dd2f78d28$var$createUnitType("px");
const $aadbef2dd2f78d28$export$f91e8c45a95a32f2 = $aadbef2dd2f78d28$var$createUnitType("vh");
const $aadbef2dd2f78d28$export$aed3d7b7d206c196 = $aadbef2dd2f78d28$var$createUnitType("vw");
const $aadbef2dd2f78d28$export$44e2e1705876d7ed = {
    ...$aadbef2dd2f78d28$export$626336c2cd4b14de,
    parse: (v)=>$aadbef2dd2f78d28$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$aadbef2dd2f78d28$export$626336c2cd4b14de.transform(v * 100)
};



const $81820dce7ae0df11$export$7d260a2a5f8bc19e = {
    ...(0, $fd4de4d4090bd1e0$export$98e628dec113755e),
    transform: Math.round
};


const $710703dd5863bfa3$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderTopWidth: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderRightWidth: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderRadius: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    radius: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    maxWidth: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    height: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    maxHeight: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    size: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    top: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    right: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    bottom: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    left: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    paddingTop: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    paddingRight: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    paddingBottom: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    paddingLeft: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    margin: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    marginTop: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    marginRight: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    marginBottom: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    marginLeft: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    rotateX: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    rotateY: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    rotateZ: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    scale: $fd4de4d4090bd1e0$export$dcdf75081b88279d,
    scaleX: (0, $fd4de4d4090bd1e0$export$dcdf75081b88279d),
    scaleY: (0, $fd4de4d4090bd1e0$export$dcdf75081b88279d),
    scaleZ: (0, $fd4de4d4090bd1e0$export$dcdf75081b88279d),
    skew: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    skewX: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    skewY: (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    distance: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    translateX: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    translateY: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    translateZ: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    x: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    y: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    z: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    perspective: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    transformPerspective: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    opacity: (0, $fd4de4d4090bd1e0$export$58f0f39f63f3cf42),
    originX: (0, $aadbef2dd2f78d28$export$44e2e1705876d7ed),
    originY: (0, $aadbef2dd2f78d28$export$44e2e1705876d7ed),
    originZ: (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $81820dce7ae0df11$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $fd4de4d4090bd1e0$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $fd4de4d4090bd1e0$export$58f0f39f63f3cf42),
    numOctaves: (0, $81820dce7ae0df11$export$7d260a2a5f8bc19e)
};


function $fac79bc606541058$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $ea94389b875d6314$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $710703dd5863bfa3$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $d1e14b7aca176c55$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $ea567687751041b1$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $79551751bdb624ce$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $a3f991e89e67addd$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(source[key]) && !(0, $7cabb04ddd4f1c5d$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $a3f991e89e67addd$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $f2Y41.useMemo)(()=>{
        const state = (0, $79551751bdb624ce$export$8940b483cf52eeda)();
        (0, $fac79bc606541058$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $a3f991e89e67addd$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $a3f991e89e67addd$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $a3f991e89e67addd$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $a3f991e89e67addd$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $a3f991e89e67addd$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $0c899df4364c5a1b$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $0c899df4364c5a1b$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $0c899df4364c5a1b$var$validMotionProps.has(key);
}


let $2ca612a997900a85$var$shouldForward = (key)=>!(0, $0c899df4364c5a1b$export$2f9c46555243bf04)(key);
function $2ca612a997900a85$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $2ca612a997900a85$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $0c899df4364c5a1b$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $2ca612a997900a85$export$59d6962c470509a5((parcelRequire("h9TKS")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $2ca612a997900a85$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($2ca612a997900a85$var$shouldForward(key) || forwardMotionProps === true && (0, $0c899df4364c5a1b$export$2f9c46555243bf04)(key) || !isDom && !(0, $0c899df4364c5a1b$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $f2Y41 = parcelRequire("f2Y41");



function $550bc5a0797ef4cc$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $550bc5a0797ef4cc$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $550bc5a0797ef4cc$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $550bc5a0797ef4cc$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $ef848cef62f17da5$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $ef848cef62f17da5$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $ef848cef62f17da5$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $ef848cef62f17da5$var$dashKeys : $ef848cef62f17da5$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $fdf145796eed0b60$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $fac79bc606541058$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $550bc5a0797ef4cc$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $ef848cef62f17da5$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $a3cb13e8c8add372$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $79551751bdb624ce$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $187c5bbc44ebd6c8$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $8a53a313e32f8c76$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $f2Y41.useMemo)(()=>{
        const state = (0, $a3cb13e8c8add372$export$41be8b43e1c4d4f9)();
        (0, $fdf145796eed0b60$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $187c5bbc44ebd6c8$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $a3f991e89e67addd$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $f36db362ba68cffc$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $7d91ae4ac4368187$export$88f3fc2fd3766989)(Component) ? (0, $8a53a313e32f8c76$export$84309c4f53cb1bd5) : (0, $a3f991e89e67addd$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $2ca612a997900a85$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $f2Y41.useMemo)(()=>(0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $f2Y41.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $2c4b92c7ad8f677c$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $c6102d84f857a56f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $10788993154c36c8$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $2c4b92c7ad8f677c$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $c6102d84f857a56f$export$28931db5d57958e5).has(key) ? (0, $c96aab1dac0c1ff8$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $8c08c3c4fd4eb285$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(prevProps.style[key]) || (0, $7cabb04ddd4f1c5d$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $08029978089f9824$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $8c08c3c4fd4eb285$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(props[key]) || (0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $0ecc8bc19224a444$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $f2Y41 = parcelRequire("f2Y41");


function $122b31be13f9d162$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $f2Y41 = parcelRequire("f2Y41");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $67a0785be9b228c1$export$fe4300aa8eebea86(init) {
    const ref = (0, $f2Y41.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $e9b0713b71e5ad60$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $240570da3b7ffcae$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $240570da3b7ffcae$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $e9b0713b71e5ad60$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $932237e3d7df006b$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $240570da3b7ffcae$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $66152b42c93bfb9b$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $66152b42c93bfb9b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $66152b42c93bfb9b$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $f2Y41.useContext)((0, $b92f06ac647b6205$export$2285bbca2c666415));
        const presenceContext = (0, $f2Y41.useContext)((0, $cd7fbda68541d25e$export$f224e4635b6f8ce2));
        const make = ()=>$66152b42c93bfb9b$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $67a0785be9b228c1$export$fe4300aa8eebea86)(make);
    };
function $66152b42c93bfb9b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $932237e3d7df006b$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $b269af27c9bfef57$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $b269af27c9bfef57$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $70615b426cbd2b46$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $122b31be13f9d162$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $709eb61066a443a9$export$8793edee2d425525 = (any)=>any;


class $e0cc0ee5048886d2$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $e0cc0ee5048886d2$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $e0cc0ee5048886d2$var$Queue();
    let nextFrame = new $e0cc0ee5048886d2$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $a9ad86b4dd57b33b$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $a9ad86b4dd57b33b$var$maxElapsed = 40;
function $a9ad86b4dd57b33b$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $a9ad86b4dd57b33b$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $e0cc0ee5048886d2$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $a9ad86b4dd57b33b$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $a9ad86b4dd57b33b$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $a9ad86b4dd57b33b$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$a9ad86b4dd57b33b$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $5dbf294fbbccf87e$export$2cef06c20297c17d, cancel: $5dbf294fbbccf87e$export$ec99c0ef4978dccb, state: $5dbf294fbbccf87e$export$fff89137e9e818ce, steps: $5dbf294fbbccf87e$export$be3f796aed065412 } = (0, $a9ad86b4dd57b33b$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $709eb61066a443a9$export$8793edee2d425525), true);


const $1134e90304aa274c$export$44dabd3fae512e85 = {
    useVisualState: (0, $66152b42c93bfb9b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $08029978089f9824$export$16da615486abaa45),
        createRenderState: (0, $a3cb13e8c8add372$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).render(()=>{
                (0, $fdf145796eed0b60$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $187c5bbc44ebd6c8$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $10788993154c36c8$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $8472c396c3da5fdd$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $66152b42c93bfb9b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $8c08c3c4fd4eb285$export$16da615486abaa45,
        createRenderState: (0, $79551751bdb624ce$export$8940b483cf52eeda)
    })
};


function $805f9a607ad0f577$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $7d91ae4ac4368187$export$88f3fc2fd3766989)(Component) ? (0, $1134e90304aa274c$export$44dabd3fae512e85) : (0, $8472c396c3da5fdd$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $f36db362ba68cffc$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $94ac01aba299b123$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $840fb45d383fc6c6$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $3b63da9e60d95533$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $3b63da9e60d95533$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $840fb45d383fc6c6$export$a4cf9c8a4b063a6e)(event) && handler(event, $3b63da9e60d95533$export$12f84bb882d06e1a(event));
};


function $34c6553b58971442$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $94ac01aba299b123$export$b1d829ddf82884aa)(target, eventName, (0, $3b63da9e60d95533$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $bea3f45b78a0c8f1$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $bea3f45b78a0c8f1$export$a4627e546088548d = (...transformers)=>transformers.reduce($bea3f45b78a0c8f1$var$combineFunctions);


function $111174ce77203f86$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $111174ce77203f86$var$globalHorizontalLock = $111174ce77203f86$export$518c5fc2dcb7974b("dragHorizontal");
const $111174ce77203f86$var$globalVerticalLock = $111174ce77203f86$export$518c5fc2dcb7974b("dragVertical");
function $111174ce77203f86$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $111174ce77203f86$var$globalVerticalLock();
    else if (drag === "x") lock = $111174ce77203f86$var$globalHorizontalLock();
    else {
        const openHorizontal = $111174ce77203f86$var$globalHorizontalLock();
        const openVertical = $111174ce77203f86$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $111174ce77203f86$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $111174ce77203f86$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $f45c7c1c2de1d25e$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $d7c362976193f6c7$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $111174ce77203f86$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $34c6553b58971442$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $d7c362976193f6c7$export$93a81ea037eac456 extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)($d7c362976193f6c7$var$addHoverEvent(this.node, true), $d7c362976193f6c7$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $2d9ab38999149902$export$d4826db40d47595b extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)((0, $94ac01aba299b123$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $94ac01aba299b123$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $4cd2867e245453be$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $4cd2867e245453be$export$e841ada32ff745b(parent, child.parentElement);
};




function $bc643594a40d9dcb$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $3b63da9e60d95533$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $bc643594a40d9dcb$export$f026abdbba7f0c9e extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $709eb61066a443a9$export$8793edee2d425525);
        this.removeEndListeners = (0, $709eb61066a443a9$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $709eb61066a443a9$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !globalTapTarget && !(0, $4cd2867e245453be$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $34c6553b58971442$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $34c6553b58971442$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $bc643594a40d9dcb$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $94ac01aba299b123$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $bc643594a40d9dcb$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $94ac01aba299b123$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $bc643594a40d9dcb$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $94ac01aba299b123$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $111174ce77203f86$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $34c6553b58971442$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $94ac01aba299b123$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $69cad8a989d60f6e$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $69cad8a989d60f6e$var$observers = new WeakMap();
const $69cad8a989d60f6e$var$fireObserverCallback = (entry)=>{
    const callback = $69cad8a989d60f6e$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $69cad8a989d60f6e$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($69cad8a989d60f6e$var$fireObserverCallback);
};
function $69cad8a989d60f6e$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$69cad8a989d60f6e$var$observers.has(lookupRoot)) $69cad8a989d60f6e$var$observers.set(lookupRoot, {});
    const rootObservers = $69cad8a989d60f6e$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($69cad8a989d60f6e$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $69cad8a989d60f6e$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $69cad8a989d60f6e$var$initIntersectionObserver(options);
    $69cad8a989d60f6e$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $69cad8a989d60f6e$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $01ba5f7eaef083b0$var$thresholdNames = {
    some: 0,
    all: 1
};
class $01ba5f7eaef083b0$export$150851c8cc2f0c72 extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $01ba5f7eaef083b0$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $69cad8a989d60f6e$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($01ba5f7eaef083b0$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $01ba5f7eaef083b0$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $f5fb539771490ee2$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $01ba5f7eaef083b0$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $bc643594a40d9dcb$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $2d9ab38999149902$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $d7c362976193f6c7$export$93a81ea037eac456)
    }
};





function $48b2f8747fc94bf0$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $aeed930e99adde3a$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $aeed930e99adde3a$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $aeed930e99adde3a$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $122b31be13f9d162$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $aeed930e99adde3a$var$getCurrent(visualElement), $aeed930e99adde3a$var$getVelocity(visualElement));
}







let $914f2a01374e708c$export$491112666e282270 = (0, $709eb61066a443a9$export$8793edee2d425525);
let $914f2a01374e708c$export$f5708dca728d7177 = (0, $709eb61066a443a9$export$8793edee2d425525);
var $914f2a01374e708c$var$check, $914f2a01374e708c$var$message, $914f2a01374e708c$var$check1, $914f2a01374e708c$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $526a51ea38092deb$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $526a51ea38092deb$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $443557f4ee67775e$export$888a3d84909f9e3d = {
    current: false
};


const $ac0f6a7f3b1ebbbe$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $ac039736424a9013$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $ac039736424a9013$export$2cf569f5e2221176[easing] || (0, $ac0f6a7f3b1ebbbe$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($ac039736424a9013$export$fcdd8f3f2160beda));
}
const $ac039736424a9013$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $ac039736424a9013$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $ac039736424a9013$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $ac039736424a9013$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $ac039736424a9013$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $ac039736424a9013$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $ac039736424a9013$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $ac0f6a7f3b1ebbbe$export$ff43f99925d7366b)(easing) ? $ac039736424a9013$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($ac039736424a9013$export$916ea73bcd3a6030) : $ac039736424a9013$export$2cf569f5e2221176[easing];
}


function $a23ee863ab64cd7f$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $ac039736424a9013$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $5a74a31f2568121b$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $9d94c17ce578afe2$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $9d94c17ce578afe2$var$subdivisionPrecision = 0.0000001;
const $9d94c17ce578afe2$var$subdivisionMaxIterations = 12;
function $9d94c17ce578afe2$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $9d94c17ce578afe2$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $9d94c17ce578afe2$var$subdivisionPrecision && ++i < $9d94c17ce578afe2$var$subdivisionMaxIterations);
    return currentT;
}
function $9d94c17ce578afe2$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $709eb61066a443a9$export$8793edee2d425525;
    const getTForX = (aX)=>$9d94c17ce578afe2$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $9d94c17ce578afe2$var$calcBezier(getTForX(t), mY1, mY2);
}


const $2699a200e1204d36$export$929e5a82286172a6 = (0, $9d94c17ce578afe2$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $2699a200e1204d36$export$57636bb43b1ccbb0 = (0, $9d94c17ce578afe2$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $2699a200e1204d36$export$c07234257a03d5e9 = (0, $9d94c17ce578afe2$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $cf56527349e184bd$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $4a4462cbda90bd6b$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $ac2775f04539a9dd$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $0c24b9f82088e008$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $0c24b9f82088e008$export$c8d67a19199d1a50 = (0, $ac2775f04539a9dd$export$2c07eeff45156d4d)($0c24b9f82088e008$export$e444123e42d03385);
const $0c24b9f82088e008$export$30d3455eee55bed5 = (0, $4a4462cbda90bd6b$export$f946554fb8aeaf0d)($0c24b9f82088e008$export$e444123e42d03385);





const $a65e05e01a4cda79$export$77edfce482316a60 = (0, $9d94c17ce578afe2$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a65e05e01a4cda79$export$b01116c84cdfe1a2 = (0, $ac2775f04539a9dd$export$2c07eeff45156d4d)($a65e05e01a4cda79$export$77edfce482316a60);
const $a65e05e01a4cda79$export$ddc5fd596f6c71b2 = (0, $4a4462cbda90bd6b$export$f946554fb8aeaf0d)($a65e05e01a4cda79$export$b01116c84cdfe1a2);



const $8b813e953975e64d$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a65e05e01a4cda79$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $a4ff3c5819dabb6f$var$easingLookup = {
    linear: (0, $709eb61066a443a9$export$8793edee2d425525),
    easeIn: $2699a200e1204d36$export$929e5a82286172a6,
    easeInOut: $2699a200e1204d36$export$c07234257a03d5e9,
    easeOut: $2699a200e1204d36$export$57636bb43b1ccbb0,
    circIn: $0c24b9f82088e008$export$e444123e42d03385,
    circInOut: $0c24b9f82088e008$export$30d3455eee55bed5,
    circOut: $0c24b9f82088e008$export$c8d67a19199d1a50,
    backIn: $a65e05e01a4cda79$export$b01116c84cdfe1a2,
    backInOut: $a65e05e01a4cda79$export$ddc5fd596f6c71b2,
    backOut: $a65e05e01a4cda79$export$77edfce482316a60,
    anticipate: $8b813e953975e64d$export$6b0af63b873d419e
};
const $a4ff3c5819dabb6f$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $914f2a01374e708c$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $9d94c17ce578afe2$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $914f2a01374e708c$export$f5708dca728d7177)($a4ff3c5819dabb6f$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $a4ff3c5819dabb6f$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $5da3b028cc79c519$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $fd4a6c3490270dbc$export$844ec244b1367d54)(v) && (0, $fd4a6c3490270dbc$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $5da3b028cc79c519$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $fd4a6c3490270dbc$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $fd4a6c3490270dbc$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $89c54125bc63c2b0$var$clampRgbUnit = (v)=>(0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)(0, 255, v);
const $89c54125bc63c2b0$export$7a99c86b5b1f4c9e = {
    ...(0, $fd4de4d4090bd1e0$export$98e628dec113755e),
    transform: (v)=>Math.round($89c54125bc63c2b0$var$clampRgbUnit(v))
};
const $89c54125bc63c2b0$export$4e46ac54fc82cf3b = {
    test: (0, $5da3b028cc79c519$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $5da3b028cc79c519$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $89c54125bc63c2b0$export$7a99c86b5b1f4c9e.transform(red) + ", " + $89c54125bc63c2b0$export$7a99c86b5b1f4c9e.transform(green) + ", " + $89c54125bc63c2b0$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $fd4a6c3490270dbc$export$83d2e9e3e4ee39ed)((0, $fd4de4d4090bd1e0$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $19d6c198c80e3f47$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $19d6c198c80e3f47$export$834dfc94dde4b3d8 = {
    test: (0, $5da3b028cc79c519$export$2c8400d58aca05e)("#"),
    parse: $19d6c198c80e3f47$var$parseHex,
    transform: (0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b).transform
};






const $2c5214bc0bfcf794$export$810b04175080204c = {
    test: (0, $5da3b028cc79c519$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $5da3b028cc79c519$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $aadbef2dd2f78d28$export$626336c2cd4b14de).transform((0, $fd4a6c3490270dbc$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $aadbef2dd2f78d28$export$626336c2cd4b14de).transform((0, $fd4a6c3490270dbc$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $fd4a6c3490270dbc$export$83d2e9e3e4ee39ed)((0, $fd4de4d4090bd1e0$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $a249955fd4987d05$export$35e9368ef982300f = {
    test: (v)=>(0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b).test(v) || (0, $19d6c198c80e3f47$export$834dfc94dde4b3d8).test(v) || (0, $2c5214bc0bfcf794$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b).test(v)) return (0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $2c5214bc0bfcf794$export$810b04175080204c).test(v)) return (0, $2c5214bc0bfcf794$export$810b04175080204c).parse(v);
        else return (0, $19d6c198c80e3f47$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $fd4a6c3490270dbc$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b).transform(v) : (0, $2c5214bc0bfcf794$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $8bd74505dbf4df56$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $8bd74505dbf4df56$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $8bd74505dbf4df56$var$hueToRgb(p, q, hue + 1 / 3);
        green = $8bd74505dbf4df56$var$hueToRgb(p, q, hue);
        blue = $8bd74505dbf4df56$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $c1d5ea532453e25b$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $c1d5ea532453e25b$var$colorTypes = [
    (0, $19d6c198c80e3f47$export$834dfc94dde4b3d8),
    (0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b),
    (0, $2c5214bc0bfcf794$export$810b04175080204c)
];
const $c1d5ea532453e25b$var$getColorType = (v)=>$c1d5ea532453e25b$var$colorTypes.find((type)=>type.test(v));
function $c1d5ea532453e25b$var$asRGBA(color) {
    const type = $c1d5ea532453e25b$var$getColorType(color);
    (0, $914f2a01374e708c$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $2c5214bc0bfcf794$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $8bd74505dbf4df56$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $c1d5ea532453e25b$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $c1d5ea532453e25b$var$asRGBA(from);
    const toRGBA = $c1d5ea532453e25b$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $c1d5ea532453e25b$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $c1d5ea532453e25b$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $c1d5ea532453e25b$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $89c54125bc63c2b0$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $2645af9d90f1501f$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $fd4a6c3490270dbc$export$844ec244b1367d54)(v) && (((_a = v.match((0, $fd4a6c3490270dbc$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $fd4a6c3490270dbc$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $2645af9d90f1501f$var$cssVarTokeniser = {
    regex: (0, $ea94389b875d6314$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $709eb61066a443a9$export$8793edee2d425525)
};
const $2645af9d90f1501f$var$colorTokeniser = {
    regex: (0, $fd4a6c3490270dbc$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $a249955fd4987d05$export$35e9368ef982300f).parse
};
const $2645af9d90f1501f$var$numberTokeniser = {
    regex: (0, $fd4a6c3490270dbc$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $fd4de4d4090bd1e0$export$98e628dec113755e).parse
};
function $2645af9d90f1501f$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $2645af9d90f1501f$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $2645af9d90f1501f$var$tokenise(info, $2645af9d90f1501f$var$cssVarTokeniser);
    $2645af9d90f1501f$var$tokenise(info, $2645af9d90f1501f$var$colorTokeniser);
    $2645af9d90f1501f$var$tokenise(info, $2645af9d90f1501f$var$numberTokeniser);
    return info;
}
function $2645af9d90f1501f$var$parseComplexValue(v) {
    return $2645af9d90f1501f$export$b61fc7c44bf646d5(v).values;
}
function $2645af9d90f1501f$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $2645af9d90f1501f$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($2645af9d90f1501f$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($2645af9d90f1501f$var$colorTokeniser.token, (0, $a249955fd4987d05$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($2645af9d90f1501f$var$numberTokeniser.token, (0, $fd4a6c3490270dbc$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $2645af9d90f1501f$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $2645af9d90f1501f$var$getAnimatableNone(v) {
    const parsed = $2645af9d90f1501f$var$parseComplexValue(v);
    const transformer = $2645af9d90f1501f$var$createTransformer(v);
    return transformer(parsed.map($2645af9d90f1501f$var$convertNumbersToZero));
}
const $2645af9d90f1501f$export$83a0e34f1302825b = {
    test: $2645af9d90f1501f$var$test,
    parse: $2645af9d90f1501f$var$parseComplexValue,
    createTransformer: $2645af9d90f1501f$var$createTransformer,
    getAnimatableNone: $2645af9d90f1501f$var$getAnimatableNone
};


const $2c234a0301f44b97$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $2c234a0301f44b97$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $a249955fd4987d05$export$35e9368ef982300f).test(origin)) return (0, $c1d5ea532453e25b$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $2c234a0301f44b97$var$mixImmediate(origin, target) : $2c234a0301f44b97$export$65516310a87d8205(origin, target);
}
const $2c234a0301f44b97$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$2c234a0301f44b97$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $2c234a0301f44b97$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $2c234a0301f44b97$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $2c234a0301f44b97$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $2645af9d90f1501f$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $2645af9d90f1501f$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $2645af9d90f1501f$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $bea3f45b78a0c8f1$export$a4627e546088548d)($2c234a0301f44b97$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $914f2a01374e708c$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $2c234a0301f44b97$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $798433f54cec3461$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $e9e5e1695a923f67$var$mixNumber = (from, to)=>(p)=>(0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(from, to, p);
function $e9e5e1695a923f67$var$detectMixerFactory(v) {
    if (typeof v === "number") return $e9e5e1695a923f67$var$mixNumber;
    else if (typeof v === "string") return (0, $a249955fd4987d05$export$35e9368ef982300f).test(v) ? (0, $c1d5ea532453e25b$export$51e568cf5c039bac) : (0, $2c234a0301f44b97$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $2c234a0301f44b97$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $2c234a0301f44b97$export$ebc23b6840c51ba1;
    return $e9e5e1695a923f67$var$mixNumber;
}
function $e9e5e1695a923f67$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $e9e5e1695a923f67$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $709eb61066a443a9$export$8793edee2d425525) : ease;
            mixer = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $e9e5e1695a923f67$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $914f2a01374e708c$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $e9e5e1695a923f67$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $798433f54cec3461$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $20c64d48f57a8d2e$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $798433f54cec3461$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $fd885e0bab832642$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $20c64d48f57a8d2e$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $591aa7605bf1347b$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $391ac2f26bab66b5$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $2699a200e1204d36$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $391ac2f26bab66b5$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $cf56527349e184bd$export$216948827bbdc797)(ease) ? ease.map((0, $a4ff3c5819dabb6f$export$ef97fe084f156ca4)) : (0, $a4ff3c5819dabb6f$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $591aa7605bf1347b$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $fd885e0bab832642$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $e9e5e1695a923f67$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $391ac2f26bab66b5$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $9b3722981f5e5a40$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $95ee6465e8e718bb$var$velocitySampleDuration = 5; // ms
function $95ee6465e8e718bb$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $95ee6465e8e718bb$var$velocitySampleDuration, 0);
    return (0, $9b3722981f5e5a40$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $6cd4cf907db1c7a5$var$safeMin = 0.001;
const $6cd4cf907db1c7a5$export$a3cdb76e84ee608e = 0.01;
const $6cd4cf907db1c7a5$export$1824b851fad8862b = 10.0;
const $6cd4cf907db1c7a5$export$ff08f2d53484465 = 0.05;
const $6cd4cf907db1c7a5$export$201ca48e54038115 = 1;
function $6cd4cf907db1c7a5$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $914f2a01374e708c$export$491112666e282270)(duration <= (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)($6cd4cf907db1c7a5$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)($6cd4cf907db1c7a5$export$ff08f2d53484465, $6cd4cf907db1c7a5$export$201ca48e54038115, dampingRatio);
    duration = (0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)($6cd4cf907db1c7a5$export$a3cdb76e84ee608e, $6cd4cf907db1c7a5$export$1824b851fad8862b, (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $6cd4cf907db1c7a5$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $6cd4cf907db1c7a5$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $6cd4cf907db1c7a5$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $6cd4cf907db1c7a5$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$6cd4cf907db1c7a5$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $6cd4cf907db1c7a5$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $6cd4cf907db1c7a5$var$rootIterations = 12;
function $6cd4cf907db1c7a5$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $6cd4cf907db1c7a5$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $6cd4cf907db1c7a5$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $f191112187eb2577$var$durationKeys = [
    "duration",
    "bounce"
];
const $f191112187eb2577$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $f191112187eb2577$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $f191112187eb2577$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$f191112187eb2577$var$isSpringType(options, $f191112187eb2577$var$physicsKeys) && $f191112187eb2577$var$isSpringType(options, $f191112187eb2577$var$durationKeys)) {
        const derived = (0, $6cd4cf907db1c7a5$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $f191112187eb2577$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $f191112187eb2577$var$getSpringOptions({
        ...options,
        velocity: -(0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $6cd4cf907db1c7a5$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $95ee6465e8e718bb$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $4f3f6ca2e340ab47$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $f191112187eb2577$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $95ee6465e8e718bb$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $5ad6a2c841cf8f80$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $5dbf294fbbccf87e$export$fff89137e9e818ce).isProcessing ? (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $331ab4c413d18eaa$export$f4ff70a5b4808fd8 = 20000;
function $331ab4c413d18eaa$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $331ab4c413d18eaa$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $331ab4c413d18eaa$export$f4ff70a5b4808fd8 ? Infinity : duration;
}



const $c7f02acb34fc9e56$var$types = {
    decay: (0, $4f3f6ca2e340ab47$export$ee3ff3a17106998),
    inertia: $4f3f6ca2e340ab47$export$ee3ff3a17106998,
    tween: (0, $391ac2f26bab66b5$export$d25ddfdf17c3ad3e),
    keyframes: (0, $391ac2f26bab66b5$export$d25ddfdf17c3ad3e),
    spring: $f191112187eb2577$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $c7f02acb34fc9e56$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $5ad6a2c841cf8f80$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $c7f02acb34fc9e56$var$types[type] || (0, $391ac2f26bab66b5$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $391ac2f26bab66b5$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $e9e5e1695a923f67$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $331ab4c413d18eaa$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $331ab4c413d18eaa$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $76147734bb39256c$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $218778f5964ae93b$var$supportsWaapi = (0, $76147734bb39256c$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $218778f5964ae93b$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $218778f5964ae93b$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $218778f5964ae93b$var$maxDuration = 20000;
const $218778f5964ae93b$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $ac039736424a9013$export$fcdd8f3f2160beda)(options.ease);
function $218778f5964ae93b$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $218778f5964ae93b$var$supportsWaapi() && $218778f5964ae93b$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Cancelling an animation will write to the DOM. For safety we want to defer
     * this until the next `update` frame lifecycle. This flag tracks whether we
     * have a pending cancel, if so we shouldn't allow animations to finish.
     */ let pendingCancel = false;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($218778f5964ae93b$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $c7f02acb34fc9e56$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $218778f5964ae93b$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $218778f5964ae93b$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $218778f5964ae93b$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $a23ee863ab64cd7f$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>{
        pendingCancel = false;
        animation.cancel();
    };
    const safeCancel = ()=>{
        pendingCancel = true;
        (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        if (pendingCancel) return;
        value.set((0, $5a74a31f2568121b$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $709eb61066a443a9$export$8793edee2d425525;
        },
        get time () {
            return (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $c7f02acb34fc9e56$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $218778f5964ae93b$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $218778f5964ae93b$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>{
            if (pendingCancel) return;
            animation.finish();
        },
        cancel: safeCancel
    };
    return controls;
}




function $4083e7b5bd90e4d9$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $709eb61066a443a9$export$8793edee2d425525),
            pause: (0, $709eb61066a443a9$export$8793edee2d425525),
            stop: (0, $709eb61066a443a9$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $709eb61066a443a9$export$8793edee2d425525),
            complete: (0, $709eb61066a443a9$export$8793edee2d425525)
        };
    };
    return delay ? (0, $c7f02acb34fc9e56$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $2f7b7017e38487e6$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $2f7b7017e38487e6$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $2f7b7017e38487e6$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $2f7b7017e38487e6$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $2f7b7017e38487e6$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $2f7b7017e38487e6$var$keyframesTransition;
    else if ((0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $2f7b7017e38487e6$var$criticallyDampedSpring(keyframes[1]) : $2f7b7017e38487e6$var$underDampedSpring;
    return $2f7b7017e38487e6$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $521b7f976c12f1ed$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $2645af9d90f1501f$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $6df9b1736b76ae18$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $6df9b1736b76ae18$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $fd4a6c3490270dbc$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $6df9b1736b76ae18$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $6df9b1736b76ae18$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $6df9b1736b76ae18$export$3dea766d36a8935f = {
    ...(0, $2645af9d90f1501f$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($6df9b1736b76ae18$var$functionRegex);
        return functions ? functions.map($6df9b1736b76ae18$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $dc44b75ec0e3dbb7$export$98cd7c72c5a731fb = {
    ...(0, $710703dd5863bfa3$export$eec14432cd1cb67b),
    color: // Color props
    $a249955fd4987d05$export$35e9368ef982300f,
    backgroundColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    outlineColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    fill: (0, $a249955fd4987d05$export$35e9368ef982300f),
    stroke: (0, $a249955fd4987d05$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    borderTopColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    borderRightColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    borderBottomColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    borderLeftColor: (0, $a249955fd4987d05$export$35e9368ef982300f),
    filter: $6df9b1736b76ae18$export$3dea766d36a8935f,
    WebkitFilter: (0, $6df9b1736b76ae18$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $dc44b75ec0e3dbb7$export$67d1babe0338d23b = (key)=>$dc44b75ec0e3dbb7$export$98cd7c72c5a731fb[key];


function $006c64b4ab7d8cac$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $dc44b75ec0e3dbb7$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $6df9b1736b76ae18$export$3dea766d36a8935f)) defaultValueType = (0, $2645af9d90f1501f$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $379a7844b6c223bf$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $2c5f766907219d93$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $379a7844b6c223bf$export$ade84c85e44a6cb1)(value);
}


function $c8a79e4c59560ec0$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $521b7f976c12f1ed$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $2c5f766907219d93$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $006c64b4ab7d8cac$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $f75817ce40412469$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $f75817ce40412469$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $b18c2ada5b8c408a$export$dd826089e3c5e502 = {
    skipAnimations: false
};


const $5f26eb06a3032e89$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $f75817ce40412469$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $c8a79e4c59560ec0$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $521b7f976c12f1ed$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $521b7f976c12f1ed$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $914f2a01374e708c$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $f75817ce40412469$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $2f7b7017e38487e6$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $443557f4ee67775e$export$888a3d84909f9e3d).current || valueTransition.type === false || (0, $b18c2ada5b8c408a$export$dd826089e3c5e502).skipAnimations) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $4083e7b5bd90e4d9$export$6f34fc8ef6c42b70)((0, $443557f4ee67775e$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (/**
         * If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $218778f5964ae93b$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $c7f02acb34fc9e56$export$ee9b76de7353d815)(options);
    };
};



function $3a7ac973cc0b8139$export$98397f3adbf6259f(value) {
    return Boolean((0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $ffb62715d647e8b9$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $a84c57f9c1418fd1$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $a84c57f9c1418fd1$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $a84c57f9c1418fd1$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $a9f5c4d164ca8228$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $a84c57f9c1418fd1$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $a84c57f9c1418fd1$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $6a9b7785b50d418f$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $6a9b7785b50d418f$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $6a9b7785b50d418f$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.18.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $5dbf294fbbccf87e$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $5dbf294fbbccf87e$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $6a9b7785b50d418f$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $a9f5c4d164ca8228$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($6a9b7785b50d418f$export$67fcd818a264039d.current) $6a9b7785b50d418f$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $9b3722981f5e5a40$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $6a9b7785b50d418f$export$ce8bdc721e76545f(init, options) {
    return new $6a9b7785b50d418f$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $13341717380ba38e$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $e4ac79f7656fe73c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $71edf6d080c4adaa$export$d176691c1998a1f5 = [
    (0, $fd4de4d4090bd1e0$export$98e628dec113755e),
    (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008),
    (0, $aadbef2dd2f78d28$export$626336c2cd4b14de),
    (0, $aadbef2dd2f78d28$export$41fc368e1a942b97),
    (0, $aadbef2dd2f78d28$export$aed3d7b7d206c196),
    (0, $aadbef2dd2f78d28$export$f91e8c45a95a32f2),
    (0, $e4ac79f7656fe73c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $71edf6d080c4adaa$export$eefdd52e3ccae428 = (v)=>$71edf6d080c4adaa$export$d176691c1998a1f5.find((0, $13341717380ba38e$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $ff8a71b3d5666564$var$valueTypes = [
    ...(0, $71edf6d080c4adaa$export$d176691c1998a1f5),
    (0, $a249955fd4987d05$export$35e9368ef982300f),
    (0, $2645af9d90f1501f$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $ff8a71b3d5666564$export$950e7e59ea1ffed7 = (v)=>$ff8a71b3d5666564$var$valueTypes.find((0, $13341717380ba38e$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $023132f08c70e8b0$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $6a9b7785b50d418f$export$ce8bdc721e76545f)(value));
}
function $023132f08c70e8b0$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $aeed930e99adde3a$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $240570da3b7ffcae$export$5485128c47bd48bb)(target[key]);
        $023132f08c70e8b0$var$setMotionValue(visualElement, key, value);
    }
}
function $023132f08c70e8b0$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $023132f08c70e8b0$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $023132f08c70e8b0$var$setVariants(child, variantLabels);
        });
    });
}
function $023132f08c70e8b0$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $023132f08c70e8b0$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $023132f08c70e8b0$var$setVariants(visualElement, [
        definition
    ]);
    else $023132f08c70e8b0$export$1f61c53461aff4a5(visualElement, definition);
}
function $023132f08c70e8b0$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $ffb62715d647e8b9$export$65583ed5a868f2d9)(value) || (0, $379a7844b6c223bf$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $ff8a71b3d5666564$export$950e7e59ea1ffed7)(value) && (0, $2645af9d90f1501f$export$83a0e34f1302825b).test(targetValue)) value = (0, $006c64b4ab7d8cac$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $6a9b7785b50d418f$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $023132f08c70e8b0$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $023132f08c70e8b0$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $023132f08c70e8b0$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $09d82c10b5662f8a$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $09d82c10b5662f8a$var$hasKeyframesChanged(value, target) {
    const current = value.get();
    if (Array.isArray(target)) for(let i = 0; i < target.length; i++){
        if (target[i] !== current) return true;
    }
    else return current !== target;
}
function $09d82c10b5662f8a$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $09d82c10b5662f8a$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $f75817ce40412469$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, $d75a1557b5f0e948$export$8592e1c077c890a6];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $5dbf294fbbccf87e$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    valueTransition.isHandoff = true;
                }
            }
        }
        let canSkip = !valueTransition.isHandoff && !$09d82c10b5662f8a$var$hasKeyframesChanged(value, valueTarget);
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, $5f26eb06a3032e89$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $3a7ac973cc0b8139$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $023132f08c70e8b0$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $13af47a112af5286$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $aeed930e99adde3a$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $09d82c10b5662f8a$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $13af47a112af5286$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $13af47a112af5286$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($13af47a112af5286$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($13af47a112af5286$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $13af47a112af5286$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $2fccbfce6c13beea$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $13af47a112af5286$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $13af47a112af5286$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $aeed930e99adde3a$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $09d82c10b5662f8a$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $e0a2fbdf6900a6b1$var$reversePriorityOrder = [
    ...(0, $be85fa1d3cfb6437$export$16e45afcc206d3a8)
].reverse();
const $e0a2fbdf6900a6b1$var$numAnimationTypes = (0, $be85fa1d3cfb6437$export$16e45afcc206d3a8).length;
function $e0a2fbdf6900a6b1$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $2fccbfce6c13beea$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $e0a2fbdf6900a6b1$export$bb53502b7a672aa8(visualElement) {
    let animate = $e0a2fbdf6900a6b1$var$animateList(visualElement);
    const state = $e0a2fbdf6900a6b1$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $aeed930e99adde3a$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $e0a2fbdf6900a6b1$var$numAnimationTypes; i++){
            const type = $e0a2fbdf6900a6b1$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $91251829777887b6$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $70615b426cbd2b46$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $e0a2fbdf6900a6b1$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $e9b0713b71e5ad60$export$9153ad4c4999f4a0)(next) && (0, $e9b0713b71e5ad60$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $48b2f8747fc94bf0$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $e0a2fbdf6900a6b1$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $48b2f8747fc94bf0$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $e0a2fbdf6900a6b1$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $e0a2fbdf6900a6b1$var$createState() {
    return {
        animate: $e0a2fbdf6900a6b1$var$createTypeState(true),
        whileInView: $e0a2fbdf6900a6b1$var$createTypeState(),
        whileHover: $e0a2fbdf6900a6b1$var$createTypeState(),
        whileTap: $e0a2fbdf6900a6b1$var$createTypeState(),
        whileDrag: $e0a2fbdf6900a6b1$var$createTypeState(),
        whileFocus: $e0a2fbdf6900a6b1$var$createTypeState(),
        exit: $e0a2fbdf6900a6b1$var$createTypeState()
    };
}



class $e65cf4fd4629c033$export$b45b3fe5caabdca extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $e0a2fbdf6900a6b1$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $70615b426cbd2b46$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $4b31d6f7517135d7$var$id = 0;
class $4b31d6f7517135d7$export$4989d1eb6104cc6c extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $4b31d6f7517135d7$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $b8f0b4dd4363a431$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $e65cf4fd4629c033$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $4b31d6f7517135d7$export$4989d1eb6104cc6c)
    }
};









const $08aa45ff3bd9a472$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $08aa45ff3bd9a472$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $08aa45ff3bd9a472$export$9f17032d917177de(a.x, b.x);
    const yDelta = $08aa45ff3bd9a472$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $8dc282031d694001$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $8dc282031d694001$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $08aa45ff3bd9a472$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $5dbf294fbbccf87e$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $8dc282031d694001$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $8dc282031d694001$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $8dc282031d694001$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $840fb45d383fc6c6$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $3b63da9e60d95533$export$12f84bb882d06e1a)(event);
        const initialInfo = $8dc282031d694001$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $5dbf294fbbccf87e$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $8dc282031d694001$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $bea3f45b78a0c8f1$export$a4627e546088548d)((0, $34c6553b58971442$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $34c6553b58971442$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $34c6553b58971442$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $8dc282031d694001$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $8dc282031d694001$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $8dc282031d694001$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $8dc282031d694001$var$subtractPoint(point, $8dc282031d694001$var$lastDevicePoint(history)),
        offset: $8dc282031d694001$var$subtractPoint(point, $8dc282031d694001$var$startDevicePoint(history)),
        velocity: $8dc282031d694001$var$getVelocity(history, 0.1)
    };
}
function $8dc282031d694001$var$startDevicePoint(history) {
    return history[0];
}
function $8dc282031d694001$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $8dc282031d694001$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $8dc282031d694001$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $526a51ea38092deb$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $526a51ea38092deb$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $ef97923ab0388ce0$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $ef97923ab0388ce0$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $ef97923ab0388ce0$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $ef97923ab0388ce0$export$c1c127004b72a37(target) / $ef97923ab0388ce0$export$c1c127004b72a37(source);
    if ($ef97923ab0388ce0$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($ef97923ab0388ce0$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $ef97923ab0388ce0$export$c0d25e96fc67d310(delta, source, target, origin) {
    $ef97923ab0388ce0$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $ef97923ab0388ce0$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $ef97923ab0388ce0$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $ef97923ab0388ce0$export$c1c127004b72a37(relative);
}
function $ef97923ab0388ce0$export$426154f9d100f99(target, relative, parent) {
    $ef97923ab0388ce0$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $ef97923ab0388ce0$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $ef97923ab0388ce0$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $ef97923ab0388ce0$export$c1c127004b72a37(layout);
}
function $ef97923ab0388ce0$export$2785bfcc929c5650(target, layout, parent) {
    $ef97923ab0388ce0$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $ef97923ab0388ce0$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $47687dbfe2773d15$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $47687dbfe2773d15$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $47687dbfe2773d15$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $47687dbfe2773d15$export$690c180aa5775042(layoutBox.x, left, right),
        y: $47687dbfe2773d15$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $47687dbfe2773d15$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $47687dbfe2773d15$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $47687dbfe2773d15$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $47687dbfe2773d15$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $47687dbfe2773d15$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(source);
    const targetLength = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $798433f54cec3461$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $798433f54cec3461$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $47687dbfe2773d15$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $47687dbfe2773d15$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $47687dbfe2773d15$export$7c5eaef8f4723d22(dragElastic = $47687dbfe2773d15$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $47687dbfe2773d15$export$a3366d3bac43a742;
    return {
        x: $47687dbfe2773d15$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $47687dbfe2773d15$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $47687dbfe2773d15$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $47687dbfe2773d15$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $47687dbfe2773d15$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $47687dbfe2773d15$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $26ad49ce9d7a92c0$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $26ad49ce9d7a92c0$export$3d227df54007d73a = ()=>({
        x: $26ad49ce9d7a92c0$export$ff25708b37f72782(),
        y: $26ad49ce9d7a92c0$export$ff25708b37f72782()
    });
const $26ad49ce9d7a92c0$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $26ad49ce9d7a92c0$export$6459fc9e86be362e = ()=>({
        x: $26ad49ce9d7a92c0$export$6db76765312617ac(),
        y: $26ad49ce9d7a92c0$export$6db76765312617ac()
    });


function $0a6e6c9499f1b04d$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $2be2f07a2cd259da$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $2be2f07a2cd259da$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $2be2f07a2cd259da$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $b9dac03025da29fe$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $b9dac03025da29fe$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$b9dac03025da29fe$var$isIdentityScale(scale) || !$b9dac03025da29fe$var$isIdentityScale(scaleX) || !$b9dac03025da29fe$var$isIdentityScale(scaleY);
}
function $b9dac03025da29fe$export$a545127cf1fbb600(values) {
    return $b9dac03025da29fe$export$bdf30dca883ea463(values) || $b9dac03025da29fe$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $b9dac03025da29fe$export$bf80f5f8f4dc327f(values) {
    return $b9dac03025da29fe$var$is2DTranslate(values.x) || $b9dac03025da29fe$var$is2DTranslate(values.y);
}
function $b9dac03025da29fe$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $4cb64ff9344e651d$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $4cb64ff9344e651d$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $4cb64ff9344e651d$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $4cb64ff9344e651d$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $4cb64ff9344e651d$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $4cb64ff9344e651d$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4cb64ff9344e651d$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $4cb64ff9344e651d$export$d80074982803af5c(box, { x: x, y: y }) {
    $4cb64ff9344e651d$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $4cb64ff9344e651d$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $4cb64ff9344e651d$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $4cb64ff9344e651d$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $4cb64ff9344e651d$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $b9dac03025da29fe$export$a545127cf1fbb600)(node.latestValues)) $4cb64ff9344e651d$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $4cb64ff9344e651d$var$snapToDefault(treeScale.x);
    treeScale.y = $4cb64ff9344e651d$var$snapToDefault(treeScale.y);
}
function $4cb64ff9344e651d$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $4cb64ff9344e651d$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $4cb64ff9344e651d$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $4cb64ff9344e651d$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $4cb64ff9344e651d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $4cb64ff9344e651d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $4cb64ff9344e651d$export$58b16271041fbfb(box, transform) {
    $4cb64ff9344e651d$export$625f1dd140a2f5e7(box.x, transform, $4cb64ff9344e651d$var$xKeys);
    $4cb64ff9344e651d$export$625f1dd140a2f5e7(box.y, transform, $4cb64ff9344e651d$var$yKeys);
}


function $ecbb9521a7ebb517$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $2be2f07a2cd259da$export$d3955c6a8f65a36b)((0, $2be2f07a2cd259da$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $ecbb9521a7ebb517$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $ecbb9521a7ebb517$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $9bf45c9f0628b95e$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $bf3e89c7c00efea6$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $bf3e89c7c00efea6$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $3b63da9e60d95533$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $111174ce77203f86$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $aadbef2dd2f78d28$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $bf3e89c7c00efea6$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $8dc282031d694001$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $9bf45c9f0628b95e$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$bf3e89c7c00efea6$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $47687dbfe2773d15$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $e9f3c51b93aef056$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $47687dbfe2773d15$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $47687dbfe2773d15$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $47687dbfe2773d15$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $e9f3c51b93aef056$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $914f2a01374e708c$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $ecbb9521a7ebb517$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $47687dbfe2773d15$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $2be2f07a2cd259da$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $2be2f07a2cd259da$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            if (!$bf3e89c7c00efea6$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $5f26eb06a3032e89$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$bf3e89c7c00efea6$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $e9f3c51b93aef056$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $47687dbfe2773d15$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            if (!$bf3e89c7c00efea6$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $bf3e89c7c00efea6$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $34c6553b58971442$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $e9f3c51b93aef056$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $94ac01aba299b123$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $47687dbfe2773d15$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $bf3e89c7c00efea6$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $bf3e89c7c00efea6$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $e824eec97edfbdea$export$5d97dc2872682820 extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $709eb61066a443a9$export$8793edee2d425525);
        this.removeListeners = (0, $709eb61066a443a9$export$8793edee2d425525);
        this.controls = new (0, $bf3e89c7c00efea6$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $709eb61066a443a9$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $c43fc44197c30296$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $c43fc44197c30296$export$b4f8f1ee75ce5859 extends (0, $f45c7c1c2de1d25e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $709eb61066a443a9$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $8dc282031d694001$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $9bf45c9f0628b95e$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $c43fc44197c30296$var$asyncHandler(onPanSessionStart),
            onStart: $c43fc44197c30296$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $34c6553b58971442$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $8275583514b5d175$export$2a8c16d82a0a0e26() {
    const context = (0, $f2Y41.useContext)((0, $cd7fbda68541d25e$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $f2Y41.useId)();
    (0, $f2Y41.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $8275583514b5d175$export$8249053f690ea39a() {
    return $8275583514b5d175$export$ee27c052bca048fb((0, $f2Y41.useContext)((0, $cd7fbda68541d25e$export$f224e4635b6f8ce2)));
}
function $8275583514b5d175$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $0f7f012764cdf3fd$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $6c8499600759bcb0$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $6c8499600759bcb0$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $aadbef2dd2f78d28$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $6c8499600759bcb0$export$fafff692be55225d(latest, node.target.x);
        const y = $6c8499600759bcb0$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $6b8fd234546d060f$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $2645af9d90f1501f$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $2645af9d90f1501f$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $443f37222a40a644$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $fba9fe967fbf1215$export$de9e7791c71225fd)($443f37222a40a644$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $0f7f012764cdf3fd$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $443f37222a40a644$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $8275583514b5d175$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $f2Y41.useContext)((0, $bbb6b89781bcd2c0$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($443f37222a40a644$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $f2Y41.useContext)((0, $e148fb33e18888cf$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $443f37222a40a644$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $6c8499600759bcb0$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $6c8499600759bcb0$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $6c8499600759bcb0$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $6c8499600759bcb0$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $6c8499600759bcb0$export$5eafb6257a5844c),
    boxShadow: (0, $6b8fd234546d060f$export$eb0bc629e74dcf8)
};








const $e7afda651c9c5bb0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $e7afda651c9c5bb0$var$numBorders = $e7afda651c9c5bb0$var$borders.length;
const $e7afda651c9c5bb0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $e7afda651c9c5bb0$var$isPx = (value)=>typeof value === "number" || (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008).test(value);
function $e7afda651c9c5bb0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $e7afda651c9c5bb0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $e7afda651c9c5bb0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $e7afda651c9c5bb0$var$numBorders; i++){
        const borderLabel = `border${$e7afda651c9c5bb0$var$borders[i]}Radius`;
        let followRadius = $e7afda651c9c5bb0$var$getRadius(follow, borderLabel);
        let leadRadius = $e7afda651c9c5bb0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $e7afda651c9c5bb0$var$isPx(followRadius) === $e7afda651c9c5bb0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)($e7afda651c9c5bb0$var$asNumber(followRadius), $e7afda651c9c5bb0$var$asNumber(leadRadius), progress), 0);
            if ((0, $aadbef2dd2f78d28$export$626336c2cd4b14de).test(leadRadius) || (0, $aadbef2dd2f78d28$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $e7afda651c9c5bb0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $e7afda651c9c5bb0$var$easeCrossfadeIn = $e7afda651c9c5bb0$var$compress(0, 0.5, (0, $0c24b9f82088e008$export$c8d67a19199d1a50));
const $e7afda651c9c5bb0$var$easeCrossfadeOut = $e7afda651c9c5bb0$var$compress(0.5, 0.95, (0, $709eb61066a443a9$export$8793edee2d425525));
function $e7afda651c9c5bb0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $798433f54cec3461$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $9ddb2b57d24406fb$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $9ddb2b57d24406fb$export$c53fd88f45d77e4b(box, originBox) {
    $9ddb2b57d24406fb$export$a0230ae482601ae8(box.x, originBox.x);
    $9ddb2b57d24406fb$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $cda84b351c3fbba1$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $4cb64ff9344e651d$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $4cb64ff9344e651d$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $cda84b351c3fbba1$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $aadbef2dd2f78d28$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $cda84b351c3fbba1$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $cda84b351c3fbba1$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $cda84b351c3fbba1$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $cda84b351c3fbba1$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $cda84b351c3fbba1$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $cda84b351c3fbba1$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $cda84b351c3fbba1$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $cda84b351c3fbba1$export$42b76f1d0d16d5b(box.x, transforms, $cda84b351c3fbba1$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $cda84b351c3fbba1$export$42b76f1d0d16d5b(box.y, transforms, $cda84b351c3fbba1$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $9df01b80d3fa0c0f$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $9df01b80d3fa0c0f$export$a7ec7642fe550fb6(delta) {
    return $9df01b80d3fa0c0f$var$isAxisDeltaZero(delta.x) && $9df01b80d3fa0c0f$var$isAxisDeltaZero(delta.y);
}
function $9df01b80d3fa0c0f$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $9df01b80d3fa0c0f$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $9df01b80d3fa0c0f$export$c5706146bc63213(box) {
    return (0, $ef97923ab0388ce0$export$c1c127004b72a37)(box.x) / (0, $ef97923ab0388ce0$export$c1c127004b72a37)(box.y);
}



class $57f9f388dcfd5dfd$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $a84c57f9c1418fd1$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $a84c57f9c1418fd1$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $fec1e77d294358d7$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $56f8d96f04c22a74$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $111c5e3ce4a8c396$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $a84c57f9c1418fd1$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $a84c57f9c1418fd1$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $56f8d96f04c22a74$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $85f1d2abd429f35a$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(checkElapsed);
}



function $b3c18e5e6356220f$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $77c7bf857346af99$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $db37d2202eb1875f$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(value) ? value : (0, $6a9b7785b50d418f$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $5f26eb06a3032e89$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $690c0b7d9aeef0c1$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $690c0b7d9aeef0c1$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $690c0b7d9aeef0c1$var$animationTarget = 1000;
let $690c0b7d9aeef0c1$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $690c0b7d9aeef0c1$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $690c0b7d9aeef0c1$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $690c0b7d9aeef0c1$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $690c0b7d9aeef0c1$var$projectionFrameData.totalNodes = $690c0b7d9aeef0c1$var$projectionFrameData.resolvedTargetDeltas = $690c0b7d9aeef0c1$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($690c0b7d9aeef0c1$export$131f2f0cc5fe9609);
                this.nodes.forEach($690c0b7d9aeef0c1$var$resolveTargetDelta);
                this.nodes.forEach($690c0b7d9aeef0c1$var$calcProjection);
                this.nodes.forEach($690c0b7d9aeef0c1$export$c2664f37bc951031);
                (0, $b3c18e5e6356220f$export$e5185e241753e543)($690c0b7d9aeef0c1$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $111c5e3ce4a8c396$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $a9f5c4d164ca8228$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $77c7bf857346af99$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $85f1d2abd429f35a$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $0f7f012764cdf3fd$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $0f7f012764cdf3fd$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($690c0b7d9aeef0c1$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $690c0b7d9aeef0c1$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $9df01b80d3fa0c0f$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $f75817ce40412469$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $690c0b7d9aeef0c1$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($690c0b7d9aeef0c1$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($690c0b7d9aeef0c1$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($690c0b7d9aeef0c1$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($690c0b7d9aeef0c1$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($690c0b7d9aeef0c1$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($690c0b7d9aeef0c1$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).delta = (0, $90953032fc0f5ac8$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).timestamp);
            (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).timestamp = now;
            (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).isProcessing = true;
            (0, $5dbf294fbbccf87e$export$be3f796aed065412).update.process((0, $5dbf294fbbccf87e$export$fff89137e9e818ce));
            (0, $5dbf294fbbccf87e$export$be3f796aed065412).preRender.process((0, $5dbf294fbbccf87e$export$fff89137e9e818ce));
            (0, $5dbf294fbbccf87e$export$be3f796aed065412).render.process((0, $5dbf294fbbccf87e$export$fff89137e9e818ce));
            (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($690c0b7d9aeef0c1$var$clearSnapshot);
            this.sharedNodes.forEach($690c0b7d9aeef0c1$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $9df01b80d3fa0c0f$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $b9dac03025da29fe$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $690c0b7d9aeef0c1$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $4cb64ff9344e651d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $4cb64ff9344e651d$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $b9dac03025da29fe$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $4cb64ff9344e651d$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $b9dac03025da29fe$export$a545127cf1fbb600)(this.latestValues)) (0, $4cb64ff9344e651d$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $b9dac03025da29fe$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $b9dac03025da29fe$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $cda84b351c3fbba1$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $b9dac03025da29fe$export$a545127cf1fbb600)(this.latestValues)) (0, $cda84b351c3fbba1$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    (0, $ef97923ab0388ce0$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $ef97923ab0388ce0$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $4cb64ff9344e651d$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    (0, $ef97923ab0388ce0$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $690c0b7d9aeef0c1$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $b9dac03025da29fe$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $b9dac03025da29fe$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $5dbf294fbbccf87e$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $4cb64ff9344e651d$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $26ad49ce9d7a92c0$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $26ad49ce9d7a92c0$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $26ad49ce9d7a92c0$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $ef97923ab0388ce0$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $fec1e77d294358d7$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $690c0b7d9aeef0c1$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $26ad49ce9d7a92c0$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($690c0b7d9aeef0c1$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $690c0b7d9aeef0c1$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $690c0b7d9aeef0c1$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $ef97923ab0388ce0$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $690c0b7d9aeef0c1$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $9df01b80d3fa0c0f$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $e7afda651c9c5bb0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(()=>{
                (0, $0f7f012764cdf3fd$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $db37d2202eb1875f$export$335a17c977067b99)(0, $690c0b7d9aeef0c1$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($690c0b7d9aeef0c1$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $690c0b7d9aeef0c1$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                const xLength = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $9ddb2b57d24406fb$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $4cb64ff9344e651d$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $ef97923ab0388ce0$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $57f9f388dcfd5dfd$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $690c0b7d9aeef0c1$var$transformAxes.length; i++){
                const key = "rotate" + $690c0b7d9aeef0c1$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $690c0b7d9aeef0c1$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $932237e3d7df006b$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $932237e3d7df006b$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $b9dac03025da29fe$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $fec1e77d294358d7$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $fba9fe967fbf1215$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $fba9fe967fbf1215$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $932237e3d7df006b$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($690c0b7d9aeef0c1$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $690c0b7d9aeef0c1$var$updateLayout(node) {
    node.updateLayout();
}
function $690c0b7d9aeef0c1$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($690c0b7d9aeef0c1$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $0a6e6c9499f1b04d$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ef97923ab0388ce0$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $26ad49ce9d7a92c0$export$3d227df54007d73a)();
        (0, $ef97923ab0388ce0$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $26ad49ce9d7a92c0$export$3d227df54007d73a)();
        if (isShared) (0, $ef97923ab0388ce0$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $ef97923ab0388ce0$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $9df01b80d3fa0c0f$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    (0, $ef97923ab0388ce0$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
                    (0, $ef97923ab0388ce0$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $9df01b80d3fa0c0f$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $690c0b7d9aeef0c1$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $690c0b7d9aeef0c1$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $690c0b7d9aeef0c1$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $690c0b7d9aeef0c1$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $690c0b7d9aeef0c1$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $690c0b7d9aeef0c1$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $690c0b7d9aeef0c1$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $690c0b7d9aeef0c1$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $690c0b7d9aeef0c1$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $690c0b7d9aeef0c1$var$calcProjection(node) {
    node.calcProjection();
}
function $690c0b7d9aeef0c1$var$resetRotation(node) {
    node.resetRotation();
}
function $690c0b7d9aeef0c1$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $690c0b7d9aeef0c1$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $690c0b7d9aeef0c1$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $ea956ab9c8e2c2c2$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $690c0b7d9aeef0c1$export$6ffd3e6ae339a132(output, from, to, p) {
    $690c0b7d9aeef0c1$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $690c0b7d9aeef0c1$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $690c0b7d9aeef0c1$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $690c0b7d9aeef0c1$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $690c0b7d9aeef0c1$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $690c0b7d9aeef0c1$var$roundPoint = $690c0b7d9aeef0c1$var$userAgentContains("applewebkit/") && !$690c0b7d9aeef0c1$var$userAgentContains("chrome/") ? Math.round : (0, $709eb61066a443a9$export$8793edee2d425525);
function $690c0b7d9aeef0c1$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $690c0b7d9aeef0c1$var$roundPoint(axis.min);
    axis.max = $690c0b7d9aeef0c1$var$roundPoint(axis.max);
}
function $690c0b7d9aeef0c1$var$roundBox(box) {
    $690c0b7d9aeef0c1$var$roundAxis(box.x);
    $690c0b7d9aeef0c1$var$roundAxis(box.y);
}
function $690c0b7d9aeef0c1$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $ef97923ab0388ce0$export$28d0384c4b79bde2)((0, $9df01b80d3fa0c0f$export$c5706146bc63213)(snapshot), (0, $9df01b80d3fa0c0f$export$c5706146bc63213)(layout), 0.2);
}




const $2e50e4748581005b$export$2d029a49a09b6177 = (0, $690c0b7d9aeef0c1$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $94ac01aba299b123$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $d6920a7ffc1e0a5b$export$b91509fcf893b648 = {
    current: undefined
};
const $d6920a7ffc1e0a5b$export$b61a9eb3dbde8858 = (0, $690c0b7d9aeef0c1$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$d6920a7ffc1e0a5b$export$b91509fcf893b648.current) {
            const documentNode = new (0, $2e50e4748581005b$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $d6920a7ffc1e0a5b$export$b91509fcf893b648.current = documentNode;
        }
        return $d6920a7ffc1e0a5b$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $23f0579b473eb67d$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $c43fc44197c30296$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $e824eec97edfbdea$export$5d97dc2872682820),
        ProjectionNode: (0, $d6920a7ffc1e0a5b$export$b61a9eb3dbde8858),
        MeasureLayout: $443f37222a40a644$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $edef554c375b9551$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $edef554c375b9551$export$b9f0c1f373aee2b0(current) {
    const match = $edef554c375b9551$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $edef554c375b9551$var$maxDepth = 4;
function $edef554c375b9551$var$getVariableValue(current, element, depth = 1) {
    (0, $914f2a01374e708c$export$f5708dca728d7177)(depth <= $edef554c375b9551$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $edef554c375b9551$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $ffb62715d647e8b9$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $ea94389b875d6314$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $edef554c375b9551$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $edef554c375b9551$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $ea94389b875d6314$export$31f9caa2600b5723)(current)) return;
        const resolved = $edef554c375b9551$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $ea94389b875d6314$export$31f9caa2600b5723)(current)) continue;
        const resolved = $edef554c375b9551$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $5a625deb6f3f8d23$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $5a625deb6f3f8d23$var$isPositionalKey = (key)=>$5a625deb6f3f8d23$var$positionalKeys.has(key);
const $5a625deb6f3f8d23$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($5a625deb6f3f8d23$var$isPositionalKey);
};
const $5a625deb6f3f8d23$var$isNumOrPxType = (v)=>v === (0, $fd4de4d4090bd1e0$export$98e628dec113755e) || v === (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008);
const $5a625deb6f3f8d23$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $5a625deb6f3f8d23$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $5a625deb6f3f8d23$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $5a625deb6f3f8d23$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $5a625deb6f3f8d23$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $5a625deb6f3f8d23$var$nonTranslationalTransformKeys = (0, $0ecc8bc19224a444$export$280dc01950909d86).filter((key)=>!$5a625deb6f3f8d23$var$transformKeys.has(key));
function $5a625deb6f3f8d23$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $5a625deb6f3f8d23$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $5a625deb6f3f8d23$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $5a625deb6f3f8d23$var$getTranslateFromMatrix(4, 13),
    y: $5a625deb6f3f8d23$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$5a625deb6f3f8d23$export$781d46a8aa670d52.translateX = $5a625deb6f3f8d23$export$781d46a8aa670d52.x;
$5a625deb6f3f8d23$export$781d46a8aa670d52.translateY = $5a625deb6f3f8d23$export$781d46a8aa670d52.y;
const $5a625deb6f3f8d23$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $5a625deb6f3f8d23$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $5a625deb6f3f8d23$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $5a625deb6f3f8d23$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($5a625deb6f3f8d23$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $71edf6d080c4adaa$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $e9b0713b71e5ad60$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $71edf6d080c4adaa$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $71edf6d080c4adaa$export$eefdd52e3ccae428)(to[i]);
                    (0, $914f2a01374e708c$export$f5708dca728d7177)(toType === fromType || $5a625deb6f3f8d23$var$isNumOrPxType(fromType) && $5a625deb6f3f8d23$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $914f2a01374e708c$export$f5708dca728d7177)((0, $71edf6d080c4adaa$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $71edf6d080c4adaa$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($5a625deb6f3f8d23$var$isNumOrPxType(fromType) && $5a625deb6f3f8d23$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $aadbef2dd2f78d28$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $5a625deb6f3f8d23$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $5a625deb6f3f8d23$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $8a8d5cf9b7d8f3fb$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $5a625deb6f3f8d23$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $5a625deb6f3f8d23$var$hasPositionalKey(target) ? $5a625deb6f3f8d23$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $0e802b064db833eb$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $edef554c375b9551$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $5a625deb6f3f8d23$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $87a803020ea92aea$export$ff7706047246b98b = {
    current: null
};
const $87a803020ea92aea$export$6476d16e2fd2d0db = {
    current: false
};


function $832e9a31884fbf44$export$ca9f41fb23dded3d() {
    (0, $87a803020ea92aea$export$6476d16e2fd2d0db).current = true;
    if (!(0, $8a8d5cf9b7d8f3fb$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $87a803020ea92aea$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $87a803020ea92aea$export$ff7706047246b98b).current = false;
}














function $07acf37f8cc5ee1b$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $3a7ac973cc0b8139$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $6a9b7785b50d418f$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $3a7ac973cc0b8139$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $6a9b7785b50d418f$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $0c84fade2413c271$export$bc2a978a17abfdde = new WeakMap();



const $f262929a9e4ae8eb$var$featureNames = Object.keys((0, $0108631ccf3abd34$export$65570e08d843624d));
const $f262929a9e4ae8eb$var$numFeatures = $f262929a9e4ae8eb$var$featureNames.length;
const $f262929a9e4ae8eb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $f262929a9e4ae8eb$var$numVariantProps = (0, $be85fa1d3cfb6437$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $f262929a9e4ae8eb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $5dbf294fbbccf87e$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $b269af27c9bfef57$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $b269af27c9bfef57$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $3a7ac973cc0b8139$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $0c84fade2413c271$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $87a803020ea92aea$export$6476d16e2fd2d0db).current) (0, $832e9a31884fbf44$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $87a803020ea92aea$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $0c84fade2413c271$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $5dbf294fbbccf87e$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $5dbf294fbbccf87e$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $f262929a9e4ae8eb$var$numFeatures; i++){
            const name = $f262929a9e4ae8eb$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $0108631ccf3abd34$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $e9f3c51b93aef056$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $f262929a9e4ae8eb$var$propEventHandlers.length; i++){
            const key = $f262929a9e4ae8eb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $07acf37f8cc5ee1b$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $f262929a9e4ae8eb$var$numVariantProps; i++){
            const name = (0, $be85fa1d3cfb6437$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $91251829777887b6$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $6a9b7785b50d418f$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $122b31be13f9d162$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $a9f5c4d164ca8228$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $bbe6fa367daf56d4$export$e49735c2a366bdc7 extends (0, $f262929a9e4ae8eb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $023132f08c70e8b0$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $023132f08c70e8b0$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $0e802b064db833eb$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $cc342b84cbb1d550$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $cc342b84cbb1d550$export$23fea75b03ac16b3 extends (0, $bbe6fa367daf56d4$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $dc44b75ec0e3dbb7$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $cc342b84cbb1d550$export$3735103072e4a80(instance);
            const value = ((0, $ea94389b875d6314$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $ecbb9521a7ebb517$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $fac79bc606541058$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $8c08c3c4fd4eb285$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $dbcf5d155a7a93bb$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $2c4b92c7ad8f677c$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $4c63d38d1fe8ed4e$export$86bcdffbaf733d84 extends (0, $bbe6fa367daf56d4$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $0ecc8bc19224a444$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $dc44b75ec0e3dbb7$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $c6102d84f857a56f$export$28931db5d57958e5).has(key) ? (0, $c96aab1dac0c1ff8$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $26ad49ce9d7a92c0$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $08029978089f9824$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $fdf145796eed0b60$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $10788993154c36c8$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $187c5bbc44ebd6c8$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $03989bf04bd6f0bc$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $7d91ae4ac4368187$export$88f3fc2fd3766989)(Component) ? new (0, $4c63d38d1fe8ed4e$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $cc342b84cbb1d550$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $3be4bd0129dfebaa$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $d6920a7ffc1e0a5b$export$b61a9eb3dbde8858),
        MeasureLayout: $443f37222a40a644$export$779f5fb01ad751cd
    }
};


const $57d2dbbeef65cd5e$var$preloadedFeatures = {
    ...(0, $b8f0b4dd4363a431$export$7f9953c70dacfd7f),
    ...(0, $f5fb539771490ee2$export$e5b72898e5a201f1),
    ...(0, $23f0579b473eb67d$export$d7d5d435647ed5a0),
    ...(0, $3be4bd0129dfebaa$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $57d2dbbeef65cd5e$export$e25e478948902b8b = /*@__PURE__*/ (0, $26028cae7631c06f$export$a28d6df673050e18)((Component, config)=>(0, $805f9a607ad0f577$export$732916c0e88175fb)(Component, config, $57d2dbbeef65cd5e$var$preloadedFeatures, (0, $03989bf04bd6f0bc$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $57d2dbbeef65cd5e$export$546614c4a05701f9(key) {
    return (0, $84a699809c9c1281$export$46b7e4b9dc6110c3)((0, $805f9a607ad0f577$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $57d2dbbeef65cd5e$var$preloadedFeatures, (0, $03989bf04bd6f0bc$export$56ba0183203348f5)));
}



var $f2Y41 = parcelRequire("f2Y41");


function $0abbdbc72eacd52a$export$5462965298c633aa(props) {
    const { question: question, deleteStudyQuestion: deleteStudyQuestion, updateStudyQuestion: updateStudyQuestion, maxOrder: maxOrder, decrementQuestionOrder: decrementQuestionOrder, incrementQuestionOrder: incrementQuestionOrder } = props;
    const [editing, setEditing] = (0, $f2Y41.useState)("");
    const [protocolReference, setProtocolReference] = (0, $f2Y41.useState)(question?.protocol_reference);
    const [decrementing, setDecrementing] = (0, $f2Y41.useState)(false);
    const [incrementing, setIncrementing] = (0, $f2Y41.useState)(false);
    const handleDecrement = (question)=>{
        if (question?.order <= 1) return;
        setDecrementing(true);
        decrementQuestionOrder(question?.id);
    };
    const handleIncrement = (question)=>{
        if (question?.order >= maxOrder()) return;
        setIncrementing(true);
        incrementQuestionOrder(question?.id);
    };
    // return (<>{JSON.stringify(question?.question?.full_text)}</>)
    if (question?.question === undefined) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $57d2dbbeef65cd5e$export$e25e478948902b8b).div, {
        animate: decrementing ? {
            top: "-80px",
            transitionEnd: {
                top: "0px"
            }
        } : incrementing ? {
            zIndex: 100,
            top: "80px",
            transitionEnd: {
                top: "0px"
            }
        } : {},
        onAnimationComplete: ()=>{
            setDecrementing(false);
            setIncrementing(false);
        },
        className: "relative flex mt-4 ml-4 mr-4 p-4 border border-gray-200 rounded transition duration-500 ease-in-out dark:bg-gray-800 bg-white",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mr-4 w-4",
                        children: question?.order
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "pr-4",
                        children: [
                            question?.exclusion_criteria === false && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "px-2 py-1 text-xs rounded-2xl bg-green-500 text-gray-50",
                                children: "Inclusion"
                            }),
                            (question?.exclusion_criteria === true || question?.exclusion_criteria === null) && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "px-2 py-1 text-xs rounded-2xl bg-red-500 text-gray-50",
                                children: "Exclusion"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                outline: false,
                                className: "text-gray-500",
                                icon: "CheckCircleIcon",
                                extraClasses: "w-8 h-8 hover:text-green-400 hover:cursor-pointer"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                outline: false,
                                className: "text-gray-500",
                                icon: "XCircleIcon",
                                extraClasses: "w-8 h-8 hover:text-red-400 hover:cursor-pointer"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                outline: false,
                                className: "text-gray-500",
                                icon: "QuestionMarkCircleIcon",
                                extraClasses: "w-8 h-8 hover:cursor-pointer hover:text-yellow-400"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex items-center pb-1 ml-4 my-2",
                onClick: ()=>setEditing("protocol_reference"),
                onKeyUp: ()=>setEditing("protocol_reference"),
                children: editing !== "protocol_reference" && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "PencilAltIcon",
                    className: "h-4 w-4 ml-2 mr-2 mt-0.5 hover:cursor-pointer"
                })
            }),
            editing !== "protocol_reference" && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex items-center w-1/12",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "text-sm",
                    children: [
                        "Protocol Ref: ",
                        question?.protocol_reference
                    ]
                })
            }),
            editing === "protocol_reference" && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex items-center ",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                        className: "w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:text-gray-900",
                        // defaultValue={question?.protocol_reference}
                        value: protocolReference,
                        onInput: (e)=>setProtocolReference(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                        type: "button",
                        className: "ml-2 border border-topo-green-200 bg-transparent hover:bg-topo-green-100 dark:hover:bg-green-200 hover:bg-opacity-50 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-topo-green text-xs font-medium mr-2 px-2.5 py-2 rounded-md flex items-center justify-between",
                        // onClick, send the question_id and the updated study_question attributes to the patch endpoint
                        onClick: ()=>{
                            updateStudyQuestion(question?.id, {
                                protocol_reference: protocolReference
                            });
                            setEditing("");
                        },
                        children: [
                            "Save",
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "CheckCircleIcon",
                                className: "ml-1 w-5 h-5 flex"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setEditing(""),
                        className: "border border-gray-200 bg-transparent hover:bg-gray-100 dark:hover:bg-gray-200 hover:bg-opacity-50 focus:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2 text-gray-500 text-xs font-medium mr-6 px-2.5 py-2 rounded-md flex items-center justify-between",
                        children: [
                            "Cancel",
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "XCircleIcon",
                                className: "ml-1 w-5 h-5 flex text-gray"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex-1 flex items-center ml-2",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "text-sm",
                        children: question?.question?.full_text
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "text-sm",
                        children: [
                            question?.question?.short_text,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-1 flex items-center ml-2 justify-end",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "text-sm ml-auto mr-2 w-15 flex justify-start",
                    children: (0, $0dcae3260236e0d2$export$d207855dff529fc9)(question?.updated_at)
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    question?.order < maxOrder() ? /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "ml-2",
                        onClick: ()=>handleIncrement(question),
                        onKeyUp: ()=>handleIncrement(question),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "ArrowDownIcon",
                            className: "h-5 hover:text-topo-green-500 hover:cursor-pointer",
                            outline: true
                        })
                    }) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "ml-2 w-5"
                    }),
                    question?.order > 1 ? /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "ml-2",
                        onClick: ()=>handleDecrement(question),
                        onKeyUp: ()=>handleDecrement(question),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "ArrowUpIcon",
                            className: "h-5 hover:text-topo-green-500 hover:cursor-pointer",
                            outline: true
                        })
                    }) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "ml-2 w-5"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "ml-4",
                        onClick: ()=>deleteStudyQuestion(question?.id),
                        onKeyUp: ()=>deleteStudyQuestion(question?.id),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "TrashIcon",
                            className: "h-5 hover:text-red-500 hover:cursor-pointer",
                            outline: true
                        })
                    })
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $d5ad39ceacacfaf4$var$isArray(value) {
    return !Array.isArray ? $d5ad39ceacacfaf4$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $d5ad39ceacacfaf4$var$INFINITY = 1 / 0;
function $d5ad39ceacacfaf4$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$d5ad39ceacacfaf4$var$INFINITY ? "-0" : result;
}
function $d5ad39ceacacfaf4$var$toString(value) {
    return value == null ? "" : $d5ad39ceacacfaf4$var$baseToString(value);
}
function $d5ad39ceacacfaf4$var$isString(value) {
    return typeof value === "string";
}
function $d5ad39ceacacfaf4$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $d5ad39ceacacfaf4$var$isBoolean(value) {
    return value === true || value === false || $d5ad39ceacacfaf4$var$isObjectLike(value) && $d5ad39ceacacfaf4$var$getTag(value) == "[object Boolean]";
}
function $d5ad39ceacacfaf4$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $d5ad39ceacacfaf4$var$isObjectLike(value) {
    return $d5ad39ceacacfaf4$var$isObject(value) && value !== null;
}
function $d5ad39ceacacfaf4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $d5ad39ceacacfaf4$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $d5ad39ceacacfaf4$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $d5ad39ceacacfaf4$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $d5ad39ceacacfaf4$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $d5ad39ceacacfaf4$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $d5ad39ceacacfaf4$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $d5ad39ceacacfaf4$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $d5ad39ceacacfaf4$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $d5ad39ceacacfaf4$var$hasOwn = Object.prototype.hasOwnProperty;
class $d5ad39ceacacfaf4$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $d5ad39ceacacfaf4$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $d5ad39ceacacfaf4$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($d5ad39ceacacfaf4$var$isString(key) || $d5ad39ceacacfaf4$var$isArray(key)) {
        src = key;
        path = $d5ad39ceacacfaf4$var$createKeyPath(key);
        id = $d5ad39ceacacfaf4$var$createKeyId(key);
    } else {
        if (!$d5ad39ceacacfaf4$var$hasOwn.call(key, "name")) throw new Error($d5ad39ceacacfaf4$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($d5ad39ceacacfaf4$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($d5ad39ceacacfaf4$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $d5ad39ceacacfaf4$var$createKeyPath(name);
        id = $d5ad39ceacacfaf4$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $d5ad39ceacacfaf4$var$createKeyPath(key) {
    return $d5ad39ceacacfaf4$var$isArray(key) ? key : key.split(".");
}
function $d5ad39ceacacfaf4$var$createKeyId(key) {
    return $d5ad39ceacacfaf4$var$isArray(key) ? key.join(".") : key;
}
function $d5ad39ceacacfaf4$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$d5ad39ceacacfaf4$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$d5ad39ceacacfaf4$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($d5ad39ceacacfaf4$var$isString(value) || $d5ad39ceacacfaf4$var$isNumber(value) || $d5ad39ceacacfaf4$var$isBoolean(value))) list.push($d5ad39ceacacfaf4$var$toString(value));
            else if ($d5ad39ceacacfaf4$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $d5ad39ceacacfaf4$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $d5ad39ceacacfaf4$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $d5ad39ceacacfaf4$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $d5ad39ceacacfaf4$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $d5ad39ceacacfaf4$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $d5ad39ceacacfaf4$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $d5ad39ceacacfaf4$var$Config = {
    ...$d5ad39ceacacfaf4$var$BasicOptions,
    ...$d5ad39ceacacfaf4$var$MatchOptions,
    ...$d5ad39ceacacfaf4$var$FuzzyOptions,
    ...$d5ad39ceacacfaf4$var$AdvancedOptions
};
const $d5ad39ceacacfaf4$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $d5ad39ceacacfaf4$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($d5ad39ceacacfaf4$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $d5ad39ceacacfaf4$var$FuseIndex {
    constructor({ getFn: getFn = $d5ad39ceacacfaf4$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d5ad39ceacacfaf4$var$Config.fieldNormWeight } = {}){
        this.norm = $d5ad39ceacacfaf4$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($d5ad39ceacacfaf4$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($d5ad39ceacacfaf4$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$d5ad39ceacacfaf4$var$isDefined(doc) || $d5ad39ceacacfaf4$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$d5ad39ceacacfaf4$var$isDefined(value)) return;
            if ($d5ad39ceacacfaf4$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$d5ad39ceacacfaf4$var$isDefined(value)) continue;
                    if ($d5ad39ceacacfaf4$var$isString(value) && !$d5ad39ceacacfaf4$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($d5ad39ceacacfaf4$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($d5ad39ceacacfaf4$var$isString(value) && !$d5ad39ceacacfaf4$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $d5ad39ceacacfaf4$var$createIndex(keys, docs, { getFn: getFn = $d5ad39ceacacfaf4$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d5ad39ceacacfaf4$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $d5ad39ceacacfaf4$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($d5ad39ceacacfaf4$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $d5ad39ceacacfaf4$var$parseIndex(data, { getFn: getFn = $d5ad39ceacacfaf4$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d5ad39ceacacfaf4$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $d5ad39ceacacfaf4$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $d5ad39ceacacfaf4$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $d5ad39ceacacfaf4$var$Config.distance, ignoreLocation: ignoreLocation = $d5ad39ceacacfaf4$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $d5ad39ceacacfaf4$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $d5ad39ceacacfaf4$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $d5ad39ceacacfaf4$var$MAX_BITS = 32;
function $d5ad39ceacacfaf4$var$search(text, pattern, patternAlphabet, { location: location = $d5ad39ceacacfaf4$var$Config.location, distance: distance = $d5ad39ceacacfaf4$var$Config.distance, threshold: threshold = $d5ad39ceacacfaf4$var$Config.threshold, findAllMatches: findAllMatches = $d5ad39ceacacfaf4$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d5ad39ceacacfaf4$var$Config.minMatchCharLength, includeMatches: includeMatches = $d5ad39ceacacfaf4$var$Config.includeMatches, ignoreLocation: ignoreLocation = $d5ad39ceacacfaf4$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $d5ad39ceacacfaf4$var$MAX_BITS) throw new Error($d5ad39ceacacfaf4$var$PATTERN_LENGTH_TOO_LARGE($d5ad39ceacacfaf4$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $d5ad39ceacacfaf4$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $d5ad39ceacacfaf4$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $d5ad39ceacacfaf4$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $d5ad39ceacacfaf4$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $d5ad39ceacacfaf4$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $d5ad39ceacacfaf4$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $d5ad39ceacacfaf4$var$BitapSearch {
    constructor(pattern, { location: location = $d5ad39ceacacfaf4$var$Config.location, threshold: threshold = $d5ad39ceacacfaf4$var$Config.threshold, distance: distance = $d5ad39ceacacfaf4$var$Config.distance, includeMatches: includeMatches = $d5ad39ceacacfaf4$var$Config.includeMatches, findAllMatches: findAllMatches = $d5ad39ceacacfaf4$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d5ad39ceacacfaf4$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $d5ad39ceacacfaf4$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $d5ad39ceacacfaf4$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $d5ad39ceacacfaf4$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $d5ad39ceacacfaf4$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $d5ad39ceacacfaf4$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $d5ad39ceacacfaf4$var$MAX_BITS), i);
                i += $d5ad39ceacacfaf4$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $d5ad39ceacacfaf4$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $d5ad39ceacacfaf4$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $d5ad39ceacacfaf4$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $d5ad39ceacacfaf4$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $d5ad39ceacacfaf4$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $d5ad39ceacacfaf4$var$ExactMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $d5ad39ceacacfaf4$var$InverseExactMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $d5ad39ceacacfaf4$var$PrefixExactMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $d5ad39ceacacfaf4$var$InversePrefixExactMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $d5ad39ceacacfaf4$var$SuffixExactMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $d5ad39ceacacfaf4$var$InverseSuffixExactMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $d5ad39ceacacfaf4$var$FuzzyMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern, { location: location = $d5ad39ceacacfaf4$var$Config.location, threshold: threshold = $d5ad39ceacacfaf4$var$Config.threshold, distance: distance = $d5ad39ceacacfaf4$var$Config.distance, includeMatches: includeMatches = $d5ad39ceacacfaf4$var$Config.includeMatches, findAllMatches: findAllMatches = $d5ad39ceacacfaf4$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d5ad39ceacacfaf4$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $d5ad39ceacacfaf4$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $d5ad39ceacacfaf4$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $d5ad39ceacacfaf4$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $d5ad39ceacacfaf4$var$IncludeMatch extends $d5ad39ceacacfaf4$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $d5ad39ceacacfaf4$var$searchers = [
    $d5ad39ceacacfaf4$var$ExactMatch,
    $d5ad39ceacacfaf4$var$IncludeMatch,
    $d5ad39ceacacfaf4$var$PrefixExactMatch,
    $d5ad39ceacacfaf4$var$InversePrefixExactMatch,
    $d5ad39ceacacfaf4$var$InverseSuffixExactMatch,
    $d5ad39ceacacfaf4$var$SuffixExactMatch,
    $d5ad39ceacacfaf4$var$InverseExactMatch,
    $d5ad39ceacacfaf4$var$FuzzyMatch
];
const $d5ad39ceacacfaf4$var$searchersLen = $d5ad39ceacacfaf4$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $d5ad39ceacacfaf4$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $d5ad39ceacacfaf4$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $d5ad39ceacacfaf4$var$parseQuery(pattern, options = {}) {
    return pattern.split($d5ad39ceacacfaf4$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($d5ad39ceacacfaf4$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $d5ad39ceacacfaf4$var$searchersLen){
                const searcher = $d5ad39ceacacfaf4$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $d5ad39ceacacfaf4$var$searchersLen){
                const searcher = $d5ad39ceacacfaf4$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $d5ad39ceacacfaf4$var$MultiMatchSet = new Set([
    $d5ad39ceacacfaf4$var$FuzzyMatch.type,
    $d5ad39ceacacfaf4$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $d5ad39ceacacfaf4$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $d5ad39ceacacfaf4$var$Config.isCaseSensitive, includeMatches: includeMatches = $d5ad39ceacacfaf4$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $d5ad39ceacacfaf4$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $d5ad39ceacacfaf4$var$Config.ignoreLocation, findAllMatches: findAllMatches = $d5ad39ceacacfaf4$var$Config.findAllMatches, location: location = $d5ad39ceacacfaf4$var$Config.location, threshold: threshold = $d5ad39ceacacfaf4$var$Config.threshold, distance: distance = $d5ad39ceacacfaf4$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $d5ad39ceacacfaf4$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($d5ad39ceacacfaf4$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $d5ad39ceacacfaf4$var$registeredSearchers = [];
function $d5ad39ceacacfaf4$var$register(...args) {
    $d5ad39ceacacfaf4$var$registeredSearchers.push(...args);
}
function $d5ad39ceacacfaf4$var$createSearcher(pattern, options) {
    for(let i = 0, len = $d5ad39ceacacfaf4$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $d5ad39ceacacfaf4$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $d5ad39ceacacfaf4$var$BitapSearch(pattern, options);
}
const $d5ad39ceacacfaf4$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $d5ad39ceacacfaf4$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $d5ad39ceacacfaf4$var$isExpression = (query)=>!!(query[$d5ad39ceacacfaf4$var$LogicalOperator.AND] || query[$d5ad39ceacacfaf4$var$LogicalOperator.OR]);
const $d5ad39ceacacfaf4$var$isPath = (query)=>!!query[$d5ad39ceacacfaf4$var$KeyType.PATH];
const $d5ad39ceacacfaf4$var$isLeaf = (query)=>!$d5ad39ceacacfaf4$var$isArray(query) && $d5ad39ceacacfaf4$var$isObject(query) && !$d5ad39ceacacfaf4$var$isExpression(query);
const $d5ad39ceacacfaf4$var$convertToExplicit = (query)=>({
        [$d5ad39ceacacfaf4$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $d5ad39ceacacfaf4$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $d5ad39ceacacfaf4$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$d5ad39ceacacfaf4$var$isExpression(query)) return next($d5ad39ceacacfaf4$var$convertToExplicit(query));
        if ($d5ad39ceacacfaf4$var$isLeaf(query)) {
            const key = isQueryPath ? query[$d5ad39ceacacfaf4$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$d5ad39ceacacfaf4$var$KeyType.PATTERN] : query[key];
            if (!$d5ad39ceacacfaf4$var$isString(pattern)) throw new Error($d5ad39ceacacfaf4$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $d5ad39ceacacfaf4$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $d5ad39ceacacfaf4$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($d5ad39ceacacfaf4$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$d5ad39ceacacfaf4$var$isExpression(query)) query = $d5ad39ceacacfaf4$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $d5ad39ceacacfaf4$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $d5ad39ceacacfaf4$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $d5ad39ceacacfaf4$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$d5ad39ceacacfaf4$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$d5ad39ceacacfaf4$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $d5ad39ceacacfaf4$var$transformScore(result, data) {
    data.score = result.score;
}
function $d5ad39ceacacfaf4$var$format(results, docs, { includeMatches: includeMatches = $d5ad39ceacacfaf4$var$Config.includeMatches, includeScore: includeScore = $d5ad39ceacacfaf4$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($d5ad39ceacacfaf4$var$transformMatches);
    if (includeScore) transformers.push($d5ad39ceacacfaf4$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $d5ad39ceacacfaf4$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$d5ad39ceacacfaf4$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $d5ad39ceacacfaf4$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $d5ad39ceacacfaf4$var$FuseIndex)) throw new Error($d5ad39ceacacfaf4$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $d5ad39ceacacfaf4$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$d5ad39ceacacfaf4$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $d5ad39ceacacfaf4$var$isString(query) ? $d5ad39ceacacfaf4$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $d5ad39ceacacfaf4$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($d5ad39ceacacfaf4$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $d5ad39ceacacfaf4$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $d5ad39ceacacfaf4$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$d5ad39ceacacfaf4$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $d5ad39ceacacfaf4$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $d5ad39ceacacfaf4$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($d5ad39ceacacfaf4$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $d5ad39ceacacfaf4$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$d5ad39ceacacfaf4$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$d5ad39ceacacfaf4$var$isDefined(value)) return [];
        let matches = [];
        if ($d5ad39ceacacfaf4$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$d5ad39ceacacfaf4$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$d5ad39ceacacfaf4$export$2e2bcd8739ae039.version = "7.0.0";
$d5ad39ceacacfaf4$export$2e2bcd8739ae039.createIndex = $d5ad39ceacacfaf4$var$createIndex;
$d5ad39ceacacfaf4$export$2e2bcd8739ae039.parseIndex = $d5ad39ceacacfaf4$var$parseIndex;
$d5ad39ceacacfaf4$export$2e2bcd8739ae039.config = $d5ad39ceacacfaf4$var$Config;
$d5ad39ceacacfaf4$export$2e2bcd8739ae039.parseQuery = $d5ad39ceacacfaf4$var$parse;
$d5ad39ceacacfaf4$var$register($d5ad39ceacacfaf4$var$ExtendedSearch);



var $f2Y41 = parcelRequire("f2Y41");


function $cc2b6f5aa5abe6b4$var$createQuestion(data) {
// TODO useCreate
// TODO create question with full_text, returns questionId
// addQuestion(questionId)
}
function $cc2b6f5aa5abe6b4$export$926a6fe223a2603b(props) {
    const { setOpen: setOpen, open: open, refreshData: refreshData, questions: questions } = props;
    const [filteredQuestions, setFilteredQuestions] = (0, $f2Y41.useState)([]);
    const [selectedQuestion, setSelectedQuestion] = (0, $f2Y41.useState)(null);
    const [studyQuestionExclusion, setStudyQuestionExclusion] = (0, $f2Y41.useState)(false);
    const [addingQuestion, setAddingQuestion] = (0, $f2Y41.useState)(false);
    const [fullText, setFullText] = (0, $f2Y41.useState)("");
    const [searchText, setSearchText] = (0, $f2Y41.useState)("");
    const handleChangeFilterText = (event)=>{
        const fuse = new (0, $d5ad39ceacacfaf4$export$2e2bcd8739ae039)(questions, {
            keys: [
                "full_text"
            ]
        });
        const result = fuse.search(event.target.value);
        setSearchText(event.target.value);
        setFilteredQuestions(result);
    };
    const handleQuestionClick = (item)=>{
        // props.addQuestion(item?.id)
        // toast.success('Saved')
        setSelectedQuestion(item);
    // setFullText(item.full_text)
    // handleChangeFilterText({target: {value: ''}})
    };
    const handleClickNewQuestion = ()=>{
        setAddingQuestion(true);
        setFullText(searchText);
        setFilteredQuestions([]);
    };
    const handleSaveQuestion = async ()=>{
        const response = await props.addQuestion(fullText);
        const question = response.data.data;
        (0, (/*@__PURE__*/$parcel$interopDefault($3d12054b9ed86c19$exports))).success("Question Saved");
        setSelectedQuestion(question);
        setAddingQuestion(false);
        refreshData();
    };
    const handleClickAddToStudy = ()=>{
        props.addStudyQuestion({
            question_id: selectedQuestion?.id,
            exclusion_criteria: studyQuestionExclusion
        });
        setAddingQuestion(false);
        setSelectedQuestion(null);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], ()=>props.setOpen(false));
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $f2Y41.Fragment),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed inset-0 overflow-hidden",
            onClose: props.setOpen,
            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "absolute inset-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153).Overlay, {
                        className: "absolute inset-0"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4).Child, {
                            as: (0, $f2Y41.Fragment),
                            enter: "transform transition ease-in-out duration-400 sm:duration-700",
                            enterFrom: "translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transform transition ease-in-out duration-400 sm:duration-700",
                            leaveFrom: "translate-x-0",
                            leaveTo: "translate-x-full",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "pointer-events-auto w-screen max-w-2xl",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex h-full flex-col overflow-y-scroll bg-white shadow-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: " bg-topo-navy px-4 py-6 sm:px-6",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "flex items-start justify-between space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                className: "space-y-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153).Title, {
                                                                        className: "text-lg font-medium text-gray-100",
                                                                        children: "Questions"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                                        className: "text-sm text-gray-300",
                                                                        children: "Click a question below to add it to the study."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "flex h-7 items-center",
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "text-gray-400 hover:text-gray-500",
                                                                    onClick: ()=>props.setOpen(false),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                            className: "sr-only",
                                                                            children: "Close panel"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ad688b80368a215e$export$2e2bcd8739ae039), {
                                                                            className: "h-6 w-6",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                selectedQuestion && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "p-6 space-y-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            className: "border rounded border-gray-100 p-4 hover:bg-gray-200 cursor-pointer",
                                                            children: selectedQuestion.full_text
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                            type: "button",
                                                            className: `mr-2 inline-flex items-center px-4 py-2 border-2 border-gray-100 shadow-sm text-sm leading-4 font-medium rounded-md hover:border-green-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent  ${studyQuestionExclusion === false ? "text-green-700 bg-green-400 outline-none ring-2 ring-offset-2 ring-green-500 dark:bg-green-400" : ""}}`,
                                                            onClick: ()=>setStudyQuestionExclusion(false),
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "mr-1",
                                                                children: "Inclusion"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                            type: "button",
                                                            className: `inline-flex items-center px-4 py-2 border-2 border-gray-100 shadow-sm text-sm leading-4 font-medium rounded-md hover:border-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent ${studyQuestionExclusion === true ? "text-red-700 bg-red-400 outline-none ring-2 ring-offset-2 ring-red-500 dark:bg-red-400" : ""}}`,
                                                            onClick: ()=>setStudyQuestionExclusion(true),
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "mr-1",
                                                                children: "Exclusion"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "pt-8",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: handleClickAddToStudy,
                                                                    className: "inline-flex justify-center rounded-md border border-transparent bg-topo-green py-2 px-4 mr-2 text-sm font-medium text-white shadow-sm hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2",
                                                                    children: "Add to Study"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                    type: "button",
                                                                    className: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-red-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                                    onClick: ()=>setSelectedQuestion(null),
                                                                    children: "Back"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "space-y-4 px-4 sm:px-6 sm:py-5",
                                                        children: [
                                                            !selectedQuestion && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                children: [
                                                                    "Search for an existing question:",
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                        type: "text",
                                                                        onChange: handleChangeFilterText
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>handleClickNewQuestion(),
                                                                        className: "inline-flex justify-center rounded-md border border-transparent bg-topo-green py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2",
                                                                        children: "New Question"
                                                                    })
                                                                ]
                                                            }),
                                                            addingQuestion && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                className: "sm:divide-y sm:divide-gray-200 sm:py-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                        className: "space-y-4 sm:py-5",
                                                                        children: [
                                                                            "Add a new question:",
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("textarea", {
                                                                                value: fullText,
                                                                                onChange: (e)=>setFullText(e.target.value),
                                                                                className: "mb-4 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                type: "text"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: handleSaveQuestion,
                                                                        className: "inline-flex justify-center rounded-md border border-transparent bg-topo-green py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2",
                                                                        children: "Save"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                        type: "button",
                                                                        className: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-red-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                                        onClick: ()=>setAddingQuestion(false),
                                                                        children: "Cancel"
                                                                    })
                                                                ]
                                                            }),
                                                            filteredQuestions?.map((result)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "border rounded border-gray-100 p-4 hover:bg-gray-200 cursor-pointer",
                                                                    onClick: ()=>handleQuestionClick(result.item),
                                                                    onKeyUp: ()=>handleQuestionClick(result.item),
                                                                    children: result?.item?.full_text
                                                                }, result?.item?.id))
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "flex justify-start space-x-3"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}


function $a69626a436edf3e6$export$fd542a1bd7c591c3() {
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { data: study } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("admin/studies", studyId);
    const { data: study_questions, mutate: mutateStudyQuestions } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/study_questions", `study_id=${studyId}`);
    const { data: questions, mutate: mutateQuestions } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/questions");
    const [questionsSlideoverOpen, setQuestionsSlideoverOpen] = (0, $f2Y41.useState)(false);
    const maxOrder = ()=>{
        if (study_questions?.length === 0) return 0;
        const max = study_questions?.slice()?.sort((a, b)=>b.order - a.order)[0];
        return max?.order || 0;
    };
    const addStudyQuestion = async (studyQuestion)=>{
        // console.log('addQuestion')
        // console.dir({study_id: study.id, question_id: id, order: maxOrder() + 1})
        const studyQuestionData = {
            study_id: study.id,
            question_id: studyQuestion.question_id,
            order: studyQuestion?.order || maxOrder() + 1,
            exclusion_criteria: studyQuestion?.exclusion_criteria || false
        };
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("study_questions", studyQuestionData, getAccessTokenSilently);
        (0, (/*@__PURE__*/$parcel$interopDefault($3d12054b9ed86c19$exports))).success("Question Added to Study");
        mutateStudyQuestions();
    };
    const addQuestion = async (fullText)=>{
        return await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/questions", {
            full_text: fullText
        }, getAccessTokenSilently);
    };
    const deleteStudyQuestion = async (id)=>{
        await (0, $b2d06586a86d14b7$export$60acb8fd13afd60d)("admin/study_questions", id, getAccessTokenSilently);
        mutateStudyQuestions();
    };
    const updateStudyQuestion = async (id, data)=>{
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/study_questions", id, data, getAccessTokenSilently);
        mutateStudyQuestions();
    };
    const decrementQuestionOrder = async (currentId)=>{
        const order = study_questions.find((studyQuestion)=>studyQuestion.id === currentId)?.order;
        if (order - 1 === 0) return;
        const previousQuestion = study_questions.find((studyQuestion)=>studyQuestion.order === order - 1);
        if (!previousQuestion.id) return;
        updateStudyQuestion(currentId, {
            order: order - 1
        });
        updateStudyQuestion(previousQuestion.id, {
            order: previousQuestion.order + 1
        });
    };
    const incrementQuestionOrder = async (currentId)=>{
        const order = study_questions.find((studyQuestion)=>studyQuestion.id === currentId)?.order;
        if (order === maxOrder()) return;
        const nextQuestion = study_questions.find((studyQuestion)=>studyQuestion.order === order + 1);
        if (!nextQuestion?.id) return;
        updateStudyQuestion(currentId, {
            order: order + 1
        });
        updateStudyQuestion(nextQuestion?.id, {
            order: nextQuestion?.order - 1
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "StudyBuilder"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1e0a7cacb65353e4$export$bbecd8bea68ec649), {
                study: study
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)($a69626a436edf3e6$var$NewQuestionButton, {
                setQuestionsSlideoverOpen: setQuestionsSlideoverOpen
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "text-sm font-bold m-4",
                children: [
                    "Total Number: ",
                    study_questions?.length
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "text-sm font-bold m-4",
                children: [
                    "Last Updated:",
                    " ",
                    (0, $0dcae3260236e0d2$export$d207855dff529fc9)(study_questions.reduce((max, obj)=>{
                        const currentDate = new Date(`${obj.updated_at}Z`);
                        return currentDate > max ? currentDate : max;
                    }, new Date(0)))
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $cc2b6f5aa5abe6b4$export$926a6fe223a2603b), {
                open: questionsSlideoverOpen,
                setOpen: setQuestionsSlideoverOpen,
                refreshData: ()=>mutateQuestions(),
                questions: questions,
                addStudyQuestion: addStudyQuestion,
                addQuestion: addQuestion
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: study_questions?.map((question)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $0abbdbc72eacd52a$export$5462965298c633aa), {
                            question: question,
                            deleteStudyQuestion: deleteStudyQuestion,
                            updateStudyQuestion: updateStudyQuestion,
                            decrementQuestionOrder: decrementQuestionOrder,
                            incrementQuestionOrder: incrementQuestionOrder,
                            maxOrder: maxOrder
                        }, question.id))
                })
            })
        ]
    });
}
const $a69626a436edf3e6$var$NewQuestionButton = (props)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "p-4 inline-flex",
        onClick: ()=>props.setQuestionsSlideoverOpen(true),
        onKeyUp: ()=>props.setQuestionsSlideoverOpen(true),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
            className: "bg-topo-blue hover:bg-blue-800 focus:ring-blue-500",
            icon: "PlusCircleIcon",
            text: "Add Question"
        })
    });



var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");



// import "./styles.scss"

var $ge3KO = parcelRequire("ge3KO");




function $b83c65d644b1672e$export$2e2bcd8739ae039({ defaultValue: defaultValue }) {
    const extensions = [
        (0, $ec108066d24b69c9$export$1df879243bf2e42d).configure({
            types: [
                (0, $31bd2e4c89b87b19$export$a7b06bfba60a8a78).name
            ]
        }),
        (0, $ea4ee2370b5b830c$export$626064c5f1b71dc).configure({
            bulletList: {
                keepMarks: true
            },
            orderedList: {
                keepMarks: true
            }
        })
    ];
    const editor = (0, $3230bda81207e15e$export$43711a1418203bbc)({
        extensions: extensions,
        content: defaultValue || "",
        editorProps: {
            attributes: {
                class: "prose max-w-none [&_ol]:list-decimal [&_ul]:list-disc text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }
        },
        editable: false
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3230bda81207e15e$export$a92c4e92ed722350), {
            editor: editor
        })
    });
}





var $ge3KO = parcelRequire("ge3KO");





function $79ae37b669c2f3fe$export$9bcb229a699e7da1() {
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: study_questions, isLoading: isLoading, mutate: mutateStudyQuestions } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/study_questions", `study_id=${studyId}`);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "pr-4",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "text-lg p-2 mb-2 font-bold text-gray-900 dark:text-white",
                            children: "Criteria"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                            to: "builder",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                    icon: "PlusCircleIcon",
                                    text: "Manage Criteria"
                                }),
                                " "
                            ]
                        })
                    ]
                })
            }),
            isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsxs)("table", {
                className: "min-w-full divide-y divide-gray-200 dark:divide-gray-600",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("thead", {
                        className: "bg-gray-50 dark:bg-gray-700",
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                    scope: "col",
                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                    children: "Type"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                    scope: "col",
                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                    children: "Protocol Reference"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                    scope: "col",
                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                    children: "Question"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                    scope: "col",
                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                    children: "Order"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                    scope: "col",
                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-300",
                                    children: "Last Updated"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("tbody", {
                        className: "bg-white dark:bg-gray-800",
                        children: study_questions.map((study_question, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                className: index % 2 !== 0 ? "bg-gray-50" : "",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                        className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                            className: "text-sm font-medium ",
                                            children: [
                                                study_question?.exclusion_criteria === false && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "px-2 py-1 text-xs rounded-2xl bg-green-500 text-gray-50",
                                                    children: "Inclusion"
                                                }),
                                                (study_question?.exclusion_criteria === true || study_question?.exclusion_criteria === null) && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "px-2 py-1 text-xs rounded-2xl bg-red-500 text-gray-50",
                                                    children: "Exclusion"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                        children: study_question.protocol_reference
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                        className: "p-4 text-sm whitespace-wrap dark:text-gray-300",
                                        children: study_question.question?.full_text
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                        children: study_question.order
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-300",
                                        children: (0, $0dcae3260236e0d2$export$d207855dff529fc9)(study_question.updated_at)
                                    })
                                ]
                            }, study_question.id))
                    })
                ]
            })
        ]
    });
}




var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");








function $eaefcf3df157487e$export$2616650b2c76fcca(props) {
    const practiceStudy = props.practiceStudy;
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: practice } } = (0, $d306139d1442c366$export$657be94be86c05b6)("admin/practices", practiceStudy.practice_id);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: practiceStudy
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    const onSubmit = (data)=>{
        data.study_id = studyId;
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/practice_studies", data.id, data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Practice Study",
        key: "practice_study"
    };
    const fields = [
        {
            label: "Practice",
            key: "practice_id",
            required: true,
            options: [
                {
                    value: practice.id,
                    label: `${practice.name} (${practice.abbreviation})`
                }
            ],
            disabled: true
        },
        {
            label: "Topo Study Id",
            key: "topography_study_identifier",
            tooltip: "This id matches the Salesforce Opportunity Id and the CRIO Internal Study Number."
        },
        {
            label: "Status",
            key: "status",
            required: true,
            options: [
                {
                    label: "Contracting",
                    key: "Contracting"
                },
                {
                    label: "Prescreening",
                    key: "Prescreening"
                },
                {
                    label: "Screening",
                    key: "Screening"
                },
                {
                    label: "Enrolling",
                    key: "Enrolling"
                },
                {
                    label: "Maintenance",
                    key: "Maintenance"
                },
                {
                    label: "Closed",
                    key: "Closed"
                }
            ]
        },
        {
            label: "Esource Study Id",
            key: "xref_study_id",
            display: "true"
        },
        {
            label: "Screening Visit Id",
            key: "xref_study_visit_id",
            display: "true"
        },
        // TODO: add datepicker
        // { label: "Enrollment Start Date", key: "enrollment_start_dt" },
        // { label: "Enrollment End Date", key: "enrollment_end_dt" },
        {
            label: "Priority",
            key: "priority",
            options: [
                {
                    label: "Low",
                    key: "low"
                },
                {
                    label: "Medium",
                    key: "medium"
                },
                {
                    label: "High",
                    key: "high"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "edit-practice-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.value,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>closeModal(),
                onKeyUp: ()=>closeModal(),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");








function $106142dbe1a64e8e$export$3593aebca40dbb76(props) {
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: practiceStudies } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practice_studies", `study_id=${studyId}`);
    const { data: { data: practices } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practices");
    const practiceOptions = practices.map((practice)=>{
        if (!practiceStudies.some((practiceStudy)=>practiceStudy.practice_id === practice.id)) return {
            key: practice.id,
            label: `${practice.name} (${practice.abbreviation})`
        };
        return {
            key: practice.id,
            label: `${practice.name} (${practice.abbreviation})`,
            disabled: true
        };
    }).filter((practice)=>practice !== undefined);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            study_id: studyId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/practice_studies", data, getAccessTokenSilently).then((response)=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const entity = {
        label: "Practice Study",
        key: "practice_study"
    };
    const fields = [
        {
            label: "Practice",
            key: "practice_id",
            required: true,
            options: practiceOptions
        },
        {
            label: "Topo Study Id",
            key: "topography_study_identifier",
            tooltip: "This id matches the Salesforce Opportunity Id and the CRIO Internal Study Number."
        },
        {
            label: "Status",
            key: "status",
            required: true,
            options: [
                {
                    label: "Contracting",
                    key: "Contracting"
                },
                {
                    label: "Prescreening",
                    key: "Prescreening"
                },
                {
                    label: "Screening",
                    key: "Screening"
                },
                {
                    label: "Enrolling",
                    key: "Enrolling"
                },
                {
                    label: "Maintenance",
                    key: "Maintenance"
                },
                {
                    label: "Closed",
                    key: "Closed"
                }
            ]
        },
        {
            label: "Esource Study Id",
            key: "xref_study_id",
            display: "true"
        },
        {
            label: "Screening Visit Id",
            key: "xref_study_visit_id",
            display: "true"
        },
        // TODO: add datepicker
        // { label: "Enrollment Start Date", key: "enrollment_start_dt" },
        // { label: "Enrollment End Date", key: "enrollment_end_dt" },
        {
            label: "Priority",
            key: "priority",
            options: [
                {
                    label: "Low",
                    key: "low"
                },
                {
                    label: "Medium",
                    key: "medium"
                },
                {
                    label: "High",
                    key: "high"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "new-practice-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "New ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("title", {
                                                        children: [
                                                            "new ",
                                                            entity.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.key,
                                                                        disabled: option?.disabled || false,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>closeModal(),
                onKeyUp: ()=>closeModal(),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $005e455b5d97c0ab$export$d40595ecb2c8894c(props) {
    const [practiceStudy, setPracticeStudy] = (0, $f2Y41.useState)();
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const [newPracticeStudyModalOpen, setNewPracticeStudyModalOpen] = (0, $f2Y41.useState)(false);
    const [editPracticeStudyModalOpen, setEditPracticeStudyModalOpen] = (0, $f2Y41.useState)(false);
    const { data: { data: practice_studies }, isFetching: isFetching, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practice_studies", `study_id=${studyId}`);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const mutatePracticeStudies = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "admin/practice_studies",
                `study_id=${studyId}`
            ]
        });
    };
    const rows = practice_studies;
    const columns = [
        {
            field: "practice_name",
            headerName: "Practice",
            width: 150,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.practice?.name
                })
        },
        {
            field: "study_name",
            headerName: "Study",
            width: 150,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.study?.name
                })
        },
        {
            field: "study_abbreviation",
            headerName: "Study Abbr.",
            width: 120,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.study?.abbreviation
                })
        },
        {
            field: "topography_study_identifier",
            headerName: "Topo Study Id",
            width: 150,
            display: "flex"
        },
        {
            field: "task_board_xref_id",
            headerName: "Monday Board ID",
            width: 150,
            display: "flex"
        },
        {
            field: "xref_study_id",
            headerName: "Esource Study Id",
            width: 150,
            display: "flex"
        },
        {
            field: "xref_study_visit_id",
            headerName: "Screening Visit Id",
            width: 150,
            display: "flex"
        },
        {
            field: "status",
            headerName: "Status",
            width: 100,
            display: "flex"
        },
        {
            field: "enrollment_start_dt",
            headerName: "Enroll Start",
            width: 120,
            display: "flex"
        },
        {
            field: "enrollment_end_dt",
            headerName: "Enroll End",
            width: 120,
            display: "flex"
        },
        {
            field: "priority",
            headerName: "Priority",
            width: 100,
            display: "flex"
        },
        {
            field: "enrollment_target",
            headerName: "Enroll Target",
            width: 120,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params)
        }
    ];
    const renderCellActions = (props)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>{
                setPracticeStudy(props.row);
                setEditPracticeStudyModalOpen(true);
            },
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-2 pr-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex justify-between items-center pl-2",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                    className: "font-bold text-lg",
                                    children: "Practice Studies"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    onClick: ()=>setNewPracticeStudyModalOpen(true),
                                    onKeyUp: ()=>setNewPracticeStudyModalOpen(true),
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                        icon: "PlusCircleIcon",
                                        text: "Add Practice Study",
                                        className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                    })
                                })
                            ]
                        })
                    }),
                    isFetching ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2 flex min-h-[200px]",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex-grow",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                                rows: rows,
                                columns: columns,
                                onCellDoubleClick: (params, event)=>{
                                    event.defaultMuiPrevented = true;
                                    setPracticeStudy(params.row);
                                    setEditPracticeStudyModalOpen(true);
                                },
                                slots: {
                                    toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                                },
                                slotProps: {
                                    toolbar: {
                                        showQuickFilter: true
                                    }
                                }
                            })
                        })
                    })
                ]
            }),
            newPracticeStudyModalOpen && studyId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $106142dbe1a64e8e$export$3593aebca40dbb76), {
                setOpen: setNewPracticeStudyModalOpen,
                refreshData: mutatePracticeStudies
            }),
            editPracticeStudyModalOpen && studyId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $eaefcf3df157487e$export$2616650b2c76fcca), {
                practiceStudy: practiceStudy,
                setOpen: setEditPracticeStudyModalOpen,
                refreshData: mutatePracticeStudies
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");





function $d8ad986d3115d18f$export$5134630abfb689e3() {
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const { data: { data: studyVisits }, isFetching: isFetching, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/study_visits", `study_id=${studyId}`);
    const rows = studyVisits;
    const columns = [
        {
            field: "visit_name",
            headerName: "Visit Name",
            width: 200,
            display: "flex"
        },
        {
            field: "xref_study_visit_order",
            headerName: "Order",
            width: 100,
            display: "flex"
        },
        {
            field: "xref_study_visit_number",
            headerName: "Visit #",
            width: 100,
            display: "flex"
        },
        {
            field: "xref_study_visit_type",
            headerName: "Type",
            width: 120,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params, handleShowStudyVisit)
        }
    ];
    const renderCellActions = (props, handleShowStudyVisit)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>handleShowStudyVisit(props.row.id, props.row.task_template_id),
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    const handleShowStudyVisit = (visitId, taskTemplateId)=>{
        navigate(`/admin/studies/${studyId}/visits/${visitId}`);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: isFetching ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "mt-2 flex min-h-[200px] pr-4",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-grow",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                    rows: rows,
                    columns: columns,
                    onCellDoubleClick: (params, event)=>{
                        event.defaultMuiPrevented = true;
                        navigate(`/admin/studies/${studyId}/visits`);
                    },
                    slots: {
                        toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                    },
                    slotProps: {
                        toolbar: {
                            showQuickFilter: true
                        }
                    }
                })
            })
        })
    });
}


function $d64fb4d9ed370ee6$export$79d648b52a36c8b8() {
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const { studyId: studyId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: study }, isFetching: isFetching, isError: isError } = (0, $d306139d1442c366$export$657be94be86c05b6)("admin/studies", studyId);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const mutateStudy = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "admin/studies",
                studyId
            ]
        });
    };
    const { data: sponsor, mutate: mutateSponsor } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("sponsors", study.sponsor_id);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const handleRefresh = ()=>{
        mutateStudy();
        mutateSponsor();
    };
    if (isError) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: '"Failed to load"'
    });
    if (isFetching) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {});
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex items-center pr-4 pl-4",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                                className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                                children: `${study.name} (${study.abbreviation})`
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                onClick: ()=>setEditModalOpen(true),
                                onKeyUp: ()=>setEditModalOpen(true),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                    icon: "PencilIcon",
                                    text: "Edit Details",
                                    className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "pr-4 mb-2",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $12bac3892b1cf3f1$export$60332b2344f7fe41), {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                className: "font-bold text-lg mb-4",
                                children: "Details"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.name || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Nickname"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.nickname || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Abbreviation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.abbreviation || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.description || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Protocol Version"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.protocol_version || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Indications"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.indications?.map((indication)=>indication.name).join(", ") || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Call Script"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.call_script || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Objectives"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.objectives || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Study Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: study.study_type || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex items-center mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                        color: "gray",
                                                        size: "sm",
                                                        children: "Sponsor"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "ml-2",
                                                        children: sponsor.name || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-gray-400 italic",
                                                            children: "Not provided"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "grid grid-cols-6 gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-1",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                color: "gray",
                                                size: "sm",
                                                children: "Trial Summary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "w-full col-span-5",
                                            onDoubleClick: ()=>setEditModalOpen(true),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b83c65d644b1672e$export$2e2bcd8739ae039), {
                                                defaultValue: study.provider_summary
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-1",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                color: "gray",
                                                size: "sm",
                                                children: "Key Inclusion/Exclusion Criteria"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-5",
                                            onDoubleClick: ()=>setEditModalOpen(true),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b83c65d644b1672e$export$2e2bcd8739ae039), {
                                                defaultValue: study.ie_criteria
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-1",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                color: "gray",
                                                size: "sm",
                                                children: "Patient Pitch"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "w-full col-span-5",
                                            onDoubleClick: ()=>setEditModalOpen(true),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b83c65d644b1672e$export$2e2bcd8739ae039), {
                                                defaultValue: study.how_you_can_help
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-1",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                color: "gray",
                                                size: "sm",
                                                children: "Compound/Asset"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-5",
                                            onDoubleClick: ()=>setEditModalOpen(true),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "",
                                                children: study.compound || /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                    className: "text-gray-400 italic",
                                                    children: "Not provided"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-1",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                color: "gray",
                                                size: "sm",
                                                children: "Study Specifics"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "w-full col-span-5",
                                            onDoubleClick: ()=>setEditModalOpen(true),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b83c65d644b1672e$export$2e2bcd8739ae039), {
                                                defaultValue: study.key_stats
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-1 hidden",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $197441659db424a5$export$37acb3580601e69a), {
                                                color: "gray",
                                                size: "sm",
                                                children: "Criteria Summary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "w-full col-span-5 hidden",
                                            onDoubleClick: ()=>setEditModalOpen(true),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b83c65d644b1672e$export$2e2bcd8739ae039), {
                                                defaultValue: study.criteria_summary
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex justify-between items-center pr-4",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                className: "text-lg  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                                children: "Visits"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                to: "visits",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                    icon: "PlusCircleIcon",
                                    text: "Manage Visits"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d8ad986d3115d18f$export$5134630abfb689e3), {}),
                editModalOpen && studyId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8e50c3caa513781d$export$75f991e6d712cb3f), {
                    studyId: studyId,
                    setOpen: setEditModalOpen,
                    refreshData: handleRefresh
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $79ae37b669c2f3fe$export$9bcb229a699e7da1), {})
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $005e455b5d97c0ab$export$d40595ecb2c8894c), {})
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");



var $ge3KO = parcelRequire("ge3KO");
function $27453d49d2dd880c$export$caec2af78bcc877f(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: `flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 ${props.className}`,
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                className: "flex-shrink-0 inline w-4 h-4 me-3",
                "aria-hidden": "true",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                viewBox: "0 0 20 20",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                    d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                className: "sr-only",
                children: "Info"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                        className: "font-medium",
                        children: [
                            props.header,
                            ":"
                        ]
                    }),
                    " ",
                    props.message
                ]
            })
        ]
    });
}




var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");

function $34ede4a4a21f9915$export$25c8cd19dc067a8d(props) {
    const { timeout: timeout = 1000 } = props;
    const { isShowing: isShowingProp = true } = props;
    const [isShowing, setIsShowing] = (0, $f2Y41.useState)(isShowingProp);
    (0, $f2Y41.useEffect)(()=>{
        const timeoutFn = setTimeout(()=>{
            setIsShowing(false);
        }, timeout);
        return ()=>{
            clearTimeout(timeoutFn);
        };
    }, [
        timeout
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4), {
        as: (0, $f2Y41.Fragment),
        show: isShowing,
        unmount: false,
        enter: "transition-opacity duration-[100ms]",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-[1000ms]",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "ml-2 text-2xl",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "CheckCircleIcon",
                extraClasses: "text-green-400"
            })
        })
    });
}






function $a352921f1a08b700$export$4734c56f51376fb5() {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [editingStudyVisitId, setEditingStudyVisitId] = (0, $f2Y41.useState)();
    const [errorMessage, setErrorMessage] = (0, $f2Y41.useState)();
    const [saved, setSaved] = (0, $f2Y41.useState)(false);
    const [isSaving, setIsSaving] = (0, $f2Y41.useState)(false);
    const { studyId: studyId, visitId: visitId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: { data: visitData }, isFetching: visitIsFetching, isError: visitIsError } = (0, $d306139d1442c366$export$fe1f5548f487c066)(`admin/study_visits/${visitId}`);
    const { data: { data: userData } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/users");
    const { data: { data: tasksData }, isLoading: isLoading, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("tasks", `task_template_id=${visitData?.task_template_id}`);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const mutateStudyVisits = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "admin/study_visits",
                `study_id=${visitId}`
            ]
        });
    };
    const rows = tasksData;
    const columns = [
        {
            field: "description",
            headerName: "Description",
            width: 200,
            display: "flex"
        },
        {
            field: "task_due_date_offset_from_visit",
            headerName: "Due Offset",
            width: 120,
            display: "flex"
        },
        {
            field: "index",
            headerName: "Order",
            width: 80,
            display: "flex"
        },
        {
            field: "team_assignment",
            headerName: "Team",
            width: 120,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    const renderUpdatedBy = (props)=>{
        let updatedBy = userData.find((user)=>user.id === props.row.task_template.updated_by_user_id);
        if (!updatedBy) updatedBy = userData.find((user)=>user.id === props.row.task_template.created_by_user_id);
        return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
            children: updatedBy.name
        });
    };
    const taskColumns = [
        {
            field: "name",
            headerName: "Task Name",
            width: 250,
            display: "flex"
        },
        ...columns,
        {
            field: "updated_by",
            headerName: "Updated By",
            width: 150,
            display: "flex",
            flex: 1,
            renderCell: (params)=>renderUpdatedBy(params)
        }
    ];
    const subtaskColumns = [
        {
            field: "name",
            headerName: "Subtask Name",
            width: 250,
            display: "flex"
        },
        ...columns
    ];
    const handleUpload = async (e)=>{
        setIsSaving(true);
        const file = e.target.files[0];
        const formData = new FormData();
        const accessToken = await getAccessTokenSilently();
        formData.append("csv_file", file);
        // post task_template_import
        const createResponse = await (0, $b2d06586a86d14b7$export$99915ff5fc5148d2).post((0, $b2d06586a86d14b7$export$7138c24907de3954)("admin/task_template_import"), formData, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-type": "multipart/form-data"
            }
        }).catch((error)=>{
            setIsSaving(false);
            if (error.response && error.response.status === 422) setErrorMessage(error.response.data.message);
            else throw error // Re-throw other errors to maintain the flow
            ;
        });
        if (createResponse) {
            // get task_template_id from response
            const taskTemplateId = createResponse?.data?.data?.id;
            // patch study_visit w/ task_template_id
            const updateResponse = await (0, $b2d06586a86d14b7$export$74524c73191a667c)("admin/study_visits", visitId, {
                task_template_id: taskTemplateId
            }, getAccessTokenSilently);
            if (updateResponse.status === 200) {
                setSaved(true);
                setEditingStudyVisitId(null);
            }
        }
        setIsSaving(false);
        mutateStudyVisits();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: `${visitData?.visit_name?.charAt(0)?.toUpperCase() + visitData?.visit_name?.slice(1)} Visit Tasks`,
                children: [
                    saved && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34ede4a4a21f9915$export$25c8cd19dc067a8d), {
                        isShowing: saved
                    }),
                    isSaving && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex ml-4 items-center text-black dark:text-gray-300 text-md",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}),
                            " Saving..."
                        ]
                    }),
                    errorMessage && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $27453d49d2dd880c$export$caec2af78bcc877f), {
                        header: "Upload Error",
                        message: errorMessage
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex-1 items-start m-1",
                        children: [
                            editingStudyVisitId !== visitData.id && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                onClick: ()=>setEditingStudyVisitId(visitData.id),
                                onKeyUp: ()=>setEditingStudyVisitId(visitData.id),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                    icon: "PlusCircleIcon",
                                    text: `${visitData.task_template_id ? "Update" : "Add"} Tasks`
                                })
                            }),
                            editingStudyVisitId === visitData.id && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                onChange: handleUpload,
                                className: "block text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400",
                                id: "default_size",
                                type: "file"
                            })
                        ]
                    })
                ]
            }),
            isError ? "Failed to load" : "",
            visitIsFetching ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex min-h-[200px]",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: taskColumns,
                        getDetailPanelContent: ({ row: row })=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                                    rows: row.subtasks,
                                    columns: subtaskColumns
                                })
                            }),
                        slots: {
                            toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                        },
                        slotProps: {
                            toolbar: {
                                showQuickFilter: true
                            }
                        }
                    })
                })
            })
        ]
    });
}




var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");




function $afb2bc80d36fb3b8$export$b672e2179622809d() {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [showSave, setShowSave] = (0, $f2Y41.useState)(false);
    const [error, setError] = (0, $f2Y41.useState)("");
    const handleSyncConfiguration = async ()=>{
        try {
            const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("admin/pipelines", {
                pipeline_name: "sync_practice_waypoints_multitenant_tables"
            }, getAccessTokenSilently);
            if (response.status === 200) setShowSave(true);
        } catch (error) {
            setError(error.message);
        }
    };
    const saveButton = ()=>{};
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex justify-between items-center pr-4",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                    className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                    children: "Sync Configuration"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "max-w-50 m-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mb-4 mt-4 max-w-prose",
                        children: 'The Network Configuration must be synced to all of the practices. Clicking "Sync Configuration" will initiate a background task that takes approximately 15 minutes to sync the configuration.'
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex items-center",
                        onClick: handleSyncConfiguration,
                        onKeyUp: handleSyncConfiguration,
                        children: [
                            showSave ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                content: "You have already synced the content!",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                    icon: "ShareIcon",
                                    text: "Sync Configuration",
                                    className: "opacity-50 cursor-not-allowed inline-flex items-center justify-center h-10 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                })
                            }) : /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                        icon: "ShareIcon",
                                        text: "Sync Configuration",
                                        className: "inline-flex items-center justify-center h-10 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                    }),
                                    error && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $27453d49d2dd880c$export$caec2af78bcc877f), {
                                        className: "ml-4 inline-flex",
                                        header: "Upload Error",
                                        message: error
                                    })
                                ]
                            }),
                            showSave && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34ede4a4a21f9915$export$25c8cd19dc067a8d), {
                                className: "ml-4 inline-flex"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");






var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");




function $a0209988b01849f0$export$d30ff6429dddb17(props) {
    const entity = {
        label: "User",
        key: "user"
    };
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset, getValues: getValues } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: data } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)(`${entity.key}s`, props.id);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = (0, $f2Y41.useState)(false);
    const [userConfirmation, setUserConfirmation] = (0, $f2Y41.useState)("");
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    (0, $f2Y41.useEffect)(()=>{
        reset(data);
    }, [
        data
    ]);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)(`admin/${entity.key}s`, props.id, data, getAccessTokenSilently).then(()=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        });
    };
    const confirmDelete = ()=>{
        setShowDeleteConfirmation(true);
    };
    const handleDelete = ()=>{
        const name = getValues("name");
        if (userConfirmation === name) (0, $b2d06586a86d14b7$export$74524c73191a667c)(`admin/${entity.key}s`, props.id, {
            deleted_at: new Date().toISOString().slice(0, -1)
        }, getAccessTokenSilently).then(()=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Prefix",
            key: "prefix",
            placeholder: "Optional (e.g. Dr.)"
        },
        {
            label: "Email",
            key: "email"
        },
        {
            label: "Role",
            key: "role",
            options: [
                {
                    label: "User",
                    value: "User"
                },
                {
                    label: "User & QA",
                    value: "QaUser"
                },
                {
                    label: "Manager",
                    value: "Manager"
                },
                {
                    label: "Admin",
                    value: "Admin"
                },
                {
                    label: "Provider",
                    value: "Provider"
                }
            ]
        },
        {
            label: "Monday.com User Id",
            key: "task_user_xref_id"
        },
        {
            label: "Ring Central Extension",
            key: "phone_extension_xref_id"
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Edit button"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "inline-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                    htmlFor: field.key,
                                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                                    children: field.label
                                                                }),
                                                                field.tooltip && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                                    content: field.tooltip,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                        icon: "QuestionMarkCircleIcon",
                                                                        className: "h-4 ml-2 rounded-md"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.value,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex justify-between pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        className: "text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800",
                                                        type: "button",
                                                        onClick: ()=>confirmDelete(),
                                                        children: "Delete"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                        type: "submit",
                                                        children: "Save"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: `${!showDeleteConfirmation ? "hidden" : undefined} flex justify-between pt-4 border-t border-gray-200 rounded-b dark:border-gray-700`,
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                    className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                    children: "Type the user's name to confirm delete:"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        type: "text",
                                                        className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        onChange: (e)=>setUserConfirmation(e.target.value),
                                                        value: userConfirmation
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        className: "text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800",
                                                        type: "button",
                                                        onClick: handleDelete,
                                                        children: "Confirm Delete"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");




function $9cf48a94c40dccd6$export$4d9c14791eeac59e(props) {
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const entity = {
        label: "User",
        key: "user"
    };
    const onSubmit = async (data)=>{
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)(`admin/${entity.key}s`, data, getAccessTokenSilently);
        props.setOpen(false);
        props.refreshData();
        reset();
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], ()=>props.setOpen(false));
    const fields = [
        {
            label: "Name",
            key: "name",
            required: true
        },
        {
            label: "Prefix",
            key: "prefix",
            placeholder: "Optional (e.g. Dr.)"
        },
        {
            label: "Email",
            key: "email",
            required: true
        },
        {
            label: "Role",
            key: "role",
            options: [
                {
                    label: "User",
                    value: "User"
                },
                {
                    label: "User & QA",
                    value: "QaUser"
                },
                {
                    label: "Manager",
                    value: "Manager"
                },
                {
                    label: "Admin",
                    value: "Admin"
                },
                {
                    label: "Provider",
                    value: "Provider"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Add ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Add user"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            placeholder: field?.placeholder,
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: field?.required || false
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.value,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");




function $ca23cae3dcd65221$export$ca1d24b9f1b8d9ca(props) {
    const [practiceUser, setPracticeUser] = (0, $f2Y41.useState)();
    const userId = props.userId;
    const [newUserModalOpen, setNewUserModalOpen] = (0, $f2Y41.useState)(false);
    const [editUserModalOpen, setEditUserModalOpen] = (0, $f2Y41.useState)(false);
    const { data: { data: practice_users }, isFetching: isFetching, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practice_users", `user_id=${userId}`);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const mutatePracticeUsers = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "admin/practice_users",
                `user_id=${userId}`
            ]
        });
    };
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const handleShowUser = (userId)=>navigate(`/admin/users/${userId}`);
    const rows = practice_users;
    const columns = [
        {
            field: "practice_name",
            headerName: "Practice",
            width: 150,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.practice?.name
                })
        },
        {
            field: "practice_abbreviation",
            headerName: "Abbr.",
            width: 100,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.practice?.abbreviation
                })
        },
        {
            field: "name",
            headerName: "Name",
            width: 150,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.user?.name
                })
        },
        {
            field: "task_user_xref_id",
            headerName: "Monday ID",
            width: 150,
            display: "flex",
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.user?.task_user_xref_id
                })
        },
        {
            field: "phone_extension_xref_id",
            headerName: "Extension",
            width: 120,
            display: "flex"
        },
        {
            field: "role",
            headerName: "Role",
            width: 150,
            display: "flex"
        },
        {
            field: "email",
            headerName: "Email",
            width: 180,
            display: "flex"
        },
        {
            field: "phone",
            headerName: "Phone",
            width: 120,
            display: "flex"
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            display: "flex",
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "mt-2",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex justify-between mb-2",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                        className: "font-bold text-lg",
                        children: "Practice Users"
                    })
                }),
                isFetching ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "mt-2 flex min-h-[200px]",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                            rows: rows,
                            columns: columns,
                            onCellDoubleClick: (params, event)=>{
                                event.defaultMuiPrevented = true;
                                handleShowUser(userId);
                            },
                            slots: {
                                toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                            },
                            slotProps: {
                                toolbar: {
                                    showQuickFilter: true
                                }
                            }
                        })
                    })
                })
            ]
        })
    });
}


function $62968d35e83340e0$export$a69f017b19597ff5() {
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/users");
    const [newModalOpen, setNewModalOpen] = (0, $f2Y41.useState)(false);
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [userId, setUserId] = (0, $f2Y41.useState)("");
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const handleShowUser = (userId)=>navigate(`/admin/users/${userId}`);
    const rows = data;
    const columns = [
        {
            field: "prefix",
            headerName: "Prefix",
            width: 50
        },
        {
            field: "name",
            headerName: "Name",
            width: 150
        },
        {
            field: "email",
            headerName: "Email",
            width: 150
        },
        // { field: 'slack_username', headerName: 'Slack', width: 150 },
        {
            field: "role",
            headerName: "Role",
            width: 150
        },
        {
            field: "task_user_xref_id",
            headerName: "Monday.com User Id",
            width: 200
        },
        {
            field: "phone_extension_xref_id",
            headerName: "Ring Central Extension",
            width: 200
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 150,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 150,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "deleted_at",
            headerName: "Deleted At",
            width: 150
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params, handleShowUser)
        }
    ];
    const renderCellActions = (props, handleShowUser)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>handleShowUser(props.row.id),
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "pl-4 pr-4",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                        className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                        children: "Users"
                    }),
                    isLoading ? "Loading.." : "",
                    isError ? "Failed to load" : "",
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        onClick: ()=>setNewModalOpen(true),
                        onKeyUp: ()=>setNewModalOpen(true),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                            icon: "PlusCircleIcon",
                            text: "Add User",
                            className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns,
                        getDetailPanelContent: ({ row: row })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ca23cae3dcd65221$export$ca1d24b9f1b8d9ca), {
                                userId: row.id
                            }),
                        onCellDoubleClick: (params, event)=>{
                            event.defaultMuiPrevented = true;
                            handleShowUser(params.row?.id);
                        },
                        slots: {
                            toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                        },
                        slotProps: {
                            toolbar: {
                                showQuickFilter: true
                            }
                        }
                    })
                })
            }),
            newModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9cf48a94c40dccd6$export$4d9c14791eeac59e), {
                setOpen: setNewModalOpen,
                refreshData: mutate
            }),
            editModalOpen && userId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a0209988b01849f0$export$d30ff6429dddb17), {
                id: userId,
                setOpen: setEditModalOpen,
                refreshData: mutate
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




function $7de5785398a4108a$export$20ede1d6f9e3058e(props) {
    const entity = {
        label: "Team",
        key: props.entity_key
    };
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: data } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)(`admin/${entity.key}s`, props.id);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    (0, $f2Y41.useEffect)(()=>{
        reset(data);
    }, [
        data
    ]);
    const onSubmit = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)(`admin/${entity.key}s`, props.id, data, getAccessTokenSilently).then(()=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const fields = [
        {
            label: "Practice",
            key: "practice_id",
            options: [
                {
                    key: data.practice?.id,
                    label: `${data.practice?.name} (${data.practice?.abbreviation})`
                }
            ],
            disabled: true
        },
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Description",
            key: "description"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        },
        {
            label: "Xref Id",
            key: "xref_id"
        },
        {
            label: "Team Type",
            key: "team_type",
            options: props.entity_key === "practice_team_xref" ? [
                {
                    label: "Clinical",
                    key: "clinical"
                },
                {
                    label: "Managers",
                    key: "managers"
                },
                {
                    label: "Site",
                    key: "site"
                },
                {
                    label: "Unblinded",
                    key: "unblinded"
                }
            ] : [
                {
                    label: "MDC",
                    key: "mdc"
                },
                {
                    label: "Regulatory",
                    key: "regulatory"
                }
            ]
        },
        {
            label: "Vendor Code",
            key: "vendor_code",
            options: [
                {
                    label: "Slack",
                    key: "slack"
                },
                {
                    label: "Monday.com",
                    key: "monday_dot_com"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-team-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Edit button"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            disabled: field.disabled,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option?.key,
                                                                        children: option?.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "flex justify-between pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                    className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                    type: "submit",
                                                    children: "Save"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





const $d059cfd252a24d61$export$1d1ff8a49462d12b = [
    "mdc",
    "regulatory"
];
const $d059cfd252a24d61$export$17e5ae7ed4f8250 = [
    "managers",
    "clinical",
    "site",
    "unblinded"
];


function $766d4a43c979d619$export$142c37f1e4234f09(props) {
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const entity = {
        label: "Team",
        key: "team_xref"
    };
    const onSubmit = async (data)=>{
        if ((0, $d059cfd252a24d61$export$17e5ae7ed4f8250).includes(data.team_type)) entity.key = "practice_team_xref";
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)(`admin/${entity.key}s`, data, getAccessTokenSilently);
        props.setOpen(false);
        props.refreshData();
        reset();
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], ()=>props.setOpen(false));
    const { data: { data: practices } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("admin/practices");
    const practiceOptions = practices.map((practice)=>({
            label: `${practice.name} (${practice.abbreviation})`,
            value: practice.id
        }));
    const fields = [
        {
            label: "Practice",
            key: "practice_id",
            options: practiceOptions
        },
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Description",
            key: "description"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        },
        {
            label: "Xref Id",
            key: "xref_id"
        },
        {
            label: "Team Type",
            key: "team_type",
            options: [
                {
                    label: "Clinical",
                    value: "clinical"
                },
                {
                    label: "Managers",
                    value: "managers"
                },
                {
                    label: "Site",
                    value: "site"
                },
                {
                    label: "Unblinded",
                    value: "unblinded"
                }
            ]
        },
        {
            label: "Vendor Code",
            key: "vendor_code",
            options: [
                {
                    label: "Slack",
                    value: "slack"
                },
                {
                    label: "Monday.com",
                    value: "monday_dot_com"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-team-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Add ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Add team"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: field?.required || false
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.value,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $99c0a9d90a452894$export$23ad457ba1c81ef4() {
    const team_xrefs = {
        practiceTeamXrefs: (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/practice_team_xrefs")
    };
    const [newModalOpen, setNewModalOpen] = (0, $f2Y41.useState)(false);
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [entityId, setEntityId] = (0, $f2Y41.useState)("");
    const [entityType, setEntityType] = (0, $f2Y41.useState)("");
    const rows = [
        ...team_xrefs.practiceTeamXrefs.data
    ];
    const columns = [
        {
            field: "practice",
            headerName: "Practice",
            width: 150,
            renderCell: (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                    children: params.row.practice?.name
                })
        },
        {
            field: "name",
            headerName: "Name",
            width: 150
        },
        {
            field: "description",
            headerName: "Description",
            width: 200
        },
        {
            field: "abbreviation",
            headerName: "Abbr.",
            width: 100
        },
        {
            field: "xref_id",
            headerName: "Xref ID",
            width: 120
        },
        {
            field: "team_type",
            headerName: "Team Type",
            width: 120
        },
        {
            field: "vendor_code",
            headerName: "Vendor",
            width: 120
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                        className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                        children: "Practice TeamXrefs"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        onClick: ()=>setNewModalOpen(true),
                        onKeyUp: ()=>setNewModalOpen(true),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                            icon: "PlusCircleIcon",
                            text: "Add Practice Team",
                            className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                        })
                    })
                ]
            }),
            team_xrefs?.practiceTeamXrefs?.isError ? "Failed to load" : "",
            team_xrefs?.practiceTeamXrefs?.isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "mt-2 flex",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                            rows: rows,
                            columns: columns,
                            onCellDoubleClick: (params, event)=>{
                                event.defaultMuiPrevented = true;
                                setEntityId(params.row.id);
                                setEntityType(params.row.practice_id !== undefined ? "practice_team_xref" : "team_xref");
                                setEditModalOpen(true);
                            },
                            slots: {
                                toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                            },
                            slotProps: {
                                toolbar: {
                                    showQuickFilter: true
                                }
                            }
                        })
                    })
                })
            }),
            newModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $766d4a43c979d619$export$142c37f1e4234f09), {
                setOpen: setNewModalOpen,
                refreshData: ()=>team_xrefs?.practiceTeamXrefs?.mutate()
            }),
            editModalOpen && entityId && entityType && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7de5785398a4108a$export$20ede1d6f9e3058e), {
                id: entityId,
                entity_key: entityType,
                setOpen: setEditModalOpen,
                refreshData: ()=>team_xrefs?.practiceTeamXrefs?.mutate()
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




const $32e1052d0dc16058$export$1d1ff8a49462d12b = [
    "mdc",
    "regulatory"
];
const $32e1052d0dc16058$export$17e5ae7ed4f8250 = [
    "managers",
    "clinical",
    "site",
    "unblinded"
];


function $1caf57de0f790698$export$20ede1d6f9e3058e(props) {
    const entity = {
        label: "Team",
        key: props.entity_key
    };
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: data } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)(`${entity.key}s`, props.id);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const onKeyPress = (event)=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], onKeyPress);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    (0, $f2Y41.useEffect)(()=>{
        reset(data);
    }, [
        data
    ]);
    const onSubmit = (data)=>{
        if ((0, $32e1052d0dc16058$export$17e5ae7ed4f8250).includes(data.team_type)) data.practice_id = practiceId;
        (0, $b2d06586a86d14b7$export$74524c73191a667c)(`admin/${entity.key}s`, props.id, data, getAccessTokenSilently).then(()=>{
            props.setOpen(false);
            props?.refreshData();
            reset();
        }, (error)=>{
        // console.dir(error);
        });
    };
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Description",
            key: "description"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        },
        {
            label: "Xref Id",
            key: "xref_id"
        },
        {
            label: "Team Type",
            key: "team_type",
            options: props.entity_key === "practice_team_xref" ? [
                {
                    label: "Clinical",
                    key: "clinical"
                },
                {
                    label: "Managers",
                    key: "managers"
                },
                {
                    label: "Site",
                    key: "site"
                },
                {
                    label: "Unblinded",
                    key: "unblinded"
                }
            ] : [
                {
                    label: "MDC",
                    key: "mdc"
                },
                {
                    label: "Regulatory",
                    key: "regulatory"
                }
            ]
        },
        {
            label: "Vendor Code",
            key: "vendor_code",
            options: [
                {
                    label: "Slack",
                    key: "slack"
                },
                {
                    label: "Monday.com",
                    key: "monday_dot_com"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-team-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Edit ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Edit button"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option?.key,
                                                                        children: option?.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "flex justify-between pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                    className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                    type: "submit",
                                                    children: "Save"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





function $d328754f45eec09b$export$142c37f1e4234f09(props) {
    props.open = props.open ? props.open : false;
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const entity = {
        label: "Team",
        key: "team_xref"
    };
    const onSubmit = async (data)=>{
        if ((0, $32e1052d0dc16058$export$17e5ae7ed4f8250).includes(data.team_type)) {
            data.practice_id = practiceId;
            entity.key = "practice_team_xref";
        }
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)(`admin/${entity.key}s`, data, getAccessTokenSilently);
        props.setOpen(false);
        props.refreshData();
        reset();
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], ()=>props.setOpen(false));
    const fields = [
        {
            label: "Name",
            key: "name"
        },
        {
            label: "Description",
            key: "description"
        },
        {
            label: "Abbreviation",
            key: "abbreviation"
        },
        {
            label: "Xref Id",
            key: "xref_id"
        },
        {
            label: "Team Type",
            key: "team_type",
            options: [
                {
                    label: "MDC",
                    value: "mdc"
                },
                {
                    label: "Regulatory",
                    value: "regulatory"
                }
            ]
        },
        {
            label: "Vendor Code",
            key: "vendor_code",
            options: [
                {
                    label: "Slack",
                    value: "slack"
                },
                {
                    label: "Monday.com",
                    value: "monday_dot_com"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-team-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                "Add ",
                                                entity.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>props.setOpen(false),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Add team"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: fields.map((field)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: field.key,
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: field.label
                                                        }),
                                                        !field.options && /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...register(field.key),
                                                            type: "text",
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: field?.required || false
                                                        }),
                                                        field.options && /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register(field.key),
                                                            name: field.key,
                                                            id: field.key,
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    selected: true,
                                                                    children: "Select an Option"
                                                                }, "default"),
                                                                field.options.map((option)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: option.value,
                                                                        children: option.label
                                                                    }, option?.label))
                                                            ]
                                                        })
                                                    ]
                                                }, field.key))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $4e8f647dc9af3ae9$export$f1090cf0f7c39d42() {
    const team_xrefs = {
        teamXrefs: (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/team_xrefs")
    };
    const [newModalOpen, setNewModalOpen] = (0, $f2Y41.useState)(false);
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [entityId, setEntityId] = (0, $f2Y41.useState)("");
    const [entityType, setEntityType] = (0, $f2Y41.useState)("");
    const rows = [
        ...team_xrefs.teamXrefs.data
    ];
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 150
        },
        {
            field: "description",
            headerName: "Description",
            width: 200
        },
        {
            field: "abbreviation",
            headerName: "Abbr.",
            width: 100
        },
        {
            field: "xref_id",
            headerName: "Xref ID",
            width: 120
        },
        {
            field: "team_type",
            headerName: "Team Type",
            width: 120
        },
        {
            field: "vendor_code",
            headerName: "Vendor",
            width: 120
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 120,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                        className: "text-2xl sm:text-3xl  p-2 mb-2 font-bold text-gray-900 dark:text-white",
                        children: "TeamXrefs"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        onClick: ()=>setNewModalOpen(true),
                        onKeyUp: ()=>setNewModalOpen(true),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                            icon: "PlusCircleIcon",
                            text: "Add Team",
                            className: "inline-flex items-center justify-center h-10 w-1/2 px-3 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 sm:w-auto dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                        })
                    })
                ]
            }),
            team_xrefs?.teamXrefs?.isError ? "Failed to load" : "",
            team_xrefs?.teamXrefs?.isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "mt-2 flex",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                            rows: rows,
                            columns: columns,
                            onCellDoubleClick: (params, event)=>{
                                event.defaultMuiPrevented = true;
                                setEntityId(params.row.id);
                                setEntityType("team_xref");
                                setEditModalOpen(true);
                            },
                            slots: {
                                toolbar: (0, $95c56b12e832f314$export$6f17559aa1de380e)
                            },
                            slotProps: {
                                toolbar: {
                                    showQuickFilter: true
                                }
                            }
                        })
                    })
                })
            }),
            newModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d328754f45eec09b$export$142c37f1e4234f09), {
                setOpen: setNewModalOpen,
                refreshData: ()=>team_xrefs?.teamXrefs?.mutate()
            }),
            editModalOpen && entityId && entityType && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1caf57de0f790698$export$20ede1d6f9e3058e), {
                id: entityId,
                entity_key: entityType,
                setOpen: setEditModalOpen,
                refreshData: ()=>team_xrefs?.teamXrefs?.mutate()
            })
        ]
    });
}


function $cdc521c4f7727b41$export$e3e08a57518b35b4() {
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("admin/users");
    const [newModalOpen, setNewModalOpen] = (0, $f2Y41.useState)(false);
    const [editModalOpen, setEditModalOpen] = (0, $f2Y41.useState)(false);
    const [userId, setUserId] = (0, $f2Y41.useState)("");
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const handleShowUser = (userId)=>navigate(`/admin/users/${userId}`);
    const rows = data;
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 150
        },
        {
            field: "email",
            headerName: "Email",
            width: 180
        },
        {
            field: "role",
            headerName: "Role",
            width: 120
        },
        {
            field: "task_user_xref_id",
            headerName: "Monday ID",
            width: 150
        },
        {
            field: "phone_extension_xref_id",
            headerName: "Extension",
            width: 120
        },
        {
            field: "created_at",
            headerName: "Created",
            width: 180,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.created_at)
        },
        {
            field: "updated_at",
            headerName: "Updated",
            width: 180,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.updated_at)
        },
        {
            field: "deleted_at",
            headerName: "Deleted",
            width: 180,
            renderCell: (params)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.row.deleted_at)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            display: "flex",
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>renderCellActions(params, handleShowUser)
        }
    ];
    const renderCellActions = (props, handleShowUser)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>handleShowUser(props.row.id),
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Edit",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "pl-4 pr-4",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4e8f647dc9af3ae9$export$f1090cf0f7c39d42), {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $99c0a9d90a452894$export$23ad457ba1c81ef4), {})
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $4nqhV = parcelRequire("4nqhV");

var $f2Y41 = parcelRequire("f2Y41");

(typeof globalThis !== "undefined" ? globalThis : window).FullCalendarVDom = {
    Component: $f2Y41.Component,
    createElement: $f2Y41.createElement,
    render: $5021361ff788fb77$exports.render,
    createRef: $f2Y41.createRef,
    Fragment: $f2Y41.Fragment,
    createContext: $f2Y41.createContext,
    createPortal: $5021361ff788fb77$exports.createPortal,
    flushSync: $59dc0342d6501289$export$cd75ccfd720a3cd4,
    unmountComponentAtNode: $5021361ff788fb77$exports.unmountComponentAtNode // never called by FullCalendar's React component
};
function $59dc0342d6501289$export$cd75ccfd720a3cd4(callback) {
    // always sync from top-level
    callback();
}



var $f2Y41 = parcelRequire("f2Y41");

var $8XAxF = parcelRequire("8XAxF");
var $767dcc0960032cbe$var$FullCalendar = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(FullCalendar, _super);
    function FullCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._calendarApi = new (0, $8XAxF.CalendarApi)();
        return _this;
    }
    FullCalendar.prototype.render = function() {
        return $f2Y41.createElement((0, $8XAxF.CalendarDataProvider), {
            optionOverrides: this.props,
            calendarApi: this._calendarApi
        }, function(data) {
            return $f2Y41.createElement((0, $8XAxF.CalendarRoot), {
                options: data.calendarOptions,
                theme: data.theme,
                emitter: data.emitter
            }, function(classNames, height, isHeightAuto, forPrint) {
                return $f2Y41.createElement("div", {
                    className: classNames.join(" "),
                    style: {
                        height: height
                    }
                }, $f2Y41.createElement((0, $8XAxF.CalendarContent), (0, $4nqhV.__assign)({
                    isHeightAuto: isHeightAuto,
                    forPrint: forPrint
                }, data)));
            });
        });
    };
    FullCalendar.prototype.getApi = function() {
        return this._calendarApi;
    };
    return FullCalendar;
}($f2Y41.Component);
var $767dcc0960032cbe$export$2e2bcd8739ae039 = $767dcc0960032cbe$var$FullCalendar;



var $d2yo0 = parcelRequire("d2yo0");

var $MPJvb = parcelRequire("MPJvb");
/*!
FullCalendar v5.11.5
Docs & License: https://fullcalendar.io/
(c) 2022 Adam Shaw
*/ 
var $8XAxF = parcelRequire("8XAxF");

var $4nqhV = parcelRequire("4nqhV");
(0, $8XAxF.config).touchMouseIgnoreWait = 500;
var $9302647051e7f7b2$var$ignoreMouseDepth = 0;
var $9302647051e7f7b2$var$listenerCnt = 0;
var $9302647051e7f7b2$var$isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ var $9302647051e7f7b2$export$2b4a7aa79dc93c02 = /** @class */ function() {
    function PointerDragging(containerEl) {
        var _this = this;
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ""; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = "";
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = function(ev) {
            if (!_this.shouldIgnoreMouse() && $9302647051e7f7b2$var$isPrimaryMouseButton(ev) && _this.tryStart(ev)) {
                var pev = _this.createEventFromMouse(ev, true);
                _this.emitter.trigger("pointerdown", pev);
                _this.initScrollWatch(pev);
                if (!_this.shouldIgnoreMove) document.addEventListener("mousemove", _this.handleMouseMove);
                document.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        this.handleMouseMove = function(ev) {
            var pev = _this.createEventFromMouse(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger("pointermove", pev);
        };
        this.handleMouseUp = function(ev) {
            document.removeEventListener("mousemove", _this.handleMouseMove);
            document.removeEventListener("mouseup", _this.handleMouseUp);
            _this.emitter.trigger("pointerup", _this.createEventFromMouse(ev));
            _this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = function(ev) {
            if (_this.tryStart(ev)) {
                _this.isTouchDragging = true;
                var pev = _this.createEventFromTouch(ev, true);
                _this.emitter.trigger("pointerdown", pev);
                _this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                var targetEl = ev.target;
                if (!_this.shouldIgnoreMove) targetEl.addEventListener("touchmove", _this.handleTouchMove);
                targetEl.addEventListener("touchend", _this.handleTouchEnd);
                targetEl.addEventListener("touchcancel", _this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener("scroll", _this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = function(ev) {
            var pev = _this.createEventFromTouch(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger("pointermove", pev);
        };
        this.handleTouchEnd = function(ev) {
            if (_this.isDragging) {
                var targetEl = ev.target;
                targetEl.removeEventListener("touchmove", _this.handleTouchMove);
                targetEl.removeEventListener("touchend", _this.handleTouchEnd);
                targetEl.removeEventListener("touchcancel", _this.handleTouchEnd);
                window.removeEventListener("scroll", _this.handleTouchScroll, true); // useCaptured=true
                _this.emitter.trigger("pointerup", _this.createEventFromTouch(ev));
                _this.cleanup(); // call last so that pointerup has access to props
                _this.isTouchDragging = false;
                $9302647051e7f7b2$var$startIgnoringMouse();
            }
        };
        this.handleTouchScroll = function() {
            _this.wasTouchScroll = true;
        };
        this.handleScroll = function(ev) {
            if (!_this.shouldIgnoreMove) {
                var pageX = window.pageXOffset - _this.prevScrollX + _this.prevPageX;
                var pageY = window.pageYOffset - _this.prevScrollY + _this.prevPageY;
                _this.emitter.trigger("pointermove", {
                    origEvent: ev,
                    isTouch: _this.isTouchDragging,
                    subjectEl: _this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - _this.origPageX,
                    deltaY: pageY - _this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, $8XAxF.Emitter)();
        containerEl.addEventListener("mousedown", this.handleMouseDown);
        containerEl.addEventListener("touchstart", this.handleTouchStart, {
            passive: true
        });
        $9302647051e7f7b2$var$listenerCreated();
    }
    PointerDragging.prototype.destroy = function() {
        this.containerEl.removeEventListener("mousedown", this.handleMouseDown);
        this.containerEl.removeEventListener("touchstart", this.handleTouchStart, {
            passive: true
        });
        $9302647051e7f7b2$var$listenerDestroyed();
    };
    PointerDragging.prototype.tryStart = function(ev) {
        var subjectEl = this.querySubjectEl(ev);
        var downEl = ev.target;
        if (subjectEl && (!this.handleSelector || (0, $8XAxF.elementClosest)(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    };
    PointerDragging.prototype.cleanup = function() {
        $9302647051e7f7b2$var$isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    };
    PointerDragging.prototype.querySubjectEl = function(ev) {
        if (this.selector) return (0, $8XAxF.elementClosest)(ev.target, this.selector);
        return this.containerEl;
    };
    PointerDragging.prototype.shouldIgnoreMouse = function() {
        return $9302647051e7f7b2$var$ignoreMouseDepth || this.isTouchDragging;
    };
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    PointerDragging.prototype.cancelTouchScroll = function() {
        if (this.isDragging) $9302647051e7f7b2$var$isWindowTouchMoveCancelled = true;
    };
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    PointerDragging.prototype.initScrollWatch = function(ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener("scroll", this.handleScroll, true); // useCapture=true
        }
    };
    PointerDragging.prototype.recordCoords = function(ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.pageXOffset;
            this.prevScrollY = window.pageYOffset;
        }
    };
    PointerDragging.prototype.destroyScrollWatch = function() {
        if (this.shouldWatchScroll) window.removeEventListener("scroll", this.handleScroll, true); // useCaptured=true
    };
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    PointerDragging.prototype.createEventFromMouse = function(ev, isFirst) {
        var deltaX = 0;
        var deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        } else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    };
    PointerDragging.prototype.createEventFromTouch = function(ev, isFirst) {
        var touches = ev.touches;
        var pageX;
        var pageY;
        var deltaX = 0;
        var deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        } else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        } else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    };
    return PointerDragging;
}();
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function $9302647051e7f7b2$var$isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function $9302647051e7f7b2$var$startIgnoringMouse() {
    $9302647051e7f7b2$var$ignoreMouseDepth += 1;
    setTimeout(function() {
        $9302647051e7f7b2$var$ignoreMouseDepth -= 1;
    }, (0, $8XAxF.config).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function $9302647051e7f7b2$var$listenerCreated() {
    $9302647051e7f7b2$var$listenerCnt += 1;
    if ($9302647051e7f7b2$var$listenerCnt === 1) window.addEventListener("touchmove", $9302647051e7f7b2$var$onWindowTouchMove, {
        passive: false
    });
}
function $9302647051e7f7b2$var$listenerDestroyed() {
    $9302647051e7f7b2$var$listenerCnt -= 1;
    if (!$9302647051e7f7b2$var$listenerCnt) window.removeEventListener("touchmove", $9302647051e7f7b2$var$onWindowTouchMove, {
        passive: false
    });
}
function $9302647051e7f7b2$var$onWindowTouchMove(ev) {
    if ($9302647051e7f7b2$var$isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ var $9302647051e7f7b2$var$ElementMirror = /** @class */ function() {
    function ElementMirror() {
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    ElementMirror.prototype.start = function(sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.pageXOffset;
        this.origScreenY = pageY - window.pageYOffset;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    };
    ElementMirror.prototype.handleMove = function(pageX, pageY) {
        this.deltaX = pageX - window.pageXOffset - this.origScreenX;
        this.deltaY = pageY - window.pageYOffset - this.origScreenY;
        this.updateElPosition();
    };
    // can be called before start
    ElementMirror.prototype.setIsVisible = function(bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) this.mirrorEl.style.display = "";
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        } else if (this.isVisible) {
            if (this.mirrorEl) this.mirrorEl.style.display = "none";
            this.isVisible = bool;
        }
    };
    // always async
    ElementMirror.prototype.stop = function(needsRevertAnimation, callback) {
        var _this = this;
        var done = function() {
            _this.cleanup();
            callback();
        };
        if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
        (this.deltaX || this.deltaY // if same coords, transition won't work
        )) this.doRevertAnimation(done, this.revertDuration);
        else setTimeout(done, 0);
    };
    ElementMirror.prototype.doRevertAnimation = function(callback, revertDuration) {
        var mirrorEl = this.mirrorEl;
        var finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition = "top " + revertDuration + "ms," + "left " + revertDuration + "ms";
        (0, $8XAxF.applyStyle)(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top
        });
        (0, $8XAxF.whenTransitionDone)(mirrorEl, function() {
            mirrorEl.style.transition = "";
            callback();
        });
    };
    ElementMirror.prototype.cleanup = function() {
        if (this.mirrorEl) {
            (0, $8XAxF.removeElement)(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    };
    ElementMirror.prototype.updateElPosition = function() {
        if (this.sourceEl && this.isVisible) (0, $8XAxF.applyStyle)(this.getMirrorEl(), {
            left: this.sourceElRect.left + this.deltaX,
            top: this.sourceElRect.top + this.deltaY
        });
    };
    ElementMirror.prototype.getMirrorEl = function() {
        var sourceElRect = this.sourceElRect;
        var mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.classList.add("fc-unselectable");
            mirrorEl.classList.add("fc-event-dragging");
            (0, $8XAxF.applyStyle)(mirrorEl, {
                position: "fixed",
                zIndex: this.zIndex,
                visibility: "",
                boxSizing: "border-box",
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: "auto",
                bottom: "auto",
                margin: 0
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    };
    return ElementMirror;
}();
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ var $9302647051e7f7b2$var$ScrollGeomCache = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ScrollGeomCache, _super);
    function ScrollGeomCache(scrollController, doesListening) {
        var _this = _super.call(this) || this;
        _this.handleScroll = function() {
            _this.scrollTop = _this.scrollController.getScrollTop();
            _this.scrollLeft = _this.scrollController.getScrollLeft();
            _this.handleScrollChange();
        };
        _this.scrollController = scrollController;
        _this.doesListening = doesListening;
        _this.scrollTop = _this.origScrollTop = scrollController.getScrollTop();
        _this.scrollLeft = _this.origScrollLeft = scrollController.getScrollLeft();
        _this.scrollWidth = scrollController.getScrollWidth();
        _this.scrollHeight = scrollController.getScrollHeight();
        _this.clientWidth = scrollController.getClientWidth();
        _this.clientHeight = scrollController.getClientHeight();
        _this.clientRect = _this.computeClientRect(); // do last in case it needs cached values
        if (_this.doesListening) _this.getEventTarget().addEventListener("scroll", _this.handleScroll);
        return _this;
    }
    ScrollGeomCache.prototype.destroy = function() {
        if (this.doesListening) this.getEventTarget().removeEventListener("scroll", this.handleScroll);
    };
    ScrollGeomCache.prototype.getScrollTop = function() {
        return this.scrollTop;
    };
    ScrollGeomCache.prototype.getScrollLeft = function() {
        return this.scrollLeft;
    };
    ScrollGeomCache.prototype.setScrollTop = function(top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    };
    ScrollGeomCache.prototype.setScrollLeft = function(top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    };
    ScrollGeomCache.prototype.getClientWidth = function() {
        return this.clientWidth;
    };
    ScrollGeomCache.prototype.getClientHeight = function() {
        return this.clientHeight;
    };
    ScrollGeomCache.prototype.getScrollWidth = function() {
        return this.scrollWidth;
    };
    ScrollGeomCache.prototype.getScrollHeight = function() {
        return this.scrollHeight;
    };
    ScrollGeomCache.prototype.handleScrollChange = function() {};
    return ScrollGeomCache;
}((0, $8XAxF.ScrollController));
var $9302647051e7f7b2$var$ElementScrollGeomCache = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(ElementScrollGeomCache, _super);
    function ElementScrollGeomCache(el, doesListening) {
        return _super.call(this, new (0, $8XAxF.ElementScrollController)(el), doesListening) || this;
    }
    ElementScrollGeomCache.prototype.getEventTarget = function() {
        return this.scrollController.el;
    };
    ElementScrollGeomCache.prototype.computeClientRect = function() {
        return (0, $8XAxF.computeInnerRect)(this.scrollController.el);
    };
    return ElementScrollGeomCache;
}($9302647051e7f7b2$var$ScrollGeomCache);
var $9302647051e7f7b2$var$WindowScrollGeomCache = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(WindowScrollGeomCache, _super);
    function WindowScrollGeomCache(doesListening) {
        return _super.call(this, new (0, $8XAxF.WindowScrollController)(), doesListening) || this;
    }
    WindowScrollGeomCache.prototype.getEventTarget = function() {
        return window;
    };
    WindowScrollGeomCache.prototype.computeClientRect = function() {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight
        };
    };
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    WindowScrollGeomCache.prototype.handleScrollChange = function() {
        this.clientRect = this.computeClientRect();
    };
    return WindowScrollGeomCache;
}($9302647051e7f7b2$var$ScrollGeomCache);
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
var $9302647051e7f7b2$var$getTime = typeof performance === "function" ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ var $9302647051e7f7b2$var$AutoScroller = /** @class */ function() {
    function AutoScroller() {
        var _this = this;
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            ".fc-scroller"
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = function() {
            if (_this.isAnimating) {
                var edge = _this.computeBestEdge(_this.pointerScreenX + window.pageXOffset, _this.pointerScreenY + window.pageYOffset);
                if (edge) {
                    var now = $9302647051e7f7b2$var$getTime();
                    _this.handleSide(edge, (now - _this.msSinceRequest) / 1000);
                    _this.requestAnimation(now);
                } else _this.isAnimating = false; // will stop animation
            }
        };
    }
    AutoScroller.prototype.start = function(pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    };
    AutoScroller.prototype.handleMove = function(pageX, pageY) {
        if (this.isEnabled) {
            var pointerScreenX = pageX - window.pageXOffset;
            var pointerScreenY = pageY - window.pageYOffset;
            var yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            var xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) this.everMovedUp = true;
            else if (yDelta > 0) this.everMovedDown = true;
            if (xDelta < 0) this.everMovedLeft = true;
            else if (xDelta > 0) this.everMovedRight = true;
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation($9302647051e7f7b2$var$getTime());
            }
        }
    };
    AutoScroller.prototype.stop = function() {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for(var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++){
                var scrollCache = _a[_i];
                scrollCache.destroy();
            }
            this.scrollCaches = null;
        }
    };
    AutoScroller.prototype.requestAnimation = function(now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    };
    AutoScroller.prototype.handleSide = function(edge, seconds) {
        var scrollCache = edge.scrollCache;
        var edgeThreshold = this.edgeThreshold;
        var invDistance = edgeThreshold - edge.distance;
        var velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
        this.maxVelocity * seconds;
        var sign = 1;
        switch(edge.name){
            case "left":
                sign = -1;
            // falls through
            case "right":
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case "top":
                sign = -1;
            // falls through
            case "bottom":
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    };
    // left/top are relative to document topleft
    AutoScroller.prototype.computeBestEdge = function(left, top) {
        var edgeThreshold = this.edgeThreshold;
        var bestSide = null;
        var scrollCaches = this.scrollCaches || [];
        for(var _i = 0, scrollCaches_1 = scrollCaches; _i < scrollCaches_1.length; _i++){
            var scrollCache = scrollCaches_1[_i];
            var rect = scrollCache.clientRect;
            var leftDist = left - rect.left;
            var rightDist = rect.right - left;
            var topDist = top - rect.top;
            var bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "top",
                    distance: topDist
                };
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "bottom",
                    distance: bottomDist
                };
                if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "left",
                    distance: leftDist
                };
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "right",
                    distance: rightDist
                };
            }
        }
        return bestSide;
    };
    AutoScroller.prototype.buildCaches = function(scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map(function(el) {
            if (el === window) return new $9302647051e7f7b2$var$WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            return new $9302647051e7f7b2$var$ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    };
    AutoScroller.prototype.queryScrollEls = function(scrollStartEl) {
        var els = [];
        for(var _i = 0, _a = this.scrollQuery; _i < _a.length; _i++){
            var query = _a[_i];
            if (typeof query === "object") els.push(query);
            else els.push.apply(els, Array.prototype.slice.call((0, $8XAxF.getElRoot)(scrollStartEl).querySelectorAll(query)));
        }
        return els;
    };
    return AutoScroller;
}();
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ var $9302647051e7f7b2$export$23a4eef4006a2769 = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(FeaturefulElementDragging, _super);
    function FeaturefulElementDragging(containerEl, selector) {
        var _this = _super.call(this, containerEl) || this;
        _this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        _this.delay = null;
        _this.minDistance = 0;
        _this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        _this.mirrorNeedsRevert = false;
        _this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        _this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        _this.isDelayEnded = false;
        _this.isDistanceSurpassed = false;
        _this.delayTimeoutId = null;
        _this.onPointerDown = function(ev) {
            if (!_this.isDragging) {
                _this.isInteracting = true;
                _this.isDelayEnded = false;
                _this.isDistanceSurpassed = false;
                (0, $8XAxF.preventSelection)(document.body);
                (0, $8XAxF.preventContextMenu)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                _this.emitter.trigger("pointerdown", ev);
                if (_this.isInteracting && // not destroyed via pointerdown handler
                !_this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    _this.mirror.setIsVisible(false); // reset. caller must set-visible
                    _this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    _this.startDelay(ev);
                    if (!_this.minDistance) _this.handleDistanceSurpassed(ev);
                }
            }
        };
        _this.onPointerMove = function(ev) {
            if (_this.isInteracting) {
                _this.emitter.trigger("pointermove", ev);
                if (!_this.isDistanceSurpassed) {
                    var minDistance = _this.minDistance;
                    var distanceSq = void 0; // current distance from the origin, squared
                    var deltaX = ev.deltaX, deltaY = ev.deltaY;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) _this.handleDistanceSurpassed(ev);
                }
                if (_this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== "scroll") {
                        _this.mirror.handleMove(ev.pageX, ev.pageY);
                        _this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    _this.emitter.trigger("dragmove", ev);
                }
            }
        };
        _this.onPointerUp = function(ev) {
            if (_this.isInteracting) {
                _this.isInteracting = false;
                (0, $8XAxF.allowSelection)(document.body);
                (0, $8XAxF.allowContextMenu)(document.body);
                _this.emitter.trigger("pointerup", ev); // can potentially set mirrorNeedsRevert
                if (_this.isDragging) {
                    _this.autoScroller.stop();
                    _this.tryStopDrag(ev); // which will stop the mirror
                }
                if (_this.delayTimeoutId) {
                    clearTimeout(_this.delayTimeoutId);
                    _this.delayTimeoutId = null;
                }
            }
        };
        var pointer = _this.pointer = new $9302647051e7f7b2$export$2b4a7aa79dc93c02(containerEl);
        pointer.emitter.on("pointerdown", _this.onPointerDown);
        pointer.emitter.on("pointermove", _this.onPointerMove);
        pointer.emitter.on("pointerup", _this.onPointerUp);
        if (selector) pointer.selector = selector;
        _this.mirror = new $9302647051e7f7b2$var$ElementMirror();
        _this.autoScroller = new $9302647051e7f7b2$var$AutoScroller();
        return _this;
    }
    FeaturefulElementDragging.prototype.destroy = function() {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    };
    FeaturefulElementDragging.prototype.startDelay = function(ev) {
        var _this = this;
        if (typeof this.delay === "number") this.delayTimeoutId = setTimeout(function() {
            _this.delayTimeoutId = null;
            _this.handleDelayEnd(ev);
        }, this.delay); // not assignable to number!
        else this.handleDelayEnd(ev);
    };
    FeaturefulElementDragging.prototype.handleDelayEnd = function(ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    };
    FeaturefulElementDragging.prototype.handleDistanceSurpassed = function(ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    };
    FeaturefulElementDragging.prototype.tryStartDrag = function(ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger("dragstart", ev);
                if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
            }
        }
    };
    FeaturefulElementDragging.prototype.tryStopDrag = function(ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    };
    FeaturefulElementDragging.prototype.stopDrag = function(ev) {
        this.isDragging = false;
        this.emitter.trigger("dragend", ev);
    };
    // fill in the implementations...
    FeaturefulElementDragging.prototype.setIgnoreMove = function(bool) {
        this.pointer.shouldIgnoreMove = bool;
    };
    FeaturefulElementDragging.prototype.setMirrorIsVisible = function(bool) {
        this.mirror.setIsVisible(bool);
    };
    FeaturefulElementDragging.prototype.setMirrorNeedsRevert = function(bool) {
        this.mirrorNeedsRevert = bool;
    };
    FeaturefulElementDragging.prototype.setAutoScrollEnabled = function(bool) {
        this.autoScroller.isEnabled = bool;
    };
    return FeaturefulElementDragging;
}((0, $8XAxF.ElementDragging));
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ var $9302647051e7f7b2$var$OffsetTracker = /** @class */ function() {
    function OffsetTracker(el) {
        this.origRect = (0, $8XAxF.computeRect)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, $8XAxF.getClippingParents)(el).map(function(scrollEl) {
            return new $9302647051e7f7b2$var$ElementScrollGeomCache(scrollEl, true);
        });
    }
    OffsetTracker.prototype.destroy = function() {
        for(var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++){
            var scrollCache = _a[_i];
            scrollCache.destroy();
        }
    };
    OffsetTracker.prototype.computeLeft = function() {
        var left = this.origRect.left;
        for(var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++){
            var scrollCache = _a[_i];
            left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        }
        return left;
    };
    OffsetTracker.prototype.computeTop = function() {
        var top = this.origRect.top;
        for(var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++){
            var scrollCache = _a[_i];
            top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        }
        return top;
    };
    OffsetTracker.prototype.isWithinClipping = function(pageX, pageY) {
        var point = {
            left: pageX,
            top: pageY
        };
        for(var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++){
            var scrollCache = _a[_i];
            if (!$9302647051e7f7b2$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, $8XAxF.pointInsideRect)(point, scrollCache.clientRect)) return false;
        }
        return true;
    };
    return OffsetTracker;
}();
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function $9302647051e7f7b2$var$isIgnoredClipping(node) {
    var tagName = node.tagName;
    return tagName === "HTML" || tagName === "BODY";
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ var $9302647051e7f7b2$var$HitDragging = /** @class */ function() {
    function HitDragging(dragging, droppableStore) {
        var _this = this;
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = function(ev) {
            var dragging = _this.dragging;
            _this.initialHit = null;
            _this.movingHit = null;
            _this.finalHit = null;
            _this.prepareHits();
            _this.processFirstCoord(ev);
            if (_this.initialHit || !_this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                _this.emitter.trigger("pointerdown", ev);
            } else dragging.setIgnoreMove(true);
        };
        this.handleDragStart = function(ev) {
            _this.emitter.trigger("dragstart", ev);
            _this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = function(ev) {
            _this.emitter.trigger("dragmove", ev);
            _this.handleMove(ev);
        };
        this.handlePointerUp = function(ev) {
            _this.releaseHits();
            _this.emitter.trigger("pointerup", ev);
        };
        this.handleDragEnd = function(ev) {
            if (_this.movingHit) _this.emitter.trigger("hitupdate", null, true, ev);
            _this.finalHit = _this.movingHit;
            _this.movingHit = null;
            _this.emitter.trigger("dragend", ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        dragging.emitter.on("dragmove", this.handleDragMove);
        dragging.emitter.on("pointerup", this.handlePointerUp);
        dragging.emitter.on("dragend", this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, $8XAxF.Emitter)();
    }
    // sets initialHit
    // sets coordAdjust
    HitDragging.prototype.processFirstCoord = function(ev) {
        var origPoint = {
            left: ev.pageX,
            top: ev.pageY
        };
        var adjustedPoint = origPoint;
        var subjectEl = ev.subjectEl;
        var subjectRect;
        if (subjectEl instanceof HTMLElement) {
            subjectRect = (0, $8XAxF.computeRect)(subjectEl);
            adjustedPoint = (0, $8XAxF.constrainPoint)(adjustedPoint, subjectRect);
        }
        var initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                var slicedSubjectRect = (0, $8XAxF.intersectRects)(subjectRect, initialHit.rect);
                if (slicedSubjectRect) adjustedPoint = (0, $8XAxF.getRectCenter)(slicedSubjectRect);
            }
            this.coordAdjust = (0, $8XAxF.diffPoints)(adjustedPoint, origPoint);
        } else this.coordAdjust = {
            left: 0,
            top: 0
        };
    };
    HitDragging.prototype.handleMove = function(ev, forceHandle) {
        var hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !$9302647051e7f7b2$var$isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger("hitupdate", hit, false, ev);
        }
    };
    HitDragging.prototype.prepareHits = function() {
        this.offsetTrackers = (0, $8XAxF.mapHash)(this.droppableStore, function(interactionSettings) {
            interactionSettings.component.prepareHits();
            return new $9302647051e7f7b2$var$OffsetTracker(interactionSettings.el);
        });
    };
    HitDragging.prototype.releaseHits = function() {
        var offsetTrackers = this.offsetTrackers;
        for(var id in offsetTrackers)offsetTrackers[id].destroy();
        this.offsetTrackers = {};
    };
    HitDragging.prototype.queryHitForOffset = function(offsetLeft, offsetTop) {
        var _a = this, droppableStore = _a.droppableStore, offsetTrackers = _a.offsetTrackers;
        var bestHit = null;
        for(var id in droppableStore){
            var component = droppableStore[id].component;
            var offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
            offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                var originLeft = offsetTracker.computeLeft();
                var originTop = offsetTracker.computeTop();
                var positionLeft = offsetLeft - originLeft;
                var positionTop = offsetTop - originTop;
                var origRect = offsetTracker.origRect;
                var width = origRect.right - origRect.left;
                var height = origRect.bottom - origRect.top;
                if (// must be within the element's bounds
                positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                    var hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                    (0, $8XAxF.rangeContainsRange)(hit.dateProfile.activeRange, hit.dateSpan.range) && (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    };
    return HitDragging;
}();
function $9302647051e7f7b2$var$isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, $8XAxF.isDateSpansEqual)(hit0.dateSpan, hit1.dateSpan);
}
function $9302647051e7f7b2$var$buildDatePointApiWithContext(dateSpan, context) {
    var props = {};
    for(var _i = 0, _a = context.pluginHooks.datePointTransforms; _i < _a.length; _i++){
        var transform = _a[_i];
        (0, $4nqhV.__assign)(props, transform(dateSpan, context));
    }
    (0, $4nqhV.__assign)(props, $9302647051e7f7b2$var$buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function $9302647051e7f7b2$var$buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ var $9302647051e7f7b2$var$DateClicking = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DateClicking, _super);
    function DateClicking(settings) {
        var _this = _super.call(this, settings) || this;
        _this.handlePointerDown = function(pev) {
            var dragging = _this.dragging;
            var downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!_this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        _this.handleDragEnd = function(ev) {
            var component = _this.component;
            var pointer = _this.dragging.pointer;
            if (!pointer.wasTouchScroll) {
                var _a = _this.hitDragging, initialHit = _a.initialHit, finalHit = _a.finalHit;
                if (initialHit && finalHit && $9302647051e7f7b2$var$isHitsEqual(initialHit, finalHit)) {
                    var context = component.context;
                    var arg = (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, $9302647051e7f7b2$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger("dateClick", arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        _this.dragging = new $9302647051e7f7b2$export$23a4eef4006a2769(settings.el);
        _this.dragging.autoScroller.isEnabled = false;
        var hitDragging = _this.hitDragging = new $9302647051e7f7b2$var$HitDragging(_this.dragging, (0, $8XAxF.interactionSettingsToStore)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    DateClicking.prototype.destroy = function() {
        this.dragging.destroy();
    };
    return DateClicking;
}((0, $8XAxF.Interaction));
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ var $9302647051e7f7b2$var$DateSelecting = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(DateSelecting, _super);
    function DateSelecting(settings) {
        var _this = _super.call(this, settings) || this;
        _this.dragSelection = null;
        _this.handlePointerDown = function(ev) {
            var _a = _this, component = _a.component, dragging = _a.dragging;
            var options = component.context.options;
            var canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? $9302647051e7f7b2$var$getComponentTouchDelay$1(component) : null;
        };
        _this.handleDragStart = function(ev) {
            _this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        _this.handleHitUpdate = function(hit, isFinal) {
            var context = _this.component.context;
            var dragSelection = null;
            var isInvalid = false;
            if (hit) {
                var initialHit = _this.hitDragging.initialHit;
                var disallowed = hit.componentId === initialHit.componentId && _this.isHitComboAllowed && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = $9302647051e7f7b2$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, $8XAxF.isDateSelectionValid)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: "SELECT_DATES",
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: "UNSELECT_DATES"
            });
            if (!isInvalid) (0, $8XAxF.enableCursor)();
            else (0, $8XAxF.disableCursor)();
            if (!isFinal) _this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        _this.handlePointerUp = function(pev) {
            if (_this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, $8XAxF.triggerDateSelect)(_this.dragSelection, pev, _this.component.context);
                _this.dragSelection = null;
            }
        };
        var component = settings.component;
        var options = component.context.options;
        var dragging = _this.dragging = new $9302647051e7f7b2$export$23a4eef4006a2769(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new $9302647051e7f7b2$var$HitDragging(_this.dragging, (0, $8XAxF.interactionSettingsToStore)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", _this.handlePointerUp);
        return _this;
    }
    DateSelecting.prototype.destroy = function() {
        this.dragging.destroy();
    };
    return DateSelecting;
}((0, $8XAxF.Interaction));
function $9302647051e7f7b2$var$getComponentTouchDelay$1(component) {
    var options = component.context.options;
    var delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function $9302647051e7f7b2$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, $8XAxF.compareNumbers));
    var props = {};
    for(var _i = 0, dateSelectionTransformers_1 = dateSelectionTransformers; _i < dateSelectionTransformers_1.length; _i++){
        var transformer = dateSelectionTransformers_1[_i];
        var res = transformer(hit0, hit1);
        if (res === false) return null;
        if (res) (0, $4nqhV.__assign)(props, res);
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
var $9302647051e7f7b2$var$EventDragging = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(EventDragging, _super);
    function EventDragging(settings) {
        var _this = _super.call(this, settings) || this;
        // internal state
        _this.subjectEl = null;
        _this.subjectSeg = null; // the seg being selected/dragged
        _this.isDragging = false;
        _this.eventRange = null;
        _this.relevantEvents = null; // the events being dragged
        _this.receivingContext = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function(ev) {
            var origTarget = ev.origEvent.target;
            var _a = _this, component = _a.component, dragging = _a.dragging;
            var mirror = dragging.mirror;
            var options = component.context.options;
            var initialContext = component.context;
            _this.subjectEl = ev.subjectEl;
            var subjectSeg = _this.subjectSeg = (0, $8XAxF.getElSeg)(ev.subjectEl);
            var eventRange = _this.eventRange = subjectSeg.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            _this.relevantEvents = (0, $8XAxF.getRelevantEvents)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? $9302647051e7f7b2$var$getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, $8XAxF.elementClosest)(origTarget, ".fc");
            mirror.revertDuration = options.dragRevertDuration;
            var isValid = component.isValidSegDownEl(origTarget) && !(0, $8XAxF.elementClosest)(origTarget, ".fc-event-resizer"); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            _this.isDragging = isValid && ev.subjectEl.classList.contains("fc-event-draggable");
        };
        _this.handleDragStart = function(ev) {
            var initialContext = _this.component.context;
            var eventRange = _this.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== _this.component.props.eventSelection) initialContext.dispatch({
                    type: "SELECT_EVENT",
                    eventInstanceId: eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: "UNSELECT_EVENT"
            });
            if (_this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger("eventDragStart", {
                    el: _this.subjectEl,
                    event: new (0, $8XAxF.EventApi)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        _this.handleHitUpdate = function(hit, isFinal) {
            if (!_this.isDragging) return;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var initialContext = _this.component.context;
            // states based on new hit
            var receivingContext = null;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $8XAxF.createEmptyEventStore)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                var receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = $9302647051e7f7b2$var$computeEventMutation(initialHit, hit, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, $8XAxF.applyMutationToEventStore)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, $8XAxF.isInteractionValid)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, $8XAxF.createEmptyEventStore)();
                        }
                    }
                } else receivingContext = null;
            }
            _this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, $8XAxF.enableCursor)();
            else (0, $8XAxF.disableCursor)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                $9302647051e7f7b2$var$isHitsEqual(initialHit, hit)) mutation = null;
                _this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                _this.dragging.setMirrorIsVisible(!hit || !(0, $8XAxF.getElRoot)(_this.subjectEl).querySelector(".fc-event-mirror"));
                // assign states based on new hit
                _this.receivingContext = receivingContext;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handlePointerUp = function() {
            if (!_this.isDragging) _this.cleanup(); // because handleDragEnd won't fire
        };
        _this.handleDragEnd = function(ev) {
            if (_this.isDragging) {
                var initialContext_1 = _this.component.context;
                var initialView = initialContext_1.viewApi;
                var _a = _this, receivingContext_1 = _a.receivingContext, validMutation = _a.validMutation;
                var eventDef = _this.eventRange.def;
                var eventInstance = _this.eventRange.instance;
                var eventApi = new (0, $8XAxF.EventApi)(initialContext_1, eventDef, eventInstance);
                var relevantEvents_1 = _this.relevantEvents;
                var mutatedRelevantEvents_1 = _this.mutatedRelevantEvents;
                var finalHit = _this.hitDragging.finalHit;
                _this.clearDrag(); // must happen after revert animation
                initialContext_1.emitter.trigger("eventDragStop", {
                    el: _this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext_1 === initialContext_1) {
                        var updatedEventApi = new (0, $8XAxF.EventApi)(initialContext_1, mutatedRelevantEvents_1.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents_1.instances[eventInstance.instanceId] : null);
                        initialContext_1.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents_1
                        });
                        var eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, $8XAxF.buildEventApis)(mutatedRelevantEvents_1, initialContext_1, eventInstance),
                            revert: function() {
                                initialContext_1.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents_1
                                });
                            }
                        };
                        var transformed = {};
                        for(var _i = 0, _b = initialContext_1.getCurrentData().pluginHooks.eventDropTransformers; _i < _b.length; _i++){
                            var transformer = _b[_i];
                            (0, $4nqhV.__assign)(transformed, transformer(validMutation, initialContext_1));
                        }
                        initialContext_1.emitter.trigger("eventDrop", (0, $4nqhV.__assign)((0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext_1.emitter.trigger("eventChange", eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext_1) {
                        var eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, $8XAxF.buildEventApis)(relevantEvents_1, initialContext_1, eventInstance),
                            revert: function() {
                                initialContext_1.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents_1
                                });
                            }
                        };
                        initialContext_1.emitter.trigger("eventLeave", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext_1.dispatch({
                            type: "REMOVE_EVENTS",
                            eventStore: relevantEvents_1
                        });
                        initialContext_1.emitter.trigger("eventRemove", eventRemoveArg);
                        var addedEventDef = mutatedRelevantEvents_1.defs[eventDef.defId];
                        var addedEventInstance = mutatedRelevantEvents_1.instances[eventInstance.instanceId];
                        var addedEventApi = new (0, $8XAxF.EventApi)(receivingContext_1, addedEventDef, addedEventInstance);
                        receivingContext_1.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents_1
                        });
                        var eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, $8XAxF.buildEventApis)(mutatedRelevantEvents_1, receivingContext_1, addedEventInstance),
                            revert: function() {
                                receivingContext_1.dispatch({
                                    type: "REMOVE_EVENTS",
                                    eventStore: mutatedRelevantEvents_1
                                });
                            }
                        };
                        receivingContext_1.emitter.trigger("eventAdd", eventAddArg);
                        if (ev.isTouch) receivingContext_1.dispatch({
                            type: "SELECT_EVENT",
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext_1.emitter.trigger("drop", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, $9302647051e7f7b2$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext_1)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext_1.emitter.trigger("eventReceive", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext_1.emitter.trigger("_noEventDrop");
            }
            _this.cleanup();
        };
        var component = _this.component;
        var options = component.context.options;
        var dragging = _this.dragging = new $9302647051e7f7b2$export$23a4eef4006a2769(settings.el);
        dragging.pointer.selector = EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new $9302647051e7f7b2$var$HitDragging(_this.dragging, (0, $8XAxF.interactionSettingsStore));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", _this.handlePointerUp);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    EventDragging.prototype.destroy = function() {
        this.dragging.destroy();
    };
    // render a drag state on the next receivingCalendar
    EventDragging.prototype.displayDrag = function(nextContext, state) {
        var initialContext = this.component.context;
        var prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) prevContext.dispatch({
                type: "SET_EVENT_DRAG",
                state: {
                    affectedEvents: state.affectedEvents,
                    mutatedEvents: (0, $8XAxF.createEmptyEventStore)(),
                    isEvent: true
                }
            });
            else prevContext.dispatch({
                type: "UNSET_EVENT_DRAG"
            });
        }
        if (nextContext) nextContext.dispatch({
            type: "SET_EVENT_DRAG",
            state: state
        });
    };
    EventDragging.prototype.clearDrag = function() {
        var initialCalendar = this.component.context;
        var receivingContext = this.receivingContext;
        if (receivingContext) receivingContext.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) initialCalendar.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
    };
    EventDragging.prototype.cleanup = function() {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    };
    // TODO: test this in IE11
    // QUESTION: why do we need it on the resizable???
    EventDragging.SELECTOR = ".fc-event-draggable, .fc-event-resizable";
    return EventDragging;
}((0, $8XAxF.Interaction));
function $9302647051e7f7b2$var$computeEventMutation(hit0, hit1, massagers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var date0 = dateSpan0.range.start;
    var date1 = dateSpan1.range.start;
    var standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, $8XAxF.startOfDay)(date0);
    }
    var delta = (0, $8XAxF.diffDates)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    var mutation = {
        datesDelta: delta,
        standardProps: standardProps
    };
    for(var _i = 0, massagers_1 = massagers; _i < massagers_1.length; _i++){
        var massager = massagers_1[_i];
        massager(mutation, hit0, hit1);
    }
    return mutation;
}
function $9302647051e7f7b2$var$getComponentTouchDelay(component) {
    var options = component.context.options;
    var delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
var $9302647051e7f7b2$var$EventResizing = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(EventResizing, _super);
    function EventResizing(settings) {
        var _this = _super.call(this, settings) || this;
        // internal state
        _this.draggingSegEl = null;
        _this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        _this.eventRange = null;
        _this.relevantEvents = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function(ev) {
            var component = _this.component;
            var segEl = _this.querySegEl(ev);
            var seg = (0, $8XAxF.getElSeg)(segEl);
            var eventRange = _this.eventRange = seg.eventRange;
            _this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            _this.dragging.setIgnoreMove(!_this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && _this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        _this.handleDragStart = function(ev) {
            var context = _this.component.context;
            var eventRange = _this.eventRange;
            _this.relevantEvents = (0, $8XAxF.getRelevantEvents)(context.getCurrentData().eventStore, _this.eventRange.instance.instanceId);
            var segEl = _this.querySegEl(ev);
            _this.draggingSegEl = segEl;
            _this.draggingSeg = (0, $8XAxF.getElSeg)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger("eventResizeStart", {
                el: segEl,
                event: new (0, $8XAxF.EventApi)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        _this.handleHitUpdate = function(hit, isFinal, ev) {
            var context = _this.component.context;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var eventInstance = _this.eventRange.instance;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $8XAxF.createEmptyEventStore)(),
                isEvent: true
            };
            if (hit) {
                var disallowed = hit.componentId === initialHit.componentId && _this.isHitComboAllowed && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = $9302647051e7f7b2$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains("fc-event-resizer-start"), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, $8XAxF.applyMutationToEventStore)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, $8XAxF.isInteractionValid)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: "SET_EVENT_RESIZE",
                state: interaction
            });
            else context.dispatch({
                type: "UNSET_EVENT_RESIZE"
            });
            if (!isInvalid) (0, $8XAxF.enableCursor)();
            else (0, $8XAxF.disableCursor)();
            if (!isFinal) {
                if (mutation && $9302647051e7f7b2$var$isHitsEqual(initialHit, hit)) mutation = null;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handleDragEnd = function(ev) {
            var context = _this.component.context;
            var eventDef = _this.eventRange.def;
            var eventInstance = _this.eventRange.instance;
            var eventApi = new (0, $8XAxF.EventApi)(context, eventDef, eventInstance);
            var relevantEvents = _this.relevantEvents;
            var mutatedRelevantEvents = _this.mutatedRelevantEvents;
            context.emitter.trigger("eventResizeStop", {
                el: _this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (_this.validMutation) {
                var updatedEventApi = new (0, $8XAxF.EventApi)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: mutatedRelevantEvents
                });
                var eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, $8XAxF.buildEventApis)(mutatedRelevantEvents, context, eventInstance),
                    revert: function() {
                        context.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger("eventResize", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, eventChangeArg), {
                    el: _this.draggingSegEl,
                    startDelta: _this.validMutation.startDelta || (0, $8XAxF.createDuration)(0),
                    endDelta: _this.validMutation.endDelta || (0, $8XAxF.createDuration)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger("eventChange", eventChangeArg);
            } else context.emitter.trigger("_noEventResize");
            // reset all internal state
            _this.draggingSeg = null;
            _this.relevantEvents = null;
            _this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        var component = settings.component;
        var dragging = _this.dragging = new $9302647051e7f7b2$export$23a4eef4006a2769(settings.el);
        dragging.pointer.selector = ".fc-event-resizer";
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        var hitDragging = _this.hitDragging = new $9302647051e7f7b2$var$HitDragging(_this.dragging, (0, $8XAxF.interactionSettingsToStore)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    EventResizing.prototype.destroy = function() {
        this.dragging.destroy();
    };
    EventResizing.prototype.querySegEl = function(ev) {
        return (0, $8XAxF.elementClosest)(ev.subjectEl, ".fc-event");
    };
    return EventResizing;
}((0, $8XAxF.Interaction));
function $9302647051e7f7b2$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
    var dateEnv = hit0.context.dateEnv;
    var date0 = hit0.dateSpan.range.start;
    var date1 = hit1.dateSpan.range.start;
    var delta = (0, $8XAxF.diffDates)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
var $9302647051e7f7b2$var$UnselectAuto = /** @class */ function() {
    function UnselectAuto(context) {
        var _this = this;
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = function(selectInfo) {
            if (selectInfo.jsEvent) _this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = function(pev) {
            var unselectCancel = _this.context.options.unselectCancel;
            var downEl = (0, $8XAxF.getEventTargetViaRoot)(pev.origEvent);
            _this.matchesCancel = !!(0, $8XAxF.elementClosest)(downEl, unselectCancel);
            _this.matchesEvent = !!(0, $8XAxF.elementClosest)(downEl, $9302647051e7f7b2$var$EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = function(pev) {
            var context = _this.context;
            var documentPointer = _this.documentPointer;
            var calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !_this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    var unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !_this.matchesCancel)) context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !_this.matchesEvent // interaction DIDN'T start on an event
                ) context.dispatch({
                    type: "UNSELECT_EVENT"
                });
            }
            _this.isRecentPointerDateSelect = false;
        };
        var documentPointer = this.documentPointer = new $9302647051e7f7b2$export$2b4a7aa79dc93c02(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on("pointerdown", this.onDocumentPointerDown);
        documentPointer.emitter.on("pointerup", this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on("select", this.onSelect);
    }
    UnselectAuto.prototype.destroy = function() {
        this.context.emitter.off("select", this.onSelect);
        this.documentPointer.destroy();
    };
    return UnselectAuto;
}();
var $9302647051e7f7b2$var$OPTION_REFINERS = {
    fixedMirrorParent: (0, $8XAxF.identity)
};
var $9302647051e7f7b2$var$LISTENER_REFINERS = {
    dateClick: (0, $8XAxF.identity),
    eventDragStart: (0, $8XAxF.identity),
    eventDragStop: (0, $8XAxF.identity),
    eventDrop: (0, $8XAxF.identity),
    eventResizeStart: (0, $8XAxF.identity),
    eventResizeStop: (0, $8XAxF.identity),
    eventResize: (0, $8XAxF.identity),
    drop: (0, $8XAxF.identity),
    eventReceive: (0, $8XAxF.identity),
    eventLeave: (0, $8XAxF.identity)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ var $9302647051e7f7b2$var$ExternalElementDragging = /** @class */ function() {
    function ExternalElementDragging(dragging, suppliedDragMeta) {
        var _this = this;
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = function(ev) {
            _this.dragMeta = _this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = function(hit, isFinal, ev) {
            var dragging = _this.hitDragging.dragging;
            var receivingContext = null;
            var droppableEvent = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: (0, $8XAxF.createEmptyEventStore)(),
                mutatedEvents: (0, $8XAxF.createEmptyEventStore)(),
                isEvent: _this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (_this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = $9302647051e7f7b2$var$computeEventForDateSpan(hit.dateSpan, _this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, $8XAxF.eventTupleToStore)(droppableEvent);
                    isInvalid = !(0, $8XAxF.isInteractionValid)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, $8XAxF.createEmptyEventStore)();
                        droppableEvent = null;
                    }
                }
            }
            _this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector(".fc-event-mirror"));
            if (!isInvalid) (0, $8XAxF.enableCursor)();
            else (0, $8XAxF.disableCursor)();
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                _this.receivingContext = receivingContext;
                _this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = function(pev) {
            var _a = _this, receivingContext = _a.receivingContext, droppableEvent = _a.droppableEvent;
            _this.clearDrag();
            if (receivingContext && droppableEvent) {
                var finalHit = _this.hitDragging.finalHit;
                var finalView = finalHit.context.viewApi;
                var dragMeta = _this.dragMeta;
                receivingContext.emitter.trigger("drop", (0, $4nqhV.__assign)((0, $4nqhV.__assign)({}, $9302647051e7f7b2$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    var addingEvents_1 = (0, $8XAxF.eventTupleToStore)(droppableEvent);
                    receivingContext.dispatch({
                        type: "MERGE_EVENTS",
                        eventStore: addingEvents_1
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: "SELECT_EVENT",
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger("eventReceive", {
                        event: new (0, $8XAxF.EventApi)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert: function() {
                            receivingContext.dispatch({
                                type: "REMOVE_EVENTS",
                                eventStore: addingEvents_1
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            _this.receivingContext = null;
            _this.droppableEvent = null;
        };
        var hitDragging = this.hitDragging = new $9302647051e7f7b2$var$HitDragging(dragging, (0, $8XAxF.interactionSettingsStore));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    ExternalElementDragging.prototype.buildDragMeta = function(subjectEl) {
        if (typeof this.suppliedDragMeta === "object") return (0, $8XAxF.parseDragMeta)(this.suppliedDragMeta);
        if (typeof this.suppliedDragMeta === "function") return (0, $8XAxF.parseDragMeta)(this.suppliedDragMeta(subjectEl));
        return $9302647051e7f7b2$var$getDragMetaFromEl(subjectEl);
    };
    ExternalElementDragging.prototype.displayDrag = function(nextContext, state) {
        var prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) prevContext.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
        if (nextContext) nextContext.dispatch({
            type: "SET_EVENT_DRAG",
            state: state
        });
    };
    ExternalElementDragging.prototype.clearDrag = function() {
        if (this.receivingContext) this.receivingContext.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
    };
    ExternalElementDragging.prototype.canDropElOnCalendar = function(el, receivingContext) {
        var dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === "function") return dropAccept.call(receivingContext.calendarApi, el);
        if (typeof dropAccept === "string" && dropAccept) return Boolean((0, $8XAxF.elementMatches)(el, dropAccept));
        return true;
    };
    return ExternalElementDragging;
}();
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function $9302647051e7f7b2$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
    var defProps = (0, $4nqhV.__assign)({}, dragMeta.leftoverProps);
    for(var _i = 0, _a = context.pluginHooks.externalDefTransforms; _i < _a.length; _i++){
        var transform = _a[_i];
        (0, $4nqhV.__assign)(defProps, transform(dateSpan, dragMeta));
    }
    var _b = (0, $8XAxF.refineEventDef)(defProps, context), refined = _b.refined, extra = _b.extra;
    var def = (0, $8XAxF.parseEventDef)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    var start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    var end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, $8XAxF.getDefaultEventEnd)(dateSpan.allDay, start, context);
    var instance = (0, $8XAxF.createEventInstance)(def.defId, {
        start: start,
        end: end
    });
    return {
        def: def,
        instance: instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function $9302647051e7f7b2$var$getDragMetaFromEl(el) {
    var str = $9302647051e7f7b2$var$getEmbeddedElData(el, "event");
    var obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, $8XAxF.parseDragMeta)(obj);
}
(0, $8XAxF.config).dataAttrPrefix = "";
function $9302647051e7f7b2$var$getEmbeddedElData(el, name) {
    var prefix = (0, $8XAxF.config).dataAttrPrefix;
    var prefixedName = (prefix ? prefix + "-" : "") + name;
    return el.getAttribute("data-" + prefixedName) || "";
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ var $9302647051e7f7b2$export$f2a139e5d18b9882 = /** @class */ function() {
    function ExternalDraggable(el, settings) {
        var _this = this;
        if (settings === void 0) settings = {};
        this.handlePointerDown = function(ev) {
            var dragging = _this.dragging;
            var _a = _this.settings, minDistance = _a.minDistance, longPressDelay = _a.longPressDelay;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, $8XAxF.BASE_OPTION_DEFAULTS).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, $8XAxF.BASE_OPTION_DEFAULTS).longPressDelay : 0;
        };
        this.handleDragStart = function(ev) {
            if (ev.isTouch && _this.dragging.delay && ev.subjectEl.classList.contains("fc-event")) _this.dragging.mirror.getMirrorEl().classList.add("fc-event-selected");
        };
        this.settings = settings;
        var dragging = this.dragging = new $9302647051e7f7b2$export$23a4eef4006a2769(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        new $9302647051e7f7b2$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    ExternalDraggable.prototype.destroy = function() {
        this.dragging.destroy();
    };
    return ExternalDraggable;
}();
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ var $9302647051e7f7b2$var$InferredElementDragging = /** @class */ function(_super) {
    (0, $4nqhV.__extends)(InferredElementDragging, _super);
    function InferredElementDragging(containerEl) {
        var _this = _super.call(this, containerEl) || this;
        _this.shouldIgnoreMove = false;
        _this.mirrorSelector = "";
        _this.currentMirrorEl = null;
        _this.handlePointerDown = function(ev) {
            _this.emitter.trigger("pointerdown", ev);
            if (!_this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            _this.emitter.trigger("dragstart", ev);
        };
        _this.handlePointerMove = function(ev) {
            if (!_this.shouldIgnoreMove) _this.emitter.trigger("dragmove", ev);
        };
        _this.handlePointerUp = function(ev) {
            _this.emitter.trigger("pointerup", ev);
            if (!_this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            _this.emitter.trigger("dragend", ev);
        };
        var pointer = _this.pointer = new $9302647051e7f7b2$export$2b4a7aa79dc93c02(containerEl);
        pointer.emitter.on("pointerdown", _this.handlePointerDown);
        pointer.emitter.on("pointermove", _this.handlePointerMove);
        pointer.emitter.on("pointerup", _this.handlePointerUp);
        return _this;
    }
    InferredElementDragging.prototype.destroy = function() {
        this.pointer.destroy();
    };
    InferredElementDragging.prototype.setIgnoreMove = function(bool) {
        this.shouldIgnoreMove = bool;
    };
    InferredElementDragging.prototype.setMirrorIsVisible = function(bool) {
        if (bool) // restore a previously hidden element.
        // use the reference in case the selector class has already been removed.
        {
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = "";
                this.currentMirrorEl = null;
            }
        } else {
            var mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = "hidden";
            }
        }
    };
    return InferredElementDragging;
}((0, $8XAxF.ElementDragging));
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ var $9302647051e7f7b2$export$51e5e9a9728fcd8f = /** @class */ function() {
    function ThirdPartyDraggable(containerOrSettings, settings) {
        var containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        var dragging = this.dragging = new $9302647051e7f7b2$var$InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === "string") dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = "[data-event]";
        if (typeof settings.mirrorSelector === "string") dragging.mirrorSelector = settings.mirrorSelector;
        new $9302647051e7f7b2$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    ThirdPartyDraggable.prototype.destroy = function() {
        this.dragging.destroy();
    };
    return ThirdPartyDraggable;
}();
var $9302647051e7f7b2$var$main = (0, $8XAxF.createPlugin)({
    componentInteractions: [
        $9302647051e7f7b2$var$DateClicking,
        $9302647051e7f7b2$var$DateSelecting,
        $9302647051e7f7b2$var$EventDragging,
        $9302647051e7f7b2$var$EventResizing
    ],
    calendarInteractions: [
        $9302647051e7f7b2$var$UnselectAuto
    ],
    elementDraggingImpl: $9302647051e7f7b2$export$23a4eef4006a2769,
    optionRefiners: $9302647051e7f7b2$var$OPTION_REFINERS,
    listenerRefiners: $9302647051e7f7b2$var$LISTENER_REFINERS
});
var $9302647051e7f7b2$export$2e2bcd8739ae039 = $9302647051e7f7b2$var$main;



function $485d3281bdc9f22a$export$e1aef45b828286de() {
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("appointments");
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-10 dark:text-gray-200",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                    className: "text-xl font-bold",
                    children: "Calendar"
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $767dcc0960032cbe$export$2e2bcd8739ae039), {
                    plugins: [
                        (0, $d2yo0.default),
                        (0, $MPJvb.default),
                        (0, $9302647051e7f7b2$export$2e2bcd8739ae039)
                    ],
                    headerToolbar: {
                        left: "prev,next today",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,timeGridDay"
                    },
                    initialView: "dayGridMonth",
                    editable: true,
                    selectable: true,
                    selectMirror: true,
                    dayMaxEvents: true,
                    weekends: true,
                    events: data.map((data)=>({
                            title: data.appointment_type,
                            start: data.start_dt
                        }))
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");
function $326f8a578b267bd7$export$334c29725a78c21d() {
    const { loginWithRedirect: loginWithRedirect, isLoading: isLoading, error: error } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    (0, $f2Y41.useEffect)(()=>{
        // if (!error) {
        loginWithRedirect();
    // }
    }, []);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: "There was an error."
            }),
            isLoading && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: "Loading..."
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");

var $60e0d777a484feec$exports = {};

$60e0d777a484feec$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "morning_1.0e4c9f46.png";


var $459e92e918607f48$exports = {};

$459e92e918607f48$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "morning_2.918a9b24.png";


var $a5ac8bf72925b857$exports = {};

$a5ac8bf72925b857$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "morning_3.69964763.png";


var $672a9baec7532cb0$exports = {};

$672a9baec7532cb0$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "afternoon_1.94503e8e.png";


var $aa7fe05ddca08dd1$exports = {};

$aa7fe05ddca08dd1$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "afternoon_2.d127fba3.png";


var $5a11aa5c6307054f$exports = {};

$5a11aa5c6307054f$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "afternoon_3.00aad003.png";


var $b51e3ea3b808581c$exports = {};

$b51e3ea3b808581c$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "evening_1.d0c8aeb1.png";


var $f52d1dcf3055abdb$exports = {};

$f52d1dcf3055abdb$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "evening_2.9504c769.png";


var $c6dba8e56cf6bc56$exports = {};

$c6dba8e56cf6bc56$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "evening_3.ec16b80a.png";


const $0e7c90fa1cca030c$export$f73bb90ba0ba1b23 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($60e0d777a484feec$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($459e92e918607f48$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a5ac8bf72925b857$exports)))
];
const $0e7c90fa1cca030c$export$6f99e6d2ab38b4c2 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($672a9baec7532cb0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($aa7fe05ddca08dd1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5a11aa5c6307054f$exports)))
];
const $0e7c90fa1cca030c$export$60aaf31dd0a39fd3 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($b51e3ea3b808581c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f52d1dcf3055abdb$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c6dba8e56cf6bc56$exports)))
];
var $0e7c90fa1cca030c$export$2e2bcd8739ae039 = {
    groupedMorningImages: $0e7c90fa1cca030c$export$f73bb90ba0ba1b23,
    groupedAfternoonImages: $0e7c90fa1cca030c$export$6f99e6d2ab38b4c2,
    groupedEveningImages: $0e7c90fa1cca030c$export$60aaf31dd0a39fd3
};



// const himalayas = new URL('../images/himalayas.jpg', import.meta.url).toString()

var $ge3KO = parcelRequire("ge3KO");


function $ac0b783463662778$export$5e4d4d29908f340e() {
    const prefersDarkMode = (0, $8256098bd6a934fe$export$56a913221adb0e51)();
    let options = "";
    if (prefersDarkMode) options = "?theme=transparent";
    const { data: data } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("metabase_iframes", `crc_manager_dashboard${options}`);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "h-screen",
        children: data && /*#__PURE__*/ (0, $ge3KO.jsx)("iframe", {
            src: data,
            className: "inset-0 w-full h-full",
            title: "eyeFrame"
        })
    });
}


// const himalayas = new URL('../images/himalayas.jpg', import.meta.url).toString()

var $ge3KO = parcelRequire("ge3KO");


function $22ca3ca6d1e5c80a$export$d9393835c11e04ab() {
    const prefersDarkMode = (0, $8256098bd6a934fe$export$56a913221adb0e51)();
    let options = "";
    if (prefersDarkMode) options = "?theme=transparent";
    const { data: data } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("metabase_iframes", `crc_dashboard${options}`);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "h-screen",
        children: data && /*#__PURE__*/ (0, $ge3KO.jsx)("iframe", {
            src: data,
            className: "inset-0 w-full h-full",
            title: "eyeFrame"
        })
    });
}



var $6TVh2 = parcelRequire("6TVh2");
const $aface4e092470bfa$var$hour = new Date().getHours();
const $aface4e092470bfa$var$morning = $aface4e092470bfa$var$hour > 0 && $aface4e092470bfa$var$hour < 12;
const $aface4e092470bfa$var$afternoon = $aface4e092470bfa$var$hour >= 12 && $aface4e092470bfa$var$hour < 17;
const $aface4e092470bfa$var$evening = $aface4e092470bfa$var$hour >= 17 && $aface4e092470bfa$var$hour <= 23;
function $aface4e092470bfa$var$useGreeting() {
    const welcomeTypes = [
        "Good morning",
        "Good afternoon",
        "Good evening"
    ];
    if ($aface4e092470bfa$var$morning) return welcomeTypes[0];
    if ($aface4e092470bfa$var$afternoon) return welcomeTypes[1];
    return welcomeTypes[2];
}
function $aface4e092470bfa$var$greetingImage() {
    if ($aface4e092470bfa$var$morning) return $6TVh2.sample((0, $0e7c90fa1cca030c$export$f73bb90ba0ba1b23));
    if ($aface4e092470bfa$var$afternoon) return $6TVh2.sample((0, $0e7c90fa1cca030c$export$6f99e6d2ab38b4c2));
    if ($aface4e092470bfa$var$evening) return $6TVh2.sample((0, $0e7c90fa1cca030c$export$60aaf31dd0a39fd3));
}
function $aface4e092470bfa$export$fe82a520fc33e5f4() {
    const greeting = $aface4e092470bfa$var$useGreeting();
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { user: user } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            !(0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser) && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $22ca3ca6d1e5c80a$export$d9393835c11e04ab), {}),
            (0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser) && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ac0b783463662778$export$5e4d4d29908f340e), {})
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


const $cb290a718e7b7293$export$971ece4402ffcac5 = [
    {
        icon: (0, $30670fdc031ff068$export$2e2bcd8739ae039),
        name: "Patient Directory",
        href: "/patients",
        iconForeground: "text-rose-700",
        iconBackground: "bg-rose-50",
        description: "Start with the patient directory"
    },
    {
        icon: (0, $380867445ff69bba$export$2e2bcd8739ae039),
        name: "Screen by Study",
        href: "/studies",
        iconForeground: "text-purple-700",
        iconBackground: "bg-purple-50",
        description: "View all the studies available to screen patients into"
    },
    {
        icon: (0, $2cf237bbed3f4e6d$export$2e2bcd8739ae039),
        name: "Calendar",
        href: "/calendar",
        iconForeground: "text-indigo-700",
        iconBackground: "bg-indigo-50",
        description: "View all apppointments across the practice"
    }
];






var $6TVh2 = parcelRequire("6TVh2");
const $4e9fe22e0f6c619a$var$hour = new Date().getHours();
const $4e9fe22e0f6c619a$var$morning = $4e9fe22e0f6c619a$var$hour < 12 && $4e9fe22e0f6c619a$var$hour > 3;
const $4e9fe22e0f6c619a$var$afternoon = $4e9fe22e0f6c619a$var$hour < 17 && $4e9fe22e0f6c619a$var$hour >= 12;
const $4e9fe22e0f6c619a$var$evening = $4e9fe22e0f6c619a$var$hour >= 17 && $4e9fe22e0f6c619a$var$hour <= 3;
function $4e9fe22e0f6c619a$var$useGreeting() {
    const welcomeTypes = [
        "Good morning",
        "Good afternoon",
        "Good evening"
    ];
    if ($4e9fe22e0f6c619a$var$morning) return welcomeTypes[0];
    if ($4e9fe22e0f6c619a$var$afternoon) return welcomeTypes[1];
    return welcomeTypes[2];
}
function $4e9fe22e0f6c619a$var$greetingImage() {
    if ($4e9fe22e0f6c619a$var$morning) return $6TVh2.sample((0, $0e7c90fa1cca030c$export$f73bb90ba0ba1b23));
    if ($4e9fe22e0f6c619a$var$afternoon) return $6TVh2.sample((0, $0e7c90fa1cca030c$export$6f99e6d2ab38b4c2));
    if ($4e9fe22e0f6c619a$var$evening) return $6TVh2.sample((0, $0e7c90fa1cca030c$export$60aaf31dd0a39fd3));
}
function $4e9fe22e0f6c619a$export$b94310965bed44e6() {
    const greeting = $4e9fe22e0f6c619a$var$useGreeting();
    const { currentUser: currentUser } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "relative overflow-hidden shadow-lg cursor-default m-6 rounded-md mb-0",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                        className: "object-cover object-[0px_ -120px] w-full h-36",
                        src: $4e9fe22e0f6c619a$var$greetingImage(),
                        alt: "dashboard"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "absolute top-0 left-0 p-2",
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "dark:rounded-md dark:bg-gray-900 dark:bg-opacity-80 py-6 px-4",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("h4", {
                                    className: "mb-1 text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-300",
                                    children: [
                                        greeting,
                                        currentUser?.given_name && ", ",
                                        currentUser?.given_name,
                                        "!"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                    className: "leading-normal text-xl font-medium text-gray-900 dark:text-gray-300",
                                    children: "Where are you heading today?"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("section", {
                "aria-labelledby": "quick-links-title",
                className: "mt-6 ",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "rounded-lg overflow-hidden shadow divide-y divide-gray-200 dark:divide-x dark:divide-gray-600 dark:divide-y dark:border-b dark:border-gray-600 dark:border-r dark:text-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-3 sm:gap-px dark:gap-0 m-5",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h2", {
                            className: "sr-only",
                            id: "quick-links-title",
                            children: "Quick links"
                        }),
                        (0, $cb290a718e7b7293$export$971ece4402ffcac5).map((action, actionIdx)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: (0, $ab3059e3726110c9$export$ce4ab0c55987d1ff)(actionIdx === 0 ? "rounded-tl-lg rounded-tr-lg sm:rounded-tr-none" : "", // actionIdx === 1 ? 'sm:rounded-tr-lg' : '',
                                // actionIdx === actions.length - 2 ? 'sm:rounded-bl-lg' : '',
                                // actionIdx === actions.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '',
                                "relative group p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-cyan-500 hover:bg-gray-50 dark:hover:bg-gray-700"),
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                            className: (0, $ab3059e3726110c9$export$ce4ab0c55987d1ff)(action.iconBackground, action.iconForeground, "rounded-lg inline-flex p-3 ring-0 ring-white"),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)(action.icon, {
                                                className: "h-6 w-6",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                                className: "text-lg font-medium",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                    to: action.href,
                                                    className: "focus:outline-none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "absolute inset-0",
                                                            "aria-hidden": "true"
                                                        }),
                                                        action.name
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                className: "mt-2 text-sm text-gray-500",
                                                children: action.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                            className: "h-6 w-6",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                    children: "X Button"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    d: "M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, action.name))
                    ]
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

function $5b6c330ed2aee3b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5b6c330ed2aee3b5$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5b6c330ed2aee3b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5b6c330ed2aee3b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $5160703896c56a30$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $5160703896c56a30$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $5160703896c56a30$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $5160703896c56a30$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $5160703896c56a30$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $5160703896c56a30$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $5160703896c56a30$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $5160703896c56a30$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $5160703896c56a30$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($5160703896c56a30$var$isDate(val)) return "date";
    if ($5160703896c56a30$var$isError(val)) return "error";
    var constructorName = $5160703896c56a30$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $5160703896c56a30$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $5160703896c56a30$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $5160703896c56a30$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $5160703896c56a30$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $5160703896c56a30$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($5160703896c56a30$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($5160703896c56a30$var$formatProdErrorMessage(1));
        return enhancer($5160703896c56a30$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($5160703896c56a30$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($5160703896c56a30$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($5160703896c56a30$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($5160703896c56a30$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($5160703896c56a30$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$5160703896c56a30$var$isPlainObject(action)) throw new Error($5160703896c56a30$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($5160703896c56a30$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($5160703896c56a30$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($5160703896c56a30$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $5160703896c56a30$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($5160703896c56a30$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$5160703896c56a30$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $5160703896c56a30$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$5160703896c56a30$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $5160703896c56a30$export$8928921ea2d3b126 = $5160703896c56a30$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5160703896c56a30$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $5160703896c56a30$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $5160703896c56a30$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$5160703896c56a30$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $5160703896c56a30$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $5160703896c56a30$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $5160703896c56a30$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $5160703896c56a30$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($5160703896c56a30$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $5160703896c56a30$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($5160703896c56a30$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $5160703896c56a30$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $5160703896c56a30$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($5160703896c56a30$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $5160703896c56a30$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $5160703896c56a30$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $5160703896c56a30$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($5160703896c56a30$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $5160703896c56a30$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $5160703896c56a30$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $5160703896c56a30$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($5160703896c56a30$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $5160703896c56a30$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $f2Y41 = parcelRequire("f2Y41");


var $f2Y41 = parcelRequire("f2Y41");
var $0631dd5e6f33ca0d$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext(null);
var $0631dd5e6f33ca0d$export$2e2bcd8739ae039 = $0631dd5e6f33ca0d$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $420dcb9fd23b7f01$var$defaultNoopBatch(callback) {
    callback();
}
var $420dcb9fd23b7f01$var$batch = $420dcb9fd23b7f01$var$defaultNoopBatch; // Allow injecting another batching function later
var $420dcb9fd23b7f01$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $420dcb9fd23b7f01$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $420dcb9fd23b7f01$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $420dcb9fd23b7f01$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0178e5a97d5c70b0$var$createListenerCollection() {
    var batch = (0, $420dcb9fd23b7f01$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $0178e5a97d5c70b0$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $0178e5a97d5c70b0$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $0178e5a97d5c70b0$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0178e5a97d5c70b0$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0178e5a97d5c70b0$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $f2Y41 = parcelRequire("f2Y41");
var $909dad60b0895555$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $f2Y41.useLayoutEffect) : (0, $f2Y41.useEffect);


function $beddacf0ba12c344$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $f2Y41.useMemo)(function() {
        var subscription = (0, $0178e5a97d5c70b0$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $f2Y41.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $909dad60b0895555$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $beddacf0ba12c344$export$2e2bcd8739ae039 = $beddacf0ba12c344$var$Provider;



var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

var $d6J3N = parcelRequire("d6J3N");

var $f2Y41 = parcelRequire("f2Y41");
var $329cc5d6a4f86c57$exports = {};
"use strict";

$329cc5d6a4f86c57$exports = (parcelRequire("2RV4g"));





var $c8229b42959ce841$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $c8229b42959ce841$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $c8229b42959ce841$var$EMPTY_ARRAY = [];
var $c8229b42959ce841$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c8229b42959ce841$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c8229b42959ce841$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $c8229b42959ce841$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $909dad60b0895555$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $c8229b42959ce841$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c8229b42959ce841$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $c8229b42959ce841$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $c8229b42959ce841$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $bKcdJ.default)(_ref2, $c8229b42959ce841$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $asN9r.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $f2Y41.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $f2Y41.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $bKcdJ.default)(props, $c8229b42959ce841$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $f2Y41.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $329cc5d6a4f86c57$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $f2Y41.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $f2Y41.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $f2Y41.useMemo)(function() {
                if (!shouldHandleStateChanges) return $c8229b42959ce841$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $0178e5a97d5c70b0$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $f2Y41.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $asN9r.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $f2Y41.useReducer)($c8229b42959ce841$var$storeStateUpdatesReducer, $c8229b42959ce841$var$EMPTY_ARRAY, $c8229b42959ce841$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $f2Y41.useRef)();
            var lastWrapperProps = (0, $f2Y41.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $f2Y41.useRef)();
            var renderIsScheduled = (0, $f2Y41.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $c8229b42959ce841$var$useIsomorphicLayoutEffectWithArgs($c8229b42959ce841$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $c8229b42959ce841$var$useIsomorphicLayoutEffectWithArgs($c8229b42959ce841$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $f2Y41.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(WrappedComponent, (0, $asN9r.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $f2Y41.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(Connect, (0, $asN9r.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($d6J3N)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($d6J3N)))(Connect, WrappedComponent);
    };
}




var $asN9r = parcelRequire("asN9r");

var $bKcdJ = parcelRequire("bKcdJ");

function $131a89140131b43b$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $131a89140131b43b$export$2e2bcd8739ae039(objA, objB) {
    if ($131a89140131b43b$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$131a89140131b43b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $df43d7d8efeaca36$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $cdd7c22825110254$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a0dbe5e864accfd6$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $a656cbee747fe042$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $cdd7c22825110254$export$2e2bcd8739ae039)(value)) (0, $a0dbe5e864accfd6$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $fe7e6aac4fc51fff$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $fe7e6aac4fc51fff$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $fe7e6aac4fc51fff$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $fe7e6aac4fc51fff$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $fe7e6aac4fc51fff$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $481fe9ce5ff1ed5f$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $fe7e6aac4fc51fff$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $481fe9ce5ff1ed5f$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $fe7e6aac4fc51fff$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $481fe9ce5ff1ed5f$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $fe7e6aac4fc51fff$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $df43d7d8efeaca36$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $481fe9ce5ff1ed5f$export$2e2bcd8739ae039 = [
    $481fe9ce5ff1ed5f$export$a9f27b4b187c1166,
    $481fe9ce5ff1ed5f$export$ba20d1a7aa0c4a90,
    $481fe9ce5ff1ed5f$export$94a6e55709d4d961
];



function $badac5bb0e7bf468$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $fe7e6aac4fc51fff$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $badac5bb0e7bf468$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $fe7e6aac4fc51fff$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $badac5bb0e7bf468$export$2e2bcd8739ae039 = [
    $badac5bb0e7bf468$export$23fc470827b14aa,
    $badac5bb0e7bf468$export$514bc8c1a53c1d66
];



var $asN9r = parcelRequire("asN9r");

function $4e1a1ec3c24f4b4e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $asN9r.default)({}, ownProps, stateProps, dispatchProps);
}
function $4e1a1ec3c24f4b4e$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $4e1a1ec3c24f4b4e$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $4e1a1ec3c24f4b4e$export$5b105939c84b5234(mergeProps) : undefined;
}
function $4e1a1ec3c24f4b4e$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $4e1a1ec3c24f4b4e$export$691c327fc30bc857;
    } : undefined;
}
var $4e1a1ec3c24f4b4e$export$2e2bcd8739ae039 = [
    $4e1a1ec3c24f4b4e$export$d61b680184bc3f00,
    $4e1a1ec3c24f4b4e$export$a13ba70ef50dda6d
];



var $bKcdJ = parcelRequire("bKcdJ");

function $aa16ca0213bab968$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $a0dbe5e864accfd6$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $aa16ca0213bab968$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $aa16ca0213bab968$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $aa16ca0213bab968$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $aa16ca0213bab968$var$verify(mergeProps, "mergeProps", displayName);
}


var $d5ec017706aa36e8$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $d5ec017706aa36e8$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $d5ec017706aa36e8$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $d5ec017706aa36e8$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $bKcdJ.default)(_ref2, $d5ec017706aa36e8$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $d5ec017706aa36e8$export$d20c0c2ca6eb2b6f : $d5ec017706aa36e8$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $f5fe88794f206302$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $f5fe88794f206302$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $f5fe88794f206302$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $f5fe88794f206302$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $c8229b42959ce841$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $badac5bb0e7bf468$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $481fe9ce5ff1ed5f$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $4e1a1ec3c24f4b4e$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $d5ec017706aa36e8$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $f5fe88794f206302$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $131a89140131b43b$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $131a89140131b43b$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $131a89140131b43b$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $bKcdJ.default)(_ref3, $f5fe88794f206302$var$_excluded);
        var initMapStateToProps = $f5fe88794f206302$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $f5fe88794f206302$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $f5fe88794f206302$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $asN9r.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $f5fe88794f206302$export$2e2bcd8739ae039 = /*#__PURE__*/ $f5fe88794f206302$export$9f9feb656dec1fc4();




var $f2Y41 = parcelRequire("f2Y41");


var $f2Y41 = parcelRequire("f2Y41");

function $a38f08e441a985fe$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $f2Y41.useContext)((0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00));
    return contextValue;
}


function $9ea5cb33123e90be$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00) ? (0, $a38f08e441a985fe$export$c1275ca9a6fd3ec5) : function() {
        return (0, $f2Y41.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $9ea5cb33123e90be$export$6ccbb43953eebf8 = /*#__PURE__*/ $9ea5cb33123e90be$export$671dba69185d0304();


function $289f9c591ae2cf39$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00);
    var useStore = context === (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00) ? (0, $9ea5cb33123e90be$export$6ccbb43953eebf8) : (0, $9ea5cb33123e90be$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $289f9c591ae2cf39$export$8ad76b76a4c905f8 = /*#__PURE__*/ $289f9c591ae2cf39$export$bc9b55530897c558();



var $f2Y41 = parcelRequire("f2Y41");




var $38783ffc5a8a398a$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $38783ffc5a8a398a$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $f2Y41.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $f2Y41.useMemo)(function() {
        return (0, $0178e5a97d5c70b0$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $f2Y41.useRef)();
    var latestSelector = (0, $f2Y41.useRef)();
    var latestStoreState = (0, $f2Y41.useRef)();
    var latestSelectedState = (0, $f2Y41.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $909dad60b0895555$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $909dad60b0895555$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $38783ffc5a8a398a$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $0631dd5e6f33ca0d$export$cc80c08dc91f1c00) ? (0, $a38f08e441a985fe$export$c1275ca9a6fd3ec5) : function() {
        return (0, $f2Y41.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $38783ffc5a8a398a$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $38783ffc5a8a398a$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $f2Y41.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $38783ffc5a8a398a$export$2105062e25df4afe = /*#__PURE__*/ $38783ffc5a8a398a$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $420dcb9fd23b7f01$export$4b9874722d0da7bc)((0, $5021361ff788fb77$exports.unstable_batchedUpdates));



var $f2Y41 = parcelRequire("f2Y41");
function $e2f7239e202f4a73$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $e2f7239e202f4a73$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $f2Y41.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $f2Y41.useRef)(true);
    var committed = (0, $f2Y41.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $e2f7239e202f4a73$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $f2Y41.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $e2f7239e202f4a73$export$33752cf3ee811995(callback, inputs) {
    return $e2f7239e202f4a73$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $e2f7239e202f4a73$export$1538c33de8887b59 = $e2f7239e202f4a73$export$b6feb8998cd9b342;
var $e2f7239e202f4a73$export$35808ee640e87ca7 = $e2f7239e202f4a73$export$33752cf3ee811995;


var $8e8a96fac33c2446$var$isProduction = true;
var $8e8a96fac33c2446$var$prefix = "Invariant failed";
function $8e8a96fac33c2446$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($8e8a96fac33c2446$var$isProduction) throw new Error($8e8a96fac33c2446$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($8e8a96fac33c2446$var$prefix, ": ").concat(provided) : $8e8a96fac33c2446$var$prefix;
    throw new Error(value);
}


var $d12d7887fa40bdf0$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $d12d7887fa40bdf0$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $d12d7887fa40bdf0$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $d12d7887fa40bdf0$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $d12d7887fa40bdf0$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $d12d7887fa40bdf0$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $d12d7887fa40bdf0$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $d12d7887fa40bdf0$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $d12d7887fa40bdf0$var$noSpacing : _ref2$padding;
    var marginBox = $d12d7887fa40bdf0$export$4b834cebd9e5cebe($d12d7887fa40bdf0$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $d12d7887fa40bdf0$export$4b834cebd9e5cebe($d12d7887fa40bdf0$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $d12d7887fa40bdf0$export$4b834cebd9e5cebe($d12d7887fa40bdf0$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $d12d7887fa40bdf0$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $d12d7887fa40bdf0$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8e8a96fac33c2446$export$2e2bcd8739ae039)(false);
    return result;
};
var $d12d7887fa40bdf0$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $d12d7887fa40bdf0$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $d12d7887fa40bdf0$var$shift(borderBox, change);
    return $d12d7887fa40bdf0$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $d12d7887fa40bdf0$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $d12d7887fa40bdf0$var$getWindowScroll();
    return $d12d7887fa40bdf0$export$cc800923e997bb8(original, scroll);
};
var $d12d7887fa40bdf0$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $d12d7887fa40bdf0$var$parse(styles.marginTop),
        right: $d12d7887fa40bdf0$var$parse(styles.marginRight),
        bottom: $d12d7887fa40bdf0$var$parse(styles.marginBottom),
        left: $d12d7887fa40bdf0$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $d12d7887fa40bdf0$var$parse(styles.paddingTop),
        right: $d12d7887fa40bdf0$var$parse(styles.paddingRight),
        bottom: $d12d7887fa40bdf0$var$parse(styles.paddingBottom),
        left: $d12d7887fa40bdf0$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $d12d7887fa40bdf0$var$parse(styles.borderTopWidth),
        right: $d12d7887fa40bdf0$var$parse(styles.borderRightWidth),
        bottom: $d12d7887fa40bdf0$var$parse(styles.borderBottomWidth),
        left: $d12d7887fa40bdf0$var$parse(styles.borderLeftWidth)
    };
    return $d12d7887fa40bdf0$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $d12d7887fa40bdf0$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $d12d7887fa40bdf0$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $e9da44423efd8196$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e9da44423efd8196$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e9da44423efd8196$var$safeIsNaN(first) && $e9da44423efd8196$var$safeIsNaN(second)) return true;
    return false;
}
function $e9da44423efd8196$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e9da44423efd8196$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e9da44423efd8196$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e9da44423efd8196$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e9da44423efd8196$export$2e2bcd8739ae039 = $e9da44423efd8196$var$memoizeOne;


var $39ab0416eb85b8c0$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $39ab0416eb85b8c0$export$2e2bcd8739ae039 = $39ab0416eb85b8c0$var$rafSchd;



var $8c1ced2594b499da$var$isProduction = true;
var $8c1ced2594b499da$var$spacesAndTabs = /[ \t]{2,}/g;
var $8c1ced2594b499da$var$lineStartWithSpaces = /^[ \t]*/gm;
var $8c1ced2594b499da$var$clean = function clean(value) {
    return value.replace($8c1ced2594b499da$var$spacesAndTabs, " ").replace($8c1ced2594b499da$var$lineStartWithSpaces, "").trim();
};
var $8c1ced2594b499da$var$getDevMessage = function getDevMessage(message) {
    return $8c1ced2594b499da$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $8c1ced2594b499da$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $8c1ced2594b499da$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $8c1ced2594b499da$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var $8c1ced2594b499da$var$isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function $8c1ced2594b499da$var$log(type, message) {
    var _console;
    if ($8c1ced2594b499da$var$isProduction) return;
    if (typeof window !== "undefined" && window[$8c1ced2594b499da$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $8c1ced2594b499da$var$getFormattedMessage(message));
}
var $8c1ced2594b499da$var$warning = $8c1ced2594b499da$var$log.bind(null, "warn");
var $8c1ced2594b499da$var$error = $8c1ced2594b499da$var$log.bind(null, "error");
function $8c1ced2594b499da$var$noop() {}
function $8c1ced2594b499da$var$getOptions(shared, fromBinding) {
    return (0, $asN9r.default)({}, shared, {}, fromBinding);
}
function $8c1ced2594b499da$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $8c1ced2594b499da$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $8c1ced2594b499da$var$isProduction$1 = true;
var $8c1ced2594b499da$var$prefix = "Invariant failed";
function $8c1ced2594b499da$var$RbdInvariant(message) {
    this.message = message;
}
$8c1ced2594b499da$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $8c1ced2594b499da$var$invariant(condition, message) {
    if (condition) return;
    if ($8c1ced2594b499da$var$isProduction$1) throw new $8c1ced2594b499da$var$RbdInvariant($8c1ced2594b499da$var$prefix);
    else throw new $8c1ced2594b499da$var$RbdInvariant($8c1ced2594b499da$var$prefix + ": " + (message || ""));
}
var $8c1ced2594b499da$var$ErrorBoundary = function(_React$Component) {
    (0, $c667c70d22b9c5fb$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $8c1ced2594b499da$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $8c1ced2594b499da$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $8c1ced2594b499da$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $8c1ced2594b499da$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Component);
var $8c1ced2594b499da$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $8c1ced2594b499da$var$position = function position(index) {
    return index + 1;
};
var $8c1ced2594b499da$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $8c1ced2594b499da$var$position(start.source.index) + "\n";
};
var $8c1ced2594b499da$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $8c1ced2594b499da$var$position(source.index);
    var endPosition = $8c1ced2594b499da$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $8c1ced2594b499da$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $8c1ced2594b499da$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $8c1ced2594b499da$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $8c1ced2594b499da$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var $8c1ced2594b499da$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $8c1ced2594b499da$var$position(source.index) + "\n";
};
var $8c1ced2594b499da$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + $8c1ced2594b499da$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $8c1ced2594b499da$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $8c1ced2594b499da$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $8c1ced2594b499da$var$returnedToStart(result.source) + "\n  ";
};
var $8c1ced2594b499da$var$preset = {
    dragHandleUsageInstructions: $8c1ced2594b499da$var$dragHandleUsageInstructions,
    onDragStart: $8c1ced2594b499da$var$onDragStart,
    onDragUpdate: $8c1ced2594b499da$var$onDragUpdate,
    onDragEnd: $8c1ced2594b499da$var$onDragEnd
};
var $8c1ced2594b499da$var$origin = {
    x: 0,
    y: 0
};
var $8c1ced2594b499da$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $8c1ced2594b499da$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $8c1ced2594b499da$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $8c1ced2594b499da$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $8c1ced2594b499da$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var $8c1ced2594b499da$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $8c1ced2594b499da$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $8c1ced2594b499da$var$distance(target, point);
    }));
};
var $8c1ced2594b499da$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $8c1ced2594b499da$var$executeClip = function(frame, subject) {
    var result = (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $8c1ced2594b499da$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $8c1ced2594b499da$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $8c1ced2594b499da$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $8c1ced2594b499da$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $8c1ced2594b499da$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $8c1ced2594b499da$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $asN9r.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $8c1ced2594b499da$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $8c1ced2594b499da$var$executeClip(frame.pageMarginBox, target);
    return (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)(target);
};
var $8c1ced2594b499da$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $8c1ced2594b499da$var$scroll(page.marginBox, frame);
    var increased = $8c1ced2594b499da$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $8c1ced2594b499da$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $8c1ced2594b499da$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $8c1ced2594b499da$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $8c1ced2594b499da$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $8c1ced2594b499da$var$negate(scrollDiff);
    var frame = (0, $asN9r.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $8c1ced2594b499da$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $asN9r.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $8c1ced2594b499da$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $8c1ced2594b499da$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $8c1ced2594b499da$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $8c1ced2594b499da$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $8c1ced2594b499da$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $8c1ced2594b499da$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $8c1ced2594b499da$var$toDroppableMap = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $8c1ced2594b499da$var$toDraggableMap = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $8c1ced2594b499da$var$toDroppableList = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(droppables) {
    return $8c1ced2594b499da$var$values(droppables);
});
var $8c1ced2594b499da$var$toDraggableList = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(draggables) {
    return $8c1ced2594b499da$var$values(draggables);
});
var $8c1ced2594b499da$var$getDraggablesInsideDroppable = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $8c1ced2594b499da$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $8c1ced2594b499da$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $8c1ced2594b499da$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $8c1ced2594b499da$var$removeDraggableFromList = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $8c1ced2594b499da$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $8c1ced2594b499da$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $asN9r.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $8c1ced2594b499da$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $8c1ced2594b499da$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $8c1ced2594b499da$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $8c1ced2594b499da$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $8c1ced2594b499da$var$noDisplacedBy = {
    point: $8c1ced2594b499da$var$origin,
    value: 0
};
var $8c1ced2594b499da$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $8c1ced2594b499da$var$noImpact = {
    displaced: $8c1ced2594b499da$var$emptyGroups,
    displacedBy: $8c1ced2594b499da$var$noDisplacedBy,
    at: null
};
var $8c1ced2594b499da$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $8c1ced2594b499da$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $8c1ced2594b499da$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $8c1ced2594b499da$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $8c1ced2594b499da$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $8c1ced2594b499da$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $8c1ced2594b499da$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $8c1ced2594b499da$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var $8c1ced2594b499da$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $8c1ced2594b499da$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $8c1ced2594b499da$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $8c1ced2594b499da$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $8c1ced2594b499da$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $8c1ced2594b499da$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $8c1ced2594b499da$var$origin;
    return $8c1ced2594b499da$var$offsetByPosition(target, displacement);
};
var $8c1ced2594b499da$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $8c1ced2594b499da$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $8c1ced2594b499da$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $8c1ced2594b499da$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $8c1ced2594b499da$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $8c1ced2594b499da$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $8c1ced2594b499da$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $8c1ced2594b499da$var$isVisible((0, $asN9r.default)({}, args, {
        isVisibleThroughFrameFn: $8c1ced2594b499da$var$isPartiallyVisibleThroughFrame
    }));
};
var $8c1ced2594b499da$var$isTotallyVisible = function isTotallyVisible(args) {
    return $8c1ced2594b499da$var$isVisible((0, $asN9r.default)({}, args, {
        isVisibleThroughFrameFn: $8c1ced2594b499da$var$isTotallyVisibleThroughFrame
    }));
};
var $8c1ced2594b499da$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $8c1ced2594b499da$var$isVisible((0, $asN9r.default)({}, args, {
        isVisibleThroughFrameFn: $8c1ced2594b499da$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $8c1ced2594b499da$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $8c1ced2594b499da$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)((0, $d12d7887fa40bdf0$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $8c1ced2594b499da$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $8c1ced2594b499da$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $8c1ced2594b499da$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $8c1ced2594b499da$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $8c1ced2594b499da$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $8c1ced2594b499da$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $8c1ced2594b499da$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $8c1ced2594b499da$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $8c1ced2594b499da$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $8c1ced2594b499da$var$isHomeOf(draggable, destination);
    if (index == null) return $8c1ced2594b499da$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $8c1ced2594b499da$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $8c1ced2594b499da$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $8c1ced2594b499da$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $8c1ced2594b499da$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $8c1ced2594b499da$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $8c1ced2594b499da$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $8c1ced2594b499da$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $8c1ced2594b499da$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $8c1ced2594b499da$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $8c1ced2594b499da$var$invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = $8c1ced2594b499da$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $8c1ced2594b499da$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $8c1ced2594b499da$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $8c1ced2594b499da$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $8c1ced2594b499da$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($8c1ced2594b499da$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $8c1ced2594b499da$var$origin : $8c1ced2594b499da$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $8c1ced2594b499da$var$origin;
};
var $8c1ced2594b499da$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $8c1ced2594b499da$var$tryGetCombine(impact);
    !combine && $8c1ced2594b499da$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $8c1ced2594b499da$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $8c1ced2594b499da$var$add(center, displaceBy);
};
var $8c1ced2594b499da$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $8c1ced2594b499da$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $8c1ced2594b499da$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $8c1ced2594b499da$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $8c1ced2594b499da$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $8c1ced2594b499da$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $8c1ced2594b499da$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $8c1ced2594b499da$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $8c1ced2594b499da$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $8c1ced2594b499da$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $8c1ced2594b499da$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $8c1ced2594b499da$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $8c1ced2594b499da$var$patch(axis.line, moveInto.contentBox[axis.start] + $8c1ced2594b499da$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $8c1ced2594b499da$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $8c1ced2594b499da$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $8c1ced2594b499da$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $8c1ced2594b499da$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($8c1ced2594b499da$var$didStartAfterCritical(closestAfter, afterCritical)) return $8c1ced2594b499da$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $d12d7887fa40bdf0$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $8c1ced2594b499da$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($8c1ced2594b499da$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $d12d7887fa40bdf0$export$cc800923e997bb8)(last.page, $8c1ced2594b499da$var$negate(afterCritical.displacedBy.point));
        return $8c1ced2594b499da$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $8c1ced2594b499da$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $8c1ced2594b499da$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $8c1ced2594b499da$var$add(point, frame.scroll.diff.displacement);
};
var $8c1ced2594b499da$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $8c1ced2594b499da$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $8c1ced2594b499da$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $8c1ced2594b499da$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $8c1ced2594b499da$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $8c1ced2594b499da$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $8c1ced2594b499da$var$scrollViewport = function(viewport, newScroll) {
    var diff = $8c1ced2594b499da$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $8c1ced2594b499da$var$negate(diff);
    var frame = (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $8c1ced2594b499da$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $8c1ced2594b499da$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $8c1ced2594b499da$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $8c1ced2594b499da$var$scrollViewport(viewport, $8c1ced2594b499da$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $8c1ced2594b499da$var$scrollDroppable(destination, $8c1ced2594b499da$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $8c1ced2594b499da$var$getDisplacementGroups({
        afterDragging: $8c1ced2594b499da$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $8c1ced2594b499da$var$getDisplacementGroups({
        afterDragging: $8c1ced2594b499da$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $8c1ced2594b499da$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $asN9r.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $8c1ced2594b499da$var$withViewportDisplacement = function(viewport, point) {
    return $8c1ced2594b499da$var$add(viewport.scroll.diff.displacement, point);
};
var $8c1ced2594b499da$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $8c1ced2594b499da$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $8c1ced2594b499da$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $8c1ced2594b499da$var$add(draggable.client.borderBox.center, offset);
};
var $8c1ced2594b499da$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $8c1ced2594b499da$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $8c1ced2594b499da$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $8c1ced2594b499da$var$isTotallyVisibleOnAxis(args) : $8c1ced2594b499da$var$isTotallyVisible(args);
};
var $8c1ced2594b499da$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $8c1ced2594b499da$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $8c1ced2594b499da$var$isHomeOf(draggable, destination);
    var impact = $8c1ced2594b499da$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $8c1ced2594b499da$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $8c1ced2594b499da$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $8c1ced2594b499da$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $8c1ced2594b499da$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $8c1ced2594b499da$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $8c1ced2594b499da$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $8c1ced2594b499da$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $8c1ced2594b499da$var$invariant(false);
    return rect;
};
var $8c1ced2594b499da$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $8c1ced2594b499da$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $8c1ced2594b499da$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $8c1ced2594b499da$var$isPartiallyVisibleThroughFrame(viewport.frame)($8c1ced2594b499da$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $8c1ced2594b499da$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $8c1ced2594b499da$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $8c1ced2594b499da$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $8c1ced2594b499da$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $8c1ced2594b499da$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $8c1ced2594b499da$var$getKnownActive(droppable)[axis.crossAxisStart] === $8c1ced2594b499da$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $8c1ced2594b499da$var$isWithin($8c1ced2594b499da$var$getKnownActive(droppable)[axis.start], $8c1ced2594b499da$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $8c1ced2594b499da$var$getKnownActive(a)[axis.start] - $8c1ced2594b499da$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $8c1ced2594b499da$var$closest(pageBorderBoxCenter, $8c1ced2594b499da$var$getCorners($8c1ced2594b499da$var$getKnownActive(a)));
        var second = $8c1ced2594b499da$var$closest(pageBorderBoxCenter, $8c1ced2594b499da$var$getCorners($8c1ced2594b499da$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $8c1ced2594b499da$var$getKnownActive(a)[axis.start] - $8c1ced2594b499da$var$getKnownActive(b)[axis.start];
    })[0];
};
var $8c1ced2594b499da$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $8c1ced2594b499da$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $8c1ced2594b499da$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $8c1ced2594b499da$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $8c1ced2594b499da$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $8c1ced2594b499da$var$offsetByPosition(original, $8c1ced2594b499da$var$negate(afterCritical.displacedBy.point)) : original;
};
var $8c1ced2594b499da$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $8c1ced2594b499da$var$isTotallyVisible({
            target: $8c1ced2594b499da$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $8c1ced2594b499da$var$distance(pageBorderBoxCenter, $8c1ced2594b499da$var$withDroppableDisplacement(destination, $8c1ced2594b499da$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $8c1ced2594b499da$var$distance(pageBorderBoxCenter, $8c1ced2594b499da$var$withDroppableDisplacement(destination, $8c1ced2594b499da$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $8c1ced2594b499da$var$getDisplacedBy = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $8c1ced2594b499da$var$patch(axis.line, displacement)
    };
});
var $8c1ced2594b499da$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $8c1ced2594b499da$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $8c1ced2594b499da$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $8c1ced2594b499da$var$patch(axis.line, needsToGrowBy);
};
var $8c1ced2594b499da$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $asN9r.default)({}, frame, {
        scroll: (0, $asN9r.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $8c1ced2594b499da$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$8c1ced2594b499da$var$isHomeOf(draggable, droppable) && $8c1ced2594b499da$var$invariant(false);
    !!droppable.subject.withPlaceholder && $8c1ced2594b499da$var$invariant(false);
    var placeholderSize = $8c1ced2594b499da$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $8c1ced2594b499da$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $8c1ced2594b499da$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $asN9r.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $8c1ced2594b499da$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $8c1ced2594b499da$var$withMaxScroll(frame, maxScroll);
    var subject = $8c1ced2594b499da$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $asN9r.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $8c1ced2594b499da$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $8c1ced2594b499da$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $8c1ced2594b499da$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $asN9r.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $8c1ced2594b499da$var$invariant(false);
    var newFrame = $8c1ced2594b499da$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $8c1ced2594b499da$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $asN9r.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $8c1ced2594b499da$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $8c1ced2594b499da$var$emptyGroups,
            displacedBy: $8c1ced2594b499da$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $8c1ced2594b499da$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $8c1ced2594b499da$var$isHomeOf(draggable, destination) ? destination : $8c1ced2594b499da$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $8c1ced2594b499da$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $8c1ced2594b499da$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $8c1ced2594b499da$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $8c1ced2594b499da$var$emptyGroups,
        index: proposedIndex
    });
};
var $8c1ced2594b499da$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $8c1ced2594b499da$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $8c1ced2594b499da$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $8c1ced2594b499da$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $8c1ced2594b499da$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $8c1ced2594b499da$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $8c1ced2594b499da$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $8c1ced2594b499da$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var $8c1ced2594b499da$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $8c1ced2594b499da$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $8c1ced2594b499da$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $8c1ced2594b499da$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $8c1ced2594b499da$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $8c1ced2594b499da$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $8c1ced2594b499da$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $8c1ced2594b499da$var$isPositionInFrame(frame) {
    var isWithinVertical = $8c1ced2594b499da$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $8c1ced2594b499da$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $8c1ced2594b499da$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $8c1ced2594b499da$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $8c1ced2594b499da$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $8c1ced2594b499da$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $8c1ced2594b499da$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $8c1ced2594b499da$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$8c1ced2594b499da$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($8c1ced2594b499da$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $8c1ced2594b499da$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $8c1ced2594b499da$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $8c1ced2594b499da$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)($8c1ced2594b499da$var$offsetByPosition(rect, point));
};
var $8c1ced2594b499da$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $8c1ced2594b499da$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $8c1ced2594b499da$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $8c1ced2594b499da$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $8c1ced2594b499da$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $8c1ced2594b499da$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $8c1ced2594b499da$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $8c1ced2594b499da$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $8c1ced2594b499da$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $8c1ced2594b499da$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $8c1ced2594b499da$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $8c1ced2594b499da$var$isHomeOf(draggable, destination)
    });
    return $8c1ced2594b499da$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $8c1ced2594b499da$var$combineThresholdDivisor = 4;
var $8c1ced2594b499da$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $8c1ced2594b499da$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $8c1ced2594b499da$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $8c1ced2594b499da$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $8c1ced2594b499da$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $8c1ced2594b499da$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $8c1ced2594b499da$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $8c1ced2594b499da$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $8c1ced2594b499da$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $8c1ced2594b499da$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $8c1ced2594b499da$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $8c1ced2594b499da$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $8c1ced2594b499da$var$withDroppableScroll(destination, pageBorderBox);
    return $8c1ced2594b499da$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $8c1ced2594b499da$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $8c1ced2594b499da$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $asN9r.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $8c1ced2594b499da$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $8c1ced2594b499da$var$whatIsDraggedOver(previousImpact);
    var now = $8c1ced2594b499da$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $8c1ced2594b499da$var$removePlaceholder(lastDroppable);
    return $8c1ced2594b499da$var$patchDroppableMap(droppables, updated);
};
var $8c1ced2594b499da$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $8c1ced2594b499da$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $8c1ced2594b499da$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($8c1ced2594b499da$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $8c1ced2594b499da$var$addPlaceholder(droppable, draggable, draggables);
    return $8c1ced2594b499da$var$patchDroppableMap(cleaned, patched);
};
var $8c1ced2594b499da$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $8c1ced2594b499da$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $8c1ced2594b499da$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $8c1ced2594b499da$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $8c1ced2594b499da$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $8c1ced2594b499da$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, $asN9r.default)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $8c1ced2594b499da$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $8c1ced2594b499da$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $asN9r.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $8c1ced2594b499da$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $8c1ced2594b499da$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $8c1ced2594b499da$var$getDraggables$1(last.all, draggables);
    var displaced = $8c1ced2594b499da$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $asN9r.default)({}, impact, {
        displaced: displaced
    });
};
var $8c1ced2594b499da$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $8c1ced2594b499da$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $8c1ced2594b499da$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $8c1ced2594b499da$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && $8c1ced2594b499da$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $8c1ced2594b499da$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $8c1ced2594b499da$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $8c1ced2594b499da$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $8c1ced2594b499da$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $8c1ced2594b499da$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $8c1ced2594b499da$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $8c1ced2594b499da$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $8c1ced2594b499da$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $8c1ced2594b499da$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $8c1ced2594b499da$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $8c1ced2594b499da$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $8c1ced2594b499da$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $8c1ced2594b499da$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $8c1ced2594b499da$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $8c1ced2594b499da$var$start = function start(key) {};
var $8c1ced2594b499da$var$finish = function finish(key) {};
var $8c1ced2594b499da$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $d12d7887fa40bdf0$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $d12d7887fa40bdf0$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $asN9r.default)({}, draggable, {
        placeholder: (0, $asN9r.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $8c1ced2594b499da$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $8c1ced2594b499da$var$invariant(false);
    return frame;
};
var $8c1ced2594b499da$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $8c1ced2594b499da$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $8c1ced2594b499da$var$add(windowScrollChange, droppableScrollChange);
        var moved = $8c1ced2594b499da$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $8c1ced2594b499da$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $8c1ced2594b499da$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $8c1ced2594b499da$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $asN9r.default)({}, state.dimensions.droppables, {}, $8c1ced2594b499da$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $8c1ced2594b499da$var$toDraggableMap($8c1ced2594b499da$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $asN9r.default)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $8c1ced2594b499da$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $8c1ced2594b499da$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $8c1ced2594b499da$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $8c1ced2594b499da$var$finish();
    var draggingState = (0, $asN9r.default)({
        phase: "DRAGGING"
    }, state, {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, $asN9r.default)({
        phase: "DROP_PENDING"
    }, draggingState, {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $8c1ced2594b499da$var$isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var $8c1ced2594b499da$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $8c1ced2594b499da$var$patchDimensionMap(state.dimensions, updated);
    if (!$8c1ced2594b499da$var$isSnapping(state) || isEnabledChanging) return $8c1ced2594b499da$var$update({
        state: state,
        dimensions: dimensions
    });
    return $8c1ced2594b499da$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $8c1ced2594b499da$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, $asN9r.default)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $8c1ced2594b499da$var$idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $8c1ced2594b499da$var$reducer = function(state, action) {
    if (state === void 0) state = $8c1ced2594b499da$var$idle;
    if (action.type === "FLUSH") return (0, $asN9r.default)({}, $8c1ced2594b499da$var$idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $8c1ced2594b499da$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $8c1ced2594b499da$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $8c1ced2594b499da$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $8c1ced2594b499da$var$add(client.selection, viewport.scroll.initial),
                offset: $8c1ced2594b499da$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $8c1ced2594b499da$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $8c1ced2594b499da$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $8c1ced2594b499da$var$invariant(false);
        var _result = (0, $asN9r.default)({
            phase: "COLLECTING"
        }, state, {
            phase: "COLLECTING"
        });
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $8c1ced2594b499da$var$invariant(false);
        return $8c1ced2594b499da$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$8c1ced2594b499da$var$isMovementAllowed(state) && $8c1ced2594b499da$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($8c1ced2594b499da$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $8c1ced2594b499da$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $8c1ced2594b499da$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $8c1ced2594b499da$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $8c1ced2594b499da$var$removeScrollJumpRequest(state);
        !$8c1ced2594b499da$var$isMovementAllowed(state) && $8c1ced2594b499da$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $8c1ced2594b499da$var$scrollDroppable(target, newScroll);
        return $8c1ced2594b499da$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$8c1ced2594b499da$var$isMovementAllowed(state) && $8c1ced2594b499da$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $8c1ced2594b499da$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $8c1ced2594b499da$var$invariant(false);
        var updated = (0, $asN9r.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $8c1ced2594b499da$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$8c1ced2594b499da$var$isMovementAllowed(state) && $8c1ced2594b499da$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $8c1ced2594b499da$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $8c1ced2594b499da$var$invariant(false);
        var _updated = (0, $asN9r.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $8c1ced2594b499da$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$8c1ced2594b499da$var$isMovementAllowed(state) && $8c1ced2594b499da$var$invariant(false);
        !state.isWindowScrollAllowed && $8c1ced2594b499da$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($8c1ced2594b499da$var$isEqual(state.viewport.scroll.current, _newScroll)) return $8c1ced2594b499da$var$removeScrollJumpRequest(state);
        var _viewport = $8c1ced2594b499da$var$scrollViewport(state.viewport, _newScroll);
        if ($8c1ced2594b499da$var$isSnapping(state)) return $8c1ced2594b499da$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $8c1ced2594b499da$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$8c1ced2594b499da$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($8c1ced2594b499da$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $asN9r.default)({}, state.viewport, {
            scroll: (0, $asN9r.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $asN9r.default)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $8c1ced2594b499da$var$invariant(false);
        var _result2 = $8c1ced2594b499da$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $8c1ced2594b499da$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $8c1ced2594b499da$var$invariant(false);
        var newState = (0, $asN9r.default)({
            phase: "DROP_PENDING"
        }, state, {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $8c1ced2594b499da$var$invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $8c1ced2594b499da$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var $8c1ced2594b499da$var$lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var $8c1ced2594b499da$var$initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var $8c1ced2594b499da$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var $8c1ced2594b499da$var$collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var $8c1ced2594b499da$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var $8c1ced2594b499da$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var $8c1ced2594b499da$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var $8c1ced2594b499da$var$move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var $8c1ced2594b499da$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var $8c1ced2594b499da$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var $8c1ced2594b499da$var$moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var $8c1ced2594b499da$var$moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var $8c1ced2594b499da$var$moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var $8c1ced2594b499da$var$moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var $8c1ced2594b499da$var$flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var $8c1ced2594b499da$var$animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var $8c1ced2594b499da$var$completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var $8c1ced2594b499da$var$drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var $8c1ced2594b499da$var$dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var $8c1ced2594b499da$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function $8c1ced2594b499da$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function $8c1ced2594b499da$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $8c1ced2594b499da$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($8c1ced2594b499da$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $8c1ced2594b499da$var$invariant(false);
                dispatch($8c1ced2594b499da$var$flush());
                dispatch($8c1ced2594b499da$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $8c1ced2594b499da$var$validateDimensions(critical, dimensions);
                dispatch($8c1ced2594b499da$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $8c1ced2594b499da$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var $8c1ced2594b499da$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var $8c1ced2594b499da$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $8c1ced2594b499da$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $8c1ced2594b499da$var$outOfTheWayTiming = $8c1ced2594b499da$var$timings.outOfTheWay + "s " + $8c1ced2594b499da$var$curves.outOfTheWay;
var $8c1ced2594b499da$var$transitions = {
    fluid: "opacity " + $8c1ced2594b499da$var$outOfTheWayTiming,
    snap: "transform " + $8c1ced2594b499da$var$outOfTheWayTiming + ", opacity " + $8c1ced2594b499da$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $8c1ced2594b499da$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $8c1ced2594b499da$var$outOfTheWayTiming,
    placeholder: "height " + $8c1ced2594b499da$var$outOfTheWayTiming + ", width " + $8c1ced2594b499da$var$outOfTheWayTiming + ", margin " + $8c1ced2594b499da$var$outOfTheWayTiming
};
var $8c1ced2594b499da$var$moveTo = function moveTo(offset) {
    return $8c1ced2594b499da$var$isEqual(offset, $8c1ced2594b499da$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $8c1ced2594b499da$var$transforms = {
    moveTo: $8c1ced2594b499da$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $8c1ced2594b499da$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $8c1ced2594b499da$var$combine.scale.drop + ")";
    }
};
var $8c1ced2594b499da$var$minDropTime = $8c1ced2594b499da$var$timings.minDropTime, $8c1ced2594b499da$var$maxDropTime = $8c1ced2594b499da$var$timings.maxDropTime;
var $8c1ced2594b499da$var$dropTimeRange = $8c1ced2594b499da$var$maxDropTime - $8c1ced2594b499da$var$minDropTime;
var $8c1ced2594b499da$var$maxDropTimeAtDistance = 1500;
var $8c1ced2594b499da$var$cancelDropModifier = 0.6;
var $8c1ced2594b499da$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $8c1ced2594b499da$var$distance(current, destination);
    if (distance$1 <= 0) return $8c1ced2594b499da$var$minDropTime;
    if (distance$1 >= $8c1ced2594b499da$var$maxDropTimeAtDistance) return $8c1ced2594b499da$var$maxDropTime;
    var percentage = distance$1 / $8c1ced2594b499da$var$maxDropTimeAtDistance;
    var duration = $8c1ced2594b499da$var$minDropTime + $8c1ced2594b499da$var$dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * $8c1ced2594b499da$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $8c1ced2594b499da$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $8c1ced2594b499da$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $8c1ced2594b499da$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $8c1ced2594b499da$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $8c1ced2594b499da$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = $8c1ced2594b499da$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $asN9r.default)({}, lastImpact, {
        displaced: $8c1ced2594b499da$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $8c1ced2594b499da$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($8c1ced2594b499da$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $8c1ced2594b499da$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $8c1ced2594b499da$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $8c1ced2594b499da$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $8c1ced2594b499da$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $8c1ced2594b499da$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $8c1ced2594b499da$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$8c1ced2594b499da$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($8c1ced2594b499da$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $8c1ced2594b499da$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($8c1ced2594b499da$var$animateDrop(args));
        };
    };
};
var $8c1ced2594b499da$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $8c1ced2594b499da$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $8c1ced2594b499da$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($8c1ced2594b499da$var$getWindowScroll());
    }
    var scheduled = (0, $39ab0416eb85b8c0$export$2e2bcd8739ae039)(updateScroll);
    var binding = $8c1ced2594b499da$var$getWindowScrollBinding(scheduled);
    var unbind = $8c1ced2594b499da$var$noop;
    function isActive() {
        return unbind !== $8c1ced2594b499da$var$noop;
    }
    function start() {
        !!isActive() && $8c1ced2594b499da$var$invariant(false);
        unbind = $8c1ced2594b499da$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $8c1ced2594b499da$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $8c1ced2594b499da$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $8c1ced2594b499da$var$shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $8c1ced2594b499da$var$scrollListener = function(store) {
    var listener = $8c1ced2594b499da$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($8c1ced2594b499da$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $8c1ced2594b499da$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $8c1ced2594b499da$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $8c1ced2594b499da$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $8c1ced2594b499da$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $8c1ced2594b499da$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $8c1ced2594b499da$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $8c1ced2594b499da$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $8c1ced2594b499da$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $8c1ced2594b499da$var$withTimings = function withTimings(key, fn) {
    $8c1ced2594b499da$var$start();
    fn();
    $8c1ced2594b499da$var$finish();
};
var $8c1ced2594b499da$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $8c1ced2594b499da$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $8c1ced2594b499da$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $8c1ced2594b499da$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $8c1ced2594b499da$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $8c1ced2594b499da$var$invariant(false);
        $8c1ced2594b499da$var$withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $8c1ced2594b499da$var$invariant(false);
        $8c1ced2594b499da$var$withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($8c1ced2594b499da$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $8c1ced2594b499da$var$invariant(false);
        var data = $8c1ced2594b499da$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $8c1ced2594b499da$var$withTimings("onDragStart", function() {
                return $8c1ced2594b499da$var$execute(getResponders().onDragStart, data, announce, $8c1ced2594b499da$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $8c1ced2594b499da$var$tryGetDestination(impact);
        var combine = $8c1ced2594b499da$var$tryGetCombine(impact);
        !dragging && $8c1ced2594b499da$var$invariant(false);
        var hasCriticalChanged = !$8c1ced2594b499da$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$8c1ced2594b499da$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$8c1ced2594b499da$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $asN9r.default)({}, $8c1ced2594b499da$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $8c1ced2594b499da$var$withTimings("onDragUpdate", function() {
                return $8c1ced2594b499da$var$execute(getResponders().onDragUpdate, data, announce, $8c1ced2594b499da$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $8c1ced2594b499da$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $8c1ced2594b499da$var$invariant(false);
        dragging = null;
        $8c1ced2594b499da$var$withTimings("onDragEnd", function() {
            return $8c1ced2594b499da$var$execute(getResponders().onDragEnd, result, announce, $8c1ced2594b499da$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $asN9r.default)({}, $8c1ced2594b499da$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $8c1ced2594b499da$var$responders = function(getResponders, announce) {
    var publisher = $8c1ced2594b499da$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $8c1ced2594b499da$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $8c1ced2594b499da$var$invariant(false);
            store.dispatch($8c1ced2594b499da$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $8c1ced2594b499da$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($8c1ced2594b499da$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $8c1ced2594b499da$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $8c1ced2594b499da$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $8c1ced2594b499da$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $8c1ced2594b499da$var$shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $8c1ced2594b499da$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($8c1ced2594b499da$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && $8c1ced2594b499da$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $8c1ced2594b499da$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($8c1ced2594b499da$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $8c1ced2594b499da$var$composeEnhancers = (0, $5160703896c56a30$export$f672e0b6f7222cd7);
var $8c1ced2594b499da$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $5160703896c56a30$export$f51a9068ac82ea43)($8c1ced2594b499da$var$reducer, $8c1ced2594b499da$var$composeEnhancers((0, $5160703896c56a30$export$9ff26e0402cc7b7)($8c1ced2594b499da$var$style(styleMarshal), $8c1ced2594b499da$var$dimensionMarshalStopper(dimensionMarshal), $8c1ced2594b499da$var$lift$1(dimensionMarshal), $8c1ced2594b499da$var$drop$1, $8c1ced2594b499da$var$dropAnimationFinish, $8c1ced2594b499da$var$dropAnimationFlushOnScroll, $8c1ced2594b499da$var$pendingDrop, $8c1ced2594b499da$var$autoScroll(autoScroller), $8c1ced2594b499da$var$scrollListener, $8c1ced2594b499da$var$focus(focusMarshal), $8c1ced2594b499da$var$responders(getResponders, announce))));
};
var $8c1ced2594b499da$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $8c1ced2594b499da$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $8c1ced2594b499da$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $8c1ced2594b499da$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($8c1ced2594b499da$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $8c1ced2594b499da$var$clean$1();
            $8c1ced2594b499da$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $8c1ced2594b499da$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $8c1ced2594b499da$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $8c1ced2594b499da$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $8c1ced2594b499da$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $8c1ced2594b499da$var$invariant(false);
    return doc;
};
var $8c1ced2594b499da$var$getMaxWindowScroll = function() {
    var doc = $8c1ced2594b499da$var$getDocumentElement();
    var maxScroll = $8c1ced2594b499da$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $8c1ced2594b499da$var$getViewport = function() {
    var scroll = $8c1ced2594b499da$var$getWindowScroll();
    var maxScroll = $8c1ced2594b499da$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $8c1ced2594b499da$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $8c1ced2594b499da$var$origin,
                displacement: $8c1ced2594b499da$var$origin
            }
        }
    };
    return viewport;
};
var $8c1ced2594b499da$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $8c1ced2594b499da$var$start();
    var viewport = $8c1ced2594b499da$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $8c1ced2594b499da$var$toDraggableMap(draggables),
        droppables: $8c1ced2594b499da$var$toDroppableMap(droppables)
    };
    $8c1ced2594b499da$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $8c1ced2594b499da$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $8c1ced2594b499da$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $8c1ced2594b499da$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $8c1ced2594b499da$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $8c1ced2594b499da$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $8c1ced2594b499da$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $8c1ced2594b499da$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($8c1ced2594b499da$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($8c1ced2594b499da$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $8c1ced2594b499da$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $8c1ced2594b499da$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $8c1ced2594b499da$var$canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $8c1ced2594b499da$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $8c1ced2594b499da$var$getScrollableDroppables = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(droppables) {
    return $8c1ced2594b499da$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $8c1ced2594b499da$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $8c1ced2594b499da$var$find($8c1ced2594b499da$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $8c1ced2594b499da$var$invariant(false);
        return $8c1ced2594b499da$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $8c1ced2594b499da$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $8c1ced2594b499da$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $8c1ced2594b499da$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $8c1ced2594b499da$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $8c1ced2594b499da$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $8c1ced2594b499da$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $8c1ced2594b499da$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $8c1ced2594b499da$var$minScroll = 1;
var $8c1ced2594b499da$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $8c1ced2594b499da$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $8c1ced2594b499da$var$minScroll;
    var percentageFromMaxScrollValueAt = $8c1ced2594b499da$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $8c1ced2594b499da$var$config.maxPixelScroll * $8c1ced2594b499da$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $8c1ced2594b499da$var$accelerateAt = $8c1ced2594b499da$var$config.durationDampening.accelerateAt;
var $8c1ced2594b499da$var$stopAt = $8c1ced2594b499da$var$config.durationDampening.stopDampeningAt;
var $8c1ced2594b499da$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $8c1ced2594b499da$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $8c1ced2594b499da$var$stopAt) return proposedScroll;
    if (runTime < $8c1ced2594b499da$var$accelerateAt) return $8c1ced2594b499da$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $8c1ced2594b499da$var$getPercentage({
        startOfRange: $8c1ced2594b499da$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $8c1ced2594b499da$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $8c1ced2594b499da$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $8c1ced2594b499da$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($8c1ced2594b499da$var$dampenValueByTime(scroll, dragStartTime), $8c1ced2594b499da$var$minScroll);
};
var $8c1ced2594b499da$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $8c1ced2594b499da$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $8c1ced2594b499da$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $8c1ced2594b499da$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $8c1ced2594b499da$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $8c1ced2594b499da$var$clean$2 = $8c1ced2594b499da$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $8c1ced2594b499da$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $8c1ced2594b499da$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $8c1ced2594b499da$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $8c1ced2594b499da$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $8c1ced2594b499da$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $8c1ced2594b499da$var$clean$2({
        x: x,
        y: y
    });
    if ($8c1ced2594b499da$var$isEqual(required, $8c1ced2594b499da$var$origin)) return null;
    var limited = $8c1ced2594b499da$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $8c1ced2594b499da$var$isEqual(limited, $8c1ced2594b499da$var$origin) ? null : limited;
};
var $8c1ced2594b499da$var$smallestSigned = $8c1ced2594b499da$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $8c1ced2594b499da$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $8c1ced2594b499da$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($8c1ced2594b499da$var$isEqual(overlap, $8c1ced2594b499da$var$origin)) return null;
        return overlap;
    };
}();
var $8c1ced2594b499da$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $8c1ced2594b499da$var$smallestSigned(change);
    var overlap = $8c1ced2594b499da$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $8c1ced2594b499da$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $8c1ced2594b499da$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $8c1ced2594b499da$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$8c1ced2594b499da$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $8c1ced2594b499da$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $8c1ced2594b499da$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $8c1ced2594b499da$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $8c1ced2594b499da$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$8c1ced2594b499da$var$canScrollDroppable(droppable, change)) return null;
    return $8c1ced2594b499da$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $8c1ced2594b499da$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $8c1ced2594b499da$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $8c1ced2594b499da$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $8c1ced2594b499da$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $8c1ced2594b499da$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $8c1ced2594b499da$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $8c1ced2594b499da$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $8c1ced2594b499da$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $8c1ced2594b499da$var$getBestScrollableDroppable({
        center: center,
        destination: $8c1ced2594b499da$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $8c1ced2594b499da$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $8c1ced2594b499da$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $39ab0416eb85b8c0$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $39ab0416eb85b8c0$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $8c1ced2594b499da$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $8c1ced2594b499da$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $8c1ced2594b499da$var$start();
        !!dragging && $8c1ced2594b499da$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $8c1ced2594b499da$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $8c1ced2594b499da$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $8c1ced2594b499da$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $8c1ced2594b499da$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$8c1ced2594b499da$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $8c1ced2594b499da$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $8c1ced2594b499da$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $8c1ced2594b499da$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$8c1ced2594b499da$var$canScrollWindow(viewport, change)) return change;
        var overlap = $8c1ced2594b499da$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $8c1ced2594b499da$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $8c1ced2594b499da$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $8c1ced2594b499da$var$whatIsDraggedOver(state.impact);
        !destination && $8c1ced2594b499da$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $8c1ced2594b499da$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $8c1ced2594b499da$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $8c1ced2594b499da$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $8c1ced2594b499da$var$prefix$1 = "data-rbd";
var $8c1ced2594b499da$var$dragHandle = function() {
    var base = $8c1ced2594b499da$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $8c1ced2594b499da$var$draggable = function() {
    var base = $8c1ced2594b499da$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $8c1ced2594b499da$var$droppable = function() {
    var base = $8c1ced2594b499da$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $8c1ced2594b499da$var$scrollContainer = {
    contextId: $8c1ced2594b499da$var$prefix$1 + "-scroll-container-context-id"
};
var $8c1ced2594b499da$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var $8c1ced2594b499da$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var $8c1ced2594b499da$var$noPointerEvents = "pointer-events: none;";
var $8c1ced2594b499da$var$getStyles$1 = function(contextId) {
    var getSelector = $8c1ced2594b499da$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($8c1ced2594b499da$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $8c1ced2594b499da$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $8c1ced2594b499da$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($8c1ced2594b499da$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($8c1ced2594b499da$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $8c1ced2594b499da$var$getStyles(rules, "always"),
        resting: $8c1ced2594b499da$var$getStyles(rules, "resting"),
        dragging: $8c1ced2594b499da$var$getStyles(rules, "dragging"),
        dropAnimating: $8c1ced2594b499da$var$getStyles(rules, "dropAnimating"),
        userCancel: $8c1ced2594b499da$var$getStyles(rules, "userCancel")
    };
};
var $8c1ced2594b499da$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $f2Y41.useLayoutEffect) : (0, $f2Y41.useEffect);
var $8c1ced2594b499da$var$getHead = function getHead() {
    var head = document.querySelector("head");
    !head && $8c1ced2594b499da$var$invariant(false);
    return head;
};
var $8c1ced2594b499da$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $8c1ced2594b499da$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return $8c1ced2594b499da$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $f2Y41.useRef)(null);
    var dynamicRef = (0, $f2Y41.useRef)(null);
    var setDynamicStyle = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)((0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $8c1ced2594b499da$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && $8c1ced2594b499da$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $8c1ced2594b499da$var$invariant(false);
        var always = $8c1ced2594b499da$var$createStyleEl(nonce);
        var dynamic = $8c1ced2594b499da$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($8c1ced2594b499da$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($8c1ced2594b499da$var$prefix$1 + "-dynamic", contextId);
        $8c1ced2594b499da$var$getHead().appendChild(always);
        $8c1ced2594b499da$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $8c1ced2594b499da$var$invariant(false);
                $8c1ced2594b499da$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $8c1ced2594b499da$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $8c1ced2594b499da$var$isHtmlElement(el) {
    return el instanceof $8c1ced2594b499da$var$getWindowFromEl(el).HTMLElement;
}
function $8c1ced2594b499da$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $8c1ced2594b499da$var$dragHandle.contextId + '="' + contextId + '"]';
    var possible = $8c1ced2594b499da$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $8c1ced2594b499da$var$find(possible, function(el) {
        return el.getAttribute($8c1ced2594b499da$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$8c1ced2594b499da$var$isHtmlElement(handle)) return null;
    return handle;
}
function $8c1ced2594b499da$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $f2Y41.useRef)({});
    var recordRef = (0, $f2Y41.useRef)(null);
    var restoreFocusFrameRef = (0, $f2Y41.useRef)(null);
    var isMountedRef = (0, $f2Y41.useRef)(false);
    var register = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $8c1ced2594b499da$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($8c1ced2594b499da$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $8c1ced2594b499da$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $8c1ced2594b499da$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $8c1ced2594b499da$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $8c1ced2594b499da$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $8c1ced2594b499da$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $8c1ced2594b499da$var$useRegistry() {
    var registry = (0, $e2f7239e202f4a73$export$1538c33de8887b59)($8c1ced2594b499da$var$createRegistry, []);
    (0, $f2Y41.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $8c1ced2594b499da$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext(null);
var $8c1ced2594b499da$var$getBodyElement = function() {
    var body = document.body;
    !body && $8c1ced2594b499da$var$invariant(false);
    return body;
};
var $8c1ced2594b499da$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $8c1ced2594b499da$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $8c1ced2594b499da$var$useAnnouncer(contextId) {
    var id = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return $8c1ced2594b499da$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $f2Y41.useRef)(null);
    (0, $f2Y41.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $asN9r.default)(el.style, $8c1ced2594b499da$var$visuallyHidden);
        $8c1ced2594b499da$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $8c1ced2594b499da$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $8c1ced2594b499da$var$count = 0;
var $8c1ced2594b499da$var$defaults = {
    separator: "::"
};
function $8c1ced2594b499da$var$reset() {
    $8c1ced2594b499da$var$count = 0;
}
function $8c1ced2594b499da$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $8c1ced2594b499da$var$defaults;
    return (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return "" + prefix + options.separator + $8c1ced2594b499da$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $8c1ced2594b499da$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $8c1ced2594b499da$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $8c1ced2594b499da$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    var id = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return $8c1ced2594b499da$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $f2Y41.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $8c1ced2594b499da$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $8c1ced2594b499da$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $8c1ced2594b499da$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext(null);
var $8c1ced2594b499da$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var $8c1ced2594b499da$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $8c1ced2594b499da$var$getVersion = function getVersion(value) {
    var result = $8c1ced2594b499da$var$semver.exec(value);
    !(result != null) && $8c1ced2594b499da$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $8c1ced2594b499da$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $8c1ced2594b499da$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $8c1ced2594b499da$var$getVersion(peerDepValue);
    var actual = $8c1ced2594b499da$var$getVersion(actualValue);
    if ($8c1ced2594b499da$var$isSatisfied(peerDep, actual)) return;
};
var $8c1ced2594b499da$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $8c1ced2594b499da$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $8c1ced2594b499da$var$useDev(useHook) {}
function $8c1ced2594b499da$var$useDevSetupWarning(fn, inputs) {
    $8c1ced2594b499da$var$useDev(function() {
        (0, $f2Y41.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $8c1ced2594b499da$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $8c1ced2594b499da$var$useStartupValidation() {
    $8c1ced2594b499da$var$useDevSetupWarning(function() {
        $8c1ced2594b499da$var$checkReactVersion($8c1ced2594b499da$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).version);
        $8c1ced2594b499da$var$checkDoctype(document);
    }, []);
}
function $8c1ced2594b499da$var$usePrevious(current) {
    var ref = (0, $f2Y41.useRef)(current);
    (0, $f2Y41.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $8c1ced2594b499da$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $8c1ced2594b499da$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $8c1ced2594b499da$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $8c1ced2594b499da$var$tab = 9;
var $8c1ced2594b499da$var$enter = 13;
var $8c1ced2594b499da$var$escape = 27;
var $8c1ced2594b499da$var$space = 32;
var $8c1ced2594b499da$var$pageUp = 33;
var $8c1ced2594b499da$var$pageDown = 34;
var $8c1ced2594b499da$var$end = 35;
var $8c1ced2594b499da$var$home = 36;
var $8c1ced2594b499da$var$arrowLeft = 37;
var $8c1ced2594b499da$var$arrowUp = 38;
var $8c1ced2594b499da$var$arrowRight = 39;
var $8c1ced2594b499da$var$arrowDown = 40;
var $8c1ced2594b499da$var$_preventedKeys;
var $8c1ced2594b499da$var$preventedKeys = ($8c1ced2594b499da$var$_preventedKeys = {}, $8c1ced2594b499da$var$_preventedKeys[$8c1ced2594b499da$var$enter] = true, $8c1ced2594b499da$var$_preventedKeys[$8c1ced2594b499da$var$tab] = true, $8c1ced2594b499da$var$_preventedKeys);
var $8c1ced2594b499da$var$preventStandardKeyEvents = function(event) {
    if ($8c1ced2594b499da$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $8c1ced2594b499da$var$supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $8c1ced2594b499da$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $8c1ced2594b499da$var$primaryButton = 0;
var $8c1ced2594b499da$var$sloppyClickThreshold = 5;
function $8c1ced2594b499da$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $8c1ced2594b499da$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $8c1ced2594b499da$var$sloppyClickThreshold;
}
var $8c1ced2594b499da$var$idle$1 = {
    type: "IDLE"
};
function $8c1ced2594b499da$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $8c1ced2594b499da$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $8c1ced2594b499da$var$invariant(false);
                var pending = phase.point;
                if (!$8c1ced2594b499da$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $8c1ced2594b499da$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $8c1ced2594b499da$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $8c1ced2594b499da$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $8c1ced2594b499da$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $f2Y41.useRef)($8c1ced2594b499da$var$idle$1);
    var unbindEventsRef = (0, $f2Y41.useRef)($8c1ced2594b499da$var$noop);
    var startCaptureBinding = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $8c1ced2594b499da$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $8c1ced2594b499da$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $8c1ced2594b499da$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $8c1ced2594b499da$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $8c1ced2594b499da$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $8c1ced2594b499da$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $8c1ced2594b499da$var$_scrollJumpKeys;
function $8c1ced2594b499da$var$noop$1() {}
var $8c1ced2594b499da$var$scrollJumpKeys = ($8c1ced2594b499da$var$_scrollJumpKeys = {}, $8c1ced2594b499da$var$_scrollJumpKeys[$8c1ced2594b499da$var$pageDown] = true, $8c1ced2594b499da$var$_scrollJumpKeys[$8c1ced2594b499da$var$pageUp] = true, $8c1ced2594b499da$var$_scrollJumpKeys[$8c1ced2594b499da$var$home] = true, $8c1ced2594b499da$var$_scrollJumpKeys[$8c1ced2594b499da$var$end] = true, $8c1ced2594b499da$var$_scrollJumpKeys);
function $8c1ced2594b499da$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === $8c1ced2594b499da$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($8c1ced2594b499da$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $8c1ced2594b499da$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $8c1ced2594b499da$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $8c1ced2594b499da$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $f2Y41.useRef)($8c1ced2594b499da$var$noop$1);
    var startCaptureBinding = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $8c1ced2594b499da$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $8c1ced2594b499da$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $8c1ced2594b499da$var$bindEvents(window, $8c1ced2594b499da$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $8c1ced2594b499da$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $8c1ced2594b499da$var$idle$2 = {
    type: "IDLE"
};
var $8c1ced2594b499da$var$timeForLongPress = 120;
var $8c1ced2594b499da$var$forcePressThreshold = 0.15;
function $8c1ced2594b499da$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $8c1ced2594b499da$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $8c1ced2594b499da$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $8c1ced2594b499da$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $8c1ced2594b499da$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $8c1ced2594b499da$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $8c1ced2594b499da$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $8c1ced2594b499da$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $f2Y41.useRef)($8c1ced2594b499da$var$idle$2);
    var unbindEventsRef = (0, $f2Y41.useRef)($8c1ced2594b499da$var$noop);
    var getPhase = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $8c1ced2594b499da$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($8c1ced2594b499da$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $8c1ced2594b499da$var$bindEvents(window, $8c1ced2594b499da$var$getHandleBindings(args), options);
        var unbindWindow = $8c1ced2594b499da$var$bindEvents(window, $8c1ced2594b499da$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && $8c1ced2594b499da$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $8c1ced2594b499da$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $8c1ced2594b499da$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($8c1ced2594b499da$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $8c1ced2594b499da$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $8c1ced2594b499da$var$useValidateSensorHooks(sensorHooks) {
    $8c1ced2594b499da$var$useDev(function() {
        var previousRef = $8c1ced2594b499da$var$usePrevious(sensorHooks);
        $8c1ced2594b499da$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $8c1ced2594b499da$var$invariant(false);
        });
    });
}
var $8c1ced2594b499da$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $8c1ced2594b499da$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($8c1ced2594b499da$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $8c1ced2594b499da$var$isAnInteractiveElement(parent, current.parentElement);
}
function $8c1ced2594b499da$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$8c1ced2594b499da$var$isHtmlElement(target)) return false;
    return $8c1ced2594b499da$var$isAnInteractiveElement(draggable, target);
}
var $8c1ced2594b499da$var$getBorderBoxCenterPosition = function(el) {
    return (0, $d12d7887fa40bdf0$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $8c1ced2594b499da$var$isElement(el) {
    return el instanceof $8c1ced2594b499da$var$getWindowFromEl(el).Element;
}
var $8c1ced2594b499da$var$supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = $8c1ced2594b499da$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $8c1ced2594b499da$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$8c1ced2594b499da$var$supportedMatchesName](selector)) return el;
    return $8c1ced2594b499da$var$closestPonyfill(el.parentElement, selector);
}
function $8c1ced2594b499da$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $8c1ced2594b499da$var$closestPonyfill(el, selector);
}
function $8c1ced2594b499da$var$getSelector(contextId) {
    return "[" + $8c1ced2594b499da$var$dragHandle.contextId + '="' + contextId + '"]';
}
function $8c1ced2594b499da$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$8c1ced2594b499da$var$isElement(target)) return null;
    var selector = $8c1ced2594b499da$var$getSelector(contextId);
    var handle = $8c1ced2594b499da$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$8c1ced2594b499da$var$isHtmlElement(handle)) return null;
    return handle;
}
function $8c1ced2594b499da$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $8c1ced2594b499da$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($8c1ced2594b499da$var$dragHandle.draggableId);
}
function $8c1ced2594b499da$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $8c1ced2594b499da$var$draggable.contextId + '="' + contextId + '"]';
    var possible = $8c1ced2594b499da$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $8c1ced2594b499da$var$find(possible, function(el) {
        return el.getAttribute($8c1ced2594b499da$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$8c1ced2594b499da$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $8c1ced2594b499da$var$preventDefault(event) {
    event.preventDefault();
}
function $8c1ced2594b499da$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $8c1ced2594b499da$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$8c1ced2594b499da$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $8c1ced2594b499da$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $8c1ced2594b499da$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $8c1ced2594b499da$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $8c1ced2594b499da$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $8c1ced2594b499da$var$noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($8c1ced2594b499da$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && $8c1ced2594b499da$var$invariant(false);
        }
        store.dispatch($8c1ced2594b499da$var$lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $8c1ced2594b499da$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $8c1ced2594b499da$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($8c1ced2594b499da$var$drop({
                reason: reason
            }));
        }
        return (0, $asN9r.default)({
            isActive: function isActive() {
                return $8c1ced2594b499da$var$_isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $39ab0416eb85b8c0$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $8c1ced2594b499da$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $asN9r.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($8c1ced2594b499da$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($8c1ced2594b499da$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($8c1ced2594b499da$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($8c1ced2594b499da$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $8c1ced2594b499da$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $8c1ced2594b499da$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $8c1ced2594b499da$var$_isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $8c1ced2594b499da$var$_isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $8c1ced2594b499da$var$defaultSensors = [
    $8c1ced2594b499da$export$2f59cd992b42195a,
    $8c1ced2594b499da$export$42b74264faad0714,
    $8c1ced2594b499da$export$ac235fd3a7bcf7b4
];
function $8c1ced2594b499da$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $8c1ced2594b499da$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $f2Y41.useState)(function() {
        return $8c1ced2594b499da$var$create();
    })[0];
    var tryAbandonLock = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(draggableId) {
        return $8c1ced2594b499da$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(draggableId, forceStop, options) {
        return $8c1ced2594b499da$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(event) {
        return $8c1ced2594b499da$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($8c1ced2594b499da$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $8c1ced2594b499da$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $8c1ced2594b499da$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $8c1ced2594b499da$var$getStore(lazyRef) {
    !lazyRef.current && $8c1ced2594b499da$var$invariant(false);
    return lazyRef.current;
}
function $8c1ced2594b499da$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $f2Y41.useRef)(null);
    $8c1ced2594b499da$var$useStartupValidation();
    var lastPropsRef = $8c1ced2594b499da$var$usePrevious(props);
    var getResponders = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        return $8c1ced2594b499da$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $8c1ced2594b499da$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $8c1ced2594b499da$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $8c1ced2594b499da$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(action) {
        $8c1ced2594b499da$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return (0, $5160703896c56a30$export$aea084d96e84da92)({
            publishWhileDragging: $8c1ced2594b499da$var$publishWhileDragging,
            updateDroppableScroll: $8c1ced2594b499da$var$updateDroppableScroll,
            updateDroppableIsEnabled: $8c1ced2594b499da$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $8c1ced2594b499da$var$updateDroppableIsCombineEnabled,
            collectionStarting: $8c1ced2594b499da$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $8c1ced2594b499da$var$useRegistry();
    var dimensionMarshal = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return $8c1ced2594b499da$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return $8c1ced2594b499da$var$createAutoScroller((0, $asN9r.default)({
            scrollWindow: $8c1ced2594b499da$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $5160703896c56a30$export$aea084d96e84da92)({
            move: $8c1ced2594b499da$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $8c1ced2594b499da$var$useFocusMarshal(contextId);
    var store = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return $8c1ced2594b499da$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var current = $8c1ced2594b499da$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($8c1ced2594b499da$var$flush());
    }, []);
    var isDragging = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var state = $8c1ced2594b499da$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(id) {
        return $8c1ced2594b499da$var$canStartDrag($8c1ced2594b499da$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        return $8c1ced2594b499da$var$isMovementAllowed($8c1ced2594b499da$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $8c1ced2594b499da$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $f2Y41.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $beddacf0ba12c344$export$2e2bcd8739ae039), {
        context: $8c1ced2594b499da$var$StoreContext,
        store: store
    }, props.children));
}
var $8c1ced2594b499da$var$count$1 = 0;
function $8c1ced2594b499da$var$reset$1() {
    $8c1ced2594b499da$var$count$1 = 0;
}
function $8c1ced2594b499da$var$useInstanceCount() {
    return (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return "" + $8c1ced2594b499da$var$count$1++;
    }, []);
}
function $8c1ced2594b499da$export$2bfe52350fc0150d() {
    $8c1ced2594b499da$var$reset$1();
    $8c1ced2594b499da$var$reset();
}
function $8c1ced2594b499da$export$237bd83162c14364(props) {
    var contextId = $8c1ced2594b499da$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $8c1ced2594b499da$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $8c1ced2594b499da$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $8c1ced2594b499da$var$isScroll = $8c1ced2594b499da$var$isEqual$1("scroll");
var $8c1ced2594b499da$var$isAuto = $8c1ced2594b499da$var$isEqual$1("auto");
var $8c1ced2594b499da$var$isVisible$1 = $8c1ced2594b499da$var$isEqual$1("visible");
var $8c1ced2594b499da$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $8c1ced2594b499da$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $8c1ced2594b499da$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $8c1ced2594b499da$var$isEither(overflow, $8c1ced2594b499da$var$isScroll) || $8c1ced2594b499da$var$isEither(overflow, $8c1ced2594b499da$var$isAuto);
};
var $8c1ced2594b499da$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $8c1ced2594b499da$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $8c1ced2594b499da$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$8c1ced2594b499da$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $8c1ced2594b499da$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $8c1ced2594b499da$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $8c1ced2594b499da$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $8c1ced2594b499da$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var $8c1ced2594b499da$var$getEnv = function(start) {
    var closestScrollable = $8c1ced2594b499da$var$getClosestScrollable(start);
    var isFixedOnPage = $8c1ced2594b499da$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $8c1ced2594b499da$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $8c1ced2594b499da$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $8c1ced2594b499da$var$origin,
                    displacement: $8c1ced2594b499da$var$origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? $8c1ced2594b499da$var$vertical : $8c1ced2594b499da$var$horizontal;
    var subject = $8c1ced2594b499da$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $8c1ced2594b499da$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $d12d7887fa40bdf0$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $d12d7887fa40bdf0$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $d12d7887fa40bdf0$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $8c1ced2594b499da$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $8c1ced2594b499da$var$getClient(ref, closestScrollable);
    var page = (0, $d12d7887fa40bdf0$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $d12d7887fa40bdf0$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $d12d7887fa40bdf0$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $8c1ced2594b499da$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $8c1ced2594b499da$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $8c1ced2594b499da$var$immediate = {
    passive: false
};
var $8c1ced2594b499da$var$delayed = {
    passive: true
};
var $8c1ced2594b499da$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $8c1ced2594b499da$var$immediate : $8c1ced2594b499da$var$delayed;
};
function $8c1ced2594b499da$var$useRequiredContext(Context) {
    var result = (0, $f2Y41.useContext)(Context);
    !result && $8c1ced2594b499da$var$invariant(false);
    return result;
}
var $8c1ced2594b499da$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $8c1ced2594b499da$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $f2Y41.useRef)(null);
    var appContext = $8c1ced2594b499da$var$useRequiredContext($8c1ced2594b499da$var$AppContext);
    var uniqueId = $8c1ced2594b499da$var$useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $8c1ced2594b499da$var$usePrevious(args);
    var descriptor = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $f2Y41.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $8c1ced2594b499da$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $8c1ced2594b499da$var$origin;
        return $8c1ced2594b499da$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return (0, $39ab0416eb85b8c0$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $8c1ced2594b499da$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $8c1ced2594b499da$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && $8c1ced2594b499da$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $8c1ced2594b499da$var$invariant(false);
        var env = $8c1ced2594b499da$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $8c1ced2594b499da$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($8c1ced2594b499da$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $8c1ced2594b499da$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $8c1ced2594b499da$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $8c1ced2594b499da$var$invariant(false);
        return $8c1ced2594b499da$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $8c1ced2594b499da$var$invariant(false);
        var closest = $8c1ced2594b499da$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($8c1ced2594b499da$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $8c1ced2594b499da$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $8c1ced2594b499da$var$invariant(false);
        var closest = $8c1ced2594b499da$var$getClosestScrollableFromDrag(dragging);
        !closest && $8c1ced2594b499da$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $8c1ced2594b499da$var$noop$2() {}
var $8c1ced2594b499da$var$empty = {
    width: 0,
    height: 0,
    margin: $8c1ced2594b499da$var$noSpacing
};
var $8c1ced2594b499da$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $8c1ced2594b499da$var$empty;
    if (animate === "close") return $8c1ced2594b499da$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $8c1ced2594b499da$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $8c1ced2594b499da$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $8c1ced2594b499da$var$transitions.placeholder : null
    };
};
function $8c1ced2594b499da$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $f2Y41.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $f2Y41.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $f2Y41.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $8c1ced2594b499da$var$noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $8c1ced2594b499da$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $8c1ced2594b499da$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $8c1ced2594b499da$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $8c1ced2594b499da$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).memo($8c1ced2594b499da$var$Placeholder);
var $8c1ced2594b499da$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createContext(null);
function $8c1ced2594b499da$var$checkIsValidInnerRef(el) {
    !(el && $8c1ced2594b499da$var$isHtmlElement(el)) && $8c1ced2594b499da$var$invariant(false);
}
function $8c1ced2594b499da$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $8c1ced2594b499da$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $8c1ced2594b499da$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $8c1ced2594b499da$var$invariant(false);
        !(typeof props.droppableId === "string") && $8c1ced2594b499da$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$8c1ced2594b499da$var$isBoolean(props.isDropDisabled) && $8c1ced2594b499da$var$invariant(false);
        !$8c1ced2594b499da$var$isBoolean(props.isCombineEnabled) && $8c1ced2594b499da$var$invariant(false);
        !$8c1ced2594b499da$var$isBoolean(props.ignoreContainerClipping) && $8c1ced2594b499da$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $8c1ced2594b499da$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $8c1ced2594b499da$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $8c1ced2594b499da$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $8c1ced2594b499da$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $8c1ced2594b499da$var$invariant(false);
    }
];
function $8c1ced2594b499da$var$useValidation(args) {
    $8c1ced2594b499da$var$useDevSetupWarning(function() {
        $8c1ced2594b499da$var$runChecks(args, $8c1ced2594b499da$var$shared);
        if (args.props.mode === "standard") $8c1ced2594b499da$var$runChecks(args, $8c1ced2594b499da$var$standard);
        if (args.props.mode === "virtual") $8c1ced2594b499da$var$runChecks(args, $8c1ced2594b499da$var$virtual);
    });
}
var $8c1ced2594b499da$var$AnimateInOut = function(_React$PureComponent) {
    (0, $c667c70d22b9c5fb$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).PureComponent);
var $8c1ced2594b499da$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $8c1ced2594b499da$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $8c1ced2594b499da$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $8c1ced2594b499da$var$transitions.snap;
    return $8c1ced2594b499da$var$transitions.fluid;
};
var $8c1ced2594b499da$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $8c1ced2594b499da$var$combine.opacity.drop : $8c1ced2594b499da$var$combine.opacity.combining;
};
var $8c1ced2594b499da$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $8c1ced2594b499da$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $8c1ced2594b499da$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $8c1ced2594b499da$var$transforms.drop(offset, isCombining) : $8c1ced2594b499da$var$transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $8c1ced2594b499da$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $8c1ced2594b499da$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $8c1ced2594b499da$var$zIndexOptions.dropAnimating : $8c1ced2594b499da$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $8c1ced2594b499da$var$getSecondaryStyle(secondary) {
    return {
        transform: $8c1ced2594b499da$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function $8c1ced2594b499da$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $8c1ced2594b499da$var$getDraggingStyle(mapped) : $8c1ced2594b499da$var$getSecondaryStyle(mapped);
}
function $8c1ced2594b499da$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $8c1ced2594b499da$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $d12d7887fa40bdf0$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $d12d7887fa40bdf0$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $8c1ced2594b499da$var$useDraggablePublisher(args) {
    var uniqueId = $8c1ced2594b499da$var$useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $8c1ced2594b499da$var$invariant(false);
        return $8c1ced2594b499da$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $f2Y41.useRef)(entry);
    var isFirstPublishRef = (0, $f2Y41.useRef)(true);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $8c1ced2594b499da$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $8c1ced2594b499da$var$useValidation$1(props, contextId, getRef) {
    $8c1ced2594b499da$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $8c1ced2594b499da$var$invariant(false);
        !(typeof id === "string") && $8c1ced2594b499da$var$invariant(false);
        !$8c1ced2594b499da$var$isInteger(props.index) && $8c1ced2594b499da$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $8c1ced2594b499da$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$8c1ced2594b499da$var$findDragHandle(contextId, id) && $8c1ced2594b499da$var$invariant(false);
    });
}
function $8c1ced2594b499da$var$useClonePropValidation(isClone) {
    $8c1ced2594b499da$var$useDev(function() {
        var initialRef = (0, $f2Y41.useRef)(isClone);
        $8c1ced2594b499da$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $8c1ced2594b499da$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $8c1ced2594b499da$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $8c1ced2594b499da$var$Draggable(props) {
    var ref = (0, $f2Y41.useRef)(null);
    var setRef = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $8c1ced2594b499da$var$useRequiredContext($8c1ced2594b499da$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $8c1ced2594b499da$var$useRequiredContext($8c1ced2594b499da$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $8c1ced2594b499da$var$useValidation$1(props, contextId, getRef);
    $8c1ced2594b499da$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $8c1ced2594b499da$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $8c1ced2594b499da$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        var style = $8c1ced2594b499da$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $8c1ced2594b499da$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $8c1ced2594b499da$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $8c1ced2594b499da$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $8c1ced2594b499da$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $8c1ced2594b499da$var$getDraggableSelector() {
    var memoizedOffset = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $8c1ced2594b499da$var$whatIsDraggedOver(state.impact);
            var combineWith = $8c1ced2594b499da$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $8c1ced2594b499da$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $8c1ced2594b499da$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $8c1ced2594b499da$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $8c1ced2594b499da$var$combine.opacity.drop : null,
                scale: _combineWith ? $8c1ced2594b499da$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $8c1ced2594b499da$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $8c1ced2594b499da$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $8c1ced2594b499da$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $8c1ced2594b499da$var$getSecondarySnapshot(null)
    }
};
function $8c1ced2594b499da$var$getSecondarySelector() {
    var memoizedOffset = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $e9da44423efd8196$export$2e2bcd8739ae039)($8c1ced2594b499da$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($8c1ced2594b499da$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $8c1ced2594b499da$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $8c1ced2594b499da$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $8c1ced2594b499da$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $8c1ced2594b499da$var$getDraggableSelector();
    var secondarySelector = $8c1ced2594b499da$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $8c1ced2594b499da$var$atRest;
    };
    return selector;
};
var $8c1ced2594b499da$var$mapDispatchToProps = {
    dropAnimationFinished: $8c1ced2594b499da$var$dropAnimationFinished
};
var $8c1ced2594b499da$var$ConnectedDraggable = (0, $f5fe88794f206302$export$2e2bcd8739ae039)($8c1ced2594b499da$var$makeMapStateToProps, $8c1ced2594b499da$var$mapDispatchToProps, null, {
    context: $8c1ced2594b499da$var$StoreContext,
    pure: true,
    areStatePropsEqual: $8c1ced2594b499da$var$isStrictEqual
})($8c1ced2594b499da$var$Draggable);
function $8c1ced2594b499da$var$PrivateDraggable(props) {
    var droppableContext = $8c1ced2594b499da$var$useRequiredContext($8c1ced2594b499da$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$ConnectedDraggable, props);
}
function $8c1ced2594b499da$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$PrivateDraggable, (0, $asN9r.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $8c1ced2594b499da$var$Droppable(props) {
    var appContext = (0, $f2Y41.useContext)($8c1ced2594b499da$var$AppContext);
    !appContext && $8c1ced2594b499da$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $f2Y41.useRef)(null);
    var placeholderRef = (0, $f2Y41.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    $8c1ced2594b499da$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $e2f7239e202f4a73$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $8c1ced2594b499da$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $8c1ced2594b499da$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $e2f7239e202f4a73$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5021361ff788fb77$exports))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($8c1ced2594b499da$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $8c1ced2594b499da$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $8c1ced2594b499da$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $8c1ced2594b499da$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $asN9r.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $e9da44423efd8196$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$8c1ced2594b499da$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $8c1ced2594b499da$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $8c1ced2594b499da$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!$8c1ced2594b499da$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $8c1ced2594b499da$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $8c1ced2594b499da$var$whatIsDraggedOverFromResult(completed.result) === id, $8c1ced2594b499da$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$8c1ced2594b499da$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $8c1ced2594b499da$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $8c1ced2594b499da$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $8c1ced2594b499da$var$updateViewportMaxScroll
};
function $8c1ced2594b499da$var$getBody() {
    !document.body && $8c1ced2594b499da$var$invariant(false);
    return document.body;
}
var $8c1ced2594b499da$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $8c1ced2594b499da$var$getBody
};
var $8c1ced2594b499da$export$423ec2075359570a = (0, $f5fe88794f206302$export$2e2bcd8739ae039)($8c1ced2594b499da$var$makeMapStateToProps$1, $8c1ced2594b499da$var$mapDispatchToProps$1, null, {
    context: $8c1ced2594b499da$var$StoreContext,
    pure: true,
    areStatePropsEqual: $8c1ced2594b499da$var$isStrictEqual
})($8c1ced2594b499da$var$Droppable);
$8c1ced2594b499da$export$423ec2075359570a.defaultProps = $8c1ced2594b499da$var$defaultProps;







var $ge3KO = parcelRequire("ge3KO");


var $ge3KO = parcelRequire("ge3KO");





const $ade6020dfbeff445$export$304dcc153ad6a9d9 = (props)=>{
    const { patient: patient, studyId: studyId, patientIndex: patientIndex, statusIndex: statusIndex } = props;
    const uniqueId = statusIndex * 10 + patientIndex;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8c1ced2594b499da$export$f2a139e5d18b9882), {
        draggableId: patient?.screens?.[0].id,
        index: uniqueId,
        children: (provided, snapshot)=>{
            let isDragging = snapshot.isDragging && !snapshot.isDropAnimating;
            return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                ref: provided.innerRef,
                className: (0, $ab3059e3726110c9$export$ce4ab0c55987d1ff)("cursor-default flex flex-col w-full px-4 py-3 mb-2 bg-gray-100 dark:bg-gray-700 rounded focus:outline-none", {
                    "shadow-modal": isDragging
                }),
                ...provided.draggableProps,
                ...provided.dragHandleProps,
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex justify-between w-full cursor-default",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                        className: "text-md font-normal text-gray-800 dark:text-gray-300 text-sm",
                                        children: [
                                            patient.given_name,
                                            " ",
                                            patient.family_name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "mt-1 text-sm font-medium text-gray-500 dark:text-gray-200 line-clamp-2 overflow-ellipsis",
                                        children: patient.screens?.map((screen)=>screen.study.id == studyId && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "py-1",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                    to: `/patients/${patient.id}/screens/${screen.id}`,
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da10e49b852b9347$export$55c72165ec0b2743), {
                                                        text: screen.study.abbreviation,
                                                        status: screen.status
                                                    })
                                                })
                                            }, screen?.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex-shrink-0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2.5 flex items-center"
                    })
                ]
            });
        }
    }, (0, $67bfd1b00f19d8e6$export$e73c8bd0f20705a)());
};



const $8ec5ca0bcac37e32$export$816b5d811295e6bc = (props)=>{
    const { status: status, patients: patients, studyId: studyId, statusIndex: statusIndex } = props;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8c1ced2594b499da$export$423ec2075359570a), {
        droppableId: status,
        type: "category",
        children: (provided)=>{
            return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                ref: provided.innerRef,
                ...provided.droppableProps,
                className: "flex flex-col flex-shrink-0 mr-3 select-none w-[200px]",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex items-center justify-between pb-4 text-sm",
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                    className: "ml-3 mr-3 font-medium",
                                    children: [
                                        "      ",
                                        (0, $17235661ec5f519b$export$b94aa994a2f01789)(status),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                    className: "mr-3 font-normal text-gray-400",
                                    children: patients?.length || 0
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex flex-col flex-1 w-full overflow-y-auto border-gray-200 pt-0.5",
                        children: [
                            patients?.map((patient, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ade6020dfbeff445$export$304dcc153ad6a9d9), {
                                    patient: patient,
                                    studyId: studyId,
                                    patientIndex: index,
                                    statusIndex: statusIndex
                                })),
                            provided.placeholder
                        ]
                    })
                ]
            });
        }
    }, status);
};


function $9c34f60534805f28$export$6ddf1eefea0f12d3() {
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { user: user } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const [filter, setFilter] = (0, $f2Y41.useState)({});
    (0, $f2Y41.useEffect)(()=>{
        const userFilter = {
            filtering: {
                link_operator: "and",
                filters: [
                    {
                        field: "assigned_to_user_id",
                        operator_value: "equals",
                        value: currentUser.id
                    }
                ]
            }
        };
        setFilter(userFilter);
        return ()=>{
            setFilter({});
        };
    }, [
        currentUser
    ]);
    const onDragEnd = ({ source: source, destination: destination, draggableId: screenId, reason: reason }, provided)=>{
        if (!reason) return;
        if (!source || !destination) return;
        const destinationStatus = destination.droppableId;
        optimisticallyUpdateScreen(screenId, destinationStatus);
    };
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { data: patients, mutate: mutatePatients } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patients_filter_and_sort", `practice_id=${practiceId}&filter_and_sort=${JSON.stringify(filter)}`);
    const { data: practiceStudies } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const optimisticallyUpdateScreen = (screenId, status)=>{
        const updatedPatient = patients.find((patient)=>patient?.screens.some((screen)=>screen.id === screenId));
        const nonUpdatedPatients = patients.slice(0).filter((patient)=>patient.id !== updatedPatient.id);
        // const nonUpdatedPatients = patients.filter((patient) => !patient.screens.some((screen) => screen.id == screenId))
        const updatedScreens = updatedPatient.screens.slice(0).map((screen)=>screen.id === screenId ? {
                ...screen,
                status: status
            } : screen);
        // console.dir(updatedPatient.id)
        // console.dir(updatedScreens)
        const newPatients = [
            ...nonUpdatedPatients,
            {
                ...updatedPatient,
                screens: updatedScreens
            }
        ];
        pivotPatientScreensByStatus(newPatients);
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", screenId, {
            status: status
        }, getAccessTokenSilently).then(()=>{
            // why does this not work..
            // mutatePatients(newPatients, {revalidate: true}).then((patients) => console.dir(patients))
            mutatePatients();
        });
    };
    const [patientsByStatus, setPatientsByStatus] = (0, $f2Y41.useState)([]);
    const [localPatients, setLocalPatients] = (0, $f2Y41.useState)([]);
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const [studyId, setStudyId] = (0, $f2Y41.useState)(searchParams.get("studyId"));
    // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: Refactor
    (0, $f2Y41.useEffect)(()=>{
        setStudyId(searchParams.get("studyId"));
        return ()=>{
            setStudyId("");
        };
    }, [
        practiceStudies
    ]);
    const handleChangeStudy = (event)=>{
        setStudyId(event.target.value);
        setSearchParams(new URLSearchParams(`studyId=${event.target.value}`), {
            replace: true
        });
    };
    // useEffect(() => {
    //   const newStudyId =
    //   console.dir(newStudyId)
    //   setStudyId(newStudyId)
    //   console.dir(studyId)
    //   pivotPatientScreensByStatus(patients)
    //   return () => {
    //     setStudyId('')
    //   }
    // }, [searchParams.get('studyId')])
    const filterPatientsByStatus = (status)=>{
        const patientsToFilter = localPatients.length > 0 ? localPatients : patients?.slice(0) || [];
        const filteredPatients = patientsToFilter.filter((patient)=>patient?.screens?.some((screen)=>screen.status === status && screen.study.id === studyId));
        console.dir(status);
        console.dir(filteredPatients);
        return filteredPatients;
    };
    const pivotPatientScreensByStatus = (patients)=>{
        console.dir("pivoting");
        console.dir(studyId);
        console.dir(patients);
        const newPatientsByStatus = (0, $dc67232e0e99ac39$export$cfd07d0d262760eb).map((status)=>({
                status: status,
                patients: patients?.slice(0).filter((patient)=>patient?.screens?.some((screen)=>screen.status === status && screen.study.id === studyId))
            }));
        setPatientsByStatus(newPatientsByStatus);
        console.dir(patientsByStatus);
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: Refactor
    (0, $f2Y41.useEffect)(()=>{
        if (!patients || patients?.length === 0) {
            console.dir("zero");
            return;
        }
        pivotPatientScreensByStatus(patients);
        return ()=>{
            setPatientsByStatus([]);
        };
    }, [
        patients,
        studyId
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "overflow-auto",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "px-4.5 py-2 flex flex-col border-b border-gray-200 dark:border-gray-600 mb-4",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h1", {
                            className: "p-4 text-xl font-bold",
                            children: "Kanban"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex items-center",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex items-center px-4",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex ml-2",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                        onChange: handleChangeStudy,
                                        value: studyId,
                                        className: "text-xs focus:ring-transparent text-gray-800 h-6 bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark: rounded pr-4.5 bg-right pl-2 py-0 appearance-none focus:outline-none border-none",
                                        children: [
                                            !studyId && /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                value: "",
                                                children: "Select a Study"
                                            }, "select_a_study"),
                                            practiceStudies.map((practiceStudy)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                    value: practiceStudy.study.id,
                                                    children: practiceStudy.study.abbreviation
                                                }, practiceStudy.study.id))
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8c1ced2594b499da$export$237bd83162c14364), {
                onDragEnd: onDragEnd,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex flex-row flex-1 pl-4",
                    children: patientsByStatus?.map((status, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $8ec5ca0bcac37e32$export$816b5d811295e6bc), {
                            status: status.status,
                            patients: status.patients,
                            studyId: studyId,
                            statusIndex: index
                        }, status.status))
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");







var $f2Y41 = parcelRequire("f2Y41");

function $00f3e4c5862b3e5b$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $00f3e4c5862b3e5b$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $f2Y41.useState)(()=>$00f3e4c5862b3e5b$var$i(t));
    return (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        u($00f3e4c5862b3e5b$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}




var $f2Y41 = parcelRequire("f2Y41");
let $7612d1a0b1ba83f8$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $7612d1a0b1ba83f8$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $7612d1a0b1ba83f8$var$a.test(l) && (l = l.replace($7612d1a0b1ba83f8$var$a, "")), l;
}
function $7612d1a0b1ba83f8$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $7612d1a0b1ba83f8$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $7612d1a0b1ba83f8$var$o(e).trim();
}



function $67421d60e2e37e3b$export$f6862afd851a1cf4(c) {
    let t = (0, $f2Y41.useRef)(""), r = (0, $f2Y41.useRef)("");
    return (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $7612d1a0b1ba83f8$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}



var $f2Y41 = parcelRequire("f2Y41");
function $9432230b7faa5fe0$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $9432230b7faa5fe0$export$24ebee078bde85c3() {
    let e = (0, $f2Y41.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $9432230b7faa5fe0$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $9432230b7faa5fe0$var$t(r);
        }
    };
}



var $f2Y41 = parcelRequire("f2Y41");


function $6647e812e79feca6$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $f2Y41.useRef)(t), l = (0, $f2Y41.useRef)(r);
    (0, $f2Y41.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $225dec9ff04e4a5b$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}




function $b8c7e5f38f3b00d2$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $b8c7e5f38f3b00d2$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($b8c7e5f38f3b00d2$export$807a7eae502106e7 || {});
function $b8c7e5f38f3b00d2$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $b8c7e5f38f3b00d2$var$u(l);
    }
}







var $2ac7db88844efa30$var$me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($2ac7db88844efa30$var$me || {}), $2ac7db88844efa30$var$de = ((r)=>(r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r))($2ac7db88844efa30$var$de || {}), $2ac7db88844efa30$var$fe = ((a)=>(a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a))($2ac7db88844efa30$var$fe || {});
function $2ac7db88844efa30$var$w(e, u = (r)=>r) {
    let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, s = (0, $4d75beccbbd4c437$export$20305e96f91bf103)(u(e.items.slice()), (t)=>t.dataRef.current.domRef.current), i = r ? s.indexOf(r) : null;
    return i === -1 && (i = null), {
        items: s,
        activeItemIndex: i
    };
}
let $2ac7db88844efa30$var$Te = {
    [1] (e) {
        return e.menuState === 1 ? e : {
            ...e,
            activeItemIndex: null,
            menuState: 1
        };
    },
    [0] (e) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            menuState: 0
        };
    },
    [2]: (e, u)=>{
        var i;
        let r = $2ac7db88844efa30$var$w(e), s = (0, $b8c7e5f38f3b00d2$export$c6b4626b54936d5e)(u, {
            resolveItems: ()=>r.items,
            resolveActiveIndex: ()=>r.activeItemIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...e,
            ...r,
            searchQuery: "",
            activeItemIndex: s,
            activationTrigger: (i = u.trigger) != null ? i : 1
        };
    },
    [3]: (e, u)=>{
        let s = e.searchQuery !== "" ? 0 : 1, i = e.searchQuery + u.value.toLowerCase(), o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + s).concat(e.items.slice(0, e.activeItemIndex + s)) : e.items).find((l)=>{
            var m;
            return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(i)) && !l.dataRef.current.disabled;
        }), a = o ? e.items.indexOf(o) : -1;
        return a === -1 || a === e.activeItemIndex ? {
            ...e,
            searchQuery: i
        } : {
            ...e,
            searchQuery: i,
            activeItemIndex: a,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, u)=>{
        let r = $2ac7db88844efa30$var$w(e, (s)=>[
                ...s,
                {
                    id: u.id,
                    dataRef: u.dataRef
                }
            ]);
        return {
            ...e,
            ...r
        };
    },
    [6]: (e, u)=>{
        let r = $2ac7db88844efa30$var$w(e, (s)=>{
            let i = s.findIndex((t)=>t.id === u.id);
            return i !== -1 && s.splice(i, 1), s;
        });
        return {
            ...e,
            ...r,
            activationTrigger: 1
        };
    }
}, $2ac7db88844efa30$var$U = (0, $f2Y41.createContext)(null);
$2ac7db88844efa30$var$U.displayName = "MenuContext";
function $2ac7db88844efa30$var$C(e) {
    let u = (0, $f2Y41.useContext)($2ac7db88844efa30$var$U);
    if (u === null) {
        let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $2ac7db88844efa30$var$C), r;
    }
    return u;
}
function $2ac7db88844efa30$var$ye(e, u) {
    return (0, $01099572ffa9156b$export$4659b591c19bdf3d)(u.type, $2ac7db88844efa30$var$Te, e, u);
}
let $2ac7db88844efa30$var$Ie = (0, $f2Y41.Fragment);
function $2ac7db88844efa30$var$Me(e, u) {
    let { __demoMode: r = !1, ...s } = e, i = (0, $f2Y41.useReducer)($2ac7db88844efa30$var$ye, {
        __demoMode: r,
        menuState: r ? 0 : 1,
        buttonRef: (0, $f2Y41.createRef)(),
        itemsRef: (0, $f2Y41.createRef)(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: t, itemsRef: o, buttonRef: a }, l] = i, m = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(u);
    (0, $c7cd72187c2da439$export$71b2224f1ce5e08e)([
        a,
        o
    ], (g, R)=>{
        var p;
        l({
            type: 1
        }), (0, $4d75beccbbd4c437$export$ff1ec1c740b3c8d5)(R, (0, $4d75beccbbd4c437$export$27112a34f2f8402d).Loose) || (g.preventDefault(), (p = a.current) == null || p.focus());
    }, t === 0);
    let I = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        l({
            type: 1
        });
    }), A = (0, $f2Y41.useMemo)(()=>({
            open: t === 0,
            close: I
        }), [
        t,
        I
    ]), f = {
        ref: m
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($2ac7db88844efa30$var$U.Provider, {
        value: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $f7ac33105fd0ff19$export$2a0ed818b175f558), {
        value: (0, $01099572ffa9156b$export$4659b591c19bdf3d)(t, {
            [0]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open,
            [1]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closed
        })
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: f,
        theirProps: s,
        slot: A,
        defaultTag: $2ac7db88844efa30$var$Ie,
        name: "Menu"
    })));
}
let $2ac7db88844efa30$var$ge = "button";
function $2ac7db88844efa30$var$Re(e, u) {
    var R;
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: s = `headlessui-menu-button-${r}`, ...i } = e, [t, o] = $2ac7db88844efa30$var$C("Menu.Button"), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(t.buttonRef, u), l = (0, $d649f2b4cbccd3d1$export$fd183955ff4b45d9)(), m = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((p)=>{
        switch(p.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Enter:
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).ArrowDown:
                p.preventDefault(), p.stopPropagation(), o({
                    type: 0
                }), l.nextFrame(()=>o({
                        type: 2,
                        focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).First
                    }));
                break;
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).ArrowUp:
                p.preventDefault(), p.stopPropagation(), o({
                    type: 0
                }), l.nextFrame(()=>o({
                        type: 2,
                        focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Last
                    }));
                break;
        }
    }), I = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((p)=>{
        switch(p.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
                p.preventDefault();
                break;
        }
    }), A = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((p)=>{
        if ((0, $d8956e419f398824$export$db61f031a278447c)(p.currentTarget)) return p.preventDefault();
        e.disabled || (t.menuState === 0 ? (o({
            type: 1
        }), l.nextFrame(()=>{
            var M;
            return (M = t.buttonRef.current) == null ? void 0 : M.focus({
                preventScroll: !0
            });
        })) : (p.preventDefault(), o({
            type: 0
        })));
    }), f = (0, $f2Y41.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t
    ]), g = {
        ref: a,
        id: s,
        type: (0, $00f3e4c5862b3e5b$export$53652b2b272efe9c)(e, t.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": (R = t.itemsRef.current) == null ? void 0 : R.id,
        "aria-expanded": t.menuState === 0,
        onKeyDown: m,
        onKeyUp: I,
        onClick: A
    };
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: i,
        slot: f,
        defaultTag: $2ac7db88844efa30$var$ge,
        name: "Menu.Button"
    });
}
let $2ac7db88844efa30$var$Ae = "div", $2ac7db88844efa30$var$be = (0, $43f03f8737506038$export$617d79dae526d2cf).RenderStrategy | (0, $43f03f8737506038$export$617d79dae526d2cf).Static;
function $2ac7db88844efa30$var$Ee(e, u) {
    var M, b;
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: s = `headlessui-menu-items-${r}`, ...i } = e, [t, o] = $2ac7db88844efa30$var$C("Menu.Items"), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(t.itemsRef, u), l = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(t.itemsRef), m = (0, $d649f2b4cbccd3d1$export$fd183955ff4b45d9)(), I = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)(), A = (()=>I !== null ? (I & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open : t.menuState === 0)();
    (0, $f2Y41.useEffect)(()=>{
        let n = t.itemsRef.current;
        n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
            preventScroll: !0
        });
    }, [
        t.menuState,
        t.itemsRef,
        l
    ]), (0, $6647e812e79feca6$export$b0abce39eb34b36)({
        container: t.itemsRef.current,
        enabled: t.menuState === 0,
        accept (n) {
            return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (n) {
            n.setAttribute("role", "none");
        }
    });
    let f = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((n)=>{
        var E, x;
        switch(m.dispose(), n.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
                    type: 3,
                    value: n.key
                });
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Enter:
                if (n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), t.activeItemIndex !== null) {
                    let { dataRef: S } = t.items[t.activeItemIndex];
                    (x = (E = S.current) == null ? void 0 : E.domRef.current) == null || x.click();
                }
                (0, $4d75beccbbd4c437$export$46388676ec35ab85)(t.buttonRef.current);
                break;
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).ArrowDown:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Next
                });
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).ArrowUp:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Previous
                });
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Home:
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).PageUp:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).First
                });
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).End:
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).PageDown:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Last
                });
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Escape:
                n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), (0, $8b81a70c157af4cc$export$12b26c28a05aa001)().nextFrame(()=>{
                    var S;
                    return (S = t.buttonRef.current) == null ? void 0 : S.focus({
                        preventScroll: !0
                    });
                });
                break;
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Tab:
                n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), (0, $8b81a70c157af4cc$export$12b26c28a05aa001)().nextFrame(()=>{
                    (0, $4d75beccbbd4c437$export$7fb6c844b485e870)(t.buttonRef.current, n.shiftKey ? (0, $4d75beccbbd4c437$export$807a7eae502106e7).Previous : (0, $4d75beccbbd4c437$export$807a7eae502106e7).Next);
                });
                break;
            default:
                n.key.length === 1 && (o({
                    type: 3,
                    value: n.key
                }), m.setTimeout(()=>o({
                        type: 4
                    }), 350));
                break;
        }
    }), g = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((n)=>{
        switch(n.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
                n.preventDefault();
                break;
        }
    }), R = (0, $f2Y41.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t
    ]), p = {
        "aria-activedescendant": t.activeItemIndex === null || (M = t.items[t.activeItemIndex]) == null ? void 0 : M.id,
        "aria-labelledby": (b = t.buttonRef.current) == null ? void 0 : b.id,
        id: s,
        onKeyDown: f,
        onKeyUp: g,
        role: "menu",
        tabIndex: 0,
        ref: a
    };
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: p,
        theirProps: i,
        slot: R,
        defaultTag: $2ac7db88844efa30$var$Ae,
        features: $2ac7db88844efa30$var$be,
        visible: A,
        name: "Menu.Items"
    });
}
let $2ac7db88844efa30$var$Se = (0, $f2Y41.Fragment);
function $2ac7db88844efa30$var$xe(e, u) {
    let r = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: s = `headlessui-menu-item-${r}`, disabled: i = !1, ...t } = e, [o, a] = $2ac7db88844efa30$var$C("Menu.Item"), l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === s : !1, m = (0, $f2Y41.useRef)(null), I = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(u, m);
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        if (o.__demoMode || o.menuState !== 0 || !l || o.activationTrigger === 0) return;
        let T = (0, $8b81a70c157af4cc$export$12b26c28a05aa001)();
        return T.requestAnimationFrame(()=>{
            var P, B;
            (B = (P = m.current) == null ? void 0 : P.scrollIntoView) == null || B.call(P, {
                block: "nearest"
            });
        }), T.dispose;
    }, [
        o.__demoMode,
        m,
        l,
        o.menuState,
        o.activationTrigger,
        o.activeItemIndex
    ]);
    let A = (0, $67421d60e2e37e3b$export$f6862afd851a1cf4)(m), f = (0, $f2Y41.useRef)({
        disabled: i,
        domRef: m,
        get textValue () {
            return A();
        }
    });
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>{
        f.current.disabled = i;
    }, [
        f,
        i
    ]), (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>(a({
            type: 5,
            id: s,
            dataRef: f
        }), ()=>a({
                type: 6,
                id: s
            })), [
        f,
        s
    ]);
    let g = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        a({
            type: 1
        });
    }), R = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((T)=>{
        if (i) return T.preventDefault();
        a({
            type: 1
        }), (0, $4d75beccbbd4c437$export$46388676ec35ab85)(o.buttonRef.current);
    }), p = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        if (i) return a({
            type: 2,
            focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Nothing
        });
        a({
            type: 2,
            focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Specific,
            id: s
        });
    }), M = (0, $9432230b7faa5fe0$export$24ebee078bde85c3)(), b = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((T)=>M.update(T)), n = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((T)=>{
        M.wasMoved(T) && (i || l || a({
            type: 2,
            focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Specific,
            id: s,
            trigger: 0
        }));
    }), E = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((T)=>{
        M.wasMoved(T) && (i || l && a({
            type: 2,
            focus: (0, $b8c7e5f38f3b00d2$export$807a7eae502106e7).Nothing
        }));
    }), x = (0, $f2Y41.useMemo)(()=>({
            active: l,
            disabled: i,
            close: g
        }), [
        l,
        i,
        g
    ]);
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            id: s,
            ref: I,
            role: "menuitem",
            tabIndex: i === !0 ? void 0 : -1,
            "aria-disabled": i === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: R,
            onFocus: p,
            onPointerEnter: b,
            onMouseEnter: b,
            onPointerMove: n,
            onMouseMove: n,
            onPointerLeave: E,
            onMouseLeave: E
        },
        theirProps: t,
        slot: x,
        defaultTag: $2ac7db88844efa30$var$Se,
        name: "Menu.Item"
    });
}
let $2ac7db88844efa30$var$Pe = (0, $43f03f8737506038$export$e43f39796049410c)($2ac7db88844efa30$var$Me), $2ac7db88844efa30$var$ve = (0, $43f03f8737506038$export$e43f39796049410c)($2ac7db88844efa30$var$Re), $2ac7db88844efa30$var$he = (0, $43f03f8737506038$export$e43f39796049410c)($2ac7db88844efa30$var$Ee), $2ac7db88844efa30$var$De = (0, $43f03f8737506038$export$e43f39796049410c)($2ac7db88844efa30$var$xe), $2ac7db88844efa30$export$d9b273488cd8ce6f = Object.assign($2ac7db88844efa30$var$Pe, {
    Button: $2ac7db88844efa30$var$ve,
    Items: $2ac7db88844efa30$var$he,
    Item: $2ac7db88844efa30$var$De
});


var $f2Y41 = parcelRequire("f2Y41");





















var $42e7a5d8f911b531$var$he = ((u)=>(u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))($42e7a5d8f911b531$var$he || {}), $42e7a5d8f911b531$var$He = ((e)=>(e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))($42e7a5d8f911b531$var$He || {});
let $42e7a5d8f911b531$var$Ge = {
    [0]: (t)=>{
        let o = {
            ...t,
            popoverState: (0, $01099572ffa9156b$export$4659b591c19bdf3d)(t.popoverState, {
                [0]: 1,
                [1]: 0
            })
        };
        return o.popoverState === 0 && (o.__demoMode = !1), o;
    },
    [1] (t) {
        return t.popoverState === 1 ? t : {
            ...t,
            popoverState: 1
        };
    },
    [2] (t, o) {
        return t.button === o.button ? t : {
            ...t,
            button: o.button
        };
    },
    [3] (t, o) {
        return t.buttonId === o.buttonId ? t : {
            ...t,
            buttonId: o.buttonId
        };
    },
    [4] (t, o) {
        return t.panel === o.panel ? t : {
            ...t,
            panel: o.panel
        };
    },
    [5] (t, o) {
        return t.panelId === o.panelId ? t : {
            ...t,
            panelId: o.panelId
        };
    }
}, $42e7a5d8f911b531$var$ue = (0, $f2Y41.createContext)(null);
$42e7a5d8f911b531$var$ue.displayName = "PopoverContext";
function $42e7a5d8f911b531$var$oe(t) {
    let o = (0, $f2Y41.useContext)($42e7a5d8f911b531$var$ue);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $42e7a5d8f911b531$var$oe), u;
    }
    return o;
}
let $42e7a5d8f911b531$var$ie = (0, $f2Y41.createContext)(null);
$42e7a5d8f911b531$var$ie.displayName = "PopoverAPIContext";
function $42e7a5d8f911b531$var$fe(t) {
    let o = (0, $f2Y41.useContext)($42e7a5d8f911b531$var$ie);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $42e7a5d8f911b531$var$fe), u;
    }
    return o;
}
let $42e7a5d8f911b531$var$Pe = (0, $f2Y41.createContext)(null);
$42e7a5d8f911b531$var$Pe.displayName = "PopoverGroupContext";
function $42e7a5d8f911b531$var$Ee() {
    return (0, $f2Y41.useContext)($42e7a5d8f911b531$var$Pe);
}
let $42e7a5d8f911b531$var$re = (0, $f2Y41.createContext)(null);
$42e7a5d8f911b531$var$re.displayName = "PopoverPanelContext";
function $42e7a5d8f911b531$var$Ne() {
    return (0, $f2Y41.useContext)($42e7a5d8f911b531$var$re);
}
function $42e7a5d8f911b531$var$ke(t, o) {
    return (0, $01099572ffa9156b$export$4659b591c19bdf3d)(o.type, $42e7a5d8f911b531$var$Ge, t, o);
}
let $42e7a5d8f911b531$var$we = "div";
function $42e7a5d8f911b531$var$Ue(t, o) {
    var B;
    let { __demoMode: u = !1, ...M } = t, x = (0, $f2Y41.useRef)(null), n = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(o, (0, $ee0946aeccd5ac5d$export$7029785b750eb74)((l)=>{
        x.current = l;
    })), e = (0, $f2Y41.useRef)([]), c = (0, $f2Y41.useReducer)($42e7a5d8f911b531$var$ke, {
        __demoMode: u,
        popoverState: u ? 0 : 1,
        buttons: e,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $f2Y41.createRef)(),
        afterPanelSentinel: (0, $f2Y41.createRef)()
    }), [{ popoverState: f, button: s, buttonId: I, panel: a, panelId: v, beforePanelSentinel: y, afterPanelSentinel: A }, P] = c, p = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)((B = x.current) != null ? B : s), E = (0, $f2Y41.useMemo)(()=>{
        if (!s || !a) return !1;
        for (let W of document.querySelectorAll("body > *"))if (Number(W == null ? void 0 : W.contains(s)) ^ Number(W == null ? void 0 : W.contains(a))) return !0;
        let l = (0, $4d75beccbbd4c437$export$433aaa1f216cf32d)(), S = l.indexOf(s), q = (S + l.length - 1) % l.length, U = (S + 1) % l.length, z = l[q], be = l[U];
        return !a.contains(z) && !a.contains(be);
    }, [
        s,
        a
    ]), F = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(I), D = (0, $2cae1ff5dfbdd805$export$86c4283a11f23f95)(v), _ = (0, $f2Y41.useMemo)(()=>({
            buttonId: F,
            panelId: D,
            close: ()=>P({
                    type: 1
                })
        }), [
        F,
        D,
        P
    ]), O = $42e7a5d8f911b531$var$Ee(), L = O == null ? void 0 : O.registerPopover, $ = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        var l;
        return (l = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? l : (p == null ? void 0 : p.activeElement) && ((s == null ? void 0 : s.contains(p.activeElement)) || (a == null ? void 0 : a.contains(p.activeElement)));
    });
    (0, $f2Y41.useEffect)(()=>L == null ? void 0 : L(_), [
        L,
        _
    ]);
    let [i, b] = (0, $af736e5a07684d0e$export$26b8c35244a70b37)(), T = (0, $b0f5336b343de017$export$445f2d1a3d9b1b9f)({
        mainTreeNodeRef: O == null ? void 0 : O.mainTreeNodeRef,
        portals: i,
        defaultContainers: [
            s,
            a
        ]
    });
    (0, $94bcc444643f252a$export$7080b3e976bc91ab)(p == null ? void 0 : p.defaultView, "focus", (l)=>{
        var S, q, U, z;
        l.target !== window && l.target instanceof HTMLElement && f === 0 && ($() || s && a && (T.contains(l.target) || (q = (S = y.current) == null ? void 0 : S.contains) != null && q.call(S, l.target) || (z = (U = A.current) == null ? void 0 : U.contains) != null && z.call(U, l.target) || P({
            type: 1
        })));
    }, !0), (0, $c7cd72187c2da439$export$71b2224f1ce5e08e)(T.resolveContainers, (l, S)=>{
        P({
            type: 1
        }), (0, $4d75beccbbd4c437$export$ff1ec1c740b3c8d5)(S, (0, $4d75beccbbd4c437$export$27112a34f2f8402d).Loose) || (l.preventDefault(), s == null || s.focus());
    }, f === 0);
    let d = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((l)=>{
        P({
            type: 1
        });
        let S = (()=>l ? l instanceof HTMLElement ? l : "current" in l && l.current instanceof HTMLElement ? l.current : s : s)();
        S == null || S.focus();
    }), r = (0, $f2Y41.useMemo)(()=>({
            close: d,
            isPortalled: E
        }), [
        d,
        E
    ]), m = (0, $f2Y41.useMemo)(()=>({
            open: f === 0,
            close: d
        }), [
        f,
        d
    ]), g = {
        ref: n
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($42e7a5d8f911b531$var$re.Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($42e7a5d8f911b531$var$ue.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($42e7a5d8f911b531$var$ie.Provider, {
        value: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $f7ac33105fd0ff19$export$2a0ed818b175f558), {
        value: (0, $01099572ffa9156b$export$4659b591c19bdf3d)(f, {
            [0]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open,
            [1]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closed
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(b, null, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: M,
        slot: m,
        defaultTag: $42e7a5d8f911b531$var$we,
        name: "Popover"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(T.MainTreeNode, null))))));
}
let $42e7a5d8f911b531$var$We = "button";
function $42e7a5d8f911b531$var$Ke(t, o) {
    let u = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: M = `headlessui-popover-button-${u}`, ...x } = t, [n, e] = $42e7a5d8f911b531$var$oe("Popover.Button"), { isPortalled: c } = $42e7a5d8f911b531$var$fe("Popover.Button"), f = (0, $f2Y41.useRef)(null), s = `headlessui-focus-sentinel-${(0, $8fb4eba1dcb7930e$export$f680877a34711e37)()}`, I = $42e7a5d8f911b531$var$Ee(), a = I == null ? void 0 : I.closeOthers, y = $42e7a5d8f911b531$var$Ne() !== null;
    (0, $f2Y41.useEffect)(()=>{
        if (!y) return e({
            type: 3,
            buttonId: M
        }), ()=>{
            e({
                type: 3,
                buttonId: null
            });
        };
    }, [
        y,
        M,
        e
    ]);
    let [A] = (0, $f2Y41.useState)(()=>Symbol()), P = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(f, o, y ? null : (r)=>{
        if (r) n.buttons.current.push(A);
        else {
            let m = n.buttons.current.indexOf(A);
            m !== -1 && n.buttons.current.splice(m, 1);
        }
        n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), r && e({
            type: 2,
            button: r
        });
    }), p = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(f, o), E = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(f), F = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        var m, g, B;
        if (y) {
            if (n.popoverState === 1) return;
            switch(r.key){
                case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
                case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), (g = (m = r.target).click) == null || g.call(m), e({
                        type: 1
                    }), (B = n.button) == null || B.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
                    type: 0
                });
                break;
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Escape:
                if (n.popoverState !== 0) return a == null ? void 0 : a(n.buttonId);
                if (!f.current || E != null && E.activeElement && !f.current.contains(E.activeElement)) return;
                r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                });
                break;
        }
    }), D = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        y || r.key === (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space && r.preventDefault();
    }), _ = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        var m, g;
        (0, $d8956e419f398824$export$db61f031a278447c)(r.currentTarget) || t.disabled || (y ? (e({
            type: 1
        }), (m = n.button) == null || m.focus()) : (r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
            type: 0
        }), (g = n.button) == null || g.focus()));
    }), O = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        r.preventDefault(), r.stopPropagation();
    }), L = n.popoverState === 0, $ = (0, $f2Y41.useMemo)(()=>({
            open: L
        }), [
        L
    ]), i = (0, $00f3e4c5862b3e5b$export$53652b2b272efe9c)(t, f), b = y ? {
        ref: p,
        type: i,
        onKeyDown: F,
        onClick: _
    } : {
        ref: P,
        id: n.buttonId,
        type: i,
        "aria-expanded": n.popoverState === 0,
        "aria-controls": n.panel ? n.panelId : void 0,
        onKeyDown: F,
        onKeyUp: D,
        onClick: _,
        onMouseDown: O
    }, T = (0, $a2ca7c5cfdcfbeeb$export$19b797546aece48f)(), d = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        let r = n.panel;
        if (!r) return;
        function m() {
            (0, $01099572ffa9156b$export$4659b591c19bdf3d)(T.current, {
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(r, (0, $4d75beccbbd4c437$export$807a7eae502106e7).First),
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(r, (0, $4d75beccbbd4c437$export$807a7eae502106e7).Last)
            }) === (0, $4d75beccbbd4c437$export$abf286375dfa6dbd).Error && (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)((0, $4d75beccbbd4c437$export$433aaa1f216cf32d)().filter((B)=>B.dataset.headlessuiFocusGuard !== "true"), (0, $01099572ffa9156b$export$4659b591c19bdf3d)(T.current, {
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Forwards]: (0, $4d75beccbbd4c437$export$807a7eae502106e7).Next,
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Backwards]: (0, $4d75beccbbd4c437$export$807a7eae502106e7).Previous
            }), {
                relativeTo: n.button
            });
        }
        m();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).Fragment, null, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: b,
        theirProps: x,
        slot: $,
        defaultTag: $42e7a5d8f911b531$var$We,
        name: "Popover.Button"
    }), L && !y && c && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
        id: s,
        features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: d
    }));
}
let $42e7a5d8f911b531$var$je = "div", $42e7a5d8f911b531$var$Ve = (0, $43f03f8737506038$export$617d79dae526d2cf).RenderStrategy | (0, $43f03f8737506038$export$617d79dae526d2cf).Static;
function $42e7a5d8f911b531$var$$e(t, o) {
    let u = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: M = `headlessui-popover-overlay-${u}`, ...x } = t, [{ popoverState: n }, e] = $42e7a5d8f911b531$var$oe("Popover.Overlay"), c = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(o), f = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)(), s = (()=>f !== null ? (f & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open : n === 0)(), I = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((y)=>{
        if ((0, $d8956e419f398824$export$db61f031a278447c)(y.currentTarget)) return y.preventDefault();
        e({
            type: 1
        });
    }), a = (0, $f2Y41.useMemo)(()=>({
            open: n === 0
        }), [
        n
    ]);
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: M,
            "aria-hidden": !0,
            onClick: I
        },
        theirProps: x,
        slot: a,
        defaultTag: $42e7a5d8f911b531$var$je,
        features: $42e7a5d8f911b531$var$Ve,
        visible: s,
        name: "Popover.Overlay"
    });
}
let $42e7a5d8f911b531$var$Je = "div", $42e7a5d8f911b531$var$Xe = (0, $43f03f8737506038$export$617d79dae526d2cf).RenderStrategy | (0, $43f03f8737506038$export$617d79dae526d2cf).Static;
function $42e7a5d8f911b531$var$Ye(t, o) {
    let u = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: M = `headlessui-popover-panel-${u}`, focus: x = !1, ...n } = t, [e, c] = $42e7a5d8f911b531$var$oe("Popover.Panel"), { close: f, isPortalled: s } = $42e7a5d8f911b531$var$fe("Popover.Panel"), I = `headlessui-focus-sentinel-before-${(0, $8fb4eba1dcb7930e$export$f680877a34711e37)()}`, a = `headlessui-focus-sentinel-after-${(0, $8fb4eba1dcb7930e$export$f680877a34711e37)()}`, v = (0, $f2Y41.useRef)(null), y = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(v, o, (i)=>{
        c({
            type: 4,
            panel: i
        });
    }), A = (0, $d6faca5411d2a17f$export$dd9fbcea3de0ae36)(v), P = (0, $43f03f8737506038$export$81218df071161f0a)();
    (0, $8bfa4e5c53a50bc6$export$ce5ed857c741fd71)(()=>(c({
            type: 5,
            panelId: M
        }), ()=>{
            c({
                type: 5,
                panelId: null
            });
        }), [
        M,
        c
    ]);
    let p = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)(), E = (()=>p !== null ? (p & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open : e.popoverState === 0)(), F = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((i)=>{
        var b;
        switch(i.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Escape:
                if (e.popoverState !== 0 || !v.current || A != null && A.activeElement && !v.current.contains(A.activeElement)) return;
                i.preventDefault(), i.stopPropagation(), c({
                    type: 1
                }), (b = e.button) == null || b.focus();
                break;
        }
    });
    (0, $f2Y41.useEffect)(()=>{
        var i;
        t.static || e.popoverState === 1 && ((i = t.unmount) == null || i) && c({
            type: 4,
            panel: null
        });
    }, [
        e.popoverState,
        t.unmount,
        t.static,
        c
    ]), (0, $f2Y41.useEffect)(()=>{
        if (e.__demoMode || !x || e.popoverState !== 0 || !v.current) return;
        let i = A == null ? void 0 : A.activeElement;
        v.current.contains(i) || (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(v.current, (0, $4d75beccbbd4c437$export$807a7eae502106e7).First);
    }, [
        e.__demoMode,
        x,
        v,
        e.popoverState
    ]);
    let D = (0, $f2Y41.useMemo)(()=>({
            open: e.popoverState === 0,
            close: f
        }), [
        e,
        f
    ]), _ = {
        ref: y,
        id: M,
        onKeyDown: F,
        onBlur: x && e.popoverState === 0 ? (i)=>{
            var T, d, r, m, g;
            let b = i.relatedTarget;
            b && v.current && ((T = v.current) != null && T.contains(b) || (c({
                type: 1
            }), ((r = (d = e.beforePanelSentinel.current) == null ? void 0 : d.contains) != null && r.call(d, b) || (g = (m = e.afterPanelSentinel.current) == null ? void 0 : m.contains) != null && g.call(m, b)) && b.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1
    }, O = (0, $a2ca7c5cfdcfbeeb$export$19b797546aece48f)(), L = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        let i = v.current;
        if (!i) return;
        function b() {
            (0, $01099572ffa9156b$export$4659b591c19bdf3d)(O.current, {
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var d;
                    (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(i, (0, $4d75beccbbd4c437$export$807a7eae502106e7).First) === (0, $4d75beccbbd4c437$export$abf286375dfa6dbd).Error && ((d = e.afterPanelSentinel.current) == null || d.focus());
                },
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var T;
                    (T = e.button) == null || T.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        b();
    }), $ = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        let i = v.current;
        if (!i) return;
        function b() {
            (0, $01099572ffa9156b$export$4659b591c19bdf3d)(O.current, {
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var B;
                    if (!e.button) return;
                    let T = (0, $4d75beccbbd4c437$export$433aaa1f216cf32d)(), d = T.indexOf(e.button), r = T.slice(0, d + 1), g = [
                        ...T.slice(d + 1),
                        ...r
                    ];
                    for (let l of g.slice())if (l.dataset.headlessuiFocusGuard === "true" || (B = e.panel) != null && B.contains(l)) {
                        let S = g.indexOf(l);
                        S !== -1 && g.splice(S, 1);
                    }
                    (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(g, (0, $4d75beccbbd4c437$export$807a7eae502106e7).First, {
                        sorted: !1
                    });
                },
                [(0, $a2ca7c5cfdcfbeeb$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var d;
                    (0, $4d75beccbbd4c437$export$82e1f4f412218a1d)(i, (0, $4d75beccbbd4c437$export$807a7eae502106e7).Previous) === (0, $4d75beccbbd4c437$export$abf286375dfa6dbd).Error && ((d = e.button) == null || d.focus());
                }
            });
        }
        b();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($42e7a5d8f911b531$var$re.Provider, {
        value: M
    }, E && s && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
        id: I,
        ref: e.beforePanelSentinel,
        features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: L
    }), (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        mergeRefs: P,
        ourProps: _,
        theirProps: n,
        slot: D,
        defaultTag: $42e7a5d8f911b531$var$Je,
        features: $42e7a5d8f911b531$var$Xe,
        visible: E,
        name: "Popover.Panel"
    }), E && s && (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $442d8163a4865c09$export$8dc98ba7eadeaa56), {
        id: a,
        ref: e.afterPanelSentinel,
        features: (0, $442d8163a4865c09$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: $
    }));
}
let $42e7a5d8f911b531$var$qe = "div";
function $42e7a5d8f911b531$var$ze(t, o) {
    let u = (0, $f2Y41.useRef)(null), M = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(u, o), [x, n] = (0, $f2Y41.useState)([]), e = (0, $b0f5336b343de017$export$64db24433d7f4942)(), c = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((P)=>{
        n((p)=>{
            let E = p.indexOf(P);
            if (E !== -1) {
                let F = p.slice();
                return F.splice(E, 1), F;
            }
            return p;
        });
    }), f = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((P)=>(n((p)=>[
                ...p,
                P
            ]), ()=>c(P))), s = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)(()=>{
        var E;
        let P = (0, $225dec9ff04e4a5b$export$b204af158042fbac)(u);
        if (!P) return !1;
        let p = P.activeElement;
        return (E = u.current) != null && E.contains(p) ? !0 : x.some((F)=>{
            var D, _;
            return ((D = P.getElementById(F.buttonId.current)) == null ? void 0 : D.contains(p)) || ((_ = P.getElementById(F.panelId.current)) == null ? void 0 : _.contains(p));
        });
    }), I = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((P)=>{
        for (let p of x)p.buttonId.current !== P && p.close();
    }), a = (0, $f2Y41.useMemo)(()=>({
            registerPopover: f,
            unregisterPopover: c,
            isFocusWithinPopoverGroup: s,
            closeOthers: I,
            mainTreeNodeRef: e.mainTreeNodeRef
        }), [
        f,
        c,
        s,
        I,
        e.mainTreeNodeRef
    ]), v = (0, $f2Y41.useMemo)(()=>({}), []), y = t, A = {
        ref: M
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($42e7a5d8f911b531$var$Pe.Provider, {
        value: a
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: A,
        theirProps: y,
        slot: v,
        defaultTag: $42e7a5d8f911b531$var$qe,
        name: "Popover.Group"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement(e.MainTreeNode, null));
}
let $42e7a5d8f911b531$var$Qe = (0, $43f03f8737506038$export$e43f39796049410c)($42e7a5d8f911b531$var$Ue), $42e7a5d8f911b531$var$Ze = (0, $43f03f8737506038$export$e43f39796049410c)($42e7a5d8f911b531$var$Ke), $42e7a5d8f911b531$var$et = (0, $43f03f8737506038$export$e43f39796049410c)($42e7a5d8f911b531$var$$e), $42e7a5d8f911b531$var$tt = (0, $43f03f8737506038$export$e43f39796049410c)($42e7a5d8f911b531$var$Ye), $42e7a5d8f911b531$var$ot = (0, $43f03f8737506038$export$e43f39796049410c)($42e7a5d8f911b531$var$ze), $42e7a5d8f911b531$export$5b6b19405a83ff9d = Object.assign($42e7a5d8f911b531$var$Qe, {
    Button: $42e7a5d8f911b531$var$Ze,
    Overlay: $42e7a5d8f911b531$var$et,
    Panel: $42e7a5d8f911b531$var$tt,
    Group: $42e7a5d8f911b531$var$ot
});





var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
function $6cc75fc5dc37e293$export$2e2bcd8739ae039() {
    const [currentMode, setCurrentMode] = (0, $f2Y41.useState)(localStorage.theme || "auto");
    const handleClick = (mode)=>{
        if (mode === "auto") localStorage.removeItem("theme");
        else localStorage.setItem("theme", mode);
        window.dispatchEvent(new Event("storage"));
        setCurrentMode(localStorage.theme || "auto");
        handleThemeChange();
    };
    const handleThemeChange = ()=>{
        if (localStorage.theme === "dark" || !("theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            document.documentElement.classList.add("dark");
            document.documentElement.classList.add("bg-gray-800");
        } else {
            document.documentElement.classList.remove("dark");
            document.documentElement.classList.remove("bg-gray-800");
        }
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
        className: "isolate inline-flex rounded-md px-2 my-2",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                type: "button",
                className: `${currentMode === "dark" ? "dark:bg-gray-500 bg-gray-200" : ""} relative inline-flex items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                onClick: ()=>handleClick("dark"),
                children: "Dark \uD83C\uDF1A"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                type: "button",
                className: `${currentMode === "light" ? "dark:bg-gray-500 bg-gray-200" : ""} relative -ml-px inline-flex items-center border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                onClick: ()=>handleClick("light"),
                children: "Light \uD83D\uDCA1"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                type: "button",
                className: `${currentMode === "auto" ? "dark:bg-gray-500 bg-gray-200" : ""} relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                title: "Follows setting set in System Preferences",
                onClick: ()=>handleClick("auto"),
                children: "Auto \u2699\uFE0F"
            })
        ]
    });
}




var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");

function $470f93728b564498$export$2e2bcd8739ae039() {
    const [joy, setJoy] = (0, $f2Y41.useState)(localStorage.joy || "false");
    const { triggerConfetti: triggerConfetti } = (0, $3d94fb79f2ee28b7$export$81073d529bbe4dc7)();
    const handleClick = (mode)=>{
        localStorage.setItem("joy", mode);
        window.dispatchEvent(new Event("storage"));
        setJoy(localStorage.joy || "false");
        triggerConfetti();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "rounded-md flex min-w-full h-16 pb-2 px-2 justify-center",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                type: "button",
                className: `${joy === "true" ? "dark:bg-gray-500 bg-gray-200" : ""} w-1/2  items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                onClick: ()=>handleClick("true"),
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        children: "Joy"
                    }),
                    " \uD83E\uDD84"
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                type: "button",
                className: `${joy === "false" ? "dark:bg-gray-500 bg-gray-200" : ""} w-1/2 -ml-px  items-center rounded-r-md border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                onClick: ()=>handleClick("false"),
                children: "No Joy \uD83E\uDEE1"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
var $47e14997d0d4d6e1$exports = {};

$47e14997d0d4d6e1$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "logo-full-white.da372c6a.svg";


const $9b48bcd938b0b2d4$var$logoWhiteUrl = new URL($47e14997d0d4d6e1$exports);
var $10a83433c3fedb00$exports = {};

$10a83433c3fedb00$exports = (parcelRequire("2bbU7")).getBundleURL("3ky57") + "logo-full-color.a6c7b3aa.svg";


const $9b48bcd938b0b2d4$var$logoColorUrl = new URL($10a83433c3fedb00$exports);
function $9b48bcd938b0b2d4$export$eed26074b425133a({ className: className = "" }) {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                className: `${className} block dark:hidden p-0.5 h-12`,
                src: $9b48bcd938b0b2d4$var$logoColorUrl,
                alt: "logo"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("img", {
                className: `${className} dark:block hidden p-0.5 h-12`,
                src: $9b48bcd938b0b2d4$var$logoWhiteUrl,
                alt: "logo"
            })
        ]
    });
}




var $ge3KO = parcelRequire("ge3KO");


function $c4d2bc17f34e11a3$export$e425967b47a2f66e() {
    const joy = (0, $e0b7fdb4f7d93cbe$export$60240ee1e969690a)();
    // https://stackoverflow.com/a/54501026
    const monthDay = (month, day)=>({
            month: month,
            day: day
        });
    const toMonthDay = (date)=>monthDay(date.getMonth(), date.getDate());
    const before = (md1, md2)=>md1.month < md2.month || md1.month === md2.month && md1.day <= md2.day;
    const after = (md1, md2)=>!before(md1, md2);
    const between = (mdX, mdLow, mdHigh)=>after(mdX, mdLow) && before(mdX, mdHigh);
    const season = (date, seasons)=>((md = toMonthDay(date))=>Object.keys(seasons).find((season)=>seasons[season](md)))();
    const MARCH_EQUINOX = monthDay(2, 20);
    const JUNE_SOLSTICE = monthDay(5, 21);
    const SEPTEMBER_EQUINOX = monthDay(8, 23);
    const DECEMBER_SOLSTICE = monthDay(11, 21);
    const NEW_YEAR = monthDay(0, 1);
    const seasons = {
        spring: (d)=>between(d, MARCH_EQUINOX, JUNE_SOLSTICE),
        summer: (d)=>between(d, JUNE_SOLSTICE, SEPTEMBER_EQUINOX),
        fall: (d)=>between(d, SEPTEMBER_EQUINOX, DECEMBER_SOLSTICE),
        winter: (d)=>between(d, DECEMBER_SOLSTICE, NEW_YEAR) || between(d, NEW_YEAR, MARCH_EQUINOX)
    };
    const seasonNow = season(new Date(), seasons);
    const renderObject = {
        spring: {
            emoji: "\uD83C\uDF37"
        },
        summer: {
            emoji: "\uD83D\uDD05"
        },
        fall: {
            emoji: "\uD83C\uDF42"
        },
        winter: {
            emoji: "\u2603\uFE0F"
        }
    };
    if (!joy) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    if (!seasonNow) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "hover:cursor-pointer",
        title: `Happy ${(0, $48358001e7c1220f$exports.titleCase)(seasonNow)}!`,
        children: renderObject[seasonNow]?.emoji
    });
}


/* This example requires Tailwind CSS v2.0+ */ 
var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");



const $3366964b70ffaf65$export$6cd530ed55e06764 = async ({ eventName: eventName, meta: meta = {}, getAccessTokenSilently: getAccessTokenSilently })=>{
    const data = {
        name: eventName,
        meta: meta
    };
    (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("events", data, getAccessTokenSilently);
};






var $ge3KO = parcelRequire("ge3KO");
var $baae59ad9f032635$exports = {};
"use strict";
function $baae59ad9f032635$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $baae59ad9f032635$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $baae59ad9f032635$var$_typeof(obj);
}
Object.defineProperty($baae59ad9f032635$exports, "__esModule", {
    value: true
});
$baae59ad9f032635$exports["default"] = void 0;

var $baae59ad9f032635$var$_react = $baae59ad9f032635$var$_interopRequireWildcard((parcelRequire("f2Y41")));
var $dd47e79dff577efc$exports = {};
"use strict";
Object.defineProperty($dd47e79dff577efc$exports, "__esModule", {
    value: true
});
$dd47e79dff577efc$exports.targetFrameTime = $dd47e79dff577efc$exports.snowfallBaseStyle = void 0;
var $dd47e79dff577efc$var$snowfallBaseStyle = {
    pointerEvents: "none",
    backgroundColor: "transparent",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
}; // Target of 60 frames per second
$dd47e79dff577efc$exports.snowfallBaseStyle = $dd47e79dff577efc$var$snowfallBaseStyle;
var $dd47e79dff577efc$var$targetFrameTime = 1000 / 60;
$dd47e79dff577efc$exports.targetFrameTime = $dd47e79dff577efc$var$targetFrameTime;


var $10dc483b6f99cd31$exports = {};
"use strict";
Object.defineProperty($10dc483b6f99cd31$exports, "__esModule", {
    value: true
});
$10dc483b6f99cd31$exports.useComponentSize = void 0;
$10dc483b6f99cd31$exports.useDeepCompareEffect = $10dc483b6f99cd31$var$useDeepCompareEffect;
$10dc483b6f99cd31$exports.useDeepMemo = $10dc483b6f99cd31$var$useDeepMemo;
$10dc483b6f99cd31$exports.useSnowflakes = $10dc483b6f99cd31$exports.useSnowfallStyle = void 0;

var $f2Y41 = parcelRequire("f2Y41");

var $10dc483b6f99cd31$var$_reactFastCompare = $10dc483b6f99cd31$var$_interopRequireDefault((parcelRequire("hPN9t")));

var $10dc483b6f99cd31$var$_Snowflake = $10dc483b6f99cd31$var$_interopRequireDefault((parcelRequire("jKgMX")));


var $gryJc = parcelRequire("gryJc");
function $10dc483b6f99cd31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $10dc483b6f99cd31$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $10dc483b6f99cd31$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $10dc483b6f99cd31$var$ownKeys(Object(source), !0).forEach(function(key) {
            $10dc483b6f99cd31$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $10dc483b6f99cd31$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $10dc483b6f99cd31$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $10dc483b6f99cd31$var$_toConsumableArray(arr) {
    return $10dc483b6f99cd31$var$_arrayWithoutHoles(arr) || $10dc483b6f99cd31$var$_iterableToArray(arr) || $10dc483b6f99cd31$var$_unsupportedIterableToArray(arr) || $10dc483b6f99cd31$var$_nonIterableSpread();
}
function $10dc483b6f99cd31$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $10dc483b6f99cd31$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $10dc483b6f99cd31$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $10dc483b6f99cd31$var$_arrayLikeToArray(arr);
}
function $10dc483b6f99cd31$var$_slicedToArray(arr, i) {
    return $10dc483b6f99cd31$var$_arrayWithHoles(arr) || $10dc483b6f99cd31$var$_iterableToArrayLimit(arr, i) || $10dc483b6f99cd31$var$_unsupportedIterableToArray(arr, i) || $10dc483b6f99cd31$var$_nonIterableRest();
}
function $10dc483b6f99cd31$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $10dc483b6f99cd31$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $10dc483b6f99cd31$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $10dc483b6f99cd31$var$_arrayLikeToArray(o, minLen);
}
function $10dc483b6f99cd31$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $10dc483b6f99cd31$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $10dc483b6f99cd31$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * A utility function to create a collection of snowflakes
 * @param canvasRef A ref to the canvas element
 * @param amount The number of snowflakes
 * @param config The configuration for each snowflake
 */ var $10dc483b6f99cd31$var$createSnowflakes = function createSnowflakes(canvasRef, amount, config) {
    if (!canvasRef.current) return [];
    var snowflakes = [];
    for(var i = 0; i < amount; i++)snowflakes.push(new $10dc483b6f99cd31$var$_Snowflake["default"](canvasRef.current, config));
    return snowflakes;
};
/**
 * A utility hook to manage creating and updating a collection of snowflakes
 * @param canvasRef A ref to the canvas element
 * @param amount The number of snowflakes
 * @param config The configuration for each snowflake
 */ var $10dc483b6f99cd31$var$useSnowflakes = function useSnowflakes(canvasRef, amount, config) {
    var _useState = (0, $f2Y41.useState)([]), _useState2 = $10dc483b6f99cd31$var$_slicedToArray(_useState, 2), snowflakes = _useState2[0], setSnowflakes = _useState2[1]; // Handle change of amount
    (0, $f2Y41.useEffect)(function() {
        setSnowflakes(function(snowflakes) {
            var sizeDifference = amount - snowflakes.length;
            if (sizeDifference > 0) return [].concat($10dc483b6f99cd31$var$_toConsumableArray(snowflakes), $10dc483b6f99cd31$var$_toConsumableArray($10dc483b6f99cd31$var$createSnowflakes(canvasRef, sizeDifference, config)));
            if (sizeDifference < 0) return snowflakes.slice(0, amount);
            return snowflakes;
        });
    }, [
        amount,
        canvasRef,
        config
    ]); // Handle change of config
    (0, $f2Y41.useEffect)(function() {
        setSnowflakes(function(snowflakes) {
            return snowflakes.map(function(snowflake) {
                snowflake.updateConfig(config);
                return snowflake;
            });
        });
    }, [
        config
    ]);
    return snowflakes;
};
/**
 * Returns the height and width of a HTML element, uses the `ResizeObserver` api if available to detect changes to the
 * size. Falls back to listening for resize events on the window.
 * @param ref A ref to the HTML element to be measured
 */ $10dc483b6f99cd31$exports.useSnowflakes = $10dc483b6f99cd31$var$useSnowflakes;
var $10dc483b6f99cd31$var$useComponentSize = function useComponentSize(ref) {
    var _useState3 = (0, $f2Y41.useState)((0, $gryJc.getSize)(ref.current)), _useState4 = $10dc483b6f99cd31$var$_slicedToArray(_useState3, 2), size = _useState4[0], setSize = _useState4[1];
    var resizeHandler = (0, $f2Y41.useCallback)(function() {
        if (ref.current) setSize((0, $gryJc.getSize)(ref.current));
    }, [
        ref
    ]);
    (0, $f2Y41.useLayoutEffect)(function() {
        var _window = window, ResizeObserver = _window.ResizeObserver;
        if (!ref.current) return;
        resizeHandler();
        if (typeof ResizeObserver === "function") {
            var resizeObserver = new ResizeObserver(resizeHandler);
            resizeObserver.observe(ref.current);
            return function() {
                return resizeObserver.disconnect();
            };
        } else {
            window.addEventListener("resize", resizeHandler);
            return function() {
                return window.removeEventListener("resize", resizeHandler);
            };
        }
    }, [
        ref,
        resizeHandler
    ]);
    return size;
};
/**
 * Utility hook that merges any provided styles with the default styles
 * @param overrides The style prop passed into the component
 */ $10dc483b6f99cd31$exports.useComponentSize = $10dc483b6f99cd31$var$useComponentSize;
var $10dc483b6f99cd31$var$useSnowfallStyle = function useSnowfallStyle(overrides) {
    var styles = (0, $f2Y41.useMemo)(function() {
        return $10dc483b6f99cd31$var$_objectSpread($10dc483b6f99cd31$var$_objectSpread({}, $dd47e79dff577efc$exports.snowfallBaseStyle), overrides || {});
    }, [
        overrides
    ]);
    return styles;
};
/**
 * Same as `React.useEffect` but uses a deep comparison on the dependency array. This should only
 * be used when working with non-primitive dependencies.
 *
 * @param effect Effect callback to run
 * @param deps Effect dependencies
 */ $10dc483b6f99cd31$exports.useSnowfallStyle = $10dc483b6f99cd31$var$useSnowfallStyle;
function $10dc483b6f99cd31$var$useDeepCompareEffect(effect, deps) {
    var ref = (0, $f2Y41.useRef)(deps); // Only update the current dependencies if they are not deep equal
    if (!(0, $10dc483b6f99cd31$var$_reactFastCompare["default"])(deps, ref.current)) ref.current = deps;
     // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $f2Y41.useEffect)(effect, ref.current);
}
/**
 * Utility hook to stabilize a reference to a value, the returned value will always match the input value
 * but (unlike an inline object) will maintain [SameValueZero](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * equality until a change is made.
 *
 * @example
 *
 * const obj = useDeepMemo({ foo: 'bar', bar: 'baz' }) // <- inline object creation
 * const prevValue = usePrevious(obj) // <- value from the previous render
 * console.log(obj === prevValue) // <- always logs true until value changes
 */ function $10dc483b6f99cd31$var$useDeepMemo(value) {
    var _useState5 = (0, $f2Y41.useState)(value), _useState6 = $10dc483b6f99cd31$var$_slicedToArray(_useState5, 2), state = _useState6[0], setState = _useState6[1];
    $10dc483b6f99cd31$var$useDeepCompareEffect(function() {
        return setState(value);
    }, [
        value
    ]);
    return state;
}



var $jKgMX = parcelRequire("jKgMX");
function $baae59ad9f032635$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($baae59ad9f032635$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $baae59ad9f032635$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $baae59ad9f032635$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $baae59ad9f032635$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $baae59ad9f032635$var$Snowfall = function Snowfall() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$color = _ref.color, color = _ref$color === void 0 ? $jKgMX.defaultConfig.color : _ref$color, _ref$changeFrequency = _ref.changeFrequency, changeFrequency = _ref$changeFrequency === void 0 ? $jKgMX.defaultConfig.changeFrequency : _ref$changeFrequency, _ref$radius = _ref.radius, radius = _ref$radius === void 0 ? $jKgMX.defaultConfig.radius : _ref$radius, _ref$speed = _ref.speed, speed = _ref$speed === void 0 ? $jKgMX.defaultConfig.speed : _ref$speed, _ref$wind = _ref.wind, wind = _ref$wind === void 0 ? $jKgMX.defaultConfig.wind : _ref$wind, _ref$rotationSpeed = _ref.rotationSpeed, rotationSpeed = _ref$rotationSpeed === void 0 ? $jKgMX.defaultConfig.rotationSpeed : _ref$rotationSpeed, _ref$snowflakeCount = _ref.snowflakeCount, snowflakeCount = _ref$snowflakeCount === void 0 ? 150 : _ref$snowflakeCount, images = _ref.images, style = _ref.style;
    var mergedStyle = (0, $10dc483b6f99cd31$exports.useSnowfallStyle)(style);
    var canvasRef = (0, $baae59ad9f032635$var$_react.useRef)(null);
    var canvasSize = (0, $10dc483b6f99cd31$exports.useComponentSize)(canvasRef);
    var animationFrame = (0, $baae59ad9f032635$var$_react.useRef)(0);
    var lastUpdate = (0, $baae59ad9f032635$var$_react.useRef)(Date.now());
    var config = (0, $10dc483b6f99cd31$exports.useDeepMemo)({
        color: color,
        changeFrequency: changeFrequency,
        radius: radius,
        speed: speed,
        wind: wind,
        rotationSpeed: rotationSpeed,
        images: images
    });
    var snowflakes = (0, $10dc483b6f99cd31$exports.useSnowflakes)(canvasRef, snowflakeCount, config);
    var render = (0, $baae59ad9f032635$var$_react.useCallback)(function() {
        var framesPassed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var canvas = canvasRef.current;
        if (canvas) {
            // Update the positions of the snowflakes
            snowflakes.forEach(function(snowflake) {
                return snowflake.update(canvas, framesPassed);
            }); // Render them if the canvas is available
            var ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
                snowflakes.forEach(function(snowflake) {
                    return snowflake.draw(ctx);
                });
            }
        }
    }, [
        snowflakes
    ]);
    var loop = (0, $baae59ad9f032635$var$_react.useCallback)(function() {
        // Update based on time passed so that a slow frame rate won't slow down the snowflake
        var now = Date.now();
        var msPassed = Date.now() - lastUpdate.current;
        lastUpdate.current = now; // Frames that would have passed if running at 60 fps
        var framesPassed = msPassed / $dd47e79dff577efc$exports.targetFrameTime;
        render(framesPassed);
        animationFrame.current = requestAnimationFrame(loop);
    }, [
        render
    ]);
    (0, $baae59ad9f032635$var$_react.useEffect)(function() {
        loop();
        return function() {
            return cancelAnimationFrame(animationFrame.current);
        };
    }, [
        loop
    ]);
    return /*#__PURE__*/ $baae59ad9f032635$var$_react["default"].createElement("canvas", {
        ref: canvasRef,
        height: canvasSize.height,
        width: canvasSize.width,
        style: mergedStyle,
        "data-testid": "SnowfallCanvas"
    });
};
var $baae59ad9f032635$var$_default = $baae59ad9f032635$var$Snowfall;
$baae59ad9f032635$exports["default"] = $baae59ad9f032635$var$_default;



var $f2Y41 = parcelRequire("f2Y41");
const $0acfd5bb8ef065cd$var$localStorageSnow = ()=>"snow" in localStorage && localStorage.snow === "true";
function $0acfd5bb8ef065cd$export$68740c2077e7f496() {
    const [prefersSnow, setPrefersSnow] = (0, $f2Y41.useState)($0acfd5bb8ef065cd$var$localStorageSnow());
    (0, $f2Y41.useEffect)(()=>{
        function handleChangeStorage() {
            setPrefersSnow($0acfd5bb8ef065cd$var$localStorageSnow());
        }
        window.addEventListener("storage", handleChangeStorage);
        return ()=>window.removeEventListener("storage", handleChangeStorage);
    }, []);
    return prefersSnow;
}


function $64be84d99e0495b6$export$9a4d4afda79eb95a() {
    const letItSnow = (0, $0acfd5bb8ef065cd$export$68740c2077e7f496)();
    if (letItSnow) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($baae59ad9f032635$exports))), {
            color: "#c7eeff",
            radius: [
                0.25,
                1
            ],
            speed: [
                0.05,
                0.5
            ],
            wind: [
                -0.05,
                0.05
            ]
        })
    });
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
}


function $03ee96426087387b$export$2e2bcd8739ae039(props) {
    const [expanded, setExpanded] = (0, $f2Y41.useState)(true);
    const [referralCount, setReferralCount] = (0, $f2Y41.useState)(null);
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const [referralBookmarkId, setReferralBookmarkId] = (0, $f2Y41.useState)("");
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser, practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    (0, $f2Y41.useEffect)(()=>{
        if (!practiceId || !getAccessTokenSilently) return;
        const createReferralBookmark = async ()=>{
            const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("filter_and_sort_bookmark", {
                filter_and_sort: {
                    filtering: {
                        filters: [
                            {
                                field: "status",
                                operator_value: "equals",
                                value: "provider_referral"
                            }
                        ]
                    },
                    practice_id: practiceId,
                    search: "",
                    sorting: []
                }
            }, getAccessTokenSilently);
            setReferralBookmarkId(response?.data?.data?.id);
        };
        createReferralBookmark();
        return ()=>{};
    }, [
        practiceId,
        getAccessTokenSilently
    ]);
    const { data: referralQueryCount } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)(referralBookmarkId && practiceId && "patients_filter_and_sort_count", referralBookmarkId, `practice_id=${practiceId}`);
    if (isLoadingCurrentUser) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    const navigation = [
        {
            name: "Directory",
            icon: (0, $d411d8c712330d41$export$2e2bcd8739ae039),
            requiresAdmin: false,
            href: "/patients"
        },
        {
            name: "Referrals",
            icon: (0, $d85e3f0109065bc6$export$2e2bcd8739ae039),
            requiresAdmin: false,
            href: "/referrals",
            badge: referralQueryCount?.count?.toString()
        },
        {
            name: "Quality Assurance",
            icon: (0, $1ae501856415166c$export$2e2bcd8739ae039),
            requiresAdmin: false,
            requiresQa: true,
            href: "/quality-assurance"
        },
        // {
        //   name: 'Kanban',
        //   icon: CollectionIcon,
        //   requiresAdmin: false,
        //   href: '/kanban',
        //   // children: [
        //   //   // { name: 'Directory', href: '/patients' },
        //   //   // { name: 'Kanban', href: '/patient_cards' },
        //   //   // { name: 'Appointments', href: '/appointments' },
        //   //   // { name: 'Quick Add', href: '/patients?modal=new' },
        //   //   // { name: 'Uploader', href: '/uploads' },
        //   // ],
        // },
        {
            name: "Dashboard",
            icon: (0, $0119b085273cd379$export$2e2bcd8739ae039),
            requiresAdmin: false,
            href: "/dashboard"
        },
        {
            name: "Calendar",
            icon: (0, $492388e9c47d257b$export$2e2bcd8739ae039),
            requiresAdmin: false,
            href: "/calendar"
        },
        {
            name: "Studies",
            icon: (0, $9b2402d2885426d7$export$2e2bcd8739ae039),
            requiresAdmin: false,
            href: "/studies"
        },
        {
            name: "Sponsors",
            icon: (0, $fe7bd221dcce92a0$export$2e2bcd8739ae039),
            requiresAdmin: false,
            href: "/sponsors"
        },
        // {
        //   name: 'Notifications',
        //   icon: InboxInIcon,
        //   current: false,
        //   href: '/notifications',
        //   rightContent: <Badge>1</Badge>
        // },
        // {
        //   name: 'Tasks',
        //   icon: CheckCircleIcon,
        //   current: false,
        //   href: '/tasks',
        //   // children: [
        //   //   // { name: 'View All', href: '/tasks' },
        //   //   // { name: 'Quick Add', href: '/tasks?modal=new' },
        //   // ],
        // },
        {
            name: "Admin",
            icon: (0, $7979fbc81d6e23bf$export$2e2bcd8739ae039),
            requiresAdmin: true,
            href: "/admin"
        }
    ];
    // TODO: function that loops through nav and assigns open Boolean to top level nav, and current boolean to children
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    const clickEvent = async (name)=>{
        await (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "Click",
            meta: {
                element: `Nav${name.replace(/\s/g, "")}`
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
    };
    const handleNavExpand = ()=>{
        expanded ? clickEvent("Collapse") : clickEvent("Expand");
        setExpanded(!expanded);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: classNames(expanded ? "w-36" : "w-[4rem]", "hidden md:flex md:flex-row md:inset-y-0 transition-all duration-500"),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: classNames(expanded ? "" : "", "dark:border-gray-700 flex flex-col flex-grow pt-2 pb-4 no-scrollbar"),
            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-grow flex flex-col",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "relative h-full",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: `flex hover:cursor-pointer ${expanded ? "justify-end mr-2" : "justify-center "}`,
                            onClick: ()=>handleNavExpand(),
                            onKeyUp: ()=>handleNavExpand(),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: expanded ? "ChevronLeftIcon" : "ChevronRightIcon",
                                className: `w-6 h-6 ${expanded ? "text-gray-900" : "text-gray-900"}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $64be84d99e0495b6$export$9a4d4afda79eb95a), {}),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("nav", {
                            className: "flex-1 px-2 space-y-1",
                            "aria-label": "Sidebar",
                            children: navigation.map((item)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: item.requiresAdmin && !(0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser) || item?.requiresQa && !(0, $601cdae3149c9149$export$3fc5baa28a2e276c)(currentUser) ? "hidden" : "",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        title: item.name,
                                        onClick: ()=>clickEvent(item.name),
                                        to: item.href,
                                        className: classNames((0, $c5383ff45095a6a6$export$6c330e8992e8a295)({
                                            path: (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(item.href).pathname
                                        }) ? "bg-white" : "bg-gray-100  hover:bg-gray-50 hover:text-gray-900", "text-gray-900 dark:text-gray-200 group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md justify-center dark:bg-gray-800 dark:hover:bg-gray-500"),
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)(item.icon, {
                                                // title={item.name}
                                                className: classNames((0, $c5383ff45095a6a6$export$6c330e8992e8a295)({
                                                    path: (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(item.href).pathname
                                                }) ? "text-gray-900" : "text-gray-900 group-hover:text-gray-200", "flex-shrink-0 h-4 w-4 dark:text-gray-200 dark:group-hover:text-gray-200"),
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: `flex items-center justify-between transition-all ${expanded ? "ml-2 flex-1" : "text-white hidden"}`,
                                                children: [
                                                    item.name,
                                                    item.badge && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "relative inline-flex items-center justify-center ml-2 py-1 px-1.5 bg-red-600 text-white text-xs rounded-full w-4 h-4",
                                                        children: item.badge
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "flex ml-2",
                                                children: item.rightContent
                                            })
                                        ]
                                    })
                                }, item.name))
                        })
                    ]
                })
            })
        })
    });
}




var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
function $1dcac9a5cc20a1cf$export$2e2bcd8739ae039() {
    const [snow, setSnow] = (0, $f2Y41.useState)(localStorage.snow || "false");
    const handleClick = (mode)=>{
        localStorage.setItem("snow", mode);
        window.dispatchEvent(new Event("storage"));
        setSnow(localStorage.snow || "true");
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "rounded-md flex min-w-full h-16 pb-2 px-2 justify-center",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                type: "button",
                className: `${snow === "true" ? "dark:bg-gray-500 bg-gray-200" : ""} w-1/2  items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                onClick: ()=>handleClick("true"),
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        children: "Snow"
                    }),
                    " \u26C4\uFE0F"
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                type: "button",
                className: `${snow === "false" ? "dark:bg-gray-500 bg-gray-200" : ""} w-1/2 -ml-px  items-center rounded-r-md border border-gray-300 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-0 focus:ring-indigo-500`,
                onClick: ()=>handleClick("false"),
                children: "No Snow \uD83C\uDF1E"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




function $7fe88aad98a23d12$export$db5d8fbac40d6cf7() {
    const { authorizedPractices: authorizedPractices, changePractice: changePractice, practiceName: practiceName, practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const selectPractice = async (practiceId)=>{
        await changePractice(practiceId);
        navigate("/home");
    };
    // TODO: Move this to authzprovider?
    const singleTenant = authorizedPractices.length <= 1;
    if (singleTenant) return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-sm font-medium pr-2 text-gray-700 dark:text-gray-200 cursor-default",
        title: practiceId,
        children: practiceName
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f), {
        as: "div",
        className: "relative inline-block text-left ml-4",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Button, {
                    className: "flex items-center rounded-full hover:cursor-pointer text-gray-700 dark:text-gray-300 hover:text-gray-600 focus:outline-none active:ring-0 active:text-gray-800 active:ring-offset-0 active:ring-offset-gray-100",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                            className: "sr-only",
                            children: "Open options"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "text-sm font-medium pr-2",
                            title: practiceName,
                            children: practiceName
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "SwitchHorizontalIcon",
                            className: "h-5 w-5",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4), {
                as: (0, $f2Y41.Fragment),
                enter: "transition ease-out duration-100",
                enterFrom: "transform opacity-0 scale-95",
                enterTo: "transform opacity-100 scale-100",
                leave: "transition ease-in duration-75",
                leaveFrom: "transform opacity-100 scale-100",
                leaveTo: "transform opacity-0 scale-95",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Items, {
                    className: "absolute left-0 z-10 mt-2 w-56 rounded-md bg-white shadow-lg  focus:outline-none",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "py-1",
                        children: !singleTenant && authorizedPractices?.map((practice)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                children: ({ active: active })=>/*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>selectPractice(practice?.id),
                                        onKeyDown: ()=>selectPractice(practice?.id),
                                        className: (0, $ab3059e3726110c9$export$ce4ab0c55987d1ff)(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "block px-4 py-2 text-sm w-full text-left"),
                                        children: practice?.name
                                    })
                            }, practice?.id))
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

function $7caf46d1a8880013$export$6c0524ba53950d9f(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a0b772244d08cba$export$e2255cf6045e8d47), {
        className: "border-2 border-white rounded-full h-9 w-9 dark:border-gray-800",
        name: props.currentUser?.name
    });
}





var $ge3KO = parcelRequire("ge3KO");


function $0ecc0f54b7a0338f$export$2e2bcd8739ae039() {
    const location = (0, $c5383ff45095a6a6$export$45d76561a5302f2b)();
    const pathnames = location.pathname.split("/").filter((path)=>path);
    const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    const isValidUUIDV4 = (str)=>uuidV4Regex.test(str);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $5b4cfec3dd23697f$export$dabcc1ec9dd9d1cc), {
        "aria-label": "Solid background breadcrumb example",
        className: "bg-gray-50 px-5 py-3 dark:bg-gray-800",
        children: [
            pathnames.length > 0 && pathnames[0] !== "home" ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $5b4cfec3dd23697f$export$dabcc1ec9dd9d1cc).Item, {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                    to: "/home",
                    children: "Home"
                })
            }, "home") : null,
            pathnames.map((name, index)=>{
                const routePath = `/${pathnames.slice(0, index + 1).join("/")}`;
                const isLast = index === pathnames.length - 1;
                let displayName = name;
                if (!isValidUUIDV4(name)) displayName = name.split("-").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
                return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $5b4cfec3dd23697f$export$dabcc1ec9dd9d1cc).Item, {
                    children: isLast ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                        children: displayName
                    }) : /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                        to: routePath,
                        children: displayName
                    })
                }, name);
            })
        ]
    });
}


const $80da8bafa816c42d$var$navigation = [
    {
        name: "Dashboard",
        href: "#",
        current: true
    },
    {
        name: "Calendar",
        href: "#",
        current: false
    },
    {
        name: "Team External References",
        href: "#",
        current: false
    },
    {
        name: "Directory",
        href: "#",
        current: false
    }
];
const $80da8bafa816c42d$var$userNavigation = [];
function $80da8bafa816c42d$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $80da8bafa816c42d$export$2e2bcd8739ae039() {
    const { logout: logout, isLoading: isLoadingAuth0User } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { isError: isErrorHealthStatus } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("status", null, {
        loadingTimeout: 10000
    });
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser, practiceName: practiceName, practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: practice } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("practices", practiceId);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingCurrentUser) return;
        if (!currentUser) return;
        if (Object.keys(currentUser).length === 0) navigate("/401");
    }, [
        currentUser,
        isLoadingCurrentUser,
        navigate
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (isErrorHealthStatus !== undefined) navigate("/404", {
            state: JSON.stringify(isErrorHealthStatus, null, 2)
        });
    }, [
        isErrorHealthStatus,
        navigate
    ]);
    if (isLoadingAuth0User) return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "p-4 h-full",
        children: "Authenticating..."
    });
    if (isLoadingCurrentUser) return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "p-4 h-full",
        children: "Authorizing..."
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3d12054b9ed86c19$exports.Toaster), {}),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $42e7a5d8f911b531$export$5b6b19405a83ff9d), {
                as: "header",
                className: ({ open: open })=>$80da8bafa816c42d$var$classNames(open ? "fixed inset-0 z-40 overflow-y-auto" : "", "bg-white shadow-sm dark:shadow-none lg:static lg:overflow-y-visible"),
                children: ({ open: open })=>/*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "max-w-0xl mx-auto px-4 dark:bg-gray-800 border-b dark:border-gray-700",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "relative flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex md:absolute md:left-0 md:inset-y-0 lg:static xl:col-span-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $64be84d99e0495b6$export$9a4d4afda79eb95a), {}),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "flex-shrink-0 flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                            className: "py-2",
                                                            href: "/",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9b48bcd938b0b2d4$export$eed26074b425133a), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            className: "ml-2",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c4d2bc17f34e11a3$export$e425967b47a2f66e), {})
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "min-w-0 flex-1 md:px-8 lg:px-0 xl:col-span-6"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "flex items-center md:absolute md:right-0 md:inset-y-0 lg:hidden",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $42e7a5d8f911b531$export$5b6b19405a83ff9d).Button, {
                                                className: "-mx-2 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open menu"
                                                    }),
                                                    open ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ad688b80368a215e$export$2e2bcd8739ae039), {
                                                        className: "block h-6 w-6",
                                                        "aria-hidden": "true"
                                                    }) : /*#__PURE__*/ (0, $ge3KO.jsx)((0, $5d4f177f2ad49a93$export$2e2bcd8739ae039), {
                                                        className: "block h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "hidden lg:flex lg:items-center lg:justify-end xl:col-span-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7fe88aad98a23d12$export$db5d8fbac40d6cf7), {}),
                                                (0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser) && /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                    title: "Events",
                                                    to: "/admin/events",
                                                    className: "ml-5 flex-shrink-0 bg-white rounded-full p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-800",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "View events"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                            icon: "RssIcon",
                                                            className: "h-6 w-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                    title: "Dashboard",
                                                    to: "/dashboard",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                        type: "button",
                                                        className: "ml-5 mr-5 flex-shrink-0 bg-white rounded-full p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-800",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "View home"
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $328c72db0bc047a6$export$2e2bcd8739ae039), {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                    title: "Waypoints Guide",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    href: "https://docs.google.com/document/d/1vubcR5mWdwg9CCqF2W8zXN6g_tuovfsObZuM81A0C6Q/edit?usp=sharing",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "InformationCircleIcon",
                                                        className: "mb-0.5 h-6 w-6 text-gray-400"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f), {
                                                    as: "div",
                                                    className: "flex-shrink-0 relative ml-5",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Button, {
                                                                className: "bg-white dark:bg-transparent cursor-pointer rounded-full flex focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                        className: "sr-only",
                                                                        children: "Open user menu"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7caf46d1a8880013$export$6c0524ba53950d9f), {
                                                                        currentUser: currentUser
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4), {
                                                            as: (0, $f2Y41.Fragment),
                                                            enter: "transition ease-out duration-100",
                                                            enterFrom: "transform opacity-0 scale-95",
                                                            enterTo: "transform opacity-100 scale-100",
                                                            leave: "transition ease-in duration-75",
                                                            leaveFrom: "transform opacity-100 scale-100",
                                                            leaveTo: "transform opacity-0 scale-95",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Items, {
                                                                className: "origin-top-right absolute z-10 right-0 mt-2 w-52 rounded-md shadow-lg dark:shadow-none bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-200 ring-1 ring-black ring-opacity-5 py-1 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                                className: "cursor-default block border-b dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700 py-2 px-4 text-sm text-gray-700",
                                                                                children: currentUser?.name
                                                                            })
                                                                    }, currentUser?.name),
                                                                    $80da8bafa816c42d$var$userNavigation.map((item)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                                                            children: ({ active: active })=>/*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                                                    href: item.href,
                                                                                    className: $80da8bafa816c42d$var$classNames(active ? "bg-gray-100" : "", "block py-4 px-6 text-sm"),
                                                                                    children: item.name
                                                                                })
                                                                        }, item.name)),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6cc75fc5dc37e293$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1dcac9a5cc20a1cf$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $470f93728b564498$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2ac7db88844efa30$export$d9b273488cd8ce6f).Item, {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                                type: "button",
                                                                                className: $80da8bafa816c42d$var$classNames(active ? "bg-gray-100" : "", "block w-full py-2 px-4 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 pt-2 border-t dark:border-gray-700"),
                                                                                onClick: ()=>{
                                                                                    localStorage.removeItem("practiceId");
                                                                                    logout({
                                                                                        logoutParams: {
                                                                                            returnTo: window.location.origin
                                                                                        }
                                                                                    });
                                                                                },
                                                                                children: "Logout"
                                                                            })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $42e7a5d8f911b531$export$5b6b19405a83ff9d).Panel, {
                                as: "nav",
                                className: "lg:hidden",
                                "aria-label": "Global",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "max-w-3xl mx-auto px-2 pt-2 pb-3 space-y-1 sm:px-4",
                                        children: $80da8bafa816c42d$var$navigation.map((item)=>/*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                href: item.href,
                                                "aria-current": item.current ? "page" : undefined,
                                                className: $80da8bafa816c42d$var$classNames(item.current ? "bg-gray-100 text-gray-900" : "hover:bg-gray-50", "block rounded-md py-2 px-3 text-base font-medium"),
                                                children: item.name
                                            }, item.name))
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "border-t border-gray-200 dark:border-gray-800 pt-4 pb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "max-w-3xl mx-auto px-4 flex items-center sm:px-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a0b772244d08cba$export$e2255cf6045e8d47), {
                                                            className: "h-10 w-10 rounded-full",
                                                            initials: "MA"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "ml-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "text-base font-medium text-gray-800",
                                                                children: currentUser?.name
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "text-sm font-medium text-gray-500",
                                                                children: currentUser?.email
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "mt-3 max-w-3xl mx-auto px-2 space-y-1 sm:px-4",
                                                children: [
                                                    (0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser) && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                        to: "/admin/events",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                            type: "button",
                                                            className: "ml-auto flex-shrink-0 bg-white rounded-full p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "View events"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                    icon: "RssIcon",
                                                                    className: "ml-1 h-6 w-6",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                        to: "/dashboard",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                            type: "button",
                                                            className: "ml-auto flex-shrink-0 bg-white rounded-full p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "View the grid"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $328c72db0bc047a6$export$2e2bcd8739ae039), {
                                                                    className: "ml-1 h-6 w-6",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    $80da8bafa816c42d$var$userNavigation.map((item)=>/*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                                            href: item.href,
                                                            className: "block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900",
                                                            children: item.name
                                                        }, item.name))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "h-[calc(100vh-70px)] md:flex flex-1",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $03ee96426087387b$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "md:flex-row flex-grow dark:text-gray-300",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0ecc0f54b7a0338f$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c5383ff45095a6a6$export$910ae8079b2c2852), {})
                        ]
                    })
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");
function $546fd21f4ffe3978$export$cad1a703886b4e3a() {
    const { logout: logout } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    (0, $f2Y41.useEffect)(()=>{
        localStorage.removeItem("practiceId");
        logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    }, [
        logout
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");


var $f2Y41 = parcelRequire("f2Y41");

var $ge3KO = parcelRequire("ge3KO");
var $4c64d1542739e3dd$var$Et = Object.create;
var $4c64d1542739e3dd$var$Ye = Object.defineProperty;
var $4c64d1542739e3dd$var$bt = Object.getOwnPropertyDescriptor;
var $4c64d1542739e3dd$var$gt = Object.getOwnPropertyNames;
var $4c64d1542739e3dd$var$yt = Object.getPrototypeOf, $4c64d1542739e3dd$var$wt = Object.prototype.hasOwnProperty;
var $4c64d1542739e3dd$var$Lt = (n, e)=>()=>(e || n((e = {
            exports: {}
        }).exports, e), e.exports);
var $4c64d1542739e3dd$var$Pt = (n, e, r, i)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let o of $4c64d1542739e3dd$var$gt(e))!$4c64d1542739e3dd$var$wt.call(n, o) && o !== r && $4c64d1542739e3dd$var$Ye(n, o, {
        get: ()=>e[o],
        enumerable: !(i = $4c64d1542739e3dd$var$bt(e, o)) || i.enumerable
    });
    return n;
};
var $4c64d1542739e3dd$var$St = (n, e, r)=>(r = n != null ? $4c64d1542739e3dd$var$Et($4c64d1542739e3dd$var$yt(n)) : {}, $4c64d1542739e3dd$var$Pt(e || !n || !n.__esModule ? $4c64d1542739e3dd$var$Ye(r, "default", {
        value: n,
        enumerable: !0
    }) : r, n));
var $4c64d1542739e3dd$var$je = $4c64d1542739e3dd$var$Lt((he, Je)=>{
    (function(n, e) {
        typeof he == "object" && typeof Je < "u" ? e(he) : typeof define == "function" && define.amd ? define([
            "exports"
        ], e) : (n = typeof globalThis < "u" ? globalThis : n || self, e(n.fastUniqueNumbers = {}));
    })(he, function(n) {
        "use strict";
        var e = function(l) {
            return function(p) {
                var f = l(p);
                return p.add(f), f;
            };
        }, r = function(l) {
            return function(p, f) {
                return l.set(p, f), f;
            };
        }, i = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, o = 536870912, u = o * 2, g = function(l, p) {
            return function(f) {
                var B = p.get(f), y = B === void 0 ? f.size : B < u ? B + 1 : 0;
                if (!f.has(y)) return l(f, y);
                if (f.size < o) {
                    for(; f.has(y);)y = Math.floor(Math.random() * u);
                    return l(f, y);
                }
                if (f.size > i) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; f.has(y);)y = Math.floor(Math.random() * i);
                return l(f, y);
            };
        }, O = new WeakMap, W = r(O), m = g(W, O), a = e(m);
        n.addUniqueNumber = a, n.generateUniqueNumber = m;
    });
});
function $4c64d1542739e3dd$export$1b06ce49faf19067(n) {
    return (0, $f2Y41.forwardRef)(function(r, i) {
        let o = {
            ...r
        }, u = $4c64d1542739e3dd$export$3e1c2ef16041091f(o);
        return typeof i == "function" ? i(u) : i && (i.current = u), (0, $ge3KO.jsx)(n, {
            ...r,
            ...u
        });
    });
}
var $4c64d1542739e3dd$var$Re = class extends (0, $f2Y41.Component) {
}, $4c64d1542739e3dd$export$c0b73c5063fae2ae = class extends $4c64d1542739e3dd$var$Re {
    constructor(e){
        super(e), this.onPresenceChange && e.setOnPresenceChange(this.onPresenceChange.bind(this)), this.onPrompt && e.setOnPrompt(this.onPrompt.bind(this)), this.onIdle && e.setOnIdle(this.onIdle.bind(this)), this.onActive && e.setOnActive(this.onActive.bind(this)), this.onAction && e.setOnAction(this.onAction.bind(this)), this.onMessage && e.setOnMessage(this.onMessage.bind(this));
    }
};
var $4c64d1542739e3dd$var$oe = $4c64d1542739e3dd$var$St($4c64d1542739e3dd$var$je());
var $4c64d1542739e3dd$var$Xe = (n)=>n.method !== void 0 && n.method === "call";
var $4c64d1542739e3dd$var$ze = (n)=>n.error === null && typeof n.id == "number";
var $4c64d1542739e3dd$var$Ke = (n)=>{
    let e = new Map([
        [
            0,
            ()=>{}
        ]
    ]), r = new Map([
        [
            0,
            ()=>{}
        ]
    ]), i = new Map, o = new Worker(n);
    return o.addEventListener("message", ({ data: m })=>{
        if ($4c64d1542739e3dd$var$Xe(m)) {
            let { params: { timerId: a, timerType: d } } = m;
            if (d === "interval") {
                let l = e.get(a);
                if (typeof l == "number") {
                    let p = i.get(l);
                    if (p === void 0 || p.timerId !== a || p.timerType !== d) throw new Error("The timer is in an undefined state.");
                } else if (typeof l < "u") l();
                else throw new Error("The timer is in an undefined state.");
            } else if (d === "timeout") {
                let l = r.get(a);
                if (typeof l == "number") {
                    let p = i.get(l);
                    if (p === void 0 || p.timerId !== a || p.timerType !== d) throw new Error("The timer is in an undefined state.");
                } else if (typeof l < "u") l(), r.delete(a);
                else throw new Error("The timer is in an undefined state.");
            }
        } else if ($4c64d1542739e3dd$var$ze(m)) {
            let { id: a } = m, d = i.get(a);
            if (d === void 0) throw new Error("The timer is in an undefined state.");
            let { timerId: l, timerType: p } = d;
            i.delete(a), p === "interval" ? e.delete(l) : r.delete(l);
        } else {
            let { error: { message: a } } = m;
            throw new Error(a);
        }
    }), {
        clearInterval: (m)=>{
            let a = (0, $4c64d1542739e3dd$var$oe.generateUniqueNumber)(i);
            i.set(a, {
                timerId: m,
                timerType: "interval"
            }), e.set(m, a), o.postMessage({
                id: a,
                method: "clear",
                params: {
                    timerId: m,
                    timerType: "interval"
                }
            });
        },
        clearTimeout: (m)=>{
            let a = (0, $4c64d1542739e3dd$var$oe.generateUniqueNumber)(i);
            i.set(a, {
                timerId: m,
                timerType: "timeout"
            }), r.set(m, a), o.postMessage({
                id: a,
                method: "clear",
                params: {
                    timerId: m,
                    timerType: "timeout"
                }
            });
        },
        setInterval: (m, a)=>{
            let d = (0, $4c64d1542739e3dd$var$oe.generateUniqueNumber)(e);
            return e.set(d, ()=>{
                m(), typeof e.get(d) == "function" && o.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: a,
                        now: performance.now(),
                        timerId: d,
                        timerType: "interval"
                    }
                });
            }), o.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: a,
                    now: performance.now(),
                    timerId: d,
                    timerType: "interval"
                }
            }), d;
        },
        setTimeout: (m, a)=>{
            let d = (0, $4c64d1542739e3dd$var$oe.generateUniqueNumber)(r);
            return r.set(d, m), o.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: a,
                    now: performance.now(),
                    timerId: d,
                    timerType: "timeout"
                }
            }), d;
        }
    };
};
var $4c64d1542739e3dd$var$Qe = (n, e)=>{
    let r = null;
    return ()=>{
        if (r !== null) return r;
        let i = new Blob([
            e
        ], {
            type: "application/javascript; charset=utf-8"
        }), o = URL.createObjectURL(i);
        return r = n(o), setTimeout(()=>URL.revokeObjectURL(o)), r;
    };
};
var $4c64d1542739e3dd$var$Ze = `(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error('The given type "'.concat(i,'" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error('The given method "'.concat(s.method,'" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error('The given type "'.concat(d,'" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`;
var $4c64d1542739e3dd$var$ve = $4c64d1542739e3dd$var$Qe($4c64d1542739e3dd$var$Ke, $4c64d1542739e3dd$var$Ze), $4c64d1542739e3dd$var$et = (n)=>$4c64d1542739e3dd$var$ve().clearInterval(n), $4c64d1542739e3dd$var$tt = (n)=>$4c64d1542739e3dd$var$ve().clearTimeout(n), $4c64d1542739e3dd$var$rt = (n, e)=>$4c64d1542739e3dd$var$ve().setInterval(n, e), $4c64d1542739e3dd$var$nt = (n, e)=>$4c64d1542739e3dd$var$ve().setTimeout(n, e);
var $4c64d1542739e3dd$var$M = (typeof window > "u" ? "undefined" : typeof window) == "object";
var $4c64d1542739e3dd$var$I = {
    setTimeout: $4c64d1542739e3dd$var$M ? setTimeout.bind(window) : setTimeout,
    clearTimeout: $4c64d1542739e3dd$var$M ? clearTimeout.bind(window) : clearTimeout,
    setInterval: $4c64d1542739e3dd$var$M ? setInterval.bind(window) : setInterval,
    clearInterval: $4c64d1542739e3dd$var$M ? clearInterval.bind(window) : clearInterval
}, $4c64d1542739e3dd$export$427b263b93108fff = {
    setTimeout: $4c64d1542739e3dd$var$nt,
    clearTimeout: $4c64d1542739e3dd$var$tt,
    setInterval: $4c64d1542739e3dd$var$rt,
    clearInterval: $4c64d1542739e3dd$var$et
};
function $4c64d1542739e3dd$export$5ca7e2fccac21705() {
    $4c64d1542739e3dd$var$I.setTimeout = setTimeout, $4c64d1542739e3dd$var$I.clearTimeout = clearTimeout, $4c64d1542739e3dd$var$I.setInterval = setInterval, $4c64d1542739e3dd$var$I.clearInterval = clearInterval, $4c64d1542739e3dd$export$427b263b93108fff.setTimeout = setTimeout, $4c64d1542739e3dd$export$427b263b93108fff.clearTimeout = clearTimeout, $4c64d1542739e3dd$export$427b263b93108fff.setInterval = setInterval, $4c64d1542739e3dd$export$427b263b93108fff.clearInterval = clearInterval;
}
function $4c64d1542739e3dd$var$it(n) {
    $4c64d1542739e3dd$var$I.setTimeout = n.setTimeout, $4c64d1542739e3dd$var$I.clearTimeout = n.clearTimeout, $4c64d1542739e3dd$var$I.setInterval = n.setInterval, $4c64d1542739e3dd$var$I.clearInterval = n.clearInterval;
}
var $4c64d1542739e3dd$var$Q = {}, $4c64d1542739e3dd$var$Ae = class {
    name;
    closed = !1;
    mc = new MessageChannel;
    constructor(e){
        this.name = e, $4c64d1542739e3dd$var$Q[e] = $4c64d1542739e3dd$var$Q[e] || [], $4c64d1542739e3dd$var$Q[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
    }
    onStorage(e) {
        if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
        let r = JSON.parse(e.newValue);
        this.mc.port2.postMessage(r);
    }
    postMessage(e) {
        if (this.closed) throw new Error("InvalidStateError");
        let r = JSON.stringify(e), i = `${this.name}:${String(Date.now())}${String(Math.random())}`;
        window.localStorage.setItem(i, r), $4c64d1542739e3dd$var$I.setTimeout(()=>{
            window.localStorage.removeItem(i);
        }, 500), $4c64d1542739e3dd$var$Q[this.name].forEach((o)=>{
            o !== this && o.mc.port2.postMessage(JSON.parse(r));
        });
    }
    close() {
        if (this.closed) return;
        this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
        let e = $4c64d1542739e3dd$var$Q[this.name].indexOf(this);
        $4c64d1542739e3dd$var$Q[this.name].splice(e, 1);
    }
    get onmessage() {
        return this.mc.port1.onmessage;
    }
    set onmessage(e) {
        this.mc.port1.onmessage = e;
    }
    get onmessageerror() {
        return this.mc.port1.onmessageerror;
    }
    set onmessageerror(e) {
        this.mc.port1.onmessageerror = e;
    }
    addEventListener(e, r) {
        return this.mc.port1.addEventListener(e, r);
    }
    removeEventListener(e, r) {
        return this.mc.port1.removeEventListener(e, r);
    }
    dispatchEvent(e) {
        return this.mc.port1.dispatchEvent(e);
    }
}, $4c64d1542739e3dd$var$st = typeof window > "u" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : $4c64d1542739e3dd$var$Ae;
function $4c64d1542739e3dd$var$ot(n = 0) {
    return new Promise((e)=>$4c64d1542739e3dd$var$I.setTimeout(e, n));
}
function $4c64d1542739e3dd$var$Te() {
    return Math.random().toString(36).substring(2);
}
var $4c64d1542739e3dd$var$Ie = class {
    options;
    channel;
    token = $4c64d1542739e3dd$var$Te();
    isLeader = !1;
    isDead = !1;
    isApplying = !1;
    reApply = !1;
    intervals = [];
    listeners = [];
    deferred;
    constructor(e, r){
        this.channel = e, this.options = r, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
    }
    async apply() {
        if (this.isLeader || this.isDead) return !1;
        if (this.isApplying) return this.reApply = !0, !1;
        this.isApplying = !0;
        let e = !1, r = (i)=>{
            let { token: o, action: u } = i.data;
            o !== this.token && (u === 0 && o > this.token && (e = !0), u === 1 && (e = !0));
        };
        this.channel.addEventListener("message", r);
        try {
            return this.sendAction(0), await $4c64d1542739e3dd$var$ot(this.options.responseTime), this.channel.removeEventListener("message", r), this.isApplying = !1, e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0);
        } catch  {
            return !1;
        }
    }
    awaitLeadership() {
        if (this.isLeader) return Promise.resolve();
        let e = !1, r = null;
        return new Promise((i)=>{
            let o = ()=>{
                if (e) return;
                e = !0;
                try {
                    $4c64d1542739e3dd$var$I.clearInterval(r);
                } catch  {}
                let g = this.intervals.indexOf(r);
                g >= 0 && this.intervals.splice(g, 1), this.channel.removeEventListener("message", u), i();
            };
            r = $4c64d1542739e3dd$var$I.setInterval(()=>{
                this.apply().then(()=>{
                    this.isLeader && o();
                });
            }, this.options.fallbackInterval), this.intervals.push(r);
            let u = (g)=>{
                let { action: O } = g.data;
                O === 2 && this.apply().then(()=>{
                    this.isLeader && o();
                });
            };
            this.channel.addEventListener("message", u);
        });
    }
    sendAction(e) {
        this.channel.postMessage({
            action: e,
            token: this.token
        });
    }
    assumeLead() {
        this.isLeader = !0;
        let e = (r)=>{
            let { action: i } = r.data;
            i === 0 && this.sendAction(1);
        };
        return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(1);
    }
    waitForLeadership() {
        return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
    }
    close() {
        if (!this.isDead) {
            this.isDead = !0, this.isLeader = !1, this.sendAction(2);
            try {
                this.listeners.forEach((e)=>this.channel.removeEventListener("message", e)), this.intervals.forEach((e)=>$4c64d1542739e3dd$var$I.clearInterval(e));
            } catch  {}
        }
    }
};
var $4c64d1542739e3dd$var$Ee = class {
    channel;
    options;
    elector;
    token = $4c64d1542739e3dd$var$Te();
    registry = new Map;
    allIdle = !1;
    isLastActive = !1;
    constructor(e){
        let { channelName: r } = e;
        if (this.options = e, this.channel = new $4c64d1542739e3dd$var$st(r), this.registry.set(this.token, 1), e.leaderElection) {
            let i = {
                fallbackInterval: 2e3,
                responseTime: 100
            };
            this.elector = new $4c64d1542739e3dd$var$Ie(this.channel, i), this.elector.waitForLeadership();
        }
        this.channel.addEventListener("message", (i)=>{
            let { action: o, token: u, data: g } = i.data;
            switch(o){
                case 3:
                    this.registry.set(u, 2);
                    break;
                case 4:
                    this.registry.delete(u);
                    break;
                case 5:
                    this.idle(u);
                    break;
                case 6:
                    this.active(u);
                    break;
                case 7:
                    this.prompt(u);
                    break;
                case 8:
                    this.start(u);
                    break;
                case 9:
                    this.reset(u);
                    break;
                case 10:
                    this.activate(u);
                    break;
                case 11:
                    this.pause(u);
                    break;
                case 12:
                    this.resume(u);
                    break;
                case 13:
                    this.options.onMessage(g);
                    break;
            }
        }), this.send(3);
    }
    get isLeader() {
        if (!this.elector) throw new Error('\u274C Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
        return this.elector.isLeader;
    }
    prompt(e = this.token) {
        this.registry.set(e, 0);
        let r = [
            ...this.registry.values()
        ].every((i)=>i === 0);
        e === this.token && this.send(7), r && this.options.onPrompt();
    }
    idle(e = this.token) {
        this.registry.set(e, 2);
        let r = [
            ...this.registry.values()
        ].every((i)=>i === 2);
        e === this.token && this.send(5), !this.allIdle && r && (this.allIdle = !0, this.options.onIdle());
    }
    active(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1);
        let r = [
            ...this.registry.values()
        ].some((i)=>i === 1);
        e === this.token && this.send(6), r && this.options.onActive(), this.isLastActive = e === this.token;
    }
    start(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(8) : this.options.start(!0), this.isLastActive = e === this.token;
    }
    reset(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(9) : this.options.reset(!0), this.isLastActive = e === this.token;
    }
    activate(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(10) : this.options.activate(!0), this.isLastActive = e === this.token;
    }
    pause(e = this.token) {
        e === this.token ? this.send(11) : this.options.pause(!0);
    }
    resume(e = this.token) {
        e === this.token ? this.send(12) : this.options.resume(!0);
    }
    message(e) {
        try {
            this.channel.postMessage({
                action: 13,
                token: this.token,
                data: e
            });
        } catch  {}
    }
    send(e) {
        try {
            this.channel.postMessage({
                action: e,
                token: this.token
            });
        } catch  {}
    }
    close() {
        this.options.leaderElection && this.elector.close(), this.send(4), this.channel.close();
    }
};
var $4c64d1542739e3dd$var$at = $4c64d1542739e3dd$var$M ? document : null, $4c64d1542739e3dd$export$1b94debb2480fd98 = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange",
    "focus"
];
function $4c64d1542739e3dd$var$ct(n, e) {
    let r;
    function i(...o) {
        r && clearTimeout(r), r = setTimeout(()=>{
            n(...o), r = null;
        }, e);
    }
    return i.cancel = function() {
        clearTimeout(r);
    }, i;
}
function $4c64d1542739e3dd$var$be(n, e) {
    let r = 0;
    return function(...i) {
        let o = new Date().getTime();
        if (!(o - r < e)) return r = o, n(...i);
    };
}
var $4c64d1542739e3dd$var$v = ()=>Date.now();
var $4c64d1542739e3dd$var$Z = 2147483647;
function $4c64d1542739e3dd$export$3e1c2ef16041091f({ timeout: n = 1200000, promptTimeout: e = 0, promptBeforeIdle: r = 0, element: i = $4c64d1542739e3dd$var$at, events: o = $4c64d1542739e3dd$export$1b94debb2480fd98, timers: u, immediateEvents: g = [], onPresenceChange: O = ()=>{}, onPrompt: W = ()=>{}, onIdle: m = ()=>{}, onActive: a = ()=>{}, onAction: d = ()=>{}, onMessage: l = ()=>{}, debounce: p = 0, throttle: f = 0, eventsThrottle: B = 200, startOnMount: y = !0, startManually: D = !1, stopOnIdle: ce = !1, crossTab: j = !1, name: Oe = "idle-timer", syncTimers: ee = 0, leaderElection: Ce = !1, disabled: C = !1 } = {}) {
    let De = (0, $f2Y41.useRef)($4c64d1542739e3dd$var$v()), ue = (0, $f2Y41.useRef)($4c64d1542739e3dd$var$v()), w = (0, $f2Y41.useRef)(null), R = (0, $f2Y41.useRef)(null), F = (0, $f2Y41.useRef)(0), te = (0, $f2Y41.useRef)(0), N = (0, $f2Y41.useRef)(0), S = (0, $f2Y41.useRef)(0), h = (0, $f2Y41.useRef)(!1), E = (0, $f2Y41.useRef)(!1), H = (0, $f2Y41.useRef)(!1), _ = (0, $f2Y41.useRef)(!0), re = (0, $f2Y41.useRef)(!1), U = (0, $f2Y41.useRef)(null), s = (0, $f2Y41.useRef)(null), k = (0, $f2Y41.useRef)(n), G = (0, $f2Y41.useRef)(0);
    (0, $f2Y41.useEffect)(()=>{
        if (e && console.warn("\u26A0\uFE0F IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), r && e) throw new Error("\u274C Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
        if (n >= $4c64d1542739e3dd$var$Z) throw new Error(`\u274C The value for the timeout property must fit in a 32 bit signed integer, ${$4c64d1542739e3dd$var$Z}.`);
        if (e >= $4c64d1542739e3dd$var$Z) throw new Error(`\u274C The value for the promptTimeout property must fit in a 32 bit signed integer, ${$4c64d1542739e3dd$var$Z}.`);
        if (r >= $4c64d1542739e3dd$var$Z) throw new Error(`\u274C The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ${$4c64d1542739e3dd$var$Z}.`);
        if (r >= n) throw new Error(`\u274C The value for the promptBeforeIdle property must be less than the timeout property, ${n}.`);
        if (r ? (k.current = n - r, G.current = r) : (k.current = n, G.current = e), !_.current) {
            if (D || C) return;
            h.current && (X.current(null, L), s.current && s.current.active()), J();
        }
    }, [
        n,
        e,
        r,
        D,
        C
    ]);
    let Ne = (0, $f2Y41.useRef)(ce);
    (0, $f2Y41.useEffect)(()=>{
        Ne.current = ce;
    }, [
        ce
    ]);
    let He = (0, $f2Y41.useRef)(g), ne = (0, $f2Y41.useRef)(i), ye = (0, $f2Y41.useRef)([
        ...new Set([
            ...o,
            ...g
        ]).values()
    ]), A = (0, $f2Y41.useRef)(C);
    (0, $f2Y41.useEffect)(()=>{
        A.current = C, !_.current && (C ? fe() : D || J());
    }, [
        C
    ]);
    let ie = (0, $f2Y41.useRef)(O);
    (0, $f2Y41.useEffect)(()=>{
        ie.current = O;
    }, [
        O
    ]);
    let le = (0, $f2Y41.useRef)(W);
    (0, $f2Y41.useEffect)(()=>{
        le.current = W;
    }, [
        W
    ]);
    let me = (0, $f2Y41.useRef)(m);
    (0, $f2Y41.useEffect)(()=>{
        me.current = m;
    }, [
        m
    ]);
    let X = (0, $f2Y41.useRef)(a);
    (0, $f2Y41.useEffect)(()=>{
        X.current = a;
    }, [
        a
    ]);
    let de = (0, $f2Y41.useRef)(d);
    (0, $f2Y41.useEffect)(()=>{
        de.current = d;
    }, [
        d
    ]);
    let z = (0, $f2Y41.useRef)(l);
    (0, $f2Y41.useEffect)(()=>{
        z.current = l;
    }, [
        l
    ]);
    let q = (0, $f2Y41.useMemo)(()=>{
        let t = (P, K)=>de.current(P, K);
        return p > 0 ? $4c64d1542739e3dd$var$ct(t, p) : f > 0 ? $4c64d1542739e3dd$var$be(t, f) : t;
    }, [
        f,
        p
    ]), _e = (0, $f2Y41.useRef)();
    (0, $f2Y41.useEffect)(()=>{
        j && ee && (_e.current = $4c64d1542739e3dd$var$be(()=>{
            s.current.active();
        }, ee));
    }, [
        j,
        ee
    ]);
    let x = ()=>{
        U.current !== null && ($4c64d1542739e3dd$var$I.clearTimeout(U.current), U.current = null);
    }, $ = (t, P = !0)=>{
        x(), U.current = $4c64d1542739e3dd$var$I.setTimeout(Le, t || k.current), P && (R.current = $4c64d1542739e3dd$var$v());
    }, Ue = (t)=>{
        !E.current && !h.current && (le.current(t, L), ie.current({
            type: "active",
            prompted: !0
        }, L)), S.current = 0, N.current = $4c64d1542739e3dd$var$v(), E.current = !0, $(G.current, !1);
    }, Fe = ()=>{
        x(), h.current || (me.current(null, L), ie.current({
            type: "idle"
        }, L)), h.current = !0, w.current = $4c64d1542739e3dd$var$v(), Ne.current ? Y() : E.current && (N.current = 0, E.current = !1);
    }, we = (t)=>{
        x(), (h.current || E.current) && (X.current(t, L), ie.current({
            type: "active",
            prompted: !1
        }, L)), E.current = !1, N.current = 0, h.current = !1, F.current += $4c64d1542739e3dd$var$v() - w.current, te.current += $4c64d1542739e3dd$var$v() - w.current, V(), $();
    }, Le = (t)=>{
        if (!h.current) {
            q.cancel && q.cancel();
            let K = $4c64d1542739e3dd$var$v() - R.current;
            if (!(k.current + G.current < K) && G.current > 0 && !E.current) {
                s.current ? s.current.prompt() : Ue(t);
                return;
            }
            s.current ? s.current.idle() : Fe();
            return;
        }
        s.current ? s.current.active() : we(t);
    }, Pe = (t)=>{
        if (!y && !R.current && (R.current = $4c64d1542739e3dd$var$v(), X.current(null, L)), q(t, L), E.current) return;
        if (x(), !h.current && He.current.includes(t.type)) {
            Le(t);
            return;
        }
        let P = $4c64d1542739e3dd$var$v() - R.current;
        if (h.current && !ce || !h.current && P >= k.current) {
            Le(t);
            return;
        }
        H.current = !1, S.current = 0, N.current = 0, $(), j && ee && _e.current();
    }, pe = (0, $f2Y41.useRef)(Pe);
    (0, $f2Y41.useEffect)(()=>{
        let t = re.current;
        t && Y(), B > 0 ? pe.current = $4c64d1542739e3dd$var$be(Pe, B) : pe.current = Pe, t && V();
    }, [
        B,
        f,
        p,
        de,
        j,
        ee
    ]);
    let V = ()=>{
        $4c64d1542739e3dd$var$M && ne.current && (re.current || (ye.current.forEach((t)=>{
            ne.current.addEventListener(t, pe.current, {
                capture: !0,
                passive: !0
            });
        }), re.current = !0));
    }, Y = (t = !1)=>{
        $4c64d1542739e3dd$var$M && ne.current && (re.current || t) && (ye.current.forEach((P)=>{
            ne.current.removeEventListener(P, pe.current, {
                capture: !0
            });
        }), re.current = !1);
    }, J = (0, $f2Y41.useCallback)((t)=>A.current ? !1 : (x(), V(), h.current = !1, E.current = !1, H.current = !1, S.current = 0, N.current = 0, s.current && !t && s.current.start(), $(), !0), [
        U,
        h,
        A,
        k,
        s
    ]), Se = (0, $f2Y41.useCallback)((t)=>A.current ? !1 : (x(), V(), ue.current = $4c64d1542739e3dd$var$v(), F.current += $4c64d1542739e3dd$var$v() - w.current, te.current += $4c64d1542739e3dd$var$v() - w.current, F.current = 0, h.current = !1, E.current = !1, H.current = !1, S.current = 0, N.current = 0, s.current && !t && s.current.reset(), D || $(), !0), [
        U,
        h,
        k,
        D,
        A,
        s
    ]), Ve = (0, $f2Y41.useCallback)((t)=>A.current ? !1 : (x(), V(), (h.current || E.current) && we(), h.current = !1, E.current = !1, H.current = !1, S.current = 0, N.current = 0, ue.current = $4c64d1542739e3dd$var$v(), s.current && !t && s.current.activate(), $(), !0), [
        U,
        h,
        E,
        A,
        k,
        s
    ]), fe = (0, $f2Y41.useCallback)((t = !1)=>A.current || H.current ? !1 : (S.current = We(), H.current = !0, Y(), x(), s.current && !t && s.current.pause(), !0), [
        U,
        A,
        s
    ]), Me = (0, $f2Y41.useCallback)((t = !1)=>A.current || !H.current ? !1 : (H.current = !1, E.current || V(), h.current || $(S.current), N.current && (N.current = $4c64d1542739e3dd$var$v()), s.current && !t && s.current.resume(), !0), [
        U,
        k,
        A,
        S,
        s
    ]), ut = (0, $f2Y41.useCallback)((t, P)=>(s.current ? (P && z.current(t, L), s.current.message(t)) : P && z.current(t, L), !0), [
        l
    ]), lt = (0, $f2Y41.useCallback)(()=>h.current, [
        h
    ]), mt = (0, $f2Y41.useCallback)(()=>E.current, [
        E
    ]), dt = (0, $f2Y41.useCallback)(()=>s.current ? s.current.isLeader : null, [
        s
    ]), pt = (0, $f2Y41.useCallback)(()=>s.current ? s.current.isLastActive : null, [
        s
    ]), ft = (0, $f2Y41.useCallback)(()=>s.current ? s.current.token : null, [
        s
    ]), We = (0, $f2Y41.useCallback)(()=>{
        if (H.current) return S.current;
        let t = S.current ? S.current : G.current + k.current, P = R.current ? $4c64d1542739e3dd$var$v() - R.current : 0, K = Math.floor(t - P);
        return K < 0 ? 0 : Math.abs(K);
    }, [
        k,
        G,
        E,
        S,
        R
    ]), Be = (0, $f2Y41.useCallback)(()=>Math.round($4c64d1542739e3dd$var$v() - ue.current), [
        ue
    ]), Ge = (0, $f2Y41.useCallback)(()=>Math.round($4c64d1542739e3dd$var$v() - De.current), [
        De
    ]), ht = (0, $f2Y41.useCallback)(()=>w.current ? new Date(w.current) : null, [
        w
    ]), vt = (0, $f2Y41.useCallback)(()=>R.current ? new Date(R.current) : null, [
        R
    ]), qe = (0, $f2Y41.useCallback)(()=>h.current ? Math.round($4c64d1542739e3dd$var$v() - w.current + F.current) : Math.round(F.current), [
        w,
        F
    ]), $e = (0, $f2Y41.useCallback)(()=>h.current ? Math.round($4c64d1542739e3dd$var$v() - w.current + te.current) : Math.round(te.current), [
        w,
        te
    ]), Tt = (0, $f2Y41.useCallback)(()=>{
        let t = Math.round(Be() - qe());
        return t >= 0 ? t : 0;
    }, [
        w,
        F
    ]), It = (0, $f2Y41.useCallback)(()=>{
        let t = Math.round(Ge() - $e());
        return t >= 0 ? t : 0;
    }, [
        w,
        F
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (p > 0 && f > 0) throw new Error("\u274C onAction can either be throttled or debounced, not both.");
        u && $4c64d1542739e3dd$var$it(u);
        let t = ()=>{
            s.current && s.current.close(), q.cancel && q.cancel(), x(), Y(!0);
        };
        return $4c64d1542739e3dd$var$M && window.addEventListener("beforeunload", t), ()=>{
            $4c64d1542739e3dd$var$M && window.removeEventListener("beforeunload", t), s.current && s.current.close(), q.cancel && q.cancel(), x(), Y(!0);
        };
    }, []), (0, $f2Y41.useEffect)(()=>{
        s.current && s.current.close(), j ? s.current = new $4c64d1542739e3dd$var$Ee({
            channelName: Oe,
            leaderElection: Ce,
            onPrompt: ()=>{
                Ue();
            },
            onIdle: ()=>{
                Fe();
            },
            onActive: ()=>{
                we();
            },
            onMessage: (t)=>{
                z.current(t, L);
            },
            start: J,
            reset: Se,
            activate: Ve,
            pause: fe,
            resume: Me
        }) : s.current = null;
    }, [
        j,
        Oe,
        Ce,
        le,
        me,
        X,
        z,
        J,
        Se,
        fe,
        Me
    ]), (0, $f2Y41.useEffect)(()=>{
        _.current || (x(), Y(!0)), !(D || C) && (y ? J() : V());
    }, [
        D,
        y,
        C,
        _
    ]), (0, $f2Y41.useEffect)(()=>{
        if (!_.current) {
            let t = [
                ...new Set([
                    ...o,
                    ...g
                ]).values()
            ];
            if (Y(), ye.current = t, ne.current = i, He.current = g, D || C) return;
            y ? J() : V();
        }
    }, [
        i,
        JSON.stringify(o),
        JSON.stringify(g),
        _,
        C,
        D,
        y
    ]), (0, $f2Y41.useEffect)(()=>{
        _.current && (_.current = !1);
    }, [
        _
    ]);
    let L = {
        message: ut,
        start: J,
        reset: Se,
        activate: Ve,
        pause: fe,
        resume: Me,
        isIdle: lt,
        isPrompted: mt,
        isLeader: dt,
        isLastActiveTab: pt,
        getTabId: ft,
        getRemainingTime: We,
        getElapsedTime: Be,
        getTotalElapsedTime: Ge,
        getLastIdleTime: ht,
        getLastActiveTime: vt,
        getIdleTime: qe,
        getTotalIdleTime: $e,
        getActiveTime: Tt,
        getTotalActiveTime: It,
        setOnPresenceChange: (t)=>{
            O = t, ie.current = t;
        },
        setOnPrompt: (t)=>{
            W = t, le.current = t;
        },
        setOnIdle: (t)=>{
            m = t, me.current = t;
        },
        setOnActive: (t)=>{
            a = t, X.current = t;
        },
        setOnAction: (t)=>{
            d = t, de.current = t;
        },
        setOnMessage: (t)=>{
            l = t, z.current = t;
        }
    };
    return L;
}
var $4c64d1542739e3dd$export$e28ea38f1e83b132 = (0, $f2Y41.createContext)(null);
function $4c64d1542739e3dd$export$17ce2adb9f89ccf5(n) {
    let e = $4c64d1542739e3dd$export$3e1c2ef16041091f(n);
    return (0, $ge3KO.jsx)($4c64d1542739e3dd$export$e28ea38f1e83b132.Provider, {
        value: e,
        children: n.children
    });
}
var $4c64d1542739e3dd$export$ee38aa87a63cd016 = $4c64d1542739e3dd$export$e28ea38f1e83b132.Consumer;
function $4c64d1542739e3dd$export$1f7d3dee7d83ab6e() {
    return (0, $f2Y41.useContext)($4c64d1542739e3dd$export$e28ea38f1e83b132);
}






var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");




function $70e2b1cc79623450$export$225587d2949665b(props) {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { data: screens } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("screens", `patient_id=${patientId}`);
    const { data: practice_studies } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies", `practice_id=${practiceId}`);
    const [unscreenedStudies, setUnscreenedStudies] = (0, $f2Y41.useState)([]);
    const { setCurrentStudyScreenName: setCurrentStudyScreenName, setCurrentStudyScreenId: setCurrentStudyScreenId } = props;
    (0, $f2Y41.useEffect)(()=>{
        if (screens?.length === 0) setUnscreenedStudies(practice_studies);
        else setUnscreenedStudies(practice_studies.filter((practice_study)=>!screens?.some((screen)=>screen.study_id === practice_study.study_id)));
    }, [
        practice_studies,
        screens
    ]);
    const handleScreenNavigate = (screen_id, screen_abbreviation = "")=>{
        setCurrentStudyScreenName(screen_abbreviation);
        setCurrentStudyScreenId(screen_id);
        navigate(`/patients/${patientId}/screens/${screen_id}`);
        handleClose();
    };
    const handleScreenStart = async (study_id)=>{
        if (!study_id) return;
        const data = {
            study_id: study_id,
            practice_id: practiceId,
            patient_id: patientId,
            status: "chart_review"
        };
        const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("screens", data, getAccessTokenSilently);
        const id = response?.data?.data?.id;
        if (id !== undefined) handleScreenNavigate(id);
        handleClose();
    };
    const handleClose = ()=>{
        props.setOpen(false);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800 dark:text-gray-200",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold",
                                        children: "This patient is not eligible"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>handleClose(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                    children: "X Button"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "ml-6 mt-2 text-xs",
                                children: "Select another study below, or select resume screening to add more data."
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "p-6 space-y-6",
                                children: [
                                    screens?.map((screen, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "font-medium",
                                                    children: [
                                                        screen.study?.abbreviation,
                                                        " - ",
                                                        screen.study?.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>handleScreenNavigate(screen.id, screen.study?.abbreviation),
                                                    onKeyUp: ()=>handleScreenNavigate(screen.id, screen.study?.abbreviation),
                                                    className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
                                                    children: [
                                                        "Continue Screen",
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                            icon: "ArrowCircleRightIcon",
                                                            className: "ml-1 w-5 h-5 flex"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, screen?.study?.id)),
                                    unscreenedStudies?.map((practice_study, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "font-medium",
                                                    children: [
                                                        practice_study.study?.abbreviation,
                                                        " -",
                                                        " ",
                                                        practice_study.study?.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>handleScreenStart(practice_study?.study?.id),
                                                    onKeyUp: ()=>handleScreenStart(practice_study?.study?.id),
                                                    className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
                                                    children: [
                                                        "Start Screen",
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                            icon: "ArrowCircleRightIcon",
                                                            className: "ml-1 w-5 h-5 flex"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, practice_study?.study?.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "items-center p-4 border-t border-gray-200 rounded-b",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                    type: "button",
                                    className: "text-white bg-topo-blue hover:bg-blue-800 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                    onClick: ()=>handleClose(),
                                    onKeyUp: ()=>handleClose(),
                                    children: "Resume Screening"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");





function $d547260374dfced5$export$582e33cc2dc774b2(props) {
    const { register: register, handleSubmit: handleSubmit, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            patient_id: props.patientId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = (data)=>{
        data.start_dt = new Date(data.start_dt).toISOString().slice(0, -1);
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patient_appointments", data, getAccessTokenSilently).then((response)=>{
            props?.refreshData();
            closeModal();
        }, (error)=>{});
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-appointment-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Add Appointment"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "grid grid-cols-6 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "appointment_type",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Appointment Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                        ...register("appointment_type"),
                                                        name: "appointment_type",
                                                        id: "appointment_type",
                                                        className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        // placeholder="NN"
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                children: "Research"
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                children: "Clinical"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "provider_name",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Provider Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        ...register("provider_name"),
                                                        type: "text",
                                                        name: "provider_name",
                                                        id: "provider_name",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        // placeholder="example@company.com"
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "start_dt",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Appointment Start Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "start_dt",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "datetime-local",
                                                                sx: {
                                                                    width: 250,
                                                                    "boxShadow": "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    ...register("patient_id"),
                                                    type: "hidden",
                                                    name: "patient_id",
                                                    id: "patient_id",
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    // placeholder="example@company.com"
                                                    required: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "items-center p-4 border-t border-gray-200 dark:border-gray-700 rounded-b",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Save"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");






var $asN9r = parcelRequire("asN9r");






function $09171a2aa9553a1f$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $22063f549fb15875$export$2e2bcd8739ae039)(arr);
}


function $fa1525cb5a1db640$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $a8ab6f62b959b64d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $124d9c34282e4c89$export$2e2bcd8739ae039(arr) {
    return (0, $09171a2aa9553a1f$export$2e2bcd8739ae039)(arr) || (0, $fa1525cb5a1db640$export$2e2bcd8739ae039)(arr) || (0, $5d89a7a782b080b9$export$2e2bcd8739ae039)(arr) || (0, $a8ab6f62b959b64d$export$2e2bcd8739ae039)();
}



var $f2Y41 = parcelRequire("f2Y41");


var $asN9r = parcelRequire("asN9r");

var $jvVhJ = parcelRequire("jvVhJ");
function $96fe3431af40818e$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $7ae53decccf308c8$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $d9ad1a8dbe1e24f9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4917cc6cc1bd8b0a$export$2e2bcd8739ae039(arr, i) {
    return (0, $96fe3431af40818e$export$2e2bcd8739ae039)(arr) || (0, $7ae53decccf308c8$export$2e2bcd8739ae039)(arr, i) || (0, $5d89a7a782b080b9$export$2e2bcd8739ae039)(arr, i) || (0, $d9ad1a8dbe1e24f9$export$2e2bcd8739ae039)();
}



var $bKcdJ = parcelRequire("bKcdJ");
function $9fbcf6b85849bc17$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $bKcdJ.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



function $746ea5d29904c166$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $f2Y41 = parcelRequire("f2Y41");



var $f2Y41 = parcelRequire("f2Y41");
var $f6968ac8a1a8469e$var$index = (0, $f2Y41.useLayoutEffect);
var $f6968ac8a1a8469e$export$2e2bcd8739ae039 = $f6968ac8a1a8469e$var$index;


var $eb52c0a5db34d84f$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $eb52c0a5db34d84f$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $eb52c0a5db34d84f$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $eb52c0a5db34d84f$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($eb52c0a5db34d84f$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $eb52c0a5db34d84f$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($eb52c0a5db34d84f$var$isArray(value)) return value.filter(Boolean);
    if ((0, $1a14283acdfb87e7$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $eb52c0a5db34d84f$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(props, $eb52c0a5db34d84f$var$_excluded$4);
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $eb52c0a5db34d84f$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $eb52c0a5db34d84f$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $eb52c0a5db34d84f$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $eb52c0a5db34d84f$var$normalizedHeight(el) {
    if ($eb52c0a5db34d84f$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $eb52c0a5db34d84f$var$getScrollTop(el) {
    if ($eb52c0a5db34d84f$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $eb52c0a5db34d84f$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($eb52c0a5db34d84f$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $eb52c0a5db34d84f$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $eb52c0a5db34d84f$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $eb52c0a5db34d84f$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $eb52c0a5db34d84f$export$b4171a6734a65d42;
    var start = $eb52c0a5db34d84f$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $eb52c0a5db34d84f$var$easeOutCubic(currentTime, start, change, duration);
        $eb52c0a5db34d84f$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $eb52c0a5db34d84f$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $eb52c0a5db34d84f$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $eb52c0a5db34d84f$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $eb52c0a5db34d84f$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $eb52c0a5db34d84f$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $eb52c0a5db34d84f$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $eb52c0a5db34d84f$var$passiveOptionAccessed = false;
var $eb52c0a5db34d84f$var$options = {
    get passive () {
        return $eb52c0a5db34d84f$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $eb52c0a5db34d84f$var$w = typeof window !== "undefined" ? window : {};
if ($eb52c0a5db34d84f$var$w.addEventListener && $eb52c0a5db34d84f$var$w.removeEventListener) {
    $eb52c0a5db34d84f$var$w.addEventListener("p", $eb52c0a5db34d84f$export$b4171a6734a65d42, $eb52c0a5db34d84f$var$options);
    $eb52c0a5db34d84f$var$w.removeEventListener("p", $eb52c0a5db34d84f$export$b4171a6734a65d42, false);
}
var $eb52c0a5db34d84f$export$2408f22a0fab9ae5 = $eb52c0a5db34d84f$var$passiveOptionAccessed;
function $eb52c0a5db34d84f$export$3466f893ebf79586(item) {
    return item != null;
}
function $eb52c0a5db34d84f$var$isArray(arg) {
    return Array.isArray(arg);
}
function $eb52c0a5db34d84f$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $eb52c0a5db34d84f$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $eb52c0a5db34d84f$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $eb52c0a5db34d84f$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $eb52c0a5db34d84f$var$_excluded$3 = [
    "children",
    "innerProps"
], $eb52c0a5db34d84f$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $eb52c0a5db34d84f$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $eb52c0a5db34d84f$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $eb52c0a5db34d84f$var$normalizedHeight(scrollParent);
    var scrollTop = $eb52c0a5db34d84f$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $eb52c0a5db34d84f$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $eb52c0a5db34d84f$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $eb52c0a5db34d84f$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $eb52c0a5db34d84f$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $eb52c0a5db34d84f$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $eb52c0a5db34d84f$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $eb52c0a5db34d84f$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $eb52c0a5db34d84f$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(_objectSpread2, $eb52c0a5db34d84f$var$alignToControl(placement), "100%"), (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $3d2a22ffe0c45568$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $eb52c0a5db34d84f$var$PortalPlacementContext = /*#__PURE__*/ (0, $f2Y41.createContext)(null);
// NOTE: internal only
var $eb52c0a5db34d84f$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $f2Y41.useContext)($eb52c0a5db34d84f$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $f2Y41.useRef)(null);
    var _useState = (0, $f2Y41.useState)(maxMenuHeight), _useState2 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $f2Y41.useState)(null), _useState4 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $f6968ac8a1a8469e$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $eb52c0a5db34d84f$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $eb52c0a5db34d84f$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $eb52c0a5db34d84f$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $eb52c0a5db34d84f$var$Menu$1 = $eb52c0a5db34d84f$var$Menu;
// ==============================
// Menu List
// ==============================
var $eb52c0a5db34d84f$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $eb52c0a5db34d84f$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $eb52c0a5db34d84f$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $eb52c0a5db34d84f$export$3b14a55fb2447963 = $eb52c0a5db34d84f$var$noticeCSS;
var $eb52c0a5db34d84f$export$342063e11d6c3cad = $eb52c0a5db34d84f$var$noticeCSS;
var $eb52c0a5db34d84f$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_ref6, $eb52c0a5db34d84f$var$_excluded$3);
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $eb52c0a5db34d84f$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_ref7, $eb52c0a5db34d84f$var$_excluded2$1);
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $eb52c0a5db34d84f$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $eb52c0a5db34d84f$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $f2Y41.useRef)(null);
    var cleanupRef = (0, $f2Y41.useRef)(null);
    var _useState5 = (0, $f2Y41.useState)($eb52c0a5db34d84f$var$coercePlacement(menuPlacement)), _useState6 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $f2Y41.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $f2Y41.useState)(null), _useState8 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $f2Y41.useCallback)(function() {
        if (!controlElement) return;
        var rect = $eb52c0a5db34d84f$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $f6968ac8a1a8469e$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $f2Y41.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $022d15fe75fec75f$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $f6968ac8a1a8469e$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $f2Y41.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({
        ref: setMenuPortalElement
    }, $eb52c0a5db34d84f$var$getStyleProps((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $5021361ff788fb77$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $eb52c0a5db34d84f$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $eb52c0a5db34d84f$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $eb52c0a5db34d84f$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $eb52c0a5db34d84f$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $eb52c0a5db34d84f$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $eb52c0a5db34d84f$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $eb52c0a5db34d84f$var$_templateObject;
var $eb52c0a5db34d84f$var$_excluded$2 = [
    "size"
], $eb52c0a5db34d84f$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $eb52c0a5db34d84f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $eb52c0a5db34d84f$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $eb52c0a5db34d84f$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_ref, $eb52c0a5db34d84f$var$_excluded$2);
    return (0, $jvVhJ.jsx)("svg", (0, $asN9r.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $eb52c0a5db34d84f$var$_ref2
    }, props));
};
var $eb52c0a5db34d84f$var$CrossIcon = function CrossIcon(props) {
    return (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$Svg, (0, $asN9r.default)({
        size: 20
    }, props), (0, $jvVhJ.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $eb52c0a5db34d84f$var$DownChevron = function DownChevron(props) {
    return (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$Svg, (0, $asN9r.default)({
        size: 20
    }, props), (0, $jvVhJ.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $eb52c0a5db34d84f$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $eb52c0a5db34d84f$export$f1e1789686576879 = $eb52c0a5db34d84f$var$baseCSS;
var $eb52c0a5db34d84f$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$DownChevron, null));
};
var $eb52c0a5db34d84f$export$407448d2b89b1813 = $eb52c0a5db34d84f$var$baseCSS;
var $eb52c0a5db34d84f$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $eb52c0a5db34d84f$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $eb52c0a5db34d84f$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("span", (0, $asN9r.default)({}, innerProps, $eb52c0a5db34d84f$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $eb52c0a5db34d84f$var$loadingDotAnimations = (0, $jvVhJ.keyframes)($eb52c0a5db34d84f$var$_templateObject || ($eb52c0a5db34d84f$var$_templateObject = (0, $746ea5d29904c166$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $eb52c0a5db34d84f$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $eb52c0a5db34d84f$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $jvVhJ.jsx)("span", {
        css: /*#__PURE__*/ (0, $jvVhJ.css)({
            animation: "".concat($eb52c0a5db34d84f$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $eb52c0a5db34d84f$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_ref7, $eb52c0a5db34d84f$var$_excluded2);
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $eb52c0a5db34d84f$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $eb52c0a5db34d84f$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({
        ref: innerRef
    }, $eb52c0a5db34d84f$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $eb52c0a5db34d84f$var$Control$1 = $eb52c0a5db34d84f$var$Control;
var $eb52c0a5db34d84f$var$_excluded$1 = [
    "data"
];
var $eb52c0a5db34d84f$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $eb52c0a5db34d84f$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $jvVhJ.jsx)(Heading, (0, $asN9r.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $jvVhJ.jsx)("div", null, children));
};
var $eb52c0a5db34d84f$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $eb52c0a5db34d84f$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $eb52c0a5db34d84f$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_cleanCommonProps, $eb52c0a5db34d84f$var$_excluded$1);
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $eb52c0a5db34d84f$var$Group$1 = $eb52c0a5db34d84f$var$Group;
var $eb52c0a5db34d84f$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $eb52c0a5db34d84f$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $eb52c0a5db34d84f$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $eb52c0a5db34d84f$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $eb52c0a5db34d84f$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $eb52c0a5db34d84f$var$spacingStyle)
};
var $eb52c0a5db34d84f$var$inputStyle = function inputStyle(isHidden) {
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $eb52c0a5db34d84f$var$spacingStyle);
};
var $eb52c0a5db34d84f$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $eb52c0a5db34d84f$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_cleanCommonProps, $eb52c0a5db34d84f$var$_excluded);
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $jvVhJ.jsx)("input", (0, $asN9r.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $eb52c0a5db34d84f$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $eb52c0a5db34d84f$var$Input$1 = $eb52c0a5db34d84f$var$Input;
var $eb52c0a5db34d84f$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $eb52c0a5db34d84f$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $eb52c0a5db34d84f$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $eb52c0a5db34d84f$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $jvVhJ.jsx)("div", innerProps, children);
};
var $eb52c0a5db34d84f$var$MultiValueContainer = $eb52c0a5db34d84f$var$MultiValueGeneric;
var $eb52c0a5db34d84f$var$MultiValueLabel = $eb52c0a5db34d84f$var$MultiValueGeneric;
function $eb52c0a5db34d84f$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({
        role: "button"
    }, innerProps), children || (0, $jvVhJ.jsx)($eb52c0a5db34d84f$var$CrossIcon, {
        size: 14
    }));
}
var $eb52c0a5db34d84f$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $jvVhJ.jsx)(Container, {
        data: data,
        innerProps: (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $jvVhJ.jsx)(Label, {
        data: data,
        innerProps: (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $jvVhJ.jsx)(Remove, {
        data: data,
        innerProps: (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $eb52c0a5db34d84f$var$MultiValue$1 = $eb52c0a5db34d84f$var$MultiValue;
var $eb52c0a5db34d84f$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $eb52c0a5db34d84f$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $eb52c0a5db34d84f$var$Option$1 = $eb52c0a5db34d84f$var$Option;
var $eb52c0a5db34d84f$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $eb52c0a5db34d84f$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $eb52c0a5db34d84f$var$Placeholder$1 = $eb52c0a5db34d84f$var$Placeholder;
var $eb52c0a5db34d84f$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $eb52c0a5db34d84f$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $jvVhJ.jsx)("div", (0, $asN9r.default)({}, $eb52c0a5db34d84f$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $eb52c0a5db34d84f$var$SingleValue$1 = $eb52c0a5db34d84f$var$SingleValue;
var $eb52c0a5db34d84f$export$db3b6bfb95261072 = {
    ClearIndicator: $eb52c0a5db34d84f$var$ClearIndicator,
    Control: $eb52c0a5db34d84f$var$Control$1,
    DropdownIndicator: $eb52c0a5db34d84f$var$DropdownIndicator,
    DownChevron: $eb52c0a5db34d84f$var$DownChevron,
    CrossIcon: $eb52c0a5db34d84f$var$CrossIcon,
    Group: $eb52c0a5db34d84f$var$Group$1,
    GroupHeading: $eb52c0a5db34d84f$var$GroupHeading,
    IndicatorsContainer: $eb52c0a5db34d84f$var$IndicatorsContainer,
    IndicatorSeparator: $eb52c0a5db34d84f$var$IndicatorSeparator,
    Input: $eb52c0a5db34d84f$var$Input$1,
    LoadingIndicator: $eb52c0a5db34d84f$var$LoadingIndicator,
    Menu: $eb52c0a5db34d84f$var$Menu$1,
    MenuList: $eb52c0a5db34d84f$var$MenuList,
    MenuPortal: $eb52c0a5db34d84f$var$MenuPortal,
    LoadingMessage: $eb52c0a5db34d84f$var$LoadingMessage,
    NoOptionsMessage: $eb52c0a5db34d84f$var$NoOptionsMessage,
    MultiValue: $eb52c0a5db34d84f$var$MultiValue$1,
    MultiValueContainer: $eb52c0a5db34d84f$var$MultiValueContainer,
    MultiValueLabel: $eb52c0a5db34d84f$var$MultiValueLabel,
    MultiValueRemove: $eb52c0a5db34d84f$var$MultiValueRemove,
    Option: $eb52c0a5db34d84f$var$Option$1,
    Placeholder: $eb52c0a5db34d84f$var$Placeholder$1,
    SelectContainer: $eb52c0a5db34d84f$var$SelectContainer,
    SingleValue: $eb52c0a5db34d84f$var$SingleValue$1,
    ValueContainer: $eb52c0a5db34d84f$var$ValueContainer
};
var $eb52c0a5db34d84f$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, $eb52c0a5db34d84f$export$db3b6bfb95261072), props.components);
};



var $jvVhJ = parcelRequire("jvVhJ");
var $6f06a9e8165c2685$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $6f06a9e8165c2685$var$isEqual(first, second) {
    if (first === second) return true;
    if ($6f06a9e8165c2685$var$safeIsNaN(first) && $6f06a9e8165c2685$var$safeIsNaN(second)) return true;
    return false;
}
function $6f06a9e8165c2685$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$6f06a9e8165c2685$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $6f06a9e8165c2685$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $6f06a9e8165c2685$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $9892e685fe4ae625$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $9892e685fe4ae625$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $9892e685fe4ae625$var$A11yText = function A11yText(props) {
    return (0, $jvVhJ.jsx)("span", (0, $asN9r.default)({
        css: $9892e685fe4ae625$var$_ref
    }, props));
};
var $9892e685fe4ae625$var$A11yText$1 = $9892e685fe4ae625$var$A11yText;
var $9892e685fe4ae625$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $9892e685fe4ae625$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $f2Y41.useMemo)(function() {
        return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, $9892e685fe4ae625$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $f2Y41.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $f2Y41.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $f2Y41.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $f2Y41.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $jvVhJ.jsx)((0, $f2Y41.Fragment), null, (0, $jvVhJ.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $jvVhJ.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $jvVhJ.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $jvVhJ.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $jvVhJ.jsx)((0, $f2Y41.Fragment), null, (0, $jvVhJ.jsx)($9892e685fe4ae625$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $jvVhJ.jsx)($9892e685fe4ae625$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $9892e685fe4ae625$var$LiveRegion$1 = $9892e685fe4ae625$var$LiveRegion;
var $9892e685fe4ae625$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $9892e685fe4ae625$var$anyDiacritic = new RegExp("[" + $9892e685fe4ae625$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $9892e685fe4ae625$var$diacriticToBase = {};
for(var $9892e685fe4ae625$var$i = 0; $9892e685fe4ae625$var$i < $9892e685fe4ae625$var$diacritics.length; $9892e685fe4ae625$var$i++){
    var $9892e685fe4ae625$var$diacritic = $9892e685fe4ae625$var$diacritics[$9892e685fe4ae625$var$i];
    for(var $9892e685fe4ae625$var$j = 0; $9892e685fe4ae625$var$j < $9892e685fe4ae625$var$diacritic.letters.length; $9892e685fe4ae625$var$j++)$9892e685fe4ae625$var$diacriticToBase[$9892e685fe4ae625$var$diacritic.letters[$9892e685fe4ae625$var$j]] = $9892e685fe4ae625$var$diacritic.base;
}
var $9892e685fe4ae625$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($9892e685fe4ae625$var$anyDiacritic, function(match) {
        return $9892e685fe4ae625$var$diacriticToBase[match];
    });
};
var $9892e685fe4ae625$var$memoizedStripDiacriticsForInput = (0, $6f06a9e8165c2685$export$2e2bcd8739ae039)($9892e685fe4ae625$var$stripDiacritics);
var $9892e685fe4ae625$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $9892e685fe4ae625$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $9892e685fe4ae625$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $9892e685fe4ae625$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $9892e685fe4ae625$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $9892e685fe4ae625$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $9892e685fe4ae625$var$memoizedStripDiacriticsForInput(input);
            candidate = $9892e685fe4ae625$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $9892e685fe4ae625$var$_excluded = [
    "innerRef"
];
function $9892e685fe4ae625$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_ref, $9892e685fe4ae625$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $eb52c0a5db34d84f$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $jvVhJ.jsx)("input", (0, $asN9r.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $jvVhJ.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $9892e685fe4ae625$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $9892e685fe4ae625$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $f2Y41.useRef)(false);
    var isTop = (0, $f2Y41.useRef)(false);
    var touchStart = (0, $f2Y41.useRef)(0);
    var scrollTarget = (0, $f2Y41.useRef)(null);
    var handleEventDelta = (0, $f2Y41.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $9892e685fe4ae625$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $f2Y41.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $f2Y41.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $f2Y41.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $f2Y41.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $eb52c0a5db34d84f$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $f2Y41.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $f2Y41.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $9892e685fe4ae625$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $9892e685fe4ae625$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $9892e685fe4ae625$var$preventTouchMove(e) {
    e.preventDefault();
}
function $9892e685fe4ae625$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $9892e685fe4ae625$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $9892e685fe4ae625$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $9892e685fe4ae625$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $9892e685fe4ae625$var$activeScrollLocks = 0;
var $9892e685fe4ae625$var$listenerOptions = {
    capture: false,
    passive: false
};
function $9892e685fe4ae625$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $f2Y41.useRef)({});
    var scrollTarget = (0, $f2Y41.useRef)(null);
    var addScrollLock = (0, $f2Y41.useCallback)(function(touchScrollTarget) {
        if (!$9892e685fe4ae625$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $9892e685fe4ae625$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $9892e685fe4ae625$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($9892e685fe4ae625$var$LOCK_STYLES).forEach(function(key) {
                var val = $9892e685fe4ae625$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $9892e685fe4ae625$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $9892e685fe4ae625$var$preventTouchMove, $9892e685fe4ae625$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $9892e685fe4ae625$var$preventInertiaScroll, $9892e685fe4ae625$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $9892e685fe4ae625$var$allowTouchMove, $9892e685fe4ae625$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $9892e685fe4ae625$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $f2Y41.useCallback)(function(touchScrollTarget) {
        if (!$9892e685fe4ae625$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $9892e685fe4ae625$var$activeScrollLocks = Math.max($9892e685fe4ae625$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $9892e685fe4ae625$var$activeScrollLocks < 1) $9892e685fe4ae625$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $9892e685fe4ae625$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $9892e685fe4ae625$var$preventTouchMove, $9892e685fe4ae625$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $9892e685fe4ae625$var$preventInertiaScroll, $9892e685fe4ae625$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $9892e685fe4ae625$var$allowTouchMove, $9892e685fe4ae625$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $f2Y41.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $9892e685fe4ae625$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9892e685fe4ae625$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $9892e685fe4ae625$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $9892e685fe4ae625$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $9892e685fe4ae625$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $9892e685fe4ae625$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $jvVhJ.jsx)((0, $f2Y41.Fragment), null, lockEnabled && (0, $jvVhJ.jsx)("div", {
        onClick: $9892e685fe4ae625$var$blurSelectInput,
        css: $9892e685fe4ae625$var$_ref2$1
    }), children(targetRef));
}
function $9892e685fe4ae625$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9892e685fe4ae625$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $9892e685fe4ae625$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $jvVhJ.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $9892e685fe4ae625$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $9892e685fe4ae625$var$RequiredInput$1 = $9892e685fe4ae625$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $9892e685fe4ae625$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $9892e685fe4ae625$var$isIPhone() {
    return $9892e685fe4ae625$var$testPlatform(/^iPhone/i);
}
function $9892e685fe4ae625$var$isMac() {
    return $9892e685fe4ae625$var$testPlatform(/^Mac/i);
}
function $9892e685fe4ae625$var$isIPad() {
    return $9892e685fe4ae625$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9892e685fe4ae625$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9892e685fe4ae625$var$isIOS() {
    return $9892e685fe4ae625$var$isIPhone() || $9892e685fe4ae625$var$isIPad();
}
function $9892e685fe4ae625$var$isAppleDevice() {
    return $9892e685fe4ae625$var$isMac() || $9892e685fe4ae625$var$isIOS();
}
var $9892e685fe4ae625$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $9892e685fe4ae625$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $9892e685fe4ae625$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $9892e685fe4ae625$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $9892e685fe4ae625$var$defaultStyles = {
    clearIndicator: (0, $eb52c0a5db34d84f$export$407448d2b89b1813),
    container: (0, $eb52c0a5db34d84f$export$8b22cf2602fb60ce),
    control: (0, $eb52c0a5db34d84f$export$4368d992c4eafac0),
    dropdownIndicator: (0, $eb52c0a5db34d84f$export$f1e1789686576879),
    group: (0, $eb52c0a5db34d84f$export$39b482c5e57630a8),
    groupHeading: (0, $eb52c0a5db34d84f$export$2d1720544b23b823),
    indicatorsContainer: (0, $eb52c0a5db34d84f$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $eb52c0a5db34d84f$export$dda1d9f60106f0e9),
    input: (0, $eb52c0a5db34d84f$export$35e795649ee09318),
    loadingIndicator: (0, $eb52c0a5db34d84f$export$882b5998b3b9117c),
    loadingMessage: (0, $eb52c0a5db34d84f$export$342063e11d6c3cad),
    menu: (0, $eb52c0a5db34d84f$export$953cecd6e717a553),
    menuList: (0, $eb52c0a5db34d84f$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $eb52c0a5db34d84f$export$ae1af26003f05816),
    multiValue: (0, $eb52c0a5db34d84f$export$ffb5f4729a158638),
    multiValueLabel: (0, $eb52c0a5db34d84f$export$9e5f44173e64f162),
    multiValueRemove: (0, $eb52c0a5db34d84f$export$625550452a3fa3ec),
    noOptionsMessage: (0, $eb52c0a5db34d84f$export$3b14a55fb2447963),
    option: (0, $eb52c0a5db34d84f$export$90a7f3efeed30595),
    placeholder: (0, $eb52c0a5db34d84f$export$efccba1c4a2ef57b),
    singleValue: (0, $eb52c0a5db34d84f$export$d141bba7fdc215a3),
    valueContainer: (0, $eb52c0a5db34d84f$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $9892e685fe4ae625$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $9892e685fe4ae625$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $9892e685fe4ae625$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $9892e685fe4ae625$var$baseUnit = 4;
// The minimum height of the control
var $9892e685fe4ae625$var$controlHeight = 38;
// The amount of space between the control and menu */
var $9892e685fe4ae625$var$menuGutter = $9892e685fe4ae625$var$baseUnit * 2;
var $9892e685fe4ae625$var$spacing = {
    baseUnit: $9892e685fe4ae625$var$baseUnit,
    controlHeight: $9892e685fe4ae625$var$controlHeight,
    menuGutter: $9892e685fe4ae625$var$menuGutter
};
var $9892e685fe4ae625$export$4368d992c4eafac0 = {
    borderRadius: $9892e685fe4ae625$var$borderRadius,
    colors: $9892e685fe4ae625$var$colors,
    spacing: $9892e685fe4ae625$var$spacing
};
var $9892e685fe4ae625$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $eb52c0a5db34d84f$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $eb52c0a5db34d84f$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $9892e685fe4ae625$export$db3b6bfb95261072(),
    formatGroupLabel: $9892e685fe4ae625$var$formatGroupLabel,
    getOptionLabel: $9892e685fe4ae625$export$8b22cf2602fb60ce,
    getOptionValue: $9892e685fe4ae625$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $9892e685fe4ae625$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $eb52c0a5db34d84f$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $9892e685fe4ae625$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $9892e685fe4ae625$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $9892e685fe4ae625$var$_isOptionSelected(props, option, selectValue);
    var label = $9892e685fe4ae625$var$getOptionLabel(props, option);
    var value = $9892e685fe4ae625$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $9892e685fe4ae625$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $9892e685fe4ae625$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $9892e685fe4ae625$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $9892e685fe4ae625$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $9892e685fe4ae625$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $eb52c0a5db34d84f$export$3466f893ebf79586));
}
function $9892e685fe4ae625$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $124d9c34282e4c89$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $9892e685fe4ae625$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $124d9c34282e4c89$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $9892e685fe4ae625$var$buildFocusableOptions(props, selectValue) {
    return $9892e685fe4ae625$var$buildFocusableOptionsFromCategorizedOptions($9892e685fe4ae625$var$buildCategorizedOptions(props, selectValue));
}
function $9892e685fe4ae625$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$9892e685fe4ae625$var$shouldHideSelectedOptions(props) || !isSelected) && $9892e685fe4ae625$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $9892e685fe4ae625$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $9892e685fe4ae625$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $9892e685fe4ae625$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $9892e685fe4ae625$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $9892e685fe4ae625$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $9892e685fe4ae625$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $9892e685fe4ae625$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $9892e685fe4ae625$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $9892e685fe4ae625$var$getOptionValue(props, i) === candidate;
    });
}
function $9892e685fe4ae625$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $9892e685fe4ae625$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $9892e685fe4ae625$var$instanceId = 1;
var $9892e685fe4ae625$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $4cbcb6406e9c00b4$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $9a883d355d6d521c$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $00aae2dd90ab1888$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $9892e685fe4ae625$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $eb52c0a5db34d84f$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $eb52c0a5db34d84f$export$ef35774e6d314e91)([].concat((0, $124d9c34282e4c89$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $eb52c0a5db34d84f$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $eb52c0a5db34d84f$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $eb52c0a5db34d84f$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $eb52c0a5db34d84f$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $eb52c0a5db34d84f$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $9892e685fe4ae625$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $9892e685fe4ae625$var$buildFocusableOptionsWithIds($9892e685fe4ae625$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $eb52c0a5db34d84f$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $9892e685fe4ae625$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $9892e685fe4ae625$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $9892e685fe4ae625$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $eb52c0a5db34d84f$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $9892e685fe4ae625$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $9892e685fe4ae625$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $eb52c0a5db34d84f$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $9892e685fe4ae625$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$9892e685fe4ae625$var$instanceId);
        _this.state.selectValue = (0, $eb52c0a5db34d84f$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $9892e685fe4ae625$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $d8274a91c4ffb49e$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $eb52c0a5db34d84f$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $eb52c0a5db34d84f$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $9892e685fe4ae625$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($9892e685fe4ae625$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, $9892e685fe4ae625$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $9892e685fe4ae625$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $9892e685fe4ae625$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $9892e685fe4ae625$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $f2Y41.createElement($9892e685fe4ae625$var$DummyInput, (0, $asN9r.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $eb52c0a5db34d84f$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $f2Y41.createElement(Input, (0, $asN9r.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $f2Y41.createElement(Placeholder, (0, $asN9r.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $f2Y41.createElement(MultiValue, (0, $asN9r.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $f2Y41.createElement(SingleValue, (0, $asN9r.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $f2Y41.createElement(ClearIndicator, (0, $asN9r.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $f2Y41.createElement(LoadingIndicator, (0, $asN9r.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $f2Y41.createElement(IndicatorSeparator, (0, $asN9r.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $f2Y41.createElement(DropdownIndicator, (0, $asN9r.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $f2Y41.createElement(Option, (0, $asN9r.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $f2Y41.createElement(Group, (0, $asN9r.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $f2Y41.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $f2Y41.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $f2Y41.createElement((0, $eb52c0a5db34d84f$export$3a1a48c8f6ef640e), (0, $asN9r.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $f2Y41.createElement(Menu, (0, $asN9r.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $f2Y41.createElement($9892e685fe4ae625$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $f2Y41.createElement(MenuList, (0, $asN9r.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $f2Y41.createElement(MenuPortal, (0, $asN9r.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $f2Y41.createElement($9892e685fe4ae625$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $f2Y41.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $f2Y41.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $f2Y41.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $f2Y41.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $f2Y41.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $f2Y41.createElement($9892e685fe4ae625$var$LiveRegion$1, (0, $asN9r.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $f2Y41.createElement(SelectContainer, (0, $asN9r.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $f2Y41.createElement(Control, (0, $asN9r.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $f2Y41.createElement(ValueContainer, (0, $asN9r.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $f2Y41.createElement(IndicatorsContainer, (0, $asN9r.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $eb52c0a5db34d84f$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $9892e685fe4ae625$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $9892e685fe4ae625$var$buildFocusableOptionsWithIds($9892e685fe4ae625$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $9892e685fe4ae625$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $9892e685fe4ae625$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $9892e685fe4ae625$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $eb52c0a5db34d84f$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $f2Y41.Component));
$9892e685fe4ae625$export$25ce5a424b770e84.defaultProps = $9892e685fe4ae625$export$407448d2b89b1813;





var $f2Y41 = parcelRequire("f2Y41");
var $456085b7b9fb8a72$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $456085b7b9fb8a72$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $9fbcf6b85849bc17$export$2e2bcd8739ae039)(_ref, $456085b7b9fb8a72$var$_excluded);
    var _useState = (0, $f2Y41.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $f2Y41.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $f2Y41.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $4917cc6cc1bd8b0a$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $f2Y41.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $f2Y41.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $f2Y41.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $f2Y41.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)((0, $5b6c330ed2aee3b5$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}



var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");


var $jZjY3 = parcelRequire("jZjY3");

var $kaWmH = parcelRequire("kaWmH");

var $31a978931c9da316$exports = {};
var $7a23c4a2d8e0ddd1$exports = {};
var $bddf050de22aac7c$exports = {};

var $ctvU7 = parcelRequire("ctvU7");
var $bddf050de22aac7c$var$_typeof = $ctvU7.default;
var $16983eef6f944ede$exports = {};

var $ctvU7 = parcelRequire("ctvU7");
var $16983eef6f944ede$var$_typeof = $ctvU7.default;
function $16983eef6f944ede$var$toPrimitive(t, r) {
    if ("object" != $16983eef6f944ede$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $16983eef6f944ede$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$16983eef6f944ede$exports = $16983eef6f944ede$var$toPrimitive, $16983eef6f944ede$exports.__esModule = true, $16983eef6f944ede$exports["default"] = $16983eef6f944ede$exports;


function $bddf050de22aac7c$var$toPropertyKey(t) {
    var i = $16983eef6f944ede$exports(t, "string");
    return "symbol" == $bddf050de22aac7c$var$_typeof(i) ? i : i + "";
}
$bddf050de22aac7c$exports = $bddf050de22aac7c$var$toPropertyKey, $bddf050de22aac7c$exports.__esModule = true, $bddf050de22aac7c$exports["default"] = $bddf050de22aac7c$exports;


function $7a23c4a2d8e0ddd1$var$_defineProperty(obj, key, value) {
    key = $bddf050de22aac7c$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$7a23c4a2d8e0ddd1$exports = $7a23c4a2d8e0ddd1$var$_defineProperty, $7a23c4a2d8e0ddd1$exports.__esModule = true, $7a23c4a2d8e0ddd1$exports["default"] = $7a23c4a2d8e0ddd1$exports;


function $31a978931c9da316$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31a978931c9da316$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31a978931c9da316$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7a23c4a2d8e0ddd1$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31a978931c9da316$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$31a978931c9da316$exports = $31a978931c9da316$var$_objectSpread2, $31a978931c9da316$exports.__esModule = true, $31a978931c9da316$exports["default"] = $31a978931c9da316$exports;


var $b7613c81a1a00690$exports = {};
var $ec7ba3cf8adb0322$exports = {};
function $ec7ba3cf8adb0322$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$ec7ba3cf8adb0322$exports = $ec7ba3cf8adb0322$var$_arrayWithHoles, $ec7ba3cf8adb0322$exports.__esModule = true, $ec7ba3cf8adb0322$exports["default"] = $ec7ba3cf8adb0322$exports;


var $25ec5c0db6b3101a$exports = {};
function $25ec5c0db6b3101a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$25ec5c0db6b3101a$exports = $25ec5c0db6b3101a$var$_iterableToArrayLimit, $25ec5c0db6b3101a$exports.__esModule = true, $25ec5c0db6b3101a$exports["default"] = $25ec5c0db6b3101a$exports;


var $54584f8c229add98$exports = {};
var $0285a3f50febb90d$exports = {};
function $0285a3f50febb90d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$0285a3f50febb90d$exports = $0285a3f50febb90d$var$_arrayLikeToArray, $0285a3f50febb90d$exports.__esModule = true, $0285a3f50febb90d$exports["default"] = $0285a3f50febb90d$exports;


function $54584f8c229add98$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0285a3f50febb90d$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0285a3f50febb90d$exports(o, minLen);
}
$54584f8c229add98$exports = $54584f8c229add98$var$_unsupportedIterableToArray, $54584f8c229add98$exports.__esModule = true, $54584f8c229add98$exports["default"] = $54584f8c229add98$exports;


var $8ce6a6d90e53d38b$exports = {};
function $8ce6a6d90e53d38b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$8ce6a6d90e53d38b$exports = $8ce6a6d90e53d38b$var$_nonIterableRest, $8ce6a6d90e53d38b$exports.__esModule = true, $8ce6a6d90e53d38b$exports["default"] = $8ce6a6d90e53d38b$exports;


function $b7613c81a1a00690$var$_slicedToArray(arr, i) {
    return $ec7ba3cf8adb0322$exports(arr) || $25ec5c0db6b3101a$exports(arr, i) || $54584f8c229add98$exports(arr, i) || $8ce6a6d90e53d38b$exports();
}
$b7613c81a1a00690$exports = $b7613c81a1a00690$var$_slicedToArray, $b7613c81a1a00690$exports.__esModule = true, $b7613c81a1a00690$exports["default"] = $b7613c81a1a00690$exports;


var $7204cf9697a4e177$exports = {};

var $hBrK5 = parcelRequire("hBrK5");
function $7204cf9697a4e177$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $hBrK5(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$7204cf9697a4e177$exports = $7204cf9697a4e177$var$_objectWithoutProperties, $7204cf9697a4e177$exports.__esModule = true, $7204cf9697a4e177$exports["default"] = $7204cf9697a4e177$exports;


var $63ecb8b2a64c4a4e$exports = {};
function $63ecb8b2a64c4a4e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$63ecb8b2a64c4a4e$exports = $63ecb8b2a64c4a4e$var$_classCallCheck, $63ecb8b2a64c4a4e$exports.__esModule = true, $63ecb8b2a64c4a4e$exports["default"] = $63ecb8b2a64c4a4e$exports;


var $68b5d155398ddb28$exports = {};

function $68b5d155398ddb28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bddf050de22aac7c$exports(descriptor.key), descriptor);
    }
}
function $68b5d155398ddb28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68b5d155398ddb28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68b5d155398ddb28$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$68b5d155398ddb28$exports = $68b5d155398ddb28$var$_createClass, $68b5d155398ddb28$exports.__esModule = true, $68b5d155398ddb28$exports["default"] = $68b5d155398ddb28$exports;


var $9a9e188caacee317$exports = {};
var $3640228ba05dc39c$exports = {};
function $3640228ba05dc39c$var$_setPrototypeOf(o, p) {
    $3640228ba05dc39c$exports = $3640228ba05dc39c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $3640228ba05dc39c$exports.__esModule = true, $3640228ba05dc39c$exports["default"] = $3640228ba05dc39c$exports;
    return $3640228ba05dc39c$var$_setPrototypeOf(o, p);
}
$3640228ba05dc39c$exports = $3640228ba05dc39c$var$_setPrototypeOf, $3640228ba05dc39c$exports.__esModule = true, $3640228ba05dc39c$exports["default"] = $3640228ba05dc39c$exports;


function $9a9e188caacee317$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3640228ba05dc39c$exports(subClass, superClass);
}
$9a9e188caacee317$exports = $9a9e188caacee317$var$_inherits, $9a9e188caacee317$exports.__esModule = true, $9a9e188caacee317$exports["default"] = $9a9e188caacee317$exports;


var $bc1aa853d606ea50$exports = {};
var $f2f670a0684258e4$exports = {};
function $f2f670a0684258e4$var$_getPrototypeOf(o) {
    $f2f670a0684258e4$exports = $f2f670a0684258e4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $f2f670a0684258e4$exports.__esModule = true, $f2f670a0684258e4$exports["default"] = $f2f670a0684258e4$exports;
    return $f2f670a0684258e4$var$_getPrototypeOf(o);
}
$f2f670a0684258e4$exports = $f2f670a0684258e4$var$_getPrototypeOf, $f2f670a0684258e4$exports.__esModule = true, $f2f670a0684258e4$exports["default"] = $f2f670a0684258e4$exports;


var $cd6ee652b03e65e8$exports = {};
function $cd6ee652b03e65e8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cd6ee652b03e65e8$exports = $cd6ee652b03e65e8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $cd6ee652b03e65e8$exports.__esModule = true, $cd6ee652b03e65e8$exports["default"] = $cd6ee652b03e65e8$exports)();
}
$cd6ee652b03e65e8$exports = $cd6ee652b03e65e8$var$_isNativeReflectConstruct, $cd6ee652b03e65e8$exports.__esModule = true, $cd6ee652b03e65e8$exports["default"] = $cd6ee652b03e65e8$exports;


var $d674ac2185c01f8a$exports = {};

var $ctvU7 = parcelRequire("ctvU7");
var $d674ac2185c01f8a$var$_typeof = $ctvU7.default;
var $0228b6a4fc7ab116$exports = {};
function $0228b6a4fc7ab116$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$0228b6a4fc7ab116$exports = $0228b6a4fc7ab116$var$_assertThisInitialized, $0228b6a4fc7ab116$exports.__esModule = true, $0228b6a4fc7ab116$exports["default"] = $0228b6a4fc7ab116$exports;


function $d674ac2185c01f8a$var$_possibleConstructorReturn(self, call) {
    if (call && ($d674ac2185c01f8a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0228b6a4fc7ab116$exports(self);
}
$d674ac2185c01f8a$exports = $d674ac2185c01f8a$var$_possibleConstructorReturn, $d674ac2185c01f8a$exports.__esModule = true, $d674ac2185c01f8a$exports["default"] = $d674ac2185c01f8a$exports;


function $bc1aa853d606ea50$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cd6ee652b03e65e8$exports();
    return function _createSuperInternal() {
        var Super = $f2f670a0684258e4$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f2f670a0684258e4$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d674ac2185c01f8a$exports(this, result);
    };
}
$bc1aa853d606ea50$exports = $bc1aa853d606ea50$var$_createSuper, $bc1aa853d606ea50$exports.__esModule = true, $bc1aa853d606ea50$exports["default"] = $bc1aa853d606ea50$exports;


var $2762e79d21dfe235$exports = {};
var $1f6da15ce974b6f7$exports = {};

function $1f6da15ce974b6f7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0285a3f50febb90d$exports(arr);
}
$1f6da15ce974b6f7$exports = $1f6da15ce974b6f7$var$_arrayWithoutHoles, $1f6da15ce974b6f7$exports.__esModule = true, $1f6da15ce974b6f7$exports["default"] = $1f6da15ce974b6f7$exports;


var $a61c8a376937b9f4$exports = {};
function $a61c8a376937b9f4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$a61c8a376937b9f4$exports = $a61c8a376937b9f4$var$_iterableToArray, $a61c8a376937b9f4$exports.__esModule = true, $a61c8a376937b9f4$exports["default"] = $a61c8a376937b9f4$exports;



var $47c5e7e21b1c7de4$exports = {};
function $47c5e7e21b1c7de4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$47c5e7e21b1c7de4$exports = $47c5e7e21b1c7de4$var$_nonIterableSpread, $47c5e7e21b1c7de4$exports.__esModule = true, $47c5e7e21b1c7de4$exports["default"] = $47c5e7e21b1c7de4$exports;


function $2762e79d21dfe235$var$_toConsumableArray(arr) {
    return $1f6da15ce974b6f7$exports(arr) || $a61c8a376937b9f4$exports(arr) || $54584f8c229add98$exports(arr) || $47c5e7e21b1c7de4$exports();
}
$2762e79d21dfe235$exports = $2762e79d21dfe235$var$_toConsumableArray, $2762e79d21dfe235$exports.__esModule = true, $2762e79d21dfe235$exports["default"] = $2762e79d21dfe235$exports;



parcelRequire("ctvU7");
var $fd41168cef20dc1f$exports = {};
function $fd41168cef20dc1f$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$fd41168cef20dc1f$exports = $fd41168cef20dc1f$var$_taggedTemplateLiteral, $fd41168cef20dc1f$exports.__esModule = true, $fd41168cef20dc1f$exports["default"] = $fd41168cef20dc1f$exports;






var $db719d6f6a8b606c$var$StateManagedSelect = /*#__PURE__*/ (0, $f2Y41.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $456085b7b9fb8a72$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $f2Y41.createElement((0, $9892e685fe4ae625$export$25ce5a424b770e84), (0, $asN9r.default)({
        ref: ref
    }, baseSelectProps));
});
var $db719d6f6a8b606c$export$2e2bcd8739ae039 = $db719d6f6a8b606c$var$StateManagedSelect;
var $db719d6f6a8b606c$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $f2Y41.useMemo)(function() {
        return (0, $kaWmH.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $f2Y41.createElement((0, $jZjY3.C), {
        value: emotionCache
    }, children);
};


function $876a77f383624865$export$19a1662012aa7379(props) {
    const { register: register, handleSubmit: handleSubmit, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            patient_id: props.patientId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { data: conditions, isLoading: isLoadingConditions, isError: isErrorConditions, mutate: mutateConditions } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("conditions");
    const [conditionsOptions, setConditionsOptions] = (0, $f2Y41.useState)([]);
    (0, $f2Y41.useEffect)(()=>{
        setConditionsOptions(conditions.slice().map((condition)=>({
                value: condition.id,
                label: condition.name
            })));
    }, [
        conditions
    ]);
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = (data)=>{
        data = {
            ...data,
            condition_id: data.condition_id?.value,
            started_at: data.started_at + " 00:00:00",
            ended_at: data.started_at + " 00:00:00"
        };
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patient_conditions", data, getAccessTokenSilently).then((response)=>{
            props?.refreshData();
            closeModal();
        }, (error)=>{});
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-condition-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Add Condition"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "grid grid-cols-6 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "medication_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Condition"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "condition_id",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $db719d6f6a8b606c$export$2e2bcd8739ae039), {
                                                                    ...field,
                                                                    filterOption: (0, $9892e685fe4ae625$export$db3b6bfb95261072)({
                                                                        ignoreAccents: false
                                                                    }),
                                                                    className: "text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                                    classNamePrefix: "select",
                                                                    defaultValue: "",
                                                                    isDisabled: false,
                                                                    isLoading: isLoadingConditions,
                                                                    isClearable: true,
                                                                    isSearchable: true,
                                                                    name: "condition_id_select",
                                                                    options: conditionsOptions
                                                                })
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "started_at",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Started at"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "started_at",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "date",
                                                                sx: {
                                                                    width: 250,
                                                                    "boxShadow": "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "ended_at",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Ended at"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "ended_at",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "date",
                                                                sx: {
                                                                    width: 250,
                                                                    "boxShadow": "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    ...register("patient_id"),
                                                    type: "hidden",
                                                    name: "patient_id",
                                                    id: "patient_id",
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    required: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "items-center p-4 border-t border-gray-200 rounded-b",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Save"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");






function $489f6d660a0cb8a1$export$35ea6cc555aa20db(props) {
    const { register: register, handleSubmit: handleSubmit, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            patient_id: props.patientId
        }
    });
    const { data: medications, isLoading: isLoadingMedications, isError: isErrorMedications, mutate: mutateMedications } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("medications");
    const { data: conditions, isLoading: isLoadingConditions, isError: isErrorConditions, mutate: mutateConditions } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("conditions");
    const [medicationsOptions, setMedicationsOptions] = (0, $f2Y41.useState)([]);
    const [conditionsOptions, setConditionsOptions] = (0, $f2Y41.useState)([]);
    const [ongoing, setOngoing] = (0, $f2Y41.useState)(true);
    (0, $f2Y41.useEffect)(()=>{
        setMedicationsOptions(medications.slice().map((medication)=>({
                value: medication.id,
                label: medication.name
            })));
    }, [
        medications
    ]);
    (0, $f2Y41.useEffect)(()=>{
        setConditionsOptions(conditions.slice().map((condition)=>({
                value: condition.id,
                label: condition.name
            })));
    }, [
        conditions
    ]);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = (data)=>{
        data = {
            ...data,
            medication_id: data.medication_id?.value,
            condition_id: data.condition_id?.value,
            started_at: data.started_at + " 00:00:00",
            ended_at: data.started_at + " 00:00:00"
        };
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patient_medications", data, getAccessTokenSilently).then((response)=>{
            props?.refreshData();
            closeModal();
        }, (error)=>{});
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-medication-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Add Medication"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "grid grid-cols-6 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "medication_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Medication"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "medication_id",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $db719d6f6a8b606c$export$2e2bcd8739ae039), {
                                                                    ...field,
                                                                    filterOption: (0, $9892e685fe4ae625$export$db3b6bfb95261072)({
                                                                        ignoreAccents: false
                                                                    }),
                                                                    className: "text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                                    classNamePrefix: "select",
                                                                    defaultValue: "",
                                                                    isDisabled: false,
                                                                    isLoading: isLoadingMedications,
                                                                    isClearable: true,
                                                                    isSearchable: true,
                                                                    name: "medication_id_select",
                                                                    options: medicationsOptions
                                                                })
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "medication_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Condition"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "condition_id",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $db719d6f6a8b606c$export$2e2bcd8739ae039), {
                                                                    ...field,
                                                                    filterOption: (0, $9892e685fe4ae625$export$db3b6bfb95261072)({
                                                                        ignoreAccents: false
                                                                    }),
                                                                    className: "text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                                    classNamePrefix: "select",
                                                                    defaultValue: "",
                                                                    isDisabled: false,
                                                                    isLoading: isLoadingConditions,
                                                                    isClearable: true,
                                                                    isSearchable: true,
                                                                    name: "condition_id_select",
                                                                    options: conditionsOptions
                                                                })
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "amount",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Amount"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        ...register("amount"),
                                                        type: "text",
                                                        name: "amount",
                                                        id: "amount",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "unit",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Unit"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        ...register("unit"),
                                                        type: "text",
                                                        name: "unit",
                                                        id: "unit",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "started_at",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Started at"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "started_at",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "date",
                                                                sx: {
                                                                    width: 250,
                                                                    "boxShadow": "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                htmlFor: "ongoing",
                                                className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                children: "Ongoing?"
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                type: "checkbox",
                                                onClick: ()=>setOngoing(!ongoing),
                                                checked: ongoing
                                            }),
                                            !ongoing && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "ended_at",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Ended at"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "ended_at",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "date",
                                                                sx: {
                                                                    width: 250,
                                                                    "boxShadow": "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    ...register("patient_id"),
                                                    type: "hidden",
                                                    name: "patient_id",
                                                    id: "patient_id",
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    required: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "items-center p-4 border-t border-gray-200 rounded-b",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Save"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $a4cf0a5f8185a83e$exports = {};
"use strict";
var $20971fe4afd694e3$exports = {};
$20971fe4afd694e3$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $a4cf0a5f8185a83e$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $a4cf0a5f8185a83e$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $a4cf0a5f8185a83e$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $a4cf0a5f8185a83e$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $20971fe4afd694e3$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $a4cf0a5f8185a83e$var$clipboardToIE11Formatting[options.format] || $a4cf0a5f8185a83e$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $a4cf0a5f8185a83e$var$format("message" in options ? options.message : $a4cf0a5f8185a83e$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$a4cf0a5f8185a83e$exports = $a4cf0a5f8185a83e$var$copy;



var $f2Y41 = parcelRequire("f2Y41");






function $89045d946c028d1e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $dac10fce6357ec0a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



function $5a8afbdb5ca9e572$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e912b0c64a070462$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $623cd31f1b422257$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $dac10fce6357ec0a$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $89045d946c028d1e$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $dac10fce6357ec0a$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


function $65d7d531c747e25e$export$67ae8b1c97c98c2a(dateOfBirth) {
    if (!dateOfBirth || dateOfBirth === "") return "No DOB Present";
    return (0, $5a8afbdb5ca9e572$export$2e2bcd8739ae039)(new Date(), new Date(dateOfBirth)) || "UNKNOWN";
}


const $ee2b32dbb58b2642$export$e5643c168619274b = (dirtyFields, allValues)=>{
    // NOTE: Recursive function.
    // If *any* item in an array was modified, the entire array must be submitted, because there's no
    // way to indicate "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.
    if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;
    // Here, we have an object.
    return Object.fromEntries(Object.keys(dirtyFields).map((key)=>[
            key,
            $ee2b32dbb58b2642$export$e5643c168619274b(dirtyFields[key], allValues[key])
        ]));
};





const $7b97d39664d4afa2$export$bf33624c422fae94 = (patient)=>patient?.patient_appointments_future?.sort((a, b)=>Date.parse(a.start_dt) - Date.parse(b.start_dt))?.[0];
const $7b97d39664d4afa2$export$db0cfc301188f132 = (patient)=>{
    const nextAppointmentValue = $7b97d39664d4afa2$export$bf33624c422fae94(patient);
    if (!!nextAppointmentValue) return (0, $0dcae3260236e0d2$export$3573c25f30e0099d)(new Date($7b97d39664d4afa2$export$bf33624c422fae94(patient)?.start_dt + "Z"));
};
const $7b97d39664d4afa2$export$b27dd62e39a722c7 = (patient)=>{
    const nextAppointmentValue = $7b97d39664d4afa2$export$bf33624c422fae94(patient)?.start_dt;
    if (!!nextAppointmentValue) return (0, $0dcae3260236e0d2$export$709bb038489fb0)(nextAppointmentValue);
};
const $7b97d39664d4afa2$export$b3533743d5383aa9 = (patient)=>{
    const nextAppointmentValue = $7b97d39664d4afa2$export$bf33624c422fae94(patient)?.start_dt;
    if (!!nextAppointmentValue) return (0, $0dcae3260236e0d2$export$d207855dff529fc9)(nextAppointmentValue);
};






var $ge3KO = parcelRequire("ge3KO");

function $651e0f772793d2c9$export$e463d9d8961b36a3(props) {
    const { attributeName: attributeName, handleSubmit: handleSubmit, onSubmit: onSubmit, register: register, editing: editing, setEditing: setEditing, reset: reset, value: value } = props;
    const resetForm = ()=>reset({
            [attributeName]: value
        });
    const handleReset = ()=>{
        resetForm();
        setEditing("");
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
        className: editing == attributeName ? "flex" : "hidden",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                ...register(attributeName),
                type: "text",
                id: attributeName,
                className: "block h-6 mr-1 text-gray-900 dark:text-gray-100 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                type: "submit",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "CheckCircleIcon",
                    className: "text-green-400 h-6 hover:text-green-500 hover:cursor-pointer"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                onClick: handleReset,
                className: "ml-1 mr-4",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "XCircleIcon",
                    className: "text-red-400 h-6 hover:text-red-500 hover:cursor-pointer"
                })
            })
        ]
    });
}



function $e743f4d352a48aa5$export$7875634418234b03(props) {
    const { patient: patient, screens: screens, submitContactPref: submitContactPref, submitDutyToWarnSent: submitDutyToWarnSent, submitDutyToWarnAcknowledged: submitDutyToWarnAcknowledged } = props;
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control, formState: { dirtyFields: dirtyFields, isDirty: isDirty } } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const canContact = ()=>props.patient?.["can_contact"] == undefined || !!props.patient?.["can_contact"];
    const [editing, setEditing] = (0, $f2Y41.useState)("");
    const dutyToWarnSent = ()=>props.patient?.duty_to_warn_sent == undefined || !!props.patient?.duty_to_warn_sent;
    const dutyToWarnAcknowledged = ()=>props.patient?.duty_to_warn_acknowledged == undefined || !!props.patient?.duty_to_warn_acknowledged;
    const onSubmit = (data)=>{
        const values = (0, $ee2b32dbb58b2642$export$e5643c168619274b)(dirtyFields, data);
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("patients", patient?.["id"], values, getAccessTokenSilently).then((response)=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientInfoUpdate",
                meta: {
                    patient_id: patient?.["id"],
                    element: "PatientInfoHeader",
                    fields: Object.keys
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
            props.mutatePatient();
            setEditing("");
        }, (error)=>{
        // console.dir(error);
        });
    };
    const handleEdit = (attributeName)=>{
        reset({
            [attributeName]: patient?.[attributeName]
        });
        setEditing(attributeName);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: `p-4 mb-4 rounded-lg border border-gray-200 shadow-md ${!canContact() ? "bg-red-300 border-red-400" : "text-gray-700 bg-white dark:bg-transparent dark:text-gray-200"}`,
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("h2", {
                    className: "text-xl font-bold",
                    children: [
                        patient.given_name,
                        " ",
                        patient.family_name,
                        patient.suffix ? `, ${patient.suffix}` : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "pt-1 items-center space-y-1",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex hover:cursor-pointer mt-1",
                                onClick: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($a4cf0a5f8185a83e$exports)))(patient.mrn) && (0, (/*@__PURE__*/$parcel$interopDefault($3d12054b9ed86c19$exports)))("\uD83D\uDCCB MRN Copied to Clipboard!"),
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-bold text-sm mr-1",
                                        children: "MRN"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "mr-6 text-sm",
                                        children: patient.mrn
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>handleEdit("referring_provider"),
                                        className: "font-bold text-sm mr-1",
                                        children: "Provider"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: `flex hover:cursor-pointer mr-6 text-sm ${patient.referring_provider ? "dark:text-gray-200" : "text-red-500 dark:text-red-400"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                onClick: ()=>handleEdit("referring_provider"),
                                                className: editing == "referring_provider" ? "hidden" : "flex ",
                                                children: [
                                                    patient.referring_provider || "Unknown",
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "opacity-0 flex items-center group-hover:opacity-100 pr-2",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                            icon: "PencilAltIcon",
                                                            className: "ml-2 h-4"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $651e0f772793d2c9$export$e463d9d8961b36a3), {
                                                attributeName: "referring_provider",
                                                value: patient.email,
                                                reset: reset,
                                                handleSubmit: handleSubmit,
                                                onSubmit: onSubmit,
                                                register: register,
                                                editing: editing,
                                                setEditing: setEditing
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-baseline pb-0",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-bold text-sm",
                                        children: "Source"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "flex text-sm ml-1",
                                        children: (0, $17235661ec5f519b$export$b94aa994a2f01789)(patient?.source)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-baseline pb-0",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-bold text-sm",
                                        children: "Next Appointment"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "flex flex-nowrap text-sm ml-1",
                                        children: (0, $7b97d39664d4afa2$export$b3533743d5383aa9)(patient)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-baseline pb-0",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-bold text-sm",
                                        children: "Age"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "flex text-sm ml-2",
                                        children: [
                                            (0, $65d7d531c747e25e$export$67ae8b1c97c98c2a)(patient.dob),
                                            " ",
                                            patient.dob ? `(${(0, $0dcae3260236e0d2$export$1d9850e26a13908a)(patient.dob)})` : ""
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex flex-col space-y-1",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "group flex items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>handleEdit("preferred_email"),
                                        className: `text-sm mr-1`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "MailIcon",
                                            className: `h-5 w-5`,
                                            outline: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: ` text-sm ${editing == "preferred_email" ? "hidden" : "flex"}`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                            className: `${patient.email || patient.preferred_email ? "dark:text-gray-200" : "text-red-500"}`,
                                            href: `mailto:${patient.preferred_email || patient.email}`,
                                            children: patient.preferred_email || patient.email || "Unknown"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>handleEdit("preferred_email"),
                                        className: editing == "preferred_email" ? "hidden" : "flex",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "opacity-0 flex items-center group-hover:opacity-100 pr-2 hover:cursor-pointer",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "PencilAltIcon",
                                                className: "ml-2 h-4"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $651e0f772793d2c9$export$e463d9d8961b36a3), {
                                        attributeName: "preferred_email",
                                        value: patient.preferred_email || patient.email,
                                        reset: reset,
                                        handleSubmit: handleSubmit,
                                        onSubmit: onSubmit,
                                        register: register,
                                        editing: editing,
                                        setEditing: setEditing
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "group flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>setEditing("preferred_phone"),
                                        className: `text-sm mr-1`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "PhoneIcon",
                                            className: `h-5 w-5 `,
                                            outline: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: `mr-6 text-sm ${editing == "preferred_phone" ? "hidden" : "flex"}`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                            className: `${patient.phone && patient.preferred_phone}} ? 'dark:text-gray-200': 'text-red-500'}`,
                                            href: `tel:${patient.preferred_phone || patient.phone}`,
                                            children: patient.preferred_phone || patient.phone || "Unknown"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>handleEdit("preferred_phone"),
                                        className: editing == "preferred_phone" ? "hidden" : "flex",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "opacity-0 flex items-center group-hover:opacity-100 pr-2 hover:cursor-pointer",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "PencilAltIcon",
                                                className: "ml-2 h-4"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $651e0f772793d2c9$export$e463d9d8961b36a3), {
                                        attributeName: "preferred_phone",
                                        value: patient.preferred_phone || patient.phone,
                                        reset: reset,
                                        handleSubmit: handleSubmit,
                                        onSubmit: onSubmit,
                                        register: register,
                                        editing: editing,
                                        setEditing: setEditing
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "items-baseline pb-1",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "font-bold text-sm mr-1 mt-2",
                                children: "Screening Studies"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex flex-col",
                                children: screens.map((screen, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        to: `/patients/${patient.id}/screens/${screen.id}`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da10e49b852b9347$export$55c72165ec0b2743), {
                                            text: screen.study.abbreviation,
                                            status: screen.status
                                        })
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex pt-2",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex space-x-2 align-top",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>submitContactPref({
                                                can_contact: true
                                            }),
                                        className: `${!canContact() ? "cursor-pointer" : "cursor-default"} `,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "CheckCircleIcon",
                                            className: `w-5 h-5 flex ${canContact() ? "text-topo-green-500" : "text-gray-500 dark:text-gray-400 hover:text-topo-green-500 dark:hover:text-topo-green-500"}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>submitContactPref({
                                                can_contact: false
                                            }),
                                        className: `${canContact() ? "cursor-pointer" : "cursor-default"}`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "XCircleIcon",
                                            className: `ml-1 w-5 h-5 flex ${!canContact() ? "text-red-500" : "text-gray-500 dark:text-gray-400 hover:text-red-500"}`
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: `flex text-sm space-x-1 font-medium ${canContact() ? "text-gray-900 dark:text-gray-300" : canContact() ? "text-gray-900 dark:text-gray-300" : "text-red-500"}`,
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-bold",
                                        children: canContact() ? "Yes," : "No,"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        children: `${canContact() ? "can" : canContact() ? "can" : "cannot"} be contacted for research`
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex pt-2",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex pr-4 space-x-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>submitDutyToWarnSent({
                                                duty_to_warn_sent: true
                                            }),
                                        className: `${!dutyToWarnSent() ? "cursor-pointer" : "cursor-default"} `,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "CheckCircleIcon",
                                            className: `w-5 h-5 flex ${dutyToWarnSent() ? "text-topo-green-500" : "text-gray-500 dark:text-gray-400 hover:text-topo-green-500 dark:hover:text-topo-green-500"}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>submitDutyToWarnSent({
                                                duty_to_warn_sent: false
                                            }),
                                        className: `${dutyToWarnSent() ? "cursor-pointer" : "cursor-default"}`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "XCircleIcon",
                                            className: `ml-1 w-5 h-5 flex ${!dutyToWarnSent() ? "text-red-500" : "text-gray-500 dark:text-gray-400 hover:text-red-500"}`
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: `flex text-sm space-x-1 font-medium align-middle ${dutyToWarnSent() ? "text-gray-900 dark:text-gray-300" : dutyToWarnSent() ? "text-gray-900 dark:text-gray-300" : "text-red-500"}`,
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: `Duty To Warn ${dutyToWarnSent() ? "sent" : "not sent"}`
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex pt-2",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex pr-4 space-x-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>submitDutyToWarnAcknowledged({
                                                duty_to_warn_acknowledged: true
                                            }),
                                        className: `${!dutyToWarnAcknowledged() ? "cursor-pointer" : "cursor-default"} `,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "CheckCircleIcon",
                                            className: `w-5 h-5 flex ${dutyToWarnAcknowledged() ? "text-topo-green-500" : "text-gray-500 dark:text-gray-400 hover:text-topo-green-500 dark:hover:text-topo-green-500"}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        onClick: ()=>submitDutyToWarnAcknowledged({
                                                duty_to_warn_acknowledged: false
                                            }),
                                        className: `${dutyToWarnAcknowledged() ? "cursor-pointer" : "cursor-default"}`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "XCircleIcon",
                                            className: `ml-1 w-5 h-5 flex ${!dutyToWarnAcknowledged() ? "text-red-500" : "text-gray-500 dark:text-gray-400 hover:text-red-500"}`
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: `flex text-sm space-x-1 font-medium align-middle ${dutyToWarnAcknowledged() ? "text-gray-900 dark:text-gray-300" : dutyToWarnAcknowledged() ? "text-gray-900 dark:text-gray-300" : "text-red-500"}`,
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: `Duty to Warn ${dutyToWarnAcknowledged() ? "acknowledged" : "not acknowledged"}`
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
function $21c6baf13a453973$export$fba3b8dabb62dcfc(props) {
    const handleClose = ()=>{
        props.resumeAfterIdle();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold dark:text-white",
                                        children: "Still there?"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>handleClose(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                clipRule: "evenodd"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "p-6 space-y-6 dark:text-gray-200",
                                children: [
                                    "We detected inactivity and paused your screening for you. ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                        children: " When you're ready to resume, just click the resume button below."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "items-center p-4 border-t border-gray-200 dark:border-gray-700 rounded-b",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                    className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                    onClick: ()=>handleClose(),
                                    children: "Resume"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}






var $ge3KO = parcelRequire("ge3KO");




var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");










function $1ec2e48a5c86f643$export$a202cae2acd3d824(props) {
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { currentUser: currentUser, practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { register: registerUpdateForm, handleSubmit: handleSubmitUpdateForm, reset: resetUpdateForm } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { data: patientComments, mutate: patientCommentsMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patient_comments", `patient_id=${props.patientId}`);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [updatingCommentId, setUpdatingCommentId] = (0, $f2Y41.useState)("");
    const { screenId: screenId = "" } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: screen } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("screens", screenId);
    const onSubmit = async (data)=>{
        data.patient_id = props.patientId;
        data.practice_id = practiceId;
        if (screen) data.study_id = screen?.study?.id;
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patient_comments", data, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientCommentCreate",
            meta: {
                patient_id: props.patientId,
                screen_id: screenId,
                element: "PatientInfoSidebar"
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        patientCommentsMutate();
        reset();
    };
    const handleEdit = (id, body)=>{
        if (updatingCommentId === id) setUpdatingCommentId("");
        else {
            setUpdatingCommentId(id);
            resetUpdateForm({
                id: id,
                body: body
            });
        }
    };
    const handleDelete = async (id)=>{
        await (0, $b2d06586a86d14b7$export$60acb8fd13afd60d)("patient_comments", id, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientCommentDelete",
            meta: {
                patient_id: props.patientId,
                element: "PatientInfoSidebar",
                patient_comment_id: id
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        patientCommentsMutate();
    };
    const onUpdate = async (data)=>{
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("patient_comments", data.id, {
            body: data.body
        }, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientCommentUpdate",
            meta: {
                patient_id: props.patientId,
                element: "PatientInfoSidebar",
                patient_comment_id: data.id
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        setUpdatingCommentId("");
        patientCommentsMutate();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "p-4 mb-4 rounded-lg border border-gray-200 shadow-md text-gray-700 bg-white dark:bg-transparent dark:text-gray-200",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                className: "mb-2 text-base font-bold text-gray-900 dark:text-gray-200",
                children: "Comments"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7caf46d1a8880013$export$6c0524ba53950d9f), {
                        currentUser: currentUser
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                        className: "flex ml-2",
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("textarea", {
                                ...register("body"),
                                rows: 1,
                                required: true,
                                className: "p-2 self-center min-h-[2.3rem] text-sm bg-white dark:bg-gray-800 border border-gray-200 shadow-sm rounded-md mr-2"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                type: "submit",
                                className: "align-middle bg-topo-navy hover:bg-blue-800 rounded focus:ring-blue-300 h-10 p-2 rotate-90",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    className: "h-5 w-5 text-white",
                                    icon: "PaperAirplaneIcon"
                                })
                            })
                        ]
                    })
                ]
            }),
            patientComments.map((comment)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "group",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex items-center space-x-2 mt-4 ",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a0b772244d08cba$export$e2255cf6045e8d47), {
                                        name: comment?.created_by?.name,
                                        className: "h-8 w-8 rounded-full dark:border-2 dark:border-gray-700 cursor-default"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex-1 min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                            className: "text-sm font-semibold text-gray-900 truncate dark:text-white flex items-baseline",
                                            children: [
                                                comment.created_by?.name,
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "ml-2 text-xs font-normal text-gray-500 truncate dark:text-gray-400",
                                                    children: (0, $0dcae3260236e0d2$export$d66c499300451a3b)(comment.created_at)
                                                })
                                            ]
                                        }),
                                        comment.study?.abbreviation && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da10e49b852b9347$export$55c72165ec0b2743), {
                                            text: comment.study?.abbreviation?.substring(0, 13)
                                        })
                                    ]
                                })
                            ]
                        }),
                        comment.id !== updatingCommentId && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "w-5 flex flex-col pl-2",
                                    children: comment.created_by_user_id === currentUser?.id && /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>handleEdit(comment.id, comment.body),
                                        onKeyUp: ()=>handleEdit(comment.id, comment.body),
                                        className: `${comment.id !== updatingCommentId ? "hidden" : ""} mt-2 align-middle group-hover:inline-block text-black hover:text-gray-500`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            className: "h-4 w-4",
                                            icon: "PencilAltIcon"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "w-64 pl-5 pt-1.5 text-sm min-h-[2rem]",
                                    children: [
                                        comment.body,
                                        !(0, $0dcae3260236e0d2$export$130c2d9632f0fc1d)(comment.created_at, comment.updated_at) && /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                            className: " ml-2 text-xs font-normal text-gray-500 truncate dark:text-gray-400",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                className: "cursor-default",
                                                title: `Last updated: ${(0, $0dcae3260236e0d2$export$d66c499300451a3b)(comment.updated_at)}`,
                                                children: "(edited)"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        comment.id === updatingCommentId && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "pl-2 pt-8",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>handleDelete(comment.id),
                                        onKeyUp: ()=>handleDelete(comment.id),
                                        className: `${comment.id !== updatingCommentId ? "hidden" : ""} h-10 align-middle group-hover:inline-block text-black hover:text-red-500`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            className: "h-4 w-4",
                                            icon: "TrashIcon"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                    className: "flex ml-4",
                                    onSubmit: handleSubmitUpdateForm(onUpdate),
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                            type: "hidden",
                                            ...registerUpdateForm("id")
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("textarea", {
                                            ...registerUpdateForm("body"),
                                            rows: 1,
                                            className: "p-2 self-center min-h-[4rem] text-sm bg-white border border-gray-200 shadow-sm rounded-md mr-2"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                    type: "submit",
                                                    className: "align-middle p-2 text-black  hover:text-topo-green",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        className: "h-5 w-5 ",
                                                        icon: "CheckCircleIcon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setUpdatingCommentId(""),
                                                    onKeyUp: ()=>setUpdatingCommentId(""),
                                                    className: "align-middle p-2 text-black hover:text-red-500",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        className: "h-5 w-5 ",
                                                        icon: "XCircleIcon"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, comment.id))
        ]
    });
}




var $ge3KO = parcelRequire("ge3KO");



function $b6a29f0887db7d93$export$931ffbc9d69cc57d(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "p-4 mb-4 rounded-lg border border-gray-200 shadow-md text-gray-700 bg-white dark:bg-transparent dark:text-gray-200",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "sm:flex sm:space-x-4 xl:space-x-0",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex justify-between",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "mb-2 text-base font-bold text-gray-900 dark:text-gray-200",
                            children: "Upcoming Appointments"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex flex-row mb-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                        onClick: ()=>props.setNewAppointmentModalOpen(true),
                        className: "text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "PlusCircleIcon",
                                className: "fill-white w-4 h-4 mr-2 rotate-90"
                            }),
                            "Add Appointment"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                        to: `/patients/${props.patientId}/appointments`,
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                            className: "text-white bg-topo-navy hover:bg-topo-navy focus:bg-topo-navy focus:outline-none focus:ring-2 focus:ring-topo-navy-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center ml-2",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    icon: "ViewListIcon",
                                    className: "fill-white w-4 h-4 mr-2"
                                }),
                                "View All"
                            ]
                        })
                    })
                ]
            }),
            props.patientAppointments.length == 0 && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "text-xs mb-2",
                children: "No Upcoming Appointments"
            }),
            props.patientAppointments.map((appointment, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex flex-row mb-4 border-b border-gray-200",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: " w-full",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex items-center w-full justify-between",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "mr-1",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "CalendarIcon",
                                                outline: true,
                                                className: "h-5 rounded-md"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "text-sm font-semibold",
                                            children: (0, $0dcae3260236e0d2$export$d207855dff529fc9)(appointment.start_dt)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "text-gray-600 dark:text-gray-300 text-xs mb-1 ml-6",
                                children: appointment.appointment_type
                            })
                        ]
                    })
                }, index))
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");







const $302d7243d3cca932$var$iconForContactType = (contactType)=>{
    switch(contactType){
        case "phone_call":
            return "PhoneIcon";
        case "in_person":
            return "UsersIcon";
        case "sms":
            return "ChatAltIcon";
        case "email":
            return "AtSymbolIcon";
        case "postcard_letter":
            return "MailOpenIcon";
        default:
            return "AnnotationIcon";
    }
};
function $302d7243d3cca932$export$b5586b0586829747(props) {
    const { screenId: screenId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const handleEdit = (contactId)=>{
        props.setContactModalEditingId(contactId);
        props.setContactModalOpen(true);
    };
    const handleMakeCall = async (props)=>{
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("contacts", {
            screen_id: screenId,
            patient_id: props.patientId,
            contact_type: "phone_call",
            contact_reason: "",
            contact_length: "",
            disposition: "",
            contacted_at: new Date().toISOString().slice(0, -1)
        }, getAccessTokenSilently).then((response)=>{
            props.setContactModalEditingId(response?.data.data?.id);
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "ContactSave",
                meta: {
                    patient_id: props.patientId,
                    screen_id: props.screenId,
                    contact_id: response?.data?.data?.id
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        });
        props.mutateContacts();
        props.setContactDispositionOpen(true);
    };
    const handleIDidntMakeACall = async (props)=>{
        props.setContactDispositionOpen(false);
        if (props.contactModalEditingId) {
            await (0, $b2d06586a86d14b7$export$74524c73191a667c)("contacts", props.contactModalEditingId, {
                deleted_at: new Date().toISOString().slice(0, -1)
            }, getAccessTokenSilently).then((response)=>{
                props.setContactModalEditingId("");
                (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                    eventName: "ContactDelete",
                    meta: {
                        patient_id: props.patientId,
                        screen_id: props.screenId,
                        contact_id: response?.data?.data?.id
                    },
                    getAccessTokenSilently: getAccessTokenSilently
                });
            });
            props.mutateContacts();
        }
    };
    const handleIMadeACall = async (props)=>{
        props.setContactModalOpen(true);
        props.setContactDispositionOpen(false);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "p-4 mb-4 rounded-lg border border-gray-200 shadow-md text-gray-700 bg-white dark:bg-transparent dark:text-gray-200",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "sm:flex xl:block sm:space-x-4 xl:space-x-0",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex justify-between",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "mb-2 text-base font-bold text-gray-900 dark:text-gray-200",
                            children: "Contact Log"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex flex-row mb-4",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                        href: `tel:${props.patient?.preferred_phone || props.patient?.phone}`,
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                            onClick: ()=>handleMakeCall(props),
                            className: " text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    icon: "PhoneIcon",
                                    className: "fill-white w-4 h-4 mr-2"
                                }),
                                props.patient?.preferred_phone || props.patient?.phone ? "Click to Call" : "No Phone"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                        onClick: ()=>props.setContactModalOpen(true),
                        className: " ml-2 text-white bg-topo-navy hover:bg-topo-navy focus:bg-topo-navy focus:outline-none focus:ring-2 focus:ring-topo-navy-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "PlusCircleIcon",
                                className: "fill-white w-4 h-4 mr-2 rotate-90"
                            }),
                            "Log Contact"
                        ]
                    })
                ]
            }),
            props.contactDispositionOpen && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-4 mb-2 bg-yellow-100 rounded p-2 pl-2 pt-2 shadow-md",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: "font-medium text-yellow-700",
                        children: "Just made a call?"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                        className: "text-yellow-700 mb-2",
                        children: "Please fill out this call log before you move onto another patient."
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex flex-row",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                type: "button",
                                className: "inline-flex items-center p-2 pr-4 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-yellow-700 bg-yellow-300 hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500",
                                onClick: ()=>handleIMadeACall(props),
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                        icon: "EyeIcon",
                                        className: "h-5 w-7 mr-1 text-yellow-700",
                                        outline: true
                                    }),
                                    "Update Call Info"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                type: "button",
                                className: "ml-2 inline-flex items-center p-2 pr-4 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-red-700 bg-red-300 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500",
                                onClick: ()=>handleIDidntMakeACall(props),
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                        icon: "EyeIcon",
                                        className: "h-5 w-7 mr-1 text-red-700",
                                        outline: true
                                    }),
                                    "I Didn't Make a Call"
                                ]
                            })
                        ]
                    })
                ]
            }),
            props.contacts?.length == 0 && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "text-xs mb-2",
                children: [
                    "No Contacts Logged",
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2 underline"
                    })
                ]
            }),
            props.contacts?.map((contact, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex flex-row mb-2 border-b border-gray-200 dark:border-gray-800 bg-gray-50  dark:bg-gray-700 dark:opacity-95 rounded p-1 pl-0 pt-2",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "block w-full",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "text-xs mb-1 font-medium mr-2 px-2.5 py-0.5 rounded-md whitespace-nowrap flex",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "UserIcon",
                                                outline: true,
                                                className: "h-4 mr-2 rounded-md"
                                            }),
                                            contact?.created_by?.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        onClick: ()=>handleEdit(contact.id),
                                        className: `mr-2 align-middle group-hover:inline-block hover:text-gray-500`,
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            className: "h-4 w-4",
                                            icon: "PencilAltIcon"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "text-xs mb-1 font-medium mr-2 px-2.5 py-0.5 rounded-md whitespace-nowrap flex",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                        icon: "ClockIcon",
                                        outline: true,
                                        className: "h-4 mr-2 rounded-md"
                                    }),
                                    (0, $0dcae3260236e0d2$export$d207855dff529fc9)(contact.contacted_at)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "text-xs mb-1 font-medium mr-2 px-2.5 py-0.5 rounded-md whitespace-nowrap flex",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                        icon: $302d7243d3cca932$var$iconForContactType(contact.contact_type),
                                        outline: true,
                                        className: "h-4 mr-2 rounded-md"
                                    }),
                                    " ",
                                    contact.contact_reason,
                                    contact.contact_reason && " - ",
                                    contact.disposition
                                ]
                            }),
                            contact?.screen && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "text-xs mb-1 font-medium mr-2 px-2.5 py-0.5 rounded-md whitespace-nowrap flex ",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                        icon: (0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[contact?.screen?.status]?.icon || "DotsHorizontalIcon",
                                        outline: true,
                                        className: "h-4 mr-2 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                        to: `/patients/${props.patientId}/screens/${contact.screen_id}`,
                                        children: contact?.screen?.study?.abbreviation
                                    })
                                ]
                            })
                        ]
                    })
                }, index))
        ]
    });
}


function $de5fe1ecb44024a1$export$6f58f7f764215e5a(props) {
    let { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const clickEvent = (name)=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "Click",
            meta: {
                element: `${name.replace(/\s/g, "")}`
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
    };
    const deleteAppointment = async (id)=>{
        await (0, $b2d06586a86d14b7$export$60acb8fd13afd60d)("patient_appointments", id, getAccessTokenSilently);
        props.mutatePatientAppointments();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b6a29f0887db7d93$export$931ffbc9d69cc57d), {
                patientId: patientId,
                patientAppointments: props.patientAppointments,
                setNewAppointmentModalOpen: props.setNewAppointmentModalOpen
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $302d7243d3cca932$export$b5586b0586829747), {
                patientId: patientId,
                patient: props.patient,
                contacts: props.contacts,
                setContactModalOpen: props.setContactModalOpen,
                contactModalEditingId: props.contactModalEditingId,
                setContactModalEditingId: props.setContactModalEditingId,
                contactDispositionOpen: props.contactDispositionOpen,
                setContactDispositionOpen: props.setContactDispositionOpen,
                mutateContacts: props.mutateContacts
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1ec2e48a5c86f643$export$a202cae2acd3d824), {
                patientId: patientId
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");






function $df4e065fa53ffdd5$export$9827c096e74f4661(props) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { screenId: screenId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: contact } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("contacts", props.contactId);
    const { data: screens, isLoading: isLoadingScreens, isError: isErrorScreens, mutate: mutateScreens } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("screens", `patient_id=${props.patientId}`);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            screen_id: screenId,
            patient_id: props.patientId,
            contact_type: "phone_call",
            contact_reason: "Phone Screen",
            contact_length: "",
            disposition: "Connected/Sent",
            contacted_at: new Date().toISOString().slice(0, -1)
        }
    });
    (0, $f2Y41.useEffect)(()=>{
        if (screenId) reset({
            screen_id: screenId
        });
    }, [
        screenId,
        reset
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (props.contactId) reset({
            screen_id: contact.screen_id,
            contact_type: contact.contact_type,
            contact_reason: contact.contact_reason,
            disposition: contact.disposition,
            contact_length: contact.contact_length
        });
    }, [
        props.contactId,
        contact,
        reset
    ]);
    const closeModal = ()=>{
        props.setContactModalEditingId("");
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = async (data)=>{
        data.practice_id = practiceId;
        if (props.contactId) await (0, $b2d06586a86d14b7$export$74524c73191a667c)("contacts", props.contactId, data, getAccessTokenSilently).then((response)=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "ContactSave",
                meta: {
                    patient_id: props.patientId,
                    screen_id: props.screenId,
                    contact_id: response?.data?.data?.id
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        });
        else await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("contacts", data, getAccessTokenSilently).then((response)=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "ContactSave",
                meta: {
                    patient_id: props.patientId,
                    screen_id: props.screenId,
                    contact_id: response?.data?.data?.id
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        });
        props.setOpen(false);
        props.setContactModalEditingId("");
        props?.refreshData();
        reset();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "edit-practice-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: [
                                                props.contactId === "" ? "Log" : "Edit",
                                                " Contact"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            onKeyUp: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                "aria-label": "close button",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        id: "svg-title",
                                                        children: "Close button"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "p-6 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "grid grid-cols-6 gap-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    type: "hidden",
                                                    ...register("patient_id")
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    type: "hidden",
                                                    ...register("contacted_at")
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "screen",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Study"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("screen_id"),
                                                            name: "screen_id",
                                                            id: "screen_id",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                screens?.map((screen)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                        value: screen?.id,
                                                                        children: screen?.study?.abbreviation
                                                                    }))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "contact_type",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Contact Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("contact_type"),
                                                            name: "contact_type",
                                                            id: "contact_type",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "phone_call",
                                                                    children: "Phone Call"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "in_person",
                                                                    children: "In Person"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "sms",
                                                                    children: "SMS"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "email",
                                                                    children: "Email"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: "postcard_letter",
                                                                    children: "Postcard/Letter"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "contact_reason",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Reason For Contact"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("contact_reason"),
                                                            name: "contact_reason",
                                                            id: "contact_reason",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Phone Screen"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Scheduling"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Remote Consent"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Appointment Reminder"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Rescheduling Appointment"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Study Outreach"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "disposition",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Result"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("disposition"),
                                                            name: "disposition",
                                                            id: "disposition",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Connected/Sent"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Left Voicemail"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "Didn't Connect"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "contact_type",
                                                            className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                            children: "Length of Contact (minutes)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                            ...register("contact_length"),
                                                            name: "contact_length",
                                                            id: "contact_length",
                                                            className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                            required: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "<1"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "1-5"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "5-10"
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: "10+"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "items-center pt-4 border-t border-gray-200 rounded-b dark:border-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                type: "submit",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                onClick: ()=>closeModal(),
                onKeyUp: ()=>closeModal(),
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");

var $74cf5c252948c23d$exports = {};
"use strict";
function $74cf5c252948c23d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $74cf5c252948c23d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $74cf5c252948c23d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $74cf5c252948c23d$var$_typeof(obj);
}
Object.defineProperty($74cf5c252948c23d$exports, "__esModule", {
    value: true
});
$74cf5c252948c23d$exports.default = void 0;

var $74cf5c252948c23d$var$_toDate = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("80LJg")));

var $74cf5c252948c23d$var$_toFloat = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("bNf7m")));

var $74cf5c252948c23d$var$_toInt = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("i0Thm")));

var $74cf5c252948c23d$var$_toBoolean = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("jy2rd")));

var $74cf5c252948c23d$var$_equals = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2rAei")));

var $74cf5c252948c23d$var$_contains = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("7BDCw")));

var $74cf5c252948c23d$var$_matches = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2sqX1")));

var $74cf5c252948c23d$var$_isEmail = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2Nl9T")));

var $74cf5c252948c23d$var$_isURL = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2Djua")));

var $74cf5c252948c23d$var$_isMACAddress = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("jxiV0")));

var $74cf5c252948c23d$var$_isIP = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("dexNN")));

var $74cf5c252948c23d$var$_isIPRange = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("kpZsd")));

var $74cf5c252948c23d$var$_isFQDN = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("T9GCh")));

var $74cf5c252948c23d$var$_isDate = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("ixWQq")));

var $74cf5c252948c23d$var$_isTime = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("9lfTy")));

var $74cf5c252948c23d$var$_isBoolean = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("hZaLR")));

var $74cf5c252948c23d$var$_isLocale = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2e4Ic")));

var $74cf5c252948c23d$var$_isAlpha = $74cf5c252948c23d$var$_interopRequireWildcard((parcelRequire("aV0rk")));

var $74cf5c252948c23d$var$_isAlphanumeric = $74cf5c252948c23d$var$_interopRequireWildcard((parcelRequire("eXdnG")));

var $74cf5c252948c23d$var$_isNumeric = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("kpyBk")));

var $74cf5c252948c23d$var$_isPassportNumber = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("8LM6z")));

var $74cf5c252948c23d$var$_isPort = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("fmlzE")));

var $74cf5c252948c23d$var$_isLowercase = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("cXOxh")));

var $74cf5c252948c23d$var$_isUppercase = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("cq4cL")));

var $74cf5c252948c23d$var$_isIMEI = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("4BlyC")));

var $74cf5c252948c23d$var$_isAscii = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("6HqiH")));

var $74cf5c252948c23d$var$_isFullWidth = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("5Hlr6")));

var $74cf5c252948c23d$var$_isHalfWidth = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("dD68v")));

var $74cf5c252948c23d$var$_isVariableWidth = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("dsvgn")));

var $74cf5c252948c23d$var$_isMultibyte = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("dQ2d3")));

var $74cf5c252948c23d$var$_isSemVer = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("87eNp")));

var $74cf5c252948c23d$var$_isSurrogatePair = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("eYk3J")));

var $74cf5c252948c23d$var$_isInt = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("vYRBE")));

var $74cf5c252948c23d$var$_isFloat = $74cf5c252948c23d$var$_interopRequireWildcard((parcelRequire("fB1zQ")));

var $74cf5c252948c23d$var$_isDecimal = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("8xjBa")));

var $74cf5c252948c23d$var$_isHexadecimal = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("ijVHf")));

var $74cf5c252948c23d$var$_isOctal = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("lE2DI")));

var $74cf5c252948c23d$var$_isDivisibleBy = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("e4PHM")));

var $74cf5c252948c23d$var$_isHexColor = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("c3ees")));

var $74cf5c252948c23d$var$_isRgbColor = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("3mSUx")));

var $74cf5c252948c23d$var$_isHSL = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("YCcJx")));

var $74cf5c252948c23d$var$_isISRC = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("d8NWY")));

var $74cf5c252948c23d$var$_isIBAN = $74cf5c252948c23d$var$_interopRequireWildcard((parcelRequire("ffjn6")));

var $74cf5c252948c23d$var$_isBIC = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("lE5QL")));

var $74cf5c252948c23d$var$_isMD = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("6XFar")));

var $74cf5c252948c23d$var$_isHash = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("22yTH")));

var $74cf5c252948c23d$var$_isJWT = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("kqU6g")));

var $74cf5c252948c23d$var$_isJSON = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("kr3HT")));

var $74cf5c252948c23d$var$_isEmpty = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("iRJWq")));

var $74cf5c252948c23d$var$_isLength = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("9Xy9f")));

var $74cf5c252948c23d$var$_isByteLength = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("5CAcv")));

var $74cf5c252948c23d$var$_isUUID = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("by6IX")));

var $74cf5c252948c23d$var$_isMongoId = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("cyH15")));

var $74cf5c252948c23d$var$_isAfter = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("7jcRv")));

var $74cf5c252948c23d$var$_isBefore = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("3LA1R")));

var $74cf5c252948c23d$var$_isIn = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("jJbsv")));

var $74cf5c252948c23d$var$_isLuhnNumber = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("d6ls8")));

var $74cf5c252948c23d$var$_isCreditCard = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("6fSL5")));

var $74cf5c252948c23d$var$_isIdentityCard = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("9shKI")));

var $74cf5c252948c23d$var$_isEAN = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2BQhf")));

var $74cf5c252948c23d$var$_isISIN = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2WYjl")));

var $74cf5c252948c23d$var$_isISBN = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("905An")));

var $74cf5c252948c23d$var$_isISSN = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2pkna")));

var $74cf5c252948c23d$var$_isTaxID = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("kk69h")));

var $74cf5c252948c23d$var$_isMobilePhone = $74cf5c252948c23d$var$_interopRequireWildcard((parcelRequire("2Crc0")));

var $74cf5c252948c23d$var$_isEthereumAddress = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("cXfyP")));

var $74cf5c252948c23d$var$_isCurrency = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("76NuI")));

var $74cf5c252948c23d$var$_isBtcAddress = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("d7JFz")));
var $3030998065478fdd$exports = {};
"use strict";
Object.defineProperty($3030998065478fdd$exports, "__esModule", {
    value: true
});
$3030998065478fdd$exports.isISO6346 = $3030998065478fdd$var$isISO6346;
$3030998065478fdd$exports.isFreightContainerID = void 0;

var $3030998065478fdd$var$_assertString = $3030998065478fdd$var$_interopRequireDefault((parcelRequire("G0UOe")));
function $3030998065478fdd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://en.wikipedia.org/wiki/ISO_6346
// according to ISO6346 standard, checksum digit is mandatory for freight container but recommended
// for other container types (J and Z)
var $3030998065478fdd$var$isISO6346Str = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/;
var $3030998065478fdd$var$isDigit = /^[0-9]$/;
function $3030998065478fdd$var$isISO6346(str) {
    (0, $3030998065478fdd$var$_assertString.default)(str);
    str = str.toUpperCase();
    if (!$3030998065478fdd$var$isISO6346Str.test(str)) return false;
    if (str.length === 11) {
        var sum = 0;
        for(var i = 0; i < str.length - 1; i++)if (!$3030998065478fdd$var$isDigit.test(str[i])) {
            var convertedCode = void 0;
            var letterCode = str.charCodeAt(i) - 55;
            if (letterCode < 11) convertedCode = letterCode;
            else if (letterCode >= 11 && letterCode <= 20) convertedCode = 12 + letterCode % 11;
            else if (letterCode >= 21 && letterCode <= 30) convertedCode = 23 + letterCode % 21;
            else convertedCode = 34 + letterCode % 31;
            sum += convertedCode * Math.pow(2, i);
        } else sum += str[i] * Math.pow(2, i);
        var checkSumDigit = sum % 11;
        return Number(str[str.length - 1]) === checkSumDigit;
    }
    return true;
}
var $3030998065478fdd$var$isFreightContainerID = $3030998065478fdd$var$isISO6346;
$3030998065478fdd$exports.isFreightContainerID = $3030998065478fdd$var$isFreightContainerID;



var $74cf5c252948c23d$var$_isISO2 = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("bANpD")));

var $74cf5c252948c23d$var$_isISO3 = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("bFpZn")));

var $74cf5c252948c23d$var$_isRFC = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("ZtoyI")));

var $74cf5c252948c23d$var$_isISO31661Alpha = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("47ueG")));

var $74cf5c252948c23d$var$_isISO31661Alpha2 = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("dv52h")));

var $74cf5c252948c23d$var$_isISO4 = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("ip6Vk")));

var $74cf5c252948c23d$var$_isBase = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("frcxl")));

var $74cf5c252948c23d$var$_isBase2 = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("7sShw")));

var $74cf5c252948c23d$var$_isBase3 = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("FZlcs")));

var $74cf5c252948c23d$var$_isDataURI = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("6K2Bh")));

var $74cf5c252948c23d$var$_isMagnetURI = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("Z46oc")));

var $74cf5c252948c23d$var$_isMailtoURI = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("efaxe")));

var $74cf5c252948c23d$var$_isMimeType = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("a1QJl")));

var $74cf5c252948c23d$var$_isLatLong = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("aHsKa")));

var $74cf5c252948c23d$var$_isPostalCode = $74cf5c252948c23d$var$_interopRequireWildcard((parcelRequire("2q1xR")));

var $74cf5c252948c23d$var$_ltrim = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("8rtqA")));

var $74cf5c252948c23d$var$_rtrim = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("8rcRs")));

var $74cf5c252948c23d$var$_trim = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("1PIcn")));

var $74cf5c252948c23d$var$_escape = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("5EWEe")));

var $74cf5c252948c23d$var$_unescape = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("l3DBq")));

var $74cf5c252948c23d$var$_stripLow = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("gYqHl")));

var $74cf5c252948c23d$var$_whitelist = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("9lu9s")));

var $74cf5c252948c23d$var$_blacklist = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("5tIZs")));

var $74cf5c252948c23d$var$_isWhitelisted = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2VKoZ")));

var $74cf5c252948c23d$var$_normalizeEmail = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("hEc4p")));

var $74cf5c252948c23d$var$_isSlug = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("4SWTk")));

var $74cf5c252948c23d$var$_isLicensePlate = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("2hf3w")));

var $74cf5c252948c23d$var$_isStrongPassword = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("aMZVv")));

var $74cf5c252948c23d$var$_isVAT = $74cf5c252948c23d$var$_interopRequireDefault((parcelRequire("8i7BV")));
function $74cf5c252948c23d$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $74cf5c252948c23d$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $74cf5c252948c23d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $74cf5c252948c23d$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $74cf5c252948c23d$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $74cf5c252948c23d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $74cf5c252948c23d$var$version = "13.11.0";
var $74cf5c252948c23d$var$validator = {
    version: $74cf5c252948c23d$var$version,
    toDate: $74cf5c252948c23d$var$_toDate.default,
    toFloat: $74cf5c252948c23d$var$_toFloat.default,
    toInt: $74cf5c252948c23d$var$_toInt.default,
    toBoolean: $74cf5c252948c23d$var$_toBoolean.default,
    equals: $74cf5c252948c23d$var$_equals.default,
    contains: $74cf5c252948c23d$var$_contains.default,
    matches: $74cf5c252948c23d$var$_matches.default,
    isEmail: $74cf5c252948c23d$var$_isEmail.default,
    isURL: $74cf5c252948c23d$var$_isURL.default,
    isMACAddress: $74cf5c252948c23d$var$_isMACAddress.default,
    isIP: $74cf5c252948c23d$var$_isIP.default,
    isIPRange: $74cf5c252948c23d$var$_isIPRange.default,
    isFQDN: $74cf5c252948c23d$var$_isFQDN.default,
    isBoolean: $74cf5c252948c23d$var$_isBoolean.default,
    isIBAN: $74cf5c252948c23d$var$_isIBAN.default,
    isBIC: $74cf5c252948c23d$var$_isBIC.default,
    isAlpha: $74cf5c252948c23d$var$_isAlpha.default,
    isAlphaLocales: $74cf5c252948c23d$var$_isAlpha.locales,
    isAlphanumeric: $74cf5c252948c23d$var$_isAlphanumeric.default,
    isAlphanumericLocales: $74cf5c252948c23d$var$_isAlphanumeric.locales,
    isNumeric: $74cf5c252948c23d$var$_isNumeric.default,
    isPassportNumber: $74cf5c252948c23d$var$_isPassportNumber.default,
    isPort: $74cf5c252948c23d$var$_isPort.default,
    isLowercase: $74cf5c252948c23d$var$_isLowercase.default,
    isUppercase: $74cf5c252948c23d$var$_isUppercase.default,
    isAscii: $74cf5c252948c23d$var$_isAscii.default,
    isFullWidth: $74cf5c252948c23d$var$_isFullWidth.default,
    isHalfWidth: $74cf5c252948c23d$var$_isHalfWidth.default,
    isVariableWidth: $74cf5c252948c23d$var$_isVariableWidth.default,
    isMultibyte: $74cf5c252948c23d$var$_isMultibyte.default,
    isSemVer: $74cf5c252948c23d$var$_isSemVer.default,
    isSurrogatePair: $74cf5c252948c23d$var$_isSurrogatePair.default,
    isInt: $74cf5c252948c23d$var$_isInt.default,
    isIMEI: $74cf5c252948c23d$var$_isIMEI.default,
    isFloat: $74cf5c252948c23d$var$_isFloat.default,
    isFloatLocales: $74cf5c252948c23d$var$_isFloat.locales,
    isDecimal: $74cf5c252948c23d$var$_isDecimal.default,
    isHexadecimal: $74cf5c252948c23d$var$_isHexadecimal.default,
    isOctal: $74cf5c252948c23d$var$_isOctal.default,
    isDivisibleBy: $74cf5c252948c23d$var$_isDivisibleBy.default,
    isHexColor: $74cf5c252948c23d$var$_isHexColor.default,
    isRgbColor: $74cf5c252948c23d$var$_isRgbColor.default,
    isHSL: $74cf5c252948c23d$var$_isHSL.default,
    isISRC: $74cf5c252948c23d$var$_isISRC.default,
    isMD5: $74cf5c252948c23d$var$_isMD.default,
    isHash: $74cf5c252948c23d$var$_isHash.default,
    isJWT: $74cf5c252948c23d$var$_isJWT.default,
    isJSON: $74cf5c252948c23d$var$_isJSON.default,
    isEmpty: $74cf5c252948c23d$var$_isEmpty.default,
    isLength: $74cf5c252948c23d$var$_isLength.default,
    isLocale: $74cf5c252948c23d$var$_isLocale.default,
    isByteLength: $74cf5c252948c23d$var$_isByteLength.default,
    isUUID: $74cf5c252948c23d$var$_isUUID.default,
    isMongoId: $74cf5c252948c23d$var$_isMongoId.default,
    isAfter: $74cf5c252948c23d$var$_isAfter.default,
    isBefore: $74cf5c252948c23d$var$_isBefore.default,
    isIn: $74cf5c252948c23d$var$_isIn.default,
    isLuhnNumber: $74cf5c252948c23d$var$_isLuhnNumber.default,
    isCreditCard: $74cf5c252948c23d$var$_isCreditCard.default,
    isIdentityCard: $74cf5c252948c23d$var$_isIdentityCard.default,
    isEAN: $74cf5c252948c23d$var$_isEAN.default,
    isISIN: $74cf5c252948c23d$var$_isISIN.default,
    isISBN: $74cf5c252948c23d$var$_isISBN.default,
    isISSN: $74cf5c252948c23d$var$_isISSN.default,
    isMobilePhone: $74cf5c252948c23d$var$_isMobilePhone.default,
    isMobilePhoneLocales: $74cf5c252948c23d$var$_isMobilePhone.locales,
    isPostalCode: $74cf5c252948c23d$var$_isPostalCode.default,
    isPostalCodeLocales: $74cf5c252948c23d$var$_isPostalCode.locales,
    isEthereumAddress: $74cf5c252948c23d$var$_isEthereumAddress.default,
    isCurrency: $74cf5c252948c23d$var$_isCurrency.default,
    isBtcAddress: $74cf5c252948c23d$var$_isBtcAddress.default,
    isISO6346: $3030998065478fdd$exports.isISO6346,
    isFreightContainerID: $3030998065478fdd$exports.isFreightContainerID,
    isISO6391: $74cf5c252948c23d$var$_isISO2.default,
    isISO8601: $74cf5c252948c23d$var$_isISO3.default,
    isRFC3339: $74cf5c252948c23d$var$_isRFC.default,
    isISO31661Alpha2: $74cf5c252948c23d$var$_isISO31661Alpha.default,
    isISO31661Alpha3: $74cf5c252948c23d$var$_isISO31661Alpha2.default,
    isISO4217: $74cf5c252948c23d$var$_isISO4.default,
    isBase32: $74cf5c252948c23d$var$_isBase.default,
    isBase58: $74cf5c252948c23d$var$_isBase2.default,
    isBase64: $74cf5c252948c23d$var$_isBase3.default,
    isDataURI: $74cf5c252948c23d$var$_isDataURI.default,
    isMagnetURI: $74cf5c252948c23d$var$_isMagnetURI.default,
    isMailtoURI: $74cf5c252948c23d$var$_isMailtoURI.default,
    isMimeType: $74cf5c252948c23d$var$_isMimeType.default,
    isLatLong: $74cf5c252948c23d$var$_isLatLong.default,
    ltrim: $74cf5c252948c23d$var$_ltrim.default,
    rtrim: $74cf5c252948c23d$var$_rtrim.default,
    trim: $74cf5c252948c23d$var$_trim.default,
    escape: $74cf5c252948c23d$var$_escape.default,
    unescape: $74cf5c252948c23d$var$_unescape.default,
    stripLow: $74cf5c252948c23d$var$_stripLow.default,
    whitelist: $74cf5c252948c23d$var$_whitelist.default,
    blacklist: $74cf5c252948c23d$var$_blacklist.default,
    isWhitelisted: $74cf5c252948c23d$var$_isWhitelisted.default,
    normalizeEmail: $74cf5c252948c23d$var$_normalizeEmail.default,
    toString: toString,
    isSlug: $74cf5c252948c23d$var$_isSlug.default,
    isStrongPassword: $74cf5c252948c23d$var$_isStrongPassword.default,
    isTaxID: $74cf5c252948c23d$var$_isTaxID.default,
    isDate: $74cf5c252948c23d$var$_isDate.default,
    isTime: $74cf5c252948c23d$var$_isTime.default,
    isLicensePlate: $74cf5c252948c23d$var$_isLicensePlate.default,
    isVAT: $74cf5c252948c23d$var$_isVAT.default,
    ibanLocales: $74cf5c252948c23d$var$_isIBAN.locales
};
var $74cf5c252948c23d$var$_default = $74cf5c252948c23d$var$validator;
$74cf5c252948c23d$exports.default = $74cf5c252948c23d$var$_default;
$74cf5c252948c23d$exports = $74cf5c252948c23d$exports.default;
$74cf5c252948c23d$exports.default = $74cf5c252948c23d$exports.default;





function $812b8eba084452ad$export$8fa3dfbad242c6c9(props) {
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { register: register, handleSubmit: handleSubmit, control: control, formState: { errors: errors } } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            patient_id: props.patientId
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [studyId, setStudyId] = (0, $f2Y41.useState)();
    const { data: practiceStudies, isLoading: practiceStudiesLoading, isError: practiceStudiesError, mutate: practiceStudiesMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const { data: practiceStudyVisits, isLoading: practiceStudyVisitsLoading, isError: practiceStudyVisitsError, mutate: practiceStudyVisitsMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_study_visits", `study_id=${studyId}`);
    const closeModal = ()=>{
        props.setOpen(false);
    };
    const studyVisits = (studyId)=>{
        setStudyId(studyId);
        practiceStudyVisitsMutate();
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const validateURL = (inputURL)=>{
        const urlPattern = /^https:\/\/app\.clinicalresearch\.io\/topography-health\/\w+\/study\/\d+\/subject\/\d+\/visit\/\d+$/;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($74cf5c252948c23d$exports))).isURL(inputURL) && urlPattern.test(inputURL)) return true;
        return "URL does not appear to be a valid visit url.";
    };
    const onSubmit = (data)=>{
        data.start_dt = new Date(data.start_dt).toISOString().slice(0, -1);
        data.practice_id = practiceId;
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("on_demand_visits", data, getAccessTokenSilently).then((response)=>{
            props?.refreshData();
            closeModal();
        }, (error)=>{});
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-appointment-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Add Today's Visit"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Close modal"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                        children: "This form is intended for visits occurring today, that did not get scheduled in CRIO and automatically created, prior to the visit. Visits are automatically generated based on the currently scheduled visits in CRIO. If the visit you wish to add does not occur today, please allow the scheduled automation to create the visit."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "grid grid-cols-6 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "study",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Study"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                        ...register("study"),
                                                        onChange: (e)=>studyVisits(e.target.value),
                                                        name: "study",
                                                        id: "study",
                                                        className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        // placeholder="NN"
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                            practiceStudies.map((practiceStudy)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: practiceStudy?.study?.id,
                                                                    children: practiceStudy?.study?.abbreviation
                                                                }, practiceStudy.id))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "practice_study_visit_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Study Visit"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                        ...register("practice_study_visit_id"),
                                                        name: "practice_study_visit_id",
                                                        id: "practice_study_visit_id",
                                                        className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        // placeholder="NN"
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                            practiceStudyVisits.map((practiceStudyVisit)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: practiceStudyVisit?.id,
                                                                    children: practiceStudyVisit?.study_visit?.visit_name
                                                                }, practiceStudyVisit.id))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "subject_study_visit_url",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                            content: `The url for the patient's visit, e.g. https://app.clinicalresearch.io/topography-health/practice/study/11111111/subject/22222222/visit/33333333`,
                                                            children: "Subject Study Visit URL"
                                                        })
                                                    }),
                                                    errors?.subject_study_visit_url?.message ?? /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                        children: errors?.subject_study_visit_url?.messagee
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        ...register("subject_study_visit_url", {
                                                            validate: validateURL
                                                        }),
                                                        type: "text",
                                                        name: "subject_study_visit_url",
                                                        id: "subject_study_visit_url",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        placeholder: "https://app.clinicalresearch.io/topography-health/practice/study/11111111/subject/22222222/visit/33333333`",
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "xref_patient_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Patient CRIO ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        ...register("xref_patient_id"),
                                                        type: "text",
                                                        name: "xref_patient_id",
                                                        id: "xref_patient_id",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        // placeholder="example@company.com"
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "start_dt",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Visit Start Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "start_dt",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "datetime-local",
                                                                sx: {
                                                                    width: 250,
                                                                    boxShadow: "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    ...register("patient_id"),
                                                    type: "hidden",
                                                    name: "patient_id",
                                                    id: "patient_id",
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    // placeholder="example@company.com"
                                                    required: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "items-center p-4 border-t border-gray-200 dark:border-gray-700 rounded-b",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Save"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");





var $f2Y41 = parcelRequire("f2Y41");




var $ge3KO = parcelRequire("ge3KO");
const $bdb50d3607022c6a$export$b70b5f2775d2561f = ()=>{
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "08:00",
                children: "8:00 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "08:15",
                children: "8:15 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "08:30",
                children: "8:30 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "08:45",
                children: "8:45 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "09:00",
                children: "9:00 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "09:15",
                children: "9:15 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "09:30",
                children: "9:30 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "09:45",
                children: "9:45 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "10:00",
                children: "10:00 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "10:15",
                children: "10:15 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "10:30",
                children: "10:30 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "10:45",
                children: "10:45 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "11:00",
                children: "11:00 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "11:15",
                children: "11:15 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "11:30",
                children: "11:30 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "11:45",
                children: "11:45 AM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "12:00",
                children: "12:00 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "12:15",
                children: "12:15 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "12:30",
                children: "12:30 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "12:45",
                children: "12:45 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "13:00",
                children: "1:00 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "13:15",
                children: "1:15 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "13:30",
                children: "1:30 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "13:45",
                children: "1:45 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "14:00",
                children: "2:00 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "14:15",
                children: "2:15 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "14:30",
                children: "2:30 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "14:45",
                children: "2:45 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "15:00",
                children: "3:00 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "15:15",
                children: "3:15 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "15:30",
                children: "3:30 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "15:45",
                children: "3:45 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "16:00",
                children: "4:00 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "16:15",
                children: "4:15 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "16:30",
                children: "4:30 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "16:45",
                children: "4:45 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "17:00",
                children: "5:00 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "17:15",
                children: "5:15 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "17:30",
                children: "5:30 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "17:45",
                children: "5:45 PM"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: "18:00",
                children: "6:00 PM"
            })
        ]
    });
};


const $1e3849d05733fd6b$export$82d3affa71d4e432 = {
    "America/New_York": "Eastern Time",
    "America/Chicago": "Central Time",
    "America/Denver": "Mountain Time",
    "America/Phoenix": "Arizona Time",
    "America/Los_Angeles": "Pacific Time"
};





function $2915233bc1bb6eea$export$a2b8ada25fefeb60(props) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: practice } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("practices", practiceId);
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control, setValue: setValue, getValues: getValues } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            patient_id: props.patientId,
            screen_id: props.screenId,
            end_time: "09:00",
            start_timezone: "America/New_York"
        }
    });
    const { data: users } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("users");
    const { data: screen, isLoading: isLoadingScreen, mutate: mutateScreen } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("screens", props.screenId);
    const [responseMessage, setResponseMessage] = (0, $f2Y41.useState)("");
    const [responseDetail, setResponseDetail] = (0, $f2Y41.useState)("");
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const closeModal = ()=>{
        props.setOpen(false);
    };
    (0, $f2Y41.useEffect)(()=>{
        if (!practice?.timezone) return;
        setValue("start_timezone", practice?.timezone);
    }, [
        setValue,
        practice
    ]);
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = async (data)=>{
        // VALIDATION RULES:
        // Must have DOB
        // Must have Phone Number or Email
        // Appointment times must end in: [:00 :15 :30 :45]
        if (!data.start_date) {
            setResponseMessage("Must set Appointment Date");
            return;
        }
        // if (!data.start_timezone) return
        if (!data.end_time) return;
        const utcStartDt = (0, $d054c02382423b6c$export$2e2bcd8739ae039)(`${data.start_date}T${data.start_time}`, data.start_timezone)?.toISOString().slice(0, -1);
        const utcEndDt = (0, $d054c02382423b6c$export$2e2bcd8739ae039)(`${data.start_date}T${data.end_time}`, data.start_timezone)?.toISOString().slice(0, -1);
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", props.screenId, {
            assigned_to_user_id: data.assigned_to_user_id
        }, getAccessTokenSilently);
        const patient_appointment_data = {
            type: "Screen",
            patient_id: data.patient_id,
            start_dt: utcStartDt,
            end_dt: utcEndDt
        };
        const patient_appointment_response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patient_appointments", patient_appointment_data, getAccessTokenSilently);
        const patient_appointment = patient_appointment_response?.data?.data;
        if (!patient_appointment) {
            setResponseMessage("Error Creating Appointment");
            return;
        }
        const crioXRefData = {
            patient_id: props.patientId,
            screen_id: props.screenId,
            patient_appointment_id: patient_appointment?.id
        };
        console.dir(crioXRefData);
        const createXrefResponse = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("crio_xrefs", crioXRefData, getAccessTokenSilently);
        console.dir("createXrefResponse");
        console.dir(createXrefResponse);
        const updateScreenResponse = await (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", props.screenId, {
            status: "moved_to_esource"
        }, getAccessTokenSilently);
        console.dir("updateScreenResponse");
        console.dir(updateScreenResponse);
        if (createXrefResponse.data.message === "success") {
            queryClient.invalidateQueries({
                queryKey: [
                    "screens",
                    props.screenId
                ]
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($3d12054b9ed86c19$exports))).success("Sent to eSource");
            closeModal();
        } else {
            setResponseMessage(createXrefResponse.data.message);
            setResponseDetail(createXrefResponse.data?.data);
            (0, (/*@__PURE__*/$parcel$interopDefault($3d12054b9ed86c19$exports))).error("There was an error sending to eSource");
        }
    };
    function setEndTimeToStartPlus(minutes) {
        // if start date is null return nothing
        // if start time is null return 0800
        // if start time isn't null get the value, parse it as a time, add it on
        const today = new Date().toISOString().split("T")[0];
        if (!getValues("start_date")) setValue("start_date", today);
        const startDate = getValues("start_date");
        console.dir(startDate);
        // if (!getValues('start_time')) return dateTimeISOWithoutTimezone(startDt.setHours(8))
        const startTime = getValues("start_time");
        const startDt = new Date(`${startDate}T${startTime}`);
        const startTimezone = getValues("start_timezone");
        // setValue('start_dt', zonedTimeToUtc(startDt, startTimezone))
        const endTime = startDt.setTime(startDt.getTime() + minutes * 60000);
        const endTimeString = `${new Date(endTime).getHours().toString().padStart(2, "0")}:${new Date(endTime).getMinutes().toString().padEnd(2, "0")}`;
        console.dir(endTimeString);
        setValue("end_time", endTimeString);
    // return dateTimeISOWithoutTimezone(endDt)
    }
    (0, $f2Y41.useEffect)(()=>{
        if (!screen) return;
        reset({
            assigned_to_user_id: screen?.assigned_to_user_id
        });
    }, [
        screen,
        reset
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-appointment-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Add To eSource"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "X Button"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "grid grid-cols-6 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-12 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "font-medium",
                                                        children: "Notes"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("ul", {
                                                        className: "list-disc pl-3.5",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                                className: "",
                                                                children: "Patient must have DOB"
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                                children: "Patient must have either: Phone Number or Email"
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                                className: "",
                                                                children: "Assigned User must have the same email in Waypoints and CRIO"
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                                children: "Appointment must be in the future"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-12",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "start_dt",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Assigned"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                        ...register("assigned_to_user_id"),
                                                        className: "rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                value: "",
                                                                children: "None"
                                                            }),
                                                            users.filter((user)=>(0, $601cdae3149c9149$export$d540efe9354f0ccc)(user)).map((user, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    value: user.id,
                                                                    className: "",
                                                                    children: user.name
                                                                }, user.id))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-12 sm:col-span-12",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "start_date",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Appointment Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "start_date",
                                                        control: control,
                                                        defaultValue: "",
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "date",
                                                                sx: {
                                                                    width: 250,
                                                                    boxShadow: "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-12 sm:col-span-12",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "start_dt",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Appointment Start Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("select", {
                                                                className: "rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600",
                                                                ...register("start_time"),
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $bdb50d3607022c6a$export$b70b5f2775d2561f), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                className: "flex ml-2 rounded-md border-gray-300 text-sm",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        type: "hidden",
                                                                        ...register("start_timezone")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                        className: "flex ml-2 rounded-md border-gray-300",
                                                                        children: (0, $1e3849d05733fd6b$export$82d3affa71d4e432)?.[practice.timezone]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-12",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "appointment_length",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Appointment Length"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        type: "button",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            setEndTimeToStartPlus(15);
                                                        },
                                                        className: "mr-2 dark:text-white hover:text-white bg-transparent border border-gray-300 dark:border-gray-600 hover:border-gray-500 hover:dark:border-gray-300 hover:bg-topo-blue-700 focus:ring-4 focus:ring-topo-blue-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center",
                                                        children: "15 min"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        type: "button",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            setEndTimeToStartPlus(30);
                                                        },
                                                        className: "mr-2 dark:text-white hover:text-white bg-transparent border border-gray-300 dark:border-gray-600 hover:border-gray-500 hover:dark:border-gray-300 hover:bg-topo-blue-700 focus:ring-4 focus:ring-topo-blue-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center",
                                                        children: "30 min"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        type: "button",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            setEndTimeToStartPlus(60);
                                                        },
                                                        className: "mr-2 dark:text-white hover:text-white bg-transparent border border-gray-300 dark:border-gray-600 hover:border-gray-500 hover:dark:border-gray-300 hover:bg-topo-blue-700 focus:ring-4 focus:ring-topo-blue-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center",
                                                        children: "60 min"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                        type: "button",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            setValue("end_time", null);
                                                        },
                                                        className: "mr-2 dark:text-white hover:text-white bg-transparent border border-gray-300 dark:border-gray-600 hover:border-gray-500 hover:dark:border-gray-300 hover:bg-topo-blue-700 focus:ring-4 focus:ring-topo-blue-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center",
                                                        children: "Custom"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "end_time",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Appointment End Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "flex items-center text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("select", {
                                                                className: "rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600",
                                                                ...register("end_time"),
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $bdb50d3607022c6a$export$b70b5f2775d2561f), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "flex ml-2 rounded-md border-gray-300",
                                                                children: (0, $1e3849d05733fd6b$export$82d3affa71d4e432)?.[practice.timezone]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    ...register("patient_id"),
                                                    type: "hidden",
                                                    name: "patient_id",
                                                    id: "patient_id",
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    // placeholder="example@company.com"
                                                    required: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-4",
                                    children: responseDetail
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "items-center p-4 border-t border-gray-200 dark:border-gray-700 rounded-b",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Save"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
function $e6e1101ce7a3066a$export$430b88e3a7edeac4(props) {
    const changePractice = async ()=>{
        await props.changePractice();
        props.setOpen(false);
    };
    const setDefaultFilterAndSort = async ()=>{
        props.setDefaultFilterAndSort();
        props.setOpen(false);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full bg-gray-800",
            id: "bookmark-modal",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "relative w-full h-full max-w-2xl px-4 md:h-auto bg-gray-800",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                className: "text-xl font-semibold dark:text-white",
                                children: "The provided url contains a bookmark filter that is invalid at this practice."
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "p-6 space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                        children: "You can either load the default bookmark filter for this practice, or switch to the practice that supports the bookmark filter."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "grid grid-cols-6 gap-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-6 sm:col-span-6 ",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                onClick: ()=>changePractice(),
                                                onKeyUp: ()=>changePractice(),
                                                type: "button",
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                children: "Change Practice and Load the Provided Bookmark Filter"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "col-span-6 sm:col-span-6",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                onClick: ()=>setDefaultFilterAndSort(),
                                                onKeyUp: ()=>setDefaultFilterAndSort(),
                                                type: "button",
                                                className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                                children: "Load the Default Bookmark Filters at the Current Practice"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}


// TODO: Edit Visit

var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");




function $575aead048882a21$export$1d454a9dbd0e6775(props) {
    const { data: visit, isLoading: visitIsLoading, isError: visitIsError, mutate: mutateVisit } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("visits", props.visitId);
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { register: register, handleSubmit: handleSubmit, control: control, formState: { errors: errors } } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            visit_id: props.visitId,
            start_dt: visit?.start_dt ?? ""
        }
    });
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const closeModal = ()=>{
        props?.refreshData();
        props.setOpen(false);
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    const onSubmit = (data)=>{
        data.start_dt = new Date(data.start_dt).toISOString().slice(0, -1);
        data.practice_id = practiceId;
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("on_demand_visits", data.visit_id, {
            start_dt: data.start_dt
        }, getAccessTokenSilently).then((response)=>{
            closeModal();
        }, (error)=>{});
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-10 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-appointment-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                            className: "text-xl font-semibold dark:text-white",
                                            children: "Reschedule Today's Visit"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                            onClick: ()=>closeModal(),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                className: "w-5 h-5",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                        children: "Close modal"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                        children: "This form is intended for visits occurring today, that did not get rescheduled in CRIO and automatically updated, prior to the visit. Visits are automatically generated and rescheduled based on the currently scheduled visits in CRIO. If the visit you wish to reschedule does not occur today, please allow the scheduled automation to update the visit."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "grid grid-cols-6 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "study",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Study"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        type: "text",
                                                        name: "study",
                                                        id: "study",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        value: visit?.study?.abbreviation ?? "",
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "practice_study_visit_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Study Visit"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        type: "text",
                                                        name: "practice_study_visit_id",
                                                        id: "practice_study_visit_id",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        value: visit?.practice_study_visit?.study_visit?.visit_name ?? "",
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "subject_study_visit_url",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                                            content: `The url for the patient's visit, e.g. https://app.clinicalresearch.io/topography-health/practice/study/11111111/subject/22222222/visit/33333333`,
                                                            children: "Subject Study Visit URL"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        type: "text",
                                                        name: "subject_study_visit_url",
                                                        id: "subject_study_visit_url",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        placeholder: "https://app.clinicalresearch.io/topography-health/practice/study/11111111/subject/22222222/visit/33333333`",
                                                        value: visit?.xref_subject_study_url ?? "",
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "xref_patient_id",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Patient CRIO ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                        type: "text",
                                                        name: "xref_patient_id",
                                                        id: "xref_patient_id",
                                                        className: "shadow-sm bg-gray-50 border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-2 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        value: visit?.xref_patient_id ?? "",
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                        htmlFor: "start_dt",
                                                        className: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                                                        children: "Visit Start Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                        name: "start_dt",
                                                        control: control,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                ...field,
                                                                type: "datetime-local",
                                                                sx: {
                                                                    width: 250,
                                                                    boxShadow: "none"
                                                                },
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                }
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "col-span-6 sm:col-span-6",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    ...register("visit_id"),
                                                    type: "hidden",
                                                    name: "visit_id",
                                                    id: "visit_id",
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    // placeholder="example@company.com"
                                                    required: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "items-center p-4 border-t border-gray-200 dark:border-gray-700 rounded-b",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Save"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


var $4d7392d447faa322$export$23344047f1eff04b;
(function(ModalType) {
    ModalType[ModalType["BulkAssign"] = 0] = "BulkAssign";
    ModalType[ModalType["Appointment"] = 1] = "Appointment";
    ModalType[ModalType["Medication"] = 2] = "Medication";
    ModalType[ModalType["Condition"] = 3] = "Condition";
    ModalType[ModalType["ContactDisposition"] = 4] = "ContactDisposition";
    ModalType[ModalType["Ineligible"] = 5] = "Ineligible";
    ModalType[ModalType["Bookmark"] = 6] = "Bookmark";
})($4d7392d447faa322$export$23344047f1eff04b || ($4d7392d447faa322$export$23344047f1eff04b = {}));
function $4d7392d447faa322$export$73b18234e5d8ffa0() {
    return (0, $c5383ff45095a6a6$export$4138103a3ae699cc)();
}
function $4d7392d447faa322$export$8dc8045e940cbc5d() {
    let { patientId: patientId, screenId: screenId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { data: patient, isLoading: isLoading, isError: isError, mutate: mutatePatient } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("patients", patientId, {
        getAccessTokenSilently: getAccessTokenSilently
    });
    const { data: screens, mutate: mutateScreens } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("screens", `patient_id=${patientId}`);
    const nowISO = (0, $f2Y41.useMemo)(()=>new Date().toISOString().slice(0, -1), []);
    const { data: patientAppointments, mutate: mutatePatientAppointments } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patient_appointments", `patient_id=${patientId}&after_dt=${nowISO}`);
    const { data: contacts, isLoading: isLoadingContacts, isError: isErrorContacts, mutate: mutateContacts } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("contacts", `patient_id=${patientId}`);
    const { register: registerContactPref, handleSubmit: handleSubmitContactPref, watch: watchContactPref, reset: resetContactPref } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { register: registerDutyToWarnSent, handleSubmit: handleSubmitDutyToWarnSent, watch: watchDutyToWarnSent, reset: resetDutyToWarnSent } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { register: registerDutyToWarnAcknowledged, handleSubmit: handleSubmitDutyToWarnAcknowledged, watch: watchDutyToWarnAcknowledged, reset: resetDutyToWarnAcknowledged } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const [modalOpen, setModalOpen] = (0, $f2Y41.useState)();
    const [newAppointmentModalOpen, setNewAppointmentModalOpen] = (0, $f2Y41.useState)(false);
    const [scheduleInESourceModalOpen, setScheduleInESourceModalOpen] = (0, $f2Y41.useState)(false);
    const [newMedicationModalOpen, setNewMedicationModalOpen] = (0, $f2Y41.useState)(false);
    const [newConditionModalOpen, setNewConditionModalOpen] = (0, $f2Y41.useState)(false);
    const [newVisitModalOpen, setNewVisitModalOpen] = (0, $f2Y41.useState)(false);
    const [editVisitModalOpen, setEditVisitModalOpen] = (0, $f2Y41.useState)(false);
    const [prompted, setPrompted] = (0, $f2Y41.useState)(false);
    const [isIdleState, setIsIdleState] = (0, $f2Y41.useState)(false);
    const [contactModalOpen, setContactModalOpen] = (0, $f2Y41.useState)(false);
    const [contactModalEditingId, setContactModalEditingId] = (0, $f2Y41.useState)("");
    const [ineligibleModalOpen, setIneligibleModalOpen] = (0, $f2Y41.useState)(false);
    const [contactDispositionOpen, setContactDispositionOpen] = (0, $f2Y41.useState)(false);
    const [currentStudyScreenName, setCurrentStudyScreenName] = (0, $f2Y41.useState)("");
    const [currentStudyScreenId, setCurrentStudyScreenId] = (0, $f2Y41.useState)("");
    const [bookmarkModalOpen, setBookmarkModalOpen] = (0, $f2Y41.useState)(false);
    const [currentVisitId, setCurrentVisitId] = (0, $f2Y41.useState)("");
    let tabs = [
        {
            name: "Studies",
            href: `/patients/${patientId}/screens`,
            current: false,
            icon: "ClipboardIcon"
        },
        {
            name: "Timeline",
            href: `/patients/${patientId}/timeline`,
            current: false,
            icon: "DocumentTextIcon"
        },
        {
            name: "Patient Info",
            href: `/patients/${patientId}/info`,
            current: false,
            icon: "PencilIcon"
        },
        {
            name: "Appointments",
            href: `/patients/${patientId}/appointments`,
            current: false,
            icon: "CalendarIcon"
        },
        {
            name: "Visits",
            href: `/patients/${patientId}/visits`,
            current: false,
            icon: "OfficeBuildingIcon"
        }
    ];
    const [infoExpanded, setInfoExpanded] = (0, $f2Y41.useState)(true);
    // Dynamically set tab current value
    tabs.map((tab)=>{
        let resolved = (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(tab.href);
        let match = (0, $c5383ff45095a6a6$export$6c330e8992e8a295)({
            path: resolved.pathname,
            end: false
        });
        tab.current = match && true;
    });
    // no match found, assume first tab
    if (tabs.filter((tab)=>tab.current === true).length === 0) tabs[0].current = true;
    const tabLabelIcon = (tab)=>{
        return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
            icon: tab.icon,
            className: "w-6 h-6 mr-2"
        });
    };
    (0, $f2Y41.useEffect)(()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientView",
            meta: {
                patient_id: patientId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
    }, [
        patientId
    ]);
    const clickEvent = (name)=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "Click",
            meta: {
                element: `${name.replace(/\s/g, "")}`
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
    };
    const handlePatientInfoExpand = ()=>{
        infoExpanded ? clickEvent("PatientInfoCollapse") : clickEvent("PatientInfoExpand");
        setInfoExpanded(!infoExpanded);
    };
    let resolvedScreenPath = (0, $c5383ff45095a6a6$export$e75d2a2d1b3c245b)(`/patients/${patientId}/screens/${screenId}`);
    let matchScreenPath = (0, $c5383ff45095a6a6$export$6c330e8992e8a295)({
        path: resolvedScreenPath.pathname,
        end: false
    });
    const onPrompt = ()=>{
        // Pause the idle checker
        // only if screening
        if (!matchScreenPath) return;
        setPrompted(true);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "ScreenIdlePrompt",
            meta: {
                patient_id: patientId,
                screen_id: screenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
    };
    const onIdle = ()=>{
        // Pause the idle checker
        // only if screening
        if (!matchScreenPath) return;
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "ScreenIdleTimeout",
            meta: {
                patient_id: patientId,
                screen_id: screenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "ScreenStop",
            meta: {
                patient_id: patientId,
                screen_id: screenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        setIsIdleState(true);
    };
    const resumeAfterIdlePrompt = async ()=>{
        // Fired on Close Modal click
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "ScreenIdleResume",
            meta: {
                patient_id: patientId,
                screen_id: screenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        // only resume screen timer
        if (isIdleState) {
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "ScreenStart",
                meta: {
                    patient_id: patientId,
                    screen_id: screenId
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
            setIsIdleState(false);
        }
        reset();
        setPrompted(false);
    };
    const timeout = 590000 // 50 seconds to prompt, use env if present
    ;
    const { isIdle: isIdle, reset: reset } = (0, $4c64d1542739e3dd$export$3e1c2ef16041091f)({
        timeout: timeout,
        onIdle: onIdle,
        onPrompt: onPrompt,
        promptTimeout: 10000 // 10 seconds after prompt to timeout (and end screen)
    });
    const submitDutyToWarnSent = (data)=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("patients", patientId, data, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientDutyToWarnSent",
            meta: {
                patient_id: patientId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        mutatePatient();
    };
    const submitDutyToWarnAcknowledged = async (data)=>{
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("patients", patientId, data, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientDutyToWarnAcknowledged",
            meta: {
                patient_id: patientId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        mutatePatient();
    };
    const submitContactPref = async (data)=>{
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("patients", patientId, data, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientContactPrefUpdated",
            meta: {
                patient_id: patientId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        mutatePatient();
        // set all screens to DQ
        if (data.can_contact == false) {
            screens.forEach(async (screen)=>{
                await (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", screen.id, {
                    status: "disqualified"
                }, getAccessTokenSilently);
                await (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                    eventName: `ScreenUpdateStatus`,
                    meta: {
                        patient_id: patientId,
                        screen_id: screen.id,
                        assigned_to_user_id: screen.assigned_to_user_id
                    },
                    getAccessTokenSilently: getAccessTokenSilently
                });
            });
            mutateScreens();
        }
    };
    const mutatePatientMedications = ()=>{
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)([
            `${(0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("patient_medications")}?patient_id=${patientId}`,
            getAccessTokenSilently
        ]);
    };
    const mutatePatientConditions = ()=>{
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)([
            `${(0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("patient_conditions")}?patient_id=${patientId}`,
            getAccessTokenSilently
        ]);
    };
    const mutatePatientVisits = ()=>{
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)([
            `${(0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("visits")}?patient_id=${patientId}`,
            getAccessTokenSilently
        ]);
    };
    (0, $f2Y41.useEffect)(()=>{
        // Guard if API data isn't back yet
        if (patient?.can_contact === undefined) return;
        // Set up initial form data
        resetContactPref({
            can_contact: patient?.can_contact
        });
        // Subscribe to changes on the form
        // TODO: Fix these types to get rid of the red squigglies
        const subscription = watchContactPref(handleSubmitContactPref(submitContactPref));
        // Leave no trace
        return ()=>subscription.unsubscribe();
    }, [
        patient.can_contact
    ]);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    (0, $f2Y41.useEffect)(()=>{
        if (isLoading) return;
        if (!patient) navigate("/patients");
        // patient not authorized
        // navigate to /patients
        return ()=>{};
    }, [
        isLoading
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: "Loading..."
    });
    if (isError) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: "Error. Please contact your support team."
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex-1 relative z-0 flex overflow-hidden h-full dark:text-gray-200 ",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("main", {
                    className: "flex-1 relative z-0 overflow-y-overlay focus:outline-none xl:order-last",
                    children: [
                        infoExpanded ? /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "hover:cursor-pointer pt-2",
                            onClick: ()=>handlePatientInfoExpand(),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "ChevronLeftIcon",
                                className: "w-6 h-6 text-gray-900"
                            })
                        }) : /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "hover:cursor-pointer pt-2",
                            onClick: ()=>handlePatientInfoExpand(),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "InformationCircleIcon"
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: " lg:block lg:flex-shrink-0 lg:order-first",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("nav", {
                                    className: "hidden pb-4",
                                    "aria-label": "Breadcrumb",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("ol", {
                                        className: "inline-flex items-center space-x-1 md:space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                className: "inline-flex items-center",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                    to: "/dashboard",
                                                    onClick: ()=>clickEvent("BreadcrumbsDashboard"),
                                                    className: "inline-flex items-center text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                        className: "w-5 h-5 mr-1",
                                                        fill: "currentColor",
                                                        viewBox: "0 0 20 20",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                            d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                            className: "w-6 h-6 text-gray-400",
                                                            fill: "currentColor",
                                                            viewBox: "0 0 20 20",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                            to: "/patients",
                                                            onClick: ()=>clickEvent("BreadcrumbsPatients"),
                                                            className: "ml-1 text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-300 dark:hover:text-white",
                                                            children: "Patients!"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                            className: "w-6 h-6 text-gray-400",
                                                            fill: "currentColor",
                                                            viewBox: "0 0 20 20",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                            to: `/patients/${patientId}`,
                                                            onClick: ()=>clickEvent("BreadcrumbsPatientInfo"),
                                                            className: "ml-1 text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-300 dark:hover:text-white",
                                                            children: [
                                                                patient.given_name,
                                                                " ",
                                                                patient.family_name
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "md:flex lg:flex lg:space-x-4 md:space-x-3",
                                    children: [
                                        infoExpanded && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex flex-col sm:w-full md:w-1/4 lg:w-1/4",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e743f4d352a48aa5$export$7875634418234b03), {
                                                    mutatePatient: mutatePatient,
                                                    patient: patient,
                                                    screens: screens,
                                                    submitContactPref: submitContactPref,
                                                    submitDutyToWarnSent: submitDutyToWarnSent,
                                                    submitDutyToWarnAcknowledged: submitDutyToWarnAcknowledged,
                                                    registerContactPref: registerContactPref,
                                                    handlePatientInfoExpand: handlePatientInfoExpand,
                                                    infoExpanded: infoExpanded
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $de5fe1ecb44024a1$export$6f58f7f764215e5a), {
                                                    patient: patient,
                                                    mutatePatient: mutatePatient,
                                                    mutatePatientAppointments: mutatePatientAppointments,
                                                    setNewAppointmentModalOpen: setNewAppointmentModalOpen,
                                                    setContactModalOpen: setContactModalOpen,
                                                    setContactDispositionOpen: setContactDispositionOpen,
                                                    contactDispositionOpen: contactDispositionOpen,
                                                    contactModalEditingId: contactModalEditingId,
                                                    setContactModalEditingId: setContactModalEditingId,
                                                    mutateContacts: mutateContacts,
                                                    patientAppointments: patientAppointments,
                                                    contacts: contacts
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex flex-col flex-1 pr-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "sm:hidden bg-white dark:bg-transparent",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                            htmlFor: "tabs",
                                                            className: "sr-only",
                                                            children: "Select a tab"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("select", {
                                                            id: "tabs",
                                                            name: "tabs",
                                                            className: "block w-full focus:ring-indigo-800 focus:border-indigo-500 border-gray-300 rounded-md",
                                                            defaultValue: tabs.find((tab)=>tab.current)?.name,
                                                            children: tabs.map((tab, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                    children: tab.name
                                                                }, index))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "hidden sm:block",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("nav", {
                                                        className: "relative z-0 flex space-x-[14px] bg-transparent dark:bg-transparent",
                                                        "aria-label": "Tabs",
                                                        children: tabs.map((tab, tabIdx)=>/*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                                to: tab.name.includes("Studies") && currentStudyScreenId ? `/patients/${patientId}/screens/${currentStudyScreenId}` : tab.href,
                                                                onClick: ()=>clickEvent("PatientTab" + tab.name),
                                                                className: (0, $ab3059e3726110c9$export$ce4ab0c55987d1ff)(tab.current ? "bg-white text-gray-900 dark:text-gray-100 dark:bg-transparent" : "bg-transparent text-gray-500 hover:text-gray-700 dark:bg-gray-900 dark:bg-opacity-30 dark:border-gray-700", tabIdx === 0 ? "" : "", tabIdx > 1 ? "" : "", tabIdx === tabs.length - 1 ? "" : "", "border-l border-t border-r rounded-t-lg group relative min-w-0 flex-1 overflow-hidden py-[20px] text-md font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 dark:hover:text-gray-300 focus:z-10"),
                                                                "aria-current": tab.current ? "page" : undefined,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                        children: currentStudyScreenName && tab.name == "Studies" ? /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                                            className: "justify-center flex",
                                                                            children: [
                                                                                tabLabelIcon(tab),
                                                                                currentStudyScreenName
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                                            className: "justify-center flex flex-nowrap",
                                                                            children: [
                                                                                tabLabelIcon(tab),
                                                                                tab.name === "Studies" ? screens.length : "",
                                                                                " ",
                                                                                tab.name
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                        "aria-hidden": "true",
                                                                        className: "absolute inset-x-0 bottom-0 h-0.5"
                                                                    })
                                                                ]
                                                            }, tabIdx))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4c64d1542739e3dd$export$17ce2adb9f89ccf5), {
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $c5383ff45095a6a6$export$910ae8079b2c2852), {
                                                        context: {
                                                            patient: patient,
                                                            mutatePatient: mutatePatient,
                                                            setModalOpen: setModalOpen,
                                                            setNewAppointmentModalOpen: setNewAppointmentModalOpen,
                                                            setNewMedicationModalOpen: setNewMedicationModalOpen,
                                                            setNewConditionModalOpen: setNewConditionModalOpen,
                                                            setNewVisitModalOpen: setNewVisitModalOpen,
                                                            setEditVisitModalOpen: setEditVisitModalOpen,
                                                            setIneligibleModalOpen: setIneligibleModalOpen,
                                                            ineligibleModalOpen: ineligibleModalOpen,
                                                            setCurrentStudyScreenName: setCurrentStudyScreenName,
                                                            setCurrentStudyScreenId: setCurrentStudyScreenId,
                                                            currentStudyScreenId: currentStudyScreenId,
                                                            contactDispositionOpen: contactDispositionOpen,
                                                            setContactDispositionOpen: setContactDispositionOpen,
                                                            setContactModalOpen: setContactModalOpen,
                                                            setContactModalEditingId: setContactModalEditingId,
                                                            setScheduleInESourceModalOpen: setScheduleInESourceModalOpen,
                                                            setCurrentVisitId: setCurrentVisitId
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            prompted && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $21c6baf13a453973$export$fba3b8dabb62dcfc), {
                resumeAfterIdle: resumeAfterIdlePrompt
            }),
            newAppointmentModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d547260374dfced5$export$582e33cc2dc774b2), {
                patientId: patientId,
                setOpen: setNewAppointmentModalOpen,
                refreshData: mutatePatientAppointments
            }),
            scheduleInESourceModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2915233bc1bb6eea$export$a2b8ada25fefeb60), {
                patientId: patientId,
                screenId: screenId,
                setOpen: setScheduleInESourceModalOpen
            }),
            newMedicationModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $489f6d660a0cb8a1$export$35ea6cc555aa20db), {
                patientId: patientId,
                setOpen: setNewMedicationModalOpen,
                refreshData: mutatePatientMedications
            }),
            newConditionModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $876a77f383624865$export$19a1662012aa7379), {
                patientId: patientId,
                setOpen: setNewConditionModalOpen,
                refreshData: mutatePatientConditions
            }),
            newVisitModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $812b8eba084452ad$export$8fa3dfbad242c6c9), {
                patientId: patientId,
                setCurrentVisitId: setCurrentVisitId,
                setOpen: setNewVisitModalOpen,
                refreshData: mutatePatientVisits
            }),
            editVisitModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $575aead048882a21$export$1d454a9dbd0e6775), {
                visitId: currentVisitId,
                setOpen: setEditVisitModalOpen,
                refreshData: mutatePatientVisits
            }),
            contactModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $df4e065fa53ffdd5$export$9827c096e74f4661), {
                patientId: patientId,
                screenId: currentStudyScreenId,
                setOpen: setContactModalOpen,
                contactId: contactModalEditingId,
                setContactModalEditingId: setContactModalEditingId,
                refreshData: mutateContacts
            }),
            ineligibleModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $70e2b1cc79623450$export$225587d2949665b), {
                setOpen: setIneligibleModalOpen,
                setCurrentStudyScreenName: setCurrentStudyScreenName,
                setCurrentStudyScreenId: setCurrentStudyScreenId
            }),
            bookmarkModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e6e1101ce7a3066a$export$430b88e3a7edeac4), {
                setOpen: setBookmarkModalOpen
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");






function $0f7e5332fc336498$export$8738b9fa7947ea8() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { setNewAppointmentModalOpen: setNewAppointmentModalOpen, currentStudyScreenId: currentStudyScreenId } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patient_appointments", `patient_id=${patientId}`);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const rows = data;
    const columnDefaults = {
        width: 150,
        headerClassName: "bg-gray-100 text-gray-500",
        display: "flex"
    };
    const columns = [
        {
            field: "start_dt",
            headerName: "Appointment Start",
            ...columnDefaults,
            type: "dateTime",
            width: 225,
            valueFormatter: (value, row, column, apiRef)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(value)
        },
        {
            field: "appointment_type",
            headerName: "Appointment Type",
            ...columnDefaults
        },
        {
            field: "appointment_location",
            headerName: "Appointment Location",
            ...columnDefaults,
            width: 225
        },
        {
            field: "provider_name",
            headerName: "Provider Name",
            ...columnDefaults
        },
        {
            field: "actions",
            headerName: "Actions",
            ...columnDefaults,
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params)=>$0f7e5332fc336498$var$renderCellActions(params, deleteAppointment)
        }
    ];
    const deleteAppointment = async (id)=>{
        await (0, $b2d06586a86d14b7$export$60acb8fd13afd60d)("patient_appointments", id, getAccessTokenSilently);
        mutate();
    };
    (0, $f2Y41.useEffect)(()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientAppointmentsViewStart",
            meta: {
                patient_id: patientId,
                screen_id: currentStudyScreenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientAppointmentsViewEnd",
                meta: {
                    patient_id: patientId,
                    screen_id: currentStudyScreenId
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-4 rounded-b-lg shadow-md bg-white dark:bg-transparent border-l border-r border-b border-gray-200",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                            children: "Appointments"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                            onClick: ()=>setNewAppointmentModalOpen(true),
                            className: "h-10 text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    icon: "PlusCircleIcon",
                                    className: "fill-white w-4 h-4 mr-2 rotate-90"
                                }),
                                "Add Appointment"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex h-screen",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                            rows: rows,
                            columns: columns,
                            disableDensitySelector: true,
                            onCellDoubleClick: (params, event)=>{
                                // event.defaultMuiPrevented = true
                                // params.row.status ? props.handleScreenNavigate(params.row.id, params.row.study.abbreviation) :  props.handleScreenStart(params.row.study_id)
                                return true;
                            },
                            initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                    }
                                },
                                sorting: {
                                    sortModel: [
                                        {
                                            field: "start_dt",
                                            sort: "desc"
                                        }
                                    ]
                                },
                                density: "comfortable" // contact
                            },
                            sx: {
                                "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                                    outline: "none"
                                },
                                ".dark & .MuiDataGrid-columnHeader": {
                                    backgroundColor: "rgb(55 65 81)",
                                    color: "#FFFFFF"
                                }
                            }
                        })
                    })
                })
            ]
        })
    });
}
const $0f7e5332fc336498$var$renderCellActions = (params, deleteAppointment)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        onClick: ()=>deleteAppointment(params?.row.id),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
            icon: "TrashIcon",
            className: "h-5 hover:text-red-500 hover:cursor-pointer",
            outline: true
        })
    });



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");



function $39b3fb49f38b43d9$export$448081bbd00c020() {
    const { data: patients, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patients");
    const [cards, setCards] = (0, $f2Y41.useState)([]);
    const [board, setBoard] = (0, $f2Y41.useState)({});
    const statuses = [
        "New",
        "Pending",
        "Screening",
        "Ineligible",
        "Eligible"
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "flex flex-col mt-2",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "inline-block min-w-full align-middle",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "overflow-hidden shadow",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex items-start justify-start px-4 mb-6 space-x-4",
                            children: statuses.map((status)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "min-w-kanban",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "py-4 text-base font-semibold text-gray-900 dark:text-gray-300",
                                            children: status
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            id: "kanban-list-{{ .id }}",
                                            className: "mb-4 space-y-4 min-w-kanban",
                                            children: status == "New" && patients.map((patient)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "flex flex-col max-w-md p-5 transform bg-white rounded-lg shadow cursor-move dark:bg-gray-800",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "flex items-center justify-between pb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                    className: "text-base font-semibold text-gray-900 dark:text-white",
                                                                    children: [
                                                                        patient.given_name,
                                                                        " ",
                                                                        patient.family_name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                                    to: `/patients/${patient.id}`,
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                                        type: "button",
                                                                        "data-modal-toggle": "kanban-card-modal",
                                                                        className: "p-2 text-sm text-gray-500 rounded-lg dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700",
                                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                            icon: "ExternalLinkIcon"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "flex flex-col",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "pb-4 text-sm font-normal text-gray-700 dark:text-gray-400",
                                                                    children: patient.mrn
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                    className: "flex justify-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                            className: "flex items-center px-3 text-sm font-medium text-green-800 bg-green-100 rounded-lg dark:bg-green-200",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                                                    className: "w-4 h-4 mr-1",
                                                                                    fill: "currentColor",
                                                                                    viewBox: "0 0 20 20",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                                                        "fill-rule": "evenodd",
                                                                                        d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                                                        "clip-rule": "evenodd"
                                                                                    })
                                                                                }),
                                                                                "Done"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                            className: "flex items-center px-3 text-sm font-medium text-purple-800 bg-purple-100 rounded-lg dark:bg-purple-200",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                                                                    className: "w-4 h-4 mr-1",
                                                                                    fill: "currentColor",
                                                                                    viewBox: "0 0 20 20",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                                                        "fill-rule": "evenodd",
                                                                                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
                                                                                        "clip-rule": "evenodd"
                                                                                    })
                                                                                }),
                                                                                (0, $0dcae3260236e0d2$export$328aec9e3e2287e0)(patient.updated_at)
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }))
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            "data-modal-toggle": "new-card-modal",
                                            className: "flex p-2 items-center justify-center w-full py-2 font-semibold text-gray-500 border-2 border-gray-200 border-dashed rounded-lg hover:bg-gray-100 hover:text-gray-900 hover:border-gray-300 dark:border-gray-800 dark:hover:border-gray-700 dark:hover:bg-gray-800 dark:hover:text-white",
                                            children: [
                                                "No ",
                                                status,
                                                " Patients"
                                            ]
                                        })
                                    ]
                                }))
                        })
                    })
                })
            })
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");






function $561b6e01510f3565$export$5e4fcd6d86b6a2ab() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { data: conditions, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patient_conditions", `patient_id=${patientId}`);
    const { currentStudyScreenId: currentStudyScreenId, setNewConditionModalOpen: setNewConditionModalOpen } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const deleteCondition = async (id)=>{
        await (0, $b2d06586a86d14b7$export$60acb8fd13afd60d)("patient_conditions", id, getAccessTokenSilently);
        mutate();
    };
    (0, $f2Y41.useEffect)(()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientConditionsViewStart",
            meta: {
                patient_id: patientId,
                screen_id: currentStudyScreenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientConditionsViewEnd",
                meta: {
                    patient_id: patientId,
                    screen_id: currentStudyScreenId
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-2 bg-white rounded-lg border border-gray-200 shadow-md",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                            children: "Conditions"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                            onClick: ()=>setNewConditionModalOpen(true),
                            className: "h-10 text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    icon: "PlusCircleIcon",
                                    className: "fill-white w-4 h-4 mr-2 rotate-90"
                                }),
                                "Add Condition"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "overflow-x-auto rounded-lg",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "inline-block min-w-full align-middle",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "overflow-hidden shadow sm:rounded-lg",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("table", {
                                    className: "min-w-full divide-y divide-gray-200 dark:divide-gray-600",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("thead", {
                                            className: "bg-gray-50 dark:bg-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Started At"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Ended At"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Created By"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("tbody", {
                                            className: "bg-white dark:bg-gray-800",
                                            children: conditions.map((condition, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                                    className: index % 2 != 0 ? "bg-gray-50" : "",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "text-sm font-medium ",
                                                                children: condition?.condition?.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: (0, $0dcae3260236e0d2$export$1d9850e26a13908a)(condition.started_at)
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: (0, $0dcae3260236e0d2$export$1d9850e26a13908a)(condition.ended_at)
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: condition.created_by_user_id
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                onClick: ()=>deleteCondition(condition.id),
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                    icon: "TrashIcon",
                                                                    className: "h-5 hover:text-red-500 hover:cursor-pointer",
                                                                    outline: true
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");








var $ge3KO = parcelRequire("ge3KO");
const $a002552be04c2c91$export$d0d68bb9ed2c643d = {
    "EN": "English",
    "AF": "Afrikaans",
    "SQ": "Albanian",
    "AR": "Arabic",
    "HY": "Armenian",
    "EU": "Basque",
    "BN": "Bengali",
    "BG": "Bulgarian",
    "CA": "Catalan",
    "KM": "Cambodian",
    "ZH": "Chinese (Mandarin)",
    "HR": "Croatian",
    "CS": "Czech",
    "DA": "Danish",
    "NL": "Dutch",
    "ET": "Estonian",
    "FJ": "Fiji",
    "FI": "Finnish",
    "FR": "French",
    "KA": "Georgian",
    "DE": "German",
    "EL": "Greek",
    "GU": "Gujarati",
    "HE": "Hebrew",
    "HI": "Hindi",
    "HU": "Hungarian",
    "IS": "Icelandic",
    "ID": "Indonesian",
    "GA": "Irish",
    "IT": "Italian",
    "JA": "Japanese",
    "JW": "Javanese",
    "KO": "Korean",
    "LA": "Latin",
    "LV": "Latvian",
    "LT": "Lithuanian",
    "MK": "Macedonian",
    "MS": "Malay",
    "ML": "Malayalam",
    "MT": "Maltese",
    "MI": "Maori",
    "MR": "Marathi",
    "MN": "Mongolian",
    "NE": "Nepali",
    "NO": "Norwegian",
    "FA": "Persian",
    "PL": "Polish",
    "PT": "Portuguese",
    "PA": "Punjabi",
    "QU": "Quechua",
    "RO": "Romanian",
    "RU": "Russian",
    "SM": "Samoan",
    "SR": "Serbian",
    "SK": "Slovak",
    "SL": "Slovenian",
    "ES": "Spanish",
    "SW": "Swahili",
    "SV": "Swedish ",
    "TA": "Tamil",
    "TT": "Tatar",
    "TE": "Telugu",
    "TH": "Thai",
    "BO": "Tibetan",
    "TO": "Tonga",
    "TR": "Turkish",
    "UK": "Ukrainian",
    "UR": "Urdu",
    "UZ": "Uzbek",
    "VI": "Vietnamese",
    "CY": "Welsh",
    "XH": "Xhosa"
};
function $a002552be04c2c91$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: Object.keys($a002552be04c2c91$export$d0d68bb9ed2c643d).map((language_key)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                value: language_key,
                children: $a002552be04c2c91$export$d0d68bb9ed2c643d[language_key]
            }, language_key))
    });
}




function $4744918c3ae38de6$export$8298529d1565c2ab() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { patient: patient, currentStudyScreenId: currentStudyScreenId, mutatePatient: mutatePatient } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control, formState: { dirtyFields: dirtyFields, isDirty: isDirty } } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [saving, setSaving] = (0, $f2Y41.useState)(false);
    (0, $f2Y41.useEffect)(()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientInfoViewStart",
            meta: {
                patient_id: patientId,
                screen_id: currentStudyScreenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientInfoViewEnd",
                meta: {
                    patient_id: patientId,
                    screen_id: currentStudyScreenId
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        };
    }, []);
    (0, $f2Y41.useEffect)(()=>{
        reset(patient);
    }, [
        reset,
        patient
    ]);
    const onSubmit = (data)=>{
        const values = (0, $ee2b32dbb58b2642$export$e5643c168619274b)(dirtyFields, data);
        setSaving(true);
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("patients", patientId, values, getAccessTokenSilently).then((response)=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientInfoUpdate",
                meta: {
                    patient_id: patientId,
                    element: "PatientInfoForm",
                    fields: Object.keys
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
            mutatePatient();
            setSaving(false);
        }, (error)=>{
        // console.dir(error);
        });
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-6 rounded-b-lg shadow-md bg-white dark:bg-transparent border-l border-r border-b border-gray-200",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("h5", {
                    className: "text-xl font-bold tracking-tight text-gray-900 dark:text-gray-200 flex flex-row",
                    children: "Patient Info"
                }),
                patient.updated_at && /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                    className: "text-xs",
                    children: [
                        "Last updated ",
                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                            className: "text-green-600 font-medium",
                            children: (0, $0dcae3260236e0d2$export$328aec9e3e2287e0)(patient.updated_at)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                    className: "mt-2",
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "given_name",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "First Name"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("given_name", {
                                disabled: false
                            }),
                            type: "text",
                            id: "given_name",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "family_name",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Last Name"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("family_name", {
                                disabled: false
                            }),
                            type: "text",
                            id: "family_name",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "suffix",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Suffix"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                            ...register("suffix"),
                            id: "suffix",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "SR"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "JR"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "III"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "IV"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "V"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "mrn",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "MRN"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("mrn", {
                                disabled: false
                            }),
                            type: "text",
                            id: "mrn",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "phone",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Phone"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("phone"),
                            type: "text",
                            id: "phone",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "preferred_phone",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Preferred Phone"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("preferred_phone"),
                            type: "text",
                            id: "preferred_phone",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "email",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("email"),
                            type: "text",
                            id: "email",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "preferred_email",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Preferred Email"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("preferred_email"),
                            type: "text",
                            id: "preferred_email",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "preferred_language",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Preferred Language"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("select", {
                            ...register("preferred_language"),
                            id: "preferred_language",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a002552be04c2c91$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "dob",
                            className: "mb-4 font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Birthdate"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                            name: "dob",
                            control: control,
                            defaultValue: "",
                            render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                    ...field,
                                    type: "date",
                                    sx: {
                                        display: "block",
                                        "marginBottom": "1rem",
                                        "padding": "0",
                                        "paddingTop": "0.1rem",
                                        width: 250,
                                        "boxShadow": "none"
                                    },
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "birth_sex",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Birth Sex"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                            ...register("birth_sex", {
                                disabled: false
                            }),
                            id: "birth_sex",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Male"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Female"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Intersex"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "gender",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Gender"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("gender"),
                            type: "text",
                            id: "gender",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "race",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Race"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                            ...register("race", {
                                disabled: false
                            }),
                            id: "race",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "American Indian or Alaska Native"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Asian"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Black or African American"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Native Hawaiian or Other Pacific Islander"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "White"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Some Other Race"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Two or More Races"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Declines to Answer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "ethnicity",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Ethnicity"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                            ...register("ethnicity"),
                            type: "text",
                            id: "ethnicity",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Hispanic or Latino"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Not Hispanic or Latino"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Declines to Answer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "referring_provider",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Referring Provider (Provider of Record)"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                            ...register("referring_provider"),
                            type: "text",
                            id: "referring_provider",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                            htmlFor: "source",
                            className: "font-medium text-sm text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                            children: "Source"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                            ...register("source"),
                            id: "source",
                            className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Provider Referral"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Data Extract"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Manual EMR Review"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                    children: "Sponsor Referral"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                    className: "mt-4 text-white bg-topo-blue hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                    type: "submit",
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34ede4a4a21f9915$export$25c8cd19dc067a8d), {
                                    isShowing: saving
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");






function $da945fc2c67ce19f$export$f6cddb448106312d() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { currentStudyScreenId: currentStudyScreenId, setNewMedicationModalOpen: setNewMedicationModalOpen } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("patient_medications", `patient_id=${patientId}`);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const deleteMedication = async (id)=>{
        await (0, $b2d06586a86d14b7$export$60acb8fd13afd60d)("patient_medications", id, getAccessTokenSilently);
        mutate();
    };
    (0, $f2Y41.useEffect)(()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientMedicationsViewStart",
            meta: {
                patient_id: patientId,
                screen_id: currentStudyScreenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientMedicationsViewEnd",
                meta: {
                    patient_id: patientId,
                    screen_id: currentStudyScreenId
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-2 bg-white rounded-lg border border-gray-200 shadow-md",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                            children: "Medications"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                            onClick: ()=>setNewMedicationModalOpen(true),
                            className: "h-10 text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    icon: "PlusCircleIcon",
                                    className: "fill-white w-4 h-4 mr-2 rotate-90"
                                }),
                                "Add Medication"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "overflow-x-auto rounded-lg",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "inline-block min-w-full align-middle",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "overflow-hidden shadow sm:rounded-lg",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("table", {
                                    className: "min-w-full divide-y divide-gray-200 dark:divide-gray-600",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("thead", {
                                            className: "bg-gray-50 dark:bg-gray-700",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Medication"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Amount"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Condition"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Started At"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Ended At"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                        children: "Created By"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                        scope: "col",
                                                        className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("tbody", {
                                            className: "bg-white dark:bg-gray-800",
                                            children: data.map((medication, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                                    className: index % 2 != 0 ? "bg-gray-50" : "",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "text-sm font-medium ",
                                                                children: medication?.medication?.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: [
                                                                medication.amount,
                                                                " ",
                                                                medication.unit
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: medication?.condition?.name
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: (0, $0dcae3260236e0d2$export$1d9850e26a13908a)(medication.started_at)
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: (0, $0dcae3260236e0d2$export$1d9850e26a13908a)(medication.ended_at)
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                            children: medication?.created_by?.name
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                onClick: ()=>deleteMedication(medication.id),
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                    icon: "TrashIcon",
                                                                    className: "h-5 hover:text-red-500 hover:cursor-pointer",
                                                                    outline: true
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
"use client";
const $26c19916d84eefae$var$d = (r2)=>{}, $26c19916d84eefae$var$h = "undefined" == typeof window ? (0, $f2Y41.useEffect) : (0, $f2Y41.useLayoutEffect), $26c19916d84eefae$var$m = (r2)=>"number" == typeof r2 && r2 > 0, $26c19916d84eefae$var$p = (r2)=>$26c19916d84eefae$var$m(r2) ? r2 : 0, $26c19916d84eefae$var$L = (r2)=>Math.round(100 * r2) / 100, $26c19916d84eefae$var$O = (r2)=>Math.round(2 * r2) / 2, $26c19916d84eefae$var$g = (r2)=>0 === r2 ? 0 : -1 * $26c19916d84eefae$var$L(r2);
const $26c19916d84eefae$var$y = {};
const $26c19916d84eefae$var$b = "rr--group", $26c19916d84eefae$var$S = "rr--box", $26c19916d84eefae$var$R = "rr--svg", $26c19916d84eefae$var$M = "rr--reset", $26c19916d84eefae$var$A = "rr--focus-reset", $26c19916d84eefae$var$E = "rr--svg-stop-1", $26c19916d84eefae$var$v = "rr--svg-stop-2", $26c19916d84eefae$var$B = "rr--on", $26c19916d84eefae$var$I = "rr--off", $26c19916d84eefae$var$x = {
    ZOOM: "rr--fx-zoom",
    POSITION: "rr--fx-position",
    OPACITY: "rr--fx-opacity",
    COLORS: "rr--fx-colors"
}, $26c19916d84eefae$var$C = {
    SMALL: "rr--rx-sm",
    MEDIUM: "rr--rx-md",
    LARGE: "rr--rx-lg",
    FULL: "rr--rx-full"
}, $26c19916d84eefae$var$w = {
    SMALL: "rr--gap-sm",
    MEDIUM: "rr--gap-md",
    LARGE: "rr--gap-lg"
}, $26c19916d84eefae$var$D = {
    SMALL: "rr--space-sm",
    MEDIUM: "rr--space-md",
    LARGE: "rr--space-lg"
}, $26c19916d84eefae$var$N = "rr--pointer", $26c19916d84eefae$var$$ = "rr--disabled", $26c19916d84eefae$var$k = "rr--dir-y", $26c19916d84eefae$var$F = "rr--dir-x", $26c19916d84eefae$var$T = "rr--has-stroke", $26c19916d84eefae$var$U = "rr--has-border", $26c19916d84eefae$var$W = "rr--hf-box-on", $26c19916d84eefae$var$P = "rr--hf-box-int", $26c19916d84eefae$var$G = "rr--hf-box-off", $26c19916d84eefae$var$K = "rr--hf-svg-on", $26c19916d84eefae$var$X = "rr--hf-svg-off", $26c19916d84eefae$var$Z = {
    FILL: "--rr--fill-on-color",
    BOX: "--rr--box-on-color",
    BORDER: "--rr--border-on-color",
    STROKE: "--rr--stroke-on-color"
}, $26c19916d84eefae$var$H = {
    FILL: "--rr--fill-off-color",
    BOX: "--rr--box-off-color",
    BORDER: "--rr--border-off-color",
    STROKE: "--rr--stroke-off-color"
}, $26c19916d84eefae$var$V = "--rr--border-width", $26c19916d84eefae$var$j = "horizontal", $26c19916d84eefae$var$Y = "vertical", $26c19916d84eefae$var$z = "svg", $26c19916d84eefae$var$q = "box", $26c19916d84eefae$var$J = {
    NONE: "none",
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    FULL: "full"
}, $26c19916d84eefae$var$Q = {
    NONE: "none",
    ZOOM: "zoom",
    POSITION: "position",
    OPACITY: "opacity",
    COLORS: "colors"
}, $26c19916d84eefae$var$_ = {
    FILL: "activeFillColor",
    BOX: "activeBoxColor",
    BORDER: "activeBoxBorderColor",
    STROKE: "activeStrokeColor"
}, $26c19916d84eefae$var$rr = {
    FILL: "inactiveFillColor",
    BOX: "inactiveBoxColor",
    BORDER: "inactiveBoxBorderColor",
    STROKE: "inactiveStrokeColor"
};
function $26c19916d84eefae$var$er({ itemShapes: t2, testId: n2, itemStrokeWidth: c2 = 0, orientation: l2 = $26c19916d84eefae$var$j, hasHF: u2 = false }) {
    const f2 = c2 > 0 ? -c2 / 2 : 0, d2 = c2 > 0 ? `${f2} ${f2}` : "0 0", m2 = (0, $f2Y41.useId)(), p2 = (0, $f2Y41.useRef)(null), [O2, y2] = (0, $f2Y41.useState)(null), [b2, S2] = (0, $f2Y41.useState)(false), M2 = (0, $f2Y41.useRef)(null), A2 = (0, $f2Y41.useRef)(null), B2 = (0, $f2Y41.useCallback)((r2)=>{
        const { width: e2, height: t3, x: n3, y: o2 } = r2.getBBox();
        if (((...r3)=>r3.every((r4)=>"number" == typeof r4))(e2, t3, n3, o2)) {
            const r3 = `${d2} ${$26c19916d84eefae$var$L(e2 + c2)} ${$26c19916d84eefae$var$L(t3 + c2)}`, i2 = `${$26c19916d84eefae$var$g(n3)} ${$26c19916d84eefae$var$g(o2)}`;
            y2({
                viewBox: r3,
                translateData: i2
            });
        }
    }, [
        c2,
        d2
    ]);
    return $26c19916d84eefae$var$h(()=>{
        if (p2.current) {
            const { width: r2, height: e2, x: t3, y: n3 } = p2.current.getBBox();
            if (0 === r2 && 0 === e2 && 0 === t3 && 0 === n3) {
                const r3 = function(r4) {
                    if (!r4 || !r4.parentElement) return null;
                    let e3 = r4 == null ? void 0 : r4.parentElement;
                    for(; e3 && "none" !== window.getComputedStyle(e3).display;)e3 = e3.parentElement;
                    return e3;
                }(p2.current);
                r3 && (A2.current = r3, S2(true));
            } else S2(false);
            B2(p2.current);
        }
    }, [
        t2,
        c2,
        u2
    ]), $26c19916d84eefae$var$h(()=>{
        if (b2 && A2.current) return M2.current = new MutationObserver((r2, e2)=>{
            r2.forEach(()=>{
                "none" === window.getComputedStyle(A2.current).display || (B2(p2.current), e2.disconnect());
            });
        }), M2.current.observe(A2.current, {
            attributes: true
        }), ()=>{
            var _a;
            (_a = M2.current) == null || _a.disconnect();
        };
    }, [
        b2,
        B2
    ]), (0, $ge3KO.jsxs)("svg", {
        "aria-hidden": "true",
        className: $26c19916d84eefae$var$R,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: O2 ? O2.viewBox : "0 0 0 0",
        preserveAspectRatio: "xMidYMid meet",
        ...c2 > 0 ? {
            strokeWidth: c2
        } : {},
        ...n2,
        children: [
            u2 && (0, $ge3KO.jsx)("defs", {
                children: (0, $ge3KO.jsxs)("linearGradient", {
                    id: m2,
                    ...l2 === $26c19916d84eefae$var$Y ? {
                        gradientTransform: "rotate(90)"
                    } : {},
                    children: [
                        (0, $ge3KO.jsx)("stop", {
                            className: $26c19916d84eefae$var$E,
                            offset: "50%"
                        }),
                        (0, $ge3KO.jsx)("stop", {
                            className: $26c19916d84eefae$var$v,
                            offset: "50%"
                        })
                    ]
                })
            }),
            (0, $ge3KO.jsx)("g", {
                ref: p2,
                shapeRendering: "geometricPrecision",
                ...function() {
                    if (O2) {
                        const r2 = `translate(${O2 == null ? void 0 : O2.translateData})`;
                        return "translate(0 0)" === r2 ? {} : {
                            transform: r2
                        };
                    }
                    return {
                        transform: void 0
                    };
                }(),
                ...u2 ? {
                    fill: `url('#${m2}')`
                } : {},
                children: t2
            })
        ]
    });
}
function $26c19916d84eefae$var$tr(r2, e2, t2) {
    switch(e2){
        case $26c19916d84eefae$var$_.FILL:
            return r2[$26c19916d84eefae$var$Z.FILL] = t2, true;
        case $26c19916d84eefae$var$_.BOX:
            return r2[$26c19916d84eefae$var$Z.BOX] = t2, true;
        case $26c19916d84eefae$var$_.BORDER:
            return r2[$26c19916d84eefae$var$Z.BORDER] = t2, true;
        case $26c19916d84eefae$var$_.STROKE:
            return r2[$26c19916d84eefae$var$Z.STROKE] = t2, true;
    }
    return false;
}
function $26c19916d84eefae$var$nr(r2, e2, t2) {
    if (!$26c19916d84eefae$var$tr(r2, e2, t2)) switch(e2){
        case $26c19916d84eefae$var$rr.FILL:
            r2[$26c19916d84eefae$var$H.FILL] = t2;
            break;
        case $26c19916d84eefae$var$rr.BOX:
            r2[$26c19916d84eefae$var$H.BOX] = t2;
            break;
        case $26c19916d84eefae$var$rr.BORDER:
            r2[$26c19916d84eefae$var$H.BORDER] = t2;
            break;
        case $26c19916d84eefae$var$rr.STROKE:
            r2[$26c19916d84eefae$var$H.STROKE] = t2;
    }
}
function $26c19916d84eefae$var$or(r2, e2, t2) {
    const n2 = {};
    let o2;
    for (const [t3, o3] of Object.entries(r2))$26c19916d84eefae$var$tr(n2, t3, o3[e2]);
    return t2 ? (o2 = Array(e2).fill({}), o2.push(n2)) : o2 = Array(e2 + 1).fill(n2), o2;
}
const $26c19916d84eefae$var$ir = (r2)=>`${r2} ${$26c19916d84eefae$var$x.COLORS}`;
function $26c19916d84eefae$var$ar({ className: r2, radius: e2, readOnly: t2, isDisabled: n2, isDynamic: o2, transition: i2, orientation: a2, absoluteBoxBorderWidth: s2, absoluteStrokeWidth: c2, spaceBetween: l2, spaceInside: u2 }) {
    const f2 = o2 ? $26c19916d84eefae$var$N : "", d2 = function(r3) {
        switch(r3){
            case $26c19916d84eefae$var$J.SMALL:
                return $26c19916d84eefae$var$w.SMALL;
            case $26c19916d84eefae$var$J.MEDIUM:
                return $26c19916d84eefae$var$w.MEDIUM;
            case $26c19916d84eefae$var$J.LARGE:
                return $26c19916d84eefae$var$w.LARGE;
            default:
                return "";
        }
    }(l2), h2 = function(r3) {
        switch(r3){
            case $26c19916d84eefae$var$J.SMALL:
                return $26c19916d84eefae$var$D.SMALL;
            case $26c19916d84eefae$var$J.MEDIUM:
                return $26c19916d84eefae$var$D.MEDIUM;
            case $26c19916d84eefae$var$J.LARGE:
                return $26c19916d84eefae$var$D.LARGE;
            default:
                return "";
        }
    }(u2), m2 = !t2 && n2 ? $26c19916d84eefae$var$$ : "", p2 = o2 && i2 !== $26c19916d84eefae$var$Q.NONE ? function(r3) {
        switch(r3){
            case $26c19916d84eefae$var$Q.ZOOM:
                return $26c19916d84eefae$var$ir($26c19916d84eefae$var$x.ZOOM);
            case $26c19916d84eefae$var$Q.POSITION:
                return $26c19916d84eefae$var$ir($26c19916d84eefae$var$x.POSITION);
            case $26c19916d84eefae$var$Q.OPACITY:
                return $26c19916d84eefae$var$ir($26c19916d84eefae$var$x.OPACITY);
            case $26c19916d84eefae$var$Q.COLORS:
                return $26c19916d84eefae$var$x.COLORS;
            default:
                return "";
        }
    }(i2) : "", L2 = a2 === $26c19916d84eefae$var$Y ? $26c19916d84eefae$var$k : $26c19916d84eefae$var$F, O2 = function(r3) {
        switch(r3){
            case $26c19916d84eefae$var$J.SMALL:
                return $26c19916d84eefae$var$C.SMALL;
            case $26c19916d84eefae$var$J.MEDIUM:
                return $26c19916d84eefae$var$C.MEDIUM;
            case $26c19916d84eefae$var$J.LARGE:
                return $26c19916d84eefae$var$C.LARGE;
            case $26c19916d84eefae$var$J.FULL:
                return $26c19916d84eefae$var$C.FULL;
            default:
                return "";
        }
    }(e2);
    return `${$26c19916d84eefae$var$b} ${L2} ${c2 > 0 ? $26c19916d84eefae$var$T : ""} ${s2 > 0 ? $26c19916d84eefae$var$U : ""}
${p2} ${O2} ${f2} ${m2} ${d2}
${h2} ${r2}`.replace(/  +/g, " ").trimEnd();
}
function $26c19916d84eefae$var$sr(r2, e2, t2) {
    return Array.from({
        length: e2
    }, (e3, n2)=>r2 ? n2 === t2 ? $26c19916d84eefae$var$B : $26c19916d84eefae$var$I : n2 <= t2 ? $26c19916d84eefae$var$B : $26c19916d84eefae$var$I);
}
function $26c19916d84eefae$var$cr(r2, e2, t2) {
    const n2 = Math.floor($26c19916d84eefae$var$O(r2));
    return Array.from({
        length: e2
    }, (r3, e3)=>"box" === t2 ? e3 > n2 ? $26c19916d84eefae$var$G : e3 === n2 ? $26c19916d84eefae$var$P : $26c19916d84eefae$var$W : e3 > n2 ? $26c19916d84eefae$var$X : $26c19916d84eefae$var$K);
}
function $26c19916d84eefae$var$lr(r2, e2) {
    const t2 = {};
    $26c19916d84eefae$var$m(e2) && (t2[$26c19916d84eefae$var$V] = `${e2}px`);
    const n2 = Object.entries(r2);
    if (n2.length > 0) for (const [r3, e3] of n2)$26c19916d84eefae$var$nr(t2, r3, e3);
    return t2;
}
const $26c19916d84eefae$var$ur = [
    $26c19916d84eefae$var$_.FILL,
    $26c19916d84eefae$var$_.BOX,
    $26c19916d84eefae$var$_.STROKE,
    $26c19916d84eefae$var$_.BORDER
];
function $26c19916d84eefae$var$fr(r2, e2, t2 = false) {
    return Array.from({
        length: r2
    }, (n2, o2)=>t2 && e2 < 0 ? o2 === r2 - 1 ? 0 : -1 : e2 <= 0 ? 0 === o2 ? 0 : -1 : e2 > 0 ? o2 === e2 ? 0 : -1 : void 0);
}
const $26c19916d84eefae$var$dr = "@smastrom/react-rating", $26c19916d84eefae$var$hr = (r2)=>`[${$26c19916d84eefae$var$dr}] - Nothing's returned from rendering. Reason: ${r2}.`;
function $26c19916d84eefae$var$mr(r2, e2) {
    return r2.shouldRender = false, r2.reason = $26c19916d84eefae$var$hr(e2), r2;
}
const $26c19916d84eefae$var$pr = "itemShapes is not a valid JSX element";
const $26c19916d84eefae$export$1644ba17714857f1 = (0, $ge3KO.jsx)("polygon", {
    points: "25 9.02 16.4 7.75 12.46 0 8.59 7.79 0 9.14 6.21 15.23 4.85 23.81 12.55 19.79 20.3 23.74 18.85 15.17 25 9.02"
}), $26c19916d84eefae$export$f2e634294c04d57d = (0, $ge3KO.jsx)("path", {
    d: "M12.5,18.16l-7.73,5.61,2.95-9.08L0,9.07H9.55S12.5,0,12.5,0l2.95,9.07h9.55l-7.73,5.62,2.95,9.08-7.73-5.61Z"
}), $26c19916d84eefae$export$9b8ea366d5b11646 = (0, $ge3KO.jsx)("path", {
    d: "M112.46,57.88c-.23-.72-.88-1.22-1.63-1.27l-6.63-.46-2.45-6.19c-.27-.7-.95-1.16-1.7-1.16h0c-.75,0-1.42,.46-1.7,1.16l-2.5,6.23-6.58,.42c-.75,.05-1.4,.55-1.63,1.27-.24,.73,0,1.53,.58,2.02l5.07,4.28-1.51,5.92c-.21,.82,.1,1.69,.78,2.19,.66,.48,1.55,.5,2.24,.07l5.23-3.31h.02l5.63,3.56c.29,.19,.63,.29,.97,.29,1.02,0,1.83-.84,1.83-1.86,0-.16-.02-.31-.06-.47l-1.6-6.48,5.04-4.2c.59-.49,.82-1.29,.58-2.02Z"
}), $26c19916d84eefae$export$948a7bb90d42f9bc = (0, $ge3KO.jsx)("path", {
    d: "M22.72,8.24h-6.68L13.97,1.88c-.81-2.51-2.13-2.51-2.95,0l-2.07,6.36H2.28c-2.63,0-3.04,1.25-.91,2.8l5.41,3.93-2.06,6.36c-.81,2.51,.25,3.28,2.39,1.73l5.41-3.93,5.41,3.93c2.13,1.55,3.2,.77,2.39-1.73l-2.07-6.36,5.41-3.93c2.13-1.55,1.72-2.8-.91-2.8Z"
}), $26c19916d84eefae$export$c7dada2933fa2ec6 = (0, $ge3KO.jsx)("path", {
    d: "M11.58,.77c.51-1.02,1.33-1.02,1.84,0l2.34,4.73c.5,1.02,1.84,2,2.98,2.16l5.22,.76c1.13,.17,1.39,.95,.57,1.75l-3.78,3.68c-.82,.8-1.33,2.37-1.14,3.5l.89,5.2c.19,1.13-.48,1.61-1.49,1.08l-4.67-2.45c-1.01-.53-2.67-.53-3.68,0l-4.67,2.46c-1.01,.53-1.68,.05-1.49-1.08l.89-5.2c.19-1.13-.32-2.7-1.14-3.5L.48,10.17c-.82-.8-.56-1.58,.57-1.75l5.22-.76c1.13-.16,2.47-1.14,2.98-2.16L11.58,.77h0Z"
}), $26c19916d84eefae$export$51def8c33e56fa36 = (0, $ge3KO.jsx)("path", {
    d: "M19.29,1.61c-2.15-2.15-5.63-2.15-7.78,0,0,0,0,0,0,0l-1.06,1.06-1.06-1.06C7.24-.54,3.76-.54,1.61,1.61-.54,3.76-.54,7.24,1.61,9.39l1.06,1.06,7.78,7.78,7.78-7.78,1.06-1.06c2.15-2.15,2.15-5.63,0-7.78,0,0,0,0,0,0Z"
}), $26c19916d84eefae$var$Rr = {
    itemShapes: $26c19916d84eefae$export$1644ba17714857f1,
    itemStrokeWidth: 2,
    activeFillColor: "#ffb23f",
    inactiveFillColor: "#fff7ed",
    activeStrokeColor: "#e17b21",
    inactiveStrokeColor: "#eda76a"
}, $26c19916d84eefae$export$8ba663d22f9191ae = (0, $f2Y41.forwardRef)(({ value: n2, items: o2 = 5, readOnly: l2 = false, onChange: m2 = $26c19916d84eefae$var$d, onHoverChange: L2 = $26c19916d84eefae$var$d, onFocus: g2 = $26c19916d84eefae$var$d, onBlur: b2 = $26c19916d84eefae$var$d, preventDefault: R2 = "all", isDisabled: E2 = false, highlightOnlySelected: v2 = false, orientation: B2 = $26c19916d84eefae$var$j, spaceBetween: I2 = $26c19916d84eefae$var$J.NONE, spaceInside: x2 = $26c19916d84eefae$var$J.SMALL, radius: C2 = $26c19916d84eefae$var$J.NONE, transition: w2 = $26c19916d84eefae$var$Q.COLORS, itemStyles: D2 = $26c19916d84eefae$var$Rr, isRequired: N2 = false, halfFillMode: $2 = $26c19916d84eefae$var$z, visibleLabelId: k2, visibleItemLabelIds: F2, invisibleItemLabels: T2, invisibleLabel: U2 = l2 ? n2 > 0 ? `Rated ${n2} on ${o2}` : "Not rated" : "Rating Selection", resetLabel: W2 = "Reset rating", id: P2, className: G2, style: K2 }, X2)=>{
    const Z2 = Array.from({
        length: o2
    }, (r2, e2)=>e2 + 1), H2 = l2 && !Number.isInteger(n2), V2 = H2 && !v2, Y2 = H2 && v2 ? Math.round(n2) : n2, _2 = !l2 && !E2, rr2 = Y2 >= 0.25, tr2 = "string" == typeof G2 ? G2 : "", nr2 = $2 === $26c19916d84eefae$var$q ? $26c19916d84eefae$var$q : $26c19916d84eefae$var$z, ir2 = V2 && !((r2)=>Number.isInteger($26c19916d84eefae$var$O(r2)))(Y2), dr2 = !N2 && !l2, hr2 = N2 ? o2 : o2 + 1, Lr2 = V2 ? function(r2, e2) {
        const t2 = $26c19916d84eefae$var$O(e2);
        return Number.isInteger(t2) ? r2.indexOf(t2) : Math.floor(t2);
    }(Z2, Y2) : Z2.indexOf(Y2), { staticColors: Or2, arrayColors: gr2, itemShapes: yr2, absoluteStrokeWidth: br2, absoluteBoxBorderWidth: Sr2 } = (0, $f2Y41.useMemo)(()=>{
        const { itemShapes: r2, itemStrokeWidth: e2, boxBorderWidth: t2, ...n3 } = D2, o3 = function(r3) {
            const e3 = {
                ...r3
            }, t3 = {}, n4 = Object.entries(e3);
            if (n4.length > 0) for (const [r4, o4] of n4)if (Array.isArray(o4) || "string" == typeof o4) {
                if (Array.isArray(o4)) for (const n5 of $26c19916d84eefae$var$ur)if (n5 === r4) {
                    const n6 = o4.filter((r5)=>"string" == typeof r5);
                    n6.length > 0 && (t3[r4] = n6, delete e3[r4]);
                } else delete e3[r4];
            } else delete e3[r4];
            return {
                arrayColors: t3,
                staticColors: e3
            };
        }(n3);
        return {
            itemShapes: r2,
            absoluteStrokeWidth: $26c19916d84eefae$var$p(e2),
            absoluteBoxBorderWidth: $26c19916d84eefae$var$p(t2),
            ...o3
        };
    }, [
        D2
    ]), Mr2 = Object.keys(gr2).length > 0, Ar = (0, $f2Y41.useCallback)((r2, e2)=>({
            dynamicClassNames: ir2 ? $26c19916d84eefae$var$cr(Y2, o2, nr2) : $26c19916d84eefae$var$sr(v2, o2, r2),
            dynamicCssVars: e2 && Mr2 ? $26c19916d84eefae$var$or(gr2, r2, v2) : []
        }), [
        gr2,
        Mr2,
        v2,
        nr2,
        ir2,
        o2,
        Y2
    ]), Er = (0, $f2Y41.useCallback)(()=>$r($26c19916d84eefae$var$fr(hr2, Lr2, !N2)), [
        Lr2,
        hr2,
        N2
    ]), vr = (0, $f2Y41.useRef)(true), Br = (0, $f2Y41.useRef)(true), Ir = (0, $f2Y41.useRef)(null), xr = (0, $f2Y41.useRef)([]), Cr = (0, $f2Y41.useRef)(false), [wr, Dr] = (0, $f2Y41.useState)({
        staticCssVars: $26c19916d84eefae$var$lr(Or2, Sr2),
        ...Ar(Lr2, rr2)
    }), [Nr, $r] = (0, $f2Y41.useState)(()=>_2 ? $26c19916d84eefae$var$fr(hr2, Lr2, !N2) : []);
    $26c19916d84eefae$var$h(()=>{
        _2 && xr.current && (Cr.current = function(r2) {
            if (r2) return "rtl" === getComputedStyle(r2).getPropertyValue("direction");
            return false;
        }(xr.current[0]));
    }, [
        _2
    ]), (0, $f2Y41.useEffect)(()=>{
        if (!vr.current) return Dr({
            staticCssVars: $26c19916d84eefae$var$lr(Or2, Sr2),
            ...Ar(Lr2, rr2)
        });
        vr.current = false;
    }, [
        Or2,
        Ar,
        Sr2,
        Lr2,
        rr2
    ]), (0, $f2Y41.useEffect)(()=>{
        if (!Br.current && _2) return Er();
        Br.current = false;
    }, [
        _2,
        Er
    ]);
    const { shouldRender: kr, reason: Fr } = function({ items: r2, itemShapes: e2 }) {
        const t2 = {
            shouldRender: true,
            reason: ""
        };
        if ("number" != typeof r2 || r2 < 1 || r2 > 10) return $26c19916d84eefae$var$mr(t2, "items is invalid");
        if (!e2) return $26c19916d84eefae$var$mr(t2, "itemStyles needs at least the property itemShapes set");
        if (!Array.isArray(e2) && !(0, $f2Y41.isValidElement)(e2)) return $26c19916d84eefae$var$mr(t2, $26c19916d84eefae$var$pr);
        if (Array.isArray(e2)) {
            if (e2.length !== r2) return $26c19916d84eefae$var$mr(t2, "itemShapes length mismatch");
            if (!e2.every((r3)=>(0, $f2Y41.isValidElement)(r3))) return $26c19916d84eefae$var$mr(t2, $26c19916d84eefae$var$pr);
        }
        return t2;
    }({
        items: o2,
        itemShapes: yr2
    });
    if (!kr) return console.error(Fr), null;
    function Tr(r2, e2, t2 = ()=>{}) {
        xr.current.some((e3)=>e3 === r2.relatedTarget) ? t2() : e2();
    }
    function Ur() {
        L2(0), Er();
    }
    function Wr(r2) {
        Tr(r2, ()=>{
            Ur();
        }), Dr({
            ...wr,
            ...Ar(Lr2, rr2)
        });
    }
    function Pr(r2) {
        Tr(r2, ()=>{
            Ur(), b2();
        });
    }
    function Gr(r2, e2) {
        const t2 = !N2 && e2 === Z2.length ? 0 : e2 + 1;
        Tr(r2, ()=>{
            g2(), L2(t2);
        }, ()=>{
            L2(t2);
        });
    }
    function Kr(r2) {
        $r($26c19916d84eefae$var$fr(hr2, r2, !N2)), xr.current[r2].focus();
    }
    const Xr = $26c19916d84eefae$var$ar({
        className: tr2,
        radius: C2,
        readOnly: l2,
        isDisabled: E2,
        isDynamic: _2,
        transition: w2,
        orientation: B2,
        absoluteBoxBorderWidth: Sr2,
        absoluteStrokeWidth: br2,
        spaceBetween: I2,
        spaceInside: x2
    });
    function Zr(r2) {
        return {
            ref: (e2)=>xr.current[r2] = e2
        };
    }
    function Hr(r2) {
        return {
            tabIndex: Nr[r2],
            onKeyDown: (e2)=>(function(r3, e3) {
                    let t2 = 0;
                    const n3 = N2 ? Z2.length - 1 : Z2.length, o3 = e3 - 1, i2 = e3 + 1, a2 = !N2 && e3 === Z2.length, s2 = 0 === e3 ? n3 : o3, c2 = n3 === e3 ? 0 : i2;
                    switch(r3.code){
                        case "Shift":
                        case "Tab":
                            return true;
                        case "ArrowDown":
                        case "ArrowRight":
                            return t2 = Cr.current ? s2 : c2, Kr(t2);
                        case "ArrowUp":
                        case "ArrowLeft":
                            return t2 = Cr.current ? c2 : s2, Kr(t2);
                        case "Enter":
                        case "Space":
                            return "all" !== R2 && "click" !== R2 || r3.preventDefault(), m2(a2 ? 0 : e3 + 1);
                    }
                    r3.stopPropagation();
                })(e2, r2)
        };
    }
    function Vr(r2) {
        return {
            onClick: (e2)=>(function(r3, e3) {
                    "all" !== R2 && "keydown" !== R2 || r3.preventDefault(), r3.stopPropagation(), m2(N2 || Lr2 !== e3 ? e3 + 1 : 0);
                })(e2, r2),
            onMouseEnter: ()=>(function(r3) {
                    L2(r3 + 1), Dr({
                        ...wr,
                        ...Ar(r3, true)
                    });
                })(r2),
            onMouseLeave: Wr
        };
    }
    function jr(r2) {
        if (l2) return {};
        const e2 = {};
        if (Array.isArray(F2)) e2["aria-labelledby"] = F2[r2];
        else {
            const t2 = Array.isArray(T2) ? T2 : Z2.map((r3, e3)=>`Rate ${e3 + 1}`);
            e2["aria-label"] = t2[r2];
        }
        return E2 && (e2["aria-disabled"] = "true"), {
            role: "radio",
            "aria-checked": r2 + 1 === Y2,
            ...e2
        };
    }
    function Yr(r2) {
        const e2 = {
            itemShapes: Array.isArray(yr2) ? yr2[r2] : yr2,
            itemStrokeWidth: br2,
            orientation: B2,
            hasHF: false,
            testId: {}
        };
        return ir2 && nr2 === $26c19916d84eefae$var$z && (e2.hasHF = r2 === Lr2), e2;
    }
    return (0, $ge3KO.jsx)("div", {
        id: P2,
        className: Xr,
        style: {
            ...K2,
            ...wr.staticCssVars
        },
        ref: function(r2) {
            _2 && !N2 && (Ir.current = r2), X2 && (X2.current = r2);
        },
        ...function() {
            if (!l2) {
                const r2 = N2 && !E2, e2 = {
                    role: "radiogroup",
                    "aria-required": r2
                };
                return r2 && (e2["aria-invalid"] = Y2 <= 0), "string" == typeof k2 && k2.length > 0 ? e2["aria-labelledby"] = k2 : e2["aria-label"] = U2, e2;
            }
            return {
                role: "img",
                "aria-label": U2
            };
        }(),
        ...$26c19916d84eefae$var$y,
        children: Z2.map((t2, n3)=>{
            var o3, i2;
            return (0, $ge3KO.jsxs)((0, $f2Y41.Fragment), {
                children: [
                    (0, $ge3KO.jsx)("div", {
                        className: `${$26c19916d84eefae$var$S} ${wr.dynamicClassNames[n3]}`,
                        style: wr.dynamicCssVars[n3],
                        ...jr(n3),
                        ...(i2 = n3, _2 ? {
                            ...Zr(i2),
                            ...Hr(i2),
                            ...Vr(i2),
                            onFocus: (r2)=>Gr(r2, i2),
                            onBlur: (r2)=>Pr(r2)
                        } : {}),
                        children: (0, $ge3KO.jsx)($26c19916d84eefae$var$er, {
                            ...Yr(n3)
                        })
                    }),
                    dr2 && n3 === Z2.length - 1 && (0, $ge3KO.jsx)("div", {
                        ...(o3 = n3 + 1, {
                            className: $26c19916d84eefae$var$M,
                            role: "radio",
                            "aria-label": W2,
                            "aria-checked": 0 === Y2,
                            onClick: ()=>m2(0),
                            onFocus: (r2)=>{
                                var _a;
                                Gr(r2, o3), (_a = Ir.current) == null || _a.classList.add($26c19916d84eefae$var$A);
                            },
                            onBlur: (r2)=>{
                                var _a;
                                Pr(r2), (_a = Ir.current) == null || _a.classList.remove($26c19916d84eefae$var$A);
                            },
                            ...Hr(o3),
                            ...Zr(o3),
                            ...E2 ? {
                                "aria-disabled": "true"
                            } : {}
                        })
                    })
                ]
            }, t2);
        })
    });
});
$26c19916d84eefae$export$8ba663d22f9191ae.displayName = "Rating";







var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");
function $17021bae4f231a31$export$ac6721e55877afc3() {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "mb-2",
                children: "In the CRIO URL, the CRIO ID can be located after '/subject/'"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mb-2",
                children: [
                    "In the following example, ",
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "inline font-bold",
                        children: "99999"
                    }),
                    " is the CRIO ID"
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "italic",
                children: "/topography-health/topo-test-site/study/55555/subject/99999"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $ge3KO = parcelRequire("ge3KO");


function $d66a7b68590573ac$export$f9f288e41e259a8b(props) {
    const columnDefaults = {
        width: 150,
        headerClassName: "bg-gray-100 text-gray-500",
        display: "flex"
    };
    const columns = [
        {
            field: "status",
            headerName: "",
            ...columnDefaults,
            width: 50,
            renderCell: $d66a7b68590573ac$var$renderCellStatus,
            valueGetter: (value, row, column, apiRef)=>$d66a7b68590573ac$var$valueGetterStatus(row?.criterion, props.questionIsExclusion)
        },
        {
            field: "term",
            headerName: "Term",
            ...columnDefaults
        },
        {
            field: "evidence",
            headerName: "Evidence",
            ...columnDefaults,
            width: 550
        },
        {
            field: "evidence_order",
            headerName: "Evidence Order",
            ...columnDefaults
        },
        {
            field: "evidence_value",
            headerName: "Evidence Value",
            ...columnDefaults
        },
        {
            field: "evidence_date",
            headerName: "Reported Date",
            ...columnDefaults,
            width: 195
        },
        {
            field: "study",
            headerName: "Found On",
            ...columnDefaults,
            flex: 1
        },
        {
            field: "data_source",
            headerName: "Data Source",
            ...columnDefaults,
            width: 195
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "max-h-[32rem] w-full",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
            rows: props.criteria,
            autoHeight: true,
            pagination: true,
            columns: columns,
            disableDensitySelector: true,
            initialState: {
                columns: {
                    columnVisibilityModel: {
                        // Hide these columns by default, the other columns will remain visible
                        evidence_order: false
                    }
                },
                filter: {
                    filterModel: {
                        items: []
                    }
                },
                sorting: {
                    sortModel: [
                        {
                            field: "status",
                            sort: "desc"
                        },
                        {
                            field: "evidence_order",
                            sort: "asc"
                        }
                    ]
                },
                pagination: {
                    paginationModel: {
                        pageSize: 5
                    }
                },
                density: "comfortable"
            },
            sx: {
                "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                    outline: "none"
                },
                ".dark & .MuiDataGrid-columnHeader": {
                    backgroundColor: "rgb(55 65 81)",
                    color: "#FFFFFF"
                }
            }
        })
    });
}
const $d66a7b68590573ac$var$valueGetterStatus = (criterion, questionIsExclusion)=>{
    if (criterion?.evidence && criterion?.question_id && !questionIsExclusion(criterion.question_id)) return 3;
    if (criterion?.evidence && criterion?.question_id && questionIsExclusion(criterion.question_id)) return 2;
    if (criterion?.evidence && !criterion?.question_id) return 1;
    if (!criterion?.evidence) return 0;
};
const $d66a7b68590573ac$var$renderCellStatus = (params)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "flex pl-2 justify-center",
        children: [
            params.value === 3 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "CheckCircleIcon",
                className: "h-4 text-green-800"
            }),
            params.value === 2 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "ExclamationCircleIcon",
                className: "h-4 text-red-700"
            }),
            params.value === 1 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "InformationCircleIcon",
                className: "h-4 text-yellow-400"
            }),
            params.value === 0 && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "QuestionMarkCircleIcon",
                className: "h-4 text-gray-400"
            })
        ]
    });


function $9f04834aa79dc178$export$8ac9c59ec2d82e90(props) {
    const questionIsExclusion = (question_id)=>props.questions.some((question)=>question.Question.id === question_id && question.StudyQuestion.exclusion_criteria);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "mt-4 p-6 pt-4 rounded-lg border border-gray-200 shadow-md bg-white dark:bg-transparent",
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "items-center min-h-5 mb-2",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex justify-between",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "ClipboardListIcon",
                                className: "text-gray-900 w-6 h-6 mr-1 dark:text-gray-400"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                className: "p-0 mr-2 text-xl font-bold text-gray-900 dark:text-white",
                                children: "Qualification Criteria"
                            })
                        ]
                    })
                }),
                props.confidenceScore && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "font-semibold mr-1 w-36 text-right",
                                    children: "Confidence Score:"
                                }),
                                props.confidenceScore
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: `mt-4 ${props?.criteria?.length > 0 ? "block" : "hidden"}`,
                    children: props?.criteria?.length && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d66a7b68590573ac$export$f9f288e41e259a8b), {
                            criteria: props?.criteria,
                            questionIsExclusion: questionIsExclusion
                        })
                    })
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


function $8d73f681972832d8$export$53620da69002b715(props) {
    const { question: question } = props;
    const { submitQuestionResponse: submitQuestionResponse } = (0, $f2Y41.useContext)((0, $a6bb6a5b7701de73$export$cb472a336c6d739d));
    const value = question?.StudyQuestionResponse?.response?.value;
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex w-36 items-center",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: `can-toggle can-toggle-rectangle ${question.StudyQuestion.exclusion_criteria ? "can-toggle-reverse-color" : ""}`,
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "",
                                onClick: ()=>submitQuestionResponse(question.StudyQuestion.id, true),
                                onKeyUp: ()=>submitQuestionResponse(question.StudyQuestion.id, true),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    outline: false,
                                    icon: "CheckCircleIcon",
                                    extraClasses: `w-8 h-8 hover:text-green-400 hover:cursor-pointer ${value === true ? "text-green-400" : ""}`
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "",
                                onClick: ()=>submitQuestionResponse(question.StudyQuestion.id, false),
                                onKeyUp: ()=>submitQuestionResponse(question.StudyQuestion.id, false),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    outline: false,
                                    icon: "XCircleIcon",
                                    extraClasses: `w-8 h-8 hover:text-red-400 hover:cursor-pointer ${value === false && value !== "" ? "text-red-400" : ""}`
                                })
                            }),
                            value === "unknown" && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "",
                                onClick: ()=>submitQuestionResponse(question.StudyQuestion.id, ""),
                                onKeyUp: ()=>submitQuestionResponse(question.StudyQuestion.id, ""),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    outline: false,
                                    icon: "QuestionMarkCircleIcon",
                                    extraClasses: `w-8 h-8 hover:cursor-pointer ${value === "unknown" ? "text-yellow-400 hover:text-gray-400" : ""}`
                                })
                            }),
                            value !== "unknown" && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "",
                                onClick: ()=>submitQuestionResponse(question.StudyQuestion.id, "unknown"),
                                onKeyUp: ()=>submitQuestionResponse(question.StudyQuestion.id, "unknown"),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    outline: false,
                                    icon: "QuestionMarkCircleIcon",
                                    extraClasses: `w-8 h-8 hover:cursor-pointer hover:text-yellow-400 ${!!value || value === "" ? "text-gray-600 " : ""}`
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "text-lg font-semibold",
                        children: question.Question.full_text
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "text-base font-normal",
                        children: [
                            question.Question.short_text,
                            " "
                        ]
                    })
                ]
            })
        ]
    });
}


function $49feddefbe49ae07$export$3e79b18f6355acc5(props) {
    const { question: question, registerResponseField: registerResponseField, criteria: criteria } = props;
    const questionCriteria = criteria?.filter((criterion)=>criterion.question_id === question.Question.id);
    if (question === undefined) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex justify-between items-center py-4",
                children: [
                    question.Question.question_type === "boolean" && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8d73f681972832d8$export$53620da69002b715), {
                        question: question
                    }),
                    question.Question.question_type === "text" && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex mr-4 items-center",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                        ...registerResponseField(question.StudyQuestion.id),
                                        type: "text",
                                        className: "w-32 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:bg-gray-700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-lg font-semibold text-gray-900 dark:text-gray-200",
                                        children: question.Question.full_text
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "text-base font-normal text-gray-900 dark:text-gray-200",
                                        children: [
                                            question.Question.short_text,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    question.Question.question_type === "single_option" && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex mr-4 items-center",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                        ...registerResponseField(question.StudyQuestion.id),
                                        className: "w-32 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:bg-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                            question.Question.allowed_values?.map((allowed_value)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                    children: allowed_value
                                                }, allowed_value))
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-lg font-semibold text-gray-900 dark:text-gray-200",
                                        children: question.Question.full_text
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "text-base font-normal text-gray-900 dark:text-gray-200",
                                        children: [
                                            question.Question.short_text,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    question.Question.question_type === "multi_option" && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex mr-4 items-center",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                        multiple: true,
                                        ...registerResponseField(question.StudyQuestion.id),
                                        className: "w-32 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:bg-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                            question.Question.allowed_values.map((allowed_value)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                    children: allowed_value
                                                }, allowed_value))
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-lg font-semibold ",
                                        children: question.Question.full_text
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "text-base font-normal",
                                        children: [
                                            question.Question.short_text,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: `ml-36 ${questionCriteria?.filter((criteria)=>!!criteria?.term).length > 0 && "mb-4"}`,
                children: questionCriteria?.filter((criteria)=>!!criteria?.term)?.map((criterion)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex items-center space-x-1",
                        children: [
                            criterion.evidence && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: question.StudyQuestion.exclusion_criteria ? "ExclamationCircleIcon" : "CheckCircleIcon",
                                className: `h-4 ${question.StudyQuestion.exclusion_criteria ? "text-red-700" : "text-green-800"}`
                            }),
                            !criterion.evidence && criterion.question_id && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "QuestionMarkCircleIcon",
                                className: "h-4 text-gray-400"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: criterion.evidence && (question.StudyQuestion.exclusion_criteria ? "text-red-700" : "text-green-800"),
                                children: [
                                    criterion.term,
                                    " - ",
                                    criterion.evidence || "Unknown",
                                    " ",
                                    criterion.evidence_value,
                                    " ",
                                    criterion.evidence_date && `on ${criterion.evidence_date}`,
                                    " "
                                ]
                            })
                        ]
                    }, criterion.id))
            })
        ]
    });
}





var $ge3KO = parcelRequire("ge3KO");


function $384ce9eed56eb4d4$export$218782237017539d(props) {
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const closeModal = ()=>{
        props.setBlockedCount(props.blockedCount + 1);
        props.closeModal();
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], closeModal);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 ml-12 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-appointment-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative ml-10 w-full h-full max-w-3xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold dark:text-white",
                                        children: "Select a criteria"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>closeModal(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                    children: "X Button"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "py-12 px-6 space-y-6",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "grid grid-cols-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "col-span-12 text-md",
                                        children: "Before leaving this chart, please select the disqualifying inclusion/exclusion criteria."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "items-center p-4 border-t border-gray-200 dark:border-gray-700 rounded-b",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        onClick: ()=>closeModal(),
                                        className: "text-white bg-topo-green hover:bg-topo-green-700 focus:ring-4 focus:ring-topo-green-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Ok"
                                    }),
                                    props.blockedCount > 1 && /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        onClick: ()=>{
                                            props.setBlockedCount(0);
                                            props.override();
                                        },
                                        className: "text-white bg-red-500 hover:bg-topo-red-500 focus:ring-4 focus:ring-red-600 font-medium rounded-lg text-sm mr-5 px-5 py-2.5 text-center",
                                        type: "submit",
                                        children: "Proceed anyway"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



const $f97b7c6e8ef8fdfe$export$3c350eb299d3f7ba = [
    "Patient unreachable or no-show",
    "Patient not interested in trial - distance",
    "Patient not interested in trial - safety concerns",
    "Patient not interested in trial - not available",
    "Patient not interested in trial - other",
    "Patient missing inclusion criteria",
    "Patient fails exclusion criteria - diagnosis",
    "Patient fails exclusion criteria - medication",
    "Patient fails exclusion criteria - other",
    "Patient enrolled in a different trial",
    "Doctor disqualified patient",
    "Patient unreliable",
    "Patient speaks another language not supported by trial or site staff",
    "Other"
];







// https://www.codemzy.com/blog/reactjs-debounce-hook

var $f2Y41 = parcelRequire("f2Y41");
// debounce function (defaults wait to .2 seconds)
const $c0d11346704ef515$var$debounce = (func, wait = 200)=>{
    let timeout; // for the setTimeout function and so it can be cleared
    function executedFunction(...args) {
        const later = ()=>{
            clearTimeout(timeout); // clears the timeout when the function is called
            func(...args); // calls the function
        };
        clearTimeout(timeout); // this clears the timeout each time the function is run again preventing later from running until we stop calling the function
        timeout = setTimeout(later, wait); // this sets the time out to run after the wait period
    }
    executedFunction.cancel = function() {
        clearTimeout(timeout); // clears the timeout
    };
    return executedFunction;
};
function $c0d11346704ef515$export$21805fee57372823(callback, delay = 1000, deps = []) {
    // debounce the callback
    const debouncedCallback = (0, $f2Y41.useCallback)($c0d11346704ef515$var$debounce(callback, delay), [
        delay,
        ...deps
    ]); // with the delay
    // clean up on unmount or dependency change
    (0, $f2Y41.useEffect)(()=>{
        return ()=>{
            debouncedCallback.cancel(); // cancel any pending calls
        };
    }, [
        delay,
        ...deps
    ]);
    // return the debounce function so we can use it
    return debouncedCallback;
}
var $c0d11346704ef515$export$2e2bcd8739ae039 = $c0d11346704ef515$export$21805fee57372823;





const $a6bb6a5b7701de73$export$cb472a336c6d739d = /*#__PURE__*/ (0, $f2Y41.createContext)({
    submitQuestionResponse: (studyQuestionId, responseValue)=>Promise
});
function $a6bb6a5b7701de73$export$d8bc8ed3a6095d17() {
    const { patientId: patientId, screenId: screenId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser, practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const screenIdRef = (0, $f2Y41.useRef)(screenId);
    if (!screenIdRef.current) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [keepDirtyScreen, setKeepDirtyScreen] = (0, $f2Y41.useState)(false);
    const queryClient = (0, $935108cabed32909$export$22e77b9572c4fded)();
    const { patient: patient, setCurrentStudyScreenId: setCurrentStudyScreenId, setCurrentStudyScreenName: setCurrentStudyScreenName, setContactModalOpen: setContactModalOpen, setScheduleInESourceModalOpen: setScheduleInESourceModalOpen, setIneligibleModalOpen: setIneligibleModalOpen, ineligibleModalOpen: ineligibleModalOpen, setContactDispositionOpen: setContactDispositionOpen } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { data: { data: screen }, isLoading: isLoadingScreen, refetch: mutateScreen } = (0, $d306139d1442c366$export$657be94be86c05b6)("screens", screenIdRef.current, {
        params: `practice_id=${practiceId}`
    });
    const { data: { data: practice } } = (0, $d306139d1442c366$export$657be94be86c05b6)("practices", practiceId);
    const { data: { data: practiceStudies } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("practice_studies");
    if (isLoadingScreen) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    const { data: criteria, isLoading: isLoadingCriteria } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("screen_qualification_criteria", `screen_id=${screenIdRef.current}&limit=200`);
    // get the screen questions and their responses
    const { data: { data: questions } } = (0, $d306139d1442c366$export$fe1f5548f487c066)("study_question_responses", `screen_id=${screenIdRef.current}`);
    const mutateStudyQuestionResponses = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                "study_question_responses",
                `screen_id=${screenIdRef.current}`
            ]
        });
    };
    const submitQuestionResponse = async (studyQuestionId, responseValue)=>{
        const study_question_response = {
            study_question_id: studyQuestionId,
            screen_id: screenIdRef.current,
            patient_id: patientId,
            response: {
                value: responseValue
            }
        };
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("study_question_responses", study_question_response, getAccessTokenSilently);
        // todo: optimistic mutate (provide the new value to the array)
        mutateStudyQuestionResponses();
        (0, $3d12054b9ed86c19$exports.toast).success("Saved");
    };
    const [savingQuestionIds, setSavingQuestionIds] = (0, $f2Y41.useState)([]);
    const [savingMeta, setSavingMeta] = (0, $f2Y41.useState)(false);
    const { data: usersData, isLoading: isLoadingUsers } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("users");
    const [users, setUsers] = (0, $f2Y41.useState)([]);
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingUsers) return;
        setUsers(usersData.filter((user)=>(0, $601cdae3149c9149$export$d540efe9354f0ccc)(user)));
        return ()=>{};
    }, [
        usersData,
        isLoadingUsers
    ]);
    // set up the response form
    const { register: registerResponseField, handleSubmit: handleSubmitResponses, watch: watchResponses, reset: resetResponses, formState: { dirtyFields: dirtyFields } } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        mode: "onChange"
    });
    // Helper function that gets loaded into a listener on component mount
    const handleVisibilityChange = async (event)=>{
        const eventName = document.visibilityState === "hidden" ? "ScreenStop" : "ScreenStart";
        const accessToken = await getAccessTokenSilently();
        const data = {
            name: eventName,
            meta: {
                practice_id: practiceId,
                patient_id: patientId,
                screen_id: screenIdRef.current
            }
        };
        fetch((0, $b2d06586a86d14b7$export$7138c24907de3954)("events"), {
            keepalive: true,
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify(data)
        });
    };
    // onMount function called from useEffect hook
    const onMount = ()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "ScreenStart",
            meta: {
                patient_id: patientId,
                screen_id: screenIdRef.current
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        const touchAndMutateScreen = async ()=>{
            // Send an update which also triggers updated_by_user_id
            await (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", screenIdRef.current, {}, getAccessTokenSilently);
            mutateScreen();
        };
        if (currentUser && !(0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser)) touchAndMutateScreen();
        window.addEventListener("visibilitychange", handleVisibilityChange);
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: Run once, on mount
    (0, $f2Y41.useEffect)(()=>{
        onMount();
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "ScreenStop",
                meta: {
                    patient_id: patientId,
                    screen_id: screenIdRef.current
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
            window.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []) //
    ;
    const assignAndMutateScreen = async ()=>{
        const previousUserId = screen.assigned_to_user_id;
        if (previousUserId === currentUser?.id) return;
        if ((0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser)) return;
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", screenIdRef.current, {
            assigned_to_user_id: currentUser?.id
        }, getAccessTokenSilently);
        resetScreen({
            assigned_to_user_id: currentUser?.id
        });
        (0, $3d12054b9ed86c19$exports.toast)("\u2705 Self Assigned");
        mutateScreen();
    };
    // When currentUser is ready, assign screen to currentUser and TOAST
    // biome-ignore lint/correctness/useExhaustiveDependencies: tbh i don't know how to specify the function as a dep
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingCurrentUser || isLoadingScreen) return;
        assignAndMutateScreen();
    }, [
        isLoadingCurrentUser,
        isLoadingScreen
    ]);
    const { register: registerScreen, handleSubmit: handleSubmitScreen, watch: watchScreen, reset: resetScreen, control: controlScreen, getValues: formValues, setValue: setFormValue } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const handleResetScreen = ()=>{
        resetScreen({
            id: screenIdRef.current,
            status: screen?.status,
            follow_up_dt: screen?.follow_up_dt,
            follow_up_reason: screen?.follow_up_reason,
            esource_xref_id: screen?.esource_xref_id,
            disqualification_reason: screen?.disqualification_reason,
            disqualification_detail: screen?.disqualification_detail,
            assigned_to_user_id: screen?.assigned_to_user_id,
            qa_feedback_detail: screen?.qa_feedback_detail
        }, {
            keepDirtyValues: keepDirtyScreen
        });
        setKeepDirtyScreen(true);
    };
    (0, $f2Y41.useEffect)(()=>{
        screenIdRef.current = screenId // Update the ref when screenId changes
        ;
        setKeepDirtyScreen(false);
    }, [
        screenId
    ]);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    // Adding a dependency on handleResetScreen somehow creates a circular dependency.
    // biome-ignore lint/correctness/useExhaustiveDependencies: Explanation above:
    (0, $f2Y41.useEffect)(()=>{
        if (!isLoadingScreen && !screen) {
            navigate("/patients");
            return;
        }
        if (Object.keys(screen)?.length === 0 || isLoadingScreen) return;
        handleResetScreen();
    }, [
        isLoadingScreen,
        screen,
        keepDirtyScreen
    ]);
    const submitQa = async (field, value)=>{
        await submitScreenUpdate({
            ...screen,
            [field]: value
        }, "QA");
    };
    const submitScreenUpdate = async (data, attribute)=>{
        // Don't save a screen.id, if the screen id and the current screenId don't match!
        if (data.id !== screenIdRef.current) return;
        if (data.assigned_to_user_id === "") data.assigned_to_user_id = null;
        setSavingMeta(true);
        await (0, $b2d06586a86d14b7$export$74524c73191a667c)("screens", screenIdRef.current, data, getAccessTokenSilently);
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: `ScreenUpdate${attribute}`,
            meta: {
                patient_id: patientId,
                screen_id: screenIdRef.current,
                assigned_to_user_id: data.assigned_to_user_id
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        mutateScreen();
        (0, $3d12054b9ed86c19$exports.toast).success("Saved");
        setSavingMeta(false);
    };
    const handleNextAppointmentClick = async (nextAppointmentDate)=>{
        setFormValue("follow_up_dt", (0, $0dcae3260236e0d2$export$9cc585672c9cb4ef)(nextAppointmentDate));
        submitScreenUpdate(formValues(), "FollowupDate");
    };
    const submitAssignedToUser = async (data)=>submitScreenUpdate(data, "AssignedUser");
    const submitStatus = async (data)=>{
        setFormValue("status", data.status);
        const formData = formValues();
        submitScreenUpdate(formData, "Status");
    };
    const submitEsourceId = async (data)=>submitScreenUpdate(data, "EsourceId");
    const submitDisqualificationReason = async (data)=>{
        submitScreenUpdate(data, "DisqualificationReason");
    };
    const submitDisqualificationDetail = async (data)=>submitScreenUpdate(data, "DisqualificationDetail");
    const submitQaFeedbackDetail = async (data)=>submitScreenUpdate(data, "QaFeedbackDetail");
    const submitFeedbackScore = async (data)=>{
        const scaledFeedbackScore = (Number.parseInt(data.feedback_score) - 1) * 25;
        submitScreenUpdate({
            id: screen.id,
            feedback_score: scaledFeedbackScore
        }, "FeedbackScore");
    };
    const submitFollowupDate = async (data)=>{
        data.follow_up_dt = (0, $0dcae3260236e0d2$export$9cc585672c9cb4ef)(data.follow_up_dt);
        submitScreenUpdate(data, "FollowupDate");
    };
    const submitFollowupReason = async (data)=>submitScreenUpdate(data, "FollowupReason");
    const handleBack = ()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "Click",
            meta: {
                element: "ScreenBackButton"
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        setCurrentStudyScreenId("");
        setCurrentStudyScreenName("");
    };
    const handleCallClick = ()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "CallPatientClick",
            meta: {
                patient_id: patientId,
                screen_id: screenIdRef.current
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        setContactDispositionOpen(true);
    };
    const handleValidation = (study_question_responses)=>{
        for (const study_question_id of Object.keys(study_question_responses)){
            const exclusion = questions.find((question)=>question.StudyQuestion.id === study_question_id).StudyQuestion.exclusion_criteria;
            if (exclusion && study_question_responses[study_question_id] === true && !ineligibleModalOpen) setIneligibleModalOpen(true);
        }
    };
    const debouncedSubmitDisqualificationDetail = (0, $c0d11346704ef515$export$2e2bcd8739ae039)(handleSubmitScreen(submitDisqualificationDetail), 500);
    const debouncedSubmitFollowupReason = (0, $c0d11346704ef515$export$2e2bcd8739ae039)(handleSubmitScreen(submitFollowupReason), 500);
    const debouncedSubmitESourceId = (0, $c0d11346704ef515$export$2e2bcd8739ae039)(handleSubmitScreen(submitEsourceId), 500);
    const debouncedSubmitQaFeedbackDetail = (0, $c0d11346704ef515$export$2e2bcd8739ae039)(handleSubmitScreen(submitQaFeedbackDetail), 500);
    (0, $f2Y41.useEffect)(()=>{
        // Guard if API data isn't back yet
        if (questions?.length === 0) return;
        // Map the questions data into something RHF can use for defaultValues
        // eg { 'f59019a0-f210-4749-8b7b-c08598309d02': true }
        const defaultValues = questions?.reduce((object, question)=>{
            object[question?.StudyQuestion.id] = question?.StudyQuestionResponse?.response?.value;
            return object;
        }, {});
        // Set up initial form defaultValues
        resetResponses(defaultValues);
    }, [
        questions,
        resetResponses
    ]);
    (0, $f2Y41.useEffect)(()=>{
        setCurrentStudyScreenName(screen?.study?.abbreviation);
    }, [
        screen,
        setCurrentStudyScreenName
    ]);
    const renderStatusIcon = (status)=>{
        const icon = (0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[status].icon;
        return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
            icon: icon,
            className: "h-8 w-8"
        });
    };
    const addToESourceHandleClick = ()=>{
        setScheduleInESourceModalOpen(true);
    };
    const currentScreenStatus = (status)=>{
        return (0, $17235661ec5f519b$export$b94aa994a2f01789)(status) === (0, $17235661ec5f519b$export$b94aa994a2f01789)(screen?.status);
    };
    const stars = ()=>{
        if (!screen?.feedback_score) return 0;
        // Bound within the range of 0 to 100
        const bounded = Math.max(0, Math.min(100, screen?.feedback_score));
        // Adjust to the nearest of 0, 25, 50, 75, 100
        const adjusted = Math.round(bounded / 25) * 25;
        // Map directly to 1-5 (0=1, 25=2, 50=3, 75=4, 100=5)
        return adjusted / 25 + 1;
    };
    const noResponses = questions?.filter((question)=>question?.StudyQuestionResponse)?.length === 0;
    // // Prevent navigation away if status is DQ and there isn't a screen_response
    const blocker = (0, $c5383ff45095a6a6$export$b273b3273281a049)(({ currentLocation: currentLocation, nextLocation: nextLocation })=>currentLocation.pathname !== nextLocation.pathname && screen?.status === "disqualified" && noResponses);
    const [blockedCount, setBlockedCount] = (0, $f2Y41.useState)(0);
    const esourceURL = ()=>{
        let url = "https://app.clinicalresearch.io/topography-health/";
        const practiceStudy = practiceStudies.filter((practiceStudy)=>practiceStudy.study_id === screen?.study_id)?.[0];
        if (screen?.esource_xref_id && practice?.xref_esource_practice_slug && practiceStudy?.xref_study_id) url = `${url}${practice.xref_esource_practice_slug}/study/${practiceStudy?.xref_study_id}/subject/${screen?.esource_xref_id}`;
        else if (practice?.xref_esource_practice_slug && practiceStudies?.[0]?.xref_study_id) url = `${url}${practice.xref_esource_practice_slug}/study/${practiceStudy?.xref_study_id}/subjects`;
        else if (practice?.xref_esource_practice_slug) url = `${url}${practice.xref_esource_practice_slug}/subjects`;
        return url;
    };
    const statusOptionsComponent = /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "grid grid-cols-11 justify-center space-x-1 mb-4 mx-2 py-1.5",
        children: [
            Object.keys((0, $dc67232e0e99ac39$export$41b4ed1d609e670b)).filter((status)=>screen?.status === "provider_referral" && status !== "assign" || screen?.status !== "provider_referral" && status !== "provider_referral").map((statusKey)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: `flex hover:cursor-pointer hover:border-gray-700 ${screen?.esource_status ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"} text-gray-600 dark:text-gray-400 ${screen?.esource_status ? "" : "hover:dark:text-gray-600"}
            ${currentScreenStatus(statusKey) ? `${(0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[statusKey].bgColor} hover:cursor-default  dark:text-gray-700` : "hover:bg-gray-50 hover:dark:text-gray-600 hover:border-gray-700 hover:cursor-pointer"}
            ${currentScreenStatus(statusKey) ? (0, $dc67232e0e99ac39$export$41b4ed1d609e670b)[statusKey].borderColor : ""}
            border-2 rounded-lg lg:h-32 pt-2 xl:h-24 md:pt-0 items-center justify-center place-items-center`,
                    onKeyDown: screen?.esource_status ? undefined : ()=>handleSubmitScreen(()=>submitStatus({
                                status: statusKey
                            })),
                    onClick: screen?.esource_status ? undefined : handleSubmitScreen(()=>submitStatus({
                            status: statusKey
                        })),
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex flex-col items-center",
                        children: [
                            renderStatusIcon(statusKey),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                className: `text-center h-10 mt-1 text-sm font-semibold ${statusKey === "disqualified" ? "text-xs 2xl:text-sm" : ""}`,
                                children: (0, $17235661ec5f519b$export$b94aa994a2f01789)(statusKey)
                            })
                        ]
                    })
                }, statusKey)),
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $34ede4a4a21f9915$export$25c8cd19dc067a8d), {
                isShowing: savingMeta
            })
        ]
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            blocker.state === "blocked" && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $384ce9eed56eb4d4$export$218782237017539d), {
                closeModal: blocker?.reset,
                override: blocker.proceed,
                setBlockedCount: setBlockedCount,
                blockedCount: blockedCount
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex px-4 pt-2 items-center bg-white dark:bg-transparent border-l border-r border-gray-200",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                    to: `/patients/${patientId}/screens`,
                    className: "text-sm flex items-center hover:underline",
                    onClick: ()=>handleBack(),
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "ArrowSmLeftIcon",
                            className: "h-5 w-5"
                        }),
                        "Back to all studies"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "border-l border-r border-b rounded-b-lg shadow-md py-2 bg-white dark:bg-transparent",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "px-3 pt-2 justify-start w-full items-center",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "font-bold pl-1 text-lg",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        "Next Step Potential",
                                        " ",
                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                            placement: "top",
                                            content: "1 = Low likelihood of moving past next step. 5 = High likelihood of moving past next step.",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "InformationCircleIcon",
                                                className: "h-5 ml-2",
                                                outline: true
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex w-1/5 pl-0.5",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                                    onChange: handleSubmitScreen(submitFeedbackScore),
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                        control: controlScreen,
                                        name: "feedback_score",
                                        // rules={{
                                        //   validate: (rating) => rating > 0,
                                        // }}
                                        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value } })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $26c19916d84eefae$export$8ba663d22f9191ae), {
                                                className: "h-7",
                                                value: stars(),
                                                isRequired: true,
                                                onChange: (stars)=>submitFeedbackScore({
                                                        feedback_score: stars
                                                    }),
                                                visibleLabelId: "rating_label",
                                                onBlur: onBlur
                                            })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                        className: "p-0 mt-6 ml-4 mr-2 text-lg font-bold text-gray-900 dark:text-white flex items-center",
                        children: [
                            "Status",
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "ml-2 mt-0.5",
                                children: screen?.status_updated_at && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        title: screen?.status_updated_at,
                                        className: "font-normal text-xs text-gray-500",
                                        children: (0, $48358001e7c1220f$exports.upperCaseFirst)((0, $0dcae3260236e0d2$export$328aec9e3e2287e0)(screen?.status_updated_at))
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex flex-1 items-center ml-4",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                className: "block mr-1 font-bold text-md",
                                children: "ESource Status"
                            }),
                            screen?.esource_status ? /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                className: "text-lg text-gray-500 px-3",
                                children: (0, $17235661ec5f519b$export$b94aa994a2f01789)(screen?.esource_status)
                            }) : /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                content: "Add the CRIO ID below to track ESource Status.",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                    className: "text-lg text-gray-300 px-3",
                                    children: "Unknown"
                                })
                            })
                        ]
                    }),
                    screen?.esource_status ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                        content: "Status changes disabled, once patient status is tracked in Esource.",
                        children: statusOptionsComponent
                    }) : statusOptionsComponent,
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex ml-6 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                    onChange: handleSubmitScreen(submitAssignedToUser),
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                            className: "mr-2 font-bold text-md",
                                            children: "Assigned to"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                            ...registerScreen("assigned_to_user_id"),
                                            className: "w-80 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-lg hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                    value: "",
                                                    children: "None"
                                                }),
                                                users.map((user, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                        value: user.id,
                                                        className: "",
                                                        children: user.name
                                                    }, user.id))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                    onSubmit: handleSubmitScreen(submitFollowupDate),
                                    onChange: handleSubmitScreen(submitFollowupDate),
                                    className: "ml-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                            className: "mr-2 font-bold text-md",
                                            children: "Due (Follow-Up Date)"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                    name: "follow_up_dt",
                                                    control: controlScreen,
                                                    defaultValue: screen?.follow_up_dt && (0, $0dcae3260236e0d2$export$3573c25f30e0099d)(new Date(`${screen?.follow_up_dt}Z`)),
                                                    render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                            ...field,
                                                            type: "datetime-local",
                                                            value: screen?.follow_up_dt && (0, $0dcae3260236e0d2$export$3573c25f30e0099d)(new Date(`${screen?.follow_up_dt}Z`)),
                                                            sx: {
                                                                display: "flex",
                                                                padding: "0",
                                                                input: {
                                                                    fontSize: "0.9rem",
                                                                    padding: "0.8rem 0.9rem"
                                                                },
                                                                width: 250,
                                                                boxShadow: "none"
                                                            },
                                                            InputProps: {
                                                                classes: {
                                                                    input: "text-sm dark:border dark:rounded dark:border-solid dark:hover:border-gray-600 dark:hover:border-solid dark:hover:rounded"
                                                                }
                                                            },
                                                            InputLabelProps: {
                                                                shrink: true
                                                            }
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "flex items-center ml-2",
                                                    children: [
                                                        "(",
                                                        (0, $0dcae3260236e0d2$export$11aaca13b5be2907)(),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "mx-4 w-full",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                    onBlur: debouncedSubmitFollowupReason,
                                    onChange: debouncedSubmitFollowupReason,
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        handleSubmitScreen(submitFollowupReason);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                            className: "mr-2 font-bold text-md",
                                            children: "Follow Up Reason"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                ...registerScreen("follow_up_reason"),
                                                type: "text",
                                                name: "follow_up_reason",
                                                id: "follow_up_reason",
                                                className: "shadow-sm border border-gray-300 dark:hover:border-gray-600 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 dark:bg-gray-800 dark:border-gray-300 dark:placeholder-gray-800 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 hover:border-gray-800"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "flex ml-6 text-gray-500",
                        children: [
                            screen?.updated_at && screen?.updated_by && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "w-80 items-center mb-2 ",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("h4", {
                                        className: "mr-1 font-bold text-md",
                                        children: [
                                            "Updated",
                                            " ",
                                            (0, $48358001e7c1220f$exports.upperCaseFirst)((0, $0dcae3260236e0d2$export$a4b1ac1b7ff01dbc)(screen?.updated_at))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                        className: "font-normal text-md",
                                        title: screen?.updated_at,
                                        children: [
                                            (0, $48358001e7c1220f$exports.upperCaseFirst)((0, $0dcae3260236e0d2$export$de04ca861cf68a2e)(screen?.updated_at)),
                                            " by",
                                            " ",
                                            screen?.updated_by.name || " "
                                        ]
                                    })
                                ]
                            }),
                            (0, $7b97d39664d4afa2$export$bf33624c422fae94)(patient) && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "items-center ml-4 mb-2",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                    content: "Click to set Next Appointment as Follow Up Date.",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "hover:cursor-pointer",
                                        onClick: ()=>handleNextAppointmentClick((0, $7b97d39664d4afa2$export$db0cfc301188f132)(patient)),
                                        onKeyDown: ()=>handleNextAppointmentClick((0, $7b97d39664d4afa2$export$db0cfc301188f132)(patient)),
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                                className: "mr-1 font-bold text-md",
                                                children: " Next Appointment "
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                className: "font-normal text-md",
                                                children: (0, $7b97d39664d4afa2$export$b3533743d5383aa9)(patient)
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("hr", {
                        className: "my-4 m-auto w-[97%]"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: `${screen?.status === "disqualified" ? "block" : "hidden"} w-full items-center mb-2`,
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex w-full my-2 ml-2",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "flex items-center mx-4 space-x-2 justify-start  w-[19.65%]",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "rounded-lg border-2 border-red-700 bg-red-300 ",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: "ExclamationIcon",
                                                    className: "h-8 w-8"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                                className: "text-red-500 font-bold text-md",
                                                children: "Reason for Disqualification"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                                        onChange: handleSubmitScreen(submitDisqualificationReason),
                                        className: screen?.status === "disqualified" ? "flex w-[75%]" : "hidden w-[75%]",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                            ...registerScreen("disqualification_reason"),
                                            className: "w-full rounded-md border-2 border-red-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                    disabled: true,
                                                    value: "",
                                                    children: "Select a reason"
                                                }),
                                                (0, $f97b7c6e8ef8fdfe$export$3c350eb299d3f7ba).map((reason)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                        value: reason,
                                                        className: "",
                                                        children: reason
                                                    }, (0, $17235661ec5f519b$export$cc8b315fc368b20a)(reason)))
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex w-full my-2 ml-2",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "flex items-center mx-4 space-x-2 justify-start w-[19.65%]",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "rounded-lg border-2",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: "DocumentTextIcon",
                                                    outline: true,
                                                    className: "h-8 w-8"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                                className: "w-full font-bold text-md",
                                                children: "Disqualification Detail"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                                        onBlur: debouncedSubmitDisqualificationDetail,
                                        onChange: debouncedSubmitDisqualificationDetail,
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            handleSubmitScreen(submitDisqualificationDetail);
                                        },
                                        className: "w-[75%] flex",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                            type: "text",
                                            ...registerScreen("disqualification_detail"),
                                            className: "flex-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: `${[
                            "moved_to_esource",
                            "schedule_for_screen"
                        ].includes(screen?.status) ? "flex items-center" : "hidden"} items-center mb-2`,
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex items-center px-6",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "flex flex-1",
                                        children: [
                                            screen?.esource_xref_id && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                                                    to: esourceURL(),
                                                    target: "_blank",
                                                    title: esourceURL(),
                                                    className: "text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-sm px-2.5 py-1.5 text-center inline-flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                            icon: "ExternalLinkIcon",
                                                            className: "fill-white w-4 h-4 mr-2 flex"
                                                        }),
                                                        screen?.esource_xref_id && practice?.xref_esource_practice_slug && practiceStudies.filter((practiceStudy)=>practiceStudy.study_id === screen?.study_id)?.[0]?.xref_study_id ? "View in Esource" : "Open Esource"
                                                    ]
                                                })
                                            }),
                                            !screen?.esource_xref_id && /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                type: "button",
                                                onClick: addToESourceHandleClick,
                                                onKeyDown: addToESourceHandleClick,
                                                className: "text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-sm px-2.5 py-1.5 text-center inline-flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "PlusCircleIcon",
                                                        className: "fill-white w-4 h-4 mr-2 rotate-90"
                                                    }),
                                                    "Add to eSource"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "px-6 flex dark:bg-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "flex w-24 items-center",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                            content: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $17021bae4f231a31$export$ac6721e55877afc3), {}),
                                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex h-full items-center pr-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                                        className: "block mr-1 font-bold text-md",
                                                        children: "CRIO ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        className: "h-5 w-5",
                                                        icon: "InformationCircleIcon"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                                        onBlur: debouncedSubmitESourceId,
                                        onChange: debouncedSubmitESourceId,
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                            ...registerScreen("esource_xref_id"),
                                            type: "text",
                                            name: "esource_xref_id",
                                            id: "esource_xref_id",
                                            className: "w-36 shadow-sm border border-gray-300 dark:hover:border-gray-600 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-800 dark:border-gray-300 dark:placeholder-gray-800 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 hover:border-gray-800"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $601cdae3149c9149$export$3fc5baa28a2e276c)(currentUser) && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-4 p-6 pt-4 rounded-lg border border-gray-200 shadow-md bg-white dark:bg-transparent",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "items-center min-h-5 mb-2",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "flex justify-between",
                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                        icon: "CheckCircleIcon",
                                        className: "text-gray-900 w-6 h-6 mr-1 dark:text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "p-0 text-xl font-bold text-gray-900 dark:text-white",
                                        children: "Quality Assurance"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "mb-2 text-xs ml-7 w-full items-center",
                                    children: "Result of QA chart review"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex w-full items-center space-x-4 ml-7 justify-start",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            className: `inline-flex items-center px-4 py-2 border-2 border-gray-100 shadow-sm text-sm leading-4 font-medium rounded-md hover:border-green-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent  ${screen?.qa_status === "no_quality_issue" ? "text-green-700 bg-green-400 outline-none ring-2 ring-offset-2 ring-green-500 dark:bg-green-400" : ""}}`,
                                            onClick: ()=>submitQa("qa_status", "no_quality_issue"),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "mr-1",
                                                    children: "Agree"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    extraClasses: "text-green-700",
                                                    icon: "ThumbUpIcon"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            className: `inline-flex items-center px-4 py-2 border-2 border-gray-100 shadow-sm text-sm leading-4 font-medium rounded-md hover:border-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent ${screen?.qa_status === "quality_issue" ? "text-red-700 bg-red-400 outline-none ring-2 ring-offset-2 ring-red-500 dark:bg-red-400" : ""}}`,
                                            onClick: ()=>submitQa("qa_status", "quality_issue"),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "mr-1",
                                                    children: "Disagree"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    extraClasses: "text-red-700",
                                                    icon: "ThumbDownIcon"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "flex items-center w-full",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "ml-4 w-[50%]",
                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                                    className: "flex flex-row",
                                                    onBlur: debouncedSubmitQaFeedbackDetail,
                                                    onChange: debouncedSubmitQaFeedbackDetail,
                                                    onSubmit: (e)=>{
                                                        e.preventDefault();
                                                        handleSubmitScreen(submitQaFeedbackDetail);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                            className: "flex items-center ",
                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                                                className: "mr-2 font-bold text-sm",
                                                                children: "QA Feedback"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                            ...registerScreen("qa_feedback_detail"),
                                                            type: "text",
                                                            name: "qa_feedback_detail",
                                                            id: "qa_feedback_detail",
                                                            className: "w-full shadow-sm border border-gray-300 dark:hover:border-gray-600 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-800 dark:border-gray-300 dark:placeholder-gray-800 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 hover:border-gray-800"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            criteria && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9f04834aa79dc178$export$8ac9c59ec2d82e90), {
                screenId: screenId,
                criteria: criteria,
                questions: questions,
                confidenceScore: screen?.confidence_score
            }),
            screen?.study?.call_script && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-4 p-6  rounded-lg border border-gray-200 shadow-md",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex justify-between",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "text-xl font-bold",
                            children: "Call Script"
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "mt-2",
                        children: screen?.study?.call_script
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-4 p-6  rounded-lg border border-gray-200 shadow-md bg-white dark:bg-transparent",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                        className: "text-xl font-bold mb-4 ",
                        children: "Screening Questions"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)($a6bb6a5b7701de73$export$cb472a336c6d739d.Provider, {
                        value: {
                            submitQuestionResponse: submitQuestionResponse
                        },
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                className: "text-l font-bold ",
                                children: "Inclusion Criteria"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                className: "text-sm font-normal text-gray-500 dark:text-gray-200",
                                children: [
                                    "The answer to ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "font-medium",
                                        children: "all"
                                    }),
                                    " of these question must be ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "text-green-500",
                                        children: "yes"
                                    }),
                                    " for the patient to be ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "text-green-500",
                                        children: "eligible"
                                    }),
                                    " for the trial.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "divide-y divide-gray-200 dark:divide-gray-700",
                                children: questions?.filter((question)=>question?.StudyQuestion?.exclusion_criteria === false).map((question, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $49feddefbe49ae07$export$3e79b18f6355acc5), {
                                        question: question,
                                        screenId: screenId,
                                        patientId: patientId,
                                        registerResponseField: registerResponseField,
                                        mutateStudyQuestionResponses: mutateStudyQuestionResponses,
                                        criteria: criteria
                                    }, question?.StudyQuestion?.id))
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("h4", {
                                className: "mt-4 text-l font-bold ",
                                children: "Exclusion Criteria"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                                className: "text-sm font-normal text-gray-500 dark:text-gray-200",
                                children: [
                                    "If the answer to ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "font-medium",
                                        children: "any"
                                    }),
                                    " of these questions is ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "text-red-500",
                                        children: "yes"
                                    }),
                                    ", this patient is ",
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                        className: "text-red-500",
                                        children: "ineligible"
                                    }),
                                    " for the trial."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "divide-y divide-gray-200 dark:divide-gray-700",
                                children: questions?.filter((question)=>question?.StudyQuestion?.exclusion_criteria === true).map((question, index)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $49feddefbe49ae07$export$3e79b18f6355acc5), {
                                        question: question,
                                        screenId: screenId,
                                        patientId: patientId,
                                        registerResponseField: registerResponseField,
                                        mutateStudyQuestionResponses: mutateStudyQuestionResponses,
                                        criteria: criteria
                                    }, question?.StudyQuestion?.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");






var $ge3KO = parcelRequire("ge3KO");
function $63d0624e3c0bc1b3$export$7d2c18701b008670(props) {
    let color = "";
    switch(props.status){
        case "Contracting":
            color = "gray";
            break;
        case "Enrolling":
            color = "green";
            break;
        case "Active":
            color = "topo-navy";
            break;
        case "Closed":
            color = "red";
            break;
        default:
            color = "blue";
            break;
    }
    return /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
        className: `bg-${color}-100 text-${color}-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md whitespace-nowrap hover:cursor-default`,
        children: props.text || "Unknown"
    });
}



function $4d07e896af6412f4$export$b3f6fef6b43a778c(props) {
    const columnDefaults = {
        width: 150,
        headerClassName: "bg-gray-100 text-gray-500",
        display: "flex"
    };
    const columns = [
        {
            field: "study",
            headerName: "Study",
            ...columnDefaults,
            width: 225,
            renderCell: (params)=>$4d07e896af6412f4$var$renderCellStudy(params, props.handleScreenNavigate, props.handleScreenStart)
        },
        {
            field: "assigned_to",
            headerName: "Assigned",
            ...columnDefaults,
            width: 225,
            renderCell: (params)=>$4d07e896af6412f4$var$renderCellAssigned(params)
        },
        {
            field: "last_updated",
            headerName: "Last Updated",
            ...columnDefaults,
            valueGetter: (value, row, column, apiRef)=>row.updated_at,
            renderCell: $4d07e896af6412f4$var$renderCellLastUpdated
        },
        {
            field: "indications",
            headerName: "Indications",
            ...columnDefaults,
            valueGetter: (value, row, column, apiRef)=>row.study?.indications?.map((indication)=>indication.name).join(", "),
            renderCell: $4d07e896af6412f4$var$renderCellIndications
        },
        {
            field: "study_status",
            headerName: "Study Status",
            ...columnDefaults,
            width: 175,
            valueGetter: (value, row, column, apiRef)=>row?.status,
            renderCell: $4d07e896af6412f4$var$renderCellStudyStatus
        },
        {
            field: "actions",
            headerName: "Actions",
            ...columnDefaults,
            flex: 1,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params)=>$4d07e896af6412f4$var$renderCellActions(params, props.handleScreenNavigate, props.handleScreenStart)
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex h-screen",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "flex-grow",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                rows: props.screens,
                columns: columns,
                disableDensitySelector: true,
                onCellDoubleClick: (params, event)=>{
                    event.defaultMuiPrevented = true;
                    params.row.screen_id ? props.handleScreenNavigate(params.row.screen_id, params.row.study.abbreviation) : props.handleScreenStart(params.row.study_id);
                },
                initialState: {
                    filter: {
                        filterModel: {
                            items: [
                                {
                                    field: "study_status",
                                    operator: "isAnyOf",
                                    value: [
                                        "enrolling",
                                        "active"
                                    ]
                                }
                            ]
                        }
                    },
                    columns: {
                        columnVisibilityModel: {
                            // Hide these columns by default, the other columns will remain visible
                            indications: false
                        }
                    },
                    density: "comfortable"
                },
                sx: {
                    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                        outline: "none"
                    },
                    ".dark & .MuiDataGrid-columnHeader": {
                        backgroundColor: "rgb(55 65 81)",
                        color: "#FFFFFF"
                    }
                }
            })
        })
    });
}
function $4d07e896af6412f4$var$renderCellStudyStatus(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $63d0624e3c0bc1b3$export$7d2c18701b008670), {
        text: props.value,
        status: props.value
    });
}
function $4d07e896af6412f4$var$renderCellAssigned(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-sm font-medium",
        children: props.value?.name || "None"
    });
}
function $4d07e896af6412f4$var$renderCellIndications(props) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
        className: "bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md",
        children: props.value || "Unknown"
    });
}
function $4d07e896af6412f4$var$renderCellLastUpdated(props) {
    if (!props.row.screen_id) return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-xs",
        children: "Not Started"
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "text-xs whitespace-nowrap dark:text-gray-40",
        title: props.row.updated_at,
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                className: "",
                children: (0, $48358001e7c1220f$exports.upperCaseFirst)((0, $0dcae3260236e0d2$export$328aec9e3e2287e0)(props.row.updated_at))
            }),
            props.row.updated_by && /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                className: "",
                children: props.row.updated_by.name
            })
        ]
    });
}
function $4d07e896af6412f4$var$renderCellStudy(params, handleScreenNavigate, handleScreenStart) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
        to: "#",
        className: "text-sm font-medium hover:cursor-pointer w-full flex-col",
        onClick: ()=>params.row?.screen_id ? handleScreenNavigate(params.row.screen_id, params.row.screen?.abbreviation) : handleScreenStart(params.row.study_id),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da10e49b852b9347$export$55c72165ec0b2743), {
            text: params.row.study?.abbreviation?.substring(0, 13),
            status: params.row?.screen_status,
            tooltipPlacement: "right"
        })
    });
}
function $4d07e896af6412f4$var$renderCellActions(props, handleScreenNavigate, handleScreenStart) {
    if (!props.row?.study_id) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: "..."
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
        type: "button",
        onClick: ()=>props.row?.screen_id ? handleScreenNavigate(props.row.screen_id, props.row.abbreviation) : handleScreenStart(props.row.study_id),
        className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
        children: [
            props.row?.screen_id ? "Continue" : "Start",
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "ArrowCircleRightIcon",
                className: "ml-1 w-5 h-5 flex"
            })
        ]
    });
}
function $4d07e896af6412f4$var$getActions(params, handleScreenNavigate, handleScreenStart) {
    return [
        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
            type: "button",
            onClick: ()=>{},
            className: "bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-white text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            children: [
                "Continue Screen",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        }, params.id)
    ];
}


function $1755fd208e56253a$export$8b567e04a6e27d40() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { setCurrentStudyScreenName: setCurrentStudyScreenName, setCurrentStudyScreenId: setCurrentStudyScreenId, currentStudyScreenId: currentStudyScreenId } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { data: started_screens, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("screens", `patient_id=${patientId}`);
    const { data: practice_studies } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const { handleSubmit: handleSubmit, register: register, reset: reset, setValue: setValue, control: control } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const [addingScreen, setAddingScreen] = (0, $f2Y41.useState)(false);
    const [newScreenStudyId, setNewScreenStudyId] = (0, $f2Y41.useState)("");
    const [unscreenedStudies, setUnscreenedStudies] = (0, $f2Y41.useState)([]);
    const [screens, setScreens] = (0, $f2Y41.useState)([]);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    (0, $f2Y41.useEffect)(()=>{
        let meta = {
            patient_id: patientId
        };
        if (currentStudyScreenId) meta = {
            ...meta,
            study_id: currentStudyScreenId
        };
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientScreensViewStart",
            meta: meta,
            getAccessTokenSilently: getAccessTokenSilently
        });
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientScreensViewEnd",
                meta: meta,
                getAccessTokenSilently: getAccessTokenSilently
            });
        };
    }, [
        currentStudyScreenId,
        getAccessTokenSilently,
        patientId
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (practice_studies.length === 0) return;
        const combinedScreens = practice_studies.slice();
        for (const screen of started_screens){
            const study_index = combinedScreens.findIndex((practice_study)=>practice_study.study_id === screen?.study_id);
            if (study_index !== -1) {
                combinedScreens[study_index].screen_id = screen?.id;
                combinedScreens[study_index].screen_status = screen?.status;
            }
        }
        setScreens(combinedScreens);
    }, [
        practice_studies,
        started_screens
    ]);
    const handleScreenNavigate = (screen_id, screen_abbreviation = "")=>{
        setCurrentStudyScreenName(screen_abbreviation);
        setCurrentStudyScreenId(screen_id);
        navigate(`/patients/${patientId}/screens/${screen_id}`);
    };
    const handleScreenStart = async (study_id)=>{
        if (!study_id) return;
        const data = {
            study_id: study_id,
            patient_id: patientId,
            practice_id: practiceId,
            status: "chart_review"
        };
        const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("screens", data, getAccessTokenSilently);
        const id = response?.data?.data?.id;
        if (id) handleScreenNavigate(id);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-4 rounded-b-lg shadow-md bg-white dark:bg-transparent border-l border-r border-b border-gray-200",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex justify-between items-center",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                        className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                        children: "Studies"
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4d07e896af6412f4$export$b3f6fef6b43a778c), {
                    patientId: patientId,
                    screens: screens,
                    handleScreenNavigate: handleScreenNavigate,
                    handleScreenStart: handleScreenStart
                })
            ]
        })
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");
var $904bcaae8d9a3375$exports = {};

$904bcaae8d9a3375$exports = function(e) {
    var t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, r.t = function(e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
}([
    function(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var n = r(1);
        Object.defineProperty(t, "default", {
            enumerable: !0,
            get: function() {
                var e;
                return (e = n, e && e.__esModule ? e : {
                    default: e
                }).default;
            }
        });
    },
    function(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var n = a(r(2)), o = a(r(3)), u = r(6);
        function a(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var l = function(e) {
            var t = e.className, r = e.style, o = function(e, t) {
                var r = {};
                for(var n in e)t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                return r;
            }(e, [
                "className",
                "style"
            ]);
            return n.default.createElement("span", {
                className: t,
                style: r
            }, (0, u.pluralize)(o));
        };
        l.propTypes = {
            singular: o.default.string.isRequired,
            plural: o.default.string,
            count: o.default.number,
            showCount: o.default.bool,
            className: o.default.string,
            style: o.default.object,
            zero: o.default.string
        }, l.defaultProps = {
            count: 1,
            showCount: !0,
            className: null,
            style: {},
            zero: null
        }, t.default = l;
    },
    function(e, t) {
        e.exports = (parcelRequire("f2Y41"));
    },
    function(e, t, r) {
        e.exports = r(4)();
    },
    function(e, t, r) {
        "use strict";
        var n = r(5);
        function o() {}
        function u() {}
        u.resetWarningCache = o, e.exports = function() {
            function e(e, t, r, o, u, a) {
                if (a !== n) {
                    var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw l.name = "Invariant Violation", l;
                }
            }
            function t() {
                return e;
            }
            e.isRequired = e;
            var r = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: u,
                resetWarningCache: o
            };
            return r.PropTypes = r, r;
        };
    },
    function(e, t, r) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    function(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.pluralize = void 0;
        var n = r(7);
        t.pluralize = n.pluralize;
    },
    function(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        t.pluralize = function(e) {
            var t = e.singular, r = e.plural, n = e.count, o = e.showCount, u = e.zero;
            if (0 === n && u) return u;
            var a = t;
            return 1 !== n && (a = r || t + "s"), o ? n + " " + a : a;
        };
    }
]);






var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");






function $56360fd7741baf4f$export$5fedfe9ea853f16(props) {
    const { event: event } = props;
    const [expanded, setExpanded] = (0, $f2Y41.useState)(false);
    const [timelineEventId, setTimelineEventId] = (0, $f2Y41.useState)("");
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: { data: timelineEventDetail }, isLoading: isLoading, isError: isError } = (0, $d306139d1442c366$export$657be94be86c05b6)("patient_timeline_events", timelineEventId, {
        params: `practice_id=${practiceId}`
    }, {
        enabled: timelineEventId !== ""
    });
    const handleExpandClick = ()=>{
        setTimelineEventId(event.id);
        setExpanded(true);
    };
    const handleCollapseClick = ()=>{
        setExpanded(false);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
        className: "flex flex-row justify-between items-start border-b pb-4 flex-grow",
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex items-center basis-1/5",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                        content: event?.event_created_by_user_name || "Unknown User",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2a0b772244d08cba$export$e2255cf6045e8d47), {
                            name: event?.event_created_by_user_name
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "ml-2",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "font-bold",
                                children: event?.created_by_user_id
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "font-semibold",
                                children: event?.event_created_by_user_name || "Unknown User"
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                content: (0, $0dcae3260236e0d2$export$709bb038489fb0)(event?.event_created_at),
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "text-xs",
                                    children: (0, $48358001e7c1220f$exports.titleCase)((0, $0dcae3260236e0d2$export$328aec9e3e2287e0)(event?.event_created_at))
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "font-normal text-sm flex-1 pr-4 pt-1",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "",
                        children: event?.event_description
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "font-normal mt-2",
                        children: expanded && timelineEventDetail && Object.entries(timelineEventDetail).map(([key, value])=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                children: [
                                    (0, $17235661ec5f519b$export$b94aa994a2f01789)(key),
                                    ": ",
                                    value
                                ]
                            }, key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "flex hidden",
                children: [
                    !expanded && /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                        type: "button",
                        className: "hover:cursor-pointer rounded-xl pt-[0.5px] bg-gray-200 dark:text-gray-700",
                        onClick: handleExpandClick,
                        onKeyUp: handleExpandClick,
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "ChevronDownIcon"
                        })
                    }),
                    expanded && /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                        type: "button",
                        className: "hover:cursor-pointer rounded-xl pt-[0.5px] bg-gray-200 dark:text-gray-700",
                        onClick: handleCollapseClick,
                        onKeyUp: handleCollapseClick,
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                            icon: "ChevronUpIcon"
                        })
                    })
                ]
            })
        ]
    });
}


function $a6f8884356347f45$export$108210b9140dbc1e() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: { data: timelineEvents }, isLoading: isLoading, isError: isError } = (0, $d306139d1442c366$export$fe1f5548f487c066)("patient_timeline_events", `patient_id=${patientId}`);
    const [filterModel, setFilterModel] = (0, $f2Y41.useState)("all");
    const toolbarButtonStyle = "inline-flex items-center p-4 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-topo-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800";
    const toolbarButtonGroupStyle = "inline-flex items-center px-4 py-2 shadow-sm text-sm leading-4 font-medium [&.active]:bg-topo-navy [&.active]:text-white [&.active]:border-transparent hover:bg-gray-400 hover:text-white focus:outline-none focus:ring-offset-2 focus:ring-blue-800";
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "p-4 rounded-b-lg shadow-md bg-white dark:bg-transparent border-l border-r border-b border-gray-200",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex flex-grow",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex-grow",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "filter-bar flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "button-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            className: `${toolbarButtonGroupStyle} rounded-l-md border ${filterModel === "all" ? "bg-topo-navy hover:bg-topo-navy text-gray-100" : ""}`,
                                            onClick: ()=>setFilterModel("all"),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: `rounded-lg  ${filterModel === "all" ? "text-gray-800 bg-white" : "bg-gray-200"} py-1 px-1.5 mr-2`,
                                                    children: timelineEvents?.total_event_count
                                                }),
                                                "All Changes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            className: `${toolbarButtonGroupStyle} border-l-0 border ${filterModel === "Contact" ? "bg-topo-navy hover:bg-topo-navy text-gray-100" : ""}`,
                                            onClick: ()=>setFilterModel("Contact"),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: `rounded-lg  ${filterModel === "Contact" ? "text-gray-800 bg-white" : "bg-gray-200"} dark:text-gray-700 py-1 px-1.5 mr-2`,
                                                    children: timelineEvents?.events?.filter((event)=>event.event_reference_model === "Contact").length
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($904bcaae8d9a3375$exports))), {
                                                    singular: "Contact",
                                                    count: timelineEvents?.events?.filter((event)=>event.event_reference_model === "PatientComment").length,
                                                    showCount: false
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            className: `${toolbarButtonGroupStyle} rounded-r-md border border-l-0 ${filterModel === "PatientComment" ? "bg-topo-navy hover:bg-topo-navy text-gray-100" : ""}`,
                                            onClick: ()=>setFilterModel("PatientComment"),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: `rounded-lg  ${filterModel === "PatientComment" ? "text-gray-800 bg-white" : "bg-gray-200"} dark:text-gray-700 py-1 px-1.5 mr-2`,
                                                    children: timelineEvents?.events?.filter((event)=>event.event_reference_model === "PatientComment").length
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($904bcaae8d9a3375$exports))), {
                                                    singular: "Comment",
                                                    count: timelineEvents?.events?.filter((event)=>event.event_reference_model === "PatientComment").length,
                                                    showCount: false
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    class: "items-center",
                                    children: [
                                        "Viewing",
                                        " ",
                                        timelineEvents?.events?.filter((event)=>event.event_reference_model === filterModel || filterModel === "all").length,
                                        " ",
                                        "of",
                                        " ",
                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($904bcaae8d9a3375$exports))), {
                                            singular: "change",
                                            count: timelineEvents?.events?.filter((event)=>event.event_reference_model === filterModel || filterModel === "all").length
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "grouping font-bold my-4 hidden",
                            children: "Today"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            class: "mt-6 space-y-6 pl-1",
                            children: timelineEvents?.events?.filter((event)=>event.event_reference_model === filterModel || filterModel === "all").reduce((acc, event)=>{
                                if (event?.event_description) acc.push({
                                    event: event
                                });
                                return acc;
                            }, []).map((eventObj)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $56360fd7741baf4f$export$5fedfe9ea853f16), {
                                    event: eventObj.event
                                }, eventObj.id))
                        })
                    ]
                })
            })
        })
    });
}


// TODO: Edit Visit

var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");







function $53b20c7dc3636d0d$export$4cfb997d294e3b11() {
    const { patientId: patientId } = (0, $c5383ff45095a6a6$export$99eaa27ddbbb95ef)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { setNewVisitModalOpen: setNewVisitModalOpen, setEditVisitModalOpen: setEditVisitModalOpen, currentStudyScreenId: currentStudyScreenId, setCurrentVisitId: setCurrentVisitId } = (0, $4d7392d447faa322$export$73b18234e5d8ffa0)();
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("visits", `patient_id=${patientId}`);
    const { data: practiceStudies, isLoading: practiceStudiesLoading, isError: practiceStudiesError, mutate: practiceStudiesMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const rows = data;
    const columnDefaults = {
        width: 150,
        headerClassName: "bg-gray-100 text-gray-500",
        display: "flex"
    };
    const columns = [
        {
            field: "start_dt",
            headerName: "Visit Start",
            ...columnDefaults,
            type: "dateTime",
            width: 225,
            valueFormatter: (value, row, column, apiRef)=>(0, $0dcae3260236e0d2$export$d207855dff529fc9)(value)
        },
        {
            field: "study",
            headerName: "Study",
            ...columnDefaults,
            valueGetter: (value, row, column, apiRef)=>row.study?.abbreviation
        },
        {
            field: "visit",
            headerName: "Visit",
            ...columnDefaults,
            width: 225,
            valueGetter: (value, row, column, apiRef)=>row.practice_study_visit?.study_visit?.visit_name
        },
        {
            field: "task_list",
            headerName: "Task List",
            filterable: false,
            ...columnDefaults,
            valueGetter: (value, row, column, apiRef)=>$53b20c7dc3636d0d$var$buildMondayUrl(practiceStudies, row?.study_id),
            renderCell: (params)=>$53b20c7dc3636d0d$var$renderCrioUrl(params, "Monday.com")
        },
        {
            field: "crio",
            headerName: "CRIO",
            flex: 1,
            filterable: false,
            ...columnDefaults,
            valueGetter: (value, row, column, apiRef)=>row.xref_subject_study_url,
            renderCell: (params)=>$53b20c7dc3636d0d$var$renderCrioUrl(params, "CRIO")
        }
    ];
    (0, $f2Y41.useEffect)(()=>{
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientVisitsViewStart",
            meta: {
                patient_id: patientId,
                screen_id: currentStudyScreenId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        return ()=>{
            (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
                eventName: "PatientVisitsViewEnd",
                meta: {
                    patient_id: patientId,
                    screen_id: currentStudyScreenId
                },
                getAccessTokenSilently: getAccessTokenSilently
            });
        };
    }, [
        currentStudyScreenId,
        getAccessTokenSilently,
        patientId
    ]);
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: isLoading ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
            children: "Loading..."
        }) : /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "p-4 rounded-lg border border-gray-200 shadow-md bg-white dark:bg-transparent col-start-2",
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                            children: "Visits"
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setNewVisitModalOpen(true),
                            onKeyUp: ()=>setNewVisitModalOpen(true),
                            className: "h-10 text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                    icon: "PlusCircleIcon",
                                    className: "fill-white w-4 h-4 mr-2 rotate-90"
                                }),
                                "Add Today's Visit"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex h-screen",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                            rows: rows,
                            columns: columns,
                            disableDensitySelector: true,
                            onCellDoubleClick: (params, event)=>{
                                setCurrentVisitId(params?.row?.id);
                                setEditVisitModalOpen(true);
                            },
                            initialState: {
                                columns: {
                                    columnVisibilityModel: {}
                                },
                                sorting: {
                                    sortModel: [
                                        {
                                            field: "start_dt",
                                            sort: "desc"
                                        }
                                    ]
                                },
                                density: "comfortable"
                            },
                            sx: {
                                "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                                    outline: "none"
                                },
                                ".dark & .MuiDataGrid-columnHeader": {
                                    backgroundColor: "rgb(55 65 81)",
                                    color: "#FFFFFF"
                                }
                            }
                        })
                    })
                })
            ]
        })
    });
}
const $53b20c7dc3636d0d$var$buildMondayUrl = (practiceStudies, studyId)=>{
    const practiceStudy = practiceStudies.find((practiceStudy)=>practiceStudy?.study_id === studyId);
    return practiceStudy?.task_board_xref_id ? `https://topography-health-team.monday.com/boards/${practiceStudy?.task_board_xref_id}` : undefined;
};
function $53b20c7dc3636d0d$var$renderCrioUrl(params, destination) {
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: params.value ? /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
            target: "_blank",
            to: params.value,
            className: "text-sm font-medium hover:cursor-pointer w-full flex-col",
            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                type: "button",
                className: "h-10 text-white bg-topo-green-500 hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 rounded font-semibol text-xs px-2.5 py-1.5 text-center inline-flex items-center",
                children: [
                    destination,
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                        icon: "ExternalLinkIcon",
                        className: "fill-white w-4 h-4 ml-2"
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {})
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $bKcdJ = parcelRequire("bKcdJ");

var $asN9r = parcelRequire("asN9r");

var $f2Y41 = parcelRequire("f2Y41");




var $jvVhJ = parcelRequire("jvVhJ");







function $085fe576393c8bd3$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $bd62ffdd337a5f37$export$2e2bcd8739ae039)("MuiLinearProgress", slot);
}
const $085fe576393c8bd3$var$linearProgressClasses = (0, $66a5d15e460293e4$export$2e2bcd8739ae039)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $085fe576393c8bd3$export$2e2bcd8739ae039 = $085fe576393c8bd3$var$linearProgressClasses;



var $ge3KO = parcelRequire("ge3KO");
"use client";
const $ef16e495f7368302$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $ef16e495f7368302$var$_ = (t)=>t, $ef16e495f7368302$var$_t, $ef16e495f7368302$var$_t2, $ef16e495f7368302$var$_t3, $ef16e495f7368302$var$_t4, $ef16e495f7368302$var$_t5, $ef16e495f7368302$var$_t6;
const $ef16e495f7368302$var$TRANSITION_DURATION = 4; // seconds
const $ef16e495f7368302$var$indeterminate1Keyframe = (0, $jvVhJ.keyframes)($ef16e495f7368302$var$_t || ($ef16e495f7368302$var$_t = $ef16e495f7368302$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $ef16e495f7368302$var$indeterminate2Keyframe = (0, $jvVhJ.keyframes)($ef16e495f7368302$var$_t2 || ($ef16e495f7368302$var$_t2 = $ef16e495f7368302$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $ef16e495f7368302$var$bufferKeyframe = (0, $jvVhJ.keyframes)($ef16e495f7368302$var$_t3 || ($ef16e495f7368302$var$_t3 = $ef16e495f7368302$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $ef16e495f7368302$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            variant === "buffer" && `color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $8919b282e93103e3$export$2e2bcd8739ae039)(slots, (0, $085fe576393c8bd3$export$bc8a6ea1eb17d7c6), classes);
};
const $ef16e495f7368302$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $dee2dd5afa9d03f4$exports.lighten)(theme.palette[color].main, 0.62) : (0, $dee2dd5afa9d03f4$exports.darken)(theme.palette[color].main, 0.5);
};
const $ef16e495f7368302$var$LinearProgressRoot = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $ef16e495f7368302$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $ef16e495f7368302$var$LinearProgressDashed = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $ef16e495f7368302$var$getColorShade(theme, ownerState.color);
    return (0, $asN9r.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $jvVhJ.css)($ef16e495f7368302$var$_t4 || ($ef16e495f7368302$var$_t4 = $ef16e495f7368302$var$_`
    animation: ${0} 3s infinite linear;
  `), $ef16e495f7368302$var$bufferKeyframe));
const $ef16e495f7368302$var$LinearProgressBar1 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$ef16e495f7368302$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$ef16e495f7368302$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $jvVhJ.css)($ef16e495f7368302$var$_t5 || ($ef16e495f7368302$var$_t5 = $ef16e495f7368302$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $ef16e495f7368302$var$indeterminate1Keyframe));
const $ef16e495f7368302$var$LinearProgressBar2 = (0, $701b5b4e63c11d4d$export$2e2bcd8739ae039)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $baa577b6b7474d92$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $asN9r.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $ef16e495f7368302$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$ef16e495f7368302$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $jvVhJ.css)($ef16e495f7368302$var$_t6 || ($ef16e495f7368302$var$_t6 = $ef16e495f7368302$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $ef16e495f7368302$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $ef16e495f7368302$var$LinearProgress = /*#__PURE__*/ $f2Y41.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $b7748db3784530dd$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $bKcdJ.default)(props, $ef16e495f7368302$var$_excluded);
    const ownerState = (0, $asN9r.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $ef16e495f7368302$var$useUtilityClasses(ownerState);
    const isRtl = (0, $9e18942dda6584ee$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ge3KO.jsxs)($ef16e495f7368302$var$LinearProgressRoot, (0, $asN9r.default)({
        className: (0, $24a8e0c05af27d75$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $ge3KO.jsx)($ef16e495f7368302$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ge3KO.jsx)($ef16e495f7368302$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $ge3KO.jsx)($ef16e495f7368302$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $ef16e495f7368302$export$2e2bcd8739ae039 = $ef16e495f7368302$var$LinearProgress;



var $f2Y41 = parcelRequire("f2Y41");
const $d4bc96b7ce0cb9f9$export$2981a24b8ea6f728 = ()=>$f2Y41.useRef({});


const $ecec77438df551f3$export$2981a24b8ea6f728 = (0, $d4bc96b7ce0cb9f9$export$2981a24b8ea6f728);



var $f2Y41 = parcelRequire("f2Y41");

var $d1903f080a9e1732$exports = {};
var $18de8782b3c1c52d$exports = {};
"use strict";
Object.defineProperty($18de8782b3c1c52d$exports, "__esModule", {
    value: true
});
Object.defineProperty($18de8782b3c1c52d$exports, "default", {
    enumerable: true,
    get: function() {
        return $18de8782b3c1c52d$var$resolveConfig;
    }
});

const $18de8782b3c1c52d$var$_resolveConfig = /*#__PURE__*/ $18de8782b3c1c52d$var$_interop_require_default((parcelRequire("fjTYl")));

const $18de8782b3c1c52d$var$_getAllConfigs = /*#__PURE__*/ $18de8782b3c1c52d$var$_interop_require_default((parcelRequire("dy6Kc")));
function $18de8782b3c1c52d$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $18de8782b3c1c52d$var$resolveConfig(...configs) {
    let [, ...defaultConfigs] = (0, $18de8782b3c1c52d$var$_getAllConfigs.default)(configs[0]);
    return (0, $18de8782b3c1c52d$var$_resolveConfig.default)([
        ...configs,
        ...defaultConfigs
    ]);
}


$d1903f080a9e1732$exports = ($18de8782b3c1c52d$exports.__esModule ? $18de8782b3c1c52d$exports : {
    default: $18de8782b3c1c52d$exports
}).default;



var $by6IX = parcelRequire("by6IX");
var $8dfe87225718a2d5$exports = {};

var $kDXKg = parcelRequire("kDXKg");

var $ekqU3 = parcelRequire("ekqU3");
const $8dfe87225718a2d5$var$scrollbarPlugin = $ekqU3(({ addUtilities: addUtilities })=>{
    //  Hides scrollbar for Chrome, Safari and Opera, IE, Edge and Firefox
    addUtilities({
        ".no-scrollbar::-webkit-scrollbar": {
            display: "none"
        },
        ".no-scrollbar": {
            "-ms-overflow-style": "none" /* IE and Edge */ ,
            "scrollbar-width": "none" /* Firefox */ 
        }
    });
});



$8dfe87225718a2d5$exports = {
    content: [
        "./src/**/*.{html,js,ts,jsx,tsx}",
        "./node_modules/flowbite/**/*.js"
    ],
    theme: {
        extend: {
            colors: {
                "topo-blue": {
                    DEFAULT: "#333D7C",
                    50: "#f2f5fc",
                    100: "#e1e8f8",
                    200: "#cad7f3",
                    300: "#a6beea",
                    400: "#7b9cdf",
                    500: "#5c7bd5",
                    600: "#4860c8",
                    700: "#3e4fb7",
                    800: "#374296",
                    900: "#333d7c",
                    950: "#222649"
                },
                "topo-navy": {
                    DEFAULT: "#031941",
                    50: "#eaf8ff",
                    100: "#d1efff",
                    200: "#ace3ff",
                    300: "#73d5ff",
                    400: "#32baff",
                    500: "#0395ff",
                    600: "#006dff",
                    700: "#0053ff",
                    800: "#0044da",
                    900: "#003faa",
                    950: "#031941"
                },
                "topo-green": {
                    DEFAULT: "#0FC0A4",
                    100: "#B1E6DD",
                    200: "#83DCCE",
                    300: "#59D3C0",
                    400: "#33C9B2",
                    500: "#0FC0A4",
                    600: "#12AB93",
                    700: "#13917D",
                    800: "#137969",
                    900: "#126154"
                }
            },
            fontFamily: {
                sans: [
                    "ui-sans-serif",
                    ...$kDXKg.fontFamily.sans
                ]
            },
            transitionProperty: {
                height: "height",
                spacing: "margin, padding",
                width: "width"
            }
        }
    },
    variants: {},
    plugins: [
        (parcelRequire("kOiDa")),
        (parcelRequire("ejmpc")),
        (parcelRequire("fUXYh")),
        $8dfe87225718a2d5$var$scrollbarPlugin
    ]
};



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");




function $eac6beb5fd754052$export$a35513874f4afb4e(props) {
    const { data: users } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("users");
    const { register: register, handleSubmit: handleSubmit } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)();
    const [assigning, setAssigning] = (0, $f2Y41.useState)(false);
    const [confirmingArchive, setConfirmingArchive] = (0, $f2Y41.useState)(false);
    const [responseMessage, setResponseMessage] = (0, $f2Y41.useState)("");
    const submitAssigned = (data)=>{
        const response = props.handleAssign(data.assigned_to_user_id);
        setAssigning(false);
    };
    const submitArchive = async ()=>{
        const response = await props.handleArchive().catch((error)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($3d12054b9ed86c19$exports)))(`\u{26A0}\u{FE0F} ${error.response.data.message}`);
            setConfirmingArchive(false);
            if (error instanceof Error) console.error("Error with fetching ..., details: ", error);
        });
    // if (response?.message) {
    //   setResponseMessage(response?.message)
    // }
    };
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "fixed flex bottom-0 right-[30%] z-50 items-end overflow-x-hidden overflow-y-auto h-modal sm:h-[8.5%] sm:w-[40%]",
            id: "add-user-modal",
            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: " relative w-full h-full max-w-2xl",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative border bg-gray-200 dark:bg-gray-900 rounded-lg",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "text-sm p-3 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: `items-center ${assigning ? "flex" : "hidden"}`,
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                        className: "flex",
                                        onSubmit: handleSubmit(submitAssigned),
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                className: "rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm hover:border-gray-800 dark:bg-gray-800 dark:hover:border-gray-600",
                                                ...register("assigned_to_user_id"),
                                                id: "assigned_to_user_id",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                        value: "",
                                                        children: "None"
                                                    }),
                                                    users.map((user)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                            value: user.id,
                                                            className: "text-sm",
                                                            children: user.name
                                                        }, user.id))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                type: "submit",
                                                className: "ml-2 border border-topo-green-200 bg-transparent hover:bg-topo-green-100 dark:hover:bg-green-200 hover:bg-opacity-50 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-topo-green text-xs font-medium mr-2 px-2.5 py-2 rounded-md flex items-center justify-between",
                                                title: screen?.study?.abbreviation,
                                                children: [
                                                    "Save",
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "CheckCircleIcon",
                                                        className: "ml-1 w-5 h-5 flex"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setAssigning(false),
                                        className: "border border-gray-200 bg-transparent hover:bg-gray-100 dark:hover:bg-gray-200 hover:bg-opacity-50 focus:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2 text-gray-500 text-xs font-medium mr-6 px-2.5 py-2 rounded-md flex items-center justify-between",
                                        title: screen?.study?.abbreviation,
                                        children: [
                                            "Cancel",
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "XCircleIcon",
                                                className: "ml-1 w-5 h-5 flex text-gray"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            responseMessage,
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: assigning ? "hidden" : "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: confirmingArchive ? "hidden" : "flex",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>{
                                                setResponseMessage("");
                                                setConfirmingArchive(true);
                                            },
                                            className: "border border-red-200 bg-transparent hover:bg-red-100 dark:hover:bg-red-200 hover:bg-opacity-50 focus:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-800 focus:ring-offset-2 text-red-500 text-xs font-medium mr-6 px-2.5 py-2 rounded-md flex items-center justify-between",
                                            title: screen?.study?.abbreviation,
                                            children: [
                                                "Archive",
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: "FolderRemoveIcon",
                                                    className: "ml-1 w-5 h-5 flex text-red"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: confirmingArchive ? "flex" : "hidden",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>submitArchive(),
                                                className: "border border-red-200 bg-transparent hover:bg-red-100 dark:hover:bg-red-200 hover:bg-opacity-50  focus:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-800 focus:ring-offset-2 text-red-500 text-xs font-medium mr-6 px-2.5 py-2 rounded-md flex items-center justify-between",
                                                title: screen?.study?.abbreviation,
                                                children: [
                                                    "Confirm",
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "ShieldExclamationIcon",
                                                        className: "ml-1 w-5 h-5 flex text-red"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setConfirmingArchive(false),
                                                className: "border border-gray-200 bg-transparent hover:bg-gray-100 dark:hover:bg-gray-200 hover:bg-opacity-50 focus:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2 text-gray-500 text-xs font-medium mr-6 px-2.5 py-2 rounded-md flex items-center justify-between",
                                                title: screen?.study?.abbreviation,
                                                children: [
                                                    "Cancel",
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "XCircleIcon",
                                                        className: "ml-1 w-5 h-5 flex text-gray"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}




var $ge3KO = parcelRequire("ge3KO");




var $f2Y41 = parcelRequire("f2Y41");

var $4c3b0460d7765197$export$915e9e7bd4f0f96d = function(s) {
    var t = s.as, a = s.errors, m = s.name, o = s.message, i = s.render, l = function(e, r) {
        if (null == e) return {};
        var n, s, t = {}, a = Object.keys(e);
        for(s = 0; s < a.length; s++)r.indexOf(n = a[s]) >= 0 || (t[n] = e[n]);
        return t;
    }(s, [
        "as",
        "errors",
        "name",
        "message",
        "render"
    ]), f = (0, $ab09d66e1a814f38$export$4d957a5e1be13b03)(), c = (0, $ab09d66e1a814f38$export$3988ae62b71be9a3)(a || f.formState.errors, m);
    if (!c) return null;
    var g = c.message, u = c.types, d = Object.assign({}, l, {
        children: g || o
    });
    return $f2Y41.isValidElement(t) ? $f2Y41.cloneElement(t, d) : i ? i({
        message: g || o,
        messages: u
    }) : $f2Y41.createElement(t || $f2Y41.Fragment, d);
};




var $f2Y41 = parcelRequire("f2Y41");







function $f8132ba269dab044$export$4e44e22a11c53e58(props) {
    const { register: register, handleSubmit: handleSubmit, control: control, reset: reset, formState: { errors: errors }, setError: setError, clearErrors: clearErrors } = (0, $ab09d66e1a814f38$export$87c0cf8eb5a167e0)({
        defaultValues: {
            dob: "",
            mrn: undefined
        }
    });
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const [submitting, setSubmitting] = (0, $f2Y41.useState)(false);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const { data: practiceStudiesData, isLoading: isLoadingPracticeStudies } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const [practiceStudies, setPracticeStudies] = (0, $f2Y41.useState)([]);
    const { triggerConfetti: triggerConfetti } = (0, $3d94fb79f2ee28b7$export$81073d529bbe4dc7)();
    const initPracticeStudies = ()=>{
        const activeStudies = practiceStudiesData.filter((practiceStudy)=>practiceStudy?.study?.status !== "Closed");
        if (practiceStudies.length === activeStudies.length) return;
        setPracticeStudies(activeStudies);
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingPracticeStudies) return;
        initPracticeStudies();
        return ()=>{};
    }, [
        isLoadingPracticeStudies
    ]);
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], ()=>props.setOpen(false));
    const createScreen = async (studyId, patientId)=>{
        const data = {
            study_id: studyId,
            patient_id: patientId,
            status: "chart_review"
        };
        await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("screens", data, getAccessTokenSilently);
    };
    /* TODO: VALIDATE FORM FIRST, MRN REQUIRED */ const onSubmitAndView = async (data)=>{
        clearErrors();
        setSubmitting(true);
        let response = {};
        let errorResponse = "";
        const { studyId: studyId, ...patientData } = data;
        if (patientData.dob === "") patientData.dob = null;
        try {
            response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patients", patientData, getAccessTokenSilently);
        } catch (error) {
            setSubmitting(false);
            setError("root.createPatientsError", {
                type: "custom",
                message: "Error submitting. Check for MRN duplication"
            });
            errorResponse = error;
            return;
        }
        setSubmitting(false);
        const patientId = response?.data?.data?.id;
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientQuickAdd",
            meta: {
                patient_id: patientId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        if (!errorResponse) reset();
        if (studyId) await createScreen(studyId, patientId);
        triggerConfetti();
        navigate(`/patients/${patientId}`);
    };
    const onSubmitAndAddNew = async (data)=>{
        clearErrors();
        setSubmitting(true);
        let response = {};
        let errorResponse = "";
        const { studyId: studyId, ...patientData } = data;
        if (patientData.dob === "") patientData.dob = null;
        try {
            response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("patients", patientData, getAccessTokenSilently);
        } catch (error) {
            setSubmitting(false);
            errorResponse = error;
            setError("root.createPatientsError", {
                type: "custom",
                message: "Error submitting. Check for MRN duplication"
            });
            return;
        }
        setSubmitting(false);
        const patientId = response?.data?.data?.id;
        (0, $3366964b70ffaf65$export$6cd530ed55e06764)({
            eventName: "PatientQuickAdd",
            meta: {
                patient_id: patientId
            },
            getAccessTokenSilently: getAccessTokenSilently
        });
        if (studyId) await createScreen(studyId, patientId);
        if (props.refreshData) props.refreshData();
        if (!errorResponse) reset();
        // TODO: Toast 🍞
        triggerConfetti();
    };
    const handleSaveAndView = async ()=>await handleSubmit(onSubmitAndView)();
    const handleSaveAndAddNew = async ()=>await handleSubmit(onSubmitAndAddNew)();
    // useEffect(() => {
    //   console.dir(errors)
    //   return () => {
    //   }
    // }, [errors])
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $f2Y41.Fragment),
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153), {
            onClose: props.setOpen,
            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "absolute inset-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153).Overlay, {
                        className: "absolute inset-0"
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4).Child, {
                            as: (0, $f2Y41.Fragment),
                            enter: "transform transition ease-in-out duration-300 sm:duration-300",
                            enterFrom: "translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transform transition ease-in-out duration-400 sm:duration-700",
                            leaveFrom: "translate-x-0",
                            leaveTo: "translate-x-full",
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "pointer-events-auto w-screen max-w-2xl",
                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("form", {
                                    className: "flex h-full flex-col overflow-y-scroll bg-white dark:bg-gray-800 dark:border-l dark:border-l-gray-600 dark:text-gray-200 shadow-xl",
                                    onSubmit: handleSubmit(onSubmitAndView),
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                            ...register("practice_id"),
                                            defaultValue: practiceId,
                                            type: "hidden"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                            ...register("source"),
                                            defaultValue: "quick_add",
                                            type: "hidden"
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: " bg-topo-blue px-4 py-6 sm:px-6 rounded-t-md",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        className: "flex items-start justify-between space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                className: "space-y-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $8a2bf535d3f591d5$export$3ddf2d174ce01153).Title, {
                                                                        className: "text-lg font-medium text-white ",
                                                                        children: [
                                                                            " ",
                                                                            "New Patient"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                                        className: "text-sm text-gray-200",
                                                                        children: "Fill in the information below to add a new patient."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                className: "flex h-7 items-center",
                                                                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "text-gray-200 hover:text-gray-500",
                                                                    onClick: ()=>props.setOpen(false),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                            className: "sr-only",
                                                                            children: "Close panel"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ad688b80368a215e$export$2e2bcd8739ae039), {
                                                                            className: "h-6 w-6",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 dark:divide-gray-700 sm:py-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("label", {
                                                                        htmlFor: "patient-mrn",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: [
                                                                            "Patient MRN",
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                                title: "Required",
                                                                                className: "p-0.5 text-red-800",
                                                                                children: "*"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                            ...register("mrn", {
                                                                                required: "MRN is required"
                                                                            }),
                                                                            required: true,
                                                                            type: "text",
                                                                            id: "patient-mrn",
                                                                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                            className: "mt-2 text-sm text-red-500",
                                                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4c3b0460d7765197$export$915e9e7bd4f0f96d), {
                                                                                errors: errors,
                                                                                name: "mrn"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-given-name",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient First Name"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        ...register("given_name"),
                                                                        required: false,
                                                                        type: "text",
                                                                        id: "patient-given-name",
                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-given-name",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient Last Name"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        ...register("family_name"),
                                                                        required: false,
                                                                        type: "text",
                                                                        id: "patient-family-name",
                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-suffix",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient Suffix"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                                        ...register("suffix", {
                                                                            disabled: false
                                                                        }),
                                                                        id: "patient-suffix",
                                                                        className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "SR"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "JR"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "III"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "IV"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "V"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-dob",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient DOB"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2 dark:text-gray-200",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ab09d66e1a814f38$export$bd0bf19f25da8474), {
                                                                        name: "dob",
                                                                        control: control,
                                                                        defaultValue: "",
                                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $fc0dded12476a4e7$export$2e2bcd8739ae039), {
                                                                                ...field,
                                                                                required: false,
                                                                                type: "date",
                                                                                sx: {
                                                                                    display: "block",
                                                                                    marginBottom: "1rem",
                                                                                    padding: "0",
                                                                                    paddingTop: "0.1rem",
                                                                                    width: 250,
                                                                                    boxShadow: "none"
                                                                                },
                                                                                InputLabelProps: {
                                                                                    shrink: true
                                                                                }
                                                                            })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-phone",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient Phone Number"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        ...register("phone"),
                                                                        type: "text",
                                                                        id: "patient-phone",
                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-email",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient Email"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        ...register("email"),
                                                                        type: "text",
                                                                        id: "patient-email",
                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-source",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Patient Source"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                                        ...register("source", {
                                                                            disabled: false
                                                                        }),
                                                                        id: "patient-source",
                                                                        className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "Provider Referral"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "Manual EMR Review"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                children: "Sponsor Referral"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                                        htmlFor: "patient-study",
                                                                        className: "block text-sm font-medium text-gray-900 dark:text-gray-200 sm:mt-px sm:pt-2",
                                                                        children: "Add to Study"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                                    className: "sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("select", {
                                                                        ...register("studyId", {
                                                                            disabled: false
                                                                        }),
                                                                        id: "patient",
                                                                        className: "mb-4 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm dark:bg-gray-700",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ge3KO.jsx)("option", {}),
                                                                            practiceStudies.map((practiceStudy)=>/*#__PURE__*/ (0, $ge3KO.jsx)("option", {
                                                                                    value: practiceStudy?.study?.id,
                                                                                    title: practiceStudy?.study?.name,
                                                                                    children: practiceStudy?.study?.abbreviation
                                                                                }, practiceStudy?.study?.id))
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "flex-shrink-0 border-t border-gray-200 dark:border-gray-700 px-4 py-5 sm:px-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    className: "mb-2 text-sm text-red-500",
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4c3b0460d7765197$export$915e9e7bd4f0f96d), {
                                                        errors: errors,
                                                        name: "root.createPatientsError"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                    className: "flex justify-start space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                            type: "button",
                                                            className: "inline-flex justify-center rounded-md border border-transparent bg-topo-green py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-topo-green-600 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2",
                                                            onClick: handleSubmit(handleSaveAndView),
                                                            disabled: submitting,
                                                            children: "Save and View"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                            type: "button",
                                                            className: "inline-flex justify-center rounded-md border border-transparent bg-topo-blue py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-900 focus:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2",
                                                            onClick: handleSubmit(handleSaveAndAddNew),
                                                            disabled: submitting,
                                                            children: "Save and Add New"
                                                        }),
                                                        /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                            type: "button",
                                                            className: "rounded-md border justify-end border-transparent bg-red-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                            onClick: ()=>props.setOpen(false),
                                                            children: "Cancel"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}






function $940beea38a6921ba$export$bbc0fd08dc1b8ad7(json) {
    let parsed;
    try {
        parsed = JSON.parse(json);
    } catch (e) {
    /* do nothing */ }
    return parsed // Could be undefined
    ;
}







var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");










var $f2Y41 = parcelRequire("f2Y41");
var $163d22ab34922bd5$var$t;
let $163d22ab34922bd5$export$7568632d0d33d16d = ($163d22ab34922bd5$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).startTransition) != null ? $163d22ab34922bd5$var$t : function(i) {
    i();
};



var $7417b2d13c755a90$var$Q = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($7417b2d13c755a90$var$Q || {}), $7417b2d13c755a90$var$V = ((t)=>(t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))($7417b2d13c755a90$var$V || {});
let $7417b2d13c755a90$var$Y = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $01099572ffa9156b$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [4] (e) {
        return e.linkedPanel === !0 ? e : {
            ...e,
            linkedPanel: !0
        };
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : {
            ...e,
            linkedPanel: !1
        };
    },
    [2] (e, n) {
        return e.buttonId === n.buttonId ? e : {
            ...e,
            buttonId: n.buttonId
        };
    },
    [3] (e, n) {
        return e.panelId === n.panelId ? e : {
            ...e,
            panelId: n.panelId
        };
    }
}, $7417b2d13c755a90$var$M = (0, $f2Y41.createContext)(null);
$7417b2d13c755a90$var$M.displayName = "DisclosureContext";
function $7417b2d13c755a90$var$_(e) {
    let n = (0, $f2Y41.useContext)($7417b2d13c755a90$var$M);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $7417b2d13c755a90$var$_), o;
    }
    return n;
}
let $7417b2d13c755a90$var$v = (0, $f2Y41.createContext)(null);
$7417b2d13c755a90$var$v.displayName = "DisclosureAPIContext";
function $7417b2d13c755a90$var$K(e) {
    let n = (0, $f2Y41.useContext)($7417b2d13c755a90$var$v);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $7417b2d13c755a90$var$K), o;
    }
    return n;
}
let $7417b2d13c755a90$var$F = (0, $f2Y41.createContext)(null);
$7417b2d13c755a90$var$F.displayName = "DisclosurePanelContext";
function $7417b2d13c755a90$var$Z() {
    return (0, $f2Y41.useContext)($7417b2d13c755a90$var$F);
}
function $7417b2d13c755a90$var$ee(e, n) {
    return (0, $01099572ffa9156b$export$4659b591c19bdf3d)(n.type, $7417b2d13c755a90$var$Y, e, n);
}
let $7417b2d13c755a90$var$te = (0, $f2Y41.Fragment);
function $7417b2d13c755a90$var$ne(e, n) {
    let { defaultOpen: o = !1, ...i } = e, f = (0, $f2Y41.useRef)(null), l = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(n, (0, $ee0946aeccd5ac5d$export$7029785b750eb74)((u)=>{
        f.current = u;
    }, e.as === void 0 || e.as === (0, $f2Y41.Fragment))), t = (0, $f2Y41.useRef)(null), d = (0, $f2Y41.useRef)(null), s = (0, $f2Y41.useReducer)($7417b2d13c755a90$var$ee, {
        disclosureState: o ? 0 : 1,
        linkedPanel: !1,
        buttonRef: d,
        panelRef: t,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: c, buttonId: a }, D] = s, p = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((u)=>{
        D({
            type: 1
        });
        let y = (0, $225dec9ff04e4a5b$export$b204af158042fbac)(f);
        if (!y || !a) return;
        let r = (()=>u ? u instanceof HTMLElement ? u : u.current instanceof HTMLElement ? u.current : y.getElementById(a) : y.getElementById(a))();
        r == null || r.focus();
    }), P = (0, $f2Y41.useMemo)(()=>({
            close: p
        }), [
        p
    ]), T = (0, $f2Y41.useMemo)(()=>({
            open: c === 0,
            close: p
        }), [
        c,
        p
    ]), C = {
        ref: l
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($7417b2d13c755a90$var$M.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($7417b2d13c755a90$var$v.Provider, {
        value: P
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $f7ac33105fd0ff19$export$2a0ed818b175f558), {
        value: (0, $01099572ffa9156b$export$4659b591c19bdf3d)(c, {
            [0]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open,
            [1]: (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Closed
        })
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        ourProps: C,
        theirProps: i,
        slot: T,
        defaultTag: $7417b2d13c755a90$var$te,
        name: "Disclosure"
    }))));
}
let $7417b2d13c755a90$var$le = "button";
function $7417b2d13c755a90$var$oe(e, n) {
    let o = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-disclosure-button-${o}`, ...f } = e, [l, t] = $7417b2d13c755a90$var$_("Disclosure.Button"), d = $7417b2d13c755a90$var$Z(), s = d === null ? !1 : d === l.panelId, c = (0, $f2Y41.useRef)(null), a = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(c, n, s ? null : l.buttonRef), D = (0, $43f03f8737506038$export$81218df071161f0a)();
    (0, $f2Y41.useEffect)(()=>{
        if (!s) return t({
            type: 2,
            buttonId: i
        }), ()=>{
            t({
                type: 2,
                buttonId: null
            });
        };
    }, [
        i,
        t,
        s
    ]);
    let p = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        var m;
        if (s) {
            if (l.disclosureState === 1) return;
            switch(r.key){
                case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
                case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), r.stopPropagation(), t({
                        type: 0
                    }), (m = l.buttonRef.current) == null || m.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), t({
                    type: 0
                });
                break;
        }
    }), P = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        switch(r.key){
            case (0, $a2773c9bee4148b2$export$4b0075e5ea5e1f26).Space:
                r.preventDefault();
                break;
        }
    }), T = (0, $937d0122ac3ce8be$export$90fc3a17d93f704c)((r)=>{
        var m;
        (0, $d8956e419f398824$export$db61f031a278447c)(r.currentTarget) || e.disabled || (s ? (t({
            type: 0
        }), (m = l.buttonRef.current) == null || m.focus()) : t({
            type: 0
        }));
    }), C = (0, $f2Y41.useMemo)(()=>({
            open: l.disclosureState === 0
        }), [
        l
    ]), u = (0, $00f3e4c5862b3e5b$export$53652b2b272efe9c)(e, c), y = s ? {
        ref: a,
        type: u,
        onKeyDown: p,
        onClick: T
    } : {
        ref: a,
        id: i,
        type: u,
        "aria-expanded": l.disclosureState === 0,
        "aria-controls": l.linkedPanel ? l.panelId : void 0,
        onKeyDown: p,
        onKeyUp: P,
        onClick: T
    };
    return (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        mergeRefs: D,
        ourProps: y,
        theirProps: f,
        slot: C,
        defaultTag: $7417b2d13c755a90$var$le,
        name: "Disclosure.Button"
    });
}
let $7417b2d13c755a90$var$re = "div", $7417b2d13c755a90$var$se = (0, $43f03f8737506038$export$617d79dae526d2cf).RenderStrategy | (0, $43f03f8737506038$export$617d79dae526d2cf).Static;
function $7417b2d13c755a90$var$ue(e, n) {
    let o = (0, $8fb4eba1dcb7930e$export$f680877a34711e37)(), { id: i = `headlessui-disclosure-panel-${o}`, ...f } = e, [l, t] = $7417b2d13c755a90$var$_("Disclosure.Panel"), { close: d } = $7417b2d13c755a90$var$K("Disclosure.Panel"), s = (0, $43f03f8737506038$export$81218df071161f0a)(), c = (0, $ee0946aeccd5ac5d$export$f6a25a78204acc7e)(n, l.panelRef, (T)=>{
        (0, $163d22ab34922bd5$export$7568632d0d33d16d)(()=>t({
                type: T ? 4 : 5
            }));
    });
    (0, $f2Y41.useEffect)(()=>(t({
            type: 3,
            panelId: i
        }), ()=>{
            t({
                type: 3,
                panelId: null
            });
        }), [
        i,
        t
    ]);
    let a = (0, $f7ac33105fd0ff19$export$fc6fdf0ecf360e)(), D = (()=>a !== null ? (a & (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open) === (0, $f7ac33105fd0ff19$export$7254cc27399e90bd).Open : l.disclosureState === 0)(), p = (0, $f2Y41.useMemo)(()=>({
            open: l.disclosureState === 0,
            close: d
        }), [
        l,
        d
    ]), P = {
        ref: c,
        id: i
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement($7417b2d13c755a90$var$F.Provider, {
        value: l.panelId
    }, (0, $43f03f8737506038$export$b3890eb0ae9dca99)({
        mergeRefs: s,
        ourProps: P,
        theirProps: f,
        slot: p,
        defaultTag: $7417b2d13c755a90$var$re,
        features: $7417b2d13c755a90$var$se,
        visible: D,
        name: "Disclosure.Panel"
    }));
}
let $7417b2d13c755a90$var$ie = (0, $43f03f8737506038$export$e43f39796049410c)($7417b2d13c755a90$var$ne), $7417b2d13c755a90$var$ae = (0, $43f03f8737506038$export$e43f39796049410c)($7417b2d13c755a90$var$oe), $7417b2d13c755a90$var$pe = (0, $43f03f8737506038$export$e43f39796049410c)($7417b2d13c755a90$var$ue), $7417b2d13c755a90$export$74a362b31437ec83 = Object.assign($7417b2d13c755a90$var$ie, {
    Button: $7417b2d13c755a90$var$ae,
    Panel: $7417b2d13c755a90$var$pe
});





var $6TVh2 = parcelRequire("6TVh2");

var $f2Y41 = parcelRequire("f2Y41");







var $ge3KO = parcelRequire("ge3KO");


const $a74ca7c7565827d7$export$4f1a296444d9d9bd = (params)=>{
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1680f2c298b4061f$export$276ebf2f43e1afe0), {
        ...params,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b8fdbc08d9d83345$export$9460f81121783d0f), {
            className: "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800",
            startIcon: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                icon: "EyeIcon",
                className: `h-5 w-7 ml-2 text-white`
            }),
            sx: {
                borderRadius: "0.375rem",
                textTransform: "capitalize",
                fontWeight: 550,
                fontSize: "0.875rem",
                backgroundColor: "#353D78",
                border: "1px",
                py: 1.2,
                mt: -0.5,
                ml: 1,
                pr: 2,
                "&:hover": {
                    color: "white",
                    backgroundColor: "#2f366d"
                }
            }
        })
    });
};
const $a74ca7c7565827d7$export$f2ead207310b6bda = (params)=>{
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1680f2c298b4061f$export$276ebf2f43e1afe0), {
        ...params,
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e53f14e1a9fb983f$export$ef68b449b329deb5), {
            ...params,
            sx: {
                borderRadius: "0.375rem",
                textTransform: "capitalize",
                fontWeight: 550,
                fontSize: "0.875rem",
                backgroundColor: "#353D78",
                py: 1.2,
                px: 1.5,
                mt: -0.5,
                "&:hover": {
                    color: "white",
                    backgroundColor: "#2f366d"
                }
            }
        })
    });
};






function $cf2242ddcdea7096$export$95036c0a3d808bad(props) {
    const { currentUser: currentUser, navigate: navigate, setQuickAddOpen: setQuickAddOpen, filtersOpen: filtersOpen, setFiltersOpen: setFiltersOpen, customSortableColumns: customSortableColumns, columns: columns, disableColumnFilter: disableColumnFilter, setDisableColumnFilter: setDisableColumnFilter, setFilterAndSort: setFilterAndSort, filterAndSort: filterAndSort, search: search, setSearch: setSearch, isValidatingPatients: isValidatingPatients, ...gridToolbarProps } = props;
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc)) // TODO: MultiTenancy
    ;
    const { data: users, isLoading: isLoadingUsers } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("users");
    const [meFirstUsers, setMeFirstUsers] = (0, $f2Y41.useState)([]);
    const apiRef = (0, $e87e8a83fc996e91$export$2d14edd3a7db3bbf)();
    const [searchInput, setSearchInput] = (0, $f2Y41.useState)(search);
    const [initSearch, setInitSearch] = (0, $f2Y41.useState)(true);
    const [listModeActive, setListModeActive] = (0, $f2Y41.useState)("active");
    const [kanbanActive, setKanbanActive] = (0, $f2Y41.useState)("");
    const { data: practiceStudiesData, isLoading: isLoadingPracticeStudies } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const [practiceStudies, setPracticeStudies] = (0, $f2Y41.useState)([]);
    const { triggerConfetti: triggerConfetti } = (0, $3d94fb79f2ee28b7$export$81073d529bbe4dc7)();
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingPracticeStudies) return;
        setPracticeStudies(practiceStudiesData.filter((practiceStudy)=>practiceStudy?.study?.status !== "Closed"));
        return ()=>{};
    }, [
        practiceStudiesData,
        isLoadingPracticeStudies
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (isLoadingUsers) return;
        setMeFirstUsers([
            ...users.filter((user)=>user.id === currentUser.id),
            ...users.filter((user)=>user.id !== currentUser.id && (0, $601cdae3149c9149$export$d540efe9354f0ccc)(user))
        ]);
    }, [
        users,
        currentUser,
        isLoadingUsers
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (search !== "" && initSearch) {
            setSearchInput(search);
            setInitSearch(false);
        }
    }, [
        search,
        initSearch
    ]);
    const gridFilterModelContainsItem = (field, value)=>(0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5))?.items?.some((item)=>item.field === field && item.value === value);
    const screensArrayIndex = {
        study: 0,
        status: 1,
        assigned: 2
    };
    const gridFilterModelContainsScreenItem = (field, value)=>filterAndSort?.filtering?.filters?.some((item)=>item?.field === field && item?.value === value);
    const handleScreensFilterClick = (field, value)=>{
        const filtering = filterAndSort?.filtering ?? {};
        const currentFilters = filtering?.filters ?? [];
        const indexToUpdate = currentFilters.findIndex((item)=>item.field === field);
        const newFilter = {
            id: field,
            field: field,
            operator_value: "equals",
            value: value
        };
        if (indexToUpdate === -1) currentFilters.push(newFilter);
        else if (currentFilters[indexToUpdate].value !== value) currentFilters[indexToUpdate] = newFilter;
        else currentFilters.splice(indexToUpdate, 1);
        filtering.filters = [
            ...currentFilters
        ];
        const newGridFilterModel = {
            items: filtering?.filters.map(({ field: field, operator_value: operator_value, value: value })=>({
                    field: field,
                    operator: operator_value,
                    value: value
                }))
        };
        apiRef.current.setFilterModel(newGridFilterModel, "upsertFilterItems");
    };
    // Unused for now until another non-screen filter is added
    const handleFilterClick = (field, value)=>{
        const gridFilterState = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5))?.items;
        const itemToDelete = gridFilterState.slice().find((gridFilterModelItem)=>gridFilterModelItem?.field === field && gridFilterModelItem?.value === value);
        if (itemToDelete) {
            apiRef.current.deleteFilterItem(itemToDelete);
            return;
        }
        const operator = "equals" // TODO: store the operator in the URL or in the column def
        ;
        const newFilterItem = {
            id: (0, $e843bba77db96df0$export$2e2bcd8739ae039)(),
            field: field,
            operator_value: operator,
            value: value
        };
        // Delete other filters for the same column
        for (const gridFilterModelItem of gridFilterState)if (gridFilterModelItem?.field === field) apiRef.current.deleteFilterItem(gridFilterModelItem);
        apiRef.current.setFilterModel(newFilterItem);
    };
    const handleClearFiltersClick = ()=>{
        apiRef.current.setFilterModel({
            items: []
        }, "upsertFilterItems");
        setFilterAndSort((filterAndSort)=>({
                filtering: {
                    filters: [],
                    link_operator: filterAndSort?.link_operator
                },
                sorting: filterAndSort?.sorting
            }));
    };
    const gridSortModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9));
    const gridSortModelContainsItem = (field)=>gridSortModel?.some((item)=>item?.field === field && item?.sort !== undefined);
    const gridSortDirection = (field)=>gridSortModel?.find((item)=>item?.field === field)?.sort;
    const handleSortClick = (field)=>{
        if (gridSortModelContainsItem(field)) {
            const newSortModel = gridSortModel.map((item)=>{
                if (item?.field === field && item?.sort === "desc") return {
                    ...item,
                    sort: "asc"
                };
            }).filter((item)=>item !== undefined);
            newSortModel && apiRef.current.setSortModel(newSortModel);
        } else apiRef.current.setSortModel([
            {
                field: field,
                sort: "desc"
            }
        ]);
    };
    const handleClearSortClick = ()=>apiRef.current.setSortModel([]);
    const quickFilterParser = (searchInput)=>{
        // trim whitespace, remove special hidden characters and + () - for phones
        return (0, $6TVh2.compact)(searchInput.split(" ").map((input)=>input.trim()// biome-ignore lint/suspicious/noControlCharactersInRegex: <striping these out of input>
            .replace(/[\u0000-\u001F\u007F-\u009F\u200B\+\(\)\-]/g, "")));
    };
    const debouncedSetSearch = (0, $c0d11346704ef515$export$2e2bcd8739ae039)((value)=>{
        setSearch(value);
    }, 500, []);
    const handleSearchChange = (event)=>{
        setInitSearch(false);
        setSearchInput(event.target.value);
        debouncedSetSearch(event.target.value);
    };
    const clearSearch = ()=>{
        setSearchInput("");
        setSearch("");
    };
    const handleDeleteFilterItem = (item)=>{
        const newFilters = [
            ...filterAndSort.filtering.filters
        ];
        const indexToDelete = newFilters.findIndex((filter)=>filter.field === item.field);
        if (indexToDelete !== -1) newFilters.splice(indexToDelete, 1);
        apiRef.current.setFilterModel({
            items: []
        }, "upsertFilterItems");
        setFilterAndSort({
            filtering: {
                filters: newFilters,
                link_operator: filterAndSort.link_operator
            },
            sorting: filterAndSort.sorting
        });
    };
    const handleDeleteSortItem = (item)=>{
        const newSorts = [
            ...filterAndSort.sorting
        ];
        const indexToDelete = newSorts.findIndex((sort)=>sort.field === item.field);
        if (indexToDelete !== -1) newSorts.splice(indexToDelete, 1);
        apiRef.current.setSortModel([]);
        setFilterAndSort({
            ...filterAndSort,
            sorting: newSorts
        });
    };
    const toolbarButtonStyle = "inline-flex items-center px-3 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-topo-blue hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800";
    const toolbarButtonGroupStyle = "inline-flex items-center px-4 border border-gray shadow-sm text-sm leading-4 font-medium text-gray-600 bg-gray-100 [&.active]:bg-topo-blue [&.active]:text-white [&.active]:border-transparent hover:bg-blue-900 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800";
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-gray-900 dark:text-gray-200",
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $7417b2d13c755a90$export$74a362b31437ec83), {
            children: [
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "flex gap-1 mr-1 mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            triggerConfetti();
                                            setQuickAddOpen(true);
                                        },
                                        className: toolbarButtonStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "PlusCircleIcon",
                                                className: "h-5 w-7 mr-1 text-white",
                                                outline: false
                                            }),
                                            "Quick Add"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "inline-flex ml-4",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                        type: "button",
                                        // change this to rounded-r-md when cards are added back in
                                        className: `${listModeActive} rounded-md ${toolbarButtonGroupStyle}`,
                                        onClick: ()=>console.log("LIST VIEW"),
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "ViewListIcon",
                                                className: "h-5 w-7 mr-1 text-gray hover:text-white active:text-white",
                                                outline: true
                                            }),
                                            "List"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a74ca7c7565827d7$export$4f1a296444d9d9bd), {
                                        ...gridToolbarProps
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                    content: 'Enclose search terms in double quotes ("example a") to treat them as a single term. Separate all other terms with spaces to treat them individually.',
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                            className: "relative ml-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                    placeholder: "Search...",
                                                    type: "text",
                                                    name: "search",
                                                    id: "search",
                                                    value: searchInput,
                                                    onChange: handleSearchChange,
                                                    className: "shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg pl-10 pr-8 py-2.5 focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: "SearchIcon",
                                                    className: "absolute left-2 top-1/2 transform -translate-y-1/2 w-6 h-6"
                                                }),
                                                search && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    onClick: clearSearch,
                                                    onKeyUp: clearSearch,
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "XIcon",
                                                        className: "absolute top-1/2 right-2 transform -translate-y-1/2 w-6 h-6 cursor-pointer hover:text-red-500"
                                                    })
                                                })
                                            ]
                                        }),
                                        false
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $7417b2d13c755a90$export$74a362b31437ec83).Button, {
                                        // TODO: trigger re-render of grid
                                        onClick: ()=>setFiltersOpen(!filtersOpen) && setDisableColumnFilter(!disableColumnFilter),
                                        className: `ml-3 ${toolbarButtonStyle}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                icon: "FilterIcon",
                                                className: "h-5 w-7 mr-1 text-white",
                                                outline: false
                                            }),
                                            filtersOpen ? "Hide" : "",
                                            " Filter"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex ml-4 items-center text-black dark:text-gray-300 text-xs",
                                    children: [
                                        "Viewing:",
                                        " ",
                                        (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$2f31562143a3e5d4)).length,
                                        " ",
                                        "of ",
                                        apiRef.current.getRowsCount(),
                                        " patients"
                                    ]
                                }),
                                isValidatingPatients && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "flex ml-4 items-center text-black dark:text-gray-300 text-md",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4b62e8b2456b349f$export$7f7cbe89f1eacd2), {}),
                                        " Loading..."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a74ca7c7565827d7$export$f2ead207310b6bda), {
                            ...gridToolbarProps
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39c8d3a34d35014d$export$be58926105124dd4), {
                    enter: "transition duration-100 ease-out origin-top",
                    enterFrom: "transform scale-y-0",
                    enterTo: "transform scale-y-100",
                    leave: "transition duration-100 ease-in origin-top",
                    leaveFrom: "transform scale-y-100",
                    leaveTo: "transform scale-y-0",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7417b2d13c755a90$export$74a362b31437ec83).Panel, {
                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                            className: "mb-4 pb-4 hover:cursor-default border-b dark:border-gray-700",
                            children: [
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "font-medium flex mb-4 text-base items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "FilterIcon",
                                            className: "h-5 -ml-0.5 mr-1",
                                            outline: false
                                        }),
                                        " ",
                                        "Filters",
                                        " ",
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "ml-2 font-normal text-xs underline self-center hover:cursor-pointer",
                                            onClick: ()=>handleClearFiltersClick(),
                                            onKeyUp: ()=>handleClearFiltersClick(),
                                            children: "Clear"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "font-medium mb-2",
                                    children: "Studies"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex",
                                    children: practiceStudies?.map((study)=>/*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            className: `mr-2 inline-flex items-center p-2 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 ${gridFilterModelContainsScreenItem("study", study?.study?.abbreviation) ? "text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white" : "text-topo-blue bg-white  dark:bg-gray-800 dark:text-blue-500 hover:bg-blue-800 hover:text-white"}`,
                                            onClick: ()=>handleScreensFilterClick("study", study?.study?.abbreviation),
                                            children: study?.study?.abbreviation
                                        }, study?.id))
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "font-medium mt-4 mb-2",
                                    children: "Status"
                                }),
                                (0, $dc67232e0e99ac39$export$cfd07d0d262760eb).map((status)=>/*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: `mr-2 inline-flex items-center p-2 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 ${gridFilterModelContainsScreenItem("status", status) ? "text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white" : "text-topo-blue bg-white  dark:bg-gray-800 dark:text-blue-500 hover:bg-blue-800 hover:text-white"}`,
                                        onClick: ()=>handleScreensFilterClick("status", status),
                                        children: (0, $17235661ec5f519b$export$b94aa994a2f01789)(status)
                                    }, `status${status}`)),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "font-medium mt-4 mb-2",
                                    children: "Assigned"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: meFirstUsers.map((user)=>/*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>handleScreensFilterClick("assigned", user?.id),
                                            className: `mr-2 inline-flex items-center p-2 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 ${gridFilterModelContainsScreenItem("assigned", user?.id) ? "text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white" : "text-topo-blue bg-white dark:bg-gray-800 dark:text-blue-500 hover:bg-blue-800 hover:text-white"}`,
                                            children: user?.name !== currentUser?.name ? user.name : `${user.name} (Me)`
                                        }, `meFirstUsers${user?.id}`))
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                    className: "font-medium flex mt-4 mb-4 text-base items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                            icon: "SortAscendingIcon",
                                            className: "h-5 mr-1",
                                            outline: false
                                        }),
                                        " ",
                                        "Sorts",
                                        " ",
                                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                            className: "ml-2 font-normal text-xs underline self-center hover:cursor-pointer",
                                            onClick: ()=>handleClearSortClick(),
                                            onKeyUp: ()=>handleClearSortClick(),
                                            children: "Clear"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "font-medium  mt-4 mb-2",
                                    children: "Sort By"
                                }),
                                /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    className: "flex items-center",
                                    children: customSortableColumns.map((column)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleSortClick(column),
                                            className: `mr-2 inline-flex items-center p-2 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 ${gridSortModelContainsItem(column) ? "text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white" : "text-topo-blue bg-white  dark:bg-gray-800 dark:text-blue-500 hover:bg-blue-800 hover:text-white"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: gridSortDirection(column) === "asc" ? "SortAscendingIcon" : "SortDescendingIcon",
                                                    className: "h-4 mr-1 text-white",
                                                    outline: true
                                                }),
                                                columns.find((gridColumn)=>gridColumn?.field === column)?.headerName
                                            ]
                                        }, `customSortableColumns${column}`))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "mb-4 select-none",
                    children: [
                        (filterAndSort?.filtering?.filters?.length > 0 || filterAndSort?.sorting?.length > 0) && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "inline-flex items-center text-sm mr-2 p-2 border leading-4 font-medium rounded-md text-topo-blue dark:text-blue-500 bg-white dark:bg-transparent dark:border dark:border-topo-blue",
                            children: "Viewing:"
                        }),
                        filterAndSort?.filtering?.filters?.filter((item)=>[
                                "study",
                                "status",
                                "assigned"
                            ].includes(item?.field)).map((item)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "mr-2 inline-flex items-center p-2 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white hover:cursor-default",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                        content: "Click to remove filter.",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleDeleteFilterItem(item),
                                            onKeyUp: ()=>handleDeleteFilterItem(item),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: "FilterIcon",
                                                    className: "w-4 mr-1 inline-flex text-white",
                                                    outline: true
                                                }),
                                                item.field === "assigned" ? (0, $17235661ec5f519b$export$b94aa994a2f01789)(users.find((user)=>user.id === item.value)?.name) : (0, $17235661ec5f519b$export$b94aa994a2f01789)(item.value)
                                            ]
                                        })
                                    })
                                })
                            }, item.field)),
                        filterAndSort?.filtering?.filters?.filter((item)=>![
                                "study",
                                "status",
                                "assigned"
                            ].includes(item?.field)).map((item)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "mr-2 inline-flex items-center p-2 pb-1.5 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white hover:cursor-default",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                        content: "Click to remove filter.",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleDeleteFilterItem(item),
                                            onKeyUp: ()=>handleDeleteFilterItem(item),
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: "FilterIcon",
                                                    className: "w-4 mr-1 inline-flex text-white",
                                                    outline: true
                                                }),
                                                columns.find((gridColumn)=>item.field === gridColumn.field)?.headerName ?? (0, $17235661ec5f519b$export$b94aa994a2f01789)(item.field),
                                                " ",
                                                item?.operator,
                                                " ",
                                                item?.value
                                            ]
                                        })
                                    })
                                })
                            }, item)),
                        (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $5f97fdc29401641a$export$55dcc66b73d9a0f9)).map((gridSortItem)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "mr-2 inline-flex items-center p-2 pb-1.5 border border-topo-blue shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800 text-white bg-topo-blue hover:bg-blue-900 hover:text-topo-white hover:cursor-default",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a49035198e9995d4$export$28c660c63b792dea), {
                                        content: "Click to remove sort.",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleDeleteSortItem(gridSortItem),
                                            onKeyUp: ()=>handleDeleteSortItem(gridSortItem),
                                            children: [
                                                gridSortDirection(gridSortItem.field) !== undefined && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                    icon: gridSortDirection(gridSortItem.field) === "asc" ? "SortAscendingIcon" : "SortDescendingIcon",
                                                    className: "w-4 mr-1 inline-flex text-white",
                                                    outline: true
                                                }),
                                                columns.find((gridColumn)=>gridSortItem?.field === gridColumn.field)?.headerName
                                            ]
                                        })
                                    })
                                })
                            }, gridSortItem.field))
                    ]
                })
            ]
        })
    });
}


const $425ea3415c0ea86d$var$fullConfig = (0, (/*@__PURE__*/$parcel$interopDefault($d1903f080a9e1732$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8dfe87225718a2d5$exports))));
const $425ea3415c0ea86d$var$DEFAULT_FILTER_AND_SORT = (practiceId)=>{
    return {
        sorting: [],
        filtering: {
            filters: [],
            link_operator: "and"
        },
        search: "",
        practice_id: practiceId
    };
};
function $425ea3415c0ea86d$export$3849a5e5f22ef010() {
    const [searchParams, setSearchParams] = (0, $68992f44774c46b5$export$f1a78c17382fe22a)();
    const { practiceId: practiceId, changePractice: changePractice, authorizedPractices: authorizedPractices } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const limit = searchParams.get("limit") || undefined || 5000;
    const pageSize = 50;
    const [bookmarkId, setBookmarkId] = (0, $f2Y41.useState)(searchParams.get("bookmarkId") ? searchParams.get("bookmarkId") : localStorage.getItem("bookmarkId"));
    const [initialState, setInitialState] = (0, $f2Y41.useState)(true);
    const [updateFilterAndSort, setUpdateFilterAndSort] = (0, $f2Y41.useState)(false);
    const [bookmarkPracticeId, setBookmarkPracticeId] = (0, $f2Y41.useState)(undefined);
    const [filterAndSort, setFilterAndSort] = (0, $f2Y41.useState)(undefined);
    const [search, setSearch] = (0, $f2Y41.useState)("");
    const defaultWidth = 150;
    const apiRef = (0, $ecec77438df551f3$export$2981a24b8ea6f728)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: patientsData, isValidating: isValidatingPatients, error: isErrorPatients, mutate: mutatePatients, size: pagePatients, setSize: setPagePatients } = (0, $b2d06586a86d14b7$export$70bb55947bcc94e6)(bookmarkId && practiceId && `patients_filter_and_sort/${bookmarkId}`, `practice_id=${practiceId}`, {
        pageSize: pageSize
    });
    const { data: patientQueryCount } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)(bookmarkId && practiceId && "patients_filter_and_sort_count", bookmarkId, `practice_id=${practiceId}`);
    (0, $f2Y41.useEffect)(()=>{
        console.dir("isErrorPatients");
        console.dir(isErrorPatients);
        // if (isErrorPatients) {
        //   localStorage.removeItem("bookmarkId")
        // }
        return ()=>{};
    }, [
        isErrorPatients
    ]);
    const [patients, setPatients] = (0, $f2Y41.useState)([]);
    const [selection, setSelection] = (0, $f2Y41.useState)(false);
    const toggleSelection = ()=>setSelection(!selection);
    const selectionEnabled = ()=>(0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser);
    const [modalOpen, setModalOpen] = (0, $f2Y41.useState)();
    (0, $f2Y41.useEffect)(()=>{
        if (!patientsData) return;
        const newPatients = patientsData.flatMap((data)=>data.data);
        setPatients([
            ...newPatients
        ]);
        return ()=>setPatients([]);
    }, [
        patientsData
    ]);
    const handleScroll = ()=>{
        if (patients.length > 0) setPagePatients(pagePatients + 1);
    };
    const isLoadingPatients = ()=>patients.length === 0;
    const columnDefaults = {
        width: defaultWidth,
        getApplyQuickFilterFn: undefined,
        display: "flex"
    };
    const columns = [
        {
            ...columnDefaults,
            field: "Continue Screen",
            headerName: "",
            width: 110,
            renderCell: (params)=>$425ea3415c0ea86d$var$renderCellContinueScreen(params, filterAndSort),
            sortable: false,
            filterable: false,
            disableColumnMenu: true
        },
        {
            ...columnDefaults,
            field: "full_name",
            headerName: "Name",
            width: 200,
            valueGetter: $425ea3415c0ea86d$var$valueGetterFullName
        },
        {
            ...columnDefaults,
            field: "mrn",
            headerName: "MRN",
            width: defaultWidth
        },
        {
            ...columnDefaults,
            field: "screens",
            headerName: "Study",
            width: 200,
            valueGetter: $425ea3415c0ea86d$var$valueGetterScreens,
            renderCell: (params)=>$425ea3415c0ea86d$var$renderCellScreens(params, filterAndSort),
            getApplyQuickFilterFn: undefined,
            sortable: false
        },
        {
            ...columnDefaults,
            field: "statuses",
            headerName: "Status",
            width: 200,
            valueGetter: $425ea3415c0ea86d$var$valueGetterScreens,
            renderCell: (params)=>$425ea3415c0ea86d$var$renderCellScreenStatusTitle(params, filterAndSort),
            getApplyQuickFilterFn: undefined,
            sortable: false
        },
        {
            ...columnDefaults,
            field: "confidence_score",
            headerName: "Confidence Score",
            width: 220,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "confidence_score"),
            renderCell: $425ea3415c0ea86d$var$renderCellOverflowAuto,
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "next_appointment",
            type: "dateTime",
            headerName: "Next Appointment",
            width: 175,
            valueGetter: $425ea3415c0ea86d$var$valueGetterNextAppointment,
            valueFormatter: $425ea3415c0ea86d$var$valueFormatterNextAppointment,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "next_appointment_type",
            headerName: "Next Appointment Type",
            width: 175,
            valueGetter: $425ea3415c0ea86d$var$valueGetterNextAppointmentType,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "next_appointment_location",
            headerName: "Next Appointment Location",
            width: 175,
            valueGetter: $425ea3415c0ea86d$var$valueGetterNextAppointmentLocation,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "last_appointment",
            type: "dateTime",
            headerName: "Last Appointment",
            width: 175,
            valueGetter: $425ea3415c0ea86d$var$valueGetterLastAppointment,
            valueFormatter: $425ea3415c0ea86d$var$valueFormatterLastAppointment,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "last_appointment_type",
            headerName: "Last Appointment Type",
            width: 175,
            valueGetter: $425ea3415c0ea86d$var$valueGetterLastAppointmentType,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "last_appointment_location",
            headerName: "Last Appointment Location",
            width: 175,
            valueGetter: $425ea3415c0ea86d$var$valueGetterLastAppointmentLocation,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "dob",
            headerName: "DOB",
            width: defaultWidth,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "referring_provider",
            headerName: "Provider",
            width: defaultWidth,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "assigned",
            headerName: "Assigned",
            width: 200,
            valueGetter: $425ea3415c0ea86d$var$valueGetterScreens,
            renderCell: (params)=>$425ea3415c0ea86d$var$renderCellAssignedTo(params, filterAndSort),
            getApplyQuickFilterFn: undefined,
            sortable: false,
            filterOperators: (0, $83e90461781fd067$export$dff3a5bcde5c5e41)().filter((value, row, column, apiRef)=>[
                    "isEmpty",
                    "isNotEmpty"
                ].includes(value))
        },
        {
            ...columnDefaults,
            field: "phone",
            headerName: "Phone Number",
            width: defaultWidth
        },
        {
            ...columnDefaults,
            field: "contact_count",
            headerName: "Contacts",
            width: defaultWidth,
            valueGetter: $425ea3415c0ea86d$var$valueGetterContacts
        },
        {
            ...columnDefaults,
            field: "contact_count_phone",
            headerName: "Phone Contacts",
            width: defaultWidth,
            valueGetter: $425ea3415c0ea86d$var$valueGetterContactsPhone
        },
        {
            ...columnDefaults,
            field: "can_contact",
            headerName: "Can Contact",
            width: defaultWidth,
            valueGetter: (value, row, column, apiRef)=>value === true ? "Yes" : "No",
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "follow_up_reason",
            headerName: "Follow Up Reason",
            width: 175,
            renderCell: $425ea3415c0ea86d$var$renderCellOverflow,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "follow_up_reason"),
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "follow_up_dt",
            headerName: "Follow Up Date",
            width: 175,
            renderCell: $425ea3415c0ea86d$var$renderCellStudyDateTime,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "follow_up_dt"),
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "disqualification_reason",
            headerName: "Disqualification Reason",
            width: 175,
            renderCell: $425ea3415c0ea86d$var$renderCellOverflow,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "disqualification_reason"),
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "disqualification_detail",
            headerName: "Disqualification Detail",
            width: 175,
            renderCell: $425ea3415c0ea86d$var$renderCellOverflow,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "disqualification_detail"),
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "status_updated_at",
            headerName: "Last Status Change Date",
            width: 175,
            renderCell: $425ea3415c0ea86d$var$renderCellStudyDateTime,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "status_updated_at"),
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "preferred_language",
            headerName: "Preferred Language",
            width: defaultWidth,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "preferred_contact_time",
            headerName: "Preferred Contact Time",
            width: 180,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "source",
            headerName: "Source",
            valueGetter: (params)=>params?.value ? (0, $17235661ec5f519b$export$b94aa994a2f01789)(params?.value) : null,
            width: 200,
            getApplyQuickFilterFn: undefined
        },
        {
            ...columnDefaults,
            field: "esource_xref_id",
            headerName: "CRIO ID",
            width: 200,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "esource_xref_id"),
            renderCell: $425ea3415c0ea86d$var$renderCellOverflowAuto,
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "feedback_score",
            headerName: "Potential",
            width: 220,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$var$valueGetterStars($425ea3415c0ea86d$export$188923b176516c9a(value, row, column, apiRef, filterAndSort, "feedback_score")),
            renderCell: $425ea3415c0ea86d$var$renderCellStars,
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "created_at",
            type: "dateTime",
            headerName: "Created",
            width: 220,
            getApplyQuickFilterFn: undefined,
            valueFormatter: (value, row, column, apiRef)=>(0, $0dcae3260236e0d2$export$709bb038489fb0)(value)
        },
        {
            ...columnDefaults,
            field: "updated_at",
            headerName: "Last Updated",
            width: 220,
            valueGetter: (value, row, column, apiRef)=>$425ea3415c0ea86d$var$valueGetterUpdatedAt(value, row, column, apiRef, filterAndSort),
            renderCell: $425ea3415c0ea86d$var$renderCellOverflowAuto,
            getApplyQuickFilterFn: undefined,
            filterable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters),
            sortable: $425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)
        },
        {
            ...columnDefaults,
            field: "",
            type: "actions",
            headerName: "",
            width: 150,
            renderCell: ()=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {}),
            sortable: false,
            filterable: false,
            hideable: false,
            disableColumnMenu: true,
            flex: 1,
            align: "left",
            headerAlign: "left"
        }
    ];
    const customSortableColumns = [
        "updated_at",
        "created_at",
        "next_appointment",
        "dob"
    ];
    const [quickAddOpen, setQuickAddOpen] = (0, $f2Y41.useState)(searchParams.get("quick_add") === "open");
    const [filtersOpen, setFiltersOpen] = (0, $f2Y41.useState)(false);
    const [rowSelectionModel, setRowSelectionModel] = (0, $f2Y41.useState)([]);
    const [disableColumnFilter, setDisableColumnFilter] = (0, $f2Y41.useState)(false);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const getRowHeight = (0, $f2Y41.useCallback)(({ model: model, densityFactor: densityFactor })=>{
        // Leaving this here as a reminder: Don't fight the framework :)
        // return model.screens.length * 20 * densityFactor + 20
        return "auto";
    }, []);
    // Init Columns from Localstorage
    (0, $f2Y41.useEffect)(()=>{
        for (const key of searchParams.keys())if (key.includes("filter_") || key.includes("sort_")) searchParams.delete(key);
        apiRef.current.subscribeEvent("filterModelChange", handleFilterModelChange);
        apiRef.current.subscribeEvent("sortModelChange", handleSortModelChange);
        apiRef.current.subscribeEvent("columnVisibilityModelChange", handleColumnVisibilityChange);
        const newColumnVisibilityModelRaw = localStorage.getItem("columnVisibilityModel");
        if (newColumnVisibilityModelRaw !== null) {
            const newColumnVisibilityModel = JSON.parse(newColumnVisibilityModelRaw);
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
        }
    }, [
        searchParams,
        apiRef.current.subscribeEvent,
        apiRef.current.setColumnVisibilityModel
    ]);
    // Update Columns when they change
    const handleColumnVisibilityChange = (gridVisibilityModel, _event, _details)=>localStorage.setItem("columnVisibilityModel", JSON.stringify(gridVisibilityModel));
    (0, $f2Y41.useEffect)(()=>{
        if (!filterAndSort && bookmarkId && practiceId) (async ()=>{
            try {
                const { data: data, status: status } = await (0, $b2d06586a86d14b7$export$99b32c99608275e1)("filter_and_sort_bookmark", `${bookmarkId}`, getAccessTokenSilently);
                const content = data?.data?.content ? JSON.parse(data?.data?.content) : undefined;
                if (content.practice_id === practiceId || content.practice_id === undefined) {
                    setFilterAndSort(content ?? content);
                    setSearch(content?.search ?? "");
                    content.search = undefined;
                } else {
                    setBookmarkPracticeId(content.practice_id);
                    setModalOpen((0, $4d7392d447faa322$export$23344047f1eff04b).Bookmark);
                }
            } catch (error) {
                console.dir(error);
                setFilterAndSort($425ea3415c0ea86d$var$DEFAULT_FILTER_AND_SORT);
                return;
            }
        })();
    }, [
        practiceId,
        bookmarkId,
        filterAndSort,
        getAccessTokenSilently
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (bookmarkId && searchParams.get("bookmarkId") !== bookmarkId && (0, (/*@__PURE__*/$parcel$interopDefault($by6IX)))(bookmarkId)) {
            searchParams.set("bookmarkId", bookmarkId);
            setSearchParams(searchParams);
        }
    }, [
        bookmarkId,
        searchParams,
        setSearchParams
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (!practiceId) return;
        if (bookmarkId && (0, (/*@__PURE__*/$parcel$interopDefault($by6IX)))(bookmarkId)) localStorage.setItem("bookmarkId", bookmarkId);
        else (async ()=>{
            console.dir("useEffectPracticeID");
            console.dir(practiceId);
            const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("filter_and_sort_bookmark", {
                filter_and_sort: $425ea3415c0ea86d$var$DEFAULT_FILTER_AND_SORT(practiceId)
            }, getAccessTokenSilently);
            setBookmarkId(response?.data?.data?.id);
        })();
    }, [
        bookmarkId,
        getAccessTokenSilently,
        practiceId
    ]);
    (0, $f2Y41.useEffect)(()=>{
        if (!filterAndSort || !practiceId) return;
        if (initialState) {
            const newGridFilterLinkOperator = filterAndSort?.filtering?.linkOperator || "and";
            const newGridSortModel = filterAndSort?.sorting || [];
            const newGridFilterModel = {
                items: filterAndSort?.filtering?.filters.map(({ field: field, operator_value: operator_value, value: value })=>({
                        id: field,
                        field: field,
                        operator: operator_value,
                        value: value
                    }))
            };
            apiRef.current.setFilterModel(newGridFilterModel, "upsertFilterItems");
            apiRef.current.setSortModel(newGridSortModel);
            apiRef.current.setFilterLogicOperator(newGridFilterLinkOperator);
            setInitialState(false);
        } else (async ()=>{
            const data = {
                filter_and_sort: {
                    ...filterAndSort,
                    search: search,
                    practice_id: practiceId
                }
            };
            const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("filter_and_sort_bookmark", data, getAccessTokenSilently);
            setBookmarkId(response?.data?.data?.id);
        })();
    }, [
        filterAndSort,
        search,
        apiRef.current.setFilterModel,
        apiRef.current.setSortModel,
        apiRef.current.setFilterLogicOperator,
        practiceId,
        initialState,
        getAccessTokenSilently
    ]);
    const handleSortModelChange = (gridSortModel)=>{
        setFilterAndSort((filterAndSort)=>({
                filtering: filterAndSort?.filtering ?? {
                    filters: [],
                    link_operator: "and"
                },
                sorting: gridSortModel
            }));
    };
    const handleFilterModelChange = (gridFilterModel, details)=>{
        if (details.reason === undefined || filterAndSort === undefined) return;
        const filters = gridFilterModel.items?.map(({ field: field, operator: operator, value: value })=>{
            if (field === "screens") field = "study";
            return {
                id: field,
                field: field,
                operator_value: operator,
                value: value
            };
        });
        const selections = ((filterAndSort)=>{
            return filterAndSort?.filtering?.filters?.filter((filterToCheck)=>[
                    "study",
                    "status",
                    "assigned"
                ].includes(filterToCheck?.field) && !filters.find((filter)=>filter.field === filterToCheck?.field)) || [];
        })(filterAndSort);
        const filtering = {
            link_operator: gridFilterModel?.logicOperator || "and",
            filters: selections ? filters.concat(selections) : filters
        };
        setFilterAndSort((filterAndSort)=>({
                sorting: filterAndSort?.sorting ?? [],
                filtering: filtering
            }));
    };
    const handleColumnVisibilityModelChange = (model, details)=>{
        setColumnVisibilityModel(model);
        localStorage.setItem("columnVisibilityModel", JSON.stringify(model));
    };
    const handleSelectionModelChange = (newRowSelectionModel)=>{
        setRowSelectionModel(newRowSelectionModel);
        if (newRowSelectionModel?.length > 0) setModalOpen((0, $4d7392d447faa322$export$23344047f1eff04b).BulkAssign);
        else if (newRowSelectionModel?.length === 0) setModalOpen(null);
    };
    const handleAssign = (newAssignedToUserId)=>{
        const payload = {
            assigned_to_user_id: newAssignedToUserId
        };
        // TODO: figure out how to get screen_ids from directory, only if it's filtered by study
        return (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("bulk_requests", {
            model: "Screen",
            payload: payload,
            entities: []
        }, getAccessTokenSilently);
    };
    const handleArchive = async ()=>{
        const archiveResponse = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("bulk_patient_deletion_requests", {
            patients: rowSelectionModel
        }, getAccessTokenSilently);
        mutatePatients();
        return archiveResponse;
    };
    const columnVisibilityModelInitial = ()=>{
        const columnVisibilityModelDefault = {
            // Hide these columns by default, the other columns will remain visible
            study: false,
            status: false,
            source: false,
            dob: false,
            referring_provider: false,
            phone: false,
            can_contact: false,
            next_appointment_type: false,
            last_appointment_type: false,
            contact_count_phone: false,
            preferred_language: false,
            preferred_contact_time: false,
            updated_at: false,
            created_at: false
        };
        return localStorage.getItem("columnVisibilityModel") !== null ? (0, $940beea38a6921ba$export$bbc0fd08dc1b8ad7)(localStorage.getItem("columnVisibilityModel")) : columnVisibilityModelDefault;
    };
    const [columnVisibilityModel, setColumnVisibilityModel] = (0, $f2Y41.useState)(columnVisibilityModelInitial());
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            isErrorPatients ? "Failed to load patients. Is your VPN connected?" : "",
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $f8132ba269dab044$export$4e44e22a11c53e58), {
                open: quickAddOpen,
                setOpen: setQuickAddOpen,
                refreshData: mutatePatients
            }),
            modalOpen === (0, $4d7392d447faa322$export$23344047f1eff04b).BulkAssign && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $eac6beb5fd754052$export$a35513874f4afb4e), {
                setOpen: setModalOpen,
                handleAssign: handleAssign,
                handleArchive: handleArchive
            }),
            modalOpen === (0, $4d7392d447faa322$export$23344047f1eff04b).Bookmark && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $e6e1101ce7a3066a$export$430b88e3a7edeac4), {
                setOpen: setModalOpen,
                setDefaultFilterAndSort: ()=>setFilterAndSort($425ea3415c0ea86d$var$DEFAULT_FILTER_AND_SORT),
                changePractice: ()=>changePractice(bookmarkPracticeId)
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex h-full py-5 bg-gray-100 text-black dark:bg-gray-800 dark:text-gray-100",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow ml-3",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        apiRef: apiRef,
                        rows: patients,
                        rowCount: patientQueryCount.count,
                        columns: columns,
                        checkboxSelection: selectionEnabled(),
                        onRowSelectionModelChange: handleSelectionModelChange,
                        disableDensitySelector: true,
                        disableColumnFilter: false,
                        getRowHeight: getRowHeight,
                        initialState: {
                            density: "comfortable"
                        },
                        filterMode: "server",
                        sortingMode: "server",
                        onFilterModelChange: handleFilterModelChange,
                        onSortModelChange: handleSortModelChange,
                        loading: isValidatingPatients,
                        columnVisibilityModel: columnVisibilityModel,
                        onColumnVisibilityModelChange: handleColumnVisibilityModelChange,
                        onRowsScrollEnd: handleScroll,
                        localeText: {
                            toolbarColumns: "Details"
                        },
                        onCellDoubleClick: (params, event)=>{
                            event.defaultMuiPrevented = true;
                            const patientPath = `/patients/${params.row.id}`;
                            const screens = $425ea3415c0ea86d$var$currentlyFilteredScreens(params?.row?.screens, filterAndSort);
                            if (screens.length === 0 || screens.length > 1) {
                                navigate(`${patientPath}/screens`);
                                return;
                            }
                            navigate(`${patientPath}/screens/${params?.row?.screens?.[0]?.id}`);
                        },
                        sx: {
                            border: "none",
                            height: "85%",
                            width: "99%",
                            "& .MuiDataGrid-columnHeaderTitle": {
                                textTransform: "capitalize",
                                fontFamily: "Inter",
                                fontWeight: "700",
                                fontSize: "12pt",
                                color: "black"
                            },
                            ".dark & .MuiDataGrid-columnHeaderTitle": {
                                color: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[200]
                            },
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "white",
                                borderBottom: "none"
                            },
                            ".dark & .MuiDataGrid-columnHeaders": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            ".dark & .MuiDataGrid-columnHeader": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            "& .MuiDataGrid-columnHeader--moving": {
                                backgroundColor: "white"
                            },
                            ".dark & .MuiDataGrid-columnHeader--moving": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            "& .MuiDataGrid-toolbarContainer": {
                                "& .MuiButton-root": {
                                    color: "white"
                                }
                            },
                            "& .MuiButtonBase-root": {
                                color: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            ".dark & .MuiButtonBase-root": {
                                color: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[100]
                            },
                            "&": {
                                display: "flex-grow",
                                height: "100%",
                                justifyContent: "flex-end"
                            },
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[100]
                            },
                            ".dark & .MuiDataGrid-row:hover": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[600]
                            },
                            "& .MuiDataGrid-virtualScrollerContent": {
                                backgroundColor: "white"
                            },
                            ".dark & .MuiDataGrid-virtualScrollerContent": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            ".dark & .MuiDataGrid-virtualScroller": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            "& .MuiDataGrid-footerContainer": {
                                backgroundColor: "white",
                                borderBottomLeftRadius: ".5rem",
                                borderBottomRightRadius: ".5rem"
                            },
                            ".dark & .MuiDataGrid-footerContainer": {
                                backgroundColor: $425ea3415c0ea86d$var$fullConfig.theme.colors.gray[700]
                            },
                            "& .MuiDataGridPro-toolbarContainer": {
                                justifyContent: "flex-end"
                            },
                            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                py: "4px"
                            },
                            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                py: "7px"
                            },
                            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                py: "7px"
                            },
                            "&.MuiDataGrid-filterFormValueInput": {
                                backgroundColor: "red"
                            }
                        },
                        slots: {
                            toolbar: (0, $cf2242ddcdea7096$export$95036c0a3d808bad),
                            loadingOverlay: (0, $ef16e495f7368302$export$2e2bcd8739ae039)
                        },
                        slotProps: {
                            filterPanel: {
                                sx: {
                                    minWidth: "50vw"
                                },
                                filterFormProps: {
                                    valueInputProps: {
                                        sx: {
                                            width: "inherit"
                                        }
                                    }
                                }
                            },
                            toolbar: {
                                currentUser: currentUser,
                                setQuickAddOpen: setQuickAddOpen,
                                navigate: navigate,
                                filtersOpen: filtersOpen,
                                setFiltersOpen: setFiltersOpen,
                                customSortableColumns: customSortableColumns,
                                columns: columns,
                                disableColumnFilter: disableColumnFilter,
                                setDisableColumnFilter: setDisableColumnFilter,
                                filterAndSort: filterAndSort,
                                setFilterAndSort: setFilterAndSort,
                                search: search,
                                csvOptions: {
                                    disableToolbarButton: !(0, $601cdae3149c9149$export$fc970ed23da99565)(currentUser)
                                },
                                printOptions: {
                                    disableToolbarButton: true
                                },
                                setSearch: setSearch,
                                isValidatingPatients: isValidatingPatients
                            }
                        }
                    })
                })
            })
        ]
    });
}
// const superCustomStudyFilterOperator: GridFilterOperator[] = [{
//   label: 'is',
//   value: 'equals',
//   InputComponent: InputScreenFilter,
//   getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
//     // [ 'AA', 'prequalified, 'phone_screen' ]
//     // [ 'AA', null, 'phone_screen' ]
//     // [ 'AA', in_progress, null ]
//     // [ null, null, 'phone_screen' ]
//     // value is a screen
//     return ({ value: screens }): boolean => {
//       if (screens === undefined) return false
//       if (filterItem?.value === undefined) return false
//       if (filterItem?.value?.length > 3) return true // migration from 4 args to 3, this should cause the filter to match all, until you clear out the filters and reset
//       // TODO: ilike functionality
//       // this is effectively an AND between the criteria
//       if (filterItem.value[0] != undefined) {
//         screens = screens.filter(screen => screen.study?.abbreviation == filterItem.value[0])
//       }
//       if (filterItem.value[1] != undefined) {
//         screens = screens.filter(screen => screen.status == filterItem.value[1])
//       }
//       if (filterItem.value[2] != undefined) {
//         screens = screens.filter(screen => screen.assigned_to?.name == filterItem.value[2])
//       }
//       return screens.length > 0
//     }
//   },
// }]
const $425ea3415c0ea86d$var$currentlyFilteredScreens = (screens, filterAndSort)=>{
    const screenFilterValue = filterAndSort?.filtering?.filters?.find((filterModelValue)=>filterModelValue.field === "study")?.value;
    return $425ea3415c0ea86d$var$sortScreens(screens)?.filter((screen)=>!screenFilterValue || screen?.study?.abbreviation === screenFilterValue);
};
const $425ea3415c0ea86d$var$moreScreens = (screens, apiRef = (0, $e87e8a83fc996e91$export$2d14edd3a7db3bbf)())=>{
    const filterModel = (0, $193e08cc82c187d1$export$f96fd476863f2e4a)(apiRef, (0, $896120ab6e9a1a0e$export$280aedb9454597a5));
    const screenFilterValue = filterModel?.items.find((filterModelValue)=>filterModelValue.field === "study")?.value;
    return screens.filter((screen)=>screenFilterValue && screen?.study?.abbreviation !== screenFilterValue)?.length;
};
const $425ea3415c0ea86d$var$renderCellScreens = (params, filterAndSort)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex-col w-full align-baseline",
        children: $425ea3415c0ea86d$var$currentlyFilteredScreens(params?.row?.screens, filterAndSort)?.map((screen)=>/*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
                to: `/patients/${params.row.id}/screens/${screen.id}`,
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da10e49b852b9347$export$55c72165ec0b2743), {
                    text: screen?.study?.abbreviation?.substring(0, 13),
                    status: screen.status
                })
            }, screen.id))
    });
const $425ea3415c0ea86d$var$renderCellScreenStatusTitle = (params, filterAndSort)=>{
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex-col space-y-4",
        children: $425ea3415c0ea86d$var$currentlyFilteredScreens(params?.row?.screens, filterAndSort)?.map((screen)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("p", {
                    className: "font-semibold",
                    children: [
                        " ",
                        screen?.status ? (0, $17235661ec5f519b$export$b94aa994a2f01789)(screen.status?.split("_").join(" ")) : "Unknown Status"
                    ]
                })
            }, screen?.id))
    });
};
const $425ea3415c0ea86d$var$renderCellAssignedTo = (params, filterAndSort)=>{
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex-col space-y-4",
        children: $425ea3415c0ea86d$var$currentlyFilteredScreens(params?.row?.screens, filterAndSort)?.map((screen)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                    children: screen?.assigned_to?.name
                })
            }, screen?.id))
    });
};
const $425ea3415c0ea86d$var$renderCellOverflow = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: `flex h-8 text-xs overflow-clip ${params.value === "Select a Study" ? "items-center" : ""}`,
        title: params.value || "None",
        children: params.value
    });
const $425ea3415c0ea86d$var$handleScreenStart = async (studyId, patientId, practiceId, getAccessTokenSilently, navigate)=>{
    if (!studyId) return;
    const data = {
        study_id: studyId,
        patient_id: patientId,
        practice_id: practiceId,
        status: "chart_review"
    };
    const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("screens", data, getAccessTokenSilently);
    const screenId = response?.data?.data?.id;
    if (screenId) navigate(`/patients/${patientId}/screens/${screenId}`);
};
const $425ea3415c0ea86d$var$renderCellContinueScreen = (params, filterAndSort)=>{
    const screen_filter = filterAndSort?.filtering?.filters?.find((item)=>item.field === "study")?.value;
    let screens = [];
    if (screen_filter) screens = $425ea3415c0ea86d$var$currentlyFilteredScreens(params?.row?.screens, filterAndSort).filter((screen)=>screen.study.abbreviation === screen_filter);
    else screens = params?.row?.screens;
    if (screens?.length > 1 || screens?.length === 0) return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {});
    const screen = screens?.[0];
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$a6c7ac8248d6e38a), {
        to: `/patients/${params?.row?.id}/screens/${screen?.id}`,
        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
            className: "border border-topo-green-200 bg-transparent hover:bg-topo-green-100 dark:hover:bg-topo-green-800 hover:bg-opacity-50 focus:bg-topo-green-700 focus:outline-none focus:ring-2 focus:ring-topo-green-800 focus:ring-offset-2 text-topo-green dark:hover:text-topo-green-200 text-xs font-medium mr-6 px-2.5 py-1.5 rounded-md flex items-center justify-between",
            title: screen?.study?.abbreviation,
            children: [
                "Screen",
                /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                    icon: "ArrowCircleRightIcon",
                    className: "ml-1 w-5 h-5 flex"
                })
            ]
        })
    });
};
const $425ea3415c0ea86d$var$renderCellStudyDateTime = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex-row w-full space-y-1 text-xs",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "text-xs",
            children: params.value === "Select a Study" ? params.value : params.value ? (0, $0dcae3260236e0d2$export$d207855dff529fc9)(params.value) : "None"
        })
    });
const $425ea3415c0ea86d$var$renderCellOverflowAuto = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-xs",
        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
            className: "overflow-auto",
            children: params.value
        })
    });
const $425ea3415c0ea86d$var$renderCellSource = (params)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "text-xs",
        children: params?.value ? (0, $17235661ec5f519b$export$b94aa994a2f01789)(params.value) : ""
    });
const $425ea3415c0ea86d$var$renderCellStars = (params)=>{
    if (params.value === "Select a Study") return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex text-xs",
        children: params.value
    });
    const stars = Array.from({
        length: params?.value
    }, (_, i)=>i + 1);
    return /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
        className: "flex space-x-1",
        children: stars.map((star)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "",
                children: "\u2B50"
            }, star))
    });
};
const $425ea3415c0ea86d$var$sortScreens = (screens)=>screens.slice().sort((v1, v2)=>new Date(v2.updated_at).getTime() - new Date(v1.updated_at).getTime());
// .filter((screen) => screen.status && screen.status != 'not_started' && screen.status != 'disqualified')
const $425ea3415c0ea86d$var$sortComparatorScreenStatus = (v1, v2, cellParams1, cellParams2)=>{
    const statuses = {
        not_started: 60,
        prequalified: 50,
        in_progress: 40,
        qualified: 30,
        disqualified: 20,
        moved_to_esource: 10
    };
    if (statuses[v2] === undefined) return -100;
    if (statuses[v1] === undefined) return 100;
    return statuses[v1] - statuses[v2];
};
const $425ea3415c0ea86d$var$valueGetterContacts = (value, row, column, apiRef)=>{
    return row?.contact_count && Object.values(row?.contact_count)?.reduce((totalContacts, currentContactValue)=>totalContacts + currentContactValue, 0);
};
const $425ea3415c0ea86d$var$valueGetterContactsPhone = (value, row, column, apiRef)=>row.contact_count?.["Phone Call"];
const $425ea3415c0ea86d$var$valueGetterFullName = (value, row, column, apiRef)=>{
    const suffix = row.suffix?.length > 0 ? `, ${row.suffix}` : "";
    return `${row.given_name} ${row.family_name}${suffix}`;
};
//TODO: There's a bug here.  return something that can be filtered on (3 item array)
const $425ea3415c0ea86d$var$valueGetterScreens = (value, row, column, apiRef)=>$425ea3415c0ea86d$var$sortScreens(row.screens);
const $425ea3415c0ea86d$var$singleStudyView = (filters)=>!!filters?.find((item)=>item.field === "study")?.value;
const $425ea3415c0ea86d$export$188923b176516c9a = (value, row, column, apiRef, filterAndSort, screenField)=>{
    if (!$425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)) return "Select a Study";
    const screenFilterValue = filterAndSort?.filtering?.filters?.find((filterModelValue)=>filterModelValue.field === "study")?.value;
    const currentlyFilteredScreens = $425ea3415c0ea86d$var$sortScreens(row.screens)?.filter((screen)=>!screenFilterValue || screen?.study?.abbreviation === screenFilterValue);
    return currentlyFilteredScreens?.[0]?.[screenField];
};
const $425ea3415c0ea86d$var$valueGetterStars = (feedback_score)=>{
    if (feedback_score === "Select a Study") return feedback_score;
    if (!feedback_score) return 0;
    // Bound within the range of 0 to 100
    const bounded = Math.max(0, Math.min(100, feedback_score));
    // Adjust to the nearest of 0, 25, 50, 75, 100
    const adjusted = Math.round(bounded / 25) * 25;
    // Map directly to 1-5 (0=1, 25=2, 50=3, 75=4, 100=5)
    return adjusted / 25 + 1;
};
const $425ea3415c0ea86d$var$valueGetterUpdatedAt = (value, row, column, apiRef, filterAndSort)=>{
    if (!$425ea3415c0ea86d$var$singleStudyView(filterAndSort?.filtering?.filters)) return "Select a Study";
    const screenFilterValue = filterAndSort?.filtering?.filters?.find((filterModelValue)=>filterModelValue.field === "study")?.value;
    const currentlyFilteredScreens = $425ea3415c0ea86d$var$sortScreens(row.screens)?.filter((screen)=>!screenFilterValue || screen?.study?.abbreviation === screenFilterValue);
    return (0, $0dcae3260236e0d2$export$709bb038489fb0)(currentlyFilteredScreens?.[0]?.updated_at);
};
// This sorts patient_appointments_last by start_dt and returns the most recent one as an ISO date
const $425ea3415c0ea86d$var$lastAppointment = (appointments)=>appointments?.sort((a, b)=>Date.parse(b.start_dt) - Date.parse(a.start_dt))?.slice(0, 1);
// This sorts patient_appointments_future by start_dt and returns the next soonest one as an ISO date
const $425ea3415c0ea86d$var$nextAppointment = (appointments)=>appointments?.sort((a, b)=>Date.parse(a.start_dt) - Date.parse(b.start_dt))?.slice(0, 1);
const $425ea3415c0ea86d$var$valueGetterLastAppointment = (value, row, column, apiRef)=>$425ea3415c0ea86d$var$lastAppointment(row?.patient_appointments_past)?.map((patient_appointment)=>(0, $0dcae3260236e0d2$export$3573c25f30e0099d)(patient_appointment?.start_dt))?.[0];
const $425ea3415c0ea86d$var$valueFormatterLastAppointment = (value, row, column, apiRef)=>(0, $0dcae3260236e0d2$export$709bb038489fb0)(new Date(value).toJSON());
const $425ea3415c0ea86d$var$valueGetterLastAppointmentType = (value, row, column, apiRef)=>$425ea3415c0ea86d$var$lastAppointment(row?.patient_appointments_past)?.[0]?.appointment_type;
const $425ea3415c0ea86d$var$valueGetterLastAppointmentLocation = (value, row, column, apiRef)=>$425ea3415c0ea86d$var$lastAppointment(row?.patient_appointments_past)?.[0]?.appointment_location;
const $425ea3415c0ea86d$var$valueGetterNextAppointment = (value, row, column, apiRef)=>{
    return $425ea3415c0ea86d$var$nextAppointment(row?.patient_appointments_future)?.map((patient_appointment)=>(0, $0dcae3260236e0d2$export$3573c25f30e0099d)(patient_appointment?.start_dt))?.[0];
};
const $425ea3415c0ea86d$var$valueFormatterNextAppointment = (value, row, column, apiRef)=>(0, $0dcae3260236e0d2$export$709bb038489fb0)(new Date(value).toJSON());
const $425ea3415c0ea86d$var$valueGetterNextAppointmentType = (value, row, column, apiRef)=>$425ea3415c0ea86d$var$nextAppointment(row?.patient_appointments_future)?.[0]?.appointment_type;
const $425ea3415c0ea86d$var$valueGetterNextAppointmentLocation = (value, row, column, apiRef)=>$425ea3415c0ea86d$var$nextAppointment(row?.patient_appointments_future)?.[0]?.appointment_location;



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


function $75705be9d11f9282$export$6a633ab11e7a27c8() {
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: sponsors, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_sponsors", `practice_id=${practiceId}`);
    // const data = [
    //   {
    //     name: 'Novo Nordis',
    //     location: 'Denmark, EU',
    //     study_indications: ['NASH', 'IBD'],
    //     study_types: ['Interventional', 'Observational']
    //   },
    //   {
    //     name: 'Exact Sciences',
    //     location: 'California, USA',
    //     study_indications: ['NASH', 'IBD'],
    //     study_types: ['Interventional', 'Observational']
    //   },
    //   {
    //     name: 'Altimmune',
    //     location: 'Israel',
    //     study_indications: ['NASH', 'IBD'],
    //     study_types: ['Interventional', 'Observational']
    //   },
    //   {
    //     name: 'Gilead',
    //     location: 'California, USA',
    //     study_indications: ['NASH', 'IBD'],
    //     study_types: ['Interventional', 'Observational']
    //   },
    // ]
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                children: "Sponsors"
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex flex-col p-4",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "overflow-x-auto rounded-lg",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "inline-block min-w-full align-middle",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "overflow-hidden shadow sm:rounded-lg",
                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("table", {
                                className: "min-w-full divide-y divide-gray-200 dark:divide-gray-600 dark:border dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("thead", {
                                        className: "bg-gray-50 dark:bg-gray-700",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Sponsor Name"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Location"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Indications"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Study Types"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("tbody", {
                                        className: "bg-white dark:bg-gray-800",
                                        children: sponsors.map((sponsor, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                                className: index % 2 !== 0 ? "bg-gray-50 dark:bg-gray-700" : "",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-sm font-medium ",
                                                            children: sponsor.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-sm font-medium ",
                                                            children: sponsor.location
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                        children: sponsor.indications.map((indication)=>/*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md",
                                                                children: indication
                                                            }, `${sponsor.id}_${indication}`))
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: " text-sm whitespace-nowrap mr-2 px-2.5 py-0.5 rounded-md",
                                                        children: sponsor.study_types.map((study_type)=>/*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md",
                                                                children: study_type
                                                            }, `${sponsor.id}_${study_type}`))
                                                    })
                                                ]
                                            }, sponsor.id))
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");


var $ge3KO = parcelRequire("ge3KO");
function $b87a08e6e701ec15$export$62ec8b3633d3aa02(props) {
    let color = "";
    switch(props.text){
        case "Low":
            color = "gray";
            break;
        case "Medium":
            color = "yellow";
            break;
        case "High":
            color = "red";
            break;
        default:
            color = "blue";
            break;
    }
    return /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
        className: `bg-${color}-100 text-${color}-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md whitespace-nowrap`,
        children: props.text || "Unknown"
    });
}






function $bb1c9129a51e03c8$export$d34e4086b673edb0() {
    // TODO: Get this from global context provider
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("practice_studies");
    const { data: practice } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("practices", practiceId);
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const handleClickPracticeStudy = (practiceStudy)=>{
        const path = `/patients?filter_screens=${encodeURIComponent(JSON.stringify([
            practiceStudy.study.abbreviation,
            null,
            null
        ]))}`;
        navigate(path);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("h3", {
                className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                children: [
                    "Studies at ",
                    practice.name
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "flex flex-col p-4",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "overflow-x-auto rounded-lg",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "inline-block min-w-full align-middle",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "overflow-hidden shadow sm:rounded-lg shadow-gray-600",
                            children: /*#__PURE__*/ (0, $ge3KO.jsxs)("table", {
                                className: "min-w-full divide-y divide-gray-200 dark:divide-gray-600 border dark:border-gray-600",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("thead", {
                                        className: "bg-gray-50 dark:bg-gray-700",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Study Name"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Abbreviation"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Sponsor"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Study Type"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Indications"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Priority"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("th", {
                                                    scope: "col",
                                                    className: "p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-gray-400",
                                                    children: "Enrollment Start Date"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("tbody", {
                                        className: "bg-white dark:bg-gray-800",
                                        children: data.map((practice_study, index)=>/*#__PURE__*/ (0, $ge3KO.jsxs)("tr", {
                                                className: `${index % 2 !== 0 ? "bg-gray-100 dark:bg-gray-600 dark:hover-bg-gray-700" : ""} hover:cursor-pointer hover:bg-sky-50 dark:hover:bg-gray-700`,
                                                onClick: ()=>handleClickPracticeStudy(practice_study),
                                                onKeyUp: ()=>handleClickPracticeStudy(practice_study),
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "text-sm font-medium ",
                                                            children: practice_study.study.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                        children: practice_study.study.abbreviation
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                        children: practice_study.study.sponsor.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm dark:text-gray-400 w-72",
                                                        children: practice_study.study.description
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: " text-sm whitespace-nowrap mr-2 px-2.5 py-0.5",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                            className: "bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md",
                                                            children: practice_study.study.study_type
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "text-xs mr-2 px-2.5 py-0.5",
                                                        children: practice_study?.study?.indications?.map((indication)=>/*#__PURE__*/ (0, $ge3KO.jsx)("span", {
                                                                className: "bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-md",
                                                                children: indication.name
                                                            }, indication.name))
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $63d0624e3c0bc1b3$export$7d2c18701b008670), {
                                                            status: practice_study.study.status,
                                                            text: practice_study.study.status
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b87a08e6e701ec15$export$62ec8b3633d3aa02), {
                                                            text: practice_study.study.priority
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("td", {
                                                        className: "p-4 text-sm whitespace-nowrap dark:text-gray-400",
                                                        children: (0, $0dcae3260236e0d2$export$1d9850e26a13908a)(practice_study.study?.enrollment_start_dt)
                                                    })
                                                ]
                                            }, practice_study.id))
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");

var $f2Y41 = parcelRequire("f2Y41");






function $eb3b032cb110d81c$export$30b765d29ac16eee() {
    const navigate = (0, $c5383ff45095a6a6$export$9770f232ac06a008)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { currentUser: currentUser, isLoading: isLoadingCurrentUser } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: qualityAssurances, mutate: qualityAssuranceMutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("qa_screens", `practice_id=${practiceId}&assigned_to_user_id=${currentUser.id}`);
    const [qualityAssuranceModalOpen, setQualityAssuranceModalOpen] = (0, $f2Y41.useState)(false);
    const handleScreenNavigate = (screen_id, patient_id)=>{
        navigate(`/patients/${patient_id}/screens/${screen_id}`);
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "mt-10 p-6 rounded-lg border border-gray-200 shadow-md",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsxs)("h5", {
                        className: "text-2xl font-bold tracking-tight flex flex-row",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                icon: "ClipboardIcon",
                                className: "h-5 mr-2 self-center"
                            }),
                            "Quality Assurance"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "px-7 mt-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                className: "p-4 rounded-lg border border-gray-200 shadow-md bg-white dark:bg-transparent",
                children: [
                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                        className: "flex justify-between items-center",
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                            className: "p-4 mb-4 text-xl font-bold text-gray-900 dark:text-white",
                            children: "Studies"
                        })
                    }),
                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a70863221a643bf5$export$5c08eb181db25a28), {
                        screens: qualityAssurances,
                        handleScreenNavigate: handleScreenNavigate
                    })
                ]
            }),
            qualityAssuranceModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $84cc3a68d9541a98$export$30497a15bc25c6dd), {
                setOpen: setQualityAssuranceModalOpen,
                refreshData: qualityAssuranceMutate
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");
function $2f0b8860bb7ad921$export$77bc526bfccc9372() {
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "px-4 sm:px-6 md:px-0 mb-2",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("h1", {
                    className: "text-2xl font-semibold text-gray-900",
                    children: "Tasks"
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                children: "\uD83D\uDEA7 Coming soon \uD83D\uDEA7"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");





var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





function $6b79fe31db3264e4$export$9792e45199f71494(props) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: appointmentsIndex, isLoading: isLoadingAppointmentsIndex, mutate: mutateAppointmentsIndex } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("appointment_imports", `practice_id=${practiceId}`);
    const [createdAppointments, setCreatedAppointments] = (0, $f2Y41.useState)(null);
    const [creatingAppointments, setCreatingAppointments] = (0, $f2Y41.useState)(false);
    const handleClose = ()=>{
        props.setOpen(false);
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("uploads"));
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], handleClose);
    const handleAppointmentFinderClick = async ()=>{
        setCreatingAppointments(true);
        setCreatedAppointments(null);
        const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("appointment_imports", {
            practice_id: practiceId
        }, getAccessTokenSilently);
        setCreatingAppointments(false);
        setCreatedAppointments(response?.data);
        mutateAppointmentsIndex();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold dark:text-white",
                                        children: "AppointmentFinder\u2122\uFE0F"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>handleClose(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                    children: "X Button"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "p-6 space-y-6",
                                children: [
                                    !createdAppointments && /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "font-semibold",
                                                children: [
                                                    "Is there a file ready? ",
                                                    isLoadingAppointmentsIndex && "...",
                                                    " ",
                                                    appointmentsIndex?.[0] ? "Yes \u2705" : "No \u274C"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:bg-red-200 disabled:text-red-700",
                                                type: "submit",
                                                disabled: creatingAppointments || !appointmentsIndex?.[0],
                                                onClick: ()=>handleAppointmentFinderClick(),
                                                children: !creatingAppointments ? "Load Appointments" : "Loading..."
                                            })
                                        ]
                                    }),
                                    creatingAppointments && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-2xl",
                                        children: "\uD83D\uDD1C"
                                    }),
                                    createdAppointments && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-semibold",
                                        children: "Success \uD83C\uDF89"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "",
                                        children: createdAppointments && Object.entries(createdAppointments.data).map(([key, value])=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                children: [
                                                    `${(0, $17235661ec5f519b$export$b94aa994a2f01789)(key)}: ${value}`,
                                                    " "
                                                ]
                                            }))
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");



var $f2Y41 = parcelRequire("f2Y41");

var $f2Y41 = parcelRequire("f2Y41");

var $aT86D = parcelRequire("aT86D");

var $4nqhV = parcelRequire("4nqhV");
var $7004bd1fab40130e$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $7004bd1fab40130e$export$8cc09085015f0dc7(file, path) {
    var f = $7004bd1fab40130e$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $7004bd1fab40130e$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $7004bd1fab40130e$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $a7f65abd4bef59fc$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $a7f65abd4bef59fc$export$a36e16046ae8f1bb(evt) {
    return (0, $4nqhV.__awaiter)(this, void 0, void 0, function() {
        return (0, $4nqhV.__generator)(this, function(_a) {
            if ($a7f65abd4bef59fc$var$isObject(evt) && $a7f65abd4bef59fc$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $a7f65abd4bef59fc$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($a7f65abd4bef59fc$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $a7f65abd4bef59fc$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $a7f65abd4bef59fc$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $a7f65abd4bef59fc$var$isDataTransfer(value) {
    return $a7f65abd4bef59fc$var$isObject(value);
}
function $a7f65abd4bef59fc$var$isChangeEvt(value) {
    return $a7f65abd4bef59fc$var$isObject(value) && $a7f65abd4bef59fc$var$isObject(value.target);
}
function $a7f65abd4bef59fc$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $a7f65abd4bef59fc$var$getInputFiles(evt) {
    return $a7f65abd4bef59fc$var$fromList(evt.target.files).map(function(file) {
        return (0, $7004bd1fab40130e$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $a7f65abd4bef59fc$var$getFsHandleFiles(handles) {
    return (0, $4nqhV.__awaiter)(this, void 0, void 0, function() {
        var files;
        return (0, $4nqhV.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $7004bd1fab40130e$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $a7f65abd4bef59fc$var$getDataTransferFiles(dt, type) {
    return (0, $4nqhV.__awaiter)(this, void 0, void 0, function() {
        var items, files;
        return (0, $4nqhV.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $a7f65abd4bef59fc$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($a7f65abd4bef59fc$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $a7f65abd4bef59fc$var$noIgnoredFiles($a7f65abd4bef59fc$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $a7f65abd4bef59fc$var$noIgnoredFiles($a7f65abd4bef59fc$var$fromList(dt.files).map(function(file) {
                            return (0, $7004bd1fab40130e$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $a7f65abd4bef59fc$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $a7f65abd4bef59fc$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $a7f65abd4bef59fc$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $a7f65abd4bef59fc$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $a7f65abd4bef59fc$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $a7f65abd4bef59fc$var$fromDirEntry(entry);
    return $a7f65abd4bef59fc$var$fromDataTransferItem(item);
}
function $a7f65abd4bef59fc$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $4nqhV.__spreadArray)((0, $4nqhV.__spreadArray)([], (0, $4nqhV.__read)(acc), false), (0, $4nqhV.__read)(Array.isArray(files) ? $a7f65abd4bef59fc$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $a7f65abd4bef59fc$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $7004bd1fab40130e$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $a7f65abd4bef59fc$var$fromEntry(entry) {
    return (0, $4nqhV.__awaiter)(this, void 0, void 0, function() {
        return (0, $4nqhV.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $a7f65abd4bef59fc$var$fromDirEntry(entry) : $a7f65abd4bef59fc$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $a7f65abd4bef59fc$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $4nqhV.__awaiter)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $4nqhV.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($a7f65abd4bef59fc$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $a7f65abd4bef59fc$var$fromFileEntry(entry) {
    return (0, $4nqhV.__awaiter)(this, void 0, void 0, function() {
        return (0, $4nqhV.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $7004bd1fab40130e$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $aa2210dc7ea20769$export$1e511d4a378977f5;
var $aa2210dc7ea20769$export$2e2bcd8739ae039;
"use strict";
$aa2210dc7ea20769$export$1e511d4a378977f5 = true;
$aa2210dc7ea20769$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $acff6c09de855ac2$var$_toConsumableArray(arr) {
    return $acff6c09de855ac2$var$_arrayWithoutHoles(arr) || $acff6c09de855ac2$var$_iterableToArray(arr) || $acff6c09de855ac2$var$_unsupportedIterableToArray(arr) || $acff6c09de855ac2$var$_nonIterableSpread();
}
function $acff6c09de855ac2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $acff6c09de855ac2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $acff6c09de855ac2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $acff6c09de855ac2$var$_arrayLikeToArray(arr);
}
function $acff6c09de855ac2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $acff6c09de855ac2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $acff6c09de855ac2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $acff6c09de855ac2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $acff6c09de855ac2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $acff6c09de855ac2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $acff6c09de855ac2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $acff6c09de855ac2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $acff6c09de855ac2$var$_typeof(obj);
}
function $acff6c09de855ac2$var$_slicedToArray(arr, i) {
    return $acff6c09de855ac2$var$_arrayWithHoles(arr) || $acff6c09de855ac2$var$_iterableToArrayLimit(arr, i) || $acff6c09de855ac2$var$_unsupportedIterableToArray(arr, i) || $acff6c09de855ac2$var$_nonIterableRest();
}
function $acff6c09de855ac2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $acff6c09de855ac2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $acff6c09de855ac2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $acff6c09de855ac2$var$_arrayLikeToArray(o, minLen);
}
function $acff6c09de855ac2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $acff6c09de855ac2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $acff6c09de855ac2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $acff6c09de855ac2$export$d2c35cc369247232 = "file-invalid-type";
var $acff6c09de855ac2$export$d7bd1185abe1e87c = "file-too-large";
var $acff6c09de855ac2$export$8bd5ec6ed990dc9 = "file-too-small";
var $acff6c09de855ac2$export$3271ef1d2dd155f9 = "too-many-files";
var $acff6c09de855ac2$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $acff6c09de855ac2$export$d2c35cc369247232,
    FileTooLarge: $acff6c09de855ac2$export$d7bd1185abe1e87c,
    FileTooSmall: $acff6c09de855ac2$export$8bd5ec6ed990dc9,
    TooManyFiles: $acff6c09de855ac2$export$3271ef1d2dd155f9
}; // File Errors
var $acff6c09de855ac2$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $acff6c09de855ac2$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $acff6c09de855ac2$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $acff6c09de855ac2$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $acff6c09de855ac2$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $acff6c09de855ac2$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $acff6c09de855ac2$export$1e1e1b6120329fe = {
    code: $acff6c09de855ac2$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $acff6c09de855ac2$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $aa2210dc7ea20769$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $acff6c09de855ac2$export$bc0bbda045f09b5a(accept)
    ];
}
function $acff6c09de855ac2$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($acff6c09de855ac2$var$isDefined(file.size)) {
        if ($acff6c09de855ac2$var$isDefined(minSize) && $acff6c09de855ac2$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $acff6c09de855ac2$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $acff6c09de855ac2$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($acff6c09de855ac2$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $acff6c09de855ac2$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($acff6c09de855ac2$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $acff6c09de855ac2$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $acff6c09de855ac2$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $acff6c09de855ac2$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $acff6c09de855ac2$export$b511db3632effe58(file, accept), _fileAccepted2 = $acff6c09de855ac2$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $acff6c09de855ac2$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $acff6c09de855ac2$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $acff6c09de855ac2$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $acff6c09de855ac2$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $acff6c09de855ac2$export$f9006bf02b243736(item) {
    return $acff6c09de855ac2$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $acff6c09de855ac2$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $acff6c09de855ac2$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $acff6c09de855ac2$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $acff6c09de855ac2$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $acff6c09de855ac2$var$isIe(userAgent) || $acff6c09de855ac2$var$isEdge(userAgent);
}
function $acff6c09de855ac2$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$acff6c09de855ac2$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $acff6c09de855ac2$export$8d6d6472146de265(event);
        });
    };
}
function $acff6c09de855ac2$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $acff6c09de855ac2$export$8ce4bd13c494743e(accept) {
    if ($acff6c09de855ac2$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $acff6c09de855ac2$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$acff6c09de855ac2$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($acff6c09de855ac2$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $acff6c09de855ac2$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $acff6c09de855ac2$var$_objectSpread($acff6c09de855ac2$var$_objectSpread({}, agg), {}, $acff6c09de855ac2$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $acff6c09de855ac2$export$1278288bcefb97b9(accept) {
    if ($acff6c09de855ac2$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $acff6c09de855ac2$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($acff6c09de855ac2$var$_toConsumableArray(a), [
            mimeType
        ], $acff6c09de855ac2$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $acff6c09de855ac2$export$69c8ec3250e1cfbf(v) || $acff6c09de855ac2$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $acff6c09de855ac2$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $acff6c09de855ac2$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $acff6c09de855ac2$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $acff6c09de855ac2$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $6b26028d99ef9d7a$var$_excluded = [
    "children"
], $6b26028d99ef9d7a$var$_excluded2 = [
    "open"
], $6b26028d99ef9d7a$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $6b26028d99ef9d7a$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $6b26028d99ef9d7a$var$_toConsumableArray(arr) {
    return $6b26028d99ef9d7a$var$_arrayWithoutHoles(arr) || $6b26028d99ef9d7a$var$_iterableToArray(arr) || $6b26028d99ef9d7a$var$_unsupportedIterableToArray(arr) || $6b26028d99ef9d7a$var$_nonIterableSpread();
}
function $6b26028d99ef9d7a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b26028d99ef9d7a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6b26028d99ef9d7a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6b26028d99ef9d7a$var$_arrayLikeToArray(arr);
}
function $6b26028d99ef9d7a$var$_slicedToArray(arr, i) {
    return $6b26028d99ef9d7a$var$_arrayWithHoles(arr) || $6b26028d99ef9d7a$var$_iterableToArrayLimit(arr, i) || $6b26028d99ef9d7a$var$_unsupportedIterableToArray(arr, i) || $6b26028d99ef9d7a$var$_nonIterableRest();
}
function $6b26028d99ef9d7a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b26028d99ef9d7a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6b26028d99ef9d7a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6b26028d99ef9d7a$var$_arrayLikeToArray(o, minLen);
}
function $6b26028d99ef9d7a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6b26028d99ef9d7a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6b26028d99ef9d7a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6b26028d99ef9d7a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6b26028d99ef9d7a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6b26028d99ef9d7a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6b26028d99ef9d7a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6b26028d99ef9d7a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6b26028d99ef9d7a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6b26028d99ef9d7a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6b26028d99ef9d7a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6b26028d99ef9d7a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $6b26028d99ef9d7a$var$Dropzone = /*#__PURE__*/ (0, $f2Y41.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $6b26028d99ef9d7a$var$_objectWithoutProperties(_ref, $6b26028d99ef9d7a$var$_excluded);
    var _useDropzone = $6b26028d99ef9d7a$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $6b26028d99ef9d7a$var$_objectWithoutProperties(_useDropzone, $6b26028d99ef9d7a$var$_excluded2);
    (0, $f2Y41.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f2Y41))).createElement((0, $f2Y41.Fragment), null, children($6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$6b26028d99ef9d7a$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $6b26028d99ef9d7a$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $a7f65abd4bef59fc$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$6b26028d99ef9d7a$var$Dropzone.defaultProps = $6b26028d99ef9d7a$var$defaultProps;
$6b26028d99ef9d7a$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($aT86D))).func
};
var $6b26028d99ef9d7a$export$2e2bcd8739ae039 = $6b26028d99ef9d7a$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $6b26028d99ef9d7a$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $6b26028d99ef9d7a$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, $6b26028d99ef9d7a$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $f2Y41.useMemo)(function() {
        return (0, $acff6c09de855ac2$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $f2Y41.useMemo)(function() {
        return (0, $acff6c09de855ac2$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $f2Y41.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $6b26028d99ef9d7a$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $f2Y41.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $6b26028d99ef9d7a$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $f2Y41.useRef)(null);
    var inputRef = (0, $f2Y41.useRef)(null);
    var _useReducer = (0, $f2Y41.useReducer)($6b26028d99ef9d7a$var$reducer, $6b26028d99ef9d7a$var$initialState), _useReducer2 = $6b26028d99ef9d7a$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $f2Y41.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $acff6c09de855ac2$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $f2Y41.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $f2Y41.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $f2Y41.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $acff6c09de855ac2$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $acff6c09de855ac2$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $f2Y41.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $f2Y41.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $f2Y41.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($6b26028d99ef9d7a$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $acff6c09de855ac2$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $acff6c09de855ac2$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $acff6c09de855ac2$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $f2Y41.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $acff6c09de855ac2$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $f2Y41.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $acff6c09de855ac2$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $f2Y41.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $acff6c09de855ac2$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $6b26028d99ef9d7a$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $acff6c09de855ac2$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $6b26028d99ef9d7a$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $acff6c09de855ac2$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $f2Y41.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $acff6c09de855ac2$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $acff6c09de855ac2$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $f2Y41.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $acff6c09de855ac2$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $acff6c09de855ac2$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $f2Y41.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $f2Y41.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $f2Y41.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $f2Y41.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $acff6c09de855ac2$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $f2Y41.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $6b26028d99ef9d7a$var$_objectWithoutProperties(_ref2, $6b26028d99ef9d7a$var$_excluded3);
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $f2Y41.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $f2Y41.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $6b26028d99ef9d7a$var$_objectWithoutProperties(_ref3, $6b26028d99ef9d7a$var$_excluded4);
            var inputProps = $6b26028d99ef9d7a$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $acff6c09de855ac2$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $6b26028d99ef9d7a$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, $6b26028d99ef9d7a$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $6b26028d99ef9d7a$var$_objectSpread($6b26028d99ef9d7a$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $6b26028d99ef9d7a$var$_objectSpread({}, $6b26028d99ef9d7a$var$initialState);
        default:
            return state;
    }
}
function $6b26028d99ef9d7a$var$noop() {}






function $2fb555f932493dd6$export$7d3039654965d75c(props) {
    // const { data: study_data } = useIndex('studies')
    const [uploadType, setUploadType] = (0, $f2Y41.useState)("");
    const [dragActive, setDragActive] = (0, $f2Y41.useState)(false);
    const [uploading, setUploading] = (0, $f2Y41.useState)(false);
    const [s3Url, setS3Url] = (0, $f2Y41.useState)("");
    const [uploadId, setUploadId] = (0, $f2Y41.useState)("");
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const createUpload = (type)=>{
        (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("uploads", {
            status: "new",
            upload_type: type
        }, getAccessTokenSilently).then((response)=>{
            setS3Url(response.data.data.s3_presigned_url);
            setUploadId(response.data.data.id);
            (0, $f14fedbe4e80ae23$export$57e795267c26e600)((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("/uploads"));
        });
    };
    const handleUploadType = (uploadType)=>{
        setUploadType(uploadType);
        createUpload(uploadType);
    };
    const handleDrop = (files)=>{
        const s3File = files[0];
        const s3Headers = {
            headers: {
                "Content-Type": s3File.type
            }
        };
        (0, $b2d06586a86d14b7$export$99915ff5fc5148d2).put(s3Url, s3File, s3Headers).then((response)=>{
            setUploading(true);
            (0, $b2d06586a86d14b7$export$74524c73191a667c)("uploads", uploadId, {
                status: "pending"
            }, getAccessTokenSilently);
        });
    };
    // const handleChange = function(e) {
    //   console.log('handleChange')
    //   e.preventDefault()
    //   setDragActive(false)
    //   if (e.target.files && e.target.files[0]) {
    //     // at least one file has been selected so do something
    //     handleFiles(e.target.files)
    //   }
    // }
    // const handleFiles = function(files) {
    //   setUploading(true)
    // }
    const handleClose = ()=>{
        props.setOpen(false);
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("uploads"));
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], handleClose);
    const { getRootProps: getRootProps, getInputProps: getInputProps } = (0, $6b26028d99ef9d7a$export$cd49c0ecc5be9f36)({
        onDropAccepted: handleDrop
    });
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold dark:text-white",
                                        title: s3Url,
                                        children: !uploadType ? "What type of data are you adding?" : `Upload ${(0, $48358001e7c1220f$exports.titleCase)(uploadType)} Data`
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>handleClose(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                    children: "X Button"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "p-6 space-y-6 dark:text-white",
                                children: [
                                    !uploadType && !uploading && /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "text-sm",
                                                children: "NB: Dates must be in ISO format: (YYYY-MM-DD) or (YYYY-MM-DDTHH:mm:SS)"
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "text-sm",
                                                children: [
                                                    "NB: To associate data with an existing patient, you may include: ",
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("br", {}),
                                                    " MRN or patient_id (waypoints patient identifier)",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                onClick: ()=>handleUploadType("QualifiedPatient"),
                                                onKeyUp: ()=>handleUploadType("QualifiedPatient"),
                                                className: "rounded shadow-md p-5 text-center items-center align-middle flex flex-col hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                        icon: "UserGroupIcon",
                                                        outline: true,
                                                        className: "mb-1 h-10 w-10 text-blue"
                                                    }),
                                                    "Qualified Patients"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        onClick: ()=>handleUploadType("Patient"),
                                                        onKeyUp: ()=>handleUploadType("Patient"),
                                                        className: "rounded shadow-md p-5 text-center items-center align-middle flex flex-col hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                icon: "UserCircleIcon",
                                                                outline: true,
                                                                className: "mb-1 h-10 w-10 text-blue"
                                                            }),
                                                            "Demographic / Contact Info"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        onClick: ()=>handleUploadType("PatientAppointment"),
                                                        onKeyUp: ()=>handleUploadType("PatientAppointment"),
                                                        className: "rounded shadow-md p-5 text-center items-center align-middle flex flex-col hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                icon: "CalendarIcon",
                                                                outline: true,
                                                                className: "mb-1 h-10 w-10 text-blue"
                                                            }),
                                                            "Appointments"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        onClick: ()=>handleUploadType("PatientCondition"),
                                                        onKeyUp: ()=>handleUploadType("PatientCondition"),
                                                        className: "rounded shadow-md p-5 text-center items-center align-middle flex flex-col hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                icon: "BeakerIcon",
                                                                outline: true,
                                                                className: "mb-1 h-10 w-10 text-blue"
                                                            }),
                                                            "Conditions"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                        onClick: ()=>handleUploadType("PatientMedication"),
                                                        onKeyUp: ()=>handleUploadType("PatientMedication"),
                                                        className: "rounded shadow-md p-5 text-center items-center align-middle flex flex-col hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                icon: "ClipboardIcon",
                                                                outline: true,
                                                                className: "mb-1 h-10 w-10 text-blue"
                                                            }),
                                                            "Medications"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    uploadType && !uploading && /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("button", {
                                                        type: "button",
                                                        className: "flex items-center mb-4 hover:text-blue-800",
                                                        onClick: ()=>setUploadType(""),
                                                        onKeyUp: ()=>setUploadType(""),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                icon: "ArrowLeftIcon",
                                                                className: "h-4 w-4 mr-1"
                                                            }),
                                                            "Back"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("a", {
                                                        className: "flex items-center mb-4 hover:text-blue-800",
                                                        href: `${undefined}/upload_templates/${uploadType}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7e2c281be9fe9de6$export$501b3ffe9d0bcd91), {
                                                                icon: "DocumentDownloadIcon",
                                                                className: "h-5 w-5"
                                                            }),
                                                            " ",
                                                            "Download CSV Template",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("form", {
                                                id: "form-file-upload",
                                                onSubmit: (e)=>e.preventDefault(),
                                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("label", {
                                                    className: `flex justify-center w-full transition ${dragActive ? "bg-gray-300 dark:bg-gray-700" : "bg-white dark:bg-gray-800"} border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none`,
                                                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("span", {
                                                        className: "flex items-center space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                className: "w-6 h-6 text-gray-600",
                                                                fill: "none",
                                                                viewBox: "0 0 24 24",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                                        children: "X Button"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                                ...getRootProps({
                                                                    className: "dropzone p-10"
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("p", {
                                                                        children: "Drop a file here to upload, or click to select a file"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("input", {
                                                                        ...getInputProps()
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    uploading && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "",
                                        children: "We're uploading your file! Click the close button to check on the progress."
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");


var $f2Y41 = parcelRequire("f2Y41");





function $7a6d58d24d41df27$export$6d57b7b0b8726e84(props) {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: patientsIndex, isLoading: isLoadingPatientsIndex, mutate: mutatePatientsIndex } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("qualified_patient_imports", `practice_id=${practiceId}`);
    const [createdPatients, setCreatedPatients] = (0, $f2Y41.useState)(null);
    const [creatingPatients, setCreatingPatients] = (0, $f2Y41.useState)(false);
    const handleClose = ()=>{
        props.setOpen(false);
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("uploads"));
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], handleClose);
    const handlePatientFinderClick = async ()=>{
        setCreatingPatients(true);
        setCreatedPatients(null);
        const response = await (0, $b2d06586a86d14b7$export$5edc9d665968dd86)("qualified_patient_imports", {
            practice_id: practiceId
        }, getAccessTokenSilently);
        setCreatingPatients(false);
        setCreatedPatients(response?.data);
        mutatePatientsIndex();
    };
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-3xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold dark:text-white",
                                        children: "PatientFinder\u2122\uFE0F"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>handleClose(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsxs)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("title", {
                                                    children: "X Button"
                                                }),
                                                /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                    clipRule: "evenodd"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "p-6 space-y-6",
                                children: [
                                    !createdPatients && /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "font-semibold",
                                                children: [
                                                    "Are there file(s) ready? ",
                                                    isLoadingPatientsIndex && "...",
                                                    " ",
                                                    patientsIndex?.[0] ? "Yes \u2705" : "No \u274C"
                                                ]
                                            }),
                                            patientsIndex?.map((patientFile)=>/*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                    children: patientFile
                                                })),
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                                className: "flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:bg-red-200 disabled:text-red-700",
                                                type: "submit",
                                                disabled: creatingPatients || !patientsIndex?.[0],
                                                onClick: ()=>handlePatientFinderClick(),
                                                children: !creatingPatients ? "Load Patients and Criteria" : "Loading..."
                                            })
                                        ]
                                    }),
                                    creatingPatients && /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-2xl",
                                        children: "\uD83D\uDD1C"
                                    }),
                                    createdPatients && /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                className: "font-semibold",
                                                children: "Success \uD83C\uDF89"
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "font-semibold",
                                                        children: "Patients"
                                                    }),
                                                    " ",
                                                    Object.entries(createdPatients.data.qualified_patients).map(([key, value])=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            children: [
                                                                `${(0, $17235661ec5f519b$export$b94aa994a2f01789)(key)}: ${value}`,
                                                                " "
                                                            ]
                                                        }))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                                        className: "font-semibold",
                                                        children: "Criteria"
                                                    }),
                                                    " ",
                                                    Object.entries(createdPatients.data.qualification_criteria).map(([key, value])=>/*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                            children: [
                                                                `${(0, $17235661ec5f519b$export$b94aa994a2f01789)(key)}: ${value}`,
                                                                " "
                                                            ]
                                                        }))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}



var $ge3KO = parcelRequire("ge3KO");




function $3e5136a85fd1fe92$export$ece4a9300a9a6124(props) {
    const { data: upload, mutate: mutateUpload } = (0, $b2d06586a86d14b7$export$7e974a91e79f266e)("uploads", props.uploadId);
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $05f1c351b568e291$export$f2b63d3ca66bb884)();
    const handleClose = ()=>{
        props.setOpen(false);
        (0, $f14fedbe4e80ae23$export$57e795267c26e600)((0, $b2d06586a86d14b7$export$3bb0762bb9063ee8)("uploads"));
    };
    const handleReprocess = ()=>{
        (0, $b2d06586a86d14b7$export$74524c73191a667c)("uploads", props.uploadId, {
            status: "pending"
        }, getAccessTokenSilently).then(()=>mutateUpload());
    };
    (0, $e11587f884e634f5$export$b65485ca34c366f3)([
        "Escape"
    ], handleClose);
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "fixed flex left-0 right-0 z-50 items-center justify-center overflow-x-hidden overflow-y-auto top-4 md:inset-0 h-modal sm:h-full",
                id: "add-user-modal",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "relative w-full h-full max-w-2xl px-4 md:h-auto",
                    children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                        className: "relative bg-white rounded-lg shadow dark:bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("h3", {
                                        className: "text-xl font-semibold dark:text-white",
                                        title: props.uploadId,
                                        children: "Upload Detail"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                        type: "button",
                                        className: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white",
                                        onClick: ()=>handleClose(),
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("svg", {
                                            className: "w-5 h-5",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ge3KO.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                clipRule: "evenodd"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                className: "p-6 dark:text-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-medium",
                                        children: "Source File"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "mt-0",
                                        children: /*#__PURE__*/ (0, $ge3KO.jsx)("a", {
                                            className: "underline text-blue-600 hover:text-blue-900 visited:text-purple-600 text-sm",
                                            href: upload.s3_presigned_url,
                                            target: "_blank",
                                            children: "Download Source File"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: "Counts"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "text-sm",
                                                children: [
                                                    "Created: ",
                                                    upload.created_count
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "text-sm",
                                                children: [
                                                    "Duplicate: ",
                                                    upload.duplicate_count
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                                                className: "text-sm",
                                                children: [
                                                    "Failed: ",
                                                    upload.failed_count
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: "Uploaded At"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-sm mb-4",
                                        children: upload.created_at
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: "Last Updated At"
                                    }),
                                    /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                        className: "text-sm mb-4",
                                        children: upload.updated_at
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                                className: "items-center p-5 border-t border-gray-200 rounded-b dark:border-gray-700",
                                children: /*#__PURE__*/ (0, $ge3KO.jsx)("button", {
                                    className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                    type: "submit",
                                    onClick: ()=>handleReprocess(),
                                    children: "Reprocess"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                id: "modal-backdrop",
                className: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"
            })
        ]
    });
}


function $b7de6640353649d0$export$b9fdcbe39e9cf25f() {
    const { practiceId: practiceId } = (0, $f2Y41.useContext)((0, $a7c01d819f290997$export$1d3893771befa5cc));
    const { data: data, isLoading: isLoading, isError: isError, mutate: mutate } = (0, $b2d06586a86d14b7$export$bb0968b4d41ab5a0)("uploads");
    const [newModalOpen, setNewModalOpen] = (0, $f2Y41.useState)(false);
    const [showModalOpen, setShowModalOpen] = (0, $f2Y41.useState)(false);
    const [patientFinderModalOpen, setPatientFinderModalOpen] = (0, $f2Y41.useState)(false);
    const [appointmentFinderModalOpen, setAppointmentFinderModalOpen] = (0, $f2Y41.useState)(false);
    const [uploadId, setUploadId] = (0, $f2Y41.useState)("");
    const dateValueGetter = (value, row, column, apiRef)=>(0, $b96a98eff2e03a49$export$2e2bcd8739ae039)(value);
    const rows = data;
    const columns = [
        {
            field: "upload_type",
            headerName: "Type",
            width: 160
        },
        {
            field: "status",
            headerName: "Status",
            width: 150
        },
        {
            field: "created_by_user_id",
            headerName: "Created By User Id",
            width: 150
        },
        {
            field: "created_count",
            headerName: "Created",
            width: 100
        },
        {
            field: "skipped_count",
            headerName: "Skipped",
            width: 100
        },
        {
            field: "duplicate_count",
            headerName: "Duplicate",
            width: 100
        },
        {
            field: "failed_count",
            headerName: "Failed",
            width: 100
        },
        // { field: 's3_bucket', headerName: 'S3 Bucket', width: 150 },
        // { field: 's3_key', headerName: 'S3 Key', width: 150 },
        {
            field: "updated_at",
            type: "dateTime",
            valueGetter: dateValueGetter,
            headerName: "Updated At",
            width: 250
        },
        {
            field: "uploaded_at",
            type: "dateTime",
            valueGetter: dateValueGetter,
            headerName: "Uploaded At",
            width: 250
        }
    ];
    return /*#__PURE__*/ (0, $ge3KO.jsxs)((0, $ge3KO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0bb17adeece2ee72$export$70d0618c8112500f), {
                title: "Uploads",
                children: /*#__PURE__*/ (0, $ge3KO.jsxs)("div", {
                    className: "flex space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "",
                            onClick: ()=>mutate(),
                            onKeyUp: ()=>mutate(),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                bgColorClass: "bg-topo-blue",
                                bgHoverColorClass: "hover:bg-blue-400",
                                focusRingColorClass: "focus:ring-topo-blue-500",
                                icon: "RefreshIcon",
                                text: "Refresher\u2122\uFE0F"
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "",
                            onClick: ()=>setPatientFinderModalOpen(true),
                            onKeyUp: ()=>setPatientFinderModalOpen(true),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                bgColorClass: "bg-cyan-500",
                                bgHoverColorClass: "hover:bg-cyan-800",
                                focusRingColorClass: "focus:ring-cyan-500",
                                icon: "DatabaseIcon",
                                text: "PatientFinder\u2122\uFE0F"
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "",
                            onClick: ()=>setAppointmentFinderModalOpen(true),
                            onKeyUp: ()=>setAppointmentFinderModalOpen(true),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                bgColorClass: "bg-orange-500",
                                bgHoverColorClass: "hover:bg-orange-700",
                                focusRingColorClass: "focus:ring-orange-500",
                                icon: "CalendarIcon",
                                text: "AppointmentFinder\u2122\uFE0F"
                            })
                        }),
                        /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                            className: "",
                            onClick: ()=>setNewModalOpen(true),
                            onKeyUp: ()=>setNewModalOpen(true),
                            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $38f9efe7437397ea$export$dbd093c273051430), {
                                icon: "DatabaseIcon",
                                text: "CSV Uploader\u2122\uFE0F"
                            })
                        })
                    ]
                })
            }),
            isLoading ? "Loading.." : "",
            isError ? "Failed to load" : "",
            /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                className: "p-2 mt-2 flex h-screen",
                children: /*#__PURE__*/ (0, $ge3KO.jsx)("div", {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $474f4e4597ff512d$export$97fd8aadf70de81f), {
                        rows: rows,
                        columns: columns,
                        initialState: {
                            sorting: {
                                sortModel: [
                                    {
                                        field: "updated_at",
                                        sort: "desc"
                                    }
                                ]
                            },
                            filter: {
                                filterModel: {
                                    items: [
                                        {
                                            field: "status",
                                            operator: "isAnyOf",
                                            value: [
                                                "new",
                                                "complete",
                                                "processing"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        onCellDoubleClick: (params, event)=>{
                            event.defaultMuiPrevented = true;
                            setUploadId(params.row.id);
                            setShowModalOpen(true);
                        }
                    })
                })
            }),
            newModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2fb555f932493dd6$export$7d3039654965d75c), {
                setOpen: setNewModalOpen
            }),
            showModalOpen && uploadId && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $3e5136a85fd1fe92$export$ece4a9300a9a6124), {
                uploadId: uploadId,
                setOpen: setShowModalOpen
            }),
            patientFinderModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $7a6d58d24d41df27$export$6d57b7b0b8726e84), {
                setOpen: setPatientFinderModalOpen
            }),
            appointmentFinderModalOpen && /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6b79fe31db3264e4$export$9792e45199f71494), {
                setOpen: setAppointmentFinderModalOpen
            })
        ]
    });
}


const $f25d7eba1a31f8b5$var$multiTenantEnabled = false;
const $f25d7eba1a31f8b5$export$9b5cb5a1fbefff82 = (0, $68992f44774c46b5$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0c4d35b57f451404$export$6cd5d5c1dae69a36), {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $326f8a578b267bd7$export$334c29725a78c21d), {})
            },
            {
                path: "auth",
                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $326f8a578b267bd7$export$334c29725a78c21d), {})
            },
            {
                path: "logout",
                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $546fd21f4ffe3978$export$cad1a703886b4e3a), {})
            },
            {
                path: "404",
                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $6538fada2412b751$export$441fbf304cc1216d), {})
            },
            {
                path: "401",
                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2173b5262bd4822b$export$5dcb52b4331c1c19), {})
            },
            {
                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $46e0cc986bfa765c$export$f01b3d7c7bbe3997), {
                    component: (0, $80da8bafa816c42d$export$2e2bcd8739ae039)
                }),
                children: [
                    {
                        path: "home",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4e9fe22e0f6c619a$export$b94310965bed44e6), {})
                    },
                    {
                        path: "quality-assurance",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $eb3b032cb110d81c$export$30b765d29ac16eee), {})
                    },
                    {
                        path: "dashboard",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $aface4e092470bfa$export$fe82a520fc33e5f4), {})
                    },
                    {
                        path: "kanban",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $9c34f60534805f28$export$6ddf1eefea0f12d3), {})
                    },
                    {
                        path: "patients",
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $425ea3415c0ea86d$export$3849a5e5f22ef010), {})
                            },
                            {
                                path: ":patientId",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4d7392d447faa322$export$8dc8045e940cbc5d), {}),
                                children: [
                                    {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4744918c3ae38de6$export$8298529d1565c2ab), {})
                                    },
                                    {
                                        path: "info",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4744918c3ae38de6$export$8298529d1565c2ab), {})
                                    },
                                    {
                                        path: "timeline",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a6f8884356347f45$export$108210b9140dbc1e), {})
                                    },
                                    {
                                        path: "screens",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1755fd208e56253a$export$8b567e04a6e27d40), {})
                                    },
                                    {
                                        path: "screens/:screenId",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a6bb6a5b7701de73$export$d8bc8ed3a6095d17), {})
                                    },
                                    {
                                        path: "appointments",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0f7e5332fc336498$export$8738b9fa7947ea8), {})
                                    },
                                    {
                                        path: "visits",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $53b20c7dc3636d0d$export$4cfb997d294e3b11), {})
                                    },
                                    {
                                        path: "medications",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $da945fc2c67ce19f$export$f6cddb448106312d), {})
                                    },
                                    {
                                        path: "conditions",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $561b6e01510f3565$export$5e4fcd6d86b6a2ab), {})
                                    }
                                ]
                            },
                            {
                                path: "patient-cards",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $39b3fb49f38b43d9$export$448081bbd00c020), {})
                            }
                        ]
                    },
                    {
                        path: "calendar",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $485d3281bdc9f22a$export$e1aef45b828286de), {})
                    },
                    {
                        path: "uploads",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $b7de6640353649d0$export$b9fdcbe39e9cf25f), {})
                    },
                    {
                        path: "studies",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $bb1c9129a51e03c8$export$d34e4086b673edb0), {})
                    },
                    {
                        path: "sponsors",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $75705be9d11f9282$export$6a633ab11e7a27c8), {})
                    },
                    {
                        path: "tasks",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2f0b8860bb7ad921$export$77bc526bfccc9372), {})
                    },
                    {
                        path: "admin",
                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $601cdae3149c9149$export$787d093fc14ee6d5), {}),
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4426f6ea82d5b247$export$c67a8869b938d43b), {})
                            },
                            {
                                path: "comments",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $29ca84b747c9e87f$export$4b2997e216293ac3), {})
                            },
                            {
                                path: "patient-finder",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $8eb36408212e470e$export$77e43c3894961eb), {})
                            },
                            {
                                path: "events",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $aacba43ee8d7e034$export$f9c0b4e215944762), {})
                            },
                            {
                                path: "sync-configuration",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $afb2bc80d36fb3b8$export$b672e2179622809d), {})
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "practices",
                                children: [
                                    {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $31a4d74716bbc6f6$export$aa329704653d4df7), {})
                                    },
                                    {
                                        path: ":practiceId",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d4b05145b4844503$export$2f51d8dd59215465), {})
                                    },
                                    {
                                        path: ":practiceId/users",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $13e872420b476e64$export$39aeeeb7b8b59bbd), {})
                                    }
                                ]
                            },
                            {
                                path: "quality-assurance",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $2c3dedf5e7eb0142$export$b6a37aeb9426baf8), {})
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "sponsors",
                                children: [
                                    {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $62a25398f0d6957b$export$2d62f9e5f72f6e68), {})
                                    },
                                    {
                                        path: ":sponsorId",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1c4fe8899a2494f0$export$272c97a1b11ba122), {})
                                    }
                                ]
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "studies",
                                children: [
                                    {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $981563d490d2c503$export$ea415ab8f03c12d8), {})
                                    },
                                    {
                                        path: ":studyId",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d64fb4d9ed370ee6$export$79d648b52a36c8b8), {})
                                    },
                                    {
                                        path: "builder",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a69626a436edf3e6$export$fd542a1bd7c591c3), {})
                                    },
                                    {
                                        path: "visits",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $d8ad986d3115d18f$export$5134630abfb689e3), {})
                                    },
                                    {
                                        path: "visits/:visitId",
                                        element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a352921f1a08b700$export$4734c56f51376fb5), {})
                                    }
                                ]
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "team_xrefs",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $cdc521c4f7727b41$export$e3e08a57518b35b4), {})
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "procedures",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $4a94d3430f6d3232$export$14e6dd6bddecd72b), {})
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "users",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $62968d35e83340e0$export$a69f017b19597ff5), {})
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "conditions",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $158f6e50d612d360$export$363c7374d425f4ad), {})
                            },
                            $f25d7eba1a31f8b5$var$multiTenantEnabled && {
                                path: "medications",
                                element: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $1007a57a4247a8f3$export$2868d2a917920a44), {})
                            }
                        ]
                    }
                ]
            }
        ]
    }
]);




var $ge3KO = parcelRequire("ge3KO");

const $cef7d12b701c6c9b$export$ec196138511a01f0 = ({ children: children })=>{
    const domain = undefined;
    const clientId = undefined;
    const audience = undefined;
    const defaultRoute = "/home";
    const scope = "openid email profile offline_access";
    if (!(domain && clientId && audience)) return null;
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $05f1c351b568e291$export$6aefaad9cc4faf3c), {
        domain: domain,
        clientId: clientId,
        authorizationParams: {
            scope: scope,
            audience: audience,
            redirectUri: window.location.origin + defaultRoute
        },
        useRefreshTokens: true,
        cacheLocation: "localstorage" // this is because we're hosting on amplify, serverless. if we had a traditional webserver, we could set HTTPOnly cookie
        ,
        children: children
    });
};




const $1feb4e6a8de6fd2d$export$a7480c291995164 = "f8aeb95951db326048e6b79ef9824d1aTz05NTcxMixFPTE3NTQ1OTMyNDYwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";



function $adaa2292442c6e9d$export$86fbec116b87613f() {
    $9b36b65c9ab22250$export$2cd8252107eb640b({
        dsn: undefined,
        integrations: [
            new $4b78ee6af91951c6$export$46d3bbd0375f5fa4({
                // See docs for support of different versions of variation of react router
                // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
                routingInstrumentation: $f7d2f1a319d5028e$export$e6e76890c5208db1((0, $f2Y41.useEffect), (0, $c5383ff45095a6a6$export$45d76561a5302f2b), (0, $c5383ff45095a6a6$export$1b3f31771c5d07c), (0, $c5383ff45095a6a6$export$16da398f5434bdec), (0, $23dfbc71b7beba8d$export$2708184779ceb39d))
            })
        ],
        // Sentry recommends adjusting this value in production,
        // or using tracesSampler for finer control
        tracesSampleRate: Number.parseFloat("1.0")
    });
    // TODO: Move this to Authorization Provider, into a useEffect [] (init), import * as Sentry from "@sentry/react"
    // TODO: Slugify the practice name that comes back from the /authorizations response for the practice_slug
    $ff70bab8e0f5d056$export$2f04de43fe27971a("practice", {
        practice_id: undefined,
        practice_slug: undefined
    });
    (0, $8173e232d95b4d5b$export$2c56d2e2ae515eeb).setLicenseKey((0, $1feb4e6a8de6fd2d$export$a7480c291995164));
    const prefersDarkMode = (0, $8256098bd6a934fe$export$56a913221adb0e51)();
    const theme = (0, $b5ba0fceafa93186$export$6adef2d23f66960d)(prefersDarkMode);
    const queryClient = new (0, $1feca0faf99b89fc$export$405d0624ed55a03f)();
    return /*#__PURE__*/ (0, $ge3KO.jsx)((0, $ge3KO.Fragment), {
        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $cef7d12b701c6c9b$export$ec196138511a01f0), {
            children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $a7c01d819f290997$export$9df4dac00da58539), {
                children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $935108cabed32909$export$45604f0cc8ae667b), {
                    client: queryClient,
                    children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $68992f44774c46b5$export$323e4fc2fa4753fb), {
                        router: (0, $f25d7eba1a31f8b5$export$9b5cb5a1fbefff82),
                        children: /*#__PURE__*/ (0, $ge3KO.jsx)((0, $0c4d35b57f451404$export$6cd5d5c1dae69a36), {})
                    })
                })
            })
        })
    });
}


const $8d3511c0dde74a64$var$container = document.getElementById("app");
const $8d3511c0dde74a64$var$root = (0, $dda2239619d6df9c$export$882461b6382ed46c)($8d3511c0dde74a64$var$container) // createRoot(container!) if you use TypeScript
;
$8d3511c0dde74a64$var$root.render(/*#__PURE__*/ (0, $ge3KO.jsx)((0, $adaa2292442c6e9d$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.e6e618d7.js.map
